var ko = Object.defineProperty;
var vo = (C) => {
  throw TypeError(C);
};
var Do = (C, e, T) => e in C ? ko(C, e, { enumerable: !0, configurable: !0, writable: !0, value: T }) : C[e] = T;
var tt = (C, e, T) => Do(C, typeof e != "symbol" ? e + "" : e, T), Qs = (C, e, T) => e.has(C) || vo("Cannot " + T);
var rt = (C, e, T) => (Qs(C, e, "read from private field"), T ? T.call(C) : e.get(C)), Ft = (C, e, T) => e.has(C) ? vo("Cannot add the same private member more than once") : e instanceof WeakSet ? e.add(C) : e.set(C, T), At = (C, e, T, $) => (Qs(C, e, "write to private field"), $ ? $.call(C, T) : e.set(C, T), T), Qt = (C, e, T) => (Qs(C, e, "access private method"), T);
var ss = (C, e, T, $) => ({
  set _(V) {
    At(C, e, V, T);
  },
  get _() {
    return rt(C, e, $);
  }
});
import * as React$1 from "react";
import React__default, { useContext, forwardRef, useRef, useCallback, useDebugValue, useEffect, useMemo, createContext, createElement, Children, isValidElement, cloneElement, useState, memo, Component } from "react";
import * as ReactDOM from "react-dom";
import ReactDOM__default, { unstable_batchedUpdates } from "react-dom";
var commonjsGlobal$1 = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function getDefaultExportFromCjs$2(C) {
  return C && C.__esModule && Object.prototype.hasOwnProperty.call(C, "default") ? C.default : C;
}
function getAugmentedNamespace(C) {
  if (C.__esModule) return C;
  var e = C.default;
  if (typeof e == "function") {
    var T = function $() {
      return this instanceof $ ? Reflect.construct(e, arguments, this.constructor) : e.apply(this, arguments);
    };
    T.prototype = e.prototype;
  } else T = {};
  return Object.defineProperty(T, "__esModule", { value: !0 }), Object.keys(C).forEach(function($) {
    var V = Object.getOwnPropertyDescriptor(C, $);
    Object.defineProperty(T, $, V.get ? V : {
      enumerable: !0,
      get: function() {
        return C[$];
      }
    });
  }), T;
}
var dist$2 = {}, bufferPolyfill = {}, base64Js = {};
base64Js.byteLength = byteLength;
base64Js.toByteArray = toByteArray;
base64Js.fromByteArray = fromByteArray;
var lookup = [], revLookup = [], Arr = typeof Uint8Array < "u" ? Uint8Array : Array, code = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
for (var i$3 = 0, len = code.length; i$3 < len; ++i$3)
  lookup[i$3] = code[i$3], revLookup[code.charCodeAt(i$3)] = i$3;
revLookup[45] = 62;
revLookup[95] = 63;
function getLens(C) {
  var e = C.length;
  if (e % 4 > 0)
    throw new Error("Invalid string. Length must be a multiple of 4");
  var T = C.indexOf("=");
  T === -1 && (T = e);
  var $ = T === e ? 0 : 4 - T % 4;
  return [T, $];
}
function byteLength(C) {
  var e = getLens(C), T = e[0], $ = e[1];
  return (T + $) * 3 / 4 - $;
}
function _byteLength(C, e, T) {
  return (e + T) * 3 / 4 - T;
}
function toByteArray(C) {
  var e, T = getLens(C), $ = T[0], V = T[1], J = new Arr(_byteLength(C, $, V)), ee = 0, te = V > 0 ? $ - 4 : $, re;
  for (re = 0; re < te; re += 4)
    e = revLookup[C.charCodeAt(re)] << 18 | revLookup[C.charCodeAt(re + 1)] << 12 | revLookup[C.charCodeAt(re + 2)] << 6 | revLookup[C.charCodeAt(re + 3)], J[ee++] = e >> 16 & 255, J[ee++] = e >> 8 & 255, J[ee++] = e & 255;
  return V === 2 && (e = revLookup[C.charCodeAt(re)] << 2 | revLookup[C.charCodeAt(re + 1)] >> 4, J[ee++] = e & 255), V === 1 && (e = revLookup[C.charCodeAt(re)] << 10 | revLookup[C.charCodeAt(re + 1)] << 4 | revLookup[C.charCodeAt(re + 2)] >> 2, J[ee++] = e >> 8 & 255, J[ee++] = e & 255), J;
}
function tripletToBase64(C) {
  return lookup[C >> 18 & 63] + lookup[C >> 12 & 63] + lookup[C >> 6 & 63] + lookup[C & 63];
}
function encodeChunk(C, e, T) {
  for (var $, V = [], J = e; J < T; J += 3)
    $ = (C[J] << 16 & 16711680) + (C[J + 1] << 8 & 65280) + (C[J + 2] & 255), V.push(tripletToBase64($));
  return V.join("");
}
function fromByteArray(C) {
  for (var e, T = C.length, $ = T % 3, V = [], J = 16383, ee = 0, te = T - $; ee < te; ee += J)
    V.push(encodeChunk(C, ee, ee + J > te ? te : ee + J));
  return $ === 1 ? (e = C[T - 1], V.push(
    lookup[e >> 2] + lookup[e << 4 & 63] + "=="
  )) : $ === 2 && (e = (C[T - 2] << 8) + C[T - 1], V.push(
    lookup[e >> 10] + lookup[e >> 4 & 63] + lookup[e << 2 & 63] + "="
  )), V.join("");
}
var ieee754 = {};
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */
ieee754.read = function(C, e, T, $, V) {
  var J, ee, te = V * 8 - $ - 1, re = (1 << te) - 1, ie = re >> 1, se = -7, de = T ? V - 1 : 0, ue = T ? -1 : 1, fe = C[e + de];
  for (de += ue, J = fe & (1 << -se) - 1, fe >>= -se, se += te; se > 0; J = J * 256 + C[e + de], de += ue, se -= 8)
    ;
  for (ee = J & (1 << -se) - 1, J >>= -se, se += $; se > 0; ee = ee * 256 + C[e + de], de += ue, se -= 8)
    ;
  if (J === 0)
    J = 1 - ie;
  else {
    if (J === re)
      return ee ? NaN : (fe ? -1 : 1) * (1 / 0);
    ee = ee + Math.pow(2, $), J = J - ie;
  }
  return (fe ? -1 : 1) * ee * Math.pow(2, J - $);
};
ieee754.write = function(C, e, T, $, V, J) {
  var ee, te, re, ie = J * 8 - V - 1, se = (1 << ie) - 1, de = se >> 1, ue = V === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0, fe = $ ? 0 : J - 1, he = $ ? 1 : -1, me = e < 0 || e === 0 && 1 / e < 0 ? 1 : 0;
  for (e = Math.abs(e), isNaN(e) || e === 1 / 0 ? (te = isNaN(e) ? 1 : 0, ee = se) : (ee = Math.floor(Math.log(e) / Math.LN2), e * (re = Math.pow(2, -ee)) < 1 && (ee--, re *= 2), ee + de >= 1 ? e += ue / re : e += ue * Math.pow(2, 1 - de), e * re >= 2 && (ee++, re /= 2), ee + de >= se ? (te = 0, ee = se) : ee + de >= 1 ? (te = (e * re - 1) * Math.pow(2, V), ee = ee + de) : (te = e * Math.pow(2, de - 1) * Math.pow(2, V), ee = 0)); V >= 8; C[T + fe] = te & 255, fe += he, te /= 256, V -= 8)
    ;
  for (ee = ee << V | te, ie += V; ie > 0; C[T + fe] = ee & 255, fe += he, ee /= 256, ie -= 8)
    ;
  C[T + fe - he] |= me * 128;
};
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */
(function(C) {
  const e = base64Js, T = ieee754, $ = typeof Symbol == "function" && typeof Symbol.for == "function" ? Symbol.for("nodejs.util.inspect.custom") : null;
  C.Buffer = te, C.SlowBuffer = Te, C.INSPECT_MAX_BYTES = 50;
  const V = 2147483647;
  C.kMaxLength = V, te.TYPED_ARRAY_SUPPORT = J(), !te.TYPED_ARRAY_SUPPORT && typeof console < "u" && typeof console.error == "function" && console.error(
    "This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support."
  );
  function J() {
    try {
      const Ve = new Uint8Array(1), Pe = { foo: function() {
        return 42;
      } };
      return Object.setPrototypeOf(Pe, Uint8Array.prototype), Object.setPrototypeOf(Ve, Pe), Ve.foo() === 42;
    } catch {
      return !1;
    }
  }
  Object.defineProperty(te.prototype, "parent", {
    enumerable: !0,
    get: function() {
      if (te.isBuffer(this))
        return this.buffer;
    }
  }), Object.defineProperty(te.prototype, "offset", {
    enumerable: !0,
    get: function() {
      if (te.isBuffer(this))
        return this.byteOffset;
    }
  });
  function ee(Ve) {
    if (Ve > V)
      throw new RangeError('The value "' + Ve + '" is invalid for option "size"');
    const Pe = new Uint8Array(Ve);
    return Object.setPrototypeOf(Pe, te.prototype), Pe;
  }
  function te(Ve, Pe, $e) {
    if (typeof Ve == "number") {
      if (typeof Pe == "string")
        throw new TypeError(
          'The "string" argument must be of type string. Received type number'
        );
      return de(Ve);
    }
    return re(Ve, Pe, $e);
  }
  te.poolSize = 8192;
  function re(Ve, Pe, $e) {
    if (typeof Ve == "string")
      return ue(Ve, Pe);
    if (ArrayBuffer.isView(Ve))
      return he(Ve);
    if (Ve == null)
      throw new TypeError(
        "The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof Ve
      );
    if (mt(Ve, ArrayBuffer) || Ve && mt(Ve.buffer, ArrayBuffer) || typeof SharedArrayBuffer < "u" && (mt(Ve, SharedArrayBuffer) || Ve && mt(Ve.buffer, SharedArrayBuffer)))
      return me(Ve, Pe, $e);
    if (typeof Ve == "number")
      throw new TypeError(
        'The "value" argument must not be of type number. Received type number'
      );
    const Ze = Ve.valueOf && Ve.valueOf();
    if (Ze != null && Ze !== Ve)
      return te.from(Ze, Pe, $e);
    const at = xe(Ve);
    if (at) return at;
    if (typeof Symbol < "u" && Symbol.toPrimitive != null && typeof Ve[Symbol.toPrimitive] == "function")
      return te.from(Ve[Symbol.toPrimitive]("string"), Pe, $e);
    throw new TypeError(
      "The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof Ve
    );
  }
  te.from = function(Ve, Pe, $e) {
    return re(Ve, Pe, $e);
  }, Object.setPrototypeOf(te.prototype, Uint8Array.prototype), Object.setPrototypeOf(te, Uint8Array);
  function ie(Ve) {
    if (typeof Ve != "number")
      throw new TypeError('"size" argument must be of type number');
    if (Ve < 0)
      throw new RangeError('The value "' + Ve + '" is invalid for option "size"');
  }
  function se(Ve, Pe, $e) {
    return ie(Ve), Ve <= 0 ? ee(Ve) : Pe !== void 0 ? typeof $e == "string" ? ee(Ve).fill(Pe, $e) : ee(Ve).fill(Pe) : ee(Ve);
  }
  te.alloc = function(Ve, Pe, $e) {
    return se(Ve, Pe, $e);
  };
  function de(Ve) {
    return ie(Ve), ee(Ve < 0 ? 0 : ve(Ve) | 0);
  }
  te.allocUnsafe = function(Ve) {
    return de(Ve);
  }, te.allocUnsafeSlow = function(Ve) {
    return de(Ve);
  };
  function ue(Ve, Pe) {
    if ((typeof Pe != "string" || Pe === "") && (Pe = "utf8"), !te.isEncoding(Pe))
      throw new TypeError("Unknown encoding: " + Pe);
    const $e = we(Ve, Pe) | 0;
    let Ze = ee($e);
    const at = Ze.write(Ve, Pe);
    return at !== $e && (Ze = Ze.slice(0, at)), Ze;
  }
  function fe(Ve) {
    const Pe = Ve.length < 0 ? 0 : ve(Ve.length) | 0, $e = ee(Pe);
    for (let Ze = 0; Ze < Pe; Ze += 1)
      $e[Ze] = Ve[Ze] & 255;
    return $e;
  }
  function he(Ve) {
    if (mt(Ve, Uint8Array)) {
      const Pe = new Uint8Array(Ve);
      return me(Pe.buffer, Pe.byteOffset, Pe.byteLength);
    }
    return fe(Ve);
  }
  function me(Ve, Pe, $e) {
    if (Pe < 0 || Ve.byteLength < Pe)
      throw new RangeError('"offset" is outside of buffer bounds');
    if (Ve.byteLength < Pe + ($e || 0))
      throw new RangeError('"length" is outside of buffer bounds');
    let Ze;
    return Pe === void 0 && $e === void 0 ? Ze = new Uint8Array(Ve) : $e === void 0 ? Ze = new Uint8Array(Ve, Pe) : Ze = new Uint8Array(Ve, Pe, $e), Object.setPrototypeOf(Ze, te.prototype), Ze;
  }
  function xe(Ve) {
    if (te.isBuffer(Ve)) {
      const Pe = ve(Ve.length) | 0, $e = ee(Pe);
      return $e.length === 0 || Ve.copy($e, 0, 0, Pe), $e;
    }
    if (Ve.length !== void 0)
      return typeof Ve.length != "number" || It(Ve.length) ? ee(0) : fe(Ve);
    if (Ve.type === "Buffer" && Array.isArray(Ve.data))
      return fe(Ve.data);
  }
  function ve(Ve) {
    if (Ve >= V)
      throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + V.toString(16) + " bytes");
    return Ve | 0;
  }
  function Te(Ve) {
    return +Ve != Ve && (Ve = 0), te.alloc(+Ve);
  }
  te.isBuffer = function(Pe) {
    return Pe != null && Pe._isBuffer === !0 && Pe !== te.prototype;
  }, te.compare = function(Pe, $e) {
    if (mt(Pe, Uint8Array) && (Pe = te.from(Pe, Pe.offset, Pe.byteLength)), mt($e, Uint8Array) && ($e = te.from($e, $e.offset, $e.byteLength)), !te.isBuffer(Pe) || !te.isBuffer($e))
      throw new TypeError(
        'The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array'
      );
    if (Pe === $e) return 0;
    let Ze = Pe.length, at = $e.length;
    for (let wt = 0, ft = Math.min(Ze, at); wt < ft; ++wt)
      if (Pe[wt] !== $e[wt]) {
        Ze = Pe[wt], at = $e[wt];
        break;
      }
    return Ze < at ? -1 : at < Ze ? 1 : 0;
  }, te.isEncoding = function(Pe) {
    switch (String(Pe).toLowerCase()) {
      case "hex":
      case "utf8":
      case "utf-8":
      case "ascii":
      case "latin1":
      case "binary":
      case "base64":
      case "ucs2":
      case "ucs-2":
      case "utf16le":
      case "utf-16le":
        return !0;
      default:
        return !1;
    }
  }, te.concat = function(Pe, $e) {
    if (!Array.isArray(Pe))
      throw new TypeError('"list" argument must be an Array of Buffers');
    if (Pe.length === 0)
      return te.alloc(0);
    let Ze;
    if ($e === void 0)
      for ($e = 0, Ze = 0; Ze < Pe.length; ++Ze)
        $e += Pe[Ze].length;
    const at = te.allocUnsafe($e);
    let wt = 0;
    for (Ze = 0; Ze < Pe.length; ++Ze) {
      let ft = Pe[Ze];
      if (mt(ft, Uint8Array))
        wt + ft.length > at.length ? (te.isBuffer(ft) || (ft = te.from(ft)), ft.copy(at, wt)) : Uint8Array.prototype.set.call(
          at,
          ft,
          wt
        );
      else if (te.isBuffer(ft))
        ft.copy(at, wt);
      else
        throw new TypeError('"list" argument must be an Array of Buffers');
      wt += ft.length;
    }
    return at;
  };
  function we(Ve, Pe) {
    if (te.isBuffer(Ve))
      return Ve.length;
    if (ArrayBuffer.isView(Ve) || mt(Ve, ArrayBuffer))
      return Ve.byteLength;
    if (typeof Ve != "string")
      throw new TypeError(
        'The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof Ve
      );
    const $e = Ve.length, Ze = arguments.length > 2 && arguments[2] === !0;
    if (!Ze && $e === 0) return 0;
    let at = !1;
    for (; ; )
      switch (Pe) {
        case "ascii":
        case "latin1":
        case "binary":
          return $e;
        case "utf8":
        case "utf-8":
          return ct(Ve).length;
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
          return $e * 2;
        case "hex":
          return $e >>> 1;
        case "base64":
          return yt(Ve).length;
        default:
          if (at)
            return Ze ? -1 : ct(Ve).length;
          Pe = ("" + Pe).toLowerCase(), at = !0;
      }
  }
  te.byteLength = we;
  function Ee(Ve, Pe, $e) {
    let Ze = !1;
    if ((Pe === void 0 || Pe < 0) && (Pe = 0), Pe > this.length || (($e === void 0 || $e > this.length) && ($e = this.length), $e <= 0) || ($e >>>= 0, Pe >>>= 0, $e <= Pe))
      return "";
    for (Ve || (Ve = "utf8"); ; )
      switch (Ve) {
        case "hex":
          return be(this, Pe, $e);
        case "utf8":
        case "utf-8":
          return ce(this, Pe, $e);
        case "ascii":
          return ye(this, Pe, $e);
        case "latin1":
        case "binary":
          return Ce(this, Pe, $e);
        case "base64":
          return oe(this, Pe, $e);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
          return ae(this, Pe, $e);
        default:
          if (Ze) throw new TypeError("Unknown encoding: " + Ve);
          Ve = (Ve + "").toLowerCase(), Ze = !0;
      }
  }
  te.prototype._isBuffer = !0;
  function Me(Ve, Pe, $e) {
    const Ze = Ve[Pe];
    Ve[Pe] = Ve[$e], Ve[$e] = Ze;
  }
  te.prototype.swap16 = function() {
    const Pe = this.length;
    if (Pe % 2 !== 0)
      throw new RangeError("Buffer size must be a multiple of 16-bits");
    for (let $e = 0; $e < Pe; $e += 2)
      Me(this, $e, $e + 1);
    return this;
  }, te.prototype.swap32 = function() {
    const Pe = this.length;
    if (Pe % 4 !== 0)
      throw new RangeError("Buffer size must be a multiple of 32-bits");
    for (let $e = 0; $e < Pe; $e += 4)
      Me(this, $e, $e + 3), Me(this, $e + 1, $e + 2);
    return this;
  }, te.prototype.swap64 = function() {
    const Pe = this.length;
    if (Pe % 8 !== 0)
      throw new RangeError("Buffer size must be a multiple of 64-bits");
    for (let $e = 0; $e < Pe; $e += 8)
      Me(this, $e, $e + 7), Me(this, $e + 1, $e + 6), Me(this, $e + 2, $e + 5), Me(this, $e + 3, $e + 4);
    return this;
  }, te.prototype.toString = function() {
    const Pe = this.length;
    return Pe === 0 ? "" : arguments.length === 0 ? ce(this, 0, Pe) : Ee.apply(this, arguments);
  }, te.prototype.toLocaleString = te.prototype.toString, te.prototype.equals = function(Pe) {
    if (!te.isBuffer(Pe)) throw new TypeError("Argument must be a Buffer");
    return this === Pe ? !0 : te.compare(this, Pe) === 0;
  }, te.prototype.inspect = function() {
    let Pe = "";
    const $e = C.INSPECT_MAX_BYTES;
    return Pe = this.toString("hex", 0, $e).replace(/(.{2})/g, "$1 ").trim(), this.length > $e && (Pe += " ... "), "<Buffer " + Pe + ">";
  }, $ && (te.prototype[$] = te.prototype.inspect), te.prototype.compare = function(Pe, $e, Ze, at, wt) {
    if (mt(Pe, Uint8Array) && (Pe = te.from(Pe, Pe.offset, Pe.byteLength)), !te.isBuffer(Pe))
      throw new TypeError(
        'The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof Pe
      );
    if ($e === void 0 && ($e = 0), Ze === void 0 && (Ze = Pe ? Pe.length : 0), at === void 0 && (at = 0), wt === void 0 && (wt = this.length), $e < 0 || Ze > Pe.length || at < 0 || wt > this.length)
      throw new RangeError("out of range index");
    if (at >= wt && $e >= Ze)
      return 0;
    if (at >= wt)
      return -1;
    if ($e >= Ze)
      return 1;
    if ($e >>>= 0, Ze >>>= 0, at >>>= 0, wt >>>= 0, this === Pe) return 0;
    let ft = wt - at, Ct = Ze - $e;
    const Ut = Math.min(ft, Ct), vt = this.slice(at, wt), Mt = Pe.slice($e, Ze);
    for (let Xt = 0; Xt < Ut; ++Xt)
      if (vt[Xt] !== Mt[Xt]) {
        ft = vt[Xt], Ct = Mt[Xt];
        break;
      }
    return ft < Ct ? -1 : Ct < ft ? 1 : 0;
  };
  function Ie(Ve, Pe, $e, Ze, at) {
    if (Ve.length === 0) return -1;
    if (typeof $e == "string" ? (Ze = $e, $e = 0) : $e > 2147483647 ? $e = 2147483647 : $e < -2147483648 && ($e = -2147483648), $e = +$e, It($e) && ($e = at ? 0 : Ve.length - 1), $e < 0 && ($e = Ve.length + $e), $e >= Ve.length) {
      if (at) return -1;
      $e = Ve.length - 1;
    } else if ($e < 0)
      if (at) $e = 0;
      else return -1;
    if (typeof Pe == "string" && (Pe = te.from(Pe, Ze)), te.isBuffer(Pe))
      return Pe.length === 0 ? -1 : ke(Ve, Pe, $e, Ze, at);
    if (typeof Pe == "number")
      return Pe = Pe & 255, typeof Uint8Array.prototype.indexOf == "function" ? at ? Uint8Array.prototype.indexOf.call(Ve, Pe, $e) : Uint8Array.prototype.lastIndexOf.call(Ve, Pe, $e) : ke(Ve, [Pe], $e, Ze, at);
    throw new TypeError("val must be string, number or Buffer");
  }
  function ke(Ve, Pe, $e, Ze, at) {
    let wt = 1, ft = Ve.length, Ct = Pe.length;
    if (Ze !== void 0 && (Ze = String(Ze).toLowerCase(), Ze === "ucs2" || Ze === "ucs-2" || Ze === "utf16le" || Ze === "utf-16le")) {
      if (Ve.length < 2 || Pe.length < 2)
        return -1;
      wt = 2, ft /= 2, Ct /= 2, $e /= 2;
    }
    function Ut(Mt, Xt) {
      return wt === 1 ? Mt[Xt] : Mt.readUInt16BE(Xt * wt);
    }
    let vt;
    if (at) {
      let Mt = -1;
      for (vt = $e; vt < ft; vt++)
        if (Ut(Ve, vt) === Ut(Pe, Mt === -1 ? 0 : vt - Mt)) {
          if (Mt === -1 && (Mt = vt), vt - Mt + 1 === Ct) return Mt * wt;
        } else
          Mt !== -1 && (vt -= vt - Mt), Mt = -1;
    } else
      for ($e + Ct > ft && ($e = ft - Ct), vt = $e; vt >= 0; vt--) {
        let Mt = !0;
        for (let Xt = 0; Xt < Ct; Xt++)
          if (Ut(Ve, vt + Xt) !== Ut(Pe, Xt)) {
            Mt = !1;
            break;
          }
        if (Mt) return vt;
      }
    return -1;
  }
  te.prototype.includes = function(Pe, $e, Ze) {
    return this.indexOf(Pe, $e, Ze) !== -1;
  }, te.prototype.indexOf = function(Pe, $e, Ze) {
    return Ie(this, Pe, $e, Ze, !0);
  }, te.prototype.lastIndexOf = function(Pe, $e, Ze) {
    return Ie(this, Pe, $e, Ze, !1);
  };
  function _e(Ve, Pe, $e, Ze) {
    $e = Number($e) || 0;
    const at = Ve.length - $e;
    Ze ? (Ze = Number(Ze), Ze > at && (Ze = at)) : Ze = at;
    const wt = Pe.length;
    Ze > wt / 2 && (Ze = wt / 2);
    let ft;
    for (ft = 0; ft < Ze; ++ft) {
      const Ct = parseInt(Pe.substr(ft * 2, 2), 16);
      if (It(Ct)) return ft;
      Ve[$e + ft] = Ct;
    }
    return ft;
  }
  function De(Ve, Pe, $e, Ze) {
    return dt(ct(Pe, Ve.length - $e), Ve, $e, Ze);
  }
  function Fe(Ve, Pe, $e, Ze) {
    return dt(it(Pe), Ve, $e, Ze);
  }
  function Ae(Ve, Pe, $e, Ze) {
    return dt(yt(Pe), Ve, $e, Ze);
  }
  function ne(Ve, Pe, $e, Ze) {
    return dt(ot(Pe, Ve.length - $e), Ve, $e, Ze);
  }
  te.prototype.write = function(Pe, $e, Ze, at) {
    if ($e === void 0)
      at = "utf8", Ze = this.length, $e = 0;
    else if (Ze === void 0 && typeof $e == "string")
      at = $e, Ze = this.length, $e = 0;
    else if (isFinite($e))
      $e = $e >>> 0, isFinite(Ze) ? (Ze = Ze >>> 0, at === void 0 && (at = "utf8")) : (at = Ze, Ze = void 0);
    else
      throw new Error(
        "Buffer.write(string, encoding, offset[, length]) is no longer supported"
      );
    const wt = this.length - $e;
    if ((Ze === void 0 || Ze > wt) && (Ze = wt), Pe.length > 0 && (Ze < 0 || $e < 0) || $e > this.length)
      throw new RangeError("Attempt to write outside buffer bounds");
    at || (at = "utf8");
    let ft = !1;
    for (; ; )
      switch (at) {
        case "hex":
          return _e(this, Pe, $e, Ze);
        case "utf8":
        case "utf-8":
          return De(this, Pe, $e, Ze);
        case "ascii":
        case "latin1":
        case "binary":
          return Fe(this, Pe, $e, Ze);
        case "base64":
          return Ae(this, Pe, $e, Ze);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
          return ne(this, Pe, $e, Ze);
        default:
          if (ft) throw new TypeError("Unknown encoding: " + at);
          at = ("" + at).toLowerCase(), ft = !0;
      }
  }, te.prototype.toJSON = function() {
    return {
      type: "Buffer",
      data: Array.prototype.slice.call(this._arr || this, 0)
    };
  };
  function oe(Ve, Pe, $e) {
    return Pe === 0 && $e === Ve.length ? e.fromByteArray(Ve) : e.fromByteArray(Ve.slice(Pe, $e));
  }
  function ce(Ve, Pe, $e) {
    $e = Math.min(Ve.length, $e);
    const Ze = [];
    let at = Pe;
    for (; at < $e; ) {
      const wt = Ve[at];
      let ft = null, Ct = wt > 239 ? 4 : wt > 223 ? 3 : wt > 191 ? 2 : 1;
      if (at + Ct <= $e) {
        let Ut, vt, Mt, Xt;
        switch (Ct) {
          case 1:
            wt < 128 && (ft = wt);
            break;
          case 2:
            Ut = Ve[at + 1], (Ut & 192) === 128 && (Xt = (wt & 31) << 6 | Ut & 63, Xt > 127 && (ft = Xt));
            break;
          case 3:
            Ut = Ve[at + 1], vt = Ve[at + 2], (Ut & 192) === 128 && (vt & 192) === 128 && (Xt = (wt & 15) << 12 | (Ut & 63) << 6 | vt & 63, Xt > 2047 && (Xt < 55296 || Xt > 57343) && (ft = Xt));
            break;
          case 4:
            Ut = Ve[at + 1], vt = Ve[at + 2], Mt = Ve[at + 3], (Ut & 192) === 128 && (vt & 192) === 128 && (Mt & 192) === 128 && (Xt = (wt & 15) << 18 | (Ut & 63) << 12 | (vt & 63) << 6 | Mt & 63, Xt > 65535 && Xt < 1114112 && (ft = Xt));
        }
      }
      ft === null ? (ft = 65533, Ct = 1) : ft > 65535 && (ft -= 65536, Ze.push(ft >>> 10 & 1023 | 55296), ft = 56320 | ft & 1023), Ze.push(ft), at += Ct;
    }
    return pe(Ze);
  }
  const le = 4096;
  function pe(Ve) {
    const Pe = Ve.length;
    if (Pe <= le)
      return String.fromCharCode.apply(String, Ve);
    let $e = "", Ze = 0;
    for (; Ze < Pe; )
      $e += String.fromCharCode.apply(
        String,
        Ve.slice(Ze, Ze += le)
      );
    return $e;
  }
  function ye(Ve, Pe, $e) {
    let Ze = "";
    $e = Math.min(Ve.length, $e);
    for (let at = Pe; at < $e; ++at)
      Ze += String.fromCharCode(Ve[at] & 127);
    return Ze;
  }
  function Ce(Ve, Pe, $e) {
    let Ze = "";
    $e = Math.min(Ve.length, $e);
    for (let at = Pe; at < $e; ++at)
      Ze += String.fromCharCode(Ve[at]);
    return Ze;
  }
  function be(Ve, Pe, $e) {
    const Ze = Ve.length;
    (!Pe || Pe < 0) && (Pe = 0), (!$e || $e < 0 || $e > Ze) && ($e = Ze);
    let at = "";
    for (let wt = Pe; wt < $e; ++wt)
      at += xt[Ve[wt]];
    return at;
  }
  function ae(Ve, Pe, $e) {
    const Ze = Ve.slice(Pe, $e);
    let at = "";
    for (let wt = 0; wt < Ze.length - 1; wt += 2)
      at += String.fromCharCode(Ze[wt] + Ze[wt + 1] * 256);
    return at;
  }
  te.prototype.slice = function(Pe, $e) {
    const Ze = this.length;
    Pe = ~~Pe, $e = $e === void 0 ? Ze : ~~$e, Pe < 0 ? (Pe += Ze, Pe < 0 && (Pe = 0)) : Pe > Ze && (Pe = Ze), $e < 0 ? ($e += Ze, $e < 0 && ($e = 0)) : $e > Ze && ($e = Ze), $e < Pe && ($e = Pe);
    const at = this.subarray(Pe, $e);
    return Object.setPrototypeOf(at, te.prototype), at;
  };
  function ge(Ve, Pe, $e) {
    if (Ve % 1 !== 0 || Ve < 0) throw new RangeError("offset is not uint");
    if (Ve + Pe > $e) throw new RangeError("Trying to access beyond buffer length");
  }
  te.prototype.readUintLE = te.prototype.readUIntLE = function(Pe, $e, Ze) {
    Pe = Pe >>> 0, $e = $e >>> 0, Ze || ge(Pe, $e, this.length);
    let at = this[Pe], wt = 1, ft = 0;
    for (; ++ft < $e && (wt *= 256); )
      at += this[Pe + ft] * wt;
    return at;
  }, te.prototype.readUintBE = te.prototype.readUIntBE = function(Pe, $e, Ze) {
    Pe = Pe >>> 0, $e = $e >>> 0, Ze || ge(Pe, $e, this.length);
    let at = this[Pe + --$e], wt = 1;
    for (; $e > 0 && (wt *= 256); )
      at += this[Pe + --$e] * wt;
    return at;
  }, te.prototype.readUint8 = te.prototype.readUInt8 = function(Pe, $e) {
    return Pe = Pe >>> 0, $e || ge(Pe, 1, this.length), this[Pe];
  }, te.prototype.readUint16LE = te.prototype.readUInt16LE = function(Pe, $e) {
    return Pe = Pe >>> 0, $e || ge(Pe, 2, this.length), this[Pe] | this[Pe + 1] << 8;
  }, te.prototype.readUint16BE = te.prototype.readUInt16BE = function(Pe, $e) {
    return Pe = Pe >>> 0, $e || ge(Pe, 2, this.length), this[Pe] << 8 | this[Pe + 1];
  }, te.prototype.readUint32LE = te.prototype.readUInt32LE = function(Pe, $e) {
    return Pe = Pe >>> 0, $e || ge(Pe, 4, this.length), (this[Pe] | this[Pe + 1] << 8 | this[Pe + 2] << 16) + this[Pe + 3] * 16777216;
  }, te.prototype.readUint32BE = te.prototype.readUInt32BE = function(Pe, $e) {
    return Pe = Pe >>> 0, $e || ge(Pe, 4, this.length), this[Pe] * 16777216 + (this[Pe + 1] << 16 | this[Pe + 2] << 8 | this[Pe + 3]);
  }, te.prototype.readBigUInt64LE = Tt(function(Pe) {
    Pe = Pe >>> 0, Ye(Pe, "offset");
    const $e = this[Pe], Ze = this[Pe + 7];
    ($e === void 0 || Ze === void 0) && Je(Pe, this.length - 8);
    const at = $e + this[++Pe] * 2 ** 8 + this[++Pe] * 2 ** 16 + this[++Pe] * 2 ** 24, wt = this[++Pe] + this[++Pe] * 2 ** 8 + this[++Pe] * 2 ** 16 + Ze * 2 ** 24;
    return BigInt(at) + (BigInt(wt) << BigInt(32));
  }), te.prototype.readBigUInt64BE = Tt(function(Pe) {
    Pe = Pe >>> 0, Ye(Pe, "offset");
    const $e = this[Pe], Ze = this[Pe + 7];
    ($e === void 0 || Ze === void 0) && Je(Pe, this.length - 8);
    const at = $e * 2 ** 24 + this[++Pe] * 2 ** 16 + this[++Pe] * 2 ** 8 + this[++Pe], wt = this[++Pe] * 2 ** 24 + this[++Pe] * 2 ** 16 + this[++Pe] * 2 ** 8 + Ze;
    return (BigInt(at) << BigInt(32)) + BigInt(wt);
  }), te.prototype.readIntLE = function(Pe, $e, Ze) {
    Pe = Pe >>> 0, $e = $e >>> 0, Ze || ge(Pe, $e, this.length);
    let at = this[Pe], wt = 1, ft = 0;
    for (; ++ft < $e && (wt *= 256); )
      at += this[Pe + ft] * wt;
    return wt *= 128, at >= wt && (at -= Math.pow(2, 8 * $e)), at;
  }, te.prototype.readIntBE = function(Pe, $e, Ze) {
    Pe = Pe >>> 0, $e = $e >>> 0, Ze || ge(Pe, $e, this.length);
    let at = $e, wt = 1, ft = this[Pe + --at];
    for (; at > 0 && (wt *= 256); )
      ft += this[Pe + --at] * wt;
    return wt *= 128, ft >= wt && (ft -= Math.pow(2, 8 * $e)), ft;
  }, te.prototype.readInt8 = function(Pe, $e) {
    return Pe = Pe >>> 0, $e || ge(Pe, 1, this.length), this[Pe] & 128 ? (255 - this[Pe] + 1) * -1 : this[Pe];
  }, te.prototype.readInt16LE = function(Pe, $e) {
    Pe = Pe >>> 0, $e || ge(Pe, 2, this.length);
    const Ze = this[Pe] | this[Pe + 1] << 8;
    return Ze & 32768 ? Ze | 4294901760 : Ze;
  }, te.prototype.readInt16BE = function(Pe, $e) {
    Pe = Pe >>> 0, $e || ge(Pe, 2, this.length);
    const Ze = this[Pe + 1] | this[Pe] << 8;
    return Ze & 32768 ? Ze | 4294901760 : Ze;
  }, te.prototype.readInt32LE = function(Pe, $e) {
    return Pe = Pe >>> 0, $e || ge(Pe, 4, this.length), this[Pe] | this[Pe + 1] << 8 | this[Pe + 2] << 16 | this[Pe + 3] << 24;
  }, te.prototype.readInt32BE = function(Pe, $e) {
    return Pe = Pe >>> 0, $e || ge(Pe, 4, this.length), this[Pe] << 24 | this[Pe + 1] << 16 | this[Pe + 2] << 8 | this[Pe + 3];
  }, te.prototype.readBigInt64LE = Tt(function(Pe) {
    Pe = Pe >>> 0, Ye(Pe, "offset");
    const $e = this[Pe], Ze = this[Pe + 7];
    ($e === void 0 || Ze === void 0) && Je(Pe, this.length - 8);
    const at = this[Pe + 4] + this[Pe + 5] * 2 ** 8 + this[Pe + 6] * 2 ** 16 + (Ze << 24);
    return (BigInt(at) << BigInt(32)) + BigInt($e + this[++Pe] * 2 ** 8 + this[++Pe] * 2 ** 16 + this[++Pe] * 2 ** 24);
  }), te.prototype.readBigInt64BE = Tt(function(Pe) {
    Pe = Pe >>> 0, Ye(Pe, "offset");
    const $e = this[Pe], Ze = this[Pe + 7];
    ($e === void 0 || Ze === void 0) && Je(Pe, this.length - 8);
    const at = ($e << 24) + // Overflow
    this[++Pe] * 2 ** 16 + this[++Pe] * 2 ** 8 + this[++Pe];
    return (BigInt(at) << BigInt(32)) + BigInt(this[++Pe] * 2 ** 24 + this[++Pe] * 2 ** 16 + this[++Pe] * 2 ** 8 + Ze);
  }), te.prototype.readFloatLE = function(Pe, $e) {
    return Pe = Pe >>> 0, $e || ge(Pe, 4, this.length), T.read(this, Pe, !0, 23, 4);
  }, te.prototype.readFloatBE = function(Pe, $e) {
    return Pe = Pe >>> 0, $e || ge(Pe, 4, this.length), T.read(this, Pe, !1, 23, 4);
  }, te.prototype.readDoubleLE = function(Pe, $e) {
    return Pe = Pe >>> 0, $e || ge(Pe, 8, this.length), T.read(this, Pe, !0, 52, 8);
  }, te.prototype.readDoubleBE = function(Pe, $e) {
    return Pe = Pe >>> 0, $e || ge(Pe, 8, this.length), T.read(this, Pe, !1, 52, 8);
  };
  function Se(Ve, Pe, $e, Ze, at, wt) {
    if (!te.isBuffer(Ve)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (Pe > at || Pe < wt) throw new RangeError('"value" argument is out of bounds');
    if ($e + Ze > Ve.length) throw new RangeError("Index out of range");
  }
  te.prototype.writeUintLE = te.prototype.writeUIntLE = function(Pe, $e, Ze, at) {
    if (Pe = +Pe, $e = $e >>> 0, Ze = Ze >>> 0, !at) {
      const Ct = Math.pow(2, 8 * Ze) - 1;
      Se(this, Pe, $e, Ze, Ct, 0);
    }
    let wt = 1, ft = 0;
    for (this[$e] = Pe & 255; ++ft < Ze && (wt *= 256); )
      this[$e + ft] = Pe / wt & 255;
    return $e + Ze;
  }, te.prototype.writeUintBE = te.prototype.writeUIntBE = function(Pe, $e, Ze, at) {
    if (Pe = +Pe, $e = $e >>> 0, Ze = Ze >>> 0, !at) {
      const Ct = Math.pow(2, 8 * Ze) - 1;
      Se(this, Pe, $e, Ze, Ct, 0);
    }
    let wt = Ze - 1, ft = 1;
    for (this[$e + wt] = Pe & 255; --wt >= 0 && (ft *= 256); )
      this[$e + wt] = Pe / ft & 255;
    return $e + Ze;
  }, te.prototype.writeUint8 = te.prototype.writeUInt8 = function(Pe, $e, Ze) {
    return Pe = +Pe, $e = $e >>> 0, Ze || Se(this, Pe, $e, 1, 255, 0), this[$e] = Pe & 255, $e + 1;
  }, te.prototype.writeUint16LE = te.prototype.writeUInt16LE = function(Pe, $e, Ze) {
    return Pe = +Pe, $e = $e >>> 0, Ze || Se(this, Pe, $e, 2, 65535, 0), this[$e] = Pe & 255, this[$e + 1] = Pe >>> 8, $e + 2;
  }, te.prototype.writeUint16BE = te.prototype.writeUInt16BE = function(Pe, $e, Ze) {
    return Pe = +Pe, $e = $e >>> 0, Ze || Se(this, Pe, $e, 2, 65535, 0), this[$e] = Pe >>> 8, this[$e + 1] = Pe & 255, $e + 2;
  }, te.prototype.writeUint32LE = te.prototype.writeUInt32LE = function(Pe, $e, Ze) {
    return Pe = +Pe, $e = $e >>> 0, Ze || Se(this, Pe, $e, 4, 4294967295, 0), this[$e + 3] = Pe >>> 24, this[$e + 2] = Pe >>> 16, this[$e + 1] = Pe >>> 8, this[$e] = Pe & 255, $e + 4;
  }, te.prototype.writeUint32BE = te.prototype.writeUInt32BE = function(Pe, $e, Ze) {
    return Pe = +Pe, $e = $e >>> 0, Ze || Se(this, Pe, $e, 4, 4294967295, 0), this[$e] = Pe >>> 24, this[$e + 1] = Pe >>> 16, this[$e + 2] = Pe >>> 8, this[$e + 3] = Pe & 255, $e + 4;
  };
  function Le(Ve, Pe, $e, Ze, at) {
    Ne(Pe, Ze, at, Ve, $e, 7);
    let wt = Number(Pe & BigInt(4294967295));
    Ve[$e++] = wt, wt = wt >> 8, Ve[$e++] = wt, wt = wt >> 8, Ve[$e++] = wt, wt = wt >> 8, Ve[$e++] = wt;
    let ft = Number(Pe >> BigInt(32) & BigInt(4294967295));
    return Ve[$e++] = ft, ft = ft >> 8, Ve[$e++] = ft, ft = ft >> 8, Ve[$e++] = ft, ft = ft >> 8, Ve[$e++] = ft, $e;
  }
  function ze(Ve, Pe, $e, Ze, at) {
    Ne(Pe, Ze, at, Ve, $e, 7);
    let wt = Number(Pe & BigInt(4294967295));
    Ve[$e + 7] = wt, wt = wt >> 8, Ve[$e + 6] = wt, wt = wt >> 8, Ve[$e + 5] = wt, wt = wt >> 8, Ve[$e + 4] = wt;
    let ft = Number(Pe >> BigInt(32) & BigInt(4294967295));
    return Ve[$e + 3] = ft, ft = ft >> 8, Ve[$e + 2] = ft, ft = ft >> 8, Ve[$e + 1] = ft, ft = ft >> 8, Ve[$e] = ft, $e + 8;
  }
  te.prototype.writeBigUInt64LE = Tt(function(Pe, $e = 0) {
    return Le(this, Pe, $e, BigInt(0), BigInt("0xffffffffffffffff"));
  }), te.prototype.writeBigUInt64BE = Tt(function(Pe, $e = 0) {
    return ze(this, Pe, $e, BigInt(0), BigInt("0xffffffffffffffff"));
  }), te.prototype.writeIntLE = function(Pe, $e, Ze, at) {
    if (Pe = +Pe, $e = $e >>> 0, !at) {
      const Ut = Math.pow(2, 8 * Ze - 1);
      Se(this, Pe, $e, Ze, Ut - 1, -Ut);
    }
    let wt = 0, ft = 1, Ct = 0;
    for (this[$e] = Pe & 255; ++wt < Ze && (ft *= 256); )
      Pe < 0 && Ct === 0 && this[$e + wt - 1] !== 0 && (Ct = 1), this[$e + wt] = (Pe / ft >> 0) - Ct & 255;
    return $e + Ze;
  }, te.prototype.writeIntBE = function(Pe, $e, Ze, at) {
    if (Pe = +Pe, $e = $e >>> 0, !at) {
      const Ut = Math.pow(2, 8 * Ze - 1);
      Se(this, Pe, $e, Ze, Ut - 1, -Ut);
    }
    let wt = Ze - 1, ft = 1, Ct = 0;
    for (this[$e + wt] = Pe & 255; --wt >= 0 && (ft *= 256); )
      Pe < 0 && Ct === 0 && this[$e + wt + 1] !== 0 && (Ct = 1), this[$e + wt] = (Pe / ft >> 0) - Ct & 255;
    return $e + Ze;
  }, te.prototype.writeInt8 = function(Pe, $e, Ze) {
    return Pe = +Pe, $e = $e >>> 0, Ze || Se(this, Pe, $e, 1, 127, -128), Pe < 0 && (Pe = 255 + Pe + 1), this[$e] = Pe & 255, $e + 1;
  }, te.prototype.writeInt16LE = function(Pe, $e, Ze) {
    return Pe = +Pe, $e = $e >>> 0, Ze || Se(this, Pe, $e, 2, 32767, -32768), this[$e] = Pe & 255, this[$e + 1] = Pe >>> 8, $e + 2;
  }, te.prototype.writeInt16BE = function(Pe, $e, Ze) {
    return Pe = +Pe, $e = $e >>> 0, Ze || Se(this, Pe, $e, 2, 32767, -32768), this[$e] = Pe >>> 8, this[$e + 1] = Pe & 255, $e + 2;
  }, te.prototype.writeInt32LE = function(Pe, $e, Ze) {
    return Pe = +Pe, $e = $e >>> 0, Ze || Se(this, Pe, $e, 4, 2147483647, -2147483648), this[$e] = Pe & 255, this[$e + 1] = Pe >>> 8, this[$e + 2] = Pe >>> 16, this[$e + 3] = Pe >>> 24, $e + 4;
  }, te.prototype.writeInt32BE = function(Pe, $e, Ze) {
    return Pe = +Pe, $e = $e >>> 0, Ze || Se(this, Pe, $e, 4, 2147483647, -2147483648), Pe < 0 && (Pe = 4294967295 + Pe + 1), this[$e] = Pe >>> 24, this[$e + 1] = Pe >>> 16, this[$e + 2] = Pe >>> 8, this[$e + 3] = Pe & 255, $e + 4;
  }, te.prototype.writeBigInt64LE = Tt(function(Pe, $e = 0) {
    return Le(this, Pe, $e, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
  }), te.prototype.writeBigInt64BE = Tt(function(Pe, $e = 0) {
    return ze(this, Pe, $e, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
  });
  function Re(Ve, Pe, $e, Ze, at, wt) {
    if ($e + Ze > Ve.length) throw new RangeError("Index out of range");
    if ($e < 0) throw new RangeError("Index out of range");
  }
  function We(Ve, Pe, $e, Ze, at) {
    return Pe = +Pe, $e = $e >>> 0, at || Re(Ve, Pe, $e, 4), T.write(Ve, Pe, $e, Ze, 23, 4), $e + 4;
  }
  te.prototype.writeFloatLE = function(Pe, $e, Ze) {
    return We(this, Pe, $e, !0, Ze);
  }, te.prototype.writeFloatBE = function(Pe, $e, Ze) {
    return We(this, Pe, $e, !1, Ze);
  };
  function Be(Ve, Pe, $e, Ze, at) {
    return Pe = +Pe, $e = $e >>> 0, at || Re(Ve, Pe, $e, 8), T.write(Ve, Pe, $e, Ze, 52, 8), $e + 8;
  }
  te.prototype.writeDoubleLE = function(Pe, $e, Ze) {
    return Be(this, Pe, $e, !0, Ze);
  }, te.prototype.writeDoubleBE = function(Pe, $e, Ze) {
    return Be(this, Pe, $e, !1, Ze);
  }, te.prototype.copy = function(Pe, $e, Ze, at) {
    if (!te.isBuffer(Pe)) throw new TypeError("argument should be a Buffer");
    if (Ze || (Ze = 0), !at && at !== 0 && (at = this.length), $e >= Pe.length && ($e = Pe.length), $e || ($e = 0), at > 0 && at < Ze && (at = Ze), at === Ze || Pe.length === 0 || this.length === 0) return 0;
    if ($e < 0)
      throw new RangeError("targetStart out of bounds");
    if (Ze < 0 || Ze >= this.length) throw new RangeError("Index out of range");
    if (at < 0) throw new RangeError("sourceEnd out of bounds");
    at > this.length && (at = this.length), Pe.length - $e < at - Ze && (at = Pe.length - $e + Ze);
    const wt = at - Ze;
    return this === Pe && typeof Uint8Array.prototype.copyWithin == "function" ? this.copyWithin($e, Ze, at) : Uint8Array.prototype.set.call(
      Pe,
      this.subarray(Ze, at),
      $e
    ), wt;
  }, te.prototype.fill = function(Pe, $e, Ze, at) {
    if (typeof Pe == "string") {
      if (typeof $e == "string" ? (at = $e, $e = 0, Ze = this.length) : typeof Ze == "string" && (at = Ze, Ze = this.length), at !== void 0 && typeof at != "string")
        throw new TypeError("encoding must be a string");
      if (typeof at == "string" && !te.isEncoding(at))
        throw new TypeError("Unknown encoding: " + at);
      if (Pe.length === 1) {
        const ft = Pe.charCodeAt(0);
        (at === "utf8" && ft < 128 || at === "latin1") && (Pe = ft);
      }
    } else typeof Pe == "number" ? Pe = Pe & 255 : typeof Pe == "boolean" && (Pe = Number(Pe));
    if ($e < 0 || this.length < $e || this.length < Ze)
      throw new RangeError("Out of range index");
    if (Ze <= $e)
      return this;
    $e = $e >>> 0, Ze = Ze === void 0 ? this.length : Ze >>> 0, Pe || (Pe = 0);
    let wt;
    if (typeof Pe == "number")
      for (wt = $e; wt < Ze; ++wt)
        this[wt] = Pe;
    else {
      const ft = te.isBuffer(Pe) ? Pe : te.from(Pe, at), Ct = ft.length;
      if (Ct === 0)
        throw new TypeError('The value "' + Pe + '" is invalid for argument "value"');
      for (wt = 0; wt < Ze - $e; ++wt)
        this[wt + $e] = ft[wt % Ct];
    }
    return this;
  };
  const Ue = {};
  function Ge(Ve, Pe, $e) {
    Ue[Ve] = class extends $e {
      constructor() {
        super(), Object.defineProperty(this, "message", {
          value: Pe.apply(this, arguments),
          writable: !0,
          configurable: !0
        }), this.name = `${this.name} [${Ve}]`, this.stack, delete this.name;
      }
      get code() {
        return Ve;
      }
      set code(at) {
        Object.defineProperty(this, "code", {
          configurable: !0,
          enumerable: !0,
          value: at,
          writable: !0
        });
      }
      toString() {
        return `${this.name} [${Ve}]: ${this.message}`;
      }
    };
  }
  Ge(
    "ERR_BUFFER_OUT_OF_BOUNDS",
    function(Ve) {
      return Ve ? `${Ve} is outside of buffer bounds` : "Attempt to access memory outside buffer bounds";
    },
    RangeError
  ), Ge(
    "ERR_INVALID_ARG_TYPE",
    function(Ve, Pe) {
      return `The "${Ve}" argument must be of type number. Received type ${typeof Pe}`;
    },
    TypeError
  ), Ge(
    "ERR_OUT_OF_RANGE",
    function(Ve, Pe, $e) {
      let Ze = `The value of "${Ve}" is out of range.`, at = $e;
      return Number.isInteger($e) && Math.abs($e) > 2 ** 32 ? at = je(String($e)) : typeof $e == "bigint" && (at = String($e), ($e > BigInt(2) ** BigInt(32) || $e < -(BigInt(2) ** BigInt(32))) && (at = je(at)), at += "n"), Ze += ` It must be ${Pe}. Received ${at}`, Ze;
    },
    RangeError
  );
  function je(Ve) {
    let Pe = "", $e = Ve.length;
    const Ze = Ve[0] === "-" ? 1 : 0;
    for (; $e >= Ze + 4; $e -= 3)
      Pe = `_${Ve.slice($e - 3, $e)}${Pe}`;
    return `${Ve.slice(0, $e)}${Pe}`;
  }
  function Oe(Ve, Pe, $e) {
    Ye(Pe, "offset"), (Ve[Pe] === void 0 || Ve[Pe + $e] === void 0) && Je(Pe, Ve.length - ($e + 1));
  }
  function Ne(Ve, Pe, $e, Ze, at, wt) {
    if (Ve > $e || Ve < Pe) {
      const ft = typeof Pe == "bigint" ? "n" : "";
      let Ct;
      throw Pe === 0 || Pe === BigInt(0) ? Ct = `>= 0${ft} and < 2${ft} ** ${(wt + 1) * 8}${ft}` : Ct = `>= -(2${ft} ** ${(wt + 1) * 8 - 1}${ft}) and < 2 ** ${(wt + 1) * 8 - 1}${ft}`, new Ue.ERR_OUT_OF_RANGE("value", Ct, Ve);
    }
    Oe(Ze, at, wt);
  }
  function Ye(Ve, Pe) {
    if (typeof Ve != "number")
      throw new Ue.ERR_INVALID_ARG_TYPE(Pe, "number", Ve);
  }
  function Je(Ve, Pe, $e) {
    throw Math.floor(Ve) !== Ve ? (Ye(Ve, $e), new Ue.ERR_OUT_OF_RANGE("offset", "an integer", Ve)) : Pe < 0 ? new Ue.ERR_BUFFER_OUT_OF_BOUNDS() : new Ue.ERR_OUT_OF_RANGE(
      "offset",
      `>= 0 and <= ${Pe}`,
      Ve
    );
  }
  const Xe = /[^+/0-9A-Za-z-_]/g;
  function st(Ve) {
    if (Ve = Ve.split("=")[0], Ve = Ve.trim().replace(Xe, ""), Ve.length < 2) return "";
    for (; Ve.length % 4 !== 0; )
      Ve = Ve + "=";
    return Ve;
  }
  function ct(Ve, Pe) {
    Pe = Pe || 1 / 0;
    let $e;
    const Ze = Ve.length;
    let at = null;
    const wt = [];
    for (let ft = 0; ft < Ze; ++ft) {
      if ($e = Ve.charCodeAt(ft), $e > 55295 && $e < 57344) {
        if (!at) {
          if ($e > 56319) {
            (Pe -= 3) > -1 && wt.push(239, 191, 189);
            continue;
          } else if (ft + 1 === Ze) {
            (Pe -= 3) > -1 && wt.push(239, 191, 189);
            continue;
          }
          at = $e;
          continue;
        }
        if ($e < 56320) {
          (Pe -= 3) > -1 && wt.push(239, 191, 189), at = $e;
          continue;
        }
        $e = (at - 55296 << 10 | $e - 56320) + 65536;
      } else at && (Pe -= 3) > -1 && wt.push(239, 191, 189);
      if (at = null, $e < 128) {
        if ((Pe -= 1) < 0) break;
        wt.push($e);
      } else if ($e < 2048) {
        if ((Pe -= 2) < 0) break;
        wt.push(
          $e >> 6 | 192,
          $e & 63 | 128
        );
      } else if ($e < 65536) {
        if ((Pe -= 3) < 0) break;
        wt.push(
          $e >> 12 | 224,
          $e >> 6 & 63 | 128,
          $e & 63 | 128
        );
      } else if ($e < 1114112) {
        if ((Pe -= 4) < 0) break;
        wt.push(
          $e >> 18 | 240,
          $e >> 12 & 63 | 128,
          $e >> 6 & 63 | 128,
          $e & 63 | 128
        );
      } else
        throw new Error("Invalid code point");
    }
    return wt;
  }
  function it(Ve) {
    const Pe = [];
    for (let $e = 0; $e < Ve.length; ++$e)
      Pe.push(Ve.charCodeAt($e) & 255);
    return Pe;
  }
  function ot(Ve, Pe) {
    let $e, Ze, at;
    const wt = [];
    for (let ft = 0; ft < Ve.length && !((Pe -= 2) < 0); ++ft)
      $e = Ve.charCodeAt(ft), Ze = $e >> 8, at = $e % 256, wt.push(at), wt.push(Ze);
    return wt;
  }
  function yt(Ve) {
    return e.toByteArray(st(Ve));
  }
  function dt(Ve, Pe, $e, Ze) {
    let at;
    for (at = 0; at < Ze && !(at + $e >= Pe.length || at >= Ve.length); ++at)
      Pe[at + $e] = Ve[at];
    return at;
  }
  function mt(Ve, Pe) {
    return Ve instanceof Pe || Ve != null && Ve.constructor != null && Ve.constructor.name != null && Ve.constructor.name === Pe.name;
  }
  function It(Ve) {
    return Ve !== Ve;
  }
  const xt = function() {
    const Ve = "0123456789abcdef", Pe = new Array(256);
    for (let $e = 0; $e < 16; ++$e) {
      const Ze = $e * 16;
      for (let at = 0; at < 16; ++at)
        Pe[Ze + at] = Ve[$e] + Ve[at];
    }
    return Pe;
  }();
  function Tt(Ve) {
    return typeof BigInt > "u" ? Yt : Ve;
  }
  function Yt() {
    throw new Error("BigInt not supported");
  }
})(bufferPolyfill);
var browser$e = { exports: {} }, process = browser$e.exports = {}, cachedSetTimeout, cachedClearTimeout;
function defaultSetTimout() {
  throw new Error("setTimeout has not been defined");
}
function defaultClearTimeout() {
  throw new Error("clearTimeout has not been defined");
}
(function() {
  try {
    typeof setTimeout == "function" ? cachedSetTimeout = setTimeout : cachedSetTimeout = defaultSetTimout;
  } catch {
    cachedSetTimeout = defaultSetTimout;
  }
  try {
    typeof clearTimeout == "function" ? cachedClearTimeout = clearTimeout : cachedClearTimeout = defaultClearTimeout;
  } catch {
    cachedClearTimeout = defaultClearTimeout;
  }
})();
function runTimeout(C) {
  if (cachedSetTimeout === setTimeout)
    return setTimeout(C, 0);
  if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout)
    return cachedSetTimeout = setTimeout, setTimeout(C, 0);
  try {
    return cachedSetTimeout(C, 0);
  } catch {
    try {
      return cachedSetTimeout.call(null, C, 0);
    } catch {
      return cachedSetTimeout.call(this, C, 0);
    }
  }
}
function runClearTimeout(C) {
  if (cachedClearTimeout === clearTimeout)
    return clearTimeout(C);
  if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout)
    return cachedClearTimeout = clearTimeout, clearTimeout(C);
  try {
    return cachedClearTimeout(C);
  } catch {
    try {
      return cachedClearTimeout.call(null, C);
    } catch {
      return cachedClearTimeout.call(this, C);
    }
  }
}
var queue = [], draining = !1, currentQueue, queueIndex = -1;
function cleanUpNextTick() {
  !draining || !currentQueue || (draining = !1, currentQueue.length ? queue = currentQueue.concat(queue) : queueIndex = -1, queue.length && drainQueue());
}
function drainQueue() {
  if (!draining) {
    var C = runTimeout(cleanUpNextTick);
    draining = !0;
    for (var e = queue.length; e; ) {
      for (currentQueue = queue, queue = []; ++queueIndex < e; )
        currentQueue && currentQueue[queueIndex].run();
      queueIndex = -1, e = queue.length;
    }
    currentQueue = null, draining = !1, runClearTimeout(C);
  }
}
process.nextTick = function(C) {
  var e = new Array(arguments.length - 1);
  if (arguments.length > 1)
    for (var T = 1; T < arguments.length; T++)
      e[T - 1] = arguments[T];
  queue.push(new Item(C, e)), queue.length === 1 && !draining && runTimeout(drainQueue);
};
function Item(C, e) {
  this.fun = C, this.array = e;
}
Item.prototype.run = function() {
  this.fun.apply(null, this.array);
};
process.title = "browser";
process.browser = !0;
process.env = {};
process.argv = [];
process.version = "";
process.versions = {};
function noop$2() {
}
process.on = noop$2;
process.addListener = noop$2;
process.once = noop$2;
process.off = noop$2;
process.removeListener = noop$2;
process.removeAllListeners = noop$2;
process.emit = noop$2;
process.prependListener = noop$2;
process.prependOnceListener = noop$2;
process.listeners = function(C) {
  return [];
};
process.binding = function(C) {
  throw new Error("process.binding is not supported");
};
process.cwd = function() {
  return "/";
};
process.chdir = function(C) {
  throw new Error("process.chdir is not supported");
};
process.umask = function() {
  return 0;
};
var browserExports = browser$e.exports;
(function(C) {
  Object.defineProperty(C, Symbol.toStringTag, { value: "Module" });
  const e = bufferPolyfill, T = browserExports, $ = (ee) => ee && ee.__esModule ? ee : { default: ee }, V = $(T), J = globalThis || window || void 0 || self;
  Object.defineProperty(C, "Buffer", { enumerable: !0, get: () => e.Buffer }), Object.defineProperty(C, "process", { enumerable: !0, get: () => V.default }), C.global = J;
})(dist$2);
var jsxRuntime = { exports: {} }, reactJsxRuntime_production_min = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredReactJsxRuntime_production_min;
function requireReactJsxRuntime_production_min() {
  if (hasRequiredReactJsxRuntime_production_min) return reactJsxRuntime_production_min;
  hasRequiredReactJsxRuntime_production_min = 1;
  var C = React__default, e = Symbol.for("react.element"), T = Symbol.for("react.fragment"), $ = Object.prototype.hasOwnProperty, V = C.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, J = { key: !0, ref: !0, __self: !0, __source: !0 };
  function ee(te, re, ie) {
    var se, de = {}, ue = null, fe = null;
    ie !== void 0 && (ue = "" + ie), re.key !== void 0 && (ue = "" + re.key), re.ref !== void 0 && (fe = re.ref);
    for (se in re) $.call(re, se) && !J.hasOwnProperty(se) && (de[se] = re[se]);
    if (te && te.defaultProps) for (se in re = te.defaultProps, re) de[se] === void 0 && (de[se] = re[se]);
    return { $$typeof: e, type: te, key: ue, ref: fe, props: de, _owner: V.current };
  }
  return reactJsxRuntime_production_min.Fragment = T, reactJsxRuntime_production_min.jsx = ee, reactJsxRuntime_production_min.jsxs = ee, reactJsxRuntime_production_min;
}
var reactJsxRuntime_development = {}, hasRequiredReactJsxRuntime_development;
function requireReactJsxRuntime_development() {
  return hasRequiredReactJsxRuntime_development || (hasRequiredReactJsxRuntime_development = 1, dist$2.process.env.NODE_ENV !== "production" && function() {
    var C = React__default, e = Symbol.for("react.element"), T = Symbol.for("react.portal"), $ = Symbol.for("react.fragment"), V = Symbol.for("react.strict_mode"), J = Symbol.for("react.profiler"), ee = Symbol.for("react.provider"), te = Symbol.for("react.context"), re = Symbol.for("react.forward_ref"), ie = Symbol.for("react.suspense"), se = Symbol.for("react.suspense_list"), de = Symbol.for("react.memo"), ue = Symbol.for("react.lazy"), fe = Symbol.for("react.offscreen"), he = Symbol.iterator, me = "@@iterator";
    function xe(qe) {
      if (qe === null || typeof qe != "object")
        return null;
      var ht = he && qe[he] || qe[me];
      return typeof ht == "function" ? ht : null;
    }
    var ve = C.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function Te(qe) {
      {
        for (var ht = arguments.length, pt = new Array(ht > 1 ? ht - 1 : 0), bt = 1; bt < ht; bt++)
          pt[bt - 1] = arguments[bt];
        we("error", qe, pt);
      }
    }
    function we(qe, ht, pt) {
      {
        var bt = ve.ReactDebugCurrentFrame, jt = bt.getStackAddendum();
        jt !== "" && (ht += "%s", pt = pt.concat([jt]));
        var $t = pt.map(function(Jt) {
          return String(Jt);
        });
        $t.unshift("Warning: " + ht), Function.prototype.apply.call(console[qe], console, $t);
      }
    }
    var Ee = !1, Me = !1, Ie = !1, ke = !1, _e = !1, De;
    De = Symbol.for("react.module.reference");
    function Fe(qe) {
      return !!(typeof qe == "string" || typeof qe == "function" || qe === $ || qe === J || _e || qe === V || qe === ie || qe === se || ke || qe === fe || Ee || Me || Ie || typeof qe == "object" && qe !== null && (qe.$$typeof === ue || qe.$$typeof === de || qe.$$typeof === ee || qe.$$typeof === te || qe.$$typeof === re || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      qe.$$typeof === De || qe.getModuleId !== void 0));
    }
    function Ae(qe, ht, pt) {
      var bt = qe.displayName;
      if (bt)
        return bt;
      var jt = ht.displayName || ht.name || "";
      return jt !== "" ? pt + "(" + jt + ")" : pt;
    }
    function ne(qe) {
      return qe.displayName || "Context";
    }
    function oe(qe) {
      if (qe == null)
        return null;
      if (typeof qe.tag == "number" && Te("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof qe == "function")
        return qe.displayName || qe.name || null;
      if (typeof qe == "string")
        return qe;
      switch (qe) {
        case $:
          return "Fragment";
        case T:
          return "Portal";
        case J:
          return "Profiler";
        case V:
          return "StrictMode";
        case ie:
          return "Suspense";
        case se:
          return "SuspenseList";
      }
      if (typeof qe == "object")
        switch (qe.$$typeof) {
          case te:
            var ht = qe;
            return ne(ht) + ".Consumer";
          case ee:
            var pt = qe;
            return ne(pt._context) + ".Provider";
          case re:
            return Ae(qe, qe.render, "ForwardRef");
          case de:
            var bt = qe.displayName || null;
            return bt !== null ? bt : oe(qe.type) || "Memo";
          case ue: {
            var jt = qe, $t = jt._payload, Jt = jt._init;
            try {
              return oe(Jt($t));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var ce = Object.assign, le = 0, pe, ye, Ce, be, ae, ge, Se;
    function Le() {
    }
    Le.__reactDisabledLog = !0;
    function ze() {
      {
        if (le === 0) {
          pe = console.log, ye = console.info, Ce = console.warn, be = console.error, ae = console.group, ge = console.groupCollapsed, Se = console.groupEnd;
          var qe = {
            configurable: !0,
            enumerable: !0,
            value: Le,
            writable: !0
          };
          Object.defineProperties(console, {
            info: qe,
            log: qe,
            warn: qe,
            error: qe,
            group: qe,
            groupCollapsed: qe,
            groupEnd: qe
          });
        }
        le++;
      }
    }
    function Re() {
      {
        if (le--, le === 0) {
          var qe = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: ce({}, qe, {
              value: pe
            }),
            info: ce({}, qe, {
              value: ye
            }),
            warn: ce({}, qe, {
              value: Ce
            }),
            error: ce({}, qe, {
              value: be
            }),
            group: ce({}, qe, {
              value: ae
            }),
            groupCollapsed: ce({}, qe, {
              value: ge
            }),
            groupEnd: ce({}, qe, {
              value: Se
            })
          });
        }
        le < 0 && Te("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var We = ve.ReactCurrentDispatcher, Be;
    function Ue(qe, ht, pt) {
      {
        if (Be === void 0)
          try {
            throw Error();
          } catch (jt) {
            var bt = jt.stack.trim().match(/\n( *(at )?)/);
            Be = bt && bt[1] || "";
          }
        return `
` + Be + qe;
      }
    }
    var Ge = !1, je;
    {
      var Oe = typeof WeakMap == "function" ? WeakMap : Map;
      je = new Oe();
    }
    function Ne(qe, ht) {
      if (!qe || Ge)
        return "";
      {
        var pt = je.get(qe);
        if (pt !== void 0)
          return pt;
      }
      var bt;
      Ge = !0;
      var jt = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var $t;
      $t = We.current, We.current = null, ze();
      try {
        if (ht) {
          var Jt = function() {
            throw Error();
          };
          if (Object.defineProperty(Jt.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(Jt, []);
            } catch (yn) {
              bt = yn;
            }
            Reflect.construct(qe, [], Jt);
          } else {
            try {
              Jt.call();
            } catch (yn) {
              bt = yn;
            }
            qe.call(Jt.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (yn) {
            bt = yn;
          }
          qe();
        }
      } catch (yn) {
        if (yn && bt && typeof yn.stack == "string") {
          for (var zt = yn.stack.split(`
`), Vt = bt.stack.split(`
`), Kt = zt.length - 1, pn = Vt.length - 1; Kt >= 1 && pn >= 0 && zt[Kt] !== Vt[pn]; )
            pn--;
          for (; Kt >= 1 && pn >= 0; Kt--, pn--)
            if (zt[Kt] !== Vt[pn]) {
              if (Kt !== 1 || pn !== 1)
                do
                  if (Kt--, pn--, pn < 0 || zt[Kt] !== Vt[pn]) {
                    var An = `
` + zt[Kt].replace(" at new ", " at ");
                    return qe.displayName && An.includes("<anonymous>") && (An = An.replace("<anonymous>", qe.displayName)), typeof qe == "function" && je.set(qe, An), An;
                  }
                while (Kt >= 1 && pn >= 0);
              break;
            }
        }
      } finally {
        Ge = !1, We.current = $t, Re(), Error.prepareStackTrace = jt;
      }
      var vn = qe ? qe.displayName || qe.name : "", Cn = vn ? Ue(vn) : "";
      return typeof qe == "function" && je.set(qe, Cn), Cn;
    }
    function Ye(qe, ht, pt) {
      return Ne(qe, !1);
    }
    function Je(qe) {
      var ht = qe.prototype;
      return !!(ht && ht.isReactComponent);
    }
    function Xe(qe, ht, pt) {
      if (qe == null)
        return "";
      if (typeof qe == "function")
        return Ne(qe, Je(qe));
      if (typeof qe == "string")
        return Ue(qe);
      switch (qe) {
        case ie:
          return Ue("Suspense");
        case se:
          return Ue("SuspenseList");
      }
      if (typeof qe == "object")
        switch (qe.$$typeof) {
          case re:
            return Ye(qe.render);
          case de:
            return Xe(qe.type, ht, pt);
          case ue: {
            var bt = qe, jt = bt._payload, $t = bt._init;
            try {
              return Xe($t(jt), ht, pt);
            } catch {
            }
          }
        }
      return "";
    }
    var st = Object.prototype.hasOwnProperty, ct = {}, it = ve.ReactDebugCurrentFrame;
    function ot(qe) {
      if (qe) {
        var ht = qe._owner, pt = Xe(qe.type, qe._source, ht ? ht.type : null);
        it.setExtraStackFrame(pt);
      } else
        it.setExtraStackFrame(null);
    }
    function yt(qe, ht, pt, bt, jt) {
      {
        var $t = Function.call.bind(st);
        for (var Jt in qe)
          if ($t(qe, Jt)) {
            var zt = void 0;
            try {
              if (typeof qe[Jt] != "function") {
                var Vt = Error((bt || "React class") + ": " + pt + " type `" + Jt + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof qe[Jt] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw Vt.name = "Invariant Violation", Vt;
              }
              zt = qe[Jt](ht, Jt, bt, pt, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (Kt) {
              zt = Kt;
            }
            zt && !(zt instanceof Error) && (ot(jt), Te("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", bt || "React class", pt, Jt, typeof zt), ot(null)), zt instanceof Error && !(zt.message in ct) && (ct[zt.message] = !0, ot(jt), Te("Failed %s type: %s", pt, zt.message), ot(null));
          }
      }
    }
    var dt = Array.isArray;
    function mt(qe) {
      return dt(qe);
    }
    function It(qe) {
      {
        var ht = typeof Symbol == "function" && Symbol.toStringTag, pt = ht && qe[Symbol.toStringTag] || qe.constructor.name || "Object";
        return pt;
      }
    }
    function xt(qe) {
      try {
        return Tt(qe), !1;
      } catch {
        return !0;
      }
    }
    function Tt(qe) {
      return "" + qe;
    }
    function Yt(qe) {
      if (xt(qe))
        return Te("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", It(qe)), Tt(qe);
    }
    var Ve = ve.ReactCurrentOwner, Pe = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, $e, Ze, at;
    at = {};
    function wt(qe) {
      if (st.call(qe, "ref")) {
        var ht = Object.getOwnPropertyDescriptor(qe, "ref").get;
        if (ht && ht.isReactWarning)
          return !1;
      }
      return qe.ref !== void 0;
    }
    function ft(qe) {
      if (st.call(qe, "key")) {
        var ht = Object.getOwnPropertyDescriptor(qe, "key").get;
        if (ht && ht.isReactWarning)
          return !1;
      }
      return qe.key !== void 0;
    }
    function Ct(qe, ht) {
      if (typeof qe.ref == "string" && Ve.current && ht && Ve.current.stateNode !== ht) {
        var pt = oe(Ve.current.type);
        at[pt] || (Te('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', oe(Ve.current.type), qe.ref), at[pt] = !0);
      }
    }
    function Ut(qe, ht) {
      {
        var pt = function() {
          $e || ($e = !0, Te("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", ht));
        };
        pt.isReactWarning = !0, Object.defineProperty(qe, "key", {
          get: pt,
          configurable: !0
        });
      }
    }
    function vt(qe, ht) {
      {
        var pt = function() {
          Ze || (Ze = !0, Te("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", ht));
        };
        pt.isReactWarning = !0, Object.defineProperty(qe, "ref", {
          get: pt,
          configurable: !0
        });
      }
    }
    var Mt = function(qe, ht, pt, bt, jt, $t, Jt) {
      var zt = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: e,
        // Built-in properties that belong on the element
        type: qe,
        key: ht,
        ref: pt,
        props: Jt,
        // Record the component responsible for creating this element.
        _owner: $t
      };
      return zt._store = {}, Object.defineProperty(zt._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(zt, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: bt
      }), Object.defineProperty(zt, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: jt
      }), Object.freeze && (Object.freeze(zt.props), Object.freeze(zt)), zt;
    };
    function Xt(qe, ht, pt, bt, jt) {
      {
        var $t, Jt = {}, zt = null, Vt = null;
        pt !== void 0 && (Yt(pt), zt = "" + pt), ft(ht) && (Yt(ht.key), zt = "" + ht.key), wt(ht) && (Vt = ht.ref, Ct(ht, jt));
        for ($t in ht)
          st.call(ht, $t) && !Pe.hasOwnProperty($t) && (Jt[$t] = ht[$t]);
        if (qe && qe.defaultProps) {
          var Kt = qe.defaultProps;
          for ($t in Kt)
            Jt[$t] === void 0 && (Jt[$t] = Kt[$t]);
        }
        if (zt || Vt) {
          var pn = typeof qe == "function" ? qe.displayName || qe.name || "Unknown" : qe;
          zt && Ut(Jt, pn), Vt && vt(Jt, pn);
        }
        return Mt(qe, zt, Vt, jt, bt, Ve.current, Jt);
      }
    }
    var St = ve.ReactCurrentOwner, Ot = ve.ReactDebugCurrentFrame;
    function wn(qe) {
      if (qe) {
        var ht = qe._owner, pt = Xe(qe.type, qe._source, ht ? ht.type : null);
        Ot.setExtraStackFrame(pt);
      } else
        Ot.setExtraStackFrame(null);
    }
    var kt;
    kt = !1;
    function Bt(qe) {
      return typeof qe == "object" && qe !== null && qe.$$typeof === e;
    }
    function Tn() {
      {
        if (St.current) {
          var qe = oe(St.current.type);
          if (qe)
            return `

Check the render method of \`` + qe + "`.";
        }
        return "";
      }
    }
    function Nt(qe) {
      return "";
    }
    var Wt = {};
    function En(qe) {
      {
        var ht = Tn();
        if (!ht) {
          var pt = typeof qe == "string" ? qe : qe.displayName || qe.name;
          pt && (ht = `

Check the top-level render call using <` + pt + ">.");
        }
        return ht;
      }
    }
    function Lt(qe, ht) {
      {
        if (!qe._store || qe._store.validated || qe.key != null)
          return;
        qe._store.validated = !0;
        var pt = En(ht);
        if (Wt[pt])
          return;
        Wt[pt] = !0;
        var bt = "";
        qe && qe._owner && qe._owner !== St.current && (bt = " It was passed a child from " + oe(qe._owner.type) + "."), wn(qe), Te('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', pt, bt), wn(null);
      }
    }
    function Ht(qe, ht) {
      {
        if (typeof qe != "object")
          return;
        if (mt(qe))
          for (var pt = 0; pt < qe.length; pt++) {
            var bt = qe[pt];
            Bt(bt) && Lt(bt, ht);
          }
        else if (Bt(qe))
          qe._store && (qe._store.validated = !0);
        else if (qe) {
          var jt = xe(qe);
          if (typeof jt == "function" && jt !== qe.entries)
            for (var $t = jt.call(qe), Jt; !(Jt = $t.next()).done; )
              Bt(Jt.value) && Lt(Jt.value, ht);
        }
      }
    }
    function In(qe) {
      {
        var ht = qe.type;
        if (ht == null || typeof ht == "string")
          return;
        var pt;
        if (typeof ht == "function")
          pt = ht.propTypes;
        else if (typeof ht == "object" && (ht.$$typeof === re || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        ht.$$typeof === de))
          pt = ht.propTypes;
        else
          return;
        if (pt) {
          var bt = oe(ht);
          yt(pt, qe.props, "prop", bt, qe);
        } else if (ht.PropTypes !== void 0 && !kt) {
          kt = !0;
          var jt = oe(ht);
          Te("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", jt || "Unknown");
        }
        typeof ht.getDefaultProps == "function" && !ht.getDefaultProps.isReactClassApproved && Te("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Dt(qe) {
      {
        for (var ht = Object.keys(qe.props), pt = 0; pt < ht.length; pt++) {
          var bt = ht[pt];
          if (bt !== "children" && bt !== "key") {
            wn(qe), Te("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", bt), wn(null);
            break;
          }
        }
        qe.ref !== null && (wn(qe), Te("Invalid attribute `ref` supplied to `React.Fragment`."), wn(null));
      }
    }
    var Gt = {};
    function Ke(qe, ht, pt, bt, jt, $t) {
      {
        var Jt = Fe(qe);
        if (!Jt) {
          var zt = "";
          (qe === void 0 || typeof qe == "object" && qe !== null && Object.keys(qe).length === 0) && (zt += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var Vt = Nt();
          Vt ? zt += Vt : zt += Tn();
          var Kt;
          qe === null ? Kt = "null" : mt(qe) ? Kt = "array" : qe !== void 0 && qe.$$typeof === e ? (Kt = "<" + (oe(qe.type) || "Unknown") + " />", zt = " Did you accidentally export a JSX literal instead of a component?") : Kt = typeof qe, Te("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", Kt, zt);
        }
        var pn = Xt(qe, ht, pt, jt, $t);
        if (pn == null)
          return pn;
        if (Jt) {
          var An = ht.children;
          if (An !== void 0)
            if (bt)
              if (mt(An)) {
                for (var vn = 0; vn < An.length; vn++)
                  Ht(An[vn], qe);
                Object.freeze && Object.freeze(An);
              } else
                Te("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Ht(An, qe);
        }
        if (st.call(ht, "key")) {
          var Cn = oe(qe), yn = Object.keys(ht).filter(function(ln) {
            return ln !== "key";
          }), dn = yn.length > 0 ? "{key: someKey, " + yn.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!Gt[Cn + dn]) {
            var xn = yn.length > 0 ? "{" + yn.join(": ..., ") + ": ...}" : "{}";
            Te(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, dn, Cn, xn, Cn), Gt[Cn + dn] = !0;
          }
        }
        return qe === $ ? Dt(pn) : In(pn), pn;
      }
    }
    function Qe(qe, ht, pt) {
      return Ke(qe, ht, pt, !0);
    }
    function et(qe, ht, pt) {
      return Ke(qe, ht, pt, !1);
    }
    var He = et, nt = Qe;
    reactJsxRuntime_development.Fragment = $, reactJsxRuntime_development.jsx = He, reactJsxRuntime_development.jsxs = nt;
  }()), reactJsxRuntime_development;
}
dist$2.process.env.NODE_ENV === "production" ? jsxRuntime.exports = requireReactJsxRuntime_production_min() : jsxRuntime.exports = requireReactJsxRuntime_development();
var jsxRuntimeExports = jsxRuntime.exports, createStyled$3 = {}, interopRequireDefault = { exports: {} };
(function(C) {
  function e(T) {
    return T && T.__esModule ? T : {
      default: T
    };
  }
  C.exports = e, C.exports.__esModule = !0, C.exports.default = C.exports;
})(interopRequireDefault);
var interopRequireDefaultExports = interopRequireDefault.exports, _extends$1 = { exports: {} }, hasRequired_extends;
function require_extends() {
  return hasRequired_extends || (hasRequired_extends = 1, function(C) {
    function e() {
      return C.exports = e = Object.assign ? Object.assign.bind() : function(T) {
        for (var $ = 1; $ < arguments.length; $++) {
          var V = arguments[$];
          for (var J in V) ({}).hasOwnProperty.call(V, J) && (T[J] = V[J]);
        }
        return T;
      }, C.exports.__esModule = !0, C.exports.default = C.exports, e.apply(null, arguments);
    }
    C.exports = e, C.exports.__esModule = !0, C.exports.default = C.exports;
  }(_extends$1)), _extends$1.exports;
}
var objectWithoutPropertiesLoose = { exports: {} }, hasRequiredObjectWithoutPropertiesLoose;
function requireObjectWithoutPropertiesLoose() {
  return hasRequiredObjectWithoutPropertiesLoose || (hasRequiredObjectWithoutPropertiesLoose = 1, function(C) {
    function e(T, $) {
      if (T == null) return {};
      var V = {};
      for (var J in T) if ({}.hasOwnProperty.call(T, J)) {
        if ($.includes(J)) continue;
        V[J] = T[J];
      }
      return V;
    }
    C.exports = e, C.exports.__esModule = !0, C.exports.default = C.exports;
  }(objectWithoutPropertiesLoose)), objectWithoutPropertiesLoose.exports;
}
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function(C) {
    for (var e = 1; e < arguments.length; e++) {
      var T = arguments[e];
      for (var $ in T) ({}).hasOwnProperty.call(T, $) && (C[$] = T[$]);
    }
    return C;
  }, _extends.apply(null, arguments);
}
var isDevelopment$3 = !1;
function sheetForTag(C) {
  if (C.sheet)
    return C.sheet;
  for (var e = 0; e < document.styleSheets.length; e++)
    if (document.styleSheets[e].ownerNode === C)
      return document.styleSheets[e];
}
function createStyleElement(C) {
  var e = document.createElement("style");
  return e.setAttribute("data-emotion", C.key), C.nonce !== void 0 && e.setAttribute("nonce", C.nonce), e.appendChild(document.createTextNode("")), e.setAttribute("data-s", ""), e;
}
var StyleSheet = /* @__PURE__ */ function() {
  function C(T) {
    var $ = this;
    this._insertTag = function(V) {
      var J;
      $.tags.length === 0 ? $.insertionPoint ? J = $.insertionPoint.nextSibling : $.prepend ? J = $.container.firstChild : J = $.before : J = $.tags[$.tags.length - 1].nextSibling, $.container.insertBefore(V, J), $.tags.push(V);
    }, this.isSpeedy = T.speedy === void 0 ? !isDevelopment$3 : T.speedy, this.tags = [], this.ctr = 0, this.nonce = T.nonce, this.key = T.key, this.container = T.container, this.prepend = T.prepend, this.insertionPoint = T.insertionPoint, this.before = null;
  }
  var e = C.prototype;
  return e.hydrate = function($) {
    $.forEach(this._insertTag);
  }, e.insert = function($) {
    this.ctr % (this.isSpeedy ? 65e3 : 1) === 0 && this._insertTag(createStyleElement(this));
    var V = this.tags[this.tags.length - 1];
    if (this.isSpeedy) {
      var J = sheetForTag(V);
      try {
        J.insertRule($, J.cssRules.length);
      } catch {
      }
    } else
      V.appendChild(document.createTextNode($));
    this.ctr++;
  }, e.flush = function() {
    this.tags.forEach(function($) {
      var V;
      return (V = $.parentNode) == null ? void 0 : V.removeChild($);
    }), this.tags = [], this.ctr = 0;
  }, C;
}(), MS = "-ms-", MOZ = "-moz-", WEBKIT = "-webkit-", COMMENT$1 = "comm", RULESET = "rule", DECLARATION = "decl", IMPORT = "@import", KEYFRAMES = "@keyframes", LAYER = "@layer", abs = Math.abs, from = String.fromCharCode, assign$2 = Object.assign;
function hash$6(C, e) {
  return charat(C, 0) ^ 45 ? (((e << 2 ^ charat(C, 0)) << 2 ^ charat(C, 1)) << 2 ^ charat(C, 2)) << 2 ^ charat(C, 3) : 0;
}
function trim$1(C) {
  return C.trim();
}
function match(C, e) {
  return (C = e.exec(C)) ? C[0] : C;
}
function replace$1(C, e, T) {
  return C.replace(e, T);
}
function indexof(C, e) {
  return C.indexOf(e);
}
function charat(C, e) {
  return C.charCodeAt(e) | 0;
}
function substr(C, e, T) {
  return C.slice(e, T);
}
function strlen(C) {
  return C.length;
}
function sizeof(C) {
  return C.length;
}
function append(C, e) {
  return e.push(C), C;
}
function combine(C, e) {
  return C.map(e).join("");
}
var line = 1, column$1 = 1, length = 0, position = 0, character = 0, characters = "";
function node$1(C, e, T, $, V, J, ee) {
  return { value: C, root: e, parent: T, type: $, props: V, children: J, line, column: column$1, length: ee, return: "" };
}
function copy$3(C, e) {
  return assign$2(node$1("", null, null, "", null, null, 0), C, { length: -C.length }, e);
}
function char() {
  return character;
}
function prev() {
  return character = position > 0 ? charat(characters, --position) : 0, column$1--, character === 10 && (column$1 = 1, line--), character;
}
function next() {
  return character = position < length ? charat(characters, position++) : 0, column$1++, character === 10 && (column$1 = 1, line++), character;
}
function peek() {
  return charat(characters, position);
}
function caret() {
  return position;
}
function slice(C, e) {
  return substr(characters, C, e);
}
function token$1(C) {
  switch (C) {
    case 0:
    case 9:
    case 10:
    case 13:
    case 32:
      return 5;
    case 33:
    case 43:
    case 44:
    case 47:
    case 62:
    case 64:
    case 126:
    case 59:
    case 123:
    case 125:
      return 4;
    case 58:
      return 3;
    case 34:
    case 39:
    case 40:
    case 91:
      return 2;
    case 41:
    case 93:
      return 1;
  }
  return 0;
}
function alloc(C) {
  return line = column$1 = 1, length = strlen(characters = C), position = 0, [];
}
function dealloc(C) {
  return characters = "", C;
}
function delimit(C) {
  return trim$1(slice(position - 1, delimiter(C === 91 ? C + 2 : C === 40 ? C + 1 : C)));
}
function whitespace(C) {
  for (; (character = peek()) && character < 33; )
    next();
  return token$1(C) > 2 || token$1(character) > 3 ? "" : " ";
}
function escaping(C, e) {
  for (; --e && next() && !(character < 48 || character > 102 || character > 57 && character < 65 || character > 70 && character < 97); )
    ;
  return slice(C, caret() + (e < 6 && peek() == 32 && next() == 32));
}
function delimiter(C) {
  for (; next(); )
    switch (character) {
      case C:
        return position;
      case 34:
      case 39:
        C !== 34 && C !== 39 && delimiter(character);
        break;
      case 40:
        C === 41 && delimiter(C);
        break;
      case 92:
        next();
        break;
    }
  return position;
}
function commenter(C, e) {
  for (; next() && C + character !== 57; )
    if (C + character === 84 && peek() === 47)
      break;
  return "/*" + slice(e, position - 1) + "*" + from(C === 47 ? C : next());
}
function identifier(C) {
  for (; !token$1(peek()); )
    next();
  return slice(C, position);
}
function compile(C) {
  return dealloc(parse$4("", null, null, null, [""], C = alloc(C), 0, [0], C));
}
function parse$4(C, e, T, $, V, J, ee, te, re) {
  for (var ie = 0, se = 0, de = ee, ue = 0, fe = 0, he = 0, me = 1, xe = 1, ve = 1, Te = 0, we = "", Ee = V, Me = J, Ie = $, ke = we; xe; )
    switch (he = Te, Te = next()) {
      case 40:
        if (he != 108 && charat(ke, de - 1) == 58) {
          indexof(ke += replace$1(delimit(Te), "&", "&\f"), "&\f") != -1 && (ve = -1);
          break;
        }
      case 34:
      case 39:
      case 91:
        ke += delimit(Te);
        break;
      case 9:
      case 10:
      case 13:
      case 32:
        ke += whitespace(he);
        break;
      case 92:
        ke += escaping(caret() - 1, 7);
        continue;
      case 47:
        switch (peek()) {
          case 42:
          case 47:
            append(comment(commenter(next(), caret()), e, T), re);
            break;
          default:
            ke += "/";
        }
        break;
      case 123 * me:
        te[ie++] = strlen(ke) * ve;
      case 125 * me:
      case 59:
      case 0:
        switch (Te) {
          case 0:
          case 125:
            xe = 0;
          case 59 + se:
            ve == -1 && (ke = replace$1(ke, /\f/g, "")), fe > 0 && strlen(ke) - de && append(fe > 32 ? declaration(ke + ";", $, T, de - 1) : declaration(replace$1(ke, " ", "") + ";", $, T, de - 2), re);
            break;
          case 59:
            ke += ";";
          default:
            if (append(Ie = ruleset(ke, e, T, ie, se, V, te, we, Ee = [], Me = [], de), J), Te === 123)
              if (se === 0)
                parse$4(ke, e, Ie, Ie, Ee, J, de, te, Me);
              else
                switch (ue === 99 && charat(ke, 3) === 110 ? 100 : ue) {
                  case 100:
                  case 108:
                  case 109:
                  case 115:
                    parse$4(C, Ie, Ie, $ && append(ruleset(C, Ie, Ie, 0, 0, V, te, we, V, Ee = [], de), Me), V, Me, de, te, $ ? Ee : Me);
                    break;
                  default:
                    parse$4(ke, Ie, Ie, Ie, [""], Me, 0, te, Me);
                }
        }
        ie = se = fe = 0, me = ve = 1, we = ke = "", de = ee;
        break;
      case 58:
        de = 1 + strlen(ke), fe = he;
      default:
        if (me < 1) {
          if (Te == 123)
            --me;
          else if (Te == 125 && me++ == 0 && prev() == 125)
            continue;
        }
        switch (ke += from(Te), Te * me) {
          case 38:
            ve = se > 0 ? 1 : (ke += "\f", -1);
            break;
          case 44:
            te[ie++] = (strlen(ke) - 1) * ve, ve = 1;
            break;
          case 64:
            peek() === 45 && (ke += delimit(next())), ue = peek(), se = de = strlen(we = ke += identifier(caret())), Te++;
            break;
          case 45:
            he === 45 && strlen(ke) == 2 && (me = 0);
        }
    }
  return J;
}
function ruleset(C, e, T, $, V, J, ee, te, re, ie, se) {
  for (var de = V - 1, ue = V === 0 ? J : [""], fe = sizeof(ue), he = 0, me = 0, xe = 0; he < $; ++he)
    for (var ve = 0, Te = substr(C, de + 1, de = abs(me = ee[he])), we = C; ve < fe; ++ve)
      (we = trim$1(me > 0 ? ue[ve] + " " + Te : replace$1(Te, /&\f/g, ue[ve]))) && (re[xe++] = we);
  return node$1(C, e, T, V === 0 ? RULESET : te, re, ie, se);
}
function comment(C, e, T) {
  return node$1(C, e, T, COMMENT$1, from(char()), substr(C, 2, -2), 0);
}
function declaration(C, e, T, $) {
  return node$1(C, e, T, DECLARATION, substr(C, 0, $), substr(C, $ + 1, -1), $);
}
function serialize$3(C, e) {
  for (var T = "", $ = sizeof(C), V = 0; V < $; V++)
    T += e(C[V], V, C, e) || "";
  return T;
}
function stringify$4(C, e, T, $) {
  switch (C.type) {
    case LAYER:
      if (C.children.length) break;
    case IMPORT:
    case DECLARATION:
      return C.return = C.return || C.value;
    case COMMENT$1:
      return "";
    case KEYFRAMES:
      return C.return = C.value + "{" + serialize$3(C.children, $) + "}";
    case RULESET:
      C.value = C.props.join(",");
  }
  return strlen(T = serialize$3(C.children, $)) ? C.return = C.value + "{" + T + "}" : "";
}
function middleware(C) {
  var e = sizeof(C);
  return function(T, $, V, J) {
    for (var ee = "", te = 0; te < e; te++)
      ee += C[te](T, $, V, J) || "";
    return ee;
  };
}
function rulesheet(C) {
  return function(e) {
    e.root || (e = e.return) && C(e);
  };
}
function memoize$1(C) {
  var e = /* @__PURE__ */ Object.create(null);
  return function(T) {
    return e[T] === void 0 && (e[T] = C(T)), e[T];
  };
}
var identifierWithPointTracking = function(e, T, $) {
  for (var V = 0, J = 0; V = J, J = peek(), V === 38 && J === 12 && (T[$] = 1), !token$1(J); )
    next();
  return slice(e, position);
}, toRules = function(e, T) {
  var $ = -1, V = 44;
  do
    switch (token$1(V)) {
      case 0:
        V === 38 && peek() === 12 && (T[$] = 1), e[$] += identifierWithPointTracking(position - 1, T, $);
        break;
      case 2:
        e[$] += delimit(V);
        break;
      case 4:
        if (V === 44) {
          e[++$] = peek() === 58 ? "&\f" : "", T[$] = e[$].length;
          break;
        }
      default:
        e[$] += from(V);
    }
  while (V = next());
  return e;
}, getRules = function(e, T) {
  return dealloc(toRules(alloc(e), T));
}, fixedElements = /* @__PURE__ */ new WeakMap(), compat = function(e) {
  if (!(e.type !== "rule" || !e.parent || // positive .length indicates that this rule contains pseudo
  // negative .length indicates that this rule has been already prefixed
  e.length < 1)) {
    for (var T = e.value, $ = e.parent, V = e.column === $.column && e.line === $.line; $.type !== "rule"; )
      if ($ = $.parent, !$) return;
    if (!(e.props.length === 1 && T.charCodeAt(0) !== 58 && !fixedElements.get($)) && !V) {
      fixedElements.set(e, !0);
      for (var J = [], ee = getRules(T, J), te = $.props, re = 0, ie = 0; re < ee.length; re++)
        for (var se = 0; se < te.length; se++, ie++)
          e.props[ie] = J[re] ? ee[re].replace(/&\f/g, te[se]) : te[se] + " " + ee[re];
    }
  }
}, removeLabel = function(e) {
  if (e.type === "decl") {
    var T = e.value;
    // charcode for l
    T.charCodeAt(0) === 108 && // charcode for b
    T.charCodeAt(2) === 98 && (e.return = "", e.value = "");
  }
};
function prefix$1(C, e) {
  switch (hash$6(C, e)) {
    case 5103:
      return WEBKIT + "print-" + C + C;
    case 5737:
    case 4201:
    case 3177:
    case 3433:
    case 1641:
    case 4457:
    case 2921:
    case 5572:
    case 6356:
    case 5844:
    case 3191:
    case 6645:
    case 3005:
    case 6391:
    case 5879:
    case 5623:
    case 6135:
    case 4599:
    case 4855:
    case 4215:
    case 6389:
    case 5109:
    case 5365:
    case 5621:
    case 3829:
      return WEBKIT + C + C;
    case 5349:
    case 4246:
    case 4810:
    case 6968:
    case 2756:
      return WEBKIT + C + MOZ + C + MS + C + C;
    case 6828:
    case 4268:
      return WEBKIT + C + MS + C + C;
    case 6165:
      return WEBKIT + C + MS + "flex-" + C + C;
    case 5187:
      return WEBKIT + C + replace$1(C, /(\w+).+(:[^]+)/, WEBKIT + "box-$1$2" + MS + "flex-$1$2") + C;
    case 5443:
      return WEBKIT + C + MS + "flex-item-" + replace$1(C, /flex-|-self/, "") + C;
    case 4675:
      return WEBKIT + C + MS + "flex-line-pack" + replace$1(C, /align-content|flex-|-self/, "") + C;
    case 5548:
      return WEBKIT + C + MS + replace$1(C, "shrink", "negative") + C;
    case 5292:
      return WEBKIT + C + MS + replace$1(C, "basis", "preferred-size") + C;
    case 6060:
      return WEBKIT + "box-" + replace$1(C, "-grow", "") + WEBKIT + C + MS + replace$1(C, "grow", "positive") + C;
    case 4554:
      return WEBKIT + replace$1(C, /([^-])(transform)/g, "$1" + WEBKIT + "$2") + C;
    case 6187:
      return replace$1(replace$1(replace$1(C, /(zoom-|grab)/, WEBKIT + "$1"), /(image-set)/, WEBKIT + "$1"), C, "") + C;
    case 5495:
    case 3959:
      return replace$1(C, /(image-set\([^]*)/, WEBKIT + "$1$`$1");
    case 4968:
      return replace$1(replace$1(C, /(.+:)(flex-)?(.*)/, WEBKIT + "box-pack:$3" + MS + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + WEBKIT + C + C;
    case 4095:
    case 3583:
    case 4068:
    case 2532:
      return replace$1(C, /(.+)-inline(.+)/, WEBKIT + "$1$2") + C;
    case 8116:
    case 7059:
    case 5753:
    case 5535:
    case 5445:
    case 5701:
    case 4933:
    case 4677:
    case 5533:
    case 5789:
    case 5021:
    case 4765:
      if (strlen(C) - 1 - e > 6) switch (charat(C, e + 1)) {
        case 109:
          if (charat(C, e + 4) !== 45) break;
        case 102:
          return replace$1(C, /(.+:)(.+)-([^]+)/, "$1" + WEBKIT + "$2-$3$1" + MOZ + (charat(C, e + 3) == 108 ? "$3" : "$2-$3")) + C;
        case 115:
          return ~indexof(C, "stretch") ? prefix$1(replace$1(C, "stretch", "fill-available"), e) + C : C;
      }
      break;
    case 4949:
      if (charat(C, e + 1) !== 115) break;
    case 6444:
      switch (charat(C, strlen(C) - 3 - (~indexof(C, "!important") && 10))) {
        case 107:
          return replace$1(C, ":", ":" + WEBKIT) + C;
        case 101:
          return replace$1(C, /(.+:)([^;!]+)(;|!.+)?/, "$1" + WEBKIT + (charat(C, 14) === 45 ? "inline-" : "") + "box$3$1" + WEBKIT + "$2$3$1" + MS + "$2box$3") + C;
      }
      break;
    case 5936:
      switch (charat(C, e + 11)) {
        case 114:
          return WEBKIT + C + MS + replace$1(C, /[svh]\w+-[tblr]{2}/, "tb") + C;
        case 108:
          return WEBKIT + C + MS + replace$1(C, /[svh]\w+-[tblr]{2}/, "tb-rl") + C;
        case 45:
          return WEBKIT + C + MS + replace$1(C, /[svh]\w+-[tblr]{2}/, "lr") + C;
      }
      return WEBKIT + C + MS + C + C;
  }
  return C;
}
var prefixer = function(e, T, $, V) {
  if (e.length > -1 && !e.return) switch (e.type) {
    case DECLARATION:
      e.return = prefix$1(e.value, e.length);
      break;
    case KEYFRAMES:
      return serialize$3([copy$3(e, {
        value: replace$1(e.value, "@", "@" + WEBKIT)
      })], V);
    case RULESET:
      if (e.length) return combine(e.props, function(J) {
        switch (match(J, /(::plac\w+|:read-\w+)/)) {
          case ":read-only":
          case ":read-write":
            return serialize$3([copy$3(e, {
              props: [replace$1(J, /:(read-\w+)/, ":" + MOZ + "$1")]
            })], V);
          case "::placeholder":
            return serialize$3([copy$3(e, {
              props: [replace$1(J, /:(plac\w+)/, ":" + WEBKIT + "input-$1")]
            }), copy$3(e, {
              props: [replace$1(J, /:(plac\w+)/, ":" + MOZ + "$1")]
            }), copy$3(e, {
              props: [replace$1(J, /:(plac\w+)/, MS + "input-$1")]
            })], V);
        }
        return "";
      });
  }
}, defaultStylisPlugins = [prefixer], createCache = function(e) {
  var T = e.key;
  if (T === "css") {
    var $ = document.querySelectorAll("style[data-emotion]:not([data-s])");
    Array.prototype.forEach.call($, function(me) {
      var xe = me.getAttribute("data-emotion");
      xe.indexOf(" ") !== -1 && (document.head.appendChild(me), me.setAttribute("data-s", ""));
    });
  }
  var V = e.stylisPlugins || defaultStylisPlugins, J = {}, ee, te = [];
  ee = e.container || document.head, Array.prototype.forEach.call(
    // this means we will ignore elements which don't have a space in them which
    // means that the style elements we're looking at are only Emotion 11 server-rendered style elements
    document.querySelectorAll('style[data-emotion^="' + T + ' "]'),
    function(me) {
      for (var xe = me.getAttribute("data-emotion").split(" "), ve = 1; ve < xe.length; ve++)
        J[xe[ve]] = !0;
      te.push(me);
    }
  );
  var re, ie = [compat, removeLabel];
  {
    var se, de = [stringify$4, rulesheet(function(me) {
      se.insert(me);
    })], ue = middleware(ie.concat(V, de)), fe = function(xe) {
      return serialize$3(compile(xe), ue);
    };
    re = function(xe, ve, Te, we) {
      se = Te, fe(xe ? xe + "{" + ve.styles + "}" : ve.styles), we && (he.inserted[ve.name] = !0);
    };
  }
  var he = {
    key: T,
    sheet: new StyleSheet({
      key: T,
      container: ee,
      nonce: e.nonce,
      speedy: e.speedy,
      prepend: e.prepend,
      insertionPoint: e.insertionPoint
    }),
    nonce: e.nonce,
    inserted: J,
    registered: {},
    insert: re
  };
  return he.sheet.hydrate(te), he;
}, reactIs$3 = { exports: {} }, reactIs_production_min$2 = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredReactIs_production_min$2;
function requireReactIs_production_min$2() {
  if (hasRequiredReactIs_production_min$2) return reactIs_production_min$2;
  hasRequiredReactIs_production_min$2 = 1;
  var C = typeof Symbol == "function" && Symbol.for, e = C ? Symbol.for("react.element") : 60103, T = C ? Symbol.for("react.portal") : 60106, $ = C ? Symbol.for("react.fragment") : 60107, V = C ? Symbol.for("react.strict_mode") : 60108, J = C ? Symbol.for("react.profiler") : 60114, ee = C ? Symbol.for("react.provider") : 60109, te = C ? Symbol.for("react.context") : 60110, re = C ? Symbol.for("react.async_mode") : 60111, ie = C ? Symbol.for("react.concurrent_mode") : 60111, se = C ? Symbol.for("react.forward_ref") : 60112, de = C ? Symbol.for("react.suspense") : 60113, ue = C ? Symbol.for("react.suspense_list") : 60120, fe = C ? Symbol.for("react.memo") : 60115, he = C ? Symbol.for("react.lazy") : 60116, me = C ? Symbol.for("react.block") : 60121, xe = C ? Symbol.for("react.fundamental") : 60117, ve = C ? Symbol.for("react.responder") : 60118, Te = C ? Symbol.for("react.scope") : 60119;
  function we(Me) {
    if (typeof Me == "object" && Me !== null) {
      var Ie = Me.$$typeof;
      switch (Ie) {
        case e:
          switch (Me = Me.type, Me) {
            case re:
            case ie:
            case $:
            case J:
            case V:
            case de:
              return Me;
            default:
              switch (Me = Me && Me.$$typeof, Me) {
                case te:
                case se:
                case he:
                case fe:
                case ee:
                  return Me;
                default:
                  return Ie;
              }
          }
        case T:
          return Ie;
      }
    }
  }
  function Ee(Me) {
    return we(Me) === ie;
  }
  return reactIs_production_min$2.AsyncMode = re, reactIs_production_min$2.ConcurrentMode = ie, reactIs_production_min$2.ContextConsumer = te, reactIs_production_min$2.ContextProvider = ee, reactIs_production_min$2.Element = e, reactIs_production_min$2.ForwardRef = se, reactIs_production_min$2.Fragment = $, reactIs_production_min$2.Lazy = he, reactIs_production_min$2.Memo = fe, reactIs_production_min$2.Portal = T, reactIs_production_min$2.Profiler = J, reactIs_production_min$2.StrictMode = V, reactIs_production_min$2.Suspense = de, reactIs_production_min$2.isAsyncMode = function(Me) {
    return Ee(Me) || we(Me) === re;
  }, reactIs_production_min$2.isConcurrentMode = Ee, reactIs_production_min$2.isContextConsumer = function(Me) {
    return we(Me) === te;
  }, reactIs_production_min$2.isContextProvider = function(Me) {
    return we(Me) === ee;
  }, reactIs_production_min$2.isElement = function(Me) {
    return typeof Me == "object" && Me !== null && Me.$$typeof === e;
  }, reactIs_production_min$2.isForwardRef = function(Me) {
    return we(Me) === se;
  }, reactIs_production_min$2.isFragment = function(Me) {
    return we(Me) === $;
  }, reactIs_production_min$2.isLazy = function(Me) {
    return we(Me) === he;
  }, reactIs_production_min$2.isMemo = function(Me) {
    return we(Me) === fe;
  }, reactIs_production_min$2.isPortal = function(Me) {
    return we(Me) === T;
  }, reactIs_production_min$2.isProfiler = function(Me) {
    return we(Me) === J;
  }, reactIs_production_min$2.isStrictMode = function(Me) {
    return we(Me) === V;
  }, reactIs_production_min$2.isSuspense = function(Me) {
    return we(Me) === de;
  }, reactIs_production_min$2.isValidElementType = function(Me) {
    return typeof Me == "string" || typeof Me == "function" || Me === $ || Me === ie || Me === J || Me === V || Me === de || Me === ue || typeof Me == "object" && Me !== null && (Me.$$typeof === he || Me.$$typeof === fe || Me.$$typeof === ee || Me.$$typeof === te || Me.$$typeof === se || Me.$$typeof === xe || Me.$$typeof === ve || Me.$$typeof === Te || Me.$$typeof === me);
  }, reactIs_production_min$2.typeOf = we, reactIs_production_min$2;
}
var reactIs_development$3 = {}, hasRequiredReactIs_development$3;
function requireReactIs_development$3() {
  return hasRequiredReactIs_development$3 || (hasRequiredReactIs_development$3 = 1, dist$2.process.env.NODE_ENV !== "production" && function() {
    var C = typeof Symbol == "function" && Symbol.for, e = C ? Symbol.for("react.element") : 60103, T = C ? Symbol.for("react.portal") : 60106, $ = C ? Symbol.for("react.fragment") : 60107, V = C ? Symbol.for("react.strict_mode") : 60108, J = C ? Symbol.for("react.profiler") : 60114, ee = C ? Symbol.for("react.provider") : 60109, te = C ? Symbol.for("react.context") : 60110, re = C ? Symbol.for("react.async_mode") : 60111, ie = C ? Symbol.for("react.concurrent_mode") : 60111, se = C ? Symbol.for("react.forward_ref") : 60112, de = C ? Symbol.for("react.suspense") : 60113, ue = C ? Symbol.for("react.suspense_list") : 60120, fe = C ? Symbol.for("react.memo") : 60115, he = C ? Symbol.for("react.lazy") : 60116, me = C ? Symbol.for("react.block") : 60121, xe = C ? Symbol.for("react.fundamental") : 60117, ve = C ? Symbol.for("react.responder") : 60118, Te = C ? Symbol.for("react.scope") : 60119;
    function we(Ne) {
      return typeof Ne == "string" || typeof Ne == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      Ne === $ || Ne === ie || Ne === J || Ne === V || Ne === de || Ne === ue || typeof Ne == "object" && Ne !== null && (Ne.$$typeof === he || Ne.$$typeof === fe || Ne.$$typeof === ee || Ne.$$typeof === te || Ne.$$typeof === se || Ne.$$typeof === xe || Ne.$$typeof === ve || Ne.$$typeof === Te || Ne.$$typeof === me);
    }
    function Ee(Ne) {
      if (typeof Ne == "object" && Ne !== null) {
        var Ye = Ne.$$typeof;
        switch (Ye) {
          case e:
            var Je = Ne.type;
            switch (Je) {
              case re:
              case ie:
              case $:
              case J:
              case V:
              case de:
                return Je;
              default:
                var Xe = Je && Je.$$typeof;
                switch (Xe) {
                  case te:
                  case se:
                  case he:
                  case fe:
                  case ee:
                    return Xe;
                  default:
                    return Ye;
                }
            }
          case T:
            return Ye;
        }
      }
    }
    var Me = re, Ie = ie, ke = te, _e = ee, De = e, Fe = se, Ae = $, ne = he, oe = fe, ce = T, le = J, pe = V, ye = de, Ce = !1;
    function be(Ne) {
      return Ce || (Ce = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), ae(Ne) || Ee(Ne) === re;
    }
    function ae(Ne) {
      return Ee(Ne) === ie;
    }
    function ge(Ne) {
      return Ee(Ne) === te;
    }
    function Se(Ne) {
      return Ee(Ne) === ee;
    }
    function Le(Ne) {
      return typeof Ne == "object" && Ne !== null && Ne.$$typeof === e;
    }
    function ze(Ne) {
      return Ee(Ne) === se;
    }
    function Re(Ne) {
      return Ee(Ne) === $;
    }
    function We(Ne) {
      return Ee(Ne) === he;
    }
    function Be(Ne) {
      return Ee(Ne) === fe;
    }
    function Ue(Ne) {
      return Ee(Ne) === T;
    }
    function Ge(Ne) {
      return Ee(Ne) === J;
    }
    function je(Ne) {
      return Ee(Ne) === V;
    }
    function Oe(Ne) {
      return Ee(Ne) === de;
    }
    reactIs_development$3.AsyncMode = Me, reactIs_development$3.ConcurrentMode = Ie, reactIs_development$3.ContextConsumer = ke, reactIs_development$3.ContextProvider = _e, reactIs_development$3.Element = De, reactIs_development$3.ForwardRef = Fe, reactIs_development$3.Fragment = Ae, reactIs_development$3.Lazy = ne, reactIs_development$3.Memo = oe, reactIs_development$3.Portal = ce, reactIs_development$3.Profiler = le, reactIs_development$3.StrictMode = pe, reactIs_development$3.Suspense = ye, reactIs_development$3.isAsyncMode = be, reactIs_development$3.isConcurrentMode = ae, reactIs_development$3.isContextConsumer = ge, reactIs_development$3.isContextProvider = Se, reactIs_development$3.isElement = Le, reactIs_development$3.isForwardRef = ze, reactIs_development$3.isFragment = Re, reactIs_development$3.isLazy = We, reactIs_development$3.isMemo = Be, reactIs_development$3.isPortal = Ue, reactIs_development$3.isProfiler = Ge, reactIs_development$3.isStrictMode = je, reactIs_development$3.isSuspense = Oe, reactIs_development$3.isValidElementType = we, reactIs_development$3.typeOf = Ee;
  }()), reactIs_development$3;
}
dist$2.process.env.NODE_ENV === "production" ? reactIs$3.exports = requireReactIs_production_min$2() : reactIs$3.exports = requireReactIs_development$3();
var reactIsExports$1 = reactIs$3.exports, reactIs$2 = reactIsExports$1, FORWARD_REF_STATICS = {
  $$typeof: !0,
  render: !0,
  defaultProps: !0,
  displayName: !0,
  propTypes: !0
}, MEMO_STATICS = {
  $$typeof: !0,
  compare: !0,
  defaultProps: !0,
  displayName: !0,
  propTypes: !0,
  type: !0
}, TYPE_STATICS = {};
TYPE_STATICS[reactIs$2.ForwardRef] = FORWARD_REF_STATICS;
TYPE_STATICS[reactIs$2.Memo] = MEMO_STATICS;
var isBrowser = !0;
function getRegisteredStyles(C, e, T) {
  var $ = "";
  return T.split(" ").forEach(function(V) {
    C[V] !== void 0 ? e.push(C[V] + ";") : V && ($ += V + " ");
  }), $;
}
var registerStyles = function(e, T, $) {
  var V = e.key + "-" + T.name;
  // we only need to add the styles to the registered cache if the
  // class name could be used further down
  // the tree but if it's a string tag, we know it won't
  // so we don't have to add it to registered cache.
  // this improves memory usage since we can avoid storing the whole style string
  ($ === !1 || // we need to always store it if we're in compat mode and
  // in node since emotion-server relies on whether a style is in
  // the registered cache to know whether a style is global or not
  // also, note that this check will be dead code eliminated in the browser
  isBrowser === !1) && e.registered[V] === void 0 && (e.registered[V] = T.styles);
}, insertStyles = function(e, T, $) {
  registerStyles(e, T, $);
  var V = e.key + "-" + T.name;
  if (e.inserted[T.name] === void 0) {
    var J = T;
    do
      e.insert(T === J ? "." + V : "", J, e.sheet, !0), J = J.next;
    while (J !== void 0);
  }
};
function murmur2(C) {
  for (var e = 0, T, $ = 0, V = C.length; V >= 4; ++$, V -= 4)
    T = C.charCodeAt($) & 255 | (C.charCodeAt(++$) & 255) << 8 | (C.charCodeAt(++$) & 255) << 16 | (C.charCodeAt(++$) & 255) << 24, T = /* Math.imul(k, m): */
    (T & 65535) * 1540483477 + ((T >>> 16) * 59797 << 16), T ^= /* k >>> r: */
    T >>> 24, e = /* Math.imul(k, m): */
    (T & 65535) * 1540483477 + ((T >>> 16) * 59797 << 16) ^ /* Math.imul(h, m): */
    (e & 65535) * 1540483477 + ((e >>> 16) * 59797 << 16);
  switch (V) {
    case 3:
      e ^= (C.charCodeAt($ + 2) & 255) << 16;
    case 2:
      e ^= (C.charCodeAt($ + 1) & 255) << 8;
    case 1:
      e ^= C.charCodeAt($) & 255, e = /* Math.imul(h, m): */
      (e & 65535) * 1540483477 + ((e >>> 16) * 59797 << 16);
  }
  return e ^= e >>> 13, e = /* Math.imul(h, m): */
  (e & 65535) * 1540483477 + ((e >>> 16) * 59797 << 16), ((e ^ e >>> 15) >>> 0).toString(36);
}
var unitlessKeys = {
  animationIterationCount: 1,
  aspectRatio: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  scale: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
}, isDevelopment$2 = !1, hyphenateRegex = /[A-Z]|^ms/g, animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g, isCustomProperty = function(e) {
  return e.charCodeAt(1) === 45;
}, isProcessableValue = function(e) {
  return e != null && typeof e != "boolean";
}, processStyleName = /* @__PURE__ */ memoize$1(function(C) {
  return isCustomProperty(C) ? C : C.replace(hyphenateRegex, "-$&").toLowerCase();
}), processStyleValue = function(e, T) {
  switch (e) {
    case "animation":
    case "animationName":
      if (typeof T == "string")
        return T.replace(animationRegex, function($, V, J) {
          return cursor = {
            name: V,
            styles: J,
            next: cursor
          }, V;
        });
  }
  return unitlessKeys[e] !== 1 && !isCustomProperty(e) && typeof T == "number" && T !== 0 ? T + "px" : T;
}, noComponentSelectorMessage = "Component selectors can only be used in conjunction with @emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware compiler transform.";
function handleInterpolation(C, e, T) {
  if (T == null)
    return "";
  var $ = T;
  if ($.__emotion_styles !== void 0)
    return $;
  switch (typeof T) {
    case "boolean":
      return "";
    case "object": {
      var V = T;
      if (V.anim === 1)
        return cursor = {
          name: V.name,
          styles: V.styles,
          next: cursor
        }, V.name;
      var J = T;
      if (J.styles !== void 0) {
        var ee = J.next;
        if (ee !== void 0)
          for (; ee !== void 0; )
            cursor = {
              name: ee.name,
              styles: ee.styles,
              next: cursor
            }, ee = ee.next;
        var te = J.styles + ";";
        return te;
      }
      return createStringFromObject(C, e, T);
    }
    case "function": {
      if (C !== void 0) {
        var re = cursor, ie = T(C);
        return cursor = re, handleInterpolation(C, e, ie);
      }
      break;
    }
  }
  var se = T;
  if (e == null)
    return se;
  var de = e[se];
  return de !== void 0 ? de : se;
}
function createStringFromObject(C, e, T) {
  var $ = "";
  if (Array.isArray(T))
    for (var V = 0; V < T.length; V++)
      $ += handleInterpolation(C, e, T[V]) + ";";
  else
    for (var J in T) {
      var ee = T[J];
      if (typeof ee != "object") {
        var te = ee;
        e != null && e[te] !== void 0 ? $ += J + "{" + e[te] + "}" : isProcessableValue(te) && ($ += processStyleName(J) + ":" + processStyleValue(J, te) + ";");
      } else {
        if (J === "NO_COMPONENT_SELECTOR" && isDevelopment$2)
          throw new Error(noComponentSelectorMessage);
        if (Array.isArray(ee) && typeof ee[0] == "string" && (e == null || e[ee[0]] === void 0))
          for (var re = 0; re < ee.length; re++)
            isProcessableValue(ee[re]) && ($ += processStyleName(J) + ":" + processStyleValue(J, ee[re]) + ";");
        else {
          var ie = handleInterpolation(C, e, ee);
          switch (J) {
            case "animation":
            case "animationName": {
              $ += processStyleName(J) + ":" + ie + ";";
              break;
            }
            default:
              $ += J + "{" + ie + "}";
          }
        }
      }
    }
  return $;
}
var labelPattern = /label:\s*([^\s;{]+)\s*(;|$)/g, cursor;
function serializeStyles(C, e, T) {
  if (C.length === 1 && typeof C[0] == "object" && C[0] !== null && C[0].styles !== void 0)
    return C[0];
  var $ = !0, V = "";
  cursor = void 0;
  var J = C[0];
  if (J == null || J.raw === void 0)
    $ = !1, V += handleInterpolation(T, e, J);
  else {
    var ee = J;
    V += ee[0];
  }
  for (var te = 1; te < C.length; te++)
    if (V += handleInterpolation(T, e, C[te]), $) {
      var re = J;
      V += re[te];
    }
  labelPattern.lastIndex = 0;
  for (var ie = "", se; (se = labelPattern.exec(V)) !== null; )
    ie += "-" + se[1];
  var de = murmur2(V) + ie;
  return {
    name: de,
    styles: V,
    next: cursor
  };
}
var syncFallback = function(e) {
  return e();
}, useInsertionEffect = React$1.useInsertionEffect ? React$1.useInsertionEffect : !1, useInsertionEffectAlwaysWithSyncFallback = useInsertionEffect || syncFallback, useInsertionEffectWithLayoutFallback = useInsertionEffect || React$1.useLayoutEffect, isDevelopment$1 = !1, EmotionCacheContext = /* @__PURE__ */ React$1.createContext(
  // we're doing this to avoid preconstruct's dead code elimination in this one case
  // because this module is primarily intended for the browser and node
  // but it's also required in react native and similar environments sometimes
  // and we could have a special build just for that
  // but this is much easier and the native packages
  // might use a different theme context in the future anyway
  typeof HTMLElement < "u" ? /* @__PURE__ */ createCache({
    key: "css"
  }) : null
), CacheProvider = EmotionCacheContext.Provider, __unsafe_useEmotionCache = function() {
  return useContext(EmotionCacheContext);
}, withEmotionCache = function(e) {
  return /* @__PURE__ */ forwardRef(function(T, $) {
    var V = useContext(EmotionCacheContext);
    return e(T, V, $);
  });
}, ThemeContext$1 = /* @__PURE__ */ React$1.createContext({}), hasOwn = {}.hasOwnProperty, typePropName = "__EMOTION_TYPE_PLEASE_DO_NOT_USE__", createEmotionProps = function(e, T) {
  var $ = {};
  for (var V in T)
    hasOwn.call(T, V) && ($[V] = T[V]);
  return $[typePropName] = e, $;
}, Insertion$1 = function(e) {
  var T = e.cache, $ = e.serialized, V = e.isStringTag;
  return registerStyles(T, $, V), useInsertionEffectAlwaysWithSyncFallback(function() {
    return insertStyles(T, $, V);
  }), null;
}, Emotion = /* @__PURE__ */ withEmotionCache(function(C, e, T) {
  var $ = C.css;
  typeof $ == "string" && e.registered[$] !== void 0 && ($ = e.registered[$]);
  var V = C[typePropName], J = [$], ee = "";
  typeof C.className == "string" ? ee = getRegisteredStyles(e.registered, J, C.className) : C.className != null && (ee = C.className + " ");
  var te = serializeStyles(J, void 0, React$1.useContext(ThemeContext$1));
  ee += e.key + "-" + te.name;
  var re = {};
  for (var ie in C)
    hasOwn.call(C, ie) && ie !== "css" && ie !== typePropName && !isDevelopment$1 && (re[ie] = C[ie]);
  return re.className = ee, T && (re.ref = T), /* @__PURE__ */ React$1.createElement(React$1.Fragment, null, /* @__PURE__ */ React$1.createElement(Insertion$1, {
    cache: e,
    serialized: te,
    isStringTag: typeof V == "string"
  }), /* @__PURE__ */ React$1.createElement(V, re));
}), Emotion$1 = Emotion;
require_extends();
var jsx = function(e, T) {
  var $ = arguments;
  if (T == null || !hasOwn.call(T, "css"))
    return React$1.createElement.apply(void 0, $);
  var V = $.length, J = new Array(V);
  J[0] = Emotion$1, J[1] = createEmotionProps(e, T);
  for (var ee = 2; ee < V; ee++)
    J[ee] = $[ee];
  return React$1.createElement.apply(null, J);
};
(function(C) {
  var e;
  e || (e = C.JSX || (C.JSX = {}));
})(jsx || (jsx = {}));
var Global = /* @__PURE__ */ withEmotionCache(function(C, e) {
  var T = C.styles, $ = serializeStyles([T], void 0, React$1.useContext(ThemeContext$1)), V = React$1.useRef();
  return useInsertionEffectWithLayoutFallback(function() {
    var J = e.key + "-global", ee = new e.sheet.constructor({
      key: J,
      nonce: e.sheet.nonce,
      container: e.sheet.container,
      speedy: e.sheet.isSpeedy
    }), te = !1, re = document.querySelector('style[data-emotion="' + J + " " + $.name + '"]');
    return e.sheet.tags.length && (ee.before = e.sheet.tags[0]), re !== null && (te = !0, re.setAttribute("data-emotion", J), ee.hydrate([re])), V.current = [ee, te], function() {
      ee.flush();
    };
  }, [e]), useInsertionEffectWithLayoutFallback(function() {
    var J = V.current, ee = J[0], te = J[1];
    if (te) {
      J[1] = !1;
      return;
    }
    if ($.next !== void 0 && insertStyles(e, $.next, !0), ee.tags.length) {
      var re = ee.tags[ee.tags.length - 1].nextElementSibling;
      ee.before = re, ee.flush();
    }
    e.insert("", $, ee, !1);
  }, [e, $.name]), null;
});
function css() {
  for (var C = arguments.length, e = new Array(C), T = 0; T < C; T++)
    e[T] = arguments[T];
  return serializeStyles(e);
}
function keyframes() {
  var C = css.apply(void 0, arguments), e = "animation-" + C.name;
  return {
    name: e,
    styles: "@keyframes " + e + "{" + C.styles + "}",
    anim: 1,
    toString: function() {
      return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
    }
  };
}
var reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|disableRemotePlayback|download|draggable|encType|enterKeyHint|fetchpriority|fetchPriority|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/, isPropValid = /* @__PURE__ */ memoize$1(
  function(C) {
    return reactPropsRegex.test(C) || C.charCodeAt(0) === 111 && C.charCodeAt(1) === 110 && C.charCodeAt(2) < 91;
  }
  /* Z+1 */
), isDevelopment = !1, testOmitPropsOnStringTag = isPropValid, testOmitPropsOnComponent = function(e) {
  return e !== "theme";
}, getDefaultShouldForwardProp = function(e) {
  return typeof e == "string" && // 96 is one less than the char code
  // for "a" so this is checking that
  // it's a lowercase character
  e.charCodeAt(0) > 96 ? testOmitPropsOnStringTag : testOmitPropsOnComponent;
}, composeShouldForwardProps = function(e, T, $) {
  var V;
  if (T) {
    var J = T.shouldForwardProp;
    V = e.__emotion_forwardProp && J ? function(ee) {
      return e.__emotion_forwardProp(ee) && J(ee);
    } : J;
  }
  return typeof V != "function" && $ && (V = e.__emotion_forwardProp), V;
}, Insertion = function(e) {
  var T = e.cache, $ = e.serialized, V = e.isStringTag;
  return registerStyles(T, $, V), useInsertionEffectAlwaysWithSyncFallback(function() {
    return insertStyles(T, $, V);
  }), null;
}, createStyled$2 = function C(e, T) {
  var $ = e.__emotion_real === e, V = $ && e.__emotion_base || e, J, ee;
  T !== void 0 && (J = T.label, ee = T.target);
  var te = composeShouldForwardProps(e, T, $), re = te || getDefaultShouldForwardProp(V), ie = !re("as");
  return function() {
    var se = arguments, de = $ && e.__emotion_styles !== void 0 ? e.__emotion_styles.slice(0) : [];
    if (J !== void 0 && de.push("label:" + J + ";"), se[0] == null || se[0].raw === void 0)
      de.push.apply(de, se);
    else {
      var ue = se[0];
      de.push(ue[0]);
      for (var fe = se.length, he = 1; he < fe; he++)
        de.push(se[he], ue[he]);
    }
    var me = withEmotionCache(function(xe, ve, Te) {
      var we = ie && xe.as || V, Ee = "", Me = [], Ie = xe;
      if (xe.theme == null) {
        Ie = {};
        for (var ke in xe)
          Ie[ke] = xe[ke];
        Ie.theme = React$1.useContext(ThemeContext$1);
      }
      typeof xe.className == "string" ? Ee = getRegisteredStyles(ve.registered, Me, xe.className) : xe.className != null && (Ee = xe.className + " ");
      var _e = serializeStyles(de.concat(Me), ve.registered, Ie);
      Ee += ve.key + "-" + _e.name, ee !== void 0 && (Ee += " " + ee);
      var De = ie && te === void 0 ? getDefaultShouldForwardProp(we) : re, Fe = {};
      for (var Ae in xe)
        ie && Ae === "as" || De(Ae) && (Fe[Ae] = xe[Ae]);
      return Fe.className = Ee, Te && (Fe.ref = Te), /* @__PURE__ */ React$1.createElement(React$1.Fragment, null, /* @__PURE__ */ React$1.createElement(Insertion, {
        cache: ve,
        serialized: _e,
        isStringTag: typeof we == "string"
      }), /* @__PURE__ */ React$1.createElement(we, Fe));
    });
    return me.displayName = J !== void 0 ? J : "Styled(" + (typeof V == "string" ? V : V.displayName || V.name || "Component") + ")", me.defaultProps = e.defaultProps, me.__emotion_real = me, me.__emotion_base = V, me.__emotion_styles = de, me.__emotion_forwardProp = te, Object.defineProperty(me, "toString", {
      value: function() {
        return ee === void 0 && isDevelopment ? "NO_COMPONENT_SELECTOR" : "." + ee;
      }
    }), me.withComponent = function(xe, ve) {
      var Te = C(xe, _extends({}, T, ve, {
        shouldForwardProp: composeShouldForwardProps(me, ve, !0)
      }));
      return Te.apply(void 0, de);
    }, me;
  };
}, tags = [
  "a",
  "abbr",
  "address",
  "area",
  "article",
  "aside",
  "audio",
  "b",
  "base",
  "bdi",
  "bdo",
  "big",
  "blockquote",
  "body",
  "br",
  "button",
  "canvas",
  "caption",
  "cite",
  "code",
  "col",
  "colgroup",
  "data",
  "datalist",
  "dd",
  "del",
  "details",
  "dfn",
  "dialog",
  "div",
  "dl",
  "dt",
  "em",
  "embed",
  "fieldset",
  "figcaption",
  "figure",
  "footer",
  "form",
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6",
  "head",
  "header",
  "hgroup",
  "hr",
  "html",
  "i",
  "iframe",
  "img",
  "input",
  "ins",
  "kbd",
  "keygen",
  "label",
  "legend",
  "li",
  "link",
  "main",
  "map",
  "mark",
  "marquee",
  "menu",
  "menuitem",
  "meta",
  "meter",
  "nav",
  "noscript",
  "object",
  "ol",
  "optgroup",
  "option",
  "output",
  "p",
  "param",
  "picture",
  "pre",
  "progress",
  "q",
  "rp",
  "rt",
  "ruby",
  "s",
  "samp",
  "script",
  "section",
  "select",
  "small",
  "source",
  "span",
  "strong",
  "style",
  "sub",
  "summary",
  "sup",
  "table",
  "tbody",
  "td",
  "textarea",
  "tfoot",
  "th",
  "thead",
  "time",
  "title",
  "tr",
  "track",
  "u",
  "ul",
  "var",
  "video",
  "wbr",
  // SVG
  "circle",
  "clipPath",
  "defs",
  "ellipse",
  "foreignObject",
  "g",
  "image",
  "line",
  "linearGradient",
  "mask",
  "path",
  "pattern",
  "polygon",
  "polyline",
  "radialGradient",
  "rect",
  "stop",
  "svg",
  "text",
  "tspan"
], newStyled = createStyled$2.bind(null);
tags.forEach(function(C) {
  newStyled[C] = newStyled(C);
});
var propTypes = { exports: {} }, reactIs$1 = { exports: {} }, reactIs_production_min$1 = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredReactIs_production_min$1;
function requireReactIs_production_min$1() {
  if (hasRequiredReactIs_production_min$1) return reactIs_production_min$1;
  hasRequiredReactIs_production_min$1 = 1;
  var C = typeof Symbol == "function" && Symbol.for, e = C ? Symbol.for("react.element") : 60103, T = C ? Symbol.for("react.portal") : 60106, $ = C ? Symbol.for("react.fragment") : 60107, V = C ? Symbol.for("react.strict_mode") : 60108, J = C ? Symbol.for("react.profiler") : 60114, ee = C ? Symbol.for("react.provider") : 60109, te = C ? Symbol.for("react.context") : 60110, re = C ? Symbol.for("react.async_mode") : 60111, ie = C ? Symbol.for("react.concurrent_mode") : 60111, se = C ? Symbol.for("react.forward_ref") : 60112, de = C ? Symbol.for("react.suspense") : 60113, ue = C ? Symbol.for("react.suspense_list") : 60120, fe = C ? Symbol.for("react.memo") : 60115, he = C ? Symbol.for("react.lazy") : 60116, me = C ? Symbol.for("react.block") : 60121, xe = C ? Symbol.for("react.fundamental") : 60117, ve = C ? Symbol.for("react.responder") : 60118, Te = C ? Symbol.for("react.scope") : 60119;
  function we(Me) {
    if (typeof Me == "object" && Me !== null) {
      var Ie = Me.$$typeof;
      switch (Ie) {
        case e:
          switch (Me = Me.type, Me) {
            case re:
            case ie:
            case $:
            case J:
            case V:
            case de:
              return Me;
            default:
              switch (Me = Me && Me.$$typeof, Me) {
                case te:
                case se:
                case he:
                case fe:
                case ee:
                  return Me;
                default:
                  return Ie;
              }
          }
        case T:
          return Ie;
      }
    }
  }
  function Ee(Me) {
    return we(Me) === ie;
  }
  return reactIs_production_min$1.AsyncMode = re, reactIs_production_min$1.ConcurrentMode = ie, reactIs_production_min$1.ContextConsumer = te, reactIs_production_min$1.ContextProvider = ee, reactIs_production_min$1.Element = e, reactIs_production_min$1.ForwardRef = se, reactIs_production_min$1.Fragment = $, reactIs_production_min$1.Lazy = he, reactIs_production_min$1.Memo = fe, reactIs_production_min$1.Portal = T, reactIs_production_min$1.Profiler = J, reactIs_production_min$1.StrictMode = V, reactIs_production_min$1.Suspense = de, reactIs_production_min$1.isAsyncMode = function(Me) {
    return Ee(Me) || we(Me) === re;
  }, reactIs_production_min$1.isConcurrentMode = Ee, reactIs_production_min$1.isContextConsumer = function(Me) {
    return we(Me) === te;
  }, reactIs_production_min$1.isContextProvider = function(Me) {
    return we(Me) === ee;
  }, reactIs_production_min$1.isElement = function(Me) {
    return typeof Me == "object" && Me !== null && Me.$$typeof === e;
  }, reactIs_production_min$1.isForwardRef = function(Me) {
    return we(Me) === se;
  }, reactIs_production_min$1.isFragment = function(Me) {
    return we(Me) === $;
  }, reactIs_production_min$1.isLazy = function(Me) {
    return we(Me) === he;
  }, reactIs_production_min$1.isMemo = function(Me) {
    return we(Me) === fe;
  }, reactIs_production_min$1.isPortal = function(Me) {
    return we(Me) === T;
  }, reactIs_production_min$1.isProfiler = function(Me) {
    return we(Me) === J;
  }, reactIs_production_min$1.isStrictMode = function(Me) {
    return we(Me) === V;
  }, reactIs_production_min$1.isSuspense = function(Me) {
    return we(Me) === de;
  }, reactIs_production_min$1.isValidElementType = function(Me) {
    return typeof Me == "string" || typeof Me == "function" || Me === $ || Me === ie || Me === J || Me === V || Me === de || Me === ue || typeof Me == "object" && Me !== null && (Me.$$typeof === he || Me.$$typeof === fe || Me.$$typeof === ee || Me.$$typeof === te || Me.$$typeof === se || Me.$$typeof === xe || Me.$$typeof === ve || Me.$$typeof === Te || Me.$$typeof === me);
  }, reactIs_production_min$1.typeOf = we, reactIs_production_min$1;
}
var reactIs_development$2 = {}, hasRequiredReactIs_development$2;
function requireReactIs_development$2() {
  return hasRequiredReactIs_development$2 || (hasRequiredReactIs_development$2 = 1, dist$2.process.env.NODE_ENV !== "production" && function() {
    var C = typeof Symbol == "function" && Symbol.for, e = C ? Symbol.for("react.element") : 60103, T = C ? Symbol.for("react.portal") : 60106, $ = C ? Symbol.for("react.fragment") : 60107, V = C ? Symbol.for("react.strict_mode") : 60108, J = C ? Symbol.for("react.profiler") : 60114, ee = C ? Symbol.for("react.provider") : 60109, te = C ? Symbol.for("react.context") : 60110, re = C ? Symbol.for("react.async_mode") : 60111, ie = C ? Symbol.for("react.concurrent_mode") : 60111, se = C ? Symbol.for("react.forward_ref") : 60112, de = C ? Symbol.for("react.suspense") : 60113, ue = C ? Symbol.for("react.suspense_list") : 60120, fe = C ? Symbol.for("react.memo") : 60115, he = C ? Symbol.for("react.lazy") : 60116, me = C ? Symbol.for("react.block") : 60121, xe = C ? Symbol.for("react.fundamental") : 60117, ve = C ? Symbol.for("react.responder") : 60118, Te = C ? Symbol.for("react.scope") : 60119;
    function we(Ne) {
      return typeof Ne == "string" || typeof Ne == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      Ne === $ || Ne === ie || Ne === J || Ne === V || Ne === de || Ne === ue || typeof Ne == "object" && Ne !== null && (Ne.$$typeof === he || Ne.$$typeof === fe || Ne.$$typeof === ee || Ne.$$typeof === te || Ne.$$typeof === se || Ne.$$typeof === xe || Ne.$$typeof === ve || Ne.$$typeof === Te || Ne.$$typeof === me);
    }
    function Ee(Ne) {
      if (typeof Ne == "object" && Ne !== null) {
        var Ye = Ne.$$typeof;
        switch (Ye) {
          case e:
            var Je = Ne.type;
            switch (Je) {
              case re:
              case ie:
              case $:
              case J:
              case V:
              case de:
                return Je;
              default:
                var Xe = Je && Je.$$typeof;
                switch (Xe) {
                  case te:
                  case se:
                  case he:
                  case fe:
                  case ee:
                    return Xe;
                  default:
                    return Ye;
                }
            }
          case T:
            return Ye;
        }
      }
    }
    var Me = re, Ie = ie, ke = te, _e = ee, De = e, Fe = se, Ae = $, ne = he, oe = fe, ce = T, le = J, pe = V, ye = de, Ce = !1;
    function be(Ne) {
      return Ce || (Ce = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), ae(Ne) || Ee(Ne) === re;
    }
    function ae(Ne) {
      return Ee(Ne) === ie;
    }
    function ge(Ne) {
      return Ee(Ne) === te;
    }
    function Se(Ne) {
      return Ee(Ne) === ee;
    }
    function Le(Ne) {
      return typeof Ne == "object" && Ne !== null && Ne.$$typeof === e;
    }
    function ze(Ne) {
      return Ee(Ne) === se;
    }
    function Re(Ne) {
      return Ee(Ne) === $;
    }
    function We(Ne) {
      return Ee(Ne) === he;
    }
    function Be(Ne) {
      return Ee(Ne) === fe;
    }
    function Ue(Ne) {
      return Ee(Ne) === T;
    }
    function Ge(Ne) {
      return Ee(Ne) === J;
    }
    function je(Ne) {
      return Ee(Ne) === V;
    }
    function Oe(Ne) {
      return Ee(Ne) === de;
    }
    reactIs_development$2.AsyncMode = Me, reactIs_development$2.ConcurrentMode = Ie, reactIs_development$2.ContextConsumer = ke, reactIs_development$2.ContextProvider = _e, reactIs_development$2.Element = De, reactIs_development$2.ForwardRef = Fe, reactIs_development$2.Fragment = Ae, reactIs_development$2.Lazy = ne, reactIs_development$2.Memo = oe, reactIs_development$2.Portal = ce, reactIs_development$2.Profiler = le, reactIs_development$2.StrictMode = pe, reactIs_development$2.Suspense = ye, reactIs_development$2.isAsyncMode = be, reactIs_development$2.isConcurrentMode = ae, reactIs_development$2.isContextConsumer = ge, reactIs_development$2.isContextProvider = Se, reactIs_development$2.isElement = Le, reactIs_development$2.isForwardRef = ze, reactIs_development$2.isFragment = Re, reactIs_development$2.isLazy = We, reactIs_development$2.isMemo = Be, reactIs_development$2.isPortal = Ue, reactIs_development$2.isProfiler = Ge, reactIs_development$2.isStrictMode = je, reactIs_development$2.isSuspense = Oe, reactIs_development$2.isValidElementType = we, reactIs_development$2.typeOf = Ee;
  }()), reactIs_development$2;
}
var hasRequiredReactIs;
function requireReactIs() {
  return hasRequiredReactIs || (hasRequiredReactIs = 1, dist$2.process.env.NODE_ENV === "production" ? reactIs$1.exports = requireReactIs_production_min$1() : reactIs$1.exports = requireReactIs_development$2()), reactIs$1.exports;
}
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var objectAssign, hasRequiredObjectAssign;
function requireObjectAssign() {
  if (hasRequiredObjectAssign) return objectAssign;
  hasRequiredObjectAssign = 1;
  var C = Object.getOwnPropertySymbols, e = Object.prototype.hasOwnProperty, T = Object.prototype.propertyIsEnumerable;
  function $(J) {
    if (J == null)
      throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(J);
  }
  function V() {
    try {
      if (!Object.assign)
        return !1;
      var J = new String("abc");
      if (J[5] = "de", Object.getOwnPropertyNames(J)[0] === "5")
        return !1;
      for (var ee = {}, te = 0; te < 10; te++)
        ee["_" + String.fromCharCode(te)] = te;
      var re = Object.getOwnPropertyNames(ee).map(function(se) {
        return ee[se];
      });
      if (re.join("") !== "0123456789")
        return !1;
      var ie = {};
      return "abcdefghijklmnopqrst".split("").forEach(function(se) {
        ie[se] = se;
      }), Object.keys(Object.assign({}, ie)).join("") === "abcdefghijklmnopqrst";
    } catch {
      return !1;
    }
  }
  return objectAssign = V() ? Object.assign : function(J, ee) {
    for (var te, re = $(J), ie, se = 1; se < arguments.length; se++) {
      te = Object(arguments[se]);
      for (var de in te)
        e.call(te, de) && (re[de] = te[de]);
      if (C) {
        ie = C(te);
        for (var ue = 0; ue < ie.length; ue++)
          T.call(te, ie[ue]) && (re[ie[ue]] = te[ie[ue]]);
      }
    }
    return re;
  }, objectAssign;
}
var ReactPropTypesSecret_1, hasRequiredReactPropTypesSecret;
function requireReactPropTypesSecret() {
  if (hasRequiredReactPropTypesSecret) return ReactPropTypesSecret_1;
  hasRequiredReactPropTypesSecret = 1;
  var C = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  return ReactPropTypesSecret_1 = C, ReactPropTypesSecret_1;
}
var has, hasRequiredHas;
function requireHas() {
  return hasRequiredHas || (hasRequiredHas = 1, has = Function.call.bind(Object.prototype.hasOwnProperty)), has;
}
var checkPropTypes_1, hasRequiredCheckPropTypes;
function requireCheckPropTypes() {
  if (hasRequiredCheckPropTypes) return checkPropTypes_1;
  hasRequiredCheckPropTypes = 1;
  var C = function() {
  };
  if (dist$2.process.env.NODE_ENV !== "production") {
    var e = requireReactPropTypesSecret(), T = {}, $ = requireHas();
    C = function(J) {
      var ee = "Warning: " + J;
      typeof console < "u" && console.error(ee);
      try {
        throw new Error(ee);
      } catch {
      }
    };
  }
  function V(J, ee, te, re, ie) {
    if (dist$2.process.env.NODE_ENV !== "production") {
      for (var se in J)
        if ($(J, se)) {
          var de;
          try {
            if (typeof J[se] != "function") {
              var ue = Error(
                (re || "React class") + ": " + te + " type `" + se + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof J[se] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
              );
              throw ue.name = "Invariant Violation", ue;
            }
            de = J[se](ee, se, re, te, null, e);
          } catch (he) {
            de = he;
          }
          if (de && !(de instanceof Error) && C(
            (re || "React class") + ": type specification of " + te + " `" + se + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof de + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
          ), de instanceof Error && !(de.message in T)) {
            T[de.message] = !0;
            var fe = ie ? ie() : "";
            C(
              "Failed " + te + " type: " + de.message + (fe ?? "")
            );
          }
        }
    }
  }
  return V.resetWarningCache = function() {
    dist$2.process.env.NODE_ENV !== "production" && (T = {});
  }, checkPropTypes_1 = V, checkPropTypes_1;
}
var factoryWithTypeCheckers, hasRequiredFactoryWithTypeCheckers;
function requireFactoryWithTypeCheckers() {
  if (hasRequiredFactoryWithTypeCheckers) return factoryWithTypeCheckers;
  hasRequiredFactoryWithTypeCheckers = 1;
  var C = requireReactIs(), e = requireObjectAssign(), T = requireReactPropTypesSecret(), $ = requireHas(), V = requireCheckPropTypes(), J = function() {
  };
  dist$2.process.env.NODE_ENV !== "production" && (J = function(te) {
    var re = "Warning: " + te;
    typeof console < "u" && console.error(re);
    try {
      throw new Error(re);
    } catch {
    }
  });
  function ee() {
    return null;
  }
  return factoryWithTypeCheckers = function(te, re) {
    var ie = typeof Symbol == "function" && Symbol.iterator, se = "@@iterator";
    function de(ae) {
      var ge = ae && (ie && ae[ie] || ae[se]);
      if (typeof ge == "function")
        return ge;
    }
    var ue = "<<anonymous>>", fe = {
      array: ve("array"),
      bigint: ve("bigint"),
      bool: ve("boolean"),
      func: ve("function"),
      number: ve("number"),
      object: ve("object"),
      string: ve("string"),
      symbol: ve("symbol"),
      any: Te(),
      arrayOf: we,
      element: Ee(),
      elementType: Me(),
      instanceOf: Ie,
      node: Fe(),
      objectOf: _e,
      oneOf: ke,
      oneOfType: De,
      shape: ne,
      exact: oe
    };
    function he(ae, ge) {
      return ae === ge ? ae !== 0 || 1 / ae === 1 / ge : ae !== ae && ge !== ge;
    }
    function me(ae, ge) {
      this.message = ae, this.data = ge && typeof ge == "object" ? ge : {}, this.stack = "";
    }
    me.prototype = Error.prototype;
    function xe(ae) {
      if (dist$2.process.env.NODE_ENV !== "production")
        var ge = {}, Se = 0;
      function Le(Re, We, Be, Ue, Ge, je, Oe) {
        if (Ue = Ue || ue, je = je || Be, Oe !== T) {
          if (re) {
            var Ne = new Error(
              "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
            );
            throw Ne.name = "Invariant Violation", Ne;
          } else if (dist$2.process.env.NODE_ENV !== "production" && typeof console < "u") {
            var Ye = Ue + ":" + Be;
            !ge[Ye] && // Avoid spamming the console because they are often not actionable except for lib authors
            Se < 3 && (J(
              "You are manually calling a React.PropTypes validation function for the `" + je + "` prop on `" + Ue + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
            ), ge[Ye] = !0, Se++);
          }
        }
        return We[Be] == null ? Re ? We[Be] === null ? new me("The " + Ge + " `" + je + "` is marked as required " + ("in `" + Ue + "`, but its value is `null`.")) : new me("The " + Ge + " `" + je + "` is marked as required in " + ("`" + Ue + "`, but its value is `undefined`.")) : null : ae(We, Be, Ue, Ge, je);
      }
      var ze = Le.bind(null, !1);
      return ze.isRequired = Le.bind(null, !0), ze;
    }
    function ve(ae) {
      function ge(Se, Le, ze, Re, We, Be) {
        var Ue = Se[Le], Ge = pe(Ue);
        if (Ge !== ae) {
          var je = ye(Ue);
          return new me(
            "Invalid " + Re + " `" + We + "` of type " + ("`" + je + "` supplied to `" + ze + "`, expected ") + ("`" + ae + "`."),
            { expectedType: ae }
          );
        }
        return null;
      }
      return xe(ge);
    }
    function Te() {
      return xe(ee);
    }
    function we(ae) {
      function ge(Se, Le, ze, Re, We) {
        if (typeof ae != "function")
          return new me("Property `" + We + "` of component `" + ze + "` has invalid PropType notation inside arrayOf.");
        var Be = Se[Le];
        if (!Array.isArray(Be)) {
          var Ue = pe(Be);
          return new me("Invalid " + Re + " `" + We + "` of type " + ("`" + Ue + "` supplied to `" + ze + "`, expected an array."));
        }
        for (var Ge = 0; Ge < Be.length; Ge++) {
          var je = ae(Be, Ge, ze, Re, We + "[" + Ge + "]", T);
          if (je instanceof Error)
            return je;
        }
        return null;
      }
      return xe(ge);
    }
    function Ee() {
      function ae(ge, Se, Le, ze, Re) {
        var We = ge[Se];
        if (!te(We)) {
          var Be = pe(We);
          return new me("Invalid " + ze + " `" + Re + "` of type " + ("`" + Be + "` supplied to `" + Le + "`, expected a single ReactElement."));
        }
        return null;
      }
      return xe(ae);
    }
    function Me() {
      function ae(ge, Se, Le, ze, Re) {
        var We = ge[Se];
        if (!C.isValidElementType(We)) {
          var Be = pe(We);
          return new me("Invalid " + ze + " `" + Re + "` of type " + ("`" + Be + "` supplied to `" + Le + "`, expected a single ReactElement type."));
        }
        return null;
      }
      return xe(ae);
    }
    function Ie(ae) {
      function ge(Se, Le, ze, Re, We) {
        if (!(Se[Le] instanceof ae)) {
          var Be = ae.name || ue, Ue = be(Se[Le]);
          return new me("Invalid " + Re + " `" + We + "` of type " + ("`" + Ue + "` supplied to `" + ze + "`, expected ") + ("instance of `" + Be + "`."));
        }
        return null;
      }
      return xe(ge);
    }
    function ke(ae) {
      if (!Array.isArray(ae))
        return dist$2.process.env.NODE_ENV !== "production" && (arguments.length > 1 ? J(
          "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
        ) : J("Invalid argument supplied to oneOf, expected an array.")), ee;
      function ge(Se, Le, ze, Re, We) {
        for (var Be = Se[Le], Ue = 0; Ue < ae.length; Ue++)
          if (he(Be, ae[Ue]))
            return null;
        var Ge = JSON.stringify(ae, function(Oe, Ne) {
          var Ye = ye(Ne);
          return Ye === "symbol" ? String(Ne) : Ne;
        });
        return new me("Invalid " + Re + " `" + We + "` of value `" + String(Be) + "` " + ("supplied to `" + ze + "`, expected one of " + Ge + "."));
      }
      return xe(ge);
    }
    function _e(ae) {
      function ge(Se, Le, ze, Re, We) {
        if (typeof ae != "function")
          return new me("Property `" + We + "` of component `" + ze + "` has invalid PropType notation inside objectOf.");
        var Be = Se[Le], Ue = pe(Be);
        if (Ue !== "object")
          return new me("Invalid " + Re + " `" + We + "` of type " + ("`" + Ue + "` supplied to `" + ze + "`, expected an object."));
        for (var Ge in Be)
          if ($(Be, Ge)) {
            var je = ae(Be, Ge, ze, Re, We + "." + Ge, T);
            if (je instanceof Error)
              return je;
          }
        return null;
      }
      return xe(ge);
    }
    function De(ae) {
      if (!Array.isArray(ae))
        return dist$2.process.env.NODE_ENV !== "production" && J("Invalid argument supplied to oneOfType, expected an instance of array."), ee;
      for (var ge = 0; ge < ae.length; ge++) {
        var Se = ae[ge];
        if (typeof Se != "function")
          return J(
            "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + Ce(Se) + " at index " + ge + "."
          ), ee;
      }
      function Le(ze, Re, We, Be, Ue) {
        for (var Ge = [], je = 0; je < ae.length; je++) {
          var Oe = ae[je], Ne = Oe(ze, Re, We, Be, Ue, T);
          if (Ne == null)
            return null;
          Ne.data && $(Ne.data, "expectedType") && Ge.push(Ne.data.expectedType);
        }
        var Ye = Ge.length > 0 ? ", expected one of type [" + Ge.join(", ") + "]" : "";
        return new me("Invalid " + Be + " `" + Ue + "` supplied to " + ("`" + We + "`" + Ye + "."));
      }
      return xe(Le);
    }
    function Fe() {
      function ae(ge, Se, Le, ze, Re) {
        return ce(ge[Se]) ? null : new me("Invalid " + ze + " `" + Re + "` supplied to " + ("`" + Le + "`, expected a ReactNode."));
      }
      return xe(ae);
    }
    function Ae(ae, ge, Se, Le, ze) {
      return new me(
        (ae || "React class") + ": " + ge + " type `" + Se + "." + Le + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + ze + "`."
      );
    }
    function ne(ae) {
      function ge(Se, Le, ze, Re, We) {
        var Be = Se[Le], Ue = pe(Be);
        if (Ue !== "object")
          return new me("Invalid " + Re + " `" + We + "` of type `" + Ue + "` " + ("supplied to `" + ze + "`, expected `object`."));
        for (var Ge in ae) {
          var je = ae[Ge];
          if (typeof je != "function")
            return Ae(ze, Re, We, Ge, ye(je));
          var Oe = je(Be, Ge, ze, Re, We + "." + Ge, T);
          if (Oe)
            return Oe;
        }
        return null;
      }
      return xe(ge);
    }
    function oe(ae) {
      function ge(Se, Le, ze, Re, We) {
        var Be = Se[Le], Ue = pe(Be);
        if (Ue !== "object")
          return new me("Invalid " + Re + " `" + We + "` of type `" + Ue + "` " + ("supplied to `" + ze + "`, expected `object`."));
        var Ge = e({}, Se[Le], ae);
        for (var je in Ge) {
          var Oe = ae[je];
          if ($(ae, je) && typeof Oe != "function")
            return Ae(ze, Re, We, je, ye(Oe));
          if (!Oe)
            return new me(
              "Invalid " + Re + " `" + We + "` key `" + je + "` supplied to `" + ze + "`.\nBad object: " + JSON.stringify(Se[Le], null, "  ") + `
Valid keys: ` + JSON.stringify(Object.keys(ae), null, "  ")
            );
          var Ne = Oe(Be, je, ze, Re, We + "." + je, T);
          if (Ne)
            return Ne;
        }
        return null;
      }
      return xe(ge);
    }
    function ce(ae) {
      switch (typeof ae) {
        case "number":
        case "string":
        case "undefined":
          return !0;
        case "boolean":
          return !ae;
        case "object":
          if (Array.isArray(ae))
            return ae.every(ce);
          if (ae === null || te(ae))
            return !0;
          var ge = de(ae);
          if (ge) {
            var Se = ge.call(ae), Le;
            if (ge !== ae.entries) {
              for (; !(Le = Se.next()).done; )
                if (!ce(Le.value))
                  return !1;
            } else
              for (; !(Le = Se.next()).done; ) {
                var ze = Le.value;
                if (ze && !ce(ze[1]))
                  return !1;
              }
          } else
            return !1;
          return !0;
        default:
          return !1;
      }
    }
    function le(ae, ge) {
      return ae === "symbol" ? !0 : ge ? ge["@@toStringTag"] === "Symbol" || typeof Symbol == "function" && ge instanceof Symbol : !1;
    }
    function pe(ae) {
      var ge = typeof ae;
      return Array.isArray(ae) ? "array" : ae instanceof RegExp ? "object" : le(ge, ae) ? "symbol" : ge;
    }
    function ye(ae) {
      if (typeof ae > "u" || ae === null)
        return "" + ae;
      var ge = pe(ae);
      if (ge === "object") {
        if (ae instanceof Date)
          return "date";
        if (ae instanceof RegExp)
          return "regexp";
      }
      return ge;
    }
    function Ce(ae) {
      var ge = ye(ae);
      switch (ge) {
        case "array":
        case "object":
          return "an " + ge;
        case "boolean":
        case "date":
        case "regexp":
          return "a " + ge;
        default:
          return ge;
      }
    }
    function be(ae) {
      return !ae.constructor || !ae.constructor.name ? ue : ae.constructor.name;
    }
    return fe.checkPropTypes = V, fe.resetWarningCache = V.resetWarningCache, fe.PropTypes = fe, fe;
  }, factoryWithTypeCheckers;
}
var factoryWithThrowingShims, hasRequiredFactoryWithThrowingShims;
function requireFactoryWithThrowingShims() {
  if (hasRequiredFactoryWithThrowingShims) return factoryWithThrowingShims;
  hasRequiredFactoryWithThrowingShims = 1;
  var C = requireReactPropTypesSecret();
  function e() {
  }
  function T() {
  }
  return T.resetWarningCache = e, factoryWithThrowingShims = function() {
    function $(ee, te, re, ie, se, de) {
      if (de !== C) {
        var ue = new Error(
          "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
        );
        throw ue.name = "Invariant Violation", ue;
      }
    }
    $.isRequired = $;
    function V() {
      return $;
    }
    var J = {
      array: $,
      bigint: $,
      bool: $,
      func: $,
      number: $,
      object: $,
      string: $,
      symbol: $,
      any: $,
      arrayOf: V,
      element: $,
      elementType: $,
      instanceOf: V,
      node: $,
      objectOf: V,
      oneOf: V,
      oneOfType: V,
      shape: V,
      exact: V,
      checkPropTypes: T,
      resetWarningCache: e
    };
    return J.PropTypes = J, J;
  }, factoryWithThrowingShims;
}
if (dist$2.process.env.NODE_ENV !== "production") {
  var ReactIs = requireReactIs(), throwOnDirectAccess = !0;
  propTypes.exports = requireFactoryWithTypeCheckers()(ReactIs.isElement, throwOnDirectAccess);
} else
  propTypes.exports = requireFactoryWithThrowingShims()();
var propTypesExports = propTypes.exports;
const PropTypes = /* @__PURE__ */ getDefaultExportFromCjs$2(propTypesExports);
let cache;
typeof document == "object" && (cache = createCache({
  key: "css",
  prepend: !0
}));
function StyledEngineProvider(C) {
  const {
    injectFirst: e,
    children: T
  } = C;
  return e && cache ? /* @__PURE__ */ jsxRuntimeExports.jsx(CacheProvider, {
    value: cache,
    children: T
  }) : T;
}
dist$2.process.env.NODE_ENV !== "production" && (StyledEngineProvider.propTypes = {
  /**
   * Your component tree.
   */
  children: PropTypes.node,
  /**
   * By default, the styles are injected last in the <head> element of the page.
   * As a result, they gain more specificity than any other style sheet.
   * If you want to override MUI's styles, set this prop.
   */
  injectFirst: PropTypes.bool
});
function isEmpty$4(C) {
  return C == null || Object.keys(C).length === 0;
}
function GlobalStyles$2(C) {
  const {
    styles: e,
    defaultTheme: T = {}
  } = C, $ = typeof e == "function" ? (V) => e(isEmpty$4(V) ? T : V) : e;
  return /* @__PURE__ */ jsxRuntimeExports.jsx(Global, {
    styles: $
  });
}
dist$2.process.env.NODE_ENV !== "production" && (GlobalStyles$2.propTypes = {
  defaultTheme: PropTypes.object,
  styles: PropTypes.oneOfType([PropTypes.array, PropTypes.string, PropTypes.object, PropTypes.func])
});
function styled$2(C, e) {
  const T = newStyled(C, e);
  return dist$2.process.env.NODE_ENV !== "production" ? (...$) => {
    const V = typeof C == "string" ? `"${C}"` : "component";
    return $.length === 0 ? console.error([`MUI: Seems like you called \`styled(${V})()\` without a \`style\` argument.`, 'You must provide a `styles` argument: `styled("div")(styleYouForgotToPass)`.'].join(`
`)) : $.some((J) => J === void 0) && console.error(`MUI: the styled(${V})(...args) API requires all its args to be defined.`), T(...$);
  } : T;
}
const internal_processStyles = (C, e) => {
  Array.isArray(C.__emotion_styles) && (C.__emotion_styles = e(C.__emotion_styles));
}, styledEngine = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  GlobalStyles: GlobalStyles$2,
  StyledEngineProvider,
  ThemeContext: ThemeContext$1,
  css,
  default: styled$2,
  internal_processStyles,
  keyframes
}, Symbol.toStringTag, { value: "Module" })), require$$1$3 = /* @__PURE__ */ getAugmentedNamespace(styledEngine);
function isPlainObject$3(C) {
  if (typeof C != "object" || C === null)
    return !1;
  const e = Object.getPrototypeOf(C);
  return (e === null || e === Object.prototype || Object.getPrototypeOf(e) === null) && !(Symbol.toStringTag in C) && !(Symbol.iterator in C);
}
function deepClone(C) {
  if (/* @__PURE__ */ React$1.isValidElement(C) || !isPlainObject$3(C))
    return C;
  const e = {};
  return Object.keys(C).forEach((T) => {
    e[T] = deepClone(C[T]);
  }), e;
}
function deepmerge$1(C, e, T = {
  clone: !0
}) {
  const $ = T.clone ? _extends({}, C) : C;
  return isPlainObject$3(C) && isPlainObject$3(e) && Object.keys(e).forEach((V) => {
    /* @__PURE__ */ React$1.isValidElement(e[V]) ? $[V] = e[V] : isPlainObject$3(e[V]) && // Avoid prototype pollution
    Object.prototype.hasOwnProperty.call(C, V) && isPlainObject$3(C[V]) ? $[V] = deepmerge$1(C[V], e[V], T) : T.clone ? $[V] = isPlainObject$3(e[V]) ? deepClone(e[V]) : e[V] : $[V] = e[V];
  }), $;
}
const deepmerge = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: deepmerge$1,
  isPlainObject: isPlainObject$3
}, Symbol.toStringTag, { value: "Module" })), require$$4$2 = /* @__PURE__ */ getAugmentedNamespace(deepmerge);
function formatMuiErrorMessage$1(C) {
  let e = "https://mui.com/production-error/?code=" + C;
  for (let T = 1; T < arguments.length; T += 1)
    e += "&args[]=" + encodeURIComponent(arguments[T]);
  return "Minified MUI error #" + C + "; visit " + e + " for the full message.";
}
const formatMuiErrorMessage = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: formatMuiErrorMessage$1
}, Symbol.toStringTag, { value: "Module" }));
function capitalize$3(C) {
  if (typeof C != "string")
    throw new Error(dist$2.process.env.NODE_ENV !== "production" ? "MUI: `capitalize(string)` expects a string argument." : formatMuiErrorMessage$1(7));
  return C.charAt(0).toUpperCase() + C.slice(1);
}
const capitalize$2 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: capitalize$3
}, Symbol.toStringTag, { value: "Module" })), require$$5$1 = /* @__PURE__ */ getAugmentedNamespace(capitalize$2);
var reactIs = { exports: {} }, reactIs_production = {};
/**
 * @license React
 * react-is.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredReactIs_production;
function requireReactIs_production() {
  if (hasRequiredReactIs_production) return reactIs_production;
  hasRequiredReactIs_production = 1;
  var C = Symbol.for("react.transitional.element"), e = Symbol.for("react.portal"), T = Symbol.for("react.fragment"), $ = Symbol.for("react.strict_mode"), V = Symbol.for("react.profiler"), J = Symbol.for("react.consumer"), ee = Symbol.for("react.context"), te = Symbol.for("react.forward_ref"), re = Symbol.for("react.suspense"), ie = Symbol.for("react.suspense_list"), se = Symbol.for("react.memo"), de = Symbol.for("react.lazy"), ue = Symbol.for("react.offscreen"), fe = Symbol.for("react.client.reference");
  function he(me) {
    if (typeof me == "object" && me !== null) {
      var xe = me.$$typeof;
      switch (xe) {
        case C:
          switch (me = me.type, me) {
            case T:
            case V:
            case $:
            case re:
            case ie:
              return me;
            default:
              switch (me = me && me.$$typeof, me) {
                case ee:
                case te:
                case de:
                case se:
                  return me;
                case J:
                  return me;
                default:
                  return xe;
              }
          }
        case e:
          return xe;
      }
    }
  }
  return reactIs_production.ContextConsumer = J, reactIs_production.ContextProvider = ee, reactIs_production.Element = C, reactIs_production.ForwardRef = te, reactIs_production.Fragment = T, reactIs_production.Lazy = de, reactIs_production.Memo = se, reactIs_production.Portal = e, reactIs_production.Profiler = V, reactIs_production.StrictMode = $, reactIs_production.Suspense = re, reactIs_production.SuspenseList = ie, reactIs_production.isContextConsumer = function(me) {
    return he(me) === J;
  }, reactIs_production.isContextProvider = function(me) {
    return he(me) === ee;
  }, reactIs_production.isElement = function(me) {
    return typeof me == "object" && me !== null && me.$$typeof === C;
  }, reactIs_production.isForwardRef = function(me) {
    return he(me) === te;
  }, reactIs_production.isFragment = function(me) {
    return he(me) === T;
  }, reactIs_production.isLazy = function(me) {
    return he(me) === de;
  }, reactIs_production.isMemo = function(me) {
    return he(me) === se;
  }, reactIs_production.isPortal = function(me) {
    return he(me) === e;
  }, reactIs_production.isProfiler = function(me) {
    return he(me) === V;
  }, reactIs_production.isStrictMode = function(me) {
    return he(me) === $;
  }, reactIs_production.isSuspense = function(me) {
    return he(me) === re;
  }, reactIs_production.isSuspenseList = function(me) {
    return he(me) === ie;
  }, reactIs_production.isValidElementType = function(me) {
    return typeof me == "string" || typeof me == "function" || me === T || me === V || me === $ || me === re || me === ie || me === ue || typeof me == "object" && me !== null && (me.$$typeof === de || me.$$typeof === se || me.$$typeof === ee || me.$$typeof === J || me.$$typeof === te || me.$$typeof === fe || me.getModuleId !== void 0);
  }, reactIs_production.typeOf = he, reactIs_production;
}
var reactIs_development$1 = {}, hasRequiredReactIs_development$1;
function requireReactIs_development$1() {
  return hasRequiredReactIs_development$1 || (hasRequiredReactIs_development$1 = 1, dist$2.process.env.NODE_ENV !== "production" && function() {
    function C(me) {
      if (typeof me == "object" && me !== null) {
        var xe = me.$$typeof;
        switch (xe) {
          case e:
            switch (me = me.type, me) {
              case $:
              case J:
              case V:
              case ie:
              case se:
                return me;
              default:
                switch (me = me && me.$$typeof, me) {
                  case te:
                  case re:
                  case ue:
                  case de:
                    return me;
                  case ee:
                    return me;
                  default:
                    return xe;
                }
            }
          case T:
            return xe;
        }
      }
    }
    var e = Symbol.for("react.transitional.element"), T = Symbol.for("react.portal"), $ = Symbol.for("react.fragment"), V = Symbol.for("react.strict_mode"), J = Symbol.for("react.profiler"), ee = Symbol.for("react.consumer"), te = Symbol.for("react.context"), re = Symbol.for("react.forward_ref"), ie = Symbol.for("react.suspense"), se = Symbol.for("react.suspense_list"), de = Symbol.for("react.memo"), ue = Symbol.for("react.lazy"), fe = Symbol.for("react.offscreen"), he = Symbol.for("react.client.reference");
    reactIs_development$1.ContextConsumer = ee, reactIs_development$1.ContextProvider = te, reactIs_development$1.Element = e, reactIs_development$1.ForwardRef = re, reactIs_development$1.Fragment = $, reactIs_development$1.Lazy = ue, reactIs_development$1.Memo = de, reactIs_development$1.Portal = T, reactIs_development$1.Profiler = J, reactIs_development$1.StrictMode = V, reactIs_development$1.Suspense = ie, reactIs_development$1.SuspenseList = se, reactIs_development$1.isContextConsumer = function(me) {
      return C(me) === ee;
    }, reactIs_development$1.isContextProvider = function(me) {
      return C(me) === te;
    }, reactIs_development$1.isElement = function(me) {
      return typeof me == "object" && me !== null && me.$$typeof === e;
    }, reactIs_development$1.isForwardRef = function(me) {
      return C(me) === re;
    }, reactIs_development$1.isFragment = function(me) {
      return C(me) === $;
    }, reactIs_development$1.isLazy = function(me) {
      return C(me) === ue;
    }, reactIs_development$1.isMemo = function(me) {
      return C(me) === de;
    }, reactIs_development$1.isPortal = function(me) {
      return C(me) === T;
    }, reactIs_development$1.isProfiler = function(me) {
      return C(me) === J;
    }, reactIs_development$1.isStrictMode = function(me) {
      return C(me) === V;
    }, reactIs_development$1.isSuspense = function(me) {
      return C(me) === ie;
    }, reactIs_development$1.isSuspenseList = function(me) {
      return C(me) === se;
    }, reactIs_development$1.isValidElementType = function(me) {
      return typeof me == "string" || typeof me == "function" || me === $ || me === J || me === V || me === ie || me === se || me === fe || typeof me == "object" && me !== null && (me.$$typeof === ue || me.$$typeof === de || me.$$typeof === te || me.$$typeof === ee || me.$$typeof === re || me.$$typeof === he || me.getModuleId !== void 0);
    }, reactIs_development$1.typeOf = C;
  }()), reactIs_development$1;
}
dist$2.process.env.NODE_ENV === "production" ? reactIs.exports = requireReactIs_production() : reactIs.exports = requireReactIs_development$1();
var reactIsExports = reactIs.exports;
const fnNameMatchRegex = /^\s*function(?:\s|\s*\/\*.*\*\/\s*)+([^(\s/]*)\s*/;
function getFunctionName(C) {
  const e = `${C}`.match(fnNameMatchRegex);
  return e && e[1] || "";
}
function getFunctionComponentName(C, e = "") {
  return C.displayName || C.name || getFunctionName(C) || e;
}
function getWrappedName(C, e, T) {
  const $ = getFunctionComponentName(e);
  return C.displayName || ($ !== "" ? `${T}(${$})` : T);
}
function getDisplayName$2(C) {
  if (C != null) {
    if (typeof C == "string")
      return C;
    if (typeof C == "function")
      return getFunctionComponentName(C, "Component");
    if (typeof C == "object")
      switch (C.$$typeof) {
        case reactIsExports.ForwardRef:
          return getWrappedName(C, C.render, "ForwardRef");
        case reactIsExports.Memo:
          return getWrappedName(C, C.type, "memo");
        default:
          return;
      }
  }
}
const getDisplayName$1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: getDisplayName$2,
  getFunctionName
}, Symbol.toStringTag, { value: "Module" })), require$$6$1 = /* @__PURE__ */ getAugmentedNamespace(getDisplayName$1);
function _objectWithoutPropertiesLoose(C, e) {
  if (C == null) return {};
  var T = {};
  for (var $ in C) if ({}.hasOwnProperty.call(C, $)) {
    if (e.includes($)) continue;
    T[$] = C[$];
  }
  return T;
}
const _excluded$14 = ["values", "unit", "step"], sortBreakpointsValues = (C) => {
  const e = Object.keys(C).map((T) => ({
    key: T,
    val: C[T]
  })) || [];
  return e.sort((T, $) => T.val - $.val), e.reduce((T, $) => _extends({}, T, {
    [$.key]: $.val
  }), {});
};
function createBreakpoints(C) {
  const {
    // The breakpoint **start** at this value.
    // For instance with the first breakpoint xs: [xs, sm).
    values: e = {
      xs: 0,
      // phone
      sm: 600,
      // tablet
      md: 900,
      // small laptop
      lg: 1200,
      // desktop
      xl: 1536
      // large screen
    },
    unit: T = "px",
    step: $ = 5
  } = C, V = _objectWithoutPropertiesLoose(C, _excluded$14), J = sortBreakpointsValues(e), ee = Object.keys(J);
  function te(ue) {
    return `@media (min-width:${typeof e[ue] == "number" ? e[ue] : ue}${T})`;
  }
  function re(ue) {
    return `@media (max-width:${(typeof e[ue] == "number" ? e[ue] : ue) - $ / 100}${T})`;
  }
  function ie(ue, fe) {
    const he = ee.indexOf(fe);
    return `@media (min-width:${typeof e[ue] == "number" ? e[ue] : ue}${T}) and (max-width:${(he !== -1 && typeof e[ee[he]] == "number" ? e[ee[he]] : fe) - $ / 100}${T})`;
  }
  function se(ue) {
    return ee.indexOf(ue) + 1 < ee.length ? ie(ue, ee[ee.indexOf(ue) + 1]) : te(ue);
  }
  function de(ue) {
    const fe = ee.indexOf(ue);
    return fe === 0 ? te(ee[1]) : fe === ee.length - 1 ? re(ee[fe]) : ie(ue, ee[ee.indexOf(ue) + 1]).replace("@media", "@media not all and");
  }
  return _extends({
    keys: ee,
    values: J,
    up: te,
    down: re,
    between: ie,
    only: se,
    not: de,
    unit: T
  }, V);
}
const shape = {
  borderRadius: 4
}, responsivePropType = dist$2.process.env.NODE_ENV !== "production" ? PropTypes.oneOfType([PropTypes.number, PropTypes.string, PropTypes.object, PropTypes.array]) : {};
function merge$1(C, e) {
  return e ? deepmerge$1(C, e, {
    clone: !1
    // No need to clone deep, it's way faster.
  }) : C;
}
const values$1 = {
  xs: 0,
  // phone
  sm: 600,
  // tablet
  md: 900,
  // small laptop
  lg: 1200,
  // desktop
  xl: 1536
  // large screen
}, defaultBreakpoints = {
  // Sorted ASC by size. That's important.
  // It can't be configured as it's used statically for propTypes.
  keys: ["xs", "sm", "md", "lg", "xl"],
  up: (C) => `@media (min-width:${values$1[C]}px)`
};
function handleBreakpoints(C, e, T) {
  const $ = C.theme || {};
  if (Array.isArray(e)) {
    const J = $.breakpoints || defaultBreakpoints;
    return e.reduce((ee, te, re) => (ee[J.up(J.keys[re])] = T(e[re]), ee), {});
  }
  if (typeof e == "object") {
    const J = $.breakpoints || defaultBreakpoints;
    return Object.keys(e).reduce((ee, te) => {
      if (Object.keys(J.values || values$1).indexOf(te) !== -1) {
        const re = J.up(te);
        ee[re] = T(e[te], te);
      } else {
        const re = te;
        ee[re] = e[re];
      }
      return ee;
    }, {});
  }
  return T(e);
}
function createEmptyBreakpointObject(C = {}) {
  var e;
  return ((e = C.keys) == null ? void 0 : e.reduce(($, V) => {
    const J = C.up(V);
    return $[J] = {}, $;
  }, {})) || {};
}
function removeUnusedBreakpoints(C, e) {
  return C.reduce((T, $) => {
    const V = T[$];
    return (!V || Object.keys(V).length === 0) && delete T[$], T;
  }, e);
}
function mergeBreakpointsInOrder(C, ...e) {
  const T = createEmptyBreakpointObject(C), $ = [T, ...e].reduce((V, J) => deepmerge$1(V, J), {});
  return removeUnusedBreakpoints(Object.keys(T), $);
}
function computeBreakpointsBase(C, e) {
  if (typeof C != "object")
    return {};
  const T = {}, $ = Object.keys(e);
  return Array.isArray(C) ? $.forEach((V, J) => {
    J < C.length && (T[V] = !0);
  }) : $.forEach((V) => {
    C[V] != null && (T[V] = !0);
  }), T;
}
function resolveBreakpointValues({
  values: C,
  breakpoints: e,
  base: T
}) {
  const $ = T || computeBreakpointsBase(C, e), V = Object.keys($);
  if (V.length === 0)
    return C;
  let J;
  return V.reduce((ee, te, re) => (Array.isArray(C) ? (ee[te] = C[re] != null ? C[re] : C[J], J = re) : typeof C == "object" ? (ee[te] = C[te] != null ? C[te] : C[J], J = te) : ee[te] = C, ee), {});
}
function getPath(C, e, T = !0) {
  if (!e || typeof e != "string")
    return null;
  if (C && C.vars && T) {
    const $ = `vars.${e}`.split(".").reduce((V, J) => V && V[J] ? V[J] : null, C);
    if ($ != null)
      return $;
  }
  return e.split(".").reduce(($, V) => $ && $[V] != null ? $[V] : null, C);
}
function getStyleValue$1(C, e, T, $ = T) {
  let V;
  return typeof C == "function" ? V = C(T) : Array.isArray(C) ? V = C[T] || $ : V = getPath(C, T) || $, e && (V = e(V, $, C)), V;
}
function style$2(C) {
  const {
    prop: e,
    cssProperty: T = C.prop,
    themeKey: $,
    transform: V
  } = C, J = (ee) => {
    if (ee[e] == null)
      return null;
    const te = ee[e], re = ee.theme, ie = getPath(re, $) || {};
    return handleBreakpoints(ee, te, (de) => {
      let ue = getStyleValue$1(ie, V, de);
      return de === ue && typeof de == "string" && (ue = getStyleValue$1(ie, V, `${e}${de === "default" ? "" : capitalize$3(de)}`, de)), T === !1 ? ue : {
        [T]: ue
      };
    });
  };
  return J.propTypes = dist$2.process.env.NODE_ENV !== "production" ? {
    [e]: responsivePropType
  } : {}, J.filterProps = [e], J;
}
function memoize(C) {
  const e = {};
  return (T) => (e[T] === void 0 && (e[T] = C(T)), e[T]);
}
const properties = {
  m: "margin",
  p: "padding"
}, directions = {
  t: "Top",
  r: "Right",
  b: "Bottom",
  l: "Left",
  x: ["Left", "Right"],
  y: ["Top", "Bottom"]
}, aliases = {
  marginX: "mx",
  marginY: "my",
  paddingX: "px",
  paddingY: "py"
}, getCssProperties = memoize((C) => {
  if (C.length > 2)
    if (aliases[C])
      C = aliases[C];
    else
      return [C];
  const [e, T] = C.split(""), $ = properties[e], V = directions[T] || "";
  return Array.isArray(V) ? V.map((J) => $ + J) : [$ + V];
}), marginKeys = ["m", "mt", "mr", "mb", "ml", "mx", "my", "margin", "marginTop", "marginRight", "marginBottom", "marginLeft", "marginX", "marginY", "marginInline", "marginInlineStart", "marginInlineEnd", "marginBlock", "marginBlockStart", "marginBlockEnd"], paddingKeys = ["p", "pt", "pr", "pb", "pl", "px", "py", "padding", "paddingTop", "paddingRight", "paddingBottom", "paddingLeft", "paddingX", "paddingY", "paddingInline", "paddingInlineStart", "paddingInlineEnd", "paddingBlock", "paddingBlockStart", "paddingBlockEnd"], spacingKeys = [...marginKeys, ...paddingKeys];
function createUnaryUnit(C, e, T, $) {
  var V;
  const J = (V = getPath(C, e, !1)) != null ? V : T;
  return typeof J == "number" ? (ee) => typeof ee == "string" ? ee : (dist$2.process.env.NODE_ENV !== "production" && typeof ee != "number" && console.error(`MUI: Expected ${$} argument to be a number or a string, got ${ee}.`), J * ee) : Array.isArray(J) ? (ee) => typeof ee == "string" ? ee : (dist$2.process.env.NODE_ENV !== "production" && (Number.isInteger(ee) ? ee > J.length - 1 && console.error([`MUI: The value provided (${ee}) overflows.`, `The supported values are: ${JSON.stringify(J)}.`, `${ee} > ${J.length - 1}, you need to add the missing values.`].join(`
`)) : console.error([`MUI: The \`theme.${e}\` array type cannot be combined with non integer values.You should either use an integer value that can be used as index, or define the \`theme.${e}\` as a number.`].join(`
`))), J[ee]) : typeof J == "function" ? J : (dist$2.process.env.NODE_ENV !== "production" && console.error([`MUI: The \`theme.${e}\` value (${J}) is invalid.`, "It should be a number, an array or a function."].join(`
`)), () => {
  });
}
function createUnarySpacing(C) {
  return createUnaryUnit(C, "spacing", 8, "spacing");
}
function getValue$2(C, e) {
  if (typeof e == "string" || e == null)
    return e;
  const T = Math.abs(e), $ = C(T);
  return e >= 0 ? $ : typeof $ == "number" ? -$ : `-${$}`;
}
function getStyleFromPropValue(C, e) {
  return (T) => C.reduce(($, V) => ($[V] = getValue$2(e, T), $), {});
}
function resolveCssProperty(C, e, T, $) {
  if (e.indexOf(T) === -1)
    return null;
  const V = getCssProperties(T), J = getStyleFromPropValue(V, $), ee = C[T];
  return handleBreakpoints(C, ee, J);
}
function style$1(C, e) {
  const T = createUnarySpacing(C.theme);
  return Object.keys(C).map(($) => resolveCssProperty(C, e, $, T)).reduce(merge$1, {});
}
function margin(C) {
  return style$1(C, marginKeys);
}
margin.propTypes = dist$2.process.env.NODE_ENV !== "production" ? marginKeys.reduce((C, e) => (C[e] = responsivePropType, C), {}) : {};
margin.filterProps = marginKeys;
function padding$2(C) {
  return style$1(C, paddingKeys);
}
padding$2.propTypes = dist$2.process.env.NODE_ENV !== "production" ? paddingKeys.reduce((C, e) => (C[e] = responsivePropType, C), {}) : {};
padding$2.filterProps = paddingKeys;
dist$2.process.env.NODE_ENV !== "production" && spacingKeys.reduce((C, e) => (C[e] = responsivePropType, C), {});
function createSpacing(C = 8) {
  if (C.mui)
    return C;
  const e = createUnarySpacing({
    spacing: C
  }), T = (...$) => (dist$2.process.env.NODE_ENV !== "production" && ($.length <= 4 || console.error(`MUI: Too many arguments provided, expected between 0 and 4, got ${$.length}`)), ($.length === 0 ? [1] : $).map((J) => {
    const ee = e(J);
    return typeof ee == "number" ? `${ee}px` : ee;
  }).join(" "));
  return T.mui = !0, T;
}
function compose$1(...C) {
  const e = C.reduce(($, V) => (V.filterProps.forEach((J) => {
    $[J] = V;
  }), $), {}), T = ($) => Object.keys($).reduce((V, J) => e[J] ? merge$1(V, e[J]($)) : V, {});
  return T.propTypes = dist$2.process.env.NODE_ENV !== "production" ? C.reduce(($, V) => Object.assign($, V.propTypes), {}) : {}, T.filterProps = C.reduce(($, V) => $.concat(V.filterProps), []), T;
}
function borderTransform(C) {
  return typeof C != "number" ? C : `${C}px solid`;
}
function createBorderStyle(C, e) {
  return style$2({
    prop: C,
    themeKey: "borders",
    transform: e
  });
}
const border = createBorderStyle("border", borderTransform), borderTop = createBorderStyle("borderTop", borderTransform), borderRight = createBorderStyle("borderRight", borderTransform), borderBottom = createBorderStyle("borderBottom", borderTransform), borderLeft = createBorderStyle("borderLeft", borderTransform), borderColor = createBorderStyle("borderColor"), borderTopColor = createBorderStyle("borderTopColor"), borderRightColor = createBorderStyle("borderRightColor"), borderBottomColor = createBorderStyle("borderBottomColor"), borderLeftColor = createBorderStyle("borderLeftColor"), outline = createBorderStyle("outline", borderTransform), outlineColor = createBorderStyle("outlineColor"), borderRadius = (C) => {
  if (C.borderRadius !== void 0 && C.borderRadius !== null) {
    const e = createUnaryUnit(C.theme, "shape.borderRadius", 4, "borderRadius"), T = ($) => ({
      borderRadius: getValue$2(e, $)
    });
    return handleBreakpoints(C, C.borderRadius, T);
  }
  return null;
};
borderRadius.propTypes = dist$2.process.env.NODE_ENV !== "production" ? {
  borderRadius: responsivePropType
} : {};
borderRadius.filterProps = ["borderRadius"];
compose$1(border, borderTop, borderRight, borderBottom, borderLeft, borderColor, borderTopColor, borderRightColor, borderBottomColor, borderLeftColor, borderRadius, outline, outlineColor);
const gap = (C) => {
  if (C.gap !== void 0 && C.gap !== null) {
    const e = createUnaryUnit(C.theme, "spacing", 8, "gap"), T = ($) => ({
      gap: getValue$2(e, $)
    });
    return handleBreakpoints(C, C.gap, T);
  }
  return null;
};
gap.propTypes = dist$2.process.env.NODE_ENV !== "production" ? {
  gap: responsivePropType
} : {};
gap.filterProps = ["gap"];
const columnGap = (C) => {
  if (C.columnGap !== void 0 && C.columnGap !== null) {
    const e = createUnaryUnit(C.theme, "spacing", 8, "columnGap"), T = ($) => ({
      columnGap: getValue$2(e, $)
    });
    return handleBreakpoints(C, C.columnGap, T);
  }
  return null;
};
columnGap.propTypes = dist$2.process.env.NODE_ENV !== "production" ? {
  columnGap: responsivePropType
} : {};
columnGap.filterProps = ["columnGap"];
const rowGap = (C) => {
  if (C.rowGap !== void 0 && C.rowGap !== null) {
    const e = createUnaryUnit(C.theme, "spacing", 8, "rowGap"), T = ($) => ({
      rowGap: getValue$2(e, $)
    });
    return handleBreakpoints(C, C.rowGap, T);
  }
  return null;
};
rowGap.propTypes = dist$2.process.env.NODE_ENV !== "production" ? {
  rowGap: responsivePropType
} : {};
rowGap.filterProps = ["rowGap"];
const gridColumn = style$2({
  prop: "gridColumn"
}), gridRow = style$2({
  prop: "gridRow"
}), gridAutoFlow = style$2({
  prop: "gridAutoFlow"
}), gridAutoColumns = style$2({
  prop: "gridAutoColumns"
}), gridAutoRows = style$2({
  prop: "gridAutoRows"
}), gridTemplateColumns = style$2({
  prop: "gridTemplateColumns"
}), gridTemplateRows = style$2({
  prop: "gridTemplateRows"
}), gridTemplateAreas = style$2({
  prop: "gridTemplateAreas"
}), gridArea = style$2({
  prop: "gridArea"
});
compose$1(gap, columnGap, rowGap, gridColumn, gridRow, gridAutoFlow, gridAutoColumns, gridAutoRows, gridTemplateColumns, gridTemplateRows, gridTemplateAreas, gridArea);
function paletteTransform(C, e) {
  return e === "grey" ? e : C;
}
const color = style$2({
  prop: "color",
  themeKey: "palette",
  transform: paletteTransform
}), bgcolor = style$2({
  prop: "bgcolor",
  cssProperty: "backgroundColor",
  themeKey: "palette",
  transform: paletteTransform
}), backgroundColor = style$2({
  prop: "backgroundColor",
  themeKey: "palette",
  transform: paletteTransform
});
compose$1(color, bgcolor, backgroundColor);
function sizingTransform(C) {
  return C <= 1 && C !== 0 ? `${C * 100}%` : C;
}
const width = style$2({
  prop: "width",
  transform: sizingTransform
}), maxWidth = (C) => {
  if (C.maxWidth !== void 0 && C.maxWidth !== null) {
    const e = (T) => {
      var $, V;
      const J = (($ = C.theme) == null || ($ = $.breakpoints) == null || ($ = $.values) == null ? void 0 : $[T]) || values$1[T];
      return J ? ((V = C.theme) == null || (V = V.breakpoints) == null ? void 0 : V.unit) !== "px" ? {
        maxWidth: `${J}${C.theme.breakpoints.unit}`
      } : {
        maxWidth: J
      } : {
        maxWidth: sizingTransform(T)
      };
    };
    return handleBreakpoints(C, C.maxWidth, e);
  }
  return null;
};
maxWidth.filterProps = ["maxWidth"];
const minWidth = style$2({
  prop: "minWidth",
  transform: sizingTransform
}), height = style$2({
  prop: "height",
  transform: sizingTransform
}), maxHeight = style$2({
  prop: "maxHeight",
  transform: sizingTransform
}), minHeight = style$2({
  prop: "minHeight",
  transform: sizingTransform
});
style$2({
  prop: "size",
  cssProperty: "width",
  transform: sizingTransform
});
style$2({
  prop: "size",
  cssProperty: "height",
  transform: sizingTransform
});
const boxSizing = style$2({
  prop: "boxSizing"
});
compose$1(width, maxWidth, minWidth, height, maxHeight, minHeight, boxSizing);
const defaultSxConfig = {
  // borders
  border: {
    themeKey: "borders",
    transform: borderTransform
  },
  borderTop: {
    themeKey: "borders",
    transform: borderTransform
  },
  borderRight: {
    themeKey: "borders",
    transform: borderTransform
  },
  borderBottom: {
    themeKey: "borders",
    transform: borderTransform
  },
  borderLeft: {
    themeKey: "borders",
    transform: borderTransform
  },
  borderColor: {
    themeKey: "palette"
  },
  borderTopColor: {
    themeKey: "palette"
  },
  borderRightColor: {
    themeKey: "palette"
  },
  borderBottomColor: {
    themeKey: "palette"
  },
  borderLeftColor: {
    themeKey: "palette"
  },
  outline: {
    themeKey: "borders",
    transform: borderTransform
  },
  outlineColor: {
    themeKey: "palette"
  },
  borderRadius: {
    themeKey: "shape.borderRadius",
    style: borderRadius
  },
  // palette
  color: {
    themeKey: "palette",
    transform: paletteTransform
  },
  bgcolor: {
    themeKey: "palette",
    cssProperty: "backgroundColor",
    transform: paletteTransform
  },
  backgroundColor: {
    themeKey: "palette",
    transform: paletteTransform
  },
  // spacing
  p: {
    style: padding$2
  },
  pt: {
    style: padding$2
  },
  pr: {
    style: padding$2
  },
  pb: {
    style: padding$2
  },
  pl: {
    style: padding$2
  },
  px: {
    style: padding$2
  },
  py: {
    style: padding$2
  },
  padding: {
    style: padding$2
  },
  paddingTop: {
    style: padding$2
  },
  paddingRight: {
    style: padding$2
  },
  paddingBottom: {
    style: padding$2
  },
  paddingLeft: {
    style: padding$2
  },
  paddingX: {
    style: padding$2
  },
  paddingY: {
    style: padding$2
  },
  paddingInline: {
    style: padding$2
  },
  paddingInlineStart: {
    style: padding$2
  },
  paddingInlineEnd: {
    style: padding$2
  },
  paddingBlock: {
    style: padding$2
  },
  paddingBlockStart: {
    style: padding$2
  },
  paddingBlockEnd: {
    style: padding$2
  },
  m: {
    style: margin
  },
  mt: {
    style: margin
  },
  mr: {
    style: margin
  },
  mb: {
    style: margin
  },
  ml: {
    style: margin
  },
  mx: {
    style: margin
  },
  my: {
    style: margin
  },
  margin: {
    style: margin
  },
  marginTop: {
    style: margin
  },
  marginRight: {
    style: margin
  },
  marginBottom: {
    style: margin
  },
  marginLeft: {
    style: margin
  },
  marginX: {
    style: margin
  },
  marginY: {
    style: margin
  },
  marginInline: {
    style: margin
  },
  marginInlineStart: {
    style: margin
  },
  marginInlineEnd: {
    style: margin
  },
  marginBlock: {
    style: margin
  },
  marginBlockStart: {
    style: margin
  },
  marginBlockEnd: {
    style: margin
  },
  // display
  displayPrint: {
    cssProperty: !1,
    transform: (C) => ({
      "@media print": {
        display: C
      }
    })
  },
  display: {},
  overflow: {},
  textOverflow: {},
  visibility: {},
  whiteSpace: {},
  // flexbox
  flexBasis: {},
  flexDirection: {},
  flexWrap: {},
  justifyContent: {},
  alignItems: {},
  alignContent: {},
  order: {},
  flex: {},
  flexGrow: {},
  flexShrink: {},
  alignSelf: {},
  justifyItems: {},
  justifySelf: {},
  // grid
  gap: {
    style: gap
  },
  rowGap: {
    style: rowGap
  },
  columnGap: {
    style: columnGap
  },
  gridColumn: {},
  gridRow: {},
  gridAutoFlow: {},
  gridAutoColumns: {},
  gridAutoRows: {},
  gridTemplateColumns: {},
  gridTemplateRows: {},
  gridTemplateAreas: {},
  gridArea: {},
  // positions
  position: {},
  zIndex: {
    themeKey: "zIndex"
  },
  top: {},
  right: {},
  bottom: {},
  left: {},
  // shadows
  boxShadow: {
    themeKey: "shadows"
  },
  // sizing
  width: {
    transform: sizingTransform
  },
  maxWidth: {
    style: maxWidth
  },
  minWidth: {
    transform: sizingTransform
  },
  height: {
    transform: sizingTransform
  },
  maxHeight: {
    transform: sizingTransform
  },
  minHeight: {
    transform: sizingTransform
  },
  boxSizing: {},
  // typography
  fontFamily: {
    themeKey: "typography"
  },
  fontSize: {
    themeKey: "typography"
  },
  fontStyle: {
    themeKey: "typography"
  },
  fontWeight: {
    themeKey: "typography"
  },
  letterSpacing: {},
  textTransform: {},
  lineHeight: {},
  textAlign: {},
  typography: {
    cssProperty: !1,
    themeKey: "typography"
  }
};
function objectsHaveSameKeys(...C) {
  const e = C.reduce(($, V) => $.concat(Object.keys(V)), []), T = new Set(e);
  return C.every(($) => T.size === Object.keys($).length);
}
function callIfFn(C, e) {
  return typeof C == "function" ? C(e) : C;
}
function unstable_createStyleFunctionSx() {
  function C(T, $, V, J) {
    const ee = {
      [T]: $,
      theme: V
    }, te = J[T];
    if (!te)
      return {
        [T]: $
      };
    const {
      cssProperty: re = T,
      themeKey: ie,
      transform: se,
      style: de
    } = te;
    if ($ == null)
      return null;
    if (ie === "typography" && $ === "inherit")
      return {
        [T]: $
      };
    const ue = getPath(V, ie) || {};
    return de ? de(ee) : handleBreakpoints(ee, $, (he) => {
      let me = getStyleValue$1(ue, se, he);
      return he === me && typeof he == "string" && (me = getStyleValue$1(ue, se, `${T}${he === "default" ? "" : capitalize$3(he)}`, he)), re === !1 ? me : {
        [re]: me
      };
    });
  }
  function e(T) {
    var $;
    const {
      sx: V,
      theme: J = {}
    } = T || {};
    if (!V)
      return null;
    const ee = ($ = J.unstable_sxConfig) != null ? $ : defaultSxConfig;
    function te(re) {
      let ie = re;
      if (typeof re == "function")
        ie = re(J);
      else if (typeof re != "object")
        return re;
      if (!ie)
        return null;
      const se = createEmptyBreakpointObject(J.breakpoints), de = Object.keys(se);
      let ue = se;
      return Object.keys(ie).forEach((fe) => {
        const he = callIfFn(ie[fe], J);
        if (he != null)
          if (typeof he == "object")
            if (ee[fe])
              ue = merge$1(ue, C(fe, he, J, ee));
            else {
              const me = handleBreakpoints({
                theme: J
              }, he, (xe) => ({
                [fe]: xe
              }));
              objectsHaveSameKeys(me, he) ? ue[fe] = e({
                sx: he,
                theme: J
              }) : ue = merge$1(ue, me);
            }
          else
            ue = merge$1(ue, C(fe, he, J, ee));
      }), removeUnusedBreakpoints(de, ue);
    }
    return Array.isArray(V) ? V.map(te) : te(V);
  }
  return e;
}
const styleFunctionSx$1 = unstable_createStyleFunctionSx();
styleFunctionSx$1.filterProps = ["sx"];
function applyStyles$2(C, e) {
  const T = this;
  return T.vars && typeof T.getColorSchemeSelector == "function" ? {
    [T.getColorSchemeSelector(C).replace(/(\[[^\]]+\])/, "*:where($1)")]: e
  } : T.palette.mode === C ? e : {};
}
const _excluded$13 = ["breakpoints", "palette", "spacing", "shape"];
function createTheme$2(C = {}, ...e) {
  const {
    breakpoints: T = {},
    palette: $ = {},
    spacing: V,
    shape: J = {}
  } = C, ee = _objectWithoutPropertiesLoose(C, _excluded$13), te = createBreakpoints(T), re = createSpacing(V);
  let ie = deepmerge$1({
    breakpoints: te,
    direction: "ltr",
    components: {},
    // Inject component definitions.
    palette: _extends({
      mode: "light"
    }, $),
    spacing: re,
    shape: _extends({}, shape, J)
  }, ee);
  return ie.applyStyles = applyStyles$2, ie = e.reduce((se, de) => deepmerge$1(se, de), ie), ie.unstable_sxConfig = _extends({}, defaultSxConfig, ee == null ? void 0 : ee.unstable_sxConfig), ie.unstable_sx = function(de) {
    return styleFunctionSx$1({
      sx: de,
      theme: this
    });
  }, ie;
}
const createTheme$1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: createTheme$2,
  private_createBreakpoints: createBreakpoints,
  unstable_applyStyles: applyStyles$2
}, Symbol.toStringTag, { value: "Module" })), require$$7 = /* @__PURE__ */ getAugmentedNamespace(createTheme$1), _excluded$12 = ["sx"], splitProps = (C) => {
  var e, T;
  const $ = {
    systemProps: {},
    otherProps: {}
  }, V = (e = C == null || (T = C.theme) == null ? void 0 : T.unstable_sxConfig) != null ? e : defaultSxConfig;
  return Object.keys(C).forEach((J) => {
    V[J] ? $.systemProps[J] = C[J] : $.otherProps[J] = C[J];
  }), $;
};
function extendSxProp(C) {
  const {
    sx: e
  } = C, T = _objectWithoutPropertiesLoose(C, _excluded$12), {
    systemProps: $,
    otherProps: V
  } = splitProps(T);
  let J;
  return Array.isArray(e) ? J = [$, ...e] : typeof e == "function" ? J = (...ee) => {
    const te = e(...ee);
    return isPlainObject$3(te) ? _extends({}, $, te) : $;
  } : J = _extends({}, $, e), _extends({}, V, {
    sx: J
  });
}
const styleFunctionSx = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: styleFunctionSx$1,
  extendSxProp,
  unstable_createStyleFunctionSx,
  unstable_defaultSxConfig: defaultSxConfig
}, Symbol.toStringTag, { value: "Module" })), require$$8 = /* @__PURE__ */ getAugmentedNamespace(styleFunctionSx);
var _interopRequireDefault$d = interopRequireDefaultExports;
Object.defineProperty(createStyled$3, "__esModule", {
  value: !0
});
var _default = createStyled$3.default = createStyled$1;
createStyled$3.shouldForwardProp = shouldForwardProp$1;
createStyled$3.systemDefaultTheme = void 0;
var _extends2 = _interopRequireDefault$d(require_extends()), _objectWithoutPropertiesLoose2 = _interopRequireDefault$d(requireObjectWithoutPropertiesLoose()), _styledEngine$1 = _interopRequireWildcard$1(require$$1$3), _deepmerge = require$$4$2, _capitalize = _interopRequireDefault$d(require$$5$1), _getDisplayName = _interopRequireDefault$d(require$$6$1), _createTheme = _interopRequireDefault$d(require$$7), _styleFunctionSx = _interopRequireDefault$d(require$$8);
const _excluded$11 = ["ownerState"], _excluded2$7 = ["variants"], _excluded3$2 = ["name", "slot", "skipVariantsResolver", "skipSx", "overridesResolver"];
function _getRequireWildcardCache$1(C) {
  if (typeof WeakMap != "function") return null;
  var e = /* @__PURE__ */ new WeakMap(), T = /* @__PURE__ */ new WeakMap();
  return (_getRequireWildcardCache$1 = function($) {
    return $ ? T : e;
  })(C);
}
function _interopRequireWildcard$1(C, e) {
  if (C && C.__esModule) return C;
  if (C === null || typeof C != "object" && typeof C != "function") return { default: C };
  var T = _getRequireWildcardCache$1(e);
  if (T && T.has(C)) return T.get(C);
  var $ = { __proto__: null }, V = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var J in C) if (J !== "default" && Object.prototype.hasOwnProperty.call(C, J)) {
    var ee = V ? Object.getOwnPropertyDescriptor(C, J) : null;
    ee && (ee.get || ee.set) ? Object.defineProperty($, J, ee) : $[J] = C[J];
  }
  return $.default = C, T && T.set(C, $), $;
}
function isEmpty$3(C) {
  return Object.keys(C).length === 0;
}
function isStringTag$1(C) {
  return typeof C == "string" && // 96 is one less than the char code
  // for "a" so this is checking that
  // it's a lowercase character
  C.charCodeAt(0) > 96;
}
function shouldForwardProp$1(C) {
  return C !== "ownerState" && C !== "theme" && C !== "sx" && C !== "as";
}
const systemDefaultTheme$2 = createStyled$3.systemDefaultTheme = (0, _createTheme.default)(), lowercaseFirstLetter$1 = (C) => C && C.charAt(0).toLowerCase() + C.slice(1);
function resolveTheme$1({
  defaultTheme: C,
  theme: e,
  themeId: T
}) {
  return isEmpty$3(e) ? C : e[T] || e;
}
function defaultOverridesResolver$1(C) {
  return C ? (e, T) => T[C] : null;
}
function processStyleArg$1(C, e) {
  let {
    ownerState: T
  } = e, $ = (0, _objectWithoutPropertiesLoose2.default)(e, _excluded$11);
  const V = typeof C == "function" ? C((0, _extends2.default)({
    ownerState: T
  }, $)) : C;
  if (Array.isArray(V))
    return V.flatMap((J) => processStyleArg$1(J, (0, _extends2.default)({
      ownerState: T
    }, $)));
  if (V && typeof V == "object" && Array.isArray(V.variants)) {
    const {
      variants: J = []
    } = V;
    let te = (0, _objectWithoutPropertiesLoose2.default)(V, _excluded2$7);
    return J.forEach((re) => {
      let ie = !0;
      typeof re.props == "function" ? ie = re.props((0, _extends2.default)({
        ownerState: T
      }, $, T)) : Object.keys(re.props).forEach((se) => {
        (T == null ? void 0 : T[se]) !== re.props[se] && $[se] !== re.props[se] && (ie = !1);
      }), ie && (Array.isArray(te) || (te = [te]), te.push(typeof re.style == "function" ? re.style((0, _extends2.default)({
        ownerState: T
      }, $, T)) : re.style));
    }), te;
  }
  return V;
}
function createStyled$1(C = {}) {
  const {
    themeId: e,
    defaultTheme: T = systemDefaultTheme$2,
    rootShouldForwardProp: $ = shouldForwardProp$1,
    slotShouldForwardProp: V = shouldForwardProp$1
  } = C, J = (ee) => (0, _styleFunctionSx.default)((0, _extends2.default)({}, ee, {
    theme: resolveTheme$1((0, _extends2.default)({}, ee, {
      defaultTheme: T,
      themeId: e
    }))
  }));
  return J.__mui_systemSx = !0, (ee, te = {}) => {
    (0, _styledEngine$1.internal_processStyles)(ee, (Me) => Me.filter((Ie) => !(Ie != null && Ie.__mui_systemSx)));
    const {
      name: re,
      slot: ie,
      skipVariantsResolver: se,
      skipSx: de,
      // TODO v6: remove `lowercaseFirstLetter()` in the next major release
      // For more details: https://github.com/mui/material-ui/pull/37908
      overridesResolver: ue = defaultOverridesResolver$1(lowercaseFirstLetter$1(ie))
    } = te, fe = (0, _objectWithoutPropertiesLoose2.default)(te, _excluded3$2), he = se !== void 0 ? se : (
      // TODO v6: remove `Root` in the next major release
      // For more details: https://github.com/mui/material-ui/pull/37908
      ie && ie !== "Root" && ie !== "root" || !1
    ), me = de || !1;
    let xe;
    dist$2.process.env.NODE_ENV !== "production" && re && (xe = `${re}-${lowercaseFirstLetter$1(ie || "Root")}`);
    let ve = shouldForwardProp$1;
    ie === "Root" || ie === "root" ? ve = $ : ie ? ve = V : isStringTag$1(ee) && (ve = void 0);
    const Te = (0, _styledEngine$1.default)(ee, (0, _extends2.default)({
      shouldForwardProp: ve,
      label: xe
    }, fe)), we = (Me) => typeof Me == "function" && Me.__emotion_real !== Me || (0, _deepmerge.isPlainObject)(Me) ? (Ie) => processStyleArg$1(Me, (0, _extends2.default)({}, Ie, {
      theme: resolveTheme$1({
        theme: Ie.theme,
        defaultTheme: T,
        themeId: e
      })
    })) : Me, Ee = (Me, ...Ie) => {
      let ke = we(Me);
      const _e = Ie ? Ie.map(we) : [];
      re && ue && _e.push((Ae) => {
        const ne = resolveTheme$1((0, _extends2.default)({}, Ae, {
          defaultTheme: T,
          themeId: e
        }));
        if (!ne.components || !ne.components[re] || !ne.components[re].styleOverrides)
          return null;
        const oe = ne.components[re].styleOverrides, ce = {};
        return Object.entries(oe).forEach(([le, pe]) => {
          ce[le] = processStyleArg$1(pe, (0, _extends2.default)({}, Ae, {
            theme: ne
          }));
        }), ue(Ae, ce);
      }), re && !he && _e.push((Ae) => {
        var ne;
        const oe = resolveTheme$1((0, _extends2.default)({}, Ae, {
          defaultTheme: T,
          themeId: e
        })), ce = oe == null || (ne = oe.components) == null || (ne = ne[re]) == null ? void 0 : ne.variants;
        return processStyleArg$1({
          variants: ce
        }, (0, _extends2.default)({}, Ae, {
          theme: oe
        }));
      }), me || _e.push(J);
      const De = _e.length - Ie.length;
      if (Array.isArray(Me) && De > 0) {
        const Ae = new Array(De).fill("");
        ke = [...Me, ...Ae], ke.raw = [...Me.raw, ...Ae];
      }
      const Fe = Te(ke, ..._e);
      if (dist$2.process.env.NODE_ENV !== "production") {
        let Ae;
        re && (Ae = `${re}${(0, _capitalize.default)(ie || "")}`), Ae === void 0 && (Ae = `Styled(${(0, _getDisplayName.default)(ee)})`), Fe.displayName = Ae;
      }
      return ee.muiName && (Fe.muiName = ee.muiName), Fe;
    };
    return Te.withConfig && (Ee.withConfig = Te.withConfig), Ee;
  };
}
const defaultGenerator = (C) => C, createClassNameGenerator = () => {
  let C = defaultGenerator;
  return {
    configure(e) {
      C = e;
    },
    generate(e) {
      return C(e);
    },
    reset() {
      C = defaultGenerator;
    }
  };
}, ClassNameGenerator = createClassNameGenerator(), globalStateClasses = {
  active: "active",
  checked: "checked",
  completed: "completed",
  disabled: "disabled",
  error: "error",
  expanded: "expanded",
  focused: "focused",
  focusVisible: "focusVisible",
  open: "open",
  readOnly: "readOnly",
  required: "required",
  selected: "selected"
};
function generateUtilityClass(C, e, T = "Mui") {
  const $ = globalStateClasses[e];
  return $ ? `${T}-${$}` : `${ClassNameGenerator.generate(C)}-${e}`;
}
function createMixins(C, e) {
  return _extends({
    toolbar: {
      minHeight: 56,
      [C.up("xs")]: {
        "@media (orientation: landscape)": {
          minHeight: 48
        }
      },
      [C.up("sm")]: {
        minHeight: 64
      }
    }
  }, e);
}
var colorManipulator = {};
const require$$1$2 = /* @__PURE__ */ getAugmentedNamespace(formatMuiErrorMessage);
function clamp$1(C, e = Number.MIN_SAFE_INTEGER, T = Number.MAX_SAFE_INTEGER) {
  return Math.max(e, Math.min(C, T));
}
const clamp = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: clamp$1
}, Symbol.toStringTag, { value: "Module" })), require$$2$2 = /* @__PURE__ */ getAugmentedNamespace(clamp);
var _interopRequireDefault$c = interopRequireDefaultExports;
Object.defineProperty(colorManipulator, "__esModule", {
  value: !0
});
var alpha_1 = colorManipulator.alpha = alpha$1;
colorManipulator.blend = blend;
colorManipulator.colorChannel = void 0;
var darken_1 = colorManipulator.darken = darken;
colorManipulator.decomposeColor = decomposeColor$1;
colorManipulator.emphasize = emphasize;
var getContrastRatio_1 = colorManipulator.getContrastRatio = getContrastRatio;
colorManipulator.getLuminance = getLuminance;
colorManipulator.hexToRgb = hexToRgb$1;
colorManipulator.hslToRgb = hslToRgb;
var lighten_1 = colorManipulator.lighten = lighten;
colorManipulator.private_safeAlpha = private_safeAlpha;
colorManipulator.private_safeColorChannel = void 0;
colorManipulator.private_safeDarken = private_safeDarken;
colorManipulator.private_safeEmphasize = private_safeEmphasize;
colorManipulator.private_safeLighten = private_safeLighten;
colorManipulator.recomposeColor = recomposeColor$1;
colorManipulator.rgbToHex = rgbToHex;
var _formatMuiErrorMessage2 = _interopRequireDefault$c(require$$1$2), _clamp = _interopRequireDefault$c(require$$2$2);
function clampWrapper$1(C, e = 0, T = 1) {
  return dist$2.process.env.NODE_ENV !== "production" && (C < e || C > T) && console.error(`MUI: The value provided ${C} is out of range [${e}, ${T}].`), (0, _clamp.default)(C, e, T);
}
function hexToRgb$1(C) {
  C = C.slice(1);
  const e = new RegExp(`.{1,${C.length >= 6 ? 2 : 1}}`, "g");
  let T = C.match(e);
  return T && T[0].length === 1 && (T = T.map(($) => $ + $)), T ? `rgb${T.length === 4 ? "a" : ""}(${T.map(($, V) => V < 3 ? parseInt($, 16) : Math.round(parseInt($, 16) / 255 * 1e3) / 1e3).join(", ")})` : "";
}
function intToHex(C) {
  const e = C.toString(16);
  return e.length === 1 ? `0${e}` : e;
}
function decomposeColor$1(C) {
  if (C.type)
    return C;
  if (C.charAt(0) === "#")
    return decomposeColor$1(hexToRgb$1(C));
  const e = C.indexOf("("), T = C.substring(0, e);
  if (["rgb", "rgba", "hsl", "hsla", "color"].indexOf(T) === -1)
    throw new Error(dist$2.process.env.NODE_ENV !== "production" ? `MUI: Unsupported \`${C}\` color.
The following formats are supported: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color().` : (0, _formatMuiErrorMessage2.default)(9, C));
  let $ = C.substring(e + 1, C.length - 1), V;
  if (T === "color") {
    if ($ = $.split(" "), V = $.shift(), $.length === 4 && $[3].charAt(0) === "/" && ($[3] = $[3].slice(1)), ["srgb", "display-p3", "a98-rgb", "prophoto-rgb", "rec-2020"].indexOf(V) === -1)
      throw new Error(dist$2.process.env.NODE_ENV !== "production" ? `MUI: unsupported \`${V}\` color space.
The following color spaces are supported: srgb, display-p3, a98-rgb, prophoto-rgb, rec-2020.` : (0, _formatMuiErrorMessage2.default)(10, V));
  } else
    $ = $.split(",");
  return $ = $.map((J) => parseFloat(J)), {
    type: T,
    values: $,
    colorSpace: V
  };
}
const colorChannel = (C) => {
  const e = decomposeColor$1(C);
  return e.values.slice(0, 3).map((T, $) => e.type.indexOf("hsl") !== -1 && $ !== 0 ? `${T}%` : T).join(" ");
};
colorManipulator.colorChannel = colorChannel;
const private_safeColorChannel = (C, e) => {
  try {
    return colorChannel(C);
  } catch {
    return e && dist$2.process.env.NODE_ENV !== "production" && console.warn(e), C;
  }
};
colorManipulator.private_safeColorChannel = private_safeColorChannel;
function recomposeColor$1(C) {
  const {
    type: e,
    colorSpace: T
  } = C;
  let {
    values: $
  } = C;
  return e.indexOf("rgb") !== -1 ? $ = $.map((V, J) => J < 3 ? parseInt(V, 10) : V) : e.indexOf("hsl") !== -1 && ($[1] = `${$[1]}%`, $[2] = `${$[2]}%`), e.indexOf("color") !== -1 ? $ = `${T} ${$.join(" ")}` : $ = `${$.join(", ")}`, `${e}(${$})`;
}
function rgbToHex(C) {
  if (C.indexOf("#") === 0)
    return C;
  const {
    values: e
  } = decomposeColor$1(C);
  return `#${e.map((T, $) => intToHex($ === 3 ? Math.round(255 * T) : T)).join("")}`;
}
function hslToRgb(C) {
  C = decomposeColor$1(C);
  const {
    values: e
  } = C, T = e[0], $ = e[1] / 100, V = e[2] / 100, J = $ * Math.min(V, 1 - V), ee = (ie, se = (ie + T / 30) % 12) => V - J * Math.max(Math.min(se - 3, 9 - se, 1), -1);
  let te = "rgb";
  const re = [Math.round(ee(0) * 255), Math.round(ee(8) * 255), Math.round(ee(4) * 255)];
  return C.type === "hsla" && (te += "a", re.push(e[3])), recomposeColor$1({
    type: te,
    values: re
  });
}
function getLuminance(C) {
  C = decomposeColor$1(C);
  let e = C.type === "hsl" || C.type === "hsla" ? decomposeColor$1(hslToRgb(C)).values : C.values;
  return e = e.map((T) => (C.type !== "color" && (T /= 255), T <= 0.03928 ? T / 12.92 : ((T + 0.055) / 1.055) ** 2.4)), Number((0.2126 * e[0] + 0.7152 * e[1] + 0.0722 * e[2]).toFixed(3));
}
function getContrastRatio(C, e) {
  const T = getLuminance(C), $ = getLuminance(e);
  return (Math.max(T, $) + 0.05) / (Math.min(T, $) + 0.05);
}
function alpha$1(C, e) {
  return C = decomposeColor$1(C), e = clampWrapper$1(e), (C.type === "rgb" || C.type === "hsl") && (C.type += "a"), C.type === "color" ? C.values[3] = `/${e}` : C.values[3] = e, recomposeColor$1(C);
}
function private_safeAlpha(C, e, T) {
  try {
    return alpha$1(C, e);
  } catch {
    return T && dist$2.process.env.NODE_ENV !== "production" && console.warn(T), C;
  }
}
function darken(C, e) {
  if (C = decomposeColor$1(C), e = clampWrapper$1(e), C.type.indexOf("hsl") !== -1)
    C.values[2] *= 1 - e;
  else if (C.type.indexOf("rgb") !== -1 || C.type.indexOf("color") !== -1)
    for (let T = 0; T < 3; T += 1)
      C.values[T] *= 1 - e;
  return recomposeColor$1(C);
}
function private_safeDarken(C, e, T) {
  try {
    return darken(C, e);
  } catch {
    return T && dist$2.process.env.NODE_ENV !== "production" && console.warn(T), C;
  }
}
function lighten(C, e) {
  if (C = decomposeColor$1(C), e = clampWrapper$1(e), C.type.indexOf("hsl") !== -1)
    C.values[2] += (100 - C.values[2]) * e;
  else if (C.type.indexOf("rgb") !== -1)
    for (let T = 0; T < 3; T += 1)
      C.values[T] += (255 - C.values[T]) * e;
  else if (C.type.indexOf("color") !== -1)
    for (let T = 0; T < 3; T += 1)
      C.values[T] += (1 - C.values[T]) * e;
  return recomposeColor$1(C);
}
function private_safeLighten(C, e, T) {
  try {
    return lighten(C, e);
  } catch {
    return T && dist$2.process.env.NODE_ENV !== "production" && console.warn(T), C;
  }
}
function emphasize(C, e = 0.15) {
  return getLuminance(C) > 0.5 ? darken(C, e) : lighten(C, e);
}
function private_safeEmphasize(C, e, T) {
  try {
    return emphasize(C, e);
  } catch {
    return T && dist$2.process.env.NODE_ENV !== "production" && console.warn(T), C;
  }
}
function blend(C, e, T, $ = 1) {
  const V = (re, ie) => Math.round((re ** (1 / $) * (1 - T) + ie ** (1 / $) * T) ** $), J = decomposeColor$1(C), ee = decomposeColor$1(e), te = [V(J.values[0], ee.values[0]), V(J.values[1], ee.values[1]), V(J.values[2], ee.values[2])];
  return recomposeColor$1({
    type: "rgb",
    values: te
  });
}
const common$3 = {
  black: "#000",
  white: "#fff"
}, grey = {
  50: "#fafafa",
  100: "#f5f5f5",
  200: "#eeeeee",
  300: "#e0e0e0",
  400: "#bdbdbd",
  500: "#9e9e9e",
  600: "#757575",
  700: "#616161",
  800: "#424242",
  900: "#212121",
  A100: "#f5f5f5",
  A200: "#eeeeee",
  A400: "#bdbdbd",
  A700: "#616161"
}, purple = {
  50: "#f3e5f5",
  100: "#e1bee7",
  200: "#ce93d8",
  300: "#ba68c8",
  400: "#ab47bc",
  500: "#9c27b0",
  600: "#8e24aa",
  700: "#7b1fa2",
  800: "#6a1b9a",
  900: "#4a148c",
  A100: "#ea80fc",
  A200: "#e040fb",
  A400: "#d500f9",
  A700: "#aa00ff"
}, red = {
  50: "#ffebee",
  100: "#ffcdd2",
  200: "#ef9a9a",
  300: "#e57373",
  400: "#ef5350",
  500: "#f44336",
  600: "#e53935",
  700: "#d32f2f",
  800: "#c62828",
  900: "#b71c1c",
  A100: "#ff8a80",
  A200: "#ff5252",
  A400: "#ff1744",
  A700: "#d50000"
}, orange = {
  50: "#fff3e0",
  100: "#ffe0b2",
  200: "#ffcc80",
  300: "#ffb74d",
  400: "#ffa726",
  500: "#ff9800",
  600: "#fb8c00",
  700: "#f57c00",
  800: "#ef6c00",
  900: "#e65100",
  A100: "#ffd180",
  A200: "#ffab40",
  A400: "#ff9100",
  A700: "#ff6d00"
}, blue = {
  50: "#e3f2fd",
  100: "#bbdefb",
  200: "#90caf9",
  300: "#64b5f6",
  400: "#42a5f5",
  500: "#2196f3",
  600: "#1e88e5",
  700: "#1976d2",
  800: "#1565c0",
  900: "#0d47a1",
  A100: "#82b1ff",
  A200: "#448aff",
  A400: "#2979ff",
  A700: "#2962ff"
}, lightBlue = {
  50: "#e1f5fe",
  100: "#b3e5fc",
  200: "#81d4fa",
  300: "#4fc3f7",
  400: "#29b6f6",
  500: "#03a9f4",
  600: "#039be5",
  700: "#0288d1",
  800: "#0277bd",
  900: "#01579b",
  A100: "#80d8ff",
  A200: "#40c4ff",
  A400: "#00b0ff",
  A700: "#0091ea"
}, green = {
  50: "#e8f5e9",
  100: "#c8e6c9",
  200: "#a5d6a7",
  300: "#81c784",
  400: "#66bb6a",
  500: "#4caf50",
  600: "#43a047",
  700: "#388e3c",
  800: "#2e7d32",
  900: "#1b5e20",
  A100: "#b9f6ca",
  A200: "#69f0ae",
  A400: "#00e676",
  A700: "#00c853"
}, _excluded$10 = ["mode", "contrastThreshold", "tonalOffset"], light$1 = {
  // The colors used to style the text.
  text: {
    // The most important text.
    primary: "rgba(0, 0, 0, 0.87)",
    // Secondary text.
    secondary: "rgba(0, 0, 0, 0.6)",
    // Disabled text have even lower visual prominence.
    disabled: "rgba(0, 0, 0, 0.38)"
  },
  // The color used to divide different elements.
  divider: "rgba(0, 0, 0, 0.12)",
  // The background colors used to style the surfaces.
  // Consistency between these values is important.
  background: {
    paper: common$3.white,
    default: common$3.white
  },
  // The colors used to style the action elements.
  action: {
    // The color of an active action like an icon button.
    active: "rgba(0, 0, 0, 0.54)",
    // The color of an hovered action.
    hover: "rgba(0, 0, 0, 0.04)",
    hoverOpacity: 0.04,
    // The color of a selected action.
    selected: "rgba(0, 0, 0, 0.08)",
    selectedOpacity: 0.08,
    // The color of a disabled action.
    disabled: "rgba(0, 0, 0, 0.26)",
    // The background color of a disabled action.
    disabledBackground: "rgba(0, 0, 0, 0.12)",
    disabledOpacity: 0.38,
    focus: "rgba(0, 0, 0, 0.12)",
    focusOpacity: 0.12,
    activatedOpacity: 0.12
  }
}, dark$1 = {
  text: {
    primary: common$3.white,
    secondary: "rgba(255, 255, 255, 0.7)",
    disabled: "rgba(255, 255, 255, 0.5)",
    icon: "rgba(255, 255, 255, 0.5)"
  },
  divider: "rgba(255, 255, 255, 0.12)",
  background: {
    paper: "#121212",
    default: "#121212"
  },
  action: {
    active: common$3.white,
    hover: "rgba(255, 255, 255, 0.08)",
    hoverOpacity: 0.08,
    selected: "rgba(255, 255, 255, 0.16)",
    selectedOpacity: 0.16,
    disabled: "rgba(255, 255, 255, 0.3)",
    disabledBackground: "rgba(255, 255, 255, 0.12)",
    disabledOpacity: 0.38,
    focus: "rgba(255, 255, 255, 0.12)",
    focusOpacity: 0.12,
    activatedOpacity: 0.24
  }
};
function addLightOrDark(C, e, T, $) {
  const V = $.light || $, J = $.dark || $ * 1.5;
  C[e] || (C.hasOwnProperty(T) ? C[e] = C[T] : e === "light" ? C.light = lighten_1(C.main, V) : e === "dark" && (C.dark = darken_1(C.main, J)));
}
function getDefaultPrimary(C = "light") {
  return C === "dark" ? {
    main: blue[200],
    light: blue[50],
    dark: blue[400]
  } : {
    main: blue[700],
    light: blue[400],
    dark: blue[800]
  };
}
function getDefaultSecondary(C = "light") {
  return C === "dark" ? {
    main: purple[200],
    light: purple[50],
    dark: purple[400]
  } : {
    main: purple[500],
    light: purple[300],
    dark: purple[700]
  };
}
function getDefaultError(C = "light") {
  return C === "dark" ? {
    main: red[500],
    light: red[300],
    dark: red[700]
  } : {
    main: red[700],
    light: red[400],
    dark: red[800]
  };
}
function getDefaultInfo(C = "light") {
  return C === "dark" ? {
    main: lightBlue[400],
    light: lightBlue[300],
    dark: lightBlue[700]
  } : {
    main: lightBlue[700],
    light: lightBlue[500],
    dark: lightBlue[900]
  };
}
function getDefaultSuccess(C = "light") {
  return C === "dark" ? {
    main: green[400],
    light: green[300],
    dark: green[700]
  } : {
    main: green[800],
    light: green[500],
    dark: green[900]
  };
}
function getDefaultWarning(C = "light") {
  return C === "dark" ? {
    main: orange[400],
    light: orange[300],
    dark: orange[700]
  } : {
    main: "#ed6c02",
    // closest to orange[800] that pass 3:1.
    light: orange[500],
    dark: orange[900]
  };
}
function createPalette(C) {
  const {
    mode: e = "light",
    contrastThreshold: T = 3,
    tonalOffset: $ = 0.2
  } = C, V = _objectWithoutPropertiesLoose(C, _excluded$10), J = C.primary || getDefaultPrimary(e), ee = C.secondary || getDefaultSecondary(e), te = C.error || getDefaultError(e), re = C.info || getDefaultInfo(e), ie = C.success || getDefaultSuccess(e), se = C.warning || getDefaultWarning(e);
  function de(me) {
    const xe = getContrastRatio_1(me, dark$1.text.primary) >= T ? dark$1.text.primary : light$1.text.primary;
    if (dist$2.process.env.NODE_ENV !== "production") {
      const ve = getContrastRatio_1(me, xe);
      ve < 3 && console.error([`MUI: The contrast ratio of ${ve}:1 for ${xe} on ${me}`, "falls below the WCAG recommended absolute minimum contrast ratio of 3:1.", "https://www.w3.org/TR/2008/REC-WCAG20-20081211/#visual-audio-contrast-contrast"].join(`
`));
    }
    return xe;
  }
  const ue = ({
    color: me,
    name: xe,
    mainShade: ve = 500,
    lightShade: Te = 300,
    darkShade: we = 700
  }) => {
    if (me = _extends({}, me), !me.main && me[ve] && (me.main = me[ve]), !me.hasOwnProperty("main"))
      throw new Error(dist$2.process.env.NODE_ENV !== "production" ? `MUI: The color${xe ? ` (${xe})` : ""} provided to augmentColor(color) is invalid.
The color object needs to have a \`main\` property or a \`${ve}\` property.` : formatMuiErrorMessage$1(11, xe ? ` (${xe})` : "", ve));
    if (typeof me.main != "string")
      throw new Error(dist$2.process.env.NODE_ENV !== "production" ? `MUI: The color${xe ? ` (${xe})` : ""} provided to augmentColor(color) is invalid.
\`color.main\` should be a string, but \`${JSON.stringify(me.main)}\` was provided instead.

Did you intend to use one of the following approaches?

import { green } from "@mui/material/colors";

const theme1 = createTheme({ palette: {
  primary: green,
} });

const theme2 = createTheme({ palette: {
  primary: { main: green[500] },
} });` : formatMuiErrorMessage$1(12, xe ? ` (${xe})` : "", JSON.stringify(me.main)));
    return addLightOrDark(me, "light", Te, $), addLightOrDark(me, "dark", we, $), me.contrastText || (me.contrastText = de(me.main)), me;
  }, fe = {
    dark: dark$1,
    light: light$1
  };
  return dist$2.process.env.NODE_ENV !== "production" && (fe[e] || console.error(`MUI: The palette mode \`${e}\` is not supported.`)), deepmerge$1(_extends({
    // A collection of common colors.
    common: _extends({}, common$3),
    // prevent mutable object.
    // The palette mode, can be light or dark.
    mode: e,
    // The colors used to represent primary interface elements for a user.
    primary: ue({
      color: J,
      name: "primary"
    }),
    // The colors used to represent secondary interface elements for a user.
    secondary: ue({
      color: ee,
      name: "secondary",
      mainShade: "A400",
      lightShade: "A200",
      darkShade: "A700"
    }),
    // The colors used to represent interface elements that the user should be made aware of.
    error: ue({
      color: te,
      name: "error"
    }),
    // The colors used to represent potentially dangerous actions or important messages.
    warning: ue({
      color: se,
      name: "warning"
    }),
    // The colors used to present information to the user that is neutral and not necessarily important.
    info: ue({
      color: re,
      name: "info"
    }),
    // The colors used to indicate the successful completion of an action that user triggered.
    success: ue({
      color: ie,
      name: "success"
    }),
    // The grey colors.
    grey,
    // Used by `getContrastText()` to maximize the contrast between
    // the background and the text.
    contrastThreshold: T,
    // Takes a background color and returns the text color that maximizes the contrast.
    getContrastText: de,
    // Generate a rich color object.
    augmentColor: ue,
    // Used by the functions below to shift a color's luminance by approximately
    // two indexes within its tonal palette.
    // E.g., shift from Red 500 to Red 300 or Red 700.
    tonalOffset: $
  }, fe[e]), V);
}
const _excluded$$ = ["fontFamily", "fontSize", "fontWeightLight", "fontWeightRegular", "fontWeightMedium", "fontWeightBold", "htmlFontSize", "allVariants", "pxToRem"];
function round$2(C) {
  return Math.round(C * 1e5) / 1e5;
}
const caseAllCaps = {
  textTransform: "uppercase"
}, defaultFontFamily = '"Roboto", "Helvetica", "Arial", sans-serif';
function createTypography(C, e) {
  const T = typeof e == "function" ? e(C) : e, {
    fontFamily: $ = defaultFontFamily,
    // The default font size of the Material Specification.
    fontSize: V = 14,
    // px
    fontWeightLight: J = 300,
    fontWeightRegular: ee = 400,
    fontWeightMedium: te = 500,
    fontWeightBold: re = 700,
    // Tell MUI what's the font-size on the html element.
    // 16px is the default font-size used by browsers.
    htmlFontSize: ie = 16,
    // Apply the CSS properties to all the variants.
    allVariants: se,
    pxToRem: de
  } = T, ue = _objectWithoutPropertiesLoose(T, _excluded$$);
  dist$2.process.env.NODE_ENV !== "production" && (typeof V != "number" && console.error("MUI: `fontSize` is required to be a number."), typeof ie != "number" && console.error("MUI: `htmlFontSize` is required to be a number."));
  const fe = V / 14, he = de || ((ve) => `${ve / ie * fe}rem`), me = (ve, Te, we, Ee, Me) => _extends({
    fontFamily: $,
    fontWeight: ve,
    fontSize: he(Te),
    // Unitless following https://meyerweb.com/eric/thoughts/2006/02/08/unitless-line-heights/
    lineHeight: we
  }, $ === defaultFontFamily ? {
    letterSpacing: `${round$2(Ee / Te)}em`
  } : {}, Me, se), xe = {
    h1: me(J, 96, 1.167, -1.5),
    h2: me(J, 60, 1.2, -0.5),
    h3: me(ee, 48, 1.167, 0),
    h4: me(ee, 34, 1.235, 0.25),
    h5: me(ee, 24, 1.334, 0),
    h6: me(te, 20, 1.6, 0.15),
    subtitle1: me(ee, 16, 1.75, 0.15),
    subtitle2: me(te, 14, 1.57, 0.1),
    body1: me(ee, 16, 1.5, 0.15),
    body2: me(ee, 14, 1.43, 0.15),
    button: me(te, 14, 1.75, 0.4, caseAllCaps),
    caption: me(ee, 12, 1.66, 0.4),
    overline: me(ee, 12, 2.66, 1, caseAllCaps),
    // TODO v6: Remove handling of 'inherit' variant from the theme as it is already handled in Material UI's Typography component. Also, remember to remove the associated types.
    inherit: {
      fontFamily: "inherit",
      fontWeight: "inherit",
      fontSize: "inherit",
      lineHeight: "inherit",
      letterSpacing: "inherit"
    }
  };
  return deepmerge$1(_extends({
    htmlFontSize: ie,
    pxToRem: he,
    fontFamily: $,
    fontSize: V,
    fontWeightLight: J,
    fontWeightRegular: ee,
    fontWeightMedium: te,
    fontWeightBold: re
  }, xe), ue, {
    clone: !1
    // No need to clone deep
  });
}
const shadowKeyUmbraOpacity = 0.2, shadowKeyPenumbraOpacity = 0.14, shadowAmbientShadowOpacity = 0.12;
function createShadow(...C) {
  return [`${C[0]}px ${C[1]}px ${C[2]}px ${C[3]}px rgba(0,0,0,${shadowKeyUmbraOpacity})`, `${C[4]}px ${C[5]}px ${C[6]}px ${C[7]}px rgba(0,0,0,${shadowKeyPenumbraOpacity})`, `${C[8]}px ${C[9]}px ${C[10]}px ${C[11]}px rgba(0,0,0,${shadowAmbientShadowOpacity})`].join(",");
}
const shadows = ["none", createShadow(0, 2, 1, -1, 0, 1, 1, 0, 0, 1, 3, 0), createShadow(0, 3, 1, -2, 0, 2, 2, 0, 0, 1, 5, 0), createShadow(0, 3, 3, -2, 0, 3, 4, 0, 0, 1, 8, 0), createShadow(0, 2, 4, -1, 0, 4, 5, 0, 0, 1, 10, 0), createShadow(0, 3, 5, -1, 0, 5, 8, 0, 0, 1, 14, 0), createShadow(0, 3, 5, -1, 0, 6, 10, 0, 0, 1, 18, 0), createShadow(0, 4, 5, -2, 0, 7, 10, 1, 0, 2, 16, 1), createShadow(0, 5, 5, -3, 0, 8, 10, 1, 0, 3, 14, 2), createShadow(0, 5, 6, -3, 0, 9, 12, 1, 0, 3, 16, 2), createShadow(0, 6, 6, -3, 0, 10, 14, 1, 0, 4, 18, 3), createShadow(0, 6, 7, -4, 0, 11, 15, 1, 0, 4, 20, 3), createShadow(0, 7, 8, -4, 0, 12, 17, 2, 0, 5, 22, 4), createShadow(0, 7, 8, -4, 0, 13, 19, 2, 0, 5, 24, 4), createShadow(0, 7, 9, -4, 0, 14, 21, 2, 0, 5, 26, 4), createShadow(0, 8, 9, -5, 0, 15, 22, 2, 0, 6, 28, 5), createShadow(0, 8, 10, -5, 0, 16, 24, 2, 0, 6, 30, 5), createShadow(0, 8, 11, -5, 0, 17, 26, 2, 0, 6, 32, 5), createShadow(0, 9, 11, -5, 0, 18, 28, 2, 0, 7, 34, 6), createShadow(0, 9, 12, -6, 0, 19, 29, 2, 0, 7, 36, 6), createShadow(0, 10, 13, -6, 0, 20, 31, 3, 0, 8, 38, 7), createShadow(0, 10, 13, -6, 0, 21, 33, 3, 0, 8, 40, 7), createShadow(0, 10, 14, -6, 0, 22, 35, 3, 0, 8, 42, 7), createShadow(0, 11, 14, -7, 0, 23, 36, 3, 0, 9, 44, 8), createShadow(0, 11, 15, -7, 0, 24, 38, 3, 0, 9, 46, 8)], _excluded$_ = ["duration", "easing", "delay"], easing = {
  // This is the most common easing curve.
  easeInOut: "cubic-bezier(0.4, 0, 0.2, 1)",
  // Objects enter the screen at full velocity from off-screen and
  // slowly decelerate to a resting point.
  easeOut: "cubic-bezier(0.0, 0, 0.2, 1)",
  // Objects leave the screen at full velocity. They do not decelerate when off-screen.
  easeIn: "cubic-bezier(0.4, 0, 1, 1)",
  // The sharp curve is used by objects that may return to the screen at any time.
  sharp: "cubic-bezier(0.4, 0, 0.6, 1)"
}, duration = {
  shortest: 150,
  shorter: 200,
  short: 250,
  // most basic recommended timing
  standard: 300,
  // this is to be used in complex animations
  complex: 375,
  // recommended when something is entering screen
  enteringScreen: 225,
  // recommended when something is leaving screen
  leavingScreen: 195
};
function formatMs(C) {
  return `${Math.round(C)}ms`;
}
function getAutoHeightDuration(C) {
  if (!C)
    return 0;
  const e = C / 36;
  return Math.round((4 + 15 * e ** 0.25 + e / 5) * 10);
}
function createTransitions(C) {
  const e = _extends({}, easing, C.easing), T = _extends({}, duration, C.duration);
  return _extends({
    getAutoHeightDuration,
    create: (V = ["all"], J = {}) => {
      const {
        duration: ee = T.standard,
        easing: te = e.easeInOut,
        delay: re = 0
      } = J, ie = _objectWithoutPropertiesLoose(J, _excluded$_);
      if (dist$2.process.env.NODE_ENV !== "production") {
        const se = (ue) => typeof ue == "string", de = (ue) => !isNaN(parseFloat(ue));
        !se(V) && !Array.isArray(V) && console.error('MUI: Argument "props" must be a string or Array.'), !de(ee) && !se(ee) && console.error(`MUI: Argument "duration" must be a number or a string but found ${ee}.`), se(te) || console.error('MUI: Argument "easing" must be a string.'), !de(re) && !se(re) && console.error('MUI: Argument "delay" must be a number or a string.'), typeof J != "object" && console.error(["MUI: Secong argument of transition.create must be an object.", "Arguments should be either `create('prop1', options)` or `create(['prop1', 'prop2'], options)`"].join(`
`)), Object.keys(ie).length !== 0 && console.error(`MUI: Unrecognized argument(s) [${Object.keys(ie).join(",")}].`);
      }
      return (Array.isArray(V) ? V : [V]).map((se) => `${se} ${typeof ee == "string" ? ee : formatMs(ee)} ${te} ${typeof re == "string" ? re : formatMs(re)}`).join(",");
    }
  }, C, {
    easing: e,
    duration: T
  });
}
const zIndex = {
  mobileStepper: 1e3,
  fab: 1050,
  speedDial: 1050,
  appBar: 1100,
  drawer: 1200,
  modal: 1300,
  snackbar: 1400,
  tooltip: 1500
}, _excluded$Z = ["breakpoints", "mixins", "spacing", "palette", "transitions", "typography", "shape"];
function createTheme(C = {}, ...e) {
  const {
    mixins: T = {},
    palette: $ = {},
    transitions: V = {},
    typography: J = {}
  } = C, ee = _objectWithoutPropertiesLoose(C, _excluded$Z);
  if (C.vars)
    throw new Error(dist$2.process.env.NODE_ENV !== "production" ? "MUI: `vars` is a private field used for CSS variables support.\nPlease use another name." : formatMuiErrorMessage$1(18));
  const te = createPalette($), re = createTheme$2(C);
  let ie = deepmerge$1(re, {
    mixins: createMixins(re.breakpoints, T),
    palette: te,
    // Don't use [...shadows] until you've verified its transpiled code is not invoking the iterator protocol.
    shadows: shadows.slice(),
    typography: createTypography(te, J),
    transitions: createTransitions(V),
    zIndex: _extends({}, zIndex)
  });
  if (ie = deepmerge$1(ie, ee), ie = e.reduce((se, de) => deepmerge$1(se, de), ie), dist$2.process.env.NODE_ENV !== "production") {
    const se = ["active", "checked", "completed", "disabled", "error", "expanded", "focused", "focusVisible", "required", "selected"], de = (ue, fe) => {
      let he;
      for (he in ue) {
        const me = ue[he];
        if (se.indexOf(he) !== -1 && Object.keys(me).length > 0) {
          if (dist$2.process.env.NODE_ENV !== "production") {
            const xe = generateUtilityClass("", he);
            console.error([`MUI: The \`${fe}\` component increases the CSS specificity of the \`${he}\` internal state.`, "You can not override it like this: ", JSON.stringify(ue, null, 2), "", `Instead, you need to use the '&.${xe}' syntax:`, JSON.stringify({
              root: {
                [`&.${xe}`]: me
              }
            }, null, 2), "", "https://mui.com/r/state-classes-guide"].join(`
`));
          }
          ue[he] = {};
        }
      }
    };
    Object.keys(ie.components).forEach((ue) => {
      const fe = ie.components[ue].styleOverrides;
      fe && ue.indexOf("Mui") === 0 && de(fe, ue);
    });
  }
  return ie.unstable_sxConfig = _extends({}, defaultSxConfig, ee == null ? void 0 : ee.unstable_sxConfig), ie.unstable_sx = function(de) {
    return styleFunctionSx$1({
      sx: de,
      theme: this
    });
  }, ie;
}
const defaultTheme$2 = createTheme(), THEME_ID = "$$material";
function slotShouldForwardProp(C) {
  return C !== "ownerState" && C !== "theme" && C !== "sx" && C !== "as";
}
const rootShouldForwardProp = (C) => slotShouldForwardProp(C) && C !== "classes", styled$1 = _default({
  themeId: THEME_ID,
  defaultTheme: defaultTheme$2,
  rootShouldForwardProp
});
var shim = { exports: {} }, useSyncExternalStoreShim_production = {};
/**
 * @license React
 * use-sync-external-store-shim.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredUseSyncExternalStoreShim_production;
function requireUseSyncExternalStoreShim_production() {
  if (hasRequiredUseSyncExternalStoreShim_production) return useSyncExternalStoreShim_production;
  hasRequiredUseSyncExternalStoreShim_production = 1;
  var C = React__default;
  function e(de, ue) {
    return de === ue && (de !== 0 || 1 / de === 1 / ue) || de !== de && ue !== ue;
  }
  var T = typeof Object.is == "function" ? Object.is : e, $ = C.useState, V = C.useEffect, J = C.useLayoutEffect, ee = C.useDebugValue;
  function te(de, ue) {
    var fe = ue(), he = $({ inst: { value: fe, getSnapshot: ue } }), me = he[0].inst, xe = he[1];
    return J(
      function() {
        me.value = fe, me.getSnapshot = ue, re(me) && xe({ inst: me });
      },
      [de, fe, ue]
    ), V(
      function() {
        return re(me) && xe({ inst: me }), de(function() {
          re(me) && xe({ inst: me });
        });
      },
      [de]
    ), ee(fe), fe;
  }
  function re(de) {
    var ue = de.getSnapshot;
    de = de.value;
    try {
      var fe = ue();
      return !T(de, fe);
    } catch {
      return !0;
    }
  }
  function ie(de, ue) {
    return ue();
  }
  var se = typeof window > "u" || typeof window.document > "u" || typeof window.document.createElement > "u" ? ie : te;
  return useSyncExternalStoreShim_production.useSyncExternalStore = C.useSyncExternalStore !== void 0 ? C.useSyncExternalStore : se, useSyncExternalStoreShim_production;
}
var useSyncExternalStoreShim_development = {}, hasRequiredUseSyncExternalStoreShim_development;
function requireUseSyncExternalStoreShim_development() {
  return hasRequiredUseSyncExternalStoreShim_development || (hasRequiredUseSyncExternalStoreShim_development = 1, dist$2.process.env.NODE_ENV !== "production" && function() {
    function C(fe, he) {
      return fe === he && (fe !== 0 || 1 / fe === 1 / he) || fe !== fe && he !== he;
    }
    function e(fe, he) {
      se || V.startTransition === void 0 || (se = !0, console.error(
        "You are using an outdated, pre-release alpha of React 18 that does not support useSyncExternalStore. The use-sync-external-store shim will not work correctly. Upgrade to a newer pre-release."
      ));
      var me = he();
      if (!de) {
        var xe = he();
        J(me, xe) || (console.error(
          "The result of getSnapshot should be cached to avoid an infinite loop"
        ), de = !0);
      }
      xe = ee({
        inst: { value: me, getSnapshot: he }
      });
      var ve = xe[0].inst, Te = xe[1];
      return re(
        function() {
          ve.value = me, ve.getSnapshot = he, T(ve) && Te({ inst: ve });
        },
        [fe, me, he]
      ), te(
        function() {
          return T(ve) && Te({ inst: ve }), fe(function() {
            T(ve) && Te({ inst: ve });
          });
        },
        [fe]
      ), ie(me), me;
    }
    function T(fe) {
      var he = fe.getSnapshot;
      fe = fe.value;
      try {
        var me = he();
        return !J(fe, me);
      } catch {
        return !0;
      }
    }
    function $(fe, he) {
      return he();
    }
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(Error());
    var V = React__default, J = typeof Object.is == "function" ? Object.is : C, ee = V.useState, te = V.useEffect, re = V.useLayoutEffect, ie = V.useDebugValue, se = !1, de = !1, ue = typeof window > "u" || typeof window.document > "u" || typeof window.document.createElement > "u" ? $ : e;
    useSyncExternalStoreShim_development.useSyncExternalStore = V.useSyncExternalStore !== void 0 ? V.useSyncExternalStore : ue, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(Error());
  }()), useSyncExternalStoreShim_development;
}
dist$2.process.env.NODE_ENV === "production" ? shim.exports = requireUseSyncExternalStoreShim_production() : shim.exports = requireUseSyncExternalStoreShim_development();
var shimExports = shim.exports, withSelector = { exports: {} }, withSelector_production = {};
/**
 * @license React
 * use-sync-external-store-shim/with-selector.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredWithSelector_production;
function requireWithSelector_production() {
  if (hasRequiredWithSelector_production) return withSelector_production;
  hasRequiredWithSelector_production = 1;
  var C = React__default, e = shimExports;
  function T(ie, se) {
    return ie === se && (ie !== 0 || 1 / ie === 1 / se) || ie !== ie && se !== se;
  }
  var $ = typeof Object.is == "function" ? Object.is : T, V = e.useSyncExternalStore, J = C.useRef, ee = C.useEffect, te = C.useMemo, re = C.useDebugValue;
  return withSelector_production.useSyncExternalStoreWithSelector = function(ie, se, de, ue, fe) {
    var he = J(null);
    if (he.current === null) {
      var me = { hasValue: !1, value: null };
      he.current = me;
    } else me = he.current;
    he = te(
      function() {
        function ve(Ie) {
          if (!Te) {
            if (Te = !0, we = Ie, Ie = ue(Ie), fe !== void 0 && me.hasValue) {
              var ke = me.value;
              if (fe(ke, Ie))
                return Ee = ke;
            }
            return Ee = Ie;
          }
          if (ke = Ee, $(we, Ie)) return ke;
          var _e = ue(Ie);
          return fe !== void 0 && fe(ke, _e) ? (we = Ie, ke) : (we = Ie, Ee = _e);
        }
        var Te = !1, we, Ee, Me = de === void 0 ? null : de;
        return [
          function() {
            return ve(se());
          },
          Me === null ? void 0 : function() {
            return ve(Me());
          }
        ];
      },
      [se, de, ue, fe]
    );
    var xe = V(ie, he[0], he[1]);
    return ee(
      function() {
        me.hasValue = !0, me.value = xe;
      },
      [xe]
    ), re(xe), xe;
  }, withSelector_production;
}
var withSelector_development = {}, hasRequiredWithSelector_development;
function requireWithSelector_development() {
  return hasRequiredWithSelector_development || (hasRequiredWithSelector_development = 1, dist$2.process.env.NODE_ENV !== "production" && function() {
    function C(ie, se) {
      return ie === se && (ie !== 0 || 1 / ie === 1 / se) || ie !== ie && se !== se;
    }
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(Error());
    var e = React__default, T = shimExports, $ = typeof Object.is == "function" ? Object.is : C, V = T.useSyncExternalStore, J = e.useRef, ee = e.useEffect, te = e.useMemo, re = e.useDebugValue;
    withSelector_development.useSyncExternalStoreWithSelector = function(ie, se, de, ue, fe) {
      var he = J(null);
      if (he.current === null) {
        var me = { hasValue: !1, value: null };
        he.current = me;
      } else me = he.current;
      he = te(
        function() {
          function ve(Ie) {
            if (!Te) {
              if (Te = !0, we = Ie, Ie = ue(Ie), fe !== void 0 && me.hasValue) {
                var ke = me.value;
                if (fe(ke, Ie))
                  return Ee = ke;
              }
              return Ee = Ie;
            }
            if (ke = Ee, $(we, Ie))
              return ke;
            var _e = ue(Ie);
            return fe !== void 0 && fe(ke, _e) ? (we = Ie, ke) : (we = Ie, Ee = _e);
          }
          var Te = !1, we, Ee, Me = de === void 0 ? null : de;
          return [
            function() {
              return ve(se());
            },
            Me === null ? void 0 : function() {
              return ve(Me());
            }
          ];
        },
        [se, de, ue, fe]
      );
      var xe = V(ie, he[0], he[1]);
      return ee(
        function() {
          me.hasValue = !0, me.value = xe;
        },
        [xe]
      ), re(xe), xe;
    }, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(Error());
  }()), withSelector_development;
}
dist$2.process.env.NODE_ENV === "production" ? withSelector.exports = requireWithSelector_production() : withSelector.exports = requireWithSelector_development();
var withSelectorExports = withSelector.exports;
function defaultNoopBatch(C) {
  C();
}
let batch = defaultNoopBatch;
const setBatch = (C) => batch = C, getBatch = () => batch, ContextKey = Symbol.for("react-redux-context"), gT = typeof globalThis < "u" ? globalThis : (
  /* fall back to a per-module scope (pre-8.1 behaviour) if `globalThis` is not available */
  {}
);
function getContext() {
  var C;
  if (!React$1.createContext) return {};
  const e = (C = gT[ContextKey]) != null ? C : gT[ContextKey] = /* @__PURE__ */ new Map();
  let T = e.get(React$1.createContext);
  return T || (T = React$1.createContext(null), dist$2.process.env.NODE_ENV !== "production" && (T.displayName = "ReactRedux"), e.set(React$1.createContext, T)), T;
}
const ReactReduxContext = /* @__PURE__ */ getContext();
function createReduxContextHook(C = ReactReduxContext) {
  return function() {
    const T = useContext(C);
    if (dist$2.process.env.NODE_ENV !== "production" && !T)
      throw new Error("could not find react-redux context value; please ensure the component is wrapped in a <Provider>");
    return T;
  };
}
const useReduxContext = /* @__PURE__ */ createReduxContextHook(), notInitialized = () => {
  throw new Error("uSES not initialized!");
};
let useSyncExternalStoreWithSelector = notInitialized;
const initializeUseSelector = (C) => {
  useSyncExternalStoreWithSelector = C;
}, refEquality = (C, e) => C === e;
function createSelectorHook(C = ReactReduxContext) {
  const e = C === ReactReduxContext ? useReduxContext : createReduxContextHook(C);
  return function($, V = {}) {
    const {
      equalityFn: J = refEquality,
      stabilityCheck: ee = void 0,
      noopCheck: te = void 0
    } = typeof V == "function" ? {
      equalityFn: V
    } : V;
    if (dist$2.process.env.NODE_ENV !== "production") {
      if (!$)
        throw new Error("You must pass a selector to useSelector");
      if (typeof $ != "function")
        throw new Error("You must pass a function as a selector to useSelector");
      if (typeof J != "function")
        throw new Error("You must pass a function as an equality function to useSelector");
    }
    const {
      store: re,
      subscription: ie,
      getServerState: se,
      stabilityCheck: de,
      noopCheck: ue
    } = e(), fe = useRef(!0), he = useCallback({
      [$.name](xe) {
        const ve = $(xe);
        if (dist$2.process.env.NODE_ENV !== "production") {
          const Te = typeof ee > "u" ? de : ee;
          if (Te === "always" || Te === "once" && fe.current) {
            const Ee = $(xe);
            if (!J(ve, Ee)) {
              let Me;
              try {
                throw new Error();
              } catch (Ie) {
                ({
                  stack: Me
                } = Ie);
              }
              console.warn("Selector " + ($.name || "unknown") + ` returned a different result when called with the same parameters. This can lead to unnecessary rerenders.
Selectors that return a new reference (such as an object or an array) should be memoized: https://redux.js.org/usage/deriving-data-selectors#optimizing-selectors-with-memoization`, {
                state: xe,
                selected: ve,
                selected2: Ee,
                stack: Me
              });
            }
          }
          const we = typeof te > "u" ? ue : te;
          if ((we === "always" || we === "once" && fe.current) && ve === xe) {
            let Ee;
            try {
              throw new Error();
            } catch (Me) {
              ({
                stack: Ee
              } = Me);
            }
            console.warn("Selector " + ($.name || "unknown") + ` returned the root state when called. This can lead to unnecessary rerenders.
Selectors that return the entire state are almost certainly a mistake, as they will cause a rerender whenever *anything* in state changes.`, {
              stack: Ee
            });
          }
          fe.current && (fe.current = !1);
        }
        return ve;
      }
    }[$.name], [$, de, ee]), me = useSyncExternalStoreWithSelector(ie.addNestedSub, re.getState, se || re.getState, he, J);
    return useDebugValue(me), me;
  };
}
const useSelector = /* @__PURE__ */ createSelectorHook();
var reactIs_production_min = {};
/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredReactIs_production_min;
function requireReactIs_production_min() {
  if (hasRequiredReactIs_production_min) return reactIs_production_min;
  hasRequiredReactIs_production_min = 1;
  var C = Symbol.for("react.element"), e = Symbol.for("react.portal"), T = Symbol.for("react.fragment"), $ = Symbol.for("react.strict_mode"), V = Symbol.for("react.profiler"), J = Symbol.for("react.provider"), ee = Symbol.for("react.context"), te = Symbol.for("react.server_context"), re = Symbol.for("react.forward_ref"), ie = Symbol.for("react.suspense"), se = Symbol.for("react.suspense_list"), de = Symbol.for("react.memo"), ue = Symbol.for("react.lazy"), fe = Symbol.for("react.offscreen"), he;
  he = Symbol.for("react.module.reference");
  function me(xe) {
    if (typeof xe == "object" && xe !== null) {
      var ve = xe.$$typeof;
      switch (ve) {
        case C:
          switch (xe = xe.type, xe) {
            case T:
            case V:
            case $:
            case ie:
            case se:
              return xe;
            default:
              switch (xe = xe && xe.$$typeof, xe) {
                case te:
                case ee:
                case re:
                case ue:
                case de:
                case J:
                  return xe;
                default:
                  return ve;
              }
          }
        case e:
          return ve;
      }
    }
  }
  return reactIs_production_min.ContextConsumer = ee, reactIs_production_min.ContextProvider = J, reactIs_production_min.Element = C, reactIs_production_min.ForwardRef = re, reactIs_production_min.Fragment = T, reactIs_production_min.Lazy = ue, reactIs_production_min.Memo = de, reactIs_production_min.Portal = e, reactIs_production_min.Profiler = V, reactIs_production_min.StrictMode = $, reactIs_production_min.Suspense = ie, reactIs_production_min.SuspenseList = se, reactIs_production_min.isAsyncMode = function() {
    return !1;
  }, reactIs_production_min.isConcurrentMode = function() {
    return !1;
  }, reactIs_production_min.isContextConsumer = function(xe) {
    return me(xe) === ee;
  }, reactIs_production_min.isContextProvider = function(xe) {
    return me(xe) === J;
  }, reactIs_production_min.isElement = function(xe) {
    return typeof xe == "object" && xe !== null && xe.$$typeof === C;
  }, reactIs_production_min.isForwardRef = function(xe) {
    return me(xe) === re;
  }, reactIs_production_min.isFragment = function(xe) {
    return me(xe) === T;
  }, reactIs_production_min.isLazy = function(xe) {
    return me(xe) === ue;
  }, reactIs_production_min.isMemo = function(xe) {
    return me(xe) === de;
  }, reactIs_production_min.isPortal = function(xe) {
    return me(xe) === e;
  }, reactIs_production_min.isProfiler = function(xe) {
    return me(xe) === V;
  }, reactIs_production_min.isStrictMode = function(xe) {
    return me(xe) === $;
  }, reactIs_production_min.isSuspense = function(xe) {
    return me(xe) === ie;
  }, reactIs_production_min.isSuspenseList = function(xe) {
    return me(xe) === se;
  }, reactIs_production_min.isValidElementType = function(xe) {
    return typeof xe == "string" || typeof xe == "function" || xe === T || xe === V || xe === $ || xe === ie || xe === se || xe === fe || typeof xe == "object" && xe !== null && (xe.$$typeof === ue || xe.$$typeof === de || xe.$$typeof === J || xe.$$typeof === ee || xe.$$typeof === re || xe.$$typeof === he || xe.getModuleId !== void 0);
  }, reactIs_production_min.typeOf = me, reactIs_production_min;
}
var reactIs_development = {}, hasRequiredReactIs_development;
function requireReactIs_development() {
  return hasRequiredReactIs_development || (hasRequiredReactIs_development = 1, dist$2.process.env.NODE_ENV !== "production" && function() {
    var C = Symbol.for("react.element"), e = Symbol.for("react.portal"), T = Symbol.for("react.fragment"), $ = Symbol.for("react.strict_mode"), V = Symbol.for("react.profiler"), J = Symbol.for("react.provider"), ee = Symbol.for("react.context"), te = Symbol.for("react.server_context"), re = Symbol.for("react.forward_ref"), ie = Symbol.for("react.suspense"), se = Symbol.for("react.suspense_list"), de = Symbol.for("react.memo"), ue = Symbol.for("react.lazy"), fe = Symbol.for("react.offscreen"), he = !1, me = !1, xe = !1, ve = !1, Te = !1, we;
    we = Symbol.for("react.module.reference");
    function Ee(Je) {
      return !!(typeof Je == "string" || typeof Je == "function" || Je === T || Je === V || Te || Je === $ || Je === ie || Je === se || ve || Je === fe || he || me || xe || typeof Je == "object" && Je !== null && (Je.$$typeof === ue || Je.$$typeof === de || Je.$$typeof === J || Je.$$typeof === ee || Je.$$typeof === re || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      Je.$$typeof === we || Je.getModuleId !== void 0));
    }
    function Me(Je) {
      if (typeof Je == "object" && Je !== null) {
        var Xe = Je.$$typeof;
        switch (Xe) {
          case C:
            var st = Je.type;
            switch (st) {
              case T:
              case V:
              case $:
              case ie:
              case se:
                return st;
              default:
                var ct = st && st.$$typeof;
                switch (ct) {
                  case te:
                  case ee:
                  case re:
                  case ue:
                  case de:
                  case J:
                    return ct;
                  default:
                    return Xe;
                }
            }
          case e:
            return Xe;
        }
      }
    }
    var Ie = ee, ke = J, _e = C, De = re, Fe = T, Ae = ue, ne = de, oe = e, ce = V, le = $, pe = ie, ye = se, Ce = !1, be = !1;
    function ae(Je) {
      return Ce || (Ce = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }
    function ge(Je) {
      return be || (be = !0, console.warn("The ReactIs.isConcurrentMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }
    function Se(Je) {
      return Me(Je) === ee;
    }
    function Le(Je) {
      return Me(Je) === J;
    }
    function ze(Je) {
      return typeof Je == "object" && Je !== null && Je.$$typeof === C;
    }
    function Re(Je) {
      return Me(Je) === re;
    }
    function We(Je) {
      return Me(Je) === T;
    }
    function Be(Je) {
      return Me(Je) === ue;
    }
    function Ue(Je) {
      return Me(Je) === de;
    }
    function Ge(Je) {
      return Me(Je) === e;
    }
    function je(Je) {
      return Me(Je) === V;
    }
    function Oe(Je) {
      return Me(Je) === $;
    }
    function Ne(Je) {
      return Me(Je) === ie;
    }
    function Ye(Je) {
      return Me(Je) === se;
    }
    reactIs_development.ContextConsumer = Ie, reactIs_development.ContextProvider = ke, reactIs_development.Element = _e, reactIs_development.ForwardRef = De, reactIs_development.Fragment = Fe, reactIs_development.Lazy = Ae, reactIs_development.Memo = ne, reactIs_development.Portal = oe, reactIs_development.Profiler = ce, reactIs_development.StrictMode = le, reactIs_development.Suspense = pe, reactIs_development.SuspenseList = ye, reactIs_development.isAsyncMode = ae, reactIs_development.isConcurrentMode = ge, reactIs_development.isContextConsumer = Se, reactIs_development.isContextProvider = Le, reactIs_development.isElement = ze, reactIs_development.isForwardRef = Re, reactIs_development.isFragment = We, reactIs_development.isLazy = Be, reactIs_development.isMemo = Ue, reactIs_development.isPortal = Ge, reactIs_development.isProfiler = je, reactIs_development.isStrictMode = Oe, reactIs_development.isSuspense = Ne, reactIs_development.isSuspenseList = Ye, reactIs_development.isValidElementType = Ee, reactIs_development.typeOf = Me;
  }()), reactIs_development;
}
dist$2.process.env.NODE_ENV === "production" ? requireReactIs_production_min() : requireReactIs_development();
function createListenerCollection() {
  const C = getBatch();
  let e = null, T = null;
  return {
    clear() {
      e = null, T = null;
    },
    notify() {
      C(() => {
        let $ = e;
        for (; $; )
          $.callback(), $ = $.next;
      });
    },
    get() {
      let $ = [], V = e;
      for (; V; )
        $.push(V), V = V.next;
      return $;
    },
    subscribe($) {
      let V = !0, J = T = {
        callback: $,
        next: null,
        prev: T
      };
      return J.prev ? J.prev.next = J : e = J, function() {
        !V || e === null || (V = !1, J.next ? J.next.prev = J.prev : T = J.prev, J.prev ? J.prev.next = J.next : e = J.next);
      };
    }
  };
}
const nullListeners = {
  notify() {
  },
  get: () => []
};
function createSubscription(C, e) {
  let T, $ = nullListeners, V = 0, J = !1;
  function ee(me) {
    se();
    const xe = $.subscribe(me);
    let ve = !1;
    return () => {
      ve || (ve = !0, xe(), de());
    };
  }
  function te() {
    $.notify();
  }
  function re() {
    he.onStateChange && he.onStateChange();
  }
  function ie() {
    return J;
  }
  function se() {
    V++, T || (T = C.subscribe(re), $ = createListenerCollection());
  }
  function de() {
    V--, T && V === 0 && (T(), T = void 0, $.clear(), $ = nullListeners);
  }
  function ue() {
    J || (J = !0, se());
  }
  function fe() {
    J && (J = !1, de());
  }
  const he = {
    addNestedSub: ee,
    notifyNestedSubs: te,
    handleChangeWrapper: re,
    isSubscribed: ie,
    trySubscribe: ue,
    tryUnsubscribe: fe,
    getListeners: () => $
  };
  return he;
}
const canUseDOM = typeof window < "u" && typeof window.document < "u" && typeof window.document.createElement < "u", useIsomorphicLayoutEffect = canUseDOM ? React$1.useLayoutEffect : React$1.useEffect;
function Provider({
  store: C,
  context: e,
  children: T,
  serverState: $,
  stabilityCheck: V = "once",
  noopCheck: J = "once"
}) {
  const ee = React$1.useMemo(() => {
    const ie = createSubscription(C);
    return {
      store: C,
      subscription: ie,
      getServerState: $ ? () => $ : void 0,
      stabilityCheck: V,
      noopCheck: J
    };
  }, [C, $, V, J]), te = React$1.useMemo(() => C.getState(), [C]);
  useIsomorphicLayoutEffect(() => {
    const {
      subscription: ie
    } = ee;
    return ie.onStateChange = ie.notifyNestedSubs, ie.trySubscribe(), te !== C.getState() && ie.notifyNestedSubs(), () => {
      ie.tryUnsubscribe(), ie.onStateChange = void 0;
    };
  }, [ee, te]);
  const re = e || ReactReduxContext;
  return /* @__PURE__ */ React$1.createElement(re.Provider, {
    value: ee
  }, T);
}
function createStoreHook(C = ReactReduxContext) {
  const e = (
    // @ts-ignore
    C === ReactReduxContext ? useReduxContext : (
      // @ts-ignore
      createReduxContextHook(C)
    )
  );
  return function() {
    const {
      store: $
    } = e();
    return $;
  };
}
const useStore = /* @__PURE__ */ createStoreHook();
function createDispatchHook(C = ReactReduxContext) {
  const e = (
    // @ts-ignore
    C === ReactReduxContext ? useStore : createStoreHook(C)
  );
  return function() {
    return e().dispatch;
  };
}
const useDispatch = /* @__PURE__ */ createDispatchHook();
initializeUseSelector(withSelectorExports.useSyncExternalStoreWithSelector);
setBatch(unstable_batchedUpdates);
function r$1(C) {
  var e, T, $ = "";
  if (typeof C == "string" || typeof C == "number") $ += C;
  else if (typeof C == "object") if (Array.isArray(C)) {
    var V = C.length;
    for (e = 0; e < V; e++) C[e] && (T = r$1(C[e])) && ($ && ($ += " "), $ += T);
  } else for (T in C) C[T] && ($ && ($ += " "), $ += T);
  return $;
}
function clsx() {
  for (var C, e, T = 0, $ = "", V = arguments.length; T < V; T++) (C = arguments[T]) && (e = r$1(C)) && ($ && ($ += " "), $ += e);
  return $;
}
function composeClasses(C, e, T = void 0) {
  const $ = {};
  return Object.keys(C).forEach(
    // `Object.keys(slots)` can't be wider than `T` because we infer `T` from `slots`.
    // @ts-expect-error https://github.com/microsoft/TypeScript/pull/12253#issuecomment-263132208
    (V) => {
      $[V] = C[V].reduce((J, ee) => {
        if (ee) {
          const te = e(ee);
          te !== "" && J.push(te), T && T[ee] && J.push(T[ee]);
        }
        return J;
      }, []).join(" ");
    }
  ), $;
}
function resolveProps(C, e) {
  const T = _extends({}, e);
  return Object.keys(C).forEach(($) => {
    if ($.toString().match(/^(components|slots)$/))
      T[$] = _extends({}, C[$], T[$]);
    else if ($.toString().match(/^(componentsProps|slotProps)$/)) {
      const V = C[$] || {}, J = e[$];
      T[$] = {}, !J || !Object.keys(J) ? T[$] = V : !V || !Object.keys(V) ? T[$] = J : (T[$] = _extends({}, J), Object.keys(V).forEach((ee) => {
        T[$][ee] = resolveProps(V[ee], J[ee]);
      }));
    } else T[$] === void 0 && (T[$] = C[$]);
  }), T;
}
const PropsContext = /* @__PURE__ */ React$1.createContext(void 0);
function DefaultPropsProvider({
  value: C,
  children: e
}) {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(PropsContext.Provider, {
    value: C,
    children: e
  });
}
dist$2.process.env.NODE_ENV !== "production" && (DefaultPropsProvider.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * @ignore
   */
  children: PropTypes.node,
  /**
   * @ignore
   */
  value: PropTypes.object
});
function getThemeProps$1(C) {
  const {
    theme: e,
    name: T,
    props: $
  } = C;
  if (!e || !e.components || !e.components[T])
    return $;
  const V = e.components[T];
  return V.defaultProps ? resolveProps(V.defaultProps, $) : !V.styleOverrides && !V.variants ? resolveProps(V, $) : $;
}
function useDefaultProps$1({
  props: C,
  name: e
}) {
  const T = React$1.useContext(PropsContext);
  return getThemeProps$1({
    props: C,
    name: e,
    theme: {
      components: T
    }
  });
}
dist$2.process.env.NODE_ENV !== "production" && (PropTypes.node, PropTypes.object.isRequired);
function useDefaultProps(C) {
  return useDefaultProps$1(C);
}
function isObjectEmpty$1(C) {
  return Object.keys(C).length === 0;
}
function useTheme$4(C = null) {
  const e = React$1.useContext(ThemeContext$1);
  return !e || isObjectEmpty$1(e) ? C : e;
}
const systemDefaultTheme$1 = createTheme$2();
function useTheme$3(C = systemDefaultTheme$1) {
  return useTheme$4(C);
}
function GlobalStyles$1({
  styles: C,
  themeId: e,
  defaultTheme: T = {}
}) {
  const $ = useTheme$3(T), V = typeof C == "function" ? C(e && $[e] || $) : C;
  return /* @__PURE__ */ jsxRuntimeExports.jsx(GlobalStyles$2, {
    styles: V
  });
}
dist$2.process.env.NODE_ENV !== "production" && (GlobalStyles$1.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * @ignore
   */
  defaultTheme: PropTypes.object,
  /**
   * @ignore
   */
  styles: PropTypes.oneOfType([PropTypes.array, PropTypes.func, PropTypes.number, PropTypes.object, PropTypes.string, PropTypes.bool]),
  /**
   * @ignore
   */
  themeId: PropTypes.string
});
const _excluded$Y = ["className", "component"];
function createBox(C = {}) {
  const {
    themeId: e,
    defaultTheme: T,
    defaultClassName: $ = "MuiBox-root",
    generateClassName: V
  } = C, J = styled$2("div", {
    shouldForwardProp: (te) => te !== "theme" && te !== "sx" && te !== "as"
  })(styleFunctionSx$1);
  return /* @__PURE__ */ React$1.forwardRef(function(re, ie) {
    const se = useTheme$3(T), de = extendSxProp(re), {
      className: ue,
      component: fe = "div"
    } = de, he = _objectWithoutPropertiesLoose(de, _excluded$Y);
    return /* @__PURE__ */ jsxRuntimeExports.jsx(J, _extends({
      as: fe,
      ref: ie,
      className: clsx(ue, V ? V($) : $),
      theme: e && se[e] || se
    }, he));
  });
}
function generateUtilityClasses(C, e, T = "Mui") {
  const $ = {};
  return e.forEach((V) => {
    $[V] = generateUtilityClass(C, V, T);
  }), $;
}
const _excluded$X = ["ownerState"], _excluded2$6 = ["variants"], _excluded3$1 = ["name", "slot", "skipVariantsResolver", "skipSx", "overridesResolver"];
function isEmpty$2(C) {
  return Object.keys(C).length === 0;
}
function isStringTag(C) {
  return typeof C == "string" && // 96 is one less than the char code
  // for "a" so this is checking that
  // it's a lowercase character
  C.charCodeAt(0) > 96;
}
function shouldForwardProp(C) {
  return C !== "ownerState" && C !== "theme" && C !== "sx" && C !== "as";
}
const systemDefaultTheme = createTheme$2(), lowercaseFirstLetter = (C) => C && C.charAt(0).toLowerCase() + C.slice(1);
function resolveTheme({
  defaultTheme: C,
  theme: e,
  themeId: T
}) {
  return isEmpty$2(e) ? C : e[T] || e;
}
function defaultOverridesResolver(C) {
  return C ? (e, T) => T[C] : null;
}
function processStyleArg(C, e) {
  let {
    ownerState: T
  } = e, $ = _objectWithoutPropertiesLoose(e, _excluded$X);
  const V = typeof C == "function" ? C(_extends({
    ownerState: T
  }, $)) : C;
  if (Array.isArray(V))
    return V.flatMap((J) => processStyleArg(J, _extends({
      ownerState: T
    }, $)));
  if (V && typeof V == "object" && Array.isArray(V.variants)) {
    const {
      variants: J = []
    } = V;
    let te = _objectWithoutPropertiesLoose(V, _excluded2$6);
    return J.forEach((re) => {
      let ie = !0;
      typeof re.props == "function" ? ie = re.props(_extends({
        ownerState: T
      }, $, T)) : Object.keys(re.props).forEach((se) => {
        (T == null ? void 0 : T[se]) !== re.props[se] && $[se] !== re.props[se] && (ie = !1);
      }), ie && (Array.isArray(te) || (te = [te]), te.push(typeof re.style == "function" ? re.style(_extends({
        ownerState: T
      }, $, T)) : re.style));
    }), te;
  }
  return V;
}
function createStyled(C = {}) {
  const {
    themeId: e,
    defaultTheme: T = systemDefaultTheme,
    rootShouldForwardProp: $ = shouldForwardProp,
    slotShouldForwardProp: V = shouldForwardProp
  } = C, J = (ee) => styleFunctionSx$1(_extends({}, ee, {
    theme: resolveTheme(_extends({}, ee, {
      defaultTheme: T,
      themeId: e
    }))
  }));
  return J.__mui_systemSx = !0, (ee, te = {}) => {
    internal_processStyles(ee, (Me) => Me.filter((Ie) => !(Ie != null && Ie.__mui_systemSx)));
    const {
      name: re,
      slot: ie,
      skipVariantsResolver: se,
      skipSx: de,
      // TODO v6: remove `lowercaseFirstLetter()` in the next major release
      // For more details: https://github.com/mui/material-ui/pull/37908
      overridesResolver: ue = defaultOverridesResolver(lowercaseFirstLetter(ie))
    } = te, fe = _objectWithoutPropertiesLoose(te, _excluded3$1), he = se !== void 0 ? se : (
      // TODO v6: remove `Root` in the next major release
      // For more details: https://github.com/mui/material-ui/pull/37908
      ie && ie !== "Root" && ie !== "root" || !1
    ), me = de || !1;
    let xe;
    dist$2.process.env.NODE_ENV !== "production" && re && (xe = `${re}-${lowercaseFirstLetter(ie || "Root")}`);
    let ve = shouldForwardProp;
    ie === "Root" || ie === "root" ? ve = $ : ie ? ve = V : isStringTag(ee) && (ve = void 0);
    const Te = styled$2(ee, _extends({
      shouldForwardProp: ve,
      label: xe
    }, fe)), we = (Me) => typeof Me == "function" && Me.__emotion_real !== Me || isPlainObject$3(Me) ? (Ie) => processStyleArg(Me, _extends({}, Ie, {
      theme: resolveTheme({
        theme: Ie.theme,
        defaultTheme: T,
        themeId: e
      })
    })) : Me, Ee = (Me, ...Ie) => {
      let ke = we(Me);
      const _e = Ie ? Ie.map(we) : [];
      re && ue && _e.push((Ae) => {
        const ne = resolveTheme(_extends({}, Ae, {
          defaultTheme: T,
          themeId: e
        }));
        if (!ne.components || !ne.components[re] || !ne.components[re].styleOverrides)
          return null;
        const oe = ne.components[re].styleOverrides, ce = {};
        return Object.entries(oe).forEach(([le, pe]) => {
          ce[le] = processStyleArg(pe, _extends({}, Ae, {
            theme: ne
          }));
        }), ue(Ae, ce);
      }), re && !he && _e.push((Ae) => {
        var ne;
        const oe = resolveTheme(_extends({}, Ae, {
          defaultTheme: T,
          themeId: e
        })), ce = oe == null || (ne = oe.components) == null || (ne = ne[re]) == null ? void 0 : ne.variants;
        return processStyleArg({
          variants: ce
        }, _extends({}, Ae, {
          theme: oe
        }));
      }), me || _e.push(J);
      const De = _e.length - Ie.length;
      if (Array.isArray(Me) && De > 0) {
        const Ae = new Array(De).fill("");
        ke = [...Me, ...Ae], ke.raw = [...Me.raw, ...Ae];
      }
      const Fe = Te(ke, ..._e);
      if (dist$2.process.env.NODE_ENV !== "production") {
        let Ae;
        re && (Ae = `${re}${capitalize$3(ie || "")}`), Ae === void 0 && (Ae = `Styled(${getDisplayName$2(ee)})`), Fe.displayName = Ae;
      }
      return ee.muiName && (Fe.muiName = ee.muiName), Fe;
    };
    return Te.withConfig && (Ee.withConfig = Te.withConfig), Ee;
  };
}
const styled = createStyled();
function getThemeProps(C) {
  const {
    theme: e,
    name: T,
    props: $
  } = C;
  return !e || !e.components || !e.components[T] || !e.components[T].defaultProps ? $ : resolveProps(e.components[T].defaultProps, $);
}
function useThemeProps({
  props: C,
  name: e,
  defaultTheme: T,
  themeId: $
}) {
  let V = useTheme$3(T);
  return $ && (V = V[$] || V), getThemeProps({
    theme: V,
    name: e,
    props: C
  });
}
const useEnhancedEffect = typeof window < "u" ? React$1.useLayoutEffect : React$1.useEffect;
function useMediaQueryOld(C, e, T, $, V) {
  const [J, ee] = React$1.useState(() => V && T ? T(C).matches : $ ? $(C).matches : e);
  return useEnhancedEffect(() => {
    let te = !0;
    if (!T)
      return;
    const re = T(C), ie = () => {
      te && ee(re.matches);
    };
    return ie(), re.addListener(ie), () => {
      te = !1, re.removeListener(ie);
    };
  }, [C, T]), J;
}
const maybeReactUseSyncExternalStore = React$1.useSyncExternalStore;
function useMediaQueryNew(C, e, T, $, V) {
  const J = React$1.useCallback(() => e, [e]), ee = React$1.useMemo(() => {
    if (V && T)
      return () => T(C).matches;
    if ($ !== null) {
      const {
        matches: se
      } = $(C);
      return () => se;
    }
    return J;
  }, [J, C, $, V, T]), [te, re] = React$1.useMemo(() => {
    if (T === null)
      return [J, () => () => {
      }];
    const se = T(C);
    return [() => se.matches, (de) => (se.addListener(de), () => {
      se.removeListener(de);
    })];
  }, [J, T, C]);
  return maybeReactUseSyncExternalStore(re, te, ee);
}
function useMediaQuery(C, e = {}) {
  const T = useTheme$4(), $ = typeof window < "u" && typeof window.matchMedia < "u", {
    defaultMatches: V = !1,
    matchMedia: J = $ ? window.matchMedia : null,
    ssrMatchMedia: ee = null,
    noSsr: te = !1
  } = getThemeProps({
    name: "MuiUseMediaQuery",
    props: e,
    theme: T
  });
  dist$2.process.env.NODE_ENV !== "production" && typeof C == "function" && T === null && console.error(["MUI: The `query` argument provided is invalid.", "You are providing a function without a theme in the context.", "One of the parent elements needs to use a ThemeProvider."].join(`
`));
  let re = typeof C == "function" ? C(T) : C;
  re = re.replace(/^@media( ?)/m, "");
  const se = (maybeReactUseSyncExternalStore !== void 0 ? useMediaQueryNew : useMediaQueryOld)(re, V, J, ee, te);
  return dist$2.process.env.NODE_ENV !== "production" && React$1.useDebugValue({
    query: re,
    match: se
  }), se;
}
function clampWrapper(C, e = 0, T = 1) {
  return dist$2.process.env.NODE_ENV !== "production" && (C < e || C > T) && console.error(`MUI: The value provided ${C} is out of range [${e}, ${T}].`), clamp$1(C, e, T);
}
function hexToRgb(C) {
  C = C.slice(1);
  const e = new RegExp(`.{1,${C.length >= 6 ? 2 : 1}}`, "g");
  let T = C.match(e);
  return T && T[0].length === 1 && (T = T.map(($) => $ + $)), T ? `rgb${T.length === 4 ? "a" : ""}(${T.map(($, V) => V < 3 ? parseInt($, 16) : Math.round(parseInt($, 16) / 255 * 1e3) / 1e3).join(", ")})` : "";
}
function decomposeColor(C) {
  if (C.type)
    return C;
  if (C.charAt(0) === "#")
    return decomposeColor(hexToRgb(C));
  const e = C.indexOf("("), T = C.substring(0, e);
  if (["rgb", "rgba", "hsl", "hsla", "color"].indexOf(T) === -1)
    throw new Error(dist$2.process.env.NODE_ENV !== "production" ? `MUI: Unsupported \`${C}\` color.
The following formats are supported: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color().` : formatMuiErrorMessage$1(9, C));
  let $ = C.substring(e + 1, C.length - 1), V;
  if (T === "color") {
    if ($ = $.split(" "), V = $.shift(), $.length === 4 && $[3].charAt(0) === "/" && ($[3] = $[3].slice(1)), ["srgb", "display-p3", "a98-rgb", "prophoto-rgb", "rec-2020"].indexOf(V) === -1)
      throw new Error(dist$2.process.env.NODE_ENV !== "production" ? `MUI: unsupported \`${V}\` color space.
The following color spaces are supported: srgb, display-p3, a98-rgb, prophoto-rgb, rec-2020.` : formatMuiErrorMessage$1(10, V));
  } else
    $ = $.split(",");
  return $ = $.map((J) => parseFloat(J)), {
    type: T,
    values: $,
    colorSpace: V
  };
}
function recomposeColor(C) {
  const {
    type: e,
    colorSpace: T
  } = C;
  let {
    values: $
  } = C;
  return e.indexOf("rgb") !== -1 ? $ = $.map((V, J) => J < 3 ? parseInt(V, 10) : V) : e.indexOf("hsl") !== -1 && ($[1] = `${$[1]}%`, $[2] = `${$[2]}%`), e.indexOf("color") !== -1 ? $ = `${T} ${$.join(" ")}` : $ = `${$.join(", ")}`, `${e}(${$})`;
}
function alpha(C, e) {
  return C = decomposeColor(C), e = clampWrapper(e), (C.type === "rgb" || C.type === "hsl") && (C.type += "a"), C.type === "color" ? C.values[3] = `/${e}` : C.values[3] = e, recomposeColor(C);
}
function chainPropTypes(C, e) {
  return dist$2.process.env.NODE_ENV === "production" ? () => null : function(...$) {
    return C(...$) || e(...$);
  };
}
function isClassComponent$1(C) {
  const {
    prototype: e = {}
  } = C;
  return !!e.isReactComponent;
}
function acceptingRef(C, e, T, $, V) {
  const J = C[e], ee = V || e;
  if (J == null || // When server-side rendering React doesn't warn either.
  // This is not an accurate check for SSR.
  // This is only in place for Emotion compat.
  // TODO: Revisit once https://github.com/facebook/react/issues/20047 is resolved.
  typeof window > "u")
    return null;
  let te;
  const re = J.type;
  return typeof re == "function" && !isClassComponent$1(re) && (te = "Did you accidentally use a plain function component for an element instead?"), te !== void 0 ? new Error(`Invalid ${$} \`${ee}\` supplied to \`${T}\`. Expected an element that can hold a ref. ${te} For more information see https://mui.com/r/caveat-with-refs-guide`) : null;
}
const elementAcceptingRef = chainPropTypes(PropTypes.element, acceptingRef);
elementAcceptingRef.isRequired = chainPropTypes(PropTypes.element.isRequired, acceptingRef);
function isClassComponent(C) {
  const {
    prototype: e = {}
  } = C;
  return !!e.isReactComponent;
}
function elementTypeAcceptingRef(C, e, T, $, V) {
  const J = C[e], ee = V || e;
  if (J == null || // When server-side rendering React doesn't warn either.
  // This is not an accurate check for SSR.
  // This is only in place for emotion compat.
  // TODO: Revisit once https://github.com/facebook/react/issues/20047 is resolved.
  typeof window > "u")
    return null;
  let te;
  return typeof J == "function" && !isClassComponent(J) && (te = "Did you accidentally provide a plain function component instead?"), te !== void 0 ? new Error(`Invalid ${$} \`${ee}\` supplied to \`${T}\`. Expected an element type that can hold a ref. ${te} For more information see https://mui.com/r/caveat-with-refs-guide`) : null;
}
const elementTypeAcceptingRef$1 = chainPropTypes(PropTypes.elementType, elementTypeAcceptingRef), specialProperty = "exact-prop: ​";
function exactProp(C) {
  return dist$2.process.env.NODE_ENV === "production" ? C : _extends({}, C, {
    [specialProperty]: (e) => {
      const T = Object.keys(e).filter(($) => !C.hasOwnProperty($));
      return T.length > 0 ? new Error(`The following props are not supported: ${T.map(($) => `\`${$}\``).join(", ")}. Please remove them.`) : null;
    }
  });
}
function HTMLElementType(C, e, T, $, V) {
  if (dist$2.process.env.NODE_ENV === "production")
    return null;
  const J = C[e], ee = V || e;
  return J == null ? null : J && J.nodeType !== 1 ? new Error(`Invalid ${$} \`${ee}\` supplied to \`${T}\`. Expected an HTMLElement.`) : null;
}
const refType = PropTypes.oneOfType([PropTypes.func, PropTypes.object]);
function createChainedFunction(...C) {
  return C.reduce((e, T) => T == null ? e : function(...V) {
    e.apply(this, V), T.apply(this, V);
  }, () => {
  });
}
function debounce$1(C, e = 166) {
  let T;
  function $(...V) {
    const J = () => {
      C.apply(this, V);
    };
    clearTimeout(T), T = setTimeout(J, e);
  }
  return $.clear = () => {
    clearTimeout(T);
  }, $;
}
function deprecatedPropType(C, e) {
  return dist$2.process.env.NODE_ENV === "production" ? () => null : (T, $, V, J, ee) => {
    const te = V || "<<anonymous>>", re = ee || $;
    return typeof T[$] < "u" ? new Error(`The ${J} \`${re}\` of \`${te}\` is deprecated. ${e}`) : null;
  };
}
function isMuiElement(C, e) {
  var T, $;
  return /* @__PURE__ */ React$1.isValidElement(C) && e.indexOf(
    // For server components `muiName` is avaialble in element.type._payload.value.muiName
    // relevant info - https://github.com/facebook/react/blob/2807d781a08db8e9873687fccc25c0f12b4fb3d4/packages/react/src/ReactLazy.js#L45
    // eslint-disable-next-line no-underscore-dangle
    (T = C.type.muiName) != null ? T : ($ = C.type) == null || ($ = $._payload) == null || ($ = $.value) == null ? void 0 : $.muiName
  ) !== -1;
}
function ownerDocument(C) {
  return C && C.ownerDocument || document;
}
function ownerWindow(C) {
  return ownerDocument(C).defaultView || window;
}
function requirePropFactory(C, e) {
  if (dist$2.process.env.NODE_ENV === "production")
    return () => null;
  const T = e ? _extends({}, e.propTypes) : null;
  return (V) => (J, ee, te, re, ie, ...se) => {
    const de = ie || ee, ue = T == null ? void 0 : T[de];
    if (ue) {
      const fe = ue(J, ee, te, re, ie, ...se);
      if (fe)
        return fe;
    }
    return typeof J[ee] < "u" && !J[V] ? new Error(`The prop \`${de}\` of \`${C}\` can only be used together with the \`${V}\` prop.`) : null;
  };
}
function setRef(C, e) {
  typeof C == "function" ? C(e) : C && (C.current = e);
}
let globalId = 0;
function useGlobalId(C) {
  const [e, T] = React$1.useState(C), $ = C || e;
  return React$1.useEffect(() => {
    e == null && (globalId += 1, T(`mui-${globalId}`));
  }, [e]), $;
}
const maybeReactUseId = React$1.useId;
function useId(C) {
  if (maybeReactUseId !== void 0) {
    const e = maybeReactUseId();
    return C ?? e;
  }
  return useGlobalId(C);
}
function unsupportedProp(C, e, T, $, V) {
  if (dist$2.process.env.NODE_ENV === "production")
    return null;
  const J = V || e;
  return typeof C[e] < "u" ? new Error(`The prop \`${J}\` is not supported. Please remove it.`) : null;
}
function useControlled({
  controlled: C,
  default: e,
  name: T,
  state: $ = "value"
}) {
  const {
    current: V
  } = React$1.useRef(C !== void 0), [J, ee] = React$1.useState(e), te = V ? C : J;
  if (dist$2.process.env.NODE_ENV !== "production") {
    React$1.useEffect(() => {
      V !== (C !== void 0) && console.error([`MUI: A component is changing the ${V ? "" : "un"}controlled ${$} state of ${T} to be ${V ? "un" : ""}controlled.`, "Elements should not switch from uncontrolled to controlled (or vice versa).", `Decide between using a controlled or uncontrolled ${T} element for the lifetime of the component.`, "The nature of the state is determined during the first render. It's considered controlled if the value is not `undefined`.", "More info: https://fb.me/react-controlled-components"].join(`
`));
    }, [$, T, C]);
    const {
      current: ie
    } = React$1.useRef(e);
    React$1.useEffect(() => {
      !V && !Object.is(ie, e) && console.error([`MUI: A component is changing the default ${$} state of an uncontrolled ${T} after being initialized. To suppress this warning opt to use a controlled ${T}.`].join(`
`));
    }, [JSON.stringify(e)]);
  }
  const re = React$1.useCallback((ie) => {
    V || ee(ie);
  }, []);
  return [te, re];
}
function useEventCallback(C) {
  const e = React$1.useRef(C);
  return useEnhancedEffect(() => {
    e.current = C;
  }), React$1.useRef((...T) => (
    // @ts-expect-error hide `this`
    (0, e.current)(...T)
  )).current;
}
function useForkRef(...C) {
  return React$1.useMemo(() => C.every((e) => e == null) ? null : (e) => {
    C.forEach((T) => {
      setRef(T, e);
    });
  }, C);
}
const UNINITIALIZED = {};
function useLazyRef(C, e) {
  const T = React$1.useRef(UNINITIALIZED);
  return T.current === UNINITIALIZED && (T.current = C(e)), T;
}
const EMPTY$1 = [];
function useOnMount(C) {
  React$1.useEffect(C, EMPTY$1);
}
class Timeout {
  constructor() {
    this.currentId = null, this.clear = () => {
      this.currentId !== null && (clearTimeout(this.currentId), this.currentId = null);
    }, this.disposeEffect = () => this.clear;
  }
  static create() {
    return new Timeout();
  }
  /**
   * Executes `fn` after `delay`, clearing any previously scheduled call.
   */
  start(e, T) {
    this.clear(), this.currentId = setTimeout(() => {
      this.currentId = null, T();
    }, e);
  }
}
function useTimeout() {
  const C = useLazyRef(Timeout.create).current;
  return useOnMount(C.disposeEffect), C;
}
let hadKeyboardEvent = !0, hadFocusVisibleRecently = !1;
const hadFocusVisibleRecentlyTimeout = new Timeout(), inputTypesWhitelist = {
  text: !0,
  search: !0,
  url: !0,
  tel: !0,
  email: !0,
  password: !0,
  number: !0,
  date: !0,
  month: !0,
  week: !0,
  time: !0,
  datetime: !0,
  "datetime-local": !0
};
function focusTriggersKeyboardModality(C) {
  const {
    type: e,
    tagName: T
  } = C;
  return !!(T === "INPUT" && inputTypesWhitelist[e] && !C.readOnly || T === "TEXTAREA" && !C.readOnly || C.isContentEditable);
}
function handleKeyDown(C) {
  C.metaKey || C.altKey || C.ctrlKey || (hadKeyboardEvent = !0);
}
function handlePointerDown() {
  hadKeyboardEvent = !1;
}
function handleVisibilityChange() {
  this.visibilityState === "hidden" && hadFocusVisibleRecently && (hadKeyboardEvent = !0);
}
function prepare(C) {
  C.addEventListener("keydown", handleKeyDown, !0), C.addEventListener("mousedown", handlePointerDown, !0), C.addEventListener("pointerdown", handlePointerDown, !0), C.addEventListener("touchstart", handlePointerDown, !0), C.addEventListener("visibilitychange", handleVisibilityChange, !0);
}
function isFocusVisible(C) {
  const {
    target: e
  } = C;
  try {
    return e.matches(":focus-visible");
  } catch {
  }
  return hadKeyboardEvent || focusTriggersKeyboardModality(e);
}
function useIsFocusVisible() {
  const C = React$1.useCallback((V) => {
    V != null && prepare(V.ownerDocument);
  }, []), e = React$1.useRef(!1);
  function T() {
    return e.current ? (hadFocusVisibleRecently = !0, hadFocusVisibleRecentlyTimeout.start(100, () => {
      hadFocusVisibleRecently = !1;
    }), e.current = !1, !0) : !1;
  }
  function $(V) {
    return isFocusVisible(V) ? (e.current = !0, !0) : !1;
  }
  return {
    isFocusVisibleRef: e,
    onFocus: $,
    onBlur: T,
    ref: C
  };
}
function getScrollbarSize(C) {
  const e = C.documentElement.clientWidth;
  return Math.abs(window.innerWidth - e);
}
const usePreviousProps = (C) => {
  const e = React$1.useRef({});
  return React$1.useEffect(() => {
    e.current = C;
  }), e.current;
}, visuallyHidden = {
  border: 0,
  clip: "rect(0 0 0 0)",
  height: "1px",
  margin: "-1px",
  overflow: "hidden",
  padding: 0,
  position: "absolute",
  whiteSpace: "nowrap",
  width: "1px"
};
function getTypeByValue(C) {
  const e = typeof C;
  switch (e) {
    case "number":
      return Number.isNaN(C) ? "NaN" : Number.isFinite(C) ? C !== Math.floor(C) ? "float" : "number" : "Infinity";
    case "object":
      return C === null ? "null" : C.constructor.name;
    default:
      return e;
  }
}
function ponyfillIsInteger(C) {
  return typeof C == "number" && isFinite(C) && Math.floor(C) === C;
}
const isInteger = Number.isInteger || ponyfillIsInteger;
function requiredInteger(C, e, T, $) {
  const V = C[e];
  if (V == null || !isInteger(V)) {
    const J = getTypeByValue(V);
    return new RangeError(`Invalid ${$} \`${e}\` of type \`${J}\` supplied to \`${T}\`, expected \`integer\`.`);
  }
  return null;
}
function validator$1(C, e, ...T) {
  return C[e] === void 0 ? null : requiredInteger(C, e, ...T);
}
function validatorNoop() {
  return null;
}
validator$1.isRequired = requiredInteger;
validatorNoop.isRequired = validatorNoop;
const integerPropType = dist$2.process.env.NODE_ENV === "production" ? validatorNoop : validator$1;
function isHostComponent(C) {
  return typeof C == "string";
}
function appendOwnerState(C, e, T) {
  return C === void 0 || isHostComponent(C) ? e : _extends({}, e, {
    ownerState: _extends({}, e.ownerState, T)
  });
}
function extractEventHandlers(C, e = []) {
  if (C === void 0)
    return {};
  const T = {};
  return Object.keys(C).filter(($) => $.match(/^on[A-Z]/) && typeof C[$] == "function" && !e.includes($)).forEach(($) => {
    T[$] = C[$];
  }), T;
}
function omitEventHandlers(C) {
  if (C === void 0)
    return {};
  const e = {};
  return Object.keys(C).filter((T) => !(T.match(/^on[A-Z]/) && typeof C[T] == "function")).forEach((T) => {
    e[T] = C[T];
  }), e;
}
function mergeSlotProps(C) {
  const {
    getSlotProps: e,
    additionalProps: T,
    externalSlotProps: $,
    externalForwardedProps: V,
    className: J
  } = C;
  if (!e) {
    const fe = clsx(T == null ? void 0 : T.className, J, V == null ? void 0 : V.className, $ == null ? void 0 : $.className), he = _extends({}, T == null ? void 0 : T.style, V == null ? void 0 : V.style, $ == null ? void 0 : $.style), me = _extends({}, T, V, $);
    return fe.length > 0 && (me.className = fe), Object.keys(he).length > 0 && (me.style = he), {
      props: me,
      internalRef: void 0
    };
  }
  const ee = extractEventHandlers(_extends({}, V, $)), te = omitEventHandlers($), re = omitEventHandlers(V), ie = e(ee), se = clsx(ie == null ? void 0 : ie.className, T == null ? void 0 : T.className, J, V == null ? void 0 : V.className, $ == null ? void 0 : $.className), de = _extends({}, ie == null ? void 0 : ie.style, T == null ? void 0 : T.style, V == null ? void 0 : V.style, $ == null ? void 0 : $.style), ue = _extends({}, ie, T, re, te);
  return se.length > 0 && (ue.className = se), Object.keys(de).length > 0 && (ue.style = de), {
    props: ue,
    internalRef: ie.ref
  };
}
function resolveComponentProps(C, e, T) {
  return typeof C == "function" ? C(e, T) : C;
}
const _excluded$W = ["elementType", "externalSlotProps", "ownerState", "skipResolvingSlotProps"];
function useSlotProps(C) {
  var e;
  const {
    elementType: T,
    externalSlotProps: $,
    ownerState: V,
    skipResolvingSlotProps: J = !1
  } = C, ee = _objectWithoutPropertiesLoose(C, _excluded$W), te = J ? {} : resolveComponentProps($, V), {
    props: re,
    internalRef: ie
  } = mergeSlotProps(_extends({}, ee, {
    externalSlotProps: te
  })), se = useForkRef(ie, te == null ? void 0 : te.ref, (e = C.additionalProps) == null ? void 0 : e.ref);
  return appendOwnerState(T, _extends({}, re, {
    ref: se
  }), V);
}
function getReactElementRef(C) {
  if (parseInt(React$1.version, 10) >= 19) {
    var e;
    return (C == null || (e = C.props) == null ? void 0 : e.ref) || null;
  }
  return (C == null ? void 0 : C.ref) || null;
}
const ThemeContext = /* @__PURE__ */ React$1.createContext(null);
dist$2.process.env.NODE_ENV !== "production" && (ThemeContext.displayName = "ThemeContext");
function useTheme$2() {
  const C = React$1.useContext(ThemeContext);
  return dist$2.process.env.NODE_ENV !== "production" && React$1.useDebugValue(C), C;
}
const hasSymbol = typeof Symbol == "function" && Symbol.for, nested = hasSymbol ? Symbol.for("mui.nested") : "__THEME_NESTED__";
function mergeOuterLocalTheme(C, e) {
  if (typeof e == "function") {
    const T = e(C);
    return dist$2.process.env.NODE_ENV !== "production" && (T || console.error(["MUI: You should return an object from your theme function, i.e.", "<ThemeProvider theme={() => ({})} />"].join(`
`))), T;
  }
  return _extends({}, C, e);
}
function ThemeProvider$2(C) {
  const {
    children: e,
    theme: T
  } = C, $ = useTheme$2();
  dist$2.process.env.NODE_ENV !== "production" && $ === null && typeof T == "function" && console.error(["MUI: You are providing a theme function prop to the ThemeProvider component:", "<ThemeProvider theme={outerTheme => outerTheme} />", "", "However, no outer theme is present.", "Make sure a theme is already injected higher in the React tree or provide a theme object."].join(`
`));
  const V = React$1.useMemo(() => {
    const J = $ === null ? T : mergeOuterLocalTheme($, T);
    return J != null && (J[nested] = $ !== null), J;
  }, [T, $]);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(ThemeContext.Provider, {
    value: V,
    children: e
  });
}
dist$2.process.env.NODE_ENV !== "production" && (ThemeProvider$2.propTypes = {
  /**
   * Your component tree.
   */
  children: PropTypes.node,
  /**
   * A theme object. You can provide a function to extend the outer theme.
   */
  theme: PropTypes.oneOfType([PropTypes.object, PropTypes.func]).isRequired
});
dist$2.process.env.NODE_ENV !== "production" && dist$2.process.env.NODE_ENV !== "production" && (ThemeProvider$2.propTypes = exactProp(ThemeProvider$2.propTypes));
const _excluded$V = ["value"], RtlContext = /* @__PURE__ */ React$1.createContext();
function RtlProvider(C) {
  let {
    value: e
  } = C, T = _objectWithoutPropertiesLoose(C, _excluded$V);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(RtlContext.Provider, _extends({
    value: e ?? !0
  }, T));
}
dist$2.process.env.NODE_ENV !== "production" && (RtlProvider.propTypes = {
  children: PropTypes.node,
  value: PropTypes.bool
});
const useRtl = () => {
  const C = React$1.useContext(RtlContext);
  return C ?? !1;
}, EMPTY_THEME = {};
function useThemeScoping(C, e, T, $ = !1) {
  return React$1.useMemo(() => {
    const V = C && e[C] || e;
    if (typeof T == "function") {
      const J = T(V), ee = C ? _extends({}, e, {
        [C]: J
      }) : J;
      return $ ? () => ee : ee;
    }
    return C ? _extends({}, e, {
      [C]: T
    }) : _extends({}, e, T);
  }, [C, e, T, $]);
}
function ThemeProvider$1(C) {
  const {
    children: e,
    theme: T,
    themeId: $
  } = C, V = useTheme$4(EMPTY_THEME), J = useTheme$2() || EMPTY_THEME;
  dist$2.process.env.NODE_ENV !== "production" && (V === null && typeof T == "function" || $ && V && !V[$] && typeof T == "function") && console.error(["MUI: You are providing a theme function prop to the ThemeProvider component:", "<ThemeProvider theme={outerTheme => outerTheme} />", "", "However, no outer theme is present.", "Make sure a theme is already injected higher in the React tree or provide a theme object."].join(`
`));
  const ee = useThemeScoping($, V, T), te = useThemeScoping($, J, T, !0), re = ee.direction === "rtl";
  return /* @__PURE__ */ jsxRuntimeExports.jsx(ThemeProvider$2, {
    theme: te,
    children: /* @__PURE__ */ jsxRuntimeExports.jsx(ThemeContext$1.Provider, {
      value: ee,
      children: /* @__PURE__ */ jsxRuntimeExports.jsx(RtlProvider, {
        value: re,
        children: /* @__PURE__ */ jsxRuntimeExports.jsx(DefaultPropsProvider, {
          value: ee == null ? void 0 : ee.components,
          children: e
        })
      })
    })
  });
}
dist$2.process.env.NODE_ENV !== "production" && (ThemeProvider$1.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Your component tree.
   */
  children: PropTypes.node,
  /**
   * A theme object. You can provide a function to extend the outer theme.
   */
  theme: PropTypes.oneOfType([PropTypes.func, PropTypes.object]).isRequired,
  /**
   * The design system's unique id for getting the corresponded theme when there are multiple design systems.
   */
  themeId: PropTypes.string
});
dist$2.process.env.NODE_ENV !== "production" && dist$2.process.env.NODE_ENV !== "production" && (ThemeProvider$1.propTypes = exactProp(ThemeProvider$1.propTypes));
function _typeof(C) {
  "@babel/helpers - typeof";
  return _typeof = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, _typeof(C);
}
function toPrimitive(C, e) {
  if (_typeof(C) != "object" || !C) return C;
  var T = C[Symbol.toPrimitive];
  if (T !== void 0) {
    var $ = T.call(C, e || "default");
    if (_typeof($) != "object") return $;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(C);
}
function toPropertyKey(C) {
  var e = toPrimitive(C, "string");
  return _typeof(e) == "symbol" ? e : e + "";
}
const _excluded$U = ["component", "direction", "spacing", "divider", "children", "className", "useFlexGap"], defaultTheme$1 = createTheme$2(), defaultCreateStyledComponent = styled("div", {
  name: "MuiStack",
  slot: "Root",
  overridesResolver: (C, e) => e.root
});
function useThemePropsDefault(C) {
  return useThemeProps({
    props: C,
    name: "MuiStack",
    defaultTheme: defaultTheme$1
  });
}
function joinChildren(C, e) {
  const T = React$1.Children.toArray(C).filter(Boolean);
  return T.reduce(($, V, J) => ($.push(V), J < T.length - 1 && $.push(/* @__PURE__ */ React$1.cloneElement(e, {
    key: `separator-${J}`
  })), $), []);
}
const getSideFromDirection = (C) => ({
  row: "Left",
  "row-reverse": "Right",
  column: "Top",
  "column-reverse": "Bottom"
})[C], style = ({
  ownerState: C,
  theme: e
}) => {
  let T = _extends({
    display: "flex",
    flexDirection: "column"
  }, handleBreakpoints({
    theme: e
  }, resolveBreakpointValues({
    values: C.direction,
    breakpoints: e.breakpoints.values
  }), ($) => ({
    flexDirection: $
  })));
  if (C.spacing) {
    const $ = createUnarySpacing(e), V = Object.keys(e.breakpoints.values).reduce((re, ie) => ((typeof C.spacing == "object" && C.spacing[ie] != null || typeof C.direction == "object" && C.direction[ie] != null) && (re[ie] = !0), re), {}), J = resolveBreakpointValues({
      values: C.direction,
      base: V
    }), ee = resolveBreakpointValues({
      values: C.spacing,
      base: V
    });
    typeof J == "object" && Object.keys(J).forEach((re, ie, se) => {
      if (!J[re]) {
        const ue = ie > 0 ? J[se[ie - 1]] : "column";
        J[re] = ue;
      }
    }), T = deepmerge$1(T, handleBreakpoints({
      theme: e
    }, ee, (re, ie) => C.useFlexGap ? {
      gap: getValue$2($, re)
    } : {
      // The useFlexGap={false} implement relies on each child to give up control of the margin.
      // We need to reset the margin to avoid double spacing.
      "& > :not(style):not(style)": {
        margin: 0
      },
      "& > :not(style) ~ :not(style)": {
        [`margin${getSideFromDirection(ie ? J[ie] : C.direction)}`]: getValue$2($, re)
      }
    }));
  }
  return T = mergeBreakpointsInOrder(e.breakpoints, T), T;
};
function createStack(C = {}) {
  const {
    // This will allow adding custom styled fn (for example for custom sx style function)
    createStyledComponent: e = defaultCreateStyledComponent,
    useThemeProps: T = useThemePropsDefault,
    componentName: $ = "MuiStack"
  } = C, V = () => composeClasses({
    root: ["root"]
  }, (re) => generateUtilityClass($, re), {}), J = e(style), ee = /* @__PURE__ */ React$1.forwardRef(function(re, ie) {
    const se = T(re), de = extendSxProp(se), {
      component: ue = "div",
      direction: fe = "column",
      spacing: he = 0,
      divider: me,
      children: xe,
      className: ve,
      useFlexGap: Te = !1
    } = de, we = _objectWithoutPropertiesLoose(de, _excluded$U), Ee = {
      direction: fe,
      spacing: he,
      useFlexGap: Te
    }, Me = V();
    return /* @__PURE__ */ jsxRuntimeExports.jsx(J, _extends({
      as: ue,
      ownerState: Ee,
      ref: ie,
      className: clsx(Me.root, ve)
    }, we, {
      children: me ? joinChildren(xe, me) : xe
    }));
  });
  return dist$2.process.env.NODE_ENV !== "production" && (ee.propTypes = {
    children: PropTypes.node,
    direction: PropTypes.oneOfType([PropTypes.oneOf(["column-reverse", "column", "row-reverse", "row"]), PropTypes.arrayOf(PropTypes.oneOf(["column-reverse", "column", "row-reverse", "row"])), PropTypes.object]),
    divider: PropTypes.node,
    spacing: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.number, PropTypes.string])), PropTypes.number, PropTypes.object, PropTypes.string]),
    sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object])
  }), ee;
}
function GlobalStyles(C) {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(GlobalStyles$1, _extends({}, C, {
    defaultTheme: defaultTheme$2,
    themeId: THEME_ID
  }));
}
dist$2.process.env.NODE_ENV !== "production" && (GlobalStyles.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The styles you want to apply globally.
   */
  styles: PropTypes.oneOfType([PropTypes.array, PropTypes.func, PropTypes.number, PropTypes.object, PropTypes.string, PropTypes.bool])
});
const html = (C, e) => _extends({
  WebkitFontSmoothing: "antialiased",
  // Antialiasing.
  MozOsxFontSmoothing: "grayscale",
  // Antialiasing.
  // Change from `box-sizing: content-box` so that `width`
  // is not affected by `padding` or `border`.
  boxSizing: "border-box",
  // Fix font resize problem in iOS
  WebkitTextSizeAdjust: "100%"
}, e && !C.vars && {
  colorScheme: C.palette.mode
}), body = (C) => _extends({
  color: (C.vars || C).palette.text.primary
}, C.typography.body1, {
  backgroundColor: (C.vars || C).palette.background.default,
  "@media print": {
    // Save printer ink.
    backgroundColor: (C.vars || C).palette.common.white
  }
});
dist$2.process.env.NODE_ENV !== "production" && (PropTypes.node, PropTypes.bool);
function getScopedCssBaselineUtilityClass(C) {
  return generateUtilityClass("MuiScopedCssBaseline", C);
}
generateUtilityClasses("MuiScopedCssBaseline", ["root"]);
const _excluded$T = ["className", "component", "enableColorScheme"], useUtilityClasses$K = (C) => {
  const {
    classes: e
  } = C;
  return composeClasses({
    root: ["root"]
  }, getScopedCssBaselineUtilityClass, e);
}, ScopedCssBaselineRoot = styled$1("div", {
  name: "MuiScopedCssBaseline",
  slot: "Root",
  overridesResolver: (C, e) => e.root
})(({
  theme: C,
  ownerState: e
}) => {
  const T = {};
  return e.enableColorScheme && C.colorSchemes && Object.entries(C.colorSchemes).forEach(([$, V]) => {
    var J;
    T[`&${C.getColorSchemeSelector($).replace(/\s*&/, "")}`] = {
      colorScheme: (J = V.palette) == null ? void 0 : J.mode
    };
  }), _extends({}, html(C, e.enableColorScheme), body(C), {
    "& *, & *::before, & *::after": {
      boxSizing: "inherit"
    },
    "& strong, & b": {
      fontWeight: C.typography.fontWeightBold
    }
  }, T);
}), ScopedCssBaseline = /* @__PURE__ */ React$1.forwardRef(function(e, T) {
  const $ = useDefaultProps({
    props: e,
    name: "MuiScopedCssBaseline"
  }), {
    className: V,
    component: J = "div"
  } = $, ee = _objectWithoutPropertiesLoose($, _excluded$T), te = _extends({}, $, {
    component: J
  }), re = useUtilityClasses$K(te);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(ScopedCssBaselineRoot, _extends({
    as: J,
    className: clsx(re.root, V),
    ref: T,
    ownerState: te
  }, ee));
});
dist$2.process.env.NODE_ENV !== "production" && (ScopedCssBaseline.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes.elementType,
  /**
   * Enable `color-scheme` CSS property to use `theme.palette.mode`.
   * For more details, check out https://developer.mozilla.org/en-US/docs/Web/CSS/color-scheme
   * For browser support, check out https://caniuse.com/?search=color-scheme
   */
  enableColorScheme: PropTypes.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object])
});
function getUnit(C) {
  return String(C).match(/[\d.\-+]*\s*(.*)/)[1] || "";
}
function toUnitless(C) {
  return parseFloat(C);
}
function useTheme$1() {
  const C = useTheme$3(defaultTheme$2);
  return dist$2.process.env.NODE_ENV !== "production" && React$1.useDebugValue(C), C[THEME_ID] || C;
}
const _excluded$S = ["theme"];
function ThemeProvider(C) {
  let {
    theme: e
  } = C, T = _objectWithoutPropertiesLoose(C, _excluded$S);
  const $ = e[THEME_ID];
  return /* @__PURE__ */ jsxRuntimeExports.jsx(ThemeProvider$1, _extends({}, T, {
    themeId: $ ? THEME_ID : void 0,
    theme: $ || e
  }));
}
dist$2.process.env.NODE_ENV !== "production" && (ThemeProvider.propTypes = {
  /**
   * Your component tree.
   */
  children: PropTypes.node,
  /**
   * A theme object. You can provide a function to extend the outer theme.
   */
  theme: PropTypes.oneOfType([PropTypes.object, PropTypes.func]).isRequired
});
const getOverlayAlpha = (C) => {
  let e;
  return C < 1 ? e = 5.11916 * C ** 2 : e = 4.5 * Math.log(C + 1) + 2, (e / 100).toFixed(2);
};
function n$1(C) {
  for (var e = arguments.length, T = Array(e > 1 ? e - 1 : 0), $ = 1; $ < e; $++) T[$ - 1] = arguments[$];
  if (dist$2.process.env.NODE_ENV !== "production") {
    var V = Y[C], J = V ? typeof V == "function" ? V.apply(null, T) : V : "unknown error nr: " + C;
    throw Error("[Immer] " + J);
  }
  throw Error("[Immer] minified error nr: " + C + (T.length ? " " + T.map(function(ee) {
    return "'" + ee + "'";
  }).join(",") : "") + ". Find the full error at: https://bit.ly/3cXEKWf");
}
function r(C) {
  return !!C && !!C[Q];
}
function t(C) {
  var e;
  return !!C && (function(T) {
    if (!T || typeof T != "object") return !1;
    var $ = Object.getPrototypeOf(T);
    if ($ === null) return !0;
    var V = Object.hasOwnProperty.call($, "constructor") && $.constructor;
    return V === Object || typeof V == "function" && Function.toString.call(V) === Z;
  }(C) || Array.isArray(C) || !!C[L] || !!(!((e = C.constructor) === null || e === void 0) && e[L]) || s(C) || v(C));
}
function i$2(C, e, T) {
  T === void 0 && (T = !1), o$2(C) === 0 ? (T ? Object.keys : nn)(C).forEach(function($) {
    T && typeof $ == "symbol" || e($, C[$], C);
  }) : C.forEach(function($, V) {
    return e(V, $, C);
  });
}
function o$2(C) {
  var e = C[Q];
  return e ? e.i > 3 ? e.i - 4 : e.i : Array.isArray(C) ? 1 : s(C) ? 2 : v(C) ? 3 : 0;
}
function u(C, e) {
  return o$2(C) === 2 ? C.has(e) : Object.prototype.hasOwnProperty.call(C, e);
}
function a$1(C, e) {
  return o$2(C) === 2 ? C.get(e) : C[e];
}
function f$2(C, e, T) {
  var $ = o$2(C);
  $ === 2 ? C.set(e, T) : $ === 3 ? C.add(T) : C[e] = T;
}
function c$1(C, e) {
  return C === e ? C !== 0 || 1 / C == 1 / e : C != C && e != e;
}
function s(C) {
  return X && C instanceof Map;
}
function v(C) {
  return q && C instanceof Set;
}
function p(C) {
  return C.o || C.t;
}
function l(C) {
  if (Array.isArray(C)) return Array.prototype.slice.call(C);
  var e = rn(C);
  delete e[Q];
  for (var T = nn(e), $ = 0; $ < T.length; $++) {
    var V = T[$], J = e[V];
    J.writable === !1 && (J.writable = !0, J.configurable = !0), (J.get || J.set) && (e[V] = { configurable: !0, writable: !0, enumerable: J.enumerable, value: C[V] });
  }
  return Object.create(Object.getPrototypeOf(C), e);
}
function d(C, e) {
  return e === void 0 && (e = !1), y(C) || r(C) || !t(C) || (o$2(C) > 1 && (C.set = C.add = C.clear = C.delete = h), Object.freeze(C), e && i$2(C, function(T, $) {
    return d($, !0);
  }, !0)), C;
}
function h() {
  n$1(2);
}
function y(C) {
  return C == null || typeof C != "object" || Object.isFrozen(C);
}
function b$1(C) {
  var e = tn[C];
  return e || n$1(18, C), e;
}
function m(C, e) {
  tn[C] || (tn[C] = e);
}
function _$4() {
  return dist$2.process.env.NODE_ENV === "production" || U || n$1(0), U;
}
function j(C, e) {
  e && (b$1("Patches"), C.u = [], C.s = [], C.v = e);
}
function g(C) {
  O(C), C.p.forEach(S$1), C.p = null;
}
function O(C) {
  C === U && (U = C.l);
}
function w(C) {
  return U = { p: [], l: U, h: C, m: !0, _: 0 };
}
function S$1(C) {
  var e = C[Q];
  e.i === 0 || e.i === 1 ? e.j() : e.g = !0;
}
function P(C, e) {
  e._ = e.p.length;
  var T = e.p[0], $ = C !== void 0 && C !== T;
  return e.h.O || b$1("ES5").S(e, C, $), $ ? (T[Q].P && (g(e), n$1(4)), t(C) && (C = M(e, C), e.l || x(e, C)), e.u && b$1("Patches").M(T[Q].t, C, e.u, e.s)) : C = M(e, T, []), g(e), e.u && e.v(e.u, e.s), C !== H ? C : void 0;
}
function M(C, e, T) {
  if (y(e)) return e;
  var $ = e[Q];
  if (!$) return i$2(e, function(te, re) {
    return A(C, $, e, te, re, T);
  }, !0), e;
  if ($.A !== C) return e;
  if (!$.P) return x(C, $.t, !0), $.t;
  if (!$.I) {
    $.I = !0, $.A._--;
    var V = $.i === 4 || $.i === 5 ? $.o = l($.k) : $.o, J = V, ee = !1;
    $.i === 3 && (J = new Set(V), V.clear(), ee = !0), i$2(J, function(te, re) {
      return A(C, $, V, te, re, T, ee);
    }), x(C, V, !1), T && C.u && b$1("Patches").N($, T, C.u, C.s);
  }
  return $.o;
}
function A(C, e, T, $, V, J, ee) {
  if (dist$2.process.env.NODE_ENV !== "production" && V === T && n$1(5), r(V)) {
    var te = M(C, V, J && e && e.i !== 3 && !u(e.R, $) ? J.concat($) : void 0);
    if (f$2(T, $, te), !r(te)) return;
    C.m = !1;
  } else ee && T.add(V);
  if (t(V) && !y(V)) {
    if (!C.h.D && C._ < 1) return;
    M(C, V), e && e.A.l || x(C, V);
  }
}
function x(C, e, T) {
  T === void 0 && (T = !1), !C.l && C.h.D && C.m && d(e, T);
}
function z(C, e) {
  var T = C[Q];
  return (T ? p(T) : C)[e];
}
function I(C, e) {
  if (e in C) for (var T = Object.getPrototypeOf(C); T; ) {
    var $ = Object.getOwnPropertyDescriptor(T, e);
    if ($) return $;
    T = Object.getPrototypeOf(T);
  }
}
function k(C) {
  C.P || (C.P = !0, C.l && k(C.l));
}
function E(C) {
  C.o || (C.o = l(C.t));
}
function N$1(C, e, T) {
  var $ = s(e) ? b$1("MapSet").F(e, T) : v(e) ? b$1("MapSet").T(e, T) : C.O ? function(V, J) {
    var ee = Array.isArray(V), te = { i: ee ? 1 : 0, A: J ? J.A : _$4(), P: !1, I: !1, R: {}, l: J, t: V, k: null, o: null, j: null, C: !1 }, re = te, ie = en;
    ee && (re = [te], ie = on);
    var se = Proxy.revocable(re, ie), de = se.revoke, ue = se.proxy;
    return te.k = ue, te.j = de, ue;
  }(e, T) : b$1("ES5").J(e, T);
  return (T ? T.A : _$4()).p.push($), $;
}
function R(C) {
  return r(C) || n$1(22, C), function e(T) {
    if (!t(T)) return T;
    var $, V = T[Q], J = o$2(T);
    if (V) {
      if (!V.P && (V.i < 4 || !b$1("ES5").K(V))) return V.t;
      V.I = !0, $ = D(T, J), V.I = !1;
    } else $ = D(T, J);
    return i$2($, function(ee, te) {
      V && a$1(V.t, ee) === te || f$2($, ee, e(te));
    }), J === 3 ? new Set($) : $;
  }(C);
}
function D(C, e) {
  switch (e) {
    case 2:
      return new Map(C);
    case 3:
      return Array.from(C);
  }
  return l(C);
}
function F() {
  function C(ee, te) {
    var re = J[ee];
    return re ? re.enumerable = te : J[ee] = re = { configurable: !0, enumerable: te, get: function() {
      var ie = this[Q];
      return dist$2.process.env.NODE_ENV !== "production" && V(ie), en.get(ie, ee);
    }, set: function(ie) {
      var se = this[Q];
      dist$2.process.env.NODE_ENV !== "production" && V(se), en.set(se, ee, ie);
    } }, re;
  }
  function e(ee) {
    for (var te = ee.length - 1; te >= 0; te--) {
      var re = ee[te][Q];
      if (!re.P) switch (re.i) {
        case 5:
          $(re) && k(re);
          break;
        case 4:
          T(re) && k(re);
      }
    }
  }
  function T(ee) {
    for (var te = ee.t, re = ee.k, ie = nn(re), se = ie.length - 1; se >= 0; se--) {
      var de = ie[se];
      if (de !== Q) {
        var ue = te[de];
        if (ue === void 0 && !u(te, de)) return !0;
        var fe = re[de], he = fe && fe[Q];
        if (he ? he.t !== ue : !c$1(fe, ue)) return !0;
      }
    }
    var me = !!te[Q];
    return ie.length !== nn(te).length + (me ? 0 : 1);
  }
  function $(ee) {
    var te = ee.k;
    if (te.length !== ee.t.length) return !0;
    var re = Object.getOwnPropertyDescriptor(te, te.length - 1);
    if (re && !re.get) return !0;
    for (var ie = 0; ie < te.length; ie++) if (!te.hasOwnProperty(ie)) return !0;
    return !1;
  }
  function V(ee) {
    ee.g && n$1(3, JSON.stringify(p(ee)));
  }
  var J = {};
  m("ES5", { J: function(ee, te) {
    var re = Array.isArray(ee), ie = function(de, ue) {
      if (de) {
        for (var fe = Array(ue.length), he = 0; he < ue.length; he++) Object.defineProperty(fe, "" + he, C(he, !0));
        return fe;
      }
      var me = rn(ue);
      delete me[Q];
      for (var xe = nn(me), ve = 0; ve < xe.length; ve++) {
        var Te = xe[ve];
        me[Te] = C(Te, de || !!me[Te].enumerable);
      }
      return Object.create(Object.getPrototypeOf(ue), me);
    }(re, ee), se = { i: re ? 5 : 4, A: te ? te.A : _$4(), P: !1, I: !1, R: {}, l: te, t: ee, k: ie, o: null, g: !1, C: !1 };
    return Object.defineProperty(ie, Q, { value: se, writable: !0 }), ie;
  }, S: function(ee, te, re) {
    re ? r(te) && te[Q].A === ee && e(ee.p) : (ee.u && function ie(se) {
      if (se && typeof se == "object") {
        var de = se[Q];
        if (de) {
          var ue = de.t, fe = de.k, he = de.R, me = de.i;
          if (me === 4) i$2(fe, function(Ee) {
            Ee !== Q && (ue[Ee] !== void 0 || u(ue, Ee) ? he[Ee] || ie(fe[Ee]) : (he[Ee] = !0, k(de)));
          }), i$2(ue, function(Ee) {
            fe[Ee] !== void 0 || u(fe, Ee) || (he[Ee] = !1, k(de));
          });
          else if (me === 5) {
            if ($(de) && (k(de), he.length = !0), fe.length < ue.length) for (var xe = fe.length; xe < ue.length; xe++) he[xe] = !1;
            else for (var ve = ue.length; ve < fe.length; ve++) he[ve] = !0;
            for (var Te = Math.min(fe.length, ue.length), we = 0; we < Te; we++) fe.hasOwnProperty(we) || (he[we] = !0), he[we] === void 0 && ie(fe[we]);
          }
        }
      }
    }(ee.p[0]), e(ee.p));
  }, K: function(ee) {
    return ee.i === 4 ? T(ee) : $(ee);
  } });
}
var G, U, W = typeof Symbol < "u" && typeof Symbol("x") == "symbol", X = typeof Map < "u", q = typeof Set < "u", B = typeof Proxy < "u" && Proxy.revocable !== void 0 && typeof Reflect < "u", H = W ? Symbol.for("immer-nothing") : ((G = {})["immer-nothing"] = !0, G), L = W ? Symbol.for("immer-draftable") : "__$immer_draftable", Q = W ? Symbol.for("immer-state") : "__$immer_state", Y = { 0: "Illegal state", 1: "Immer drafts cannot have computed properties", 2: "This object has been frozen and should not be mutated", 3: function(C) {
  return "Cannot use a proxy that has been revoked. Did you pass an object from inside an immer function to an async process? " + C;
}, 4: "An immer producer returned a new value *and* modified its draft. Either return a new value *or* modify the draft.", 5: "Immer forbids circular references", 6: "The first or second argument to `produce` must be a function", 7: "The third argument to `produce` must be a function or undefined", 8: "First argument to `createDraft` must be a plain object, an array, or an immerable object", 9: "First argument to `finishDraft` must be a draft returned by `createDraft`", 10: "The given draft is already finalized", 11: "Object.defineProperty() cannot be used on an Immer draft", 12: "Object.setPrototypeOf() cannot be used on an Immer draft", 13: "Immer only supports deleting array indices", 14: "Immer only supports setting array indices and the 'length' property", 15: function(C) {
  return "Cannot apply patch, path doesn't resolve: " + C;
}, 16: 'Sets cannot have "replace" patches.', 17: function(C) {
  return "Unsupported patch operation: " + C;
}, 18: function(C) {
  return "The plugin for '" + C + "' has not been loaded into Immer. To enable the plugin, import and call `enable" + C + "()` when initializing your application.";
}, 20: "Cannot use proxies if Proxy, Proxy.revocable or Reflect are not available", 21: function(C) {
  return "produce can only be called on things that are draftable: plain objects, arrays, Map, Set or classes that are marked with '[immerable]: true'. Got '" + C + "'";
}, 22: function(C) {
  return "'current' expects a draft, got: " + C;
}, 23: function(C) {
  return "'original' expects a draft, got: " + C;
}, 24: "Patching reserved attributes like __proto__, prototype and constructor is not allowed" }, Z = "" + Object.prototype.constructor, nn = typeof Reflect < "u" && Reflect.ownKeys ? Reflect.ownKeys : Object.getOwnPropertySymbols !== void 0 ? function(C) {
  return Object.getOwnPropertyNames(C).concat(Object.getOwnPropertySymbols(C));
} : Object.getOwnPropertyNames, rn = Object.getOwnPropertyDescriptors || function(C) {
  var e = {};
  return nn(C).forEach(function(T) {
    e[T] = Object.getOwnPropertyDescriptor(C, T);
  }), e;
}, tn = {}, en = { get: function(C, e) {
  if (e === Q) return C;
  var T = p(C);
  if (!u(T, e)) return function(V, J, ee) {
    var te, re = I(J, ee);
    return re ? "value" in re ? re.value : (te = re.get) === null || te === void 0 ? void 0 : te.call(V.k) : void 0;
  }(C, T, e);
  var $ = T[e];
  return C.I || !t($) ? $ : $ === z(C.t, e) ? (E(C), C.o[e] = N$1(C.A.h, $, C)) : $;
}, has: function(C, e) {
  return e in p(C);
}, ownKeys: function(C) {
  return Reflect.ownKeys(p(C));
}, set: function(C, e, T) {
  var $ = I(p(C), e);
  if ($ != null && $.set) return $.set.call(C.k, T), !0;
  if (!C.P) {
    var V = z(p(C), e), J = V == null ? void 0 : V[Q];
    if (J && J.t === T) return C.o[e] = T, C.R[e] = !1, !0;
    if (c$1(T, V) && (T !== void 0 || u(C.t, e))) return !0;
    E(C), k(C);
  }
  return C.o[e] === T && (T !== void 0 || e in C.o) || Number.isNaN(T) && Number.isNaN(C.o[e]) || (C.o[e] = T, C.R[e] = !0), !0;
}, deleteProperty: function(C, e) {
  return z(C.t, e) !== void 0 || e in C.t ? (C.R[e] = !1, E(C), k(C)) : delete C.R[e], C.o && delete C.o[e], !0;
}, getOwnPropertyDescriptor: function(C, e) {
  var T = p(C), $ = Reflect.getOwnPropertyDescriptor(T, e);
  return $ && { writable: !0, configurable: C.i !== 1 || e !== "length", enumerable: $.enumerable, value: T[e] };
}, defineProperty: function() {
  n$1(11);
}, getPrototypeOf: function(C) {
  return Object.getPrototypeOf(C.t);
}, setPrototypeOf: function() {
  n$1(12);
} }, on = {};
i$2(en, function(C, e) {
  on[C] = function() {
    return arguments[0] = arguments[0][0], e.apply(this, arguments);
  };
}), on.deleteProperty = function(C, e) {
  return dist$2.process.env.NODE_ENV !== "production" && isNaN(parseInt(e)) && n$1(13), on.set.call(this, C, e, void 0);
}, on.set = function(C, e, T) {
  return dist$2.process.env.NODE_ENV !== "production" && e !== "length" && isNaN(parseInt(e)) && n$1(14), en.set.call(this, C[0], e, T, C[0]);
};
var un = function() {
  function C(T) {
    var $ = this;
    this.O = B, this.D = !0, this.produce = function(V, J, ee) {
      if (typeof V == "function" && typeof J != "function") {
        var te = J;
        J = V;
        var re = $;
        return function(me) {
          var xe = this;
          me === void 0 && (me = te);
          for (var ve = arguments.length, Te = Array(ve > 1 ? ve - 1 : 0), we = 1; we < ve; we++) Te[we - 1] = arguments[we];
          return re.produce(me, function(Ee) {
            var Me;
            return (Me = J).call.apply(Me, [xe, Ee].concat(Te));
          });
        };
      }
      var ie;
      if (typeof J != "function" && n$1(6), ee !== void 0 && typeof ee != "function" && n$1(7), t(V)) {
        var se = w($), de = N$1($, V, void 0), ue = !0;
        try {
          ie = J(de), ue = !1;
        } finally {
          ue ? g(se) : O(se);
        }
        return typeof Promise < "u" && ie instanceof Promise ? ie.then(function(me) {
          return j(se, ee), P(me, se);
        }, function(me) {
          throw g(se), me;
        }) : (j(se, ee), P(ie, se));
      }
      if (!V || typeof V != "object") {
        if ((ie = J(V)) === void 0 && (ie = V), ie === H && (ie = void 0), $.D && d(ie, !0), ee) {
          var fe = [], he = [];
          b$1("Patches").M(V, ie, fe, he), ee(fe, he);
        }
        return ie;
      }
      n$1(21, V);
    }, this.produceWithPatches = function(V, J) {
      if (typeof V == "function") return function(ie) {
        for (var se = arguments.length, de = Array(se > 1 ? se - 1 : 0), ue = 1; ue < se; ue++) de[ue - 1] = arguments[ue];
        return $.produceWithPatches(ie, function(fe) {
          return V.apply(void 0, [fe].concat(de));
        });
      };
      var ee, te, re = $.produce(V, J, function(ie, se) {
        ee = ie, te = se;
      });
      return typeof Promise < "u" && re instanceof Promise ? re.then(function(ie) {
        return [ie, ee, te];
      }) : [re, ee, te];
    }, typeof (T == null ? void 0 : T.useProxies) == "boolean" && this.setUseProxies(T.useProxies), typeof (T == null ? void 0 : T.autoFreeze) == "boolean" && this.setAutoFreeze(T.autoFreeze);
  }
  var e = C.prototype;
  return e.createDraft = function(T) {
    t(T) || n$1(8), r(T) && (T = R(T));
    var $ = w(this), V = N$1(this, T, void 0);
    return V[Q].C = !0, O($), V;
  }, e.finishDraft = function(T, $) {
    var V = T && T[Q];
    dist$2.process.env.NODE_ENV !== "production" && (V && V.C || n$1(9), V.I && n$1(10));
    var J = V.A;
    return j(J, $), P(void 0, J);
  }, e.setAutoFreeze = function(T) {
    this.D = T;
  }, e.setUseProxies = function(T) {
    T && !B && n$1(20), this.O = T;
  }, e.applyPatches = function(T, $) {
    var V;
    for (V = $.length - 1; V >= 0; V--) {
      var J = $[V];
      if (J.path.length === 0 && J.op === "replace") {
        T = J.value;
        break;
      }
    }
    V > -1 && ($ = $.slice(V + 1));
    var ee = b$1("Patches").$;
    return r(T) ? ee(T, $) : this.produce(T, function(te) {
      return ee(te, $);
    });
  }, C;
}(), an = new un(), fn = an.produce;
an.produceWithPatches.bind(an);
an.setAutoFreeze.bind(an);
an.setUseProxies.bind(an);
an.applyPatches.bind(an);
an.createDraft.bind(an);
an.finishDraft.bind(an);
function _defineProperty(C, e, T) {
  return (e = toPropertyKey(e)) in C ? Object.defineProperty(C, e, {
    value: T,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : C[e] = T, C;
}
function ownKeys(C, e) {
  var T = Object.keys(C);
  if (Object.getOwnPropertySymbols) {
    var $ = Object.getOwnPropertySymbols(C);
    e && ($ = $.filter(function(V) {
      return Object.getOwnPropertyDescriptor(C, V).enumerable;
    })), T.push.apply(T, $);
  }
  return T;
}
function _objectSpread2(C) {
  for (var e = 1; e < arguments.length; e++) {
    var T = arguments[e] != null ? arguments[e] : {};
    e % 2 ? ownKeys(Object(T), !0).forEach(function($) {
      _defineProperty(C, $, T[$]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(C, Object.getOwnPropertyDescriptors(T)) : ownKeys(Object(T)).forEach(function($) {
      Object.defineProperty(C, $, Object.getOwnPropertyDescriptor(T, $));
    });
  }
  return C;
}
function formatProdErrorMessage(C) {
  return "Minified Redux error #" + C + "; visit https://redux.js.org/Errors?code=" + C + " for the full message or use the non-minified dev environment for full errors. ";
}
var $$observable = function() {
  return typeof Symbol == "function" && Symbol.observable || "@@observable";
}(), randomString = function() {
  return Math.random().toString(36).substring(7).split("").join(".");
}, ActionTypes = {
  INIT: "@@redux/INIT" + randomString(),
  REPLACE: "@@redux/REPLACE" + randomString(),
  PROBE_UNKNOWN_ACTION: function() {
    return "@@redux/PROBE_UNKNOWN_ACTION" + randomString();
  }
};
function isPlainObject$2(C) {
  if (typeof C != "object" || C === null) return !1;
  for (var e = C; Object.getPrototypeOf(e) !== null; )
    e = Object.getPrototypeOf(e);
  return Object.getPrototypeOf(C) === e;
}
function miniKindOf(C) {
  if (C === void 0) return "undefined";
  if (C === null) return "null";
  var e = typeof C;
  switch (e) {
    case "boolean":
    case "string":
    case "number":
    case "symbol":
    case "function":
      return e;
  }
  if (Array.isArray(C)) return "array";
  if (isDate$1(C)) return "date";
  if (isError$1(C)) return "error";
  var T = ctorName(C);
  switch (T) {
    case "Symbol":
    case "Promise":
    case "WeakMap":
    case "WeakSet":
    case "Map":
    case "Set":
      return T;
  }
  return e.slice(8, -1).toLowerCase().replace(/\s/g, "");
}
function ctorName(C) {
  return typeof C.constructor == "function" ? C.constructor.name : null;
}
function isError$1(C) {
  return C instanceof Error || typeof C.message == "string" && C.constructor && typeof C.constructor.stackTraceLimit == "number";
}
function isDate$1(C) {
  return C instanceof Date ? !0 : typeof C.toDateString == "function" && typeof C.getDate == "function" && typeof C.setDate == "function";
}
function kindOf$1(C) {
  var e = typeof C;
  return dist$2.process.env.NODE_ENV !== "production" && (e = miniKindOf(C)), e;
}
function createStore(C, e, T) {
  var $;
  if (typeof e == "function" && typeof T == "function" || typeof T == "function" && typeof arguments[3] == "function")
    throw new Error(dist$2.process.env.NODE_ENV === "production" ? formatProdErrorMessage(0) : "It looks like you are passing several store enhancers to createStore(). This is not supported. Instead, compose them together to a single function. See https://redux.js.org/tutorials/fundamentals/part-4-store#creating-a-store-with-enhancers for an example.");
  if (typeof e == "function" && typeof T > "u" && (T = e, e = void 0), typeof T < "u") {
    if (typeof T != "function")
      throw new Error(dist$2.process.env.NODE_ENV === "production" ? formatProdErrorMessage(1) : "Expected the enhancer to be a function. Instead, received: '" + kindOf$1(T) + "'");
    return T(createStore)(C, e);
  }
  if (typeof C != "function")
    throw new Error(dist$2.process.env.NODE_ENV === "production" ? formatProdErrorMessage(2) : "Expected the root reducer to be a function. Instead, received: '" + kindOf$1(C) + "'");
  var V = C, J = e, ee = [], te = ee, re = !1;
  function ie() {
    te === ee && (te = ee.slice());
  }
  function se() {
    if (re)
      throw new Error(dist$2.process.env.NODE_ENV === "production" ? formatProdErrorMessage(3) : "You may not call store.getState() while the reducer is executing. The reducer has already received the state as an argument. Pass it down from the top reducer instead of reading it from the store.");
    return J;
  }
  function de(me) {
    if (typeof me != "function")
      throw new Error(dist$2.process.env.NODE_ENV === "production" ? formatProdErrorMessage(4) : "Expected the listener to be a function. Instead, received: '" + kindOf$1(me) + "'");
    if (re)
      throw new Error(dist$2.process.env.NODE_ENV === "production" ? formatProdErrorMessage(5) : "You may not call store.subscribe() while the reducer is executing. If you would like to be notified after the store has been updated, subscribe from a component and invoke store.getState() in the callback to access the latest state. See https://redux.js.org/api/store#subscribelistener for more details.");
    var xe = !0;
    return ie(), te.push(me), function() {
      if (xe) {
        if (re)
          throw new Error(dist$2.process.env.NODE_ENV === "production" ? formatProdErrorMessage(6) : "You may not unsubscribe from a store listener while the reducer is executing. See https://redux.js.org/api/store#subscribelistener for more details.");
        xe = !1, ie();
        var Te = te.indexOf(me);
        te.splice(Te, 1), ee = null;
      }
    };
  }
  function ue(me) {
    if (!isPlainObject$2(me))
      throw new Error(dist$2.process.env.NODE_ENV === "production" ? formatProdErrorMessage(7) : "Actions must be plain objects. Instead, the actual type was: '" + kindOf$1(me) + "'. You may need to add middleware to your store setup to handle dispatching other values, such as 'redux-thunk' to handle dispatching functions. See https://redux.js.org/tutorials/fundamentals/part-4-store#middleware and https://redux.js.org/tutorials/fundamentals/part-6-async-logic#using-the-redux-thunk-middleware for examples.");
    if (typeof me.type > "u")
      throw new Error(dist$2.process.env.NODE_ENV === "production" ? formatProdErrorMessage(8) : 'Actions may not have an undefined "type" property. You may have misspelled an action type string constant.');
    if (re)
      throw new Error(dist$2.process.env.NODE_ENV === "production" ? formatProdErrorMessage(9) : "Reducers may not dispatch actions.");
    try {
      re = !0, J = V(J, me);
    } finally {
      re = !1;
    }
    for (var xe = ee = te, ve = 0; ve < xe.length; ve++) {
      var Te = xe[ve];
      Te();
    }
    return me;
  }
  function fe(me) {
    if (typeof me != "function")
      throw new Error(dist$2.process.env.NODE_ENV === "production" ? formatProdErrorMessage(10) : "Expected the nextReducer to be a function. Instead, received: '" + kindOf$1(me));
    V = me, ue({
      type: ActionTypes.REPLACE
    });
  }
  function he() {
    var me, xe = de;
    return me = {
      /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */
      subscribe: function(Te) {
        if (typeof Te != "object" || Te === null)
          throw new Error(dist$2.process.env.NODE_ENV === "production" ? formatProdErrorMessage(11) : "Expected the observer to be an object. Instead, received: '" + kindOf$1(Te) + "'");
        function we() {
          Te.next && Te.next(se());
        }
        we();
        var Ee = xe(we);
        return {
          unsubscribe: Ee
        };
      }
    }, me[$$observable] = function() {
      return this;
    }, me;
  }
  return ue({
    type: ActionTypes.INIT
  }), $ = {
    dispatch: ue,
    subscribe: de,
    getState: se,
    replaceReducer: fe
  }, $[$$observable] = he, $;
}
function warning(C) {
  typeof console < "u" && typeof console.error == "function" && console.error(C);
  try {
    throw new Error(C);
  } catch {
  }
}
function getUnexpectedStateShapeWarningMessage(C, e, T, $) {
  var V = Object.keys(e), J = T && T.type === ActionTypes.INIT ? "preloadedState argument passed to createStore" : "previous state received by the reducer";
  if (V.length === 0)
    return "Store does not have a valid reducer. Make sure the argument passed to combineReducers is an object whose values are reducers.";
  if (!isPlainObject$2(C))
    return "The " + J + ' has unexpected type of "' + kindOf$1(C) + '". Expected argument to be an object with the following ' + ('keys: "' + V.join('", "') + '"');
  var ee = Object.keys(C).filter(function(te) {
    return !e.hasOwnProperty(te) && !$[te];
  });
  if (ee.forEach(function(te) {
    $[te] = !0;
  }), !(T && T.type === ActionTypes.REPLACE) && ee.length > 0)
    return "Unexpected " + (ee.length > 1 ? "keys" : "key") + " " + ('"' + ee.join('", "') + '" found in ' + J + ". ") + "Expected to find one of the known reducer keys instead: " + ('"' + V.join('", "') + '". Unexpected keys will be ignored.');
}
function assertReducerShape(C) {
  Object.keys(C).forEach(function(e) {
    var T = C[e], $ = T(void 0, {
      type: ActionTypes.INIT
    });
    if (typeof $ > "u")
      throw new Error(dist$2.process.env.NODE_ENV === "production" ? formatProdErrorMessage(12) : 'The slice reducer for key "' + e + `" returned undefined during initialization. If the state passed to the reducer is undefined, you must explicitly return the initial state. The initial state may not be undefined. If you don't want to set a value for this reducer, you can use null instead of undefined.`);
    if (typeof T(void 0, {
      type: ActionTypes.PROBE_UNKNOWN_ACTION()
    }) > "u")
      throw new Error(dist$2.process.env.NODE_ENV === "production" ? formatProdErrorMessage(13) : 'The slice reducer for key "' + e + '" returned undefined when probed with a random type. ' + ("Don't try to handle '" + ActionTypes.INIT + `' or other actions in "redux/*" `) + "namespace. They are considered private. Instead, you must return the current state for any unknown actions, unless it is undefined, in which case you must return the initial state, regardless of the action type. The initial state may not be undefined, but can be null.");
  });
}
function combineReducers(C) {
  for (var e = Object.keys(C), T = {}, $ = 0; $ < e.length; $++) {
    var V = e[$];
    dist$2.process.env.NODE_ENV !== "production" && typeof C[V] > "u" && warning('No reducer provided for key "' + V + '"'), typeof C[V] == "function" && (T[V] = C[V]);
  }
  var J = Object.keys(T), ee;
  dist$2.process.env.NODE_ENV !== "production" && (ee = {});
  var te;
  try {
    assertReducerShape(T);
  } catch (re) {
    te = re;
  }
  return function(ie, se) {
    if (ie === void 0 && (ie = {}), te)
      throw te;
    if (dist$2.process.env.NODE_ENV !== "production") {
      var de = getUnexpectedStateShapeWarningMessage(ie, T, se, ee);
      de && warning(de);
    }
    for (var ue = !1, fe = {}, he = 0; he < J.length; he++) {
      var me = J[he], xe = T[me], ve = ie[me], Te = xe(ve, se);
      if (typeof Te > "u") {
        var we = se && se.type;
        throw new Error(dist$2.process.env.NODE_ENV === "production" ? formatProdErrorMessage(14) : "When called with an action of type " + (we ? '"' + String(we) + '"' : "(unknown type)") + ', the slice reducer for key "' + me + '" returned undefined. To ignore an action, you must explicitly return the previous state. If you want this reducer to hold no value, you can return null instead of undefined.');
      }
      fe[me] = Te, ue = ue || Te !== ve;
    }
    return ue = ue || J.length !== Object.keys(ie).length, ue ? fe : ie;
  };
}
function compose() {
  for (var C = arguments.length, e = new Array(C), T = 0; T < C; T++)
    e[T] = arguments[T];
  return e.length === 0 ? function($) {
    return $;
  } : e.length === 1 ? e[0] : e.reduce(function($, V) {
    return function() {
      return $(V.apply(void 0, arguments));
    };
  });
}
function applyMiddleware() {
  for (var C = arguments.length, e = new Array(C), T = 0; T < C; T++)
    e[T] = arguments[T];
  return function($) {
    return function() {
      var V = $.apply(void 0, arguments), J = function() {
        throw new Error(dist$2.process.env.NODE_ENV === "production" ? formatProdErrorMessage(15) : "Dispatching while constructing your middleware is not allowed. Other middleware would not be applied to this dispatch.");
      }, ee = {
        getState: V.getState,
        dispatch: function() {
          return J.apply(void 0, arguments);
        }
      }, te = e.map(function(re) {
        return re(ee);
      });
      return J = compose.apply(void 0, te)(V.dispatch), _objectSpread2(_objectSpread2({}, V), {}, {
        dispatch: J
      });
    };
  };
}
function createThunkMiddleware(C) {
  var e = function($) {
    var V = $.dispatch, J = $.getState;
    return function(ee) {
      return function(te) {
        return typeof te == "function" ? te(V, J, C) : ee(te);
      };
    };
  };
  return e;
}
var thunk = createThunkMiddleware();
thunk.withExtraArgument = createThunkMiddleware;
var __extends = /* @__PURE__ */ function() {
  var C = function(e, T) {
    return C = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function($, V) {
      $.__proto__ = V;
    } || function($, V) {
      for (var J in V) Object.prototype.hasOwnProperty.call(V, J) && ($[J] = V[J]);
    }, C(e, T);
  };
  return function(e, T) {
    if (typeof T != "function" && T !== null)
      throw new TypeError("Class extends value " + String(T) + " is not a constructor or null");
    C(e, T);
    function $() {
      this.constructor = e;
    }
    e.prototype = T === null ? Object.create(T) : ($.prototype = T.prototype, new $());
  };
}(), __generator = function(C, e) {
  var T = { label: 0, sent: function() {
    if (J[0] & 1) throw J[1];
    return J[1];
  }, trys: [], ops: [] }, $, V, J, ee;
  return ee = { next: te(0), throw: te(1), return: te(2) }, typeof Symbol == "function" && (ee[Symbol.iterator] = function() {
    return this;
  }), ee;
  function te(ie) {
    return function(se) {
      return re([ie, se]);
    };
  }
  function re(ie) {
    if ($) throw new TypeError("Generator is already executing.");
    for (; T; ) try {
      if ($ = 1, V && (J = ie[0] & 2 ? V.return : ie[0] ? V.throw || ((J = V.return) && J.call(V), 0) : V.next) && !(J = J.call(V, ie[1])).done) return J;
      switch (V = 0, J && (ie = [ie[0] & 2, J.value]), ie[0]) {
        case 0:
        case 1:
          J = ie;
          break;
        case 4:
          return T.label++, { value: ie[1], done: !1 };
        case 5:
          T.label++, V = ie[1], ie = [0];
          continue;
        case 7:
          ie = T.ops.pop(), T.trys.pop();
          continue;
        default:
          if (J = T.trys, !(J = J.length > 0 && J[J.length - 1]) && (ie[0] === 6 || ie[0] === 2)) {
            T = 0;
            continue;
          }
          if (ie[0] === 3 && (!J || ie[1] > J[0] && ie[1] < J[3])) {
            T.label = ie[1];
            break;
          }
          if (ie[0] === 6 && T.label < J[1]) {
            T.label = J[1], J = ie;
            break;
          }
          if (J && T.label < J[2]) {
            T.label = J[2], T.ops.push(ie);
            break;
          }
          J[2] && T.ops.pop(), T.trys.pop();
          continue;
      }
      ie = e.call(C, T);
    } catch (se) {
      ie = [6, se], V = 0;
    } finally {
      $ = J = 0;
    }
    if (ie[0] & 5) throw ie[1];
    return { value: ie[0] ? ie[1] : void 0, done: !0 };
  }
}, __spreadArray = function(C, e) {
  for (var T = 0, $ = e.length, V = C.length; T < $; T++, V++)
    C[V] = e[T];
  return C;
}, __defProp = Object.defineProperty, __defProps = Object.defineProperties, __getOwnPropDescs = Object.getOwnPropertyDescriptors, __getOwnPropSymbols = Object.getOwnPropertySymbols, __hasOwnProp = Object.prototype.hasOwnProperty, __propIsEnum = Object.prototype.propertyIsEnumerable, __defNormalProp = function(C, e, T) {
  return e in C ? __defProp(C, e, { enumerable: !0, configurable: !0, writable: !0, value: T }) : C[e] = T;
}, __spreadValues = function(C, e) {
  for (var T in e || (e = {}))
    __hasOwnProp.call(e, T) && __defNormalProp(C, T, e[T]);
  if (__getOwnPropSymbols)
    for (var $ = 0, V = __getOwnPropSymbols(e); $ < V.length; $++) {
      var T = V[$];
      __propIsEnum.call(e, T) && __defNormalProp(C, T, e[T]);
    }
  return C;
}, __spreadProps = function(C, e) {
  return __defProps(C, __getOwnPropDescs(e));
}, __async = function(C, e, T) {
  return new Promise(function($, V) {
    var J = function(re) {
      try {
        te(T.next(re));
      } catch (ie) {
        V(ie);
      }
    }, ee = function(re) {
      try {
        te(T.throw(re));
      } catch (ie) {
        V(ie);
      }
    }, te = function(re) {
      return re.done ? $(re.value) : Promise.resolve(re.value).then(J, ee);
    };
    te((T = T.apply(C, e)).next());
  });
}, composeWithDevTools = typeof window < "u" && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ : function() {
  if (arguments.length !== 0)
    return typeof arguments[0] == "object" ? compose : compose.apply(null, arguments);
};
function isPlainObject$1(C) {
  if (typeof C != "object" || C === null)
    return !1;
  var e = Object.getPrototypeOf(C);
  if (e === null)
    return !0;
  for (var T = e; Object.getPrototypeOf(T) !== null; )
    T = Object.getPrototypeOf(T);
  return e === T;
}
var hasMatchFunction = function(C) {
  return C && typeof C.match == "function";
};
function createAction(C, e) {
  function T() {
    for (var $ = [], V = 0; V < arguments.length; V++)
      $[V] = arguments[V];
    if (e) {
      var J = e.apply(void 0, $);
      if (!J)
        throw new Error("prepareAction did not return an object");
      return __spreadValues(__spreadValues({
        type: C,
        payload: J.payload
      }, "meta" in J && { meta: J.meta }), "error" in J && { error: J.error });
    }
    return { type: C, payload: $[0] };
  }
  return T.toString = function() {
    return "" + C;
  }, T.type = C, T.match = function($) {
    return $.type === C;
  }, T;
}
function isActionCreator(C) {
  return typeof C == "function" && "type" in C && hasMatchFunction(C);
}
function getMessage(C) {
  var e = C ? ("" + C).split("/") : [], T = e[e.length - 1] || "actionCreator";
  return 'Detected an action creator with type "' + (C || "unknown") + `" being dispatched. 
Make sure you're calling the action creator before dispatching, i.e. \`dispatch(` + T + "())` instead of `dispatch(" + T + ")`. This is necessary even if the action has no payload.";
}
function createActionCreatorInvariantMiddleware(C) {
  if (C === void 0 && (C = {}), dist$2.process.env.NODE_ENV === "production")
    return function() {
      return function($) {
        return function(V) {
          return $(V);
        };
      };
    };
  var e = C.isActionCreator, T = e === void 0 ? isActionCreator : e;
  return function() {
    return function($) {
      return function(V) {
        return T(V) && console.warn(getMessage(V.type)), $(V);
      };
    };
  };
}
function getTimeMeasureUtils(C, e) {
  var T = 0;
  return {
    measureTime: function($) {
      var V = Date.now();
      try {
        return $();
      } finally {
        var J = Date.now();
        T += J - V;
      }
    },
    warnIfExceeded: function() {
      T > C && console.warn(e + " took " + T + "ms, which is more than the warning threshold of " + C + `ms. 
If your state or actions are very large, you may want to disable the middleware as it might cause too much of a slowdown in development mode. See https://redux-toolkit.js.org/api/getDefaultMiddleware for instructions.
It is disabled in production builds, so you don't need to worry about that.`);
    }
  };
}
var MiddlewareArray = (
  /** @class */
  function(C) {
    __extends(e, C);
    function e() {
      for (var T = [], $ = 0; $ < arguments.length; $++)
        T[$] = arguments[$];
      var V = C.apply(this, T) || this;
      return Object.setPrototypeOf(V, e.prototype), V;
    }
    return Object.defineProperty(e, Symbol.species, {
      get: function() {
        return e;
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype.concat = function() {
      for (var T = [], $ = 0; $ < arguments.length; $++)
        T[$] = arguments[$];
      return C.prototype.concat.apply(this, T);
    }, e.prototype.prepend = function() {
      for (var T = [], $ = 0; $ < arguments.length; $++)
        T[$] = arguments[$];
      return T.length === 1 && Array.isArray(T[0]) ? new (e.bind.apply(e, __spreadArray([void 0], T[0].concat(this))))() : new (e.bind.apply(e, __spreadArray([void 0], T.concat(this))))();
    }, e;
  }(Array)
), EnhancerArray = (
  /** @class */
  function(C) {
    __extends(e, C);
    function e() {
      for (var T = [], $ = 0; $ < arguments.length; $++)
        T[$] = arguments[$];
      var V = C.apply(this, T) || this;
      return Object.setPrototypeOf(V, e.prototype), V;
    }
    return Object.defineProperty(e, Symbol.species, {
      get: function() {
        return e;
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype.concat = function() {
      for (var T = [], $ = 0; $ < arguments.length; $++)
        T[$] = arguments[$];
      return C.prototype.concat.apply(this, T);
    }, e.prototype.prepend = function() {
      for (var T = [], $ = 0; $ < arguments.length; $++)
        T[$] = arguments[$];
      return T.length === 1 && Array.isArray(T[0]) ? new (e.bind.apply(e, __spreadArray([void 0], T[0].concat(this))))() : new (e.bind.apply(e, __spreadArray([void 0], T.concat(this))))();
    }, e;
  }(Array)
);
function freezeDraftable(C) {
  return t(C) ? fn(C, function() {
  }) : C;
}
var isProduction = dist$2.process.env.NODE_ENV === "production", prefix = "Invariant failed";
function invariant(C, e) {
  if (!C)
    throw isProduction ? new Error(prefix) : new Error(prefix + ": " + (e || ""));
}
function stringify$3(C, e, T, $) {
  return JSON.stringify(C, getSerialize(e, $), T);
}
function getSerialize(C, e) {
  var T = [], $ = [];
  return e || (e = function(V, J) {
    return T[0] === J ? "[Circular ~]" : "[Circular ~." + $.slice(0, T.indexOf(J)).join(".") + "]";
  }), function(V, J) {
    if (T.length > 0) {
      var ee = T.indexOf(this);
      ~ee ? T.splice(ee + 1) : T.push(this), ~ee ? $.splice(ee, 1 / 0, V) : $.push(V), ~T.indexOf(J) && (J = e.call(this, V, J));
    } else
      T.push(J);
    return C == null ? J : C.call(this, V, J);
  };
}
function isImmutableDefault(C) {
  return typeof C != "object" || C == null || Object.isFrozen(C);
}
function trackForMutations(C, e, T) {
  var $ = trackProperties(C, e, T);
  return {
    detectMutations: function() {
      return detectMutations(C, e, $, T);
    }
  };
}
function trackProperties(C, e, T, $, V) {
  e === void 0 && (e = []), $ === void 0 && ($ = ""), V === void 0 && (V = /* @__PURE__ */ new Set());
  var J = { value: T };
  if (!C(T) && !V.has(T)) {
    V.add(T), J.children = {};
    for (var ee in T) {
      var te = $ ? $ + "." + ee : ee;
      e.length && e.indexOf(te) !== -1 || (J.children[ee] = trackProperties(C, e, T[ee], te));
    }
  }
  return J;
}
function detectMutations(C, e, T, $, V, J) {
  e === void 0 && (e = []), V === void 0 && (V = !1), J === void 0 && (J = "");
  var ee = T ? T.value : void 0, te = ee === $;
  if (V && !te && !Number.isNaN($))
    return { wasMutated: !0, path: J };
  if (C(ee) || C($))
    return { wasMutated: !1 };
  var re = {};
  for (var ie in T.children)
    re[ie] = !0;
  for (var ie in $)
    re[ie] = !0;
  var se = e.length > 0, de = function(fe) {
    var he = J ? J + "." + fe : fe;
    if (se) {
      var me = e.some(function(ve) {
        return ve instanceof RegExp ? ve.test(he) : he === ve;
      });
      if (me)
        return "continue";
    }
    var xe = detectMutations(C, e, T.children[fe], $[fe], te, he);
    if (xe.wasMutated)
      return { value: xe };
  };
  for (var ie in re) {
    var ue = de(ie);
    if (typeof ue == "object")
      return ue.value;
  }
  return { wasMutated: !1 };
}
function createImmutableStateInvariantMiddleware(C) {
  if (C === void 0 && (C = {}), dist$2.process.env.NODE_ENV === "production")
    return function() {
      return function(re) {
        return function(ie) {
          return re(ie);
        };
      };
    };
  var e = C.isImmutable, T = e === void 0 ? isImmutableDefault : e, $ = C.ignoredPaths, V = C.warnAfter, J = V === void 0 ? 32 : V, ee = C.ignore;
  $ = $ || ee;
  var te = trackForMutations.bind(null, T, $);
  return function(re) {
    var ie = re.getState, se = ie(), de = te(se), ue;
    return function(fe) {
      return function(he) {
        var me = getTimeMeasureUtils(J, "ImmutableStateInvariantMiddleware");
        me.measureTime(function() {
          se = ie(), ue = de.detectMutations(), de = te(se), invariant(!ue.wasMutated, "A state mutation was detected between dispatches, in the path '" + (ue.path || "") + "'.  This may cause incorrect behavior. (https://redux.js.org/style-guide/style-guide#do-not-mutate-state)");
        });
        var xe = fe(he);
        return me.measureTime(function() {
          se = ie(), ue = de.detectMutations(), de = te(se), ue.wasMutated && invariant(!ue.wasMutated, "A state mutation was detected inside a dispatch, in the path: " + (ue.path || "") + ". Take a look at the reducer(s) handling the action " + stringify$3(he) + ". (https://redux.js.org/style-guide/style-guide#do-not-mutate-state)");
        }), me.warnIfExceeded(), xe;
      };
    };
  };
}
function isPlain(C) {
  var e = typeof C;
  return C == null || e === "string" || e === "boolean" || e === "number" || Array.isArray(C) || isPlainObject$1(C);
}
function findNonSerializableValue(C, e, T, $, V, J) {
  e === void 0 && (e = ""), T === void 0 && (T = isPlain), V === void 0 && (V = []);
  var ee;
  if (!T(C))
    return {
      keyPath: e || "<root>",
      value: C
    };
  if (typeof C != "object" || C === null || J != null && J.has(C))
    return !1;
  for (var te = $ != null ? $(C) : Object.entries(C), re = V.length > 0, ie = function(xe, ve) {
    var Te = e ? e + "." + xe : xe;
    if (re) {
      var we = V.some(function(Ee) {
        return Ee instanceof RegExp ? Ee.test(Te) : Te === Ee;
      });
      if (we)
        return "continue";
    }
    if (!T(ve))
      return { value: {
        keyPath: Te,
        value: ve
      } };
    if (typeof ve == "object" && (ee = findNonSerializableValue(ve, Te, T, $, V, J), ee))
      return { value: ee };
  }, se = 0, de = te; se < de.length; se++) {
    var ue = de[se], fe = ue[0], he = ue[1], me = ie(fe, he);
    if (typeof me == "object")
      return me.value;
  }
  return J && isNestedFrozen(C) && J.add(C), !1;
}
function isNestedFrozen(C) {
  if (!Object.isFrozen(C))
    return !1;
  for (var e = 0, T = Object.values(C); e < T.length; e++) {
    var $ = T[e];
    if (!(typeof $ != "object" || $ === null) && !isNestedFrozen($))
      return !1;
  }
  return !0;
}
function createSerializableStateInvariantMiddleware(C) {
  if (C === void 0 && (C = {}), dist$2.process.env.NODE_ENV === "production")
    return function() {
      return function(we) {
        return function(Ee) {
          return we(Ee);
        };
      };
    };
  var e = C.isSerializable, T = e === void 0 ? isPlain : e, $ = C.getEntries, V = C.ignoredActions, J = V === void 0 ? [] : V, ee = C.ignoredActionPaths, te = ee === void 0 ? ["meta.arg", "meta.baseQueryMeta"] : ee, re = C.ignoredPaths, ie = re === void 0 ? [] : re, se = C.warnAfter, de = se === void 0 ? 32 : se, ue = C.ignoreState, fe = ue === void 0 ? !1 : ue, he = C.ignoreActions, me = he === void 0 ? !1 : he, xe = C.disableCache, ve = xe === void 0 ? !1 : xe, Te = !ve && WeakSet ? /* @__PURE__ */ new WeakSet() : void 0;
  return function(we) {
    return function(Ee) {
      return function(Me) {
        var Ie = Ee(Me), ke = getTimeMeasureUtils(de, "SerializableStateInvariantMiddleware");
        return !me && !(J.length && J.indexOf(Me.type) !== -1) && ke.measureTime(function() {
          var _e = findNonSerializableValue(Me, "", T, $, te, Te);
          if (_e) {
            var De = _e.keyPath, Fe = _e.value;
            console.error("A non-serializable value was detected in an action, in the path: `" + De + "`. Value:", Fe, `
Take a look at the logic that dispatched this action: `, Me, `
(See https://redux.js.org/faq/actions#why-should-type-be-a-string-or-at-least-serializable-why-should-my-action-types-be-constants)`, `
(To allow non-serializable values see: https://redux-toolkit.js.org/usage/usage-guide#working-with-non-serializable-data)`);
          }
        }), fe || (ke.measureTime(function() {
          var _e = we.getState(), De = findNonSerializableValue(_e, "", T, $, ie, Te);
          if (De) {
            var Fe = De.keyPath, Ae = De.value;
            console.error("A non-serializable value was detected in the state, in the path: `" + Fe + "`. Value:", Ae, `
Take a look at the reducer(s) handling this action type: ` + Me.type + `.
(See https://redux.js.org/faq/organizing-state#can-i-put-functions-promises-or-other-non-serializable-items-in-my-store-state)`);
          }
        }), ke.warnIfExceeded()), Ie;
      };
    };
  };
}
function isBoolean$1(C) {
  return typeof C == "boolean";
}
function curryGetDefaultMiddleware() {
  return function(e) {
    return getDefaultMiddleware(e);
  };
}
function getDefaultMiddleware(C) {
  C === void 0 && (C = {});
  var e = C.thunk, T = e === void 0 ? !0 : e, $ = C.immutableCheck, V = $ === void 0 ? !0 : $, J = C.serializableCheck, ee = J === void 0 ? !0 : J, te = C.actionCreatorCheck, re = te === void 0 ? !0 : te, ie = new MiddlewareArray();
  if (T && (isBoolean$1(T) ? ie.push(thunk) : ie.push(thunk.withExtraArgument(T.extraArgument))), dist$2.process.env.NODE_ENV !== "production") {
    if (V) {
      var se = {};
      isBoolean$1(V) || (se = V), ie.unshift(createImmutableStateInvariantMiddleware(se));
    }
    if (ee) {
      var de = {};
      isBoolean$1(ee) || (de = ee), ie.push(createSerializableStateInvariantMiddleware(de));
    }
    if (re) {
      var ue = {};
      isBoolean$1(re) || (ue = re), ie.unshift(createActionCreatorInvariantMiddleware(ue));
    }
  }
  return ie;
}
var IS_PRODUCTION = dist$2.process.env.NODE_ENV === "production";
function configureStore(C) {
  var e = curryGetDefaultMiddleware(), T = C || {}, $ = T.reducer, V = $ === void 0 ? void 0 : $, J = T.middleware, ee = J === void 0 ? e() : J, te = T.devTools, re = te === void 0 ? !0 : te, ie = T.preloadedState, se = ie === void 0 ? void 0 : ie, de = T.enhancers, ue = de === void 0 ? void 0 : de, fe;
  if (typeof V == "function")
    fe = V;
  else if (isPlainObject$1(V))
    fe = combineReducers(V);
  else
    throw new Error('"reducer" is a required argument, and must be a function or an object of functions that can be passed to combineReducers');
  var he = ee;
  if (typeof he == "function" && (he = he(e), !IS_PRODUCTION && !Array.isArray(he)))
    throw new Error("when using a middleware builder function, an array of middleware must be returned");
  if (!IS_PRODUCTION && he.some(function(Ee) {
    return typeof Ee != "function";
  }))
    throw new Error("each middleware provided to configureStore must be a function");
  var me = applyMiddleware.apply(void 0, he), xe = compose;
  re && (xe = composeWithDevTools(__spreadValues({
    trace: !IS_PRODUCTION
  }, typeof re == "object" && re)));
  var ve = new EnhancerArray(me), Te = ve;
  Array.isArray(ue) ? Te = __spreadArray([me], ue) : typeof ue == "function" && (Te = ue(ve));
  var we = xe.apply(void 0, Te);
  return createStore(fe, se, we);
}
function executeReducerBuilderCallback(C) {
  var e = {}, T = [], $, V = {
    addCase: function(J, ee) {
      if (dist$2.process.env.NODE_ENV !== "production") {
        if (T.length > 0)
          throw new Error("`builder.addCase` should only be called before calling `builder.addMatcher`");
        if ($)
          throw new Error("`builder.addCase` should only be called before calling `builder.addDefaultCase`");
      }
      var te = typeof J == "string" ? J : J.type;
      if (!te)
        throw new Error("`builder.addCase` cannot be called with an empty action type");
      if (te in e)
        throw new Error("`builder.addCase` cannot be called with two reducers for the same action type");
      return e[te] = ee, V;
    },
    addMatcher: function(J, ee) {
      if (dist$2.process.env.NODE_ENV !== "production" && $)
        throw new Error("`builder.addMatcher` should only be called before calling `builder.addDefaultCase`");
      return T.push({ matcher: J, reducer: ee }), V;
    },
    addDefaultCase: function(J) {
      if (dist$2.process.env.NODE_ENV !== "production" && $)
        throw new Error("`builder.addDefaultCase` can only be called once");
      return $ = J, V;
    }
  };
  return C(V), [e, T, $];
}
function isStateFunction(C) {
  return typeof C == "function";
}
var hasWarnedAboutObjectNotation = !1;
function createReducer(C, e, T, $) {
  T === void 0 && (T = []), dist$2.process.env.NODE_ENV !== "production" && typeof e == "object" && (hasWarnedAboutObjectNotation || (hasWarnedAboutObjectNotation = !0, console.warn("The object notation for `createReducer` is deprecated, and will be removed in RTK 2.0. Please use the 'builder callback' notation instead: https://redux-toolkit.js.org/api/createReducer")));
  var V = typeof e == "function" ? executeReducerBuilderCallback(e) : [e, T, $], J = V[0], ee = V[1], te = V[2], re;
  if (isStateFunction(C))
    re = function() {
      return freezeDraftable(C());
    };
  else {
    var ie = freezeDraftable(C);
    re = function() {
      return ie;
    };
  }
  function se(de, ue) {
    de === void 0 && (de = re());
    var fe = __spreadArray([
      J[ue.type]
    ], ee.filter(function(he) {
      var me = he.matcher;
      return me(ue);
    }).map(function(he) {
      var me = he.reducer;
      return me;
    }));
    return fe.filter(function(he) {
      return !!he;
    }).length === 0 && (fe = [te]), fe.reduce(function(he, me) {
      if (me)
        if (r(he)) {
          var xe = he, ve = me(xe, ue);
          return ve === void 0 ? he : ve;
        } else {
          if (t(he))
            return fn(he, function(Te) {
              return me(Te, ue);
            });
          var ve = me(he, ue);
          if (ve === void 0) {
            if (he === null)
              return he;
            throw Error("A case reducer on a non-draftable value must not return undefined");
          }
          return ve;
        }
      return he;
    }, de);
  }
  return se.getInitialState = re, se;
}
var hasWarnedAboutObjectNotation2 = !1;
function getType2(C, e) {
  return C + "/" + e;
}
function createSlice(C) {
  var e = C.name;
  if (!e)
    throw new Error("`name` is a required option for createSlice");
  typeof dist$2.process < "u" && dist$2.process.env.NODE_ENV === "development" && C.initialState === void 0 && console.error("You must provide an `initialState` value that is not `undefined`. You may have misspelled `initialState`");
  var T = typeof C.initialState == "function" ? C.initialState : freezeDraftable(C.initialState), $ = C.reducers || {}, V = Object.keys($), J = {}, ee = {}, te = {};
  V.forEach(function(se) {
    var de = $[se], ue = getType2(e, se), fe, he;
    "reducer" in de ? (fe = de.reducer, he = de.prepare) : fe = de, J[se] = fe, ee[ue] = fe, te[se] = he ? createAction(ue, he) : createAction(ue);
  });
  function re() {
    dist$2.process.env.NODE_ENV !== "production" && typeof C.extraReducers == "object" && (hasWarnedAboutObjectNotation2 || (hasWarnedAboutObjectNotation2 = !0, console.warn("The object notation for `createSlice.extraReducers` is deprecated, and will be removed in RTK 2.0. Please use the 'builder callback' notation instead: https://redux-toolkit.js.org/api/createSlice")));
    var se = typeof C.extraReducers == "function" ? executeReducerBuilderCallback(C.extraReducers) : [C.extraReducers], de = se[0], ue = de === void 0 ? {} : de, fe = se[1], he = fe === void 0 ? [] : fe, me = se[2], xe = me === void 0 ? void 0 : me, ve = __spreadValues(__spreadValues({}, ue), ee);
    return createReducer(T, function(Te) {
      for (var we in ve)
        Te.addCase(we, ve[we]);
      for (var Ee = 0, Me = he; Ee < Me.length; Ee++) {
        var Ie = Me[Ee];
        Te.addMatcher(Ie.matcher, Ie.reducer);
      }
      xe && Te.addDefaultCase(xe);
    });
  }
  var ie;
  return {
    name: e,
    reducer: function(se, de) {
      return ie || (ie = re()), ie(se, de);
    },
    actions: te,
    caseReducers: J,
    getInitialState: function() {
      return ie || (ie = re()), ie.getInitialState();
    }
  };
}
var urlAlphabet = "ModuleSymbhasOwnPr-0123456789ABCDEFGHNRVfgctiUvz_KqYTJkLxpZXIjQW", nanoid = function(C) {
  C === void 0 && (C = 21);
  for (var e = "", T = C; T--; )
    e += urlAlphabet[Math.random() * 64 | 0];
  return e;
}, commonProperties = [
  "name",
  "message",
  "stack",
  "code"
], RejectWithValue = (
  /** @class */
  /* @__PURE__ */ function() {
    function C(e, T) {
      this.payload = e, this.meta = T;
    }
    return C;
  }()
), FulfillWithMeta = (
  /** @class */
  /* @__PURE__ */ function() {
    function C(e, T) {
      this.payload = e, this.meta = T;
    }
    return C;
  }()
), miniSerializeError = function(C) {
  if (typeof C == "object" && C !== null) {
    for (var e = {}, T = 0, $ = commonProperties; T < $.length; T++) {
      var V = $[T];
      typeof C[V] == "string" && (e[V] = C[V]);
    }
    return e;
  }
  return { message: String(C) };
};
(function() {
  function C(e, T, $) {
    var V = createAction(e + "/fulfilled", function(se, de, ue, fe) {
      return {
        payload: se,
        meta: __spreadProps(__spreadValues({}, fe || {}), {
          arg: ue,
          requestId: de,
          requestStatus: "fulfilled"
        })
      };
    }), J = createAction(e + "/pending", function(se, de, ue) {
      return {
        payload: void 0,
        meta: __spreadProps(__spreadValues({}, ue || {}), {
          arg: de,
          requestId: se,
          requestStatus: "pending"
        })
      };
    }), ee = createAction(e + "/rejected", function(se, de, ue, fe, he) {
      return {
        payload: fe,
        error: ($ && $.serializeError || miniSerializeError)(se || "Rejected"),
        meta: __spreadProps(__spreadValues({}, he || {}), {
          arg: ue,
          requestId: de,
          rejectedWithValue: !!fe,
          requestStatus: "rejected",
          aborted: (se == null ? void 0 : se.name) === "AbortError",
          condition: (se == null ? void 0 : se.name) === "ConditionError"
        })
      };
    }), te = !1, re = typeof AbortController < "u" ? AbortController : (
      /** @class */
      function() {
        function se() {
          this.signal = {
            aborted: !1,
            addEventListener: function() {
            },
            dispatchEvent: function() {
              return !1;
            },
            onabort: function() {
            },
            removeEventListener: function() {
            },
            reason: void 0,
            throwIfAborted: function() {
            }
          };
        }
        return se.prototype.abort = function() {
          dist$2.process.env.NODE_ENV !== "production" && (te || (te = !0, console.info("This platform does not implement AbortController. \nIf you want to use the AbortController to react to `abort` events, please consider importing a polyfill like 'abortcontroller-polyfill/dist/abortcontroller-polyfill-only'.")));
        }, se;
      }()
    );
    function ie(se) {
      return function(de, ue, fe) {
        var he = $ != null && $.idGenerator ? $.idGenerator(se) : nanoid(), me = new re(), xe;
        function ve(we) {
          xe = we, me.abort();
        }
        var Te = function() {
          return __async(this, null, function() {
            var we, Ee, Me, Ie, ke, _e, De;
            return __generator(this, function(Fe) {
              switch (Fe.label) {
                case 0:
                  return Fe.trys.push([0, 4, , 5]), Ie = (we = $ == null ? void 0 : $.condition) == null ? void 0 : we.call($, se, { getState: ue, extra: fe }), isThenable$1(Ie) ? [4, Ie] : [3, 2];
                case 1:
                  Ie = Fe.sent(), Fe.label = 2;
                case 2:
                  if (Ie === !1 || me.signal.aborted)
                    throw {
                      name: "ConditionError",
                      message: "Aborted due to condition callback returning false."
                    };
                  return ke = new Promise(function(Ae, ne) {
                    return me.signal.addEventListener("abort", function() {
                      return ne({
                        name: "AbortError",
                        message: xe || "Aborted"
                      });
                    });
                  }), de(J(he, se, (Ee = $ == null ? void 0 : $.getPendingMeta) == null ? void 0 : Ee.call($, { requestId: he, arg: se }, { getState: ue, extra: fe }))), [4, Promise.race([
                    ke,
                    Promise.resolve(T(se, {
                      dispatch: de,
                      getState: ue,
                      extra: fe,
                      requestId: he,
                      signal: me.signal,
                      abort: ve,
                      rejectWithValue: function(Ae, ne) {
                        return new RejectWithValue(Ae, ne);
                      },
                      fulfillWithValue: function(Ae, ne) {
                        return new FulfillWithMeta(Ae, ne);
                      }
                    })).then(function(Ae) {
                      if (Ae instanceof RejectWithValue)
                        throw Ae;
                      return Ae instanceof FulfillWithMeta ? V(Ae.payload, he, se, Ae.meta) : V(Ae, he, se);
                    })
                  ])];
                case 3:
                  return Me = Fe.sent(), [3, 5];
                case 4:
                  return _e = Fe.sent(), Me = _e instanceof RejectWithValue ? ee(null, he, se, _e.payload, _e.meta) : ee(_e, he, se), [3, 5];
                case 5:
                  return De = $ && !$.dispatchConditionRejection && ee.match(Me) && Me.meta.condition, De || de(Me), [2, Me];
              }
            });
          });
        }();
        return Object.assign(Te, {
          abort: ve,
          requestId: he,
          arg: se,
          unwrap: function() {
            return Te.then(unwrapResult);
          }
        });
      };
    }
    return Object.assign(ie, {
      pending: J,
      rejected: ee,
      fulfilled: V,
      typePrefix: e
    });
  }
  return C.withTypes = function() {
    return C;
  }, C;
})();
function unwrapResult(C) {
  if (C.meta && C.meta.rejectedWithValue)
    throw C.payload;
  if (C.error)
    throw C.error;
  return C.payload;
}
function isThenable$1(C) {
  return C !== null && typeof C == "object" && typeof C.then == "function";
}
var alm = "listenerMiddleware";
createAction(alm + "/add");
createAction(alm + "/removeAll");
createAction(alm + "/remove");
var promise;
typeof queueMicrotask == "function" && queueMicrotask.bind(typeof window < "u" ? window : typeof dist$2.global < "u" ? dist$2.global : globalThis);
F();
const initialState$4 = {
  txData: void 0,
  sendTx: "",
  redeemTx: "",
  transferComplete: !1,
  route: void 0,
  isResumeTx: !1,
  timestamp: 0
}, redeemSlice = createSlice({
  name: "redeem",
  initialState: initialState$4,
  reducers: {
    setTxDetails: (C, { payload: e }) => {
      C.txData = e;
    },
    setSendTx: (C, { payload: e }) => {
      C.sendTx = e;
    },
    setRoute: (C, { payload: e }) => {
      C.route = e;
    },
    clearRedeem: (C) => {
      Object.keys(C).forEach((e) => {
        C[e] = initialState$4[e];
      });
    },
    setIsResumeTx: (C, { payload: e }) => {
      C.isResumeTx = e;
    },
    setTimestamp: (C, { payload: e }) => {
      C.timestamp = e;
    }
  }
}), {
  setTxDetails,
  setSendTx,
  clearRedeem,
  setRoute: setRoute$1,
  setIsResumeTx,
  setTimestamp
} = redeemSlice.actions, redeemReducer = redeemSlice.reducer;
var Context = /* @__PURE__ */ ((C) => (C.ETH = "Ethereum", C.TERRA = "Terra", C.XPLA = "XPLA", C.SOLANA = "Solana", C.ALGORAND = "Algorand", C.NEAR = "Near", C.APTOS = "Aptos", C.SUI = "Sui", C.OTHER = "OTHER", C))(Context || {});
const TESTNET$1 = {
  Solana: {
    key: "Solana",
    id: 1,
    context: Context.SOLANA,
    finalityThreshold: 32
  },
  Bsc: {
    key: "Bsc",
    id: 4,
    context: Context.ETH,
    finalityThreshold: 3
  },
  Avalanche: {
    key: "Avalanche",
    id: 6,
    context: Context.ETH,
    finalityThreshold: 1
  },
  Fantom: {
    key: "Fantom",
    id: 10,
    context: Context.ETH,
    finalityThreshold: 1
  },
  Celo: {
    key: "Celo",
    id: 14,
    context: Context.ETH,
    finalityThreshold: 1
  },
  Moonbeam: {
    key: "Moonbeam",
    id: 16,
    context: Context.ETH,
    finalityThreshold: 1
  },
  Sui: {
    key: "Sui",
    id: 21,
    context: Context.SUI,
    finalityThreshold: 0
  },
  Aptos: {
    key: "Aptos",
    id: 22,
    context: Context.APTOS,
    finalityThreshold: 0
  },
  Klaytn: {
    key: "Klaytn",
    id: 13,
    context: Context.ETH,
    finalityThreshold: 0
  },
  Scroll: {
    key: "Scroll",
    id: 34,
    context: Context.ETH,
    finalityThreshold: 0
  },
  Blast: {
    key: "Blast",
    id: 36,
    context: Context.ETH,
    finalityThreshold: 0
  },
  Xlayer: {
    key: "Xlayer",
    id: 37,
    context: Context.ETH,
    finalityThreshold: 0
  },
  Sepolia: {
    key: "Sepolia",
    id: 10002,
    context: Context.ETH,
    finalityThreshold: 0
  },
  ArbitrumSepolia: {
    key: "ArbitrumSepolia",
    id: 10003,
    context: Context.ETH,
    finalityThreshold: 0
  },
  BaseSepolia: {
    key: "BaseSepolia",
    id: 10004,
    context: Context.ETH,
    finalityThreshold: 0
  },
  OptimismSepolia: {
    key: "OptimismSepolia",
    id: 10005,
    context: Context.ETH,
    finalityThreshold: 0
  },
  Mantle: {
    key: "Mantle",
    id: 35,
    context: Context.ETH,
    finalityThreshold: 0
  },
  Worldchain: {
    key: "Worldchain",
    id: 45,
    context: Context.ETH,
    finalityThreshold: 0
  }
}, TESTNET_CONFIG = {
  env: "Testnet",
  rpcs: {
    Bsc: "https://data-seed-prebsc-1-s3.binance.org:8545",
    Avalanche: "https://api.avax-test.network/ext/bc/C/rpc",
    Fantom: "https://rpc.ankr.com/fantom_testnet",
    Celo: "https://alfajores-forno.celo-testnet.org",
    Solana: "https://api.devnet.solana.com",
    Moonbeam: "https://rpc.api.moonbase.moonbeam.network",
    Sui: "https://fullnode.testnet.sui.io",
    Aptos: "https://fullnode.testnet.aptoslabs.com/v1",
    Sei: "https://rpc.atlantic-2.seinetwork.io",
    Wormchain: "",
    Osmosis: "https://rpc.osmotest5.osmosis.zone",
    Cosmoshub: "https://rpc.sentry-02.theta-testnet.polypore.xyz",
    Evmos: "https://evmos-testnet-rpc.polkachu.com",
    Kujira: "https://kujira-testnet-rpc.polkachu.com",
    Injective: "https://injective-testnet-rpc.polkachu.com",
    Klaytn: "https://rpc.ankr.com/klaytn_testnet",
    Sepolia: "https://rpc.ankr.com/eth_sepolia",
    ArbitrumSepolia: "https://sepolia-rollup.arbitrum.io/rpc",
    BaseSepolia: "https://base-sepolia-rpc.publicnode.com",
    OptimismSepolia: "https://sepolia.optimism.io",
    Scroll: "https://rpc.ankr.com/scroll_sepolia_testnet",
    Blast: "https://rpc.ankr.com/blast_testnet_sepolia",
    Xlayer: "https://testrpc.xlayer.tech",
    Mantle: "https://rpc.sepolia.mantle.xyz",
    Worldchain: "https://worldchain-sepolia.g.alchemy.com/public"
  },
  rest: {
    Sei: "https://rest.atlantic-2.seinetwork.io",
    Evmos: "https://evmos-testnet-api.polkachu.com",
    Injective: "https://injective-testnet-api.polkachu.com"
  },
  graphql: {
    Aptos: "https://indexer-testnet.staging.gcp.aptosdev.com/v1/graphql"
  },
  chains: TESTNET$1,
  wormholeHosts: ["https://wormhole-v2-testnet-api.certus.one"]
}, MAINNET$1 = {
  Ethereum: {
    key: "Ethereum",
    id: 2,
    context: Context.ETH,
    finalityThreshold: 64
  },
  Solana: {
    key: "Solana",
    id: 1,
    context: Context.SOLANA,
    finalityThreshold: 32
  },
  Polygon: {
    key: "Polygon",
    id: 5,
    context: Context.ETH,
    finalityThreshold: 42
  },
  Bsc: {
    key: "Bsc",
    id: 4,
    context: Context.ETH,
    finalityThreshold: 3
  },
  Avalanche: {
    key: "Avalanche",
    id: 6,
    context: Context.ETH,
    finalityThreshold: 1
  },
  Fantom: {
    key: "Fantom",
    id: 10,
    context: Context.ETH,
    finalityThreshold: 1
  },
  Celo: {
    key: "Celo",
    id: 14,
    context: Context.ETH,
    finalityThreshold: 1
  },
  Moonbeam: {
    key: "Moonbeam",
    id: 16,
    context: Context.ETH,
    finalityThreshold: 1
  },
  Sui: {
    key: "Sui",
    id: 21,
    context: Context.SUI,
    finalityThreshold: 0
  },
  Aptos: {
    key: "Aptos",
    id: 22,
    context: Context.APTOS,
    finalityThreshold: 0
  },
  Arbitrum: {
    key: "Arbitrum",
    id: 23,
    context: Context.ETH,
    finalityThreshold: 0
  },
  Optimism: {
    key: "Optimism",
    id: 24,
    context: Context.ETH,
    finalityThreshold: 0
  },
  Base: {
    key: "Base",
    id: 30,
    context: Context.ETH,
    finalityThreshold: 0
  },
  Klaytn: {
    key: "Klaytn",
    id: 13,
    context: Context.ETH,
    finalityThreshold: 0
  },
  Scroll: {
    key: "Scroll",
    id: 34,
    context: Context.ETH,
    finalityThreshold: 0
  },
  Blast: {
    key: "Blast",
    id: 36,
    context: Context.ETH,
    finalityThreshold: 0
  },
  Mantle: {
    key: "Mantle",
    id: 35,
    context: Context.ETH,
    finalityThreshold: 0
  },
  Xlayer: {
    key: "Xlayer",
    id: 37,
    context: Context.ETH,
    finalityThreshold: 0
  },
  Worldchain: {
    key: "Worldchain",
    id: 45,
    context: Context.ETH,
    finalityThreshold: 0
  }
}, MAINNET_CONFIG = {
  env: "Mainnet",
  rpcs: {
    Ethereum: "https://rpc.ankr.com/eth",
    Solana: "https://solana-mainnet.rpc.extrnode.com",
    Polygon: "https://rpc.ankr.com/polygon",
    Bsc: "https://bscrpc.com",
    Avalanche: "https://rpc.ankr.com/avalanche",
    Fantom: "https://rpc.ankr.com/fantom",
    Celo: "https://rpc.ankr.com/celo",
    Moonbeam: "https://rpc.ankr.com/moonbeam",
    Sui: "https://rpc.mainnet.sui.io",
    Aptos: "https://fullnode.mainnet.aptoslabs.com/v1",
    Arbitrum: "https://rpc.ankr.com/arbitrum",
    Optimism: "https://rpc.ankr.com/optimism",
    Base: "https://base.publicnode.com",
    Sei: "",
    // TODO: fill in
    Wormchain: "https://wormchain-rpc.quickapi.com",
    Osmosis: "https://osmosis-rpc.polkachu.com",
    Cosmoshub: "https://cosmos-rpc.polkachu.com",
    Evmos: "https://evmos-rpc.polkachu.com",
    Kujira: "https://kujira-rpc.polkachu.com",
    Injective: "https://injective-rpc.publicnode.com/",
    // TODO: use the library to get the correct rpc https://docs.ts.injective.network/querying/querying-api/querying-indexer-explorer#fetch-transaction-using-transaction-hash
    Klaytn: "https://rpc.ankr.com/klaytn",
    Scroll: "https://rpc.ankr.com/scroll",
    Blast: "https://rpc.ankr.com/blast",
    Xlayer: "https://rpc.xlayer.tech",
    Mantle: "https://rpc.mantle.xyz",
    Worldchain: "https://worldchain-mainnet.g.alchemy.com/public"
  },
  rest: {
    Sei: "",
    Evmos: "https://evmos-api.polkachu.com",
    Injective: "https://injective-api.polkachu.com"
  },
  graphql: {
    Aptos: "https://indexer.mainnet.aptoslabs.com/v1/graphql"
  },
  chains: MAINNET$1,
  wormholeHosts: [
    "https://wormhole-v2-mainnet-api.certus.one",
    "https://wormhole-v2-mainnet-api.mcf.rocks",
    "https://wormhole-v2-mainnet-api.chainlayer.network",
    "https://wormhole-v2-mainnet-api.staking.fund"
  ]
}, DEVNET$1 = {
  Ethereum: {
    key: "Ethereum",
    id: 2,
    context: Context.ETH,
    finalityThreshold: 64
  }
  //Osmosis: {
  //  key: 'Osmosis',
  //  id: 20,
  //  context: Context.COSMOS,
  //  finalityThreshold: 0,
  //},
  //Wormchain: {
  //  context: Context.COSMOS,
  //  key: 'Wormchain',
  //  id: 3104,
  //  finalityThreshold: 0,
  //},
  //Terra2: {
  //  context: Context.COSMOS,
  //  key: 'Terra2',
  //  id: 18,
  //  finalityThreshold: 0,
  //},
}, DEVNET_CONFIG = {
  env: "Devnet",
  rpcs: {
    Ethereum: "http://localhost:8545",
    Wormchain: "http://localhost:26659",
    Osmosis: "http://localhost:33043",
    Terra2: "http://localhost:26658"
  },
  rest: {},
  graphql: {},
  chains: DEVNET$1,
  wormholeHosts: ["http://localhost:7071"]
}, version$3 = "6.13.4";
function checkType(C, e, T) {
  const $ = e.split("|").map((J) => J.trim());
  for (let J = 0; J < $.length; J++)
    switch (e) {
      case "any":
        return;
      case "bigint":
      case "boolean":
      case "number":
      case "string":
        if (typeof C === e)
          return;
    }
  const V = new Error(`invalid value for type ${e}`);
  throw V.code = "INVALID_ARGUMENT", V.argument = `value.${T}`, V.value = C, V;
}
async function resolveProperties(C) {
  const e = Object.keys(C);
  return (await Promise.all(e.map(($) => Promise.resolve(C[$])))).reduce(($, V, J) => ($[e[J]] = V, $), {});
}
function defineProperties(C, e, T) {
  for (let $ in e) {
    let V = e[$];
    const J = T ? T[$] : null;
    J && checkType(V, J, $), Object.defineProperty(C, $, { enumerable: !0, value: V, writable: !1 });
  }
}
function stringify$2(C) {
  if (C == null)
    return "null";
  if (Array.isArray(C))
    return "[ " + C.map(stringify$2).join(", ") + " ]";
  if (C instanceof Uint8Array) {
    const e = "0123456789abcdef";
    let T = "0x";
    for (let $ = 0; $ < C.length; $++)
      T += e[C[$] >> 4], T += e[C[$] & 15];
    return T;
  }
  if (typeof C == "object" && typeof C.toJSON == "function")
    return stringify$2(C.toJSON());
  switch (typeof C) {
    case "boolean":
    case "symbol":
      return C.toString();
    case "bigint":
      return BigInt(C).toString();
    case "number":
      return C.toString();
    case "string":
      return JSON.stringify(C);
    case "object": {
      const e = Object.keys(C);
      return e.sort(), "{ " + e.map((T) => `${stringify$2(T)}: ${stringify$2(C[T])}`).join(", ") + " }";
    }
  }
  return "[ COULD NOT SERIALIZE ]";
}
function isError(C, e) {
  return C && C.code === e;
}
function isCallException(C) {
  return isError(C, "CALL_EXCEPTION");
}
function makeError(C, e, T) {
  let $ = C;
  {
    const J = [];
    if (T) {
      if ("message" in T || "code" in T || "name" in T)
        throw new Error(`value will overwrite populated values: ${stringify$2(T)}`);
      for (const ee in T) {
        if (ee === "shortMessage")
          continue;
        const te = T[ee];
        J.push(ee + "=" + stringify$2(te));
      }
    }
    J.push(`code=${e}`), J.push(`version=${version$3}`), J.length && (C += " (" + J.join(", ") + ")");
  }
  let V;
  switch (e) {
    case "INVALID_ARGUMENT":
      V = new TypeError(C);
      break;
    case "NUMERIC_FAULT":
    case "BUFFER_OVERRUN":
      V = new RangeError(C);
      break;
    default:
      V = new Error(C);
  }
  return defineProperties(V, { code: e }), T && Object.assign(V, T), V.shortMessage == null && defineProperties(V, { shortMessage: $ }), V;
}
function assert$5(C, e, T, $) {
  if (!C)
    throw makeError(e, T, $);
}
function assertArgument(C, e, T, $) {
  assert$5(C, e, "INVALID_ARGUMENT", { argument: T, value: $ });
}
function assertArgumentCount(C, e, T) {
  T == null && (T = ""), T && (T = ": " + T), assert$5(C >= e, "missing arguemnt" + T, "MISSING_ARGUMENT", {
    count: C,
    expectedCount: e
  }), assert$5(C <= e, "too many arguments" + T, "UNEXPECTED_ARGUMENT", {
    count: C,
    expectedCount: e
  });
}
const _normalizeForms = ["NFD", "NFC", "NFKD", "NFKC"].reduce((C, e) => {
  try {
    if ("test".normalize(e) !== "test")
      throw new Error("bad");
    if (e === "NFD" && "é".normalize("NFD") !== "é")
      throw new Error("broken");
    C.push(e);
  } catch {
  }
  return C;
}, []);
function assertNormalize(C) {
  assert$5(_normalizeForms.indexOf(C) >= 0, "platform missing String.prototype.normalize", "UNSUPPORTED_OPERATION", {
    operation: "String.prototype.normalize",
    info: { form: C }
  });
}
function assertPrivate(C, e, T) {
  if (T == null && (T = ""), C !== e) {
    let $ = T, V = "new";
    T && ($ += ".", V += " " + T), assert$5(!1, `private constructor; use ${$}from* methods`, "UNSUPPORTED_OPERATION", {
      operation: V
    });
  }
}
function _getBytes(C, e, T) {
  if (C instanceof Uint8Array)
    return T ? new Uint8Array(C) : C;
  if (typeof C == "string" && C.match(/^0x(?:[0-9a-f][0-9a-f])*$/i)) {
    const $ = new Uint8Array((C.length - 2) / 2);
    let V = 2;
    for (let J = 0; J < $.length; J++)
      $[J] = parseInt(C.substring(V, V + 2), 16), V += 2;
    return $;
  }
  assertArgument(!1, "invalid BytesLike value", e || "value", C);
}
function getBytes(C, e) {
  return _getBytes(C, e, !1);
}
function getBytesCopy(C, e) {
  return _getBytes(C, e, !0);
}
function isHexString(C, e) {
  return !(typeof C != "string" || !C.match(/^0x[0-9A-Fa-f]*$/) || typeof e == "number" && C.length !== 2 + 2 * e || e === !0 && C.length % 2 !== 0);
}
function isBytesLike(C) {
  return isHexString(C, !0) || C instanceof Uint8Array;
}
const HexCharacters = "0123456789abcdef";
function hexlify(C) {
  const e = getBytes(C);
  let T = "0x";
  for (let $ = 0; $ < e.length; $++) {
    const V = e[$];
    T += HexCharacters[(V & 240) >> 4] + HexCharacters[V & 15];
  }
  return T;
}
function concat(C) {
  return "0x" + C.map((e) => hexlify(e).substring(2)).join("");
}
function dataLength(C) {
  return isHexString(C, !0) ? (C.length - 2) / 2 : getBytes(C).length;
}
function dataSlice(C, e, T) {
  const $ = getBytes(C);
  return T != null && T > $.length && assert$5(!1, "cannot slice beyond data bounds", "BUFFER_OVERRUN", {
    buffer: $,
    length: $.length,
    offset: T
  }), hexlify($.slice(e ?? 0, T ?? $.length));
}
function zeroPad(C, e, T) {
  const $ = getBytes(C);
  assert$5(e >= $.length, "padding exceeds data length", "BUFFER_OVERRUN", {
    buffer: new Uint8Array($),
    length: e,
    offset: e + 1
  });
  const V = new Uint8Array(e);
  return V.fill(0), T ? V.set($, e - $.length) : V.set($, 0), hexlify(V);
}
function zeroPadValue(C, e) {
  return zeroPad(C, e, !0);
}
function zeroPadBytes(C, e) {
  return zeroPad(C, e, !1);
}
const BN_0$a = BigInt(0), BN_1$4 = BigInt(1), maxValue = 9007199254740991;
function fromTwos(C, e) {
  const T = getUint(C, "value"), $ = BigInt(getNumber(e, "width"));
  if (assert$5(T >> $ === BN_0$a, "overflow", "NUMERIC_FAULT", {
    operation: "fromTwos",
    fault: "overflow",
    value: C
  }), T >> $ - BN_1$4) {
    const V = (BN_1$4 << $) - BN_1$4;
    return -((~T & V) + BN_1$4);
  }
  return T;
}
function toTwos(C, e) {
  let T = getBigInt(C, "value");
  const $ = BigInt(getNumber(e, "width")), V = BN_1$4 << $ - BN_1$4;
  if (T < BN_0$a) {
    T = -T, assert$5(T <= V, "too low", "NUMERIC_FAULT", {
      operation: "toTwos",
      fault: "overflow",
      value: C
    });
    const J = (BN_1$4 << $) - BN_1$4;
    return (~T & J) + BN_1$4;
  } else
    assert$5(T < V, "too high", "NUMERIC_FAULT", {
      operation: "toTwos",
      fault: "overflow",
      value: C
    });
  return T;
}
function mask$3(C, e) {
  const T = getUint(C, "value"), $ = BigInt(getNumber(e, "bits"));
  return T & (BN_1$4 << $) - BN_1$4;
}
function getBigInt(C, e) {
  switch (typeof C) {
    case "bigint":
      return C;
    case "number":
      return assertArgument(Number.isInteger(C), "underflow", e || "value", C), assertArgument(C >= -maxValue && C <= maxValue, "overflow", e || "value", C), BigInt(C);
    case "string":
      try {
        if (C === "")
          throw new Error("empty string");
        return C[0] === "-" && C[1] !== "-" ? -BigInt(C.substring(1)) : BigInt(C);
      } catch (T) {
        assertArgument(!1, `invalid BigNumberish string: ${T.message}`, e || "value", C);
      }
  }
  assertArgument(!1, "invalid BigNumberish value", e || "value", C);
}
function getUint(C, e) {
  const T = getBigInt(C, e);
  return assert$5(T >= BN_0$a, "unsigned value cannot be negative", "NUMERIC_FAULT", {
    fault: "overflow",
    operation: "getUint",
    value: C
  }), T;
}
const Nibbles$1 = "0123456789abcdef";
function toBigInt(C) {
  if (C instanceof Uint8Array) {
    let e = "0x0";
    for (const T of C)
      e += Nibbles$1[T >> 4], e += Nibbles$1[T & 15];
    return BigInt(e);
  }
  return getBigInt(C);
}
function getNumber(C, e) {
  switch (typeof C) {
    case "bigint":
      return assertArgument(C >= -maxValue && C <= maxValue, "overflow", e || "value", C), Number(C);
    case "number":
      return assertArgument(Number.isInteger(C), "underflow", e || "value", C), assertArgument(C >= -maxValue && C <= maxValue, "overflow", e || "value", C), C;
    case "string":
      try {
        if (C === "")
          throw new Error("empty string");
        return getNumber(BigInt(C), e);
      } catch (T) {
        assertArgument(!1, `invalid numeric string: ${T.message}`, e || "value", C);
      }
  }
  assertArgument(!1, "invalid numeric value", e || "value", C);
}
function toNumber(C) {
  return getNumber(toBigInt(C));
}
function toBeHex(C, e) {
  let $ = getUint(C, "value").toString(16);
  if (e == null)
    $.length % 2 && ($ = "0" + $);
  else {
    const V = getNumber(e, "width");
    for (assert$5(V * 2 >= $.length, `value exceeds width (${V} bytes)`, "NUMERIC_FAULT", {
      operation: "toBeHex",
      fault: "overflow",
      value: C
    }); $.length < V * 2; )
      $ = "0" + $;
  }
  return "0x" + $;
}
function toBeArray(C) {
  const e = getUint(C, "value");
  if (e === BN_0$a)
    return new Uint8Array([]);
  let T = e.toString(16);
  T.length % 2 && (T = "0" + T);
  const $ = new Uint8Array(T.length / 2);
  for (let V = 0; V < $.length; V++) {
    const J = V * 2;
    $[V] = parseInt(T.substring(J, J + 2), 16);
  }
  return $;
}
function toQuantity(C) {
  let e = hexlify(isBytesLike(C) ? C : toBeArray(C)).substring(2);
  for (; e.startsWith("0"); )
    e = e.substring(1);
  return e === "" && (e = "0"), "0x" + e;
}
const Alphabet = "123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz";
let Lookup = null;
function getAlpha(C) {
  if (Lookup == null) {
    Lookup = {};
    for (let T = 0; T < Alphabet.length; T++)
      Lookup[Alphabet[T]] = BigInt(T);
  }
  const e = Lookup[C];
  return assertArgument(e != null, "invalid base58 value", "letter", C), e;
}
const BN_0$9 = BigInt(0), BN_58 = BigInt(58);
function encodeBase58(C) {
  const e = getBytes(C);
  let T = toBigInt(e), $ = "";
  for (; T; )
    $ = Alphabet[Number(T % BN_58)] + $, T /= BN_58;
  for (let V = 0; V < e.length && !e[V]; V++)
    $ = Alphabet[0] + $;
  return $;
}
function decodeBase58(C) {
  let e = BN_0$9;
  for (let T = 0; T < C.length; T++)
    e *= BN_58, e += getAlpha(C[T]);
  return e;
}
function decodeBase64(C) {
  C = atob(C);
  const e = new Uint8Array(C.length);
  for (let T = 0; T < C.length; T++)
    e[T] = C.charCodeAt(T);
  return getBytes(e);
}
function encodeBase64(C) {
  const e = getBytes(C);
  let T = "";
  for (let $ = 0; $ < e.length; $++)
    T += String.fromCharCode(e[$]);
  return btoa(T);
}
var ba;
class EventPayload {
  /**
   *  Create a new **EventPayload** for %%emitter%% with
   *  the %%listener%% and for %%filter%%.
   */
  constructor(e, T, $) {
    /**
     *  The event filter.
     */
    tt(this, "filter");
    /**
     *  The **EventEmitterable**.
     */
    tt(this, "emitter");
    Ft(this, ba);
    At(this, ba, T), defineProperties(this, { emitter: e, filter: $ });
  }
  /**
   *  Unregister the triggered listener for future events.
   */
  async removeListener() {
    rt(this, ba) != null && await this.emitter.off(this.filter, rt(this, ba));
  }
}
ba = new WeakMap();
function errorFunc(C, e, T, $, V) {
  assertArgument(!1, `invalid codepoint at offset ${e}; ${C}`, "bytes", T);
}
function ignoreFunc(C, e, T, $, V) {
  if (C === "BAD_PREFIX" || C === "UNEXPECTED_CONTINUE") {
    let J = 0;
    for (let ee = e + 1; ee < T.length && T[ee] >> 6 === 2; ee++)
      J++;
    return J;
  }
  return C === "OVERRUN" ? T.length - e - 1 : 0;
}
function replaceFunc(C, e, T, $, V) {
  return C === "OVERLONG" ? (assertArgument(typeof V == "number", "invalid bad code point for replacement", "badCodepoint", V), $.push(V), 0) : ($.push(65533), ignoreFunc(C, e, T));
}
const Utf8ErrorFuncs = Object.freeze({
  error: errorFunc,
  ignore: ignoreFunc,
  replace: replaceFunc
});
function getUtf8CodePoints(C, e) {
  e == null && (e = Utf8ErrorFuncs.error);
  const T = getBytes(C, "bytes"), $ = [];
  let V = 0;
  for (; V < T.length; ) {
    const J = T[V++];
    if (!(J >> 7)) {
      $.push(J);
      continue;
    }
    let ee = null, te = null;
    if ((J & 224) === 192)
      ee = 1, te = 127;
    else if ((J & 240) === 224)
      ee = 2, te = 2047;
    else if ((J & 248) === 240)
      ee = 3, te = 65535;
    else {
      (J & 192) === 128 ? V += e("UNEXPECTED_CONTINUE", V - 1, T, $) : V += e("BAD_PREFIX", V - 1, T, $);
      continue;
    }
    if (V - 1 + ee >= T.length) {
      V += e("OVERRUN", V - 1, T, $);
      continue;
    }
    let re = J & (1 << 8 - ee - 1) - 1;
    for (let ie = 0; ie < ee; ie++) {
      let se = T[V];
      if ((se & 192) != 128) {
        V += e("MISSING_CONTINUE", V, T, $), re = null;
        break;
      }
      re = re << 6 | se & 63, V++;
    }
    if (re !== null) {
      if (re > 1114111) {
        V += e("OUT_OF_RANGE", V - 1 - ee, T, $, re);
        continue;
      }
      if (re >= 55296 && re <= 57343) {
        V += e("UTF16_SURROGATE", V - 1 - ee, T, $, re);
        continue;
      }
      if (re <= te) {
        V += e("OVERLONG", V - 1 - ee, T, $, re);
        continue;
      }
      $.push(re);
    }
  }
  return $;
}
function toUtf8Bytes(C, e) {
  assertArgument(typeof C == "string", "invalid string value", "str", C), e != null && (assertNormalize(e), C = C.normalize(e));
  let T = [];
  for (let $ = 0; $ < C.length; $++) {
    const V = C.charCodeAt($);
    if (V < 128)
      T.push(V);
    else if (V < 2048)
      T.push(V >> 6 | 192), T.push(V & 63 | 128);
    else if ((V & 64512) == 55296) {
      $++;
      const J = C.charCodeAt($);
      assertArgument($ < C.length && (J & 64512) === 56320, "invalid surrogate pair", "str", C);
      const ee = 65536 + ((V & 1023) << 10) + (J & 1023);
      T.push(ee >> 18 | 240), T.push(ee >> 12 & 63 | 128), T.push(ee >> 6 & 63 | 128), T.push(ee & 63 | 128);
    } else
      T.push(V >> 12 | 224), T.push(V >> 6 & 63 | 128), T.push(V & 63 | 128);
  }
  return new Uint8Array(T);
}
function _toUtf8String(C) {
  return C.map((e) => e <= 65535 ? String.fromCharCode(e) : (e -= 65536, String.fromCharCode((e >> 10 & 1023) + 55296, (e & 1023) + 56320))).join("");
}
function toUtf8String(C, e) {
  return _toUtf8String(getUtf8CodePoints(C, e));
}
function createGetUrl(C) {
  async function e(T, $) {
    assert$5($ == null || !$.cancelled, "request cancelled before sending", "CANCELLED");
    const V = T.url.split(":")[0].toLowerCase();
    assert$5(V === "http" || V === "https", `unsupported protocol ${V}`, "UNSUPPORTED_OPERATION", {
      info: { protocol: V },
      operation: "request"
    }), assert$5(V === "https" || !T.credentials || T.allowInsecureAuthentication, "insecure authorized connections unsupported", "UNSUPPORTED_OPERATION", {
      operation: "request"
    });
    let J = null;
    const ee = new AbortController(), te = setTimeout(() => {
      J = makeError("request timeout", "TIMEOUT"), ee.abort();
    }, T.timeout);
    $ && $.addListener(() => {
      J = makeError("request cancelled", "CANCELLED"), ee.abort();
    });
    const re = {
      method: T.method,
      headers: new Headers(Array.from(T)),
      body: T.body || void 0,
      signal: ee.signal
    };
    let ie;
    try {
      ie = await fetch(T.url, re);
    } catch (fe) {
      throw clearTimeout(te), J || fe;
    }
    clearTimeout(te);
    const se = {};
    ie.headers.forEach((fe, he) => {
      se[he.toLowerCase()] = fe;
    });
    const de = await ie.arrayBuffer(), ue = de == null ? null : new Uint8Array(de);
    return {
      statusCode: ie.status,
      statusMessage: ie.statusText,
      headers: se,
      body: ue
    };
  }
  return e;
}
const MAX_ATTEMPTS = 12, SLOT_INTERVAL = 250;
let defaultGetUrlFunc = createGetUrl();
const reData = new RegExp("^data:([^;:]*)?(;base64)?,(.*)$", "i"), reIpfs = new RegExp("^ipfs://(ipfs/)?(.*)$", "i");
let locked$5 = !1;
async function dataGatewayFunc(C, e) {
  try {
    const T = C.match(reData);
    if (!T)
      throw new Error("invalid data");
    return new FetchResponse(200, "OK", {
      "content-type": T[1] || "text/plain"
    }, T[2] ? decodeBase64(T[3]) : unpercent(T[3]));
  } catch {
    return new FetchResponse(599, "BAD REQUEST (invalid data: URI)", {}, null, new FetchRequest(C));
  }
}
function getIpfsGatewayFunc(C) {
  async function e(T, $) {
    try {
      const V = T.match(reIpfs);
      if (!V)
        throw new Error("invalid link");
      return new FetchRequest(`${C}${V[2]}`);
    } catch {
      return new FetchResponse(599, "BAD REQUEST (invalid IPFS URI)", {}, null, new FetchRequest(T));
    }
  }
  return e;
}
const Gateways = {
  data: dataGatewayFunc,
  ipfs: getIpfsGatewayFunc("https://gateway.ipfs.io/ipfs/")
}, fetchSignals = /* @__PURE__ */ new WeakMap();
var Fi, oi;
class FetchCancelSignal {
  constructor(e) {
    Ft(this, Fi);
    Ft(this, oi);
    At(this, Fi, []), At(this, oi, !1), fetchSignals.set(e, () => {
      if (!rt(this, oi)) {
        At(this, oi, !0);
        for (const T of rt(this, Fi))
          setTimeout(() => {
            T();
          }, 0);
        At(this, Fi, []);
      }
    });
  }
  addListener(e) {
    assert$5(!rt(this, oi), "singal already cancelled", "UNSUPPORTED_OPERATION", {
      operation: "fetchCancelSignal.addCancelListener"
    }), rt(this, Fi).push(e);
  }
  get cancelled() {
    return rt(this, oi);
  }
  checkSignal() {
    assert$5(!this.cancelled, "cancelled", "CANCELLED", {});
  }
}
Fi = new WeakMap(), oi = new WeakMap();
function checkSignal(C) {
  if (C == null)
    throw new Error("missing signal; should not happen");
  return C.checkSignal(), C;
}
var ga, ya, Cr, Vr, xa, Aa, Vn, or, Yr, $i, Ui, zi, Dr, wr, ci, Wi, os;
const Ws = class Ws {
  /**
   *  Create a new FetchRequest instance with default values.
   *
   *  Once created, each property may be set before issuing a
   *  ``.send()`` to make the request.
   */
  constructor(e) {
    Ft(this, Wi);
    Ft(this, ga);
    Ft(this, ya);
    Ft(this, Cr);
    Ft(this, Vr);
    Ft(this, xa);
    Ft(this, Aa);
    Ft(this, Vn);
    Ft(this, or);
    Ft(this, Yr);
    // Hooks
    Ft(this, $i);
    Ft(this, Ui);
    Ft(this, zi);
    Ft(this, Dr);
    Ft(this, wr);
    Ft(this, ci);
    At(this, Aa, String(e)), At(this, ga, !1), At(this, ya, !0), At(this, Cr, {}), At(this, Vr, ""), At(this, xa, 3e5), At(this, wr, {
      slotInterval: SLOT_INTERVAL,
      maxAttempts: MAX_ATTEMPTS
    }), At(this, ci, null);
  }
  /**
   *  The fetch URL to request.
   */
  get url() {
    return rt(this, Aa);
  }
  set url(e) {
    At(this, Aa, String(e));
  }
  /**
   *  The fetch body, if any, to send as the request body. //(default: null)//
   *
   *  When setting a body, the intrinsic ``Content-Type`` is automatically
   *  set and will be used if **not overridden** by setting a custom
   *  header.
   *
   *  If %%body%% is null, the body is cleared (along with the
   *  intrinsic ``Content-Type``).
   *
   *  If %%body%% is a string, the intrinsic ``Content-Type`` is set to
   *  ``text/plain``.
   *
   *  If %%body%% is a Uint8Array, the intrinsic ``Content-Type`` is set to
   *  ``application/octet-stream``.
   *
   *  If %%body%% is any other object, the intrinsic ``Content-Type`` is
   *  set to ``application/json``.
   */
  get body() {
    return rt(this, Vn) == null ? null : new Uint8Array(rt(this, Vn));
  }
  set body(e) {
    if (e == null)
      At(this, Vn, void 0), At(this, or, void 0);
    else if (typeof e == "string")
      At(this, Vn, toUtf8Bytes(e)), At(this, or, "text/plain");
    else if (e instanceof Uint8Array)
      At(this, Vn, e), At(this, or, "application/octet-stream");
    else if (typeof e == "object")
      At(this, Vn, toUtf8Bytes(JSON.stringify(e))), At(this, or, "application/json");
    else
      throw new Error("invalid body");
  }
  /**
   *  Returns true if the request has a body.
   */
  hasBody() {
    return rt(this, Vn) != null;
  }
  /**
   *  The HTTP method to use when requesting the URI. If no method
   *  has been explicitly set, then ``GET`` is used if the body is
   *  null and ``POST`` otherwise.
   */
  get method() {
    return rt(this, Vr) ? rt(this, Vr) : this.hasBody() ? "POST" : "GET";
  }
  set method(e) {
    e == null && (e = ""), At(this, Vr, String(e).toUpperCase());
  }
  /**
   *  The headers that will be used when requesting the URI. All
   *  keys are lower-case.
   *
   *  This object is a copy, so any changes will **NOT** be reflected
   *  in the ``FetchRequest``.
   *
   *  To set a header entry, use the ``setHeader`` method.
   */
  get headers() {
    const e = Object.assign({}, rt(this, Cr));
    return rt(this, Yr) && (e.authorization = `Basic ${encodeBase64(toUtf8Bytes(rt(this, Yr)))}`), this.allowGzip && (e["accept-encoding"] = "gzip"), e["content-type"] == null && rt(this, or) && (e["content-type"] = rt(this, or)), this.body && (e["content-length"] = String(this.body.length)), e;
  }
  /**
   *  Get the header for %%key%%, ignoring case.
   */
  getHeader(e) {
    return this.headers[e.toLowerCase()];
  }
  /**
   *  Set the header for %%key%% to %%value%%. All values are coerced
   *  to a string.
   */
  setHeader(e, T) {
    rt(this, Cr)[String(e).toLowerCase()] = String(T);
  }
  /**
   *  Clear all headers, resetting all intrinsic headers.
   */
  clearHeaders() {
    At(this, Cr, {});
  }
  [Symbol.iterator]() {
    const e = this.headers, T = Object.keys(e);
    let $ = 0;
    return {
      next: () => {
        if ($ < T.length) {
          const V = T[$++];
          return {
            value: [V, e[V]],
            done: !1
          };
        }
        return { value: void 0, done: !0 };
      }
    };
  }
  /**
   *  The value that will be sent for the ``Authorization`` header.
   *
   *  To set the credentials, use the ``setCredentials`` method.
   */
  get credentials() {
    return rt(this, Yr) || null;
  }
  /**
   *  Sets an ``Authorization`` for %%username%% with %%password%%.
   */
  setCredentials(e, T) {
    assertArgument(!e.match(/:/), "invalid basic authentication username", "username", "[REDACTED]"), At(this, Yr, `${e}:${T}`);
  }
  /**
   *  Enable and request gzip-encoded responses. The response will
   *  automatically be decompressed. //(default: true)//
   */
  get allowGzip() {
    return rt(this, ya);
  }
  set allowGzip(e) {
    At(this, ya, !!e);
  }
  /**
   *  Allow ``Authentication`` credentials to be sent over insecure
   *  channels. //(default: false)//
   */
  get allowInsecureAuthentication() {
    return !!rt(this, ga);
  }
  set allowInsecureAuthentication(e) {
    At(this, ga, !!e);
  }
  /**
   *  The timeout (in milliseconds) to wait for a complete response.
   *  //(default: 5 minutes)//
   */
  get timeout() {
    return rt(this, xa);
  }
  set timeout(e) {
    assertArgument(e >= 0, "timeout must be non-zero", "timeout", e), At(this, xa, e);
  }
  /**
   *  This function is called prior to each request, for example
   *  during a redirection or retry in case of server throttling.
   *
   *  This offers an opportunity to populate headers or update
   *  content before sending a request.
   */
  get preflightFunc() {
    return rt(this, $i) || null;
  }
  set preflightFunc(e) {
    At(this, $i, e);
  }
  /**
   *  This function is called after each response, offering an
   *  opportunity to provide client-level throttling or updating
   *  response data.
   *
   *  Any error thrown in this causes the ``send()`` to throw.
   *
   *  To schedule a retry attempt (assuming the maximum retry limit
   *  has not been reached), use [[response.throwThrottleError]].
   */
  get processFunc() {
    return rt(this, Ui) || null;
  }
  set processFunc(e) {
    At(this, Ui, e);
  }
  /**
   *  This function is called on each retry attempt.
   */
  get retryFunc() {
    return rt(this, zi) || null;
  }
  set retryFunc(e) {
    At(this, zi, e);
  }
  /**
   *  This function is called to fetch content from HTTP and
   *  HTTPS URLs and is platform specific (e.g. nodejs vs
   *  browsers).
   *
   *  This is by default the currently registered global getUrl
   *  function, which can be changed using [[registerGetUrl]].
   *  If this has been set, setting is to ``null`` will cause
   *  this FetchRequest (and any future clones) to revert back to
   *  using the currently registered global getUrl function.
   *
   *  Setting this is generally not necessary, but may be useful
   *  for developers that wish to intercept requests or to
   *  configurege a proxy or other agent.
   */
  get getUrlFunc() {
    return rt(this, ci) || defaultGetUrlFunc;
  }
  set getUrlFunc(e) {
    At(this, ci, e);
  }
  toString() {
    return `<FetchRequest method=${JSON.stringify(this.method)} url=${JSON.stringify(this.url)} headers=${JSON.stringify(this.headers)} body=${rt(this, Vn) ? hexlify(rt(this, Vn)) : "null"}>`;
  }
  /**
   *  Update the throttle parameters used to determine maximum
   *  attempts and exponential-backoff properties.
   */
  setThrottleParams(e) {
    e.slotInterval != null && (rt(this, wr).slotInterval = e.slotInterval), e.maxAttempts != null && (rt(this, wr).maxAttempts = e.maxAttempts);
  }
  /**
   *  Resolves to the response by sending the request.
   */
  send() {
    return assert$5(rt(this, Dr) == null, "request already sent", "UNSUPPORTED_OPERATION", { operation: "fetchRequest.send" }), At(this, Dr, new FetchCancelSignal(this)), Qt(this, Wi, os).call(this, 0, getTime$1() + this.timeout, 0, this, new FetchResponse(0, "", {}, null, this));
  }
  /**
   *  Cancels the inflight response, causing a ``CANCELLED``
   *  error to be rejected from the [[send]].
   */
  cancel() {
    assert$5(rt(this, Dr) != null, "request has not been sent", "UNSUPPORTED_OPERATION", { operation: "fetchRequest.cancel" });
    const e = fetchSignals.get(this);
    if (!e)
      throw new Error("missing signal; should not happen");
    e();
  }
  /**
   *  Returns a new [[FetchRequest]] that represents the redirection
   *  to %%location%%.
   */
  redirect(e) {
    const T = this.url.split(":")[0].toLowerCase(), $ = e.split(":")[0].toLowerCase();
    assert$5(this.method === "GET" && (T !== "https" || $ !== "http") && e.match(/^https?:/), "unsupported redirect", "UNSUPPORTED_OPERATION", {
      operation: `redirect(${this.method} ${JSON.stringify(this.url)} => ${JSON.stringify(e)})`
    });
    const V = new Ws(e);
    return V.method = "GET", V.allowGzip = this.allowGzip, V.timeout = this.timeout, At(V, Cr, Object.assign({}, rt(this, Cr))), rt(this, Vn) && At(V, Vn, new Uint8Array(rt(this, Vn))), At(V, or, rt(this, or)), V;
  }
  /**
   *  Create a new copy of this request.
   */
  clone() {
    const e = new Ws(this.url);
    return At(e, Vr, rt(this, Vr)), rt(this, Vn) && At(e, Vn, rt(this, Vn)), At(e, or, rt(this, or)), At(e, Cr, Object.assign({}, rt(this, Cr))), At(e, Yr, rt(this, Yr)), this.allowGzip && (e.allowGzip = !0), e.timeout = this.timeout, this.allowInsecureAuthentication && (e.allowInsecureAuthentication = !0), At(e, $i, rt(this, $i)), At(e, Ui, rt(this, Ui)), At(e, zi, rt(this, zi)), At(e, wr, Object.assign({}, rt(this, wr))), At(e, ci, rt(this, ci)), e;
  }
  /**
   *  Locks all static configuration for gateways and FetchGetUrlFunc
   *  registration.
   */
  static lockConfig() {
    locked$5 = !0;
  }
  /**
   *  Get the current Gateway function for %%scheme%%.
   */
  static getGateway(e) {
    return Gateways[e.toLowerCase()] || null;
  }
  /**
   *  Use the %%func%% when fetching URIs using %%scheme%%.
   *
   *  This method affects all requests globally.
   *
   *  If [[lockConfig]] has been called, no change is made and this
   *  throws.
   */
  static registerGateway(e, T) {
    if (e = e.toLowerCase(), e === "http" || e === "https")
      throw new Error(`cannot intercept ${e}; use registerGetUrl`);
    if (locked$5)
      throw new Error("gateways locked");
    Gateways[e] = T;
  }
  /**
   *  Use %%getUrl%% when fetching URIs over HTTP and HTTPS requests.
   *
   *  This method affects all requests globally.
   *
   *  If [[lockConfig]] has been called, no change is made and this
   *  throws.
   */
  static registerGetUrl(e) {
    if (locked$5)
      throw new Error("gateways locked");
    defaultGetUrlFunc = e;
  }
  /**
   *  Creates a getUrl function that fetches content from HTTP and
   *  HTTPS URLs.
   *
   *  The available %%options%% are dependent on the platform
   *  implementation of the default getUrl function.
   *
   *  This is not generally something that is needed, but is useful
   *  when trying to customize simple behaviour when fetching HTTP
   *  content.
   */
  static createGetUrlFunc(e) {
    return createGetUrl();
  }
  /**
   *  Creates a function that can "fetch" data URIs.
   *
   *  Note that this is automatically done internally to support
   *  data URIs, so it is not necessary to register it.
   *
   *  This is not generally something that is needed, but may
   *  be useful in a wrapper to perfom custom data URI functionality.
   */
  static createDataGateway() {
    return dataGatewayFunc;
  }
  /**
   *  Creates a function that will fetch IPFS (unvalidated) from
   *  a custom gateway baseUrl.
   *
   *  The default IPFS gateway used internally is
   *  ``"https:/\/gateway.ipfs.io/ipfs/"``.
   */
  static createIpfsGatewayFunc(e) {
    return getIpfsGatewayFunc(e);
  }
};
ga = new WeakMap(), ya = new WeakMap(), Cr = new WeakMap(), Vr = new WeakMap(), xa = new WeakMap(), Aa = new WeakMap(), Vn = new WeakMap(), or = new WeakMap(), Yr = new WeakMap(), $i = new WeakMap(), Ui = new WeakMap(), zi = new WeakMap(), Dr = new WeakMap(), wr = new WeakMap(), ci = new WeakMap(), Wi = new WeakSet(), os = async function(e, T, $, V, J) {
  var se, de, ue;
  if (e >= rt(this, wr).maxAttempts)
    return J.makeServerError("exceeded maximum retry limit");
  assert$5(getTime$1() <= T, "timeout", "TIMEOUT", {
    operation: "request.send",
    reason: "timeout",
    request: V
  }), $ > 0 && await wait($);
  let ee = this.clone();
  const te = (ee.url.split(":")[0] || "").toLowerCase();
  if (te in Gateways) {
    const fe = await Gateways[te](ee.url, checkSignal(rt(V, Dr)));
    if (fe instanceof FetchResponse) {
      let he = fe;
      if (this.processFunc) {
        checkSignal(rt(V, Dr));
        try {
          he = await this.processFunc(ee, he);
        } catch (me) {
          (me.throttle == null || typeof me.stall != "number") && he.makeServerError("error in post-processing function", me).assertOk();
        }
      }
      return he;
    }
    ee = fe;
  }
  this.preflightFunc && (ee = await this.preflightFunc(ee));
  const re = await this.getUrlFunc(ee, checkSignal(rt(V, Dr)));
  let ie = new FetchResponse(re.statusCode, re.statusMessage, re.headers, re.body, V);
  if (ie.statusCode === 301 || ie.statusCode === 302) {
    try {
      const fe = ie.headers.location || "";
      return Qt(se = ee.redirect(fe), Wi, os).call(se, e + 1, T, 0, V, ie);
    } catch {
    }
    return ie;
  } else if (ie.statusCode === 429 && (this.retryFunc == null || await this.retryFunc(ee, ie, e))) {
    const fe = ie.headers["retry-after"];
    let he = rt(this, wr).slotInterval * Math.trunc(Math.random() * Math.pow(2, e));
    return typeof fe == "string" && fe.match(/^[1-9][0-9]*$/) && (he = parseInt(fe)), Qt(de = ee.clone(), Wi, os).call(de, e + 1, T, he, V, ie);
  }
  if (this.processFunc) {
    checkSignal(rt(V, Dr));
    try {
      ie = await this.processFunc(ee, ie);
    } catch (fe) {
      (fe.throttle == null || typeof fe.stall != "number") && ie.makeServerError("error in post-processing function", fe).assertOk();
      let he = rt(this, wr).slotInterval * Math.trunc(Math.random() * Math.pow(2, e));
      return fe.stall >= 0 && (he = fe.stall), Qt(ue = ee.clone(), Wi, os).call(ue, e + 1, T, he, V, ie);
    }
  }
  return ie;
};
let FetchRequest = Ws;
var ms, bs, gs, cr, va, Hi;
const bo = class bo {
  constructor(e, T, $, V, J) {
    Ft(this, ms);
    Ft(this, bs);
    Ft(this, gs);
    Ft(this, cr);
    Ft(this, va);
    Ft(this, Hi);
    At(this, ms, e), At(this, bs, T), At(this, gs, Object.keys($).reduce((ee, te) => (ee[te.toLowerCase()] = String($[te]), ee), {})), At(this, cr, V == null ? null : new Uint8Array(V)), At(this, va, J || null), At(this, Hi, { message: "" });
  }
  toString() {
    return `<FetchResponse status=${this.statusCode} body=${rt(this, cr) ? hexlify(rt(this, cr)) : "null"}>`;
  }
  /**
   *  The response status code.
   */
  get statusCode() {
    return rt(this, ms);
  }
  /**
   *  The response status message.
   */
  get statusMessage() {
    return rt(this, bs);
  }
  /**
   *  The response headers. All keys are lower-case.
   */
  get headers() {
    return Object.assign({}, rt(this, gs));
  }
  /**
   *  The response body, or ``null`` if there was no body.
   */
  get body() {
    return rt(this, cr) == null ? null : new Uint8Array(rt(this, cr));
  }
  /**
   *  The response body as a UTF-8 encoded string, or the empty
   *  string (i.e. ``""``) if there was no body.
   *
   *  An error is thrown if the body is invalid UTF-8 data.
   */
  get bodyText() {
    try {
      return rt(this, cr) == null ? "" : toUtf8String(rt(this, cr));
    } catch {
      assert$5(!1, "response body is not valid UTF-8 data", "UNSUPPORTED_OPERATION", {
        operation: "bodyText",
        info: { response: this }
      });
    }
  }
  /**
   *  The response body, decoded as JSON.
   *
   *  An error is thrown if the body is invalid JSON-encoded data
   *  or if there was no body.
   */
  get bodyJson() {
    try {
      return JSON.parse(this.bodyText);
    } catch {
      assert$5(!1, "response body is not valid JSON", "UNSUPPORTED_OPERATION", {
        operation: "bodyJson",
        info: { response: this }
      });
    }
  }
  [Symbol.iterator]() {
    const e = this.headers, T = Object.keys(e);
    let $ = 0;
    return {
      next: () => {
        if ($ < T.length) {
          const V = T[$++];
          return {
            value: [V, e[V]],
            done: !1
          };
        }
        return { value: void 0, done: !0 };
      }
    };
  }
  /**
   *  Return a Response with matching headers and body, but with
   *  an error status code (i.e. 599) and %%message%% with an
   *  optional %%error%%.
   */
  makeServerError(e, T) {
    let $;
    e ? $ = `CLIENT ESCALATED SERVER ERROR (${this.statusCode} ${this.statusMessage}; ${e})` : (e = `${this.statusCode} ${this.statusMessage}`, $ = `CLIENT ESCALATED SERVER ERROR (${e})`);
    const V = new bo(599, $, this.headers, this.body, rt(this, va) || void 0);
    return At(V, Hi, { message: e, error: T }), V;
  }
  /**
   *  If called within a [request.processFunc](FetchRequest-processFunc)
   *  call, causes the request to retry as if throttled for %%stall%%
   *  milliseconds.
   */
  throwThrottleError(e, T) {
    T == null ? T = -1 : assertArgument(Number.isInteger(T) && T >= 0, "invalid stall timeout", "stall", T);
    const $ = new Error(e || "throttling requests");
    throw defineProperties($, { stall: T, throttle: !0 }), $;
  }
  /**
   *  Get the header value for %%key%%, ignoring case.
   */
  getHeader(e) {
    return this.headers[e.toLowerCase()];
  }
  /**
   *  Returns true if the response has a body.
   */
  hasBody() {
    return rt(this, cr) != null;
  }
  /**
   *  The request made for this response.
   */
  get request() {
    return rt(this, va);
  }
  /**
   *  Returns true if this response was a success statusCode.
   */
  ok() {
    return rt(this, Hi).message === "" && this.statusCode >= 200 && this.statusCode < 300;
  }
  /**
   *  Throws a ``SERVER_ERROR`` if this response is not ok.
   */
  assertOk() {
    if (this.ok())
      return;
    let { message: e, error: T } = rt(this, Hi);
    e === "" && (e = `server response ${this.statusCode} ${this.statusMessage}`);
    let $ = null;
    this.request && ($ = this.request.url);
    let V = null;
    try {
      rt(this, cr) && (V = toUtf8String(rt(this, cr)));
    } catch {
    }
    assert$5(!1, e, "SERVER_ERROR", {
      request: this.request || "unknown request",
      response: this,
      error: T,
      info: {
        requestUrl: $,
        responseBody: V,
        responseStatus: `${this.statusCode} ${this.statusMessage}`
      }
    });
  }
};
ms = new WeakMap(), bs = new WeakMap(), gs = new WeakMap(), cr = new WeakMap(), va = new WeakMap(), Hi = new WeakMap();
let FetchResponse = bo;
function getTime$1() {
  return (/* @__PURE__ */ new Date()).getTime();
}
function unpercent(C) {
  return toUtf8Bytes(C.replace(/%([0-9a-f][0-9a-f])/gi, (e, T) => String.fromCharCode(parseInt(T, 16))));
}
function wait(C) {
  return new Promise((e) => setTimeout(e, C));
}
const BN_N1 = BigInt(-1), BN_0$8 = BigInt(0), BN_1$3 = BigInt(1), BN_5 = BigInt(5), _guard$5 = {};
let Zeros$1 = "0000";
for (; Zeros$1.length < 80; )
  Zeros$1 += Zeros$1;
function getTens(C) {
  let e = Zeros$1;
  for (; e.length < C; )
    e += e;
  return BigInt("1" + e.substring(0, C));
}
function checkValue(C, e, T) {
  const $ = BigInt(e.width);
  if (e.signed) {
    const V = BN_1$3 << $ - BN_1$3;
    assert$5(T == null || C >= -V && C < V, "overflow", "NUMERIC_FAULT", {
      operation: T,
      fault: "overflow",
      value: C
    }), C > BN_0$8 ? C = fromTwos(mask$3(C, $), $) : C = -fromTwos(mask$3(-C, $), $);
  } else {
    const V = BN_1$3 << $;
    assert$5(T == null || C >= 0 && C < V, "overflow", "NUMERIC_FAULT", {
      operation: T,
      fault: "overflow",
      value: C
    }), C = (C % V + V) % V & V - BN_1$3;
  }
  return C;
}
function getFormat(C) {
  typeof C == "number" && (C = `fixed128x${C}`);
  let e = !0, T = 128, $ = 18;
  if (typeof C == "string") {
    if (C !== "fixed") if (C === "ufixed")
      e = !1;
    else {
      const J = C.match(/^(u?)fixed([0-9]+)x([0-9]+)$/);
      assertArgument(J, "invalid fixed format", "format", C), e = J[1] !== "u", T = parseInt(J[2]), $ = parseInt(J[3]);
    }
  } else if (C) {
    const J = C, ee = (te, re, ie) => J[te] == null ? ie : (assertArgument(typeof J[te] === re, "invalid fixed format (" + te + " not " + re + ")", "format." + te, J[te]), J[te]);
    e = ee("signed", "boolean", e), T = ee("width", "number", T), $ = ee("decimals", "number", $);
  }
  assertArgument(T % 8 === 0, "invalid FixedNumber width (not byte aligned)", "format.width", T), assertArgument($ <= 80, "invalid FixedNumber decimals (too large)", "format.decimals", $);
  const V = (e ? "" : "u") + "fixed" + String(T) + "x" + String($);
  return { signed: e, width: T, decimals: $, name: V };
}
function toString$3(C, e) {
  let T = "";
  C < BN_0$8 && (T = "-", C *= BN_N1);
  let $ = C.toString();
  if (e === 0)
    return T + $;
  for (; $.length <= e; )
    $ = Zeros$1 + $;
  const V = $.length - e;
  for ($ = $.substring(0, V) + "." + $.substring(V); $[0] === "0" && $[1] !== "."; )
    $ = $.substring(1);
  for (; $[$.length - 1] === "0" && $[$.length - 2] !== "."; )
    $ = $.substring(0, $.length - 1);
  return T + $;
}
var Tr, $n, tr, On, Li, zr, eo, to, no, ro;
const si = class si {
  // Use this when changing this file to get some typing info,
  // but then switch to any to mask the internal type
  //constructor(guard: any, value: bigint, format: _FixedFormat) {
  /**
   *  @private
   */
  constructor(e, T, $) {
    Ft(this, On);
    /**
     *  The specific fixed-point arithmetic field for this value.
     */
    tt(this, "format");
    Ft(this, Tr);
    // The actual value (accounting for decimals)
    Ft(this, $n);
    // A base-10 value to multiple values by to maintain the magnitude
    Ft(this, tr);
    /**
     *  This is a property so console.log shows a human-meaningful value.
     *
     *  @private
     */
    tt(this, "_value");
    assertPrivate(e, _guard$5, "FixedNumber"), At(this, $n, T), At(this, Tr, $);
    const V = toString$3(T, $.decimals);
    defineProperties(this, { format: $.name, _value: V }), At(this, tr, getTens($.decimals));
  }
  /**
   *  If true, negative values are permitted, otherwise only
   *  positive values and zero are allowed.
   */
  get signed() {
    return rt(this, Tr).signed;
  }
  /**
   *  The number of bits available to store the value.
   */
  get width() {
    return rt(this, Tr).width;
  }
  /**
   *  The number of decimal places in the fixed-point arithment field.
   */
  get decimals() {
    return rt(this, Tr).decimals;
  }
  /**
   *  The value as an integer, based on the smallest unit the
   *  [[decimals]] allow.
   */
  get value() {
    return rt(this, $n);
  }
  /**
   *  Returns a new [[FixedNumber]] with the result of %%this%% added
   *  to %%other%%, ignoring overflow.
   */
  addUnsafe(e) {
    return Qt(this, On, eo).call(this, e);
  }
  /**
   *  Returns a new [[FixedNumber]] with the result of %%this%% added
   *  to %%other%%. A [[NumericFaultError]] is thrown if overflow
   *  occurs.
   */
  add(e) {
    return Qt(this, On, eo).call(this, e, "add");
  }
  /**
   *  Returns a new [[FixedNumber]] with the result of %%other%% subtracted
   *  from %%this%%, ignoring overflow.
   */
  subUnsafe(e) {
    return Qt(this, On, to).call(this, e);
  }
  /**
   *  Returns a new [[FixedNumber]] with the result of %%other%% subtracted
   *  from %%this%%. A [[NumericFaultError]] is thrown if overflow
   *  occurs.
   */
  sub(e) {
    return Qt(this, On, to).call(this, e, "sub");
  }
  /**
   *  Returns a new [[FixedNumber]] with the result of %%this%% multiplied
   *  by %%other%%, ignoring overflow and underflow (precision loss).
   */
  mulUnsafe(e) {
    return Qt(this, On, no).call(this, e);
  }
  /**
   *  Returns a new [[FixedNumber]] with the result of %%this%% multiplied
   *  by %%other%%. A [[NumericFaultError]] is thrown if overflow
   *  occurs.
   */
  mul(e) {
    return Qt(this, On, no).call(this, e, "mul");
  }
  /**
   *  Returns a new [[FixedNumber]] with the result of %%this%% multiplied
   *  by %%other%%. A [[NumericFaultError]] is thrown if overflow
   *  occurs or if underflow (precision loss) occurs.
   */
  mulSignal(e) {
    Qt(this, On, Li).call(this, e);
    const T = rt(this, $n) * rt(e, $n);
    return assert$5(T % rt(this, tr) === BN_0$8, "precision lost during signalling mul", "NUMERIC_FAULT", {
      operation: "mulSignal",
      fault: "underflow",
      value: this
    }), Qt(this, On, zr).call(this, T / rt(this, tr), "mulSignal");
  }
  /**
   *  Returns a new [[FixedNumber]] with the result of %%this%% divided
   *  by %%other%%, ignoring underflow (precision loss). A
   *  [[NumericFaultError]] is thrown if overflow occurs.
   */
  divUnsafe(e) {
    return Qt(this, On, ro).call(this, e);
  }
  /**
   *  Returns a new [[FixedNumber]] with the result of %%this%% divided
   *  by %%other%%, ignoring underflow (precision loss). A
   *  [[NumericFaultError]] is thrown if overflow occurs.
   */
  div(e) {
    return Qt(this, On, ro).call(this, e, "div");
  }
  /**
   *  Returns a new [[FixedNumber]] with the result of %%this%% divided
   *  by %%other%%. A [[NumericFaultError]] is thrown if underflow
   *  (precision loss) occurs.
   */
  divSignal(e) {
    assert$5(rt(e, $n) !== BN_0$8, "division by zero", "NUMERIC_FAULT", {
      operation: "div",
      fault: "divide-by-zero",
      value: this
    }), Qt(this, On, Li).call(this, e);
    const T = rt(this, $n) * rt(this, tr);
    return assert$5(T % rt(e, $n) === BN_0$8, "precision lost during signalling div", "NUMERIC_FAULT", {
      operation: "divSignal",
      fault: "underflow",
      value: this
    }), Qt(this, On, zr).call(this, T / rt(e, $n), "divSignal");
  }
  /**
   *  Returns a comparison result between %%this%% and %%other%%.
   *
   *  This is suitable for use in sorting, where ``-1`` implies %%this%%
   *  is smaller, ``1`` implies %%this%% is larger and ``0`` implies
   *  both are equal.
   */
  cmp(e) {
    let T = this.value, $ = e.value;
    const V = this.decimals - e.decimals;
    return V > 0 ? $ *= getTens(V) : V < 0 && (T *= getTens(-V)), T < $ ? -1 : T > $ ? 1 : 0;
  }
  /**
   *  Returns true if %%other%% is equal to %%this%%.
   */
  eq(e) {
    return this.cmp(e) === 0;
  }
  /**
   *  Returns true if %%other%% is less than to %%this%%.
   */
  lt(e) {
    return this.cmp(e) < 0;
  }
  /**
   *  Returns true if %%other%% is less than or equal to %%this%%.
   */
  lte(e) {
    return this.cmp(e) <= 0;
  }
  /**
   *  Returns true if %%other%% is greater than to %%this%%.
   */
  gt(e) {
    return this.cmp(e) > 0;
  }
  /**
   *  Returns true if %%other%% is greater than or equal to %%this%%.
   */
  gte(e) {
    return this.cmp(e) >= 0;
  }
  /**
   *  Returns a new [[FixedNumber]] which is the largest **integer**
   *  that is less than or equal to %%this%%.
   *
   *  The decimal component of the result will always be ``0``.
   */
  floor() {
    let e = rt(this, $n);
    return rt(this, $n) < BN_0$8 && (e -= rt(this, tr) - BN_1$3), e = rt(this, $n) / rt(this, tr) * rt(this, tr), Qt(this, On, zr).call(this, e, "floor");
  }
  /**
   *  Returns a new [[FixedNumber]] which is the smallest **integer**
   *  that is greater than or equal to %%this%%.
   *
   *  The decimal component of the result will always be ``0``.
   */
  ceiling() {
    let e = rt(this, $n);
    return rt(this, $n) > BN_0$8 && (e += rt(this, tr) - BN_1$3), e = rt(this, $n) / rt(this, tr) * rt(this, tr), Qt(this, On, zr).call(this, e, "ceiling");
  }
  /**
   *  Returns a new [[FixedNumber]] with the decimal component
   *  rounded up on ties at %%decimals%% places.
   */
  round(e) {
    if (e == null && (e = 0), e >= this.decimals)
      return this;
    const T = this.decimals - e, $ = BN_5 * getTens(T - 1);
    let V = this.value + $;
    const J = getTens(T);
    return V = V / J * J, checkValue(V, rt(this, Tr), "round"), new si(_guard$5, V, rt(this, Tr));
  }
  /**
   *  Returns true if %%this%% is equal to ``0``.
   */
  isZero() {
    return rt(this, $n) === BN_0$8;
  }
  /**
   *  Returns true if %%this%% is less than ``0``.
   */
  isNegative() {
    return rt(this, $n) < BN_0$8;
  }
  /**
   *  Returns the string representation of %%this%%.
   */
  toString() {
    return this._value;
  }
  /**
   *  Returns a float approximation.
   *
   *  Due to IEEE 754 precission (or lack thereof), this function
   *  can only return an approximation and most values will contain
   *  rounding errors.
   */
  toUnsafeFloat() {
    return parseFloat(this.toString());
  }
  /**
   *  Return a new [[FixedNumber]] with the same value but has had
   *  its field set to %%format%%.
   *
   *  This will throw if the value cannot fit into %%format%%.
   */
  toFormat(e) {
    return si.fromString(this.toString(), e);
  }
  /**
   *  Creates a new [[FixedNumber]] for %%value%% divided by
   *  %%decimal%% places with %%format%%.
   *
   *  This will throw a [[NumericFaultError]] if %%value%% (once adjusted
   *  for %%decimals%%) cannot fit in %%format%%, either due to overflow
   *  or underflow (precision loss).
   */
  static fromValue(e, T, $) {
    const V = T == null ? 0 : getNumber(T), J = getFormat($);
    let ee = getBigInt(e, "value");
    const te = V - J.decimals;
    if (te > 0) {
      const re = getTens(te);
      assert$5(ee % re === BN_0$8, "value loses precision for format", "NUMERIC_FAULT", {
        operation: "fromValue",
        fault: "underflow",
        value: e
      }), ee /= re;
    } else te < 0 && (ee *= getTens(-te));
    return checkValue(ee, J, "fromValue"), new si(_guard$5, ee, J);
  }
  /**
   *  Creates a new [[FixedNumber]] for %%value%% with %%format%%.
   *
   *  This will throw a [[NumericFaultError]] if %%value%% cannot fit
   *  in %%format%%, either due to overflow or underflow (precision loss).
   */
  static fromString(e, T) {
    const $ = e.match(/^(-?)([0-9]*)\.?([0-9]*)$/);
    assertArgument($ && $[2].length + $[3].length > 0, "invalid FixedNumber string value", "value", e);
    const V = getFormat(T);
    let J = $[2] || "0", ee = $[3] || "";
    for (; ee.length < V.decimals; )
      ee += Zeros$1;
    assert$5(ee.substring(V.decimals).match(/^0*$/), "too many decimals for format", "NUMERIC_FAULT", {
      operation: "fromString",
      fault: "underflow",
      value: e
    }), ee = ee.substring(0, V.decimals);
    const te = BigInt($[1] + J + ee);
    return checkValue(te, V, "fromString"), new si(_guard$5, te, V);
  }
  /**
   *  Creates a new [[FixedNumber]] with the big-endian representation
   *  %%value%% with %%format%%.
   *
   *  This will throw a [[NumericFaultError]] if %%value%% cannot fit
   *  in %%format%% due to overflow.
   */
  static fromBytes(e, T) {
    let $ = toBigInt(getBytes(e, "value"));
    const V = getFormat(T);
    return V.signed && ($ = fromTwos($, V.width)), checkValue($, V, "fromBytes"), new si(_guard$5, $, V);
  }
};
Tr = new WeakMap(), $n = new WeakMap(), tr = new WeakMap(), On = new WeakSet(), Li = function(e) {
  assertArgument(this.format === e.format, "incompatible format; use fixedNumber.toFormat", "other", e);
}, zr = function(e, T) {
  return e = checkValue(e, rt(this, Tr), T), new si(_guard$5, e, rt(this, Tr));
}, eo = function(e, T) {
  return Qt(this, On, Li).call(this, e), Qt(this, On, zr).call(this, rt(this, $n) + rt(e, $n), T);
}, to = function(e, T) {
  return Qt(this, On, Li).call(this, e), Qt(this, On, zr).call(this, rt(this, $n) - rt(e, $n), T);
}, no = function(e, T) {
  return Qt(this, On, Li).call(this, e), Qt(this, On, zr).call(this, rt(this, $n) * rt(e, $n) / rt(this, tr), T);
}, ro = function(e, T) {
  return assert$5(rt(e, $n) !== BN_0$8, "division by zero", "NUMERIC_FAULT", {
    operation: "div",
    fault: "divide-by-zero",
    value: this
  }), Qt(this, On, Li).call(this, e), Qt(this, On, zr).call(this, rt(this, $n) * rt(this, tr) / rt(e, $n), T);
};
let FixedNumber = si;
function hexlifyByte(C) {
  let e = C.toString(16);
  for (; e.length < 2; )
    e = "0" + e;
  return "0x" + e;
}
function unarrayifyInteger(C, e, T) {
  let $ = 0;
  for (let V = 0; V < T; V++)
    $ = $ * 256 + C[e + V];
  return $;
}
function _decodeChildren(C, e, T, $) {
  const V = [];
  for (; T < e + 1 + $; ) {
    const J = _decode(C, T);
    V.push(J.result), T += J.consumed, assert$5(T <= e + 1 + $, "child data too short", "BUFFER_OVERRUN", {
      buffer: C,
      length: $,
      offset: e
    });
  }
  return { consumed: 1 + $, result: V };
}
function _decode(C, e) {
  assert$5(C.length !== 0, "data too short", "BUFFER_OVERRUN", {
    buffer: C,
    length: 0,
    offset: 1
  });
  const T = ($) => {
    assert$5($ <= C.length, "data short segment too short", "BUFFER_OVERRUN", {
      buffer: C,
      length: C.length,
      offset: $
    });
  };
  if (C[e] >= 248) {
    const $ = C[e] - 247;
    T(e + 1 + $);
    const V = unarrayifyInteger(C, e + 1, $);
    return T(e + 1 + $ + V), _decodeChildren(C, e, e + 1 + $, $ + V);
  } else if (C[e] >= 192) {
    const $ = C[e] - 192;
    return T(e + 1 + $), _decodeChildren(C, e, e + 1, $);
  } else if (C[e] >= 184) {
    const $ = C[e] - 183;
    T(e + 1 + $);
    const V = unarrayifyInteger(C, e + 1, $);
    T(e + 1 + $ + V);
    const J = hexlify(C.slice(e + 1 + $, e + 1 + $ + V));
    return { consumed: 1 + $ + V, result: J };
  } else if (C[e] >= 128) {
    const $ = C[e] - 128;
    T(e + 1 + $);
    const V = hexlify(C.slice(e + 1, e + 1 + $));
    return { consumed: 1 + $, result: V };
  }
  return { consumed: 1, result: hexlifyByte(C[e]) };
}
function decodeRlp(C) {
  const e = getBytes(C, "data"), T = _decode(e, 0);
  return assertArgument(T.consumed === e.length, "unexpected junk after rlp payload", "data", C), T.result;
}
function arrayifyInteger(C) {
  const e = [];
  for (; C; )
    e.unshift(C & 255), C >>= 8;
  return e;
}
function _encode(C) {
  if (Array.isArray(C)) {
    let $ = [];
    if (C.forEach(function(J) {
      $ = $.concat(_encode(J));
    }), $.length <= 55)
      return $.unshift(192 + $.length), $;
    const V = arrayifyInteger($.length);
    return V.unshift(247 + V.length), V.concat($);
  }
  const e = Array.prototype.slice.call(getBytes(C, "object"));
  if (e.length === 1 && e[0] <= 127)
    return e;
  if (e.length <= 55)
    return e.unshift(128 + e.length), e;
  const T = arrayifyInteger(e.length);
  return T.unshift(183 + T.length), T.concat(e);
}
const nibbles = "0123456789abcdef";
function encodeRlp(C) {
  let e = "0x";
  for (const T of _encode(C))
    e += nibbles[T >> 4], e += nibbles[T & 15];
  return e;
}
const names = [
  "wei",
  "kwei",
  "mwei",
  "gwei",
  "szabo",
  "finney",
  "ether"
];
function formatUnits(C, e) {
  let T = 18;
  if (typeof e == "string") {
    const $ = names.indexOf(e);
    assertArgument($ >= 0, "invalid unit", "unit", e), T = 3 * $;
  } else e != null && (T = getNumber(e, "unit"));
  return FixedNumber.fromValue(C, T, { decimals: T, width: 512 }).toString();
}
function parseUnits$1(C, e) {
  assertArgument(typeof C == "string", "value must be a string", "value", C);
  let T = 18;
  if (typeof e == "string") {
    const $ = names.indexOf(e);
    assertArgument($ >= 0, "invalid unit", "unit", e), T = 3 * $;
  } else e != null && (T = getNumber(e, "unit"));
  return FixedNumber.fromString(C, { decimals: T, width: 512 }).value;
}
function formatEther(C) {
  return formatUnits(C, 18);
}
function uuidV4(C) {
  const e = getBytes(C, "randomBytes");
  e[6] = e[6] & 15 | 64, e[8] = e[8] & 63 | 128;
  const T = hexlify(e);
  return [
    T.substring(2, 10),
    T.substring(10, 14),
    T.substring(14, 18),
    T.substring(18, 22),
    T.substring(22, 34)
  ].join("-");
}
const WordSize = 32, Padding = new Uint8Array(WordSize), passProperties$1 = ["then"], _guard$4 = {}, resultNames = /* @__PURE__ */ new WeakMap();
function getNames(C) {
  return resultNames.get(C);
}
function setNames(C, e) {
  resultNames.set(C, e);
}
function throwError(C, e) {
  const T = new Error(`deferred error during ABI decoding triggered accessing ${C}`);
  throw T.error = e, T;
}
function toObject(C, e, T) {
  return C.indexOf(null) >= 0 ? e.map(($, V) => $ instanceof Result ? toObject(getNames($), $, T) : $) : C.reduce(($, V, J) => {
    let ee = e.getValue(V);
    return V in $ || (T && ee instanceof Result && (ee = toObject(getNames(ee), ee, T)), $[V] = ee), $;
  }, {});
}
var Ca;
const pa = class pa extends Array {
  /**
   *  @private
   */
  constructor(...T) {
    const $ = T[0];
    let V = T[1], J = (T[2] || []).slice(), ee = !0;
    $ !== _guard$4 && (V = T, J = [], ee = !1);
    super(V.length);
    // No longer used; but cannot be removed as it will remove the
    // #private field from the .d.ts which may break backwards
    // compatibility
    Ft(this, Ca);
    V.forEach((ie, se) => {
      this[se] = ie;
    });
    const te = J.reduce((ie, se) => (typeof se == "string" && ie.set(se, (ie.get(se) || 0) + 1), ie), /* @__PURE__ */ new Map());
    if (setNames(this, Object.freeze(V.map((ie, se) => {
      const de = J[se];
      return de != null && te.get(de) === 1 ? de : null;
    }))), At(this, Ca, []), rt(this, Ca) == null && rt(this, Ca), !ee)
      return;
    Object.freeze(this);
    const re = new Proxy(this, {
      get: (ie, se, de) => {
        if (typeof se == "string") {
          if (se.match(/^[0-9]+$/)) {
            const fe = getNumber(se, "%index");
            if (fe < 0 || fe >= this.length)
              throw new RangeError("out of result range");
            const he = ie[fe];
            return he instanceof Error && throwError(`index ${fe}`, he), he;
          }
          if (passProperties$1.indexOf(se) >= 0)
            return Reflect.get(ie, se, de);
          const ue = ie[se];
          if (ue instanceof Function)
            return function(...fe) {
              return ue.apply(this === de ? ie : this, fe);
            };
          if (!(se in ie))
            return ie.getValue.apply(this === de ? ie : this, [se]);
        }
        return Reflect.get(ie, se, de);
      }
    });
    return setNames(re, getNames(this)), re;
  }
  /**
   *  Returns the Result as a normal Array. If %%deep%%, any children
   *  which are Result objects are also converted to a normal Array.
   *
   *  This will throw if there are any outstanding deferred
   *  errors.
   */
  toArray(T) {
    const $ = [];
    return this.forEach((V, J) => {
      V instanceof Error && throwError(`index ${J}`, V), T && V instanceof pa && (V = V.toArray(T)), $.push(V);
    }), $;
  }
  /**
   *  Returns the Result as an Object with each name-value pair. If
   *  %%deep%%, any children which are Result objects are also
   *  converted to an Object.
   *
   *  This will throw if any value is unnamed, or if there are
   *  any outstanding deferred errors.
   */
  toObject(T) {
    const $ = getNames(this);
    return $.reduce((V, J, ee) => (assert$5(J != null, `value at index ${ee} unnamed`, "UNSUPPORTED_OPERATION", {
      operation: "toObject()"
    }), toObject($, this, T)), {});
  }
  /**
   *  @_ignore
   */
  slice(T, $) {
    T == null && (T = 0), T < 0 && (T += this.length, T < 0 && (T = 0)), $ == null && ($ = this.length), $ < 0 && ($ += this.length, $ < 0 && ($ = 0)), $ > this.length && ($ = this.length);
    const V = getNames(this), J = [], ee = [];
    for (let te = T; te < $; te++)
      J.push(this[te]), ee.push(V[te]);
    return new pa(_guard$4, J, ee);
  }
  /**
   *  @_ignore
   */
  filter(T, $) {
    const V = getNames(this), J = [], ee = [];
    for (let te = 0; te < this.length; te++) {
      const re = this[te];
      re instanceof Error && throwError(`index ${te}`, re), T.call($, re, te, this) && (J.push(re), ee.push(V[te]));
    }
    return new pa(_guard$4, J, ee);
  }
  /**
   *  @_ignore
   */
  map(T, $) {
    const V = [];
    for (let J = 0; J < this.length; J++) {
      const ee = this[J];
      ee instanceof Error && throwError(`index ${J}`, ee), V.push(T.call($, ee, J, this));
    }
    return V;
  }
  /**
   *  Returns the value for %%name%%.
   *
   *  Since it is possible to have a key whose name conflicts with
   *  a method on a [[Result]] or its superclass Array, or any
   *  JavaScript keyword, this ensures all named values are still
   *  accessible by name.
   */
  getValue(T) {
    const $ = getNames(this).indexOf(T);
    if ($ === -1)
      return;
    const V = this[$];
    return V instanceof Error && throwError(`property ${JSON.stringify(T)}`, V.error), V;
  }
  /**
   *  Creates a new [[Result]] for %%items%% with each entry
   *  also accessible by its corresponding name in %%keys%%.
   */
  static fromItems(T, $) {
    return new pa(_guard$4, T, $);
  }
};
Ca = new WeakMap();
let Result = pa;
function getValue$1(C) {
  let e = toBeArray(C);
  return assert$5(e.length <= WordSize, "value out-of-bounds", "BUFFER_OVERRUN", { buffer: e, length: WordSize, offset: e.length }), e.length !== WordSize && (e = getBytesCopy(concat([Padding.slice(e.length % WordSize), e]))), e;
}
class Coder {
  constructor(e, T, $, V) {
    // The coder name:
    //   - address, uint256, tuple, array, etc.
    tt(this, "name");
    // The fully expanded type, including composite types:
    //   - address, uint256, tuple(address,bytes), uint256[3][4][],  etc.
    tt(this, "type");
    // The localName bound in the signature, in this example it is "baz":
    //   - tuple(address foo, uint bar) baz
    tt(this, "localName");
    // Whether this type is dynamic:
    //  - Dynamic: bytes, string, address[], tuple(boolean[]), etc.
    //  - Not Dynamic: address, uint256, boolean[3], tuple(address, uint8)
    tt(this, "dynamic");
    defineProperties(this, { name: e, type: T, localName: $, dynamic: V }, {
      name: "string",
      type: "string",
      localName: "string",
      dynamic: "boolean"
    });
  }
  _throwError(e, T) {
    assertArgument(!1, e, this.localName, T);
  }
}
var qr, Gi, wa, _s;
class Writer {
  constructor() {
    Ft(this, wa);
    // An array of WordSize lengthed objects to concatenation
    Ft(this, qr);
    Ft(this, Gi);
    At(this, qr, []), At(this, Gi, 0);
  }
  get data() {
    return concat(rt(this, qr));
  }
  get length() {
    return rt(this, Gi);
  }
  appendWriter(e) {
    return Qt(this, wa, _s).call(this, getBytesCopy(e.data));
  }
  // Arrayish item; pad on the right to *nearest* WordSize
  writeBytes(e) {
    let T = getBytesCopy(e);
    const $ = T.length % WordSize;
    return $ && (T = getBytesCopy(concat([T, Padding.slice($)]))), Qt(this, wa, _s).call(this, T);
  }
  // Numeric item; pad on the left *to* WordSize
  writeValue(e) {
    return Qt(this, wa, _s).call(this, getValue$1(e));
  }
  // Inserts a numeric place-holder, returning a callback that can
  // be used to asjust the value later
  writeUpdatableValue() {
    const e = rt(this, qr).length;
    return rt(this, qr).push(Padding), At(this, Gi, rt(this, Gi) + WordSize), (T) => {
      rt(this, qr)[e] = getValue$1(T);
    };
  }
}
qr = new WeakMap(), Gi = new WeakMap(), wa = new WeakSet(), _s = function(e) {
  return rt(this, qr).push(e), At(this, Gi, rt(this, Gi) + e.length), e.length;
};
var rr, lr, Vi, Yi, li, da, io, To;
const go = class go {
  constructor(e, T, $) {
    Ft(this, da);
    // Allows incomplete unpadded data to be read; otherwise an error
    // is raised if attempting to overrun the buffer. This is required
    // to deal with an old Solidity bug, in which event data for
    // external (not public thoguh) was tightly packed.
    tt(this, "allowLoose");
    Ft(this, rr);
    Ft(this, lr);
    Ft(this, Vi);
    Ft(this, Yi);
    Ft(this, li);
    defineProperties(this, { allowLoose: !!T }), At(this, rr, getBytesCopy(e)), At(this, Vi, 0), At(this, Yi, null), At(this, li, $ ?? 1024), At(this, lr, 0);
  }
  get data() {
    return hexlify(rt(this, rr));
  }
  get dataLength() {
    return rt(this, rr).length;
  }
  get consumed() {
    return rt(this, lr);
  }
  get bytes() {
    return new Uint8Array(rt(this, rr));
  }
  // Create a sub-reader with the same underlying data, but offset
  subReader(e) {
    const T = new go(rt(this, rr).slice(rt(this, lr) + e), this.allowLoose, rt(this, li));
    return At(T, Yi, this), T;
  }
  // Read bytes
  readBytes(e, T) {
    let $ = Qt(this, da, To).call(this, 0, e, !!T);
    return Qt(this, da, io).call(this, e), At(this, lr, rt(this, lr) + $.length), $.slice(0, e);
  }
  // Read a numeric values
  readValue() {
    return toBigInt(this.readBytes(WordSize));
  }
  readIndex() {
    return toNumber(this.readBytes(WordSize));
  }
};
rr = new WeakMap(), lr = new WeakMap(), Vi = new WeakMap(), Yi = new WeakMap(), li = new WeakMap(), da = new WeakSet(), io = function(e) {
  var T;
  if (rt(this, Yi))
    return Qt(T = rt(this, Yi), da, io).call(T, e);
  At(this, Vi, rt(this, Vi) + e), assert$5(rt(this, li) < 1 || rt(this, Vi) <= rt(this, li) * this.dataLength, `compressed ABI data exceeds inflation ratio of ${rt(this, li)} ( see: https://github.com/ethers-io/ethers.js/issues/4537 )`, "BUFFER_OVERRUN", {
    buffer: getBytesCopy(rt(this, rr)),
    offset: rt(this, lr),
    length: e,
    info: {
      bytesRead: rt(this, Vi),
      dataLength: this.dataLength
    }
  });
}, To = function(e, T, $) {
  let V = Math.ceil(T / WordSize) * WordSize;
  return rt(this, lr) + V > rt(this, rr).length && (this.allowLoose && $ && rt(this, lr) + T <= rt(this, rr).length ? V = T : assert$5(!1, "data out-of-bounds", "BUFFER_OVERRUN", {
    buffer: getBytesCopy(rt(this, rr)),
    length: rt(this, rr).length,
    offset: rt(this, lr) + V
  })), rt(this, rr).slice(rt(this, lr), rt(this, lr) + V);
};
let Reader = go;
function number$3(C) {
  if (!Number.isSafeInteger(C) || C < 0)
    throw new Error(`Wrong positive integer: ${C}`);
}
function bytes$1(C, ...e) {
  if (!(C instanceof Uint8Array))
    throw new Error("Expected Uint8Array");
  if (e.length > 0 && !e.includes(C.length))
    throw new Error(`Expected Uint8Array of length ${e}, not of length=${C.length}`);
}
function hash$5(C) {
  if (typeof C != "function" || typeof C.create != "function")
    throw new Error("Hash should be wrapped by utils.wrapConstructor");
  number$3(C.outputLen), number$3(C.blockLen);
}
function exists(C, e = !0) {
  if (C.destroyed)
    throw new Error("Hash instance has been destroyed");
  if (e && C.finished)
    throw new Error("Hash#digest() has already been called");
}
function output(C, e) {
  bytes$1(C);
  const T = e.outputLen;
  if (C.length < T)
    throw new Error(`digestInto() expects output buffer of length at least ${T}`);
}
const crypto$4 = typeof globalThis == "object" && "crypto" in globalThis ? globalThis.crypto : void 0;
/*! noble-hashes - MIT License (c) 2022 Paul Miller (paulmillr.com) */
const u8a$1 = (C) => C instanceof Uint8Array, u32$3 = (C) => new Uint32Array(C.buffer, C.byteOffset, Math.floor(C.byteLength / 4)), createView$2 = (C) => new DataView(C.buffer, C.byteOffset, C.byteLength), rotr$2 = (C, e) => C << 32 - e | C >>> e, isLE$1 = new Uint8Array(new Uint32Array([287454020]).buffer)[0] === 68;
if (!isLE$1)
  throw new Error("Non little-endian hardware is not supported");
const nextTick = async () => {
};
async function asyncLoop(C, e, T) {
  let $ = Date.now();
  for (let V = 0; V < C; V++) {
    T(V);
    const J = Date.now() - $;
    J >= 0 && J < e || (await nextTick(), $ += J);
  }
}
function utf8ToBytes$4(C) {
  if (typeof C != "string")
    throw new Error(`utf8ToBytes expected string, got ${typeof C}`);
  return new Uint8Array(new TextEncoder().encode(C));
}
function toBytes$3(C) {
  if (typeof C == "string" && (C = utf8ToBytes$4(C)), !u8a$1(C))
    throw new Error(`expected Uint8Array, got ${typeof C}`);
  return C;
}
function concatBytes$4(...C) {
  const e = new Uint8Array(C.reduce(($, V) => $ + V.length, 0));
  let T = 0;
  return C.forEach(($) => {
    if (!u8a$1($))
      throw new Error("Uint8Array expected");
    e.set($, T), T += $.length;
  }), e;
}
let Hash$2 = class {
  // Safe version that clones internal state
  clone() {
    return this._cloneInto();
  }
};
const toStr = {}.toString;
function checkOpts$1(C, e) {
  if (e !== void 0 && toStr.call(e) !== "[object Object]")
    throw new Error("Options should be object or undefined");
  return Object.assign(C, e);
}
function wrapConstructor$2(C) {
  const e = ($) => C().update(toBytes$3($)).digest(), T = C();
  return e.outputLen = T.outputLen, e.blockLen = T.blockLen, e.create = () => C(), e;
}
function randomBytes$4(C = 32) {
  if (crypto$4 && typeof crypto$4.getRandomValues == "function")
    return crypto$4.getRandomValues(new Uint8Array(C));
  throw new Error("crypto.getRandomValues must be defined");
}
let HMAC$1 = class extends Hash$2 {
  constructor(e, T) {
    super(), this.finished = !1, this.destroyed = !1, hash$5(e);
    const $ = toBytes$3(T);
    if (this.iHash = e.create(), typeof this.iHash.update != "function")
      throw new Error("Expected instance of class which extends utils.Hash");
    this.blockLen = this.iHash.blockLen, this.outputLen = this.iHash.outputLen;
    const V = this.blockLen, J = new Uint8Array(V);
    J.set($.length > V ? e.create().update($).digest() : $);
    for (let ee = 0; ee < J.length; ee++)
      J[ee] ^= 54;
    this.iHash.update(J), this.oHash = e.create();
    for (let ee = 0; ee < J.length; ee++)
      J[ee] ^= 106;
    this.oHash.update(J), J.fill(0);
  }
  update(e) {
    return exists(this), this.iHash.update(e), this;
  }
  digestInto(e) {
    exists(this), bytes$1(e, this.outputLen), this.finished = !0, this.iHash.digestInto(e), this.oHash.update(e), this.oHash.digestInto(e), this.destroy();
  }
  digest() {
    const e = new Uint8Array(this.oHash.outputLen);
    return this.digestInto(e), e;
  }
  _cloneInto(e) {
    e || (e = Object.create(Object.getPrototypeOf(this), {}));
    const { oHash: T, iHash: $, finished: V, destroyed: J, blockLen: ee, outputLen: te } = this;
    return e = e, e.finished = V, e.destroyed = J, e.blockLen = ee, e.outputLen = te, e.oHash = T._cloneInto(e.oHash), e.iHash = $._cloneInto(e.iHash), e;
  }
  destroy() {
    this.destroyed = !0, this.oHash.destroy(), this.iHash.destroy();
  }
};
const hmac$2 = (C, e, T) => new HMAC$1(C, e).update(T).digest();
hmac$2.create = (C, e) => new HMAC$1(C, e);
function pbkdf2Init(C, e, T, $) {
  hash$5(C);
  const V = checkOpts$1({ dkLen: 32, asyncTick: 10 }, $), { c: J, dkLen: ee, asyncTick: te } = V;
  if (number$3(J), number$3(ee), number$3(te), J < 1)
    throw new Error("PBKDF2: iterations (c) should be >= 1");
  const re = toBytes$3(e), ie = toBytes$3(T), se = new Uint8Array(ee), de = hmac$2.create(C, re), ue = de._cloneInto().update(ie);
  return { c: J, dkLen: ee, asyncTick: te, DK: se, PRF: de, PRFSalt: ue };
}
function pbkdf2Output(C, e, T, $, V) {
  return C.destroy(), e.destroy(), $ && $.destroy(), V.fill(0), T;
}
function pbkdf2$1(C, e, T, $) {
  const { c: V, dkLen: J, DK: ee, PRF: te, PRFSalt: re } = pbkdf2Init(C, e, T, $);
  let ie;
  const se = new Uint8Array(4), de = createView$2(se), ue = new Uint8Array(te.outputLen);
  for (let fe = 1, he = 0; he < J; fe++, he += te.outputLen) {
    const me = ee.subarray(he, he + te.outputLen);
    de.setInt32(0, fe, !1), (ie = re._cloneInto(ie)).update(se).digestInto(ue), me.set(ue.subarray(0, me.length));
    for (let xe = 1; xe < V; xe++) {
      te._cloneInto(ie).update(ue).digestInto(ue);
      for (let ve = 0; ve < me.length; ve++)
        me[ve] ^= ue[ve];
    }
  }
  return pbkdf2Output(te, re, ee, ie, ue);
}
function setBigUint64$2(C, e, T, $) {
  if (typeof C.setBigUint64 == "function")
    return C.setBigUint64(e, T, $);
  const V = BigInt(32), J = BigInt(4294967295), ee = Number(T >> V & J), te = Number(T & J), re = $ ? 4 : 0, ie = $ ? 0 : 4;
  C.setUint32(e + re, ee, $), C.setUint32(e + ie, te, $);
}
class SHA2 extends Hash$2 {
  constructor(e, T, $, V) {
    super(), this.blockLen = e, this.outputLen = T, this.padOffset = $, this.isLE = V, this.finished = !1, this.length = 0, this.pos = 0, this.destroyed = !1, this.buffer = new Uint8Array(e), this.view = createView$2(this.buffer);
  }
  update(e) {
    exists(this);
    const { view: T, buffer: $, blockLen: V } = this;
    e = toBytes$3(e);
    const J = e.length;
    for (let ee = 0; ee < J; ) {
      const te = Math.min(V - this.pos, J - ee);
      if (te === V) {
        const re = createView$2(e);
        for (; V <= J - ee; ee += V)
          this.process(re, ee);
        continue;
      }
      $.set(e.subarray(ee, ee + te), this.pos), this.pos += te, ee += te, this.pos === V && (this.process(T, 0), this.pos = 0);
    }
    return this.length += e.length, this.roundClean(), this;
  }
  digestInto(e) {
    exists(this), output(e, this), this.finished = !0;
    const { buffer: T, view: $, blockLen: V, isLE: J } = this;
    let { pos: ee } = this;
    T[ee++] = 128, this.buffer.subarray(ee).fill(0), this.padOffset > V - ee && (this.process($, 0), ee = 0);
    for (let de = ee; de < V; de++)
      T[de] = 0;
    setBigUint64$2($, V - 8, BigInt(this.length * 8), J), this.process($, 0);
    const te = createView$2(e), re = this.outputLen;
    if (re % 4)
      throw new Error("_sha2: outputLen should be aligned to 32bit");
    const ie = re / 4, se = this.get();
    if (ie > se.length)
      throw new Error("_sha2: outputLen bigger than state");
    for (let de = 0; de < ie; de++)
      te.setUint32(4 * de, se[de], J);
  }
  digest() {
    const { buffer: e, outputLen: T } = this;
    this.digestInto(e);
    const $ = e.slice(0, T);
    return this.destroy(), $;
  }
  _cloneInto(e) {
    e || (e = new this.constructor()), e.set(...this.get());
    const { blockLen: T, buffer: $, length: V, finished: J, destroyed: ee, pos: te } = this;
    return e.length = V, e.pos = te, e.finished = J, e.destroyed = ee, V % T && e.buffer.set($), e;
  }
}
const Chi$2 = (C, e, T) => C & e ^ ~C & T, Maj$2 = (C, e, T) => C & e ^ C & T ^ e & T, SHA256_K$2 = /* @__PURE__ */ new Uint32Array([
  1116352408,
  1899447441,
  3049323471,
  3921009573,
  961987163,
  1508970993,
  2453635748,
  2870763221,
  3624381080,
  310598401,
  607225278,
  1426881987,
  1925078388,
  2162078206,
  2614888103,
  3248222580,
  3835390401,
  4022224774,
  264347078,
  604807628,
  770255983,
  1249150122,
  1555081692,
  1996064986,
  2554220882,
  2821834349,
  2952996808,
  3210313671,
  3336571891,
  3584528711,
  113926993,
  338241895,
  666307205,
  773529912,
  1294757372,
  1396182291,
  1695183700,
  1986661051,
  2177026350,
  2456956037,
  2730485921,
  2820302411,
  3259730800,
  3345764771,
  3516065817,
  3600352804,
  4094571909,
  275423344,
  430227734,
  506948616,
  659060556,
  883997877,
  958139571,
  1322822218,
  1537002063,
  1747873779,
  1955562222,
  2024104815,
  2227730452,
  2361852424,
  2428436474,
  2756734187,
  3204031479,
  3329325298
]), IV = /* @__PURE__ */ new Uint32Array([
  1779033703,
  3144134277,
  1013904242,
  2773480762,
  1359893119,
  2600822924,
  528734635,
  1541459225
]), SHA256_W$2 = /* @__PURE__ */ new Uint32Array(64);
let SHA256$2 = class extends SHA2 {
  constructor() {
    super(64, 32, 8, !1), this.A = IV[0] | 0, this.B = IV[1] | 0, this.C = IV[2] | 0, this.D = IV[3] | 0, this.E = IV[4] | 0, this.F = IV[5] | 0, this.G = IV[6] | 0, this.H = IV[7] | 0;
  }
  get() {
    const { A: e, B: T, C: $, D: V, E: J, F: ee, G: te, H: re } = this;
    return [e, T, $, V, J, ee, te, re];
  }
  // prettier-ignore
  set(e, T, $, V, J, ee, te, re) {
    this.A = e | 0, this.B = T | 0, this.C = $ | 0, this.D = V | 0, this.E = J | 0, this.F = ee | 0, this.G = te | 0, this.H = re | 0;
  }
  process(e, T) {
    for (let de = 0; de < 16; de++, T += 4)
      SHA256_W$2[de] = e.getUint32(T, !1);
    for (let de = 16; de < 64; de++) {
      const ue = SHA256_W$2[de - 15], fe = SHA256_W$2[de - 2], he = rotr$2(ue, 7) ^ rotr$2(ue, 18) ^ ue >>> 3, me = rotr$2(fe, 17) ^ rotr$2(fe, 19) ^ fe >>> 10;
      SHA256_W$2[de] = me + SHA256_W$2[de - 7] + he + SHA256_W$2[de - 16] | 0;
    }
    let { A: $, B: V, C: J, D: ee, E: te, F: re, G: ie, H: se } = this;
    for (let de = 0; de < 64; de++) {
      const ue = rotr$2(te, 6) ^ rotr$2(te, 11) ^ rotr$2(te, 25), fe = se + ue + Chi$2(te, re, ie) + SHA256_K$2[de] + SHA256_W$2[de] | 0, me = (rotr$2($, 2) ^ rotr$2($, 13) ^ rotr$2($, 22)) + Maj$2($, V, J) | 0;
      se = ie, ie = re, re = te, te = ee + fe | 0, ee = J, J = V, V = $, $ = fe + me | 0;
    }
    $ = $ + this.A | 0, V = V + this.B | 0, J = J + this.C | 0, ee = ee + this.D | 0, te = te + this.E | 0, re = re + this.F | 0, ie = ie + this.G | 0, se = se + this.H | 0, this.set($, V, J, ee, te, re, ie, se);
  }
  roundClean() {
    SHA256_W$2.fill(0);
  }
  destroy() {
    this.set(0, 0, 0, 0, 0, 0, 0, 0), this.buffer.fill(0);
  }
};
const sha256$7 = /* @__PURE__ */ wrapConstructor$2(() => new SHA256$2()), U32_MASK64$2 = /* @__PURE__ */ BigInt(2 ** 32 - 1), _32n$2 = /* @__PURE__ */ BigInt(32);
function fromBig$2(C, e = !1) {
  return e ? { h: Number(C & U32_MASK64$2), l: Number(C >> _32n$2 & U32_MASK64$2) } : { h: Number(C >> _32n$2 & U32_MASK64$2) | 0, l: Number(C & U32_MASK64$2) | 0 };
}
function split$3(C, e = !1) {
  let T = new Uint32Array(C.length), $ = new Uint32Array(C.length);
  for (let V = 0; V < C.length; V++) {
    const { h: J, l: ee } = fromBig$2(C[V], e);
    [T[V], $[V]] = [J, ee];
  }
  return [T, $];
}
const toBig$2 = (C, e) => BigInt(C >>> 0) << _32n$2 | BigInt(e >>> 0), shrSH$2 = (C, e, T) => C >>> T, shrSL$2 = (C, e, T) => C << 32 - T | e >>> T, rotrSH$2 = (C, e, T) => C >>> T | e << 32 - T, rotrSL$2 = (C, e, T) => C << 32 - T | e >>> T, rotrBH$2 = (C, e, T) => C << 64 - T | e >>> T - 32, rotrBL$2 = (C, e, T) => C >>> T - 32 | e << 64 - T, rotr32H$2 = (C, e) => e, rotr32L$2 = (C, e) => C, rotlSH$2 = (C, e, T) => C << T | e >>> 32 - T, rotlSL$2 = (C, e, T) => e << T | C >>> 32 - T, rotlBH$2 = (C, e, T) => e << T - 32 | C >>> 64 - T, rotlBL$2 = (C, e, T) => C << T - 32 | e >>> 64 - T;
function add$2(C, e, T, $) {
  const V = (e >>> 0) + ($ >>> 0);
  return { h: C + T + (V / 2 ** 32 | 0) | 0, l: V | 0 };
}
const add3L$2 = (C, e, T) => (C >>> 0) + (e >>> 0) + (T >>> 0), add3H$2 = (C, e, T, $) => e + T + $ + (C / 2 ** 32 | 0) | 0, add4L$2 = (C, e, T, $) => (C >>> 0) + (e >>> 0) + (T >>> 0) + ($ >>> 0), add4H$2 = (C, e, T, $, V) => e + T + $ + V + (C / 2 ** 32 | 0) | 0, add5L$2 = (C, e, T, $, V) => (C >>> 0) + (e >>> 0) + (T >>> 0) + ($ >>> 0) + (V >>> 0), add5H$2 = (C, e, T, $, V, J) => e + T + $ + V + J + (C / 2 ** 32 | 0) | 0, u64$5 = {
  fromBig: fromBig$2,
  split: split$3,
  toBig: toBig$2,
  shrSH: shrSH$2,
  shrSL: shrSL$2,
  rotrSH: rotrSH$2,
  rotrSL: rotrSL$2,
  rotrBH: rotrBH$2,
  rotrBL: rotrBL$2,
  rotr32H: rotr32H$2,
  rotr32L: rotr32L$2,
  rotlSH: rotlSH$2,
  rotlSL: rotlSL$2,
  rotlBH: rotlBH$2,
  rotlBL: rotlBL$2,
  add: add$2,
  add3L: add3L$2,
  add3H: add3H$2,
  add4L: add4L$2,
  add4H: add4H$2,
  add5H: add5H$2,
  add5L: add5L$2
}, [SHA512_Kh$2, SHA512_Kl$2] = u64$5.split([
  "0x428a2f98d728ae22",
  "0x7137449123ef65cd",
  "0xb5c0fbcfec4d3b2f",
  "0xe9b5dba58189dbbc",
  "0x3956c25bf348b538",
  "0x59f111f1b605d019",
  "0x923f82a4af194f9b",
  "0xab1c5ed5da6d8118",
  "0xd807aa98a3030242",
  "0x12835b0145706fbe",
  "0x243185be4ee4b28c",
  "0x550c7dc3d5ffb4e2",
  "0x72be5d74f27b896f",
  "0x80deb1fe3b1696b1",
  "0x9bdc06a725c71235",
  "0xc19bf174cf692694",
  "0xe49b69c19ef14ad2",
  "0xefbe4786384f25e3",
  "0x0fc19dc68b8cd5b5",
  "0x240ca1cc77ac9c65",
  "0x2de92c6f592b0275",
  "0x4a7484aa6ea6e483",
  "0x5cb0a9dcbd41fbd4",
  "0x76f988da831153b5",
  "0x983e5152ee66dfab",
  "0xa831c66d2db43210",
  "0xb00327c898fb213f",
  "0xbf597fc7beef0ee4",
  "0xc6e00bf33da88fc2",
  "0xd5a79147930aa725",
  "0x06ca6351e003826f",
  "0x142929670a0e6e70",
  "0x27b70a8546d22ffc",
  "0x2e1b21385c26c926",
  "0x4d2c6dfc5ac42aed",
  "0x53380d139d95b3df",
  "0x650a73548baf63de",
  "0x766a0abb3c77b2a8",
  "0x81c2c92e47edaee6",
  "0x92722c851482353b",
  "0xa2bfe8a14cf10364",
  "0xa81a664bbc423001",
  "0xc24b8b70d0f89791",
  "0xc76c51a30654be30",
  "0xd192e819d6ef5218",
  "0xd69906245565a910",
  "0xf40e35855771202a",
  "0x106aa07032bbd1b8",
  "0x19a4c116b8d2d0c8",
  "0x1e376c085141ab53",
  "0x2748774cdf8eeb99",
  "0x34b0bcb5e19b48a8",
  "0x391c0cb3c5c95a63",
  "0x4ed8aa4ae3418acb",
  "0x5b9cca4f7763e373",
  "0x682e6ff3d6b2b8a3",
  "0x748f82ee5defb2fc",
  "0x78a5636f43172f60",
  "0x84c87814a1f0ab72",
  "0x8cc702081a6439ec",
  "0x90befffa23631e28",
  "0xa4506cebde82bde9",
  "0xbef9a3f7b2c67915",
  "0xc67178f2e372532b",
  "0xca273eceea26619c",
  "0xd186b8c721c0c207",
  "0xeada7dd6cde0eb1e",
  "0xf57d4f7fee6ed178",
  "0x06f067aa72176fba",
  "0x0a637dc5a2c898a6",
  "0x113f9804bef90dae",
  "0x1b710b35131c471b",
  "0x28db77f523047d84",
  "0x32caab7b40c72493",
  "0x3c9ebe0a15c9bebc",
  "0x431d67c49c100d4c",
  "0x4cc5d4becb3e42b6",
  "0x597f299cfc657e2a",
  "0x5fcb6fab3ad6faec",
  "0x6c44198c4a475817"
].map((C) => BigInt(C))), SHA512_W_H$2 = /* @__PURE__ */ new Uint32Array(80), SHA512_W_L$2 = /* @__PURE__ */ new Uint32Array(80);
let SHA512$2 = class extends SHA2 {
  constructor() {
    super(128, 64, 16, !1), this.Ah = 1779033703, this.Al = -205731576, this.Bh = -1150833019, this.Bl = -2067093701, this.Ch = 1013904242, this.Cl = -23791573, this.Dh = -1521486534, this.Dl = 1595750129, this.Eh = 1359893119, this.El = -1377402159, this.Fh = -1694144372, this.Fl = 725511199, this.Gh = 528734635, this.Gl = -79577749, this.Hh = 1541459225, this.Hl = 327033209;
  }
  // prettier-ignore
  get() {
    const { Ah: e, Al: T, Bh: $, Bl: V, Ch: J, Cl: ee, Dh: te, Dl: re, Eh: ie, El: se, Fh: de, Fl: ue, Gh: fe, Gl: he, Hh: me, Hl: xe } = this;
    return [e, T, $, V, J, ee, te, re, ie, se, de, ue, fe, he, me, xe];
  }
  // prettier-ignore
  set(e, T, $, V, J, ee, te, re, ie, se, de, ue, fe, he, me, xe) {
    this.Ah = e | 0, this.Al = T | 0, this.Bh = $ | 0, this.Bl = V | 0, this.Ch = J | 0, this.Cl = ee | 0, this.Dh = te | 0, this.Dl = re | 0, this.Eh = ie | 0, this.El = se | 0, this.Fh = de | 0, this.Fl = ue | 0, this.Gh = fe | 0, this.Gl = he | 0, this.Hh = me | 0, this.Hl = xe | 0;
  }
  process(e, T) {
    for (let we = 0; we < 16; we++, T += 4)
      SHA512_W_H$2[we] = e.getUint32(T), SHA512_W_L$2[we] = e.getUint32(T += 4);
    for (let we = 16; we < 80; we++) {
      const Ee = SHA512_W_H$2[we - 15] | 0, Me = SHA512_W_L$2[we - 15] | 0, Ie = u64$5.rotrSH(Ee, Me, 1) ^ u64$5.rotrSH(Ee, Me, 8) ^ u64$5.shrSH(Ee, Me, 7), ke = u64$5.rotrSL(Ee, Me, 1) ^ u64$5.rotrSL(Ee, Me, 8) ^ u64$5.shrSL(Ee, Me, 7), _e = SHA512_W_H$2[we - 2] | 0, De = SHA512_W_L$2[we - 2] | 0, Fe = u64$5.rotrSH(_e, De, 19) ^ u64$5.rotrBH(_e, De, 61) ^ u64$5.shrSH(_e, De, 6), Ae = u64$5.rotrSL(_e, De, 19) ^ u64$5.rotrBL(_e, De, 61) ^ u64$5.shrSL(_e, De, 6), ne = u64$5.add4L(ke, Ae, SHA512_W_L$2[we - 7], SHA512_W_L$2[we - 16]), oe = u64$5.add4H(ne, Ie, Fe, SHA512_W_H$2[we - 7], SHA512_W_H$2[we - 16]);
      SHA512_W_H$2[we] = oe | 0, SHA512_W_L$2[we] = ne | 0;
    }
    let { Ah: $, Al: V, Bh: J, Bl: ee, Ch: te, Cl: re, Dh: ie, Dl: se, Eh: de, El: ue, Fh: fe, Fl: he, Gh: me, Gl: xe, Hh: ve, Hl: Te } = this;
    for (let we = 0; we < 80; we++) {
      const Ee = u64$5.rotrSH(de, ue, 14) ^ u64$5.rotrSH(de, ue, 18) ^ u64$5.rotrBH(de, ue, 41), Me = u64$5.rotrSL(de, ue, 14) ^ u64$5.rotrSL(de, ue, 18) ^ u64$5.rotrBL(de, ue, 41), Ie = de & fe ^ ~de & me, ke = ue & he ^ ~ue & xe, _e = u64$5.add5L(Te, Me, ke, SHA512_Kl$2[we], SHA512_W_L$2[we]), De = u64$5.add5H(_e, ve, Ee, Ie, SHA512_Kh$2[we], SHA512_W_H$2[we]), Fe = _e | 0, Ae = u64$5.rotrSH($, V, 28) ^ u64$5.rotrBH($, V, 34) ^ u64$5.rotrBH($, V, 39), ne = u64$5.rotrSL($, V, 28) ^ u64$5.rotrBL($, V, 34) ^ u64$5.rotrBL($, V, 39), oe = $ & J ^ $ & te ^ J & te, ce = V & ee ^ V & re ^ ee & re;
      ve = me | 0, Te = xe | 0, me = fe | 0, xe = he | 0, fe = de | 0, he = ue | 0, { h: de, l: ue } = u64$5.add(ie | 0, se | 0, De | 0, Fe | 0), ie = te | 0, se = re | 0, te = J | 0, re = ee | 0, J = $ | 0, ee = V | 0;
      const le = u64$5.add3L(Fe, ne, ce);
      $ = u64$5.add3H(le, De, Ae, oe), V = le | 0;
    }
    ({ h: $, l: V } = u64$5.add(this.Ah | 0, this.Al | 0, $ | 0, V | 0)), { h: J, l: ee } = u64$5.add(this.Bh | 0, this.Bl | 0, J | 0, ee | 0), { h: te, l: re } = u64$5.add(this.Ch | 0, this.Cl | 0, te | 0, re | 0), { h: ie, l: se } = u64$5.add(this.Dh | 0, this.Dl | 0, ie | 0, se | 0), { h: de, l: ue } = u64$5.add(this.Eh | 0, this.El | 0, de | 0, ue | 0), { h: fe, l: he } = u64$5.add(this.Fh | 0, this.Fl | 0, fe | 0, he | 0), { h: me, l: xe } = u64$5.add(this.Gh | 0, this.Gl | 0, me | 0, xe | 0), { h: ve, l: Te } = u64$5.add(this.Hh | 0, this.Hl | 0, ve | 0, Te | 0), this.set($, V, J, ee, te, re, ie, se, de, ue, fe, he, me, xe, ve, Te);
  }
  roundClean() {
    SHA512_W_H$2.fill(0), SHA512_W_L$2.fill(0);
  }
  destroy() {
    this.buffer.fill(0), this.set(0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0);
  }
};
const sha512$6 = /* @__PURE__ */ wrapConstructor$2(() => new SHA512$2());
function getGlobal$1() {
  if (typeof self < "u")
    return self;
  if (typeof window < "u")
    return window;
  if (typeof dist$2.global < "u")
    return dist$2.global;
  throw new Error("unable to locate global object");
}
const anyGlobal = getGlobal$1(), crypto$3 = anyGlobal.crypto || anyGlobal.msCrypto;
function createHash(C) {
  switch (C) {
    case "sha256":
      return sha256$7.create();
    case "sha512":
      return sha512$6.create();
  }
  assertArgument(!1, "invalid hashing algorithm name", "algorithm", C);
}
function createHmac(C, e) {
  const T = { sha256: sha256$7, sha512: sha512$6 }[C];
  return assertArgument(T != null, "invalid hmac algorithm", "algorithm", C), hmac$2.create(T, e);
}
function pbkdf2Sync(C, e, T, $, V) {
  const J = { sha256: sha256$7, sha512: sha512$6 }[V];
  return assertArgument(J != null, "invalid pbkdf2 algorithm", "algorithm", V), pbkdf2$1(J, C, e, { c: T, dkLen: $ });
}
function randomBytes$3(C) {
  assert$5(crypto$3 != null, "platform does not support secure random numbers", "UNSUPPORTED_OPERATION", {
    operation: "randomBytes"
  }), assertArgument(Number.isInteger(C) && C > 0 && C <= 1024, "invalid length", "length", C);
  const e = new Uint8Array(C);
  return crypto$3.getRandomValues(e), e;
}
let locked$4 = !1;
const _computeHmac = function(C, e, T) {
  return createHmac(C, e).update(T).digest();
};
let __computeHmac = _computeHmac;
function computeHmac(C, e, T) {
  const $ = getBytes(e, "key"), V = getBytes(T, "data");
  return hexlify(__computeHmac(C, $, V));
}
computeHmac._ = _computeHmac;
computeHmac.lock = function() {
  locked$4 = !0;
};
computeHmac.register = function(C) {
  if (locked$4)
    throw new Error("computeHmac is locked");
  __computeHmac = C;
};
Object.freeze(computeHmac);
const [SHA3_PI$1, SHA3_ROTL$1, _SHA3_IOTA$1] = [[], [], []], _0n$a = /* @__PURE__ */ BigInt(0), _1n$d = /* @__PURE__ */ BigInt(1), _2n$9 = /* @__PURE__ */ BigInt(2), _7n$1 = /* @__PURE__ */ BigInt(7), _256n$1 = /* @__PURE__ */ BigInt(256), _0x71n$1 = /* @__PURE__ */ BigInt(113);
for (let C = 0, e = _1n$d, T = 1, $ = 0; C < 24; C++) {
  [T, $] = [$, (2 * T + 3 * $) % 5], SHA3_PI$1.push(2 * (5 * $ + T)), SHA3_ROTL$1.push((C + 1) * (C + 2) / 2 % 64);
  let V = _0n$a;
  for (let J = 0; J < 7; J++)
    e = (e << _1n$d ^ (e >> _7n$1) * _0x71n$1) % _256n$1, e & _2n$9 && (V ^= _1n$d << (_1n$d << /* @__PURE__ */ BigInt(J)) - _1n$d);
  _SHA3_IOTA$1.push(V);
}
const [SHA3_IOTA_H$1, SHA3_IOTA_L$1] = /* @__PURE__ */ split$3(_SHA3_IOTA$1, !0), rotlH$1 = (C, e, T) => T > 32 ? rotlBH$2(C, e, T) : rotlSH$2(C, e, T), rotlL$1 = (C, e, T) => T > 32 ? rotlBL$2(C, e, T) : rotlSL$2(C, e, T);
function keccakP$1(C, e = 24) {
  const T = new Uint32Array(10);
  for (let $ = 24 - e; $ < 24; $++) {
    for (let ee = 0; ee < 10; ee++)
      T[ee] = C[ee] ^ C[ee + 10] ^ C[ee + 20] ^ C[ee + 30] ^ C[ee + 40];
    for (let ee = 0; ee < 10; ee += 2) {
      const te = (ee + 8) % 10, re = (ee + 2) % 10, ie = T[re], se = T[re + 1], de = rotlH$1(ie, se, 1) ^ T[te], ue = rotlL$1(ie, se, 1) ^ T[te + 1];
      for (let fe = 0; fe < 50; fe += 10)
        C[ee + fe] ^= de, C[ee + fe + 1] ^= ue;
    }
    let V = C[2], J = C[3];
    for (let ee = 0; ee < 24; ee++) {
      const te = SHA3_ROTL$1[ee], re = rotlH$1(V, J, te), ie = rotlL$1(V, J, te), se = SHA3_PI$1[ee];
      V = C[se], J = C[se + 1], C[se] = re, C[se + 1] = ie;
    }
    for (let ee = 0; ee < 50; ee += 10) {
      for (let te = 0; te < 10; te++)
        T[te] = C[ee + te];
      for (let te = 0; te < 10; te++)
        C[ee + te] ^= ~T[(te + 2) % 10] & T[(te + 4) % 10];
    }
    C[0] ^= SHA3_IOTA_H$1[$], C[1] ^= SHA3_IOTA_L$1[$];
  }
  T.fill(0);
}
let Keccak$1 = class Eo extends Hash$2 {
  // NOTE: we accept arguments in bytes instead of bits here.
  constructor(e, T, $, V = !1, J = 24) {
    if (super(), this.blockLen = e, this.suffix = T, this.outputLen = $, this.enableXOF = V, this.rounds = J, this.pos = 0, this.posOut = 0, this.finished = !1, this.destroyed = !1, number$3($), 0 >= this.blockLen || this.blockLen >= 200)
      throw new Error("Sha3 supports only keccak-f1600 function");
    this.state = new Uint8Array(200), this.state32 = u32$3(this.state);
  }
  keccak() {
    keccakP$1(this.state32, this.rounds), this.posOut = 0, this.pos = 0;
  }
  update(e) {
    exists(this);
    const { blockLen: T, state: $ } = this;
    e = toBytes$3(e);
    const V = e.length;
    for (let J = 0; J < V; ) {
      const ee = Math.min(T - this.pos, V - J);
      for (let te = 0; te < ee; te++)
        $[this.pos++] ^= e[J++];
      this.pos === T && this.keccak();
    }
    return this;
  }
  finish() {
    if (this.finished)
      return;
    this.finished = !0;
    const { state: e, suffix: T, pos: $, blockLen: V } = this;
    e[$] ^= T, T & 128 && $ === V - 1 && this.keccak(), e[V - 1] ^= 128, this.keccak();
  }
  writeInto(e) {
    exists(this, !1), bytes$1(e), this.finish();
    const T = this.state, { blockLen: $ } = this;
    for (let V = 0, J = e.length; V < J; ) {
      this.posOut >= $ && this.keccak();
      const ee = Math.min($ - this.posOut, J - V);
      e.set(T.subarray(this.posOut, this.posOut + ee), V), this.posOut += ee, V += ee;
    }
    return e;
  }
  xofInto(e) {
    if (!this.enableXOF)
      throw new Error("XOF is not possible for this instance");
    return this.writeInto(e);
  }
  xof(e) {
    return number$3(e), this.xofInto(new Uint8Array(e));
  }
  digestInto(e) {
    if (output(e, this), this.finished)
      throw new Error("digest() was already called");
    return this.writeInto(e), this.destroy(), e;
  }
  digest() {
    return this.digestInto(new Uint8Array(this.outputLen));
  }
  destroy() {
    this.destroyed = !0, this.state.fill(0);
  }
  _cloneInto(e) {
    const { blockLen: T, suffix: $, outputLen: V, rounds: J, enableXOF: ee } = this;
    return e || (e = new Eo(T, $, V, ee, J)), e.state32.set(this.state32), e.pos = this.pos, e.posOut = this.posOut, e.finished = this.finished, e.rounds = J, e.suffix = $, e.outputLen = V, e.enableXOF = ee, e.destroyed = this.destroyed, e;
  }
};
const gen$1 = (C, e, T) => wrapConstructor$2(() => new Keccak$1(e, C, T)), keccak_256$1 = /* @__PURE__ */ gen$1(1, 136, 256 / 8);
let locked$3 = !1;
const _keccak256 = function(C) {
  return keccak_256$1(C);
};
let __keccak256 = _keccak256;
function keccak256(C) {
  const e = getBytes(C, "data");
  return hexlify(__keccak256(e));
}
keccak256._ = _keccak256;
keccak256.lock = function() {
  locked$3 = !0;
};
keccak256.register = function(C) {
  if (locked$3)
    throw new TypeError("keccak256 is locked");
  __keccak256 = C;
};
Object.freeze(keccak256);
const Rho = /* @__PURE__ */ new Uint8Array([7, 4, 13, 1, 10, 6, 15, 3, 12, 0, 9, 5, 2, 14, 11, 8]), Id = /* @__PURE__ */ Uint8Array.from({ length: 16 }, (C, e) => e), Pi = /* @__PURE__ */ Id.map((C) => (9 * C + 5) % 16);
let idxL = [Id], idxR = [Pi];
for (let C = 0; C < 4; C++)
  for (let e of [idxL, idxR])
    e.push(e[C].map((T) => Rho[T]));
const shifts = /* @__PURE__ */ [
  [11, 14, 15, 12, 5, 8, 7, 9, 11, 13, 14, 15, 6, 7, 9, 8],
  [12, 13, 11, 15, 6, 9, 9, 7, 12, 15, 11, 13, 7, 8, 7, 7],
  [13, 15, 14, 11, 7, 7, 6, 8, 13, 14, 13, 12, 5, 5, 6, 9],
  [14, 11, 12, 14, 8, 6, 5, 5, 15, 12, 15, 14, 9, 9, 8, 6],
  [15, 12, 13, 13, 9, 5, 8, 6, 14, 11, 12, 11, 8, 6, 5, 5]
].map((C) => new Uint8Array(C)), shiftsL = /* @__PURE__ */ idxL.map((C, e) => C.map((T) => shifts[e][T])), shiftsR = /* @__PURE__ */ idxR.map((C, e) => C.map((T) => shifts[e][T])), Kl = /* @__PURE__ */ new Uint32Array([
  0,
  1518500249,
  1859775393,
  2400959708,
  2840853838
]), Kr = /* @__PURE__ */ new Uint32Array([
  1352829926,
  1548603684,
  1836072691,
  2053994217,
  0
]), rotl$2 = (C, e) => C << e | C >>> 32 - e;
function f$1(C, e, T, $) {
  return C === 0 ? e ^ T ^ $ : C === 1 ? e & T | ~e & $ : C === 2 ? (e | ~T) ^ $ : C === 3 ? e & $ | T & ~$ : e ^ (T | ~$);
}
const BUF = /* @__PURE__ */ new Uint32Array(16);
class RIPEMD160 extends SHA2 {
  constructor() {
    super(64, 20, 8, !0), this.h0 = 1732584193, this.h1 = -271733879, this.h2 = -1732584194, this.h3 = 271733878, this.h4 = -1009589776;
  }
  get() {
    const { h0: e, h1: T, h2: $, h3: V, h4: J } = this;
    return [e, T, $, V, J];
  }
  set(e, T, $, V, J) {
    this.h0 = e | 0, this.h1 = T | 0, this.h2 = $ | 0, this.h3 = V | 0, this.h4 = J | 0;
  }
  process(e, T) {
    for (let fe = 0; fe < 16; fe++, T += 4)
      BUF[fe] = e.getUint32(T, !0);
    let $ = this.h0 | 0, V = $, J = this.h1 | 0, ee = J, te = this.h2 | 0, re = te, ie = this.h3 | 0, se = ie, de = this.h4 | 0, ue = de;
    for (let fe = 0; fe < 5; fe++) {
      const he = 4 - fe, me = Kl[fe], xe = Kr[fe], ve = idxL[fe], Te = idxR[fe], we = shiftsL[fe], Ee = shiftsR[fe];
      for (let Me = 0; Me < 16; Me++) {
        const Ie = rotl$2($ + f$1(fe, J, te, ie) + BUF[ve[Me]] + me, we[Me]) + de | 0;
        $ = de, de = ie, ie = rotl$2(te, 10) | 0, te = J, J = Ie;
      }
      for (let Me = 0; Me < 16; Me++) {
        const Ie = rotl$2(V + f$1(he, ee, re, se) + BUF[Te[Me]] + xe, Ee[Me]) + ue | 0;
        V = ue, ue = se, se = rotl$2(re, 10) | 0, re = ee, ee = Ie;
      }
    }
    this.set(this.h1 + te + se | 0, this.h2 + ie + ue | 0, this.h3 + de + V | 0, this.h4 + $ + ee | 0, this.h0 + J + re | 0);
  }
  roundClean() {
    BUF.fill(0);
  }
  destroy() {
    this.destroyed = !0, this.buffer.fill(0), this.set(0, 0, 0, 0, 0);
  }
}
const ripemd160$2 = /* @__PURE__ */ wrapConstructor$2(() => new RIPEMD160());
let locked$2 = !1;
const _ripemd160 = function(C) {
  return ripemd160$2(C);
};
let __ripemd160 = _ripemd160;
function ripemd160$1(C) {
  const e = getBytes(C, "data");
  return hexlify(__ripemd160(e));
}
ripemd160$1._ = _ripemd160;
ripemd160$1.lock = function() {
  locked$2 = !0;
};
ripemd160$1.register = function(C) {
  if (locked$2)
    throw new TypeError("ripemd160 is locked");
  __ripemd160 = C;
};
Object.freeze(ripemd160$1);
let locked$1 = !1;
const _pbkdf2 = function(C, e, T, $, V) {
  return pbkdf2Sync(C, e, T, $, V);
};
let __pbkdf2 = _pbkdf2;
function pbkdf2(C, e, T, $, V) {
  const J = getBytes(C, "password"), ee = getBytes(e, "salt");
  return hexlify(__pbkdf2(J, ee, T, $, V));
}
pbkdf2._ = _pbkdf2;
pbkdf2.lock = function() {
  locked$1 = !0;
};
pbkdf2.register = function(C) {
  if (locked$1)
    throw new Error("pbkdf2 is locked");
  __pbkdf2 = C;
};
Object.freeze(pbkdf2);
let locked = !1;
const _randomBytes = function(C) {
  return new Uint8Array(randomBytes$3(C));
};
let __randomBytes = _randomBytes;
function randomBytes$2(C) {
  return __randomBytes(C);
}
randomBytes$2._ = _randomBytes;
randomBytes$2.lock = function() {
  locked = !0;
};
randomBytes$2.register = function(C) {
  if (locked)
    throw new Error("randomBytes is locked");
  __randomBytes = C;
};
Object.freeze(randomBytes$2);
const rotl$1 = (C, e) => C << e | C >>> 32 - e;
function XorAndSalsa(C, e, T, $, V, J) {
  let ee = C[e++] ^ T[$++], te = C[e++] ^ T[$++], re = C[e++] ^ T[$++], ie = C[e++] ^ T[$++], se = C[e++] ^ T[$++], de = C[e++] ^ T[$++], ue = C[e++] ^ T[$++], fe = C[e++] ^ T[$++], he = C[e++] ^ T[$++], me = C[e++] ^ T[$++], xe = C[e++] ^ T[$++], ve = C[e++] ^ T[$++], Te = C[e++] ^ T[$++], we = C[e++] ^ T[$++], Ee = C[e++] ^ T[$++], Me = C[e++] ^ T[$++], Ie = ee, ke = te, _e = re, De = ie, Fe = se, Ae = de, ne = ue, oe = fe, ce = he, le = me, pe = xe, ye = ve, Ce = Te, be = we, ae = Ee, ge = Me;
  for (let Se = 0; Se < 8; Se += 2)
    Fe ^= rotl$1(Ie + Ce | 0, 7), ce ^= rotl$1(Fe + Ie | 0, 9), Ce ^= rotl$1(ce + Fe | 0, 13), Ie ^= rotl$1(Ce + ce | 0, 18), le ^= rotl$1(Ae + ke | 0, 7), be ^= rotl$1(le + Ae | 0, 9), ke ^= rotl$1(be + le | 0, 13), Ae ^= rotl$1(ke + be | 0, 18), ae ^= rotl$1(pe + ne | 0, 7), _e ^= rotl$1(ae + pe | 0, 9), ne ^= rotl$1(_e + ae | 0, 13), pe ^= rotl$1(ne + _e | 0, 18), De ^= rotl$1(ge + ye | 0, 7), oe ^= rotl$1(De + ge | 0, 9), ye ^= rotl$1(oe + De | 0, 13), ge ^= rotl$1(ye + oe | 0, 18), ke ^= rotl$1(Ie + De | 0, 7), _e ^= rotl$1(ke + Ie | 0, 9), De ^= rotl$1(_e + ke | 0, 13), Ie ^= rotl$1(De + _e | 0, 18), ne ^= rotl$1(Ae + Fe | 0, 7), oe ^= rotl$1(ne + Ae | 0, 9), Fe ^= rotl$1(oe + ne | 0, 13), Ae ^= rotl$1(Fe + oe | 0, 18), ye ^= rotl$1(pe + le | 0, 7), ce ^= rotl$1(ye + pe | 0, 9), le ^= rotl$1(ce + ye | 0, 13), pe ^= rotl$1(le + ce | 0, 18), Ce ^= rotl$1(ge + ae | 0, 7), be ^= rotl$1(Ce + ge | 0, 9), ae ^= rotl$1(be + Ce | 0, 13), ge ^= rotl$1(ae + be | 0, 18);
  V[J++] = ee + Ie | 0, V[J++] = te + ke | 0, V[J++] = re + _e | 0, V[J++] = ie + De | 0, V[J++] = se + Fe | 0, V[J++] = de + Ae | 0, V[J++] = ue + ne | 0, V[J++] = fe + oe | 0, V[J++] = he + ce | 0, V[J++] = me + le | 0, V[J++] = xe + pe | 0, V[J++] = ve + ye | 0, V[J++] = Te + Ce | 0, V[J++] = we + be | 0, V[J++] = Ee + ae | 0, V[J++] = Me + ge | 0;
}
function BlockMix(C, e, T, $, V) {
  let J = $ + 0, ee = $ + 16 * V;
  for (let te = 0; te < 16; te++)
    T[ee + te] = C[e + (2 * V - 1) * 16 + te];
  for (let te = 0; te < V; te++, J += 16, e += 16)
    XorAndSalsa(T, ee, C, e, T, J), te > 0 && (ee += 16), XorAndSalsa(T, J, C, e += 16, T, ee);
}
function scryptInit(C, e, T) {
  const $ = checkOpts$1({
    dkLen: 32,
    asyncTick: 10,
    maxmem: 1073742848
  }, T), { N: V, r: J, p: ee, dkLen: te, asyncTick: re, maxmem: ie, onProgress: se } = $;
  if (number$3(V), number$3(J), number$3(ee), number$3(te), number$3(re), number$3(ie), se !== void 0 && typeof se != "function")
    throw new Error("progressCb should be function");
  const de = 128 * J, ue = de / 4;
  if (V <= 1 || V & V - 1 || V >= 2 ** (de / 8) || V > 2 ** 32)
    throw new Error("Scrypt: N must be larger than 1, a power of 2, less than 2^(128 * r / 8) and less than 2^32");
  if (ee < 0 || ee > (2 ** 32 - 1) * 32 / de)
    throw new Error("Scrypt: p must be a positive integer less than or equal to ((2^32 - 1) * 32) / (128 * r)");
  if (te < 0 || te > (2 ** 32 - 1) * 32)
    throw new Error("Scrypt: dkLen should be positive integer less than or equal to (2^32 - 1) * 32");
  const fe = de * (V + ee);
  if (fe > ie)
    throw new Error(`Scrypt: parameters too large, ${fe} (128 * r * (N + p)) > ${ie} (maxmem)`);
  const he = pbkdf2$1(sha256$7, C, e, { c: 1, dkLen: de * ee }), me = u32$3(he), xe = u32$3(new Uint8Array(de * V)), ve = u32$3(new Uint8Array(de));
  let Te = () => {
  };
  if (se) {
    const we = 2 * V * ee, Ee = Math.max(Math.floor(we / 1e4), 1);
    let Me = 0;
    Te = () => {
      Me++, se && (!(Me % Ee) || Me === we) && se(Me / we);
    };
  }
  return { N: V, r: J, p: ee, dkLen: te, blockSize32: ue, V: xe, B32: me, B: he, tmp: ve, blockMixCb: Te, asyncTick: re };
}
function scryptOutput(C, e, T, $, V) {
  const J = pbkdf2$1(sha256$7, C, T, { c: 1, dkLen: e });
  return T.fill(0), $.fill(0), V.fill(0), J;
}
function scrypt$1(C, e, T) {
  const { N: $, r: V, p: J, dkLen: ee, blockSize32: te, V: re, B32: ie, B: se, tmp: de, blockMixCb: ue } = scryptInit(C, e, T);
  for (let fe = 0; fe < J; fe++) {
    const he = te * fe;
    for (let me = 0; me < te; me++)
      re[me] = ie[he + me];
    for (let me = 0, xe = 0; me < $ - 1; me++)
      BlockMix(re, xe, re, xe += te, V), ue();
    BlockMix(re, ($ - 1) * te, ie, he, V), ue();
    for (let me = 0; me < $; me++) {
      const xe = ie[he + te - 16] % $;
      for (let ve = 0; ve < te; ve++)
        de[ve] = ie[he + ve] ^ re[xe * te + ve];
      BlockMix(de, 0, ie, he, V), ue();
    }
  }
  return scryptOutput(C, ee, se, re, de);
}
async function scryptAsync(C, e, T) {
  const { N: $, r: V, p: J, dkLen: ee, blockSize32: te, V: re, B32: ie, B: se, tmp: de, blockMixCb: ue, asyncTick: fe } = scryptInit(C, e, T);
  for (let he = 0; he < J; he++) {
    const me = te * he;
    for (let ve = 0; ve < te; ve++)
      re[ve] = ie[me + ve];
    let xe = 0;
    await asyncLoop($ - 1, fe, () => {
      BlockMix(re, xe, re, xe += te, V), ue();
    }), BlockMix(re, ($ - 1) * te, ie, me, V), ue(), await asyncLoop($, fe, () => {
      const ve = ie[me + te - 16] % $;
      for (let Te = 0; Te < te; Te++)
        de[Te] = ie[me + Te] ^ re[ve * te + Te];
      BlockMix(de, 0, ie, me, V), ue();
    });
  }
  return scryptOutput(C, ee, se, re, de);
}
let lockedSync = !1, lockedAsync = !1;
const _scryptAsync = async function(C, e, T, $, V, J, ee) {
  return await scryptAsync(C, e, { N: T, r: $, p: V, dkLen: J, onProgress: ee });
}, _scryptSync = function(C, e, T, $, V, J) {
  return scrypt$1(C, e, { N: T, r: $, p: V, dkLen: J });
};
let __scryptAsync = _scryptAsync, __scryptSync = _scryptSync;
async function scrypt(C, e, T, $, V, J, ee) {
  const te = getBytes(C, "passwd"), re = getBytes(e, "salt");
  return hexlify(await __scryptAsync(te, re, T, $, V, J, ee));
}
scrypt._ = _scryptAsync;
scrypt.lock = function() {
  lockedAsync = !0;
};
scrypt.register = function(C) {
  if (lockedAsync)
    throw new Error("scrypt is locked");
  __scryptAsync = C;
};
Object.freeze(scrypt);
function scryptSync(C, e, T, $, V, J) {
  const ee = getBytes(C, "passwd"), te = getBytes(e, "salt");
  return hexlify(__scryptSync(ee, te, T, $, V, J));
}
scryptSync._ = _scryptSync;
scryptSync.lock = function() {
  lockedSync = !0;
};
scryptSync.register = function(C) {
  if (lockedSync)
    throw new Error("scryptSync is locked");
  __scryptSync = C;
};
Object.freeze(scryptSync);
const _sha256 = function(C) {
  return createHash("sha256").update(C).digest();
};
let __sha256 = _sha256, locked256 = !1;
function sha256$6(C) {
  const e = getBytes(C, "data");
  return hexlify(__sha256(e));
}
sha256$6._ = _sha256;
sha256$6.lock = function() {
  locked256 = !0;
};
sha256$6.register = function(C) {
  if (locked256)
    throw new Error("sha256 is locked");
  __sha256 = C;
};
Object.freeze(sha256$6);
Object.freeze(sha256$6);
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */
const _0n$9 = BigInt(0), _1n$c = BigInt(1), _2n$8 = BigInt(2), u8a = (C) => C instanceof Uint8Array, hexes$2 = /* @__PURE__ */ Array.from({ length: 256 }, (C, e) => e.toString(16).padStart(2, "0"));
function bytesToHex$2(C) {
  if (!u8a(C))
    throw new Error("Uint8Array expected");
  let e = "";
  for (let T = 0; T < C.length; T++)
    e += hexes$2[C[T]];
  return e;
}
function numberToHexUnpadded$1(C) {
  const e = C.toString(16);
  return e.length & 1 ? `0${e}` : e;
}
function hexToNumber$1(C) {
  if (typeof C != "string")
    throw new Error("hex string expected, got " + typeof C);
  return BigInt(C === "" ? "0" : `0x${C}`);
}
function hexToBytes$2(C) {
  if (typeof C != "string")
    throw new Error("hex string expected, got " + typeof C);
  const e = C.length;
  if (e % 2)
    throw new Error("padded hex string expected, got unpadded hex of length " + e);
  const T = new Uint8Array(e / 2);
  for (let $ = 0; $ < T.length; $++) {
    const V = $ * 2, J = C.slice(V, V + 2), ee = Number.parseInt(J, 16);
    if (Number.isNaN(ee) || ee < 0)
      throw new Error("Invalid byte sequence");
    T[$] = ee;
  }
  return T;
}
function bytesToNumberBE$1(C) {
  return hexToNumber$1(bytesToHex$2(C));
}
function bytesToNumberLE$1(C) {
  if (!u8a(C))
    throw new Error("Uint8Array expected");
  return hexToNumber$1(bytesToHex$2(Uint8Array.from(C).reverse()));
}
function numberToBytesBE$1(C, e) {
  return hexToBytes$2(C.toString(16).padStart(e * 2, "0"));
}
function numberToBytesLE$1(C, e) {
  return numberToBytesBE$1(C, e).reverse();
}
function numberToVarBytesBE$1(C) {
  return hexToBytes$2(numberToHexUnpadded$1(C));
}
function ensureBytes$1(C, e, T) {
  let $;
  if (typeof e == "string")
    try {
      $ = hexToBytes$2(e);
    } catch (J) {
      throw new Error(`${C} must be valid hex string, got "${e}". Cause: ${J}`);
    }
  else if (u8a(e))
    $ = Uint8Array.from(e);
  else
    throw new Error(`${C} must be hex string or Uint8Array`);
  const V = $.length;
  if (typeof T == "number" && V !== T)
    throw new Error(`${C} expected ${T} bytes, got ${V}`);
  return $;
}
function concatBytes$3(...C) {
  const e = new Uint8Array(C.reduce(($, V) => $ + V.length, 0));
  let T = 0;
  return C.forEach(($) => {
    if (!u8a($))
      throw new Error("Uint8Array expected");
    e.set($, T), T += $.length;
  }), e;
}
function equalBytes$1(C, e) {
  if (C.length !== e.length)
    return !1;
  for (let T = 0; T < C.length; T++)
    if (C[T] !== e[T])
      return !1;
  return !0;
}
function utf8ToBytes$3(C) {
  if (typeof C != "string")
    throw new Error(`utf8ToBytes expected string, got ${typeof C}`);
  return new Uint8Array(new TextEncoder().encode(C));
}
function bitLen$1(C) {
  let e;
  for (e = 0; C > _0n$9; C >>= _1n$c, e += 1)
    ;
  return e;
}
function bitGet$1(C, e) {
  return C >> BigInt(e) & _1n$c;
}
const bitSet$1 = (C, e, T) => C | (T ? _1n$c : _0n$9) << BigInt(e), bitMask$1 = (C) => (_2n$8 << BigInt(C - 1)) - _1n$c, u8n$1 = (C) => new Uint8Array(C), u8fr$1 = (C) => Uint8Array.from(C);
function createHmacDrbg$1(C, e, T) {
  if (typeof C != "number" || C < 2)
    throw new Error("hashLen must be a number");
  if (typeof e != "number" || e < 2)
    throw new Error("qByteLen must be a number");
  if (typeof T != "function")
    throw new Error("hmacFn must be a function");
  let $ = u8n$1(C), V = u8n$1(C), J = 0;
  const ee = () => {
    $.fill(1), V.fill(0), J = 0;
  }, te = (...de) => T(V, $, ...de), re = (de = u8n$1()) => {
    V = te(u8fr$1([0]), de), $ = te(), de.length !== 0 && (V = te(u8fr$1([1]), de), $ = te());
  }, ie = () => {
    if (J++ >= 1e3)
      throw new Error("drbg: tried 1000 values");
    let de = 0;
    const ue = [];
    for (; de < e; ) {
      $ = te();
      const fe = $.slice();
      ue.push(fe), de += $.length;
    }
    return concatBytes$3(...ue);
  };
  return (de, ue) => {
    ee(), re(de);
    let fe;
    for (; !(fe = ue(ie())); )
      re();
    return ee(), fe;
  };
}
const validatorFns$1 = {
  bigint: (C) => typeof C == "bigint",
  function: (C) => typeof C == "function",
  boolean: (C) => typeof C == "boolean",
  string: (C) => typeof C == "string",
  stringOrUint8Array: (C) => typeof C == "string" || C instanceof Uint8Array,
  isSafeInteger: (C) => Number.isSafeInteger(C),
  array: (C) => Array.isArray(C),
  field: (C, e) => e.Fp.isValid(C),
  hash: (C) => typeof C == "function" && Number.isSafeInteger(C.outputLen)
};
function validateObject$1(C, e, T = {}) {
  const $ = (V, J, ee) => {
    const te = validatorFns$1[J];
    if (typeof te != "function")
      throw new Error(`Invalid validator "${J}", expected function`);
    const re = C[V];
    if (!(ee && re === void 0) && !te(re, C))
      throw new Error(`Invalid param ${String(V)}=${re} (${typeof re}), expected ${J}`);
  };
  for (const [V, J] of Object.entries(e))
    $(V, J, !1);
  for (const [V, J] of Object.entries(T))
    $(V, J, !0);
  return C;
}
const ut$1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  bitGet: bitGet$1,
  bitLen: bitLen$1,
  bitMask: bitMask$1,
  bitSet: bitSet$1,
  bytesToHex: bytesToHex$2,
  bytesToNumberBE: bytesToNumberBE$1,
  bytesToNumberLE: bytesToNumberLE$1,
  concatBytes: concatBytes$3,
  createHmacDrbg: createHmacDrbg$1,
  ensureBytes: ensureBytes$1,
  equalBytes: equalBytes$1,
  hexToBytes: hexToBytes$2,
  hexToNumber: hexToNumber$1,
  numberToBytesBE: numberToBytesBE$1,
  numberToBytesLE: numberToBytesLE$1,
  numberToHexUnpadded: numberToHexUnpadded$1,
  numberToVarBytesBE: numberToVarBytesBE$1,
  utf8ToBytes: utf8ToBytes$3,
  validateObject: validateObject$1
}, Symbol.toStringTag, { value: "Module" }));
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */
const _0n$8 = BigInt(0), _1n$b = BigInt(1), _2n$7 = BigInt(2), _3n$3 = BigInt(3), _4n$1 = BigInt(4), _5n$2 = BigInt(5), _8n$3 = BigInt(8);
BigInt(9);
BigInt(16);
function mod$1(C, e) {
  const T = C % e;
  return T >= _0n$8 ? T : e + T;
}
function pow$1(C, e, T) {
  if (T <= _0n$8 || e < _0n$8)
    throw new Error("Expected power/modulo > 0");
  if (T === _1n$b)
    return _0n$8;
  let $ = _1n$b;
  for (; e > _0n$8; )
    e & _1n$b && ($ = $ * C % T), C = C * C % T, e >>= _1n$b;
  return $;
}
function pow2$1(C, e, T) {
  let $ = C;
  for (; e-- > _0n$8; )
    $ *= $, $ %= T;
  return $;
}
function invert$1(C, e) {
  if (C === _0n$8 || e <= _0n$8)
    throw new Error(`invert: expected positive integers, got n=${C} mod=${e}`);
  let T = mod$1(C, e), $ = e, V = _0n$8, J = _1n$b;
  for (; T !== _0n$8; ) {
    const te = $ / T, re = $ % T, ie = V - J * te;
    $ = T, T = re, V = J, J = ie;
  }
  if ($ !== _1n$b)
    throw new Error("invert: does not exist");
  return mod$1(V, e);
}
function tonelliShanks$1(C) {
  const e = (C - _1n$b) / _2n$7;
  let T, $, V;
  for (T = C - _1n$b, $ = 0; T % _2n$7 === _0n$8; T /= _2n$7, $++)
    ;
  for (V = _2n$7; V < C && pow$1(V, e, C) !== C - _1n$b; V++)
    ;
  if ($ === 1) {
    const ee = (C + _1n$b) / _4n$1;
    return function(re, ie) {
      const se = re.pow(ie, ee);
      if (!re.eql(re.sqr(se), ie))
        throw new Error("Cannot find square root");
      return se;
    };
  }
  const J = (T + _1n$b) / _2n$7;
  return function(te, re) {
    if (te.pow(re, e) === te.neg(te.ONE))
      throw new Error("Cannot find square root");
    let ie = $, se = te.pow(te.mul(te.ONE, V), T), de = te.pow(re, J), ue = te.pow(re, T);
    for (; !te.eql(ue, te.ONE); ) {
      if (te.eql(ue, te.ZERO))
        return te.ZERO;
      let fe = 1;
      for (let me = te.sqr(ue); fe < ie && !te.eql(me, te.ONE); fe++)
        me = te.sqr(me);
      const he = te.pow(se, _1n$b << BigInt(ie - fe - 1));
      se = te.sqr(he), de = te.mul(de, he), ue = te.mul(ue, se), ie = fe;
    }
    return de;
  };
}
function FpSqrt$1(C) {
  if (C % _4n$1 === _3n$3) {
    const e = (C + _1n$b) / _4n$1;
    return function($, V) {
      const J = $.pow(V, e);
      if (!$.eql($.sqr(J), V))
        throw new Error("Cannot find square root");
      return J;
    };
  }
  if (C % _8n$3 === _5n$2) {
    const e = (C - _5n$2) / _8n$3;
    return function($, V) {
      const J = $.mul(V, _2n$7), ee = $.pow(J, e), te = $.mul(V, ee), re = $.mul($.mul(te, _2n$7), ee), ie = $.mul(te, $.sub(re, $.ONE));
      if (!$.eql($.sqr(ie), V))
        throw new Error("Cannot find square root");
      return ie;
    };
  }
  return tonelliShanks$1(C);
}
const FIELD_FIELDS$1 = [
  "create",
  "isValid",
  "is0",
  "neg",
  "inv",
  "sqrt",
  "sqr",
  "eql",
  "add",
  "sub",
  "mul",
  "pow",
  "div",
  "addN",
  "subN",
  "mulN",
  "sqrN"
];
function validateField$1(C) {
  const e = {
    ORDER: "bigint",
    MASK: "bigint",
    BYTES: "isSafeInteger",
    BITS: "isSafeInteger"
  }, T = FIELD_FIELDS$1.reduce(($, V) => ($[V] = "function", $), e);
  return validateObject$1(C, T);
}
function FpPow$1(C, e, T) {
  if (T < _0n$8)
    throw new Error("Expected power > 0");
  if (T === _0n$8)
    return C.ONE;
  if (T === _1n$b)
    return e;
  let $ = C.ONE, V = e;
  for (; T > _0n$8; )
    T & _1n$b && ($ = C.mul($, V)), V = C.sqr(V), T >>= _1n$b;
  return $;
}
function FpInvertBatch$1(C, e) {
  const T = new Array(e.length), $ = e.reduce((J, ee, te) => C.is0(ee) ? J : (T[te] = J, C.mul(J, ee)), C.ONE), V = C.inv($);
  return e.reduceRight((J, ee, te) => C.is0(ee) ? J : (T[te] = C.mul(J, T[te]), C.mul(J, ee)), V), T;
}
function nLength$1(C, e) {
  const T = e !== void 0 ? e : C.toString(2).length, $ = Math.ceil(T / 8);
  return { nBitLength: T, nByteLength: $ };
}
function Field$1(C, e, T = !1, $ = {}) {
  if (C <= _0n$8)
    throw new Error(`Expected Field ORDER > 0, got ${C}`);
  const { nBitLength: V, nByteLength: J } = nLength$1(C, e);
  if (J > 2048)
    throw new Error("Field lengths over 2048 bytes are not supported");
  const ee = FpSqrt$1(C), te = Object.freeze({
    ORDER: C,
    BITS: V,
    BYTES: J,
    MASK: bitMask$1(V),
    ZERO: _0n$8,
    ONE: _1n$b,
    create: (re) => mod$1(re, C),
    isValid: (re) => {
      if (typeof re != "bigint")
        throw new Error(`Invalid field element: expected bigint, got ${typeof re}`);
      return _0n$8 <= re && re < C;
    },
    is0: (re) => re === _0n$8,
    isOdd: (re) => (re & _1n$b) === _1n$b,
    neg: (re) => mod$1(-re, C),
    eql: (re, ie) => re === ie,
    sqr: (re) => mod$1(re * re, C),
    add: (re, ie) => mod$1(re + ie, C),
    sub: (re, ie) => mod$1(re - ie, C),
    mul: (re, ie) => mod$1(re * ie, C),
    pow: (re, ie) => FpPow$1(te, re, ie),
    div: (re, ie) => mod$1(re * invert$1(ie, C), C),
    // Same as above, but doesn't normalize
    sqrN: (re) => re * re,
    addN: (re, ie) => re + ie,
    subN: (re, ie) => re - ie,
    mulN: (re, ie) => re * ie,
    inv: (re) => invert$1(re, C),
    sqrt: $.sqrt || ((re) => ee(te, re)),
    invertBatch: (re) => FpInvertBatch$1(te, re),
    // TODO: do we really need constant cmov?
    // We don't have const-time bigints anyway, so probably will be not very useful
    cmov: (re, ie, se) => se ? ie : re,
    toBytes: (re) => T ? numberToBytesLE$1(re, J) : numberToBytesBE$1(re, J),
    fromBytes: (re) => {
      if (re.length !== J)
        throw new Error(`Fp.fromBytes: expected ${J}, got ${re.length}`);
      return T ? bytesToNumberLE$1(re) : bytesToNumberBE$1(re);
    }
  });
  return Object.freeze(te);
}
function getFieldBytesLength$1(C) {
  if (typeof C != "bigint")
    throw new Error("field order must be bigint");
  const e = C.toString(2).length;
  return Math.ceil(e / 8);
}
function getMinHashLength$1(C) {
  const e = getFieldBytesLength$1(C);
  return e + Math.ceil(e / 2);
}
function mapHashToField$1(C, e, T = !1) {
  const $ = C.length, V = getFieldBytesLength$1(e), J = getMinHashLength$1(e);
  if ($ < 16 || $ < J || $ > 1024)
    throw new Error(`expected ${J}-1024 bytes of input, got ${$}`);
  const ee = T ? bytesToNumberBE$1(C) : bytesToNumberLE$1(C), te = mod$1(ee, e - _1n$b) + _1n$b;
  return T ? numberToBytesLE$1(te, V) : numberToBytesBE$1(te, V);
}
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */
const _0n$7 = BigInt(0), _1n$a = BigInt(1);
function wNAF$1(C, e) {
  const T = (V, J) => {
    const ee = J.negate();
    return V ? ee : J;
  }, $ = (V) => {
    const J = Math.ceil(e / V) + 1, ee = 2 ** (V - 1);
    return { windows: J, windowSize: ee };
  };
  return {
    constTimeNegate: T,
    // non-const time multiplication ladder
    unsafeLadder(V, J) {
      let ee = C.ZERO, te = V;
      for (; J > _0n$7; )
        J & _1n$a && (ee = ee.add(te)), te = te.double(), J >>= _1n$a;
      return ee;
    },
    /**
     * Creates a wNAF precomputation window. Used for caching.
     * Default window size is set by `utils.precompute()` and is equal to 8.
     * Number of precomputed points depends on the curve size:
     * 2^(𝑊−1) * (Math.ceil(𝑛 / 𝑊) + 1), where:
     * - 𝑊 is the window size
     * - 𝑛 is the bitlength of the curve order.
     * For a 256-bit curve and window size 8, the number of precomputed points is 128 * 33 = 4224.
     * @returns precomputed point tables flattened to a single array
     */
    precomputeWindow(V, J) {
      const { windows: ee, windowSize: te } = $(J), re = [];
      let ie = V, se = ie;
      for (let de = 0; de < ee; de++) {
        se = ie, re.push(se);
        for (let ue = 1; ue < te; ue++)
          se = se.add(ie), re.push(se);
        ie = se.double();
      }
      return re;
    },
    /**
     * Implements ec multiplication using precomputed tables and w-ary non-adjacent form.
     * @param W window size
     * @param precomputes precomputed tables
     * @param n scalar (we don't check here, but should be less than curve order)
     * @returns real and fake (for const-time) points
     */
    wNAF(V, J, ee) {
      const { windows: te, windowSize: re } = $(V);
      let ie = C.ZERO, se = C.BASE;
      const de = BigInt(2 ** V - 1), ue = 2 ** V, fe = BigInt(V);
      for (let he = 0; he < te; he++) {
        const me = he * re;
        let xe = Number(ee & de);
        ee >>= fe, xe > re && (xe -= ue, ee += _1n$a);
        const ve = me, Te = me + Math.abs(xe) - 1, we = he % 2 !== 0, Ee = xe < 0;
        xe === 0 ? se = se.add(T(we, J[ve])) : ie = ie.add(T(Ee, J[Te]));
      }
      return { p: ie, f: se };
    },
    wNAFCached(V, J, ee, te) {
      const re = V._WINDOW_SIZE || 1;
      let ie = J.get(V);
      return ie || (ie = this.precomputeWindow(V, re), re !== 1 && J.set(V, te(ie))), this.wNAF(re, ie, ee);
    }
  };
}
function validateBasic$1(C) {
  return validateField$1(C.Fp), validateObject$1(C, {
    n: "bigint",
    h: "bigint",
    Gx: "field",
    Gy: "field"
  }, {
    nBitLength: "isSafeInteger",
    nByteLength: "isSafeInteger"
  }), Object.freeze({
    ...nLength$1(C.n, C.nBitLength),
    ...C,
    p: C.Fp.ORDER
  });
}
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */
function validatePointOpts$1(C) {
  const e = validateBasic$1(C);
  validateObject$1(e, {
    a: "field",
    b: "field"
  }, {
    allowedPrivateKeyLengths: "array",
    wrapPrivateKey: "boolean",
    isTorsionFree: "function",
    clearCofactor: "function",
    allowInfinityPoint: "boolean",
    fromBytes: "function",
    toBytes: "function"
  });
  const { endo: T, Fp: $, a: V } = e;
  if (T) {
    if (!$.eql(V, $.ZERO))
      throw new Error("Endomorphism can only be defined for Koblitz curves that have a=0");
    if (typeof T != "object" || typeof T.beta != "bigint" || typeof T.splitScalar != "function")
      throw new Error("Expected endomorphism with beta: bigint and splitScalar: function");
  }
  return Object.freeze({ ...e });
}
const { bytesToNumberBE: b2n$1, hexToBytes: h2b$1 } = ut$1, DER$1 = {
  // asn.1 DER encoding utils
  Err: class extends Error {
    constructor(e = "") {
      super(e);
    }
  },
  _parseInt(C) {
    const { Err: e } = DER$1;
    if (C.length < 2 || C[0] !== 2)
      throw new e("Invalid signature integer tag");
    const T = C[1], $ = C.subarray(2, T + 2);
    if (!T || $.length !== T)
      throw new e("Invalid signature integer: wrong length");
    if ($[0] & 128)
      throw new e("Invalid signature integer: negative");
    if ($[0] === 0 && !($[1] & 128))
      throw new e("Invalid signature integer: unnecessary leading zero");
    return { d: b2n$1($), l: C.subarray(T + 2) };
  },
  toSig(C) {
    const { Err: e } = DER$1, T = typeof C == "string" ? h2b$1(C) : C;
    if (!(T instanceof Uint8Array))
      throw new Error("ui8a expected");
    let $ = T.length;
    if ($ < 2 || T[0] != 48)
      throw new e("Invalid signature tag");
    if (T[1] !== $ - 2)
      throw new e("Invalid signature: incorrect length");
    const { d: V, l: J } = DER$1._parseInt(T.subarray(2)), { d: ee, l: te } = DER$1._parseInt(J);
    if (te.length)
      throw new e("Invalid signature: left bytes after parsing");
    return { r: V, s: ee };
  },
  hexFromSig(C) {
    const e = (ie) => Number.parseInt(ie[0], 16) & 8 ? "00" + ie : ie, T = (ie) => {
      const se = ie.toString(16);
      return se.length & 1 ? `0${se}` : se;
    }, $ = e(T(C.s)), V = e(T(C.r)), J = $.length / 2, ee = V.length / 2, te = T(J), re = T(ee);
    return `30${T(ee + J + 4)}02${re}${V}02${te}${$}`;
  }
}, _0n$6 = BigInt(0), _1n$9 = BigInt(1);
BigInt(2);
const _3n$2 = BigInt(3);
BigInt(4);
function weierstrassPoints$1(C) {
  const e = validatePointOpts$1(C), { Fp: T } = e, $ = e.toBytes || ((he, me, xe) => {
    const ve = me.toAffine();
    return concatBytes$3(Uint8Array.from([4]), T.toBytes(ve.x), T.toBytes(ve.y));
  }), V = e.fromBytes || ((he) => {
    const me = he.subarray(1), xe = T.fromBytes(me.subarray(0, T.BYTES)), ve = T.fromBytes(me.subarray(T.BYTES, 2 * T.BYTES));
    return { x: xe, y: ve };
  });
  function J(he) {
    const { a: me, b: xe } = e, ve = T.sqr(he), Te = T.mul(ve, he);
    return T.add(T.add(Te, T.mul(he, me)), xe);
  }
  if (!T.eql(T.sqr(e.Gy), J(e.Gx)))
    throw new Error("bad generator point: equation left != right");
  function ee(he) {
    return typeof he == "bigint" && _0n$6 < he && he < e.n;
  }
  function te(he) {
    if (!ee(he))
      throw new Error("Expected valid bigint: 0 < bigint < curve.n");
  }
  function re(he) {
    const { allowedPrivateKeyLengths: me, nByteLength: xe, wrapPrivateKey: ve, n: Te } = e;
    if (me && typeof he != "bigint") {
      if (he instanceof Uint8Array && (he = bytesToHex$2(he)), typeof he != "string" || !me.includes(he.length))
        throw new Error("Invalid key");
      he = he.padStart(xe * 2, "0");
    }
    let we;
    try {
      we = typeof he == "bigint" ? he : bytesToNumberBE$1(ensureBytes$1("private key", he, xe));
    } catch {
      throw new Error(`private key must be ${xe} bytes, hex or bigint, not ${typeof he}`);
    }
    return ve && (we = mod$1(we, Te)), te(we), we;
  }
  const ie = /* @__PURE__ */ new Map();
  function se(he) {
    if (!(he instanceof de))
      throw new Error("ProjectivePoint expected");
  }
  class de {
    constructor(me, xe, ve) {
      if (this.px = me, this.py = xe, this.pz = ve, me == null || !T.isValid(me))
        throw new Error("x required");
      if (xe == null || !T.isValid(xe))
        throw new Error("y required");
      if (ve == null || !T.isValid(ve))
        throw new Error("z required");
    }
    // Does not validate if the point is on-curve.
    // Use fromHex instead, or call assertValidity() later.
    static fromAffine(me) {
      const { x: xe, y: ve } = me || {};
      if (!me || !T.isValid(xe) || !T.isValid(ve))
        throw new Error("invalid affine point");
      if (me instanceof de)
        throw new Error("projective point not allowed");
      const Te = (we) => T.eql(we, T.ZERO);
      return Te(xe) && Te(ve) ? de.ZERO : new de(xe, ve, T.ONE);
    }
    get x() {
      return this.toAffine().x;
    }
    get y() {
      return this.toAffine().y;
    }
    /**
     * Takes a bunch of Projective Points but executes only one
     * inversion on all of them. Inversion is very slow operation,
     * so this improves performance massively.
     * Optimization: converts a list of projective points to a list of identical points with Z=1.
     */
    static normalizeZ(me) {
      const xe = T.invertBatch(me.map((ve) => ve.pz));
      return me.map((ve, Te) => ve.toAffine(xe[Te])).map(de.fromAffine);
    }
    /**
     * Converts hash string or Uint8Array to Point.
     * @param hex short/long ECDSA hex
     */
    static fromHex(me) {
      const xe = de.fromAffine(V(ensureBytes$1("pointHex", me)));
      return xe.assertValidity(), xe;
    }
    // Multiplies generator point by privateKey.
    static fromPrivateKey(me) {
      return de.BASE.multiply(re(me));
    }
    // "Private method", don't use it directly
    _setWindowSize(me) {
      this._WINDOW_SIZE = me, ie.delete(this);
    }
    // A point on curve is valid if it conforms to equation.
    assertValidity() {
      if (this.is0()) {
        if (e.allowInfinityPoint && !T.is0(this.py))
          return;
        throw new Error("bad point: ZERO");
      }
      const { x: me, y: xe } = this.toAffine();
      if (!T.isValid(me) || !T.isValid(xe))
        throw new Error("bad point: x or y not FE");
      const ve = T.sqr(xe), Te = J(me);
      if (!T.eql(ve, Te))
        throw new Error("bad point: equation left != right");
      if (!this.isTorsionFree())
        throw new Error("bad point: not in prime-order subgroup");
    }
    hasEvenY() {
      const { y: me } = this.toAffine();
      if (T.isOdd)
        return !T.isOdd(me);
      throw new Error("Field doesn't support isOdd");
    }
    /**
     * Compare one point to another.
     */
    equals(me) {
      se(me);
      const { px: xe, py: ve, pz: Te } = this, { px: we, py: Ee, pz: Me } = me, Ie = T.eql(T.mul(xe, Me), T.mul(we, Te)), ke = T.eql(T.mul(ve, Me), T.mul(Ee, Te));
      return Ie && ke;
    }
    /**
     * Flips point to one corresponding to (x, -y) in Affine coordinates.
     */
    negate() {
      return new de(this.px, T.neg(this.py), this.pz);
    }
    // Renes-Costello-Batina exception-free doubling formula.
    // There is 30% faster Jacobian formula, but it is not complete.
    // https://eprint.iacr.org/2015/1060, algorithm 3
    // Cost: 8M + 3S + 3*a + 2*b3 + 15add.
    double() {
      const { a: me, b: xe } = e, ve = T.mul(xe, _3n$2), { px: Te, py: we, pz: Ee } = this;
      let Me = T.ZERO, Ie = T.ZERO, ke = T.ZERO, _e = T.mul(Te, Te), De = T.mul(we, we), Fe = T.mul(Ee, Ee), Ae = T.mul(Te, we);
      return Ae = T.add(Ae, Ae), ke = T.mul(Te, Ee), ke = T.add(ke, ke), Me = T.mul(me, ke), Ie = T.mul(ve, Fe), Ie = T.add(Me, Ie), Me = T.sub(De, Ie), Ie = T.add(De, Ie), Ie = T.mul(Me, Ie), Me = T.mul(Ae, Me), ke = T.mul(ve, ke), Fe = T.mul(me, Fe), Ae = T.sub(_e, Fe), Ae = T.mul(me, Ae), Ae = T.add(Ae, ke), ke = T.add(_e, _e), _e = T.add(ke, _e), _e = T.add(_e, Fe), _e = T.mul(_e, Ae), Ie = T.add(Ie, _e), Fe = T.mul(we, Ee), Fe = T.add(Fe, Fe), _e = T.mul(Fe, Ae), Me = T.sub(Me, _e), ke = T.mul(Fe, De), ke = T.add(ke, ke), ke = T.add(ke, ke), new de(Me, Ie, ke);
    }
    // Renes-Costello-Batina exception-free addition formula.
    // There is 30% faster Jacobian formula, but it is not complete.
    // https://eprint.iacr.org/2015/1060, algorithm 1
    // Cost: 12M + 0S + 3*a + 3*b3 + 23add.
    add(me) {
      se(me);
      const { px: xe, py: ve, pz: Te } = this, { px: we, py: Ee, pz: Me } = me;
      let Ie = T.ZERO, ke = T.ZERO, _e = T.ZERO;
      const De = e.a, Fe = T.mul(e.b, _3n$2);
      let Ae = T.mul(xe, we), ne = T.mul(ve, Ee), oe = T.mul(Te, Me), ce = T.add(xe, ve), le = T.add(we, Ee);
      ce = T.mul(ce, le), le = T.add(Ae, ne), ce = T.sub(ce, le), le = T.add(xe, Te);
      let pe = T.add(we, Me);
      return le = T.mul(le, pe), pe = T.add(Ae, oe), le = T.sub(le, pe), pe = T.add(ve, Te), Ie = T.add(Ee, Me), pe = T.mul(pe, Ie), Ie = T.add(ne, oe), pe = T.sub(pe, Ie), _e = T.mul(De, le), Ie = T.mul(Fe, oe), _e = T.add(Ie, _e), Ie = T.sub(ne, _e), _e = T.add(ne, _e), ke = T.mul(Ie, _e), ne = T.add(Ae, Ae), ne = T.add(ne, Ae), oe = T.mul(De, oe), le = T.mul(Fe, le), ne = T.add(ne, oe), oe = T.sub(Ae, oe), oe = T.mul(De, oe), le = T.add(le, oe), Ae = T.mul(ne, le), ke = T.add(ke, Ae), Ae = T.mul(pe, le), Ie = T.mul(ce, Ie), Ie = T.sub(Ie, Ae), Ae = T.mul(ce, ne), _e = T.mul(pe, _e), _e = T.add(_e, Ae), new de(Ie, ke, _e);
    }
    subtract(me) {
      return this.add(me.negate());
    }
    is0() {
      return this.equals(de.ZERO);
    }
    wNAF(me) {
      return fe.wNAFCached(this, ie, me, (xe) => {
        const ve = T.invertBatch(xe.map((Te) => Te.pz));
        return xe.map((Te, we) => Te.toAffine(ve[we])).map(de.fromAffine);
      });
    }
    /**
     * Non-constant-time multiplication. Uses double-and-add algorithm.
     * It's faster, but should only be used when you don't care about
     * an exposed private key e.g. sig verification, which works over *public* keys.
     */
    multiplyUnsafe(me) {
      const xe = de.ZERO;
      if (me === _0n$6)
        return xe;
      if (te(me), me === _1n$9)
        return this;
      const { endo: ve } = e;
      if (!ve)
        return fe.unsafeLadder(this, me);
      let { k1neg: Te, k1: we, k2neg: Ee, k2: Me } = ve.splitScalar(me), Ie = xe, ke = xe, _e = this;
      for (; we > _0n$6 || Me > _0n$6; )
        we & _1n$9 && (Ie = Ie.add(_e)), Me & _1n$9 && (ke = ke.add(_e)), _e = _e.double(), we >>= _1n$9, Me >>= _1n$9;
      return Te && (Ie = Ie.negate()), Ee && (ke = ke.negate()), ke = new de(T.mul(ke.px, ve.beta), ke.py, ke.pz), Ie.add(ke);
    }
    /**
     * Constant time multiplication.
     * Uses wNAF method. Windowed method may be 10% faster,
     * but takes 2x longer to generate and consumes 2x memory.
     * Uses precomputes when available.
     * Uses endomorphism for Koblitz curves.
     * @param scalar by which the point would be multiplied
     * @returns New point
     */
    multiply(me) {
      te(me);
      let xe = me, ve, Te;
      const { endo: we } = e;
      if (we) {
        const { k1neg: Ee, k1: Me, k2neg: Ie, k2: ke } = we.splitScalar(xe);
        let { p: _e, f: De } = this.wNAF(Me), { p: Fe, f: Ae } = this.wNAF(ke);
        _e = fe.constTimeNegate(Ee, _e), Fe = fe.constTimeNegate(Ie, Fe), Fe = new de(T.mul(Fe.px, we.beta), Fe.py, Fe.pz), ve = _e.add(Fe), Te = De.add(Ae);
      } else {
        const { p: Ee, f: Me } = this.wNAF(xe);
        ve = Ee, Te = Me;
      }
      return de.normalizeZ([ve, Te])[0];
    }
    /**
     * Efficiently calculate `aP + bQ`. Unsafe, can expose private key, if used incorrectly.
     * Not using Strauss-Shamir trick: precomputation tables are faster.
     * The trick could be useful if both P and Q are not G (not in our case).
     * @returns non-zero affine point
     */
    multiplyAndAddUnsafe(me, xe, ve) {
      const Te = de.BASE, we = (Me, Ie) => Ie === _0n$6 || Ie === _1n$9 || !Me.equals(Te) ? Me.multiplyUnsafe(Ie) : Me.multiply(Ie), Ee = we(this, xe).add(we(me, ve));
      return Ee.is0() ? void 0 : Ee;
    }
    // Converts Projective point to affine (x, y) coordinates.
    // Can accept precomputed Z^-1 - for example, from invertBatch.
    // (x, y, z) ∋ (x=x/z, y=y/z)
    toAffine(me) {
      const { px: xe, py: ve, pz: Te } = this, we = this.is0();
      me == null && (me = we ? T.ONE : T.inv(Te));
      const Ee = T.mul(xe, me), Me = T.mul(ve, me), Ie = T.mul(Te, me);
      if (we)
        return { x: T.ZERO, y: T.ZERO };
      if (!T.eql(Ie, T.ONE))
        throw new Error("invZ was invalid");
      return { x: Ee, y: Me };
    }
    isTorsionFree() {
      const { h: me, isTorsionFree: xe } = e;
      if (me === _1n$9)
        return !0;
      if (xe)
        return xe(de, this);
      throw new Error("isTorsionFree() has not been declared for the elliptic curve");
    }
    clearCofactor() {
      const { h: me, clearCofactor: xe } = e;
      return me === _1n$9 ? this : xe ? xe(de, this) : this.multiplyUnsafe(e.h);
    }
    toRawBytes(me = !0) {
      return this.assertValidity(), $(de, this, me);
    }
    toHex(me = !0) {
      return bytesToHex$2(this.toRawBytes(me));
    }
  }
  de.BASE = new de(e.Gx, e.Gy, T.ONE), de.ZERO = new de(T.ZERO, T.ONE, T.ZERO);
  const ue = e.nBitLength, fe = wNAF$1(de, e.endo ? Math.ceil(ue / 2) : ue);
  return {
    CURVE: e,
    ProjectivePoint: de,
    normPrivateKeyToScalar: re,
    weierstrassEquation: J,
    isWithinCurveOrder: ee
  };
}
function validateOpts$2(C) {
  const e = validateBasic$1(C);
  return validateObject$1(e, {
    hash: "hash",
    hmac: "function",
    randomBytes: "function"
  }, {
    bits2int: "function",
    bits2int_modN: "function",
    lowS: "boolean"
  }), Object.freeze({ lowS: !0, ...e });
}
function weierstrass$1(C) {
  const e = validateOpts$2(C), { Fp: T, n: $ } = e, V = T.BYTES + 1, J = 2 * T.BYTES + 1;
  function ee(le) {
    return _0n$6 < le && le < T.ORDER;
  }
  function te(le) {
    return mod$1(le, $);
  }
  function re(le) {
    return invert$1(le, $);
  }
  const { ProjectivePoint: ie, normPrivateKeyToScalar: se, weierstrassEquation: de, isWithinCurveOrder: ue } = weierstrassPoints$1({
    ...e,
    toBytes(le, pe, ye) {
      const Ce = pe.toAffine(), be = T.toBytes(Ce.x), ae = concatBytes$3;
      return ye ? ae(Uint8Array.from([pe.hasEvenY() ? 2 : 3]), be) : ae(Uint8Array.from([4]), be, T.toBytes(Ce.y));
    },
    fromBytes(le) {
      const pe = le.length, ye = le[0], Ce = le.subarray(1);
      if (pe === V && (ye === 2 || ye === 3)) {
        const be = bytesToNumberBE$1(Ce);
        if (!ee(be))
          throw new Error("Point is not on curve");
        const ae = de(be);
        let ge = T.sqrt(ae);
        const Se = (ge & _1n$9) === _1n$9;
        return (ye & 1) === 1 !== Se && (ge = T.neg(ge)), { x: be, y: ge };
      } else if (pe === J && ye === 4) {
        const be = T.fromBytes(Ce.subarray(0, T.BYTES)), ae = T.fromBytes(Ce.subarray(T.BYTES, 2 * T.BYTES));
        return { x: be, y: ae };
      } else
        throw new Error(`Point of length ${pe} was invalid. Expected ${V} compressed bytes or ${J} uncompressed bytes`);
    }
  }), fe = (le) => bytesToHex$2(numberToBytesBE$1(le, e.nByteLength));
  function he(le) {
    const pe = $ >> _1n$9;
    return le > pe;
  }
  function me(le) {
    return he(le) ? te(-le) : le;
  }
  const xe = (le, pe, ye) => bytesToNumberBE$1(le.slice(pe, ye));
  class ve {
    constructor(pe, ye, Ce) {
      this.r = pe, this.s = ye, this.recovery = Ce, this.assertValidity();
    }
    // pair (bytes of r, bytes of s)
    static fromCompact(pe) {
      const ye = e.nByteLength;
      return pe = ensureBytes$1("compactSignature", pe, ye * 2), new ve(xe(pe, 0, ye), xe(pe, ye, 2 * ye));
    }
    // DER encoded ECDSA signature
    // https://bitcoin.stackexchange.com/questions/57644/what-are-the-parts-of-a-bitcoin-transaction-input-script
    static fromDER(pe) {
      const { r: ye, s: Ce } = DER$1.toSig(ensureBytes$1("DER", pe));
      return new ve(ye, Ce);
    }
    assertValidity() {
      if (!ue(this.r))
        throw new Error("r must be 0 < r < CURVE.n");
      if (!ue(this.s))
        throw new Error("s must be 0 < s < CURVE.n");
    }
    addRecoveryBit(pe) {
      return new ve(this.r, this.s, pe);
    }
    recoverPublicKey(pe) {
      const { r: ye, s: Ce, recovery: be } = this, ae = ke(ensureBytes$1("msgHash", pe));
      if (be == null || ![0, 1, 2, 3].includes(be))
        throw new Error("recovery id invalid");
      const ge = be === 2 || be === 3 ? ye + e.n : ye;
      if (ge >= T.ORDER)
        throw new Error("recovery id 2 or 3 invalid");
      const Se = be & 1 ? "03" : "02", Le = ie.fromHex(Se + fe(ge)), ze = re(ge), Re = te(-ae * ze), We = te(Ce * ze), Be = ie.BASE.multiplyAndAddUnsafe(Le, Re, We);
      if (!Be)
        throw new Error("point at infinify");
      return Be.assertValidity(), Be;
    }
    // Signatures should be low-s, to prevent malleability.
    hasHighS() {
      return he(this.s);
    }
    normalizeS() {
      return this.hasHighS() ? new ve(this.r, te(-this.s), this.recovery) : this;
    }
    // DER-encoded
    toDERRawBytes() {
      return hexToBytes$2(this.toDERHex());
    }
    toDERHex() {
      return DER$1.hexFromSig({ r: this.r, s: this.s });
    }
    // padded bytes of r, then padded bytes of s
    toCompactRawBytes() {
      return hexToBytes$2(this.toCompactHex());
    }
    toCompactHex() {
      return fe(this.r) + fe(this.s);
    }
  }
  const Te = {
    isValidPrivateKey(le) {
      try {
        return se(le), !0;
      } catch {
        return !1;
      }
    },
    normPrivateKeyToScalar: se,
    /**
     * Produces cryptographically secure private key from random of size
     * (groupLen + ceil(groupLen / 2)) with modulo bias being negligible.
     */
    randomPrivateKey: () => {
      const le = getMinHashLength$1(e.n);
      return mapHashToField$1(e.randomBytes(le), e.n);
    },
    /**
     * Creates precompute table for an arbitrary EC point. Makes point "cached".
     * Allows to massively speed-up `point.multiply(scalar)`.
     * @returns cached point
     * @example
     * const fast = utils.precompute(8, ProjectivePoint.fromHex(someonesPubKey));
     * fast.multiply(privKey); // much faster ECDH now
     */
    precompute(le = 8, pe = ie.BASE) {
      return pe._setWindowSize(le), pe.multiply(BigInt(3)), pe;
    }
  };
  function we(le, pe = !0) {
    return ie.fromPrivateKey(le).toRawBytes(pe);
  }
  function Ee(le) {
    const pe = le instanceof Uint8Array, ye = typeof le == "string", Ce = (pe || ye) && le.length;
    return pe ? Ce === V || Ce === J : ye ? Ce === 2 * V || Ce === 2 * J : le instanceof ie;
  }
  function Me(le, pe, ye = !0) {
    if (Ee(le))
      throw new Error("first arg must be private key");
    if (!Ee(pe))
      throw new Error("second arg must be public key");
    return ie.fromHex(pe).multiply(se(le)).toRawBytes(ye);
  }
  const Ie = e.bits2int || function(le) {
    const pe = bytesToNumberBE$1(le), ye = le.length * 8 - e.nBitLength;
    return ye > 0 ? pe >> BigInt(ye) : pe;
  }, ke = e.bits2int_modN || function(le) {
    return te(Ie(le));
  }, _e = bitMask$1(e.nBitLength);
  function De(le) {
    if (typeof le != "bigint")
      throw new Error("bigint expected");
    if (!(_0n$6 <= le && le < _e))
      throw new Error(`bigint expected < 2^${e.nBitLength}`);
    return numberToBytesBE$1(le, e.nByteLength);
  }
  function Fe(le, pe, ye = Ae) {
    if (["recovered", "canonical"].some((Ge) => Ge in ye))
      throw new Error("sign() legacy options not supported");
    const { hash: Ce, randomBytes: be } = e;
    let { lowS: ae, prehash: ge, extraEntropy: Se } = ye;
    ae == null && (ae = !0), le = ensureBytes$1("msgHash", le), ge && (le = ensureBytes$1("prehashed msgHash", Ce(le)));
    const Le = ke(le), ze = se(pe), Re = [De(ze), De(Le)];
    if (Se != null) {
      const Ge = Se === !0 ? be(T.BYTES) : Se;
      Re.push(ensureBytes$1("extraEntropy", Ge));
    }
    const We = concatBytes$3(...Re), Be = Le;
    function Ue(Ge) {
      const je = Ie(Ge);
      if (!ue(je))
        return;
      const Oe = re(je), Ne = ie.BASE.multiply(je).toAffine(), Ye = te(Ne.x);
      if (Ye === _0n$6)
        return;
      const Je = te(Oe * te(Be + Ye * ze));
      if (Je === _0n$6)
        return;
      let Xe = (Ne.x === Ye ? 0 : 2) | Number(Ne.y & _1n$9), st = Je;
      return ae && he(Je) && (st = me(Je), Xe ^= 1), new ve(Ye, st, Xe);
    }
    return { seed: We, k2sig: Ue };
  }
  const Ae = { lowS: e.lowS, prehash: !1 }, ne = { lowS: e.lowS, prehash: !1 };
  function oe(le, pe, ye = Ae) {
    const { seed: Ce, k2sig: be } = Fe(le, pe, ye), ae = e;
    return createHmacDrbg$1(ae.hash.outputLen, ae.nByteLength, ae.hmac)(Ce, be);
  }
  ie.BASE._setWindowSize(8);
  function ce(le, pe, ye, Ce = ne) {
    var Ne;
    const be = le;
    if (pe = ensureBytes$1("msgHash", pe), ye = ensureBytes$1("publicKey", ye), "strict" in Ce)
      throw new Error("options.strict was renamed to lowS");
    const { lowS: ae, prehash: ge } = Ce;
    let Se, Le;
    try {
      if (typeof be == "string" || be instanceof Uint8Array)
        try {
          Se = ve.fromDER(be);
        } catch (Ye) {
          if (!(Ye instanceof DER$1.Err))
            throw Ye;
          Se = ve.fromCompact(be);
        }
      else if (typeof be == "object" && typeof be.r == "bigint" && typeof be.s == "bigint") {
        const { r: Ye, s: Je } = be;
        Se = new ve(Ye, Je);
      } else
        throw new Error("PARSE");
      Le = ie.fromHex(ye);
    } catch (Ye) {
      if (Ye.message === "PARSE")
        throw new Error("signature must be Signature instance, Uint8Array or hex string");
      return !1;
    }
    if (ae && Se.hasHighS())
      return !1;
    ge && (pe = e.hash(pe));
    const { r: ze, s: Re } = Se, We = ke(pe), Be = re(Re), Ue = te(We * Be), Ge = te(ze * Be), je = (Ne = ie.BASE.multiplyAndAddUnsafe(Le, Ue, Ge)) == null ? void 0 : Ne.toAffine();
    return je ? te(je.x) === ze : !1;
  }
  return {
    CURVE: e,
    getPublicKey: we,
    getSharedSecret: Me,
    sign: oe,
    verify: ce,
    ProjectivePoint: ie,
    Signature: ve,
    utils: Te
  };
}
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */
function getHash$1(C) {
  return {
    hash: C,
    hmac: (e, ...T) => hmac$2(C, e, concatBytes$4(...T)),
    randomBytes: randomBytes$4
  };
}
function createCurve$1(C, e) {
  const T = ($) => weierstrass$1({ ...C, ...getHash$1($) });
  return Object.freeze({ ...T(e), create: T });
}
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */
const secp256k1P$1 = BigInt("0xfffffffffffffffffffffffffffffffffffffffffffffffffffffffefffffc2f"), secp256k1N$1 = BigInt("0xfffffffffffffffffffffffffffffffebaaedce6af48a03bbfd25e8cd0364141"), _1n$8 = BigInt(1), _2n$6 = BigInt(2), divNearest$1 = (C, e) => (C + e / _2n$6) / e;
function sqrtMod$1(C) {
  const e = secp256k1P$1, T = BigInt(3), $ = BigInt(6), V = BigInt(11), J = BigInt(22), ee = BigInt(23), te = BigInt(44), re = BigInt(88), ie = C * C * C % e, se = ie * ie * C % e, de = pow2$1(se, T, e) * se % e, ue = pow2$1(de, T, e) * se % e, fe = pow2$1(ue, _2n$6, e) * ie % e, he = pow2$1(fe, V, e) * fe % e, me = pow2$1(he, J, e) * he % e, xe = pow2$1(me, te, e) * me % e, ve = pow2$1(xe, re, e) * xe % e, Te = pow2$1(ve, te, e) * me % e, we = pow2$1(Te, T, e) * se % e, Ee = pow2$1(we, ee, e) * he % e, Me = pow2$1(Ee, $, e) * ie % e, Ie = pow2$1(Me, _2n$6, e);
  if (!Fp$1.eql(Fp$1.sqr(Ie), C))
    throw new Error("Cannot find square root");
  return Ie;
}
const Fp$1 = Field$1(secp256k1P$1, void 0, void 0, { sqrt: sqrtMod$1 }), secp256k1$2 = createCurve$1({
  a: BigInt(0),
  b: BigInt(7),
  Fp: Fp$1,
  n: secp256k1N$1,
  // Base point (x, y) aka generator point
  Gx: BigInt("55066263022277343669578718895168534326250603453777594175500187360389116729240"),
  Gy: BigInt("32670510020758816978083085130507043184471273380659243275938904335757337482424"),
  h: BigInt(1),
  lowS: !0,
  /**
   * secp256k1 belongs to Koblitz curves: it has efficiently computable endomorphism.
   * Endomorphism uses 2x less RAM, speeds up precomputation by 2x and ECDH / key recovery by 20%.
   * For precomputed wNAF it trades off 1/2 init time & 1/3 ram for 20% perf hit.
   * Explanation: https://gist.github.com/paulmillr/eb670806793e84df628a7c434a873066
   */
  endo: {
    beta: BigInt("0x7ae96a2b657c07106e64479eac3434e99cf0497512f58995c1396c28719501ee"),
    splitScalar: (C) => {
      const e = secp256k1N$1, T = BigInt("0x3086d221a7d46bcde86c90e49284eb15"), $ = -_1n$8 * BigInt("0xe4437ed6010e88286f547fa90abfe4c3"), V = BigInt("0x114ca50f7a8e2f3f657c1108d9d44cfd8"), J = T, ee = BigInt("0x100000000000000000000000000000000"), te = divNearest$1(J * C, e), re = divNearest$1(-$ * C, e);
      let ie = mod$1(C - te * T - re * V, e), se = mod$1(-te * $ - re * J, e);
      const de = ie > ee, ue = se > ee;
      if (de && (ie = e - ie), ue && (se = e - se), ie > ee || se > ee)
        throw new Error("splitScalar: Endomorphism failed, k=" + C);
      return { k1neg: de, k1: ie, k2neg: ue, k2: se };
    }
  }
}, sha256$7);
BigInt(0);
secp256k1$2.ProjectivePoint;
const ZeroAddress = "0x0000000000000000000000000000000000000000", ZeroHash = "0x0000000000000000000000000000000000000000000000000000000000000000", MessagePrefix = `Ethereum Signed Message:
`, BN_0$7 = BigInt(0), BN_1$2 = BigInt(1), BN_2$2 = BigInt(2), BN_27$1 = BigInt(27), BN_28$1 = BigInt(28), BN_35$1 = BigInt(35), _guard$3 = {};
function toUint256(C) {
  return zeroPadValue(toBeArray(C), 32);
}
var Ta, Ea, Ma, qi, ar;
let Signature$1 = (ar = class {
  /**
   *  @private
   */
  constructor(e, T, $, V) {
    Ft(this, Ta);
    Ft(this, Ea);
    Ft(this, Ma);
    Ft(this, qi);
    assertPrivate(e, _guard$3, "Signature"), At(this, Ta, T), At(this, Ea, $), At(this, Ma, V), At(this, qi, null);
  }
  /**
   *  The ``r`` value for a signautre.
   *
   *  This represents the ``x`` coordinate of a "reference" or
   *  challenge point, from which the ``y`` can be computed.
   */
  get r() {
    return rt(this, Ta);
  }
  set r(e) {
    assertArgument(dataLength(e) === 32, "invalid r", "value", e), At(this, Ta, hexlify(e));
  }
  /**
   *  The ``s`` value for a signature.
   */
  get s() {
    return rt(this, Ea);
  }
  set s(e) {
    assertArgument(dataLength(e) === 32, "invalid s", "value", e);
    const T = hexlify(e);
    assertArgument(parseInt(T.substring(0, 3)) < 8, "non-canonical s", "value", T), At(this, Ea, T);
  }
  /**
   *  The ``v`` value for a signature.
   *
   *  Since a given ``x`` value for ``r`` has two possible values for
   *  its correspondin ``y``, the ``v`` indicates which of the two ``y``
   *  values to use.
   *
   *  It is normalized to the values ``27`` or ``28`` for legacy
   *  purposes.
   */
  get v() {
    return rt(this, Ma);
  }
  set v(e) {
    const T = getNumber(e, "value");
    assertArgument(T === 27 || T === 28, "invalid v", "v", e), At(this, Ma, T);
  }
  /**
   *  The EIP-155 ``v`` for legacy transactions. For non-legacy
   *  transactions, this value is ``null``.
   */
  get networkV() {
    return rt(this, qi);
  }
  /**
   *  The chain ID for EIP-155 legacy transactions. For non-legacy
   *  transactions, this value is ``null``.
   */
  get legacyChainId() {
    const e = this.networkV;
    return e == null ? null : ar.getChainId(e);
  }
  /**
   *  The ``yParity`` for the signature.
   *
   *  See ``v`` for more details on how this value is used.
   */
  get yParity() {
    return this.v === 27 ? 0 : 1;
  }
  /**
   *  The [[link-eip-2098]] compact representation of the ``yParity``
   *  and ``s`` compacted into a single ``bytes32``.
   */
  get yParityAndS() {
    const e = getBytes(this.s);
    return this.yParity && (e[0] |= 128), hexlify(e);
  }
  /**
   *  The [[link-eip-2098]] compact representation.
   */
  get compactSerialized() {
    return concat([this.r, this.yParityAndS]);
  }
  /**
   *  The serialized representation.
   */
  get serialized() {
    return concat([this.r, this.s, this.yParity ? "0x1c" : "0x1b"]);
  }
  [Symbol.for("nodejs.util.inspect.custom")]() {
    return `Signature { r: "${this.r}", s: "${this.s}", yParity: ${this.yParity}, networkV: ${this.networkV} }`;
  }
  /**
   *  Returns a new identical [[Signature]].
   */
  clone() {
    const e = new ar(_guard$3, this.r, this.s, this.v);
    return this.networkV && At(e, qi, this.networkV), e;
  }
  /**
   *  Returns a representation that is compatible with ``JSON.stringify``.
   */
  toJSON() {
    const e = this.networkV;
    return {
      _type: "signature",
      networkV: e != null ? e.toString() : null,
      r: this.r,
      s: this.s,
      v: this.v
    };
  }
  /**
   *  Compute the chain ID from the ``v`` in a legacy EIP-155 transactions.
   *
   *  @example:
   *    Signature.getChainId(45)
   *    //_result:
   *
   *    Signature.getChainId(46)
   *    //_result:
   */
  static getChainId(e) {
    const T = getBigInt(e, "v");
    return T == BN_27$1 || T == BN_28$1 ? BN_0$7 : (assertArgument(T >= BN_35$1, "invalid EIP-155 v", "v", e), (T - BN_35$1) / BN_2$2);
  }
  /**
   *  Compute the ``v`` for a chain ID for a legacy EIP-155 transactions.
   *
   *  Legacy transactions which use [[link-eip-155]] hijack the ``v``
   *  property to include the chain ID.
   *
   *  @example:
   *    Signature.getChainIdV(5, 27)
   *    //_result:
   *
   *    Signature.getChainIdV(5, 28)
   *    //_result:
   *
   */
  static getChainIdV(e, T) {
    return getBigInt(e) * BN_2$2 + BigInt(35 + T - 27);
  }
  /**
   *  Compute the normalized legacy transaction ``v`` from a ``yParirty``,
   *  a legacy transaction ``v`` or a legacy [[link-eip-155]] transaction.
   *
   *  @example:
   *    // The values 0 and 1 imply v is actually yParity
   *    Signature.getNormalizedV(0)
   *    //_result:
   *
   *    // Legacy non-EIP-1559 transaction (i.e. 27 or 28)
   *    Signature.getNormalizedV(27)
   *    //_result:
   *
   *    // Legacy EIP-155 transaction (i.e. >= 35)
   *    Signature.getNormalizedV(46)
   *    //_result:
   *
   *    // Invalid values throw
   *    Signature.getNormalizedV(5)
   *    //_error:
   */
  static getNormalizedV(e) {
    const T = getBigInt(e);
    return T === BN_0$7 || T === BN_27$1 ? 27 : T === BN_1$2 || T === BN_28$1 ? 28 : (assertArgument(T >= BN_35$1, "invalid v", "v", e), T & BN_1$2 ? 27 : 28);
  }
  /**
   *  Creates a new [[Signature]].
   *
   *  If no %%sig%% is provided, a new [[Signature]] is created
   *  with default values.
   *
   *  If %%sig%% is a string, it is parsed.
   */
  static from(e) {
    function T(ie, se) {
      assertArgument(ie, se, "signature", e);
    }
    if (e == null)
      return new ar(_guard$3, ZeroHash, ZeroHash, 27);
    if (typeof e == "string") {
      const ie = getBytes(e, "signature");
      if (ie.length === 64) {
        const se = hexlify(ie.slice(0, 32)), de = ie.slice(32, 64), ue = de[0] & 128 ? 28 : 27;
        return de[0] &= 127, new ar(_guard$3, se, hexlify(de), ue);
      }
      if (ie.length === 65) {
        const se = hexlify(ie.slice(0, 32)), de = ie.slice(32, 64);
        T((de[0] & 128) === 0, "non-canonical s");
        const ue = ar.getNormalizedV(ie[64]);
        return new ar(_guard$3, se, hexlify(de), ue);
      }
      T(!1, "invalid raw signature length");
    }
    if (e instanceof ar)
      return e.clone();
    const $ = e.r;
    T($ != null, "missing r");
    const V = toUint256($), J = function(ie, se) {
      if (ie != null)
        return toUint256(ie);
      if (se != null) {
        T(isHexString(se, 32), "invalid yParityAndS");
        const de = getBytes(se);
        return de[0] &= 127, hexlify(de);
      }
      T(!1, "missing s");
    }(e.s, e.yParityAndS);
    T((getBytes(J)[0] & 128) == 0, "non-canonical s");
    const { networkV: ee, v: te } = function(ie, se, de) {
      if (ie != null) {
        const ue = getBigInt(ie);
        return {
          networkV: ue >= BN_35$1 ? ue : void 0,
          v: ar.getNormalizedV(ue)
        };
      }
      if (se != null)
        return T(isHexString(se, 32), "invalid yParityAndS"), { v: getBytes(se)[0] & 128 ? 28 : 27 };
      if (de != null) {
        switch (getNumber(de, "sig.yParity")) {
          case 0:
            return { v: 27 };
          case 1:
            return { v: 28 };
        }
        T(!1, "invalid yParity");
      }
      T(!1, "missing v");
    }(e.v, e.yParityAndS, e.yParity), re = new ar(_guard$3, V, J, te);
    return ee && At(re, qi, ee), T(e.yParity == null || getNumber(e.yParity, "sig.yParity") === re.yParity, "yParity mismatch"), T(e.yParityAndS == null || e.yParityAndS === re.yParityAndS, "yParityAndS mismatch"), re;
  }
}, Ta = new WeakMap(), Ea = new WeakMap(), Ma = new WeakMap(), qi = new WeakMap(), ar);
var Zr;
const _i = class _i {
  /**
   *  Creates a new **SigningKey** for %%privateKey%%.
   */
  constructor(e) {
    Ft(this, Zr);
    assertArgument(dataLength(e) === 32, "invalid private key", "privateKey", "[REDACTED]"), At(this, Zr, hexlify(e));
  }
  /**
   *  The private key.
   */
  get privateKey() {
    return rt(this, Zr);
  }
  /**
   *  The uncompressed public key.
   *
   * This will always begin with the prefix ``0x04`` and be 132
   * characters long (the ``0x`` prefix and 130 hexadecimal nibbles).
   */
  get publicKey() {
    return _i.computePublicKey(rt(this, Zr));
  }
  /**
   *  The compressed public key.
   *
   *  This will always begin with either the prefix ``0x02`` or ``0x03``
   *  and be 68 characters long (the ``0x`` prefix and 33 hexadecimal
   *  nibbles)
   */
  get compressedPublicKey() {
    return _i.computePublicKey(rt(this, Zr), !0);
  }
  /**
   *  Return the signature of the signed %%digest%%.
   */
  sign(e) {
    assertArgument(dataLength(e) === 32, "invalid digest length", "digest", e);
    const T = secp256k1$2.sign(getBytesCopy(e), getBytesCopy(rt(this, Zr)), {
      lowS: !0
    });
    return Signature$1.from({
      r: toBeHex(T.r, 32),
      s: toBeHex(T.s, 32),
      v: T.recovery ? 28 : 27
    });
  }
  /**
   *  Returns the [[link-wiki-ecdh]] shared secret between this
   *  private key and the %%other%% key.
   *
   *  The %%other%% key may be any type of key, a raw public key,
   *  a compressed/uncompressed pubic key or aprivate key.
   *
   *  Best practice is usually to use a cryptographic hash on the
   *  returned value before using it as a symetric secret.
   *
   *  @example:
   *    sign1 = new SigningKey(id("some-secret-1"))
   *    sign2 = new SigningKey(id("some-secret-2"))
   *
   *    // Notice that privA.computeSharedSecret(pubB)...
   *    sign1.computeSharedSecret(sign2.publicKey)
   *    //_result:
   *
   *    // ...is equal to privB.computeSharedSecret(pubA).
   *    sign2.computeSharedSecret(sign1.publicKey)
   *    //_result:
   */
  computeSharedSecret(e) {
    const T = _i.computePublicKey(e);
    return hexlify(secp256k1$2.getSharedSecret(getBytesCopy(rt(this, Zr)), getBytes(T), !1));
  }
  /**
   *  Compute the public key for %%key%%, optionally %%compressed%%.
   *
   *  The %%key%% may be any type of key, a raw public key, a
   *  compressed/uncompressed public key or private key.
   *
   *  @example:
   *    sign = new SigningKey(id("some-secret"));
   *
   *    // Compute the uncompressed public key for a private key
   *    SigningKey.computePublicKey(sign.privateKey)
   *    //_result:
   *
   *    // Compute the compressed public key for a private key
   *    SigningKey.computePublicKey(sign.privateKey, true)
   *    //_result:
   *
   *    // Compute the uncompressed public key
   *    SigningKey.computePublicKey(sign.publicKey, false);
   *    //_result:
   *
   *    // Compute the Compressed a public key
   *    SigningKey.computePublicKey(sign.publicKey, true);
   *    //_result:
   */
  static computePublicKey(e, T) {
    let $ = getBytes(e, "key");
    if ($.length === 32) {
      const J = secp256k1$2.getPublicKey($, !!T);
      return hexlify(J);
    }
    if ($.length === 64) {
      const J = new Uint8Array(65);
      J[0] = 4, J.set($, 1), $ = J;
    }
    const V = secp256k1$2.ProjectivePoint.fromHex($);
    return hexlify(V.toRawBytes(T));
  }
  /**
   *  Returns the public key for the private key which produced the
   *  %%signature%% for the given %%digest%%.
   *
   *  @example:
   *    key = new SigningKey(id("some-secret"))
   *    digest = id("hello world")
   *    sig = key.sign(digest)
   *
   *    // Notice the signer public key...
   *    key.publicKey
   *    //_result:
   *
   *    // ...is equal to the recovered public key
   *    SigningKey.recoverPublicKey(digest, sig)
   *    //_result:
   *
   */
  static recoverPublicKey(e, T) {
    assertArgument(dataLength(e) === 32, "invalid digest length", "digest", e);
    const $ = Signature$1.from(T);
    let V = secp256k1$2.Signature.fromCompact(getBytesCopy(concat([$.r, $.s])));
    V = V.addRecoveryBit($.yParity);
    const J = V.recoverPublicKey(getBytesCopy(e));
    return assertArgument(J != null, "invalid signautre for digest", "signature", T), "0x" + J.toHex(!1);
  }
  /**
   *  Returns the point resulting from adding the ellipic curve points
   *  %%p0%% and %%p1%%.
   *
   *  This is not a common function most developers should require, but
   *  can be useful for certain privacy-specific techniques.
   *
   *  For example, it is used by [[HDNodeWallet]] to compute child
   *  addresses from parent public keys and chain codes.
   */
  static addPoints(e, T, $) {
    const V = secp256k1$2.ProjectivePoint.fromHex(_i.computePublicKey(e).substring(2)), J = secp256k1$2.ProjectivePoint.fromHex(_i.computePublicKey(T).substring(2));
    return "0x" + V.add(J).toHex(!!$);
  }
};
Zr = new WeakMap();
let SigningKey = _i;
const BN_0$6 = BigInt(0), BN_36 = BigInt(36);
function getChecksumAddress(C) {
  C = C.toLowerCase();
  const e = C.substring(2).split(""), T = new Uint8Array(40);
  for (let V = 0; V < 40; V++)
    T[V] = e[V].charCodeAt(0);
  const $ = getBytes(keccak256(T));
  for (let V = 0; V < 40; V += 2)
    $[V >> 1] >> 4 >= 8 && (e[V] = e[V].toUpperCase()), ($[V >> 1] & 15) >= 8 && (e[V + 1] = e[V + 1].toUpperCase());
  return "0x" + e.join("");
}
const ibanLookup = {};
for (let C = 0; C < 10; C++)
  ibanLookup[String(C)] = String(C);
for (let C = 0; C < 26; C++)
  ibanLookup[String.fromCharCode(65 + C)] = String(10 + C);
const safeDigits = 15;
function ibanChecksum(C) {
  C = C.toUpperCase(), C = C.substring(4) + C.substring(0, 2) + "00";
  let e = C.split("").map(($) => ibanLookup[$]).join("");
  for (; e.length >= safeDigits; ) {
    let $ = e.substring(0, safeDigits);
    e = parseInt($, 10) % 97 + e.substring($.length);
  }
  let T = String(98 - parseInt(e, 10) % 97);
  for (; T.length < 2; )
    T = "0" + T;
  return T;
}
const Base36 = function() {
  const C = {};
  for (let e = 0; e < 36; e++) {
    const T = "0123456789abcdefghijklmnopqrstuvwxyz"[e];
    C[T] = BigInt(e);
  }
  return C;
}();
function fromBase36(C) {
  C = C.toLowerCase();
  let e = BN_0$6;
  for (let T = 0; T < C.length; T++)
    e = e * BN_36 + Base36[C[T]];
  return e;
}
function getAddress(C) {
  if (assertArgument(typeof C == "string", "invalid address", "address", C), C.match(/^(0x)?[0-9a-fA-F]{40}$/)) {
    C.startsWith("0x") || (C = "0x" + C);
    const e = getChecksumAddress(C);
    return assertArgument(!C.match(/([A-F].*[a-f])|([a-f].*[A-F])/) || e === C, "bad address checksum", "address", C), e;
  }
  if (C.match(/^XE[0-9]{2}[0-9A-Za-z]{30,31}$/)) {
    assertArgument(C.substring(2, 4) === ibanChecksum(C), "bad icap checksum", "address", C);
    let e = fromBase36(C.substring(4)).toString(16);
    for (; e.length < 40; )
      e = "0" + e;
    return getChecksumAddress("0x" + e);
  }
  assertArgument(!1, "invalid address", "address", C);
}
function getCreateAddress(C) {
  const e = getAddress(C.from);
  let $ = getBigInt(C.nonce, "tx.nonce").toString(16);
  return $ === "0" ? $ = "0x" : $.length % 2 ? $ = "0x0" + $ : $ = "0x" + $, getAddress(dataSlice(keccak256(encodeRlp([e, $])), 12));
}
function isAddressable(C) {
  return C && typeof C.getAddress == "function";
}
function isAddress(C) {
  try {
    return getAddress(C), !0;
  } catch {
  }
  return !1;
}
async function checkAddress(C, e) {
  const T = await e;
  return (T == null || T === "0x0000000000000000000000000000000000000000") && (assert$5(typeof C != "string", "unconfigured name", "UNCONFIGURED_NAME", { value: C }), assertArgument(!1, "invalid AddressLike value; did not resolve to a value address", "target", C)), getAddress(T);
}
function resolveAddress(C, e) {
  if (typeof C == "string")
    return C.match(/^0x[0-9a-f]{40}$/i) ? getAddress(C) : (assert$5(e != null, "ENS resolution requires a provider", "UNSUPPORTED_OPERATION", { operation: "resolveName" }), checkAddress(C, e.resolveName(C)));
  if (isAddressable(C))
    return checkAddress(C, C.getAddress());
  if (C && typeof C.then == "function")
    return checkAddress(C, C);
  assertArgument(!1, "unsupported addressable value", "target", C);
}
const _gaurd = {};
function n(C, e) {
  let T = !1;
  return e < 0 && (T = !0, e *= -1), new Typed(_gaurd, `${T ? "" : "u"}int${e}`, C, { signed: T, width: e });
}
function b(C, e) {
  return new Typed(_gaurd, `bytes${e || ""}`, C, { size: e });
}
const _typedSymbol = Symbol.for("_ethers_typed");
var Ki;
const Hr = class Hr {
  /**
   *  @_ignore:
   */
  constructor(e, T, $, V) {
    /**
     *  The type, as a Solidity-compatible type.
     */
    tt(this, "type");
    /**
     *  The actual value.
     */
    tt(this, "value");
    Ft(this, Ki);
    /**
     *  @_ignore:
     */
    tt(this, "_typedSymbol");
    V == null && (V = null), assertPrivate(_gaurd, e, "Typed"), defineProperties(this, { _typedSymbol, type: T, value: $ }), At(this, Ki, V), this.format();
  }
  /**
   *  Format the type as a Human-Readable type.
   */
  format() {
    if (this.type === "array")
      throw new Error("");
    if (this.type === "dynamicArray")
      throw new Error("");
    return this.type === "tuple" ? `tuple(${this.value.map((e) => e.format()).join(",")})` : this.type;
  }
  /**
   *  The default value returned by this type.
   */
  defaultValue() {
    return 0;
  }
  /**
   *  The minimum value for numeric types.
   */
  minValue() {
    return 0;
  }
  /**
   *  The maximum value for numeric types.
   */
  maxValue() {
    return 0;
  }
  /**
   *  Returns ``true`` and provides a type guard is this is a [[TypedBigInt]].
   */
  isBigInt() {
    return !!this.type.match(/^u?int[0-9]+$/);
  }
  /**
   *  Returns ``true`` and provides a type guard is this is a [[TypedData]].
   */
  isData() {
    return this.type.startsWith("bytes");
  }
  /**
   *  Returns ``true`` and provides a type guard is this is a [[TypedString]].
   */
  isString() {
    return this.type === "string";
  }
  /**
   *  Returns the tuple name, if this is a tuple. Throws otherwise.
   */
  get tupleName() {
    if (this.type !== "tuple")
      throw TypeError("not a tuple");
    return rt(this, Ki);
  }
  // Returns the length of this type as an array
  // - `null` indicates the length is unforced, it could be dynamic
  // - `-1` indicates the length is dynamic
  // - any other value indicates it is a static array and is its length
  /**
   *  Returns the length of the array type or ``-1`` if it is dynamic.
   *
   *  Throws if the type is not an array.
   */
  get arrayLength() {
    if (this.type !== "array")
      throw TypeError("not an array");
    return rt(this, Ki) === !0 ? -1 : rt(this, Ki) === !1 ? this.value.length : null;
  }
  /**
   *  Returns a new **Typed** of %%type%% with the %%value%%.
   */
  static from(e, T) {
    return new Hr(_gaurd, e, T);
  }
  /**
   *  Return a new ``uint8`` type for %%v%%.
   */
  static uint8(e) {
    return n(e, 8);
  }
  /**
   *  Return a new ``uint16`` type for %%v%%.
   */
  static uint16(e) {
    return n(e, 16);
  }
  /**
   *  Return a new ``uint24`` type for %%v%%.
   */
  static uint24(e) {
    return n(e, 24);
  }
  /**
   *  Return a new ``uint32`` type for %%v%%.
   */
  static uint32(e) {
    return n(e, 32);
  }
  /**
   *  Return a new ``uint40`` type for %%v%%.
   */
  static uint40(e) {
    return n(e, 40);
  }
  /**
   *  Return a new ``uint48`` type for %%v%%.
   */
  static uint48(e) {
    return n(e, 48);
  }
  /**
   *  Return a new ``uint56`` type for %%v%%.
   */
  static uint56(e) {
    return n(e, 56);
  }
  /**
   *  Return a new ``uint64`` type for %%v%%.
   */
  static uint64(e) {
    return n(e, 64);
  }
  /**
   *  Return a new ``uint72`` type for %%v%%.
   */
  static uint72(e) {
    return n(e, 72);
  }
  /**
   *  Return a new ``uint80`` type for %%v%%.
   */
  static uint80(e) {
    return n(e, 80);
  }
  /**
   *  Return a new ``uint88`` type for %%v%%.
   */
  static uint88(e) {
    return n(e, 88);
  }
  /**
   *  Return a new ``uint96`` type for %%v%%.
   */
  static uint96(e) {
    return n(e, 96);
  }
  /**
   *  Return a new ``uint104`` type for %%v%%.
   */
  static uint104(e) {
    return n(e, 104);
  }
  /**
   *  Return a new ``uint112`` type for %%v%%.
   */
  static uint112(e) {
    return n(e, 112);
  }
  /**
   *  Return a new ``uint120`` type for %%v%%.
   */
  static uint120(e) {
    return n(e, 120);
  }
  /**
   *  Return a new ``uint128`` type for %%v%%.
   */
  static uint128(e) {
    return n(e, 128);
  }
  /**
   *  Return a new ``uint136`` type for %%v%%.
   */
  static uint136(e) {
    return n(e, 136);
  }
  /**
   *  Return a new ``uint144`` type for %%v%%.
   */
  static uint144(e) {
    return n(e, 144);
  }
  /**
   *  Return a new ``uint152`` type for %%v%%.
   */
  static uint152(e) {
    return n(e, 152);
  }
  /**
   *  Return a new ``uint160`` type for %%v%%.
   */
  static uint160(e) {
    return n(e, 160);
  }
  /**
   *  Return a new ``uint168`` type for %%v%%.
   */
  static uint168(e) {
    return n(e, 168);
  }
  /**
   *  Return a new ``uint176`` type for %%v%%.
   */
  static uint176(e) {
    return n(e, 176);
  }
  /**
   *  Return a new ``uint184`` type for %%v%%.
   */
  static uint184(e) {
    return n(e, 184);
  }
  /**
   *  Return a new ``uint192`` type for %%v%%.
   */
  static uint192(e) {
    return n(e, 192);
  }
  /**
   *  Return a new ``uint200`` type for %%v%%.
   */
  static uint200(e) {
    return n(e, 200);
  }
  /**
   *  Return a new ``uint208`` type for %%v%%.
   */
  static uint208(e) {
    return n(e, 208);
  }
  /**
   *  Return a new ``uint216`` type for %%v%%.
   */
  static uint216(e) {
    return n(e, 216);
  }
  /**
   *  Return a new ``uint224`` type for %%v%%.
   */
  static uint224(e) {
    return n(e, 224);
  }
  /**
   *  Return a new ``uint232`` type for %%v%%.
   */
  static uint232(e) {
    return n(e, 232);
  }
  /**
   *  Return a new ``uint240`` type for %%v%%.
   */
  static uint240(e) {
    return n(e, 240);
  }
  /**
   *  Return a new ``uint248`` type for %%v%%.
   */
  static uint248(e) {
    return n(e, 248);
  }
  /**
   *  Return a new ``uint256`` type for %%v%%.
   */
  static uint256(e) {
    return n(e, 256);
  }
  /**
   *  Return a new ``uint256`` type for %%v%%.
   */
  static uint(e) {
    return n(e, 256);
  }
  /**
   *  Return a new ``int8`` type for %%v%%.
   */
  static int8(e) {
    return n(e, -8);
  }
  /**
   *  Return a new ``int16`` type for %%v%%.
   */
  static int16(e) {
    return n(e, -16);
  }
  /**
   *  Return a new ``int24`` type for %%v%%.
   */
  static int24(e) {
    return n(e, -24);
  }
  /**
   *  Return a new ``int32`` type for %%v%%.
   */
  static int32(e) {
    return n(e, -32);
  }
  /**
   *  Return a new ``int40`` type for %%v%%.
   */
  static int40(e) {
    return n(e, -40);
  }
  /**
   *  Return a new ``int48`` type for %%v%%.
   */
  static int48(e) {
    return n(e, -48);
  }
  /**
   *  Return a new ``int56`` type for %%v%%.
   */
  static int56(e) {
    return n(e, -56);
  }
  /**
   *  Return a new ``int64`` type for %%v%%.
   */
  static int64(e) {
    return n(e, -64);
  }
  /**
   *  Return a new ``int72`` type for %%v%%.
   */
  static int72(e) {
    return n(e, -72);
  }
  /**
   *  Return a new ``int80`` type for %%v%%.
   */
  static int80(e) {
    return n(e, -80);
  }
  /**
   *  Return a new ``int88`` type for %%v%%.
   */
  static int88(e) {
    return n(e, -88);
  }
  /**
   *  Return a new ``int96`` type for %%v%%.
   */
  static int96(e) {
    return n(e, -96);
  }
  /**
   *  Return a new ``int104`` type for %%v%%.
   */
  static int104(e) {
    return n(e, -104);
  }
  /**
   *  Return a new ``int112`` type for %%v%%.
   */
  static int112(e) {
    return n(e, -112);
  }
  /**
   *  Return a new ``int120`` type for %%v%%.
   */
  static int120(e) {
    return n(e, -120);
  }
  /**
   *  Return a new ``int128`` type for %%v%%.
   */
  static int128(e) {
    return n(e, -128);
  }
  /**
   *  Return a new ``int136`` type for %%v%%.
   */
  static int136(e) {
    return n(e, -136);
  }
  /**
   *  Return a new ``int144`` type for %%v%%.
   */
  static int144(e) {
    return n(e, -144);
  }
  /**
   *  Return a new ``int52`` type for %%v%%.
   */
  static int152(e) {
    return n(e, -152);
  }
  /**
   *  Return a new ``int160`` type for %%v%%.
   */
  static int160(e) {
    return n(e, -160);
  }
  /**
   *  Return a new ``int168`` type for %%v%%.
   */
  static int168(e) {
    return n(e, -168);
  }
  /**
   *  Return a new ``int176`` type for %%v%%.
   */
  static int176(e) {
    return n(e, -176);
  }
  /**
   *  Return a new ``int184`` type for %%v%%.
   */
  static int184(e) {
    return n(e, -184);
  }
  /**
   *  Return a new ``int92`` type for %%v%%.
   */
  static int192(e) {
    return n(e, -192);
  }
  /**
   *  Return a new ``int200`` type for %%v%%.
   */
  static int200(e) {
    return n(e, -200);
  }
  /**
   *  Return a new ``int208`` type for %%v%%.
   */
  static int208(e) {
    return n(e, -208);
  }
  /**
   *  Return a new ``int216`` type for %%v%%.
   */
  static int216(e) {
    return n(e, -216);
  }
  /**
   *  Return a new ``int224`` type for %%v%%.
   */
  static int224(e) {
    return n(e, -224);
  }
  /**
   *  Return a new ``int232`` type for %%v%%.
   */
  static int232(e) {
    return n(e, -232);
  }
  /**
   *  Return a new ``int240`` type for %%v%%.
   */
  static int240(e) {
    return n(e, -240);
  }
  /**
   *  Return a new ``int248`` type for %%v%%.
   */
  static int248(e) {
    return n(e, -248);
  }
  /**
   *  Return a new ``int256`` type for %%v%%.
   */
  static int256(e) {
    return n(e, -256);
  }
  /**
   *  Return a new ``int256`` type for %%v%%.
   */
  static int(e) {
    return n(e, -256);
  }
  /**
   *  Return a new ``bytes1`` type for %%v%%.
   */
  static bytes1(e) {
    return b(e, 1);
  }
  /**
   *  Return a new ``bytes2`` type for %%v%%.
   */
  static bytes2(e) {
    return b(e, 2);
  }
  /**
   *  Return a new ``bytes3`` type for %%v%%.
   */
  static bytes3(e) {
    return b(e, 3);
  }
  /**
   *  Return a new ``bytes4`` type for %%v%%.
   */
  static bytes4(e) {
    return b(e, 4);
  }
  /**
   *  Return a new ``bytes5`` type for %%v%%.
   */
  static bytes5(e) {
    return b(e, 5);
  }
  /**
   *  Return a new ``bytes6`` type for %%v%%.
   */
  static bytes6(e) {
    return b(e, 6);
  }
  /**
   *  Return a new ``bytes7`` type for %%v%%.
   */
  static bytes7(e) {
    return b(e, 7);
  }
  /**
   *  Return a new ``bytes8`` type for %%v%%.
   */
  static bytes8(e) {
    return b(e, 8);
  }
  /**
   *  Return a new ``bytes9`` type for %%v%%.
   */
  static bytes9(e) {
    return b(e, 9);
  }
  /**
   *  Return a new ``bytes10`` type for %%v%%.
   */
  static bytes10(e) {
    return b(e, 10);
  }
  /**
   *  Return a new ``bytes11`` type for %%v%%.
   */
  static bytes11(e) {
    return b(e, 11);
  }
  /**
   *  Return a new ``bytes12`` type for %%v%%.
   */
  static bytes12(e) {
    return b(e, 12);
  }
  /**
   *  Return a new ``bytes13`` type for %%v%%.
   */
  static bytes13(e) {
    return b(e, 13);
  }
  /**
   *  Return a new ``bytes14`` type for %%v%%.
   */
  static bytes14(e) {
    return b(e, 14);
  }
  /**
   *  Return a new ``bytes15`` type for %%v%%.
   */
  static bytes15(e) {
    return b(e, 15);
  }
  /**
   *  Return a new ``bytes16`` type for %%v%%.
   */
  static bytes16(e) {
    return b(e, 16);
  }
  /**
   *  Return a new ``bytes17`` type for %%v%%.
   */
  static bytes17(e) {
    return b(e, 17);
  }
  /**
   *  Return a new ``bytes18`` type for %%v%%.
   */
  static bytes18(e) {
    return b(e, 18);
  }
  /**
   *  Return a new ``bytes19`` type for %%v%%.
   */
  static bytes19(e) {
    return b(e, 19);
  }
  /**
   *  Return a new ``bytes20`` type for %%v%%.
   */
  static bytes20(e) {
    return b(e, 20);
  }
  /**
   *  Return a new ``bytes21`` type for %%v%%.
   */
  static bytes21(e) {
    return b(e, 21);
  }
  /**
   *  Return a new ``bytes22`` type for %%v%%.
   */
  static bytes22(e) {
    return b(e, 22);
  }
  /**
   *  Return a new ``bytes23`` type for %%v%%.
   */
  static bytes23(e) {
    return b(e, 23);
  }
  /**
   *  Return a new ``bytes24`` type for %%v%%.
   */
  static bytes24(e) {
    return b(e, 24);
  }
  /**
   *  Return a new ``bytes25`` type for %%v%%.
   */
  static bytes25(e) {
    return b(e, 25);
  }
  /**
   *  Return a new ``bytes26`` type for %%v%%.
   */
  static bytes26(e) {
    return b(e, 26);
  }
  /**
   *  Return a new ``bytes27`` type for %%v%%.
   */
  static bytes27(e) {
    return b(e, 27);
  }
  /**
   *  Return a new ``bytes28`` type for %%v%%.
   */
  static bytes28(e) {
    return b(e, 28);
  }
  /**
   *  Return a new ``bytes29`` type for %%v%%.
   */
  static bytes29(e) {
    return b(e, 29);
  }
  /**
   *  Return a new ``bytes30`` type for %%v%%.
   */
  static bytes30(e) {
    return b(e, 30);
  }
  /**
   *  Return a new ``bytes31`` type for %%v%%.
   */
  static bytes31(e) {
    return b(e, 31);
  }
  /**
   *  Return a new ``bytes32`` type for %%v%%.
   */
  static bytes32(e) {
    return b(e, 32);
  }
  /**
   *  Return a new ``address`` type for %%v%%.
   */
  static address(e) {
    return new Hr(_gaurd, "address", e);
  }
  /**
   *  Return a new ``bool`` type for %%v%%.
   */
  static bool(e) {
    return new Hr(_gaurd, "bool", !!e);
  }
  /**
   *  Return a new ``bytes`` type for %%v%%.
   */
  static bytes(e) {
    return new Hr(_gaurd, "bytes", e);
  }
  /**
   *  Return a new ``string`` type for %%v%%.
   */
  static string(e) {
    return new Hr(_gaurd, "string", e);
  }
  /**
   *  Return a new ``array`` type for %%v%%, allowing %%dynamic%% length.
   */
  static array(e, T) {
    throw new Error("not implemented yet");
  }
  /**
   *  Return a new ``tuple`` type for %%v%%, with the optional %%name%%.
   */
  static tuple(e, T) {
    throw new Error("not implemented yet");
  }
  /**
   *  Return a new ``uint8`` type for %%v%%.
   */
  static overrides(e) {
    return new Hr(_gaurd, "overrides", Object.assign({}, e));
  }
  /**
   *  Returns true only if %%value%% is a [[Typed]] instance.
   */
  static isTyped(e) {
    return e && typeof e == "object" && "_typedSymbol" in e && e._typedSymbol === _typedSymbol;
  }
  /**
   *  If the value is a [[Typed]] instance, validates the underlying value
   *  and returns it, otherwise returns value directly.
   *
   *  This is useful for functions that with to accept either a [[Typed]]
   *  object or values.
   */
  static dereference(e, T) {
    if (Hr.isTyped(e)) {
      if (e.type !== T)
        throw new Error(`invalid type: expecetd ${T}, got ${e.type}`);
      return e.value;
    }
    return e;
  }
};
Ki = new WeakMap();
let Typed = Hr;
class AddressCoder extends Coder {
  constructor(e) {
    super("address", "address", e, !1);
  }
  defaultValue() {
    return "0x0000000000000000000000000000000000000000";
  }
  encode(e, T) {
    let $ = Typed.dereference(T, "string");
    try {
      $ = getAddress($);
    } catch (V) {
      return this._throwError(V.message, T);
    }
    return e.writeValue($);
  }
  decode(e) {
    return getAddress(toBeHex(e.readValue(), 20));
  }
}
class AnonymousCoder extends Coder {
  constructor(T) {
    super(T.name, T.type, "_", T.dynamic);
    tt(this, "coder");
    this.coder = T;
  }
  defaultValue() {
    return this.coder.defaultValue();
  }
  encode(T, $) {
    return this.coder.encode(T, $);
  }
  decode(T) {
    return this.coder.decode(T);
  }
}
function pack(C, e, T) {
  let $ = [];
  if (Array.isArray(T))
    $ = T;
  else if (T && typeof T == "object") {
    let re = {};
    $ = e.map((ie) => {
      const se = ie.localName;
      return assert$5(se, "cannot encode object for signature with missing names", "INVALID_ARGUMENT", { argument: "values", info: { coder: ie }, value: T }), assert$5(!re[se], "cannot encode object for signature with duplicate names", "INVALID_ARGUMENT", { argument: "values", info: { coder: ie }, value: T }), re[se] = !0, T[se];
    });
  } else
    assertArgument(!1, "invalid tuple value", "tuple", T);
  assertArgument(e.length === $.length, "types/value length mismatch", "tuple", T);
  let V = new Writer(), J = new Writer(), ee = [];
  e.forEach((re, ie) => {
    let se = $[ie];
    if (re.dynamic) {
      let de = J.length;
      re.encode(J, se);
      let ue = V.writeUpdatableValue();
      ee.push((fe) => {
        ue(fe + de);
      });
    } else
      re.encode(V, se);
  }), ee.forEach((re) => {
    re(V.length);
  });
  let te = C.appendWriter(V);
  return te += C.appendWriter(J), te;
}
function unpack(C, e) {
  let T = [], $ = [], V = C.subReader(0);
  return e.forEach((J) => {
    let ee = null;
    if (J.dynamic) {
      let te = C.readIndex(), re = V.subReader(te);
      try {
        ee = J.decode(re);
      } catch (ie) {
        if (isError(ie, "BUFFER_OVERRUN"))
          throw ie;
        ee = ie, ee.baseType = J.name, ee.name = J.localName, ee.type = J.type;
      }
    } else
      try {
        ee = J.decode(C);
      } catch (te) {
        if (isError(te, "BUFFER_OVERRUN"))
          throw te;
        ee = te, ee.baseType = J.name, ee.name = J.localName, ee.type = J.type;
      }
    if (ee == null)
      throw new Error("investigate");
    T.push(ee), $.push(J.localName || null);
  }), Result.fromItems(T, $);
}
class ArrayCoder extends Coder {
  constructor(T, $, V) {
    const J = T.type + "[" + ($ >= 0 ? $ : "") + "]", ee = $ === -1 || T.dynamic;
    super("array", J, V, ee);
    tt(this, "coder");
    tt(this, "length");
    defineProperties(this, { coder: T, length: $ });
  }
  defaultValue() {
    const T = this.coder.defaultValue(), $ = [];
    for (let V = 0; V < this.length; V++)
      $.push(T);
    return $;
  }
  encode(T, $) {
    const V = Typed.dereference($, "array");
    Array.isArray(V) || this._throwError("expected array value", V);
    let J = this.length;
    J === -1 && (J = V.length, T.writeValue(V.length)), assertArgumentCount(V.length, J, "coder array" + (this.localName ? " " + this.localName : ""));
    let ee = [];
    for (let te = 0; te < V.length; te++)
      ee.push(this.coder);
    return pack(T, ee, V);
  }
  decode(T) {
    let $ = this.length;
    $ === -1 && ($ = T.readIndex(), assert$5($ * WordSize <= T.dataLength, "insufficient data length", "BUFFER_OVERRUN", { buffer: T.bytes, offset: $ * WordSize, length: T.dataLength }));
    let V = [];
    for (let J = 0; J < $; J++)
      V.push(new AnonymousCoder(this.coder));
    return unpack(T, V);
  }
}
class BooleanCoder extends Coder {
  constructor(e) {
    super("bool", "bool", e, !1);
  }
  defaultValue() {
    return !1;
  }
  encode(e, T) {
    const $ = Typed.dereference(T, "bool");
    return e.writeValue($ ? 1 : 0);
  }
  decode(e) {
    return !!e.readValue();
  }
}
class DynamicBytesCoder extends Coder {
  constructor(e, T) {
    super(e, e, T, !0);
  }
  defaultValue() {
    return "0x";
  }
  encode(e, T) {
    T = getBytesCopy(T);
    let $ = e.writeValue(T.length);
    return $ += e.writeBytes(T), $;
  }
  decode(e) {
    return e.readBytes(e.readIndex(), !0);
  }
}
class BytesCoder extends DynamicBytesCoder {
  constructor(e) {
    super("bytes", e);
  }
  decode(e) {
    return hexlify(super.decode(e));
  }
}
class FixedBytesCoder extends Coder {
  constructor(T, $) {
    let V = "bytes" + String(T);
    super(V, V, $, !1);
    tt(this, "size");
    defineProperties(this, { size: T }, { size: "number" });
  }
  defaultValue() {
    return "0x0000000000000000000000000000000000000000000000000000000000000000".substring(0, 2 + this.size * 2);
  }
  encode(T, $) {
    let V = getBytesCopy(Typed.dereference($, this.type));
    return V.length !== this.size && this._throwError("incorrect data length", $), T.writeBytes(V);
  }
  decode(T) {
    return hexlify(T.readBytes(this.size));
  }
}
const Empty = new Uint8Array([]);
class NullCoder extends Coder {
  constructor(e) {
    super("null", "", e, !1);
  }
  defaultValue() {
    return null;
  }
  encode(e, T) {
    return T != null && this._throwError("not null", T), e.writeBytes(Empty);
  }
  decode(e) {
    return e.readBytes(0), null;
  }
}
const BN_0$5 = BigInt(0), BN_1$1 = BigInt(1), BN_MAX_UINT256$1 = BigInt("0xffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff");
class NumberCoder extends Coder {
  constructor(T, $, V) {
    const J = ($ ? "int" : "uint") + T * 8;
    super(J, J, V, !1);
    tt(this, "size");
    tt(this, "signed");
    defineProperties(this, { size: T, signed: $ }, { size: "number", signed: "boolean" });
  }
  defaultValue() {
    return 0;
  }
  encode(T, $) {
    let V = getBigInt(Typed.dereference($, this.type)), J = mask$3(BN_MAX_UINT256$1, WordSize * 8);
    if (this.signed) {
      let ee = mask$3(J, this.size * 8 - 1);
      (V > ee || V < -(ee + BN_1$1)) && this._throwError("value out-of-bounds", $), V = toTwos(V, 8 * WordSize);
    } else (V < BN_0$5 || V > mask$3(J, this.size * 8)) && this._throwError("value out-of-bounds", $);
    return T.writeValue(V);
  }
  decode(T) {
    let $ = mask$3(T.readValue(), this.size * 8);
    return this.signed && ($ = fromTwos($, this.size * 8)), $;
  }
}
class StringCoder extends DynamicBytesCoder {
  constructor(e) {
    super("string", e);
  }
  defaultValue() {
    return "";
  }
  encode(e, T) {
    return super.encode(e, toUtf8Bytes(Typed.dereference(T, "string")));
  }
  decode(e) {
    return toUtf8String(super.decode(e));
  }
}
class TupleCoder extends Coder {
  constructor(T, $) {
    let V = !1;
    const J = [];
    T.forEach((te) => {
      te.dynamic && (V = !0), J.push(te.type);
    });
    const ee = "tuple(" + J.join(",") + ")";
    super("tuple", ee, $, V);
    tt(this, "coders");
    defineProperties(this, { coders: Object.freeze(T.slice()) });
  }
  defaultValue() {
    const T = [];
    this.coders.forEach((V) => {
      T.push(V.defaultValue());
    });
    const $ = this.coders.reduce((V, J) => {
      const ee = J.localName;
      return ee && (V[ee] || (V[ee] = 0), V[ee]++), V;
    }, {});
    return this.coders.forEach((V, J) => {
      let ee = V.localName;
      !ee || $[ee] !== 1 || (ee === "length" && (ee = "_length"), T[ee] == null && (T[ee] = T[J]));
    }), Object.freeze(T);
  }
  encode(T, $) {
    const V = Typed.dereference($, "tuple");
    return pack(T, this.coders, V);
  }
  decode(T) {
    return unpack(T, this.coders);
  }
}
function id(C) {
  return keccak256(toUtf8Bytes(C));
}
var COMPRESSED$1 = "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";
const FENCED = /* @__PURE__ */ new Map([[8217, "apostrophe"], [8260, "fraction slash"], [12539, "middle dot"]]), NSM_MAX = 4;
function decode_arithmetic(C) {
  let e = 0;
  function T() {
    return C[e++] << 8 | C[e++];
  }
  let $ = T(), V = 1, J = [0, 1];
  for (let Me = 1; Me < $; Me++)
    J.push(V += T());
  let ee = T(), te = e;
  e += ee;
  let re = 0, ie = 0;
  function se() {
    return re == 0 && (ie = ie << 8 | C[e++], re = 8), ie >> --re & 1;
  }
  const de = 31, ue = 2 ** de, fe = ue >>> 1, he = fe >> 1, me = ue - 1;
  let xe = 0;
  for (let Me = 0; Me < de; Me++) xe = xe << 1 | se();
  let ve = [], Te = 0, we = ue;
  for (; ; ) {
    let Me = Math.floor(((xe - Te + 1) * V - 1) / we), Ie = 0, ke = $;
    for (; ke - Ie > 1; ) {
      let Fe = Ie + ke >>> 1;
      Me < J[Fe] ? ke = Fe : Ie = Fe;
    }
    if (Ie == 0) break;
    ve.push(Ie);
    let _e = Te + Math.floor(we * J[Ie] / V), De = Te + Math.floor(we * J[Ie + 1] / V) - 1;
    for (; !((_e ^ De) & fe); )
      xe = xe << 1 & me | se(), _e = _e << 1 & me, De = De << 1 & me | 1;
    for (; _e & ~De & he; )
      xe = xe & fe | xe << 1 & me >>> 1 | se(), _e = _e << 1 ^ fe, De = (De ^ fe) << 1 | fe | 1;
    Te = _e, we = 1 + De - _e;
  }
  let Ee = $ - 4;
  return ve.map((Me) => {
    switch (Me - Ee) {
      case 3:
        return Ee + 65792 + (C[te++] << 16 | C[te++] << 8 | C[te++]);
      case 2:
        return Ee + 256 + (C[te++] << 8 | C[te++]);
      case 1:
        return Ee + C[te++];
      default:
        return Me - 1;
    }
  });
}
function read_payload(C) {
  let e = 0;
  return () => C[e++];
}
function read_compressed_payload(C) {
  return read_payload(decode_arithmetic(unsafe_atob(C)));
}
function unsafe_atob(C) {
  let e = [];
  [..."ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/"].forEach((V, J) => e[V.charCodeAt(0)] = J);
  let T = C.length, $ = new Uint8Array(6 * T >> 3);
  for (let V = 0, J = 0, ee = 0, te = 0; V < T; V++)
    te = te << 6 | e[C.charCodeAt(V)], ee += 6, ee >= 8 && ($[J++] = te >> (ee -= 8));
  return $;
}
function signed(C) {
  return C & 1 ? ~C >> 1 : C >> 1;
}
function read_deltas(C, e) {
  let T = Array(C);
  for (let $ = 0, V = 0; $ < C; $++) T[$] = V += signed(e());
  return T;
}
function read_sorted(C, e = 0) {
  let T = [];
  for (; ; ) {
    let $ = C(), V = C();
    if (!V) break;
    e += $;
    for (let J = 0; J < V; J++)
      T.push(e + J);
    e += V + 1;
  }
  return T;
}
function read_sorted_arrays(C) {
  return read_array_while(() => {
    let e = read_sorted(C);
    if (e.length) return e;
  });
}
function read_mapped(C) {
  let e = [];
  for (; ; ) {
    let T = C();
    if (T == 0) break;
    e.push(read_linear_table(T, C));
  }
  for (; ; ) {
    let T = C() - 1;
    if (T < 0) break;
    e.push(read_replacement_table(T, C));
  }
  return e.flat();
}
function read_array_while(C) {
  let e = [];
  for (; ; ) {
    let T = C(e.length);
    if (!T) break;
    e.push(T);
  }
  return e;
}
function read_transposed(C, e, T) {
  let $ = Array(C).fill().map(() => []);
  for (let V = 0; V < e; V++)
    read_deltas(C, T).forEach((J, ee) => $[ee].push(J));
  return $;
}
function read_linear_table(C, e) {
  let T = 1 + e(), $ = e(), V = read_array_while(e);
  return read_transposed(V.length, 1 + C, e).flatMap((ee, te) => {
    let [re, ...ie] = ee;
    return Array(V[te]).fill().map((se, de) => {
      let ue = de * $;
      return [re + de * T, ie.map((fe) => fe + ue)];
    });
  });
}
function read_replacement_table(C, e) {
  let T = 1 + e();
  return read_transposed(T, 1 + C, e).map((V) => [V[0], V.slice(1)]);
}
function read_trie(C) {
  let e = [], T = read_sorted(C);
  return V($([]), []), e;
  function $(J) {
    let ee = C(), te = read_array_while(() => {
      let re = read_sorted(C).map((ie) => T[ie]);
      if (re.length) return $(re);
    });
    return { S: ee, B: te, Q: J };
  }
  function V({ S: J, B: ee }, te, re) {
    if (!(J & 4 && re === te[te.length - 1])) {
      J & 2 && (re = te[te.length - 1]), J & 1 && e.push(te);
      for (let ie of ee)
        for (let se of ie.Q)
          V(ie, [...te, se], re);
    }
  }
}
function hex_cp(C) {
  return C.toString(16).toUpperCase().padStart(2, "0");
}
function quote_cp(C) {
  return `{${hex_cp(C)}}`;
}
function explode_cp(C) {
  let e = [];
  for (let T = 0, $ = C.length; T < $; ) {
    let V = C.codePointAt(T);
    T += V < 65536 ? 1 : 2, e.push(V);
  }
  return e;
}
function str_from_cps(C) {
  let T = C.length;
  if (T < 4096) return String.fromCodePoint(...C);
  let $ = [];
  for (let V = 0; V < T; )
    $.push(String.fromCodePoint(...C.slice(V, V += 4096)));
  return $.join("");
}
function compare_arrays(C, e) {
  let T = C.length, $ = T - e.length;
  for (let V = 0; $ == 0 && V < T; V++) $ = C[V] - e[V];
  return $;
}
var COMPRESSED = "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";
const S0 = 44032, L0 = 4352, V0 = 4449, T0 = 4519, L_COUNT = 19, V_COUNT = 21, T_COUNT = 28, N_COUNT = V_COUNT * T_COUNT, S_COUNT = L_COUNT * N_COUNT, S1 = S0 + S_COUNT, L1 = L0 + L_COUNT, V1 = V0 + V_COUNT, T1$1 = T0 + T_COUNT;
function unpack_cc(C) {
  return C >> 24 & 255;
}
function unpack_cp(C) {
  return C & 16777215;
}
let SHIFTED_RANK, EXCLUSIONS, DECOMP, RECOMP;
function init$1() {
  let C = read_compressed_payload(COMPRESSED);
  SHIFTED_RANK = new Map(read_sorted_arrays(C).flatMap((e, T) => e.map(($) => [$, T + 1 << 24]))), EXCLUSIONS = new Set(read_sorted(C)), DECOMP = /* @__PURE__ */ new Map(), RECOMP = /* @__PURE__ */ new Map();
  for (let [e, T] of read_mapped(C)) {
    if (!EXCLUSIONS.has(e) && T.length == 2) {
      let [$, V] = T, J = RECOMP.get($);
      J || (J = /* @__PURE__ */ new Map(), RECOMP.set($, J)), J.set(V, e);
    }
    DECOMP.set(e, T.reverse());
  }
}
function is_hangul(C) {
  return C >= S0 && C < S1;
}
function compose_pair(C, e) {
  if (C >= L0 && C < L1 && e >= V0 && e < V1)
    return S0 + (C - L0) * N_COUNT + (e - V0) * T_COUNT;
  if (is_hangul(C) && e > T0 && e < T1$1 && (C - S0) % T_COUNT == 0)
    return C + (e - T0);
  {
    let T = RECOMP.get(C);
    return T && (T = T.get(e), T) ? T : -1;
  }
}
function decomposed(C) {
  SHIFTED_RANK || init$1();
  let e = [], T = [], $ = !1;
  function V(J) {
    let ee = SHIFTED_RANK.get(J);
    ee && ($ = !0, J |= ee), e.push(J);
  }
  for (let J of C)
    for (; ; ) {
      if (J < 128)
        e.push(J);
      else if (is_hangul(J)) {
        let ee = J - S0, te = ee / N_COUNT | 0, re = ee % N_COUNT / T_COUNT | 0, ie = ee % T_COUNT;
        V(L0 + te), V(V0 + re), ie > 0 && V(T0 + ie);
      } else {
        let ee = DECOMP.get(J);
        ee ? T.push(...ee) : V(J);
      }
      if (!T.length) break;
      J = T.pop();
    }
  if ($ && e.length > 1) {
    let J = unpack_cc(e[0]);
    for (let ee = 1; ee < e.length; ee++) {
      let te = unpack_cc(e[ee]);
      if (te == 0 || J <= te) {
        J = te;
        continue;
      }
      let re = ee - 1;
      for (; ; ) {
        let ie = e[re + 1];
        if (e[re + 1] = e[re], e[re] = ie, !re || (J = unpack_cc(e[--re]), J <= te)) break;
      }
      J = unpack_cc(e[ee]);
    }
  }
  return e;
}
function composed_from_decomposed(C) {
  let e = [], T = [], $ = -1, V = 0;
  for (let J of C) {
    let ee = unpack_cc(J), te = unpack_cp(J);
    if ($ == -1)
      ee == 0 ? $ = te : e.push(te);
    else if (V > 0 && V >= ee)
      ee == 0 ? (e.push($, ...T), T.length = 0, $ = te) : T.push(te), V = ee;
    else {
      let re = compose_pair($, te);
      re >= 0 ? $ = re : V == 0 && ee == 0 ? (e.push($), $ = te) : (T.push(te), V = ee);
    }
  }
  return $ >= 0 && e.push($, ...T), e;
}
function nfd(C) {
  return decomposed(C).map(unpack_cp);
}
function nfc(C) {
  return composed_from_decomposed(decomposed(C));
}
const HYPHEN = 45, STOP_CH = ".", FE0F = 65039, UNIQUE_PH = 1, Array_from = (C) => Array.from(C);
function group_has_cp(C, e) {
  return C.P.has(e) || C.Q.has(e);
}
class Emoji extends Array {
  get is_emoji() {
    return !0;
  }
  // free tagging system
}
let MAPPED, IGNORED, CM, NSM, ESCAPE, GROUPS, WHOLE_VALID, WHOLE_MAP, VALID, EMOJI_LIST, EMOJI_ROOT;
function init() {
  if (MAPPED) return;
  let C = read_compressed_payload(COMPRESSED$1);
  const e = () => read_sorted(C), T = () => new Set(e()), $ = (se, de) => de.forEach((ue) => se.add(ue));
  MAPPED = new Map(read_mapped(C)), IGNORED = T(), CM = e(), NSM = new Set(e().map((se) => CM[se])), CM = new Set(CM), ESCAPE = T(), T();
  let V = read_sorted_arrays(C), J = C();
  const ee = () => {
    let se = /* @__PURE__ */ new Set();
    return e().forEach((de) => $(se, V[de])), $(se, e()), se;
  };
  GROUPS = read_array_while((se) => {
    let de = read_array_while(C).map((ue) => ue + 96);
    if (de.length) {
      let ue = se >= J;
      de[0] -= 32, de = str_from_cps(de), ue && (de = `Restricted[${de}]`);
      let fe = ee(), he = ee(), me = !C();
      return { N: de, P: fe, Q: he, M: me, R: ue };
    }
  }), WHOLE_VALID = T(), WHOLE_MAP = /* @__PURE__ */ new Map();
  let te = e().concat(Array_from(WHOLE_VALID)).sort((se, de) => se - de);
  te.forEach((se, de) => {
    let ue = C(), fe = te[de] = ue ? te[de - ue] : { V: [], M: /* @__PURE__ */ new Map() };
    fe.V.push(se), WHOLE_VALID.has(se) || WHOLE_MAP.set(se, fe);
  });
  for (let { V: se, M: de } of new Set(WHOLE_MAP.values())) {
    let ue = [];
    for (let he of se) {
      let me = GROUPS.filter((ve) => group_has_cp(ve, he)), xe = ue.find(({ G: ve }) => me.some((Te) => ve.has(Te)));
      xe || (xe = { G: /* @__PURE__ */ new Set(), V: [] }, ue.push(xe)), xe.V.push(he), $(xe.G, me);
    }
    let fe = ue.flatMap((he) => Array_from(he.G));
    for (let { G: he, V: me } of ue) {
      let xe = new Set(fe.filter((ve) => !he.has(ve)));
      for (let ve of me)
        de.set(ve, xe);
    }
  }
  VALID = /* @__PURE__ */ new Set();
  let re = /* @__PURE__ */ new Set();
  const ie = (se) => VALID.has(se) ? re.add(se) : VALID.add(se);
  for (let se of GROUPS) {
    for (let de of se.P) ie(de);
    for (let de of se.Q) ie(de);
  }
  for (let se of VALID)
    !WHOLE_MAP.has(se) && !re.has(se) && WHOLE_MAP.set(se, UNIQUE_PH);
  $(VALID, nfd(VALID)), EMOJI_LIST = read_trie(C).map((se) => Emoji.from(se)).sort(compare_arrays), EMOJI_ROOT = /* @__PURE__ */ new Map();
  for (let se of EMOJI_LIST) {
    let de = [EMOJI_ROOT];
    for (let ue of se) {
      let fe = de.map((he) => {
        let me = he.get(ue);
        return me || (me = /* @__PURE__ */ new Map(), he.set(ue, me)), me;
      });
      ue === FE0F ? de.push(...fe) : de = fe;
    }
    for (let ue of de)
      ue.V = se;
  }
}
function quoted_cp(C) {
  return (should_escape(C) ? "" : `${bidi_qq(safe_str_from_cps([C]))} `) + quote_cp(C);
}
function bidi_qq(C) {
  return `"${C}"‎`;
}
function check_label_extension(C) {
  if (C.length >= 4 && C[2] == HYPHEN && C[3] == HYPHEN)
    throw new Error(`invalid label extension: "${str_from_cps(C.slice(0, 4))}"`);
}
function check_leading_underscore(C) {
  for (let T = C.lastIndexOf(95); T > 0; )
    if (C[--T] !== 95)
      throw new Error("underscore allowed only at start");
}
function check_fenced(C) {
  let e = C[0], T = FENCED.get(e);
  if (T) throw error_placement(`leading ${T}`);
  let $ = C.length, V = -1;
  for (let J = 1; J < $; J++) {
    e = C[J];
    let ee = FENCED.get(e);
    if (ee) {
      if (V == J) throw error_placement(`${T} + ${ee}`);
      V = J + 1, T = ee;
    }
  }
  if (V == $) throw error_placement(`trailing ${T}`);
}
function safe_str_from_cps(C, e = 1 / 0, T = quote_cp) {
  let $ = [];
  is_combining_mark(C[0]) && $.push("◌"), C.length > e && (e >>= 1, C = [...C.slice(0, e), 8230, ...C.slice(-e)]);
  let V = 0, J = C.length;
  for (let ee = 0; ee < J; ee++) {
    let te = C[ee];
    should_escape(te) && ($.push(str_from_cps(C.slice(V, ee))), $.push(T(te)), V = ee + 1);
  }
  return $.push(str_from_cps(C.slice(V, J))), $.join("");
}
function is_combining_mark(C) {
  return init(), CM.has(C);
}
function should_escape(C) {
  return init(), ESCAPE.has(C);
}
function ens_normalize(C) {
  return flatten(split$2(C, nfc, filter_fe0f));
}
function split$2(C, e, T) {
  if (!C) return [];
  init();
  let $ = 0;
  return C.split(STOP_CH).map((V) => {
    let J = explode_cp(V), ee = {
      input: J,
      offset: $
      // codepoint, not substring!
    };
    $ += J.length + 1;
    try {
      let te = ee.tokens = tokens_from_str(J, e, T), re = te.length, ie;
      if (!re)
        throw new Error("empty label");
      let se = ee.output = te.flat();
      if (check_leading_underscore(se), !(ee.emoji = re > 1 || te[0].is_emoji) && se.every((ue) => ue < 128))
        check_label_extension(se), ie = "ASCII";
      else {
        let ue = te.flatMap((fe) => fe.is_emoji ? [] : fe);
        if (!ue.length)
          ie = "Emoji";
        else {
          if (CM.has(se[0])) throw error_placement("leading combining mark");
          for (let me = 1; me < re; me++) {
            let xe = te[me];
            if (!xe.is_emoji && CM.has(xe[0]))
              throw error_placement(`emoji + combining mark: "${str_from_cps(te[me - 1])} + ${safe_str_from_cps([xe[0]])}"`);
          }
          check_fenced(se);
          let fe = Array_from(new Set(ue)), [he] = determine_group(fe);
          check_group(he, ue), check_whole(he, fe), ie = he.N;
        }
      }
      ee.type = ie;
    } catch (te) {
      ee.error = te;
    }
    return ee;
  });
}
function check_whole(C, e) {
  let T, $ = [];
  for (let V of e) {
    let J = WHOLE_MAP.get(V);
    if (J === UNIQUE_PH) return;
    if (J) {
      let ee = J.M.get(V);
      if (T = T ? T.filter((te) => ee.has(te)) : Array_from(ee), !T.length) return;
    } else
      $.push(V);
  }
  if (T) {
    for (let V of T)
      if ($.every((J) => group_has_cp(V, J)))
        throw new Error(`whole-script confusable: ${C.N}/${V.N}`);
  }
}
function determine_group(C) {
  let e = GROUPS;
  for (let T of C) {
    let $ = e.filter((V) => group_has_cp(V, T));
    if (!$.length)
      throw GROUPS.some((V) => group_has_cp(V, T)) ? error_group_member(e[0], T) : error_disallowed(T);
    if (e = $, $.length == 1) break;
  }
  return e;
}
function flatten(C) {
  return C.map(({ input: e, error: T, output: $ }) => {
    if (T) {
      let V = T.message;
      throw new Error(C.length == 1 ? V : `Invalid label ${bidi_qq(safe_str_from_cps(e, 63))}: ${V}`);
    }
    return str_from_cps($);
  }).join(STOP_CH);
}
function error_disallowed(C) {
  return new Error(`disallowed character: ${quoted_cp(C)}`);
}
function error_group_member(C, e) {
  let T = quoted_cp(e), $ = GROUPS.find((V) => V.P.has(e));
  return $ && (T = `${$.N} ${T}`), new Error(`illegal mixture: ${C.N} + ${T}`);
}
function error_placement(C) {
  return new Error(`illegal placement: ${C}`);
}
function check_group(C, e) {
  for (let T of e)
    if (!group_has_cp(C, T))
      throw error_group_member(C, T);
  if (C.M) {
    let T = nfd(e);
    for (let $ = 1, V = T.length; $ < V; $++)
      if (NSM.has(T[$])) {
        let J = $ + 1;
        for (let ee; J < V && NSM.has(ee = T[J]); J++)
          for (let te = $; te < J; te++)
            if (T[te] == ee)
              throw new Error(`duplicate non-spacing marks: ${quoted_cp(ee)}`);
        if (J - $ > NSM_MAX)
          throw new Error(`excessive non-spacing marks: ${bidi_qq(safe_str_from_cps(T.slice($ - 1, J)))} (${J - $}/${NSM_MAX})`);
        $ = J;
      }
  }
}
function tokens_from_str(C, e, T) {
  let $ = [], V = [];
  for (C = C.slice().reverse(); C.length; ) {
    let J = consume_emoji_reversed(C);
    if (J)
      V.length && ($.push(e(V)), V = []), $.push(T(J));
    else {
      let ee = C.pop();
      if (VALID.has(ee))
        V.push(ee);
      else {
        let te = MAPPED.get(ee);
        if (te)
          V.push(...te);
        else if (!IGNORED.has(ee))
          throw error_disallowed(ee);
      }
    }
  }
  return V.length && $.push(e(V)), $;
}
function filter_fe0f(C) {
  return C.filter((e) => e != FE0F);
}
function consume_emoji_reversed(C, e) {
  let T = EMOJI_ROOT, $, V = C.length;
  for (; V && (T = T.get(C[--V]), !!T); ) {
    let { V: J } = T;
    J && ($ = J, C.length = V);
  }
  return $;
}
const Zeros = new Uint8Array(32);
Zeros.fill(0);
function checkComponent(C) {
  return assertArgument(C.length !== 0, "invalid ENS name; empty component", "comp", C), C;
}
function ensNameSplit(C) {
  const e = toUtf8Bytes(ensNormalize(C)), T = [];
  if (C.length === 0)
    return T;
  let $ = 0;
  for (let V = 0; V < e.length; V++)
    e[V] === 46 && (T.push(checkComponent(e.slice($, V))), $ = V + 1);
  return assertArgument($ < e.length, "invalid ENS name; empty component", "name", C), T.push(checkComponent(e.slice($))), T;
}
function ensNormalize(C) {
  try {
    if (C.length === 0)
      throw new Error("empty label");
    return ens_normalize(C);
  } catch (e) {
    assertArgument(!1, `invalid ENS name (${e.message})`, "name", C);
  }
}
function namehash(C) {
  assertArgument(typeof C == "string", "invalid ENS name; not a string", "name", C), assertArgument(C.length, "invalid ENS name (empty label)", "name", C);
  let e = Zeros;
  const T = ensNameSplit(C);
  for (; T.length; )
    e = keccak256(concat([e, keccak256(T.pop())]));
  return hexlify(e);
}
function dnsEncode(C, e) {
  const T = e;
  return assertArgument(T <= 255, "DNS encoded label cannot exceed 255", "length", T), hexlify(concat(ensNameSplit(C).map(($) => {
    assertArgument($.length <= T, `label ${JSON.stringify(C)} exceeds ${T} bytes`, "name", C);
    const V = new Uint8Array($.length + 1);
    return V.set($, 1), V[0] = V.length - 1, V;
  }))) + "00";
}
function accessSetify(C, e) {
  return {
    address: getAddress(C),
    storageKeys: e.map((T, $) => (assertArgument(isHexString(T, 32), "invalid slot", `storageKeys[${$}]`, T), T.toLowerCase()))
  };
}
function accessListify(C) {
  if (Array.isArray(C))
    return C.map((T, $) => Array.isArray(T) ? (assertArgument(T.length === 2, "invalid slot set", `value[${$}]`, T), accessSetify(T[0], T[1])) : (assertArgument(T != null && typeof T == "object", "invalid address-slot set", "value", C), accessSetify(T.address, T.storageKeys)));
  assertArgument(C != null && typeof C == "object", "invalid access list", "value", C);
  const e = Object.keys(C).map((T) => {
    const $ = C[T].reduce((V, J) => (V[J] = !0, V), {});
    return accessSetify(T, Object.keys($).sort());
  });
  return e.sort((T, $) => T.address.localeCompare($.address)), e;
}
function computeAddress(C) {
  let e;
  return typeof C == "string" ? e = SigningKey.computePublicKey(C, !1) : e = C.publicKey, getAddress(keccak256("0x" + e.substring(4)).substring(26));
}
function recoverAddress(C, e) {
  return computeAddress(SigningKey.recoverPublicKey(C, e));
}
const BN_0$4 = BigInt(0), BN_2$1 = BigInt(2), BN_27 = BigInt(27), BN_28 = BigInt(28), BN_35 = BigInt(35), BN_MAX_UINT = BigInt("0xffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff"), BLOB_SIZE = 4096 * 32;
function getVersionedHash(C, e) {
  let T = C.toString(16);
  for (; T.length < 2; )
    T = "0" + T;
  return T += sha256$6(e).substring(4), "0x" + T;
}
function handleAddress(C) {
  return C === "0x" ? null : getAddress(C);
}
function handleAccessList(C, e) {
  try {
    return accessListify(C);
  } catch (T) {
    assertArgument(!1, T.message, e, C);
  }
}
function handleNumber(C, e) {
  return C === "0x" ? 0 : getNumber(C, e);
}
function handleUint(C, e) {
  if (C === "0x")
    return BN_0$4;
  const T = getBigInt(C, e);
  return assertArgument(T <= BN_MAX_UINT, "value exceeds uint size", e, T), T;
}
function formatNumber(C, e) {
  const T = getBigInt(C, "value"), $ = toBeArray(T);
  return assertArgument($.length <= 32, "value too large", `tx.${e}`, T), $;
}
function formatAccessList(C) {
  return accessListify(C).map((e) => [e.address, e.storageKeys]);
}
function formatHashes(C, e) {
  assertArgument(Array.isArray(C), `invalid ${e}`, "value", C);
  for (let T = 0; T < C.length; T++)
    assertArgument(isHexString(C[T], 32), "invalid ${ param } hash", `value[${T}]`, C[T]);
  return C;
}
function _parseLegacy(C) {
  const e = decodeRlp(C);
  assertArgument(Array.isArray(e) && (e.length === 9 || e.length === 6), "invalid field count for legacy transaction", "data", C);
  const T = {
    type: 0,
    nonce: handleNumber(e[0], "nonce"),
    gasPrice: handleUint(e[1], "gasPrice"),
    gasLimit: handleUint(e[2], "gasLimit"),
    to: handleAddress(e[3]),
    value: handleUint(e[4], "value"),
    data: hexlify(e[5]),
    chainId: BN_0$4
  };
  if (e.length === 6)
    return T;
  const $ = handleUint(e[6], "v"), V = handleUint(e[7], "r"), J = handleUint(e[8], "s");
  if (V === BN_0$4 && J === BN_0$4)
    T.chainId = $;
  else {
    let ee = ($ - BN_35) / BN_2$1;
    ee < BN_0$4 && (ee = BN_0$4), T.chainId = ee, assertArgument(ee !== BN_0$4 || $ === BN_27 || $ === BN_28, "non-canonical legacy v", "v", e[6]), T.signature = Signature$1.from({
      r: zeroPadValue(e[7], 32),
      s: zeroPadValue(e[8], 32),
      v: $
    });
  }
  return T;
}
function _serializeLegacy(C, e) {
  const T = [
    formatNumber(C.nonce, "nonce"),
    formatNumber(C.gasPrice || 0, "gasPrice"),
    formatNumber(C.gasLimit, "gasLimit"),
    C.to || "0x",
    formatNumber(C.value, "value"),
    C.data
  ];
  let $ = BN_0$4;
  if (C.chainId != BN_0$4)
    $ = getBigInt(C.chainId, "tx.chainId"), assertArgument(!e || e.networkV == null || e.legacyChainId === $, "tx.chainId/sig.v mismatch", "sig", e);
  else if (C.signature) {
    const J = C.signature.legacyChainId;
    J != null && ($ = J);
  }
  if (!e)
    return $ !== BN_0$4 && (T.push(toBeArray($)), T.push("0x"), T.push("0x")), encodeRlp(T);
  let V = BigInt(27 + e.yParity);
  return $ !== BN_0$4 ? V = Signature$1.getChainIdV($, e.v) : BigInt(e.v) !== V && assertArgument(!1, "tx.chainId/sig.v mismatch", "sig", e), T.push(toBeArray(V)), T.push(toBeArray(e.r)), T.push(toBeArray(e.s)), encodeRlp(T);
}
function _parseEipSignature(C, e) {
  let T;
  try {
    if (T = handleNumber(e[0], "yParity"), T !== 0 && T !== 1)
      throw new Error("bad yParity");
  } catch {
    assertArgument(!1, "invalid yParity", "yParity", e[0]);
  }
  const $ = zeroPadValue(e[1], 32), V = zeroPadValue(e[2], 32), J = Signature$1.from({ r: $, s: V, yParity: T });
  C.signature = J;
}
function _parseEip1559(C) {
  const e = decodeRlp(getBytes(C).slice(1));
  assertArgument(Array.isArray(e) && (e.length === 9 || e.length === 12), "invalid field count for transaction type: 2", "data", hexlify(C));
  const T = {
    type: 2,
    chainId: handleUint(e[0], "chainId"),
    nonce: handleNumber(e[1], "nonce"),
    maxPriorityFeePerGas: handleUint(e[2], "maxPriorityFeePerGas"),
    maxFeePerGas: handleUint(e[3], "maxFeePerGas"),
    gasPrice: null,
    gasLimit: handleUint(e[4], "gasLimit"),
    to: handleAddress(e[5]),
    value: handleUint(e[6], "value"),
    data: hexlify(e[7]),
    accessList: handleAccessList(e[8], "accessList")
  };
  return e.length === 9 || _parseEipSignature(T, e.slice(9)), T;
}
function _serializeEip1559(C, e) {
  const T = [
    formatNumber(C.chainId, "chainId"),
    formatNumber(C.nonce, "nonce"),
    formatNumber(C.maxPriorityFeePerGas || 0, "maxPriorityFeePerGas"),
    formatNumber(C.maxFeePerGas || 0, "maxFeePerGas"),
    formatNumber(C.gasLimit, "gasLimit"),
    C.to || "0x",
    formatNumber(C.value, "value"),
    C.data,
    formatAccessList(C.accessList || [])
  ];
  return e && (T.push(formatNumber(e.yParity, "yParity")), T.push(toBeArray(e.r)), T.push(toBeArray(e.s))), concat(["0x02", encodeRlp(T)]);
}
function _parseEip2930(C) {
  const e = decodeRlp(getBytes(C).slice(1));
  assertArgument(Array.isArray(e) && (e.length === 8 || e.length === 11), "invalid field count for transaction type: 1", "data", hexlify(C));
  const T = {
    type: 1,
    chainId: handleUint(e[0], "chainId"),
    nonce: handleNumber(e[1], "nonce"),
    gasPrice: handleUint(e[2], "gasPrice"),
    gasLimit: handleUint(e[3], "gasLimit"),
    to: handleAddress(e[4]),
    value: handleUint(e[5], "value"),
    data: hexlify(e[6]),
    accessList: handleAccessList(e[7], "accessList")
  };
  return e.length === 8 || _parseEipSignature(T, e.slice(8)), T;
}
function _serializeEip2930(C, e) {
  const T = [
    formatNumber(C.chainId, "chainId"),
    formatNumber(C.nonce, "nonce"),
    formatNumber(C.gasPrice || 0, "gasPrice"),
    formatNumber(C.gasLimit, "gasLimit"),
    C.to || "0x",
    formatNumber(C.value, "value"),
    C.data,
    formatAccessList(C.accessList || [])
  ];
  return e && (T.push(formatNumber(e.yParity, "recoveryParam")), T.push(toBeArray(e.r)), T.push(toBeArray(e.s))), concat(["0x01", encodeRlp(T)]);
}
function _parseEip4844(C) {
  let e = decodeRlp(getBytes(C).slice(1)), T = "3", $ = null;
  if (e.length === 4 && Array.isArray(e[0])) {
    T = "3 (network format)";
    const J = e[1], ee = e[2], te = e[3];
    assertArgument(Array.isArray(J), "invalid network format: blobs not an array", "fields[1]", J), assertArgument(Array.isArray(ee), "invalid network format: commitments not an array", "fields[2]", ee), assertArgument(Array.isArray(te), "invalid network format: proofs not an array", "fields[3]", te), assertArgument(J.length === ee.length, "invalid network format: blobs/commitments length mismatch", "fields", e), assertArgument(J.length === te.length, "invalid network format: blobs/proofs length mismatch", "fields", e), $ = [];
    for (let re = 0; re < e[1].length; re++)
      $.push({
        data: J[re],
        commitment: ee[re],
        proof: te[re]
      });
    e = e[0];
  }
  assertArgument(Array.isArray(e) && (e.length === 11 || e.length === 14), `invalid field count for transaction type: ${T}`, "data", hexlify(C));
  const V = {
    type: 3,
    chainId: handleUint(e[0], "chainId"),
    nonce: handleNumber(e[1], "nonce"),
    maxPriorityFeePerGas: handleUint(e[2], "maxPriorityFeePerGas"),
    maxFeePerGas: handleUint(e[3], "maxFeePerGas"),
    gasPrice: null,
    gasLimit: handleUint(e[4], "gasLimit"),
    to: handleAddress(e[5]),
    value: handleUint(e[6], "value"),
    data: hexlify(e[7]),
    accessList: handleAccessList(e[8], "accessList"),
    maxFeePerBlobGas: handleUint(e[9], "maxFeePerBlobGas"),
    blobVersionedHashes: e[10]
  };
  $ && (V.blobs = $), assertArgument(V.to != null, `invalid address for transaction type: ${T}`, "data", C), assertArgument(Array.isArray(V.blobVersionedHashes), "invalid blobVersionedHashes: must be an array", "data", C);
  for (let J = 0; J < V.blobVersionedHashes.length; J++)
    assertArgument(isHexString(V.blobVersionedHashes[J], 32), `invalid blobVersionedHash at index ${J}: must be length 32`, "data", C);
  return e.length === 11 || _parseEipSignature(V, e.slice(11)), V;
}
function _serializeEip4844(C, e, T) {
  const $ = [
    formatNumber(C.chainId, "chainId"),
    formatNumber(C.nonce, "nonce"),
    formatNumber(C.maxPriorityFeePerGas || 0, "maxPriorityFeePerGas"),
    formatNumber(C.maxFeePerGas || 0, "maxFeePerGas"),
    formatNumber(C.gasLimit, "gasLimit"),
    C.to || ZeroAddress,
    formatNumber(C.value, "value"),
    C.data,
    formatAccessList(C.accessList || []),
    formatNumber(C.maxFeePerBlobGas || 0, "maxFeePerBlobGas"),
    formatHashes(C.blobVersionedHashes || [], "blobVersionedHashes")
  ];
  return e && ($.push(formatNumber(e.yParity, "yParity")), $.push(toBeArray(e.r)), $.push(toBeArray(e.s)), T) ? concat([
    "0x03",
    encodeRlp([
      $,
      T.map((V) => V.data),
      T.map((V) => V.commitment),
      T.map((V) => V.proof)
    ])
  ]) : concat(["0x03", encodeRlp($)]);
}
var Nr, Ia, Sa, ka, Da, Na, Pa, Ra, La, _a, Ba, ja, Zi, di, Qr, ui, Oa, Bs, Ar;
let Transaction$1 = (Ar = class {
  /**
   *  Creates a new Transaction with default values.
   */
  constructor() {
    Ft(this, Oa);
    Ft(this, Nr);
    Ft(this, Ia);
    Ft(this, Sa);
    Ft(this, ka);
    Ft(this, Da);
    Ft(this, Na);
    Ft(this, Pa);
    Ft(this, Ra);
    Ft(this, La);
    Ft(this, _a);
    Ft(this, Ba);
    Ft(this, ja);
    Ft(this, Zi);
    Ft(this, di);
    Ft(this, Qr);
    Ft(this, ui);
    At(this, Nr, null), At(this, Ia, null), At(this, ka, 0), At(this, Da, BN_0$4), At(this, Na, null), At(this, Pa, null), At(this, Ra, null), At(this, Sa, "0x"), At(this, La, BN_0$4), At(this, _a, BN_0$4), At(this, Ba, null), At(this, ja, null), At(this, Zi, null), At(this, di, null), At(this, ui, null), At(this, Qr, null);
  }
  /**
   *  The transaction type.
   *
   *  If null, the type will be automatically inferred based on
   *  explicit properties.
   */
  get type() {
    return rt(this, Nr);
  }
  set type(e) {
    switch (e) {
      case null:
        At(this, Nr, null);
        break;
      case 0:
      case "legacy":
        At(this, Nr, 0);
        break;
      case 1:
      case "berlin":
      case "eip-2930":
        At(this, Nr, 1);
        break;
      case 2:
      case "london":
      case "eip-1559":
        At(this, Nr, 2);
        break;
      case 3:
      case "cancun":
      case "eip-4844":
        At(this, Nr, 3);
        break;
      default:
        assertArgument(!1, "unsupported transaction type", "type", e);
    }
  }
  /**
   *  The name of the transaction type.
   */
  get typeName() {
    switch (this.type) {
      case 0:
        return "legacy";
      case 1:
        return "eip-2930";
      case 2:
        return "eip-1559";
      case 3:
        return "eip-4844";
    }
    return null;
  }
  /**
   *  The ``to`` address for the transaction or ``null`` if the
   *  transaction is an ``init`` transaction.
   */
  get to() {
    const e = rt(this, Ia);
    return e == null && this.type === 3 ? ZeroAddress : e;
  }
  set to(e) {
    At(this, Ia, e == null ? null : getAddress(e));
  }
  /**
   *  The transaction nonce.
   */
  get nonce() {
    return rt(this, ka);
  }
  set nonce(e) {
    At(this, ka, getNumber(e, "value"));
  }
  /**
   *  The gas limit.
   */
  get gasLimit() {
    return rt(this, Da);
  }
  set gasLimit(e) {
    At(this, Da, getBigInt(e));
  }
  /**
   *  The gas price.
   *
   *  On legacy networks this defines the fee that will be paid. On
   *  EIP-1559 networks, this should be ``null``.
   */
  get gasPrice() {
    const e = rt(this, Na);
    return e == null && (this.type === 0 || this.type === 1) ? BN_0$4 : e;
  }
  set gasPrice(e) {
    At(this, Na, e == null ? null : getBigInt(e, "gasPrice"));
  }
  /**
   *  The maximum priority fee per unit of gas to pay. On legacy
   *  networks this should be ``null``.
   */
  get maxPriorityFeePerGas() {
    const e = rt(this, Pa);
    return e ?? (this.type === 2 || this.type === 3 ? BN_0$4 : null);
  }
  set maxPriorityFeePerGas(e) {
    At(this, Pa, e == null ? null : getBigInt(e, "maxPriorityFeePerGas"));
  }
  /**
   *  The maximum total fee per unit of gas to pay. On legacy
   *  networks this should be ``null``.
   */
  get maxFeePerGas() {
    const e = rt(this, Ra);
    return e ?? (this.type === 2 || this.type === 3 ? BN_0$4 : null);
  }
  set maxFeePerGas(e) {
    At(this, Ra, e == null ? null : getBigInt(e, "maxFeePerGas"));
  }
  /**
   *  The transaction data. For ``init`` transactions this is the
   *  deployment code.
   */
  get data() {
    return rt(this, Sa);
  }
  set data(e) {
    At(this, Sa, hexlify(e));
  }
  /**
   *  The amount of ether (in wei) to send in this transactions.
   */
  get value() {
    return rt(this, La);
  }
  set value(e) {
    At(this, La, getBigInt(e, "value"));
  }
  /**
   *  The chain ID this transaction is valid on.
   */
  get chainId() {
    return rt(this, _a);
  }
  set chainId(e) {
    At(this, _a, getBigInt(e));
  }
  /**
   *  If signed, the signature for this transaction.
   */
  get signature() {
    return rt(this, Ba) || null;
  }
  set signature(e) {
    At(this, Ba, e == null ? null : Signature$1.from(e));
  }
  /**
   *  The access list.
   *
   *  An access list permits discounted (but pre-paid) access to
   *  bytecode and state variable access within contract execution.
   */
  get accessList() {
    const e = rt(this, ja) || null;
    return e ?? (this.type === 1 || this.type === 2 || this.type === 3 ? [] : null);
  }
  set accessList(e) {
    At(this, ja, e == null ? null : accessListify(e));
  }
  /**
   *  The max fee per blob gas for Cancun transactions.
   */
  get maxFeePerBlobGas() {
    const e = rt(this, Zi);
    return e == null && this.type === 3 ? BN_0$4 : e;
  }
  set maxFeePerBlobGas(e) {
    At(this, Zi, e == null ? null : getBigInt(e, "maxFeePerBlobGas"));
  }
  /**
   *  The BLOb versioned hashes for Cancun transactions.
   */
  get blobVersionedHashes() {
    let e = rt(this, di);
    return e == null && this.type === 3 ? [] : e;
  }
  set blobVersionedHashes(e) {
    if (e != null) {
      assertArgument(Array.isArray(e), "blobVersionedHashes must be an Array", "value", e), e = e.slice();
      for (let T = 0; T < e.length; T++)
        assertArgument(isHexString(e[T], 32), "invalid blobVersionedHash", `value[${T}]`, e[T]);
    }
    At(this, di, e);
  }
  /**
   *  The BLObs for the Transaction, if any.
   *
   *  If ``blobs`` is non-``null``, then the [[seriailized]]
   *  will return the network formatted sidecar, otherwise it
   *  will return the standard [[link-eip-2718]] payload. The
   *  [[unsignedSerialized]] is unaffected regardless.
   *
   *  When setting ``blobs``, either fully valid [[Blob]] objects
   *  may be specified (i.e. correctly padded, with correct
   *  committments and proofs) or a raw [[BytesLike]] may
   *  be provided.
   *
   *  If raw [[BytesLike]] are provided, the [[kzg]] property **must**
   *  be already set. The blob will be correctly padded and the
   *  [[KzgLibrary]] will be used to compute the committment and
   *  proof for the blob.
   *
   *  A BLOb is a sequence of field elements, each of which must
   *  be within the BLS field modulo, so some additional processing
   *  may be required to encode arbitrary data to ensure each 32 byte
   *  field is within the valid range.
   *
   *  Setting this automatically populates [[blobVersionedHashes]],
   *  overwriting any existing values. Setting this to ``null``
   *  does **not** remove the [[blobVersionedHashes]], leaving them
   *  present.
   */
  get blobs() {
    return rt(this, ui) == null ? null : rt(this, ui).map((e) => Object.assign({}, e));
  }
  set blobs(e) {
    if (e == null) {
      At(this, ui, null);
      return;
    }
    const T = [], $ = [];
    for (let V = 0; V < e.length; V++) {
      const J = e[V];
      if (isBytesLike(J)) {
        assert$5(rt(this, Qr), "adding a raw blob requires a KZG library", "UNSUPPORTED_OPERATION", {
          operation: "set blobs()"
        });
        let ee = getBytes(J);
        if (assertArgument(ee.length <= BLOB_SIZE, "blob is too large", `blobs[${V}]`, J), ee.length !== BLOB_SIZE) {
          const ie = new Uint8Array(BLOB_SIZE);
          ie.set(ee), ee = ie;
        }
        const te = rt(this, Qr).blobToKzgCommitment(ee), re = hexlify(rt(this, Qr).computeBlobKzgProof(ee, te));
        T.push({
          data: hexlify(ee),
          commitment: hexlify(te),
          proof: re
        }), $.push(getVersionedHash(1, te));
      } else {
        const ee = hexlify(J.commitment);
        T.push({
          data: hexlify(J.data),
          commitment: ee,
          proof: hexlify(J.proof)
        }), $.push(getVersionedHash(1, ee));
      }
    }
    At(this, ui, T), At(this, di, $);
  }
  get kzg() {
    return rt(this, Qr);
  }
  set kzg(e) {
    At(this, Qr, e);
  }
  /**
   *  The transaction hash, if signed. Otherwise, ``null``.
   */
  get hash() {
    return this.signature == null ? null : keccak256(Qt(this, Oa, Bs).call(this, !0, !1));
  }
  /**
   *  The pre-image hash of this transaction.
   *
   *  This is the digest that a [[Signer]] must sign to authorize
   *  this transaction.
   */
  get unsignedHash() {
    return keccak256(this.unsignedSerialized);
  }
  /**
   *  The sending address, if signed. Otherwise, ``null``.
   */
  get from() {
    return this.signature == null ? null : recoverAddress(this.unsignedHash, this.signature);
  }
  /**
   *  The public key of the sender, if signed. Otherwise, ``null``.
   */
  get fromPublicKey() {
    return this.signature == null ? null : SigningKey.recoverPublicKey(this.unsignedHash, this.signature);
  }
  /**
   *  Returns true if signed.
   *
   *  This provides a Type Guard that properties requiring a signed
   *  transaction are non-null.
   */
  isSigned() {
    return this.signature != null;
  }
  /**
   *  The serialized transaction.
   *
   *  This throws if the transaction is unsigned. For the pre-image,
   *  use [[unsignedSerialized]].
   */
  get serialized() {
    return Qt(this, Oa, Bs).call(this, !0, !0);
  }
  /**
   *  The transaction pre-image.
   *
   *  The hash of this is the digest which needs to be signed to
   *  authorize this transaction.
   */
  get unsignedSerialized() {
    return Qt(this, Oa, Bs).call(this, !1, !1);
  }
  /**
   *  Return the most "likely" type; currently the highest
   *  supported transaction type.
   */
  inferType() {
    const e = this.inferTypes();
    return e.indexOf(2) >= 0 ? 2 : e.pop();
  }
  /**
   *  Validates the explicit properties and returns a list of compatible
   *  transaction types.
   */
  inferTypes() {
    const e = this.gasPrice != null, T = this.maxFeePerGas != null || this.maxPriorityFeePerGas != null, $ = this.accessList != null, V = rt(this, Zi) != null || rt(this, di);
    this.maxFeePerGas != null && this.maxPriorityFeePerGas != null && assert$5(this.maxFeePerGas >= this.maxPriorityFeePerGas, "priorityFee cannot be more than maxFee", "BAD_DATA", { value: this }), assert$5(!T || this.type !== 0 && this.type !== 1, "transaction type cannot have maxFeePerGas or maxPriorityFeePerGas", "BAD_DATA", { value: this }), assert$5(this.type !== 0 || !$, "legacy transaction cannot have accessList", "BAD_DATA", { value: this });
    const J = [];
    return this.type != null ? J.push(this.type) : T ? J.push(2) : e ? (J.push(1), $ || J.push(0)) : $ ? (J.push(1), J.push(2)) : (V && this.to || (J.push(0), J.push(1), J.push(2)), J.push(3)), J.sort(), J;
  }
  /**
   *  Returns true if this transaction is a legacy transaction (i.e.
   *  ``type === 0``).
   *
   *  This provides a Type Guard that the related properties are
   *  non-null.
   */
  isLegacy() {
    return this.type === 0;
  }
  /**
   *  Returns true if this transaction is berlin hardform transaction (i.e.
   *  ``type === 1``).
   *
   *  This provides a Type Guard that the related properties are
   *  non-null.
   */
  isBerlin() {
    return this.type === 1;
  }
  /**
   *  Returns true if this transaction is london hardform transaction (i.e.
   *  ``type === 2``).
   *
   *  This provides a Type Guard that the related properties are
   *  non-null.
   */
  isLondon() {
    return this.type === 2;
  }
  /**
   *  Returns true if this transaction is an [[link-eip-4844]] BLOB
   *  transaction.
   *
   *  This provides a Type Guard that the related properties are
   *  non-null.
   */
  isCancun() {
    return this.type === 3;
  }
  /**
   *  Create a copy of this transaciton.
   */
  clone() {
    return Ar.from(this);
  }
  /**
   *  Return a JSON-friendly object.
   */
  toJSON() {
    const e = (T) => T == null ? null : T.toString();
    return {
      type: this.type,
      to: this.to,
      //            from: this.from,
      data: this.data,
      nonce: this.nonce,
      gasLimit: e(this.gasLimit),
      gasPrice: e(this.gasPrice),
      maxPriorityFeePerGas: e(this.maxPriorityFeePerGas),
      maxFeePerGas: e(this.maxFeePerGas),
      value: e(this.value),
      chainId: e(this.chainId),
      sig: this.signature ? this.signature.toJSON() : null,
      accessList: this.accessList
    };
  }
  /**
   *  Create a **Transaction** from a serialized transaction or a
   *  Transaction-like object.
   */
  static from(e) {
    if (e == null)
      return new Ar();
    if (typeof e == "string") {
      const $ = getBytes(e);
      if ($[0] >= 127)
        return Ar.from(_parseLegacy($));
      switch ($[0]) {
        case 1:
          return Ar.from(_parseEip2930($));
        case 2:
          return Ar.from(_parseEip1559($));
        case 3:
          return Ar.from(_parseEip4844($));
      }
      assert$5(!1, "unsupported transaction type", "UNSUPPORTED_OPERATION", { operation: "from" });
    }
    const T = new Ar();
    return e.type != null && (T.type = e.type), e.to != null && (T.to = e.to), e.nonce != null && (T.nonce = e.nonce), e.gasLimit != null && (T.gasLimit = e.gasLimit), e.gasPrice != null && (T.gasPrice = e.gasPrice), e.maxPriorityFeePerGas != null && (T.maxPriorityFeePerGas = e.maxPriorityFeePerGas), e.maxFeePerGas != null && (T.maxFeePerGas = e.maxFeePerGas), e.maxFeePerBlobGas != null && (T.maxFeePerBlobGas = e.maxFeePerBlobGas), e.data != null && (T.data = e.data), e.value != null && (T.value = e.value), e.chainId != null && (T.chainId = e.chainId), e.signature != null && (T.signature = Signature$1.from(e.signature)), e.accessList != null && (T.accessList = e.accessList), e.blobVersionedHashes != null && (T.blobVersionedHashes = e.blobVersionedHashes), e.kzg != null && (T.kzg = e.kzg), e.blobs != null && (T.blobs = e.blobs), e.hash != null && (assertArgument(T.isSigned(), "unsigned transaction cannot define '.hash'", "tx", e), assertArgument(T.hash === e.hash, "hash mismatch", "tx", e)), e.from != null && (assertArgument(T.isSigned(), "unsigned transaction cannot define '.from'", "tx", e), assertArgument(T.from.toLowerCase() === (e.from || "").toLowerCase(), "from mismatch", "tx", e)), T;
  }
}, Nr = new WeakMap(), Ia = new WeakMap(), Sa = new WeakMap(), ka = new WeakMap(), Da = new WeakMap(), Na = new WeakMap(), Pa = new WeakMap(), Ra = new WeakMap(), La = new WeakMap(), _a = new WeakMap(), Ba = new WeakMap(), ja = new WeakMap(), Zi = new WeakMap(), di = new WeakMap(), Qr = new WeakMap(), ui = new WeakMap(), Oa = new WeakSet(), Bs = function(e, T) {
  assert$5(!e || this.signature != null, "cannot serialize unsigned transaction; maybe you meant .unsignedSerialized", "UNSUPPORTED_OPERATION", { operation: ".serialized" });
  const $ = e ? this.signature : null;
  switch (this.inferType()) {
    case 0:
      return _serializeLegacy(this, $);
    case 1:
      return _serializeEip2930(this, $);
    case 2:
      return _serializeEip1559(this, $);
    case 3:
      return _serializeEip4844(this, $, T ? this.blobs : null);
  }
  assert$5(!1, "unsupported transaction type", "UNSUPPORTED_OPERATION", { operation: ".serialized" });
}, Ar);
function hashMessage(C) {
  return typeof C == "string" && (C = toUtf8Bytes(C)), keccak256(concat([
    toUtf8Bytes(MessagePrefix),
    toUtf8Bytes(String(C.length)),
    C
  ]));
}
const padding$1 = new Uint8Array(32);
padding$1.fill(0);
const BN__1 = BigInt(-1), BN_0$3 = BigInt(0), BN_1 = BigInt(1), BN_MAX_UINT256 = BigInt("0xffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff");
function hexPadRight(C) {
  const e = getBytes(C), T = e.length % 32;
  return T ? concat([e, padding$1.slice(T)]) : hexlify(e);
}
const hexTrue = toBeHex(BN_1, 32), hexFalse = toBeHex(BN_0$3, 32), domainFieldTypes = {
  name: "string",
  version: "string",
  chainId: "uint256",
  verifyingContract: "address",
  salt: "bytes32"
}, domainFieldNames = [
  "name",
  "version",
  "chainId",
  "verifyingContract",
  "salt"
];
function checkString(C) {
  return function(e) {
    return assertArgument(typeof e == "string", `invalid domain value for ${JSON.stringify(C)}`, `domain.${C}`, e), e;
  };
}
const domainChecks = {
  name: checkString("name"),
  version: checkString("version"),
  chainId: function(C) {
    const e = getBigInt(C, "domain.chainId");
    return assertArgument(e >= 0, "invalid chain ID", "domain.chainId", C), Number.isSafeInteger(e) ? Number(e) : toQuantity(e);
  },
  verifyingContract: function(C) {
    try {
      return getAddress(C).toLowerCase();
    } catch {
    }
    assertArgument(!1, 'invalid domain value "verifyingContract"', "domain.verifyingContract", C);
  },
  salt: function(C) {
    const e = getBytes(C, "domain.salt");
    return assertArgument(e.length === 32, 'invalid domain value "salt"', "domain.salt", C), hexlify(e);
  }
};
function getBaseEncoder(C) {
  {
    const e = C.match(/^(u?)int(\d+)$/);
    if (e) {
      const T = e[1] === "", $ = parseInt(e[2]);
      assertArgument($ % 8 === 0 && $ !== 0 && $ <= 256 && e[2] === String($), "invalid numeric width", "type", C);
      const V = mask$3(BN_MAX_UINT256, T ? $ - 1 : $), J = T ? (V + BN_1) * BN__1 : BN_0$3;
      return function(ee) {
        const te = getBigInt(ee, "value");
        return assertArgument(te >= J && te <= V, `value out-of-bounds for ${C}`, "value", te), toBeHex(T ? toTwos(te, 256) : te, 32);
      };
    }
  }
  {
    const e = C.match(/^bytes(\d+)$/);
    if (e) {
      const T = parseInt(e[1]);
      return assertArgument(T !== 0 && T <= 32 && e[1] === String(T), "invalid bytes width", "type", C), function($) {
        const V = getBytes($);
        return assertArgument(V.length === T, `invalid length for ${C}`, "value", $), hexPadRight($);
      };
    }
  }
  switch (C) {
    case "address":
      return function(e) {
        return zeroPadValue(getAddress(e), 32);
      };
    case "bool":
      return function(e) {
        return e ? hexTrue : hexFalse;
      };
    case "bytes":
      return function(e) {
        return keccak256(e);
      };
    case "string":
      return function(e) {
        return id(e);
      };
  }
  return null;
}
function encodeType(C, e) {
  return `${C}(${e.map(({ name: T, type: $ }) => $ + " " + T).join(",")})`;
}
function splitArray(C) {
  const e = C.match(/^([^\x5b]*)((\x5b\d*\x5d)*)(\x5b(\d*)\x5d)$/);
  return e ? {
    base: e[1],
    index: e[2] + e[4],
    array: {
      base: e[1],
      prefix: e[1] + e[2],
      count: e[5] ? parseInt(e[5]) : -1
    }
  } : { base: C };
}
var ys, Xr, Fa, Hs, Mo;
const ur = class ur {
  /**
   *  Create a new **TypedDataEncoder** for %%types%%.
   *
   *  This performs all necessary checking that types are valid and
   *  do not violate the [[link-eip-712]] structural constraints as
   *  well as computes the [[primaryType]].
   */
  constructor(e) {
    Ft(this, Hs);
    /**
     *  The primary type for the structured [[types]].
     *
     *  This is derived automatically from the [[types]], since no
     *  recursion is possible, once the DAG for the types is consturcted
     *  internally, the primary type must be the only remaining type with
     *  no parent nodes.
     */
    tt(this, "primaryType");
    Ft(this, ys);
    Ft(this, Xr);
    Ft(this, Fa);
    At(this, Xr, /* @__PURE__ */ new Map()), At(this, Fa, /* @__PURE__ */ new Map());
    const T = /* @__PURE__ */ new Map(), $ = /* @__PURE__ */ new Map(), V = /* @__PURE__ */ new Map(), J = {};
    Object.keys(e).forEach((re) => {
      J[re] = e[re].map(({ name: ie, type: se }) => {
        let { base: de, index: ue } = splitArray(se);
        return de === "int" && !e.int && (de = "int256"), de === "uint" && !e.uint && (de = "uint256"), { name: ie, type: de + (ue || "") };
      }), T.set(re, /* @__PURE__ */ new Set()), $.set(re, []), V.set(re, /* @__PURE__ */ new Set());
    }), At(this, ys, JSON.stringify(J));
    for (const re in J) {
      const ie = /* @__PURE__ */ new Set();
      for (const se of J[re]) {
        assertArgument(!ie.has(se.name), `duplicate variable name ${JSON.stringify(se.name)} in ${JSON.stringify(re)}`, "types", e), ie.add(se.name);
        const de = splitArray(se.type).base;
        assertArgument(de !== re, `circular type reference to ${JSON.stringify(de)}`, "types", e), !getBaseEncoder(de) && (assertArgument($.has(de), `unknown type ${JSON.stringify(de)}`, "types", e), $.get(de).push(re), T.get(re).add(de));
      }
    }
    const ee = Array.from($.keys()).filter((re) => $.get(re).length === 0);
    assertArgument(ee.length !== 0, "missing primary type", "types", e), assertArgument(ee.length === 1, `ambiguous primary types or unused types: ${ee.map((re) => JSON.stringify(re)).join(", ")}`, "types", e), defineProperties(this, { primaryType: ee[0] });
    function te(re, ie) {
      assertArgument(!ie.has(re), `circular type reference to ${JSON.stringify(re)}`, "types", e), ie.add(re);
      for (const se of T.get(re))
        if ($.has(se)) {
          te(se, ie);
          for (const de of ie)
            V.get(de).add(se);
        }
      ie.delete(re);
    }
    te(this.primaryType, /* @__PURE__ */ new Set());
    for (const [re, ie] of V) {
      const se = Array.from(ie);
      se.sort(), rt(this, Xr).set(re, encodeType(re, J[re]) + se.map((de) => encodeType(de, J[de])).join(""));
    }
  }
  /**
   *  The types.
   */
  get types() {
    return JSON.parse(rt(this, ys));
  }
  /**
   *  Returnthe encoder for the specific %%type%%.
   */
  getEncoder(e) {
    let T = rt(this, Fa).get(e);
    return T || (T = Qt(this, Hs, Mo).call(this, e), rt(this, Fa).set(e, T)), T;
  }
  /**
   *  Return the full type for %%name%%.
   */
  encodeType(e) {
    const T = rt(this, Xr).get(e);
    return assertArgument(T, `unknown type: ${JSON.stringify(e)}`, "name", e), T;
  }
  /**
   *  Return the encoded %%value%% for the %%type%%.
   */
  encodeData(e, T) {
    return this.getEncoder(e)(T);
  }
  /**
   *  Returns the hash of %%value%% for the type of %%name%%.
   */
  hashStruct(e, T) {
    return keccak256(this.encodeData(e, T));
  }
  /**
   *  Return the fulled encoded %%value%% for the [[types]].
   */
  encode(e) {
    return this.encodeData(this.primaryType, e);
  }
  /**
   *  Return the hash of the fully encoded %%value%% for the [[types]].
   */
  hash(e) {
    return this.hashStruct(this.primaryType, e);
  }
  /**
   *  @_ignore:
   */
  _visit(e, T, $) {
    if (getBaseEncoder(e))
      return $(e, T);
    const V = splitArray(e).array;
    if (V)
      return assertArgument(V.count === -1 || V.count === T.length, `array length mismatch; expected length ${V.count}`, "value", T), T.map((ee) => this._visit(V.prefix, ee, $));
    const J = this.types[e];
    if (J)
      return J.reduce((ee, { name: te, type: re }) => (ee[te] = this._visit(re, T[te], $), ee), {});
    assertArgument(!1, `unknown type: ${e}`, "type", e);
  }
  /**
   *  Call %%calback%% for each value in %%value%%, passing the type and
   *  component within %%value%%.
   *
   *  This is useful for replacing addresses or other transformation that
   *  may be desired on each component, based on its type.
   */
  visit(e, T) {
    return this._visit(this.primaryType, e, T);
  }
  /**
   *  Create a new **TypedDataEncoder** for %%types%%.
   */
  static from(e) {
    return new ur(e);
  }
  /**
   *  Return the primary type for %%types%%.
   */
  static getPrimaryType(e) {
    return ur.from(e).primaryType;
  }
  /**
   *  Return the hashed struct for %%value%% using %%types%% and %%name%%.
   */
  static hashStruct(e, T, $) {
    return ur.from(T).hashStruct(e, $);
  }
  /**
   *  Return the domain hash for %%domain%%.
   */
  static hashDomain(e) {
    const T = [];
    for (const $ in e) {
      if (e[$] == null)
        continue;
      const V = domainFieldTypes[$];
      assertArgument(V, `invalid typed-data domain key: ${JSON.stringify($)}`, "domain", e), T.push({ name: $, type: V });
    }
    return T.sort(($, V) => domainFieldNames.indexOf($.name) - domainFieldNames.indexOf(V.name)), ur.hashStruct("EIP712Domain", { EIP712Domain: T }, e);
  }
  /**
   *  Return the fully encoded [[link-eip-712]] %%value%% for %%types%% with %%domain%%.
   */
  static encode(e, T, $) {
    return concat([
      "0x1901",
      ur.hashDomain(e),
      ur.from(T).hash($)
    ]);
  }
  /**
   *  Return the hash of the fully encoded [[link-eip-712]] %%value%% for %%types%% with %%domain%%.
   */
  static hash(e, T, $) {
    return keccak256(ur.encode(e, T, $));
  }
  // Replaces all address types with ENS names with their looked up address
  /**
   * Resolves to the value from resolving all addresses in %%value%% for
   * %%types%% and the %%domain%%.
   */
  static async resolveNames(e, T, $, V) {
    e = Object.assign({}, e);
    for (const te in e)
      e[te] == null && delete e[te];
    const J = {};
    e.verifyingContract && !isHexString(e.verifyingContract, 20) && (J[e.verifyingContract] = "0x");
    const ee = ur.from(T);
    ee.visit($, (te, re) => (te === "address" && !isHexString(re, 20) && (J[re] = "0x"), re));
    for (const te in J)
      J[te] = await V(te);
    return e.verifyingContract && J[e.verifyingContract] && (e.verifyingContract = J[e.verifyingContract]), $ = ee.visit($, (te, re) => te === "address" && J[re] ? J[re] : re), { domain: e, value: $ };
  }
  /**
   *  Returns the JSON-encoded payload expected by nodes which implement
   *  the JSON-RPC [[link-eip-712]] method.
   */
  static getPayload(e, T, $) {
    ur.hashDomain(e);
    const V = {}, J = [];
    domainFieldNames.forEach((re) => {
      const ie = e[re];
      ie != null && (V[re] = domainChecks[re](ie), J.push({ name: re, type: domainFieldTypes[re] }));
    });
    const ee = ur.from(T);
    T = ee.types;
    const te = Object.assign({}, T);
    return assertArgument(te.EIP712Domain == null, "types must not contain EIP712Domain type", "types.EIP712Domain", T), te.EIP712Domain = J, ee.encode($), {
      types: te,
      domain: V,
      primaryType: ee.primaryType,
      message: ee.visit($, (re, ie) => {
        if (re.match(/^bytes(\d*)/))
          return hexlify(getBytes(ie));
        if (re.match(/^u?int/))
          return getBigInt(ie).toString();
        switch (re) {
          case "address":
            return ie.toLowerCase();
          case "bool":
            return !!ie;
          case "string":
            return assertArgument(typeof ie == "string", "invalid string", "value", ie), ie;
        }
        assertArgument(!1, "unsupported type", "type", re);
      })
    };
  }
};
ys = new WeakMap(), Xr = new WeakMap(), Fa = new WeakMap(), Hs = new WeakSet(), Mo = function(e) {
  {
    const V = getBaseEncoder(e);
    if (V)
      return V;
  }
  const T = splitArray(e).array;
  if (T) {
    const V = T.prefix, J = this.getEncoder(V);
    return (ee) => {
      assertArgument(T.count === -1 || T.count === ee.length, `array length mismatch; expected length ${T.count}`, "value", ee);
      let te = ee.map(J);
      return rt(this, Xr).has(V) && (te = te.map(keccak256)), keccak256(concat(te));
    };
  }
  const $ = this.types[e];
  if ($) {
    const V = id(rt(this, Xr).get(e));
    return (J) => {
      const ee = $.map(({ name: te, type: re }) => {
        const ie = this.getEncoder(re)(J[te]);
        return rt(this, Xr).has(re) ? keccak256(ie) : ie;
      });
      return ee.unshift(V), concat(ee);
    };
  }
  assertArgument(!1, `unknown type: ${e}`, "type", e);
};
let TypedDataEncoder = ur;
function setify(C) {
  const e = /* @__PURE__ */ new Set();
  return C.forEach((T) => e.add(T)), Object.freeze(e);
}
const _kwVisibDeploy = "external public payable override", KwVisibDeploy = setify(_kwVisibDeploy.split(" ")), _kwVisib = "constant external internal payable private public pure view override", KwVisib = setify(_kwVisib.split(" ")), _kwTypes = "constructor error event fallback function receive struct", KwTypes = setify(_kwTypes.split(" ")), _kwModifiers = "calldata memory storage payable indexed", KwModifiers = setify(_kwModifiers.split(" ")), _kwOther = "tuple returns", _keywords = [_kwTypes, _kwModifiers, _kwOther, _kwVisib].join(" "), Keywords = setify(_keywords.split(" ")), SimpleTokens = {
  "(": "OPEN_PAREN",
  ")": "CLOSE_PAREN",
  "[": "OPEN_BRACKET",
  "]": "CLOSE_BRACKET",
  ",": "COMMA",
  "@": "AT"
}, regexWhitespacePrefix = new RegExp("^(\\s*)"), regexNumberPrefix = new RegExp("^([0-9]+)"), regexIdPrefix = new RegExp("^([a-zA-Z$_][a-zA-Z0-9$_]*)"), regexId = new RegExp("^([a-zA-Z$_][a-zA-Z0-9$_]*)$"), regexType = new RegExp("^(address|bool|bytes([0-9]*)|string|u?int([0-9]*))$");
var qn, Er, xs, ao;
const Gs = class Gs {
  constructor(e) {
    Ft(this, xs);
    Ft(this, qn);
    Ft(this, Er);
    At(this, qn, 0), At(this, Er, e.slice());
  }
  get offset() {
    return rt(this, qn);
  }
  get length() {
    return rt(this, Er).length - rt(this, qn);
  }
  clone() {
    return new Gs(rt(this, Er));
  }
  reset() {
    At(this, qn, 0);
  }
  // Pops and returns the value of the next token, if it is a keyword in allowed; throws if out of tokens
  popKeyword(e) {
    const T = this.peek();
    if (T.type !== "KEYWORD" || !e.has(T.text))
      throw new Error(`expected keyword ${T.text}`);
    return this.pop().text;
  }
  // Pops and returns the value of the next token if it is `type`; throws if out of tokens
  popType(e) {
    if (this.peek().type !== e) {
      const T = this.peek();
      throw new Error(`expected ${e}; got ${T.type} ${JSON.stringify(T.text)}`);
    }
    return this.pop().text;
  }
  // Pops and returns a "(" TOKENS ")"
  popParen() {
    const e = this.peek();
    if (e.type !== "OPEN_PAREN")
      throw new Error("bad start");
    const T = Qt(this, xs, ao).call(this, rt(this, qn) + 1, e.match + 1);
    return At(this, qn, e.match + 1), T;
  }
  // Pops and returns the items within "(" ITEM1 "," ITEM2 "," ... ")"
  popParams() {
    const e = this.peek();
    if (e.type !== "OPEN_PAREN")
      throw new Error("bad start");
    const T = [];
    for (; rt(this, qn) < e.match - 1; ) {
      const $ = this.peek().linkNext;
      T.push(Qt(this, xs, ao).call(this, rt(this, qn) + 1, $)), At(this, qn, $);
    }
    return At(this, qn, e.match + 1), T;
  }
  // Returns the top Token, throwing if out of tokens
  peek() {
    if (rt(this, qn) >= rt(this, Er).length)
      throw new Error("out-of-bounds");
    return rt(this, Er)[rt(this, qn)];
  }
  // Returns the next value, if it is a keyword in `allowed`
  peekKeyword(e) {
    const T = this.peekType("KEYWORD");
    return T != null && e.has(T) ? T : null;
  }
  // Returns the value of the next token if it is `type`
  peekType(e) {
    if (this.length === 0)
      return null;
    const T = this.peek();
    return T.type === e ? T.text : null;
  }
  // Returns the next token; throws if out of tokens
  pop() {
    const e = this.peek();
    return ss(this, qn)._++, e;
  }
  toString() {
    const e = [];
    for (let T = rt(this, qn); T < rt(this, Er).length; T++) {
      const $ = rt(this, Er)[T];
      e.push(`${$.type}:${$.text}`);
    }
    return `<TokenString ${e.join(" ")}>`;
  }
};
qn = new WeakMap(), Er = new WeakMap(), xs = new WeakSet(), ao = function(e = 0, T = 0) {
  return new Gs(rt(this, Er).slice(e, T).map(($) => Object.freeze(Object.assign({}, $, {
    match: $.match - e,
    linkBack: $.linkBack - e,
    linkNext: $.linkNext - e
  }))));
};
let TokenString = Gs;
function lex(C) {
  const e = [], T = (ee) => {
    const te = J < C.length ? JSON.stringify(C[J]) : "$EOI";
    throw new Error(`invalid token ${te} at ${J}: ${ee}`);
  };
  let $ = [], V = [], J = 0;
  for (; J < C.length; ) {
    let ee = C.substring(J), te = ee.match(regexWhitespacePrefix);
    te && (J += te[1].length, ee = C.substring(J));
    const re = { depth: $.length, linkBack: -1, linkNext: -1, match: -1, type: "", text: "", offset: J, value: -1 };
    e.push(re);
    let ie = SimpleTokens[ee[0]] || "";
    if (ie) {
      if (re.type = ie, re.text = ee[0], J++, ie === "OPEN_PAREN")
        $.push(e.length - 1), V.push(e.length - 1);
      else if (ie == "CLOSE_PAREN")
        $.length === 0 && T("no matching open bracket"), re.match = $.pop(), e[re.match].match = e.length - 1, re.depth--, re.linkBack = V.pop(), e[re.linkBack].linkNext = e.length - 1;
      else if (ie === "COMMA")
        re.linkBack = V.pop(), e[re.linkBack].linkNext = e.length - 1, V.push(e.length - 1);
      else if (ie === "OPEN_BRACKET")
        re.type = "BRACKET";
      else if (ie === "CLOSE_BRACKET") {
        let se = e.pop().text;
        if (e.length > 0 && e[e.length - 1].type === "NUMBER") {
          const de = e.pop().text;
          se = de + se, e[e.length - 1].value = getNumber(de);
        }
        if (e.length === 0 || e[e.length - 1].type !== "BRACKET")
          throw new Error("missing opening bracket");
        e[e.length - 1].text += se;
      }
      continue;
    }
    if (te = ee.match(regexIdPrefix), te) {
      if (re.text = te[1], J += re.text.length, Keywords.has(re.text)) {
        re.type = "KEYWORD";
        continue;
      }
      if (re.text.match(regexType)) {
        re.type = "TYPE";
        continue;
      }
      re.type = "ID";
      continue;
    }
    if (te = ee.match(regexNumberPrefix), te) {
      re.text = te[1], re.type = "NUMBER", J += re.text.length;
      continue;
    }
    throw new Error(`unexpected token ${JSON.stringify(ee[0])} at position ${J}`);
  }
  return new TokenString(e.map((ee) => Object.freeze(ee)));
}
function allowSingle(C, e) {
  let T = [];
  for (const $ in e.keys())
    C.has($) && T.push($);
  if (T.length > 1)
    throw new Error(`conflicting types: ${T.join(", ")}`);
}
function consumeName(C, e) {
  if (e.peekKeyword(KwTypes)) {
    const T = e.pop().text;
    if (T !== C)
      throw new Error(`expected ${C}, got ${T}`);
  }
  return e.popType("ID");
}
function consumeKeywords(C, e) {
  const T = /* @__PURE__ */ new Set();
  for (; ; ) {
    const $ = C.peekType("KEYWORD");
    if ($ == null || e && !e.has($))
      break;
    if (C.pop(), T.has($))
      throw new Error(`duplicate keywords: ${JSON.stringify($)}`);
    T.add($);
  }
  return Object.freeze(T);
}
function consumeMutability(C) {
  let e = consumeKeywords(C, KwVisib);
  return allowSingle(e, setify("constant payable nonpayable".split(" "))), allowSingle(e, setify("pure view payable nonpayable".split(" "))), e.has("view") ? "view" : e.has("pure") ? "pure" : e.has("payable") ? "payable" : e.has("nonpayable") ? "nonpayable" : e.has("constant") ? "view" : "nonpayable";
}
function consumeParams(C, e) {
  return C.popParams().map((T) => ParamType.from(T, e));
}
function consumeGas(C) {
  if (C.peekType("AT")) {
    if (C.pop(), C.peekType("NUMBER"))
      return getBigInt(C.pop().text);
    throw new Error("invalid gas");
  }
  return null;
}
function consumeEoi(C) {
  if (C.length)
    throw new Error(`unexpected tokens at offset ${C.offset}: ${C.toString()}`);
}
const regexArrayType = new RegExp(/^(.*)\[([0-9]*)\]$/);
function verifyBasicType(C) {
  const e = C.match(regexType);
  if (assertArgument(e, "invalid type", "type", C), C === "uint")
    return "uint256";
  if (C === "int")
    return "int256";
  if (e[2]) {
    const T = parseInt(e[2]);
    assertArgument(T !== 0 && T <= 32, "invalid bytes length", "type", C);
  } else if (e[3]) {
    const T = parseInt(e[3]);
    assertArgument(T !== 0 && T <= 256 && T % 8 === 0, "invalid numeric width", "type", C);
  }
  return C;
}
const _guard$2 = {}, internal$1 = Symbol.for("_ethers_internal"), ParamTypeInternal = "_ParamTypeInternal", ErrorFragmentInternal = "_ErrorInternal", EventFragmentInternal = "_EventInternal", ConstructorFragmentInternal = "_ConstructorInternal", FallbackFragmentInternal = "_FallbackInternal", FunctionFragmentInternal = "_FunctionInternal", StructFragmentInternal = "_StructInternal";
var $a, js;
const fr = class fr {
  /**
   *  @private
   */
  constructor(e, T, $, V, J, ee, te, re) {
    Ft(this, $a);
    /**
     *  The local name of the parameter (or ``""`` if unbound)
     */
    tt(this, "name");
    /**
     *  The fully qualified type (e.g. ``"address"``, ``"tuple(address)"``,
     *  ``"uint256[3][]"``)
     */
    tt(this, "type");
    /**
     *  The base type (e.g. ``"address"``, ``"tuple"``, ``"array"``)
     */
    tt(this, "baseType");
    /**
     *  True if the parameters is indexed.
     *
     *  For non-indexable types this is ``null``.
     */
    tt(this, "indexed");
    /**
     *  The components for the tuple.
     *
     *  For non-tuple types this is ``null``.
     */
    tt(this, "components");
    /**
     *  The array length, or ``-1`` for dynamic-lengthed arrays.
     *
     *  For non-array types this is ``null``.
     */
    tt(this, "arrayLength");
    /**
     *  The type of each child in the array.
     *
     *  For non-array types this is ``null``.
     */
    tt(this, "arrayChildren");
    if (assertPrivate(e, _guard$2, "ParamType"), Object.defineProperty(this, internal$1, { value: ParamTypeInternal }), ee && (ee = Object.freeze(ee.slice())), V === "array") {
      if (te == null || re == null)
        throw new Error("");
    } else if (te != null || re != null)
      throw new Error("");
    if (V === "tuple") {
      if (ee == null)
        throw new Error("");
    } else if (ee != null)
      throw new Error("");
    defineProperties(this, {
      name: T,
      type: $,
      baseType: V,
      indexed: J,
      components: ee,
      arrayLength: te,
      arrayChildren: re
    });
  }
  /**
   *  Return a string representation of this type.
   *
   *  For example,
   *
   *  ``sighash" => "(uint256,address)"``
   *
   *  ``"minimal" => "tuple(uint256,address) indexed"``
   *
   *  ``"full" => "tuple(uint256 foo, address bar) indexed baz"``
   */
  format(e) {
    if (e == null && (e = "sighash"), e === "json") {
      const $ = this.name || "";
      if (this.isArray()) {
        const J = JSON.parse(this.arrayChildren.format("json"));
        return J.name = $, J.type += `[${this.arrayLength < 0 ? "" : String(this.arrayLength)}]`, JSON.stringify(J);
      }
      const V = {
        type: this.baseType === "tuple" ? "tuple" : this.type,
        name: $
      };
      return typeof this.indexed == "boolean" && (V.indexed = this.indexed), this.isTuple() && (V.components = this.components.map((J) => JSON.parse(J.format(e)))), JSON.stringify(V);
    }
    let T = "";
    return this.isArray() ? (T += this.arrayChildren.format(e), T += `[${this.arrayLength < 0 ? "" : String(this.arrayLength)}]`) : this.isTuple() ? T += "(" + this.components.map(($) => $.format(e)).join(e === "full" ? ", " : ",") + ")" : T += this.type, e !== "sighash" && (this.indexed === !0 && (T += " indexed"), e === "full" && this.name && (T += " " + this.name)), T;
  }
  /**
   *  Returns true if %%this%% is an Array type.
   *
   *  This provides a type gaurd ensuring that [[arrayChildren]]
   *  and [[arrayLength]] are non-null.
   */
  isArray() {
    return this.baseType === "array";
  }
  /**
   *  Returns true if %%this%% is a Tuple type.
   *
   *  This provides a type gaurd ensuring that [[components]]
   *  is non-null.
   */
  isTuple() {
    return this.baseType === "tuple";
  }
  /**
   *  Returns true if %%this%% is an Indexable type.
   *
   *  This provides a type gaurd ensuring that [[indexed]]
   *  is non-null.
   */
  isIndexable() {
    return this.indexed != null;
  }
  /**
   *  Walks the **ParamType** with %%value%%, calling %%process%%
   *  on each type, destructing the %%value%% recursively.
   */
  walk(e, T) {
    if (this.isArray()) {
      if (!Array.isArray(e))
        throw new Error("invalid array value");
      if (this.arrayLength !== -1 && e.length !== this.arrayLength)
        throw new Error("array is wrong length");
      const $ = this;
      return e.map((V) => $.arrayChildren.walk(V, T));
    }
    if (this.isTuple()) {
      if (!Array.isArray(e))
        throw new Error("invalid tuple value");
      if (e.length !== this.components.length)
        throw new Error("array is wrong length");
      const $ = this;
      return e.map((V, J) => $.components[J].walk(V, T));
    }
    return T(this.type, e);
  }
  /**
   *  Walks the **ParamType** with %%value%%, asynchronously calling
   *  %%process%% on each type, destructing the %%value%% recursively.
   *
   *  This can be used to resolve ENS names by walking and resolving each
   *  ``"address"`` type.
   */
  async walkAsync(e, T) {
    const $ = [], V = [e];
    return Qt(this, $a, js).call(this, $, e, T, (J) => {
      V[0] = J;
    }), $.length && await Promise.all($), V[0];
  }
  /**
   *  Creates a new **ParamType** for %%obj%%.
   *
   *  If %%allowIndexed%% then the ``indexed`` keyword is permitted,
   *  otherwise the ``indexed`` keyword will throw an error.
   */
  static from(e, T) {
    if (fr.isParamType(e))
      return e;
    if (typeof e == "string")
      try {
        return fr.from(lex(e), T);
      } catch {
        assertArgument(!1, "invalid param type", "obj", e);
      }
    else if (e instanceof TokenString) {
      let te = "", re = "", ie = null;
      consumeKeywords(e, setify(["tuple"])).has("tuple") || e.peekType("OPEN_PAREN") ? (re = "tuple", ie = e.popParams().map((me) => fr.from(me)), te = `tuple(${ie.map((me) => me.format()).join(",")})`) : (te = verifyBasicType(e.popType("TYPE")), re = te);
      let se = null, de = null;
      for (; e.length && e.peekType("BRACKET"); ) {
        const me = e.pop();
        se = new fr(_guard$2, "", te, re, null, ie, de, se), de = me.value, te += me.text, re = "array", ie = null;
      }
      let ue = null;
      if (consumeKeywords(e, KwModifiers).has("indexed")) {
        if (!T)
          throw new Error("");
        ue = !0;
      }
      const he = e.peekType("ID") ? e.pop().text : "";
      if (e.length)
        throw new Error("leftover tokens");
      return new fr(_guard$2, he, te, re, ue, ie, de, se);
    }
    const $ = e.name;
    assertArgument(!$ || typeof $ == "string" && $.match(regexId), "invalid name", "obj.name", $);
    let V = e.indexed;
    V != null && (assertArgument(T, "parameter cannot be indexed", "obj.indexed", e.indexed), V = !!V);
    let J = e.type, ee = J.match(regexArrayType);
    if (ee) {
      const te = parseInt(ee[2] || "-1"), re = fr.from({
        type: ee[1],
        components: e.components
      });
      return new fr(_guard$2, $ || "", J, "array", V, null, te, re);
    }
    if (J === "tuple" || J.startsWith(
      "tuple("
      /* fix: ) */
    ) || J.startsWith(
      "("
      /* fix: ) */
    )) {
      const te = e.components != null ? e.components.map((ie) => fr.from(ie)) : null;
      return new fr(_guard$2, $ || "", J, "tuple", V, te, null, null);
    }
    return J = verifyBasicType(e.type), new fr(_guard$2, $ || "", J, J, V, null, null, null);
  }
  /**
   *  Returns true if %%value%% is a **ParamType**.
   */
  static isParamType(e) {
    return e && e[internal$1] === ParamTypeInternal;
  }
};
$a = new WeakSet(), js = function(e, T, $, V) {
  if (this.isArray()) {
    if (!Array.isArray(T))
      throw new Error("invalid array value");
    if (this.arrayLength !== -1 && T.length !== this.arrayLength)
      throw new Error("array is wrong length");
    const ee = this.arrayChildren, te = T.slice();
    te.forEach((re, ie) => {
      var se;
      Qt(se = ee, $a, js).call(se, e, re, $, (de) => {
        te[ie] = de;
      });
    }), V(te);
    return;
  }
  if (this.isTuple()) {
    const ee = this.components;
    let te;
    if (Array.isArray(T))
      te = T.slice();
    else {
      if (T == null || typeof T != "object")
        throw new Error("invalid tuple value");
      te = ee.map((re) => {
        if (!re.name)
          throw new Error("cannot use object value with unnamed components");
        if (!(re.name in T))
          throw new Error(`missing value for component ${re.name}`);
        return T[re.name];
      });
    }
    if (te.length !== this.components.length)
      throw new Error("array is wrong length");
    te.forEach((re, ie) => {
      var se;
      Qt(se = ee[ie], $a, js).call(se, e, re, $, (de) => {
        te[ie] = de;
      });
    }), V(te);
    return;
  }
  const J = $(this.type, T);
  J.then ? e.push(async function() {
    V(await J);
  }()) : V(J);
};
let ParamType = fr;
class Fragment {
  /**
   *  @private
   */
  constructor(e, T, $) {
    /**
     *  The type of the fragment.
     */
    tt(this, "type");
    /**
     *  The inputs for the fragment.
     */
    tt(this, "inputs");
    assertPrivate(e, _guard$2, "Fragment"), $ = Object.freeze($.slice()), defineProperties(this, { type: T, inputs: $ });
  }
  /**
   *  Creates a new **Fragment** for %%obj%%, wich can be any supported
   *  ABI frgament type.
   */
  static from(e) {
    if (typeof e == "string") {
      try {
        Fragment.from(JSON.parse(e));
      } catch {
      }
      return Fragment.from(lex(e));
    }
    if (e instanceof TokenString)
      switch (e.peekKeyword(KwTypes)) {
        case "constructor":
          return ConstructorFragment.from(e);
        case "error":
          return ErrorFragment.from(e);
        case "event":
          return EventFragment.from(e);
        case "fallback":
        case "receive":
          return FallbackFragment.from(e);
        case "function":
          return FunctionFragment.from(e);
        case "struct":
          return StructFragment.from(e);
      }
    else if (typeof e == "object") {
      switch (e.type) {
        case "constructor":
          return ConstructorFragment.from(e);
        case "error":
          return ErrorFragment.from(e);
        case "event":
          return EventFragment.from(e);
        case "fallback":
        case "receive":
          return FallbackFragment.from(e);
        case "function":
          return FunctionFragment.from(e);
        case "struct":
          return StructFragment.from(e);
      }
      assert$5(!1, `unsupported type: ${e.type}`, "UNSUPPORTED_OPERATION", {
        operation: "Fragment.from"
      });
    }
    assertArgument(!1, "unsupported frgament object", "obj", e);
  }
  /**
   *  Returns true if %%value%% is a [[ConstructorFragment]].
   */
  static isConstructor(e) {
    return ConstructorFragment.isFragment(e);
  }
  /**
   *  Returns true if %%value%% is an [[ErrorFragment]].
   */
  static isError(e) {
    return ErrorFragment.isFragment(e);
  }
  /**
   *  Returns true if %%value%% is an [[EventFragment]].
   */
  static isEvent(e) {
    return EventFragment.isFragment(e);
  }
  /**
   *  Returns true if %%value%% is a [[FunctionFragment]].
   */
  static isFunction(e) {
    return FunctionFragment.isFragment(e);
  }
  /**
   *  Returns true if %%value%% is a [[StructFragment]].
   */
  static isStruct(e) {
    return StructFragment.isFragment(e);
  }
}
class NamedFragment extends Fragment {
  /**
   *  @private
   */
  constructor(T, $, V, J) {
    super(T, $, J);
    /**
     *  The name of the fragment.
     */
    tt(this, "name");
    assertArgument(typeof V == "string" && V.match(regexId), "invalid identifier", "name", V), J = Object.freeze(J.slice()), defineProperties(this, { name: V });
  }
}
function joinParams(C, e) {
  return "(" + e.map((T) => T.format(C)).join(C === "full" ? ", " : ",") + ")";
}
class ErrorFragment extends NamedFragment {
  /**
   *  @private
   */
  constructor(e, T, $) {
    super(e, "error", T, $), Object.defineProperty(this, internal$1, { value: ErrorFragmentInternal });
  }
  /**
   *  The Custom Error selector.
   */
  get selector() {
    return id(this.format("sighash")).substring(0, 10);
  }
  /**
   *  Returns a string representation of this fragment as %%format%%.
   */
  format(e) {
    if (e == null && (e = "sighash"), e === "json")
      return JSON.stringify({
        type: "error",
        name: this.name,
        inputs: this.inputs.map(($) => JSON.parse($.format(e)))
      });
    const T = [];
    return e !== "sighash" && T.push("error"), T.push(this.name + joinParams(e, this.inputs)), T.join(" ");
  }
  /**
   *  Returns a new **ErrorFragment** for %%obj%%.
   */
  static from(e) {
    if (ErrorFragment.isFragment(e))
      return e;
    if (typeof e == "string")
      return ErrorFragment.from(lex(e));
    if (e instanceof TokenString) {
      const T = consumeName("error", e), $ = consumeParams(e);
      return consumeEoi(e), new ErrorFragment(_guard$2, T, $);
    }
    return new ErrorFragment(_guard$2, e.name, e.inputs ? e.inputs.map(ParamType.from) : []);
  }
  /**
   *  Returns ``true`` and provides a type guard if %%value%% is an
   *  **ErrorFragment**.
   */
  static isFragment(e) {
    return e && e[internal$1] === ErrorFragmentInternal;
  }
}
class EventFragment extends NamedFragment {
  /**
   *  @private
   */
  constructor(T, $, V, J) {
    super(T, "event", $, V);
    /**
     *  Whether this event is anonymous.
     */
    tt(this, "anonymous");
    Object.defineProperty(this, internal$1, { value: EventFragmentInternal }), defineProperties(this, { anonymous: J });
  }
  /**
   *  The Event topic hash.
   */
  get topicHash() {
    return id(this.format("sighash"));
  }
  /**
   *  Returns a string representation of this event as %%format%%.
   */
  format(T) {
    if (T == null && (T = "sighash"), T === "json")
      return JSON.stringify({
        type: "event",
        anonymous: this.anonymous,
        name: this.name,
        inputs: this.inputs.map((V) => JSON.parse(V.format(T)))
      });
    const $ = [];
    return T !== "sighash" && $.push("event"), $.push(this.name + joinParams(T, this.inputs)), T !== "sighash" && this.anonymous && $.push("anonymous"), $.join(" ");
  }
  /**
   *  Return the topic hash for an event with %%name%% and %%params%%.
   */
  static getTopicHash(T, $) {
    return $ = ($ || []).map((J) => ParamType.from(J)), new EventFragment(_guard$2, T, $, !1).topicHash;
  }
  /**
   *  Returns a new **EventFragment** for %%obj%%.
   */
  static from(T) {
    if (EventFragment.isFragment(T))
      return T;
    if (typeof T == "string")
      try {
        return EventFragment.from(lex(T));
      } catch {
        assertArgument(!1, "invalid event fragment", "obj", T);
      }
    else if (T instanceof TokenString) {
      const $ = consumeName("event", T), V = consumeParams(T, !0), J = !!consumeKeywords(T, setify(["anonymous"])).has("anonymous");
      return consumeEoi(T), new EventFragment(_guard$2, $, V, J);
    }
    return new EventFragment(_guard$2, T.name, T.inputs ? T.inputs.map(($) => ParamType.from($, !0)) : [], !!T.anonymous);
  }
  /**
   *  Returns ``true`` and provides a type guard if %%value%% is an
   *  **EventFragment**.
   */
  static isFragment(T) {
    return T && T[internal$1] === EventFragmentInternal;
  }
}
class ConstructorFragment extends Fragment {
  /**
   *  @private
   */
  constructor(T, $, V, J, ee) {
    super(T, $, V);
    /**
     *  Whether the constructor can receive an endowment.
     */
    tt(this, "payable");
    /**
     *  The recommended gas limit for deployment or ``null``.
     */
    tt(this, "gas");
    Object.defineProperty(this, internal$1, { value: ConstructorFragmentInternal }), defineProperties(this, { payable: J, gas: ee });
  }
  /**
   *  Returns a string representation of this constructor as %%format%%.
   */
  format(T) {
    if (assert$5(T != null && T !== "sighash", "cannot format a constructor for sighash", "UNSUPPORTED_OPERATION", { operation: "format(sighash)" }), T === "json")
      return JSON.stringify({
        type: "constructor",
        stateMutability: this.payable ? "payable" : "undefined",
        payable: this.payable,
        gas: this.gas != null ? this.gas : void 0,
        inputs: this.inputs.map((V) => JSON.parse(V.format(T)))
      });
    const $ = [`constructor${joinParams(T, this.inputs)}`];
    return this.payable && $.push("payable"), this.gas != null && $.push(`@${this.gas.toString()}`), $.join(" ");
  }
  /**
   *  Returns a new **ConstructorFragment** for %%obj%%.
   */
  static from(T) {
    if (ConstructorFragment.isFragment(T))
      return T;
    if (typeof T == "string")
      try {
        return ConstructorFragment.from(lex(T));
      } catch {
        assertArgument(!1, "invalid constuctor fragment", "obj", T);
      }
    else if (T instanceof TokenString) {
      consumeKeywords(T, setify(["constructor"]));
      const $ = consumeParams(T), V = !!consumeKeywords(T, KwVisibDeploy).has("payable"), J = consumeGas(T);
      return consumeEoi(T), new ConstructorFragment(_guard$2, "constructor", $, V, J);
    }
    return new ConstructorFragment(_guard$2, "constructor", T.inputs ? T.inputs.map(ParamType.from) : [], !!T.payable, T.gas != null ? T.gas : null);
  }
  /**
   *  Returns ``true`` and provides a type guard if %%value%% is a
   *  **ConstructorFragment**.
   */
  static isFragment(T) {
    return T && T[internal$1] === ConstructorFragmentInternal;
  }
}
class FallbackFragment extends Fragment {
  constructor(T, $, V) {
    super(T, "fallback", $);
    /**
     *  If the function can be sent value during invocation.
     */
    tt(this, "payable");
    Object.defineProperty(this, internal$1, { value: FallbackFragmentInternal }), defineProperties(this, { payable: V });
  }
  /**
   *  Returns a string representation of this fallback as %%format%%.
   */
  format(T) {
    const $ = this.inputs.length === 0 ? "receive" : "fallback";
    if (T === "json") {
      const V = this.payable ? "payable" : "nonpayable";
      return JSON.stringify({ type: $, stateMutability: V });
    }
    return `${$}()${this.payable ? " payable" : ""}`;
  }
  /**
   *  Returns a new **FallbackFragment** for %%obj%%.
   */
  static from(T) {
    if (FallbackFragment.isFragment(T))
      return T;
    if (typeof T == "string")
      try {
        return FallbackFragment.from(lex(T));
      } catch {
        assertArgument(!1, "invalid fallback fragment", "obj", T);
      }
    else if (T instanceof TokenString) {
      const $ = T.toString(), V = T.peekKeyword(setify(["fallback", "receive"]));
      if (assertArgument(V, "type must be fallback or receive", "obj", $), T.popKeyword(setify(["fallback", "receive"])) === "receive") {
        const re = consumeParams(T);
        return assertArgument(re.length === 0, "receive cannot have arguments", "obj.inputs", re), consumeKeywords(T, setify(["payable"])), consumeEoi(T), new FallbackFragment(_guard$2, [], !0);
      }
      let ee = consumeParams(T);
      ee.length ? assertArgument(ee.length === 1 && ee[0].type === "bytes", "invalid fallback inputs", "obj.inputs", ee.map((re) => re.format("minimal")).join(", ")) : ee = [ParamType.from("bytes")];
      const te = consumeMutability(T);
      if (assertArgument(te === "nonpayable" || te === "payable", "fallback cannot be constants", "obj.stateMutability", te), consumeKeywords(T, setify(["returns"])).has("returns")) {
        const re = consumeParams(T);
        assertArgument(re.length === 1 && re[0].type === "bytes", "invalid fallback outputs", "obj.outputs", re.map((ie) => ie.format("minimal")).join(", "));
      }
      return consumeEoi(T), new FallbackFragment(_guard$2, ee, te === "payable");
    }
    if (T.type === "receive")
      return new FallbackFragment(_guard$2, [], !0);
    if (T.type === "fallback") {
      const $ = [ParamType.from("bytes")], V = T.stateMutability === "payable";
      return new FallbackFragment(_guard$2, $, V);
    }
    assertArgument(!1, "invalid fallback description", "obj", T);
  }
  /**
   *  Returns ``true`` and provides a type guard if %%value%% is a
   *  **FallbackFragment**.
   */
  static isFragment(T) {
    return T && T[internal$1] === FallbackFragmentInternal;
  }
}
class FunctionFragment extends NamedFragment {
  /**
   *  @private
   */
  constructor(T, $, V, J, ee, te) {
    super(T, "function", $, J);
    /**
     *  If the function is constant (e.g. ``pure`` or ``view`` functions).
     */
    tt(this, "constant");
    /**
     *  The returned types for the result of calling this function.
     */
    tt(this, "outputs");
    /**
     *  The state mutability (e.g. ``payable``, ``nonpayable``, ``view``
     *  or ``pure``)
     */
    tt(this, "stateMutability");
    /**
     *  If the function can be sent value during invocation.
     */
    tt(this, "payable");
    /**
     *  The recommended gas limit to send when calling this function.
     */
    tt(this, "gas");
    Object.defineProperty(this, internal$1, { value: FunctionFragmentInternal }), ee = Object.freeze(ee.slice()), defineProperties(this, { constant: V === "view" || V === "pure", gas: te, outputs: ee, payable: V === "payable", stateMutability: V });
  }
  /**
   *  The Function selector.
   */
  get selector() {
    return id(this.format("sighash")).substring(0, 10);
  }
  /**
   *  Returns a string representation of this function as %%format%%.
   */
  format(T) {
    if (T == null && (T = "sighash"), T === "json")
      return JSON.stringify({
        type: "function",
        name: this.name,
        constant: this.constant,
        stateMutability: this.stateMutability !== "nonpayable" ? this.stateMutability : void 0,
        payable: this.payable,
        gas: this.gas != null ? this.gas : void 0,
        inputs: this.inputs.map((V) => JSON.parse(V.format(T))),
        outputs: this.outputs.map((V) => JSON.parse(V.format(T)))
      });
    const $ = [];
    return T !== "sighash" && $.push("function"), $.push(this.name + joinParams(T, this.inputs)), T !== "sighash" && (this.stateMutability !== "nonpayable" && $.push(this.stateMutability), this.outputs && this.outputs.length && ($.push("returns"), $.push(joinParams(T, this.outputs))), this.gas != null && $.push(`@${this.gas.toString()}`)), $.join(" ");
  }
  /**
   *  Return the selector for a function with %%name%% and %%params%%.
   */
  static getSelector(T, $) {
    return $ = ($ || []).map((J) => ParamType.from(J)), new FunctionFragment(_guard$2, T, "view", $, [], null).selector;
  }
  /**
   *  Returns a new **FunctionFragment** for %%obj%%.
   */
  static from(T) {
    if (FunctionFragment.isFragment(T))
      return T;
    if (typeof T == "string")
      try {
        return FunctionFragment.from(lex(T));
      } catch {
        assertArgument(!1, "invalid function fragment", "obj", T);
      }
    else if (T instanceof TokenString) {
      const V = consumeName("function", T), J = consumeParams(T), ee = consumeMutability(T);
      let te = [];
      consumeKeywords(T, setify(["returns"])).has("returns") && (te = consumeParams(T));
      const re = consumeGas(T);
      return consumeEoi(T), new FunctionFragment(_guard$2, V, ee, J, te, re);
    }
    let $ = T.stateMutability;
    return $ == null && ($ = "payable", typeof T.constant == "boolean" ? ($ = "view", T.constant || ($ = "payable", typeof T.payable == "boolean" && !T.payable && ($ = "nonpayable"))) : typeof T.payable == "boolean" && !T.payable && ($ = "nonpayable")), new FunctionFragment(_guard$2, T.name, $, T.inputs ? T.inputs.map(ParamType.from) : [], T.outputs ? T.outputs.map(ParamType.from) : [], T.gas != null ? T.gas : null);
  }
  /**
   *  Returns ``true`` and provides a type guard if %%value%% is a
   *  **FunctionFragment**.
   */
  static isFragment(T) {
    return T && T[internal$1] === FunctionFragmentInternal;
  }
}
class StructFragment extends NamedFragment {
  /**
   *  @private
   */
  constructor(e, T, $) {
    super(e, "struct", T, $), Object.defineProperty(this, internal$1, { value: StructFragmentInternal });
  }
  /**
   *  Returns a string representation of this struct as %%format%%.
   */
  format() {
    throw new Error("@TODO");
  }
  /**
   *  Returns a new **StructFragment** for %%obj%%.
   */
  static from(e) {
    if (typeof e == "string")
      try {
        return StructFragment.from(lex(e));
      } catch {
        assertArgument(!1, "invalid struct fragment", "obj", e);
      }
    else if (e instanceof TokenString) {
      const T = consumeName("struct", e), $ = consumeParams(e);
      return consumeEoi(e), new StructFragment(_guard$2, T, $);
    }
    return new StructFragment(_guard$2, e.name, e.inputs ? e.inputs.map(ParamType.from) : []);
  }
  // @TODO: fix this return type
  /**
   *  Returns ``true`` and provides a type guard if %%value%% is a
   *  **StructFragment**.
   */
  static isFragment(e) {
    return e && e[internal$1] === StructFragmentInternal;
  }
}
const PanicReasons$1 = /* @__PURE__ */ new Map();
PanicReasons$1.set(0, "GENERIC_PANIC");
PanicReasons$1.set(1, "ASSERT_FALSE");
PanicReasons$1.set(17, "OVERFLOW");
PanicReasons$1.set(18, "DIVIDE_BY_ZERO");
PanicReasons$1.set(33, "ENUM_RANGE_ERROR");
PanicReasons$1.set(34, "BAD_STORAGE_DATA");
PanicReasons$1.set(49, "STACK_UNDERFLOW");
PanicReasons$1.set(50, "ARRAY_RANGE_ERROR");
PanicReasons$1.set(65, "OUT_OF_MEMORY");
PanicReasons$1.set(81, "UNINITIALIZED_FUNCTION_CALL");
const paramTypeBytes = new RegExp(/^bytes([0-9]*)$/), paramTypeNumber = new RegExp(/^(u?int)([0-9]*)$/);
let defaultCoder = null, defaultMaxInflation = 1024;
function getBuiltinCallException(C, e, T, $) {
  let V = "missing revert data", J = null;
  const ee = null;
  let te = null;
  if (T) {
    V = "execution reverted";
    const ie = getBytes(T);
    if (T = hexlify(T), ie.length === 0)
      V += " (no data present; likely require(false) occurred", J = "require(false)";
    else if (ie.length % 32 !== 4)
      V += " (could not decode reason; invalid data length)";
    else if (hexlify(ie.slice(0, 4)) === "0x08c379a0")
      try {
        J = $.decode(["string"], ie.slice(4))[0], te = {
          signature: "Error(string)",
          name: "Error",
          args: [J]
        }, V += `: ${JSON.stringify(J)}`;
      } catch {
        V += " (could not decode reason; invalid string data)";
      }
    else if (hexlify(ie.slice(0, 4)) === "0x4e487b71")
      try {
        const se = Number($.decode(["uint256"], ie.slice(4))[0]);
        te = {
          signature: "Panic(uint256)",
          name: "Panic",
          args: [se]
        }, J = `Panic due to ${PanicReasons$1.get(se) || "UNKNOWN"}(${se})`, V += `: ${J}`;
      } catch {
        V += " (could not decode panic code)";
      }
    else
      V += " (unknown custom error)";
  }
  const re = {
    to: e.to ? getAddress(e.to) : null,
    data: e.data || "0x"
  };
  return e.from && (re.from = getAddress(e.from)), makeError(V, "CALL_EXCEPTION", {
    action: C,
    data: T,
    reason: J,
    transaction: re,
    invocation: ee,
    revert: te
  });
}
var fi, ua;
const Vs = class Vs {
  constructor() {
    Ft(this, fi);
  }
  /**
   *  Get the default values for the given %%types%%.
   *
   *  For example, a ``uint`` is by default ``0`` and ``bool``
   *  is by default ``false``.
   */
  getDefaultValue(e) {
    const T = e.map((V) => Qt(this, fi, ua).call(this, ParamType.from(V)));
    return new TupleCoder(T, "_").defaultValue();
  }
  /**
   *  Encode the %%values%% as the %%types%% into ABI data.
   *
   *  @returns DataHexstring
   */
  encode(e, T) {
    assertArgumentCount(T.length, e.length, "types/values length mismatch");
    const $ = e.map((ee) => Qt(this, fi, ua).call(this, ParamType.from(ee))), V = new TupleCoder($, "_"), J = new Writer();
    return V.encode(J, T), J.data;
  }
  /**
   *  Decode the ABI %%data%% as the %%types%% into values.
   *
   *  If %%loose%% decoding is enabled, then strict padding is
   *  not enforced. Some older versions of Solidity incorrectly
   *  padded event data emitted from ``external`` functions.
   */
  decode(e, T, $) {
    const V = e.map((ee) => Qt(this, fi, ua).call(this, ParamType.from(ee)));
    return new TupleCoder(V, "_").decode(new Reader(T, $, defaultMaxInflation));
  }
  static _setDefaultMaxInflation(e) {
    assertArgument(typeof e == "number" && Number.isInteger(e), "invalid defaultMaxInflation factor", "value", e), defaultMaxInflation = e;
  }
  /**
   *  Returns the shared singleton instance of a default [[AbiCoder]].
   *
   *  On the first call, the instance is created internally.
   */
  static defaultAbiCoder() {
    return defaultCoder == null && (defaultCoder = new Vs()), defaultCoder;
  }
  /**
   *  Returns an ethers-compatible [[CallExceptionError]] Error for the given
   *  result %%data%% for the [[CallExceptionAction]] %%action%% against
   *  the Transaction %%tx%%.
   */
  static getBuiltinCallException(e, T, $) {
    return getBuiltinCallException(e, T, $, Vs.defaultAbiCoder());
  }
};
fi = new WeakSet(), ua = function(e) {
  if (e.isArray())
    return new ArrayCoder(Qt(this, fi, ua).call(this, e.arrayChildren), e.arrayLength, e.name);
  if (e.isTuple())
    return new TupleCoder(e.components.map(($) => Qt(this, fi, ua).call(this, $)), e.name);
  switch (e.baseType) {
    case "address":
      return new AddressCoder(e.name);
    case "bool":
      return new BooleanCoder(e.name);
    case "string":
      return new StringCoder(e.name);
    case "bytes":
      return new BytesCoder(e.name);
    case "":
      return new NullCoder(e.name);
  }
  let T = e.type.match(paramTypeNumber);
  if (T) {
    let $ = parseInt(T[2] || "256");
    return assertArgument($ !== 0 && $ <= 256 && $ % 8 === 0, "invalid " + T[1] + " bit length", "param", e), new NumberCoder($ / 8, T[1] === "int", e.name);
  }
  if (T = e.type.match(paramTypeBytes), T) {
    let $ = parseInt(T[1]);
    return assertArgument($ !== 0 && $ <= 32, "invalid bytes length", "param", e), new FixedBytesCoder($, e.name);
  }
  assertArgument(!1, "invalid type", "type", e.type);
};
let AbiCoder = Vs;
class LogDescription {
  /**
   *  @_ignore:
   */
  constructor(e, T, $) {
    /**
     *  The matching fragment for the ``topic0``.
     */
    tt(this, "fragment");
    /**
     *  The name of the Event.
     */
    tt(this, "name");
    /**
     *  The full Event signature.
     */
    tt(this, "signature");
    /**
     *  The topic hash for the Event.
     */
    tt(this, "topic");
    /**
     *  The arguments passed into the Event with ``emit``.
     */
    tt(this, "args");
    const V = e.name, J = e.format();
    defineProperties(this, {
      fragment: e,
      name: V,
      signature: J,
      topic: T,
      args: $
    });
  }
}
class TransactionDescription {
  /**
   *  @_ignore:
   */
  constructor(e, T, $, V) {
    /**
     *  The matching fragment from the transaction ``data``.
     */
    tt(this, "fragment");
    /**
     *  The name of the Function from the transaction ``data``.
     */
    tt(this, "name");
    /**
     *  The arguments passed to the Function from the transaction ``data``.
     */
    tt(this, "args");
    /**
     *  The full Function signature from the transaction ``data``.
     */
    tt(this, "signature");
    /**
     *  The selector for the Function from the transaction ``data``.
     */
    tt(this, "selector");
    /**
     *  The ``value`` (in wei) from the transaction.
     */
    tt(this, "value");
    const J = e.name, ee = e.format();
    defineProperties(this, {
      fragment: e,
      name: J,
      args: $,
      signature: ee,
      selector: T,
      value: V
    });
  }
}
class ErrorDescription {
  /**
   *  @_ignore:
   */
  constructor(e, T, $) {
    /**
     *  The matching fragment.
     */
    tt(this, "fragment");
    /**
     *  The name of the Error.
     */
    tt(this, "name");
    /**
     *  The arguments passed to the Error with ``revert``.
     */
    tt(this, "args");
    /**
     *  The full Error signature.
     */
    tt(this, "signature");
    /**
     *  The selector for the Error.
     */
    tt(this, "selector");
    const V = e.name, J = e.format();
    defineProperties(this, {
      fragment: e,
      name: V,
      args: $,
      signature: J,
      selector: T
    });
  }
}
class Indexed {
  /**
   *  @_ignore:
   */
  constructor(e) {
    /**
     *  The ``keccak256`` of the value logged.
     */
    tt(this, "hash");
    /**
     *  @_ignore:
     */
    tt(this, "_isIndexed");
    defineProperties(this, { hash: e, _isIndexed: !0 });
  }
  /**
   *  Returns ``true`` if %%value%% is an **Indexed**.
   *
   *  This provides a Type Guard for property access.
   */
  static isIndexed(e) {
    return !!(e && e._isIndexed);
  }
}
const PanicReasons = {
  0: "generic panic",
  1: "assert(false)",
  17: "arithmetic overflow",
  18: "division or modulo by zero",
  33: "enum overflow",
  34: "invalid encoded storage byte array accessed",
  49: "out-of-bounds array access; popping on an empty array",
  50: "out-of-bounds access of an array or bytesN",
  65: "out of memory",
  81: "uninitialized function"
}, BuiltinErrors = {
  "0x08c379a0": {
    signature: "Error(string)",
    name: "Error",
    inputs: ["string"],
    reason: (C) => `reverted with reason string ${JSON.stringify(C)}`
  },
  "0x4e487b71": {
    signature: "Panic(uint256)",
    name: "Panic",
    inputs: ["uint256"],
    reason: (C) => {
      let e = "unknown panic code";
      return C >= 0 && C <= 255 && PanicReasons[C.toString()] && (e = PanicReasons[C.toString()]), `reverted with panic code 0x${C.toString(16)} (${e})`;
    }
  }
};
var Pr, Rr, Lr, Xn, Ur, Os, Fs;
const Bi = class Bi {
  /**
   *  Create a new Interface for the %%fragments%%.
   */
  constructor(e) {
    Ft(this, Ur);
    /**
     *  All the Contract ABI members (i.e. methods, events, errors, etc).
     */
    tt(this, "fragments");
    /**
     *  The Contract constructor.
     */
    tt(this, "deploy");
    /**
     *  The Fallback method, if any.
     */
    tt(this, "fallback");
    /**
     *  If receiving ether is supported.
     */
    tt(this, "receive");
    Ft(this, Pr);
    Ft(this, Rr);
    Ft(this, Lr);
    //    #structs: Map<string, StructFragment>;
    Ft(this, Xn);
    let T = [];
    typeof e == "string" ? T = JSON.parse(e) : T = e, At(this, Lr, /* @__PURE__ */ new Map()), At(this, Pr, /* @__PURE__ */ new Map()), At(this, Rr, /* @__PURE__ */ new Map());
    const $ = [];
    for (const ee of T)
      try {
        $.push(Fragment.from(ee));
      } catch (te) {
        console.log(`[Warning] Invalid Fragment ${JSON.stringify(ee)}:`, te.message);
      }
    defineProperties(this, {
      fragments: Object.freeze($)
    });
    let V = null, J = !1;
    At(this, Xn, this.getAbiCoder()), this.fragments.forEach((ee, te) => {
      let re;
      switch (ee.type) {
        case "constructor":
          if (this.deploy) {
            console.log("duplicate definition - constructor");
            return;
          }
          defineProperties(this, { deploy: ee });
          return;
        case "fallback":
          ee.inputs.length === 0 ? J = !0 : (assertArgument(!V || ee.payable !== V.payable, "conflicting fallback fragments", `fragments[${te}]`, ee), V = ee, J = V.payable);
          return;
        case "function":
          re = rt(this, Lr);
          break;
        case "event":
          re = rt(this, Rr);
          break;
        case "error":
          re = rt(this, Pr);
          break;
        default:
          return;
      }
      const ie = ee.format();
      re.has(ie) || re.set(ie, ee);
    }), this.deploy || defineProperties(this, {
      deploy: ConstructorFragment.from("constructor()")
    }), defineProperties(this, { fallback: V, receive: J });
  }
  /**
   *  Returns the entire Human-Readable ABI, as an array of
   *  signatures, optionally as %%minimal%% strings, which
   *  removes parameter names and unneceesary spaces.
   */
  format(e) {
    const T = e ? "minimal" : "full";
    return this.fragments.map((V) => V.format(T));
  }
  /**
   *  Return the JSON-encoded ABI. This is the format Solidiy
   *  returns.
   */
  formatJson() {
    const e = this.fragments.map((T) => T.format("json"));
    return JSON.stringify(e.map((T) => JSON.parse(T)));
  }
  /**
   *  The ABI coder that will be used to encode and decode binary
   *  data.
   */
  getAbiCoder() {
    return AbiCoder.defaultAbiCoder();
  }
  /**
   *  Get the function name for %%key%%, which may be a function selector,
   *  function name or function signature that belongs to the ABI.
   */
  getFunctionName(e) {
    const T = Qt(this, Ur, Os).call(this, e, null, !1);
    return assertArgument(T, "no matching function", "key", e), T.name;
  }
  /**
   *  Returns true if %%key%% (a function selector, function name or
   *  function signature) is present in the ABI.
   *
   *  In the case of a function name, the name may be ambiguous, so
   *  accessing the [[FunctionFragment]] may require refinement.
   */
  hasFunction(e) {
    return !!Qt(this, Ur, Os).call(this, e, null, !1);
  }
  /**
   *  Get the [[FunctionFragment]] for %%key%%, which may be a function
   *  selector, function name or function signature that belongs to the ABI.
   *
   *  If %%values%% is provided, it will use the Typed API to handle
   *  ambiguous cases where multiple functions match by name.
   *
   *  If the %%key%% and %%values%% do not refine to a single function in
   *  the ABI, this will throw.
   */
  getFunction(e, T) {
    return Qt(this, Ur, Os).call(this, e, T || null, !0);
  }
  /**
   *  Iterate over all functions, calling %%callback%%, sorted by their name.
   */
  forEachFunction(e) {
    const T = Array.from(rt(this, Lr).keys());
    T.sort(($, V) => $.localeCompare(V));
    for (let $ = 0; $ < T.length; $++) {
      const V = T[$];
      e(rt(this, Lr).get(V), $);
    }
  }
  /**
   *  Get the event name for %%key%%, which may be a topic hash,
   *  event name or event signature that belongs to the ABI.
   */
  getEventName(e) {
    const T = Qt(this, Ur, Fs).call(this, e, null, !1);
    return assertArgument(T, "no matching event", "key", e), T.name;
  }
  /**
   *  Returns true if %%key%% (an event topic hash, event name or
   *  event signature) is present in the ABI.
   *
   *  In the case of an event name, the name may be ambiguous, so
   *  accessing the [[EventFragment]] may require refinement.
   */
  hasEvent(e) {
    return !!Qt(this, Ur, Fs).call(this, e, null, !1);
  }
  /**
   *  Get the [[EventFragment]] for %%key%%, which may be a topic hash,
   *  event name or event signature that belongs to the ABI.
   *
   *  If %%values%% is provided, it will use the Typed API to handle
   *  ambiguous cases where multiple events match by name.
   *
   *  If the %%key%% and %%values%% do not refine to a single event in
   *  the ABI, this will throw.
   */
  getEvent(e, T) {
    return Qt(this, Ur, Fs).call(this, e, T || null, !0);
  }
  /**
   *  Iterate over all events, calling %%callback%%, sorted by their name.
   */
  forEachEvent(e) {
    const T = Array.from(rt(this, Rr).keys());
    T.sort(($, V) => $.localeCompare(V));
    for (let $ = 0; $ < T.length; $++) {
      const V = T[$];
      e(rt(this, Rr).get(V), $);
    }
  }
  /**
   *  Get the [[ErrorFragment]] for %%key%%, which may be an error
   *  selector, error name or error signature that belongs to the ABI.
   *
   *  If %%values%% is provided, it will use the Typed API to handle
   *  ambiguous cases where multiple errors match by name.
   *
   *  If the %%key%% and %%values%% do not refine to a single error in
   *  the ABI, this will throw.
   */
  getError(e, T) {
    if (isHexString(e)) {
      const V = e.toLowerCase();
      if (BuiltinErrors[V])
        return ErrorFragment.from(BuiltinErrors[V].signature);
      for (const J of rt(this, Pr).values())
        if (V === J.selector)
          return J;
      return null;
    }
    if (e.indexOf("(") === -1) {
      const V = [];
      for (const [J, ee] of rt(this, Pr))
        J.split(
          "("
          /* fix:) */
        )[0] === e && V.push(ee);
      if (V.length === 0)
        return e === "Error" ? ErrorFragment.from("error Error(string)") : e === "Panic" ? ErrorFragment.from("error Panic(uint256)") : null;
      if (V.length > 1) {
        const J = V.map((ee) => JSON.stringify(ee.format())).join(", ");
        assertArgument(!1, `ambiguous error description (i.e. ${J})`, "name", e);
      }
      return V[0];
    }
    if (e = ErrorFragment.from(e).format(), e === "Error(string)")
      return ErrorFragment.from("error Error(string)");
    if (e === "Panic(uint256)")
      return ErrorFragment.from("error Panic(uint256)");
    const $ = rt(this, Pr).get(e);
    return $ || null;
  }
  /**
   *  Iterate over all errors, calling %%callback%%, sorted by their name.
   */
  forEachError(e) {
    const T = Array.from(rt(this, Pr).keys());
    T.sort(($, V) => $.localeCompare(V));
    for (let $ = 0; $ < T.length; $++) {
      const V = T[$];
      e(rt(this, Pr).get(V), $);
    }
  }
  // Get the 4-byte selector used by Solidity to identify a function
  /*
  getSelector(fragment: ErrorFragment | FunctionFragment): string {
      if (typeof(fragment) === "string") {
          const matches: Array<Fragment> = [ ];
  
          try { matches.push(this.getFunction(fragment)); } catch (error) { }
          try { matches.push(this.getError(<string>fragment)); } catch (_) { }
  
          if (matches.length === 0) {
              logger.throwArgumentError("unknown fragment", "key", fragment);
          } else if (matches.length > 1) {
              logger.throwArgumentError("ambiguous fragment matches function and error", "key", fragment);
          }
  
          fragment = matches[0];
      }
  
      return dataSlice(id(fragment.format()), 0, 4);
  }
      */
  // Get the 32-byte topic hash used by Solidity to identify an event
  /*
  getEventTopic(fragment: EventFragment): string {
      //if (typeof(fragment) === "string") { fragment = this.getEvent(eventFragment); }
      return id(fragment.format());
  }
  */
  _decodeParams(e, T) {
    return rt(this, Xn).decode(e, T);
  }
  _encodeParams(e, T) {
    return rt(this, Xn).encode(e, T);
  }
  /**
   *  Encodes a ``tx.data`` object for deploying the Contract with
   *  the %%values%% as the constructor arguments.
   */
  encodeDeploy(e) {
    return this._encodeParams(this.deploy.inputs, e || []);
  }
  /**
   *  Decodes the result %%data%% (e.g. from an ``eth_call``) for the
   *  specified error (see [[getError]] for valid values for
   *  %%key%%).
   *
   *  Most developers should prefer the [[parseCallResult]] method instead,
   *  which will automatically detect a ``CALL_EXCEPTION`` and throw the
   *  corresponding error.
   */
  decodeErrorResult(e, T) {
    if (typeof e == "string") {
      const $ = this.getError(e);
      assertArgument($, "unknown error", "fragment", e), e = $;
    }
    return assertArgument(dataSlice(T, 0, 4) === e.selector, `data signature does not match error ${e.name}.`, "data", T), this._decodeParams(e.inputs, dataSlice(T, 4));
  }
  /**
   *  Encodes the transaction revert data for a call result that
   *  reverted from the the Contract with the sepcified %%error%%
   *  (see [[getError]] for valid values for %%fragment%%) with the %%values%%.
   *
   *  This is generally not used by most developers, unless trying to mock
   *  a result from a Contract.
   */
  encodeErrorResult(e, T) {
    if (typeof e == "string") {
      const $ = this.getError(e);
      assertArgument($, "unknown error", "fragment", e), e = $;
    }
    return concat([
      e.selector,
      this._encodeParams(e.inputs, T || [])
    ]);
  }
  /**
   *  Decodes the %%data%% from a transaction ``tx.data`` for
   *  the function specified (see [[getFunction]] for valid values
   *  for %%fragment%%).
   *
   *  Most developers should prefer the [[parseTransaction]] method
   *  instead, which will automatically detect the fragment.
   */
  decodeFunctionData(e, T) {
    if (typeof e == "string") {
      const $ = this.getFunction(e);
      assertArgument($, "unknown function", "fragment", e), e = $;
    }
    return assertArgument(dataSlice(T, 0, 4) === e.selector, `data signature does not match function ${e.name}.`, "data", T), this._decodeParams(e.inputs, dataSlice(T, 4));
  }
  /**
   *  Encodes the ``tx.data`` for a transaction that calls the function
   *  specified (see [[getFunction]] for valid values for %%fragment%%) with
   *  the %%values%%.
   */
  encodeFunctionData(e, T) {
    if (typeof e == "string") {
      const $ = this.getFunction(e);
      assertArgument($, "unknown function", "fragment", e), e = $;
    }
    return concat([
      e.selector,
      this._encodeParams(e.inputs, T || [])
    ]);
  }
  /**
   *  Decodes the result %%data%% (e.g. from an ``eth_call``) for the
   *  specified function (see [[getFunction]] for valid values for
   *  %%key%%).
   *
   *  Most developers should prefer the [[parseCallResult]] method instead,
   *  which will automatically detect a ``CALL_EXCEPTION`` and throw the
   *  corresponding error.
   */
  decodeFunctionResult(e, T) {
    if (typeof e == "string") {
      const J = this.getFunction(e);
      assertArgument(J, "unknown function", "fragment", e), e = J;
    }
    let $ = "invalid length for result data";
    const V = getBytesCopy(T);
    if (V.length % 32 === 0)
      try {
        return rt(this, Xn).decode(e.outputs, V);
      } catch {
        $ = "could not decode result data";
      }
    assert$5(!1, $, "BAD_DATA", {
      value: hexlify(V),
      info: { method: e.name, signature: e.format() }
    });
  }
  makeError(e, T) {
    const $ = getBytes(e, "data"), V = AbiCoder.getBuiltinCallException("call", T, $);
    if (V.message.startsWith("execution reverted (unknown custom error)")) {
      const te = hexlify($.slice(0, 4)), re = this.getError(te);
      if (re)
        try {
          const ie = rt(this, Xn).decode(re.inputs, $.slice(4));
          V.revert = {
            name: re.name,
            signature: re.format(),
            args: ie
          }, V.reason = V.revert.signature, V.message = `execution reverted: ${V.reason}`;
        } catch {
          V.message = "execution reverted (coult not decode custom error)";
        }
    }
    const ee = this.parseTransaction(T);
    return ee && (V.invocation = {
      method: ee.name,
      signature: ee.signature,
      args: ee.args
    }), V;
  }
  /**
   *  Encodes the result data (e.g. from an ``eth_call``) for the
   *  specified function (see [[getFunction]] for valid values
   *  for %%fragment%%) with %%values%%.
   *
   *  This is generally not used by most developers, unless trying to mock
   *  a result from a Contract.
   */
  encodeFunctionResult(e, T) {
    if (typeof e == "string") {
      const $ = this.getFunction(e);
      assertArgument($, "unknown function", "fragment", e), e = $;
    }
    return hexlify(rt(this, Xn).encode(e.outputs, T || []));
  }
  /*
      spelunk(inputs: Array<ParamType>, values: ReadonlyArray<any>, processfunc: (type: string, value: any) => Promise<any>): Promise<Array<any>> {
          const promises: Array<Promise<>> = [ ];
          const process = function(type: ParamType, value: any): any {
              if (type.baseType === "array") {
                  return descend(type.child
              }
              if (type. === "address") {
              }
          };
  
          const descend = function (inputs: Array<ParamType>, values: ReadonlyArray<any>) {
              if (inputs.length !== values.length) { throw new Error("length mismatch"); }
              
          };
  
          const result: Array<any> = [ ];
          values.forEach((value, index) => {
              if (value == null) {
                  topics.push(null);
              } else if (param.baseType === "array" || param.baseType === "tuple") {
                  logger.throwArgumentError("filtering with tuples or arrays not supported", ("contract." + param.name), value);
              } else if (Array.isArray(value)) {
                  topics.push(value.map((value) => encodeTopic(param, value)));
              } else {
                  topics.push(encodeTopic(param, value));
              }
          });
      }
  */
  // Create the filter for the event with search criteria (e.g. for eth_filterLog)
  encodeFilterTopics(e, T) {
    if (typeof e == "string") {
      const J = this.getEvent(e);
      assertArgument(J, "unknown event", "eventFragment", e), e = J;
    }
    assert$5(T.length <= e.inputs.length, `too many arguments for ${e.format()}`, "UNEXPECTED_ARGUMENT", { count: T.length, expectedCount: e.inputs.length });
    const $ = [];
    e.anonymous || $.push(e.topicHash);
    const V = (J, ee) => J.type === "string" ? id(ee) : J.type === "bytes" ? keccak256(hexlify(ee)) : (J.type === "bool" && typeof ee == "boolean" ? ee = ee ? "0x01" : "0x00" : J.type.match(/^u?int/) ? ee = toBeHex(ee) : J.type.match(/^bytes/) ? ee = zeroPadBytes(ee, 32) : J.type === "address" && rt(this, Xn).encode(["address"], [ee]), zeroPadValue(hexlify(ee), 32));
    for (T.forEach((J, ee) => {
      const te = e.inputs[ee];
      if (!te.indexed) {
        assertArgument(J == null, "cannot filter non-indexed parameters; must be null", "contract." + te.name, J);
        return;
      }
      J == null ? $.push(null) : te.baseType === "array" || te.baseType === "tuple" ? assertArgument(!1, "filtering with tuples or arrays not supported", "contract." + te.name, J) : Array.isArray(J) ? $.push(J.map((re) => V(te, re))) : $.push(V(te, J));
    }); $.length && $[$.length - 1] === null; )
      $.pop();
    return $;
  }
  encodeEventLog(e, T) {
    if (typeof e == "string") {
      const ee = this.getEvent(e);
      assertArgument(ee, "unknown event", "eventFragment", e), e = ee;
    }
    const $ = [], V = [], J = [];
    return e.anonymous || $.push(e.topicHash), assertArgument(T.length === e.inputs.length, "event arguments/values mismatch", "values", T), e.inputs.forEach((ee, te) => {
      const re = T[te];
      if (ee.indexed)
        if (ee.type === "string")
          $.push(id(re));
        else if (ee.type === "bytes")
          $.push(keccak256(re));
        else {
          if (ee.baseType === "tuple" || ee.baseType === "array")
            throw new Error("not implemented");
          $.push(rt(this, Xn).encode([ee.type], [re]));
        }
      else
        V.push(ee), J.push(re);
    }), {
      data: rt(this, Xn).encode(V, J),
      topics: $
    };
  }
  // Decode a filter for the event and the search criteria
  decodeEventLog(e, T, $) {
    if (typeof e == "string") {
      const fe = this.getEvent(e);
      assertArgument(fe, "unknown event", "eventFragment", e), e = fe;
    }
    if ($ != null && !e.anonymous) {
      const fe = e.topicHash;
      assertArgument(isHexString($[0], 32) && $[0].toLowerCase() === fe, "fragment/topic mismatch", "topics[0]", $[0]), $ = $.slice(1);
    }
    const V = [], J = [], ee = [];
    e.inputs.forEach((fe, he) => {
      fe.indexed ? fe.type === "string" || fe.type === "bytes" || fe.baseType === "tuple" || fe.baseType === "array" ? (V.push(ParamType.from({ type: "bytes32", name: fe.name })), ee.push(!0)) : (V.push(fe), ee.push(!1)) : (J.push(fe), ee.push(!1));
    });
    const te = $ != null ? rt(this, Xn).decode(V, concat($)) : null, re = rt(this, Xn).decode(J, T, !0), ie = [], se = [];
    let de = 0, ue = 0;
    return e.inputs.forEach((fe, he) => {
      let me = null;
      if (fe.indexed)
        if (te == null)
          me = new Indexed(null);
        else if (ee[he])
          me = new Indexed(te[ue++]);
        else
          try {
            me = te[ue++];
          } catch (xe) {
            me = xe;
          }
      else
        try {
          me = re[de++];
        } catch (xe) {
          me = xe;
        }
      ie.push(me), se.push(fe.name || null);
    }), Result.fromItems(ie, se);
  }
  /**
   *  Parses a transaction, finding the matching function and extracts
   *  the parameter values along with other useful function details.
   *
   *  If the matching function cannot be found, return null.
   */
  parseTransaction(e) {
    const T = getBytes(e.data, "tx.data"), $ = getBigInt(e.value != null ? e.value : 0, "tx.value"), V = this.getFunction(hexlify(T.slice(0, 4)));
    if (!V)
      return null;
    const J = rt(this, Xn).decode(V.inputs, T.slice(4));
    return new TransactionDescription(V, V.selector, J, $);
  }
  parseCallResult(e) {
    throw new Error("@TODO");
  }
  /**
   *  Parses a receipt log, finding the matching event and extracts
   *  the parameter values along with other useful event details.
   *
   *  If the matching event cannot be found, returns null.
   */
  parseLog(e) {
    const T = this.getEvent(e.topics[0]);
    return !T || T.anonymous ? null : new LogDescription(T, T.topicHash, this.decodeEventLog(T, e.data, e.topics));
  }
  /**
   *  Parses a revert data, finding the matching error and extracts
   *  the parameter values along with other useful error details.
   *
   *  If the matching error cannot be found, returns null.
   */
  parseError(e) {
    const T = hexlify(e), $ = this.getError(dataSlice(T, 0, 4));
    if (!$)
      return null;
    const V = rt(this, Xn).decode($.inputs, dataSlice(T, 4));
    return new ErrorDescription($, $.selector, V);
  }
  /**
   *  Creates a new [[Interface]] from the ABI %%value%%.
   *
   *  The %%value%% may be provided as an existing [[Interface]] object,
   *  a JSON-encoded ABI or any Human-Readable ABI format.
   */
  static from(e) {
    return e instanceof Bi ? e : typeof e == "string" ? new Bi(JSON.parse(e)) : typeof e.formatJson == "function" ? new Bi(e.formatJson()) : typeof e.format == "function" ? new Bi(e.format("json")) : new Bi(e);
  }
};
Pr = new WeakMap(), Rr = new WeakMap(), Lr = new WeakMap(), Xn = new WeakMap(), Ur = new WeakSet(), // Find a function definition by any means necessary (unless it is ambiguous)
Os = function(e, T, $) {
  if (isHexString(e)) {
    const J = e.toLowerCase();
    for (const ee of rt(this, Lr).values())
      if (J === ee.selector)
        return ee;
    return null;
  }
  if (e.indexOf("(") === -1) {
    const J = [];
    for (const [ee, te] of rt(this, Lr))
      ee.split(
        "("
        /* fix:) */
      )[0] === e && J.push(te);
    if (T) {
      const ee = T.length > 0 ? T[T.length - 1] : null;
      let te = T.length, re = !0;
      Typed.isTyped(ee) && ee.type === "overrides" && (re = !1, te--);
      for (let ie = J.length - 1; ie >= 0; ie--) {
        const se = J[ie].inputs.length;
        se !== te && (!re || se !== te - 1) && J.splice(ie, 1);
      }
      for (let ie = J.length - 1; ie >= 0; ie--) {
        const se = J[ie].inputs;
        for (let de = 0; de < T.length; de++)
          if (Typed.isTyped(T[de])) {
            if (de >= se.length) {
              if (T[de].type === "overrides")
                continue;
              J.splice(ie, 1);
              break;
            }
            if (T[de].type !== se[de].baseType) {
              J.splice(ie, 1);
              break;
            }
          }
      }
    }
    if (J.length === 1 && T && T.length !== J[0].inputs.length) {
      const ee = T[T.length - 1];
      (ee == null || Array.isArray(ee) || typeof ee != "object") && J.splice(0, 1);
    }
    if (J.length === 0)
      return null;
    if (J.length > 1 && $) {
      const ee = J.map((te) => JSON.stringify(te.format())).join(", ");
      assertArgument(!1, `ambiguous function description (i.e. matches ${ee})`, "key", e);
    }
    return J[0];
  }
  const V = rt(this, Lr).get(FunctionFragment.from(e).format());
  return V || null;
}, // Find an event definition by any means necessary (unless it is ambiguous)
Fs = function(e, T, $) {
  if (isHexString(e)) {
    const J = e.toLowerCase();
    for (const ee of rt(this, Rr).values())
      if (J === ee.topicHash)
        return ee;
    return null;
  }
  if (e.indexOf("(") === -1) {
    const J = [];
    for (const [ee, te] of rt(this, Rr))
      ee.split(
        "("
        /* fix:) */
      )[0] === e && J.push(te);
    if (T) {
      for (let ee = J.length - 1; ee >= 0; ee--)
        J[ee].inputs.length < T.length && J.splice(ee, 1);
      for (let ee = J.length - 1; ee >= 0; ee--) {
        const te = J[ee].inputs;
        for (let re = 0; re < T.length; re++)
          if (Typed.isTyped(T[re]) && T[re].type !== te[re].baseType) {
            J.splice(ee, 1);
            break;
          }
      }
    }
    if (J.length === 0)
      return null;
    if (J.length > 1 && $) {
      const ee = J.map((te) => JSON.stringify(te.format())).join(", ");
      assertArgument(!1, `ambiguous event description (i.e. matches ${ee})`, "key", e);
    }
    return J[0];
  }
  const V = rt(this, Rr).get(EventFragment.from(e).format());
  return V || null;
};
let Interface = Bi;
const BN_0$2 = BigInt(0);
function getValue(C) {
  return C ?? null;
}
function toJson(C) {
  return C == null ? null : C.toString();
}
class FeeData {
  /**
   *  Creates a new FeeData for %%gasPrice%%, %%maxFeePerGas%% and
   *  %%maxPriorityFeePerGas%%.
   */
  constructor(e, T, $) {
    /**
     *  The gas price for legacy networks.
     */
    tt(this, "gasPrice");
    /**
     *  The maximum fee to pay per gas.
     *
     *  The base fee per gas is defined by the network and based on
     *  congestion, increasing the cost during times of heavy load
     *  and lowering when less busy.
     *
     *  The actual fee per gas will be the base fee for the block
     *  and the priority fee, up to the max fee per gas.
     *
     *  This will be ``null`` on legacy networks (i.e. [pre-EIP-1559](link-eip-1559))
     */
    tt(this, "maxFeePerGas");
    /**
     *  The additional amout to pay per gas to encourage a validator
     *  to include the transaction.
     *
     *  The purpose of this is to compensate the validator for the
     *  adjusted risk for including a given transaction.
     *
     *  This will be ``null`` on legacy networks (i.e. [pre-EIP-1559](link-eip-1559))
     */
    tt(this, "maxPriorityFeePerGas");
    defineProperties(this, {
      gasPrice: getValue(e),
      maxFeePerGas: getValue(T),
      maxPriorityFeePerGas: getValue($)
    });
  }
  /**
   *  Returns a JSON-friendly value.
   */
  toJSON() {
    const { gasPrice: e, maxFeePerGas: T, maxPriorityFeePerGas: $ } = this;
    return {
      _type: "FeeData",
      gasPrice: toJson(e),
      maxFeePerGas: toJson(T),
      maxPriorityFeePerGas: toJson($)
    };
  }
}
function copyRequest(C) {
  const e = {};
  C.to && (e.to = C.to), C.from && (e.from = C.from), C.data && (e.data = hexlify(C.data));
  const T = "chainId,gasLimit,gasPrice,maxFeePerBlobGas,maxFeePerGas,maxPriorityFeePerGas,value".split(/,/);
  for (const V of T)
    !(V in C) || C[V] == null || (e[V] = getBigInt(C[V], `request.${V}`));
  const $ = "type,nonce".split(/,/);
  for (const V of $)
    !(V in C) || C[V] == null || (e[V] = getNumber(C[V], `request.${V}`));
  return C.accessList && (e.accessList = accessListify(C.accessList)), "blockTag" in C && (e.blockTag = C.blockTag), "enableCcipRead" in C && (e.enableCcipRead = !!C.enableCcipRead), "customData" in C && (e.customData = C.customData), "blobVersionedHashes" in C && C.blobVersionedHashes && (e.blobVersionedHashes = C.blobVersionedHashes.slice()), "kzg" in C && (e.kzg = C.kzg), "blobs" in C && C.blobs && (e.blobs = C.blobs.map((V) => isBytesLike(V) ? hexlify(V) : Object.assign({}, V))), e;
}
var Jr;
class Block {
  /**
   *  Create a new **Block** object.
   *
   *  This should generally not be necessary as the unless implementing a
   *  low-level library.
   */
  constructor(e, T) {
    /**
     *  The provider connected to the block used to fetch additional details
     *  if necessary.
     */
    tt(this, "provider");
    /**
     *  The block number, sometimes called the block height. This is a
     *  sequential number that is one higher than the parent block.
     */
    tt(this, "number");
    /**
     *  The block hash.
     *
     *  This hash includes all properties, so can be safely used to identify
     *  an exact set of block properties.
     */
    tt(this, "hash");
    /**
     *  The timestamp for this block, which is the number of seconds since
     *  epoch that this block was included.
     */
    tt(this, "timestamp");
    /**
     *  The block hash of the parent block.
     */
    tt(this, "parentHash");
    /**
     *  The hash tree root of the parent beacon block for the given
     *  execution block. See [[link-eip-4788]].
     */
    tt(this, "parentBeaconBlockRoot");
    /**
     *  The nonce.
     *
     *  On legacy networks, this is the random number inserted which
     *  permitted the difficulty target to be reached.
     */
    tt(this, "nonce");
    /**
     *  The difficulty target.
     *
     *  On legacy networks, this is the proof-of-work target required
     *  for a block to meet the protocol rules to be included.
     *
     *  On modern networks, this is a random number arrived at using
     *  randao.  @TODO: Find links?
     */
    tt(this, "difficulty");
    /**
     *  The total gas limit for this block.
     */
    tt(this, "gasLimit");
    /**
     *  The total gas used in this block.
     */
    tt(this, "gasUsed");
    /**
     *  The root hash for the global state after applying changes
     *  in this block.
     */
    tt(this, "stateRoot");
    /**
     *  The hash of the transaction receipts trie.
     */
    tt(this, "receiptsRoot");
    /**
     *  The total amount of blob gas consumed by the transactions
     *  within the block. See [[link-eip-4844]].
     */
    tt(this, "blobGasUsed");
    /**
     *  The running total of blob gas consumed in excess of the
     *  target, prior to the block. See [[link-eip-4844]].
     */
    tt(this, "excessBlobGas");
    /**
     *  The miner coinbase address, wihch receives any subsidies for
     *  including this block.
     */
    tt(this, "miner");
    /**
     *  The latest RANDAO mix of the post beacon state of
     *  the previous block.
     */
    tt(this, "prevRandao");
    /**
     *  Any extra data the validator wished to include.
     */
    tt(this, "extraData");
    /**
     *  The base fee per gas that all transactions in this block were
     *  charged.
     *
     *  This adjusts after each block, depending on how congested the network
     *  is.
     */
    tt(this, "baseFeePerGas");
    Ft(this, Jr);
    At(this, Jr, e.transactions.map(($) => typeof $ != "string" ? new TransactionResponse($, T) : $)), defineProperties(this, {
      provider: T,
      hash: getValue(e.hash),
      number: e.number,
      timestamp: e.timestamp,
      parentHash: e.parentHash,
      parentBeaconBlockRoot: e.parentBeaconBlockRoot,
      nonce: e.nonce,
      difficulty: e.difficulty,
      gasLimit: e.gasLimit,
      gasUsed: e.gasUsed,
      blobGasUsed: e.blobGasUsed,
      excessBlobGas: e.excessBlobGas,
      miner: e.miner,
      prevRandao: getValue(e.prevRandao),
      extraData: e.extraData,
      baseFeePerGas: getValue(e.baseFeePerGas),
      stateRoot: e.stateRoot,
      receiptsRoot: e.receiptsRoot
    });
  }
  /**
   *  Returns the list of transaction hashes, in the order
   *  they were executed within the block.
   */
  get transactions() {
    return rt(this, Jr).map((e) => typeof e == "string" ? e : e.hash);
  }
  /**
   *  Returns the complete transactions, in the order they
   *  were executed within the block.
   *
   *  This is only available for blocks which prefetched
   *  transactions, by passing ``true`` to %%prefetchTxs%%
   *  into [[Provider-getBlock]].
   */
  get prefetchedTransactions() {
    const e = rt(this, Jr).slice();
    return e.length === 0 ? [] : (assert$5(typeof e[0] == "object", "transactions were not prefetched with block request", "UNSUPPORTED_OPERATION", {
      operation: "transactionResponses()"
    }), e);
  }
  /**
   *  Returns a JSON-friendly value.
   */
  toJSON() {
    const { baseFeePerGas: e, difficulty: T, extraData: $, gasLimit: V, gasUsed: J, hash: ee, miner: te, prevRandao: re, nonce: ie, number: se, parentHash: de, parentBeaconBlockRoot: ue, stateRoot: fe, receiptsRoot: he, timestamp: me, transactions: xe } = this;
    return {
      _type: "Block",
      baseFeePerGas: toJson(e),
      difficulty: toJson(T),
      extraData: $,
      gasLimit: toJson(V),
      gasUsed: toJson(J),
      blobGasUsed: toJson(this.blobGasUsed),
      excessBlobGas: toJson(this.excessBlobGas),
      hash: ee,
      miner: te,
      prevRandao: re,
      nonce: ie,
      number: se,
      parentHash: de,
      timestamp: me,
      parentBeaconBlockRoot: ue,
      stateRoot: fe,
      receiptsRoot: he,
      transactions: xe
    };
  }
  [Symbol.iterator]() {
    let e = 0;
    const T = this.transactions;
    return {
      next: () => e < this.length ? {
        value: T[e++],
        done: !1
      } : { value: void 0, done: !0 }
    };
  }
  /**
   *  The number of transactions in this block.
   */
  get length() {
    return rt(this, Jr).length;
  }
  /**
   *  The [[link-js-date]] this block was included at.
   */
  get date() {
    return this.timestamp == null ? null : new Date(this.timestamp * 1e3);
  }
  /**
   *  Get the transaction at %%indexe%% within this block.
   */
  async getTransaction(e) {
    let T;
    if (typeof e == "number")
      T = rt(this, Jr)[e];
    else {
      const $ = e.toLowerCase();
      for (const V of rt(this, Jr))
        if (typeof V == "string") {
          if (V !== $)
            continue;
          T = V;
          break;
        } else {
          if (V.hash === $)
            continue;
          T = V;
          break;
        }
    }
    if (T == null)
      throw new Error("no such tx");
    return typeof T == "string" ? await this.provider.getTransaction(T) : T;
  }
  /**
   *  If a **Block** was fetched with a request to include the transactions
   *  this will allow synchronous access to those transactions.
   *
   *  If the transactions were not prefetched, this will throw.
   */
  getPrefetchedTransaction(e) {
    const T = this.prefetchedTransactions;
    if (typeof e == "number")
      return T[e];
    e = e.toLowerCase();
    for (const $ of T)
      if ($.hash === e)
        return $;
    assertArgument(!1, "no matching transaction", "indexOrHash", e);
  }
  /**
   *  Returns true if this block been mined. This provides a type guard
   *  for all properties on a [[MinedBlock]].
   */
  isMined() {
    return !!this.hash;
  }
  /**
   *  Returns true if this block is an [[link-eip-2930]] block.
   */
  isLondon() {
    return !!this.baseFeePerGas;
  }
  /**
   *  @_ignore:
   */
  orphanedEvent() {
    if (!this.isMined())
      throw new Error("");
    return createOrphanedBlockFilter(this);
  }
}
Jr = new WeakMap();
class Log {
  /**
   *  @_ignore:
   */
  constructor(e, T) {
    /**
     *  The provider connected to the log used to fetch additional details
     *  if necessary.
     */
    tt(this, "provider");
    /**
     *  The transaction hash of the transaction this log occurred in. Use the
     *  [[Log-getTransaction]] to get the [[TransactionResponse]].
     */
    tt(this, "transactionHash");
    /**
     *  The block hash of the block this log occurred in. Use the
     *  [[Log-getBlock]] to get the [[Block]].
     */
    tt(this, "blockHash");
    /**
     *  The block number of the block this log occurred in. It is preferred
     *  to use the [[Block-hash]] when fetching the related [[Block]],
     *  since in the case of an orphaned block, the block at that height may
     *  have changed.
     */
    tt(this, "blockNumber");
    /**
     *  If the **Log** represents a block that was removed due to an orphaned
     *  block, this will be true.
     *
     *  This can only happen within an orphan event listener.
     */
    tt(this, "removed");
    /**
     *  The address of the contract that emitted this log.
     */
    tt(this, "address");
    /**
     *  The data included in this log when it was emitted.
     */
    tt(this, "data");
    /**
     *  The indexed topics included in this log when it was emitted.
     *
     *  All topics are included in the bloom filters, so they can be
     *  efficiently filtered using the [[Provider-getLogs]] method.
     */
    tt(this, "topics");
    /**
     *  The index within the block this log occurred at. This is generally
     *  not useful to developers, but can be used with the various roots
     *  to proof inclusion within a block.
     */
    tt(this, "index");
    /**
     *  The index within the transaction of this log.
     */
    tt(this, "transactionIndex");
    this.provider = T;
    const $ = Object.freeze(e.topics.slice());
    defineProperties(this, {
      transactionHash: e.transactionHash,
      blockHash: e.blockHash,
      blockNumber: e.blockNumber,
      removed: e.removed,
      address: e.address,
      data: e.data,
      topics: $,
      index: e.index,
      transactionIndex: e.transactionIndex
    });
  }
  /**
   *  Returns a JSON-compatible object.
   */
  toJSON() {
    const { address: e, blockHash: T, blockNumber: $, data: V, index: J, removed: ee, topics: te, transactionHash: re, transactionIndex: ie } = this;
    return {
      _type: "log",
      address: e,
      blockHash: T,
      blockNumber: $,
      data: V,
      index: J,
      removed: ee,
      topics: te,
      transactionHash: re,
      transactionIndex: ie
    };
  }
  /**
   *  Returns the block that this log occurred in.
   */
  async getBlock() {
    const e = await this.provider.getBlock(this.blockHash);
    return assert$5(!!e, "failed to find transaction", "UNKNOWN_ERROR", {}), e;
  }
  /**
   *  Returns the transaction that this log occurred in.
   */
  async getTransaction() {
    const e = await this.provider.getTransaction(this.transactionHash);
    return assert$5(!!e, "failed to find transaction", "UNKNOWN_ERROR", {}), e;
  }
  /**
   *  Returns the transaction receipt fot the transaction that this
   *  log occurred in.
   */
  async getTransactionReceipt() {
    const e = await this.provider.getTransactionReceipt(this.transactionHash);
    return assert$5(!!e, "failed to find transaction receipt", "UNKNOWN_ERROR", {}), e;
  }
  /**
   *  @_ignore:
   */
  removedEvent() {
    return createRemovedLogFilter(this);
  }
}
var As;
class TransactionReceipt {
  /**
   *  @_ignore:
   */
  constructor(e, T) {
    /**
     *  The provider connected to the log used to fetch additional details
     *  if necessary.
     */
    tt(this, "provider");
    /**
     *  The address the transaction was sent to.
     */
    tt(this, "to");
    /**
     *  The sender of the transaction.
     */
    tt(this, "from");
    /**
     *  The address of the contract if the transaction was directly
     *  responsible for deploying one.
     *
     *  This is non-null **only** if the ``to`` is empty and the ``data``
     *  was successfully executed as initcode.
     */
    tt(this, "contractAddress");
    /**
     *  The transaction hash.
     */
    tt(this, "hash");
    /**
     *  The index of this transaction within the block transactions.
     */
    tt(this, "index");
    /**
     *  The block hash of the [[Block]] this transaction was included in.
     */
    tt(this, "blockHash");
    /**
     *  The block number of the [[Block]] this transaction was included in.
     */
    tt(this, "blockNumber");
    /**
     *  The bloom filter bytes that represent all logs that occurred within
     *  this transaction. This is generally not useful for most developers,
     *  but can be used to validate the included logs.
     */
    tt(this, "logsBloom");
    /**
     *  The actual amount of gas used by this transaction.
     *
     *  When creating a transaction, the amount of gas that will be used can
     *  only be approximated, but the sender must pay the gas fee for the
     *  entire gas limit. After the transaction, the difference is refunded.
     */
    tt(this, "gasUsed");
    /**
     *  The gas used for BLObs. See [[link-eip-4844]].
     */
    tt(this, "blobGasUsed");
    /**
     *  The amount of gas used by all transactions within the block for this
     *  and all transactions with a lower ``index``.
     *
     *  This is generally not useful for developers but can be used to
     *  validate certain aspects of execution.
     */
    tt(this, "cumulativeGasUsed");
    /**
     *  The actual gas price used during execution.
     *
     *  Due to the complexity of [[link-eip-1559]] this value can only
     *  be caluclated after the transaction has been mined, snce the base
     *  fee is protocol-enforced.
     */
    tt(this, "gasPrice");
    /**
     *  The price paid per BLOB in gas. See [[link-eip-4844]].
     */
    tt(this, "blobGasPrice");
    /**
     *  The [[link-eip-2718]] transaction type.
     */
    tt(this, "type");
    //readonly byzantium!: boolean;
    /**
     *  The status of this transaction, indicating success (i.e. ``1``) or
     *  a revert (i.e. ``0``).
     *
     *  This is available in post-byzantium blocks, but some backends may
     *  backfill this value.
     */
    tt(this, "status");
    /**
     *  The root hash of this transaction.
     *
     *  This is no present and was only included in pre-byzantium blocks, but
     *  could be used to validate certain parts of the receipt.
     */
    tt(this, "root");
    Ft(this, As);
    At(this, As, Object.freeze(e.logs.map((V) => new Log(V, T))));
    let $ = BN_0$2;
    e.effectiveGasPrice != null ? $ = e.effectiveGasPrice : e.gasPrice != null && ($ = e.gasPrice), defineProperties(this, {
      provider: T,
      to: e.to,
      from: e.from,
      contractAddress: e.contractAddress,
      hash: e.hash,
      index: e.index,
      blockHash: e.blockHash,
      blockNumber: e.blockNumber,
      logsBloom: e.logsBloom,
      gasUsed: e.gasUsed,
      cumulativeGasUsed: e.cumulativeGasUsed,
      blobGasUsed: e.blobGasUsed,
      gasPrice: $,
      blobGasPrice: e.blobGasPrice,
      type: e.type,
      //byzantium: tx.byzantium,
      status: e.status,
      root: e.root
    });
  }
  /**
   *  The logs for this transaction.
   */
  get logs() {
    return rt(this, As);
  }
  /**
   *  Returns a JSON-compatible representation.
   */
  toJSON() {
    const {
      to: e,
      from: T,
      contractAddress: $,
      hash: V,
      index: J,
      blockHash: ee,
      blockNumber: te,
      logsBloom: re,
      logs: ie,
      //byzantium, 
      status: se,
      root: de
    } = this;
    return {
      _type: "TransactionReceipt",
      blockHash: ee,
      blockNumber: te,
      //byzantium, 
      contractAddress: $,
      cumulativeGasUsed: toJson(this.cumulativeGasUsed),
      from: T,
      gasPrice: toJson(this.gasPrice),
      blobGasUsed: toJson(this.blobGasUsed),
      blobGasPrice: toJson(this.blobGasPrice),
      gasUsed: toJson(this.gasUsed),
      hash: V,
      index: J,
      logs: ie,
      logsBloom: re,
      root: de,
      status: se,
      to: e
    };
  }
  /**
   *  @_ignore:
   */
  get length() {
    return this.logs.length;
  }
  [Symbol.iterator]() {
    let e = 0;
    return {
      next: () => e < this.length ? { value: this.logs[e++], done: !1 } : { value: void 0, done: !0 }
    };
  }
  /**
   *  The total fee for this transaction, in wei.
   */
  get fee() {
    return this.gasUsed * this.gasPrice;
  }
  /**
   *  Resolves to the block this transaction occurred in.
   */
  async getBlock() {
    const e = await this.provider.getBlock(this.blockHash);
    if (e == null)
      throw new Error("TODO");
    return e;
  }
  /**
   *  Resolves to the transaction this transaction occurred in.
   */
  async getTransaction() {
    const e = await this.provider.getTransaction(this.hash);
    if (e == null)
      throw new Error("TODO");
    return e;
  }
  /**
   *  Resolves to the return value of the execution of this transaction.
   *
   *  Support for this feature is limited, as it requires an archive node
   *  with the ``debug_`` or ``trace_`` API enabled.
   */
  async getResult() {
    return await this.provider.getTransactionResult(this.hash);
  }
  /**
   *  Resolves to the number of confirmations this transaction has.
   */
  async confirmations() {
    return await this.provider.getBlockNumber() - this.blockNumber + 1;
  }
  /**
   *  @_ignore:
   */
  removedEvent() {
    return createRemovedTransactionFilter(this);
  }
  /**
   *  @_ignore:
   */
  reorderedEvent(e) {
    return assert$5(!e || e.isMined(), "unmined 'other' transction cannot be orphaned", "UNSUPPORTED_OPERATION", { operation: "reorderedEvent(other)" }), createReorderedTransactionFilter(this, e);
  }
}
As = new WeakMap();
var pi;
const yo = class yo {
  /**
   *  @_ignore:
   */
  constructor(e, T) {
    /**
     *  The provider this is connected to, which will influence how its
     *  methods will resolve its async inspection methods.
     */
    tt(this, "provider");
    /**
     *  The block number of the block that this transaction was included in.
     *
     *  This is ``null`` for pending transactions.
     */
    tt(this, "blockNumber");
    /**
     *  The blockHash of the block that this transaction was included in.
     *
     *  This is ``null`` for pending transactions.
     */
    tt(this, "blockHash");
    /**
     *  The index within the block that this transaction resides at.
     */
    tt(this, "index");
    /**
     *  The transaction hash.
     */
    tt(this, "hash");
    /**
     *  The [[link-eip-2718]] transaction envelope type. This is
     *  ``0`` for legacy transactions types.
     */
    tt(this, "type");
    /**
     *  The receiver of this transaction.
     *
     *  If ``null``, then the transaction is an initcode transaction.
     *  This means the result of executing the [[data]] will be deployed
     *  as a new contract on chain (assuming it does not revert) and the
     *  address may be computed using [[getCreateAddress]].
     */
    tt(this, "to");
    /**
     *  The sender of this transaction. It is implicitly computed
     *  from the transaction pre-image hash (as the digest) and the
     *  [[signature]] using ecrecover.
     */
    tt(this, "from");
    /**
     *  The nonce, which is used to prevent replay attacks and offer
     *  a method to ensure transactions from a given sender are explicitly
     *  ordered.
     *
     *  When sending a transaction, this must be equal to the number of
     *  transactions ever sent by [[from]].
     */
    tt(this, "nonce");
    /**
     *  The maximum units of gas this transaction can consume. If execution
     *  exceeds this, the entries transaction is reverted and the sender
     *  is charged for the full amount, despite not state changes being made.
     */
    tt(this, "gasLimit");
    /**
     *  The gas price can have various values, depending on the network.
     *
     *  In modern networks, for transactions that are included this is
     *  the //effective gas price// (the fee per gas that was actually
     *  charged), while for transactions that have not been included yet
     *  is the [[maxFeePerGas]].
     *
     *  For legacy transactions, or transactions on legacy networks, this
     *  is the fee that will be charged per unit of gas the transaction
     *  consumes.
     */
    tt(this, "gasPrice");
    /**
     *  The maximum priority fee (per unit of gas) to allow a
     *  validator to charge the sender. This is inclusive of the
     *  [[maxFeeFeePerGas]].
     */
    tt(this, "maxPriorityFeePerGas");
    /**
     *  The maximum fee (per unit of gas) to allow this transaction
     *  to charge the sender.
     */
    tt(this, "maxFeePerGas");
    /**
     *  The [[link-eip-4844]] max fee per BLOb gas.
     */
    tt(this, "maxFeePerBlobGas");
    /**
     *  The data.
     */
    tt(this, "data");
    /**
     *  The value, in wei. Use [[formatEther]] to format this value
     *  as ether.
     */
    tt(this, "value");
    /**
     *  The chain ID.
     */
    tt(this, "chainId");
    /**
     *  The signature.
     */
    tt(this, "signature");
    /**
     *  The [[link-eip-2930]] access list for transaction types that
     *  support it, otherwise ``null``.
     */
    tt(this, "accessList");
    /**
     *  The [[link-eip-4844]] BLOb versioned hashes.
     */
    tt(this, "blobVersionedHashes");
    Ft(this, pi);
    this.provider = T, this.blockNumber = e.blockNumber != null ? e.blockNumber : null, this.blockHash = e.blockHash != null ? e.blockHash : null, this.hash = e.hash, this.index = e.index, this.type = e.type, this.from = e.from, this.to = e.to || null, this.gasLimit = e.gasLimit, this.nonce = e.nonce, this.data = e.data, this.value = e.value, this.gasPrice = e.gasPrice, this.maxPriorityFeePerGas = e.maxPriorityFeePerGas != null ? e.maxPriorityFeePerGas : null, this.maxFeePerGas = e.maxFeePerGas != null ? e.maxFeePerGas : null, this.maxFeePerBlobGas = e.maxFeePerBlobGas != null ? e.maxFeePerBlobGas : null, this.chainId = e.chainId, this.signature = e.signature, this.accessList = e.accessList != null ? e.accessList : null, this.blobVersionedHashes = e.blobVersionedHashes != null ? e.blobVersionedHashes : null, At(this, pi, -1);
  }
  /**
   *  Returns a JSON-compatible representation of this transaction.
   */
  toJSON() {
    const { blockNumber: e, blockHash: T, index: $, hash: V, type: J, to: ee, from: te, nonce: re, data: ie, signature: se, accessList: de, blobVersionedHashes: ue } = this;
    return {
      _type: "TransactionResponse",
      accessList: de,
      blockNumber: e,
      blockHash: T,
      blobVersionedHashes: ue,
      chainId: toJson(this.chainId),
      data: ie,
      from: te,
      gasLimit: toJson(this.gasLimit),
      gasPrice: toJson(this.gasPrice),
      hash: V,
      maxFeePerGas: toJson(this.maxFeePerGas),
      maxPriorityFeePerGas: toJson(this.maxPriorityFeePerGas),
      maxFeePerBlobGas: toJson(this.maxFeePerBlobGas),
      nonce: re,
      signature: se,
      to: ee,
      index: $,
      type: J,
      value: toJson(this.value)
    };
  }
  /**
   *  Resolves to the Block that this transaction was included in.
   *
   *  This will return null if the transaction has not been included yet.
   */
  async getBlock() {
    let e = this.blockNumber;
    if (e == null) {
      const $ = await this.getTransaction();
      $ && (e = $.blockNumber);
    }
    if (e == null)
      return null;
    const T = this.provider.getBlock(e);
    if (T == null)
      throw new Error("TODO");
    return T;
  }
  /**
   *  Resolves to this transaction being re-requested from the
   *  provider. This can be used if you have an unmined transaction
   *  and wish to get an up-to-date populated instance.
   */
  async getTransaction() {
    return this.provider.getTransaction(this.hash);
  }
  /**
   *  Resolve to the number of confirmations this transaction has.
   */
  async confirmations() {
    if (this.blockNumber == null) {
      const { tx: T, blockNumber: $ } = await resolveProperties({
        tx: this.getTransaction(),
        blockNumber: this.provider.getBlockNumber()
      });
      return T == null || T.blockNumber == null ? 0 : $ - T.blockNumber + 1;
    }
    return await this.provider.getBlockNumber() - this.blockNumber + 1;
  }
  /**
   *  Resolves once this transaction has been mined and has
   *  %%confirms%% blocks including it (default: ``1``) with an
   *  optional %%timeout%%.
   *
   *  This can resolve to ``null`` only if %%confirms%% is ``0``
   *  and the transaction has not been mined, otherwise this will
   *  wait until enough confirmations have completed.
   */
  async wait(e, T) {
    const $ = e ?? 1, V = T ?? 0;
    let J = rt(this, pi), ee = -1, te = J === -1;
    const re = async () => {
      if (te)
        return null;
      const { blockNumber: ue, nonce: fe } = await resolveProperties({
        blockNumber: this.provider.getBlockNumber(),
        nonce: this.provider.getTransactionCount(this.from)
      });
      if (fe < this.nonce) {
        J = ue;
        return;
      }
      if (te)
        return null;
      const he = await this.getTransaction();
      if (!(he && he.blockNumber != null))
        for (ee === -1 && (ee = J - 3, ee < rt(this, pi) && (ee = rt(this, pi))); ee <= ue; ) {
          if (te)
            return null;
          const me = await this.provider.getBlock(ee, !0);
          if (me == null)
            return;
          for (const xe of me)
            if (xe === this.hash)
              return;
          for (let xe = 0; xe < me.length; xe++) {
            const ve = await me.getTransaction(xe);
            if (ve.from === this.from && ve.nonce === this.nonce) {
              if (te)
                return null;
              const Te = await this.provider.getTransactionReceipt(ve.hash);
              if (Te == null || ue - Te.blockNumber + 1 < $)
                return;
              let we = "replaced";
              ve.data === this.data && ve.to === this.to && ve.value === this.value ? we = "repriced" : ve.data === "0x" && ve.from === ve.to && ve.value === BN_0$2 && (we = "cancelled"), assert$5(!1, "transaction was replaced", "TRANSACTION_REPLACED", {
                cancelled: we === "replaced" || we === "cancelled",
                reason: we,
                replacement: ve.replaceableTransaction(J),
                hash: ve.hash,
                receipt: Te
              });
            }
          }
          ee++;
        }
    }, ie = (ue) => {
      if (ue == null || ue.status !== 0)
        return ue;
      assert$5(!1, "transaction execution reverted", "CALL_EXCEPTION", {
        action: "sendTransaction",
        data: null,
        reason: null,
        invocation: null,
        revert: null,
        transaction: {
          to: ue.to,
          from: ue.from,
          data: ""
          // @TODO: in v7, split out sendTransaction properties
        },
        receipt: ue
      });
    }, se = await this.provider.getTransactionReceipt(this.hash);
    if ($ === 0)
      return ie(se);
    if (se) {
      if (await se.confirmations() >= $)
        return ie(se);
    } else if (await re(), $ === 0)
      return null;
    return await new Promise((ue, fe) => {
      const he = [], me = () => {
        he.forEach((ve) => ve());
      };
      if (he.push(() => {
        te = !0;
      }), V > 0) {
        const ve = setTimeout(() => {
          me(), fe(makeError("wait for transaction timeout", "TIMEOUT"));
        }, V);
        he.push(() => {
          clearTimeout(ve);
        });
      }
      const xe = async (ve) => {
        if (await ve.confirmations() >= $) {
          me();
          try {
            ue(ie(ve));
          } catch (Te) {
            fe(Te);
          }
        }
      };
      if (he.push(() => {
        this.provider.off(this.hash, xe);
      }), this.provider.on(this.hash, xe), J >= 0) {
        const ve = async () => {
          try {
            await re();
          } catch (Te) {
            if (isError(Te, "TRANSACTION_REPLACED")) {
              me(), fe(Te);
              return;
            }
          }
          te || this.provider.once("block", ve);
        };
        he.push(() => {
          this.provider.off("block", ve);
        }), this.provider.once("block", ve);
      }
    });
  }
  /**
   *  Returns ``true`` if this transaction has been included.
   *
   *  This is effective only as of the time the TransactionResponse
   *  was instantiated. To get up-to-date information, use
   *  [[getTransaction]].
   *
   *  This provides a Type Guard that this transaction will have
   *  non-null property values for properties that are null for
   *  unmined transactions.
   */
  isMined() {
    return this.blockHash != null;
  }
  /**
   *  Returns true if the transaction is a legacy (i.e. ``type == 0``)
   *  transaction.
   *
   *  This provides a Type Guard that this transaction will have
   *  the ``null``-ness for hardfork-specific properties set correctly.
   */
  isLegacy() {
    return this.type === 0;
  }
  /**
   *  Returns true if the transaction is a Berlin (i.e. ``type == 1``)
   *  transaction. See [[link-eip-2070]].
   *
   *  This provides a Type Guard that this transaction will have
   *  the ``null``-ness for hardfork-specific properties set correctly.
   */
  isBerlin() {
    return this.type === 1;
  }
  /**
   *  Returns true if the transaction is a London (i.e. ``type == 2``)
   *  transaction. See [[link-eip-1559]].
   *
   *  This provides a Type Guard that this transaction will have
   *  the ``null``-ness for hardfork-specific properties set correctly.
   */
  isLondon() {
    return this.type === 2;
  }
  /**
   *  Returns true if hte transaction is a Cancun (i.e. ``type == 3``)
   *  transaction. See [[link-eip-4844]].
   */
  isCancun() {
    return this.type === 3;
  }
  /**
   *  Returns a filter which can be used to listen for orphan events
   *  that evict this transaction.
   */
  removedEvent() {
    return assert$5(this.isMined(), "unmined transaction canot be orphaned", "UNSUPPORTED_OPERATION", { operation: "removeEvent()" }), createRemovedTransactionFilter(this);
  }
  /**
   *  Returns a filter which can be used to listen for orphan events
   *  that re-order this event against %%other%%.
   */
  reorderedEvent(e) {
    return assert$5(this.isMined(), "unmined transaction canot be orphaned", "UNSUPPORTED_OPERATION", { operation: "removeEvent()" }), assert$5(!e || e.isMined(), "unmined 'other' transaction canot be orphaned", "UNSUPPORTED_OPERATION", { operation: "removeEvent()" }), createReorderedTransactionFilter(this, e);
  }
  /**
   *  Returns a new TransactionResponse instance which has the ability to
   *  detect (and throw an error) if the transaction is replaced, which
   *  will begin scanning at %%startBlock%%.
   *
   *  This should generally not be used by developers and is intended
   *  primarily for internal use. Setting an incorrect %%startBlock%% can
   *  have devastating performance consequences if used incorrectly.
   */
  replaceableTransaction(e) {
    assertArgument(Number.isInteger(e) && e >= 0, "invalid startBlock", "startBlock", e);
    const T = new yo(this, this.provider);
    return At(T, pi, e), T;
  }
};
pi = new WeakMap();
let TransactionResponse = yo;
function createOrphanedBlockFilter(C) {
  return { orphan: "drop-block", hash: C.hash, number: C.number };
}
function createReorderedTransactionFilter(C, e) {
  return { orphan: "reorder-transaction", tx: C, other: e };
}
function createRemovedTransactionFilter(C) {
  return { orphan: "drop-transaction", tx: C };
}
function createRemovedLogFilter(C) {
  return { orphan: "drop-log", log: {
    transactionHash: C.transactionHash,
    blockHash: C.blockHash,
    blockNumber: C.blockNumber,
    address: C.address,
    data: C.data,
    topics: Object.freeze(C.topics.slice()),
    index: C.index
  } };
}
class EventLog extends Log {
  /**
   * @_ignore:
   */
  constructor(T, $, V) {
    super(T, T.provider);
    /**
     *  The Contract Interface.
     */
    tt(this, "interface");
    /**
     *  The matching event.
     */
    tt(this, "fragment");
    /**
     *  The parsed arguments passed to the event by ``emit``.
     */
    tt(this, "args");
    const J = $.decodeEventLog(V, T.data, T.topics);
    defineProperties(this, { args: J, fragment: V, interface: $ });
  }
  /**
   *  The name of the event.
   */
  get eventName() {
    return this.fragment.name;
  }
  /**
   *  The signature of the event.
   */
  get eventSignature() {
    return this.fragment.format();
  }
}
class UndecodedEventLog extends Log {
  /**
   * @_ignore:
   */
  constructor(T, $) {
    super(T, T.provider);
    /**
     *  The error encounted when trying to decode the log.
     */
    tt(this, "error");
    defineProperties(this, { error: $ });
  }
}
var Ua;
class ContractTransactionReceipt extends TransactionReceipt {
  /**
   *  @_ignore:
   */
  constructor(T, $, V) {
    super(V, $);
    Ft(this, Ua);
    At(this, Ua, T);
  }
  /**
   *  The parsed logs for any [[Log]] which has a matching event in the
   *  Contract ABI.
   */
  get logs() {
    return super.logs.map((T) => {
      const $ = T.topics.length ? rt(this, Ua).getEvent(T.topics[0]) : null;
      if ($)
        try {
          return new EventLog(T, rt(this, Ua), $);
        } catch (V) {
          return new UndecodedEventLog(T, V);
        }
      return T;
    });
  }
}
Ua = new WeakMap();
var vs;
class ContractTransactionResponse extends TransactionResponse {
  /**
   *  @_ignore:
   */
  constructor(T, $, V) {
    super(V, $);
    Ft(this, vs);
    At(this, vs, T);
  }
  /**
   *  Resolves once this transaction has been mined and has
   *  %%confirms%% blocks including it (default: ``1``) with an
   *  optional %%timeout%%.
   *
   *  This can resolve to ``null`` only if %%confirms%% is ``0``
   *  and the transaction has not been mined, otherwise this will
   *  wait until enough confirmations have completed.
   */
  async wait(T, $) {
    const V = await super.wait(T, $);
    return V == null ? null : new ContractTransactionReceipt(rt(this, vs), this.provider, V);
  }
}
vs = new WeakMap();
class ContractUnknownEventPayload extends EventPayload {
  /**
   *  @_event:
   */
  constructor(T, $, V, J) {
    super(T, $, V);
    /**
     *  The log with no matching events.
     */
    tt(this, "log");
    defineProperties(this, { log: J });
  }
  /**
   *  Resolves to the block the event occured in.
   */
  async getBlock() {
    return await this.log.getBlock();
  }
  /**
   *  Resolves to the transaction the event occured in.
   */
  async getTransaction() {
    return await this.log.getTransaction();
  }
  /**
   *  Resolves to the transaction receipt the event occured in.
   */
  async getTransactionReceipt() {
    return await this.log.getTransactionReceipt();
  }
}
class ContractEventPayload extends ContractUnknownEventPayload {
  /**
   *  @_ignore:
   */
  constructor(e, T, $, V, J) {
    super(e, T, $, new EventLog(J, e.interface, V));
    const ee = e.interface.decodeEventLog(V, this.log.data, this.log.topics);
    defineProperties(this, { args: ee, fragment: V });
  }
  /**
   *  The event name.
   */
  get eventName() {
    return this.fragment.name;
  }
  /**
   *  The event signature.
   */
  get eventSignature() {
    return this.fragment.format();
  }
}
const BN_0$1 = BigInt(0);
function canCall(C) {
  return C && typeof C.call == "function";
}
function canEstimate(C) {
  return C && typeof C.estimateGas == "function";
}
function canResolve(C) {
  return C && typeof C.resolveName == "function";
}
function canSend(C) {
  return C && typeof C.sendTransaction == "function";
}
function getResolver(C) {
  if (C != null) {
    if (canResolve(C))
      return C;
    if (C.provider)
      return C.provider;
  }
}
var Cs;
class PreparedTopicFilter {
  constructor(e, T, $) {
    Ft(this, Cs);
    tt(this, "fragment");
    if (defineProperties(this, { fragment: T }), T.inputs.length < $.length)
      throw new Error("too many arguments");
    const V = getRunner(e.runner, "resolveName"), J = canResolve(V) ? V : null;
    At(this, Cs, async function() {
      const ee = await Promise.all(T.inputs.map((te, re) => $[re] == null ? null : te.walkAsync($[re], (se, de) => se === "address" ? Array.isArray(de) ? Promise.all(de.map((ue) => resolveAddress(ue, J))) : resolveAddress(de, J) : de)));
      return e.interface.encodeFilterTopics(T, ee);
    }());
  }
  getTopicFilter() {
    return rt(this, Cs);
  }
}
Cs = new WeakMap();
function getRunner(C, e) {
  return C == null ? null : typeof C[e] == "function" ? C : C.provider && typeof C.provider[e] == "function" ? C.provider : null;
}
function getProvider$1(C) {
  return C == null ? null : C.provider || null;
}
async function copyOverrides(C, e) {
  const T = Typed.dereference(C, "overrides");
  assertArgument(typeof T == "object", "invalid overrides parameter", "overrides", C);
  const $ = copyRequest(T);
  return assertArgument($.to == null || (e || []).indexOf("to") >= 0, "cannot override to", "overrides.to", $.to), assertArgument($.data == null || (e || []).indexOf("data") >= 0, "cannot override data", "overrides.data", $.data), $.from && ($.from = $.from), $;
}
async function resolveArgs(C, e, T) {
  const $ = getRunner(C, "resolveName"), V = canResolve($) ? $ : null;
  return await Promise.all(e.map((J, ee) => J.walkAsync(T[ee], (te, re) => (re = Typed.dereference(re, te), te === "address" ? resolveAddress(re, V) : re))));
}
function buildWrappedFallback(C) {
  const e = async function(ee) {
    const te = await copyOverrides(ee, ["data"]);
    te.to = await C.getAddress(), te.from && (te.from = await resolveAddress(te.from, getResolver(C.runner)));
    const re = C.interface, ie = getBigInt(te.value || BN_0$1, "overrides.value") === BN_0$1, se = (te.data || "0x") === "0x";
    re.fallback && !re.fallback.payable && re.receive && !se && !ie && assertArgument(!1, "cannot send data to receive or send value to non-payable fallback", "overrides", ee), assertArgument(re.fallback || se, "cannot send data to receive-only contract", "overrides.data", te.data);
    const de = re.receive || re.fallback && re.fallback.payable;
    return assertArgument(de || ie, "cannot send value to non-payable fallback", "overrides.value", te.value), assertArgument(re.fallback || se, "cannot send data to receive-only contract", "overrides.data", te.data), te;
  }, T = async function(ee) {
    const te = getRunner(C.runner, "call");
    assert$5(canCall(te), "contract runner does not support calling", "UNSUPPORTED_OPERATION", { operation: "call" });
    const re = await e(ee);
    try {
      return await te.call(re);
    } catch (ie) {
      throw isCallException(ie) && ie.data ? C.interface.makeError(ie.data, re) : ie;
    }
  }, $ = async function(ee) {
    const te = C.runner;
    assert$5(canSend(te), "contract runner does not support sending transactions", "UNSUPPORTED_OPERATION", { operation: "sendTransaction" });
    const re = await te.sendTransaction(await e(ee)), ie = getProvider$1(C.runner);
    return new ContractTransactionResponse(C.interface, ie, re);
  }, V = async function(ee) {
    const te = getRunner(C.runner, "estimateGas");
    return assert$5(canEstimate(te), "contract runner does not support gas estimation", "UNSUPPORTED_OPERATION", { operation: "estimateGas" }), await te.estimateGas(await e(ee));
  }, J = async (ee) => await $(ee);
  return defineProperties(J, {
    _contract: C,
    estimateGas: V,
    populateTransaction: e,
    send: $,
    staticCall: T
  }), J;
}
function buildWrappedMethod(C, e) {
  const T = function(...ie) {
    const se = C.interface.getFunction(e, ie);
    return assert$5(se, "no matching fragment", "UNSUPPORTED_OPERATION", {
      operation: "fragment",
      info: { key: e, args: ie }
    }), se;
  }, $ = async function(...ie) {
    const se = T(...ie);
    let de = {};
    if (se.inputs.length + 1 === ie.length && (de = await copyOverrides(ie.pop()), de.from && (de.from = await resolveAddress(de.from, getResolver(C.runner)))), se.inputs.length !== ie.length)
      throw new Error("internal error: fragment inputs doesn't match arguments; should not happen");
    const ue = await resolveArgs(C.runner, se.inputs, ie);
    return Object.assign({}, de, await resolveProperties({
      to: C.getAddress(),
      data: C.interface.encodeFunctionData(se, ue)
    }));
  }, V = async function(...ie) {
    const se = await te(...ie);
    return se.length === 1 ? se[0] : se;
  }, J = async function(...ie) {
    const se = C.runner;
    assert$5(canSend(se), "contract runner does not support sending transactions", "UNSUPPORTED_OPERATION", { operation: "sendTransaction" });
    const de = await se.sendTransaction(await $(...ie)), ue = getProvider$1(C.runner);
    return new ContractTransactionResponse(C.interface, ue, de);
  }, ee = async function(...ie) {
    const se = getRunner(C.runner, "estimateGas");
    return assert$5(canEstimate(se), "contract runner does not support gas estimation", "UNSUPPORTED_OPERATION", { operation: "estimateGas" }), await se.estimateGas(await $(...ie));
  }, te = async function(...ie) {
    const se = getRunner(C.runner, "call");
    assert$5(canCall(se), "contract runner does not support calling", "UNSUPPORTED_OPERATION", { operation: "call" });
    const de = await $(...ie);
    let ue = "0x";
    try {
      ue = await se.call(de);
    } catch (he) {
      throw isCallException(he) && he.data ? C.interface.makeError(he.data, de) : he;
    }
    const fe = T(...ie);
    return C.interface.decodeFunctionResult(fe, ue);
  }, re = async (...ie) => T(...ie).constant ? await V(...ie) : await J(...ie);
  return defineProperties(re, {
    name: C.interface.getFunctionName(e),
    _contract: C,
    _key: e,
    getFragment: T,
    estimateGas: ee,
    populateTransaction: $,
    send: J,
    staticCall: V,
    staticCallResult: te
  }), Object.defineProperty(re, "fragment", {
    configurable: !1,
    enumerable: !0,
    get: () => {
      const ie = C.interface.getFunction(e);
      return assert$5(ie, "no matching fragment", "UNSUPPORTED_OPERATION", {
        operation: "fragment",
        info: { key: e }
      }), ie;
    }
  }), re;
}
function buildWrappedEvent(C, e) {
  const T = function(...V) {
    const J = C.interface.getEvent(e, V);
    return assert$5(J, "no matching fragment", "UNSUPPORTED_OPERATION", {
      operation: "fragment",
      info: { key: e, args: V }
    }), J;
  }, $ = function(...V) {
    return new PreparedTopicFilter(C, T(...V), V);
  };
  return defineProperties($, {
    name: C.interface.getEventName(e),
    _contract: C,
    _key: e,
    getFragment: T
  }), Object.defineProperty($, "fragment", {
    configurable: !1,
    enumerable: !0,
    get: () => {
      const V = C.interface.getEvent(e);
      return assert$5(V, "no matching fragment", "UNSUPPORTED_OPERATION", {
        operation: "fragment",
        info: { key: e }
      }), V;
    }
  }), $;
}
const internal = Symbol.for("_ethersInternal_contract"), internalValues = /* @__PURE__ */ new WeakMap();
function setInternal(C, e) {
  internalValues.set(C[internal], e);
}
function getInternal(C) {
  return internalValues.get(C[internal]);
}
function isDeferred(C) {
  return C && typeof C == "object" && "getTopicFilter" in C && typeof C.getTopicFilter == "function" && C.fragment;
}
async function getSubInfo(C, e) {
  let T, $ = null;
  if (Array.isArray(e)) {
    const J = function(ee) {
      if (isHexString(ee, 32))
        return ee;
      const te = C.interface.getEvent(ee);
      return assertArgument(te, "unknown fragment", "name", ee), te.topicHash;
    };
    T = e.map((ee) => ee == null ? null : Array.isArray(ee) ? ee.map(J) : J(ee));
  } else e === "*" ? T = [null] : typeof e == "string" ? isHexString(e, 32) ? T = [e] : ($ = C.interface.getEvent(e), assertArgument($, "unknown fragment", "event", e), T = [$.topicHash]) : isDeferred(e) ? T = await e.getTopicFilter() : "fragment" in e ? ($ = e.fragment, T = [$.topicHash]) : assertArgument(!1, "unknown event name", "event", e);
  T = T.map((J) => {
    if (J == null)
      return null;
    if (Array.isArray(J)) {
      const ee = Array.from(new Set(J.map((te) => te.toLowerCase())).values());
      return ee.length === 1 ? ee[0] : (ee.sort(), ee);
    }
    return J.toLowerCase();
  });
  const V = T.map((J) => J == null ? "null" : Array.isArray(J) ? J.join("|") : J).join("&");
  return { fragment: $, tag: V, topics: T };
}
async function hasSub(C, e) {
  const { subs: T } = getInternal(C);
  return T.get((await getSubInfo(C, e)).tag) || null;
}
async function getSub(C, e, T) {
  const $ = getProvider$1(C.runner);
  assert$5($, "contract runner does not support subscribing", "UNSUPPORTED_OPERATION", { operation: e });
  const { fragment: V, tag: J, topics: ee } = await getSubInfo(C, T), { addr: te, subs: re } = getInternal(C);
  let ie = re.get(J);
  if (!ie) {
    const de = { address: te || C, topics: ee }, ue = (xe) => {
      let ve = V;
      if (ve == null)
        try {
          ve = C.interface.getEvent(xe.topics[0]);
        } catch {
        }
      if (ve) {
        const Te = ve, we = V ? C.interface.decodeEventLog(V, xe.data, xe.topics) : [];
        emit(C, T, we, (Ee) => new ContractEventPayload(C, Ee, T, Te, xe));
      } else
        emit(C, T, [], (Te) => new ContractUnknownEventPayload(C, Te, T, xe));
    };
    let fe = [];
    ie = { tag: J, listeners: [], start: () => {
      fe.length || fe.push($.on(de, ue));
    }, stop: async () => {
      if (fe.length == 0)
        return;
      let xe = fe;
      fe = [], await Promise.all(xe), $.off(de, ue);
    } }, re.set(J, ie);
  }
  return ie;
}
let lastEmit = Promise.resolve();
async function _emit(C, e, T, $) {
  await lastEmit;
  const V = await hasSub(C, e);
  if (!V)
    return !1;
  const J = V.listeners.length;
  return V.listeners = V.listeners.filter(({ listener: ee, once: te }) => {
    const re = Array.from(T);
    $ && re.push($(te ? null : ee));
    try {
      ee.call(C, ...re);
    } catch {
    }
    return !te;
  }), V.listeners.length === 0 && (V.stop(), getInternal(C).subs.delete(V.tag)), J > 0;
}
async function emit(C, e, T, $) {
  try {
    await lastEmit;
  } catch {
  }
  const V = _emit(C, e, T, $);
  return lastEmit = V, await V;
}
const passProperties = ["then"];
var Co;
Co = internal;
const us = class us {
  /**
   *  Creates a new contract connected to %%target%% with the %%abi%% and
   *  optionally connected to a %%runner%% to perform operations on behalf
   *  of.
   */
  constructor(e, T, $, V) {
    /**
     *  The target to connect to.
     *
     *  This can be an address, ENS name or any [[Addressable]], such as
     *  another contract. To get the resovled address, use the ``getAddress``
     *  method.
     */
    tt(this, "target");
    /**
     *  The contract Interface.
     */
    tt(this, "interface");
    /**
     *  The connected runner. This is generally a [[Provider]] or a
     *  [[Signer]], which dictates what operations are supported.
     *
     *  For example, a **Contract** connected to a [[Provider]] may
     *  only execute read-only operations.
     */
    tt(this, "runner");
    /**
     *  All the Events available on this contract.
     */
    tt(this, "filters");
    /**
     *  @_ignore:
     */
    tt(this, Co);
    /**
     *  The fallback or receive function if any.
     */
    tt(this, "fallback");
    assertArgument(typeof e == "string" || isAddressable(e), "invalid value for Contract target", "target", e), $ == null && ($ = null);
    const J = Interface.from(T);
    defineProperties(this, { target: e, runner: $, interface: J }), Object.defineProperty(this, internal, { value: {} });
    let ee, te = null, re = null;
    if (V) {
      const de = getProvider$1($);
      re = new ContractTransactionResponse(this.interface, de, V);
    }
    let ie = /* @__PURE__ */ new Map();
    if (typeof e == "string")
      if (isHexString(e))
        te = e, ee = Promise.resolve(e);
      else {
        const de = getRunner($, "resolveName");
        if (!canResolve(de))
          throw makeError("contract runner does not support name resolution", "UNSUPPORTED_OPERATION", {
            operation: "resolveName"
          });
        ee = de.resolveName(e).then((ue) => {
          if (ue == null)
            throw makeError("an ENS name used for a contract target must be correctly configured", "UNCONFIGURED_NAME", {
              value: e
            });
          return getInternal(this).addr = ue, ue;
        });
      }
    else
      ee = e.getAddress().then((de) => {
        if (de == null)
          throw new Error("TODO");
        return getInternal(this).addr = de, de;
      });
    setInternal(this, { addrPromise: ee, addr: te, deployTx: re, subs: ie });
    const se = new Proxy({}, {
      get: (de, ue, fe) => {
        if (typeof ue == "symbol" || passProperties.indexOf(ue) >= 0)
          return Reflect.get(de, ue, fe);
        try {
          return this.getEvent(ue);
        } catch (he) {
          if (!isError(he, "INVALID_ARGUMENT") || he.argument !== "key")
            throw he;
        }
      },
      has: (de, ue) => passProperties.indexOf(ue) >= 0 ? Reflect.has(de, ue) : Reflect.has(de, ue) || this.interface.hasEvent(String(ue))
    });
    return defineProperties(this, { filters: se }), defineProperties(this, {
      fallback: J.receive || J.fallback ? buildWrappedFallback(this) : null
    }), new Proxy(this, {
      get: (de, ue, fe) => {
        if (typeof ue == "symbol" || ue in de || passProperties.indexOf(ue) >= 0)
          return Reflect.get(de, ue, fe);
        try {
          return de.getFunction(ue);
        } catch (he) {
          if (!isError(he, "INVALID_ARGUMENT") || he.argument !== "key")
            throw he;
        }
      },
      has: (de, ue) => typeof ue == "symbol" || ue in de || passProperties.indexOf(ue) >= 0 ? Reflect.has(de, ue) : de.interface.hasFunction(ue)
    });
  }
  /**
   *  Return a new Contract instance with the same target and ABI, but
   *  a different %%runner%%.
   */
  connect(e) {
    return new us(this.target, this.interface, e);
  }
  /**
   *  Return a new Contract instance with the same ABI and runner, but
   *  a different %%target%%.
   */
  attach(e) {
    return new us(e, this.interface, this.runner);
  }
  /**
   *  Return the resolved address of this Contract.
   */
  async getAddress() {
    return await getInternal(this).addrPromise;
  }
  /**
   *  Return the deployed bytecode or null if no bytecode is found.
   */
  async getDeployedCode() {
    const e = getProvider$1(this.runner);
    assert$5(e, "runner does not support .provider", "UNSUPPORTED_OPERATION", { operation: "getDeployedCode" });
    const T = await e.getCode(await this.getAddress());
    return T === "0x" ? null : T;
  }
  /**
   *  Resolve to this Contract once the bytecode has been deployed, or
   *  resolve immediately if already deployed.
   */
  async waitForDeployment() {
    const e = this.deploymentTransaction();
    if (e)
      return await e.wait(), this;
    if (await this.getDeployedCode() != null)
      return this;
    const $ = getProvider$1(this.runner);
    return assert$5($ != null, "contract runner does not support .provider", "UNSUPPORTED_OPERATION", { operation: "waitForDeployment" }), new Promise((V, J) => {
      const ee = async () => {
        try {
          if (await this.getDeployedCode() != null)
            return V(this);
          $.once("block", ee);
        } catch (te) {
          J(te);
        }
      };
      ee();
    });
  }
  /**
   *  Return the transaction used to deploy this contract.
   *
   *  This is only available if this instance was returned from a
   *  [[ContractFactory]].
   */
  deploymentTransaction() {
    return getInternal(this).deployTx;
  }
  /**
   *  Return the function for a given name. This is useful when a contract
   *  method name conflicts with a JavaScript name such as ``prototype`` or
   *  when using a Contract programatically.
   */
  getFunction(e) {
    return typeof e != "string" && (e = e.format()), buildWrappedMethod(this, e);
  }
  /**
   *  Return the event for a given name. This is useful when a contract
   *  event name conflicts with a JavaScript name such as ``prototype`` or
   *  when using a Contract programatically.
   */
  getEvent(e) {
    return typeof e != "string" && (e = e.format()), buildWrappedEvent(this, e);
  }
  /**
   *  @_ignore:
   */
  async queryTransaction(e) {
    throw new Error("@TODO");
  }
  /*
      // @TODO: this is a non-backwards compatible change, but will be added
      //        in v7 and in a potential SmartContract class in an upcoming
      //        v6 release
      async getTransactionReceipt(hash: string): Promise<null | ContractTransactionReceipt> {
          const provider = getProvider(this.runner);
          assert(provider, "contract runner does not have a provider",
              "UNSUPPORTED_OPERATION", { operation: "queryTransaction" });
  
          const receipt = await provider.getTransactionReceipt(hash);
          if (receipt == null) { return null; }
  
          return new ContractTransactionReceipt(this.interface, provider, receipt);
      }
      */
  /**
   *  Provide historic access to event data for %%event%% in the range
   *  %%fromBlock%% (default: ``0``) to %%toBlock%% (default: ``"latest"``)
   *  inclusive.
   */
  async queryFilter(e, T, $) {
    T == null && (T = 0), $ == null && ($ = "latest");
    const { addr: V, addrPromise: J } = getInternal(this), ee = V || await J, { fragment: te, topics: re } = await getSubInfo(this, e), ie = { address: ee, topics: re, fromBlock: T, toBlock: $ }, se = getProvider$1(this.runner);
    return assert$5(se, "contract runner does not have a provider", "UNSUPPORTED_OPERATION", { operation: "queryFilter" }), (await se.getLogs(ie)).map((de) => {
      let ue = te;
      if (ue == null)
        try {
          ue = this.interface.getEvent(de.topics[0]);
        } catch {
        }
      if (ue)
        try {
          return new EventLog(de, this.interface, ue);
        } catch (fe) {
          return new UndecodedEventLog(de, fe);
        }
      return new Log(de, se);
    });
  }
  /**
   *  Add an event %%listener%% for the %%event%%.
   */
  async on(e, T) {
    const $ = await getSub(this, "on", e);
    return $.listeners.push({ listener: T, once: !1 }), $.start(), this;
  }
  /**
   *  Add an event %%listener%% for the %%event%%, but remove the listener
   *  after it is fired once.
   */
  async once(e, T) {
    const $ = await getSub(this, "once", e);
    return $.listeners.push({ listener: T, once: !0 }), $.start(), this;
  }
  /**
   *  Emit an %%event%% calling all listeners with %%args%%.
   *
   *  Resolves to ``true`` if any listeners were called.
   */
  async emit(e, ...T) {
    return await emit(this, e, T, null);
  }
  /**
   *  Resolves to the number of listeners of %%event%% or the total number
   *  of listeners if unspecified.
   */
  async listenerCount(e) {
    if (e) {
      const V = await hasSub(this, e);
      return V ? V.listeners.length : 0;
    }
    const { subs: T } = getInternal(this);
    let $ = 0;
    for (const { listeners: V } of T.values())
      $ += V.length;
    return $;
  }
  /**
   *  Resolves to the listeners subscribed to %%event%% or all listeners
   *  if unspecified.
   */
  async listeners(e) {
    if (e) {
      const V = await hasSub(this, e);
      return V ? V.listeners.map(({ listener: J }) => J) : [];
    }
    const { subs: T } = getInternal(this);
    let $ = [];
    for (const { listeners: V } of T.values())
      $ = $.concat(V.map(({ listener: J }) => J));
    return $;
  }
  /**
   *  Remove the %%listener%% from the listeners for %%event%% or remove
   *  all listeners if unspecified.
   */
  async off(e, T) {
    const $ = await hasSub(this, e);
    if (!$)
      return this;
    if (T) {
      const V = $.listeners.map(({ listener: J }) => J).indexOf(T);
      V >= 0 && $.listeners.splice(V, 1);
    }
    return (T == null || $.listeners.length === 0) && ($.stop(), getInternal(this).subs.delete($.tag)), this;
  }
  /**
   *  Remove all the listeners for %%event%% or remove all listeners if
   *  unspecified.
   */
  async removeAllListeners(e) {
    if (e) {
      const T = await hasSub(this, e);
      if (!T)
        return this;
      T.stop(), getInternal(this).subs.delete(T.tag);
    } else {
      const { subs: T } = getInternal(this);
      for (const { tag: $, stop: V } of T.values())
        V(), T.delete($);
    }
    return this;
  }
  /**
   *  Alias for [on].
   */
  async addListener(e, T) {
    return await this.on(e, T);
  }
  /**
   *  Alias for [off].
   */
  async removeListener(e, T) {
    return await this.off(e, T);
  }
  /**
   *  Create a new Class for the %%abi%%.
   */
  static buildClass(e) {
    class T extends us {
      constructor(V, J = null) {
        super(V, e, J);
      }
    }
    return T;
  }
  /**
   *  Create a new BaseContract with a specified Interface.
   */
  static from(e, T, $) {
    return $ == null && ($ = null), new this(e, T, $);
  }
};
let BaseContract = us;
function _ContractBase() {
  return BaseContract;
}
class Contract extends _ContractBase() {
}
class ContractFactory {
  /**
   *  Create a new **ContractFactory** with %%abi%% and %%bytecode%%,
   *  optionally connected to %%runner%%.
   *
   *  The %%bytecode%% may be the ``bytecode`` property within the
   *  standard Solidity JSON output.
   */
  constructor(e, T, $) {
    /**
     *  The Contract Interface.
     */
    tt(this, "interface");
    /**
     *  The Contract deployment bytecode. Often called the initcode.
     */
    tt(this, "bytecode");
    /**
     *  The ContractRunner to deploy the Contract as.
     */
    tt(this, "runner");
    const V = Interface.from(e);
    T instanceof Uint8Array || (typeof T == "object" && (T = T.object), T.startsWith("0x") || (T = "0x" + T)), T = hexlify(getBytes(T)), defineProperties(this, {
      bytecode: T,
      interface: V,
      runner: $ || null
    });
  }
  attach(e) {
    return new BaseContract(e, this.interface, this.runner);
  }
  /**
   *  Resolves to the transaction to deploy the contract, passing %%args%%
   *  into the constructor.
   */
  async getDeployTransaction(...e) {
    let T = {};
    const $ = this.interface.deploy;
    if ($.inputs.length + 1 === e.length && (T = await copyOverrides(e.pop())), $.inputs.length !== e.length)
      throw new Error("incorrect number of arguments to constructor");
    const V = await resolveArgs(this.runner, $.inputs, e), J = concat([this.bytecode, this.interface.encodeDeploy(V)]);
    return Object.assign({}, T, { data: J });
  }
  /**
   *  Resolves to the Contract deployed by passing %%args%% into the
   *  constructor.
   *
   *  This will resolve to the Contract before it has been deployed to the
   *  network, so the [[BaseContract-waitForDeployment]] should be used before
   *  sending any transactions to it.
   */
  async deploy(...e) {
    const T = await this.getDeployTransaction(...e);
    assert$5(this.runner && typeof this.runner.sendTransaction == "function", "factory runner does not support sending transactions", "UNSUPPORTED_OPERATION", {
      operation: "sendTransaction"
    });
    const $ = await this.runner.sendTransaction(T), V = getCreateAddress($);
    return new BaseContract(V, this.interface, this.runner, $);
  }
  /**
   *  Return a new **ContractFactory** with the same ABI and bytecode,
   *  but connected to %%runner%%.
   */
  connect(e) {
    return new ContractFactory(this.interface, this.bytecode, e);
  }
  /**
   *  Create a new **ContractFactory** from the standard Solidity JSON output.
   */
  static fromSolidity(e, T) {
    assertArgument(e != null, "bad compiler output", "output", e), typeof e == "string" && (e = JSON.parse(e));
    const $ = e.abi;
    let V = "";
    return e.bytecode ? V = e.bytecode : e.evm && e.evm.bytecode && (V = e.evm.bytecode), new this($, V, T);
  }
}
function getIpfsLink(C) {
  return C.match(/^ipfs:\/\/ipfs\//i) ? C = C.substring(12) : C.match(/^ipfs:\/\//i) ? C = C.substring(7) : assertArgument(!1, "unsupported IPFS format", "link", C), `https://gateway.ipfs.io/ipfs/${C}`;
}
class MulticoinProviderPlugin {
  /**
   *  Creates a new **MulticoinProviderPluing** for %%name%%.
   */
  constructor(e) {
    /**
     *  The name.
     */
    tt(this, "name");
    defineProperties(this, { name: e });
  }
  connect(e) {
    return this;
  }
  /**
   *  Returns ``true`` if %%coinType%% is supported by this plugin.
   */
  supportsCoinType(e) {
    return !1;
  }
  /**
   *  Resolves to the encoded %%address%% for %%coinType%%.
   */
  async encodeAddress(e, T) {
    throw new Error("unsupported coin");
  }
  /**
   *  Resolves to the decoded %%data%% for %%coinType%%.
   */
  async decodeAddress(e, T) {
    throw new Error("unsupported coin");
  }
}
const matcherIpfs = new RegExp("^(ipfs)://(.*)$", "i"), matchers = [
  new RegExp("^(https)://(.*)$", "i"),
  new RegExp("^(data):(.*)$", "i"),
  matcherIpfs,
  new RegExp("^eip155:[0-9]+/(erc[0-9]+):(.*)$", "i")
];
var hi, Qi, mi, fa, Ys, Io;
const ha = class ha {
  constructor(e, T, $) {
    Ft(this, mi);
    /**
     *  The connected provider.
     */
    tt(this, "provider");
    /**
     *  The address of the resolver.
     */
    tt(this, "address");
    /**
     *  The name this resolver was resolved against.
     */
    tt(this, "name");
    // For EIP-2544 names, the ancestor that provided the resolver
    Ft(this, hi);
    Ft(this, Qi);
    defineProperties(this, { provider: e, address: T, name: $ }), At(this, hi, null), At(this, Qi, new Contract(T, [
      "function supportsInterface(bytes4) view returns (bool)",
      "function resolve(bytes, bytes) view returns (bytes)",
      "function addr(bytes32) view returns (address)",
      "function addr(bytes32, uint) view returns (bytes)",
      "function text(bytes32, string) view returns (string)",
      "function contenthash(bytes32) view returns (bytes)"
    ], e));
  }
  /**
   *  Resolves to true if the resolver supports wildcard resolution.
   */
  async supportsWildcard() {
    return rt(this, hi) == null && At(this, hi, (async () => {
      try {
        return await rt(this, Qi).supportsInterface("0x9061b923");
      } catch (e) {
        if (isError(e, "CALL_EXCEPTION"))
          return !1;
        throw At(this, hi, null), e;
      }
    })()), await rt(this, hi);
  }
  /**
   *  Resolves to the address for %%coinType%% or null if the
   *  provided %%coinType%% has not been configured.
   */
  async getAddress(e) {
    if (e == null && (e = 60), e === 60)
      try {
        const J = await Qt(this, mi, fa).call(this, "addr(bytes32)");
        return J == null || J === ZeroAddress ? null : J;
      } catch (J) {
        if (isError(J, "CALL_EXCEPTION"))
          return null;
        throw J;
      }
    if (e >= 0 && e < 2147483648) {
      let J = e + 2147483648;
      const ee = await Qt(this, mi, fa).call(this, "addr(bytes32,uint)", [J]);
      if (isHexString(ee, 20))
        return getAddress(ee);
    }
    let T = null;
    for (const J of this.provider.plugins)
      if (J instanceof MulticoinProviderPlugin && J.supportsCoinType(e)) {
        T = J;
        break;
      }
    if (T == null)
      return null;
    const $ = await Qt(this, mi, fa).call(this, "addr(bytes32,uint)", [e]);
    if ($ == null || $ === "0x")
      return null;
    const V = await T.decodeAddress(e, $);
    if (V != null)
      return V;
    assert$5(!1, "invalid coin data", "UNSUPPORTED_OPERATION", {
      operation: `getAddress(${e})`,
      info: { coinType: e, data: $ }
    });
  }
  /**
   *  Resolves to the EIP-634 text record for %%key%%, or ``null``
   *  if unconfigured.
   */
  async getText(e) {
    const T = await Qt(this, mi, fa).call(this, "text(bytes32,string)", [e]);
    return T == null || T === "0x" ? null : T;
  }
  /**
   *  Rsolves to the content-hash or ``null`` if unconfigured.
   */
  async getContentHash() {
    const e = await Qt(this, mi, fa).call(this, "contenthash(bytes32)");
    if (e == null || e === "0x")
      return null;
    const T = e.match(/^0x(e3010170|e5010172)(([0-9a-f][0-9a-f])([0-9a-f][0-9a-f])([0-9a-f]*))$/);
    if (T) {
      const V = T[1] === "e3010170" ? "ipfs" : "ipns", J = parseInt(T[4], 16);
      if (T[5].length === J * 2)
        return `${V}://${encodeBase58("0x" + T[2])}`;
    }
    const $ = e.match(/^0xe40101fa011b20([0-9a-f]*)$/);
    if ($ && $[1].length === 64)
      return `bzz://${$[1]}`;
    assert$5(!1, "invalid or unsupported content hash data", "UNSUPPORTED_OPERATION", {
      operation: "getContentHash()",
      info: { data: e }
    });
  }
  /**
   *  Resolves to the avatar url or ``null`` if the avatar is either
   *  unconfigured or incorrectly configured (e.g. references an NFT
   *  not owned by the address).
   *
   *  If diagnosing issues with configurations, the [[_getAvatar]]
   *  method may be useful.
   */
  async getAvatar() {
    return (await this._getAvatar()).url;
  }
  /**
   *  When resolving an avatar, there are many steps involved, such
   *  fetching metadata and possibly validating ownership of an
   *  NFT.
   *
   *  This method can be used to examine each step and the value it
   *  was working from.
   */
  async _getAvatar() {
    const e = [{ type: "name", value: this.name }];
    try {
      const T = await this.getText("avatar");
      if (T == null)
        return e.push({ type: "!avatar", value: "" }), { url: null, linkage: e };
      e.push({ type: "avatar", value: T });
      for (let $ = 0; $ < matchers.length; $++) {
        const V = T.match(matchers[$]);
        if (V == null)
          continue;
        const J = V[1].toLowerCase();
        switch (J) {
          case "https":
          case "data":
            return e.push({ type: "url", value: T }), { linkage: e, url: T };
          case "ipfs": {
            const ee = getIpfsLink(T);
            return e.push({ type: "ipfs", value: T }), e.push({ type: "url", value: ee }), { linkage: e, url: ee };
          }
          case "erc721":
          case "erc1155": {
            const ee = J === "erc721" ? "tokenURI(uint256)" : "uri(uint256)";
            e.push({ type: J, value: T });
            const te = await this.getAddress();
            if (te == null)
              return e.push({ type: "!owner", value: "" }), { url: null, linkage: e };
            const re = (V[2] || "").split("/");
            if (re.length !== 2)
              return e.push({ type: `!${J}caip`, value: V[2] || "" }), { url: null, linkage: e };
            const ie = re[1], se = new Contract(re[0], [
              // ERC-721
              "function tokenURI(uint) view returns (string)",
              "function ownerOf(uint) view returns (address)",
              // ERC-1155
              "function uri(uint) view returns (string)",
              "function balanceOf(address, uint256) view returns (uint)"
            ], this.provider);
            if (J === "erc721") {
              const me = await se.ownerOf(ie);
              if (te !== me)
                return e.push({ type: "!owner", value: me }), { url: null, linkage: e };
              e.push({ type: "owner", value: me });
            } else if (J === "erc1155") {
              const me = await se.balanceOf(te, ie);
              if (!me)
                return e.push({ type: "!balance", value: "0" }), { url: null, linkage: e };
              e.push({ type: "balance", value: me.toString() });
            }
            let de = await se[ee](ie);
            if (de == null || de === "0x")
              return e.push({ type: "!metadata-url", value: "" }), { url: null, linkage: e };
            e.push({ type: "metadata-url-base", value: de }), J === "erc1155" && (de = de.replace("{id}", toBeHex(ie, 32).substring(2)), e.push({ type: "metadata-url-expanded", value: de })), de.match(/^ipfs:/i) && (de = getIpfsLink(de)), e.push({ type: "metadata-url", value: de });
            let ue = {};
            const fe = await new FetchRequest(de).send();
            fe.assertOk();
            try {
              ue = fe.bodyJson;
            } catch {
              try {
                e.push({ type: "!metadata", value: fe.bodyText });
              } catch {
                const ve = fe.body;
                return ve && e.push({ type: "!metadata", value: hexlify(ve) }), { url: null, linkage: e };
              }
              return { url: null, linkage: e };
            }
            if (!ue)
              return e.push({ type: "!metadata", value: "" }), { url: null, linkage: e };
            e.push({ type: "metadata", value: JSON.stringify(ue) });
            let he = ue.image;
            if (typeof he != "string")
              return e.push({ type: "!imageUrl", value: "" }), { url: null, linkage: e };
            if (!he.match(/^(https:\/\/|data:)/i)) {
              if (he.match(matcherIpfs) == null)
                return e.push({ type: "!imageUrl-ipfs", value: he }), { url: null, linkage: e };
              e.push({ type: "imageUrl-ipfs", value: he }), he = getIpfsLink(he);
            }
            return e.push({ type: "url", value: he }), { linkage: e, url: he };
          }
        }
      }
    } catch {
    }
    return { linkage: e, url: null };
  }
  static async getEnsAddress(e) {
    const T = await e.getNetwork(), $ = T.getPlugin("org.ethers.plugins.network.Ens");
    return assert$5($, "network does not support ENS", "UNSUPPORTED_OPERATION", {
      operation: "getEnsAddress",
      info: { network: T }
    }), $.address;
  }
  /**
   *  Resolve to the ENS resolver for %%name%% using %%provider%% or
   *  ``null`` if unconfigured.
   */
  static async fromName(e, T) {
    var V;
    let $ = T;
    for (; ; ) {
      if ($ === "" || $ === "." || T !== "eth" && $ === "eth")
        return null;
      const J = await Qt(V = ha, Ys, Io).call(V, e, $);
      if (J != null) {
        const ee = new ha(e, J, T);
        return $ !== T && !await ee.supportsWildcard() ? null : ee;
      }
      $ = $.split(".").slice(1).join(".");
    }
  }
};
hi = new WeakMap(), Qi = new WeakMap(), mi = new WeakSet(), fa = async function(e, T) {
  T = (T || []).slice();
  const $ = rt(this, Qi).interface;
  T.unshift(namehash(this.name));
  let V = null;
  await this.supportsWildcard() && (V = $.getFunction(e), assert$5(V, "missing fragment", "UNKNOWN_ERROR", {
    info: { funcName: e }
  }), T = [
    dnsEncode(this.name, 255),
    $.encodeFunctionData(V, T)
  ], e = "resolve(bytes,bytes)"), T.push({
    enableCcipRead: !0
  });
  try {
    const J = await rt(this, Qi)[e](...T);
    return V ? $.decodeFunctionResult(V, J)[0] : J;
  } catch (J) {
    if (!isError(J, "CALL_EXCEPTION"))
      throw J;
  }
  return null;
}, Ys = new WeakSet(), Io = async function(e, T) {
  const $ = await ha.getEnsAddress(e);
  try {
    const J = await new Contract($, [
      "function resolver(bytes32) view returns (address)"
    ], e).resolver(namehash(T), {
      enableCcipRead: !0
    });
    return J === ZeroAddress ? null : J;
  } catch (V) {
    throw V;
  }
  return null;
}, Ft(ha, Ys);
let EnsResolver = ha;
const BN_0 = BigInt(0);
function allowNull(C, e) {
  return function(T) {
    return T == null ? e : C(T);
  };
}
function arrayOf(C, e) {
  return (T) => {
    if (e && T == null)
      return null;
    if (!Array.isArray(T))
      throw new Error("not an array");
    return T.map(($) => C($));
  };
}
function object$1(C, e) {
  return (T) => {
    const $ = {};
    for (const V in C) {
      let J = V;
      if (e && V in e && !(J in T)) {
        for (const ee of e[V])
          if (ee in T) {
            J = ee;
            break;
          }
      }
      try {
        const ee = C[V](T[J]);
        ee !== void 0 && ($[V] = ee);
      } catch (ee) {
        const te = ee instanceof Error ? ee.message : "not-an-error";
        assert$5(!1, `invalid value for value.${V} (${te})`, "BAD_DATA", { value: T });
      }
    }
    return $;
  };
}
function formatBoolean(C) {
  switch (C) {
    case !0:
    case "true":
      return !0;
    case !1:
    case "false":
      return !1;
  }
  assertArgument(!1, `invalid boolean; ${JSON.stringify(C)}`, "value", C);
}
function formatData(C) {
  return assertArgument(isHexString(C, !0), "invalid data", "value", C), C;
}
function formatHash(C) {
  return assertArgument(isHexString(C, 32), "invalid hash", "value", C), C;
}
const _formatLog = object$1({
  address: getAddress,
  blockHash: formatHash,
  blockNumber: getNumber,
  data: formatData,
  index: getNumber,
  removed: allowNull(formatBoolean, !1),
  topics: arrayOf(formatHash),
  transactionHash: formatHash,
  transactionIndex: getNumber
}, {
  index: ["logIndex"]
});
function formatLog(C) {
  return _formatLog(C);
}
const _formatBlock = object$1({
  hash: allowNull(formatHash),
  parentHash: formatHash,
  parentBeaconBlockRoot: allowNull(formatHash, null),
  number: getNumber,
  timestamp: getNumber,
  nonce: allowNull(formatData),
  difficulty: getBigInt,
  gasLimit: getBigInt,
  gasUsed: getBigInt,
  stateRoot: allowNull(formatHash, null),
  receiptsRoot: allowNull(formatHash, null),
  blobGasUsed: allowNull(getBigInt, null),
  excessBlobGas: allowNull(getBigInt, null),
  miner: allowNull(getAddress),
  prevRandao: allowNull(formatHash, null),
  extraData: formatData,
  baseFeePerGas: allowNull(getBigInt)
}, {
  prevRandao: ["mixHash"]
});
function formatBlock(C) {
  const e = _formatBlock(C);
  return e.transactions = C.transactions.map((T) => typeof T == "string" ? T : formatTransactionResponse(T)), e;
}
const _formatReceiptLog = object$1({
  transactionIndex: getNumber,
  blockNumber: getNumber,
  transactionHash: formatHash,
  address: getAddress,
  topics: arrayOf(formatHash),
  data: formatData,
  index: getNumber,
  blockHash: formatHash
}, {
  index: ["logIndex"]
});
function formatReceiptLog(C) {
  return _formatReceiptLog(C);
}
const _formatTransactionReceipt = object$1({
  to: allowNull(getAddress, null),
  from: allowNull(getAddress, null),
  contractAddress: allowNull(getAddress, null),
  // should be allowNull(hash), but broken-EIP-658 support is handled in receipt
  index: getNumber,
  root: allowNull(hexlify),
  gasUsed: getBigInt,
  blobGasUsed: allowNull(getBigInt, null),
  logsBloom: allowNull(formatData),
  blockHash: formatHash,
  hash: formatHash,
  logs: arrayOf(formatReceiptLog),
  blockNumber: getNumber,
  //confirmations: allowNull(getNumber, null),
  cumulativeGasUsed: getBigInt,
  effectiveGasPrice: allowNull(getBigInt),
  blobGasPrice: allowNull(getBigInt, null),
  status: allowNull(getNumber),
  type: allowNull(getNumber, 0)
}, {
  effectiveGasPrice: ["gasPrice"],
  hash: ["transactionHash"],
  index: ["transactionIndex"]
});
function formatTransactionReceipt(C) {
  return _formatTransactionReceipt(C);
}
function formatTransactionResponse(C) {
  C.to && getBigInt(C.to) === BN_0 && (C.to = "0x0000000000000000000000000000000000000000");
  const e = object$1({
    hash: formatHash,
    // Some nodes do not return this, usually test nodes (like Ganache)
    index: allowNull(getNumber, void 0),
    type: (T) => T === "0x" || T == null ? 0 : getNumber(T),
    accessList: allowNull(accessListify, null),
    blobVersionedHashes: allowNull(arrayOf(formatHash, !0), null),
    blockHash: allowNull(formatHash, null),
    blockNumber: allowNull(getNumber, null),
    transactionIndex: allowNull(getNumber, null),
    from: getAddress,
    // either (gasPrice) or (maxPriorityFeePerGas + maxFeePerGas) must be set
    gasPrice: allowNull(getBigInt),
    maxPriorityFeePerGas: allowNull(getBigInt),
    maxFeePerGas: allowNull(getBigInt),
    maxFeePerBlobGas: allowNull(getBigInt, null),
    gasLimit: getBigInt,
    to: allowNull(getAddress, null),
    value: getBigInt,
    nonce: getNumber,
    data: formatData,
    creates: allowNull(getAddress, null),
    chainId: allowNull(getBigInt, null)
  }, {
    data: ["input"],
    gasLimit: ["gas"],
    index: ["transactionIndex"]
  })(C);
  if (e.to == null && e.creates == null && (e.creates = getCreateAddress(e)), (C.type === 1 || C.type === 2) && C.accessList == null && (e.accessList = []), C.signature ? e.signature = Signature$1.from(C.signature) : e.signature = Signature$1.from(C), e.chainId == null) {
    const T = e.signature.legacyChainId;
    T != null && (e.chainId = T);
  }
  return e.blockHash && getBigInt(e.blockHash) === BN_0 && (e.blockHash = null), e;
}
const EnsAddress = "0x00000000000C2E074eC69A0dFb2997BA6C7d2e1e";
class NetworkPlugin {
  /**
   *  Creates a new **NetworkPlugin**.
   */
  constructor(e) {
    /**
     *  The name of the plugin.
     *
     *  It is recommended to use reverse-domain-notation, which permits
     *  unique names with a known authority as well as hierarchal entries.
     */
    tt(this, "name");
    defineProperties(this, { name: e });
  }
  /**
   *  Creates a copy of this plugin.
   */
  clone() {
    return new NetworkPlugin(this.name);
  }
}
class GasCostPlugin extends NetworkPlugin {
  /**
   *  Creates a new GasCostPlugin from %%effectiveBlock%% until the
   *  latest block or another GasCostPlugin supercedes that block number,
   *  with the associated %%costs%%.
   */
  constructor(T, $) {
    T == null && (T = 0);
    super(`org.ethers.network.plugins.GasCost#${T || 0}`);
    /**
     *  The block number to treat these values as valid from.
     *
     *  This allows a hardfork to have updated values included as well as
     *  mulutiple hardforks to be supported.
     */
    tt(this, "effectiveBlock");
    /**
     *  The transactions base fee.
     */
    tt(this, "txBase");
    /**
     *  The fee for creating a new account.
     */
    tt(this, "txCreate");
    /**
     *  The fee per zero-byte in the data.
     */
    tt(this, "txDataZero");
    /**
     *  The fee per non-zero-byte in the data.
     */
    tt(this, "txDataNonzero");
    /**
     *  The fee per storage key in the [[link-eip-2930]] access list.
     */
    tt(this, "txAccessListStorageKey");
    /**
     *  The fee per address in the [[link-eip-2930]] access list.
     */
    tt(this, "txAccessListAddress");
    const V = { effectiveBlock: T };
    function J(ee, te) {
      let re = ($ || {})[ee];
      re == null && (re = te), assertArgument(typeof re == "number", `invalud value for ${ee}`, "costs", $), V[ee] = re;
    }
    J("txBase", 21e3), J("txCreate", 32e3), J("txDataZero", 4), J("txDataNonzero", 16), J("txAccessListStorageKey", 1900), J("txAccessListAddress", 2400), defineProperties(this, V);
  }
  clone() {
    return new GasCostPlugin(this.effectiveBlock, this);
  }
}
class EnsPlugin extends NetworkPlugin {
  /**
   *  Creates a new **EnsPlugin** connected to %%address%% on the
   *  %%targetNetwork%%. The default ENS address and mainnet is used
   *  if unspecified.
   */
  constructor(T, $) {
    super("org.ethers.plugins.network.Ens");
    /**
     *  The ENS Registrty Contract address.
     */
    tt(this, "address");
    /**
     *  The chain ID that the ENS contract lives on.
     */
    tt(this, "targetNetwork");
    defineProperties(this, {
      address: T || EnsAddress,
      targetNetwork: $ ?? 1
    });
  }
  clone() {
    return new EnsPlugin(this.address, this.targetNetwork);
  }
}
var ws, Ts;
class FetchUrlFeeDataNetworkPlugin extends NetworkPlugin {
  /**
   *  Creates a new **FetchUrlFeeDataNetworkPlugin** which will
   *  be used when computing the fee data for the network.
   */
  constructor(T, $) {
    super("org.ethers.plugins.network.FetchUrlFeeDataPlugin");
    Ft(this, ws);
    Ft(this, Ts);
    At(this, ws, T), At(this, Ts, $);
  }
  /**
   *  The URL to initialize the FetchRequest with in %%processFunc%%.
   */
  get url() {
    return rt(this, ws);
  }
  /**
   *  The callback to use when computing the FeeData.
   */
  get processFunc() {
    return rt(this, Ts);
  }
  // We are immutable, so we can serve as our own clone
  clone() {
    return this;
  }
}
ws = new WeakMap(), Ts = new WeakMap();
const Networks = /* @__PURE__ */ new Map();
var za, Wa, bi;
const ma = class ma {
  /**
   *  Creates a new **Network** for %%name%% and %%chainId%%.
   */
  constructor(e, T) {
    Ft(this, za);
    Ft(this, Wa);
    Ft(this, bi);
    At(this, za, e), At(this, Wa, getBigInt(T)), At(this, bi, /* @__PURE__ */ new Map());
  }
  /**
   *  Returns a JSON-compatible representation of a Network.
   */
  toJSON() {
    return { name: this.name, chainId: String(this.chainId) };
  }
  /**
   *  The network common name.
   *
   *  This is the canonical name, as networks migh have multiple
   *  names.
   */
  get name() {
    return rt(this, za);
  }
  set name(e) {
    At(this, za, e);
  }
  /**
   *  The network chain ID.
   */
  get chainId() {
    return rt(this, Wa);
  }
  set chainId(e) {
    At(this, Wa, getBigInt(e, "chainId"));
  }
  /**
   *  Returns true if %%other%% matches this network. Any chain ID
   *  must match, and if no chain ID is present, the name must match.
   *
   *  This method does not currently check for additional properties,
   *  such as ENS address or plug-in compatibility.
   */
  matches(e) {
    if (e == null)
      return !1;
    if (typeof e == "string") {
      try {
        return this.chainId === getBigInt(e);
      } catch {
      }
      return this.name === e;
    }
    if (typeof e == "number" || typeof e == "bigint") {
      try {
        return this.chainId === getBigInt(e);
      } catch {
      }
      return !1;
    }
    if (typeof e == "object") {
      if (e.chainId != null) {
        try {
          return this.chainId === getBigInt(e.chainId);
        } catch {
        }
        return !1;
      }
      return e.name != null ? this.name === e.name : !1;
    }
    return !1;
  }
  /**
   *  Returns the list of plugins currently attached to this Network.
   */
  get plugins() {
    return Array.from(rt(this, bi).values());
  }
  /**
   *  Attach a new %%plugin%% to this Network. The network name
   *  must be unique, excluding any fragment.
   */
  attachPlugin(e) {
    if (rt(this, bi).get(e.name))
      throw new Error(`cannot replace existing plugin: ${e.name} `);
    return rt(this, bi).set(e.name, e.clone()), this;
  }
  /**
   *  Return the plugin, if any, matching %%name%% exactly. Plugins
   *  with fragments will not be returned unless %%name%% includes
   *  a fragment.
   */
  getPlugin(e) {
    return rt(this, bi).get(e) || null;
  }
  /**
   *  Gets a list of all plugins that match %%name%%, with otr without
   *  a fragment.
   */
  getPlugins(e) {
    return this.plugins.filter((T) => T.name.split("#")[0] === e);
  }
  /**
   *  Create a copy of this Network.
   */
  clone() {
    const e = new ma(this.name, this.chainId);
    return this.plugins.forEach((T) => {
      e.attachPlugin(T.clone());
    }), e;
  }
  /**
   *  Compute the intrinsic gas required for a transaction.
   *
   *  A GasCostPlugin can be attached to override the default
   *  values.
   */
  computeIntrinsicGas(e) {
    const T = this.getPlugin("org.ethers.plugins.network.GasCost") || new GasCostPlugin();
    let $ = T.txBase;
    if (e.to == null && ($ += T.txCreate), e.data)
      for (let V = 2; V < e.data.length; V += 2)
        e.data.substring(V, V + 2) === "00" ? $ += T.txDataZero : $ += T.txDataNonzero;
    if (e.accessList) {
      const V = accessListify(e.accessList);
      for (const J in V)
        $ += T.txAccessListAddress + T.txAccessListStorageKey * V[J].storageKeys.length;
    }
    return $;
  }
  /**
   *  Returns a new Network for the %%network%% name or chainId.
   */
  static from(e) {
    if (injectCommonNetworks(), e == null)
      return ma.from("mainnet");
    if (typeof e == "number" && (e = BigInt(e)), typeof e == "string" || typeof e == "bigint") {
      const T = Networks.get(e);
      if (T)
        return T();
      if (typeof e == "bigint")
        return new ma("unknown", e);
      assertArgument(!1, "unknown network", "network", e);
    }
    if (typeof e.clone == "function")
      return e.clone();
    if (typeof e == "object") {
      assertArgument(typeof e.name == "string" && typeof e.chainId == "number", "invalid network object name or chainId", "network", e);
      const T = new ma(e.name, e.chainId);
      return (e.ensAddress || e.ensNetwork != null) && T.attachPlugin(new EnsPlugin(e.ensAddress, e.ensNetwork)), T;
    }
    assertArgument(!1, "invalid network", "network", e);
  }
  /**
   *  Register %%nameOrChainId%% with a function which returns
   *  an instance of a Network representing that chain.
   */
  static register(e, T) {
    typeof e == "number" && (e = BigInt(e));
    const $ = Networks.get(e);
    $ && assertArgument(!1, `conflicting network for ${JSON.stringify($.name)}`, "nameOrChainId", e), Networks.set(e, T);
  }
};
za = new WeakMap(), Wa = new WeakMap(), bi = new WeakMap();
let Network = ma;
function parseUnits(C, e) {
  const T = String(C);
  if (!T.match(/^[0-9.]+$/))
    throw new Error(`invalid gwei value: ${C}`);
  const $ = T.split(".");
  if ($.length === 1 && $.push(""), $.length !== 2)
    throw new Error(`invalid gwei value: ${C}`);
  for (; $[1].length < e; )
    $[1] += "0";
  if ($[1].length > 9) {
    let V = BigInt($[1].substring(0, 9));
    $[1].substring(9).match(/^0+$/) || V++, $[1] = V.toString();
  }
  return BigInt($[0] + $[1]);
}
function getGasStationPlugin(C) {
  return new FetchUrlFeeDataNetworkPlugin(C, async (e, T, $) => {
    $.setHeader("User-Agent", "ethers");
    let V;
    try {
      const [J, ee] = await Promise.all([
        $.send(),
        e()
      ]);
      V = J;
      const te = V.bodyJson.standard;
      return {
        gasPrice: ee.gasPrice,
        maxFeePerGas: parseUnits(te.maxFee, 9),
        maxPriorityFeePerGas: parseUnits(te.maxPriorityFee, 9)
      };
    } catch (J) {
      assert$5(!1, `error encountered with polygon gas station (${JSON.stringify($.url)})`, "SERVER_ERROR", { request: $, response: V, error: J });
    }
  });
}
let injected = !1;
function injectCommonNetworks() {
  if (injected)
    return;
  injected = !0;
  function C(e, T, $) {
    const V = function() {
      const J = new Network(e, T);
      return $.ensNetwork != null && J.attachPlugin(new EnsPlugin(null, $.ensNetwork)), J.attachPlugin(new GasCostPlugin()), ($.plugins || []).forEach((ee) => {
        J.attachPlugin(ee);
      }), J;
    };
    Network.register(e, V), Network.register(T, V), $.altNames && $.altNames.forEach((J) => {
      Network.register(J, V);
    });
  }
  C("mainnet", 1, { ensNetwork: 1, altNames: ["homestead"] }), C("ropsten", 3, { ensNetwork: 3 }), C("rinkeby", 4, { ensNetwork: 4 }), C("goerli", 5, { ensNetwork: 5 }), C("kovan", 42, { ensNetwork: 42 }), C("sepolia", 11155111, { ensNetwork: 11155111 }), C("holesky", 17e3, { ensNetwork: 17e3 }), C("classic", 61, {}), C("classicKotti", 6, {}), C("arbitrum", 42161, {
    ensNetwork: 1
  }), C("arbitrum-goerli", 421613, {}), C("arbitrum-sepolia", 421614, {}), C("base", 8453, { ensNetwork: 1 }), C("base-goerli", 84531, {}), C("base-sepolia", 84532, {}), C("bnb", 56, { ensNetwork: 1 }), C("bnbt", 97, {}), C("linea", 59144, { ensNetwork: 1 }), C("linea-goerli", 59140, {}), C("linea-sepolia", 59141, {}), C("matic", 137, {
    ensNetwork: 1,
    plugins: [
      getGasStationPlugin("https://gasstation.polygon.technology/v2")
    ]
  }), C("matic-amoy", 80002, {}), C("matic-mumbai", 80001, {
    altNames: ["maticMumbai", "maticmum"],
    plugins: [
      getGasStationPlugin("https://gasstation-testnet.polygon.technology/v2")
    ]
  }), C("optimism", 10, {
    ensNetwork: 1,
    plugins: []
  }), C("optimism-goerli", 420, {}), C("optimism-sepolia", 11155420, {}), C("xdai", 100, { ensNetwork: 1 });
}
function copy$2(C) {
  return JSON.parse(JSON.stringify(C));
}
var ei, br, gi, _r, Ha, $s;
class PollingBlockSubscriber {
  /**
   *  Create a new **PollingBlockSubscriber** attached to %%provider%%.
   */
  constructor(e) {
    Ft(this, Ha);
    Ft(this, ei);
    Ft(this, br);
    Ft(this, gi);
    // The most recent block we have scanned for events. The value -2
    // indicates we still need to fetch an initial block number
    Ft(this, _r);
    At(this, ei, e), At(this, br, null), At(this, gi, 4e3), At(this, _r, -2);
  }
  /**
   *  The polling interval.
   */
  get pollingInterval() {
    return rt(this, gi);
  }
  set pollingInterval(e) {
    At(this, gi, e);
  }
  start() {
    rt(this, br) || (At(this, br, rt(this, ei)._setTimeout(Qt(this, Ha, $s).bind(this), rt(this, gi))), Qt(this, Ha, $s).call(this));
  }
  stop() {
    rt(this, br) && (rt(this, ei)._clearTimeout(rt(this, br)), At(this, br, null));
  }
  pause(e) {
    this.stop(), e && At(this, _r, -2);
  }
  resume() {
    this.start();
  }
}
ei = new WeakMap(), br = new WeakMap(), gi = new WeakMap(), _r = new WeakMap(), Ha = new WeakSet(), $s = async function() {
  try {
    const e = await rt(this, ei).getBlockNumber();
    if (rt(this, _r) === -2) {
      At(this, _r, e);
      return;
    }
    if (e !== rt(this, _r)) {
      for (let T = rt(this, _r) + 1; T <= e; T++) {
        if (rt(this, br) == null)
          return;
        await rt(this, ei).emit("block", T);
      }
      At(this, _r, e);
    }
  } catch {
  }
  rt(this, br) != null && At(this, br, rt(this, ei)._setTimeout(Qt(this, Ha, $s).bind(this), rt(this, gi)));
};
var Xi, Ji, yi;
class OnBlockSubscriber {
  /**
   *  Create a new **OnBlockSubscriber** attached to %%provider%%.
   */
  constructor(e) {
    Ft(this, Xi);
    Ft(this, Ji);
    Ft(this, yi);
    At(this, Xi, e), At(this, yi, !1), At(this, Ji, (T) => {
      this._poll(T, rt(this, Xi));
    });
  }
  /**
   *  Called on every new block.
   */
  async _poll(e, T) {
    throw new Error("sub-classes must override this");
  }
  start() {
    rt(this, yi) || (At(this, yi, !0), rt(this, Ji).call(this, -2), rt(this, Xi).on("block", rt(this, Ji)));
  }
  stop() {
    rt(this, yi) && (At(this, yi, !1), rt(this, Xi).off("block", rt(this, Ji)));
  }
  pause(e) {
    this.stop();
  }
  resume() {
    this.start();
  }
}
Xi = new WeakMap(), Ji = new WeakMap(), yi = new WeakMap();
var Ga, ti;
class PollingBlockTagSubscriber extends OnBlockSubscriber {
  constructor(T, $) {
    super(T);
    Ft(this, Ga);
    Ft(this, ti);
    At(this, Ga, $), At(this, ti, -2);
  }
  pause(T) {
    T && At(this, ti, -2), super.pause(T);
  }
  async _poll(T, $) {
    const V = await $.getBlock(rt(this, Ga));
    V != null && (rt(this, ti) === -2 ? At(this, ti, V.number) : V.number > rt(this, ti) && ($.emit(rt(this, Ga), V.number), At(this, ti, V.number)));
  }
}
Ga = new WeakMap(), ti = new WeakMap();
var qs;
class PollingOrphanSubscriber extends OnBlockSubscriber {
  constructor(T, $) {
    super(T);
    Ft(this, qs);
    At(this, qs, copy$2($));
  }
  async _poll(T, $) {
    throw new Error("@TODO");
  }
}
qs = new WeakMap();
var Va;
class PollingTransactionSubscriber extends OnBlockSubscriber {
  /**
   *  Create a new **PollingTransactionSubscriber** attached to
   *  %%provider%%, listening for %%hash%%.
   */
  constructor(T, $) {
    super(T);
    Ft(this, Va);
    At(this, Va, $);
  }
  async _poll(T, $) {
    const V = await $.getTransactionReceipt(rt(this, Va));
    V && $.emit(rt(this, Va), V);
  }
}
Va = new WeakMap();
var ni, Ya, qa, xi, gr, Ks, So;
class PollingEventSubscriber {
  /**
   *  Create a new **PollingTransactionSubscriber** attached to
   *  %%provider%%, listening for %%filter%%.
   */
  constructor(e, T) {
    Ft(this, Ks);
    Ft(this, ni);
    Ft(this, Ya);
    Ft(this, qa);
    Ft(this, xi);
    // The most recent block we have scanned for events. The value -2
    // indicates we still need to fetch an initial block number
    Ft(this, gr);
    At(this, ni, e), At(this, Ya, copy$2(T)), At(this, qa, Qt(this, Ks, So).bind(this)), At(this, xi, !1), At(this, gr, -2);
  }
  start() {
    rt(this, xi) || (At(this, xi, !0), rt(this, gr) === -2 && rt(this, ni).getBlockNumber().then((e) => {
      At(this, gr, e);
    }), rt(this, ni).on("block", rt(this, qa)));
  }
  stop() {
    rt(this, xi) && (At(this, xi, !1), rt(this, ni).off("block", rt(this, qa)));
  }
  pause(e) {
    this.stop(), e && At(this, gr, -2);
  }
  resume() {
    this.start();
  }
}
ni = new WeakMap(), Ya = new WeakMap(), qa = new WeakMap(), xi = new WeakMap(), gr = new WeakMap(), Ks = new WeakSet(), So = async function(e) {
  if (rt(this, gr) === -2)
    return;
  const T = copy$2(rt(this, Ya));
  T.fromBlock = rt(this, gr) + 1, T.toBlock = e;
  const $ = await rt(this, ni).getLogs(T);
  if ($.length === 0) {
    rt(this, gr) < e - 60 && At(this, gr, e - 60);
    return;
  }
  for (const V of $)
    rt(this, ni).emit(rt(this, Ya), V), At(this, gr, V.blockNumber);
};
const BN_2 = BigInt(2), MAX_CCIP_REDIRECTS = 10;
function isPromise(C) {
  return C && typeof C.then == "function";
}
function getTag(C, e) {
  return C + ":" + JSON.stringify(e, (T, $) => {
    if ($ == null)
      return "null";
    if (typeof $ == "bigint")
      return `bigint:${$.toString()}`;
    if (typeof $ == "string")
      return $.toLowerCase();
    if (typeof $ == "object" && !Array.isArray($)) {
      const V = Object.keys($);
      return V.sort(), V.reduce((J, ee) => (J[ee] = $[ee], J), {});
    }
    return $;
  });
}
class UnmanagedSubscriber {
  /**
   *  Create a new UnmanagedSubscriber with %%name%%.
   */
  constructor(e) {
    /**
     *  The name fof the event.
     */
    tt(this, "name");
    defineProperties(this, { name: e });
  }
  start() {
  }
  stop() {
  }
  pause(e) {
  }
  resume() {
  }
}
function copy$1(C) {
  return JSON.parse(JSON.stringify(C));
}
function concisify(C) {
  return C = Array.from(new Set(C).values()), C.sort(), C;
}
async function getSubscription(C, e) {
  if (C == null)
    throw new Error("invalid event");
  if (Array.isArray(C) && (C = { topics: C }), typeof C == "string")
    switch (C) {
      case "block":
      case "debug":
      case "error":
      case "finalized":
      case "network":
      case "pending":
      case "safe":
        return { type: C, tag: C };
    }
  if (isHexString(C, 32)) {
    const T = C.toLowerCase();
    return { type: "transaction", tag: getTag("tx", { hash: T }), hash: T };
  }
  if (C.orphan) {
    const T = C;
    return { type: "orphan", tag: getTag("orphan", T), filter: copy$1(T) };
  }
  if (C.address || C.topics) {
    const T = C, $ = {
      topics: (T.topics || []).map((V) => V == null ? null : Array.isArray(V) ? concisify(V.map((J) => J.toLowerCase())) : V.toLowerCase())
    };
    if (T.address) {
      const V = [], J = [], ee = (te) => {
        isHexString(te) ? V.push(te) : J.push((async () => {
          V.push(await resolveAddress(te, e));
        })());
      };
      Array.isArray(T.address) ? T.address.forEach(ee) : ee(T.address), J.length && await Promise.all(J), $.address = concisify(V.map((te) => te.toLowerCase()));
    }
    return { filter: $, tag: getTag("event", $), type: "event" };
  }
  assertArgument(!1, "unknown ProviderEvent", "event", C);
}
function getTime() {
  return (/* @__PURE__ */ new Date()).getTime();
}
const defaultOptions$1 = {
  cacheTimeout: 250,
  pollingInterval: 4e3
};
var Jn, Ai, er, Ka, dr, ea, vi, ri, Es, yr, Za, Qa, Rn, sr, so, oo, cs, co, ls, Us;
class AbstractProvider {
  /**
   *  Create a new **AbstractProvider** connected to %%network%%, or
   *  use the various network detection capabilities to discover the
   *  [[Network]] if necessary.
   */
  constructor(e, T) {
    Ft(this, Rn);
    Ft(this, Jn);
    Ft(this, Ai);
    // null=unpaused, true=paused+dropWhilePaused, false=paused
    Ft(this, er);
    Ft(this, Ka);
    Ft(this, dr);
    Ft(this, ea);
    Ft(this, vi);
    // The most recent block number if running an event or -1 if no "block" event
    Ft(this, ri);
    Ft(this, Es);
    Ft(this, yr);
    Ft(this, Za);
    Ft(this, Qa);
    if (At(this, Qa, Object.assign({}, defaultOptions$1, T || {})), e === "any")
      At(this, ea, !0), At(this, dr, null);
    else if (e) {
      const $ = Network.from(e);
      At(this, ea, !1), At(this, dr, Promise.resolve($)), setTimeout(() => {
        this.emit("network", $, null);
      }, 0);
    } else
      At(this, ea, !1), At(this, dr, null);
    At(this, ri, -1), At(this, vi, /* @__PURE__ */ new Map()), At(this, Jn, /* @__PURE__ */ new Map()), At(this, Ai, /* @__PURE__ */ new Map()), At(this, er, null), At(this, Ka, !1), At(this, Es, 1), At(this, yr, /* @__PURE__ */ new Map()), At(this, Za, !1);
  }
  get pollingInterval() {
    return rt(this, Qa).pollingInterval;
  }
  /**
   *  Returns ``this``, to allow an **AbstractProvider** to implement
   *  the [[ContractRunner]] interface.
   */
  get provider() {
    return this;
  }
  /**
   *  Returns all the registered plug-ins.
   */
  get plugins() {
    return Array.from(rt(this, Ai).values());
  }
  /**
   *  Attach a new plug-in.
   */
  attachPlugin(e) {
    if (rt(this, Ai).get(e.name))
      throw new Error(`cannot replace existing plugin: ${e.name} `);
    return rt(this, Ai).set(e.name, e.connect(this)), this;
  }
  /**
   *  Get a plugin by name.
   */
  getPlugin(e) {
    return rt(this, Ai).get(e) || null;
  }
  /**
   *  Prevent any CCIP-read operation, regardless of whether requested
   *  in a [[call]] using ``enableCcipRead``.
   */
  get disableCcipRead() {
    return rt(this, Za);
  }
  set disableCcipRead(e) {
    At(this, Za, !!e);
  }
  /**
   *  Resolves to the data for executing the CCIP-read operations.
   */
  async ccipReadFetch(e, T, $) {
    if (this.disableCcipRead || $.length === 0 || e.to == null)
      return null;
    const V = e.to.toLowerCase(), J = T.toLowerCase(), ee = [];
    for (let te = 0; te < $.length; te++) {
      const re = $[te], ie = re.replace("{sender}", V).replace("{data}", J), se = new FetchRequest(ie);
      re.indexOf("{data}") === -1 && (se.body = { data: J, sender: V }), this.emit("debug", { action: "sendCcipReadFetchRequest", request: se, index: te, urls: $ });
      let de = "unknown error", ue;
      try {
        ue = await se.send();
      } catch (fe) {
        ee.push(fe.message), this.emit("debug", { action: "receiveCcipReadFetchError", request: se, result: { error: fe } });
        continue;
      }
      try {
        const fe = ue.bodyJson;
        if (fe.data)
          return this.emit("debug", { action: "receiveCcipReadFetchResult", request: se, result: fe }), fe.data;
        fe.message && (de = fe.message), this.emit("debug", { action: "receiveCcipReadFetchError", request: se, result: fe });
      } catch {
      }
      assert$5(ue.statusCode < 400 || ue.statusCode >= 500, `response not found during CCIP fetch: ${de}`, "OFFCHAIN_FAULT", { reason: "404_MISSING_RESOURCE", transaction: e, info: { url: re, errorMessage: de } }), ee.push(de);
    }
    assert$5(!1, `error encountered during CCIP fetch: ${ee.map((te) => JSON.stringify(te)).join(", ")}`, "OFFCHAIN_FAULT", {
      reason: "500_SERVER_ERROR",
      transaction: e,
      info: { urls: $, errorMessages: ee }
    });
  }
  /**
   *  Provides the opportunity for a sub-class to wrap a block before
   *  returning it, to add additional properties or an alternate
   *  sub-class of [[Block]].
   */
  _wrapBlock(e, T) {
    return new Block(formatBlock(e), this);
  }
  /**
   *  Provides the opportunity for a sub-class to wrap a log before
   *  returning it, to add additional properties or an alternate
   *  sub-class of [[Log]].
   */
  _wrapLog(e, T) {
    return new Log(formatLog(e), this);
  }
  /**
   *  Provides the opportunity for a sub-class to wrap a transaction
   *  receipt before returning it, to add additional properties or an
   *  alternate sub-class of [[TransactionReceipt]].
   */
  _wrapTransactionReceipt(e, T) {
    return new TransactionReceipt(formatTransactionReceipt(e), this);
  }
  /**
   *  Provides the opportunity for a sub-class to wrap a transaction
   *  response before returning it, to add additional properties or an
   *  alternate sub-class of [[TransactionResponse]].
   */
  _wrapTransactionResponse(e, T) {
    return new TransactionResponse(formatTransactionResponse(e), this);
  }
  /**
   *  Resolves to the Network, forcing a network detection using whatever
   *  technique the sub-class requires.
   *
   *  Sub-classes **must** override this.
   */
  _detectNetwork() {
    assert$5(!1, "sub-classes must implement this", "UNSUPPORTED_OPERATION", {
      operation: "_detectNetwork"
    });
  }
  /**
   *  Sub-classes should use this to perform all built-in operations. All
   *  methods sanitizes and normalizes the values passed into this.
   *
   *  Sub-classes **must** override this.
   */
  async _perform(e) {
    assert$5(!1, `unsupported method: ${e.method}`, "UNSUPPORTED_OPERATION", {
      operation: e.method,
      info: e
    });
  }
  // State
  async getBlockNumber() {
    const e = getNumber(await Qt(this, Rn, sr).call(this, { method: "getBlockNumber" }), "%response");
    return rt(this, ri) >= 0 && At(this, ri, e), e;
  }
  /**
   *  Returns or resolves to the address for %%address%%, resolving ENS
   *  names and [[Addressable]] objects and returning if already an
   *  address.
   */
  _getAddress(e) {
    return resolveAddress(e, this);
  }
  /**
   *  Returns or resolves to a valid block tag for %%blockTag%%, resolving
   *  negative values and returning if already a valid block tag.
   */
  _getBlockTag(e) {
    if (e == null)
      return "latest";
    switch (e) {
      case "earliest":
        return "0x0";
      case "finalized":
      case "latest":
      case "pending":
      case "safe":
        return e;
    }
    if (isHexString(e))
      return isHexString(e, 32) ? e : toQuantity(e);
    if (typeof e == "bigint" && (e = getNumber(e, "blockTag")), typeof e == "number")
      return e >= 0 ? toQuantity(e) : rt(this, ri) >= 0 ? toQuantity(rt(this, ri) + e) : this.getBlockNumber().then((T) => toQuantity(T + e));
    assertArgument(!1, "invalid blockTag", "blockTag", e);
  }
  /**
   *  Returns or resolves to a filter for %%filter%%, resolving any ENS
   *  names or [[Addressable]] object and returning if already a valid
   *  filter.
   */
  _getFilter(e) {
    const T = (e.topics || []).map((re) => re == null ? null : Array.isArray(re) ? concisify(re.map((ie) => ie.toLowerCase())) : re.toLowerCase()), $ = "blockHash" in e ? e.blockHash : void 0, V = (re, ie, se) => {
      let de;
      switch (re.length) {
        case 0:
          break;
        case 1:
          de = re[0];
          break;
        default:
          re.sort(), de = re;
      }
      if ($ && (ie != null || se != null))
        throw new Error("invalid filter");
      const ue = {};
      return de && (ue.address = de), T.length && (ue.topics = T), ie && (ue.fromBlock = ie), se && (ue.toBlock = se), $ && (ue.blockHash = $), ue;
    };
    let J = [];
    if (e.address)
      if (Array.isArray(e.address))
        for (const re of e.address)
          J.push(this._getAddress(re));
      else
        J.push(this._getAddress(e.address));
    let ee;
    "fromBlock" in e && (ee = this._getBlockTag(e.fromBlock));
    let te;
    return "toBlock" in e && (te = this._getBlockTag(e.toBlock)), J.filter((re) => typeof re != "string").length || ee != null && typeof ee != "string" || te != null && typeof te != "string" ? Promise.all([Promise.all(J), ee, te]).then((re) => V(re[0], re[1], re[2])) : V(J, ee, te);
  }
  /**
   *  Returns or resolves to a transaction for %%request%%, resolving
   *  any ENS names or [[Addressable]] and returning if already a valid
   *  transaction.
   */
  _getTransactionRequest(e) {
    const T = copyRequest(e), $ = [];
    if (["to", "from"].forEach((V) => {
      if (T[V] == null)
        return;
      const J = resolveAddress(T[V], this);
      isPromise(J) ? $.push(async function() {
        T[V] = await J;
      }()) : T[V] = J;
    }), T.blockTag != null) {
      const V = this._getBlockTag(T.blockTag);
      isPromise(V) ? $.push(async function() {
        T.blockTag = await V;
      }()) : T.blockTag = V;
    }
    return $.length ? async function() {
      return await Promise.all($), T;
    }() : T;
  }
  async getNetwork() {
    if (rt(this, dr) == null) {
      const V = (async () => {
        try {
          const J = await this._detectNetwork();
          return this.emit("network", J, null), J;
        } catch (J) {
          throw rt(this, dr) === V && At(this, dr, null), J;
        }
      })();
      return At(this, dr, V), (await V).clone();
    }
    const e = rt(this, dr), [T, $] = await Promise.all([
      e,
      this._detectNetwork()
      // The actual connected network
    ]);
    return T.chainId !== $.chainId && (rt(this, ea) ? (this.emit("network", $, T), rt(this, dr) === e && At(this, dr, Promise.resolve($))) : assert$5(!1, `network changed: ${T.chainId} => ${$.chainId} `, "NETWORK_ERROR", {
      event: "changed"
    })), T.clone();
  }
  async getFeeData() {
    const e = await this.getNetwork(), T = async () => {
      const { _block: V, gasPrice: J, priorityFee: ee } = await resolveProperties({
        _block: Qt(this, Rn, co).call(this, "latest", !1),
        gasPrice: (async () => {
          try {
            const se = await Qt(this, Rn, sr).call(this, { method: "getGasPrice" });
            return getBigInt(se, "%response");
          } catch {
          }
          return null;
        })(),
        priorityFee: (async () => {
          try {
            const se = await Qt(this, Rn, sr).call(this, { method: "getPriorityFee" });
            return getBigInt(se, "%response");
          } catch {
          }
          return null;
        })()
      });
      let te = null, re = null;
      const ie = this._wrapBlock(V, e);
      return ie && ie.baseFeePerGas && (re = ee ?? BigInt("1000000000"), te = ie.baseFeePerGas * BN_2 + re), new FeeData(J, te, re);
    }, $ = e.getPlugin("org.ethers.plugins.network.FetchUrlFeeDataPlugin");
    if ($) {
      const V = new FetchRequest($.url), J = await $.processFunc(T, this, V);
      return new FeeData(J.gasPrice, J.maxFeePerGas, J.maxPriorityFeePerGas);
    }
    return await T();
  }
  async estimateGas(e) {
    let T = this._getTransactionRequest(e);
    return isPromise(T) && (T = await T), getBigInt(await Qt(this, Rn, sr).call(this, {
      method: "estimateGas",
      transaction: T
    }), "%response");
  }
  async call(e) {
    const { tx: T, blockTag: $ } = await resolveProperties({
      tx: this._getTransactionRequest(e),
      blockTag: this._getBlockTag(e.blockTag)
    });
    return await Qt(this, Rn, oo).call(this, Qt(this, Rn, so).call(this, T, $, e.enableCcipRead ? 0 : -1));
  }
  async getBalance(e, T) {
    return getBigInt(await Qt(this, Rn, cs).call(this, { method: "getBalance" }, e, T), "%response");
  }
  async getTransactionCount(e, T) {
    return getNumber(await Qt(this, Rn, cs).call(this, { method: "getTransactionCount" }, e, T), "%response");
  }
  async getCode(e, T) {
    return hexlify(await Qt(this, Rn, cs).call(this, { method: "getCode" }, e, T));
  }
  async getStorage(e, T, $) {
    const V = getBigInt(T, "position");
    return hexlify(await Qt(this, Rn, cs).call(this, { method: "getStorage", position: V }, e, $));
  }
  // Write
  async broadcastTransaction(e) {
    const { blockNumber: T, hash: $, network: V } = await resolveProperties({
      blockNumber: this.getBlockNumber(),
      hash: this._perform({
        method: "broadcastTransaction",
        signedTransaction: e
      }),
      network: this.getNetwork()
    }), J = Transaction$1.from(e);
    if (J.hash !== $)
      throw new Error("@TODO: the returned hash did not match");
    return this._wrapTransactionResponse(J, V).replaceableTransaction(T);
  }
  // Queries
  async getBlock(e, T) {
    const { network: $, params: V } = await resolveProperties({
      network: this.getNetwork(),
      params: Qt(this, Rn, co).call(this, e, !!T)
    });
    return V == null ? null : this._wrapBlock(V, $);
  }
  async getTransaction(e) {
    const { network: T, params: $ } = await resolveProperties({
      network: this.getNetwork(),
      params: Qt(this, Rn, sr).call(this, { method: "getTransaction", hash: e })
    });
    return $ == null ? null : this._wrapTransactionResponse($, T);
  }
  async getTransactionReceipt(e) {
    const { network: T, params: $ } = await resolveProperties({
      network: this.getNetwork(),
      params: Qt(this, Rn, sr).call(this, { method: "getTransactionReceipt", hash: e })
    });
    if ($ == null)
      return null;
    if ($.gasPrice == null && $.effectiveGasPrice == null) {
      const V = await Qt(this, Rn, sr).call(this, { method: "getTransaction", hash: e });
      if (V == null)
        throw new Error("report this; could not find tx or effectiveGasPrice");
      $.effectiveGasPrice = V.gasPrice;
    }
    return this._wrapTransactionReceipt($, T);
  }
  async getTransactionResult(e) {
    const { result: T } = await resolveProperties({
      network: this.getNetwork(),
      result: Qt(this, Rn, sr).call(this, { method: "getTransactionResult", hash: e })
    });
    return T == null ? null : hexlify(T);
  }
  // Bloom-filter Queries
  async getLogs(e) {
    let T = this._getFilter(e);
    isPromise(T) && (T = await T);
    const { network: $, params: V } = await resolveProperties({
      network: this.getNetwork(),
      params: Qt(this, Rn, sr).call(this, { method: "getLogs", filter: T })
    });
    return V.map((J) => this._wrapLog(J, $));
  }
  // ENS
  _getProvider(e) {
    assert$5(!1, "provider cannot connect to target network", "UNSUPPORTED_OPERATION", {
      operation: "_getProvider()"
    });
  }
  async getResolver(e) {
    return await EnsResolver.fromName(this, e);
  }
  async getAvatar(e) {
    const T = await this.getResolver(e);
    return T ? await T.getAvatar() : null;
  }
  async resolveName(e) {
    const T = await this.getResolver(e);
    return T ? await T.getAddress() : null;
  }
  async lookupAddress(e) {
    e = getAddress(e);
    const T = namehash(e.substring(2).toLowerCase() + ".addr.reverse");
    try {
      const $ = await EnsResolver.getEnsAddress(this), J = await new Contract($, [
        "function resolver(bytes32) view returns (address)"
      ], this).resolver(T);
      if (J == null || J === ZeroAddress)
        return null;
      const te = await new Contract(J, [
        "function name(bytes32) view returns (string)"
      ], this).name(T);
      return await this.resolveName(te) !== e ? null : te;
    } catch ($) {
      if (isError($, "BAD_DATA") && $.value === "0x" || isError($, "CALL_EXCEPTION"))
        return null;
      throw $;
    }
    return null;
  }
  async waitForTransaction(e, T, $) {
    const V = T ?? 1;
    return V === 0 ? this.getTransactionReceipt(e) : new Promise(async (J, ee) => {
      let te = null;
      const re = async (ie) => {
        try {
          const se = await this.getTransactionReceipt(e);
          if (se != null && ie - se.blockNumber + 1 >= V) {
            J(se), te && (clearTimeout(te), te = null);
            return;
          }
        } catch (se) {
          console.log("EEE", se);
        }
        this.once("block", re);
      };
      $ != null && (te = setTimeout(() => {
        te != null && (te = null, this.off("block", re), ee(makeError("timeout", "TIMEOUT", { reason: "timeout" })));
      }, $)), re(await this.getBlockNumber());
    });
  }
  async waitForBlock(e) {
    assert$5(!1, "not implemented yet", "NOT_IMPLEMENTED", {
      operation: "waitForBlock"
    });
  }
  /**
   *  Clear a timer created using the [[_setTimeout]] method.
   */
  _clearTimeout(e) {
    const T = rt(this, yr).get(e);
    T && (T.timer && clearTimeout(T.timer), rt(this, yr).delete(e));
  }
  /**
   *  Create a timer that will execute %%func%% after at least %%timeout%%
   *  (in ms). If %%timeout%% is unspecified, then %%func%% will execute
   *  in the next event loop.
   *
   *  [Pausing](AbstractProvider-paused) the provider will pause any
   *  associated timers.
   */
  _setTimeout(e, T) {
    T == null && (T = 0);
    const $ = ss(this, Es)._++, V = () => {
      rt(this, yr).delete($), e();
    };
    if (this.paused)
      rt(this, yr).set($, { timer: null, func: V, time: T });
    else {
      const J = setTimeout(V, T);
      rt(this, yr).set($, { timer: J, func: V, time: getTime() });
    }
    return $;
  }
  /**
   *  Perform %%func%% on each subscriber.
   */
  _forEachSubscriber(e) {
    for (const T of rt(this, Jn).values())
      e(T.subscriber);
  }
  /**
   *  Sub-classes may override this to customize subscription
   *  implementations.
   */
  _getSubscriber(e) {
    switch (e.type) {
      case "debug":
      case "error":
      case "network":
        return new UnmanagedSubscriber(e.type);
      case "block": {
        const T = new PollingBlockSubscriber(this);
        return T.pollingInterval = this.pollingInterval, T;
      }
      case "safe":
      case "finalized":
        return new PollingBlockTagSubscriber(this, e.type);
      case "event":
        return new PollingEventSubscriber(this, e.filter);
      case "transaction":
        return new PollingTransactionSubscriber(this, e.hash);
      case "orphan":
        return new PollingOrphanSubscriber(this, e.filter);
    }
    throw new Error(`unsupported event: ${e.type}`);
  }
  /**
   *  If a [[Subscriber]] fails and needs to replace itself, this
   *  method may be used.
   *
   *  For example, this is used for providers when using the
   *  ``eth_getFilterChanges`` method, which can return null if state
   *  filters are not supported by the backend, allowing the Subscriber
   *  to swap in a [[PollingEventSubscriber]].
   */
  _recoverSubscriber(e, T) {
    for (const $ of rt(this, Jn).values())
      if ($.subscriber === e) {
        $.started && $.subscriber.stop(), $.subscriber = T, $.started && T.start(), rt(this, er) != null && T.pause(rt(this, er));
        break;
      }
  }
  async on(e, T) {
    const $ = await Qt(this, Rn, Us).call(this, e);
    return $.listeners.push({ listener: T, once: !1 }), $.started || ($.subscriber.start(), $.started = !0, rt(this, er) != null && $.subscriber.pause(rt(this, er))), this;
  }
  async once(e, T) {
    const $ = await Qt(this, Rn, Us).call(this, e);
    return $.listeners.push({ listener: T, once: !0 }), $.started || ($.subscriber.start(), $.started = !0, rt(this, er) != null && $.subscriber.pause(rt(this, er))), this;
  }
  async emit(e, ...T) {
    const $ = await Qt(this, Rn, ls).call(this, e, T);
    if (!$ || $.listeners.length === 0)
      return !1;
    const V = $.listeners.length;
    return $.listeners = $.listeners.filter(({ listener: J, once: ee }) => {
      const te = new EventPayload(this, ee ? null : J, e);
      try {
        J.call(this, ...T, te);
      } catch {
      }
      return !ee;
    }), $.listeners.length === 0 && ($.started && $.subscriber.stop(), rt(this, Jn).delete($.tag)), V > 0;
  }
  async listenerCount(e) {
    if (e) {
      const $ = await Qt(this, Rn, ls).call(this, e);
      return $ ? $.listeners.length : 0;
    }
    let T = 0;
    for (const { listeners: $ } of rt(this, Jn).values())
      T += $.length;
    return T;
  }
  async listeners(e) {
    if (e) {
      const $ = await Qt(this, Rn, ls).call(this, e);
      return $ ? $.listeners.map(({ listener: V }) => V) : [];
    }
    let T = [];
    for (const { listeners: $ } of rt(this, Jn).values())
      T = T.concat($.map(({ listener: V }) => V));
    return T;
  }
  async off(e, T) {
    const $ = await Qt(this, Rn, ls).call(this, e);
    if (!$)
      return this;
    if (T) {
      const V = $.listeners.map(({ listener: J }) => J).indexOf(T);
      V >= 0 && $.listeners.splice(V, 1);
    }
    return (!T || $.listeners.length === 0) && ($.started && $.subscriber.stop(), rt(this, Jn).delete($.tag)), this;
  }
  async removeAllListeners(e) {
    if (e) {
      const { tag: T, started: $, subscriber: V } = await Qt(this, Rn, Us).call(this, e);
      $ && V.stop(), rt(this, Jn).delete(T);
    } else
      for (const [T, { started: $, subscriber: V }] of rt(this, Jn))
        $ && V.stop(), rt(this, Jn).delete(T);
    return this;
  }
  // Alias for "on"
  async addListener(e, T) {
    return await this.on(e, T);
  }
  // Alias for "off"
  async removeListener(e, T) {
    return this.off(e, T);
  }
  /**
   *  If this provider has been destroyed using the [[destroy]] method.
   *
   *  Once destroyed, all resources are reclaimed, internal event loops
   *  and timers are cleaned up and no further requests may be sent to
   *  the provider.
   */
  get destroyed() {
    return rt(this, Ka);
  }
  /**
   *  Sub-classes may use this to shutdown any sockets or release their
   *  resources and reject any pending requests.
   *
   *  Sub-classes **must** call ``super.destroy()``.
   */
  destroy() {
    this.removeAllListeners();
    for (const e of rt(this, yr).keys())
      this._clearTimeout(e);
    At(this, Ka, !0);
  }
  /**
   *  Whether the provider is currently paused.
   *
   *  A paused provider will not emit any events, and generally should
   *  not make any requests to the network, but that is up to sub-classes
   *  to manage.
   *
   *  Setting ``paused = true`` is identical to calling ``.pause(false)``,
   *  which will buffer any events that occur while paused until the
   *  provider is unpaused.
   */
  get paused() {
    return rt(this, er) != null;
  }
  set paused(e) {
    !!e !== this.paused && (this.paused ? this.resume() : this.pause(!1));
  }
  /**
   *  Pause the provider. If %%dropWhilePaused%%, any events that occur
   *  while paused are dropped, otherwise all events will be emitted once
   *  the provider is unpaused.
   */
  pause(e) {
    if (At(this, ri, -1), rt(this, er) != null) {
      if (rt(this, er) == !!e)
        return;
      assert$5(!1, "cannot change pause type; resume first", "UNSUPPORTED_OPERATION", {
        operation: "pause"
      });
    }
    this._forEachSubscriber((T) => T.pause(e)), At(this, er, !!e);
    for (const T of rt(this, yr).values())
      T.timer && clearTimeout(T.timer), T.time = getTime() - T.time;
  }
  /**
   *  Resume the provider.
   */
  resume() {
    if (rt(this, er) != null) {
      this._forEachSubscriber((e) => e.resume()), At(this, er, null);
      for (const e of rt(this, yr).values()) {
        let T = e.time;
        T < 0 && (T = 0), e.time = getTime(), setTimeout(e.func, T);
      }
    }
  }
}
Jn = new WeakMap(), Ai = new WeakMap(), er = new WeakMap(), Ka = new WeakMap(), dr = new WeakMap(), ea = new WeakMap(), vi = new WeakMap(), ri = new WeakMap(), Es = new WeakMap(), yr = new WeakMap(), Za = new WeakMap(), Qa = new WeakMap(), Rn = new WeakSet(), sr = async function(e) {
  const T = rt(this, Qa).cacheTimeout;
  if (T < 0)
    return await this._perform(e);
  const $ = getTag(e.method, e);
  let V = rt(this, vi).get($);
  return V || (V = this._perform(e), rt(this, vi).set($, V), setTimeout(() => {
    rt(this, vi).get($) === V && rt(this, vi).delete($);
  }, T)), await V;
}, so = async function(e, T, $) {
  assert$5($ < MAX_CCIP_REDIRECTS, "CCIP read exceeded maximum redirections", "OFFCHAIN_FAULT", {
    reason: "TOO_MANY_REDIRECTS",
    transaction: Object.assign({}, e, { blockTag: T, enableCcipRead: !0 })
  });
  const V = copyRequest(e);
  try {
    return hexlify(await this._perform({ method: "call", transaction: V, blockTag: T }));
  } catch (J) {
    if (!this.disableCcipRead && isCallException(J) && J.data && $ >= 0 && T === "latest" && V.to != null && dataSlice(J.data, 0, 4) === "0x556f1830") {
      const ee = J.data, te = await resolveAddress(V.to, this);
      let re;
      try {
        re = parseOffchainLookup(dataSlice(J.data, 4));
      } catch (de) {
        assert$5(!1, de.message, "OFFCHAIN_FAULT", {
          reason: "BAD_DATA",
          transaction: V,
          info: { data: ee }
        });
      }
      assert$5(re.sender.toLowerCase() === te.toLowerCase(), "CCIP Read sender mismatch", "CALL_EXCEPTION", {
        action: "call",
        data: ee,
        reason: "OffchainLookup",
        transaction: V,
        invocation: null,
        revert: {
          signature: "OffchainLookup(address,string[],bytes,bytes4,bytes)",
          name: "OffchainLookup",
          args: re.errorArgs
        }
      });
      const ie = await this.ccipReadFetch(V, re.calldata, re.urls);
      assert$5(ie != null, "CCIP Read failed to fetch data", "OFFCHAIN_FAULT", {
        reason: "FETCH_FAILED",
        transaction: V,
        info: { data: J.data, errorArgs: re.errorArgs }
      });
      const se = {
        to: te,
        data: concat([re.selector, encodeBytes([ie, re.extraData])])
      };
      this.emit("debug", { action: "sendCcipReadCall", transaction: se });
      try {
        const de = await Qt(this, Rn, so).call(this, se, T, $ + 1);
        return this.emit("debug", { action: "receiveCcipReadCallResult", transaction: Object.assign({}, se), result: de }), de;
      } catch (de) {
        throw this.emit("debug", { action: "receiveCcipReadCallError", transaction: Object.assign({}, se), error: de }), de;
      }
    }
    throw J;
  }
}, oo = async function(e) {
  const { value: T } = await resolveProperties({
    network: this.getNetwork(),
    value: e
  });
  return T;
}, cs = async function(e, T, $) {
  let V = this._getAddress(T), J = this._getBlockTag($);
  return (typeof V != "string" || typeof J != "string") && ([V, J] = await Promise.all([V, J])), await Qt(this, Rn, oo).call(this, Qt(this, Rn, sr).call(this, Object.assign(e, { address: V, blockTag: J })));
}, co = async function(e, T) {
  if (isHexString(e, 32))
    return await Qt(this, Rn, sr).call(this, {
      method: "getBlock",
      blockHash: e,
      includeTransactions: T
    });
  let $ = this._getBlockTag(e);
  return typeof $ != "string" && ($ = await $), await Qt(this, Rn, sr).call(this, {
    method: "getBlock",
    blockTag: $,
    includeTransactions: T
  });
}, ls = async function(e, T) {
  let $ = await getSubscription(e, this);
  return $.type === "event" && T && T.length > 0 && T[0].removed === !0 && ($ = await getSubscription({ orphan: "drop-log", log: T[0] }, this)), rt(this, Jn).get($.tag) || null;
}, Us = async function(e) {
  const T = await getSubscription(e, this), $ = T.tag;
  let V = rt(this, Jn).get($);
  return V || (V = { subscriber: this._getSubscriber(T), tag: $, addressableMap: /* @__PURE__ */ new WeakMap(), nameMap: /* @__PURE__ */ new Map(), started: !1, listeners: [] }, rt(this, Jn).set($, V)), V;
};
function _parseString(C, e) {
  try {
    const T = _parseBytes(C, e);
    if (T)
      return toUtf8String(T);
  } catch {
  }
  return null;
}
function _parseBytes(C, e) {
  if (C === "0x")
    return null;
  try {
    const T = getNumber(dataSlice(C, e, e + 32)), $ = getNumber(dataSlice(C, T, T + 32));
    return dataSlice(C, T + 32, T + 32 + $);
  } catch {
  }
  return null;
}
function numPad(C) {
  const e = toBeArray(C);
  if (e.length > 32)
    throw new Error("internal; should not happen");
  const T = new Uint8Array(32);
  return T.set(e, 32 - e.length), T;
}
function bytesPad(C) {
  if (C.length % 32 === 0)
    return C;
  const e = new Uint8Array(Math.ceil(C.length / 32) * 32);
  return e.set(C), e;
}
const empty = new Uint8Array([]);
function encodeBytes(C) {
  const e = [];
  let T = 0;
  for (let $ = 0; $ < C.length; $++)
    e.push(empty), T += 32;
  for (let $ = 0; $ < C.length; $++) {
    const V = getBytes(C[$]);
    e[$] = numPad(T), e.push(numPad(V.length)), e.push(bytesPad(V)), T += 32 + Math.ceil(V.length / 32) * 32;
  }
  return concat(e);
}
const zeros = "0x0000000000000000000000000000000000000000000000000000000000000000";
function parseOffchainLookup(C) {
  const e = {
    sender: "",
    urls: [],
    calldata: "",
    selector: "",
    extraData: "",
    errorArgs: []
  };
  assert$5(dataLength(C) >= 5 * 32, "insufficient OffchainLookup data", "OFFCHAIN_FAULT", {
    reason: "insufficient OffchainLookup data"
  });
  const T = dataSlice(C, 0, 32);
  assert$5(dataSlice(T, 0, 12) === dataSlice(zeros, 0, 12), "corrupt OffchainLookup sender", "OFFCHAIN_FAULT", {
    reason: "corrupt OffchainLookup sender"
  }), e.sender = dataSlice(T, 12);
  try {
    const $ = [], V = getNumber(dataSlice(C, 32, 64)), J = getNumber(dataSlice(C, V, V + 32)), ee = dataSlice(C, V + 32);
    for (let te = 0; te < J; te++) {
      const re = _parseString(ee, te * 32);
      if (re == null)
        throw new Error("abort");
      $.push(re);
    }
    e.urls = $;
  } catch {
    assert$5(!1, "corrupt OffchainLookup urls", "OFFCHAIN_FAULT", {
      reason: "corrupt OffchainLookup urls"
    });
  }
  try {
    const $ = _parseBytes(C, 64);
    if ($ == null)
      throw new Error("abort");
    e.calldata = $;
  } catch {
    assert$5(!1, "corrupt OffchainLookup calldata", "OFFCHAIN_FAULT", {
      reason: "corrupt OffchainLookup calldata"
    });
  }
  assert$5(dataSlice(C, 100, 128) === dataSlice(zeros, 0, 28), "corrupt OffchainLookup callbaackSelector", "OFFCHAIN_FAULT", {
    reason: "corrupt OffchainLookup callbaackSelector"
  }), e.selector = dataSlice(C, 96, 100);
  try {
    const $ = _parseBytes(C, 128);
    if ($ == null)
      throw new Error("abort");
    e.extraData = $;
  } catch {
    assert$5(!1, "corrupt OffchainLookup extraData", "OFFCHAIN_FAULT", {
      reason: "corrupt OffchainLookup extraData"
    });
  }
  return e.errorArgs = "sender,urls,calldata,selector,extraData".split(/,/).map(($) => e[$]), e;
}
function checkProvider(C, e) {
  if (C.provider)
    return C.provider;
  assert$5(!1, "missing provider", "UNSUPPORTED_OPERATION", { operation: e });
}
async function populate(C, e) {
  let T = copyRequest(e);
  if (T.to != null && (T.to = resolveAddress(T.to, C)), T.from != null) {
    const $ = T.from;
    T.from = Promise.all([
      C.getAddress(),
      resolveAddress($, C)
    ]).then(([V, J]) => (assertArgument(V.toLowerCase() === J.toLowerCase(), "transaction from mismatch", "tx.from", J), V));
  } else
    T.from = C.getAddress();
  return await resolveProperties(T);
}
class AbstractSigner {
  /**
   *  Creates a new Signer connected to %%provider%%.
   */
  constructor(e) {
    /**
     *  The provider this signer is connected to.
     */
    tt(this, "provider");
    defineProperties(this, { provider: e || null });
  }
  async getNonce(e) {
    return checkProvider(this, "getTransactionCount").getTransactionCount(await this.getAddress(), e);
  }
  async populateCall(e) {
    return await populate(this, e);
  }
  async populateTransaction(e) {
    const T = checkProvider(this, "populateTransaction"), $ = await populate(this, e);
    $.nonce == null && ($.nonce = await this.getNonce("pending")), $.gasLimit == null && ($.gasLimit = await this.estimateGas($));
    const V = await this.provider.getNetwork();
    if ($.chainId != null) {
      const ee = getBigInt($.chainId);
      assertArgument(ee === V.chainId, "transaction chainId mismatch", "tx.chainId", e.chainId);
    } else
      $.chainId = V.chainId;
    const J = $.maxFeePerGas != null || $.maxPriorityFeePerGas != null;
    if ($.gasPrice != null && ($.type === 2 || J) ? assertArgument(!1, "eip-1559 transaction do not support gasPrice", "tx", e) : ($.type === 0 || $.type === 1) && J && assertArgument(!1, "pre-eip-1559 transaction do not support maxFeePerGas/maxPriorityFeePerGas", "tx", e), ($.type === 2 || $.type == null) && $.maxFeePerGas != null && $.maxPriorityFeePerGas != null)
      $.type = 2;
    else if ($.type === 0 || $.type === 1) {
      const ee = await T.getFeeData();
      assert$5(ee.gasPrice != null, "network does not support gasPrice", "UNSUPPORTED_OPERATION", {
        operation: "getGasPrice"
      }), $.gasPrice == null && ($.gasPrice = ee.gasPrice);
    } else {
      const ee = await T.getFeeData();
      if ($.type == null)
        if (ee.maxFeePerGas != null && ee.maxPriorityFeePerGas != null)
          if ($.type = 2, $.gasPrice != null) {
            const te = $.gasPrice;
            delete $.gasPrice, $.maxFeePerGas = te, $.maxPriorityFeePerGas = te;
          } else
            $.maxFeePerGas == null && ($.maxFeePerGas = ee.maxFeePerGas), $.maxPriorityFeePerGas == null && ($.maxPriorityFeePerGas = ee.maxPriorityFeePerGas);
        else ee.gasPrice != null ? (assert$5(!J, "network does not support EIP-1559", "UNSUPPORTED_OPERATION", {
          operation: "populateTransaction"
        }), $.gasPrice == null && ($.gasPrice = ee.gasPrice), $.type = 0) : assert$5(!1, "failed to get consistent fee data", "UNSUPPORTED_OPERATION", {
          operation: "signer.getFeeData"
        });
      else ($.type === 2 || $.type === 3) && ($.maxFeePerGas == null && ($.maxFeePerGas = ee.maxFeePerGas), $.maxPriorityFeePerGas == null && ($.maxPriorityFeePerGas = ee.maxPriorityFeePerGas));
    }
    return await resolveProperties($);
  }
  async estimateGas(e) {
    return checkProvider(this, "estimateGas").estimateGas(await this.populateCall(e));
  }
  async call(e) {
    return checkProvider(this, "call").call(await this.populateCall(e));
  }
  async resolveName(e) {
    return await checkProvider(this, "resolveName").resolveName(e);
  }
  async sendTransaction(e) {
    const T = checkProvider(this, "sendTransaction"), $ = await this.populateTransaction(e);
    delete $.from;
    const V = Transaction$1.from($);
    return await T.broadcastTransaction(await this.signTransaction(V));
  }
}
var Xa, zs;
const xo = class xo extends AbstractSigner {
  /**
   *  Creates a new **VoidSigner** with %%address%% attached to
   *  %%provider%%.
   */
  constructor(T, $) {
    super($);
    Ft(this, Xa);
    /**
     *  The signer address.
     */
    tt(this, "address");
    defineProperties(this, { address: T });
  }
  async getAddress() {
    return this.address;
  }
  connect(T) {
    return new xo(this.address, T);
  }
  async signTransaction(T) {
    Qt(this, Xa, zs).call(this, "transactions", "signTransaction");
  }
  async signMessage(T) {
    Qt(this, Xa, zs).call(this, "messages", "signMessage");
  }
  async signTypedData(T, $, V) {
    Qt(this, Xa, zs).call(this, "typed-data", "signTypedData");
  }
};
Xa = new WeakSet(), zs = function(T, $) {
  assert$5(!1, `VoidSigner cannot sign ${T}`, "UNSUPPORTED_OPERATION", { operation: $ });
};
let VoidSigner = xo;
function copy(C) {
  return JSON.parse(JSON.stringify(C));
}
var nr, Br, ta, Ci, na, Ja, Ri, lo, uo;
class FilterIdSubscriber {
  /**
   *  Creates a new **FilterIdSubscriber** which will used [[_subscribe]]
   *  and [[_emitResults]] to setup the subscription and provide the event
   *  to the %%provider%%.
   */
  constructor(e) {
    Ft(this, Ri);
    Ft(this, nr);
    Ft(this, Br);
    Ft(this, ta);
    Ft(this, Ci);
    Ft(this, na);
    Ft(this, Ja);
    At(this, nr, e), At(this, Br, null), At(this, ta, Qt(this, Ri, lo).bind(this)), At(this, Ci, !1), At(this, na, null), At(this, Ja, !1);
  }
  /**
   *  Sub-classes **must** override this to begin the subscription.
   */
  _subscribe(e) {
    throw new Error("subclasses must override this");
  }
  /**
   *  Sub-classes **must** override this handle the events.
   */
  _emitResults(e, T) {
    throw new Error("subclasses must override this");
  }
  /**
   *  Sub-classes **must** override this handle recovery on errors.
   */
  _recover(e) {
    throw new Error("subclasses must override this");
  }
  start() {
    rt(this, Ci) || (At(this, Ci, !0), Qt(this, Ri, lo).call(this, -2));
  }
  stop() {
    rt(this, Ci) && (At(this, Ci, !1), At(this, Ja, !0), Qt(this, Ri, uo).call(this), rt(this, nr).off("block", rt(this, ta)));
  }
  pause(e) {
    e && Qt(this, Ri, uo).call(this), rt(this, nr).off("block", rt(this, ta));
  }
  resume() {
    this.start();
  }
}
nr = new WeakMap(), Br = new WeakMap(), ta = new WeakMap(), Ci = new WeakMap(), na = new WeakMap(), Ja = new WeakMap(), Ri = new WeakSet(), lo = async function(e) {
  try {
    rt(this, Br) == null && At(this, Br, this._subscribe(rt(this, nr)));
    let T = null;
    try {
      T = await rt(this, Br);
    } catch (J) {
      if (!isError(J, "UNSUPPORTED_OPERATION") || J.operation !== "eth_newFilter")
        throw J;
    }
    if (T == null) {
      At(this, Br, null), rt(this, nr)._recoverSubscriber(this, this._recover(rt(this, nr)));
      return;
    }
    const $ = await rt(this, nr).getNetwork();
    if (rt(this, na) || At(this, na, $), rt(this, na).chainId !== $.chainId)
      throw new Error("chaid changed");
    if (rt(this, Ja))
      return;
    const V = await rt(this, nr).send("eth_getFilterChanges", [T]);
    await this._emitResults(rt(this, nr), V);
  } catch (T) {
    console.log("@TODO", T);
  }
  rt(this, nr).once("block", rt(this, ta));
}, uo = function() {
  const e = rt(this, Br);
  e && (At(this, Br, null), e.then((T) => {
    rt(this, nr).destroyed || rt(this, nr).send("eth_uninstallFilter", [T]);
  }));
};
var ra;
class FilterIdEventSubscriber extends FilterIdSubscriber {
  /**
   *  Creates a new **FilterIdEventSubscriber** attached to %%provider%%
   *  listening for %%filter%%.
   */
  constructor(T, $) {
    super(T);
    Ft(this, ra);
    At(this, ra, copy($));
  }
  _recover(T) {
    return new PollingEventSubscriber(T, rt(this, ra));
  }
  async _subscribe(T) {
    return await T.send("eth_newFilter", [rt(this, ra)]);
  }
  async _emitResults(T, $) {
    for (const V of $)
      T.emit(rt(this, ra), T._wrapLog(V, T._network));
  }
}
ra = new WeakMap();
class FilterIdPendingSubscriber extends FilterIdSubscriber {
  async _subscribe(e) {
    return await e.send("eth_newPendingTransactionFilter", []);
  }
  async _emitResults(e, T) {
    for (const $ of T)
      e.emit("pending", $);
  }
}
const Primitive = "bigint,boolean,function,number,string,symbol".split(/,/g);
function deepCopy(C) {
  if (C == null || Primitive.indexOf(typeof C) >= 0 || typeof C.getAddress == "function")
    return C;
  if (Array.isArray(C))
    return C.map(deepCopy);
  if (typeof C == "object")
    return Object.keys(C).reduce((e, T) => (e[T] = C[T], e), {});
  throw new Error(`should not happen: ${C} (${typeof C})`);
}
function stall$2(C) {
  return new Promise((e) => {
    setTimeout(e, C);
  });
}
function getLowerCase(C) {
  return C && C.toLowerCase();
}
function isPollable(C) {
  return C && typeof C.pollingInterval == "number";
}
const defaultOptions = {
  polling: !1,
  staticNetwork: null,
  batchStallTime: 10,
  batchMaxSize: 1 << 20,
  batchMaxCount: 100,
  cacheTimeout: 250,
  pollingInterval: 4e3
};
class JsonRpcSigner extends AbstractSigner {
  constructor(T, $) {
    super(T);
    tt(this, "address");
    $ = getAddress($), defineProperties(this, { address: $ });
  }
  connect(T) {
    assert$5(!1, "cannot reconnect JsonRpcSigner", "UNSUPPORTED_OPERATION", {
      operation: "signer.connect"
    });
  }
  async getAddress() {
    return this.address;
  }
  // JSON-RPC will automatially fill in nonce, etc. so we just check from
  async populateTransaction(T) {
    return await this.populateCall(T);
  }
  // Returns just the hash of the transaction after sent, which is what
  // the bare JSON-RPC API does;
  async sendUncheckedTransaction(T) {
    const $ = deepCopy(T), V = [];
    if ($.from) {
      const ee = $.from;
      V.push((async () => {
        const te = await resolveAddress(ee, this.provider);
        assertArgument(te != null && te.toLowerCase() === this.address.toLowerCase(), "from address mismatch", "transaction", T), $.from = te;
      })());
    } else
      $.from = this.address;
    if ($.gasLimit == null && V.push((async () => {
      $.gasLimit = await this.provider.estimateGas({ ...$, from: this.address });
    })()), $.to != null) {
      const ee = $.to;
      V.push((async () => {
        $.to = await resolveAddress(ee, this.provider);
      })());
    }
    V.length && await Promise.all(V);
    const J = this.provider.getRpcTransaction($);
    return this.provider.send("eth_sendTransaction", [J]);
  }
  async sendTransaction(T) {
    const $ = await this.provider.getBlockNumber(), V = await this.sendUncheckedTransaction(T);
    return await new Promise((J, ee) => {
      const te = [1e3, 100];
      let re = 0;
      const ie = async () => {
        try {
          const se = await this.provider.getTransaction(V);
          if (se != null) {
            J(se.replaceableTransaction($));
            return;
          }
        } catch (se) {
          if (isError(se, "CANCELLED") || isError(se, "BAD_DATA") || isError(se, "NETWORK_ERROR") || isError(se, "UNSUPPORTED_OPERATION")) {
            se.info == null && (se.info = {}), se.info.sendTransactionHash = V, ee(se);
            return;
          }
          if (isError(se, "INVALID_ARGUMENT") && (re++, se.info == null && (se.info = {}), se.info.sendTransactionHash = V, re > 10)) {
            ee(se);
            return;
          }
          this.provider.emit("error", makeError("failed to fetch transation after sending (will try again)", "UNKNOWN_ERROR", { error: se }));
        }
        this.provider._setTimeout(() => {
          ie();
        }, te.pop() || 4e3);
      };
      ie();
    });
  }
  async signTransaction(T) {
    const $ = deepCopy(T);
    if ($.from) {
      const J = await resolveAddress($.from, this.provider);
      assertArgument(J != null && J.toLowerCase() === this.address.toLowerCase(), "from address mismatch", "transaction", T), $.from = J;
    } else
      $.from = this.address;
    const V = this.provider.getRpcTransaction($);
    return await this.provider.send("eth_signTransaction", [V]);
  }
  async signMessage(T) {
    const $ = typeof T == "string" ? toUtf8Bytes(T) : T;
    return await this.provider.send("personal_sign", [
      hexlify($),
      this.address.toLowerCase()
    ]);
  }
  async signTypedData(T, $, V) {
    const J = deepCopy(V), ee = await TypedDataEncoder.resolveNames(T, $, J, async (te) => {
      const re = await resolveAddress(te);
      return assertArgument(re != null, "TypedData does not support null address", "value", te), re;
    });
    return await this.provider.send("eth_signTypedData_v4", [
      this.address.toLowerCase(),
      JSON.stringify(TypedDataEncoder.getPayload(ee.domain, $, ee.value))
    ]);
  }
  async unlock(T) {
    return this.provider.send("personal_unlockAccount", [
      this.address.toLowerCase(),
      T,
      null
    ]);
  }
  // https://github.com/ethereum/wiki/wiki/JSON-RPC#eth_sign
  async _legacySignMessage(T) {
    const $ = typeof T == "string" ? toUtf8Bytes(T) : T;
    return await this.provider.send("eth_sign", [
      this.address.toLowerCase(),
      hexlify($)
    ]);
  }
}
var ia, es, ii, jr, Mr, xr, ir, Ms, fo;
class JsonRpcApiProvider extends AbstractProvider {
  constructor(T, $) {
    super(T, $);
    Ft(this, Ms);
    Ft(this, ia);
    // The next ID to use for the JSON-RPC ID field
    Ft(this, es);
    // Payloads are queued and triggered in batches using the drainTimer
    Ft(this, ii);
    Ft(this, jr);
    Ft(this, Mr);
    Ft(this, xr);
    Ft(this, ir);
    At(this, es, 1), At(this, ia, Object.assign({}, defaultOptions, $ || {})), At(this, ii, []), At(this, jr, null), At(this, xr, null), At(this, ir, null);
    {
      let J = null;
      const ee = new Promise((te) => {
        J = te;
      });
      At(this, Mr, { promise: ee, resolve: J });
    }
    const V = this._getOption("staticNetwork");
    typeof V == "boolean" ? (assertArgument(!V || T !== "any", "staticNetwork cannot be used on special network 'any'", "options", $), V && T != null && At(this, xr, Network.from(T))) : V && (assertArgument(T == null || V.matches(T), "staticNetwork MUST match network object", "options", $), At(this, xr, V));
  }
  /**
   *  Returns the value associated with the option %%key%%.
   *
   *  Sub-classes can use this to inquire about configuration options.
   */
  _getOption(T) {
    return rt(this, ia)[T];
  }
  /**
   *  Gets the [[Network]] this provider has committed to. On each call, the network
   *  is detected, and if it has changed, the call will reject.
   */
  get _network() {
    return assert$5(rt(this, xr), "network is not available yet", "NETWORK_ERROR"), rt(this, xr);
  }
  /**
   *  Resolves to the non-normalized value by performing %%req%%.
   *
   *  Sub-classes may override this to modify behavior of actions,
   *  and should generally call ``super._perform`` as a fallback.
   */
  async _perform(T) {
    if (T.method === "call" || T.method === "estimateGas") {
      let V = T.transaction;
      if (V && V.type != null && getBigInt(V.type) && V.maxFeePerGas == null && V.maxPriorityFeePerGas == null) {
        const J = await this.getFeeData();
        J.maxFeePerGas == null && J.maxPriorityFeePerGas == null && (T = Object.assign({}, T, {
          transaction: Object.assign({}, V, { type: void 0 })
        }));
      }
    }
    const $ = this.getRpcRequest(T);
    return $ != null ? await this.send($.method, $.args) : super._perform(T);
  }
  /**
   *  Sub-classes may override this; it detects the *actual* network that
   *  we are **currently** connected to.
   *
   *  Keep in mind that [[send]] may only be used once [[ready]], otherwise the
   *  _send primitive must be used instead.
   */
  async _detectNetwork() {
    const T = this._getOption("staticNetwork");
    if (T)
      if (T === !0) {
        if (rt(this, xr))
          return rt(this, xr);
      } else
        return T;
    return rt(this, ir) ? await rt(this, ir) : this.ready ? (At(this, ir, (async () => {
      try {
        const $ = Network.from(getBigInt(await this.send("eth_chainId", [])));
        return At(this, ir, null), $;
      } catch ($) {
        throw At(this, ir, null), $;
      }
    })()), await rt(this, ir)) : (At(this, ir, (async () => {
      const $ = {
        id: ss(this, es)._++,
        method: "eth_chainId",
        params: [],
        jsonrpc: "2.0"
      };
      this.emit("debug", { action: "sendRpcPayload", payload: $ });
      let V;
      try {
        V = (await this._send($))[0], At(this, ir, null);
      } catch (J) {
        throw At(this, ir, null), this.emit("debug", { action: "receiveRpcError", error: J }), J;
      }
      if (this.emit("debug", { action: "receiveRpcResult", result: V }), "result" in V)
        return Network.from(getBigInt(V.result));
      throw this.getRpcError($, V);
    })()), await rt(this, ir));
  }
  /**
   *  Sub-classes **MUST** call this. Until [[_start]] has been called, no calls
   *  will be passed to [[_send]] from [[send]]. If it is overridden, then
   *  ``super._start()`` **MUST** be called.
   *
   *  Calling it multiple times is safe and has no effect.
   */
  _start() {
    rt(this, Mr) == null || rt(this, Mr).resolve == null || (rt(this, Mr).resolve(), At(this, Mr, null), (async () => {
      for (; rt(this, xr) == null && !this.destroyed; )
        try {
          At(this, xr, await this._detectNetwork());
        } catch (T) {
          if (this.destroyed)
            break;
          console.log("JsonRpcProvider failed to detect network and cannot start up; retry in 1s (perhaps the URL is wrong or the node is not started)"), this.emit("error", makeError("failed to bootstrap network detection", "NETWORK_ERROR", { event: "initial-network-discovery", info: { error: T } })), await stall$2(1e3);
        }
      Qt(this, Ms, fo).call(this);
    })());
  }
  /**
   *  Resolves once the [[_start]] has been called. This can be used in
   *  sub-classes to defer sending data until the connection has been
   *  established.
   */
  async _waitUntilReady() {
    if (rt(this, Mr) != null)
      return await rt(this, Mr).promise;
  }
  /**
   *  Return a Subscriber that will manage the %%sub%%.
   *
   *  Sub-classes may override this to modify the behavior of
   *  subscription management.
   */
  _getSubscriber(T) {
    return T.type === "pending" ? new FilterIdPendingSubscriber(this) : T.type === "event" ? this._getOption("polling") ? new PollingEventSubscriber(this, T.filter) : new FilterIdEventSubscriber(this, T.filter) : T.type === "orphan" && T.filter.orphan === "drop-log" ? new UnmanagedSubscriber("orphan") : super._getSubscriber(T);
  }
  /**
   *  Returns true only if the [[_start]] has been called.
   */
  get ready() {
    return rt(this, Mr) == null;
  }
  /**
   *  Returns %%tx%% as a normalized JSON-RPC transaction request,
   *  which has all values hexlified and any numeric values converted
   *  to Quantity values.
   */
  getRpcTransaction(T) {
    const $ = {};
    return ["chainId", "gasLimit", "gasPrice", "type", "maxFeePerGas", "maxPriorityFeePerGas", "nonce", "value"].forEach((V) => {
      if (T[V] == null)
        return;
      let J = V;
      V === "gasLimit" && (J = "gas"), $[J] = toQuantity(getBigInt(T[V], `tx.${V}`));
    }), ["from", "to", "data"].forEach((V) => {
      T[V] != null && ($[V] = hexlify(T[V]));
    }), T.accessList && ($.accessList = accessListify(T.accessList)), T.blobVersionedHashes && ($.blobVersionedHashes = T.blobVersionedHashes.map((V) => V.toLowerCase())), $;
  }
  /**
   *  Returns the request method and arguments required to perform
   *  %%req%%.
   */
  getRpcRequest(T) {
    switch (T.method) {
      case "chainId":
        return { method: "eth_chainId", args: [] };
      case "getBlockNumber":
        return { method: "eth_blockNumber", args: [] };
      case "getGasPrice":
        return { method: "eth_gasPrice", args: [] };
      case "getPriorityFee":
        return { method: "eth_maxPriorityFeePerGas", args: [] };
      case "getBalance":
        return {
          method: "eth_getBalance",
          args: [getLowerCase(T.address), T.blockTag]
        };
      case "getTransactionCount":
        return {
          method: "eth_getTransactionCount",
          args: [getLowerCase(T.address), T.blockTag]
        };
      case "getCode":
        return {
          method: "eth_getCode",
          args: [getLowerCase(T.address), T.blockTag]
        };
      case "getStorage":
        return {
          method: "eth_getStorageAt",
          args: [
            getLowerCase(T.address),
            "0x" + T.position.toString(16),
            T.blockTag
          ]
        };
      case "broadcastTransaction":
        return {
          method: "eth_sendRawTransaction",
          args: [T.signedTransaction]
        };
      case "getBlock":
        if ("blockTag" in T)
          return {
            method: "eth_getBlockByNumber",
            args: [T.blockTag, !!T.includeTransactions]
          };
        if ("blockHash" in T)
          return {
            method: "eth_getBlockByHash",
            args: [T.blockHash, !!T.includeTransactions]
          };
        break;
      case "getTransaction":
        return {
          method: "eth_getTransactionByHash",
          args: [T.hash]
        };
      case "getTransactionReceipt":
        return {
          method: "eth_getTransactionReceipt",
          args: [T.hash]
        };
      case "call":
        return {
          method: "eth_call",
          args: [this.getRpcTransaction(T.transaction), T.blockTag]
        };
      case "estimateGas":
        return {
          method: "eth_estimateGas",
          args: [this.getRpcTransaction(T.transaction)]
        };
      case "getLogs":
        return T.filter && T.filter.address != null && (Array.isArray(T.filter.address) ? T.filter.address = T.filter.address.map(getLowerCase) : T.filter.address = getLowerCase(T.filter.address)), { method: "eth_getLogs", args: [T.filter] };
    }
    return null;
  }
  /**
   *  Returns an ethers-style Error for the given JSON-RPC error
   *  %%payload%%, coalescing the various strings and error shapes
   *  that different nodes return, coercing them into a machine-readable
   *  standardized error.
   */
  getRpcError(T, $) {
    const { method: V } = T, { error: J } = $;
    if (V === "eth_estimateGas" && J.message) {
      const re = J.message;
      if (!re.match(/revert/i) && re.match(/insufficient funds/i))
        return makeError("insufficient funds", "INSUFFICIENT_FUNDS", {
          transaction: T.params[0],
          info: { payload: T, error: J }
        });
    }
    if (V === "eth_call" || V === "eth_estimateGas") {
      const re = spelunkData(J), ie = AbiCoder.getBuiltinCallException(V === "eth_call" ? "call" : "estimateGas", T.params[0], re ? re.data : null);
      return ie.info = { error: J, payload: T }, ie;
    }
    const ee = JSON.stringify(spelunkMessage(J));
    if (typeof J.message == "string" && J.message.match(/user denied|ethers-user-denied/i))
      return makeError("user rejected action", "ACTION_REJECTED", {
        action: {
          eth_sign: "signMessage",
          personal_sign: "signMessage",
          eth_signTypedData_v4: "signTypedData",
          eth_signTransaction: "signTransaction",
          eth_sendTransaction: "sendTransaction",
          eth_requestAccounts: "requestAccess",
          wallet_requestAccounts: "requestAccess"
        }[V] || "unknown",
        reason: "rejected",
        info: { payload: T, error: J }
      });
    if (V === "eth_sendRawTransaction" || V === "eth_sendTransaction") {
      const re = T.params[0];
      if (ee.match(/insufficient funds|base fee exceeds gas limit/i))
        return makeError("insufficient funds for intrinsic transaction cost", "INSUFFICIENT_FUNDS", {
          transaction: re,
          info: { error: J }
        });
      if (ee.match(/nonce/i) && ee.match(/too low/i))
        return makeError("nonce has already been used", "NONCE_EXPIRED", { transaction: re, info: { error: J } });
      if (ee.match(/replacement transaction/i) && ee.match(/underpriced/i))
        return makeError("replacement fee too low", "REPLACEMENT_UNDERPRICED", { transaction: re, info: { error: J } });
      if (ee.match(/only replay-protected/i))
        return makeError("legacy pre-eip-155 transactions not supported", "UNSUPPORTED_OPERATION", {
          operation: V,
          info: { transaction: re, info: { error: J } }
        });
    }
    let te = !!ee.match(/the method .* does not exist/i);
    return te || J && J.details && J.details.startsWith("Unauthorized method:") && (te = !0), te ? makeError("unsupported operation", "UNSUPPORTED_OPERATION", {
      operation: T.method,
      info: { error: J, payload: T }
    }) : makeError("could not coalesce error", "UNKNOWN_ERROR", { error: J, payload: T });
  }
  /**
   *  Requests the %%method%% with %%params%% via the JSON-RPC protocol
   *  over the underlying channel. This can be used to call methods
   *  on the backend that do not have a high-level API within the Provider
   *  API.
   *
   *  This method queues requests according to the batch constraints
   *  in the options, assigns the request a unique ID.
   *
   *  **Do NOT override** this method in sub-classes; instead
   *  override [[_send]] or force the options values in the
   *  call to the constructor to modify this method's behavior.
   */
  send(T, $) {
    if (this.destroyed)
      return Promise.reject(makeError("provider destroyed; cancelled request", "UNSUPPORTED_OPERATION", { operation: T }));
    const V = ss(this, es)._++, J = new Promise((ee, te) => {
      rt(this, ii).push({
        resolve: ee,
        reject: te,
        payload: { method: T, params: $, id: V, jsonrpc: "2.0" }
      });
    });
    return Qt(this, Ms, fo).call(this), J;
  }
  /**
   *  Resolves to the [[Signer]] account for  %%address%% managed by
   *  the client.
   *
   *  If the %%address%% is a number, it is used as an index in the
   *  the accounts from [[listAccounts]].
   *
   *  This can only be used on clients which manage accounts (such as
   *  Geth with imported account or MetaMask).
   *
   *  Throws if the account doesn't exist.
   */
  async getSigner(T) {
    T == null && (T = 0);
    const $ = this.send("eth_accounts", []);
    if (typeof T == "number") {
      const J = await $;
      if (T >= J.length)
        throw new Error("no such account");
      return new JsonRpcSigner(this, J[T]);
    }
    const { accounts: V } = await resolveProperties({
      network: this.getNetwork(),
      accounts: $
    });
    T = getAddress(T);
    for (const J of V)
      if (getAddress(J) === T)
        return new JsonRpcSigner(this, T);
    throw new Error("invalid account");
  }
  async listAccounts() {
    return (await this.send("eth_accounts", [])).map(($) => new JsonRpcSigner(this, $));
  }
  destroy() {
    rt(this, jr) && (clearTimeout(rt(this, jr)), At(this, jr, null));
    for (const { payload: T, reject: $ } of rt(this, ii))
      $(makeError("provider destroyed; cancelled request", "UNSUPPORTED_OPERATION", { operation: T.method }));
    At(this, ii, []), super.destroy();
  }
}
ia = new WeakMap(), es = new WeakMap(), ii = new WeakMap(), jr = new WeakMap(), Mr = new WeakMap(), xr = new WeakMap(), ir = new WeakMap(), Ms = new WeakSet(), fo = function() {
  if (rt(this, jr))
    return;
  const T = this._getOption("batchMaxCount") === 1 ? 0 : this._getOption("batchStallTime");
  At(this, jr, setTimeout(() => {
    At(this, jr, null);
    const $ = rt(this, ii);
    for (At(this, ii, []); $.length; ) {
      const V = [$.shift()];
      for (; $.length && V.length !== rt(this, ia).batchMaxCount; )
        if (V.push($.shift()), JSON.stringify(V.map((ee) => ee.payload)).length > rt(this, ia).batchMaxSize) {
          $.unshift(V.pop());
          break;
        }
      (async () => {
        const J = V.length === 1 ? V[0].payload : V.map((ee) => ee.payload);
        this.emit("debug", { action: "sendRpcPayload", payload: J });
        try {
          const ee = await this._send(J);
          this.emit("debug", { action: "receiveRpcResult", result: ee });
          for (const { resolve: te, reject: re, payload: ie } of V) {
            if (this.destroyed) {
              re(makeError("provider destroyed; cancelled request", "UNSUPPORTED_OPERATION", { operation: ie.method }));
              continue;
            }
            const se = ee.filter((de) => de.id === ie.id)[0];
            if (se == null) {
              const de = makeError("missing response for request", "BAD_DATA", {
                value: ee,
                info: { payload: ie }
              });
              this.emit("error", de), re(de);
              continue;
            }
            if ("error" in se) {
              re(this.getRpcError(ie, se));
              continue;
            }
            te(se.result);
          }
        } catch (ee) {
          this.emit("debug", { action: "receiveRpcError", error: ee });
          for (const { reject: te } of V)
            te(ee);
        }
      })();
    }
  }, T));
};
var wi;
class JsonRpcApiPollingProvider extends JsonRpcApiProvider {
  constructor(T, $) {
    super(T, $);
    Ft(this, wi);
    let V = this._getOption("pollingInterval");
    V == null && (V = defaultOptions.pollingInterval), At(this, wi, V);
  }
  _getSubscriber(T) {
    const $ = super._getSubscriber(T);
    return isPollable($) && ($.pollingInterval = rt(this, wi)), $;
  }
  /**
   *  The polling interval (default: 4000 ms)
   */
  get pollingInterval() {
    return rt(this, wi);
  }
  set pollingInterval(T) {
    if (!Number.isInteger(T) || T < 0)
      throw new Error("invalid interval");
    At(this, wi, T), this._forEachSubscriber(($) => {
      isPollable($) && ($.pollingInterval = rt(this, wi));
    });
  }
}
wi = new WeakMap();
var ts, wo;
let JsonRpcProvider$1 = (wo = class extends JsonRpcApiPollingProvider {
  constructor(T, $, V) {
    T == null && (T = "http://localhost:8545");
    super($, V);
    Ft(this, ts);
    typeof T == "string" ? At(this, ts, new FetchRequest(T)) : At(this, ts, T.clone());
  }
  _getConnection() {
    return rt(this, ts).clone();
  }
  async send(T, $) {
    return await this._start(), await super.send(T, $);
  }
  async _send(T) {
    const $ = this._getConnection();
    $.body = JSON.stringify(T), $.setHeader("content-type", "application/json");
    const V = await $.send();
    V.assertOk();
    let J = V.bodyJson;
    return Array.isArray(J) || (J = [J]), J;
  }
}, ts = new WeakMap(), wo);
function spelunkData(C) {
  if (C == null)
    return null;
  if (typeof C.message == "string" && C.message.match(/revert/i) && isHexString(C.data))
    return { message: C.message, data: C.data };
  if (typeof C == "object") {
    for (const e in C) {
      const T = spelunkData(C[e]);
      if (T)
        return T;
    }
    return null;
  }
  if (typeof C == "string")
    try {
      return spelunkData(JSON.parse(C));
    } catch {
    }
  return null;
}
function _spelunkMessage(C, e) {
  if (C != null) {
    if (typeof C.message == "string" && e.push(C.message), typeof C == "object")
      for (const T in C)
        _spelunkMessage(C[T], e);
    if (typeof C == "string")
      try {
        return _spelunkMessage(JSON.parse(C), e);
      } catch {
      }
  }
}
function spelunkMessage(C) {
  const e = [];
  return _spelunkMessage(C, e), e;
}
function getGlobal() {
  if (typeof self < "u")
    return self;
  if (typeof window < "u")
    return window;
  if (typeof dist$2.global < "u")
    return dist$2.global;
  throw new Error("unable to locate global object");
}
const _WebSocket = getGlobal().WebSocket;
var Or, Is, Ti, aa, Ei;
class SocketSubscriber {
  /**
   *  Creates a new **SocketSubscriber** attached to %%provider%% listening
   *  to %%filter%%.
   */
  constructor(e, T) {
    Ft(this, Or);
    Ft(this, Is);
    Ft(this, Ti);
    Ft(this, aa);
    Ft(this, Ei);
    At(this, Or, e), At(this, Is, JSON.stringify(T)), At(this, Ti, null), At(this, aa, null), At(this, Ei, null);
  }
  /**
   *  The filter.
   */
  get filter() {
    return JSON.parse(rt(this, Is));
  }
  start() {
    At(this, Ti, rt(this, Or).send("eth_subscribe", this.filter).then((e) => (rt(this, Or)._register(e, this), e)));
  }
  stop() {
    rt(this, Ti).then((e) => {
      rt(this, Or).destroyed || rt(this, Or).send("eth_unsubscribe", [e]);
    }), At(this, Ti, null);
  }
  // @TODO: pause should trap the current blockNumber, unsub, and on resume use getLogs
  //        and resume
  pause(e) {
    assert$5(e, "preserve logs while paused not supported by SocketSubscriber yet", "UNSUPPORTED_OPERATION", { operation: "pause(false)" }), At(this, aa, !!e);
  }
  resume() {
    At(this, aa, null);
  }
  /**
   *  @_ignore:
   */
  _handleMessage(e) {
    if (rt(this, Ti) != null && rt(this, aa) === null) {
      let T = rt(this, Ei);
      T == null ? T = this._emit(rt(this, Or), e) : T = T.then(async () => {
        await this._emit(rt(this, Or), e);
      }), At(this, Ei, T.then(() => {
        rt(this, Ei) === T && At(this, Ei, null);
      }));
    }
  }
  /**
   *  Sub-classes **must** override this to emit the events on the
   *  provider.
   */
  async _emit(e, T) {
    throw new Error("sub-classes must implemente this; _emit");
  }
}
Or = new WeakMap(), Is = new WeakMap(), Ti = new WeakMap(), aa = new WeakMap(), Ei = new WeakMap();
class SocketBlockSubscriber extends SocketSubscriber {
  /**
   *  @_ignore:
   */
  constructor(e) {
    super(e, ["newHeads"]);
  }
  async _emit(e, T) {
    e.emit("block", parseInt(T.number));
  }
}
class SocketPendingSubscriber extends SocketSubscriber {
  /**
   *  @_ignore:
   */
  constructor(e) {
    super(e, ["newPendingTransactions"]);
  }
  async _emit(e, T) {
    e.emit("pending", T);
  }
}
var Ss;
class SocketEventSubscriber extends SocketSubscriber {
  /**
   *  @_ignore:
   */
  constructor(T, $) {
    super(T, ["logs", $]);
    Ft(this, Ss);
    At(this, Ss, JSON.stringify($));
  }
  /**
   *  The filter.
   */
  get logFilter() {
    return JSON.parse(rt(this, Ss));
  }
  async _emit(T, $) {
    T.emit(this.logFilter, T._wrapLog($, T._network));
  }
}
Ss = new WeakMap();
var sa, ns, Mi;
class SocketProvider extends JsonRpcApiProvider {
  /**
   *  Creates a new **SocketProvider** connected to %%network%%.
   *
   *  If unspecified, the network will be discovered.
   */
  constructor(T, $) {
    const V = Object.assign({}, $ ?? {});
    assertArgument(V.batchMaxCount == null || V.batchMaxCount === 1, "sockets-based providers do not support batches", "options.batchMaxCount", $), V.batchMaxCount = 1, V.staticNetwork == null && (V.staticNetwork = !0);
    super(T, V);
    Ft(this, sa);
    // Maps each filterId to its subscriber
    Ft(this, ns);
    // If any events come in before a subscriber has finished
    // registering, queue them
    Ft(this, Mi);
    At(this, sa, /* @__PURE__ */ new Map()), At(this, ns, /* @__PURE__ */ new Map()), At(this, Mi, /* @__PURE__ */ new Map());
  }
  // This value is only valid after _start has been called
  /*
  get _network(): Network {
      if (this.#network == null) {
          throw new Error("this shouldn't happen");
      }
      return this.#network.clone();
  }
  */
  _getSubscriber(T) {
    switch (T.type) {
      case "close":
        return new UnmanagedSubscriber("close");
      case "block":
        return new SocketBlockSubscriber(this);
      case "pending":
        return new SocketPendingSubscriber(this);
      case "event":
        return new SocketEventSubscriber(this, T.filter);
      case "orphan":
        if (T.filter.orphan === "drop-log")
          return new UnmanagedSubscriber("drop-log");
    }
    return super._getSubscriber(T);
  }
  /**
   *  Register a new subscriber. This is used internalled by Subscribers
   *  and generally is unecessary unless extending capabilities.
   */
  _register(T, $) {
    rt(this, ns).set(T, $);
    const V = rt(this, Mi).get(T);
    if (V) {
      for (const J of V)
        $._handleMessage(J);
      rt(this, Mi).delete(T);
    }
  }
  async _send(T) {
    assertArgument(!Array.isArray(T), "WebSocket does not support batch send", "payload", T);
    const $ = new Promise((V, J) => {
      rt(this, sa).set(T.id, { payload: T, resolve: V, reject: J });
    });
    return await this._waitUntilReady(), await this._write(JSON.stringify(T)), [await $];
  }
  // Sub-classes must call this once they are connected
  /*
      async _start(): Promise<void> {
          if (this.#ready) { return; }
  
          for (const { payload } of this.#callbacks.values()) {
              await this._write(JSON.stringify(payload));
          }
  
          this.#ready = (async function() {
              await super._start();
          })();
      }
      */
  /**
   *  Sub-classes **must** call this with messages received over their
   *  transport to be processed and dispatched.
   */
  async _processMessage(T) {
    const $ = JSON.parse(T);
    if ($ && typeof $ == "object" && "id" in $) {
      const V = rt(this, sa).get($.id);
      if (V == null) {
        this.emit("error", makeError("received result for unknown id", "UNKNOWN_ERROR", {
          reasonCode: "UNKNOWN_ID",
          result: $
        }));
        return;
      }
      rt(this, sa).delete($.id), V.resolve($);
    } else if ($ && $.method === "eth_subscription") {
      const V = $.params.subscription, J = rt(this, ns).get(V);
      if (J)
        J._handleMessage($.params.result);
      else {
        let ee = rt(this, Mi).get(V);
        ee == null && (ee = [], rt(this, Mi).set(V, ee)), ee.push($.params.result);
      }
    } else {
      this.emit("error", makeError("received unexpected message", "UNKNOWN_ERROR", {
        reasonCode: "UNEXPECTED_MESSAGE",
        result: $
      }));
      return;
    }
  }
  /**
   *  Sub-classes **must** override this to send %%message%% over their
   *  transport.
   */
  async _write(T) {
    throw new Error("sub-classes must override this");
  }
}
sa = new WeakMap(), ns = new WeakMap(), Mi = new WeakMap();
var oa, Ir;
class WebSocketProvider extends SocketProvider {
  constructor(T, $, V) {
    super($, V);
    Ft(this, oa);
    Ft(this, Ir);
    typeof T == "string" ? (At(this, oa, () => new _WebSocket(T)), At(this, Ir, rt(this, oa).call(this))) : typeof T == "function" ? (At(this, oa, T), At(this, Ir, T())) : (At(this, oa, null), At(this, Ir, T)), this.websocket.onopen = async () => {
      try {
        await this._start(), this.resume();
      } catch (J) {
        console.log("failed to start WebsocketProvider", J);
      }
    }, this.websocket.onmessage = (J) => {
      this._processMessage(J.data);
    };
  }
  get websocket() {
    if (rt(this, Ir) == null)
      throw new Error("websocket closed");
    return rt(this, Ir);
  }
  async _write(T) {
    this.websocket.send(T);
  }
  async destroy() {
    rt(this, Ir) != null && (rt(this, Ir).close(), At(this, Ir, null)), super.destroy();
  }
}
oa = new WeakMap(), Ir = new WeakMap();
var rs;
const Ao = class Ao extends AbstractSigner {
  /**
   *  Creates a new BaseWallet for %%privateKey%%, optionally
   *  connected to %%provider%%.
   *
   *  If %%provider%% is not specified, only offline methods can
   *  be used.
   */
  constructor(T, $) {
    super($);
    /**
     *  The wallet address.
     */
    tt(this, "address");
    Ft(this, rs);
    assertArgument(T && typeof T.sign == "function", "invalid private key", "privateKey", "[ REDACTED ]"), At(this, rs, T);
    const V = computeAddress(this.signingKey.publicKey);
    defineProperties(this, { address: V });
  }
  // Store private values behind getters to reduce visibility
  // in console.log
  /**
   *  The [[SigningKey]] used for signing payloads.
   */
  get signingKey() {
    return rt(this, rs);
  }
  /**
   *  The private key for this wallet.
   */
  get privateKey() {
    return this.signingKey.privateKey;
  }
  async getAddress() {
    return this.address;
  }
  connect(T) {
    return new Ao(rt(this, rs), T);
  }
  async signTransaction(T) {
    T = copyRequest(T);
    const { to: $, from: V } = await resolveProperties({
      to: T.to ? resolveAddress(T.to, this.provider) : void 0,
      from: T.from ? resolveAddress(T.from, this.provider) : void 0
    });
    $ != null && (T.to = $), V != null && (T.from = V), T.from != null && (assertArgument(getAddress(T.from) === this.address, "transaction from address mismatch", "tx.from", T.from), delete T.from);
    const J = Transaction$1.from(T);
    return J.signature = this.signingKey.sign(J.unsignedHash), J.serialized;
  }
  async signMessage(T) {
    return this.signMessageSync(T);
  }
  // @TODO: Add a secialized signTx and signTyped sync that enforces
  // all parameters are known?
  /**
   *  Returns the signature for %%message%% signed with this wallet.
   */
  signMessageSync(T) {
    return this.signingKey.sign(hashMessage(T)).serialized;
  }
  async signTypedData(T, $, V) {
    const J = await TypedDataEncoder.resolveNames(T, $, V, async (ee) => {
      assert$5(this.provider != null, "cannot resolve ENS names without a provider", "UNSUPPORTED_OPERATION", {
        operation: "resolveName",
        info: { name: ee }
      });
      const te = await this.provider.resolveName(ee);
      return assert$5(te != null, "unconfigured ENS name", "UNCONFIGURED_NAME", {
        value: ee
      }), te;
    });
    return this.signingKey.sign(TypedDataEncoder.hash(J.domain, $, J.value)).serialized;
  }
};
rs = new WeakMap();
let BaseWallet = Ao;
const subsChrs = " !#$%&'()*+,-./<=>?@[]^_`{|}~", Word = /^[a-z]*$/i;
function unfold(C, e) {
  let T = 97;
  return C.reduce(($, V) => (V === e ? T++ : V.match(Word) ? $.push(String.fromCharCode(T) + V) : (T = 97, $.push(V)), $), []);
}
function decode$4(C, e) {
  for (let V = subsChrs.length - 1; V >= 0; V--)
    C = C.split(subsChrs[V]).join(e.substring(2 * V, 2 * V + 2));
  const T = [], $ = C.replace(/(:|([0-9])|([A-Z][a-z]*))/g, (V, J, ee, te) => {
    if (ee)
      for (let re = parseInt(ee); re >= 0; re--)
        T.push(";");
    else
      T.push(J.toLowerCase());
    return "";
  });
  if ($)
    throw new Error(`leftovers: ${JSON.stringify($)}`);
  return unfold(unfold(T, ";"), ":");
}
function decodeOwl(C) {
  return assertArgument(C[0] === "0", "unsupported auwl data", "data", C), decode$4(C.substring(1 + 2 * subsChrs.length), C.substring(1, 1 + 2 * subsChrs.length));
}
class Wordlist {
  /**
   *  Creates a new Wordlist instance.
   *
   *  Sub-classes MUST call this if they provide their own constructor,
   *  passing in the locale string of the language.
   *
   *  Generally there is no need to create instances of a Wordlist,
   *  since each language-specific Wordlist creates an instance and
   *  there is no state kept internally, so they are safe to share.
   */
  constructor(e) {
    tt(this, "locale");
    defineProperties(this, { locale: e });
  }
  /**
   *  Sub-classes may override this to provide a language-specific
   *  method for spliting %%phrase%% into individual words.
   *
   *  By default, %%phrase%% is split using any sequences of
   *  white-space as defined by regular expressions (i.e. ``/\s+/``).
   */
  split(e) {
    return e.toLowerCase().split(/\s+/g);
  }
  /**
   *  Sub-classes may override this to provider a language-specific
   *  method for joining %%words%% into a phrase.
   *
   *  By default, %%words%% are joined by a single space.
   */
  join(e) {
    return e.join(" ");
  }
}
var as, ks, ca, Ds, po;
class WordlistOwl extends Wordlist {
  /**
   *  Creates a new Wordlist for %%locale%% using the OWL %%data%%
   *  and validated against the %%checksum%%.
   */
  constructor(T, $, V) {
    super(T);
    Ft(this, Ds);
    Ft(this, as);
    Ft(this, ks);
    Ft(this, ca);
    At(this, as, $), At(this, ks, V), At(this, ca, null);
  }
  /**
   *  The OWL-encoded data.
   */
  get _data() {
    return rt(this, as);
  }
  /**
   *  Decode all the words for the wordlist.
   */
  _decodeWords() {
    return decodeOwl(rt(this, as));
  }
  getWord(T) {
    const $ = Qt(this, Ds, po).call(this);
    return assertArgument(T >= 0 && T < $.length, `invalid word index: ${T}`, "index", T), $[T];
  }
  getWordIndex(T) {
    return Qt(this, Ds, po).call(this).indexOf(T);
  }
}
as = new WeakMap(), ks = new WeakMap(), ca = new WeakMap(), Ds = new WeakSet(), po = function() {
  if (rt(this, ca) == null) {
    const T = this._decodeWords();
    if (id(T.join(`
`) + `
`) !== rt(this, ks))
      throw new Error(`BIP39 Wordlist for ${this.locale} FAILED`);
    At(this, ca, T);
  }
  return rt(this, ca);
};
const words = "0erleonalorenseinceregesticitStanvetearctssi#ch2Athck&tneLl0And#Il.yLeOutO=S|S%b/ra@SurdU'0Ce[Cid|CountCu'Hie=IdOu,-Qui*Ro[TT]T%T*[Tu$0AptDD-tD*[Ju,M.UltV<)Vi)0Rob-0FairF%dRaid0A(EEntRee0Ead0MRRp%tS!_rmBumCoholErtI&LLeyLowMo,O}PhaReadySoT Ways0A>urAz(gOngOuntU'd0Aly,Ch%Ci|G G!GryIm$K!Noun)Nu$O` Sw T&naTiqueXietyY1ArtOlogyPe?P!Pro=Ril1ChCt-EaEnaGueMMedM%MyOundR<+Re,Ri=RowTTefa@Ti,Tw%k0KPe@SaultSetSi,SumeThma0H!>OmTa{T&dT.udeTra@0Ct]D.Gu,NtTh%ToTumn0Era+OcadoOid0AkeA*AyEsomeFulKw?d0Is:ByChel%C#D+GL<)Lc#y~MbooN<aNn RRelyRga(R*lSeS-SketTt!3A^AnAutyCau'ComeEfF%eG(Ha=H(dLie=LowLtN^Nef./TrayTt Twe&Y#d3Cyc!DKeNdOlogyRdR`Tt _{AdeAmeAnketA,EakE[IndOodO[omOu'UeUrUsh_rdAtDyIlMbNeNusOkO,Rd R(gRrowSsTtomUn)XY_{etA(AndA[A=EadEezeI{Id+IefIghtIngIskOccoliOk&OnzeOomO` OwnUsh2Bb!DdyD+tFf$oIldLbLkL!tNd!Nk Rd&Rg R,SS(e[SyTt Y Zz:Bba+B(B!CtusGeKe~LmM aMpNN$N)lNdyNn#NoeNvasNy#Pab!P.$Pta(RRb#RdRgoRpetRryRtSeShS(o/!Su$TT$ogT^Teg%yTt!UghtU'Ut]Ve3Il(gL yM|NsusNturyRe$Rta(_irAlkAmp]An+AosApt Ar+A'AtEapE{Ee'EfErryE,I{&IefIldIm}yOi)Oo'R#-U{!UnkUrn0G?Nnam#Rc!Tiz&TyVil_imApArifyAwAyE<ErkEv I{I|IffImbIn-IpO{OgO'O`OudOwnUbUmpU, Ut^_^A,C#utDeFfeeIlInL!@L%LumnMb(eMeMf%tM-Mm#Mp<yNc tNdu@NfirmNg*[N}@Nsid NtrolNv()OkOlPp PyR$ReRnR*@/Tt#U^UntryUp!Ur'Us(V Yo>_{Ad!AftAmA}AshAt AwlAzyEamEd.EekEwI{etImeIspIt-OpO[Ou^OwdUci$UelUi'Umb!Un^UshYY,$2BeLtu*PPbo?dRiousRr|Rta(R=Sh]/omTe3C!:DMa+MpN)Ng R(gShUght WnY3AlBa>BrisCadeCemb CideCl(eC%a>C*a'ErF&'F(eFyG*eLayLiv M<dMi'Ni$Nti,NyP?tP&dPos.P`PutyRi=ScribeS tSignSkSpair/royTailTe@VelopVi)Vo>3AgramAlAm#dAryCeE'lEtFf G.$Gn.yLemmaNn NosaurRe@RtSag*eScov Sea'ShSmi[S%d Splay/<)V tVideV%)Zzy5Ct%Cum|G~Lph(Ma(Na>NkeyN%OrSeUb!Ve_ftAg#AmaA,-AwEamE[IftIllInkIpI=OpUmY2CkMbNeR(g/T^Ty1Arf1Nam-:G G!RlyRnR`Sily/Sy1HoOlogyOnomy0GeItUca>1F%t0G1GhtTh 2BowD E@r-Eg<tEm|Eph<tEvat%I>Se0B?kBodyBra)Er+Ot]PloyPow Pty0Ab!A@DD![D%'EmyErgyF%)Ga+G(eH<)JoyLi,OughR-hRollSu*T Ti*TryVelope1Isode0U$Uip0AA'OdeOs]R%Upt0CapeSayS&)Ta>0Ern$H-s1Id&)IlOkeOl=1A@Amp!Ce[Ch<+C.eCludeCu'Ecu>Erci'Hau,Hib.I!I,ItOt-P<dPe@Pi*Pla(Po'P*[T&dTra0EEbrow:Br-CeCultyDeIntI`~L'MeMilyMousNNcyNtasyRmSh]TT$Th TigueUltV%.e3Atu*Bru?yD $EEdElMa!N)/iv$T^V W3B Ct]EldGu*LeLmLt N$NdNeNg NishReRmR,Sc$ShTT}[X_gAmeAshAtAv%EeIghtIpOatO{O%Ow UidUshY_mCusGIlLd~owOdOtR)Re,R+tRkRtu}RumRw?dSsil/ UndX_gi!AmeEqu|EshI&dIn+OgOntO,OwnOz&U.2ElNNnyRna)RyTu*:D+tInLaxy~ yMePRa+Rba+Rd&Rl-Rm|SSpTeTh U+Ze3N $NiusN*Nt!Nu(e/u*2O,0AntFtGg!Ng RaffeRlVe_dAn)A*A[IdeImp'ObeOomOryO=OwUe_tDde[LdOdO'RillaSpelSsipV nWn_bA)A(AntApeA[Av.yEatE&IdIefItOc yOupOwUnt_rdE[IdeIltIt?N3M:B.IrLfMm M, NdPpyRb%RdRshR=,TVeWkZ?d3AdAl`ArtAvyD+hogIght~oLmetLpNRo3Dd&Gh~NtPRe/%y5BbyCkeyLdLeLiday~owMeNeyOdPeRnRr%R'Sp.$/TelUrV 5BGeM<Mb!M%Nd*dNgryNtRd!RryRtSb<d3Brid:1EOn0EaEntifyLe2N%e4LLeg$L}[0A+Ita>M&'Mu}Pa@Po'Pro=Pul'0ChCludeComeC*a'DexD-a>Do%Du,ryF<tFl-tF%mHa!H .Iti$Je@JuryMa>N Noc|PutQuiryS<eSe@SideSpi*/$lTa@T e,ToVe,V.eVol=3On0L<dOla>Sue0Em1Ory:CketGu?RZz3AlousAns~yWel9BInKeUr}yY5D+I)MpNg!Ni%Nk/:Ng?oo3EnEpT^upY3CkDD}yNdNgdomSsTT^&TeTt&Wi4EeIfeO{Ow:BBelB%Dd DyKeMpNgua+PtopR+T T(UghUndryVaWWnWsu.Y Zy3Ad AfArnA=Ctu*FtGG$G&dIsu*M#NdNg`NsOp?dSs#Tt Vel3ArB tyBr?yC&'FeFtGhtKeMbM.NkOnQuid/Tt!VeZ?d5AdAnB, C$CkG-NelyNgOpTt yUdUn+VeY$5CkyGga+Mb N?N^Xury3R-s:Ch(eDG-G}tIdIlInJ%KeMm$NNa+Nda>NgoNs]Nu$P!Rb!R^Rg(R(eRketRria+SkSs/ T^T i$ThTrixTt XimumZe3AdowAnAsu*AtCh<-D$DiaLodyLtMb M%yNt]NuRcyR+R.RryShSsa+T$Thod3Dd!DnightLk~]M-NdNimumN%Nu>Rac!Rr%S ySs/akeXXedXtu*5Bi!DelDifyMM|N.%NkeyN, N`OnR$ReRn(gSqu.oTh T]T%Unta(U'VeVie5ChFf(LeLtiplySc!SeumShroomS-/Tu$3Self/ yTh:I=MePk(Rrow/yT]Tu*3ArCkEdGati=G!@I` PhewR=/TTw%kUtr$V WsXt3CeGht5B!I'M(eeOd!Rm$R`SeTab!TeTh(gTi)VelW5C!?Mb R'T:K0EyJe@Li+Scu*S =Ta(Vious0CurE<Tob 0Or1FF Fi)T&2L1Ay0DI=Ymp-0It0CeEI#L(eLy1EnEraIn]Po'T]1An+B.Ch?dD D(?yG<I|Ig($Ph<0Tr-h0H 0Tdo%T TputTside0AlEnEr0NN 0Yg&0/ 0O}:CtDd!GeIrLa)LmNdaNelN-N` P RadeR|RkRrotRtySsT^ThTi|TrolTt nU'VeYm|3A)AnutArAs<tL-<NN$tyNcilOp!Pp Rfe@Rm.Rs#T2O}OtoRa'Ys-$0AnoCn-Ctu*E)GGe#~LotNkO} Pe/olT^Zza_)A}tA,-A>AyEa'Ed+U{UgUn+2EmEtIntL?LeLi)NdNyOlPul?Rt]S.]Ssib!/TatoTt yV tyWd W _@i)Ai'Ed-tEf Epa*Es|EttyEv|I)IdeIm?yIntI%.yIs#Iva>IzeOb!mO)[Odu)Of.OgramOje@Omo>OofOp tyOsp O>@OudOvide2Bl-Dd(g~LpL'Mpk(N^PilPpyR^a'R.yRpo'R'ShTZz!3Ramid:99Al.yAntumArt E,]I{ItIzO>:Bb.Cco#CeCkD?DioIlInI'~yMpN^NdomN+PidReTeTh V&WZ%3AdyAlAs#BelBuildC$lCei=CipeC%dCyc!Du)F!@F%mFu'G]G*tGul?Je@LaxLea'LiefLyMa(Memb M(dMo=Nd NewNtOp&PairPeatPla)P%tQui*ScueSemb!Si,Sour)Sp#'SultTi*T*atTurnUn]Ve$ViewW?d2Y`m0BBb#CeChDeD+F!GhtGidNgOtPp!SkTu$V$V 5AdA,BotBu,CketM<)OfOkieOmSeTa>UghUndU>Y$5Bb DeGLeNNwayR$:DDd!D}[FeIlLadLm#L#LtLu>MeMp!NdTisfyToshiU)Usa+VeY1A!AnA*Att E}HemeHoolI&)I[%sOrp]OutRapRe&RiptRub1AAr^As#AtC#dC*tCt]Cur.yEdEkGm|Le@~M(?Ni%N'Nt&)RiesRvi)Ss]Tt!TupV&_dowAftAllowA*EdEllEriffIeldIftI}IpIv O{OeOotOpOrtOuld O=RimpRugUff!Y0Bl(gCkDeE+GhtGnL|Lk~yLv Mil?Mp!N)NgR&/ Tua>XZe1A>Et^IIllInIrtUll0AbAmEepEnd I)IdeIghtImOg<OtOwUsh0AllArtI!OkeOo`0A{AkeApIffOw0ApCc Ci$CkDaFtL?Ldi LidLut]L=Me#eNgOnRryRtUlUndUpUr)U`0A)A*Ati$AwnEakEci$EedEllEndH eI)Id IkeInIr.L.OilOns%O#OrtOtRayReadR(gY0Ua*UeezeUir*l_b!AdiumAffA+AirsAmpAndArtA>AyEakEelEmEpE*oI{IllIngO{Oma^O}OolOryO=Ra>gyReetRikeR#gRugg!Ud|UffUmb!Y!0Bje@Bm.BwayC)[ChDd&Ff G?G+,ItMm NNnyN'tP PplyP*meReRfa)R+Rpri'RroundR=ySpe@/a(1AllowAmpApArmE?EetIftImIngIt^Ord1MbolMptomRup/em:B!Ck!GIlL|LkNkPeR+tSk/eTtooXi3A^Am~NN<tNnisNtRm/Xt_nkAtEmeEnE%yE*EyIngIsOughtReeRi=RowUmbUnd 0CketDeG LtMb MeNyPRedSsueT!5A,BaccoDayDdl EGe` I!tK&MatoM%rowNeNgueNightOlO`PP-Pp!R^RnadoRtoi'SsT$Uri,W?dW WnY_{AdeAff-Ag-A(Ansf ApAshA=lAyEatEeEndI$IbeI{Igg ImIpOphyOub!U{UeUlyUmpetU,U`Y2BeIt]Mb!NaN}lRkeyRnRt!1El=EntyI)InI,O1PeP-$:5Ly5B*lla0Ab!Awa*C!Cov D DoFairFoldHappyIf%mIqueItIv 'KnownLo{TilUsu$Veil1Da>GradeHoldOnP Set1B<Ge0A+EEdEfulE![U$0Il.y:C<tCuumGueLidL!yL=NNishP%Rious/Ult3H-!L=tNd%Ntu*NueRbRifyRs]RyS'lT <3Ab!Br<tCiousCt%yDeoEw~a+Nta+Ol(Rtu$RusSaS.Su$T$Vid5C$I)IdLc<oLumeTeYa+:GeG#ItLk~LnutNtRfa*RmRri%ShSp/eT VeY3Al`Ap#ArA'lA` BDd(gEk&dIrdLcome/T_!AtEatEelEnE*IpIsp 0DeD`FeLd~NNdowNeNgNkNn Nt ReSdomSeShT}[5LfM<Nd OdOlRdRkRldRryR`_pE{E,!I,I>Ong::Rd3Ar~ow9UUngU`:3BraRo9NeO", checksum$1 = "0x3c8acc1e7b08d8e76f9fda015ef48dc8c710a73cb7e0f77b2c18a9b5a7adde60";
let wordlist = null;
class LangEn extends WordlistOwl {
  /**
   *  Creates a new instance of the English language Wordlist.
   *
   *  This should be unnecessary most of the time as the exported
   *  [[langEn]] should suffice.
   *
   *  @_ignore:
   */
  constructor() {
    super("en", words, checksum$1);
  }
  /**
   *  Returns a singleton instance of a ``LangEn``, creating it
   *  if this is the first time being called.
   */
  static wordlist() {
    return wordlist == null && (wordlist = new LangEn()), wordlist;
  }
}
function getUpperMask(C) {
  return (1 << C) - 1 << 8 - C & 255;
}
function getLowerMask(C) {
  return (1 << C) - 1 & 255;
}
function mnemonicToEntropy(C, e) {
  assertNormalize("NFKD"), e == null && (e = LangEn.wordlist());
  const T = e.split(C);
  assertArgument(T.length % 3 === 0 && T.length >= 12 && T.length <= 24, "invalid mnemonic length", "mnemonic", "[ REDACTED ]");
  const $ = new Uint8Array(Math.ceil(11 * T.length / 8));
  let V = 0;
  for (let ie = 0; ie < T.length; ie++) {
    let se = e.getWordIndex(T[ie].normalize("NFKD"));
    assertArgument(se >= 0, `invalid mnemonic word at index ${ie}`, "mnemonic", "[ REDACTED ]");
    for (let de = 0; de < 11; de++)
      se & 1 << 10 - de && ($[V >> 3] |= 1 << 7 - V % 8), V++;
  }
  const J = 32 * T.length / 3, ee = T.length / 3, te = getUpperMask(ee), re = getBytes(sha256$6($.slice(0, J / 8)))[0] & te;
  return assertArgument(re === ($[$.length - 1] & te), "invalid mnemonic checksum", "mnemonic", "[ REDACTED ]"), hexlify($.slice(0, J / 8));
}
function entropyToMnemonic(C, e) {
  assertArgument(C.length % 4 === 0 && C.length >= 16 && C.length <= 32, "invalid entropy size", "entropy", "[ REDACTED ]"), e == null && (e = LangEn.wordlist());
  const T = [0];
  let $ = 11;
  for (let ee = 0; ee < C.length; ee++)
    $ > 8 ? (T[T.length - 1] <<= 8, T[T.length - 1] |= C[ee], $ -= 8) : (T[T.length - 1] <<= $, T[T.length - 1] |= C[ee] >> 8 - $, T.push(C[ee] & getLowerMask(8 - $)), $ += 3);
  const V = C.length / 4, J = parseInt(sha256$6(C).substring(2, 4), 16) & getUpperMask(V);
  return T[T.length - 1] <<= V, T[T.length - 1] |= J >> 8 - V, e.join(T.map((ee) => e.getWord(ee)));
}
const _guard$1 = {};
class Mnemonic {
  /**
   *  @private
   */
  constructor(e, T, $, V, J) {
    /**
     *  The mnemonic phrase of 12, 15, 18, 21 or 24 words.
     *
     *  Use the [[wordlist]] ``split`` method to get the individual words.
     */
    tt(this, "phrase");
    /**
     *  The password used for this mnemonic. If no password is used this
     *  is the empty string (i.e. ``""``) as per the specification.
     */
    tt(this, "password");
    /**
     *  The wordlist for this mnemonic.
     */
    tt(this, "wordlist");
    /**
     *  The underlying entropy which the mnemonic encodes.
     */
    tt(this, "entropy");
    V == null && (V = ""), J == null && (J = LangEn.wordlist()), assertPrivate(e, _guard$1, "Mnemonic"), defineProperties(this, { phrase: $, password: V, wordlist: J, entropy: T });
  }
  /**
   *  Returns the seed for the mnemonic.
   */
  computeSeed() {
    const e = toUtf8Bytes("mnemonic" + this.password, "NFKD");
    return pbkdf2(toUtf8Bytes(this.phrase, "NFKD"), e, 2048, 64, "sha512");
  }
  /**
   *  Creates a new Mnemonic for the %%phrase%%.
   *
   *  The default %%password%% is the empty string and the default
   *  wordlist is the [English wordlists](LangEn).
   */
  static fromPhrase(e, T, $) {
    const V = mnemonicToEntropy(e, $);
    return e = entropyToMnemonic(getBytes(V), $), new Mnemonic(_guard$1, V, e, T, $);
  }
  /**
   *  Create a new **Mnemonic** from the %%entropy%%.
   *
   *  The default %%password%% is the empty string and the default
   *  wordlist is the [English wordlists](LangEn).
   */
  static fromEntropy(e, T, $) {
    const V = getBytes(e, "entropy"), J = entropyToMnemonic(V, $);
    return new Mnemonic(_guard$1, hexlify(V), J, T, $);
  }
  /**
   *  Returns the phrase for %%mnemonic%%.
   */
  static entropyToPhrase(e, T) {
    const $ = getBytes(e, "entropy");
    return entropyToMnemonic($, T);
  }
  /**
   *  Returns the entropy for %%phrase%%.
   */
  static phraseToEntropy(e, T) {
    return mnemonicToEntropy(e, T);
  }
  /**
   *  Returns true if %%phrase%% is a valid [[link-bip-39]] phrase.
   *
   *  This checks all the provided words belong to the %%wordlist%%,
   *  that the length is valid and the checksum is correct.
   */
  static isValidMnemonic(e, T) {
    try {
      return mnemonicToEntropy(e, T), !0;
    } catch {
    }
    return !1;
  }
}
/*! MIT License. Copyright 2015-2022 Richard Moore <me@ricmoo.com>. See LICENSE.txt. */
var __classPrivateFieldGet$2 = function(C, e, T, $) {
  if (T === "a" && !$) throw new TypeError("Private accessor was defined without a getter");
  if (typeof e == "function" ? C !== e || !$ : !e.has(C)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
  return T === "m" ? $ : T === "a" ? $.call(C) : $ ? $.value : e.get(C);
}, __classPrivateFieldSet$2 = function(C, e, T, $, V) {
  if ($ === "m") throw new TypeError("Private method is not writable");
  if ($ === "a" && !V) throw new TypeError("Private accessor was defined without a setter");
  if (typeof e == "function" ? C !== e || !V : !e.has(C)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
  return $ === "a" ? V.call(C, T) : V ? V.value = T : e.set(C, T), T;
}, _AES_key, _AES_Kd, _AES_Ke;
const numberOfRounds = { 16: 10, 24: 12, 32: 14 }, rcon = [1, 2, 4, 8, 16, 32, 64, 128, 27, 54, 108, 216, 171, 77, 154, 47, 94, 188, 99, 198, 151, 53, 106, 212, 179, 125, 250, 239, 197, 145], S = [99, 124, 119, 123, 242, 107, 111, 197, 48, 1, 103, 43, 254, 215, 171, 118, 202, 130, 201, 125, 250, 89, 71, 240, 173, 212, 162, 175, 156, 164, 114, 192, 183, 253, 147, 38, 54, 63, 247, 204, 52, 165, 229, 241, 113, 216, 49, 21, 4, 199, 35, 195, 24, 150, 5, 154, 7, 18, 128, 226, 235, 39, 178, 117, 9, 131, 44, 26, 27, 110, 90, 160, 82, 59, 214, 179, 41, 227, 47, 132, 83, 209, 0, 237, 32, 252, 177, 91, 106, 203, 190, 57, 74, 76, 88, 207, 208, 239, 170, 251, 67, 77, 51, 133, 69, 249, 2, 127, 80, 60, 159, 168, 81, 163, 64, 143, 146, 157, 56, 245, 188, 182, 218, 33, 16, 255, 243, 210, 205, 12, 19, 236, 95, 151, 68, 23, 196, 167, 126, 61, 100, 93, 25, 115, 96, 129, 79, 220, 34, 42, 144, 136, 70, 238, 184, 20, 222, 94, 11, 219, 224, 50, 58, 10, 73, 6, 36, 92, 194, 211, 172, 98, 145, 149, 228, 121, 231, 200, 55, 109, 141, 213, 78, 169, 108, 86, 244, 234, 101, 122, 174, 8, 186, 120, 37, 46, 28, 166, 180, 198, 232, 221, 116, 31, 75, 189, 139, 138, 112, 62, 181, 102, 72, 3, 246, 14, 97, 53, 87, 185, 134, 193, 29, 158, 225, 248, 152, 17, 105, 217, 142, 148, 155, 30, 135, 233, 206, 85, 40, 223, 140, 161, 137, 13, 191, 230, 66, 104, 65, 153, 45, 15, 176, 84, 187, 22], Si = [82, 9, 106, 213, 48, 54, 165, 56, 191, 64, 163, 158, 129, 243, 215, 251, 124, 227, 57, 130, 155, 47, 255, 135, 52, 142, 67, 68, 196, 222, 233, 203, 84, 123, 148, 50, 166, 194, 35, 61, 238, 76, 149, 11, 66, 250, 195, 78, 8, 46, 161, 102, 40, 217, 36, 178, 118, 91, 162, 73, 109, 139, 209, 37, 114, 248, 246, 100, 134, 104, 152, 22, 212, 164, 92, 204, 93, 101, 182, 146, 108, 112, 72, 80, 253, 237, 185, 218, 94, 21, 70, 87, 167, 141, 157, 132, 144, 216, 171, 0, 140, 188, 211, 10, 247, 228, 88, 5, 184, 179, 69, 6, 208, 44, 30, 143, 202, 63, 15, 2, 193, 175, 189, 3, 1, 19, 138, 107, 58, 145, 17, 65, 79, 103, 220, 234, 151, 242, 207, 206, 240, 180, 230, 115, 150, 172, 116, 34, 231, 173, 53, 133, 226, 249, 55, 232, 28, 117, 223, 110, 71, 241, 26, 113, 29, 41, 197, 137, 111, 183, 98, 14, 170, 24, 190, 27, 252, 86, 62, 75, 198, 210, 121, 32, 154, 219, 192, 254, 120, 205, 90, 244, 31, 221, 168, 51, 136, 7, 199, 49, 177, 18, 16, 89, 39, 128, 236, 95, 96, 81, 127, 169, 25, 181, 74, 13, 45, 229, 122, 159, 147, 201, 156, 239, 160, 224, 59, 77, 174, 42, 245, 176, 200, 235, 187, 60, 131, 83, 153, 97, 23, 43, 4, 126, 186, 119, 214, 38, 225, 105, 20, 99, 85, 33, 12, 125], T1 = [3328402341, 4168907908, 4000806809, 4135287693, 4294111757, 3597364157, 3731845041, 2445657428, 1613770832, 33620227, 3462883241, 1445669757, 3892248089, 3050821474, 1303096294, 3967186586, 2412431941, 528646813, 2311702848, 4202528135, 4026202645, 2992200171, 2387036105, 4226871307, 1101901292, 3017069671, 1604494077, 1169141738, 597466303, 1403299063, 3832705686, 2613100635, 1974974402, 3791519004, 1033081774, 1277568618, 1815492186, 2118074177, 4126668546, 2211236943, 1748251740, 1369810420, 3521504564, 4193382664, 3799085459, 2883115123, 1647391059, 706024767, 134480908, 2512897874, 1176707941, 2646852446, 806885416, 932615841, 168101135, 798661301, 235341577, 605164086, 461406363, 3756188221, 3454790438, 1311188841, 2142417613, 3933566367, 302582043, 495158174, 1479289972, 874125870, 907746093, 3698224818, 3025820398, 1537253627, 2756858614, 1983593293, 3084310113, 2108928974, 1378429307, 3722699582, 1580150641, 327451799, 2790478837, 3117535592, 0, 3253595436, 1075847264, 3825007647, 2041688520, 3059440621, 3563743934, 2378943302, 1740553945, 1916352843, 2487896798, 2555137236, 2958579944, 2244988746, 3151024235, 3320835882, 1336584933, 3992714006, 2252555205, 2588757463, 1714631509, 293963156, 2319795663, 3925473552, 67240454, 4269768577, 2689618160, 2017213508, 631218106, 1269344483, 2723238387, 1571005438, 2151694528, 93294474, 1066570413, 563977660, 1882732616, 4059428100, 1673313503, 2008463041, 2950355573, 1109467491, 537923632, 3858759450, 4260623118, 3218264685, 2177748300, 403442708, 638784309, 3287084079, 3193921505, 899127202, 2286175436, 773265209, 2479146071, 1437050866, 4236148354, 2050833735, 3362022572, 3126681063, 840505643, 3866325909, 3227541664, 427917720, 2655997905, 2749160575, 1143087718, 1412049534, 999329963, 193497219, 2353415882, 3354324521, 1807268051, 672404540, 2816401017, 3160301282, 369822493, 2916866934, 3688947771, 1681011286, 1949973070, 336202270, 2454276571, 201721354, 1210328172, 3093060836, 2680341085, 3184776046, 1135389935, 3294782118, 965841320, 831886756, 3554993207, 4068047243, 3588745010, 2345191491, 1849112409, 3664604599, 26054028, 2983581028, 2622377682, 1235855840, 3630984372, 2891339514, 4092916743, 3488279077, 3395642799, 4101667470, 1202630377, 268961816, 1874508501, 4034427016, 1243948399, 1546530418, 941366308, 1470539505, 1941222599, 2546386513, 3421038627, 2715671932, 3899946140, 1042226977, 2521517021, 1639824860, 227249030, 260737669, 3765465232, 2084453954, 1907733956, 3429263018, 2420656344, 100860677, 4160157185, 470683154, 3261161891, 1781871967, 2924959737, 1773779408, 394692241, 2579611992, 974986535, 664706745, 3655459128, 3958962195, 731420851, 571543859, 3530123707, 2849626480, 126783113, 865375399, 765172662, 1008606754, 361203602, 3387549984, 2278477385, 2857719295, 1344809080, 2782912378, 59542671, 1503764984, 160008576, 437062935, 1707065306, 3622233649, 2218934982, 3496503480, 2185314755, 697932208, 1512910199, 504303377, 2075177163, 2824099068, 1841019862, 739644986], T2 = [2781242211, 2230877308, 2582542199, 2381740923, 234877682, 3184946027, 2984144751, 1418839493, 1348481072, 50462977, 2848876391, 2102799147, 434634494, 1656084439, 3863849899, 2599188086, 1167051466, 2636087938, 1082771913, 2281340285, 368048890, 3954334041, 3381544775, 201060592, 3963727277, 1739838676, 4250903202, 3930435503, 3206782108, 4149453988, 2531553906, 1536934080, 3262494647, 484572669, 2923271059, 1783375398, 1517041206, 1098792767, 49674231, 1334037708, 1550332980, 4098991525, 886171109, 150598129, 2481090929, 1940642008, 1398944049, 1059722517, 201851908, 1385547719, 1699095331, 1587397571, 674240536, 2704774806, 252314885, 3039795866, 151914247, 908333586, 2602270848, 1038082786, 651029483, 1766729511, 3447698098, 2682942837, 454166793, 2652734339, 1951935532, 775166490, 758520603, 3000790638, 4004797018, 4217086112, 4137964114, 1299594043, 1639438038, 3464344499, 2068982057, 1054729187, 1901997871, 2534638724, 4121318227, 1757008337, 0, 750906861, 1614815264, 535035132, 3363418545, 3988151131, 3201591914, 1183697867, 3647454910, 1265776953, 3734260298, 3566750796, 3903871064, 1250283471, 1807470800, 717615087, 3847203498, 384695291, 3313910595, 3617213773, 1432761139, 2484176261, 3481945413, 283769337, 100925954, 2180939647, 4037038160, 1148730428, 3123027871, 3813386408, 4087501137, 4267549603, 3229630528, 2315620239, 2906624658, 3156319645, 1215313976, 82966005, 3747855548, 3245848246, 1974459098, 1665278241, 807407632, 451280895, 251524083, 1841287890, 1283575245, 337120268, 891687699, 801369324, 3787349855, 2721421207, 3431482436, 959321879, 1469301956, 4065699751, 2197585534, 1199193405, 2898814052, 3887750493, 724703513, 2514908019, 2696962144, 2551808385, 3516813135, 2141445340, 1715741218, 2119445034, 2872807568, 2198571144, 3398190662, 700968686, 3547052216, 1009259540, 2041044702, 3803995742, 487983883, 1991105499, 1004265696, 1449407026, 1316239930, 504629770, 3683797321, 168560134, 1816667172, 3837287516, 1570751170, 1857934291, 4014189740, 2797888098, 2822345105, 2754712981, 936633572, 2347923833, 852879335, 1133234376, 1500395319, 3084545389, 2348912013, 1689376213, 3533459022, 3762923945, 3034082412, 4205598294, 133428468, 634383082, 2949277029, 2398386810, 3913789102, 403703816, 3580869306, 2297460856, 1867130149, 1918643758, 607656988, 4049053350, 3346248884, 1368901318, 600565992, 2090982877, 2632479860, 557719327, 3717614411, 3697393085, 2249034635, 2232388234, 2430627952, 1115438654, 3295786421, 2865522278, 3633334344, 84280067, 33027830, 303828494, 2747425121, 1600795957, 4188952407, 3496589753, 2434238086, 1486471617, 658119965, 3106381470, 953803233, 334231800, 3005978776, 857870609, 3151128937, 1890179545, 2298973838, 2805175444, 3056442267, 574365214, 2450884487, 550103529, 1233637070, 4289353045, 2018519080, 2057691103, 2399374476, 4166623649, 2148108681, 387583245, 3664101311, 836232934, 3330556482, 3100665960, 3280093505, 2955516313, 2002398509, 287182607, 3413881008, 4238890068, 3597515707, 975967766], T3 = [1671808611, 2089089148, 2006576759, 2072901243, 4061003762, 1807603307, 1873927791, 3310653893, 810573872, 16974337, 1739181671, 729634347, 4263110654, 3613570519, 2883997099, 1989864566, 3393556426, 2191335298, 3376449993, 2106063485, 4195741690, 1508618841, 1204391495, 4027317232, 2917941677, 3563566036, 2734514082, 2951366063, 2629772188, 2767672228, 1922491506, 3227229120, 3082974647, 4246528509, 2477669779, 644500518, 911895606, 1061256767, 4144166391, 3427763148, 878471220, 2784252325, 3845444069, 4043897329, 1905517169, 3631459288, 827548209, 356461077, 67897348, 3344078279, 593839651, 3277757891, 405286936, 2527147926, 84871685, 2595565466, 118033927, 305538066, 2157648768, 3795705826, 3945188843, 661212711, 2999812018, 1973414517, 152769033, 2208177539, 745822252, 439235610, 455947803, 1857215598, 1525593178, 2700827552, 1391895634, 994932283, 3596728278, 3016654259, 695947817, 3812548067, 795958831, 2224493444, 1408607827, 3513301457, 0, 3979133421, 543178784, 4229948412, 2982705585, 1542305371, 1790891114, 3410398667, 3201918910, 961245753, 1256100938, 1289001036, 1491644504, 3477767631, 3496721360, 4012557807, 2867154858, 4212583931, 1137018435, 1305975373, 861234739, 2241073541, 1171229253, 4178635257, 33948674, 2139225727, 1357946960, 1011120188, 2679776671, 2833468328, 1374921297, 2751356323, 1086357568, 2408187279, 2460827538, 2646352285, 944271416, 4110742005, 3168756668, 3066132406, 3665145818, 560153121, 271589392, 4279952895, 4077846003, 3530407890, 3444343245, 202643468, 322250259, 3962553324, 1608629855, 2543990167, 1154254916, 389623319, 3294073796, 2817676711, 2122513534, 1028094525, 1689045092, 1575467613, 422261273, 1939203699, 1621147744, 2174228865, 1339137615, 3699352540, 577127458, 712922154, 2427141008, 2290289544, 1187679302, 3995715566, 3100863416, 339486740, 3732514782, 1591917662, 186455563, 3681988059, 3762019296, 844522546, 978220090, 169743370, 1239126601, 101321734, 611076132, 1558493276, 3260915650, 3547250131, 2901361580, 1655096418, 2443721105, 2510565781, 3828863972, 2039214713, 3878868455, 3359869896, 928607799, 1840765549, 2374762893, 3580146133, 1322425422, 2850048425, 1823791212, 1459268694, 4094161908, 3928346602, 1706019429, 2056189050, 2934523822, 135794696, 3134549946, 2022240376, 628050469, 779246638, 472135708, 2800834470, 3032970164, 3327236038, 3894660072, 3715932637, 1956440180, 522272287, 1272813131, 3185336765, 2340818315, 2323976074, 1888542832, 1044544574, 3049550261, 1722469478, 1222152264, 50660867, 4127324150, 236067854, 1638122081, 895445557, 1475980887, 3117443513, 2257655686, 3243809217, 489110045, 2662934430, 3778599393, 4162055160, 2561878936, 288563729, 1773916777, 3648039385, 2391345038, 2493985684, 2612407707, 505560094, 2274497927, 3911240169, 3460925390, 1442818645, 678973480, 3749357023, 2358182796, 2717407649, 2306869641, 219617805, 3218761151, 3862026214, 1120306242, 1756942440, 1103331905, 2578459033, 762796589, 252780047, 2966125488, 1425844308, 3151392187, 372911126], T4 = [1667474886, 2088535288, 2004326894, 2071694838, 4075949567, 1802223062, 1869591006, 3318043793, 808472672, 16843522, 1734846926, 724270422, 4278065639, 3621216949, 2880169549, 1987484396, 3402253711, 2189597983, 3385409673, 2105378810, 4210693615, 1499065266, 1195886990, 4042263547, 2913856577, 3570689971, 2728590687, 2947541573, 2627518243, 2762274643, 1920112356, 3233831835, 3082273397, 4261223649, 2475929149, 640051788, 909531756, 1061110142, 4160160501, 3435941763, 875846760, 2779116625, 3857003729, 4059105529, 1903268834, 3638064043, 825316194, 353713962, 67374088, 3351728789, 589522246, 3284360861, 404236336, 2526454071, 84217610, 2593830191, 117901582, 303183396, 2155911963, 3806477791, 3958056653, 656894286, 2998062463, 1970642922, 151591698, 2206440989, 741110872, 437923380, 454765878, 1852748508, 1515908788, 2694904667, 1381168804, 993742198, 3604373943, 3014905469, 690584402, 3823320797, 791638366, 2223281939, 1398011302, 3520161977, 0, 3991743681, 538992704, 4244381667, 2981218425, 1532751286, 1785380564, 3419096717, 3200178535, 960056178, 1246420628, 1280103576, 1482221744, 3486468741, 3503319995, 4025428677, 2863326543, 4227536621, 1128514950, 1296947098, 859002214, 2240123921, 1162203018, 4193849577, 33687044, 2139062782, 1347481760, 1010582648, 2678045221, 2829640523, 1364325282, 2745433693, 1077985408, 2408548869, 2459086143, 2644360225, 943212656, 4126475505, 3166494563, 3065430391, 3671750063, 555836226, 269496352, 4294908645, 4092792573, 3537006015, 3452783745, 202118168, 320025894, 3974901699, 1600119230, 2543297077, 1145359496, 387397934, 3301201811, 2812801621, 2122220284, 1027426170, 1684319432, 1566435258, 421079858, 1936954854, 1616945344, 2172753945, 1330631070, 3705438115, 572679748, 707427924, 2425400123, 2290647819, 1179044492, 4008585671, 3099120491, 336870440, 3739122087, 1583276732, 185277718, 3688593069, 3772791771, 842159716, 976899700, 168435220, 1229577106, 101059084, 606366792, 1549591736, 3267517855, 3553849021, 2897014595, 1650632388, 2442242105, 2509612081, 3840161747, 2038008818, 3890688725, 3368567691, 926374254, 1835907034, 2374863873, 3587531953, 1313788572, 2846482505, 1819063512, 1448540844, 4109633523, 3941213647, 1701162954, 2054852340, 2930698567, 134748176, 3132806511, 2021165296, 623210314, 774795868, 471606328, 2795958615, 3031746419, 3334885783, 3907527627, 3722280097, 1953799400, 522133822, 1263263126, 3183336545, 2341176845, 2324333839, 1886425312, 1044267644, 3048588401, 1718004428, 1212733584, 50529542, 4143317495, 235803164, 1633788866, 892690282, 1465383342, 3115962473, 2256965911, 3250673817, 488449850, 2661202215, 3789633753, 4177007595, 2560144171, 286339874, 1768537042, 3654906025, 2391705863, 2492770099, 2610673197, 505291324, 2273808917, 3924369609, 3469625735, 1431699370, 673740880, 3755965093, 2358021891, 2711746649, 2307489801, 218961690, 3217021541, 3873845719, 1111672452, 1751693520, 1094828930, 2576986153, 757954394, 252645662, 2964376443, 1414855848, 3149649517, 370555436], T5 = [1374988112, 2118214995, 437757123, 975658646, 1001089995, 530400753, 2902087851, 1273168787, 540080725, 2910219766, 2295101073, 4110568485, 1340463100, 3307916247, 641025152, 3043140495, 3736164937, 632953703, 1172967064, 1576976609, 3274667266, 2169303058, 2370213795, 1809054150, 59727847, 361929877, 3211623147, 2505202138, 3569255213, 1484005843, 1239443753, 2395588676, 1975683434, 4102977912, 2572697195, 666464733, 3202437046, 4035489047, 3374361702, 2110667444, 1675577880, 3843699074, 2538681184, 1649639237, 2976151520, 3144396420, 4269907996, 4178062228, 1883793496, 2403728665, 2497604743, 1383856311, 2876494627, 1917518562, 3810496343, 1716890410, 3001755655, 800440835, 2261089178, 3543599269, 807962610, 599762354, 33778362, 3977675356, 2328828971, 2809771154, 4077384432, 1315562145, 1708848333, 101039829, 3509871135, 3299278474, 875451293, 2733856160, 92987698, 2767645557, 193195065, 1080094634, 1584504582, 3178106961, 1042385657, 2531067453, 3711829422, 1306967366, 2438237621, 1908694277, 67556463, 1615861247, 429456164, 3602770327, 2302690252, 1742315127, 2968011453, 126454664, 3877198648, 2043211483, 2709260871, 2084704233, 4169408201, 0, 159417987, 841739592, 504459436, 1817866830, 4245618683, 260388950, 1034867998, 908933415, 168810852, 1750902305, 2606453969, 607530554, 202008497, 2472011535, 3035535058, 463180190, 2160117071, 1641816226, 1517767529, 470948374, 3801332234, 3231722213, 1008918595, 303765277, 235474187, 4069246893, 766945465, 337553864, 1475418501, 2943682380, 4003061179, 2743034109, 4144047775, 1551037884, 1147550661, 1543208500, 2336434550, 3408119516, 3069049960, 3102011747, 3610369226, 1113818384, 328671808, 2227573024, 2236228733, 3535486456, 2935566865, 3341394285, 496906059, 3702665459, 226906860, 2009195472, 733156972, 2842737049, 294930682, 1206477858, 2835123396, 2700099354, 1451044056, 573804783, 2269728455, 3644379585, 2362090238, 2564033334, 2801107407, 2776292904, 3669462566, 1068351396, 742039012, 1350078989, 1784663195, 1417561698, 4136440770, 2430122216, 775550814, 2193862645, 2673705150, 1775276924, 1876241833, 3475313331, 3366754619, 270040487, 3902563182, 3678124923, 3441850377, 1851332852, 3969562369, 2203032232, 3868552805, 2868897406, 566021896, 4011190502, 3135740889, 1248802510, 3936291284, 699432150, 832877231, 708780849, 3332740144, 899835584, 1951317047, 4236429990, 3767586992, 866637845, 4043610186, 1106041591, 2144161806, 395441711, 1984812685, 1139781709, 3433712980, 3835036895, 2664543715, 1282050075, 3240894392, 1181045119, 2640243204, 25965917, 4203181171, 4211818798, 3009879386, 2463879762, 3910161971, 1842759443, 2597806476, 933301370, 1509430414, 3943906441, 3467192302, 3076639029, 3776767469, 2051518780, 2631065433, 1441952575, 404016761, 1942435775, 1408749034, 1610459739, 3745345300, 2017778566, 3400528769, 3110650942, 941896748, 3265478751, 371049330, 3168937228, 675039627, 4279080257, 967311729, 135050206, 3635733660, 1683407248, 2076935265, 3576870512, 1215061108, 3501741890], T6 = [1347548327, 1400783205, 3273267108, 2520393566, 3409685355, 4045380933, 2880240216, 2471224067, 1428173050, 4138563181, 2441661558, 636813900, 4233094615, 3620022987, 2149987652, 2411029155, 1239331162, 1730525723, 2554718734, 3781033664, 46346101, 310463728, 2743944855, 3328955385, 3875770207, 2501218972, 3955191162, 3667219033, 768917123, 3545789473, 692707433, 1150208456, 1786102409, 2029293177, 1805211710, 3710368113, 3065962831, 401639597, 1724457132, 3028143674, 409198410, 2196052529, 1620529459, 1164071807, 3769721975, 2226875310, 486441376, 2499348523, 1483753576, 428819965, 2274680428, 3075636216, 598438867, 3799141122, 1474502543, 711349675, 129166120, 53458370, 2592523643, 2782082824, 4063242375, 2988687269, 3120694122, 1559041666, 730517276, 2460449204, 4042459122, 2706270690, 3446004468, 3573941694, 533804130, 2328143614, 2637442643, 2695033685, 839224033, 1973745387, 957055980, 2856345839, 106852767, 1371368976, 4181598602, 1033297158, 2933734917, 1179510461, 3046200461, 91341917, 1862534868, 4284502037, 605657339, 2547432937, 3431546947, 2003294622, 3182487618, 2282195339, 954669403, 3682191598, 1201765386, 3917234703, 3388507166, 0, 2198438022, 1211247597, 2887651696, 1315723890, 4227665663, 1443857720, 507358933, 657861945, 1678381017, 560487590, 3516619604, 975451694, 2970356327, 261314535, 3535072918, 2652609425, 1333838021, 2724322336, 1767536459, 370938394, 182621114, 3854606378, 1128014560, 487725847, 185469197, 2918353863, 3106780840, 3356761769, 2237133081, 1286567175, 3152976349, 4255350624, 2683765030, 3160175349, 3309594171, 878443390, 1988838185, 3704300486, 1756818940, 1673061617, 3403100636, 272786309, 1075025698, 545572369, 2105887268, 4174560061, 296679730, 1841768865, 1260232239, 4091327024, 3960309330, 3497509347, 1814803222, 2578018489, 4195456072, 575138148, 3299409036, 446754879, 3629546796, 4011996048, 3347532110, 3252238545, 4270639778, 915985419, 3483825537, 681933534, 651868046, 2755636671, 3828103837, 223377554, 2607439820, 1649704518, 3270937875, 3901806776, 1580087799, 4118987695, 3198115200, 2087309459, 2842678573, 3016697106, 1003007129, 2802849917, 1860738147, 2077965243, 164439672, 4100872472, 32283319, 2827177882, 1709610350, 2125135846, 136428751, 3874428392, 3652904859, 3460984630, 3572145929, 3593056380, 2939266226, 824852259, 818324884, 3224740454, 930369212, 2801566410, 2967507152, 355706840, 1257309336, 4148292826, 243256656, 790073846, 2373340630, 1296297904, 1422699085, 3756299780, 3818836405, 457992840, 3099667487, 2135319889, 77422314, 1560382517, 1945798516, 788204353, 1521706781, 1385356242, 870912086, 325965383, 2358957921, 2050466060, 2388260884, 2313884476, 4006521127, 901210569, 3990953189, 1014646705, 1503449823, 1062597235, 2031621326, 3212035895, 3931371469, 1533017514, 350174575, 2256028891, 2177544179, 1052338372, 741876788, 1606591296, 1914052035, 213705253, 2334669897, 1107234197, 1899603969, 3725069491, 2631447780, 2422494913, 1635502980, 1893020342, 1950903388, 1120974935], T7 = [2807058932, 1699970625, 2764249623, 1586903591, 1808481195, 1173430173, 1487645946, 59984867, 4199882800, 1844882806, 1989249228, 1277555970, 3623636965, 3419915562, 1149249077, 2744104290, 1514790577, 459744698, 244860394, 3235995134, 1963115311, 4027744588, 2544078150, 4190530515, 1608975247, 2627016082, 2062270317, 1507497298, 2200818878, 567498868, 1764313568, 3359936201, 2305455554, 2037970062, 1047239e3, 1910319033, 1337376481, 2904027272, 2892417312, 984907214, 1243112415, 830661914, 861968209, 2135253587, 2011214180, 2927934315, 2686254721, 731183368, 1750626376, 4246310725, 1820824798, 4172763771, 3542330227, 48394827, 2404901663, 2871682645, 671593195, 3254988725, 2073724613, 145085239, 2280796200, 2779915199, 1790575107, 2187128086, 472615631, 3029510009, 4075877127, 3802222185, 4107101658, 3201631749, 1646252340, 4270507174, 1402811438, 1436590835, 3778151818, 3950355702, 3963161475, 4020912224, 2667994737, 273792366, 2331590177, 104699613, 95345982, 3175501286, 2377486676, 1560637892, 3564045318, 369057872, 4213447064, 3919042237, 1137477952, 2658625497, 1119727848, 2340947849, 1530455833, 4007360968, 172466556, 266959938, 516552836, 0, 2256734592, 3980931627, 1890328081, 1917742170, 4294704398, 945164165, 3575528878, 958871085, 3647212047, 2787207260, 1423022939, 775562294, 1739656202, 3876557655, 2530391278, 2443058075, 3310321856, 547512796, 1265195639, 437656594, 3121275539, 719700128, 3762502690, 387781147, 218828297, 3350065803, 2830708150, 2848461854, 428169201, 122466165, 3720081049, 1627235199, 648017665, 4122762354, 1002783846, 2117360635, 695634755, 3336358691, 4234721005, 4049844452, 3704280881, 2232435299, 574624663, 287343814, 612205898, 1039717051, 840019705, 2708326185, 793451934, 821288114, 1391201670, 3822090177, 376187827, 3113855344, 1224348052, 1679968233, 2361698556, 1058709744, 752375421, 2431590963, 1321699145, 3519142200, 2734591178, 188127444, 2177869557, 3727205754, 2384911031, 3215212461, 2648976442, 2450346104, 3432737375, 1180849278, 331544205, 3102249176, 4150144569, 2952102595, 2159976285, 2474404304, 766078933, 313773861, 2570832044, 2108100632, 1668212892, 3145456443, 2013908262, 418672217, 3070356634, 2594734927, 1852171925, 3867060991, 3473416636, 3907448597, 2614737639, 919489135, 164948639, 2094410160, 2997825956, 590424639, 2486224549, 1723872674, 3157750862, 3399941250, 3501252752, 3625268135, 2555048196, 3673637356, 1343127501, 4130281361, 3599595085, 2957853679, 1297403050, 81781910, 3051593425, 2283490410, 532201772, 1367295589, 3926170974, 895287692, 1953757831, 1093597963, 492483431, 3528626907, 1446242576, 1192455638, 1636604631, 209336225, 344873464, 1015671571, 669961897, 3375740769, 3857572124, 2973530695, 3747192018, 1933530610, 3464042516, 935293895, 3454686199, 2858115069, 1863638845, 3683022916, 4085369519, 3292445032, 875313188, 1080017571, 3279033885, 621591778, 1233856572, 2504130317, 24197544, 3017672716, 3835484340, 3247465558, 2220981195, 3060847922, 1551124588, 1463996600], T8 = [4104605777, 1097159550, 396673818, 660510266, 2875968315, 2638606623, 4200115116, 3808662347, 821712160, 1986918061, 3430322568, 38544885, 3856137295, 718002117, 893681702, 1654886325, 2975484382, 3122358053, 3926825029, 4274053469, 796197571, 1290801793, 1184342925, 3556361835, 2405426947, 2459735317, 1836772287, 1381620373, 3196267988, 1948373848, 3764988233, 3385345166, 3263785589, 2390325492, 1480485785, 3111247143, 3780097726, 2293045232, 548169417, 3459953789, 3746175075, 439452389, 1362321559, 1400849762, 1685577905, 1806599355, 2174754046, 137073913, 1214797936, 1174215055, 3731654548, 2079897426, 1943217067, 1258480242, 529487843, 1437280870, 3945269170, 3049390895, 3313212038, 923313619, 679998e3, 3215307299, 57326082, 377642221, 3474729866, 2041877159, 133361907, 1776460110, 3673476453, 96392454, 878845905, 2801699524, 777231668, 4082475170, 2330014213, 4142626212, 2213296395, 1626319424, 1906247262, 1846563261, 562755902, 3708173718, 1040559837, 3871163981, 1418573201, 3294430577, 114585348, 1343618912, 2566595609, 3186202582, 1078185097, 3651041127, 3896688048, 2307622919, 425408743, 3371096953, 2081048481, 1108339068, 2216610296, 0, 2156299017, 736970802, 292596766, 1517440620, 251657213, 2235061775, 2933202493, 758720310, 265905162, 1554391400, 1532285339, 908999204, 174567692, 1474760595, 4002861748, 2610011675, 3234156416, 3693126241, 2001430874, 303699484, 2478443234, 2687165888, 585122620, 454499602, 151849742, 2345119218, 3064510765, 514443284, 4044981591, 1963412655, 2581445614, 2137062819, 19308535, 1928707164, 1715193156, 4219352155, 1126790795, 600235211, 3992742070, 3841024952, 836553431, 1669664834, 2535604243, 3323011204, 1243905413, 3141400786, 4180808110, 698445255, 2653899549, 2989552604, 2253581325, 3252932727, 3004591147, 1891211689, 2487810577, 3915653703, 4237083816, 4030667424, 2100090966, 865136418, 1229899655, 953270745, 3399679628, 3557504664, 4118925222, 2061379749, 3079546586, 2915017791, 983426092, 2022837584, 1607244650, 2118541908, 2366882550, 3635996816, 972512814, 3283088770, 1568718495, 3499326569, 3576539503, 621982671, 2895723464, 410887952, 2623762152, 1002142683, 645401037, 1494807662, 2595684844, 1335535747, 2507040230, 4293295786, 3167684641, 367585007, 3885750714, 1865862730, 2668221674, 2960971305, 2763173681, 1059270954, 2777952454, 2724642869, 1320957812, 2194319100, 2429595872, 2815956275, 77089521, 3973773121, 3444575871, 2448830231, 1305906550, 4021308739, 2857194700, 2516901860, 3518358430, 1787304780, 740276417, 1699839814, 1592394909, 2352307457, 2272556026, 188821243, 1729977011, 3687994002, 274084841, 3594982253, 3613494426, 2701949495, 4162096729, 322734571, 2837966542, 1640576439, 484830689, 1202797690, 3537852828, 4067639125, 349075736, 3342319475, 4157467219, 4255800159, 1030690015, 1155237496, 2951971274, 1757691577, 607398968, 2738905026, 499347990, 3794078908, 1011452712, 227885567, 2818666809, 213114376, 3034881240, 1455525988, 3414450555, 850817237, 1817998408, 3092726480], U1 = [0, 235474187, 470948374, 303765277, 941896748, 908933415, 607530554, 708780849, 1883793496, 2118214995, 1817866830, 1649639237, 1215061108, 1181045119, 1417561698, 1517767529, 3767586992, 4003061179, 4236429990, 4069246893, 3635733660, 3602770327, 3299278474, 3400528769, 2430122216, 2664543715, 2362090238, 2193862645, 2835123396, 2801107407, 3035535058, 3135740889, 3678124923, 3576870512, 3341394285, 3374361702, 3810496343, 3977675356, 4279080257, 4043610186, 2876494627, 2776292904, 3076639029, 3110650942, 2472011535, 2640243204, 2403728665, 2169303058, 1001089995, 899835584, 666464733, 699432150, 59727847, 226906860, 530400753, 294930682, 1273168787, 1172967064, 1475418501, 1509430414, 1942435775, 2110667444, 1876241833, 1641816226, 2910219766, 2743034109, 2976151520, 3211623147, 2505202138, 2606453969, 2302690252, 2269728455, 3711829422, 3543599269, 3240894392, 3475313331, 3843699074, 3943906441, 4178062228, 4144047775, 1306967366, 1139781709, 1374988112, 1610459739, 1975683434, 2076935265, 1775276924, 1742315127, 1034867998, 866637845, 566021896, 800440835, 92987698, 193195065, 429456164, 395441711, 1984812685, 2017778566, 1784663195, 1683407248, 1315562145, 1080094634, 1383856311, 1551037884, 101039829, 135050206, 437757123, 337553864, 1042385657, 807962610, 573804783, 742039012, 2531067453, 2564033334, 2328828971, 2227573024, 2935566865, 2700099354, 3001755655, 3168937228, 3868552805, 3902563182, 4203181171, 4102977912, 3736164937, 3501741890, 3265478751, 3433712980, 1106041591, 1340463100, 1576976609, 1408749034, 2043211483, 2009195472, 1708848333, 1809054150, 832877231, 1068351396, 766945465, 599762354, 159417987, 126454664, 361929877, 463180190, 2709260871, 2943682380, 3178106961, 3009879386, 2572697195, 2538681184, 2236228733, 2336434550, 3509871135, 3745345300, 3441850377, 3274667266, 3910161971, 3877198648, 4110568485, 4211818798, 2597806476, 2497604743, 2261089178, 2295101073, 2733856160, 2902087851, 3202437046, 2968011453, 3936291284, 3835036895, 4136440770, 4169408201, 3535486456, 3702665459, 3467192302, 3231722213, 2051518780, 1951317047, 1716890410, 1750902305, 1113818384, 1282050075, 1584504582, 1350078989, 168810852, 67556463, 371049330, 404016761, 841739592, 1008918595, 775550814, 540080725, 3969562369, 3801332234, 4035489047, 4269907996, 3569255213, 3669462566, 3366754619, 3332740144, 2631065433, 2463879762, 2160117071, 2395588676, 2767645557, 2868897406, 3102011747, 3069049960, 202008497, 33778362, 270040487, 504459436, 875451293, 975658646, 675039627, 641025152, 2084704233, 1917518562, 1615861247, 1851332852, 1147550661, 1248802510, 1484005843, 1451044056, 933301370, 967311729, 733156972, 632953703, 260388950, 25965917, 328671808, 496906059, 1206477858, 1239443753, 1543208500, 1441952575, 2144161806, 1908694277, 1675577880, 1842759443, 3610369226, 3644379585, 3408119516, 3307916247, 4011190502, 3776767469, 4077384432, 4245618683, 2809771154, 2842737049, 3144396420, 3043140495, 2673705150, 2438237621, 2203032232, 2370213795], U2 = [0, 185469197, 370938394, 487725847, 741876788, 657861945, 975451694, 824852259, 1483753576, 1400783205, 1315723890, 1164071807, 1950903388, 2135319889, 1649704518, 1767536459, 2967507152, 3152976349, 2801566410, 2918353863, 2631447780, 2547432937, 2328143614, 2177544179, 3901806776, 3818836405, 4270639778, 4118987695, 3299409036, 3483825537, 3535072918, 3652904859, 2077965243, 1893020342, 1841768865, 1724457132, 1474502543, 1559041666, 1107234197, 1257309336, 598438867, 681933534, 901210569, 1052338372, 261314535, 77422314, 428819965, 310463728, 3409685355, 3224740454, 3710368113, 3593056380, 3875770207, 3960309330, 4045380933, 4195456072, 2471224067, 2554718734, 2237133081, 2388260884, 3212035895, 3028143674, 2842678573, 2724322336, 4138563181, 4255350624, 3769721975, 3955191162, 3667219033, 3516619604, 3431546947, 3347532110, 2933734917, 2782082824, 3099667487, 3016697106, 2196052529, 2313884476, 2499348523, 2683765030, 1179510461, 1296297904, 1347548327, 1533017514, 1786102409, 1635502980, 2087309459, 2003294622, 507358933, 355706840, 136428751, 53458370, 839224033, 957055980, 605657339, 790073846, 2373340630, 2256028891, 2607439820, 2422494913, 2706270690, 2856345839, 3075636216, 3160175349, 3573941694, 3725069491, 3273267108, 3356761769, 4181598602, 4063242375, 4011996048, 3828103837, 1033297158, 915985419, 730517276, 545572369, 296679730, 446754879, 129166120, 213705253, 1709610350, 1860738147, 1945798516, 2029293177, 1239331162, 1120974935, 1606591296, 1422699085, 4148292826, 4233094615, 3781033664, 3931371469, 3682191598, 3497509347, 3446004468, 3328955385, 2939266226, 2755636671, 3106780840, 2988687269, 2198438022, 2282195339, 2501218972, 2652609425, 1201765386, 1286567175, 1371368976, 1521706781, 1805211710, 1620529459, 2105887268, 1988838185, 533804130, 350174575, 164439672, 46346101, 870912086, 954669403, 636813900, 788204353, 2358957921, 2274680428, 2592523643, 2441661558, 2695033685, 2880240216, 3065962831, 3182487618, 3572145929, 3756299780, 3270937875, 3388507166, 4174560061, 4091327024, 4006521127, 3854606378, 1014646705, 930369212, 711349675, 560487590, 272786309, 457992840, 106852767, 223377554, 1678381017, 1862534868, 1914052035, 2031621326, 1211247597, 1128014560, 1580087799, 1428173050, 32283319, 182621114, 401639597, 486441376, 768917123, 651868046, 1003007129, 818324884, 1503449823, 1385356242, 1333838021, 1150208456, 1973745387, 2125135846, 1673061617, 1756818940, 2970356327, 3120694122, 2802849917, 2887651696, 2637442643, 2520393566, 2334669897, 2149987652, 3917234703, 3799141122, 4284502037, 4100872472, 3309594171, 3460984630, 3545789473, 3629546796, 2050466060, 1899603969, 1814803222, 1730525723, 1443857720, 1560382517, 1075025698, 1260232239, 575138148, 692707433, 878443390, 1062597235, 243256656, 91341917, 409198410, 325965383, 3403100636, 3252238545, 3704300486, 3620022987, 3874428392, 3990953189, 4042459122, 4227665663, 2460449204, 2578018489, 2226875310, 2411029155, 3198115200, 3046200461, 2827177882, 2743944855], U3 = [0, 218828297, 437656594, 387781147, 875313188, 958871085, 775562294, 590424639, 1750626376, 1699970625, 1917742170, 2135253587, 1551124588, 1367295589, 1180849278, 1265195639, 3501252752, 3720081049, 3399941250, 3350065803, 3835484340, 3919042237, 4270507174, 4085369519, 3102249176, 3051593425, 2734591178, 2952102595, 2361698556, 2177869557, 2530391278, 2614737639, 3145456443, 3060847922, 2708326185, 2892417312, 2404901663, 2187128086, 2504130317, 2555048196, 3542330227, 3727205754, 3375740769, 3292445032, 3876557655, 3926170974, 4246310725, 4027744588, 1808481195, 1723872674, 1910319033, 2094410160, 1608975247, 1391201670, 1173430173, 1224348052, 59984867, 244860394, 428169201, 344873464, 935293895, 984907214, 766078933, 547512796, 1844882806, 1627235199, 2011214180, 2062270317, 1507497298, 1423022939, 1137477952, 1321699145, 95345982, 145085239, 532201772, 313773861, 830661914, 1015671571, 731183368, 648017665, 3175501286, 2957853679, 2807058932, 2858115069, 2305455554, 2220981195, 2474404304, 2658625497, 3575528878, 3625268135, 3473416636, 3254988725, 3778151818, 3963161475, 4213447064, 4130281361, 3599595085, 3683022916, 3432737375, 3247465558, 3802222185, 4020912224, 4172763771, 4122762354, 3201631749, 3017672716, 2764249623, 2848461854, 2331590177, 2280796200, 2431590963, 2648976442, 104699613, 188127444, 472615631, 287343814, 840019705, 1058709744, 671593195, 621591778, 1852171925, 1668212892, 1953757831, 2037970062, 1514790577, 1463996600, 1080017571, 1297403050, 3673637356, 3623636965, 3235995134, 3454686199, 4007360968, 3822090177, 4107101658, 4190530515, 2997825956, 3215212461, 2830708150, 2779915199, 2256734592, 2340947849, 2627016082, 2443058075, 172466556, 122466165, 273792366, 492483431, 1047239e3, 861968209, 612205898, 695634755, 1646252340, 1863638845, 2013908262, 1963115311, 1446242576, 1530455833, 1277555970, 1093597963, 1636604631, 1820824798, 2073724613, 1989249228, 1436590835, 1487645946, 1337376481, 1119727848, 164948639, 81781910, 331544205, 516552836, 1039717051, 821288114, 669961897, 719700128, 2973530695, 3157750862, 2871682645, 2787207260, 2232435299, 2283490410, 2667994737, 2450346104, 3647212047, 3564045318, 3279033885, 3464042516, 3980931627, 3762502690, 4150144569, 4199882800, 3070356634, 3121275539, 2904027272, 2686254721, 2200818878, 2384911031, 2570832044, 2486224549, 3747192018, 3528626907, 3310321856, 3359936201, 3950355702, 3867060991, 4049844452, 4234721005, 1739656202, 1790575107, 2108100632, 1890328081, 1402811438, 1586903591, 1233856572, 1149249077, 266959938, 48394827, 369057872, 418672217, 1002783846, 919489135, 567498868, 752375421, 209336225, 24197544, 376187827, 459744698, 945164165, 895287692, 574624663, 793451934, 1679968233, 1764313568, 2117360635, 1933530610, 1343127501, 1560637892, 1243112415, 1192455638, 3704280881, 3519142200, 3336358691, 3419915562, 3907448597, 3857572124, 4075877127, 4294704398, 3029510009, 3113855344, 2927934315, 2744104290, 2159976285, 2377486676, 2594734927, 2544078150], U4 = [0, 151849742, 303699484, 454499602, 607398968, 758720310, 908999204, 1059270954, 1214797936, 1097159550, 1517440620, 1400849762, 1817998408, 1699839814, 2118541908, 2001430874, 2429595872, 2581445614, 2194319100, 2345119218, 3034881240, 3186202582, 2801699524, 2951971274, 3635996816, 3518358430, 3399679628, 3283088770, 4237083816, 4118925222, 4002861748, 3885750714, 1002142683, 850817237, 698445255, 548169417, 529487843, 377642221, 227885567, 77089521, 1943217067, 2061379749, 1640576439, 1757691577, 1474760595, 1592394909, 1174215055, 1290801793, 2875968315, 2724642869, 3111247143, 2960971305, 2405426947, 2253581325, 2638606623, 2487810577, 3808662347, 3926825029, 4044981591, 4162096729, 3342319475, 3459953789, 3576539503, 3693126241, 1986918061, 2137062819, 1685577905, 1836772287, 1381620373, 1532285339, 1078185097, 1229899655, 1040559837, 923313619, 740276417, 621982671, 439452389, 322734571, 137073913, 19308535, 3871163981, 4021308739, 4104605777, 4255800159, 3263785589, 3414450555, 3499326569, 3651041127, 2933202493, 2815956275, 3167684641, 3049390895, 2330014213, 2213296395, 2566595609, 2448830231, 1305906550, 1155237496, 1607244650, 1455525988, 1776460110, 1626319424, 2079897426, 1928707164, 96392454, 213114376, 396673818, 514443284, 562755902, 679998e3, 865136418, 983426092, 3708173718, 3557504664, 3474729866, 3323011204, 4180808110, 4030667424, 3945269170, 3794078908, 2507040230, 2623762152, 2272556026, 2390325492, 2975484382, 3092726480, 2738905026, 2857194700, 3973773121, 3856137295, 4274053469, 4157467219, 3371096953, 3252932727, 3673476453, 3556361835, 2763173681, 2915017791, 3064510765, 3215307299, 2156299017, 2307622919, 2459735317, 2610011675, 2081048481, 1963412655, 1846563261, 1729977011, 1480485785, 1362321559, 1243905413, 1126790795, 878845905, 1030690015, 645401037, 796197571, 274084841, 425408743, 38544885, 188821243, 3613494426, 3731654548, 3313212038, 3430322568, 4082475170, 4200115116, 3780097726, 3896688048, 2668221674, 2516901860, 2366882550, 2216610296, 3141400786, 2989552604, 2837966542, 2687165888, 1202797690, 1320957812, 1437280870, 1554391400, 1669664834, 1787304780, 1906247262, 2022837584, 265905162, 114585348, 499347990, 349075736, 736970802, 585122620, 972512814, 821712160, 2595684844, 2478443234, 2293045232, 2174754046, 3196267988, 3079546586, 2895723464, 2777952454, 3537852828, 3687994002, 3234156416, 3385345166, 4142626212, 4293295786, 3841024952, 3992742070, 174567692, 57326082, 410887952, 292596766, 777231668, 660510266, 1011452712, 893681702, 1108339068, 1258480242, 1343618912, 1494807662, 1715193156, 1865862730, 1948373848, 2100090966, 2701949495, 2818666809, 3004591147, 3122358053, 2235061775, 2352307457, 2535604243, 2653899549, 3915653703, 3764988233, 4219352155, 4067639125, 3444575871, 3294430577, 3746175075, 3594982253, 836553431, 953270745, 600235211, 718002117, 367585007, 484830689, 133361907, 251657213, 2041877159, 1891211689, 1806599355, 1654886325, 1568718495, 1418573201, 1335535747, 1184342925];
function convertToInt32(C) {
  const e = [];
  for (let T = 0; T < C.length; T += 4)
    e.push(C[T] << 24 | C[T + 1] << 16 | C[T + 2] << 8 | C[T + 3]);
  return e;
}
class AES {
  get key() {
    return __classPrivateFieldGet$2(this, _AES_key, "f").slice();
  }
  constructor(e) {
    if (_AES_key.set(this, void 0), _AES_Kd.set(this, void 0), _AES_Ke.set(this, void 0), !(this instanceof AES))
      throw Error("AES must be instanitated with `new`");
    __classPrivateFieldSet$2(this, _AES_key, new Uint8Array(e), "f");
    const T = numberOfRounds[this.key.length];
    if (T == null)
      throw new TypeError("invalid key size (must be 16, 24 or 32 bytes)");
    __classPrivateFieldSet$2(this, _AES_Ke, [], "f"), __classPrivateFieldSet$2(this, _AES_Kd, [], "f");
    for (let se = 0; se <= T; se++)
      __classPrivateFieldGet$2(this, _AES_Ke, "f").push([0, 0, 0, 0]), __classPrivateFieldGet$2(this, _AES_Kd, "f").push([0, 0, 0, 0]);
    const $ = (T + 1) * 4, V = this.key.length / 4, J = convertToInt32(this.key);
    let ee;
    for (let se = 0; se < V; se++)
      ee = se >> 2, __classPrivateFieldGet$2(this, _AES_Ke, "f")[ee][se % 4] = J[se], __classPrivateFieldGet$2(this, _AES_Kd, "f")[T - ee][se % 4] = J[se];
    let te = 0, re = V, ie;
    for (; re < $; ) {
      if (ie = J[V - 1], J[0] ^= S[ie >> 16 & 255] << 24 ^ S[ie >> 8 & 255] << 16 ^ S[ie & 255] << 8 ^ S[ie >> 24 & 255] ^ rcon[te] << 24, te += 1, V != 8)
        for (let fe = 1; fe < V; fe++)
          J[fe] ^= J[fe - 1];
      else {
        for (let fe = 1; fe < V / 2; fe++)
          J[fe] ^= J[fe - 1];
        ie = J[V / 2 - 1], J[V / 2] ^= S[ie & 255] ^ S[ie >> 8 & 255] << 8 ^ S[ie >> 16 & 255] << 16 ^ S[ie >> 24 & 255] << 24;
        for (let fe = V / 2 + 1; fe < V; fe++)
          J[fe] ^= J[fe - 1];
      }
      let se = 0, de, ue;
      for (; se < V && re < $; )
        de = re >> 2, ue = re % 4, __classPrivateFieldGet$2(this, _AES_Ke, "f")[de][ue] = J[se], __classPrivateFieldGet$2(this, _AES_Kd, "f")[T - de][ue] = J[se++], re++;
    }
    for (let se = 1; se < T; se++)
      for (let de = 0; de < 4; de++)
        ie = __classPrivateFieldGet$2(this, _AES_Kd, "f")[se][de], __classPrivateFieldGet$2(this, _AES_Kd, "f")[se][de] = U1[ie >> 24 & 255] ^ U2[ie >> 16 & 255] ^ U3[ie >> 8 & 255] ^ U4[ie & 255];
  }
  encrypt(e) {
    if (e.length != 16)
      throw new TypeError("invalid plaintext size (must be 16 bytes)");
    const T = __classPrivateFieldGet$2(this, _AES_Ke, "f").length - 1, $ = [0, 0, 0, 0];
    let V = convertToInt32(e);
    for (let te = 0; te < 4; te++)
      V[te] ^= __classPrivateFieldGet$2(this, _AES_Ke, "f")[0][te];
    for (let te = 1; te < T; te++) {
      for (let re = 0; re < 4; re++)
        $[re] = T1[V[re] >> 24 & 255] ^ T2[V[(re + 1) % 4] >> 16 & 255] ^ T3[V[(re + 2) % 4] >> 8 & 255] ^ T4[V[(re + 3) % 4] & 255] ^ __classPrivateFieldGet$2(this, _AES_Ke, "f")[te][re];
      V = $.slice();
    }
    const J = new Uint8Array(16);
    let ee = 0;
    for (let te = 0; te < 4; te++)
      ee = __classPrivateFieldGet$2(this, _AES_Ke, "f")[T][te], J[4 * te] = (S[V[te] >> 24 & 255] ^ ee >> 24) & 255, J[4 * te + 1] = (S[V[(te + 1) % 4] >> 16 & 255] ^ ee >> 16) & 255, J[4 * te + 2] = (S[V[(te + 2) % 4] >> 8 & 255] ^ ee >> 8) & 255, J[4 * te + 3] = (S[V[(te + 3) % 4] & 255] ^ ee) & 255;
    return J;
  }
  decrypt(e) {
    if (e.length != 16)
      throw new TypeError("invalid ciphertext size (must be 16 bytes)");
    const T = __classPrivateFieldGet$2(this, _AES_Kd, "f").length - 1, $ = [0, 0, 0, 0];
    let V = convertToInt32(e);
    for (let te = 0; te < 4; te++)
      V[te] ^= __classPrivateFieldGet$2(this, _AES_Kd, "f")[0][te];
    for (let te = 1; te < T; te++) {
      for (let re = 0; re < 4; re++)
        $[re] = T5[V[re] >> 24 & 255] ^ T6[V[(re + 3) % 4] >> 16 & 255] ^ T7[V[(re + 2) % 4] >> 8 & 255] ^ T8[V[(re + 1) % 4] & 255] ^ __classPrivateFieldGet$2(this, _AES_Kd, "f")[te][re];
      V = $.slice();
    }
    const J = new Uint8Array(16);
    let ee = 0;
    for (let te = 0; te < 4; te++)
      ee = __classPrivateFieldGet$2(this, _AES_Kd, "f")[T][te], J[4 * te] = (Si[V[te] >> 24 & 255] ^ ee >> 24) & 255, J[4 * te + 1] = (Si[V[(te + 3) % 4] >> 16 & 255] ^ ee >> 16) & 255, J[4 * te + 2] = (Si[V[(te + 2) % 4] >> 8 & 255] ^ ee >> 8) & 255, J[4 * te + 3] = (Si[V[(te + 1) % 4] & 255] ^ ee) & 255;
    return J;
  }
}
_AES_key = /* @__PURE__ */ new WeakMap(), _AES_Kd = /* @__PURE__ */ new WeakMap(), _AES_Ke = /* @__PURE__ */ new WeakMap();
class ModeOfOperation {
  constructor(e, T, $) {
    if ($ && !(this instanceof $))
      throw new Error(`${e} must be instantiated with "new"`);
    Object.defineProperties(this, {
      aes: { enumerable: !0, value: new AES(T) },
      name: { enumerable: !0, value: e }
    });
  }
}
var __classPrivateFieldSet$1 = function(C, e, T, $, V) {
  if ($ === "m") throw new TypeError("Private method is not writable");
  if ($ === "a" && !V) throw new TypeError("Private accessor was defined without a setter");
  if (typeof e == "function" ? C !== e || !V : !e.has(C)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
  return $ === "a" ? V.call(C, T) : V ? V.value = T : e.set(C, T), T;
}, __classPrivateFieldGet$1 = function(C, e, T, $) {
  if (T === "a" && !$) throw new TypeError("Private accessor was defined without a getter");
  if (typeof e == "function" ? C !== e || !$ : !e.has(C)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
  return T === "m" ? $ : T === "a" ? $.call(C) : $ ? $.value : e.get(C);
}, _CBC_iv, _CBC_lastBlock;
class CBC extends ModeOfOperation {
  constructor(e, T) {
    if (super("ECC", e, CBC), _CBC_iv.set(this, void 0), _CBC_lastBlock.set(this, void 0), T) {
      if (T.length % 16)
        throw new TypeError("invalid iv size (must be 16 bytes)");
      __classPrivateFieldSet$1(this, _CBC_iv, new Uint8Array(T), "f");
    } else
      __classPrivateFieldSet$1(this, _CBC_iv, new Uint8Array(16), "f");
    __classPrivateFieldSet$1(this, _CBC_lastBlock, this.iv, "f");
  }
  get iv() {
    return new Uint8Array(__classPrivateFieldGet$1(this, _CBC_iv, "f"));
  }
  encrypt(e) {
    if (e.length % 16)
      throw new TypeError("invalid plaintext size (must be multiple of 16 bytes)");
    const T = new Uint8Array(e.length);
    for (let $ = 0; $ < e.length; $ += 16) {
      for (let V = 0; V < 16; V++)
        __classPrivateFieldGet$1(this, _CBC_lastBlock, "f")[V] ^= e[$ + V];
      __classPrivateFieldSet$1(this, _CBC_lastBlock, this.aes.encrypt(__classPrivateFieldGet$1(this, _CBC_lastBlock, "f")), "f"), T.set(__classPrivateFieldGet$1(this, _CBC_lastBlock, "f"), $);
    }
    return T;
  }
  decrypt(e) {
    if (e.length % 16)
      throw new TypeError("invalid ciphertext size (must be multiple of 16 bytes)");
    const T = new Uint8Array(e.length);
    for (let $ = 0; $ < e.length; $ += 16) {
      const V = this.aes.decrypt(e.subarray($, $ + 16));
      for (let J = 0; J < 16; J++)
        T[$ + J] = V[J] ^ __classPrivateFieldGet$1(this, _CBC_lastBlock, "f")[J], __classPrivateFieldGet$1(this, _CBC_lastBlock, "f")[J] = e[$ + J];
    }
    return T;
  }
}
_CBC_iv = /* @__PURE__ */ new WeakMap(), _CBC_lastBlock = /* @__PURE__ */ new WeakMap();
var __classPrivateFieldSet = function(C, e, T, $, V) {
  if ($ === "m") throw new TypeError("Private method is not writable");
  if ($ === "a" && !V) throw new TypeError("Private accessor was defined without a setter");
  if (typeof e == "function" ? C !== e || !V : !e.has(C)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
  return $ === "a" ? V.call(C, T) : V ? V.value = T : e.set(C, T), T;
}, __classPrivateFieldGet = function(C, e, T, $) {
  if (T === "a" && !$) throw new TypeError("Private accessor was defined without a getter");
  if (typeof e == "function" ? C !== e || !$ : !e.has(C)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
  return T === "m" ? $ : T === "a" ? $.call(C) : $ ? $.value : e.get(C);
}, _CTR_remaining, _CTR_remainingIndex, _CTR_counter;
class CTR extends ModeOfOperation {
  constructor(e, T) {
    super("CTR", e, CTR), _CTR_remaining.set(this, void 0), _CTR_remainingIndex.set(this, void 0), _CTR_counter.set(this, void 0), __classPrivateFieldSet(this, _CTR_counter, new Uint8Array(16), "f"), __classPrivateFieldGet(this, _CTR_counter, "f").fill(0), __classPrivateFieldSet(this, _CTR_remaining, __classPrivateFieldGet(this, _CTR_counter, "f"), "f"), __classPrivateFieldSet(this, _CTR_remainingIndex, 16, "f"), T == null && (T = 1), typeof T == "number" ? this.setCounterValue(T) : this.setCounterBytes(T);
  }
  get counter() {
    return new Uint8Array(__classPrivateFieldGet(this, _CTR_counter, "f"));
  }
  setCounterValue(e) {
    if (!Number.isInteger(e) || e < 0 || e > Number.MAX_SAFE_INTEGER)
      throw new TypeError("invalid counter initial integer value");
    for (let T = 15; T >= 0; --T)
      __classPrivateFieldGet(this, _CTR_counter, "f")[T] = e % 256, e = Math.floor(e / 256);
  }
  setCounterBytes(e) {
    if (e.length !== 16)
      throw new TypeError("invalid counter initial Uint8Array value length");
    __classPrivateFieldGet(this, _CTR_counter, "f").set(e);
  }
  increment() {
    for (let e = 15; e >= 0; e--)
      if (__classPrivateFieldGet(this, _CTR_counter, "f")[e] === 255)
        __classPrivateFieldGet(this, _CTR_counter, "f")[e] = 0;
      else {
        __classPrivateFieldGet(this, _CTR_counter, "f")[e]++;
        break;
      }
  }
  encrypt(e) {
    var T, $;
    const V = new Uint8Array(e);
    for (let J = 0; J < V.length; J++)
      __classPrivateFieldGet(this, _CTR_remainingIndex, "f") === 16 && (__classPrivateFieldSet(this, _CTR_remaining, this.aes.encrypt(__classPrivateFieldGet(this, _CTR_counter, "f")), "f"), __classPrivateFieldSet(this, _CTR_remainingIndex, 0, "f"), this.increment()), V[J] ^= __classPrivateFieldGet(this, _CTR_remaining, "f")[__classPrivateFieldSet(this, _CTR_remainingIndex, ($ = __classPrivateFieldGet(this, _CTR_remainingIndex, "f"), T = $++, $), "f"), T];
    return V;
  }
  decrypt(e) {
    return this.encrypt(e);
  }
}
_CTR_remaining = /* @__PURE__ */ new WeakMap(), _CTR_remainingIndex = /* @__PURE__ */ new WeakMap(), _CTR_counter = /* @__PURE__ */ new WeakMap();
function pkcs7Strip(C) {
  if (C.length < 16)
    throw new TypeError("PKCS#7 invalid length");
  const e = C[C.length - 1];
  if (e > 16)
    throw new TypeError("PKCS#7 padding byte out of range");
  const T = C.length - e;
  for (let $ = 0; $ < e; $++)
    if (C[T + $] !== e)
      throw new TypeError("PKCS#7 invalid padding byte");
  return new Uint8Array(C.subarray(0, T));
}
function looseArrayify(C) {
  return typeof C == "string" && !C.startsWith("0x") && (C = "0x" + C), getBytesCopy(C);
}
function zpad$1(C, e) {
  for (C = String(C); C.length < e; )
    C = "0" + C;
  return C;
}
function getPassword(C) {
  return typeof C == "string" ? toUtf8Bytes(C, "NFKC") : getBytesCopy(C);
}
function spelunk(C, e) {
  const T = e.match(/^([a-z0-9$_.-]*)(:([a-z]+))?(!)?$/i);
  assertArgument(T != null, "invalid path", "path", e);
  const $ = T[1], V = T[3], J = T[4] === "!";
  let ee = C;
  for (const te of $.toLowerCase().split(".")) {
    if (Array.isArray(ee)) {
      if (!te.match(/^[0-9]+$/))
        break;
      ee = ee[parseInt(te)];
    } else if (typeof ee == "object") {
      let re = null;
      for (const ie in ee)
        if (ie.toLowerCase() === te) {
          re = ee[ie];
          break;
        }
      ee = re;
    } else
      ee = null;
    if (ee == null)
      break;
  }
  if (assertArgument(!J || ee != null, "missing required value", "path", $), V && ee != null) {
    if (V === "int") {
      if (typeof ee == "string" && ee.match(/^-?[0-9]+$/))
        return parseInt(ee);
      if (Number.isSafeInteger(ee))
        return ee;
    }
    if (V === "number" && typeof ee == "string" && ee.match(/^-?[0-9.]*$/))
      return parseFloat(ee);
    if (V === "data" && typeof ee == "string")
      return looseArrayify(ee);
    if (V === "array" && Array.isArray(ee) || V === typeof ee)
      return ee;
    assertArgument(!1, `wrong type found for ${V} `, "path", $);
  }
  return ee;
}
const defaultPath$1 = "m/44'/60'/0'/0/0";
function isKeystoreJson(C) {
  try {
    const e = JSON.parse(C);
    if ((e.version != null ? parseInt(e.version) : 0) === 3)
      return !0;
  } catch {
  }
  return !1;
}
function decrypt(C, e, T) {
  if (spelunk(C, "crypto.cipher:string") === "aes-128-ctr") {
    const V = spelunk(C, "crypto.cipherparams.iv:data!"), J = new CTR(e, V);
    return hexlify(J.decrypt(T));
  }
  assert$5(!1, "unsupported cipher", "UNSUPPORTED_OPERATION", {
    operation: "decrypt"
  });
}
function getAccount$1(C, e) {
  const T = getBytes(e), $ = spelunk(C, "crypto.ciphertext:data!"), V = hexlify(keccak256(concat([T.slice(16, 32), $]))).substring(2);
  assertArgument(V === spelunk(C, "crypto.mac:string!").toLowerCase(), "incorrect password", "password", "[ REDACTED ]");
  const J = decrypt(C, T.slice(0, 16), $), ee = computeAddress(J);
  if (C.address) {
    let ie = C.address.toLowerCase();
    ie.startsWith("0x") || (ie = "0x" + ie), assertArgument(getAddress(ie) === ee, "keystore address/privateKey mismatch", "address", C.address);
  }
  const te = { address: ee, privateKey: J };
  if (spelunk(C, "x-ethers.version:string") === "0.1") {
    const ie = T.slice(32, 64), se = spelunk(C, "x-ethers.mnemonicCiphertext:data!"), de = spelunk(C, "x-ethers.mnemonicCounter:data!"), ue = new CTR(ie, de);
    te.mnemonic = {
      path: spelunk(C, "x-ethers.path:string") || defaultPath$1,
      locale: spelunk(C, "x-ethers.locale:string") || "en",
      entropy: hexlify(getBytes(ue.decrypt(se)))
    };
  }
  return te;
}
function getDecryptKdfParams(C) {
  const e = spelunk(C, "crypto.kdf:string");
  if (e && typeof e == "string") {
    if (e.toLowerCase() === "scrypt") {
      const T = spelunk(C, "crypto.kdfparams.salt:data!"), $ = spelunk(C, "crypto.kdfparams.n:int!"), V = spelunk(C, "crypto.kdfparams.r:int!"), J = spelunk(C, "crypto.kdfparams.p:int!");
      assertArgument($ > 0 && ($ & $ - 1) === 0, "invalid kdf.N", "kdf.N", $), assertArgument(V > 0 && J > 0, "invalid kdf", "kdf", e);
      const ee = spelunk(C, "crypto.kdfparams.dklen:int!");
      return assertArgument(ee === 32, "invalid kdf.dklen", "kdf.dflen", ee), { name: "scrypt", salt: T, N: $, r: V, p: J, dkLen: 64 };
    } else if (e.toLowerCase() === "pbkdf2") {
      const T = spelunk(C, "crypto.kdfparams.salt:data!"), $ = spelunk(C, "crypto.kdfparams.prf:string!"), V = $.split("-").pop();
      assertArgument(V === "sha256" || V === "sha512", "invalid kdf.pdf", "kdf.pdf", $);
      const J = spelunk(C, "crypto.kdfparams.c:int!"), ee = spelunk(C, "crypto.kdfparams.dklen:int!");
      return assertArgument(ee === 32, "invalid kdf.dklen", "kdf.dklen", ee), { name: "pbkdf2", salt: T, count: J, dkLen: ee, algorithm: V };
    }
  }
  assertArgument(!1, "unsupported key-derivation function", "kdf", e);
}
function decryptKeystoreJsonSync(C, e) {
  const T = JSON.parse(C), $ = getPassword(e), V = getDecryptKdfParams(T);
  if (V.name === "pbkdf2") {
    const { salt: de, count: ue, dkLen: fe, algorithm: he } = V, me = pbkdf2($, de, ue, fe, he);
    return getAccount$1(T, me);
  }
  assert$5(V.name === "scrypt", "cannot be reached", "UNKNOWN_ERROR", { params: V });
  const { salt: J, N: ee, r: te, p: re, dkLen: ie } = V, se = scryptSync($, J, ee, te, re, ie);
  return getAccount$1(T, se);
}
function stall$1(C) {
  return new Promise((e) => {
    setTimeout(() => {
      e();
    }, C);
  });
}
async function decryptKeystoreJson(C, e, T) {
  const $ = JSON.parse(C), V = getPassword(e), J = getDecryptKdfParams($);
  if (J.name === "pbkdf2") {
    T && (T(0), await stall$1(0));
    const { salt: ue, count: fe, dkLen: he, algorithm: me } = J, xe = pbkdf2(V, ue, fe, he, me);
    return T && (T(1), await stall$1(0)), getAccount$1($, xe);
  }
  assert$5(J.name === "scrypt", "cannot be reached", "UNKNOWN_ERROR", { params: J });
  const { salt: ee, N: te, r: re, p: ie, dkLen: se } = J, de = await scrypt(V, ee, te, re, ie, se, T);
  return getAccount$1($, de);
}
function getEncryptKdfParams(C) {
  const e = C.salt != null ? getBytes(C.salt, "options.salt") : randomBytes$2(32);
  let T = 1 << 17, $ = 8, V = 1;
  return C.scrypt && (C.scrypt.N && (T = C.scrypt.N), C.scrypt.r && ($ = C.scrypt.r), C.scrypt.p && (V = C.scrypt.p)), assertArgument(typeof T == "number" && T > 0 && Number.isSafeInteger(T) && (BigInt(T) & BigInt(T - 1)) === BigInt(0), "invalid scrypt N parameter", "options.N", T), assertArgument(typeof $ == "number" && $ > 0 && Number.isSafeInteger($), "invalid scrypt r parameter", "options.r", $), assertArgument(typeof V == "number" && V > 0 && Number.isSafeInteger(V), "invalid scrypt p parameter", "options.p", V), { name: "scrypt", dkLen: 32, salt: e, N: T, r: $, p: V };
}
function _encryptKeystore(C, e, T, $) {
  const V = getBytes(T.privateKey, "privateKey"), J = $.iv != null ? getBytes($.iv, "options.iv") : randomBytes$2(16);
  assertArgument(J.length === 16, "invalid options.iv length", "options.iv", $.iv);
  const ee = $.uuid != null ? getBytes($.uuid, "options.uuid") : randomBytes$2(16);
  assertArgument(ee.length === 16, "invalid options.uuid length", "options.uuid", $.iv);
  const te = C.slice(0, 16), re = C.slice(16, 32), ie = new CTR(te, J), se = getBytes(ie.encrypt(V)), de = keccak256(concat([re, se])), ue = {
    address: T.address.substring(2).toLowerCase(),
    id: uuidV4(ee),
    version: 3,
    Crypto: {
      cipher: "aes-128-ctr",
      cipherparams: {
        iv: hexlify(J).substring(2)
      },
      ciphertext: hexlify(se).substring(2),
      kdf: "scrypt",
      kdfparams: {
        salt: hexlify(e.salt).substring(2),
        n: e.N,
        dklen: 32,
        p: e.p,
        r: e.r
      },
      mac: de.substring(2)
    }
  };
  if (T.mnemonic) {
    const fe = $.client != null ? $.client : `ethers/${version$3}`, he = T.mnemonic.path || defaultPath$1, me = T.mnemonic.locale || "en", xe = C.slice(32, 64), ve = getBytes(T.mnemonic.entropy, "account.mnemonic.entropy"), Te = randomBytes$2(16), we = new CTR(xe, Te), Ee = getBytes(we.encrypt(ve)), Me = /* @__PURE__ */ new Date(), ke = "UTC--" + (Me.getUTCFullYear() + "-" + zpad$1(Me.getUTCMonth() + 1, 2) + "-" + zpad$1(Me.getUTCDate(), 2) + "T" + zpad$1(Me.getUTCHours(), 2) + "-" + zpad$1(Me.getUTCMinutes(), 2) + "-" + zpad$1(Me.getUTCSeconds(), 2) + ".0Z") + "--" + ue.address;
    ue["x-ethers"] = {
      client: fe,
      gethFilename: ke,
      path: he,
      locale: me,
      mnemonicCounter: hexlify(Te).substring(2),
      mnemonicCiphertext: hexlify(Ee).substring(2),
      version: "0.1"
    };
  }
  return JSON.stringify(ue);
}
function encryptKeystoreJsonSync(C, e, T) {
  T == null && (T = {});
  const $ = getPassword(e), V = getEncryptKdfParams(T), J = scryptSync($, V.salt, V.N, V.r, V.p, 64);
  return _encryptKeystore(getBytes(J), V, C, T);
}
async function encryptKeystoreJson(C, e, T) {
  T == null && (T = {});
  const $ = getPassword(e), V = getEncryptKdfParams(T), J = await scrypt($, V.salt, V.N, V.r, V.p, 64, T.progressCallback);
  return _encryptKeystore(getBytes(J), V, C, T);
}
const defaultPath = "m/44'/60'/0'/0/0", MasterSecret = new Uint8Array([66, 105, 116, 99, 111, 105, 110, 32, 115, 101, 101, 100]), HardenedBit = 2147483648, N = BigInt("0xfffffffffffffffffffffffffffffffebaaedce6af48a03bbfd25e8cd0364141"), Nibbles = "0123456789abcdef";
function zpad(C, e) {
  let T = "";
  for (; C; )
    T = Nibbles[C % 16] + T, C = Math.trunc(C / 16);
  for (; T.length < e * 2; )
    T = "0" + T;
  return "0x" + T;
}
function encodeBase58Check(C) {
  const e = getBytes(C), T = dataSlice(sha256$6(sha256$6(e)), 0, 4), $ = concat([e, T]);
  return encodeBase58($);
}
const _guard = {};
function ser_I(C, e, T, $) {
  const V = new Uint8Array(37);
  C & HardenedBit ? (assert$5($ != null, "cannot derive child of neutered node", "UNSUPPORTED_OPERATION", {
    operation: "deriveChild"
  }), V.set(getBytes($), 1)) : V.set(getBytes(T));
  for (let ee = 24; ee >= 0; ee -= 8)
    V[33 + (ee >> 3)] = C >> 24 - ee & 255;
  const J = getBytes(computeHmac("sha512", e, V));
  return { IL: J.slice(0, 32), IR: J.slice(32) };
}
function derivePath(C, e) {
  const T = e.split("/");
  assertArgument(T.length > 0, "invalid path", "path", e), T[0] === "m" && (assertArgument(C.depth === 0, `cannot derive root path (i.e. path starting with "m/") for a node at non-zero depth ${C.depth}`, "path", e), T.shift());
  let $ = C;
  for (let V = 0; V < T.length; V++) {
    const J = T[V];
    if (J.match(/^[0-9]+'$/)) {
      const ee = parseInt(J.substring(0, J.length - 1));
      assertArgument(ee < HardenedBit, "invalid path index", `path[${V}]`, J), $ = $.deriveChild(HardenedBit + ee);
    } else if (J.match(/^[0-9]+$/)) {
      const ee = parseInt(J);
      assertArgument(ee < HardenedBit, "invalid path index", `path[${V}]`, J), $ = $.deriveChild(ee);
    } else
      assertArgument(!1, "invalid path component", `path[${V}]`, J);
  }
  return $;
}
var Ns, ho, la, ds;
const vr = class vr extends BaseWallet {
  /**
   *  @private
   */
  constructor(T, $, V, J, ee, te, re, ie, se) {
    super($, se);
    Ft(this, Ns);
    /**
     *  The compressed public key.
     */
    tt(this, "publicKey");
    /**
     *  The fingerprint.
     *
     *  A fingerprint allows quick qay to detect parent and child nodes,
     *  but developers should be prepared to deal with collisions as it
     *  is only 4 bytes.
     */
    tt(this, "fingerprint");
    /**
     *  The parent fingerprint.
     */
    tt(this, "parentFingerprint");
    /**
     *  The mnemonic used to create this HD Node, if available.
     *
     *  Sources such as extended keys do not encode the mnemonic, in
     *  which case this will be ``null``.
     */
    tt(this, "mnemonic");
    /**
     *  The chaincode, which is effectively a public key used
     *  to derive children.
     */
    tt(this, "chainCode");
    /**
     *  The derivation path of this wallet.
     *
     *  Since extended keys do not provide full path details, this
     *  may be ``null``, if instantiated from a source that does not
     *  encode it.
     */
    tt(this, "path");
    /**
     *  The child index of this wallet. Values over ``2 *\* 31`` indicate
     *  the node is hardened.
     */
    tt(this, "index");
    /**
     *  The depth of this wallet, which is the number of components
     *  in its path.
     */
    tt(this, "depth");
    assertPrivate(T, _guard, "HDNodeWallet"), defineProperties(this, { publicKey: $.compressedPublicKey });
    const de = dataSlice(ripemd160$1(sha256$6(this.publicKey)), 0, 4);
    defineProperties(this, {
      parentFingerprint: V,
      fingerprint: de,
      chainCode: J,
      path: ee,
      index: te,
      depth: re
    }), defineProperties(this, { mnemonic: ie });
  }
  connect(T) {
    return new vr(_guard, this.signingKey, this.parentFingerprint, this.chainCode, this.path, this.index, this.depth, this.mnemonic, T);
  }
  /**
   *  Resolves to a [JSON Keystore Wallet](json-wallets) encrypted with
   *  %%password%%.
   *
   *  If %%progressCallback%% is specified, it will receive periodic
   *  updates as the encryption process progreses.
   */
  async encrypt(T, $) {
    return await encryptKeystoreJson(Qt(this, Ns, ho).call(this), T, { progressCallback: $ });
  }
  /**
   *  Returns a [JSON Keystore Wallet](json-wallets) encryped with
   *  %%password%%.
   *
   *  It is preferred to use the [async version](encrypt) instead,
   *  which allows a [[ProgressCallback]] to keep the user informed.
   *
   *  This method will block the event loop (freezing all UI) until
   *  it is complete, which may be a non-trivial duration.
   */
  encryptSync(T) {
    return encryptKeystoreJsonSync(Qt(this, Ns, ho).call(this), T);
  }
  /**
   *  The extended key.
   *
   *  This key will begin with the prefix ``xpriv`` and can be used to
   *  reconstruct this HD Node to derive its children.
   */
  get extendedKey() {
    return assert$5(this.depth < 256, "Depth too deep", "UNSUPPORTED_OPERATION", { operation: "extendedKey" }), encodeBase58Check(concat([
      "0x0488ADE4",
      zpad(this.depth, 1),
      this.parentFingerprint,
      zpad(this.index, 4),
      this.chainCode,
      concat(["0x00", this.privateKey])
    ]));
  }
  /**
   *  Returns true if this wallet has a path, providing a Type Guard
   *  that the path is non-null.
   */
  hasPath() {
    return this.path != null;
  }
  /**
   *  Returns a neutered HD Node, which removes the private details
   *  of an HD Node.
   *
   *  A neutered node has no private key, but can be used to derive
   *  child addresses and other public data about the HD Node.
   */
  neuter() {
    return new HDNodeVoidWallet(_guard, this.address, this.publicKey, this.parentFingerprint, this.chainCode, this.path, this.index, this.depth, this.provider);
  }
  /**
   *  Return the child for %%index%%.
   */
  deriveChild(T) {
    const $ = getNumber(T, "index");
    assertArgument($ <= 4294967295, "invalid index", "index", $);
    let V = this.path;
    V && (V += "/" + ($ & ~HardenedBit), $ & HardenedBit && (V += "'"));
    const { IR: J, IL: ee } = ser_I($, this.chainCode, this.publicKey, this.privateKey), te = new SigningKey(toBeHex((toBigInt(ee) + BigInt(this.privateKey)) % N, 32));
    return new vr(_guard, te, this.fingerprint, hexlify(J), V, $, this.depth + 1, this.mnemonic, this.provider);
  }
  /**
   *  Return the HDNode for %%path%% from this node.
   */
  derivePath(T) {
    return derivePath(this, T);
  }
  /**
   *  Creates a new HD Node from %%extendedKey%%.
   *
   *  If the %%extendedKey%% will either have a prefix or ``xpub`` or
   *  ``xpriv``, returning a neutered HD Node ([[HDNodeVoidWallet]])
   *  or full HD Node ([[HDNodeWallet) respectively.
   */
  static fromExtendedKey(T) {
    const $ = toBeArray(decodeBase58(T));
    assertArgument($.length === 82 || encodeBase58Check($.slice(0, 78)) === T, "invalid extended key", "extendedKey", "[ REDACTED ]");
    const V = $[4], J = hexlify($.slice(5, 9)), ee = parseInt(hexlify($.slice(9, 13)).substring(2), 16), te = hexlify($.slice(13, 45)), re = $.slice(45, 78);
    switch (hexlify($.slice(0, 4))) {
      case "0x0488b21e":
      case "0x043587cf": {
        const ie = hexlify(re);
        return new HDNodeVoidWallet(_guard, computeAddress(ie), ie, J, te, null, ee, V, null);
      }
      case "0x0488ade4":
      case "0x04358394 ":
        if (re[0] !== 0)
          break;
        return new vr(_guard, new SigningKey(re.slice(1)), J, te, null, ee, V, null, null);
    }
    assertArgument(!1, "invalid extended key prefix", "extendedKey", "[ REDACTED ]");
  }
  /**
   *  Creates a new random HDNode.
   */
  static createRandom(T, $, V) {
    var ee;
    T == null && (T = ""), $ == null && ($ = defaultPath), V == null && (V = LangEn.wordlist());
    const J = Mnemonic.fromEntropy(randomBytes$2(16), T, V);
    return Qt(ee = vr, la, ds).call(ee, J.computeSeed(), J).derivePath($);
  }
  /**
   *  Create an HD Node from %%mnemonic%%.
   */
  static fromMnemonic(T, $) {
    var V;
    return $ || ($ = defaultPath), Qt(V = vr, la, ds).call(V, T.computeSeed(), T).derivePath($);
  }
  /**
   *  Creates an HD Node from a mnemonic %%phrase%%.
   */
  static fromPhrase(T, $, V, J) {
    var te;
    $ == null && ($ = ""), V == null && (V = defaultPath), J == null && (J = LangEn.wordlist());
    const ee = Mnemonic.fromPhrase(T, $, J);
    return Qt(te = vr, la, ds).call(te, ee.computeSeed(), ee).derivePath(V);
  }
  /**
   *  Creates an HD Node from a %%seed%%.
   */
  static fromSeed(T) {
    var $;
    return Qt($ = vr, la, ds).call($, T, null);
  }
};
Ns = new WeakSet(), ho = function() {
  const T = { address: this.address, privateKey: this.privateKey }, $ = this.mnemonic;
  return this.path && $ && $.wordlist.locale === "en" && $.password === "" && (T.mnemonic = {
    path: this.path,
    locale: "en",
    entropy: $.entropy
  }), T;
}, la = new WeakSet(), ds = function(T, $) {
  assertArgument(isBytesLike(T), "invalid seed", "seed", "[REDACTED]");
  const V = getBytes(T, "seed");
  assertArgument(V.length >= 16 && V.length <= 64, "invalid seed", "seed", "[REDACTED]");
  const J = getBytes(computeHmac("sha512", MasterSecret, V)), ee = new SigningKey(hexlify(J.slice(0, 32)));
  return new vr(_guard, ee, "0x00000000", hexlify(J.slice(32)), "m", 0, 0, $, null);
}, Ft(vr, la);
let HDNodeWallet = vr;
class HDNodeVoidWallet extends VoidSigner {
  /**
   *  @private
   */
  constructor(T, $, V, J, ee, te, re, ie, se) {
    super($, se);
    /**
     *  The compressed public key.
     */
    tt(this, "publicKey");
    /**
     *  The fingerprint.
     *
     *  A fingerprint allows quick qay to detect parent and child nodes,
     *  but developers should be prepared to deal with collisions as it
     *  is only 4 bytes.
     */
    tt(this, "fingerprint");
    /**
     *  The parent node fingerprint.
     */
    tt(this, "parentFingerprint");
    /**
     *  The chaincode, which is effectively a public key used
     *  to derive children.
     */
    tt(this, "chainCode");
    /**
     *  The derivation path of this wallet.
     *
     *  Since extended keys do not provider full path details, this
     *  may be ``null``, if instantiated from a source that does not
     *  enocde it.
     */
    tt(this, "path");
    /**
     *  The child index of this wallet. Values over ``2 *\* 31`` indicate
     *  the node is hardened.
     */
    tt(this, "index");
    /**
     *  The depth of this wallet, which is the number of components
     *  in its path.
     */
    tt(this, "depth");
    assertPrivate(T, _guard, "HDNodeVoidWallet"), defineProperties(this, { publicKey: V });
    const de = dataSlice(ripemd160$1(sha256$6(V)), 0, 4);
    defineProperties(this, {
      publicKey: V,
      fingerprint: de,
      parentFingerprint: J,
      chainCode: ee,
      path: te,
      index: re,
      depth: ie
    });
  }
  connect(T) {
    return new HDNodeVoidWallet(_guard, this.address, this.publicKey, this.parentFingerprint, this.chainCode, this.path, this.index, this.depth, T);
  }
  /**
   *  The extended key.
   *
   *  This key will begin with the prefix ``xpub`` and can be used to
   *  reconstruct this neutered key to derive its children addresses.
   */
  get extendedKey() {
    return assert$5(this.depth < 256, "Depth too deep", "UNSUPPORTED_OPERATION", { operation: "extendedKey" }), encodeBase58Check(concat([
      "0x0488B21E",
      zpad(this.depth, 1),
      this.parentFingerprint,
      zpad(this.index, 4),
      this.chainCode,
      this.publicKey
    ]));
  }
  /**
   *  Returns true if this wallet has a path, providing a Type Guard
   *  that the path is non-null.
   */
  hasPath() {
    return this.path != null;
  }
  /**
   *  Return the child for %%index%%.
   */
  deriveChild(T) {
    const $ = getNumber(T, "index");
    assertArgument($ <= 4294967295, "invalid index", "index", $);
    let V = this.path;
    V && (V += "/" + ($ & ~HardenedBit), $ & HardenedBit && (V += "'"));
    const { IR: J, IL: ee } = ser_I($, this.chainCode, this.publicKey, null), te = SigningKey.addPoints(ee, this.publicKey, !0), re = computeAddress(te);
    return new HDNodeVoidWallet(_guard, re, te, this.fingerprint, hexlify(J), V, $, this.depth + 1, this.provider);
  }
  /**
   *  Return the signer for %%path%% from this node.
   */
  derivePath(T) {
    return derivePath(this, T);
  }
}
function isCrowdsaleJson(C) {
  try {
    if (JSON.parse(C).encseed)
      return !0;
  } catch {
  }
  return !1;
}
function decryptCrowdsaleJson(C, e) {
  const T = JSON.parse(C), $ = getPassword(e), V = getAddress(spelunk(T, "ethaddr:string!")), J = looseArrayify(spelunk(T, "encseed:string!"));
  assertArgument(J && J.length % 16 === 0, "invalid encseed", "json", C);
  const ee = getBytes(pbkdf2($, $, 2e3, 32, "sha256")).slice(0, 16), te = J.slice(0, 16), re = J.slice(16), ie = new CBC(ee, te), se = pkcs7Strip(getBytes(ie.decrypt(re)));
  let de = "";
  for (let ue = 0; ue < se.length; ue++)
    de += String.fromCharCode(se[ue]);
  return { address: V, privateKey: id(de) };
}
function stall(C) {
  return new Promise((e) => {
    setTimeout(() => {
      e();
    }, C);
  });
}
var Ps, $r, mo;
let Wallet$1 = ($r = class extends BaseWallet {
  /**
   *  Create a new wallet for the private %%key%%, optionally connected
   *  to %%provider%%.
   */
  constructor(e, T) {
    typeof e == "string" && !e.startsWith("0x") && (e = "0x" + e);
    let $ = typeof e == "string" ? new SigningKey(e) : e;
    super($, T);
  }
  connect(e) {
    return new $r(this.signingKey, e);
  }
  /**
   *  Resolves to a [JSON Keystore Wallet](json-wallets) encrypted with
   *  %%password%%.
   *
   *  If %%progressCallback%% is specified, it will receive periodic
   *  updates as the encryption process progreses.
   */
  async encrypt(e, T) {
    const $ = { address: this.address, privateKey: this.privateKey };
    return await encryptKeystoreJson($, e, { progressCallback: T });
  }
  /**
   *  Returns a [JSON Keystore Wallet](json-wallets) encryped with
   *  %%password%%.
   *
   *  It is preferred to use the [async version](encrypt) instead,
   *  which allows a [[ProgressCallback]] to keep the user informed.
   *
   *  This method will block the event loop (freezing all UI) until
   *  it is complete, which may be a non-trivial duration.
   */
  encryptSync(e) {
    const T = { address: this.address, privateKey: this.privateKey };
    return encryptKeystoreJsonSync(T, e);
  }
  /**
   *  Creates (asynchronously) a **Wallet** by decrypting the %%json%%
   *  with %%password%%.
   *
   *  If %%progress%% is provided, it is called periodically during
   *  decryption so that any UI can be updated.
   */
  static async fromEncryptedJson(e, T, $) {
    var J;
    let V = null;
    return isKeystoreJson(e) ? V = await decryptKeystoreJson(e, T, $) : isCrowdsaleJson(e) && ($ && ($(0), await stall(0)), V = decryptCrowdsaleJson(e, T), $ && ($(1), await stall(0))), Qt(J = $r, Ps, mo).call(J, V);
  }
  /**
   *  Creates a **Wallet** by decrypting the %%json%% with %%password%%.
   *
   *  The [[fromEncryptedJson]] method is preferred, as this method
   *  will lock up and freeze the UI during decryption, which may take
   *  some time.
   */
  static fromEncryptedJsonSync(e, T) {
    var V;
    let $ = null;
    return isKeystoreJson(e) ? $ = decryptKeystoreJsonSync(e, T) : isCrowdsaleJson(e) ? $ = decryptCrowdsaleJson(e, T) : assertArgument(!1, "invalid JSON wallet", "json", "[ REDACTED ]"), Qt(V = $r, Ps, mo).call(V, $);
  }
  /**
   *  Creates a new random [[HDNodeWallet]] using the available
   *  [cryptographic random source](randomBytes).
   *
   *  If there is no crytographic random source, this will throw.
   */
  static createRandom(e) {
    const T = HDNodeWallet.createRandom();
    return e ? T.connect(e) : T;
  }
  /**
   *  Creates a [[HDNodeWallet]] for %%phrase%%.
   */
  static fromPhrase(e, T) {
    const $ = HDNodeWallet.fromPhrase(e);
    return T ? $.connect(T) : $;
  }
}, Ps = new WeakSet(), mo = function(e) {
  if (assertArgument(e, "invalid JSON wallet", "json", "[ REDACTED ]"), "mnemonic" in e && e.mnemonic && e.mnemonic.locale === "en") {
    const $ = Mnemonic.fromEntropy(e.mnemonic.entropy), V = HDNodeWallet.fromMnemonic($, e.mnemonic.path);
    if (V.address === e.address && V.privateKey === e.privateKey)
      return V;
    console.log("WARNING: JSON mismatch address/privateKey != mnemonic; fallback onto private key");
  }
  const T = new $r(e.privateKey);
  return assertArgument(T.address === e.address, "address/privateKey mismatch", "json", "[ REDACTED ]"), T;
}, Ft($r, Ps), $r);
class MultiProvider {
  constructor() {
    tt(this, "domains");
    tt(this, "providers");
    tt(this, "signers");
    this.domains = /* @__PURE__ */ new Map(), this.providers = /* @__PURE__ */ new Map(), this.signers = /* @__PURE__ */ new Map();
  }
  /**
   * Resgister a domain with the MultiProvider. This allows the multiprovider
   * to resolves tha domain info, and reference it by name or number.
   *
   * @param domain The Domain object to register.
   */
  registerDomain(e) {
    this.domains.set(e.name, e);
  }
  get registeredDomains() {
    return Array.from(this.domains.values());
  }
  get domainNumbers() {
    return this.registeredDomains.map((e) => e.domain);
  }
  get domainNames() {
    return Array.from(this.domains.keys());
  }
  get missingProviders() {
    return this.domainNames.filter((e) => !this.providers.has(e));
  }
  /**
   * Resolve a domain name (or number) to the canonical number.
   *
   * This function is used extensively to disambiguate domains.
   *
   * @param nameOrDomain A domain name or number.
   * @returns The canonical domain number.
   */
  resolveDomain(e) {
    let T;
    if (typeof e == "number" ? T = this.registeredDomains.find(($) => ($ == null ? void 0 : $.domain) === e) : typeof e == "string" && (T = this.registeredDomains.find(
      ($) => ($ == null ? void 0 : $.name.toLowerCase()) === e.toLowerCase()
    )), !T) throw new UnknownDomainError(this, e);
    return T.domain;
  }
  /**
   * Resolve the name of a registered {@link Domain}, from its name or number.
   *
   * Similar to `resolveDomain`.
   *
   * @param nameOrDomain A domain name or number.
   * @returns The name
   * @throws If the domain is unknown
   */
  resolveDomainName(e) {
    let T;
    if (typeof e == "number" ? T = this.registeredDomains.find(($) => ($ == null ? void 0 : $.domain) === e) : typeof e == "string" && (T = this.registeredDomains.find(
      ($) => ($ == null ? void 0 : $.name.toLowerCase()) === e.toLowerCase()
    )), !T) throw new UnknownDomainError(this, e);
    return T.name;
  }
  /**
   * Check whether the {@link MultiProvider} is aware of a domain.
   *
   * @param nameOrDomain A domain name or number.
   * @returns true if the {@link Domain} has been registered, else false.
   */
  knownDomain(e) {
    try {
      return this.resolveDomain(e), !0;
    } catch {
      return !1;
    }
  }
  /**
   * Get the registered {@link Domain} object (if any)
   *
   * @param nameOrDomain A domain name or number.
   * @returns A {@link Domain} (if the domain has been registered)
   */
  getDomain(e) {
    let T = e;
    if (typeof T != "string" && (T = this.resolveDomainName(e)), !!T)
      return this.domains.get(T);
  }
  /**
   * Get the registered {@link Domain} object (or error)
   *
   * @param nameOrDomain A domain name or number.
   * @returns A {@link Domain}
   * @throws if the domain has not been registered
   */
  mustGetDomain(e) {
    const T = this.getDomain(e);
    if (!T) throw new UnknownDomainError(this, e);
    return T;
  }
  /**
   * Register an ethers Provider for a specified domain.
   *
   * @param nameOrDomain A domain name or number.
   * @param provider An ethers Provider to be used by requests to that domain.
   */
  registerProvider(e, T) {
    const $ = this.mustGetDomain(e).name;
    try {
      const V = this.signers.get($);
      V && this.signers.set($, V.connect(T));
    } catch {
      this.unregisterSigner($);
    }
    this.providers.set($, T);
  }
  /**
   * Shortcut to register a provider by its HTTP RPC URL.
   *
   * @param nameOrDomain A domain name or number.
   * @param rpc The HTTP RPC Url
   */
  registerRpcProvider(e, T) {
    const $ = this.resolveDomain(e);
    if (T.startsWith("http://") || T.startsWith("https://")) {
      const V = new JsonRpcProvider$1(T);
      this.registerProvider($, V);
    } else if (T.startsWith("ws://") || T.startsWith("wss://")) {
      const V = new WebSocketProvider(T);
      this.registerProvider($, V);
    } else
      throw new Error(
        "Unknown RPC string scheme. Expected an http or websocket URI"
      );
  }
  /**
   * Get the Provider associated with a doman (if any)
   *
   * @param nameOrDomain A domain name or number.
   * @returns The currently registered Provider (or none)
   */
  getProvider(e) {
    const T = this.resolveDomainName(e);
    return this.providers.get(T);
  }
  /**
   * Get the Provider associated with a doman (or error)
   *
   * @param nameOrDomain A domain name or number.
   * @returns A Provider
   * @throws If no provider has been registered for the specified domain
   */
  mustGetProvider(e) {
    const T = this.getProvider(e);
    if (!T)
      throw new NoProviderError(this, e);
    return T;
  }
  /**
   * Register an ethers Signer for a specified domain.
   *
   * @param nameOrDomain A domain name or number.
   * @param signer An ethers Signer to be used by requests to that domain.
   */
  registerSigner(e, T) {
    const $ = this.resolveDomainName(e), V = this.providers.get($);
    if (!V && !T.provider)
      throw new NoProviderError(this, e);
    if (V)
      try {
        T = T.connect(V), this.signers.set($, T);
        return;
      } catch {
      }
    if (!T.provider)
      throw new Error("Signer does not permit reconnect and has no provider");
    this.signers.set($, T);
  }
  /**
   * Remove the registered ethers Signer from a domain. This function will
   * attempt to preserve any Provider that was previously connected to this
   * domain.
   *
   * @param nameOrDomain A domain name or number.
   */
  unregisterSigner(e) {
    const T = this.resolveDomainName(e);
    if (!this.signers.has(T))
      return;
    const $ = this.signers.get(T);
    if ($ == null || $.provider == null)
      throw new UnreachableError("signer was missing provider.");
    this.signers.delete(T), this.getProvider(e) || this.providers.set(T, $.provider);
  }
  /**
   * Clear all signers from all registered domains.
   */
  clearSigners() {
    this.domainNumbers.forEach((e) => this.unregisterSigner(e));
  }
  /**
   * A shortcut for registering a basic local privkey signer on a domain.
   *
   * @param nameOrDomain A domain name or number.
   * @param privkey A private key string passed to `ethers.Wallet`
   */
  registerWalletSigner(e, T) {
    const $ = this.resolveDomain(e), V = new Wallet$1(T);
    this.registerSigner($, V);
  }
  /**
   * Return the signer registered to a domain (if any).
   *
   * @param nameOrDomain A domain name or number.
   * @returns The registered signer (or undefined)
   */
  getSigner(e) {
    const T = this.resolveDomainName(e);
    return this.signers.get(T);
  }
  /**
   * Get the Signer associated with a doman (or error)
   *
   * @param nameOrDomain A domain name or number.
   * @returns A Signer
   * @throws If no provider has been registered for the specified domain
   */
  mustGetSigner(e) {
    const T = this.getSigner(e);
    if (!T)
      throw new UnknownDomainError(this, e);
    return T;
  }
  /**
   * Returns the most privileged connection registered to a domain. E.g.
   * this function will attempt to return a Signer, then attempt to return the
   * Provider (if no Signer is registered). If neither Signer nor Provider is
   * registered for a domain, it will return undefined
   *
   * @param nameOrDomain A domain name or number.
   * @returns A Signer (if any), otherwise a Provider (if any), otherwise
   *          undefined
   */
  getConnection(e) {
    return this.getSigner(e) ?? this.getProvider(e);
  }
  /**
   * Get the Connection associated with a doman (or error)
   *
   * @param nameOrDomain A domain name or number.
   * @returns A Signer
   * @returns A Signer (if any), otherwise a Provider (if any), otherwise error
   */
  mustGetConnection(e) {
    const T = this.getConnection(e);
    if (!T)
      throw new NoProviderError(this, e);
    return T;
  }
  /**
   * Resolves the address of a Signer on a domain (or undefined, if no Signer)
   *
   * @param nameOrDomain A domain name or number.
   * @returns A Promise for the address of the registered signer (if any)
   */
  async getAddress(e) {
    const T = this.getSigner(e);
    return await (T == null ? void 0 : T.getAddress());
  }
}
class UnreachableError extends Error {
  constructor(e) {
    super(
      `Unreachable. You should not see this Error. Please file an issue at https://github.com/nomad-xyz/monorepo, including the full error output. Extra info: ${e ?? "none"}`
    );
  }
}
class WithContext extends Error {
  constructor(T, $) {
    super($);
    tt(this, "provider");
    this.provider = T;
  }
}
class UnknownDomainError extends WithContext {
  constructor(T, $) {
    super(
      T,
      `Attempted to access an unknown domain: ${$}.
Hint: have you called \`context.registerDomain(...)\` yet?`
    );
    tt(this, "domain");
    this.name = "UnknownDomainError", this.domain = $;
  }
}
class NoProviderError extends WithContext {
  constructor(T, $) {
    const V = T.resolveDomainName($), J = T.resolveDomain($);
    super(
      T,
      `Missing provider for domain: ${J} : ${V}.
Hint: Have you called \`context.registerProvider(${$}, provider)\` yet?`
    );
    tt(this, "domain");
    tt(this, "domainName");
    tt(this, "domainNumber");
    this.name = "NoProviderError", this.domain = $, this.domainName = V, this.domainNumber = J;
  }
}
const range = (C) => [...Array(C).keys()], column = (C, e) => C.map((T) => T[e]), zip = (C) => range(C[0].length).map((e) => range(C.length).map((T) => C[T][e])), filterIndexes = (C, e, T) => {
  const $ = new Set(Array.isArray(e) ? e : [e]);
  return C.filter((V, J) => $.has(J) !== T);
};
function isMappableKey(C) {
  return ["string", "number", "symbol", "bigint", "boolean"].includes(typeof C);
}
const isRecursiveTuple = (C) => C.length === 2 && !Array.isArray(C[0]) && Array.isArray(C[1]), cartesianRightRecursive = (C) => C.length === 0 ? [] : Array.isArray(C[0]) ? C.map(([e, T]) => Array.isArray(T) ? (isRecursiveTuple(T) ? cartesianRightRecursive(T) : T).map(($) => [e, $].flat()) : [[e, T]]).flat() : isRecursiveTuple(C) ? cartesianRightRecursive(C[1]).map((e) => [C[0], e]) : C, toMapping = (C, e) => {
  const T = cartesianRightRecursive(C);
  if (T.length === 0)
    throw new Error("Invalid mapping: empty");
  const $ = e === void 0 ? [range(T[0].length - 1), [T[0].length - 1]] : e.map((ue) => typeof ue == "number" ? [ue] : ue);
  let V = [], J = !0;
  const ee = (ue, fe) => {
    const he = Array.from(new Set(ue[0]).values()), me = new Map(he.map((ve) => [ve, []]));
    for (const [ve, Te] of ue[0].entries())
      me.get(Te).push(ve);
    if (ue.length === 1) {
      const ve = Object.fromEntries(he.map((Te) => [Te, me.get(Te).map((we) => fe[we].length === 1 ? fe[we][0] : fe[we])]));
      if (J) {
        for (const Te of me.values())
          if (Te.length > 1)
            return J = !1, ve;
        V.push(ve);
      }
      return ve;
    }
    const xe = zip(ue.slice(1));
    return Object.fromEntries(he.map((ve) => {
      const Te = me.get(ve), we = zip(Te.map((Me) => xe[Me])), Ee = Te.map((Me) => fe[Me]);
      return [
        ve,
        ee(we, Ee)
      ];
    }));
  }, te = zip(T), re = (ue) => {
    const fe = te[ue];
    if (fe === void 0)
      throw new Error(`Invalid shape: column ${ue} does not exist`);
    return fe;
  }, [ie, se] = $.map((ue) => ue.map((fe) => re(fe)));
  if (ie.length === 0)
    throw new Error("Invalid shape: empty key set");
  if (se.length === 0)
    throw new Error("Invalid shape: empty value set");
  for (const ue of ie)
    for (const fe of ue)
      if (!isMappableKey(fe))
        throw new Error(`Invalid key: ${fe} in ${ue}`);
  const de = ee(ie, zip(se));
  if (J)
    for (const ue of V)
      for (const fe of Object.keys(ue))
        ue[fe] = ue[fe][0];
  return de;
};
function constMap(C, e) {
  const T = toMapping(C, e), $ = (...V) => V.reduce((J, ee) => J ? J[ee.toString()] ?? void 0 : void 0, T);
  return Object.assign($, {
    has: (...V) => $(...V) !== void 0,
    get: (...V) => $(...V),
    subMap: (V) => T[V.toString()]
  });
}
function lazyInstantiate(C) {
  let e = null;
  return () => (e || (e = C()), e);
}
function throws(C) {
  try {
    return C(), !1;
  } catch {
    return !0;
  }
}
var binaryLiterals = ["int", "uint", "bytes", "array", "switch"], defaultEndianness = "big", numberMaxSize = 6, isNumType = (C) => typeof C == "number" || typeof C == "bigint", isBytesType = (C) => C instanceof Uint8Array, isPrimitiveType = (C) => isNumType(C) || isBytesType(C), isItem = (C) => binaryLiterals.includes(C == null ? void 0 : C.binary), isLayout = (C) => isItem(C) || Array.isArray(C) && C.every(isItem), isFixedNumberConversion = (C) => typeof (C == null ? void 0 : C.from) == "number", isFixedBigintConversion = (C) => typeof (C == null ? void 0 : C.from) == "bigint", isFixedUintConversion = (C) => isFixedNumberConversion(C) || isFixedBigintConversion(C), isFixedBytesConversion = (C) => isBytesType(C == null ? void 0 : C.from), isFixedPrimitiveConversion = (C) => isFixedUintConversion(C) || isFixedBytesConversion(C), checkSize = (C, e) => {
  if (C !== e)
    throw new Error(`size mismatch: layout size: ${C}, data size: ${e}`);
  return e;
}, checkItemSize = (C, e) => "size" in C && C.size !== void 0 ? checkSize(C.size, e) : e, checkNumEquals = (C, e) => {
  if (C != e)
    throw new Error(`value mismatch: (constant) layout value: ${C}, data value: ${e}`);
}, checkBytesTypeEqual = (C, e, T) => {
  const $ = (ie, se) => se === void 0 ? [0, ie.length] : Array.isArray(se) ? se : [se, ie.length], [V, J] = $(C, T == null ? void 0 : T.customSlice), [ee, te] = $(e, T == null ? void 0 : T.dataSlize), re = J - V;
  checkSize(re, te - ee);
  for (let ie = 0; ie < C.length; ++ie)
    if (C[ie + V] !== e[ie + ee])
      throw new Error(
        `binary data mismatch: layout value: ${C}, offset: ${V}, data value: ${e}, offset: ${ee}`
      );
};
function findIdLayoutPair(C, e) {
  const T = e[C.idTag ?? "id"];
  return C.layouts.find(
    ([$]) => (Array.isArray($) ? $[1] : $) == T
  );
}
function calcStaticSize(C) {
  return internalCalcSize(C, staticCalc);
}
var staticCalc = Symbol("staticCalc");
function calcSizeForSerialization(C, e) {
  const T = [], $ = internalCalcSize(C, e, T);
  if ($ === null)
    throw new Error(
      `coding error: couldn't calculate layout size for layout ${C} with data ${e}`
    );
  return [$, T];
}
function calcItemSize(C, e, T) {
  const $ = (V) => (T !== void 0 && T.push(V), V);
  switch (C.binary) {
    case "int":
    case "uint":
      return C.size;
    case "bytes": {
      const V = "lengthSize" in C ? C.lengthSize | 0 : 0;
      if ("layout" in C) {
        const { custom: ee } = C, te = internalCalcSize(
          C.layout,
          ee === void 0 ? e : typeof ee.from == "function" ? e !== staticCalc ? $(ee.from(e)) : staticCalc : ee.from,
          //flex layout bytes only allows conversions, not fixed values
          T
        );
        return te === null ? "size" in C ? C.size ?? null : null : V + checkItemSize(C, te);
      }
      const { custom: J } = C;
      return isBytesType(J) ? V + J.length : isFixedBytesConversion(J) ? V + J.from.length : J === void 0 ? e !== staticCalc ? V + checkItemSize(C, e.length) : null : e !== staticCalc ? V + checkItemSize(C, $(J.from(e)).length) : null;
    }
    case "array": {
      const V = "length" in C ? C.length : void 0;
      if (e === staticCalc) {
        if (V !== void 0) {
          const ee = internalCalcSize(C.layout, staticCalc, T);
          return ee !== null ? V * ee : null;
        }
        return null;
      }
      let J = 0;
      if (V !== void 0 && V !== e.length)
        throw new Error(
          `array length mismatch: layout length: ${V}, data length: ${e.length}`
        );
      "lengthSize" in C && C.lengthSize !== void 0 && (J += C.lengthSize);
      for (let ee = 0; ee < e.length; ++ee) {
        const te = internalCalcSize(C.layout, e[ee], T);
        if (te === null)
          return null;
        J += te;
      }
      return J;
    }
    case "switch": {
      if (e !== staticCalc) {
        const [J, ee] = findIdLayoutPair(C, e), te = internalCalcSize(ee, e, T);
        return te !== null ? C.idSize + te : null;
      }
      let V = null;
      for (const [J, ee] of C.layouts) {
        const te = internalCalcSize(ee, staticCalc, T);
        if (V === null)
          V = te;
        else if (te !== V)
          return null;
      }
      return C.idSize + V;
    }
  }
}
function internalCalcSize(C, e, T) {
  if (isItem(C))
    return calcItemSize(C, e, T);
  let $ = 0;
  for (const V of C) {
    let J;
    if (e === staticCalc)
      J = staticCalc;
    else if (!("omit" in V) || !V.omit) {
      if (!(V.name in e))
        throw new Error(`missing data for layout item: ${V.name}`);
      J = e[V.name];
    }
    const ee = calcItemSize(V, J, T);
    if (ee === null) {
      if (e !== staticCalc)
        throw new Error(`coding error: couldn't calculate size for layout item: ${V.name}`);
      return null;
    }
    $ += ee;
  }
  return $;
}
var cursorWrite = (C, e) => {
  C.bytes.set(e, C.offset), C.offset += e.length;
}, bcqGetNext = (C) => C.bytesConversions[C.position++];
function serialize$2(C, e, T) {
  const [$, V] = calcSizeForSerialization(C, e), J = { bytes: T ?? new Uint8Array($), offset: 0 };
  if (internalSerialize(C, e, J, { bytesConversions: V, position: 0 }), !T && J.offset !== J.bytes.length)
    throw new Error(
      `encoded data is shorter than expected: ${J.bytes.length} > ${J.offset}`
    );
  return T ? J.offset : J.bytes;
}
var maxAllowedNumberVal = 2 ** (numberMaxSize * 8);
function serializeNum$1(C, e, T, $ = defaultEndianness, V = !1) {
  if (!V && C < 0)
    throw new Error(`Value ${C} is negative but unsigned`);
  if (typeof C == "number") {
    if (!Number.isInteger(C))
      throw new Error(`Value ${C} is not an integer`);
    if (e > numberMaxSize) {
      if (C >= maxAllowedNumberVal)
        throw new Error(`Value ${C} is too large to be safely converted into an integer`);
      if (V && C < -maxAllowedNumberVal)
        throw new Error(`Value ${C} is too small to be safely converted into an integer`);
    }
  }
  const J = 2n ** BigInt(e * 8 - (V ? 1 : 0));
  if (C >= J)
    throw new Error(`Value ${C} is too large for ${e} bytes`);
  if (V && C < -J)
    throw new Error(`Value ${C} is too small for ${e} bytes`);
  for (let ee = 0; ee < e; ++ee)
    T.bytes[T.offset + ee] = Number(BigInt(C) >> BigInt(8 * ($ === "big" ? e - ee - 1 : ee)) & 0xffn);
  T.offset += e;
}
function internalSerialize(C, e, T, $) {
  if (isItem(C))
    serializeItem(C, e, T, $);
  else
    for (const V of C)
      try {
        serializeItem(V, e[V.name], T, $);
      } catch (J) {
        throw J.message = `when serializing item '${V.name}': ${J.message}`, J;
      }
}
function serializeItem(C, e, T, $) {
  switch (C.binary) {
    case "int":
    case "uint": {
      const V = (() => {
        var J;
        return isNumType(C.custom) ? ("omit" in C && C.omit || checkNumEquals(C.custom, e), C.custom) : isNumType((J = C == null ? void 0 : C.custom) == null ? void 0 : J.from) ? C.custom.from : C.custom !== void 0 ? C.custom.from(e) : e;
      })();
      serializeNum$1(V, C.size, T, C.endianness, C.binary === "int");
      break;
    }
    case "bytes": {
      const V = T.offset;
      if ("lengthSize" in C && C.lengthSize !== void 0 && (T.offset += C.lengthSize), "layout" in C) {
        const { custom: J } = C;
        let ee;
        J === void 0 ? ee = e : typeof J.from != "function" ? ee = J.from : ee = bcqGetNext($), internalSerialize(C.layout, ee, T, $);
      } else {
        const { custom: J } = C;
        isBytesType(J) ? ("omit" in C && C.omit || checkBytesTypeEqual(J, e), cursorWrite(T, J)) : isFixedBytesConversion(J) ? cursorWrite(T, J.from) : cursorWrite(T, J !== void 0 ? bcqGetNext($) : e);
      }
      if ("lengthSize" in C && C.lengthSize !== void 0) {
        const J = T.offset - V - C.lengthSize, ee = T.offset;
        T.offset = V, serializeNum$1(J, C.lengthSize, T, C.lengthEndianness), T.offset = ee;
      } else
        checkItemSize(C, T.offset - V);
      break;
    }
    case "array": {
      if ("length" in C && C.length !== e.length)
        throw new Error(
          `array length mismatch: layout length: ${C.length}, data length: ${e.length}`
        );
      "lengthSize" in C && C.lengthSize !== void 0 && serializeNum$1(e.length, C.lengthSize, T, C.lengthEndianness);
      for (let V = 0; V < e.length; ++V)
        internalSerialize(C.layout, e[V], T, $);
      break;
    }
    case "switch": {
      const [V, J] = findIdLayoutPair(C, e), ee = Array.isArray(V) ? V[0] : V;
      serializeNum$1(ee, C.idSize, T, C.idEndianness), internalSerialize(J, e, T, $);
      break;
    }
  }
}
function getCachedSerializedFrom(C) {
  const e = C.custom;
  if (!("cachedSerializedFrom" in e) && (e.cachedSerializedFrom = serialize$2(C.layout, e.from), "size" in C && C.size !== void 0 && C.size !== e.cachedSerializedFrom.length))
    throw new Error(
      "Layout specification error: custom.from does not serialize to specified size"
    );
  return e.cachedSerializedFrom;
}
function deserialize$2(C, e, T) {
  const $ = T ?? !0, V = {
    bytes: e,
    offset: 0,
    end: e.length
  }, J = internalDeserialize(C, V);
  if ($ && V.offset !== V.end)
    throw new Error(`encoded data is longer than expected: ${V.end} > ${V.offset}`);
  return $ ? J : [J, V.offset];
}
function updateOffset(C, e) {
  const T = C.offset + e;
  if (T > C.end)
    throw new Error(`chunk is shorter than expected: ${C.end} < ${T}`);
  C.offset = T;
}
function internalDeserialize(C, e) {
  if (!Array.isArray(C))
    return deserializeItem(C, e);
  let T = {};
  for (const $ of C)
    try {
      ($.omit ? {} : T)[$.name] = deserializeItem($, e);
    } catch (V) {
      throw V.message = `when deserializing item '${$.name}': ${V.message}`, V;
    }
  return T;
}
function deserializeNum$1(C, e, T = defaultEndianness, $ = !1) {
  let V = 0n;
  for (let J = 0; J < e; ++J)
    V |= BigInt(C.bytes[C.offset + J]) << BigInt(8 * (T === "big" ? e - J - 1 : J));
  return $ && C.bytes[C.offset + (T === "big" ? 0 : e - 1)] & 128 && (V -= 1n << BigInt(8 * e)), updateOffset(C, e), e > numberMaxSize ? V : Number(V);
}
function deserializeItem(C, e) {
  switch (C.binary) {
    case "int":
    case "uint": {
      const T = deserializeNum$1(e, C.size, C.endianness, C.binary === "int"), { custom: $ } = C;
      return isNumType($) ? (checkNumEquals($, T), $) : isNumType($ == null ? void 0 : $.from) ? (checkNumEquals($.from, T), $.to) : $ !== void 0 ? $.to(T) : T;
    }
    case "bytes": {
      const T = "lengthSize" in C && C.lengthSize !== void 0 ? deserializeNum$1(e, C.lengthSize, C.lengthEndianness) : C == null ? void 0 : C.size;
      if ("layout" in C) {
        const { custom: te } = C, re = e.offset;
        let ie;
        if (T === void 0)
          ie = internalDeserialize(C.layout, e);
        else {
          const se = { ...e, end: e.offset + T };
          if (updateOffset(e, T), ie = internalDeserialize(C.layout, se), se.offset !== se.end)
            throw new Error(
              `read less data than expected: ${se.offset - e.offset} < ${T}`
            );
        }
        return te !== void 0 ? typeof te.from != "function" ? (checkBytesTypeEqual(
          getCachedSerializedFrom(C),
          e.bytes,
          { dataSlize: [re, e.offset] }
        ), te.to) : te.to(ie) : ie;
      }
      const { custom: $ } = C;
      {
        let te, re;
        if (isBytesType($) ? te = $ : isFixedBytesConversion($) && (te = $.from, re = $.to), te !== void 0) {
          const ie = T ?? te.length, se = e.bytes.subarray(e.offset, e.offset + ie);
          return checkBytesTypeEqual(te, se), updateOffset(e, ie), re ?? te;
        }
      }
      const V = e.offset, J = T !== void 0 ? e.offset + T : e.end;
      updateOffset(e, J - V);
      const ee = e.bytes.subarray(V, J);
      return $ !== void 0 ? $.to(ee) : ee;
    }
    case "array": {
      let T = [];
      const { layout: $ } = C, V = () => {
        const ee = internalDeserialize($, e);
        T.push(ee);
      };
      let J = null;
      if ("length" in C && C.length !== void 0 ? J = C.length : "lengthSize" in C && C.lengthSize !== void 0 && (J = deserializeNum$1(e, C.lengthSize, C.lengthEndianness)), J !== null)
        for (let ee = 0; ee < J; ++ee)
          V();
      else
        for (; e.offset < e.end; )
          V();
      return T;
    }
    case "switch": {
      const T = deserializeNum$1(e, C.idSize, C.idEndianness), { layouts: $ } = C;
      if ($.length === 0)
        throw new Error("switch item has no layouts");
      const V = typeof $[0][0] == "number", J = $.find(([ie]) => V ? ie === T : ie[0] === T);
      if (J === void 0)
        throw new Error(`unknown id value: ${T}`);
      const [ee, te] = J, re = internalDeserialize(te, e);
      return {
        [C.idTag ?? "id"]: V ? T : ee[1],
        ...re
      };
    }
  }
}
function addFixedValues(C, e) {
  return internalAddFixedValues(C, e);
}
function internalAddFixedValuesItem(C, e) {
  switch (C.binary) {
    case "bytes":
      if ("layout" in C) {
        const { custom: T } = C;
        return T === void 0 || typeof T.from != "function" ? internalAddFixedValues(C.layout, T ? T.from : e) : e;
      }
    case "int":
    case "uint": {
      const { custom: T } = C;
      return C != null && C.omit ? void 0 : isPrimitiveType(T) ? T : isFixedPrimitiveConversion(T) ? T.to : e;
    }
    case "array":
      return Array.isArray(e) ? e.map((T) => internalAddFixedValues(C.layout, T)) : void 0;
    case "switch": {
      const T = e[C.idTag ?? "id"], [$, V] = C.layouts.find(
        ([J]) => (Array.isArray(J) ? J[1] : J) == T
      );
      return {
        [C.idTag ?? "id"]: T,
        ...internalAddFixedValues(V, e)
      };
    }
  }
}
function internalAddFixedValues(C, e) {
  if (e = e ?? {}, isItem(C))
    return internalAddFixedValuesItem(C, e);
  const T = {};
  for (const $ of C) {
    const V = internalAddFixedValuesItem(
      $,
      e[$.name] ?? {}
    );
    V !== void 0 && (T[$.name] = V);
  }
  return T;
}
function buildDiscriminator(C, e) {
  const [T, $] = internalBuildDiscriminator(C);
  if (!T && !e)
    throw new Error("Cannot uniquely distinguished the given layouts");
  return (V) => {
    const J = $(V);
    return J.length === 0 ? null : J[0];
  };
}
function arrayToBitset(C) {
  return C.reduce((e, T) => e | BigInt(1) << BigInt(T), BigInt(0));
}
function bitsetToArray(C) {
  const e = [];
  for (let T = 0n; C > 0n; C >>= 1n, ++T)
    C & 1n && e.push(Number(T));
  return e;
}
function count(C) {
  let e = 0;
  for (; C > 0n; C >>= 1n)
    e += Number(C & 1n);
  return e;
}
var lengthSizeMax = (C) => C > 0 ? 2 ** (8 * C) - 1 : 1 / 0;
function layoutItemMeta(C, e, T) {
  var $;
  switch (C.binary) {
    case "int":
    case "uint": {
      const V = isNumType(C.custom) ? C.custom : isNumType(($ = C == null ? void 0 : C.custom) == null ? void 0 : $.from) ? C.custom.from : null;
      if (V !== null && e !== null) {
        const J = { bytes: new Uint8Array(C.size), offset: 0 };
        serializeNum$1(V, C.size, J, C.endianness, C.binary === "int"), T.push([e, J.bytes]);
      }
      return [C.size, C.size];
    }
    case "bytes": {
      const V = "lengthSize" in C ? C.lengthSize | 0 : 0;
      let J, ee;
      if ("layout" in C) {
        const { custom: re } = C;
        if (re !== void 0 && typeof re.from != "function")
          J = getCachedSerializedFrom(C), ee = J.length;
        else {
          const ie = calcStaticSize(C.layout);
          ie !== null && (ee = ie);
        }
      } else {
        const { custom: re } = C;
        isBytesType(re) ? (J = re, ee = re.length) : isFixedBytesConversion(re) && (J = re.from, ee = re.from.length);
      }
      if (V > 0 && e !== null) {
        if (ee !== void 0) {
          const re = { bytes: new Uint8Array(V), offset: 0 }, ie = C.lengthEndianness;
          serializeNum$1(ee, V, re, ie, !1), T.push([e, re.bytes]);
        }
        e += V;
      }
      if (J !== void 0)
        return e !== null && T.push([e, J]), [V + J.length, V + J.length];
      const te = "size" in C && C.size !== void 0 ? [C.size, C.size] : void 0;
      if ("layout" in C) {
        const re = createLayoutMeta(C.layout, e, T);
        return te ?? [V + re[0], V + re[1]];
      }
      return te ?? [V, lengthSizeMax(V)];
    }
    case "array": {
      if ("length" in C) {
        let J = [];
        const ee = createLayoutMeta(C.layout, 0, J);
        if (e !== null)
          if (ee[0] !== ee[1]) {
            if (C.length > 0)
              for (const [te, re] of J)
                T.push([e + te, re]);
          } else
            for (let te = 0; te < C.length; ++te)
              for (const [re, ie] of J)
                T.push([e + re + te * ee[0], ie]);
        return [C.length * ee[0], C.length * ee[1]];
      }
      const V = C.lengthSize | 0;
      return [V, lengthSizeMax(V)];
    }
    case "switch": {
      const V = C.layouts.map((re) => []), { idSize: J, idEndianness: ee } = C, te = C.layouts.map(([re, ie], se) => {
        const de = Array.isArray(re) ? re[0] : re;
        if (e !== null) {
          const fe = { bytes: new Uint8Array(J), offset: 0 };
          serializeNum$1(de, J, fe, ee), V[se].push([0, fe.bytes]);
        }
        const ue = createLayoutMeta(ie, e !== null ? J : null, V[se]);
        return [ue[0] + J, ue[1] + J];
      });
      return e !== null && V.every((re) => re.length > 0) && (() => {
        const re = Math.min(
          ...V.map((se) => se.at(-1)[0] + se.at(-1)[1].length)
        ), ie = V.map((se) => 0);
        for (let se = 0; se < re; ) {
          let de = null, ue = 0;
          for (; ue < V.length; ) {
            let fe = ie[ue];
            const he = V[ue], [me, xe] = he[fe];
            if (me + xe.length <= se) {
              if (++fe, fe === he.length)
                return;
              ie[ue] = fe, se = he[fe][0];
              break;
            }
            const ve = xe[se - me];
            if (de === null && (de = ve), ve !== de) {
              ++se;
              break;
            }
            ++ue;
          }
          ue === V.length && (T.push([e + se, new Uint8Array([de])]), ++se);
        }
      })(), [
        Math.min(...te.map(([re]) => re)),
        Math.max(...te.map(([re, ie]) => ie))
      ];
    }
  }
}
function createLayoutMeta(C, e, T) {
  if (!Array.isArray(C))
    return layoutItemMeta(C, e, T);
  let $ = [0, 0];
  for (const V of C) {
    const J = layoutItemMeta(V, e, T);
    $[0] += J[0], $[1] += J[1], e !== null && (e = J[0] === J[1] ? e + J[0] : null);
  }
  return $;
}
function buildAscendingBounds(C) {
  const e = /* @__PURE__ */ new Map();
  let T = [];
  const $ = (V) => {
    for (; T.length > 0 && T[0][0] < V; ) {
      const J = T[0][0] + 1, ee = T.findIndex(([te]) => J <= te);
      ee === -1 ? T = [] : T.splice(0, ee), e.set(J, arrayToBitset(T.map(([, te]) => te)));
    }
  };
  for (const [[V, J], ee] of C) {
    $(V);
    const te = T.findIndex(([re]) => re > J);
    te === -1 ? T.push([J, ee]) : T.splice(te, 0, [J, ee]), e.set(V, arrayToBitset(T.map(([, re]) => re)));
  }
  return $(1 / 0), e;
}
function internalBuildDiscriminator(C) {
  if (C.length === 0)
    throw new Error("Cannot discriminate empty set of layouts");
  const e = 0n, T = (1n << BigInt(C.length)) - 1n, $ = C.map(() => []), V = C.map((we, Ee) => createLayoutMeta(we, 0, $[Ee])), J = V.map((we, Ee) => [we, Ee]).sort(([[we]], [[Ee]]) => we - Ee), ee = (() => {
    let we = T;
    const Ee = /* @__PURE__ */ new Map();
    for (const [[Me], Ie] of J)
      we ^= 1n << BigInt(Ie), Ee.set(Me, we);
    return Ee;
  })(), te = buildAscendingBounds(J), re = C.length - Math.max(
    ...[...te.values()].map((we) => count(we))
  ), ie = (we) => {
    let Ee = T;
    for (const [Me, Ie] of ee) {
      if (we < Me)
        break;
      Ee = Ie;
    }
    return Ee;
  }, se = (we) => {
    let Ee = e;
    for (const [Me, Ie] of te) {
      if (we < Me)
        break;
      Ee = Ie;
    }
    return Ee;
  }, de = Array.from({
    length: Math.max(...$.map((we) => we.length > 0 ? we.at(-1)[0] + we.at(-1)[1].length : 0))
  }).map(() => []);
  for (let we = 0; we < $.length; ++we)
    for (const [Ee, Me] of $[we])
      for (let Ie = 0; Ie < Me.length; ++Ie)
        de[Ee + Ie].push([Me[Ie], we]);
  let ue = [];
  for (const [we, Ee] of de.entries()) {
    const Me = ie(we), Ie = Me ^ arrayToBitset(Ee.map(([, Fe]) => Fe)), ke = T ^ Me, _e = /* @__PURE__ */ new Map();
    for (const [Fe, Ae] of Ee)
      _e.has(Fe) || _e.set(Fe, e), _e.set(Fe, _e.get(Fe) | 1n << BigInt(Ae));
    let De = C.length - Math.max(count(Ie), count(ke));
    for (const Fe of _e.values()) {
      const Ae = Ee.length - count(Fe) + count(ke);
      De = Math.min(De, Ae);
    }
    if (De !== 0) {
      if (De === C.length - 1)
        return [
          !0,
          (Fe) => bitsetToArray(
            Fe.length <= we ? ke : _e.get(Fe[we]) ?? e
          )
        ];
      ue.push([De, we, ke, _e, Ie]);
    }
  }
  if (re === C.length - 1)
    return [!0, (we) => bitsetToArray(se(we.length))];
  ue.sort(([we], [Ee]) => Ee - we);
  let fe = !0;
  const he = /* @__PURE__ */ new Map(), me = /* @__PURE__ */ new Map(), xe = (we, Ee) => {
    he.set(we, Ee), me.has(count(we)) || me.set(count(we), []), me.get(count(we)).push(we);
  }, ve = (we, Ee) => {
    if (count(we) <= 1 || he.has(we))
      return;
    let Me = 0;
    const Ie = /* @__PURE__ */ new Map();
    for (const _e of bitsetToArray(we)) {
      const De = V[_e][0], Fe = te.get(De) & we;
      Ie.set(De, Fe), Me = Math.max(Me, count(Fe));
    }
    Me = count(we) - Me;
    const ke = [];
    for (const [_e, De, Fe, Ae, ne] of Ee) {
      const oe = /* @__PURE__ */ new Map();
      let ce = 0;
      for (const [ye, Ce] of Ae) {
        const be = Ce & we;
        count(be) > 0 && (oe.set(ye, be), ce += count(be));
      }
      const le = Fe & we;
      let pe = oe.size > 0 ? _e : 0;
      for (const ye of oe.values()) {
        const Ce = ce - count(ye) + count(le);
        pe = Math.min(pe, Ce);
      }
      if (pe !== 0) {
        if (pe === count(we) - 1) {
          xe(we, [De, le, oe]);
          return;
        }
        ke.push([
          pe,
          De,
          le,
          oe,
          ne & we
        ]);
      }
    }
    if (Me === count(we) - 1) {
      xe(we, "size");
      return;
    }
    if (ke.sort(([_e], [De]) => De - _e), ke.length > 0 && ke[0][0] >= Me) {
      const [, _e, De, Fe, Ae] = ke[0];
      xe(we, [_e, De, Fe]), ve(De, ke);
      for (const ne of Fe.values())
        ve(ne | Ae, ke.slice(1));
      return;
    }
    if (Me > 0) {
      xe(we, "size");
      for (const _e of Ie.values())
        ve(_e, ke);
      return;
    }
    xe(we, "indistinguishable"), fe = !1;
  };
  ve(T, ue);
  const Te = (we) => {
    for (let Ee = count(we) + 1; Ee < C.length - 2; ++Ee)
      for (const Me of me.get(Ee) ?? [])
        if ((we & Me) == we)
          return he.get(Me);
    throw new Error("Implementation error in layout discrimination algorithm");
  };
  return [fe, (we) => {
    let Ee = T, Me = he.get(Ee);
    for (; Me !== "indistinguishable"; ) {
      if (Me === "size")
        Ee &= se(we.length);
      else {
        const [Ie, ke, _e] = Me;
        if (we.length <= Ie)
          Ee &= ke;
        else {
          const De = we[Ie];
          for (const [Fe, Ae] of _e)
            Fe !== De && (Ee ^= Ee & Ae);
          Ee ^= Ee & ke;
        }
      }
      if (count(Ee) <= 1)
        break;
      Me = he.get(Ee) ?? Te(Ee);
    }
    return bitsetToArray(Ee);
  }];
}
var customizableBytes = (C, e) => ({
  ...C,
  binary: "bytes",
  ...e === void 0 ? {} : isLayout(e) ? { layout: e } : e instanceof Uint8Array || isFixedBytesConversion(e) || !Array.isArray(e) ? { custom: e } : { layout: e[0], custom: e[1] }
});
function enumItem(C, e) {
  const T = Object.fromEntries(C.map(([V, J]) => [J, V])), $ = Object.fromEntries(C);
  return {
    binary: "uint",
    size: (e == null ? void 0 : e.size) ?? 1,
    endianness: (e == null ? void 0 : e.endianness) ?? "big",
    custom: {
      to: (V) => {
        const J = T[V];
        if (J === void 0)
          throw new Error(`Invalid enum value: ${V}`);
        return J;
      },
      from: (V) => $[V]
    }
  };
}
function bitsetItem(C, e) {
  return {
    binary: "uint",
    size: Math.ceil(C.length / 8),
    custom: {
      to: (T) => {
        const $ = {};
        for (let V = 0; V < C.length; ++V)
          C[V] && ($[C[V]] = (BigInt(T) & 1n << BigInt(V)) !== 0n);
        return $;
      },
      from: (T) => {
        let $ = 0n;
        for (let V = 0; V < C.length; ++V)
          C[V] && T[C[V]] && ($ |= 1n << BigInt(V));
        return C.length > numberMaxSize ? $ : Number($);
      }
    }
  };
}
function denoise(C, e) {
  return Number(Number(C).toFixed(e));
}
function parse$3(C, e) {
  if (validateAmountInput(C, e), C = C.toString(), C.includes("e"))
    throw new Error("Scientific notation is not supported yet by Amount");
  const T = C.split(".");
  if (T.length > 2)
    throw "Too many decimals";
  let [$, V] = T.length === 0 ? ["0", ""] : T.length === 1 ? [T[0], ""] : T;
  if (V = V.padEnd(e, "0"), V.length > e) {
    if (BigInt(V.substring(e)) !== 0n)
      throw new Error("Amount: invalid input. Decimals too low.");
    V = V.substring(0, e);
  }
  return { amount: BigInt($ + V).toString(), decimals: e };
}
function truncate(C, e) {
  if (C.decimals <= e)
    return C;
  const T = BigInt(C.decimals - e);
  return {
    amount: (units(C) / 10n ** T * 10n ** T).toString(),
    decimals: C.decimals
  };
}
function scale$1(C, e) {
  if (C.decimals === e)
    return C;
  if (C.amount === "0")
    return { amount: C.amount, decimals: e };
  const T = e - C.decimals;
  if (T > 0)
    return {
      amount: C.amount + "0".repeat(T),
      decimals: e
    };
  if (BigInt(C.amount.substring(C.amount.length + T)) === 0n)
    return {
      amount: C.amount.substring(0, C.amount.length + T),
      decimals: e
    };
  throw new Error(`scaleAmount(${JSON.stringify(C)}, ${e}) would result in altered amount. Use truncateAmount first if you intended to truncate it.`);
}
function fromBaseUnits(C, e) {
  return { amount: C.toString(), decimals: e };
}
function units(C) {
  return validateAmount$1(C), BigInt(C.amount);
}
function display(C, e) {
  validateAmount$1(C);
  let T = C.amount.substring(0, C.amount.length - C.decimals).padStart(1, "0"), $ = C.amount.substring(C.amount.length - C.decimals).padStart(C.decimals, "0");
  if (e !== void 0) {
    for (; $.length > e && $[$.length - 1] === "0"; )
      $ = $.substring(0, $.length - 1);
    $ = $.padEnd(e, "0");
  } else
    $ = $.replace(/0+$/, "");
  return $.length > 0 ? `${T}.${$}` : T;
}
function whole(C) {
  return Number(display(C));
}
function fmt(C, e) {
  return display(fromBaseUnits(C, e));
}
function validateAmountInput(C, e) {
  if (typeof C == "number") {
    if (!isFinite(C))
      throw new Error("Amount: invalid input. Amount must be finite");
    if (C < 0)
      throw new Error("Amount: invalid input. Amount cannot be negative");
  } else if (!/^[0-9\.]*$/.test(C))
    throw new Error("Amount: invalid input. Must only contain digits.");
  if (!isFinite(e))
    throw new Error("Amount: invalid input. Decimals must be finite");
}
function validateAmount$1(C) {
  if (!/^[0-9]*$/.test(C.amount))
    throw new Error("Amount: invalid input. Must only contain digits.");
  if (C.decimals < 0)
    throw new Error("Amount: invalid input. Decimals must be >= 0");
  if (!isFinite(C.decimals))
    throw new Error("Amount: invalid input. Decimals must be a finite number.");
}
/*! scure-base - MIT License (c) 2022 Paul Miller (paulmillr.com) */
function isBytes$3(C) {
  return C instanceof Uint8Array || ArrayBuffer.isView(C) && C.constructor.name === "Uint8Array";
}
function isArrayOf(C, e) {
  return Array.isArray(e) ? e.length === 0 ? !0 : C ? e.every((T) => typeof T == "string") : e.every((T) => Number.isSafeInteger(T)) : !1;
}
function afn(C) {
  if (typeof C != "function")
    throw new Error("function expected");
  return !0;
}
function astr(C, e) {
  if (typeof e != "string")
    throw new Error(`${C}: string expected`);
  return !0;
}
function anumber$2(C) {
  if (!Number.isSafeInteger(C))
    throw new Error(`invalid integer: ${C}`);
}
function aArr(C) {
  if (!Array.isArray(C))
    throw new Error("array expected");
}
function astrArr(C, e) {
  if (!isArrayOf(!0, e))
    throw new Error(`${C}: array of strings expected`);
}
function anumArr(C, e) {
  if (!isArrayOf(!1, e))
    throw new Error(`${C}: array of numbers expected`);
}
// @__NO_SIDE_EFFECTS__
function chain(...C) {
  const e = (J) => J, T = (J, ee) => (te) => J(ee(te)), $ = C.map((J) => J.encode).reduceRight(T, e), V = C.map((J) => J.decode).reduce(T, e);
  return { encode: $, decode: V };
}
// @__NO_SIDE_EFFECTS__
function alphabet(C) {
  const e = typeof C == "string" ? C.split("") : C, T = e.length;
  astrArr("alphabet", e);
  const $ = new Map(e.map((V, J) => [V, J]));
  return {
    encode: (V) => (aArr(V), V.map((J) => {
      if (!Number.isSafeInteger(J) || J < 0 || J >= T)
        throw new Error(`alphabet.encode: digit index outside alphabet "${J}". Allowed: ${C}`);
      return e[J];
    })),
    decode: (V) => (aArr(V), V.map((J) => {
      astr("alphabet.decode", J);
      const ee = $.get(J);
      if (ee === void 0)
        throw new Error(`Unknown letter: "${J}". Allowed: ${C}`);
      return ee;
    }))
  };
}
// @__NO_SIDE_EFFECTS__
function join(C = "") {
  return astr("join", C), {
    encode: (e) => (astrArr("join.decode", e), e.join(C)),
    decode: (e) => (astr("join.decode", e), e.split(C))
  };
}
// @__NO_SIDE_EFFECTS__
function padding(C, e = "=") {
  return anumber$2(C), astr("padding", e), {
    encode(T) {
      for (astrArr("padding.encode", T); T.length * C % 8; )
        T.push(e);
      return T;
    },
    decode(T) {
      astrArr("padding.decode", T);
      let $ = T.length;
      if ($ * C % 8)
        throw new Error("padding: invalid, string should have whole number of bytes");
      for (; $ > 0 && T[$ - 1] === e; $--)
        if (($ - 1) * C % 8 === 0)
          throw new Error("padding: invalid, string has too much padding");
      return T.slice(0, $);
    }
  };
}
function convertRadix(C, e, T) {
  if (e < 2)
    throw new Error(`convertRadix: invalid from=${e}, base cannot be less than 2`);
  if (T < 2)
    throw new Error(`convertRadix: invalid to=${T}, base cannot be less than 2`);
  if (aArr(C), !C.length)
    return [];
  let $ = 0;
  const V = [], J = Array.from(C, (te) => {
    if (anumber$2(te), te < 0 || te >= e)
      throw new Error(`invalid integer: ${te}`);
    return te;
  }), ee = J.length;
  for (; ; ) {
    let te = 0, re = !0;
    for (let ie = $; ie < ee; ie++) {
      const se = J[ie], de = e * te, ue = de + se;
      if (!Number.isSafeInteger(ue) || de / e !== te || ue - se !== de)
        throw new Error("convertRadix: carry overflow");
      const fe = ue / T;
      te = ue % T;
      const he = Math.floor(fe);
      if (J[ie] = he, !Number.isSafeInteger(he) || he * T + te !== ue)
        throw new Error("convertRadix: carry overflow");
      if (re)
        he ? re = !1 : $ = ie;
      else continue;
    }
    if (V.push(te), re)
      break;
  }
  for (let te = 0; te < C.length - 1 && C[te] === 0; te++)
    V.push(0);
  return V.reverse();
}
const gcd = (C, e) => e === 0 ? C : gcd(e, C % e), radix2carry = /* @__NO_SIDE_EFFECTS__ */ (C, e) => C + (e - gcd(C, e)), powers = /* @__PURE__ */ (() => {
  let C = [];
  for (let e = 0; e < 40; e++)
    C.push(2 ** e);
  return C;
})();
function convertRadix2(C, e, T, $) {
  if (aArr(C), e <= 0 || e > 32)
    throw new Error(`convertRadix2: wrong from=${e}`);
  if (T <= 0 || T > 32)
    throw new Error(`convertRadix2: wrong to=${T}`);
  if (/* @__PURE__ */ radix2carry(e, T) > 32)
    throw new Error(`convertRadix2: carry overflow from=${e} to=${T} carryBits=${/* @__PURE__ */ radix2carry(e, T)}`);
  let V = 0, J = 0;
  const ee = powers[e], te = powers[T] - 1, re = [];
  for (const ie of C) {
    if (anumber$2(ie), ie >= ee)
      throw new Error(`convertRadix2: invalid data word=${ie} from=${e}`);
    if (V = V << e | ie, J + e > 32)
      throw new Error(`convertRadix2: carry overflow pos=${J} from=${e}`);
    for (J += e; J >= T; J -= T)
      re.push((V >> J - T & te) >>> 0);
    const se = powers[J];
    if (se === void 0)
      throw new Error("invalid carry");
    V &= se - 1;
  }
  if (V = V << T - J & te, !$ && J >= e)
    throw new Error("Excess padding");
  if (!$ && V > 0)
    throw new Error(`Non-zero padding: ${V}`);
  return $ && J > 0 && re.push(V >>> 0), re;
}
// @__NO_SIDE_EFFECTS__
function radix(C) {
  anumber$2(C);
  const e = 2 ** 8;
  return {
    encode: (T) => {
      if (!isBytes$3(T))
        throw new Error("radix.encode input should be Uint8Array");
      return convertRadix(Array.from(T), e, C);
    },
    decode: (T) => (anumArr("radix.decode", T), Uint8Array.from(convertRadix(T, C, e)))
  };
}
// @__NO_SIDE_EFFECTS__
function radix2(C, e = !1) {
  if (anumber$2(C), C <= 0 || C > 32)
    throw new Error("radix2: bits should be in (0..32]");
  if (/* @__PURE__ */ radix2carry(8, C) > 32 || /* @__PURE__ */ radix2carry(C, 8) > 32)
    throw new Error("radix2: carry overflow");
  return {
    encode: (T) => {
      if (!isBytes$3(T))
        throw new Error("radix2.encode input should be Uint8Array");
      return convertRadix2(Array.from(T), 8, C, !e);
    },
    decode: (T) => (anumArr("radix2.decode", T), Uint8Array.from(convertRadix2(T, C, 8, e)))
  };
}
function unsafeWrapper(C) {
  return afn(C), function(...e) {
    try {
      return C.apply(null, e);
    } catch {
    }
  };
}
function checksum(C, e) {
  return anumber$2(C), afn(e), {
    encode(T) {
      if (!isBytes$3(T))
        throw new Error("checksum.encode: input should be Uint8Array");
      const $ = e(T).slice(0, C), V = new Uint8Array(T.length + C);
      return V.set(T), V.set($, T.length), V;
    },
    decode(T) {
      if (!isBytes$3(T))
        throw new Error("checksum.decode: input should be Uint8Array");
      const $ = T.slice(0, -C), V = T.slice(-C), J = e($).slice(0, C);
      for (let ee = 0; ee < C; ee++)
        if (J[ee] !== V[ee])
          throw new Error("Invalid checksum");
      return $;
    }
  };
}
const base16 = /* @__PURE__ */ chain(/* @__PURE__ */ radix2(4), /* @__PURE__ */ alphabet("0123456789ABCDEF"), /* @__PURE__ */ join("")), base64$1 = /* @__PURE__ */ chain(/* @__PURE__ */ radix2(6), /* @__PURE__ */ alphabet("ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/"), /* @__PURE__ */ padding(6), /* @__PURE__ */ join("")), genBase58 = /* @__NO_SIDE_EFFECTS__ */ (C) => /* @__PURE__ */ chain(/* @__PURE__ */ radix(58), /* @__PURE__ */ alphabet(C), /* @__PURE__ */ join("")), base58 = /* @__PURE__ */ genBase58("123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz"), createBase58check = (C) => /* @__PURE__ */ chain(checksum(4, (e) => C(C(e))), base58), BECH_ALPHABET = /* @__PURE__ */ chain(/* @__PURE__ */ alphabet("qpzry9x8gf2tvdw0s3jn54khce6mua7l"), /* @__PURE__ */ join("")), POLYMOD_GENERATORS = [996825010, 642813549, 513874426, 1027748829, 705979059];
function bech32Polymod(C) {
  const e = C >> 25;
  let T = (C & 33554431) << 5;
  for (let $ = 0; $ < POLYMOD_GENERATORS.length; $++)
    (e >> $ & 1) === 1 && (T ^= POLYMOD_GENERATORS[$]);
  return T;
}
function bechChecksum(C, e, T = 1) {
  const $ = C.length;
  let V = 1;
  for (let J = 0; J < $; J++) {
    const ee = C.charCodeAt(J);
    if (ee < 33 || ee > 126)
      throw new Error(`Invalid prefix (${C})`);
    V = bech32Polymod(V) ^ ee >> 5;
  }
  V = bech32Polymod(V);
  for (let J = 0; J < $; J++)
    V = bech32Polymod(V) ^ C.charCodeAt(J) & 31;
  for (let J of e)
    V = bech32Polymod(V) ^ J;
  for (let J = 0; J < 6; J++)
    V = bech32Polymod(V);
  return V ^= T, BECH_ALPHABET.encode(convertRadix2([V % powers[30]], 30, 5, !1));
}
// @__NO_SIDE_EFFECTS__
function genBech32(C) {
  const e = C === "bech32" ? 1 : 734539939, T = /* @__PURE__ */ radix2(5), $ = T.decode, V = T.encode, J = unsafeWrapper($);
  function ee(de, ue, fe = 90) {
    astr("bech32.encode prefix", de), isBytes$3(ue) && (ue = Array.from(ue)), anumArr("bech32.encode", ue);
    const he = de.length;
    if (he === 0)
      throw new TypeError(`Invalid prefix length ${he}`);
    const me = he + 7 + ue.length;
    if (fe !== !1 && me > fe)
      throw new TypeError(`Length ${me} exceeds limit ${fe}`);
    const xe = de.toLowerCase(), ve = bechChecksum(xe, ue, e);
    return `${xe}1${BECH_ALPHABET.encode(ue)}${ve}`;
  }
  function te(de, ue = 90) {
    astr("bech32.decode input", de);
    const fe = de.length;
    if (fe < 8 || ue !== !1 && fe > ue)
      throw new TypeError(`invalid string length: ${fe} (${de}). Expected (8..${ue})`);
    const he = de.toLowerCase();
    if (de !== he && de !== de.toUpperCase())
      throw new Error("String must be lowercase or uppercase");
    const me = he.lastIndexOf("1");
    if (me === 0 || me === -1)
      throw new Error('Letter "1" must be present between prefix and data only');
    const xe = he.slice(0, me), ve = he.slice(me + 1);
    if (ve.length < 6)
      throw new Error("Data must be at least 6 characters long");
    const Te = BECH_ALPHABET.decode(ve).slice(0, -6), we = bechChecksum(xe, Te, e);
    if (!ve.endsWith(we))
      throw new Error(`Invalid checksum in ${de}: expected "${we}"`);
    return { prefix: xe, words: Te };
  }
  const re = unsafeWrapper(te);
  function ie(de) {
    const { prefix: ue, words: fe } = te(de, !1);
    return { prefix: ue, words: fe, bytes: $(fe) };
  }
  function se(de, ue) {
    return ee(de, V(ue));
  }
  return {
    encode: ee,
    decode: te,
    encodeFromBytes: se,
    decodeToBytes: ie,
    decodeUnsafe: re,
    fromWords: $,
    fromWordsUnsafe: J,
    toWords: V
  };
}
const bech32 = /* @__PURE__ */ genBech32("bech32"), stripPrefix = (C, e) => e.startsWith(C) ? e.slice(C.length) : e, isHexRegex = /^(?:0x)?[0-9a-fA-F]+$/, hex$1 = {
  /** check if a string is valid hex */
  valid: (C) => isHexRegex.test(C),
  /** decode a hex string to Uint8Array */
  decode: (C) => base16.decode(stripPrefix("0x", C).toUpperCase()),
  /** encode a string or Uint8Array to hex */
  encode: (C, e = !1) => (C = typeof C == "string" ? bytes.encode(C) : C, (e ? "0x" : "") + base16.encode(C).toLowerCase())
}, isB64Regex = /^(?:[A-Za-z0-9+/]{4})*(?:[A-Za-z0-9+/]{2}==|[A-Za-z0-9+/]{3}=)?$/, b64 = {
  /** check if a string is valid base64 */
  valid: (C) => isB64Regex.test(C),
  /** decode a base64 string to Uint8Array */
  decode: base64$1.decode,
  /** encode a string or Uint8Array to base64 */
  encode: (C) => base64$1.encode(typeof C == "string" ? bytes.encode(C) : C)
}, b58 = {
  /** decode a base58 string to Uint8Array */
  decode: base58.decode,
  /** encode a string or Uint8Array to base58 */
  encode: (C) => base58.encode(typeof C == "string" ? bytes.encode(C) : C)
}, bignum = {
  /** decode a hex string or bytes to a bigint */
  decode: (C) => (typeof C != "string" && (C = hex$1.encode(C, !0)), C === "" || C === "0x" ? 0n : BigInt(C)),
  /** encode a bigint as a hex string */
  encode: (C, e = !1) => bignum.toString(C, e),
  /** convert a bigint to a hexstring */
  toString: (C, e = !1) => {
    let T = C.toString(16);
    return T = T.length % 2 === 1 ? T = "0" + T : T, e ? "0x" + T : T;
  },
  /** convert a bigint or number to bytes,
   *   optionally specify length, left padded with 0s to length
   */
  toBytes: (C, e) => {
    typeof C == "number" && (C = bignum.toBigInt(C));
    const T = hex$1.decode(bignum.toString(C));
    if (!e)
      return T;
    if (e < T.length)
      throw new Error(`Can't fit ${C} into ${e} bytes.`);
    return bytes.zpad(T, e);
  },
  /** safe cast from bigint to number */
  toNumber: (C) => {
    if (C > BigInt(Number.MAX_SAFE_INTEGER))
      throw new Error(`Invalid cast: ${C} exceeds MAX_SAFE_INTEGER`);
    return Number(C);
  },
  /** safe cast from number to bigint */
  toBigInt: (C) => {
    if (C > Number.MAX_SAFE_INTEGER)
      throw new Error(`Invalid cast: ${C} exceeds MAX_SAFE_INTEGER`);
    return BigInt(C);
  }
}, bytes = {
  /** encode a string to Uint8Array */
  encode: (C) => new TextEncoder().encode(C),
  /** decode a Uint8Array to string */
  decode: (C) => new TextDecoder().decode(C),
  /** compare two Uint8Arrays for equality */
  equals: (C, e) => C.length === e.length && C.every((T, $) => T === e[$]),
  /** pad a Uint8Array to a given length, optionally specifying padding direction */
  zpad: (C, e, T = !0) => T ? bytes.concat(new Uint8Array(e - C.length), C) : bytes.concat(C, new Uint8Array(e - C.length)),
  /** concatenate multiple Uint8Arrays into a single Uint8Array */
  concat: (...C) => {
    const e = C.reduce((V, J) => V + J.length, 0), T = new Uint8Array(e);
    let $ = 0;
    return C.forEach((V) => {
      T.set(V, $), $ += V.length;
    }), T;
  }
}, chainIdAndChainEntries = [
  //Unlike the old sdk, we are not including an "Unset" chain with chainId 0 here because:
  //  * no other types would be associated with it (such as contracts or a platform)
  //  * avoids awkward "chain but not 'Unset'" checks
  //  * "off" is not a TV channel either
  //Instead we'll use `null` for chain and 0 as the chainId where appropriate (e.g. governance VAAs)
  [1, "Solana"],
  [2, "Ethereum"],
  [3, "Terra"],
  [4, "Bsc"],
  [5, "Polygon"],
  [6, "Avalanche"],
  [7, "Oasis"],
  [8, "Algorand"],
  [9, "Aurora"],
  [10, "Fantom"],
  [11, "Karura"],
  [12, "Acala"],
  [13, "Klaytn"],
  [14, "Celo"],
  [15, "Near"],
  [16, "Moonbeam"],
  [17, "Neon"],
  [18, "Terra2"],
  [19, "Injective"],
  [20, "Osmosis"],
  [21, "Sui"],
  [22, "Aptos"],
  [23, "Arbitrum"],
  [24, "Optimism"],
  [25, "Gnosis"],
  [26, "Pythnet"],
  [28, "Xpla"],
  [29, "Btc"],
  [30, "Base"],
  [32, "Sei"],
  [33, "Rootstock"],
  [34, "Scroll"],
  [35, "Mantle"],
  [36, "Blast"],
  [37, "Xlayer"],
  [38, "Linea"],
  [39, "Berachain"],
  [40, "Seievm"],
  [43, "Snaxchain"],
  [44, "Unichain"],
  [45, "Worldchain"],
  [46, "Ink"],
  [47, "HyperEVM"],
  [3104, "Wormchain"],
  [4e3, "Cosmoshub"],
  [4001, "Evmos"],
  [4002, "Kujira"],
  [4003, "Neutron"],
  [4004, "Celestia"],
  [4005, "Stargaze"],
  [4006, "Seda"],
  [4007, "Dymension"],
  [4008, "Provenance"],
  [4009, "Noble"],
  [10002, "Sepolia"],
  [10003, "ArbitrumSepolia"],
  [10004, "BaseSepolia"],
  [10005, "OptimismSepolia"],
  [10006, "Holesky"],
  [10007, "PolygonSepolia"],
  [10008, "MonadDevnet"]
], [chainIds, chains$4] = zip(chainIdAndChainEntries), chainToChainId = constMap(chainIdAndChainEntries, [1, 0]), chainIdToChain = constMap(chainIdAndChainEntries), isChain = (C) => chainToChainId.has(C), isChainId = (C) => chainIdToChain.has(C), toChainId = (C) => {
  switch (typeof C) {
    case "string":
      if (isChain(C))
        return chainToChainId(C);
      break;
    case "number":
      if (isChainId(C))
        return C;
      break;
  }
  throw Error(`Cannot convert to ChainId: ${C}`);
}, toChain = (C) => {
  switch (typeof C) {
    case "string":
      if (isChain(C))
        return C;
      break;
    case "number":
      if (isChainId(C))
        return chainIdToChain(C);
      break;
    case "bigint":
      if (isChainId(Number(C)))
        return chainIdToChain.get(Number(C));
      break;
  }
  throw Error(`Cannot convert to Chain: ${C}`);
}, platformAndChainsEntries = [
  [
    "Evm",
    [
      "Acala",
      "Arbitrum",
      "Aurora",
      "Avalanche",
      "Base",
      "Bsc",
      "Celo",
      "Ethereum",
      "Fantom",
      "Gnosis",
      "Karura",
      "Klaytn",
      "Moonbeam",
      "Neon",
      "Oasis",
      "Optimism",
      "Polygon",
      "Rootstock",
      "Sepolia",
      "ArbitrumSepolia",
      "BaseSepolia",
      "OptimismSepolia",
      "Holesky",
      "PolygonSepolia",
      "Mantle",
      "Scroll",
      "Blast",
      "Xlayer",
      "Linea",
      "Berachain",
      "Seievm",
      "Snaxchain",
      "Unichain",
      "Worldchain",
      "Ink",
      "HyperEVM",
      "MonadDevnet"
    ]
  ],
  [
    "Solana",
    [
      "Solana",
      "Pythnet"
    ]
  ],
  [
    "Cosmwasm",
    [
      "Cosmoshub",
      "Evmos",
      "Injective",
      "Kujira",
      "Osmosis",
      "Sei",
      "Terra",
      "Terra2",
      "Wormchain",
      "Xpla",
      "Dymension",
      "Neutron",
      "Stargaze",
      "Celestia",
      "Seda",
      "Provenance",
      "Noble"
    ]
  ],
  [
    "Btc",
    [
      "Btc"
    ]
  ],
  [
    "Algorand",
    [
      "Algorand"
    ]
  ],
  [
    "Sui",
    [
      "Sui"
    ]
  ],
  [
    "Aptos",
    [
      "Aptos"
    ]
  ],
  [
    "Near",
    [
      "Near"
    ]
  ]
];
column(platformAndChainsEntries, 0);
const platformToChains = constMap(platformAndChainsEntries), chainToPlatform = constMap(platformAndChainsEntries, [1, 0]), platformAddressFormatEntries = [
  ["Evm", "hex"],
  ["Solana", "base58"],
  ["Cosmwasm", "bech32"],
  ["Btc", "bech32"],
  //though we currently don't have any btc addresses
  ["Algorand", "algorandAppId"],
  ["Sui", "hex"],
  ["Aptos", "hex"],
  ["Near", "sha256"]
], platformToAddressFormat = constMap(platformAddressFormatEntries), filters = {
  byAddress: (C, e) => Object.values(C).find((T) => isEqualCaseInsensitive(T.address, e)),
  native: (C) => filters.byAddress(C, "native"),
  bySymbol: (C, e) => {
    const T = Object.values(C).filter(($) => $.symbol === e);
    return T && T.length > 0 ? T : void 0;
  },
  byKey: (C, e) => {
    const T = Object.entries(C).find(([$]) => e === $);
    return T ? T[1] : void 0;
  }
}, isEqualCaseInsensitive = (C, e) => C.toLowerCase() === e.toLowerCase();
var ConsistencyLevels;
(function(C) {
  C[C.Finalized = 1] = "Finalized", C[C.Immediate = 200] = "Immediate", C[C.Safe = 201] = "Safe";
})(ConsistencyLevels || (ConsistencyLevels = {}));
const safeThresholds = [
  ["Ethereum", 32]
  // number of rounds in an epoch
];
constMap(safeThresholds);
const finalityThresholds = [
  ["Solana", 32],
  ["Ethereum", 72],
  // between 64 and 95 blocks; use 72 as a middle ground
  ["Bsc", 15],
  // Check-pointed to L1 after ~512 blocks
  ["Optimism", 512],
  ["Base", 512],
  ["Arbitrum", 4096],
  // TODO: validate, this is inferred from vaa metrics timing
  ["Blast", 512],
  ["Xlayer", 300],
  ["Scroll", 300],
  ["Mantle", 512],
  ["Worldchain", 512],
  // Check-pointed after 32 blocks
  ["Polygon", 32],
  // Single block finality
  ["Fantom", 1],
  ["Celo", 1],
  ["Moonbeam", 1],
  ["Karura", 1],
  ["Acala", 1],
  ["Oasis", 1],
  // Instant finality
  ["Avalanche", 0],
  ["Sui", 0],
  ["Algorand", 0],
  ["Aptos", 0],
  ["Klaytn", 0],
  ["Sei", 0],
  ["Near", 0],
  ["Osmosis", 0],
  ["Terra", 0],
  ["Terra2", 0],
  ["Xpla", 0],
  ["Injective", 0],
  ["Berachain", 1],
  ["Seievm", 1],
  ["Snaxchain", 512],
  ["Unichain", 512],
  ["Ink", 512],
  ["HyperEVM", 1],
  ["Cosmoshub", 0],
  ["Evmos", 0],
  ["Kujira", 0],
  ["Neutron", 0],
  ["Celestia", 0],
  ["Stargaze", 0],
  ["Dymension", 0],
  ["Provenance", 0],
  ["Noble", 0],
  // Testnets
  ["Sepolia", 72],
  ["ArbitrumSepolia", 4096],
  ["BaseSepolia", 512],
  ["OptimismSepolia", 512],
  ["PolygonSepolia", 32],
  ["MonadDevnet", 1]
], finalityThreshold = constMap(finalityThresholds), blockTimeMilliseconds = [
  ["Acala", 12e3],
  ["Algorand", 3300],
  ["Aptos", 4e3],
  ["Arbitrum", 260],
  ["ArbitrumSepolia", 260],
  ["Aurora", 3e3],
  ["Avalanche", 2e3],
  ["Base", 2e3],
  ["BaseSepolia", 2e3],
  ["Blast", 2e3],
  ["Bsc", 3e3],
  ["Celo", 5e3],
  ["Cosmoshub", 5e3],
  ["Ethereum", 15e3],
  ["Evmos", 2e3],
  ["Fantom", 2500],
  ["Gnosis", 5e3],
  ["Holesky", 15e3],
  ["Injective", 2500],
  ["Karura", 12e3],
  ["Klaytn", 1e3],
  ["Kujira", 3e3],
  ["Mantle", 2e3],
  ["Moonbeam", 12e3],
  ["MonadDevnet", 1e3],
  ["Near", 1500],
  ["Neon", 3e4],
  ["Oasis", 6e3],
  ["Optimism", 2e3],
  ["OptimismSepolia", 2e3],
  ["Osmosis", 6e3],
  ["Polygon", 2e3],
  ["PolygonSepolia", 2e3],
  ["Rootstock", 3e4],
  ["Scroll", 3e3],
  ["Sei", 400],
  ["Sepolia", 15e3],
  ["Solana", 400],
  ["Sui", 3e3],
  ["Terra", 6e3],
  ["Terra2", 6e3],
  ["Xpla", 5e3],
  ["Xlayer", 3e3],
  ["Worldchain", 2e3],
  ["Wormchain", 5e3],
  ["Btc", 6e5],
  ["Pythnet", 400],
  ["Dymension", 5e3],
  ["Celestia", 5e3],
  ["Neutron", 5e3],
  ["Stargaze", 5e3],
  ["Seda", 7500]
], blockTime = constMap(blockTimeMilliseconds);
function estimateFinalityTime(C) {
  const e = finalityThreshold.get(C);
  if (e === void 0)
    throw new Error("Cannot find finality for " + C);
  const T = blockTime.get(C);
  if (T === void 0)
    throw new Error("Cannot find block time for " + C);
  return e * T;
}
const nativeDecimalEntries = [
  ["Evm", 18],
  ["Solana", 9],
  ["Sui", 9],
  ["Aptos", 8],
  ["Cosmwasm", 6],
  ["Algorand", 6],
  ["Btc", 8],
  ["Near", 12]
], nativeDecimals = constMap(nativeDecimalEntries), explorerConfig = [
  [
    "Mainnet",
    [
      [
        "Ethereum",
        {
          name: "Etherscan",
          baseUrl: "https://etherscan.io/",
          endpoints: {
            tx: "tx/",
            account: "address/"
          }
        }
      ],
      [
        "Solana",
        {
          name: "Solana Explorer",
          baseUrl: "https://explorer.solana.com/",
          endpoints: {
            tx: "tx/",
            account: "address/"
          }
        }
      ],
      [
        "Polygon",
        {
          name: "PolygonScan",
          baseUrl: "https://polygonscan.com/",
          endpoints: {
            tx: "tx/",
            account: "address/"
          }
        }
      ],
      [
        "Bsc",
        {
          name: "BscScan",
          baseUrl: "https://bscscan.com/",
          endpoints: {
            tx: "tx/",
            account: "address/"
          }
        }
      ],
      [
        "Avalanche",
        {
          name: "Snowtrace",
          baseUrl: "https://snowtrace.io/",
          endpoints: {
            tx: "tx/",
            account: "address/"
          }
        }
      ],
      [
        "Fantom",
        {
          name: "FTMscan",
          baseUrl: "https://ftmscan.com/",
          endpoints: {
            tx: "tx/",
            account: "address/"
          }
        }
      ],
      [
        "Celo",
        {
          name: "Celo Explorer",
          baseUrl: "https://explorer.celo.org/mainnet/",
          endpoints: {
            tx: "tx/",
            account: "address/"
          }
        }
      ],
      [
        "Moonbeam",
        {
          name: "Moonscan",
          baseUrl: "https://moonscan.io/",
          endpoints: {
            tx: "tx/",
            account: "address/"
          }
        }
      ],
      [
        "Sui",
        {
          name: "Sui Explorer",
          baseUrl: "https://explorer.sui.io/",
          endpoints: {
            tx: "txblock/",
            account: "address/"
          }
        }
      ],
      [
        "Aptos",
        {
          name: "Aptos Explorer",
          baseUrl: "https://explorer.aptoslabs.com/",
          endpoints: {
            tx: "txn/",
            account: "account/"
          }
        }
      ],
      [
        "Sei",
        {
          name: "Sei Explorer",
          baseUrl: "https://sei.explorers.guru/",
          endpoints: {
            tx: "transaction/",
            account: "address/"
          }
        }
      ],
      [
        "Karura",
        {
          name: "Karura Explorer",
          baseUrl: "https://blockscout.karura.network/",
          endpoints: {
            tx: "tx/",
            account: "address/"
          }
        }
      ],
      [
        "Acala",
        {
          name: "Acala Explorer",
          baseUrl: "https://blockscout.acala.network/",
          endpoints: {
            tx: "tx/",
            account: "address/"
          }
        }
      ]
    ]
  ],
  [
    "Testnet",
    [
      [
        "Ethereum",
        {
          name: "Etherscan",
          baseUrl: "https://goerli.etherscan.io/",
          endpoints: {
            tx: "tx/",
            account: "address/"
          }
        }
      ],
      [
        "Polygon",
        {
          name: "PolygonScan",
          baseUrl: "https://mumbai.polygonscan.com/",
          endpoints: {
            tx: "tx/",
            account: "address/"
          }
        }
      ],
      [
        "Bsc",
        {
          name: "BscScan",
          baseUrl: "https://testnet.bscscan.com/",
          endpoints: {
            tx: "tx/",
            account: "address/"
          }
        }
      ],
      [
        "Avalanche",
        {
          name: "Snowtrace",
          baseUrl: "https://testnet.snowtrace.io/",
          endpoints: {
            tx: "tx/",
            account: "address/"
          }
        }
      ],
      [
        "Fantom",
        {
          name: "FTMscan",
          baseUrl: "https://testnet.ftmscan.com/",
          endpoints: {
            tx: "tx/",
            account: "address/"
          }
        }
      ],
      [
        "Celo",
        {
          name: "Celo Explorer",
          baseUrl: "https://explorer.celo.org/alfajores/",
          endpoints: {
            tx: "tx/",
            account: "address/"
          }
        }
      ],
      [
        "Moonbeam",
        {
          name: "Moonscan",
          baseUrl: "https://moonbase.moonscan.io/",
          endpoints: {
            tx: "tx/",
            account: "address/"
          }
        }
      ],
      [
        "Solana",
        {
          name: "Solana Explorer",
          baseUrl: "https://explorer.solana.com/",
          endpoints: {
            tx: "tx/",
            account: "address/"
          },
          networkQuery: {
            default: "Devnet",
            Testnet: "?cluster=testnet",
            Devnet: "?cluster=devnet"
          }
        }
      ],
      [
        "Sui",
        {
          name: "Sui Explorer",
          baseUrl: "https://explorer.sui.io/",
          endpoints: {
            tx: "txblock/",
            account: "address/"
          },
          networkQuery: {
            default: "Testnet",
            Testnet: "?network=testnet",
            Devnet: "?network=devnet"
          }
        }
      ],
      [
        "Aptos",
        {
          name: "Aptos Explorer",
          baseUrl: "https://explorer.aptoslabs.com/",
          endpoints: {
            tx: "txn/",
            account: "account/"
          },
          networkQuery: {
            default: "Testnet",
            Testnet: "?network=testnet",
            Devnet: "?network=devnet"
          }
        }
      ],
      [
        "Sei",
        {
          name: "Sei Explorer",
          baseUrl: "https://sei.explorers.guru/",
          endpoints: {
            tx: "transaction/",
            account: "address/"
          }
        }
      ],
      [
        "Karura",
        {
          name: "Karura Explorer",
          baseUrl: "https://blockscout.karura-testnet.aca-staging.network/",
          endpoints: {
            tx: "tx/",
            account: "address/"
          }
        }
      ],
      [
        "Acala",
        {
          name: "Acala Explorer",
          baseUrl: "https://blockscout.acala-dev.aca-dev.network/",
          endpoints: {
            tx: "tx/",
            account: "address/"
          }
        }
      ]
    ]
  ]
], explorerConfs = constMap(explorerConfig), explorerConfigs = (C, e) => C === "Devnet" ? void 0 : explorerConfs.get(C, e), rpcConfig = [
  [
    "Mainnet",
    [
      ["Ethereum", "https://rpc.ankr.com/eth"],
      ["Solana", "https://api.mainnet-beta.solana.com"],
      ["Polygon", "https://rpc.ankr.com/polygon"],
      ["Bsc", "https://bscrpc.com"],
      ["Avalanche", "https://rpc.ankr.com/avalanche"],
      ["Fantom", "https://rpc.ankr.com/fantom"],
      ["Celo", "https://rpc.ankr.com/celo"],
      ["Moonbeam", "https://rpc.ankr.com/moonbeam"],
      ["Sui", "https://rpc.mainnet.sui.io"],
      ["Aptos", "https://fullnode.mainnet.aptoslabs.com/v1"],
      ["Arbitrum", "https://arb1.arbitrum.io/rpc"],
      ["Optimism", "https://mainnet.optimism.io"],
      ["Base", "https://mainnet.base.org"],
      ["Osmosis", "https://osmosis-rpc.polkachu.com"],
      ["Cosmoshub", "https://cosmos-rpc.publicnode.com:443"],
      ["Evmos", "https://evmos-rpc.polkachu.com"],
      ["Injective", "https://sentry.tm.injective.network"],
      ["Wormchain", "https://wormchain-rpc.quickapi.com"],
      ["Xpla", "https://dimension-rpc.xpla.dev"],
      ["Sei", "https://sei-rpc.polkachu.com/"],
      ["Algorand", "https://mainnet-api.algonode.cloud"],
      ["Terra", "https://terra-classic-rpc.publicnode.com"],
      ["Terra2", "https://terra-rpc.polkachu.com"],
      ["Karura", "https://eth-rpc-karura.aca-api.network"],
      ["Acala", "https://eth-rpc-acala.aca-api.network"],
      ["Oasis", "https://emerald.oasis.dev"],
      ["Dymension", "https://dymension-rpc.polkachu.com/"],
      ["Stargaze", "https://stargaze-rpc.polkachu.com/"],
      ["Celestia", "https://celestia-rpc.polkachu.com/"],
      ["Neutron", "https://neutron-rpc.polkachu.com/"],
      ["Blast", "https://rpc.blast.io"],
      ["Provenance", "https://rpc.provenance.io/"],
      ["Noble", "https://noble-rpc.polkachu.com/"],
      ["Linea", "https://rpc.linea.build"],
      ["Scroll", "https://rpc.ankr.com/scroll"],
      ["Xlayer", "https://xlayerrpc.okx.com/"],
      ["Gnosis", "https://rpc.ankr.com/gnosis"],
      ["Rootstock", "https://public-node.rsk.co"],
      ["Mantle", "https://rpc.mantle.xyz"],
      ["Klaytn", "https://rpc.ankr.com/klaytn"],
      ["Snaxchain", "https://mainnet.snaxchain.io"],
      ["Worldchain", "https://worldchain-mainnet.g.alchemy.com/public"]
    ]
  ],
  [
    "Testnet",
    [
      ["Ethereum", "https://eth-goerli.public.blastapi.io"],
      ["Polygon", "https://rpc-mumbai.polygon.technology"],
      ["Bsc", "https://data-seed-prebsc-1-s3.binance.org:8545"],
      ["Avalanche", "https://api.avax-test.network/ext/bc/C/rpc"],
      ["Fantom", "https://rpc.ankr.com/fantom_testnet"],
      ["Celo", "https://alfajores-forno.celo-testnet.org"],
      ["Solana", "https://api.devnet.solana.com"],
      ["Oasis", "https://testnet.emerald.oasis.io"],
      ["Moonbeam", "https://rpc.api.moonbase.moonbeam.network"],
      ["Sui", "https://fullnode.testnet.sui.io"],
      ["Aptos", "https://fullnode.testnet.aptoslabs.com/v1"],
      ["Sei", "https://sei-testnet-rpc.polkachu.com"],
      ["Arbitrum", "https://arbitrum-goerli.public.blastapi.io"],
      ["Optimism", "https://optimism-goerli.public.blastapi.io"],
      ["Base", "https://base-goerli.public.blastapi.io"],
      ["Injective", "https://testnet.sentry.tm.injective.network"],
      ["Osmosis", "https://rpc.testnet.osmosis.zone"],
      ["Cosmoshub", "https://rpc.sentry-02.theta-testnet.polypore.xyz"],
      ["Evmos", "https://evmos-testnet-rpc.polkachu.com"],
      ["Wormchain", "https://gateway.testnet.xlabs.xyz/"],
      ["Xpla", "https://cube-rpc.xpla.dev"],
      ["Sepolia", "https://ethereum-sepolia.publicnode.com"],
      ["Algorand", "https://testnet-api.algonode.cloud"],
      ["Terra", "https://bombay.stakesystems.io"],
      ["Terra2", "https://terra-testnet-rpc.polkachu.com"],
      ["ArbitrumSepolia", "https://sepolia-rollup.arbitrum.io/rpc"],
      ["OptimismSepolia", "https://sepolia.optimism.io"],
      ["BaseSepolia", "https://sepolia.base.org"],
      ["PolygonSepolia", "https://rpc-amoy.polygon.technology/"],
      ["Mantle", "https://mantle-sepolia.drpc.org"],
      ["Karura", "https://eth-rpc-karura-testnet.aca-staging.network"],
      ["Acala", "https://eth-rpc-acala-testnet.aca-staging.network"],
      ["Blast", "https://sepolia.blast.io"],
      ["Berachain", "https://artio.rpc.berachain.com"],
      ["Seievm", "https://evm-rpc-testnet.sei-apis.com/"],
      ["Linea", "https://rpc.sepolia.linea.build"],
      ["Xlayer", "https://testrpc.xlayer.tech/"],
      ["Scroll", "https://rpc.ankr.com/scroll_sepolia_testnet"],
      ["Rootstock", "https://public-node.testnet.rsk.co"],
      ["Gnosis", "https://rpc.chiadochain.net"],
      ["Klaytn", "https://rpc.ankr.com/klaytn_testnet"],
      ["Snaxchain", "https://testnet.snaxchain.io"],
      ["Unichain", "https://sepolia.unichain.org"],
      ["Worldchain", "https://worldchain-sepolia.g.alchemy.com/public"],
      ["Ink", "https://rpc-qnd-sepolia.inkonchain.com"],
      ["HyperEVM", "https://api.hyperliquid-testnet.xyz/evm"],
      ["MonadDevnet", ""],
      // TODO: No public rpc is currently available, override with a custom rpc for now.
      ["Noble", "https://noble-testnet-rpc.polkachu.com/"]
    ]
  ],
  [
    "Devnet",
    [
      ["Ethereum", "http://eth-devnet:8545"],
      ["Bsc", "http://eth-devnet2:8545"],
      ["Solana", "http://solana-devnet:8899"]
    ]
  ]
], rpc$1 = constMap(rpcConfig), rpcAddress = (C, e) => rpc$1.get(C, e) ?? "", chainNetworkNativeChainIdEntries = [
  [
    "Mainnet",
    [
      ["Aptos", 1n],
      ["Algorand", "mainnet-v1.0"],
      ["Near", "mainnet"],
      ["Cosmoshub", "cosmoshub-4"],
      ["Evmos", "evmos_9001-2"],
      ["Injective", "injective-1"],
      ["Osmosis", "osmosis-1"],
      ["Sei", "pacific-1"],
      ["Terra", "columbus-5"],
      ["Terra2", "phoenix-1"],
      ["Wormchain", "wormchain"],
      ["Xpla", "dimension_37-1"],
      ["Kujira", "kaiyo-1"],
      ["Solana", "5eykt4UsFv8P8NJdTREpY1vzqKqZKvdpKuc147dw2N9d"],
      ["Sui", "35834a8a"],
      ["Acala", 787n],
      ["Arbitrum", 42161n],
      ["Aurora", 1313161554n],
      ["Avalanche", 43114n],
      ["Base", 8453n],
      ["Bsc", 56n],
      ["Celo", 42220n],
      ["Ethereum", 1n],
      ["Fantom", 250n],
      ["Gnosis", 100n],
      ["Karura", 686n],
      ["Klaytn", 8217n],
      ["Moonbeam", 1284n],
      ["Neon", 245022934n],
      ["Oasis", 42262n],
      ["Optimism", 10n],
      ["Polygon", 137n],
      ["Rootstock", 30n],
      ["Neutron", "neutron-1"],
      ["Stargaze", "stargaze-1"],
      ["Celestia", "celestia"],
      ["Dymension", "dymension_1100-1"],
      ["Provenance", "pio-mainnet-1"],
      ["Noble", "noble-1"],
      ["Xlayer", 196n],
      ["Mantle", 5000n],
      ["Scroll", 534352n],
      ["Blast", 81457n],
      ["Linea", 59144n],
      ["Snaxchain", 2192n],
      ["Worldchain", 480n]
    ]
  ],
  [
    "Testnet",
    [
      ["Aptos", 2n],
      ["Algorand", "testnet-v1.0"],
      ["Near", "testnet"],
      ["Cosmoshub", "theta-testnet-001"],
      ["Evmos", "evmos_9000-4"],
      ["Injective", "injective-888"],
      ["Osmosis", "osmo-test-5"],
      ["Sei", "atlantic-2"],
      ["Terra", "bombay-12"],
      ["Terra2", "pisco-1"],
      ["Wormchain", "wormchain-testnet-0"],
      ["Xpla", "cube_47-5"],
      ["Kujira", "harpoon-4"],
      ["Solana", "EtWTRABZaYq6iMfeYKouRu166VU2xqa1wcaWoxPkrZBG"],
      ["Sui", "4c78adac"],
      ["Acala", 597n],
      ["Arbitrum", 421613n],
      ["Aurora", 1313161555n],
      ["Avalanche", 43113n],
      //fuji
      ["Base", 84531n],
      ["Bsc", 97n],
      ["Celo", 44787n],
      //alfajores
      ["Ethereum", 5n],
      //goerli
      ["Fantom", 4002n],
      ["Gnosis", 10200n],
      ["Karura", 596n],
      ["Klaytn", 1001n],
      //baobab
      ["Moonbeam", 1287n],
      //moonbase alpha
      ["Neon", 245022940n],
      ["Oasis", 42261n],
      ["Optimism", 420n],
      ["Polygon", 80001n],
      //mumbai
      ["Rootstock", 31n],
      ["Sepolia", 11155111n],
      ["ArbitrumSepolia", 421614n],
      ["BaseSepolia", 84532n],
      ["OptimismSepolia", 11155420n],
      ["PolygonSepolia", 80002n],
      ["Holesky", 17000n],
      ["Neutron", "pion-1"],
      ["Celestia", "mocha-4"],
      ["Seda", "seda-1-testnet"],
      ["Noble", "grand-1"],
      ["Blast", 168587773n],
      // Sepolia testnet
      ["Mantle", 5003n],
      // Sepolia testnet
      ["Scroll", 534351n],
      ["Berachain", 80084n],
      // Testnet v2
      ["Seievm", 1328n],
      ["Snaxchain", 13001n],
      ["Unichain", 1301n],
      ["Worldchain", 4801n],
      ["Ink", 763373n],
      ["HyperEVM", 998n],
      ["Xlayer", 195n],
      ["Linea", 59141n],
      // Sepolia
      ["MonadDevnet", 41454n]
    ]
  ],
  [
    "Devnet",
    [
      ["Aptos", 0n],
      ["Algorand", "sandnet-v1.0"],
      ["Bsc", 1397n],
      ["Ethereum", 1337n],
      ["Injective", "injective_devnet_fake"],
      ["Solana", "8wF6jKV3cKwyaVkWcoV9KpDqmkjvEYno9hKZrKx8TbZn"]
    ]
  ]
], networkChainToNativeChainId = constMap(chainNetworkNativeChainIdEntries), nativeChainIdToNetworkChain = constMap(chainNetworkNativeChainIdEntries, [2, [0, 1]]);
function platformNativeChainIdToNetworkChain(C, e) {
  const $ = nativeChainIdToNetworkChain(e).filter(([V, J]) => chainToPlatform(J) === C);
  if ($.length !== 1)
    throw new Error(`Platform ${C} has multiple chains with native chain id ${e}`);
  return $[0];
}
const circleAPIs = [
  ["Mainnet", "https://iris-api.circle.com/v1/attestations"],
  ["Testnet", "https://iris-api-sandbox.circle.com/v1/attestations"]
], circleAPI = constMap(circleAPIs), usdcContracts = [
  [
    "Mainnet",
    [
      ["Ethereum", "0xa0b86991c6218b36c1d19d4a2e9eb0ce3606eb48"],
      ["Avalanche", "0xb97ef9ef8734c71904d8002f8b6bc66dd9c48a6e"],
      ["Optimism", "0x0b2C639c533813f4Aa9D7837CAf62653d097Ff85"],
      ["Arbitrum", "0xaf88d065e77c8cC2239327C5EDb3A432268e5831"],
      ["Solana", "EPjFWdd5AufqSSqeM2qN1xzybapC8G4wEGGkZwyTDt1v"],
      ["Base", "0x833589fcd6edb6e08f4c7c32d4f71b54bda02913"],
      ["Polygon", "0x3c499c542cef5e3811e1192ce70d8cc03d5c3359"],
      ["Sui", "0xdba34672e30cb065b1f93e3ab55318768fd6fef66c15942c9f7cb846e2f900e7::usdc::USDC"]
    ]
  ],
  [
    "Testnet",
    [
      ["Sepolia", "0x1c7D4B196Cb0C7B01d743Fbc6116a902379C7238"],
      ["Avalanche", "0x5425890298aed601595a70AB815c96711a31Bc65"],
      ["OptimismSepolia", "0x5fd84259d66Cd46123540766Be93DFE6D43130D7"],
      ["ArbitrumSepolia", "0x75faf114eafb1BDbe2F0316DF893fd58CE46AA4d"],
      ["Solana", "4zMMC9srt5Ri5X14GAgXhaHii3GnPAEERYPJgZJDncDU"],
      ["BaseSepolia", "0x036CbD53842c5426634e7929541eC2318f3dCF7e"],
      ["Polygon", "0x9999f7fea5938fd3b1e26a12c3f2fb024e194f97"],
      ["Sui", "0xa1ec7fc00a6f40db9693ad1415d0c193ad3906494428cf252621037bd7117e29::usdc::USDC"]
    ]
  ]
], usdcContract = constMap(usdcContracts), circleDomains = [
  [
    "Mainnet",
    [
      ["Ethereum", 0],
      ["Avalanche", 1],
      ["Optimism", 2],
      ["Arbitrum", 3],
      ["Solana", 5],
      ["Base", 6],
      ["Polygon", 7],
      ["Sui", 8]
    ]
  ],
  [
    "Testnet",
    [
      ["Sepolia", 0],
      ["Avalanche", 1],
      ["OptimismSepolia", 2],
      ["ArbitrumSepolia", 3],
      ["Solana", 5],
      ["BaseSepolia", 6],
      ["Polygon", 7],
      ["Sui", 8]
    ]
  ]
], circleChainId = constMap(circleDomains, [[0, 1], 2]), circleChainIdToChain = constMap(circleDomains, [[0, 2], 1]);
zip(circleDomains);
const isCircleChain = (C, e) => circleChainId.has(C, e), isCircleChainId = (C, e) => circleChainIdToChain.has(C, e), isCircleSupported = (C, e) => usdcContract.has(C, e), toCircleChain = (C, e) => {
  switch (typeof e) {
    case "string":
      if (isCircleChain(C, e))
        return e;
      break;
    case "number":
      if (isCircleChainId(C, e))
        return circleChainIdToChain(C, e);
      break;
    case "bigint":
      const T = Number(e);
      if (isCircleChainId(C, T))
        return circleChainIdToChain(C, T);
      break;
  }
  throw Error(`Cannot convert to Chain: ${e}`);
}, coreBridgeContracts = [
  [
    "Mainnet",
    [
      ["Solana", "worm2ZoG2kUd4vFXhvjh93UUH596ayRfgQ2MgjNMTth"],
      ["Ethereum", "0x98f3c9e6E3fAce36bAAd05FE09d375Ef1464288B"],
      ["Terra", "terra1dq03ugtd40zu9hcgdzrsq6z2z4hwhc9tqk2uy5"],
      ["Bsc", "0x98f3c9e6E3fAce36bAAd05FE09d375Ef1464288B"],
      ["Polygon", "0x7A4B5a56256163F07b2C80A7cA55aBE66c4ec4d7"],
      ["Avalanche", "0x54a8e5f9c4CbA08F9943965859F6c34eAF03E26c"],
      ["Oasis", "0xfE8cD454b4A1CA468B57D79c0cc77Ef5B6f64585"],
      ["Algorand", "842125965"],
      ["Aurora", "0xa321448d90d4e5b0A732867c18eA198e75CAC48E"],
      ["Fantom", "0x126783A6Cb203a3E35344528B26ca3a0489a1485"],
      ["Karura", "0xa321448d90d4e5b0A732867c18eA198e75CAC48E"],
      ["Acala", "0xa321448d90d4e5b0A732867c18eA198e75CAC48E"],
      ["Klaytn", "0x0C21603c4f3a6387e241c0091A7EA39E43E90bb7"],
      ["Celo", "0xa321448d90d4e5b0A732867c18eA198e75CAC48E"],
      ["Near", "contract.wormhole_crypto.near"],
      ["Injective", "inj17p9rzwnnfxcjp32un9ug7yhhzgtkhvl9l2q74d"],
      ["Aptos", "0x5bc11445584a763c1fa7ed39081f1b920954da14e04b32440cba863d03e19625"],
      ["Sui", "0xaeab97f96cf9877fee2883315d459552b2b921edc16d7ceac6eab944dd88919c"],
      ["Moonbeam", "0xC8e2b0cD52Cf01b0Ce87d389Daa3d414d4cE29f3"],
      ["Terra2", "terra12mrnzvhx3rpej6843uge2yyfppfyd3u9c3uq223q8sl48huz9juqffcnhp"],
      ["Arbitrum", "0xa5f208e072434bC67592E4C49C1B991BA79BCA46"],
      ["Optimism", "0xEe91C335eab126dF5fDB3797EA9d6aD93aeC9722"],
      ["Gnosis", "0xa321448d90d4e5b0A732867c18eA198e75CAC48E"],
      ["Pythnet", "H3fxXJ86ADW2PNuDDmZJg6mzTtPxkYCpNuQUTgmJ7AjU"],
      ["Base", "0xbebdb6C8ddC678FfA9f8748f85C815C556Dd8ac6"],
      ["Rootstock", "0xbebdb6C8ddC678FfA9f8748f85C815C556Dd8ac6"],
      ["Xlayer", "0x194B123c5E96B9b2E49763619985790Dc241CAC0"],
      ["Xpla", "xpla1jn8qmdda5m6f6fqu9qv46rt7ajhklg40ukpqchkejcvy8x7w26cqxamv3w"],
      ["Sei", "sei1gjrrme22cyha4ht2xapn3f08zzw6z3d4uxx6fyy9zd5dyr3yxgzqqncdqn"],
      ["Wormchain", "wormhole1ufs3tlq4umljk0qfe8k5ya0x6hpavn897u2cnf9k0en9jr7qarqqaqfk2j"],
      ["Neutron", "neutron16rerygcpahqcxx5t8vjla46ym8ccn7xz7rtc6ju5ujcd36cmc7zs9zrunh"],
      ["Blast", "0xbebdb6C8ddC678FfA9f8748f85C815C556Dd8ac6"],
      ["Scroll", "0xbebdb6C8ddC678FfA9f8748f85C815C556Dd8ac6"],
      ["Mantle", "0xbebdb6C8ddC678FfA9f8748f85C815C556Dd8ac6"],
      ["Snaxchain", "0xc1BA3CC4bFE724A08FbbFbF64F8db196738665f4"],
      ["Worldchain", "0xcbcEe4e081464A15d8Ad5f58BB493954421eB506"]
    ]
  ],
  [
    "Testnet",
    [
      ["Solana", "3u8hJUVTA4jH1wYAyUur7FFZVQ8H635K3tSHHF4ssjQ5"],
      ["Ethereum", "0x706abc4E45D419950511e474C7B9Ed348A4a716c"],
      ["Terra", "terra1pd65m0q9tl3v8znnz5f5ltsfegyzah7g42cx5v"],
      ["Bsc", "0x68605AD7b15c732a30b1BbC62BE8F2A509D74b4D"],
      ["Polygon", "0x0CBE91CF822c73C2315FB05100C2F714765d5c20"],
      ["Avalanche", "0x7bbcE28e64B3F8b84d876Ab298393c38ad7aac4C"],
      ["Oasis", "0xc1C338397ffA53a2Eb12A7038b4eeb34791F8aCb"],
      ["Algorand", "86525623"],
      ["Aurora", "0xBd07292de7b505a4E803CEe286184f7Acf908F5e"],
      ["Fantom", "0x1BB3B4119b7BA9dfad76B0545fb3F531383c3bB7"],
      ["Karura", "0x64fb09E405D2043ed7785a29E296C766D56F2056"],
      ["Acala", "0x64fb09E405D2043ed7785a29E296C766D56F2056"],
      ["Klaytn", "0x1830CC6eE66c84D2F177B94D544967c774E624cA"],
      ["Celo", "0x88505117CA88e7dd2eC6EA1E13f0948db2D50D56"],
      ["Near", "wormhole.wormhole.testnet"],
      ["Injective", "inj1xx3aupmgv3ce537c0yce8zzd3sz567syuyedpg"],
      ["Osmosis", "osmo1hggkxr0hpw83f8vuft7ruvmmamsxmwk2hzz6nytdkzyup9krt0dq27sgyx"],
      ["Aptos", "0x5bc11445584a763c1fa7ed39081f1b920954da14e04b32440cba863d03e19625"],
      ["Sui", "0x31358d198147da50db32eda2562951d53973a0c0ad5ed738e9b17d88b213d790"],
      ["Moonbeam", "0xa5B7D85a8f27dd7907dc8FdC21FA5657D5E2F901"],
      ["Neon", "0x268557122Ffd64c85750d630b716471118F323c8"],
      ["Terra2", "terra19nv3xr5lrmmr7egvrk2kqgw4kcn43xrtd5g0mpgwwvhetusk4k7s66jyv0"],
      ["Arbitrum", "0xC7A204bDBFe983FCD8d8E61D02b475D4073fF97e"],
      ["Optimism", "0x6b9C8671cdDC8dEab9c719bB87cBd3e782bA6a35"],
      ["Gnosis", "0xBB73cB66C26740F31d1FabDC6b7A46a038A300dd"],
      ["Pythnet", "EUrRARh92Cdc54xrDn6qzaqjA77NRrCcfbr8kPwoTL4z"],
      ["Xpla", "xpla1upkjn4mthr0047kahvn0llqx4qpqfn75lnph4jpxfn8walmm8mqsanyy35"],
      ["Base", "0x23908A62110e21C04F3A4e011d24F901F911744A"],
      ["Sei", "sei1nna9mzp274djrgzhzkac2gvm3j27l402s4xzr08chq57pjsupqnqaj0d5s"],
      ["Sepolia", "0x4a8bc80Ed5a4067f1CCf107057b8270E0cC11A78"],
      ["Rootstock", "0xbebdb6C8ddC678FfA9f8748f85C815C556Dd8ac6"],
      ["Wormchain", "wormhole16jzpxp0e8550c9aht6q9svcux30vtyyyyxv5w2l2djjra46580wsazcjwp"],
      ["ArbitrumSepolia", "0x6b9C8671cdDC8dEab9c719bB87cBd3e782bA6a35"],
      ["BaseSepolia", "0x79A1027a6A159502049F10906D333EC57E95F083"],
      ["OptimismSepolia", "0x31377888146f3253211EFEf5c676D41ECe7D58Fe"],
      ["Holesky", "0xa10f2eF61dE1f19f586ab8B6F2EbA89bACE63F7a"],
      ["Neutron", "neutron1enf63k37nnv9cugggpm06mg70emcnxgj9p64v2s8yx7a2yhhzk2q6xesk4"],
      ["Mantle", "0x376428e7f26D5867e69201b275553C45B09EE090"],
      ["PolygonSepolia", "0x6b9C8671cdDC8dEab9c719bB87cBd3e782bA6a35"],
      ["Scroll", "0x055F47F1250012C6B20c436570a76e52c17Af2D5"],
      ["Blast", "0x473e002D7add6fB67a4964F13bFd61280Ca46886"],
      ["Berachain", "0xBB73cB66C26740F31d1FabDC6b7A46a038A300dd"],
      ["Seievm", "0xBB73cB66C26740F31d1FabDC6b7A46a038A300dd"],
      ["Snaxchain", "0xBB73cB66C26740F31d1FabDC6b7A46a038A300dd"],
      ["Unichain", "0xBB73cB66C26740F31d1FabDC6b7A46a038A300dd"],
      ["Worldchain", "0xe5E02cD12B6FcA153b0d7fF4bF55730AE7B3C93A"],
      ["Ink", "0xBB73cB66C26740F31d1FabDC6b7A46a038A300dd"],
      ["HyperEVM", "0xBB73cB66C26740F31d1FabDC6b7A46a038A300dd"],
      ["Xlayer", "0xA31aa3FDb7aF7Db93d18DDA4e19F811342EDF780"],
      ["Linea", "0x79A1027a6A159502049F10906D333EC57E95F083"],
      ["MonadDevnet", "0xBB73cB66C26740F31d1FabDC6b7A46a038A300dd"]
    ]
  ],
  [
    "Devnet",
    [
      ["Solana", "Bridge1p5gheXUvJ6jGWGeCsgPKgnE3YgdGKRVCMY9o"],
      ["Ethereum", "0xC89Ce4735882C9F0f0FE26686c53074E09B0D550"],
      ["Terra", "terra14hj2tavq8fpesdwxxcu44rty3hh90vhujrvcmstl4zr3txmfvw9ssrc8au"],
      ["Bsc", "0xC89Ce4735882C9F0f0FE26686c53074E09B0D550"],
      ["Algorand", "1004"],
      ["Near", "wormhole.test.near"],
      ["Aptos", "0xde0036a9600559e295d5f6802ef6f3f802f510366e0c23912b0655d972166017"],
      ["Sui", "0x5a5160ca3c2037f4b4051344096ef7a48ebf4400b3f385e57ea90e1628a8bde0"],
      ["Terra2", "terra14hj2tavq8fpesdwxxcu44rty3hh90vhujrvcmstl4zr3txmfvw9ssrc8au"],
      ["Wormchain", "wormhole17p9rzwnnfxcjp32un9ug7yhhzgtkhvl9jfksztgw5uh69wac2pgshdnj3k"]
    ]
  ]
], tokenBridgeContracts = [
  [
    "Mainnet",
    [
      ["Solana", "wormDTUJ6AWPNvk59vGQbDvGJmqbDTdgWgAqcLBCgUb"],
      ["Ethereum", "0x3ee18B2214AFF97000D974cf647E7C347E8fa585"],
      ["Terra", "terra10nmmwe8r3g99a9newtqa7a75xfgs2e8z87r2sf"],
      ["Bsc", "0xB6F6D86a8f9879A9c87f643768d9efc38c1Da6E7"],
      ["Polygon", "0x5a58505a96D1dbf8dF91cB21B54419FC36e93fdE"],
      ["Avalanche", "0x0e082F06FF657D94310cB8cE8B0D9a04541d8052"],
      ["Oasis", "0x5848C791e09901b40A9Ef749f2a6735b418d7564"],
      ["Algorand", "842126029"],
      ["Aurora", "0x51b5123a7b0F9b2bA265f9c4C8de7D78D52f510F"],
      ["Fantom", "0x7C9Fc5741288cDFdD83CeB07f3ea7e22618D79D2"],
      ["Karura", "0xae9d7fe007b3327AA64A32824Aaac52C42a6E624"],
      ["Acala", "0xae9d7fe007b3327AA64A32824Aaac52C42a6E624"],
      ["Klaytn", "0x5b08ac39EAED75c0439FC750d9FE7E1F9dD0193F"],
      ["Celo", "0x796Dff6D74F3E27060B71255Fe517BFb23C93eed"],
      ["Near", "contract.portalbridge.near"],
      ["Injective", "inj1ghd753shjuwexxywmgs4xz7x2q732vcnxxynfn"],
      ["Aptos", "0x576410486a2da45eee6c949c995670112ddf2fbeedab20350d506328eefc9d4f"],
      ["Sui", "0xc57508ee0d4595e5a8728974a4a93a787d38f339757230d441e895422c07aba9"],
      ["Moonbeam", "0xb1731c586ca89a23809861c6103f0b96b3f57d92"],
      ["Terra2", "terra153366q50k7t8nn7gec00hg66crnhkdggpgdtaxltaq6xrutkkz3s992fw9"],
      ["Arbitrum", "0x0b2402144Bb366A632D14B83F244D2e0e21bD39c"],
      ["Optimism", "0x1D68124e65faFC907325e3EDbF8c4d84499DAa8b"],
      ["Base", "0x8d2de8d2f73F1F4cAB472AC9A881C9b123C79627"],
      ["Xlayer", "0x5537857664B0f9eFe38C9f320F75fEf23234D904"],
      ["Xpla", "xpla137w0wfch2dfmz7jl2ap8pcmswasj8kg06ay4dtjzw7tzkn77ufxqfw7acv"],
      ["Sei", "sei1smzlm9t79kur392nu9egl8p8je9j92q4gzguewj56a05kyxxra0qy0nuf3"],
      ["Wormchain", "wormhole1466nf3zuxpya8q9emxukd7vftaf6h4psr0a07srl5zw74zh84yjq4lyjmh"],
      ["Blast", "0x24850c6f61C438823F01B7A3BF2B89B72174Fa9d"],
      ["Scroll", "0x24850c6f61C438823F01B7A3BF2B89B72174Fa9d"],
      ["Mantle", "0x24850c6f61C438823F01B7A3BF2B89B72174Fa9d"],
      ["Snaxchain", "0x8B94bfE456B48a6025b92E11Be393BAa86e68410"],
      ["Worldchain", "0xc309275443519adca74c9136b02A38eF96E3a1f6"]
    ]
  ],
  [
    "Testnet",
    [
      ["Solana", "DZnkkTmCiFWfYTfT41X3Rd1kDgozqzxWaHqsw6W4x2oe"],
      ["Ethereum", "0xF890982f9310df57d00f659cf4fd87e65adEd8d7"],
      ["Terra", "terra1pseddrv0yfsn76u4zxrjmtf45kdlmalswdv39a"],
      ["Bsc", "0x9dcF9D205C9De35334D646BeE44b2D2859712A09"],
      ["Polygon", "0x377D55a7928c046E18eEbb61977e714d2a76472a"],
      ["Avalanche", "0x61E44E506Ca5659E6c0bba9b678586fA2d729756"],
      ["Oasis", "0x88d8004A9BdbfD9D28090A02010C19897a29605c"],
      ["Algorand", "86525641"],
      ["Aurora", "0xD05eD3ad637b890D68a854d607eEAF11aF456fba"],
      ["Fantom", "0x599CEa2204B4FaECd584Ab1F2b6aCA137a0afbE8"],
      ["Karura", "0xe157115ef34c93145Fec2FE53706846853B07F42"],
      ["Acala", "0xe157115ef34c93145Fec2FE53706846853B07F42"],
      ["Klaytn", "0xC7A13BE098720840dEa132D860fDfa030884b09A"],
      ["Celo", "0x05ca6037eC51F8b712eD2E6Fa72219FEaE74E153"],
      ["Near", "token.wormhole.testnet"],
      ["Injective", "inj1q0e70vhrv063eah90mu97sazhywmeegp7myvnh"],
      ["Aptos", "0x576410486a2da45eee6c949c995670112ddf2fbeedab20350d506328eefc9d4f"],
      ["Sui", "0x6fb10cdb7aa299e9a4308752dadecb049ff55a892de92992a1edbd7912b3d6da"],
      ["Moonbeam", "0xbc976D4b9D57E57c3cA52e1Fd136C45FF7955A96"],
      ["Neon", "0xEe3dB83916Ccdc3593b734F7F2d16D630F39F1D0"],
      ["Terra2", "terra1c02vds4uhgtrmcw7ldlg75zumdqxr8hwf7npseuf2h58jzhpgjxsgmwkvk"],
      ["Arbitrum", "0x23908A62110e21C04F3A4e011d24F901F911744A"],
      ["ArbitrumSepolia", "0xC7A204bDBFe983FCD8d8E61D02b475D4073fF97e"],
      ["Optimism", "0xC7A204bDBFe983FCD8d8E61D02b475D4073fF97e"],
      ["OptimismSepolia", "0x99737Ec4B815d816c49A385943baf0380e75c0Ac"],
      ["Xpla", "xpla1kek6zgdaxcsu35nqfsyvs2t9vs87dqkkq6hjdgczacysjn67vt8sern93x"],
      ["Base", "0xA31aa3FDb7aF7Db93d18DDA4e19F811342EDF780"],
      ["BaseSepolia", "0x86F55A04690fd7815A3D802bD587e83eA888B239"],
      ["Sei", "sei1jv5xw094mclanxt5emammy875qelf3v62u4tl4lp5nhte3w3s9ts9w9az2"],
      ["Sepolia", "0xDB5492265f6038831E89f495670FF909aDe94bd9"],
      ["Wormchain", "wormhole1aaf9r6s7nxhysuegqrxv0wpm27ypyv4886medd3mrkrw6t4yfcnst3qpex"],
      ["Holesky", "0x76d093BbaE4529a342080546cAFEec4AcbA59EC6"],
      ["Mantle", "0x75Bfa155a9D7A3714b0861c8a8aF0C4633c45b5D"],
      ["PolygonSepolia", "0xC7A204bDBFe983FCD8d8E61D02b475D4073fF97e"],
      ["Scroll", "0x22427d90B7dA3fA4642F7025A854c7254E4e45BF"],
      ["Blast", "0x430855B4D43b8AEB9D2B9869B74d58dda79C0dB2"],
      ["Xlayer", "0xdA91a06299BBF302091B053c6B9EF86Eff0f930D"],
      ["Berachain", "0xa10f2eF61dE1f19f586ab8B6F2EbA89bACE63F7a"],
      ["Seievm", "0x23908A62110e21C04F3A4e011d24F901F911744A"],
      ["Snaxchain", "0xa10f2eF61dE1f19f586ab8B6F2EbA89bACE63F7a"],
      ["Unichain", "0xa10f2eF61dE1f19f586ab8B6F2EbA89bACE63F7a"],
      ["Worldchain", "0x430855B4D43b8AEB9D2B9869B74d58dda79C0dB2"],
      ["Ink", "0x376428e7f26D5867e69201b275553C45B09EE090"],
      ["HyperEVM", "0x4a8bc80Ed5a4067f1CCf107057b8270E0cC11A78"],
      ["Linea", "0xC7A204bDBFe983FCD8d8E61D02b475D4073fF97e"]
    ]
  ],
  [
    "Devnet",
    [
      ["Solana", "B6RHG3mfcckmrYN1UhmJzyS1XX3fZKbkeUcpJe9Sy3FE"],
      ["Ethereum", "0x0290FB167208Af455bB137780163b7B7a9a10C16"],
      ["Terra", "terra1nc5tatafv6eyq7llkr2gv50ff9e22mnf70qgjlv737ktmt4eswrquka9l6"],
      ["Bsc", "0x0290FB167208Af455bB137780163b7B7a9a10C16"],
      ["Algorand", "1006"],
      ["Near", "token.test.near"],
      ["Aptos", "0x84a5f374d29fc77e370014dce4fd6a55b58ad608de8074b0be5571701724da31"],
      ["Sui", "0xa6a3da85bbe05da5bfd953708d56f1a3a023e7fb58e5a824a3d4de3791e8f690"],
      ["Terra2", "terra1nc5tatafv6eyq7llkr2gv50ff9e22mnf70qgjlv737ktmt4eswrquka9l6"],
      ["Wormchain", "wormhole1ghd753shjuwexxywmgs4xz7x2q732vcnkm6h2pyv9s6ah3hylvrqtm7t3h"]
    ]
  ]
], tokenBridgeRelayerContracts = [
  [
    "Mainnet",
    [
      ["Ethereum", "0xcafd2f0a35a4459fa40c0517e17e6fa2939441ca"],
      ["Bsc", "0xcafd2f0a35a4459fa40c0517e17e6fa2939441ca"],
      ["Polygon", "0xcafd2f0a35a4459fa40c0517e17e6fa2939441ca"],
      ["Avalanche", "0xcafd2f0a35a4459fa40c0517e17e6fa2939441ca"],
      ["Fantom", "0xcafd2f0a35a4459fa40c0517e17e6fa2939441ca"],
      ["Celo", "0xcafd2f0a35a4459fa40c0517e17e6fa2939441ca"],
      ["Sui", "0x57f4e0ba41a7045e29d435bc66cc4175f381eb700e6ec16d4fdfe92e5a4dff9f"],
      ["Solana", "3vxKRPwUTiEkeUVyoZ9MXFe1V71sRLbLqu1gRYaWmehQ"],
      ["Base", "0xaE8dc4a7438801Ec4edC0B035EcCCcF3807F4CC1"],
      ["Moonbeam", "0xcafd2f0a35a4459fa40c0517e17e6fa2939441ca"],
      ["Arbitrum", "0xaE8dc4a7438801Ec4edC0B035EcCCcF3807F4CC1"],
      ["Optimism", "0xaE8dc4a7438801Ec4edC0B035EcCCcF3807F4CC1"]
    ]
  ],
  [
    "Testnet",
    [
      ["Ethereum", "0x9563a59c15842a6f322b10f69d1dd88b41f2e97b"],
      ["Bsc", "0x9563a59c15842a6f322b10f69d1dd88b41f2e97b"],
      ["Polygon", "0x9563a59c15842a6f322b10f69d1dd88b41f2e97b"],
      ["Avalanche", "0x9563a59c15842a6f322b10f69d1dd88b41f2e97b"],
      ["Fantom", "0x9563a59c15842a6f322b10f69d1dd88b41f2e97b"],
      ["Celo", "0x9563a59c15842a6f322b10f69d1dd88b41f2e97b"],
      ["Sui", "0xb30040e5120f8cb853b691cb6d45981ae884b1d68521a9dc7c3ae881c0031923"],
      ["Base", "0xae8dc4a7438801ec4edc0b035eccccf3807f4cc1"],
      ["Moonbeam", "0x9563a59c15842a6f322b10f69d1dd88b41f2e97b"],
      ["Solana", "3bPRWXqtSfUaCw3S4wdgvypQtsSzcmvDeaqSqPDkncrg"],
      ["Sepolia", ""],
      ["ArbitrumSepolia", "0xaE8dc4a7438801Ec4edC0B035EcCCcF3807F4CC1"],
      ["OptimismSepolia", "0xaE8dc4a7438801Ec4edC0B035EcCCcF3807F4CC1"],
      ["BaseSepolia", ""]
    ]
  ]
], nftBridgeContracts = [
  [
    "Mainnet",
    [
      ["Solana", "WnFt12ZrnzZrFZkt2xsNsaNWoQribnuQ5B5FrDbwDhD"],
      ["Ethereum", "0x6FFd7EdE62328b3Af38FCD61461Bbfc52F5651fE"],
      ["Bsc", "0x5a58505a96D1dbf8dF91cB21B54419FC36e93fdE"],
      ["Polygon", "0x90BBd86a6Fe93D3bc3ed6335935447E75fAb7fCf"],
      ["Avalanche", "0xf7B6737Ca9c4e08aE573F75A97B73D7a813f5De5"],
      ["Oasis", "0x04952D522Ff217f40B5Ef3cbF659EcA7b952a6c1"],
      ["Aurora", "0x6dcC0484472523ed9Cdc017F711Bcbf909789284"],
      ["Fantom", "0xA9c7119aBDa80d4a4E0C06C8F4d8cF5893234535"],
      ["Karura", "0xb91e3638F82A1fACb28690b37e3aAE45d2c33808"],
      ["Acala", "0xb91e3638F82A1fACb28690b37e3aAE45d2c33808"],
      ["Klaytn", "0x3c3c561757BAa0b78c5C025CdEAa4ee24C1dFfEf"],
      ["Celo", "0xA6A377d75ca5c9052c9a77ED1e865Cc25Bd97bf3"],
      ["Aptos", "0x1bdffae984043833ed7fe223f7af7a3f8902d04129b14f801823e64827da7130"],
      ["Moonbeam", "0x453cfbe096c0f8d763e8c5f24b441097d577bde2"],
      ["Arbitrum", "0x3dD14D553cFD986EAC8e3bddF629d82073e188c8"],
      ["Base", "0xDA3adC6621B2677BEf9aD26598e6939CF0D92f88"],
      ["Optimism", "0xfE8cD454b4A1CA468B57D79c0cc77Ef5B6f64585"]
    ]
  ],
  [
    "Testnet",
    [
      ["Solana", "2rHhojZ7hpu1zA91nvZmT8TqWWvMcKmmNBCr2mKTtMq4"],
      ["Ethereum", "0xD8E4C2DbDd2e2bd8F1336EA691dBFF6952B1a6eB"],
      ["Bsc", "0xcD16E5613EF35599dc82B24Cb45B5A93D779f1EE"],
      ["Polygon", "0x51a02d0dcb5e52F5b92bdAA38FA013C91c7309A9"],
      ["Avalanche", "0xD601BAf2EEE3C028344471684F6b27E789D9075D"],
      ["Oasis", "0xC5c25B41AB0b797571620F5204Afa116A44c0ebA"],
      ["Aurora", "0x8F399607E9BA2405D87F5f3e1B78D950b44b2e24"],
      ["Fantom", "0x63eD9318628D26BdCB15df58B53BB27231D1B227"],
      ["Klaytn", "0x94c994fC51c13101062958b567e743f1a04432dE"],
      ["Celo", "0xaCD8190F647a31E56A656748bC30F69259f245Db"],
      ["Moonbeam", "0x98A0F4B96972b32Fcb3BD03cAeB66A44a6aB9Edb"],
      ["Neon", "0x66E5BcFD45D2F3f166c567ADa663f9d2ffb292B4"],
      ["Arbitrum", "0xEe3dB83916Ccdc3593b734F7F2d16D630F39F1D0"],
      ["Optimism", "0x23908A62110e21C04F3A4e011d24F901F911744A"],
      ["Base", "0xF681d1cc5F25a3694E348e7975d7564Aa581db59"],
      ["Sepolia", "0x6a0B52ac198e4870e5F3797d5B403838a5bbFD99"],
      ["Aptos", "0x1bdffae984043833ed7fe223f7af7a3f8902d04129b14f801823e64827da7130"],
      ["ArbitrumSepolia", "0x23908A62110e21C04F3A4e011d24F901F911744A"],
      ["BaseSepolia", "0x268557122Ffd64c85750d630b716471118F323c8"],
      ["OptimismSepolia", "0x27812285fbe85BA1DF242929B906B31EE3dd1b9f"],
      ["Holesky", "0xc8941d483c45eF8FB72E4d1F9dDE089C95fF8171"],
      ["PolygonSepolia", "0x23908A62110e21C04F3A4e011d24F901F911744A"],
      ["Mantle", "0xD7D732C8Bf5eBF620EA55b5828eae20418eEF083"],
      ["Scroll", "0x47B9a1406BEe29a3001BFEB7e45aE45fFFB40c18"]
    ]
  ],
  [
    "Devnet",
    [
      ["Solana", "NFTWqJR8YnRVqPDvTJrYuLrQDitTG5AScqbeghi4zSA"],
      ["Ethereum", "0x26b4afb60d6c903165150c6f0aa14f8016be4aec"],
      ["Terra", "terra1plju286nnfj3z54wgcggd4enwaa9fgf5kgrgzl"],
      ["Bsc", "0x26b4afb60d6c903165150c6f0aa14f8016be4aec"],
      ["Aptos", "0x46da3d4c569388af61f951bdd1153f4c875f90c2991f6b2d0a38e2161a40852c"]
    ]
  ]
], relayerContracts = [
  [
    "Mainnet",
    [
      ["Ethereum", "0x27428DD2d3DD32A4D7f7C497eAaa23130d894911"],
      ["Bsc", "0x27428DD2d3DD32A4D7f7C497eAaa23130d894911"],
      ["Polygon", "0x27428DD2d3DD32A4D7f7C497eAaa23130d894911"],
      ["Avalanche", "0x27428DD2d3DD32A4D7f7C497eAaa23130d894911"],
      ["Fantom", "0x27428DD2d3DD32A4D7f7C497eAaa23130d894911"],
      ["Klaytn", "0x27428DD2d3DD32A4D7f7C497eAaa23130d894911"],
      ["Celo", "0x27428DD2d3DD32A4D7f7C497eAaa23130d894911"],
      ["Moonbeam", "0x27428DD2d3DD32A4D7f7C497eAaa23130d894911"],
      ["Base", "0x706f82e9bb5b0813501714ab5974216704980e31"],
      ["Arbitrum", "0x27428DD2d3DD32A4D7f7C497eAaa23130d894911"],
      ["Optimism", "0x27428DD2d3DD32A4D7f7C497eAaa23130d894911"],
      ["Blast", "0x27428DD2d3DD32A4D7f7C497eAaa23130d894911"],
      ["Scroll", "0x27428DD2d3DD32A4D7f7C497eAaa23130d894911"],
      ["Mantle", "0x27428DD2d3DD32A4D7f7C497eAaa23130d894911"],
      ["Xlayer", "0x27428DD2d3DD32A4D7f7C497eAaa23130d894911"],
      ["Worldchain", "0x1520cc9e779c56dab5866bebfb885c86840c33d3"],
      ["Snaxchain", "0x27428DD2d3DD32A4D7f7C497eAaa23130d894911"]
    ]
  ],
  [
    "Testnet",
    [
      ["Ethereum", "0x28D8F1Be96f97C1387e94A53e00eCcFb4E75175a"],
      ["Bsc", "0x80aC94316391752A193C1c47E27D382b507c93F3"],
      ["Polygon", "0x0591C25ebd0580E0d4F27A82Fc2e24E7489CB5e0"],
      ["Avalanche", "0xA3cF45939bD6260bcFe3D66bc73d60f19e49a8BB"],
      ["Fantom", "0x9563a59c15842a6f322b10f69d1dd88b41f2e97b"],
      ["Celo", "0x306B68267Deb7c5DfCDa3619E22E9Ca39C374f84"],
      ["Moonbeam", "0x0591C25ebd0580E0d4F27A82Fc2e24E7489CB5e0"],
      ["Arbitrum", "0xAd753479354283eEE1b86c9470c84D42f229FF43"],
      ["Optimism", "0x01A957A525a5b7A72808bA9D10c389674E459891"],
      ["Base", "0xea8029CD7FCAEFFcD1F53686430Db0Fc8ed384E1"],
      ["Sepolia", "0x7B1bD7a6b4E61c2a123AC6BC2cbfC614437D0470"],
      ["ArbitrumSepolia", "0x7B1bD7a6b4E61c2a123AC6BC2cbfC614437D0470"],
      ["BaseSepolia", "0x93BAD53DDfB6132b0aC8E37f6029163E63372cEE"],
      ["OptimismSepolia", "0x93BAD53DDfB6132b0aC8E37f6029163E63372cEE"]
    ]
  ],
  [
    "Devnet",
    [
      ["Ethereum", "0xcC680D088586c09c3E0E099a676FA4b6e42467b4"],
      ["Bsc", "0xcC680D088586c09c3E0E099a676FA4b6e42467b4"]
    ]
  ]
], circleContracts$1 = [
  [
    "Mainnet",
    [
      [
        "Ethereum",
        {
          tokenMessenger: "0xbd3fa81b58ba92a82136038b25adec7066af3155",
          messageTransmitter: "0x0a992d191deec32afe36203ad87d7d289a738f81",
          wormholeRelayer: "0x4cb69FaE7e7Af841e44E1A1c30Af640739378bb2",
          wormhole: "0xAaDA05BD399372f0b0463744C09113c137636f6a"
        }
      ],
      [
        "Avalanche",
        {
          tokenMessenger: "0x6b25532e1060ce10cc3b0a99e5683b91bfde6982",
          messageTransmitter: "0x8186359af5f57fbb40c6b14a588d2a59c0c29880",
          wormholeRelayer: "0x4cb69FaE7e7Af841e44E1A1c30Af640739378bb2",
          wormhole: "0x09Fb06A271faFf70A651047395AaEb6265265F13"
        }
      ],
      [
        "Optimism",
        {
          tokenMessenger: "0x2B4069517957735bE00ceE0fadAE88a26365528f",
          messageTransmitter: "0x4d41f22c5a0e5c74090899e5a8fb597a8842b3e8",
          wormholeRelayer: "0x4cb69FaE7e7Af841e44E1A1c30Af640739378bb2",
          wormhole: "0x2703483B1a5a7c577e8680de9Df8Be03c6f30e3c"
        }
      ],
      [
        "Arbitrum",
        {
          tokenMessenger: "0x19330d10D9Cc8751218eaf51E8885D058642E08A",
          messageTransmitter: "0xC30362313FBBA5cf9163F0bb16a0e01f01A896ca",
          wormholeRelayer: "0x4cb69FaE7e7Af841e44E1A1c30Af640739378bb2",
          wormhole: "0x2703483B1a5a7c577e8680de9Df8Be03c6f30e3c"
        }
      ],
      [
        "Base",
        {
          tokenMessenger: "0x1682Ae6375C4E4A97e4B583BC394c861A46D8962",
          messageTransmitter: "0xAD09780d193884d503182aD4588450C416D6F9D4",
          wormholeRelayer: "0x4cb69FaE7e7Af841e44E1A1c30Af640739378bb2",
          wormhole: "0x03faBB06Fa052557143dC28eFCFc63FC12843f1D"
        }
      ],
      [
        "Solana",
        {
          tokenMessenger: "CCTPiPYPc6AsJuwueEnWgSgucamXDZwBd53dQ11YiKX3",
          messageTransmitter: "CCTPmbSD7gX1bxKPAmg77w8oFzNFpaQiQUWD43TKaecd",
          wormholeRelayer: "",
          wormhole: ""
        }
      ],
      [
        "Polygon",
        {
          tokenMessenger: "0x9daF8c91AEFAE50b9c0E69629D3F6Ca40cA3B3FE",
          messageTransmitter: "0xF3be9355363857F3e001be68856A2f96b4C39Ba9",
          wormholeRelayer: "0x4cb69FaE7e7Af841e44E1A1c30Af640739378bb2",
          wormhole: "0x0FF28217dCc90372345954563486528aa865cDd6"
        }
      ],
      [
        "Sui",
        {
          tokenMessenger: "0x2aa6c5d56376c371f88a6cc42e852824994993cb9bab8d3e6450cbe3cb32b94e",
          messageTransmitter: "0x08d87d37ba49e785dde270a83f8e979605b03dc552b5548f26fdf2f49bf7ed1b",
          wormholeRelayer: "",
          wormhole: ""
        }
      ]
    ]
  ],
  [
    "Testnet",
    [
      [
        "Sepolia",
        {
          tokenMessenger: "0x9f3B8679c73C2Fef8b59B4f3444d4e156fb70AA5",
          messageTransmitter: "0x7865fAfC2db2093669d92c0F33AeEF291086BEFD",
          wormholeRelayer: "0x4cb69FaE7e7Af841e44E1A1c30Af640739378bb2",
          wormhole: "0x2703483B1a5a7c577e8680de9Df8Be03c6f30e3c"
        }
      ],
      [
        "Avalanche",
        {
          tokenMessenger: "0xeb08f243e5d3fcff26a9e38ae5520a669f4019d0",
          messageTransmitter: "0xa9fb1b3009dcb79e2fe346c16a604b8fa8ae0a79",
          wormholeRelayer: "0x774a70bbd03327c21460b60f25b677d9e46ab458",
          wormhole: "0x58f4c17449c90665891c42e14d34aae7a26a472e"
        }
      ],
      [
        "OptimismSepolia",
        {
          tokenMessenger: "0x9f3B8679c73C2Fef8b59B4f3444d4e156fb70AA5",
          messageTransmitter: "0x7865fAfC2db2093669d92c0F33AeEF291086BEFD",
          wormholeRelayer: "0x4cb69FaE7e7Af841e44E1A1c30Af640739378bb2",
          wormhole: "0x2703483B1a5a7c577e8680de9Df8Be03c6f30e3c"
        }
      ],
      [
        "ArbitrumSepolia",
        {
          tokenMessenger: "0x9f3B8679c73C2Fef8b59B4f3444d4e156fb70AA5",
          messageTransmitter: "0xaCF1ceeF35caAc005e15888dDb8A3515C41B4872",
          wormholeRelayer: "0x4cb69FaE7e7Af841e44E1A1c30Af640739378bb2",
          wormhole: "0x2703483B1a5a7c577e8680de9Df8Be03c6f30e3c"
        }
      ],
      [
        "Solana",
        {
          tokenMessenger: "CCTPiPYPc6AsJuwueEnWgSgucamXDZwBd53dQ11YiKX3",
          messageTransmitter: "CCTPmbSD7gX1bxKPAmg77w8oFzNFpaQiQUWD43TKaecd",
          wormholeRelayer: "",
          wormhole: ""
        }
      ],
      [
        "BaseSepolia",
        {
          tokenMessenger: "0x9f3B8679c73C2Fef8b59B4f3444d4e156fb70AA5",
          messageTransmitter: "0x7865fAfC2db2093669d92c0F33AeEF291086BEFD",
          wormholeRelayer: "0x4cb69FaE7e7Af841e44E1A1c30Af640739378bb2",
          wormhole: "0x2703483B1a5a7c577e8680de9Df8Be03c6f30e3c"
        }
      ],
      [
        "Polygon",
        {
          tokenMessenger: "0x9f3B8679c73C2Fef8b59B4f3444d4e156fb70AA5",
          messageTransmitter: "0xe09A679F56207EF33F5b9d8fb4499Ec00792eA73",
          wormholeRelayer: "0x4cb69FaE7e7Af841e44E1A1c30Af640739378bb2",
          wormhole: "0x2703483B1a5a7c577e8680de9Df8Be03c6f30e3c"
        }
      ],
      [
        "Sui",
        {
          tokenMessenger: "0x31cc14d80c175ae39777c0238f20594c6d4869cfab199f40b69f3319956b8beb",
          messageTransmitter: "0x4931e06dce648b3931f890035bd196920770e913e43e45990b383f6486fdd0a5",
          wormholeRelayer: "",
          wormhole: ""
        }
      ]
    ]
  ]
], gatewayContracts = [
  [
    "Mainnet",
    [
      ["Wormchain", "wormhole14ejqjyq8um4p3xfqj74yld5waqljf88fz25yxnma0cngspxe3les00fpjx"]
    ]
  ],
  [
    "Testnet",
    [
      ["Wormchain", "wormhole1ctnjk7an90lz5wjfvr3cf6x984a8cjnv8dpmztmlpcq4xteaa2xs9pwmzk"]
    ]
  ]
], translatorContracts = [
  [
    "Mainnet",
    [
      ["Sei", "sei189adguawugk3e55zn63z8r9ll29xrjwca636ra7v7gxuzn98sxyqwzt47l"]
    ]
  ],
  [
    "Testnet",
    [
      ["Sei", "sei1dkdwdvknx0qav5cp5kw68mkn3r99m3svkyjfvkztwh97dv2lm0ksj6xrak"]
    ]
  ]
], rollupContractAddresses = [
  [
    "Mainnet",
    [
      ["Polygon", ["Ethereum", "0x86E4Dc95c7FBdBf52e33D563BbDB00823894C287"]],
      ["Optimism", ["Ethereum", "0xdfe97868233d1aa22e815a266982f2cf17685a27"]],
      ["Arbitrum", ["Ethereum", "0x1c479675ad559dc151f6ec7ed3fbf8cee79582b6"]]
    ]
  ],
  [
    "Testnet",
    [
      ["Polygon", ["Ethereum", "0x2890ba17efe978480615e330ecb65333b880928e"]],
      ["Optimism", ["Ethereum", "0xe6dfba0953616bacab0c9a8ecb3a9bba77fc15c0"]],
      ["Arbitrum", ["Ethereum", "0x45af9ed1d03703e480ce7d328fb684bb67da5049"]]
      // TODO double check
    ]
  ]
], porticoContracts = [
  [
    "Mainnet",
    [
      ["Ethereum", {
        porticoUniswap: "0x48b6101128C0ed1E208b7C910e60542A2ee6f476",
        uniswapQuoterV2: "0x61fFE014bA17989E743c5F6cB21bF9697530B21e",
        porticoPancakeSwap: "0x4db1683d60e0a933A9A477a19FA32F472bB9d06e",
        pancakeSwapQuoterV2: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997"
      }],
      ["Polygon", {
        porticoUniswap: "0x227bABe533fa9a1085f5261210E0B7137E44437B",
        uniswapQuoterV2: "0x61fFE014bA17989E743c5F6cB21bF9697530B21e",
        porticoPancakeSwap: void 0,
        pancakeSwapQuoterV2: void 0
      }],
      ["Bsc", {
        porticoUniswap: "0x05498574BD0Fa99eeCB01e1241661E7eE58F8a85",
        uniswapQuoterV2: "0x78D78E420Da98ad378D7799bE8f4AF69033EB077",
        porticoPancakeSwap: "0xF352DC165783538A26e38A536e76DceF227d90F2",
        pancakeSwapQuoterV2: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997"
      }],
      ["Avalanche", {
        porticoUniswap: "0xE565E118e75304dD3cF83dff409c90034b7EA18a",
        uniswapQuoterV2: "0xbe0F5544EC67e9B3b2D979aaA43f18Fd87E6257F",
        porticoPancakeSwap: void 0,
        pancakeSwapQuoterV2: void 0
      }],
      ["Arbitrum", {
        porticoUniswap: "0x48fa7528bFD6164DdF09dF0Ed22451cF59c84130",
        uniswapQuoterV2: "0x61fFE014bA17989E743c5F6cB21bF9697530B21e",
        porticoPancakeSwap: "0xE70946692E2e56ae47BfAe2d93d31bd60952B090",
        pancakeSwapQuoterV2: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997"
      }],
      ["Optimism", {
        porticoUniswap: "0x9ae506cDDd27DEe1275fd1fe6627E5dc65257061",
        uniswapQuoterV2: "0x61fFE014bA17989E743c5F6cB21bF9697530B21e",
        porticoPancakeSwap: void 0,
        pancakeSwapQuoterV2: void 0
      }],
      ["Base", {
        porticoUniswap: "0x610d4DFAC3EC32e0be98D18DDb280DACD76A1889",
        uniswapQuoterV2: "0x3d4e44Eb1374240CE5F1B871ab261CD16335B76a",
        porticoPancakeSwap: "0x4568aa1eA0ED54db666c58B4526B3FC9BD9be9bf",
        pancakeSwapQuoterV2: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997"
      }],
      ["Celo", {
        porticoUniswap: "0xE565E118e75304dD3cF83dff409c90034b7EA18a",
        uniswapQuoterV2: "0x82825d0554fA07f7FC52Ab63c961F330fdEFa8E8",
        porticoPancakeSwap: void 0,
        pancakeSwapQuoterV2: void 0
      }]
    ]
  ]
], coreBridge = constMap(coreBridgeContracts), tokenBridge = constMap(tokenBridgeContracts), tokenBridgeRelayer = constMap(tokenBridgeRelayerContracts), nftBridge = constMap(nftBridgeContracts), relayer = constMap(relayerContracts), gateway = constMap(gatewayContracts), translator = constMap(translatorContracts), portico = constMap(porticoContracts), circleContracts = constMap(circleContracts$1);
constMap(rollupContractAddresses);
const tokenBridgeChains = constMap(tokenBridgeContracts, [0, 1]), tokenBridgeRelayerChains = constMap(tokenBridgeRelayerContracts, [0, 1]), circleContractChains = constMap(circleContracts$1, [0, 1]), porticoContractChains = constMap(porticoContracts, [0, 1]), guardianKeyAndNameEntries = [
  [
    "Mainnet",
    [
      ["0x58CC3AE5C097b213cE3c81979e1B9f9570746AA5", "JumpCrypto"],
      ["0xfF6CB952589BDE862c25Ef4392132fb9D4A42157", "Staked"],
      ["0x114De8460193bdf3A2fCf81f86a09765F4762fD1", "Figment"],
      ["0x107A0086b32d7A0977926A205131d8731D39cbEB", "ChainodeTech"],
      ["0x8C82B2fd82FaeD2711d59AF0F2499D16e726f6b2", "Inotel"],
      ["0x11b39756C042441BE6D8650b69b54EbE715E2343", "HashQuark"],
      ["0x54Ce5B4D348fb74B958e8966e2ec3dBd4958a7cd", "Chainlayer"],
      ["0x15e7cAF07C4e3DC8e7C469f92C8Cd88FB8005a20", "xLabs"],
      ["0x74a3bf913953D695260D88BC1aA25A4eeE363ef0", "Forbole"],
      ["0x000aC0076727b35FBea2dAc28fEE5cCB0fEA768e", "StakingFund"],
      ["0xAF45Ced136b9D9e24903464AE889F5C8a723FC14", "MoonletWallet"],
      ["0xf93124b7c738843CBB89E864c862c38cddCccF95", "P2PValidator"],
      ["0xD2CC37A4dc036a8D232b48f62cDD4731412f4890", "01Node"],
      ["0xDA798F6896A3331F64b48c12D1D57Fd9cbe70811", "MCF"],
      ["0x71AA1BE1D36CaFE3867910F99C09e347899C19C3", "Everstake"],
      ["0x8192b6E7387CCd768277c17DAb1b7a5027c0b3Cf", "ChorusOne"],
      ["0x178e21ad2E77AE06711549CFBB1f9c7a9d8096e8", "Syncnode"],
      ["0x5E1487F35515d02A92753504a8D75471b9f49EdB", "Triton"],
      ["0x6FbEBc898F403E4773E95feB15E80C9A99c8348d", "StakingFacilities"]
    ]
  ],
  [
    "Testnet",
    [
      ["0x13947Bd48b18E53fdAeEe77F3473391aC727C638", "Testnet guardian"]
    ]
  ]
];
filterIndexes(zip(cartesianRightRecursive(guardianKeyAndNameEntries)), [1, 2]);
constMap(guardianKeyAndNameEntries, [[0, 2], 1]);
constMap(guardianKeyAndNameEntries, [1, [0, 2]]);
const guardianAttestationEta = 5;
function anumber$1(C) {
  if (!Number.isSafeInteger(C) || C < 0)
    throw new Error("positive integer expected, got " + C);
}
function isBytes$2(C) {
  return C instanceof Uint8Array || ArrayBuffer.isView(C) && C.constructor.name === "Uint8Array";
}
function abytes$2(C, ...e) {
  if (!isBytes$2(C))
    throw new Error("Uint8Array expected");
  if (e.length > 0 && !e.includes(C.length))
    throw new Error("Uint8Array expected of length " + e + ", got length=" + C.length);
}
function ahash$1(C) {
  if (typeof C != "function" || typeof C.create != "function")
    throw new Error("Hash should be wrapped by utils.wrapConstructor");
  anumber$1(C.outputLen), anumber$1(C.blockLen);
}
function aexists$1(C, e = !0) {
  if (C.destroyed)
    throw new Error("Hash instance has been destroyed");
  if (e && C.finished)
    throw new Error("Hash#digest() has already been called");
}
function aoutput$1(C, e) {
  abytes$2(C);
  const T = e.outputLen;
  if (C.length < T)
    throw new Error("digestInto() expects output buffer of length at least " + T);
}
const crypto$2 = typeof globalThis == "object" && "crypto" in globalThis ? globalThis.crypto : void 0;
/*! noble-hashes - MIT License (c) 2022 Paul Miller (paulmillr.com) */
const u32$2 = (C) => new Uint32Array(C.buffer, C.byteOffset, Math.floor(C.byteLength / 4)), createView$1 = (C) => new DataView(C.buffer, C.byteOffset, C.byteLength), rotr$1 = (C, e) => C << 32 - e | C >>> e, rotl = (C, e) => C << e | C >>> 32 - e >>> 0, isLE = new Uint8Array(new Uint32Array([287454020]).buffer)[0] === 68, byteSwap = (C) => C << 24 & 4278190080 | C << 8 & 16711680 | C >>> 8 & 65280 | C >>> 24 & 255, byteSwapIfBE = isLE ? (C) => C : (C) => byteSwap(C);
function byteSwap32(C) {
  for (let e = 0; e < C.length; e++)
    C[e] = byteSwap(C[e]);
}
const hexes$1 = /* @__PURE__ */ Array.from({ length: 256 }, (C, e) => e.toString(16).padStart(2, "0"));
function bytesToHex$1(C) {
  abytes$2(C);
  let e = "";
  for (let T = 0; T < C.length; T++)
    e += hexes$1[C[T]];
  return e;
}
const asciis$1 = { _0: 48, _9: 57, A: 65, F: 70, a: 97, f: 102 };
function asciiToBase16$1(C) {
  if (C >= asciis$1._0 && C <= asciis$1._9)
    return C - asciis$1._0;
  if (C >= asciis$1.A && C <= asciis$1.F)
    return C - (asciis$1.A - 10);
  if (C >= asciis$1.a && C <= asciis$1.f)
    return C - (asciis$1.a - 10);
}
function hexToBytes$1(C) {
  if (typeof C != "string")
    throw new Error("hex string expected, got " + typeof C);
  const e = C.length, T = e / 2;
  if (e % 2)
    throw new Error("hex string expected, got unpadded hex of length " + e);
  const $ = new Uint8Array(T);
  for (let V = 0, J = 0; V < T; V++, J += 2) {
    const ee = asciiToBase16$1(C.charCodeAt(J)), te = asciiToBase16$1(C.charCodeAt(J + 1));
    if (ee === void 0 || te === void 0) {
      const re = C[J] + C[J + 1];
      throw new Error('hex string expected, got non-hex character "' + re + '" at index ' + J);
    }
    $[V] = ee * 16 + te;
  }
  return $;
}
function utf8ToBytes$2(C) {
  if (typeof C != "string")
    throw new Error("utf8ToBytes expected string, got " + typeof C);
  return new Uint8Array(new TextEncoder().encode(C));
}
function toBytes$2(C) {
  return typeof C == "string" && (C = utf8ToBytes$2(C)), abytes$2(C), C;
}
function concatBytes$2(...C) {
  let e = 0;
  for (let $ = 0; $ < C.length; $++) {
    const V = C[$];
    abytes$2(V), e += V.length;
  }
  const T = new Uint8Array(e);
  for (let $ = 0, V = 0; $ < C.length; $++) {
    const J = C[$];
    T.set(J, V), V += J.length;
  }
  return T;
}
let Hash$1 = class {
  // Safe version that clones internal state
  clone() {
    return this._cloneInto();
  }
};
function checkOpts(C, e) {
  if (e !== void 0 && {}.toString.call(e) !== "[object Object]")
    throw new Error("Options should be object or undefined");
  return Object.assign(C, e);
}
function wrapConstructor$1(C) {
  const e = ($) => C().update(toBytes$2($)).digest(), T = C();
  return e.outputLen = T.outputLen, e.blockLen = T.blockLen, e.create = () => C(), e;
}
function wrapConstructorWithOpts(C) {
  const e = ($, V) => C(V).update(toBytes$2($)).digest(), T = C({});
  return e.outputLen = T.outputLen, e.blockLen = T.blockLen, e.create = ($) => C($), e;
}
function randomBytes$1(C = 32) {
  if (crypto$2 && typeof crypto$2.getRandomValues == "function")
    return crypto$2.getRandomValues(new Uint8Array(C));
  if (crypto$2 && typeof crypto$2.randomBytes == "function")
    return crypto$2.randomBytes(C);
  throw new Error("crypto.getRandomValues must be defined");
}
function setBigUint64$1(C, e, T, $) {
  if (typeof C.setBigUint64 == "function")
    return C.setBigUint64(e, T, $);
  const V = BigInt(32), J = BigInt(4294967295), ee = Number(T >> V & J), te = Number(T & J), re = $ ? 4 : 0, ie = $ ? 0 : 4;
  C.setUint32(e + re, ee, $), C.setUint32(e + ie, te, $);
}
const Chi$1 = (C, e, T) => C & e ^ ~C & T, Maj$1 = (C, e, T) => C & e ^ C & T ^ e & T;
let HashMD$1 = class extends Hash$1 {
  constructor(e, T, $, V) {
    super(), this.blockLen = e, this.outputLen = T, this.padOffset = $, this.isLE = V, this.finished = !1, this.length = 0, this.pos = 0, this.destroyed = !1, this.buffer = new Uint8Array(e), this.view = createView$1(this.buffer);
  }
  update(e) {
    aexists$1(this);
    const { view: T, buffer: $, blockLen: V } = this;
    e = toBytes$2(e);
    const J = e.length;
    for (let ee = 0; ee < J; ) {
      const te = Math.min(V - this.pos, J - ee);
      if (te === V) {
        const re = createView$1(e);
        for (; V <= J - ee; ee += V)
          this.process(re, ee);
        continue;
      }
      $.set(e.subarray(ee, ee + te), this.pos), this.pos += te, ee += te, this.pos === V && (this.process(T, 0), this.pos = 0);
    }
    return this.length += e.length, this.roundClean(), this;
  }
  digestInto(e) {
    aexists$1(this), aoutput$1(e, this), this.finished = !0;
    const { buffer: T, view: $, blockLen: V, isLE: J } = this;
    let { pos: ee } = this;
    T[ee++] = 128, this.buffer.subarray(ee).fill(0), this.padOffset > V - ee && (this.process($, 0), ee = 0);
    for (let de = ee; de < V; de++)
      T[de] = 0;
    setBigUint64$1($, V - 8, BigInt(this.length * 8), J), this.process($, 0);
    const te = createView$1(e), re = this.outputLen;
    if (re % 4)
      throw new Error("_sha2: outputLen should be aligned to 32bit");
    const ie = re / 4, se = this.get();
    if (ie > se.length)
      throw new Error("_sha2: outputLen bigger than state");
    for (let de = 0; de < ie; de++)
      te.setUint32(4 * de, se[de], J);
  }
  digest() {
    const { buffer: e, outputLen: T } = this;
    this.digestInto(e);
    const $ = e.slice(0, T);
    return this.destroy(), $;
  }
  _cloneInto(e) {
    e || (e = new this.constructor()), e.set(...this.get());
    const { blockLen: T, buffer: $, length: V, finished: J, destroyed: ee, pos: te } = this;
    return e.length = V, e.pos = te, e.finished = J, e.destroyed = ee, V % T && e.buffer.set($), e;
  }
};
const SHA256_K$1 = /* @__PURE__ */ new Uint32Array([
  1116352408,
  1899447441,
  3049323471,
  3921009573,
  961987163,
  1508970993,
  2453635748,
  2870763221,
  3624381080,
  310598401,
  607225278,
  1426881987,
  1925078388,
  2162078206,
  2614888103,
  3248222580,
  3835390401,
  4022224774,
  264347078,
  604807628,
  770255983,
  1249150122,
  1555081692,
  1996064986,
  2554220882,
  2821834349,
  2952996808,
  3210313671,
  3336571891,
  3584528711,
  113926993,
  338241895,
  666307205,
  773529912,
  1294757372,
  1396182291,
  1695183700,
  1986661051,
  2177026350,
  2456956037,
  2730485921,
  2820302411,
  3259730800,
  3345764771,
  3516065817,
  3600352804,
  4094571909,
  275423344,
  430227734,
  506948616,
  659060556,
  883997877,
  958139571,
  1322822218,
  1537002063,
  1747873779,
  1955562222,
  2024104815,
  2227730452,
  2361852424,
  2428436474,
  2756734187,
  3204031479,
  3329325298
]), SHA256_IV$1 = /* @__PURE__ */ new Uint32Array([
  1779033703,
  3144134277,
  1013904242,
  2773480762,
  1359893119,
  2600822924,
  528734635,
  1541459225
]), SHA256_W$1 = /* @__PURE__ */ new Uint32Array(64);
let SHA256$1 = class extends HashMD$1 {
  constructor() {
    super(64, 32, 8, !1), this.A = SHA256_IV$1[0] | 0, this.B = SHA256_IV$1[1] | 0, this.C = SHA256_IV$1[2] | 0, this.D = SHA256_IV$1[3] | 0, this.E = SHA256_IV$1[4] | 0, this.F = SHA256_IV$1[5] | 0, this.G = SHA256_IV$1[6] | 0, this.H = SHA256_IV$1[7] | 0;
  }
  get() {
    const { A: e, B: T, C: $, D: V, E: J, F: ee, G: te, H: re } = this;
    return [e, T, $, V, J, ee, te, re];
  }
  // prettier-ignore
  set(e, T, $, V, J, ee, te, re) {
    this.A = e | 0, this.B = T | 0, this.C = $ | 0, this.D = V | 0, this.E = J | 0, this.F = ee | 0, this.G = te | 0, this.H = re | 0;
  }
  process(e, T) {
    for (let de = 0; de < 16; de++, T += 4)
      SHA256_W$1[de] = e.getUint32(T, !1);
    for (let de = 16; de < 64; de++) {
      const ue = SHA256_W$1[de - 15], fe = SHA256_W$1[de - 2], he = rotr$1(ue, 7) ^ rotr$1(ue, 18) ^ ue >>> 3, me = rotr$1(fe, 17) ^ rotr$1(fe, 19) ^ fe >>> 10;
      SHA256_W$1[de] = me + SHA256_W$1[de - 7] + he + SHA256_W$1[de - 16] | 0;
    }
    let { A: $, B: V, C: J, D: ee, E: te, F: re, G: ie, H: se } = this;
    for (let de = 0; de < 64; de++) {
      const ue = rotr$1(te, 6) ^ rotr$1(te, 11) ^ rotr$1(te, 25), fe = se + ue + Chi$1(te, re, ie) + SHA256_K$1[de] + SHA256_W$1[de] | 0, me = (rotr$1($, 2) ^ rotr$1($, 13) ^ rotr$1($, 22)) + Maj$1($, V, J) | 0;
      se = ie, ie = re, re = te, te = ee + fe | 0, ee = J, J = V, V = $, $ = fe + me | 0;
    }
    $ = $ + this.A | 0, V = V + this.B | 0, J = J + this.C | 0, ee = ee + this.D | 0, te = te + this.E | 0, re = re + this.F | 0, ie = ie + this.G | 0, se = se + this.H | 0, this.set($, V, J, ee, te, re, ie, se);
  }
  roundClean() {
    SHA256_W$1.fill(0);
  }
  destroy() {
    this.set(0, 0, 0, 0, 0, 0, 0, 0), this.buffer.fill(0);
  }
};
const sha256$5 = /* @__PURE__ */ wrapConstructor$1(() => new SHA256$1()), U32_MASK64$1 = /* @__PURE__ */ BigInt(2 ** 32 - 1), _32n$1 = /* @__PURE__ */ BigInt(32);
function fromBig$1(C, e = !1) {
  return e ? { h: Number(C & U32_MASK64$1), l: Number(C >> _32n$1 & U32_MASK64$1) } : { h: Number(C >> _32n$1 & U32_MASK64$1) | 0, l: Number(C & U32_MASK64$1) | 0 };
}
function split$1(C, e = !1) {
  let T = new Uint32Array(C.length), $ = new Uint32Array(C.length);
  for (let V = 0; V < C.length; V++) {
    const { h: J, l: ee } = fromBig$1(C[V], e);
    [T[V], $[V]] = [J, ee];
  }
  return [T, $];
}
const toBig$1 = (C, e) => BigInt(C >>> 0) << _32n$1 | BigInt(e >>> 0), shrSH$1 = (C, e, T) => C >>> T, shrSL$1 = (C, e, T) => C << 32 - T | e >>> T, rotrSH$1 = (C, e, T) => C >>> T | e << 32 - T, rotrSL$1 = (C, e, T) => C << 32 - T | e >>> T, rotrBH$1 = (C, e, T) => C << 64 - T | e >>> T - 32, rotrBL$1 = (C, e, T) => C >>> T - 32 | e << 64 - T, rotr32H$1 = (C, e) => e, rotr32L$1 = (C, e) => C, rotlSH$1 = (C, e, T) => C << T | e >>> 32 - T, rotlSL$1 = (C, e, T) => e << T | C >>> 32 - T, rotlBH$1 = (C, e, T) => e << T - 32 | C >>> 64 - T, rotlBL$1 = (C, e, T) => C << T - 32 | e >>> 64 - T;
function add$1(C, e, T, $) {
  const V = (e >>> 0) + ($ >>> 0);
  return { h: C + T + (V / 2 ** 32 | 0) | 0, l: V | 0 };
}
const add3L$1 = (C, e, T) => (C >>> 0) + (e >>> 0) + (T >>> 0), add3H$1 = (C, e, T, $) => e + T + $ + (C / 2 ** 32 | 0) | 0, add4L$1 = (C, e, T, $) => (C >>> 0) + (e >>> 0) + (T >>> 0) + ($ >>> 0), add4H$1 = (C, e, T, $, V) => e + T + $ + V + (C / 2 ** 32 | 0) | 0, add5L$1 = (C, e, T, $, V) => (C >>> 0) + (e >>> 0) + (T >>> 0) + ($ >>> 0) + (V >>> 0), add5H$1 = (C, e, T, $, V, J) => e + T + $ + V + J + (C / 2 ** 32 | 0) | 0, u64$4 = {
  fromBig: fromBig$1,
  split: split$1,
  toBig: toBig$1,
  shrSH: shrSH$1,
  shrSL: shrSL$1,
  rotrSH: rotrSH$1,
  rotrSL: rotrSL$1,
  rotrBH: rotrBH$1,
  rotrBL: rotrBL$1,
  rotr32H: rotr32H$1,
  rotr32L: rotr32L$1,
  rotlSH: rotlSH$1,
  rotlSL: rotlSL$1,
  rotlBH: rotlBH$1,
  rotlBL: rotlBL$1,
  add: add$1,
  add3L: add3L$1,
  add3H: add3H$1,
  add4L: add4L$1,
  add4H: add4H$1,
  add5H: add5H$1,
  add5L: add5L$1
}, SHA3_PI = [], SHA3_ROTL = [], _SHA3_IOTA = [], _0n$5 = /* @__PURE__ */ BigInt(0), _1n$7 = /* @__PURE__ */ BigInt(1), _2n$5 = /* @__PURE__ */ BigInt(2), _7n = /* @__PURE__ */ BigInt(7), _256n = /* @__PURE__ */ BigInt(256), _0x71n = /* @__PURE__ */ BigInt(113);
for (let C = 0, e = _1n$7, T = 1, $ = 0; C < 24; C++) {
  [T, $] = [$, (2 * T + 3 * $) % 5], SHA3_PI.push(2 * (5 * $ + T)), SHA3_ROTL.push((C + 1) * (C + 2) / 2 % 64);
  let V = _0n$5;
  for (let J = 0; J < 7; J++)
    e = (e << _1n$7 ^ (e >> _7n) * _0x71n) % _256n, e & _2n$5 && (V ^= _1n$7 << (_1n$7 << /* @__PURE__ */ BigInt(J)) - _1n$7);
  _SHA3_IOTA.push(V);
}
const [SHA3_IOTA_H, SHA3_IOTA_L] = /* @__PURE__ */ split$1(_SHA3_IOTA, !0), rotlH = (C, e, T) => T > 32 ? rotlBH$1(C, e, T) : rotlSH$1(C, e, T), rotlL = (C, e, T) => T > 32 ? rotlBL$1(C, e, T) : rotlSL$1(C, e, T);
function keccakP(C, e = 24) {
  const T = new Uint32Array(10);
  for (let $ = 24 - e; $ < 24; $++) {
    for (let ee = 0; ee < 10; ee++)
      T[ee] = C[ee] ^ C[ee + 10] ^ C[ee + 20] ^ C[ee + 30] ^ C[ee + 40];
    for (let ee = 0; ee < 10; ee += 2) {
      const te = (ee + 8) % 10, re = (ee + 2) % 10, ie = T[re], se = T[re + 1], de = rotlH(ie, se, 1) ^ T[te], ue = rotlL(ie, se, 1) ^ T[te + 1];
      for (let fe = 0; fe < 50; fe += 10)
        C[ee + fe] ^= de, C[ee + fe + 1] ^= ue;
    }
    let V = C[2], J = C[3];
    for (let ee = 0; ee < 24; ee++) {
      const te = SHA3_ROTL[ee], re = rotlH(V, J, te), ie = rotlL(V, J, te), se = SHA3_PI[ee];
      V = C[se], J = C[se + 1], C[se] = re, C[se + 1] = ie;
    }
    for (let ee = 0; ee < 50; ee += 10) {
      for (let te = 0; te < 10; te++)
        T[te] = C[ee + te];
      for (let te = 0; te < 10; te++)
        C[ee + te] ^= ~T[(te + 2) % 10] & T[(te + 4) % 10];
    }
    C[0] ^= SHA3_IOTA_H[$], C[1] ^= SHA3_IOTA_L[$];
  }
  T.fill(0);
}
class Keccak extends Hash$1 {
  // NOTE: we accept arguments in bytes instead of bits here.
  constructor(e, T, $, V = !1, J = 24) {
    if (super(), this.blockLen = e, this.suffix = T, this.outputLen = $, this.enableXOF = V, this.rounds = J, this.pos = 0, this.posOut = 0, this.finished = !1, this.destroyed = !1, anumber$1($), 0 >= this.blockLen || this.blockLen >= 200)
      throw new Error("Sha3 supports only keccak-f1600 function");
    this.state = new Uint8Array(200), this.state32 = u32$2(this.state);
  }
  keccak() {
    isLE || byteSwap32(this.state32), keccakP(this.state32, this.rounds), isLE || byteSwap32(this.state32), this.posOut = 0, this.pos = 0;
  }
  update(e) {
    aexists$1(this);
    const { blockLen: T, state: $ } = this;
    e = toBytes$2(e);
    const V = e.length;
    for (let J = 0; J < V; ) {
      const ee = Math.min(T - this.pos, V - J);
      for (let te = 0; te < ee; te++)
        $[this.pos++] ^= e[J++];
      this.pos === T && this.keccak();
    }
    return this;
  }
  finish() {
    if (this.finished)
      return;
    this.finished = !0;
    const { state: e, suffix: T, pos: $, blockLen: V } = this;
    e[$] ^= T, T & 128 && $ === V - 1 && this.keccak(), e[V - 1] ^= 128, this.keccak();
  }
  writeInto(e) {
    aexists$1(this, !1), abytes$2(e), this.finish();
    const T = this.state, { blockLen: $ } = this;
    for (let V = 0, J = e.length; V < J; ) {
      this.posOut >= $ && this.keccak();
      const ee = Math.min($ - this.posOut, J - V);
      e.set(T.subarray(this.posOut, this.posOut + ee), V), this.posOut += ee, V += ee;
    }
    return e;
  }
  xofInto(e) {
    if (!this.enableXOF)
      throw new Error("XOF is not possible for this instance");
    return this.writeInto(e);
  }
  xof(e) {
    return anumber$1(e), this.xofInto(new Uint8Array(e));
  }
  digestInto(e) {
    if (aoutput$1(e, this), this.finished)
      throw new Error("digest() was already called");
    return this.writeInto(e), this.destroy(), e;
  }
  digest() {
    return this.digestInto(new Uint8Array(this.outputLen));
  }
  destroy() {
    this.destroyed = !0, this.state.fill(0);
  }
  _cloneInto(e) {
    const { blockLen: T, suffix: $, outputLen: V, rounds: J, enableXOF: ee } = this;
    return e || (e = new Keccak(T, $, V, ee, J)), e.state32.set(this.state32), e.pos = this.pos, e.posOut = this.posOut, e.finished = this.finished, e.rounds = J, e.suffix = $, e.outputLen = V, e.enableXOF = ee, e.destroyed = this.destroyed, e;
  }
}
const gen = (C, e, T) => wrapConstructor$1(() => new Keccak(e, C, T)), sha3_256 = /* @__PURE__ */ gen(6, 136, 256 / 8), keccak_256 = /* @__PURE__ */ gen(1, 136, 256 / 8), [SHA512_Kh$1, SHA512_Kl$1] = u64$4.split([
  "0x428a2f98d728ae22",
  "0x7137449123ef65cd",
  "0xb5c0fbcfec4d3b2f",
  "0xe9b5dba58189dbbc",
  "0x3956c25bf348b538",
  "0x59f111f1b605d019",
  "0x923f82a4af194f9b",
  "0xab1c5ed5da6d8118",
  "0xd807aa98a3030242",
  "0x12835b0145706fbe",
  "0x243185be4ee4b28c",
  "0x550c7dc3d5ffb4e2",
  "0x72be5d74f27b896f",
  "0x80deb1fe3b1696b1",
  "0x9bdc06a725c71235",
  "0xc19bf174cf692694",
  "0xe49b69c19ef14ad2",
  "0xefbe4786384f25e3",
  "0x0fc19dc68b8cd5b5",
  "0x240ca1cc77ac9c65",
  "0x2de92c6f592b0275",
  "0x4a7484aa6ea6e483",
  "0x5cb0a9dcbd41fbd4",
  "0x76f988da831153b5",
  "0x983e5152ee66dfab",
  "0xa831c66d2db43210",
  "0xb00327c898fb213f",
  "0xbf597fc7beef0ee4",
  "0xc6e00bf33da88fc2",
  "0xd5a79147930aa725",
  "0x06ca6351e003826f",
  "0x142929670a0e6e70",
  "0x27b70a8546d22ffc",
  "0x2e1b21385c26c926",
  "0x4d2c6dfc5ac42aed",
  "0x53380d139d95b3df",
  "0x650a73548baf63de",
  "0x766a0abb3c77b2a8",
  "0x81c2c92e47edaee6",
  "0x92722c851482353b",
  "0xa2bfe8a14cf10364",
  "0xa81a664bbc423001",
  "0xc24b8b70d0f89791",
  "0xc76c51a30654be30",
  "0xd192e819d6ef5218",
  "0xd69906245565a910",
  "0xf40e35855771202a",
  "0x106aa07032bbd1b8",
  "0x19a4c116b8d2d0c8",
  "0x1e376c085141ab53",
  "0x2748774cdf8eeb99",
  "0x34b0bcb5e19b48a8",
  "0x391c0cb3c5c95a63",
  "0x4ed8aa4ae3418acb",
  "0x5b9cca4f7763e373",
  "0x682e6ff3d6b2b8a3",
  "0x748f82ee5defb2fc",
  "0x78a5636f43172f60",
  "0x84c87814a1f0ab72",
  "0x8cc702081a6439ec",
  "0x90befffa23631e28",
  "0xa4506cebde82bde9",
  "0xbef9a3f7b2c67915",
  "0xc67178f2e372532b",
  "0xca273eceea26619c",
  "0xd186b8c721c0c207",
  "0xeada7dd6cde0eb1e",
  "0xf57d4f7fee6ed178",
  "0x06f067aa72176fba",
  "0x0a637dc5a2c898a6",
  "0x113f9804bef90dae",
  "0x1b710b35131c471b",
  "0x28db77f523047d84",
  "0x32caab7b40c72493",
  "0x3c9ebe0a15c9bebc",
  "0x431d67c49c100d4c",
  "0x4cc5d4becb3e42b6",
  "0x597f299cfc657e2a",
  "0x5fcb6fab3ad6faec",
  "0x6c44198c4a475817"
].map((C) => BigInt(C))), SHA512_W_H$1 = /* @__PURE__ */ new Uint32Array(80), SHA512_W_L$1 = /* @__PURE__ */ new Uint32Array(80);
let SHA512$1 = class extends HashMD$1 {
  constructor() {
    super(128, 64, 16, !1), this.Ah = 1779033703, this.Al = -205731576, this.Bh = -1150833019, this.Bl = -2067093701, this.Ch = 1013904242, this.Cl = -23791573, this.Dh = -1521486534, this.Dl = 1595750129, this.Eh = 1359893119, this.El = -1377402159, this.Fh = -1694144372, this.Fl = 725511199, this.Gh = 528734635, this.Gl = -79577749, this.Hh = 1541459225, this.Hl = 327033209;
  }
  // prettier-ignore
  get() {
    const { Ah: e, Al: T, Bh: $, Bl: V, Ch: J, Cl: ee, Dh: te, Dl: re, Eh: ie, El: se, Fh: de, Fl: ue, Gh: fe, Gl: he, Hh: me, Hl: xe } = this;
    return [e, T, $, V, J, ee, te, re, ie, se, de, ue, fe, he, me, xe];
  }
  // prettier-ignore
  set(e, T, $, V, J, ee, te, re, ie, se, de, ue, fe, he, me, xe) {
    this.Ah = e | 0, this.Al = T | 0, this.Bh = $ | 0, this.Bl = V | 0, this.Ch = J | 0, this.Cl = ee | 0, this.Dh = te | 0, this.Dl = re | 0, this.Eh = ie | 0, this.El = se | 0, this.Fh = de | 0, this.Fl = ue | 0, this.Gh = fe | 0, this.Gl = he | 0, this.Hh = me | 0, this.Hl = xe | 0;
  }
  process(e, T) {
    for (let we = 0; we < 16; we++, T += 4)
      SHA512_W_H$1[we] = e.getUint32(T), SHA512_W_L$1[we] = e.getUint32(T += 4);
    for (let we = 16; we < 80; we++) {
      const Ee = SHA512_W_H$1[we - 15] | 0, Me = SHA512_W_L$1[we - 15] | 0, Ie = u64$4.rotrSH(Ee, Me, 1) ^ u64$4.rotrSH(Ee, Me, 8) ^ u64$4.shrSH(Ee, Me, 7), ke = u64$4.rotrSL(Ee, Me, 1) ^ u64$4.rotrSL(Ee, Me, 8) ^ u64$4.shrSL(Ee, Me, 7), _e = SHA512_W_H$1[we - 2] | 0, De = SHA512_W_L$1[we - 2] | 0, Fe = u64$4.rotrSH(_e, De, 19) ^ u64$4.rotrBH(_e, De, 61) ^ u64$4.shrSH(_e, De, 6), Ae = u64$4.rotrSL(_e, De, 19) ^ u64$4.rotrBL(_e, De, 61) ^ u64$4.shrSL(_e, De, 6), ne = u64$4.add4L(ke, Ae, SHA512_W_L$1[we - 7], SHA512_W_L$1[we - 16]), oe = u64$4.add4H(ne, Ie, Fe, SHA512_W_H$1[we - 7], SHA512_W_H$1[we - 16]);
      SHA512_W_H$1[we] = oe | 0, SHA512_W_L$1[we] = ne | 0;
    }
    let { Ah: $, Al: V, Bh: J, Bl: ee, Ch: te, Cl: re, Dh: ie, Dl: se, Eh: de, El: ue, Fh: fe, Fl: he, Gh: me, Gl: xe, Hh: ve, Hl: Te } = this;
    for (let we = 0; we < 80; we++) {
      const Ee = u64$4.rotrSH(de, ue, 14) ^ u64$4.rotrSH(de, ue, 18) ^ u64$4.rotrBH(de, ue, 41), Me = u64$4.rotrSL(de, ue, 14) ^ u64$4.rotrSL(de, ue, 18) ^ u64$4.rotrBL(de, ue, 41), Ie = de & fe ^ ~de & me, ke = ue & he ^ ~ue & xe, _e = u64$4.add5L(Te, Me, ke, SHA512_Kl$1[we], SHA512_W_L$1[we]), De = u64$4.add5H(_e, ve, Ee, Ie, SHA512_Kh$1[we], SHA512_W_H$1[we]), Fe = _e | 0, Ae = u64$4.rotrSH($, V, 28) ^ u64$4.rotrBH($, V, 34) ^ u64$4.rotrBH($, V, 39), ne = u64$4.rotrSL($, V, 28) ^ u64$4.rotrBL($, V, 34) ^ u64$4.rotrBL($, V, 39), oe = $ & J ^ $ & te ^ J & te, ce = V & ee ^ V & re ^ ee & re;
      ve = me | 0, Te = xe | 0, me = fe | 0, xe = he | 0, fe = de | 0, he = ue | 0, { h: de, l: ue } = u64$4.add(ie | 0, se | 0, De | 0, Fe | 0), ie = te | 0, se = re | 0, te = J | 0, re = ee | 0, J = $ | 0, ee = V | 0;
      const le = u64$4.add3L(Fe, ne, ce);
      $ = u64$4.add3H(le, De, Ae, oe), V = le | 0;
    }
    ({ h: $, l: V } = u64$4.add(this.Ah | 0, this.Al | 0, $ | 0, V | 0)), { h: J, l: ee } = u64$4.add(this.Bh | 0, this.Bl | 0, J | 0, ee | 0), { h: te, l: re } = u64$4.add(this.Ch | 0, this.Cl | 0, te | 0, re | 0), { h: ie, l: se } = u64$4.add(this.Dh | 0, this.Dl | 0, ie | 0, se | 0), { h: de, l: ue } = u64$4.add(this.Eh | 0, this.El | 0, de | 0, ue | 0), { h: fe, l: he } = u64$4.add(this.Fh | 0, this.Fl | 0, fe | 0, he | 0), { h: me, l: xe } = u64$4.add(this.Gh | 0, this.Gl | 0, me | 0, xe | 0), { h: ve, l: Te } = u64$4.add(this.Hh | 0, this.Hl | 0, ve | 0, Te | 0), this.set($, V, J, ee, te, re, ie, se, de, ue, fe, he, me, xe, ve, Te);
  }
  roundClean() {
    SHA512_W_H$1.fill(0), SHA512_W_L$1.fill(0);
  }
  destroy() {
    this.buffer.fill(0), this.set(0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0);
  }
};
class SHA512_256 extends SHA512$1 {
  constructor() {
    super(), this.Ah = 573645204, this.Al = -64227540, this.Bh = -1621794909, this.Bl = -934517566, this.Ch = 596883563, this.Cl = 1867755857, this.Dh = -1774684391, this.Dl = 1497426621, this.Eh = -1775747358, this.El = -1467023389, this.Fh = -1101128155, this.Fl = 1401305490, this.Gh = 721525244, this.Gl = 746961066, this.Hh = 246885852, this.Hl = -2117784414, this.outputLen = 32;
  }
}
const sha512$5 = /* @__PURE__ */ wrapConstructor$1(() => new SHA512$1()), sha512_256 = /* @__PURE__ */ wrapConstructor$1(() => new SHA512_256());
function anumber(C) {
  if (!Number.isSafeInteger(C) || C < 0)
    throw new Error("positive integer expected, got " + C);
}
function isBytes$1(C) {
  return C instanceof Uint8Array || ArrayBuffer.isView(C) && C.constructor.name === "Uint8Array";
}
function abytes$1(C, ...e) {
  if (!isBytes$1(C))
    throw new Error("Uint8Array expected");
  if (e.length > 0 && !e.includes(C.length))
    throw new Error("Uint8Array expected of length " + e + ", got length=" + C.length);
}
function ahash(C) {
  if (typeof C != "function" || typeof C.create != "function")
    throw new Error("Hash should be wrapped by utils.wrapConstructor");
  anumber(C.outputLen), anumber(C.blockLen);
}
function aexists(C, e = !0) {
  if (C.destroyed)
    throw new Error("Hash instance has been destroyed");
  if (e && C.finished)
    throw new Error("Hash#digest() has already been called");
}
function aoutput(C, e) {
  abytes$1(C);
  const T = e.outputLen;
  if (C.length < T)
    throw new Error("digestInto() expects output buffer of length at least " + T);
}
const crypto$1 = typeof globalThis == "object" && "crypto" in globalThis ? globalThis.crypto : void 0;
/*! noble-hashes - MIT License (c) 2022 Paul Miller (paulmillr.com) */
const createView = (C) => new DataView(C.buffer, C.byteOffset, C.byteLength), rotr = (C, e) => C << 32 - e | C >>> e;
function utf8ToBytes$1(C) {
  if (typeof C != "string")
    throw new Error("utf8ToBytes expected string, got " + typeof C);
  return new Uint8Array(new TextEncoder().encode(C));
}
function toBytes$1(C) {
  return typeof C == "string" && (C = utf8ToBytes$1(C)), abytes$1(C), C;
}
function concatBytes$1(...C) {
  let e = 0;
  for (let $ = 0; $ < C.length; $++) {
    const V = C[$];
    abytes$1(V), e += V.length;
  }
  const T = new Uint8Array(e);
  for (let $ = 0, V = 0; $ < C.length; $++) {
    const J = C[$];
    T.set(J, V), V += J.length;
  }
  return T;
}
class Hash {
  // Safe version that clones internal state
  clone() {
    return this._cloneInto();
  }
}
function wrapConstructor(C) {
  const e = ($) => C().update(toBytes$1($)).digest(), T = C();
  return e.outputLen = T.outputLen, e.blockLen = T.blockLen, e.create = () => C(), e;
}
function randomBytes(C = 32) {
  if (crypto$1 && typeof crypto$1.getRandomValues == "function")
    return crypto$1.getRandomValues(new Uint8Array(C));
  if (crypto$1 && typeof crypto$1.randomBytes == "function")
    return crypto$1.randomBytes(C);
  throw new Error("crypto.getRandomValues must be defined");
}
function setBigUint64(C, e, T, $) {
  if (typeof C.setBigUint64 == "function")
    return C.setBigUint64(e, T, $);
  const V = BigInt(32), J = BigInt(4294967295), ee = Number(T >> V & J), te = Number(T & J), re = $ ? 4 : 0, ie = $ ? 0 : 4;
  C.setUint32(e + re, ee, $), C.setUint32(e + ie, te, $);
}
const Chi = (C, e, T) => C & e ^ ~C & T, Maj = (C, e, T) => C & e ^ C & T ^ e & T;
class HashMD extends Hash {
  constructor(e, T, $, V) {
    super(), this.blockLen = e, this.outputLen = T, this.padOffset = $, this.isLE = V, this.finished = !1, this.length = 0, this.pos = 0, this.destroyed = !1, this.buffer = new Uint8Array(e), this.view = createView(this.buffer);
  }
  update(e) {
    aexists(this);
    const { view: T, buffer: $, blockLen: V } = this;
    e = toBytes$1(e);
    const J = e.length;
    for (let ee = 0; ee < J; ) {
      const te = Math.min(V - this.pos, J - ee);
      if (te === V) {
        const re = createView(e);
        for (; V <= J - ee; ee += V)
          this.process(re, ee);
        continue;
      }
      $.set(e.subarray(ee, ee + te), this.pos), this.pos += te, ee += te, this.pos === V && (this.process(T, 0), this.pos = 0);
    }
    return this.length += e.length, this.roundClean(), this;
  }
  digestInto(e) {
    aexists(this), aoutput(e, this), this.finished = !0;
    const { buffer: T, view: $, blockLen: V, isLE: J } = this;
    let { pos: ee } = this;
    T[ee++] = 128, this.buffer.subarray(ee).fill(0), this.padOffset > V - ee && (this.process($, 0), ee = 0);
    for (let de = ee; de < V; de++)
      T[de] = 0;
    setBigUint64($, V - 8, BigInt(this.length * 8), J), this.process($, 0);
    const te = createView(e), re = this.outputLen;
    if (re % 4)
      throw new Error("_sha2: outputLen should be aligned to 32bit");
    const ie = re / 4, se = this.get();
    if (ie > se.length)
      throw new Error("_sha2: outputLen bigger than state");
    for (let de = 0; de < ie; de++)
      te.setUint32(4 * de, se[de], J);
  }
  digest() {
    const { buffer: e, outputLen: T } = this;
    this.digestInto(e);
    const $ = e.slice(0, T);
    return this.destroy(), $;
  }
  _cloneInto(e) {
    e || (e = new this.constructor()), e.set(...this.get());
    const { blockLen: T, buffer: $, length: V, finished: J, destroyed: ee, pos: te } = this;
    return e.length = V, e.pos = te, e.finished = J, e.destroyed = ee, V % T && e.buffer.set($), e;
  }
}
const SHA256_K = /* @__PURE__ */ new Uint32Array([
  1116352408,
  1899447441,
  3049323471,
  3921009573,
  961987163,
  1508970993,
  2453635748,
  2870763221,
  3624381080,
  310598401,
  607225278,
  1426881987,
  1925078388,
  2162078206,
  2614888103,
  3248222580,
  3835390401,
  4022224774,
  264347078,
  604807628,
  770255983,
  1249150122,
  1555081692,
  1996064986,
  2554220882,
  2821834349,
  2952996808,
  3210313671,
  3336571891,
  3584528711,
  113926993,
  338241895,
  666307205,
  773529912,
  1294757372,
  1396182291,
  1695183700,
  1986661051,
  2177026350,
  2456956037,
  2730485921,
  2820302411,
  3259730800,
  3345764771,
  3516065817,
  3600352804,
  4094571909,
  275423344,
  430227734,
  506948616,
  659060556,
  883997877,
  958139571,
  1322822218,
  1537002063,
  1747873779,
  1955562222,
  2024104815,
  2227730452,
  2361852424,
  2428436474,
  2756734187,
  3204031479,
  3329325298
]), SHA256_IV = /* @__PURE__ */ new Uint32Array([
  1779033703,
  3144134277,
  1013904242,
  2773480762,
  1359893119,
  2600822924,
  528734635,
  1541459225
]), SHA256_W = /* @__PURE__ */ new Uint32Array(64);
class SHA256 extends HashMD {
  constructor() {
    super(64, 32, 8, !1), this.A = SHA256_IV[0] | 0, this.B = SHA256_IV[1] | 0, this.C = SHA256_IV[2] | 0, this.D = SHA256_IV[3] | 0, this.E = SHA256_IV[4] | 0, this.F = SHA256_IV[5] | 0, this.G = SHA256_IV[6] | 0, this.H = SHA256_IV[7] | 0;
  }
  get() {
    const { A: e, B: T, C: $, D: V, E: J, F: ee, G: te, H: re } = this;
    return [e, T, $, V, J, ee, te, re];
  }
  // prettier-ignore
  set(e, T, $, V, J, ee, te, re) {
    this.A = e | 0, this.B = T | 0, this.C = $ | 0, this.D = V | 0, this.E = J | 0, this.F = ee | 0, this.G = te | 0, this.H = re | 0;
  }
  process(e, T) {
    for (let de = 0; de < 16; de++, T += 4)
      SHA256_W[de] = e.getUint32(T, !1);
    for (let de = 16; de < 64; de++) {
      const ue = SHA256_W[de - 15], fe = SHA256_W[de - 2], he = rotr(ue, 7) ^ rotr(ue, 18) ^ ue >>> 3, me = rotr(fe, 17) ^ rotr(fe, 19) ^ fe >>> 10;
      SHA256_W[de] = me + SHA256_W[de - 7] + he + SHA256_W[de - 16] | 0;
    }
    let { A: $, B: V, C: J, D: ee, E: te, F: re, G: ie, H: se } = this;
    for (let de = 0; de < 64; de++) {
      const ue = rotr(te, 6) ^ rotr(te, 11) ^ rotr(te, 25), fe = se + ue + Chi(te, re, ie) + SHA256_K[de] + SHA256_W[de] | 0, me = (rotr($, 2) ^ rotr($, 13) ^ rotr($, 22)) + Maj($, V, J) | 0;
      se = ie, ie = re, re = te, te = ee + fe | 0, ee = J, J = V, V = $, $ = fe + me | 0;
    }
    $ = $ + this.A | 0, V = V + this.B | 0, J = J + this.C | 0, ee = ee + this.D | 0, te = te + this.E | 0, re = re + this.F | 0, ie = ie + this.G | 0, se = se + this.H | 0, this.set($, V, J, ee, te, re, ie, se);
  }
  roundClean() {
    SHA256_W.fill(0);
  }
  destroy() {
    this.set(0, 0, 0, 0, 0, 0, 0, 0), this.buffer.fill(0);
  }
}
const sha256$4 = /* @__PURE__ */ wrapConstructor(() => new SHA256());
class HMAC extends Hash {
  constructor(e, T) {
    super(), this.finished = !1, this.destroyed = !1, ahash(e);
    const $ = toBytes$1(T);
    if (this.iHash = e.create(), typeof this.iHash.update != "function")
      throw new Error("Expected instance of class which extends utils.Hash");
    this.blockLen = this.iHash.blockLen, this.outputLen = this.iHash.outputLen;
    const V = this.blockLen, J = new Uint8Array(V);
    J.set($.length > V ? e.create().update($).digest() : $);
    for (let ee = 0; ee < J.length; ee++)
      J[ee] ^= 54;
    this.iHash.update(J), this.oHash = e.create();
    for (let ee = 0; ee < J.length; ee++)
      J[ee] ^= 106;
    this.oHash.update(J), J.fill(0);
  }
  update(e) {
    return aexists(this), this.iHash.update(e), this;
  }
  digestInto(e) {
    aexists(this), abytes$1(e, this.outputLen), this.finished = !0, this.iHash.digestInto(e), this.oHash.update(e), this.oHash.digestInto(e), this.destroy();
  }
  digest() {
    const e = new Uint8Array(this.oHash.outputLen);
    return this.digestInto(e), e;
  }
  _cloneInto(e) {
    e || (e = Object.create(Object.getPrototypeOf(this), {}));
    const { oHash: T, iHash: $, finished: V, destroyed: J, blockLen: ee, outputLen: te } = this;
    return e = e, e.finished = V, e.destroyed = J, e.blockLen = ee, e.outputLen = te, e.oHash = T._cloneInto(e.oHash), e.iHash = $._cloneInto(e.iHash), e;
  }
  destroy() {
    this.destroyed = !0, this.oHash.destroy(), this.iHash.destroy();
  }
}
const hmac$1 = (C, e, T) => new HMAC(C, e).update(T).digest();
hmac$1.create = (C, e) => new HMAC(C, e);
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */
const _0n$4 = /* @__PURE__ */ BigInt(0), _1n$6 = /* @__PURE__ */ BigInt(1), _2n$4 = /* @__PURE__ */ BigInt(2);
function isBytes(C) {
  return C instanceof Uint8Array || ArrayBuffer.isView(C) && C.constructor.name === "Uint8Array";
}
function abytes(C) {
  if (!isBytes(C))
    throw new Error("Uint8Array expected");
}
function abool(C, e) {
  if (typeof e != "boolean")
    throw new Error(C + " boolean expected, got " + e);
}
const hexes = /* @__PURE__ */ Array.from({ length: 256 }, (C, e) => e.toString(16).padStart(2, "0"));
function bytesToHex(C) {
  abytes(C);
  let e = "";
  for (let T = 0; T < C.length; T++)
    e += hexes[C[T]];
  return e;
}
function numberToHexUnpadded(C) {
  const e = C.toString(16);
  return e.length & 1 ? "0" + e : e;
}
function hexToNumber(C) {
  if (typeof C != "string")
    throw new Error("hex string expected, got " + typeof C);
  return C === "" ? _0n$4 : BigInt("0x" + C);
}
const asciis = { _0: 48, _9: 57, A: 65, F: 70, a: 97, f: 102 };
function asciiToBase16(C) {
  if (C >= asciis._0 && C <= asciis._9)
    return C - asciis._0;
  if (C >= asciis.A && C <= asciis.F)
    return C - (asciis.A - 10);
  if (C >= asciis.a && C <= asciis.f)
    return C - (asciis.a - 10);
}
function hexToBytes(C) {
  if (typeof C != "string")
    throw new Error("hex string expected, got " + typeof C);
  const e = C.length, T = e / 2;
  if (e % 2)
    throw new Error("hex string expected, got unpadded hex of length " + e);
  const $ = new Uint8Array(T);
  for (let V = 0, J = 0; V < T; V++, J += 2) {
    const ee = asciiToBase16(C.charCodeAt(J)), te = asciiToBase16(C.charCodeAt(J + 1));
    if (ee === void 0 || te === void 0) {
      const re = C[J] + C[J + 1];
      throw new Error('hex string expected, got non-hex character "' + re + '" at index ' + J);
    }
    $[V] = ee * 16 + te;
  }
  return $;
}
function bytesToNumberBE(C) {
  return hexToNumber(bytesToHex(C));
}
function bytesToNumberLE(C) {
  return abytes(C), hexToNumber(bytesToHex(Uint8Array.from(C).reverse()));
}
function numberToBytesBE(C, e) {
  return hexToBytes(C.toString(16).padStart(e * 2, "0"));
}
function numberToBytesLE(C, e) {
  return numberToBytesBE(C, e).reverse();
}
function numberToVarBytesBE(C) {
  return hexToBytes(numberToHexUnpadded(C));
}
function ensureBytes(C, e, T) {
  let $;
  if (typeof e == "string")
    try {
      $ = hexToBytes(e);
    } catch (J) {
      throw new Error(C + " must be hex string or Uint8Array, cause: " + J);
    }
  else if (isBytes(e))
    $ = Uint8Array.from(e);
  else
    throw new Error(C + " must be hex string or Uint8Array");
  const V = $.length;
  if (typeof T == "number" && V !== T)
    throw new Error(C + " of length " + T + " expected, got " + V);
  return $;
}
function concatBytes(...C) {
  let e = 0;
  for (let $ = 0; $ < C.length; $++) {
    const V = C[$];
    abytes(V), e += V.length;
  }
  const T = new Uint8Array(e);
  for (let $ = 0, V = 0; $ < C.length; $++) {
    const J = C[$];
    T.set(J, V), V += J.length;
  }
  return T;
}
function equalBytes(C, e) {
  if (C.length !== e.length)
    return !1;
  let T = 0;
  for (let $ = 0; $ < C.length; $++)
    T |= C[$] ^ e[$];
  return T === 0;
}
function utf8ToBytes(C) {
  if (typeof C != "string")
    throw new Error("string expected");
  return new Uint8Array(new TextEncoder().encode(C));
}
const isPosBig = (C) => typeof C == "bigint" && _0n$4 <= C;
function inRange$1(C, e, T) {
  return isPosBig(C) && isPosBig(e) && isPosBig(T) && e <= C && C < T;
}
function aInRange(C, e, T, $) {
  if (!inRange$1(e, T, $))
    throw new Error("expected valid " + C + ": " + T + " <= n < " + $ + ", got " + e);
}
function bitLen(C) {
  let e;
  for (e = 0; C > _0n$4; C >>= _1n$6, e += 1)
    ;
  return e;
}
function bitGet(C, e) {
  return C >> BigInt(e) & _1n$6;
}
function bitSet(C, e, T) {
  return C | (T ? _1n$6 : _0n$4) << BigInt(e);
}
const bitMask = (C) => (_2n$4 << BigInt(C - 1)) - _1n$6, u8n = (C) => new Uint8Array(C), u8fr = (C) => Uint8Array.from(C);
function createHmacDrbg(C, e, T) {
  if (typeof C != "number" || C < 2)
    throw new Error("hashLen must be a number");
  if (typeof e != "number" || e < 2)
    throw new Error("qByteLen must be a number");
  if (typeof T != "function")
    throw new Error("hmacFn must be a function");
  let $ = u8n(C), V = u8n(C), J = 0;
  const ee = () => {
    $.fill(1), V.fill(0), J = 0;
  }, te = (...de) => T(V, $, ...de), re = (de = u8n()) => {
    V = te(u8fr([0]), de), $ = te(), de.length !== 0 && (V = te(u8fr([1]), de), $ = te());
  }, ie = () => {
    if (J++ >= 1e3)
      throw new Error("drbg: tried 1000 values");
    let de = 0;
    const ue = [];
    for (; de < e; ) {
      $ = te();
      const fe = $.slice();
      ue.push(fe), de += $.length;
    }
    return concatBytes(...ue);
  };
  return (de, ue) => {
    ee(), re(de);
    let fe;
    for (; !(fe = ue(ie())); )
      re();
    return ee(), fe;
  };
}
const validatorFns = {
  bigint: (C) => typeof C == "bigint",
  function: (C) => typeof C == "function",
  boolean: (C) => typeof C == "boolean",
  string: (C) => typeof C == "string",
  stringOrUint8Array: (C) => typeof C == "string" || isBytes(C),
  isSafeInteger: (C) => Number.isSafeInteger(C),
  array: (C) => Array.isArray(C),
  field: (C, e) => e.Fp.isValid(C),
  hash: (C) => typeof C == "function" && Number.isSafeInteger(C.outputLen)
};
function validateObject(C, e, T = {}) {
  const $ = (V, J, ee) => {
    const te = validatorFns[J];
    if (typeof te != "function")
      throw new Error("invalid validator function");
    const re = C[V];
    if (!(ee && re === void 0) && !te(re, C))
      throw new Error("param " + String(V) + " is invalid. Expected " + J + ", got " + re);
  };
  for (const [V, J] of Object.entries(e))
    $(V, J, !1);
  for (const [V, J] of Object.entries(T))
    $(V, J, !0);
  return C;
}
const notImplemented = () => {
  throw new Error("not implemented");
};
function memoized(C) {
  const e = /* @__PURE__ */ new WeakMap();
  return (T, ...$) => {
    const V = e.get(T);
    if (V !== void 0)
      return V;
    const J = C(T, ...$);
    return e.set(T, J), J;
  };
}
const ut = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  aInRange,
  abool,
  abytes,
  bitGet,
  bitLen,
  bitMask,
  bitSet,
  bytesToHex,
  bytesToNumberBE,
  bytesToNumberLE,
  concatBytes,
  createHmacDrbg,
  ensureBytes,
  equalBytes,
  hexToBytes,
  hexToNumber,
  inRange: inRange$1,
  isBytes,
  memoized,
  notImplemented,
  numberToBytesBE,
  numberToBytesLE,
  numberToHexUnpadded,
  numberToVarBytesBE,
  utf8ToBytes,
  validateObject
}, Symbol.toStringTag, { value: "Module" }));
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */
const _0n$3 = BigInt(0), _1n$5 = BigInt(1), _2n$3 = /* @__PURE__ */ BigInt(2), _3n$1 = /* @__PURE__ */ BigInt(3), _4n = /* @__PURE__ */ BigInt(4), _5n$1 = /* @__PURE__ */ BigInt(5), _8n$2 = /* @__PURE__ */ BigInt(8);
function mod(C, e) {
  const T = C % e;
  return T >= _0n$3 ? T : e + T;
}
function pow(C, e, T) {
  if (e < _0n$3)
    throw new Error("invalid exponent, negatives unsupported");
  if (T <= _0n$3)
    throw new Error("invalid modulus");
  if (T === _1n$5)
    return _0n$3;
  let $ = _1n$5;
  for (; e > _0n$3; )
    e & _1n$5 && ($ = $ * C % T), C = C * C % T, e >>= _1n$5;
  return $;
}
function pow2(C, e, T) {
  let $ = C;
  for (; e-- > _0n$3; )
    $ *= $, $ %= T;
  return $;
}
function invert(C, e) {
  if (C === _0n$3)
    throw new Error("invert: expected non-zero number");
  if (e <= _0n$3)
    throw new Error("invert: expected positive modulus, got " + e);
  let T = mod(C, e), $ = e, V = _0n$3, J = _1n$5;
  for (; T !== _0n$3; ) {
    const te = $ / T, re = $ % T, ie = V - J * te;
    $ = T, T = re, V = J, J = ie;
  }
  if ($ !== _1n$5)
    throw new Error("invert: does not exist");
  return mod(V, e);
}
function tonelliShanks(C) {
  const e = (C - _1n$5) / _2n$3;
  let T, $, V;
  for (T = C - _1n$5, $ = 0; T % _2n$3 === _0n$3; T /= _2n$3, $++)
    ;
  for (V = _2n$3; V < C && pow(V, e, C) !== C - _1n$5; V++)
    if (V > 1e3)
      throw new Error("Cannot find square root: likely non-prime P");
  if ($ === 1) {
    const ee = (C + _1n$5) / _4n;
    return function(re, ie) {
      const se = re.pow(ie, ee);
      if (!re.eql(re.sqr(se), ie))
        throw new Error("Cannot find square root");
      return se;
    };
  }
  const J = (T + _1n$5) / _2n$3;
  return function(te, re) {
    if (te.pow(re, e) === te.neg(te.ONE))
      throw new Error("Cannot find square root");
    let ie = $, se = te.pow(te.mul(te.ONE, V), T), de = te.pow(re, J), ue = te.pow(re, T);
    for (; !te.eql(ue, te.ONE); ) {
      if (te.eql(ue, te.ZERO))
        return te.ZERO;
      let fe = 1;
      for (let me = te.sqr(ue); fe < ie && !te.eql(me, te.ONE); fe++)
        me = te.sqr(me);
      const he = te.pow(se, _1n$5 << BigInt(ie - fe - 1));
      se = te.sqr(he), de = te.mul(de, he), ue = te.mul(ue, se), ie = fe;
    }
    return de;
  };
}
function FpSqrt(C) {
  if (C % _4n === _3n$1) {
    const e = (C + _1n$5) / _4n;
    return function($, V) {
      const J = $.pow(V, e);
      if (!$.eql($.sqr(J), V))
        throw new Error("Cannot find square root");
      return J;
    };
  }
  if (C % _8n$2 === _5n$1) {
    const e = (C - _5n$1) / _8n$2;
    return function($, V) {
      const J = $.mul(V, _2n$3), ee = $.pow(J, e), te = $.mul(V, ee), re = $.mul($.mul(te, _2n$3), ee), ie = $.mul(te, $.sub(re, $.ONE));
      if (!$.eql($.sqr(ie), V))
        throw new Error("Cannot find square root");
      return ie;
    };
  }
  return tonelliShanks(C);
}
const isNegativeLE = (C, e) => (mod(C, e) & _1n$5) === _1n$5, FIELD_FIELDS = [
  "create",
  "isValid",
  "is0",
  "neg",
  "inv",
  "sqrt",
  "sqr",
  "eql",
  "add",
  "sub",
  "mul",
  "pow",
  "div",
  "addN",
  "subN",
  "mulN",
  "sqrN"
];
function validateField(C) {
  const e = {
    ORDER: "bigint",
    MASK: "bigint",
    BYTES: "isSafeInteger",
    BITS: "isSafeInteger"
  }, T = FIELD_FIELDS.reduce(($, V) => ($[V] = "function", $), e);
  return validateObject(C, T);
}
function FpPow(C, e, T) {
  if (T < _0n$3)
    throw new Error("invalid exponent, negatives unsupported");
  if (T === _0n$3)
    return C.ONE;
  if (T === _1n$5)
    return e;
  let $ = C.ONE, V = e;
  for (; T > _0n$3; )
    T & _1n$5 && ($ = C.mul($, V)), V = C.sqr(V), T >>= _1n$5;
  return $;
}
function FpInvertBatch(C, e) {
  const T = new Array(e.length), $ = e.reduce((J, ee, te) => C.is0(ee) ? J : (T[te] = J, C.mul(J, ee)), C.ONE), V = C.inv($);
  return e.reduceRight((J, ee, te) => C.is0(ee) ? J : (T[te] = C.mul(J, T[te]), C.mul(J, ee)), V), T;
}
function nLength(C, e) {
  const T = e !== void 0 ? e : C.toString(2).length, $ = Math.ceil(T / 8);
  return { nBitLength: T, nByteLength: $ };
}
function Field(C, e, T = !1, $ = {}) {
  if (C <= _0n$3)
    throw new Error("invalid field: expected ORDER > 0, got " + C);
  const { nBitLength: V, nByteLength: J } = nLength(C, e);
  if (J > 2048)
    throw new Error("invalid field: expected ORDER of <= 2048 bytes");
  let ee;
  const te = Object.freeze({
    ORDER: C,
    BITS: V,
    BYTES: J,
    MASK: bitMask(V),
    ZERO: _0n$3,
    ONE: _1n$5,
    create: (re) => mod(re, C),
    isValid: (re) => {
      if (typeof re != "bigint")
        throw new Error("invalid field element: expected bigint, got " + typeof re);
      return _0n$3 <= re && re < C;
    },
    is0: (re) => re === _0n$3,
    isOdd: (re) => (re & _1n$5) === _1n$5,
    neg: (re) => mod(-re, C),
    eql: (re, ie) => re === ie,
    sqr: (re) => mod(re * re, C),
    add: (re, ie) => mod(re + ie, C),
    sub: (re, ie) => mod(re - ie, C),
    mul: (re, ie) => mod(re * ie, C),
    pow: (re, ie) => FpPow(te, re, ie),
    div: (re, ie) => mod(re * invert(ie, C), C),
    // Same as above, but doesn't normalize
    sqrN: (re) => re * re,
    addN: (re, ie) => re + ie,
    subN: (re, ie) => re - ie,
    mulN: (re, ie) => re * ie,
    inv: (re) => invert(re, C),
    sqrt: $.sqrt || ((re) => (ee || (ee = FpSqrt(C)), ee(te, re))),
    invertBatch: (re) => FpInvertBatch(te, re),
    // TODO: do we really need constant cmov?
    // We don't have const-time bigints anyway, so probably will be not very useful
    cmov: (re, ie, se) => se ? ie : re,
    toBytes: (re) => T ? numberToBytesLE(re, J) : numberToBytesBE(re, J),
    fromBytes: (re) => {
      if (re.length !== J)
        throw new Error("Field.fromBytes: expected " + J + " bytes, got " + re.length);
      return T ? bytesToNumberLE(re) : bytesToNumberBE(re);
    }
  });
  return Object.freeze(te);
}
function getFieldBytesLength(C) {
  if (typeof C != "bigint")
    throw new Error("field order must be bigint");
  const e = C.toString(2).length;
  return Math.ceil(e / 8);
}
function getMinHashLength(C) {
  const e = getFieldBytesLength(C);
  return e + Math.ceil(e / 2);
}
function mapHashToField(C, e, T = !1) {
  const $ = C.length, V = getFieldBytesLength(e), J = getMinHashLength(e);
  if ($ < 16 || $ < J || $ > 1024)
    throw new Error("expected " + J + "-1024 bytes of input, got " + $);
  const ee = T ? bytesToNumberBE(C) : bytesToNumberLE(C), te = mod(ee, e - _1n$5) + _1n$5;
  return T ? numberToBytesLE(te, V) : numberToBytesBE(te, V);
}
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */
const _0n$2 = BigInt(0), _1n$4 = BigInt(1);
function constTimeNegate(C, e) {
  const T = e.negate();
  return C ? T : e;
}
function validateW(C, e) {
  if (!Number.isSafeInteger(C) || C <= 0 || C > e)
    throw new Error("invalid window size, expected [1.." + e + "], got W=" + C);
}
function calcWOpts(C, e) {
  validateW(C, e);
  const T = Math.ceil(e / C) + 1, $ = 2 ** (C - 1);
  return { windows: T, windowSize: $ };
}
function validateMSMPoints(C, e) {
  if (!Array.isArray(C))
    throw new Error("array expected");
  C.forEach((T, $) => {
    if (!(T instanceof e))
      throw new Error("invalid point at index " + $);
  });
}
function validateMSMScalars(C, e) {
  if (!Array.isArray(C))
    throw new Error("array of scalars expected");
  C.forEach((T, $) => {
    if (!e.isValid(T))
      throw new Error("invalid scalar at index " + $);
  });
}
const pointPrecomputes = /* @__PURE__ */ new WeakMap(), pointWindowSizes = /* @__PURE__ */ new WeakMap();
function getW(C) {
  return pointWindowSizes.get(C) || 1;
}
function wNAF(C, e) {
  return {
    constTimeNegate,
    hasPrecomputes(T) {
      return getW(T) !== 1;
    },
    // non-const time multiplication ladder
    unsafeLadder(T, $, V = C.ZERO) {
      let J = T;
      for (; $ > _0n$2; )
        $ & _1n$4 && (V = V.add(J)), J = J.double(), $ >>= _1n$4;
      return V;
    },
    /**
     * Creates a wNAF precomputation window. Used for caching.
     * Default window size is set by `utils.precompute()` and is equal to 8.
     * Number of precomputed points depends on the curve size:
     * 2^(𝑊−1) * (Math.ceil(𝑛 / 𝑊) + 1), where:
     * - 𝑊 is the window size
     * - 𝑛 is the bitlength of the curve order.
     * For a 256-bit curve and window size 8, the number of precomputed points is 128 * 33 = 4224.
     * @param elm Point instance
     * @param W window size
     * @returns precomputed point tables flattened to a single array
     */
    precomputeWindow(T, $) {
      const { windows: V, windowSize: J } = calcWOpts($, e), ee = [];
      let te = T, re = te;
      for (let ie = 0; ie < V; ie++) {
        re = te, ee.push(re);
        for (let se = 1; se < J; se++)
          re = re.add(te), ee.push(re);
        te = re.double();
      }
      return ee;
    },
    /**
     * Implements ec multiplication using precomputed tables and w-ary non-adjacent form.
     * @param W window size
     * @param precomputes precomputed tables
     * @param n scalar (we don't check here, but should be less than curve order)
     * @returns real and fake (for const-time) points
     */
    wNAF(T, $, V) {
      const { windows: J, windowSize: ee } = calcWOpts(T, e);
      let te = C.ZERO, re = C.BASE;
      const ie = BigInt(2 ** T - 1), se = 2 ** T, de = BigInt(T);
      for (let ue = 0; ue < J; ue++) {
        const fe = ue * ee;
        let he = Number(V & ie);
        V >>= de, he > ee && (he -= se, V += _1n$4);
        const me = fe, xe = fe + Math.abs(he) - 1, ve = ue % 2 !== 0, Te = he < 0;
        he === 0 ? re = re.add(constTimeNegate(ve, $[me])) : te = te.add(constTimeNegate(Te, $[xe]));
      }
      return { p: te, f: re };
    },
    /**
     * Implements ec unsafe (non const-time) multiplication using precomputed tables and w-ary non-adjacent form.
     * @param W window size
     * @param precomputes precomputed tables
     * @param n scalar (we don't check here, but should be less than curve order)
     * @param acc accumulator point to add result of multiplication
     * @returns point
     */
    wNAFUnsafe(T, $, V, J = C.ZERO) {
      const { windows: ee, windowSize: te } = calcWOpts(T, e), re = BigInt(2 ** T - 1), ie = 2 ** T, se = BigInt(T);
      for (let de = 0; de < ee; de++) {
        const ue = de * te;
        if (V === _0n$2)
          break;
        let fe = Number(V & re);
        if (V >>= se, fe > te && (fe -= ie, V += _1n$4), fe === 0)
          continue;
        let he = $[ue + Math.abs(fe) - 1];
        fe < 0 && (he = he.negate()), J = J.add(he);
      }
      return J;
    },
    getPrecomputes(T, $, V) {
      let J = pointPrecomputes.get($);
      return J || (J = this.precomputeWindow($, T), T !== 1 && pointPrecomputes.set($, V(J))), J;
    },
    wNAFCached(T, $, V) {
      const J = getW(T);
      return this.wNAF(J, this.getPrecomputes(J, T, V), $);
    },
    wNAFCachedUnsafe(T, $, V, J) {
      const ee = getW(T);
      return ee === 1 ? this.unsafeLadder(T, $, J) : this.wNAFUnsafe(ee, this.getPrecomputes(ee, T, V), $, J);
    },
    // We calculate precomputes for elliptic curve point multiplication
    // using windowed method. This specifies window size and
    // stores precomputed values. Usually only base point would be precomputed.
    setWindowSize(T, $) {
      validateW($, e), pointWindowSizes.set(T, $), pointPrecomputes.delete(T);
    }
  };
}
function pippenger(C, e, T, $) {
  if (validateMSMPoints(T, C), validateMSMScalars($, e), T.length !== $.length)
    throw new Error("arrays of points and scalars must have equal length");
  const V = C.ZERO, J = bitLen(BigInt(T.length)), ee = J > 12 ? J - 3 : J > 4 ? J - 2 : J ? 2 : 1, te = (1 << ee) - 1, re = new Array(te + 1).fill(V), ie = Math.floor((e.BITS - 1) / ee) * ee;
  let se = V;
  for (let de = ie; de >= 0; de -= ee) {
    re.fill(V);
    for (let fe = 0; fe < $.length; fe++) {
      const he = $[fe], me = Number(he >> BigInt(de) & BigInt(te));
      re[me] = re[me].add(T[fe]);
    }
    let ue = V;
    for (let fe = re.length - 1, he = V; fe > 0; fe--)
      he = he.add(re[fe]), ue = ue.add(he);
    if (se = se.add(ue), de !== 0)
      for (let fe = 0; fe < ee; fe++)
        se = se.double();
  }
  return se;
}
function validateBasic(C) {
  return validateField(C.Fp), validateObject(C, {
    n: "bigint",
    h: "bigint",
    Gx: "field",
    Gy: "field"
  }, {
    nBitLength: "isSafeInteger",
    nByteLength: "isSafeInteger"
  }), Object.freeze({
    ...nLength(C.n, C.nBitLength),
    ...C,
    p: C.Fp.ORDER
  });
}
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */
function validateSigVerOpts(C) {
  C.lowS !== void 0 && abool("lowS", C.lowS), C.prehash !== void 0 && abool("prehash", C.prehash);
}
function validatePointOpts(C) {
  const e = validateBasic(C);
  validateObject(e, {
    a: "field",
    b: "field"
  }, {
    allowedPrivateKeyLengths: "array",
    wrapPrivateKey: "boolean",
    isTorsionFree: "function",
    clearCofactor: "function",
    allowInfinityPoint: "boolean",
    fromBytes: "function",
    toBytes: "function"
  });
  const { endo: T, Fp: $, a: V } = e;
  if (T) {
    if (!$.eql(V, $.ZERO))
      throw new Error("invalid endomorphism, can only be defined for Koblitz curves that have a=0");
    if (typeof T != "object" || typeof T.beta != "bigint" || typeof T.splitScalar != "function")
      throw new Error("invalid endomorphism, expected beta: bigint and splitScalar: function");
  }
  return Object.freeze({ ...e });
}
const { bytesToNumberBE: b2n, hexToBytes: h2b } = ut, DER = {
  // asn.1 DER encoding utils
  Err: class extends Error {
    constructor(e = "") {
      super(e);
    }
  },
  // Basic building block is TLV (Tag-Length-Value)
  _tlv: {
    encode: (C, e) => {
      const { Err: T } = DER;
      if (C < 0 || C > 256)
        throw new T("tlv.encode: wrong tag");
      if (e.length & 1)
        throw new T("tlv.encode: unpadded data");
      const $ = e.length / 2, V = numberToHexUnpadded($);
      if (V.length / 2 & 128)
        throw new T("tlv.encode: long form length too big");
      const J = $ > 127 ? numberToHexUnpadded(V.length / 2 | 128) : "";
      return numberToHexUnpadded(C) + J + V + e;
    },
    // v - value, l - left bytes (unparsed)
    decode(C, e) {
      const { Err: T } = DER;
      let $ = 0;
      if (C < 0 || C > 256)
        throw new T("tlv.encode: wrong tag");
      if (e.length < 2 || e[$++] !== C)
        throw new T("tlv.decode: wrong tlv");
      const V = e[$++], J = !!(V & 128);
      let ee = 0;
      if (!J)
        ee = V;
      else {
        const re = V & 127;
        if (!re)
          throw new T("tlv.decode(long): indefinite length not supported");
        if (re > 4)
          throw new T("tlv.decode(long): byte length is too big");
        const ie = e.subarray($, $ + re);
        if (ie.length !== re)
          throw new T("tlv.decode: length bytes not complete");
        if (ie[0] === 0)
          throw new T("tlv.decode(long): zero leftmost byte");
        for (const se of ie)
          ee = ee << 8 | se;
        if ($ += re, ee < 128)
          throw new T("tlv.decode(long): not minimal encoding");
      }
      const te = e.subarray($, $ + ee);
      if (te.length !== ee)
        throw new T("tlv.decode: wrong value length");
      return { v: te, l: e.subarray($ + ee) };
    }
  },
  // https://crypto.stackexchange.com/a/57734 Leftmost bit of first byte is 'negative' flag,
  // since we always use positive integers here. It must always be empty:
  // - add zero byte if exists
  // - if next byte doesn't have a flag, leading zero is not allowed (minimal encoding)
  _int: {
    encode(C) {
      const { Err: e } = DER;
      if (C < _0n$1)
        throw new e("integer: negative integers are not allowed");
      let T = numberToHexUnpadded(C);
      if (Number.parseInt(T[0], 16) & 8 && (T = "00" + T), T.length & 1)
        throw new e("unexpected DER parsing assertion: unpadded hex");
      return T;
    },
    decode(C) {
      const { Err: e } = DER;
      if (C[0] & 128)
        throw new e("invalid signature integer: negative");
      if (C[0] === 0 && !(C[1] & 128))
        throw new e("invalid signature integer: unnecessary leading zero");
      return b2n(C);
    }
  },
  toSig(C) {
    const { Err: e, _int: T, _tlv: $ } = DER, V = typeof C == "string" ? h2b(C) : C;
    abytes(V);
    const { v: J, l: ee } = $.decode(48, V);
    if (ee.length)
      throw new e("invalid signature: left bytes after parsing");
    const { v: te, l: re } = $.decode(2, J), { v: ie, l: se } = $.decode(2, re);
    if (se.length)
      throw new e("invalid signature: left bytes after parsing");
    return { r: T.decode(te), s: T.decode(ie) };
  },
  hexFromSig(C) {
    const { _tlv: e, _int: T } = DER, $ = e.encode(2, T.encode(C.r)), V = e.encode(2, T.encode(C.s)), J = $ + V;
    return e.encode(48, J);
  }
}, _0n$1 = BigInt(0), _1n$3 = BigInt(1);
BigInt(2);
const _3n = BigInt(3);
BigInt(4);
function weierstrassPoints(C) {
  const e = validatePointOpts(C), { Fp: T } = e, $ = Field(e.n, e.nBitLength), V = e.toBytes || ((me, xe, ve) => {
    const Te = xe.toAffine();
    return concatBytes(Uint8Array.from([4]), T.toBytes(Te.x), T.toBytes(Te.y));
  }), J = e.fromBytes || ((me) => {
    const xe = me.subarray(1), ve = T.fromBytes(xe.subarray(0, T.BYTES)), Te = T.fromBytes(xe.subarray(T.BYTES, 2 * T.BYTES));
    return { x: ve, y: Te };
  });
  function ee(me) {
    const { a: xe, b: ve } = e, Te = T.sqr(me), we = T.mul(Te, me);
    return T.add(T.add(we, T.mul(me, xe)), ve);
  }
  if (!T.eql(T.sqr(e.Gy), ee(e.Gx)))
    throw new Error("bad generator point: equation left != right");
  function te(me) {
    return inRange$1(me, _1n$3, e.n);
  }
  function re(me) {
    const { allowedPrivateKeyLengths: xe, nByteLength: ve, wrapPrivateKey: Te, n: we } = e;
    if (xe && typeof me != "bigint") {
      if (isBytes(me) && (me = bytesToHex(me)), typeof me != "string" || !xe.includes(me.length))
        throw new Error("invalid private key");
      me = me.padStart(ve * 2, "0");
    }
    let Ee;
    try {
      Ee = typeof me == "bigint" ? me : bytesToNumberBE(ensureBytes("private key", me, ve));
    } catch {
      throw new Error("invalid private key, expected hex or " + ve + " bytes, got " + typeof me);
    }
    return Te && (Ee = mod(Ee, we)), aInRange("private key", Ee, _1n$3, we), Ee;
  }
  function ie(me) {
    if (!(me instanceof ue))
      throw new Error("ProjectivePoint expected");
  }
  const se = memoized((me, xe) => {
    const { px: ve, py: Te, pz: we } = me;
    if (T.eql(we, T.ONE))
      return { x: ve, y: Te };
    const Ee = me.is0();
    xe == null && (xe = Ee ? T.ONE : T.inv(we));
    const Me = T.mul(ve, xe), Ie = T.mul(Te, xe), ke = T.mul(we, xe);
    if (Ee)
      return { x: T.ZERO, y: T.ZERO };
    if (!T.eql(ke, T.ONE))
      throw new Error("invZ was invalid");
    return { x: Me, y: Ie };
  }), de = memoized((me) => {
    if (me.is0()) {
      if (e.allowInfinityPoint && !T.is0(me.py))
        return;
      throw new Error("bad point: ZERO");
    }
    const { x: xe, y: ve } = me.toAffine();
    if (!T.isValid(xe) || !T.isValid(ve))
      throw new Error("bad point: x or y not FE");
    const Te = T.sqr(ve), we = ee(xe);
    if (!T.eql(Te, we))
      throw new Error("bad point: equation left != right");
    if (!me.isTorsionFree())
      throw new Error("bad point: not in prime-order subgroup");
    return !0;
  });
  class ue {
    constructor(xe, ve, Te) {
      if (this.px = xe, this.py = ve, this.pz = Te, xe == null || !T.isValid(xe))
        throw new Error("x required");
      if (ve == null || !T.isValid(ve))
        throw new Error("y required");
      if (Te == null || !T.isValid(Te))
        throw new Error("z required");
      Object.freeze(this);
    }
    // Does not validate if the point is on-curve.
    // Use fromHex instead, or call assertValidity() later.
    static fromAffine(xe) {
      const { x: ve, y: Te } = xe || {};
      if (!xe || !T.isValid(ve) || !T.isValid(Te))
        throw new Error("invalid affine point");
      if (xe instanceof ue)
        throw new Error("projective point not allowed");
      const we = (Ee) => T.eql(Ee, T.ZERO);
      return we(ve) && we(Te) ? ue.ZERO : new ue(ve, Te, T.ONE);
    }
    get x() {
      return this.toAffine().x;
    }
    get y() {
      return this.toAffine().y;
    }
    /**
     * Takes a bunch of Projective Points but executes only one
     * inversion on all of them. Inversion is very slow operation,
     * so this improves performance massively.
     * Optimization: converts a list of projective points to a list of identical points with Z=1.
     */
    static normalizeZ(xe) {
      const ve = T.invertBatch(xe.map((Te) => Te.pz));
      return xe.map((Te, we) => Te.toAffine(ve[we])).map(ue.fromAffine);
    }
    /**
     * Converts hash string or Uint8Array to Point.
     * @param hex short/long ECDSA hex
     */
    static fromHex(xe) {
      const ve = ue.fromAffine(J(ensureBytes("pointHex", xe)));
      return ve.assertValidity(), ve;
    }
    // Multiplies generator point by privateKey.
    static fromPrivateKey(xe) {
      return ue.BASE.multiply(re(xe));
    }
    // Multiscalar Multiplication
    static msm(xe, ve) {
      return pippenger(ue, $, xe, ve);
    }
    // "Private method", don't use it directly
    _setWindowSize(xe) {
      he.setWindowSize(this, xe);
    }
    // A point on curve is valid if it conforms to equation.
    assertValidity() {
      de(this);
    }
    hasEvenY() {
      const { y: xe } = this.toAffine();
      if (T.isOdd)
        return !T.isOdd(xe);
      throw new Error("Field doesn't support isOdd");
    }
    /**
     * Compare one point to another.
     */
    equals(xe) {
      ie(xe);
      const { px: ve, py: Te, pz: we } = this, { px: Ee, py: Me, pz: Ie } = xe, ke = T.eql(T.mul(ve, Ie), T.mul(Ee, we)), _e = T.eql(T.mul(Te, Ie), T.mul(Me, we));
      return ke && _e;
    }
    /**
     * Flips point to one corresponding to (x, -y) in Affine coordinates.
     */
    negate() {
      return new ue(this.px, T.neg(this.py), this.pz);
    }
    // Renes-Costello-Batina exception-free doubling formula.
    // There is 30% faster Jacobian formula, but it is not complete.
    // https://eprint.iacr.org/2015/1060, algorithm 3
    // Cost: 8M + 3S + 3*a + 2*b3 + 15add.
    double() {
      const { a: xe, b: ve } = e, Te = T.mul(ve, _3n), { px: we, py: Ee, pz: Me } = this;
      let Ie = T.ZERO, ke = T.ZERO, _e = T.ZERO, De = T.mul(we, we), Fe = T.mul(Ee, Ee), Ae = T.mul(Me, Me), ne = T.mul(we, Ee);
      return ne = T.add(ne, ne), _e = T.mul(we, Me), _e = T.add(_e, _e), Ie = T.mul(xe, _e), ke = T.mul(Te, Ae), ke = T.add(Ie, ke), Ie = T.sub(Fe, ke), ke = T.add(Fe, ke), ke = T.mul(Ie, ke), Ie = T.mul(ne, Ie), _e = T.mul(Te, _e), Ae = T.mul(xe, Ae), ne = T.sub(De, Ae), ne = T.mul(xe, ne), ne = T.add(ne, _e), _e = T.add(De, De), De = T.add(_e, De), De = T.add(De, Ae), De = T.mul(De, ne), ke = T.add(ke, De), Ae = T.mul(Ee, Me), Ae = T.add(Ae, Ae), De = T.mul(Ae, ne), Ie = T.sub(Ie, De), _e = T.mul(Ae, Fe), _e = T.add(_e, _e), _e = T.add(_e, _e), new ue(Ie, ke, _e);
    }
    // Renes-Costello-Batina exception-free addition formula.
    // There is 30% faster Jacobian formula, but it is not complete.
    // https://eprint.iacr.org/2015/1060, algorithm 1
    // Cost: 12M + 0S + 3*a + 3*b3 + 23add.
    add(xe) {
      ie(xe);
      const { px: ve, py: Te, pz: we } = this, { px: Ee, py: Me, pz: Ie } = xe;
      let ke = T.ZERO, _e = T.ZERO, De = T.ZERO;
      const Fe = e.a, Ae = T.mul(e.b, _3n);
      let ne = T.mul(ve, Ee), oe = T.mul(Te, Me), ce = T.mul(we, Ie), le = T.add(ve, Te), pe = T.add(Ee, Me);
      le = T.mul(le, pe), pe = T.add(ne, oe), le = T.sub(le, pe), pe = T.add(ve, we);
      let ye = T.add(Ee, Ie);
      return pe = T.mul(pe, ye), ye = T.add(ne, ce), pe = T.sub(pe, ye), ye = T.add(Te, we), ke = T.add(Me, Ie), ye = T.mul(ye, ke), ke = T.add(oe, ce), ye = T.sub(ye, ke), De = T.mul(Fe, pe), ke = T.mul(Ae, ce), De = T.add(ke, De), ke = T.sub(oe, De), De = T.add(oe, De), _e = T.mul(ke, De), oe = T.add(ne, ne), oe = T.add(oe, ne), ce = T.mul(Fe, ce), pe = T.mul(Ae, pe), oe = T.add(oe, ce), ce = T.sub(ne, ce), ce = T.mul(Fe, ce), pe = T.add(pe, ce), ne = T.mul(oe, pe), _e = T.add(_e, ne), ne = T.mul(ye, pe), ke = T.mul(le, ke), ke = T.sub(ke, ne), ne = T.mul(le, oe), De = T.mul(ye, De), De = T.add(De, ne), new ue(ke, _e, De);
    }
    subtract(xe) {
      return this.add(xe.negate());
    }
    is0() {
      return this.equals(ue.ZERO);
    }
    wNAF(xe) {
      return he.wNAFCached(this, xe, ue.normalizeZ);
    }
    /**
     * Non-constant-time multiplication. Uses double-and-add algorithm.
     * It's faster, but should only be used when you don't care about
     * an exposed private key e.g. sig verification, which works over *public* keys.
     */
    multiplyUnsafe(xe) {
      const { endo: ve, n: Te } = e;
      aInRange("scalar", xe, _0n$1, Te);
      const we = ue.ZERO;
      if (xe === _0n$1)
        return we;
      if (this.is0() || xe === _1n$3)
        return this;
      if (!ve || he.hasPrecomputes(this))
        return he.wNAFCachedUnsafe(this, xe, ue.normalizeZ);
      let { k1neg: Ee, k1: Me, k2neg: Ie, k2: ke } = ve.splitScalar(xe), _e = we, De = we, Fe = this;
      for (; Me > _0n$1 || ke > _0n$1; )
        Me & _1n$3 && (_e = _e.add(Fe)), ke & _1n$3 && (De = De.add(Fe)), Fe = Fe.double(), Me >>= _1n$3, ke >>= _1n$3;
      return Ee && (_e = _e.negate()), Ie && (De = De.negate()), De = new ue(T.mul(De.px, ve.beta), De.py, De.pz), _e.add(De);
    }
    /**
     * Constant time multiplication.
     * Uses wNAF method. Windowed method may be 10% faster,
     * but takes 2x longer to generate and consumes 2x memory.
     * Uses precomputes when available.
     * Uses endomorphism for Koblitz curves.
     * @param scalar by which the point would be multiplied
     * @returns New point
     */
    multiply(xe) {
      const { endo: ve, n: Te } = e;
      aInRange("scalar", xe, _1n$3, Te);
      let we, Ee;
      if (ve) {
        const { k1neg: Me, k1: Ie, k2neg: ke, k2: _e } = ve.splitScalar(xe);
        let { p: De, f: Fe } = this.wNAF(Ie), { p: Ae, f: ne } = this.wNAF(_e);
        De = he.constTimeNegate(Me, De), Ae = he.constTimeNegate(ke, Ae), Ae = new ue(T.mul(Ae.px, ve.beta), Ae.py, Ae.pz), we = De.add(Ae), Ee = Fe.add(ne);
      } else {
        const { p: Me, f: Ie } = this.wNAF(xe);
        we = Me, Ee = Ie;
      }
      return ue.normalizeZ([we, Ee])[0];
    }
    /**
     * Efficiently calculate `aP + bQ`. Unsafe, can expose private key, if used incorrectly.
     * Not using Strauss-Shamir trick: precomputation tables are faster.
     * The trick could be useful if both P and Q are not G (not in our case).
     * @returns non-zero affine point
     */
    multiplyAndAddUnsafe(xe, ve, Te) {
      const we = ue.BASE, Ee = (Ie, ke) => ke === _0n$1 || ke === _1n$3 || !Ie.equals(we) ? Ie.multiplyUnsafe(ke) : Ie.multiply(ke), Me = Ee(this, ve).add(Ee(xe, Te));
      return Me.is0() ? void 0 : Me;
    }
    // Converts Projective point to affine (x, y) coordinates.
    // Can accept precomputed Z^-1 - for example, from invertBatch.
    // (x, y, z) ∋ (x=x/z, y=y/z)
    toAffine(xe) {
      return se(this, xe);
    }
    isTorsionFree() {
      const { h: xe, isTorsionFree: ve } = e;
      if (xe === _1n$3)
        return !0;
      if (ve)
        return ve(ue, this);
      throw new Error("isTorsionFree() has not been declared for the elliptic curve");
    }
    clearCofactor() {
      const { h: xe, clearCofactor: ve } = e;
      return xe === _1n$3 ? this : ve ? ve(ue, this) : this.multiplyUnsafe(e.h);
    }
    toRawBytes(xe = !0) {
      return abool("isCompressed", xe), this.assertValidity(), V(ue, this, xe);
    }
    toHex(xe = !0) {
      return abool("isCompressed", xe), bytesToHex(this.toRawBytes(xe));
    }
  }
  ue.BASE = new ue(e.Gx, e.Gy, T.ONE), ue.ZERO = new ue(T.ZERO, T.ONE, T.ZERO);
  const fe = e.nBitLength, he = wNAF(ue, e.endo ? Math.ceil(fe / 2) : fe);
  return {
    CURVE: e,
    ProjectivePoint: ue,
    normPrivateKeyToScalar: re,
    weierstrassEquation: ee,
    isWithinCurveOrder: te
  };
}
function validateOpts$1(C) {
  const e = validateBasic(C);
  return validateObject(e, {
    hash: "hash",
    hmac: "function",
    randomBytes: "function"
  }, {
    bits2int: "function",
    bits2int_modN: "function",
    lowS: "boolean"
  }), Object.freeze({ lowS: !0, ...e });
}
function weierstrass(C) {
  const e = validateOpts$1(C), { Fp: T, n: $ } = e, V = T.BYTES + 1, J = 2 * T.BYTES + 1;
  function ee(ce) {
    return mod(ce, $);
  }
  function te(ce) {
    return invert(ce, $);
  }
  const { ProjectivePoint: re, normPrivateKeyToScalar: ie, weierstrassEquation: se, isWithinCurveOrder: de } = weierstrassPoints({
    ...e,
    toBytes(ce, le, pe) {
      const ye = le.toAffine(), Ce = T.toBytes(ye.x), be = concatBytes;
      return abool("isCompressed", pe), pe ? be(Uint8Array.from([le.hasEvenY() ? 2 : 3]), Ce) : be(Uint8Array.from([4]), Ce, T.toBytes(ye.y));
    },
    fromBytes(ce) {
      const le = ce.length, pe = ce[0], ye = ce.subarray(1);
      if (le === V && (pe === 2 || pe === 3)) {
        const Ce = bytesToNumberBE(ye);
        if (!inRange$1(Ce, _1n$3, T.ORDER))
          throw new Error("Point is not on curve");
        const be = se(Ce);
        let ae;
        try {
          ae = T.sqrt(be);
        } catch (Le) {
          const ze = Le instanceof Error ? ": " + Le.message : "";
          throw new Error("Point is not on curve" + ze);
        }
        const ge = (ae & _1n$3) === _1n$3;
        return (pe & 1) === 1 !== ge && (ae = T.neg(ae)), { x: Ce, y: ae };
      } else if (le === J && pe === 4) {
        const Ce = T.fromBytes(ye.subarray(0, T.BYTES)), be = T.fromBytes(ye.subarray(T.BYTES, 2 * T.BYTES));
        return { x: Ce, y: be };
      } else {
        const Ce = V, be = J;
        throw new Error("invalid Point, expected length of " + Ce + ", or uncompressed " + be + ", got " + le);
      }
    }
  }), ue = (ce) => bytesToHex(numberToBytesBE(ce, e.nByteLength));
  function fe(ce) {
    const le = $ >> _1n$3;
    return ce > le;
  }
  function he(ce) {
    return fe(ce) ? ee(-ce) : ce;
  }
  const me = (ce, le, pe) => bytesToNumberBE(ce.slice(le, pe));
  class xe {
    constructor(le, pe, ye) {
      this.r = le, this.s = pe, this.recovery = ye, this.assertValidity();
    }
    // pair (bytes of r, bytes of s)
    static fromCompact(le) {
      const pe = e.nByteLength;
      return le = ensureBytes("compactSignature", le, pe * 2), new xe(me(le, 0, pe), me(le, pe, 2 * pe));
    }
    // DER encoded ECDSA signature
    // https://bitcoin.stackexchange.com/questions/57644/what-are-the-parts-of-a-bitcoin-transaction-input-script
    static fromDER(le) {
      const { r: pe, s: ye } = DER.toSig(ensureBytes("DER", le));
      return new xe(pe, ye);
    }
    assertValidity() {
      aInRange("r", this.r, _1n$3, $), aInRange("s", this.s, _1n$3, $);
    }
    addRecoveryBit(le) {
      return new xe(this.r, this.s, le);
    }
    recoverPublicKey(le) {
      const { r: pe, s: ye, recovery: Ce } = this, be = Ie(ensureBytes("msgHash", le));
      if (Ce == null || ![0, 1, 2, 3].includes(Ce))
        throw new Error("recovery id invalid");
      const ae = Ce === 2 || Ce === 3 ? pe + e.n : pe;
      if (ae >= T.ORDER)
        throw new Error("recovery id 2 or 3 invalid");
      const ge = Ce & 1 ? "03" : "02", Se = re.fromHex(ge + ue(ae)), Le = te(ae), ze = ee(-be * Le), Re = ee(ye * Le), We = re.BASE.multiplyAndAddUnsafe(Se, ze, Re);
      if (!We)
        throw new Error("point at infinify");
      return We.assertValidity(), We;
    }
    // Signatures should be low-s, to prevent malleability.
    hasHighS() {
      return fe(this.s);
    }
    normalizeS() {
      return this.hasHighS() ? new xe(this.r, ee(-this.s), this.recovery) : this;
    }
    // DER-encoded
    toDERRawBytes() {
      return hexToBytes(this.toDERHex());
    }
    toDERHex() {
      return DER.hexFromSig({ r: this.r, s: this.s });
    }
    // padded bytes of r, then padded bytes of s
    toCompactRawBytes() {
      return hexToBytes(this.toCompactHex());
    }
    toCompactHex() {
      return ue(this.r) + ue(this.s);
    }
  }
  const ve = {
    isValidPrivateKey(ce) {
      try {
        return ie(ce), !0;
      } catch {
        return !1;
      }
    },
    normPrivateKeyToScalar: ie,
    /**
     * Produces cryptographically secure private key from random of size
     * (groupLen + ceil(groupLen / 2)) with modulo bias being negligible.
     */
    randomPrivateKey: () => {
      const ce = getMinHashLength(e.n);
      return mapHashToField(e.randomBytes(ce), e.n);
    },
    /**
     * Creates precompute table for an arbitrary EC point. Makes point "cached".
     * Allows to massively speed-up `point.multiply(scalar)`.
     * @returns cached point
     * @example
     * const fast = utils.precompute(8, ProjectivePoint.fromHex(someonesPubKey));
     * fast.multiply(privKey); // much faster ECDH now
     */
    precompute(ce = 8, le = re.BASE) {
      return le._setWindowSize(ce), le.multiply(BigInt(3)), le;
    }
  };
  function Te(ce, le = !0) {
    return re.fromPrivateKey(ce).toRawBytes(le);
  }
  function we(ce) {
    const le = isBytes(ce), pe = typeof ce == "string", ye = (le || pe) && ce.length;
    return le ? ye === V || ye === J : pe ? ye === 2 * V || ye === 2 * J : ce instanceof re;
  }
  function Ee(ce, le, pe = !0) {
    if (we(ce))
      throw new Error("first arg must be private key");
    if (!we(le))
      throw new Error("second arg must be public key");
    return re.fromHex(le).multiply(ie(ce)).toRawBytes(pe);
  }
  const Me = e.bits2int || function(ce) {
    if (ce.length > 8192)
      throw new Error("input is too large");
    const le = bytesToNumberBE(ce), pe = ce.length * 8 - e.nBitLength;
    return pe > 0 ? le >> BigInt(pe) : le;
  }, Ie = e.bits2int_modN || function(ce) {
    return ee(Me(ce));
  }, ke = bitMask(e.nBitLength);
  function _e(ce) {
    return aInRange("num < 2^" + e.nBitLength, ce, _0n$1, ke), numberToBytesBE(ce, e.nByteLength);
  }
  function De(ce, le, pe = Fe) {
    if (["recovered", "canonical"].some((Ue) => Ue in pe))
      throw new Error("sign() legacy options not supported");
    const { hash: ye, randomBytes: Ce } = e;
    let { lowS: be, prehash: ae, extraEntropy: ge } = pe;
    be == null && (be = !0), ce = ensureBytes("msgHash", ce), validateSigVerOpts(pe), ae && (ce = ensureBytes("prehashed msgHash", ye(ce)));
    const Se = Ie(ce), Le = ie(le), ze = [_e(Le), _e(Se)];
    if (ge != null && ge !== !1) {
      const Ue = ge === !0 ? Ce(T.BYTES) : ge;
      ze.push(ensureBytes("extraEntropy", Ue));
    }
    const Re = concatBytes(...ze), We = Se;
    function Be(Ue) {
      const Ge = Me(Ue);
      if (!de(Ge))
        return;
      const je = te(Ge), Oe = re.BASE.multiply(Ge).toAffine(), Ne = ee(Oe.x);
      if (Ne === _0n$1)
        return;
      const Ye = ee(je * ee(We + Ne * Le));
      if (Ye === _0n$1)
        return;
      let Je = (Oe.x === Ne ? 0 : 2) | Number(Oe.y & _1n$3), Xe = Ye;
      return be && fe(Ye) && (Xe = he(Ye), Je ^= 1), new xe(Ne, Xe, Je);
    }
    return { seed: Re, k2sig: Be };
  }
  const Fe = { lowS: e.lowS, prehash: !1 }, Ae = { lowS: e.lowS, prehash: !1 };
  function ne(ce, le, pe = Fe) {
    const { seed: ye, k2sig: Ce } = De(ce, le, pe), be = e;
    return createHmacDrbg(be.hash.outputLen, be.nByteLength, be.hmac)(ye, Ce);
  }
  re.BASE._setWindowSize(8);
  function oe(ce, le, pe, ye = Ae) {
    var Je;
    const Ce = ce;
    le = ensureBytes("msgHash", le), pe = ensureBytes("publicKey", pe);
    const { lowS: be, prehash: ae, format: ge } = ye;
    if (validateSigVerOpts(ye), "strict" in ye)
      throw new Error("options.strict was renamed to lowS");
    if (ge !== void 0 && ge !== "compact" && ge !== "der")
      throw new Error("format must be compact or der");
    const Se = typeof Ce == "string" || isBytes(Ce), Le = !Se && !ge && typeof Ce == "object" && Ce !== null && typeof Ce.r == "bigint" && typeof Ce.s == "bigint";
    if (!Se && !Le)
      throw new Error("invalid signature, expected Uint8Array, hex string or Signature instance");
    let ze, Re;
    try {
      if (Le && (ze = new xe(Ce.r, Ce.s)), Se) {
        try {
          ge !== "compact" && (ze = xe.fromDER(Ce));
        } catch (Xe) {
          if (!(Xe instanceof DER.Err))
            throw Xe;
        }
        !ze && ge !== "der" && (ze = xe.fromCompact(Ce));
      }
      Re = re.fromHex(pe);
    } catch {
      return !1;
    }
    if (!ze || be && ze.hasHighS())
      return !1;
    ae && (le = e.hash(le));
    const { r: We, s: Be } = ze, Ue = Ie(le), Ge = te(Be), je = ee(Ue * Ge), Oe = ee(We * Ge), Ne = (Je = re.BASE.multiplyAndAddUnsafe(Re, je, Oe)) == null ? void 0 : Je.toAffine();
    return Ne ? ee(Ne.x) === We : !1;
  }
  return {
    CURVE: e,
    getPublicKey: Te,
    getSharedSecret: Ee,
    sign: ne,
    verify: oe,
    ProjectivePoint: re,
    Signature: xe,
    utils: ve
  };
}
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */
function getHash(C) {
  return {
    hash: C,
    hmac: (e, ...T) => hmac$1(C, e, concatBytes$1(...T)),
    randomBytes
  };
}
function createCurve(C, e) {
  const T = ($) => weierstrass({ ...C, ...getHash($) });
  return Object.freeze({ ...T(e), create: T });
}
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */
const secp256k1P = BigInt("0xfffffffffffffffffffffffffffffffffffffffffffffffffffffffefffffc2f"), secp256k1N = BigInt("0xfffffffffffffffffffffffffffffffebaaedce6af48a03bbfd25e8cd0364141"), _1n$2 = BigInt(1), _2n$2 = BigInt(2), divNearest = (C, e) => (C + e / _2n$2) / e;
function sqrtMod(C) {
  const e = secp256k1P, T = BigInt(3), $ = BigInt(6), V = BigInt(11), J = BigInt(22), ee = BigInt(23), te = BigInt(44), re = BigInt(88), ie = C * C * C % e, se = ie * ie * C % e, de = pow2(se, T, e) * se % e, ue = pow2(de, T, e) * se % e, fe = pow2(ue, _2n$2, e) * ie % e, he = pow2(fe, V, e) * fe % e, me = pow2(he, J, e) * he % e, xe = pow2(me, te, e) * me % e, ve = pow2(xe, re, e) * xe % e, Te = pow2(ve, te, e) * me % e, we = pow2(Te, T, e) * se % e, Ee = pow2(we, ee, e) * he % e, Me = pow2(Ee, $, e) * ie % e, Ie = pow2(Me, _2n$2, e);
  if (!Fpk1.eql(Fpk1.sqr(Ie), C))
    throw new Error("Cannot find square root");
  return Ie;
}
const Fpk1 = Field(secp256k1P, void 0, void 0, { sqrt: sqrtMod }), secp256k1$1 = createCurve({
  a: BigInt(0),
  // equation params: a, b
  b: BigInt(7),
  // Seem to be rigid: bitcointalk.org/index.php?topic=289795.msg3183975#msg3183975
  Fp: Fpk1,
  // Field's prime: 2n**256n - 2n**32n - 2n**9n - 2n**8n - 2n**7n - 2n**6n - 2n**4n - 1n
  n: secp256k1N,
  // Curve order, total count of valid points in the field
  // Base point (x, y) aka generator point
  Gx: BigInt("55066263022277343669578718895168534326250603453777594175500187360389116729240"),
  Gy: BigInt("32670510020758816978083085130507043184471273380659243275938904335757337482424"),
  h: BigInt(1),
  // Cofactor
  lowS: !0,
  // Allow only low-S signatures by default in sign() and verify()
  /**
   * secp256k1 belongs to Koblitz curves: it has efficiently computable endomorphism.
   * Endomorphism uses 2x less RAM, speeds up precomputation by 2x and ECDH / key recovery by 20%.
   * For precomputed wNAF it trades off 1/2 init time & 1/3 ram for 20% perf hit.
   * Explanation: https://gist.github.com/paulmillr/eb670806793e84df628a7c434a873066
   */
  endo: {
    beta: BigInt("0x7ae96a2b657c07106e64479eac3434e99cf0497512f58995c1396c28719501ee"),
    splitScalar: (C) => {
      const e = secp256k1N, T = BigInt("0x3086d221a7d46bcde86c90e49284eb15"), $ = -_1n$2 * BigInt("0xe4437ed6010e88286f547fa90abfe4c3"), V = BigInt("0x114ca50f7a8e2f3f657c1108d9d44cfd8"), J = T, ee = BigInt("0x100000000000000000000000000000000"), te = divNearest(J * C, e), re = divNearest(-$ * C, e);
      let ie = mod(C - te * T - re * V, e), se = mod(-te * $ - re * J, e);
      const de = ie > ee, ue = se > ee;
      if (de && (ie = e - ie), ue && (se = e - se), ie > ee || se > ee)
        throw new Error("splitScalar: Endomorphism failed, k=" + C);
      return { k1neg: de, k1: ie, k2neg: ue, k2: se };
    }
  }
}, sha256$4);
BigInt(0);
secp256k1$1.ProjectivePoint;
const U32_MASK64 = /* @__PURE__ */ BigInt(2 ** 32 - 1), _32n = /* @__PURE__ */ BigInt(32);
function fromBig(C, e = !1) {
  return e ? { h: Number(C & U32_MASK64), l: Number(C >> _32n & U32_MASK64) } : { h: Number(C >> _32n & U32_MASK64) | 0, l: Number(C & U32_MASK64) | 0 };
}
function split(C, e = !1) {
  let T = new Uint32Array(C.length), $ = new Uint32Array(C.length);
  for (let V = 0; V < C.length; V++) {
    const { h: J, l: ee } = fromBig(C[V], e);
    [T[V], $[V]] = [J, ee];
  }
  return [T, $];
}
const toBig = (C, e) => BigInt(C >>> 0) << _32n | BigInt(e >>> 0), shrSH = (C, e, T) => C >>> T, shrSL = (C, e, T) => C << 32 - T | e >>> T, rotrSH = (C, e, T) => C >>> T | e << 32 - T, rotrSL = (C, e, T) => C << 32 - T | e >>> T, rotrBH = (C, e, T) => C << 64 - T | e >>> T - 32, rotrBL = (C, e, T) => C >>> T - 32 | e << 64 - T, rotr32H = (C, e) => e, rotr32L = (C, e) => C, rotlSH = (C, e, T) => C << T | e >>> 32 - T, rotlSL = (C, e, T) => e << T | C >>> 32 - T, rotlBH = (C, e, T) => e << T - 32 | C >>> 64 - T, rotlBL = (C, e, T) => C << T - 32 | e >>> 64 - T;
function add(C, e, T, $) {
  const V = (e >>> 0) + ($ >>> 0);
  return { h: C + T + (V / 2 ** 32 | 0) | 0, l: V | 0 };
}
const add3L = (C, e, T) => (C >>> 0) + (e >>> 0) + (T >>> 0), add3H = (C, e, T, $) => e + T + $ + (C / 2 ** 32 | 0) | 0, add4L = (C, e, T, $) => (C >>> 0) + (e >>> 0) + (T >>> 0) + ($ >>> 0), add4H = (C, e, T, $, V) => e + T + $ + V + (C / 2 ** 32 | 0) | 0, add5L = (C, e, T, $, V) => (C >>> 0) + (e >>> 0) + (T >>> 0) + ($ >>> 0) + (V >>> 0), add5H = (C, e, T, $, V, J) => e + T + $ + V + J + (C / 2 ** 32 | 0) | 0, u64$3 = {
  fromBig,
  split,
  toBig,
  shrSH,
  shrSL,
  rotrSH,
  rotrSL,
  rotrBH,
  rotrBL,
  rotr32H,
  rotr32L,
  rotlSH,
  rotlSL,
  rotlBH,
  rotlBL,
  add,
  add3L,
  add3H,
  add4L,
  add4H,
  add5H,
  add5L
}, [SHA512_Kh, SHA512_Kl] = u64$3.split([
  "0x428a2f98d728ae22",
  "0x7137449123ef65cd",
  "0xb5c0fbcfec4d3b2f",
  "0xe9b5dba58189dbbc",
  "0x3956c25bf348b538",
  "0x59f111f1b605d019",
  "0x923f82a4af194f9b",
  "0xab1c5ed5da6d8118",
  "0xd807aa98a3030242",
  "0x12835b0145706fbe",
  "0x243185be4ee4b28c",
  "0x550c7dc3d5ffb4e2",
  "0x72be5d74f27b896f",
  "0x80deb1fe3b1696b1",
  "0x9bdc06a725c71235",
  "0xc19bf174cf692694",
  "0xe49b69c19ef14ad2",
  "0xefbe4786384f25e3",
  "0x0fc19dc68b8cd5b5",
  "0x240ca1cc77ac9c65",
  "0x2de92c6f592b0275",
  "0x4a7484aa6ea6e483",
  "0x5cb0a9dcbd41fbd4",
  "0x76f988da831153b5",
  "0x983e5152ee66dfab",
  "0xa831c66d2db43210",
  "0xb00327c898fb213f",
  "0xbf597fc7beef0ee4",
  "0xc6e00bf33da88fc2",
  "0xd5a79147930aa725",
  "0x06ca6351e003826f",
  "0x142929670a0e6e70",
  "0x27b70a8546d22ffc",
  "0x2e1b21385c26c926",
  "0x4d2c6dfc5ac42aed",
  "0x53380d139d95b3df",
  "0x650a73548baf63de",
  "0x766a0abb3c77b2a8",
  "0x81c2c92e47edaee6",
  "0x92722c851482353b",
  "0xa2bfe8a14cf10364",
  "0xa81a664bbc423001",
  "0xc24b8b70d0f89791",
  "0xc76c51a30654be30",
  "0xd192e819d6ef5218",
  "0xd69906245565a910",
  "0xf40e35855771202a",
  "0x106aa07032bbd1b8",
  "0x19a4c116b8d2d0c8",
  "0x1e376c085141ab53",
  "0x2748774cdf8eeb99",
  "0x34b0bcb5e19b48a8",
  "0x391c0cb3c5c95a63",
  "0x4ed8aa4ae3418acb",
  "0x5b9cca4f7763e373",
  "0x682e6ff3d6b2b8a3",
  "0x748f82ee5defb2fc",
  "0x78a5636f43172f60",
  "0x84c87814a1f0ab72",
  "0x8cc702081a6439ec",
  "0x90befffa23631e28",
  "0xa4506cebde82bde9",
  "0xbef9a3f7b2c67915",
  "0xc67178f2e372532b",
  "0xca273eceea26619c",
  "0xd186b8c721c0c207",
  "0xeada7dd6cde0eb1e",
  "0xf57d4f7fee6ed178",
  "0x06f067aa72176fba",
  "0x0a637dc5a2c898a6",
  "0x113f9804bef90dae",
  "0x1b710b35131c471b",
  "0x28db77f523047d84",
  "0x32caab7b40c72493",
  "0x3c9ebe0a15c9bebc",
  "0x431d67c49c100d4c",
  "0x4cc5d4becb3e42b6",
  "0x597f299cfc657e2a",
  "0x5fcb6fab3ad6faec",
  "0x6c44198c4a475817"
].map((C) => BigInt(C))), SHA512_W_H = /* @__PURE__ */ new Uint32Array(80), SHA512_W_L = /* @__PURE__ */ new Uint32Array(80);
class SHA512 extends HashMD {
  constructor() {
    super(128, 64, 16, !1), this.Ah = 1779033703, this.Al = -205731576, this.Bh = -1150833019, this.Bl = -2067093701, this.Ch = 1013904242, this.Cl = -23791573, this.Dh = -1521486534, this.Dl = 1595750129, this.Eh = 1359893119, this.El = -1377402159, this.Fh = -1694144372, this.Fl = 725511199, this.Gh = 528734635, this.Gl = -79577749, this.Hh = 1541459225, this.Hl = 327033209;
  }
  // prettier-ignore
  get() {
    const { Ah: e, Al: T, Bh: $, Bl: V, Ch: J, Cl: ee, Dh: te, Dl: re, Eh: ie, El: se, Fh: de, Fl: ue, Gh: fe, Gl: he, Hh: me, Hl: xe } = this;
    return [e, T, $, V, J, ee, te, re, ie, se, de, ue, fe, he, me, xe];
  }
  // prettier-ignore
  set(e, T, $, V, J, ee, te, re, ie, se, de, ue, fe, he, me, xe) {
    this.Ah = e | 0, this.Al = T | 0, this.Bh = $ | 0, this.Bl = V | 0, this.Ch = J | 0, this.Cl = ee | 0, this.Dh = te | 0, this.Dl = re | 0, this.Eh = ie | 0, this.El = se | 0, this.Fh = de | 0, this.Fl = ue | 0, this.Gh = fe | 0, this.Gl = he | 0, this.Hh = me | 0, this.Hl = xe | 0;
  }
  process(e, T) {
    for (let we = 0; we < 16; we++, T += 4)
      SHA512_W_H[we] = e.getUint32(T), SHA512_W_L[we] = e.getUint32(T += 4);
    for (let we = 16; we < 80; we++) {
      const Ee = SHA512_W_H[we - 15] | 0, Me = SHA512_W_L[we - 15] | 0, Ie = u64$3.rotrSH(Ee, Me, 1) ^ u64$3.rotrSH(Ee, Me, 8) ^ u64$3.shrSH(Ee, Me, 7), ke = u64$3.rotrSL(Ee, Me, 1) ^ u64$3.rotrSL(Ee, Me, 8) ^ u64$3.shrSL(Ee, Me, 7), _e = SHA512_W_H[we - 2] | 0, De = SHA512_W_L[we - 2] | 0, Fe = u64$3.rotrSH(_e, De, 19) ^ u64$3.rotrBH(_e, De, 61) ^ u64$3.shrSH(_e, De, 6), Ae = u64$3.rotrSL(_e, De, 19) ^ u64$3.rotrBL(_e, De, 61) ^ u64$3.shrSL(_e, De, 6), ne = u64$3.add4L(ke, Ae, SHA512_W_L[we - 7], SHA512_W_L[we - 16]), oe = u64$3.add4H(ne, Ie, Fe, SHA512_W_H[we - 7], SHA512_W_H[we - 16]);
      SHA512_W_H[we] = oe | 0, SHA512_W_L[we] = ne | 0;
    }
    let { Ah: $, Al: V, Bh: J, Bl: ee, Ch: te, Cl: re, Dh: ie, Dl: se, Eh: de, El: ue, Fh: fe, Fl: he, Gh: me, Gl: xe, Hh: ve, Hl: Te } = this;
    for (let we = 0; we < 80; we++) {
      const Ee = u64$3.rotrSH(de, ue, 14) ^ u64$3.rotrSH(de, ue, 18) ^ u64$3.rotrBH(de, ue, 41), Me = u64$3.rotrSL(de, ue, 14) ^ u64$3.rotrSL(de, ue, 18) ^ u64$3.rotrBL(de, ue, 41), Ie = de & fe ^ ~de & me, ke = ue & he ^ ~ue & xe, _e = u64$3.add5L(Te, Me, ke, SHA512_Kl[we], SHA512_W_L[we]), De = u64$3.add5H(_e, ve, Ee, Ie, SHA512_Kh[we], SHA512_W_H[we]), Fe = _e | 0, Ae = u64$3.rotrSH($, V, 28) ^ u64$3.rotrBH($, V, 34) ^ u64$3.rotrBH($, V, 39), ne = u64$3.rotrSL($, V, 28) ^ u64$3.rotrBL($, V, 34) ^ u64$3.rotrBL($, V, 39), oe = $ & J ^ $ & te ^ J & te, ce = V & ee ^ V & re ^ ee & re;
      ve = me | 0, Te = xe | 0, me = fe | 0, xe = he | 0, fe = de | 0, he = ue | 0, { h: de, l: ue } = u64$3.add(ie | 0, se | 0, De | 0, Fe | 0), ie = te | 0, se = re | 0, te = J | 0, re = ee | 0, J = $ | 0, ee = V | 0;
      const le = u64$3.add3L(Fe, ne, ce);
      $ = u64$3.add3H(le, De, Ae, oe), V = le | 0;
    }
    ({ h: $, l: V } = u64$3.add(this.Ah | 0, this.Al | 0, $ | 0, V | 0)), { h: J, l: ee } = u64$3.add(this.Bh | 0, this.Bl | 0, J | 0, ee | 0), { h: te, l: re } = u64$3.add(this.Ch | 0, this.Cl | 0, te | 0, re | 0), { h: ie, l: se } = u64$3.add(this.Dh | 0, this.Dl | 0, ie | 0, se | 0), { h: de, l: ue } = u64$3.add(this.Eh | 0, this.El | 0, de | 0, ue | 0), { h: fe, l: he } = u64$3.add(this.Fh | 0, this.Fl | 0, fe | 0, he | 0), { h: me, l: xe } = u64$3.add(this.Gh | 0, this.Gl | 0, me | 0, xe | 0), { h: ve, l: Te } = u64$3.add(this.Hh | 0, this.Hl | 0, ve | 0, Te | 0), this.set($, V, J, ee, te, re, ie, se, de, ue, fe, he, me, xe, ve, Te);
  }
  roundClean() {
    SHA512_W_H.fill(0), SHA512_W_L.fill(0);
  }
  destroy() {
    this.buffer.fill(0), this.set(0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0);
  }
}
const sha512$4 = /* @__PURE__ */ wrapConstructor(() => new SHA512());
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */
const _0n = BigInt(0), _1n$1 = BigInt(1), _2n$1 = BigInt(2), _8n$1 = BigInt(8), VERIFY_DEFAULT = { zip215: !0 };
function validateOpts(C) {
  const e = validateBasic(C);
  return validateObject(C, {
    hash: "function",
    a: "bigint",
    d: "bigint",
    randomBytes: "function"
  }, {
    adjustScalarBytes: "function",
    domain: "function",
    uvRatio: "function",
    mapToCurve: "function"
  }), Object.freeze({ ...e });
}
function twistedEdwards(C) {
  const e = validateOpts(C), { Fp: T, n: $, prehash: V, hash: J, randomBytes: ee, nByteLength: te, h: re } = e, ie = _2n$1 << BigInt(te * 8) - _1n$1, se = T.create, de = Field(e.n, e.nBitLength), ue = e.uvRatio || ((pe, ye) => {
    try {
      return { isValid: !0, value: T.sqrt(pe * T.inv(ye)) };
    } catch {
      return { isValid: !1, value: _0n };
    }
  }), fe = e.adjustScalarBytes || ((pe) => pe), he = e.domain || ((pe, ye, Ce) => {
    if (abool("phflag", Ce), ye.length || Ce)
      throw new Error("Contexts/pre-hash are not supported");
    return pe;
  });
  function me(pe, ye) {
    aInRange("coordinate " + pe, ye, _0n, ie);
  }
  function xe(pe) {
    if (!(pe instanceof we))
      throw new Error("ExtendedPoint expected");
  }
  const ve = memoized((pe, ye) => {
    const { ex: Ce, ey: be, ez: ae } = pe, ge = pe.is0();
    ye == null && (ye = ge ? _8n$1 : T.inv(ae));
    const Se = se(Ce * ye), Le = se(be * ye), ze = se(ae * ye);
    if (ge)
      return { x: _0n, y: _1n$1 };
    if (ze !== _1n$1)
      throw new Error("invZ was invalid");
    return { x: Se, y: Le };
  }), Te = memoized((pe) => {
    const { a: ye, d: Ce } = e;
    if (pe.is0())
      throw new Error("bad point: ZERO");
    const { ex: be, ey: ae, ez: ge, et: Se } = pe, Le = se(be * be), ze = se(ae * ae), Re = se(ge * ge), We = se(Re * Re), Be = se(Le * ye), Ue = se(Re * se(Be + ze)), Ge = se(We + se(Ce * se(Le * ze)));
    if (Ue !== Ge)
      throw new Error("bad point: equation left != right (1)");
    const je = se(be * ae), Oe = se(ge * Se);
    if (je !== Oe)
      throw new Error("bad point: equation left != right (2)");
    return !0;
  });
  class we {
    constructor(ye, Ce, be, ae) {
      this.ex = ye, this.ey = Ce, this.ez = be, this.et = ae, me("x", ye), me("y", Ce), me("z", be), me("t", ae), Object.freeze(this);
    }
    get x() {
      return this.toAffine().x;
    }
    get y() {
      return this.toAffine().y;
    }
    static fromAffine(ye) {
      if (ye instanceof we)
        throw new Error("extended point not allowed");
      const { x: Ce, y: be } = ye || {};
      return me("x", Ce), me("y", be), new we(Ce, be, _1n$1, se(Ce * be));
    }
    static normalizeZ(ye) {
      const Ce = T.invertBatch(ye.map((be) => be.ez));
      return ye.map((be, ae) => be.toAffine(Ce[ae])).map(we.fromAffine);
    }
    // Multiscalar Multiplication
    static msm(ye, Ce) {
      return pippenger(we, de, ye, Ce);
    }
    // "Private method", don't use it directly
    _setWindowSize(ye) {
      Ie.setWindowSize(this, ye);
    }
    // Not required for fromHex(), which always creates valid points.
    // Could be useful for fromAffine().
    assertValidity() {
      Te(this);
    }
    // Compare one point to another.
    equals(ye) {
      xe(ye);
      const { ex: Ce, ey: be, ez: ae } = this, { ex: ge, ey: Se, ez: Le } = ye, ze = se(Ce * Le), Re = se(ge * ae), We = se(be * Le), Be = se(Se * ae);
      return ze === Re && We === Be;
    }
    is0() {
      return this.equals(we.ZERO);
    }
    negate() {
      return new we(se(-this.ex), this.ey, this.ez, se(-this.et));
    }
    // Fast algo for doubling Extended Point.
    // https://hyperelliptic.org/EFD/g1p/auto-twisted-extended.html#doubling-dbl-2008-hwcd
    // Cost: 4M + 4S + 1*a + 6add + 1*2.
    double() {
      const { a: ye } = e, { ex: Ce, ey: be, ez: ae } = this, ge = se(Ce * Ce), Se = se(be * be), Le = se(_2n$1 * se(ae * ae)), ze = se(ye * ge), Re = Ce + be, We = se(se(Re * Re) - ge - Se), Be = ze + Se, Ue = Be - Le, Ge = ze - Se, je = se(We * Ue), Oe = se(Be * Ge), Ne = se(We * Ge), Ye = se(Ue * Be);
      return new we(je, Oe, Ye, Ne);
    }
    // Fast algo for adding 2 Extended Points.
    // https://hyperelliptic.org/EFD/g1p/auto-twisted-extended.html#addition-add-2008-hwcd
    // Cost: 9M + 1*a + 1*d + 7add.
    add(ye) {
      xe(ye);
      const { a: Ce, d: be } = e, { ex: ae, ey: ge, ez: Se, et: Le } = this, { ex: ze, ey: Re, ez: We, et: Be } = ye;
      if (Ce === BigInt(-1)) {
        const yt = se((ge - ae) * (Re + ze)), dt = se((ge + ae) * (Re - ze)), mt = se(dt - yt);
        if (mt === _0n)
          return this.double();
        const It = se(Se * _2n$1 * Be), xt = se(Le * _2n$1 * We), Tt = xt + It, Yt = dt + yt, Ve = xt - It, Pe = se(Tt * mt), $e = se(Yt * Ve), Ze = se(Tt * Ve), at = se(mt * Yt);
        return new we(Pe, $e, at, Ze);
      }
      const Ue = se(ae * ze), Ge = se(ge * Re), je = se(Le * be * Be), Oe = se(Se * We), Ne = se((ae + ge) * (ze + Re) - Ue - Ge), Ye = Oe - je, Je = Oe + je, Xe = se(Ge - Ce * Ue), st = se(Ne * Ye), ct = se(Je * Xe), it = se(Ne * Xe), ot = se(Ye * Je);
      return new we(st, ct, ot, it);
    }
    subtract(ye) {
      return this.add(ye.negate());
    }
    wNAF(ye) {
      return Ie.wNAFCached(this, ye, we.normalizeZ);
    }
    // Constant-time multiplication.
    multiply(ye) {
      const Ce = ye;
      aInRange("scalar", Ce, _1n$1, $);
      const { p: be, f: ae } = this.wNAF(Ce);
      return we.normalizeZ([be, ae])[0];
    }
    // Non-constant-time multiplication. Uses double-and-add algorithm.
    // It's faster, but should only be used when you don't care about
    // an exposed private key e.g. sig verification.
    // Does NOT allow scalars higher than CURVE.n.
    // Accepts optional accumulator to merge with multiply (important for sparse scalars)
    multiplyUnsafe(ye, Ce = we.ZERO) {
      const be = ye;
      return aInRange("scalar", be, _0n, $), be === _0n ? Me : this.is0() || be === _1n$1 ? this : Ie.wNAFCachedUnsafe(this, be, we.normalizeZ, Ce);
    }
    // Checks if point is of small order.
    // If you add something to small order point, you will have "dirty"
    // point with torsion component.
    // Multiplies point by cofactor and checks if the result is 0.
    isSmallOrder() {
      return this.multiplyUnsafe(re).is0();
    }
    // Multiplies point by curve order and checks if the result is 0.
    // Returns `false` is the point is dirty.
    isTorsionFree() {
      return Ie.unsafeLadder(this, $).is0();
    }
    // Converts Extended point to default (x, y) coordinates.
    // Can accept precomputed Z^-1 - for example, from invertBatch.
    toAffine(ye) {
      return ve(this, ye);
    }
    clearCofactor() {
      const { h: ye } = e;
      return ye === _1n$1 ? this : this.multiplyUnsafe(ye);
    }
    // Converts hash string or Uint8Array to Point.
    // Uses algo from RFC8032 5.1.3.
    static fromHex(ye, Ce = !1) {
      const { d: be, a: ae } = e, ge = T.BYTES;
      ye = ensureBytes("pointHex", ye, ge), abool("zip215", Ce);
      const Se = ye.slice(), Le = ye[ge - 1];
      Se[ge - 1] = Le & -129;
      const ze = bytesToNumberLE(Se), Re = Ce ? ie : T.ORDER;
      aInRange("pointHex.y", ze, _0n, Re);
      const We = se(ze * ze), Be = se(We - _1n$1), Ue = se(be * We - ae);
      let { isValid: Ge, value: je } = ue(Be, Ue);
      if (!Ge)
        throw new Error("Point.fromHex: invalid y coordinate");
      const Oe = (je & _1n$1) === _1n$1, Ne = (Le & 128) !== 0;
      if (!Ce && je === _0n && Ne)
        throw new Error("Point.fromHex: x=0 and x_0=1");
      return Ne !== Oe && (je = se(-je)), we.fromAffine({ x: je, y: ze });
    }
    static fromPrivateKey(ye) {
      return De(ye).point;
    }
    toRawBytes() {
      const { x: ye, y: Ce } = this.toAffine(), be = numberToBytesLE(Ce, T.BYTES);
      return be[be.length - 1] |= ye & _1n$1 ? 128 : 0, be;
    }
    toHex() {
      return bytesToHex(this.toRawBytes());
    }
  }
  we.BASE = new we(e.Gx, e.Gy, _1n$1, se(e.Gx * e.Gy)), we.ZERO = new we(_0n, _1n$1, _1n$1, _0n);
  const { BASE: Ee, ZERO: Me } = we, Ie = wNAF(we, te * 8);
  function ke(pe) {
    return mod(pe, $);
  }
  function _e(pe) {
    return ke(bytesToNumberLE(pe));
  }
  function De(pe) {
    const ye = T.BYTES;
    pe = ensureBytes("private key", pe, ye);
    const Ce = ensureBytes("hashed private key", J(pe), 2 * ye), be = fe(Ce.slice(0, ye)), ae = Ce.slice(ye, 2 * ye), ge = _e(be), Se = Ee.multiply(ge), Le = Se.toRawBytes();
    return { head: be, prefix: ae, scalar: ge, point: Se, pointBytes: Le };
  }
  function Fe(pe) {
    return De(pe).pointBytes;
  }
  function Ae(pe = new Uint8Array(), ...ye) {
    const Ce = concatBytes(...ye);
    return _e(J(he(Ce, ensureBytes("context", pe), !!V)));
  }
  function ne(pe, ye, Ce = {}) {
    pe = ensureBytes("message", pe), V && (pe = V(pe));
    const { prefix: be, scalar: ae, pointBytes: ge } = De(ye), Se = Ae(Ce.context, be, pe), Le = Ee.multiply(Se).toRawBytes(), ze = Ae(Ce.context, Le, ge, pe), Re = ke(Se + ze * ae);
    aInRange("signature.s", Re, _0n, $);
    const We = concatBytes(Le, numberToBytesLE(Re, T.BYTES));
    return ensureBytes("result", We, T.BYTES * 2);
  }
  const oe = VERIFY_DEFAULT;
  function ce(pe, ye, Ce, be = oe) {
    const { context: ae, zip215: ge } = be, Se = T.BYTES;
    pe = ensureBytes("signature", pe, 2 * Se), ye = ensureBytes("message", ye), Ce = ensureBytes("publicKey", Ce, Se), ge !== void 0 && abool("zip215", ge), V && (ye = V(ye));
    const Le = bytesToNumberLE(pe.slice(Se, 2 * Se));
    let ze, Re, We;
    try {
      ze = we.fromHex(Ce, ge), Re = we.fromHex(pe.slice(0, Se), ge), We = Ee.multiplyUnsafe(Le);
    } catch {
      return !1;
    }
    if (!ge && ze.isSmallOrder())
      return !1;
    const Be = Ae(ae, Re.toRawBytes(), ze.toRawBytes(), ye);
    return Re.add(ze.multiplyUnsafe(Be)).subtract(We).clearCofactor().equals(we.ZERO);
  }
  return Ee._setWindowSize(8), {
    CURVE: e,
    getPublicKey: Fe,
    sign: ne,
    verify: ce,
    ExtendedPoint: we,
    utils: {
      getExtendedPublicKey: De,
      // ed25519 private keys are uniform 32b. No need to check for modulo bias, like in secp256k1.
      randomPrivateKey: () => ee(T.BYTES),
      /**
       * We're doing scalar multiplication (used in getPublicKey etc) with precomputed BASE_POINT
       * values. This slows down first getPublicKey() by milliseconds (see Speed section),
       * but allows to speed-up subsequent getPublicKey() calls up to 20x.
       * @param windowSize 2, 4, 8, 16
       */
      precompute(pe = 8, ye = we.BASE) {
        return ye._setWindowSize(pe), ye.multiply(BigInt(3)), ye;
      }
    }
  };
}
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */
const ED25519_P = BigInt("57896044618658097711785492504343953926634992332820282019728792003956564819949"), ED25519_SQRT_M1 = /* @__PURE__ */ BigInt("19681161376707505956807079304988542015446066515923890162744021073123829784752");
BigInt(0);
const _1n = BigInt(1), _2n = BigInt(2);
BigInt(3);
const _5n = BigInt(5), _8n = BigInt(8);
function ed25519_pow_2_252_3(C) {
  const e = BigInt(10), T = BigInt(20), $ = BigInt(40), V = BigInt(80), J = ED25519_P, te = C * C % J * C % J, re = pow2(te, _2n, J) * te % J, ie = pow2(re, _1n, J) * C % J, se = pow2(ie, _5n, J) * ie % J, de = pow2(se, e, J) * se % J, ue = pow2(de, T, J) * de % J, fe = pow2(ue, $, J) * ue % J, he = pow2(fe, V, J) * fe % J, me = pow2(he, V, J) * fe % J, xe = pow2(me, e, J) * se % J;
  return { pow_p_5_8: pow2(xe, _2n, J) * C % J, b2: te };
}
function adjustScalarBytes(C) {
  return C[0] &= 248, C[31] &= 127, C[31] |= 64, C;
}
function uvRatio(C, e) {
  const T = ED25519_P, $ = mod(e * e * e, T), V = mod($ * $ * e, T), J = ed25519_pow_2_252_3(C * V).pow_p_5_8;
  let ee = mod(C * $ * J, T);
  const te = mod(e * ee * ee, T), re = ee, ie = mod(ee * ED25519_SQRT_M1, T), se = te === C, de = te === mod(-C, T), ue = te === mod(-C * ED25519_SQRT_M1, T);
  return se && (ee = re), (de || ue) && (ee = ie), isNegativeLE(ee, T) && (ee = mod(-ee, T)), { isValid: se || de, value: ee };
}
const Fp = Field(ED25519_P, void 0, !0), ed25519Defaults = {
  // Param: a
  a: BigInt(-1),
  // Fp.create(-1) is proper; our way still works and is faster
  // d is equal to -121665/121666 over finite field.
  // Negative number is P - number, and division is invert(number, P)
  d: BigInt("37095705934669439343138083508754565189542113879843219016388785533085940283555"),
  // Finite field 𝔽p over which we'll do calculations; 2n**255n - 19n
  Fp,
  // Subgroup order: how many points curve has
  // 2n**252n + 27742317777372353535851937790883648493n;
  n: BigInt("7237005577332262213973186563042994240857116359379907606001950938285454250989"),
  // Cofactor
  h: _8n,
  // Base point (x, y) aka generator point
  Gx: BigInt("15112221349535400772501151409588531511454012693041857206046113283949847762202"),
  Gy: BigInt("46316835694926478169428394003475163141307993866256225615783033603165251855960"),
  hash: sha512$4,
  randomBytes,
  adjustScalarBytes,
  // dom2
  // Ratio of u to v. Allows us to combine inversion and square root. Uses algo from RFC8032 5.1.3.
  // Constant-time, u/√v
  uvRatio
}, ed25519 = twistedEdwards(ed25519Defaults), algorandAppIdLayout = [
  { name: "appIdPrefix", binary: "bytes", custom: bytes.encode("appID"), omit: !0 },
  { name: "appId", binary: "uint", size: 8 }
], Sr = class Sr {
  constructor(e, T = "hex") {
    tt(this, "address");
    this.address = typeof e == "string" ? Sr.stringToUint8Array(e, T) : e;
  }
  toNative(e) {
    return toNative(e, this);
  }
  unwrap() {
    return this.address;
  }
  toString() {
    return hex$1.encode(this.address, !0);
  }
  toUint8Array() {
    return this.address;
  }
  toUniversalAddress() {
    return this;
  }
  equals(e) {
    return bytes.equals(this.address, e.address);
  }
  static isValidAddress(e, T = "hex") {
    return !throws(() => Sr.stringToUint8Array(e, T));
  }
  static instanceof(e) {
    return typeof e == "object" && "constructor" in e && e.constructor.type === Sr.type;
  }
  static stringToUint8Array(e, T) {
    const $ = (() => {
      switch (T) {
        case "hex":
          if (![40, 2 * this.byteSize].includes(e.length - (e.startsWith("0x") ? 2 : 0)))
            throw new Error(`string ${e} has invalid length for format ${T}`);
          return hex$1.decode(e);
        case "base58":
          return b58.decode(e);
        case "bech32":
          return bech32.decodeToBytes(e).bytes;
        case "algorandAppId":
          return sha512_256(serialize$2(algorandAppIdLayout, { appId: BigInt(e) }));
        case "sha256":
          return sha256$5(e);
      }
    })();
    if ($.length > Sr.byteSize)
      throw new Error(`string ${e} has invalid length for format ${T}`);
    return $.length < Sr.byteSize ? bytes.zpad($, Sr.byteSize) : $;
  }
};
tt(Sr, "byteSize", 32), tt(Sr, "type", "Universal");
let UniversalAddress = Sr;
function isChainSpecificAddress(C) {
  return typeof C == "object" && "setChain" in C;
}
const nativeFactory = /* @__PURE__ */ new Map();
function registerNative(C, e) {
  nativeFactory.has(C) || nativeFactory.set(C, e);
}
function toNative(C, e) {
  const T = chainToPlatform.get(C), $ = nativeFactory.get(T);
  if (!$)
    throw new Error(`No native address type registered for platform ${T}, import the platform directly or, if using sdk package, import the addresses conditional export`);
  try {
    const V = new $(e);
    return isChainSpecificAddress(V) && V.setChain(C), V;
  } catch (V) {
    const J = `Error parsing address as a native ${C} address: ${V.message}`;
    if (UniversalAddress.instanceof(e))
      throw J;
    return console.error(J), console.error("Attempting to parse as UniversalAddress"), new UniversalAddress(e).toNative(C);
  }
}
function toUniversal(C, e) {
  const T = chainToPlatform.get(C);
  return new UniversalAddress(e, platformToAddressFormat.get(T));
}
function isVersionedProtocolInitializer(C) {
  return "getVersion" in C;
}
const protocolFactory = {};
function registerProtocol(C, e, T) {
  e in protocolFactory || (protocolFactory[e] = {});
  const $ = protocolFactory[e];
  if (C in $)
    throw new Error(`Protocol ${C} for protocol ${e} has already registered`);
  protocolFactory[e][C] = T;
}
function protocolIsRegistered(C, e) {
  const T = isChain(C) ? chainToPlatform.get(C) : C;
  return e in protocolFactory ? T in protocolFactory[e] : !1;
}
function getProtocolInitializer(C, e) {
  if (e in protocolFactory) {
    const T = protocolFactory[e];
    if (T && C in T) {
      const $ = T[C];
      if ($)
        return $;
    }
  }
  throw new Error(`No protocols registered for ${C}:${e}. This may be because the platform specific protocol implementation is not registered (by installing and importing it) or no implementation exists for this platform`);
}
const create$4 = (C, e, T, $) => getProtocolInitializer(C, e).fromRpc(T, $), composeLiteral = (C, e) => C ? `${C}:${e}` : e, payloadFactory = /* @__PURE__ */ new Map();
function registerPayloadType(C, e, T) {
  const $ = composeLiteral(C, e);
  if (payloadFactory.has($))
    throw new Error(`Payload type ${$} already registered`);
  payloadFactory.set($, T);
}
function registerPayloadTypes(C, e) {
  for (const [T, $] of e)
    registerPayloadType(C, T, $);
}
const amountItem = {
  binary: "uint",
  size: 32
}, chainItemBase = { binary: "uint", size: 2 }, chainItem = (C) => ({
  ...chainItemBase,
  custom: {
    to: (e) => {
      if (e === 0) {
        if (!(C != null && C.allowNull))
          throw new Error("ChainId 0 is not valid for this protocol and action");
        return null;
      }
      const T = toChain(e), $ = (C == null ? void 0 : C.allowedChains) ?? chains$4;
      if (!$.includes(T))
        throw new Error(`Chain ${T} not in allowed chains ${$}`);
      return T;
    },
    from: (e) => e == null ? 0 : chainToChainId(e)
  }
}), circleDomainItem = {
  binary: "uint",
  size: 4
}, circleNonceItem = {
  binary: "uint",
  size: 8
}, guardianSetItem = {
  binary: "uint",
  size: 4
}, payloadIdItem = (C) => ({
  name: "payloadId",
  binary: "uint",
  size: 1,
  custom: C,
  omit: !0
}), sequenceItem = {
  binary: "uint",
  size: 8
};
class Signature {
  constructor(e, T, $) {
    tt(this, "r");
    tt(this, "s");
    tt(this, "v");
    this.r = e, this.s = T, this.v = $;
  }
  encode() {
    return serialize$2(signatureItem, this);
  }
  static decode(e) {
    return deserialize$2(signatureItem, e);
  }
}
var SignatureUtils;
(function(C) {
  function e(J) {
    return secp256k1$1.getPublicKey(J);
  }
  C.toPubkey = e;
  function T(J, ee) {
    if (ee.length != 32)
      throw new Error("hash.length != 32");
    return secp256k1$1.sign(ee, J);
  }
  C.sign = T;
  function $(J, ee, te) {
    const { r: re, s: ie } = J;
    return secp256k1$1.verify({ r: re, s: ie }, te, ee);
  }
  C.validate = $;
  function V(J, ee) {
    const { r: te, s: re, v: ie } = J, se = new secp256k1$1.Signature(te, re);
    return se.recovery = ie, se.recoverPublicKey(ee).toRawBytes();
  }
  C.recover = V;
})(SignatureUtils || (SignatureUtils = {}));
const signatureLayout = [
  { name: "r", binary: "uint", size: 32 },
  { name: "s", binary: "uint", size: 32 },
  { name: "v", binary: "uint", size: 1 }
], signatureItem = {
  binary: "bytes",
  layout: signatureLayout,
  custom: {
    to: (C) => new Signature(C.r, C.s, C.v),
    from: (C) => ({ r: C.r, s: C.s, v: C.v })
  }
}, universalAddressItem = {
  binary: "bytes",
  size: 32,
  custom: {
    to: (C) => new UniversalAddress(C),
    from: (C) => C.toUint8Array()
  }
}, trimZeros = (C) => {
  const e = C.findIndex((T) => T !== 0);
  return -1 < e ? C.slice(e) : new Uint8Array([]);
}, stringConversion = {
  to: bytes.decode,
  from: bytes.encode
}, fixedLengthStringItem$1 = (C) => ({
  binary: "bytes",
  size: C,
  custom: {
    to: (e) => bytes.decode(trimZeros(e)),
    from: (e) => bytes.zpad(bytes.encode(e), C)
  }
});
function decomposeLiteral(C) {
  const e = C.indexOf(":");
  return e !== -1 ? [C.slice(0, e), C.slice(e + 1)] : [null, C];
}
const guardianSignatureLayout = [
  { name: "guardianIndex", binary: "uint", size: 1 },
  { name: "signature", ...signatureItem }
], headerLayout = [
  { name: "version", binary: "uint", size: 1, custom: 1, omit: !0 },
  { name: "guardianSet", ...guardianSetItem },
  { name: "signatures", binary: "array", lengthSize: 1, layout: guardianSignatureLayout }
], envelopeLayout = [
  { name: "timestamp", binary: "uint", size: 4 },
  { name: "nonce", binary: "uint", size: 4 },
  { name: "emitterChain", ...chainItem() },
  { name: "emitterAddress", ...universalAddressItem },
  { name: "sequence", ...sequenceItem },
  { name: "consistencyLevel", binary: "uint", size: 1 }
], baseLayout = [...headerLayout, ...envelopeLayout];
function getPayloadLayout(C) {
  const e = payloadFactory.get(C);
  if (!e)
    throw new Error(`No layout registered for payload type ${C}`);
  return e;
}
function payloadLiteralToPayloadItemLayout(C) {
  return {
    name: "payload",
    binary: "bytes",
    ...C === "Uint8Array" ? {} : { layout: getPayloadLayout(C) }
  };
}
function serialize$1(C) {
  const e = [
    ...baseLayout,
    payloadLiteralToPayloadItemLayout(C.payloadLiteral)
  ];
  return serialize$2(e, C);
}
function serializePayload(C, e) {
  if (C === "Uint8Array")
    return e;
  const T = getPayloadLayout(C);
  return serialize$2(T, e);
}
function payloadDiscriminator(C, e) {
  const T = (() => {
    if (Array.isArray(C[0]))
      return C.flatMap(([ee, te]) => te.map((re) => composeLiteral(ee, re)));
    if (typeof C[1] == "string")
      return C;
    const [V, J] = C;
    return J.map((ee) => composeLiteral(V, ee));
  })(), $ = buildDiscriminator(T.map((V) => getPayloadLayout(V)), !!e);
  return (V) => {
    typeof V == "string" && (V = hex$1.decode(V));
    const J = $(V);
    return Array.isArray(J) ? J.map((ee) => T[ee]) : J !== null ? T[J] : null;
  };
}
function deserialize$1(C, e) {
  typeof e == "string" && (e = hex$1.decode(e));
  const [T, $] = deserialize$2(headerLayout, e, !1);
  for (let fe = 1; fe < T.signatures.length; ++fe)
    if (T.signatures[fe].guardianIndex <= T.signatures[fe - 1].guardianIndex)
      throw new Error("Guardian signatures must be in ascending order of guardian set index");
  const V = $, [J, ee] = deserialize$2(envelopeLayout, e.subarray(V), !1), te = V + ee, [re, ie] = typeof C == "string" ? [
    C,
    deserializePayload(C, e.subarray(te))
  ] : deserializePayload(C, e.subarray(te)), [se, de] = decomposeLiteral(re), ue = keccak_256(e.slice(V));
  return {
    protocolName: se,
    payloadName: de,
    payloadLiteral: re,
    ...T,
    ...J,
    payload: ie,
    hash: ue
  };
}
function deserializePayload(C, e, T = 0) {
  return (() => {
    if (typeof e == "string" && (e = hex$1.decode(e)), C === "Uint8Array")
      return e.slice(T);
    if (typeof C == "string")
      return deserialize$2(getPayloadLayout(C), e.subarray(T));
    const $ = C(e.slice(T));
    if ($ === null)
      throw new Error(`Encoded data does not match any of the given payload types - ${e}`);
    return [
      $,
      deserialize$2(getPayloadLayout($), e.subarray(T))
    ];
  })();
}
function bodyLayout(C) {
  return [...envelopeLayout, payloadLiteralToPayloadItemLayout(C)];
}
function createVAA(C, e) {
  const [T, $] = decomposeLiteral(C), V = addFixedValues(bodyLayout(C), e);
  return {
    protocolName: T,
    payloadName: $,
    payloadLiteral: C,
    ...addFixedValues(headerLayout, e),
    ...V,
    hash: keccak_256(serialize$2(bodyLayout(C), V))
  };
}
class PlatformContext {
  constructor(e, T) {
    tt(this, "network");
    tt(this, "config");
    this.network = e, this.config = T;
  }
  /** provides access to the static attributes of the PlatformContext class */
  utils() {
    return this.constructor;
  }
  /** Create a new Protocol Client instance by protocol name using the RPC connection to determine the network */
  getProtocol(e, T) {
    return create$4(this.utils()._platform, e, T, this.config);
  }
  /** Get the underlying ProtocolInitializer to construct yourself */
  getProtocolInitializer(e) {
    return getProtocolInitializer(this.utils()._platform, e);
  }
  /** Look up transaction logs and parse out Wormhole messages */
  async parseWormholeMessages(e, T, $) {
    return (await this.getProtocol("WormholeCore", T)).parseTransaction($);
  }
}
const mainnetTokenEntries = [
  [
    "Ethereum",
    [
      [
        "ETH",
        {
          symbol: "ETH",
          decimals: 18,
          address: "native",
          wrappedKey: "WETH"
        }
      ],
      [
        "WETH",
        {
          symbol: "WETH",
          decimals: 18,
          address: "0xc02aaa39b223fe8d0a0e5c4f27ead9083c756cc2"
        }
      ],
      [
        "USDCeth",
        {
          symbol: "USDC",
          decimals: 6,
          address: "0xa0b86991c6218b36c1d19d4a2e9eb0ce3606eb48"
        }
      ],
      [
        "WBTC",
        {
          symbol: "WBTC",
          decimals: 8,
          address: "0x2260fac5e5542a773aa44fbcfedf7c193bc2c599"
        }
      ],
      [
        "USDT",
        {
          symbol: "USDT",
          decimals: 6,
          address: "0xdac17f958d2ee523a2206206994597c13d831ec7"
        }
      ],
      [
        "DAI",
        {
          symbol: "DAI",
          decimals: 18,
          address: "0x6b175474e89094c44da98b954eedeac495271d0f"
        }
      ],
      [
        "BUSD",
        {
          symbol: "BUSD",
          decimals: 18,
          address: "0x4fabb145d64652a948d72533023f6e7a623c7c53"
        }
      ],
      [
        "WMATIC",
        {
          symbol: "WMATIC",
          decimals: 18,
          address: "0x7c9f4C87d911613Fe9ca58b579f737911AAD2D43",
          original: "Polygon"
        }
      ],
      [
        "WBNB",
        {
          symbol: "WBNB",
          decimals: 18,
          address: "0x418D75f65a02b3D53B2418FB8E1fe493759c7605",
          original: "Bsc"
        }
      ],
      [
        "USDCbnb",
        {
          symbol: "USDC",
          decimals: 18,
          address: "0x7cd167B101D2808Cfd2C45d17b2E7EA9F46b74B6",
          original: "Bsc"
        }
      ],
      [
        "WAVAX",
        {
          symbol: "WAVAX",
          decimals: 18,
          address: "0x85f138bfEE4ef8e540890CFb48F620571d67Eda3",
          original: "Avalanche"
        }
      ],
      [
        "USDCavax",
        {
          symbol: "USDC",
          decimals: 6,
          address: "0x39EbF69137D98FB7659Ef8D4ea21ec26394389d7",
          original: "Avalanche"
        }
      ],
      [
        "WFTM",
        {
          symbol: "WFTM",
          decimals: 18,
          address: "0x4cD2690d86284e044cb63E60F1EB218a825a7e92",
          original: "Fantom"
        }
      ],
      [
        "CELO",
        {
          symbol: "CELO",
          decimals: 18,
          address: "0x3294395e62F4eB6aF3f1Fcf89f5602D90Fb3Ef69",
          original: "Celo"
        }
      ],
      [
        "WGLMR",
        {
          symbol: "WGLMR",
          decimals: 18,
          address: "0x93d3696A9F879b331f40CB5059e37015423A3Bd0",
          original: "Moonbeam"
        }
      ],
      [
        "WSOL",
        {
          symbol: "WSOL",
          decimals: 9,
          address: "0xD31a59c85aE9D8edEFeC411D448f90841571b89c",
          original: "Solana"
        }
      ],
      [
        "USDCsol",
        {
          symbol: "USDC",
          decimals: 6,
          address: "0x41f7B8b9b897276b7AAE926a9016935280b44E97",
          original: "Solana"
        }
      ],
      [
        "SUI",
        {
          symbol: "SUI",
          decimals: 9,
          address: "0x84074EA631dEc7a4edcD5303d164D5dEa4c653D6",
          original: "Sui"
        }
      ],
      [
        "APT",
        {
          symbol: "APT",
          decimals: 8,
          address: "0x8CDf7AF57E4c8B930e1B23c477c22f076530585e",
          original: "Aptos"
        }
      ],
      [
        "WETHarbitrum",
        {
          symbol: "WETH",
          decimals: 18,
          address: "0xb945E3F853B5f8033C8513Cf3cE9F8AD9beBB1c9",
          original: "Arbitrum"
        }
      ],
      [
        "USDCarbitrum",
        {
          symbol: "USDC",
          decimals: 6,
          address: "0xCFc006a32a98031C2338BF9d5ff8ED2c0Cae4a9e",
          original: "Arbitrum"
        }
      ],
      [
        "WETHoptimism",
        {
          symbol: "WETH",
          decimals: 18,
          address: "0x8B5653Ae095529155462eDa8CF664eD96773F557",
          original: "Optimism"
        }
      ],
      [
        "WETHbase",
        {
          symbol: "WETH",
          decimals: 18,
          address: "0x1D4241F7370253C0f12EFC536B7e16E462Fb3526",
          original: "Base"
        }
      ],
      [
        "tBTC",
        {
          symbol: "tBTC",
          decimals: 18,
          address: "0x18084fbA666a33d37592fA2633fD49a74DD93a88"
        }
      ],
      [
        "tBTCpolygon",
        {
          symbol: "tBTC",
          decimals: 18,
          address: "0xb4c624dBC50804dA086cf2380cD55dEBC0d22E96",
          original: "Polygon"
        }
      ],
      [
        "tBTCoptimism",
        {
          symbol: "tBTC",
          decimals: 18,
          address: "0xB8d1E0642bFD3744CaBd2ca8830cFabE19b2Ca54",
          original: "Optimism"
        }
      ],
      [
        "tBTCarbitrum",
        {
          symbol: "tBTC",
          decimals: 18,
          address: "0x4F3819A6cfF717BFfE801a75c73A984141c76589",
          original: "Arbitrum"
        }
      ],
      [
        "tBTCbase",
        {
          symbol: "tBTC",
          decimals: 18,
          address: "0x733F28B3e315046Db01dAbC292D6F0F7F26C4551",
          original: "Base"
        }
      ],
      [
        "wstETH",
        {
          symbol: "wstETH",
          decimals: 18,
          address: "0x7f39C581F595B53c5cb19bD0b3f8dA6c935E2Ca0"
        }
      ],
      [
        "WKLAY",
        {
          symbol: "WKLAY",
          decimals: 18,
          address: "0x9AEA32B459e96C8eF5010f69130bf95fd129ac05",
          original: "Klaytn"
        }
      ],
      [
        "PYTH",
        {
          symbol: "PYTH",
          decimals: 6,
          address: "0xeFc0CED4B3D536103e76a1c4c74F0385C8F4Bdd3",
          original: "Solana"
        }
      ]
    ]
  ],
  [
    "Bsc",
    [
      [
        "WETH",
        {
          symbol: "WETH",
          decimals: 18,
          address: "0x4DB5a66E937A9F4473fA95b1cAF1d1E1D62E29EA",
          original: "Ethereum"
        }
      ],
      [
        "USDCeth",
        {
          symbol: "USDC",
          decimals: 6,
          address: "0xB04906e95AB5D797aDA81508115611fee694c2b3",
          original: "Ethereum"
        }
      ],
      [
        "WBTC",
        {
          symbol: "WBTC",
          decimals: 8,
          address: "0x43359676E1A3F9FbB5de095333f8e9c1B46dFA44",
          original: "Ethereum"
        }
      ],
      [
        "USDT",
        {
          symbol: "USDT",
          decimals: 6,
          address: "0x524bC91Dc82d6b90EF29F76A3ECAaBAffFD490Bc",
          original: "Ethereum"
        }
      ],
      [
        "DAI",
        {
          symbol: "DAI",
          decimals: 18,
          address: "0x3413a030EF81a3dD5a302F4B4D11d911e12ed337",
          original: "Ethereum"
        }
      ],
      [
        "BUSD",
        {
          symbol: "BUSD",
          decimals: 18,
          address: "0x035de3679E692C471072d1A09bEb9298fBB2BD31",
          original: "Ethereum"
        }
      ],
      [
        "WMATIC",
        {
          symbol: "WMATIC",
          decimals: 18,
          address: "0xc836d8dC361E44DbE64c4862D55BA041F88Ddd39",
          original: "Polygon"
        }
      ],
      [
        "USDCpolygon",
        {
          symbol: "USDC",
          decimals: 6,
          address: "0xe6d82Bbe75041E42E51d755e922cE1BA91af9c4d",
          original: "Polygon"
        }
      ],
      [
        "BNB",
        {
          symbol: "BNB",
          decimals: 18,
          address: "native",
          wrappedKey: "WBNB"
        }
      ],
      [
        "WBNB",
        {
          symbol: "WBNB",
          decimals: 18,
          address: "0xbb4cdb9cbd36b01bd1cbaebf2de08d9173bc095c"
        }
      ],
      [
        "USDCbnb",
        {
          symbol: "USDC",
          decimals: 18,
          address: "0x8AC76a51cc950d9822D68b83fE1Ad97B32Cd580d"
        }
      ],
      [
        "WAVAX",
        {
          symbol: "WAVAX",
          decimals: 18,
          address: "0x96412902aa9aFf61E13f085e70D3152C6ef2a817",
          original: "Avalanche"
        }
      ],
      [
        "USDCavax",
        {
          symbol: "USDC",
          decimals: 6,
          address: "0xc88Dc63bf0c8c8198C97Db0945E3eF25Ca89A8e4",
          original: "Avalanche"
        }
      ],
      [
        "WFTM",
        {
          symbol: "WFTM",
          decimals: 18,
          address: "0xbF8413EE8612E0E4f66Aa63B5ebE27f3C5883d47",
          original: "Fantom"
        }
      ],
      [
        "CELO",
        {
          symbol: "CELO",
          decimals: 18,
          address: "0x2A335e327a55b177f5B40132fEC5D7298aa0D7e6",
          original: "Celo"
        }
      ],
      [
        "WGLMR",
        {
          symbol: "WGLMR",
          decimals: 18,
          address: "0x1C063db3c621BF901FC6C1D03328b08b2F9bbfba",
          original: "Moonbeam"
        }
      ],
      [
        "WSOL",
        {
          symbol: "WSOL",
          decimals: 9,
          address: "0xfA54fF1a158B5189Ebba6ae130CEd6bbd3aEA76e",
          original: "Solana"
        }
      ],
      [
        "USDCsol",
        {
          symbol: "USDC",
          decimals: 6,
          address: "0x91Ca579B0D47E5cfD5D0862c21D5659d39C8eCf0",
          original: "Solana"
        }
      ],
      [
        "SUI",
        {
          symbol: "SUI",
          decimals: 9,
          address: "0x8314f6Bf1B4dd8604A0fC33C84F9AF2fc07AABC8",
          original: "Sui"
        }
      ],
      [
        "APT",
        {
          symbol: "APT",
          decimals: 8,
          address: "0x2Ba98cf7Edd2c5C794e21bc3Dc6973D3C2585eE3",
          original: "Aptos"
        }
      ],
      [
        "WETHarbitrum",
        {
          symbol: "WETH",
          decimals: 18,
          address: "0xaA1eEdABC48D078350ccBdD620bD088848e299E5",
          original: "Arbitrum"
        }
      ],
      [
        "USDCarbitrum",
        {
          symbol: "USDC",
          decimals: 6,
          address: "0x5caa170b465122D15a6D20FD9A804a9613CE7882",
          original: "Arbitrum"
        }
      ],
      [
        "WETHoptimism",
        {
          symbol: "WETH",
          decimals: 18,
          address: "0x94AEc09B5e2CE591e39DC6aa58A3A6E85Ed45265",
          original: "Optimism"
        }
      ],
      [
        "USDCoptimism",
        {
          symbol: "USDC",
          decimals: 6,
          address: "0xa41ae127D04F7ee73B5058E2C60Fb7c7A2D21F79",
          original: "Optimism"
        }
      ],
      [
        "WETHbsc",
        {
          symbol: "WETH",
          decimals: 18,
          address: "0x2170Ed0880ac9A755fd29B2688956BD959F933F8"
        }
      ],
      [
        "WETHbase",
        {
          symbol: "WETH",
          decimals: 18,
          address: "0x9dc152F4941cE1A138326e70c3600385bf0C22dD",
          original: "Base"
        }
      ],
      [
        "USDCbase",
        {
          symbol: "USDC",
          decimals: 6,
          address: "0x55CaD531c8E303Cab8B3BE4bB4744Db4f896ac81",
          original: "Base"
        }
      ],
      [
        "tBTC",
        {
          symbol: "tBTC",
          decimals: 18,
          address: "0x94c97dd3Bde5bC1406BCe82E7941A6365968521D",
          original: "Ethereum"
        }
      ],
      [
        "wstETH",
        {
          symbol: "wstETH",
          decimals: 18,
          address: "0xad80E1A9B5824234afA9dE1F3bbDb8a994796169",
          original: "Ethereum"
        }
      ],
      [
        "WKLAY",
        {
          symbol: "WKLAY",
          decimals: 18,
          address: "0xEA970e7b7D131Ea36c3051C9Ca11e785462fE00c",
          original: "Klaytn"
        }
      ],
      [
        "PYTH",
        {
          symbol: "PYTH",
          decimals: 6,
          address: "0xb0188B0bb2cD4a6D2744637fC83C94a284B247Da",
          original: "Solana"
        }
      ],
      [
        "USDTbsc",
        {
          symbol: "USDT",
          decimals: 18,
          address: "0x55d398326f99059fF775485246999027B3197955"
        }
      ]
    ]
  ],
  [
    "Polygon",
    [
      [
        "WETH",
        {
          symbol: "WETH",
          decimals: 18,
          address: "0x11CD37bb86F65419713f30673A480EA33c826872",
          original: "Ethereum"
        }
      ],
      [
        "USDCeth",
        {
          symbol: "USDC",
          decimals: 6,
          address: "0x4318CB63A2b8edf2De971E2F17F77097e499459D",
          original: "Ethereum"
        }
      ],
      [
        "WBTC",
        {
          symbol: "WBTC",
          decimals: 8,
          address: "0x5D49c278340655B56609FdF8976eb0612aF3a0C3",
          original: "Ethereum"
        }
      ],
      [
        "USDT",
        {
          symbol: "USDT",
          decimals: 6,
          address: "0x9417669fBF23357D2774e9D421307bd5eA1006d2",
          original: "Ethereum"
        }
      ],
      [
        "DAI",
        {
          symbol: "DAI",
          decimals: 18,
          address: "0x732EB1747ecCFC431fF19bc359ffc83755B1918c",
          original: "Ethereum"
        }
      ],
      [
        "BUSD",
        {
          symbol: "BUSD",
          decimals: 18,
          address: "0x95ea750420da26bE1Ab0891e209e921bCd84763f",
          original: "Ethereum"
        }
      ],
      [
        "MATIC",
        {
          symbol: "MATIC",
          decimals: 18,
          address: "native",
          wrappedKey: "WMATIC"
        }
      ],
      [
        "WMATIC",
        {
          symbol: "WMATIC",
          decimals: 18,
          address: "0x0d500b1d8e8ef31e21c99d1db9a6444d3adf1270"
        }
      ],
      [
        "WETHpolygon",
        {
          symbol: "WETH",
          decimals: 18,
          address: "0x7ceB23fD6bC0adD59E62ac25578270cFf1b9f619"
        }
      ],
      [
        "USDCpolygon",
        {
          symbol: "USDC",
          decimals: 6,
          address: "0x3c499c542cef5e3811e1192ce70d8cc03d5c3359"
        }
      ],
      [
        "WBNB",
        {
          symbol: "WBNB",
          decimals: 18,
          address: "0xeCDCB5B88F8e3C15f95c720C51c71c9E2080525d",
          original: "Bsc"
        }
      ],
      [
        "USDCbnb",
        {
          symbol: "USDC",
          decimals: 18,
          address: "0x4B3a922c773BDCF3BA8f1A4FDAc2029E1D0E9868",
          original: "Bsc"
        }
      ],
      [
        "WAVAX",
        {
          symbol: "WAVAX",
          decimals: 18,
          address: "0x7Bb11E7f8b10E9e571E5d8Eace04735fDFB2358a",
          original: "Avalanche"
        }
      ],
      [
        "USDCavax",
        {
          symbol: "USDC",
          decimals: 6,
          address: "0xAEA5CC14DefbC1b845FDE729E563B717Ee6825ae",
          original: "Avalanche"
        }
      ],
      [
        "WFTM",
        {
          symbol: "WFTM",
          decimals: 18,
          address: "0x3726831304D77f585f1Aca9d9841cc3Ef80dAa62",
          original: "Fantom"
        }
      ],
      [
        "CELO",
        {
          symbol: "CELO",
          decimals: 18,
          address: "0x922F49a9911effc034eE756196E59BE7b90D43b3",
          original: "Celo"
        }
      ],
      [
        "WGLMR",
        {
          symbol: "WGLMR",
          decimals: 18,
          address: "0xcC48d6CF842083fEc0E01d913fB964b585975F05",
          original: "Moonbeam"
        }
      ],
      [
        "WSOL",
        {
          symbol: "WSOL",
          decimals: 9,
          address: "0xd93f7E271cB87c23AaA73edC008A79646d1F9912",
          original: "Solana"
        }
      ],
      [
        "USDCsol",
        {
          symbol: "USDC",
          decimals: 6,
          address: "0x576Cf361711cd940CD9C397BB98C4C896cBd38De",
          original: "Solana"
        }
      ],
      [
        "SUI",
        {
          symbol: "SUI",
          decimals: 9,
          address: "0x34bE049fEbfc6C64Ffd82Da08a8931A9a45f2cc8",
          original: "Sui"
        }
      ],
      [
        "APT",
        {
          symbol: "APT",
          decimals: 8,
          address: "0xa4ef199d3ad524E9C3C51Ac46B303B103A307Cef",
          original: "Aptos"
        }
      ],
      [
        "WETHarbitrum",
        {
          symbol: "WETH",
          decimals: 18,
          address: "0x6a5c59AB16268d2c872916054C50440B999e417C",
          original: "Arbitrum"
        }
      ],
      [
        "USDCarbitrum",
        {
          symbol: "USDC",
          decimals: 6,
          address: "0x7800FE8951cdc1cDea748d878fAce63018D97960",
          original: "Arbitrum"
        }
      ],
      [
        "WETHoptimism",
        {
          symbol: "WETH",
          decimals: 18,
          address: "0x8182De59485Bb646542Db8C7E5958148Dc699319",
          original: "Optimism"
        }
      ],
      [
        "USDCoptimism",
        {
          symbol: "USDC",
          decimals: 6,
          address: "0x31F12aCb60C3c32EE884F3894a873347C097D925",
          original: "Optimism"
        }
      ],
      [
        "WETHbase",
        {
          symbol: "WETH",
          decimals: 18,
          address: "0x5BCf8d8c097FbB35C371F921E3FF3e6F6Eb54B41",
          original: "Base"
        }
      ],
      [
        "USDCbase",
        {
          symbol: "USDC",
          decimals: 6,
          address: "0x1eeCaB0F75fE93abbFa0cDFfb4fB13d1dC8706c8",
          original: "Base"
        }
      ],
      [
        "tBTC",
        {
          symbol: "tBTC",
          decimals: 18,
          address: "0x3362b2B92b331925F09F9E5bCA3E8C43921a435C",
          original: "Ethereum"
        }
      ],
      [
        "tBTCpolygon",
        {
          symbol: "tBTC",
          decimals: 18,
          address: "0x236aa50979D5f3De3Bd1Eeb40E81137F22ab794b"
        }
      ],
      [
        "tBTCoptimism",
        {
          symbol: "tBTC",
          decimals: 18,
          address: "0x68A8797da1c8ED592600d70A5151886A92D2183C",
          original: "Optimism"
        }
      ],
      [
        "tBTCarbitrum",
        {
          symbol: "tBTC",
          decimals: 18,
          address: "0x045D8c62D5326aa51a31518ECF3aF80C17421Aba",
          original: "Arbitrum"
        }
      ],
      [
        "wstETH",
        {
          symbol: "wstETH",
          decimals: 18,
          address: "0xe082a7Fc696De18172Ad08D956569Ee80BC37f06",
          original: "Ethereum"
        }
      ],
      [
        "wstETHpolygon",
        {
          symbol: "wstETH",
          decimals: 18,
          address: "0x03b54A6e9a984069379fae1a4fC4dBAE93B3bCCD"
        }
      ],
      [
        "WKLAY",
        {
          symbol: "WKLAY",
          decimals: 18,
          address: "0x415ce980fde17F1FF102e1c6e4ce860Acc615D74",
          original: "Klaytn"
        }
      ],
      [
        "PYTH",
        {
          symbol: "PYTH",
          decimals: 6,
          address: "0xFa4B761A1e07909Ba31331a5dfa12390E3ff5583",
          original: "Solana"
        }
      ],
      [
        "USDTpolygon",
        {
          symbol: "USDT",
          decimals: 6,
          address: "0xc2132D05D31c914a87C6611C10748AEb04B58e8F"
        }
      ]
    ]
  ],
  [
    "Avalanche",
    [
      [
        "WETH",
        {
          symbol: "WETH",
          decimals: 18,
          address: "0x8b82A291F83ca07Af22120ABa21632088fC92931",
          original: "Ethereum"
        }
      ],
      [
        "USDCeth",
        {
          symbol: "USDC",
          decimals: 6,
          address: "0xB24CA28D4e2742907115fECda335b40dbda07a4C",
          original: "Ethereum"
        }
      ],
      [
        "WBTC",
        {
          symbol: "WBTC",
          decimals: 8,
          address: "0x1C0e79C5292c59bbC13C9F9f209D204cf4d65aD6",
          original: "Ethereum"
        }
      ],
      [
        "USDT",
        {
          symbol: "USDT",
          decimals: 6,
          address: "0x9d228444FC4B7E15A2C481b48E10247A03351FD8",
          original: "Ethereum"
        }
      ],
      [
        "DAI",
        {
          symbol: "DAI",
          decimals: 18,
          address: "0xca319f81D147559e19A522A0a0310Dd43A96cA0F",
          original: "Ethereum"
        }
      ],
      [
        "WMATIC",
        {
          symbol: "WMATIC",
          decimals: 18,
          address: "0xf2f13f0B7008ab2FA4A2418F4ccC3684E49D20Eb",
          original: "Polygon"
        }
      ],
      [
        "USDCpolygon",
        {
          symbol: "USDC",
          decimals: 6,
          address: "0xDb2d08f5A9C9ADBBA0DE5a69bbB1E9Ca03411692",
          original: "Polygon"
        }
      ],
      [
        "WBNB",
        {
          symbol: "WBNB",
          decimals: 18,
          address: "0x442F7f22b1EE2c842bEAFf52880d4573E9201158",
          original: "Bsc"
        }
      ],
      [
        "USDCbnb",
        {
          symbol: "USDC",
          decimals: 18,
          address: "0x6145E8a910aE937913426BF32De2b26039728ACF",
          original: "Bsc"
        }
      ],
      [
        "AVAX",
        {
          symbol: "AVAX",
          decimals: 18,
          address: "native",
          wrappedKey: "WAVAX"
        }
      ],
      [
        "WAVAX",
        {
          symbol: "WAVAX",
          decimals: 18,
          address: "0xb31f66aa3c1e785363f0875a1b74e27b85fd66c7"
        }
      ],
      [
        "USDCavax",
        {
          symbol: "USDC",
          decimals: 6,
          address: "0xB97EF9Ef8734C71904D8002F8b6Bc66Dd9c48a6E"
        }
      ],
      [
        "WETHavax",
        {
          symbol: "WETH",
          decimals: 18,
          address: "0x49d5c2bdffac6ce2bfdb6640f4f80f226bc10bab"
        }
      ],
      [
        "WFTM",
        {
          symbol: "WFTM",
          decimals: 18,
          address: "0xd19abc09B7b36F7558929b97a866f499a26c2f83",
          original: "Fantom"
        }
      ],
      [
        "CELO",
        {
          symbol: "CELO",
          decimals: 18,
          address: "0x494317B8521c5a5287a06DEE467dd6fe285dA4a8",
          original: "Celo"
        }
      ],
      [
        "WGLMR",
        {
          symbol: "WGLMR",
          decimals: 18,
          address: "0x375aA6C67BF499fBf01804A9f92C03c0776F372d",
          original: "Moonbeam"
        }
      ],
      [
        "WSOL",
        {
          symbol: "WSOL",
          decimals: 9,
          address: "0xFE6B19286885a4F7F55AdAD09C3Cd1f906D2478F",
          original: "Solana"
        }
      ],
      [
        "USDCsol",
        {
          symbol: "USDC",
          decimals: 6,
          address: "0x0950Fc1AD509358dAeaD5eB8020a3c7d8b43b9DA",
          original: "Solana"
        }
      ],
      [
        "SUI",
        {
          symbol: "SUI",
          decimals: 9,
          address: "0x1703CB0F762D2a435199B64Ea47E5349B7C17480",
          original: "Sui"
        }
      ],
      [
        "APT",
        {
          symbol: "APT",
          decimals: 8,
          address: "0x43c588459b3243fA541B98CC4B2E995b3de553A2",
          original: "Aptos"
        }
      ],
      [
        "WETHarbitrum",
        {
          symbol: "WETH",
          decimals: 18,
          address: "0xDfDA518A1612030536bD77Fd67eAcbe90dDC52Ab",
          original: "Arbitrum"
        }
      ],
      [
        "USDCarbitrum",
        {
          symbol: "USDC",
          decimals: 6,
          address: "0x4b5fE357Eb11c735078e47526D6e853DBff18541",
          original: "Arbitrum"
        }
      ],
      [
        "WETHoptimism",
        {
          symbol: "WETH",
          decimals: 18,
          address: "0xDf11535274c0FD2Fe41A88bd1bBF802D72296037",
          original: "Optimism"
        }
      ],
      [
        "USDCoptimism",
        {
          symbol: "USDC",
          decimals: 6,
          address: "0xBe04f76A0ba2100c3F2d6Aa1FD8484F415469573",
          original: "Optimism"
        }
      ],
      [
        "WETHbase",
        {
          symbol: "WETH",
          decimals: 18,
          address: "0xFA83178c66fE51ee99109b5cC912f8098Ff812eF",
          original: "Base"
        }
      ],
      [
        "USDCbase",
        {
          symbol: "USDC",
          decimals: 6,
          address: "0xab933e939a9236BD439F7d29b87CE712f42bAC06",
          original: "Base"
        }
      ],
      [
        "tBTC",
        {
          symbol: "tBTC",
          decimals: 18,
          address: "0x3F531c038A0D2d9c7D19FC3554cd0439791526c4",
          original: "Ethereum"
        }
      ],
      [
        "WKLAY",
        {
          symbol: "WKLAY",
          decimals: 18,
          address: "0x126C03982Ad6D7ef7E6aF020bF219e87185a6BC3",
          original: "Klaytn"
        }
      ],
      [
        "PYTH",
        {
          symbol: "PYTH",
          decimals: 6,
          address: "0x8A0691e602B7a5FCc51a27E4a08376dE50889B42",
          original: "Solana"
        }
      ],
      [
        "USDTavax",
        {
          symbol: "USDT",
          decimals: 6,
          address: "0x9702230a8ea53601f5cd2dc00fdbc13d4df4a8c7"
        }
      ]
    ]
  ],
  [
    "Fantom",
    [
      [
        "WETH",
        {
          symbol: "WETH",
          decimals: 18,
          address: "0x2A126f043BDEBe5A0A9841c51915E562D9B07289",
          original: "Ethereum"
        }
      ],
      [
        "USDCeth",
        {
          symbol: "USDC",
          decimals: 6,
          address: "0x2Ec752329c3EB419136ca5e4432Aa2CDb1eA23e6",
          original: "Ethereum"
        }
      ],
      [
        "WBTC",
        {
          symbol: "WBTC",
          decimals: 8,
          address: "0x87e9E225aD8a0755B9958fd95BE43DD6A91FF3A7",
          original: "Ethereum"
        }
      ],
      [
        "USDT",
        {
          symbol: "USDT",
          decimals: 6,
          address: "0x14BCb86aEed6a74D3452550a25D37f1c30AA0A66",
          original: "Ethereum"
        }
      ],
      [
        "DAI",
        {
          symbol: "DAI",
          decimals: 18,
          address: "0xEE786D3D73Ea645365c7248E4e40eDba08B1169F",
          original: "Ethereum"
        }
      ],
      [
        "WMATIC",
        {
          symbol: "WMATIC",
          decimals: 18,
          address: "0xb88A6064B1F3FF5B9AE4A82fFD52560b0dF9FBD3",
          original: "Polygon"
        }
      ],
      [
        "USDCpolygon",
        {
          symbol: "USDC",
          decimals: 6,
          address: "0xB4DcfD221048a1Dad989D39456BBd87762c26F06",
          original: "Polygon"
        }
      ],
      [
        "WBNB",
        {
          symbol: "WBNB",
          decimals: 18,
          address: "0xc033551e05907Ddd643AE14b6D4a9CA72BfF509B",
          original: "Bsc"
        }
      ],
      [
        "USDCbnb",
        {
          symbol: "USDC",
          decimals: 18,
          address: "0x0FcbDAC44c67A43607D3E95886dB19871ADc985F",
          original: "Bsc"
        }
      ],
      [
        "WAVAX",
        {
          symbol: "WAVAX",
          decimals: 18,
          address: "0x358CE030DC6116Cc296E8B9F002728e65459C146",
          original: "Avalanche"
        }
      ],
      [
        "USDCavax",
        {
          symbol: "USDC",
          decimals: 6,
          address: "0xEfE7701cb2B80664385Be226d0300912CA92f66A",
          original: "Avalanche"
        }
      ],
      [
        "FTM",
        {
          symbol: "FTM",
          decimals: 18,
          address: "native",
          wrappedKey: "WFTM"
        }
      ],
      [
        "WFTM",
        {
          symbol: "WFTM",
          decimals: 18,
          address: "0x21be370d5312f44cb42ce377bc9b8a0cef1a4c83"
        }
      ],
      [
        "CELO",
        {
          symbol: "CELO",
          decimals: 18,
          address: "0xF432490C6c96C9d3bF523a499a1CEaFd8208A373",
          original: "Celo"
        }
      ],
      [
        "WGLMR",
        {
          symbol: "WGLMR",
          decimals: 18,
          address: "0xBF227E92D6754EB4BFE26C40cb299ff2809Da45f",
          original: "Moonbeam"
        }
      ],
      [
        "WSOL",
        {
          symbol: "WSOL",
          decimals: 9,
          address: "0xd99021C2A33e4Cf243010539c9e9b7c52E0236c1",
          original: "Solana"
        }
      ],
      [
        "USDCsol",
        {
          symbol: "USDC",
          decimals: 6,
          address: "0xb8398DA4FB3BC4306B9D9d9d13d9573e7d0E299f",
          original: "Solana"
        }
      ],
      [
        "SUI",
        {
          symbol: "SUI",
          decimals: 9,
          address: "0xC277423a21F6e32D886BF85Ef6cCB945d5D28347",
          original: "Sui"
        }
      ],
      [
        "APT",
        {
          symbol: "APT",
          decimals: 8,
          address: "0x3Cd9162Ca5256b8E26A0e3Ad14CCfF7C0Da0F174",
          original: "Aptos"
        }
      ],
      [
        "WETHarbitrum",
        {
          symbol: "WETH",
          decimals: 18,
          address: "0xE8367853A0823515D37b1538331B4704089becb4",
          original: "Arbitrum"
        }
      ],
      [
        "USDCarbitrum",
        {
          symbol: "USDC",
          decimals: 6,
          address: "0x2228703672906fEe5eD681Ec28e42B4506b8c336",
          original: "Arbitrum"
        }
      ],
      [
        "WETHoptimism",
        {
          symbol: "WETH",
          decimals: 18,
          address: "0xe8E8f941377A955bFA72880ec0dc2319dbC827a8",
          original: "Optimism"
        }
      ],
      [
        "USDCoptimism",
        {
          symbol: "USDC",
          decimals: 6,
          address: "0x385b219f0C4fa2e84EfE5aaf9692a821C57B8248",
          original: "Optimism"
        }
      ],
      [
        "WETHbase",
        {
          symbol: "WETH",
          decimals: 18,
          address: "0xd3365E7355230c78098b44B172eE27DAB95B041A",
          original: "Base"
        }
      ],
      [
        "USDCbase",
        {
          symbol: "USDC",
          decimals: 6,
          address: "0xd9E4C283d8A49Dc3767A6F5a4dFdc1d0cEf21604",
          original: "Base"
        }
      ],
      [
        "tBTC",
        {
          symbol: "tBTC",
          decimals: 18,
          address: "0xeE27799cF29D7F64647B92f47d543B382B49f83E",
          original: "Ethereum"
        }
      ],
      [
        "WKLAY",
        {
          symbol: "WKLAY",
          decimals: 18,
          address: "0x787e2F3509583C0F03A339Be0826463C839CBE5E",
          original: "Klaytn"
        }
      ],
      [
        "PYTH",
        {
          symbol: "PYTH",
          decimals: 6,
          address: "0x77ad3B2dA29FBd208F12c3C701E969F4422aAD79",
          original: "Solana"
        }
      ]
    ]
  ],
  [
    "Celo",
    [
      [
        "WETH",
        {
          symbol: "WETH",
          decimals: 18,
          address: "0x66803FB87aBd4aaC3cbB3fAd7C3aa01f6F3FB207",
          original: "Ethereum"
        }
      ],
      [
        "USDCeth",
        {
          symbol: "USDC",
          decimals: 6,
          address: "0x37f750B7cC259A2f741AF45294f6a16572CF5cAd",
          original: "Ethereum"
        }
      ],
      [
        "WBTC",
        {
          symbol: "WBTC",
          decimals: 8,
          address: "0xd71Ffd0940c920786eC4DbB5A12306669b5b81EF",
          original: "Ethereum"
        }
      ],
      [
        "USDT",
        {
          symbol: "USDT",
          decimals: 6,
          address: "0x617f3112bf5397D0467D315cC709EF968D9ba546",
          original: "Ethereum"
        }
      ],
      [
        "DAI",
        {
          symbol: "DAI",
          decimals: 18,
          address: "0x97926a82930bb7B33178E3c2f4ED1BFDc91A9FBF",
          original: "Ethereum"
        }
      ],
      [
        "BUSD",
        {
          symbol: "BUSD",
          decimals: 18,
          address: "0x1dd42c0785ca90B677adc2ABad01dfc5ECcD0b4d",
          original: "Ethereum"
        }
      ],
      [
        "WMATIC",
        {
          symbol: "WMATIC",
          decimals: 18,
          address: "0x9C234706292b1144133ED509ccc5B3CD193BF712",
          original: "Polygon"
        }
      ],
      [
        "USDCpolygon",
        {
          symbol: "USDC",
          decimals: 6,
          address: "0x42c76808f3179A091Ee007A2955aF2522978ADE7",
          original: "Polygon"
        }
      ],
      [
        "WBNB",
        {
          symbol: "WBNB",
          decimals: 18,
          address: "0xBf2554ce8A4D1351AFeB1aC3E5545AaF7591042d",
          original: "Bsc"
        }
      ],
      [
        "USDCbnb",
        {
          symbol: "USDC",
          decimals: 18,
          address: "0x9d9abAE97a9344e3854527b4efbB366a1564bfEb",
          original: "Bsc"
        }
      ],
      [
        "WAVAX",
        {
          symbol: "WAVAX",
          decimals: 18,
          address: "0xFFdb274b4909fC2efE26C8e4Ddc9fe91963cAA4d",
          original: "Avalanche"
        }
      ],
      [
        "USDCavax",
        {
          symbol: "USDC",
          decimals: 6,
          address: "0x62FFf2D2D1692D52eAf043AeeC727F7918d269D3",
          original: "Avalanche"
        }
      ],
      [
        "WFTM",
        {
          symbol: "WFTM",
          decimals: 18,
          address: "0xd1A342eE2210238233a347FEd61EE7Faf9f251ce",
          original: "Fantom"
        }
      ],
      [
        "CELO",
        {
          symbol: "CELO",
          decimals: 18,
          address: "0x471ece3750da237f93b8e339c536989b8978a438"
        }
      ],
      [
        "USDT",
        {
          symbol: "USDT",
          decimals: 6,
          address: "0x48065fbBE25f71C9282ddf5e1cD6D6A887483D5e"
        }
      ],
      [
        "WGLMR",
        {
          symbol: "WGLMR",
          decimals: 18,
          address: "0x383A5513AbE4Fe36e0E00d484F710148E348Aa9D",
          original: "Moonbeam"
        }
      ],
      [
        "WSOL",
        {
          symbol: "WSOL",
          decimals: 9,
          address: "0x4581E64115d46CcdeE65Be2336bEc86c9BA54C01",
          original: "Solana"
        }
      ],
      [
        "USDCsol",
        {
          symbol: "USDC",
          decimals: 6,
          address: "0x8B6eef6C449D3Ac723a9C06a9eaE2dCd7d308BA9",
          original: "Solana"
        }
      ],
      [
        "SUI",
        {
          symbol: "SUI",
          decimals: 9,
          address: "0x1Cb9859B1A16A67ef83A0c7b9A21eeC17d9a97Dc",
          original: "Sui"
        }
      ],
      [
        "APT",
        {
          symbol: "APT",
          decimals: 8,
          address: "0x89F2b718Ca518db39d377F0ABBa6B42582b549F7",
          original: "Aptos"
        }
      ],
      [
        "WETHarbitrum",
        {
          symbol: "WETH",
          decimals: 18,
          address: "0xc6F962fCcb140ece554AfD0E589f971532A57f14",
          original: "Arbitrum"
        }
      ],
      [
        "USDCarbitrum",
        {
          symbol: "USDC",
          decimals: 6,
          address: "0xA41a62567d9eb960D84b72663FdaeBE0BCdE2683",
          original: "Arbitrum"
        }
      ],
      [
        "WETHoptimism",
        {
          symbol: "WETH",
          decimals: 18,
          address: "0x8d53771b1Ec7461f8e45Bca2609c45bC0bbd0677",
          original: "Optimism"
        }
      ],
      [
        "USDCoptimism",
        {
          symbol: "USDC",
          decimals: 6,
          address: "0xEe48963C003e21EaCEdFA8a0A19BB3cbF7E776Fe",
          original: "Optimism"
        }
      ],
      [
        "WETHbase",
        {
          symbol: "WETH",
          decimals: 18,
          address: "0x905CADB645684140E285e2D09D39dF5a2082BC87",
          original: "Base"
        }
      ],
      [
        "USDCbase",
        {
          symbol: "USDC",
          decimals: 6,
          address: "0x2e2acb1782Aad0490f8446b6fD4626C467987bD6",
          original: "Base"
        }
      ],
      [
        "tBTC",
        {
          symbol: "tBTC",
          decimals: 18,
          address: "0xFaED7314060FCEc652ED91D9eac6c980DCA9D3B8",
          original: "Ethereum"
        }
      ],
      [
        "tBTCarbitrum",
        {
          symbol: "tBTC",
          decimals: 18,
          address: "0x72878E7d3A8746e0c91b9F16F0b8ee4fDE9DDc06",
          original: "Arbitrum"
        }
      ],
      [
        "WKLAY",
        {
          symbol: "WKLAY",
          decimals: 18,
          address: "0xe304254de5c2048F9bFb042dDFB54f84d1d77730",
          original: "Klaytn"
        }
      ],
      [
        "PYTH",
        {
          symbol: "PYTH",
          decimals: 6,
          address: "0x985aa4814419ba338379A634785216301e51113D",
          original: "Solana"
        }
      ]
    ]
  ],
  [
    "Moonbeam",
    [
      [
        "WETH",
        {
          symbol: "WETH",
          decimals: 18,
          address: "0xab3f0245B83feB11d15AAffeFD7AD465a59817eD",
          original: "Ethereum"
        }
      ],
      [
        "USDCeth",
        {
          symbol: "USDC",
          decimals: 6,
          address: "0x931715FEE2d06333043d11F658C8CE934aC61D0c",
          original: "Ethereum"
        }
      ],
      [
        "WBTC",
        {
          symbol: "WBTC",
          decimals: 8,
          address: "0xE57eBd2d67B462E9926e04a8e33f01cD0D64346D",
          original: "Ethereum"
        }
      ],
      [
        "USDT",
        {
          symbol: "USDT",
          decimals: 6,
          address: "0xc30E9cA94CF52f3Bf5692aaCF81353a27052c46f",
          original: "Ethereum"
        }
      ],
      [
        "DAI",
        {
          symbol: "DAI",
          decimals: 18,
          address: "0x06e605775296e851FF43b4dAa541Bb0984E9D6fD",
          original: "Ethereum"
        }
      ],
      [
        "BUSD",
        {
          symbol: "BUSD",
          decimals: 18,
          address: "0xa2284e1F98E4d0B7Eb6a6b4f3C57f1b209C755F3",
          original: "Ethereum"
        }
      ],
      [
        "WMATIC",
        {
          symbol: "WMATIC",
          decimals: 18,
          address: "0x82DbDa803bb52434B1f4F41A6F0Acb1242A7dFa3",
          original: "Polygon"
        }
      ],
      [
        "USDCpolygon",
        {
          symbol: "USDC",
          decimals: 6,
          address: "0x4415BfBDee669446550d55c749007EF60B520FC8",
          original: "Polygon"
        }
      ],
      [
        "WBNB",
        {
          symbol: "WBNB",
          decimals: 18,
          address: "0xE3b841C3f96e647E6dc01b468d6D0AD3562a9eeb",
          original: "Bsc"
        }
      ],
      [
        "USDCbnb",
        {
          symbol: "USDC",
          decimals: 18,
          address: "0x7f433E22366E03a3758CE22cCf82887d828078f8",
          original: "Bsc"
        }
      ],
      [
        "WAVAX",
        {
          symbol: "WAVAX",
          decimals: 18,
          address: "0xd4937A95BeC789CC1AE1640714C61c160279B22F",
          original: "Avalanche"
        }
      ],
      [
        "USDCavax",
        {
          symbol: "USDC",
          decimals: 6,
          address: "0xd4918c40cA9f02d42Cb53d06587aF42017Bc345D",
          original: "Avalanche"
        }
      ],
      [
        "WFTM",
        {
          symbol: "WFTM",
          decimals: 18,
          address: "0x609AedD990bf45926bca9E4eE988b4Fb98587D3A",
          original: "Fantom"
        }
      ],
      [
        "CELO",
        {
          symbol: "CELO",
          decimals: 18,
          address: "0xc1a792041985F65c17Eb65E66E254DC879CF380b",
          original: "Celo"
        }
      ],
      [
        "GLMR",
        {
          symbol: "GLMR",
          decimals: 18,
          address: "native",
          wrappedKey: "WGLMR"
        }
      ],
      [
        "WGLMR",
        {
          symbol: "WGLMR",
          decimals: 18,
          address: "0xAcc15dC74880C9944775448304B263D191c6077F"
        }
      ],
      [
        "WSOL",
        {
          symbol: "WSOL",
          decimals: 9,
          address: "0x99Fec54a5Ad36D50A4Bba3a41CAB983a5BB86A7d",
          original: "Solana"
        }
      ],
      [
        "USDCsol",
        {
          symbol: "USDC",
          decimals: 6,
          address: "0x098d6eE48341D6a0a0A72dE5baaF80A10E0F6082",
          original: "Solana"
        }
      ],
      [
        "SUI",
        {
          symbol: "SUI",
          decimals: 9,
          address: "0x484eCCE6775143D3335Ed2C7bCB22151C53B9F49",
          original: "Sui"
        }
      ],
      [
        "APT",
        {
          symbol: "APT",
          decimals: 8,
          address: "0x25331575641d35D9765e1934acC8F0991c58e904",
          original: "Aptos"
        }
      ],
      [
        "WETHarbitrum",
        {
          symbol: "WETH",
          decimals: 18,
          address: "0x18872b45c603eD2EbC508b9C5514a85c2e2791FB",
          original: "Arbitrum"
        }
      ],
      [
        "WETHoptimism",
        {
          symbol: "WETH",
          decimals: 18,
          address: "0xd4870F7F5AD8Ae5139E1a5D8AD4ac55204aE4490",
          original: "Optimism"
        }
      ],
      [
        "USDCoptimism",
        {
          symbol: "USDC",
          decimals: 6,
          address: "0x7143e8EA96e158381057a58AfdDF44601c7e532C",
          original: "Optimism"
        }
      ],
      [
        "WETHbase",
        {
          symbol: "WETH",
          decimals: 18,
          address: "0x6C6f83366A42fcA4D30a2D3f1914284de995Ac3a",
          original: "Base"
        }
      ],
      [
        "USDCbase",
        {
          symbol: "USDC",
          decimals: 6,
          address: "0xE6d02a875CcC153c076fe418f33De3A5C420f505",
          original: "Base"
        }
      ],
      [
        "tBTC",
        {
          symbol: "tBTC",
          decimals: 18,
          address: "0xeCd65E4B89495Ae63b4f11cA872a23680A7c419c",
          original: "Ethereum"
        }
      ],
      [
        "WKLAY",
        {
          symbol: "WKLAY",
          decimals: 18,
          address: "0xf0a9476E4712123A807859f9Fd25fe98213379BD",
          original: "Klaytn"
        }
      ]
    ]
  ],
  [
    "Solana",
    [
      [
        "WETH",
        {
          symbol: "WETH",
          decimals: 8,
          address: "7vfCXTUXx5WJV5JADk17DUJ4ksgau7utNKj4b963voxs",
          original: "Ethereum"
        }
      ],
      [
        "USDCeth",
        {
          symbol: "USDC",
          decimals: 6,
          address: "A9mUU4qviSctJVPJdBJWkb28deg915LYJKrzQ19ji3FM",
          original: "Ethereum"
        }
      ],
      [
        "WBTC",
        {
          symbol: "WBTC",
          decimals: 8,
          address: "3NZ9JMVBmGAqocybic2c7LQCJScmgsAZ6vQqTDzcqmJh",
          original: "Ethereum"
        }
      ],
      [
        "USDT",
        {
          symbol: "USDT",
          decimals: 6,
          address: "Dn4noZ5jgGfkntzcQSUZ8czkreiZ1ForXYoV2H8Dm7S1",
          original: "Ethereum"
        }
      ],
      [
        "DAI",
        {
          symbol: "DAI",
          decimals: 8,
          address: "EjmyN6qEC1Tf1JxiG1ae7UTJhUxSwk1TCWNWqxWV4J6o",
          original: "Ethereum"
        }
      ],
      [
        "BUSD",
        {
          symbol: "BUSD",
          decimals: 8,
          address: "33fsBLA8djQm82RpHmE3SuVrPGtZBWNYExsEUeKX1HXX",
          original: "Ethereum"
        }
      ],
      [
        "WMATIC",
        {
          symbol: "WMATIC",
          decimals: 8,
          address: "Gz7VkD4MacbEB6yC5XD3HcumEiYx2EtDYYrfikGsvopG",
          original: "Polygon"
        }
      ],
      [
        "WBNB",
        {
          symbol: "WBNB",
          decimals: 8,
          address: "9gP2kCy3wA1ctvYWQk75guqXuHfrEomqydHLtcTCqiLa",
          original: "Bsc"
        }
      ],
      [
        "USDCbnb",
        {
          symbol: "USDC",
          decimals: 8,
          address: "FCqfQSujuPxy6V42UvafBhsysWtEq1vhjfMN1PUbgaxA",
          original: "Bsc"
        }
      ],
      [
        "WAVAX",
        {
          symbol: "WAVAX",
          decimals: 8,
          address: "KgV1GvrHQmRBY8sHQQeUKwTm2r2h8t4C8qt12Cw1HVE",
          original: "Avalanche"
        }
      ],
      [
        "USDCavax",
        {
          symbol: "USDC",
          decimals: 6,
          address: "FHfba3ov5P3RjaiLVgh8FTv4oirxQDoVXuoUUDvHuXax",
          original: "Avalanche"
        }
      ],
      [
        "WFTM",
        {
          symbol: "WFTM",
          decimals: 8,
          address: "DRQBDBEWmwWGK13fRTLhSPzjbvMSUavhV6nW4RUH8W6T",
          original: "Fantom"
        }
      ],
      [
        "CELO",
        {
          symbol: "CELO",
          decimals: 8,
          address: "9kvAcwQbqejuJMd59mKuw2bfSsLRaQ7zuvaTVHEeBBec",
          original: "Celo"
        }
      ],
      [
        "WGLMR",
        {
          symbol: "WGLMR",
          decimals: 8,
          address: "7ixSaXGsHAFy34wogPk2YXiUX3BMmQMFdercdaHLnBby",
          original: "Moonbeam"
        }
      ],
      [
        "SOL",
        {
          symbol: "SOL",
          decimals: 9,
          address: "native",
          wrappedKey: "WSOL"
        }
      ],
      [
        "WSOL",
        {
          symbol: "WSOL",
          decimals: 9,
          address: "So11111111111111111111111111111111111111112"
        }
      ],
      [
        "USDCsol",
        {
          symbol: "USDC",
          decimals: 6,
          address: "EPjFWdd5AufqSSqeM2qN1xzybapC8G4wEGGkZwyTDt1v"
        }
      ],
      [
        "SUI",
        {
          symbol: "SUI",
          decimals: 8,
          address: "G1vJEgzepqhnVu35BN4jrkv3wVwkujYWFFCxhbEZ1CZr",
          original: "Sui"
        }
      ],
      [
        "APT",
        {
          symbol: "APT",
          decimals: 8,
          address: "6LNeTYMqtNm1pBFN8PfhQaoLyegAH8GD32WmHU9erXKN",
          original: "Aptos"
        }
      ],
      [
        "WETHarbitrum",
        {
          symbol: "WETH",
          decimals: 8,
          address: "CSD6JQMvLi46psjHdpfFdr826mF336pEVMJgjwcoS1m4",
          original: "Arbitrum"
        }
      ],
      [
        "USDCarbitrum",
        {
          symbol: "USDC",
          decimals: 6,
          address: "CR4xnGrhsu1fWNPoX4KbTUUtqGMF3mzRLfj4S6YEs1Yo",
          original: "Arbitrum"
        }
      ],
      [
        "WETHoptimism",
        {
          symbol: "WETH",
          decimals: 8,
          address: "8M6d63oL7dvMZ1gNbgGe3h8afMSWJEKEhtPTFM2u8h3c",
          original: "Optimism"
        }
      ],
      [
        "WETHbase",
        {
          symbol: "WETH",
          decimals: 8,
          address: "DWXe1hxpnb8LAH21iyXcjvMbiAGzoYyuCVQtRLvZdLYd",
          original: "Base"
        }
      ],
      [
        "USDCbase",
        {
          symbol: "USDC",
          decimals: 6,
          address: "EfqRM8ZGWhDTKJ7BHmFvNagKVu3AxQRDQs8WMMaoBCu6",
          original: "Base"
        }
      ],
      [
        "tBTC",
        {
          symbol: "tBTC",
          decimals: 8,
          address: "25rXTx9zDZcHyTav5sRqM6YBvTGu9pPH9yv83uAEqbgG",
          original: "Ethereum"
        }
      ],
      [
        "tBTCsol",
        {
          symbol: "tBTC",
          decimals: 8,
          address: "6DNSN2BJsaPFdFFc1zP37kkeNe4Usc1Sqkzr9C9vPWcU"
        }
      ],
      [
        "wstETH",
        {
          symbol: "wstETH",
          decimals: 8,
          address: "ZScHuTtqZukUrtZS43teTKGs2VqkKL8k4QCouR2n6Uo",
          original: "Ethereum"
        }
      ],
      [
        "PYTH",
        {
          symbol: "PYTH",
          decimals: 6,
          address: "HZ1JovNiVvGrGNiiYvEozEVgZ58xaU3RKwX8eACQBCt3"
        }
      ]
    ]
  ],
  [
    "Sui",
    [
      [
        "WETH",
        {
          symbol: "WETH",
          decimals: 8,
          address: "0xaf8cd5edc19c4512f4259f0bee101a40d41ebed738ade5874359610ef8eeced5::coin::COIN",
          original: "Ethereum"
        }
      ],
      [
        "USDCeth",
        {
          symbol: "USDC",
          decimals: 6,
          address: "0x5d4b302506645c37ff133b98c4b50a5ae14841659738d6d733d59d0d217a93bf::coin::COIN",
          original: "Ethereum"
        }
      ],
      [
        "WBTC",
        {
          symbol: "WBTC",
          decimals: 8,
          address: "0x27792d9fed7f9844eb4839566001bb6f6cb4804f66aa2da6fe1ee242d896881::coin::COIN",
          original: "Ethereum"
        }
      ],
      [
        "USDT",
        {
          symbol: "USDT",
          decimals: 6,
          address: "0xc060006111016b8a020ad5b33834984a437aaa7d3c74c18e09a95d48aceab08c::coin::COIN",
          original: "Ethereum"
        }
      ],
      [
        "WMATIC",
        {
          symbol: "WMATIC",
          decimals: 8,
          address: "0xdbe380b13a6d0f5cdedd58de8f04625263f113b3f9db32b3e1983f49e2841676::coin::COIN",
          original: "Polygon"
        }
      ],
      [
        "USDCpolygon",
        {
          symbol: "USDC",
          decimals: 6,
          address: "0x5c8c9082401982e8c2519a5c12883a5475295bf5cec4a0a13c26d35dd9a20d73::coin::COIN",
          original: "Polygon"
        }
      ],
      [
        "WBNB",
        {
          symbol: "WBNB",
          decimals: 8,
          address: "0xb848cce11ef3a8f62eccea6eb5b35a12c4c2b1ee1af7755d02d7bd6218e8226f::coin::COIN",
          original: "Bsc"
        }
      ],
      [
        "USDCbnb",
        {
          symbol: "USDC",
          decimals: 8,
          address: "0x909cba62ce96d54de25bec9502de5ca7b4f28901747bbf96b76c2e63ec5f1cba::coin::COIN",
          original: "Bsc"
        }
      ],
      [
        "WAVAX",
        {
          symbol: "WAVAX",
          decimals: 8,
          address: "0x1e8b532cca6569cab9f9b9ebc73f8c13885012ade714729aa3b450e0339ac766::coin::COIN",
          original: "Avalanche"
        }
      ],
      [
        "USDCavax",
        {
          symbol: "USDC",
          decimals: 6,
          address: "0xe596782fbaebef51ae99ffac8731aed98a80642b9dc193ed659c97fbc2cc0f84::coin::COIN",
          original: "Avalanche"
        }
      ],
      [
        "WFTM",
        {
          symbol: "WFTM",
          decimals: 8,
          address: "0x6081300950a4f1e2081580e919c210436a1bed49080502834950d31ee55a2396::coin::COIN",
          original: "Fantom"
        }
      ],
      [
        "CELO",
        {
          symbol: "CELO",
          decimals: 8,
          address: "0xa198f3be41cda8c07b3bf3fee02263526e535d682499806979a111e88a5a8d0f::coin::COIN",
          original: "Celo"
        }
      ],
      [
        "WGLMR",
        {
          symbol: "WGLMR",
          decimals: 8,
          address: "0x66f87084e49c38f76502d17f87d17f943f183bb94117561eb573e075fdc5ff75::coin::COIN",
          original: "Moonbeam"
        }
      ],
      [
        "WSOL",
        {
          symbol: "WSOL",
          decimals: 8,
          address: "0xb7844e289a8410e50fb3ca48d69eb9cf29e27d223ef90353fe1bd8e27ff8f3f8::coin::COIN",
          original: "Solana"
        }
      ],
      [
        "USDCsol",
        {
          symbol: "USDC",
          decimals: 6,
          address: "0xb231fcda8bbddb31f2ef02e6161444aec64a514e2c89279584ac9806ce9cf037::coin::COIN",
          original: "Solana"
        }
      ],
      [
        "SUI",
        {
          symbol: "SUI",
          decimals: 9,
          address: "0x2::sui::SUI"
        }
      ],
      [
        "APT",
        {
          symbol: "APT",
          decimals: 8,
          address: "0x3a5143bb1196e3bcdfab6203d1683ae29edd26294fc8bfeafe4aaa9d2704df37::coin::COIN",
          original: "Aptos"
        }
      ],
      [
        "WETHarbitrum",
        {
          symbol: "WETH",
          decimals: 8,
          address: "0x33744e7df340a4d01c23f6b18c13563f767545ea95f976f8045f056358419da3::coin::COIN",
          original: "Arbitrum"
        }
      ],
      [
        "USDCarbitrum",
        {
          symbol: "USDC",
          decimals: 6,
          address: "0xc3f8927de33d3deb52c282a836082a413bc73c6ee0bd4d7ec7e3b6b4c28e9abf::coin::COIN",
          original: "Arbitrum"
        }
      ],
      [
        "WETHoptimism",
        {
          symbol: "WETH",
          decimals: 8,
          address: "0xaab14ec22908de73d1b0619f5e03842398f8e68262981bd35ef44b42d22b23a::coin::COIN",
          original: "Optimism"
        }
      ],
      [
        "USDCoptimism",
        {
          symbol: "USDC",
          decimals: 6,
          address: "0x6037801f060f0f54b3817bca05e3c8b9b9ffaa2da8e93fd5b80fa662aa3c9e55::coin::COIN",
          original: "Optimism"
        }
      ],
      [
        "WETHbase",
        {
          symbol: "WETH",
          decimals: 8,
          address: "0xaecbc804fa7ca7cffc74c9a05eb6ae86fda0c68375b5c1724204a1065bcb239a::coin::COIN",
          original: "Base"
        }
      ],
      [
        "USDCbase",
        {
          symbol: "USDC",
          decimals: 6,
          address: "0x7e3e74afcc1913aa9491c8cee89b02131a6e5519b090f16b54321835c1241cfb::coin::COIN",
          original: "Base"
        }
      ],
      [
        "tBTC",
        {
          symbol: "tBTC",
          decimals: 8,
          address: "0xbc3a676894871284b3ccfb2eec66f428612000e2a6e6d23f592ce8833c27c973::coin::COIN",
          original: "Ethereum"
        }
      ],
      [
        "WKLAY",
        {
          symbol: "WKLAY",
          decimals: 8,
          address: "0xa5ec915864d7f37b25ca9144b2db6ebcf29e73603c2ccf9d0e765adcd9049a98::coin::COIN",
          original: "Klaytn"
        }
      ],
      [
        "PYTH",
        {
          symbol: "PYTH",
          decimals: 6,
          address: "0x9c6d76eb273e6b5ba2ec8d708b7fa336a5531f6be59f326b5be8d4d8b12348a4::coin::COIN",
          original: "Solana"
        }
      ]
    ]
  ],
  [
    "Aptos",
    [
      [
        "WETH",
        {
          symbol: "WETH",
          decimals: 8,
          address: "0xcc8a89c8dce9693d354449f1f73e60e14e347417854f029db5bc8e7454008abb::coin::T",
          original: "Ethereum"
        }
      ],
      [
        "USDCeth",
        {
          symbol: "USDC",
          decimals: 6,
          address: "0x5e156f1207d0ebfa19a9eeff00d62a282278fb8719f4fab3a586a0a2c0fffbea::coin::T",
          original: "Ethereum"
        }
      ],
      [
        "WBTC",
        {
          symbol: "WBTC",
          decimals: 8,
          address: "0xae478ff7d83ed072dbc5e264250e67ef58f57c99d89b447efd8a0a2e8b2be76e::coin::T",
          original: "Ethereum"
        }
      ],
      [
        "USDT",
        {
          symbol: "USDT",
          decimals: 6,
          address: "0xa2eda21a58856fda86451436513b867c97eecb4ba099da5775520e0f7492e852::coin::T",
          original: "Ethereum"
        }
      ],
      [
        "DAI",
        {
          symbol: "DAI",
          decimals: 8,
          address: "0x407a220699982ebb514568d007938d2447d33667e4418372ffec1ddb24491b6c::coin::T",
          original: "Ethereum"
        }
      ],
      [
        "BUSD",
        {
          symbol: "BUSD",
          decimals: 8,
          address: "0x77400d2f56a01bad2d7c8c6fa282f62647ce3c03f43f2a8742e47ea01a91e24a::coin::T",
          original: "Ethereum"
        }
      ],
      [
        "WMATIC",
        {
          symbol: "WMATIC",
          decimals: 8,
          address: "0x6781088e2a1629d38eda521467af4a8ca7bfa7e5516338017940389595c85c0f::coin::T",
          original: "Polygon"
        }
      ],
      [
        "USDCpolygon",
        {
          symbol: "USDC",
          decimals: 6,
          address: "0xc5fd7820e9f053e6dd8e7dd8ca3ce8e9b10d200ba1692bdeb7a035217180ad4a::coin::T",
          original: "Polygon"
        }
      ],
      [
        "WBNB",
        {
          symbol: "WBNB",
          decimals: 8,
          address: "0x6312bc0a484bc4e37013befc9949df2d7c8a78e01c6fe14a34018449d136ba86::coin::T",
          original: "Bsc"
        }
      ],
      [
        "USDCbnb",
        {
          symbol: "USDC",
          decimals: 8,
          address: "0x79a6ed7a0607fdad2d18d67d1a0e552d4b09ebce5951f1e5c851732c02437595::coin::T",
          original: "Bsc"
        }
      ],
      [
        "WAVAX",
        {
          symbol: "WAVAX",
          decimals: 8,
          address: "0x5b1bbc25524d41b17a95dac402cf2f584f56400bf5cc06b53c36b331b1ec6e8f::coin::T",
          original: "Avalanche"
        }
      ],
      [
        "USDCavax",
        {
          symbol: "USDC",
          decimals: 6,
          address: "0x39d84c2af3b0c9895b45d4da098049e382c451ba63bec0ce0396ff7af4bb5dff::coin::T",
          original: "Avalanche"
        }
      ],
      [
        "WFTM",
        {
          symbol: "WFTM",
          decimals: 8,
          address: "0xd1aa2ff36a0e93e1b4e4fecdecf8bb95bc5de399061c5e84b515281f48718842::coin::T",
          original: "Fantom"
        }
      ],
      [
        "CELO",
        {
          symbol: "CELO",
          decimals: 8,
          address: "0xac0c3c35d50f6ef00e3b4db6998732fe9ed6331384925fe8ec95fcd7745a9112::coin::T",
          original: "Celo"
        }
      ],
      [
        "WGLMR",
        {
          symbol: "WGLMR",
          decimals: 8,
          address: "0x7ab1283a7b13c4254d4e1f803d7ce6578442c1d7a40d0faee41cd48ba4884c8a::coin::T",
          original: "Moonbeam"
        }
      ],
      [
        "WSOL",
        {
          symbol: "WSOL",
          decimals: 8,
          address: "0xdd89c0e695df0692205912fb69fc290418bed0dbe6e4573d744a6d5e6bab6c13::coin::T",
          original: "Solana"
        }
      ],
      [
        "USDCsol",
        {
          symbol: "USDC",
          decimals: 6,
          address: "0xc91d826e29a3183eb3b6f6aa3a722089fdffb8e9642b94c5fcd4c48d035c0080::coin::T",
          original: "Solana"
        }
      ],
      [
        "SUI",
        {
          symbol: "SUI",
          decimals: 8,
          address: "0xa72a97e872be9ee3d2f14d56fd511eb7e4a53f4055be3a267d8602e7685b41c0::coin::T",
          original: "Sui"
        }
      ],
      [
        "APT",
        {
          symbol: "APT",
          decimals: 8,
          address: "0x1::aptos_coin::AptosCoin"
        }
      ],
      [
        "WETHarbitrum",
        {
          symbol: "WETH",
          decimals: 8,
          address: "0x0e977796d7bfb3263609b90dffd264c7bd078ce35dac42b55302858d9fa3452b::coin::T",
          original: "Arbitrum"
        }
      ],
      [
        "USDCarbitrum",
        {
          symbol: "USDC",
          decimals: 6,
          address: "0xca3a2c28bc8c6c762f752dd2a4ebbfd00356ca99977ce6636e3af5897124a87a::coin::T",
          original: "Arbitrum"
        }
      ],
      [
        "WETHoptimism",
        {
          symbol: "WETH",
          decimals: 8,
          address: "0x6a7a7f36ef5e2d0e65fcf72669c20d514d68298b0f76c7554517208f73260aaf::coin::T",
          original: "Optimism"
        }
      ],
      [
        "USDCoptimism",
        {
          symbol: "USDC",
          decimals: 6,
          address: "0x4f6ecb05a797902d472abc2f5804bde93a53d8b75f14f767824cdb1623a4ee83::coin::T",
          original: "Optimism"
        }
      ],
      [
        "WETHbase",
        {
          symbol: "WETH",
          decimals: 8,
          address: "0x5b5f14781164cf77185a7b6acd8e4f3cbb7e7cfb1cd5760d2b8af81075fc153d::coin::T",
          original: "Base"
        }
      ],
      [
        "USDCbase",
        {
          symbol: "USDC",
          decimals: 6,
          address: "0xfcc4fcd734d5b8578fb629d238d15264a49eca6165c7444c21feec3b4962eb88::coin::T",
          original: "Base"
        }
      ],
      [
        "tBTC",
        {
          symbol: "tBTC",
          decimals: 8,
          address: "0x9d5a0f8215301fa8096df332b1533f6328f18c32fbac2a7089cfbea73b3068a7::coin::T",
          original: "Ethereum"
        }
      ],
      [
        "WKLAY",
        {
          symbol: "WKLAY",
          decimals: 8,
          address: "0x539b652f8230a0e42adaeda4706b5639893d22362eda6ea897493c210cb48219::coin::T",
          original: "Klaytn"
        }
      ],
      [
        "PYTH",
        {
          symbol: "PYTH",
          decimals: 6,
          address: "0x770211b47954e15bec1a4271bf33bacebc2d2adb43b7dc1ca45efa787615dd4c::coin::T",
          original: "Solana"
        }
      ]
    ]
  ],
  [
    "Base",
    [
      [
        "WETH",
        {
          symbol: "WETH",
          decimals: 18,
          address: "0x71b35ECb35104773537f849FBC353F81303A5860",
          original: "Ethereum"
        }
      ],
      [
        "USDCeth",
        {
          symbol: "USDC",
          decimals: 6,
          address: "0xec267C53f53807c2337C257f8AC3Fc3cC07cc0ed",
          original: "Ethereum"
        }
      ],
      [
        "WBTC",
        {
          symbol: "WBTC",
          decimals: 8,
          address: "0xE6396f780b543dF16ee3b784D789c75B68319db0",
          original: "Ethereum"
        }
      ],
      [
        "USDT",
        {
          symbol: "USDT",
          decimals: 6,
          address: "0xFf0C62A4979400841eFaA6faADb07Ac7d5C98b27",
          original: "Ethereum"
        }
      ],
      [
        "DAI",
        {
          symbol: "DAI",
          decimals: 18,
          address: "0x617Edadb51BfB43A44Bb91C7402129C23bA52381",
          original: "Ethereum"
        }
      ],
      [
        "WMATIC",
        {
          symbol: "WMATIC",
          decimals: 18,
          address: "0xc863399E5c5C4011B1DC3fB602902C77BA72B709",
          original: "Polygon"
        }
      ],
      [
        "USDCpolygon",
        {
          symbol: "USDC",
          decimals: 6,
          address: "0xFe1579BAc60363c8572CB30Bf4DD1Fd85811BBF8",
          original: "Polygon"
        }
      ],
      [
        "WBNB",
        {
          symbol: "WBNB",
          decimals: 18,
          address: "0x7fdAa50d7399ac436943028edA6ed9a1BD89509f",
          original: "Bsc"
        }
      ],
      [
        "USDCbnb",
        {
          symbol: "USDC",
          decimals: 18,
          address: "0x68E2b07F92ed506f92935d7359ECA84D5342dbb4",
          original: "Bsc"
        }
      ],
      [
        "WAVAX",
        {
          symbol: "WAVAX",
          decimals: 18,
          address: "0xc449A60A31E1eebFE83c42E9465fd4Dc318aE9a7",
          original: "Avalanche"
        }
      ],
      [
        "USDCavax",
        {
          symbol: "USDC",
          decimals: 6,
          address: "0xD83385fE100E20c269a5975D4Bf92525BcE09F87",
          original: "Avalanche"
        }
      ],
      [
        "WFTM",
        {
          symbol: "WFTM",
          decimals: 18,
          address: "0x936Fa2DE8380Dc5BF34C80F1BaD53a9f3630263B",
          original: "Fantom"
        }
      ],
      [
        "CELO",
        {
          symbol: "CELO",
          decimals: 18,
          address: "0x74df3823aA29D278cAD0A3632fCB56C896a38eD4",
          original: "Celo"
        }
      ],
      [
        "WGLMR",
        {
          symbol: "WGLMR",
          decimals: 18,
          address: "0xfdB7311BeC3b2CcCF8407d0585f81B97b3b5eff1",
          original: "Moonbeam"
        }
      ],
      [
        "WSOL",
        {
          symbol: "WSOL",
          decimals: 9,
          address: "0x1C61629598e4a901136a81BC138E5828dc150d67",
          original: "Solana"
        }
      ],
      [
        "USDCsol",
        {
          symbol: "USDC",
          decimals: 6,
          address: "0xe8CE40EBBB844142400D21558a2F1c9683d69139",
          original: "Solana"
        }
      ],
      [
        "SUI",
        {
          symbol: "SUI",
          decimals: 9,
          address: "0x36c6FBF7B49bF65f5F82b674af219C05b2a4aDD1",
          original: "Sui"
        }
      ],
      [
        "APT",
        {
          symbol: "APT",
          decimals: 8,
          address: "0x1d36126289Be1658297A35CC3EB2BB80A7D7A04b",
          original: "Aptos"
        }
      ],
      [
        "WETHarbitrum",
        {
          symbol: "WETH",
          decimals: 18,
          address: "0x9D36e0edb8BBaBeec5edE8a218dc2B9a6Fce494F",
          original: "Arbitrum"
        }
      ],
      [
        "USDCarbitrum",
        {
          symbol: "USDC",
          decimals: 6,
          address: "0xb96B82Cd6D45d98Fb6897D16A5E4EE888329C513",
          original: "Arbitrum"
        }
      ],
      [
        "WETHoptimism",
        {
          symbol: "WETH",
          decimals: 18,
          address: "0xCb725aC8d9985D3bE306Dd9e1517d3702929176c",
          original: "Optimism"
        }
      ],
      [
        "USDCoptimism",
        {
          symbol: "USDC",
          decimals: 6,
          address: "0xc6bfBeb3002aD563D2d1f72614C61C83Bf147Acd",
          original: "Optimism"
        }
      ],
      [
        "ETHbase",
        {
          symbol: "ETH",
          decimals: 18,
          address: "native",
          wrappedKey: "WETHbase"
        }
      ],
      [
        "WETHbase",
        {
          symbol: "WETH",
          decimals: 18,
          address: "0x4200000000000000000000000000000000000006"
        }
      ],
      [
        "USDCbase",
        {
          symbol: "USDC",
          decimals: 6,
          address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913"
        }
      ],
      [
        "wstETHbase",
        {
          symbol: "wstETH",
          decimals: 18,
          address: "0xc1CBa3fCea344f92D9239c08C0568f6F2F0ee452"
        }
      ],
      [
        "tBTC",
        {
          symbol: "tBTC",
          decimals: 18,
          address: "0x9EE95E6Bd1B3C5740F105d6fb06b8BDeF64Eec70",
          original: "Ethereum"
        }
      ],
      [
        "tBTCarbitrum",
        {
          symbol: "tBTC",
          decimals: 18,
          address: "0x56D0873e0eCA4a56063e1BF945788365666CFBFC",
          original: "Arbitrum"
        }
      ],
      [
        "tBTCbase",
        {
          symbol: "tBTC",
          decimals: 18,
          address: "0x236aa50979D5f3De3Bd1Eeb40E81137F22ab794b"
        }
      ],
      [
        "wstETH",
        {
          symbol: "wstETH",
          decimals: 18,
          address: "0xEd4e2FD35161c3c0e33cA187fce64C70d44Ce32b",
          original: "Ethereum"
        }
      ],
      [
        "WKLAY",
        {
          symbol: "WKLAY",
          decimals: 18,
          address: "0x41c433c146c47Dc53FC48cDc69e406e365e298E1",
          original: "Klaytn"
        }
      ],
      [
        "PYTH",
        {
          symbol: "PYTH",
          decimals: 6,
          address: "0x4c5d8A75F3762c1561D96f177694f67378705E98",
          original: "Solana"
        }
      ],
      [
        "USDTbase",
        {
          symbol: "USDT",
          decimals: 6,
          address: "0xfde4C96c8593536E31F229EA8f37b2ADa2699bb2"
        }
      ]
    ]
  ],
  [
    "Arbitrum",
    [
      [
        "WETH",
        {
          symbol: "WETH",
          decimals: 18,
          address: "0xD8369C2EDA18dD6518eABb1F85BD60606dEb39Ec",
          original: "Ethereum"
        }
      ],
      [
        "USDCeth",
        {
          symbol: "USDC",
          decimals: 6,
          address: "0xC96F2715E2a242d50D1b0bC923dbe1740b8eCf18",
          original: "Ethereum"
        }
      ],
      [
        "WBTC",
        {
          symbol: "WBTC",
          decimals: 8,
          address: "0x397846a8078d4845c7f5c6Ca76aeBbcFDc044fAe",
          original: "Ethereum"
        }
      ],
      [
        "USDT",
        {
          symbol: "USDT",
          decimals: 6,
          address: "0xE4728F3E48E94C6DA2B53610E677cc241DAFB134",
          original: "Ethereum"
        }
      ],
      [
        "DAI",
        {
          symbol: "DAI",
          decimals: 18,
          address: "0x5c4f2FEFB97F7DF09E762d95C83f0Ccf8bCe8234",
          original: "Ethereum"
        }
      ],
      [
        "WMATIC",
        {
          symbol: "WMATIC",
          decimals: 18,
          address: "0x3ab0E28C3F56616aD7061b4db38aE337E3809AEA",
          original: "Polygon"
        }
      ],
      [
        "USDCpolygon",
        {
          symbol: "USDC",
          decimals: 6,
          address: "0x599ADB10E6A012dF34935D47407450f6D7170e3C",
          original: "Polygon"
        }
      ],
      [
        "WBNB",
        {
          symbol: "WBNB",
          decimals: 18,
          address: "0x7AF00405916D823eDb1121546EfA6F4972B51b84",
          original: "Bsc"
        }
      ],
      [
        "USDCbnb",
        {
          symbol: "USDC",
          decimals: 18,
          address: "0x1a0590F951bc9C3818Ce75ba5Bbe92831b2cf57e",
          original: "Bsc"
        }
      ],
      [
        "WAVAX",
        {
          symbol: "WAVAX",
          decimals: 18,
          address: "0x565609fAF65B92F7be02468acF86f8979423e514",
          original: "Avalanche"
        }
      ],
      [
        "USDCavax",
        {
          symbol: "USDC",
          decimals: 6,
          address: "0x93e0FcbEd43CD6fC30DF00CcBD4669718dc74e77",
          original: "Avalanche"
        }
      ],
      [
        "WFTM",
        {
          symbol: "WFTM",
          decimals: 18,
          address: "0x7f7dcDb91930033a4Eb269196EBb6fd5f0644E4B",
          original: "Fantom"
        }
      ],
      [
        "CELO",
        {
          symbol: "CELO",
          decimals: 18,
          address: "0x4E51aC49bC5e2d87e0EF713E9e5AB2D71EF4F336",
          original: "Celo"
        }
      ],
      [
        "WGLMR",
        {
          symbol: "WGLMR",
          decimals: 18,
          address: "0x944C5b67a03e6Cb93Ae1E4B70081f13b04CDB6Bd",
          original: "Moonbeam"
        }
      ],
      [
        "WSOL",
        {
          symbol: "WSOL",
          decimals: 9,
          address: "0x2bcC6D6CdBbDC0a4071e48bb3B969b06B3330c07",
          original: "Solana"
        }
      ],
      [
        "USDCsol",
        {
          symbol: "USDC",
          decimals: 6,
          address: "0x3870546cfd600ba87e4180686d29dC993A45d3B7",
          original: "Solana"
        }
      ],
      [
        "SUI",
        {
          symbol: "SUI",
          decimals: 9,
          address: "0xCF79d86B8a830030aF6D835737d6eac3bE823fD7",
          original: "Sui"
        }
      ],
      [
        "APT",
        {
          symbol: "APT",
          decimals: 8,
          address: "0x4EdeF400eDe5309240814b5FC403F224504604e9",
          original: "Aptos"
        }
      ],
      [
        "ETHarbitrum",
        {
          symbol: "ETH",
          decimals: 18,
          address: "native",
          wrappedKey: "WETHarbitrum"
        }
      ],
      [
        "WETHarbitrum",
        {
          symbol: "WETH",
          decimals: 18,
          address: "0x82af49447d8a07e3bd95bd0d56f35241523fbab1"
        }
      ],
      [
        "USDCarbitrum",
        {
          symbol: "USDC",
          decimals: 6,
          address: "0xaf88d065e77c8cC2239327C5EDb3A432268e5831"
        }
      ],
      [
        "WETHoptimism",
        {
          symbol: "WETH",
          decimals: 18,
          address: "0xB1fC645a86fB5085e12D8BDDb77702F728D2A26F",
          original: "Optimism"
        }
      ],
      [
        "USDCoptimism",
        {
          symbol: "USDC",
          decimals: 6,
          address: "0x3A5C2Da9E30741cb59a5e9446A23A86886fC9DC2",
          original: "Optimism"
        }
      ],
      [
        "WETHbase",
        {
          symbol: "WETH",
          decimals: 18,
          address: "0xBAfbCB010D920e0Dab9DFdcF634De1B777028a85",
          original: "Base"
        }
      ],
      [
        "USDCbase",
        {
          symbol: "USDC",
          decimals: 6,
          address: "0x8619F97D4d08382548F536E5CE1D3e0D9bA40326",
          original: "Base"
        }
      ],
      [
        "tBTC",
        {
          symbol: "tBTC",
          decimals: 18,
          address: "0x57723abc582DBfE11Ea01f1A1f48aEE20bD65D73",
          original: "Ethereum"
        }
      ],
      [
        "tBTCpolygon",
        {
          symbol: "tBTC",
          decimals: 18,
          address: "0x3bab04bDFd2Dc3640c2B9390A2Da05bC1192D482",
          original: "Polygon"
        }
      ],
      [
        "tBTCoptimism",
        {
          symbol: "tBTC",
          decimals: 18,
          address: "0x2519010b6585247BcDC8BcDa5C8730Be754b8c76",
          original: "Optimism"
        }
      ],
      [
        "tBTCarbitrum",
        {
          symbol: "tBTC",
          decimals: 18,
          address: "0x6c84a8f1c29108F47a79964b5Fe888D4f4D0dE40"
        }
      ],
      [
        "wstETH",
        {
          symbol: "wstETH",
          decimals: 18,
          address: "0xf2717122Dfdbe988ae811E7eFB157aAa07Ff9D0F",
          original: "Ethereum"
        }
      ],
      [
        "wstETHarbitrum",
        {
          symbol: "wstETH",
          decimals: 18,
          address: "0x5979D7b546E38E414F7E9822514be443A4800529"
        }
      ],
      [
        "WKLAY",
        {
          symbol: "WKLAY",
          decimals: 18,
          address: "0xFA95f6c796E54F9C4a99392CAE84410a25794BB3",
          original: "Klaytn"
        }
      ],
      [
        "PYTH",
        {
          symbol: "PYTH",
          decimals: 6,
          address: "0xE4D5c6aE46ADFAF04313081e8C0052A30b6Dd724",
          original: "Solana"
        }
      ],
      [
        "USDTarbitrum",
        {
          symbol: "USDT",
          decimals: 6,
          address: "0xFd086bC7CD5C481DCC9C85ebE478A1C0b69FCbb9"
        }
      ]
    ]
  ],
  [
    "Optimism",
    [
      [
        "WETH",
        {
          symbol: "WETH",
          decimals: 18,
          address: "0xb47bC3ed6D70F04fe759b2529c9bc7377889678f",
          original: "Ethereum"
        }
      ],
      [
        "USDCeth",
        {
          symbol: "USDC",
          decimals: 6,
          address: "0x711e53D031ea9B0bb0C24dD506df11b41AEA419e",
          original: "Ethereum"
        }
      ],
      [
        "WBTC",
        {
          symbol: "WBTC",
          decimals: 8,
          address: "0xB214C19d81c99E75e84706a3aa0A757319023e26",
          original: "Ethereum"
        }
      ],
      [
        "USDT",
        {
          symbol: "USDT",
          decimals: 6,
          address: "0xf6B4185FCf8aF291c0E3927fbEab7046b4f6A8CA",
          original: "Ethereum"
        }
      ],
      [
        "DAI",
        {
          symbol: "DAI",
          decimals: 18,
          address: "0x098EA47D630b46df1E08e389e5e4466119c7dd30",
          original: "Ethereum"
        }
      ],
      [
        "WMATIC",
        {
          symbol: "WMATIC",
          decimals: 18,
          address: "0x8f02B6a32cebcAe44D2Fd17d87966f5B5dD14c6d",
          original: "Polygon"
        }
      ],
      [
        "USDCpolygon",
        {
          symbol: "USDC",
          decimals: 6,
          address: "0xbB1EaB9Eb8fDf65F0E291D013DA07B4b65a27a01",
          original: "Polygon"
        }
      ],
      [
        "WBNB",
        {
          symbol: "WBNB",
          decimals: 18,
          address: "0x6A09fE65ACa27C12573F04aAFa290bD75497E1BC",
          original: "Bsc"
        }
      ],
      [
        "USDCbnb",
        {
          symbol: "USDC",
          decimals: 18,
          address: "0x1C15057d1F3794C934a6cBC1f7EceE934050F219",
          original: "Bsc"
        }
      ],
      [
        "WAVAX",
        {
          symbol: "WAVAX",
          decimals: 18,
          address: "0x8418C1d909842f458c9394886b83F19d62bF1A0D",
          original: "Avalanche"
        }
      ],
      [
        "USDCavax",
        {
          symbol: "USDC",
          decimals: 6,
          address: "0x355f0a8a7ecAeD971b8Fbd50994558291ff2413a",
          original: "Avalanche"
        }
      ],
      [
        "WFTM",
        {
          symbol: "WFTM",
          decimals: 18,
          address: "0x0b0ecbe5C3995541876d27633B63296570FB34Af",
          original: "Fantom"
        }
      ],
      [
        "CELO",
        {
          symbol: "CELO",
          decimals: 18,
          address: "0x9b88D293b7a791E40d36A39765FFd5A1B9b5c349",
          original: "Celo"
        }
      ],
      [
        "WGLMR",
        {
          symbol: "WGLMR",
          decimals: 18,
          address: "0xbffD46DFDb8d3a02b8D2E0F864a2cD712090a4D3",
          original: "Moonbeam"
        }
      ],
      [
        "WSOL",
        {
          symbol: "WSOL",
          decimals: 9,
          address: "0xba1Cf949c382A32a09A17B2AdF3587fc7fA664f1",
          original: "Solana"
        }
      ],
      [
        "USDCsol",
        {
          symbol: "USDC",
          decimals: 6,
          address: "0x6F974A6dfD5B166731704Be226795901c45Bb815",
          original: "Solana"
        }
      ],
      [
        "SUI",
        {
          symbol: "SUI",
          decimals: 9,
          address: "0x27A533e438892DA192725b4C9AcA51447F457212",
          original: "Sui"
        }
      ],
      [
        "APT",
        {
          symbol: "APT",
          decimals: 8,
          address: "0xC5B3AC2DF8D8D7AC851F763a5b3Ff23B4A696d59",
          original: "Aptos"
        }
      ],
      [
        "WETHarbitrum",
        {
          symbol: "WETH",
          decimals: 18,
          address: "0x825206E1D29456337769e6f1384101E997C6A732",
          original: "Arbitrum"
        }
      ],
      [
        "USDCarbitrum",
        {
          symbol: "USDC",
          decimals: 6,
          address: "0xa6252F56cc6eEA21165d56744C795F91c8a3Cf68",
          original: "Arbitrum"
        }
      ],
      [
        "ETHoptimism",
        {
          symbol: "ETH",
          decimals: 18,
          address: "native",
          wrappedKey: "WETHoptimism"
        }
      ],
      [
        "WETHoptimism",
        {
          symbol: "WETH",
          decimals: 18,
          address: "0x4200000000000000000000000000000000000006"
        }
      ],
      [
        "USDCoptimism",
        {
          symbol: "USDC",
          decimals: 6,
          address: "0x0b2c639c533813f4aa9d7837caf62653d097ff85"
        }
      ],
      [
        "WETHbase",
        {
          symbol: "WETH",
          decimals: 18,
          address: "0x3F369a664fa665e01e8EB9f20bFcE03A0CAb8971",
          original: "Base"
        }
      ],
      [
        "USDCbase",
        {
          symbol: "USDC",
          decimals: 6,
          address: "0xb931c7BbD87A6e249EaA7355B13927F9c99Bce87",
          original: "Base"
        }
      ],
      [
        "tBTC",
        {
          symbol: "tBTC",
          decimals: 18,
          address: "0xeC0a755664271b87002dDa33CA2484B24aF68912",
          original: "Ethereum"
        }
      ],
      [
        "tBTCpolygon",
        {
          symbol: "tBTC",
          decimals: 18,
          address: "0xE4C32B9eA749fa0342B1C42C01E80028B97c3917",
          original: "Polygon"
        }
      ],
      [
        "tBTCoptimism",
        {
          symbol: "tBTC",
          decimals: 18,
          address: "0x6c84a8f1c29108F47a79964b5Fe888D4f4D0dE40"
        }
      ],
      [
        "tBTCarbitrum",
        {
          symbol: "tBTC",
          decimals: 18,
          address: "0x2390a5131fcba6e47f702172cF4876589E4161c6",
          original: "Arbitrum"
        }
      ],
      [
        "wstETH",
        {
          symbol: "wstETH",
          decimals: 18,
          address: "0x855CFcEEe998c8ca34F9c914F584AbF72dC88B87",
          original: "Ethereum"
        }
      ],
      [
        "wstETHoptimism",
        {
          symbol: "wstETH",
          decimals: 18,
          address: "0x1F32b1c2345538c0c6f582fCB022739c4A194Ebb"
        }
      ],
      [
        "WKLAY",
        {
          symbol: "WKLAY",
          decimals: 18,
          address: "0xbbeF8233a0d10EEAb84E913FaDB337ab9b62F683",
          original: "Klaytn"
        }
      ],
      [
        "PYTH",
        {
          symbol: "PYTH",
          decimals: 6,
          address: "0x99C59ACeBFEF3BBFB7129DC90D1a11DB0E91187f",
          original: "Solana"
        }
      ],
      [
        "USDToptimism",
        {
          symbol: "USDT",
          decimals: 6,
          address: "0x94b008aA00579c1307B0EF2c499aD98a8ce58e58"
        }
      ]
    ]
  ],
  [
    "Wormchain",
    [
      [
        "WETH",
        {
          symbol: "WETH",
          decimals: 8,
          address: "wormhole18csycs4vm6varkp00apuqlsm7v4twg8jsljk8wfdd7cghr7g4rtslwqndm",
          original: "Ethereum"
        }
      ],
      [
        "USDCeth",
        {
          symbol: "USDC",
          decimals: 6,
          address: "wormhole1utjx3594tlvfw4375esgu72wa4sdgf0q7x4ye27husf5kvuzp5rsr72gdq",
          original: "Ethereum"
        }
      ],
      [
        "WBTC",
        {
          symbol: "WBTC",
          decimals: 8,
          address: "wormhole1nz0r0au8aj6dc00wmm3ufy4g4k86rjzlr8wkf92cktdlps5lgfcqxnx9yk",
          original: "Ethereum"
        }
      ],
      [
        "USDT",
        {
          symbol: "USDT",
          decimals: 6,
          address: "wormhole1w27ekqvvtzfanfxnkw4jx2f8gdfeqwd3drkee3e64xat6phwjg0savgmhw",
          original: "Ethereum"
        }
      ],
      [
        "DAI",
        {
          symbol: "DAI",
          decimals: 8,
          address: "wormhole1chejx4qqtvwxy6684yrsmf6pylancxqhk3vsmtleg5ta3zrffljqfscg87",
          original: "Ethereum"
        }
      ],
      [
        "BUSD",
        {
          symbol: "BUSD",
          decimals: 8,
          address: "wormhole1msyushf6d76u9wupuvm6jdvc0x4trmv5w5kxr0hyt7n9npp233usg7pkhm",
          original: "Ethereum"
        }
      ],
      [
        "WMATIC",
        {
          symbol: "WMATIC",
          decimals: 8,
          address: "wormhole1xmpenz0ykxfy8rxr3yc3d4dtqq4dpas4zz3xl6sh873us3vajlpszn4ph7",
          original: "Polygon"
        }
      ],
      [
        "WBNB",
        {
          symbol: "WBNB",
          decimals: 8,
          address: "wormhole169nr66h9gcsfljvsnxnqfjakskcjt6ac8f58wqjuagu79m540teqfvaal4",
          original: "Bsc"
        }
      ],
      [
        "USDCbnb",
        {
          symbol: "USDC",
          decimals: 8,
          address: "wormhole1g3acw7aumaj3r348cqn4kazrehlmn822w9p46sqwztnke27h3lysxj4ddr",
          original: "Bsc"
        }
      ],
      [
        "WAVAX",
        {
          symbol: "WAVAX",
          decimals: 8,
          address: "wormhole1ml922hnp59jtq9a87arekvx60ezehwlg2v3j5pduplwkenfa68ksgmzxwr",
          original: "Avalanche"
        }
      ],
      [
        "USDCavax",
        {
          symbol: "USDC",
          decimals: 6,
          address: "wormhole1gwm6mrnse9atzf4mer4dnrz64mp6pa75wpsxywu8gymt9fwsk46sfr372u",
          original: "Avalanche"
        }
      ],
      [
        "WFTM",
        {
          symbol: "WFTM",
          decimals: 8,
          address: "wormhole1e0cwfmla7exa578xddl87paxexw9ymwrzysfjms8c2mstxjkldlqn45jqa",
          original: "Fantom"
        }
      ],
      [
        "CELO",
        {
          symbol: "CELO",
          decimals: 8,
          address: "wormhole1kqey3a6k26kyensq7elcpx229tlj4d3qlshwhjq5xjm8dcdvu60qtef8k9",
          original: "Celo"
        }
      ],
      [
        "WGLMR",
        {
          symbol: "WGLMR",
          decimals: 8,
          address: "wormhole1gzuv84xrwwhxhf0f62av279vfyrfrm7x58fcnadlr5m90gnx223ses2st0",
          original: "Moonbeam"
        }
      ],
      [
        "WSOL",
        {
          symbol: "WSOL",
          decimals: 8,
          address: "wormhole1wn625s4jcmvk0szpl85rj5azkfc6suyvf75q6vrddscjdphtve8sca0pvl",
          original: "Solana"
        }
      ],
      [
        "USDCsol",
        {
          symbol: "USDC",
          decimals: 6,
          address: "wormhole17fr8awnysyv3nt5je4strczdupssl8u9jqam890jfv72sh32yyqqhtg3ry",
          original: "Solana"
        }
      ],
      [
        "SUI",
        {
          symbol: "SUI",
          decimals: 8,
          address: "wormhole19hlynxzedrlqv99v6qscww7d3crhl86qtd0vprpltg5g9xx6jk9q6ya33y",
          original: "Sui"
        }
      ],
      [
        "APT",
        {
          symbol: "APT",
          decimals: 8,
          address: "wormhole1f9sxjn0qu8xylcpzlvnhrefnatndqxnrajfrnr5h97hegnmsdqhsh6juc0",
          original: "Aptos"
        }
      ],
      [
        "WETHarbitrum",
        {
          symbol: "WETH",
          decimals: 8,
          address: "wormhole18nlwscr7290j463vcptqlgqudycry2rdnw2ysltpc2nqefk3353s808rl9",
          original: "Arbitrum"
        }
      ],
      [
        "WETHoptimism",
        {
          symbol: "WETH",
          decimals: 8,
          address: "wormhole1ev8rhdflmlq6de5g7ttj585fhuv3jfhnuhfzyh7qrswhzaq2tkqswxz6y3",
          original: "Optimism"
        }
      ],
      [
        "USDCoptimism",
        {
          symbol: "USDC",
          decimals: 6,
          address: "wormhole1snw0qugpjcxwtxzzkqt5guwavq85eumxzeagql2u2m662xrtnjuqyj3pkj",
          original: "Optimism"
        }
      ],
      [
        "USDCbase",
        {
          symbol: "USDC",
          decimals: 6,
          address: "wormhole1edkult6zudk6ld23fesjfrehux35q86engsq5jlycl0e4upkz8mqkgcprf",
          original: "Base"
        }
      ],
      [
        "tBTC",
        {
          symbol: "tBTC",
          decimals: 8,
          address: "wormhole1nu9wf9dw384attnpu0pwfet5fajn05w2ex4r07mghvk3xcwrt2yq5uutp5",
          original: "Ethereum"
        }
      ],
      [
        "tBTCpolygon",
        {
          symbol: "tBTC",
          decimals: 8,
          address: "wormhole1uj24zecnaxz7ftz0sh6dsayfene4w3yptwg0422kves9duel67vsr7hlyz",
          original: "Polygon"
        }
      ],
      [
        "tBTCarbitrum",
        {
          symbol: "tBTC",
          decimals: 8,
          address: "wormhole1q8ynvqvtw49ln73mn70v4me4q03fvvmhkf2lh4ueam5w4362s2asjmvxtd",
          original: "Arbitrum"
        }
      ],
      [
        "wstETH",
        {
          symbol: "wstETH",
          decimals: 8,
          address: "wormhole1gg6f95cymcfrfzhpek7cf5wl53t5kng52cd2m0krgdlu8k58vd8qezy8pt",
          original: "Ethereum"
        }
      ],
      [
        "WKLAY",
        {
          symbol: "WKLAY",
          decimals: 8,
          address: "wormhole1kyy876kye7k79fuzat532yyqkrzhlr6l7hc7lfa2rk5tygzhy00qrhjgkc",
          original: "Klaytn"
        }
      ]
    ]
  ],
  [
    "Osmosis",
    [
      [
        "WETH",
        {
          symbol: "WETH",
          decimals: 8,
          address: "ibc/62F82550D0B96522361C89B0DA1119DE262FBDFB25E5502BC5101B5C0D0DBAAC",
          original: "Ethereum"
        }
      ],
      [
        "USDCeth",
        {
          symbol: "USDC",
          decimals: 6,
          address: "ibc/6B99DB46AA9FF47162148C1726866919E44A6A5E0274B90912FD17E19A337695",
          original: "Ethereum"
        }
      ],
      [
        "WBTC",
        {
          symbol: "WBTC",
          decimals: 8,
          address: "ibc/E4CD61E1FA3EB04EF1BF924D676AB9FD55E84A0DCF4E78C11CCA0E14E5B42672",
          original: "Ethereum"
        }
      ],
      [
        "USDT",
        {
          symbol: "USDT",
          decimals: 6,
          address: "ibc/2108F2D81CBE328F371AD0CEF56691B18A86E08C3651504E42487D9EE92DDE9C",
          original: "Ethereum"
        }
      ],
      [
        "DAI",
        {
          symbol: "DAI",
          decimals: 8,
          address: "ibc/898ACF6F5DEBF535103BBD52E3E5B70A311AD097B198A152483F69290B4210C0",
          original: "Ethereum"
        }
      ],
      [
        "WMATIC",
        {
          symbol: "WMATIC",
          decimals: 8,
          address: "ibc/03B6D1925A09B3033AA6FA8772202719ABDC51F8CC2A5C26D0A9B19832F2C023",
          original: "Polygon"
        }
      ],
      [
        "WBNB",
        {
          symbol: "WBNB",
          decimals: 8,
          address: "ibc/5394BB30B3C9BD1EE84C9531E5094DDE2490964F518CBE8A4C91F748CE559AF5",
          original: "Bsc"
        }
      ],
      [
        "USDCbnb",
        {
          symbol: "USDC",
          decimals: 8,
          address: "ibc/B28ACEF11D063FA8B1DA73C2F7DA3A1CFCCBC13E96B671698D4860E9367B55BB",
          original: "Bsc"
        }
      ],
      [
        "WAVAX",
        {
          symbol: "WAVAX",
          decimals: 8,
          address: "ibc/22B44C7369EED16089B9840ADE399B80D9483B4E459E67643C96C681D7C463D0",
          original: "Avalanche"
        }
      ],
      [
        "USDCavax",
        {
          symbol: "USDC",
          decimals: 6,
          address: "ibc/0B3C3D06228578334B66B57FBFBA4033216CEB8119B27ACDEE18D92DA5B28D43",
          original: "Avalanche"
        }
      ],
      [
        "WFTM",
        {
          symbol: "WFTM",
          decimals: 8,
          address: "ibc/397DFE63D87F6940ECA583DFF5461E48BF0BA6554CBBE70278E307DDFDC8E9D5",
          original: "Fantom"
        }
      ],
      [
        "CELO",
        {
          symbol: "CELO",
          decimals: 8,
          address: "ibc/83300733052AB5F6E0F0C221E24189B6DF26CC94C73D2F44627627F9DEF4A9C8",
          original: "Celo"
        }
      ],
      [
        "WGLMR",
        {
          symbol: "WGLMR",
          decimals: 8,
          address: "ibc/0F2941B0168D8DB77DA1B6A2D3A95EC04026D3C97FA3BFE8FD1D5D3F983AA518",
          original: "Moonbeam"
        }
      ],
      [
        "WSOL",
        {
          symbol: "WSOL",
          decimals: 8,
          address: "ibc/1E43D59E565D41FB4E54CA639B838FFD5BCFC20003D330A56CB1396231AA1CBA",
          original: "Solana"
        }
      ],
      [
        "USDCsol",
        {
          symbol: "USDC",
          decimals: 6,
          address: "ibc/F08DE332018E8070CC4C68FE06E04E254F527556A614F5F8F9A68AF38D367E45",
          original: "Solana"
        }
      ],
      [
        "SUI",
        {
          symbol: "SUI",
          decimals: 8,
          address: "ibc/B1C287C2701774522570010EEBCD864BCB7AB714711B3AA218699FDD75E832F5",
          original: "Sui"
        }
      ],
      [
        "APT",
        {
          symbol: "APT",
          decimals: 8,
          address: "ibc/A4D176906C1646949574B48C1928D475F2DF56DE0AC04E1C99B08F90BC21ABDE",
          original: "Aptos"
        }
      ],
      [
        "USDCbase",
        {
          symbol: "USDC",
          decimals: 6,
          address: "ibc/8AC0F990290BBEF3AEBFCBF70F902AD954781BB40D07EB76341272800D48D05F",
          original: "Base"
        }
      ],
      [
        "OSMO",
        {
          symbol: "OSMO",
          decimals: 6,
          address: "uosmo"
        }
      ],
      [
        "tBTC",
        {
          symbol: "tBTC",
          decimals: 8,
          address: "ibc/6207D35D2C08F2162575C3C4BFD524226E50639121A273045F1B393AF67DCEB3",
          original: "Ethereum"
        }
      ],
      [
        "wstETH",
        {
          symbol: "wstETH",
          decimals: 8,
          address: "ibc/BF75AE1500CB7EC458E91A11731F1B6AC1F1FE1FA937A88564955ED6A83CA2FB",
          original: "Ethereum"
        }
      ]
    ]
  ],
  [
    "Evmos",
    [
      [
        "WETH",
        {
          symbol: "WETH",
          decimals: 8,
          address: "ibc/4442A8E0D487A49E76EA6606F5DADCF8D0DBDD8499112340C964970DB745EDA2",
          original: "Ethereum"
        }
      ],
      [
        "USDCeth",
        {
          symbol: "USDC",
          decimals: 6,
          address: "ibc/0C19171CDC59451F91D2749CDEA63355532DCD5D8904CCBAC4953290E16AB8FD",
          original: "Ethereum"
        }
      ],
      [
        "WBTC",
        {
          symbol: "WBTC",
          decimals: 8,
          address: "ibc/46C5DA1CB61C5BAA8730ABA467ADD58DE0333B075CACE28BC87E64AE8C9CA051",
          original: "Ethereum"
        }
      ],
      [
        "USDT",
        {
          symbol: "USDT",
          decimals: 6,
          address: "ibc/C9072A294F5649D64E87A6998DD750576881E454CACCDAF7376EFC0FA243808D",
          original: "Ethereum"
        }
      ],
      [
        "USDCbnb",
        {
          symbol: "USDC",
          decimals: 8,
          address: "ibc/8E08C01546EF346F7E9A3600DDBC88943ADF3B20A67F1F2DD7B83D85613BCCAB",
          original: "Bsc"
        }
      ],
      [
        "WAVAX",
        {
          symbol: "WAVAX",
          decimals: 8,
          address: "ibc/2EA2FE172078576E62DA20F14EEED12B26611D93150FE1D68E1AAE00479AC335",
          original: "Avalanche"
        }
      ],
      [
        "USDCavax",
        {
          symbol: "USDC",
          decimals: 6,
          address: "ibc/39913E647C3549D663B1ED7F0745E1779515170C5215B98B2C8410B4C073AD30",
          original: "Avalanche"
        }
      ],
      [
        "WFTM",
        {
          symbol: "WFTM",
          decimals: 8,
          address: "ibc/9EFE5F5D75A87197DD257BA7A96A3BCCEC9DB59D257C742FB5AA9D3DF612D476",
          original: "Fantom"
        }
      ],
      [
        "WSOL",
        {
          symbol: "WSOL",
          decimals: 8,
          address: "ibc/4443218F584A7AB2DFBCF93872D6E5B6967A11C53515DDF45A2CF387C54BD73A",
          original: "Solana"
        }
      ],
      [
        "WETHarbitrum",
        {
          symbol: "WETH",
          decimals: 8,
          address: "ibc/9E2E7B4A53409267CD686F4EB67969C2602A0F5FF9BDB1082B00E71CC4815DDE",
          original: "Arbitrum"
        }
      ],
      [
        "EVMOS",
        {
          symbol: "EVMOS",
          decimals: 18,
          address: "aevmos"
        }
      ]
    ]
  ],
  [
    "Kujira",
    [
      [
        "WETH",
        {
          symbol: "WETH",
          decimals: 8,
          address: "ibc/7D9D28CABB49A4BB1A50C3B7E4544BFDBC5DDFAEB84A7787755A34CE7196CE15",
          original: "Ethereum"
        }
      ],
      [
        "USDCeth",
        {
          symbol: "USDC",
          decimals: 6,
          address: "ibc/C5EADE2C526B9629D230AC02A97644984ACB7C2F9A6C85126D1025CB0DA42588",
          original: "Ethereum"
        }
      ],
      [
        "WBTC",
        {
          symbol: "WBTC",
          decimals: 8,
          address: "ibc/B2C7F21B604E3974A7DA5DAA9395905F2F3C85392F8A221CFDF62E4A9F4E48E4",
          original: "Ethereum"
        }
      ],
      [
        "DAI",
        {
          symbol: "DAI",
          decimals: 8,
          address: "ibc/3CE8A3DE4AE5AE2B4B8C03B2B227CC284732EDC849E506615FF2AA3D8EB1BAFC",
          original: "Ethereum"
        }
      ],
      [
        "WAVAX",
        {
          symbol: "WAVAX",
          decimals: 8,
          address: "ibc/28E7241F6508EB4692C721E91201377323796EF2758CCD83D220A40EAD32601E",
          original: "Avalanche"
        }
      ],
      [
        "USDCavax",
        {
          symbol: "USDC",
          decimals: 6,
          address: "ibc/F9F41DB8DA49EA6AB9EB4B2C9E0ECDC2502ABDA2FE728B85994BF31240CBC163",
          original: "Avalanche"
        }
      ],
      [
        "CELO",
        {
          symbol: "CELO",
          decimals: 8,
          address: "ibc/4ACD155D71182398277CBD2C630A7C8C5F0F16FFF77965FDE4C845A4CDE2D60C",
          original: "Celo"
        }
      ],
      [
        "WGLMR",
        {
          symbol: "WGLMR",
          decimals: 8,
          address: "ibc/3D337ECC89A8421DD6F33C4B7DDE9D4A18D728A4A688BA30E41F466EC8DD3869",
          original: "Moonbeam"
        }
      ],
      [
        "WSOL",
        {
          symbol: "WSOL",
          decimals: 8,
          address: "ibc/E5CA126979E2FFB4C70C072F8094D07ECF27773B37623AD2BF7582AD0726F0F3",
          original: "Solana"
        }
      ],
      [
        "SUI",
        {
          symbol: "SUI",
          decimals: 8,
          address: "ibc/EBA52E7239CC1BC7F8ECF4F41523B6DD477FF067FD953315704A9A4FD2131B48",
          original: "Sui"
        }
      ],
      [
        "KUJI",
        {
          symbol: "KUJI",
          decimals: 6,
          address: "ukuji"
        }
      ]
    ]
  ],
  [
    "Klaytn",
    [
      [
        "KLAY",
        {
          symbol: "KLAY",
          decimals: 18,
          address: "native",
          wrappedKey: "WKLAY"
        }
      ],
      [
        "WKLAY",
        {
          symbol: "WKLAY",
          decimals: 18,
          address: "0xe4f05A66Ec68B54A58B17c22107b02e0232cC817"
        }
      ]
    ]
  ]
], mainnetChainTokens = constMap(mainnetTokenEntries, [0, [1, 2]]), testnetTokenEntries = [
  [
    "Ethereum",
    [
      [
        "ETH",
        {
          symbol: "ETH",
          decimals: 18,
          address: "native",
          wrappedKey: "WETH"
        }
      ],
      [
        "WETH",
        {
          symbol: "WETH",
          decimals: 18,
          address: "0xB4FBF271143F4FBf7B91A5ded31805e42b2208d6"
        }
      ],
      [
        "USDCeth",
        {
          symbol: "USDC",
          decimals: 6,
          address: "0x07865c6e87b9f70255377e024ace6630c1eaa37f"
        }
      ],
      [
        "WBTC",
        {
          symbol: "WBTC",
          decimals: 8,
          address: "0xC04B0d3107736C32e19F1c62b2aF67BE61d63a05"
        }
      ],
      [
        "USDT",
        {
          symbol: "USDT",
          decimals: 6,
          address: "0xC2C527C0CACF457746Bd31B2a698Fe89de2b6d49"
        }
      ],
      [
        "DAI",
        {
          symbol: "DAI",
          decimals: 18,
          address: "0x11fE4B6AE13d2a6055C8D9cF65c55bac32B5d844"
        }
      ],
      [
        "WMATIC",
        {
          symbol: "WMATIC",
          decimals: 18,
          address: "0x7cd0e8ff09cEB653813bD3d63d0554c1CB4BFdf6",
          original: "Polygon"
        }
      ],
      [
        "WBNB",
        {
          symbol: "WBNB",
          decimals: 18,
          address: "0xB19693FEB013Bab65866dE0a845a9511064230cE",
          original: "Bsc"
        }
      ],
      [
        "WAVAX",
        {
          symbol: "WAVAX",
          decimals: 18,
          address: "0x4C1b727f6df3B075E682C41a25687A69846aaC04",
          original: "Avalanche"
        }
      ],
      [
        "USDCavax",
        {
          symbol: "USDC",
          decimals: 6,
          address: "0xF6699D3f725C4b64Cc6010F2DF77B4B05C76Cd5C",
          original: "Avalanche"
        }
      ],
      [
        "WFTM",
        {
          symbol: "WFTM",
          decimals: 18,
          address: "0x0d7A9Cdbb7C21E64825cF81750A5081a32aFb5d4",
          original: "Fantom"
        }
      ],
      [
        "CELO",
        {
          symbol: "CELO",
          decimals: 18,
          address: "0xe092525a787CD56B901279b5864a224c22B95B72",
          original: "Celo"
        }
      ],
      [
        "WGLMR",
        {
          symbol: "WGLMR",
          decimals: 18,
          address: "0x0dc83BB61008A5E1194fe50fA9E474713C1AEcD7",
          original: "Moonbeam"
        }
      ],
      [
        "WSOL",
        {
          symbol: "WSOL",
          decimals: 9,
          address: "0x494701CE895389d917a938f0ea202D4eB9684Eab",
          original: "Solana"
        }
      ],
      [
        "SUI",
        {
          symbol: "SUI",
          decimals: 9,
          address: "0x70F7360C49D227ccBbb98fB7B69B7CDB651195bb",
          original: "Sui"
        }
      ],
      [
        "APT",
        {
          symbol: "APT",
          decimals: 8,
          address: "0xd7A89a8DD20Cb4F252c7FB96B6421b37d82cE506",
          original: "Aptos"
        }
      ],
      [
        "USDCarbitrum",
        {
          symbol: "USDC",
          decimals: 6,
          address: "0xd962F26D93c4eF609Ba00Ed6101326A1490B9489",
          original: "Arbitrum"
        }
      ],
      [
        "WETHbase",
        {
          symbol: "WETH",
          decimals: 18,
          address: "0x76e39239e40857030D6f4D8545EFbd71F904d344",
          original: "Base"
        }
      ],
      [
        "USDCbase",
        {
          symbol: "USDC",
          decimals: 6,
          address: "0x5aA392243437dDC8b4d86bfC90DF296908740A41",
          original: "Base"
        }
      ],
      [
        "tBTC",
        {
          symbol: "tBTC",
          decimals: 18,
          address: "0x679874fBE6D4E7Cc54A59e315FF1eB266686a937"
        }
      ],
      [
        "tBTCarbitrum",
        {
          symbol: "tBTC",
          decimals: 18,
          address: "0x575D93A2278FbF4E8Bd3d51B539a6E237C3F17c5",
          original: "Arbitrum"
        }
      ],
      [
        "tBTCsol",
        {
          symbol: "tBTC",
          decimals: 8,
          address: "0x57A52B6F0b393AF7d36116183cA83E584e636eA4",
          original: "Solana"
        }
      ],
      [
        "wstETH",
        {
          symbol: "wstETH",
          decimals: 18,
          address: "0x6320cD32aA674d2898A68ec82e869385Fc5f7E2f"
        }
      ],
      [
        "SEI",
        {
          symbol: "SEI",
          decimals: 6,
          address: "0xd68df72136207E9471C915cf1B6Cf43D587D4E0A",
          original: "Sei"
        }
      ],
      [
        "WKLAY",
        {
          symbol: "WKLAY",
          decimals: 18,
          address: "0x327e0c7D5cFa65d4f9E358dC9fA4446C49dBcB6C",
          original: "Klaytn"
        }
      ]
    ]
  ],
  [
    "Polygon",
    [
      [
        "WETH",
        {
          symbol: "WETH",
          decimals: 18,
          address: "0xc6735cc74553Cc2caeB9F5e1Ea0A4dAe12ef4632",
          original: "Ethereum"
        }
      ],
      [
        "USDCeth",
        {
          symbol: "USDC",
          decimals: 6,
          address: "0x543237045a106D7fd2eE3e2B44b5728e70BDe9c3",
          original: "Ethereum"
        }
      ],
      [
        "USDT",
        {
          symbol: "USDT",
          decimals: 6,
          address: "0x02E30E84161BE1aBfcBB2b154B11De4C2b5E0a32",
          original: "Ethereum"
        }
      ],
      [
        "DAI",
        {
          symbol: "DAI",
          decimals: 18,
          address: "0x87374d35C5F1bD78c2b1da383F460e154e7D3E5e",
          original: "Ethereum"
        }
      ],
      [
        "MATIC",
        {
          symbol: "MATIC",
          decimals: 18,
          address: "native",
          wrappedKey: "WMATIC"
        }
      ],
      [
        "WMATIC",
        {
          symbol: "WMATIC",
          decimals: 18,
          address: "0x9c3C9283D3e44854697Cd22D3Faa240Cfb032889"
        }
      ],
      [
        "USDCpolygon",
        {
          symbol: "USDC",
          decimals: 6,
          address: "0x9999f7fea5938fd3b1e26a12c3f2fb024e194f97"
        }
      ],
      [
        "WBNB",
        {
          symbol: "WBNB",
          decimals: 18,
          address: "0x0C63D8ADB69204b2946DcB945a6f16d97C255eE2",
          original: "Bsc"
        }
      ],
      [
        "WAVAX",
        {
          symbol: "WAVAX",
          decimals: 18,
          address: "0x51f3D34651523dD8CC4872ee261A1B0B3f73AceF",
          original: "Avalanche"
        }
      ],
      [
        "USDCavax",
        {
          symbol: "USDC",
          decimals: 6,
          address: "0xcc048C353Fdc2f5c378B7BCab9B240Ca2b619f1c",
          original: "Avalanche"
        }
      ],
      [
        "WFTM",
        {
          symbol: "WFTM",
          decimals: 18,
          address: "0x84aa9100a36D6c3514605F62342abF3cE77D5b97",
          original: "Fantom"
        }
      ],
      [
        "CELO",
        {
          symbol: "CELO",
          decimals: 18,
          address: "0xAd027790A64331A11bd1b651739450cC9Dc0098F",
          original: "Celo"
        }
      ],
      [
        "WGLMR",
        {
          symbol: "WGLMR",
          decimals: 18,
          address: "0x693b9AC2199d989bDA8C9C5b5d7A3680B4f40dAa",
          original: "Moonbeam"
        }
      ],
      [
        "WSOL",
        {
          symbol: "WSOL",
          decimals: 9,
          address: "0x0284B4994456Fae4cb56E4d33228d51B674EAD1b",
          original: "Solana"
        }
      ],
      [
        "SUI",
        {
          symbol: "SUI",
          decimals: 9,
          address: "0x3dadA6f29f80A0427C4989E17a5a2ada17441841",
          original: "Sui"
        }
      ],
      [
        "APT",
        {
          symbol: "APT",
          decimals: 8,
          address: "0x226B436043B537BD158e84fA199E2Aa36bf364f8",
          original: "Aptos"
        }
      ],
      [
        "WETHoptimism",
        {
          symbol: "WETH",
          decimals: 18,
          address: "0xC77d781f38Cf52F8Ea0b4c0F22312bB9A34911b5",
          original: "Optimism"
        }
      ],
      [
        "WETHbase",
        {
          symbol: "WETH",
          decimals: 18,
          address: "0x68C4365d5229A44D9A59058B65500365492b5307",
          original: "Base"
        }
      ],
      [
        "tBTC",
        {
          symbol: "tBTC",
          decimals: 18,
          address: "0xf6CC0Cc8D54a4b1A63a0E9745663e0c844Ee4D48",
          original: "Ethereum"
        }
      ],
      [
        "tBTCpolygon",
        {
          symbol: "tBTC",
          decimals: 18,
          address: "0xBcD7917282E529BAA6f232DdDc75F3901245A492"
        }
      ],
      [
        "SEI",
        {
          symbol: "SEI",
          decimals: 6,
          address: "0xc5C0229B38564E1E8083031405Be8d6E6e3Bc462",
          original: "Sei"
        }
      ],
      [
        "WKLAY",
        {
          symbol: "WKLAY",
          decimals: 18,
          address: "0x7b34f3711705eB2963fB856cda063C979de4749e",
          original: "Klaytn"
        }
      ]
    ]
  ],
  [
    "Bsc",
    [
      [
        "WETH",
        {
          symbol: "WETH",
          decimals: 18,
          address: "0x064a85eac6b4Bd7190BCAd3458dBD9459989c37B",
          original: "Ethereum"
        }
      ],
      [
        "USDCeth",
        {
          symbol: "USDC",
          decimals: 6,
          address: "0x861B5C16A2EcED022241072A7beA9D530b99EB6f",
          original: "Ethereum"
        }
      ],
      [
        "USDT",
        {
          symbol: "USDT",
          decimals: 6,
          address: "0xe94AaBAdB6F833f65B8A9AdDD030985B775188c9",
          original: "Ethereum"
        }
      ],
      [
        "DAI",
        {
          symbol: "DAI",
          decimals: 18,
          address: "0x45082C9Fc6BBCa72288F47Fad21dE0BECC75759E",
          original: "Ethereum"
        }
      ],
      [
        "WMATIC",
        {
          symbol: "WMATIC",
          decimals: 18,
          address: "0x7FCDA925f0994121752ca14C334297BeC3d0eA9E",
          original: "Polygon"
        }
      ],
      [
        "BNB",
        {
          symbol: "BNB",
          decimals: 18,
          address: "native",
          wrappedKey: "WBNB"
        }
      ],
      [
        "WBNB",
        {
          symbol: "WBNB",
          decimals: 18,
          address: "0xae13d989daC2f0dEbFf460aC112a837C89BAa7cd"
        }
      ],
      [
        "WAVAX",
        {
          symbol: "WAVAX",
          decimals: 18,
          address: "0x6cE9E2c8b59bbcf65dA375D3d8AB503c8524caf7",
          original: "Avalanche"
        }
      ],
      [
        "USDCavax",
        {
          symbol: "USDC",
          decimals: 6,
          address: "0x1cfeCf72bcBE1E429A21A5B11E708C7c397AaC54",
          original: "Avalanche"
        }
      ],
      [
        "WFTM",
        {
          symbol: "WFTM",
          decimals: 18,
          address: "0x9aB305B792DBdb8253bEE909E7006611Cb45175b",
          original: "Fantom"
        }
      ],
      [
        "CELO",
        {
          symbol: "CELO",
          decimals: 18,
          address: "0x1471698cBD9cAB0228F2EEA9303A2b3aA0ABDC2B",
          original: "Celo"
        }
      ],
      [
        "WGLMR",
        {
          symbol: "WGLMR",
          decimals: 18,
          address: "0x5C31B36599ED7f06b09c0ffC7A2F928cE496F046",
          original: "Moonbeam"
        }
      ],
      [
        "WSOL",
        {
          symbol: "WSOL",
          decimals: 9,
          address: "0x30f19eBba919954FDc020B8A20aEF13ab5e02Af0",
          original: "Solana"
        }
      ],
      [
        "USDCsol",
        {
          symbol: "USDC",
          decimals: 6,
          address: "0x51a3cc54eA30Da607974C5D07B8502599801AC08",
          original: "Solana"
        }
      ],
      [
        "SUI",
        {
          symbol: "SUI",
          decimals: 9,
          address: "0x5A73D76e09Af2E428EC64aE10F91B78AC990B298",
          original: "Sui"
        }
      ],
      [
        "APT",
        {
          symbol: "APT",
          decimals: 8,
          address: "0x4A7Bd5E135f421057F97BbA8BCeeE5c18334f454",
          original: "Aptos"
        }
      ],
      [
        "WETHarbitrum",
        {
          symbol: "WETH",
          decimals: 18,
          address: "0x60845E2503Fcd945b3A6f0bC077a31CC913E654D",
          original: "Arbitrum"
        }
      ],
      [
        "USDCarbitrum",
        {
          symbol: "USDC",
          decimals: 6,
          address: "0xe3aA397cb6d93Cce4fAd9Cc9E796CCa5E50FB5ED",
          original: "Arbitrum"
        }
      ],
      [
        "WETHbase",
        {
          symbol: "WETH",
          decimals: 18,
          address: "0x63108fC941F3cCE0B484De19746B5Af949EAF6eE",
          original: "Base"
        }
      ],
      [
        "tBTC",
        {
          symbol: "tBTC",
          decimals: 18,
          address: "0xE7176110261ef2FfC885dd568C1093f58F0aEee9",
          original: "Ethereum"
        }
      ],
      [
        "SEI",
        {
          symbol: "SEI",
          decimals: 6,
          address: "0x79A8FFFCED130314eCC8782C846c4d8d4867A900",
          original: "Sei"
        }
      ],
      [
        "WKLAY",
        {
          symbol: "WKLAY",
          decimals: 18,
          address: "0x79D34FDb686B5D139949E4F92D83EEe376489176",
          original: "Klaytn"
        }
      ]
    ]
  ],
  [
    "Avalanche",
    [
      [
        "WETH",
        {
          symbol: "WETH",
          decimals: 18,
          address: "0xbB5A2dC896Ec4E2fa77F40FA630582ed9c6D0172",
          original: "Ethereum"
        }
      ],
      [
        "USDCeth",
        {
          symbol: "USDC",
          decimals: 6,
          address: "0x63A30f239DC8d1c17Bf6653a68Fc6C2F83641E6d",
          original: "Ethereum"
        }
      ],
      [
        "DAI",
        {
          symbol: "DAI",
          decimals: 18,
          address: "0x3989C9c4bdd30400E6Aa90990683EAd6a1638A16",
          original: "Ethereum"
        }
      ],
      [
        "WMATIC",
        {
          symbol: "WMATIC",
          decimals: 18,
          address: "0x78554394273957d7e55afC841aeA27Cce469AEd4",
          original: "Polygon"
        }
      ],
      [
        "WBNB",
        {
          symbol: "WBNB",
          decimals: 18,
          address: "0x10F1053bF2884b28ee0Bd7a2dDBa237Af3511d29",
          original: "Bsc"
        }
      ],
      [
        "AVAX",
        {
          symbol: "AVAX",
          decimals: 18,
          address: "native",
          wrappedKey: "WAVAX"
        }
      ],
      [
        "WAVAX",
        {
          symbol: "WAVAX",
          decimals: 18,
          address: "0xd00ae08403B9bbb9124bB305C09058E32C39A48c"
        }
      ],
      [
        "USDCavax",
        {
          symbol: "USDC",
          decimals: 6,
          address: "0x5425890298aed601595a70AB815c96711a31Bc65"
        }
      ],
      [
        "WFTM",
        {
          symbol: "WFTM",
          decimals: 18,
          address: "0x094cB577C21Ab1360178beE74B9591fa12216dAD",
          original: "Fantom"
        }
      ],
      [
        "CELO",
        {
          symbol: "CELO",
          decimals: 18,
          address: "0xC66d9c2b33c347d4A4441975f4688fcD5DD4c441",
          original: "Celo"
        }
      ],
      [
        "WGLMR",
        {
          symbol: "WGLMR",
          decimals: 18,
          address: "0xf080782DF38eD5228D2FC2882d13D56c8f1D6f21",
          original: "Moonbeam"
        }
      ],
      [
        "WSOL",
        {
          symbol: "WSOL",
          decimals: 9,
          address: "0xb10563644a6AB8948ee6d7f5b0a1fb15AaEa1E03",
          original: "Solana"
        }
      ],
      [
        "SUI",
        {
          symbol: "SUI",
          decimals: 9,
          address: "0xfc5128F8556a6F059466E67740e6cC31EE5C2C47",
          original: "Sui"
        }
      ],
      [
        "APT",
        {
          symbol: "APT",
          decimals: 8,
          address: "0x996a3f12C1FcD7339Ea8801f629201e4d42EAD04",
          original: "Aptos"
        }
      ],
      [
        "WETHarbitrum",
        {
          symbol: "WETH",
          decimals: 18,
          address: "0x36Bd1562F874941eE62Ebb2b3A45B4A88A9df90e",
          original: "Arbitrum"
        }
      ],
      [
        "WETHoptimism",
        {
          symbol: "WETH",
          decimals: 18,
          address: "0x301587BF484756441de43E522027e3751871237B",
          original: "Optimism"
        }
      ],
      [
        "WETHbase",
        {
          symbol: "WETH",
          decimals: 18,
          address: "0xc07c754ef7473d315D973F7D9F7858C2eCe0a0a6",
          original: "Base"
        }
      ],
      [
        "tBTC",
        {
          symbol: "tBTC",
          decimals: 18,
          address: "0x7E1779F65B644E5f98DdC4D2cB0A0106a7E6d9e1",
          original: "Ethereum"
        }
      ],
      [
        "tBTCarbitrum",
        {
          symbol: "tBTC",
          decimals: 18,
          address: "0x4beDc7471374d7479120E44ea9593eBB85f48AD9",
          original: "Arbitrum"
        }
      ],
      [
        "SEI",
        {
          symbol: "SEI",
          decimals: 6,
          address: "0xfe2eCDD1708aaebf1cF802C6124fAFb18B22dfEE",
          original: "Sei"
        }
      ]
    ]
  ],
  [
    "Fantom",
    [
      [
        "WETH",
        {
          symbol: "WETH",
          decimals: 18,
          address: "0x758FEebDDeC06f4bCcEc8F756C8efBD35d5b7124",
          original: "Ethereum"
        }
      ],
      [
        "USDCeth",
        {
          symbol: "USDC",
          decimals: 6,
          address: "0xDF7928AF5B33F7de592594958D8d6Ff8472Eb407",
          original: "Ethereum"
        }
      ],
      [
        "USDT",
        {
          symbol: "USDT",
          decimals: 6,
          address: "0x32eF19C4b3DF65a24972A489e70AdDef5E54262C",
          original: "Ethereum"
        }
      ],
      [
        "DAI",
        {
          symbol: "DAI",
          decimals: 18,
          address: "0xE4FE5DF2084f9D81595e4fcba2399020FBE7b233",
          original: "Ethereum"
        }
      ],
      [
        "WMATIC",
        {
          symbol: "WMATIC",
          decimals: 18,
          address: "0x47a4C4c0f96D6CBe5b5C0A46CB0E22d6A17F1430",
          original: "Polygon"
        }
      ],
      [
        "WBNB",
        {
          symbol: "WBNB",
          decimals: 18,
          address: "0xfB174b43228950C2055CFc25AE93f2DCe8E2beF0",
          original: "Bsc"
        }
      ],
      [
        "WAVAX",
        {
          symbol: "WAVAX",
          decimals: 18,
          address: "0x0f545Be981C37fB15ab7c65404648761e99016e4",
          original: "Avalanche"
        }
      ],
      [
        "USDCavax",
        {
          symbol: "USDC",
          decimals: 6,
          address: "0x6BC4E8D8c1d54656D1DeBCa96efc53aFd1408aD2",
          original: "Avalanche"
        }
      ],
      [
        "FTM",
        {
          symbol: "FTM",
          decimals: 18,
          address: "native",
          wrappedKey: "WFTM"
        }
      ],
      [
        "WFTM",
        {
          symbol: "WFTM",
          decimals: 18,
          address: "0xf1277d1Ed8AD466beddF92ef448A132661956621"
        }
      ],
      [
        "CELO",
        {
          symbol: "CELO",
          decimals: 18,
          address: "0xB18E73a69c3Aaea39a610372537Cf8482622d199",
          original: "Celo"
        }
      ],
      [
        "WGLMR",
        {
          symbol: "WGLMR",
          decimals: 18,
          address: "0x41E3CFDFC255A4bF3C8D3560Bc8D3D9b5080338e",
          original: "Moonbeam"
        }
      ],
      [
        "WSOL",
        {
          symbol: "WSOL",
          decimals: 9,
          address: "0xED1a08Fc69A7008d225890A96aaE258c465CC7ad",
          original: "Solana"
        }
      ],
      [
        "SUI",
        {
          symbol: "SUI",
          decimals: 9,
          address: "0xd882AB49372eC093E8697B5153f54ab5e7738e3b",
          original: "Sui"
        }
      ],
      [
        "APT",
        {
          symbol: "APT",
          decimals: 8,
          address: "0xAb2297E8994149BA91737944E40891881aF762a4",
          original: "Aptos"
        }
      ],
      [
        "WETHarbitrum",
        {
          symbol: "WETH",
          decimals: 18,
          address: "0x456e08952f9091B6c268dC0cECad53d141152C59",
          original: "Arbitrum"
        }
      ],
      [
        "USDCoptimism",
        {
          symbol: "USDC",
          decimals: 6,
          address: "0x685B29e17440c42758Ab3F80FD3603EF01bebe9A",
          original: "Optimism"
        }
      ],
      [
        "WETHbase",
        {
          symbol: "WETH",
          decimals: 18,
          address: "0x01950A33DfFa63E6Bc23b5dB440505581A4cc0e7",
          original: "Base"
        }
      ],
      [
        "tBTC",
        {
          symbol: "tBTC",
          decimals: 18,
          address: "0x66E080407407620844fE2083c33108BE55E087bc",
          original: "Ethereum"
        }
      ],
      [
        "SEI",
        {
          symbol: "SEI",
          decimals: 6,
          address: "0x832e8050D6c64724500DE9B0ffe1CAc6c570a26d",
          original: "Sei"
        }
      ]
    ]
  ],
  [
    "Celo",
    [
      [
        "WETH",
        {
          symbol: "WETH",
          decimals: 18,
          address: "0x898471a82737dFFfB61915F9e8381e279076D72b",
          original: "Ethereum"
        }
      ],
      [
        "USDCeth",
        {
          symbol: "USDC",
          decimals: 6,
          address: "0xB0524bEF6c61c6150B340b2828a890fD8dEa60C0",
          original: "Ethereum"
        }
      ],
      [
        "DAI",
        {
          symbol: "DAI",
          decimals: 18,
          address: "0xeBB3fF6E5d61d3793Fdb60f7942BA78E636019f6",
          original: "Ethereum"
        }
      ],
      [
        "WMATIC",
        {
          symbol: "WMATIC",
          decimals: 18,
          address: "0x7a56409988BBF8758b3ba412b9c7E3FE504C8544",
          original: "Polygon"
        }
      ],
      [
        "WBNB",
        {
          symbol: "WBNB",
          decimals: 18,
          address: "0xa8050be9389466c3c524F10F131f244ACbf21A0D",
          original: "Bsc"
        }
      ],
      [
        "WAVAX",
        {
          symbol: "WAVAX",
          decimals: 18,
          address: "0x502c8C83008D9Dd812a7C5fB886C063060C73Dbf",
          original: "Avalanche"
        }
      ],
      [
        "USDCavax",
        {
          symbol: "USDC",
          decimals: 6,
          address: "0xDDB349c976cA2C873644F21f594767Eb5390C831",
          original: "Avalanche"
        }
      ],
      [
        "WFTM",
        {
          symbol: "WFTM",
          decimals: 18,
          address: "0xE6F8710cA14CFe7F5aAAD3A799C3d1D92dCba938",
          original: "Fantom"
        }
      ],
      [
        "CELO",
        {
          symbol: "CELO",
          decimals: 18,
          address: "0xF194afDf50B03e69Bd7D057c1Aa9e10c9954E4C9"
        }
      ],
      [
        "WGLMR",
        {
          symbol: "WGLMR",
          decimals: 18,
          address: "0x132D2172D89cd9CfD480A8887c6bF92360fB460e",
          original: "Moonbeam"
        }
      ],
      [
        "WSOL",
        {
          symbol: "WSOL",
          decimals: 9,
          address: "0x05EEF2AE1A7A938D78598F7d9e8b97A9bED0c9eC",
          original: "Solana"
        }
      ],
      [
        "SUI",
        {
          symbol: "SUI",
          decimals: 9,
          address: "0xa40d9E69ca9867C4bFbeC11Ce79C939991e9bf26",
          original: "Sui"
        }
      ],
      [
        "APT",
        {
          symbol: "APT",
          decimals: 8,
          address: "0xAC0a2fF7DD597de863878a3372142b07B614C125",
          original: "Aptos"
        }
      ],
      [
        "USDCarbitrum",
        {
          symbol: "USDC",
          decimals: 6,
          address: "0x0C4AbF95Ff3d82d1F02f55e65050eA5bA062606E",
          original: "Arbitrum"
        }
      ],
      [
        "WETHoptimism",
        {
          symbol: "WETH",
          decimals: 18,
          address: "0x28E768a51D19dcB753a24B79D1e89c92fee094Ba",
          original: "Optimism"
        }
      ],
      [
        "tBTC",
        {
          symbol: "tBTC",
          decimals: 18,
          address: "0x01a050Fc725F4E99aAD43Eb6f8481f38ee6231aD",
          original: "Ethereum"
        }
      ],
      [
        "SEI",
        {
          symbol: "SEI",
          decimals: 6,
          address: "0x05Efb4aC79ef48a4830f517834c6f5f039F16832",
          original: "Sei"
        }
      ]
    ]
  ],
  [
    "Moonbeam",
    [
      [
        "WETH",
        {
          symbol: "WETH",
          decimals: 18,
          address: "0xd27d8883E31FAA11B2613b14BE83ad8951C8783C",
          original: "Ethereum"
        }
      ],
      [
        "USDCeth",
        {
          symbol: "USDC",
          decimals: 6,
          address: "0xE5dE10C4b744bac6b783fAF8d9B9fDFF14Acc3c9",
          original: "Ethereum"
        }
      ],
      [
        "USDT",
        {
          symbol: "USDT",
          decimals: 6,
          address: "0x7f5Ca1bcFb38fDF4c0E0646FCbf3FA87740ff65D",
          original: "Ethereum"
        }
      ],
      [
        "DAI",
        {
          symbol: "DAI",
          decimals: 18,
          address: "0xc31EC0108D8e886be58808B4C2C53f8365f1885D",
          original: "Ethereum"
        }
      ],
      [
        "WMATIC",
        {
          symbol: "WMATIC",
          decimals: 18,
          address: "0xD2888f015BcB76CE3d27b6024cdEFA16836d0dbb",
          original: "Polygon"
        }
      ],
      [
        "WBNB",
        {
          symbol: "WBNB",
          decimals: 18,
          address: "0x6097E80331B0c6aF4F74D7F2363E70Cb2Fd078A5",
          original: "Bsc"
        }
      ],
      [
        "WAVAX",
        {
          symbol: "WAVAX",
          decimals: 18,
          address: "0x2E8afeCC19842229358f3650cc3F091908dcbaB4",
          original: "Avalanche"
        }
      ],
      [
        "USDCavax",
        {
          symbol: "USDC",
          decimals: 6,
          address: "0x6533CE14804D113b1F494dC56c5D60A43cb5C3b5",
          original: "Avalanche"
        }
      ],
      [
        "WFTM",
        {
          symbol: "WFTM",
          decimals: 18,
          address: "0x566c1cebc6A4AFa1C122E039C4BEBe77043148Ee",
          original: "Fantom"
        }
      ],
      [
        "CELO",
        {
          symbol: "CELO",
          decimals: 18,
          address: "0x3406a9b09adf0cb36DC04c1523C4b294C6b79513",
          original: "Celo"
        }
      ],
      [
        "GLMR",
        {
          symbol: "GLMR",
          decimals: 18,
          address: "native",
          wrappedKey: "WGLMR"
        }
      ],
      [
        "WGLMR",
        {
          symbol: "WGLMR",
          decimals: 18,
          address: "0xD909178CC99d318e4D46e7E66a972955859670E1"
        }
      ],
      [
        "SUI",
        {
          symbol: "SUI",
          decimals: 9,
          address: "0x2ed4B5B1071A3C676664E9085C0e3826542C1b27",
          original: "Sui"
        }
      ],
      [
        "APT",
        {
          symbol: "APT",
          decimals: 8,
          address: "0xCaa2A1d3BbbA0D1466571e83b4E2CbE04252593D",
          original: "Aptos"
        }
      ],
      [
        "WETHarbitrum",
        {
          symbol: "WETH",
          decimals: 18,
          address: "0x15025b956969DD8F1d0CD69959Ad97128F8f6D69",
          original: "Arbitrum"
        }
      ],
      [
        "USDCoptimism",
        {
          symbol: "USDC",
          decimals: 6,
          address: "0xf98E630a3DD4F21Cab7a37Bb01209cb62959169D",
          original: "Optimism"
        }
      ],
      [
        "USDCbase",
        {
          symbol: "USDC",
          decimals: 6,
          address: "0x7480641F5B00b4Fc39d6AaeC4Cd851EdEA7f31CF",
          original: "Base"
        }
      ],
      [
        "tBTC",
        {
          symbol: "tBTC",
          decimals: 18,
          address: "0xf82E21cE03471983Afb9c2E3789Aa13a2d7242E8",
          original: "Ethereum"
        }
      ],
      [
        "SEI",
        {
          symbol: "SEI",
          decimals: 6,
          address: "0x1EdDe35B7e058194B457B8621285EaFA710f01ea",
          original: "Sei"
        }
      ]
    ]
  ],
  [
    "Solana",
    [
      [
        "WETH",
        {
          symbol: "WETH",
          decimals: 8,
          address: "7VPWjBhCXrpYYBiRKZh1ubh9tLZZNkZGp2ReRphEV4Mc",
          original: "Ethereum"
        }
      ],
      [
        "USDCeth",
        {
          symbol: "USDC",
          decimals: 6,
          address: "2BAqec7Qof3Y7VJatwFsRHUNSQBSkzaEsT1V5bW6dbZY",
          original: "Ethereum"
        }
      ],
      [
        "DAI",
        {
          symbol: "DAI",
          decimals: 8,
          address: "3WK3mEDNPrNuQReBvM28NcsqrExMnPxD9pPJmgrUeKKH",
          original: "Ethereum"
        }
      ],
      [
        "WMATIC",
        {
          symbol: "WMATIC",
          decimals: 8,
          address: "ACbmcQxbbhiXWM1GmapUSMmBYKMvnFLfAAXKqdo8xKwo",
          original: "Polygon"
        }
      ],
      [
        "WBNB",
        {
          symbol: "WBNB",
          decimals: 8,
          address: "BaGfF51MQ3a61papTRDYaNefBgTQ9ywnVne5fCff4bxT",
          original: "Bsc"
        }
      ],
      [
        "WAVAX",
        {
          symbol: "WAVAX",
          decimals: 8,
          address: "3Ftc5hTz9sG4huk79onufGiebJNDMZNL8HYgdMJ9E7JR",
          original: "Avalanche"
        }
      ],
      [
        "USDCavax",
        {
          symbol: "USDC",
          decimals: 6,
          address: "GQtMXZxnuacCFTXVeTvyHi6P9F6chbtzhVc8JgD8hv7c",
          original: "Avalanche"
        }
      ],
      [
        "WFTM",
        {
          symbol: "WFTM",
          decimals: 8,
          address: "DMw2tLaq1bVoAEKtkoUtieSk9bfCPUvubYLatTMsSVop",
          original: "Fantom"
        }
      ],
      [
        "CELO",
        {
          symbol: "CELO",
          decimals: 8,
          address: "84F2QX9278ToDmA98u4A86xSV9hz1ovazr8zwGaX6qjS",
          original: "Celo"
        }
      ],
      [
        "WGLMR",
        {
          symbol: "WGLMR",
          decimals: 8,
          address: "8987WGkYa5viiZ9DD8sS3PB5XghKmWjkEgmzvwDuoAEc",
          original: "Moonbeam"
        }
      ],
      [
        "SOL",
        {
          symbol: "SOL",
          decimals: 9,
          address: "native",
          wrappedKey: "WSOL"
        }
      ],
      [
        "WSOL",
        {
          symbol: "WSOL",
          decimals: 9,
          address: "So11111111111111111111111111111111111111112"
        }
      ],
      [
        "USDCsol",
        {
          symbol: "USDC",
          decimals: 6,
          address: "4zMMC9srt5Ri5X14GAgXhaHii3GnPAEERYPJgZJDncDU"
        }
      ],
      [
        "SUI",
        {
          symbol: "SUI",
          decimals: 8,
          address: "BJZ72CjPQojVoH68mzrd4VQ4nr6KuhbAGnhZEZCujKxY",
          original: "Sui"
        }
      ],
      [
        "APT",
        {
          symbol: "APT",
          decimals: 8,
          address: "7EvFD3JKCJVdtkAYdaSVKJsrPEJCzy2neJha7TREGrCa",
          original: "Aptos"
        }
      ],
      [
        "WETHbase",
        {
          symbol: "WETH",
          decimals: 8,
          address: "EKZqcBZ3Y7YTDinpecA7SxRp9B4s1m99VHJ9jpvyTwzW",
          original: "Base"
        }
      ],
      [
        "tBTC",
        {
          symbol: "tBTC",
          decimals: 8,
          address: "FMYvcyMJJ22whB9m3T5g1oPKwM6jpLnFBXnrY6eXmCrp",
          original: "Ethereum"
        }
      ],
      [
        "tBTCoptimism",
        {
          symbol: "tBTC",
          decimals: 8,
          address: "HsPvRT3J7kuitNvNHogyZeSEagcqAqwwq2FPgrGfgApy",
          original: "Optimism"
        }
      ],
      [
        "tBTCsol",
        {
          symbol: "tBTC",
          decimals: 8,
          address: "6DNSN2BJsaPFdFFc1zP37kkeNe4Usc1Sqkzr9C9vPWcU"
        }
      ],
      [
        "SEI",
        {
          symbol: "SEI",
          decimals: 6,
          address: "8LFdfuhbfdH8oBzSKDgfPAxvLW24dCM9ttjBrBobURuk",
          original: "Sei"
        }
      ]
    ]
  ],
  [
    "Sui",
    [
      [
        "WETH",
        {
          symbol: "WETH",
          decimals: 8,
          address: "0x72831f626b1f0e11be201893d5cb641917730b1ccac778e4a77f8ab2052f0784::coin::COIN",
          original: "Ethereum"
        }
      ],
      [
        "USDCeth",
        {
          symbol: "USDC",
          decimals: 6,
          address: "0x9e4396c19ec1c5f2214c79d3af3f31e59869640305560f8f2499c36fa9c8e0f2::coin::COIN",
          original: "Ethereum"
        }
      ],
      [
        "DAI",
        {
          symbol: "DAI",
          decimals: 8,
          address: "0xe6fc78aa2b52b785bdcb67901cd85793a0b593248f315cb755974d23d0fcb837::coin::COIN",
          original: "Ethereum"
        }
      ],
      [
        "WMATIC",
        {
          symbol: "WMATIC",
          decimals: 8,
          address: "0xa516bcbf83b29a2944bb53ec9f934ea7d78c3626d3ae411d2fb9dcb977522e67::coin::COIN",
          original: "Polygon"
        }
      ],
      [
        "WBNB",
        {
          symbol: "WBNB",
          decimals: 8,
          address: "0xddcf8680a8a4b8a527d8c85ec203274991590c2ea898d1c4635b70164d9c584b::coin::COIN",
          original: "Bsc"
        }
      ],
      [
        "WAVAX",
        {
          symbol: "WAVAX",
          decimals: 8,
          address: "0xa600741c469fb57ed01497ddf101e798fa79a9c529bd176675c5c4d970811f80::coin::COIN",
          original: "Avalanche"
        }
      ],
      [
        "USDCavax",
        {
          symbol: "USDC",
          decimals: 6,
          address: "0x2aa8c885d04e676c4e87b7d0f94d4f3b243b1b5d93239d1cc41d5528ce1714c1::coin::COIN",
          original: "Avalanche"
        }
      ],
      [
        "WFTM",
        {
          symbol: "WFTM",
          decimals: 8,
          address: "0x14e756ff65e0ac810a5f69ca5276ef5b899a6df3c4717de1f85559d8b5ae6ea6::coin::COIN",
          original: "Fantom"
        }
      ],
      [
        "CELO",
        {
          symbol: "CELO",
          decimals: 8,
          address: "0x81868174a6b11e1acc337b3414f9912455435d486609fb8d50b34312865085f2::coin::COIN",
          original: "Celo"
        }
      ],
      [
        "WGLMR",
        {
          symbol: "WGLMR",
          decimals: 8,
          address: "0xeffae382de96981f7ddd2d294429924827e8f325d612487a12d6a0b249171002::coin::COIN",
          original: "Moonbeam"
        }
      ],
      [
        "WSOL",
        {
          symbol: "WSOL",
          decimals: 8,
          address: "0xbc03aaab4c11eb84df8bf39fdc714fa5d5b65b16eb7d155e22c74a68c8d4e17f::coin::COIN",
          original: "Solana"
        }
      ],
      [
        "SUI",
        {
          symbol: "SUI",
          decimals: 9,
          address: "0x2::sui::SUI"
        }
      ],
      [
        "APT",
        {
          symbol: "APT",
          decimals: 8,
          address: "0x812d6feb8b84e55d47a0bfcae9fb6a4e7e09be5ec86ce0a729e0f67d5f59f477::coin::COIN",
          original: "Aptos"
        }
      ],
      [
        "USDCoptimism",
        {
          symbol: "USDC",
          decimals: 6,
          address: "0xbbc39df58a11072ceeac1f685393ca912d1a1bfd6e772053ec5a544f36124da::coin::COIN",
          original: "Optimism"
        }
      ],
      [
        "WETHbase",
        {
          symbol: "WETH",
          decimals: 8,
          address: "0x7b442b988864149dedfb9b6a75a88c7c33b9ddd3d15a87bf25104e1fcdd680ab::coin::COIN",
          original: "Base"
        }
      ],
      [
        "USDCbase",
        {
          symbol: "USDC",
          decimals: 6,
          address: "0x4125940814a0ca87465a1a59092a7344633ad03b48ad7cda36d799d8558012c1::coin::COIN",
          original: "Base"
        }
      ],
      [
        "tBTC",
        {
          symbol: "tBTC",
          decimals: 8,
          address: "0xacf6784120b221a077ab0b84acc0b76930779eb55f157ea2492be4a60b808f6::coin::COIN",
          original: "Ethereum"
        }
      ],
      [
        "SEI",
        {
          symbol: "SEI",
          decimals: 6,
          address: "0x22c5cdaabaae4b6d3351f9bba9511b0aebb0662a6c209a360f0776e1e77a8438::coin::COIN",
          original: "Sei"
        }
      ]
    ]
  ],
  [
    "Aptos",
    [
      [
        "WETH",
        {
          symbol: "WETH",
          decimals: 8,
          address: "0x381775005cb32cdd3dbf935ae1b978ed40d309c72b009cd4a812aab6d991418a::coin::T",
          original: "Ethereum"
        }
      ],
      [
        "WMATIC",
        {
          symbol: "WMATIC",
          decimals: 8,
          address: "0x5f229253e2b2d03fb909f565feca49452582bd633a5816e5ce30aa593cb49d8a::coin::T",
          original: "Polygon"
        }
      ],
      [
        "WBNB",
        {
          symbol: "WBNB",
          decimals: 8,
          address: "0xa5894f5ddb8647e6143102aa336ff07374f7b32e88c1c703aef5b7c9a370bf80::coin::T",
          original: "Bsc"
        }
      ],
      [
        "WAVAX",
        {
          symbol: "WAVAX",
          decimals: 8,
          address: "0xbe8f4301c0b54e870902b9a23eeb95ce74ac190531782aa3262337ceb145401a::coin::T",
          original: "Avalanche"
        }
      ],
      [
        "USDCavax",
        {
          symbol: "USDC",
          decimals: 6,
          address: "0x02ef7697bdb33361ca39d228671203afc0dea3202e792d79d2072b761d87c834::coin::T",
          original: "Avalanche"
        }
      ],
      [
        "WFTM",
        {
          symbol: "WFTM",
          decimals: 8,
          address: "0x533c6ade00d15d1e014c41e29e34853e87df92c4e01a6a3f41318dbd098048d6::coin::T",
          original: "Fantom"
        }
      ],
      [
        "CELO",
        {
          symbol: "CELO",
          decimals: 8,
          address: "0xecbb0f7e7d049499ca83ca1358344f56557886f6f7adc740d6734cce7bfc9a14::coin::T",
          original: "Celo"
        }
      ],
      [
        "WGLMR",
        {
          symbol: "WGLMR",
          decimals: 8,
          address: "0x338373b6694f71dbeac5ca4a30503bf5f083888d71678aed31255de416be37c0::coin::T",
          original: "Moonbeam"
        }
      ],
      [
        "WSOL",
        {
          symbol: "WSOL",
          decimals: 8,
          address: "0xdd89c0e695df0692205912fb69fc290418bed0dbe6e4573d744a6d5e6bab6c13::coin::T",
          original: "Solana"
        }
      ],
      [
        "SUI",
        {
          symbol: "SUI",
          decimals: 8,
          address: "0x7b22d0e02f653d4fd1caddcfa4719a2b329da56eb81d8f27db703f02466c26a5::coin::T",
          original: "Sui"
        }
      ],
      [
        "APT",
        {
          symbol: "APT",
          decimals: 8,
          address: "0x1::aptos_coin::AptosCoin"
        }
      ],
      [
        "USDCarbitrum",
        {
          symbol: "USDC",
          decimals: 6,
          address: "0x3f0fdd44d96dae888d6c576218cf655458316a27c7bdc46537f61e531b10d3df::coin::T",
          original: "Arbitrum"
        }
      ],
      [
        "USDCoptimism",
        {
          symbol: "USDC",
          decimals: 6,
          address: "0xcff1d9820851201436ad225dcc4374a2d15f52a74109283eb9881be799677e92::coin::T",
          original: "Optimism"
        }
      ],
      [
        "WETHbase",
        {
          symbol: "WETH",
          decimals: 8,
          address: "0x5b5f14781164cf77185a7b6acd8e4f3cbb7e7cfb1cd5760d2b8af81075fc153d::coin::T",
          original: "Base"
        }
      ],
      [
        "USDCbase",
        {
          symbol: "USDC",
          decimals: 6,
          address: "0xcfaabb3cb08ad612905dd6b2593d044ce857dfe5360148333b4635fb57d4d13f::coin::T",
          original: "Base"
        }
      ],
      [
        "tBTC",
        {
          symbol: "tBTC",
          decimals: 8,
          address: "0x6e2d5d1a6d6d0e0c5db506ce64ead0530847a48b96516abbb08cdebe43fe3036::coin::T",
          original: "Ethereum"
        }
      ],
      [
        "SEI",
        {
          symbol: "SEI",
          decimals: 6,
          address: "0xcae0ba0b7a435730ab65f1c8357d213e5cf9d4b377b96761745a8edaf9c9df6d::coin::T",
          original: "Sei"
        }
      ]
    ]
  ],
  [
    "Base",
    [
      [
        "WETH",
        {
          symbol: "WETH",
          decimals: 18,
          address: "0x44D627f900da8AdaC7561bD73aA745F132450798",
          original: "Ethereum"
        }
      ],
      [
        "USDCeth",
        {
          symbol: "USDC",
          decimals: 6,
          address: "0x5010B0988a035915C91a2a432085824FcB3D8d3f",
          original: "Ethereum"
        }
      ],
      [
        "DAI",
        {
          symbol: "DAI",
          decimals: 18,
          address: "0x31B2BAEE47Dc5Fc06baEC1BF73C124031b44fB97",
          original: "Ethereum"
        }
      ],
      [
        "WMATIC",
        {
          symbol: "WMATIC",
          decimals: 18,
          address: "0xFFB5d863d5132523d013338845A1Bb01EDd440f4",
          original: "Polygon"
        }
      ],
      [
        "WBNB",
        {
          symbol: "WBNB",
          decimals: 18,
          address: "0x9DeF11E63C23c71dE3716b81dD2Fdad2B24b8b7F",
          original: "Bsc"
        }
      ],
      [
        "WAVAX",
        {
          symbol: "WAVAX",
          decimals: 18,
          address: "0x410B0EE532EFfB18fa4d90cc095B1CD58aC43d5a",
          original: "Avalanche"
        }
      ],
      [
        "USDCavax",
        {
          symbol: "USDC",
          decimals: 6,
          address: "0x4C5208246676486064c501E1DAF2dD21596Bc5f5",
          original: "Avalanche"
        }
      ],
      [
        "WFTM",
        {
          symbol: "WFTM",
          decimals: 18,
          address: "0xB4808E58713112AbAbB8167C7187F8988df38bbD",
          original: "Fantom"
        }
      ],
      [
        "CELO",
        {
          symbol: "CELO",
          decimals: 18,
          address: "0x72C56041ea5fe8bDE99b2A123fb5964cDE8C7FE9",
          original: "Celo"
        }
      ],
      [
        "WGLMR",
        {
          symbol: "WGLMR",
          decimals: 18,
          address: "0xCEc03b5710a464F4354AF35ebD0310238F656DFf",
          original: "Moonbeam"
        }
      ],
      [
        "WSOL",
        {
          symbol: "WSOL",
          decimals: 9,
          address: "0x6Fb1dE2372e48fe66c84cf37cc2fb54EaEe62988",
          original: "Solana"
        }
      ],
      [
        "SUI",
        {
          symbol: "SUI",
          decimals: 9,
          address: "0xEe0fC8BECD593B41AACBd93936fDAbc2A444370A",
          original: "Sui"
        }
      ],
      [
        "APT",
        {
          symbol: "APT",
          decimals: 8,
          address: "0xd934A15FfA3945DD0Ba2cb7b4174024261A14874",
          original: "Aptos"
        }
      ],
      [
        "WETHarbitrum",
        {
          symbol: "WETH",
          decimals: 18,
          address: "0x8eD43aBdc4f836aa60933177B31AC358ea09f27E",
          original: "Arbitrum"
        }
      ],
      [
        "WETHoptimism",
        {
          symbol: "WETH",
          decimals: 18,
          address: "0x5c443C05C72F0660502d88642c807020cc9b71A2",
          original: "Optimism"
        }
      ],
      [
        "ETHbase",
        {
          symbol: "ETH",
          decimals: 18,
          address: "native",
          wrappedKey: "WETHbase"
        }
      ],
      [
        "WETHbase",
        {
          symbol: "WETH",
          decimals: 18,
          address: "0x4200000000000000000000000000000000000006"
        }
      ],
      [
        "USDCbase",
        {
          symbol: "USDC",
          decimals: 6,
          address: "0xf175520c52418dfe19c8098071a252da48cd1c19"
        }
      ],
      [
        "tBTC",
        {
          symbol: "tBTC",
          decimals: 18,
          address: "0x0219441240d89fAc3fD708d06d8fD3A072C02FB6",
          original: "Ethereum"
        }
      ],
      [
        "tBTCbase",
        {
          symbol: "tBTC",
          decimals: 18,
          address: "0x783349cd20f26CE12e747b1a17bC38D252c9e119"
        }
      ],
      [
        "tBTCsol",
        {
          symbol: "tBTC",
          decimals: 8,
          address: "0x9dA16Ae62De05bcb4606c4BFbB54046872501Bd0",
          original: "Solana"
        }
      ],
      [
        "SEI",
        {
          symbol: "SEI",
          decimals: 6,
          address: "0x7B5edB2B3d2BeA8057a736B82AC6EF35c70bdadD",
          original: "Sei"
        }
      ]
    ]
  ],
  [
    "Sei",
    [
      [
        "WETH",
        {
          symbol: "WETH",
          decimals: 8,
          address: "sei13pzlt9etk44hj22lckncvampq2qu2gxv6r6774f3hma4vc07wqgsmftjx7",
          original: "Ethereum"
        }
      ],
      [
        "USDCeth",
        {
          symbol: "USDC",
          decimals: 6,
          address: "sei1nj32y0h0vzam33ay42h2majlfk7tdkqcuk84srn0v2a52kmujgfsyfe78f",
          original: "Ethereum"
        }
      ],
      [
        "WMATIC",
        {
          symbol: "WMATIC",
          decimals: 8,
          address: "sei1dc94as3vgxn3qkr5h0lnnrep69mtfku6jg4t94gfkunuyzr5g5eqyqvj9p",
          original: "Polygon"
        }
      ],
      [
        "WBNB",
        {
          symbol: "WBNB",
          decimals: 8,
          address: "sei10a7see3f9t2j9l8fdweur3aqy4zgvz583a268hhhln3yzps6l5mqnl4ua6",
          original: "Bsc"
        }
      ],
      [
        "WAVAX",
        {
          symbol: "WAVAX",
          decimals: 8,
          address: "sei1mgpq67pj7p2acy5x7r5lz7fulxmuxr3uh5f0szyvqgvru3glufzsxk8tnx",
          original: "Avalanche"
        }
      ],
      [
        "USDCavax",
        {
          symbol: "USDC",
          decimals: 6,
          address: "sei1uyce5s6cc8hveg0maq2lg7wm6v6fvwqmznypj559nzf9wr9tmw3qnd3ce7",
          original: "Avalanche"
        }
      ],
      [
        "WFTM",
        {
          symbol: "WFTM",
          decimals: 8,
          address: "sei1cr3j7rxq0dhq04ksftmj8n2w096w9g7ck8fngkvk2lrmy3qwz56q9thu9u",
          original: "Fantom"
        }
      ],
      [
        "CELO",
        {
          symbol: "CELO",
          decimals: 8,
          address: "sei1yw4wv2zqg9xkn67zvq3azye0t8h0x9kgyg3d53jym24gxt49vdyswk5upj",
          original: "Celo"
        }
      ],
      [
        "WGLMR",
        {
          symbol: "WGLMR",
          decimals: 8,
          address: "sei140m6xagmw0zesejzhsvk46zprgscr7tu94h36rwsutcsxcs4fmds9sevym",
          original: "Moonbeam"
        }
      ],
      [
        "WSOL",
        {
          symbol: "WSOL",
          decimals: 8,
          address: "sei1at3xuugacwgu3ppx7fxzmtr3q6m3ztjuean9r2mwcnqupw28yezs7unxgz",
          original: "Solana"
        }
      ],
      [
        "SUI",
        {
          symbol: "SUI",
          decimals: 8,
          address: "sei1rhpcprr2pffe6ydf078a0qeslhnlywxh2t3wjax4489z0m29cj9swj5khc",
          original: "Sui"
        }
      ],
      [
        "APT",
        {
          symbol: "APT",
          decimals: 8,
          address: "sei1em74y5sts4h8y5zuhfdn4w5g8zs285qld3kczpk6rh32jpvjyqqsvv0pdt",
          original: "Aptos"
        }
      ],
      [
        "WETHarbitrum",
        {
          symbol: "WETH",
          decimals: 8,
          address: "sei1pf5j3dgngm8yj2xkwmvmvt87g4vyc0szpjz92q8ly9erh23ytn4s983htv",
          original: "Arbitrum"
        }
      ],
      [
        "WETHbase",
        {
          symbol: "WETH",
          decimals: 8,
          address: "sei1kdqylzcv86t7slg8m30mlfgna9xsrusghdgnavvurkv0rku7jvqqta7lka",
          original: "Base"
        }
      ],
      [
        "USDCbase",
        {
          symbol: "USDC",
          decimals: 6,
          address: "sei1lf6ghmrkd7gn5jlj6xw64suycpjy7g4s5q92fc2gef4f8q3znanq95mmgv",
          original: "Base"
        }
      ],
      [
        "tBTCsol",
        {
          symbol: "tBTC",
          decimals: 8,
          address: "sei1aj3uu9ejt8fk6rpjfhzluqnzqmv3enlndjmt8llkr7dn2dtz55xst4s3mn",
          original: "Solana"
        }
      ],
      [
        "SEI",
        {
          symbol: "SEI",
          decimals: 6,
          address: "usei"
        }
      ]
    ]
  ],
  [
    "Arbitrum",
    [
      [
        "WETH",
        {
          symbol: "WETH",
          decimals: 18,
          address: "0x285d75E04D78F53f4Ed29A506a7e8479EEf3035f",
          original: "Ethereum"
        }
      ],
      [
        "USDCeth",
        {
          symbol: "USDC",
          decimals: 6,
          address: "0x42A212A2E7eA8feF4ED28F439F16A6ABDd34DA35",
          original: "Ethereum"
        }
      ],
      [
        "USDT",
        {
          symbol: "USDT",
          decimals: 6,
          address: "0x2B732F5ad6117818Ad3b7aC73C16033F6ECD78E5",
          original: "Ethereum"
        }
      ],
      [
        "WMATIC",
        {
          symbol: "WMATIC",
          decimals: 18,
          address: "0x50FD4064cC536a964E2E0Dc7B3fE2313Ab386bEA",
          original: "Polygon"
        }
      ],
      [
        "WBNB",
        {
          symbol: "WBNB",
          decimals: 18,
          address: "0xB039aC4Fa8Ed99d30C2f7D791294A9d5FAd698eF",
          original: "Bsc"
        }
      ],
      [
        "WAVAX",
        {
          symbol: "WAVAX",
          decimals: 18,
          address: "0x92b0C4D27a05921Ded4BB117755990F567aEe049",
          original: "Avalanche"
        }
      ],
      [
        "USDCavax",
        {
          symbol: "USDC",
          decimals: 6,
          address: "0xb39697B8BA5df91A169690DfEf88B911436619F2",
          original: "Avalanche"
        }
      ],
      [
        "WFTM",
        {
          symbol: "WFTM",
          decimals: 18,
          address: "0xa507f7566B8aDE000E886166B95964677ef3b3Ef",
          original: "Fantom"
        }
      ],
      [
        "CELO",
        {
          symbol: "CELO",
          decimals: 18,
          address: "0x9592eE6eD1D9E611b7aa6F20CCbD7Ba571Be8bdd",
          original: "Celo"
        }
      ],
      [
        "WSOL",
        {
          symbol: "WSOL",
          decimals: 9,
          address: "0xF8cbdc4E54281b801f182039c250Ad6d13818250",
          original: "Solana"
        }
      ],
      [
        "SUI",
        {
          symbol: "SUI",
          decimals: 9,
          address: "0xe64e2139fdf6Ee7e3795FE51955e21bA3d9eB9F7",
          original: "Sui"
        }
      ],
      [
        "APT",
        {
          symbol: "APT",
          decimals: 8,
          address: "0xa81C3BEf2d6f10213b860458DC119666C0ba13bf",
          original: "Aptos"
        }
      ],
      [
        "ETHarbitrum",
        {
          symbol: "ETH",
          decimals: 18,
          address: "native",
          wrappedKey: "WETHarbitrum"
        }
      ],
      [
        "WETHarbitrum",
        {
          symbol: "WETH",
          decimals: 18,
          address: "0xee01c0cd76354c383b8c7b4e65ea88d00b06f36f"
        }
      ],
      [
        "USDCarbitrum",
        {
          symbol: "USDC",
          decimals: 6,
          address: "0xfd064A18f3BF249cf1f87FC203E90D8f650f2d63"
        }
      ],
      [
        "WETHoptimism",
        {
          symbol: "WETH",
          decimals: 18,
          address: "0xFd903eA23Bf65f26FdAf2eeb589cf007b108882E",
          original: "Optimism"
        }
      ],
      [
        "WETHbase",
        {
          symbol: "WETH",
          decimals: 18,
          address: "0xbC4CB3CD7186fD457C072298C48d0eDf7213CAEa",
          original: "Base"
        }
      ],
      [
        "tBTC",
        {
          symbol: "tBTC",
          decimals: 18,
          address: "0x97B5fE27a82b2B187D9a19C5782d9eB93B82DaC3",
          original: "Ethereum"
        }
      ],
      [
        "tBTCarbitrum",
        {
          symbol: "tBTC",
          decimals: 18,
          address: "0x85727F4725A4B2834e00Db1AA8e1b843a188162F"
        }
      ],
      [
        "tBTCsol",
        {
          symbol: "tBTC",
          decimals: 8,
          address: "0x227115F659f7c2939D23FedE68583F5291c395A6",
          original: "Solana"
        }
      ],
      [
        "SEI",
        {
          symbol: "SEI",
          decimals: 6,
          address: "0x90eC817A1f7C1Eb18dD2985C534A78dD88747F47",
          original: "Sei"
        }
      ]
    ]
  ],
  [
    "Optimism",
    [
      [
        "WETH",
        {
          symbol: "WETH",
          decimals: 18,
          address: "0x33Db338718aC89Cd8DB13B56af05be3a3029BBE5",
          original: "Ethereum"
        }
      ],
      [
        "USDCeth",
        {
          symbol: "USDC",
          decimals: 6,
          address: "0x0382F518AcE1a86224c78B7CDfa67B9774055A1b",
          original: "Ethereum"
        }
      ],
      [
        "WMATIC",
        {
          symbol: "WMATIC",
          decimals: 18,
          address: "0x427B5a0b0384D7FD3AF81805A166a2d9C1116D7d",
          original: "Polygon"
        }
      ],
      [
        "WFTM",
        {
          symbol: "WFTM",
          decimals: 18,
          address: "0x81BA80f5820273AA965086e710042d737993f12c",
          original: "Fantom"
        }
      ],
      [
        "WGLMR",
        {
          symbol: "WGLMR",
          decimals: 18,
          address: "0x99436d62259532E0407A7aE78A3b48D119B13903",
          original: "Moonbeam"
        }
      ],
      [
        "WSOL",
        {
          symbol: "WSOL",
          decimals: 9,
          address: "0x06EcAF6638070Ccf3b3dEA421b3becAA57f3e559",
          original: "Solana"
        }
      ],
      [
        "ETHoptimism",
        {
          symbol: "ETH",
          decimals: 18,
          address: "native",
          wrappedKey: "WETHoptimism"
        }
      ],
      [
        "WETHoptimism",
        {
          symbol: "WETH",
          decimals: 18,
          address: "0x4200000000000000000000000000000000000006"
        }
      ],
      [
        "USDCoptimism",
        {
          symbol: "USDC",
          decimals: 6,
          address: "0xe05606174bac4A6364B31bd0eCA4bf4dD368f8C6"
        }
      ],
      [
        "WETHbase",
        {
          symbol: "WETH",
          decimals: 18,
          address: "0x04b559971c90Dfb12D9795E95883e55f2fcf34Ed",
          original: "Base"
        }
      ],
      [
        "tBTC",
        {
          symbol: "tBTC",
          decimals: 18,
          address: "0x5D89a5BcB86F15a2CCAb05e7E3bEE23fDF246a64",
          original: "Ethereum"
        }
      ],
      [
        "tBTCpolygon",
        {
          symbol: "tBTC",
          decimals: 18,
          address: "0xE04e0F5f2C6ce45A40482C3AB92CA91D6741D717",
          original: "Polygon"
        }
      ],
      [
        "tBTCoptimism",
        {
          symbol: "tBTC",
          decimals: 18,
          address: "0x1a53759DE2eADf73bd0b05c07a4F1F5B7912dA3d"
        }
      ],
      [
        "SEI",
        {
          symbol: "SEI",
          decimals: 6,
          address: "0xE12be3D96fE101246bF2d290184B0eC6D35d02CA",
          original: "Sei"
        }
      ]
    ]
  ],
  [
    "Wormchain",
    [
      [
        "WETH",
        {
          symbol: "WETH",
          decimals: 8,
          address: "wormhole1vguuxez2h5ekltfj9gjd62fs5k4rl2zy5hfrncasykzw08rezpfs63pmq2",
          original: "Ethereum"
        }
      ],
      [
        "USDCeth",
        {
          symbol: "USDC",
          decimals: 6,
          address: "wormhole1rl8su3hadqqq2v86lscpuklsh2mh84cxqvjdew4jt9yd07dzekyqkmcy3p",
          original: "Ethereum"
        }
      ],
      [
        "USDT",
        {
          symbol: "USDT",
          decimals: 6,
          address: "wormhole1v2efcqkp2qtev06t0ksjnx6trxdd0f7fxg2zdrtzr8cr9wdpjkyqkv9ch6",
          original: "Ethereum"
        }
      ],
      [
        "DAI",
        {
          symbol: "DAI",
          decimals: 8,
          address: "wormhole1uuwad4khwek2h05gmkktzmh8l4t0ep54yydlsqg0l4y2uh3tqfyq3an9k6",
          original: "Ethereum"
        }
      ],
      [
        "WMATIC",
        {
          symbol: "WMATIC",
          decimals: 8,
          address: "wormhole1vhjnzk9ly03dugffvzfcwgry4dgc8x0sv0nqqtfxj3ajn7rn5ghq6whn2p",
          original: "Polygon"
        }
      ],
      [
        "WBNB",
        {
          symbol: "WBNB",
          decimals: 8,
          address: "wormhole1335rlmhujm0gj5e9gh7at9jpqvqckz0mpe4v284ar4lw5mlkryzsnetfsj",
          original: "Bsc"
        }
      ],
      [
        "WAVAX",
        {
          symbol: "WAVAX",
          decimals: 8,
          address: "wormhole1tqwwyth34550lg2437m05mjnjp8w7h5ka7m70jtzpxn4uh2ktsmq8dv649",
          original: "Avalanche"
        }
      ],
      [
        "USDCavax",
        {
          symbol: "USDC",
          decimals: 6,
          address: "wormhole1qum2tr7hh4y7ruzew68c64myjec0dq2s2njf6waja5t0w879lutqv2exs9",
          original: "Avalanche"
        }
      ],
      [
        "WFTM",
        {
          symbol: "WFTM",
          decimals: 8,
          address: "wormhole1808lz8dp2c39vhm9gnemt7zzj95nvrmjepxp7v3w4skzrlyzcmnsxkduxf",
          original: "Fantom"
        }
      ],
      [
        "CELO",
        {
          symbol: "CELO",
          decimals: 8,
          address: "wormhole1e8z2wjelypwxw5sey62jvwjyup88w55q3h6m0x8jtwjf6sx5c7ys4mzydk",
          original: "Celo"
        }
      ],
      [
        "WGLMR",
        {
          symbol: "WGLMR",
          decimals: 8,
          address: "wormhole10sfpr8ykh9xn93u8xec4ed3990nmvh86e0vaegkauqhlkxspysyqwavrxx",
          original: "Moonbeam"
        }
      ],
      [
        "WSOL",
        {
          symbol: "WSOL",
          decimals: 8,
          address: "wormhole1gryz69gzl6mz2m66a4twg922jtlc47nlx73sxv88lvq86du5zvyqz3mt23",
          original: "Solana"
        }
      ],
      [
        "USDCsol",
        {
          symbol: "USDC",
          decimals: 6,
          address: "wormhole1ced9v4plkf25q8c6k9gz0guq6l4xyjujpjlvxfg8lpaqywkmamashswq7p",
          original: "Solana"
        }
      ],
      [
        "SUI",
        {
          symbol: "SUI",
          decimals: 8,
          address: "wormhole1yf4p93xu68j5fseupm4laj4k6f60gy7ynx6r5vvyr9c0hl3uy8vqpqd6h0",
          original: "Sui"
        }
      ],
      [
        "APT",
        {
          symbol: "APT",
          decimals: 8,
          address: "wormhole1u8rft0gee23fa6a0t4t88ualrza5lj8ses4aur0l66c7efpvjezqchv34j",
          original: "Aptos"
        }
      ],
      [
        "WETHarbitrum",
        {
          symbol: "WETH",
          decimals: 8,
          address: "wormhole186k0cp83c3wyvapgh8fxf66ededemzrfujvjfsx0xw3vr0u9g8sq2y30vx",
          original: "Arbitrum"
        }
      ],
      [
        "USDCarbitrum",
        {
          symbol: "USDC",
          decimals: 6,
          address: "wormhole1s3pk90ccfl6ueehnj8s9pdgyjjlspmr3m5rv46arjh5v4g08dd0qrchjrk",
          original: "Arbitrum"
        }
      ],
      [
        "WETHoptimism",
        {
          symbol: "WETH",
          decimals: 8,
          address: "wormhole12eu6c7f67l8gdl2lt0hz0dgdh24dhune6wjgy5t0es3tpfzhc3yspwnpfy",
          original: "Optimism"
        }
      ],
      [
        "USDCoptimism",
        {
          symbol: "USDC",
          decimals: 6,
          address: "wormhole1u5z7097gm57zvun9wqsx6jxej2gpdjhg9l9xfe58rhpm29rtjmfqfnl4yv",
          original: "Optimism"
        }
      ],
      [
        "WETHbase",
        {
          symbol: "WETH",
          decimals: 8,
          address: "wormhole10p89p4zh00dwdg8h52sysrqm0l2j47jj3kmg93pnz2a039ucw7esgl5vl9",
          original: "Base"
        }
      ],
      [
        "USDCbase",
        {
          symbol: "USDC",
          decimals: 6,
          address: "wormhole1ja4txt6m0jjq0gmjtmv442f8wk0r5f5apaya0z55wwlrpg3p5xaq3qxw7h",
          original: "Base"
        }
      ],
      [
        "tBTCarbitrum",
        {
          symbol: "tBTC",
          decimals: 8,
          address: "wormhole1rm8ztmk20lrd6ex8uqq3yu7a6eyfjwvg53pcuuj22ffe2y8r3yzqr8j4v9",
          original: "Arbitrum"
        }
      ],
      [
        "wstETH",
        {
          symbol: "wstETH",
          decimals: 8,
          address: "wormhole1u2zdjcczjrenwmf57fmrpensk4the84azdm05m3unm387rm8asdsxqwfeu",
          original: "Ethereum"
        }
      ]
    ]
  ],
  [
    "Osmosis",
    [
      [
        "WETH",
        {
          symbol: "WETH",
          decimals: 8,
          address: "ibc/A4A8B6AE885DACD75B228031C0D18AD7EE1B914CED30C9F6F4230DDBD4A1CF2B",
          original: "Ethereum"
        }
      ],
      [
        "USDCeth",
        {
          symbol: "USDC",
          decimals: 6,
          address: "ibc/3BB8C4BD1C90599B2FA5B5839DD0813EF7B94B0BD0904C4C5A61498AE81E0EE9",
          original: "Ethereum"
        }
      ],
      [
        "USDT",
        {
          symbol: "USDT",
          decimals: 6,
          address: "ibc/1941ED1147121BA7DF35559597B6EB3251844DBBBE4557337D957CB95E0978C2",
          original: "Ethereum"
        }
      ],
      [
        "DAI",
        {
          symbol: "DAI",
          decimals: 8,
          address: "ibc/2864B3418775DDB90EE1410EFF822FDA94E9F0FF77FC8771644761C79EDFE7A3",
          original: "Ethereum"
        }
      ],
      [
        "WMATIC",
        {
          symbol: "WMATIC",
          decimals: 8,
          address: "ibc/43F15553F8598186394E81E18604B8B4532B2D7E855D9FFE68A2EF6802C18BE4",
          original: "Polygon"
        }
      ],
      [
        "WBNB",
        {
          symbol: "WBNB",
          decimals: 8,
          address: "ibc/65A67BA10DE2378B32AC5A822321E370966D3D4E180DEFB4C3C5245B21088DDF",
          original: "Bsc"
        }
      ],
      [
        "WAVAX",
        {
          symbol: "WAVAX",
          decimals: 8,
          address: "ibc/99EAD53D49EC7CC4E2E2EB26C22CF81C16727DF0C4BF7F7ACBF0D22D910DB5DE",
          original: "Avalanche"
        }
      ],
      [
        "USDCavax",
        {
          symbol: "USDC",
          decimals: 6,
          address: "ibc/EC9FA5074F34F0644A025BB0263FDAE8F364C5E08523F6464465EF1010FF5A3A",
          original: "Avalanche"
        }
      ],
      [
        "WFTM",
        {
          symbol: "WFTM",
          decimals: 8,
          address: "ibc/145C6B688F70B0C2F6D87546A5974A75CE75B3A2940275B750E65797B2996157",
          original: "Fantom"
        }
      ],
      [
        "CELO",
        {
          symbol: "CELO",
          decimals: 8,
          address: "ibc/3A4EA3F8096856C0802F86B218DD74213B4C10224AA44BBD54AEAAA2ABF078BA",
          original: "Celo"
        }
      ],
      [
        "WGLMR",
        {
          symbol: "WGLMR",
          decimals: 8,
          address: "ibc/7DB06BB67428510AFC3967DC90F5632C679D55D8C487A951A0EEC3160AF492A6",
          original: "Moonbeam"
        }
      ],
      [
        "WSOL",
        {
          symbol: "WSOL",
          decimals: 8,
          address: "ibc/B5D53105A7AA2BEC4DA4B3304228F3856219AE7CF84A9023043C481629E3E319",
          original: "Solana"
        }
      ],
      [
        "USDCsol",
        {
          symbol: "USDC",
          decimals: 6,
          address: "ibc/35A0467DE5744662078DE8B36CBBE0CF0EAA022565A3E6630CB375DDEBB96E05",
          original: "Solana"
        }
      ],
      [
        "SUI",
        {
          symbol: "SUI",
          decimals: 8,
          address: "ibc/30778BA41ADF2D8A70B90DB53C2E0251731A40276EF6737215BB1A6ED9E90078",
          original: "Sui"
        }
      ],
      [
        "APT",
        {
          symbol: "APT",
          decimals: 8,
          address: "ibc/7C495BD95757ED662A897C139F1C9F18275A86EE7203A0B073E2DB12B1E19D63",
          original: "Aptos"
        }
      ],
      [
        "WETHarbitrum",
        {
          symbol: "WETH",
          decimals: 8,
          address: "ibc/221A4AADF7972F3BB8F48A6CA984FF0AE65B5D973FF1A695B9642AD702F51789",
          original: "Arbitrum"
        }
      ],
      [
        "USDCarbitrum",
        {
          symbol: "USDC",
          decimals: 6,
          address: "ibc/06ED2700071B5A9C582F51A556537DA94E69EF547E7E6CCD8BFA3D95C818A525",
          original: "Arbitrum"
        }
      ],
      [
        "WETHoptimism",
        {
          symbol: "WETH",
          decimals: 8,
          address: "ibc/80B3FECB24A4CE94537444E5BF937AC4C08A39BF90D59620D278FA185BD2B148",
          original: "Optimism"
        }
      ],
      [
        "USDCoptimism",
        {
          symbol: "USDC",
          decimals: 6,
          address: "ibc/0A98A3947189D7C368170C76C3EF49486DDBE095F34B72A3C7F92AEBE1013A1D",
          original: "Optimism"
        }
      ],
      [
        "WETHbase",
        {
          symbol: "WETH",
          decimals: 8,
          address: "ibc/A45069EA82C933945973E66E4222EEE4624498D4483508FE9BEBF9D519F2132F",
          original: "Base"
        }
      ],
      [
        "USDCbase",
        {
          symbol: "USDC",
          decimals: 6,
          address: "ibc/2E4F8BC7F7AF33752CF7E290CAD4417EE67CD18FFC0D099E6519A440E588E0CE",
          original: "Base"
        }
      ],
      [
        "OSMO",
        {
          symbol: "OSMO",
          decimals: 6,
          address: "uosmo"
        }
      ],
      [
        "wstETH",
        {
          symbol: "wstETH",
          decimals: 8,
          address: "ibc/C66B7DB3ED665D2F5FE8ED15E88B5913A37D80601E161C5E53A743DE12C0FB85",
          original: "Ethereum"
        }
      ]
    ]
  ],
  [
    "Cosmoshub",
    [
      [
        "WETH",
        {
          symbol: "WETH",
          decimals: 8,
          address: "ibc/77FE9153FA76C3107CB9F6633AC33509A58529E9622327F216BA8107C79C2DE3",
          original: "Ethereum"
        }
      ],
      [
        "USDCeth",
        {
          symbol: "USDC",
          decimals: 6,
          address: "ibc/D0EC31D1176BB69EA1A7CF7172CA0380B7AF488AFC6D55B101B8363C2141CD4F",
          original: "Ethereum"
        }
      ],
      [
        "USDT",
        {
          symbol: "USDT",
          decimals: 6,
          address: "ibc/755FBC53FFB46FB505B5269F9BEDF47041F2A0EF2FF8D0520315403E5925C80A",
          original: "Ethereum"
        }
      ],
      [
        "DAI",
        {
          symbol: "DAI",
          decimals: 8,
          address: "ibc/5F21E975410DA22AF565B1772DC45AD0BD5F6DA004981EBE291763F3D2C72A96",
          original: "Ethereum"
        }
      ],
      [
        "WMATIC",
        {
          symbol: "WMATIC",
          decimals: 8,
          address: "ibc/37FB599287C6963C413E915FDE83EFA69A3CE8147675DD5A7F974B45F39C8A31",
          original: "Polygon"
        }
      ],
      [
        "WBNB",
        {
          symbol: "WBNB",
          decimals: 8,
          address: "ibc/5B0D5974A56332468DD4B2D07C96A7386FCF8FE7303FF41234F90E410EF51937",
          original: "Bsc"
        }
      ],
      [
        "WAVAX",
        {
          symbol: "WAVAX",
          decimals: 8,
          address: "ibc/BAEAC83736444C09656FBE666FB625974FCCDEE566EB700EBFD2642C5F6CF13A",
          original: "Avalanche"
        }
      ],
      [
        "USDCavax",
        {
          symbol: "USDC",
          decimals: 6,
          address: "ibc/F09E98FA8682FF39130F171E9D89A948B0C3A452F2A31F22B6CC54A3AAE1CD4A",
          original: "Avalanche"
        }
      ],
      [
        "WFTM",
        {
          symbol: "WFTM",
          decimals: 8,
          address: "ibc/919D8F138B7E71BB067C7301AB5C2D48415E8C3A2D9187861245CEC668F88E3C",
          original: "Fantom"
        }
      ],
      [
        "CELO",
        {
          symbol: "CELO",
          decimals: 8,
          address: "ibc/009206915358A002C852A2A2CBEDB8446D2D02E519C815087A01F8BDB4DF77BA",
          original: "Celo"
        }
      ],
      [
        "WGLMR",
        {
          symbol: "WGLMR",
          decimals: 8,
          address: "ibc/1EEDF447A6B046B20C00B1497BED5947219AEEBE0D9A85235C85133A554DF7A4",
          original: "Moonbeam"
        }
      ],
      [
        "WSOL",
        {
          symbol: "WSOL",
          decimals: 8,
          address: "ibc/D3EA463A51E31B2B30BED1978575CAC145DBAB354B8A0EA5D4CFB12D737AF790",
          original: "Solana"
        }
      ],
      [
        "USDCsol",
        {
          symbol: "USDC",
          decimals: 6,
          address: "ibc/26D8D6C63C8D37A5127591DDA905E04CC69CBD3A64F9DA3B1DA3FB0B6A7D9FA5",
          original: "Solana"
        }
      ],
      [
        "SUI",
        {
          symbol: "SUI",
          decimals: 8,
          address: "ibc/129EC6B8A41BE07F94DD267F552F4AE1D5EAEBB51634A1468556AF06C10C2692",
          original: "Sui"
        }
      ],
      [
        "APT",
        {
          symbol: "APT",
          decimals: 8,
          address: "ibc/0CCA5EB15BC2FE474E71DBC9698302CDE260B6F6548F91C30002F7CBF228197B",
          original: "Aptos"
        }
      ],
      [
        "WETHarbitrum",
        {
          symbol: "WETH",
          decimals: 8,
          address: "ibc/AB4046AF5B6F146C006DE4DECAD929D24F762A701E09EC8B29000EC63A6E649B",
          original: "Arbitrum"
        }
      ],
      [
        "USDCarbitrum",
        {
          symbol: "USDC",
          decimals: 6,
          address: "ibc/6D1B6A7A9EF692A279A6B5994C98C0D598D003D9203BE8309F14B6E57A58506E",
          original: "Arbitrum"
        }
      ],
      [
        "WETHoptimism",
        {
          symbol: "WETH",
          decimals: 8,
          address: "ibc/A0298483510D803A045AA7F49CCBD0F9D01010FE0B1A346EBDFFF4BA820C3D21",
          original: "Optimism"
        }
      ],
      [
        "USDCoptimism",
        {
          symbol: "USDC",
          decimals: 6,
          address: "ibc/CE3F2FE630DA6A1187F085CDC8D59BA8B20DA48F4866F2D71C5AB7A1D5859933",
          original: "Optimism"
        }
      ],
      [
        "WETHbase",
        {
          symbol: "WETH",
          decimals: 8,
          address: "ibc/97035986A4BD0AF555713355A02EA31A4526616B6543E019E0D750007FABE06C",
          original: "Base"
        }
      ],
      [
        "USDCbase",
        {
          symbol: "USDC",
          decimals: 6,
          address: "ibc/8560BA5F45C95AE716C05978E364F50C98347ACBEC745840C30F91611FA36698",
          original: "Base"
        }
      ],
      [
        "wstETH",
        {
          symbol: "wstETH",
          decimals: 8,
          address: "ibc/5BB02667F9F0C8284FCF7716065C2779039817FBCB91E937F5149FE89FD8F202",
          original: "Ethereum"
        }
      ],
      [
        "ATOM",
        {
          symbol: "ATOM",
          decimals: 6,
          address: "uatom"
        }
      ]
    ]
  ],
  [
    "Evmos",
    [
      [
        "EVMOS",
        {
          symbol: "EVMOS",
          decimals: 18,
          address: "atevmos"
        }
      ]
    ]
  ],
  [
    "Kujira",
    [
      [
        "KUJI",
        {
          symbol: "KUJI",
          decimals: 6,
          address: "ukuji"
        }
      ]
    ]
  ],
  [
    "Klaytn",
    [
      [
        "KLAY",
        {
          symbol: "KLAY",
          decimals: 18,
          address: "native",
          wrappedKey: "WKLAY"
        }
      ],
      [
        "WKLAY",
        {
          symbol: "WKLAY",
          decimals: 18,
          address: "0x0339d5Eb6D195Ba90B13ed1BCeAa97EbD198b106"
        }
      ]
    ]
  ],
  [
    "Sepolia",
    [
      [
        "ETHsepolia",
        {
          symbol: "ETH",
          decimals: 18,
          address: "native",
          wrappedKey: "WETHsepolia"
        }
      ],
      [
        "WETHsepolia",
        {
          symbol: "WETH",
          decimals: 18,
          address: "0xeef12A83EE5b7161D3873317c8E0E7B76e0B5D9c"
        }
      ]
    ]
  ],
  [
    "ArbitrumSepolia",
    [
      [
        "ETHarbitrum_sepolia",
        {
          symbol: "ETH",
          decimals: 18,
          address: "native",
          wrappedKey: "WETHarbitrum_sepolia"
        }
      ],
      [
        "WETHarbitrum_sepolia",
        {
          symbol: "WETH",
          decimals: 18,
          address: "0x980B62Da83eFf3D4576C647993b0c1D7faf17c73"
        }
      ]
    ]
  ],
  [
    "BaseSepolia",
    [
      [
        "ETHbase_sepolia",
        {
          symbol: "ETH",
          decimals: 18,
          address: "native",
          wrappedKey: "WETHbase_sepolia"
        }
      ],
      [
        "WETHbase_sepolia",
        {
          symbol: "WETH",
          decimals: 18,
          address: "0x4200000000000000000000000000000000000006"
        }
      ]
    ]
  ],
  [
    "OptimismSepolia",
    [
      [
        "ETHoptimism_sepolia",
        {
          symbol: "ETH",
          decimals: 18,
          address: "native",
          wrappedKey: "WETHoptimism_sepolia"
        }
      ],
      [
        "WETHoptimism_sepolia",
        {
          symbol: "WETH",
          decimals: 18,
          address: "0x4200000000000000000000000000000000000006"
        }
      ]
    ]
  ]
], testnetChainTokens = constMap(testnetTokenEntries, [0, [1, 2]]);
function getTokenMap(C, e) {
  if (C !== "Devnet") {
    if (C === "Mainnet") {
      if (!mainnetChainTokens.has(e))
        return;
      const T = mainnetChainTokens.get(e);
      return Object.fromEntries(T.map(([$, V]) => [$, { ...V, chain: e, key: $ }]));
    }
    if (C === "Testnet") {
      if (!testnetChainTokens.has(e))
        return;
      const T = testnetChainTokens.get(e);
      return Object.fromEntries(T.map(([$, V]) => [$, { ...V, chain: e, key: $ }]));
    }
    throw new Error("Unsupported network: " + C);
  }
}
function getNative(C, e) {
  const T = getTokenMap(C, e);
  return T ? filters.native(T) : void 0;
}
function getTokenByAddress(C, e, T) {
  const $ = getTokenMap(C, e);
  return $ ? filters.byAddress($, T) : void 0;
}
function getTokenByKey(C, e, T) {
  const $ = getTokenMap(C, e);
  return $ ? filters.byKey($, T) : void 0;
}
function getContracts(C, e) {
  const T = {
    coreBridge: coreBridge.get(C, e),
    tokenBridge: tokenBridge.get(C, e),
    nftBridge: nftBridge.get(C, e),
    relayer: relayer.get(C, e),
    tokenBridgeRelayer: tokenBridgeRelayer.get(C, e)
  };
  return circleContracts.has(C, e) && (T.cctp = circleContracts.get(C, e)), gateway.has(C, e) && (T.gateway = gateway.get(C, e)), translator.has(C, e) && (T.translator = translator.get(C, e)), portico.has(C, e) && (T.portico = portico.get(C, e)), T;
}
function isNative$1(C) {
  return typeof C == "string" && C === "native";
}
function nativeTokenId(C) {
  return { chain: C, address: "native" };
}
function isTokenId(C) {
  return typeof C == "object" && C.address !== void 0 && C.chain !== void 0 && isChain(C.chain);
}
function isSameToken(C, e) {
  return C.chain !== e.chain ? !1 : isNative$1(C.address) && isNative$1(e.address) ? !0 : canonicalAddress(C) === canonicalAddress(e);
}
function canonicalAddress(C) {
  return isTokenId(C) && isNative$1(C.address) ? C.address : C.address.toNative(C.chain).toString();
}
function universalAddress(C) {
  if (isNative$1(C.address))
    throw new Error("Invalid address, cannot convert the string literal `native` to a Universal Address");
  return C.address.toUniversalAddress().toString();
}
function resolveWrappedToken(C, e, T) {
  let $;
  if (isTokenId(T)) {
    if (!isNative$1(T.address))
      return [!1, T];
    $ = T.address;
  } else
    $ = T;
  if (isNative$1($)) {
    const J = getNative(C, e);
    if (!J)
      throw new Error("Invalid destination token");
    const ee = J.wrappedKey, te = getTokenByKey(C, e, ee);
    if (!te)
      throw new Error("Invalid wrapped token key: " + ee);
    return [!0, { chain: e, address: toNative(e, te.address) }];
  }
  return [!1, { chain: e, address: $ }];
}
function isTransactionIdentifier(C) {
  return C.chain !== void 0 && C.txid !== void 0;
}
function buildConfig$1(C) {
  return chains$4.map((T) => {
    const $ = chainToPlatform(T);
    let V = "";
    try {
      V = networkChainToNativeChainId.get(C, T);
    } catch {
    }
    const J = getTokenMap(C, T), ee = J ? Object.values(J).find((re) => isNative$1(re.address) && re.wrappedKey) : void 0, te = ee ? J[ee.wrappedKey] : void 0;
    return {
      key: T,
      platform: $,
      network: C,
      chainId: toChainId(T),
      finalityThreshold: finalityThreshold.get(T) ?? 0,
      blockTime: blockTime.get(T) ?? 0,
      contracts: getContracts(C, T),
      nativeTokenDecimals: nativeDecimals($),
      nativeChainId: V,
      tokenMap: J,
      wrappedNative: te,
      explorer: explorerConfigs(C, T),
      rpc: rpcAddress(C, T)
    };
  }).reduce((T, $) => ({ ...T, [$.key]: $ }), {});
}
class ChainContext {
  constructor(e, T, $) {
    tt(this, "network");
    tt(this, "chain");
    tt(this, "config");
    tt(this, "platform");
    tt(this, "rpc");
    // Cached Protocol clients
    tt(this, "protocols", /* @__PURE__ */ new Map());
    /**
     * Check to see if the Wormhole Core protocol is supported by this chain
     * @returns a boolean indicating if this chain supports the Wormhole Core protocol
     */
    tt(this, "supportsWormholeCore", () => this.supportsProtocol("WormholeCore"));
    /**
     * Get the Wormhole Core protocol client for this chain
     * @returns the Wormhole Core protocol client for this chain
     */
    tt(this, "getWormholeCore", () => this.getProtocol("WormholeCore"));
    /**
     * Check to see if the Token Bridge protocol is supported by this chain
     * @returns a boolean indicating if this chain supports the Token Bridge protocol
     */
    tt(this, "supportsTokenBridge", () => this.supportsProtocol("TokenBridge"));
    /**
     * Get the Token Bridge protocol client for this chain
     * @returns the Token Bridge protocol client for this chain
     */
    tt(this, "getTokenBridge", () => this.getProtocol("TokenBridge"));
    /**
     * Check to see if the Automatic Token Bridge protocol is supported by this chain
     * @returns  a boolean indicating if this chain supports the Automatic Token Bridge protocol
     */
    tt(this, "supportsAutomaticTokenBridge", () => this.supportsProtocol("AutomaticTokenBridge"));
    /**
     * Get the Automatic Token Bridge protocol client for this chain
     * @returns the Automatic Token Bridge protocol client for this chain
     */
    tt(this, "getAutomaticTokenBridge", () => this.getProtocol("AutomaticTokenBridge"));
    /**
     * Check to see if the Circle Bridge protocol is supported by this chain
     * @returns a boolean indicating if this chain supports the Circle Bridge protocol
     */
    tt(this, "supportsCircleBridge", () => this.supportsProtocol("CircleBridge"));
    /**
     * Get the Circle Bridge protocol client for this chain
     * @returns the Circle Bridge protocol client for this chain
     */
    tt(this, "getCircleBridge", () => this.getProtocol("CircleBridge"));
    /**
     * Check to see if the Automatic Circle Bridge protocol is supported by this chain
     * @returns a boolean indicating if this chain supports the Automatic Circle Bridge protocol
     */
    tt(this, "supportsAutomaticCircleBridge", () => this.supportsProtocol("AutomaticCircleBridge"));
    /**
     * Get the Automatic Circle Bridge protocol client for this chain
     * @returns the Automatic Circle Bridge protocol client for this chain
     */
    tt(this, "getAutomaticCircleBridge", () => this.getProtocol("AutomaticCircleBridge"));
    /**
     * Check to see if the IBC Bridge protocol is supported by this chain
     * @returns a boolean indicating if this chain supports the IBC Bridge protocol
     */
    tt(this, "supportsIbcBridge", () => this.supportsProtocol("IbcBridge"));
    /**
     * Get the IBC Bridge protocol client for this chain
     * @returns the IBC Bridge protocol client for this chain
     */
    tt(this, "getIbcBridge", () => this.getProtocol("IbcBridge"));
    /**
     * Check to see if the Portico Bridge protocol is supported by this chain
     * @returns a boolean indicating if this chain supports the Portico Bridge protocol
     */
    tt(this, "supportsPorticoBridge", () => this.supportsProtocol("PorticoBridge"));
    /**
     * Get the Portico Bridge protocol client for this chain
     * @returns the Portico Bridge protocol client for this chain
     */
    tt(this, "getPorticoBridge", () => this.getProtocol("PorticoBridge"));
    this.config = T.config[e], this.platform = T, this.chain = this.config.key, this.network = this.config.network, this.rpc = $;
  }
  /**
   * Get an RPC connection for this chain, uses the configuration passed in
   * the initial constructor
   *
   * @returns the RPC connection for this chain
   */
  getRpc() {
    return this.rpc = this.rpc ? this.rpc : this.platform.getRpc(this.chain), this.rpc;
  }
  /**
   *  Get the number of decimals for a token
   *
   *  @param token the token to get the decimals for
   *  @returns the number of decimals for the token
   */
  async getDecimals(e) {
    if (isNative$1(e))
      return this.config.nativeTokenDecimals;
    if (this.config.tokenMap) {
      const T = canonicalAddress({ chain: this.chain, address: e }), $ = getTokenByAddress(this.network, this.chain, T);
      if ($)
        return $.decimals;
    }
    return this.platform.utils().getDecimals(this.chain, await this.getRpc(), e);
  }
  /**
   * Get the balance of a token for a given address
   *
   * @param walletAddr the address to get the balance for
   * @param token the token to get the balance for
   * @returns the balance of the token for the address
   *
   */
  async getBalance(e, T) {
    return this.platform.utils().getBalance(this.chain, await this.getRpc(), e, T);
  }
  /**
   * Get the latest block number seen by the chain according to the RPC
   *
   * @returns the latest block number
   */
  async getLatestBlock() {
    return this.platform.utils().getLatestBlock(await this.getRpc());
  }
  /**
   * Get the latest _finalized_ block number seen by the chain according to the RPC
   *
   * @returns the latest finalized block number
   */
  async getLatestFinalizedBlock() {
    return this.platform.utils().getLatestFinalizedBlock(await this.getRpc());
  }
  /**
   * Parse the Wormhole Core messages from a transaction
   *
   * @param txid the transaction to parse
   * @returns the Wormhole Core messages emitted by the transaction
   */
  async parseTransaction(e) {
    return this.platform.parseWormholeMessages(this.chain, await this.getRpc(), e);
  }
  /**
   *  Send a transaction and wait for it to be confirmed
   *
   * @param stxns the signed transaction to send
   * @returns the transaction hashes of the sent transactions
   */
  async sendWait(e) {
    return this.platform.utils().sendWait(this.chain, await this.getRpc(), e);
  }
  /**
   * Get the token data from the local cache if available
   * @param symbol the symbol of the token to get
   * @returns the token data if available
   */
  getToken(e) {
    if (this.config.tokenMap && e in this.config.tokenMap)
      return this.config.tokenMap[e];
  }
  /**
   * Get the token id of the wrapped token for the native gas token
   *
   * @returns the wrapped token for the native gas token
   */
  async getNativeWrappedTokenId() {
    if (this.config.wrappedNative) {
      const { address: T } = this.config.wrappedNative;
      return { chain: this.chain, address: toNative(this.chain, T) };
    }
    const e = await this.getTokenBridge();
    return { chain: this.chain, address: await e.getWrappedNative() };
  }
  /**
   * Get the token account for a given address and token
   *
   * @remarks
   * This is really only useful in the context of Solana but in order
   * to provide a consistent interface, we provide it here.
   *
   * @param address the address to get the token account for
   * @param token the token to get the token account for
   * @returns the token account for the address and token
   */
  async getTokenAccount(e, T) {
    return { chain: this.chain, address: e };
  }
  /**
   * Check to see if a given protocol is supported by this chain
   * by checking if it is registered in the platform and the configuration
   * is available and correct
   *
   * @param protocolName the name of the Protocol to check for support
   * @returns a boolean indicating if this protocol is supported
   */
  supportsProtocol(e) {
    return protocolIsRegistered(this.chain, e);
  }
  /**
   * Construct a protocol client for the given protocol
   *
   * Note: If no contracts are passed, we assume the default contracts should be used
   * and that the protocol client is cacheable
   *
   * @param protocolName The name of the protocol to construct a client for
   * @returns An instance of the protocol client that implements the protocol interface for the chain
   */
  async getProtocol(e, T, $) {
    if (!T && this.protocols.has(e))
      return this.protocols.get(e);
    const V = T ? { ...this.config.contracts, ...T } : this.config.contracts, J = $ ?? await this.getRpc(), ee = this.platform.getProtocolInitializer(e);
    let te;
    if ($) {
      if (T)
        throw new Error("Custom contracts are currently not supported with custom rpc connection. Add the contracts to the base config.");
      te = await this.platform.getProtocol(e, J);
    } else if (isVersionedProtocolInitializer(ee)) {
      const re = await ee.getVersion(J, V);
      te = new ee(this.network, this.chain, J, V, re);
    } else
      te = new ee(this.network, this.chain, J, V);
    return T || this.protocols.set(e, te), te;
  }
}
function isSigner(C) {
  return isSignOnlySigner(C) || isSignAndSendSigner(C);
}
function isSignOnlySigner(C) {
  return typeof C == "object" && "chain" in C && typeof C.chain == "function" && "address" in C && typeof C.address == "function" && "sign" in C && typeof C.sign == "function";
}
function isSignAndSendSigner(C) {
  return typeof C == "object" && "chain" in C && typeof C.chain == "function" && "address" in C && typeof C.address == "function" && "signAndSend" in C && typeof C.signAndSend == "function";
}
class PlatformNativeSigner {
  constructor(e, T, $) {
    tt(this, "_chain");
    tt(this, "_address");
    tt(this, "_signer");
    this._chain = e, this._address = T, this._signer = $;
  }
  unwrap() {
    return this._signer;
  }
}
function isWormholeMessageId(C) {
  return C.sequence !== void 0 && C.emitter !== void 0 && C.chain !== void 0;
}
function isCircleMessageId(C) {
  return C.hash !== void 0;
}
const depositWithPayloadLayout = (C) => [
  payloadIdItem(1),
  {
    name: "token",
    binary: "bytes",
    layout: [
      { name: "address", ...universalAddressItem },
      { name: "amount", ...amountItem }
    ]
  },
  { name: "sourceDomain", ...circleDomainItem },
  { name: "targetDomain", ...circleDomainItem },
  { name: "nonce", ...circleNonceItem },
  { name: "caller", ...universalAddressItem },
  { name: "mintRecipient", ...universalAddressItem },
  customizableBytes({ name: "payload", lengthSize: 2 }, C)
], circleConnectPayload = [
  payloadIdItem(1),
  { name: "targetRelayerFee", ...amountItem },
  { name: "toNativeTokenAmount", ...amountItem },
  { name: "targetRecipient", ...universalAddressItem }
], automaticCircleBridgeNamedPayloads = [
  ["DepositWithPayload", depositWithPayloadLayout()],
  ["TransferWithRelay", depositWithPayloadLayout(circleConnectPayload)]
];
registerPayloadTypes("AutomaticCircleBridge", automaticCircleBridgeNamedPayloads);
const messageVersionItem = { binary: "uint", size: 4, custom: 0, omit: !0 }, circleBurnMessageLayout = [
  // messageBodyVersion is:
  // * immutable: https://github.com/circlefin/evm-cctp-contracts/blob/adb2a382b09ea574f4d18d8af5b6706e8ed9b8f2/src/TokenMessenger.sol#L107
  // * 0: https://etherscan.io/address/0xbd3fa81b58ba92a82136038b25adec7066af3155#readContract
  { name: "messageBodyVersion", ...messageVersionItem },
  { name: "burnToken", ...universalAddressItem },
  { name: "mintRecipient", ...universalAddressItem },
  { name: "amount", ...amountItem },
  { name: "messageSender", ...universalAddressItem }
], circleMessageLayout = [
  // version is:
  // * immutable: https://github.com/circlefin/evm-cctp-contracts/blob/adb2a382b09ea574f4d18d8af5b6706e8ed9b8f2/src/MessageTransmitter.sol#L75
  // * 0: https://etherscan.io/address/0x0a992d191deec32afe36203ad87d7d289a738f81#readContract
  { name: "version", ...messageVersionItem },
  { name: "sourceDomain", ...circleDomainItem },
  { name: "destinationDomain", ...circleDomainItem },
  { name: "nonce", ...circleNonceItem },
  { name: "sender", ...universalAddressItem },
  { name: "recipient", ...universalAddressItem },
  { name: "destinationCaller", ...universalAddressItem },
  { name: "payload", binary: "bytes", layout: circleBurnMessageLayout }
], circleBridgeNamedPayloads = [
  ["Message", circleMessageLayout]
];
registerPayloadTypes("CircleBridge", circleBridgeNamedPayloads);
var CircleBridge;
(function(C) {
  C.isCircleAttestation = (e) => e.message !== void 0, C.deserialize = (e) => {
    const T = deserialize$2(circleMessageLayout, e), $ = hex$1.encode(keccak_256(e), !0);
    return [T, $];
  }, C.serialize = (e) => serialize$2(circleMessageLayout, e);
})(CircleBridge || (CircleBridge = {}));
var AutomaticCircleBridge;
(function(C) {
  const e = "AutomaticCircleBridge", T = ["DepositWithPayload", "TransferWithRelay"];
  C.getTransferDiscriminator = lazyInstantiate(() => payloadDiscriminator([e, T]));
})(AutomaticCircleBridge || (AutomaticCircleBridge = {}));
function isCircleTransferDetails(C) {
  return C.amount !== void 0 && C.from !== void 0 && C.to !== void 0;
}
const fixedLengthStringItem = {
  binary: "bytes",
  size: 32,
  custom: {
    to: (C) => range(C.byteLength).map((e) => String.fromCharCode(C[e])).join(""),
    from: (C) => new Uint8Array(C.split("").map((e) => e.charCodeAt(0)))
  }
}, transferCommonLayout = [
  {
    name: "token",
    binary: "bytes",
    layout: [
      { name: "amount", ...amountItem },
      { name: "address", ...universalAddressItem },
      { name: "chain", ...chainItem() }
    ]
  },
  {
    name: "to",
    binary: "bytes",
    layout: [
      { name: "address", ...universalAddressItem },
      { name: "chain", ...chainItem() }
    ]
  }
], transferWithPayloadLayout = (C) => [
  payloadIdItem(3),
  ...transferCommonLayout,
  { name: "from", ...universalAddressItem },
  customizableBytes({ name: "payload" }, C)
], tokenBridgeNamedPayloads = [
  [
    "AttestMeta",
    [
      payloadIdItem(2),
      {
        name: "token",
        binary: "bytes",
        layout: [
          { name: "address", ...universalAddressItem },
          { name: "chain", ...chainItem() }
        ]
      },
      { name: "decimals", binary: "uint", size: 1 },
      { name: "symbol", ...fixedLengthStringItem },
      { name: "name", ...fixedLengthStringItem }
    ]
  ],
  ["Transfer", [payloadIdItem(1), ...transferCommonLayout, { name: "fee", ...amountItem }]],
  ["TransferWithPayload", transferWithPayloadLayout()]
];
registerPayloadTypes("TokenBridge", tokenBridgeNamedPayloads);
const flagsItem = bitsetItem(["shouldWrapNative", "shouldUnwrapNative"]), porticoFlagSetLayout = [
  { name: "recipientChain", binary: "uint", endianness: "little", size: 2 },
  { name: "bridgeNonce", binary: "uint", endianness: "little", size: 4 },
  { name: "feeTierStart", binary: "uint", endianness: "little", size: 3 },
  { name: "feeTierFinish", binary: "uint", endianness: "little", size: 3 },
  { name: "padding", binary: "bytes", size: 19 },
  { name: "flags", ...flagsItem }
], porticoPayloadLayout = [
  { name: "flagSet", binary: "bytes", layout: porticoFlagSetLayout },
  { name: "finalTokenAddress", ...universalAddressItem },
  { name: "recipientAddress", ...universalAddressItem },
  { name: "cannonAssetAmount", ...amountItem },
  { name: "minAmountFinish", ...amountItem },
  { name: "relayerFee", ...amountItem }
], namedPayloads$1 = [
  ["Transfer", transferWithPayloadLayout(porticoPayloadLayout)]
];
registerPayloadTypes("PorticoBridge", namedPayloads$1);
var PorticoBridge;
(function(C) {
  C.deserializePayload = (e) => deserialize$2(porticoPayloadLayout, e), C.serializePayload = (e) => serialize$2(porticoPayloadLayout, e), C.deserializeFlagSet = (e) => deserialize$2(porticoFlagSetLayout, e), C.serializeFlagSet = (e) => serialize$2(porticoFlagSetLayout, e);
})(PorticoBridge || (PorticoBridge = {}));
const encodedExecutionInfoItem = {
  binary: "bytes",
  layout: [
    { name: "size", binary: "uint", size: 4, custom: 3 * 32, omit: !0 },
    { name: "waste", binary: "uint", size: 31, custom: 0n, omit: !0 },
    { name: "version", binary: "uint", size: 1, custom: 0, omit: !0 },
    { name: "gasLimit", ...amountItem },
    { name: "targetChainRefundPerGasUnused", ...amountItem }
  ]
}, addressChainItem = {
  binary: "bytes",
  layout: [
    { name: "chain", ...chainItem() },
    { name: "address", ...universalAddressItem }
  ]
}, vaaKeyLayout = [
  { name: "chain", ...chainItem() },
  { name: "emitterAddress", ...universalAddressItem },
  { name: "sequence", ...sequenceItem }
], cctpKeyLayout = [
  { name: "size", binary: "uint", size: 4, custom: 12, omit: !0 },
  { name: "domain", ...circleDomainItem },
  { name: "nonce", ...circleNonceItem }
], messageKeySwitchLayout = {
  binary: "switch",
  idSize: 1,
  idTag: "keyType",
  layouts: [
    [[1, "VAA"], vaaKeyLayout],
    [[2, "CCTP"], cctpKeyLayout]
  ]
}, deliveryInstructionLayout = (C) => [
  payloadIdItem(1),
  { name: "target", ...addressChainItem },
  customizableBytes({ name: "payload", lengthSize: 4 }, C),
  { name: "requestedReceiverValue", ...amountItem },
  { name: "extraReceiverValue", ...amountItem },
  { name: "executionInfo", ...encodedExecutionInfoItem },
  { name: "refund", ...addressChainItem },
  { name: "refundDeliveryProvider", ...universalAddressItem },
  { name: "sourceDeliveryProvider", ...universalAddressItem },
  { name: "senderAddress", ...universalAddressItem },
  { name: "messageKeys", binary: "array", lengthSize: 1, layout: messageKeySwitchLayout }
], namedPayloads = [
  ["DeliveryInstruction", deliveryInstructionLayout()],
  [
    "RedeliveryInstruction",
    [
      payloadIdItem(2),
      { name: "deliveryVaaKey", binary: "bytes", layout: messageKeySwitchLayout },
      { name: "targetChain", ...chainItem() },
      { name: "newRequestedReceiverValue", ...amountItem },
      { name: "newEncodedExecutionInfo", ...encodedExecutionInfoItem },
      { name: "newSourceDeliveryProvider", ...universalAddressItem },
      { name: "newSenderAddress", ...universalAddressItem }
    ]
  ]
];
registerPayloadTypes("Relayer", namedPayloads);
const connectPayload = [
  payloadIdItem(1),
  { name: "targetRelayerFee", ...amountItem },
  { name: "toNativeTokenAmount", ...amountItem },
  { name: "targetRecipient", ...universalAddressItem }
], automaticTokenBridgeNamedPayloads = [
  ["TransferWithRelay", transferWithPayloadLayout(connectPayload)]
];
registerPayloadTypes("AutomaticTokenBridge", automaticTokenBridgeNamedPayloads);
const ErrNotWrapped = (C) => new Error(`Token ${C} is not a wrapped asset`);
var TokenBridge;
(function(C) {
  const e = "TokenBridge", T = ["Transfer", "TransferWithPayload"], $ = ["AttestMeta"];
  [...T, ...$], C.getTransferDiscriminator = lazyInstantiate(() => payloadDiscriminator([e, T]));
})(TokenBridge || (TokenBridge = {}));
function isTokenTransferDetails(C) {
  return C.token !== void 0 && C.amount !== void 0 && C.from !== void 0 && C.to !== void 0;
}
const modificationKinds = [
  ["Add", 1],
  ["Subtract", 2],
  ["Unknown", 3]
], rawEvmAddressItem = {
  binary: "bytes",
  size: 20,
  custom: {
    to: (C) => hex$1.encode(C, !0),
    from: (C) => hex$1.decode(C)
  }
}, contractActions = [
  ["UpgradeContract", [!1, [{ name: "newContract", ...universalAddressItem }]]],
  [
    "RegisterChain",
    [!0, [
      { name: "foreignChain", ...chainItem() },
      { name: "foreignAddress", ...universalAddressItem }
    ]]
  ],
  //a word on the chainId for RecoverChainId:
  //The EVM contracts accept an arbitrary number when recovering chain ids however I don't think you
  //  ever want to set the wormhole chain id of a contract (even on a fork) to 0 since this would
  //  mean that afterwards all the checks that use `vaa.chainId == this.chainId` in the contract
  //  would suddenly accept "broadcast VAAs" which is almost certainly not what's intended.
  //TODO should we define governance actions that are platform specific here?
  //     (reason against: we might want to deserialize types that are specific to the platform)
  [
    "RecoverChainId",
    [!1, [
      { name: "evmChainId", binary: "uint", size: 32 },
      { name: "newChainId", ...chainItem({ allowedChains: platformToChains("Evm") }) }
    ]]
  ],
  [
    "GuardianSetUpgrade",
    [!0, [
      { name: "guardianSet", ...guardianSetItem },
      { name: "guardians", binary: "array", lengthSize: 1, layout: rawEvmAddressItem }
    ]]
  ],
  ["SetMessageFee", [!1, [{ name: "messageFee", binary: "uint", size: 32 }]]],
  [
    "TransferFees",
    [!0, [
      { name: "amount", binary: "uint", size: 32 },
      { name: "recipient", ...universalAddressItem }
    ]]
  ],
  ["UpdateDefaultProvider", [!1, [{ name: "defaultProvider", ...universalAddressItem }]]],
  [
    "RegisterEmitterAndDomain",
    [!0, [
      { name: "emitterChain", ...chainItem() },
      { name: "emitterAddress", ...universalAddressItem },
      { name: "domain", binary: "uint", size: 4 }
    ]]
  ],
  ["UpdateFinality", [!1, [{ name: "finality", binary: "uint", size: 1 }]]]
], wasmHashItem = { binary: "bytes", size: 32 }, wasmContractLayout = [
  { name: "contractAddr", ...universalAddressItem },
  { name: "codeId", binary: "uint", size: 8 }
], wormchainActions = [
  ["StoreCode", [!1, [{ name: "wasmHash", ...wasmHashItem }]]],
  ["InstantiateContract", [!1, [{ name: "instantiationParamsHash", ...wasmHashItem }]]],
  ["MigrateContract", [!1, [{ name: "migrationParamsHash", ...wasmHashItem }]]],
  ["AddWasmInstantiateAllowlist", [!1, wasmContractLayout]],
  ["DeleteWasmInstantiateAllowlist", [!1, wasmContractLayout]]
], gatewayScheduleUpgradeItem = (() => {
  const C = (V) => ({ binary: "bytes", size: V, custom: stringConversion }), e = [
    { name: "height", binary: "uint", size: 8 }
  ], T = calcStaticSize(e), $ = (V) => [
    { name: "name", ...C(V) },
    ...e
  ];
  return {
    binary: "bytes",
    custom: {
      to: (V) => deserialize$2($(V.length - T), V),
      from: (V) => serialize$2($(V.name.length), V)
    }
  };
})(), gatewayActions = [
  ["ScheduleUpgrade", [!1, gatewayScheduleUpgradeItem]],
  ["CancelUpgrade", [!0, []]],
  [
    "SetIbcComposabilityMwContract",
    [!1, [
      { name: "contractAddress", ...universalAddressItem }
    ]]
  ]
], globalAccountantActions = [
  [
    "ModifyBalance",
    [!1, [
      { name: "sequence", ...sequenceItem },
      { name: "modifiedChain", ...chainItem() },
      { name: "tokenChain", ...chainItem() },
      { name: "tokenAddress", ...universalAddressItem },
      { name: "kind", ...enumItem(modificationKinds) },
      { name: "amount", ...amountItem },
      { name: "reason", ...fixedLengthStringItem$1(32) }
    ]]
  ]
], ibcReceiverActions = [
  [
    "ActionUpdateChannelChain",
    [!1, [
      { name: "channelId", ...fixedLengthStringItem$1(64) },
      //TODO previous name was "chainId" which is definitely wrong - check new name
      { name: "channelChain", ...chainItem({ allowedChains: platformToChains("Cosmwasm") }) }
    ]]
  ]
], generalPurposeActions = [
  [
    "GeneralPurposeEvm",
    [!1, [
      { name: "governanceContract", ...rawEvmAddressItem },
      { name: "targetContract", ...rawEvmAddressItem },
      { name: "payload", binary: "bytes", lengthSize: 2 }
    ]]
  ],
  [
    "GeneralPurposeSolana",
    [!1, [
      { name: "governanceContract", ...universalAddressItem },
      { name: "payload", binary: "bytes" }
    ]]
  ]
], actionTuples = [
  ...contractActions,
  ...wormchainActions,
  ...gatewayActions,
  ...globalAccountantActions,
  ...ibcReceiverActions,
  ...generalPurposeActions
];
column(actionTuples, 0);
const actionMapping = Object.fromEntries(actionTuples), sdkProtocolNameAndGovernanceVaaModuleEntries = [
  ["WormholeCore", "Core"],
  ["TokenBridge", "TokenBridge"],
  ["NftBridge", "NftBridge"],
  ["Relayer", "WormholeRelayer"],
  ["CircleBridge", "CircleIntegration"],
  ["IbcBridge", "IbcTranslator"],
  ["IbcReceiver", "IbcReceiver"],
  ["GlobalAccountant", "GlobalAccountant"],
  ["GeneralPurposeGovernance", "GeneralPurposeGovernance"],
  ["WormchainGovernance", "WasmdModule"],
  ["GatewayGovernance", "GatewayModule"]
], sdkProtocolNameToGovernanceVaaModuleMapping = constMap(sdkProtocolNameAndGovernanceVaaModuleEntries), protocolConversion = (C) => ({
  to: C,
  from: (() => {
    const T = new Uint8Array(32), $ = sdkProtocolNameToGovernanceVaaModuleMapping(C);
    for (let V = 1; V <= $.length; ++V)
      T[32 - V] = $.charCodeAt($.length - V);
    return T;
  })()
}), actionConversion = (C, e) => ({
  to: C,
  from: e
}), governanceLayout = (C, e, T) => [
  { name: "protocol", binary: "bytes", custom: protocolConversion(C) },
  { name: "action", binary: "uint", size: 1, custom: actionConversion(e, T) },
  { name: "chain", ...chainItem({ allowNull: actionMapping[e][0] }) },
  { name: "actionArgs", binary: "bytes", layout: actionMapping[e][1] }
], governancePayload = (C, e, T) => [e, governanceLayout(C, e, T)], coreBridgePayloads = [
  //see wormhole ethereum/contracts/GovernanceStructs.sol
  //and wormhole solana/bridge/program/src/types.rs
  governancePayload("WormholeCore", "UpgradeContract", 1),
  governancePayload("WormholeCore", "GuardianSetUpgrade", 2),
  governancePayload("WormholeCore", "SetMessageFee", 3),
  governancePayload("WormholeCore", "TransferFees", 4),
  governancePayload("WormholeCore", "RecoverChainId", 5)
  //only evm
], tokenBridgePayloads = [
  //see wormhole ethereum/contracts/bridge/BridgeGovernance.sol
  governancePayload("TokenBridge", "RegisterChain", 1),
  governancePayload("TokenBridge", "UpgradeContract", 2),
  governancePayload("TokenBridge", "RecoverChainId", 3)
], nftBridgePayloads = [
  //see wormhole ethereum/contracts/nft/NFTBridgeGovernance.sol
  governancePayload("NftBridge", "RegisterChain", 1),
  governancePayload("NftBridge", "UpgradeContract", 2),
  governancePayload("NftBridge", "RecoverChainId", 3)
], relayerPayloads = [
  //see wormhole ethereum/contracts/relayer/wormholeRelayer/WormholeRelayerGovernance.sol
  governancePayload("Relayer", "RegisterChain", 1),
  governancePayload("Relayer", "UpgradeContract", 2),
  governancePayload("Relayer", "UpdateDefaultProvider", 3)
], cctpPayloads = [
  //see wormhole-circle-integration evm/src/circle_integration/CircleIntegrationGovernance.sol
  governancePayload("CircleBridge", "UpdateFinality", 1),
  governancePayload("CircleBridge", "RegisterEmitterAndDomain", 2),
  governancePayload("CircleBridge", "UpgradeContract", 3)
], ibcBridgePayloads = [
  //see wormhole cosmwasm/contracts/ibc-translator/src/execute.rs submit_update_chain_to_channel_map
  governancePayload("IbcBridge", "ActionUpdateChannelChain", 1)
], ibcReceiverPayloads = [
  //see wormhole cosmwasm/contracts/wormchain-ibc-receiver/src/contract.rs
  governancePayload("IbcReceiver", "ActionUpdateChannelChain", 1)
], globalAccountantPayloads = [
  //see wormhole cosmwasm/contracts/global-accountant/src/contract.rs handle_accountant_governance_vaa
  governancePayload("GlobalAccountant", "ModifyBalance", 1)
], generalPurposeGovernancePayloads = [
  governancePayload("GeneralPurposeGovernance", "GeneralPurposeEvm", 1),
  governancePayload("GeneralPurposeGovernance", "GeneralPurposeSolana", 2)
], wormchainGovernancePayloads = [
  //see wormhole wormchain/x/wormhole/keeper/msg_server_wasmd.go
  governancePayload("WormchainGovernance", "StoreCode", 1),
  governancePayload("WormchainGovernance", "InstantiateContract", 2),
  governancePayload("WormchainGovernance", "MigrateContract", 3),
  //see wormhole wormchain/x/wormhole/keeper/msg_server_wasm_instantiate_allowlist.go
  governancePayload("WormchainGovernance", "AddWasmInstantiateAllowlist", 4),
  governancePayload("WormchainGovernance", "DeleteWasmInstantiateAllowlist", 5)
], gatewayGovernancePayloads = [
  //see wormhole wormchain/x/wormhole/keeper/msg_server_execute_gateway_governance_vaa.go
  governancePayload("GatewayGovernance", "ScheduleUpgrade", 1),
  governancePayload("GatewayGovernance", "CancelUpgrade", 2),
  governancePayload("GatewayGovernance", "SetIbcComposabilityMwContract", 3)
];
registerPayloadTypes("WormholeCore", coreBridgePayloads);
registerPayloadTypes("TokenBridge", tokenBridgePayloads);
registerPayloadTypes("NftBridge", nftBridgePayloads);
registerPayloadTypes("Relayer", relayerPayloads);
registerPayloadTypes("CircleBridge", cctpPayloads);
registerPayloadTypes("IbcBridge", ibcBridgePayloads);
registerPayloadTypes("IbcReceiver", ibcReceiverPayloads);
registerPayloadTypes("GlobalAccountant", globalAccountantPayloads);
registerPayloadTypes("GeneralPurposeGovernance", generalPurposeGovernancePayloads);
registerPayloadTypes("WormchainGovernance", wormchainGovernancePayloads);
registerPayloadTypes("GatewayGovernance", gatewayGovernancePayloads);
function bind(C, e) {
  return function() {
    return C.apply(e, arguments);
  };
}
const { toString: toString$2 } = Object.prototype, { getPrototypeOf } = Object, kindOf = /* @__PURE__ */ ((C) => (e) => {
  const T = toString$2.call(e);
  return C[T] || (C[T] = T.slice(8, -1).toLowerCase());
})(/* @__PURE__ */ Object.create(null)), kindOfTest = (C) => (C = C.toLowerCase(), (e) => kindOf(e) === C), typeOfTest = (C) => (e) => typeof e === C, { isArray } = Array, isUndefined = typeOfTest("undefined");
function isBuffer(C) {
  return C !== null && !isUndefined(C) && C.constructor !== null && !isUndefined(C.constructor) && isFunction(C.constructor.isBuffer) && C.constructor.isBuffer(C);
}
const isArrayBuffer = kindOfTest("ArrayBuffer");
function isArrayBufferView(C) {
  let e;
  return typeof ArrayBuffer < "u" && ArrayBuffer.isView ? e = ArrayBuffer.isView(C) : e = C && C.buffer && isArrayBuffer(C.buffer), e;
}
const isString = typeOfTest("string"), isFunction = typeOfTest("function"), isNumber = typeOfTest("number"), isObject$3 = (C) => C !== null && typeof C == "object", isBoolean = (C) => C === !0 || C === !1, isPlainObject = (C) => {
  if (kindOf(C) !== "object")
    return !1;
  const e = getPrototypeOf(C);
  return (e === null || e === Object.prototype || Object.getPrototypeOf(e) === null) && !(Symbol.toStringTag in C) && !(Symbol.iterator in C);
}, isDate = kindOfTest("Date"), isFile = kindOfTest("File"), isBlob = kindOfTest("Blob"), isFileList = kindOfTest("FileList"), isStream = (C) => isObject$3(C) && isFunction(C.pipe), isFormData = (C) => {
  let e;
  return C && (typeof FormData == "function" && C instanceof FormData || isFunction(C.append) && ((e = kindOf(C)) === "formdata" || // detect form-data instance
  e === "object" && isFunction(C.toString) && C.toString() === "[object FormData]"));
}, isURLSearchParams = kindOfTest("URLSearchParams"), trim = (C) => C.trim ? C.trim() : C.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
function forEach(C, e, { allOwnKeys: T = !1 } = {}) {
  if (C === null || typeof C > "u")
    return;
  let $, V;
  if (typeof C != "object" && (C = [C]), isArray(C))
    for ($ = 0, V = C.length; $ < V; $++)
      e.call(null, C[$], $, C);
  else {
    const J = T ? Object.getOwnPropertyNames(C) : Object.keys(C), ee = J.length;
    let te;
    for ($ = 0; $ < ee; $++)
      te = J[$], e.call(null, C[te], te, C);
  }
}
function findKey(C, e) {
  e = e.toLowerCase();
  const T = Object.keys(C);
  let $ = T.length, V;
  for (; $-- > 0; )
    if (V = T[$], e === V.toLowerCase())
      return V;
  return null;
}
const _global = typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : dist$2.global, isContextDefined = (C) => !isUndefined(C) && C !== _global;
function merge() {
  const { caseless: C } = isContextDefined(this) && this || {}, e = {}, T = ($, V) => {
    const J = C && findKey(e, V) || V;
    isPlainObject(e[J]) && isPlainObject($) ? e[J] = merge(e[J], $) : isPlainObject($) ? e[J] = merge({}, $) : isArray($) ? e[J] = $.slice() : e[J] = $;
  };
  for (let $ = 0, V = arguments.length; $ < V; $++)
    arguments[$] && forEach(arguments[$], T);
  return e;
}
const extend = (C, e, T, { allOwnKeys: $ } = {}) => (forEach(e, (V, J) => {
  T && isFunction(V) ? C[J] = bind(V, T) : C[J] = V;
}, { allOwnKeys: $ }), C), stripBOM = (C) => (C.charCodeAt(0) === 65279 && (C = C.slice(1)), C), inherits = (C, e, T, $) => {
  C.prototype = Object.create(e.prototype, $), C.prototype.constructor = C, Object.defineProperty(C, "super", {
    value: e.prototype
  }), T && Object.assign(C.prototype, T);
}, toFlatObject = (C, e, T, $) => {
  let V, J, ee;
  const te = {};
  if (e = e || {}, C == null) return e;
  do {
    for (V = Object.getOwnPropertyNames(C), J = V.length; J-- > 0; )
      ee = V[J], (!$ || $(ee, C, e)) && !te[ee] && (e[ee] = C[ee], te[ee] = !0);
    C = T !== !1 && getPrototypeOf(C);
  } while (C && (!T || T(C, e)) && C !== Object.prototype);
  return e;
}, endsWith = (C, e, T) => {
  C = String(C), (T === void 0 || T > C.length) && (T = C.length), T -= e.length;
  const $ = C.indexOf(e, T);
  return $ !== -1 && $ === T;
}, toArray = (C) => {
  if (!C) return null;
  if (isArray(C)) return C;
  let e = C.length;
  if (!isNumber(e)) return null;
  const T = new Array(e);
  for (; e-- > 0; )
    T[e] = C[e];
  return T;
}, isTypedArray = /* @__PURE__ */ ((C) => (e) => C && e instanceof C)(typeof Uint8Array < "u" && getPrototypeOf(Uint8Array)), forEachEntry = (C, e) => {
  const $ = (C && C[Symbol.iterator]).call(C);
  let V;
  for (; (V = $.next()) && !V.done; ) {
    const J = V.value;
    e.call(C, J[0], J[1]);
  }
}, matchAll = (C, e) => {
  let T;
  const $ = [];
  for (; (T = C.exec(e)) !== null; )
    $.push(T);
  return $;
}, isHTMLForm = kindOfTest("HTMLFormElement"), toCamelCase = (C) => C.toLowerCase().replace(
  /[-_\s]([a-z\d])(\w*)/g,
  function(T, $, V) {
    return $.toUpperCase() + V;
  }
), hasOwnProperty = (({ hasOwnProperty: C }) => (e, T) => C.call(e, T))(Object.prototype), isRegExp = kindOfTest("RegExp"), reduceDescriptors = (C, e) => {
  const T = Object.getOwnPropertyDescriptors(C), $ = {};
  forEach(T, (V, J) => {
    e(V, J, C) !== !1 && ($[J] = V);
  }), Object.defineProperties(C, $);
}, freezeMethods = (C) => {
  reduceDescriptors(C, (e, T) => {
    if (isFunction(C) && ["arguments", "caller", "callee"].indexOf(T) !== -1)
      return !1;
    const $ = C[T];
    if (isFunction($)) {
      if (e.enumerable = !1, "writable" in e) {
        e.writable = !1;
        return;
      }
      e.set || (e.set = () => {
        throw Error("Can not rewrite read-only method '" + T + "'");
      });
    }
  });
}, toObjectSet = (C, e) => {
  const T = {}, $ = (V) => {
    V.forEach((J) => {
      T[J] = !0;
    });
  };
  return isArray(C) ? $(C) : $(String(C).split(e)), T;
}, noop$1 = () => {
}, toFiniteNumber = (C, e) => (C = +C, Number.isFinite(C) ? C : e), ALPHA = "abcdefghijklmnopqrstuvwxyz", DIGIT = "0123456789", ALPHABET$3 = {
  DIGIT,
  ALPHA,
  ALPHA_DIGIT: ALPHA + ALPHA.toUpperCase() + DIGIT
}, generateString = (C = 16, e = ALPHABET$3.ALPHA_DIGIT) => {
  let T = "";
  const { length: $ } = e;
  for (; C--; )
    T += e[Math.random() * $ | 0];
  return T;
};
function isSpecCompliantForm(C) {
  return !!(C && isFunction(C.append) && C[Symbol.toStringTag] === "FormData" && C[Symbol.iterator]);
}
const toJSONObject = (C) => {
  const e = new Array(10), T = ($, V) => {
    if (isObject$3($)) {
      if (e.indexOf($) >= 0)
        return;
      if (!("toJSON" in $)) {
        e[V] = $;
        const J = isArray($) ? [] : {};
        return forEach($, (ee, te) => {
          const re = T(ee, V + 1);
          !isUndefined(re) && (J[te] = re);
        }), e[V] = void 0, J;
      }
    }
    return $;
  };
  return T(C, 0);
}, isAsyncFn = kindOfTest("AsyncFunction"), isThenable = (C) => C && (isObject$3(C) || isFunction(C)) && isFunction(C.then) && isFunction(C.catch), utils$6 = {
  isArray,
  isArrayBuffer,
  isBuffer,
  isFormData,
  isArrayBufferView,
  isString,
  isNumber,
  isBoolean,
  isObject: isObject$3,
  isPlainObject,
  isUndefined,
  isDate,
  isFile,
  isBlob,
  isRegExp,
  isFunction,
  isStream,
  isURLSearchParams,
  isTypedArray,
  isFileList,
  forEach,
  merge,
  extend,
  trim,
  stripBOM,
  inherits,
  toFlatObject,
  kindOf,
  kindOfTest,
  endsWith,
  toArray,
  forEachEntry,
  matchAll,
  isHTMLForm,
  hasOwnProperty,
  hasOwnProp: hasOwnProperty,
  // an alias to avoid ESLint no-prototype-builtins detection
  reduceDescriptors,
  freezeMethods,
  toObjectSet,
  toCamelCase,
  noop: noop$1,
  toFiniteNumber,
  findKey,
  global: _global,
  isContextDefined,
  ALPHABET: ALPHABET$3,
  generateString,
  isSpecCompliantForm,
  toJSONObject,
  isAsyncFn,
  isThenable
};
function AxiosError(C, e, T, $, V) {
  Error.call(this), Error.captureStackTrace ? Error.captureStackTrace(this, this.constructor) : this.stack = new Error().stack, this.message = C, this.name = "AxiosError", e && (this.code = e), T && (this.config = T), $ && (this.request = $), V && (this.response = V);
}
utils$6.inherits(AxiosError, Error, {
  toJSON: function() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: utils$6.toJSONObject(this.config),
      code: this.code,
      status: this.response && this.response.status ? this.response.status : null
    };
  }
});
const prototype$1 = AxiosError.prototype, descriptors = {};
[
  "ERR_BAD_OPTION_VALUE",
  "ERR_BAD_OPTION",
  "ECONNABORTED",
  "ETIMEDOUT",
  "ERR_NETWORK",
  "ERR_FR_TOO_MANY_REDIRECTS",
  "ERR_DEPRECATED",
  "ERR_BAD_RESPONSE",
  "ERR_BAD_REQUEST",
  "ERR_CANCELED",
  "ERR_NOT_SUPPORT",
  "ERR_INVALID_URL"
  // eslint-disable-next-line func-names
].forEach((C) => {
  descriptors[C] = { value: C };
});
Object.defineProperties(AxiosError, descriptors);
Object.defineProperty(prototype$1, "isAxiosError", { value: !0 });
AxiosError.from = (C, e, T, $, V, J) => {
  const ee = Object.create(prototype$1);
  return utils$6.toFlatObject(C, ee, function(re) {
    return re !== Error.prototype;
  }, (te) => te !== "isAxiosError"), AxiosError.call(ee, C.message, e, T, $, V), ee.cause = C, ee.name = C.name, J && Object.assign(ee, J), ee;
};
const httpAdapter = null;
function isVisitable(C) {
  return utils$6.isPlainObject(C) || utils$6.isArray(C);
}
function removeBrackets(C) {
  return utils$6.endsWith(C, "[]") ? C.slice(0, -2) : C;
}
function renderKey(C, e, T) {
  return C ? C.concat(e).map(function(V, J) {
    return V = removeBrackets(V), !T && J ? "[" + V + "]" : V;
  }).join(T ? "." : "") : e;
}
function isFlatArray(C) {
  return utils$6.isArray(C) && !C.some(isVisitable);
}
const predicates = utils$6.toFlatObject(utils$6, {}, null, function(e) {
  return /^is[A-Z]/.test(e);
});
function toFormData(C, e, T) {
  if (!utils$6.isObject(C))
    throw new TypeError("target must be an object");
  e = e || new FormData(), T = utils$6.toFlatObject(T, {
    metaTokens: !0,
    dots: !1,
    indexes: !1
  }, !1, function(me, xe) {
    return !utils$6.isUndefined(xe[me]);
  });
  const $ = T.metaTokens, V = T.visitor || se, J = T.dots, ee = T.indexes, re = (T.Blob || typeof Blob < "u" && Blob) && utils$6.isSpecCompliantForm(e);
  if (!utils$6.isFunction(V))
    throw new TypeError("visitor must be a function");
  function ie(he) {
    if (he === null) return "";
    if (utils$6.isDate(he))
      return he.toISOString();
    if (!re && utils$6.isBlob(he))
      throw new AxiosError("Blob is not supported. Use a Buffer instead.");
    return utils$6.isArrayBuffer(he) || utils$6.isTypedArray(he) ? re && typeof Blob == "function" ? new Blob([he]) : dist$2.Buffer.from(he) : he;
  }
  function se(he, me, xe) {
    let ve = he;
    if (he && !xe && typeof he == "object") {
      if (utils$6.endsWith(me, "{}"))
        me = $ ? me : me.slice(0, -2), he = JSON.stringify(he);
      else if (utils$6.isArray(he) && isFlatArray(he) || (utils$6.isFileList(he) || utils$6.endsWith(me, "[]")) && (ve = utils$6.toArray(he)))
        return me = removeBrackets(me), ve.forEach(function(we, Ee) {
          !(utils$6.isUndefined(we) || we === null) && e.append(
            // eslint-disable-next-line no-nested-ternary
            ee === !0 ? renderKey([me], Ee, J) : ee === null ? me : me + "[]",
            ie(we)
          );
        }), !1;
    }
    return isVisitable(he) ? !0 : (e.append(renderKey(xe, me, J), ie(he)), !1);
  }
  const de = [], ue = Object.assign(predicates, {
    defaultVisitor: se,
    convertValue: ie,
    isVisitable
  });
  function fe(he, me) {
    if (!utils$6.isUndefined(he)) {
      if (de.indexOf(he) !== -1)
        throw Error("Circular reference detected in " + me.join("."));
      de.push(he), utils$6.forEach(he, function(ve, Te) {
        (!(utils$6.isUndefined(ve) || ve === null) && V.call(
          e,
          ve,
          utils$6.isString(Te) ? Te.trim() : Te,
          me,
          ue
        )) === !0 && fe(ve, me ? me.concat(Te) : [Te]);
      }), de.pop();
    }
  }
  if (!utils$6.isObject(C))
    throw new TypeError("data must be an object");
  return fe(C), e;
}
function encode$5(C) {
  const e = {
    "!": "%21",
    "'": "%27",
    "(": "%28",
    ")": "%29",
    "~": "%7E",
    "%20": "+",
    "%00": "\0"
  };
  return encodeURIComponent(C).replace(/[!'()~]|%20|%00/g, function($) {
    return e[$];
  });
}
function AxiosURLSearchParams(C, e) {
  this._pairs = [], C && toFormData(C, this, e);
}
const prototype = AxiosURLSearchParams.prototype;
prototype.append = function(e, T) {
  this._pairs.push([e, T]);
};
prototype.toString = function(e) {
  const T = e ? function($) {
    return e.call(this, $, encode$5);
  } : encode$5;
  return this._pairs.map(function(V) {
    return T(V[0]) + "=" + T(V[1]);
  }, "").join("&");
};
function encode$4(C) {
  return encodeURIComponent(C).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
}
function buildURL(C, e, T) {
  if (!e)
    return C;
  const $ = T && T.encode || encode$4, V = T && T.serialize;
  let J;
  if (V ? J = V(e, T) : J = utils$6.isURLSearchParams(e) ? e.toString() : new AxiosURLSearchParams(e, T).toString($), J) {
    const ee = C.indexOf("#");
    ee !== -1 && (C = C.slice(0, ee)), C += (C.indexOf("?") === -1 ? "?" : "&") + J;
  }
  return C;
}
class InterceptorManager {
  constructor() {
    this.handlers = [];
  }
  /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   *
   * @return {Number} An ID used to remove interceptor later
   */
  use(e, T, $) {
    return this.handlers.push({
      fulfilled: e,
      rejected: T,
      synchronous: $ ? $.synchronous : !1,
      runWhen: $ ? $.runWhen : null
    }), this.handlers.length - 1;
  }
  /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {Boolean} `true` if the interceptor was removed, `false` otherwise
   */
  eject(e) {
    this.handlers[e] && (this.handlers[e] = null);
  }
  /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */
  clear() {
    this.handlers && (this.handlers = []);
  }
  /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */
  forEach(e) {
    utils$6.forEach(this.handlers, function($) {
      $ !== null && e($);
    });
  }
}
const transitionalDefaults = {
  silentJSONParsing: !0,
  forcedJSONParsing: !0,
  clarifyTimeoutError: !1
}, URLSearchParams$1 = typeof URLSearchParams < "u" ? URLSearchParams : AxiosURLSearchParams, FormData$1 = typeof FormData < "u" ? FormData : null, Blob$4 = typeof Blob < "u" ? Blob : null, isStandardBrowserEnv = (() => {
  let C;
  return typeof navigator < "u" && ((C = navigator.product) === "ReactNative" || C === "NativeScript" || C === "NS") ? !1 : typeof window < "u" && typeof document < "u";
})(), isStandardBrowserWebWorkerEnv = typeof WorkerGlobalScope < "u" && // eslint-disable-next-line no-undef
self instanceof WorkerGlobalScope && typeof self.importScripts == "function", platform = {
  isBrowser: !0,
  classes: {
    URLSearchParams: URLSearchParams$1,
    FormData: FormData$1,
    Blob: Blob$4
  },
  isStandardBrowserEnv,
  isStandardBrowserWebWorkerEnv,
  protocols: ["http", "https", "file", "blob", "url", "data"]
};
function toURLEncodedForm(C, e) {
  return toFormData(C, new platform.classes.URLSearchParams(), Object.assign({
    visitor: function(T, $, V, J) {
      return platform.isNode && utils$6.isBuffer(T) ? (this.append($, T.toString("base64")), !1) : J.defaultVisitor.apply(this, arguments);
    }
  }, e));
}
function parsePropPath(C) {
  return utils$6.matchAll(/\w+|\[(\w*)]/g, C).map((e) => e[0] === "[]" ? "" : e[1] || e[0]);
}
function arrayToObject(C) {
  const e = {}, T = Object.keys(C);
  let $;
  const V = T.length;
  let J;
  for ($ = 0; $ < V; $++)
    J = T[$], e[J] = C[J];
  return e;
}
function formDataToJSON(C) {
  function e(T, $, V, J) {
    let ee = T[J++];
    const te = Number.isFinite(+ee), re = J >= T.length;
    return ee = !ee && utils$6.isArray(V) ? V.length : ee, re ? (utils$6.hasOwnProp(V, ee) ? V[ee] = [V[ee], $] : V[ee] = $, !te) : ((!V[ee] || !utils$6.isObject(V[ee])) && (V[ee] = []), e(T, $, V[ee], J) && utils$6.isArray(V[ee]) && (V[ee] = arrayToObject(V[ee])), !te);
  }
  if (utils$6.isFormData(C) && utils$6.isFunction(C.entries)) {
    const T = {};
    return utils$6.forEachEntry(C, ($, V) => {
      e(parsePropPath($), V, T, 0);
    }), T;
  }
  return null;
}
const DEFAULT_CONTENT_TYPE = {
  "Content-Type": void 0
};
function stringifySafely(C, e, T) {
  if (utils$6.isString(C))
    try {
      return (e || JSON.parse)(C), utils$6.trim(C);
    } catch ($) {
      if ($.name !== "SyntaxError")
        throw $;
    }
  return (T || JSON.stringify)(C);
}
const defaults = {
  transitional: transitionalDefaults,
  adapter: ["xhr", "http"],
  transformRequest: [function(e, T) {
    const $ = T.getContentType() || "", V = $.indexOf("application/json") > -1, J = utils$6.isObject(e);
    if (J && utils$6.isHTMLForm(e) && (e = new FormData(e)), utils$6.isFormData(e))
      return V && V ? JSON.stringify(formDataToJSON(e)) : e;
    if (utils$6.isArrayBuffer(e) || utils$6.isBuffer(e) || utils$6.isStream(e) || utils$6.isFile(e) || utils$6.isBlob(e))
      return e;
    if (utils$6.isArrayBufferView(e))
      return e.buffer;
    if (utils$6.isURLSearchParams(e))
      return T.setContentType("application/x-www-form-urlencoded;charset=utf-8", !1), e.toString();
    let te;
    if (J) {
      if ($.indexOf("application/x-www-form-urlencoded") > -1)
        return toURLEncodedForm(e, this.formSerializer).toString();
      if ((te = utils$6.isFileList(e)) || $.indexOf("multipart/form-data") > -1) {
        const re = this.env && this.env.FormData;
        return toFormData(
          te ? { "files[]": e } : e,
          re && new re(),
          this.formSerializer
        );
      }
    }
    return J || V ? (T.setContentType("application/json", !1), stringifySafely(e)) : e;
  }],
  transformResponse: [function(e) {
    const T = this.transitional || defaults.transitional, $ = T && T.forcedJSONParsing, V = this.responseType === "json";
    if (e && utils$6.isString(e) && ($ && !this.responseType || V)) {
      const ee = !(T && T.silentJSONParsing) && V;
      try {
        return JSON.parse(e);
      } catch (te) {
        if (ee)
          throw te.name === "SyntaxError" ? AxiosError.from(te, AxiosError.ERR_BAD_RESPONSE, this, null, this.response) : te;
      }
    }
    return e;
  }],
  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,
  xsrfCookieName: "XSRF-TOKEN",
  xsrfHeaderName: "X-XSRF-TOKEN",
  maxContentLength: -1,
  maxBodyLength: -1,
  env: {
    FormData: platform.classes.FormData,
    Blob: platform.classes.Blob
  },
  validateStatus: function(e) {
    return e >= 200 && e < 300;
  },
  headers: {
    common: {
      Accept: "application/json, text/plain, */*"
    }
  }
};
utils$6.forEach(["delete", "get", "head"], function(e) {
  defaults.headers[e] = {};
});
utils$6.forEach(["post", "put", "patch"], function(e) {
  defaults.headers[e] = utils$6.merge(DEFAULT_CONTENT_TYPE);
});
const ignoreDuplicateOf = utils$6.toObjectSet([
  "age",
  "authorization",
  "content-length",
  "content-type",
  "etag",
  "expires",
  "from",
  "host",
  "if-modified-since",
  "if-unmodified-since",
  "last-modified",
  "location",
  "max-forwards",
  "proxy-authorization",
  "referer",
  "retry-after",
  "user-agent"
]), parseHeaders = (C) => {
  const e = {};
  let T, $, V;
  return C && C.split(`
`).forEach(function(ee) {
    V = ee.indexOf(":"), T = ee.substring(0, V).trim().toLowerCase(), $ = ee.substring(V + 1).trim(), !(!T || e[T] && ignoreDuplicateOf[T]) && (T === "set-cookie" ? e[T] ? e[T].push($) : e[T] = [$] : e[T] = e[T] ? e[T] + ", " + $ : $);
  }), e;
}, $internals = Symbol("internals");
function normalizeHeader(C) {
  return C && String(C).trim().toLowerCase();
}
function normalizeValue(C) {
  return C === !1 || C == null ? C : utils$6.isArray(C) ? C.map(normalizeValue) : String(C);
}
function parseTokens(C) {
  const e = /* @__PURE__ */ Object.create(null), T = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
  let $;
  for (; $ = T.exec(C); )
    e[$[1]] = $[2];
  return e;
}
const isValidHeaderName = (C) => /^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(C.trim());
function matchHeaderValue(C, e, T, $, V) {
  if (utils$6.isFunction($))
    return $.call(this, e, T);
  if (V && (e = T), !!utils$6.isString(e)) {
    if (utils$6.isString($))
      return e.indexOf($) !== -1;
    if (utils$6.isRegExp($))
      return $.test(e);
  }
}
function formatHeader(C) {
  return C.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (e, T, $) => T.toUpperCase() + $);
}
function buildAccessors(C, e) {
  const T = utils$6.toCamelCase(" " + e);
  ["get", "set", "has"].forEach(($) => {
    Object.defineProperty(C, $ + T, {
      value: function(V, J, ee) {
        return this[$].call(this, e, V, J, ee);
      },
      configurable: !0
    });
  });
}
class AxiosHeaders {
  constructor(e) {
    e && this.set(e);
  }
  set(e, T, $) {
    const V = this;
    function J(te, re, ie) {
      const se = normalizeHeader(re);
      if (!se)
        throw new Error("header name must be a non-empty string");
      const de = utils$6.findKey(V, se);
      (!de || V[de] === void 0 || ie === !0 || ie === void 0 && V[de] !== !1) && (V[de || re] = normalizeValue(te));
    }
    const ee = (te, re) => utils$6.forEach(te, (ie, se) => J(ie, se, re));
    return utils$6.isPlainObject(e) || e instanceof this.constructor ? ee(e, T) : utils$6.isString(e) && (e = e.trim()) && !isValidHeaderName(e) ? ee(parseHeaders(e), T) : e != null && J(T, e, $), this;
  }
  get(e, T) {
    if (e = normalizeHeader(e), e) {
      const $ = utils$6.findKey(this, e);
      if ($) {
        const V = this[$];
        if (!T)
          return V;
        if (T === !0)
          return parseTokens(V);
        if (utils$6.isFunction(T))
          return T.call(this, V, $);
        if (utils$6.isRegExp(T))
          return T.exec(V);
        throw new TypeError("parser must be boolean|regexp|function");
      }
    }
  }
  has(e, T) {
    if (e = normalizeHeader(e), e) {
      const $ = utils$6.findKey(this, e);
      return !!($ && this[$] !== void 0 && (!T || matchHeaderValue(this, this[$], $, T)));
    }
    return !1;
  }
  delete(e, T) {
    const $ = this;
    let V = !1;
    function J(ee) {
      if (ee = normalizeHeader(ee), ee) {
        const te = utils$6.findKey($, ee);
        te && (!T || matchHeaderValue($, $[te], te, T)) && (delete $[te], V = !0);
      }
    }
    return utils$6.isArray(e) ? e.forEach(J) : J(e), V;
  }
  clear(e) {
    const T = Object.keys(this);
    let $ = T.length, V = !1;
    for (; $--; ) {
      const J = T[$];
      (!e || matchHeaderValue(this, this[J], J, e, !0)) && (delete this[J], V = !0);
    }
    return V;
  }
  normalize(e) {
    const T = this, $ = {};
    return utils$6.forEach(this, (V, J) => {
      const ee = utils$6.findKey($, J);
      if (ee) {
        T[ee] = normalizeValue(V), delete T[J];
        return;
      }
      const te = e ? formatHeader(J) : String(J).trim();
      te !== J && delete T[J], T[te] = normalizeValue(V), $[te] = !0;
    }), this;
  }
  concat(...e) {
    return this.constructor.concat(this, ...e);
  }
  toJSON(e) {
    const T = /* @__PURE__ */ Object.create(null);
    return utils$6.forEach(this, ($, V) => {
      $ != null && $ !== !1 && (T[V] = e && utils$6.isArray($) ? $.join(", ") : $);
    }), T;
  }
  [Symbol.iterator]() {
    return Object.entries(this.toJSON())[Symbol.iterator]();
  }
  toString() {
    return Object.entries(this.toJSON()).map(([e, T]) => e + ": " + T).join(`
`);
  }
  get [Symbol.toStringTag]() {
    return "AxiosHeaders";
  }
  static from(e) {
    return e instanceof this ? e : new this(e);
  }
  static concat(e, ...T) {
    const $ = new this(e);
    return T.forEach((V) => $.set(V)), $;
  }
  static accessor(e) {
    const $ = (this[$internals] = this[$internals] = {
      accessors: {}
    }).accessors, V = this.prototype;
    function J(ee) {
      const te = normalizeHeader(ee);
      $[te] || (buildAccessors(V, ee), $[te] = !0);
    }
    return utils$6.isArray(e) ? e.forEach(J) : J(e), this;
  }
}
AxiosHeaders.accessor(["Content-Type", "Content-Length", "Accept", "Accept-Encoding", "User-Agent", "Authorization"]);
utils$6.freezeMethods(AxiosHeaders.prototype);
utils$6.freezeMethods(AxiosHeaders);
function transformData(C, e) {
  const T = this || defaults, $ = e || T, V = AxiosHeaders.from($.headers);
  let J = $.data;
  return utils$6.forEach(C, function(te) {
    J = te.call(T, J, V.normalize(), e ? e.status : void 0);
  }), V.normalize(), J;
}
function isCancel(C) {
  return !!(C && C.__CANCEL__);
}
function CanceledError(C, e, T) {
  AxiosError.call(this, C ?? "canceled", AxiosError.ERR_CANCELED, e, T), this.name = "CanceledError";
}
utils$6.inherits(CanceledError, AxiosError, {
  __CANCEL__: !0
});
function settle(C, e, T) {
  const $ = T.config.validateStatus;
  !T.status || !$ || $(T.status) ? C(T) : e(new AxiosError(
    "Request failed with status code " + T.status,
    [AxiosError.ERR_BAD_REQUEST, AxiosError.ERR_BAD_RESPONSE][Math.floor(T.status / 100) - 4],
    T.config,
    T.request,
    T
  ));
}
const cookies = platform.isStandardBrowserEnv ? (
  // Standard browser envs support document.cookie
  /* @__PURE__ */ function() {
    return {
      write: function(T, $, V, J, ee, te) {
        const re = [];
        re.push(T + "=" + encodeURIComponent($)), utils$6.isNumber(V) && re.push("expires=" + new Date(V).toGMTString()), utils$6.isString(J) && re.push("path=" + J), utils$6.isString(ee) && re.push("domain=" + ee), te === !0 && re.push("secure"), document.cookie = re.join("; ");
      },
      read: function(T) {
        const $ = document.cookie.match(new RegExp("(^|;\\s*)(" + T + ")=([^;]*)"));
        return $ ? decodeURIComponent($[3]) : null;
      },
      remove: function(T) {
        this.write(T, "", Date.now() - 864e5);
      }
    };
  }()
) : (
  // Non standard browser env (web workers, react-native) lack needed support.
  /* @__PURE__ */ function() {
    return {
      write: function() {
      },
      read: function() {
        return null;
      },
      remove: function() {
      }
    };
  }()
);
function isAbsoluteURL(C) {
  return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(C);
}
function combineURLs(C, e) {
  return e ? C.replace(/\/+$/, "") + "/" + e.replace(/^\/+/, "") : C;
}
function buildFullPath(C, e) {
  return C && !isAbsoluteURL(e) ? combineURLs(C, e) : e;
}
const isURLSameOrigin = platform.isStandardBrowserEnv ? (
  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
  function() {
    const e = /(msie|trident)/i.test(navigator.userAgent), T = document.createElement("a");
    let $;
    function V(J) {
      let ee = J;
      return e && (T.setAttribute("href", ee), ee = T.href), T.setAttribute("href", ee), {
        href: T.href,
        protocol: T.protocol ? T.protocol.replace(/:$/, "") : "",
        host: T.host,
        search: T.search ? T.search.replace(/^\?/, "") : "",
        hash: T.hash ? T.hash.replace(/^#/, "") : "",
        hostname: T.hostname,
        port: T.port,
        pathname: T.pathname.charAt(0) === "/" ? T.pathname : "/" + T.pathname
      };
    }
    return $ = V(window.location.href), function(ee) {
      const te = utils$6.isString(ee) ? V(ee) : ee;
      return te.protocol === $.protocol && te.host === $.host;
    };
  }()
) : (
  // Non standard browser envs (web workers, react-native) lack needed support.
  /* @__PURE__ */ function() {
    return function() {
      return !0;
    };
  }()
);
function parseProtocol(C) {
  const e = /^([-+\w]{1,25})(:?\/\/|:)/.exec(C);
  return e && e[1] || "";
}
function speedometer(C, e) {
  C = C || 10;
  const T = new Array(C), $ = new Array(C);
  let V = 0, J = 0, ee;
  return e = e !== void 0 ? e : 1e3, function(re) {
    const ie = Date.now(), se = $[J];
    ee || (ee = ie), T[V] = re, $[V] = ie;
    let de = J, ue = 0;
    for (; de !== V; )
      ue += T[de++], de = de % C;
    if (V = (V + 1) % C, V === J && (J = (J + 1) % C), ie - ee < e)
      return;
    const fe = se && ie - se;
    return fe ? Math.round(ue * 1e3 / fe) : void 0;
  };
}
function progressEventReducer(C, e) {
  let T = 0;
  const $ = speedometer(50, 250);
  return (V) => {
    const J = V.loaded, ee = V.lengthComputable ? V.total : void 0, te = J - T, re = $(te), ie = J <= ee;
    T = J;
    const se = {
      loaded: J,
      total: ee,
      progress: ee ? J / ee : void 0,
      bytes: te,
      rate: re || void 0,
      estimated: re && ee && ie ? (ee - J) / re : void 0,
      event: V
    };
    se[e ? "download" : "upload"] = !0, C(se);
  };
}
const isXHRAdapterSupported = typeof XMLHttpRequest < "u", xhrAdapter = isXHRAdapterSupported && function(C) {
  return new Promise(function(T, $) {
    let V = C.data;
    const J = AxiosHeaders.from(C.headers).normalize(), ee = C.responseType;
    let te;
    function re() {
      C.cancelToken && C.cancelToken.unsubscribe(te), C.signal && C.signal.removeEventListener("abort", te);
    }
    utils$6.isFormData(V) && (platform.isStandardBrowserEnv || platform.isStandardBrowserWebWorkerEnv ? J.setContentType(!1) : J.setContentType("multipart/form-data;", !1));
    let ie = new XMLHttpRequest();
    if (C.auth) {
      const fe = C.auth.username || "", he = C.auth.password ? unescape(encodeURIComponent(C.auth.password)) : "";
      J.set("Authorization", "Basic " + btoa(fe + ":" + he));
    }
    const se = buildFullPath(C.baseURL, C.url);
    ie.open(C.method.toUpperCase(), buildURL(se, C.params, C.paramsSerializer), !0), ie.timeout = C.timeout;
    function de() {
      if (!ie)
        return;
      const fe = AxiosHeaders.from(
        "getAllResponseHeaders" in ie && ie.getAllResponseHeaders()
      ), me = {
        data: !ee || ee === "text" || ee === "json" ? ie.responseText : ie.response,
        status: ie.status,
        statusText: ie.statusText,
        headers: fe,
        config: C,
        request: ie
      };
      settle(function(ve) {
        T(ve), re();
      }, function(ve) {
        $(ve), re();
      }, me), ie = null;
    }
    if ("onloadend" in ie ? ie.onloadend = de : ie.onreadystatechange = function() {
      !ie || ie.readyState !== 4 || ie.status === 0 && !(ie.responseURL && ie.responseURL.indexOf("file:") === 0) || setTimeout(de);
    }, ie.onabort = function() {
      ie && ($(new AxiosError("Request aborted", AxiosError.ECONNABORTED, C, ie)), ie = null);
    }, ie.onerror = function() {
      $(new AxiosError("Network Error", AxiosError.ERR_NETWORK, C, ie)), ie = null;
    }, ie.ontimeout = function() {
      let he = C.timeout ? "timeout of " + C.timeout + "ms exceeded" : "timeout exceeded";
      const me = C.transitional || transitionalDefaults;
      C.timeoutErrorMessage && (he = C.timeoutErrorMessage), $(new AxiosError(
        he,
        me.clarifyTimeoutError ? AxiosError.ETIMEDOUT : AxiosError.ECONNABORTED,
        C,
        ie
      )), ie = null;
    }, platform.isStandardBrowserEnv) {
      const fe = (C.withCredentials || isURLSameOrigin(se)) && C.xsrfCookieName && cookies.read(C.xsrfCookieName);
      fe && J.set(C.xsrfHeaderName, fe);
    }
    V === void 0 && J.setContentType(null), "setRequestHeader" in ie && utils$6.forEach(J.toJSON(), function(he, me) {
      ie.setRequestHeader(me, he);
    }), utils$6.isUndefined(C.withCredentials) || (ie.withCredentials = !!C.withCredentials), ee && ee !== "json" && (ie.responseType = C.responseType), typeof C.onDownloadProgress == "function" && ie.addEventListener("progress", progressEventReducer(C.onDownloadProgress, !0)), typeof C.onUploadProgress == "function" && ie.upload && ie.upload.addEventListener("progress", progressEventReducer(C.onUploadProgress)), (C.cancelToken || C.signal) && (te = (fe) => {
      ie && ($(!fe || fe.type ? new CanceledError(null, C, ie) : fe), ie.abort(), ie = null);
    }, C.cancelToken && C.cancelToken.subscribe(te), C.signal && (C.signal.aborted ? te() : C.signal.addEventListener("abort", te)));
    const ue = parseProtocol(se);
    if (ue && platform.protocols.indexOf(ue) === -1) {
      $(new AxiosError("Unsupported protocol " + ue + ":", AxiosError.ERR_BAD_REQUEST, C));
      return;
    }
    ie.send(V || null);
  });
}, knownAdapters = {
  http: httpAdapter,
  xhr: xhrAdapter
};
utils$6.forEach(knownAdapters, (C, e) => {
  if (C) {
    try {
      Object.defineProperty(C, "name", { value: e });
    } catch {
    }
    Object.defineProperty(C, "adapterName", { value: e });
  }
});
const adapters = {
  getAdapter: (C) => {
    C = utils$6.isArray(C) ? C : [C];
    const { length: e } = C;
    let T, $;
    for (let V = 0; V < e && (T = C[V], !($ = utils$6.isString(T) ? knownAdapters[T.toLowerCase()] : T)); V++)
      ;
    if (!$)
      throw $ === !1 ? new AxiosError(
        `Adapter ${T} is not supported by the environment`,
        "ERR_NOT_SUPPORT"
      ) : new Error(
        utils$6.hasOwnProp(knownAdapters, T) ? `Adapter '${T}' is not available in the build` : `Unknown adapter '${T}'`
      );
    if (!utils$6.isFunction($))
      throw new TypeError("adapter is not a function");
    return $;
  },
  adapters: knownAdapters
};
function throwIfCancellationRequested(C) {
  if (C.cancelToken && C.cancelToken.throwIfRequested(), C.signal && C.signal.aborted)
    throw new CanceledError(null, C);
}
function dispatchRequest(C) {
  return throwIfCancellationRequested(C), C.headers = AxiosHeaders.from(C.headers), C.data = transformData.call(
    C,
    C.transformRequest
  ), ["post", "put", "patch"].indexOf(C.method) !== -1 && C.headers.setContentType("application/x-www-form-urlencoded", !1), adapters.getAdapter(C.adapter || defaults.adapter)(C).then(function($) {
    return throwIfCancellationRequested(C), $.data = transformData.call(
      C,
      C.transformResponse,
      $
    ), $.headers = AxiosHeaders.from($.headers), $;
  }, function($) {
    return isCancel($) || (throwIfCancellationRequested(C), $ && $.response && ($.response.data = transformData.call(
      C,
      C.transformResponse,
      $.response
    ), $.response.headers = AxiosHeaders.from($.response.headers))), Promise.reject($);
  });
}
const headersToObject = (C) => C instanceof AxiosHeaders ? C.toJSON() : C;
function mergeConfig(C, e) {
  e = e || {};
  const T = {};
  function $(ie, se, de) {
    return utils$6.isPlainObject(ie) && utils$6.isPlainObject(se) ? utils$6.merge.call({ caseless: de }, ie, se) : utils$6.isPlainObject(se) ? utils$6.merge({}, se) : utils$6.isArray(se) ? se.slice() : se;
  }
  function V(ie, se, de) {
    if (utils$6.isUndefined(se)) {
      if (!utils$6.isUndefined(ie))
        return $(void 0, ie, de);
    } else return $(ie, se, de);
  }
  function J(ie, se) {
    if (!utils$6.isUndefined(se))
      return $(void 0, se);
  }
  function ee(ie, se) {
    if (utils$6.isUndefined(se)) {
      if (!utils$6.isUndefined(ie))
        return $(void 0, ie);
    } else return $(void 0, se);
  }
  function te(ie, se, de) {
    if (de in e)
      return $(ie, se);
    if (de in C)
      return $(void 0, ie);
  }
  const re = {
    url: J,
    method: J,
    data: J,
    baseURL: ee,
    transformRequest: ee,
    transformResponse: ee,
    paramsSerializer: ee,
    timeout: ee,
    timeoutMessage: ee,
    withCredentials: ee,
    adapter: ee,
    responseType: ee,
    xsrfCookieName: ee,
    xsrfHeaderName: ee,
    onUploadProgress: ee,
    onDownloadProgress: ee,
    decompress: ee,
    maxContentLength: ee,
    maxBodyLength: ee,
    beforeRedirect: ee,
    transport: ee,
    httpAgent: ee,
    httpsAgent: ee,
    cancelToken: ee,
    socketPath: ee,
    responseEncoding: ee,
    validateStatus: te,
    headers: (ie, se) => V(headersToObject(ie), headersToObject(se), !0)
  };
  return utils$6.forEach(Object.keys(Object.assign({}, C, e)), function(se) {
    const de = re[se] || V, ue = de(C[se], e[se], se);
    utils$6.isUndefined(ue) && de !== te || (T[se] = ue);
  }), T;
}
const VERSION = "1.4.0", validators$1 = {};
["object", "boolean", "number", "function", "string", "symbol"].forEach((C, e) => {
  validators$1[C] = function($) {
    return typeof $ === C || "a" + (e < 1 ? "n " : " ") + C;
  };
});
const deprecatedWarnings = {};
validators$1.transitional = function(e, T, $) {
  function V(J, ee) {
    return "[Axios v" + VERSION + "] Transitional option '" + J + "'" + ee + ($ ? ". " + $ : "");
  }
  return (J, ee, te) => {
    if (e === !1)
      throw new AxiosError(
        V(ee, " has been removed" + (T ? " in " + T : "")),
        AxiosError.ERR_DEPRECATED
      );
    return T && !deprecatedWarnings[ee] && (deprecatedWarnings[ee] = !0, console.warn(
      V(
        ee,
        " has been deprecated since v" + T + " and will be removed in the near future"
      )
    )), e ? e(J, ee, te) : !0;
  };
};
function assertOptions(C, e, T) {
  if (typeof C != "object")
    throw new AxiosError("options must be an object", AxiosError.ERR_BAD_OPTION_VALUE);
  const $ = Object.keys(C);
  let V = $.length;
  for (; V-- > 0; ) {
    const J = $[V], ee = e[J];
    if (ee) {
      const te = C[J], re = te === void 0 || ee(te, J, C);
      if (re !== !0)
        throw new AxiosError("option " + J + " must be " + re, AxiosError.ERR_BAD_OPTION_VALUE);
      continue;
    }
    if (T !== !0)
      throw new AxiosError("Unknown option " + J, AxiosError.ERR_BAD_OPTION);
  }
}
const validator = {
  assertOptions,
  validators: validators$1
}, validators = validator.validators;
class Axios {
  constructor(e) {
    this.defaults = e, this.interceptors = {
      request: new InterceptorManager(),
      response: new InterceptorManager()
    };
  }
  /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */
  request(e, T) {
    typeof e == "string" ? (T = T || {}, T.url = e) : T = e || {}, T = mergeConfig(this.defaults, T);
    const { transitional: $, paramsSerializer: V, headers: J } = T;
    $ !== void 0 && validator.assertOptions($, {
      silentJSONParsing: validators.transitional(validators.boolean),
      forcedJSONParsing: validators.transitional(validators.boolean),
      clarifyTimeoutError: validators.transitional(validators.boolean)
    }, !1), V != null && (utils$6.isFunction(V) ? T.paramsSerializer = {
      serialize: V
    } : validator.assertOptions(V, {
      encode: validators.function,
      serialize: validators.function
    }, !0)), T.method = (T.method || this.defaults.method || "get").toLowerCase();
    let ee;
    ee = J && utils$6.merge(
      J.common,
      J[T.method]
    ), ee && utils$6.forEach(
      ["delete", "get", "head", "post", "put", "patch", "common"],
      (he) => {
        delete J[he];
      }
    ), T.headers = AxiosHeaders.concat(ee, J);
    const te = [];
    let re = !0;
    this.interceptors.request.forEach(function(me) {
      typeof me.runWhen == "function" && me.runWhen(T) === !1 || (re = re && me.synchronous, te.unshift(me.fulfilled, me.rejected));
    });
    const ie = [];
    this.interceptors.response.forEach(function(me) {
      ie.push(me.fulfilled, me.rejected);
    });
    let se, de = 0, ue;
    if (!re) {
      const he = [dispatchRequest.bind(this), void 0];
      for (he.unshift.apply(he, te), he.push.apply(he, ie), ue = he.length, se = Promise.resolve(T); de < ue; )
        se = se.then(he[de++], he[de++]);
      return se;
    }
    ue = te.length;
    let fe = T;
    for (de = 0; de < ue; ) {
      const he = te[de++], me = te[de++];
      try {
        fe = he(fe);
      } catch (xe) {
        me.call(this, xe);
        break;
      }
    }
    try {
      se = dispatchRequest.call(this, fe);
    } catch (he) {
      return Promise.reject(he);
    }
    for (de = 0, ue = ie.length; de < ue; )
      se = se.then(ie[de++], ie[de++]);
    return se;
  }
  getUri(e) {
    e = mergeConfig(this.defaults, e);
    const T = buildFullPath(e.baseURL, e.url);
    return buildURL(T, e.params, e.paramsSerializer);
  }
}
utils$6.forEach(["delete", "get", "head", "options"], function(e) {
  Axios.prototype[e] = function(T, $) {
    return this.request(mergeConfig($ || {}, {
      method: e,
      url: T,
      data: ($ || {}).data
    }));
  };
});
utils$6.forEach(["post", "put", "patch"], function(e) {
  function T($) {
    return function(J, ee, te) {
      return this.request(mergeConfig(te || {}, {
        method: e,
        headers: $ ? {
          "Content-Type": "multipart/form-data"
        } : {},
        url: J,
        data: ee
      }));
    };
  }
  Axios.prototype[e] = T(), Axios.prototype[e + "Form"] = T(!0);
});
class CancelToken {
  constructor(e) {
    if (typeof e != "function")
      throw new TypeError("executor must be a function.");
    let T;
    this.promise = new Promise(function(J) {
      T = J;
    });
    const $ = this;
    this.promise.then((V) => {
      if (!$._listeners) return;
      let J = $._listeners.length;
      for (; J-- > 0; )
        $._listeners[J](V);
      $._listeners = null;
    }), this.promise.then = (V) => {
      let J;
      const ee = new Promise((te) => {
        $.subscribe(te), J = te;
      }).then(V);
      return ee.cancel = function() {
        $.unsubscribe(J);
      }, ee;
    }, e(function(J, ee, te) {
      $.reason || ($.reason = new CanceledError(J, ee, te), T($.reason));
    });
  }
  /**
   * Throws a `CanceledError` if cancellation has been requested.
   */
  throwIfRequested() {
    if (this.reason)
      throw this.reason;
  }
  /**
   * Subscribe to the cancel signal
   */
  subscribe(e) {
    if (this.reason) {
      e(this.reason);
      return;
    }
    this._listeners ? this._listeners.push(e) : this._listeners = [e];
  }
  /**
   * Unsubscribe from the cancel signal
   */
  unsubscribe(e) {
    if (!this._listeners)
      return;
    const T = this._listeners.indexOf(e);
    T !== -1 && this._listeners.splice(T, 1);
  }
  /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */
  static source() {
    let e;
    return {
      token: new CancelToken(function(V) {
        e = V;
      }),
      cancel: e
    };
  }
}
function spread(C) {
  return function(T) {
    return C.apply(null, T);
  };
}
function isAxiosError(C) {
  return utils$6.isObject(C) && C.isAxiosError === !0;
}
const HttpStatusCode = {
  Continue: 100,
  SwitchingProtocols: 101,
  Processing: 102,
  EarlyHints: 103,
  Ok: 200,
  Created: 201,
  Accepted: 202,
  NonAuthoritativeInformation: 203,
  NoContent: 204,
  ResetContent: 205,
  PartialContent: 206,
  MultiStatus: 207,
  AlreadyReported: 208,
  ImUsed: 226,
  MultipleChoices: 300,
  MovedPermanently: 301,
  Found: 302,
  SeeOther: 303,
  NotModified: 304,
  UseProxy: 305,
  Unused: 306,
  TemporaryRedirect: 307,
  PermanentRedirect: 308,
  BadRequest: 400,
  Unauthorized: 401,
  PaymentRequired: 402,
  Forbidden: 403,
  NotFound: 404,
  MethodNotAllowed: 405,
  NotAcceptable: 406,
  ProxyAuthenticationRequired: 407,
  RequestTimeout: 408,
  Conflict: 409,
  Gone: 410,
  LengthRequired: 411,
  PreconditionFailed: 412,
  PayloadTooLarge: 413,
  UriTooLong: 414,
  UnsupportedMediaType: 415,
  RangeNotSatisfiable: 416,
  ExpectationFailed: 417,
  ImATeapot: 418,
  MisdirectedRequest: 421,
  UnprocessableEntity: 422,
  Locked: 423,
  FailedDependency: 424,
  TooEarly: 425,
  UpgradeRequired: 426,
  PreconditionRequired: 428,
  TooManyRequests: 429,
  RequestHeaderFieldsTooLarge: 431,
  UnavailableForLegalReasons: 451,
  InternalServerError: 500,
  NotImplemented: 501,
  BadGateway: 502,
  ServiceUnavailable: 503,
  GatewayTimeout: 504,
  HttpVersionNotSupported: 505,
  VariantAlsoNegotiates: 506,
  InsufficientStorage: 507,
  LoopDetected: 508,
  NotExtended: 510,
  NetworkAuthenticationRequired: 511
};
Object.entries(HttpStatusCode).forEach(([C, e]) => {
  HttpStatusCode[e] = C;
});
function createInstance(C) {
  const e = new Axios(C), T = bind(Axios.prototype.request, e);
  return utils$6.extend(T, Axios.prototype, e, { allOwnKeys: !0 }), utils$6.extend(T, e, null, { allOwnKeys: !0 }), T.create = function(V) {
    return createInstance(mergeConfig(C, V));
  }, T;
}
const axios = createInstance(defaults);
axios.Axios = Axios;
axios.CanceledError = CanceledError;
axios.CancelToken = CancelToken;
axios.isCancel = isCancel;
axios.VERSION = VERSION;
axios.toFormData = toFormData;
axios.AxiosError = AxiosError;
axios.Cancel = axios.CanceledError;
axios.all = function(e) {
  return Promise.all(e);
};
axios.spread = spread;
axios.isAxiosError = isAxiosError;
axios.mergeConfig = mergeConfig;
axios.AxiosHeaders = AxiosHeaders;
axios.formToJSON = (C) => formDataToJSON(utils$6.isHTMLForm(C) ? new FormData(C) : C);
axios.HttpStatusCode = HttpStatusCode;
axios.default = axios;
const DEFAULT_TASK_TIMEOUT = 60 * 1e3, CONFIG$1 = {
  Mainnet: {
    api: "https://api.wormholescan.io",
    circleAPI: circleAPI("Mainnet"),
    chains: buildConfig$1("Mainnet")
  },
  Testnet: {
    api: "https://api.testnet.wormholescan.io",
    circleAPI: circleAPI("Testnet"),
    chains: buildConfig$1("Testnet")
  },
  Devnet: {
    api: "http://guardian:7071",
    // Tilt Guardian REST api
    circleAPI: "",
    chains: buildConfig$1("Devnet")
  }
};
function networkPlatformConfigs(C, e) {
  return Object.fromEntries(Object.entries(CONFIG$1[C].chains).filter(([T, $]) => $.platform == e));
}
function applyWormholeConfigOverrides(C, e) {
  let T = CONFIG$1[C];
  return e ? override(T, e) : T;
}
function applyChainsConfigConfigOverrides(C, e, T) {
  const $ = networkPlatformConfigs(C, e);
  return T ? override($, T) : $;
}
function override(C, e) {
  C || (C = {});
  for (const [T, $] of Object.entries(e))
    typeof $ == "object" && !Array.isArray($) ? C[T] = override(C[T], $) : C[T] = $;
  return C;
}
const inNode = typeof dist$2.process < "u";
inNode && dist$2.process.env.NETWORK;
async function retry(C, e, T = DEFAULT_TASK_TIMEOUT, $) {
  const V = Math.floor(T / e);
  let J = 0;
  return new Promise((ee, te) => {
    C().then((re) => {
      if (re !== null) {
        ee(re);
        return;
      }
      let ie = setInterval(async () => {
        if (J >= V) {
          clearInterval(ie), ee(null);
          return;
        }
        const se = await C();
        se !== null ? (clearInterval(ie), ee(se)) : $ && console.log(`Retrying ${$}, attempt ${J}/${V} `), J++;
      }, e);
    });
  });
}
const CIRCLE_RETRY_INTERVAL = 2e3;
var CircleAttestationStatus;
(function(C) {
  C.complete = "complete", C.pending_confirmations = "pending_confirmations";
})(CircleAttestationStatus || (CircleAttestationStatus = {}));
const mapCircleAttestation = (C) => ({
  message: C.attestation,
  status: C.status
});
async function getCircleAttestation(C, e) {
  var $;
  const T = `${C}/${e}`;
  try {
    const V = await axios.get(T), J = mapCircleAttestation(V == null ? void 0 : V.data);
    return J.message === "PENDING" ? null : J.message;
  } catch (V) {
    if (!V || typeof V == "object" && (axios.isAxiosError(V) && (($ = V.response) == null ? void 0 : $.status) === 404 || "status" in V && V.status === 404))
      return null;
    throw V;
  }
}
async function getCircleAttestationWithRetry(C, e, T) {
  return retry(() => getCircleAttestation(C, e), CIRCLE_RETRY_INTERVAL, T, "Circle:GetAttestation");
}
async function signSendWait(C, e, T) {
  if (!isSigner(T))
    throw new Error("Invalid signer, not SignAndSendSigner or SignOnlySigner");
  return (await ssw(e, async (J) => isSignAndSendSigner(T) ? T.signAndSend(J) : C.sendWait(await T.sign(J)))).map((J) => ({ chain: C.chain, txid: J }));
}
async function ssw(C, e) {
  const T = [];
  let $ = [];
  for await (const V of C)
    V.parallelizable ? $.push(V) : ($.length > 0 && (T.push(...await e($)), $ = []), T.push(...await e([V])));
  return $.length > 0 && T.push(...await e($)), T;
}
var TransferState;
(function(C) {
  C[C.Failed = -1] = "Failed", C[C.Created = 0] = "Created", C[C.SourceInitiated = 1] = "SourceInitiated", C[C.SourceFinalized = 2] = "SourceFinalized", C[C.InReview = 3] = "InReview", C[C.Attested = 4] = "Attested", C[C.Refunded = 5] = "Refunded", C[C.DestinationInitiated = 6] = "DestinationInitiated", C[C.DestinationQueued = 7] = "DestinationQueued", C[C.DestinationFinalized = 8] = "DestinationFinalized";
})(TransferState || (TransferState = {}));
function isSourceInitiated(C) {
  return C.state === TransferState.SourceInitiated;
}
function isSourceFinalized(C) {
  return C.state === TransferState.SourceFinalized;
}
function isInReview(C) {
  return C.state === TransferState.InReview;
}
function isAttested(C) {
  return C.state === TransferState.Attested;
}
function isRefunded(C) {
  return C.state === TransferState.Refunded;
}
function isRedeemed(C) {
  return C.state === TransferState.DestinationInitiated;
}
function isDestinationQueued(C) {
  return C.state === TransferState.DestinationQueued;
}
function isCompleted(C) {
  return C.state === TransferState.DestinationFinalized;
}
function isFailed(C) {
  return C.state < 0;
}
class CircleTransfer {
  constructor(e, T, $, V) {
    tt(this, "wh");
    tt(this, "fromChain");
    tt(this, "toChain");
    // state machine tracker
    tt(this, "_state");
    // transfer details
    tt(this, "transfer");
    // Populated after Initialized
    tt(this, "txids", []);
    tt(this, "attestations");
    this._state = TransferState.Created, this.wh = e, this.transfer = T, this.fromChain = $ ?? e.getChain(T.from.chain), this.toChain = V ?? e.getChain(T.to.chain);
  }
  getTransferState() {
    return this._state;
  }
  static async from(e, T, $ = DEFAULT_TASK_TIMEOUT, V, J) {
    if (isCircleTransferDetails(T))
      return T = {
        ...T,
        ...await CircleTransfer.destinationOverrides(e.getChain(T.from.chain), e.getChain(T.to.chain), T)
      }, new CircleTransfer(e, T, V, J);
    let ee;
    if (isWormholeMessageId(T))
      ee = await CircleTransfer.fromWormholeMessageId(e, T, $);
    else if (isTransactionIdentifier(T))
      ee = await CircleTransfer.fromTransaction(e, T, $, V);
    else if (isCircleMessageId(T))
      ee = await CircleTransfer.fromCircleMessage(e, T);
    else
      throw new Error("Invalid `from` parameter for CircleTransfer");
    return ee.fromChain = V ?? e.getChain(ee.transfer.from.chain), ee.toChain = J ?? e.getChain(ee.transfer.to.chain), await ee.fetchAttestation($), ee;
  }
  // init from the seq id
  static async fromWormholeMessageId(e, T, $) {
    const { chain: V, emitter: J } = T, ee = await CircleTransfer.getTransferVaa(e, T), te = ee.payload.mintRecipient, re = toCircleChain(e.network, ee.payload.targetDomain), { wormholeRelayer: ie } = e.config.chains[re].contracts.cctp;
    let se = !1;
    if (ie) {
      const fe = Wormhole.chainAddress(V, ie).address.toUniversalAddress();
      se = ee.payloadName === "TransferWithRelay" && te.equals(fe);
    }
    const de = {
      from: { chain: T.chain, address: ee.payload.caller },
      to: { chain: re, address: te },
      amount: ee.payload.token.amount,
      automatic: se
    }, ue = new CircleTransfer(e, de);
    return ue.attestations = [{ id: { emitter: J, sequence: ee.sequence, chain: V }, attestation: ee }], ue._state = TransferState.Attested, ue;
  }
  static async fromCircleMessage(e, T) {
    const [$, V] = CircleBridge.deserialize(hex$1.decode(T)), { payload: J } = $, ee = J.messageSender, te = J.mintRecipient, re = toCircleChain(e.network, $.sourceDomain), ie = toCircleChain(e.network, $.destinationDomain), se = {
      from: { chain: re, address: ee },
      to: { chain: ie, address: te },
      amount: J.amount,
      automatic: !1
    }, de = new CircleTransfer(e, se);
    return de.attestations = [{ id: { hash: V }, attestation: { message: $ } }], de._state = TransferState.SourceInitiated, de;
  }
  // init from source tx hash
  static async fromTransaction(e, T, $, V) {
    const { chain: J, txid: ee } = T;
    V = V ?? e.getChain(J);
    let te = [];
    try {
      te = await V.parseTransaction(ee);
    } catch (ie) {
      if (!(ie.message.includes("no bridge messages found") || ie.message.includes("not found"))) throw ie;
    }
    let re;
    if (te.length > 0)
      re = await CircleTransfer.fromWormholeMessageId(e, te[0], $);
    else {
      const se = await (await V.getCircleBridge()).parseTransactionDetails(ee), de = {
        ...se,
        // Note: assuming automatic is false since we didn't find a VAA
        automatic: !1
      };
      re = new CircleTransfer(e, de), re.attestations = [{ id: se.id, attestation: { message: se.message } }];
    }
    return re._state = TransferState.SourceInitiated, re.txids = [T], re;
  }
  // start the WormholeTransfer by submitting transactions to the source chain
  // returns a transaction hash
  async initiateTransfer(e) {
    if (this._state !== TransferState.Created)
      throw new Error("Invalid state transition in `start`");
    return this.txids = await CircleTransfer.transfer(this.fromChain, this.transfer, e), this._state = TransferState.SourceInitiated, this.txids.map(({ txid: T }) => T);
  }
  async _fetchWormholeAttestation(e) {
    let T = this.attestations ?? [];
    if (!T || T.length == 0)
      throw new Error("No VAA details available");
    for (const $ in T)
      T[$].attestation || (T[$].attestation = await CircleTransfer.getTransferVaa(this.wh, T[$].id, e));
    return this.attestations = T, T.map(($) => $.id);
  }
  async _fetchCircleAttestation(e) {
    var $, V;
    let T = this.attestations ?? [];
    if (!T || T.length == 0) {
      if (this.txids.length === 0)
        throw new Error("No circle attestations or transactions to fetch");
      const J = this.txids[(($ = this.txids) == null ? void 0 : $.length) - 1], re = await (await this.wh.getChain(this.transfer.from.chain).getCircleBridge()).parseTransactionDetails(J.txid);
      T = [{ id: re.id, attestation: { message: re.message } }];
    }
    for (const J in T) {
      const ee = T[J];
      if ((V = ee.attestation) != null && V.attestation)
        continue;
      const te = await this.wh.getCircleAttestation(ee.id.hash, e);
      if (te === null)
        throw new Error("No attestation available after timeout exhausted");
      T[J].attestation.attestation = te;
    }
    return this.attestations = T, T.map((J) => J.id);
  }
  // wait for the VAA to be ready
  // returns the sequence number
  async fetchAttestation(e) {
    if (this._state < TransferState.SourceInitiated)
      throw new Error("Invalid state transition in `fetchAttestation`");
    const T = this.transfer.automatic ? (await Promise.all([
      this._fetchWormholeAttestation(e),
      this._fetchCircleAttestation(e)
    ])).flat() : await this._fetchCircleAttestation(e);
    if (this._state = TransferState.Attested, this.attestations && this.attestations.length > 0)
      for (const $ of this.attestations) {
        const { attestation: V } = $;
        if (!CircleBridge.isCircleAttestation(V))
          continue;
        await CircleTransfer.isTransferComplete(this.toChain, V) && (this._state = TransferState.DestinationFinalized);
      }
    return T;
  }
  // finish the WormholeTransfer by submitting transactions to the destination chain
  // returns a transaction hash
  async completeTransfer(e) {
    var de;
    if (this._state < TransferState.Attested)
      throw new Error("Invalid state transition in `finish`");
    if (this.transfer.automatic)
      throw this.attestations ? this.attestations.find((fe) => isWormholeMessageId(fe.id)) ? new Error("No method to redeem auto circle bridge tx (yet)") : new Error("No VAA found") : new Error("No VAA details available");
    if (!this.attestations)
      throw new Error("No Circle Attestations found");
    const T = this.attestations.filter((ue) => isCircleMessageId(ue.id));
    if (T.length > 1)
      throw new Error(`Expected a single circle attestation, found ${T.length}`);
    const { id: $, attestation: V } = T[0];
    if (!V)
      throw new Error(`No Circle Attestation for ${$.hash}`);
    const { message: J, attestation: ee } = V;
    if (!ee)
      throw new Error(`No Circle Attestation for ${$.hash}`);
    const te = await this.toChain.getCircleBridge(), re = Wormhole.parseAddress(e.chain(), e.address()), ie = te.redeem(re, J, ee), se = await signSendWait(this.toChain, ie, e);
    return (de = this.txids) == null || de.push(...se), se.map(({ txid: ue }) => ue);
  }
}
(function(C) {
  async function e(ie, se, de) {
    let ue;
    return se.automatic ? ue = (await ie.getAutomaticCircleBridge()).transfer(se.from.address, { chain: se.to.chain, address: se.to.address }, se.amount, se.nativeGas) : ue = (await ie.getCircleBridge()).transfer(se.from.address, { chain: se.to.chain, address: se.to.address }, se.amount), await signSendWait(ie, ue, de);
  }
  C.transfer = e;
  async function* T(ie, se, de = DEFAULT_TASK_TIMEOUT, ue, fe) {
    var xe, ve;
    const he = Date.now(), me = (Te, we) => Math.max(we - (Date.now() - Te), 0);
    if (ue = ue ?? ie.getChain(se.from), fe = fe ?? ie.getChain(se.to), isSourceInitiated(se)) {
      if (se.originTxs.length === 0)
        throw "Invalid state transition: no originating transactions";
      const Te = se.originTxs[se.originTxs.length - 1], we = await C.getTransferMessage(ue, Te.txid);
      se = {
        ...se,
        attestation: { id: we.id, attestation: { message: we.message } },
        state: TransferState.SourceFinalized
      }, yield se;
    }
    if (isSourceFinalized(se)) {
      if (!se.attestation)
        throw "Invalid state transition: no attestation id";
      if (isWormholeMessageId(se.attestation.id)) {
        let Te = se.attestation.attestation ? se.attestation.attestation : void 0;
        Te || (Te = await C.getTransferVaa(ie, se.attestation.id, me(he, de)), se = {
          ...se,
          attestation: { id: se.attestation.id, attestation: Te },
          state: TransferState.Attested
        }, yield se);
      } else if (isCircleMessageId(se.attestation.id)) {
        const Te = await ie.getCircleAttestation(se.attestation.id.hash, de), we = se.originTxs[se.originTxs.length - 1], Me = await (await ue.getCircleBridge()).parseTransactionDetails(we.txid);
        Te && (se = {
          ...se,
          attestation: {
            id: se.attestation.id,
            attestation: {
              attestation: Te,
              message: Me.message
            }
          },
          state: TransferState.Attested
        }, yield se);
      }
    }
    if (isAttested(se) || isSourceFinalized(se)) {
      if (!se.attestation)
        throw "Invalid state transition";
      if (isWormholeMessageId(se.attestation.id)) {
        const Te = await ie.getTransactionStatus(se.attestation.id, me(he, de));
        if (Te && ((ve = (xe = Te.globalTx) == null ? void 0 : xe.destinationTx) != null && ve.txHash)) {
          const { chainId: we, txHash: Ee } = Te.globalTx.destinationTx;
          se = {
            ...se,
            destinationTxs: [{ chain: toChain(we), txid: Ee }],
            state: TransferState.DestinationInitiated
          }, yield se;
        }
      }
    }
    (isAttested(se) || isRedeemed(se)) && (await C.isTransferComplete(fe, se.attestation.attestation) && (se = {
      ...se,
      state: TransferState.DestinationFinalized,
      destinationTxs: []
    }), yield se);
  }
  C.track = T;
  async function $(ie, se, de) {
    const ue = { ...de };
    if (de.to.chain === "Solana" && !ue.automatic) {
      const fe = Wormhole.parseAddress("Solana", usdcContract.get(se.network, se.chain));
      ue.to = await se.getTokenAccount(ue.to.address, fe);
    }
    return ue;
  }
  C.destinationOverrides = $;
  async function V(ie, se, de) {
    const ue = usdcContract.get(se.network, se.chain);
    if (!ue)
      throw "Invalid transfer, no USDC contract on destination";
    const fe = usdcContract.get(ie.network, ie.chain);
    if (!fe)
      throw "Invalid transfer, no USDC contract on source";
    const he = Wormhole.chainAddress(se.chain, ue), me = Wormhole.chainAddress(ie.chain, fe), xe = (ie.chain === "Polygon" ? 2e3 * 200 : estimateFinalityTime(ie.chain)) + guardianAttestationEta;
    if (!de.automatic)
      return {
        sourceToken: { token: me, amount: de.amount },
        destinationToken: { token: he, amount: de.amount },
        eta: xe
      };
    let ve = de.amount;
    const Te = de.nativeGas ? de.nativeGas : 0n;
    ve -= Te;
    const Ee = await (await ie.getAutomaticCircleBridge()).getRelayerFee(se.chain);
    ve -= Ee;
    let Me = 0n;
    return de.nativeGas && (Me = await (await se.getAutomaticCircleBridge()).nativeTokenAmount(Te)), {
      sourceToken: {
        token: me,
        amount: de.amount
      },
      destinationToken: { token: he, amount: ve },
      relayFee: { token: me, amount: Ee },
      destinationNativeGas: Me,
      eta: xe
    };
  }
  C.quoteTransfer = V;
  async function J(ie, se) {
    if (!CircleBridge.isCircleAttestation(se))
      throw new Error("Must check for completion with circle message");
    return await (await ie.getCircleBridge()).isTransferCompleted(se.message);
  }
  C.isTransferComplete = J;
  async function ee(ie, se, de) {
    const ue = await ie.getVaa(se, "AutomaticCircleBridge:TransferWithRelay", de);
    if (!ue)
      throw new Error("No VAA available after timeout exhausted");
    return ue;
  }
  C.getTransferVaa = ee;
  async function te(ie, se) {
    return await (await ie.getCircleBridge()).parseTransactionDetails(se);
  }
  C.getTransferMessage = te;
  function re(ie) {
    var Te, we;
    const { from: se, to: de } = ie.transfer;
    let ue = {
      from: se.chain,
      to: de.chain,
      state: TransferState.Created
    };
    const fe = ie.txids.filter((Ee) => Ee.chain === ie.transfer.from.chain);
    fe.length > 0 && (ue = {
      ...ue,
      state: TransferState.SourceInitiated,
      originTxs: fe
    });
    const he = ((Te = ie.attestations) == null ? void 0 : Te.filter((Ee) => isWormholeMessageId(Ee.id))) ?? [], me = ((we = ie.attestations) == null ? void 0 : we.filter((Ee) => isCircleMessageId(Ee.id))) ?? [], xe = me.length > 0 ? me[0] : he.length > 0 ? he[0] : void 0;
    xe && xe.id && (ue = {
      ...ue,
      state: TransferState.SourceFinalized,
      attestation: xe
    }, xe.attestation && (ue = {
      ...ue,
      state: TransferState.Attested,
      attestation: { id: xe.id, attestation: xe.attestation }
    }));
    const ve = ie.txids.filter((Ee) => Ee.chain === ie.transfer.to.chain);
    return ve.length > 0 && (ue = {
      ...ue,
      state: TransferState.DestinationInitiated,
      destinationTxs: ve
    }), ue;
  }
  C.getReceipt = re;
})(CircleTransfer || (CircleTransfer = {}));
const WHSCAN_RETRY_INTERVAL = 2e3;
async function getVaaBytes(C, e) {
  var re;
  const { chain: T, emitter: $, sequence: V } = e, J = toChainId(T), ee = stripPrefix("0x", $.toString()), te = `${C}/v1/signed_vaa/${J}/${ee}/${V}`;
  try {
    const { data: { vaaBytes: ie } } = await axios.get(te);
    return b64.decode(ie);
  } catch (ie) {
    if (!ie || typeof ie == "object" && (axios.isAxiosError(ie) && ((re = ie.response) == null ? void 0 : re.status) === 404 || "status" in ie && ie.status === 404))
      return null;
    throw ie;
  }
}
async function getVaaBytesWithRetry(C, e, T) {
  return await retry(() => getVaaBytes(C, e), WHSCAN_RETRY_INTERVAL, T, "Wormholescan:GetVaaBytes");
}
async function getVaa(C, e, T) {
  const $ = await getVaaBytes(C, e);
  return $ ? deserialize$1(T, $) : null;
}
async function getVaaWithRetry(C, e, T, $) {
  return await retry(() => getVaa(C, e, T), WHSCAN_RETRY_INTERVAL, $, "Wormholescan:GetVaaBytes");
}
async function getTransactionStatus$1(C, e) {
  var re;
  const { chain: T, emitter: $, sequence: V } = e, J = toChainId(T), ee = $.toUniversalAddress().toString(), te = `${C}/api/v1/transactions/${J}/${ee}/${V}`;
  try {
    return (await axios.get(te)).data;
  } catch (ie) {
    if (!ie || typeof ie == "object" && (axios.isAxiosError(ie) && ((re = ie.response) == null ? void 0 : re.status) === 404 || "status" in ie && ie.status === 404))
      return null;
    throw ie;
  }
}
async function getTransactionStatusWithRetry(C, e, T) {
  return await retry(() => getTransactionStatus$1(C, e), WHSCAN_RETRY_INTERVAL, T, "Wormholescan:GetTransactionStatus");
}
async function getVaaByTxHash(C, e) {
  var $;
  const T = `${C}/api/v1/vaas?txHash=${e}`;
  try {
    const V = await axios.get(T);
    if (V.data.data.length > 0)
      return V.data.data[0];
  } catch (V) {
    if (!V || typeof V == "object" && (axios.isAxiosError(V) && (($ = V.response) == null ? void 0 : $.status) === 404 || "status" in V && V.status === 404))
      return null;
    throw V;
  }
  return null;
}
async function getVaaByTxHashWithRetry(C, e, T, $) {
  const J = await retry(() => getVaaByTxHash(C, e), WHSCAN_RETRY_INTERVAL, $, "Wormholescan:GetVaaByTxHash");
  return J ? deserialize$1(T, b64.decode(J.vaa)) : null;
}
async function getTxsByAddress(C, e, T = 50, $ = 0) {
  var J;
  const V = `${C}/api/v1/transactions?address=${e}&pageSize=${T}&page=${$}`;
  try {
    const ee = await axios.get(V);
    if (ee.data.transactions.length > 0)
      return ee.data.transactions;
  } catch (ee) {
    if (!ee || typeof ee == "object" && (axios.isAxiosError(ee) && ((J = ee.response) == null ? void 0 : J.status) === 404 || "status" in ee && ee.status === 404))
      return null;
    throw ee;
  }
  return null;
}
async function getGovernedTokens(C) {
  const e = `${C}/v1/governor/token_list`;
  try {
    const T = await axios.get(e);
    if (T.data && T.data.entries.length > 0)
      return T.data.entries.reduce(($, V) => {
        const J = toChain(V.originChainId);
        return $[J] = $[J] || {}, $[J][V.originAddress] = V.price, $;
      }, {});
  } catch {
  }
  return null;
}
async function getGovernorLimits(C) {
  const e = `${C}/v1/governor/available_notional_by_chain`;
  try {
    const T = await axios.get(e);
    if (T.data && T.data.entries.length > 0)
      return T.data.entries.reduce(($, V) => {
        const J = V.bigTransactionSize === "0" ? void 0 : whole(parse$3(V.bigTransactionSize, 2));
        return $[toChain(V.chainId)] = {
          available: whole(parse$3(V.remainingAvailableNotional, 2)),
          limit: whole(parse$3(V.notionalLimit, 2)),
          maxSize: J
        }, $;
      }, {});
  } catch {
  }
  return null;
}
async function getIsVaaEnqueued(C, e) {
  const { chain: T, emitter: $, sequence: V } = e, J = toChainId(T), ee = $.toUniversalAddress().toString(), te = `${C}/v1/governor/is_vaa_enqueued/${J}/${ee}/${V}`;
  return (await axios.get(te)).data.isEnqueued;
}
class TokenTransfer {
  constructor(e, T, $, V) {
    tt(this, "wh");
    tt(this, "fromChain");
    tt(this, "toChain");
    // state machine tracker
    tt(this, "_state");
    // transfer details
    tt(this, "transfer");
    // txids, populated once transactions are submitted
    tt(this, "txids", []);
    // The corresponding vaa representing the TokenTransfer
    // on the source chain (if its been completed and finalized)
    tt(this, "attestations");
    this._state = TransferState.Created, this.wh = e, this.transfer = T, this.fromChain = $ ?? e.getChain(T.from.chain), this.toChain = V ?? e.getChain(T.to.chain);
  }
  getTransferState() {
    return this._state;
  }
  static async from(e, T, $ = 6e3, V, J) {
    if (isTokenTransferDetails(T))
      return V = V ?? e.getChain(T.from.chain), J = J ?? e.getChain(T.to.chain), TokenTransfer.validateTransferDetails(e, T, V, J), T = {
        ...T,
        ...await TokenTransfer.destinationOverrides(V, J, T)
      }, new TokenTransfer(e, T, V, J);
    let ee;
    if (isWormholeMessageId(T))
      ee = await TokenTransfer.fromIdentifier(e, T, $);
    else if (isTransactionIdentifier(T))
      ee = await TokenTransfer.fromTransaction(e, T, $, V);
    else
      throw new Error("Invalid `from` parameter for TokenTransfer");
    return ee.fromChain = V ?? e.getChain(ee.transfer.from.chain), ee.toChain = J ?? e.getChain(ee.transfer.to.chain), await ee.fetchAttestation($), ee;
  }
  // init from the seq id
  static async fromIdentifier(e, T, $) {
    const V = await TokenTransfer.getTransferVaa(e, T, $);
    if (!V)
      throw new Error("VAA not found");
    const J = V.protocolName === "AutomaticTokenBridge";
    let ee = { chain: V.emitterChain, address: V.emitterAddress }, { token: te, to: re } = V.payload, ie;
    if (te.chain === ee.chain)
      ie = await e.getTokenNativeAddress(ee.chain, te.chain, te.address);
    else {
      const ve = await (await (await e.getChain(ee.chain)).getTokenBridge()).getWrappedAsset(te);
      ie = toNative(ee.chain, ve.toString());
    }
    const se = await e.getDecimals(ee.chain, ie), de = scale$1(fromBaseUnits(te.amount, Math.min(se, TokenTransfer.MAX_DECIMALS)), se);
    let ue = 0n;
    J && (ue = V.payload.payload.toNativeTokenAmount, ee = { chain: V.emitterChain, address: V.payload.from }, re = { chain: V.payload.to.chain, address: V.payload.payload.targetRecipient });
    const fe = {
      token: te,
      amount: units(de),
      from: ee,
      to: re,
      automatic: J,
      nativeGas: ue
    }, he = new TokenTransfer(e, fe);
    return he.attestations = [{ id: T, attestation: V }], he._state = TransferState.Attested, he;
  }
  static async fromTransaction(e, T, $, V) {
    V = V ?? e.getChain(T.chain);
    const J = await TokenTransfer.getTransferMessage(V, T.txid, $), ee = await TokenTransfer.fromIdentifier(e, J, $);
    return ee.txids = [T], ee;
  }
  // start the WormholeTransfer by submitting transactions to the source chain
  // returns a transaction hash
  async initiateTransfer(e) {
    if (this._state !== TransferState.Created)
      throw new Error("Invalid state transition in `initiateTransfer`");
    return this.txids = await TokenTransfer.transfer(this.fromChain, this.transfer, e), this._state = TransferState.SourceInitiated, this.txids.map(({ txid: T }) => T);
  }
  // wait for the VAA to be ready
  // returns the sequence number
  async fetchAttestation(e) {
    if (this._state < TransferState.SourceInitiated || this._state > TransferState.Attested)
      throw new Error("Invalid state transition in `fetchAttestation`, expected at least `SourceInitiated`");
    if (!this.attestations || this.attestations.length === 0) {
      if (this.txids.length === 0)
        throw new Error("No VAAs set and txids available to look them up");
      const T = this.txids[this.txids.length - 1], $ = await TokenTransfer.getTransferMessage(this.fromChain, T.txid, e);
      this.attestations = [{ id: $ }];
    }
    for (const T in this.attestations) {
      if (this.attestations[T].attestation)
        continue;
      const $ = await TokenTransfer.getTransferVaa(this.wh, this.attestations[T].id, e);
      if (!$)
        throw new Error("VAA not found");
      this.attestations[T].attestation = $;
    }
    if (this._state = TransferState.Attested, this.attestations.length > 0) {
      const { attestation: T } = this.attestations[0];
      await TokenTransfer.isTransferComplete(this.toChain, T) && (this._state = TransferState.DestinationFinalized);
    }
    return this.attestations.map((T) => T.id);
  }
  // finish the WormholeTransfer by submitting transactions to the destination chain
  // returns a transaction hash
  async completeTransfer(e) {
    if (this._state < TransferState.Attested)
      throw new Error("Invalid state transition, must be attested prior to calling `completeTransfer`.");
    if (!this.attestations)
      throw new Error("No VAA details available");
    const { attestation: T } = this.attestations[0];
    if (!T)
      throw new Error(`No VAA found for ${this.attestations[0].id.sequence}`);
    const $ = await TokenTransfer.redeem(this.toChain, T, e);
    return this.txids.push(...$), this._state = TransferState.DestinationInitiated, $.map(({ txid: V }) => V);
  }
}
(function(C) {
  C.MAX_DECIMALS = 8;
  async function e(fe, he, me) {
    const xe = toNative(me.chain(), me.address()), ve = isTokenId(he.token) ? he.token.address : he.token;
    let Te;
    return he.automatic ? Te = (await fe.getAutomaticTokenBridge()).transfer(xe, he.to, ve, he.amount, he.nativeGas) : Te = (await fe.getTokenBridge()).transfer(xe, he.to, ve, he.amount, he.payload), signSendWait(fe, Te, me);
  }
  C.transfer = e;
  async function T(fe, he, me) {
    const xe = toNative(me.chain(), me.address()), ve = he.protocolName === "AutomaticTokenBridge" ? (await fe.getAutomaticTokenBridge()).redeem(xe, he) : (await fe.getTokenBridge()).redeem(xe, he);
    return signSendWait(fe, ve, me);
  }
  C.redeem = T;
  async function* $(fe, he, me = DEFAULT_TASK_TIMEOUT, xe, ve) {
    var Ee, Me;
    const Te = Date.now(), we = (Ie, ke) => Math.max(ke - (Date.now() - Ie), 0);
    if (xe = xe ?? fe.getChain(he.from), isSourceInitiated(he)) {
      if (he.originTxs.length === 0)
        throw "Origin transactions required to fetch message id";
      const { txid: Ie } = he.originTxs[he.originTxs.length - 1], ke = await C.getTransferMessage(xe, Ie, we(Te, me));
      he = {
        ...he,
        state: TransferState.SourceFinalized,
        attestation: { id: ke }
      }, yield he;
    }
    if (isSourceFinalized(he) || isInReview(he)) {
      if (!he.attestation.id)
        throw "Attestation id required to fetch attestation";
      const { id: Ie } = he.attestation, ke = await C.getTransferVaa(fe, Ie, we(Te, me));
      throw ke ? (he = {
        ...he,
        attestation: { id: Ie, attestation: ke },
        state: TransferState.Attested
      }, yield he) : await C.isTransferEnqueued(fe, Ie) && (he = {
        ...he,
        state: TransferState.InReview
      }, yield he), new Error("Attestation not found");
    }
    if (isAttested(he) || isSourceFinalized(he) || isInReview(he)) {
      if (!he.attestation.id)
        throw "Attestation id required to fetch redeem tx";
      const { id: Ie } = he.attestation, ke = await fe.getTransactionStatus(Ie, we(Te, me));
      if (ke && ((Me = (Ee = ke.globalTx) == null ? void 0 : Ee.destinationTx) != null && Me.txHash)) {
        const { chainId: _e, txHash: De } = ke.globalTx.destinationTx;
        he = {
          ...he,
          destinationTxs: [{ chain: toChain(_e), txid: De }],
          state: TransferState.DestinationInitiated
        };
      }
      yield he;
    }
    if (isAttested(he) || isRedeemed(he)) {
      if (!he.attestation.attestation)
        throw "Signed Attestation required to check for redeem";
      if (he.attestation.attestation.payloadName === "AttestMeta")
        throw new Error("Unable to track an AttestMeta receipt");
      await C.isTransferComplete(ve ?? fe.getChain(he.attestation.attestation.payload.to.chain), he.attestation.attestation) && (he = {
        ...he,
        state: TransferState.DestinationFinalized
      }), yield he;
    }
    yield he;
  }
  C.track = $;
  function V(fe) {
    const { transfer: he } = fe, me = he.from.chain, xe = he.to.chain;
    let ve = {
      from: me,
      to: xe,
      state: TransferState.Created
    };
    const Te = fe.txids.filter((Ie) => Ie.chain === he.from.chain);
    Te.length > 0 && (ve = {
      ...ve,
      state: TransferState.SourceInitiated,
      originTxs: Te
    });
    const we = fe.attestations && fe.attestations.length > 0 ? fe.attestations[0] : void 0, Ee = we && we.id ? { id: we.id, attestation: we.attestation } : void 0;
    Ee && Ee.id && (ve = {
      ...ve,
      state: TransferState.SourceFinalized,
      attestation: { id: Ee.id }
    }, Ee.attestation && (ve = {
      ...ve,
      state: TransferState.Attested,
      attestation: { id: Ee.id, attestation: Ee.attestation }
    }));
    const Me = fe.txids.filter((Ie) => Ie.chain === he.to.chain);
    return Me.length > 0 && (ve = {
      ...ve,
      state: TransferState.DestinationFinalized,
      destinationTxs: Me
    }), ve;
  }
  C.getReceipt = V;
  async function J(fe, he, me) {
    let xe;
    const ve = await fe.getTokenBridge();
    if (isNative$1(me.address)) {
      const Ee = await ve.getWrappedNative();
      xe = {
        chain: me.chain,
        address: await ve.getTokenUniversalAddress(Ee)
      };
    } else
      try {
        let Ee;
        UniversalAddress.instanceof(me.address) ? Ee = await ve.getWrappedAsset(me) : Ee = me.address, xe = await ve.getOriginalAsset(Ee);
      } catch (Ee) {
        if (!Ee.message.includes("not a wrapped asset"))
          throw Ee;
        let Me;
        UniversalAddress.instanceof(me.address) ? Me = await ve.getTokenNativeAddress(fe.chain, me.address) : Me = me.address, xe = { chain: me.chain, address: await ve.getTokenUniversalAddress(Me) };
      }
    const Te = await he.getTokenBridge();
    if (xe.chain === he.chain) {
      const Ee = await Te.getTokenNativeAddress(xe.chain, xe.address);
      return { chain: he.chain, address: Ee };
    }
    const we = await Te.getWrappedAsset(xe);
    return { chain: he.chain, address: we };
  }
  C.lookupDestinationToken = J;
  async function ee(fe, he) {
    return he.protocolName === "AutomaticTokenBridge" && (he = deserialize$1("TokenBridge:TransferWithPayload", serialize$1(he))), (await fe.getTokenBridge()).isTransferCompleted(he);
  }
  C.isTransferComplete = ee;
  async function te(fe, he, me) {
    const xe = await Wormhole.parseMessageFromTx(fe, he, me);
    if (xe.length !== 1)
      throw new Error("Expected a single Wormhole Message, got: " + xe.length);
    return xe[0];
  }
  C.getTransferMessage = te;
  async function re(fe, he, me) {
    const xe = await fe.getVaa(he, TokenBridge.getTransferDiscriminator(), me);
    if (!xe)
      return null;
    if (xe.payloadName === "TransferWithPayload") {
      const { chain: ve, address: Te } = xe.payload.to, { tokenBridgeRelayer: we } = fe.config.chains[ve].contracts, Ee = we ? toUniversal(ve, we) : null;
      if (Ee && Te.equals(Ee))
        return deserialize$1("AutomaticTokenBridge:TransferWithRelay", serialize$1(xe));
    }
    return xe;
  }
  C.getTransferVaa = re;
  async function ie(fe, he) {
    return await fe.getIsVaaEnqueued(he);
  }
  C.isTransferEnqueued = ie;
  function se(fe, he, me, xe) {
    if (he.amount === 0n)
      throw new Error("Amount cannot be 0");
    if (he.from.chain === he.to.chain)
      throw new Error("Cannot transfer to the same chain");
    if (me = me ?? fe.getChain(he.from.chain), xe = xe ?? fe.getChain(he.to.chain), he.automatic) {
      if (he.payload)
        throw new Error("Payload with automatic delivery is not supported");
      if (!me.supportsAutomaticTokenBridge())
        throw new Error(`Automatic Token Bridge not supported on ${he.from.chain}`);
      if (!xe.supportsAutomaticTokenBridge())
        throw new Error(`Automatic Token Bridge not supported on ${he.to.chain}`);
      const ve = he.nativeGas ?? 0n;
      if (ve > he.amount)
        throw new Error(`Native gas amount  > amount (${ve} > ${he.amount})`);
    } else {
      if (he.nativeGas)
        throw new Error("Gas Dropoff is only supported for automatic transfers");
      if (!me.supportsTokenBridge())
        throw new Error(`Token Bridge not supported on ${he.from.chain}`);
      if (!xe.supportsTokenBridge())
        throw new Error(`Token Bridge not supported on ${he.to.chain}`);
    }
  }
  C.validateTransferDetails = se;
  async function de(fe, he, me, xe) {
    const ve = await he.getTokenBridge();
    let Te;
    if (isNative$1(xe.token.address))
      Te = await ve.getWrappedNative();
    else if (UniversalAddress.instanceof(xe.token.address))
      try {
        Te = await ve.getWrappedAsset(xe.token);
      } catch (Se) {
        if (!Se.message.includes("not a wrapped asset"))
          throw Se;
        Te = await ve.getTokenNativeAddress(he.chain, xe.token.address);
      }
    else
      Te = xe.token.address;
    const we = Wormhole.tokenId(he.chain, Te.toString()), Ee = await he.getDecimals(Te), Me = fromBaseUnits(xe.amount, Ee), Ie = truncate(Me, C.MAX_DECIMALS), [ke, _e] = await Promise.all([
      getGovernedTokens(fe.config.api),
      getGovernorLimits(fe.config.api)
    ]), De = [];
    if (_e !== null && he.chain in _e && ke !== null) {
      let Se;
      if (isNative$1(xe.token.address))
        Se = {
          chain: he.chain,
          address: await ve.getTokenUniversalAddress(Te)
        };
      else
        try {
          Se = await ve.getOriginalAsset(xe.token.address);
        } catch (Le) {
          if (!Le.message.includes("not a wrapped asset"))
            throw Le;
          Se = {
            chain: he.chain,
            address: await ve.getTokenUniversalAddress(Te)
          };
        }
      if (Se.chain in ke && Se.address.toString() in ke[Se.chain]) {
        const Le = _e[he.chain], Re = ke[Se.chain][Se.address.toString()] * whole(Ie);
        Le.maxSize && Re > Le.maxSize && De.push({
          type: "GovernorLimitWarning",
          reason: "ExceedsLargeTransferLimit"
        }), Re > Le.available && De.push({
          type: "GovernorLimitWarning",
          reason: "ExceedsRemainingNotional"
        });
      }
    }
    const Fe = await C.lookupDestinationToken(he, me, xe.token), Ae = await me.getDecimals(Fe.address), ne = scale$1(Ie, Ae), oe = estimateFinalityTime(he.chain) + guardianAttestationEta;
    if (!xe.automatic)
      return {
        sourceToken: {
          token: we,
          amount: units(Ie)
        },
        destinationToken: { token: Fe, amount: units(ne) },
        warnings: De.length > 0 ? De : void 0,
        eta: oe
      };
    const le = await (await he.getAutomaticTokenBridge()).getRelayerFee(me.chain, Te), pe = scale$1(truncate(fromBaseUnits(le, Ee), C.MAX_DECIMALS), Ae), ye = xe.nativeGas ?? 0n, Ce = units(scale$1(truncate(fromBaseUnits(ye, Ee), C.MAX_DECIMALS), Ae)), be = 890880n;
    let ae = 0n;
    if (xe.nativeGas) {
      const Se = await me.getAutomaticTokenBridge(), [Le, ze] = await Promise.all([
        Se.maxSwapAmount(Fe.address),
        // Get the actual amount we should receive
        Se.nativeTokenAmount(Fe.address, Ce)
      ]);
      if (Ce > Le)
        throw new Error(`Native gas amount exceeds maximum swap amount: ${fmt(Ce, Ae)}>${fmt(Le, Ae)}`);
      if (me.chain === "Solana" && ze < be)
        throw new Error(`Native gas amount must be at least ${be} lamports`);
      ae = ze;
    }
    const ge = units(ne) - Ce - units(pe);
    if (Fe.chain === "Solana") {
      const Se = await me.getNativeWrappedTokenId();
      if (Fe.address === Se.address && ge < be)
        throw new Error(`Destination amount must be at least ${be} lamports`);
    }
    return {
      sourceToken: {
        token: we,
        amount: units(Ie)
      },
      destinationToken: { token: Fe, amount: ge },
      relayFee: { token: we, amount: le },
      destinationNativeGas: ae,
      warnings: De.length > 0 ? De : void 0,
      eta: oe
    };
  }
  C.quoteTransfer = de;
  async function ue(fe, he, me) {
    const xe = { ...me };
    if (me.to.chain === "Solana" && !xe.automatic) {
      const ve = await C.lookupDestinationToken(fe, he, xe.token);
      xe.to = await he.getTokenAccount(xe.to.address, ve.address);
    }
    if (xe.to.chain === "Sei") {
      if (xe.to.chain === "Sei" && xe.payload)
        throw new Error("Arbitrary payloads unsupported for Sei");
      xe.payload = bytes.encode(JSON.stringify({
        basic_recipient: {
          recipient: b64.encode(xe.to.address.toString())
        }
      }));
      const ve = he.config.contracts.translator;
      if (ve === void 0 || ve === "")
        throw new Error("Unexpected empty translator address");
      xe.to = Wormhole.chainAddress(xe.to.chain, ve);
    }
    return xe;
  }
  C.destinationOverrides = ue;
})(TokenTransfer || (TokenTransfer = {}));
function uniqueTokens(C) {
  if (C.length === 0)
    return [];
  const { chain: e } = C[0];
  if (!C.every((T) => T.chain === e))
    throw new Error("Not every chain is equal");
  return Array.from(new Set(C.map((T) => canonicalAddress(T)))).map((T) => Wormhole.tokenId(e, T));
}
async function getTokenDetails$1(C, e) {
  const T = canonicalAddress(e), $ = C.config.tokenMap ? filters.byAddress(C.config.tokenMap, T) : void 0, V = $ ? $.symbol : void 0, J = isNative$1(e.address) ? await C.getNativeWrappedTokenId() : void 0, ee = Number(await C.getDecimals(e.address));
  return {
    id: e,
    decimals: ee,
    wrapped: J,
    symbol: V
  };
}
class RouteResolver {
  constructor(e, T) {
    tt(this, "wh");
    tt(this, "routeConstructors");
    tt(this, "inputTokenList");
    this.wh = e, this.routeConstructors = T;
  }
  async supportedSourceTokens(e) {
    if (this.inputTokenList)
      return this.inputTokenList;
    const T = await Promise.all(this.routeConstructors.map(async ($) => {
      try {
        return await $.supportedSourceTokens(e);
      } catch (V) {
        return console.error(`Failed to get supported source tokens for ${$.meta.name}: `, V), [];
      }
    }));
    return this.inputTokenList = uniqueTokens(T.flat()), this.inputTokenList;
  }
  async supportedDestinationTokens(e, T, $) {
    const [, V] = resolveWrappedToken(T.network, T.chain, e), J = await Promise.all(this.routeConstructors.map(async (ee) => {
      if (!ee.supportedNetworks().includes(T.network))
        return [];
      const re = ee.supportedChains(T.network);
      if (!re.includes(T.chain) || !re.includes($.chain))
        return [];
      try {
        return await ee.supportedDestinationTokens(V, T, $);
      } catch {
        return [];
      }
    }));
    return uniqueTokens(J.flat());
  }
  async findRoutes(e) {
    return (await Promise.all(this.routeConstructors.map(async ($) => {
      try {
        const V = $.supportedNetworks().includes(this.wh.network) && $.supportedChains(this.wh.network).includes(e.toChain.chain) && $.supportedChains(this.wh.network).includes(e.fromChain.chain), J = canonicalAddress(isNative$1(e.source.id.address) ? e.source.wrapped : e.source.id), ee = (await $.supportedSourceTokens(e.fromChain)).filter((ie) => canonicalAddress(ie) === J).length > 0, te = canonicalAddress(isNative$1(e.destination.id.address) ? e.destination.wrapped : e.destination.id), re = (await $.supportedDestinationTokens(e.source.id, e.fromChain, e.toChain)).filter((ie) => canonicalAddress(ie) === te).length > 0;
        return V && ee && re;
      } catch {
        return !1;
      }
    })).then(($) => this.routeConstructors.filter((V, J) => $[J]))).map(($) => new $(this.wh));
  }
}
class Wormhole {
  constructor(e, T, $) {
    tt(this, "_network");
    tt(this, "_platforms");
    tt(this, "_chains");
    tt(this, "config");
    this._network = e, this.config = applyWormholeConfigOverrides(e, $), this._chains = /* @__PURE__ */ new Map(), this._platforms = /* @__PURE__ */ new Map();
    for (const V of T)
      this._platforms.set(V._platform, new V(e, this.config.chains));
  }
  get network() {
    return this._network;
  }
  /**
   * Creates a CircleTransfer object to move Native USDC from one chain to another
   * @param amount the amount to transfer
   * @param from the address to transfer from
   * @param to the address to transfer to
   * @param automatic whether to use automatic delivery
   * @param payload the payload to send with the transfer
   * @param nativeGas the amount of native gas to send with the transfer
   * @returns the CircleTransfer object
   * @throws Errors if the chain or protocol is not supported
   */
  async circleTransfer(e, T, $, V, J, ee) {
    if (V && J)
      throw new Error("Payload with automatic delivery is not supported");
    if (!isCircleChain(this.network, T.chain) || !isCircleChain(this.network, $.chain) || !isCircleSupported(this.network, T.chain) || !isCircleSupported(this.network, $.chain))
      throw new Error(`Network and chain not supported: ${this.network} ${T.chain} `);
    if (V) {
      const ie = await (await this.getChain(T.chain).getAutomaticCircleBridge()).getRelayerFee($.chain) + (ee || 0n);
      if (e < ie)
        throw new Error(`Amount must be > ${ie} (relayerFee + nativeGas)`);
    }
    return await CircleTransfer.from(this, {
      amount: e,
      from: T,
      to: $,
      automatic: V,
      payload: J,
      nativeGas: ee
    });
  }
  /**
   * Creates a TokenTransfer object to move a token from one chain to another
   * @param token the token to transfer
   * @param amount the amount to transfer
   * @param from the address to transfer from
   * @param to the address to transfer to
   * @param automatic whether to use automatic delivery
   * @param payload the payload to send with the transfer
   * @param nativeGas the amount of native gas to send with the transfer
   * @returns the TokenTransfer object
   * @throws Errors if the chain or protocol is not supported
   */
  async tokenTransfer(e, T, $, V, J, ee, te) {
    return await TokenTransfer.from(this, {
      token: e,
      amount: T,
      from: $,
      to: V,
      automatic: J,
      payload: ee,
      nativeGas: te
    });
  }
  /**
   * Gets a RouteResolver configured with the routes passed
   * @param routes the list RouteConstructors to use
   * @returns the RouteResolver
   */
  resolver(e) {
    return new RouteResolver(this, e);
  }
  /**
   * Gets the contract addresses for a given chain
   * @param chain the chain name
   * @returns the contract addresses
   */
  getContracts(e) {
    var T;
    return (T = this.config.chains[e]) == null ? void 0 : T.contracts;
  }
  /**
   * Returns the platform object, i.e. the class with platform-specific logic and methods
   * @param chain the platform name
   * @returns the platform context class
   * @throws Errors if platform is not found
   */
  getPlatform(e) {
    const T = this._platforms.get(e);
    if (!T)
      throw new Error(`Not able to retrieve platform ${e}. Did it get registered in the constructor?`);
    return T;
  }
  /**
   * Returns the chain "context", i.e. the class with chain-specific logic and methods
   * @param chain the chain name
   * @returns the chain context class
   * @throws Errors if context is not found
   */
  getChain(e) {
    const T = chainToPlatform(e);
    return this._chains.has(e) || this._chains.set(e, this.getPlatform(T).getChain(e)), this._chains.get(e);
  }
  /**
   * Gets the TokenId for a token representation on any chain
   *  These are the Wormhole wrapped token addresses, not necessarily
   *  the canonical version of that token
   *
   * @param chain The chain name to get the wrapped token address
   * @param tokenId The Token ID (chain/address) of the original token
   * @returns The TokenId on the given chain, null if it does not exist
   * @throws Errors if the chain is not supported or the token does not exist
   */
  async getWrappedAsset(e, T) {
    const V = await this.getChain(e).getTokenBridge();
    return { chain: e, address: await V.getWrappedAsset(T) };
  }
  /**
   *  Taking the original TokenId for some wrapped token chain
   *  These are the Wormhole wrapped token addresses, not necessarily
   *  the canonical version of that token
   *
   * @param tokenId The Token ID of the token we're looking up the original asset for
   * @returns The Original TokenId corresponding to the token id passed,
   * @throws Errors if the chain is not supported or the token does not exist
   */
  async getOriginalAsset(e) {
    return await (await this.getChain(e.chain).getTokenBridge()).getOriginalAsset(e.address);
  }
  /**
   * Returns the UniversalAddress of the token. This may require fetching on-chain data.
   * @param chain The chain to get the UniversalAddress for
   * @param token The address to get the UniversalAddress for
   * @returns The UniversalAddress of the token
   */
  async getTokenUniversalAddress(e, T) {
    return await (await this.getChain(e).getTokenBridge()).getTokenUniversalAddress(T);
  }
  /**
   * Returns the native address of the token. This may require fetching on-chain data.
   * @param chain The chain to get the native address for
   * @param originChain The chain the token is from / native to
   * @param token The address to get the native address for
   * @returns The native address of the token
   */
  async getTokenNativeAddress(e, T, $) {
    return await (await this.getChain(e).getTokenBridge()).getTokenNativeAddress(T, $);
  }
  /**
   * Gets the number of decimals for a token on a given chain
   *
   * @param chain The chain name or id of the token/representation
   * @param token The token address
   * @returns The number of decimals
   */
  async getDecimals(e, T) {
    return await this.getChain(e).getDecimals(T);
  }
  /**
   * Fetches the balance of a given token for a wallet
   *
   * @param walletAddress The wallet address
   * @param tokenId The token ID (its home chain and address on the home chain)
   * @param chain The chain name or id
   * @returns The token balance of the wormhole asset as a BigNumber
   */
  async getBalance(e, T, $) {
    return this.getChain(e).getBalance($, T);
  }
  /**
   * Gets the associated token account for chains that require it (only Solana currently).
   *
   * @param token the TokenId of the token to get the token account for
   * @param recipient the address of the primary account that may require a separate token account
   * @returns
   */
  async getTokenAccount(e, T) {
    return this.getChain(e.chain).getTokenAccount(e.address, T.address);
  }
  /**
   * Gets the Raw VAA Bytes from the API or Guardian RPC, finality must be met before the VAA will be available.
   *
   * @param wormholeMessageId The WormholeMessageId corresponding to the VAA to be fetched
   * @param timeout The total amount of time to wait for the VAA to be available
   * @returns The VAA bytes if available
   * @throws Errors if the VAA is not available after the retries
   */
  async getVaaBytes(e, T = DEFAULT_TASK_TIMEOUT) {
    return await getVaaBytesWithRetry(this.config.api, e, T);
  }
  /**
   * Gets a VAA from the API or Guardian RPC, finality must be met before the VAA will be available.
   *
   * @param id The WormholeMessageId or Transaction hash corresponding to the VAA to be fetched
   * @param decodeAs The VAA type to decode the bytes as
   * @param timeout The total amount of time to wait for the VAA to be available
   * @returns The VAA if available
   * @throws Errors if the VAA is not available after the retries
   */
  async getVaa(e, T, $ = DEFAULT_TASK_TIMEOUT) {
    return typeof e == "string" ? await getVaaByTxHashWithRetry(this.config.api, e, T, $) : await getVaaWithRetry(this.config.api, e, T, $);
  }
  /**
   * Gets if the token bridge transfer VAA has been enqueued by the Governor.
   * @param id The WormholeMessageId corresponding to the token bridge transfer VAA to check
   * @returns True if the transfer has been enqueued, false otherwise
   */
  async getIsVaaEnqueued(e) {
    return await getIsVaaEnqueued(this.config.api, e);
  }
  /**
   * Gets the CircleAttestation corresponding to the message hash logged in the transfer transaction.
   * @param msgHash  The keccak256 hash of the message emitted by the circle contract
   * @param timeout The total amount of time to wait for the VAA to be available
   * @returns The CircleAttestation as a string, if available
   * @throws Errors if the CircleAttestation is not available after the retries
   */
  async getCircleAttestation(e, T = DEFAULT_TASK_TIMEOUT) {
    return getCircleAttestationWithRetry(this.config.circleAPI, e, T);
  }
  /**
   * Get the status of a transaction, identified by the chain, emitter address, and sequence number
   *
   * @param id the message id for the Wormhole Message to get transaction status for or originating Transaction hash
   * @returns the TransactionStatus
   */
  async getTransactionStatus(e, T = DEFAULT_TASK_TIMEOUT) {
    let $;
    if (typeof e == "string") {
      const V = await getVaaByTxHashWithRetry(this.config.api, e, "Uint8Array", T);
      if (!V)
        return null;
      $ = { emitter: V.emitterAddress, chain: V.emitterChain, sequence: V.sequence };
    } else
      $ = e;
    return await getTransactionStatusWithRetry(this.config.api, $, T);
  }
  /**
   * Get recent transactions for an address
   *
   * @param address the string formatted address to get transactions for
   * @returns the TransactionStatus
   */
  async getTransactionsForAddress(e, T = 50, $ = 0) {
    return getTxsByAddress(this.config.api, e, T, $);
  }
  /**
   * Parse an address from its canonical string format to a NativeAddress
   *
   * @param chain The chain the address is for
   * @param address The address in canonical string format
   * @returns The address in the NativeAddress format
   */
  static parseAddress(e, T) {
    return toNative(e, T);
  }
  /**
   * Return a string in the canonical chain format representing the address
   * of a token or account
   *
   * @param chainAddress The ChainAddress or TokenId to get a string address
   * @returns The string address in canonical format for the chain
   */
  static canonicalAddress(e) {
    return canonicalAddress(e);
  }
  /**
   * Parse an address from its canonical string format to a NativeAddress
   *
   * @param chain The chain the address is for
   * @param address The native address in canonical string format
   * @returns The ChainAddress
   */
  static chainAddress(e, T) {
    return { chain: e, address: Wormhole.parseAddress(e, T) };
  }
  /**
   * Parse an address from its canonical string format to a NativeAddress
   *
   * @param chain The chain the address is for
   * @param address The native address in canonical string format or the string "native"
   * @returns The ChainAddress
   */
  static tokenId(e, T) {
    return isNative$1(T) ? nativeTokenId(e) : this.chainAddress(e, T);
  }
  /**
   * Parses all relevant information from a transaction given the sending tx hash and sending chain
   *
   * @param chain The sending chain name or context
   * @param tx The sending transaction hash
   * @returns The parsed WormholeMessageId
   */
  static async parseMessageFromTx(e, T, $ = DEFAULT_TASK_TIMEOUT) {
    const J = await retry(async () => {
      try {
        const ee = await e.parseTransaction(T);
        return ee.length === 0 ? null : ee;
      } catch (ee) {
        return console.error(ee), null;
      }
    }, e.config.blockTime, $, "WormholeCore:ParseMessageFromTransaction");
    if (!J)
      throw new Error(`No WormholeMessageId found for ${T}`);
    return J;
  }
}
class Route {
  constructor(e) {
    tt(this, "wh");
    this.wh = e;
  }
  // Get the url to view the transfer on the explorer for the route provider
  transferUrl(e) {
    return `https://wormholescan.io/#/tx/${e}?network=${this.wh.network}`;
  }
}
class AutomaticRoute extends Route {
}
tt(AutomaticRoute, "IS_AUTOMATIC", !0);
function isAutomatic(C) {
  return !!C.constructor.IS_AUTOMATIC;
}
class ManualRoute extends Route {
}
tt(ManualRoute, "NATIVE_GAS_DROPOFF_SUPPORTED", !1), tt(ManualRoute, "IS_AUTOMATIC", !1);
function isManual(C) {
  return C.complete !== void 0;
}
class FinalizableRoute extends Route {
}
function isFinalizable(C) {
  return C.finalize !== void 0;
}
class RouteTransferRequest {
  constructor(e, T, $, V) {
    tt(this, "source");
    tt(this, "destination");
    tt(this, "fromChain");
    tt(this, "toChain");
    this.fromChain = e, this.toChain = T, this.source = $, this.destination = V;
  }
  parseAmount(e) {
    return parse$3(e, this.source.decimals);
  }
  amountFromBaseUnits(e) {
    return fromBaseUnits(e, this.source.decimals);
  }
  async displayQuote(e, T, $) {
    let V = {
      success: !0,
      sourceToken: {
        token: e.sourceToken.token,
        amount: fromBaseUnits(e.sourceToken.amount, this.source.decimals)
      },
      destinationToken: {
        token: e.destinationToken.token,
        amount: fromBaseUnits(e.destinationToken.amount, this.destination.decimals)
      },
      params: T
    };
    if (e.relayFee) {
      const ee = await (e.relayFee.token.chain === this.fromChain.chain ? this.fromChain : this.toChain).getDecimals(e.relayFee.token.address);
      V.relayFee = {
        token: e.relayFee.token,
        amount: fromBaseUnits(e.relayFee.amount, ee)
      };
    }
    if (e.destinationNativeGas) {
      const J = await this.toChain.getDecimals("native");
      V.destinationNativeGas = fromBaseUnits(e.destinationNativeGas, J);
    }
    return e.warnings && e.warnings.length > 0 && (V.warnings = [...e.warnings]), V.eta = e.eta, $ && (V.details = $), V;
  }
  static async create(e, T, $, V) {
    $ = $ ?? e.getChain(T.source.chain), V = V ?? e.getChain(T.destination.chain);
    const J = await getTokenDetails$1($, T.source), ee = await getTokenDetails$1(V, T.destination);
    return new RouteTransferRequest($, V, J, ee);
  }
}
class MinAmountError extends Error {
  constructor(T) {
    super(`Minimum transfer amount is ${display(T)}`);
    tt(this, "min");
    this.min = T;
  }
  minAmount() {
    return this.min;
  }
}
class UnavailableError extends Error {
  constructor(T) {
    super("Unable to fetch a quote");
    tt(this, "internalError");
    this.internalError = T;
  }
}
async function checkAndCompleteTransfer(C, e, T, $ = 120 * 1e3, V = console.log) {
  const J = Date.now();
  V("Checking transfer state...");
  for await (e of C.track(e, 120 * 1e3))
    V("Current Transfer State: ", TransferState[e.state]);
  if (isCompleted(e))
    return e;
  if (isManual(C) && isAttested(e) && T) {
    V("Completing transfer...");
    const te = await C.complete(T, e);
    V("Completed transfer with txids: ", te);
  }
  if (isFinalizable(C) && isRedeemed(e) && T) {
    V("Finalizing transfer...");
    const te = await C.finalize(T, e);
    V("Finalized transfer with txids: ", te);
  }
  const ee = $ - (Date.now() - J);
  return ee > 0 ? (V("Transfer not complete, trying again in a 2000ms..."), await new Promise((re) => setTimeout(re, 2e3)), checkAndCompleteTransfer(C, e, T, ee)) : e;
}
var Rs;
let AutomaticTokenBridgeRoute$1 = (Rs = class extends AutomaticRoute {
  static supportedNetworks() {
    return ["Mainnet", "Testnet"];
  }
  // get the list of chains this route supports
  static supportedChains(e) {
    return tokenBridgeRelayerChains.has(e) ? tokenBridgeRelayerChains.get(e) : [];
  }
  // get the list of source tokens that are possible to send
  static async supportedSourceTokens(e) {
    const $ = await (await e.getAutomaticTokenBridge()).getRegisteredTokens();
    return [
      nativeTokenId(e.chain),
      ...$.map((V) => ({ chain: e.chain, address: V }))
    ];
  }
  // get the list of destination tokens that may be received on the destination chain
  static async supportedDestinationTokens(e, T, $) {
    try {
      const V = await TokenTransfer.lookupDestinationToken(T, $, e);
      if (!await (await $.getAutomaticTokenBridge()).isRegisteredToken(V.address))
        throw new Error("Destination token is not accepted by the AutomaticTokenBridge");
      return [V];
    } catch (V) {
      return console.error(`Failed to get destination token: ${V}`), [];
    }
  }
  getDefaultOptions() {
    return { nativeGas: 0 };
  }
  async validate(e, T) {
    try {
      const $ = T.options ?? this.getDefaultOptions();
      if ($.nativeGas && ($.nativeGas > 1 || $.nativeGas < 0))
        throw new Error("Native gas must be between 0.0 and 1.0 (0% and 100%)");
      const { destination: V } = e;
      isNative$1(V.id.address) && $.nativeGas === 0 && ($.nativeGas = 0);
      const J = { ...T, options: $ };
      return { valid: !0, params: {
        ...J,
        normalizedParams: await this.normalizeTransferParams(e, J)
      } };
    } catch ($) {
      return { valid: !1, params: T, error: $ };
    }
  }
  async normalizeTransferParams(e, T) {
    const $ = e.parseAmount(T.amount), V = isNative$1(e.source.id.address) ? await e.fromChain.getNativeWrappedTokenId() : e.source.id, ee = await (await e.fromChain.getAutomaticTokenBridge()).getRelayerFee(e.toChain.chain, V.address), te = ee * 105n / 100n;
    if (units($) < te)
      throw new MinAmountError(fromBaseUnits(te, $.decimals));
    const re = units($) - ee;
    let ie = fromBaseUnits(0n, e.source.decimals);
    if (T.options && T.options.nativeGas > 0) {
      let de = await (await e.toChain.getAutomaticTokenBridge()).maxSwapAmount(e.destination.id.address);
      const ue = truncate(fromBaseUnits(re, $.decimals), TokenTransfer.MAX_DECIMALS), fe = await e.toChain.getDecimals(e.destination.id.address), he = units(scale$1(ue, fe));
      he < de && (de = he);
      const me = 1e4, xe = BigInt(Math.floor(T.options.nativeGas * me)), ve = de * xe / BigInt(me), Te = fromBaseUnits(ve, e.destination.decimals);
      ie = scale$1(truncate(Te, TokenTransfer.MAX_DECIMALS), e.source.decimals), units(ie) > re && (ie = fromBaseUnits(re, e.source.decimals));
    }
    return {
      fee: fromBaseUnits(ee, e.source.decimals),
      amount: $,
      nativeGasAmount: ie
    };
  }
  async quote(e, T) {
    const $ = await e.fromChain.getAutomaticTokenBridge();
    if (isTokenId(e.source.id) && !await $.isRegisteredToken(e.source.id.address))
      return {
        success: !1,
        error: new Error("Source token is not registered")
      };
    try {
      let V = await TokenTransfer.quoteTransfer(this.wh, e.fromChain, e.toChain, {
        automatic: !0,
        amount: units(T.normalizedParams.amount),
        token: e.source.id,
        nativeGas: units(T.normalizedParams.nativeGasAmount)
      });
      return e.displayQuote(V, T);
    } catch (V) {
      return {
        success: !1,
        error: V
      };
    }
  }
  async initiate(e, T, $, V) {
    const { params: J } = $, ee = this.toTransferDetails(e, J, Wormhole.chainAddress(T.chain(), T.address()), V), te = await TokenTransfer.transfer(e.fromChain, ee, T);
    return {
      from: ee.from.chain,
      to: ee.to.chain,
      state: TransferState.SourceInitiated,
      originTxs: te
    };
  }
  async *track(e, T) {
    try {
      yield* TokenTransfer.track(this.wh, e, T);
    } catch ($) {
      throw $;
    }
  }
  toTransferDetails(e, T, $, V) {
    return {
      from: $,
      to: V,
      automatic: !0,
      amount: units(T.normalizedParams.amount),
      token: e.source.id,
      nativeGas: units(T.normalizedParams.nativeGasAmount)
    };
  }
}, tt(Rs, "NATIVE_GAS_DROPOFF_SUPPORTED", !0), tt(Rs, "meta", {
  name: "AutomaticTokenBridge"
}), Rs);
var Xs;
let TokenBridgeRoute$1 = (Xs = class extends ManualRoute {
  static supportedNetworks() {
    return ["Mainnet", "Testnet"];
  }
  // get the list of chains this route supports
  static supportedChains(e) {
    return tokenBridgeChains(e);
  }
  // get the list of source tokens that are possible to send
  static async supportedSourceTokens(e) {
    return Object.values(e.config.tokenMap).map((T) => Wormhole.tokenId(T.chain, T.address));
  }
  // get the list of destination tokens that may be received on the destination chain
  static async supportedDestinationTokens(e, T, $) {
    try {
      return [await TokenTransfer.lookupDestinationToken(T, $, e)];
    } catch (V) {
      return console.error(`Failed to get destination token: ${V}`), [];
    }
  }
  getDefaultOptions() {
    return { payload: void 0 };
  }
  async validate(e, T) {
    const $ = parse$3(T.amount, e.source.decimals);
    return { valid: !0, params: {
      amount: T.amount,
      normalizedParams: { amount: $ },
      options: {}
    } };
  }
  async quote(e, T) {
    try {
      return e.displayQuote(await TokenTransfer.quoteTransfer(this.wh, e.fromChain, e.toChain, {
        token: e.source.id,
        amount: units(T.normalizedParams.amount),
        ...T.options
      }), T);
    } catch ($) {
      return {
        success: !1,
        error: $
      };
    }
  }
  async initiate(e, T, $, V) {
    const { params: J } = $, ee = await TokenTransfer.destinationOverrides(e.fromChain, e.toChain, this.toTransferDetails(e, J, Wormhole.chainAddress(T.chain(), T.address()), V)), te = await TokenTransfer.transfer(e.fromChain, ee, T);
    return {
      from: ee.from.chain,
      to: ee.to.chain,
      state: TransferState.SourceInitiated,
      originTxs: te
    };
  }
  async complete(e, T) {
    if (!isAttested(T))
      throw new Error("The source must be finalized in order to complete the transfer");
    const $ = this.wh.getChain(T.to), V = await TokenTransfer.redeem($, T.attestation.attestation, e);
    return {
      ...T,
      state: TransferState.DestinationInitiated,
      destinationTxs: V
    };
  }
  async resume(e) {
    const T = await TokenTransfer.from(this.wh, e, 1e4);
    return TokenTransfer.getReceipt(T);
  }
  async *track(e, T) {
    yield* TokenTransfer.track(this.wh, e, T);
  }
  toTransferDetails(e, T, $, V) {
    return {
      from: $,
      to: V,
      token: e.source.id,
      amount: units(T.normalizedParams.amount),
      ...T.options
    };
  }
}, tt(Xs, "meta", {
  name: "ManualTokenBridge"
}), Xs);
const SLIPPAGE_BPS = 15n, MAX_SLIPPAGE_BPS = 100n, BPS_PER_HUNDRED_PERCENT = 10000n;
var ai;
let AutomaticPorticoRoute$1 = (ai = class extends AutomaticRoute {
  static supportedNetworks() {
    return ["Mainnet"];
  }
  static supportedChains(e) {
    return porticoContractChains.has(e) ? porticoContractChains.get(e) : [];
  }
  static async supportedSourceTokens(e) {
    const T = await e.getPorticoBridge(), { tokenMap: $ } = e.config;
    return T.supportedTokens().filter((V) => !$ || filters.byAddress($, canonicalAddress(V.token))).map((V) => V.token);
  }
  static async supportedDestinationTokens(e, T, $) {
    const [, V] = resolveWrappedToken(T.network, T.chain, e), J = canonicalAddress(V), ee = await T.getPorticoBridge();
    try {
      const de = await ee.getTransferrableToken(J);
      await TokenTransfer.lookupDestinationToken(T, $, de);
    } catch {
      return [];
    }
    const re = (await $.getPorticoBridge()).supportedTokens(), { tokenMap: ie } = $.config, se = ee.getTokenGroup(J);
    return re.filter((de) => (de.group === se || // ETH/WETH supports wrapping/unwrapping
    de.group === "ETH" && se === "WETH" || de.group === "WETH" && se === "ETH") && (!ie || filters.byAddress(ie, canonicalAddress(de.token)))).map((de) => de.token);
  }
  getDefaultOptions() {
    return {};
  }
  async validate(e, T) {
    try {
      if (!ai.supportedChains(e.fromChain.network).includes(e.fromChain.chain) || !ai.supportedChains(e.toChain.network).includes(e.toChain.chain))
        throw new Error("Protocol not supported");
      const { fromChain: $, toChain: V, source: J, destination: ee } = e, { network: te } = $, [, re] = resolveWrappedToken(te, $.chain, J.id), [, ie] = resolveWrappedToken(te, V.chain, ee.id), se = await $.getPorticoBridge(), de = await V.getPorticoBridge(), ue = await se.getTransferrableToken(canonicalAddress(re)), fe = await de.getTransferrableToken(canonicalAddress(ie));
      return { valid: !0, params: {
        amount: T.amount,
        options: T.options ?? this.getDefaultOptions(),
        normalizedParams: {
          amount: e.parseAmount(T.amount),
          canonicalSourceToken: ue,
          canonicalDestinationToken: fe,
          sourceToken: re,
          destinationToken: ie
        }
      } };
    } catch ($) {
      return { valid: !1, error: $, params: T };
    }
  }
  async quote(e, T) {
    try {
      const $ = await this.fetchSwapQuote(e, T), V = Math.max(e.source.decimals, e.destination.decimals), J = units(scale$1(T.normalizedParams.amount, V));
      if (units(scale$1(fromBaseUnits($.minAmountFinish, e.destination.decimals), V)) < J - J * MAX_SLIPPAGE_BPS / BPS_PER_HUNDRED_PERCENT)
        throw new Error("Slippage too high");
      const re = await (await e.toChain.getPorticoBridge()).quoteRelay(T.normalizedParams.canonicalDestinationToken.address, T.normalizedParams.destinationToken.address), ie = {
        swapAmounts: $,
        relayerFee: re
      }, se = ie.swapAmounts.minAmountFinish - re;
      return se < 0n ? {
        success: !1,
        error: new Error(`Amount too low for slippage and fee, would result in negative destination amount (${se})`)
      } : await e.displayQuote({
        sourceToken: {
          token: T.normalizedParams.sourceToken,
          amount: units(T.normalizedParams.amount)
        },
        destinationToken: {
          token: T.normalizedParams.destinationToken,
          amount: ie.swapAmounts.minAmountFinish - re
        },
        relayFee: {
          token: T.normalizedParams.destinationToken,
          amount: re
        },
        eta: estimateFinalityTime(e.fromChain.chain)
      }, T, ie);
    } catch ($) {
      return {
        success: !1,
        error: $
      };
    }
  }
  async initiate(e, T, $, V) {
    const { params: J, details: ee } = $, te = e.source.id.address, re = e.destination.id, ie = await e.fromChain.getPorticoBridge(), se = ie.getTokenGroup(te.toString()), ue = (await e.toChain.getPorticoBridge()).getPorticoAddress(se), fe = ie.transfer(Wormhole.parseAddress(T.chain(), T.address()), V, te, units(J.normalizedParams.amount), re, ue, ee);
    return {
      originTxs: await signSendWait(e.fromChain, fe, T),
      state: TransferState.SourceInitiated,
      from: e.fromChain.chain,
      to: e.toChain.chain
    };
  }
  async *track(e, T) {
    if (isSourceInitiated(e) || isSourceFinalized(e)) {
      const { txid: $ } = e.originTxs[e.originTxs.length - 1], V = await this.wh.getVaa($, "PorticoBridge:Transfer", T);
      if (!V)
        throw new Error("No VAA found for transaction: " + $);
      const J = {
        chain: V.emitterChain,
        emitter: V.emitterAddress,
        sequence: V.sequence
      };
      e = {
        ...e,
        state: TransferState.Attested,
        attestation: {
          id: J,
          attestation: V
        }
      }, yield e;
    }
    isAttested(e) && await (await this.wh.getChain(e.to).getPorticoBridge()).isTransferCompleted(e.attestation.attestation) && (e = {
      ...e,
      state: TransferState.DestinationFinalized
    }, yield e), yield e;
  }
  async complete(e, T) {
    if (!isAttested(T))
      throw new Error("Source must be attested");
    const $ = await this.wh.getChain(T.to), V = await $.getPorticoBridge(), J = Wormhole.chainAddress(e.chain(), e.address()), ee = V.redeem(J.address, T.attestation.attestation);
    return await signSendWait($, ee, e);
  }
  async fetchSwapQuote(e, T) {
    const $ = await e.fromChain.getPorticoBridge(), V = units(T.normalizedParams.amount), J = $.getTokenGroup(canonicalAddress(T.normalizedParams.sourceToken)), ee = await $.quoteSwap(T.normalizedParams.sourceToken.address, T.normalizedParams.canonicalSourceToken.address, J, V), te = ee * SLIPPAGE_BPS / BPS_PER_HUNDRED_PERCENT;
    if (te >= ee)
      throw new Error("Start slippage too high");
    const re = await e.toChain.getPorticoBridge(), ie = ee - te, se = await re.quoteSwap(T.normalizedParams.canonicalDestinationToken.address, T.normalizedParams.destinationToken.address, J, ie), de = se * SLIPPAGE_BPS / BPS_PER_HUNDRED_PERCENT;
    if (de >= se)
      throw new Error("Finish slippage too high");
    const ue = se - de;
    return {
      minAmountStart: ie,
      minAmountFinish: ue
    };
  }
}, tt(ai, "NATIVE_GAS_DROPOFF_SUPPORTED", !1), tt(ai, "meta", {
  name: "AutomaticPortico"
}), ai);
var Js;
let CCTPRoute$1 = (Js = class extends ManualRoute {
  static supportedNetworks() {
    return ["Mainnet", "Testnet"];
  }
  // get the list of chains this route supports
  static supportedChains(e) {
    return circleContractChains.has(e) ? circleContractChains.get(e) : [];
  }
  // get the list of source tokens that are possible to send
  static async supportedSourceTokens(e) {
    const { network: T, chain: $ } = e;
    return usdcContract.has(T, $) ? [Wormhole.chainAddress($, usdcContract.get(T, $))] : [];
  }
  // get the list of destination tokens that may be received on the destination chain
  static async supportedDestinationTokens(e, T, $) {
    const V = usdcContract.get(T.network, T.chain);
    if (!V)
      return [];
    if (!isSameToken(e, Wormhole.tokenId(T.chain, V)))
      return [];
    const { network: J, chain: ee } = $;
    return usdcContract.has(J, ee) ? [Wormhole.chainAddress(ee, usdcContract.get(J, ee))] : [];
  }
  getDefaultOptions() {
    return {
      payload: void 0
    };
  }
  async validate(e, T) {
    return { valid: !0, params: {
      normalizedParams: {
        amount: e.parseAmount(T.amount)
      },
      options: T.options ?? this.getDefaultOptions(),
      ...T
    } };
  }
  async quote(e, T) {
    try {
      return e.displayQuote(await CircleTransfer.quoteTransfer(e.fromChain, e.toChain, {
        automatic: !1,
        amount: units(T.normalizedParams.amount),
        ...T.options
      }), T);
    } catch ($) {
      return {
        success: !1,
        error: $
      };
    }
  }
  async initiate(e, T, $, V) {
    const { params: J } = $, ee = await CircleTransfer.destinationOverrides(e.fromChain, e.toChain, this.toTransferDetails(J, Wormhole.chainAddress(T.chain(), T.address()), V)), te = await CircleTransfer.transfer(e.fromChain, ee, T), re = await CircleTransfer.getTransferMessage(e.fromChain, te[te.length - 1].txid);
    return {
      from: ee.from.chain,
      to: ee.to.chain,
      state: TransferState.SourceFinalized,
      originTxs: te,
      attestation: { id: re.id, attestation: { message: re.message } }
    };
  }
  async complete(e, T) {
    if (!isAttested(T))
      throw new Error("The source must be finalized in order to complete the transfer");
    const { id: $, attestation: V } = T.attestation;
    if (CircleBridge.isCircleAttestation(V)) {
      const { message: J, attestation: ee } = V;
      if (!ee)
        throw new Error(`No Circle attestation for ${$}`);
      const te = this.wh.getChain(T.to), re = await te.getCircleBridge(), ie = Wormhole.parseAddress(e.chain(), e.address()), se = re.redeem(ie, J, ee), de = await signSendWait(te, se, e);
      return {
        ...T,
        state: TransferState.DestinationInitiated,
        destinationTxs: de
      };
    } else
      return T;
  }
  async resume(e) {
    const T = await CircleTransfer.from(this.wh, e, 1e4);
    return CircleTransfer.getReceipt(T);
  }
  async *track(e, T) {
    yield* CircleTransfer.track(this.wh, e, T);
  }
  toTransferDetails(e, T, $) {
    return {
      from: T,
      to: $,
      amount: units(e.normalizedParams.amount),
      automatic: !1,
      ...e.options
    };
  }
}, tt(Js, "meta", {
  name: "ManualCCTP"
}), Js);
var Ls;
let AutomaticCCTPRoute$1 = (Ls = class extends AutomaticRoute {
  static supportedNetworks() {
    return ["Mainnet", "Testnet"];
  }
  // get the list of chains this route supports
  static supportedChains(e) {
    return circleContractChains.has(e) ? circleContractChains.get(e).filter(($) => {
      var V;
      return (V = circleContracts.get(e, $)) == null ? void 0 : V.wormholeRelayer;
    }) : [];
  }
  // get the list of source tokens that are possible to send
  static async supportedSourceTokens(e) {
    const { network: T, chain: $ } = e;
    return usdcContract.has(T, $) ? [Wormhole.chainAddress($, usdcContract.get(T, $))] : [];
  }
  // get the list of destination tokens that may be received on the destination chain
  static async supportedDestinationTokens(e, T, $) {
    const V = usdcContract.get(T.network, T.chain);
    if (!V)
      return [];
    if (!isSameToken(e, Wormhole.tokenId(T.chain, V)))
      return [];
    const { network: J, chain: ee } = $;
    return usdcContract.has(J, ee) ? [Wormhole.chainAddress(ee, usdcContract.get(J, ee))] : [];
  }
  getDefaultOptions() {
    return {
      nativeGas: 0
    };
  }
  async validate(e, T) {
    try {
      const $ = T.options ?? this.getDefaultOptions();
      return { valid: !0, params: {
        normalizedParams: await this.normalizeTransferParams(e, T),
        options: $,
        ...T
      } };
    } catch ($) {
      return {
        valid: !1,
        params: T,
        error: $
      };
    }
  }
  async quote(e, T) {
    try {
      return e.displayQuote(await CircleTransfer.quoteTransfer(e.fromChain, e.toChain, {
        automatic: !0,
        amount: units(T.normalizedParams.amount),
        nativeGas: units(T.normalizedParams.nativeGasAmount)
      }), T);
    } catch ($) {
      return {
        success: !1,
        error: $
      };
    }
  }
  async normalizeTransferParams(e, T) {
    const $ = e.parseAmount(T.amount), J = await (await e.fromChain.getAutomaticCircleBridge()).getRelayerFee(e.toChain.chain), ee = J * 105n / 100n;
    if (units($) < ee)
      throw new MinAmountError(fromBaseUnits(ee, $.decimals));
    const te = units($) - J, ie = (T.options ?? this.getDefaultOptions()).nativeGas ?? 0;
    if (ie > 1 || ie < 0)
      throw new Error("Native gas must be between 0.0 and 1.0 (0% and 100%)");
    let se = 0n;
    if (ie > 0) {
      let ue = await (await e.toChain.getAutomaticCircleBridge()).maxSwapAmount();
      te < ue && (ue = te);
      const fe = 1e4, he = BigInt(Math.floor(ie * fe));
      se = ue * he / BigInt(fe), se === te && se > 0n && (se -= 1n);
    }
    return {
      fee: e.amountFromBaseUnits(J),
      amount: $,
      nativeGasAmount: e.amountFromBaseUnits(se)
    };
  }
  toTransferDetails(e, T, $) {
    return {
      from: T,
      to: $,
      amount: units(e.normalizedParams.amount),
      automatic: !0,
      nativeGas: units(e.normalizedParams.nativeGasAmount)
    };
  }
  async initiate(e, T, $, V) {
    const { params: J } = $;
    let ee = this.toTransferDetails(J, Wormhole.chainAddress(T.chain(), T.address()), V), te = await CircleTransfer.transfer(e.fromChain, ee, T);
    const re = await CircleTransfer.getTransferMessage(e.fromChain, te[te.length - 1].txid);
    return {
      from: ee.from.chain,
      to: ee.to.chain,
      state: TransferState.SourceFinalized,
      originTxs: te,
      attestation: { id: re.id, attestation: { message: re.message } }
    };
  }
  async *track(e, T) {
    yield* CircleTransfer.track(this.wh, e, T);
  }
}, tt(Ls, "NATIVE_GAS_DROPOFF_SUPPORTED", !0), tt(Ls, "meta", {
  name: "AutomaticCCTP"
}), Ls);
const routes = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  AutomaticCCTPRoute: AutomaticCCTPRoute$1,
  AutomaticPorticoRoute: AutomaticPorticoRoute$1,
  AutomaticRoute,
  AutomaticTokenBridgeRoute: AutomaticTokenBridgeRoute$1,
  BPS_PER_HUNDRED_PERCENT,
  CCTPRoute: CCTPRoute$1,
  FinalizableRoute,
  MAX_SLIPPAGE_BPS,
  ManualRoute,
  MinAmountError,
  Route,
  RouteResolver,
  RouteTransferRequest,
  SLIPPAGE_BPS,
  TokenBridgeRoute: TokenBridgeRoute$1,
  UnavailableError,
  checkAndCompleteTransfer,
  isAutomatic,
  isFinalizable,
  isManual
}, Symbol.toStringTag, { value: "Module" }));
function commonjsRequire(C) {
  throw new Error('Could not dynamically require "' + C + '". Please configure the dynamicRequireTargets or/and ignoreDynamicRequires option of @rollup/plugin-commonjs appropriately for this require call to work.');
}
var naclFast = { exports: {} }, cryptoBrowserify = {}, browser$d = { exports: {} }, safeBuffer$2 = { exports: {} };
/*! safe-buffer. MIT License. Feross Aboukhadijeh <https://feross.org/opensource> */
(function(C, e) {
  var T = bufferPolyfill, $ = T.Buffer;
  function V(ee, te) {
    for (var re in ee)
      te[re] = ee[re];
  }
  $.from && $.alloc && $.allocUnsafe && $.allocUnsafeSlow ? C.exports = T : (V(T, e), e.Buffer = J);
  function J(ee, te, re) {
    return $(ee, te, re);
  }
  J.prototype = Object.create($.prototype), V($, J), J.from = function(ee, te, re) {
    if (typeof ee == "number")
      throw new TypeError("Argument must not be a number");
    return $(ee, te, re);
  }, J.alloc = function(ee, te, re) {
    if (typeof ee != "number")
      throw new TypeError("Argument must be a number");
    var ie = $(ee);
    return te !== void 0 ? typeof re == "string" ? ie.fill(te, re) : ie.fill(te) : ie.fill(0), ie;
  }, J.allocUnsafe = function(ee) {
    if (typeof ee != "number")
      throw new TypeError("Argument must be a number");
    return $(ee);
  }, J.allocUnsafeSlow = function(ee) {
    if (typeof ee != "number")
      throw new TypeError("Argument must be a number");
    return T.SlowBuffer(ee);
  };
})(safeBuffer$2, safeBuffer$2.exports);
var safeBufferExports = safeBuffer$2.exports, hasRequiredBrowser$b;
function requireBrowser$b() {
  if (hasRequiredBrowser$b) return browser$d.exports;
  hasRequiredBrowser$b = 1;
  var C = 65536, e = 4294967295;
  function T() {
    throw new Error(`Secure random number generation is not supported by this browser.
Use Chrome, Firefox or Internet Explorer 11`);
  }
  var $ = safeBufferExports.Buffer, V = commonjsGlobal$1.crypto || commonjsGlobal$1.msCrypto;
  V && V.getRandomValues ? browser$d.exports = J : browser$d.exports = T;
  function J(ee, te) {
    if (ee > e) throw new RangeError("requested too many random bytes");
    var re = $.allocUnsafe(ee);
    if (ee > 0)
      if (ee > C)
        for (var ie = 0; ie < ee; ie += C)
          V.getRandomValues(re.slice(ie, ie + C));
      else
        V.getRandomValues(re);
    return typeof te == "function" ? dist$2.process.nextTick(function() {
      te(null, re);
    }) : re;
  }
  return browser$d.exports;
}
var inherits_browser = { exports: {} }, hasRequiredInherits_browser;
function requireInherits_browser() {
  return hasRequiredInherits_browser || (hasRequiredInherits_browser = 1, typeof Object.create == "function" ? inherits_browser.exports = function(e, T) {
    T && (e.super_ = T, e.prototype = Object.create(T.prototype, {
      constructor: {
        value: e,
        enumerable: !1,
        writable: !0,
        configurable: !0
      }
    }));
  } : inherits_browser.exports = function(e, T) {
    if (T) {
      e.super_ = T;
      var $ = function() {
      };
      $.prototype = T.prototype, e.prototype = new $(), e.prototype.constructor = e;
    }
  }), inherits_browser.exports;
}
var events = { exports: {} }, hasRequiredEvents;
function requireEvents() {
  if (hasRequiredEvents) return events.exports;
  hasRequiredEvents = 1;
  var C = typeof Reflect == "object" ? Reflect : null, e = C && typeof C.apply == "function" ? C.apply : function(Me, Ie, ke) {
    return Function.prototype.apply.call(Me, Ie, ke);
  }, T;
  C && typeof C.ownKeys == "function" ? T = C.ownKeys : Object.getOwnPropertySymbols ? T = function(Me) {
    return Object.getOwnPropertyNames(Me).concat(Object.getOwnPropertySymbols(Me));
  } : T = function(Me) {
    return Object.getOwnPropertyNames(Me);
  };
  function $(Ee) {
    console && console.warn && console.warn(Ee);
  }
  var V = Number.isNaN || function(Me) {
    return Me !== Me;
  };
  function J() {
    J.init.call(this);
  }
  events.exports = J, events.exports.once = ve, J.EventEmitter = J, J.prototype._events = void 0, J.prototype._eventsCount = 0, J.prototype._maxListeners = void 0;
  var ee = 10;
  function te(Ee) {
    if (typeof Ee != "function")
      throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof Ee);
  }
  Object.defineProperty(J, "defaultMaxListeners", {
    enumerable: !0,
    get: function() {
      return ee;
    },
    set: function(Ee) {
      if (typeof Ee != "number" || Ee < 0 || V(Ee))
        throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + Ee + ".");
      ee = Ee;
    }
  }), J.init = function() {
    (this._events === void 0 || this._events === Object.getPrototypeOf(this)._events) && (this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0), this._maxListeners = this._maxListeners || void 0;
  }, J.prototype.setMaxListeners = function(Me) {
    if (typeof Me != "number" || Me < 0 || V(Me))
      throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + Me + ".");
    return this._maxListeners = Me, this;
  };
  function re(Ee) {
    return Ee._maxListeners === void 0 ? J.defaultMaxListeners : Ee._maxListeners;
  }
  J.prototype.getMaxListeners = function() {
    return re(this);
  }, J.prototype.emit = function(Me) {
    for (var Ie = [], ke = 1; ke < arguments.length; ke++) Ie.push(arguments[ke]);
    var _e = Me === "error", De = this._events;
    if (De !== void 0)
      _e = _e && De.error === void 0;
    else if (!_e)
      return !1;
    if (_e) {
      var Fe;
      if (Ie.length > 0 && (Fe = Ie[0]), Fe instanceof Error)
        throw Fe;
      var Ae = new Error("Unhandled error." + (Fe ? " (" + Fe.message + ")" : ""));
      throw Ae.context = Fe, Ae;
    }
    var ne = De[Me];
    if (ne === void 0)
      return !1;
    if (typeof ne == "function")
      e(ne, this, Ie);
    else
      for (var oe = ne.length, ce = he(ne, oe), ke = 0; ke < oe; ++ke)
        e(ce[ke], this, Ie);
    return !0;
  };
  function ie(Ee, Me, Ie, ke) {
    var _e, De, Fe;
    if (te(Ie), De = Ee._events, De === void 0 ? (De = Ee._events = /* @__PURE__ */ Object.create(null), Ee._eventsCount = 0) : (De.newListener !== void 0 && (Ee.emit(
      "newListener",
      Me,
      Ie.listener ? Ie.listener : Ie
    ), De = Ee._events), Fe = De[Me]), Fe === void 0)
      Fe = De[Me] = Ie, ++Ee._eventsCount;
    else if (typeof Fe == "function" ? Fe = De[Me] = ke ? [Ie, Fe] : [Fe, Ie] : ke ? Fe.unshift(Ie) : Fe.push(Ie), _e = re(Ee), _e > 0 && Fe.length > _e && !Fe.warned) {
      Fe.warned = !0;
      var Ae = new Error("Possible EventEmitter memory leak detected. " + Fe.length + " " + String(Me) + " listeners added. Use emitter.setMaxListeners() to increase limit");
      Ae.name = "MaxListenersExceededWarning", Ae.emitter = Ee, Ae.type = Me, Ae.count = Fe.length, $(Ae);
    }
    return Ee;
  }
  J.prototype.addListener = function(Me, Ie) {
    return ie(this, Me, Ie, !1);
  }, J.prototype.on = J.prototype.addListener, J.prototype.prependListener = function(Me, Ie) {
    return ie(this, Me, Ie, !0);
  };
  function se() {
    if (!this.fired)
      return this.target.removeListener(this.type, this.wrapFn), this.fired = !0, arguments.length === 0 ? this.listener.call(this.target) : this.listener.apply(this.target, arguments);
  }
  function de(Ee, Me, Ie) {
    var ke = { fired: !1, wrapFn: void 0, target: Ee, type: Me, listener: Ie }, _e = se.bind(ke);
    return _e.listener = Ie, ke.wrapFn = _e, _e;
  }
  J.prototype.once = function(Me, Ie) {
    return te(Ie), this.on(Me, de(this, Me, Ie)), this;
  }, J.prototype.prependOnceListener = function(Me, Ie) {
    return te(Ie), this.prependListener(Me, de(this, Me, Ie)), this;
  }, J.prototype.removeListener = function(Me, Ie) {
    var ke, _e, De, Fe, Ae;
    if (te(Ie), _e = this._events, _e === void 0)
      return this;
    if (ke = _e[Me], ke === void 0)
      return this;
    if (ke === Ie || ke.listener === Ie)
      --this._eventsCount === 0 ? this._events = /* @__PURE__ */ Object.create(null) : (delete _e[Me], _e.removeListener && this.emit("removeListener", Me, ke.listener || Ie));
    else if (typeof ke != "function") {
      for (De = -1, Fe = ke.length - 1; Fe >= 0; Fe--)
        if (ke[Fe] === Ie || ke[Fe].listener === Ie) {
          Ae = ke[Fe].listener, De = Fe;
          break;
        }
      if (De < 0)
        return this;
      De === 0 ? ke.shift() : me(ke, De), ke.length === 1 && (_e[Me] = ke[0]), _e.removeListener !== void 0 && this.emit("removeListener", Me, Ae || Ie);
    }
    return this;
  }, J.prototype.off = J.prototype.removeListener, J.prototype.removeAllListeners = function(Me) {
    var Ie, ke, _e;
    if (ke = this._events, ke === void 0)
      return this;
    if (ke.removeListener === void 0)
      return arguments.length === 0 ? (this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0) : ke[Me] !== void 0 && (--this._eventsCount === 0 ? this._events = /* @__PURE__ */ Object.create(null) : delete ke[Me]), this;
    if (arguments.length === 0) {
      var De = Object.keys(ke), Fe;
      for (_e = 0; _e < De.length; ++_e)
        Fe = De[_e], Fe !== "removeListener" && this.removeAllListeners(Fe);
      return this.removeAllListeners("removeListener"), this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0, this;
    }
    if (Ie = ke[Me], typeof Ie == "function")
      this.removeListener(Me, Ie);
    else if (Ie !== void 0)
      for (_e = Ie.length - 1; _e >= 0; _e--)
        this.removeListener(Me, Ie[_e]);
    return this;
  };
  function ue(Ee, Me, Ie) {
    var ke = Ee._events;
    if (ke === void 0)
      return [];
    var _e = ke[Me];
    return _e === void 0 ? [] : typeof _e == "function" ? Ie ? [_e.listener || _e] : [_e] : Ie ? xe(_e) : he(_e, _e.length);
  }
  J.prototype.listeners = function(Me) {
    return ue(this, Me, !0);
  }, J.prototype.rawListeners = function(Me) {
    return ue(this, Me, !1);
  }, J.listenerCount = function(Ee, Me) {
    return typeof Ee.listenerCount == "function" ? Ee.listenerCount(Me) : fe.call(Ee, Me);
  }, J.prototype.listenerCount = fe;
  function fe(Ee) {
    var Me = this._events;
    if (Me !== void 0) {
      var Ie = Me[Ee];
      if (typeof Ie == "function")
        return 1;
      if (Ie !== void 0)
        return Ie.length;
    }
    return 0;
  }
  J.prototype.eventNames = function() {
    return this._eventsCount > 0 ? T(this._events) : [];
  };
  function he(Ee, Me) {
    for (var Ie = new Array(Me), ke = 0; ke < Me; ++ke)
      Ie[ke] = Ee[ke];
    return Ie;
  }
  function me(Ee, Me) {
    for (; Me + 1 < Ee.length; Me++)
      Ee[Me] = Ee[Me + 1];
    Ee.pop();
  }
  function xe(Ee) {
    for (var Me = new Array(Ee.length), Ie = 0; Ie < Me.length; ++Ie)
      Me[Ie] = Ee[Ie].listener || Ee[Ie];
    return Me;
  }
  function ve(Ee, Me) {
    return new Promise(function(Ie, ke) {
      function _e(Fe) {
        Ee.removeListener(Me, De), ke(Fe);
      }
      function De() {
        typeof Ee.removeListener == "function" && Ee.removeListener("error", _e), Ie([].slice.call(arguments));
      }
      we(Ee, Me, De, { once: !0 }), Me !== "error" && Te(Ee, _e, { once: !0 });
    });
  }
  function Te(Ee, Me, Ie) {
    typeof Ee.on == "function" && we(Ee, "error", Me, Ie);
  }
  function we(Ee, Me, Ie, ke) {
    if (typeof Ee.on == "function")
      ke.once ? Ee.once(Me, Ie) : Ee.on(Me, Ie);
    else if (typeof Ee.addEventListener == "function")
      Ee.addEventListener(Me, function _e(De) {
        ke.once && Ee.removeEventListener(Me, _e), Ie(De);
      });
    else
      throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof Ee);
  }
  return events.exports;
}
var streamBrowser$1, hasRequiredStreamBrowser$1;
function requireStreamBrowser$1() {
  return hasRequiredStreamBrowser$1 || (hasRequiredStreamBrowser$1 = 1, streamBrowser$1 = requireEvents().EventEmitter), streamBrowser$1;
}
const __viteBrowserExternal = {}, __viteBrowserExternal$1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: __viteBrowserExternal
}, Symbol.toStringTag, { value: "Module" })), require$$0$2 = /* @__PURE__ */ getAugmentedNamespace(__viteBrowserExternal$1);
var buffer_list, hasRequiredBuffer_list;
function requireBuffer_list() {
  if (hasRequiredBuffer_list) return buffer_list;
  hasRequiredBuffer_list = 1;
  function C(he, me) {
    var xe = Object.keys(he);
    if (Object.getOwnPropertySymbols) {
      var ve = Object.getOwnPropertySymbols(he);
      me && (ve = ve.filter(function(Te) {
        return Object.getOwnPropertyDescriptor(he, Te).enumerable;
      })), xe.push.apply(xe, ve);
    }
    return xe;
  }
  function e(he) {
    for (var me = 1; me < arguments.length; me++) {
      var xe = arguments[me] != null ? arguments[me] : {};
      me % 2 ? C(Object(xe), !0).forEach(function(ve) {
        T(he, ve, xe[ve]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(he, Object.getOwnPropertyDescriptors(xe)) : C(Object(xe)).forEach(function(ve) {
        Object.defineProperty(he, ve, Object.getOwnPropertyDescriptor(xe, ve));
      });
    }
    return he;
  }
  function T(he, me, xe) {
    return me = ee(me), me in he ? Object.defineProperty(he, me, { value: xe, enumerable: !0, configurable: !0, writable: !0 }) : he[me] = xe, he;
  }
  function $(he, me) {
    if (!(he instanceof me))
      throw new TypeError("Cannot call a class as a function");
  }
  function V(he, me) {
    for (var xe = 0; xe < me.length; xe++) {
      var ve = me[xe];
      ve.enumerable = ve.enumerable || !1, ve.configurable = !0, "value" in ve && (ve.writable = !0), Object.defineProperty(he, ee(ve.key), ve);
    }
  }
  function J(he, me, xe) {
    return me && V(he.prototype, me), Object.defineProperty(he, "prototype", { writable: !1 }), he;
  }
  function ee(he) {
    var me = te(he, "string");
    return typeof me == "symbol" ? me : String(me);
  }
  function te(he, me) {
    if (typeof he != "object" || he === null) return he;
    var xe = he[Symbol.toPrimitive];
    if (xe !== void 0) {
      var ve = xe.call(he, me || "default");
      if (typeof ve != "object") return ve;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (me === "string" ? String : Number)(he);
  }
  var re = bufferPolyfill, ie = re.Buffer, se = require$$0$2, de = se.inspect, ue = de && de.custom || "inspect";
  function fe(he, me, xe) {
    ie.prototype.copy.call(he, me, xe);
  }
  return buffer_list = /* @__PURE__ */ function() {
    function he() {
      $(this, he), this.head = null, this.tail = null, this.length = 0;
    }
    return J(he, [{
      key: "push",
      value: function(xe) {
        var ve = {
          data: xe,
          next: null
        };
        this.length > 0 ? this.tail.next = ve : this.head = ve, this.tail = ve, ++this.length;
      }
    }, {
      key: "unshift",
      value: function(xe) {
        var ve = {
          data: xe,
          next: this.head
        };
        this.length === 0 && (this.tail = ve), this.head = ve, ++this.length;
      }
    }, {
      key: "shift",
      value: function() {
        if (this.length !== 0) {
          var xe = this.head.data;
          return this.length === 1 ? this.head = this.tail = null : this.head = this.head.next, --this.length, xe;
        }
      }
    }, {
      key: "clear",
      value: function() {
        this.head = this.tail = null, this.length = 0;
      }
    }, {
      key: "join",
      value: function(xe) {
        if (this.length === 0) return "";
        for (var ve = this.head, Te = "" + ve.data; ve = ve.next; ) Te += xe + ve.data;
        return Te;
      }
    }, {
      key: "concat",
      value: function(xe) {
        if (this.length === 0) return ie.alloc(0);
        for (var ve = ie.allocUnsafe(xe >>> 0), Te = this.head, we = 0; Te; )
          fe(Te.data, ve, we), we += Te.data.length, Te = Te.next;
        return ve;
      }
      // Consumes a specified amount of bytes or characters from the buffered data.
    }, {
      key: "consume",
      value: function(xe, ve) {
        var Te;
        return xe < this.head.data.length ? (Te = this.head.data.slice(0, xe), this.head.data = this.head.data.slice(xe)) : xe === this.head.data.length ? Te = this.shift() : Te = ve ? this._getString(xe) : this._getBuffer(xe), Te;
      }
    }, {
      key: "first",
      value: function() {
        return this.head.data;
      }
      // Consumes a specified amount of characters from the buffered data.
    }, {
      key: "_getString",
      value: function(xe) {
        var ve = this.head, Te = 1, we = ve.data;
        for (xe -= we.length; ve = ve.next; ) {
          var Ee = ve.data, Me = xe > Ee.length ? Ee.length : xe;
          if (Me === Ee.length ? we += Ee : we += Ee.slice(0, xe), xe -= Me, xe === 0) {
            Me === Ee.length ? (++Te, ve.next ? this.head = ve.next : this.head = this.tail = null) : (this.head = ve, ve.data = Ee.slice(Me));
            break;
          }
          ++Te;
        }
        return this.length -= Te, we;
      }
      // Consumes a specified amount of bytes from the buffered data.
    }, {
      key: "_getBuffer",
      value: function(xe) {
        var ve = ie.allocUnsafe(xe), Te = this.head, we = 1;
        for (Te.data.copy(ve), xe -= Te.data.length; Te = Te.next; ) {
          var Ee = Te.data, Me = xe > Ee.length ? Ee.length : xe;
          if (Ee.copy(ve, ve.length - xe, 0, Me), xe -= Me, xe === 0) {
            Me === Ee.length ? (++we, Te.next ? this.head = Te.next : this.head = this.tail = null) : (this.head = Te, Te.data = Ee.slice(Me));
            break;
          }
          ++we;
        }
        return this.length -= we, ve;
      }
      // Make sure the linked list only shows the minimal necessary information.
    }, {
      key: ue,
      value: function(xe, ve) {
        return de(this, e(e({}, ve), {}, {
          // Only inspect one level.
          depth: 0,
          // It should not recurse.
          customInspect: !1
        }));
      }
    }]), he;
  }(), buffer_list;
}
var destroy_1$1, hasRequiredDestroy$1;
function requireDestroy$1() {
  if (hasRequiredDestroy$1) return destroy_1$1;
  hasRequiredDestroy$1 = 1;
  function C(ee, te) {
    var re = this, ie = this._readableState && this._readableState.destroyed, se = this._writableState && this._writableState.destroyed;
    return ie || se ? (te ? te(ee) : ee && (this._writableState ? this._writableState.errorEmitted || (this._writableState.errorEmitted = !0, dist$2.process.nextTick(V, this, ee)) : dist$2.process.nextTick(V, this, ee)), this) : (this._readableState && (this._readableState.destroyed = !0), this._writableState && (this._writableState.destroyed = !0), this._destroy(ee || null, function(de) {
      !te && de ? re._writableState ? re._writableState.errorEmitted ? dist$2.process.nextTick(T, re) : (re._writableState.errorEmitted = !0, dist$2.process.nextTick(e, re, de)) : dist$2.process.nextTick(e, re, de) : te ? (dist$2.process.nextTick(T, re), te(de)) : dist$2.process.nextTick(T, re);
    }), this);
  }
  function e(ee, te) {
    V(ee, te), T(ee);
  }
  function T(ee) {
    ee._writableState && !ee._writableState.emitClose || ee._readableState && !ee._readableState.emitClose || ee.emit("close");
  }
  function $() {
    this._readableState && (this._readableState.destroyed = !1, this._readableState.reading = !1, this._readableState.ended = !1, this._readableState.endEmitted = !1), this._writableState && (this._writableState.destroyed = !1, this._writableState.ended = !1, this._writableState.ending = !1, this._writableState.finalCalled = !1, this._writableState.prefinished = !1, this._writableState.finished = !1, this._writableState.errorEmitted = !1);
  }
  function V(ee, te) {
    ee.emit("error", te);
  }
  function J(ee, te) {
    var re = ee._readableState, ie = ee._writableState;
    re && re.autoDestroy || ie && ie.autoDestroy ? ee.destroy(te) : ee.emit("error", te);
  }
  return destroy_1$1 = {
    destroy: C,
    undestroy: $,
    errorOrDestroy: J
  }, destroy_1$1;
}
var errorsBrowser = {}, hasRequiredErrorsBrowser;
function requireErrorsBrowser() {
  if (hasRequiredErrorsBrowser) return errorsBrowser;
  hasRequiredErrorsBrowser = 1;
  function C(te, re) {
    te.prototype = Object.create(re.prototype), te.prototype.constructor = te, te.__proto__ = re;
  }
  var e = {};
  function T(te, re, ie) {
    ie || (ie = Error);
    function se(ue, fe, he) {
      return typeof re == "string" ? re : re(ue, fe, he);
    }
    var de = /* @__PURE__ */ function(ue) {
      C(fe, ue);
      function fe(he, me, xe) {
        return ue.call(this, se(he, me, xe)) || this;
      }
      return fe;
    }(ie);
    de.prototype.name = ie.name, de.prototype.code = te, e[te] = de;
  }
  function $(te, re) {
    if (Array.isArray(te)) {
      var ie = te.length;
      return te = te.map(function(se) {
        return String(se);
      }), ie > 2 ? "one of ".concat(re, " ").concat(te.slice(0, ie - 1).join(", "), ", or ") + te[ie - 1] : ie === 2 ? "one of ".concat(re, " ").concat(te[0], " or ").concat(te[1]) : "of ".concat(re, " ").concat(te[0]);
    } else
      return "of ".concat(re, " ").concat(String(te));
  }
  function V(te, re, ie) {
    return te.substr(0, re.length) === re;
  }
  function J(te, re, ie) {
    return (ie === void 0 || ie > te.length) && (ie = te.length), te.substring(ie - re.length, ie) === re;
  }
  function ee(te, re, ie) {
    return typeof ie != "number" && (ie = 0), ie + re.length > te.length ? !1 : te.indexOf(re, ie) !== -1;
  }
  return T("ERR_INVALID_OPT_VALUE", function(te, re) {
    return 'The value "' + re + '" is invalid for option "' + te + '"';
  }, TypeError), T("ERR_INVALID_ARG_TYPE", function(te, re, ie) {
    var se;
    typeof re == "string" && V(re, "not ") ? (se = "must not be", re = re.replace(/^not /, "")) : se = "must be";
    var de;
    if (J(te, " argument"))
      de = "The ".concat(te, " ").concat(se, " ").concat($(re, "type"));
    else {
      var ue = ee(te, ".") ? "property" : "argument";
      de = 'The "'.concat(te, '" ').concat(ue, " ").concat(se, " ").concat($(re, "type"));
    }
    return de += ". Received type ".concat(typeof ie), de;
  }, TypeError), T("ERR_STREAM_PUSH_AFTER_EOF", "stream.push() after EOF"), T("ERR_METHOD_NOT_IMPLEMENTED", function(te) {
    return "The " + te + " method is not implemented";
  }), T("ERR_STREAM_PREMATURE_CLOSE", "Premature close"), T("ERR_STREAM_DESTROYED", function(te) {
    return "Cannot call " + te + " after a stream was destroyed";
  }), T("ERR_MULTIPLE_CALLBACK", "Callback called multiple times"), T("ERR_STREAM_CANNOT_PIPE", "Cannot pipe, not readable"), T("ERR_STREAM_WRITE_AFTER_END", "write after end"), T("ERR_STREAM_NULL_VALUES", "May not write null values to stream", TypeError), T("ERR_UNKNOWN_ENCODING", function(te) {
    return "Unknown encoding: " + te;
  }, TypeError), T("ERR_STREAM_UNSHIFT_AFTER_END_EVENT", "stream.unshift() after end event"), errorsBrowser.codes = e, errorsBrowser;
}
var state, hasRequiredState;
function requireState() {
  if (hasRequiredState) return state;
  hasRequiredState = 1;
  var C = requireErrorsBrowser().codes.ERR_INVALID_OPT_VALUE;
  function e($, V, J) {
    return $.highWaterMark != null ? $.highWaterMark : V ? $[J] : null;
  }
  function T($, V, J, ee) {
    var te = e(V, ee, J);
    if (te != null) {
      if (!(isFinite(te) && Math.floor(te) === te) || te < 0) {
        var re = ee ? J : "highWaterMark";
        throw new C(re, te);
      }
      return Math.floor(te);
    }
    return $.objectMode ? 16 : 16 * 1024;
  }
  return state = {
    getHighWaterMark: T
  }, state;
}
var browser$c, hasRequiredBrowser$a;
function requireBrowser$a() {
  if (hasRequiredBrowser$a) return browser$c;
  hasRequiredBrowser$a = 1, browser$c = C;
  function C(T, $) {
    if (e("noDeprecation"))
      return T;
    var V = !1;
    function J() {
      if (!V) {
        if (e("throwDeprecation"))
          throw new Error($);
        e("traceDeprecation") ? console.trace($) : console.warn($), V = !0;
      }
      return T.apply(this, arguments);
    }
    return J;
  }
  function e(T) {
    try {
      if (!commonjsGlobal$1.localStorage) return !1;
    } catch {
      return !1;
    }
    var $ = commonjsGlobal$1.localStorage[T];
    return $ == null ? !1 : String($).toLowerCase() === "true";
  }
  return browser$c;
}
var _stream_writable$1, hasRequired_stream_writable$1;
function require_stream_writable$1() {
  if (hasRequired_stream_writable$1) return _stream_writable$1;
  hasRequired_stream_writable$1 = 1, _stream_writable$1 = _e;
  function C(We) {
    var Be = this;
    this.next = null, this.entry = null, this.finish = function() {
      Re(Be, We);
    };
  }
  var e;
  _e.WritableState = Ie;
  var T = {
    deprecate: requireBrowser$a()
  }, $ = requireStreamBrowser$1(), V = bufferPolyfill.Buffer, J = (typeof commonjsGlobal$1 < "u" ? commonjsGlobal$1 : typeof window < "u" ? window : typeof self < "u" ? self : {}).Uint8Array || function() {
  };
  function ee(We) {
    return V.from(We);
  }
  function te(We) {
    return V.isBuffer(We) || We instanceof J;
  }
  var re = requireDestroy$1(), ie = requireState(), se = ie.getHighWaterMark, de = requireErrorsBrowser().codes, ue = de.ERR_INVALID_ARG_TYPE, fe = de.ERR_METHOD_NOT_IMPLEMENTED, he = de.ERR_MULTIPLE_CALLBACK, me = de.ERR_STREAM_CANNOT_PIPE, xe = de.ERR_STREAM_DESTROYED, ve = de.ERR_STREAM_NULL_VALUES, Te = de.ERR_STREAM_WRITE_AFTER_END, we = de.ERR_UNKNOWN_ENCODING, Ee = re.errorOrDestroy;
  requireInherits_browser()(_e, $);
  function Me() {
  }
  function Ie(We, Be, Ue) {
    e = e || require_stream_duplex$1(), We = We || {}, typeof Ue != "boolean" && (Ue = Be instanceof e), this.objectMode = !!We.objectMode, Ue && (this.objectMode = this.objectMode || !!We.writableObjectMode), this.highWaterMark = se(this, We, "writableHighWaterMark", Ue), this.finalCalled = !1, this.needDrain = !1, this.ending = !1, this.ended = !1, this.finished = !1, this.destroyed = !1;
    var Ge = We.decodeStrings === !1;
    this.decodeStrings = !Ge, this.defaultEncoding = We.defaultEncoding || "utf8", this.length = 0, this.writing = !1, this.corked = 0, this.sync = !0, this.bufferProcessing = !1, this.onwrite = function(je) {
      pe(Be, je);
    }, this.writecb = null, this.writelen = 0, this.bufferedRequest = null, this.lastBufferedRequest = null, this.pendingcb = 0, this.prefinished = !1, this.errorEmitted = !1, this.emitClose = We.emitClose !== !1, this.autoDestroy = !!We.autoDestroy, this.bufferedRequestCount = 0, this.corkedRequestsFree = new C(this);
  }
  Ie.prototype.getBuffer = function() {
    for (var Be = this.bufferedRequest, Ue = []; Be; )
      Ue.push(Be), Be = Be.next;
    return Ue;
  }, function() {
    try {
      Object.defineProperty(Ie.prototype, "buffer", {
        get: T.deprecate(function() {
          return this.getBuffer();
        }, "_writableState.buffer is deprecated. Use _writableState.getBuffer instead.", "DEP0003")
      });
    } catch {
    }
  }();
  var ke;
  typeof Symbol == "function" && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] == "function" ? (ke = Function.prototype[Symbol.hasInstance], Object.defineProperty(_e, Symbol.hasInstance, {
    value: function(Be) {
      return ke.call(this, Be) ? !0 : this !== _e ? !1 : Be && Be._writableState instanceof Ie;
    }
  })) : ke = function(Be) {
    return Be instanceof this;
  };
  function _e(We) {
    e = e || require_stream_duplex$1();
    var Be = this instanceof e;
    if (!Be && !ke.call(_e, this)) return new _e(We);
    this._writableState = new Ie(We, this, Be), this.writable = !0, We && (typeof We.write == "function" && (this._write = We.write), typeof We.writev == "function" && (this._writev = We.writev), typeof We.destroy == "function" && (this._destroy = We.destroy), typeof We.final == "function" && (this._final = We.final)), $.call(this);
  }
  _e.prototype.pipe = function() {
    Ee(this, new me());
  };
  function De(We, Be) {
    var Ue = new Te();
    Ee(We, Ue), dist$2.process.nextTick(Be, Ue);
  }
  function Fe(We, Be, Ue, Ge) {
    var je;
    return Ue === null ? je = new ve() : typeof Ue != "string" && !Be.objectMode && (je = new ue("chunk", ["string", "Buffer"], Ue)), je ? (Ee(We, je), dist$2.process.nextTick(Ge, je), !1) : !0;
  }
  _e.prototype.write = function(We, Be, Ue) {
    var Ge = this._writableState, je = !1, Oe = !Ge.objectMode && te(We);
    return Oe && !V.isBuffer(We) && (We = ee(We)), typeof Be == "function" && (Ue = Be, Be = null), Oe ? Be = "buffer" : Be || (Be = Ge.defaultEncoding), typeof Ue != "function" && (Ue = Me), Ge.ending ? De(this, Ue) : (Oe || Fe(this, Ge, We, Ue)) && (Ge.pendingcb++, je = ne(this, Ge, Oe, We, Be, Ue)), je;
  }, _e.prototype.cork = function() {
    this._writableState.corked++;
  }, _e.prototype.uncork = function() {
    var We = this._writableState;
    We.corked && (We.corked--, !We.writing && !We.corked && !We.bufferProcessing && We.bufferedRequest && be(this, We));
  }, _e.prototype.setDefaultEncoding = function(Be) {
    if (typeof Be == "string" && (Be = Be.toLowerCase()), !(["hex", "utf8", "utf-8", "ascii", "binary", "base64", "ucs2", "ucs-2", "utf16le", "utf-16le", "raw"].indexOf((Be + "").toLowerCase()) > -1)) throw new we(Be);
    return this._writableState.defaultEncoding = Be, this;
  }, Object.defineProperty(_e.prototype, "writableBuffer", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._writableState && this._writableState.getBuffer();
    }
  });
  function Ae(We, Be, Ue) {
    return !We.objectMode && We.decodeStrings !== !1 && typeof Be == "string" && (Be = V.from(Be, Ue)), Be;
  }
  Object.defineProperty(_e.prototype, "writableHighWaterMark", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._writableState.highWaterMark;
    }
  });
  function ne(We, Be, Ue, Ge, je, Oe) {
    if (!Ue) {
      var Ne = Ae(Be, Ge, je);
      Ge !== Ne && (Ue = !0, je = "buffer", Ge = Ne);
    }
    var Ye = Be.objectMode ? 1 : Ge.length;
    Be.length += Ye;
    var Je = Be.length < Be.highWaterMark;
    if (Je || (Be.needDrain = !0), Be.writing || Be.corked) {
      var Xe = Be.lastBufferedRequest;
      Be.lastBufferedRequest = {
        chunk: Ge,
        encoding: je,
        isBuf: Ue,
        callback: Oe,
        next: null
      }, Xe ? Xe.next = Be.lastBufferedRequest : Be.bufferedRequest = Be.lastBufferedRequest, Be.bufferedRequestCount += 1;
    } else
      oe(We, Be, !1, Ye, Ge, je, Oe);
    return Je;
  }
  function oe(We, Be, Ue, Ge, je, Oe, Ne) {
    Be.writelen = Ge, Be.writecb = Ne, Be.writing = !0, Be.sync = !0, Be.destroyed ? Be.onwrite(new xe("write")) : Ue ? We._writev(je, Be.onwrite) : We._write(je, Oe, Be.onwrite), Be.sync = !1;
  }
  function ce(We, Be, Ue, Ge, je) {
    --Be.pendingcb, Ue ? (dist$2.process.nextTick(je, Ge), dist$2.process.nextTick(Le, We, Be), We._writableState.errorEmitted = !0, Ee(We, Ge)) : (je(Ge), We._writableState.errorEmitted = !0, Ee(We, Ge), Le(We, Be));
  }
  function le(We) {
    We.writing = !1, We.writecb = null, We.length -= We.writelen, We.writelen = 0;
  }
  function pe(We, Be) {
    var Ue = We._writableState, Ge = Ue.sync, je = Ue.writecb;
    if (typeof je != "function") throw new he();
    if (le(Ue), Be) ce(We, Ue, Ge, Be, je);
    else {
      var Oe = ae(Ue) || We.destroyed;
      !Oe && !Ue.corked && !Ue.bufferProcessing && Ue.bufferedRequest && be(We, Ue), Ge ? dist$2.process.nextTick(ye, We, Ue, Oe, je) : ye(We, Ue, Oe, je);
    }
  }
  function ye(We, Be, Ue, Ge) {
    Ue || Ce(We, Be), Be.pendingcb--, Ge(), Le(We, Be);
  }
  function Ce(We, Be) {
    Be.length === 0 && Be.needDrain && (Be.needDrain = !1, We.emit("drain"));
  }
  function be(We, Be) {
    Be.bufferProcessing = !0;
    var Ue = Be.bufferedRequest;
    if (We._writev && Ue && Ue.next) {
      var Ge = Be.bufferedRequestCount, je = new Array(Ge), Oe = Be.corkedRequestsFree;
      Oe.entry = Ue;
      for (var Ne = 0, Ye = !0; Ue; )
        je[Ne] = Ue, Ue.isBuf || (Ye = !1), Ue = Ue.next, Ne += 1;
      je.allBuffers = Ye, oe(We, Be, !0, Be.length, je, "", Oe.finish), Be.pendingcb++, Be.lastBufferedRequest = null, Oe.next ? (Be.corkedRequestsFree = Oe.next, Oe.next = null) : Be.corkedRequestsFree = new C(Be), Be.bufferedRequestCount = 0;
    } else {
      for (; Ue; ) {
        var Je = Ue.chunk, Xe = Ue.encoding, st = Ue.callback, ct = Be.objectMode ? 1 : Je.length;
        if (oe(We, Be, !1, ct, Je, Xe, st), Ue = Ue.next, Be.bufferedRequestCount--, Be.writing)
          break;
      }
      Ue === null && (Be.lastBufferedRequest = null);
    }
    Be.bufferedRequest = Ue, Be.bufferProcessing = !1;
  }
  _e.prototype._write = function(We, Be, Ue) {
    Ue(new fe("_write()"));
  }, _e.prototype._writev = null, _e.prototype.end = function(We, Be, Ue) {
    var Ge = this._writableState;
    return typeof We == "function" ? (Ue = We, We = null, Be = null) : typeof Be == "function" && (Ue = Be, Be = null), We != null && this.write(We, Be), Ge.corked && (Ge.corked = 1, this.uncork()), Ge.ending || ze(this, Ge, Ue), this;
  }, Object.defineProperty(_e.prototype, "writableLength", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._writableState.length;
    }
  });
  function ae(We) {
    return We.ending && We.length === 0 && We.bufferedRequest === null && !We.finished && !We.writing;
  }
  function ge(We, Be) {
    We._final(function(Ue) {
      Be.pendingcb--, Ue && Ee(We, Ue), Be.prefinished = !0, We.emit("prefinish"), Le(We, Be);
    });
  }
  function Se(We, Be) {
    !Be.prefinished && !Be.finalCalled && (typeof We._final == "function" && !Be.destroyed ? (Be.pendingcb++, Be.finalCalled = !0, dist$2.process.nextTick(ge, We, Be)) : (Be.prefinished = !0, We.emit("prefinish")));
  }
  function Le(We, Be) {
    var Ue = ae(Be);
    if (Ue && (Se(We, Be), Be.pendingcb === 0 && (Be.finished = !0, We.emit("finish"), Be.autoDestroy))) {
      var Ge = We._readableState;
      (!Ge || Ge.autoDestroy && Ge.endEmitted) && We.destroy();
    }
    return Ue;
  }
  function ze(We, Be, Ue) {
    Be.ending = !0, Le(We, Be), Ue && (Be.finished ? dist$2.process.nextTick(Ue) : We.once("finish", Ue)), Be.ended = !0, We.writable = !1;
  }
  function Re(We, Be, Ue) {
    var Ge = We.entry;
    for (We.entry = null; Ge; ) {
      var je = Ge.callback;
      Be.pendingcb--, je(Ue), Ge = Ge.next;
    }
    Be.corkedRequestsFree.next = We;
  }
  return Object.defineProperty(_e.prototype, "destroyed", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._writableState === void 0 ? !1 : this._writableState.destroyed;
    },
    set: function(Be) {
      this._writableState && (this._writableState.destroyed = Be);
    }
  }), _e.prototype.destroy = re.destroy, _e.prototype._undestroy = re.undestroy, _e.prototype._destroy = function(We, Be) {
    Be(We);
  }, _stream_writable$1;
}
var _stream_duplex$1, hasRequired_stream_duplex$1;
function require_stream_duplex$1() {
  if (hasRequired_stream_duplex$1) return _stream_duplex$1;
  hasRequired_stream_duplex$1 = 1;
  var C = Object.keys || function(ie) {
    var se = [];
    for (var de in ie) se.push(de);
    return se;
  };
  _stream_duplex$1 = ee;
  var e = require_stream_readable$1(), T = require_stream_writable$1();
  requireInherits_browser()(ee, e);
  for (var $ = C(T.prototype), V = 0; V < $.length; V++) {
    var J = $[V];
    ee.prototype[J] || (ee.prototype[J] = T.prototype[J]);
  }
  function ee(ie) {
    if (!(this instanceof ee)) return new ee(ie);
    e.call(this, ie), T.call(this, ie), this.allowHalfOpen = !0, ie && (ie.readable === !1 && (this.readable = !1), ie.writable === !1 && (this.writable = !1), ie.allowHalfOpen === !1 && (this.allowHalfOpen = !1, this.once("end", te)));
  }
  Object.defineProperty(ee.prototype, "writableHighWaterMark", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._writableState.highWaterMark;
    }
  }), Object.defineProperty(ee.prototype, "writableBuffer", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._writableState && this._writableState.getBuffer();
    }
  }), Object.defineProperty(ee.prototype, "writableLength", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._writableState.length;
    }
  });
  function te() {
    this._writableState.ended || dist$2.process.nextTick(re, this);
  }
  function re(ie) {
    ie.end();
  }
  return Object.defineProperty(ee.prototype, "destroyed", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._readableState === void 0 || this._writableState === void 0 ? !1 : this._readableState.destroyed && this._writableState.destroyed;
    },
    set: function(se) {
      this._readableState === void 0 || this._writableState === void 0 || (this._readableState.destroyed = se, this._writableState.destroyed = se);
    }
  }), _stream_duplex$1;
}
var string_decoder$1 = {}, hasRequiredString_decoder$1;
function requireString_decoder$1() {
  if (hasRequiredString_decoder$1) return string_decoder$1;
  hasRequiredString_decoder$1 = 1;
  var C = safeBufferExports.Buffer, e = C.isEncoding || function(ve) {
    switch (ve = "" + ve, ve && ve.toLowerCase()) {
      case "hex":
      case "utf8":
      case "utf-8":
      case "ascii":
      case "binary":
      case "base64":
      case "ucs2":
      case "ucs-2":
      case "utf16le":
      case "utf-16le":
      case "raw":
        return !0;
      default:
        return !1;
    }
  };
  function T(ve) {
    if (!ve) return "utf8";
    for (var Te; ; )
      switch (ve) {
        case "utf8":
        case "utf-8":
          return "utf8";
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
          return "utf16le";
        case "latin1":
        case "binary":
          return "latin1";
        case "base64":
        case "ascii":
        case "hex":
          return ve;
        default:
          if (Te) return;
          ve = ("" + ve).toLowerCase(), Te = !0;
      }
  }
  function $(ve) {
    var Te = T(ve);
    if (typeof Te != "string" && (C.isEncoding === e || !e(ve))) throw new Error("Unknown encoding: " + ve);
    return Te || ve;
  }
  string_decoder$1.StringDecoder = V;
  function V(ve) {
    this.encoding = $(ve);
    var Te;
    switch (this.encoding) {
      case "utf16le":
        this.text = de, this.end = ue, Te = 4;
        break;
      case "utf8":
        this.fillLast = re, Te = 4;
        break;
      case "base64":
        this.text = fe, this.end = he, Te = 3;
        break;
      default:
        this.write = me, this.end = xe;
        return;
    }
    this.lastNeed = 0, this.lastTotal = 0, this.lastChar = C.allocUnsafe(Te);
  }
  V.prototype.write = function(ve) {
    if (ve.length === 0) return "";
    var Te, we;
    if (this.lastNeed) {
      if (Te = this.fillLast(ve), Te === void 0) return "";
      we = this.lastNeed, this.lastNeed = 0;
    } else
      we = 0;
    return we < ve.length ? Te ? Te + this.text(ve, we) : this.text(ve, we) : Te || "";
  }, V.prototype.end = se, V.prototype.text = ie, V.prototype.fillLast = function(ve) {
    if (this.lastNeed <= ve.length)
      return ve.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed), this.lastChar.toString(this.encoding, 0, this.lastTotal);
    ve.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, ve.length), this.lastNeed -= ve.length;
  };
  function J(ve) {
    return ve <= 127 ? 0 : ve >> 5 === 6 ? 2 : ve >> 4 === 14 ? 3 : ve >> 3 === 30 ? 4 : ve >> 6 === 2 ? -1 : -2;
  }
  function ee(ve, Te, we) {
    var Ee = Te.length - 1;
    if (Ee < we) return 0;
    var Me = J(Te[Ee]);
    return Me >= 0 ? (Me > 0 && (ve.lastNeed = Me - 1), Me) : --Ee < we || Me === -2 ? 0 : (Me = J(Te[Ee]), Me >= 0 ? (Me > 0 && (ve.lastNeed = Me - 2), Me) : --Ee < we || Me === -2 ? 0 : (Me = J(Te[Ee]), Me >= 0 ? (Me > 0 && (Me === 2 ? Me = 0 : ve.lastNeed = Me - 3), Me) : 0));
  }
  function te(ve, Te, we) {
    if ((Te[0] & 192) !== 128)
      return ve.lastNeed = 0, "�";
    if (ve.lastNeed > 1 && Te.length > 1) {
      if ((Te[1] & 192) !== 128)
        return ve.lastNeed = 1, "�";
      if (ve.lastNeed > 2 && Te.length > 2 && (Te[2] & 192) !== 128)
        return ve.lastNeed = 2, "�";
    }
  }
  function re(ve) {
    var Te = this.lastTotal - this.lastNeed, we = te(this, ve);
    if (we !== void 0) return we;
    if (this.lastNeed <= ve.length)
      return ve.copy(this.lastChar, Te, 0, this.lastNeed), this.lastChar.toString(this.encoding, 0, this.lastTotal);
    ve.copy(this.lastChar, Te, 0, ve.length), this.lastNeed -= ve.length;
  }
  function ie(ve, Te) {
    var we = ee(this, ve, Te);
    if (!this.lastNeed) return ve.toString("utf8", Te);
    this.lastTotal = we;
    var Ee = ve.length - (we - this.lastNeed);
    return ve.copy(this.lastChar, 0, Ee), ve.toString("utf8", Te, Ee);
  }
  function se(ve) {
    var Te = ve && ve.length ? this.write(ve) : "";
    return this.lastNeed ? Te + "�" : Te;
  }
  function de(ve, Te) {
    if ((ve.length - Te) % 2 === 0) {
      var we = ve.toString("utf16le", Te);
      if (we) {
        var Ee = we.charCodeAt(we.length - 1);
        if (Ee >= 55296 && Ee <= 56319)
          return this.lastNeed = 2, this.lastTotal = 4, this.lastChar[0] = ve[ve.length - 2], this.lastChar[1] = ve[ve.length - 1], we.slice(0, -1);
      }
      return we;
    }
    return this.lastNeed = 1, this.lastTotal = 2, this.lastChar[0] = ve[ve.length - 1], ve.toString("utf16le", Te, ve.length - 1);
  }
  function ue(ve) {
    var Te = ve && ve.length ? this.write(ve) : "";
    if (this.lastNeed) {
      var we = this.lastTotal - this.lastNeed;
      return Te + this.lastChar.toString("utf16le", 0, we);
    }
    return Te;
  }
  function fe(ve, Te) {
    var we = (ve.length - Te) % 3;
    return we === 0 ? ve.toString("base64", Te) : (this.lastNeed = 3 - we, this.lastTotal = 3, we === 1 ? this.lastChar[0] = ve[ve.length - 1] : (this.lastChar[0] = ve[ve.length - 2], this.lastChar[1] = ve[ve.length - 1]), ve.toString("base64", Te, ve.length - we));
  }
  function he(ve) {
    var Te = ve && ve.length ? this.write(ve) : "";
    return this.lastNeed ? Te + this.lastChar.toString("base64", 0, 3 - this.lastNeed) : Te;
  }
  function me(ve) {
    return ve.toString(this.encoding);
  }
  function xe(ve) {
    return ve && ve.length ? this.write(ve) : "";
  }
  return string_decoder$1;
}
var endOfStream, hasRequiredEndOfStream;
function requireEndOfStream() {
  if (hasRequiredEndOfStream) return endOfStream;
  hasRequiredEndOfStream = 1;
  var C = requireErrorsBrowser().codes.ERR_STREAM_PREMATURE_CLOSE;
  function e(J) {
    var ee = !1;
    return function() {
      if (!ee) {
        ee = !0;
        for (var te = arguments.length, re = new Array(te), ie = 0; ie < te; ie++)
          re[ie] = arguments[ie];
        J.apply(this, re);
      }
    };
  }
  function T() {
  }
  function $(J) {
    return J.setHeader && typeof J.abort == "function";
  }
  function V(J, ee, te) {
    if (typeof ee == "function") return V(J, null, ee);
    ee || (ee = {}), te = e(te || T);
    var re = ee.readable || ee.readable !== !1 && J.readable, ie = ee.writable || ee.writable !== !1 && J.writable, se = function() {
      J.writable || ue();
    }, de = J._writableState && J._writableState.finished, ue = function() {
      ie = !1, de = !0, re || te.call(J);
    }, fe = J._readableState && J._readableState.endEmitted, he = function() {
      re = !1, fe = !0, ie || te.call(J);
    }, me = function(we) {
      te.call(J, we);
    }, xe = function() {
      var we;
      if (re && !fe)
        return (!J._readableState || !J._readableState.ended) && (we = new C()), te.call(J, we);
      if (ie && !de)
        return (!J._writableState || !J._writableState.ended) && (we = new C()), te.call(J, we);
    }, ve = function() {
      J.req.on("finish", ue);
    };
    return $(J) ? (J.on("complete", ue), J.on("abort", xe), J.req ? ve() : J.on("request", ve)) : ie && !J._writableState && (J.on("end", se), J.on("close", se)), J.on("end", he), J.on("finish", ue), ee.error !== !1 && J.on("error", me), J.on("close", xe), function() {
      J.removeListener("complete", ue), J.removeListener("abort", xe), J.removeListener("request", ve), J.req && J.req.removeListener("finish", ue), J.removeListener("end", se), J.removeListener("close", se), J.removeListener("finish", ue), J.removeListener("end", he), J.removeListener("error", me), J.removeListener("close", xe);
    };
  }
  return endOfStream = V, endOfStream;
}
var async_iterator, hasRequiredAsync_iterator;
function requireAsync_iterator() {
  if (hasRequiredAsync_iterator) return async_iterator;
  hasRequiredAsync_iterator = 1;
  var C;
  function e(we, Ee, Me) {
    return Ee = T(Ee), Ee in we ? Object.defineProperty(we, Ee, { value: Me, enumerable: !0, configurable: !0, writable: !0 }) : we[Ee] = Me, we;
  }
  function T(we) {
    var Ee = $(we, "string");
    return typeof Ee == "symbol" ? Ee : String(Ee);
  }
  function $(we, Ee) {
    if (typeof we != "object" || we === null) return we;
    var Me = we[Symbol.toPrimitive];
    if (Me !== void 0) {
      var Ie = Me.call(we, Ee || "default");
      if (typeof Ie != "object") return Ie;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (Ee === "string" ? String : Number)(we);
  }
  var V = requireEndOfStream(), J = Symbol("lastResolve"), ee = Symbol("lastReject"), te = Symbol("error"), re = Symbol("ended"), ie = Symbol("lastPromise"), se = Symbol("handlePromise"), de = Symbol("stream");
  function ue(we, Ee) {
    return {
      value: we,
      done: Ee
    };
  }
  function fe(we) {
    var Ee = we[J];
    if (Ee !== null) {
      var Me = we[de].read();
      Me !== null && (we[ie] = null, we[J] = null, we[ee] = null, Ee(ue(Me, !1)));
    }
  }
  function he(we) {
    dist$2.process.nextTick(fe, we);
  }
  function me(we, Ee) {
    return function(Me, Ie) {
      we.then(function() {
        if (Ee[re]) {
          Me(ue(void 0, !0));
          return;
        }
        Ee[se](Me, Ie);
      }, Ie);
    };
  }
  var xe = Object.getPrototypeOf(function() {
  }), ve = Object.setPrototypeOf((C = {
    get stream() {
      return this[de];
    },
    next: function() {
      var Ee = this, Me = this[te];
      if (Me !== null)
        return Promise.reject(Me);
      if (this[re])
        return Promise.resolve(ue(void 0, !0));
      if (this[de].destroyed)
        return new Promise(function(De, Fe) {
          dist$2.process.nextTick(function() {
            Ee[te] ? Fe(Ee[te]) : De(ue(void 0, !0));
          });
        });
      var Ie = this[ie], ke;
      if (Ie)
        ke = new Promise(me(Ie, this));
      else {
        var _e = this[de].read();
        if (_e !== null)
          return Promise.resolve(ue(_e, !1));
        ke = new Promise(this[se]);
      }
      return this[ie] = ke, ke;
    }
  }, e(C, Symbol.asyncIterator, function() {
    return this;
  }), e(C, "return", function() {
    var Ee = this;
    return new Promise(function(Me, Ie) {
      Ee[de].destroy(null, function(ke) {
        if (ke) {
          Ie(ke);
          return;
        }
        Me(ue(void 0, !0));
      });
    });
  }), C), xe), Te = function(Ee) {
    var Me, Ie = Object.create(ve, (Me = {}, e(Me, de, {
      value: Ee,
      writable: !0
    }), e(Me, J, {
      value: null,
      writable: !0
    }), e(Me, ee, {
      value: null,
      writable: !0
    }), e(Me, te, {
      value: null,
      writable: !0
    }), e(Me, re, {
      value: Ee._readableState.endEmitted,
      writable: !0
    }), e(Me, se, {
      value: function(_e, De) {
        var Fe = Ie[de].read();
        Fe ? (Ie[ie] = null, Ie[J] = null, Ie[ee] = null, _e(ue(Fe, !1))) : (Ie[J] = _e, Ie[ee] = De);
      },
      writable: !0
    }), Me));
    return Ie[ie] = null, V(Ee, function(ke) {
      if (ke && ke.code !== "ERR_STREAM_PREMATURE_CLOSE") {
        var _e = Ie[ee];
        _e !== null && (Ie[ie] = null, Ie[J] = null, Ie[ee] = null, _e(ke)), Ie[te] = ke;
        return;
      }
      var De = Ie[J];
      De !== null && (Ie[ie] = null, Ie[J] = null, Ie[ee] = null, De(ue(void 0, !0))), Ie[re] = !0;
    }), Ee.on("readable", he.bind(null, Ie)), Ie;
  };
  return async_iterator = Te, async_iterator;
}
var fromBrowser, hasRequiredFromBrowser;
function requireFromBrowser() {
  return hasRequiredFromBrowser || (hasRequiredFromBrowser = 1, fromBrowser = function() {
    throw new Error("Readable.from is not available in the browser");
  }), fromBrowser;
}
var _stream_readable$1, hasRequired_stream_readable$1;
function require_stream_readable$1() {
  if (hasRequired_stream_readable$1) return _stream_readable$1;
  hasRequired_stream_readable$1 = 1, _stream_readable$1 = De;
  var C;
  De.ReadableState = _e, requireEvents().EventEmitter;
  var e = function(Ne, Ye) {
    return Ne.listeners(Ye).length;
  }, T = requireStreamBrowser$1(), $ = bufferPolyfill.Buffer, V = (typeof commonjsGlobal$1 < "u" ? commonjsGlobal$1 : typeof window < "u" ? window : typeof self < "u" ? self : {}).Uint8Array || function() {
  };
  function J(Oe) {
    return $.from(Oe);
  }
  function ee(Oe) {
    return $.isBuffer(Oe) || Oe instanceof V;
  }
  var te = require$$0$2, re;
  te && te.debuglog ? re = te.debuglog("stream") : re = function() {
  };
  var ie = requireBuffer_list(), se = requireDestroy$1(), de = requireState(), ue = de.getHighWaterMark, fe = requireErrorsBrowser().codes, he = fe.ERR_INVALID_ARG_TYPE, me = fe.ERR_STREAM_PUSH_AFTER_EOF, xe = fe.ERR_METHOD_NOT_IMPLEMENTED, ve = fe.ERR_STREAM_UNSHIFT_AFTER_END_EVENT, Te, we, Ee;
  requireInherits_browser()(De, T);
  var Me = se.errorOrDestroy, Ie = ["error", "close", "destroy", "pause", "resume"];
  function ke(Oe, Ne, Ye) {
    if (typeof Oe.prependListener == "function") return Oe.prependListener(Ne, Ye);
    !Oe._events || !Oe._events[Ne] ? Oe.on(Ne, Ye) : Array.isArray(Oe._events[Ne]) ? Oe._events[Ne].unshift(Ye) : Oe._events[Ne] = [Ye, Oe._events[Ne]];
  }
  function _e(Oe, Ne, Ye) {
    C = C || require_stream_duplex$1(), Oe = Oe || {}, typeof Ye != "boolean" && (Ye = Ne instanceof C), this.objectMode = !!Oe.objectMode, Ye && (this.objectMode = this.objectMode || !!Oe.readableObjectMode), this.highWaterMark = ue(this, Oe, "readableHighWaterMark", Ye), this.buffer = new ie(), this.length = 0, this.pipes = null, this.pipesCount = 0, this.flowing = null, this.ended = !1, this.endEmitted = !1, this.reading = !1, this.sync = !0, this.needReadable = !1, this.emittedReadable = !1, this.readableListening = !1, this.resumeScheduled = !1, this.paused = !0, this.emitClose = Oe.emitClose !== !1, this.autoDestroy = !!Oe.autoDestroy, this.destroyed = !1, this.defaultEncoding = Oe.defaultEncoding || "utf8", this.awaitDrain = 0, this.readingMore = !1, this.decoder = null, this.encoding = null, Oe.encoding && (Te || (Te = requireString_decoder$1().StringDecoder), this.decoder = new Te(Oe.encoding), this.encoding = Oe.encoding);
  }
  function De(Oe) {
    if (C = C || require_stream_duplex$1(), !(this instanceof De)) return new De(Oe);
    var Ne = this instanceof C;
    this._readableState = new _e(Oe, this, Ne), this.readable = !0, Oe && (typeof Oe.read == "function" && (this._read = Oe.read), typeof Oe.destroy == "function" && (this._destroy = Oe.destroy)), T.call(this);
  }
  Object.defineProperty(De.prototype, "destroyed", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._readableState === void 0 ? !1 : this._readableState.destroyed;
    },
    set: function(Ne) {
      this._readableState && (this._readableState.destroyed = Ne);
    }
  }), De.prototype.destroy = se.destroy, De.prototype._undestroy = se.undestroy, De.prototype._destroy = function(Oe, Ne) {
    Ne(Oe);
  }, De.prototype.push = function(Oe, Ne) {
    var Ye = this._readableState, Je;
    return Ye.objectMode ? Je = !0 : typeof Oe == "string" && (Ne = Ne || Ye.defaultEncoding, Ne !== Ye.encoding && (Oe = $.from(Oe, Ne), Ne = ""), Je = !0), Fe(this, Oe, Ne, !1, Je);
  }, De.prototype.unshift = function(Oe) {
    return Fe(this, Oe, null, !0, !1);
  };
  function Fe(Oe, Ne, Ye, Je, Xe) {
    re("readableAddChunk", Ne);
    var st = Oe._readableState;
    if (Ne === null)
      st.reading = !1, pe(Oe, st);
    else {
      var ct;
      if (Xe || (ct = ne(st, Ne)), ct)
        Me(Oe, ct);
      else if (st.objectMode || Ne && Ne.length > 0)
        if (typeof Ne != "string" && !st.objectMode && Object.getPrototypeOf(Ne) !== $.prototype && (Ne = J(Ne)), Je)
          st.endEmitted ? Me(Oe, new ve()) : Ae(Oe, st, Ne, !0);
        else if (st.ended)
          Me(Oe, new me());
        else {
          if (st.destroyed)
            return !1;
          st.reading = !1, st.decoder && !Ye ? (Ne = st.decoder.write(Ne), st.objectMode || Ne.length !== 0 ? Ae(Oe, st, Ne, !1) : be(Oe, st)) : Ae(Oe, st, Ne, !1);
        }
      else Je || (st.reading = !1, be(Oe, st));
    }
    return !st.ended && (st.length < st.highWaterMark || st.length === 0);
  }
  function Ae(Oe, Ne, Ye, Je) {
    Ne.flowing && Ne.length === 0 && !Ne.sync ? (Ne.awaitDrain = 0, Oe.emit("data", Ye)) : (Ne.length += Ne.objectMode ? 1 : Ye.length, Je ? Ne.buffer.unshift(Ye) : Ne.buffer.push(Ye), Ne.needReadable && ye(Oe)), be(Oe, Ne);
  }
  function ne(Oe, Ne) {
    var Ye;
    return !ee(Ne) && typeof Ne != "string" && Ne !== void 0 && !Oe.objectMode && (Ye = new he("chunk", ["string", "Buffer", "Uint8Array"], Ne)), Ye;
  }
  De.prototype.isPaused = function() {
    return this._readableState.flowing === !1;
  }, De.prototype.setEncoding = function(Oe) {
    Te || (Te = requireString_decoder$1().StringDecoder);
    var Ne = new Te(Oe);
    this._readableState.decoder = Ne, this._readableState.encoding = this._readableState.decoder.encoding;
    for (var Ye = this._readableState.buffer.head, Je = ""; Ye !== null; )
      Je += Ne.write(Ye.data), Ye = Ye.next;
    return this._readableState.buffer.clear(), Je !== "" && this._readableState.buffer.push(Je), this._readableState.length = Je.length, this;
  };
  var oe = 1073741824;
  function ce(Oe) {
    return Oe >= oe ? Oe = oe : (Oe--, Oe |= Oe >>> 1, Oe |= Oe >>> 2, Oe |= Oe >>> 4, Oe |= Oe >>> 8, Oe |= Oe >>> 16, Oe++), Oe;
  }
  function le(Oe, Ne) {
    return Oe <= 0 || Ne.length === 0 && Ne.ended ? 0 : Ne.objectMode ? 1 : Oe !== Oe ? Ne.flowing && Ne.length ? Ne.buffer.head.data.length : Ne.length : (Oe > Ne.highWaterMark && (Ne.highWaterMark = ce(Oe)), Oe <= Ne.length ? Oe : Ne.ended ? Ne.length : (Ne.needReadable = !0, 0));
  }
  De.prototype.read = function(Oe) {
    re("read", Oe), Oe = parseInt(Oe, 10);
    var Ne = this._readableState, Ye = Oe;
    if (Oe !== 0 && (Ne.emittedReadable = !1), Oe === 0 && Ne.needReadable && ((Ne.highWaterMark !== 0 ? Ne.length >= Ne.highWaterMark : Ne.length > 0) || Ne.ended))
      return re("read: emitReadable", Ne.length, Ne.ended), Ne.length === 0 && Ne.ended ? Ue(this) : ye(this), null;
    if (Oe = le(Oe, Ne), Oe === 0 && Ne.ended)
      return Ne.length === 0 && Ue(this), null;
    var Je = Ne.needReadable;
    re("need readable", Je), (Ne.length === 0 || Ne.length - Oe < Ne.highWaterMark) && (Je = !0, re("length less than watermark", Je)), Ne.ended || Ne.reading ? (Je = !1, re("reading or ended", Je)) : Je && (re("do read"), Ne.reading = !0, Ne.sync = !0, Ne.length === 0 && (Ne.needReadable = !0), this._read(Ne.highWaterMark), Ne.sync = !1, Ne.reading || (Oe = le(Ye, Ne)));
    var Xe;
    return Oe > 0 ? Xe = Be(Oe, Ne) : Xe = null, Xe === null ? (Ne.needReadable = Ne.length <= Ne.highWaterMark, Oe = 0) : (Ne.length -= Oe, Ne.awaitDrain = 0), Ne.length === 0 && (Ne.ended || (Ne.needReadable = !0), Ye !== Oe && Ne.ended && Ue(this)), Xe !== null && this.emit("data", Xe), Xe;
  };
  function pe(Oe, Ne) {
    if (re("onEofChunk"), !Ne.ended) {
      if (Ne.decoder) {
        var Ye = Ne.decoder.end();
        Ye && Ye.length && (Ne.buffer.push(Ye), Ne.length += Ne.objectMode ? 1 : Ye.length);
      }
      Ne.ended = !0, Ne.sync ? ye(Oe) : (Ne.needReadable = !1, Ne.emittedReadable || (Ne.emittedReadable = !0, Ce(Oe)));
    }
  }
  function ye(Oe) {
    var Ne = Oe._readableState;
    re("emitReadable", Ne.needReadable, Ne.emittedReadable), Ne.needReadable = !1, Ne.emittedReadable || (re("emitReadable", Ne.flowing), Ne.emittedReadable = !0, dist$2.process.nextTick(Ce, Oe));
  }
  function Ce(Oe) {
    var Ne = Oe._readableState;
    re("emitReadable_", Ne.destroyed, Ne.length, Ne.ended), !Ne.destroyed && (Ne.length || Ne.ended) && (Oe.emit("readable"), Ne.emittedReadable = !1), Ne.needReadable = !Ne.flowing && !Ne.ended && Ne.length <= Ne.highWaterMark, We(Oe);
  }
  function be(Oe, Ne) {
    Ne.readingMore || (Ne.readingMore = !0, dist$2.process.nextTick(ae, Oe, Ne));
  }
  function ae(Oe, Ne) {
    for (; !Ne.reading && !Ne.ended && (Ne.length < Ne.highWaterMark || Ne.flowing && Ne.length === 0); ) {
      var Ye = Ne.length;
      if (re("maybeReadMore read 0"), Oe.read(0), Ye === Ne.length)
        break;
    }
    Ne.readingMore = !1;
  }
  De.prototype._read = function(Oe) {
    Me(this, new xe("_read()"));
  }, De.prototype.pipe = function(Oe, Ne) {
    var Ye = this, Je = this._readableState;
    switch (Je.pipesCount) {
      case 0:
        Je.pipes = Oe;
        break;
      case 1:
        Je.pipes = [Je.pipes, Oe];
        break;
      default:
        Je.pipes.push(Oe);
        break;
    }
    Je.pipesCount += 1, re("pipe count=%d opts=%j", Je.pipesCount, Ne);
    var Xe = (!Ne || Ne.end !== !1) && Oe !== dist$2.process.stdout && Oe !== dist$2.process.stderr, st = Xe ? it : Yt;
    Je.endEmitted ? dist$2.process.nextTick(st) : Ye.once("end", st), Oe.on("unpipe", ct);
    function ct(Ve, Pe) {
      re("onunpipe"), Ve === Ye && Pe && Pe.hasUnpiped === !1 && (Pe.hasUnpiped = !0, dt());
    }
    function it() {
      re("onend"), Oe.end();
    }
    var ot = ge(Ye);
    Oe.on("drain", ot);
    var yt = !1;
    function dt() {
      re("cleanup"), Oe.removeListener("close", xt), Oe.removeListener("finish", Tt), Oe.removeListener("drain", ot), Oe.removeListener("error", It), Oe.removeListener("unpipe", ct), Ye.removeListener("end", it), Ye.removeListener("end", Yt), Ye.removeListener("data", mt), yt = !0, Je.awaitDrain && (!Oe._writableState || Oe._writableState.needDrain) && ot();
    }
    Ye.on("data", mt);
    function mt(Ve) {
      re("ondata");
      var Pe = Oe.write(Ve);
      re("dest.write", Pe), Pe === !1 && ((Je.pipesCount === 1 && Je.pipes === Oe || Je.pipesCount > 1 && je(Je.pipes, Oe) !== -1) && !yt && (re("false write response, pause", Je.awaitDrain), Je.awaitDrain++), Ye.pause());
    }
    function It(Ve) {
      re("onerror", Ve), Yt(), Oe.removeListener("error", It), e(Oe, "error") === 0 && Me(Oe, Ve);
    }
    ke(Oe, "error", It);
    function xt() {
      Oe.removeListener("finish", Tt), Yt();
    }
    Oe.once("close", xt);
    function Tt() {
      re("onfinish"), Oe.removeListener("close", xt), Yt();
    }
    Oe.once("finish", Tt);
    function Yt() {
      re("unpipe"), Ye.unpipe(Oe);
    }
    return Oe.emit("pipe", Ye), Je.flowing || (re("pipe resume"), Ye.resume()), Oe;
  };
  function ge(Oe) {
    return function() {
      var Ye = Oe._readableState;
      re("pipeOnDrain", Ye.awaitDrain), Ye.awaitDrain && Ye.awaitDrain--, Ye.awaitDrain === 0 && e(Oe, "data") && (Ye.flowing = !0, We(Oe));
    };
  }
  De.prototype.unpipe = function(Oe) {
    var Ne = this._readableState, Ye = {
      hasUnpiped: !1
    };
    if (Ne.pipesCount === 0) return this;
    if (Ne.pipesCount === 1)
      return Oe && Oe !== Ne.pipes ? this : (Oe || (Oe = Ne.pipes), Ne.pipes = null, Ne.pipesCount = 0, Ne.flowing = !1, Oe && Oe.emit("unpipe", this, Ye), this);
    if (!Oe) {
      var Je = Ne.pipes, Xe = Ne.pipesCount;
      Ne.pipes = null, Ne.pipesCount = 0, Ne.flowing = !1;
      for (var st = 0; st < Xe; st++) Je[st].emit("unpipe", this, {
        hasUnpiped: !1
      });
      return this;
    }
    var ct = je(Ne.pipes, Oe);
    return ct === -1 ? this : (Ne.pipes.splice(ct, 1), Ne.pipesCount -= 1, Ne.pipesCount === 1 && (Ne.pipes = Ne.pipes[0]), Oe.emit("unpipe", this, Ye), this);
  }, De.prototype.on = function(Oe, Ne) {
    var Ye = T.prototype.on.call(this, Oe, Ne), Je = this._readableState;
    return Oe === "data" ? (Je.readableListening = this.listenerCount("readable") > 0, Je.flowing !== !1 && this.resume()) : Oe === "readable" && !Je.endEmitted && !Je.readableListening && (Je.readableListening = Je.needReadable = !0, Je.flowing = !1, Je.emittedReadable = !1, re("on readable", Je.length, Je.reading), Je.length ? ye(this) : Je.reading || dist$2.process.nextTick(Le, this)), Ye;
  }, De.prototype.addListener = De.prototype.on, De.prototype.removeListener = function(Oe, Ne) {
    var Ye = T.prototype.removeListener.call(this, Oe, Ne);
    return Oe === "readable" && dist$2.process.nextTick(Se, this), Ye;
  }, De.prototype.removeAllListeners = function(Oe) {
    var Ne = T.prototype.removeAllListeners.apply(this, arguments);
    return (Oe === "readable" || Oe === void 0) && dist$2.process.nextTick(Se, this), Ne;
  };
  function Se(Oe) {
    var Ne = Oe._readableState;
    Ne.readableListening = Oe.listenerCount("readable") > 0, Ne.resumeScheduled && !Ne.paused ? Ne.flowing = !0 : Oe.listenerCount("data") > 0 && Oe.resume();
  }
  function Le(Oe) {
    re("readable nexttick read 0"), Oe.read(0);
  }
  De.prototype.resume = function() {
    var Oe = this._readableState;
    return Oe.flowing || (re("resume"), Oe.flowing = !Oe.readableListening, ze(this, Oe)), Oe.paused = !1, this;
  };
  function ze(Oe, Ne) {
    Ne.resumeScheduled || (Ne.resumeScheduled = !0, dist$2.process.nextTick(Re, Oe, Ne));
  }
  function Re(Oe, Ne) {
    re("resume", Ne.reading), Ne.reading || Oe.read(0), Ne.resumeScheduled = !1, Oe.emit("resume"), We(Oe), Ne.flowing && !Ne.reading && Oe.read(0);
  }
  De.prototype.pause = function() {
    return re("call pause flowing=%j", this._readableState.flowing), this._readableState.flowing !== !1 && (re("pause"), this._readableState.flowing = !1, this.emit("pause")), this._readableState.paused = !0, this;
  };
  function We(Oe) {
    var Ne = Oe._readableState;
    for (re("flow", Ne.flowing); Ne.flowing && Oe.read() !== null; ) ;
  }
  De.prototype.wrap = function(Oe) {
    var Ne = this, Ye = this._readableState, Je = !1;
    Oe.on("end", function() {
      if (re("wrapped end"), Ye.decoder && !Ye.ended) {
        var ct = Ye.decoder.end();
        ct && ct.length && Ne.push(ct);
      }
      Ne.push(null);
    }), Oe.on("data", function(ct) {
      if (re("wrapped data"), Ye.decoder && (ct = Ye.decoder.write(ct)), !(Ye.objectMode && ct == null) && !(!Ye.objectMode && (!ct || !ct.length))) {
        var it = Ne.push(ct);
        it || (Je = !0, Oe.pause());
      }
    });
    for (var Xe in Oe)
      this[Xe] === void 0 && typeof Oe[Xe] == "function" && (this[Xe] = /* @__PURE__ */ function(it) {
        return function() {
          return Oe[it].apply(Oe, arguments);
        };
      }(Xe));
    for (var st = 0; st < Ie.length; st++)
      Oe.on(Ie[st], this.emit.bind(this, Ie[st]));
    return this._read = function(ct) {
      re("wrapped _read", ct), Je && (Je = !1, Oe.resume());
    }, this;
  }, typeof Symbol == "function" && (De.prototype[Symbol.asyncIterator] = function() {
    return we === void 0 && (we = requireAsync_iterator()), we(this);
  }), Object.defineProperty(De.prototype, "readableHighWaterMark", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._readableState.highWaterMark;
    }
  }), Object.defineProperty(De.prototype, "readableBuffer", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._readableState && this._readableState.buffer;
    }
  }), Object.defineProperty(De.prototype, "readableFlowing", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._readableState.flowing;
    },
    set: function(Ne) {
      this._readableState && (this._readableState.flowing = Ne);
    }
  }), De._fromList = Be, Object.defineProperty(De.prototype, "readableLength", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._readableState.length;
    }
  });
  function Be(Oe, Ne) {
    if (Ne.length === 0) return null;
    var Ye;
    return Ne.objectMode ? Ye = Ne.buffer.shift() : !Oe || Oe >= Ne.length ? (Ne.decoder ? Ye = Ne.buffer.join("") : Ne.buffer.length === 1 ? Ye = Ne.buffer.first() : Ye = Ne.buffer.concat(Ne.length), Ne.buffer.clear()) : Ye = Ne.buffer.consume(Oe, Ne.decoder), Ye;
  }
  function Ue(Oe) {
    var Ne = Oe._readableState;
    re("endReadable", Ne.endEmitted), Ne.endEmitted || (Ne.ended = !0, dist$2.process.nextTick(Ge, Ne, Oe));
  }
  function Ge(Oe, Ne) {
    if (re("endReadableNT", Oe.endEmitted, Oe.length), !Oe.endEmitted && Oe.length === 0 && (Oe.endEmitted = !0, Ne.readable = !1, Ne.emit("end"), Oe.autoDestroy)) {
      var Ye = Ne._writableState;
      (!Ye || Ye.autoDestroy && Ye.finished) && Ne.destroy();
    }
  }
  typeof Symbol == "function" && (De.from = function(Oe, Ne) {
    return Ee === void 0 && (Ee = requireFromBrowser()), Ee(De, Oe, Ne);
  });
  function je(Oe, Ne) {
    for (var Ye = 0, Je = Oe.length; Ye < Je; Ye++)
      if (Oe[Ye] === Ne) return Ye;
    return -1;
  }
  return _stream_readable$1;
}
var _stream_transform$1, hasRequired_stream_transform$1;
function require_stream_transform$1() {
  if (hasRequired_stream_transform$1) return _stream_transform$1;
  hasRequired_stream_transform$1 = 1, _stream_transform$1 = te;
  var C = requireErrorsBrowser().codes, e = C.ERR_METHOD_NOT_IMPLEMENTED, T = C.ERR_MULTIPLE_CALLBACK, $ = C.ERR_TRANSFORM_ALREADY_TRANSFORMING, V = C.ERR_TRANSFORM_WITH_LENGTH_0, J = require_stream_duplex$1();
  requireInherits_browser()(te, J);
  function ee(se, de) {
    var ue = this._transformState;
    ue.transforming = !1;
    var fe = ue.writecb;
    if (fe === null)
      return this.emit("error", new T());
    ue.writechunk = null, ue.writecb = null, de != null && this.push(de), fe(se);
    var he = this._readableState;
    he.reading = !1, (he.needReadable || he.length < he.highWaterMark) && this._read(he.highWaterMark);
  }
  function te(se) {
    if (!(this instanceof te)) return new te(se);
    J.call(this, se), this._transformState = {
      afterTransform: ee.bind(this),
      needTransform: !1,
      transforming: !1,
      writecb: null,
      writechunk: null,
      writeencoding: null
    }, this._readableState.needReadable = !0, this._readableState.sync = !1, se && (typeof se.transform == "function" && (this._transform = se.transform), typeof se.flush == "function" && (this._flush = se.flush)), this.on("prefinish", re);
  }
  function re() {
    var se = this;
    typeof this._flush == "function" && !this._readableState.destroyed ? this._flush(function(de, ue) {
      ie(se, de, ue);
    }) : ie(this, null, null);
  }
  te.prototype.push = function(se, de) {
    return this._transformState.needTransform = !1, J.prototype.push.call(this, se, de);
  }, te.prototype._transform = function(se, de, ue) {
    ue(new e("_transform()"));
  }, te.prototype._write = function(se, de, ue) {
    var fe = this._transformState;
    if (fe.writecb = ue, fe.writechunk = se, fe.writeencoding = de, !fe.transforming) {
      var he = this._readableState;
      (fe.needTransform || he.needReadable || he.length < he.highWaterMark) && this._read(he.highWaterMark);
    }
  }, te.prototype._read = function(se) {
    var de = this._transformState;
    de.writechunk !== null && !de.transforming ? (de.transforming = !0, this._transform(de.writechunk, de.writeencoding, de.afterTransform)) : de.needTransform = !0;
  }, te.prototype._destroy = function(se, de) {
    J.prototype._destroy.call(this, se, function(ue) {
      de(ue);
    });
  };
  function ie(se, de, ue) {
    if (de) return se.emit("error", de);
    if (ue != null && se.push(ue), se._writableState.length) throw new V();
    if (se._transformState.transforming) throw new $();
    return se.push(null);
  }
  return _stream_transform$1;
}
var _stream_passthrough$1, hasRequired_stream_passthrough$1;
function require_stream_passthrough$1() {
  if (hasRequired_stream_passthrough$1) return _stream_passthrough$1;
  hasRequired_stream_passthrough$1 = 1, _stream_passthrough$1 = e;
  var C = require_stream_transform$1();
  requireInherits_browser()(e, C);
  function e(T) {
    if (!(this instanceof e)) return new e(T);
    C.call(this, T);
  }
  return e.prototype._transform = function(T, $, V) {
    V(null, T);
  }, _stream_passthrough$1;
}
var pipeline_1, hasRequiredPipeline;
function requirePipeline() {
  if (hasRequiredPipeline) return pipeline_1;
  hasRequiredPipeline = 1;
  var C;
  function e(ue) {
    var fe = !1;
    return function() {
      fe || (fe = !0, ue.apply(void 0, arguments));
    };
  }
  var T = requireErrorsBrowser().codes, $ = T.ERR_MISSING_ARGS, V = T.ERR_STREAM_DESTROYED;
  function J(ue) {
    if (ue) throw ue;
  }
  function ee(ue) {
    return ue.setHeader && typeof ue.abort == "function";
  }
  function te(ue, fe, he, me) {
    me = e(me);
    var xe = !1;
    ue.on("close", function() {
      xe = !0;
    }), C === void 0 && (C = requireEndOfStream()), C(ue, {
      readable: fe,
      writable: he
    }, function(Te) {
      if (Te) return me(Te);
      xe = !0, me();
    });
    var ve = !1;
    return function(Te) {
      if (!xe && !ve) {
        if (ve = !0, ee(ue)) return ue.abort();
        if (typeof ue.destroy == "function") return ue.destroy();
        me(Te || new V("pipe"));
      }
    };
  }
  function re(ue) {
    ue();
  }
  function ie(ue, fe) {
    return ue.pipe(fe);
  }
  function se(ue) {
    return !ue.length || typeof ue[ue.length - 1] != "function" ? J : ue.pop();
  }
  function de() {
    for (var ue = arguments.length, fe = new Array(ue), he = 0; he < ue; he++)
      fe[he] = arguments[he];
    var me = se(fe);
    if (Array.isArray(fe[0]) && (fe = fe[0]), fe.length < 2)
      throw new $("streams");
    var xe, ve = fe.map(function(Te, we) {
      var Ee = we < fe.length - 1, Me = we > 0;
      return te(Te, Ee, Me, function(Ie) {
        xe || (xe = Ie), Ie && ve.forEach(re), !Ee && (ve.forEach(re), me(xe));
      });
    });
    return fe.reduce(ie);
  }
  return pipeline_1 = de, pipeline_1;
}
var streamBrowserify, hasRequiredStreamBrowserify;
function requireStreamBrowserify() {
  if (hasRequiredStreamBrowserify) return streamBrowserify;
  hasRequiredStreamBrowserify = 1, streamBrowserify = T;
  var C = requireEvents().EventEmitter, e = requireInherits_browser();
  e(T, C), T.Readable = require_stream_readable$1(), T.Writable = require_stream_writable$1(), T.Duplex = require_stream_duplex$1(), T.Transform = require_stream_transform$1(), T.PassThrough = require_stream_passthrough$1(), T.finished = requireEndOfStream(), T.pipeline = requirePipeline(), T.Stream = T;
  function T() {
    C.call(this);
  }
  return T.prototype.pipe = function($, V) {
    var J = this;
    function ee(fe) {
      $.writable && $.write(fe) === !1 && J.pause && J.pause();
    }
    J.on("data", ee);
    function te() {
      J.readable && J.resume && J.resume();
    }
    $.on("drain", te), !$._isStdio && (!V || V.end !== !1) && (J.on("end", ie), J.on("close", se));
    var re = !1;
    function ie() {
      re || (re = !0, $.end());
    }
    function se() {
      re || (re = !0, typeof $.destroy == "function" && $.destroy());
    }
    function de(fe) {
      if (ue(), C.listenerCount(this, "error") === 0)
        throw fe;
    }
    J.on("error", de), $.on("error", de);
    function ue() {
      J.removeListener("data", ee), $.removeListener("drain", te), J.removeListener("end", ie), J.removeListener("close", se), J.removeListener("error", de), $.removeListener("error", de), J.removeListener("end", ue), J.removeListener("close", ue), $.removeListener("close", ue);
    }
    return J.on("end", ue), J.on("close", ue), $.on("close", ue), $.emit("pipe", J), $;
  }, streamBrowserify;
}
var hashBase, hasRequiredHashBase;
function requireHashBase() {
  if (hasRequiredHashBase) return hashBase;
  hasRequiredHashBase = 1;
  var C = safeBufferExports.Buffer, e = requireStreamBrowserify().Transform, T = requireInherits_browser();
  function $(te) {
    e.call(this), this._block = C.allocUnsafe(te), this._blockSize = te, this._blockOffset = 0, this._length = [0, 0, 0, 0], this._finalized = !1;
  }
  T($, e), $.prototype._transform = function(te, re, ie) {
    var se = null;
    try {
      this.update(te, re);
    } catch (de) {
      se = de;
    }
    ie(se);
  }, $.prototype._flush = function(te) {
    var re = null;
    try {
      this.push(this.digest());
    } catch (ie) {
      re = ie;
    }
    te(re);
  };
  var V = typeof Uint8Array < "u", J = typeof ArrayBuffer < "u" && typeof Uint8Array < "u" && ArrayBuffer.isView && (C.prototype instanceof Uint8Array || C.TYPED_ARRAY_SUPPORT);
  function ee(te, re) {
    if (te instanceof C) return te;
    if (typeof te == "string") return C.from(te, re);
    if (J && ArrayBuffer.isView(te)) {
      if (te.byteLength === 0) return C.alloc(0);
      var ie = C.from(te.buffer, te.byteOffset, te.byteLength);
      if (ie.byteLength === te.byteLength) return ie;
    }
    if (V && te instanceof Uint8Array || C.isBuffer(te) && te.constructor && typeof te.constructor.isBuffer == "function" && te.constructor.isBuffer(te))
      return C.from(te);
    throw new TypeError('The "data" argument must be of type string or an instance of Buffer, TypedArray, or DataView.');
  }
  return $.prototype.update = function(te, re) {
    if (this._finalized) throw new Error("Digest already called");
    te = ee(te, re);
    for (var ie = this._block, se = 0; this._blockOffset + te.length - se >= this._blockSize; ) {
      for (var de = this._blockOffset; de < this._blockSize; ) ie[de++] = te[se++];
      this._update(), this._blockOffset = 0;
    }
    for (; se < te.length; ) ie[this._blockOffset++] = te[se++];
    for (var ue = 0, fe = te.length * 8; fe > 0; ++ue)
      this._length[ue] += fe, fe = this._length[ue] / 4294967296 | 0, fe > 0 && (this._length[ue] -= 4294967296 * fe);
    return this;
  }, $.prototype._update = function() {
    throw new Error("_update is not implemented");
  }, $.prototype.digest = function(te) {
    if (this._finalized) throw new Error("Digest already called");
    this._finalized = !0;
    var re = this._digest();
    te !== void 0 && (re = re.toString(te)), this._block.fill(0), this._blockOffset = 0;
    for (var ie = 0; ie < 4; ++ie) this._length[ie] = 0;
    return re;
  }, $.prototype._digest = function() {
    throw new Error("_digest is not implemented");
  }, hashBase = $, hashBase;
}
var md5_js, hasRequiredMd5_js;
function requireMd5_js() {
  if (hasRequiredMd5_js) return md5_js;
  hasRequiredMd5_js = 1;
  var C = requireInherits_browser(), e = requireHashBase(), T = safeBufferExports.Buffer, $ = new Array(16);
  function V() {
    e.call(this, 64), this._a = 1732584193, this._b = 4023233417, this._c = 2562383102, this._d = 271733878;
  }
  C(V, e), V.prototype._update = function() {
    for (var se = $, de = 0; de < 16; ++de) se[de] = this._block.readInt32LE(de * 4);
    var ue = this._a, fe = this._b, he = this._c, me = this._d;
    ue = ee(ue, fe, he, me, se[0], 3614090360, 7), me = ee(me, ue, fe, he, se[1], 3905402710, 12), he = ee(he, me, ue, fe, se[2], 606105819, 17), fe = ee(fe, he, me, ue, se[3], 3250441966, 22), ue = ee(ue, fe, he, me, se[4], 4118548399, 7), me = ee(me, ue, fe, he, se[5], 1200080426, 12), he = ee(he, me, ue, fe, se[6], 2821735955, 17), fe = ee(fe, he, me, ue, se[7], 4249261313, 22), ue = ee(ue, fe, he, me, se[8], 1770035416, 7), me = ee(me, ue, fe, he, se[9], 2336552879, 12), he = ee(he, me, ue, fe, se[10], 4294925233, 17), fe = ee(fe, he, me, ue, se[11], 2304563134, 22), ue = ee(ue, fe, he, me, se[12], 1804603682, 7), me = ee(me, ue, fe, he, se[13], 4254626195, 12), he = ee(he, me, ue, fe, se[14], 2792965006, 17), fe = ee(fe, he, me, ue, se[15], 1236535329, 22), ue = te(ue, fe, he, me, se[1], 4129170786, 5), me = te(me, ue, fe, he, se[6], 3225465664, 9), he = te(he, me, ue, fe, se[11], 643717713, 14), fe = te(fe, he, me, ue, se[0], 3921069994, 20), ue = te(ue, fe, he, me, se[5], 3593408605, 5), me = te(me, ue, fe, he, se[10], 38016083, 9), he = te(he, me, ue, fe, se[15], 3634488961, 14), fe = te(fe, he, me, ue, se[4], 3889429448, 20), ue = te(ue, fe, he, me, se[9], 568446438, 5), me = te(me, ue, fe, he, se[14], 3275163606, 9), he = te(he, me, ue, fe, se[3], 4107603335, 14), fe = te(fe, he, me, ue, se[8], 1163531501, 20), ue = te(ue, fe, he, me, se[13], 2850285829, 5), me = te(me, ue, fe, he, se[2], 4243563512, 9), he = te(he, me, ue, fe, se[7], 1735328473, 14), fe = te(fe, he, me, ue, se[12], 2368359562, 20), ue = re(ue, fe, he, me, se[5], 4294588738, 4), me = re(me, ue, fe, he, se[8], 2272392833, 11), he = re(he, me, ue, fe, se[11], 1839030562, 16), fe = re(fe, he, me, ue, se[14], 4259657740, 23), ue = re(ue, fe, he, me, se[1], 2763975236, 4), me = re(me, ue, fe, he, se[4], 1272893353, 11), he = re(he, me, ue, fe, se[7], 4139469664, 16), fe = re(fe, he, me, ue, se[10], 3200236656, 23), ue = re(ue, fe, he, me, se[13], 681279174, 4), me = re(me, ue, fe, he, se[0], 3936430074, 11), he = re(he, me, ue, fe, se[3], 3572445317, 16), fe = re(fe, he, me, ue, se[6], 76029189, 23), ue = re(ue, fe, he, me, se[9], 3654602809, 4), me = re(me, ue, fe, he, se[12], 3873151461, 11), he = re(he, me, ue, fe, se[15], 530742520, 16), fe = re(fe, he, me, ue, se[2], 3299628645, 23), ue = ie(ue, fe, he, me, se[0], 4096336452, 6), me = ie(me, ue, fe, he, se[7], 1126891415, 10), he = ie(he, me, ue, fe, se[14], 2878612391, 15), fe = ie(fe, he, me, ue, se[5], 4237533241, 21), ue = ie(ue, fe, he, me, se[12], 1700485571, 6), me = ie(me, ue, fe, he, se[3], 2399980690, 10), he = ie(he, me, ue, fe, se[10], 4293915773, 15), fe = ie(fe, he, me, ue, se[1], 2240044497, 21), ue = ie(ue, fe, he, me, se[8], 1873313359, 6), me = ie(me, ue, fe, he, se[15], 4264355552, 10), he = ie(he, me, ue, fe, se[6], 2734768916, 15), fe = ie(fe, he, me, ue, se[13], 1309151649, 21), ue = ie(ue, fe, he, me, se[4], 4149444226, 6), me = ie(me, ue, fe, he, se[11], 3174756917, 10), he = ie(he, me, ue, fe, se[2], 718787259, 15), fe = ie(fe, he, me, ue, se[9], 3951481745, 21), this._a = this._a + ue | 0, this._b = this._b + fe | 0, this._c = this._c + he | 0, this._d = this._d + me | 0;
  }, V.prototype._digest = function() {
    this._block[this._blockOffset++] = 128, this._blockOffset > 56 && (this._block.fill(0, this._blockOffset, 64), this._update(), this._blockOffset = 0), this._block.fill(0, this._blockOffset, 56), this._block.writeUInt32LE(this._length[0], 56), this._block.writeUInt32LE(this._length[1], 60), this._update();
    var se = T.allocUnsafe(16);
    return se.writeInt32LE(this._a, 0), se.writeInt32LE(this._b, 4), se.writeInt32LE(this._c, 8), se.writeInt32LE(this._d, 12), se;
  };
  function J(se, de) {
    return se << de | se >>> 32 - de;
  }
  function ee(se, de, ue, fe, he, me, xe) {
    return J(se + (de & ue | ~de & fe) + he + me | 0, xe) + de | 0;
  }
  function te(se, de, ue, fe, he, me, xe) {
    return J(se + (de & fe | ue & ~fe) + he + me | 0, xe) + de | 0;
  }
  function re(se, de, ue, fe, he, me, xe) {
    return J(se + (de ^ ue ^ fe) + he + me | 0, xe) + de | 0;
  }
  function ie(se, de, ue, fe, he, me, xe) {
    return J(se + (ue ^ (de | ~fe)) + he + me | 0, xe) + de | 0;
  }
  return md5_js = V, md5_js;
}
var ripemd160, hasRequiredRipemd160;
function requireRipemd160() {
  if (hasRequiredRipemd160) return ripemd160;
  hasRequiredRipemd160 = 1;
  var C = bufferPolyfill.Buffer, e = requireInherits_browser(), T = requireHashBase(), $ = new Array(16), V = [
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15,
    7,
    4,
    13,
    1,
    10,
    6,
    15,
    3,
    12,
    0,
    9,
    5,
    2,
    14,
    11,
    8,
    3,
    10,
    14,
    4,
    9,
    15,
    8,
    1,
    2,
    7,
    0,
    6,
    13,
    11,
    5,
    12,
    1,
    9,
    11,
    10,
    0,
    8,
    12,
    4,
    13,
    3,
    7,
    15,
    14,
    5,
    6,
    2,
    4,
    0,
    5,
    9,
    7,
    12,
    2,
    10,
    14,
    1,
    3,
    8,
    11,
    6,
    15,
    13
  ], J = [
    5,
    14,
    7,
    0,
    9,
    2,
    11,
    4,
    13,
    6,
    15,
    8,
    1,
    10,
    3,
    12,
    6,
    11,
    3,
    7,
    0,
    13,
    5,
    10,
    14,
    15,
    8,
    12,
    4,
    9,
    1,
    2,
    15,
    5,
    1,
    3,
    7,
    14,
    6,
    9,
    11,
    8,
    12,
    2,
    10,
    0,
    4,
    13,
    8,
    6,
    4,
    1,
    3,
    11,
    15,
    0,
    5,
    12,
    2,
    13,
    9,
    7,
    10,
    14,
    12,
    15,
    10,
    4,
    1,
    5,
    8,
    7,
    6,
    2,
    13,
    14,
    0,
    3,
    9,
    11
  ], ee = [
    11,
    14,
    15,
    12,
    5,
    8,
    7,
    9,
    11,
    13,
    14,
    15,
    6,
    7,
    9,
    8,
    7,
    6,
    8,
    13,
    11,
    9,
    7,
    15,
    7,
    12,
    15,
    9,
    11,
    7,
    13,
    12,
    11,
    13,
    6,
    7,
    14,
    9,
    13,
    15,
    14,
    8,
    13,
    6,
    5,
    12,
    7,
    5,
    11,
    12,
    14,
    15,
    14,
    15,
    9,
    8,
    9,
    14,
    5,
    6,
    8,
    6,
    5,
    12,
    9,
    15,
    5,
    11,
    6,
    8,
    13,
    12,
    5,
    12,
    13,
    14,
    11,
    8,
    5,
    6
  ], te = [
    8,
    9,
    9,
    11,
    13,
    15,
    15,
    5,
    7,
    7,
    8,
    11,
    14,
    14,
    12,
    6,
    9,
    13,
    15,
    7,
    12,
    8,
    9,
    11,
    7,
    7,
    12,
    7,
    6,
    15,
    13,
    11,
    9,
    7,
    15,
    11,
    8,
    6,
    6,
    14,
    12,
    13,
    5,
    14,
    13,
    13,
    7,
    5,
    15,
    5,
    8,
    11,
    14,
    14,
    6,
    14,
    6,
    9,
    12,
    9,
    12,
    5,
    15,
    8,
    8,
    5,
    12,
    9,
    12,
    5,
    14,
    6,
    8,
    13,
    6,
    5,
    15,
    13,
    11,
    11
  ], re = [0, 1518500249, 1859775393, 2400959708, 2840853838], ie = [1352829926, 1548603684, 1836072691, 2053994217, 0];
  function se() {
    T.call(this, 64), this._a = 1732584193, this._b = 4023233417, this._c = 2562383102, this._d = 271733878, this._e = 3285377520;
  }
  e(se, T), se.prototype._update = function() {
    for (var ve = $, Te = 0; Te < 16; ++Te) ve[Te] = this._block.readInt32LE(Te * 4);
    for (var we = this._a | 0, Ee = this._b | 0, Me = this._c | 0, Ie = this._d | 0, ke = this._e | 0, _e = this._a | 0, De = this._b | 0, Fe = this._c | 0, Ae = this._d | 0, ne = this._e | 0, oe = 0; oe < 80; oe += 1) {
      var ce, le;
      oe < 16 ? (ce = ue(we, Ee, Me, Ie, ke, ve[V[oe]], re[0], ee[oe]), le = xe(_e, De, Fe, Ae, ne, ve[J[oe]], ie[0], te[oe])) : oe < 32 ? (ce = fe(we, Ee, Me, Ie, ke, ve[V[oe]], re[1], ee[oe]), le = me(_e, De, Fe, Ae, ne, ve[J[oe]], ie[1], te[oe])) : oe < 48 ? (ce = he(we, Ee, Me, Ie, ke, ve[V[oe]], re[2], ee[oe]), le = he(_e, De, Fe, Ae, ne, ve[J[oe]], ie[2], te[oe])) : oe < 64 ? (ce = me(we, Ee, Me, Ie, ke, ve[V[oe]], re[3], ee[oe]), le = fe(_e, De, Fe, Ae, ne, ve[J[oe]], ie[3], te[oe])) : (ce = xe(we, Ee, Me, Ie, ke, ve[V[oe]], re[4], ee[oe]), le = ue(_e, De, Fe, Ae, ne, ve[J[oe]], ie[4], te[oe])), we = ke, ke = Ie, Ie = de(Me, 10), Me = Ee, Ee = ce, _e = ne, ne = Ae, Ae = de(Fe, 10), Fe = De, De = le;
    }
    var pe = this._b + Me + Ae | 0;
    this._b = this._c + Ie + ne | 0, this._c = this._d + ke + _e | 0, this._d = this._e + we + De | 0, this._e = this._a + Ee + Fe | 0, this._a = pe;
  }, se.prototype._digest = function() {
    this._block[this._blockOffset++] = 128, this._blockOffset > 56 && (this._block.fill(0, this._blockOffset, 64), this._update(), this._blockOffset = 0), this._block.fill(0, this._blockOffset, 56), this._block.writeUInt32LE(this._length[0], 56), this._block.writeUInt32LE(this._length[1], 60), this._update();
    var ve = C.alloc ? C.alloc(20) : new C(20);
    return ve.writeInt32LE(this._a, 0), ve.writeInt32LE(this._b, 4), ve.writeInt32LE(this._c, 8), ve.writeInt32LE(this._d, 12), ve.writeInt32LE(this._e, 16), ve;
  };
  function de(ve, Te) {
    return ve << Te | ve >>> 32 - Te;
  }
  function ue(ve, Te, we, Ee, Me, Ie, ke, _e) {
    return de(ve + (Te ^ we ^ Ee) + Ie + ke | 0, _e) + Me | 0;
  }
  function fe(ve, Te, we, Ee, Me, Ie, ke, _e) {
    return de(ve + (Te & we | ~Te & Ee) + Ie + ke | 0, _e) + Me | 0;
  }
  function he(ve, Te, we, Ee, Me, Ie, ke, _e) {
    return de(ve + ((Te | ~we) ^ Ee) + Ie + ke | 0, _e) + Me | 0;
  }
  function me(ve, Te, we, Ee, Me, Ie, ke, _e) {
    return de(ve + (Te & Ee | we & ~Ee) + Ie + ke | 0, _e) + Me | 0;
  }
  function xe(ve, Te, we, Ee, Me, Ie, ke, _e) {
    return de(ve + (Te ^ (we | ~Ee)) + Ie + ke | 0, _e) + Me | 0;
  }
  return ripemd160 = se, ripemd160;
}
var sha_js = { exports: {} }, hash$4, hasRequiredHash$1;
function requireHash$1() {
  if (hasRequiredHash$1) return hash$4;
  hasRequiredHash$1 = 1;
  var C = safeBufferExports.Buffer;
  function e(T, $) {
    this._block = C.alloc(T), this._finalSize = $, this._blockSize = T, this._len = 0;
  }
  return e.prototype.update = function(T, $) {
    typeof T == "string" && ($ = $ || "utf8", T = C.from(T, $));
    for (var V = this._block, J = this._blockSize, ee = T.length, te = this._len, re = 0; re < ee; ) {
      for (var ie = te % J, se = Math.min(ee - re, J - ie), de = 0; de < se; de++)
        V[ie + de] = T[re + de];
      te += se, re += se, te % J === 0 && this._update(V);
    }
    return this._len += ee, this;
  }, e.prototype.digest = function(T) {
    var $ = this._len % this._blockSize;
    this._block[$] = 128, this._block.fill(0, $ + 1), $ >= this._finalSize && (this._update(this._block), this._block.fill(0));
    var V = this._len * 8;
    if (V <= 4294967295)
      this._block.writeUInt32BE(V, this._blockSize - 4);
    else {
      var J = (V & 4294967295) >>> 0, ee = (V - J) / 4294967296;
      this._block.writeUInt32BE(ee, this._blockSize - 8), this._block.writeUInt32BE(J, this._blockSize - 4);
    }
    this._update(this._block);
    var te = this._hash();
    return T ? te.toString(T) : te;
  }, e.prototype._update = function() {
    throw new Error("_update must be implemented by subclass");
  }, hash$4 = e, hash$4;
}
var sha$1, hasRequiredSha$1;
function requireSha$1() {
  if (hasRequiredSha$1) return sha$1;
  hasRequiredSha$1 = 1;
  var C = requireInherits_browser(), e = requireHash$1(), T = safeBufferExports.Buffer, $ = [
    1518500249,
    1859775393,
    -1894007588,
    -899497514
  ], V = new Array(80);
  function J() {
    this.init(), this._w = V, e.call(this, 64, 56);
  }
  C(J, e), J.prototype.init = function() {
    return this._a = 1732584193, this._b = 4023233417, this._c = 2562383102, this._d = 271733878, this._e = 3285377520, this;
  };
  function ee(ie) {
    return ie << 5 | ie >>> 27;
  }
  function te(ie) {
    return ie << 30 | ie >>> 2;
  }
  function re(ie, se, de, ue) {
    return ie === 0 ? se & de | ~se & ue : ie === 2 ? se & de | se & ue | de & ue : se ^ de ^ ue;
  }
  return J.prototype._update = function(ie) {
    for (var se = this._w, de = this._a | 0, ue = this._b | 0, fe = this._c | 0, he = this._d | 0, me = this._e | 0, xe = 0; xe < 16; ++xe) se[xe] = ie.readInt32BE(xe * 4);
    for (; xe < 80; ++xe) se[xe] = se[xe - 3] ^ se[xe - 8] ^ se[xe - 14] ^ se[xe - 16];
    for (var ve = 0; ve < 80; ++ve) {
      var Te = ~~(ve / 20), we = ee(de) + re(Te, ue, fe, he) + me + se[ve] + $[Te] | 0;
      me = he, he = fe, fe = te(ue), ue = de, de = we;
    }
    this._a = de + this._a | 0, this._b = ue + this._b | 0, this._c = fe + this._c | 0, this._d = he + this._d | 0, this._e = me + this._e | 0;
  }, J.prototype._hash = function() {
    var ie = T.allocUnsafe(20);
    return ie.writeInt32BE(this._a | 0, 0), ie.writeInt32BE(this._b | 0, 4), ie.writeInt32BE(this._c | 0, 8), ie.writeInt32BE(this._d | 0, 12), ie.writeInt32BE(this._e | 0, 16), ie;
  }, sha$1 = J, sha$1;
}
var sha1$1, hasRequiredSha1;
function requireSha1() {
  if (hasRequiredSha1) return sha1$1;
  hasRequiredSha1 = 1;
  var C = requireInherits_browser(), e = requireHash$1(), T = safeBufferExports.Buffer, $ = [
    1518500249,
    1859775393,
    -1894007588,
    -899497514
  ], V = new Array(80);
  function J() {
    this.init(), this._w = V, e.call(this, 64, 56);
  }
  C(J, e), J.prototype.init = function() {
    return this._a = 1732584193, this._b = 4023233417, this._c = 2562383102, this._d = 271733878, this._e = 3285377520, this;
  };
  function ee(se) {
    return se << 1 | se >>> 31;
  }
  function te(se) {
    return se << 5 | se >>> 27;
  }
  function re(se) {
    return se << 30 | se >>> 2;
  }
  function ie(se, de, ue, fe) {
    return se === 0 ? de & ue | ~de & fe : se === 2 ? de & ue | de & fe | ue & fe : de ^ ue ^ fe;
  }
  return J.prototype._update = function(se) {
    for (var de = this._w, ue = this._a | 0, fe = this._b | 0, he = this._c | 0, me = this._d | 0, xe = this._e | 0, ve = 0; ve < 16; ++ve) de[ve] = se.readInt32BE(ve * 4);
    for (; ve < 80; ++ve) de[ve] = ee(de[ve - 3] ^ de[ve - 8] ^ de[ve - 14] ^ de[ve - 16]);
    for (var Te = 0; Te < 80; ++Te) {
      var we = ~~(Te / 20), Ee = te(ue) + ie(we, fe, he, me) + xe + de[Te] + $[we] | 0;
      xe = me, me = he, he = re(fe), fe = ue, ue = Ee;
    }
    this._a = ue + this._a | 0, this._b = fe + this._b | 0, this._c = he + this._c | 0, this._d = me + this._d | 0, this._e = xe + this._e | 0;
  }, J.prototype._hash = function() {
    var se = T.allocUnsafe(20);
    return se.writeInt32BE(this._a | 0, 0), se.writeInt32BE(this._b | 0, 4), se.writeInt32BE(this._c | 0, 8), se.writeInt32BE(this._d | 0, 12), se.writeInt32BE(this._e | 0, 16), se;
  }, sha1$1 = J, sha1$1;
}
var sha256$3, hasRequiredSha256;
function requireSha256() {
  if (hasRequiredSha256) return sha256$3;
  hasRequiredSha256 = 1;
  var C = requireInherits_browser(), e = requireHash$1(), T = safeBufferExports.Buffer, $ = [
    1116352408,
    1899447441,
    3049323471,
    3921009573,
    961987163,
    1508970993,
    2453635748,
    2870763221,
    3624381080,
    310598401,
    607225278,
    1426881987,
    1925078388,
    2162078206,
    2614888103,
    3248222580,
    3835390401,
    4022224774,
    264347078,
    604807628,
    770255983,
    1249150122,
    1555081692,
    1996064986,
    2554220882,
    2821834349,
    2952996808,
    3210313671,
    3336571891,
    3584528711,
    113926993,
    338241895,
    666307205,
    773529912,
    1294757372,
    1396182291,
    1695183700,
    1986661051,
    2177026350,
    2456956037,
    2730485921,
    2820302411,
    3259730800,
    3345764771,
    3516065817,
    3600352804,
    4094571909,
    275423344,
    430227734,
    506948616,
    659060556,
    883997877,
    958139571,
    1322822218,
    1537002063,
    1747873779,
    1955562222,
    2024104815,
    2227730452,
    2361852424,
    2428436474,
    2756734187,
    3204031479,
    3329325298
  ], V = new Array(64);
  function J() {
    this.init(), this._w = V, e.call(this, 64, 56);
  }
  C(J, e), J.prototype.init = function() {
    return this._a = 1779033703, this._b = 3144134277, this._c = 1013904242, this._d = 2773480762, this._e = 1359893119, this._f = 2600822924, this._g = 528734635, this._h = 1541459225, this;
  };
  function ee(ue, fe, he) {
    return he ^ ue & (fe ^ he);
  }
  function te(ue, fe, he) {
    return ue & fe | he & (ue | fe);
  }
  function re(ue) {
    return (ue >>> 2 | ue << 30) ^ (ue >>> 13 | ue << 19) ^ (ue >>> 22 | ue << 10);
  }
  function ie(ue) {
    return (ue >>> 6 | ue << 26) ^ (ue >>> 11 | ue << 21) ^ (ue >>> 25 | ue << 7);
  }
  function se(ue) {
    return (ue >>> 7 | ue << 25) ^ (ue >>> 18 | ue << 14) ^ ue >>> 3;
  }
  function de(ue) {
    return (ue >>> 17 | ue << 15) ^ (ue >>> 19 | ue << 13) ^ ue >>> 10;
  }
  return J.prototype._update = function(ue) {
    for (var fe = this._w, he = this._a | 0, me = this._b | 0, xe = this._c | 0, ve = this._d | 0, Te = this._e | 0, we = this._f | 0, Ee = this._g | 0, Me = this._h | 0, Ie = 0; Ie < 16; ++Ie) fe[Ie] = ue.readInt32BE(Ie * 4);
    for (; Ie < 64; ++Ie) fe[Ie] = de(fe[Ie - 2]) + fe[Ie - 7] + se(fe[Ie - 15]) + fe[Ie - 16] | 0;
    for (var ke = 0; ke < 64; ++ke) {
      var _e = Me + ie(Te) + ee(Te, we, Ee) + $[ke] + fe[ke] | 0, De = re(he) + te(he, me, xe) | 0;
      Me = Ee, Ee = we, we = Te, Te = ve + _e | 0, ve = xe, xe = me, me = he, he = _e + De | 0;
    }
    this._a = he + this._a | 0, this._b = me + this._b | 0, this._c = xe + this._c | 0, this._d = ve + this._d | 0, this._e = Te + this._e | 0, this._f = we + this._f | 0, this._g = Ee + this._g | 0, this._h = Me + this._h | 0;
  }, J.prototype._hash = function() {
    var ue = T.allocUnsafe(32);
    return ue.writeInt32BE(this._a, 0), ue.writeInt32BE(this._b, 4), ue.writeInt32BE(this._c, 8), ue.writeInt32BE(this._d, 12), ue.writeInt32BE(this._e, 16), ue.writeInt32BE(this._f, 20), ue.writeInt32BE(this._g, 24), ue.writeInt32BE(this._h, 28), ue;
  }, sha256$3 = J, sha256$3;
}
var sha224$1, hasRequiredSha224;
function requireSha224() {
  if (hasRequiredSha224) return sha224$1;
  hasRequiredSha224 = 1;
  var C = requireInherits_browser(), e = requireSha256(), T = requireHash$1(), $ = safeBufferExports.Buffer, V = new Array(64);
  function J() {
    this.init(), this._w = V, T.call(this, 64, 56);
  }
  return C(J, e), J.prototype.init = function() {
    return this._a = 3238371032, this._b = 914150663, this._c = 812702999, this._d = 4144912697, this._e = 4290775857, this._f = 1750603025, this._g = 1694076839, this._h = 3204075428, this;
  }, J.prototype._hash = function() {
    var ee = $.allocUnsafe(28);
    return ee.writeInt32BE(this._a, 0), ee.writeInt32BE(this._b, 4), ee.writeInt32BE(this._c, 8), ee.writeInt32BE(this._d, 12), ee.writeInt32BE(this._e, 16), ee.writeInt32BE(this._f, 20), ee.writeInt32BE(this._g, 24), ee;
  }, sha224$1 = J, sha224$1;
}
var sha512$3, hasRequiredSha512;
function requireSha512() {
  if (hasRequiredSha512) return sha512$3;
  hasRequiredSha512 = 1;
  var C = requireInherits_browser(), e = requireHash$1(), T = safeBufferExports.Buffer, $ = [
    1116352408,
    3609767458,
    1899447441,
    602891725,
    3049323471,
    3964484399,
    3921009573,
    2173295548,
    961987163,
    4081628472,
    1508970993,
    3053834265,
    2453635748,
    2937671579,
    2870763221,
    3664609560,
    3624381080,
    2734883394,
    310598401,
    1164996542,
    607225278,
    1323610764,
    1426881987,
    3590304994,
    1925078388,
    4068182383,
    2162078206,
    991336113,
    2614888103,
    633803317,
    3248222580,
    3479774868,
    3835390401,
    2666613458,
    4022224774,
    944711139,
    264347078,
    2341262773,
    604807628,
    2007800933,
    770255983,
    1495990901,
    1249150122,
    1856431235,
    1555081692,
    3175218132,
    1996064986,
    2198950837,
    2554220882,
    3999719339,
    2821834349,
    766784016,
    2952996808,
    2566594879,
    3210313671,
    3203337956,
    3336571891,
    1034457026,
    3584528711,
    2466948901,
    113926993,
    3758326383,
    338241895,
    168717936,
    666307205,
    1188179964,
    773529912,
    1546045734,
    1294757372,
    1522805485,
    1396182291,
    2643833823,
    1695183700,
    2343527390,
    1986661051,
    1014477480,
    2177026350,
    1206759142,
    2456956037,
    344077627,
    2730485921,
    1290863460,
    2820302411,
    3158454273,
    3259730800,
    3505952657,
    3345764771,
    106217008,
    3516065817,
    3606008344,
    3600352804,
    1432725776,
    4094571909,
    1467031594,
    275423344,
    851169720,
    430227734,
    3100823752,
    506948616,
    1363258195,
    659060556,
    3750685593,
    883997877,
    3785050280,
    958139571,
    3318307427,
    1322822218,
    3812723403,
    1537002063,
    2003034995,
    1747873779,
    3602036899,
    1955562222,
    1575990012,
    2024104815,
    1125592928,
    2227730452,
    2716904306,
    2361852424,
    442776044,
    2428436474,
    593698344,
    2756734187,
    3733110249,
    3204031479,
    2999351573,
    3329325298,
    3815920427,
    3391569614,
    3928383900,
    3515267271,
    566280711,
    3940187606,
    3454069534,
    4118630271,
    4000239992,
    116418474,
    1914138554,
    174292421,
    2731055270,
    289380356,
    3203993006,
    460393269,
    320620315,
    685471733,
    587496836,
    852142971,
    1086792851,
    1017036298,
    365543100,
    1126000580,
    2618297676,
    1288033470,
    3409855158,
    1501505948,
    4234509866,
    1607167915,
    987167468,
    1816402316,
    1246189591
  ], V = new Array(160);
  function J() {
    this.init(), this._w = V, e.call(this, 128, 112);
  }
  C(J, e), J.prototype.init = function() {
    return this._ah = 1779033703, this._bh = 3144134277, this._ch = 1013904242, this._dh = 2773480762, this._eh = 1359893119, this._fh = 2600822924, this._gh = 528734635, this._hh = 1541459225, this._al = 4089235720, this._bl = 2227873595, this._cl = 4271175723, this._dl = 1595750129, this._el = 2917565137, this._fl = 725511199, this._gl = 4215389547, this._hl = 327033209, this;
  };
  function ee(me, xe, ve) {
    return ve ^ me & (xe ^ ve);
  }
  function te(me, xe, ve) {
    return me & xe | ve & (me | xe);
  }
  function re(me, xe) {
    return (me >>> 28 | xe << 4) ^ (xe >>> 2 | me << 30) ^ (xe >>> 7 | me << 25);
  }
  function ie(me, xe) {
    return (me >>> 14 | xe << 18) ^ (me >>> 18 | xe << 14) ^ (xe >>> 9 | me << 23);
  }
  function se(me, xe) {
    return (me >>> 1 | xe << 31) ^ (me >>> 8 | xe << 24) ^ me >>> 7;
  }
  function de(me, xe) {
    return (me >>> 1 | xe << 31) ^ (me >>> 8 | xe << 24) ^ (me >>> 7 | xe << 25);
  }
  function ue(me, xe) {
    return (me >>> 19 | xe << 13) ^ (xe >>> 29 | me << 3) ^ me >>> 6;
  }
  function fe(me, xe) {
    return (me >>> 19 | xe << 13) ^ (xe >>> 29 | me << 3) ^ (me >>> 6 | xe << 26);
  }
  function he(me, xe) {
    return me >>> 0 < xe >>> 0 ? 1 : 0;
  }
  return J.prototype._update = function(me) {
    for (var xe = this._w, ve = this._ah | 0, Te = this._bh | 0, we = this._ch | 0, Ee = this._dh | 0, Me = this._eh | 0, Ie = this._fh | 0, ke = this._gh | 0, _e = this._hh | 0, De = this._al | 0, Fe = this._bl | 0, Ae = this._cl | 0, ne = this._dl | 0, oe = this._el | 0, ce = this._fl | 0, le = this._gl | 0, pe = this._hl | 0, ye = 0; ye < 32; ye += 2)
      xe[ye] = me.readInt32BE(ye * 4), xe[ye + 1] = me.readInt32BE(ye * 4 + 4);
    for (; ye < 160; ye += 2) {
      var Ce = xe[ye - 30], be = xe[ye - 15 * 2 + 1], ae = se(Ce, be), ge = de(be, Ce);
      Ce = xe[ye - 2 * 2], be = xe[ye - 2 * 2 + 1];
      var Se = ue(Ce, be), Le = fe(be, Ce), ze = xe[ye - 7 * 2], Re = xe[ye - 7 * 2 + 1], We = xe[ye - 16 * 2], Be = xe[ye - 16 * 2 + 1], Ue = ge + Re | 0, Ge = ae + ze + he(Ue, ge) | 0;
      Ue = Ue + Le | 0, Ge = Ge + Se + he(Ue, Le) | 0, Ue = Ue + Be | 0, Ge = Ge + We + he(Ue, Be) | 0, xe[ye] = Ge, xe[ye + 1] = Ue;
    }
    for (var je = 0; je < 160; je += 2) {
      Ge = xe[je], Ue = xe[je + 1];
      var Oe = te(ve, Te, we), Ne = te(De, Fe, Ae), Ye = re(ve, De), Je = re(De, ve), Xe = ie(Me, oe), st = ie(oe, Me), ct = $[je], it = $[je + 1], ot = ee(Me, Ie, ke), yt = ee(oe, ce, le), dt = pe + st | 0, mt = _e + Xe + he(dt, pe) | 0;
      dt = dt + yt | 0, mt = mt + ot + he(dt, yt) | 0, dt = dt + it | 0, mt = mt + ct + he(dt, it) | 0, dt = dt + Ue | 0, mt = mt + Ge + he(dt, Ue) | 0;
      var It = Je + Ne | 0, xt = Ye + Oe + he(It, Je) | 0;
      _e = ke, pe = le, ke = Ie, le = ce, Ie = Me, ce = oe, oe = ne + dt | 0, Me = Ee + mt + he(oe, ne) | 0, Ee = we, ne = Ae, we = Te, Ae = Fe, Te = ve, Fe = De, De = dt + It | 0, ve = mt + xt + he(De, dt) | 0;
    }
    this._al = this._al + De | 0, this._bl = this._bl + Fe | 0, this._cl = this._cl + Ae | 0, this._dl = this._dl + ne | 0, this._el = this._el + oe | 0, this._fl = this._fl + ce | 0, this._gl = this._gl + le | 0, this._hl = this._hl + pe | 0, this._ah = this._ah + ve + he(this._al, De) | 0, this._bh = this._bh + Te + he(this._bl, Fe) | 0, this._ch = this._ch + we + he(this._cl, Ae) | 0, this._dh = this._dh + Ee + he(this._dl, ne) | 0, this._eh = this._eh + Me + he(this._el, oe) | 0, this._fh = this._fh + Ie + he(this._fl, ce) | 0, this._gh = this._gh + ke + he(this._gl, le) | 0, this._hh = this._hh + _e + he(this._hl, pe) | 0;
  }, J.prototype._hash = function() {
    var me = T.allocUnsafe(64);
    function xe(ve, Te, we) {
      me.writeInt32BE(ve, we), me.writeInt32BE(Te, we + 4);
    }
    return xe(this._ah, this._al, 0), xe(this._bh, this._bl, 8), xe(this._ch, this._cl, 16), xe(this._dh, this._dl, 24), xe(this._eh, this._el, 32), xe(this._fh, this._fl, 40), xe(this._gh, this._gl, 48), xe(this._hh, this._hl, 56), me;
  }, sha512$3 = J, sha512$3;
}
var sha384$1, hasRequiredSha384;
function requireSha384() {
  if (hasRequiredSha384) return sha384$1;
  hasRequiredSha384 = 1;
  var C = requireInherits_browser(), e = requireSha512(), T = requireHash$1(), $ = safeBufferExports.Buffer, V = new Array(160);
  function J() {
    this.init(), this._w = V, T.call(this, 128, 112);
  }
  return C(J, e), J.prototype.init = function() {
    return this._ah = 3418070365, this._bh = 1654270250, this._ch = 2438529370, this._dh = 355462360, this._eh = 1731405415, this._fh = 2394180231, this._gh = 3675008525, this._hh = 1203062813, this._al = 3238371032, this._bl = 914150663, this._cl = 812702999, this._dl = 4144912697, this._el = 4290775857, this._fl = 1750603025, this._gl = 1694076839, this._hl = 3204075428, this;
  }, J.prototype._hash = function() {
    var ee = $.allocUnsafe(48);
    function te(re, ie, se) {
      ee.writeInt32BE(re, se), ee.writeInt32BE(ie, se + 4);
    }
    return te(this._ah, this._al, 0), te(this._bh, this._bl, 8), te(this._ch, this._cl, 16), te(this._dh, this._dl, 24), te(this._eh, this._el, 32), te(this._fh, this._fl, 40), ee;
  }, sha384$1 = J, sha384$1;
}
var hasRequiredSha_js;
function requireSha_js() {
  if (hasRequiredSha_js) return sha_js.exports;
  hasRequiredSha_js = 1;
  var C = sha_js.exports = function(T) {
    T = T.toLowerCase();
    var $ = C[T];
    if (!$) throw new Error(T + " is not supported (we accept pull requests)");
    return new $();
  };
  return C.sha = requireSha$1(), C.sha1 = requireSha1(), C.sha224 = requireSha224(), C.sha256 = requireSha256(), C.sha384 = requireSha384(), C.sha512 = requireSha512(), sha_js.exports;
}
var cipherBase, hasRequiredCipherBase;
function requireCipherBase() {
  if (hasRequiredCipherBase) return cipherBase;
  hasRequiredCipherBase = 1;
  var C = safeBufferExports.Buffer, e = requireStreamBrowserify().Transform, T = requireString_decoder$1().StringDecoder, $ = requireInherits_browser();
  function V(re) {
    e.call(this), this.hashMode = typeof re == "string", this.hashMode ? this[re] = this._finalOrDigest : this.final = this._finalOrDigest, this._final && (this.__final = this._final, this._final = null), this._decoder = null, this._encoding = null;
  }
  $(V, e);
  var J = typeof Uint8Array < "u", ee = typeof ArrayBuffer < "u" && typeof Uint8Array < "u" && ArrayBuffer.isView && (C.prototype instanceof Uint8Array || C.TYPED_ARRAY_SUPPORT);
  function te(re, ie) {
    if (re instanceof C)
      return re;
    if (typeof re == "string")
      return C.from(re, ie);
    if (ee && ArrayBuffer.isView(re)) {
      if (re.byteLength === 0)
        return C.alloc(0);
      var se = C.from(re.buffer, re.byteOffset, re.byteLength);
      if (se.byteLength === re.byteLength)
        return se;
    }
    if (J && re instanceof Uint8Array || C.isBuffer(re) && re.constructor && typeof re.constructor.isBuffer == "function" && re.constructor.isBuffer(re))
      return C.from(re);
    throw new TypeError('The "data" argument must be of type string or an instance of Buffer, TypedArray, or DataView.');
  }
  return V.prototype.update = function(re, ie, se) {
    var de = te(re, ie), ue = this._update(de);
    return this.hashMode ? this : (se && (ue = this._toString(ue, se)), ue);
  }, V.prototype.setAutoPadding = function() {
  }, V.prototype.getAuthTag = function() {
    throw new Error("trying to get auth tag in unsupported state");
  }, V.prototype.setAuthTag = function() {
    throw new Error("trying to set auth tag in unsupported state");
  }, V.prototype.setAAD = function() {
    throw new Error("trying to set aad in unsupported state");
  }, V.prototype._transform = function(re, ie, se) {
    var de;
    try {
      this.hashMode ? this._update(re) : this.push(this._update(re));
    } catch (ue) {
      de = ue;
    } finally {
      se(de);
    }
  }, V.prototype._flush = function(re) {
    var ie;
    try {
      this.push(this.__final());
    } catch (se) {
      ie = se;
    }
    re(ie);
  }, V.prototype._finalOrDigest = function(re) {
    var ie = this.__final() || C.alloc(0);
    return re && (ie = this._toString(ie, re, !0)), ie;
  }, V.prototype._toString = function(re, ie, se) {
    if (this._decoder || (this._decoder = new T(ie), this._encoding = ie), this._encoding !== ie)
      throw new Error("can’t switch encodings");
    var de = this._decoder.write(re);
    return se && (de += this._decoder.end()), de;
  }, cipherBase = V, cipherBase;
}
var browser$b, hasRequiredBrowser$9;
function requireBrowser$9() {
  if (hasRequiredBrowser$9) return browser$b;
  hasRequiredBrowser$9 = 1;
  var C = requireInherits_browser(), e = requireMd5_js(), T = requireRipemd160(), $ = requireSha_js(), V = requireCipherBase();
  function J(ee) {
    V.call(this, "digest"), this._hash = ee;
  }
  return C(J, V), J.prototype._update = function(ee) {
    this._hash.update(ee);
  }, J.prototype._final = function() {
    return this._hash.digest();
  }, browser$b = function(te) {
    return te = te.toLowerCase(), te === "md5" ? new e() : te === "rmd160" || te === "ripemd160" ? new T() : new J($(te));
  }, browser$b;
}
var legacy, hasRequiredLegacy;
function requireLegacy() {
  if (hasRequiredLegacy) return legacy;
  hasRequiredLegacy = 1;
  var C = requireInherits_browser(), e = safeBufferExports.Buffer, T = requireCipherBase(), $ = e.alloc(128), V = 64;
  function J(ee, te) {
    T.call(this, "digest"), typeof te == "string" && (te = e.from(te)), this._alg = ee, this._key = te, te.length > V ? te = ee(te) : te.length < V && (te = e.concat([te, $], V));
    for (var re = this._ipad = e.allocUnsafe(V), ie = this._opad = e.allocUnsafe(V), se = 0; se < V; se++)
      re[se] = te[se] ^ 54, ie[se] = te[se] ^ 92;
    this._hash = [re];
  }
  return C(J, T), J.prototype._update = function(ee) {
    this._hash.push(ee);
  }, J.prototype._final = function() {
    var ee = this._alg(e.concat(this._hash));
    return this._alg(e.concat([this._opad, ee]));
  }, legacy = J, legacy;
}
var md5$1, hasRequiredMd5;
function requireMd5() {
  if (hasRequiredMd5) return md5$1;
  hasRequiredMd5 = 1;
  var C = requireMd5_js();
  return md5$1 = function(e) {
    return new C().update(e).digest();
  }, md5$1;
}
var browser$a, hasRequiredBrowser$8;
function requireBrowser$8() {
  if (hasRequiredBrowser$8) return browser$a;
  hasRequiredBrowser$8 = 1;
  var C = requireInherits_browser(), e = requireLegacy(), T = requireCipherBase(), $ = safeBufferExports.Buffer, V = requireMd5(), J = requireRipemd160(), ee = requireSha_js(), te = $.alloc(128);
  function re(ie, se) {
    T.call(this, "digest"), typeof se == "string" && (se = $.from(se));
    var de = ie === "sha512" || ie === "sha384" ? 128 : 64;
    if (this._alg = ie, this._key = se, se.length > de) {
      var ue = ie === "rmd160" ? new J() : ee(ie);
      se = ue.update(se).digest();
    } else se.length < de && (se = $.concat([se, te], de));
    for (var fe = this._ipad = $.allocUnsafe(de), he = this._opad = $.allocUnsafe(de), me = 0; me < de; me++)
      fe[me] = se[me] ^ 54, he[me] = se[me] ^ 92;
    this._hash = ie === "rmd160" ? new J() : ee(ie), this._hash.update(fe);
  }
  return C(re, T), re.prototype._update = function(ie) {
    this._hash.update(ie);
  }, re.prototype._final = function() {
    var ie = this._hash.digest(), se = this._alg === "rmd160" ? new J() : ee(this._alg);
    return se.update(this._opad).update(ie).digest();
  }, browser$a = function(se, de) {
    return se = se.toLowerCase(), se === "rmd160" || se === "ripemd160" ? new re("rmd160", de) : se === "md5" ? new e(V, de) : new re(se, de);
  }, browser$a;
}
const sha224WithRSAEncryption = {
  sign: "rsa",
  hash: "sha224",
  id: "302d300d06096086480165030402040500041c"
}, sha256WithRSAEncryption = {
  sign: "rsa",
  hash: "sha256",
  id: "3031300d060960864801650304020105000420"
}, sha384WithRSAEncryption = {
  sign: "rsa",
  hash: "sha384",
  id: "3041300d060960864801650304020205000430"
}, sha512WithRSAEncryption = {
  sign: "rsa",
  hash: "sha512",
  id: "3051300d060960864801650304020305000440"
}, sha256$2 = {
  sign: "ecdsa",
  hash: "sha256",
  id: ""
}, sha224 = {
  sign: "ecdsa",
  hash: "sha224",
  id: ""
}, sha384 = {
  sign: "ecdsa",
  hash: "sha384",
  id: ""
}, sha512$2 = {
  sign: "ecdsa",
  hash: "sha512",
  id: ""
}, DSA = {
  sign: "dsa",
  hash: "sha1",
  id: ""
}, ripemd160WithRSA = {
  sign: "rsa",
  hash: "rmd160",
  id: "3021300906052b2403020105000414"
}, md5WithRSAEncryption = {
  sign: "rsa",
  hash: "md5",
  id: "3020300c06082a864886f70d020505000410"
}, require$$6 = {
  sha224WithRSAEncryption,
  "RSA-SHA224": {
    sign: "ecdsa/rsa",
    hash: "sha224",
    id: "302d300d06096086480165030402040500041c"
  },
  sha256WithRSAEncryption,
  "RSA-SHA256": {
    sign: "ecdsa/rsa",
    hash: "sha256",
    id: "3031300d060960864801650304020105000420"
  },
  sha384WithRSAEncryption,
  "RSA-SHA384": {
    sign: "ecdsa/rsa",
    hash: "sha384",
    id: "3041300d060960864801650304020205000430"
  },
  sha512WithRSAEncryption,
  "RSA-SHA512": {
    sign: "ecdsa/rsa",
    hash: "sha512",
    id: "3051300d060960864801650304020305000440"
  },
  "RSA-SHA1": {
    sign: "rsa",
    hash: "sha1",
    id: "3021300906052b0e03021a05000414"
  },
  "ecdsa-with-SHA1": {
    sign: "ecdsa",
    hash: "sha1",
    id: ""
  },
  sha256: sha256$2,
  sha224,
  sha384,
  sha512: sha512$2,
  "DSA-SHA": {
    sign: "dsa",
    hash: "sha1",
    id: ""
  },
  "DSA-SHA1": {
    sign: "dsa",
    hash: "sha1",
    id: ""
  },
  DSA,
  "DSA-WITH-SHA224": {
    sign: "dsa",
    hash: "sha224",
    id: ""
  },
  "DSA-SHA224": {
    sign: "dsa",
    hash: "sha224",
    id: ""
  },
  "DSA-WITH-SHA256": {
    sign: "dsa",
    hash: "sha256",
    id: ""
  },
  "DSA-SHA256": {
    sign: "dsa",
    hash: "sha256",
    id: ""
  },
  "DSA-WITH-SHA384": {
    sign: "dsa",
    hash: "sha384",
    id: ""
  },
  "DSA-SHA384": {
    sign: "dsa",
    hash: "sha384",
    id: ""
  },
  "DSA-WITH-SHA512": {
    sign: "dsa",
    hash: "sha512",
    id: ""
  },
  "DSA-SHA512": {
    sign: "dsa",
    hash: "sha512",
    id: ""
  },
  "DSA-RIPEMD160": {
    sign: "dsa",
    hash: "rmd160",
    id: ""
  },
  ripemd160WithRSA,
  "RSA-RIPEMD160": {
    sign: "rsa",
    hash: "rmd160",
    id: "3021300906052b2403020105000414"
  },
  md5WithRSAEncryption,
  "RSA-MD5": {
    sign: "rsa",
    hash: "md5",
    id: "3020300c06082a864886f70d020505000410"
  }
};
var algos, hasRequiredAlgos;
function requireAlgos() {
  return hasRequiredAlgos || (hasRequiredAlgos = 1, algos = require$$6), algos;
}
var browser$9 = {}, precondition, hasRequiredPrecondition;
function requirePrecondition() {
  if (hasRequiredPrecondition) return precondition;
  hasRequiredPrecondition = 1;
  var C = Math.pow(2, 30) - 1;
  return precondition = function(e, T) {
    if (typeof e != "number")
      throw new TypeError("Iterations not a number");
    if (e < 0)
      throw new TypeError("Bad iterations");
    if (typeof T != "number")
      throw new TypeError("Key length not a number");
    if (T < 0 || T > C || T !== T)
      throw new TypeError("Bad key length");
  }, precondition;
}
var defaultEncoding_1, hasRequiredDefaultEncoding;
function requireDefaultEncoding() {
  if (hasRequiredDefaultEncoding) return defaultEncoding_1;
  hasRequiredDefaultEncoding = 1;
  var C;
  if (commonjsGlobal$1.process && commonjsGlobal$1.process.browser)
    C = "utf-8";
  else if (commonjsGlobal$1.process && commonjsGlobal$1.process.version) {
    var e = parseInt(dist$2.process.version.split(".")[0].slice(1), 10);
    C = e >= 6 ? "utf-8" : "binary";
  } else
    C = "utf-8";
  return defaultEncoding_1 = C, defaultEncoding_1;
}
var toBuffer$1, hasRequiredToBuffer;
function requireToBuffer() {
  if (hasRequiredToBuffer) return toBuffer$1;
  hasRequiredToBuffer = 1;
  var C = safeBufferExports.Buffer;
  return toBuffer$1 = function(e, T, $) {
    if (C.isBuffer(e))
      return e;
    if (typeof e == "string")
      return C.from(e, T);
    if (ArrayBuffer.isView(e))
      return C.from(e.buffer);
    throw new TypeError($ + " must be a string, a Buffer, a typed array or a DataView");
  }, toBuffer$1;
}
var syncBrowser, hasRequiredSyncBrowser;
function requireSyncBrowser() {
  if (hasRequiredSyncBrowser) return syncBrowser;
  hasRequiredSyncBrowser = 1;
  var C = requireMd5(), e = requireRipemd160(), T = requireSha_js(), $ = safeBufferExports.Buffer, V = requirePrecondition(), J = requireDefaultEncoding(), ee = requireToBuffer(), te = $.alloc(128), re = {
    md5: 16,
    sha1: 20,
    sha224: 28,
    sha256: 32,
    sha384: 48,
    sha512: 64,
    rmd160: 20,
    ripemd160: 20
  };
  function ie(ue, fe, he) {
    var me = se(ue), xe = ue === "sha512" || ue === "sha384" ? 128 : 64;
    fe.length > xe ? fe = me(fe) : fe.length < xe && (fe = $.concat([fe, te], xe));
    for (var ve = $.allocUnsafe(xe + re[ue]), Te = $.allocUnsafe(xe + re[ue]), we = 0; we < xe; we++)
      ve[we] = fe[we] ^ 54, Te[we] = fe[we] ^ 92;
    var Ee = $.allocUnsafe(xe + he + 4);
    ve.copy(Ee, 0, 0, xe), this.ipad1 = Ee, this.ipad2 = ve, this.opad = Te, this.alg = ue, this.blocksize = xe, this.hash = me, this.size = re[ue];
  }
  ie.prototype.run = function(ue, fe) {
    ue.copy(fe, this.blocksize);
    var he = this.hash(fe);
    return he.copy(this.opad, this.blocksize), this.hash(this.opad);
  };
  function se(ue) {
    function fe(me) {
      return T(ue).update(me).digest();
    }
    function he(me) {
      return new e().update(me).digest();
    }
    return ue === "rmd160" || ue === "ripemd160" ? he : ue === "md5" ? C : fe;
  }
  function de(ue, fe, he, me, xe) {
    V(he, me), ue = ee(ue, J, "Password"), fe = ee(fe, J, "Salt"), xe = xe || "sha1";
    var ve = new ie(xe, ue, fe.length), Te = $.allocUnsafe(me), we = $.allocUnsafe(fe.length + 4);
    fe.copy(we, 0, 0, fe.length);
    for (var Ee = 0, Me = re[xe], Ie = Math.ceil(me / Me), ke = 1; ke <= Ie; ke++) {
      we.writeUInt32BE(ke, fe.length);
      for (var _e = ve.run(we, ve.ipad1), De = _e, Fe = 1; Fe < he; Fe++) {
        De = ve.run(De, ve.ipad2);
        for (var Ae = 0; Ae < Me; Ae++) _e[Ae] ^= De[Ae];
      }
      _e.copy(Te, Ee), Ee += Me;
    }
    return Te;
  }
  return syncBrowser = de, syncBrowser;
}
var async, hasRequiredAsync;
function requireAsync() {
  if (hasRequiredAsync) return async;
  hasRequiredAsync = 1;
  var C = safeBufferExports.Buffer, e = requirePrecondition(), T = requireDefaultEncoding(), $ = requireSyncBrowser(), V = requireToBuffer(), J, ee = commonjsGlobal$1.crypto && commonjsGlobal$1.crypto.subtle, te = {
    sha: "SHA-1",
    "sha-1": "SHA-1",
    sha1: "SHA-1",
    sha256: "SHA-256",
    "sha-256": "SHA-256",
    sha384: "SHA-384",
    "sha-384": "SHA-384",
    "sha-512": "SHA-512",
    sha512: "SHA-512"
  }, re = [];
  function ie(he) {
    if (commonjsGlobal$1.process && !commonjsGlobal$1.process.browser || !ee || !ee.importKey || !ee.deriveBits)
      return Promise.resolve(!1);
    if (re[he] !== void 0)
      return re[he];
    J = J || C.alloc(8);
    var me = ue(J, J, 10, 128, he).then(function() {
      return !0;
    }).catch(function() {
      return !1;
    });
    return re[he] = me, me;
  }
  var se;
  function de() {
    return se || (commonjsGlobal$1.process && commonjsGlobal$1.process.nextTick ? se = commonjsGlobal$1.process.nextTick : commonjsGlobal$1.queueMicrotask ? se = commonjsGlobal$1.queueMicrotask : commonjsGlobal$1.setImmediate ? se = commonjsGlobal$1.setImmediate : se = commonjsGlobal$1.setTimeout, se);
  }
  function ue(he, me, xe, ve, Te) {
    return ee.importKey(
      "raw",
      he,
      { name: "PBKDF2" },
      !1,
      ["deriveBits"]
    ).then(function(we) {
      return ee.deriveBits({
        name: "PBKDF2",
        salt: me,
        iterations: xe,
        hash: {
          name: Te
        }
      }, we, ve << 3);
    }).then(function(we) {
      return C.from(we);
    });
  }
  function fe(he, me) {
    he.then(function(xe) {
      de()(function() {
        me(null, xe);
      });
    }, function(xe) {
      de()(function() {
        me(xe);
      });
    });
  }
  return async = function(he, me, xe, ve, Te, we) {
    typeof Te == "function" && (we = Te, Te = void 0), Te = Te || "sha1";
    var Ee = te[Te.toLowerCase()];
    if (!Ee || typeof commonjsGlobal$1.Promise != "function") {
      de()(function() {
        var Me;
        try {
          Me = $(he, me, xe, ve, Te);
        } catch (Ie) {
          return we(Ie);
        }
        we(null, Me);
      });
      return;
    }
    if (e(xe, ve), he = V(he, T, "Password"), me = V(me, T, "Salt"), typeof we != "function") throw new Error("No callback provided to pbkdf2");
    fe(ie(Ee).then(function(Me) {
      return Me ? ue(he, me, xe, ve, Ee) : $(he, me, xe, ve, Te);
    }), we);
  }, async;
}
var hasRequiredBrowser$7;
function requireBrowser$7() {
  return hasRequiredBrowser$7 || (hasRequiredBrowser$7 = 1, browser$9.pbkdf2 = requireAsync(), browser$9.pbkdf2Sync = requireSyncBrowser()), browser$9;
}
var browser$8 = {}, des$1 = {}, utils$5 = {}, hasRequiredUtils$3;
function requireUtils$3() {
  if (hasRequiredUtils$3) return utils$5;
  hasRequiredUtils$3 = 1, utils$5.readUInt32BE = function(V, J) {
    var ee = V[0 + J] << 24 | V[1 + J] << 16 | V[2 + J] << 8 | V[3 + J];
    return ee >>> 0;
  }, utils$5.writeUInt32BE = function(V, J, ee) {
    V[0 + ee] = J >>> 24, V[1 + ee] = J >>> 16 & 255, V[2 + ee] = J >>> 8 & 255, V[3 + ee] = J & 255;
  }, utils$5.ip = function(V, J, ee, te) {
    for (var re = 0, ie = 0, se = 6; se >= 0; se -= 2) {
      for (var de = 0; de <= 24; de += 8)
        re <<= 1, re |= J >>> de + se & 1;
      for (var de = 0; de <= 24; de += 8)
        re <<= 1, re |= V >>> de + se & 1;
    }
    for (var se = 6; se >= 0; se -= 2) {
      for (var de = 1; de <= 25; de += 8)
        ie <<= 1, ie |= J >>> de + se & 1;
      for (var de = 1; de <= 25; de += 8)
        ie <<= 1, ie |= V >>> de + se & 1;
    }
    ee[te + 0] = re >>> 0, ee[te + 1] = ie >>> 0;
  }, utils$5.rip = function(V, J, ee, te) {
    for (var re = 0, ie = 0, se = 0; se < 4; se++)
      for (var de = 24; de >= 0; de -= 8)
        re <<= 1, re |= J >>> de + se & 1, re <<= 1, re |= V >>> de + se & 1;
    for (var se = 4; se < 8; se++)
      for (var de = 24; de >= 0; de -= 8)
        ie <<= 1, ie |= J >>> de + se & 1, ie <<= 1, ie |= V >>> de + se & 1;
    ee[te + 0] = re >>> 0, ee[te + 1] = ie >>> 0;
  }, utils$5.pc1 = function(V, J, ee, te) {
    for (var re = 0, ie = 0, se = 7; se >= 5; se--) {
      for (var de = 0; de <= 24; de += 8)
        re <<= 1, re |= J >> de + se & 1;
      for (var de = 0; de <= 24; de += 8)
        re <<= 1, re |= V >> de + se & 1;
    }
    for (var de = 0; de <= 24; de += 8)
      re <<= 1, re |= J >> de + se & 1;
    for (var se = 1; se <= 3; se++) {
      for (var de = 0; de <= 24; de += 8)
        ie <<= 1, ie |= J >> de + se & 1;
      for (var de = 0; de <= 24; de += 8)
        ie <<= 1, ie |= V >> de + se & 1;
    }
    for (var de = 0; de <= 24; de += 8)
      ie <<= 1, ie |= V >> de + se & 1;
    ee[te + 0] = re >>> 0, ee[te + 1] = ie >>> 0;
  }, utils$5.r28shl = function(V, J) {
    return V << J & 268435455 | V >>> 28 - J;
  };
  var C = [
    // inL => outL
    14,
    11,
    17,
    4,
    27,
    23,
    25,
    0,
    13,
    22,
    7,
    18,
    5,
    9,
    16,
    24,
    2,
    20,
    12,
    21,
    1,
    8,
    15,
    26,
    // inR => outR
    15,
    4,
    25,
    19,
    9,
    1,
    26,
    16,
    5,
    11,
    23,
    8,
    12,
    7,
    17,
    0,
    22,
    3,
    10,
    14,
    6,
    20,
    27,
    24
  ];
  utils$5.pc2 = function(V, J, ee, te) {
    for (var re = 0, ie = 0, se = C.length >>> 1, de = 0; de < se; de++)
      re <<= 1, re |= V >>> C[de] & 1;
    for (var de = se; de < C.length; de++)
      ie <<= 1, ie |= J >>> C[de] & 1;
    ee[te + 0] = re >>> 0, ee[te + 1] = ie >>> 0;
  }, utils$5.expand = function(V, J, ee) {
    var te = 0, re = 0;
    te = (V & 1) << 5 | V >>> 27;
    for (var ie = 23; ie >= 15; ie -= 4)
      te <<= 6, te |= V >>> ie & 63;
    for (var ie = 11; ie >= 3; ie -= 4)
      re |= V >>> ie & 63, re <<= 6;
    re |= (V & 31) << 1 | V >>> 31, J[ee + 0] = te >>> 0, J[ee + 1] = re >>> 0;
  };
  var e = [
    14,
    0,
    4,
    15,
    13,
    7,
    1,
    4,
    2,
    14,
    15,
    2,
    11,
    13,
    8,
    1,
    3,
    10,
    10,
    6,
    6,
    12,
    12,
    11,
    5,
    9,
    9,
    5,
    0,
    3,
    7,
    8,
    4,
    15,
    1,
    12,
    14,
    8,
    8,
    2,
    13,
    4,
    6,
    9,
    2,
    1,
    11,
    7,
    15,
    5,
    12,
    11,
    9,
    3,
    7,
    14,
    3,
    10,
    10,
    0,
    5,
    6,
    0,
    13,
    15,
    3,
    1,
    13,
    8,
    4,
    14,
    7,
    6,
    15,
    11,
    2,
    3,
    8,
    4,
    14,
    9,
    12,
    7,
    0,
    2,
    1,
    13,
    10,
    12,
    6,
    0,
    9,
    5,
    11,
    10,
    5,
    0,
    13,
    14,
    8,
    7,
    10,
    11,
    1,
    10,
    3,
    4,
    15,
    13,
    4,
    1,
    2,
    5,
    11,
    8,
    6,
    12,
    7,
    6,
    12,
    9,
    0,
    3,
    5,
    2,
    14,
    15,
    9,
    10,
    13,
    0,
    7,
    9,
    0,
    14,
    9,
    6,
    3,
    3,
    4,
    15,
    6,
    5,
    10,
    1,
    2,
    13,
    8,
    12,
    5,
    7,
    14,
    11,
    12,
    4,
    11,
    2,
    15,
    8,
    1,
    13,
    1,
    6,
    10,
    4,
    13,
    9,
    0,
    8,
    6,
    15,
    9,
    3,
    8,
    0,
    7,
    11,
    4,
    1,
    15,
    2,
    14,
    12,
    3,
    5,
    11,
    10,
    5,
    14,
    2,
    7,
    12,
    7,
    13,
    13,
    8,
    14,
    11,
    3,
    5,
    0,
    6,
    6,
    15,
    9,
    0,
    10,
    3,
    1,
    4,
    2,
    7,
    8,
    2,
    5,
    12,
    11,
    1,
    12,
    10,
    4,
    14,
    15,
    9,
    10,
    3,
    6,
    15,
    9,
    0,
    0,
    6,
    12,
    10,
    11,
    1,
    7,
    13,
    13,
    8,
    15,
    9,
    1,
    4,
    3,
    5,
    14,
    11,
    5,
    12,
    2,
    7,
    8,
    2,
    4,
    14,
    2,
    14,
    12,
    11,
    4,
    2,
    1,
    12,
    7,
    4,
    10,
    7,
    11,
    13,
    6,
    1,
    8,
    5,
    5,
    0,
    3,
    15,
    15,
    10,
    13,
    3,
    0,
    9,
    14,
    8,
    9,
    6,
    4,
    11,
    2,
    8,
    1,
    12,
    11,
    7,
    10,
    1,
    13,
    14,
    7,
    2,
    8,
    13,
    15,
    6,
    9,
    15,
    12,
    0,
    5,
    9,
    6,
    10,
    3,
    4,
    0,
    5,
    14,
    3,
    12,
    10,
    1,
    15,
    10,
    4,
    15,
    2,
    9,
    7,
    2,
    12,
    6,
    9,
    8,
    5,
    0,
    6,
    13,
    1,
    3,
    13,
    4,
    14,
    14,
    0,
    7,
    11,
    5,
    3,
    11,
    8,
    9,
    4,
    14,
    3,
    15,
    2,
    5,
    12,
    2,
    9,
    8,
    5,
    12,
    15,
    3,
    10,
    7,
    11,
    0,
    14,
    4,
    1,
    10,
    7,
    1,
    6,
    13,
    0,
    11,
    8,
    6,
    13,
    4,
    13,
    11,
    0,
    2,
    11,
    14,
    7,
    15,
    4,
    0,
    9,
    8,
    1,
    13,
    10,
    3,
    14,
    12,
    3,
    9,
    5,
    7,
    12,
    5,
    2,
    10,
    15,
    6,
    8,
    1,
    6,
    1,
    6,
    4,
    11,
    11,
    13,
    13,
    8,
    12,
    1,
    3,
    4,
    7,
    10,
    14,
    7,
    10,
    9,
    15,
    5,
    6,
    0,
    8,
    15,
    0,
    14,
    5,
    2,
    9,
    3,
    2,
    12,
    13,
    1,
    2,
    15,
    8,
    13,
    4,
    8,
    6,
    10,
    15,
    3,
    11,
    7,
    1,
    4,
    10,
    12,
    9,
    5,
    3,
    6,
    14,
    11,
    5,
    0,
    0,
    14,
    12,
    9,
    7,
    2,
    7,
    2,
    11,
    1,
    4,
    14,
    1,
    7,
    9,
    4,
    12,
    10,
    14,
    8,
    2,
    13,
    0,
    15,
    6,
    12,
    10,
    9,
    13,
    0,
    15,
    3,
    3,
    5,
    5,
    6,
    8,
    11
  ];
  utils$5.substitute = function(V, J) {
    for (var ee = 0, te = 0; te < 4; te++) {
      var re = V >>> 18 - te * 6 & 63, ie = e[te * 64 + re];
      ee <<= 4, ee |= ie;
    }
    for (var te = 0; te < 4; te++) {
      var re = J >>> 18 - te * 6 & 63, ie = e[4 * 64 + te * 64 + re];
      ee <<= 4, ee |= ie;
    }
    return ee >>> 0;
  };
  var T = [
    16,
    25,
    12,
    11,
    3,
    20,
    4,
    15,
    31,
    17,
    9,
    6,
    27,
    14,
    1,
    22,
    30,
    24,
    8,
    18,
    0,
    5,
    29,
    23,
    13,
    19,
    2,
    26,
    10,
    21,
    28,
    7
  ];
  return utils$5.permute = function(V) {
    for (var J = 0, ee = 0; ee < T.length; ee++)
      J <<= 1, J |= V >>> T[ee] & 1;
    return J >>> 0;
  }, utils$5.padSplit = function(V, J, ee) {
    for (var te = V.toString(2); te.length < J; )
      te = "0" + te;
    for (var re = [], ie = 0; ie < J; ie += ee)
      re.push(te.slice(ie, ie + ee));
    return re.join(" ");
  }, utils$5;
}
var minimalisticAssert, hasRequiredMinimalisticAssert;
function requireMinimalisticAssert() {
  if (hasRequiredMinimalisticAssert) return minimalisticAssert;
  hasRequiredMinimalisticAssert = 1, minimalisticAssert = C;
  function C(e, T) {
    if (!e)
      throw new Error(T || "Assertion failed");
  }
  return C.equal = function(T, $, V) {
    if (T != $)
      throw new Error(V || "Assertion failed: " + T + " != " + $);
  }, minimalisticAssert;
}
var cipher, hasRequiredCipher;
function requireCipher() {
  if (hasRequiredCipher) return cipher;
  hasRequiredCipher = 1;
  var C = requireMinimalisticAssert();
  function e(T) {
    this.options = T, this.type = this.options.type, this.blockSize = 8, this._init(), this.buffer = new Array(this.blockSize), this.bufferOff = 0, this.padding = T.padding !== !1;
  }
  return cipher = e, e.prototype._init = function() {
  }, e.prototype.update = function($) {
    return $.length === 0 ? [] : this.type === "decrypt" ? this._updateDecrypt($) : this._updateEncrypt($);
  }, e.prototype._buffer = function($, V) {
    for (var J = Math.min(this.buffer.length - this.bufferOff, $.length - V), ee = 0; ee < J; ee++)
      this.buffer[this.bufferOff + ee] = $[V + ee];
    return this.bufferOff += J, J;
  }, e.prototype._flushBuffer = function($, V) {
    return this._update(this.buffer, 0, $, V), this.bufferOff = 0, this.blockSize;
  }, e.prototype._updateEncrypt = function($) {
    var V = 0, J = 0, ee = (this.bufferOff + $.length) / this.blockSize | 0, te = new Array(ee * this.blockSize);
    this.bufferOff !== 0 && (V += this._buffer($, V), this.bufferOff === this.buffer.length && (J += this._flushBuffer(te, J)));
    for (var re = $.length - ($.length - V) % this.blockSize; V < re; V += this.blockSize)
      this._update($, V, te, J), J += this.blockSize;
    for (; V < $.length; V++, this.bufferOff++)
      this.buffer[this.bufferOff] = $[V];
    return te;
  }, e.prototype._updateDecrypt = function($) {
    for (var V = 0, J = 0, ee = Math.ceil((this.bufferOff + $.length) / this.blockSize) - 1, te = new Array(ee * this.blockSize); ee > 0; ee--)
      V += this._buffer($, V), J += this._flushBuffer(te, J);
    return V += this._buffer($, V), te;
  }, e.prototype.final = function($) {
    var V;
    $ && (V = this.update($));
    var J;
    return this.type === "encrypt" ? J = this._finalEncrypt() : J = this._finalDecrypt(), V ? V.concat(J) : J;
  }, e.prototype._pad = function($, V) {
    if (V === 0)
      return !1;
    for (; V < $.length; )
      $[V++] = 0;
    return !0;
  }, e.prototype._finalEncrypt = function() {
    if (!this._pad(this.buffer, this.bufferOff))
      return [];
    var $ = new Array(this.blockSize);
    return this._update(this.buffer, 0, $, 0), $;
  }, e.prototype._unpad = function($) {
    return $;
  }, e.prototype._finalDecrypt = function() {
    C.equal(this.bufferOff, this.blockSize, "Not enough data to decrypt");
    var $ = new Array(this.blockSize);
    return this._flushBuffer($, 0), this._unpad($);
  }, cipher;
}
var des, hasRequiredDes$1;
function requireDes$1() {
  if (hasRequiredDes$1) return des;
  hasRequiredDes$1 = 1;
  var C = requireMinimalisticAssert(), e = requireInherits_browser(), T = requireUtils$3(), $ = requireCipher();
  function V() {
    this.tmp = new Array(2), this.keys = null;
  }
  function J(te) {
    $.call(this, te);
    var re = new V();
    this._desState = re, this.deriveKeys(re, te.key);
  }
  e(J, $), des = J, J.create = function(re) {
    return new J(re);
  };
  var ee = [
    1,
    1,
    2,
    2,
    2,
    2,
    2,
    2,
    1,
    2,
    2,
    2,
    2,
    2,
    2,
    1
  ];
  return J.prototype.deriveKeys = function(re, ie) {
    re.keys = new Array(16 * 2), C.equal(ie.length, this.blockSize, "Invalid key length");
    var se = T.readUInt32BE(ie, 0), de = T.readUInt32BE(ie, 4);
    T.pc1(se, de, re.tmp, 0), se = re.tmp[0], de = re.tmp[1];
    for (var ue = 0; ue < re.keys.length; ue += 2) {
      var fe = ee[ue >>> 1];
      se = T.r28shl(se, fe), de = T.r28shl(de, fe), T.pc2(se, de, re.keys, ue);
    }
  }, J.prototype._update = function(re, ie, se, de) {
    var ue = this._desState, fe = T.readUInt32BE(re, ie), he = T.readUInt32BE(re, ie + 4);
    T.ip(fe, he, ue.tmp, 0), fe = ue.tmp[0], he = ue.tmp[1], this.type === "encrypt" ? this._encrypt(ue, fe, he, ue.tmp, 0) : this._decrypt(ue, fe, he, ue.tmp, 0), fe = ue.tmp[0], he = ue.tmp[1], T.writeUInt32BE(se, fe, de), T.writeUInt32BE(se, he, de + 4);
  }, J.prototype._pad = function(re, ie) {
    if (this.padding === !1)
      return !1;
    for (var se = re.length - ie, de = ie; de < re.length; de++)
      re[de] = se;
    return !0;
  }, J.prototype._unpad = function(re) {
    if (this.padding === !1)
      return re;
    for (var ie = re[re.length - 1], se = re.length - ie; se < re.length; se++)
      C.equal(re[se], ie);
    return re.slice(0, re.length - ie);
  }, J.prototype._encrypt = function(re, ie, se, de, ue) {
    for (var fe = ie, he = se, me = 0; me < re.keys.length; me += 2) {
      var xe = re.keys[me], ve = re.keys[me + 1];
      T.expand(he, re.tmp, 0), xe ^= re.tmp[0], ve ^= re.tmp[1];
      var Te = T.substitute(xe, ve), we = T.permute(Te), Ee = he;
      he = (fe ^ we) >>> 0, fe = Ee;
    }
    T.rip(he, fe, de, ue);
  }, J.prototype._decrypt = function(re, ie, se, de, ue) {
    for (var fe = se, he = ie, me = re.keys.length - 2; me >= 0; me -= 2) {
      var xe = re.keys[me], ve = re.keys[me + 1];
      T.expand(fe, re.tmp, 0), xe ^= re.tmp[0], ve ^= re.tmp[1];
      var Te = T.substitute(xe, ve), we = T.permute(Te), Ee = fe;
      fe = (he ^ we) >>> 0, he = Ee;
    }
    T.rip(fe, he, de, ue);
  }, des;
}
var cbc$1 = {}, hasRequiredCbc$1;
function requireCbc$1() {
  if (hasRequiredCbc$1) return cbc$1;
  hasRequiredCbc$1 = 1;
  var C = requireMinimalisticAssert(), e = requireInherits_browser(), T = {};
  function $(J) {
    C.equal(J.length, 8, "Invalid IV length"), this.iv = new Array(8);
    for (var ee = 0; ee < this.iv.length; ee++)
      this.iv[ee] = J[ee];
  }
  function V(J) {
    function ee(se) {
      J.call(this, se), this._cbcInit();
    }
    e(ee, J);
    for (var te = Object.keys(T), re = 0; re < te.length; re++) {
      var ie = te[re];
      ee.prototype[ie] = T[ie];
    }
    return ee.create = function(de) {
      return new ee(de);
    }, ee;
  }
  return cbc$1.instantiate = V, T._cbcInit = function() {
    var ee = new $(this.options.iv);
    this._cbcState = ee;
  }, T._update = function(ee, te, re, ie) {
    var se = this._cbcState, de = this.constructor.super_.prototype, ue = se.iv;
    if (this.type === "encrypt") {
      for (var fe = 0; fe < this.blockSize; fe++)
        ue[fe] ^= ee[te + fe];
      de._update.call(this, ue, 0, re, ie);
      for (var fe = 0; fe < this.blockSize; fe++)
        ue[fe] = re[ie + fe];
    } else {
      de._update.call(this, ee, te, re, ie);
      for (var fe = 0; fe < this.blockSize; fe++)
        re[ie + fe] ^= ue[fe];
      for (var fe = 0; fe < this.blockSize; fe++)
        ue[fe] = ee[te + fe];
    }
  }, cbc$1;
}
var ede, hasRequiredEde;
function requireEde() {
  if (hasRequiredEde) return ede;
  hasRequiredEde = 1;
  var C = requireMinimalisticAssert(), e = requireInherits_browser(), T = requireCipher(), $ = requireDes$1();
  function V(ee, te) {
    C.equal(te.length, 24, "Invalid key length");
    var re = te.slice(0, 8), ie = te.slice(8, 16), se = te.slice(16, 24);
    ee === "encrypt" ? this.ciphers = [
      $.create({ type: "encrypt", key: re }),
      $.create({ type: "decrypt", key: ie }),
      $.create({ type: "encrypt", key: se })
    ] : this.ciphers = [
      $.create({ type: "decrypt", key: se }),
      $.create({ type: "encrypt", key: ie }),
      $.create({ type: "decrypt", key: re })
    ];
  }
  function J(ee) {
    T.call(this, ee);
    var te = new V(this.type, this.options.key);
    this._edeState = te;
  }
  return e(J, T), ede = J, J.create = function(te) {
    return new J(te);
  }, J.prototype._update = function(te, re, ie, se) {
    var de = this._edeState;
    de.ciphers[0]._update(te, re, ie, se), de.ciphers[1]._update(ie, se, ie, se), de.ciphers[2]._update(ie, se, ie, se);
  }, J.prototype._pad = $.prototype._pad, J.prototype._unpad = $.prototype._unpad, ede;
}
var hasRequiredDes;
function requireDes() {
  return hasRequiredDes || (hasRequiredDes = 1, des$1.utils = requireUtils$3(), des$1.Cipher = requireCipher(), des$1.DES = requireDes$1(), des$1.CBC = requireCbc$1(), des$1.EDE = requireEde()), des$1;
}
var browserifyDes, hasRequiredBrowserifyDes;
function requireBrowserifyDes() {
  if (hasRequiredBrowserifyDes) return browserifyDes;
  hasRequiredBrowserifyDes = 1;
  var C = requireCipherBase(), e = requireDes(), T = requireInherits_browser(), $ = safeBufferExports.Buffer, V = {
    "des-ede3-cbc": e.CBC.instantiate(e.EDE),
    "des-ede3": e.EDE,
    "des-ede-cbc": e.CBC.instantiate(e.EDE),
    "des-ede": e.EDE,
    "des-cbc": e.CBC.instantiate(e.DES),
    "des-ecb": e.DES
  };
  V.des = V["des-cbc"], V.des3 = V["des-ede3-cbc"], browserifyDes = J, T(J, C);
  function J(ee) {
    C.call(this);
    var te = ee.mode.toLowerCase(), re = V[te], ie;
    ee.decrypt ? ie = "decrypt" : ie = "encrypt";
    var se = ee.key;
    $.isBuffer(se) || (se = $.from(se)), (te === "des-ede" || te === "des-ede-cbc") && (se = $.concat([se, se.slice(0, 8)]));
    var de = ee.iv;
    $.isBuffer(de) || (de = $.from(de)), this._des = re.create({
      key: se,
      iv: de,
      type: ie
    });
  }
  return J.prototype._update = function(ee) {
    return $.from(this._des.update(ee));
  }, J.prototype._final = function() {
    return $.from(this._des.final());
  }, browserifyDes;
}
var browser$7 = {}, encrypter = {}, ecb = {}, hasRequiredEcb;
function requireEcb() {
  return hasRequiredEcb || (hasRequiredEcb = 1, ecb.encrypt = function(C, e) {
    return C._cipher.encryptBlock(e);
  }, ecb.decrypt = function(C, e) {
    return C._cipher.decryptBlock(e);
  }), ecb;
}
var cbc = {}, bufferXor, hasRequiredBufferXor;
function requireBufferXor() {
  return hasRequiredBufferXor || (hasRequiredBufferXor = 1, bufferXor = function(e, T) {
    for (var $ = Math.min(e.length, T.length), V = new dist$2.Buffer($), J = 0; J < $; ++J)
      V[J] = e[J] ^ T[J];
    return V;
  }), bufferXor;
}
var hasRequiredCbc;
function requireCbc() {
  if (hasRequiredCbc) return cbc;
  hasRequiredCbc = 1;
  var C = requireBufferXor();
  return cbc.encrypt = function(e, T) {
    var $ = C(T, e._prev);
    return e._prev = e._cipher.encryptBlock($), e._prev;
  }, cbc.decrypt = function(e, T) {
    var $ = e._prev;
    e._prev = T;
    var V = e._cipher.decryptBlock(T);
    return C(V, $);
  }, cbc;
}
var cfb = {}, hasRequiredCfb;
function requireCfb() {
  if (hasRequiredCfb) return cfb;
  hasRequiredCfb = 1;
  var C = safeBufferExports.Buffer, e = requireBufferXor();
  function T($, V, J) {
    var ee = V.length, te = e(V, $._cache);
    return $._cache = $._cache.slice(ee), $._prev = C.concat([$._prev, J ? V : te]), te;
  }
  return cfb.encrypt = function($, V, J) {
    for (var ee = C.allocUnsafe(0), te; V.length; )
      if ($._cache.length === 0 && ($._cache = $._cipher.encryptBlock($._prev), $._prev = C.allocUnsafe(0)), $._cache.length <= V.length)
        te = $._cache.length, ee = C.concat([ee, T($, V.slice(0, te), J)]), V = V.slice(te);
      else {
        ee = C.concat([ee, T($, V, J)]);
        break;
      }
    return ee;
  }, cfb;
}
var cfb8 = {}, hasRequiredCfb8;
function requireCfb8() {
  if (hasRequiredCfb8) return cfb8;
  hasRequiredCfb8 = 1;
  var C = safeBufferExports.Buffer;
  function e(T, $, V) {
    var J = T._cipher.encryptBlock(T._prev), ee = J[0] ^ $;
    return T._prev = C.concat([
      T._prev.slice(1),
      C.from([V ? $ : ee])
    ]), ee;
  }
  return cfb8.encrypt = function(T, $, V) {
    for (var J = $.length, ee = C.allocUnsafe(J), te = -1; ++te < J; )
      ee[te] = e(T, $[te], V);
    return ee;
  }, cfb8;
}
var cfb1 = {}, hasRequiredCfb1;
function requireCfb1() {
  if (hasRequiredCfb1) return cfb1;
  hasRequiredCfb1 = 1;
  var C = safeBufferExports.Buffer;
  function e($, V, J) {
    for (var ee, te = -1, re = 8, ie = 0, se, de; ++te < re; )
      ee = $._cipher.encryptBlock($._prev), se = V & 1 << 7 - te ? 128 : 0, de = ee[0] ^ se, ie += (de & 128) >> te % 8, $._prev = T($._prev, J ? se : de);
    return ie;
  }
  function T($, V) {
    var J = $.length, ee = -1, te = C.allocUnsafe($.length);
    for ($ = C.concat([$, C.from([V])]); ++ee < J; )
      te[ee] = $[ee] << 1 | $[ee + 1] >> 7;
    return te;
  }
  return cfb1.encrypt = function($, V, J) {
    for (var ee = V.length, te = C.allocUnsafe(ee), re = -1; ++re < ee; )
      te[re] = e($, V[re], J);
    return te;
  }, cfb1;
}
var ofb = {}, hasRequiredOfb;
function requireOfb() {
  if (hasRequiredOfb) return ofb;
  hasRequiredOfb = 1;
  var C = requireBufferXor();
  function e(T) {
    return T._prev = T._cipher.encryptBlock(T._prev), T._prev;
  }
  return ofb.encrypt = function(T, $) {
    for (; T._cache.length < $.length; )
      T._cache = dist$2.Buffer.concat([T._cache, e(T)]);
    var V = T._cache.slice(0, $.length);
    return T._cache = T._cache.slice($.length), C($, V);
  }, ofb;
}
var ctr = {}, incr32_1, hasRequiredIncr32;
function requireIncr32() {
  if (hasRequiredIncr32) return incr32_1;
  hasRequiredIncr32 = 1;
  function C(e) {
    for (var T = e.length, $; T--; )
      if ($ = e.readUInt8(T), $ === 255)
        e.writeUInt8(0, T);
      else {
        $++, e.writeUInt8($, T);
        break;
      }
  }
  return incr32_1 = C, incr32_1;
}
var hasRequiredCtr;
function requireCtr() {
  if (hasRequiredCtr) return ctr;
  hasRequiredCtr = 1;
  var C = requireBufferXor(), e = safeBufferExports.Buffer, T = requireIncr32();
  function $(J) {
    var ee = J._cipher.encryptBlockRaw(J._prev);
    return T(J._prev), ee;
  }
  var V = 16;
  return ctr.encrypt = function(J, ee) {
    var te = Math.ceil(ee.length / V), re = J._cache.length;
    J._cache = e.concat([
      J._cache,
      e.allocUnsafe(te * V)
    ]);
    for (var ie = 0; ie < te; ie++) {
      var se = $(J), de = re + ie * V;
      J._cache.writeUInt32BE(se[0], de + 0), J._cache.writeUInt32BE(se[1], de + 4), J._cache.writeUInt32BE(se[2], de + 8), J._cache.writeUInt32BE(se[3], de + 12);
    }
    var ue = J._cache.slice(0, ee.length);
    return J._cache = J._cache.slice(ee.length), C(ee, ue);
  }, ctr;
}
const aes128 = {
  cipher: "AES",
  key: 128,
  iv: 16,
  mode: "CBC",
  type: "block"
}, aes192 = {
  cipher: "AES",
  key: 192,
  iv: 16,
  mode: "CBC",
  type: "block"
}, aes256 = {
  cipher: "AES",
  key: 256,
  iv: 16,
  mode: "CBC",
  type: "block"
}, require$$2$1 = {
  "aes-128-ecb": {
    cipher: "AES",
    key: 128,
    iv: 0,
    mode: "ECB",
    type: "block"
  },
  "aes-192-ecb": {
    cipher: "AES",
    key: 192,
    iv: 0,
    mode: "ECB",
    type: "block"
  },
  "aes-256-ecb": {
    cipher: "AES",
    key: 256,
    iv: 0,
    mode: "ECB",
    type: "block"
  },
  "aes-128-cbc": {
    cipher: "AES",
    key: 128,
    iv: 16,
    mode: "CBC",
    type: "block"
  },
  "aes-192-cbc": {
    cipher: "AES",
    key: 192,
    iv: 16,
    mode: "CBC",
    type: "block"
  },
  "aes-256-cbc": {
    cipher: "AES",
    key: 256,
    iv: 16,
    mode: "CBC",
    type: "block"
  },
  aes128,
  aes192,
  aes256,
  "aes-128-cfb": {
    cipher: "AES",
    key: 128,
    iv: 16,
    mode: "CFB",
    type: "stream"
  },
  "aes-192-cfb": {
    cipher: "AES",
    key: 192,
    iv: 16,
    mode: "CFB",
    type: "stream"
  },
  "aes-256-cfb": {
    cipher: "AES",
    key: 256,
    iv: 16,
    mode: "CFB",
    type: "stream"
  },
  "aes-128-cfb8": {
    cipher: "AES",
    key: 128,
    iv: 16,
    mode: "CFB8",
    type: "stream"
  },
  "aes-192-cfb8": {
    cipher: "AES",
    key: 192,
    iv: 16,
    mode: "CFB8",
    type: "stream"
  },
  "aes-256-cfb8": {
    cipher: "AES",
    key: 256,
    iv: 16,
    mode: "CFB8",
    type: "stream"
  },
  "aes-128-cfb1": {
    cipher: "AES",
    key: 128,
    iv: 16,
    mode: "CFB1",
    type: "stream"
  },
  "aes-192-cfb1": {
    cipher: "AES",
    key: 192,
    iv: 16,
    mode: "CFB1",
    type: "stream"
  },
  "aes-256-cfb1": {
    cipher: "AES",
    key: 256,
    iv: 16,
    mode: "CFB1",
    type: "stream"
  },
  "aes-128-ofb": {
    cipher: "AES",
    key: 128,
    iv: 16,
    mode: "OFB",
    type: "stream"
  },
  "aes-192-ofb": {
    cipher: "AES",
    key: 192,
    iv: 16,
    mode: "OFB",
    type: "stream"
  },
  "aes-256-ofb": {
    cipher: "AES",
    key: 256,
    iv: 16,
    mode: "OFB",
    type: "stream"
  },
  "aes-128-ctr": {
    cipher: "AES",
    key: 128,
    iv: 16,
    mode: "CTR",
    type: "stream"
  },
  "aes-192-ctr": {
    cipher: "AES",
    key: 192,
    iv: 16,
    mode: "CTR",
    type: "stream"
  },
  "aes-256-ctr": {
    cipher: "AES",
    key: 256,
    iv: 16,
    mode: "CTR",
    type: "stream"
  },
  "aes-128-gcm": {
    cipher: "AES",
    key: 128,
    iv: 12,
    mode: "GCM",
    type: "auth"
  },
  "aes-192-gcm": {
    cipher: "AES",
    key: 192,
    iv: 12,
    mode: "GCM",
    type: "auth"
  },
  "aes-256-gcm": {
    cipher: "AES",
    key: 256,
    iv: 12,
    mode: "GCM",
    type: "auth"
  }
};
var modes_1, hasRequiredModes$1;
function requireModes$1() {
  if (hasRequiredModes$1) return modes_1;
  hasRequiredModes$1 = 1;
  var C = {
    ECB: requireEcb(),
    CBC: requireCbc(),
    CFB: requireCfb(),
    CFB8: requireCfb8(),
    CFB1: requireCfb1(),
    OFB: requireOfb(),
    CTR: requireCtr(),
    GCM: requireCtr()
  }, e = require$$2$1;
  for (var T in e)
    e[T].module = C[e[T].mode];
  return modes_1 = e, modes_1;
}
var aes = {}, hasRequiredAes;
function requireAes() {
  if (hasRequiredAes) return aes;
  hasRequiredAes = 1;
  var C = safeBufferExports.Buffer;
  function e(te) {
    C.isBuffer(te) || (te = C.from(te));
    for (var re = te.length / 4 | 0, ie = new Array(re), se = 0; se < re; se++)
      ie[se] = te.readUInt32BE(se * 4);
    return ie;
  }
  function T(te) {
    for (var re = 0; re < te.length; te++)
      te[re] = 0;
  }
  function $(te, re, ie, se, de) {
    for (var ue = ie[0], fe = ie[1], he = ie[2], me = ie[3], xe = te[0] ^ re[0], ve = te[1] ^ re[1], Te = te[2] ^ re[2], we = te[3] ^ re[3], Ee, Me, Ie, ke, _e = 4, De = 1; De < de; De++)
      Ee = ue[xe >>> 24] ^ fe[ve >>> 16 & 255] ^ he[Te >>> 8 & 255] ^ me[we & 255] ^ re[_e++], Me = ue[ve >>> 24] ^ fe[Te >>> 16 & 255] ^ he[we >>> 8 & 255] ^ me[xe & 255] ^ re[_e++], Ie = ue[Te >>> 24] ^ fe[we >>> 16 & 255] ^ he[xe >>> 8 & 255] ^ me[ve & 255] ^ re[_e++], ke = ue[we >>> 24] ^ fe[xe >>> 16 & 255] ^ he[ve >>> 8 & 255] ^ me[Te & 255] ^ re[_e++], xe = Ee, ve = Me, Te = Ie, we = ke;
    return Ee = (se[xe >>> 24] << 24 | se[ve >>> 16 & 255] << 16 | se[Te >>> 8 & 255] << 8 | se[we & 255]) ^ re[_e++], Me = (se[ve >>> 24] << 24 | se[Te >>> 16 & 255] << 16 | se[we >>> 8 & 255] << 8 | se[xe & 255]) ^ re[_e++], Ie = (se[Te >>> 24] << 24 | se[we >>> 16 & 255] << 16 | se[xe >>> 8 & 255] << 8 | se[ve & 255]) ^ re[_e++], ke = (se[we >>> 24] << 24 | se[xe >>> 16 & 255] << 16 | se[ve >>> 8 & 255] << 8 | se[Te & 255]) ^ re[_e++], Ee = Ee >>> 0, Me = Me >>> 0, Ie = Ie >>> 0, ke = ke >>> 0, [Ee, Me, Ie, ke];
  }
  var V = [0, 1, 2, 4, 8, 16, 32, 64, 128, 27, 54], J = function() {
    for (var te = new Array(256), re = 0; re < 256; re++)
      re < 128 ? te[re] = re << 1 : te[re] = re << 1 ^ 283;
    for (var ie = [], se = [], de = [[], [], [], []], ue = [[], [], [], []], fe = 0, he = 0, me = 0; me < 256; ++me) {
      var xe = he ^ he << 1 ^ he << 2 ^ he << 3 ^ he << 4;
      xe = xe >>> 8 ^ xe & 255 ^ 99, ie[fe] = xe, se[xe] = fe;
      var ve = te[fe], Te = te[ve], we = te[Te], Ee = te[xe] * 257 ^ xe * 16843008;
      de[0][fe] = Ee << 24 | Ee >>> 8, de[1][fe] = Ee << 16 | Ee >>> 16, de[2][fe] = Ee << 8 | Ee >>> 24, de[3][fe] = Ee, Ee = we * 16843009 ^ Te * 65537 ^ ve * 257 ^ fe * 16843008, ue[0][xe] = Ee << 24 | Ee >>> 8, ue[1][xe] = Ee << 16 | Ee >>> 16, ue[2][xe] = Ee << 8 | Ee >>> 24, ue[3][xe] = Ee, fe === 0 ? fe = he = 1 : (fe = ve ^ te[te[te[we ^ ve]]], he ^= te[te[he]]);
    }
    return {
      SBOX: ie,
      INV_SBOX: se,
      SUB_MIX: de,
      INV_SUB_MIX: ue
    };
  }();
  function ee(te) {
    this._key = e(te), this._reset();
  }
  return ee.blockSize = 4 * 4, ee.keySize = 256 / 8, ee.prototype.blockSize = ee.blockSize, ee.prototype.keySize = ee.keySize, ee.prototype._reset = function() {
    for (var te = this._key, re = te.length, ie = re + 6, se = (ie + 1) * 4, de = [], ue = 0; ue < re; ue++)
      de[ue] = te[ue];
    for (ue = re; ue < se; ue++) {
      var fe = de[ue - 1];
      ue % re === 0 ? (fe = fe << 8 | fe >>> 24, fe = J.SBOX[fe >>> 24] << 24 | J.SBOX[fe >>> 16 & 255] << 16 | J.SBOX[fe >>> 8 & 255] << 8 | J.SBOX[fe & 255], fe ^= V[ue / re | 0] << 24) : re > 6 && ue % re === 4 && (fe = J.SBOX[fe >>> 24] << 24 | J.SBOX[fe >>> 16 & 255] << 16 | J.SBOX[fe >>> 8 & 255] << 8 | J.SBOX[fe & 255]), de[ue] = de[ue - re] ^ fe;
    }
    for (var he = [], me = 0; me < se; me++) {
      var xe = se - me, ve = de[xe - (me % 4 ? 0 : 4)];
      me < 4 || xe <= 4 ? he[me] = ve : he[me] = J.INV_SUB_MIX[0][J.SBOX[ve >>> 24]] ^ J.INV_SUB_MIX[1][J.SBOX[ve >>> 16 & 255]] ^ J.INV_SUB_MIX[2][J.SBOX[ve >>> 8 & 255]] ^ J.INV_SUB_MIX[3][J.SBOX[ve & 255]];
    }
    this._nRounds = ie, this._keySchedule = de, this._invKeySchedule = he;
  }, ee.prototype.encryptBlockRaw = function(te) {
    return te = e(te), $(te, this._keySchedule, J.SUB_MIX, J.SBOX, this._nRounds);
  }, ee.prototype.encryptBlock = function(te) {
    var re = this.encryptBlockRaw(te), ie = C.allocUnsafe(16);
    return ie.writeUInt32BE(re[0], 0), ie.writeUInt32BE(re[1], 4), ie.writeUInt32BE(re[2], 8), ie.writeUInt32BE(re[3], 12), ie;
  }, ee.prototype.decryptBlock = function(te) {
    te = e(te);
    var re = te[1];
    te[1] = te[3], te[3] = re;
    var ie = $(te, this._invKeySchedule, J.INV_SUB_MIX, J.INV_SBOX, this._nRounds), se = C.allocUnsafe(16);
    return se.writeUInt32BE(ie[0], 0), se.writeUInt32BE(ie[3], 4), se.writeUInt32BE(ie[2], 8), se.writeUInt32BE(ie[1], 12), se;
  }, ee.prototype.scrub = function() {
    T(this._keySchedule), T(this._invKeySchedule), T(this._key);
  }, aes.AES = ee, aes;
}
var ghash, hasRequiredGhash;
function requireGhash() {
  if (hasRequiredGhash) return ghash;
  hasRequiredGhash = 1;
  var C = safeBufferExports.Buffer, e = C.alloc(16, 0);
  function T(J) {
    return [
      J.readUInt32BE(0),
      J.readUInt32BE(4),
      J.readUInt32BE(8),
      J.readUInt32BE(12)
    ];
  }
  function $(J) {
    var ee = C.allocUnsafe(16);
    return ee.writeUInt32BE(J[0] >>> 0, 0), ee.writeUInt32BE(J[1] >>> 0, 4), ee.writeUInt32BE(J[2] >>> 0, 8), ee.writeUInt32BE(J[3] >>> 0, 12), ee;
  }
  function V(J) {
    this.h = J, this.state = C.alloc(16, 0), this.cache = C.allocUnsafe(0);
  }
  return V.prototype.ghash = function(J) {
    for (var ee = -1; ++ee < J.length; )
      this.state[ee] ^= J[ee];
    this._multiply();
  }, V.prototype._multiply = function() {
    for (var J = T(this.h), ee = [0, 0, 0, 0], te, re, ie, se = -1; ++se < 128; ) {
      for (re = (this.state[~~(se / 8)] & 1 << 7 - se % 8) !== 0, re && (ee[0] ^= J[0], ee[1] ^= J[1], ee[2] ^= J[2], ee[3] ^= J[3]), ie = (J[3] & 1) !== 0, te = 3; te > 0; te--)
        J[te] = J[te] >>> 1 | (J[te - 1] & 1) << 31;
      J[0] = J[0] >>> 1, ie && (J[0] = J[0] ^ 225 << 24);
    }
    this.state = $(ee);
  }, V.prototype.update = function(J) {
    this.cache = C.concat([this.cache, J]);
    for (var ee; this.cache.length >= 16; )
      ee = this.cache.slice(0, 16), this.cache = this.cache.slice(16), this.ghash(ee);
  }, V.prototype.final = function(J, ee) {
    return this.cache.length && this.ghash(C.concat([this.cache, e], 16)), this.ghash($([0, J, 0, ee])), this.state;
  }, ghash = V, ghash;
}
var authCipher, hasRequiredAuthCipher;
function requireAuthCipher() {
  if (hasRequiredAuthCipher) return authCipher;
  hasRequiredAuthCipher = 1;
  var C = requireAes(), e = safeBufferExports.Buffer, T = requireCipherBase(), $ = requireInherits_browser(), V = requireGhash(), J = requireBufferXor(), ee = requireIncr32();
  function te(se, de) {
    var ue = 0;
    se.length !== de.length && ue++;
    for (var fe = Math.min(se.length, de.length), he = 0; he < fe; ++he)
      ue += se[he] ^ de[he];
    return ue;
  }
  function re(se, de, ue) {
    if (de.length === 12)
      return se._finID = e.concat([de, e.from([0, 0, 0, 1])]), e.concat([de, e.from([0, 0, 0, 2])]);
    var fe = new V(ue), he = de.length, me = he % 16;
    fe.update(de), me && (me = 16 - me, fe.update(e.alloc(me, 0))), fe.update(e.alloc(8, 0));
    var xe = he * 8, ve = e.alloc(8);
    ve.writeUIntBE(xe, 0, 8), fe.update(ve), se._finID = fe.state;
    var Te = e.from(se._finID);
    return ee(Te), Te;
  }
  function ie(se, de, ue, fe) {
    T.call(this);
    var he = e.alloc(4, 0);
    this._cipher = new C.AES(de);
    var me = this._cipher.encryptBlock(he);
    this._ghash = new V(me), ue = re(this, ue, me), this._prev = e.from(ue), this._cache = e.allocUnsafe(0), this._secCache = e.allocUnsafe(0), this._decrypt = fe, this._alen = 0, this._len = 0, this._mode = se, this._authTag = null, this._called = !1;
  }
  return $(ie, T), ie.prototype._update = function(se) {
    if (!this._called && this._alen) {
      var de = 16 - this._alen % 16;
      de < 16 && (de = e.alloc(de, 0), this._ghash.update(de));
    }
    this._called = !0;
    var ue = this._mode.encrypt(this, se);
    return this._decrypt ? this._ghash.update(se) : this._ghash.update(ue), this._len += se.length, ue;
  }, ie.prototype._final = function() {
    if (this._decrypt && !this._authTag) throw new Error("Unsupported state or unable to authenticate data");
    var se = J(this._ghash.final(this._alen * 8, this._len * 8), this._cipher.encryptBlock(this._finID));
    if (this._decrypt && te(se, this._authTag)) throw new Error("Unsupported state or unable to authenticate data");
    this._authTag = se, this._cipher.scrub();
  }, ie.prototype.getAuthTag = function() {
    if (this._decrypt || !e.isBuffer(this._authTag)) throw new Error("Attempting to get auth tag in unsupported state");
    return this._authTag;
  }, ie.prototype.setAuthTag = function(de) {
    if (!this._decrypt) throw new Error("Attempting to set auth tag in unsupported state");
    this._authTag = de;
  }, ie.prototype.setAAD = function(de) {
    if (this._called) throw new Error("Attempting to set AAD in unsupported state");
    this._ghash.update(de), this._alen += de.length;
  }, authCipher = ie, authCipher;
}
var streamCipher, hasRequiredStreamCipher;
function requireStreamCipher() {
  if (hasRequiredStreamCipher) return streamCipher;
  hasRequiredStreamCipher = 1;
  var C = requireAes(), e = safeBufferExports.Buffer, T = requireCipherBase(), $ = requireInherits_browser();
  function V(J, ee, te, re) {
    T.call(this), this._cipher = new C.AES(ee), this._prev = e.from(te), this._cache = e.allocUnsafe(0), this._secCache = e.allocUnsafe(0), this._decrypt = re, this._mode = J;
  }
  return $(V, T), V.prototype._update = function(J) {
    return this._mode.encrypt(this, J, this._decrypt);
  }, V.prototype._final = function() {
    this._cipher.scrub();
  }, streamCipher = V, streamCipher;
}
var evp_bytestokey, hasRequiredEvp_bytestokey;
function requireEvp_bytestokey() {
  if (hasRequiredEvp_bytestokey) return evp_bytestokey;
  hasRequiredEvp_bytestokey = 1;
  var C = safeBufferExports.Buffer, e = requireMd5_js();
  function T($, V, J, ee) {
    if (C.isBuffer($) || ($ = C.from($, "binary")), V && (C.isBuffer(V) || (V = C.from(V, "binary")), V.length !== 8))
      throw new RangeError("salt should be Buffer with 8 byte length");
    for (var te = J / 8, re = C.alloc(te), ie = C.alloc(ee || 0), se = C.alloc(0); te > 0 || ee > 0; ) {
      var de = new e();
      de.update(se), de.update($), V && de.update(V), se = de.digest();
      var ue = 0;
      if (te > 0) {
        var fe = re.length - te;
        ue = Math.min(te, se.length), se.copy(re, fe, 0, ue), te -= ue;
      }
      if (ue < se.length && ee > 0) {
        var he = ie.length - ee, me = Math.min(ee, se.length - ue);
        se.copy(ie, he, ue, ue + me), ee -= me;
      }
    }
    return se.fill(0), { key: re, iv: ie };
  }
  return evp_bytestokey = T, evp_bytestokey;
}
var hasRequiredEncrypter;
function requireEncrypter() {
  if (hasRequiredEncrypter) return encrypter;
  hasRequiredEncrypter = 1;
  var C = requireModes$1(), e = requireAuthCipher(), T = safeBufferExports.Buffer, $ = requireStreamCipher(), V = requireCipherBase(), J = requireAes(), ee = requireEvp_bytestokey(), te = requireInherits_browser();
  function re(fe, he, me) {
    V.call(this), this._cache = new se(), this._cipher = new J.AES(he), this._prev = T.from(me), this._mode = fe, this._autopadding = !0;
  }
  te(re, V), re.prototype._update = function(fe) {
    this._cache.add(fe);
    for (var he, me, xe = []; he = this._cache.get(); )
      me = this._mode.encrypt(this, he), xe.push(me);
    return T.concat(xe);
  };
  var ie = T.alloc(16, 16);
  re.prototype._final = function() {
    var fe = this._cache.flush();
    if (this._autopadding)
      return fe = this._mode.encrypt(this, fe), this._cipher.scrub(), fe;
    if (!fe.equals(ie))
      throw this._cipher.scrub(), new Error("data not multiple of block length");
  }, re.prototype.setAutoPadding = function(fe) {
    return this._autopadding = !!fe, this;
  };
  function se() {
    this.cache = T.allocUnsafe(0);
  }
  se.prototype.add = function(fe) {
    this.cache = T.concat([this.cache, fe]);
  }, se.prototype.get = function() {
    if (this.cache.length > 15) {
      var fe = this.cache.slice(0, 16);
      return this.cache = this.cache.slice(16), fe;
    }
    return null;
  }, se.prototype.flush = function() {
    for (var fe = 16 - this.cache.length, he = T.allocUnsafe(fe), me = -1; ++me < fe; )
      he.writeUInt8(fe, me);
    return T.concat([this.cache, he]);
  };
  function de(fe, he, me) {
    var xe = C[fe.toLowerCase()];
    if (!xe) throw new TypeError("invalid suite type");
    if (typeof he == "string" && (he = T.from(he)), he.length !== xe.key / 8) throw new TypeError("invalid key length " + he.length);
    if (typeof me == "string" && (me = T.from(me)), xe.mode !== "GCM" && me.length !== xe.iv) throw new TypeError("invalid iv length " + me.length);
    return xe.type === "stream" ? new $(xe.module, he, me) : xe.type === "auth" ? new e(xe.module, he, me) : new re(xe.module, he, me);
  }
  function ue(fe, he) {
    var me = C[fe.toLowerCase()];
    if (!me) throw new TypeError("invalid suite type");
    var xe = ee(he, !1, me.key, me.iv);
    return de(fe, xe.key, xe.iv);
  }
  return encrypter.createCipheriv = de, encrypter.createCipher = ue, encrypter;
}
var decrypter = {}, hasRequiredDecrypter;
function requireDecrypter() {
  if (hasRequiredDecrypter) return decrypter;
  hasRequiredDecrypter = 1;
  var C = requireAuthCipher(), e = safeBufferExports.Buffer, T = requireModes$1(), $ = requireStreamCipher(), V = requireCipherBase(), J = requireAes(), ee = requireEvp_bytestokey(), te = requireInherits_browser();
  function re(fe, he, me) {
    V.call(this), this._cache = new ie(), this._last = void 0, this._cipher = new J.AES(he), this._prev = e.from(me), this._mode = fe, this._autopadding = !0;
  }
  te(re, V), re.prototype._update = function(fe) {
    this._cache.add(fe);
    for (var he, me, xe = []; he = this._cache.get(this._autopadding); )
      me = this._mode.decrypt(this, he), xe.push(me);
    return e.concat(xe);
  }, re.prototype._final = function() {
    var fe = this._cache.flush();
    if (this._autopadding)
      return se(this._mode.decrypt(this, fe));
    if (fe)
      throw new Error("data not multiple of block length");
  }, re.prototype.setAutoPadding = function(fe) {
    return this._autopadding = !!fe, this;
  };
  function ie() {
    this.cache = e.allocUnsafe(0);
  }
  ie.prototype.add = function(fe) {
    this.cache = e.concat([this.cache, fe]);
  }, ie.prototype.get = function(fe) {
    var he;
    if (fe) {
      if (this.cache.length > 16)
        return he = this.cache.slice(0, 16), this.cache = this.cache.slice(16), he;
    } else if (this.cache.length >= 16)
      return he = this.cache.slice(0, 16), this.cache = this.cache.slice(16), he;
    return null;
  }, ie.prototype.flush = function() {
    if (this.cache.length) return this.cache;
  };
  function se(fe) {
    var he = fe[15];
    if (he < 1 || he > 16)
      throw new Error("unable to decrypt data");
    for (var me = -1; ++me < he; )
      if (fe[me + (16 - he)] !== he)
        throw new Error("unable to decrypt data");
    if (he !== 16)
      return fe.slice(0, 16 - he);
  }
  function de(fe, he, me) {
    var xe = T[fe.toLowerCase()];
    if (!xe) throw new TypeError("invalid suite type");
    if (typeof me == "string" && (me = e.from(me)), xe.mode !== "GCM" && me.length !== xe.iv) throw new TypeError("invalid iv length " + me.length);
    if (typeof he == "string" && (he = e.from(he)), he.length !== xe.key / 8) throw new TypeError("invalid key length " + he.length);
    return xe.type === "stream" ? new $(xe.module, he, me, !0) : xe.type === "auth" ? new C(xe.module, he, me, !0) : new re(xe.module, he, me);
  }
  function ue(fe, he) {
    var me = T[fe.toLowerCase()];
    if (!me) throw new TypeError("invalid suite type");
    var xe = ee(he, !1, me.key, me.iv);
    return de(fe, xe.key, xe.iv);
  }
  return decrypter.createDecipher = ue, decrypter.createDecipheriv = de, decrypter;
}
var hasRequiredBrowser$6;
function requireBrowser$6() {
  if (hasRequiredBrowser$6) return browser$7;
  hasRequiredBrowser$6 = 1;
  var C = requireEncrypter(), e = requireDecrypter(), T = require$$2$1;
  function $() {
    return Object.keys(T);
  }
  return browser$7.createCipher = browser$7.Cipher = C.createCipher, browser$7.createCipheriv = browser$7.Cipheriv = C.createCipheriv, browser$7.createDecipher = browser$7.Decipher = e.createDecipher, browser$7.createDecipheriv = browser$7.Decipheriv = e.createDecipheriv, browser$7.listCiphers = browser$7.getCiphers = $, browser$7;
}
var modes = {}, hasRequiredModes;
function requireModes() {
  return hasRequiredModes || (hasRequiredModes = 1, function(C) {
    C["des-ecb"] = {
      key: 8,
      iv: 0
    }, C["des-cbc"] = C.des = {
      key: 8,
      iv: 8
    }, C["des-ede3-cbc"] = C.des3 = {
      key: 24,
      iv: 8
    }, C["des-ede3"] = {
      key: 24,
      iv: 0
    }, C["des-ede-cbc"] = {
      key: 16,
      iv: 8
    }, C["des-ede"] = {
      key: 16,
      iv: 0
    };
  }(modes)), modes;
}
var hasRequiredBrowser$5;
function requireBrowser$5() {
  if (hasRequiredBrowser$5) return browser$8;
  hasRequiredBrowser$5 = 1;
  var C = requireBrowserifyDes(), e = requireBrowser$6(), T = requireModes$1(), $ = requireModes(), V = requireEvp_bytestokey();
  function J(se, de) {
    se = se.toLowerCase();
    var ue, fe;
    if (T[se])
      ue = T[se].key, fe = T[se].iv;
    else if ($[se])
      ue = $[se].key * 8, fe = $[se].iv;
    else
      throw new TypeError("invalid suite type");
    var he = V(de, !1, ue, fe);
    return te(se, he.key, he.iv);
  }
  function ee(se, de) {
    se = se.toLowerCase();
    var ue, fe;
    if (T[se])
      ue = T[se].key, fe = T[se].iv;
    else if ($[se])
      ue = $[se].key * 8, fe = $[se].iv;
    else
      throw new TypeError("invalid suite type");
    var he = V(de, !1, ue, fe);
    return re(se, he.key, he.iv);
  }
  function te(se, de, ue) {
    if (se = se.toLowerCase(), T[se]) return e.createCipheriv(se, de, ue);
    if ($[se]) return new C({ key: de, iv: ue, mode: se });
    throw new TypeError("invalid suite type");
  }
  function re(se, de, ue) {
    if (se = se.toLowerCase(), T[se]) return e.createDecipheriv(se, de, ue);
    if ($[se]) return new C({ key: de, iv: ue, mode: se, decrypt: !0 });
    throw new TypeError("invalid suite type");
  }
  function ie() {
    return Object.keys($).concat(e.getCiphers());
  }
  return browser$8.createCipher = browser$8.Cipher = J, browser$8.createCipheriv = browser$8.Cipheriv = te, browser$8.createDecipher = browser$8.Decipher = ee, browser$8.createDecipheriv = browser$8.Decipheriv = re, browser$8.listCiphers = browser$8.getCiphers = ie, browser$8;
}
var browser$6 = {}, bn$6 = { exports: {} };
bn$6.exports;
var hasRequiredBn$5;
function requireBn$5() {
  return hasRequiredBn$5 || (hasRequiredBn$5 = 1, function(C) {
    (function(e, T) {
      function $(Ae, ne) {
        if (!Ae) throw new Error(ne || "Assertion failed");
      }
      function V(Ae, ne) {
        Ae.super_ = ne;
        var oe = function() {
        };
        oe.prototype = ne.prototype, Ae.prototype = new oe(), Ae.prototype.constructor = Ae;
      }
      function J(Ae, ne, oe) {
        if (J.isBN(Ae))
          return Ae;
        this.negative = 0, this.words = null, this.length = 0, this.red = null, Ae !== null && ((ne === "le" || ne === "be") && (oe = ne, ne = 10), this._init(Ae || 0, ne || 10, oe || "be"));
      }
      typeof e == "object" ? e.exports = J : T.BN = J, J.BN = J, J.wordSize = 26;
      var ee;
      try {
        typeof window < "u" && typeof window.Buffer < "u" ? ee = window.Buffer : ee = bufferPolyfill.Buffer;
      } catch {
      }
      J.isBN = function(ne) {
        return ne instanceof J ? !0 : ne !== null && typeof ne == "object" && ne.constructor.wordSize === J.wordSize && Array.isArray(ne.words);
      }, J.max = function(ne, oe) {
        return ne.cmp(oe) > 0 ? ne : oe;
      }, J.min = function(ne, oe) {
        return ne.cmp(oe) < 0 ? ne : oe;
      }, J.prototype._init = function(ne, oe, ce) {
        if (typeof ne == "number")
          return this._initNumber(ne, oe, ce);
        if (typeof ne == "object")
          return this._initArray(ne, oe, ce);
        oe === "hex" && (oe = 16), $(oe === (oe | 0) && oe >= 2 && oe <= 36), ne = ne.toString().replace(/\s+/g, "");
        var le = 0;
        ne[0] === "-" && (le++, this.negative = 1), le < ne.length && (oe === 16 ? this._parseHex(ne, le, ce) : (this._parseBase(ne, oe, le), ce === "le" && this._initArray(this.toArray(), oe, ce)));
      }, J.prototype._initNumber = function(ne, oe, ce) {
        ne < 0 && (this.negative = 1, ne = -ne), ne < 67108864 ? (this.words = [ne & 67108863], this.length = 1) : ne < 4503599627370496 ? (this.words = [
          ne & 67108863,
          ne / 67108864 & 67108863
        ], this.length = 2) : ($(ne < 9007199254740992), this.words = [
          ne & 67108863,
          ne / 67108864 & 67108863,
          1
        ], this.length = 3), ce === "le" && this._initArray(this.toArray(), oe, ce);
      }, J.prototype._initArray = function(ne, oe, ce) {
        if ($(typeof ne.length == "number"), ne.length <= 0)
          return this.words = [0], this.length = 1, this;
        this.length = Math.ceil(ne.length / 3), this.words = new Array(this.length);
        for (var le = 0; le < this.length; le++)
          this.words[le] = 0;
        var pe, ye, Ce = 0;
        if (ce === "be")
          for (le = ne.length - 1, pe = 0; le >= 0; le -= 3)
            ye = ne[le] | ne[le - 1] << 8 | ne[le - 2] << 16, this.words[pe] |= ye << Ce & 67108863, this.words[pe + 1] = ye >>> 26 - Ce & 67108863, Ce += 24, Ce >= 26 && (Ce -= 26, pe++);
        else if (ce === "le")
          for (le = 0, pe = 0; le < ne.length; le += 3)
            ye = ne[le] | ne[le + 1] << 8 | ne[le + 2] << 16, this.words[pe] |= ye << Ce & 67108863, this.words[pe + 1] = ye >>> 26 - Ce & 67108863, Ce += 24, Ce >= 26 && (Ce -= 26, pe++);
        return this.strip();
      };
      function te(Ae, ne) {
        var oe = Ae.charCodeAt(ne);
        return oe >= 65 && oe <= 70 ? oe - 55 : oe >= 97 && oe <= 102 ? oe - 87 : oe - 48 & 15;
      }
      function re(Ae, ne, oe) {
        var ce = te(Ae, oe);
        return oe - 1 >= ne && (ce |= te(Ae, oe - 1) << 4), ce;
      }
      J.prototype._parseHex = function(ne, oe, ce) {
        this.length = Math.ceil((ne.length - oe) / 6), this.words = new Array(this.length);
        for (var le = 0; le < this.length; le++)
          this.words[le] = 0;
        var pe = 0, ye = 0, Ce;
        if (ce === "be")
          for (le = ne.length - 1; le >= oe; le -= 2)
            Ce = re(ne, oe, le) << pe, this.words[ye] |= Ce & 67108863, pe >= 18 ? (pe -= 18, ye += 1, this.words[ye] |= Ce >>> 26) : pe += 8;
        else {
          var be = ne.length - oe;
          for (le = be % 2 === 0 ? oe + 1 : oe; le < ne.length; le += 2)
            Ce = re(ne, oe, le) << pe, this.words[ye] |= Ce & 67108863, pe >= 18 ? (pe -= 18, ye += 1, this.words[ye] |= Ce >>> 26) : pe += 8;
        }
        this.strip();
      };
      function ie(Ae, ne, oe, ce) {
        for (var le = 0, pe = Math.min(Ae.length, oe), ye = ne; ye < pe; ye++) {
          var Ce = Ae.charCodeAt(ye) - 48;
          le *= ce, Ce >= 49 ? le += Ce - 49 + 10 : Ce >= 17 ? le += Ce - 17 + 10 : le += Ce;
        }
        return le;
      }
      J.prototype._parseBase = function(ne, oe, ce) {
        this.words = [0], this.length = 1;
        for (var le = 0, pe = 1; pe <= 67108863; pe *= oe)
          le++;
        le--, pe = pe / oe | 0;
        for (var ye = ne.length - ce, Ce = ye % le, be = Math.min(ye, ye - Ce) + ce, ae = 0, ge = ce; ge < be; ge += le)
          ae = ie(ne, ge, ge + le, oe), this.imuln(pe), this.words[0] + ae < 67108864 ? this.words[0] += ae : this._iaddn(ae);
        if (Ce !== 0) {
          var Se = 1;
          for (ae = ie(ne, ge, ne.length, oe), ge = 0; ge < Ce; ge++)
            Se *= oe;
          this.imuln(Se), this.words[0] + ae < 67108864 ? this.words[0] += ae : this._iaddn(ae);
        }
        this.strip();
      }, J.prototype.copy = function(ne) {
        ne.words = new Array(this.length);
        for (var oe = 0; oe < this.length; oe++)
          ne.words[oe] = this.words[oe];
        ne.length = this.length, ne.negative = this.negative, ne.red = this.red;
      }, J.prototype.clone = function() {
        var ne = new J(null);
        return this.copy(ne), ne;
      }, J.prototype._expand = function(ne) {
        for (; this.length < ne; )
          this.words[this.length++] = 0;
        return this;
      }, J.prototype.strip = function() {
        for (; this.length > 1 && this.words[this.length - 1] === 0; )
          this.length--;
        return this._normSign();
      }, J.prototype._normSign = function() {
        return this.length === 1 && this.words[0] === 0 && (this.negative = 0), this;
      }, J.prototype.inspect = function() {
        return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
      };
      var se = [
        "",
        "0",
        "00",
        "000",
        "0000",
        "00000",
        "000000",
        "0000000",
        "00000000",
        "000000000",
        "0000000000",
        "00000000000",
        "000000000000",
        "0000000000000",
        "00000000000000",
        "000000000000000",
        "0000000000000000",
        "00000000000000000",
        "000000000000000000",
        "0000000000000000000",
        "00000000000000000000",
        "000000000000000000000",
        "0000000000000000000000",
        "00000000000000000000000",
        "000000000000000000000000",
        "0000000000000000000000000"
      ], de = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
      ], ue = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        1e7,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64e6,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        243e5,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
      ];
      J.prototype.toString = function(ne, oe) {
        ne = ne || 10, oe = oe | 0 || 1;
        var ce;
        if (ne === 16 || ne === "hex") {
          ce = "";
          for (var le = 0, pe = 0, ye = 0; ye < this.length; ye++) {
            var Ce = this.words[ye], be = ((Ce << le | pe) & 16777215).toString(16);
            pe = Ce >>> 24 - le & 16777215, le += 2, le >= 26 && (le -= 26, ye--), pe !== 0 || ye !== this.length - 1 ? ce = se[6 - be.length] + be + ce : ce = be + ce;
          }
          for (pe !== 0 && (ce = pe.toString(16) + ce); ce.length % oe !== 0; )
            ce = "0" + ce;
          return this.negative !== 0 && (ce = "-" + ce), ce;
        }
        if (ne === (ne | 0) && ne >= 2 && ne <= 36) {
          var ae = de[ne], ge = ue[ne];
          ce = "";
          var Se = this.clone();
          for (Se.negative = 0; !Se.isZero(); ) {
            var Le = Se.modn(ge).toString(ne);
            Se = Se.idivn(ge), Se.isZero() ? ce = Le + ce : ce = se[ae - Le.length] + Le + ce;
          }
          for (this.isZero() && (ce = "0" + ce); ce.length % oe !== 0; )
            ce = "0" + ce;
          return this.negative !== 0 && (ce = "-" + ce), ce;
        }
        $(!1, "Base should be between 2 and 36");
      }, J.prototype.toNumber = function() {
        var ne = this.words[0];
        return this.length === 2 ? ne += this.words[1] * 67108864 : this.length === 3 && this.words[2] === 1 ? ne += 4503599627370496 + this.words[1] * 67108864 : this.length > 2 && $(!1, "Number can only safely store up to 53 bits"), this.negative !== 0 ? -ne : ne;
      }, J.prototype.toJSON = function() {
        return this.toString(16);
      }, J.prototype.toBuffer = function(ne, oe) {
        return $(typeof ee < "u"), this.toArrayLike(ee, ne, oe);
      }, J.prototype.toArray = function(ne, oe) {
        return this.toArrayLike(Array, ne, oe);
      }, J.prototype.toArrayLike = function(ne, oe, ce) {
        var le = this.byteLength(), pe = ce || Math.max(1, le);
        $(le <= pe, "byte array longer than desired length"), $(pe > 0, "Requested array length <= 0"), this.strip();
        var ye = oe === "le", Ce = new ne(pe), be, ae, ge = this.clone();
        if (ye) {
          for (ae = 0; !ge.isZero(); ae++)
            be = ge.andln(255), ge.iushrn(8), Ce[ae] = be;
          for (; ae < pe; ae++)
            Ce[ae] = 0;
        } else {
          for (ae = 0; ae < pe - le; ae++)
            Ce[ae] = 0;
          for (ae = 0; !ge.isZero(); ae++)
            be = ge.andln(255), ge.iushrn(8), Ce[pe - ae - 1] = be;
        }
        return Ce;
      }, Math.clz32 ? J.prototype._countBits = function(ne) {
        return 32 - Math.clz32(ne);
      } : J.prototype._countBits = function(ne) {
        var oe = ne, ce = 0;
        return oe >= 4096 && (ce += 13, oe >>>= 13), oe >= 64 && (ce += 7, oe >>>= 7), oe >= 8 && (ce += 4, oe >>>= 4), oe >= 2 && (ce += 2, oe >>>= 2), ce + oe;
      }, J.prototype._zeroBits = function(ne) {
        if (ne === 0) return 26;
        var oe = ne, ce = 0;
        return oe & 8191 || (ce += 13, oe >>>= 13), oe & 127 || (ce += 7, oe >>>= 7), oe & 15 || (ce += 4, oe >>>= 4), oe & 3 || (ce += 2, oe >>>= 2), oe & 1 || ce++, ce;
      }, J.prototype.bitLength = function() {
        var ne = this.words[this.length - 1], oe = this._countBits(ne);
        return (this.length - 1) * 26 + oe;
      };
      function fe(Ae) {
        for (var ne = new Array(Ae.bitLength()), oe = 0; oe < ne.length; oe++) {
          var ce = oe / 26 | 0, le = oe % 26;
          ne[oe] = (Ae.words[ce] & 1 << le) >>> le;
        }
        return ne;
      }
      J.prototype.zeroBits = function() {
        if (this.isZero()) return 0;
        for (var ne = 0, oe = 0; oe < this.length; oe++) {
          var ce = this._zeroBits(this.words[oe]);
          if (ne += ce, ce !== 26) break;
        }
        return ne;
      }, J.prototype.byteLength = function() {
        return Math.ceil(this.bitLength() / 8);
      }, J.prototype.toTwos = function(ne) {
        return this.negative !== 0 ? this.abs().inotn(ne).iaddn(1) : this.clone();
      }, J.prototype.fromTwos = function(ne) {
        return this.testn(ne - 1) ? this.notn(ne).iaddn(1).ineg() : this.clone();
      }, J.prototype.isNeg = function() {
        return this.negative !== 0;
      }, J.prototype.neg = function() {
        return this.clone().ineg();
      }, J.prototype.ineg = function() {
        return this.isZero() || (this.negative ^= 1), this;
      }, J.prototype.iuor = function(ne) {
        for (; this.length < ne.length; )
          this.words[this.length++] = 0;
        for (var oe = 0; oe < ne.length; oe++)
          this.words[oe] = this.words[oe] | ne.words[oe];
        return this.strip();
      }, J.prototype.ior = function(ne) {
        return $((this.negative | ne.negative) === 0), this.iuor(ne);
      }, J.prototype.or = function(ne) {
        return this.length > ne.length ? this.clone().ior(ne) : ne.clone().ior(this);
      }, J.prototype.uor = function(ne) {
        return this.length > ne.length ? this.clone().iuor(ne) : ne.clone().iuor(this);
      }, J.prototype.iuand = function(ne) {
        var oe;
        this.length > ne.length ? oe = ne : oe = this;
        for (var ce = 0; ce < oe.length; ce++)
          this.words[ce] = this.words[ce] & ne.words[ce];
        return this.length = oe.length, this.strip();
      }, J.prototype.iand = function(ne) {
        return $((this.negative | ne.negative) === 0), this.iuand(ne);
      }, J.prototype.and = function(ne) {
        return this.length > ne.length ? this.clone().iand(ne) : ne.clone().iand(this);
      }, J.prototype.uand = function(ne) {
        return this.length > ne.length ? this.clone().iuand(ne) : ne.clone().iuand(this);
      }, J.prototype.iuxor = function(ne) {
        var oe, ce;
        this.length > ne.length ? (oe = this, ce = ne) : (oe = ne, ce = this);
        for (var le = 0; le < ce.length; le++)
          this.words[le] = oe.words[le] ^ ce.words[le];
        if (this !== oe)
          for (; le < oe.length; le++)
            this.words[le] = oe.words[le];
        return this.length = oe.length, this.strip();
      }, J.prototype.ixor = function(ne) {
        return $((this.negative | ne.negative) === 0), this.iuxor(ne);
      }, J.prototype.xor = function(ne) {
        return this.length > ne.length ? this.clone().ixor(ne) : ne.clone().ixor(this);
      }, J.prototype.uxor = function(ne) {
        return this.length > ne.length ? this.clone().iuxor(ne) : ne.clone().iuxor(this);
      }, J.prototype.inotn = function(ne) {
        $(typeof ne == "number" && ne >= 0);
        var oe = Math.ceil(ne / 26) | 0, ce = ne % 26;
        this._expand(oe), ce > 0 && oe--;
        for (var le = 0; le < oe; le++)
          this.words[le] = ~this.words[le] & 67108863;
        return ce > 0 && (this.words[le] = ~this.words[le] & 67108863 >> 26 - ce), this.strip();
      }, J.prototype.notn = function(ne) {
        return this.clone().inotn(ne);
      }, J.prototype.setn = function(ne, oe) {
        $(typeof ne == "number" && ne >= 0);
        var ce = ne / 26 | 0, le = ne % 26;
        return this._expand(ce + 1), oe ? this.words[ce] = this.words[ce] | 1 << le : this.words[ce] = this.words[ce] & ~(1 << le), this.strip();
      }, J.prototype.iadd = function(ne) {
        var oe;
        if (this.negative !== 0 && ne.negative === 0)
          return this.negative = 0, oe = this.isub(ne), this.negative ^= 1, this._normSign();
        if (this.negative === 0 && ne.negative !== 0)
          return ne.negative = 0, oe = this.isub(ne), ne.negative = 1, oe._normSign();
        var ce, le;
        this.length > ne.length ? (ce = this, le = ne) : (ce = ne, le = this);
        for (var pe = 0, ye = 0; ye < le.length; ye++)
          oe = (ce.words[ye] | 0) + (le.words[ye] | 0) + pe, this.words[ye] = oe & 67108863, pe = oe >>> 26;
        for (; pe !== 0 && ye < ce.length; ye++)
          oe = (ce.words[ye] | 0) + pe, this.words[ye] = oe & 67108863, pe = oe >>> 26;
        if (this.length = ce.length, pe !== 0)
          this.words[this.length] = pe, this.length++;
        else if (ce !== this)
          for (; ye < ce.length; ye++)
            this.words[ye] = ce.words[ye];
        return this;
      }, J.prototype.add = function(ne) {
        var oe;
        return ne.negative !== 0 && this.negative === 0 ? (ne.negative = 0, oe = this.sub(ne), ne.negative ^= 1, oe) : ne.negative === 0 && this.negative !== 0 ? (this.negative = 0, oe = ne.sub(this), this.negative = 1, oe) : this.length > ne.length ? this.clone().iadd(ne) : ne.clone().iadd(this);
      }, J.prototype.isub = function(ne) {
        if (ne.negative !== 0) {
          ne.negative = 0;
          var oe = this.iadd(ne);
          return ne.negative = 1, oe._normSign();
        } else if (this.negative !== 0)
          return this.negative = 0, this.iadd(ne), this.negative = 1, this._normSign();
        var ce = this.cmp(ne);
        if (ce === 0)
          return this.negative = 0, this.length = 1, this.words[0] = 0, this;
        var le, pe;
        ce > 0 ? (le = this, pe = ne) : (le = ne, pe = this);
        for (var ye = 0, Ce = 0; Ce < pe.length; Ce++)
          oe = (le.words[Ce] | 0) - (pe.words[Ce] | 0) + ye, ye = oe >> 26, this.words[Ce] = oe & 67108863;
        for (; ye !== 0 && Ce < le.length; Ce++)
          oe = (le.words[Ce] | 0) + ye, ye = oe >> 26, this.words[Ce] = oe & 67108863;
        if (ye === 0 && Ce < le.length && le !== this)
          for (; Ce < le.length; Ce++)
            this.words[Ce] = le.words[Ce];
        return this.length = Math.max(this.length, Ce), le !== this && (this.negative = 1), this.strip();
      }, J.prototype.sub = function(ne) {
        return this.clone().isub(ne);
      };
      function he(Ae, ne, oe) {
        oe.negative = ne.negative ^ Ae.negative;
        var ce = Ae.length + ne.length | 0;
        oe.length = ce, ce = ce - 1 | 0;
        var le = Ae.words[0] | 0, pe = ne.words[0] | 0, ye = le * pe, Ce = ye & 67108863, be = ye / 67108864 | 0;
        oe.words[0] = Ce;
        for (var ae = 1; ae < ce; ae++) {
          for (var ge = be >>> 26, Se = be & 67108863, Le = Math.min(ae, ne.length - 1), ze = Math.max(0, ae - Ae.length + 1); ze <= Le; ze++) {
            var Re = ae - ze | 0;
            le = Ae.words[Re] | 0, pe = ne.words[ze] | 0, ye = le * pe + Se, ge += ye / 67108864 | 0, Se = ye & 67108863;
          }
          oe.words[ae] = Se | 0, be = ge | 0;
        }
        return be !== 0 ? oe.words[ae] = be | 0 : oe.length--, oe.strip();
      }
      var me = function(ne, oe, ce) {
        var le = ne.words, pe = oe.words, ye = ce.words, Ce = 0, be, ae, ge, Se = le[0] | 0, Le = Se & 8191, ze = Se >>> 13, Re = le[1] | 0, We = Re & 8191, Be = Re >>> 13, Ue = le[2] | 0, Ge = Ue & 8191, je = Ue >>> 13, Oe = le[3] | 0, Ne = Oe & 8191, Ye = Oe >>> 13, Je = le[4] | 0, Xe = Je & 8191, st = Je >>> 13, ct = le[5] | 0, it = ct & 8191, ot = ct >>> 13, yt = le[6] | 0, dt = yt & 8191, mt = yt >>> 13, It = le[7] | 0, xt = It & 8191, Tt = It >>> 13, Yt = le[8] | 0, Ve = Yt & 8191, Pe = Yt >>> 13, $e = le[9] | 0, Ze = $e & 8191, at = $e >>> 13, wt = pe[0] | 0, ft = wt & 8191, Ct = wt >>> 13, Ut = pe[1] | 0, vt = Ut & 8191, Mt = Ut >>> 13, Xt = pe[2] | 0, St = Xt & 8191, Ot = Xt >>> 13, wn = pe[3] | 0, kt = wn & 8191, Bt = wn >>> 13, Tn = pe[4] | 0, Nt = Tn & 8191, Wt = Tn >>> 13, En = pe[5] | 0, Lt = En & 8191, Ht = En >>> 13, In = pe[6] | 0, Dt = In & 8191, Gt = In >>> 13, Ke = pe[7] | 0, Qe = Ke & 8191, et = Ke >>> 13, He = pe[8] | 0, nt = He & 8191, qe = He >>> 13, ht = pe[9] | 0, pt = ht & 8191, bt = ht >>> 13;
        ce.negative = ne.negative ^ oe.negative, ce.length = 19, be = Math.imul(Le, ft), ae = Math.imul(Le, Ct), ae = ae + Math.imul(ze, ft) | 0, ge = Math.imul(ze, Ct);
        var jt = (Ce + be | 0) + ((ae & 8191) << 13) | 0;
        Ce = (ge + (ae >>> 13) | 0) + (jt >>> 26) | 0, jt &= 67108863, be = Math.imul(We, ft), ae = Math.imul(We, Ct), ae = ae + Math.imul(Be, ft) | 0, ge = Math.imul(Be, Ct), be = be + Math.imul(Le, vt) | 0, ae = ae + Math.imul(Le, Mt) | 0, ae = ae + Math.imul(ze, vt) | 0, ge = ge + Math.imul(ze, Mt) | 0;
        var $t = (Ce + be | 0) + ((ae & 8191) << 13) | 0;
        Ce = (ge + (ae >>> 13) | 0) + ($t >>> 26) | 0, $t &= 67108863, be = Math.imul(Ge, ft), ae = Math.imul(Ge, Ct), ae = ae + Math.imul(je, ft) | 0, ge = Math.imul(je, Ct), be = be + Math.imul(We, vt) | 0, ae = ae + Math.imul(We, Mt) | 0, ae = ae + Math.imul(Be, vt) | 0, ge = ge + Math.imul(Be, Mt) | 0, be = be + Math.imul(Le, St) | 0, ae = ae + Math.imul(Le, Ot) | 0, ae = ae + Math.imul(ze, St) | 0, ge = ge + Math.imul(ze, Ot) | 0;
        var Jt = (Ce + be | 0) + ((ae & 8191) << 13) | 0;
        Ce = (ge + (ae >>> 13) | 0) + (Jt >>> 26) | 0, Jt &= 67108863, be = Math.imul(Ne, ft), ae = Math.imul(Ne, Ct), ae = ae + Math.imul(Ye, ft) | 0, ge = Math.imul(Ye, Ct), be = be + Math.imul(Ge, vt) | 0, ae = ae + Math.imul(Ge, Mt) | 0, ae = ae + Math.imul(je, vt) | 0, ge = ge + Math.imul(je, Mt) | 0, be = be + Math.imul(We, St) | 0, ae = ae + Math.imul(We, Ot) | 0, ae = ae + Math.imul(Be, St) | 0, ge = ge + Math.imul(Be, Ot) | 0, be = be + Math.imul(Le, kt) | 0, ae = ae + Math.imul(Le, Bt) | 0, ae = ae + Math.imul(ze, kt) | 0, ge = ge + Math.imul(ze, Bt) | 0;
        var zt = (Ce + be | 0) + ((ae & 8191) << 13) | 0;
        Ce = (ge + (ae >>> 13) | 0) + (zt >>> 26) | 0, zt &= 67108863, be = Math.imul(Xe, ft), ae = Math.imul(Xe, Ct), ae = ae + Math.imul(st, ft) | 0, ge = Math.imul(st, Ct), be = be + Math.imul(Ne, vt) | 0, ae = ae + Math.imul(Ne, Mt) | 0, ae = ae + Math.imul(Ye, vt) | 0, ge = ge + Math.imul(Ye, Mt) | 0, be = be + Math.imul(Ge, St) | 0, ae = ae + Math.imul(Ge, Ot) | 0, ae = ae + Math.imul(je, St) | 0, ge = ge + Math.imul(je, Ot) | 0, be = be + Math.imul(We, kt) | 0, ae = ae + Math.imul(We, Bt) | 0, ae = ae + Math.imul(Be, kt) | 0, ge = ge + Math.imul(Be, Bt) | 0, be = be + Math.imul(Le, Nt) | 0, ae = ae + Math.imul(Le, Wt) | 0, ae = ae + Math.imul(ze, Nt) | 0, ge = ge + Math.imul(ze, Wt) | 0;
        var Vt = (Ce + be | 0) + ((ae & 8191) << 13) | 0;
        Ce = (ge + (ae >>> 13) | 0) + (Vt >>> 26) | 0, Vt &= 67108863, be = Math.imul(it, ft), ae = Math.imul(it, Ct), ae = ae + Math.imul(ot, ft) | 0, ge = Math.imul(ot, Ct), be = be + Math.imul(Xe, vt) | 0, ae = ae + Math.imul(Xe, Mt) | 0, ae = ae + Math.imul(st, vt) | 0, ge = ge + Math.imul(st, Mt) | 0, be = be + Math.imul(Ne, St) | 0, ae = ae + Math.imul(Ne, Ot) | 0, ae = ae + Math.imul(Ye, St) | 0, ge = ge + Math.imul(Ye, Ot) | 0, be = be + Math.imul(Ge, kt) | 0, ae = ae + Math.imul(Ge, Bt) | 0, ae = ae + Math.imul(je, kt) | 0, ge = ge + Math.imul(je, Bt) | 0, be = be + Math.imul(We, Nt) | 0, ae = ae + Math.imul(We, Wt) | 0, ae = ae + Math.imul(Be, Nt) | 0, ge = ge + Math.imul(Be, Wt) | 0, be = be + Math.imul(Le, Lt) | 0, ae = ae + Math.imul(Le, Ht) | 0, ae = ae + Math.imul(ze, Lt) | 0, ge = ge + Math.imul(ze, Ht) | 0;
        var Kt = (Ce + be | 0) + ((ae & 8191) << 13) | 0;
        Ce = (ge + (ae >>> 13) | 0) + (Kt >>> 26) | 0, Kt &= 67108863, be = Math.imul(dt, ft), ae = Math.imul(dt, Ct), ae = ae + Math.imul(mt, ft) | 0, ge = Math.imul(mt, Ct), be = be + Math.imul(it, vt) | 0, ae = ae + Math.imul(it, Mt) | 0, ae = ae + Math.imul(ot, vt) | 0, ge = ge + Math.imul(ot, Mt) | 0, be = be + Math.imul(Xe, St) | 0, ae = ae + Math.imul(Xe, Ot) | 0, ae = ae + Math.imul(st, St) | 0, ge = ge + Math.imul(st, Ot) | 0, be = be + Math.imul(Ne, kt) | 0, ae = ae + Math.imul(Ne, Bt) | 0, ae = ae + Math.imul(Ye, kt) | 0, ge = ge + Math.imul(Ye, Bt) | 0, be = be + Math.imul(Ge, Nt) | 0, ae = ae + Math.imul(Ge, Wt) | 0, ae = ae + Math.imul(je, Nt) | 0, ge = ge + Math.imul(je, Wt) | 0, be = be + Math.imul(We, Lt) | 0, ae = ae + Math.imul(We, Ht) | 0, ae = ae + Math.imul(Be, Lt) | 0, ge = ge + Math.imul(Be, Ht) | 0, be = be + Math.imul(Le, Dt) | 0, ae = ae + Math.imul(Le, Gt) | 0, ae = ae + Math.imul(ze, Dt) | 0, ge = ge + Math.imul(ze, Gt) | 0;
        var pn = (Ce + be | 0) + ((ae & 8191) << 13) | 0;
        Ce = (ge + (ae >>> 13) | 0) + (pn >>> 26) | 0, pn &= 67108863, be = Math.imul(xt, ft), ae = Math.imul(xt, Ct), ae = ae + Math.imul(Tt, ft) | 0, ge = Math.imul(Tt, Ct), be = be + Math.imul(dt, vt) | 0, ae = ae + Math.imul(dt, Mt) | 0, ae = ae + Math.imul(mt, vt) | 0, ge = ge + Math.imul(mt, Mt) | 0, be = be + Math.imul(it, St) | 0, ae = ae + Math.imul(it, Ot) | 0, ae = ae + Math.imul(ot, St) | 0, ge = ge + Math.imul(ot, Ot) | 0, be = be + Math.imul(Xe, kt) | 0, ae = ae + Math.imul(Xe, Bt) | 0, ae = ae + Math.imul(st, kt) | 0, ge = ge + Math.imul(st, Bt) | 0, be = be + Math.imul(Ne, Nt) | 0, ae = ae + Math.imul(Ne, Wt) | 0, ae = ae + Math.imul(Ye, Nt) | 0, ge = ge + Math.imul(Ye, Wt) | 0, be = be + Math.imul(Ge, Lt) | 0, ae = ae + Math.imul(Ge, Ht) | 0, ae = ae + Math.imul(je, Lt) | 0, ge = ge + Math.imul(je, Ht) | 0, be = be + Math.imul(We, Dt) | 0, ae = ae + Math.imul(We, Gt) | 0, ae = ae + Math.imul(Be, Dt) | 0, ge = ge + Math.imul(Be, Gt) | 0, be = be + Math.imul(Le, Qe) | 0, ae = ae + Math.imul(Le, et) | 0, ae = ae + Math.imul(ze, Qe) | 0, ge = ge + Math.imul(ze, et) | 0;
        var An = (Ce + be | 0) + ((ae & 8191) << 13) | 0;
        Ce = (ge + (ae >>> 13) | 0) + (An >>> 26) | 0, An &= 67108863, be = Math.imul(Ve, ft), ae = Math.imul(Ve, Ct), ae = ae + Math.imul(Pe, ft) | 0, ge = Math.imul(Pe, Ct), be = be + Math.imul(xt, vt) | 0, ae = ae + Math.imul(xt, Mt) | 0, ae = ae + Math.imul(Tt, vt) | 0, ge = ge + Math.imul(Tt, Mt) | 0, be = be + Math.imul(dt, St) | 0, ae = ae + Math.imul(dt, Ot) | 0, ae = ae + Math.imul(mt, St) | 0, ge = ge + Math.imul(mt, Ot) | 0, be = be + Math.imul(it, kt) | 0, ae = ae + Math.imul(it, Bt) | 0, ae = ae + Math.imul(ot, kt) | 0, ge = ge + Math.imul(ot, Bt) | 0, be = be + Math.imul(Xe, Nt) | 0, ae = ae + Math.imul(Xe, Wt) | 0, ae = ae + Math.imul(st, Nt) | 0, ge = ge + Math.imul(st, Wt) | 0, be = be + Math.imul(Ne, Lt) | 0, ae = ae + Math.imul(Ne, Ht) | 0, ae = ae + Math.imul(Ye, Lt) | 0, ge = ge + Math.imul(Ye, Ht) | 0, be = be + Math.imul(Ge, Dt) | 0, ae = ae + Math.imul(Ge, Gt) | 0, ae = ae + Math.imul(je, Dt) | 0, ge = ge + Math.imul(je, Gt) | 0, be = be + Math.imul(We, Qe) | 0, ae = ae + Math.imul(We, et) | 0, ae = ae + Math.imul(Be, Qe) | 0, ge = ge + Math.imul(Be, et) | 0, be = be + Math.imul(Le, nt) | 0, ae = ae + Math.imul(Le, qe) | 0, ae = ae + Math.imul(ze, nt) | 0, ge = ge + Math.imul(ze, qe) | 0;
        var vn = (Ce + be | 0) + ((ae & 8191) << 13) | 0;
        Ce = (ge + (ae >>> 13) | 0) + (vn >>> 26) | 0, vn &= 67108863, be = Math.imul(Ze, ft), ae = Math.imul(Ze, Ct), ae = ae + Math.imul(at, ft) | 0, ge = Math.imul(at, Ct), be = be + Math.imul(Ve, vt) | 0, ae = ae + Math.imul(Ve, Mt) | 0, ae = ae + Math.imul(Pe, vt) | 0, ge = ge + Math.imul(Pe, Mt) | 0, be = be + Math.imul(xt, St) | 0, ae = ae + Math.imul(xt, Ot) | 0, ae = ae + Math.imul(Tt, St) | 0, ge = ge + Math.imul(Tt, Ot) | 0, be = be + Math.imul(dt, kt) | 0, ae = ae + Math.imul(dt, Bt) | 0, ae = ae + Math.imul(mt, kt) | 0, ge = ge + Math.imul(mt, Bt) | 0, be = be + Math.imul(it, Nt) | 0, ae = ae + Math.imul(it, Wt) | 0, ae = ae + Math.imul(ot, Nt) | 0, ge = ge + Math.imul(ot, Wt) | 0, be = be + Math.imul(Xe, Lt) | 0, ae = ae + Math.imul(Xe, Ht) | 0, ae = ae + Math.imul(st, Lt) | 0, ge = ge + Math.imul(st, Ht) | 0, be = be + Math.imul(Ne, Dt) | 0, ae = ae + Math.imul(Ne, Gt) | 0, ae = ae + Math.imul(Ye, Dt) | 0, ge = ge + Math.imul(Ye, Gt) | 0, be = be + Math.imul(Ge, Qe) | 0, ae = ae + Math.imul(Ge, et) | 0, ae = ae + Math.imul(je, Qe) | 0, ge = ge + Math.imul(je, et) | 0, be = be + Math.imul(We, nt) | 0, ae = ae + Math.imul(We, qe) | 0, ae = ae + Math.imul(Be, nt) | 0, ge = ge + Math.imul(Be, qe) | 0, be = be + Math.imul(Le, pt) | 0, ae = ae + Math.imul(Le, bt) | 0, ae = ae + Math.imul(ze, pt) | 0, ge = ge + Math.imul(ze, bt) | 0;
        var Cn = (Ce + be | 0) + ((ae & 8191) << 13) | 0;
        Ce = (ge + (ae >>> 13) | 0) + (Cn >>> 26) | 0, Cn &= 67108863, be = Math.imul(Ze, vt), ae = Math.imul(Ze, Mt), ae = ae + Math.imul(at, vt) | 0, ge = Math.imul(at, Mt), be = be + Math.imul(Ve, St) | 0, ae = ae + Math.imul(Ve, Ot) | 0, ae = ae + Math.imul(Pe, St) | 0, ge = ge + Math.imul(Pe, Ot) | 0, be = be + Math.imul(xt, kt) | 0, ae = ae + Math.imul(xt, Bt) | 0, ae = ae + Math.imul(Tt, kt) | 0, ge = ge + Math.imul(Tt, Bt) | 0, be = be + Math.imul(dt, Nt) | 0, ae = ae + Math.imul(dt, Wt) | 0, ae = ae + Math.imul(mt, Nt) | 0, ge = ge + Math.imul(mt, Wt) | 0, be = be + Math.imul(it, Lt) | 0, ae = ae + Math.imul(it, Ht) | 0, ae = ae + Math.imul(ot, Lt) | 0, ge = ge + Math.imul(ot, Ht) | 0, be = be + Math.imul(Xe, Dt) | 0, ae = ae + Math.imul(Xe, Gt) | 0, ae = ae + Math.imul(st, Dt) | 0, ge = ge + Math.imul(st, Gt) | 0, be = be + Math.imul(Ne, Qe) | 0, ae = ae + Math.imul(Ne, et) | 0, ae = ae + Math.imul(Ye, Qe) | 0, ge = ge + Math.imul(Ye, et) | 0, be = be + Math.imul(Ge, nt) | 0, ae = ae + Math.imul(Ge, qe) | 0, ae = ae + Math.imul(je, nt) | 0, ge = ge + Math.imul(je, qe) | 0, be = be + Math.imul(We, pt) | 0, ae = ae + Math.imul(We, bt) | 0, ae = ae + Math.imul(Be, pt) | 0, ge = ge + Math.imul(Be, bt) | 0;
        var yn = (Ce + be | 0) + ((ae & 8191) << 13) | 0;
        Ce = (ge + (ae >>> 13) | 0) + (yn >>> 26) | 0, yn &= 67108863, be = Math.imul(Ze, St), ae = Math.imul(Ze, Ot), ae = ae + Math.imul(at, St) | 0, ge = Math.imul(at, Ot), be = be + Math.imul(Ve, kt) | 0, ae = ae + Math.imul(Ve, Bt) | 0, ae = ae + Math.imul(Pe, kt) | 0, ge = ge + Math.imul(Pe, Bt) | 0, be = be + Math.imul(xt, Nt) | 0, ae = ae + Math.imul(xt, Wt) | 0, ae = ae + Math.imul(Tt, Nt) | 0, ge = ge + Math.imul(Tt, Wt) | 0, be = be + Math.imul(dt, Lt) | 0, ae = ae + Math.imul(dt, Ht) | 0, ae = ae + Math.imul(mt, Lt) | 0, ge = ge + Math.imul(mt, Ht) | 0, be = be + Math.imul(it, Dt) | 0, ae = ae + Math.imul(it, Gt) | 0, ae = ae + Math.imul(ot, Dt) | 0, ge = ge + Math.imul(ot, Gt) | 0, be = be + Math.imul(Xe, Qe) | 0, ae = ae + Math.imul(Xe, et) | 0, ae = ae + Math.imul(st, Qe) | 0, ge = ge + Math.imul(st, et) | 0, be = be + Math.imul(Ne, nt) | 0, ae = ae + Math.imul(Ne, qe) | 0, ae = ae + Math.imul(Ye, nt) | 0, ge = ge + Math.imul(Ye, qe) | 0, be = be + Math.imul(Ge, pt) | 0, ae = ae + Math.imul(Ge, bt) | 0, ae = ae + Math.imul(je, pt) | 0, ge = ge + Math.imul(je, bt) | 0;
        var dn = (Ce + be | 0) + ((ae & 8191) << 13) | 0;
        Ce = (ge + (ae >>> 13) | 0) + (dn >>> 26) | 0, dn &= 67108863, be = Math.imul(Ze, kt), ae = Math.imul(Ze, Bt), ae = ae + Math.imul(at, kt) | 0, ge = Math.imul(at, Bt), be = be + Math.imul(Ve, Nt) | 0, ae = ae + Math.imul(Ve, Wt) | 0, ae = ae + Math.imul(Pe, Nt) | 0, ge = ge + Math.imul(Pe, Wt) | 0, be = be + Math.imul(xt, Lt) | 0, ae = ae + Math.imul(xt, Ht) | 0, ae = ae + Math.imul(Tt, Lt) | 0, ge = ge + Math.imul(Tt, Ht) | 0, be = be + Math.imul(dt, Dt) | 0, ae = ae + Math.imul(dt, Gt) | 0, ae = ae + Math.imul(mt, Dt) | 0, ge = ge + Math.imul(mt, Gt) | 0, be = be + Math.imul(it, Qe) | 0, ae = ae + Math.imul(it, et) | 0, ae = ae + Math.imul(ot, Qe) | 0, ge = ge + Math.imul(ot, et) | 0, be = be + Math.imul(Xe, nt) | 0, ae = ae + Math.imul(Xe, qe) | 0, ae = ae + Math.imul(st, nt) | 0, ge = ge + Math.imul(st, qe) | 0, be = be + Math.imul(Ne, pt) | 0, ae = ae + Math.imul(Ne, bt) | 0, ae = ae + Math.imul(Ye, pt) | 0, ge = ge + Math.imul(Ye, bt) | 0;
        var xn = (Ce + be | 0) + ((ae & 8191) << 13) | 0;
        Ce = (ge + (ae >>> 13) | 0) + (xn >>> 26) | 0, xn &= 67108863, be = Math.imul(Ze, Nt), ae = Math.imul(Ze, Wt), ae = ae + Math.imul(at, Nt) | 0, ge = Math.imul(at, Wt), be = be + Math.imul(Ve, Lt) | 0, ae = ae + Math.imul(Ve, Ht) | 0, ae = ae + Math.imul(Pe, Lt) | 0, ge = ge + Math.imul(Pe, Ht) | 0, be = be + Math.imul(xt, Dt) | 0, ae = ae + Math.imul(xt, Gt) | 0, ae = ae + Math.imul(Tt, Dt) | 0, ge = ge + Math.imul(Tt, Gt) | 0, be = be + Math.imul(dt, Qe) | 0, ae = ae + Math.imul(dt, et) | 0, ae = ae + Math.imul(mt, Qe) | 0, ge = ge + Math.imul(mt, et) | 0, be = be + Math.imul(it, nt) | 0, ae = ae + Math.imul(it, qe) | 0, ae = ae + Math.imul(ot, nt) | 0, ge = ge + Math.imul(ot, qe) | 0, be = be + Math.imul(Xe, pt) | 0, ae = ae + Math.imul(Xe, bt) | 0, ae = ae + Math.imul(st, pt) | 0, ge = ge + Math.imul(st, bt) | 0;
        var ln = (Ce + be | 0) + ((ae & 8191) << 13) | 0;
        Ce = (ge + (ae >>> 13) | 0) + (ln >>> 26) | 0, ln &= 67108863, be = Math.imul(Ze, Lt), ae = Math.imul(Ze, Ht), ae = ae + Math.imul(at, Lt) | 0, ge = Math.imul(at, Ht), be = be + Math.imul(Ve, Dt) | 0, ae = ae + Math.imul(Ve, Gt) | 0, ae = ae + Math.imul(Pe, Dt) | 0, ge = ge + Math.imul(Pe, Gt) | 0, be = be + Math.imul(xt, Qe) | 0, ae = ae + Math.imul(xt, et) | 0, ae = ae + Math.imul(Tt, Qe) | 0, ge = ge + Math.imul(Tt, et) | 0, be = be + Math.imul(dt, nt) | 0, ae = ae + Math.imul(dt, qe) | 0, ae = ae + Math.imul(mt, nt) | 0, ge = ge + Math.imul(mt, qe) | 0, be = be + Math.imul(it, pt) | 0, ae = ae + Math.imul(it, bt) | 0, ae = ae + Math.imul(ot, pt) | 0, ge = ge + Math.imul(ot, bt) | 0;
        var mn = (Ce + be | 0) + ((ae & 8191) << 13) | 0;
        Ce = (ge + (ae >>> 13) | 0) + (mn >>> 26) | 0, mn &= 67108863, be = Math.imul(Ze, Dt), ae = Math.imul(Ze, Gt), ae = ae + Math.imul(at, Dt) | 0, ge = Math.imul(at, Gt), be = be + Math.imul(Ve, Qe) | 0, ae = ae + Math.imul(Ve, et) | 0, ae = ae + Math.imul(Pe, Qe) | 0, ge = ge + Math.imul(Pe, et) | 0, be = be + Math.imul(xt, nt) | 0, ae = ae + Math.imul(xt, qe) | 0, ae = ae + Math.imul(Tt, nt) | 0, ge = ge + Math.imul(Tt, qe) | 0, be = be + Math.imul(dt, pt) | 0, ae = ae + Math.imul(dt, bt) | 0, ae = ae + Math.imul(mt, pt) | 0, ge = ge + Math.imul(mt, bt) | 0;
        var gn = (Ce + be | 0) + ((ae & 8191) << 13) | 0;
        Ce = (ge + (ae >>> 13) | 0) + (gn >>> 26) | 0, gn &= 67108863, be = Math.imul(Ze, Qe), ae = Math.imul(Ze, et), ae = ae + Math.imul(at, Qe) | 0, ge = Math.imul(at, et), be = be + Math.imul(Ve, nt) | 0, ae = ae + Math.imul(Ve, qe) | 0, ae = ae + Math.imul(Pe, nt) | 0, ge = ge + Math.imul(Pe, qe) | 0, be = be + Math.imul(xt, pt) | 0, ae = ae + Math.imul(xt, bt) | 0, ae = ae + Math.imul(Tt, pt) | 0, ge = ge + Math.imul(Tt, bt) | 0;
        var cn = (Ce + be | 0) + ((ae & 8191) << 13) | 0;
        Ce = (ge + (ae >>> 13) | 0) + (cn >>> 26) | 0, cn &= 67108863, be = Math.imul(Ze, nt), ae = Math.imul(Ze, qe), ae = ae + Math.imul(at, nt) | 0, ge = Math.imul(at, qe), be = be + Math.imul(Ve, pt) | 0, ae = ae + Math.imul(Ve, bt) | 0, ae = ae + Math.imul(Pe, pt) | 0, ge = ge + Math.imul(Pe, bt) | 0;
        var Pt = (Ce + be | 0) + ((ae & 8191) << 13) | 0;
        Ce = (ge + (ae >>> 13) | 0) + (Pt >>> 26) | 0, Pt &= 67108863, be = Math.imul(Ze, pt), ae = Math.imul(Ze, bt), ae = ae + Math.imul(at, pt) | 0, ge = Math.imul(at, bt);
        var Rt = (Ce + be | 0) + ((ae & 8191) << 13) | 0;
        return Ce = (ge + (ae >>> 13) | 0) + (Rt >>> 26) | 0, Rt &= 67108863, ye[0] = jt, ye[1] = $t, ye[2] = Jt, ye[3] = zt, ye[4] = Vt, ye[5] = Kt, ye[6] = pn, ye[7] = An, ye[8] = vn, ye[9] = Cn, ye[10] = yn, ye[11] = dn, ye[12] = xn, ye[13] = ln, ye[14] = mn, ye[15] = gn, ye[16] = cn, ye[17] = Pt, ye[18] = Rt, Ce !== 0 && (ye[19] = Ce, ce.length++), ce;
      };
      Math.imul || (me = he);
      function xe(Ae, ne, oe) {
        oe.negative = ne.negative ^ Ae.negative, oe.length = Ae.length + ne.length;
        for (var ce = 0, le = 0, pe = 0; pe < oe.length - 1; pe++) {
          var ye = le;
          le = 0;
          for (var Ce = ce & 67108863, be = Math.min(pe, ne.length - 1), ae = Math.max(0, pe - Ae.length + 1); ae <= be; ae++) {
            var ge = pe - ae, Se = Ae.words[ge] | 0, Le = ne.words[ae] | 0, ze = Se * Le, Re = ze & 67108863;
            ye = ye + (ze / 67108864 | 0) | 0, Re = Re + Ce | 0, Ce = Re & 67108863, ye = ye + (Re >>> 26) | 0, le += ye >>> 26, ye &= 67108863;
          }
          oe.words[pe] = Ce, ce = ye, ye = le;
        }
        return ce !== 0 ? oe.words[pe] = ce : oe.length--, oe.strip();
      }
      function ve(Ae, ne, oe) {
        var ce = new Te();
        return ce.mulp(Ae, ne, oe);
      }
      J.prototype.mulTo = function(ne, oe) {
        var ce, le = this.length + ne.length;
        return this.length === 10 && ne.length === 10 ? ce = me(this, ne, oe) : le < 63 ? ce = he(this, ne, oe) : le < 1024 ? ce = xe(this, ne, oe) : ce = ve(this, ne, oe), ce;
      };
      function Te(Ae, ne) {
        this.x = Ae, this.y = ne;
      }
      Te.prototype.makeRBT = function(ne) {
        for (var oe = new Array(ne), ce = J.prototype._countBits(ne) - 1, le = 0; le < ne; le++)
          oe[le] = this.revBin(le, ce, ne);
        return oe;
      }, Te.prototype.revBin = function(ne, oe, ce) {
        if (ne === 0 || ne === ce - 1) return ne;
        for (var le = 0, pe = 0; pe < oe; pe++)
          le |= (ne & 1) << oe - pe - 1, ne >>= 1;
        return le;
      }, Te.prototype.permute = function(ne, oe, ce, le, pe, ye) {
        for (var Ce = 0; Ce < ye; Ce++)
          le[Ce] = oe[ne[Ce]], pe[Ce] = ce[ne[Ce]];
      }, Te.prototype.transform = function(ne, oe, ce, le, pe, ye) {
        this.permute(ye, ne, oe, ce, le, pe);
        for (var Ce = 1; Ce < pe; Ce <<= 1)
          for (var be = Ce << 1, ae = Math.cos(2 * Math.PI / be), ge = Math.sin(2 * Math.PI / be), Se = 0; Se < pe; Se += be)
            for (var Le = ae, ze = ge, Re = 0; Re < Ce; Re++) {
              var We = ce[Se + Re], Be = le[Se + Re], Ue = ce[Se + Re + Ce], Ge = le[Se + Re + Ce], je = Le * Ue - ze * Ge;
              Ge = Le * Ge + ze * Ue, Ue = je, ce[Se + Re] = We + Ue, le[Se + Re] = Be + Ge, ce[Se + Re + Ce] = We - Ue, le[Se + Re + Ce] = Be - Ge, Re !== be && (je = ae * Le - ge * ze, ze = ae * ze + ge * Le, Le = je);
            }
      }, Te.prototype.guessLen13b = function(ne, oe) {
        var ce = Math.max(oe, ne) | 1, le = ce & 1, pe = 0;
        for (ce = ce / 2 | 0; ce; ce = ce >>> 1)
          pe++;
        return 1 << pe + 1 + le;
      }, Te.prototype.conjugate = function(ne, oe, ce) {
        if (!(ce <= 1))
          for (var le = 0; le < ce / 2; le++) {
            var pe = ne[le];
            ne[le] = ne[ce - le - 1], ne[ce - le - 1] = pe, pe = oe[le], oe[le] = -oe[ce - le - 1], oe[ce - le - 1] = -pe;
          }
      }, Te.prototype.normalize13b = function(ne, oe) {
        for (var ce = 0, le = 0; le < oe / 2; le++) {
          var pe = Math.round(ne[2 * le + 1] / oe) * 8192 + Math.round(ne[2 * le] / oe) + ce;
          ne[le] = pe & 67108863, pe < 67108864 ? ce = 0 : ce = pe / 67108864 | 0;
        }
        return ne;
      }, Te.prototype.convert13b = function(ne, oe, ce, le) {
        for (var pe = 0, ye = 0; ye < oe; ye++)
          pe = pe + (ne[ye] | 0), ce[2 * ye] = pe & 8191, pe = pe >>> 13, ce[2 * ye + 1] = pe & 8191, pe = pe >>> 13;
        for (ye = 2 * oe; ye < le; ++ye)
          ce[ye] = 0;
        $(pe === 0), $((pe & -8192) === 0);
      }, Te.prototype.stub = function(ne) {
        for (var oe = new Array(ne), ce = 0; ce < ne; ce++)
          oe[ce] = 0;
        return oe;
      }, Te.prototype.mulp = function(ne, oe, ce) {
        var le = 2 * this.guessLen13b(ne.length, oe.length), pe = this.makeRBT(le), ye = this.stub(le), Ce = new Array(le), be = new Array(le), ae = new Array(le), ge = new Array(le), Se = new Array(le), Le = new Array(le), ze = ce.words;
        ze.length = le, this.convert13b(ne.words, ne.length, Ce, le), this.convert13b(oe.words, oe.length, ge, le), this.transform(Ce, ye, be, ae, le, pe), this.transform(ge, ye, Se, Le, le, pe);
        for (var Re = 0; Re < le; Re++) {
          var We = be[Re] * Se[Re] - ae[Re] * Le[Re];
          ae[Re] = be[Re] * Le[Re] + ae[Re] * Se[Re], be[Re] = We;
        }
        return this.conjugate(be, ae, le), this.transform(be, ae, ze, ye, le, pe), this.conjugate(ze, ye, le), this.normalize13b(ze, le), ce.negative = ne.negative ^ oe.negative, ce.length = ne.length + oe.length, ce.strip();
      }, J.prototype.mul = function(ne) {
        var oe = new J(null);
        return oe.words = new Array(this.length + ne.length), this.mulTo(ne, oe);
      }, J.prototype.mulf = function(ne) {
        var oe = new J(null);
        return oe.words = new Array(this.length + ne.length), ve(this, ne, oe);
      }, J.prototype.imul = function(ne) {
        return this.clone().mulTo(ne, this);
      }, J.prototype.imuln = function(ne) {
        $(typeof ne == "number"), $(ne < 67108864);
        for (var oe = 0, ce = 0; ce < this.length; ce++) {
          var le = (this.words[ce] | 0) * ne, pe = (le & 67108863) + (oe & 67108863);
          oe >>= 26, oe += le / 67108864 | 0, oe += pe >>> 26, this.words[ce] = pe & 67108863;
        }
        return oe !== 0 && (this.words[ce] = oe, this.length++), this;
      }, J.prototype.muln = function(ne) {
        return this.clone().imuln(ne);
      }, J.prototype.sqr = function() {
        return this.mul(this);
      }, J.prototype.isqr = function() {
        return this.imul(this.clone());
      }, J.prototype.pow = function(ne) {
        var oe = fe(ne);
        if (oe.length === 0) return new J(1);
        for (var ce = this, le = 0; le < oe.length && oe[le] === 0; le++, ce = ce.sqr())
          ;
        if (++le < oe.length)
          for (var pe = ce.sqr(); le < oe.length; le++, pe = pe.sqr())
            oe[le] !== 0 && (ce = ce.mul(pe));
        return ce;
      }, J.prototype.iushln = function(ne) {
        $(typeof ne == "number" && ne >= 0);
        var oe = ne % 26, ce = (ne - oe) / 26, le = 67108863 >>> 26 - oe << 26 - oe, pe;
        if (oe !== 0) {
          var ye = 0;
          for (pe = 0; pe < this.length; pe++) {
            var Ce = this.words[pe] & le, be = (this.words[pe] | 0) - Ce << oe;
            this.words[pe] = be | ye, ye = Ce >>> 26 - oe;
          }
          ye && (this.words[pe] = ye, this.length++);
        }
        if (ce !== 0) {
          for (pe = this.length - 1; pe >= 0; pe--)
            this.words[pe + ce] = this.words[pe];
          for (pe = 0; pe < ce; pe++)
            this.words[pe] = 0;
          this.length += ce;
        }
        return this.strip();
      }, J.prototype.ishln = function(ne) {
        return $(this.negative === 0), this.iushln(ne);
      }, J.prototype.iushrn = function(ne, oe, ce) {
        $(typeof ne == "number" && ne >= 0);
        var le;
        oe ? le = (oe - oe % 26) / 26 : le = 0;
        var pe = ne % 26, ye = Math.min((ne - pe) / 26, this.length), Ce = 67108863 ^ 67108863 >>> pe << pe, be = ce;
        if (le -= ye, le = Math.max(0, le), be) {
          for (var ae = 0; ae < ye; ae++)
            be.words[ae] = this.words[ae];
          be.length = ye;
        }
        if (ye !== 0) if (this.length > ye)
          for (this.length -= ye, ae = 0; ae < this.length; ae++)
            this.words[ae] = this.words[ae + ye];
        else
          this.words[0] = 0, this.length = 1;
        var ge = 0;
        for (ae = this.length - 1; ae >= 0 && (ge !== 0 || ae >= le); ae--) {
          var Se = this.words[ae] | 0;
          this.words[ae] = ge << 26 - pe | Se >>> pe, ge = Se & Ce;
        }
        return be && ge !== 0 && (be.words[be.length++] = ge), this.length === 0 && (this.words[0] = 0, this.length = 1), this.strip();
      }, J.prototype.ishrn = function(ne, oe, ce) {
        return $(this.negative === 0), this.iushrn(ne, oe, ce);
      }, J.prototype.shln = function(ne) {
        return this.clone().ishln(ne);
      }, J.prototype.ushln = function(ne) {
        return this.clone().iushln(ne);
      }, J.prototype.shrn = function(ne) {
        return this.clone().ishrn(ne);
      }, J.prototype.ushrn = function(ne) {
        return this.clone().iushrn(ne);
      }, J.prototype.testn = function(ne) {
        $(typeof ne == "number" && ne >= 0);
        var oe = ne % 26, ce = (ne - oe) / 26, le = 1 << oe;
        if (this.length <= ce) return !1;
        var pe = this.words[ce];
        return !!(pe & le);
      }, J.prototype.imaskn = function(ne) {
        $(typeof ne == "number" && ne >= 0);
        var oe = ne % 26, ce = (ne - oe) / 26;
        if ($(this.negative === 0, "imaskn works only with positive numbers"), this.length <= ce)
          return this;
        if (oe !== 0 && ce++, this.length = Math.min(ce, this.length), oe !== 0) {
          var le = 67108863 ^ 67108863 >>> oe << oe;
          this.words[this.length - 1] &= le;
        }
        return this.strip();
      }, J.prototype.maskn = function(ne) {
        return this.clone().imaskn(ne);
      }, J.prototype.iaddn = function(ne) {
        return $(typeof ne == "number"), $(ne < 67108864), ne < 0 ? this.isubn(-ne) : this.negative !== 0 ? this.length === 1 && (this.words[0] | 0) < ne ? (this.words[0] = ne - (this.words[0] | 0), this.negative = 0, this) : (this.negative = 0, this.isubn(ne), this.negative = 1, this) : this._iaddn(ne);
      }, J.prototype._iaddn = function(ne) {
        this.words[0] += ne;
        for (var oe = 0; oe < this.length && this.words[oe] >= 67108864; oe++)
          this.words[oe] -= 67108864, oe === this.length - 1 ? this.words[oe + 1] = 1 : this.words[oe + 1]++;
        return this.length = Math.max(this.length, oe + 1), this;
      }, J.prototype.isubn = function(ne) {
        if ($(typeof ne == "number"), $(ne < 67108864), ne < 0) return this.iaddn(-ne);
        if (this.negative !== 0)
          return this.negative = 0, this.iaddn(ne), this.negative = 1, this;
        if (this.words[0] -= ne, this.length === 1 && this.words[0] < 0)
          this.words[0] = -this.words[0], this.negative = 1;
        else
          for (var oe = 0; oe < this.length && this.words[oe] < 0; oe++)
            this.words[oe] += 67108864, this.words[oe + 1] -= 1;
        return this.strip();
      }, J.prototype.addn = function(ne) {
        return this.clone().iaddn(ne);
      }, J.prototype.subn = function(ne) {
        return this.clone().isubn(ne);
      }, J.prototype.iabs = function() {
        return this.negative = 0, this;
      }, J.prototype.abs = function() {
        return this.clone().iabs();
      }, J.prototype._ishlnsubmul = function(ne, oe, ce) {
        var le = ne.length + ce, pe;
        this._expand(le);
        var ye, Ce = 0;
        for (pe = 0; pe < ne.length; pe++) {
          ye = (this.words[pe + ce] | 0) + Ce;
          var be = (ne.words[pe] | 0) * oe;
          ye -= be & 67108863, Ce = (ye >> 26) - (be / 67108864 | 0), this.words[pe + ce] = ye & 67108863;
        }
        for (; pe < this.length - ce; pe++)
          ye = (this.words[pe + ce] | 0) + Ce, Ce = ye >> 26, this.words[pe + ce] = ye & 67108863;
        if (Ce === 0) return this.strip();
        for ($(Ce === -1), Ce = 0, pe = 0; pe < this.length; pe++)
          ye = -(this.words[pe] | 0) + Ce, Ce = ye >> 26, this.words[pe] = ye & 67108863;
        return this.negative = 1, this.strip();
      }, J.prototype._wordDiv = function(ne, oe) {
        var ce = this.length - ne.length, le = this.clone(), pe = ne, ye = pe.words[pe.length - 1] | 0, Ce = this._countBits(ye);
        ce = 26 - Ce, ce !== 0 && (pe = pe.ushln(ce), le.iushln(ce), ye = pe.words[pe.length - 1] | 0);
        var be = le.length - pe.length, ae;
        if (oe !== "mod") {
          ae = new J(null), ae.length = be + 1, ae.words = new Array(ae.length);
          for (var ge = 0; ge < ae.length; ge++)
            ae.words[ge] = 0;
        }
        var Se = le.clone()._ishlnsubmul(pe, 1, be);
        Se.negative === 0 && (le = Se, ae && (ae.words[be] = 1));
        for (var Le = be - 1; Le >= 0; Le--) {
          var ze = (le.words[pe.length + Le] | 0) * 67108864 + (le.words[pe.length + Le - 1] | 0);
          for (ze = Math.min(ze / ye | 0, 67108863), le._ishlnsubmul(pe, ze, Le); le.negative !== 0; )
            ze--, le.negative = 0, le._ishlnsubmul(pe, 1, Le), le.isZero() || (le.negative ^= 1);
          ae && (ae.words[Le] = ze);
        }
        return ae && ae.strip(), le.strip(), oe !== "div" && ce !== 0 && le.iushrn(ce), {
          div: ae || null,
          mod: le
        };
      }, J.prototype.divmod = function(ne, oe, ce) {
        if ($(!ne.isZero()), this.isZero())
          return {
            div: new J(0),
            mod: new J(0)
          };
        var le, pe, ye;
        return this.negative !== 0 && ne.negative === 0 ? (ye = this.neg().divmod(ne, oe), oe !== "mod" && (le = ye.div.neg()), oe !== "div" && (pe = ye.mod.neg(), ce && pe.negative !== 0 && pe.iadd(ne)), {
          div: le,
          mod: pe
        }) : this.negative === 0 && ne.negative !== 0 ? (ye = this.divmod(ne.neg(), oe), oe !== "mod" && (le = ye.div.neg()), {
          div: le,
          mod: ye.mod
        }) : this.negative & ne.negative ? (ye = this.neg().divmod(ne.neg(), oe), oe !== "div" && (pe = ye.mod.neg(), ce && pe.negative !== 0 && pe.isub(ne)), {
          div: ye.div,
          mod: pe
        }) : ne.length > this.length || this.cmp(ne) < 0 ? {
          div: new J(0),
          mod: this
        } : ne.length === 1 ? oe === "div" ? {
          div: this.divn(ne.words[0]),
          mod: null
        } : oe === "mod" ? {
          div: null,
          mod: new J(this.modn(ne.words[0]))
        } : {
          div: this.divn(ne.words[0]),
          mod: new J(this.modn(ne.words[0]))
        } : this._wordDiv(ne, oe);
      }, J.prototype.div = function(ne) {
        return this.divmod(ne, "div", !1).div;
      }, J.prototype.mod = function(ne) {
        return this.divmod(ne, "mod", !1).mod;
      }, J.prototype.umod = function(ne) {
        return this.divmod(ne, "mod", !0).mod;
      }, J.prototype.divRound = function(ne) {
        var oe = this.divmod(ne);
        if (oe.mod.isZero()) return oe.div;
        var ce = oe.div.negative !== 0 ? oe.mod.isub(ne) : oe.mod, le = ne.ushrn(1), pe = ne.andln(1), ye = ce.cmp(le);
        return ye < 0 || pe === 1 && ye === 0 ? oe.div : oe.div.negative !== 0 ? oe.div.isubn(1) : oe.div.iaddn(1);
      }, J.prototype.modn = function(ne) {
        $(ne <= 67108863);
        for (var oe = (1 << 26) % ne, ce = 0, le = this.length - 1; le >= 0; le--)
          ce = (oe * ce + (this.words[le] | 0)) % ne;
        return ce;
      }, J.prototype.idivn = function(ne) {
        $(ne <= 67108863);
        for (var oe = 0, ce = this.length - 1; ce >= 0; ce--) {
          var le = (this.words[ce] | 0) + oe * 67108864;
          this.words[ce] = le / ne | 0, oe = le % ne;
        }
        return this.strip();
      }, J.prototype.divn = function(ne) {
        return this.clone().idivn(ne);
      }, J.prototype.egcd = function(ne) {
        $(ne.negative === 0), $(!ne.isZero());
        var oe = this, ce = ne.clone();
        oe.negative !== 0 ? oe = oe.umod(ne) : oe = oe.clone();
        for (var le = new J(1), pe = new J(0), ye = new J(0), Ce = new J(1), be = 0; oe.isEven() && ce.isEven(); )
          oe.iushrn(1), ce.iushrn(1), ++be;
        for (var ae = ce.clone(), ge = oe.clone(); !oe.isZero(); ) {
          for (var Se = 0, Le = 1; !(oe.words[0] & Le) && Se < 26; ++Se, Le <<= 1) ;
          if (Se > 0)
            for (oe.iushrn(Se); Se-- > 0; )
              (le.isOdd() || pe.isOdd()) && (le.iadd(ae), pe.isub(ge)), le.iushrn(1), pe.iushrn(1);
          for (var ze = 0, Re = 1; !(ce.words[0] & Re) && ze < 26; ++ze, Re <<= 1) ;
          if (ze > 0)
            for (ce.iushrn(ze); ze-- > 0; )
              (ye.isOdd() || Ce.isOdd()) && (ye.iadd(ae), Ce.isub(ge)), ye.iushrn(1), Ce.iushrn(1);
          oe.cmp(ce) >= 0 ? (oe.isub(ce), le.isub(ye), pe.isub(Ce)) : (ce.isub(oe), ye.isub(le), Ce.isub(pe));
        }
        return {
          a: ye,
          b: Ce,
          gcd: ce.iushln(be)
        };
      }, J.prototype._invmp = function(ne) {
        $(ne.negative === 0), $(!ne.isZero());
        var oe = this, ce = ne.clone();
        oe.negative !== 0 ? oe = oe.umod(ne) : oe = oe.clone();
        for (var le = new J(1), pe = new J(0), ye = ce.clone(); oe.cmpn(1) > 0 && ce.cmpn(1) > 0; ) {
          for (var Ce = 0, be = 1; !(oe.words[0] & be) && Ce < 26; ++Ce, be <<= 1) ;
          if (Ce > 0)
            for (oe.iushrn(Ce); Ce-- > 0; )
              le.isOdd() && le.iadd(ye), le.iushrn(1);
          for (var ae = 0, ge = 1; !(ce.words[0] & ge) && ae < 26; ++ae, ge <<= 1) ;
          if (ae > 0)
            for (ce.iushrn(ae); ae-- > 0; )
              pe.isOdd() && pe.iadd(ye), pe.iushrn(1);
          oe.cmp(ce) >= 0 ? (oe.isub(ce), le.isub(pe)) : (ce.isub(oe), pe.isub(le));
        }
        var Se;
        return oe.cmpn(1) === 0 ? Se = le : Se = pe, Se.cmpn(0) < 0 && Se.iadd(ne), Se;
      }, J.prototype.gcd = function(ne) {
        if (this.isZero()) return ne.abs();
        if (ne.isZero()) return this.abs();
        var oe = this.clone(), ce = ne.clone();
        oe.negative = 0, ce.negative = 0;
        for (var le = 0; oe.isEven() && ce.isEven(); le++)
          oe.iushrn(1), ce.iushrn(1);
        do {
          for (; oe.isEven(); )
            oe.iushrn(1);
          for (; ce.isEven(); )
            ce.iushrn(1);
          var pe = oe.cmp(ce);
          if (pe < 0) {
            var ye = oe;
            oe = ce, ce = ye;
          } else if (pe === 0 || ce.cmpn(1) === 0)
            break;
          oe.isub(ce);
        } while (!0);
        return ce.iushln(le);
      }, J.prototype.invm = function(ne) {
        return this.egcd(ne).a.umod(ne);
      }, J.prototype.isEven = function() {
        return (this.words[0] & 1) === 0;
      }, J.prototype.isOdd = function() {
        return (this.words[0] & 1) === 1;
      }, J.prototype.andln = function(ne) {
        return this.words[0] & ne;
      }, J.prototype.bincn = function(ne) {
        $(typeof ne == "number");
        var oe = ne % 26, ce = (ne - oe) / 26, le = 1 << oe;
        if (this.length <= ce)
          return this._expand(ce + 1), this.words[ce] |= le, this;
        for (var pe = le, ye = ce; pe !== 0 && ye < this.length; ye++) {
          var Ce = this.words[ye] | 0;
          Ce += pe, pe = Ce >>> 26, Ce &= 67108863, this.words[ye] = Ce;
        }
        return pe !== 0 && (this.words[ye] = pe, this.length++), this;
      }, J.prototype.isZero = function() {
        return this.length === 1 && this.words[0] === 0;
      }, J.prototype.cmpn = function(ne) {
        var oe = ne < 0;
        if (this.negative !== 0 && !oe) return -1;
        if (this.negative === 0 && oe) return 1;
        this.strip();
        var ce;
        if (this.length > 1)
          ce = 1;
        else {
          oe && (ne = -ne), $(ne <= 67108863, "Number is too big");
          var le = this.words[0] | 0;
          ce = le === ne ? 0 : le < ne ? -1 : 1;
        }
        return this.negative !== 0 ? -ce | 0 : ce;
      }, J.prototype.cmp = function(ne) {
        if (this.negative !== 0 && ne.negative === 0) return -1;
        if (this.negative === 0 && ne.negative !== 0) return 1;
        var oe = this.ucmp(ne);
        return this.negative !== 0 ? -oe | 0 : oe;
      }, J.prototype.ucmp = function(ne) {
        if (this.length > ne.length) return 1;
        if (this.length < ne.length) return -1;
        for (var oe = 0, ce = this.length - 1; ce >= 0; ce--) {
          var le = this.words[ce] | 0, pe = ne.words[ce] | 0;
          if (le !== pe) {
            le < pe ? oe = -1 : le > pe && (oe = 1);
            break;
          }
        }
        return oe;
      }, J.prototype.gtn = function(ne) {
        return this.cmpn(ne) === 1;
      }, J.prototype.gt = function(ne) {
        return this.cmp(ne) === 1;
      }, J.prototype.gten = function(ne) {
        return this.cmpn(ne) >= 0;
      }, J.prototype.gte = function(ne) {
        return this.cmp(ne) >= 0;
      }, J.prototype.ltn = function(ne) {
        return this.cmpn(ne) === -1;
      }, J.prototype.lt = function(ne) {
        return this.cmp(ne) === -1;
      }, J.prototype.lten = function(ne) {
        return this.cmpn(ne) <= 0;
      }, J.prototype.lte = function(ne) {
        return this.cmp(ne) <= 0;
      }, J.prototype.eqn = function(ne) {
        return this.cmpn(ne) === 0;
      }, J.prototype.eq = function(ne) {
        return this.cmp(ne) === 0;
      }, J.red = function(ne) {
        return new De(ne);
      }, J.prototype.toRed = function(ne) {
        return $(!this.red, "Already a number in reduction context"), $(this.negative === 0, "red works only with positives"), ne.convertTo(this)._forceRed(ne);
      }, J.prototype.fromRed = function() {
        return $(this.red, "fromRed works only with numbers in reduction context"), this.red.convertFrom(this);
      }, J.prototype._forceRed = function(ne) {
        return this.red = ne, this;
      }, J.prototype.forceRed = function(ne) {
        return $(!this.red, "Already a number in reduction context"), this._forceRed(ne);
      }, J.prototype.redAdd = function(ne) {
        return $(this.red, "redAdd works only with red numbers"), this.red.add(this, ne);
      }, J.prototype.redIAdd = function(ne) {
        return $(this.red, "redIAdd works only with red numbers"), this.red.iadd(this, ne);
      }, J.prototype.redSub = function(ne) {
        return $(this.red, "redSub works only with red numbers"), this.red.sub(this, ne);
      }, J.prototype.redISub = function(ne) {
        return $(this.red, "redISub works only with red numbers"), this.red.isub(this, ne);
      }, J.prototype.redShl = function(ne) {
        return $(this.red, "redShl works only with red numbers"), this.red.shl(this, ne);
      }, J.prototype.redMul = function(ne) {
        return $(this.red, "redMul works only with red numbers"), this.red._verify2(this, ne), this.red.mul(this, ne);
      }, J.prototype.redIMul = function(ne) {
        return $(this.red, "redMul works only with red numbers"), this.red._verify2(this, ne), this.red.imul(this, ne);
      }, J.prototype.redSqr = function() {
        return $(this.red, "redSqr works only with red numbers"), this.red._verify1(this), this.red.sqr(this);
      }, J.prototype.redISqr = function() {
        return $(this.red, "redISqr works only with red numbers"), this.red._verify1(this), this.red.isqr(this);
      }, J.prototype.redSqrt = function() {
        return $(this.red, "redSqrt works only with red numbers"), this.red._verify1(this), this.red.sqrt(this);
      }, J.prototype.redInvm = function() {
        return $(this.red, "redInvm works only with red numbers"), this.red._verify1(this), this.red.invm(this);
      }, J.prototype.redNeg = function() {
        return $(this.red, "redNeg works only with red numbers"), this.red._verify1(this), this.red.neg(this);
      }, J.prototype.redPow = function(ne) {
        return $(this.red && !ne.red, "redPow(normalNum)"), this.red._verify1(this), this.red.pow(this, ne);
      };
      var we = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
      };
      function Ee(Ae, ne) {
        this.name = Ae, this.p = new J(ne, 16), this.n = this.p.bitLength(), this.k = new J(1).iushln(this.n).isub(this.p), this.tmp = this._tmp();
      }
      Ee.prototype._tmp = function() {
        var ne = new J(null);
        return ne.words = new Array(Math.ceil(this.n / 13)), ne;
      }, Ee.prototype.ireduce = function(ne) {
        var oe = ne, ce;
        do
          this.split(oe, this.tmp), oe = this.imulK(oe), oe = oe.iadd(this.tmp), ce = oe.bitLength();
        while (ce > this.n);
        var le = ce < this.n ? -1 : oe.ucmp(this.p);
        return le === 0 ? (oe.words[0] = 0, oe.length = 1) : le > 0 ? oe.isub(this.p) : oe.strip !== void 0 ? oe.strip() : oe._strip(), oe;
      }, Ee.prototype.split = function(ne, oe) {
        ne.iushrn(this.n, 0, oe);
      }, Ee.prototype.imulK = function(ne) {
        return ne.imul(this.k);
      };
      function Me() {
        Ee.call(
          this,
          "k256",
          "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f"
        );
      }
      V(Me, Ee), Me.prototype.split = function(ne, oe) {
        for (var ce = 4194303, le = Math.min(ne.length, 9), pe = 0; pe < le; pe++)
          oe.words[pe] = ne.words[pe];
        if (oe.length = le, ne.length <= 9) {
          ne.words[0] = 0, ne.length = 1;
          return;
        }
        var ye = ne.words[9];
        for (oe.words[oe.length++] = ye & ce, pe = 10; pe < ne.length; pe++) {
          var Ce = ne.words[pe] | 0;
          ne.words[pe - 10] = (Ce & ce) << 4 | ye >>> 22, ye = Ce;
        }
        ye >>>= 22, ne.words[pe - 10] = ye, ye === 0 && ne.length > 10 ? ne.length -= 10 : ne.length -= 9;
      }, Me.prototype.imulK = function(ne) {
        ne.words[ne.length] = 0, ne.words[ne.length + 1] = 0, ne.length += 2;
        for (var oe = 0, ce = 0; ce < ne.length; ce++) {
          var le = ne.words[ce] | 0;
          oe += le * 977, ne.words[ce] = oe & 67108863, oe = le * 64 + (oe / 67108864 | 0);
        }
        return ne.words[ne.length - 1] === 0 && (ne.length--, ne.words[ne.length - 1] === 0 && ne.length--), ne;
      };
      function Ie() {
        Ee.call(
          this,
          "p224",
          "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001"
        );
      }
      V(Ie, Ee);
      function ke() {
        Ee.call(
          this,
          "p192",
          "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff"
        );
      }
      V(ke, Ee);
      function _e() {
        Ee.call(
          this,
          "25519",
          "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed"
        );
      }
      V(_e, Ee), _e.prototype.imulK = function(ne) {
        for (var oe = 0, ce = 0; ce < ne.length; ce++) {
          var le = (ne.words[ce] | 0) * 19 + oe, pe = le & 67108863;
          le >>>= 26, ne.words[ce] = pe, oe = le;
        }
        return oe !== 0 && (ne.words[ne.length++] = oe), ne;
      }, J._prime = function(ne) {
        if (we[ne]) return we[ne];
        var oe;
        if (ne === "k256")
          oe = new Me();
        else if (ne === "p224")
          oe = new Ie();
        else if (ne === "p192")
          oe = new ke();
        else if (ne === "p25519")
          oe = new _e();
        else
          throw new Error("Unknown prime " + ne);
        return we[ne] = oe, oe;
      };
      function De(Ae) {
        if (typeof Ae == "string") {
          var ne = J._prime(Ae);
          this.m = ne.p, this.prime = ne;
        } else
          $(Ae.gtn(1), "modulus must be greater than 1"), this.m = Ae, this.prime = null;
      }
      De.prototype._verify1 = function(ne) {
        $(ne.negative === 0, "red works only with positives"), $(ne.red, "red works only with red numbers");
      }, De.prototype._verify2 = function(ne, oe) {
        $((ne.negative | oe.negative) === 0, "red works only with positives"), $(
          ne.red && ne.red === oe.red,
          "red works only with red numbers"
        );
      }, De.prototype.imod = function(ne) {
        return this.prime ? this.prime.ireduce(ne)._forceRed(this) : ne.umod(this.m)._forceRed(this);
      }, De.prototype.neg = function(ne) {
        return ne.isZero() ? ne.clone() : this.m.sub(ne)._forceRed(this);
      }, De.prototype.add = function(ne, oe) {
        this._verify2(ne, oe);
        var ce = ne.add(oe);
        return ce.cmp(this.m) >= 0 && ce.isub(this.m), ce._forceRed(this);
      }, De.prototype.iadd = function(ne, oe) {
        this._verify2(ne, oe);
        var ce = ne.iadd(oe);
        return ce.cmp(this.m) >= 0 && ce.isub(this.m), ce;
      }, De.prototype.sub = function(ne, oe) {
        this._verify2(ne, oe);
        var ce = ne.sub(oe);
        return ce.cmpn(0) < 0 && ce.iadd(this.m), ce._forceRed(this);
      }, De.prototype.isub = function(ne, oe) {
        this._verify2(ne, oe);
        var ce = ne.isub(oe);
        return ce.cmpn(0) < 0 && ce.iadd(this.m), ce;
      }, De.prototype.shl = function(ne, oe) {
        return this._verify1(ne), this.imod(ne.ushln(oe));
      }, De.prototype.imul = function(ne, oe) {
        return this._verify2(ne, oe), this.imod(ne.imul(oe));
      }, De.prototype.mul = function(ne, oe) {
        return this._verify2(ne, oe), this.imod(ne.mul(oe));
      }, De.prototype.isqr = function(ne) {
        return this.imul(ne, ne.clone());
      }, De.prototype.sqr = function(ne) {
        return this.mul(ne, ne);
      }, De.prototype.sqrt = function(ne) {
        if (ne.isZero()) return ne.clone();
        var oe = this.m.andln(3);
        if ($(oe % 2 === 1), oe === 3) {
          var ce = this.m.add(new J(1)).iushrn(2);
          return this.pow(ne, ce);
        }
        for (var le = this.m.subn(1), pe = 0; !le.isZero() && le.andln(1) === 0; )
          pe++, le.iushrn(1);
        $(!le.isZero());
        var ye = new J(1).toRed(this), Ce = ye.redNeg(), be = this.m.subn(1).iushrn(1), ae = this.m.bitLength();
        for (ae = new J(2 * ae * ae).toRed(this); this.pow(ae, be).cmp(Ce) !== 0; )
          ae.redIAdd(Ce);
        for (var ge = this.pow(ae, le), Se = this.pow(ne, le.addn(1).iushrn(1)), Le = this.pow(ne, le), ze = pe; Le.cmp(ye) !== 0; ) {
          for (var Re = Le, We = 0; Re.cmp(ye) !== 0; We++)
            Re = Re.redSqr();
          $(We < ze);
          var Be = this.pow(ge, new J(1).iushln(ze - We - 1));
          Se = Se.redMul(Be), ge = Be.redSqr(), Le = Le.redMul(ge), ze = We;
        }
        return Se;
      }, De.prototype.invm = function(ne) {
        var oe = ne._invmp(this.m);
        return oe.negative !== 0 ? (oe.negative = 0, this.imod(oe).redNeg()) : this.imod(oe);
      }, De.prototype.pow = function(ne, oe) {
        if (oe.isZero()) return new J(1).toRed(this);
        if (oe.cmpn(1) === 0) return ne.clone();
        var ce = 4, le = new Array(1 << ce);
        le[0] = new J(1).toRed(this), le[1] = ne;
        for (var pe = 2; pe < le.length; pe++)
          le[pe] = this.mul(le[pe - 1], ne);
        var ye = le[0], Ce = 0, be = 0, ae = oe.bitLength() % 26;
        for (ae === 0 && (ae = 26), pe = oe.length - 1; pe >= 0; pe--) {
          for (var ge = oe.words[pe], Se = ae - 1; Se >= 0; Se--) {
            var Le = ge >> Se & 1;
            if (ye !== le[0] && (ye = this.sqr(ye)), Le === 0 && Ce === 0) {
              be = 0;
              continue;
            }
            Ce <<= 1, Ce |= Le, be++, !(be !== ce && (pe !== 0 || Se !== 0)) && (ye = this.mul(ye, le[Ce]), be = 0, Ce = 0);
          }
          ae = 26;
        }
        return ye;
      }, De.prototype.convertTo = function(ne) {
        var oe = ne.umod(this.m);
        return oe === ne ? oe.clone() : oe;
      }, De.prototype.convertFrom = function(ne) {
        var oe = ne.clone();
        return oe.red = null, oe;
      }, J.mont = function(ne) {
        return new Fe(ne);
      };
      function Fe(Ae) {
        De.call(this, Ae), this.shift = this.m.bitLength(), this.shift % 26 !== 0 && (this.shift += 26 - this.shift % 26), this.r = new J(1).iushln(this.shift), this.r2 = this.imod(this.r.sqr()), this.rinv = this.r._invmp(this.m), this.minv = this.rinv.mul(this.r).isubn(1).div(this.m), this.minv = this.minv.umod(this.r), this.minv = this.r.sub(this.minv);
      }
      V(Fe, De), Fe.prototype.convertTo = function(ne) {
        return this.imod(ne.ushln(this.shift));
      }, Fe.prototype.convertFrom = function(ne) {
        var oe = this.imod(ne.mul(this.rinv));
        return oe.red = null, oe;
      }, Fe.prototype.imul = function(ne, oe) {
        if (ne.isZero() || oe.isZero())
          return ne.words[0] = 0, ne.length = 1, ne;
        var ce = ne.imul(oe), le = ce.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m), pe = ce.isub(le).iushrn(this.shift), ye = pe;
        return pe.cmp(this.m) >= 0 ? ye = pe.isub(this.m) : pe.cmpn(0) < 0 && (ye = pe.iadd(this.m)), ye._forceRed(this);
      }, Fe.prototype.mul = function(ne, oe) {
        if (ne.isZero() || oe.isZero()) return new J(0)._forceRed(this);
        var ce = ne.mul(oe), le = ce.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m), pe = ce.isub(le).iushrn(this.shift), ye = pe;
        return pe.cmp(this.m) >= 0 ? ye = pe.isub(this.m) : pe.cmpn(0) < 0 && (ye = pe.iadd(this.m)), ye._forceRed(this);
      }, Fe.prototype.invm = function(ne) {
        var oe = this.imod(ne._invmp(this.m).mul(this.r2));
        return oe._forceRed(this);
      };
    })(C, commonjsGlobal$1);
  }(bn$6)), bn$6.exports;
}
var bn$5 = { exports: {} };
bn$5.exports;
var hasRequiredBn$4;
function requireBn$4() {
  return hasRequiredBn$4 || (hasRequiredBn$4 = 1, function(C) {
    (function(e, T) {
      function $(Ae, ne) {
        if (!Ae) throw new Error(ne || "Assertion failed");
      }
      function V(Ae, ne) {
        Ae.super_ = ne;
        var oe = function() {
        };
        oe.prototype = ne.prototype, Ae.prototype = new oe(), Ae.prototype.constructor = Ae;
      }
      function J(Ae, ne, oe) {
        if (J.isBN(Ae))
          return Ae;
        this.negative = 0, this.words = null, this.length = 0, this.red = null, Ae !== null && ((ne === "le" || ne === "be") && (oe = ne, ne = 10), this._init(Ae || 0, ne || 10, oe || "be"));
      }
      typeof e == "object" ? e.exports = J : T.BN = J, J.BN = J, J.wordSize = 26;
      var ee;
      try {
        typeof window < "u" && typeof window.Buffer < "u" ? ee = window.Buffer : ee = bufferPolyfill.Buffer;
      } catch {
      }
      J.isBN = function(ne) {
        return ne instanceof J ? !0 : ne !== null && typeof ne == "object" && ne.constructor.wordSize === J.wordSize && Array.isArray(ne.words);
      }, J.max = function(ne, oe) {
        return ne.cmp(oe) > 0 ? ne : oe;
      }, J.min = function(ne, oe) {
        return ne.cmp(oe) < 0 ? ne : oe;
      }, J.prototype._init = function(ne, oe, ce) {
        if (typeof ne == "number")
          return this._initNumber(ne, oe, ce);
        if (typeof ne == "object")
          return this._initArray(ne, oe, ce);
        oe === "hex" && (oe = 16), $(oe === (oe | 0) && oe >= 2 && oe <= 36), ne = ne.toString().replace(/\s+/g, "");
        var le = 0;
        ne[0] === "-" && (le++, this.negative = 1), le < ne.length && (oe === 16 ? this._parseHex(ne, le, ce) : (this._parseBase(ne, oe, le), ce === "le" && this._initArray(this.toArray(), oe, ce)));
      }, J.prototype._initNumber = function(ne, oe, ce) {
        ne < 0 && (this.negative = 1, ne = -ne), ne < 67108864 ? (this.words = [ne & 67108863], this.length = 1) : ne < 4503599627370496 ? (this.words = [
          ne & 67108863,
          ne / 67108864 & 67108863
        ], this.length = 2) : ($(ne < 9007199254740992), this.words = [
          ne & 67108863,
          ne / 67108864 & 67108863,
          1
        ], this.length = 3), ce === "le" && this._initArray(this.toArray(), oe, ce);
      }, J.prototype._initArray = function(ne, oe, ce) {
        if ($(typeof ne.length == "number"), ne.length <= 0)
          return this.words = [0], this.length = 1, this;
        this.length = Math.ceil(ne.length / 3), this.words = new Array(this.length);
        for (var le = 0; le < this.length; le++)
          this.words[le] = 0;
        var pe, ye, Ce = 0;
        if (ce === "be")
          for (le = ne.length - 1, pe = 0; le >= 0; le -= 3)
            ye = ne[le] | ne[le - 1] << 8 | ne[le - 2] << 16, this.words[pe] |= ye << Ce & 67108863, this.words[pe + 1] = ye >>> 26 - Ce & 67108863, Ce += 24, Ce >= 26 && (Ce -= 26, pe++);
        else if (ce === "le")
          for (le = 0, pe = 0; le < ne.length; le += 3)
            ye = ne[le] | ne[le + 1] << 8 | ne[le + 2] << 16, this.words[pe] |= ye << Ce & 67108863, this.words[pe + 1] = ye >>> 26 - Ce & 67108863, Ce += 24, Ce >= 26 && (Ce -= 26, pe++);
        return this.strip();
      };
      function te(Ae, ne) {
        var oe = Ae.charCodeAt(ne);
        return oe >= 65 && oe <= 70 ? oe - 55 : oe >= 97 && oe <= 102 ? oe - 87 : oe - 48 & 15;
      }
      function re(Ae, ne, oe) {
        var ce = te(Ae, oe);
        return oe - 1 >= ne && (ce |= te(Ae, oe - 1) << 4), ce;
      }
      J.prototype._parseHex = function(ne, oe, ce) {
        this.length = Math.ceil((ne.length - oe) / 6), this.words = new Array(this.length);
        for (var le = 0; le < this.length; le++)
          this.words[le] = 0;
        var pe = 0, ye = 0, Ce;
        if (ce === "be")
          for (le = ne.length - 1; le >= oe; le -= 2)
            Ce = re(ne, oe, le) << pe, this.words[ye] |= Ce & 67108863, pe >= 18 ? (pe -= 18, ye += 1, this.words[ye] |= Ce >>> 26) : pe += 8;
        else {
          var be = ne.length - oe;
          for (le = be % 2 === 0 ? oe + 1 : oe; le < ne.length; le += 2)
            Ce = re(ne, oe, le) << pe, this.words[ye] |= Ce & 67108863, pe >= 18 ? (pe -= 18, ye += 1, this.words[ye] |= Ce >>> 26) : pe += 8;
        }
        this.strip();
      };
      function ie(Ae, ne, oe, ce) {
        for (var le = 0, pe = Math.min(Ae.length, oe), ye = ne; ye < pe; ye++) {
          var Ce = Ae.charCodeAt(ye) - 48;
          le *= ce, Ce >= 49 ? le += Ce - 49 + 10 : Ce >= 17 ? le += Ce - 17 + 10 : le += Ce;
        }
        return le;
      }
      J.prototype._parseBase = function(ne, oe, ce) {
        this.words = [0], this.length = 1;
        for (var le = 0, pe = 1; pe <= 67108863; pe *= oe)
          le++;
        le--, pe = pe / oe | 0;
        for (var ye = ne.length - ce, Ce = ye % le, be = Math.min(ye, ye - Ce) + ce, ae = 0, ge = ce; ge < be; ge += le)
          ae = ie(ne, ge, ge + le, oe), this.imuln(pe), this.words[0] + ae < 67108864 ? this.words[0] += ae : this._iaddn(ae);
        if (Ce !== 0) {
          var Se = 1;
          for (ae = ie(ne, ge, ne.length, oe), ge = 0; ge < Ce; ge++)
            Se *= oe;
          this.imuln(Se), this.words[0] + ae < 67108864 ? this.words[0] += ae : this._iaddn(ae);
        }
        this.strip();
      }, J.prototype.copy = function(ne) {
        ne.words = new Array(this.length);
        for (var oe = 0; oe < this.length; oe++)
          ne.words[oe] = this.words[oe];
        ne.length = this.length, ne.negative = this.negative, ne.red = this.red;
      }, J.prototype.clone = function() {
        var ne = new J(null);
        return this.copy(ne), ne;
      }, J.prototype._expand = function(ne) {
        for (; this.length < ne; )
          this.words[this.length++] = 0;
        return this;
      }, J.prototype.strip = function() {
        for (; this.length > 1 && this.words[this.length - 1] === 0; )
          this.length--;
        return this._normSign();
      }, J.prototype._normSign = function() {
        return this.length === 1 && this.words[0] === 0 && (this.negative = 0), this;
      }, J.prototype.inspect = function() {
        return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
      };
      var se = [
        "",
        "0",
        "00",
        "000",
        "0000",
        "00000",
        "000000",
        "0000000",
        "00000000",
        "000000000",
        "0000000000",
        "00000000000",
        "000000000000",
        "0000000000000",
        "00000000000000",
        "000000000000000",
        "0000000000000000",
        "00000000000000000",
        "000000000000000000",
        "0000000000000000000",
        "00000000000000000000",
        "000000000000000000000",
        "0000000000000000000000",
        "00000000000000000000000",
        "000000000000000000000000",
        "0000000000000000000000000"
      ], de = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
      ], ue = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        1e7,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64e6,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        243e5,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
      ];
      J.prototype.toString = function(ne, oe) {
        ne = ne || 10, oe = oe | 0 || 1;
        var ce;
        if (ne === 16 || ne === "hex") {
          ce = "";
          for (var le = 0, pe = 0, ye = 0; ye < this.length; ye++) {
            var Ce = this.words[ye], be = ((Ce << le | pe) & 16777215).toString(16);
            pe = Ce >>> 24 - le & 16777215, le += 2, le >= 26 && (le -= 26, ye--), pe !== 0 || ye !== this.length - 1 ? ce = se[6 - be.length] + be + ce : ce = be + ce;
          }
          for (pe !== 0 && (ce = pe.toString(16) + ce); ce.length % oe !== 0; )
            ce = "0" + ce;
          return this.negative !== 0 && (ce = "-" + ce), ce;
        }
        if (ne === (ne | 0) && ne >= 2 && ne <= 36) {
          var ae = de[ne], ge = ue[ne];
          ce = "";
          var Se = this.clone();
          for (Se.negative = 0; !Se.isZero(); ) {
            var Le = Se.modn(ge).toString(ne);
            Se = Se.idivn(ge), Se.isZero() ? ce = Le + ce : ce = se[ae - Le.length] + Le + ce;
          }
          for (this.isZero() && (ce = "0" + ce); ce.length % oe !== 0; )
            ce = "0" + ce;
          return this.negative !== 0 && (ce = "-" + ce), ce;
        }
        $(!1, "Base should be between 2 and 36");
      }, J.prototype.toNumber = function() {
        var ne = this.words[0];
        return this.length === 2 ? ne += this.words[1] * 67108864 : this.length === 3 && this.words[2] === 1 ? ne += 4503599627370496 + this.words[1] * 67108864 : this.length > 2 && $(!1, "Number can only safely store up to 53 bits"), this.negative !== 0 ? -ne : ne;
      }, J.prototype.toJSON = function() {
        return this.toString(16);
      }, J.prototype.toBuffer = function(ne, oe) {
        return $(typeof ee < "u"), this.toArrayLike(ee, ne, oe);
      }, J.prototype.toArray = function(ne, oe) {
        return this.toArrayLike(Array, ne, oe);
      }, J.prototype.toArrayLike = function(ne, oe, ce) {
        var le = this.byteLength(), pe = ce || Math.max(1, le);
        $(le <= pe, "byte array longer than desired length"), $(pe > 0, "Requested array length <= 0"), this.strip();
        var ye = oe === "le", Ce = new ne(pe), be, ae, ge = this.clone();
        if (ye) {
          for (ae = 0; !ge.isZero(); ae++)
            be = ge.andln(255), ge.iushrn(8), Ce[ae] = be;
          for (; ae < pe; ae++)
            Ce[ae] = 0;
        } else {
          for (ae = 0; ae < pe - le; ae++)
            Ce[ae] = 0;
          for (ae = 0; !ge.isZero(); ae++)
            be = ge.andln(255), ge.iushrn(8), Ce[pe - ae - 1] = be;
        }
        return Ce;
      }, Math.clz32 ? J.prototype._countBits = function(ne) {
        return 32 - Math.clz32(ne);
      } : J.prototype._countBits = function(ne) {
        var oe = ne, ce = 0;
        return oe >= 4096 && (ce += 13, oe >>>= 13), oe >= 64 && (ce += 7, oe >>>= 7), oe >= 8 && (ce += 4, oe >>>= 4), oe >= 2 && (ce += 2, oe >>>= 2), ce + oe;
      }, J.prototype._zeroBits = function(ne) {
        if (ne === 0) return 26;
        var oe = ne, ce = 0;
        return oe & 8191 || (ce += 13, oe >>>= 13), oe & 127 || (ce += 7, oe >>>= 7), oe & 15 || (ce += 4, oe >>>= 4), oe & 3 || (ce += 2, oe >>>= 2), oe & 1 || ce++, ce;
      }, J.prototype.bitLength = function() {
        var ne = this.words[this.length - 1], oe = this._countBits(ne);
        return (this.length - 1) * 26 + oe;
      };
      function fe(Ae) {
        for (var ne = new Array(Ae.bitLength()), oe = 0; oe < ne.length; oe++) {
          var ce = oe / 26 | 0, le = oe % 26;
          ne[oe] = (Ae.words[ce] & 1 << le) >>> le;
        }
        return ne;
      }
      J.prototype.zeroBits = function() {
        if (this.isZero()) return 0;
        for (var ne = 0, oe = 0; oe < this.length; oe++) {
          var ce = this._zeroBits(this.words[oe]);
          if (ne += ce, ce !== 26) break;
        }
        return ne;
      }, J.prototype.byteLength = function() {
        return Math.ceil(this.bitLength() / 8);
      }, J.prototype.toTwos = function(ne) {
        return this.negative !== 0 ? this.abs().inotn(ne).iaddn(1) : this.clone();
      }, J.prototype.fromTwos = function(ne) {
        return this.testn(ne - 1) ? this.notn(ne).iaddn(1).ineg() : this.clone();
      }, J.prototype.isNeg = function() {
        return this.negative !== 0;
      }, J.prototype.neg = function() {
        return this.clone().ineg();
      }, J.prototype.ineg = function() {
        return this.isZero() || (this.negative ^= 1), this;
      }, J.prototype.iuor = function(ne) {
        for (; this.length < ne.length; )
          this.words[this.length++] = 0;
        for (var oe = 0; oe < ne.length; oe++)
          this.words[oe] = this.words[oe] | ne.words[oe];
        return this.strip();
      }, J.prototype.ior = function(ne) {
        return $((this.negative | ne.negative) === 0), this.iuor(ne);
      }, J.prototype.or = function(ne) {
        return this.length > ne.length ? this.clone().ior(ne) : ne.clone().ior(this);
      }, J.prototype.uor = function(ne) {
        return this.length > ne.length ? this.clone().iuor(ne) : ne.clone().iuor(this);
      }, J.prototype.iuand = function(ne) {
        var oe;
        this.length > ne.length ? oe = ne : oe = this;
        for (var ce = 0; ce < oe.length; ce++)
          this.words[ce] = this.words[ce] & ne.words[ce];
        return this.length = oe.length, this.strip();
      }, J.prototype.iand = function(ne) {
        return $((this.negative | ne.negative) === 0), this.iuand(ne);
      }, J.prototype.and = function(ne) {
        return this.length > ne.length ? this.clone().iand(ne) : ne.clone().iand(this);
      }, J.prototype.uand = function(ne) {
        return this.length > ne.length ? this.clone().iuand(ne) : ne.clone().iuand(this);
      }, J.prototype.iuxor = function(ne) {
        var oe, ce;
        this.length > ne.length ? (oe = this, ce = ne) : (oe = ne, ce = this);
        for (var le = 0; le < ce.length; le++)
          this.words[le] = oe.words[le] ^ ce.words[le];
        if (this !== oe)
          for (; le < oe.length; le++)
            this.words[le] = oe.words[le];
        return this.length = oe.length, this.strip();
      }, J.prototype.ixor = function(ne) {
        return $((this.negative | ne.negative) === 0), this.iuxor(ne);
      }, J.prototype.xor = function(ne) {
        return this.length > ne.length ? this.clone().ixor(ne) : ne.clone().ixor(this);
      }, J.prototype.uxor = function(ne) {
        return this.length > ne.length ? this.clone().iuxor(ne) : ne.clone().iuxor(this);
      }, J.prototype.inotn = function(ne) {
        $(typeof ne == "number" && ne >= 0);
        var oe = Math.ceil(ne / 26) | 0, ce = ne % 26;
        this._expand(oe), ce > 0 && oe--;
        for (var le = 0; le < oe; le++)
          this.words[le] = ~this.words[le] & 67108863;
        return ce > 0 && (this.words[le] = ~this.words[le] & 67108863 >> 26 - ce), this.strip();
      }, J.prototype.notn = function(ne) {
        return this.clone().inotn(ne);
      }, J.prototype.setn = function(ne, oe) {
        $(typeof ne == "number" && ne >= 0);
        var ce = ne / 26 | 0, le = ne % 26;
        return this._expand(ce + 1), oe ? this.words[ce] = this.words[ce] | 1 << le : this.words[ce] = this.words[ce] & ~(1 << le), this.strip();
      }, J.prototype.iadd = function(ne) {
        var oe;
        if (this.negative !== 0 && ne.negative === 0)
          return this.negative = 0, oe = this.isub(ne), this.negative ^= 1, this._normSign();
        if (this.negative === 0 && ne.negative !== 0)
          return ne.negative = 0, oe = this.isub(ne), ne.negative = 1, oe._normSign();
        var ce, le;
        this.length > ne.length ? (ce = this, le = ne) : (ce = ne, le = this);
        for (var pe = 0, ye = 0; ye < le.length; ye++)
          oe = (ce.words[ye] | 0) + (le.words[ye] | 0) + pe, this.words[ye] = oe & 67108863, pe = oe >>> 26;
        for (; pe !== 0 && ye < ce.length; ye++)
          oe = (ce.words[ye] | 0) + pe, this.words[ye] = oe & 67108863, pe = oe >>> 26;
        if (this.length = ce.length, pe !== 0)
          this.words[this.length] = pe, this.length++;
        else if (ce !== this)
          for (; ye < ce.length; ye++)
            this.words[ye] = ce.words[ye];
        return this;
      }, J.prototype.add = function(ne) {
        var oe;
        return ne.negative !== 0 && this.negative === 0 ? (ne.negative = 0, oe = this.sub(ne), ne.negative ^= 1, oe) : ne.negative === 0 && this.negative !== 0 ? (this.negative = 0, oe = ne.sub(this), this.negative = 1, oe) : this.length > ne.length ? this.clone().iadd(ne) : ne.clone().iadd(this);
      }, J.prototype.isub = function(ne) {
        if (ne.negative !== 0) {
          ne.negative = 0;
          var oe = this.iadd(ne);
          return ne.negative = 1, oe._normSign();
        } else if (this.negative !== 0)
          return this.negative = 0, this.iadd(ne), this.negative = 1, this._normSign();
        var ce = this.cmp(ne);
        if (ce === 0)
          return this.negative = 0, this.length = 1, this.words[0] = 0, this;
        var le, pe;
        ce > 0 ? (le = this, pe = ne) : (le = ne, pe = this);
        for (var ye = 0, Ce = 0; Ce < pe.length; Ce++)
          oe = (le.words[Ce] | 0) - (pe.words[Ce] | 0) + ye, ye = oe >> 26, this.words[Ce] = oe & 67108863;
        for (; ye !== 0 && Ce < le.length; Ce++)
          oe = (le.words[Ce] | 0) + ye, ye = oe >> 26, this.words[Ce] = oe & 67108863;
        if (ye === 0 && Ce < le.length && le !== this)
          for (; Ce < le.length; Ce++)
            this.words[Ce] = le.words[Ce];
        return this.length = Math.max(this.length, Ce), le !== this && (this.negative = 1), this.strip();
      }, J.prototype.sub = function(ne) {
        return this.clone().isub(ne);
      };
      function he(Ae, ne, oe) {
        oe.negative = ne.negative ^ Ae.negative;
        var ce = Ae.length + ne.length | 0;
        oe.length = ce, ce = ce - 1 | 0;
        var le = Ae.words[0] | 0, pe = ne.words[0] | 0, ye = le * pe, Ce = ye & 67108863, be = ye / 67108864 | 0;
        oe.words[0] = Ce;
        for (var ae = 1; ae < ce; ae++) {
          for (var ge = be >>> 26, Se = be & 67108863, Le = Math.min(ae, ne.length - 1), ze = Math.max(0, ae - Ae.length + 1); ze <= Le; ze++) {
            var Re = ae - ze | 0;
            le = Ae.words[Re] | 0, pe = ne.words[ze] | 0, ye = le * pe + Se, ge += ye / 67108864 | 0, Se = ye & 67108863;
          }
          oe.words[ae] = Se | 0, be = ge | 0;
        }
        return be !== 0 ? oe.words[ae] = be | 0 : oe.length--, oe.strip();
      }
      var me = function(ne, oe, ce) {
        var le = ne.words, pe = oe.words, ye = ce.words, Ce = 0, be, ae, ge, Se = le[0] | 0, Le = Se & 8191, ze = Se >>> 13, Re = le[1] | 0, We = Re & 8191, Be = Re >>> 13, Ue = le[2] | 0, Ge = Ue & 8191, je = Ue >>> 13, Oe = le[3] | 0, Ne = Oe & 8191, Ye = Oe >>> 13, Je = le[4] | 0, Xe = Je & 8191, st = Je >>> 13, ct = le[5] | 0, it = ct & 8191, ot = ct >>> 13, yt = le[6] | 0, dt = yt & 8191, mt = yt >>> 13, It = le[7] | 0, xt = It & 8191, Tt = It >>> 13, Yt = le[8] | 0, Ve = Yt & 8191, Pe = Yt >>> 13, $e = le[9] | 0, Ze = $e & 8191, at = $e >>> 13, wt = pe[0] | 0, ft = wt & 8191, Ct = wt >>> 13, Ut = pe[1] | 0, vt = Ut & 8191, Mt = Ut >>> 13, Xt = pe[2] | 0, St = Xt & 8191, Ot = Xt >>> 13, wn = pe[3] | 0, kt = wn & 8191, Bt = wn >>> 13, Tn = pe[4] | 0, Nt = Tn & 8191, Wt = Tn >>> 13, En = pe[5] | 0, Lt = En & 8191, Ht = En >>> 13, In = pe[6] | 0, Dt = In & 8191, Gt = In >>> 13, Ke = pe[7] | 0, Qe = Ke & 8191, et = Ke >>> 13, He = pe[8] | 0, nt = He & 8191, qe = He >>> 13, ht = pe[9] | 0, pt = ht & 8191, bt = ht >>> 13;
        ce.negative = ne.negative ^ oe.negative, ce.length = 19, be = Math.imul(Le, ft), ae = Math.imul(Le, Ct), ae = ae + Math.imul(ze, ft) | 0, ge = Math.imul(ze, Ct);
        var jt = (Ce + be | 0) + ((ae & 8191) << 13) | 0;
        Ce = (ge + (ae >>> 13) | 0) + (jt >>> 26) | 0, jt &= 67108863, be = Math.imul(We, ft), ae = Math.imul(We, Ct), ae = ae + Math.imul(Be, ft) | 0, ge = Math.imul(Be, Ct), be = be + Math.imul(Le, vt) | 0, ae = ae + Math.imul(Le, Mt) | 0, ae = ae + Math.imul(ze, vt) | 0, ge = ge + Math.imul(ze, Mt) | 0;
        var $t = (Ce + be | 0) + ((ae & 8191) << 13) | 0;
        Ce = (ge + (ae >>> 13) | 0) + ($t >>> 26) | 0, $t &= 67108863, be = Math.imul(Ge, ft), ae = Math.imul(Ge, Ct), ae = ae + Math.imul(je, ft) | 0, ge = Math.imul(je, Ct), be = be + Math.imul(We, vt) | 0, ae = ae + Math.imul(We, Mt) | 0, ae = ae + Math.imul(Be, vt) | 0, ge = ge + Math.imul(Be, Mt) | 0, be = be + Math.imul(Le, St) | 0, ae = ae + Math.imul(Le, Ot) | 0, ae = ae + Math.imul(ze, St) | 0, ge = ge + Math.imul(ze, Ot) | 0;
        var Jt = (Ce + be | 0) + ((ae & 8191) << 13) | 0;
        Ce = (ge + (ae >>> 13) | 0) + (Jt >>> 26) | 0, Jt &= 67108863, be = Math.imul(Ne, ft), ae = Math.imul(Ne, Ct), ae = ae + Math.imul(Ye, ft) | 0, ge = Math.imul(Ye, Ct), be = be + Math.imul(Ge, vt) | 0, ae = ae + Math.imul(Ge, Mt) | 0, ae = ae + Math.imul(je, vt) | 0, ge = ge + Math.imul(je, Mt) | 0, be = be + Math.imul(We, St) | 0, ae = ae + Math.imul(We, Ot) | 0, ae = ae + Math.imul(Be, St) | 0, ge = ge + Math.imul(Be, Ot) | 0, be = be + Math.imul(Le, kt) | 0, ae = ae + Math.imul(Le, Bt) | 0, ae = ae + Math.imul(ze, kt) | 0, ge = ge + Math.imul(ze, Bt) | 0;
        var zt = (Ce + be | 0) + ((ae & 8191) << 13) | 0;
        Ce = (ge + (ae >>> 13) | 0) + (zt >>> 26) | 0, zt &= 67108863, be = Math.imul(Xe, ft), ae = Math.imul(Xe, Ct), ae = ae + Math.imul(st, ft) | 0, ge = Math.imul(st, Ct), be = be + Math.imul(Ne, vt) | 0, ae = ae + Math.imul(Ne, Mt) | 0, ae = ae + Math.imul(Ye, vt) | 0, ge = ge + Math.imul(Ye, Mt) | 0, be = be + Math.imul(Ge, St) | 0, ae = ae + Math.imul(Ge, Ot) | 0, ae = ae + Math.imul(je, St) | 0, ge = ge + Math.imul(je, Ot) | 0, be = be + Math.imul(We, kt) | 0, ae = ae + Math.imul(We, Bt) | 0, ae = ae + Math.imul(Be, kt) | 0, ge = ge + Math.imul(Be, Bt) | 0, be = be + Math.imul(Le, Nt) | 0, ae = ae + Math.imul(Le, Wt) | 0, ae = ae + Math.imul(ze, Nt) | 0, ge = ge + Math.imul(ze, Wt) | 0;
        var Vt = (Ce + be | 0) + ((ae & 8191) << 13) | 0;
        Ce = (ge + (ae >>> 13) | 0) + (Vt >>> 26) | 0, Vt &= 67108863, be = Math.imul(it, ft), ae = Math.imul(it, Ct), ae = ae + Math.imul(ot, ft) | 0, ge = Math.imul(ot, Ct), be = be + Math.imul(Xe, vt) | 0, ae = ae + Math.imul(Xe, Mt) | 0, ae = ae + Math.imul(st, vt) | 0, ge = ge + Math.imul(st, Mt) | 0, be = be + Math.imul(Ne, St) | 0, ae = ae + Math.imul(Ne, Ot) | 0, ae = ae + Math.imul(Ye, St) | 0, ge = ge + Math.imul(Ye, Ot) | 0, be = be + Math.imul(Ge, kt) | 0, ae = ae + Math.imul(Ge, Bt) | 0, ae = ae + Math.imul(je, kt) | 0, ge = ge + Math.imul(je, Bt) | 0, be = be + Math.imul(We, Nt) | 0, ae = ae + Math.imul(We, Wt) | 0, ae = ae + Math.imul(Be, Nt) | 0, ge = ge + Math.imul(Be, Wt) | 0, be = be + Math.imul(Le, Lt) | 0, ae = ae + Math.imul(Le, Ht) | 0, ae = ae + Math.imul(ze, Lt) | 0, ge = ge + Math.imul(ze, Ht) | 0;
        var Kt = (Ce + be | 0) + ((ae & 8191) << 13) | 0;
        Ce = (ge + (ae >>> 13) | 0) + (Kt >>> 26) | 0, Kt &= 67108863, be = Math.imul(dt, ft), ae = Math.imul(dt, Ct), ae = ae + Math.imul(mt, ft) | 0, ge = Math.imul(mt, Ct), be = be + Math.imul(it, vt) | 0, ae = ae + Math.imul(it, Mt) | 0, ae = ae + Math.imul(ot, vt) | 0, ge = ge + Math.imul(ot, Mt) | 0, be = be + Math.imul(Xe, St) | 0, ae = ae + Math.imul(Xe, Ot) | 0, ae = ae + Math.imul(st, St) | 0, ge = ge + Math.imul(st, Ot) | 0, be = be + Math.imul(Ne, kt) | 0, ae = ae + Math.imul(Ne, Bt) | 0, ae = ae + Math.imul(Ye, kt) | 0, ge = ge + Math.imul(Ye, Bt) | 0, be = be + Math.imul(Ge, Nt) | 0, ae = ae + Math.imul(Ge, Wt) | 0, ae = ae + Math.imul(je, Nt) | 0, ge = ge + Math.imul(je, Wt) | 0, be = be + Math.imul(We, Lt) | 0, ae = ae + Math.imul(We, Ht) | 0, ae = ae + Math.imul(Be, Lt) | 0, ge = ge + Math.imul(Be, Ht) | 0, be = be + Math.imul(Le, Dt) | 0, ae = ae + Math.imul(Le, Gt) | 0, ae = ae + Math.imul(ze, Dt) | 0, ge = ge + Math.imul(ze, Gt) | 0;
        var pn = (Ce + be | 0) + ((ae & 8191) << 13) | 0;
        Ce = (ge + (ae >>> 13) | 0) + (pn >>> 26) | 0, pn &= 67108863, be = Math.imul(xt, ft), ae = Math.imul(xt, Ct), ae = ae + Math.imul(Tt, ft) | 0, ge = Math.imul(Tt, Ct), be = be + Math.imul(dt, vt) | 0, ae = ae + Math.imul(dt, Mt) | 0, ae = ae + Math.imul(mt, vt) | 0, ge = ge + Math.imul(mt, Mt) | 0, be = be + Math.imul(it, St) | 0, ae = ae + Math.imul(it, Ot) | 0, ae = ae + Math.imul(ot, St) | 0, ge = ge + Math.imul(ot, Ot) | 0, be = be + Math.imul(Xe, kt) | 0, ae = ae + Math.imul(Xe, Bt) | 0, ae = ae + Math.imul(st, kt) | 0, ge = ge + Math.imul(st, Bt) | 0, be = be + Math.imul(Ne, Nt) | 0, ae = ae + Math.imul(Ne, Wt) | 0, ae = ae + Math.imul(Ye, Nt) | 0, ge = ge + Math.imul(Ye, Wt) | 0, be = be + Math.imul(Ge, Lt) | 0, ae = ae + Math.imul(Ge, Ht) | 0, ae = ae + Math.imul(je, Lt) | 0, ge = ge + Math.imul(je, Ht) | 0, be = be + Math.imul(We, Dt) | 0, ae = ae + Math.imul(We, Gt) | 0, ae = ae + Math.imul(Be, Dt) | 0, ge = ge + Math.imul(Be, Gt) | 0, be = be + Math.imul(Le, Qe) | 0, ae = ae + Math.imul(Le, et) | 0, ae = ae + Math.imul(ze, Qe) | 0, ge = ge + Math.imul(ze, et) | 0;
        var An = (Ce + be | 0) + ((ae & 8191) << 13) | 0;
        Ce = (ge + (ae >>> 13) | 0) + (An >>> 26) | 0, An &= 67108863, be = Math.imul(Ve, ft), ae = Math.imul(Ve, Ct), ae = ae + Math.imul(Pe, ft) | 0, ge = Math.imul(Pe, Ct), be = be + Math.imul(xt, vt) | 0, ae = ae + Math.imul(xt, Mt) | 0, ae = ae + Math.imul(Tt, vt) | 0, ge = ge + Math.imul(Tt, Mt) | 0, be = be + Math.imul(dt, St) | 0, ae = ae + Math.imul(dt, Ot) | 0, ae = ae + Math.imul(mt, St) | 0, ge = ge + Math.imul(mt, Ot) | 0, be = be + Math.imul(it, kt) | 0, ae = ae + Math.imul(it, Bt) | 0, ae = ae + Math.imul(ot, kt) | 0, ge = ge + Math.imul(ot, Bt) | 0, be = be + Math.imul(Xe, Nt) | 0, ae = ae + Math.imul(Xe, Wt) | 0, ae = ae + Math.imul(st, Nt) | 0, ge = ge + Math.imul(st, Wt) | 0, be = be + Math.imul(Ne, Lt) | 0, ae = ae + Math.imul(Ne, Ht) | 0, ae = ae + Math.imul(Ye, Lt) | 0, ge = ge + Math.imul(Ye, Ht) | 0, be = be + Math.imul(Ge, Dt) | 0, ae = ae + Math.imul(Ge, Gt) | 0, ae = ae + Math.imul(je, Dt) | 0, ge = ge + Math.imul(je, Gt) | 0, be = be + Math.imul(We, Qe) | 0, ae = ae + Math.imul(We, et) | 0, ae = ae + Math.imul(Be, Qe) | 0, ge = ge + Math.imul(Be, et) | 0, be = be + Math.imul(Le, nt) | 0, ae = ae + Math.imul(Le, qe) | 0, ae = ae + Math.imul(ze, nt) | 0, ge = ge + Math.imul(ze, qe) | 0;
        var vn = (Ce + be | 0) + ((ae & 8191) << 13) | 0;
        Ce = (ge + (ae >>> 13) | 0) + (vn >>> 26) | 0, vn &= 67108863, be = Math.imul(Ze, ft), ae = Math.imul(Ze, Ct), ae = ae + Math.imul(at, ft) | 0, ge = Math.imul(at, Ct), be = be + Math.imul(Ve, vt) | 0, ae = ae + Math.imul(Ve, Mt) | 0, ae = ae + Math.imul(Pe, vt) | 0, ge = ge + Math.imul(Pe, Mt) | 0, be = be + Math.imul(xt, St) | 0, ae = ae + Math.imul(xt, Ot) | 0, ae = ae + Math.imul(Tt, St) | 0, ge = ge + Math.imul(Tt, Ot) | 0, be = be + Math.imul(dt, kt) | 0, ae = ae + Math.imul(dt, Bt) | 0, ae = ae + Math.imul(mt, kt) | 0, ge = ge + Math.imul(mt, Bt) | 0, be = be + Math.imul(it, Nt) | 0, ae = ae + Math.imul(it, Wt) | 0, ae = ae + Math.imul(ot, Nt) | 0, ge = ge + Math.imul(ot, Wt) | 0, be = be + Math.imul(Xe, Lt) | 0, ae = ae + Math.imul(Xe, Ht) | 0, ae = ae + Math.imul(st, Lt) | 0, ge = ge + Math.imul(st, Ht) | 0, be = be + Math.imul(Ne, Dt) | 0, ae = ae + Math.imul(Ne, Gt) | 0, ae = ae + Math.imul(Ye, Dt) | 0, ge = ge + Math.imul(Ye, Gt) | 0, be = be + Math.imul(Ge, Qe) | 0, ae = ae + Math.imul(Ge, et) | 0, ae = ae + Math.imul(je, Qe) | 0, ge = ge + Math.imul(je, et) | 0, be = be + Math.imul(We, nt) | 0, ae = ae + Math.imul(We, qe) | 0, ae = ae + Math.imul(Be, nt) | 0, ge = ge + Math.imul(Be, qe) | 0, be = be + Math.imul(Le, pt) | 0, ae = ae + Math.imul(Le, bt) | 0, ae = ae + Math.imul(ze, pt) | 0, ge = ge + Math.imul(ze, bt) | 0;
        var Cn = (Ce + be | 0) + ((ae & 8191) << 13) | 0;
        Ce = (ge + (ae >>> 13) | 0) + (Cn >>> 26) | 0, Cn &= 67108863, be = Math.imul(Ze, vt), ae = Math.imul(Ze, Mt), ae = ae + Math.imul(at, vt) | 0, ge = Math.imul(at, Mt), be = be + Math.imul(Ve, St) | 0, ae = ae + Math.imul(Ve, Ot) | 0, ae = ae + Math.imul(Pe, St) | 0, ge = ge + Math.imul(Pe, Ot) | 0, be = be + Math.imul(xt, kt) | 0, ae = ae + Math.imul(xt, Bt) | 0, ae = ae + Math.imul(Tt, kt) | 0, ge = ge + Math.imul(Tt, Bt) | 0, be = be + Math.imul(dt, Nt) | 0, ae = ae + Math.imul(dt, Wt) | 0, ae = ae + Math.imul(mt, Nt) | 0, ge = ge + Math.imul(mt, Wt) | 0, be = be + Math.imul(it, Lt) | 0, ae = ae + Math.imul(it, Ht) | 0, ae = ae + Math.imul(ot, Lt) | 0, ge = ge + Math.imul(ot, Ht) | 0, be = be + Math.imul(Xe, Dt) | 0, ae = ae + Math.imul(Xe, Gt) | 0, ae = ae + Math.imul(st, Dt) | 0, ge = ge + Math.imul(st, Gt) | 0, be = be + Math.imul(Ne, Qe) | 0, ae = ae + Math.imul(Ne, et) | 0, ae = ae + Math.imul(Ye, Qe) | 0, ge = ge + Math.imul(Ye, et) | 0, be = be + Math.imul(Ge, nt) | 0, ae = ae + Math.imul(Ge, qe) | 0, ae = ae + Math.imul(je, nt) | 0, ge = ge + Math.imul(je, qe) | 0, be = be + Math.imul(We, pt) | 0, ae = ae + Math.imul(We, bt) | 0, ae = ae + Math.imul(Be, pt) | 0, ge = ge + Math.imul(Be, bt) | 0;
        var yn = (Ce + be | 0) + ((ae & 8191) << 13) | 0;
        Ce = (ge + (ae >>> 13) | 0) + (yn >>> 26) | 0, yn &= 67108863, be = Math.imul(Ze, St), ae = Math.imul(Ze, Ot), ae = ae + Math.imul(at, St) | 0, ge = Math.imul(at, Ot), be = be + Math.imul(Ve, kt) | 0, ae = ae + Math.imul(Ve, Bt) | 0, ae = ae + Math.imul(Pe, kt) | 0, ge = ge + Math.imul(Pe, Bt) | 0, be = be + Math.imul(xt, Nt) | 0, ae = ae + Math.imul(xt, Wt) | 0, ae = ae + Math.imul(Tt, Nt) | 0, ge = ge + Math.imul(Tt, Wt) | 0, be = be + Math.imul(dt, Lt) | 0, ae = ae + Math.imul(dt, Ht) | 0, ae = ae + Math.imul(mt, Lt) | 0, ge = ge + Math.imul(mt, Ht) | 0, be = be + Math.imul(it, Dt) | 0, ae = ae + Math.imul(it, Gt) | 0, ae = ae + Math.imul(ot, Dt) | 0, ge = ge + Math.imul(ot, Gt) | 0, be = be + Math.imul(Xe, Qe) | 0, ae = ae + Math.imul(Xe, et) | 0, ae = ae + Math.imul(st, Qe) | 0, ge = ge + Math.imul(st, et) | 0, be = be + Math.imul(Ne, nt) | 0, ae = ae + Math.imul(Ne, qe) | 0, ae = ae + Math.imul(Ye, nt) | 0, ge = ge + Math.imul(Ye, qe) | 0, be = be + Math.imul(Ge, pt) | 0, ae = ae + Math.imul(Ge, bt) | 0, ae = ae + Math.imul(je, pt) | 0, ge = ge + Math.imul(je, bt) | 0;
        var dn = (Ce + be | 0) + ((ae & 8191) << 13) | 0;
        Ce = (ge + (ae >>> 13) | 0) + (dn >>> 26) | 0, dn &= 67108863, be = Math.imul(Ze, kt), ae = Math.imul(Ze, Bt), ae = ae + Math.imul(at, kt) | 0, ge = Math.imul(at, Bt), be = be + Math.imul(Ve, Nt) | 0, ae = ae + Math.imul(Ve, Wt) | 0, ae = ae + Math.imul(Pe, Nt) | 0, ge = ge + Math.imul(Pe, Wt) | 0, be = be + Math.imul(xt, Lt) | 0, ae = ae + Math.imul(xt, Ht) | 0, ae = ae + Math.imul(Tt, Lt) | 0, ge = ge + Math.imul(Tt, Ht) | 0, be = be + Math.imul(dt, Dt) | 0, ae = ae + Math.imul(dt, Gt) | 0, ae = ae + Math.imul(mt, Dt) | 0, ge = ge + Math.imul(mt, Gt) | 0, be = be + Math.imul(it, Qe) | 0, ae = ae + Math.imul(it, et) | 0, ae = ae + Math.imul(ot, Qe) | 0, ge = ge + Math.imul(ot, et) | 0, be = be + Math.imul(Xe, nt) | 0, ae = ae + Math.imul(Xe, qe) | 0, ae = ae + Math.imul(st, nt) | 0, ge = ge + Math.imul(st, qe) | 0, be = be + Math.imul(Ne, pt) | 0, ae = ae + Math.imul(Ne, bt) | 0, ae = ae + Math.imul(Ye, pt) | 0, ge = ge + Math.imul(Ye, bt) | 0;
        var xn = (Ce + be | 0) + ((ae & 8191) << 13) | 0;
        Ce = (ge + (ae >>> 13) | 0) + (xn >>> 26) | 0, xn &= 67108863, be = Math.imul(Ze, Nt), ae = Math.imul(Ze, Wt), ae = ae + Math.imul(at, Nt) | 0, ge = Math.imul(at, Wt), be = be + Math.imul(Ve, Lt) | 0, ae = ae + Math.imul(Ve, Ht) | 0, ae = ae + Math.imul(Pe, Lt) | 0, ge = ge + Math.imul(Pe, Ht) | 0, be = be + Math.imul(xt, Dt) | 0, ae = ae + Math.imul(xt, Gt) | 0, ae = ae + Math.imul(Tt, Dt) | 0, ge = ge + Math.imul(Tt, Gt) | 0, be = be + Math.imul(dt, Qe) | 0, ae = ae + Math.imul(dt, et) | 0, ae = ae + Math.imul(mt, Qe) | 0, ge = ge + Math.imul(mt, et) | 0, be = be + Math.imul(it, nt) | 0, ae = ae + Math.imul(it, qe) | 0, ae = ae + Math.imul(ot, nt) | 0, ge = ge + Math.imul(ot, qe) | 0, be = be + Math.imul(Xe, pt) | 0, ae = ae + Math.imul(Xe, bt) | 0, ae = ae + Math.imul(st, pt) | 0, ge = ge + Math.imul(st, bt) | 0;
        var ln = (Ce + be | 0) + ((ae & 8191) << 13) | 0;
        Ce = (ge + (ae >>> 13) | 0) + (ln >>> 26) | 0, ln &= 67108863, be = Math.imul(Ze, Lt), ae = Math.imul(Ze, Ht), ae = ae + Math.imul(at, Lt) | 0, ge = Math.imul(at, Ht), be = be + Math.imul(Ve, Dt) | 0, ae = ae + Math.imul(Ve, Gt) | 0, ae = ae + Math.imul(Pe, Dt) | 0, ge = ge + Math.imul(Pe, Gt) | 0, be = be + Math.imul(xt, Qe) | 0, ae = ae + Math.imul(xt, et) | 0, ae = ae + Math.imul(Tt, Qe) | 0, ge = ge + Math.imul(Tt, et) | 0, be = be + Math.imul(dt, nt) | 0, ae = ae + Math.imul(dt, qe) | 0, ae = ae + Math.imul(mt, nt) | 0, ge = ge + Math.imul(mt, qe) | 0, be = be + Math.imul(it, pt) | 0, ae = ae + Math.imul(it, bt) | 0, ae = ae + Math.imul(ot, pt) | 0, ge = ge + Math.imul(ot, bt) | 0;
        var mn = (Ce + be | 0) + ((ae & 8191) << 13) | 0;
        Ce = (ge + (ae >>> 13) | 0) + (mn >>> 26) | 0, mn &= 67108863, be = Math.imul(Ze, Dt), ae = Math.imul(Ze, Gt), ae = ae + Math.imul(at, Dt) | 0, ge = Math.imul(at, Gt), be = be + Math.imul(Ve, Qe) | 0, ae = ae + Math.imul(Ve, et) | 0, ae = ae + Math.imul(Pe, Qe) | 0, ge = ge + Math.imul(Pe, et) | 0, be = be + Math.imul(xt, nt) | 0, ae = ae + Math.imul(xt, qe) | 0, ae = ae + Math.imul(Tt, nt) | 0, ge = ge + Math.imul(Tt, qe) | 0, be = be + Math.imul(dt, pt) | 0, ae = ae + Math.imul(dt, bt) | 0, ae = ae + Math.imul(mt, pt) | 0, ge = ge + Math.imul(mt, bt) | 0;
        var gn = (Ce + be | 0) + ((ae & 8191) << 13) | 0;
        Ce = (ge + (ae >>> 13) | 0) + (gn >>> 26) | 0, gn &= 67108863, be = Math.imul(Ze, Qe), ae = Math.imul(Ze, et), ae = ae + Math.imul(at, Qe) | 0, ge = Math.imul(at, et), be = be + Math.imul(Ve, nt) | 0, ae = ae + Math.imul(Ve, qe) | 0, ae = ae + Math.imul(Pe, nt) | 0, ge = ge + Math.imul(Pe, qe) | 0, be = be + Math.imul(xt, pt) | 0, ae = ae + Math.imul(xt, bt) | 0, ae = ae + Math.imul(Tt, pt) | 0, ge = ge + Math.imul(Tt, bt) | 0;
        var cn = (Ce + be | 0) + ((ae & 8191) << 13) | 0;
        Ce = (ge + (ae >>> 13) | 0) + (cn >>> 26) | 0, cn &= 67108863, be = Math.imul(Ze, nt), ae = Math.imul(Ze, qe), ae = ae + Math.imul(at, nt) | 0, ge = Math.imul(at, qe), be = be + Math.imul(Ve, pt) | 0, ae = ae + Math.imul(Ve, bt) | 0, ae = ae + Math.imul(Pe, pt) | 0, ge = ge + Math.imul(Pe, bt) | 0;
        var Pt = (Ce + be | 0) + ((ae & 8191) << 13) | 0;
        Ce = (ge + (ae >>> 13) | 0) + (Pt >>> 26) | 0, Pt &= 67108863, be = Math.imul(Ze, pt), ae = Math.imul(Ze, bt), ae = ae + Math.imul(at, pt) | 0, ge = Math.imul(at, bt);
        var Rt = (Ce + be | 0) + ((ae & 8191) << 13) | 0;
        return Ce = (ge + (ae >>> 13) | 0) + (Rt >>> 26) | 0, Rt &= 67108863, ye[0] = jt, ye[1] = $t, ye[2] = Jt, ye[3] = zt, ye[4] = Vt, ye[5] = Kt, ye[6] = pn, ye[7] = An, ye[8] = vn, ye[9] = Cn, ye[10] = yn, ye[11] = dn, ye[12] = xn, ye[13] = ln, ye[14] = mn, ye[15] = gn, ye[16] = cn, ye[17] = Pt, ye[18] = Rt, Ce !== 0 && (ye[19] = Ce, ce.length++), ce;
      };
      Math.imul || (me = he);
      function xe(Ae, ne, oe) {
        oe.negative = ne.negative ^ Ae.negative, oe.length = Ae.length + ne.length;
        for (var ce = 0, le = 0, pe = 0; pe < oe.length - 1; pe++) {
          var ye = le;
          le = 0;
          for (var Ce = ce & 67108863, be = Math.min(pe, ne.length - 1), ae = Math.max(0, pe - Ae.length + 1); ae <= be; ae++) {
            var ge = pe - ae, Se = Ae.words[ge] | 0, Le = ne.words[ae] | 0, ze = Se * Le, Re = ze & 67108863;
            ye = ye + (ze / 67108864 | 0) | 0, Re = Re + Ce | 0, Ce = Re & 67108863, ye = ye + (Re >>> 26) | 0, le += ye >>> 26, ye &= 67108863;
          }
          oe.words[pe] = Ce, ce = ye, ye = le;
        }
        return ce !== 0 ? oe.words[pe] = ce : oe.length--, oe.strip();
      }
      function ve(Ae, ne, oe) {
        var ce = new Te();
        return ce.mulp(Ae, ne, oe);
      }
      J.prototype.mulTo = function(ne, oe) {
        var ce, le = this.length + ne.length;
        return this.length === 10 && ne.length === 10 ? ce = me(this, ne, oe) : le < 63 ? ce = he(this, ne, oe) : le < 1024 ? ce = xe(this, ne, oe) : ce = ve(this, ne, oe), ce;
      };
      function Te(Ae, ne) {
        this.x = Ae, this.y = ne;
      }
      Te.prototype.makeRBT = function(ne) {
        for (var oe = new Array(ne), ce = J.prototype._countBits(ne) - 1, le = 0; le < ne; le++)
          oe[le] = this.revBin(le, ce, ne);
        return oe;
      }, Te.prototype.revBin = function(ne, oe, ce) {
        if (ne === 0 || ne === ce - 1) return ne;
        for (var le = 0, pe = 0; pe < oe; pe++)
          le |= (ne & 1) << oe - pe - 1, ne >>= 1;
        return le;
      }, Te.prototype.permute = function(ne, oe, ce, le, pe, ye) {
        for (var Ce = 0; Ce < ye; Ce++)
          le[Ce] = oe[ne[Ce]], pe[Ce] = ce[ne[Ce]];
      }, Te.prototype.transform = function(ne, oe, ce, le, pe, ye) {
        this.permute(ye, ne, oe, ce, le, pe);
        for (var Ce = 1; Ce < pe; Ce <<= 1)
          for (var be = Ce << 1, ae = Math.cos(2 * Math.PI / be), ge = Math.sin(2 * Math.PI / be), Se = 0; Se < pe; Se += be)
            for (var Le = ae, ze = ge, Re = 0; Re < Ce; Re++) {
              var We = ce[Se + Re], Be = le[Se + Re], Ue = ce[Se + Re + Ce], Ge = le[Se + Re + Ce], je = Le * Ue - ze * Ge;
              Ge = Le * Ge + ze * Ue, Ue = je, ce[Se + Re] = We + Ue, le[Se + Re] = Be + Ge, ce[Se + Re + Ce] = We - Ue, le[Se + Re + Ce] = Be - Ge, Re !== be && (je = ae * Le - ge * ze, ze = ae * ze + ge * Le, Le = je);
            }
      }, Te.prototype.guessLen13b = function(ne, oe) {
        var ce = Math.max(oe, ne) | 1, le = ce & 1, pe = 0;
        for (ce = ce / 2 | 0; ce; ce = ce >>> 1)
          pe++;
        return 1 << pe + 1 + le;
      }, Te.prototype.conjugate = function(ne, oe, ce) {
        if (!(ce <= 1))
          for (var le = 0; le < ce / 2; le++) {
            var pe = ne[le];
            ne[le] = ne[ce - le - 1], ne[ce - le - 1] = pe, pe = oe[le], oe[le] = -oe[ce - le - 1], oe[ce - le - 1] = -pe;
          }
      }, Te.prototype.normalize13b = function(ne, oe) {
        for (var ce = 0, le = 0; le < oe / 2; le++) {
          var pe = Math.round(ne[2 * le + 1] / oe) * 8192 + Math.round(ne[2 * le] / oe) + ce;
          ne[le] = pe & 67108863, pe < 67108864 ? ce = 0 : ce = pe / 67108864 | 0;
        }
        return ne;
      }, Te.prototype.convert13b = function(ne, oe, ce, le) {
        for (var pe = 0, ye = 0; ye < oe; ye++)
          pe = pe + (ne[ye] | 0), ce[2 * ye] = pe & 8191, pe = pe >>> 13, ce[2 * ye + 1] = pe & 8191, pe = pe >>> 13;
        for (ye = 2 * oe; ye < le; ++ye)
          ce[ye] = 0;
        $(pe === 0), $((pe & -8192) === 0);
      }, Te.prototype.stub = function(ne) {
        for (var oe = new Array(ne), ce = 0; ce < ne; ce++)
          oe[ce] = 0;
        return oe;
      }, Te.prototype.mulp = function(ne, oe, ce) {
        var le = 2 * this.guessLen13b(ne.length, oe.length), pe = this.makeRBT(le), ye = this.stub(le), Ce = new Array(le), be = new Array(le), ae = new Array(le), ge = new Array(le), Se = new Array(le), Le = new Array(le), ze = ce.words;
        ze.length = le, this.convert13b(ne.words, ne.length, Ce, le), this.convert13b(oe.words, oe.length, ge, le), this.transform(Ce, ye, be, ae, le, pe), this.transform(ge, ye, Se, Le, le, pe);
        for (var Re = 0; Re < le; Re++) {
          var We = be[Re] * Se[Re] - ae[Re] * Le[Re];
          ae[Re] = be[Re] * Le[Re] + ae[Re] * Se[Re], be[Re] = We;
        }
        return this.conjugate(be, ae, le), this.transform(be, ae, ze, ye, le, pe), this.conjugate(ze, ye, le), this.normalize13b(ze, le), ce.negative = ne.negative ^ oe.negative, ce.length = ne.length + oe.length, ce.strip();
      }, J.prototype.mul = function(ne) {
        var oe = new J(null);
        return oe.words = new Array(this.length + ne.length), this.mulTo(ne, oe);
      }, J.prototype.mulf = function(ne) {
        var oe = new J(null);
        return oe.words = new Array(this.length + ne.length), ve(this, ne, oe);
      }, J.prototype.imul = function(ne) {
        return this.clone().mulTo(ne, this);
      }, J.prototype.imuln = function(ne) {
        $(typeof ne == "number"), $(ne < 67108864);
        for (var oe = 0, ce = 0; ce < this.length; ce++) {
          var le = (this.words[ce] | 0) * ne, pe = (le & 67108863) + (oe & 67108863);
          oe >>= 26, oe += le / 67108864 | 0, oe += pe >>> 26, this.words[ce] = pe & 67108863;
        }
        return oe !== 0 && (this.words[ce] = oe, this.length++), this;
      }, J.prototype.muln = function(ne) {
        return this.clone().imuln(ne);
      }, J.prototype.sqr = function() {
        return this.mul(this);
      }, J.prototype.isqr = function() {
        return this.imul(this.clone());
      }, J.prototype.pow = function(ne) {
        var oe = fe(ne);
        if (oe.length === 0) return new J(1);
        for (var ce = this, le = 0; le < oe.length && oe[le] === 0; le++, ce = ce.sqr())
          ;
        if (++le < oe.length)
          for (var pe = ce.sqr(); le < oe.length; le++, pe = pe.sqr())
            oe[le] !== 0 && (ce = ce.mul(pe));
        return ce;
      }, J.prototype.iushln = function(ne) {
        $(typeof ne == "number" && ne >= 0);
        var oe = ne % 26, ce = (ne - oe) / 26, le = 67108863 >>> 26 - oe << 26 - oe, pe;
        if (oe !== 0) {
          var ye = 0;
          for (pe = 0; pe < this.length; pe++) {
            var Ce = this.words[pe] & le, be = (this.words[pe] | 0) - Ce << oe;
            this.words[pe] = be | ye, ye = Ce >>> 26 - oe;
          }
          ye && (this.words[pe] = ye, this.length++);
        }
        if (ce !== 0) {
          for (pe = this.length - 1; pe >= 0; pe--)
            this.words[pe + ce] = this.words[pe];
          for (pe = 0; pe < ce; pe++)
            this.words[pe] = 0;
          this.length += ce;
        }
        return this.strip();
      }, J.prototype.ishln = function(ne) {
        return $(this.negative === 0), this.iushln(ne);
      }, J.prototype.iushrn = function(ne, oe, ce) {
        $(typeof ne == "number" && ne >= 0);
        var le;
        oe ? le = (oe - oe % 26) / 26 : le = 0;
        var pe = ne % 26, ye = Math.min((ne - pe) / 26, this.length), Ce = 67108863 ^ 67108863 >>> pe << pe, be = ce;
        if (le -= ye, le = Math.max(0, le), be) {
          for (var ae = 0; ae < ye; ae++)
            be.words[ae] = this.words[ae];
          be.length = ye;
        }
        if (ye !== 0) if (this.length > ye)
          for (this.length -= ye, ae = 0; ae < this.length; ae++)
            this.words[ae] = this.words[ae + ye];
        else
          this.words[0] = 0, this.length = 1;
        var ge = 0;
        for (ae = this.length - 1; ae >= 0 && (ge !== 0 || ae >= le); ae--) {
          var Se = this.words[ae] | 0;
          this.words[ae] = ge << 26 - pe | Se >>> pe, ge = Se & Ce;
        }
        return be && ge !== 0 && (be.words[be.length++] = ge), this.length === 0 && (this.words[0] = 0, this.length = 1), this.strip();
      }, J.prototype.ishrn = function(ne, oe, ce) {
        return $(this.negative === 0), this.iushrn(ne, oe, ce);
      }, J.prototype.shln = function(ne) {
        return this.clone().ishln(ne);
      }, J.prototype.ushln = function(ne) {
        return this.clone().iushln(ne);
      }, J.prototype.shrn = function(ne) {
        return this.clone().ishrn(ne);
      }, J.prototype.ushrn = function(ne) {
        return this.clone().iushrn(ne);
      }, J.prototype.testn = function(ne) {
        $(typeof ne == "number" && ne >= 0);
        var oe = ne % 26, ce = (ne - oe) / 26, le = 1 << oe;
        if (this.length <= ce) return !1;
        var pe = this.words[ce];
        return !!(pe & le);
      }, J.prototype.imaskn = function(ne) {
        $(typeof ne == "number" && ne >= 0);
        var oe = ne % 26, ce = (ne - oe) / 26;
        if ($(this.negative === 0, "imaskn works only with positive numbers"), this.length <= ce)
          return this;
        if (oe !== 0 && ce++, this.length = Math.min(ce, this.length), oe !== 0) {
          var le = 67108863 ^ 67108863 >>> oe << oe;
          this.words[this.length - 1] &= le;
        }
        return this.strip();
      }, J.prototype.maskn = function(ne) {
        return this.clone().imaskn(ne);
      }, J.prototype.iaddn = function(ne) {
        return $(typeof ne == "number"), $(ne < 67108864), ne < 0 ? this.isubn(-ne) : this.negative !== 0 ? this.length === 1 && (this.words[0] | 0) < ne ? (this.words[0] = ne - (this.words[0] | 0), this.negative = 0, this) : (this.negative = 0, this.isubn(ne), this.negative = 1, this) : this._iaddn(ne);
      }, J.prototype._iaddn = function(ne) {
        this.words[0] += ne;
        for (var oe = 0; oe < this.length && this.words[oe] >= 67108864; oe++)
          this.words[oe] -= 67108864, oe === this.length - 1 ? this.words[oe + 1] = 1 : this.words[oe + 1]++;
        return this.length = Math.max(this.length, oe + 1), this;
      }, J.prototype.isubn = function(ne) {
        if ($(typeof ne == "number"), $(ne < 67108864), ne < 0) return this.iaddn(-ne);
        if (this.negative !== 0)
          return this.negative = 0, this.iaddn(ne), this.negative = 1, this;
        if (this.words[0] -= ne, this.length === 1 && this.words[0] < 0)
          this.words[0] = -this.words[0], this.negative = 1;
        else
          for (var oe = 0; oe < this.length && this.words[oe] < 0; oe++)
            this.words[oe] += 67108864, this.words[oe + 1] -= 1;
        return this.strip();
      }, J.prototype.addn = function(ne) {
        return this.clone().iaddn(ne);
      }, J.prototype.subn = function(ne) {
        return this.clone().isubn(ne);
      }, J.prototype.iabs = function() {
        return this.negative = 0, this;
      }, J.prototype.abs = function() {
        return this.clone().iabs();
      }, J.prototype._ishlnsubmul = function(ne, oe, ce) {
        var le = ne.length + ce, pe;
        this._expand(le);
        var ye, Ce = 0;
        for (pe = 0; pe < ne.length; pe++) {
          ye = (this.words[pe + ce] | 0) + Ce;
          var be = (ne.words[pe] | 0) * oe;
          ye -= be & 67108863, Ce = (ye >> 26) - (be / 67108864 | 0), this.words[pe + ce] = ye & 67108863;
        }
        for (; pe < this.length - ce; pe++)
          ye = (this.words[pe + ce] | 0) + Ce, Ce = ye >> 26, this.words[pe + ce] = ye & 67108863;
        if (Ce === 0) return this.strip();
        for ($(Ce === -1), Ce = 0, pe = 0; pe < this.length; pe++)
          ye = -(this.words[pe] | 0) + Ce, Ce = ye >> 26, this.words[pe] = ye & 67108863;
        return this.negative = 1, this.strip();
      }, J.prototype._wordDiv = function(ne, oe) {
        var ce = this.length - ne.length, le = this.clone(), pe = ne, ye = pe.words[pe.length - 1] | 0, Ce = this._countBits(ye);
        ce = 26 - Ce, ce !== 0 && (pe = pe.ushln(ce), le.iushln(ce), ye = pe.words[pe.length - 1] | 0);
        var be = le.length - pe.length, ae;
        if (oe !== "mod") {
          ae = new J(null), ae.length = be + 1, ae.words = new Array(ae.length);
          for (var ge = 0; ge < ae.length; ge++)
            ae.words[ge] = 0;
        }
        var Se = le.clone()._ishlnsubmul(pe, 1, be);
        Se.negative === 0 && (le = Se, ae && (ae.words[be] = 1));
        for (var Le = be - 1; Le >= 0; Le--) {
          var ze = (le.words[pe.length + Le] | 0) * 67108864 + (le.words[pe.length + Le - 1] | 0);
          for (ze = Math.min(ze / ye | 0, 67108863), le._ishlnsubmul(pe, ze, Le); le.negative !== 0; )
            ze--, le.negative = 0, le._ishlnsubmul(pe, 1, Le), le.isZero() || (le.negative ^= 1);
          ae && (ae.words[Le] = ze);
        }
        return ae && ae.strip(), le.strip(), oe !== "div" && ce !== 0 && le.iushrn(ce), {
          div: ae || null,
          mod: le
        };
      }, J.prototype.divmod = function(ne, oe, ce) {
        if ($(!ne.isZero()), this.isZero())
          return {
            div: new J(0),
            mod: new J(0)
          };
        var le, pe, ye;
        return this.negative !== 0 && ne.negative === 0 ? (ye = this.neg().divmod(ne, oe), oe !== "mod" && (le = ye.div.neg()), oe !== "div" && (pe = ye.mod.neg(), ce && pe.negative !== 0 && pe.iadd(ne)), {
          div: le,
          mod: pe
        }) : this.negative === 0 && ne.negative !== 0 ? (ye = this.divmod(ne.neg(), oe), oe !== "mod" && (le = ye.div.neg()), {
          div: le,
          mod: ye.mod
        }) : this.negative & ne.negative ? (ye = this.neg().divmod(ne.neg(), oe), oe !== "div" && (pe = ye.mod.neg(), ce && pe.negative !== 0 && pe.isub(ne)), {
          div: ye.div,
          mod: pe
        }) : ne.length > this.length || this.cmp(ne) < 0 ? {
          div: new J(0),
          mod: this
        } : ne.length === 1 ? oe === "div" ? {
          div: this.divn(ne.words[0]),
          mod: null
        } : oe === "mod" ? {
          div: null,
          mod: new J(this.modn(ne.words[0]))
        } : {
          div: this.divn(ne.words[0]),
          mod: new J(this.modn(ne.words[0]))
        } : this._wordDiv(ne, oe);
      }, J.prototype.div = function(ne) {
        return this.divmod(ne, "div", !1).div;
      }, J.prototype.mod = function(ne) {
        return this.divmod(ne, "mod", !1).mod;
      }, J.prototype.umod = function(ne) {
        return this.divmod(ne, "mod", !0).mod;
      }, J.prototype.divRound = function(ne) {
        var oe = this.divmod(ne);
        if (oe.mod.isZero()) return oe.div;
        var ce = oe.div.negative !== 0 ? oe.mod.isub(ne) : oe.mod, le = ne.ushrn(1), pe = ne.andln(1), ye = ce.cmp(le);
        return ye < 0 || pe === 1 && ye === 0 ? oe.div : oe.div.negative !== 0 ? oe.div.isubn(1) : oe.div.iaddn(1);
      }, J.prototype.modn = function(ne) {
        $(ne <= 67108863);
        for (var oe = (1 << 26) % ne, ce = 0, le = this.length - 1; le >= 0; le--)
          ce = (oe * ce + (this.words[le] | 0)) % ne;
        return ce;
      }, J.prototype.idivn = function(ne) {
        $(ne <= 67108863);
        for (var oe = 0, ce = this.length - 1; ce >= 0; ce--) {
          var le = (this.words[ce] | 0) + oe * 67108864;
          this.words[ce] = le / ne | 0, oe = le % ne;
        }
        return this.strip();
      }, J.prototype.divn = function(ne) {
        return this.clone().idivn(ne);
      }, J.prototype.egcd = function(ne) {
        $(ne.negative === 0), $(!ne.isZero());
        var oe = this, ce = ne.clone();
        oe.negative !== 0 ? oe = oe.umod(ne) : oe = oe.clone();
        for (var le = new J(1), pe = new J(0), ye = new J(0), Ce = new J(1), be = 0; oe.isEven() && ce.isEven(); )
          oe.iushrn(1), ce.iushrn(1), ++be;
        for (var ae = ce.clone(), ge = oe.clone(); !oe.isZero(); ) {
          for (var Se = 0, Le = 1; !(oe.words[0] & Le) && Se < 26; ++Se, Le <<= 1) ;
          if (Se > 0)
            for (oe.iushrn(Se); Se-- > 0; )
              (le.isOdd() || pe.isOdd()) && (le.iadd(ae), pe.isub(ge)), le.iushrn(1), pe.iushrn(1);
          for (var ze = 0, Re = 1; !(ce.words[0] & Re) && ze < 26; ++ze, Re <<= 1) ;
          if (ze > 0)
            for (ce.iushrn(ze); ze-- > 0; )
              (ye.isOdd() || Ce.isOdd()) && (ye.iadd(ae), Ce.isub(ge)), ye.iushrn(1), Ce.iushrn(1);
          oe.cmp(ce) >= 0 ? (oe.isub(ce), le.isub(ye), pe.isub(Ce)) : (ce.isub(oe), ye.isub(le), Ce.isub(pe));
        }
        return {
          a: ye,
          b: Ce,
          gcd: ce.iushln(be)
        };
      }, J.prototype._invmp = function(ne) {
        $(ne.negative === 0), $(!ne.isZero());
        var oe = this, ce = ne.clone();
        oe.negative !== 0 ? oe = oe.umod(ne) : oe = oe.clone();
        for (var le = new J(1), pe = new J(0), ye = ce.clone(); oe.cmpn(1) > 0 && ce.cmpn(1) > 0; ) {
          for (var Ce = 0, be = 1; !(oe.words[0] & be) && Ce < 26; ++Ce, be <<= 1) ;
          if (Ce > 0)
            for (oe.iushrn(Ce); Ce-- > 0; )
              le.isOdd() && le.iadd(ye), le.iushrn(1);
          for (var ae = 0, ge = 1; !(ce.words[0] & ge) && ae < 26; ++ae, ge <<= 1) ;
          if (ae > 0)
            for (ce.iushrn(ae); ae-- > 0; )
              pe.isOdd() && pe.iadd(ye), pe.iushrn(1);
          oe.cmp(ce) >= 0 ? (oe.isub(ce), le.isub(pe)) : (ce.isub(oe), pe.isub(le));
        }
        var Se;
        return oe.cmpn(1) === 0 ? Se = le : Se = pe, Se.cmpn(0) < 0 && Se.iadd(ne), Se;
      }, J.prototype.gcd = function(ne) {
        if (this.isZero()) return ne.abs();
        if (ne.isZero()) return this.abs();
        var oe = this.clone(), ce = ne.clone();
        oe.negative = 0, ce.negative = 0;
        for (var le = 0; oe.isEven() && ce.isEven(); le++)
          oe.iushrn(1), ce.iushrn(1);
        do {
          for (; oe.isEven(); )
            oe.iushrn(1);
          for (; ce.isEven(); )
            ce.iushrn(1);
          var pe = oe.cmp(ce);
          if (pe < 0) {
            var ye = oe;
            oe = ce, ce = ye;
          } else if (pe === 0 || ce.cmpn(1) === 0)
            break;
          oe.isub(ce);
        } while (!0);
        return ce.iushln(le);
      }, J.prototype.invm = function(ne) {
        return this.egcd(ne).a.umod(ne);
      }, J.prototype.isEven = function() {
        return (this.words[0] & 1) === 0;
      }, J.prototype.isOdd = function() {
        return (this.words[0] & 1) === 1;
      }, J.prototype.andln = function(ne) {
        return this.words[0] & ne;
      }, J.prototype.bincn = function(ne) {
        $(typeof ne == "number");
        var oe = ne % 26, ce = (ne - oe) / 26, le = 1 << oe;
        if (this.length <= ce)
          return this._expand(ce + 1), this.words[ce] |= le, this;
        for (var pe = le, ye = ce; pe !== 0 && ye < this.length; ye++) {
          var Ce = this.words[ye] | 0;
          Ce += pe, pe = Ce >>> 26, Ce &= 67108863, this.words[ye] = Ce;
        }
        return pe !== 0 && (this.words[ye] = pe, this.length++), this;
      }, J.prototype.isZero = function() {
        return this.length === 1 && this.words[0] === 0;
      }, J.prototype.cmpn = function(ne) {
        var oe = ne < 0;
        if (this.negative !== 0 && !oe) return -1;
        if (this.negative === 0 && oe) return 1;
        this.strip();
        var ce;
        if (this.length > 1)
          ce = 1;
        else {
          oe && (ne = -ne), $(ne <= 67108863, "Number is too big");
          var le = this.words[0] | 0;
          ce = le === ne ? 0 : le < ne ? -1 : 1;
        }
        return this.negative !== 0 ? -ce | 0 : ce;
      }, J.prototype.cmp = function(ne) {
        if (this.negative !== 0 && ne.negative === 0) return -1;
        if (this.negative === 0 && ne.negative !== 0) return 1;
        var oe = this.ucmp(ne);
        return this.negative !== 0 ? -oe | 0 : oe;
      }, J.prototype.ucmp = function(ne) {
        if (this.length > ne.length) return 1;
        if (this.length < ne.length) return -1;
        for (var oe = 0, ce = this.length - 1; ce >= 0; ce--) {
          var le = this.words[ce] | 0, pe = ne.words[ce] | 0;
          if (le !== pe) {
            le < pe ? oe = -1 : le > pe && (oe = 1);
            break;
          }
        }
        return oe;
      }, J.prototype.gtn = function(ne) {
        return this.cmpn(ne) === 1;
      }, J.prototype.gt = function(ne) {
        return this.cmp(ne) === 1;
      }, J.prototype.gten = function(ne) {
        return this.cmpn(ne) >= 0;
      }, J.prototype.gte = function(ne) {
        return this.cmp(ne) >= 0;
      }, J.prototype.ltn = function(ne) {
        return this.cmpn(ne) === -1;
      }, J.prototype.lt = function(ne) {
        return this.cmp(ne) === -1;
      }, J.prototype.lten = function(ne) {
        return this.cmpn(ne) <= 0;
      }, J.prototype.lte = function(ne) {
        return this.cmp(ne) <= 0;
      }, J.prototype.eqn = function(ne) {
        return this.cmpn(ne) === 0;
      }, J.prototype.eq = function(ne) {
        return this.cmp(ne) === 0;
      }, J.red = function(ne) {
        return new De(ne);
      }, J.prototype.toRed = function(ne) {
        return $(!this.red, "Already a number in reduction context"), $(this.negative === 0, "red works only with positives"), ne.convertTo(this)._forceRed(ne);
      }, J.prototype.fromRed = function() {
        return $(this.red, "fromRed works only with numbers in reduction context"), this.red.convertFrom(this);
      }, J.prototype._forceRed = function(ne) {
        return this.red = ne, this;
      }, J.prototype.forceRed = function(ne) {
        return $(!this.red, "Already a number in reduction context"), this._forceRed(ne);
      }, J.prototype.redAdd = function(ne) {
        return $(this.red, "redAdd works only with red numbers"), this.red.add(this, ne);
      }, J.prototype.redIAdd = function(ne) {
        return $(this.red, "redIAdd works only with red numbers"), this.red.iadd(this, ne);
      }, J.prototype.redSub = function(ne) {
        return $(this.red, "redSub works only with red numbers"), this.red.sub(this, ne);
      }, J.prototype.redISub = function(ne) {
        return $(this.red, "redISub works only with red numbers"), this.red.isub(this, ne);
      }, J.prototype.redShl = function(ne) {
        return $(this.red, "redShl works only with red numbers"), this.red.shl(this, ne);
      }, J.prototype.redMul = function(ne) {
        return $(this.red, "redMul works only with red numbers"), this.red._verify2(this, ne), this.red.mul(this, ne);
      }, J.prototype.redIMul = function(ne) {
        return $(this.red, "redMul works only with red numbers"), this.red._verify2(this, ne), this.red.imul(this, ne);
      }, J.prototype.redSqr = function() {
        return $(this.red, "redSqr works only with red numbers"), this.red._verify1(this), this.red.sqr(this);
      }, J.prototype.redISqr = function() {
        return $(this.red, "redISqr works only with red numbers"), this.red._verify1(this), this.red.isqr(this);
      }, J.prototype.redSqrt = function() {
        return $(this.red, "redSqrt works only with red numbers"), this.red._verify1(this), this.red.sqrt(this);
      }, J.prototype.redInvm = function() {
        return $(this.red, "redInvm works only with red numbers"), this.red._verify1(this), this.red.invm(this);
      }, J.prototype.redNeg = function() {
        return $(this.red, "redNeg works only with red numbers"), this.red._verify1(this), this.red.neg(this);
      }, J.prototype.redPow = function(ne) {
        return $(this.red && !ne.red, "redPow(normalNum)"), this.red._verify1(this), this.red.pow(this, ne);
      };
      var we = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
      };
      function Ee(Ae, ne) {
        this.name = Ae, this.p = new J(ne, 16), this.n = this.p.bitLength(), this.k = new J(1).iushln(this.n).isub(this.p), this.tmp = this._tmp();
      }
      Ee.prototype._tmp = function() {
        var ne = new J(null);
        return ne.words = new Array(Math.ceil(this.n / 13)), ne;
      }, Ee.prototype.ireduce = function(ne) {
        var oe = ne, ce;
        do
          this.split(oe, this.tmp), oe = this.imulK(oe), oe = oe.iadd(this.tmp), ce = oe.bitLength();
        while (ce > this.n);
        var le = ce < this.n ? -1 : oe.ucmp(this.p);
        return le === 0 ? (oe.words[0] = 0, oe.length = 1) : le > 0 ? oe.isub(this.p) : oe.strip !== void 0 ? oe.strip() : oe._strip(), oe;
      }, Ee.prototype.split = function(ne, oe) {
        ne.iushrn(this.n, 0, oe);
      }, Ee.prototype.imulK = function(ne) {
        return ne.imul(this.k);
      };
      function Me() {
        Ee.call(
          this,
          "k256",
          "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f"
        );
      }
      V(Me, Ee), Me.prototype.split = function(ne, oe) {
        for (var ce = 4194303, le = Math.min(ne.length, 9), pe = 0; pe < le; pe++)
          oe.words[pe] = ne.words[pe];
        if (oe.length = le, ne.length <= 9) {
          ne.words[0] = 0, ne.length = 1;
          return;
        }
        var ye = ne.words[9];
        for (oe.words[oe.length++] = ye & ce, pe = 10; pe < ne.length; pe++) {
          var Ce = ne.words[pe] | 0;
          ne.words[pe - 10] = (Ce & ce) << 4 | ye >>> 22, ye = Ce;
        }
        ye >>>= 22, ne.words[pe - 10] = ye, ye === 0 && ne.length > 10 ? ne.length -= 10 : ne.length -= 9;
      }, Me.prototype.imulK = function(ne) {
        ne.words[ne.length] = 0, ne.words[ne.length + 1] = 0, ne.length += 2;
        for (var oe = 0, ce = 0; ce < ne.length; ce++) {
          var le = ne.words[ce] | 0;
          oe += le * 977, ne.words[ce] = oe & 67108863, oe = le * 64 + (oe / 67108864 | 0);
        }
        return ne.words[ne.length - 1] === 0 && (ne.length--, ne.words[ne.length - 1] === 0 && ne.length--), ne;
      };
      function Ie() {
        Ee.call(
          this,
          "p224",
          "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001"
        );
      }
      V(Ie, Ee);
      function ke() {
        Ee.call(
          this,
          "p192",
          "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff"
        );
      }
      V(ke, Ee);
      function _e() {
        Ee.call(
          this,
          "25519",
          "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed"
        );
      }
      V(_e, Ee), _e.prototype.imulK = function(ne) {
        for (var oe = 0, ce = 0; ce < ne.length; ce++) {
          var le = (ne.words[ce] | 0) * 19 + oe, pe = le & 67108863;
          le >>>= 26, ne.words[ce] = pe, oe = le;
        }
        return oe !== 0 && (ne.words[ne.length++] = oe), ne;
      }, J._prime = function(ne) {
        if (we[ne]) return we[ne];
        var oe;
        if (ne === "k256")
          oe = new Me();
        else if (ne === "p224")
          oe = new Ie();
        else if (ne === "p192")
          oe = new ke();
        else if (ne === "p25519")
          oe = new _e();
        else
          throw new Error("Unknown prime " + ne);
        return we[ne] = oe, oe;
      };
      function De(Ae) {
        if (typeof Ae == "string") {
          var ne = J._prime(Ae);
          this.m = ne.p, this.prime = ne;
        } else
          $(Ae.gtn(1), "modulus must be greater than 1"), this.m = Ae, this.prime = null;
      }
      De.prototype._verify1 = function(ne) {
        $(ne.negative === 0, "red works only with positives"), $(ne.red, "red works only with red numbers");
      }, De.prototype._verify2 = function(ne, oe) {
        $((ne.negative | oe.negative) === 0, "red works only with positives"), $(
          ne.red && ne.red === oe.red,
          "red works only with red numbers"
        );
      }, De.prototype.imod = function(ne) {
        return this.prime ? this.prime.ireduce(ne)._forceRed(this) : ne.umod(this.m)._forceRed(this);
      }, De.prototype.neg = function(ne) {
        return ne.isZero() ? ne.clone() : this.m.sub(ne)._forceRed(this);
      }, De.prototype.add = function(ne, oe) {
        this._verify2(ne, oe);
        var ce = ne.add(oe);
        return ce.cmp(this.m) >= 0 && ce.isub(this.m), ce._forceRed(this);
      }, De.prototype.iadd = function(ne, oe) {
        this._verify2(ne, oe);
        var ce = ne.iadd(oe);
        return ce.cmp(this.m) >= 0 && ce.isub(this.m), ce;
      }, De.prototype.sub = function(ne, oe) {
        this._verify2(ne, oe);
        var ce = ne.sub(oe);
        return ce.cmpn(0) < 0 && ce.iadd(this.m), ce._forceRed(this);
      }, De.prototype.isub = function(ne, oe) {
        this._verify2(ne, oe);
        var ce = ne.isub(oe);
        return ce.cmpn(0) < 0 && ce.iadd(this.m), ce;
      }, De.prototype.shl = function(ne, oe) {
        return this._verify1(ne), this.imod(ne.ushln(oe));
      }, De.prototype.imul = function(ne, oe) {
        return this._verify2(ne, oe), this.imod(ne.imul(oe));
      }, De.prototype.mul = function(ne, oe) {
        return this._verify2(ne, oe), this.imod(ne.mul(oe));
      }, De.prototype.isqr = function(ne) {
        return this.imul(ne, ne.clone());
      }, De.prototype.sqr = function(ne) {
        return this.mul(ne, ne);
      }, De.prototype.sqrt = function(ne) {
        if (ne.isZero()) return ne.clone();
        var oe = this.m.andln(3);
        if ($(oe % 2 === 1), oe === 3) {
          var ce = this.m.add(new J(1)).iushrn(2);
          return this.pow(ne, ce);
        }
        for (var le = this.m.subn(1), pe = 0; !le.isZero() && le.andln(1) === 0; )
          pe++, le.iushrn(1);
        $(!le.isZero());
        var ye = new J(1).toRed(this), Ce = ye.redNeg(), be = this.m.subn(1).iushrn(1), ae = this.m.bitLength();
        for (ae = new J(2 * ae * ae).toRed(this); this.pow(ae, be).cmp(Ce) !== 0; )
          ae.redIAdd(Ce);
        for (var ge = this.pow(ae, le), Se = this.pow(ne, le.addn(1).iushrn(1)), Le = this.pow(ne, le), ze = pe; Le.cmp(ye) !== 0; ) {
          for (var Re = Le, We = 0; Re.cmp(ye) !== 0; We++)
            Re = Re.redSqr();
          $(We < ze);
          var Be = this.pow(ge, new J(1).iushln(ze - We - 1));
          Se = Se.redMul(Be), ge = Be.redSqr(), Le = Le.redMul(ge), ze = We;
        }
        return Se;
      }, De.prototype.invm = function(ne) {
        var oe = ne._invmp(this.m);
        return oe.negative !== 0 ? (oe.negative = 0, this.imod(oe).redNeg()) : this.imod(oe);
      }, De.prototype.pow = function(ne, oe) {
        if (oe.isZero()) return new J(1).toRed(this);
        if (oe.cmpn(1) === 0) return ne.clone();
        var ce = 4, le = new Array(1 << ce);
        le[0] = new J(1).toRed(this), le[1] = ne;
        for (var pe = 2; pe < le.length; pe++)
          le[pe] = this.mul(le[pe - 1], ne);
        var ye = le[0], Ce = 0, be = 0, ae = oe.bitLength() % 26;
        for (ae === 0 && (ae = 26), pe = oe.length - 1; pe >= 0; pe--) {
          for (var ge = oe.words[pe], Se = ae - 1; Se >= 0; Se--) {
            var Le = ge >> Se & 1;
            if (ye !== le[0] && (ye = this.sqr(ye)), Le === 0 && Ce === 0) {
              be = 0;
              continue;
            }
            Ce <<= 1, Ce |= Le, be++, !(be !== ce && (pe !== 0 || Se !== 0)) && (ye = this.mul(ye, le[Ce]), be = 0, Ce = 0);
          }
          ae = 26;
        }
        return ye;
      }, De.prototype.convertTo = function(ne) {
        var oe = ne.umod(this.m);
        return oe === ne ? oe.clone() : oe;
      }, De.prototype.convertFrom = function(ne) {
        var oe = ne.clone();
        return oe.red = null, oe;
      }, J.mont = function(ne) {
        return new Fe(ne);
      };
      function Fe(Ae) {
        De.call(this, Ae), this.shift = this.m.bitLength(), this.shift % 26 !== 0 && (this.shift += 26 - this.shift % 26), this.r = new J(1).iushln(this.shift), this.r2 = this.imod(this.r.sqr()), this.rinv = this.r._invmp(this.m), this.minv = this.rinv.mul(this.r).isubn(1).div(this.m), this.minv = this.minv.umod(this.r), this.minv = this.r.sub(this.minv);
      }
      V(Fe, De), Fe.prototype.convertTo = function(ne) {
        return this.imod(ne.ushln(this.shift));
      }, Fe.prototype.convertFrom = function(ne) {
        var oe = this.imod(ne.mul(this.rinv));
        return oe.red = null, oe;
      }, Fe.prototype.imul = function(ne, oe) {
        if (ne.isZero() || oe.isZero())
          return ne.words[0] = 0, ne.length = 1, ne;
        var ce = ne.imul(oe), le = ce.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m), pe = ce.isub(le).iushrn(this.shift), ye = pe;
        return pe.cmp(this.m) >= 0 ? ye = pe.isub(this.m) : pe.cmpn(0) < 0 && (ye = pe.iadd(this.m)), ye._forceRed(this);
      }, Fe.prototype.mul = function(ne, oe) {
        if (ne.isZero() || oe.isZero()) return new J(0)._forceRed(this);
        var ce = ne.mul(oe), le = ce.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m), pe = ce.isub(le).iushrn(this.shift), ye = pe;
        return pe.cmp(this.m) >= 0 ? ye = pe.isub(this.m) : pe.cmpn(0) < 0 && (ye = pe.iadd(this.m)), ye._forceRed(this);
      }, Fe.prototype.invm = function(ne) {
        var oe = this.imod(ne._invmp(this.m).mul(this.r2));
        return oe._forceRed(this);
      };
    })(C, commonjsGlobal$1);
  }(bn$5)), bn$5.exports;
}
var brorand = { exports: {} }, hasRequiredBrorand;
function requireBrorand() {
  if (hasRequiredBrorand) return brorand.exports;
  hasRequiredBrorand = 1;
  var C;
  brorand.exports = function(V) {
    return C || (C = new e(null)), C.generate(V);
  };
  function e($) {
    this.rand = $;
  }
  if (brorand.exports.Rand = e, e.prototype.generate = function(V) {
    return this._rand(V);
  }, e.prototype._rand = function(V) {
    if (this.rand.getBytes)
      return this.rand.getBytes(V);
    for (var J = new Uint8Array(V), ee = 0; ee < J.length; ee++)
      J[ee] = this.rand.getByte();
    return J;
  }, typeof self == "object")
    self.crypto && self.crypto.getRandomValues ? e.prototype._rand = function(V) {
      var J = new Uint8Array(V);
      return self.crypto.getRandomValues(J), J;
    } : self.msCrypto && self.msCrypto.getRandomValues ? e.prototype._rand = function(V) {
      var J = new Uint8Array(V);
      return self.msCrypto.getRandomValues(J), J;
    } : typeof window == "object" && (e.prototype._rand = function() {
      throw new Error("Not implemented yet");
    });
  else
    try {
      var T = requireCryptoBrowserify();
      if (typeof T.randomBytes != "function")
        throw new Error("Not supported");
      e.prototype._rand = function(V) {
        return T.randomBytes(V);
      };
    } catch {
    }
  return brorand.exports;
}
var mr, hasRequiredMr;
function requireMr() {
  if (hasRequiredMr) return mr;
  hasRequiredMr = 1;
  var C = requireBn$4(), e = requireBrorand();
  function T($) {
    this.rand = $ || new e.Rand();
  }
  return mr = T, T.create = function(V) {
    return new T(V);
  }, T.prototype._randbelow = function(V) {
    var J = V.bitLength(), ee = Math.ceil(J / 8);
    do
      var te = new C(this.rand.generate(ee));
    while (te.cmp(V) >= 0);
    return te;
  }, T.prototype._randrange = function(V, J) {
    var ee = J.sub(V);
    return V.add(this._randbelow(ee));
  }, T.prototype.test = function(V, J, ee) {
    var te = V.bitLength(), re = C.mont(V), ie = new C(1).toRed(re);
    J || (J = Math.max(1, te / 48 | 0));
    for (var se = V.subn(1), de = 0; !se.testn(de); de++)
      ;
    for (var ue = V.shrn(de), fe = se.toRed(re), he = !0; J > 0; J--) {
      var me = this._randrange(new C(2), se);
      ee && ee(me);
      var xe = me.toRed(re).redPow(ue);
      if (!(xe.cmp(ie) === 0 || xe.cmp(fe) === 0)) {
        for (var ve = 1; ve < de; ve++) {
          if (xe = xe.redSqr(), xe.cmp(ie) === 0)
            return !1;
          if (xe.cmp(fe) === 0)
            break;
        }
        if (ve === de)
          return !1;
      }
    }
    return he;
  }, T.prototype.getDivisor = function(V, J) {
    var ee = V.bitLength(), te = C.mont(V), re = new C(1).toRed(te);
    J || (J = Math.max(1, ee / 48 | 0));
    for (var ie = V.subn(1), se = 0; !ie.testn(se); se++)
      ;
    for (var de = V.shrn(se), ue = ie.toRed(te); J > 0; J--) {
      var fe = this._randrange(new C(2), ie), he = V.gcd(fe);
      if (he.cmpn(1) !== 0)
        return he;
      var me = fe.toRed(te).redPow(de);
      if (!(me.cmp(re) === 0 || me.cmp(ue) === 0)) {
        for (var xe = 1; xe < se; xe++) {
          if (me = me.redSqr(), me.cmp(re) === 0)
            return me.fromRed().subn(1).gcd(V);
          if (me.cmp(ue) === 0)
            break;
        }
        if (xe === se)
          return me = me.redSqr(), me.fromRed().subn(1).gcd(V);
      }
    }
    return !1;
  }, mr;
}
var generatePrime, hasRequiredGeneratePrime;
function requireGeneratePrime() {
  if (hasRequiredGeneratePrime) return generatePrime;
  hasRequiredGeneratePrime = 1;
  var C = requireBrowser$b();
  generatePrime = xe, xe.simpleSieve = he, xe.fermatTest = me;
  var e = requireBn$5(), T = new e(24), $ = requireMr(), V = new $(), J = new e(1), ee = new e(2), te = new e(5);
  new e(16), new e(8);
  var re = new e(10), ie = new e(3);
  new e(7);
  var se = new e(11), de = new e(4);
  new e(12);
  var ue = null;
  function fe() {
    if (ue !== null)
      return ue;
    var ve = 1048576, Te = [];
    Te[0] = 2;
    for (var we = 1, Ee = 3; Ee < ve; Ee += 2) {
      for (var Me = Math.ceil(Math.sqrt(Ee)), Ie = 0; Ie < we && Te[Ie] <= Me && Ee % Te[Ie] !== 0; Ie++)
        ;
      we !== Ie && Te[Ie] <= Me || (Te[we++] = Ee);
    }
    return ue = Te, Te;
  }
  function he(ve) {
    for (var Te = fe(), we = 0; we < Te.length; we++)
      if (ve.modn(Te[we]) === 0)
        return ve.cmpn(Te[we]) === 0;
    return !0;
  }
  function me(ve) {
    var Te = e.mont(ve);
    return ee.toRed(Te).redPow(ve.subn(1)).fromRed().cmpn(1) === 0;
  }
  function xe(ve, Te) {
    if (ve < 16)
      return Te === 2 || Te === 5 ? new e([140, 123]) : new e([140, 39]);
    Te = new e(Te);
    for (var we, Ee; ; ) {
      for (we = new e(C(Math.ceil(ve / 8))); we.bitLength() > ve; )
        we.ishrn(1);
      if (we.isEven() && we.iadd(J), we.testn(1) || we.iadd(ee), Te.cmp(ee)) {
        if (!Te.cmp(te))
          for (; we.mod(re).cmp(ie); )
            we.iadd(de);
      } else for (; we.mod(T).cmp(se); )
        we.iadd(de);
      if (Ee = we.shrn(1), he(Ee) && he(we) && me(Ee) && me(we) && V.test(Ee) && V.test(we))
        return we;
    }
  }
  return generatePrime;
}
const modp1 = {
  gen: "02",
  prime: "ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a63a3620ffffffffffffffff"
}, modp2 = {
  gen: "02",
  prime: "ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece65381ffffffffffffffff"
}, modp5 = {
  gen: "02",
  prime: "ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca237327ffffffffffffffff"
}, modp14 = {
  gen: "02",
  prime: "ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aacaa68ffffffffffffffff"
}, modp15 = {
  gen: "02",
  prime: "ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a93ad2caffffffffffffffff"
}, modp16 = {
  gen: "02",
  prime: "ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c934063199ffffffffffffffff"
}, modp17 = {
  gen: "02",
  prime: "ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c93402849236c3fab4d27c7026c1d4dcb2602646dec9751e763dba37bdf8ff9406ad9e530ee5db382f413001aeb06a53ed9027d831179727b0865a8918da3edbebcf9b14ed44ce6cbaced4bb1bdb7f1447e6cc254b332051512bd7af426fb8f401378cd2bf5983ca01c64b92ecf032ea15d1721d03f482d7ce6e74fef6d55e702f46980c82b5a84031900b1c9e59e7c97fbec7e8f323a97a7e36cc88be0f1d45b7ff585ac54bd407b22b4154aacc8f6d7ebf48e1d814cc5ed20f8037e0a79715eef29be32806a1d58bb7c5da76f550aa3d8a1fbff0eb19ccb1a313d55cda56c9ec2ef29632387fe8d76e3c0468043e8f663f4860ee12bf2d5b0b7474d6e694f91e6dcc4024ffffffffffffffff"
}, modp18 = {
  gen: "02",
  prime: "ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c93402849236c3fab4d27c7026c1d4dcb2602646dec9751e763dba37bdf8ff9406ad9e530ee5db382f413001aeb06a53ed9027d831179727b0865a8918da3edbebcf9b14ed44ce6cbaced4bb1bdb7f1447e6cc254b332051512bd7af426fb8f401378cd2bf5983ca01c64b92ecf032ea15d1721d03f482d7ce6e74fef6d55e702f46980c82b5a84031900b1c9e59e7c97fbec7e8f323a97a7e36cc88be0f1d45b7ff585ac54bd407b22b4154aacc8f6d7ebf48e1d814cc5ed20f8037e0a79715eef29be32806a1d58bb7c5da76f550aa3d8a1fbff0eb19ccb1a313d55cda56c9ec2ef29632387fe8d76e3c0468043e8f663f4860ee12bf2d5b0b7474d6e694f91e6dbe115974a3926f12fee5e438777cb6a932df8cd8bec4d073b931ba3bc832b68d9dd300741fa7bf8afc47ed2576f6936ba424663aab639c5ae4f5683423b4742bf1c978238f16cbe39d652de3fdb8befc848ad922222e04a4037c0713eb57a81a23f0c73473fc646cea306b4bcbc8862f8385ddfa9d4b7fa2c087e879683303ed5bdd3a062b3cf5b3a278a66d2a13f83f44f82ddf310ee074ab6a364597e899a0255dc164f31cc50846851df9ab48195ded7ea1b1d510bd7ee74d73faf36bc31ecfa268359046f4eb879f924009438b481c6cd7889a002ed5ee382bc9190da6fc026e479558e4475677e9aa9e3050e2765694dfc81f56e880b96e7160c980dd98edd3dfffffffffffffffff"
}, require$$1$1 = {
  modp1,
  modp2,
  modp5,
  modp14,
  modp15,
  modp16,
  modp17,
  modp18
};
var dh, hasRequiredDh;
function requireDh() {
  if (hasRequiredDh) return dh;
  hasRequiredDh = 1;
  var C = requireBn$5(), e = requireMr(), T = new e(), $ = new C(24), V = new C(11), J = new C(10), ee = new C(3), te = new C(7), re = requireGeneratePrime(), ie = requireBrowser$b();
  dh = he;
  function se(xe, ve) {
    return ve = ve || "utf8", dist$2.Buffer.isBuffer(xe) || (xe = new dist$2.Buffer(xe, ve)), this._pub = new C(xe), this;
  }
  function de(xe, ve) {
    return ve = ve || "utf8", dist$2.Buffer.isBuffer(xe) || (xe = new dist$2.Buffer(xe, ve)), this._priv = new C(xe), this;
  }
  var ue = {};
  function fe(xe, ve) {
    var Te = ve.toString("hex"), we = [Te, xe.toString(16)].join("_");
    if (we in ue)
      return ue[we];
    var Ee = 0;
    if (xe.isEven() || !re.simpleSieve || !re.fermatTest(xe) || !T.test(xe))
      return Ee += 1, Te === "02" || Te === "05" ? Ee += 8 : Ee += 4, ue[we] = Ee, Ee;
    T.test(xe.shrn(1)) || (Ee += 2);
    var Me;
    switch (Te) {
      case "02":
        xe.mod($).cmp(V) && (Ee += 8);
        break;
      case "05":
        Me = xe.mod(J), Me.cmp(ee) && Me.cmp(te) && (Ee += 8);
        break;
      default:
        Ee += 4;
    }
    return ue[we] = Ee, Ee;
  }
  function he(xe, ve, Te) {
    this.setGenerator(ve), this.__prime = new C(xe), this._prime = C.mont(this.__prime), this._primeLen = xe.length, this._pub = void 0, this._priv = void 0, this._primeCode = void 0, Te ? (this.setPublicKey = se, this.setPrivateKey = de) : this._primeCode = 8;
  }
  Object.defineProperty(he.prototype, "verifyError", {
    enumerable: !0,
    get: function() {
      return typeof this._primeCode != "number" && (this._primeCode = fe(this.__prime, this.__gen)), this._primeCode;
    }
  }), he.prototype.generateKeys = function() {
    return this._priv || (this._priv = new C(ie(this._primeLen))), this._pub = this._gen.toRed(this._prime).redPow(this._priv).fromRed(), this.getPublicKey();
  }, he.prototype.computeSecret = function(xe) {
    xe = new C(xe), xe = xe.toRed(this._prime);
    var ve = xe.redPow(this._priv).fromRed(), Te = new dist$2.Buffer(ve.toArray()), we = this.getPrime();
    if (Te.length < we.length) {
      var Ee = new dist$2.Buffer(we.length - Te.length);
      Ee.fill(0), Te = dist$2.Buffer.concat([Ee, Te]);
    }
    return Te;
  }, he.prototype.getPublicKey = function(ve) {
    return me(this._pub, ve);
  }, he.prototype.getPrivateKey = function(ve) {
    return me(this._priv, ve);
  }, he.prototype.getPrime = function(xe) {
    return me(this.__prime, xe);
  }, he.prototype.getGenerator = function(xe) {
    return me(this._gen, xe);
  }, he.prototype.setGenerator = function(xe, ve) {
    return ve = ve || "utf8", dist$2.Buffer.isBuffer(xe) || (xe = new dist$2.Buffer(xe, ve)), this.__gen = xe, this._gen = new C(xe), this;
  };
  function me(xe, ve) {
    var Te = new dist$2.Buffer(xe.toArray());
    return ve ? Te.toString(ve) : Te;
  }
  return dh;
}
var hasRequiredBrowser$4;
function requireBrowser$4() {
  if (hasRequiredBrowser$4) return browser$6;
  hasRequiredBrowser$4 = 1;
  var C = requireGeneratePrime(), e = require$$1$1, T = requireDh();
  function $(ee) {
    var te = new dist$2.Buffer(e[ee].prime, "hex"), re = new dist$2.Buffer(e[ee].gen, "hex");
    return new T(te, re);
  }
  var V = {
    binary: !0,
    hex: !0,
    base64: !0
  };
  function J(ee, te, re, ie) {
    return dist$2.Buffer.isBuffer(te) || V[te] === void 0 ? J(ee, "binary", te, re) : (te = te || "binary", ie = ie || "binary", re = re || new dist$2.Buffer([2]), dist$2.Buffer.isBuffer(re) || (re = new dist$2.Buffer(re, ie)), typeof ee == "number" ? new T(C(ee, re), re, !0) : (dist$2.Buffer.isBuffer(ee) || (ee = new dist$2.Buffer(ee, te)), new T(ee, re, !0)));
  }
  return browser$6.DiffieHellmanGroup = browser$6.createDiffieHellmanGroup = browser$6.getDiffieHellman = $, browser$6.createDiffieHellman = browser$6.DiffieHellman = J, browser$6;
}
var readableBrowser = { exports: {} }, processNextickArgs = { exports: {} }, hasRequiredProcessNextickArgs;
function requireProcessNextickArgs() {
  if (hasRequiredProcessNextickArgs) return processNextickArgs.exports;
  hasRequiredProcessNextickArgs = 1, typeof dist$2.process > "u" || !dist$2.process.version || dist$2.process.version.indexOf("v0.") === 0 || dist$2.process.version.indexOf("v1.") === 0 && dist$2.process.version.indexOf("v1.8.") !== 0 ? processNextickArgs.exports = { nextTick: C } : processNextickArgs.exports = dist$2.process;
  function C(e, T, $, V) {
    if (typeof e != "function")
      throw new TypeError('"callback" argument must be a function');
    var J = arguments.length, ee, te;
    switch (J) {
      case 0:
      case 1:
        return dist$2.process.nextTick(e);
      case 2:
        return dist$2.process.nextTick(function() {
          e.call(null, T);
        });
      case 3:
        return dist$2.process.nextTick(function() {
          e.call(null, T, $);
        });
      case 4:
        return dist$2.process.nextTick(function() {
          e.call(null, T, $, V);
        });
      default:
        for (ee = new Array(J - 1), te = 0; te < ee.length; )
          ee[te++] = arguments[te];
        return dist$2.process.nextTick(function() {
          e.apply(null, ee);
        });
    }
  }
  return processNextickArgs.exports;
}
var isarray, hasRequiredIsarray;
function requireIsarray() {
  if (hasRequiredIsarray) return isarray;
  hasRequiredIsarray = 1;
  var C = {}.toString;
  return isarray = Array.isArray || function(e) {
    return C.call(e) == "[object Array]";
  }, isarray;
}
var streamBrowser, hasRequiredStreamBrowser;
function requireStreamBrowser() {
  return hasRequiredStreamBrowser || (hasRequiredStreamBrowser = 1, streamBrowser = requireEvents().EventEmitter), streamBrowser;
}
var safeBuffer$1 = { exports: {} }, hasRequiredSafeBuffer$1;
function requireSafeBuffer$1() {
  return hasRequiredSafeBuffer$1 || (hasRequiredSafeBuffer$1 = 1, function(C, e) {
    var T = bufferPolyfill, $ = T.Buffer;
    function V(ee, te) {
      for (var re in ee)
        te[re] = ee[re];
    }
    $.from && $.alloc && $.allocUnsafe && $.allocUnsafeSlow ? C.exports = T : (V(T, e), e.Buffer = J);
    function J(ee, te, re) {
      return $(ee, te, re);
    }
    V($, J), J.from = function(ee, te, re) {
      if (typeof ee == "number")
        throw new TypeError("Argument must not be a number");
      return $(ee, te, re);
    }, J.alloc = function(ee, te, re) {
      if (typeof ee != "number")
        throw new TypeError("Argument must be a number");
      var ie = $(ee);
      return te !== void 0 ? typeof re == "string" ? ie.fill(te, re) : ie.fill(te) : ie.fill(0), ie;
    }, J.allocUnsafe = function(ee) {
      if (typeof ee != "number")
        throw new TypeError("Argument must be a number");
      return $(ee);
    }, J.allocUnsafeSlow = function(ee) {
      if (typeof ee != "number")
        throw new TypeError("Argument must be a number");
      return T.SlowBuffer(ee);
    };
  }(safeBuffer$1, safeBuffer$1.exports)), safeBuffer$1.exports;
}
var util = {}, hasRequiredUtil;
function requireUtil() {
  if (hasRequiredUtil) return util;
  hasRequiredUtil = 1;
  function C(me) {
    return Array.isArray ? Array.isArray(me) : he(me) === "[object Array]";
  }
  util.isArray = C;
  function e(me) {
    return typeof me == "boolean";
  }
  util.isBoolean = e;
  function T(me) {
    return me === null;
  }
  util.isNull = T;
  function $(me) {
    return me == null;
  }
  util.isNullOrUndefined = $;
  function V(me) {
    return typeof me == "number";
  }
  util.isNumber = V;
  function J(me) {
    return typeof me == "string";
  }
  util.isString = J;
  function ee(me) {
    return typeof me == "symbol";
  }
  util.isSymbol = ee;
  function te(me) {
    return me === void 0;
  }
  util.isUndefined = te;
  function re(me) {
    return he(me) === "[object RegExp]";
  }
  util.isRegExp = re;
  function ie(me) {
    return typeof me == "object" && me !== null;
  }
  util.isObject = ie;
  function se(me) {
    return he(me) === "[object Date]";
  }
  util.isDate = se;
  function de(me) {
    return he(me) === "[object Error]" || me instanceof Error;
  }
  util.isError = de;
  function ue(me) {
    return typeof me == "function";
  }
  util.isFunction = ue;
  function fe(me) {
    return me === null || typeof me == "boolean" || typeof me == "number" || typeof me == "string" || typeof me == "symbol" || // ES6 symbol
    typeof me > "u";
  }
  util.isPrimitive = fe, util.isBuffer = bufferPolyfill.Buffer.isBuffer;
  function he(me) {
    return Object.prototype.toString.call(me);
  }
  return util;
}
var BufferList = { exports: {} }, hasRequiredBufferList;
function requireBufferList() {
  return hasRequiredBufferList || (hasRequiredBufferList = 1, function(C) {
    function e(J, ee) {
      if (!(J instanceof ee))
        throw new TypeError("Cannot call a class as a function");
    }
    var T = requireSafeBuffer$1().Buffer, $ = require$$0$2;
    function V(J, ee, te) {
      J.copy(ee, te);
    }
    C.exports = function() {
      function J() {
        e(this, J), this.head = null, this.tail = null, this.length = 0;
      }
      return J.prototype.push = function(te) {
        var re = { data: te, next: null };
        this.length > 0 ? this.tail.next = re : this.head = re, this.tail = re, ++this.length;
      }, J.prototype.unshift = function(te) {
        var re = { data: te, next: this.head };
        this.length === 0 && (this.tail = re), this.head = re, ++this.length;
      }, J.prototype.shift = function() {
        if (this.length !== 0) {
          var te = this.head.data;
          return this.length === 1 ? this.head = this.tail = null : this.head = this.head.next, --this.length, te;
        }
      }, J.prototype.clear = function() {
        this.head = this.tail = null, this.length = 0;
      }, J.prototype.join = function(te) {
        if (this.length === 0) return "";
        for (var re = this.head, ie = "" + re.data; re = re.next; )
          ie += te + re.data;
        return ie;
      }, J.prototype.concat = function(te) {
        if (this.length === 0) return T.alloc(0);
        for (var re = T.allocUnsafe(te >>> 0), ie = this.head, se = 0; ie; )
          V(ie.data, re, se), se += ie.data.length, ie = ie.next;
        return re;
      }, J;
    }(), $ && $.inspect && $.inspect.custom && (C.exports.prototype[$.inspect.custom] = function() {
      var J = $.inspect({ length: this.length });
      return this.constructor.name + " " + J;
    });
  }(BufferList)), BufferList.exports;
}
var destroy_1, hasRequiredDestroy;
function requireDestroy() {
  if (hasRequiredDestroy) return destroy_1;
  hasRequiredDestroy = 1;
  var C = requireProcessNextickArgs();
  function e(V, J) {
    var ee = this, te = this._readableState && this._readableState.destroyed, re = this._writableState && this._writableState.destroyed;
    return te || re ? (J ? J(V) : V && (this._writableState ? this._writableState.errorEmitted || (this._writableState.errorEmitted = !0, C.nextTick($, this, V)) : C.nextTick($, this, V)), this) : (this._readableState && (this._readableState.destroyed = !0), this._writableState && (this._writableState.destroyed = !0), this._destroy(V || null, function(ie) {
      !J && ie ? ee._writableState ? ee._writableState.errorEmitted || (ee._writableState.errorEmitted = !0, C.nextTick($, ee, ie)) : C.nextTick($, ee, ie) : J && J(ie);
    }), this);
  }
  function T() {
    this._readableState && (this._readableState.destroyed = !1, this._readableState.reading = !1, this._readableState.ended = !1, this._readableState.endEmitted = !1), this._writableState && (this._writableState.destroyed = !1, this._writableState.ended = !1, this._writableState.ending = !1, this._writableState.finalCalled = !1, this._writableState.prefinished = !1, this._writableState.finished = !1, this._writableState.errorEmitted = !1);
  }
  function $(V, J) {
    V.emit("error", J);
  }
  return destroy_1 = {
    destroy: e,
    undestroy: T
  }, destroy_1;
}
var _stream_writable, hasRequired_stream_writable;
function require_stream_writable() {
  if (hasRequired_stream_writable) return _stream_writable;
  hasRequired_stream_writable = 1;
  var C = requireProcessNextickArgs();
  _stream_writable = me;
  function e(ye) {
    var Ce = this;
    this.next = null, this.entry = null, this.finish = function() {
      pe(Ce, ye);
    };
  }
  var T = !dist$2.process.browser && ["v0.10", "v0.9."].indexOf(dist$2.process.version.slice(0, 5)) > -1 ? setImmediate : C.nextTick, $;
  me.WritableState = fe;
  var V = Object.create(requireUtil());
  V.inherits = requireInherits_browser();
  var J = {
    deprecate: requireBrowser$a()
  }, ee = requireStreamBrowser(), te = requireSafeBuffer$1().Buffer, re = (typeof commonjsGlobal$1 < "u" ? commonjsGlobal$1 : typeof window < "u" ? window : typeof self < "u" ? self : {}).Uint8Array || function() {
  };
  function ie(ye) {
    return te.from(ye);
  }
  function se(ye) {
    return te.isBuffer(ye) || ye instanceof re;
  }
  var de = requireDestroy();
  V.inherits(me, ee);
  function ue() {
  }
  function fe(ye, Ce) {
    $ = $ || require_stream_duplex(), ye = ye || {};
    var be = Ce instanceof $;
    this.objectMode = !!ye.objectMode, be && (this.objectMode = this.objectMode || !!ye.writableObjectMode);
    var ae = ye.highWaterMark, ge = ye.writableHighWaterMark, Se = this.objectMode ? 16 : 16 * 1024;
    ae || ae === 0 ? this.highWaterMark = ae : be && (ge || ge === 0) ? this.highWaterMark = ge : this.highWaterMark = Se, this.highWaterMark = Math.floor(this.highWaterMark), this.finalCalled = !1, this.needDrain = !1, this.ending = !1, this.ended = !1, this.finished = !1, this.destroyed = !1;
    var Le = ye.decodeStrings === !1;
    this.decodeStrings = !Le, this.defaultEncoding = ye.defaultEncoding || "utf8", this.length = 0, this.writing = !1, this.corked = 0, this.sync = !0, this.bufferProcessing = !1, this.onwrite = function(ze) {
      ke(Ce, ze);
    }, this.writecb = null, this.writelen = 0, this.bufferedRequest = null, this.lastBufferedRequest = null, this.pendingcb = 0, this.prefinished = !1, this.errorEmitted = !1, this.bufferedRequestCount = 0, this.corkedRequestsFree = new e(this);
  }
  fe.prototype.getBuffer = function() {
    for (var Ce = this.bufferedRequest, be = []; Ce; )
      be.push(Ce), Ce = Ce.next;
    return be;
  }, function() {
    try {
      Object.defineProperty(fe.prototype, "buffer", {
        get: J.deprecate(function() {
          return this.getBuffer();
        }, "_writableState.buffer is deprecated. Use _writableState.getBuffer instead.", "DEP0003")
      });
    } catch {
    }
  }();
  var he;
  typeof Symbol == "function" && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] == "function" ? (he = Function.prototype[Symbol.hasInstance], Object.defineProperty(me, Symbol.hasInstance, {
    value: function(ye) {
      return he.call(this, ye) ? !0 : this !== me ? !1 : ye && ye._writableState instanceof fe;
    }
  })) : he = function(ye) {
    return ye instanceof this;
  };
  function me(ye) {
    if ($ = $ || require_stream_duplex(), !he.call(me, this) && !(this instanceof $))
      return new me(ye);
    this._writableState = new fe(ye, this), this.writable = !0, ye && (typeof ye.write == "function" && (this._write = ye.write), typeof ye.writev == "function" && (this._writev = ye.writev), typeof ye.destroy == "function" && (this._destroy = ye.destroy), typeof ye.final == "function" && (this._final = ye.final)), ee.call(this);
  }
  me.prototype.pipe = function() {
    this.emit("error", new Error("Cannot pipe, not readable"));
  };
  function xe(ye, Ce) {
    var be = new Error("write after end");
    ye.emit("error", be), C.nextTick(Ce, be);
  }
  function ve(ye, Ce, be, ae) {
    var ge = !0, Se = !1;
    return be === null ? Se = new TypeError("May not write null values to stream") : typeof be != "string" && be !== void 0 && !Ce.objectMode && (Se = new TypeError("Invalid non-string/buffer chunk")), Se && (ye.emit("error", Se), C.nextTick(ae, Se), ge = !1), ge;
  }
  me.prototype.write = function(ye, Ce, be) {
    var ae = this._writableState, ge = !1, Se = !ae.objectMode && se(ye);
    return Se && !te.isBuffer(ye) && (ye = ie(ye)), typeof Ce == "function" && (be = Ce, Ce = null), Se ? Ce = "buffer" : Ce || (Ce = ae.defaultEncoding), typeof be != "function" && (be = ue), ae.ended ? xe(this, be) : (Se || ve(this, ae, ye, be)) && (ae.pendingcb++, ge = we(this, ae, Se, ye, Ce, be)), ge;
  }, me.prototype.cork = function() {
    var ye = this._writableState;
    ye.corked++;
  }, me.prototype.uncork = function() {
    var ye = this._writableState;
    ye.corked && (ye.corked--, !ye.writing && !ye.corked && !ye.bufferProcessing && ye.bufferedRequest && Fe(this, ye));
  }, me.prototype.setDefaultEncoding = function(Ce) {
    if (typeof Ce == "string" && (Ce = Ce.toLowerCase()), !(["hex", "utf8", "utf-8", "ascii", "binary", "base64", "ucs2", "ucs-2", "utf16le", "utf-16le", "raw"].indexOf((Ce + "").toLowerCase()) > -1)) throw new TypeError("Unknown encoding: " + Ce);
    return this._writableState.defaultEncoding = Ce, this;
  };
  function Te(ye, Ce, be) {
    return !ye.objectMode && ye.decodeStrings !== !1 && typeof Ce == "string" && (Ce = te.from(Ce, be)), Ce;
  }
  Object.defineProperty(me.prototype, "writableHighWaterMark", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._writableState.highWaterMark;
    }
  });
  function we(ye, Ce, be, ae, ge, Se) {
    if (!be) {
      var Le = Te(Ce, ae, ge);
      ae !== Le && (be = !0, ge = "buffer", ae = Le);
    }
    var ze = Ce.objectMode ? 1 : ae.length;
    Ce.length += ze;
    var Re = Ce.length < Ce.highWaterMark;
    if (Re || (Ce.needDrain = !0), Ce.writing || Ce.corked) {
      var We = Ce.lastBufferedRequest;
      Ce.lastBufferedRequest = {
        chunk: ae,
        encoding: ge,
        isBuf: be,
        callback: Se,
        next: null
      }, We ? We.next = Ce.lastBufferedRequest : Ce.bufferedRequest = Ce.lastBufferedRequest, Ce.bufferedRequestCount += 1;
    } else
      Ee(ye, Ce, !1, ze, ae, ge, Se);
    return Re;
  }
  function Ee(ye, Ce, be, ae, ge, Se, Le) {
    Ce.writelen = ae, Ce.writecb = Le, Ce.writing = !0, Ce.sync = !0, be ? ye._writev(ge, Ce.onwrite) : ye._write(ge, Se, Ce.onwrite), Ce.sync = !1;
  }
  function Me(ye, Ce, be, ae, ge) {
    --Ce.pendingcb, be ? (C.nextTick(ge, ae), C.nextTick(ce, ye, Ce), ye._writableState.errorEmitted = !0, ye.emit("error", ae)) : (ge(ae), ye._writableState.errorEmitted = !0, ye.emit("error", ae), ce(ye, Ce));
  }
  function Ie(ye) {
    ye.writing = !1, ye.writecb = null, ye.length -= ye.writelen, ye.writelen = 0;
  }
  function ke(ye, Ce) {
    var be = ye._writableState, ae = be.sync, ge = be.writecb;
    if (Ie(be), Ce) Me(ye, be, ae, Ce, ge);
    else {
      var Se = Ae(be);
      !Se && !be.corked && !be.bufferProcessing && be.bufferedRequest && Fe(ye, be), ae ? T(_e, ye, be, Se, ge) : _e(ye, be, Se, ge);
    }
  }
  function _e(ye, Ce, be, ae) {
    be || De(ye, Ce), Ce.pendingcb--, ae(), ce(ye, Ce);
  }
  function De(ye, Ce) {
    Ce.length === 0 && Ce.needDrain && (Ce.needDrain = !1, ye.emit("drain"));
  }
  function Fe(ye, Ce) {
    Ce.bufferProcessing = !0;
    var be = Ce.bufferedRequest;
    if (ye._writev && be && be.next) {
      var ae = Ce.bufferedRequestCount, ge = new Array(ae), Se = Ce.corkedRequestsFree;
      Se.entry = be;
      for (var Le = 0, ze = !0; be; )
        ge[Le] = be, be.isBuf || (ze = !1), be = be.next, Le += 1;
      ge.allBuffers = ze, Ee(ye, Ce, !0, Ce.length, ge, "", Se.finish), Ce.pendingcb++, Ce.lastBufferedRequest = null, Se.next ? (Ce.corkedRequestsFree = Se.next, Se.next = null) : Ce.corkedRequestsFree = new e(Ce), Ce.bufferedRequestCount = 0;
    } else {
      for (; be; ) {
        var Re = be.chunk, We = be.encoding, Be = be.callback, Ue = Ce.objectMode ? 1 : Re.length;
        if (Ee(ye, Ce, !1, Ue, Re, We, Be), be = be.next, Ce.bufferedRequestCount--, Ce.writing)
          break;
      }
      be === null && (Ce.lastBufferedRequest = null);
    }
    Ce.bufferedRequest = be, Ce.bufferProcessing = !1;
  }
  me.prototype._write = function(ye, Ce, be) {
    be(new Error("_write() is not implemented"));
  }, me.prototype._writev = null, me.prototype.end = function(ye, Ce, be) {
    var ae = this._writableState;
    typeof ye == "function" ? (be = ye, ye = null, Ce = null) : typeof Ce == "function" && (be = Ce, Ce = null), ye != null && this.write(ye, Ce), ae.corked && (ae.corked = 1, this.uncork()), ae.ending || le(this, ae, be);
  };
  function Ae(ye) {
    return ye.ending && ye.length === 0 && ye.bufferedRequest === null && !ye.finished && !ye.writing;
  }
  function ne(ye, Ce) {
    ye._final(function(be) {
      Ce.pendingcb--, be && ye.emit("error", be), Ce.prefinished = !0, ye.emit("prefinish"), ce(ye, Ce);
    });
  }
  function oe(ye, Ce) {
    !Ce.prefinished && !Ce.finalCalled && (typeof ye._final == "function" ? (Ce.pendingcb++, Ce.finalCalled = !0, C.nextTick(ne, ye, Ce)) : (Ce.prefinished = !0, ye.emit("prefinish")));
  }
  function ce(ye, Ce) {
    var be = Ae(Ce);
    return be && (oe(ye, Ce), Ce.pendingcb === 0 && (Ce.finished = !0, ye.emit("finish"))), be;
  }
  function le(ye, Ce, be) {
    Ce.ending = !0, ce(ye, Ce), be && (Ce.finished ? C.nextTick(be) : ye.once("finish", be)), Ce.ended = !0, ye.writable = !1;
  }
  function pe(ye, Ce, be) {
    var ae = ye.entry;
    for (ye.entry = null; ae; ) {
      var ge = ae.callback;
      Ce.pendingcb--, ge(be), ae = ae.next;
    }
    Ce.corkedRequestsFree.next = ye;
  }
  return Object.defineProperty(me.prototype, "destroyed", {
    get: function() {
      return this._writableState === void 0 ? !1 : this._writableState.destroyed;
    },
    set: function(ye) {
      this._writableState && (this._writableState.destroyed = ye);
    }
  }), me.prototype.destroy = de.destroy, me.prototype._undestroy = de.undestroy, me.prototype._destroy = function(ye, Ce) {
    this.end(), Ce(ye);
  }, _stream_writable;
}
var _stream_duplex, hasRequired_stream_duplex;
function require_stream_duplex() {
  if (hasRequired_stream_duplex) return _stream_duplex;
  hasRequired_stream_duplex = 1;
  var C = requireProcessNextickArgs(), e = Object.keys || function(de) {
    var ue = [];
    for (var fe in de)
      ue.push(fe);
    return ue;
  };
  _stream_duplex = re;
  var T = Object.create(requireUtil());
  T.inherits = requireInherits_browser();
  var $ = require_stream_readable(), V = require_stream_writable();
  T.inherits(re, $);
  for (var J = e(V.prototype), ee = 0; ee < J.length; ee++) {
    var te = J[ee];
    re.prototype[te] || (re.prototype[te] = V.prototype[te]);
  }
  function re(de) {
    if (!(this instanceof re)) return new re(de);
    $.call(this, de), V.call(this, de), de && de.readable === !1 && (this.readable = !1), de && de.writable === !1 && (this.writable = !1), this.allowHalfOpen = !0, de && de.allowHalfOpen === !1 && (this.allowHalfOpen = !1), this.once("end", ie);
  }
  Object.defineProperty(re.prototype, "writableHighWaterMark", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._writableState.highWaterMark;
    }
  });
  function ie() {
    this.allowHalfOpen || this._writableState.ended || C.nextTick(se, this);
  }
  function se(de) {
    de.end();
  }
  return Object.defineProperty(re.prototype, "destroyed", {
    get: function() {
      return this._readableState === void 0 || this._writableState === void 0 ? !1 : this._readableState.destroyed && this._writableState.destroyed;
    },
    set: function(de) {
      this._readableState === void 0 || this._writableState === void 0 || (this._readableState.destroyed = de, this._writableState.destroyed = de);
    }
  }), re.prototype._destroy = function(de, ue) {
    this.push(null), this.end(), C.nextTick(ue, de);
  }, _stream_duplex;
}
var string_decoder = {}, safeBuffer = { exports: {} }, hasRequiredSafeBuffer;
function requireSafeBuffer() {
  return hasRequiredSafeBuffer || (hasRequiredSafeBuffer = 1, function(C, e) {
    var T = bufferPolyfill, $ = T.Buffer;
    function V(ee, te) {
      for (var re in ee)
        te[re] = ee[re];
    }
    $.from && $.alloc && $.allocUnsafe && $.allocUnsafeSlow ? C.exports = T : (V(T, e), e.Buffer = J);
    function J(ee, te, re) {
      return $(ee, te, re);
    }
    V($, J), J.from = function(ee, te, re) {
      if (typeof ee == "number")
        throw new TypeError("Argument must not be a number");
      return $(ee, te, re);
    }, J.alloc = function(ee, te, re) {
      if (typeof ee != "number")
        throw new TypeError("Argument must be a number");
      var ie = $(ee);
      return te !== void 0 ? typeof re == "string" ? ie.fill(te, re) : ie.fill(te) : ie.fill(0), ie;
    }, J.allocUnsafe = function(ee) {
      if (typeof ee != "number")
        throw new TypeError("Argument must be a number");
      return $(ee);
    }, J.allocUnsafeSlow = function(ee) {
      if (typeof ee != "number")
        throw new TypeError("Argument must be a number");
      return T.SlowBuffer(ee);
    };
  }(safeBuffer, safeBuffer.exports)), safeBuffer.exports;
}
var hasRequiredString_decoder;
function requireString_decoder() {
  if (hasRequiredString_decoder) return string_decoder;
  hasRequiredString_decoder = 1;
  var C = requireSafeBuffer().Buffer, e = C.isEncoding || function(ve) {
    switch (ve = "" + ve, ve && ve.toLowerCase()) {
      case "hex":
      case "utf8":
      case "utf-8":
      case "ascii":
      case "binary":
      case "base64":
      case "ucs2":
      case "ucs-2":
      case "utf16le":
      case "utf-16le":
      case "raw":
        return !0;
      default:
        return !1;
    }
  };
  function T(ve) {
    if (!ve) return "utf8";
    for (var Te; ; )
      switch (ve) {
        case "utf8":
        case "utf-8":
          return "utf8";
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
          return "utf16le";
        case "latin1":
        case "binary":
          return "latin1";
        case "base64":
        case "ascii":
        case "hex":
          return ve;
        default:
          if (Te) return;
          ve = ("" + ve).toLowerCase(), Te = !0;
      }
  }
  function $(ve) {
    var Te = T(ve);
    if (typeof Te != "string" && (C.isEncoding === e || !e(ve))) throw new Error("Unknown encoding: " + ve);
    return Te || ve;
  }
  string_decoder.StringDecoder = V;
  function V(ve) {
    this.encoding = $(ve);
    var Te;
    switch (this.encoding) {
      case "utf16le":
        this.text = de, this.end = ue, Te = 4;
        break;
      case "utf8":
        this.fillLast = re, Te = 4;
        break;
      case "base64":
        this.text = fe, this.end = he, Te = 3;
        break;
      default:
        this.write = me, this.end = xe;
        return;
    }
    this.lastNeed = 0, this.lastTotal = 0, this.lastChar = C.allocUnsafe(Te);
  }
  V.prototype.write = function(ve) {
    if (ve.length === 0) return "";
    var Te, we;
    if (this.lastNeed) {
      if (Te = this.fillLast(ve), Te === void 0) return "";
      we = this.lastNeed, this.lastNeed = 0;
    } else
      we = 0;
    return we < ve.length ? Te ? Te + this.text(ve, we) : this.text(ve, we) : Te || "";
  }, V.prototype.end = se, V.prototype.text = ie, V.prototype.fillLast = function(ve) {
    if (this.lastNeed <= ve.length)
      return ve.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed), this.lastChar.toString(this.encoding, 0, this.lastTotal);
    ve.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, ve.length), this.lastNeed -= ve.length;
  };
  function J(ve) {
    return ve <= 127 ? 0 : ve >> 5 === 6 ? 2 : ve >> 4 === 14 ? 3 : ve >> 3 === 30 ? 4 : ve >> 6 === 2 ? -1 : -2;
  }
  function ee(ve, Te, we) {
    var Ee = Te.length - 1;
    if (Ee < we) return 0;
    var Me = J(Te[Ee]);
    return Me >= 0 ? (Me > 0 && (ve.lastNeed = Me - 1), Me) : --Ee < we || Me === -2 ? 0 : (Me = J(Te[Ee]), Me >= 0 ? (Me > 0 && (ve.lastNeed = Me - 2), Me) : --Ee < we || Me === -2 ? 0 : (Me = J(Te[Ee]), Me >= 0 ? (Me > 0 && (Me === 2 ? Me = 0 : ve.lastNeed = Me - 3), Me) : 0));
  }
  function te(ve, Te, we) {
    if ((Te[0] & 192) !== 128)
      return ve.lastNeed = 0, "�";
    if (ve.lastNeed > 1 && Te.length > 1) {
      if ((Te[1] & 192) !== 128)
        return ve.lastNeed = 1, "�";
      if (ve.lastNeed > 2 && Te.length > 2 && (Te[2] & 192) !== 128)
        return ve.lastNeed = 2, "�";
    }
  }
  function re(ve) {
    var Te = this.lastTotal - this.lastNeed, we = te(this, ve);
    if (we !== void 0) return we;
    if (this.lastNeed <= ve.length)
      return ve.copy(this.lastChar, Te, 0, this.lastNeed), this.lastChar.toString(this.encoding, 0, this.lastTotal);
    ve.copy(this.lastChar, Te, 0, ve.length), this.lastNeed -= ve.length;
  }
  function ie(ve, Te) {
    var we = ee(this, ve, Te);
    if (!this.lastNeed) return ve.toString("utf8", Te);
    this.lastTotal = we;
    var Ee = ve.length - (we - this.lastNeed);
    return ve.copy(this.lastChar, 0, Ee), ve.toString("utf8", Te, Ee);
  }
  function se(ve) {
    var Te = ve && ve.length ? this.write(ve) : "";
    return this.lastNeed ? Te + "�" : Te;
  }
  function de(ve, Te) {
    if ((ve.length - Te) % 2 === 0) {
      var we = ve.toString("utf16le", Te);
      if (we) {
        var Ee = we.charCodeAt(we.length - 1);
        if (Ee >= 55296 && Ee <= 56319)
          return this.lastNeed = 2, this.lastTotal = 4, this.lastChar[0] = ve[ve.length - 2], this.lastChar[1] = ve[ve.length - 1], we.slice(0, -1);
      }
      return we;
    }
    return this.lastNeed = 1, this.lastTotal = 2, this.lastChar[0] = ve[ve.length - 1], ve.toString("utf16le", Te, ve.length - 1);
  }
  function ue(ve) {
    var Te = ve && ve.length ? this.write(ve) : "";
    if (this.lastNeed) {
      var we = this.lastTotal - this.lastNeed;
      return Te + this.lastChar.toString("utf16le", 0, we);
    }
    return Te;
  }
  function fe(ve, Te) {
    var we = (ve.length - Te) % 3;
    return we === 0 ? ve.toString("base64", Te) : (this.lastNeed = 3 - we, this.lastTotal = 3, we === 1 ? this.lastChar[0] = ve[ve.length - 1] : (this.lastChar[0] = ve[ve.length - 2], this.lastChar[1] = ve[ve.length - 1]), ve.toString("base64", Te, ve.length - we));
  }
  function he(ve) {
    var Te = ve && ve.length ? this.write(ve) : "";
    return this.lastNeed ? Te + this.lastChar.toString("base64", 0, 3 - this.lastNeed) : Te;
  }
  function me(ve) {
    return ve.toString(this.encoding);
  }
  function xe(ve) {
    return ve && ve.length ? this.write(ve) : "";
  }
  return string_decoder;
}
var _stream_readable, hasRequired_stream_readable;
function require_stream_readable() {
  if (hasRequired_stream_readable) return _stream_readable;
  hasRequired_stream_readable = 1;
  var C = requireProcessNextickArgs();
  _stream_readable = Te;
  var e = requireIsarray(), T;
  Te.ReadableState = ve, requireEvents().EventEmitter;
  var $ = function(Be, Ue) {
    return Be.listeners(Ue).length;
  }, V = requireStreamBrowser(), J = requireSafeBuffer$1().Buffer, ee = (typeof commonjsGlobal$1 < "u" ? commonjsGlobal$1 : typeof window < "u" ? window : typeof self < "u" ? self : {}).Uint8Array || function() {
  };
  function te(Be) {
    return J.from(Be);
  }
  function re(Be) {
    return J.isBuffer(Be) || Be instanceof ee;
  }
  var ie = Object.create(requireUtil());
  ie.inherits = requireInherits_browser();
  var se = require$$0$2, de = void 0;
  se && se.debuglog ? de = se.debuglog("stream") : de = function() {
  };
  var ue = requireBufferList(), fe = requireDestroy(), he;
  ie.inherits(Te, V);
  var me = ["error", "close", "destroy", "pause", "resume"];
  function xe(Be, Ue, Ge) {
    if (typeof Be.prependListener == "function") return Be.prependListener(Ue, Ge);
    !Be._events || !Be._events[Ue] ? Be.on(Ue, Ge) : e(Be._events[Ue]) ? Be._events[Ue].unshift(Ge) : Be._events[Ue] = [Ge, Be._events[Ue]];
  }
  function ve(Be, Ue) {
    T = T || require_stream_duplex(), Be = Be || {};
    var Ge = Ue instanceof T;
    this.objectMode = !!Be.objectMode, Ge && (this.objectMode = this.objectMode || !!Be.readableObjectMode);
    var je = Be.highWaterMark, Oe = Be.readableHighWaterMark, Ne = this.objectMode ? 16 : 16 * 1024;
    je || je === 0 ? this.highWaterMark = je : Ge && (Oe || Oe === 0) ? this.highWaterMark = Oe : this.highWaterMark = Ne, this.highWaterMark = Math.floor(this.highWaterMark), this.buffer = new ue(), this.length = 0, this.pipes = null, this.pipesCount = 0, this.flowing = null, this.ended = !1, this.endEmitted = !1, this.reading = !1, this.sync = !0, this.needReadable = !1, this.emittedReadable = !1, this.readableListening = !1, this.resumeScheduled = !1, this.destroyed = !1, this.defaultEncoding = Be.defaultEncoding || "utf8", this.awaitDrain = 0, this.readingMore = !1, this.decoder = null, this.encoding = null, Be.encoding && (he || (he = requireString_decoder().StringDecoder), this.decoder = new he(Be.encoding), this.encoding = Be.encoding);
  }
  function Te(Be) {
    if (T = T || require_stream_duplex(), !(this instanceof Te)) return new Te(Be);
    this._readableState = new ve(Be, this), this.readable = !0, Be && (typeof Be.read == "function" && (this._read = Be.read), typeof Be.destroy == "function" && (this._destroy = Be.destroy)), V.call(this);
  }
  Object.defineProperty(Te.prototype, "destroyed", {
    get: function() {
      return this._readableState === void 0 ? !1 : this._readableState.destroyed;
    },
    set: function(Be) {
      this._readableState && (this._readableState.destroyed = Be);
    }
  }), Te.prototype.destroy = fe.destroy, Te.prototype._undestroy = fe.undestroy, Te.prototype._destroy = function(Be, Ue) {
    this.push(null), Ue(Be);
  }, Te.prototype.push = function(Be, Ue) {
    var Ge = this._readableState, je;
    return Ge.objectMode ? je = !0 : typeof Be == "string" && (Ue = Ue || Ge.defaultEncoding, Ue !== Ge.encoding && (Be = J.from(Be, Ue), Ue = ""), je = !0), we(this, Be, Ue, !1, je);
  }, Te.prototype.unshift = function(Be) {
    return we(this, Be, null, !0, !1);
  };
  function we(Be, Ue, Ge, je, Oe) {
    var Ne = Be._readableState;
    if (Ue === null)
      Ne.reading = !1, Fe(Be, Ne);
    else {
      var Ye;
      Oe || (Ye = Me(Ne, Ue)), Ye ? Be.emit("error", Ye) : Ne.objectMode || Ue && Ue.length > 0 ? (typeof Ue != "string" && !Ne.objectMode && Object.getPrototypeOf(Ue) !== J.prototype && (Ue = te(Ue)), je ? Ne.endEmitted ? Be.emit("error", new Error("stream.unshift() after end event")) : Ee(Be, Ne, Ue, !0) : Ne.ended ? Be.emit("error", new Error("stream.push() after EOF")) : (Ne.reading = !1, Ne.decoder && !Ge ? (Ue = Ne.decoder.write(Ue), Ne.objectMode || Ue.length !== 0 ? Ee(Be, Ne, Ue, !1) : oe(Be, Ne)) : Ee(Be, Ne, Ue, !1))) : je || (Ne.reading = !1);
    }
    return Ie(Ne);
  }
  function Ee(Be, Ue, Ge, je) {
    Ue.flowing && Ue.length === 0 && !Ue.sync ? (Be.emit("data", Ge), Be.read(0)) : (Ue.length += Ue.objectMode ? 1 : Ge.length, je ? Ue.buffer.unshift(Ge) : Ue.buffer.push(Ge), Ue.needReadable && Ae(Be)), oe(Be, Ue);
  }
  function Me(Be, Ue) {
    var Ge;
    return !re(Ue) && typeof Ue != "string" && Ue !== void 0 && !Be.objectMode && (Ge = new TypeError("Invalid non-string/buffer chunk")), Ge;
  }
  function Ie(Be) {
    return !Be.ended && (Be.needReadable || Be.length < Be.highWaterMark || Be.length === 0);
  }
  Te.prototype.isPaused = function() {
    return this._readableState.flowing === !1;
  }, Te.prototype.setEncoding = function(Be) {
    return he || (he = requireString_decoder().StringDecoder), this._readableState.decoder = new he(Be), this._readableState.encoding = Be, this;
  };
  var ke = 8388608;
  function _e(Be) {
    return Be >= ke ? Be = ke : (Be--, Be |= Be >>> 1, Be |= Be >>> 2, Be |= Be >>> 4, Be |= Be >>> 8, Be |= Be >>> 16, Be++), Be;
  }
  function De(Be, Ue) {
    return Be <= 0 || Ue.length === 0 && Ue.ended ? 0 : Ue.objectMode ? 1 : Be !== Be ? Ue.flowing && Ue.length ? Ue.buffer.head.data.length : Ue.length : (Be > Ue.highWaterMark && (Ue.highWaterMark = _e(Be)), Be <= Ue.length ? Be : Ue.ended ? Ue.length : (Ue.needReadable = !0, 0));
  }
  Te.prototype.read = function(Be) {
    de("read", Be), Be = parseInt(Be, 10);
    var Ue = this._readableState, Ge = Be;
    if (Be !== 0 && (Ue.emittedReadable = !1), Be === 0 && Ue.needReadable && (Ue.length >= Ue.highWaterMark || Ue.ended))
      return de("read: emitReadable", Ue.length, Ue.ended), Ue.length === 0 && Ue.ended ? ze(this) : Ae(this), null;
    if (Be = De(Be, Ue), Be === 0 && Ue.ended)
      return Ue.length === 0 && ze(this), null;
    var je = Ue.needReadable;
    de("need readable", je), (Ue.length === 0 || Ue.length - Be < Ue.highWaterMark) && (je = !0, de("length less than watermark", je)), Ue.ended || Ue.reading ? (je = !1, de("reading or ended", je)) : je && (de("do read"), Ue.reading = !0, Ue.sync = !0, Ue.length === 0 && (Ue.needReadable = !0), this._read(Ue.highWaterMark), Ue.sync = !1, Ue.reading || (Be = De(Ge, Ue)));
    var Oe;
    return Be > 0 ? Oe = ae(Be, Ue) : Oe = null, Oe === null ? (Ue.needReadable = !0, Be = 0) : Ue.length -= Be, Ue.length === 0 && (Ue.ended || (Ue.needReadable = !0), Ge !== Be && Ue.ended && ze(this)), Oe !== null && this.emit("data", Oe), Oe;
  };
  function Fe(Be, Ue) {
    if (!Ue.ended) {
      if (Ue.decoder) {
        var Ge = Ue.decoder.end();
        Ge && Ge.length && (Ue.buffer.push(Ge), Ue.length += Ue.objectMode ? 1 : Ge.length);
      }
      Ue.ended = !0, Ae(Be);
    }
  }
  function Ae(Be) {
    var Ue = Be._readableState;
    Ue.needReadable = !1, Ue.emittedReadable || (de("emitReadable", Ue.flowing), Ue.emittedReadable = !0, Ue.sync ? C.nextTick(ne, Be) : ne(Be));
  }
  function ne(Be) {
    de("emit readable"), Be.emit("readable"), be(Be);
  }
  function oe(Be, Ue) {
    Ue.readingMore || (Ue.readingMore = !0, C.nextTick(ce, Be, Ue));
  }
  function ce(Be, Ue) {
    for (var Ge = Ue.length; !Ue.reading && !Ue.flowing && !Ue.ended && Ue.length < Ue.highWaterMark && (de("maybeReadMore read 0"), Be.read(0), Ge !== Ue.length); )
      Ge = Ue.length;
    Ue.readingMore = !1;
  }
  Te.prototype._read = function(Be) {
    this.emit("error", new Error("_read() is not implemented"));
  }, Te.prototype.pipe = function(Be, Ue) {
    var Ge = this, je = this._readableState;
    switch (je.pipesCount) {
      case 0:
        je.pipes = Be;
        break;
      case 1:
        je.pipes = [je.pipes, Be];
        break;
      default:
        je.pipes.push(Be);
        break;
    }
    je.pipesCount += 1, de("pipe count=%d opts=%j", je.pipesCount, Ue);
    var Oe = (!Ue || Ue.end !== !1) && Be !== dist$2.process.stdout && Be !== dist$2.process.stderr, Ne = Oe ? Je : It;
    je.endEmitted ? C.nextTick(Ne) : Ge.once("end", Ne), Be.on("unpipe", Ye);
    function Ye(xt, Tt) {
      de("onunpipe"), xt === Ge && Tt && Tt.hasUnpiped === !1 && (Tt.hasUnpiped = !0, ct());
    }
    function Je() {
      de("onend"), Be.end();
    }
    var Xe = le(Ge);
    Be.on("drain", Xe);
    var st = !1;
    function ct() {
      de("cleanup"), Be.removeListener("close", dt), Be.removeListener("finish", mt), Be.removeListener("drain", Xe), Be.removeListener("error", yt), Be.removeListener("unpipe", Ye), Ge.removeListener("end", Je), Ge.removeListener("end", It), Ge.removeListener("data", ot), st = !0, je.awaitDrain && (!Be._writableState || Be._writableState.needDrain) && Xe();
    }
    var it = !1;
    Ge.on("data", ot);
    function ot(xt) {
      de("ondata"), it = !1;
      var Tt = Be.write(xt);
      Tt === !1 && !it && ((je.pipesCount === 1 && je.pipes === Be || je.pipesCount > 1 && We(je.pipes, Be) !== -1) && !st && (de("false write response, pause", je.awaitDrain), je.awaitDrain++, it = !0), Ge.pause());
    }
    function yt(xt) {
      de("onerror", xt), It(), Be.removeListener("error", yt), $(Be, "error") === 0 && Be.emit("error", xt);
    }
    xe(Be, "error", yt);
    function dt() {
      Be.removeListener("finish", mt), It();
    }
    Be.once("close", dt);
    function mt() {
      de("onfinish"), Be.removeListener("close", dt), It();
    }
    Be.once("finish", mt);
    function It() {
      de("unpipe"), Ge.unpipe(Be);
    }
    return Be.emit("pipe", Ge), je.flowing || (de("pipe resume"), Ge.resume()), Be;
  };
  function le(Be) {
    return function() {
      var Ue = Be._readableState;
      de("pipeOnDrain", Ue.awaitDrain), Ue.awaitDrain && Ue.awaitDrain--, Ue.awaitDrain === 0 && $(Be, "data") && (Ue.flowing = !0, be(Be));
    };
  }
  Te.prototype.unpipe = function(Be) {
    var Ue = this._readableState, Ge = { hasUnpiped: !1 };
    if (Ue.pipesCount === 0) return this;
    if (Ue.pipesCount === 1)
      return Be && Be !== Ue.pipes ? this : (Be || (Be = Ue.pipes), Ue.pipes = null, Ue.pipesCount = 0, Ue.flowing = !1, Be && Be.emit("unpipe", this, Ge), this);
    if (!Be) {
      var je = Ue.pipes, Oe = Ue.pipesCount;
      Ue.pipes = null, Ue.pipesCount = 0, Ue.flowing = !1;
      for (var Ne = 0; Ne < Oe; Ne++)
        je[Ne].emit("unpipe", this, { hasUnpiped: !1 });
      return this;
    }
    var Ye = We(Ue.pipes, Be);
    return Ye === -1 ? this : (Ue.pipes.splice(Ye, 1), Ue.pipesCount -= 1, Ue.pipesCount === 1 && (Ue.pipes = Ue.pipes[0]), Be.emit("unpipe", this, Ge), this);
  }, Te.prototype.on = function(Be, Ue) {
    var Ge = V.prototype.on.call(this, Be, Ue);
    if (Be === "data")
      this._readableState.flowing !== !1 && this.resume();
    else if (Be === "readable") {
      var je = this._readableState;
      !je.endEmitted && !je.readableListening && (je.readableListening = je.needReadable = !0, je.emittedReadable = !1, je.reading ? je.length && Ae(this) : C.nextTick(pe, this));
    }
    return Ge;
  }, Te.prototype.addListener = Te.prototype.on;
  function pe(Be) {
    de("readable nexttick read 0"), Be.read(0);
  }
  Te.prototype.resume = function() {
    var Be = this._readableState;
    return Be.flowing || (de("resume"), Be.flowing = !0, ye(this, Be)), this;
  };
  function ye(Be, Ue) {
    Ue.resumeScheduled || (Ue.resumeScheduled = !0, C.nextTick(Ce, Be, Ue));
  }
  function Ce(Be, Ue) {
    Ue.reading || (de("resume read 0"), Be.read(0)), Ue.resumeScheduled = !1, Ue.awaitDrain = 0, Be.emit("resume"), be(Be), Ue.flowing && !Ue.reading && Be.read(0);
  }
  Te.prototype.pause = function() {
    return de("call pause flowing=%j", this._readableState.flowing), this._readableState.flowing !== !1 && (de("pause"), this._readableState.flowing = !1, this.emit("pause")), this;
  };
  function be(Be) {
    var Ue = Be._readableState;
    for (de("flow", Ue.flowing); Ue.flowing && Be.read() !== null; )
      ;
  }
  Te.prototype.wrap = function(Be) {
    var Ue = this, Ge = this._readableState, je = !1;
    Be.on("end", function() {
      if (de("wrapped end"), Ge.decoder && !Ge.ended) {
        var Ye = Ge.decoder.end();
        Ye && Ye.length && Ue.push(Ye);
      }
      Ue.push(null);
    }), Be.on("data", function(Ye) {
      if (de("wrapped data"), Ge.decoder && (Ye = Ge.decoder.write(Ye)), !(Ge.objectMode && Ye == null) && !(!Ge.objectMode && (!Ye || !Ye.length))) {
        var Je = Ue.push(Ye);
        Je || (je = !0, Be.pause());
      }
    });
    for (var Oe in Be)
      this[Oe] === void 0 && typeof Be[Oe] == "function" && (this[Oe] = /* @__PURE__ */ function(Ye) {
        return function() {
          return Be[Ye].apply(Be, arguments);
        };
      }(Oe));
    for (var Ne = 0; Ne < me.length; Ne++)
      Be.on(me[Ne], this.emit.bind(this, me[Ne]));
    return this._read = function(Ye) {
      de("wrapped _read", Ye), je && (je = !1, Be.resume());
    }, this;
  }, Object.defineProperty(Te.prototype, "readableHighWaterMark", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._readableState.highWaterMark;
    }
  }), Te._fromList = ae;
  function ae(Be, Ue) {
    if (Ue.length === 0) return null;
    var Ge;
    return Ue.objectMode ? Ge = Ue.buffer.shift() : !Be || Be >= Ue.length ? (Ue.decoder ? Ge = Ue.buffer.join("") : Ue.buffer.length === 1 ? Ge = Ue.buffer.head.data : Ge = Ue.buffer.concat(Ue.length), Ue.buffer.clear()) : Ge = ge(Be, Ue.buffer, Ue.decoder), Ge;
  }
  function ge(Be, Ue, Ge) {
    var je;
    return Be < Ue.head.data.length ? (je = Ue.head.data.slice(0, Be), Ue.head.data = Ue.head.data.slice(Be)) : Be === Ue.head.data.length ? je = Ue.shift() : je = Ge ? Se(Be, Ue) : Le(Be, Ue), je;
  }
  function Se(Be, Ue) {
    var Ge = Ue.head, je = 1, Oe = Ge.data;
    for (Be -= Oe.length; Ge = Ge.next; ) {
      var Ne = Ge.data, Ye = Be > Ne.length ? Ne.length : Be;
      if (Ye === Ne.length ? Oe += Ne : Oe += Ne.slice(0, Be), Be -= Ye, Be === 0) {
        Ye === Ne.length ? (++je, Ge.next ? Ue.head = Ge.next : Ue.head = Ue.tail = null) : (Ue.head = Ge, Ge.data = Ne.slice(Ye));
        break;
      }
      ++je;
    }
    return Ue.length -= je, Oe;
  }
  function Le(Be, Ue) {
    var Ge = J.allocUnsafe(Be), je = Ue.head, Oe = 1;
    for (je.data.copy(Ge), Be -= je.data.length; je = je.next; ) {
      var Ne = je.data, Ye = Be > Ne.length ? Ne.length : Be;
      if (Ne.copy(Ge, Ge.length - Be, 0, Ye), Be -= Ye, Be === 0) {
        Ye === Ne.length ? (++Oe, je.next ? Ue.head = je.next : Ue.head = Ue.tail = null) : (Ue.head = je, je.data = Ne.slice(Ye));
        break;
      }
      ++Oe;
    }
    return Ue.length -= Oe, Ge;
  }
  function ze(Be) {
    var Ue = Be._readableState;
    if (Ue.length > 0) throw new Error('"endReadable()" called on non-empty stream');
    Ue.endEmitted || (Ue.ended = !0, C.nextTick(Re, Ue, Be));
  }
  function Re(Be, Ue) {
    !Be.endEmitted && Be.length === 0 && (Be.endEmitted = !0, Ue.readable = !1, Ue.emit("end"));
  }
  function We(Be, Ue) {
    for (var Ge = 0, je = Be.length; Ge < je; Ge++)
      if (Be[Ge] === Ue) return Ge;
    return -1;
  }
  return _stream_readable;
}
var _stream_transform, hasRequired_stream_transform;
function require_stream_transform() {
  if (hasRequired_stream_transform) return _stream_transform;
  hasRequired_stream_transform = 1, _stream_transform = $;
  var C = require_stream_duplex(), e = Object.create(requireUtil());
  e.inherits = requireInherits_browser(), e.inherits($, C);
  function T(ee, te) {
    var re = this._transformState;
    re.transforming = !1;
    var ie = re.writecb;
    if (!ie)
      return this.emit("error", new Error("write callback called multiple times"));
    re.writechunk = null, re.writecb = null, te != null && this.push(te), ie(ee);
    var se = this._readableState;
    se.reading = !1, (se.needReadable || se.length < se.highWaterMark) && this._read(se.highWaterMark);
  }
  function $(ee) {
    if (!(this instanceof $)) return new $(ee);
    C.call(this, ee), this._transformState = {
      afterTransform: T.bind(this),
      needTransform: !1,
      transforming: !1,
      writecb: null,
      writechunk: null,
      writeencoding: null
    }, this._readableState.needReadable = !0, this._readableState.sync = !1, ee && (typeof ee.transform == "function" && (this._transform = ee.transform), typeof ee.flush == "function" && (this._flush = ee.flush)), this.on("prefinish", V);
  }
  function V() {
    var ee = this;
    typeof this._flush == "function" ? this._flush(function(te, re) {
      J(ee, te, re);
    }) : J(this, null, null);
  }
  $.prototype.push = function(ee, te) {
    return this._transformState.needTransform = !1, C.prototype.push.call(this, ee, te);
  }, $.prototype._transform = function(ee, te, re) {
    throw new Error("_transform() is not implemented");
  }, $.prototype._write = function(ee, te, re) {
    var ie = this._transformState;
    if (ie.writecb = re, ie.writechunk = ee, ie.writeencoding = te, !ie.transforming) {
      var se = this._readableState;
      (ie.needTransform || se.needReadable || se.length < se.highWaterMark) && this._read(se.highWaterMark);
    }
  }, $.prototype._read = function(ee) {
    var te = this._transformState;
    te.writechunk !== null && te.writecb && !te.transforming ? (te.transforming = !0, this._transform(te.writechunk, te.writeencoding, te.afterTransform)) : te.needTransform = !0;
  }, $.prototype._destroy = function(ee, te) {
    var re = this;
    C.prototype._destroy.call(this, ee, function(ie) {
      te(ie), re.emit("close");
    });
  };
  function J(ee, te, re) {
    if (te) return ee.emit("error", te);
    if (re != null && ee.push(re), ee._writableState.length) throw new Error("Calling transform done when ws.length != 0");
    if (ee._transformState.transforming) throw new Error("Calling transform done when still transforming");
    return ee.push(null);
  }
  return _stream_transform;
}
var _stream_passthrough, hasRequired_stream_passthrough;
function require_stream_passthrough() {
  if (hasRequired_stream_passthrough) return _stream_passthrough;
  hasRequired_stream_passthrough = 1, _stream_passthrough = T;
  var C = require_stream_transform(), e = Object.create(requireUtil());
  e.inherits = requireInherits_browser(), e.inherits(T, C);
  function T($) {
    if (!(this instanceof T)) return new T($);
    C.call(this, $);
  }
  return T.prototype._transform = function($, V, J) {
    J(null, $);
  }, _stream_passthrough;
}
var hasRequiredReadableBrowser;
function requireReadableBrowser() {
  return hasRequiredReadableBrowser || (hasRequiredReadableBrowser = 1, function(C, e) {
    e = C.exports = require_stream_readable(), e.Stream = e, e.Readable = e, e.Writable = require_stream_writable(), e.Duplex = require_stream_duplex(), e.Transform = require_stream_transform(), e.PassThrough = require_stream_passthrough();
  }(readableBrowser, readableBrowser.exports)), readableBrowser.exports;
}
var sign$1 = { exports: {} }, bn$4 = { exports: {} };
bn$4.exports;
(function(C) {
  (function(e, T) {
    function $(oe, ce) {
      if (!oe) throw new Error(ce || "Assertion failed");
    }
    function V(oe, ce) {
      oe.super_ = ce;
      var le = function() {
      };
      le.prototype = ce.prototype, oe.prototype = new le(), oe.prototype.constructor = oe;
    }
    function J(oe, ce, le) {
      if (J.isBN(oe))
        return oe;
      this.negative = 0, this.words = null, this.length = 0, this.red = null, oe !== null && ((ce === "le" || ce === "be") && (le = ce, ce = 10), this._init(oe || 0, ce || 10, le || "be"));
    }
    typeof e == "object" ? e.exports = J : T.BN = J, J.BN = J, J.wordSize = 26;
    var ee;
    try {
      typeof window < "u" && typeof window.Buffer < "u" ? ee = window.Buffer : ee = bufferPolyfill.Buffer;
    } catch {
    }
    J.isBN = function(ce) {
      return ce instanceof J ? !0 : ce !== null && typeof ce == "object" && ce.constructor.wordSize === J.wordSize && Array.isArray(ce.words);
    }, J.max = function(ce, le) {
      return ce.cmp(le) > 0 ? ce : le;
    }, J.min = function(ce, le) {
      return ce.cmp(le) < 0 ? ce : le;
    }, J.prototype._init = function(ce, le, pe) {
      if (typeof ce == "number")
        return this._initNumber(ce, le, pe);
      if (typeof ce == "object")
        return this._initArray(ce, le, pe);
      le === "hex" && (le = 16), $(le === (le | 0) && le >= 2 && le <= 36), ce = ce.toString().replace(/\s+/g, "");
      var ye = 0;
      ce[0] === "-" && (ye++, this.negative = 1), ye < ce.length && (le === 16 ? this._parseHex(ce, ye, pe) : (this._parseBase(ce, le, ye), pe === "le" && this._initArray(this.toArray(), le, pe)));
    }, J.prototype._initNumber = function(ce, le, pe) {
      ce < 0 && (this.negative = 1, ce = -ce), ce < 67108864 ? (this.words = [ce & 67108863], this.length = 1) : ce < 4503599627370496 ? (this.words = [
        ce & 67108863,
        ce / 67108864 & 67108863
      ], this.length = 2) : ($(ce < 9007199254740992), this.words = [
        ce & 67108863,
        ce / 67108864 & 67108863,
        1
      ], this.length = 3), pe === "le" && this._initArray(this.toArray(), le, pe);
    }, J.prototype._initArray = function(ce, le, pe) {
      if ($(typeof ce.length == "number"), ce.length <= 0)
        return this.words = [0], this.length = 1, this;
      this.length = Math.ceil(ce.length / 3), this.words = new Array(this.length);
      for (var ye = 0; ye < this.length; ye++)
        this.words[ye] = 0;
      var Ce, be, ae = 0;
      if (pe === "be")
        for (ye = ce.length - 1, Ce = 0; ye >= 0; ye -= 3)
          be = ce[ye] | ce[ye - 1] << 8 | ce[ye - 2] << 16, this.words[Ce] |= be << ae & 67108863, this.words[Ce + 1] = be >>> 26 - ae & 67108863, ae += 24, ae >= 26 && (ae -= 26, Ce++);
      else if (pe === "le")
        for (ye = 0, Ce = 0; ye < ce.length; ye += 3)
          be = ce[ye] | ce[ye + 1] << 8 | ce[ye + 2] << 16, this.words[Ce] |= be << ae & 67108863, this.words[Ce + 1] = be >>> 26 - ae & 67108863, ae += 24, ae >= 26 && (ae -= 26, Ce++);
      return this._strip();
    };
    function te(oe, ce) {
      var le = oe.charCodeAt(ce);
      if (le >= 48 && le <= 57)
        return le - 48;
      if (le >= 65 && le <= 70)
        return le - 55;
      if (le >= 97 && le <= 102)
        return le - 87;
      $(!1, "Invalid character in " + oe);
    }
    function re(oe, ce, le) {
      var pe = te(oe, le);
      return le - 1 >= ce && (pe |= te(oe, le - 1) << 4), pe;
    }
    J.prototype._parseHex = function(ce, le, pe) {
      this.length = Math.ceil((ce.length - le) / 6), this.words = new Array(this.length);
      for (var ye = 0; ye < this.length; ye++)
        this.words[ye] = 0;
      var Ce = 0, be = 0, ae;
      if (pe === "be")
        for (ye = ce.length - 1; ye >= le; ye -= 2)
          ae = re(ce, le, ye) << Ce, this.words[be] |= ae & 67108863, Ce >= 18 ? (Ce -= 18, be += 1, this.words[be] |= ae >>> 26) : Ce += 8;
      else {
        var ge = ce.length - le;
        for (ye = ge % 2 === 0 ? le + 1 : le; ye < ce.length; ye += 2)
          ae = re(ce, le, ye) << Ce, this.words[be] |= ae & 67108863, Ce >= 18 ? (Ce -= 18, be += 1, this.words[be] |= ae >>> 26) : Ce += 8;
      }
      this._strip();
    };
    function ie(oe, ce, le, pe) {
      for (var ye = 0, Ce = 0, be = Math.min(oe.length, le), ae = ce; ae < be; ae++) {
        var ge = oe.charCodeAt(ae) - 48;
        ye *= pe, ge >= 49 ? Ce = ge - 49 + 10 : ge >= 17 ? Ce = ge - 17 + 10 : Ce = ge, $(ge >= 0 && Ce < pe, "Invalid character"), ye += Ce;
      }
      return ye;
    }
    J.prototype._parseBase = function(ce, le, pe) {
      this.words = [0], this.length = 1;
      for (var ye = 0, Ce = 1; Ce <= 67108863; Ce *= le)
        ye++;
      ye--, Ce = Ce / le | 0;
      for (var be = ce.length - pe, ae = be % ye, ge = Math.min(be, be - ae) + pe, Se = 0, Le = pe; Le < ge; Le += ye)
        Se = ie(ce, Le, Le + ye, le), this.imuln(Ce), this.words[0] + Se < 67108864 ? this.words[0] += Se : this._iaddn(Se);
      if (ae !== 0) {
        var ze = 1;
        for (Se = ie(ce, Le, ce.length, le), Le = 0; Le < ae; Le++)
          ze *= le;
        this.imuln(ze), this.words[0] + Se < 67108864 ? this.words[0] += Se : this._iaddn(Se);
      }
      this._strip();
    }, J.prototype.copy = function(ce) {
      ce.words = new Array(this.length);
      for (var le = 0; le < this.length; le++)
        ce.words[le] = this.words[le];
      ce.length = this.length, ce.negative = this.negative, ce.red = this.red;
    };
    function se(oe, ce) {
      oe.words = ce.words, oe.length = ce.length, oe.negative = ce.negative, oe.red = ce.red;
    }
    if (J.prototype._move = function(ce) {
      se(ce, this);
    }, J.prototype.clone = function() {
      var ce = new J(null);
      return this.copy(ce), ce;
    }, J.prototype._expand = function(ce) {
      for (; this.length < ce; )
        this.words[this.length++] = 0;
      return this;
    }, J.prototype._strip = function() {
      for (; this.length > 1 && this.words[this.length - 1] === 0; )
        this.length--;
      return this._normSign();
    }, J.prototype._normSign = function() {
      return this.length === 1 && this.words[0] === 0 && (this.negative = 0), this;
    }, typeof Symbol < "u" && typeof Symbol.for == "function")
      try {
        J.prototype[Symbol.for("nodejs.util.inspect.custom")] = de;
      } catch {
        J.prototype.inspect = de;
      }
    else
      J.prototype.inspect = de;
    function de() {
      return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
    }
    var ue = [
      "",
      "0",
      "00",
      "000",
      "0000",
      "00000",
      "000000",
      "0000000",
      "00000000",
      "000000000",
      "0000000000",
      "00000000000",
      "000000000000",
      "0000000000000",
      "00000000000000",
      "000000000000000",
      "0000000000000000",
      "00000000000000000",
      "000000000000000000",
      "0000000000000000000",
      "00000000000000000000",
      "000000000000000000000",
      "0000000000000000000000",
      "00000000000000000000000",
      "000000000000000000000000",
      "0000000000000000000000000"
    ], fe = [
      0,
      0,
      25,
      16,
      12,
      11,
      10,
      9,
      8,
      8,
      7,
      7,
      7,
      7,
      6,
      6,
      6,
      6,
      6,
      6,
      6,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5
    ], he = [
      0,
      0,
      33554432,
      43046721,
      16777216,
      48828125,
      60466176,
      40353607,
      16777216,
      43046721,
      1e7,
      19487171,
      35831808,
      62748517,
      7529536,
      11390625,
      16777216,
      24137569,
      34012224,
      47045881,
      64e6,
      4084101,
      5153632,
      6436343,
      7962624,
      9765625,
      11881376,
      14348907,
      17210368,
      20511149,
      243e5,
      28629151,
      33554432,
      39135393,
      45435424,
      52521875,
      60466176
    ];
    J.prototype.toString = function(ce, le) {
      ce = ce || 10, le = le | 0 || 1;
      var pe;
      if (ce === 16 || ce === "hex") {
        pe = "";
        for (var ye = 0, Ce = 0, be = 0; be < this.length; be++) {
          var ae = this.words[be], ge = ((ae << ye | Ce) & 16777215).toString(16);
          Ce = ae >>> 24 - ye & 16777215, ye += 2, ye >= 26 && (ye -= 26, be--), Ce !== 0 || be !== this.length - 1 ? pe = ue[6 - ge.length] + ge + pe : pe = ge + pe;
        }
        for (Ce !== 0 && (pe = Ce.toString(16) + pe); pe.length % le !== 0; )
          pe = "0" + pe;
        return this.negative !== 0 && (pe = "-" + pe), pe;
      }
      if (ce === (ce | 0) && ce >= 2 && ce <= 36) {
        var Se = fe[ce], Le = he[ce];
        pe = "";
        var ze = this.clone();
        for (ze.negative = 0; !ze.isZero(); ) {
          var Re = ze.modrn(Le).toString(ce);
          ze = ze.idivn(Le), ze.isZero() ? pe = Re + pe : pe = ue[Se - Re.length] + Re + pe;
        }
        for (this.isZero() && (pe = "0" + pe); pe.length % le !== 0; )
          pe = "0" + pe;
        return this.negative !== 0 && (pe = "-" + pe), pe;
      }
      $(!1, "Base should be between 2 and 36");
    }, J.prototype.toNumber = function() {
      var ce = this.words[0];
      return this.length === 2 ? ce += this.words[1] * 67108864 : this.length === 3 && this.words[2] === 1 ? ce += 4503599627370496 + this.words[1] * 67108864 : this.length > 2 && $(!1, "Number can only safely store up to 53 bits"), this.negative !== 0 ? -ce : ce;
    }, J.prototype.toJSON = function() {
      return this.toString(16, 2);
    }, ee && (J.prototype.toBuffer = function(ce, le) {
      return this.toArrayLike(ee, ce, le);
    }), J.prototype.toArray = function(ce, le) {
      return this.toArrayLike(Array, ce, le);
    };
    var me = function(ce, le) {
      return ce.allocUnsafe ? ce.allocUnsafe(le) : new ce(le);
    };
    J.prototype.toArrayLike = function(ce, le, pe) {
      this._strip();
      var ye = this.byteLength(), Ce = pe || Math.max(1, ye);
      $(ye <= Ce, "byte array longer than desired length"), $(Ce > 0, "Requested array length <= 0");
      var be = me(ce, Ce), ae = le === "le" ? "LE" : "BE";
      return this["_toArrayLike" + ae](be, ye), be;
    }, J.prototype._toArrayLikeLE = function(ce, le) {
      for (var pe = 0, ye = 0, Ce = 0, be = 0; Ce < this.length; Ce++) {
        var ae = this.words[Ce] << be | ye;
        ce[pe++] = ae & 255, pe < ce.length && (ce[pe++] = ae >> 8 & 255), pe < ce.length && (ce[pe++] = ae >> 16 & 255), be === 6 ? (pe < ce.length && (ce[pe++] = ae >> 24 & 255), ye = 0, be = 0) : (ye = ae >>> 24, be += 2);
      }
      if (pe < ce.length)
        for (ce[pe++] = ye; pe < ce.length; )
          ce[pe++] = 0;
    }, J.prototype._toArrayLikeBE = function(ce, le) {
      for (var pe = ce.length - 1, ye = 0, Ce = 0, be = 0; Ce < this.length; Ce++) {
        var ae = this.words[Ce] << be | ye;
        ce[pe--] = ae & 255, pe >= 0 && (ce[pe--] = ae >> 8 & 255), pe >= 0 && (ce[pe--] = ae >> 16 & 255), be === 6 ? (pe >= 0 && (ce[pe--] = ae >> 24 & 255), ye = 0, be = 0) : (ye = ae >>> 24, be += 2);
      }
      if (pe >= 0)
        for (ce[pe--] = ye; pe >= 0; )
          ce[pe--] = 0;
    }, Math.clz32 ? J.prototype._countBits = function(ce) {
      return 32 - Math.clz32(ce);
    } : J.prototype._countBits = function(ce) {
      var le = ce, pe = 0;
      return le >= 4096 && (pe += 13, le >>>= 13), le >= 64 && (pe += 7, le >>>= 7), le >= 8 && (pe += 4, le >>>= 4), le >= 2 && (pe += 2, le >>>= 2), pe + le;
    }, J.prototype._zeroBits = function(ce) {
      if (ce === 0) return 26;
      var le = ce, pe = 0;
      return le & 8191 || (pe += 13, le >>>= 13), le & 127 || (pe += 7, le >>>= 7), le & 15 || (pe += 4, le >>>= 4), le & 3 || (pe += 2, le >>>= 2), le & 1 || pe++, pe;
    }, J.prototype.bitLength = function() {
      var ce = this.words[this.length - 1], le = this._countBits(ce);
      return (this.length - 1) * 26 + le;
    };
    function xe(oe) {
      for (var ce = new Array(oe.bitLength()), le = 0; le < ce.length; le++) {
        var pe = le / 26 | 0, ye = le % 26;
        ce[le] = oe.words[pe] >>> ye & 1;
      }
      return ce;
    }
    J.prototype.zeroBits = function() {
      if (this.isZero()) return 0;
      for (var ce = 0, le = 0; le < this.length; le++) {
        var pe = this._zeroBits(this.words[le]);
        if (ce += pe, pe !== 26) break;
      }
      return ce;
    }, J.prototype.byteLength = function() {
      return Math.ceil(this.bitLength() / 8);
    }, J.prototype.toTwos = function(ce) {
      return this.negative !== 0 ? this.abs().inotn(ce).iaddn(1) : this.clone();
    }, J.prototype.fromTwos = function(ce) {
      return this.testn(ce - 1) ? this.notn(ce).iaddn(1).ineg() : this.clone();
    }, J.prototype.isNeg = function() {
      return this.negative !== 0;
    }, J.prototype.neg = function() {
      return this.clone().ineg();
    }, J.prototype.ineg = function() {
      return this.isZero() || (this.negative ^= 1), this;
    }, J.prototype.iuor = function(ce) {
      for (; this.length < ce.length; )
        this.words[this.length++] = 0;
      for (var le = 0; le < ce.length; le++)
        this.words[le] = this.words[le] | ce.words[le];
      return this._strip();
    }, J.prototype.ior = function(ce) {
      return $((this.negative | ce.negative) === 0), this.iuor(ce);
    }, J.prototype.or = function(ce) {
      return this.length > ce.length ? this.clone().ior(ce) : ce.clone().ior(this);
    }, J.prototype.uor = function(ce) {
      return this.length > ce.length ? this.clone().iuor(ce) : ce.clone().iuor(this);
    }, J.prototype.iuand = function(ce) {
      var le;
      this.length > ce.length ? le = ce : le = this;
      for (var pe = 0; pe < le.length; pe++)
        this.words[pe] = this.words[pe] & ce.words[pe];
      return this.length = le.length, this._strip();
    }, J.prototype.iand = function(ce) {
      return $((this.negative | ce.negative) === 0), this.iuand(ce);
    }, J.prototype.and = function(ce) {
      return this.length > ce.length ? this.clone().iand(ce) : ce.clone().iand(this);
    }, J.prototype.uand = function(ce) {
      return this.length > ce.length ? this.clone().iuand(ce) : ce.clone().iuand(this);
    }, J.prototype.iuxor = function(ce) {
      var le, pe;
      this.length > ce.length ? (le = this, pe = ce) : (le = ce, pe = this);
      for (var ye = 0; ye < pe.length; ye++)
        this.words[ye] = le.words[ye] ^ pe.words[ye];
      if (this !== le)
        for (; ye < le.length; ye++)
          this.words[ye] = le.words[ye];
      return this.length = le.length, this._strip();
    }, J.prototype.ixor = function(ce) {
      return $((this.negative | ce.negative) === 0), this.iuxor(ce);
    }, J.prototype.xor = function(ce) {
      return this.length > ce.length ? this.clone().ixor(ce) : ce.clone().ixor(this);
    }, J.prototype.uxor = function(ce) {
      return this.length > ce.length ? this.clone().iuxor(ce) : ce.clone().iuxor(this);
    }, J.prototype.inotn = function(ce) {
      $(typeof ce == "number" && ce >= 0);
      var le = Math.ceil(ce / 26) | 0, pe = ce % 26;
      this._expand(le), pe > 0 && le--;
      for (var ye = 0; ye < le; ye++)
        this.words[ye] = ~this.words[ye] & 67108863;
      return pe > 0 && (this.words[ye] = ~this.words[ye] & 67108863 >> 26 - pe), this._strip();
    }, J.prototype.notn = function(ce) {
      return this.clone().inotn(ce);
    }, J.prototype.setn = function(ce, le) {
      $(typeof ce == "number" && ce >= 0);
      var pe = ce / 26 | 0, ye = ce % 26;
      return this._expand(pe + 1), le ? this.words[pe] = this.words[pe] | 1 << ye : this.words[pe] = this.words[pe] & ~(1 << ye), this._strip();
    }, J.prototype.iadd = function(ce) {
      var le;
      if (this.negative !== 0 && ce.negative === 0)
        return this.negative = 0, le = this.isub(ce), this.negative ^= 1, this._normSign();
      if (this.negative === 0 && ce.negative !== 0)
        return ce.negative = 0, le = this.isub(ce), ce.negative = 1, le._normSign();
      var pe, ye;
      this.length > ce.length ? (pe = this, ye = ce) : (pe = ce, ye = this);
      for (var Ce = 0, be = 0; be < ye.length; be++)
        le = (pe.words[be] | 0) + (ye.words[be] | 0) + Ce, this.words[be] = le & 67108863, Ce = le >>> 26;
      for (; Ce !== 0 && be < pe.length; be++)
        le = (pe.words[be] | 0) + Ce, this.words[be] = le & 67108863, Ce = le >>> 26;
      if (this.length = pe.length, Ce !== 0)
        this.words[this.length] = Ce, this.length++;
      else if (pe !== this)
        for (; be < pe.length; be++)
          this.words[be] = pe.words[be];
      return this;
    }, J.prototype.add = function(ce) {
      var le;
      return ce.negative !== 0 && this.negative === 0 ? (ce.negative = 0, le = this.sub(ce), ce.negative ^= 1, le) : ce.negative === 0 && this.negative !== 0 ? (this.negative = 0, le = ce.sub(this), this.negative = 1, le) : this.length > ce.length ? this.clone().iadd(ce) : ce.clone().iadd(this);
    }, J.prototype.isub = function(ce) {
      if (ce.negative !== 0) {
        ce.negative = 0;
        var le = this.iadd(ce);
        return ce.negative = 1, le._normSign();
      } else if (this.negative !== 0)
        return this.negative = 0, this.iadd(ce), this.negative = 1, this._normSign();
      var pe = this.cmp(ce);
      if (pe === 0)
        return this.negative = 0, this.length = 1, this.words[0] = 0, this;
      var ye, Ce;
      pe > 0 ? (ye = this, Ce = ce) : (ye = ce, Ce = this);
      for (var be = 0, ae = 0; ae < Ce.length; ae++)
        le = (ye.words[ae] | 0) - (Ce.words[ae] | 0) + be, be = le >> 26, this.words[ae] = le & 67108863;
      for (; be !== 0 && ae < ye.length; ae++)
        le = (ye.words[ae] | 0) + be, be = le >> 26, this.words[ae] = le & 67108863;
      if (be === 0 && ae < ye.length && ye !== this)
        for (; ae < ye.length; ae++)
          this.words[ae] = ye.words[ae];
      return this.length = Math.max(this.length, ae), ye !== this && (this.negative = 1), this._strip();
    }, J.prototype.sub = function(ce) {
      return this.clone().isub(ce);
    };
    function ve(oe, ce, le) {
      le.negative = ce.negative ^ oe.negative;
      var pe = oe.length + ce.length | 0;
      le.length = pe, pe = pe - 1 | 0;
      var ye = oe.words[0] | 0, Ce = ce.words[0] | 0, be = ye * Ce, ae = be & 67108863, ge = be / 67108864 | 0;
      le.words[0] = ae;
      for (var Se = 1; Se < pe; Se++) {
        for (var Le = ge >>> 26, ze = ge & 67108863, Re = Math.min(Se, ce.length - 1), We = Math.max(0, Se - oe.length + 1); We <= Re; We++) {
          var Be = Se - We | 0;
          ye = oe.words[Be] | 0, Ce = ce.words[We] | 0, be = ye * Ce + ze, Le += be / 67108864 | 0, ze = be & 67108863;
        }
        le.words[Se] = ze | 0, ge = Le | 0;
      }
      return ge !== 0 ? le.words[Se] = ge | 0 : le.length--, le._strip();
    }
    var Te = function(ce, le, pe) {
      var ye = ce.words, Ce = le.words, be = pe.words, ae = 0, ge, Se, Le, ze = ye[0] | 0, Re = ze & 8191, We = ze >>> 13, Be = ye[1] | 0, Ue = Be & 8191, Ge = Be >>> 13, je = ye[2] | 0, Oe = je & 8191, Ne = je >>> 13, Ye = ye[3] | 0, Je = Ye & 8191, Xe = Ye >>> 13, st = ye[4] | 0, ct = st & 8191, it = st >>> 13, ot = ye[5] | 0, yt = ot & 8191, dt = ot >>> 13, mt = ye[6] | 0, It = mt & 8191, xt = mt >>> 13, Tt = ye[7] | 0, Yt = Tt & 8191, Ve = Tt >>> 13, Pe = ye[8] | 0, $e = Pe & 8191, Ze = Pe >>> 13, at = ye[9] | 0, wt = at & 8191, ft = at >>> 13, Ct = Ce[0] | 0, Ut = Ct & 8191, vt = Ct >>> 13, Mt = Ce[1] | 0, Xt = Mt & 8191, St = Mt >>> 13, Ot = Ce[2] | 0, wn = Ot & 8191, kt = Ot >>> 13, Bt = Ce[3] | 0, Tn = Bt & 8191, Nt = Bt >>> 13, Wt = Ce[4] | 0, En = Wt & 8191, Lt = Wt >>> 13, Ht = Ce[5] | 0, In = Ht & 8191, Dt = Ht >>> 13, Gt = Ce[6] | 0, Ke = Gt & 8191, Qe = Gt >>> 13, et = Ce[7] | 0, He = et & 8191, nt = et >>> 13, qe = Ce[8] | 0, ht = qe & 8191, pt = qe >>> 13, bt = Ce[9] | 0, jt = bt & 8191, $t = bt >>> 13;
      pe.negative = ce.negative ^ le.negative, pe.length = 19, ge = Math.imul(Re, Ut), Se = Math.imul(Re, vt), Se = Se + Math.imul(We, Ut) | 0, Le = Math.imul(We, vt);
      var Jt = (ae + ge | 0) + ((Se & 8191) << 13) | 0;
      ae = (Le + (Se >>> 13) | 0) + (Jt >>> 26) | 0, Jt &= 67108863, ge = Math.imul(Ue, Ut), Se = Math.imul(Ue, vt), Se = Se + Math.imul(Ge, Ut) | 0, Le = Math.imul(Ge, vt), ge = ge + Math.imul(Re, Xt) | 0, Se = Se + Math.imul(Re, St) | 0, Se = Se + Math.imul(We, Xt) | 0, Le = Le + Math.imul(We, St) | 0;
      var zt = (ae + ge | 0) + ((Se & 8191) << 13) | 0;
      ae = (Le + (Se >>> 13) | 0) + (zt >>> 26) | 0, zt &= 67108863, ge = Math.imul(Oe, Ut), Se = Math.imul(Oe, vt), Se = Se + Math.imul(Ne, Ut) | 0, Le = Math.imul(Ne, vt), ge = ge + Math.imul(Ue, Xt) | 0, Se = Se + Math.imul(Ue, St) | 0, Se = Se + Math.imul(Ge, Xt) | 0, Le = Le + Math.imul(Ge, St) | 0, ge = ge + Math.imul(Re, wn) | 0, Se = Se + Math.imul(Re, kt) | 0, Se = Se + Math.imul(We, wn) | 0, Le = Le + Math.imul(We, kt) | 0;
      var Vt = (ae + ge | 0) + ((Se & 8191) << 13) | 0;
      ae = (Le + (Se >>> 13) | 0) + (Vt >>> 26) | 0, Vt &= 67108863, ge = Math.imul(Je, Ut), Se = Math.imul(Je, vt), Se = Se + Math.imul(Xe, Ut) | 0, Le = Math.imul(Xe, vt), ge = ge + Math.imul(Oe, Xt) | 0, Se = Se + Math.imul(Oe, St) | 0, Se = Se + Math.imul(Ne, Xt) | 0, Le = Le + Math.imul(Ne, St) | 0, ge = ge + Math.imul(Ue, wn) | 0, Se = Se + Math.imul(Ue, kt) | 0, Se = Se + Math.imul(Ge, wn) | 0, Le = Le + Math.imul(Ge, kt) | 0, ge = ge + Math.imul(Re, Tn) | 0, Se = Se + Math.imul(Re, Nt) | 0, Se = Se + Math.imul(We, Tn) | 0, Le = Le + Math.imul(We, Nt) | 0;
      var Kt = (ae + ge | 0) + ((Se & 8191) << 13) | 0;
      ae = (Le + (Se >>> 13) | 0) + (Kt >>> 26) | 0, Kt &= 67108863, ge = Math.imul(ct, Ut), Se = Math.imul(ct, vt), Se = Se + Math.imul(it, Ut) | 0, Le = Math.imul(it, vt), ge = ge + Math.imul(Je, Xt) | 0, Se = Se + Math.imul(Je, St) | 0, Se = Se + Math.imul(Xe, Xt) | 0, Le = Le + Math.imul(Xe, St) | 0, ge = ge + Math.imul(Oe, wn) | 0, Se = Se + Math.imul(Oe, kt) | 0, Se = Se + Math.imul(Ne, wn) | 0, Le = Le + Math.imul(Ne, kt) | 0, ge = ge + Math.imul(Ue, Tn) | 0, Se = Se + Math.imul(Ue, Nt) | 0, Se = Se + Math.imul(Ge, Tn) | 0, Le = Le + Math.imul(Ge, Nt) | 0, ge = ge + Math.imul(Re, En) | 0, Se = Se + Math.imul(Re, Lt) | 0, Se = Se + Math.imul(We, En) | 0, Le = Le + Math.imul(We, Lt) | 0;
      var pn = (ae + ge | 0) + ((Se & 8191) << 13) | 0;
      ae = (Le + (Se >>> 13) | 0) + (pn >>> 26) | 0, pn &= 67108863, ge = Math.imul(yt, Ut), Se = Math.imul(yt, vt), Se = Se + Math.imul(dt, Ut) | 0, Le = Math.imul(dt, vt), ge = ge + Math.imul(ct, Xt) | 0, Se = Se + Math.imul(ct, St) | 0, Se = Se + Math.imul(it, Xt) | 0, Le = Le + Math.imul(it, St) | 0, ge = ge + Math.imul(Je, wn) | 0, Se = Se + Math.imul(Je, kt) | 0, Se = Se + Math.imul(Xe, wn) | 0, Le = Le + Math.imul(Xe, kt) | 0, ge = ge + Math.imul(Oe, Tn) | 0, Se = Se + Math.imul(Oe, Nt) | 0, Se = Se + Math.imul(Ne, Tn) | 0, Le = Le + Math.imul(Ne, Nt) | 0, ge = ge + Math.imul(Ue, En) | 0, Se = Se + Math.imul(Ue, Lt) | 0, Se = Se + Math.imul(Ge, En) | 0, Le = Le + Math.imul(Ge, Lt) | 0, ge = ge + Math.imul(Re, In) | 0, Se = Se + Math.imul(Re, Dt) | 0, Se = Se + Math.imul(We, In) | 0, Le = Le + Math.imul(We, Dt) | 0;
      var An = (ae + ge | 0) + ((Se & 8191) << 13) | 0;
      ae = (Le + (Se >>> 13) | 0) + (An >>> 26) | 0, An &= 67108863, ge = Math.imul(It, Ut), Se = Math.imul(It, vt), Se = Se + Math.imul(xt, Ut) | 0, Le = Math.imul(xt, vt), ge = ge + Math.imul(yt, Xt) | 0, Se = Se + Math.imul(yt, St) | 0, Se = Se + Math.imul(dt, Xt) | 0, Le = Le + Math.imul(dt, St) | 0, ge = ge + Math.imul(ct, wn) | 0, Se = Se + Math.imul(ct, kt) | 0, Se = Se + Math.imul(it, wn) | 0, Le = Le + Math.imul(it, kt) | 0, ge = ge + Math.imul(Je, Tn) | 0, Se = Se + Math.imul(Je, Nt) | 0, Se = Se + Math.imul(Xe, Tn) | 0, Le = Le + Math.imul(Xe, Nt) | 0, ge = ge + Math.imul(Oe, En) | 0, Se = Se + Math.imul(Oe, Lt) | 0, Se = Se + Math.imul(Ne, En) | 0, Le = Le + Math.imul(Ne, Lt) | 0, ge = ge + Math.imul(Ue, In) | 0, Se = Se + Math.imul(Ue, Dt) | 0, Se = Se + Math.imul(Ge, In) | 0, Le = Le + Math.imul(Ge, Dt) | 0, ge = ge + Math.imul(Re, Ke) | 0, Se = Se + Math.imul(Re, Qe) | 0, Se = Se + Math.imul(We, Ke) | 0, Le = Le + Math.imul(We, Qe) | 0;
      var vn = (ae + ge | 0) + ((Se & 8191) << 13) | 0;
      ae = (Le + (Se >>> 13) | 0) + (vn >>> 26) | 0, vn &= 67108863, ge = Math.imul(Yt, Ut), Se = Math.imul(Yt, vt), Se = Se + Math.imul(Ve, Ut) | 0, Le = Math.imul(Ve, vt), ge = ge + Math.imul(It, Xt) | 0, Se = Se + Math.imul(It, St) | 0, Se = Se + Math.imul(xt, Xt) | 0, Le = Le + Math.imul(xt, St) | 0, ge = ge + Math.imul(yt, wn) | 0, Se = Se + Math.imul(yt, kt) | 0, Se = Se + Math.imul(dt, wn) | 0, Le = Le + Math.imul(dt, kt) | 0, ge = ge + Math.imul(ct, Tn) | 0, Se = Se + Math.imul(ct, Nt) | 0, Se = Se + Math.imul(it, Tn) | 0, Le = Le + Math.imul(it, Nt) | 0, ge = ge + Math.imul(Je, En) | 0, Se = Se + Math.imul(Je, Lt) | 0, Se = Se + Math.imul(Xe, En) | 0, Le = Le + Math.imul(Xe, Lt) | 0, ge = ge + Math.imul(Oe, In) | 0, Se = Se + Math.imul(Oe, Dt) | 0, Se = Se + Math.imul(Ne, In) | 0, Le = Le + Math.imul(Ne, Dt) | 0, ge = ge + Math.imul(Ue, Ke) | 0, Se = Se + Math.imul(Ue, Qe) | 0, Se = Se + Math.imul(Ge, Ke) | 0, Le = Le + Math.imul(Ge, Qe) | 0, ge = ge + Math.imul(Re, He) | 0, Se = Se + Math.imul(Re, nt) | 0, Se = Se + Math.imul(We, He) | 0, Le = Le + Math.imul(We, nt) | 0;
      var Cn = (ae + ge | 0) + ((Se & 8191) << 13) | 0;
      ae = (Le + (Se >>> 13) | 0) + (Cn >>> 26) | 0, Cn &= 67108863, ge = Math.imul($e, Ut), Se = Math.imul($e, vt), Se = Se + Math.imul(Ze, Ut) | 0, Le = Math.imul(Ze, vt), ge = ge + Math.imul(Yt, Xt) | 0, Se = Se + Math.imul(Yt, St) | 0, Se = Se + Math.imul(Ve, Xt) | 0, Le = Le + Math.imul(Ve, St) | 0, ge = ge + Math.imul(It, wn) | 0, Se = Se + Math.imul(It, kt) | 0, Se = Se + Math.imul(xt, wn) | 0, Le = Le + Math.imul(xt, kt) | 0, ge = ge + Math.imul(yt, Tn) | 0, Se = Se + Math.imul(yt, Nt) | 0, Se = Se + Math.imul(dt, Tn) | 0, Le = Le + Math.imul(dt, Nt) | 0, ge = ge + Math.imul(ct, En) | 0, Se = Se + Math.imul(ct, Lt) | 0, Se = Se + Math.imul(it, En) | 0, Le = Le + Math.imul(it, Lt) | 0, ge = ge + Math.imul(Je, In) | 0, Se = Se + Math.imul(Je, Dt) | 0, Se = Se + Math.imul(Xe, In) | 0, Le = Le + Math.imul(Xe, Dt) | 0, ge = ge + Math.imul(Oe, Ke) | 0, Se = Se + Math.imul(Oe, Qe) | 0, Se = Se + Math.imul(Ne, Ke) | 0, Le = Le + Math.imul(Ne, Qe) | 0, ge = ge + Math.imul(Ue, He) | 0, Se = Se + Math.imul(Ue, nt) | 0, Se = Se + Math.imul(Ge, He) | 0, Le = Le + Math.imul(Ge, nt) | 0, ge = ge + Math.imul(Re, ht) | 0, Se = Se + Math.imul(Re, pt) | 0, Se = Se + Math.imul(We, ht) | 0, Le = Le + Math.imul(We, pt) | 0;
      var yn = (ae + ge | 0) + ((Se & 8191) << 13) | 0;
      ae = (Le + (Se >>> 13) | 0) + (yn >>> 26) | 0, yn &= 67108863, ge = Math.imul(wt, Ut), Se = Math.imul(wt, vt), Se = Se + Math.imul(ft, Ut) | 0, Le = Math.imul(ft, vt), ge = ge + Math.imul($e, Xt) | 0, Se = Se + Math.imul($e, St) | 0, Se = Se + Math.imul(Ze, Xt) | 0, Le = Le + Math.imul(Ze, St) | 0, ge = ge + Math.imul(Yt, wn) | 0, Se = Se + Math.imul(Yt, kt) | 0, Se = Se + Math.imul(Ve, wn) | 0, Le = Le + Math.imul(Ve, kt) | 0, ge = ge + Math.imul(It, Tn) | 0, Se = Se + Math.imul(It, Nt) | 0, Se = Se + Math.imul(xt, Tn) | 0, Le = Le + Math.imul(xt, Nt) | 0, ge = ge + Math.imul(yt, En) | 0, Se = Se + Math.imul(yt, Lt) | 0, Se = Se + Math.imul(dt, En) | 0, Le = Le + Math.imul(dt, Lt) | 0, ge = ge + Math.imul(ct, In) | 0, Se = Se + Math.imul(ct, Dt) | 0, Se = Se + Math.imul(it, In) | 0, Le = Le + Math.imul(it, Dt) | 0, ge = ge + Math.imul(Je, Ke) | 0, Se = Se + Math.imul(Je, Qe) | 0, Se = Se + Math.imul(Xe, Ke) | 0, Le = Le + Math.imul(Xe, Qe) | 0, ge = ge + Math.imul(Oe, He) | 0, Se = Se + Math.imul(Oe, nt) | 0, Se = Se + Math.imul(Ne, He) | 0, Le = Le + Math.imul(Ne, nt) | 0, ge = ge + Math.imul(Ue, ht) | 0, Se = Se + Math.imul(Ue, pt) | 0, Se = Se + Math.imul(Ge, ht) | 0, Le = Le + Math.imul(Ge, pt) | 0, ge = ge + Math.imul(Re, jt) | 0, Se = Se + Math.imul(Re, $t) | 0, Se = Se + Math.imul(We, jt) | 0, Le = Le + Math.imul(We, $t) | 0;
      var dn = (ae + ge | 0) + ((Se & 8191) << 13) | 0;
      ae = (Le + (Se >>> 13) | 0) + (dn >>> 26) | 0, dn &= 67108863, ge = Math.imul(wt, Xt), Se = Math.imul(wt, St), Se = Se + Math.imul(ft, Xt) | 0, Le = Math.imul(ft, St), ge = ge + Math.imul($e, wn) | 0, Se = Se + Math.imul($e, kt) | 0, Se = Se + Math.imul(Ze, wn) | 0, Le = Le + Math.imul(Ze, kt) | 0, ge = ge + Math.imul(Yt, Tn) | 0, Se = Se + Math.imul(Yt, Nt) | 0, Se = Se + Math.imul(Ve, Tn) | 0, Le = Le + Math.imul(Ve, Nt) | 0, ge = ge + Math.imul(It, En) | 0, Se = Se + Math.imul(It, Lt) | 0, Se = Se + Math.imul(xt, En) | 0, Le = Le + Math.imul(xt, Lt) | 0, ge = ge + Math.imul(yt, In) | 0, Se = Se + Math.imul(yt, Dt) | 0, Se = Se + Math.imul(dt, In) | 0, Le = Le + Math.imul(dt, Dt) | 0, ge = ge + Math.imul(ct, Ke) | 0, Se = Se + Math.imul(ct, Qe) | 0, Se = Se + Math.imul(it, Ke) | 0, Le = Le + Math.imul(it, Qe) | 0, ge = ge + Math.imul(Je, He) | 0, Se = Se + Math.imul(Je, nt) | 0, Se = Se + Math.imul(Xe, He) | 0, Le = Le + Math.imul(Xe, nt) | 0, ge = ge + Math.imul(Oe, ht) | 0, Se = Se + Math.imul(Oe, pt) | 0, Se = Se + Math.imul(Ne, ht) | 0, Le = Le + Math.imul(Ne, pt) | 0, ge = ge + Math.imul(Ue, jt) | 0, Se = Se + Math.imul(Ue, $t) | 0, Se = Se + Math.imul(Ge, jt) | 0, Le = Le + Math.imul(Ge, $t) | 0;
      var xn = (ae + ge | 0) + ((Se & 8191) << 13) | 0;
      ae = (Le + (Se >>> 13) | 0) + (xn >>> 26) | 0, xn &= 67108863, ge = Math.imul(wt, wn), Se = Math.imul(wt, kt), Se = Se + Math.imul(ft, wn) | 0, Le = Math.imul(ft, kt), ge = ge + Math.imul($e, Tn) | 0, Se = Se + Math.imul($e, Nt) | 0, Se = Se + Math.imul(Ze, Tn) | 0, Le = Le + Math.imul(Ze, Nt) | 0, ge = ge + Math.imul(Yt, En) | 0, Se = Se + Math.imul(Yt, Lt) | 0, Se = Se + Math.imul(Ve, En) | 0, Le = Le + Math.imul(Ve, Lt) | 0, ge = ge + Math.imul(It, In) | 0, Se = Se + Math.imul(It, Dt) | 0, Se = Se + Math.imul(xt, In) | 0, Le = Le + Math.imul(xt, Dt) | 0, ge = ge + Math.imul(yt, Ke) | 0, Se = Se + Math.imul(yt, Qe) | 0, Se = Se + Math.imul(dt, Ke) | 0, Le = Le + Math.imul(dt, Qe) | 0, ge = ge + Math.imul(ct, He) | 0, Se = Se + Math.imul(ct, nt) | 0, Se = Se + Math.imul(it, He) | 0, Le = Le + Math.imul(it, nt) | 0, ge = ge + Math.imul(Je, ht) | 0, Se = Se + Math.imul(Je, pt) | 0, Se = Se + Math.imul(Xe, ht) | 0, Le = Le + Math.imul(Xe, pt) | 0, ge = ge + Math.imul(Oe, jt) | 0, Se = Se + Math.imul(Oe, $t) | 0, Se = Se + Math.imul(Ne, jt) | 0, Le = Le + Math.imul(Ne, $t) | 0;
      var ln = (ae + ge | 0) + ((Se & 8191) << 13) | 0;
      ae = (Le + (Se >>> 13) | 0) + (ln >>> 26) | 0, ln &= 67108863, ge = Math.imul(wt, Tn), Se = Math.imul(wt, Nt), Se = Se + Math.imul(ft, Tn) | 0, Le = Math.imul(ft, Nt), ge = ge + Math.imul($e, En) | 0, Se = Se + Math.imul($e, Lt) | 0, Se = Se + Math.imul(Ze, En) | 0, Le = Le + Math.imul(Ze, Lt) | 0, ge = ge + Math.imul(Yt, In) | 0, Se = Se + Math.imul(Yt, Dt) | 0, Se = Se + Math.imul(Ve, In) | 0, Le = Le + Math.imul(Ve, Dt) | 0, ge = ge + Math.imul(It, Ke) | 0, Se = Se + Math.imul(It, Qe) | 0, Se = Se + Math.imul(xt, Ke) | 0, Le = Le + Math.imul(xt, Qe) | 0, ge = ge + Math.imul(yt, He) | 0, Se = Se + Math.imul(yt, nt) | 0, Se = Se + Math.imul(dt, He) | 0, Le = Le + Math.imul(dt, nt) | 0, ge = ge + Math.imul(ct, ht) | 0, Se = Se + Math.imul(ct, pt) | 0, Se = Se + Math.imul(it, ht) | 0, Le = Le + Math.imul(it, pt) | 0, ge = ge + Math.imul(Je, jt) | 0, Se = Se + Math.imul(Je, $t) | 0, Se = Se + Math.imul(Xe, jt) | 0, Le = Le + Math.imul(Xe, $t) | 0;
      var mn = (ae + ge | 0) + ((Se & 8191) << 13) | 0;
      ae = (Le + (Se >>> 13) | 0) + (mn >>> 26) | 0, mn &= 67108863, ge = Math.imul(wt, En), Se = Math.imul(wt, Lt), Se = Se + Math.imul(ft, En) | 0, Le = Math.imul(ft, Lt), ge = ge + Math.imul($e, In) | 0, Se = Se + Math.imul($e, Dt) | 0, Se = Se + Math.imul(Ze, In) | 0, Le = Le + Math.imul(Ze, Dt) | 0, ge = ge + Math.imul(Yt, Ke) | 0, Se = Se + Math.imul(Yt, Qe) | 0, Se = Se + Math.imul(Ve, Ke) | 0, Le = Le + Math.imul(Ve, Qe) | 0, ge = ge + Math.imul(It, He) | 0, Se = Se + Math.imul(It, nt) | 0, Se = Se + Math.imul(xt, He) | 0, Le = Le + Math.imul(xt, nt) | 0, ge = ge + Math.imul(yt, ht) | 0, Se = Se + Math.imul(yt, pt) | 0, Se = Se + Math.imul(dt, ht) | 0, Le = Le + Math.imul(dt, pt) | 0, ge = ge + Math.imul(ct, jt) | 0, Se = Se + Math.imul(ct, $t) | 0, Se = Se + Math.imul(it, jt) | 0, Le = Le + Math.imul(it, $t) | 0;
      var gn = (ae + ge | 0) + ((Se & 8191) << 13) | 0;
      ae = (Le + (Se >>> 13) | 0) + (gn >>> 26) | 0, gn &= 67108863, ge = Math.imul(wt, In), Se = Math.imul(wt, Dt), Se = Se + Math.imul(ft, In) | 0, Le = Math.imul(ft, Dt), ge = ge + Math.imul($e, Ke) | 0, Se = Se + Math.imul($e, Qe) | 0, Se = Se + Math.imul(Ze, Ke) | 0, Le = Le + Math.imul(Ze, Qe) | 0, ge = ge + Math.imul(Yt, He) | 0, Se = Se + Math.imul(Yt, nt) | 0, Se = Se + Math.imul(Ve, He) | 0, Le = Le + Math.imul(Ve, nt) | 0, ge = ge + Math.imul(It, ht) | 0, Se = Se + Math.imul(It, pt) | 0, Se = Se + Math.imul(xt, ht) | 0, Le = Le + Math.imul(xt, pt) | 0, ge = ge + Math.imul(yt, jt) | 0, Se = Se + Math.imul(yt, $t) | 0, Se = Se + Math.imul(dt, jt) | 0, Le = Le + Math.imul(dt, $t) | 0;
      var cn = (ae + ge | 0) + ((Se & 8191) << 13) | 0;
      ae = (Le + (Se >>> 13) | 0) + (cn >>> 26) | 0, cn &= 67108863, ge = Math.imul(wt, Ke), Se = Math.imul(wt, Qe), Se = Se + Math.imul(ft, Ke) | 0, Le = Math.imul(ft, Qe), ge = ge + Math.imul($e, He) | 0, Se = Se + Math.imul($e, nt) | 0, Se = Se + Math.imul(Ze, He) | 0, Le = Le + Math.imul(Ze, nt) | 0, ge = ge + Math.imul(Yt, ht) | 0, Se = Se + Math.imul(Yt, pt) | 0, Se = Se + Math.imul(Ve, ht) | 0, Le = Le + Math.imul(Ve, pt) | 0, ge = ge + Math.imul(It, jt) | 0, Se = Se + Math.imul(It, $t) | 0, Se = Se + Math.imul(xt, jt) | 0, Le = Le + Math.imul(xt, $t) | 0;
      var Pt = (ae + ge | 0) + ((Se & 8191) << 13) | 0;
      ae = (Le + (Se >>> 13) | 0) + (Pt >>> 26) | 0, Pt &= 67108863, ge = Math.imul(wt, He), Se = Math.imul(wt, nt), Se = Se + Math.imul(ft, He) | 0, Le = Math.imul(ft, nt), ge = ge + Math.imul($e, ht) | 0, Se = Se + Math.imul($e, pt) | 0, Se = Se + Math.imul(Ze, ht) | 0, Le = Le + Math.imul(Ze, pt) | 0, ge = ge + Math.imul(Yt, jt) | 0, Se = Se + Math.imul(Yt, $t) | 0, Se = Se + Math.imul(Ve, jt) | 0, Le = Le + Math.imul(Ve, $t) | 0;
      var Rt = (ae + ge | 0) + ((Se & 8191) << 13) | 0;
      ae = (Le + (Se >>> 13) | 0) + (Rt >>> 26) | 0, Rt &= 67108863, ge = Math.imul(wt, ht), Se = Math.imul(wt, pt), Se = Se + Math.imul(ft, ht) | 0, Le = Math.imul(ft, pt), ge = ge + Math.imul($e, jt) | 0, Se = Se + Math.imul($e, $t) | 0, Se = Se + Math.imul(Ze, jt) | 0, Le = Le + Math.imul(Ze, $t) | 0;
      var sn = (ae + ge | 0) + ((Se & 8191) << 13) | 0;
      ae = (Le + (Se >>> 13) | 0) + (sn >>> 26) | 0, sn &= 67108863, ge = Math.imul(wt, jt), Se = Math.imul(wt, $t), Se = Se + Math.imul(ft, jt) | 0, Le = Math.imul(ft, $t);
      var qt = (ae + ge | 0) + ((Se & 8191) << 13) | 0;
      return ae = (Le + (Se >>> 13) | 0) + (qt >>> 26) | 0, qt &= 67108863, be[0] = Jt, be[1] = zt, be[2] = Vt, be[3] = Kt, be[4] = pn, be[5] = An, be[6] = vn, be[7] = Cn, be[8] = yn, be[9] = dn, be[10] = xn, be[11] = ln, be[12] = mn, be[13] = gn, be[14] = cn, be[15] = Pt, be[16] = Rt, be[17] = sn, be[18] = qt, ae !== 0 && (be[19] = ae, pe.length++), pe;
    };
    Math.imul || (Te = ve);
    function we(oe, ce, le) {
      le.negative = ce.negative ^ oe.negative, le.length = oe.length + ce.length;
      for (var pe = 0, ye = 0, Ce = 0; Ce < le.length - 1; Ce++) {
        var be = ye;
        ye = 0;
        for (var ae = pe & 67108863, ge = Math.min(Ce, ce.length - 1), Se = Math.max(0, Ce - oe.length + 1); Se <= ge; Se++) {
          var Le = Ce - Se, ze = oe.words[Le] | 0, Re = ce.words[Se] | 0, We = ze * Re, Be = We & 67108863;
          be = be + (We / 67108864 | 0) | 0, Be = Be + ae | 0, ae = Be & 67108863, be = be + (Be >>> 26) | 0, ye += be >>> 26, be &= 67108863;
        }
        le.words[Ce] = ae, pe = be, be = ye;
      }
      return pe !== 0 ? le.words[Ce] = pe : le.length--, le._strip();
    }
    function Ee(oe, ce, le) {
      return we(oe, ce, le);
    }
    J.prototype.mulTo = function(ce, le) {
      var pe, ye = this.length + ce.length;
      return this.length === 10 && ce.length === 10 ? pe = Te(this, ce, le) : ye < 63 ? pe = ve(this, ce, le) : ye < 1024 ? pe = we(this, ce, le) : pe = Ee(this, ce, le), pe;
    }, J.prototype.mul = function(ce) {
      var le = new J(null);
      return le.words = new Array(this.length + ce.length), this.mulTo(ce, le);
    }, J.prototype.mulf = function(ce) {
      var le = new J(null);
      return le.words = new Array(this.length + ce.length), Ee(this, ce, le);
    }, J.prototype.imul = function(ce) {
      return this.clone().mulTo(ce, this);
    }, J.prototype.imuln = function(ce) {
      var le = ce < 0;
      le && (ce = -ce), $(typeof ce == "number"), $(ce < 67108864);
      for (var pe = 0, ye = 0; ye < this.length; ye++) {
        var Ce = (this.words[ye] | 0) * ce, be = (Ce & 67108863) + (pe & 67108863);
        pe >>= 26, pe += Ce / 67108864 | 0, pe += be >>> 26, this.words[ye] = be & 67108863;
      }
      return pe !== 0 && (this.words[ye] = pe, this.length++), le ? this.ineg() : this;
    }, J.prototype.muln = function(ce) {
      return this.clone().imuln(ce);
    }, J.prototype.sqr = function() {
      return this.mul(this);
    }, J.prototype.isqr = function() {
      return this.imul(this.clone());
    }, J.prototype.pow = function(ce) {
      var le = xe(ce);
      if (le.length === 0) return new J(1);
      for (var pe = this, ye = 0; ye < le.length && le[ye] === 0; ye++, pe = pe.sqr())
        ;
      if (++ye < le.length)
        for (var Ce = pe.sqr(); ye < le.length; ye++, Ce = Ce.sqr())
          le[ye] !== 0 && (pe = pe.mul(Ce));
      return pe;
    }, J.prototype.iushln = function(ce) {
      $(typeof ce == "number" && ce >= 0);
      var le = ce % 26, pe = (ce - le) / 26, ye = 67108863 >>> 26 - le << 26 - le, Ce;
      if (le !== 0) {
        var be = 0;
        for (Ce = 0; Ce < this.length; Ce++) {
          var ae = this.words[Ce] & ye, ge = (this.words[Ce] | 0) - ae << le;
          this.words[Ce] = ge | be, be = ae >>> 26 - le;
        }
        be && (this.words[Ce] = be, this.length++);
      }
      if (pe !== 0) {
        for (Ce = this.length - 1; Ce >= 0; Ce--)
          this.words[Ce + pe] = this.words[Ce];
        for (Ce = 0; Ce < pe; Ce++)
          this.words[Ce] = 0;
        this.length += pe;
      }
      return this._strip();
    }, J.prototype.ishln = function(ce) {
      return $(this.negative === 0), this.iushln(ce);
    }, J.prototype.iushrn = function(ce, le, pe) {
      $(typeof ce == "number" && ce >= 0);
      var ye;
      le ? ye = (le - le % 26) / 26 : ye = 0;
      var Ce = ce % 26, be = Math.min((ce - Ce) / 26, this.length), ae = 67108863 ^ 67108863 >>> Ce << Ce, ge = pe;
      if (ye -= be, ye = Math.max(0, ye), ge) {
        for (var Se = 0; Se < be; Se++)
          ge.words[Se] = this.words[Se];
        ge.length = be;
      }
      if (be !== 0) if (this.length > be)
        for (this.length -= be, Se = 0; Se < this.length; Se++)
          this.words[Se] = this.words[Se + be];
      else
        this.words[0] = 0, this.length = 1;
      var Le = 0;
      for (Se = this.length - 1; Se >= 0 && (Le !== 0 || Se >= ye); Se--) {
        var ze = this.words[Se] | 0;
        this.words[Se] = Le << 26 - Ce | ze >>> Ce, Le = ze & ae;
      }
      return ge && Le !== 0 && (ge.words[ge.length++] = Le), this.length === 0 && (this.words[0] = 0, this.length = 1), this._strip();
    }, J.prototype.ishrn = function(ce, le, pe) {
      return $(this.negative === 0), this.iushrn(ce, le, pe);
    }, J.prototype.shln = function(ce) {
      return this.clone().ishln(ce);
    }, J.prototype.ushln = function(ce) {
      return this.clone().iushln(ce);
    }, J.prototype.shrn = function(ce) {
      return this.clone().ishrn(ce);
    }, J.prototype.ushrn = function(ce) {
      return this.clone().iushrn(ce);
    }, J.prototype.testn = function(ce) {
      $(typeof ce == "number" && ce >= 0);
      var le = ce % 26, pe = (ce - le) / 26, ye = 1 << le;
      if (this.length <= pe) return !1;
      var Ce = this.words[pe];
      return !!(Ce & ye);
    }, J.prototype.imaskn = function(ce) {
      $(typeof ce == "number" && ce >= 0);
      var le = ce % 26, pe = (ce - le) / 26;
      if ($(this.negative === 0, "imaskn works only with positive numbers"), this.length <= pe)
        return this;
      if (le !== 0 && pe++, this.length = Math.min(pe, this.length), le !== 0) {
        var ye = 67108863 ^ 67108863 >>> le << le;
        this.words[this.length - 1] &= ye;
      }
      return this._strip();
    }, J.prototype.maskn = function(ce) {
      return this.clone().imaskn(ce);
    }, J.prototype.iaddn = function(ce) {
      return $(typeof ce == "number"), $(ce < 67108864), ce < 0 ? this.isubn(-ce) : this.negative !== 0 ? this.length === 1 && (this.words[0] | 0) <= ce ? (this.words[0] = ce - (this.words[0] | 0), this.negative = 0, this) : (this.negative = 0, this.isubn(ce), this.negative = 1, this) : this._iaddn(ce);
    }, J.prototype._iaddn = function(ce) {
      this.words[0] += ce;
      for (var le = 0; le < this.length && this.words[le] >= 67108864; le++)
        this.words[le] -= 67108864, le === this.length - 1 ? this.words[le + 1] = 1 : this.words[le + 1]++;
      return this.length = Math.max(this.length, le + 1), this;
    }, J.prototype.isubn = function(ce) {
      if ($(typeof ce == "number"), $(ce < 67108864), ce < 0) return this.iaddn(-ce);
      if (this.negative !== 0)
        return this.negative = 0, this.iaddn(ce), this.negative = 1, this;
      if (this.words[0] -= ce, this.length === 1 && this.words[0] < 0)
        this.words[0] = -this.words[0], this.negative = 1;
      else
        for (var le = 0; le < this.length && this.words[le] < 0; le++)
          this.words[le] += 67108864, this.words[le + 1] -= 1;
      return this._strip();
    }, J.prototype.addn = function(ce) {
      return this.clone().iaddn(ce);
    }, J.prototype.subn = function(ce) {
      return this.clone().isubn(ce);
    }, J.prototype.iabs = function() {
      return this.negative = 0, this;
    }, J.prototype.abs = function() {
      return this.clone().iabs();
    }, J.prototype._ishlnsubmul = function(ce, le, pe) {
      var ye = ce.length + pe, Ce;
      this._expand(ye);
      var be, ae = 0;
      for (Ce = 0; Ce < ce.length; Ce++) {
        be = (this.words[Ce + pe] | 0) + ae;
        var ge = (ce.words[Ce] | 0) * le;
        be -= ge & 67108863, ae = (be >> 26) - (ge / 67108864 | 0), this.words[Ce + pe] = be & 67108863;
      }
      for (; Ce < this.length - pe; Ce++)
        be = (this.words[Ce + pe] | 0) + ae, ae = be >> 26, this.words[Ce + pe] = be & 67108863;
      if (ae === 0) return this._strip();
      for ($(ae === -1), ae = 0, Ce = 0; Ce < this.length; Ce++)
        be = -(this.words[Ce] | 0) + ae, ae = be >> 26, this.words[Ce] = be & 67108863;
      return this.negative = 1, this._strip();
    }, J.prototype._wordDiv = function(ce, le) {
      var pe = this.length - ce.length, ye = this.clone(), Ce = ce, be = Ce.words[Ce.length - 1] | 0, ae = this._countBits(be);
      pe = 26 - ae, pe !== 0 && (Ce = Ce.ushln(pe), ye.iushln(pe), be = Ce.words[Ce.length - 1] | 0);
      var ge = ye.length - Ce.length, Se;
      if (le !== "mod") {
        Se = new J(null), Se.length = ge + 1, Se.words = new Array(Se.length);
        for (var Le = 0; Le < Se.length; Le++)
          Se.words[Le] = 0;
      }
      var ze = ye.clone()._ishlnsubmul(Ce, 1, ge);
      ze.negative === 0 && (ye = ze, Se && (Se.words[ge] = 1));
      for (var Re = ge - 1; Re >= 0; Re--) {
        var We = (ye.words[Ce.length + Re] | 0) * 67108864 + (ye.words[Ce.length + Re - 1] | 0);
        for (We = Math.min(We / be | 0, 67108863), ye._ishlnsubmul(Ce, We, Re); ye.negative !== 0; )
          We--, ye.negative = 0, ye._ishlnsubmul(Ce, 1, Re), ye.isZero() || (ye.negative ^= 1);
        Se && (Se.words[Re] = We);
      }
      return Se && Se._strip(), ye._strip(), le !== "div" && pe !== 0 && ye.iushrn(pe), {
        div: Se || null,
        mod: ye
      };
    }, J.prototype.divmod = function(ce, le, pe) {
      if ($(!ce.isZero()), this.isZero())
        return {
          div: new J(0),
          mod: new J(0)
        };
      var ye, Ce, be;
      return this.negative !== 0 && ce.negative === 0 ? (be = this.neg().divmod(ce, le), le !== "mod" && (ye = be.div.neg()), le !== "div" && (Ce = be.mod.neg(), pe && Ce.negative !== 0 && Ce.iadd(ce)), {
        div: ye,
        mod: Ce
      }) : this.negative === 0 && ce.negative !== 0 ? (be = this.divmod(ce.neg(), le), le !== "mod" && (ye = be.div.neg()), {
        div: ye,
        mod: be.mod
      }) : this.negative & ce.negative ? (be = this.neg().divmod(ce.neg(), le), le !== "div" && (Ce = be.mod.neg(), pe && Ce.negative !== 0 && Ce.isub(ce)), {
        div: be.div,
        mod: Ce
      }) : ce.length > this.length || this.cmp(ce) < 0 ? {
        div: new J(0),
        mod: this
      } : ce.length === 1 ? le === "div" ? {
        div: this.divn(ce.words[0]),
        mod: null
      } : le === "mod" ? {
        div: null,
        mod: new J(this.modrn(ce.words[0]))
      } : {
        div: this.divn(ce.words[0]),
        mod: new J(this.modrn(ce.words[0]))
      } : this._wordDiv(ce, le);
    }, J.prototype.div = function(ce) {
      return this.divmod(ce, "div", !1).div;
    }, J.prototype.mod = function(ce) {
      return this.divmod(ce, "mod", !1).mod;
    }, J.prototype.umod = function(ce) {
      return this.divmod(ce, "mod", !0).mod;
    }, J.prototype.divRound = function(ce) {
      var le = this.divmod(ce);
      if (le.mod.isZero()) return le.div;
      var pe = le.div.negative !== 0 ? le.mod.isub(ce) : le.mod, ye = ce.ushrn(1), Ce = ce.andln(1), be = pe.cmp(ye);
      return be < 0 || Ce === 1 && be === 0 ? le.div : le.div.negative !== 0 ? le.div.isubn(1) : le.div.iaddn(1);
    }, J.prototype.modrn = function(ce) {
      var le = ce < 0;
      le && (ce = -ce), $(ce <= 67108863);
      for (var pe = (1 << 26) % ce, ye = 0, Ce = this.length - 1; Ce >= 0; Ce--)
        ye = (pe * ye + (this.words[Ce] | 0)) % ce;
      return le ? -ye : ye;
    }, J.prototype.modn = function(ce) {
      return this.modrn(ce);
    }, J.prototype.idivn = function(ce) {
      var le = ce < 0;
      le && (ce = -ce), $(ce <= 67108863);
      for (var pe = 0, ye = this.length - 1; ye >= 0; ye--) {
        var Ce = (this.words[ye] | 0) + pe * 67108864;
        this.words[ye] = Ce / ce | 0, pe = Ce % ce;
      }
      return this._strip(), le ? this.ineg() : this;
    }, J.prototype.divn = function(ce) {
      return this.clone().idivn(ce);
    }, J.prototype.egcd = function(ce) {
      $(ce.negative === 0), $(!ce.isZero());
      var le = this, pe = ce.clone();
      le.negative !== 0 ? le = le.umod(ce) : le = le.clone();
      for (var ye = new J(1), Ce = new J(0), be = new J(0), ae = new J(1), ge = 0; le.isEven() && pe.isEven(); )
        le.iushrn(1), pe.iushrn(1), ++ge;
      for (var Se = pe.clone(), Le = le.clone(); !le.isZero(); ) {
        for (var ze = 0, Re = 1; !(le.words[0] & Re) && ze < 26; ++ze, Re <<= 1) ;
        if (ze > 0)
          for (le.iushrn(ze); ze-- > 0; )
            (ye.isOdd() || Ce.isOdd()) && (ye.iadd(Se), Ce.isub(Le)), ye.iushrn(1), Ce.iushrn(1);
        for (var We = 0, Be = 1; !(pe.words[0] & Be) && We < 26; ++We, Be <<= 1) ;
        if (We > 0)
          for (pe.iushrn(We); We-- > 0; )
            (be.isOdd() || ae.isOdd()) && (be.iadd(Se), ae.isub(Le)), be.iushrn(1), ae.iushrn(1);
        le.cmp(pe) >= 0 ? (le.isub(pe), ye.isub(be), Ce.isub(ae)) : (pe.isub(le), be.isub(ye), ae.isub(Ce));
      }
      return {
        a: be,
        b: ae,
        gcd: pe.iushln(ge)
      };
    }, J.prototype._invmp = function(ce) {
      $(ce.negative === 0), $(!ce.isZero());
      var le = this, pe = ce.clone();
      le.negative !== 0 ? le = le.umod(ce) : le = le.clone();
      for (var ye = new J(1), Ce = new J(0), be = pe.clone(); le.cmpn(1) > 0 && pe.cmpn(1) > 0; ) {
        for (var ae = 0, ge = 1; !(le.words[0] & ge) && ae < 26; ++ae, ge <<= 1) ;
        if (ae > 0)
          for (le.iushrn(ae); ae-- > 0; )
            ye.isOdd() && ye.iadd(be), ye.iushrn(1);
        for (var Se = 0, Le = 1; !(pe.words[0] & Le) && Se < 26; ++Se, Le <<= 1) ;
        if (Se > 0)
          for (pe.iushrn(Se); Se-- > 0; )
            Ce.isOdd() && Ce.iadd(be), Ce.iushrn(1);
        le.cmp(pe) >= 0 ? (le.isub(pe), ye.isub(Ce)) : (pe.isub(le), Ce.isub(ye));
      }
      var ze;
      return le.cmpn(1) === 0 ? ze = ye : ze = Ce, ze.cmpn(0) < 0 && ze.iadd(ce), ze;
    }, J.prototype.gcd = function(ce) {
      if (this.isZero()) return ce.abs();
      if (ce.isZero()) return this.abs();
      var le = this.clone(), pe = ce.clone();
      le.negative = 0, pe.negative = 0;
      for (var ye = 0; le.isEven() && pe.isEven(); ye++)
        le.iushrn(1), pe.iushrn(1);
      do {
        for (; le.isEven(); )
          le.iushrn(1);
        for (; pe.isEven(); )
          pe.iushrn(1);
        var Ce = le.cmp(pe);
        if (Ce < 0) {
          var be = le;
          le = pe, pe = be;
        } else if (Ce === 0 || pe.cmpn(1) === 0)
          break;
        le.isub(pe);
      } while (!0);
      return pe.iushln(ye);
    }, J.prototype.invm = function(ce) {
      return this.egcd(ce).a.umod(ce);
    }, J.prototype.isEven = function() {
      return (this.words[0] & 1) === 0;
    }, J.prototype.isOdd = function() {
      return (this.words[0] & 1) === 1;
    }, J.prototype.andln = function(ce) {
      return this.words[0] & ce;
    }, J.prototype.bincn = function(ce) {
      $(typeof ce == "number");
      var le = ce % 26, pe = (ce - le) / 26, ye = 1 << le;
      if (this.length <= pe)
        return this._expand(pe + 1), this.words[pe] |= ye, this;
      for (var Ce = ye, be = pe; Ce !== 0 && be < this.length; be++) {
        var ae = this.words[be] | 0;
        ae += Ce, Ce = ae >>> 26, ae &= 67108863, this.words[be] = ae;
      }
      return Ce !== 0 && (this.words[be] = Ce, this.length++), this;
    }, J.prototype.isZero = function() {
      return this.length === 1 && this.words[0] === 0;
    }, J.prototype.cmpn = function(ce) {
      var le = ce < 0;
      if (this.negative !== 0 && !le) return -1;
      if (this.negative === 0 && le) return 1;
      this._strip();
      var pe;
      if (this.length > 1)
        pe = 1;
      else {
        le && (ce = -ce), $(ce <= 67108863, "Number is too big");
        var ye = this.words[0] | 0;
        pe = ye === ce ? 0 : ye < ce ? -1 : 1;
      }
      return this.negative !== 0 ? -pe | 0 : pe;
    }, J.prototype.cmp = function(ce) {
      if (this.negative !== 0 && ce.negative === 0) return -1;
      if (this.negative === 0 && ce.negative !== 0) return 1;
      var le = this.ucmp(ce);
      return this.negative !== 0 ? -le | 0 : le;
    }, J.prototype.ucmp = function(ce) {
      if (this.length > ce.length) return 1;
      if (this.length < ce.length) return -1;
      for (var le = 0, pe = this.length - 1; pe >= 0; pe--) {
        var ye = this.words[pe] | 0, Ce = ce.words[pe] | 0;
        if (ye !== Ce) {
          ye < Ce ? le = -1 : ye > Ce && (le = 1);
          break;
        }
      }
      return le;
    }, J.prototype.gtn = function(ce) {
      return this.cmpn(ce) === 1;
    }, J.prototype.gt = function(ce) {
      return this.cmp(ce) === 1;
    }, J.prototype.gten = function(ce) {
      return this.cmpn(ce) >= 0;
    }, J.prototype.gte = function(ce) {
      return this.cmp(ce) >= 0;
    }, J.prototype.ltn = function(ce) {
      return this.cmpn(ce) === -1;
    }, J.prototype.lt = function(ce) {
      return this.cmp(ce) === -1;
    }, J.prototype.lten = function(ce) {
      return this.cmpn(ce) <= 0;
    }, J.prototype.lte = function(ce) {
      return this.cmp(ce) <= 0;
    }, J.prototype.eqn = function(ce) {
      return this.cmpn(ce) === 0;
    }, J.prototype.eq = function(ce) {
      return this.cmp(ce) === 0;
    }, J.red = function(ce) {
      return new Ae(ce);
    }, J.prototype.toRed = function(ce) {
      return $(!this.red, "Already a number in reduction context"), $(this.negative === 0, "red works only with positives"), ce.convertTo(this)._forceRed(ce);
    }, J.prototype.fromRed = function() {
      return $(this.red, "fromRed works only with numbers in reduction context"), this.red.convertFrom(this);
    }, J.prototype._forceRed = function(ce) {
      return this.red = ce, this;
    }, J.prototype.forceRed = function(ce) {
      return $(!this.red, "Already a number in reduction context"), this._forceRed(ce);
    }, J.prototype.redAdd = function(ce) {
      return $(this.red, "redAdd works only with red numbers"), this.red.add(this, ce);
    }, J.prototype.redIAdd = function(ce) {
      return $(this.red, "redIAdd works only with red numbers"), this.red.iadd(this, ce);
    }, J.prototype.redSub = function(ce) {
      return $(this.red, "redSub works only with red numbers"), this.red.sub(this, ce);
    }, J.prototype.redISub = function(ce) {
      return $(this.red, "redISub works only with red numbers"), this.red.isub(this, ce);
    }, J.prototype.redShl = function(ce) {
      return $(this.red, "redShl works only with red numbers"), this.red.shl(this, ce);
    }, J.prototype.redMul = function(ce) {
      return $(this.red, "redMul works only with red numbers"), this.red._verify2(this, ce), this.red.mul(this, ce);
    }, J.prototype.redIMul = function(ce) {
      return $(this.red, "redMul works only with red numbers"), this.red._verify2(this, ce), this.red.imul(this, ce);
    }, J.prototype.redSqr = function() {
      return $(this.red, "redSqr works only with red numbers"), this.red._verify1(this), this.red.sqr(this);
    }, J.prototype.redISqr = function() {
      return $(this.red, "redISqr works only with red numbers"), this.red._verify1(this), this.red.isqr(this);
    }, J.prototype.redSqrt = function() {
      return $(this.red, "redSqrt works only with red numbers"), this.red._verify1(this), this.red.sqrt(this);
    }, J.prototype.redInvm = function() {
      return $(this.red, "redInvm works only with red numbers"), this.red._verify1(this), this.red.invm(this);
    }, J.prototype.redNeg = function() {
      return $(this.red, "redNeg works only with red numbers"), this.red._verify1(this), this.red.neg(this);
    }, J.prototype.redPow = function(ce) {
      return $(this.red && !ce.red, "redPow(normalNum)"), this.red._verify1(this), this.red.pow(this, ce);
    };
    var Me = {
      k256: null,
      p224: null,
      p192: null,
      p25519: null
    };
    function Ie(oe, ce) {
      this.name = oe, this.p = new J(ce, 16), this.n = this.p.bitLength(), this.k = new J(1).iushln(this.n).isub(this.p), this.tmp = this._tmp();
    }
    Ie.prototype._tmp = function() {
      var ce = new J(null);
      return ce.words = new Array(Math.ceil(this.n / 13)), ce;
    }, Ie.prototype.ireduce = function(ce) {
      var le = ce, pe;
      do
        this.split(le, this.tmp), le = this.imulK(le), le = le.iadd(this.tmp), pe = le.bitLength();
      while (pe > this.n);
      var ye = pe < this.n ? -1 : le.ucmp(this.p);
      return ye === 0 ? (le.words[0] = 0, le.length = 1) : ye > 0 ? le.isub(this.p) : le.strip !== void 0 ? le.strip() : le._strip(), le;
    }, Ie.prototype.split = function(ce, le) {
      ce.iushrn(this.n, 0, le);
    }, Ie.prototype.imulK = function(ce) {
      return ce.imul(this.k);
    };
    function ke() {
      Ie.call(
        this,
        "k256",
        "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f"
      );
    }
    V(ke, Ie), ke.prototype.split = function(ce, le) {
      for (var pe = 4194303, ye = Math.min(ce.length, 9), Ce = 0; Ce < ye; Ce++)
        le.words[Ce] = ce.words[Ce];
      if (le.length = ye, ce.length <= 9) {
        ce.words[0] = 0, ce.length = 1;
        return;
      }
      var be = ce.words[9];
      for (le.words[le.length++] = be & pe, Ce = 10; Ce < ce.length; Ce++) {
        var ae = ce.words[Ce] | 0;
        ce.words[Ce - 10] = (ae & pe) << 4 | be >>> 22, be = ae;
      }
      be >>>= 22, ce.words[Ce - 10] = be, be === 0 && ce.length > 10 ? ce.length -= 10 : ce.length -= 9;
    }, ke.prototype.imulK = function(ce) {
      ce.words[ce.length] = 0, ce.words[ce.length + 1] = 0, ce.length += 2;
      for (var le = 0, pe = 0; pe < ce.length; pe++) {
        var ye = ce.words[pe] | 0;
        le += ye * 977, ce.words[pe] = le & 67108863, le = ye * 64 + (le / 67108864 | 0);
      }
      return ce.words[ce.length - 1] === 0 && (ce.length--, ce.words[ce.length - 1] === 0 && ce.length--), ce;
    };
    function _e() {
      Ie.call(
        this,
        "p224",
        "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001"
      );
    }
    V(_e, Ie);
    function De() {
      Ie.call(
        this,
        "p192",
        "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff"
      );
    }
    V(De, Ie);
    function Fe() {
      Ie.call(
        this,
        "25519",
        "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed"
      );
    }
    V(Fe, Ie), Fe.prototype.imulK = function(ce) {
      for (var le = 0, pe = 0; pe < ce.length; pe++) {
        var ye = (ce.words[pe] | 0) * 19 + le, Ce = ye & 67108863;
        ye >>>= 26, ce.words[pe] = Ce, le = ye;
      }
      return le !== 0 && (ce.words[ce.length++] = le), ce;
    }, J._prime = function(ce) {
      if (Me[ce]) return Me[ce];
      var le;
      if (ce === "k256")
        le = new ke();
      else if (ce === "p224")
        le = new _e();
      else if (ce === "p192")
        le = new De();
      else if (ce === "p25519")
        le = new Fe();
      else
        throw new Error("Unknown prime " + ce);
      return Me[ce] = le, le;
    };
    function Ae(oe) {
      if (typeof oe == "string") {
        var ce = J._prime(oe);
        this.m = ce.p, this.prime = ce;
      } else
        $(oe.gtn(1), "modulus must be greater than 1"), this.m = oe, this.prime = null;
    }
    Ae.prototype._verify1 = function(ce) {
      $(ce.negative === 0, "red works only with positives"), $(ce.red, "red works only with red numbers");
    }, Ae.prototype._verify2 = function(ce, le) {
      $((ce.negative | le.negative) === 0, "red works only with positives"), $(
        ce.red && ce.red === le.red,
        "red works only with red numbers"
      );
    }, Ae.prototype.imod = function(ce) {
      return this.prime ? this.prime.ireduce(ce)._forceRed(this) : (se(ce, ce.umod(this.m)._forceRed(this)), ce);
    }, Ae.prototype.neg = function(ce) {
      return ce.isZero() ? ce.clone() : this.m.sub(ce)._forceRed(this);
    }, Ae.prototype.add = function(ce, le) {
      this._verify2(ce, le);
      var pe = ce.add(le);
      return pe.cmp(this.m) >= 0 && pe.isub(this.m), pe._forceRed(this);
    }, Ae.prototype.iadd = function(ce, le) {
      this._verify2(ce, le);
      var pe = ce.iadd(le);
      return pe.cmp(this.m) >= 0 && pe.isub(this.m), pe;
    }, Ae.prototype.sub = function(ce, le) {
      this._verify2(ce, le);
      var pe = ce.sub(le);
      return pe.cmpn(0) < 0 && pe.iadd(this.m), pe._forceRed(this);
    }, Ae.prototype.isub = function(ce, le) {
      this._verify2(ce, le);
      var pe = ce.isub(le);
      return pe.cmpn(0) < 0 && pe.iadd(this.m), pe;
    }, Ae.prototype.shl = function(ce, le) {
      return this._verify1(ce), this.imod(ce.ushln(le));
    }, Ae.prototype.imul = function(ce, le) {
      return this._verify2(ce, le), this.imod(ce.imul(le));
    }, Ae.prototype.mul = function(ce, le) {
      return this._verify2(ce, le), this.imod(ce.mul(le));
    }, Ae.prototype.isqr = function(ce) {
      return this.imul(ce, ce.clone());
    }, Ae.prototype.sqr = function(ce) {
      return this.mul(ce, ce);
    }, Ae.prototype.sqrt = function(ce) {
      if (ce.isZero()) return ce.clone();
      var le = this.m.andln(3);
      if ($(le % 2 === 1), le === 3) {
        var pe = this.m.add(new J(1)).iushrn(2);
        return this.pow(ce, pe);
      }
      for (var ye = this.m.subn(1), Ce = 0; !ye.isZero() && ye.andln(1) === 0; )
        Ce++, ye.iushrn(1);
      $(!ye.isZero());
      var be = new J(1).toRed(this), ae = be.redNeg(), ge = this.m.subn(1).iushrn(1), Se = this.m.bitLength();
      for (Se = new J(2 * Se * Se).toRed(this); this.pow(Se, ge).cmp(ae) !== 0; )
        Se.redIAdd(ae);
      for (var Le = this.pow(Se, ye), ze = this.pow(ce, ye.addn(1).iushrn(1)), Re = this.pow(ce, ye), We = Ce; Re.cmp(be) !== 0; ) {
        for (var Be = Re, Ue = 0; Be.cmp(be) !== 0; Ue++)
          Be = Be.redSqr();
        $(Ue < We);
        var Ge = this.pow(Le, new J(1).iushln(We - Ue - 1));
        ze = ze.redMul(Ge), Le = Ge.redSqr(), Re = Re.redMul(Le), We = Ue;
      }
      return ze;
    }, Ae.prototype.invm = function(ce) {
      var le = ce._invmp(this.m);
      return le.negative !== 0 ? (le.negative = 0, this.imod(le).redNeg()) : this.imod(le);
    }, Ae.prototype.pow = function(ce, le) {
      if (le.isZero()) return new J(1).toRed(this);
      if (le.cmpn(1) === 0) return ce.clone();
      var pe = 4, ye = new Array(1 << pe);
      ye[0] = new J(1).toRed(this), ye[1] = ce;
      for (var Ce = 2; Ce < ye.length; Ce++)
        ye[Ce] = this.mul(ye[Ce - 1], ce);
      var be = ye[0], ae = 0, ge = 0, Se = le.bitLength() % 26;
      for (Se === 0 && (Se = 26), Ce = le.length - 1; Ce >= 0; Ce--) {
        for (var Le = le.words[Ce], ze = Se - 1; ze >= 0; ze--) {
          var Re = Le >> ze & 1;
          if (be !== ye[0] && (be = this.sqr(be)), Re === 0 && ae === 0) {
            ge = 0;
            continue;
          }
          ae <<= 1, ae |= Re, ge++, !(ge !== pe && (Ce !== 0 || ze !== 0)) && (be = this.mul(be, ye[ae]), ge = 0, ae = 0);
        }
        Se = 26;
      }
      return be;
    }, Ae.prototype.convertTo = function(ce) {
      var le = ce.umod(this.m);
      return le === ce ? le.clone() : le;
    }, Ae.prototype.convertFrom = function(ce) {
      var le = ce.clone();
      return le.red = null, le;
    }, J.mont = function(ce) {
      return new ne(ce);
    };
    function ne(oe) {
      Ae.call(this, oe), this.shift = this.m.bitLength(), this.shift % 26 !== 0 && (this.shift += 26 - this.shift % 26), this.r = new J(1).iushln(this.shift), this.r2 = this.imod(this.r.sqr()), this.rinv = this.r._invmp(this.m), this.minv = this.rinv.mul(this.r).isubn(1).div(this.m), this.minv = this.minv.umod(this.r), this.minv = this.r.sub(this.minv);
    }
    V(ne, Ae), ne.prototype.convertTo = function(ce) {
      return this.imod(ce.ushln(this.shift));
    }, ne.prototype.convertFrom = function(ce) {
      var le = this.imod(ce.mul(this.rinv));
      return le.red = null, le;
    }, ne.prototype.imul = function(ce, le) {
      if (ce.isZero() || le.isZero())
        return ce.words[0] = 0, ce.length = 1, ce;
      var pe = ce.imul(le), ye = pe.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m), Ce = pe.isub(ye).iushrn(this.shift), be = Ce;
      return Ce.cmp(this.m) >= 0 ? be = Ce.isub(this.m) : Ce.cmpn(0) < 0 && (be = Ce.iadd(this.m)), be._forceRed(this);
    }, ne.prototype.mul = function(ce, le) {
      if (ce.isZero() || le.isZero()) return new J(0)._forceRed(this);
      var pe = ce.mul(le), ye = pe.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m), Ce = pe.isub(ye).iushrn(this.shift), be = Ce;
      return Ce.cmp(this.m) >= 0 ? be = Ce.isub(this.m) : Ce.cmpn(0) < 0 && (be = Ce.iadd(this.m)), be._forceRed(this);
    }, ne.prototype.invm = function(ce) {
      var le = this.imod(ce._invmp(this.m).mul(this.r2));
      return le._forceRed(this);
    };
  })(C, commonjsGlobal$1);
})(bn$4);
var bnExports = bn$4.exports;
const BN = /* @__PURE__ */ getDefaultExportFromCjs$2(bnExports);
var browserifyRsa, hasRequiredBrowserifyRsa;
function requireBrowserifyRsa() {
  if (hasRequiredBrowserifyRsa) return browserifyRsa;
  hasRequiredBrowserifyRsa = 1;
  var C = bnExports, e = requireBrowser$b(), T = safeBufferExports.Buffer;
  function $(ee) {
    var te = ee.modulus.byteLength(), re;
    do
      re = new C(e(te));
    while (re.cmp(ee.modulus) >= 0 || !re.umod(ee.prime1) || !re.umod(ee.prime2));
    return re;
  }
  function V(ee) {
    var te = $(ee), re = te.toRed(C.mont(ee.modulus)).redPow(new C(ee.publicExponent)).fromRed();
    return { blinder: re, unblinder: te.invm(ee.modulus) };
  }
  function J(ee, te) {
    var re = V(te), ie = te.modulus.byteLength(), se = new C(ee).mul(re.blinder).umod(te.modulus), de = se.toRed(C.mont(te.prime1)), ue = se.toRed(C.mont(te.prime2)), fe = te.coefficient, he = te.prime1, me = te.prime2, xe = de.redPow(te.exponent1).fromRed(), ve = ue.redPow(te.exponent2).fromRed(), Te = xe.isub(ve).imul(fe).umod(he).imul(me);
    return ve.iadd(Te).imul(re.unblinder).umod(te.modulus).toArrayLike(T, "be", ie);
  }
  return J.getr = $, browserifyRsa = J, browserifyRsa;
}
var elliptic = {};
const name$1 = "elliptic", version$2 = "6.6.1", description = "EC cryptography", main$1 = "lib/elliptic.js", files = [
  "lib"
], scripts = {
  lint: "eslint lib test",
  "lint:fix": "npm run lint -- --fix",
  unit: "istanbul test _mocha --reporter=spec test/index.js",
  test: "npm run lint && npm run unit",
  version: "grunt dist && git add dist/"
}, repository = {
  type: "git",
  url: "git@github.com:indutny/elliptic"
}, keywords = [
  "EC",
  "Elliptic",
  "curve",
  "Cryptography"
], author = "Fedor Indutny <fedor@indutny.com>", license = "MIT", bugs = {
  url: "https://github.com/indutny/elliptic/issues"
}, homepage = "https://github.com/indutny/elliptic", devDependencies = {
  brfs: "^2.0.2",
  coveralls: "^3.1.0",
  eslint: "^7.6.0",
  grunt: "^1.2.1",
  "grunt-browserify": "^5.3.0",
  "grunt-cli": "^1.3.2",
  "grunt-contrib-connect": "^3.0.0",
  "grunt-contrib-copy": "^1.0.0",
  "grunt-contrib-uglify": "^5.0.0",
  "grunt-mocha-istanbul": "^5.0.2",
  "grunt-saucelabs": "^9.0.1",
  istanbul: "^0.4.5",
  mocha: "^8.0.1"
}, dependencies = {
  "bn.js": "^4.11.9",
  brorand: "^1.1.0",
  "hash.js": "^1.0.0",
  "hmac-drbg": "^1.0.1",
  inherits: "^2.0.4",
  "minimalistic-assert": "^1.0.1",
  "minimalistic-crypto-utils": "^1.0.1"
}, require$$0$1 = {
  name: name$1,
  version: version$2,
  description,
  main: main$1,
  files,
  scripts,
  repository,
  keywords,
  author,
  license,
  bugs,
  homepage,
  devDependencies,
  dependencies
};
var utils$4 = {}, bn$3 = { exports: {} };
bn$3.exports;
var hasRequiredBn$3;
function requireBn$3() {
  return hasRequiredBn$3 || (hasRequiredBn$3 = 1, function(C) {
    (function(e, T) {
      function $(Ae, ne) {
        if (!Ae) throw new Error(ne || "Assertion failed");
      }
      function V(Ae, ne) {
        Ae.super_ = ne;
        var oe = function() {
        };
        oe.prototype = ne.prototype, Ae.prototype = new oe(), Ae.prototype.constructor = Ae;
      }
      function J(Ae, ne, oe) {
        if (J.isBN(Ae))
          return Ae;
        this.negative = 0, this.words = null, this.length = 0, this.red = null, Ae !== null && ((ne === "le" || ne === "be") && (oe = ne, ne = 10), this._init(Ae || 0, ne || 10, oe || "be"));
      }
      typeof e == "object" ? e.exports = J : T.BN = J, J.BN = J, J.wordSize = 26;
      var ee;
      try {
        typeof window < "u" && typeof window.Buffer < "u" ? ee = window.Buffer : ee = bufferPolyfill.Buffer;
      } catch {
      }
      J.isBN = function(ne) {
        return ne instanceof J ? !0 : ne !== null && typeof ne == "object" && ne.constructor.wordSize === J.wordSize && Array.isArray(ne.words);
      }, J.max = function(ne, oe) {
        return ne.cmp(oe) > 0 ? ne : oe;
      }, J.min = function(ne, oe) {
        return ne.cmp(oe) < 0 ? ne : oe;
      }, J.prototype._init = function(ne, oe, ce) {
        if (typeof ne == "number")
          return this._initNumber(ne, oe, ce);
        if (typeof ne == "object")
          return this._initArray(ne, oe, ce);
        oe === "hex" && (oe = 16), $(oe === (oe | 0) && oe >= 2 && oe <= 36), ne = ne.toString().replace(/\s+/g, "");
        var le = 0;
        ne[0] === "-" && (le++, this.negative = 1), le < ne.length && (oe === 16 ? this._parseHex(ne, le, ce) : (this._parseBase(ne, oe, le), ce === "le" && this._initArray(this.toArray(), oe, ce)));
      }, J.prototype._initNumber = function(ne, oe, ce) {
        ne < 0 && (this.negative = 1, ne = -ne), ne < 67108864 ? (this.words = [ne & 67108863], this.length = 1) : ne < 4503599627370496 ? (this.words = [
          ne & 67108863,
          ne / 67108864 & 67108863
        ], this.length = 2) : ($(ne < 9007199254740992), this.words = [
          ne & 67108863,
          ne / 67108864 & 67108863,
          1
        ], this.length = 3), ce === "le" && this._initArray(this.toArray(), oe, ce);
      }, J.prototype._initArray = function(ne, oe, ce) {
        if ($(typeof ne.length == "number"), ne.length <= 0)
          return this.words = [0], this.length = 1, this;
        this.length = Math.ceil(ne.length / 3), this.words = new Array(this.length);
        for (var le = 0; le < this.length; le++)
          this.words[le] = 0;
        var pe, ye, Ce = 0;
        if (ce === "be")
          for (le = ne.length - 1, pe = 0; le >= 0; le -= 3)
            ye = ne[le] | ne[le - 1] << 8 | ne[le - 2] << 16, this.words[pe] |= ye << Ce & 67108863, this.words[pe + 1] = ye >>> 26 - Ce & 67108863, Ce += 24, Ce >= 26 && (Ce -= 26, pe++);
        else if (ce === "le")
          for (le = 0, pe = 0; le < ne.length; le += 3)
            ye = ne[le] | ne[le + 1] << 8 | ne[le + 2] << 16, this.words[pe] |= ye << Ce & 67108863, this.words[pe + 1] = ye >>> 26 - Ce & 67108863, Ce += 24, Ce >= 26 && (Ce -= 26, pe++);
        return this.strip();
      };
      function te(Ae, ne) {
        var oe = Ae.charCodeAt(ne);
        return oe >= 65 && oe <= 70 ? oe - 55 : oe >= 97 && oe <= 102 ? oe - 87 : oe - 48 & 15;
      }
      function re(Ae, ne, oe) {
        var ce = te(Ae, oe);
        return oe - 1 >= ne && (ce |= te(Ae, oe - 1) << 4), ce;
      }
      J.prototype._parseHex = function(ne, oe, ce) {
        this.length = Math.ceil((ne.length - oe) / 6), this.words = new Array(this.length);
        for (var le = 0; le < this.length; le++)
          this.words[le] = 0;
        var pe = 0, ye = 0, Ce;
        if (ce === "be")
          for (le = ne.length - 1; le >= oe; le -= 2)
            Ce = re(ne, oe, le) << pe, this.words[ye] |= Ce & 67108863, pe >= 18 ? (pe -= 18, ye += 1, this.words[ye] |= Ce >>> 26) : pe += 8;
        else {
          var be = ne.length - oe;
          for (le = be % 2 === 0 ? oe + 1 : oe; le < ne.length; le += 2)
            Ce = re(ne, oe, le) << pe, this.words[ye] |= Ce & 67108863, pe >= 18 ? (pe -= 18, ye += 1, this.words[ye] |= Ce >>> 26) : pe += 8;
        }
        this.strip();
      };
      function ie(Ae, ne, oe, ce) {
        for (var le = 0, pe = Math.min(Ae.length, oe), ye = ne; ye < pe; ye++) {
          var Ce = Ae.charCodeAt(ye) - 48;
          le *= ce, Ce >= 49 ? le += Ce - 49 + 10 : Ce >= 17 ? le += Ce - 17 + 10 : le += Ce;
        }
        return le;
      }
      J.prototype._parseBase = function(ne, oe, ce) {
        this.words = [0], this.length = 1;
        for (var le = 0, pe = 1; pe <= 67108863; pe *= oe)
          le++;
        le--, pe = pe / oe | 0;
        for (var ye = ne.length - ce, Ce = ye % le, be = Math.min(ye, ye - Ce) + ce, ae = 0, ge = ce; ge < be; ge += le)
          ae = ie(ne, ge, ge + le, oe), this.imuln(pe), this.words[0] + ae < 67108864 ? this.words[0] += ae : this._iaddn(ae);
        if (Ce !== 0) {
          var Se = 1;
          for (ae = ie(ne, ge, ne.length, oe), ge = 0; ge < Ce; ge++)
            Se *= oe;
          this.imuln(Se), this.words[0] + ae < 67108864 ? this.words[0] += ae : this._iaddn(ae);
        }
        this.strip();
      }, J.prototype.copy = function(ne) {
        ne.words = new Array(this.length);
        for (var oe = 0; oe < this.length; oe++)
          ne.words[oe] = this.words[oe];
        ne.length = this.length, ne.negative = this.negative, ne.red = this.red;
      }, J.prototype.clone = function() {
        var ne = new J(null);
        return this.copy(ne), ne;
      }, J.prototype._expand = function(ne) {
        for (; this.length < ne; )
          this.words[this.length++] = 0;
        return this;
      }, J.prototype.strip = function() {
        for (; this.length > 1 && this.words[this.length - 1] === 0; )
          this.length--;
        return this._normSign();
      }, J.prototype._normSign = function() {
        return this.length === 1 && this.words[0] === 0 && (this.negative = 0), this;
      }, J.prototype.inspect = function() {
        return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
      };
      var se = [
        "",
        "0",
        "00",
        "000",
        "0000",
        "00000",
        "000000",
        "0000000",
        "00000000",
        "000000000",
        "0000000000",
        "00000000000",
        "000000000000",
        "0000000000000",
        "00000000000000",
        "000000000000000",
        "0000000000000000",
        "00000000000000000",
        "000000000000000000",
        "0000000000000000000",
        "00000000000000000000",
        "000000000000000000000",
        "0000000000000000000000",
        "00000000000000000000000",
        "000000000000000000000000",
        "0000000000000000000000000"
      ], de = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
      ], ue = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        1e7,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64e6,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        243e5,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
      ];
      J.prototype.toString = function(ne, oe) {
        ne = ne || 10, oe = oe | 0 || 1;
        var ce;
        if (ne === 16 || ne === "hex") {
          ce = "";
          for (var le = 0, pe = 0, ye = 0; ye < this.length; ye++) {
            var Ce = this.words[ye], be = ((Ce << le | pe) & 16777215).toString(16);
            pe = Ce >>> 24 - le & 16777215, le += 2, le >= 26 && (le -= 26, ye--), pe !== 0 || ye !== this.length - 1 ? ce = se[6 - be.length] + be + ce : ce = be + ce;
          }
          for (pe !== 0 && (ce = pe.toString(16) + ce); ce.length % oe !== 0; )
            ce = "0" + ce;
          return this.negative !== 0 && (ce = "-" + ce), ce;
        }
        if (ne === (ne | 0) && ne >= 2 && ne <= 36) {
          var ae = de[ne], ge = ue[ne];
          ce = "";
          var Se = this.clone();
          for (Se.negative = 0; !Se.isZero(); ) {
            var Le = Se.modn(ge).toString(ne);
            Se = Se.idivn(ge), Se.isZero() ? ce = Le + ce : ce = se[ae - Le.length] + Le + ce;
          }
          for (this.isZero() && (ce = "0" + ce); ce.length % oe !== 0; )
            ce = "0" + ce;
          return this.negative !== 0 && (ce = "-" + ce), ce;
        }
        $(!1, "Base should be between 2 and 36");
      }, J.prototype.toNumber = function() {
        var ne = this.words[0];
        return this.length === 2 ? ne += this.words[1] * 67108864 : this.length === 3 && this.words[2] === 1 ? ne += 4503599627370496 + this.words[1] * 67108864 : this.length > 2 && $(!1, "Number can only safely store up to 53 bits"), this.negative !== 0 ? -ne : ne;
      }, J.prototype.toJSON = function() {
        return this.toString(16);
      }, J.prototype.toBuffer = function(ne, oe) {
        return $(typeof ee < "u"), this.toArrayLike(ee, ne, oe);
      }, J.prototype.toArray = function(ne, oe) {
        return this.toArrayLike(Array, ne, oe);
      }, J.prototype.toArrayLike = function(ne, oe, ce) {
        var le = this.byteLength(), pe = ce || Math.max(1, le);
        $(le <= pe, "byte array longer than desired length"), $(pe > 0, "Requested array length <= 0"), this.strip();
        var ye = oe === "le", Ce = new ne(pe), be, ae, ge = this.clone();
        if (ye) {
          for (ae = 0; !ge.isZero(); ae++)
            be = ge.andln(255), ge.iushrn(8), Ce[ae] = be;
          for (; ae < pe; ae++)
            Ce[ae] = 0;
        } else {
          for (ae = 0; ae < pe - le; ae++)
            Ce[ae] = 0;
          for (ae = 0; !ge.isZero(); ae++)
            be = ge.andln(255), ge.iushrn(8), Ce[pe - ae - 1] = be;
        }
        return Ce;
      }, Math.clz32 ? J.prototype._countBits = function(ne) {
        return 32 - Math.clz32(ne);
      } : J.prototype._countBits = function(ne) {
        var oe = ne, ce = 0;
        return oe >= 4096 && (ce += 13, oe >>>= 13), oe >= 64 && (ce += 7, oe >>>= 7), oe >= 8 && (ce += 4, oe >>>= 4), oe >= 2 && (ce += 2, oe >>>= 2), ce + oe;
      }, J.prototype._zeroBits = function(ne) {
        if (ne === 0) return 26;
        var oe = ne, ce = 0;
        return oe & 8191 || (ce += 13, oe >>>= 13), oe & 127 || (ce += 7, oe >>>= 7), oe & 15 || (ce += 4, oe >>>= 4), oe & 3 || (ce += 2, oe >>>= 2), oe & 1 || ce++, ce;
      }, J.prototype.bitLength = function() {
        var ne = this.words[this.length - 1], oe = this._countBits(ne);
        return (this.length - 1) * 26 + oe;
      };
      function fe(Ae) {
        for (var ne = new Array(Ae.bitLength()), oe = 0; oe < ne.length; oe++) {
          var ce = oe / 26 | 0, le = oe % 26;
          ne[oe] = (Ae.words[ce] & 1 << le) >>> le;
        }
        return ne;
      }
      J.prototype.zeroBits = function() {
        if (this.isZero()) return 0;
        for (var ne = 0, oe = 0; oe < this.length; oe++) {
          var ce = this._zeroBits(this.words[oe]);
          if (ne += ce, ce !== 26) break;
        }
        return ne;
      }, J.prototype.byteLength = function() {
        return Math.ceil(this.bitLength() / 8);
      }, J.prototype.toTwos = function(ne) {
        return this.negative !== 0 ? this.abs().inotn(ne).iaddn(1) : this.clone();
      }, J.prototype.fromTwos = function(ne) {
        return this.testn(ne - 1) ? this.notn(ne).iaddn(1).ineg() : this.clone();
      }, J.prototype.isNeg = function() {
        return this.negative !== 0;
      }, J.prototype.neg = function() {
        return this.clone().ineg();
      }, J.prototype.ineg = function() {
        return this.isZero() || (this.negative ^= 1), this;
      }, J.prototype.iuor = function(ne) {
        for (; this.length < ne.length; )
          this.words[this.length++] = 0;
        for (var oe = 0; oe < ne.length; oe++)
          this.words[oe] = this.words[oe] | ne.words[oe];
        return this.strip();
      }, J.prototype.ior = function(ne) {
        return $((this.negative | ne.negative) === 0), this.iuor(ne);
      }, J.prototype.or = function(ne) {
        return this.length > ne.length ? this.clone().ior(ne) : ne.clone().ior(this);
      }, J.prototype.uor = function(ne) {
        return this.length > ne.length ? this.clone().iuor(ne) : ne.clone().iuor(this);
      }, J.prototype.iuand = function(ne) {
        var oe;
        this.length > ne.length ? oe = ne : oe = this;
        for (var ce = 0; ce < oe.length; ce++)
          this.words[ce] = this.words[ce] & ne.words[ce];
        return this.length = oe.length, this.strip();
      }, J.prototype.iand = function(ne) {
        return $((this.negative | ne.negative) === 0), this.iuand(ne);
      }, J.prototype.and = function(ne) {
        return this.length > ne.length ? this.clone().iand(ne) : ne.clone().iand(this);
      }, J.prototype.uand = function(ne) {
        return this.length > ne.length ? this.clone().iuand(ne) : ne.clone().iuand(this);
      }, J.prototype.iuxor = function(ne) {
        var oe, ce;
        this.length > ne.length ? (oe = this, ce = ne) : (oe = ne, ce = this);
        for (var le = 0; le < ce.length; le++)
          this.words[le] = oe.words[le] ^ ce.words[le];
        if (this !== oe)
          for (; le < oe.length; le++)
            this.words[le] = oe.words[le];
        return this.length = oe.length, this.strip();
      }, J.prototype.ixor = function(ne) {
        return $((this.negative | ne.negative) === 0), this.iuxor(ne);
      }, J.prototype.xor = function(ne) {
        return this.length > ne.length ? this.clone().ixor(ne) : ne.clone().ixor(this);
      }, J.prototype.uxor = function(ne) {
        return this.length > ne.length ? this.clone().iuxor(ne) : ne.clone().iuxor(this);
      }, J.prototype.inotn = function(ne) {
        $(typeof ne == "number" && ne >= 0);
        var oe = Math.ceil(ne / 26) | 0, ce = ne % 26;
        this._expand(oe), ce > 0 && oe--;
        for (var le = 0; le < oe; le++)
          this.words[le] = ~this.words[le] & 67108863;
        return ce > 0 && (this.words[le] = ~this.words[le] & 67108863 >> 26 - ce), this.strip();
      }, J.prototype.notn = function(ne) {
        return this.clone().inotn(ne);
      }, J.prototype.setn = function(ne, oe) {
        $(typeof ne == "number" && ne >= 0);
        var ce = ne / 26 | 0, le = ne % 26;
        return this._expand(ce + 1), oe ? this.words[ce] = this.words[ce] | 1 << le : this.words[ce] = this.words[ce] & ~(1 << le), this.strip();
      }, J.prototype.iadd = function(ne) {
        var oe;
        if (this.negative !== 0 && ne.negative === 0)
          return this.negative = 0, oe = this.isub(ne), this.negative ^= 1, this._normSign();
        if (this.negative === 0 && ne.negative !== 0)
          return ne.negative = 0, oe = this.isub(ne), ne.negative = 1, oe._normSign();
        var ce, le;
        this.length > ne.length ? (ce = this, le = ne) : (ce = ne, le = this);
        for (var pe = 0, ye = 0; ye < le.length; ye++)
          oe = (ce.words[ye] | 0) + (le.words[ye] | 0) + pe, this.words[ye] = oe & 67108863, pe = oe >>> 26;
        for (; pe !== 0 && ye < ce.length; ye++)
          oe = (ce.words[ye] | 0) + pe, this.words[ye] = oe & 67108863, pe = oe >>> 26;
        if (this.length = ce.length, pe !== 0)
          this.words[this.length] = pe, this.length++;
        else if (ce !== this)
          for (; ye < ce.length; ye++)
            this.words[ye] = ce.words[ye];
        return this;
      }, J.prototype.add = function(ne) {
        var oe;
        return ne.negative !== 0 && this.negative === 0 ? (ne.negative = 0, oe = this.sub(ne), ne.negative ^= 1, oe) : ne.negative === 0 && this.negative !== 0 ? (this.negative = 0, oe = ne.sub(this), this.negative = 1, oe) : this.length > ne.length ? this.clone().iadd(ne) : ne.clone().iadd(this);
      }, J.prototype.isub = function(ne) {
        if (ne.negative !== 0) {
          ne.negative = 0;
          var oe = this.iadd(ne);
          return ne.negative = 1, oe._normSign();
        } else if (this.negative !== 0)
          return this.negative = 0, this.iadd(ne), this.negative = 1, this._normSign();
        var ce = this.cmp(ne);
        if (ce === 0)
          return this.negative = 0, this.length = 1, this.words[0] = 0, this;
        var le, pe;
        ce > 0 ? (le = this, pe = ne) : (le = ne, pe = this);
        for (var ye = 0, Ce = 0; Ce < pe.length; Ce++)
          oe = (le.words[Ce] | 0) - (pe.words[Ce] | 0) + ye, ye = oe >> 26, this.words[Ce] = oe & 67108863;
        for (; ye !== 0 && Ce < le.length; Ce++)
          oe = (le.words[Ce] | 0) + ye, ye = oe >> 26, this.words[Ce] = oe & 67108863;
        if (ye === 0 && Ce < le.length && le !== this)
          for (; Ce < le.length; Ce++)
            this.words[Ce] = le.words[Ce];
        return this.length = Math.max(this.length, Ce), le !== this && (this.negative = 1), this.strip();
      }, J.prototype.sub = function(ne) {
        return this.clone().isub(ne);
      };
      function he(Ae, ne, oe) {
        oe.negative = ne.negative ^ Ae.negative;
        var ce = Ae.length + ne.length | 0;
        oe.length = ce, ce = ce - 1 | 0;
        var le = Ae.words[0] | 0, pe = ne.words[0] | 0, ye = le * pe, Ce = ye & 67108863, be = ye / 67108864 | 0;
        oe.words[0] = Ce;
        for (var ae = 1; ae < ce; ae++) {
          for (var ge = be >>> 26, Se = be & 67108863, Le = Math.min(ae, ne.length - 1), ze = Math.max(0, ae - Ae.length + 1); ze <= Le; ze++) {
            var Re = ae - ze | 0;
            le = Ae.words[Re] | 0, pe = ne.words[ze] | 0, ye = le * pe + Se, ge += ye / 67108864 | 0, Se = ye & 67108863;
          }
          oe.words[ae] = Se | 0, be = ge | 0;
        }
        return be !== 0 ? oe.words[ae] = be | 0 : oe.length--, oe.strip();
      }
      var me = function(ne, oe, ce) {
        var le = ne.words, pe = oe.words, ye = ce.words, Ce = 0, be, ae, ge, Se = le[0] | 0, Le = Se & 8191, ze = Se >>> 13, Re = le[1] | 0, We = Re & 8191, Be = Re >>> 13, Ue = le[2] | 0, Ge = Ue & 8191, je = Ue >>> 13, Oe = le[3] | 0, Ne = Oe & 8191, Ye = Oe >>> 13, Je = le[4] | 0, Xe = Je & 8191, st = Je >>> 13, ct = le[5] | 0, it = ct & 8191, ot = ct >>> 13, yt = le[6] | 0, dt = yt & 8191, mt = yt >>> 13, It = le[7] | 0, xt = It & 8191, Tt = It >>> 13, Yt = le[8] | 0, Ve = Yt & 8191, Pe = Yt >>> 13, $e = le[9] | 0, Ze = $e & 8191, at = $e >>> 13, wt = pe[0] | 0, ft = wt & 8191, Ct = wt >>> 13, Ut = pe[1] | 0, vt = Ut & 8191, Mt = Ut >>> 13, Xt = pe[2] | 0, St = Xt & 8191, Ot = Xt >>> 13, wn = pe[3] | 0, kt = wn & 8191, Bt = wn >>> 13, Tn = pe[4] | 0, Nt = Tn & 8191, Wt = Tn >>> 13, En = pe[5] | 0, Lt = En & 8191, Ht = En >>> 13, In = pe[6] | 0, Dt = In & 8191, Gt = In >>> 13, Ke = pe[7] | 0, Qe = Ke & 8191, et = Ke >>> 13, He = pe[8] | 0, nt = He & 8191, qe = He >>> 13, ht = pe[9] | 0, pt = ht & 8191, bt = ht >>> 13;
        ce.negative = ne.negative ^ oe.negative, ce.length = 19, be = Math.imul(Le, ft), ae = Math.imul(Le, Ct), ae = ae + Math.imul(ze, ft) | 0, ge = Math.imul(ze, Ct);
        var jt = (Ce + be | 0) + ((ae & 8191) << 13) | 0;
        Ce = (ge + (ae >>> 13) | 0) + (jt >>> 26) | 0, jt &= 67108863, be = Math.imul(We, ft), ae = Math.imul(We, Ct), ae = ae + Math.imul(Be, ft) | 0, ge = Math.imul(Be, Ct), be = be + Math.imul(Le, vt) | 0, ae = ae + Math.imul(Le, Mt) | 0, ae = ae + Math.imul(ze, vt) | 0, ge = ge + Math.imul(ze, Mt) | 0;
        var $t = (Ce + be | 0) + ((ae & 8191) << 13) | 0;
        Ce = (ge + (ae >>> 13) | 0) + ($t >>> 26) | 0, $t &= 67108863, be = Math.imul(Ge, ft), ae = Math.imul(Ge, Ct), ae = ae + Math.imul(je, ft) | 0, ge = Math.imul(je, Ct), be = be + Math.imul(We, vt) | 0, ae = ae + Math.imul(We, Mt) | 0, ae = ae + Math.imul(Be, vt) | 0, ge = ge + Math.imul(Be, Mt) | 0, be = be + Math.imul(Le, St) | 0, ae = ae + Math.imul(Le, Ot) | 0, ae = ae + Math.imul(ze, St) | 0, ge = ge + Math.imul(ze, Ot) | 0;
        var Jt = (Ce + be | 0) + ((ae & 8191) << 13) | 0;
        Ce = (ge + (ae >>> 13) | 0) + (Jt >>> 26) | 0, Jt &= 67108863, be = Math.imul(Ne, ft), ae = Math.imul(Ne, Ct), ae = ae + Math.imul(Ye, ft) | 0, ge = Math.imul(Ye, Ct), be = be + Math.imul(Ge, vt) | 0, ae = ae + Math.imul(Ge, Mt) | 0, ae = ae + Math.imul(je, vt) | 0, ge = ge + Math.imul(je, Mt) | 0, be = be + Math.imul(We, St) | 0, ae = ae + Math.imul(We, Ot) | 0, ae = ae + Math.imul(Be, St) | 0, ge = ge + Math.imul(Be, Ot) | 0, be = be + Math.imul(Le, kt) | 0, ae = ae + Math.imul(Le, Bt) | 0, ae = ae + Math.imul(ze, kt) | 0, ge = ge + Math.imul(ze, Bt) | 0;
        var zt = (Ce + be | 0) + ((ae & 8191) << 13) | 0;
        Ce = (ge + (ae >>> 13) | 0) + (zt >>> 26) | 0, zt &= 67108863, be = Math.imul(Xe, ft), ae = Math.imul(Xe, Ct), ae = ae + Math.imul(st, ft) | 0, ge = Math.imul(st, Ct), be = be + Math.imul(Ne, vt) | 0, ae = ae + Math.imul(Ne, Mt) | 0, ae = ae + Math.imul(Ye, vt) | 0, ge = ge + Math.imul(Ye, Mt) | 0, be = be + Math.imul(Ge, St) | 0, ae = ae + Math.imul(Ge, Ot) | 0, ae = ae + Math.imul(je, St) | 0, ge = ge + Math.imul(je, Ot) | 0, be = be + Math.imul(We, kt) | 0, ae = ae + Math.imul(We, Bt) | 0, ae = ae + Math.imul(Be, kt) | 0, ge = ge + Math.imul(Be, Bt) | 0, be = be + Math.imul(Le, Nt) | 0, ae = ae + Math.imul(Le, Wt) | 0, ae = ae + Math.imul(ze, Nt) | 0, ge = ge + Math.imul(ze, Wt) | 0;
        var Vt = (Ce + be | 0) + ((ae & 8191) << 13) | 0;
        Ce = (ge + (ae >>> 13) | 0) + (Vt >>> 26) | 0, Vt &= 67108863, be = Math.imul(it, ft), ae = Math.imul(it, Ct), ae = ae + Math.imul(ot, ft) | 0, ge = Math.imul(ot, Ct), be = be + Math.imul(Xe, vt) | 0, ae = ae + Math.imul(Xe, Mt) | 0, ae = ae + Math.imul(st, vt) | 0, ge = ge + Math.imul(st, Mt) | 0, be = be + Math.imul(Ne, St) | 0, ae = ae + Math.imul(Ne, Ot) | 0, ae = ae + Math.imul(Ye, St) | 0, ge = ge + Math.imul(Ye, Ot) | 0, be = be + Math.imul(Ge, kt) | 0, ae = ae + Math.imul(Ge, Bt) | 0, ae = ae + Math.imul(je, kt) | 0, ge = ge + Math.imul(je, Bt) | 0, be = be + Math.imul(We, Nt) | 0, ae = ae + Math.imul(We, Wt) | 0, ae = ae + Math.imul(Be, Nt) | 0, ge = ge + Math.imul(Be, Wt) | 0, be = be + Math.imul(Le, Lt) | 0, ae = ae + Math.imul(Le, Ht) | 0, ae = ae + Math.imul(ze, Lt) | 0, ge = ge + Math.imul(ze, Ht) | 0;
        var Kt = (Ce + be | 0) + ((ae & 8191) << 13) | 0;
        Ce = (ge + (ae >>> 13) | 0) + (Kt >>> 26) | 0, Kt &= 67108863, be = Math.imul(dt, ft), ae = Math.imul(dt, Ct), ae = ae + Math.imul(mt, ft) | 0, ge = Math.imul(mt, Ct), be = be + Math.imul(it, vt) | 0, ae = ae + Math.imul(it, Mt) | 0, ae = ae + Math.imul(ot, vt) | 0, ge = ge + Math.imul(ot, Mt) | 0, be = be + Math.imul(Xe, St) | 0, ae = ae + Math.imul(Xe, Ot) | 0, ae = ae + Math.imul(st, St) | 0, ge = ge + Math.imul(st, Ot) | 0, be = be + Math.imul(Ne, kt) | 0, ae = ae + Math.imul(Ne, Bt) | 0, ae = ae + Math.imul(Ye, kt) | 0, ge = ge + Math.imul(Ye, Bt) | 0, be = be + Math.imul(Ge, Nt) | 0, ae = ae + Math.imul(Ge, Wt) | 0, ae = ae + Math.imul(je, Nt) | 0, ge = ge + Math.imul(je, Wt) | 0, be = be + Math.imul(We, Lt) | 0, ae = ae + Math.imul(We, Ht) | 0, ae = ae + Math.imul(Be, Lt) | 0, ge = ge + Math.imul(Be, Ht) | 0, be = be + Math.imul(Le, Dt) | 0, ae = ae + Math.imul(Le, Gt) | 0, ae = ae + Math.imul(ze, Dt) | 0, ge = ge + Math.imul(ze, Gt) | 0;
        var pn = (Ce + be | 0) + ((ae & 8191) << 13) | 0;
        Ce = (ge + (ae >>> 13) | 0) + (pn >>> 26) | 0, pn &= 67108863, be = Math.imul(xt, ft), ae = Math.imul(xt, Ct), ae = ae + Math.imul(Tt, ft) | 0, ge = Math.imul(Tt, Ct), be = be + Math.imul(dt, vt) | 0, ae = ae + Math.imul(dt, Mt) | 0, ae = ae + Math.imul(mt, vt) | 0, ge = ge + Math.imul(mt, Mt) | 0, be = be + Math.imul(it, St) | 0, ae = ae + Math.imul(it, Ot) | 0, ae = ae + Math.imul(ot, St) | 0, ge = ge + Math.imul(ot, Ot) | 0, be = be + Math.imul(Xe, kt) | 0, ae = ae + Math.imul(Xe, Bt) | 0, ae = ae + Math.imul(st, kt) | 0, ge = ge + Math.imul(st, Bt) | 0, be = be + Math.imul(Ne, Nt) | 0, ae = ae + Math.imul(Ne, Wt) | 0, ae = ae + Math.imul(Ye, Nt) | 0, ge = ge + Math.imul(Ye, Wt) | 0, be = be + Math.imul(Ge, Lt) | 0, ae = ae + Math.imul(Ge, Ht) | 0, ae = ae + Math.imul(je, Lt) | 0, ge = ge + Math.imul(je, Ht) | 0, be = be + Math.imul(We, Dt) | 0, ae = ae + Math.imul(We, Gt) | 0, ae = ae + Math.imul(Be, Dt) | 0, ge = ge + Math.imul(Be, Gt) | 0, be = be + Math.imul(Le, Qe) | 0, ae = ae + Math.imul(Le, et) | 0, ae = ae + Math.imul(ze, Qe) | 0, ge = ge + Math.imul(ze, et) | 0;
        var An = (Ce + be | 0) + ((ae & 8191) << 13) | 0;
        Ce = (ge + (ae >>> 13) | 0) + (An >>> 26) | 0, An &= 67108863, be = Math.imul(Ve, ft), ae = Math.imul(Ve, Ct), ae = ae + Math.imul(Pe, ft) | 0, ge = Math.imul(Pe, Ct), be = be + Math.imul(xt, vt) | 0, ae = ae + Math.imul(xt, Mt) | 0, ae = ae + Math.imul(Tt, vt) | 0, ge = ge + Math.imul(Tt, Mt) | 0, be = be + Math.imul(dt, St) | 0, ae = ae + Math.imul(dt, Ot) | 0, ae = ae + Math.imul(mt, St) | 0, ge = ge + Math.imul(mt, Ot) | 0, be = be + Math.imul(it, kt) | 0, ae = ae + Math.imul(it, Bt) | 0, ae = ae + Math.imul(ot, kt) | 0, ge = ge + Math.imul(ot, Bt) | 0, be = be + Math.imul(Xe, Nt) | 0, ae = ae + Math.imul(Xe, Wt) | 0, ae = ae + Math.imul(st, Nt) | 0, ge = ge + Math.imul(st, Wt) | 0, be = be + Math.imul(Ne, Lt) | 0, ae = ae + Math.imul(Ne, Ht) | 0, ae = ae + Math.imul(Ye, Lt) | 0, ge = ge + Math.imul(Ye, Ht) | 0, be = be + Math.imul(Ge, Dt) | 0, ae = ae + Math.imul(Ge, Gt) | 0, ae = ae + Math.imul(je, Dt) | 0, ge = ge + Math.imul(je, Gt) | 0, be = be + Math.imul(We, Qe) | 0, ae = ae + Math.imul(We, et) | 0, ae = ae + Math.imul(Be, Qe) | 0, ge = ge + Math.imul(Be, et) | 0, be = be + Math.imul(Le, nt) | 0, ae = ae + Math.imul(Le, qe) | 0, ae = ae + Math.imul(ze, nt) | 0, ge = ge + Math.imul(ze, qe) | 0;
        var vn = (Ce + be | 0) + ((ae & 8191) << 13) | 0;
        Ce = (ge + (ae >>> 13) | 0) + (vn >>> 26) | 0, vn &= 67108863, be = Math.imul(Ze, ft), ae = Math.imul(Ze, Ct), ae = ae + Math.imul(at, ft) | 0, ge = Math.imul(at, Ct), be = be + Math.imul(Ve, vt) | 0, ae = ae + Math.imul(Ve, Mt) | 0, ae = ae + Math.imul(Pe, vt) | 0, ge = ge + Math.imul(Pe, Mt) | 0, be = be + Math.imul(xt, St) | 0, ae = ae + Math.imul(xt, Ot) | 0, ae = ae + Math.imul(Tt, St) | 0, ge = ge + Math.imul(Tt, Ot) | 0, be = be + Math.imul(dt, kt) | 0, ae = ae + Math.imul(dt, Bt) | 0, ae = ae + Math.imul(mt, kt) | 0, ge = ge + Math.imul(mt, Bt) | 0, be = be + Math.imul(it, Nt) | 0, ae = ae + Math.imul(it, Wt) | 0, ae = ae + Math.imul(ot, Nt) | 0, ge = ge + Math.imul(ot, Wt) | 0, be = be + Math.imul(Xe, Lt) | 0, ae = ae + Math.imul(Xe, Ht) | 0, ae = ae + Math.imul(st, Lt) | 0, ge = ge + Math.imul(st, Ht) | 0, be = be + Math.imul(Ne, Dt) | 0, ae = ae + Math.imul(Ne, Gt) | 0, ae = ae + Math.imul(Ye, Dt) | 0, ge = ge + Math.imul(Ye, Gt) | 0, be = be + Math.imul(Ge, Qe) | 0, ae = ae + Math.imul(Ge, et) | 0, ae = ae + Math.imul(je, Qe) | 0, ge = ge + Math.imul(je, et) | 0, be = be + Math.imul(We, nt) | 0, ae = ae + Math.imul(We, qe) | 0, ae = ae + Math.imul(Be, nt) | 0, ge = ge + Math.imul(Be, qe) | 0, be = be + Math.imul(Le, pt) | 0, ae = ae + Math.imul(Le, bt) | 0, ae = ae + Math.imul(ze, pt) | 0, ge = ge + Math.imul(ze, bt) | 0;
        var Cn = (Ce + be | 0) + ((ae & 8191) << 13) | 0;
        Ce = (ge + (ae >>> 13) | 0) + (Cn >>> 26) | 0, Cn &= 67108863, be = Math.imul(Ze, vt), ae = Math.imul(Ze, Mt), ae = ae + Math.imul(at, vt) | 0, ge = Math.imul(at, Mt), be = be + Math.imul(Ve, St) | 0, ae = ae + Math.imul(Ve, Ot) | 0, ae = ae + Math.imul(Pe, St) | 0, ge = ge + Math.imul(Pe, Ot) | 0, be = be + Math.imul(xt, kt) | 0, ae = ae + Math.imul(xt, Bt) | 0, ae = ae + Math.imul(Tt, kt) | 0, ge = ge + Math.imul(Tt, Bt) | 0, be = be + Math.imul(dt, Nt) | 0, ae = ae + Math.imul(dt, Wt) | 0, ae = ae + Math.imul(mt, Nt) | 0, ge = ge + Math.imul(mt, Wt) | 0, be = be + Math.imul(it, Lt) | 0, ae = ae + Math.imul(it, Ht) | 0, ae = ae + Math.imul(ot, Lt) | 0, ge = ge + Math.imul(ot, Ht) | 0, be = be + Math.imul(Xe, Dt) | 0, ae = ae + Math.imul(Xe, Gt) | 0, ae = ae + Math.imul(st, Dt) | 0, ge = ge + Math.imul(st, Gt) | 0, be = be + Math.imul(Ne, Qe) | 0, ae = ae + Math.imul(Ne, et) | 0, ae = ae + Math.imul(Ye, Qe) | 0, ge = ge + Math.imul(Ye, et) | 0, be = be + Math.imul(Ge, nt) | 0, ae = ae + Math.imul(Ge, qe) | 0, ae = ae + Math.imul(je, nt) | 0, ge = ge + Math.imul(je, qe) | 0, be = be + Math.imul(We, pt) | 0, ae = ae + Math.imul(We, bt) | 0, ae = ae + Math.imul(Be, pt) | 0, ge = ge + Math.imul(Be, bt) | 0;
        var yn = (Ce + be | 0) + ((ae & 8191) << 13) | 0;
        Ce = (ge + (ae >>> 13) | 0) + (yn >>> 26) | 0, yn &= 67108863, be = Math.imul(Ze, St), ae = Math.imul(Ze, Ot), ae = ae + Math.imul(at, St) | 0, ge = Math.imul(at, Ot), be = be + Math.imul(Ve, kt) | 0, ae = ae + Math.imul(Ve, Bt) | 0, ae = ae + Math.imul(Pe, kt) | 0, ge = ge + Math.imul(Pe, Bt) | 0, be = be + Math.imul(xt, Nt) | 0, ae = ae + Math.imul(xt, Wt) | 0, ae = ae + Math.imul(Tt, Nt) | 0, ge = ge + Math.imul(Tt, Wt) | 0, be = be + Math.imul(dt, Lt) | 0, ae = ae + Math.imul(dt, Ht) | 0, ae = ae + Math.imul(mt, Lt) | 0, ge = ge + Math.imul(mt, Ht) | 0, be = be + Math.imul(it, Dt) | 0, ae = ae + Math.imul(it, Gt) | 0, ae = ae + Math.imul(ot, Dt) | 0, ge = ge + Math.imul(ot, Gt) | 0, be = be + Math.imul(Xe, Qe) | 0, ae = ae + Math.imul(Xe, et) | 0, ae = ae + Math.imul(st, Qe) | 0, ge = ge + Math.imul(st, et) | 0, be = be + Math.imul(Ne, nt) | 0, ae = ae + Math.imul(Ne, qe) | 0, ae = ae + Math.imul(Ye, nt) | 0, ge = ge + Math.imul(Ye, qe) | 0, be = be + Math.imul(Ge, pt) | 0, ae = ae + Math.imul(Ge, bt) | 0, ae = ae + Math.imul(je, pt) | 0, ge = ge + Math.imul(je, bt) | 0;
        var dn = (Ce + be | 0) + ((ae & 8191) << 13) | 0;
        Ce = (ge + (ae >>> 13) | 0) + (dn >>> 26) | 0, dn &= 67108863, be = Math.imul(Ze, kt), ae = Math.imul(Ze, Bt), ae = ae + Math.imul(at, kt) | 0, ge = Math.imul(at, Bt), be = be + Math.imul(Ve, Nt) | 0, ae = ae + Math.imul(Ve, Wt) | 0, ae = ae + Math.imul(Pe, Nt) | 0, ge = ge + Math.imul(Pe, Wt) | 0, be = be + Math.imul(xt, Lt) | 0, ae = ae + Math.imul(xt, Ht) | 0, ae = ae + Math.imul(Tt, Lt) | 0, ge = ge + Math.imul(Tt, Ht) | 0, be = be + Math.imul(dt, Dt) | 0, ae = ae + Math.imul(dt, Gt) | 0, ae = ae + Math.imul(mt, Dt) | 0, ge = ge + Math.imul(mt, Gt) | 0, be = be + Math.imul(it, Qe) | 0, ae = ae + Math.imul(it, et) | 0, ae = ae + Math.imul(ot, Qe) | 0, ge = ge + Math.imul(ot, et) | 0, be = be + Math.imul(Xe, nt) | 0, ae = ae + Math.imul(Xe, qe) | 0, ae = ae + Math.imul(st, nt) | 0, ge = ge + Math.imul(st, qe) | 0, be = be + Math.imul(Ne, pt) | 0, ae = ae + Math.imul(Ne, bt) | 0, ae = ae + Math.imul(Ye, pt) | 0, ge = ge + Math.imul(Ye, bt) | 0;
        var xn = (Ce + be | 0) + ((ae & 8191) << 13) | 0;
        Ce = (ge + (ae >>> 13) | 0) + (xn >>> 26) | 0, xn &= 67108863, be = Math.imul(Ze, Nt), ae = Math.imul(Ze, Wt), ae = ae + Math.imul(at, Nt) | 0, ge = Math.imul(at, Wt), be = be + Math.imul(Ve, Lt) | 0, ae = ae + Math.imul(Ve, Ht) | 0, ae = ae + Math.imul(Pe, Lt) | 0, ge = ge + Math.imul(Pe, Ht) | 0, be = be + Math.imul(xt, Dt) | 0, ae = ae + Math.imul(xt, Gt) | 0, ae = ae + Math.imul(Tt, Dt) | 0, ge = ge + Math.imul(Tt, Gt) | 0, be = be + Math.imul(dt, Qe) | 0, ae = ae + Math.imul(dt, et) | 0, ae = ae + Math.imul(mt, Qe) | 0, ge = ge + Math.imul(mt, et) | 0, be = be + Math.imul(it, nt) | 0, ae = ae + Math.imul(it, qe) | 0, ae = ae + Math.imul(ot, nt) | 0, ge = ge + Math.imul(ot, qe) | 0, be = be + Math.imul(Xe, pt) | 0, ae = ae + Math.imul(Xe, bt) | 0, ae = ae + Math.imul(st, pt) | 0, ge = ge + Math.imul(st, bt) | 0;
        var ln = (Ce + be | 0) + ((ae & 8191) << 13) | 0;
        Ce = (ge + (ae >>> 13) | 0) + (ln >>> 26) | 0, ln &= 67108863, be = Math.imul(Ze, Lt), ae = Math.imul(Ze, Ht), ae = ae + Math.imul(at, Lt) | 0, ge = Math.imul(at, Ht), be = be + Math.imul(Ve, Dt) | 0, ae = ae + Math.imul(Ve, Gt) | 0, ae = ae + Math.imul(Pe, Dt) | 0, ge = ge + Math.imul(Pe, Gt) | 0, be = be + Math.imul(xt, Qe) | 0, ae = ae + Math.imul(xt, et) | 0, ae = ae + Math.imul(Tt, Qe) | 0, ge = ge + Math.imul(Tt, et) | 0, be = be + Math.imul(dt, nt) | 0, ae = ae + Math.imul(dt, qe) | 0, ae = ae + Math.imul(mt, nt) | 0, ge = ge + Math.imul(mt, qe) | 0, be = be + Math.imul(it, pt) | 0, ae = ae + Math.imul(it, bt) | 0, ae = ae + Math.imul(ot, pt) | 0, ge = ge + Math.imul(ot, bt) | 0;
        var mn = (Ce + be | 0) + ((ae & 8191) << 13) | 0;
        Ce = (ge + (ae >>> 13) | 0) + (mn >>> 26) | 0, mn &= 67108863, be = Math.imul(Ze, Dt), ae = Math.imul(Ze, Gt), ae = ae + Math.imul(at, Dt) | 0, ge = Math.imul(at, Gt), be = be + Math.imul(Ve, Qe) | 0, ae = ae + Math.imul(Ve, et) | 0, ae = ae + Math.imul(Pe, Qe) | 0, ge = ge + Math.imul(Pe, et) | 0, be = be + Math.imul(xt, nt) | 0, ae = ae + Math.imul(xt, qe) | 0, ae = ae + Math.imul(Tt, nt) | 0, ge = ge + Math.imul(Tt, qe) | 0, be = be + Math.imul(dt, pt) | 0, ae = ae + Math.imul(dt, bt) | 0, ae = ae + Math.imul(mt, pt) | 0, ge = ge + Math.imul(mt, bt) | 0;
        var gn = (Ce + be | 0) + ((ae & 8191) << 13) | 0;
        Ce = (ge + (ae >>> 13) | 0) + (gn >>> 26) | 0, gn &= 67108863, be = Math.imul(Ze, Qe), ae = Math.imul(Ze, et), ae = ae + Math.imul(at, Qe) | 0, ge = Math.imul(at, et), be = be + Math.imul(Ve, nt) | 0, ae = ae + Math.imul(Ve, qe) | 0, ae = ae + Math.imul(Pe, nt) | 0, ge = ge + Math.imul(Pe, qe) | 0, be = be + Math.imul(xt, pt) | 0, ae = ae + Math.imul(xt, bt) | 0, ae = ae + Math.imul(Tt, pt) | 0, ge = ge + Math.imul(Tt, bt) | 0;
        var cn = (Ce + be | 0) + ((ae & 8191) << 13) | 0;
        Ce = (ge + (ae >>> 13) | 0) + (cn >>> 26) | 0, cn &= 67108863, be = Math.imul(Ze, nt), ae = Math.imul(Ze, qe), ae = ae + Math.imul(at, nt) | 0, ge = Math.imul(at, qe), be = be + Math.imul(Ve, pt) | 0, ae = ae + Math.imul(Ve, bt) | 0, ae = ae + Math.imul(Pe, pt) | 0, ge = ge + Math.imul(Pe, bt) | 0;
        var Pt = (Ce + be | 0) + ((ae & 8191) << 13) | 0;
        Ce = (ge + (ae >>> 13) | 0) + (Pt >>> 26) | 0, Pt &= 67108863, be = Math.imul(Ze, pt), ae = Math.imul(Ze, bt), ae = ae + Math.imul(at, pt) | 0, ge = Math.imul(at, bt);
        var Rt = (Ce + be | 0) + ((ae & 8191) << 13) | 0;
        return Ce = (ge + (ae >>> 13) | 0) + (Rt >>> 26) | 0, Rt &= 67108863, ye[0] = jt, ye[1] = $t, ye[2] = Jt, ye[3] = zt, ye[4] = Vt, ye[5] = Kt, ye[6] = pn, ye[7] = An, ye[8] = vn, ye[9] = Cn, ye[10] = yn, ye[11] = dn, ye[12] = xn, ye[13] = ln, ye[14] = mn, ye[15] = gn, ye[16] = cn, ye[17] = Pt, ye[18] = Rt, Ce !== 0 && (ye[19] = Ce, ce.length++), ce;
      };
      Math.imul || (me = he);
      function xe(Ae, ne, oe) {
        oe.negative = ne.negative ^ Ae.negative, oe.length = Ae.length + ne.length;
        for (var ce = 0, le = 0, pe = 0; pe < oe.length - 1; pe++) {
          var ye = le;
          le = 0;
          for (var Ce = ce & 67108863, be = Math.min(pe, ne.length - 1), ae = Math.max(0, pe - Ae.length + 1); ae <= be; ae++) {
            var ge = pe - ae, Se = Ae.words[ge] | 0, Le = ne.words[ae] | 0, ze = Se * Le, Re = ze & 67108863;
            ye = ye + (ze / 67108864 | 0) | 0, Re = Re + Ce | 0, Ce = Re & 67108863, ye = ye + (Re >>> 26) | 0, le += ye >>> 26, ye &= 67108863;
          }
          oe.words[pe] = Ce, ce = ye, ye = le;
        }
        return ce !== 0 ? oe.words[pe] = ce : oe.length--, oe.strip();
      }
      function ve(Ae, ne, oe) {
        var ce = new Te();
        return ce.mulp(Ae, ne, oe);
      }
      J.prototype.mulTo = function(ne, oe) {
        var ce, le = this.length + ne.length;
        return this.length === 10 && ne.length === 10 ? ce = me(this, ne, oe) : le < 63 ? ce = he(this, ne, oe) : le < 1024 ? ce = xe(this, ne, oe) : ce = ve(this, ne, oe), ce;
      };
      function Te(Ae, ne) {
        this.x = Ae, this.y = ne;
      }
      Te.prototype.makeRBT = function(ne) {
        for (var oe = new Array(ne), ce = J.prototype._countBits(ne) - 1, le = 0; le < ne; le++)
          oe[le] = this.revBin(le, ce, ne);
        return oe;
      }, Te.prototype.revBin = function(ne, oe, ce) {
        if (ne === 0 || ne === ce - 1) return ne;
        for (var le = 0, pe = 0; pe < oe; pe++)
          le |= (ne & 1) << oe - pe - 1, ne >>= 1;
        return le;
      }, Te.prototype.permute = function(ne, oe, ce, le, pe, ye) {
        for (var Ce = 0; Ce < ye; Ce++)
          le[Ce] = oe[ne[Ce]], pe[Ce] = ce[ne[Ce]];
      }, Te.prototype.transform = function(ne, oe, ce, le, pe, ye) {
        this.permute(ye, ne, oe, ce, le, pe);
        for (var Ce = 1; Ce < pe; Ce <<= 1)
          for (var be = Ce << 1, ae = Math.cos(2 * Math.PI / be), ge = Math.sin(2 * Math.PI / be), Se = 0; Se < pe; Se += be)
            for (var Le = ae, ze = ge, Re = 0; Re < Ce; Re++) {
              var We = ce[Se + Re], Be = le[Se + Re], Ue = ce[Se + Re + Ce], Ge = le[Se + Re + Ce], je = Le * Ue - ze * Ge;
              Ge = Le * Ge + ze * Ue, Ue = je, ce[Se + Re] = We + Ue, le[Se + Re] = Be + Ge, ce[Se + Re + Ce] = We - Ue, le[Se + Re + Ce] = Be - Ge, Re !== be && (je = ae * Le - ge * ze, ze = ae * ze + ge * Le, Le = je);
            }
      }, Te.prototype.guessLen13b = function(ne, oe) {
        var ce = Math.max(oe, ne) | 1, le = ce & 1, pe = 0;
        for (ce = ce / 2 | 0; ce; ce = ce >>> 1)
          pe++;
        return 1 << pe + 1 + le;
      }, Te.prototype.conjugate = function(ne, oe, ce) {
        if (!(ce <= 1))
          for (var le = 0; le < ce / 2; le++) {
            var pe = ne[le];
            ne[le] = ne[ce - le - 1], ne[ce - le - 1] = pe, pe = oe[le], oe[le] = -oe[ce - le - 1], oe[ce - le - 1] = -pe;
          }
      }, Te.prototype.normalize13b = function(ne, oe) {
        for (var ce = 0, le = 0; le < oe / 2; le++) {
          var pe = Math.round(ne[2 * le + 1] / oe) * 8192 + Math.round(ne[2 * le] / oe) + ce;
          ne[le] = pe & 67108863, pe < 67108864 ? ce = 0 : ce = pe / 67108864 | 0;
        }
        return ne;
      }, Te.prototype.convert13b = function(ne, oe, ce, le) {
        for (var pe = 0, ye = 0; ye < oe; ye++)
          pe = pe + (ne[ye] | 0), ce[2 * ye] = pe & 8191, pe = pe >>> 13, ce[2 * ye + 1] = pe & 8191, pe = pe >>> 13;
        for (ye = 2 * oe; ye < le; ++ye)
          ce[ye] = 0;
        $(pe === 0), $((pe & -8192) === 0);
      }, Te.prototype.stub = function(ne) {
        for (var oe = new Array(ne), ce = 0; ce < ne; ce++)
          oe[ce] = 0;
        return oe;
      }, Te.prototype.mulp = function(ne, oe, ce) {
        var le = 2 * this.guessLen13b(ne.length, oe.length), pe = this.makeRBT(le), ye = this.stub(le), Ce = new Array(le), be = new Array(le), ae = new Array(le), ge = new Array(le), Se = new Array(le), Le = new Array(le), ze = ce.words;
        ze.length = le, this.convert13b(ne.words, ne.length, Ce, le), this.convert13b(oe.words, oe.length, ge, le), this.transform(Ce, ye, be, ae, le, pe), this.transform(ge, ye, Se, Le, le, pe);
        for (var Re = 0; Re < le; Re++) {
          var We = be[Re] * Se[Re] - ae[Re] * Le[Re];
          ae[Re] = be[Re] * Le[Re] + ae[Re] * Se[Re], be[Re] = We;
        }
        return this.conjugate(be, ae, le), this.transform(be, ae, ze, ye, le, pe), this.conjugate(ze, ye, le), this.normalize13b(ze, le), ce.negative = ne.negative ^ oe.negative, ce.length = ne.length + oe.length, ce.strip();
      }, J.prototype.mul = function(ne) {
        var oe = new J(null);
        return oe.words = new Array(this.length + ne.length), this.mulTo(ne, oe);
      }, J.prototype.mulf = function(ne) {
        var oe = new J(null);
        return oe.words = new Array(this.length + ne.length), ve(this, ne, oe);
      }, J.prototype.imul = function(ne) {
        return this.clone().mulTo(ne, this);
      }, J.prototype.imuln = function(ne) {
        $(typeof ne == "number"), $(ne < 67108864);
        for (var oe = 0, ce = 0; ce < this.length; ce++) {
          var le = (this.words[ce] | 0) * ne, pe = (le & 67108863) + (oe & 67108863);
          oe >>= 26, oe += le / 67108864 | 0, oe += pe >>> 26, this.words[ce] = pe & 67108863;
        }
        return oe !== 0 && (this.words[ce] = oe, this.length++), this;
      }, J.prototype.muln = function(ne) {
        return this.clone().imuln(ne);
      }, J.prototype.sqr = function() {
        return this.mul(this);
      }, J.prototype.isqr = function() {
        return this.imul(this.clone());
      }, J.prototype.pow = function(ne) {
        var oe = fe(ne);
        if (oe.length === 0) return new J(1);
        for (var ce = this, le = 0; le < oe.length && oe[le] === 0; le++, ce = ce.sqr())
          ;
        if (++le < oe.length)
          for (var pe = ce.sqr(); le < oe.length; le++, pe = pe.sqr())
            oe[le] !== 0 && (ce = ce.mul(pe));
        return ce;
      }, J.prototype.iushln = function(ne) {
        $(typeof ne == "number" && ne >= 0);
        var oe = ne % 26, ce = (ne - oe) / 26, le = 67108863 >>> 26 - oe << 26 - oe, pe;
        if (oe !== 0) {
          var ye = 0;
          for (pe = 0; pe < this.length; pe++) {
            var Ce = this.words[pe] & le, be = (this.words[pe] | 0) - Ce << oe;
            this.words[pe] = be | ye, ye = Ce >>> 26 - oe;
          }
          ye && (this.words[pe] = ye, this.length++);
        }
        if (ce !== 0) {
          for (pe = this.length - 1; pe >= 0; pe--)
            this.words[pe + ce] = this.words[pe];
          for (pe = 0; pe < ce; pe++)
            this.words[pe] = 0;
          this.length += ce;
        }
        return this.strip();
      }, J.prototype.ishln = function(ne) {
        return $(this.negative === 0), this.iushln(ne);
      }, J.prototype.iushrn = function(ne, oe, ce) {
        $(typeof ne == "number" && ne >= 0);
        var le;
        oe ? le = (oe - oe % 26) / 26 : le = 0;
        var pe = ne % 26, ye = Math.min((ne - pe) / 26, this.length), Ce = 67108863 ^ 67108863 >>> pe << pe, be = ce;
        if (le -= ye, le = Math.max(0, le), be) {
          for (var ae = 0; ae < ye; ae++)
            be.words[ae] = this.words[ae];
          be.length = ye;
        }
        if (ye !== 0) if (this.length > ye)
          for (this.length -= ye, ae = 0; ae < this.length; ae++)
            this.words[ae] = this.words[ae + ye];
        else
          this.words[0] = 0, this.length = 1;
        var ge = 0;
        for (ae = this.length - 1; ae >= 0 && (ge !== 0 || ae >= le); ae--) {
          var Se = this.words[ae] | 0;
          this.words[ae] = ge << 26 - pe | Se >>> pe, ge = Se & Ce;
        }
        return be && ge !== 0 && (be.words[be.length++] = ge), this.length === 0 && (this.words[0] = 0, this.length = 1), this.strip();
      }, J.prototype.ishrn = function(ne, oe, ce) {
        return $(this.negative === 0), this.iushrn(ne, oe, ce);
      }, J.prototype.shln = function(ne) {
        return this.clone().ishln(ne);
      }, J.prototype.ushln = function(ne) {
        return this.clone().iushln(ne);
      }, J.prototype.shrn = function(ne) {
        return this.clone().ishrn(ne);
      }, J.prototype.ushrn = function(ne) {
        return this.clone().iushrn(ne);
      }, J.prototype.testn = function(ne) {
        $(typeof ne == "number" && ne >= 0);
        var oe = ne % 26, ce = (ne - oe) / 26, le = 1 << oe;
        if (this.length <= ce) return !1;
        var pe = this.words[ce];
        return !!(pe & le);
      }, J.prototype.imaskn = function(ne) {
        $(typeof ne == "number" && ne >= 0);
        var oe = ne % 26, ce = (ne - oe) / 26;
        if ($(this.negative === 0, "imaskn works only with positive numbers"), this.length <= ce)
          return this;
        if (oe !== 0 && ce++, this.length = Math.min(ce, this.length), oe !== 0) {
          var le = 67108863 ^ 67108863 >>> oe << oe;
          this.words[this.length - 1] &= le;
        }
        return this.strip();
      }, J.prototype.maskn = function(ne) {
        return this.clone().imaskn(ne);
      }, J.prototype.iaddn = function(ne) {
        return $(typeof ne == "number"), $(ne < 67108864), ne < 0 ? this.isubn(-ne) : this.negative !== 0 ? this.length === 1 && (this.words[0] | 0) < ne ? (this.words[0] = ne - (this.words[0] | 0), this.negative = 0, this) : (this.negative = 0, this.isubn(ne), this.negative = 1, this) : this._iaddn(ne);
      }, J.prototype._iaddn = function(ne) {
        this.words[0] += ne;
        for (var oe = 0; oe < this.length && this.words[oe] >= 67108864; oe++)
          this.words[oe] -= 67108864, oe === this.length - 1 ? this.words[oe + 1] = 1 : this.words[oe + 1]++;
        return this.length = Math.max(this.length, oe + 1), this;
      }, J.prototype.isubn = function(ne) {
        if ($(typeof ne == "number"), $(ne < 67108864), ne < 0) return this.iaddn(-ne);
        if (this.negative !== 0)
          return this.negative = 0, this.iaddn(ne), this.negative = 1, this;
        if (this.words[0] -= ne, this.length === 1 && this.words[0] < 0)
          this.words[0] = -this.words[0], this.negative = 1;
        else
          for (var oe = 0; oe < this.length && this.words[oe] < 0; oe++)
            this.words[oe] += 67108864, this.words[oe + 1] -= 1;
        return this.strip();
      }, J.prototype.addn = function(ne) {
        return this.clone().iaddn(ne);
      }, J.prototype.subn = function(ne) {
        return this.clone().isubn(ne);
      }, J.prototype.iabs = function() {
        return this.negative = 0, this;
      }, J.prototype.abs = function() {
        return this.clone().iabs();
      }, J.prototype._ishlnsubmul = function(ne, oe, ce) {
        var le = ne.length + ce, pe;
        this._expand(le);
        var ye, Ce = 0;
        for (pe = 0; pe < ne.length; pe++) {
          ye = (this.words[pe + ce] | 0) + Ce;
          var be = (ne.words[pe] | 0) * oe;
          ye -= be & 67108863, Ce = (ye >> 26) - (be / 67108864 | 0), this.words[pe + ce] = ye & 67108863;
        }
        for (; pe < this.length - ce; pe++)
          ye = (this.words[pe + ce] | 0) + Ce, Ce = ye >> 26, this.words[pe + ce] = ye & 67108863;
        if (Ce === 0) return this.strip();
        for ($(Ce === -1), Ce = 0, pe = 0; pe < this.length; pe++)
          ye = -(this.words[pe] | 0) + Ce, Ce = ye >> 26, this.words[pe] = ye & 67108863;
        return this.negative = 1, this.strip();
      }, J.prototype._wordDiv = function(ne, oe) {
        var ce = this.length - ne.length, le = this.clone(), pe = ne, ye = pe.words[pe.length - 1] | 0, Ce = this._countBits(ye);
        ce = 26 - Ce, ce !== 0 && (pe = pe.ushln(ce), le.iushln(ce), ye = pe.words[pe.length - 1] | 0);
        var be = le.length - pe.length, ae;
        if (oe !== "mod") {
          ae = new J(null), ae.length = be + 1, ae.words = new Array(ae.length);
          for (var ge = 0; ge < ae.length; ge++)
            ae.words[ge] = 0;
        }
        var Se = le.clone()._ishlnsubmul(pe, 1, be);
        Se.negative === 0 && (le = Se, ae && (ae.words[be] = 1));
        for (var Le = be - 1; Le >= 0; Le--) {
          var ze = (le.words[pe.length + Le] | 0) * 67108864 + (le.words[pe.length + Le - 1] | 0);
          for (ze = Math.min(ze / ye | 0, 67108863), le._ishlnsubmul(pe, ze, Le); le.negative !== 0; )
            ze--, le.negative = 0, le._ishlnsubmul(pe, 1, Le), le.isZero() || (le.negative ^= 1);
          ae && (ae.words[Le] = ze);
        }
        return ae && ae.strip(), le.strip(), oe !== "div" && ce !== 0 && le.iushrn(ce), {
          div: ae || null,
          mod: le
        };
      }, J.prototype.divmod = function(ne, oe, ce) {
        if ($(!ne.isZero()), this.isZero())
          return {
            div: new J(0),
            mod: new J(0)
          };
        var le, pe, ye;
        return this.negative !== 0 && ne.negative === 0 ? (ye = this.neg().divmod(ne, oe), oe !== "mod" && (le = ye.div.neg()), oe !== "div" && (pe = ye.mod.neg(), ce && pe.negative !== 0 && pe.iadd(ne)), {
          div: le,
          mod: pe
        }) : this.negative === 0 && ne.negative !== 0 ? (ye = this.divmod(ne.neg(), oe), oe !== "mod" && (le = ye.div.neg()), {
          div: le,
          mod: ye.mod
        }) : this.negative & ne.negative ? (ye = this.neg().divmod(ne.neg(), oe), oe !== "div" && (pe = ye.mod.neg(), ce && pe.negative !== 0 && pe.isub(ne)), {
          div: ye.div,
          mod: pe
        }) : ne.length > this.length || this.cmp(ne) < 0 ? {
          div: new J(0),
          mod: this
        } : ne.length === 1 ? oe === "div" ? {
          div: this.divn(ne.words[0]),
          mod: null
        } : oe === "mod" ? {
          div: null,
          mod: new J(this.modn(ne.words[0]))
        } : {
          div: this.divn(ne.words[0]),
          mod: new J(this.modn(ne.words[0]))
        } : this._wordDiv(ne, oe);
      }, J.prototype.div = function(ne) {
        return this.divmod(ne, "div", !1).div;
      }, J.prototype.mod = function(ne) {
        return this.divmod(ne, "mod", !1).mod;
      }, J.prototype.umod = function(ne) {
        return this.divmod(ne, "mod", !0).mod;
      }, J.prototype.divRound = function(ne) {
        var oe = this.divmod(ne);
        if (oe.mod.isZero()) return oe.div;
        var ce = oe.div.negative !== 0 ? oe.mod.isub(ne) : oe.mod, le = ne.ushrn(1), pe = ne.andln(1), ye = ce.cmp(le);
        return ye < 0 || pe === 1 && ye === 0 ? oe.div : oe.div.negative !== 0 ? oe.div.isubn(1) : oe.div.iaddn(1);
      }, J.prototype.modn = function(ne) {
        $(ne <= 67108863);
        for (var oe = (1 << 26) % ne, ce = 0, le = this.length - 1; le >= 0; le--)
          ce = (oe * ce + (this.words[le] | 0)) % ne;
        return ce;
      }, J.prototype.idivn = function(ne) {
        $(ne <= 67108863);
        for (var oe = 0, ce = this.length - 1; ce >= 0; ce--) {
          var le = (this.words[ce] | 0) + oe * 67108864;
          this.words[ce] = le / ne | 0, oe = le % ne;
        }
        return this.strip();
      }, J.prototype.divn = function(ne) {
        return this.clone().idivn(ne);
      }, J.prototype.egcd = function(ne) {
        $(ne.negative === 0), $(!ne.isZero());
        var oe = this, ce = ne.clone();
        oe.negative !== 0 ? oe = oe.umod(ne) : oe = oe.clone();
        for (var le = new J(1), pe = new J(0), ye = new J(0), Ce = new J(1), be = 0; oe.isEven() && ce.isEven(); )
          oe.iushrn(1), ce.iushrn(1), ++be;
        for (var ae = ce.clone(), ge = oe.clone(); !oe.isZero(); ) {
          for (var Se = 0, Le = 1; !(oe.words[0] & Le) && Se < 26; ++Se, Le <<= 1) ;
          if (Se > 0)
            for (oe.iushrn(Se); Se-- > 0; )
              (le.isOdd() || pe.isOdd()) && (le.iadd(ae), pe.isub(ge)), le.iushrn(1), pe.iushrn(1);
          for (var ze = 0, Re = 1; !(ce.words[0] & Re) && ze < 26; ++ze, Re <<= 1) ;
          if (ze > 0)
            for (ce.iushrn(ze); ze-- > 0; )
              (ye.isOdd() || Ce.isOdd()) && (ye.iadd(ae), Ce.isub(ge)), ye.iushrn(1), Ce.iushrn(1);
          oe.cmp(ce) >= 0 ? (oe.isub(ce), le.isub(ye), pe.isub(Ce)) : (ce.isub(oe), ye.isub(le), Ce.isub(pe));
        }
        return {
          a: ye,
          b: Ce,
          gcd: ce.iushln(be)
        };
      }, J.prototype._invmp = function(ne) {
        $(ne.negative === 0), $(!ne.isZero());
        var oe = this, ce = ne.clone();
        oe.negative !== 0 ? oe = oe.umod(ne) : oe = oe.clone();
        for (var le = new J(1), pe = new J(0), ye = ce.clone(); oe.cmpn(1) > 0 && ce.cmpn(1) > 0; ) {
          for (var Ce = 0, be = 1; !(oe.words[0] & be) && Ce < 26; ++Ce, be <<= 1) ;
          if (Ce > 0)
            for (oe.iushrn(Ce); Ce-- > 0; )
              le.isOdd() && le.iadd(ye), le.iushrn(1);
          for (var ae = 0, ge = 1; !(ce.words[0] & ge) && ae < 26; ++ae, ge <<= 1) ;
          if (ae > 0)
            for (ce.iushrn(ae); ae-- > 0; )
              pe.isOdd() && pe.iadd(ye), pe.iushrn(1);
          oe.cmp(ce) >= 0 ? (oe.isub(ce), le.isub(pe)) : (ce.isub(oe), pe.isub(le));
        }
        var Se;
        return oe.cmpn(1) === 0 ? Se = le : Se = pe, Se.cmpn(0) < 0 && Se.iadd(ne), Se;
      }, J.prototype.gcd = function(ne) {
        if (this.isZero()) return ne.abs();
        if (ne.isZero()) return this.abs();
        var oe = this.clone(), ce = ne.clone();
        oe.negative = 0, ce.negative = 0;
        for (var le = 0; oe.isEven() && ce.isEven(); le++)
          oe.iushrn(1), ce.iushrn(1);
        do {
          for (; oe.isEven(); )
            oe.iushrn(1);
          for (; ce.isEven(); )
            ce.iushrn(1);
          var pe = oe.cmp(ce);
          if (pe < 0) {
            var ye = oe;
            oe = ce, ce = ye;
          } else if (pe === 0 || ce.cmpn(1) === 0)
            break;
          oe.isub(ce);
        } while (!0);
        return ce.iushln(le);
      }, J.prototype.invm = function(ne) {
        return this.egcd(ne).a.umod(ne);
      }, J.prototype.isEven = function() {
        return (this.words[0] & 1) === 0;
      }, J.prototype.isOdd = function() {
        return (this.words[0] & 1) === 1;
      }, J.prototype.andln = function(ne) {
        return this.words[0] & ne;
      }, J.prototype.bincn = function(ne) {
        $(typeof ne == "number");
        var oe = ne % 26, ce = (ne - oe) / 26, le = 1 << oe;
        if (this.length <= ce)
          return this._expand(ce + 1), this.words[ce] |= le, this;
        for (var pe = le, ye = ce; pe !== 0 && ye < this.length; ye++) {
          var Ce = this.words[ye] | 0;
          Ce += pe, pe = Ce >>> 26, Ce &= 67108863, this.words[ye] = Ce;
        }
        return pe !== 0 && (this.words[ye] = pe, this.length++), this;
      }, J.prototype.isZero = function() {
        return this.length === 1 && this.words[0] === 0;
      }, J.prototype.cmpn = function(ne) {
        var oe = ne < 0;
        if (this.negative !== 0 && !oe) return -1;
        if (this.negative === 0 && oe) return 1;
        this.strip();
        var ce;
        if (this.length > 1)
          ce = 1;
        else {
          oe && (ne = -ne), $(ne <= 67108863, "Number is too big");
          var le = this.words[0] | 0;
          ce = le === ne ? 0 : le < ne ? -1 : 1;
        }
        return this.negative !== 0 ? -ce | 0 : ce;
      }, J.prototype.cmp = function(ne) {
        if (this.negative !== 0 && ne.negative === 0) return -1;
        if (this.negative === 0 && ne.negative !== 0) return 1;
        var oe = this.ucmp(ne);
        return this.negative !== 0 ? -oe | 0 : oe;
      }, J.prototype.ucmp = function(ne) {
        if (this.length > ne.length) return 1;
        if (this.length < ne.length) return -1;
        for (var oe = 0, ce = this.length - 1; ce >= 0; ce--) {
          var le = this.words[ce] | 0, pe = ne.words[ce] | 0;
          if (le !== pe) {
            le < pe ? oe = -1 : le > pe && (oe = 1);
            break;
          }
        }
        return oe;
      }, J.prototype.gtn = function(ne) {
        return this.cmpn(ne) === 1;
      }, J.prototype.gt = function(ne) {
        return this.cmp(ne) === 1;
      }, J.prototype.gten = function(ne) {
        return this.cmpn(ne) >= 0;
      }, J.prototype.gte = function(ne) {
        return this.cmp(ne) >= 0;
      }, J.prototype.ltn = function(ne) {
        return this.cmpn(ne) === -1;
      }, J.prototype.lt = function(ne) {
        return this.cmp(ne) === -1;
      }, J.prototype.lten = function(ne) {
        return this.cmpn(ne) <= 0;
      }, J.prototype.lte = function(ne) {
        return this.cmp(ne) <= 0;
      }, J.prototype.eqn = function(ne) {
        return this.cmpn(ne) === 0;
      }, J.prototype.eq = function(ne) {
        return this.cmp(ne) === 0;
      }, J.red = function(ne) {
        return new De(ne);
      }, J.prototype.toRed = function(ne) {
        return $(!this.red, "Already a number in reduction context"), $(this.negative === 0, "red works only with positives"), ne.convertTo(this)._forceRed(ne);
      }, J.prototype.fromRed = function() {
        return $(this.red, "fromRed works only with numbers in reduction context"), this.red.convertFrom(this);
      }, J.prototype._forceRed = function(ne) {
        return this.red = ne, this;
      }, J.prototype.forceRed = function(ne) {
        return $(!this.red, "Already a number in reduction context"), this._forceRed(ne);
      }, J.prototype.redAdd = function(ne) {
        return $(this.red, "redAdd works only with red numbers"), this.red.add(this, ne);
      }, J.prototype.redIAdd = function(ne) {
        return $(this.red, "redIAdd works only with red numbers"), this.red.iadd(this, ne);
      }, J.prototype.redSub = function(ne) {
        return $(this.red, "redSub works only with red numbers"), this.red.sub(this, ne);
      }, J.prototype.redISub = function(ne) {
        return $(this.red, "redISub works only with red numbers"), this.red.isub(this, ne);
      }, J.prototype.redShl = function(ne) {
        return $(this.red, "redShl works only with red numbers"), this.red.shl(this, ne);
      }, J.prototype.redMul = function(ne) {
        return $(this.red, "redMul works only with red numbers"), this.red._verify2(this, ne), this.red.mul(this, ne);
      }, J.prototype.redIMul = function(ne) {
        return $(this.red, "redMul works only with red numbers"), this.red._verify2(this, ne), this.red.imul(this, ne);
      }, J.prototype.redSqr = function() {
        return $(this.red, "redSqr works only with red numbers"), this.red._verify1(this), this.red.sqr(this);
      }, J.prototype.redISqr = function() {
        return $(this.red, "redISqr works only with red numbers"), this.red._verify1(this), this.red.isqr(this);
      }, J.prototype.redSqrt = function() {
        return $(this.red, "redSqrt works only with red numbers"), this.red._verify1(this), this.red.sqrt(this);
      }, J.prototype.redInvm = function() {
        return $(this.red, "redInvm works only with red numbers"), this.red._verify1(this), this.red.invm(this);
      }, J.prototype.redNeg = function() {
        return $(this.red, "redNeg works only with red numbers"), this.red._verify1(this), this.red.neg(this);
      }, J.prototype.redPow = function(ne) {
        return $(this.red && !ne.red, "redPow(normalNum)"), this.red._verify1(this), this.red.pow(this, ne);
      };
      var we = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
      };
      function Ee(Ae, ne) {
        this.name = Ae, this.p = new J(ne, 16), this.n = this.p.bitLength(), this.k = new J(1).iushln(this.n).isub(this.p), this.tmp = this._tmp();
      }
      Ee.prototype._tmp = function() {
        var ne = new J(null);
        return ne.words = new Array(Math.ceil(this.n / 13)), ne;
      }, Ee.prototype.ireduce = function(ne) {
        var oe = ne, ce;
        do
          this.split(oe, this.tmp), oe = this.imulK(oe), oe = oe.iadd(this.tmp), ce = oe.bitLength();
        while (ce > this.n);
        var le = ce < this.n ? -1 : oe.ucmp(this.p);
        return le === 0 ? (oe.words[0] = 0, oe.length = 1) : le > 0 ? oe.isub(this.p) : oe.strip !== void 0 ? oe.strip() : oe._strip(), oe;
      }, Ee.prototype.split = function(ne, oe) {
        ne.iushrn(this.n, 0, oe);
      }, Ee.prototype.imulK = function(ne) {
        return ne.imul(this.k);
      };
      function Me() {
        Ee.call(
          this,
          "k256",
          "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f"
        );
      }
      V(Me, Ee), Me.prototype.split = function(ne, oe) {
        for (var ce = 4194303, le = Math.min(ne.length, 9), pe = 0; pe < le; pe++)
          oe.words[pe] = ne.words[pe];
        if (oe.length = le, ne.length <= 9) {
          ne.words[0] = 0, ne.length = 1;
          return;
        }
        var ye = ne.words[9];
        for (oe.words[oe.length++] = ye & ce, pe = 10; pe < ne.length; pe++) {
          var Ce = ne.words[pe] | 0;
          ne.words[pe - 10] = (Ce & ce) << 4 | ye >>> 22, ye = Ce;
        }
        ye >>>= 22, ne.words[pe - 10] = ye, ye === 0 && ne.length > 10 ? ne.length -= 10 : ne.length -= 9;
      }, Me.prototype.imulK = function(ne) {
        ne.words[ne.length] = 0, ne.words[ne.length + 1] = 0, ne.length += 2;
        for (var oe = 0, ce = 0; ce < ne.length; ce++) {
          var le = ne.words[ce] | 0;
          oe += le * 977, ne.words[ce] = oe & 67108863, oe = le * 64 + (oe / 67108864 | 0);
        }
        return ne.words[ne.length - 1] === 0 && (ne.length--, ne.words[ne.length - 1] === 0 && ne.length--), ne;
      };
      function Ie() {
        Ee.call(
          this,
          "p224",
          "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001"
        );
      }
      V(Ie, Ee);
      function ke() {
        Ee.call(
          this,
          "p192",
          "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff"
        );
      }
      V(ke, Ee);
      function _e() {
        Ee.call(
          this,
          "25519",
          "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed"
        );
      }
      V(_e, Ee), _e.prototype.imulK = function(ne) {
        for (var oe = 0, ce = 0; ce < ne.length; ce++) {
          var le = (ne.words[ce] | 0) * 19 + oe, pe = le & 67108863;
          le >>>= 26, ne.words[ce] = pe, oe = le;
        }
        return oe !== 0 && (ne.words[ne.length++] = oe), ne;
      }, J._prime = function(ne) {
        if (we[ne]) return we[ne];
        var oe;
        if (ne === "k256")
          oe = new Me();
        else if (ne === "p224")
          oe = new Ie();
        else if (ne === "p192")
          oe = new ke();
        else if (ne === "p25519")
          oe = new _e();
        else
          throw new Error("Unknown prime " + ne);
        return we[ne] = oe, oe;
      };
      function De(Ae) {
        if (typeof Ae == "string") {
          var ne = J._prime(Ae);
          this.m = ne.p, this.prime = ne;
        } else
          $(Ae.gtn(1), "modulus must be greater than 1"), this.m = Ae, this.prime = null;
      }
      De.prototype._verify1 = function(ne) {
        $(ne.negative === 0, "red works only with positives"), $(ne.red, "red works only with red numbers");
      }, De.prototype._verify2 = function(ne, oe) {
        $((ne.negative | oe.negative) === 0, "red works only with positives"), $(
          ne.red && ne.red === oe.red,
          "red works only with red numbers"
        );
      }, De.prototype.imod = function(ne) {
        return this.prime ? this.prime.ireduce(ne)._forceRed(this) : ne.umod(this.m)._forceRed(this);
      }, De.prototype.neg = function(ne) {
        return ne.isZero() ? ne.clone() : this.m.sub(ne)._forceRed(this);
      }, De.prototype.add = function(ne, oe) {
        this._verify2(ne, oe);
        var ce = ne.add(oe);
        return ce.cmp(this.m) >= 0 && ce.isub(this.m), ce._forceRed(this);
      }, De.prototype.iadd = function(ne, oe) {
        this._verify2(ne, oe);
        var ce = ne.iadd(oe);
        return ce.cmp(this.m) >= 0 && ce.isub(this.m), ce;
      }, De.prototype.sub = function(ne, oe) {
        this._verify2(ne, oe);
        var ce = ne.sub(oe);
        return ce.cmpn(0) < 0 && ce.iadd(this.m), ce._forceRed(this);
      }, De.prototype.isub = function(ne, oe) {
        this._verify2(ne, oe);
        var ce = ne.isub(oe);
        return ce.cmpn(0) < 0 && ce.iadd(this.m), ce;
      }, De.prototype.shl = function(ne, oe) {
        return this._verify1(ne), this.imod(ne.ushln(oe));
      }, De.prototype.imul = function(ne, oe) {
        return this._verify2(ne, oe), this.imod(ne.imul(oe));
      }, De.prototype.mul = function(ne, oe) {
        return this._verify2(ne, oe), this.imod(ne.mul(oe));
      }, De.prototype.isqr = function(ne) {
        return this.imul(ne, ne.clone());
      }, De.prototype.sqr = function(ne) {
        return this.mul(ne, ne);
      }, De.prototype.sqrt = function(ne) {
        if (ne.isZero()) return ne.clone();
        var oe = this.m.andln(3);
        if ($(oe % 2 === 1), oe === 3) {
          var ce = this.m.add(new J(1)).iushrn(2);
          return this.pow(ne, ce);
        }
        for (var le = this.m.subn(1), pe = 0; !le.isZero() && le.andln(1) === 0; )
          pe++, le.iushrn(1);
        $(!le.isZero());
        var ye = new J(1).toRed(this), Ce = ye.redNeg(), be = this.m.subn(1).iushrn(1), ae = this.m.bitLength();
        for (ae = new J(2 * ae * ae).toRed(this); this.pow(ae, be).cmp(Ce) !== 0; )
          ae.redIAdd(Ce);
        for (var ge = this.pow(ae, le), Se = this.pow(ne, le.addn(1).iushrn(1)), Le = this.pow(ne, le), ze = pe; Le.cmp(ye) !== 0; ) {
          for (var Re = Le, We = 0; Re.cmp(ye) !== 0; We++)
            Re = Re.redSqr();
          $(We < ze);
          var Be = this.pow(ge, new J(1).iushln(ze - We - 1));
          Se = Se.redMul(Be), ge = Be.redSqr(), Le = Le.redMul(ge), ze = We;
        }
        return Se;
      }, De.prototype.invm = function(ne) {
        var oe = ne._invmp(this.m);
        return oe.negative !== 0 ? (oe.negative = 0, this.imod(oe).redNeg()) : this.imod(oe);
      }, De.prototype.pow = function(ne, oe) {
        if (oe.isZero()) return new J(1).toRed(this);
        if (oe.cmpn(1) === 0) return ne.clone();
        var ce = 4, le = new Array(1 << ce);
        le[0] = new J(1).toRed(this), le[1] = ne;
        for (var pe = 2; pe < le.length; pe++)
          le[pe] = this.mul(le[pe - 1], ne);
        var ye = le[0], Ce = 0, be = 0, ae = oe.bitLength() % 26;
        for (ae === 0 && (ae = 26), pe = oe.length - 1; pe >= 0; pe--) {
          for (var ge = oe.words[pe], Se = ae - 1; Se >= 0; Se--) {
            var Le = ge >> Se & 1;
            if (ye !== le[0] && (ye = this.sqr(ye)), Le === 0 && Ce === 0) {
              be = 0;
              continue;
            }
            Ce <<= 1, Ce |= Le, be++, !(be !== ce && (pe !== 0 || Se !== 0)) && (ye = this.mul(ye, le[Ce]), be = 0, Ce = 0);
          }
          ae = 26;
        }
        return ye;
      }, De.prototype.convertTo = function(ne) {
        var oe = ne.umod(this.m);
        return oe === ne ? oe.clone() : oe;
      }, De.prototype.convertFrom = function(ne) {
        var oe = ne.clone();
        return oe.red = null, oe;
      }, J.mont = function(ne) {
        return new Fe(ne);
      };
      function Fe(Ae) {
        De.call(this, Ae), this.shift = this.m.bitLength(), this.shift % 26 !== 0 && (this.shift += 26 - this.shift % 26), this.r = new J(1).iushln(this.shift), this.r2 = this.imod(this.r.sqr()), this.rinv = this.r._invmp(this.m), this.minv = this.rinv.mul(this.r).isubn(1).div(this.m), this.minv = this.minv.umod(this.r), this.minv = this.r.sub(this.minv);
      }
      V(Fe, De), Fe.prototype.convertTo = function(ne) {
        return this.imod(ne.ushln(this.shift));
      }, Fe.prototype.convertFrom = function(ne) {
        var oe = this.imod(ne.mul(this.rinv));
        return oe.red = null, oe;
      }, Fe.prototype.imul = function(ne, oe) {
        if (ne.isZero() || oe.isZero())
          return ne.words[0] = 0, ne.length = 1, ne;
        var ce = ne.imul(oe), le = ce.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m), pe = ce.isub(le).iushrn(this.shift), ye = pe;
        return pe.cmp(this.m) >= 0 ? ye = pe.isub(this.m) : pe.cmpn(0) < 0 && (ye = pe.iadd(this.m)), ye._forceRed(this);
      }, Fe.prototype.mul = function(ne, oe) {
        if (ne.isZero() || oe.isZero()) return new J(0)._forceRed(this);
        var ce = ne.mul(oe), le = ce.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m), pe = ce.isub(le).iushrn(this.shift), ye = pe;
        return pe.cmp(this.m) >= 0 ? ye = pe.isub(this.m) : pe.cmpn(0) < 0 && (ye = pe.iadd(this.m)), ye._forceRed(this);
      }, Fe.prototype.invm = function(ne) {
        var oe = this.imod(ne._invmp(this.m).mul(this.r2));
        return oe._forceRed(this);
      };
    })(C, commonjsGlobal$1);
  }(bn$3)), bn$3.exports;
}
var utils$3 = {}, hasRequiredUtils$2;
function requireUtils$2() {
  return hasRequiredUtils$2 || (hasRequiredUtils$2 = 1, function(C) {
    var e = C;
    function T(J, ee) {
      if (Array.isArray(J))
        return J.slice();
      if (!J)
        return [];
      var te = [];
      if (typeof J != "string") {
        for (var re = 0; re < J.length; re++)
          te[re] = J[re] | 0;
        return te;
      }
      if (ee === "hex") {
        J = J.replace(/[^a-z0-9]+/ig, ""), J.length % 2 !== 0 && (J = "0" + J);
        for (var re = 0; re < J.length; re += 2)
          te.push(parseInt(J[re] + J[re + 1], 16));
      } else
        for (var re = 0; re < J.length; re++) {
          var ie = J.charCodeAt(re), se = ie >> 8, de = ie & 255;
          se ? te.push(se, de) : te.push(de);
        }
      return te;
    }
    e.toArray = T;
    function $(J) {
      return J.length === 1 ? "0" + J : J;
    }
    e.zero2 = $;
    function V(J) {
      for (var ee = "", te = 0; te < J.length; te++)
        ee += $(J[te].toString(16));
      return ee;
    }
    e.toHex = V, e.encode = function(ee, te) {
      return te === "hex" ? V(ee) : ee;
    };
  }(utils$3)), utils$3;
}
var hasRequiredUtils$1;
function requireUtils$1() {
  return hasRequiredUtils$1 || (hasRequiredUtils$1 = 1, function(C) {
    var e = C, T = requireBn$3(), $ = requireMinimalisticAssert(), V = requireUtils$2();
    e.assert = $, e.toArray = V.toArray, e.zero2 = V.zero2, e.toHex = V.toHex, e.encode = V.encode;
    function J(se, de, ue) {
      var fe = new Array(Math.max(se.bitLength(), ue) + 1), he;
      for (he = 0; he < fe.length; he += 1)
        fe[he] = 0;
      var me = 1 << de + 1, xe = se.clone();
      for (he = 0; he < fe.length; he++) {
        var ve, Te = xe.andln(me - 1);
        xe.isOdd() ? (Te > (me >> 1) - 1 ? ve = (me >> 1) - Te : ve = Te, xe.isubn(ve)) : ve = 0, fe[he] = ve, xe.iushrn(1);
      }
      return fe;
    }
    e.getNAF = J;
    function ee(se, de) {
      var ue = [
        [],
        []
      ];
      se = se.clone(), de = de.clone();
      for (var fe = 0, he = 0, me; se.cmpn(-fe) > 0 || de.cmpn(-he) > 0; ) {
        var xe = se.andln(3) + fe & 3, ve = de.andln(3) + he & 3;
        xe === 3 && (xe = -1), ve === 3 && (ve = -1);
        var Te;
        xe & 1 ? (me = se.andln(7) + fe & 7, (me === 3 || me === 5) && ve === 2 ? Te = -xe : Te = xe) : Te = 0, ue[0].push(Te);
        var we;
        ve & 1 ? (me = de.andln(7) + he & 7, (me === 3 || me === 5) && xe === 2 ? we = -ve : we = ve) : we = 0, ue[1].push(we), 2 * fe === Te + 1 && (fe = 1 - fe), 2 * he === we + 1 && (he = 1 - he), se.iushrn(1), de.iushrn(1);
      }
      return ue;
    }
    e.getJSF = ee;
    function te(se, de, ue) {
      var fe = "_" + de;
      se.prototype[de] = function() {
        return this[fe] !== void 0 ? this[fe] : this[fe] = ue.call(this);
      };
    }
    e.cachedProperty = te;
    function re(se) {
      return typeof se == "string" ? e.toArray(se, "hex") : se;
    }
    e.parseBytes = re;
    function ie(se) {
      return new T(se, "hex", "le");
    }
    e.intFromLE = ie;
  }(utils$4)), utils$4;
}
var curve = {}, base$5, hasRequiredBase$1;
function requireBase$1() {
  if (hasRequiredBase$1) return base$5;
  hasRequiredBase$1 = 1;
  var C = requireBn$3(), e = requireUtils$1(), T = e.getNAF, $ = e.getJSF, V = e.assert;
  function J(te, re) {
    this.type = te, this.p = new C(re.p, 16), this.red = re.prime ? C.red(re.prime) : C.mont(this.p), this.zero = new C(0).toRed(this.red), this.one = new C(1).toRed(this.red), this.two = new C(2).toRed(this.red), this.n = re.n && new C(re.n, 16), this.g = re.g && this.pointFromJSON(re.g, re.gRed), this._wnafT1 = new Array(4), this._wnafT2 = new Array(4), this._wnafT3 = new Array(4), this._wnafT4 = new Array(4), this._bitLength = this.n ? this.n.bitLength() : 0;
    var ie = this.n && this.p.div(this.n);
    !ie || ie.cmpn(100) > 0 ? this.redN = null : (this._maxwellTrick = !0, this.redN = this.n.toRed(this.red));
  }
  base$5 = J, J.prototype.point = function() {
    throw new Error("Not implemented");
  }, J.prototype.validate = function() {
    throw new Error("Not implemented");
  }, J.prototype._fixedNafMul = function(re, ie) {
    V(re.precomputed);
    var se = re._getDoubles(), de = T(ie, 1, this._bitLength), ue = (1 << se.step + 1) - (se.step % 2 === 0 ? 2 : 1);
    ue /= 3;
    var fe = [], he, me;
    for (he = 0; he < de.length; he += se.step) {
      me = 0;
      for (var xe = he + se.step - 1; xe >= he; xe--)
        me = (me << 1) + de[xe];
      fe.push(me);
    }
    for (var ve = this.jpoint(null, null, null), Te = this.jpoint(null, null, null), we = ue; we > 0; we--) {
      for (he = 0; he < fe.length; he++)
        me = fe[he], me === we ? Te = Te.mixedAdd(se.points[he]) : me === -we && (Te = Te.mixedAdd(se.points[he].neg()));
      ve = ve.add(Te);
    }
    return ve.toP();
  }, J.prototype._wnafMul = function(re, ie) {
    var se = 4, de = re._getNAFPoints(se);
    se = de.wnd;
    for (var ue = de.points, fe = T(ie, se, this._bitLength), he = this.jpoint(null, null, null), me = fe.length - 1; me >= 0; me--) {
      for (var xe = 0; me >= 0 && fe[me] === 0; me--)
        xe++;
      if (me >= 0 && xe++, he = he.dblp(xe), me < 0)
        break;
      var ve = fe[me];
      V(ve !== 0), re.type === "affine" ? ve > 0 ? he = he.mixedAdd(ue[ve - 1 >> 1]) : he = he.mixedAdd(ue[-ve - 1 >> 1].neg()) : ve > 0 ? he = he.add(ue[ve - 1 >> 1]) : he = he.add(ue[-ve - 1 >> 1].neg());
    }
    return re.type === "affine" ? he.toP() : he;
  }, J.prototype._wnafMulAdd = function(re, ie, se, de, ue) {
    var fe = this._wnafT1, he = this._wnafT2, me = this._wnafT3, xe = 0, ve, Te, we;
    for (ve = 0; ve < de; ve++) {
      we = ie[ve];
      var Ee = we._getNAFPoints(re);
      fe[ve] = Ee.wnd, he[ve] = Ee.points;
    }
    for (ve = de - 1; ve >= 1; ve -= 2) {
      var Me = ve - 1, Ie = ve;
      if (fe[Me] !== 1 || fe[Ie] !== 1) {
        me[Me] = T(se[Me], fe[Me], this._bitLength), me[Ie] = T(se[Ie], fe[Ie], this._bitLength), xe = Math.max(me[Me].length, xe), xe = Math.max(me[Ie].length, xe);
        continue;
      }
      var ke = [
        ie[Me],
        /* 1 */
        null,
        /* 3 */
        null,
        /* 5 */
        ie[Ie]
        /* 7 */
      ];
      ie[Me].y.cmp(ie[Ie].y) === 0 ? (ke[1] = ie[Me].add(ie[Ie]), ke[2] = ie[Me].toJ().mixedAdd(ie[Ie].neg())) : ie[Me].y.cmp(ie[Ie].y.redNeg()) === 0 ? (ke[1] = ie[Me].toJ().mixedAdd(ie[Ie]), ke[2] = ie[Me].add(ie[Ie].neg())) : (ke[1] = ie[Me].toJ().mixedAdd(ie[Ie]), ke[2] = ie[Me].toJ().mixedAdd(ie[Ie].neg()));
      var _e = [
        -3,
        /* -1 -1 */
        -1,
        /* -1 0 */
        -5,
        /* -1 1 */
        -7,
        /* 0 -1 */
        0,
        /* 0 0 */
        7,
        /* 0 1 */
        5,
        /* 1 -1 */
        1,
        /* 1 0 */
        3
        /* 1 1 */
      ], De = $(se[Me], se[Ie]);
      for (xe = Math.max(De[0].length, xe), me[Me] = new Array(xe), me[Ie] = new Array(xe), Te = 0; Te < xe; Te++) {
        var Fe = De[0][Te] | 0, Ae = De[1][Te] | 0;
        me[Me][Te] = _e[(Fe + 1) * 3 + (Ae + 1)], me[Ie][Te] = 0, he[Me] = ke;
      }
    }
    var ne = this.jpoint(null, null, null), oe = this._wnafT4;
    for (ve = xe; ve >= 0; ve--) {
      for (var ce = 0; ve >= 0; ) {
        var le = !0;
        for (Te = 0; Te < de; Te++)
          oe[Te] = me[Te][ve] | 0, oe[Te] !== 0 && (le = !1);
        if (!le)
          break;
        ce++, ve--;
      }
      if (ve >= 0 && ce++, ne = ne.dblp(ce), ve < 0)
        break;
      for (Te = 0; Te < de; Te++) {
        var pe = oe[Te];
        pe !== 0 && (pe > 0 ? we = he[Te][pe - 1 >> 1] : pe < 0 && (we = he[Te][-pe - 1 >> 1].neg()), we.type === "affine" ? ne = ne.mixedAdd(we) : ne = ne.add(we));
      }
    }
    for (ve = 0; ve < de; ve++)
      he[ve] = null;
    return ue ? ne : ne.toP();
  };
  function ee(te, re) {
    this.curve = te, this.type = re, this.precomputed = null;
  }
  return J.BasePoint = ee, ee.prototype.eq = function() {
    throw new Error("Not implemented");
  }, ee.prototype.validate = function() {
    return this.curve.validate(this);
  }, J.prototype.decodePoint = function(re, ie) {
    re = e.toArray(re, ie);
    var se = this.p.byteLength();
    if ((re[0] === 4 || re[0] === 6 || re[0] === 7) && re.length - 1 === 2 * se) {
      re[0] === 6 ? V(re[re.length - 1] % 2 === 0) : re[0] === 7 && V(re[re.length - 1] % 2 === 1);
      var de = this.point(
        re.slice(1, 1 + se),
        re.slice(1 + se, 1 + 2 * se)
      );
      return de;
    } else if ((re[0] === 2 || re[0] === 3) && re.length - 1 === se)
      return this.pointFromX(re.slice(1, 1 + se), re[0] === 3);
    throw new Error("Unknown point format");
  }, ee.prototype.encodeCompressed = function(re) {
    return this.encode(re, !0);
  }, ee.prototype._encode = function(re) {
    var ie = this.curve.p.byteLength(), se = this.getX().toArray("be", ie);
    return re ? [this.getY().isEven() ? 2 : 3].concat(se) : [4].concat(se, this.getY().toArray("be", ie));
  }, ee.prototype.encode = function(re, ie) {
    return e.encode(this._encode(ie), re);
  }, ee.prototype.precompute = function(re) {
    if (this.precomputed)
      return this;
    var ie = {
      doubles: null,
      naf: null,
      beta: null
    };
    return ie.naf = this._getNAFPoints(8), ie.doubles = this._getDoubles(4, re), ie.beta = this._getBeta(), this.precomputed = ie, this;
  }, ee.prototype._hasDoubles = function(re) {
    if (!this.precomputed)
      return !1;
    var ie = this.precomputed.doubles;
    return ie ? ie.points.length >= Math.ceil((re.bitLength() + 1) / ie.step) : !1;
  }, ee.prototype._getDoubles = function(re, ie) {
    if (this.precomputed && this.precomputed.doubles)
      return this.precomputed.doubles;
    for (var se = [this], de = this, ue = 0; ue < ie; ue += re) {
      for (var fe = 0; fe < re; fe++)
        de = de.dbl();
      se.push(de);
    }
    return {
      step: re,
      points: se
    };
  }, ee.prototype._getNAFPoints = function(re) {
    if (this.precomputed && this.precomputed.naf)
      return this.precomputed.naf;
    for (var ie = [this], se = (1 << re) - 1, de = se === 1 ? null : this.dbl(), ue = 1; ue < se; ue++)
      ie[ue] = ie[ue - 1].add(de);
    return {
      wnd: re,
      points: ie
    };
  }, ee.prototype._getBeta = function() {
    return null;
  }, ee.prototype.dblp = function(re) {
    for (var ie = this, se = 0; se < re; se++)
      ie = ie.dbl();
    return ie;
  }, base$5;
}
var short, hasRequiredShort;
function requireShort() {
  if (hasRequiredShort) return short;
  hasRequiredShort = 1;
  var C = requireUtils$1(), e = requireBn$3(), T = requireInherits_browser(), $ = requireBase$1(), V = C.assert;
  function J(re) {
    $.call(this, "short", re), this.a = new e(re.a, 16).toRed(this.red), this.b = new e(re.b, 16).toRed(this.red), this.tinv = this.two.redInvm(), this.zeroA = this.a.fromRed().cmpn(0) === 0, this.threeA = this.a.fromRed().sub(this.p).cmpn(-3) === 0, this.endo = this._getEndomorphism(re), this._endoWnafT1 = new Array(4), this._endoWnafT2 = new Array(4);
  }
  T(J, $), short = J, J.prototype._getEndomorphism = function(ie) {
    if (!(!this.zeroA || !this.g || !this.n || this.p.modn(3) !== 1)) {
      var se, de;
      if (ie.beta)
        se = new e(ie.beta, 16).toRed(this.red);
      else {
        var ue = this._getEndoRoots(this.p);
        se = ue[0].cmp(ue[1]) < 0 ? ue[0] : ue[1], se = se.toRed(this.red);
      }
      if (ie.lambda)
        de = new e(ie.lambda, 16);
      else {
        var fe = this._getEndoRoots(this.n);
        this.g.mul(fe[0]).x.cmp(this.g.x.redMul(se)) === 0 ? de = fe[0] : (de = fe[1], V(this.g.mul(de).x.cmp(this.g.x.redMul(se)) === 0));
      }
      var he;
      return ie.basis ? he = ie.basis.map(function(me) {
        return {
          a: new e(me.a, 16),
          b: new e(me.b, 16)
        };
      }) : he = this._getEndoBasis(de), {
        beta: se,
        lambda: de,
        basis: he
      };
    }
  }, J.prototype._getEndoRoots = function(ie) {
    var se = ie === this.p ? this.red : e.mont(ie), de = new e(2).toRed(se).redInvm(), ue = de.redNeg(), fe = new e(3).toRed(se).redNeg().redSqrt().redMul(de), he = ue.redAdd(fe).fromRed(), me = ue.redSub(fe).fromRed();
    return [he, me];
  }, J.prototype._getEndoBasis = function(ie) {
    for (var se = this.n.ushrn(Math.floor(this.n.bitLength() / 2)), de = ie, ue = this.n.clone(), fe = new e(1), he = new e(0), me = new e(0), xe = new e(1), ve, Te, we, Ee, Me, Ie, ke, _e = 0, De, Fe; de.cmpn(0) !== 0; ) {
      var Ae = ue.div(de);
      De = ue.sub(Ae.mul(de)), Fe = me.sub(Ae.mul(fe));
      var ne = xe.sub(Ae.mul(he));
      if (!we && De.cmp(se) < 0)
        ve = ke.neg(), Te = fe, we = De.neg(), Ee = Fe;
      else if (we && ++_e === 2)
        break;
      ke = De, ue = de, de = De, me = fe, fe = Fe, xe = he, he = ne;
    }
    Me = De.neg(), Ie = Fe;
    var oe = we.sqr().add(Ee.sqr()), ce = Me.sqr().add(Ie.sqr());
    return ce.cmp(oe) >= 0 && (Me = ve, Ie = Te), we.negative && (we = we.neg(), Ee = Ee.neg()), Me.negative && (Me = Me.neg(), Ie = Ie.neg()), [
      { a: we, b: Ee },
      { a: Me, b: Ie }
    ];
  }, J.prototype._endoSplit = function(ie) {
    var se = this.endo.basis, de = se[0], ue = se[1], fe = ue.b.mul(ie).divRound(this.n), he = de.b.neg().mul(ie).divRound(this.n), me = fe.mul(de.a), xe = he.mul(ue.a), ve = fe.mul(de.b), Te = he.mul(ue.b), we = ie.sub(me).sub(xe), Ee = ve.add(Te).neg();
    return { k1: we, k2: Ee };
  }, J.prototype.pointFromX = function(ie, se) {
    ie = new e(ie, 16), ie.red || (ie = ie.toRed(this.red));
    var de = ie.redSqr().redMul(ie).redIAdd(ie.redMul(this.a)).redIAdd(this.b), ue = de.redSqrt();
    if (ue.redSqr().redSub(de).cmp(this.zero) !== 0)
      throw new Error("invalid point");
    var fe = ue.fromRed().isOdd();
    return (se && !fe || !se && fe) && (ue = ue.redNeg()), this.point(ie, ue);
  }, J.prototype.validate = function(ie) {
    if (ie.inf)
      return !0;
    var se = ie.x, de = ie.y, ue = this.a.redMul(se), fe = se.redSqr().redMul(se).redIAdd(ue).redIAdd(this.b);
    return de.redSqr().redISub(fe).cmpn(0) === 0;
  }, J.prototype._endoWnafMulAdd = function(ie, se, de) {
    for (var ue = this._endoWnafT1, fe = this._endoWnafT2, he = 0; he < ie.length; he++) {
      var me = this._endoSplit(se[he]), xe = ie[he], ve = xe._getBeta();
      me.k1.negative && (me.k1.ineg(), xe = xe.neg(!0)), me.k2.negative && (me.k2.ineg(), ve = ve.neg(!0)), ue[he * 2] = xe, ue[he * 2 + 1] = ve, fe[he * 2] = me.k1, fe[he * 2 + 1] = me.k2;
    }
    for (var Te = this._wnafMulAdd(1, ue, fe, he * 2, de), we = 0; we < he * 2; we++)
      ue[we] = null, fe[we] = null;
    return Te;
  };
  function ee(re, ie, se, de) {
    $.BasePoint.call(this, re, "affine"), ie === null && se === null ? (this.x = null, this.y = null, this.inf = !0) : (this.x = new e(ie, 16), this.y = new e(se, 16), de && (this.x.forceRed(this.curve.red), this.y.forceRed(this.curve.red)), this.x.red || (this.x = this.x.toRed(this.curve.red)), this.y.red || (this.y = this.y.toRed(this.curve.red)), this.inf = !1);
  }
  T(ee, $.BasePoint), J.prototype.point = function(ie, se, de) {
    return new ee(this, ie, se, de);
  }, J.prototype.pointFromJSON = function(ie, se) {
    return ee.fromJSON(this, ie, se);
  }, ee.prototype._getBeta = function() {
    if (this.curve.endo) {
      var ie = this.precomputed;
      if (ie && ie.beta)
        return ie.beta;
      var se = this.curve.point(this.x.redMul(this.curve.endo.beta), this.y);
      if (ie) {
        var de = this.curve, ue = function(fe) {
          return de.point(fe.x.redMul(de.endo.beta), fe.y);
        };
        ie.beta = se, se.precomputed = {
          beta: null,
          naf: ie.naf && {
            wnd: ie.naf.wnd,
            points: ie.naf.points.map(ue)
          },
          doubles: ie.doubles && {
            step: ie.doubles.step,
            points: ie.doubles.points.map(ue)
          }
        };
      }
      return se;
    }
  }, ee.prototype.toJSON = function() {
    return this.precomputed ? [this.x, this.y, this.precomputed && {
      doubles: this.precomputed.doubles && {
        step: this.precomputed.doubles.step,
        points: this.precomputed.doubles.points.slice(1)
      },
      naf: this.precomputed.naf && {
        wnd: this.precomputed.naf.wnd,
        points: this.precomputed.naf.points.slice(1)
      }
    }] : [this.x, this.y];
  }, ee.fromJSON = function(ie, se, de) {
    typeof se == "string" && (se = JSON.parse(se));
    var ue = ie.point(se[0], se[1], de);
    if (!se[2])
      return ue;
    function fe(me) {
      return ie.point(me[0], me[1], de);
    }
    var he = se[2];
    return ue.precomputed = {
      beta: null,
      doubles: he.doubles && {
        step: he.doubles.step,
        points: [ue].concat(he.doubles.points.map(fe))
      },
      naf: he.naf && {
        wnd: he.naf.wnd,
        points: [ue].concat(he.naf.points.map(fe))
      }
    }, ue;
  }, ee.prototype.inspect = function() {
    return this.isInfinity() ? "<EC Point Infinity>" : "<EC Point x: " + this.x.fromRed().toString(16, 2) + " y: " + this.y.fromRed().toString(16, 2) + ">";
  }, ee.prototype.isInfinity = function() {
    return this.inf;
  }, ee.prototype.add = function(ie) {
    if (this.inf)
      return ie;
    if (ie.inf)
      return this;
    if (this.eq(ie))
      return this.dbl();
    if (this.neg().eq(ie))
      return this.curve.point(null, null);
    if (this.x.cmp(ie.x) === 0)
      return this.curve.point(null, null);
    var se = this.y.redSub(ie.y);
    se.cmpn(0) !== 0 && (se = se.redMul(this.x.redSub(ie.x).redInvm()));
    var de = se.redSqr().redISub(this.x).redISub(ie.x), ue = se.redMul(this.x.redSub(de)).redISub(this.y);
    return this.curve.point(de, ue);
  }, ee.prototype.dbl = function() {
    if (this.inf)
      return this;
    var ie = this.y.redAdd(this.y);
    if (ie.cmpn(0) === 0)
      return this.curve.point(null, null);
    var se = this.curve.a, de = this.x.redSqr(), ue = ie.redInvm(), fe = de.redAdd(de).redIAdd(de).redIAdd(se).redMul(ue), he = fe.redSqr().redISub(this.x.redAdd(this.x)), me = fe.redMul(this.x.redSub(he)).redISub(this.y);
    return this.curve.point(he, me);
  }, ee.prototype.getX = function() {
    return this.x.fromRed();
  }, ee.prototype.getY = function() {
    return this.y.fromRed();
  }, ee.prototype.mul = function(ie) {
    return ie = new e(ie, 16), this.isInfinity() ? this : this._hasDoubles(ie) ? this.curve._fixedNafMul(this, ie) : this.curve.endo ? this.curve._endoWnafMulAdd([this], [ie]) : this.curve._wnafMul(this, ie);
  }, ee.prototype.mulAdd = function(ie, se, de) {
    var ue = [this, se], fe = [ie, de];
    return this.curve.endo ? this.curve._endoWnafMulAdd(ue, fe) : this.curve._wnafMulAdd(1, ue, fe, 2);
  }, ee.prototype.jmulAdd = function(ie, se, de) {
    var ue = [this, se], fe = [ie, de];
    return this.curve.endo ? this.curve._endoWnafMulAdd(ue, fe, !0) : this.curve._wnafMulAdd(1, ue, fe, 2, !0);
  }, ee.prototype.eq = function(ie) {
    return this === ie || this.inf === ie.inf && (this.inf || this.x.cmp(ie.x) === 0 && this.y.cmp(ie.y) === 0);
  }, ee.prototype.neg = function(ie) {
    if (this.inf)
      return this;
    var se = this.curve.point(this.x, this.y.redNeg());
    if (ie && this.precomputed) {
      var de = this.precomputed, ue = function(fe) {
        return fe.neg();
      };
      se.precomputed = {
        naf: de.naf && {
          wnd: de.naf.wnd,
          points: de.naf.points.map(ue)
        },
        doubles: de.doubles && {
          step: de.doubles.step,
          points: de.doubles.points.map(ue)
        }
      };
    }
    return se;
  }, ee.prototype.toJ = function() {
    if (this.inf)
      return this.curve.jpoint(null, null, null);
    var ie = this.curve.jpoint(this.x, this.y, this.curve.one);
    return ie;
  };
  function te(re, ie, se, de) {
    $.BasePoint.call(this, re, "jacobian"), ie === null && se === null && de === null ? (this.x = this.curve.one, this.y = this.curve.one, this.z = new e(0)) : (this.x = new e(ie, 16), this.y = new e(se, 16), this.z = new e(de, 16)), this.x.red || (this.x = this.x.toRed(this.curve.red)), this.y.red || (this.y = this.y.toRed(this.curve.red)), this.z.red || (this.z = this.z.toRed(this.curve.red)), this.zOne = this.z === this.curve.one;
  }
  return T(te, $.BasePoint), J.prototype.jpoint = function(ie, se, de) {
    return new te(this, ie, se, de);
  }, te.prototype.toP = function() {
    if (this.isInfinity())
      return this.curve.point(null, null);
    var ie = this.z.redInvm(), se = ie.redSqr(), de = this.x.redMul(se), ue = this.y.redMul(se).redMul(ie);
    return this.curve.point(de, ue);
  }, te.prototype.neg = function() {
    return this.curve.jpoint(this.x, this.y.redNeg(), this.z);
  }, te.prototype.add = function(ie) {
    if (this.isInfinity())
      return ie;
    if (ie.isInfinity())
      return this;
    var se = ie.z.redSqr(), de = this.z.redSqr(), ue = this.x.redMul(se), fe = ie.x.redMul(de), he = this.y.redMul(se.redMul(ie.z)), me = ie.y.redMul(de.redMul(this.z)), xe = ue.redSub(fe), ve = he.redSub(me);
    if (xe.cmpn(0) === 0)
      return ve.cmpn(0) !== 0 ? this.curve.jpoint(null, null, null) : this.dbl();
    var Te = xe.redSqr(), we = Te.redMul(xe), Ee = ue.redMul(Te), Me = ve.redSqr().redIAdd(we).redISub(Ee).redISub(Ee), Ie = ve.redMul(Ee.redISub(Me)).redISub(he.redMul(we)), ke = this.z.redMul(ie.z).redMul(xe);
    return this.curve.jpoint(Me, Ie, ke);
  }, te.prototype.mixedAdd = function(ie) {
    if (this.isInfinity())
      return ie.toJ();
    if (ie.isInfinity())
      return this;
    var se = this.z.redSqr(), de = this.x, ue = ie.x.redMul(se), fe = this.y, he = ie.y.redMul(se).redMul(this.z), me = de.redSub(ue), xe = fe.redSub(he);
    if (me.cmpn(0) === 0)
      return xe.cmpn(0) !== 0 ? this.curve.jpoint(null, null, null) : this.dbl();
    var ve = me.redSqr(), Te = ve.redMul(me), we = de.redMul(ve), Ee = xe.redSqr().redIAdd(Te).redISub(we).redISub(we), Me = xe.redMul(we.redISub(Ee)).redISub(fe.redMul(Te)), Ie = this.z.redMul(me);
    return this.curve.jpoint(Ee, Me, Ie);
  }, te.prototype.dblp = function(ie) {
    if (ie === 0)
      return this;
    if (this.isInfinity())
      return this;
    if (!ie)
      return this.dbl();
    var se;
    if (this.curve.zeroA || this.curve.threeA) {
      var de = this;
      for (se = 0; se < ie; se++)
        de = de.dbl();
      return de;
    }
    var ue = this.curve.a, fe = this.curve.tinv, he = this.x, me = this.y, xe = this.z, ve = xe.redSqr().redSqr(), Te = me.redAdd(me);
    for (se = 0; se < ie; se++) {
      var we = he.redSqr(), Ee = Te.redSqr(), Me = Ee.redSqr(), Ie = we.redAdd(we).redIAdd(we).redIAdd(ue.redMul(ve)), ke = he.redMul(Ee), _e = Ie.redSqr().redISub(ke.redAdd(ke)), De = ke.redISub(_e), Fe = Ie.redMul(De);
      Fe = Fe.redIAdd(Fe).redISub(Me);
      var Ae = Te.redMul(xe);
      se + 1 < ie && (ve = ve.redMul(Me)), he = _e, xe = Ae, Te = Fe;
    }
    return this.curve.jpoint(he, Te.redMul(fe), xe);
  }, te.prototype.dbl = function() {
    return this.isInfinity() ? this : this.curve.zeroA ? this._zeroDbl() : this.curve.threeA ? this._threeDbl() : this._dbl();
  }, te.prototype._zeroDbl = function() {
    var ie, se, de;
    if (this.zOne) {
      var ue = this.x.redSqr(), fe = this.y.redSqr(), he = fe.redSqr(), me = this.x.redAdd(fe).redSqr().redISub(ue).redISub(he);
      me = me.redIAdd(me);
      var xe = ue.redAdd(ue).redIAdd(ue), ve = xe.redSqr().redISub(me).redISub(me), Te = he.redIAdd(he);
      Te = Te.redIAdd(Te), Te = Te.redIAdd(Te), ie = ve, se = xe.redMul(me.redISub(ve)).redISub(Te), de = this.y.redAdd(this.y);
    } else {
      var we = this.x.redSqr(), Ee = this.y.redSqr(), Me = Ee.redSqr(), Ie = this.x.redAdd(Ee).redSqr().redISub(we).redISub(Me);
      Ie = Ie.redIAdd(Ie);
      var ke = we.redAdd(we).redIAdd(we), _e = ke.redSqr(), De = Me.redIAdd(Me);
      De = De.redIAdd(De), De = De.redIAdd(De), ie = _e.redISub(Ie).redISub(Ie), se = ke.redMul(Ie.redISub(ie)).redISub(De), de = this.y.redMul(this.z), de = de.redIAdd(de);
    }
    return this.curve.jpoint(ie, se, de);
  }, te.prototype._threeDbl = function() {
    var ie, se, de;
    if (this.zOne) {
      var ue = this.x.redSqr(), fe = this.y.redSqr(), he = fe.redSqr(), me = this.x.redAdd(fe).redSqr().redISub(ue).redISub(he);
      me = me.redIAdd(me);
      var xe = ue.redAdd(ue).redIAdd(ue).redIAdd(this.curve.a), ve = xe.redSqr().redISub(me).redISub(me);
      ie = ve;
      var Te = he.redIAdd(he);
      Te = Te.redIAdd(Te), Te = Te.redIAdd(Te), se = xe.redMul(me.redISub(ve)).redISub(Te), de = this.y.redAdd(this.y);
    } else {
      var we = this.z.redSqr(), Ee = this.y.redSqr(), Me = this.x.redMul(Ee), Ie = this.x.redSub(we).redMul(this.x.redAdd(we));
      Ie = Ie.redAdd(Ie).redIAdd(Ie);
      var ke = Me.redIAdd(Me);
      ke = ke.redIAdd(ke);
      var _e = ke.redAdd(ke);
      ie = Ie.redSqr().redISub(_e), de = this.y.redAdd(this.z).redSqr().redISub(Ee).redISub(we);
      var De = Ee.redSqr();
      De = De.redIAdd(De), De = De.redIAdd(De), De = De.redIAdd(De), se = Ie.redMul(ke.redISub(ie)).redISub(De);
    }
    return this.curve.jpoint(ie, se, de);
  }, te.prototype._dbl = function() {
    var ie = this.curve.a, se = this.x, de = this.y, ue = this.z, fe = ue.redSqr().redSqr(), he = se.redSqr(), me = de.redSqr(), xe = he.redAdd(he).redIAdd(he).redIAdd(ie.redMul(fe)), ve = se.redAdd(se);
    ve = ve.redIAdd(ve);
    var Te = ve.redMul(me), we = xe.redSqr().redISub(Te.redAdd(Te)), Ee = Te.redISub(we), Me = me.redSqr();
    Me = Me.redIAdd(Me), Me = Me.redIAdd(Me), Me = Me.redIAdd(Me);
    var Ie = xe.redMul(Ee).redISub(Me), ke = de.redAdd(de).redMul(ue);
    return this.curve.jpoint(we, Ie, ke);
  }, te.prototype.trpl = function() {
    if (!this.curve.zeroA)
      return this.dbl().add(this);
    var ie = this.x.redSqr(), se = this.y.redSqr(), de = this.z.redSqr(), ue = se.redSqr(), fe = ie.redAdd(ie).redIAdd(ie), he = fe.redSqr(), me = this.x.redAdd(se).redSqr().redISub(ie).redISub(ue);
    me = me.redIAdd(me), me = me.redAdd(me).redIAdd(me), me = me.redISub(he);
    var xe = me.redSqr(), ve = ue.redIAdd(ue);
    ve = ve.redIAdd(ve), ve = ve.redIAdd(ve), ve = ve.redIAdd(ve);
    var Te = fe.redIAdd(me).redSqr().redISub(he).redISub(xe).redISub(ve), we = se.redMul(Te);
    we = we.redIAdd(we), we = we.redIAdd(we);
    var Ee = this.x.redMul(xe).redISub(we);
    Ee = Ee.redIAdd(Ee), Ee = Ee.redIAdd(Ee);
    var Me = this.y.redMul(Te.redMul(ve.redISub(Te)).redISub(me.redMul(xe)));
    Me = Me.redIAdd(Me), Me = Me.redIAdd(Me), Me = Me.redIAdd(Me);
    var Ie = this.z.redAdd(me).redSqr().redISub(de).redISub(xe);
    return this.curve.jpoint(Ee, Me, Ie);
  }, te.prototype.mul = function(ie, se) {
    return ie = new e(ie, se), this.curve._wnafMul(this, ie);
  }, te.prototype.eq = function(ie) {
    if (ie.type === "affine")
      return this.eq(ie.toJ());
    if (this === ie)
      return !0;
    var se = this.z.redSqr(), de = ie.z.redSqr();
    if (this.x.redMul(de).redISub(ie.x.redMul(se)).cmpn(0) !== 0)
      return !1;
    var ue = se.redMul(this.z), fe = de.redMul(ie.z);
    return this.y.redMul(fe).redISub(ie.y.redMul(ue)).cmpn(0) === 0;
  }, te.prototype.eqXToP = function(ie) {
    var se = this.z.redSqr(), de = ie.toRed(this.curve.red).redMul(se);
    if (this.x.cmp(de) === 0)
      return !0;
    for (var ue = ie.clone(), fe = this.curve.redN.redMul(se); ; ) {
      if (ue.iadd(this.curve.n), ue.cmp(this.curve.p) >= 0)
        return !1;
      if (de.redIAdd(fe), this.x.cmp(de) === 0)
        return !0;
    }
  }, te.prototype.inspect = function() {
    return this.isInfinity() ? "<EC JPoint Infinity>" : "<EC JPoint x: " + this.x.toString(16, 2) + " y: " + this.y.toString(16, 2) + " z: " + this.z.toString(16, 2) + ">";
  }, te.prototype.isInfinity = function() {
    return this.z.cmpn(0) === 0;
  }, short;
}
var mont, hasRequiredMont;
function requireMont() {
  if (hasRequiredMont) return mont;
  hasRequiredMont = 1;
  var C = requireBn$3(), e = requireInherits_browser(), T = requireBase$1(), $ = requireUtils$1();
  function V(ee) {
    T.call(this, "mont", ee), this.a = new C(ee.a, 16).toRed(this.red), this.b = new C(ee.b, 16).toRed(this.red), this.i4 = new C(4).toRed(this.red).redInvm(), this.two = new C(2).toRed(this.red), this.a24 = this.i4.redMul(this.a.redAdd(this.two));
  }
  e(V, T), mont = V, V.prototype.validate = function(te) {
    var re = te.normalize().x, ie = re.redSqr(), se = ie.redMul(re).redAdd(ie.redMul(this.a)).redAdd(re), de = se.redSqrt();
    return de.redSqr().cmp(se) === 0;
  };
  function J(ee, te, re) {
    T.BasePoint.call(this, ee, "projective"), te === null && re === null ? (this.x = this.curve.one, this.z = this.curve.zero) : (this.x = new C(te, 16), this.z = new C(re, 16), this.x.red || (this.x = this.x.toRed(this.curve.red)), this.z.red || (this.z = this.z.toRed(this.curve.red)));
  }
  return e(J, T.BasePoint), V.prototype.decodePoint = function(te, re) {
    return this.point($.toArray(te, re), 1);
  }, V.prototype.point = function(te, re) {
    return new J(this, te, re);
  }, V.prototype.pointFromJSON = function(te) {
    return J.fromJSON(this, te);
  }, J.prototype.precompute = function() {
  }, J.prototype._encode = function() {
    return this.getX().toArray("be", this.curve.p.byteLength());
  }, J.fromJSON = function(te, re) {
    return new J(te, re[0], re[1] || te.one);
  }, J.prototype.inspect = function() {
    return this.isInfinity() ? "<EC Point Infinity>" : "<EC Point x: " + this.x.fromRed().toString(16, 2) + " z: " + this.z.fromRed().toString(16, 2) + ">";
  }, J.prototype.isInfinity = function() {
    return this.z.cmpn(0) === 0;
  }, J.prototype.dbl = function() {
    var te = this.x.redAdd(this.z), re = te.redSqr(), ie = this.x.redSub(this.z), se = ie.redSqr(), de = re.redSub(se), ue = re.redMul(se), fe = de.redMul(se.redAdd(this.curve.a24.redMul(de)));
    return this.curve.point(ue, fe);
  }, J.prototype.add = function() {
    throw new Error("Not supported on Montgomery curve");
  }, J.prototype.diffAdd = function(te, re) {
    var ie = this.x.redAdd(this.z), se = this.x.redSub(this.z), de = te.x.redAdd(te.z), ue = te.x.redSub(te.z), fe = ue.redMul(ie), he = de.redMul(se), me = re.z.redMul(fe.redAdd(he).redSqr()), xe = re.x.redMul(fe.redISub(he).redSqr());
    return this.curve.point(me, xe);
  }, J.prototype.mul = function(te) {
    for (var re = te.clone(), ie = this, se = this.curve.point(null, null), de = this, ue = []; re.cmpn(0) !== 0; re.iushrn(1))
      ue.push(re.andln(1));
    for (var fe = ue.length - 1; fe >= 0; fe--)
      ue[fe] === 0 ? (ie = ie.diffAdd(se, de), se = se.dbl()) : (se = ie.diffAdd(se, de), ie = ie.dbl());
    return se;
  }, J.prototype.mulAdd = function() {
    throw new Error("Not supported on Montgomery curve");
  }, J.prototype.jumlAdd = function() {
    throw new Error("Not supported on Montgomery curve");
  }, J.prototype.eq = function(te) {
    return this.getX().cmp(te.getX()) === 0;
  }, J.prototype.normalize = function() {
    return this.x = this.x.redMul(this.z.redInvm()), this.z = this.curve.one, this;
  }, J.prototype.getX = function() {
    return this.normalize(), this.x.fromRed();
  }, mont;
}
var edwards, hasRequiredEdwards;
function requireEdwards() {
  if (hasRequiredEdwards) return edwards;
  hasRequiredEdwards = 1;
  var C = requireUtils$1(), e = requireBn$3(), T = requireInherits_browser(), $ = requireBase$1(), V = C.assert;
  function J(te) {
    this.twisted = (te.a | 0) !== 1, this.mOneA = this.twisted && (te.a | 0) === -1, this.extended = this.mOneA, $.call(this, "edwards", te), this.a = new e(te.a, 16).umod(this.red.m), this.a = this.a.toRed(this.red), this.c = new e(te.c, 16).toRed(this.red), this.c2 = this.c.redSqr(), this.d = new e(te.d, 16).toRed(this.red), this.dd = this.d.redAdd(this.d), V(!this.twisted || this.c.fromRed().cmpn(1) === 0), this.oneC = (te.c | 0) === 1;
  }
  T(J, $), edwards = J, J.prototype._mulA = function(re) {
    return this.mOneA ? re.redNeg() : this.a.redMul(re);
  }, J.prototype._mulC = function(re) {
    return this.oneC ? re : this.c.redMul(re);
  }, J.prototype.jpoint = function(re, ie, se, de) {
    return this.point(re, ie, se, de);
  }, J.prototype.pointFromX = function(re, ie) {
    re = new e(re, 16), re.red || (re = re.toRed(this.red));
    var se = re.redSqr(), de = this.c2.redSub(this.a.redMul(se)), ue = this.one.redSub(this.c2.redMul(this.d).redMul(se)), fe = de.redMul(ue.redInvm()), he = fe.redSqrt();
    if (he.redSqr().redSub(fe).cmp(this.zero) !== 0)
      throw new Error("invalid point");
    var me = he.fromRed().isOdd();
    return (ie && !me || !ie && me) && (he = he.redNeg()), this.point(re, he);
  }, J.prototype.pointFromY = function(re, ie) {
    re = new e(re, 16), re.red || (re = re.toRed(this.red));
    var se = re.redSqr(), de = se.redSub(this.c2), ue = se.redMul(this.d).redMul(this.c2).redSub(this.a), fe = de.redMul(ue.redInvm());
    if (fe.cmp(this.zero) === 0) {
      if (ie)
        throw new Error("invalid point");
      return this.point(this.zero, re);
    }
    var he = fe.redSqrt();
    if (he.redSqr().redSub(fe).cmp(this.zero) !== 0)
      throw new Error("invalid point");
    return he.fromRed().isOdd() !== ie && (he = he.redNeg()), this.point(he, re);
  }, J.prototype.validate = function(re) {
    if (re.isInfinity())
      return !0;
    re.normalize();
    var ie = re.x.redSqr(), se = re.y.redSqr(), de = ie.redMul(this.a).redAdd(se), ue = this.c2.redMul(this.one.redAdd(this.d.redMul(ie).redMul(se)));
    return de.cmp(ue) === 0;
  };
  function ee(te, re, ie, se, de) {
    $.BasePoint.call(this, te, "projective"), re === null && ie === null && se === null ? (this.x = this.curve.zero, this.y = this.curve.one, this.z = this.curve.one, this.t = this.curve.zero, this.zOne = !0) : (this.x = new e(re, 16), this.y = new e(ie, 16), this.z = se ? new e(se, 16) : this.curve.one, this.t = de && new e(de, 16), this.x.red || (this.x = this.x.toRed(this.curve.red)), this.y.red || (this.y = this.y.toRed(this.curve.red)), this.z.red || (this.z = this.z.toRed(this.curve.red)), this.t && !this.t.red && (this.t = this.t.toRed(this.curve.red)), this.zOne = this.z === this.curve.one, this.curve.extended && !this.t && (this.t = this.x.redMul(this.y), this.zOne || (this.t = this.t.redMul(this.z.redInvm()))));
  }
  return T(ee, $.BasePoint), J.prototype.pointFromJSON = function(re) {
    return ee.fromJSON(this, re);
  }, J.prototype.point = function(re, ie, se, de) {
    return new ee(this, re, ie, se, de);
  }, ee.fromJSON = function(re, ie) {
    return new ee(re, ie[0], ie[1], ie[2]);
  }, ee.prototype.inspect = function() {
    return this.isInfinity() ? "<EC Point Infinity>" : "<EC Point x: " + this.x.fromRed().toString(16, 2) + " y: " + this.y.fromRed().toString(16, 2) + " z: " + this.z.fromRed().toString(16, 2) + ">";
  }, ee.prototype.isInfinity = function() {
    return this.x.cmpn(0) === 0 && (this.y.cmp(this.z) === 0 || this.zOne && this.y.cmp(this.curve.c) === 0);
  }, ee.prototype._extDbl = function() {
    var re = this.x.redSqr(), ie = this.y.redSqr(), se = this.z.redSqr();
    se = se.redIAdd(se);
    var de = this.curve._mulA(re), ue = this.x.redAdd(this.y).redSqr().redISub(re).redISub(ie), fe = de.redAdd(ie), he = fe.redSub(se), me = de.redSub(ie), xe = ue.redMul(he), ve = fe.redMul(me), Te = ue.redMul(me), we = he.redMul(fe);
    return this.curve.point(xe, ve, we, Te);
  }, ee.prototype._projDbl = function() {
    var re = this.x.redAdd(this.y).redSqr(), ie = this.x.redSqr(), se = this.y.redSqr(), de, ue, fe, he, me, xe;
    if (this.curve.twisted) {
      he = this.curve._mulA(ie);
      var ve = he.redAdd(se);
      this.zOne ? (de = re.redSub(ie).redSub(se).redMul(ve.redSub(this.curve.two)), ue = ve.redMul(he.redSub(se)), fe = ve.redSqr().redSub(ve).redSub(ve)) : (me = this.z.redSqr(), xe = ve.redSub(me).redISub(me), de = re.redSub(ie).redISub(se).redMul(xe), ue = ve.redMul(he.redSub(se)), fe = ve.redMul(xe));
    } else
      he = ie.redAdd(se), me = this.curve._mulC(this.z).redSqr(), xe = he.redSub(me).redSub(me), de = this.curve._mulC(re.redISub(he)).redMul(xe), ue = this.curve._mulC(he).redMul(ie.redISub(se)), fe = he.redMul(xe);
    return this.curve.point(de, ue, fe);
  }, ee.prototype.dbl = function() {
    return this.isInfinity() ? this : this.curve.extended ? this._extDbl() : this._projDbl();
  }, ee.prototype._extAdd = function(re) {
    var ie = this.y.redSub(this.x).redMul(re.y.redSub(re.x)), se = this.y.redAdd(this.x).redMul(re.y.redAdd(re.x)), de = this.t.redMul(this.curve.dd).redMul(re.t), ue = this.z.redMul(re.z.redAdd(re.z)), fe = se.redSub(ie), he = ue.redSub(de), me = ue.redAdd(de), xe = se.redAdd(ie), ve = fe.redMul(he), Te = me.redMul(xe), we = fe.redMul(xe), Ee = he.redMul(me);
    return this.curve.point(ve, Te, Ee, we);
  }, ee.prototype._projAdd = function(re) {
    var ie = this.z.redMul(re.z), se = ie.redSqr(), de = this.x.redMul(re.x), ue = this.y.redMul(re.y), fe = this.curve.d.redMul(de).redMul(ue), he = se.redSub(fe), me = se.redAdd(fe), xe = this.x.redAdd(this.y).redMul(re.x.redAdd(re.y)).redISub(de).redISub(ue), ve = ie.redMul(he).redMul(xe), Te, we;
    return this.curve.twisted ? (Te = ie.redMul(me).redMul(ue.redSub(this.curve._mulA(de))), we = he.redMul(me)) : (Te = ie.redMul(me).redMul(ue.redSub(de)), we = this.curve._mulC(he).redMul(me)), this.curve.point(ve, Te, we);
  }, ee.prototype.add = function(re) {
    return this.isInfinity() ? re : re.isInfinity() ? this : this.curve.extended ? this._extAdd(re) : this._projAdd(re);
  }, ee.prototype.mul = function(re) {
    return this._hasDoubles(re) ? this.curve._fixedNafMul(this, re) : this.curve._wnafMul(this, re);
  }, ee.prototype.mulAdd = function(re, ie, se) {
    return this.curve._wnafMulAdd(1, [this, ie], [re, se], 2, !1);
  }, ee.prototype.jmulAdd = function(re, ie, se) {
    return this.curve._wnafMulAdd(1, [this, ie], [re, se], 2, !0);
  }, ee.prototype.normalize = function() {
    if (this.zOne)
      return this;
    var re = this.z.redInvm();
    return this.x = this.x.redMul(re), this.y = this.y.redMul(re), this.t && (this.t = this.t.redMul(re)), this.z = this.curve.one, this.zOne = !0, this;
  }, ee.prototype.neg = function() {
    return this.curve.point(
      this.x.redNeg(),
      this.y,
      this.z,
      this.t && this.t.redNeg()
    );
  }, ee.prototype.getX = function() {
    return this.normalize(), this.x.fromRed();
  }, ee.prototype.getY = function() {
    return this.normalize(), this.y.fromRed();
  }, ee.prototype.eq = function(re) {
    return this === re || this.getX().cmp(re.getX()) === 0 && this.getY().cmp(re.getY()) === 0;
  }, ee.prototype.eqXToP = function(re) {
    var ie = re.toRed(this.curve.red).redMul(this.z);
    if (this.x.cmp(ie) === 0)
      return !0;
    for (var se = re.clone(), de = this.curve.redN.redMul(this.z); ; ) {
      if (se.iadd(this.curve.n), se.cmp(this.curve.p) >= 0)
        return !1;
      if (ie.redIAdd(de), this.x.cmp(ie) === 0)
        return !0;
    }
  }, ee.prototype.toP = ee.prototype.normalize, ee.prototype.mixedAdd = ee.prototype.add, edwards;
}
var hasRequiredCurve;
function requireCurve() {
  return hasRequiredCurve || (hasRequiredCurve = 1, function(C) {
    var e = C;
    e.base = requireBase$1(), e.short = requireShort(), e.mont = requireMont(), e.edwards = requireEdwards();
  }(curve)), curve;
}
var curves = {}, hash$3 = {}, utils$2 = {}, hasRequiredUtils;
function requireUtils() {
  if (hasRequiredUtils) return utils$2;
  hasRequiredUtils = 1;
  var C = requireMinimalisticAssert(), e = requireInherits_browser();
  utils$2.inherits = e;
  function T(ne, oe) {
    return (ne.charCodeAt(oe) & 64512) !== 55296 || oe < 0 || oe + 1 >= ne.length ? !1 : (ne.charCodeAt(oe + 1) & 64512) === 56320;
  }
  function $(ne, oe) {
    if (Array.isArray(ne))
      return ne.slice();
    if (!ne)
      return [];
    var ce = [];
    if (typeof ne == "string")
      if (oe) {
        if (oe === "hex")
          for (ne = ne.replace(/[^a-z0-9]+/ig, ""), ne.length % 2 !== 0 && (ne = "0" + ne), pe = 0; pe < ne.length; pe += 2)
            ce.push(parseInt(ne[pe] + ne[pe + 1], 16));
      } else for (var le = 0, pe = 0; pe < ne.length; pe++) {
        var ye = ne.charCodeAt(pe);
        ye < 128 ? ce[le++] = ye : ye < 2048 ? (ce[le++] = ye >> 6 | 192, ce[le++] = ye & 63 | 128) : T(ne, pe) ? (ye = 65536 + ((ye & 1023) << 10) + (ne.charCodeAt(++pe) & 1023), ce[le++] = ye >> 18 | 240, ce[le++] = ye >> 12 & 63 | 128, ce[le++] = ye >> 6 & 63 | 128, ce[le++] = ye & 63 | 128) : (ce[le++] = ye >> 12 | 224, ce[le++] = ye >> 6 & 63 | 128, ce[le++] = ye & 63 | 128);
      }
    else
      for (pe = 0; pe < ne.length; pe++)
        ce[pe] = ne[pe] | 0;
    return ce;
  }
  utils$2.toArray = $;
  function V(ne) {
    for (var oe = "", ce = 0; ce < ne.length; ce++)
      oe += te(ne[ce].toString(16));
    return oe;
  }
  utils$2.toHex = V;
  function J(ne) {
    var oe = ne >>> 24 | ne >>> 8 & 65280 | ne << 8 & 16711680 | (ne & 255) << 24;
    return oe >>> 0;
  }
  utils$2.htonl = J;
  function ee(ne, oe) {
    for (var ce = "", le = 0; le < ne.length; le++) {
      var pe = ne[le];
      oe === "little" && (pe = J(pe)), ce += re(pe.toString(16));
    }
    return ce;
  }
  utils$2.toHex32 = ee;
  function te(ne) {
    return ne.length === 1 ? "0" + ne : ne;
  }
  utils$2.zero2 = te;
  function re(ne) {
    return ne.length === 7 ? "0" + ne : ne.length === 6 ? "00" + ne : ne.length === 5 ? "000" + ne : ne.length === 4 ? "0000" + ne : ne.length === 3 ? "00000" + ne : ne.length === 2 ? "000000" + ne : ne.length === 1 ? "0000000" + ne : ne;
  }
  utils$2.zero8 = re;
  function ie(ne, oe, ce, le) {
    var pe = ce - oe;
    C(pe % 4 === 0);
    for (var ye = new Array(pe / 4), Ce = 0, be = oe; Ce < ye.length; Ce++, be += 4) {
      var ae;
      le === "big" ? ae = ne[be] << 24 | ne[be + 1] << 16 | ne[be + 2] << 8 | ne[be + 3] : ae = ne[be + 3] << 24 | ne[be + 2] << 16 | ne[be + 1] << 8 | ne[be], ye[Ce] = ae >>> 0;
    }
    return ye;
  }
  utils$2.join32 = ie;
  function se(ne, oe) {
    for (var ce = new Array(ne.length * 4), le = 0, pe = 0; le < ne.length; le++, pe += 4) {
      var ye = ne[le];
      oe === "big" ? (ce[pe] = ye >>> 24, ce[pe + 1] = ye >>> 16 & 255, ce[pe + 2] = ye >>> 8 & 255, ce[pe + 3] = ye & 255) : (ce[pe + 3] = ye >>> 24, ce[pe + 2] = ye >>> 16 & 255, ce[pe + 1] = ye >>> 8 & 255, ce[pe] = ye & 255);
    }
    return ce;
  }
  utils$2.split32 = se;
  function de(ne, oe) {
    return ne >>> oe | ne << 32 - oe;
  }
  utils$2.rotr32 = de;
  function ue(ne, oe) {
    return ne << oe | ne >>> 32 - oe;
  }
  utils$2.rotl32 = ue;
  function fe(ne, oe) {
    return ne + oe >>> 0;
  }
  utils$2.sum32 = fe;
  function he(ne, oe, ce) {
    return ne + oe + ce >>> 0;
  }
  utils$2.sum32_3 = he;
  function me(ne, oe, ce, le) {
    return ne + oe + ce + le >>> 0;
  }
  utils$2.sum32_4 = me;
  function xe(ne, oe, ce, le, pe) {
    return ne + oe + ce + le + pe >>> 0;
  }
  utils$2.sum32_5 = xe;
  function ve(ne, oe, ce, le) {
    var pe = ne[oe], ye = ne[oe + 1], Ce = le + ye >>> 0, be = (Ce < le ? 1 : 0) + ce + pe;
    ne[oe] = be >>> 0, ne[oe + 1] = Ce;
  }
  utils$2.sum64 = ve;
  function Te(ne, oe, ce, le) {
    var pe = oe + le >>> 0, ye = (pe < oe ? 1 : 0) + ne + ce;
    return ye >>> 0;
  }
  utils$2.sum64_hi = Te;
  function we(ne, oe, ce, le) {
    var pe = oe + le;
    return pe >>> 0;
  }
  utils$2.sum64_lo = we;
  function Ee(ne, oe, ce, le, pe, ye, Ce, be) {
    var ae = 0, ge = oe;
    ge = ge + le >>> 0, ae += ge < oe ? 1 : 0, ge = ge + ye >>> 0, ae += ge < ye ? 1 : 0, ge = ge + be >>> 0, ae += ge < be ? 1 : 0;
    var Se = ne + ce + pe + Ce + ae;
    return Se >>> 0;
  }
  utils$2.sum64_4_hi = Ee;
  function Me(ne, oe, ce, le, pe, ye, Ce, be) {
    var ae = oe + le + ye + be;
    return ae >>> 0;
  }
  utils$2.sum64_4_lo = Me;
  function Ie(ne, oe, ce, le, pe, ye, Ce, be, ae, ge) {
    var Se = 0, Le = oe;
    Le = Le + le >>> 0, Se += Le < oe ? 1 : 0, Le = Le + ye >>> 0, Se += Le < ye ? 1 : 0, Le = Le + be >>> 0, Se += Le < be ? 1 : 0, Le = Le + ge >>> 0, Se += Le < ge ? 1 : 0;
    var ze = ne + ce + pe + Ce + ae + Se;
    return ze >>> 0;
  }
  utils$2.sum64_5_hi = Ie;
  function ke(ne, oe, ce, le, pe, ye, Ce, be, ae, ge) {
    var Se = oe + le + ye + be + ge;
    return Se >>> 0;
  }
  utils$2.sum64_5_lo = ke;
  function _e(ne, oe, ce) {
    var le = oe << 32 - ce | ne >>> ce;
    return le >>> 0;
  }
  utils$2.rotr64_hi = _e;
  function De(ne, oe, ce) {
    var le = ne << 32 - ce | oe >>> ce;
    return le >>> 0;
  }
  utils$2.rotr64_lo = De;
  function Fe(ne, oe, ce) {
    return ne >>> ce;
  }
  utils$2.shr64_hi = Fe;
  function Ae(ne, oe, ce) {
    var le = ne << 32 - ce | oe >>> ce;
    return le >>> 0;
  }
  return utils$2.shr64_lo = Ae, utils$2;
}
var common$2 = {}, hasRequiredCommon$1;
function requireCommon$1() {
  if (hasRequiredCommon$1) return common$2;
  hasRequiredCommon$1 = 1;
  var C = requireUtils(), e = requireMinimalisticAssert();
  function T() {
    this.pending = null, this.pendingTotal = 0, this.blockSize = this.constructor.blockSize, this.outSize = this.constructor.outSize, this.hmacStrength = this.constructor.hmacStrength, this.padLength = this.constructor.padLength / 8, this.endian = "big", this._delta8 = this.blockSize / 8, this._delta32 = this.blockSize / 32;
  }
  return common$2.BlockHash = T, T.prototype.update = function(V, J) {
    if (V = C.toArray(V, J), this.pending ? this.pending = this.pending.concat(V) : this.pending = V, this.pendingTotal += V.length, this.pending.length >= this._delta8) {
      V = this.pending;
      var ee = V.length % this._delta8;
      this.pending = V.slice(V.length - ee, V.length), this.pending.length === 0 && (this.pending = null), V = C.join32(V, 0, V.length - ee, this.endian);
      for (var te = 0; te < V.length; te += this._delta32)
        this._update(V, te, te + this._delta32);
    }
    return this;
  }, T.prototype.digest = function(V) {
    return this.update(this._pad()), e(this.pending === null), this._digest(V);
  }, T.prototype._pad = function() {
    var V = this.pendingTotal, J = this._delta8, ee = J - (V + this.padLength) % J, te = new Array(ee + this.padLength);
    te[0] = 128;
    for (var re = 1; re < ee; re++)
      te[re] = 0;
    if (V <<= 3, this.endian === "big") {
      for (var ie = 8; ie < this.padLength; ie++)
        te[re++] = 0;
      te[re++] = 0, te[re++] = 0, te[re++] = 0, te[re++] = 0, te[re++] = V >>> 24 & 255, te[re++] = V >>> 16 & 255, te[re++] = V >>> 8 & 255, te[re++] = V & 255;
    } else
      for (te[re++] = V & 255, te[re++] = V >>> 8 & 255, te[re++] = V >>> 16 & 255, te[re++] = V >>> 24 & 255, te[re++] = 0, te[re++] = 0, te[re++] = 0, te[re++] = 0, ie = 8; ie < this.padLength; ie++)
        te[re++] = 0;
    return te;
  }, common$2;
}
var sha = {}, common$1 = {}, hasRequiredCommon;
function requireCommon() {
  if (hasRequiredCommon) return common$1;
  hasRequiredCommon = 1;
  var C = requireUtils(), e = C.rotr32;
  function T(se, de, ue, fe) {
    if (se === 0)
      return $(de, ue, fe);
    if (se === 1 || se === 3)
      return J(de, ue, fe);
    if (se === 2)
      return V(de, ue, fe);
  }
  common$1.ft_1 = T;
  function $(se, de, ue) {
    return se & de ^ ~se & ue;
  }
  common$1.ch32 = $;
  function V(se, de, ue) {
    return se & de ^ se & ue ^ de & ue;
  }
  common$1.maj32 = V;
  function J(se, de, ue) {
    return se ^ de ^ ue;
  }
  common$1.p32 = J;
  function ee(se) {
    return e(se, 2) ^ e(se, 13) ^ e(se, 22);
  }
  common$1.s0_256 = ee;
  function te(se) {
    return e(se, 6) ^ e(se, 11) ^ e(se, 25);
  }
  common$1.s1_256 = te;
  function re(se) {
    return e(se, 7) ^ e(se, 18) ^ se >>> 3;
  }
  common$1.g0_256 = re;
  function ie(se) {
    return e(se, 17) ^ e(se, 19) ^ se >>> 10;
  }
  return common$1.g1_256 = ie, common$1;
}
var _1, hasRequired_1;
function require_1() {
  if (hasRequired_1) return _1;
  hasRequired_1 = 1;
  var C = requireUtils(), e = requireCommon$1(), T = requireCommon(), $ = C.rotl32, V = C.sum32, J = C.sum32_5, ee = T.ft_1, te = e.BlockHash, re = [
    1518500249,
    1859775393,
    2400959708,
    3395469782
  ];
  function ie() {
    if (!(this instanceof ie))
      return new ie();
    te.call(this), this.h = [
      1732584193,
      4023233417,
      2562383102,
      271733878,
      3285377520
    ], this.W = new Array(80);
  }
  return C.inherits(ie, te), _1 = ie, ie.blockSize = 512, ie.outSize = 160, ie.hmacStrength = 80, ie.padLength = 64, ie.prototype._update = function(de, ue) {
    for (var fe = this.W, he = 0; he < 16; he++)
      fe[he] = de[ue + he];
    for (; he < fe.length; he++)
      fe[he] = $(fe[he - 3] ^ fe[he - 8] ^ fe[he - 14] ^ fe[he - 16], 1);
    var me = this.h[0], xe = this.h[1], ve = this.h[2], Te = this.h[3], we = this.h[4];
    for (he = 0; he < fe.length; he++) {
      var Ee = ~~(he / 20), Me = J($(me, 5), ee(Ee, xe, ve, Te), we, fe[he], re[Ee]);
      we = Te, Te = ve, ve = $(xe, 30), xe = me, me = Me;
    }
    this.h[0] = V(this.h[0], me), this.h[1] = V(this.h[1], xe), this.h[2] = V(this.h[2], ve), this.h[3] = V(this.h[3], Te), this.h[4] = V(this.h[4], we);
  }, ie.prototype._digest = function(de) {
    return de === "hex" ? C.toHex32(this.h, "big") : C.split32(this.h, "big");
  }, _1;
}
var _256, hasRequired_256;
function require_256() {
  if (hasRequired_256) return _256;
  hasRequired_256 = 1;
  var C = requireUtils(), e = requireCommon$1(), T = requireCommon(), $ = requireMinimalisticAssert(), V = C.sum32, J = C.sum32_4, ee = C.sum32_5, te = T.ch32, re = T.maj32, ie = T.s0_256, se = T.s1_256, de = T.g0_256, ue = T.g1_256, fe = e.BlockHash, he = [
    1116352408,
    1899447441,
    3049323471,
    3921009573,
    961987163,
    1508970993,
    2453635748,
    2870763221,
    3624381080,
    310598401,
    607225278,
    1426881987,
    1925078388,
    2162078206,
    2614888103,
    3248222580,
    3835390401,
    4022224774,
    264347078,
    604807628,
    770255983,
    1249150122,
    1555081692,
    1996064986,
    2554220882,
    2821834349,
    2952996808,
    3210313671,
    3336571891,
    3584528711,
    113926993,
    338241895,
    666307205,
    773529912,
    1294757372,
    1396182291,
    1695183700,
    1986661051,
    2177026350,
    2456956037,
    2730485921,
    2820302411,
    3259730800,
    3345764771,
    3516065817,
    3600352804,
    4094571909,
    275423344,
    430227734,
    506948616,
    659060556,
    883997877,
    958139571,
    1322822218,
    1537002063,
    1747873779,
    1955562222,
    2024104815,
    2227730452,
    2361852424,
    2428436474,
    2756734187,
    3204031479,
    3329325298
  ];
  function me() {
    if (!(this instanceof me))
      return new me();
    fe.call(this), this.h = [
      1779033703,
      3144134277,
      1013904242,
      2773480762,
      1359893119,
      2600822924,
      528734635,
      1541459225
    ], this.k = he, this.W = new Array(64);
  }
  return C.inherits(me, fe), _256 = me, me.blockSize = 512, me.outSize = 256, me.hmacStrength = 192, me.padLength = 64, me.prototype._update = function(ve, Te) {
    for (var we = this.W, Ee = 0; Ee < 16; Ee++)
      we[Ee] = ve[Te + Ee];
    for (; Ee < we.length; Ee++)
      we[Ee] = J(ue(we[Ee - 2]), we[Ee - 7], de(we[Ee - 15]), we[Ee - 16]);
    var Me = this.h[0], Ie = this.h[1], ke = this.h[2], _e = this.h[3], De = this.h[4], Fe = this.h[5], Ae = this.h[6], ne = this.h[7];
    for ($(this.k.length === we.length), Ee = 0; Ee < we.length; Ee++) {
      var oe = ee(ne, se(De), te(De, Fe, Ae), this.k[Ee], we[Ee]), ce = V(ie(Me), re(Me, Ie, ke));
      ne = Ae, Ae = Fe, Fe = De, De = V(_e, oe), _e = ke, ke = Ie, Ie = Me, Me = V(oe, ce);
    }
    this.h[0] = V(this.h[0], Me), this.h[1] = V(this.h[1], Ie), this.h[2] = V(this.h[2], ke), this.h[3] = V(this.h[3], _e), this.h[4] = V(this.h[4], De), this.h[5] = V(this.h[5], Fe), this.h[6] = V(this.h[6], Ae), this.h[7] = V(this.h[7], ne);
  }, me.prototype._digest = function(ve) {
    return ve === "hex" ? C.toHex32(this.h, "big") : C.split32(this.h, "big");
  }, _256;
}
var _224, hasRequired_224;
function require_224() {
  if (hasRequired_224) return _224;
  hasRequired_224 = 1;
  var C = requireUtils(), e = require_256();
  function T() {
    if (!(this instanceof T))
      return new T();
    e.call(this), this.h = [
      3238371032,
      914150663,
      812702999,
      4144912697,
      4290775857,
      1750603025,
      1694076839,
      3204075428
    ];
  }
  return C.inherits(T, e), _224 = T, T.blockSize = 512, T.outSize = 224, T.hmacStrength = 192, T.padLength = 64, T.prototype._digest = function(V) {
    return V === "hex" ? C.toHex32(this.h.slice(0, 7), "big") : C.split32(this.h.slice(0, 7), "big");
  }, _224;
}
var _512, hasRequired_512;
function require_512() {
  if (hasRequired_512) return _512;
  hasRequired_512 = 1;
  var C = requireUtils(), e = requireCommon$1(), T = requireMinimalisticAssert(), $ = C.rotr64_hi, V = C.rotr64_lo, J = C.shr64_hi, ee = C.shr64_lo, te = C.sum64, re = C.sum64_hi, ie = C.sum64_lo, se = C.sum64_4_hi, de = C.sum64_4_lo, ue = C.sum64_5_hi, fe = C.sum64_5_lo, he = e.BlockHash, me = [
    1116352408,
    3609767458,
    1899447441,
    602891725,
    3049323471,
    3964484399,
    3921009573,
    2173295548,
    961987163,
    4081628472,
    1508970993,
    3053834265,
    2453635748,
    2937671579,
    2870763221,
    3664609560,
    3624381080,
    2734883394,
    310598401,
    1164996542,
    607225278,
    1323610764,
    1426881987,
    3590304994,
    1925078388,
    4068182383,
    2162078206,
    991336113,
    2614888103,
    633803317,
    3248222580,
    3479774868,
    3835390401,
    2666613458,
    4022224774,
    944711139,
    264347078,
    2341262773,
    604807628,
    2007800933,
    770255983,
    1495990901,
    1249150122,
    1856431235,
    1555081692,
    3175218132,
    1996064986,
    2198950837,
    2554220882,
    3999719339,
    2821834349,
    766784016,
    2952996808,
    2566594879,
    3210313671,
    3203337956,
    3336571891,
    1034457026,
    3584528711,
    2466948901,
    113926993,
    3758326383,
    338241895,
    168717936,
    666307205,
    1188179964,
    773529912,
    1546045734,
    1294757372,
    1522805485,
    1396182291,
    2643833823,
    1695183700,
    2343527390,
    1986661051,
    1014477480,
    2177026350,
    1206759142,
    2456956037,
    344077627,
    2730485921,
    1290863460,
    2820302411,
    3158454273,
    3259730800,
    3505952657,
    3345764771,
    106217008,
    3516065817,
    3606008344,
    3600352804,
    1432725776,
    4094571909,
    1467031594,
    275423344,
    851169720,
    430227734,
    3100823752,
    506948616,
    1363258195,
    659060556,
    3750685593,
    883997877,
    3785050280,
    958139571,
    3318307427,
    1322822218,
    3812723403,
    1537002063,
    2003034995,
    1747873779,
    3602036899,
    1955562222,
    1575990012,
    2024104815,
    1125592928,
    2227730452,
    2716904306,
    2361852424,
    442776044,
    2428436474,
    593698344,
    2756734187,
    3733110249,
    3204031479,
    2999351573,
    3329325298,
    3815920427,
    3391569614,
    3928383900,
    3515267271,
    566280711,
    3940187606,
    3454069534,
    4118630271,
    4000239992,
    116418474,
    1914138554,
    174292421,
    2731055270,
    289380356,
    3203993006,
    460393269,
    320620315,
    685471733,
    587496836,
    852142971,
    1086792851,
    1017036298,
    365543100,
    1126000580,
    2618297676,
    1288033470,
    3409855158,
    1501505948,
    4234509866,
    1607167915,
    987167468,
    1816402316,
    1246189591
  ];
  function xe() {
    if (!(this instanceof xe))
      return new xe();
    he.call(this), this.h = [
      1779033703,
      4089235720,
      3144134277,
      2227873595,
      1013904242,
      4271175723,
      2773480762,
      1595750129,
      1359893119,
      2917565137,
      2600822924,
      725511199,
      528734635,
      4215389547,
      1541459225,
      327033209
    ], this.k = me, this.W = new Array(160);
  }
  C.inherits(xe, he), _512 = xe, xe.blockSize = 1024, xe.outSize = 512, xe.hmacStrength = 192, xe.padLength = 128, xe.prototype._prepareBlock = function(ce, le) {
    for (var pe = this.W, ye = 0; ye < 32; ye++)
      pe[ye] = ce[le + ye];
    for (; ye < pe.length; ye += 2) {
      var Ce = Ae(pe[ye - 4], pe[ye - 3]), be = ne(pe[ye - 4], pe[ye - 3]), ae = pe[ye - 14], ge = pe[ye - 13], Se = De(pe[ye - 30], pe[ye - 29]), Le = Fe(pe[ye - 30], pe[ye - 29]), ze = pe[ye - 32], Re = pe[ye - 31];
      pe[ye] = se(
        Ce,
        be,
        ae,
        ge,
        Se,
        Le,
        ze,
        Re
      ), pe[ye + 1] = de(
        Ce,
        be,
        ae,
        ge,
        Se,
        Le,
        ze,
        Re
      );
    }
  }, xe.prototype._update = function(ce, le) {
    this._prepareBlock(ce, le);
    var pe = this.W, ye = this.h[0], Ce = this.h[1], be = this.h[2], ae = this.h[3], ge = this.h[4], Se = this.h[5], Le = this.h[6], ze = this.h[7], Re = this.h[8], We = this.h[9], Be = this.h[10], Ue = this.h[11], Ge = this.h[12], je = this.h[13], Oe = this.h[14], Ne = this.h[15];
    T(this.k.length === pe.length);
    for (var Ye = 0; Ye < pe.length; Ye += 2) {
      var Je = Oe, Xe = Ne, st = ke(Re, We), ct = _e(Re, We), it = ve(Re, We, Be, Ue, Ge), ot = Te(Re, We, Be, Ue, Ge, je), yt = this.k[Ye], dt = this.k[Ye + 1], mt = pe[Ye], It = pe[Ye + 1], xt = ue(
        Je,
        Xe,
        st,
        ct,
        it,
        ot,
        yt,
        dt,
        mt,
        It
      ), Tt = fe(
        Je,
        Xe,
        st,
        ct,
        it,
        ot,
        yt,
        dt,
        mt,
        It
      );
      Je = Me(ye, Ce), Xe = Ie(ye, Ce), st = we(ye, Ce, be, ae, ge), ct = Ee(ye, Ce, be, ae, ge, Se);
      var Yt = re(Je, Xe, st, ct), Ve = ie(Je, Xe, st, ct);
      Oe = Ge, Ne = je, Ge = Be, je = Ue, Be = Re, Ue = We, Re = re(Le, ze, xt, Tt), We = ie(ze, ze, xt, Tt), Le = ge, ze = Se, ge = be, Se = ae, be = ye, ae = Ce, ye = re(xt, Tt, Yt, Ve), Ce = ie(xt, Tt, Yt, Ve);
    }
    te(this.h, 0, ye, Ce), te(this.h, 2, be, ae), te(this.h, 4, ge, Se), te(this.h, 6, Le, ze), te(this.h, 8, Re, We), te(this.h, 10, Be, Ue), te(this.h, 12, Ge, je), te(this.h, 14, Oe, Ne);
  }, xe.prototype._digest = function(ce) {
    return ce === "hex" ? C.toHex32(this.h, "big") : C.split32(this.h, "big");
  };
  function ve(oe, ce, le, pe, ye) {
    var Ce = oe & le ^ ~oe & ye;
    return Ce < 0 && (Ce += 4294967296), Ce;
  }
  function Te(oe, ce, le, pe, ye, Ce) {
    var be = ce & pe ^ ~ce & Ce;
    return be < 0 && (be += 4294967296), be;
  }
  function we(oe, ce, le, pe, ye) {
    var Ce = oe & le ^ oe & ye ^ le & ye;
    return Ce < 0 && (Ce += 4294967296), Ce;
  }
  function Ee(oe, ce, le, pe, ye, Ce) {
    var be = ce & pe ^ ce & Ce ^ pe & Ce;
    return be < 0 && (be += 4294967296), be;
  }
  function Me(oe, ce) {
    var le = $(oe, ce, 28), pe = $(ce, oe, 2), ye = $(ce, oe, 7), Ce = le ^ pe ^ ye;
    return Ce < 0 && (Ce += 4294967296), Ce;
  }
  function Ie(oe, ce) {
    var le = V(oe, ce, 28), pe = V(ce, oe, 2), ye = V(ce, oe, 7), Ce = le ^ pe ^ ye;
    return Ce < 0 && (Ce += 4294967296), Ce;
  }
  function ke(oe, ce) {
    var le = $(oe, ce, 14), pe = $(oe, ce, 18), ye = $(ce, oe, 9), Ce = le ^ pe ^ ye;
    return Ce < 0 && (Ce += 4294967296), Ce;
  }
  function _e(oe, ce) {
    var le = V(oe, ce, 14), pe = V(oe, ce, 18), ye = V(ce, oe, 9), Ce = le ^ pe ^ ye;
    return Ce < 0 && (Ce += 4294967296), Ce;
  }
  function De(oe, ce) {
    var le = $(oe, ce, 1), pe = $(oe, ce, 8), ye = J(oe, ce, 7), Ce = le ^ pe ^ ye;
    return Ce < 0 && (Ce += 4294967296), Ce;
  }
  function Fe(oe, ce) {
    var le = V(oe, ce, 1), pe = V(oe, ce, 8), ye = ee(oe, ce, 7), Ce = le ^ pe ^ ye;
    return Ce < 0 && (Ce += 4294967296), Ce;
  }
  function Ae(oe, ce) {
    var le = $(oe, ce, 19), pe = $(ce, oe, 29), ye = J(oe, ce, 6), Ce = le ^ pe ^ ye;
    return Ce < 0 && (Ce += 4294967296), Ce;
  }
  function ne(oe, ce) {
    var le = V(oe, ce, 19), pe = V(ce, oe, 29), ye = ee(oe, ce, 6), Ce = le ^ pe ^ ye;
    return Ce < 0 && (Ce += 4294967296), Ce;
  }
  return _512;
}
var _384, hasRequired_384;
function require_384() {
  if (hasRequired_384) return _384;
  hasRequired_384 = 1;
  var C = requireUtils(), e = require_512();
  function T() {
    if (!(this instanceof T))
      return new T();
    e.call(this), this.h = [
      3418070365,
      3238371032,
      1654270250,
      914150663,
      2438529370,
      812702999,
      355462360,
      4144912697,
      1731405415,
      4290775857,
      2394180231,
      1750603025,
      3675008525,
      1694076839,
      1203062813,
      3204075428
    ];
  }
  return C.inherits(T, e), _384 = T, T.blockSize = 1024, T.outSize = 384, T.hmacStrength = 192, T.padLength = 128, T.prototype._digest = function(V) {
    return V === "hex" ? C.toHex32(this.h.slice(0, 12), "big") : C.split32(this.h.slice(0, 12), "big");
  }, _384;
}
var hasRequiredSha;
function requireSha() {
  return hasRequiredSha || (hasRequiredSha = 1, sha.sha1 = require_1(), sha.sha224 = require_224(), sha.sha256 = require_256(), sha.sha384 = require_384(), sha.sha512 = require_512()), sha;
}
var ripemd = {}, hasRequiredRipemd;
function requireRipemd() {
  if (hasRequiredRipemd) return ripemd;
  hasRequiredRipemd = 1;
  var C = requireUtils(), e = requireCommon$1(), T = C.rotl32, $ = C.sum32, V = C.sum32_3, J = C.sum32_4, ee = e.BlockHash;
  function te() {
    if (!(this instanceof te))
      return new te();
    ee.call(this), this.h = [1732584193, 4023233417, 2562383102, 271733878, 3285377520], this.endian = "little";
  }
  C.inherits(te, ee), ripemd.ripemd160 = te, te.blockSize = 512, te.outSize = 160, te.hmacStrength = 192, te.padLength = 64, te.prototype._update = function(xe, ve) {
    for (var Te = this.h[0], we = this.h[1], Ee = this.h[2], Me = this.h[3], Ie = this.h[4], ke = Te, _e = we, De = Ee, Fe = Me, Ae = Ie, ne = 0; ne < 80; ne++) {
      var oe = $(
        T(
          J(Te, re(ne, we, Ee, Me), xe[de[ne] + ve], ie(ne)),
          fe[ne]
        ),
        Ie
      );
      Te = Ie, Ie = Me, Me = T(Ee, 10), Ee = we, we = oe, oe = $(
        T(
          J(ke, re(79 - ne, _e, De, Fe), xe[ue[ne] + ve], se(ne)),
          he[ne]
        ),
        Ae
      ), ke = Ae, Ae = Fe, Fe = T(De, 10), De = _e, _e = oe;
    }
    oe = V(this.h[1], Ee, Fe), this.h[1] = V(this.h[2], Me, Ae), this.h[2] = V(this.h[3], Ie, ke), this.h[3] = V(this.h[4], Te, _e), this.h[4] = V(this.h[0], we, De), this.h[0] = oe;
  }, te.prototype._digest = function(xe) {
    return xe === "hex" ? C.toHex32(this.h, "little") : C.split32(this.h, "little");
  };
  function re(me, xe, ve, Te) {
    return me <= 15 ? xe ^ ve ^ Te : me <= 31 ? xe & ve | ~xe & Te : me <= 47 ? (xe | ~ve) ^ Te : me <= 63 ? xe & Te | ve & ~Te : xe ^ (ve | ~Te);
  }
  function ie(me) {
    return me <= 15 ? 0 : me <= 31 ? 1518500249 : me <= 47 ? 1859775393 : me <= 63 ? 2400959708 : 2840853838;
  }
  function se(me) {
    return me <= 15 ? 1352829926 : me <= 31 ? 1548603684 : me <= 47 ? 1836072691 : me <= 63 ? 2053994217 : 0;
  }
  var de = [
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15,
    7,
    4,
    13,
    1,
    10,
    6,
    15,
    3,
    12,
    0,
    9,
    5,
    2,
    14,
    11,
    8,
    3,
    10,
    14,
    4,
    9,
    15,
    8,
    1,
    2,
    7,
    0,
    6,
    13,
    11,
    5,
    12,
    1,
    9,
    11,
    10,
    0,
    8,
    12,
    4,
    13,
    3,
    7,
    15,
    14,
    5,
    6,
    2,
    4,
    0,
    5,
    9,
    7,
    12,
    2,
    10,
    14,
    1,
    3,
    8,
    11,
    6,
    15,
    13
  ], ue = [
    5,
    14,
    7,
    0,
    9,
    2,
    11,
    4,
    13,
    6,
    15,
    8,
    1,
    10,
    3,
    12,
    6,
    11,
    3,
    7,
    0,
    13,
    5,
    10,
    14,
    15,
    8,
    12,
    4,
    9,
    1,
    2,
    15,
    5,
    1,
    3,
    7,
    14,
    6,
    9,
    11,
    8,
    12,
    2,
    10,
    0,
    4,
    13,
    8,
    6,
    4,
    1,
    3,
    11,
    15,
    0,
    5,
    12,
    2,
    13,
    9,
    7,
    10,
    14,
    12,
    15,
    10,
    4,
    1,
    5,
    8,
    7,
    6,
    2,
    13,
    14,
    0,
    3,
    9,
    11
  ], fe = [
    11,
    14,
    15,
    12,
    5,
    8,
    7,
    9,
    11,
    13,
    14,
    15,
    6,
    7,
    9,
    8,
    7,
    6,
    8,
    13,
    11,
    9,
    7,
    15,
    7,
    12,
    15,
    9,
    11,
    7,
    13,
    12,
    11,
    13,
    6,
    7,
    14,
    9,
    13,
    15,
    14,
    8,
    13,
    6,
    5,
    12,
    7,
    5,
    11,
    12,
    14,
    15,
    14,
    15,
    9,
    8,
    9,
    14,
    5,
    6,
    8,
    6,
    5,
    12,
    9,
    15,
    5,
    11,
    6,
    8,
    13,
    12,
    5,
    12,
    13,
    14,
    11,
    8,
    5,
    6
  ], he = [
    8,
    9,
    9,
    11,
    13,
    15,
    15,
    5,
    7,
    7,
    8,
    11,
    14,
    14,
    12,
    6,
    9,
    13,
    15,
    7,
    12,
    8,
    9,
    11,
    7,
    7,
    12,
    7,
    6,
    15,
    13,
    11,
    9,
    7,
    15,
    11,
    8,
    6,
    6,
    14,
    12,
    13,
    5,
    14,
    13,
    13,
    7,
    5,
    15,
    5,
    8,
    11,
    14,
    14,
    6,
    14,
    6,
    9,
    12,
    9,
    12,
    5,
    15,
    8,
    8,
    5,
    12,
    9,
    12,
    5,
    14,
    6,
    8,
    13,
    6,
    5,
    15,
    13,
    11,
    11
  ];
  return ripemd;
}
var hmac, hasRequiredHmac;
function requireHmac() {
  if (hasRequiredHmac) return hmac;
  hasRequiredHmac = 1;
  var C = requireUtils(), e = requireMinimalisticAssert();
  function T($, V, J) {
    if (!(this instanceof T))
      return new T($, V, J);
    this.Hash = $, this.blockSize = $.blockSize / 8, this.outSize = $.outSize / 8, this.inner = null, this.outer = null, this._init(C.toArray(V, J));
  }
  return hmac = T, T.prototype._init = function(V) {
    V.length > this.blockSize && (V = new this.Hash().update(V).digest()), e(V.length <= this.blockSize);
    for (var J = V.length; J < this.blockSize; J++)
      V.push(0);
    for (J = 0; J < V.length; J++)
      V[J] ^= 54;
    for (this.inner = new this.Hash().update(V), J = 0; J < V.length; J++)
      V[J] ^= 106;
    this.outer = new this.Hash().update(V);
  }, T.prototype.update = function(V, J) {
    return this.inner.update(V, J), this;
  }, T.prototype.digest = function(V) {
    return this.outer.update(this.inner.digest()), this.outer.digest(V);
  }, hmac;
}
var hasRequiredHash;
function requireHash() {
  return hasRequiredHash || (hasRequiredHash = 1, function(C) {
    var e = C;
    e.utils = requireUtils(), e.common = requireCommon$1(), e.sha = requireSha(), e.ripemd = requireRipemd(), e.hmac = requireHmac(), e.sha1 = e.sha.sha1, e.sha256 = e.sha.sha256, e.sha224 = e.sha.sha224, e.sha384 = e.sha.sha384, e.sha512 = e.sha.sha512, e.ripemd160 = e.ripemd.ripemd160;
  }(hash$3)), hash$3;
}
var secp256k1, hasRequiredSecp256k1;
function requireSecp256k1() {
  return hasRequiredSecp256k1 || (hasRequiredSecp256k1 = 1, secp256k1 = {
    doubles: {
      step: 4,
      points: [
        [
          "e60fce93b59e9ec53011aabc21c23e97b2a31369b87a5ae9c44ee89e2a6dec0a",
          "f7e3507399e595929db99f34f57937101296891e44d23f0be1f32cce69616821"
        ],
        [
          "8282263212c609d9ea2a6e3e172de238d8c39cabd5ac1ca10646e23fd5f51508",
          "11f8a8098557dfe45e8256e830b60ace62d613ac2f7b17bed31b6eaff6e26caf"
        ],
        [
          "175e159f728b865a72f99cc6c6fc846de0b93833fd2222ed73fce5b551e5b739",
          "d3506e0d9e3c79eba4ef97a51ff71f5eacb5955add24345c6efa6ffee9fed695"
        ],
        [
          "363d90d447b00c9c99ceac05b6262ee053441c7e55552ffe526bad8f83ff4640",
          "4e273adfc732221953b445397f3363145b9a89008199ecb62003c7f3bee9de9"
        ],
        [
          "8b4b5f165df3c2be8c6244b5b745638843e4a781a15bcd1b69f79a55dffdf80c",
          "4aad0a6f68d308b4b3fbd7813ab0da04f9e336546162ee56b3eff0c65fd4fd36"
        ],
        [
          "723cbaa6e5db996d6bf771c00bd548c7b700dbffa6c0e77bcb6115925232fcda",
          "96e867b5595cc498a921137488824d6e2660a0653779494801dc069d9eb39f5f"
        ],
        [
          "eebfa4d493bebf98ba5feec812c2d3b50947961237a919839a533eca0e7dd7fa",
          "5d9a8ca3970ef0f269ee7edaf178089d9ae4cdc3a711f712ddfd4fdae1de8999"
        ],
        [
          "100f44da696e71672791d0a09b7bde459f1215a29b3c03bfefd7835b39a48db0",
          "cdd9e13192a00b772ec8f3300c090666b7ff4a18ff5195ac0fbd5cd62bc65a09"
        ],
        [
          "e1031be262c7ed1b1dc9227a4a04c017a77f8d4464f3b3852c8acde6e534fd2d",
          "9d7061928940405e6bb6a4176597535af292dd419e1ced79a44f18f29456a00d"
        ],
        [
          "feea6cae46d55b530ac2839f143bd7ec5cf8b266a41d6af52d5e688d9094696d",
          "e57c6b6c97dce1bab06e4e12bf3ecd5c981c8957cc41442d3155debf18090088"
        ],
        [
          "da67a91d91049cdcb367be4be6ffca3cfeed657d808583de33fa978bc1ec6cb1",
          "9bacaa35481642bc41f463f7ec9780e5dec7adc508f740a17e9ea8e27a68be1d"
        ],
        [
          "53904faa0b334cdda6e000935ef22151ec08d0f7bb11069f57545ccc1a37b7c0",
          "5bc087d0bc80106d88c9eccac20d3c1c13999981e14434699dcb096b022771c8"
        ],
        [
          "8e7bcd0bd35983a7719cca7764ca906779b53a043a9b8bcaeff959f43ad86047",
          "10b7770b2a3da4b3940310420ca9514579e88e2e47fd68b3ea10047e8460372a"
        ],
        [
          "385eed34c1cdff21e6d0818689b81bde71a7f4f18397e6690a841e1599c43862",
          "283bebc3e8ea23f56701de19e9ebf4576b304eec2086dc8cc0458fe5542e5453"
        ],
        [
          "6f9d9b803ecf191637c73a4413dfa180fddf84a5947fbc9c606ed86c3fac3a7",
          "7c80c68e603059ba69b8e2a30e45c4d47ea4dd2f5c281002d86890603a842160"
        ],
        [
          "3322d401243c4e2582a2147c104d6ecbf774d163db0f5e5313b7e0e742d0e6bd",
          "56e70797e9664ef5bfb019bc4ddaf9b72805f63ea2873af624f3a2e96c28b2a0"
        ],
        [
          "85672c7d2de0b7da2bd1770d89665868741b3f9af7643397721d74d28134ab83",
          "7c481b9b5b43b2eb6374049bfa62c2e5e77f17fcc5298f44c8e3094f790313a6"
        ],
        [
          "948bf809b1988a46b06c9f1919413b10f9226c60f668832ffd959af60c82a0a",
          "53a562856dcb6646dc6b74c5d1c3418c6d4dff08c97cd2bed4cb7f88d8c8e589"
        ],
        [
          "6260ce7f461801c34f067ce0f02873a8f1b0e44dfc69752accecd819f38fd8e8",
          "bc2da82b6fa5b571a7f09049776a1ef7ecd292238051c198c1a84e95b2b4ae17"
        ],
        [
          "e5037de0afc1d8d43d8348414bbf4103043ec8f575bfdc432953cc8d2037fa2d",
          "4571534baa94d3b5f9f98d09fb990bddbd5f5b03ec481f10e0e5dc841d755bda"
        ],
        [
          "e06372b0f4a207adf5ea905e8f1771b4e7e8dbd1c6a6c5b725866a0ae4fce725",
          "7a908974bce18cfe12a27bb2ad5a488cd7484a7787104870b27034f94eee31dd"
        ],
        [
          "213c7a715cd5d45358d0bbf9dc0ce02204b10bdde2a3f58540ad6908d0559754",
          "4b6dad0b5ae462507013ad06245ba190bb4850f5f36a7eeddff2c27534b458f2"
        ],
        [
          "4e7c272a7af4b34e8dbb9352a5419a87e2838c70adc62cddf0cc3a3b08fbd53c",
          "17749c766c9d0b18e16fd09f6def681b530b9614bff7dd33e0b3941817dcaae6"
        ],
        [
          "fea74e3dbe778b1b10f238ad61686aa5c76e3db2be43057632427e2840fb27b6",
          "6e0568db9b0b13297cf674deccb6af93126b596b973f7b77701d3db7f23cb96f"
        ],
        [
          "76e64113f677cf0e10a2570d599968d31544e179b760432952c02a4417bdde39",
          "c90ddf8dee4e95cf577066d70681f0d35e2a33d2b56d2032b4b1752d1901ac01"
        ],
        [
          "c738c56b03b2abe1e8281baa743f8f9a8f7cc643df26cbee3ab150242bcbb891",
          "893fb578951ad2537f718f2eacbfbbbb82314eef7880cfe917e735d9699a84c3"
        ],
        [
          "d895626548b65b81e264c7637c972877d1d72e5f3a925014372e9f6588f6c14b",
          "febfaa38f2bc7eae728ec60818c340eb03428d632bb067e179363ed75d7d991f"
        ],
        [
          "b8da94032a957518eb0f6433571e8761ceffc73693e84edd49150a564f676e03",
          "2804dfa44805a1e4d7c99cc9762808b092cc584d95ff3b511488e4e74efdf6e7"
        ],
        [
          "e80fea14441fb33a7d8adab9475d7fab2019effb5156a792f1a11778e3c0df5d",
          "eed1de7f638e00771e89768ca3ca94472d155e80af322ea9fcb4291b6ac9ec78"
        ],
        [
          "a301697bdfcd704313ba48e51d567543f2a182031efd6915ddc07bbcc4e16070",
          "7370f91cfb67e4f5081809fa25d40f9b1735dbf7c0a11a130c0d1a041e177ea1"
        ],
        [
          "90ad85b389d6b936463f9d0512678de208cc330b11307fffab7ac63e3fb04ed4",
          "e507a3620a38261affdcbd9427222b839aefabe1582894d991d4d48cb6ef150"
        ],
        [
          "8f68b9d2f63b5f339239c1ad981f162ee88c5678723ea3351b7b444c9ec4c0da",
          "662a9f2dba063986de1d90c2b6be215dbbea2cfe95510bfdf23cbf79501fff82"
        ],
        [
          "e4f3fb0176af85d65ff99ff9198c36091f48e86503681e3e6686fd5053231e11",
          "1e63633ad0ef4f1c1661a6d0ea02b7286cc7e74ec951d1c9822c38576feb73bc"
        ],
        [
          "8c00fa9b18ebf331eb961537a45a4266c7034f2f0d4e1d0716fb6eae20eae29e",
          "efa47267fea521a1a9dc343a3736c974c2fadafa81e36c54e7d2a4c66702414b"
        ],
        [
          "e7a26ce69dd4829f3e10cec0a9e98ed3143d084f308b92c0997fddfc60cb3e41",
          "2a758e300fa7984b471b006a1aafbb18d0a6b2c0420e83e20e8a9421cf2cfd51"
        ],
        [
          "b6459e0ee3662ec8d23540c223bcbdc571cbcb967d79424f3cf29eb3de6b80ef",
          "67c876d06f3e06de1dadf16e5661db3c4b3ae6d48e35b2ff30bf0b61a71ba45"
        ],
        [
          "d68a80c8280bb840793234aa118f06231d6f1fc67e73c5a5deda0f5b496943e8",
          "db8ba9fff4b586d00c4b1f9177b0e28b5b0e7b8f7845295a294c84266b133120"
        ],
        [
          "324aed7df65c804252dc0270907a30b09612aeb973449cea4095980fc28d3d5d",
          "648a365774b61f2ff130c0c35aec1f4f19213b0c7e332843967224af96ab7c84"
        ],
        [
          "4df9c14919cde61f6d51dfdbe5fee5dceec4143ba8d1ca888e8bd373fd054c96",
          "35ec51092d8728050974c23a1d85d4b5d506cdc288490192ebac06cad10d5d"
        ],
        [
          "9c3919a84a474870faed8a9c1cc66021523489054d7f0308cbfc99c8ac1f98cd",
          "ddb84f0f4a4ddd57584f044bf260e641905326f76c64c8e6be7e5e03d4fc599d"
        ],
        [
          "6057170b1dd12fdf8de05f281d8e06bb91e1493a8b91d4cc5a21382120a959e5",
          "9a1af0b26a6a4807add9a2daf71df262465152bc3ee24c65e899be932385a2a8"
        ],
        [
          "a576df8e23a08411421439a4518da31880cef0fba7d4df12b1a6973eecb94266",
          "40a6bf20e76640b2c92b97afe58cd82c432e10a7f514d9f3ee8be11ae1b28ec8"
        ],
        [
          "7778a78c28dec3e30a05fe9629de8c38bb30d1f5cf9a3a208f763889be58ad71",
          "34626d9ab5a5b22ff7098e12f2ff580087b38411ff24ac563b513fc1fd9f43ac"
        ],
        [
          "928955ee637a84463729fd30e7afd2ed5f96274e5ad7e5cb09eda9c06d903ac",
          "c25621003d3f42a827b78a13093a95eeac3d26efa8a8d83fc5180e935bcd091f"
        ],
        [
          "85d0fef3ec6db109399064f3a0e3b2855645b4a907ad354527aae75163d82751",
          "1f03648413a38c0be29d496e582cf5663e8751e96877331582c237a24eb1f962"
        ],
        [
          "ff2b0dce97eece97c1c9b6041798b85dfdfb6d8882da20308f5404824526087e",
          "493d13fef524ba188af4c4dc54d07936c7b7ed6fb90e2ceb2c951e01f0c29907"
        ],
        [
          "827fbbe4b1e880ea9ed2b2e6301b212b57f1ee148cd6dd28780e5e2cf856e241",
          "c60f9c923c727b0b71bef2c67d1d12687ff7a63186903166d605b68baec293ec"
        ],
        [
          "eaa649f21f51bdbae7be4ae34ce6e5217a58fdce7f47f9aa7f3b58fa2120e2b3",
          "be3279ed5bbbb03ac69a80f89879aa5a01a6b965f13f7e59d47a5305ba5ad93d"
        ],
        [
          "e4a42d43c5cf169d9391df6decf42ee541b6d8f0c9a137401e23632dda34d24f",
          "4d9f92e716d1c73526fc99ccfb8ad34ce886eedfa8d8e4f13a7f7131deba9414"
        ],
        [
          "1ec80fef360cbdd954160fadab352b6b92b53576a88fea4947173b9d4300bf19",
          "aeefe93756b5340d2f3a4958a7abbf5e0146e77f6295a07b671cdc1cc107cefd"
        ],
        [
          "146a778c04670c2f91b00af4680dfa8bce3490717d58ba889ddb5928366642be",
          "b318e0ec3354028add669827f9d4b2870aaa971d2f7e5ed1d0b297483d83efd0"
        ],
        [
          "fa50c0f61d22e5f07e3acebb1aa07b128d0012209a28b9776d76a8793180eef9",
          "6b84c6922397eba9b72cd2872281a68a5e683293a57a213b38cd8d7d3f4f2811"
        ],
        [
          "da1d61d0ca721a11b1a5bf6b7d88e8421a288ab5d5bba5220e53d32b5f067ec2",
          "8157f55a7c99306c79c0766161c91e2966a73899d279b48a655fba0f1ad836f1"
        ],
        [
          "a8e282ff0c9706907215ff98e8fd416615311de0446f1e062a73b0610d064e13",
          "7f97355b8db81c09abfb7f3c5b2515888b679a3e50dd6bd6cef7c73111f4cc0c"
        ],
        [
          "174a53b9c9a285872d39e56e6913cab15d59b1fa512508c022f382de8319497c",
          "ccc9dc37abfc9c1657b4155f2c47f9e6646b3a1d8cb9854383da13ac079afa73"
        ],
        [
          "959396981943785c3d3e57edf5018cdbe039e730e4918b3d884fdff09475b7ba",
          "2e7e552888c331dd8ba0386a4b9cd6849c653f64c8709385e9b8abf87524f2fd"
        ],
        [
          "d2a63a50ae401e56d645a1153b109a8fcca0a43d561fba2dbb51340c9d82b151",
          "e82d86fb6443fcb7565aee58b2948220a70f750af484ca52d4142174dcf89405"
        ],
        [
          "64587e2335471eb890ee7896d7cfdc866bacbdbd3839317b3436f9b45617e073",
          "d99fcdd5bf6902e2ae96dd6447c299a185b90a39133aeab358299e5e9faf6589"
        ],
        [
          "8481bde0e4e4d885b3a546d3e549de042f0aa6cea250e7fd358d6c86dd45e458",
          "38ee7b8cba5404dd84a25bf39cecb2ca900a79c42b262e556d64b1b59779057e"
        ],
        [
          "13464a57a78102aa62b6979ae817f4637ffcfed3c4b1ce30bcd6303f6caf666b",
          "69be159004614580ef7e433453ccb0ca48f300a81d0942e13f495a907f6ecc27"
        ],
        [
          "bc4a9df5b713fe2e9aef430bcc1dc97a0cd9ccede2f28588cada3a0d2d83f366",
          "d3a81ca6e785c06383937adf4b798caa6e8a9fbfa547b16d758d666581f33c1"
        ],
        [
          "8c28a97bf8298bc0d23d8c749452a32e694b65e30a9472a3954ab30fe5324caa",
          "40a30463a3305193378fedf31f7cc0eb7ae784f0451cb9459e71dc73cbef9482"
        ],
        [
          "8ea9666139527a8c1dd94ce4f071fd23c8b350c5a4bb33748c4ba111faccae0",
          "620efabbc8ee2782e24e7c0cfb95c5d735b783be9cf0f8e955af34a30e62b945"
        ],
        [
          "dd3625faef5ba06074669716bbd3788d89bdde815959968092f76cc4eb9a9787",
          "7a188fa3520e30d461da2501045731ca941461982883395937f68d00c644a573"
        ],
        [
          "f710d79d9eb962297e4f6232b40e8f7feb2bc63814614d692c12de752408221e",
          "ea98e67232d3b3295d3b535532115ccac8612c721851617526ae47a9c77bfc82"
        ]
      ]
    },
    naf: {
      wnd: 7,
      points: [
        [
          "f9308a019258c31049344f85f89d5229b531c845836f99b08601f113bce036f9",
          "388f7b0f632de8140fe337e62a37f3566500a99934c2231b6cb9fd7584b8e672"
        ],
        [
          "2f8bde4d1a07209355b4a7250a5c5128e88b84bddc619ab7cba8d569b240efe4",
          "d8ac222636e5e3d6d4dba9dda6c9c426f788271bab0d6840dca87d3aa6ac62d6"
        ],
        [
          "5cbdf0646e5db4eaa398f365f2ea7a0e3d419b7e0330e39ce92bddedcac4f9bc",
          "6aebca40ba255960a3178d6d861a54dba813d0b813fde7b5a5082628087264da"
        ],
        [
          "acd484e2f0c7f65309ad178a9f559abde09796974c57e714c35f110dfc27ccbe",
          "cc338921b0a7d9fd64380971763b61e9add888a4375f8e0f05cc262ac64f9c37"
        ],
        [
          "774ae7f858a9411e5ef4246b70c65aac5649980be5c17891bbec17895da008cb",
          "d984a032eb6b5e190243dd56d7b7b365372db1e2dff9d6a8301d74c9c953c61b"
        ],
        [
          "f28773c2d975288bc7d1d205c3748651b075fbc6610e58cddeeddf8f19405aa8",
          "ab0902e8d880a89758212eb65cdaf473a1a06da521fa91f29b5cb52db03ed81"
        ],
        [
          "d7924d4f7d43ea965a465ae3095ff41131e5946f3c85f79e44adbcf8e27e080e",
          "581e2872a86c72a683842ec228cc6defea40af2bd896d3a5c504dc9ff6a26b58"
        ],
        [
          "defdea4cdb677750a420fee807eacf21eb9898ae79b9768766e4faa04a2d4a34",
          "4211ab0694635168e997b0ead2a93daeced1f4a04a95c0f6cfb199f69e56eb77"
        ],
        [
          "2b4ea0a797a443d293ef5cff444f4979f06acfebd7e86d277475656138385b6c",
          "85e89bc037945d93b343083b5a1c86131a01f60c50269763b570c854e5c09b7a"
        ],
        [
          "352bbf4a4cdd12564f93fa332ce333301d9ad40271f8107181340aef25be59d5",
          "321eb4075348f534d59c18259dda3e1f4a1b3b2e71b1039c67bd3d8bcf81998c"
        ],
        [
          "2fa2104d6b38d11b0230010559879124e42ab8dfeff5ff29dc9cdadd4ecacc3f",
          "2de1068295dd865b64569335bd5dd80181d70ecfc882648423ba76b532b7d67"
        ],
        [
          "9248279b09b4d68dab21a9b066edda83263c3d84e09572e269ca0cd7f5453714",
          "73016f7bf234aade5d1aa71bdea2b1ff3fc0de2a887912ffe54a32ce97cb3402"
        ],
        [
          "daed4f2be3a8bf278e70132fb0beb7522f570e144bf615c07e996d443dee8729",
          "a69dce4a7d6c98e8d4a1aca87ef8d7003f83c230f3afa726ab40e52290be1c55"
        ],
        [
          "c44d12c7065d812e8acf28d7cbb19f9011ecd9e9fdf281b0e6a3b5e87d22e7db",
          "2119a460ce326cdc76c45926c982fdac0e106e861edf61c5a039063f0e0e6482"
        ],
        [
          "6a245bf6dc698504c89a20cfded60853152b695336c28063b61c65cbd269e6b4",
          "e022cf42c2bd4a708b3f5126f16a24ad8b33ba48d0423b6efd5e6348100d8a82"
        ],
        [
          "1697ffa6fd9de627c077e3d2fe541084ce13300b0bec1146f95ae57f0d0bd6a5",
          "b9c398f186806f5d27561506e4557433a2cf15009e498ae7adee9d63d01b2396"
        ],
        [
          "605bdb019981718b986d0f07e834cb0d9deb8360ffb7f61df982345ef27a7479",
          "2972d2de4f8d20681a78d93ec96fe23c26bfae84fb14db43b01e1e9056b8c49"
        ],
        [
          "62d14dab4150bf497402fdc45a215e10dcb01c354959b10cfe31c7e9d87ff33d",
          "80fc06bd8cc5b01098088a1950eed0db01aa132967ab472235f5642483b25eaf"
        ],
        [
          "80c60ad0040f27dade5b4b06c408e56b2c50e9f56b9b8b425e555c2f86308b6f",
          "1c38303f1cc5c30f26e66bad7fe72f70a65eed4cbe7024eb1aa01f56430bd57a"
        ],
        [
          "7a9375ad6167ad54aa74c6348cc54d344cc5dc9487d847049d5eabb0fa03c8fb",
          "d0e3fa9eca8726909559e0d79269046bdc59ea10c70ce2b02d499ec224dc7f7"
        ],
        [
          "d528ecd9b696b54c907a9ed045447a79bb408ec39b68df504bb51f459bc3ffc9",
          "eecf41253136e5f99966f21881fd656ebc4345405c520dbc063465b521409933"
        ],
        [
          "49370a4b5f43412ea25f514e8ecdad05266115e4a7ecb1387231808f8b45963",
          "758f3f41afd6ed428b3081b0512fd62a54c3f3afbb5b6764b653052a12949c9a"
        ],
        [
          "77f230936ee88cbbd73df930d64702ef881d811e0e1498e2f1c13eb1fc345d74",
          "958ef42a7886b6400a08266e9ba1b37896c95330d97077cbbe8eb3c7671c60d6"
        ],
        [
          "f2dac991cc4ce4b9ea44887e5c7c0bce58c80074ab9d4dbaeb28531b7739f530",
          "e0dedc9b3b2f8dad4da1f32dec2531df9eb5fbeb0598e4fd1a117dba703a3c37"
        ],
        [
          "463b3d9f662621fb1b4be8fbbe2520125a216cdfc9dae3debcba4850c690d45b",
          "5ed430d78c296c3543114306dd8622d7c622e27c970a1de31cb377b01af7307e"
        ],
        [
          "f16f804244e46e2a09232d4aff3b59976b98fac14328a2d1a32496b49998f247",
          "cedabd9b82203f7e13d206fcdf4e33d92a6c53c26e5cce26d6579962c4e31df6"
        ],
        [
          "caf754272dc84563b0352b7a14311af55d245315ace27c65369e15f7151d41d1",
          "cb474660ef35f5f2a41b643fa5e460575f4fa9b7962232a5c32f908318a04476"
        ],
        [
          "2600ca4b282cb986f85d0f1709979d8b44a09c07cb86d7c124497bc86f082120",
          "4119b88753c15bd6a693b03fcddbb45d5ac6be74ab5f0ef44b0be9475a7e4b40"
        ],
        [
          "7635ca72d7e8432c338ec53cd12220bc01c48685e24f7dc8c602a7746998e435",
          "91b649609489d613d1d5e590f78e6d74ecfc061d57048bad9e76f302c5b9c61"
        ],
        [
          "754e3239f325570cdbbf4a87deee8a66b7f2b33479d468fbc1a50743bf56cc18",
          "673fb86e5bda30fb3cd0ed304ea49a023ee33d0197a695d0c5d98093c536683"
        ],
        [
          "e3e6bd1071a1e96aff57859c82d570f0330800661d1c952f9fe2694691d9b9e8",
          "59c9e0bba394e76f40c0aa58379a3cb6a5a2283993e90c4167002af4920e37f5"
        ],
        [
          "186b483d056a033826ae73d88f732985c4ccb1f32ba35f4b4cc47fdcf04aa6eb",
          "3b952d32c67cf77e2e17446e204180ab21fb8090895138b4a4a797f86e80888b"
        ],
        [
          "df9d70a6b9876ce544c98561f4be4f725442e6d2b737d9c91a8321724ce0963f",
          "55eb2dafd84d6ccd5f862b785dc39d4ab157222720ef9da217b8c45cf2ba2417"
        ],
        [
          "5edd5cc23c51e87a497ca815d5dce0f8ab52554f849ed8995de64c5f34ce7143",
          "efae9c8dbc14130661e8cec030c89ad0c13c66c0d17a2905cdc706ab7399a868"
        ],
        [
          "290798c2b6476830da12fe02287e9e777aa3fba1c355b17a722d362f84614fba",
          "e38da76dcd440621988d00bcf79af25d5b29c094db2a23146d003afd41943e7a"
        ],
        [
          "af3c423a95d9f5b3054754efa150ac39cd29552fe360257362dfdecef4053b45",
          "f98a3fd831eb2b749a93b0e6f35cfb40c8cd5aa667a15581bc2feded498fd9c6"
        ],
        [
          "766dbb24d134e745cccaa28c99bf274906bb66b26dcf98df8d2fed50d884249a",
          "744b1152eacbe5e38dcc887980da38b897584a65fa06cedd2c924f97cbac5996"
        ],
        [
          "59dbf46f8c94759ba21277c33784f41645f7b44f6c596a58ce92e666191abe3e",
          "c534ad44175fbc300f4ea6ce648309a042ce739a7919798cd85e216c4a307f6e"
        ],
        [
          "f13ada95103c4537305e691e74e9a4a8dd647e711a95e73cb62dc6018cfd87b8",
          "e13817b44ee14de663bf4bc808341f326949e21a6a75c2570778419bdaf5733d"
        ],
        [
          "7754b4fa0e8aced06d4167a2c59cca4cda1869c06ebadfb6488550015a88522c",
          "30e93e864e669d82224b967c3020b8fa8d1e4e350b6cbcc537a48b57841163a2"
        ],
        [
          "948dcadf5990e048aa3874d46abef9d701858f95de8041d2a6828c99e2262519",
          "e491a42537f6e597d5d28a3224b1bc25df9154efbd2ef1d2cbba2cae5347d57e"
        ],
        [
          "7962414450c76c1689c7b48f8202ec37fb224cf5ac0bfa1570328a8a3d7c77ab",
          "100b610ec4ffb4760d5c1fc133ef6f6b12507a051f04ac5760afa5b29db83437"
        ],
        [
          "3514087834964b54b15b160644d915485a16977225b8847bb0dd085137ec47ca",
          "ef0afbb2056205448e1652c48e8127fc6039e77c15c2378b7e7d15a0de293311"
        ],
        [
          "d3cc30ad6b483e4bc79ce2c9dd8bc54993e947eb8df787b442943d3f7b527eaf",
          "8b378a22d827278d89c5e9be8f9508ae3c2ad46290358630afb34db04eede0a4"
        ],
        [
          "1624d84780732860ce1c78fcbfefe08b2b29823db913f6493975ba0ff4847610",
          "68651cf9b6da903e0914448c6cd9d4ca896878f5282be4c8cc06e2a404078575"
        ],
        [
          "733ce80da955a8a26902c95633e62a985192474b5af207da6df7b4fd5fc61cd4",
          "f5435a2bd2badf7d485a4d8b8db9fcce3e1ef8e0201e4578c54673bc1dc5ea1d"
        ],
        [
          "15d9441254945064cf1a1c33bbd3b49f8966c5092171e699ef258dfab81c045c",
          "d56eb30b69463e7234f5137b73b84177434800bacebfc685fc37bbe9efe4070d"
        ],
        [
          "a1d0fcf2ec9de675b612136e5ce70d271c21417c9d2b8aaaac138599d0717940",
          "edd77f50bcb5a3cab2e90737309667f2641462a54070f3d519212d39c197a629"
        ],
        [
          "e22fbe15c0af8ccc5780c0735f84dbe9a790badee8245c06c7ca37331cb36980",
          "a855babad5cd60c88b430a69f53a1a7a38289154964799be43d06d77d31da06"
        ],
        [
          "311091dd9860e8e20ee13473c1155f5f69635e394704eaa74009452246cfa9b3",
          "66db656f87d1f04fffd1f04788c06830871ec5a64feee685bd80f0b1286d8374"
        ],
        [
          "34c1fd04d301be89b31c0442d3e6ac24883928b45a9340781867d4232ec2dbdf",
          "9414685e97b1b5954bd46f730174136d57f1ceeb487443dc5321857ba73abee"
        ],
        [
          "f219ea5d6b54701c1c14de5b557eb42a8d13f3abbcd08affcc2a5e6b049b8d63",
          "4cb95957e83d40b0f73af4544cccf6b1f4b08d3c07b27fb8d8c2962a400766d1"
        ],
        [
          "d7b8740f74a8fbaab1f683db8f45de26543a5490bca627087236912469a0b448",
          "fa77968128d9c92ee1010f337ad4717eff15db5ed3c049b3411e0315eaa4593b"
        ],
        [
          "32d31c222f8f6f0ef86f7c98d3a3335ead5bcd32abdd94289fe4d3091aa824bf",
          "5f3032f5892156e39ccd3d7915b9e1da2e6dac9e6f26e961118d14b8462e1661"
        ],
        [
          "7461f371914ab32671045a155d9831ea8793d77cd59592c4340f86cbc18347b5",
          "8ec0ba238b96bec0cbdddcae0aa442542eee1ff50c986ea6b39847b3cc092ff6"
        ],
        [
          "ee079adb1df1860074356a25aa38206a6d716b2c3e67453d287698bad7b2b2d6",
          "8dc2412aafe3be5c4c5f37e0ecc5f9f6a446989af04c4e25ebaac479ec1c8c1e"
        ],
        [
          "16ec93e447ec83f0467b18302ee620f7e65de331874c9dc72bfd8616ba9da6b5",
          "5e4631150e62fb40d0e8c2a7ca5804a39d58186a50e497139626778e25b0674d"
        ],
        [
          "eaa5f980c245f6f038978290afa70b6bd8855897f98b6aa485b96065d537bd99",
          "f65f5d3e292c2e0819a528391c994624d784869d7e6ea67fb18041024edc07dc"
        ],
        [
          "78c9407544ac132692ee1910a02439958ae04877151342ea96c4b6b35a49f51",
          "f3e0319169eb9b85d5404795539a5e68fa1fbd583c064d2462b675f194a3ddb4"
        ],
        [
          "494f4be219a1a77016dcd838431aea0001cdc8ae7a6fc688726578d9702857a5",
          "42242a969283a5f339ba7f075e36ba2af925ce30d767ed6e55f4b031880d562c"
        ],
        [
          "a598a8030da6d86c6bc7f2f5144ea549d28211ea58faa70ebf4c1e665c1fe9b5",
          "204b5d6f84822c307e4b4a7140737aec23fc63b65b35f86a10026dbd2d864e6b"
        ],
        [
          "c41916365abb2b5d09192f5f2dbeafec208f020f12570a184dbadc3e58595997",
          "4f14351d0087efa49d245b328984989d5caf9450f34bfc0ed16e96b58fa9913"
        ],
        [
          "841d6063a586fa475a724604da03bc5b92a2e0d2e0a36acfe4c73a5514742881",
          "73867f59c0659e81904f9a1c7543698e62562d6744c169ce7a36de01a8d6154"
        ],
        [
          "5e95bb399a6971d376026947f89bde2f282b33810928be4ded112ac4d70e20d5",
          "39f23f366809085beebfc71181313775a99c9aed7d8ba38b161384c746012865"
        ],
        [
          "36e4641a53948fd476c39f8a99fd974e5ec07564b5315d8bf99471bca0ef2f66",
          "d2424b1b1abe4eb8164227b085c9aa9456ea13493fd563e06fd51cf5694c78fc"
        ],
        [
          "336581ea7bfbbb290c191a2f507a41cf5643842170e914faeab27c2c579f726",
          "ead12168595fe1be99252129b6e56b3391f7ab1410cd1e0ef3dcdcabd2fda224"
        ],
        [
          "8ab89816dadfd6b6a1f2634fcf00ec8403781025ed6890c4849742706bd43ede",
          "6fdcef09f2f6d0a044e654aef624136f503d459c3e89845858a47a9129cdd24e"
        ],
        [
          "1e33f1a746c9c5778133344d9299fcaa20b0938e8acff2544bb40284b8c5fb94",
          "60660257dd11b3aa9c8ed618d24edff2306d320f1d03010e33a7d2057f3b3b6"
        ],
        [
          "85b7c1dcb3cec1b7ee7f30ded79dd20a0ed1f4cc18cbcfcfa410361fd8f08f31",
          "3d98a9cdd026dd43f39048f25a8847f4fcafad1895d7a633c6fed3c35e999511"
        ],
        [
          "29df9fbd8d9e46509275f4b125d6d45d7fbe9a3b878a7af872a2800661ac5f51",
          "b4c4fe99c775a606e2d8862179139ffda61dc861c019e55cd2876eb2a27d84b"
        ],
        [
          "a0b1cae06b0a847a3fea6e671aaf8adfdfe58ca2f768105c8082b2e449fce252",
          "ae434102edde0958ec4b19d917a6a28e6b72da1834aff0e650f049503a296cf2"
        ],
        [
          "4e8ceafb9b3e9a136dc7ff67e840295b499dfb3b2133e4ba113f2e4c0e121e5",
          "cf2174118c8b6d7a4b48f6d534ce5c79422c086a63460502b827ce62a326683c"
        ],
        [
          "d24a44e047e19b6f5afb81c7ca2f69080a5076689a010919f42725c2b789a33b",
          "6fb8d5591b466f8fc63db50f1c0f1c69013f996887b8244d2cdec417afea8fa3"
        ],
        [
          "ea01606a7a6c9cdd249fdfcfacb99584001edd28abbab77b5104e98e8e3b35d4",
          "322af4908c7312b0cfbfe369f7a7b3cdb7d4494bc2823700cfd652188a3ea98d"
        ],
        [
          "af8addbf2b661c8a6c6328655eb96651252007d8c5ea31be4ad196de8ce2131f",
          "6749e67c029b85f52a034eafd096836b2520818680e26ac8f3dfbcdb71749700"
        ],
        [
          "e3ae1974566ca06cc516d47e0fb165a674a3dabcfca15e722f0e3450f45889",
          "2aeabe7e4531510116217f07bf4d07300de97e4874f81f533420a72eeb0bd6a4"
        ],
        [
          "591ee355313d99721cf6993ffed1e3e301993ff3ed258802075ea8ced397e246",
          "b0ea558a113c30bea60fc4775460c7901ff0b053d25ca2bdeee98f1a4be5d196"
        ],
        [
          "11396d55fda54c49f19aa97318d8da61fa8584e47b084945077cf03255b52984",
          "998c74a8cd45ac01289d5833a7beb4744ff536b01b257be4c5767bea93ea57a4"
        ],
        [
          "3c5d2a1ba39c5a1790000738c9e0c40b8dcdfd5468754b6405540157e017aa7a",
          "b2284279995a34e2f9d4de7396fc18b80f9b8b9fdd270f6661f79ca4c81bd257"
        ],
        [
          "cc8704b8a60a0defa3a99a7299f2e9c3fbc395afb04ac078425ef8a1793cc030",
          "bdd46039feed17881d1e0862db347f8cf395b74fc4bcdc4e940b74e3ac1f1b13"
        ],
        [
          "c533e4f7ea8555aacd9777ac5cad29b97dd4defccc53ee7ea204119b2889b197",
          "6f0a256bc5efdf429a2fb6242f1a43a2d9b925bb4a4b3a26bb8e0f45eb596096"
        ],
        [
          "c14f8f2ccb27d6f109f6d08d03cc96a69ba8c34eec07bbcf566d48e33da6593",
          "c359d6923bb398f7fd4473e16fe1c28475b740dd098075e6c0e8649113dc3a38"
        ],
        [
          "a6cbc3046bc6a450bac24789fa17115a4c9739ed75f8f21ce441f72e0b90e6ef",
          "21ae7f4680e889bb130619e2c0f95a360ceb573c70603139862afd617fa9b9f"
        ],
        [
          "347d6d9a02c48927ebfb86c1359b1caf130a3c0267d11ce6344b39f99d43cc38",
          "60ea7f61a353524d1c987f6ecec92f086d565ab687870cb12689ff1e31c74448"
        ],
        [
          "da6545d2181db8d983f7dcb375ef5866d47c67b1bf31c8cf855ef7437b72656a",
          "49b96715ab6878a79e78f07ce5680c5d6673051b4935bd897fea824b77dc208a"
        ],
        [
          "c40747cc9d012cb1a13b8148309c6de7ec25d6945d657146b9d5994b8feb1111",
          "5ca560753be2a12fc6de6caf2cb489565db936156b9514e1bb5e83037e0fa2d4"
        ],
        [
          "4e42c8ec82c99798ccf3a610be870e78338c7f713348bd34c8203ef4037f3502",
          "7571d74ee5e0fb92a7a8b33a07783341a5492144cc54bcc40a94473693606437"
        ],
        [
          "3775ab7089bc6af823aba2e1af70b236d251cadb0c86743287522a1b3b0dedea",
          "be52d107bcfa09d8bcb9736a828cfa7fac8db17bf7a76a2c42ad961409018cf7"
        ],
        [
          "cee31cbf7e34ec379d94fb814d3d775ad954595d1314ba8846959e3e82f74e26",
          "8fd64a14c06b589c26b947ae2bcf6bfa0149ef0be14ed4d80f448a01c43b1c6d"
        ],
        [
          "b4f9eaea09b6917619f6ea6a4eb5464efddb58fd45b1ebefcdc1a01d08b47986",
          "39e5c9925b5a54b07433a4f18c61726f8bb131c012ca542eb24a8ac07200682a"
        ],
        [
          "d4263dfc3d2df923a0179a48966d30ce84e2515afc3dccc1b77907792ebcc60e",
          "62dfaf07a0f78feb30e30d6295853ce189e127760ad6cf7fae164e122a208d54"
        ],
        [
          "48457524820fa65a4f8d35eb6930857c0032acc0a4a2de422233eeda897612c4",
          "25a748ab367979d98733c38a1fa1c2e7dc6cc07db2d60a9ae7a76aaa49bd0f77"
        ],
        [
          "dfeeef1881101f2cb11644f3a2afdfc2045e19919152923f367a1767c11cceda",
          "ecfb7056cf1de042f9420bab396793c0c390bde74b4bbdff16a83ae09a9a7517"
        ],
        [
          "6d7ef6b17543f8373c573f44e1f389835d89bcbc6062ced36c82df83b8fae859",
          "cd450ec335438986dfefa10c57fea9bcc521a0959b2d80bbf74b190dca712d10"
        ],
        [
          "e75605d59102a5a2684500d3b991f2e3f3c88b93225547035af25af66e04541f",
          "f5c54754a8f71ee540b9b48728473e314f729ac5308b06938360990e2bfad125"
        ],
        [
          "eb98660f4c4dfaa06a2be453d5020bc99a0c2e60abe388457dd43fefb1ed620c",
          "6cb9a8876d9cb8520609af3add26cd20a0a7cd8a9411131ce85f44100099223e"
        ],
        [
          "13e87b027d8514d35939f2e6892b19922154596941888336dc3563e3b8dba942",
          "fef5a3c68059a6dec5d624114bf1e91aac2b9da568d6abeb2570d55646b8adf1"
        ],
        [
          "ee163026e9fd6fe017c38f06a5be6fc125424b371ce2708e7bf4491691e5764a",
          "1acb250f255dd61c43d94ccc670d0f58f49ae3fa15b96623e5430da0ad6c62b2"
        ],
        [
          "b268f5ef9ad51e4d78de3a750c2dc89b1e626d43505867999932e5db33af3d80",
          "5f310d4b3c99b9ebb19f77d41c1dee018cf0d34fd4191614003e945a1216e423"
        ],
        [
          "ff07f3118a9df035e9fad85eb6c7bfe42b02f01ca99ceea3bf7ffdba93c4750d",
          "438136d603e858a3a5c440c38eccbaddc1d2942114e2eddd4740d098ced1f0d8"
        ],
        [
          "8d8b9855c7c052a34146fd20ffb658bea4b9f69e0d825ebec16e8c3ce2b526a1",
          "cdb559eedc2d79f926baf44fb84ea4d44bcf50fee51d7ceb30e2e7f463036758"
        ],
        [
          "52db0b5384dfbf05bfa9d472d7ae26dfe4b851ceca91b1eba54263180da32b63",
          "c3b997d050ee5d423ebaf66a6db9f57b3180c902875679de924b69d84a7b375"
        ],
        [
          "e62f9490d3d51da6395efd24e80919cc7d0f29c3f3fa48c6fff543becbd43352",
          "6d89ad7ba4876b0b22c2ca280c682862f342c8591f1daf5170e07bfd9ccafa7d"
        ],
        [
          "7f30ea2476b399b4957509c88f77d0191afa2ff5cb7b14fd6d8e7d65aaab1193",
          "ca5ef7d4b231c94c3b15389a5f6311e9daff7bb67b103e9880ef4bff637acaec"
        ],
        [
          "5098ff1e1d9f14fb46a210fada6c903fef0fb7b4a1dd1d9ac60a0361800b7a00",
          "9731141d81fc8f8084d37c6e7542006b3ee1b40d60dfe5362a5b132fd17ddc0"
        ],
        [
          "32b78c7de9ee512a72895be6b9cbefa6e2f3c4ccce445c96b9f2c81e2778ad58",
          "ee1849f513df71e32efc3896ee28260c73bb80547ae2275ba497237794c8753c"
        ],
        [
          "e2cb74fddc8e9fbcd076eef2a7c72b0ce37d50f08269dfc074b581550547a4f7",
          "d3aa2ed71c9dd2247a62df062736eb0baddea9e36122d2be8641abcb005cc4a4"
        ],
        [
          "8438447566d4d7bedadc299496ab357426009a35f235cb141be0d99cd10ae3a8",
          "c4e1020916980a4da5d01ac5e6ad330734ef0d7906631c4f2390426b2edd791f"
        ],
        [
          "4162d488b89402039b584c6fc6c308870587d9c46f660b878ab65c82c711d67e",
          "67163e903236289f776f22c25fb8a3afc1732f2b84b4e95dbda47ae5a0852649"
        ],
        [
          "3fad3fa84caf0f34f0f89bfd2dcf54fc175d767aec3e50684f3ba4a4bf5f683d",
          "cd1bc7cb6cc407bb2f0ca647c718a730cf71872e7d0d2a53fa20efcdfe61826"
        ],
        [
          "674f2600a3007a00568c1a7ce05d0816c1fb84bf1370798f1c69532faeb1a86b",
          "299d21f9413f33b3edf43b257004580b70db57da0b182259e09eecc69e0d38a5"
        ],
        [
          "d32f4da54ade74abb81b815ad1fb3b263d82d6c692714bcff87d29bd5ee9f08f",
          "f9429e738b8e53b968e99016c059707782e14f4535359d582fc416910b3eea87"
        ],
        [
          "30e4e670435385556e593657135845d36fbb6931f72b08cb1ed954f1e3ce3ff6",
          "462f9bce619898638499350113bbc9b10a878d35da70740dc695a559eb88db7b"
        ],
        [
          "be2062003c51cc3004682904330e4dee7f3dcd10b01e580bf1971b04d4cad297",
          "62188bc49d61e5428573d48a74e1c655b1c61090905682a0d5558ed72dccb9bc"
        ],
        [
          "93144423ace3451ed29e0fb9ac2af211cb6e84a601df5993c419859fff5df04a",
          "7c10dfb164c3425f5c71a3f9d7992038f1065224f72bb9d1d902a6d13037b47c"
        ],
        [
          "b015f8044f5fcbdcf21ca26d6c34fb8197829205c7b7d2a7cb66418c157b112c",
          "ab8c1e086d04e813744a655b2df8d5f83b3cdc6faa3088c1d3aea1454e3a1d5f"
        ],
        [
          "d5e9e1da649d97d89e4868117a465a3a4f8a18de57a140d36b3f2af341a21b52",
          "4cb04437f391ed73111a13cc1d4dd0db1693465c2240480d8955e8592f27447a"
        ],
        [
          "d3ae41047dd7ca065dbf8ed77b992439983005cd72e16d6f996a5316d36966bb",
          "bd1aeb21ad22ebb22a10f0303417c6d964f8cdd7df0aca614b10dc14d125ac46"
        ],
        [
          "463e2763d885f958fc66cdd22800f0a487197d0a82e377b49f80af87c897b065",
          "bfefacdb0e5d0fd7df3a311a94de062b26b80c61fbc97508b79992671ef7ca7f"
        ],
        [
          "7985fdfd127c0567c6f53ec1bb63ec3158e597c40bfe747c83cddfc910641917",
          "603c12daf3d9862ef2b25fe1de289aed24ed291e0ec6708703a5bd567f32ed03"
        ],
        [
          "74a1ad6b5f76e39db2dd249410eac7f99e74c59cb83d2d0ed5ff1543da7703e9",
          "cc6157ef18c9c63cd6193d83631bbea0093e0968942e8c33d5737fd790e0db08"
        ],
        [
          "30682a50703375f602d416664ba19b7fc9bab42c72747463a71d0896b22f6da3",
          "553e04f6b018b4fa6c8f39e7f311d3176290d0e0f19ca73f17714d9977a22ff8"
        ],
        [
          "9e2158f0d7c0d5f26c3791efefa79597654e7a2b2464f52b1ee6c1347769ef57",
          "712fcdd1b9053f09003a3481fa7762e9ffd7c8ef35a38509e2fbf2629008373"
        ],
        [
          "176e26989a43c9cfeba4029c202538c28172e566e3c4fce7322857f3be327d66",
          "ed8cc9d04b29eb877d270b4878dc43c19aefd31f4eee09ee7b47834c1fa4b1c3"
        ],
        [
          "75d46efea3771e6e68abb89a13ad747ecf1892393dfc4f1b7004788c50374da8",
          "9852390a99507679fd0b86fd2b39a868d7efc22151346e1a3ca4726586a6bed8"
        ],
        [
          "809a20c67d64900ffb698c4c825f6d5f2310fb0451c869345b7319f645605721",
          "9e994980d9917e22b76b061927fa04143d096ccc54963e6a5ebfa5f3f8e286c1"
        ],
        [
          "1b38903a43f7f114ed4500b4eac7083fdefece1cf29c63528d563446f972c180",
          "4036edc931a60ae889353f77fd53de4a2708b26b6f5da72ad3394119daf408f9"
        ]
      ]
    }
  }), secp256k1;
}
var hasRequiredCurves;
function requireCurves() {
  return hasRequiredCurves || (hasRequiredCurves = 1, function(C) {
    var e = C, T = requireHash(), $ = requireCurve(), V = requireUtils$1(), J = V.assert;
    function ee(ie) {
      ie.type === "short" ? this.curve = new $.short(ie) : ie.type === "edwards" ? this.curve = new $.edwards(ie) : this.curve = new $.mont(ie), this.g = this.curve.g, this.n = this.curve.n, this.hash = ie.hash, J(this.g.validate(), "Invalid curve"), J(this.g.mul(this.n).isInfinity(), "Invalid curve, G*N != O");
    }
    e.PresetCurve = ee;
    function te(ie, se) {
      Object.defineProperty(e, ie, {
        configurable: !0,
        enumerable: !0,
        get: function() {
          var de = new ee(se);
          return Object.defineProperty(e, ie, {
            configurable: !0,
            enumerable: !0,
            value: de
          }), de;
        }
      });
    }
    te("p192", {
      type: "short",
      prime: "p192",
      p: "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff",
      a: "ffffffff ffffffff ffffffff fffffffe ffffffff fffffffc",
      b: "64210519 e59c80e7 0fa7e9ab 72243049 feb8deec c146b9b1",
      n: "ffffffff ffffffff ffffffff 99def836 146bc9b1 b4d22831",
      hash: T.sha256,
      gRed: !1,
      g: [
        "188da80e b03090f6 7cbf20eb 43a18800 f4ff0afd 82ff1012",
        "07192b95 ffc8da78 631011ed 6b24cdd5 73f977a1 1e794811"
      ]
    }), te("p224", {
      type: "short",
      prime: "p224",
      p: "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001",
      a: "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff fffffffe",
      b: "b4050a85 0c04b3ab f5413256 5044b0b7 d7bfd8ba 270b3943 2355ffb4",
      n: "ffffffff ffffffff ffffffff ffff16a2 e0b8f03e 13dd2945 5c5c2a3d",
      hash: T.sha256,
      gRed: !1,
      g: [
        "b70e0cbd 6bb4bf7f 321390b9 4a03c1d3 56c21122 343280d6 115c1d21",
        "bd376388 b5f723fb 4c22dfe6 cd4375a0 5a074764 44d58199 85007e34"
      ]
    }), te("p256", {
      type: "short",
      prime: null,
      p: "ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff ffffffff",
      a: "ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff fffffffc",
      b: "5ac635d8 aa3a93e7 b3ebbd55 769886bc 651d06b0 cc53b0f6 3bce3c3e 27d2604b",
      n: "ffffffff 00000000 ffffffff ffffffff bce6faad a7179e84 f3b9cac2 fc632551",
      hash: T.sha256,
      gRed: !1,
      g: [
        "6b17d1f2 e12c4247 f8bce6e5 63a440f2 77037d81 2deb33a0 f4a13945 d898c296",
        "4fe342e2 fe1a7f9b 8ee7eb4a 7c0f9e16 2bce3357 6b315ece cbb64068 37bf51f5"
      ]
    }), te("p384", {
      type: "short",
      prime: null,
      p: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe ffffffff 00000000 00000000 ffffffff",
      a: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe ffffffff 00000000 00000000 fffffffc",
      b: "b3312fa7 e23ee7e4 988e056b e3f82d19 181d9c6e fe814112 0314088f 5013875a c656398d 8a2ed19d 2a85c8ed d3ec2aef",
      n: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff c7634d81 f4372ddf 581a0db2 48b0a77a ecec196a ccc52973",
      hash: T.sha384,
      gRed: !1,
      g: [
        "aa87ca22 be8b0537 8eb1c71e f320ad74 6e1d3b62 8ba79b98 59f741e0 82542a38 5502f25d bf55296c 3a545e38 72760ab7",
        "3617de4a 96262c6f 5d9e98bf 9292dc29 f8f41dbd 289a147c e9da3113 b5f0b8c0 0a60b1ce 1d7e819d 7a431d7c 90ea0e5f"
      ]
    }), te("p521", {
      type: "short",
      prime: null,
      p: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff",
      a: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffc",
      b: "00000051 953eb961 8e1c9a1f 929a21a0 b68540ee a2da725b 99b315f3 b8b48991 8ef109e1 56193951 ec7e937b 1652c0bd 3bb1bf07 3573df88 3d2c34f1 ef451fd4 6b503f00",
      n: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffa 51868783 bf2f966b 7fcc0148 f709a5d0 3bb5c9b8 899c47ae bb6fb71e 91386409",
      hash: T.sha512,
      gRed: !1,
      g: [
        "000000c6 858e06b7 0404e9cd 9e3ecb66 2395b442 9c648139 053fb521 f828af60 6b4d3dba a14b5e77 efe75928 fe1dc127 a2ffa8de 3348b3c1 856a429b f97e7e31 c2e5bd66",
        "00000118 39296a78 9a3bc004 5c8a5fb4 2c7d1bd9 98f54449 579b4468 17afbd17 273e662c 97ee7299 5ef42640 c550b901 3fad0761 353c7086 a272c240 88be9476 9fd16650"
      ]
    }), te("curve25519", {
      type: "mont",
      prime: "p25519",
      p: "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed",
      a: "76d06",
      b: "1",
      n: "1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed",
      hash: T.sha256,
      gRed: !1,
      g: [
        "9"
      ]
    }), te("ed25519", {
      type: "edwards",
      prime: "p25519",
      p: "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed",
      a: "-1",
      c: "1",
      // -121665 * (121666^(-1)) (mod P)
      d: "52036cee2b6ffe73 8cc740797779e898 00700a4d4141d8ab 75eb4dca135978a3",
      n: "1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed",
      hash: T.sha256,
      gRed: !1,
      g: [
        "216936d3cd6e53fec0a4e231fdd6dc5c692cc7609525a7b2c9562d608f25d51a",
        // 4/5
        "6666666666666666666666666666666666666666666666666666666666666658"
      ]
    });
    var re;
    try {
      re = requireSecp256k1();
    } catch {
      re = void 0;
    }
    te("secp256k1", {
      type: "short",
      prime: "k256",
      p: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f",
      a: "0",
      b: "7",
      n: "ffffffff ffffffff ffffffff fffffffe baaedce6 af48a03b bfd25e8c d0364141",
      h: "1",
      hash: T.sha256,
      // Precomputed endomorphism
      beta: "7ae96a2b657c07106e64479eac3434e99cf0497512f58995c1396c28719501ee",
      lambda: "5363ad4cc05c30e0a5261c028812645a122e22ea20816678df02967c1b23bd72",
      basis: [
        {
          a: "3086d221a7d46bcde86c90e49284eb15",
          b: "-e4437ed6010e88286f547fa90abfe4c3"
        },
        {
          a: "114ca50f7a8e2f3f657c1108d9d44cfd8",
          b: "3086d221a7d46bcde86c90e49284eb15"
        }
      ],
      gRed: !1,
      g: [
        "79be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798",
        "483ada7726a3c4655da4fbfc0e1108a8fd17b448a68554199c47d08ffb10d4b8",
        re
      ]
    });
  }(curves)), curves;
}
var hmacDrbg, hasRequiredHmacDrbg;
function requireHmacDrbg() {
  if (hasRequiredHmacDrbg) return hmacDrbg;
  hasRequiredHmacDrbg = 1;
  var C = requireHash(), e = requireUtils$2(), T = requireMinimalisticAssert();
  function $(V) {
    if (!(this instanceof $))
      return new $(V);
    this.hash = V.hash, this.predResist = !!V.predResist, this.outLen = this.hash.outSize, this.minEntropy = V.minEntropy || this.hash.hmacStrength, this._reseed = null, this.reseedInterval = null, this.K = null, this.V = null;
    var J = e.toArray(V.entropy, V.entropyEnc || "hex"), ee = e.toArray(V.nonce, V.nonceEnc || "hex"), te = e.toArray(V.pers, V.persEnc || "hex");
    T(
      J.length >= this.minEntropy / 8,
      "Not enough entropy. Minimum is: " + this.minEntropy + " bits"
    ), this._init(J, ee, te);
  }
  return hmacDrbg = $, $.prototype._init = function(J, ee, te) {
    var re = J.concat(ee).concat(te);
    this.K = new Array(this.outLen / 8), this.V = new Array(this.outLen / 8);
    for (var ie = 0; ie < this.V.length; ie++)
      this.K[ie] = 0, this.V[ie] = 1;
    this._update(re), this._reseed = 1, this.reseedInterval = 281474976710656;
  }, $.prototype._hmac = function() {
    return new C.hmac(this.hash, this.K);
  }, $.prototype._update = function(J) {
    var ee = this._hmac().update(this.V).update([0]);
    J && (ee = ee.update(J)), this.K = ee.digest(), this.V = this._hmac().update(this.V).digest(), J && (this.K = this._hmac().update(this.V).update([1]).update(J).digest(), this.V = this._hmac().update(this.V).digest());
  }, $.prototype.reseed = function(J, ee, te, re) {
    typeof ee != "string" && (re = te, te = ee, ee = null), J = e.toArray(J, ee), te = e.toArray(te, re), T(
      J.length >= this.minEntropy / 8,
      "Not enough entropy. Minimum is: " + this.minEntropy + " bits"
    ), this._update(J.concat(te || [])), this._reseed = 1;
  }, $.prototype.generate = function(J, ee, te, re) {
    if (this._reseed > this.reseedInterval)
      throw new Error("Reseed is required");
    typeof ee != "string" && (re = te, te = ee, ee = null), te && (te = e.toArray(te, re || "hex"), this._update(te));
    for (var ie = []; ie.length < J; )
      this.V = this._hmac().update(this.V).digest(), ie = ie.concat(this.V);
    var se = ie.slice(0, J);
    return this._update(te), this._reseed++, e.encode(se, ee);
  }, hmacDrbg;
}
var key$1, hasRequiredKey$1;
function requireKey$1() {
  if (hasRequiredKey$1) return key$1;
  hasRequiredKey$1 = 1;
  var C = requireBn$3(), e = requireUtils$1(), T = e.assert;
  function $(V, J) {
    this.ec = V, this.priv = null, this.pub = null, J.priv && this._importPrivate(J.priv, J.privEnc), J.pub && this._importPublic(J.pub, J.pubEnc);
  }
  return key$1 = $, $.fromPublic = function(J, ee, te) {
    return ee instanceof $ ? ee : new $(J, {
      pub: ee,
      pubEnc: te
    });
  }, $.fromPrivate = function(J, ee, te) {
    return ee instanceof $ ? ee : new $(J, {
      priv: ee,
      privEnc: te
    });
  }, $.prototype.validate = function() {
    var J = this.getPublic();
    return J.isInfinity() ? { result: !1, reason: "Invalid public key" } : J.validate() ? J.mul(this.ec.curve.n).isInfinity() ? { result: !0, reason: null } : { result: !1, reason: "Public key * N != O" } : { result: !1, reason: "Public key is not a point" };
  }, $.prototype.getPublic = function(J, ee) {
    return typeof J == "string" && (ee = J, J = null), this.pub || (this.pub = this.ec.g.mul(this.priv)), ee ? this.pub.encode(ee, J) : this.pub;
  }, $.prototype.getPrivate = function(J) {
    return J === "hex" ? this.priv.toString(16, 2) : this.priv;
  }, $.prototype._importPrivate = function(J, ee) {
    this.priv = new C(J, ee || 16), this.priv = this.priv.umod(this.ec.curve.n);
  }, $.prototype._importPublic = function(J, ee) {
    if (J.x || J.y) {
      this.ec.curve.type === "mont" ? T(J.x, "Need x coordinate") : (this.ec.curve.type === "short" || this.ec.curve.type === "edwards") && T(J.x && J.y, "Need both x and y coordinate"), this.pub = this.ec.curve.point(J.x, J.y);
      return;
    }
    this.pub = this.ec.curve.decodePoint(J, ee);
  }, $.prototype.derive = function(J) {
    return J.validate() || T(J.validate(), "public point not validated"), J.mul(this.priv).getX();
  }, $.prototype.sign = function(J, ee, te) {
    return this.ec.sign(J, this, ee, te);
  }, $.prototype.verify = function(J, ee, te) {
    return this.ec.verify(J, ee, this, void 0, te);
  }, $.prototype.inspect = function() {
    return "<Key priv: " + (this.priv && this.priv.toString(16, 2)) + " pub: " + (this.pub && this.pub.inspect()) + " >";
  }, key$1;
}
var signature$2, hasRequiredSignature$1;
function requireSignature$1() {
  if (hasRequiredSignature$1) return signature$2;
  hasRequiredSignature$1 = 1;
  var C = requireBn$3(), e = requireUtils$1(), T = e.assert;
  function $(re, ie) {
    if (re instanceof $)
      return re;
    this._importDER(re, ie) || (T(re.r && re.s, "Signature without r or s"), this.r = new C(re.r, 16), this.s = new C(re.s, 16), re.recoveryParam === void 0 ? this.recoveryParam = null : this.recoveryParam = re.recoveryParam);
  }
  signature$2 = $;
  function V() {
    this.place = 0;
  }
  function J(re, ie) {
    var se = re[ie.place++];
    if (!(se & 128))
      return se;
    var de = se & 15;
    if (de === 0 || de > 4 || re[ie.place] === 0)
      return !1;
    for (var ue = 0, fe = 0, he = ie.place; fe < de; fe++, he++)
      ue <<= 8, ue |= re[he], ue >>>= 0;
    return ue <= 127 ? !1 : (ie.place = he, ue);
  }
  function ee(re) {
    for (var ie = 0, se = re.length - 1; !re[ie] && !(re[ie + 1] & 128) && ie < se; )
      ie++;
    return ie === 0 ? re : re.slice(ie);
  }
  $.prototype._importDER = function(ie, se) {
    ie = e.toArray(ie, se);
    var de = new V();
    if (ie[de.place++] !== 48)
      return !1;
    var ue = J(ie, de);
    if (ue === !1 || ue + de.place !== ie.length || ie[de.place++] !== 2)
      return !1;
    var fe = J(ie, de);
    if (fe === !1 || ie[de.place] & 128)
      return !1;
    var he = ie.slice(de.place, fe + de.place);
    if (de.place += fe, ie[de.place++] !== 2)
      return !1;
    var me = J(ie, de);
    if (me === !1 || ie.length !== me + de.place || ie[de.place] & 128)
      return !1;
    var xe = ie.slice(de.place, me + de.place);
    if (he[0] === 0)
      if (he[1] & 128)
        he = he.slice(1);
      else
        return !1;
    if (xe[0] === 0)
      if (xe[1] & 128)
        xe = xe.slice(1);
      else
        return !1;
    return this.r = new C(he), this.s = new C(xe), this.recoveryParam = null, !0;
  };
  function te(re, ie) {
    if (ie < 128) {
      re.push(ie);
      return;
    }
    var se = 1 + (Math.log(ie) / Math.LN2 >>> 3);
    for (re.push(se | 128); --se; )
      re.push(ie >>> (se << 3) & 255);
    re.push(ie);
  }
  return $.prototype.toDER = function(ie) {
    var se = this.r.toArray(), de = this.s.toArray();
    for (se[0] & 128 && (se = [0].concat(se)), de[0] & 128 && (de = [0].concat(de)), se = ee(se), de = ee(de); !de[0] && !(de[1] & 128); )
      de = de.slice(1);
    var ue = [2];
    te(ue, se.length), ue = ue.concat(se), ue.push(2), te(ue, de.length);
    var fe = ue.concat(de), he = [48];
    return te(he, fe.length), he = he.concat(fe), e.encode(he, ie);
  }, signature$2;
}
var ec, hasRequiredEc;
function requireEc() {
  if (hasRequiredEc) return ec;
  hasRequiredEc = 1;
  var C = requireBn$3(), e = requireHmacDrbg(), T = requireUtils$1(), $ = requireCurves(), V = requireBrorand(), J = T.assert, ee = requireKey$1(), te = requireSignature$1();
  function re(ie) {
    if (!(this instanceof re))
      return new re(ie);
    typeof ie == "string" && (J(
      Object.prototype.hasOwnProperty.call($, ie),
      "Unknown curve " + ie
    ), ie = $[ie]), ie instanceof $.PresetCurve && (ie = { curve: ie }), this.curve = ie.curve.curve, this.n = this.curve.n, this.nh = this.n.ushrn(1), this.g = this.curve.g, this.g = ie.curve.g, this.g.precompute(ie.curve.n.bitLength() + 1), this.hash = ie.hash || ie.curve.hash;
  }
  return ec = re, re.prototype.keyPair = function(se) {
    return new ee(this, se);
  }, re.prototype.keyFromPrivate = function(se, de) {
    return ee.fromPrivate(this, se, de);
  }, re.prototype.keyFromPublic = function(se, de) {
    return ee.fromPublic(this, se, de);
  }, re.prototype.genKeyPair = function(se) {
    se || (se = {});
    for (var de = new e({
      hash: this.hash,
      pers: se.pers,
      persEnc: se.persEnc || "utf8",
      entropy: se.entropy || V(this.hash.hmacStrength),
      entropyEnc: se.entropy && se.entropyEnc || "utf8",
      nonce: this.n.toArray()
    }), ue = this.n.byteLength(), fe = this.n.sub(new C(2)); ; ) {
      var he = new C(de.generate(ue));
      if (!(he.cmp(fe) > 0))
        return he.iaddn(1), this.keyFromPrivate(he);
    }
  }, re.prototype._truncateToN = function(se, de, ue) {
    var fe;
    if (C.isBN(se) || typeof se == "number")
      se = new C(se, 16), fe = se.byteLength();
    else if (typeof se == "object")
      fe = se.length, se = new C(se, 16);
    else {
      var he = se.toString();
      fe = he.length + 1 >>> 1, se = new C(he, 16);
    }
    typeof ue != "number" && (ue = fe * 8);
    var me = ue - this.n.bitLength();
    return me > 0 && (se = se.ushrn(me)), !de && se.cmp(this.n) >= 0 ? se.sub(this.n) : se;
  }, re.prototype.sign = function(se, de, ue, fe) {
    if (typeof ue == "object" && (fe = ue, ue = null), fe || (fe = {}), typeof se != "string" && typeof se != "number" && !C.isBN(se)) {
      J(
        typeof se == "object" && se && typeof se.length == "number",
        "Expected message to be an array-like, a hex string, or a BN instance"
      ), J(se.length >>> 0 === se.length);
      for (var he = 0; he < se.length; he++) J((se[he] & 255) === se[he]);
    }
    de = this.keyFromPrivate(de, ue), se = this._truncateToN(se, !1, fe.msgBitLength), J(!se.isNeg(), "Can not sign a negative message");
    var me = this.n.byteLength(), xe = de.getPrivate().toArray("be", me), ve = se.toArray("be", me);
    J(new C(ve).eq(se), "Can not sign message");
    for (var Te = new e({
      hash: this.hash,
      entropy: xe,
      nonce: ve,
      pers: fe.pers,
      persEnc: fe.persEnc || "utf8"
    }), we = this.n.sub(new C(1)), Ee = 0; ; Ee++) {
      var Me = fe.k ? fe.k(Ee) : new C(Te.generate(this.n.byteLength()));
      if (Me = this._truncateToN(Me, !0), !(Me.cmpn(1) <= 0 || Me.cmp(we) >= 0)) {
        var Ie = this.g.mul(Me);
        if (!Ie.isInfinity()) {
          var ke = Ie.getX(), _e = ke.umod(this.n);
          if (_e.cmpn(0) !== 0) {
            var De = Me.invm(this.n).mul(_e.mul(de.getPrivate()).iadd(se));
            if (De = De.umod(this.n), De.cmpn(0) !== 0) {
              var Fe = (Ie.getY().isOdd() ? 1 : 0) | (ke.cmp(_e) !== 0 ? 2 : 0);
              return fe.canonical && De.cmp(this.nh) > 0 && (De = this.n.sub(De), Fe ^= 1), new te({ r: _e, s: De, recoveryParam: Fe });
            }
          }
        }
      }
    }
  }, re.prototype.verify = function(se, de, ue, fe, he) {
    he || (he = {}), se = this._truncateToN(se, !1, he.msgBitLength), ue = this.keyFromPublic(ue, fe), de = new te(de, "hex");
    var me = de.r, xe = de.s;
    if (me.cmpn(1) < 0 || me.cmp(this.n) >= 0 || xe.cmpn(1) < 0 || xe.cmp(this.n) >= 0)
      return !1;
    var ve = xe.invm(this.n), Te = ve.mul(se).umod(this.n), we = ve.mul(me).umod(this.n), Ee;
    return this.curve._maxwellTrick ? (Ee = this.g.jmulAdd(Te, ue.getPublic(), we), Ee.isInfinity() ? !1 : Ee.eqXToP(me)) : (Ee = this.g.mulAdd(Te, ue.getPublic(), we), Ee.isInfinity() ? !1 : Ee.getX().umod(this.n).cmp(me) === 0);
  }, re.prototype.recoverPubKey = function(ie, se, de, ue) {
    J((3 & de) === de, "The recovery param is more than two bits"), se = new te(se, ue);
    var fe = this.n, he = new C(ie), me = se.r, xe = se.s, ve = de & 1, Te = de >> 1;
    if (me.cmp(this.curve.p.umod(this.curve.n)) >= 0 && Te)
      throw new Error("Unable to find sencond key candinate");
    Te ? me = this.curve.pointFromX(me.add(this.curve.n), ve) : me = this.curve.pointFromX(me, ve);
    var we = se.r.invm(fe), Ee = fe.sub(he).mul(we).umod(fe), Me = xe.mul(we).umod(fe);
    return this.g.mulAdd(Ee, me, Me);
  }, re.prototype.getKeyRecoveryParam = function(ie, se, de, ue) {
    if (se = new te(se, ue), se.recoveryParam !== null)
      return se.recoveryParam;
    for (var fe = 0; fe < 4; fe++) {
      var he;
      try {
        he = this.recoverPubKey(ie, se, fe);
      } catch {
        continue;
      }
      if (he.eq(de))
        return fe;
    }
    throw new Error("Unable to find valid recovery factor");
  }, ec;
}
var key, hasRequiredKey;
function requireKey() {
  if (hasRequiredKey) return key;
  hasRequiredKey = 1;
  var C = requireUtils$1(), e = C.assert, T = C.parseBytes, $ = C.cachedProperty;
  function V(J, ee) {
    this.eddsa = J, this._secret = T(ee.secret), J.isPoint(ee.pub) ? this._pub = ee.pub : this._pubBytes = T(ee.pub);
  }
  return V.fromPublic = function(ee, te) {
    return te instanceof V ? te : new V(ee, { pub: te });
  }, V.fromSecret = function(ee, te) {
    return te instanceof V ? te : new V(ee, { secret: te });
  }, V.prototype.secret = function() {
    return this._secret;
  }, $(V, "pubBytes", function() {
    return this.eddsa.encodePoint(this.pub());
  }), $(V, "pub", function() {
    return this._pubBytes ? this.eddsa.decodePoint(this._pubBytes) : this.eddsa.g.mul(this.priv());
  }), $(V, "privBytes", function() {
    var ee = this.eddsa, te = this.hash(), re = ee.encodingLength - 1, ie = te.slice(0, ee.encodingLength);
    return ie[0] &= 248, ie[re] &= 127, ie[re] |= 64, ie;
  }), $(V, "priv", function() {
    return this.eddsa.decodeInt(this.privBytes());
  }), $(V, "hash", function() {
    return this.eddsa.hash().update(this.secret()).digest();
  }), $(V, "messagePrefix", function() {
    return this.hash().slice(this.eddsa.encodingLength);
  }), V.prototype.sign = function(ee) {
    return e(this._secret, "KeyPair can only verify"), this.eddsa.sign(ee, this);
  }, V.prototype.verify = function(ee, te) {
    return this.eddsa.verify(ee, te, this);
  }, V.prototype.getSecret = function(ee) {
    return e(this._secret, "KeyPair is public only"), C.encode(this.secret(), ee);
  }, V.prototype.getPublic = function(ee) {
    return C.encode(this.pubBytes(), ee);
  }, key = V, key;
}
var signature$1, hasRequiredSignature;
function requireSignature() {
  if (hasRequiredSignature) return signature$1;
  hasRequiredSignature = 1;
  var C = requireBn$3(), e = requireUtils$1(), T = e.assert, $ = e.cachedProperty, V = e.parseBytes;
  function J(ee, te) {
    this.eddsa = ee, typeof te != "object" && (te = V(te)), Array.isArray(te) && (T(te.length === ee.encodingLength * 2, "Signature has invalid size"), te = {
      R: te.slice(0, ee.encodingLength),
      S: te.slice(ee.encodingLength)
    }), T(te.R && te.S, "Signature without R or S"), ee.isPoint(te.R) && (this._R = te.R), te.S instanceof C && (this._S = te.S), this._Rencoded = Array.isArray(te.R) ? te.R : te.Rencoded, this._Sencoded = Array.isArray(te.S) ? te.S : te.Sencoded;
  }
  return $(J, "S", function() {
    return this.eddsa.decodeInt(this.Sencoded());
  }), $(J, "R", function() {
    return this.eddsa.decodePoint(this.Rencoded());
  }), $(J, "Rencoded", function() {
    return this.eddsa.encodePoint(this.R());
  }), $(J, "Sencoded", function() {
    return this.eddsa.encodeInt(this.S());
  }), J.prototype.toBytes = function() {
    return this.Rencoded().concat(this.Sencoded());
  }, J.prototype.toHex = function() {
    return e.encode(this.toBytes(), "hex").toUpperCase();
  }, signature$1 = J, signature$1;
}
var eddsa, hasRequiredEddsa;
function requireEddsa() {
  if (hasRequiredEddsa) return eddsa;
  hasRequiredEddsa = 1;
  var C = requireHash(), e = requireCurves(), T = requireUtils$1(), $ = T.assert, V = T.parseBytes, J = requireKey(), ee = requireSignature();
  function te(re) {
    if ($(re === "ed25519", "only tested with ed25519 so far"), !(this instanceof te))
      return new te(re);
    re = e[re].curve, this.curve = re, this.g = re.g, this.g.precompute(re.n.bitLength() + 1), this.pointClass = re.point().constructor, this.encodingLength = Math.ceil(re.n.bitLength() / 8), this.hash = C.sha512;
  }
  return eddsa = te, te.prototype.sign = function(ie, se) {
    ie = V(ie);
    var de = this.keyFromSecret(se), ue = this.hashInt(de.messagePrefix(), ie), fe = this.g.mul(ue), he = this.encodePoint(fe), me = this.hashInt(he, de.pubBytes(), ie).mul(de.priv()), xe = ue.add(me).umod(this.curve.n);
    return this.makeSignature({ R: fe, S: xe, Rencoded: he });
  }, te.prototype.verify = function(ie, se, de) {
    if (ie = V(ie), se = this.makeSignature(se), se.S().gte(se.eddsa.curve.n) || se.S().isNeg())
      return !1;
    var ue = this.keyFromPublic(de), fe = this.hashInt(se.Rencoded(), ue.pubBytes(), ie), he = this.g.mul(se.S()), me = se.R().add(ue.pub().mul(fe));
    return me.eq(he);
  }, te.prototype.hashInt = function() {
    for (var ie = this.hash(), se = 0; se < arguments.length; se++)
      ie.update(arguments[se]);
    return T.intFromLE(ie.digest()).umod(this.curve.n);
  }, te.prototype.keyFromPublic = function(ie) {
    return J.fromPublic(this, ie);
  }, te.prototype.keyFromSecret = function(ie) {
    return J.fromSecret(this, ie);
  }, te.prototype.makeSignature = function(ie) {
    return ie instanceof ee ? ie : new ee(this, ie);
  }, te.prototype.encodePoint = function(ie) {
    var se = ie.getY().toArray("le", this.encodingLength);
    return se[this.encodingLength - 1] |= ie.getX().isOdd() ? 128 : 0, se;
  }, te.prototype.decodePoint = function(ie) {
    ie = T.parseBytes(ie);
    var se = ie.length - 1, de = ie.slice(0, se).concat(ie[se] & -129), ue = (ie[se] & 128) !== 0, fe = T.intFromLE(de);
    return this.curve.pointFromY(fe, ue);
  }, te.prototype.encodeInt = function(ie) {
    return ie.toArray("le", this.encodingLength);
  }, te.prototype.decodeInt = function(ie) {
    return T.intFromLE(ie);
  }, te.prototype.isPoint = function(ie) {
    return ie instanceof this.pointClass;
  }, eddsa;
}
var hasRequiredElliptic;
function requireElliptic() {
  return hasRequiredElliptic || (hasRequiredElliptic = 1, function(C) {
    var e = C;
    e.version = require$$0$1.version, e.utils = requireUtils$1(), e.rand = requireBrorand(), e.curve = requireCurve(), e.curves = requireCurves(), e.ec = requireEc(), e.eddsa = requireEddsa();
  }(elliptic)), elliptic;
}
var asn1$1 = {}, asn1 = {}, bn$2 = { exports: {} };
bn$2.exports;
var hasRequiredBn$2;
function requireBn$2() {
  return hasRequiredBn$2 || (hasRequiredBn$2 = 1, function(C) {
    (function(e, T) {
      function $(Ae, ne) {
        if (!Ae) throw new Error(ne || "Assertion failed");
      }
      function V(Ae, ne) {
        Ae.super_ = ne;
        var oe = function() {
        };
        oe.prototype = ne.prototype, Ae.prototype = new oe(), Ae.prototype.constructor = Ae;
      }
      function J(Ae, ne, oe) {
        if (J.isBN(Ae))
          return Ae;
        this.negative = 0, this.words = null, this.length = 0, this.red = null, Ae !== null && ((ne === "le" || ne === "be") && (oe = ne, ne = 10), this._init(Ae || 0, ne || 10, oe || "be"));
      }
      typeof e == "object" ? e.exports = J : T.BN = J, J.BN = J, J.wordSize = 26;
      var ee;
      try {
        typeof window < "u" && typeof window.Buffer < "u" ? ee = window.Buffer : ee = bufferPolyfill.Buffer;
      } catch {
      }
      J.isBN = function(ne) {
        return ne instanceof J ? !0 : ne !== null && typeof ne == "object" && ne.constructor.wordSize === J.wordSize && Array.isArray(ne.words);
      }, J.max = function(ne, oe) {
        return ne.cmp(oe) > 0 ? ne : oe;
      }, J.min = function(ne, oe) {
        return ne.cmp(oe) < 0 ? ne : oe;
      }, J.prototype._init = function(ne, oe, ce) {
        if (typeof ne == "number")
          return this._initNumber(ne, oe, ce);
        if (typeof ne == "object")
          return this._initArray(ne, oe, ce);
        oe === "hex" && (oe = 16), $(oe === (oe | 0) && oe >= 2 && oe <= 36), ne = ne.toString().replace(/\s+/g, "");
        var le = 0;
        ne[0] === "-" && (le++, this.negative = 1), le < ne.length && (oe === 16 ? this._parseHex(ne, le, ce) : (this._parseBase(ne, oe, le), ce === "le" && this._initArray(this.toArray(), oe, ce)));
      }, J.prototype._initNumber = function(ne, oe, ce) {
        ne < 0 && (this.negative = 1, ne = -ne), ne < 67108864 ? (this.words = [ne & 67108863], this.length = 1) : ne < 4503599627370496 ? (this.words = [
          ne & 67108863,
          ne / 67108864 & 67108863
        ], this.length = 2) : ($(ne < 9007199254740992), this.words = [
          ne & 67108863,
          ne / 67108864 & 67108863,
          1
        ], this.length = 3), ce === "le" && this._initArray(this.toArray(), oe, ce);
      }, J.prototype._initArray = function(ne, oe, ce) {
        if ($(typeof ne.length == "number"), ne.length <= 0)
          return this.words = [0], this.length = 1, this;
        this.length = Math.ceil(ne.length / 3), this.words = new Array(this.length);
        for (var le = 0; le < this.length; le++)
          this.words[le] = 0;
        var pe, ye, Ce = 0;
        if (ce === "be")
          for (le = ne.length - 1, pe = 0; le >= 0; le -= 3)
            ye = ne[le] | ne[le - 1] << 8 | ne[le - 2] << 16, this.words[pe] |= ye << Ce & 67108863, this.words[pe + 1] = ye >>> 26 - Ce & 67108863, Ce += 24, Ce >= 26 && (Ce -= 26, pe++);
        else if (ce === "le")
          for (le = 0, pe = 0; le < ne.length; le += 3)
            ye = ne[le] | ne[le + 1] << 8 | ne[le + 2] << 16, this.words[pe] |= ye << Ce & 67108863, this.words[pe + 1] = ye >>> 26 - Ce & 67108863, Ce += 24, Ce >= 26 && (Ce -= 26, pe++);
        return this.strip();
      };
      function te(Ae, ne) {
        var oe = Ae.charCodeAt(ne);
        return oe >= 65 && oe <= 70 ? oe - 55 : oe >= 97 && oe <= 102 ? oe - 87 : oe - 48 & 15;
      }
      function re(Ae, ne, oe) {
        var ce = te(Ae, oe);
        return oe - 1 >= ne && (ce |= te(Ae, oe - 1) << 4), ce;
      }
      J.prototype._parseHex = function(ne, oe, ce) {
        this.length = Math.ceil((ne.length - oe) / 6), this.words = new Array(this.length);
        for (var le = 0; le < this.length; le++)
          this.words[le] = 0;
        var pe = 0, ye = 0, Ce;
        if (ce === "be")
          for (le = ne.length - 1; le >= oe; le -= 2)
            Ce = re(ne, oe, le) << pe, this.words[ye] |= Ce & 67108863, pe >= 18 ? (pe -= 18, ye += 1, this.words[ye] |= Ce >>> 26) : pe += 8;
        else {
          var be = ne.length - oe;
          for (le = be % 2 === 0 ? oe + 1 : oe; le < ne.length; le += 2)
            Ce = re(ne, oe, le) << pe, this.words[ye] |= Ce & 67108863, pe >= 18 ? (pe -= 18, ye += 1, this.words[ye] |= Ce >>> 26) : pe += 8;
        }
        this.strip();
      };
      function ie(Ae, ne, oe, ce) {
        for (var le = 0, pe = Math.min(Ae.length, oe), ye = ne; ye < pe; ye++) {
          var Ce = Ae.charCodeAt(ye) - 48;
          le *= ce, Ce >= 49 ? le += Ce - 49 + 10 : Ce >= 17 ? le += Ce - 17 + 10 : le += Ce;
        }
        return le;
      }
      J.prototype._parseBase = function(ne, oe, ce) {
        this.words = [0], this.length = 1;
        for (var le = 0, pe = 1; pe <= 67108863; pe *= oe)
          le++;
        le--, pe = pe / oe | 0;
        for (var ye = ne.length - ce, Ce = ye % le, be = Math.min(ye, ye - Ce) + ce, ae = 0, ge = ce; ge < be; ge += le)
          ae = ie(ne, ge, ge + le, oe), this.imuln(pe), this.words[0] + ae < 67108864 ? this.words[0] += ae : this._iaddn(ae);
        if (Ce !== 0) {
          var Se = 1;
          for (ae = ie(ne, ge, ne.length, oe), ge = 0; ge < Ce; ge++)
            Se *= oe;
          this.imuln(Se), this.words[0] + ae < 67108864 ? this.words[0] += ae : this._iaddn(ae);
        }
        this.strip();
      }, J.prototype.copy = function(ne) {
        ne.words = new Array(this.length);
        for (var oe = 0; oe < this.length; oe++)
          ne.words[oe] = this.words[oe];
        ne.length = this.length, ne.negative = this.negative, ne.red = this.red;
      }, J.prototype.clone = function() {
        var ne = new J(null);
        return this.copy(ne), ne;
      }, J.prototype._expand = function(ne) {
        for (; this.length < ne; )
          this.words[this.length++] = 0;
        return this;
      }, J.prototype.strip = function() {
        for (; this.length > 1 && this.words[this.length - 1] === 0; )
          this.length--;
        return this._normSign();
      }, J.prototype._normSign = function() {
        return this.length === 1 && this.words[0] === 0 && (this.negative = 0), this;
      }, J.prototype.inspect = function() {
        return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
      };
      var se = [
        "",
        "0",
        "00",
        "000",
        "0000",
        "00000",
        "000000",
        "0000000",
        "00000000",
        "000000000",
        "0000000000",
        "00000000000",
        "000000000000",
        "0000000000000",
        "00000000000000",
        "000000000000000",
        "0000000000000000",
        "00000000000000000",
        "000000000000000000",
        "0000000000000000000",
        "00000000000000000000",
        "000000000000000000000",
        "0000000000000000000000",
        "00000000000000000000000",
        "000000000000000000000000",
        "0000000000000000000000000"
      ], de = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
      ], ue = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        1e7,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64e6,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        243e5,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
      ];
      J.prototype.toString = function(ne, oe) {
        ne = ne || 10, oe = oe | 0 || 1;
        var ce;
        if (ne === 16 || ne === "hex") {
          ce = "";
          for (var le = 0, pe = 0, ye = 0; ye < this.length; ye++) {
            var Ce = this.words[ye], be = ((Ce << le | pe) & 16777215).toString(16);
            pe = Ce >>> 24 - le & 16777215, le += 2, le >= 26 && (le -= 26, ye--), pe !== 0 || ye !== this.length - 1 ? ce = se[6 - be.length] + be + ce : ce = be + ce;
          }
          for (pe !== 0 && (ce = pe.toString(16) + ce); ce.length % oe !== 0; )
            ce = "0" + ce;
          return this.negative !== 0 && (ce = "-" + ce), ce;
        }
        if (ne === (ne | 0) && ne >= 2 && ne <= 36) {
          var ae = de[ne], ge = ue[ne];
          ce = "";
          var Se = this.clone();
          for (Se.negative = 0; !Se.isZero(); ) {
            var Le = Se.modn(ge).toString(ne);
            Se = Se.idivn(ge), Se.isZero() ? ce = Le + ce : ce = se[ae - Le.length] + Le + ce;
          }
          for (this.isZero() && (ce = "0" + ce); ce.length % oe !== 0; )
            ce = "0" + ce;
          return this.negative !== 0 && (ce = "-" + ce), ce;
        }
        $(!1, "Base should be between 2 and 36");
      }, J.prototype.toNumber = function() {
        var ne = this.words[0];
        return this.length === 2 ? ne += this.words[1] * 67108864 : this.length === 3 && this.words[2] === 1 ? ne += 4503599627370496 + this.words[1] * 67108864 : this.length > 2 && $(!1, "Number can only safely store up to 53 bits"), this.negative !== 0 ? -ne : ne;
      }, J.prototype.toJSON = function() {
        return this.toString(16);
      }, J.prototype.toBuffer = function(ne, oe) {
        return $(typeof ee < "u"), this.toArrayLike(ee, ne, oe);
      }, J.prototype.toArray = function(ne, oe) {
        return this.toArrayLike(Array, ne, oe);
      }, J.prototype.toArrayLike = function(ne, oe, ce) {
        var le = this.byteLength(), pe = ce || Math.max(1, le);
        $(le <= pe, "byte array longer than desired length"), $(pe > 0, "Requested array length <= 0"), this.strip();
        var ye = oe === "le", Ce = new ne(pe), be, ae, ge = this.clone();
        if (ye) {
          for (ae = 0; !ge.isZero(); ae++)
            be = ge.andln(255), ge.iushrn(8), Ce[ae] = be;
          for (; ae < pe; ae++)
            Ce[ae] = 0;
        } else {
          for (ae = 0; ae < pe - le; ae++)
            Ce[ae] = 0;
          for (ae = 0; !ge.isZero(); ae++)
            be = ge.andln(255), ge.iushrn(8), Ce[pe - ae - 1] = be;
        }
        return Ce;
      }, Math.clz32 ? J.prototype._countBits = function(ne) {
        return 32 - Math.clz32(ne);
      } : J.prototype._countBits = function(ne) {
        var oe = ne, ce = 0;
        return oe >= 4096 && (ce += 13, oe >>>= 13), oe >= 64 && (ce += 7, oe >>>= 7), oe >= 8 && (ce += 4, oe >>>= 4), oe >= 2 && (ce += 2, oe >>>= 2), ce + oe;
      }, J.prototype._zeroBits = function(ne) {
        if (ne === 0) return 26;
        var oe = ne, ce = 0;
        return oe & 8191 || (ce += 13, oe >>>= 13), oe & 127 || (ce += 7, oe >>>= 7), oe & 15 || (ce += 4, oe >>>= 4), oe & 3 || (ce += 2, oe >>>= 2), oe & 1 || ce++, ce;
      }, J.prototype.bitLength = function() {
        var ne = this.words[this.length - 1], oe = this._countBits(ne);
        return (this.length - 1) * 26 + oe;
      };
      function fe(Ae) {
        for (var ne = new Array(Ae.bitLength()), oe = 0; oe < ne.length; oe++) {
          var ce = oe / 26 | 0, le = oe % 26;
          ne[oe] = (Ae.words[ce] & 1 << le) >>> le;
        }
        return ne;
      }
      J.prototype.zeroBits = function() {
        if (this.isZero()) return 0;
        for (var ne = 0, oe = 0; oe < this.length; oe++) {
          var ce = this._zeroBits(this.words[oe]);
          if (ne += ce, ce !== 26) break;
        }
        return ne;
      }, J.prototype.byteLength = function() {
        return Math.ceil(this.bitLength() / 8);
      }, J.prototype.toTwos = function(ne) {
        return this.negative !== 0 ? this.abs().inotn(ne).iaddn(1) : this.clone();
      }, J.prototype.fromTwos = function(ne) {
        return this.testn(ne - 1) ? this.notn(ne).iaddn(1).ineg() : this.clone();
      }, J.prototype.isNeg = function() {
        return this.negative !== 0;
      }, J.prototype.neg = function() {
        return this.clone().ineg();
      }, J.prototype.ineg = function() {
        return this.isZero() || (this.negative ^= 1), this;
      }, J.prototype.iuor = function(ne) {
        for (; this.length < ne.length; )
          this.words[this.length++] = 0;
        for (var oe = 0; oe < ne.length; oe++)
          this.words[oe] = this.words[oe] | ne.words[oe];
        return this.strip();
      }, J.prototype.ior = function(ne) {
        return $((this.negative | ne.negative) === 0), this.iuor(ne);
      }, J.prototype.or = function(ne) {
        return this.length > ne.length ? this.clone().ior(ne) : ne.clone().ior(this);
      }, J.prototype.uor = function(ne) {
        return this.length > ne.length ? this.clone().iuor(ne) : ne.clone().iuor(this);
      }, J.prototype.iuand = function(ne) {
        var oe;
        this.length > ne.length ? oe = ne : oe = this;
        for (var ce = 0; ce < oe.length; ce++)
          this.words[ce] = this.words[ce] & ne.words[ce];
        return this.length = oe.length, this.strip();
      }, J.prototype.iand = function(ne) {
        return $((this.negative | ne.negative) === 0), this.iuand(ne);
      }, J.prototype.and = function(ne) {
        return this.length > ne.length ? this.clone().iand(ne) : ne.clone().iand(this);
      }, J.prototype.uand = function(ne) {
        return this.length > ne.length ? this.clone().iuand(ne) : ne.clone().iuand(this);
      }, J.prototype.iuxor = function(ne) {
        var oe, ce;
        this.length > ne.length ? (oe = this, ce = ne) : (oe = ne, ce = this);
        for (var le = 0; le < ce.length; le++)
          this.words[le] = oe.words[le] ^ ce.words[le];
        if (this !== oe)
          for (; le < oe.length; le++)
            this.words[le] = oe.words[le];
        return this.length = oe.length, this.strip();
      }, J.prototype.ixor = function(ne) {
        return $((this.negative | ne.negative) === 0), this.iuxor(ne);
      }, J.prototype.xor = function(ne) {
        return this.length > ne.length ? this.clone().ixor(ne) : ne.clone().ixor(this);
      }, J.prototype.uxor = function(ne) {
        return this.length > ne.length ? this.clone().iuxor(ne) : ne.clone().iuxor(this);
      }, J.prototype.inotn = function(ne) {
        $(typeof ne == "number" && ne >= 0);
        var oe = Math.ceil(ne / 26) | 0, ce = ne % 26;
        this._expand(oe), ce > 0 && oe--;
        for (var le = 0; le < oe; le++)
          this.words[le] = ~this.words[le] & 67108863;
        return ce > 0 && (this.words[le] = ~this.words[le] & 67108863 >> 26 - ce), this.strip();
      }, J.prototype.notn = function(ne) {
        return this.clone().inotn(ne);
      }, J.prototype.setn = function(ne, oe) {
        $(typeof ne == "number" && ne >= 0);
        var ce = ne / 26 | 0, le = ne % 26;
        return this._expand(ce + 1), oe ? this.words[ce] = this.words[ce] | 1 << le : this.words[ce] = this.words[ce] & ~(1 << le), this.strip();
      }, J.prototype.iadd = function(ne) {
        var oe;
        if (this.negative !== 0 && ne.negative === 0)
          return this.negative = 0, oe = this.isub(ne), this.negative ^= 1, this._normSign();
        if (this.negative === 0 && ne.negative !== 0)
          return ne.negative = 0, oe = this.isub(ne), ne.negative = 1, oe._normSign();
        var ce, le;
        this.length > ne.length ? (ce = this, le = ne) : (ce = ne, le = this);
        for (var pe = 0, ye = 0; ye < le.length; ye++)
          oe = (ce.words[ye] | 0) + (le.words[ye] | 0) + pe, this.words[ye] = oe & 67108863, pe = oe >>> 26;
        for (; pe !== 0 && ye < ce.length; ye++)
          oe = (ce.words[ye] | 0) + pe, this.words[ye] = oe & 67108863, pe = oe >>> 26;
        if (this.length = ce.length, pe !== 0)
          this.words[this.length] = pe, this.length++;
        else if (ce !== this)
          for (; ye < ce.length; ye++)
            this.words[ye] = ce.words[ye];
        return this;
      }, J.prototype.add = function(ne) {
        var oe;
        return ne.negative !== 0 && this.negative === 0 ? (ne.negative = 0, oe = this.sub(ne), ne.negative ^= 1, oe) : ne.negative === 0 && this.negative !== 0 ? (this.negative = 0, oe = ne.sub(this), this.negative = 1, oe) : this.length > ne.length ? this.clone().iadd(ne) : ne.clone().iadd(this);
      }, J.prototype.isub = function(ne) {
        if (ne.negative !== 0) {
          ne.negative = 0;
          var oe = this.iadd(ne);
          return ne.negative = 1, oe._normSign();
        } else if (this.negative !== 0)
          return this.negative = 0, this.iadd(ne), this.negative = 1, this._normSign();
        var ce = this.cmp(ne);
        if (ce === 0)
          return this.negative = 0, this.length = 1, this.words[0] = 0, this;
        var le, pe;
        ce > 0 ? (le = this, pe = ne) : (le = ne, pe = this);
        for (var ye = 0, Ce = 0; Ce < pe.length; Ce++)
          oe = (le.words[Ce] | 0) - (pe.words[Ce] | 0) + ye, ye = oe >> 26, this.words[Ce] = oe & 67108863;
        for (; ye !== 0 && Ce < le.length; Ce++)
          oe = (le.words[Ce] | 0) + ye, ye = oe >> 26, this.words[Ce] = oe & 67108863;
        if (ye === 0 && Ce < le.length && le !== this)
          for (; Ce < le.length; Ce++)
            this.words[Ce] = le.words[Ce];
        return this.length = Math.max(this.length, Ce), le !== this && (this.negative = 1), this.strip();
      }, J.prototype.sub = function(ne) {
        return this.clone().isub(ne);
      };
      function he(Ae, ne, oe) {
        oe.negative = ne.negative ^ Ae.negative;
        var ce = Ae.length + ne.length | 0;
        oe.length = ce, ce = ce - 1 | 0;
        var le = Ae.words[0] | 0, pe = ne.words[0] | 0, ye = le * pe, Ce = ye & 67108863, be = ye / 67108864 | 0;
        oe.words[0] = Ce;
        for (var ae = 1; ae < ce; ae++) {
          for (var ge = be >>> 26, Se = be & 67108863, Le = Math.min(ae, ne.length - 1), ze = Math.max(0, ae - Ae.length + 1); ze <= Le; ze++) {
            var Re = ae - ze | 0;
            le = Ae.words[Re] | 0, pe = ne.words[ze] | 0, ye = le * pe + Se, ge += ye / 67108864 | 0, Se = ye & 67108863;
          }
          oe.words[ae] = Se | 0, be = ge | 0;
        }
        return be !== 0 ? oe.words[ae] = be | 0 : oe.length--, oe.strip();
      }
      var me = function(ne, oe, ce) {
        var le = ne.words, pe = oe.words, ye = ce.words, Ce = 0, be, ae, ge, Se = le[0] | 0, Le = Se & 8191, ze = Se >>> 13, Re = le[1] | 0, We = Re & 8191, Be = Re >>> 13, Ue = le[2] | 0, Ge = Ue & 8191, je = Ue >>> 13, Oe = le[3] | 0, Ne = Oe & 8191, Ye = Oe >>> 13, Je = le[4] | 0, Xe = Je & 8191, st = Je >>> 13, ct = le[5] | 0, it = ct & 8191, ot = ct >>> 13, yt = le[6] | 0, dt = yt & 8191, mt = yt >>> 13, It = le[7] | 0, xt = It & 8191, Tt = It >>> 13, Yt = le[8] | 0, Ve = Yt & 8191, Pe = Yt >>> 13, $e = le[9] | 0, Ze = $e & 8191, at = $e >>> 13, wt = pe[0] | 0, ft = wt & 8191, Ct = wt >>> 13, Ut = pe[1] | 0, vt = Ut & 8191, Mt = Ut >>> 13, Xt = pe[2] | 0, St = Xt & 8191, Ot = Xt >>> 13, wn = pe[3] | 0, kt = wn & 8191, Bt = wn >>> 13, Tn = pe[4] | 0, Nt = Tn & 8191, Wt = Tn >>> 13, En = pe[5] | 0, Lt = En & 8191, Ht = En >>> 13, In = pe[6] | 0, Dt = In & 8191, Gt = In >>> 13, Ke = pe[7] | 0, Qe = Ke & 8191, et = Ke >>> 13, He = pe[8] | 0, nt = He & 8191, qe = He >>> 13, ht = pe[9] | 0, pt = ht & 8191, bt = ht >>> 13;
        ce.negative = ne.negative ^ oe.negative, ce.length = 19, be = Math.imul(Le, ft), ae = Math.imul(Le, Ct), ae = ae + Math.imul(ze, ft) | 0, ge = Math.imul(ze, Ct);
        var jt = (Ce + be | 0) + ((ae & 8191) << 13) | 0;
        Ce = (ge + (ae >>> 13) | 0) + (jt >>> 26) | 0, jt &= 67108863, be = Math.imul(We, ft), ae = Math.imul(We, Ct), ae = ae + Math.imul(Be, ft) | 0, ge = Math.imul(Be, Ct), be = be + Math.imul(Le, vt) | 0, ae = ae + Math.imul(Le, Mt) | 0, ae = ae + Math.imul(ze, vt) | 0, ge = ge + Math.imul(ze, Mt) | 0;
        var $t = (Ce + be | 0) + ((ae & 8191) << 13) | 0;
        Ce = (ge + (ae >>> 13) | 0) + ($t >>> 26) | 0, $t &= 67108863, be = Math.imul(Ge, ft), ae = Math.imul(Ge, Ct), ae = ae + Math.imul(je, ft) | 0, ge = Math.imul(je, Ct), be = be + Math.imul(We, vt) | 0, ae = ae + Math.imul(We, Mt) | 0, ae = ae + Math.imul(Be, vt) | 0, ge = ge + Math.imul(Be, Mt) | 0, be = be + Math.imul(Le, St) | 0, ae = ae + Math.imul(Le, Ot) | 0, ae = ae + Math.imul(ze, St) | 0, ge = ge + Math.imul(ze, Ot) | 0;
        var Jt = (Ce + be | 0) + ((ae & 8191) << 13) | 0;
        Ce = (ge + (ae >>> 13) | 0) + (Jt >>> 26) | 0, Jt &= 67108863, be = Math.imul(Ne, ft), ae = Math.imul(Ne, Ct), ae = ae + Math.imul(Ye, ft) | 0, ge = Math.imul(Ye, Ct), be = be + Math.imul(Ge, vt) | 0, ae = ae + Math.imul(Ge, Mt) | 0, ae = ae + Math.imul(je, vt) | 0, ge = ge + Math.imul(je, Mt) | 0, be = be + Math.imul(We, St) | 0, ae = ae + Math.imul(We, Ot) | 0, ae = ae + Math.imul(Be, St) | 0, ge = ge + Math.imul(Be, Ot) | 0, be = be + Math.imul(Le, kt) | 0, ae = ae + Math.imul(Le, Bt) | 0, ae = ae + Math.imul(ze, kt) | 0, ge = ge + Math.imul(ze, Bt) | 0;
        var zt = (Ce + be | 0) + ((ae & 8191) << 13) | 0;
        Ce = (ge + (ae >>> 13) | 0) + (zt >>> 26) | 0, zt &= 67108863, be = Math.imul(Xe, ft), ae = Math.imul(Xe, Ct), ae = ae + Math.imul(st, ft) | 0, ge = Math.imul(st, Ct), be = be + Math.imul(Ne, vt) | 0, ae = ae + Math.imul(Ne, Mt) | 0, ae = ae + Math.imul(Ye, vt) | 0, ge = ge + Math.imul(Ye, Mt) | 0, be = be + Math.imul(Ge, St) | 0, ae = ae + Math.imul(Ge, Ot) | 0, ae = ae + Math.imul(je, St) | 0, ge = ge + Math.imul(je, Ot) | 0, be = be + Math.imul(We, kt) | 0, ae = ae + Math.imul(We, Bt) | 0, ae = ae + Math.imul(Be, kt) | 0, ge = ge + Math.imul(Be, Bt) | 0, be = be + Math.imul(Le, Nt) | 0, ae = ae + Math.imul(Le, Wt) | 0, ae = ae + Math.imul(ze, Nt) | 0, ge = ge + Math.imul(ze, Wt) | 0;
        var Vt = (Ce + be | 0) + ((ae & 8191) << 13) | 0;
        Ce = (ge + (ae >>> 13) | 0) + (Vt >>> 26) | 0, Vt &= 67108863, be = Math.imul(it, ft), ae = Math.imul(it, Ct), ae = ae + Math.imul(ot, ft) | 0, ge = Math.imul(ot, Ct), be = be + Math.imul(Xe, vt) | 0, ae = ae + Math.imul(Xe, Mt) | 0, ae = ae + Math.imul(st, vt) | 0, ge = ge + Math.imul(st, Mt) | 0, be = be + Math.imul(Ne, St) | 0, ae = ae + Math.imul(Ne, Ot) | 0, ae = ae + Math.imul(Ye, St) | 0, ge = ge + Math.imul(Ye, Ot) | 0, be = be + Math.imul(Ge, kt) | 0, ae = ae + Math.imul(Ge, Bt) | 0, ae = ae + Math.imul(je, kt) | 0, ge = ge + Math.imul(je, Bt) | 0, be = be + Math.imul(We, Nt) | 0, ae = ae + Math.imul(We, Wt) | 0, ae = ae + Math.imul(Be, Nt) | 0, ge = ge + Math.imul(Be, Wt) | 0, be = be + Math.imul(Le, Lt) | 0, ae = ae + Math.imul(Le, Ht) | 0, ae = ae + Math.imul(ze, Lt) | 0, ge = ge + Math.imul(ze, Ht) | 0;
        var Kt = (Ce + be | 0) + ((ae & 8191) << 13) | 0;
        Ce = (ge + (ae >>> 13) | 0) + (Kt >>> 26) | 0, Kt &= 67108863, be = Math.imul(dt, ft), ae = Math.imul(dt, Ct), ae = ae + Math.imul(mt, ft) | 0, ge = Math.imul(mt, Ct), be = be + Math.imul(it, vt) | 0, ae = ae + Math.imul(it, Mt) | 0, ae = ae + Math.imul(ot, vt) | 0, ge = ge + Math.imul(ot, Mt) | 0, be = be + Math.imul(Xe, St) | 0, ae = ae + Math.imul(Xe, Ot) | 0, ae = ae + Math.imul(st, St) | 0, ge = ge + Math.imul(st, Ot) | 0, be = be + Math.imul(Ne, kt) | 0, ae = ae + Math.imul(Ne, Bt) | 0, ae = ae + Math.imul(Ye, kt) | 0, ge = ge + Math.imul(Ye, Bt) | 0, be = be + Math.imul(Ge, Nt) | 0, ae = ae + Math.imul(Ge, Wt) | 0, ae = ae + Math.imul(je, Nt) | 0, ge = ge + Math.imul(je, Wt) | 0, be = be + Math.imul(We, Lt) | 0, ae = ae + Math.imul(We, Ht) | 0, ae = ae + Math.imul(Be, Lt) | 0, ge = ge + Math.imul(Be, Ht) | 0, be = be + Math.imul(Le, Dt) | 0, ae = ae + Math.imul(Le, Gt) | 0, ae = ae + Math.imul(ze, Dt) | 0, ge = ge + Math.imul(ze, Gt) | 0;
        var pn = (Ce + be | 0) + ((ae & 8191) << 13) | 0;
        Ce = (ge + (ae >>> 13) | 0) + (pn >>> 26) | 0, pn &= 67108863, be = Math.imul(xt, ft), ae = Math.imul(xt, Ct), ae = ae + Math.imul(Tt, ft) | 0, ge = Math.imul(Tt, Ct), be = be + Math.imul(dt, vt) | 0, ae = ae + Math.imul(dt, Mt) | 0, ae = ae + Math.imul(mt, vt) | 0, ge = ge + Math.imul(mt, Mt) | 0, be = be + Math.imul(it, St) | 0, ae = ae + Math.imul(it, Ot) | 0, ae = ae + Math.imul(ot, St) | 0, ge = ge + Math.imul(ot, Ot) | 0, be = be + Math.imul(Xe, kt) | 0, ae = ae + Math.imul(Xe, Bt) | 0, ae = ae + Math.imul(st, kt) | 0, ge = ge + Math.imul(st, Bt) | 0, be = be + Math.imul(Ne, Nt) | 0, ae = ae + Math.imul(Ne, Wt) | 0, ae = ae + Math.imul(Ye, Nt) | 0, ge = ge + Math.imul(Ye, Wt) | 0, be = be + Math.imul(Ge, Lt) | 0, ae = ae + Math.imul(Ge, Ht) | 0, ae = ae + Math.imul(je, Lt) | 0, ge = ge + Math.imul(je, Ht) | 0, be = be + Math.imul(We, Dt) | 0, ae = ae + Math.imul(We, Gt) | 0, ae = ae + Math.imul(Be, Dt) | 0, ge = ge + Math.imul(Be, Gt) | 0, be = be + Math.imul(Le, Qe) | 0, ae = ae + Math.imul(Le, et) | 0, ae = ae + Math.imul(ze, Qe) | 0, ge = ge + Math.imul(ze, et) | 0;
        var An = (Ce + be | 0) + ((ae & 8191) << 13) | 0;
        Ce = (ge + (ae >>> 13) | 0) + (An >>> 26) | 0, An &= 67108863, be = Math.imul(Ve, ft), ae = Math.imul(Ve, Ct), ae = ae + Math.imul(Pe, ft) | 0, ge = Math.imul(Pe, Ct), be = be + Math.imul(xt, vt) | 0, ae = ae + Math.imul(xt, Mt) | 0, ae = ae + Math.imul(Tt, vt) | 0, ge = ge + Math.imul(Tt, Mt) | 0, be = be + Math.imul(dt, St) | 0, ae = ae + Math.imul(dt, Ot) | 0, ae = ae + Math.imul(mt, St) | 0, ge = ge + Math.imul(mt, Ot) | 0, be = be + Math.imul(it, kt) | 0, ae = ae + Math.imul(it, Bt) | 0, ae = ae + Math.imul(ot, kt) | 0, ge = ge + Math.imul(ot, Bt) | 0, be = be + Math.imul(Xe, Nt) | 0, ae = ae + Math.imul(Xe, Wt) | 0, ae = ae + Math.imul(st, Nt) | 0, ge = ge + Math.imul(st, Wt) | 0, be = be + Math.imul(Ne, Lt) | 0, ae = ae + Math.imul(Ne, Ht) | 0, ae = ae + Math.imul(Ye, Lt) | 0, ge = ge + Math.imul(Ye, Ht) | 0, be = be + Math.imul(Ge, Dt) | 0, ae = ae + Math.imul(Ge, Gt) | 0, ae = ae + Math.imul(je, Dt) | 0, ge = ge + Math.imul(je, Gt) | 0, be = be + Math.imul(We, Qe) | 0, ae = ae + Math.imul(We, et) | 0, ae = ae + Math.imul(Be, Qe) | 0, ge = ge + Math.imul(Be, et) | 0, be = be + Math.imul(Le, nt) | 0, ae = ae + Math.imul(Le, qe) | 0, ae = ae + Math.imul(ze, nt) | 0, ge = ge + Math.imul(ze, qe) | 0;
        var vn = (Ce + be | 0) + ((ae & 8191) << 13) | 0;
        Ce = (ge + (ae >>> 13) | 0) + (vn >>> 26) | 0, vn &= 67108863, be = Math.imul(Ze, ft), ae = Math.imul(Ze, Ct), ae = ae + Math.imul(at, ft) | 0, ge = Math.imul(at, Ct), be = be + Math.imul(Ve, vt) | 0, ae = ae + Math.imul(Ve, Mt) | 0, ae = ae + Math.imul(Pe, vt) | 0, ge = ge + Math.imul(Pe, Mt) | 0, be = be + Math.imul(xt, St) | 0, ae = ae + Math.imul(xt, Ot) | 0, ae = ae + Math.imul(Tt, St) | 0, ge = ge + Math.imul(Tt, Ot) | 0, be = be + Math.imul(dt, kt) | 0, ae = ae + Math.imul(dt, Bt) | 0, ae = ae + Math.imul(mt, kt) | 0, ge = ge + Math.imul(mt, Bt) | 0, be = be + Math.imul(it, Nt) | 0, ae = ae + Math.imul(it, Wt) | 0, ae = ae + Math.imul(ot, Nt) | 0, ge = ge + Math.imul(ot, Wt) | 0, be = be + Math.imul(Xe, Lt) | 0, ae = ae + Math.imul(Xe, Ht) | 0, ae = ae + Math.imul(st, Lt) | 0, ge = ge + Math.imul(st, Ht) | 0, be = be + Math.imul(Ne, Dt) | 0, ae = ae + Math.imul(Ne, Gt) | 0, ae = ae + Math.imul(Ye, Dt) | 0, ge = ge + Math.imul(Ye, Gt) | 0, be = be + Math.imul(Ge, Qe) | 0, ae = ae + Math.imul(Ge, et) | 0, ae = ae + Math.imul(je, Qe) | 0, ge = ge + Math.imul(je, et) | 0, be = be + Math.imul(We, nt) | 0, ae = ae + Math.imul(We, qe) | 0, ae = ae + Math.imul(Be, nt) | 0, ge = ge + Math.imul(Be, qe) | 0, be = be + Math.imul(Le, pt) | 0, ae = ae + Math.imul(Le, bt) | 0, ae = ae + Math.imul(ze, pt) | 0, ge = ge + Math.imul(ze, bt) | 0;
        var Cn = (Ce + be | 0) + ((ae & 8191) << 13) | 0;
        Ce = (ge + (ae >>> 13) | 0) + (Cn >>> 26) | 0, Cn &= 67108863, be = Math.imul(Ze, vt), ae = Math.imul(Ze, Mt), ae = ae + Math.imul(at, vt) | 0, ge = Math.imul(at, Mt), be = be + Math.imul(Ve, St) | 0, ae = ae + Math.imul(Ve, Ot) | 0, ae = ae + Math.imul(Pe, St) | 0, ge = ge + Math.imul(Pe, Ot) | 0, be = be + Math.imul(xt, kt) | 0, ae = ae + Math.imul(xt, Bt) | 0, ae = ae + Math.imul(Tt, kt) | 0, ge = ge + Math.imul(Tt, Bt) | 0, be = be + Math.imul(dt, Nt) | 0, ae = ae + Math.imul(dt, Wt) | 0, ae = ae + Math.imul(mt, Nt) | 0, ge = ge + Math.imul(mt, Wt) | 0, be = be + Math.imul(it, Lt) | 0, ae = ae + Math.imul(it, Ht) | 0, ae = ae + Math.imul(ot, Lt) | 0, ge = ge + Math.imul(ot, Ht) | 0, be = be + Math.imul(Xe, Dt) | 0, ae = ae + Math.imul(Xe, Gt) | 0, ae = ae + Math.imul(st, Dt) | 0, ge = ge + Math.imul(st, Gt) | 0, be = be + Math.imul(Ne, Qe) | 0, ae = ae + Math.imul(Ne, et) | 0, ae = ae + Math.imul(Ye, Qe) | 0, ge = ge + Math.imul(Ye, et) | 0, be = be + Math.imul(Ge, nt) | 0, ae = ae + Math.imul(Ge, qe) | 0, ae = ae + Math.imul(je, nt) | 0, ge = ge + Math.imul(je, qe) | 0, be = be + Math.imul(We, pt) | 0, ae = ae + Math.imul(We, bt) | 0, ae = ae + Math.imul(Be, pt) | 0, ge = ge + Math.imul(Be, bt) | 0;
        var yn = (Ce + be | 0) + ((ae & 8191) << 13) | 0;
        Ce = (ge + (ae >>> 13) | 0) + (yn >>> 26) | 0, yn &= 67108863, be = Math.imul(Ze, St), ae = Math.imul(Ze, Ot), ae = ae + Math.imul(at, St) | 0, ge = Math.imul(at, Ot), be = be + Math.imul(Ve, kt) | 0, ae = ae + Math.imul(Ve, Bt) | 0, ae = ae + Math.imul(Pe, kt) | 0, ge = ge + Math.imul(Pe, Bt) | 0, be = be + Math.imul(xt, Nt) | 0, ae = ae + Math.imul(xt, Wt) | 0, ae = ae + Math.imul(Tt, Nt) | 0, ge = ge + Math.imul(Tt, Wt) | 0, be = be + Math.imul(dt, Lt) | 0, ae = ae + Math.imul(dt, Ht) | 0, ae = ae + Math.imul(mt, Lt) | 0, ge = ge + Math.imul(mt, Ht) | 0, be = be + Math.imul(it, Dt) | 0, ae = ae + Math.imul(it, Gt) | 0, ae = ae + Math.imul(ot, Dt) | 0, ge = ge + Math.imul(ot, Gt) | 0, be = be + Math.imul(Xe, Qe) | 0, ae = ae + Math.imul(Xe, et) | 0, ae = ae + Math.imul(st, Qe) | 0, ge = ge + Math.imul(st, et) | 0, be = be + Math.imul(Ne, nt) | 0, ae = ae + Math.imul(Ne, qe) | 0, ae = ae + Math.imul(Ye, nt) | 0, ge = ge + Math.imul(Ye, qe) | 0, be = be + Math.imul(Ge, pt) | 0, ae = ae + Math.imul(Ge, bt) | 0, ae = ae + Math.imul(je, pt) | 0, ge = ge + Math.imul(je, bt) | 0;
        var dn = (Ce + be | 0) + ((ae & 8191) << 13) | 0;
        Ce = (ge + (ae >>> 13) | 0) + (dn >>> 26) | 0, dn &= 67108863, be = Math.imul(Ze, kt), ae = Math.imul(Ze, Bt), ae = ae + Math.imul(at, kt) | 0, ge = Math.imul(at, Bt), be = be + Math.imul(Ve, Nt) | 0, ae = ae + Math.imul(Ve, Wt) | 0, ae = ae + Math.imul(Pe, Nt) | 0, ge = ge + Math.imul(Pe, Wt) | 0, be = be + Math.imul(xt, Lt) | 0, ae = ae + Math.imul(xt, Ht) | 0, ae = ae + Math.imul(Tt, Lt) | 0, ge = ge + Math.imul(Tt, Ht) | 0, be = be + Math.imul(dt, Dt) | 0, ae = ae + Math.imul(dt, Gt) | 0, ae = ae + Math.imul(mt, Dt) | 0, ge = ge + Math.imul(mt, Gt) | 0, be = be + Math.imul(it, Qe) | 0, ae = ae + Math.imul(it, et) | 0, ae = ae + Math.imul(ot, Qe) | 0, ge = ge + Math.imul(ot, et) | 0, be = be + Math.imul(Xe, nt) | 0, ae = ae + Math.imul(Xe, qe) | 0, ae = ae + Math.imul(st, nt) | 0, ge = ge + Math.imul(st, qe) | 0, be = be + Math.imul(Ne, pt) | 0, ae = ae + Math.imul(Ne, bt) | 0, ae = ae + Math.imul(Ye, pt) | 0, ge = ge + Math.imul(Ye, bt) | 0;
        var xn = (Ce + be | 0) + ((ae & 8191) << 13) | 0;
        Ce = (ge + (ae >>> 13) | 0) + (xn >>> 26) | 0, xn &= 67108863, be = Math.imul(Ze, Nt), ae = Math.imul(Ze, Wt), ae = ae + Math.imul(at, Nt) | 0, ge = Math.imul(at, Wt), be = be + Math.imul(Ve, Lt) | 0, ae = ae + Math.imul(Ve, Ht) | 0, ae = ae + Math.imul(Pe, Lt) | 0, ge = ge + Math.imul(Pe, Ht) | 0, be = be + Math.imul(xt, Dt) | 0, ae = ae + Math.imul(xt, Gt) | 0, ae = ae + Math.imul(Tt, Dt) | 0, ge = ge + Math.imul(Tt, Gt) | 0, be = be + Math.imul(dt, Qe) | 0, ae = ae + Math.imul(dt, et) | 0, ae = ae + Math.imul(mt, Qe) | 0, ge = ge + Math.imul(mt, et) | 0, be = be + Math.imul(it, nt) | 0, ae = ae + Math.imul(it, qe) | 0, ae = ae + Math.imul(ot, nt) | 0, ge = ge + Math.imul(ot, qe) | 0, be = be + Math.imul(Xe, pt) | 0, ae = ae + Math.imul(Xe, bt) | 0, ae = ae + Math.imul(st, pt) | 0, ge = ge + Math.imul(st, bt) | 0;
        var ln = (Ce + be | 0) + ((ae & 8191) << 13) | 0;
        Ce = (ge + (ae >>> 13) | 0) + (ln >>> 26) | 0, ln &= 67108863, be = Math.imul(Ze, Lt), ae = Math.imul(Ze, Ht), ae = ae + Math.imul(at, Lt) | 0, ge = Math.imul(at, Ht), be = be + Math.imul(Ve, Dt) | 0, ae = ae + Math.imul(Ve, Gt) | 0, ae = ae + Math.imul(Pe, Dt) | 0, ge = ge + Math.imul(Pe, Gt) | 0, be = be + Math.imul(xt, Qe) | 0, ae = ae + Math.imul(xt, et) | 0, ae = ae + Math.imul(Tt, Qe) | 0, ge = ge + Math.imul(Tt, et) | 0, be = be + Math.imul(dt, nt) | 0, ae = ae + Math.imul(dt, qe) | 0, ae = ae + Math.imul(mt, nt) | 0, ge = ge + Math.imul(mt, qe) | 0, be = be + Math.imul(it, pt) | 0, ae = ae + Math.imul(it, bt) | 0, ae = ae + Math.imul(ot, pt) | 0, ge = ge + Math.imul(ot, bt) | 0;
        var mn = (Ce + be | 0) + ((ae & 8191) << 13) | 0;
        Ce = (ge + (ae >>> 13) | 0) + (mn >>> 26) | 0, mn &= 67108863, be = Math.imul(Ze, Dt), ae = Math.imul(Ze, Gt), ae = ae + Math.imul(at, Dt) | 0, ge = Math.imul(at, Gt), be = be + Math.imul(Ve, Qe) | 0, ae = ae + Math.imul(Ve, et) | 0, ae = ae + Math.imul(Pe, Qe) | 0, ge = ge + Math.imul(Pe, et) | 0, be = be + Math.imul(xt, nt) | 0, ae = ae + Math.imul(xt, qe) | 0, ae = ae + Math.imul(Tt, nt) | 0, ge = ge + Math.imul(Tt, qe) | 0, be = be + Math.imul(dt, pt) | 0, ae = ae + Math.imul(dt, bt) | 0, ae = ae + Math.imul(mt, pt) | 0, ge = ge + Math.imul(mt, bt) | 0;
        var gn = (Ce + be | 0) + ((ae & 8191) << 13) | 0;
        Ce = (ge + (ae >>> 13) | 0) + (gn >>> 26) | 0, gn &= 67108863, be = Math.imul(Ze, Qe), ae = Math.imul(Ze, et), ae = ae + Math.imul(at, Qe) | 0, ge = Math.imul(at, et), be = be + Math.imul(Ve, nt) | 0, ae = ae + Math.imul(Ve, qe) | 0, ae = ae + Math.imul(Pe, nt) | 0, ge = ge + Math.imul(Pe, qe) | 0, be = be + Math.imul(xt, pt) | 0, ae = ae + Math.imul(xt, bt) | 0, ae = ae + Math.imul(Tt, pt) | 0, ge = ge + Math.imul(Tt, bt) | 0;
        var cn = (Ce + be | 0) + ((ae & 8191) << 13) | 0;
        Ce = (ge + (ae >>> 13) | 0) + (cn >>> 26) | 0, cn &= 67108863, be = Math.imul(Ze, nt), ae = Math.imul(Ze, qe), ae = ae + Math.imul(at, nt) | 0, ge = Math.imul(at, qe), be = be + Math.imul(Ve, pt) | 0, ae = ae + Math.imul(Ve, bt) | 0, ae = ae + Math.imul(Pe, pt) | 0, ge = ge + Math.imul(Pe, bt) | 0;
        var Pt = (Ce + be | 0) + ((ae & 8191) << 13) | 0;
        Ce = (ge + (ae >>> 13) | 0) + (Pt >>> 26) | 0, Pt &= 67108863, be = Math.imul(Ze, pt), ae = Math.imul(Ze, bt), ae = ae + Math.imul(at, pt) | 0, ge = Math.imul(at, bt);
        var Rt = (Ce + be | 0) + ((ae & 8191) << 13) | 0;
        return Ce = (ge + (ae >>> 13) | 0) + (Rt >>> 26) | 0, Rt &= 67108863, ye[0] = jt, ye[1] = $t, ye[2] = Jt, ye[3] = zt, ye[4] = Vt, ye[5] = Kt, ye[6] = pn, ye[7] = An, ye[8] = vn, ye[9] = Cn, ye[10] = yn, ye[11] = dn, ye[12] = xn, ye[13] = ln, ye[14] = mn, ye[15] = gn, ye[16] = cn, ye[17] = Pt, ye[18] = Rt, Ce !== 0 && (ye[19] = Ce, ce.length++), ce;
      };
      Math.imul || (me = he);
      function xe(Ae, ne, oe) {
        oe.negative = ne.negative ^ Ae.negative, oe.length = Ae.length + ne.length;
        for (var ce = 0, le = 0, pe = 0; pe < oe.length - 1; pe++) {
          var ye = le;
          le = 0;
          for (var Ce = ce & 67108863, be = Math.min(pe, ne.length - 1), ae = Math.max(0, pe - Ae.length + 1); ae <= be; ae++) {
            var ge = pe - ae, Se = Ae.words[ge] | 0, Le = ne.words[ae] | 0, ze = Se * Le, Re = ze & 67108863;
            ye = ye + (ze / 67108864 | 0) | 0, Re = Re + Ce | 0, Ce = Re & 67108863, ye = ye + (Re >>> 26) | 0, le += ye >>> 26, ye &= 67108863;
          }
          oe.words[pe] = Ce, ce = ye, ye = le;
        }
        return ce !== 0 ? oe.words[pe] = ce : oe.length--, oe.strip();
      }
      function ve(Ae, ne, oe) {
        var ce = new Te();
        return ce.mulp(Ae, ne, oe);
      }
      J.prototype.mulTo = function(ne, oe) {
        var ce, le = this.length + ne.length;
        return this.length === 10 && ne.length === 10 ? ce = me(this, ne, oe) : le < 63 ? ce = he(this, ne, oe) : le < 1024 ? ce = xe(this, ne, oe) : ce = ve(this, ne, oe), ce;
      };
      function Te(Ae, ne) {
        this.x = Ae, this.y = ne;
      }
      Te.prototype.makeRBT = function(ne) {
        for (var oe = new Array(ne), ce = J.prototype._countBits(ne) - 1, le = 0; le < ne; le++)
          oe[le] = this.revBin(le, ce, ne);
        return oe;
      }, Te.prototype.revBin = function(ne, oe, ce) {
        if (ne === 0 || ne === ce - 1) return ne;
        for (var le = 0, pe = 0; pe < oe; pe++)
          le |= (ne & 1) << oe - pe - 1, ne >>= 1;
        return le;
      }, Te.prototype.permute = function(ne, oe, ce, le, pe, ye) {
        for (var Ce = 0; Ce < ye; Ce++)
          le[Ce] = oe[ne[Ce]], pe[Ce] = ce[ne[Ce]];
      }, Te.prototype.transform = function(ne, oe, ce, le, pe, ye) {
        this.permute(ye, ne, oe, ce, le, pe);
        for (var Ce = 1; Ce < pe; Ce <<= 1)
          for (var be = Ce << 1, ae = Math.cos(2 * Math.PI / be), ge = Math.sin(2 * Math.PI / be), Se = 0; Se < pe; Se += be)
            for (var Le = ae, ze = ge, Re = 0; Re < Ce; Re++) {
              var We = ce[Se + Re], Be = le[Se + Re], Ue = ce[Se + Re + Ce], Ge = le[Se + Re + Ce], je = Le * Ue - ze * Ge;
              Ge = Le * Ge + ze * Ue, Ue = je, ce[Se + Re] = We + Ue, le[Se + Re] = Be + Ge, ce[Se + Re + Ce] = We - Ue, le[Se + Re + Ce] = Be - Ge, Re !== be && (je = ae * Le - ge * ze, ze = ae * ze + ge * Le, Le = je);
            }
      }, Te.prototype.guessLen13b = function(ne, oe) {
        var ce = Math.max(oe, ne) | 1, le = ce & 1, pe = 0;
        for (ce = ce / 2 | 0; ce; ce = ce >>> 1)
          pe++;
        return 1 << pe + 1 + le;
      }, Te.prototype.conjugate = function(ne, oe, ce) {
        if (!(ce <= 1))
          for (var le = 0; le < ce / 2; le++) {
            var pe = ne[le];
            ne[le] = ne[ce - le - 1], ne[ce - le - 1] = pe, pe = oe[le], oe[le] = -oe[ce - le - 1], oe[ce - le - 1] = -pe;
          }
      }, Te.prototype.normalize13b = function(ne, oe) {
        for (var ce = 0, le = 0; le < oe / 2; le++) {
          var pe = Math.round(ne[2 * le + 1] / oe) * 8192 + Math.round(ne[2 * le] / oe) + ce;
          ne[le] = pe & 67108863, pe < 67108864 ? ce = 0 : ce = pe / 67108864 | 0;
        }
        return ne;
      }, Te.prototype.convert13b = function(ne, oe, ce, le) {
        for (var pe = 0, ye = 0; ye < oe; ye++)
          pe = pe + (ne[ye] | 0), ce[2 * ye] = pe & 8191, pe = pe >>> 13, ce[2 * ye + 1] = pe & 8191, pe = pe >>> 13;
        for (ye = 2 * oe; ye < le; ++ye)
          ce[ye] = 0;
        $(pe === 0), $((pe & -8192) === 0);
      }, Te.prototype.stub = function(ne) {
        for (var oe = new Array(ne), ce = 0; ce < ne; ce++)
          oe[ce] = 0;
        return oe;
      }, Te.prototype.mulp = function(ne, oe, ce) {
        var le = 2 * this.guessLen13b(ne.length, oe.length), pe = this.makeRBT(le), ye = this.stub(le), Ce = new Array(le), be = new Array(le), ae = new Array(le), ge = new Array(le), Se = new Array(le), Le = new Array(le), ze = ce.words;
        ze.length = le, this.convert13b(ne.words, ne.length, Ce, le), this.convert13b(oe.words, oe.length, ge, le), this.transform(Ce, ye, be, ae, le, pe), this.transform(ge, ye, Se, Le, le, pe);
        for (var Re = 0; Re < le; Re++) {
          var We = be[Re] * Se[Re] - ae[Re] * Le[Re];
          ae[Re] = be[Re] * Le[Re] + ae[Re] * Se[Re], be[Re] = We;
        }
        return this.conjugate(be, ae, le), this.transform(be, ae, ze, ye, le, pe), this.conjugate(ze, ye, le), this.normalize13b(ze, le), ce.negative = ne.negative ^ oe.negative, ce.length = ne.length + oe.length, ce.strip();
      }, J.prototype.mul = function(ne) {
        var oe = new J(null);
        return oe.words = new Array(this.length + ne.length), this.mulTo(ne, oe);
      }, J.prototype.mulf = function(ne) {
        var oe = new J(null);
        return oe.words = new Array(this.length + ne.length), ve(this, ne, oe);
      }, J.prototype.imul = function(ne) {
        return this.clone().mulTo(ne, this);
      }, J.prototype.imuln = function(ne) {
        $(typeof ne == "number"), $(ne < 67108864);
        for (var oe = 0, ce = 0; ce < this.length; ce++) {
          var le = (this.words[ce] | 0) * ne, pe = (le & 67108863) + (oe & 67108863);
          oe >>= 26, oe += le / 67108864 | 0, oe += pe >>> 26, this.words[ce] = pe & 67108863;
        }
        return oe !== 0 && (this.words[ce] = oe, this.length++), this;
      }, J.prototype.muln = function(ne) {
        return this.clone().imuln(ne);
      }, J.prototype.sqr = function() {
        return this.mul(this);
      }, J.prototype.isqr = function() {
        return this.imul(this.clone());
      }, J.prototype.pow = function(ne) {
        var oe = fe(ne);
        if (oe.length === 0) return new J(1);
        for (var ce = this, le = 0; le < oe.length && oe[le] === 0; le++, ce = ce.sqr())
          ;
        if (++le < oe.length)
          for (var pe = ce.sqr(); le < oe.length; le++, pe = pe.sqr())
            oe[le] !== 0 && (ce = ce.mul(pe));
        return ce;
      }, J.prototype.iushln = function(ne) {
        $(typeof ne == "number" && ne >= 0);
        var oe = ne % 26, ce = (ne - oe) / 26, le = 67108863 >>> 26 - oe << 26 - oe, pe;
        if (oe !== 0) {
          var ye = 0;
          for (pe = 0; pe < this.length; pe++) {
            var Ce = this.words[pe] & le, be = (this.words[pe] | 0) - Ce << oe;
            this.words[pe] = be | ye, ye = Ce >>> 26 - oe;
          }
          ye && (this.words[pe] = ye, this.length++);
        }
        if (ce !== 0) {
          for (pe = this.length - 1; pe >= 0; pe--)
            this.words[pe + ce] = this.words[pe];
          for (pe = 0; pe < ce; pe++)
            this.words[pe] = 0;
          this.length += ce;
        }
        return this.strip();
      }, J.prototype.ishln = function(ne) {
        return $(this.negative === 0), this.iushln(ne);
      }, J.prototype.iushrn = function(ne, oe, ce) {
        $(typeof ne == "number" && ne >= 0);
        var le;
        oe ? le = (oe - oe % 26) / 26 : le = 0;
        var pe = ne % 26, ye = Math.min((ne - pe) / 26, this.length), Ce = 67108863 ^ 67108863 >>> pe << pe, be = ce;
        if (le -= ye, le = Math.max(0, le), be) {
          for (var ae = 0; ae < ye; ae++)
            be.words[ae] = this.words[ae];
          be.length = ye;
        }
        if (ye !== 0) if (this.length > ye)
          for (this.length -= ye, ae = 0; ae < this.length; ae++)
            this.words[ae] = this.words[ae + ye];
        else
          this.words[0] = 0, this.length = 1;
        var ge = 0;
        for (ae = this.length - 1; ae >= 0 && (ge !== 0 || ae >= le); ae--) {
          var Se = this.words[ae] | 0;
          this.words[ae] = ge << 26 - pe | Se >>> pe, ge = Se & Ce;
        }
        return be && ge !== 0 && (be.words[be.length++] = ge), this.length === 0 && (this.words[0] = 0, this.length = 1), this.strip();
      }, J.prototype.ishrn = function(ne, oe, ce) {
        return $(this.negative === 0), this.iushrn(ne, oe, ce);
      }, J.prototype.shln = function(ne) {
        return this.clone().ishln(ne);
      }, J.prototype.ushln = function(ne) {
        return this.clone().iushln(ne);
      }, J.prototype.shrn = function(ne) {
        return this.clone().ishrn(ne);
      }, J.prototype.ushrn = function(ne) {
        return this.clone().iushrn(ne);
      }, J.prototype.testn = function(ne) {
        $(typeof ne == "number" && ne >= 0);
        var oe = ne % 26, ce = (ne - oe) / 26, le = 1 << oe;
        if (this.length <= ce) return !1;
        var pe = this.words[ce];
        return !!(pe & le);
      }, J.prototype.imaskn = function(ne) {
        $(typeof ne == "number" && ne >= 0);
        var oe = ne % 26, ce = (ne - oe) / 26;
        if ($(this.negative === 0, "imaskn works only with positive numbers"), this.length <= ce)
          return this;
        if (oe !== 0 && ce++, this.length = Math.min(ce, this.length), oe !== 0) {
          var le = 67108863 ^ 67108863 >>> oe << oe;
          this.words[this.length - 1] &= le;
        }
        return this.strip();
      }, J.prototype.maskn = function(ne) {
        return this.clone().imaskn(ne);
      }, J.prototype.iaddn = function(ne) {
        return $(typeof ne == "number"), $(ne < 67108864), ne < 0 ? this.isubn(-ne) : this.negative !== 0 ? this.length === 1 && (this.words[0] | 0) < ne ? (this.words[0] = ne - (this.words[0] | 0), this.negative = 0, this) : (this.negative = 0, this.isubn(ne), this.negative = 1, this) : this._iaddn(ne);
      }, J.prototype._iaddn = function(ne) {
        this.words[0] += ne;
        for (var oe = 0; oe < this.length && this.words[oe] >= 67108864; oe++)
          this.words[oe] -= 67108864, oe === this.length - 1 ? this.words[oe + 1] = 1 : this.words[oe + 1]++;
        return this.length = Math.max(this.length, oe + 1), this;
      }, J.prototype.isubn = function(ne) {
        if ($(typeof ne == "number"), $(ne < 67108864), ne < 0) return this.iaddn(-ne);
        if (this.negative !== 0)
          return this.negative = 0, this.iaddn(ne), this.negative = 1, this;
        if (this.words[0] -= ne, this.length === 1 && this.words[0] < 0)
          this.words[0] = -this.words[0], this.negative = 1;
        else
          for (var oe = 0; oe < this.length && this.words[oe] < 0; oe++)
            this.words[oe] += 67108864, this.words[oe + 1] -= 1;
        return this.strip();
      }, J.prototype.addn = function(ne) {
        return this.clone().iaddn(ne);
      }, J.prototype.subn = function(ne) {
        return this.clone().isubn(ne);
      }, J.prototype.iabs = function() {
        return this.negative = 0, this;
      }, J.prototype.abs = function() {
        return this.clone().iabs();
      }, J.prototype._ishlnsubmul = function(ne, oe, ce) {
        var le = ne.length + ce, pe;
        this._expand(le);
        var ye, Ce = 0;
        for (pe = 0; pe < ne.length; pe++) {
          ye = (this.words[pe + ce] | 0) + Ce;
          var be = (ne.words[pe] | 0) * oe;
          ye -= be & 67108863, Ce = (ye >> 26) - (be / 67108864 | 0), this.words[pe + ce] = ye & 67108863;
        }
        for (; pe < this.length - ce; pe++)
          ye = (this.words[pe + ce] | 0) + Ce, Ce = ye >> 26, this.words[pe + ce] = ye & 67108863;
        if (Ce === 0) return this.strip();
        for ($(Ce === -1), Ce = 0, pe = 0; pe < this.length; pe++)
          ye = -(this.words[pe] | 0) + Ce, Ce = ye >> 26, this.words[pe] = ye & 67108863;
        return this.negative = 1, this.strip();
      }, J.prototype._wordDiv = function(ne, oe) {
        var ce = this.length - ne.length, le = this.clone(), pe = ne, ye = pe.words[pe.length - 1] | 0, Ce = this._countBits(ye);
        ce = 26 - Ce, ce !== 0 && (pe = pe.ushln(ce), le.iushln(ce), ye = pe.words[pe.length - 1] | 0);
        var be = le.length - pe.length, ae;
        if (oe !== "mod") {
          ae = new J(null), ae.length = be + 1, ae.words = new Array(ae.length);
          for (var ge = 0; ge < ae.length; ge++)
            ae.words[ge] = 0;
        }
        var Se = le.clone()._ishlnsubmul(pe, 1, be);
        Se.negative === 0 && (le = Se, ae && (ae.words[be] = 1));
        for (var Le = be - 1; Le >= 0; Le--) {
          var ze = (le.words[pe.length + Le] | 0) * 67108864 + (le.words[pe.length + Le - 1] | 0);
          for (ze = Math.min(ze / ye | 0, 67108863), le._ishlnsubmul(pe, ze, Le); le.negative !== 0; )
            ze--, le.negative = 0, le._ishlnsubmul(pe, 1, Le), le.isZero() || (le.negative ^= 1);
          ae && (ae.words[Le] = ze);
        }
        return ae && ae.strip(), le.strip(), oe !== "div" && ce !== 0 && le.iushrn(ce), {
          div: ae || null,
          mod: le
        };
      }, J.prototype.divmod = function(ne, oe, ce) {
        if ($(!ne.isZero()), this.isZero())
          return {
            div: new J(0),
            mod: new J(0)
          };
        var le, pe, ye;
        return this.negative !== 0 && ne.negative === 0 ? (ye = this.neg().divmod(ne, oe), oe !== "mod" && (le = ye.div.neg()), oe !== "div" && (pe = ye.mod.neg(), ce && pe.negative !== 0 && pe.iadd(ne)), {
          div: le,
          mod: pe
        }) : this.negative === 0 && ne.negative !== 0 ? (ye = this.divmod(ne.neg(), oe), oe !== "mod" && (le = ye.div.neg()), {
          div: le,
          mod: ye.mod
        }) : this.negative & ne.negative ? (ye = this.neg().divmod(ne.neg(), oe), oe !== "div" && (pe = ye.mod.neg(), ce && pe.negative !== 0 && pe.isub(ne)), {
          div: ye.div,
          mod: pe
        }) : ne.length > this.length || this.cmp(ne) < 0 ? {
          div: new J(0),
          mod: this
        } : ne.length === 1 ? oe === "div" ? {
          div: this.divn(ne.words[0]),
          mod: null
        } : oe === "mod" ? {
          div: null,
          mod: new J(this.modn(ne.words[0]))
        } : {
          div: this.divn(ne.words[0]),
          mod: new J(this.modn(ne.words[0]))
        } : this._wordDiv(ne, oe);
      }, J.prototype.div = function(ne) {
        return this.divmod(ne, "div", !1).div;
      }, J.prototype.mod = function(ne) {
        return this.divmod(ne, "mod", !1).mod;
      }, J.prototype.umod = function(ne) {
        return this.divmod(ne, "mod", !0).mod;
      }, J.prototype.divRound = function(ne) {
        var oe = this.divmod(ne);
        if (oe.mod.isZero()) return oe.div;
        var ce = oe.div.negative !== 0 ? oe.mod.isub(ne) : oe.mod, le = ne.ushrn(1), pe = ne.andln(1), ye = ce.cmp(le);
        return ye < 0 || pe === 1 && ye === 0 ? oe.div : oe.div.negative !== 0 ? oe.div.isubn(1) : oe.div.iaddn(1);
      }, J.prototype.modn = function(ne) {
        $(ne <= 67108863);
        for (var oe = (1 << 26) % ne, ce = 0, le = this.length - 1; le >= 0; le--)
          ce = (oe * ce + (this.words[le] | 0)) % ne;
        return ce;
      }, J.prototype.idivn = function(ne) {
        $(ne <= 67108863);
        for (var oe = 0, ce = this.length - 1; ce >= 0; ce--) {
          var le = (this.words[ce] | 0) + oe * 67108864;
          this.words[ce] = le / ne | 0, oe = le % ne;
        }
        return this.strip();
      }, J.prototype.divn = function(ne) {
        return this.clone().idivn(ne);
      }, J.prototype.egcd = function(ne) {
        $(ne.negative === 0), $(!ne.isZero());
        var oe = this, ce = ne.clone();
        oe.negative !== 0 ? oe = oe.umod(ne) : oe = oe.clone();
        for (var le = new J(1), pe = new J(0), ye = new J(0), Ce = new J(1), be = 0; oe.isEven() && ce.isEven(); )
          oe.iushrn(1), ce.iushrn(1), ++be;
        for (var ae = ce.clone(), ge = oe.clone(); !oe.isZero(); ) {
          for (var Se = 0, Le = 1; !(oe.words[0] & Le) && Se < 26; ++Se, Le <<= 1) ;
          if (Se > 0)
            for (oe.iushrn(Se); Se-- > 0; )
              (le.isOdd() || pe.isOdd()) && (le.iadd(ae), pe.isub(ge)), le.iushrn(1), pe.iushrn(1);
          for (var ze = 0, Re = 1; !(ce.words[0] & Re) && ze < 26; ++ze, Re <<= 1) ;
          if (ze > 0)
            for (ce.iushrn(ze); ze-- > 0; )
              (ye.isOdd() || Ce.isOdd()) && (ye.iadd(ae), Ce.isub(ge)), ye.iushrn(1), Ce.iushrn(1);
          oe.cmp(ce) >= 0 ? (oe.isub(ce), le.isub(ye), pe.isub(Ce)) : (ce.isub(oe), ye.isub(le), Ce.isub(pe));
        }
        return {
          a: ye,
          b: Ce,
          gcd: ce.iushln(be)
        };
      }, J.prototype._invmp = function(ne) {
        $(ne.negative === 0), $(!ne.isZero());
        var oe = this, ce = ne.clone();
        oe.negative !== 0 ? oe = oe.umod(ne) : oe = oe.clone();
        for (var le = new J(1), pe = new J(0), ye = ce.clone(); oe.cmpn(1) > 0 && ce.cmpn(1) > 0; ) {
          for (var Ce = 0, be = 1; !(oe.words[0] & be) && Ce < 26; ++Ce, be <<= 1) ;
          if (Ce > 0)
            for (oe.iushrn(Ce); Ce-- > 0; )
              le.isOdd() && le.iadd(ye), le.iushrn(1);
          for (var ae = 0, ge = 1; !(ce.words[0] & ge) && ae < 26; ++ae, ge <<= 1) ;
          if (ae > 0)
            for (ce.iushrn(ae); ae-- > 0; )
              pe.isOdd() && pe.iadd(ye), pe.iushrn(1);
          oe.cmp(ce) >= 0 ? (oe.isub(ce), le.isub(pe)) : (ce.isub(oe), pe.isub(le));
        }
        var Se;
        return oe.cmpn(1) === 0 ? Se = le : Se = pe, Se.cmpn(0) < 0 && Se.iadd(ne), Se;
      }, J.prototype.gcd = function(ne) {
        if (this.isZero()) return ne.abs();
        if (ne.isZero()) return this.abs();
        var oe = this.clone(), ce = ne.clone();
        oe.negative = 0, ce.negative = 0;
        for (var le = 0; oe.isEven() && ce.isEven(); le++)
          oe.iushrn(1), ce.iushrn(1);
        do {
          for (; oe.isEven(); )
            oe.iushrn(1);
          for (; ce.isEven(); )
            ce.iushrn(1);
          var pe = oe.cmp(ce);
          if (pe < 0) {
            var ye = oe;
            oe = ce, ce = ye;
          } else if (pe === 0 || ce.cmpn(1) === 0)
            break;
          oe.isub(ce);
        } while (!0);
        return ce.iushln(le);
      }, J.prototype.invm = function(ne) {
        return this.egcd(ne).a.umod(ne);
      }, J.prototype.isEven = function() {
        return (this.words[0] & 1) === 0;
      }, J.prototype.isOdd = function() {
        return (this.words[0] & 1) === 1;
      }, J.prototype.andln = function(ne) {
        return this.words[0] & ne;
      }, J.prototype.bincn = function(ne) {
        $(typeof ne == "number");
        var oe = ne % 26, ce = (ne - oe) / 26, le = 1 << oe;
        if (this.length <= ce)
          return this._expand(ce + 1), this.words[ce] |= le, this;
        for (var pe = le, ye = ce; pe !== 0 && ye < this.length; ye++) {
          var Ce = this.words[ye] | 0;
          Ce += pe, pe = Ce >>> 26, Ce &= 67108863, this.words[ye] = Ce;
        }
        return pe !== 0 && (this.words[ye] = pe, this.length++), this;
      }, J.prototype.isZero = function() {
        return this.length === 1 && this.words[0] === 0;
      }, J.prototype.cmpn = function(ne) {
        var oe = ne < 0;
        if (this.negative !== 0 && !oe) return -1;
        if (this.negative === 0 && oe) return 1;
        this.strip();
        var ce;
        if (this.length > 1)
          ce = 1;
        else {
          oe && (ne = -ne), $(ne <= 67108863, "Number is too big");
          var le = this.words[0] | 0;
          ce = le === ne ? 0 : le < ne ? -1 : 1;
        }
        return this.negative !== 0 ? -ce | 0 : ce;
      }, J.prototype.cmp = function(ne) {
        if (this.negative !== 0 && ne.negative === 0) return -1;
        if (this.negative === 0 && ne.negative !== 0) return 1;
        var oe = this.ucmp(ne);
        return this.negative !== 0 ? -oe | 0 : oe;
      }, J.prototype.ucmp = function(ne) {
        if (this.length > ne.length) return 1;
        if (this.length < ne.length) return -1;
        for (var oe = 0, ce = this.length - 1; ce >= 0; ce--) {
          var le = this.words[ce] | 0, pe = ne.words[ce] | 0;
          if (le !== pe) {
            le < pe ? oe = -1 : le > pe && (oe = 1);
            break;
          }
        }
        return oe;
      }, J.prototype.gtn = function(ne) {
        return this.cmpn(ne) === 1;
      }, J.prototype.gt = function(ne) {
        return this.cmp(ne) === 1;
      }, J.prototype.gten = function(ne) {
        return this.cmpn(ne) >= 0;
      }, J.prototype.gte = function(ne) {
        return this.cmp(ne) >= 0;
      }, J.prototype.ltn = function(ne) {
        return this.cmpn(ne) === -1;
      }, J.prototype.lt = function(ne) {
        return this.cmp(ne) === -1;
      }, J.prototype.lten = function(ne) {
        return this.cmpn(ne) <= 0;
      }, J.prototype.lte = function(ne) {
        return this.cmp(ne) <= 0;
      }, J.prototype.eqn = function(ne) {
        return this.cmpn(ne) === 0;
      }, J.prototype.eq = function(ne) {
        return this.cmp(ne) === 0;
      }, J.red = function(ne) {
        return new De(ne);
      }, J.prototype.toRed = function(ne) {
        return $(!this.red, "Already a number in reduction context"), $(this.negative === 0, "red works only with positives"), ne.convertTo(this)._forceRed(ne);
      }, J.prototype.fromRed = function() {
        return $(this.red, "fromRed works only with numbers in reduction context"), this.red.convertFrom(this);
      }, J.prototype._forceRed = function(ne) {
        return this.red = ne, this;
      }, J.prototype.forceRed = function(ne) {
        return $(!this.red, "Already a number in reduction context"), this._forceRed(ne);
      }, J.prototype.redAdd = function(ne) {
        return $(this.red, "redAdd works only with red numbers"), this.red.add(this, ne);
      }, J.prototype.redIAdd = function(ne) {
        return $(this.red, "redIAdd works only with red numbers"), this.red.iadd(this, ne);
      }, J.prototype.redSub = function(ne) {
        return $(this.red, "redSub works only with red numbers"), this.red.sub(this, ne);
      }, J.prototype.redISub = function(ne) {
        return $(this.red, "redISub works only with red numbers"), this.red.isub(this, ne);
      }, J.prototype.redShl = function(ne) {
        return $(this.red, "redShl works only with red numbers"), this.red.shl(this, ne);
      }, J.prototype.redMul = function(ne) {
        return $(this.red, "redMul works only with red numbers"), this.red._verify2(this, ne), this.red.mul(this, ne);
      }, J.prototype.redIMul = function(ne) {
        return $(this.red, "redMul works only with red numbers"), this.red._verify2(this, ne), this.red.imul(this, ne);
      }, J.prototype.redSqr = function() {
        return $(this.red, "redSqr works only with red numbers"), this.red._verify1(this), this.red.sqr(this);
      }, J.prototype.redISqr = function() {
        return $(this.red, "redISqr works only with red numbers"), this.red._verify1(this), this.red.isqr(this);
      }, J.prototype.redSqrt = function() {
        return $(this.red, "redSqrt works only with red numbers"), this.red._verify1(this), this.red.sqrt(this);
      }, J.prototype.redInvm = function() {
        return $(this.red, "redInvm works only with red numbers"), this.red._verify1(this), this.red.invm(this);
      }, J.prototype.redNeg = function() {
        return $(this.red, "redNeg works only with red numbers"), this.red._verify1(this), this.red.neg(this);
      }, J.prototype.redPow = function(ne) {
        return $(this.red && !ne.red, "redPow(normalNum)"), this.red._verify1(this), this.red.pow(this, ne);
      };
      var we = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
      };
      function Ee(Ae, ne) {
        this.name = Ae, this.p = new J(ne, 16), this.n = this.p.bitLength(), this.k = new J(1).iushln(this.n).isub(this.p), this.tmp = this._tmp();
      }
      Ee.prototype._tmp = function() {
        var ne = new J(null);
        return ne.words = new Array(Math.ceil(this.n / 13)), ne;
      }, Ee.prototype.ireduce = function(ne) {
        var oe = ne, ce;
        do
          this.split(oe, this.tmp), oe = this.imulK(oe), oe = oe.iadd(this.tmp), ce = oe.bitLength();
        while (ce > this.n);
        var le = ce < this.n ? -1 : oe.ucmp(this.p);
        return le === 0 ? (oe.words[0] = 0, oe.length = 1) : le > 0 ? oe.isub(this.p) : oe.strip !== void 0 ? oe.strip() : oe._strip(), oe;
      }, Ee.prototype.split = function(ne, oe) {
        ne.iushrn(this.n, 0, oe);
      }, Ee.prototype.imulK = function(ne) {
        return ne.imul(this.k);
      };
      function Me() {
        Ee.call(
          this,
          "k256",
          "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f"
        );
      }
      V(Me, Ee), Me.prototype.split = function(ne, oe) {
        for (var ce = 4194303, le = Math.min(ne.length, 9), pe = 0; pe < le; pe++)
          oe.words[pe] = ne.words[pe];
        if (oe.length = le, ne.length <= 9) {
          ne.words[0] = 0, ne.length = 1;
          return;
        }
        var ye = ne.words[9];
        for (oe.words[oe.length++] = ye & ce, pe = 10; pe < ne.length; pe++) {
          var Ce = ne.words[pe] | 0;
          ne.words[pe - 10] = (Ce & ce) << 4 | ye >>> 22, ye = Ce;
        }
        ye >>>= 22, ne.words[pe - 10] = ye, ye === 0 && ne.length > 10 ? ne.length -= 10 : ne.length -= 9;
      }, Me.prototype.imulK = function(ne) {
        ne.words[ne.length] = 0, ne.words[ne.length + 1] = 0, ne.length += 2;
        for (var oe = 0, ce = 0; ce < ne.length; ce++) {
          var le = ne.words[ce] | 0;
          oe += le * 977, ne.words[ce] = oe & 67108863, oe = le * 64 + (oe / 67108864 | 0);
        }
        return ne.words[ne.length - 1] === 0 && (ne.length--, ne.words[ne.length - 1] === 0 && ne.length--), ne;
      };
      function Ie() {
        Ee.call(
          this,
          "p224",
          "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001"
        );
      }
      V(Ie, Ee);
      function ke() {
        Ee.call(
          this,
          "p192",
          "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff"
        );
      }
      V(ke, Ee);
      function _e() {
        Ee.call(
          this,
          "25519",
          "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed"
        );
      }
      V(_e, Ee), _e.prototype.imulK = function(ne) {
        for (var oe = 0, ce = 0; ce < ne.length; ce++) {
          var le = (ne.words[ce] | 0) * 19 + oe, pe = le & 67108863;
          le >>>= 26, ne.words[ce] = pe, oe = le;
        }
        return oe !== 0 && (ne.words[ne.length++] = oe), ne;
      }, J._prime = function(ne) {
        if (we[ne]) return we[ne];
        var oe;
        if (ne === "k256")
          oe = new Me();
        else if (ne === "p224")
          oe = new Ie();
        else if (ne === "p192")
          oe = new ke();
        else if (ne === "p25519")
          oe = new _e();
        else
          throw new Error("Unknown prime " + ne);
        return we[ne] = oe, oe;
      };
      function De(Ae) {
        if (typeof Ae == "string") {
          var ne = J._prime(Ae);
          this.m = ne.p, this.prime = ne;
        } else
          $(Ae.gtn(1), "modulus must be greater than 1"), this.m = Ae, this.prime = null;
      }
      De.prototype._verify1 = function(ne) {
        $(ne.negative === 0, "red works only with positives"), $(ne.red, "red works only with red numbers");
      }, De.prototype._verify2 = function(ne, oe) {
        $((ne.negative | oe.negative) === 0, "red works only with positives"), $(
          ne.red && ne.red === oe.red,
          "red works only with red numbers"
        );
      }, De.prototype.imod = function(ne) {
        return this.prime ? this.prime.ireduce(ne)._forceRed(this) : ne.umod(this.m)._forceRed(this);
      }, De.prototype.neg = function(ne) {
        return ne.isZero() ? ne.clone() : this.m.sub(ne)._forceRed(this);
      }, De.prototype.add = function(ne, oe) {
        this._verify2(ne, oe);
        var ce = ne.add(oe);
        return ce.cmp(this.m) >= 0 && ce.isub(this.m), ce._forceRed(this);
      }, De.prototype.iadd = function(ne, oe) {
        this._verify2(ne, oe);
        var ce = ne.iadd(oe);
        return ce.cmp(this.m) >= 0 && ce.isub(this.m), ce;
      }, De.prototype.sub = function(ne, oe) {
        this._verify2(ne, oe);
        var ce = ne.sub(oe);
        return ce.cmpn(0) < 0 && ce.iadd(this.m), ce._forceRed(this);
      }, De.prototype.isub = function(ne, oe) {
        this._verify2(ne, oe);
        var ce = ne.isub(oe);
        return ce.cmpn(0) < 0 && ce.iadd(this.m), ce;
      }, De.prototype.shl = function(ne, oe) {
        return this._verify1(ne), this.imod(ne.ushln(oe));
      }, De.prototype.imul = function(ne, oe) {
        return this._verify2(ne, oe), this.imod(ne.imul(oe));
      }, De.prototype.mul = function(ne, oe) {
        return this._verify2(ne, oe), this.imod(ne.mul(oe));
      }, De.prototype.isqr = function(ne) {
        return this.imul(ne, ne.clone());
      }, De.prototype.sqr = function(ne) {
        return this.mul(ne, ne);
      }, De.prototype.sqrt = function(ne) {
        if (ne.isZero()) return ne.clone();
        var oe = this.m.andln(3);
        if ($(oe % 2 === 1), oe === 3) {
          var ce = this.m.add(new J(1)).iushrn(2);
          return this.pow(ne, ce);
        }
        for (var le = this.m.subn(1), pe = 0; !le.isZero() && le.andln(1) === 0; )
          pe++, le.iushrn(1);
        $(!le.isZero());
        var ye = new J(1).toRed(this), Ce = ye.redNeg(), be = this.m.subn(1).iushrn(1), ae = this.m.bitLength();
        for (ae = new J(2 * ae * ae).toRed(this); this.pow(ae, be).cmp(Ce) !== 0; )
          ae.redIAdd(Ce);
        for (var ge = this.pow(ae, le), Se = this.pow(ne, le.addn(1).iushrn(1)), Le = this.pow(ne, le), ze = pe; Le.cmp(ye) !== 0; ) {
          for (var Re = Le, We = 0; Re.cmp(ye) !== 0; We++)
            Re = Re.redSqr();
          $(We < ze);
          var Be = this.pow(ge, new J(1).iushln(ze - We - 1));
          Se = Se.redMul(Be), ge = Be.redSqr(), Le = Le.redMul(ge), ze = We;
        }
        return Se;
      }, De.prototype.invm = function(ne) {
        var oe = ne._invmp(this.m);
        return oe.negative !== 0 ? (oe.negative = 0, this.imod(oe).redNeg()) : this.imod(oe);
      }, De.prototype.pow = function(ne, oe) {
        if (oe.isZero()) return new J(1).toRed(this);
        if (oe.cmpn(1) === 0) return ne.clone();
        var ce = 4, le = new Array(1 << ce);
        le[0] = new J(1).toRed(this), le[1] = ne;
        for (var pe = 2; pe < le.length; pe++)
          le[pe] = this.mul(le[pe - 1], ne);
        var ye = le[0], Ce = 0, be = 0, ae = oe.bitLength() % 26;
        for (ae === 0 && (ae = 26), pe = oe.length - 1; pe >= 0; pe--) {
          for (var ge = oe.words[pe], Se = ae - 1; Se >= 0; Se--) {
            var Le = ge >> Se & 1;
            if (ye !== le[0] && (ye = this.sqr(ye)), Le === 0 && Ce === 0) {
              be = 0;
              continue;
            }
            Ce <<= 1, Ce |= Le, be++, !(be !== ce && (pe !== 0 || Se !== 0)) && (ye = this.mul(ye, le[Ce]), be = 0, Ce = 0);
          }
          ae = 26;
        }
        return ye;
      }, De.prototype.convertTo = function(ne) {
        var oe = ne.umod(this.m);
        return oe === ne ? oe.clone() : oe;
      }, De.prototype.convertFrom = function(ne) {
        var oe = ne.clone();
        return oe.red = null, oe;
      }, J.mont = function(ne) {
        return new Fe(ne);
      };
      function Fe(Ae) {
        De.call(this, Ae), this.shift = this.m.bitLength(), this.shift % 26 !== 0 && (this.shift += 26 - this.shift % 26), this.r = new J(1).iushln(this.shift), this.r2 = this.imod(this.r.sqr()), this.rinv = this.r._invmp(this.m), this.minv = this.rinv.mul(this.r).isubn(1).div(this.m), this.minv = this.minv.umod(this.r), this.minv = this.r.sub(this.minv);
      }
      V(Fe, De), Fe.prototype.convertTo = function(ne) {
        return this.imod(ne.ushln(this.shift));
      }, Fe.prototype.convertFrom = function(ne) {
        var oe = this.imod(ne.mul(this.rinv));
        return oe.red = null, oe;
      }, Fe.prototype.imul = function(ne, oe) {
        if (ne.isZero() || oe.isZero())
          return ne.words[0] = 0, ne.length = 1, ne;
        var ce = ne.imul(oe), le = ce.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m), pe = ce.isub(le).iushrn(this.shift), ye = pe;
        return pe.cmp(this.m) >= 0 ? ye = pe.isub(this.m) : pe.cmpn(0) < 0 && (ye = pe.iadd(this.m)), ye._forceRed(this);
      }, Fe.prototype.mul = function(ne, oe) {
        if (ne.isZero() || oe.isZero()) return new J(0)._forceRed(this);
        var ce = ne.mul(oe), le = ce.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m), pe = ce.isub(le).iushrn(this.shift), ye = pe;
        return pe.cmp(this.m) >= 0 ? ye = pe.isub(this.m) : pe.cmpn(0) < 0 && (ye = pe.iadd(this.m)), ye._forceRed(this);
      }, Fe.prototype.invm = function(ne) {
        var oe = this.imod(ne._invmp(this.m).mul(this.r2));
        return oe._forceRed(this);
      };
    })(C, commonjsGlobal$1);
  }(bn$2)), bn$2.exports;
}
var api = {}, hasRequiredApi;
function requireApi() {
  return hasRequiredApi || (hasRequiredApi = 1, function(C) {
    var e = requireAsn1$1(), T = requireInherits_browser(), $ = C;
    $.define = function(ee, te) {
      return new V(ee, te);
    };
    function V(J, ee) {
      this.name = J, this.body = ee, this.decoders = {}, this.encoders = {};
    }
    V.prototype._createNamed = function(ee) {
      var te;
      try {
        te = require$$0$2.runInThisContext(
          "(function " + this.name + `(entity) {
  this._initNamed(entity);
})`
        );
      } catch {
        te = function(ie) {
          this._initNamed(ie);
        };
      }
      return T(te, ee), te.prototype._initNamed = function(ie) {
        ee.call(this, ie);
      }, new te(this);
    }, V.prototype._getDecoder = function(ee) {
      return ee = ee || "der", this.decoders.hasOwnProperty(ee) || (this.decoders[ee] = this._createNamed(e.decoders[ee])), this.decoders[ee];
    }, V.prototype.decode = function(ee, te, re) {
      return this._getDecoder(te).decode(ee, re);
    }, V.prototype._getEncoder = function(ee) {
      return ee = ee || "der", this.encoders.hasOwnProperty(ee) || (this.encoders[ee] = this._createNamed(e.encoders[ee])), this.encoders[ee];
    }, V.prototype.encode = function(ee, te, re) {
      return this._getEncoder(te).encode(ee, re);
    };
  }(api)), api;
}
var base$4 = {}, reporter = {}, hasRequiredReporter;
function requireReporter() {
  if (hasRequiredReporter) return reporter;
  hasRequiredReporter = 1;
  var C = requireInherits_browser();
  function e($) {
    this._reporterState = {
      obj: null,
      path: [],
      options: $ || {},
      errors: []
    };
  }
  reporter.Reporter = e, e.prototype.isError = function(V) {
    return V instanceof T;
  }, e.prototype.save = function() {
    var V = this._reporterState;
    return { obj: V.obj, pathLen: V.path.length };
  }, e.prototype.restore = function(V) {
    var J = this._reporterState;
    J.obj = V.obj, J.path = J.path.slice(0, V.pathLen);
  }, e.prototype.enterKey = function(V) {
    return this._reporterState.path.push(V);
  }, e.prototype.exitKey = function(V) {
    var J = this._reporterState;
    J.path = J.path.slice(0, V - 1);
  }, e.prototype.leaveKey = function(V, J, ee) {
    var te = this._reporterState;
    this.exitKey(V), te.obj !== null && (te.obj[J] = ee);
  }, e.prototype.path = function() {
    return this._reporterState.path.join("/");
  }, e.prototype.enterObject = function() {
    var V = this._reporterState, J = V.obj;
    return V.obj = {}, J;
  }, e.prototype.leaveObject = function(V) {
    var J = this._reporterState, ee = J.obj;
    return J.obj = V, ee;
  }, e.prototype.error = function(V) {
    var J, ee = this._reporterState, te = V instanceof T;
    if (te ? J = V : J = new T(ee.path.map(function(re) {
      return "[" + JSON.stringify(re) + "]";
    }).join(""), V.message || V, V.stack), !ee.options.partial)
      throw J;
    return te || ee.errors.push(J), J;
  }, e.prototype.wrapResult = function(V) {
    var J = this._reporterState;
    return J.options.partial ? {
      result: this.isError(V) ? null : V,
      errors: J.errors
    } : V;
  };
  function T($, V) {
    this.path = $, this.rethrow(V);
  }
  return C(T, Error), T.prototype.rethrow = function(V) {
    if (this.message = V + " at: " + (this.path || "(shallow)"), Error.captureStackTrace && Error.captureStackTrace(this, T), !this.stack)
      try {
        throw new Error(this.message);
      } catch (J) {
        this.stack = J.stack;
      }
    return this;
  }, reporter;
}
var buffer = {}, hasRequiredBuffer;
function requireBuffer() {
  if (hasRequiredBuffer) return buffer;
  hasRequiredBuffer = 1;
  var C = requireInherits_browser(), e = requireBase().Reporter, T = bufferPolyfill.Buffer;
  function $(J, ee) {
    if (e.call(this, ee), !T.isBuffer(J)) {
      this.error("Input not Buffer");
      return;
    }
    this.base = J, this.offset = 0, this.length = J.length;
  }
  C($, e), buffer.DecoderBuffer = $, $.prototype.save = function() {
    return { offset: this.offset, reporter: e.prototype.save.call(this) };
  }, $.prototype.restore = function(ee) {
    var te = new $(this.base);
    return te.offset = ee.offset, te.length = this.offset, this.offset = ee.offset, e.prototype.restore.call(this, ee.reporter), te;
  }, $.prototype.isEmpty = function() {
    return this.offset === this.length;
  }, $.prototype.readUInt8 = function(ee) {
    return this.offset + 1 <= this.length ? this.base.readUInt8(this.offset++, !0) : this.error(ee || "DecoderBuffer overrun");
  }, $.prototype.skip = function(ee, te) {
    if (!(this.offset + ee <= this.length))
      return this.error(te || "DecoderBuffer overrun");
    var re = new $(this.base);
    return re._reporterState = this._reporterState, re.offset = this.offset, re.length = this.offset + ee, this.offset += ee, re;
  }, $.prototype.raw = function(ee) {
    return this.base.slice(ee ? ee.offset : this.offset, this.length);
  };
  function V(J, ee) {
    if (Array.isArray(J))
      this.length = 0, this.value = J.map(function(te) {
        return te instanceof V || (te = new V(te, ee)), this.length += te.length, te;
      }, this);
    else if (typeof J == "number") {
      if (!(0 <= J && J <= 255))
        return ee.error("non-byte EncoderBuffer value");
      this.value = J, this.length = 1;
    } else if (typeof J == "string")
      this.value = J, this.length = T.byteLength(J);
    else if (T.isBuffer(J))
      this.value = J, this.length = J.length;
    else
      return ee.error("Unsupported type: " + typeof J);
  }
  return buffer.EncoderBuffer = V, V.prototype.join = function(ee, te) {
    return ee || (ee = new T(this.length)), te || (te = 0), this.length === 0 || (Array.isArray(this.value) ? this.value.forEach(function(re) {
      re.join(ee, te), te += re.length;
    }) : (typeof this.value == "number" ? ee[te] = this.value : typeof this.value == "string" ? ee.write(this.value, te) : T.isBuffer(this.value) && this.value.copy(ee, te), te += this.length)), ee;
  }, buffer;
}
var node, hasRequiredNode;
function requireNode() {
  if (hasRequiredNode) return node;
  hasRequiredNode = 1;
  var C = requireBase().Reporter, e = requireBase().EncoderBuffer, T = requireBase().DecoderBuffer, $ = requireMinimalisticAssert(), V = [
    "seq",
    "seqof",
    "set",
    "setof",
    "objid",
    "bool",
    "gentime",
    "utctime",
    "null_",
    "enum",
    "int",
    "objDesc",
    "bitstr",
    "bmpstr",
    "charstr",
    "genstr",
    "graphstr",
    "ia5str",
    "iso646str",
    "numstr",
    "octstr",
    "printstr",
    "t61str",
    "unistr",
    "utf8str",
    "videostr"
  ], J = [
    "key",
    "obj",
    "use",
    "optional",
    "explicit",
    "implicit",
    "def",
    "choice",
    "any",
    "contains"
  ].concat(V), ee = [
    "_peekTag",
    "_decodeTag",
    "_use",
    "_decodeStr",
    "_decodeObjid",
    "_decodeTime",
    "_decodeNull",
    "_decodeInt",
    "_decodeBool",
    "_decodeList",
    "_encodeComposite",
    "_encodeStr",
    "_encodeObjid",
    "_encodeTime",
    "_encodeNull",
    "_encodeInt",
    "_encodeBool"
  ];
  function te(ie, se) {
    var de = {};
    this._baseState = de, de.enc = ie, de.parent = se || null, de.children = null, de.tag = null, de.args = null, de.reverseArgs = null, de.choice = null, de.optional = !1, de.any = !1, de.obj = !1, de.use = null, de.useDecoder = null, de.key = null, de.default = null, de.explicit = null, de.implicit = null, de.contains = null, de.parent || (de.children = [], this._wrap());
  }
  node = te;
  var re = [
    "enc",
    "parent",
    "children",
    "tag",
    "args",
    "reverseArgs",
    "choice",
    "optional",
    "any",
    "obj",
    "use",
    "alteredUse",
    "key",
    "default",
    "explicit",
    "implicit",
    "contains"
  ];
  return te.prototype.clone = function() {
    var se = this._baseState, de = {};
    re.forEach(function(fe) {
      de[fe] = se[fe];
    });
    var ue = new this.constructor(de.parent);
    return ue._baseState = de, ue;
  }, te.prototype._wrap = function() {
    var se = this._baseState;
    J.forEach(function(de) {
      this[de] = function() {
        var fe = new this.constructor(this);
        return se.children.push(fe), fe[de].apply(fe, arguments);
      };
    }, this);
  }, te.prototype._init = function(se) {
    var de = this._baseState;
    $(de.parent === null), se.call(this), de.children = de.children.filter(function(ue) {
      return ue._baseState.parent === this;
    }, this), $.equal(de.children.length, 1, "Root node can have only one child");
  }, te.prototype._useArgs = function(se) {
    var de = this._baseState, ue = se.filter(function(fe) {
      return fe instanceof this.constructor;
    }, this);
    se = se.filter(function(fe) {
      return !(fe instanceof this.constructor);
    }, this), ue.length !== 0 && ($(de.children === null), de.children = ue, ue.forEach(function(fe) {
      fe._baseState.parent = this;
    }, this)), se.length !== 0 && ($(de.args === null), de.args = se, de.reverseArgs = se.map(function(fe) {
      if (typeof fe != "object" || fe.constructor !== Object)
        return fe;
      var he = {};
      return Object.keys(fe).forEach(function(me) {
        me == (me | 0) && (me |= 0);
        var xe = fe[me];
        he[xe] = me;
      }), he;
    }));
  }, ee.forEach(function(ie) {
    te.prototype[ie] = function() {
      var de = this._baseState;
      throw new Error(ie + " not implemented for encoding: " + de.enc);
    };
  }), V.forEach(function(ie) {
    te.prototype[ie] = function() {
      var de = this._baseState, ue = Array.prototype.slice.call(arguments);
      return $(de.tag === null), de.tag = ie, this._useArgs(ue), this;
    };
  }), te.prototype.use = function(se) {
    $(se);
    var de = this._baseState;
    return $(de.use === null), de.use = se, this;
  }, te.prototype.optional = function() {
    var se = this._baseState;
    return se.optional = !0, this;
  }, te.prototype.def = function(se) {
    var de = this._baseState;
    return $(de.default === null), de.default = se, de.optional = !0, this;
  }, te.prototype.explicit = function(se) {
    var de = this._baseState;
    return $(de.explicit === null && de.implicit === null), de.explicit = se, this;
  }, te.prototype.implicit = function(se) {
    var de = this._baseState;
    return $(de.explicit === null && de.implicit === null), de.implicit = se, this;
  }, te.prototype.obj = function() {
    var se = this._baseState, de = Array.prototype.slice.call(arguments);
    return se.obj = !0, de.length !== 0 && this._useArgs(de), this;
  }, te.prototype.key = function(se) {
    var de = this._baseState;
    return $(de.key === null), de.key = se, this;
  }, te.prototype.any = function() {
    var se = this._baseState;
    return se.any = !0, this;
  }, te.prototype.choice = function(se) {
    var de = this._baseState;
    return $(de.choice === null), de.choice = se, this._useArgs(Object.keys(se).map(function(ue) {
      return se[ue];
    })), this;
  }, te.prototype.contains = function(se) {
    var de = this._baseState;
    return $(de.use === null), de.contains = se, this;
  }, te.prototype._decode = function(se, de) {
    var ue = this._baseState;
    if (ue.parent === null)
      return se.wrapResult(ue.children[0]._decode(se, de));
    var fe = ue.default, he = !0, me = null;
    if (ue.key !== null && (me = se.enterKey(ue.key)), ue.optional) {
      var xe = null;
      if (ue.explicit !== null ? xe = ue.explicit : ue.implicit !== null ? xe = ue.implicit : ue.tag !== null && (xe = ue.tag), xe === null && !ue.any) {
        var ve = se.save();
        try {
          ue.choice === null ? this._decodeGeneric(ue.tag, se, de) : this._decodeChoice(se, de), he = !0;
        } catch {
          he = !1;
        }
        se.restore(ve);
      } else if (he = this._peekTag(se, xe, ue.any), se.isError(he))
        return he;
    }
    var Te;
    if (ue.obj && he && (Te = se.enterObject()), he) {
      if (ue.explicit !== null) {
        var we = this._decodeTag(se, ue.explicit);
        if (se.isError(we))
          return we;
        se = we;
      }
      var Ee = se.offset;
      if (ue.use === null && ue.choice === null) {
        if (ue.any)
          var ve = se.save();
        var Me = this._decodeTag(
          se,
          ue.implicit !== null ? ue.implicit : ue.tag,
          ue.any
        );
        if (se.isError(Me))
          return Me;
        ue.any ? fe = se.raw(ve) : se = Me;
      }
      if (de && de.track && ue.tag !== null && de.track(se.path(), Ee, se.length, "tagged"), de && de.track && ue.tag !== null && de.track(se.path(), se.offset, se.length, "content"), ue.any ? fe = fe : ue.choice === null ? fe = this._decodeGeneric(ue.tag, se, de) : fe = this._decodeChoice(se, de), se.isError(fe))
        return fe;
      if (!ue.any && ue.choice === null && ue.children !== null && ue.children.forEach(function(_e) {
        _e._decode(se, de);
      }), ue.contains && (ue.tag === "octstr" || ue.tag === "bitstr")) {
        var Ie = new T(fe);
        fe = this._getUse(ue.contains, se._reporterState.obj)._decode(Ie, de);
      }
    }
    return ue.obj && he && (fe = se.leaveObject(Te)), ue.key !== null && (fe !== null || he === !0) ? se.leaveKey(me, ue.key, fe) : me !== null && se.exitKey(me), fe;
  }, te.prototype._decodeGeneric = function(se, de, ue) {
    var fe = this._baseState;
    return se === "seq" || se === "set" ? null : se === "seqof" || se === "setof" ? this._decodeList(de, se, fe.args[0], ue) : /str$/.test(se) ? this._decodeStr(de, se, ue) : se === "objid" && fe.args ? this._decodeObjid(de, fe.args[0], fe.args[1], ue) : se === "objid" ? this._decodeObjid(de, null, null, ue) : se === "gentime" || se === "utctime" ? this._decodeTime(de, se, ue) : se === "null_" ? this._decodeNull(de, ue) : se === "bool" ? this._decodeBool(de, ue) : se === "objDesc" ? this._decodeStr(de, se, ue) : se === "int" || se === "enum" ? this._decodeInt(de, fe.args && fe.args[0], ue) : fe.use !== null ? this._getUse(fe.use, de._reporterState.obj)._decode(de, ue) : de.error("unknown tag: " + se);
  }, te.prototype._getUse = function(se, de) {
    var ue = this._baseState;
    return ue.useDecoder = this._use(se, de), $(ue.useDecoder._baseState.parent === null), ue.useDecoder = ue.useDecoder._baseState.children[0], ue.implicit !== ue.useDecoder._baseState.implicit && (ue.useDecoder = ue.useDecoder.clone(), ue.useDecoder._baseState.implicit = ue.implicit), ue.useDecoder;
  }, te.prototype._decodeChoice = function(se, de) {
    var ue = this._baseState, fe = null, he = !1;
    return Object.keys(ue.choice).some(function(me) {
      var xe = se.save(), ve = ue.choice[me];
      try {
        var Te = ve._decode(se, de);
        if (se.isError(Te))
          return !1;
        fe = { type: me, value: Te }, he = !0;
      } catch {
        return se.restore(xe), !1;
      }
      return !0;
    }, this), he ? fe : se.error("Choice not matched");
  }, te.prototype._createEncoderBuffer = function(se) {
    return new e(se, this.reporter);
  }, te.prototype._encode = function(se, de, ue) {
    var fe = this._baseState;
    if (!(fe.default !== null && fe.default === se)) {
      var he = this._encodeValue(se, de, ue);
      if (he !== void 0 && !this._skipDefault(he, de, ue))
        return he;
    }
  }, te.prototype._encodeValue = function(se, de, ue) {
    var fe = this._baseState;
    if (fe.parent === null)
      return fe.children[0]._encode(se, de || new C());
    var ve = null;
    if (this.reporter = de, fe.optional && se === void 0)
      if (fe.default !== null)
        se = fe.default;
      else
        return;
    var he = null, me = !1;
    if (fe.any)
      ve = this._createEncoderBuffer(se);
    else if (fe.choice)
      ve = this._encodeChoice(se, de);
    else if (fe.contains)
      he = this._getUse(fe.contains, ue)._encode(se, de), me = !0;
    else if (fe.children)
      he = fe.children.map(function(Ee) {
        if (Ee._baseState.tag === "null_")
          return Ee._encode(null, de, se);
        if (Ee._baseState.key === null)
          return de.error("Child should have a key");
        var Me = de.enterKey(Ee._baseState.key);
        if (typeof se != "object")
          return de.error("Child expected, but input is not object");
        var Ie = Ee._encode(se[Ee._baseState.key], de, se);
        return de.leaveKey(Me), Ie;
      }, this).filter(function(Ee) {
        return Ee;
      }), he = this._createEncoderBuffer(he);
    else if (fe.tag === "seqof" || fe.tag === "setof") {
      if (!(fe.args && fe.args.length === 1))
        return de.error("Too many args for : " + fe.tag);
      if (!Array.isArray(se))
        return de.error("seqof/setof, but data is not Array");
      var xe = this.clone();
      xe._baseState.implicit = null, he = this._createEncoderBuffer(se.map(function(Ee) {
        var Me = this._baseState;
        return this._getUse(Me.args[0], se)._encode(Ee, de);
      }, xe));
    } else fe.use !== null ? ve = this._getUse(fe.use, ue)._encode(se, de) : (he = this._encodePrimitive(fe.tag, se), me = !0);
    var ve;
    if (!fe.any && fe.choice === null) {
      var Te = fe.implicit !== null ? fe.implicit : fe.tag, we = fe.implicit === null ? "universal" : "context";
      Te === null ? fe.use === null && de.error("Tag could be omitted only for .use()") : fe.use === null && (ve = this._encodeComposite(Te, me, we, he));
    }
    return fe.explicit !== null && (ve = this._encodeComposite(fe.explicit, !1, "context", ve)), ve;
  }, te.prototype._encodeChoice = function(se, de) {
    var ue = this._baseState, fe = ue.choice[se.type];
    return fe || $(
      !1,
      se.type + " not found in " + JSON.stringify(Object.keys(ue.choice))
    ), fe._encode(se.value, de);
  }, te.prototype._encodePrimitive = function(se, de) {
    var ue = this._baseState;
    if (/str$/.test(se))
      return this._encodeStr(de, se);
    if (se === "objid" && ue.args)
      return this._encodeObjid(de, ue.reverseArgs[0], ue.args[1]);
    if (se === "objid")
      return this._encodeObjid(de, null, null);
    if (se === "gentime" || se === "utctime")
      return this._encodeTime(de, se);
    if (se === "null_")
      return this._encodeNull();
    if (se === "int" || se === "enum")
      return this._encodeInt(de, ue.args && ue.reverseArgs[0]);
    if (se === "bool")
      return this._encodeBool(de);
    if (se === "objDesc")
      return this._encodeStr(de, se);
    throw new Error("Unsupported tag: " + se);
  }, te.prototype._isNumstr = function(se) {
    return /^[0-9 ]*$/.test(se);
  }, te.prototype._isPrintstr = function(se) {
    return /^[A-Za-z0-9 '\(\)\+,\-\.\/:=\?]*$/.test(se);
  }, node;
}
var hasRequiredBase;
function requireBase() {
  return hasRequiredBase || (hasRequiredBase = 1, function(C) {
    var e = C;
    e.Reporter = requireReporter().Reporter, e.DecoderBuffer = requireBuffer().DecoderBuffer, e.EncoderBuffer = requireBuffer().EncoderBuffer, e.Node = requireNode();
  }(base$4)), base$4;
}
var constants$1 = {}, der = {}, hasRequiredDer$2;
function requireDer$2() {
  return hasRequiredDer$2 || (hasRequiredDer$2 = 1, function(C) {
    var e = requireConstants();
    C.tagClass = {
      0: "universal",
      1: "application",
      2: "context",
      3: "private"
    }, C.tagClassByName = e._reverse(C.tagClass), C.tag = {
      0: "end",
      1: "bool",
      2: "int",
      3: "bitstr",
      4: "octstr",
      5: "null_",
      6: "objid",
      7: "objDesc",
      8: "external",
      9: "real",
      10: "enum",
      11: "embed",
      12: "utf8str",
      13: "relativeOid",
      16: "seq",
      17: "set",
      18: "numstr",
      19: "printstr",
      20: "t61str",
      21: "videostr",
      22: "ia5str",
      23: "utctime",
      24: "gentime",
      25: "graphstr",
      26: "iso646str",
      27: "genstr",
      28: "unistr",
      29: "charstr",
      30: "bmpstr"
    }, C.tagByName = e._reverse(C.tag);
  }(der)), der;
}
var hasRequiredConstants;
function requireConstants() {
  return hasRequiredConstants || (hasRequiredConstants = 1, function(C) {
    var e = C;
    e._reverse = function($) {
      var V = {};
      return Object.keys($).forEach(function(J) {
        (J | 0) == J && (J = J | 0);
        var ee = $[J];
        V[ee] = J;
      }), V;
    }, e.der = requireDer$2();
  }(constants$1)), constants$1;
}
var decoders = {}, der_1$1, hasRequiredDer$1;
function requireDer$1() {
  if (hasRequiredDer$1) return der_1$1;
  hasRequiredDer$1 = 1;
  var C = requireInherits_browser(), e = requireAsn1$1(), T = e.base, $ = e.bignum, V = e.constants.der;
  function J(ie) {
    this.enc = "der", this.name = ie.name, this.entity = ie, this.tree = new ee(), this.tree._init(ie.body);
  }
  der_1$1 = J, J.prototype.decode = function(se, de) {
    return se instanceof T.DecoderBuffer || (se = new T.DecoderBuffer(se, de)), this.tree._decode(se, de);
  };
  function ee(ie) {
    T.Node.call(this, "der", ie);
  }
  C(ee, T.Node), ee.prototype._peekTag = function(se, de, ue) {
    if (se.isEmpty())
      return !1;
    var fe = se.save(), he = te(se, 'Failed to peek tag: "' + de + '"');
    return se.isError(he) ? he : (se.restore(fe), he.tag === de || he.tagStr === de || he.tagStr + "of" === de || ue);
  }, ee.prototype._decodeTag = function(se, de, ue) {
    var fe = te(
      se,
      'Failed to decode tag of "' + de + '"'
    );
    if (se.isError(fe))
      return fe;
    var he = re(
      se,
      fe.primitive,
      'Failed to get length of "' + de + '"'
    );
    if (se.isError(he))
      return he;
    if (!ue && fe.tag !== de && fe.tagStr !== de && fe.tagStr + "of" !== de)
      return se.error('Failed to match tag: "' + de + '"');
    if (fe.primitive || he !== null)
      return se.skip(he, 'Failed to match body of: "' + de + '"');
    var me = se.save(), xe = this._skipUntilEnd(
      se,
      'Failed to skip indefinite length body: "' + this.tag + '"'
    );
    return se.isError(xe) ? xe : (he = se.offset - me.offset, se.restore(me), se.skip(he, 'Failed to match body of: "' + de + '"'));
  }, ee.prototype._skipUntilEnd = function(se, de) {
    for (; ; ) {
      var ue = te(se, de);
      if (se.isError(ue))
        return ue;
      var fe = re(se, ue.primitive, de);
      if (se.isError(fe))
        return fe;
      var he;
      if (ue.primitive || fe !== null ? he = se.skip(fe) : he = this._skipUntilEnd(se, de), se.isError(he))
        return he;
      if (ue.tagStr === "end")
        break;
    }
  }, ee.prototype._decodeList = function(se, de, ue, fe) {
    for (var he = []; !se.isEmpty(); ) {
      var me = this._peekTag(se, "end");
      if (se.isError(me))
        return me;
      var xe = ue.decode(se, "der", fe);
      if (se.isError(xe) && me)
        break;
      he.push(xe);
    }
    return he;
  }, ee.prototype._decodeStr = function(se, de) {
    if (de === "bitstr") {
      var ue = se.readUInt8();
      return se.isError(ue) ? ue : { unused: ue, data: se.raw() };
    } else if (de === "bmpstr") {
      var fe = se.raw();
      if (fe.length % 2 === 1)
        return se.error("Decoding of string type: bmpstr length mismatch");
      for (var he = "", me = 0; me < fe.length / 2; me++)
        he += String.fromCharCode(fe.readUInt16BE(me * 2));
      return he;
    } else if (de === "numstr") {
      var xe = se.raw().toString("ascii");
      return this._isNumstr(xe) ? xe : se.error("Decoding of string type: numstr unsupported characters");
    } else {
      if (de === "octstr")
        return se.raw();
      if (de === "objDesc")
        return se.raw();
      if (de === "printstr") {
        var ve = se.raw().toString("ascii");
        return this._isPrintstr(ve) ? ve : se.error("Decoding of string type: printstr unsupported characters");
      } else return /str$/.test(de) ? se.raw().toString() : se.error("Decoding of string type: " + de + " unsupported");
    }
  }, ee.prototype._decodeObjid = function(se, de, ue) {
    for (var fe, he = [], me = 0; !se.isEmpty(); ) {
      var xe = se.readUInt8();
      me <<= 7, me |= xe & 127, xe & 128 || (he.push(me), me = 0);
    }
    xe & 128 && he.push(me);
    var ve = he[0] / 40 | 0, Te = he[0] % 40;
    if (ue ? fe = he : fe = [ve, Te].concat(he.slice(1)), de) {
      var we = de[fe.join(" ")];
      we === void 0 && (we = de[fe.join(".")]), we !== void 0 && (fe = we);
    }
    return fe;
  }, ee.prototype._decodeTime = function(se, de) {
    var ue = se.raw().toString();
    if (de === "gentime")
      var fe = ue.slice(0, 4) | 0, he = ue.slice(4, 6) | 0, me = ue.slice(6, 8) | 0, xe = ue.slice(8, 10) | 0, ve = ue.slice(10, 12) | 0, Te = ue.slice(12, 14) | 0;
    else if (de === "utctime") {
      var fe = ue.slice(0, 2) | 0, he = ue.slice(2, 4) | 0, me = ue.slice(4, 6) | 0, xe = ue.slice(6, 8) | 0, ve = ue.slice(8, 10) | 0, Te = ue.slice(10, 12) | 0;
      fe < 70 ? fe = 2e3 + fe : fe = 1900 + fe;
    } else
      return se.error("Decoding " + de + " time is not supported yet");
    return Date.UTC(fe, he - 1, me, xe, ve, Te, 0);
  }, ee.prototype._decodeNull = function(se) {
    return null;
  }, ee.prototype._decodeBool = function(se) {
    var de = se.readUInt8();
    return se.isError(de) ? de : de !== 0;
  }, ee.prototype._decodeInt = function(se, de) {
    var ue = se.raw(), fe = new $(ue);
    return de && (fe = de[fe.toString(10)] || fe), fe;
  }, ee.prototype._use = function(se, de) {
    return typeof se == "function" && (se = se(de)), se._getDecoder("der").tree;
  };
  function te(ie, se) {
    var de = ie.readUInt8(se);
    if (ie.isError(de))
      return de;
    var ue = V.tagClass[de >> 6], fe = (de & 32) === 0;
    if ((de & 31) === 31) {
      var he = de;
      for (de = 0; (he & 128) === 128; ) {
        if (he = ie.readUInt8(se), ie.isError(he))
          return he;
        de <<= 7, de |= he & 127;
      }
    } else
      de &= 31;
    var me = V.tag[de];
    return {
      cls: ue,
      primitive: fe,
      tag: de,
      tagStr: me
    };
  }
  function re(ie, se, de) {
    var ue = ie.readUInt8(de);
    if (ie.isError(ue))
      return ue;
    if (!se && ue === 128)
      return null;
    if (!(ue & 128))
      return ue;
    var fe = ue & 127;
    if (fe > 4)
      return ie.error("length octect is too long");
    ue = 0;
    for (var he = 0; he < fe; he++) {
      ue <<= 8;
      var me = ie.readUInt8(de);
      if (ie.isError(me))
        return me;
      ue |= me;
    }
    return ue;
  }
  return der_1$1;
}
var pem$1, hasRequiredPem$1;
function requirePem$1() {
  if (hasRequiredPem$1) return pem$1;
  hasRequiredPem$1 = 1;
  var C = requireInherits_browser(), e = bufferPolyfill.Buffer, T = requireDer$1();
  function $(V) {
    T.call(this, V), this.enc = "pem";
  }
  return C($, T), pem$1 = $, $.prototype.decode = function(J, ee) {
    for (var te = J.toString().split(/[\r\n]+/g), re = ee.label.toUpperCase(), ie = /^-----(BEGIN|END) ([^-]+)-----$/, se = -1, de = -1, ue = 0; ue < te.length; ue++) {
      var fe = te[ue].match(ie);
      if (fe !== null && fe[2] === re)
        if (se === -1) {
          if (fe[1] !== "BEGIN")
            break;
          se = ue;
        } else {
          if (fe[1] !== "END")
            break;
          de = ue;
          break;
        }
    }
    if (se === -1 || de === -1)
      throw new Error("PEM section not found for: " + re);
    var he = te.slice(se + 1, de).join("");
    he.replace(/[^a-z0-9\+\/=]+/gi, "");
    var me = new e(he, "base64");
    return T.prototype.decode.call(this, me, ee);
  }, pem$1;
}
var hasRequiredDecoders;
function requireDecoders() {
  return hasRequiredDecoders || (hasRequiredDecoders = 1, function(C) {
    var e = C;
    e.der = requireDer$1(), e.pem = requirePem$1();
  }(decoders)), decoders;
}
var encoders = {}, der_1, hasRequiredDer;
function requireDer() {
  if (hasRequiredDer) return der_1;
  hasRequiredDer = 1;
  var C = requireInherits_browser(), e = bufferPolyfill.Buffer, T = requireAsn1$1(), $ = T.base, V = T.constants.der;
  function J(ie) {
    this.enc = "der", this.name = ie.name, this.entity = ie, this.tree = new ee(), this.tree._init(ie.body);
  }
  der_1 = J, J.prototype.encode = function(se, de) {
    return this.tree._encode(se, de).join();
  };
  function ee(ie) {
    $.Node.call(this, "der", ie);
  }
  C(ee, $.Node), ee.prototype._encodeComposite = function(se, de, ue, fe) {
    var he = re(se, de, ue, this.reporter);
    if (fe.length < 128) {
      var ve = new e(2);
      return ve[0] = he, ve[1] = fe.length, this._createEncoderBuffer([ve, fe]);
    }
    for (var me = 1, xe = fe.length; xe >= 256; xe >>= 8)
      me++;
    var ve = new e(2 + me);
    ve[0] = he, ve[1] = 128 | me;
    for (var xe = 1 + me, Te = fe.length; Te > 0; xe--, Te >>= 8)
      ve[xe] = Te & 255;
    return this._createEncoderBuffer([ve, fe]);
  }, ee.prototype._encodeStr = function(se, de) {
    if (de === "bitstr")
      return this._createEncoderBuffer([se.unused | 0, se.data]);
    if (de === "bmpstr") {
      for (var ue = new e(se.length * 2), fe = 0; fe < se.length; fe++)
        ue.writeUInt16BE(se.charCodeAt(fe), fe * 2);
      return this._createEncoderBuffer(ue);
    } else return de === "numstr" ? this._isNumstr(se) ? this._createEncoderBuffer(se) : this.reporter.error("Encoding of string type: numstr supports only digits and space") : de === "printstr" ? this._isPrintstr(se) ? this._createEncoderBuffer(se) : this.reporter.error("Encoding of string type: printstr supports only latin upper and lower case letters, digits, space, apostrophe, left and rigth parenthesis, plus sign, comma, hyphen, dot, slash, colon, equal sign, question mark") : /str$/.test(de) ? this._createEncoderBuffer(se) : de === "objDesc" ? this._createEncoderBuffer(se) : this.reporter.error("Encoding of string type: " + de + " unsupported");
  }, ee.prototype._encodeObjid = function(se, de, ue) {
    if (typeof se == "string") {
      if (!de)
        return this.reporter.error("string objid given, but no values map found");
      if (!de.hasOwnProperty(se))
        return this.reporter.error("objid not found in values map");
      se = de[se].split(/[\s\.]+/g);
      for (var fe = 0; fe < se.length; fe++)
        se[fe] |= 0;
    } else if (Array.isArray(se)) {
      se = se.slice();
      for (var fe = 0; fe < se.length; fe++)
        se[fe] |= 0;
    }
    if (!Array.isArray(se))
      return this.reporter.error("objid() should be either array or string, got: " + JSON.stringify(se));
    if (!ue) {
      if (se[1] >= 40)
        return this.reporter.error("Second objid identifier OOB");
      se.splice(0, 2, se[0] * 40 + se[1]);
    }
    for (var he = 0, fe = 0; fe < se.length; fe++) {
      var me = se[fe];
      for (he++; me >= 128; me >>= 7)
        he++;
    }
    for (var xe = new e(he), ve = xe.length - 1, fe = se.length - 1; fe >= 0; fe--) {
      var me = se[fe];
      for (xe[ve--] = me & 127; (me >>= 7) > 0; )
        xe[ve--] = 128 | me & 127;
    }
    return this._createEncoderBuffer(xe);
  };
  function te(ie) {
    return ie < 10 ? "0" + ie : ie;
  }
  ee.prototype._encodeTime = function(se, de) {
    var ue, fe = new Date(se);
    return de === "gentime" ? ue = [
      te(fe.getFullYear()),
      te(fe.getUTCMonth() + 1),
      te(fe.getUTCDate()),
      te(fe.getUTCHours()),
      te(fe.getUTCMinutes()),
      te(fe.getUTCSeconds()),
      "Z"
    ].join("") : de === "utctime" ? ue = [
      te(fe.getFullYear() % 100),
      te(fe.getUTCMonth() + 1),
      te(fe.getUTCDate()),
      te(fe.getUTCHours()),
      te(fe.getUTCMinutes()),
      te(fe.getUTCSeconds()),
      "Z"
    ].join("") : this.reporter.error("Encoding " + de + " time is not supported yet"), this._encodeStr(ue, "octstr");
  }, ee.prototype._encodeNull = function() {
    return this._createEncoderBuffer("");
  }, ee.prototype._encodeInt = function(se, de) {
    if (typeof se == "string") {
      if (!de)
        return this.reporter.error("String int or enum given, but no values map");
      if (!de.hasOwnProperty(se))
        return this.reporter.error("Values map doesn't contain: " + JSON.stringify(se));
      se = de[se];
    }
    if (typeof se != "number" && !e.isBuffer(se)) {
      var ue = se.toArray();
      !se.sign && ue[0] & 128 && ue.unshift(0), se = new e(ue);
    }
    if (e.isBuffer(se)) {
      var fe = se.length;
      se.length === 0 && fe++;
      var me = new e(fe);
      return se.copy(me), se.length === 0 && (me[0] = 0), this._createEncoderBuffer(me);
    }
    if (se < 128)
      return this._createEncoderBuffer(se);
    if (se < 256)
      return this._createEncoderBuffer([0, se]);
    for (var fe = 1, he = se; he >= 256; he >>= 8)
      fe++;
    for (var me = new Array(fe), he = me.length - 1; he >= 0; he--)
      me[he] = se & 255, se >>= 8;
    return me[0] & 128 && me.unshift(0), this._createEncoderBuffer(new e(me));
  }, ee.prototype._encodeBool = function(se) {
    return this._createEncoderBuffer(se ? 255 : 0);
  }, ee.prototype._use = function(se, de) {
    return typeof se == "function" && (se = se(de)), se._getEncoder("der").tree;
  }, ee.prototype._skipDefault = function(se, de, ue) {
    var fe = this._baseState, he;
    if (fe.default === null)
      return !1;
    var me = se.join();
    if (fe.defaultBuffer === void 0 && (fe.defaultBuffer = this._encodeValue(fe.default, de, ue).join()), me.length !== fe.defaultBuffer.length)
      return !1;
    for (he = 0; he < me.length; he++)
      if (me[he] !== fe.defaultBuffer[he])
        return !1;
    return !0;
  };
  function re(ie, se, de, ue) {
    var fe;
    if (ie === "seqof" ? ie = "seq" : ie === "setof" && (ie = "set"), V.tagByName.hasOwnProperty(ie))
      fe = V.tagByName[ie];
    else if (typeof ie == "number" && (ie | 0) === ie)
      fe = ie;
    else
      return ue.error("Unknown tag: " + ie);
    return fe >= 31 ? ue.error("Multi-octet tag encoding unsupported") : (se || (fe |= 32), fe |= V.tagClassByName[de || "universal"] << 6, fe);
  }
  return der_1;
}
var pem, hasRequiredPem;
function requirePem() {
  if (hasRequiredPem) return pem;
  hasRequiredPem = 1;
  var C = requireInherits_browser(), e = requireDer();
  function T($) {
    e.call(this, $), this.enc = "pem";
  }
  return C(T, e), pem = T, T.prototype.encode = function(V, J) {
    for (var ee = e.prototype.encode.call(this, V), te = ee.toString("base64"), re = ["-----BEGIN " + J.label + "-----"], ie = 0; ie < te.length; ie += 64)
      re.push(te.slice(ie, ie + 64));
    return re.push("-----END " + J.label + "-----"), re.join(`
`);
  }, pem;
}
var hasRequiredEncoders;
function requireEncoders() {
  return hasRequiredEncoders || (hasRequiredEncoders = 1, function(C) {
    var e = C;
    e.der = requireDer(), e.pem = requirePem();
  }(encoders)), encoders;
}
var hasRequiredAsn1$1;
function requireAsn1$1() {
  return hasRequiredAsn1$1 || (hasRequiredAsn1$1 = 1, function(C) {
    var e = C;
    e.bignum = requireBn$2(), e.define = requireApi().define, e.base = requireBase(), e.constants = requireConstants(), e.decoders = requireDecoders(), e.encoders = requireEncoders();
  }(asn1)), asn1;
}
var certificate, hasRequiredCertificate;
function requireCertificate() {
  if (hasRequiredCertificate) return certificate;
  hasRequiredCertificate = 1;
  var C = requireAsn1$1(), e = C.define("Time", function() {
    this.choice({
      utcTime: this.utctime(),
      generalTime: this.gentime()
    });
  }), T = C.define("AttributeTypeValue", function() {
    this.seq().obj(
      this.key("type").objid(),
      this.key("value").any()
    );
  }), $ = C.define("AlgorithmIdentifier", function() {
    this.seq().obj(
      this.key("algorithm").objid(),
      this.key("parameters").optional(),
      this.key("curve").objid().optional()
    );
  }), V = C.define("SubjectPublicKeyInfo", function() {
    this.seq().obj(
      this.key("algorithm").use($),
      this.key("subjectPublicKey").bitstr()
    );
  }), J = C.define("RelativeDistinguishedName", function() {
    this.setof(T);
  }), ee = C.define("RDNSequence", function() {
    this.seqof(J);
  }), te = C.define("Name", function() {
    this.choice({
      rdnSequence: this.use(ee)
    });
  }), re = C.define("Validity", function() {
    this.seq().obj(
      this.key("notBefore").use(e),
      this.key("notAfter").use(e)
    );
  }), ie = C.define("Extension", function() {
    this.seq().obj(
      this.key("extnID").objid(),
      this.key("critical").bool().def(!1),
      this.key("extnValue").octstr()
    );
  }), se = C.define("TBSCertificate", function() {
    this.seq().obj(
      this.key("version").explicit(0).int().optional(),
      this.key("serialNumber").int(),
      this.key("signature").use($),
      this.key("issuer").use(te),
      this.key("validity").use(re),
      this.key("subject").use(te),
      this.key("subjectPublicKeyInfo").use(V),
      this.key("issuerUniqueID").implicit(1).bitstr().optional(),
      this.key("subjectUniqueID").implicit(2).bitstr().optional(),
      this.key("extensions").explicit(3).seqof(ie).optional()
    );
  }), de = C.define("X509Certificate", function() {
    this.seq().obj(
      this.key("tbsCertificate").use(se),
      this.key("signatureAlgorithm").use($),
      this.key("signatureValue").bitstr()
    );
  });
  return certificate = de, certificate;
}
var hasRequiredAsn1;
function requireAsn1() {
  if (hasRequiredAsn1) return asn1$1;
  hasRequiredAsn1 = 1;
  var C = requireAsn1$1();
  asn1$1.certificate = requireCertificate();
  var e = C.define("RSAPrivateKey", function() {
    this.seq().obj(
      this.key("version").int(),
      this.key("modulus").int(),
      this.key("publicExponent").int(),
      this.key("privateExponent").int(),
      this.key("prime1").int(),
      this.key("prime2").int(),
      this.key("exponent1").int(),
      this.key("exponent2").int(),
      this.key("coefficient").int()
    );
  });
  asn1$1.RSAPrivateKey = e;
  var T = C.define("RSAPublicKey", function() {
    this.seq().obj(
      this.key("modulus").int(),
      this.key("publicExponent").int()
    );
  });
  asn1$1.RSAPublicKey = T;
  var $ = C.define("AlgorithmIdentifier", function() {
    this.seq().obj(
      this.key("algorithm").objid(),
      this.key("none").null_().optional(),
      this.key("curve").objid().optional(),
      this.key("params").seq().obj(
        this.key("p").int(),
        this.key("q").int(),
        this.key("g").int()
      ).optional()
    );
  }), V = C.define("SubjectPublicKeyInfo", function() {
    this.seq().obj(
      this.key("algorithm").use($),
      this.key("subjectPublicKey").bitstr()
    );
  });
  asn1$1.PublicKey = V;
  var J = C.define("PrivateKeyInfo", function() {
    this.seq().obj(
      this.key("version").int(),
      this.key("algorithm").use($),
      this.key("subjectPrivateKey").octstr()
    );
  });
  asn1$1.PrivateKey = J;
  var ee = C.define("EncryptedPrivateKeyInfo", function() {
    this.seq().obj(
      this.key("algorithm").seq().obj(
        this.key("id").objid(),
        this.key("decrypt").seq().obj(
          this.key("kde").seq().obj(
            this.key("id").objid(),
            this.key("kdeparams").seq().obj(
              this.key("salt").octstr(),
              this.key("iters").int()
            )
          ),
          this.key("cipher").seq().obj(
            this.key("algo").objid(),
            this.key("iv").octstr()
          )
        )
      ),
      this.key("subjectPrivateKey").octstr()
    );
  });
  asn1$1.EncryptedPrivateKey = ee;
  var te = C.define("DSAPrivateKey", function() {
    this.seq().obj(
      this.key("version").int(),
      this.key("p").int(),
      this.key("q").int(),
      this.key("g").int(),
      this.key("pub_key").int(),
      this.key("priv_key").int()
    );
  });
  asn1$1.DSAPrivateKey = te, asn1$1.DSAparam = C.define("DSAparam", function() {
    this.int();
  });
  var re = C.define("ECParameters", function() {
    this.choice({
      namedCurve: this.objid()
    });
  }), ie = C.define("ECPrivateKey", function() {
    this.seq().obj(
      this.key("version").int(),
      this.key("privateKey").octstr(),
      this.key("parameters").optional().explicit(0).use(re),
      this.key("publicKey").optional().explicit(1).bitstr()
    );
  });
  return asn1$1.ECPrivateKey = ie, asn1$1.signature = C.define("signature", function() {
    this.seq().obj(
      this.key("r").int(),
      this.key("s").int()
    );
  }), asn1$1;
}
const require$$1 = {
  "2.16.840.1.101.3.4.1.1": "aes-128-ecb",
  "2.16.840.1.101.3.4.1.2": "aes-128-cbc",
  "2.16.840.1.101.3.4.1.3": "aes-128-ofb",
  "2.16.840.1.101.3.4.1.4": "aes-128-cfb",
  "2.16.840.1.101.3.4.1.21": "aes-192-ecb",
  "2.16.840.1.101.3.4.1.22": "aes-192-cbc",
  "2.16.840.1.101.3.4.1.23": "aes-192-ofb",
  "2.16.840.1.101.3.4.1.24": "aes-192-cfb",
  "2.16.840.1.101.3.4.1.41": "aes-256-ecb",
  "2.16.840.1.101.3.4.1.42": "aes-256-cbc",
  "2.16.840.1.101.3.4.1.43": "aes-256-ofb",
  "2.16.840.1.101.3.4.1.44": "aes-256-cfb"
};
var fixProc, hasRequiredFixProc;
function requireFixProc() {
  if (hasRequiredFixProc) return fixProc;
  hasRequiredFixProc = 1;
  var C = /Proc-Type: 4,ENCRYPTED[\n\r]+DEK-Info: AES-((?:128)|(?:192)|(?:256))-CBC,([0-9A-H]+)[\n\r]+([0-9A-z\n\r+/=]+)[\n\r]+/m, e = /^-----BEGIN ((?:.*? KEY)|CERTIFICATE)-----/m, T = /^-----BEGIN ((?:.*? KEY)|CERTIFICATE)-----([0-9A-z\n\r+/=]+)-----END \1-----$/m, $ = requireEvp_bytestokey(), V = requireBrowser$6(), J = safeBufferExports.Buffer;
  return fixProc = function(ee, te) {
    var re = ee.toString(), ie = re.match(C), se;
    if (ie) {
      var ue = "aes" + ie[1], fe = J.from(ie[2], "hex"), he = J.from(ie[3].replace(/[\r\n]/g, ""), "base64"), me = $(te, fe.slice(0, 8), parseInt(ie[1], 10)).key, xe = [], ve = V.createDecipheriv(ue, me, fe);
      xe.push(ve.update(he)), xe.push(ve.final()), se = J.concat(xe);
    } else {
      var de = re.match(T);
      se = J.from(de[2].replace(/[\r\n]/g, ""), "base64");
    }
    var Te = re.match(e)[1];
    return {
      tag: Te,
      data: se
    };
  }, fixProc;
}
var parseAsn1, hasRequiredParseAsn1;
function requireParseAsn1() {
  if (hasRequiredParseAsn1) return parseAsn1;
  hasRequiredParseAsn1 = 1;
  var C = requireAsn1(), e = require$$1, T = requireFixProc(), $ = requireBrowser$6(), V = requireBrowser$7(), J = safeBufferExports.Buffer;
  function ee(re, ie) {
    var se = re.algorithm.decrypt.kde.kdeparams.salt, de = parseInt(re.algorithm.decrypt.kde.kdeparams.iters.toString(), 10), ue = e[re.algorithm.decrypt.cipher.algo.join(".")], fe = re.algorithm.decrypt.cipher.iv, he = re.subjectPrivateKey, me = parseInt(ue.split("-")[1], 10) / 8, xe = V.pbkdf2Sync(ie, se, de, me, "sha1"), ve = $.createDecipheriv(ue, xe, fe), Te = [];
    return Te.push(ve.update(he)), Te.push(ve.final()), J.concat(Te);
  }
  function te(re) {
    var ie;
    typeof re == "object" && !J.isBuffer(re) && (ie = re.passphrase, re = re.key), typeof re == "string" && (re = J.from(re));
    var se = T(re, ie), de = se.tag, ue = se.data, fe, he;
    switch (de) {
      case "CERTIFICATE":
        he = C.certificate.decode(ue, "der").tbsCertificate.subjectPublicKeyInfo;
      case "PUBLIC KEY":
        switch (he || (he = C.PublicKey.decode(ue, "der")), fe = he.algorithm.algorithm.join("."), fe) {
          case "1.2.840.113549.1.1.1":
            return C.RSAPublicKey.decode(he.subjectPublicKey.data, "der");
          case "1.2.840.10045.2.1":
            return he.subjectPrivateKey = he.subjectPublicKey, {
              type: "ec",
              data: he
            };
          case "1.2.840.10040.4.1":
            return he.algorithm.params.pub_key = C.DSAparam.decode(he.subjectPublicKey.data, "der"), {
              type: "dsa",
              data: he.algorithm.params
            };
          default:
            throw new Error("unknown key id " + fe);
        }
      case "ENCRYPTED PRIVATE KEY":
        ue = C.EncryptedPrivateKey.decode(ue, "der"), ue = ee(ue, ie);
      case "PRIVATE KEY":
        switch (he = C.PrivateKey.decode(ue, "der"), fe = he.algorithm.algorithm.join("."), fe) {
          case "1.2.840.113549.1.1.1":
            return C.RSAPrivateKey.decode(he.subjectPrivateKey, "der");
          case "1.2.840.10045.2.1":
            return {
              curve: he.algorithm.curve,
              privateKey: C.ECPrivateKey.decode(he.subjectPrivateKey, "der").privateKey
            };
          case "1.2.840.10040.4.1":
            return he.algorithm.params.priv_key = C.DSAparam.decode(he.subjectPrivateKey, "der"), {
              type: "dsa",
              params: he.algorithm.params
            };
          default:
            throw new Error("unknown key id " + fe);
        }
      case "RSA PUBLIC KEY":
        return C.RSAPublicKey.decode(ue, "der");
      case "RSA PRIVATE KEY":
        return C.RSAPrivateKey.decode(ue, "der");
      case "DSA PRIVATE KEY":
        return {
          type: "dsa",
          params: C.DSAPrivateKey.decode(ue, "der")
        };
      case "EC PRIVATE KEY":
        return ue = C.ECPrivateKey.decode(ue, "der"), {
          curve: ue.parameters.value,
          privateKey: ue.privateKey
        };
      default:
        throw new Error("unknown key type " + de);
    }
  }
  return te.signature = C.signature, parseAsn1 = te, parseAsn1;
}
const require$$4$1 = {
  "1.3.132.0.10": "secp256k1",
  "1.3.132.0.33": "p224",
  "1.2.840.10045.3.1.1": "p192",
  "1.2.840.10045.3.1.7": "p256",
  "1.3.132.0.34": "p384",
  "1.3.132.0.35": "p521"
};
var hasRequiredSign;
function requireSign() {
  if (hasRequiredSign) return sign$1.exports;
  hasRequiredSign = 1;
  var C = safeBufferExports.Buffer, e = requireBrowser$8(), T = requireBrowserifyRsa(), $ = requireElliptic().ec, V = bnExports, J = requireParseAsn1(), ee = require$$4$1, te = 1;
  function re(ve, Te, we, Ee, Me) {
    var Ie = J(Te);
    if (Ie.curve) {
      if (Ee !== "ecdsa" && Ee !== "ecdsa/rsa")
        throw new Error("wrong private key type");
      return ie(ve, Ie);
    } else if (Ie.type === "dsa") {
      if (Ee !== "dsa")
        throw new Error("wrong private key type");
      return se(ve, Ie, we);
    }
    if (Ee !== "rsa" && Ee !== "ecdsa/rsa")
      throw new Error("wrong private key type");
    if (Te.padding !== void 0 && Te.padding !== te)
      throw new Error("illegal or unsupported padding mode");
    ve = C.concat([Me, ve]);
    for (var ke = Ie.modulus.byteLength(), _e = [0, 1]; ve.length + _e.length + 1 < ke; )
      _e.push(255);
    _e.push(0);
    for (var De = -1; ++De < ve.length; )
      _e.push(ve[De]);
    var Fe = T(_e, Ie);
    return Fe;
  }
  function ie(ve, Te) {
    var we = ee[Te.curve.join(".")];
    if (!we)
      throw new Error("unknown curve " + Te.curve.join("."));
    var Ee = new $(we), Me = Ee.keyFromPrivate(Te.privateKey), Ie = Me.sign(ve);
    return C.from(Ie.toDER());
  }
  function se(ve, Te, we) {
    for (var Ee = Te.params.priv_key, Me = Te.params.p, Ie = Te.params.q, ke = Te.params.g, _e = new V(0), De, Fe = fe(ve, Ie).mod(Ie), Ae = !1, ne = ue(Ee, Ie, ve, we); Ae === !1; )
      De = me(Ie, ne, we), _e = xe(ke, De, Me, Ie), Ae = De.invm(Ie).imul(Fe.add(Ee.mul(_e))).mod(Ie), Ae.cmpn(0) === 0 && (Ae = !1, _e = new V(0));
    return de(_e, Ae);
  }
  function de(ve, Te) {
    ve = ve.toArray(), Te = Te.toArray(), ve[0] & 128 && (ve = [0].concat(ve)), Te[0] & 128 && (Te = [0].concat(Te));
    var we = ve.length + Te.length + 4, Ee = [
      48,
      we,
      2,
      ve.length
    ];
    return Ee = Ee.concat(ve, [2, Te.length], Te), C.from(Ee);
  }
  function ue(ve, Te, we, Ee) {
    if (ve = C.from(ve.toArray()), ve.length < Te.byteLength()) {
      var Me = C.alloc(Te.byteLength() - ve.length);
      ve = C.concat([Me, ve]);
    }
    var Ie = we.length, ke = he(we, Te), _e = C.alloc(Ie);
    _e.fill(1);
    var De = C.alloc(Ie);
    return De = e(Ee, De).update(_e).update(C.from([0])).update(ve).update(ke).digest(), _e = e(Ee, De).update(_e).digest(), De = e(Ee, De).update(_e).update(C.from([1])).update(ve).update(ke).digest(), _e = e(Ee, De).update(_e).digest(), { k: De, v: _e };
  }
  function fe(ve, Te) {
    var we = new V(ve), Ee = (ve.length << 3) - Te.bitLength();
    return Ee > 0 && we.ishrn(Ee), we;
  }
  function he(ve, Te) {
    ve = fe(ve, Te), ve = ve.mod(Te);
    var we = C.from(ve.toArray());
    if (we.length < Te.byteLength()) {
      var Ee = C.alloc(Te.byteLength() - we.length);
      we = C.concat([Ee, we]);
    }
    return we;
  }
  function me(ve, Te, we) {
    var Ee, Me;
    do {
      for (Ee = C.alloc(0); Ee.length * 8 < ve.bitLength(); )
        Te.v = e(we, Te.k).update(Te.v).digest(), Ee = C.concat([Ee, Te.v]);
      Me = fe(Ee, ve), Te.k = e(we, Te.k).update(Te.v).update(C.from([0])).digest(), Te.v = e(we, Te.k).update(Te.v).digest();
    } while (Me.cmp(ve) !== -1);
    return Me;
  }
  function xe(ve, Te, we, Ee) {
    return ve.toRed(V.mont(we)).redPow(Te).fromRed().mod(Ee);
  }
  return sign$1.exports = re, sign$1.exports.getKey = ue, sign$1.exports.makeKey = me, sign$1.exports;
}
var verify_1, hasRequiredVerify;
function requireVerify() {
  if (hasRequiredVerify) return verify_1;
  hasRequiredVerify = 1;
  var C = safeBufferExports.Buffer, e = bnExports, T = requireElliptic().ec, $ = requireParseAsn1(), V = require$$4$1;
  function J(ie, se, de, ue, fe) {
    var he = $(de);
    if (he.type === "ec") {
      if (ue !== "ecdsa" && ue !== "ecdsa/rsa")
        throw new Error("wrong public key type");
      return ee(ie, se, he);
    } else if (he.type === "dsa") {
      if (ue !== "dsa")
        throw new Error("wrong public key type");
      return te(ie, se, he);
    }
    if (ue !== "rsa" && ue !== "ecdsa/rsa")
      throw new Error("wrong public key type");
    se = C.concat([fe, se]);
    for (var me = he.modulus.byteLength(), xe = [1], ve = 0; se.length + xe.length + 2 < me; )
      xe.push(255), ve += 1;
    xe.push(0);
    for (var Te = -1; ++Te < se.length; )
      xe.push(se[Te]);
    xe = C.from(xe);
    var we = e.mont(he.modulus);
    ie = new e(ie).toRed(we), ie = ie.redPow(new e(he.publicExponent)), ie = C.from(ie.fromRed().toArray());
    var Ee = ve < 8 ? 1 : 0;
    for (me = Math.min(ie.length, xe.length), ie.length !== xe.length && (Ee = 1), Te = -1; ++Te < me; )
      Ee |= ie[Te] ^ xe[Te];
    return Ee === 0;
  }
  function ee(ie, se, de) {
    var ue = V[de.data.algorithm.curve.join(".")];
    if (!ue)
      throw new Error("unknown curve " + de.data.algorithm.curve.join("."));
    var fe = new T(ue), he = de.data.subjectPrivateKey.data;
    return fe.verify(se, ie, he);
  }
  function te(ie, se, de) {
    var ue = de.data.p, fe = de.data.q, he = de.data.g, me = de.data.pub_key, xe = $.signature.decode(ie, "der"), ve = xe.s, Te = xe.r;
    re(ve, fe), re(Te, fe);
    var we = e.mont(ue), Ee = ve.invm(fe), Me = he.toRed(we).redPow(new e(se).mul(Ee).mod(fe)).fromRed().mul(me.toRed(we).redPow(Te.mul(Ee).mod(fe)).fromRed()).mod(ue).mod(fe);
    return Me.cmp(Te) === 0;
  }
  function re(ie, se) {
    if (ie.cmpn(0) <= 0)
      throw new Error("invalid sig");
    if (ie.cmp(se) >= 0)
      throw new Error("invalid sig");
  }
  return verify_1 = J, verify_1;
}
var browser$5, hasRequiredBrowser$3;
function requireBrowser$3() {
  if (hasRequiredBrowser$3) return browser$5;
  hasRequiredBrowser$3 = 1;
  var C = safeBufferExports.Buffer, e = requireBrowser$9(), T = requireReadableBrowser(), $ = requireInherits_browser(), V = requireSign(), J = requireVerify(), ee = require$$6;
  Object.keys(ee).forEach(function(de) {
    ee[de].id = C.from(ee[de].id, "hex"), ee[de.toLowerCase()] = ee[de];
  });
  function te(de) {
    T.Writable.call(this);
    var ue = ee[de];
    if (!ue)
      throw new Error("Unknown message digest");
    this._hashType = ue.hash, this._hash = e(ue.hash), this._tag = ue.id, this._signType = ue.sign;
  }
  $(te, T.Writable), te.prototype._write = function(ue, fe, he) {
    this._hash.update(ue), he();
  }, te.prototype.update = function(ue, fe) {
    return this._hash.update(typeof ue == "string" ? C.from(ue, fe) : ue), this;
  }, te.prototype.sign = function(ue, fe) {
    this.end();
    var he = this._hash.digest(), me = V(he, ue, this._hashType, this._signType, this._tag);
    return fe ? me.toString(fe) : me;
  };
  function re(de) {
    T.Writable.call(this);
    var ue = ee[de];
    if (!ue)
      throw new Error("Unknown message digest");
    this._hash = e(ue.hash), this._tag = ue.id, this._signType = ue.sign;
  }
  $(re, T.Writable), re.prototype._write = function(ue, fe, he) {
    this._hash.update(ue), he();
  }, re.prototype.update = function(ue, fe) {
    return this._hash.update(typeof ue == "string" ? C.from(ue, fe) : ue), this;
  }, re.prototype.verify = function(ue, fe, he) {
    var me = typeof fe == "string" ? C.from(fe, he) : fe;
    this.end();
    var xe = this._hash.digest();
    return J(me, xe, ue, this._signType, this._tag);
  };
  function ie(de) {
    return new te(de);
  }
  function se(de) {
    return new re(de);
  }
  return browser$5 = {
    Sign: ie,
    Verify: se,
    createSign: ie,
    createVerify: se
  }, browser$5;
}
var bn$1 = { exports: {} };
bn$1.exports;
var hasRequiredBn$1;
function requireBn$1() {
  return hasRequiredBn$1 || (hasRequiredBn$1 = 1, function(C) {
    (function(e, T) {
      function $(Ae, ne) {
        if (!Ae) throw new Error(ne || "Assertion failed");
      }
      function V(Ae, ne) {
        Ae.super_ = ne;
        var oe = function() {
        };
        oe.prototype = ne.prototype, Ae.prototype = new oe(), Ae.prototype.constructor = Ae;
      }
      function J(Ae, ne, oe) {
        if (J.isBN(Ae))
          return Ae;
        this.negative = 0, this.words = null, this.length = 0, this.red = null, Ae !== null && ((ne === "le" || ne === "be") && (oe = ne, ne = 10), this._init(Ae || 0, ne || 10, oe || "be"));
      }
      typeof e == "object" ? e.exports = J : T.BN = J, J.BN = J, J.wordSize = 26;
      var ee;
      try {
        typeof window < "u" && typeof window.Buffer < "u" ? ee = window.Buffer : ee = bufferPolyfill.Buffer;
      } catch {
      }
      J.isBN = function(ne) {
        return ne instanceof J ? !0 : ne !== null && typeof ne == "object" && ne.constructor.wordSize === J.wordSize && Array.isArray(ne.words);
      }, J.max = function(ne, oe) {
        return ne.cmp(oe) > 0 ? ne : oe;
      }, J.min = function(ne, oe) {
        return ne.cmp(oe) < 0 ? ne : oe;
      }, J.prototype._init = function(ne, oe, ce) {
        if (typeof ne == "number")
          return this._initNumber(ne, oe, ce);
        if (typeof ne == "object")
          return this._initArray(ne, oe, ce);
        oe === "hex" && (oe = 16), $(oe === (oe | 0) && oe >= 2 && oe <= 36), ne = ne.toString().replace(/\s+/g, "");
        var le = 0;
        ne[0] === "-" && (le++, this.negative = 1), le < ne.length && (oe === 16 ? this._parseHex(ne, le, ce) : (this._parseBase(ne, oe, le), ce === "le" && this._initArray(this.toArray(), oe, ce)));
      }, J.prototype._initNumber = function(ne, oe, ce) {
        ne < 0 && (this.negative = 1, ne = -ne), ne < 67108864 ? (this.words = [ne & 67108863], this.length = 1) : ne < 4503599627370496 ? (this.words = [
          ne & 67108863,
          ne / 67108864 & 67108863
        ], this.length = 2) : ($(ne < 9007199254740992), this.words = [
          ne & 67108863,
          ne / 67108864 & 67108863,
          1
        ], this.length = 3), ce === "le" && this._initArray(this.toArray(), oe, ce);
      }, J.prototype._initArray = function(ne, oe, ce) {
        if ($(typeof ne.length == "number"), ne.length <= 0)
          return this.words = [0], this.length = 1, this;
        this.length = Math.ceil(ne.length / 3), this.words = new Array(this.length);
        for (var le = 0; le < this.length; le++)
          this.words[le] = 0;
        var pe, ye, Ce = 0;
        if (ce === "be")
          for (le = ne.length - 1, pe = 0; le >= 0; le -= 3)
            ye = ne[le] | ne[le - 1] << 8 | ne[le - 2] << 16, this.words[pe] |= ye << Ce & 67108863, this.words[pe + 1] = ye >>> 26 - Ce & 67108863, Ce += 24, Ce >= 26 && (Ce -= 26, pe++);
        else if (ce === "le")
          for (le = 0, pe = 0; le < ne.length; le += 3)
            ye = ne[le] | ne[le + 1] << 8 | ne[le + 2] << 16, this.words[pe] |= ye << Ce & 67108863, this.words[pe + 1] = ye >>> 26 - Ce & 67108863, Ce += 24, Ce >= 26 && (Ce -= 26, pe++);
        return this.strip();
      };
      function te(Ae, ne) {
        var oe = Ae.charCodeAt(ne);
        return oe >= 65 && oe <= 70 ? oe - 55 : oe >= 97 && oe <= 102 ? oe - 87 : oe - 48 & 15;
      }
      function re(Ae, ne, oe) {
        var ce = te(Ae, oe);
        return oe - 1 >= ne && (ce |= te(Ae, oe - 1) << 4), ce;
      }
      J.prototype._parseHex = function(ne, oe, ce) {
        this.length = Math.ceil((ne.length - oe) / 6), this.words = new Array(this.length);
        for (var le = 0; le < this.length; le++)
          this.words[le] = 0;
        var pe = 0, ye = 0, Ce;
        if (ce === "be")
          for (le = ne.length - 1; le >= oe; le -= 2)
            Ce = re(ne, oe, le) << pe, this.words[ye] |= Ce & 67108863, pe >= 18 ? (pe -= 18, ye += 1, this.words[ye] |= Ce >>> 26) : pe += 8;
        else {
          var be = ne.length - oe;
          for (le = be % 2 === 0 ? oe + 1 : oe; le < ne.length; le += 2)
            Ce = re(ne, oe, le) << pe, this.words[ye] |= Ce & 67108863, pe >= 18 ? (pe -= 18, ye += 1, this.words[ye] |= Ce >>> 26) : pe += 8;
        }
        this.strip();
      };
      function ie(Ae, ne, oe, ce) {
        for (var le = 0, pe = Math.min(Ae.length, oe), ye = ne; ye < pe; ye++) {
          var Ce = Ae.charCodeAt(ye) - 48;
          le *= ce, Ce >= 49 ? le += Ce - 49 + 10 : Ce >= 17 ? le += Ce - 17 + 10 : le += Ce;
        }
        return le;
      }
      J.prototype._parseBase = function(ne, oe, ce) {
        this.words = [0], this.length = 1;
        for (var le = 0, pe = 1; pe <= 67108863; pe *= oe)
          le++;
        le--, pe = pe / oe | 0;
        for (var ye = ne.length - ce, Ce = ye % le, be = Math.min(ye, ye - Ce) + ce, ae = 0, ge = ce; ge < be; ge += le)
          ae = ie(ne, ge, ge + le, oe), this.imuln(pe), this.words[0] + ae < 67108864 ? this.words[0] += ae : this._iaddn(ae);
        if (Ce !== 0) {
          var Se = 1;
          for (ae = ie(ne, ge, ne.length, oe), ge = 0; ge < Ce; ge++)
            Se *= oe;
          this.imuln(Se), this.words[0] + ae < 67108864 ? this.words[0] += ae : this._iaddn(ae);
        }
        this.strip();
      }, J.prototype.copy = function(ne) {
        ne.words = new Array(this.length);
        for (var oe = 0; oe < this.length; oe++)
          ne.words[oe] = this.words[oe];
        ne.length = this.length, ne.negative = this.negative, ne.red = this.red;
      }, J.prototype.clone = function() {
        var ne = new J(null);
        return this.copy(ne), ne;
      }, J.prototype._expand = function(ne) {
        for (; this.length < ne; )
          this.words[this.length++] = 0;
        return this;
      }, J.prototype.strip = function() {
        for (; this.length > 1 && this.words[this.length - 1] === 0; )
          this.length--;
        return this._normSign();
      }, J.prototype._normSign = function() {
        return this.length === 1 && this.words[0] === 0 && (this.negative = 0), this;
      }, J.prototype.inspect = function() {
        return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
      };
      var se = [
        "",
        "0",
        "00",
        "000",
        "0000",
        "00000",
        "000000",
        "0000000",
        "00000000",
        "000000000",
        "0000000000",
        "00000000000",
        "000000000000",
        "0000000000000",
        "00000000000000",
        "000000000000000",
        "0000000000000000",
        "00000000000000000",
        "000000000000000000",
        "0000000000000000000",
        "00000000000000000000",
        "000000000000000000000",
        "0000000000000000000000",
        "00000000000000000000000",
        "000000000000000000000000",
        "0000000000000000000000000"
      ], de = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
      ], ue = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        1e7,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64e6,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        243e5,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
      ];
      J.prototype.toString = function(ne, oe) {
        ne = ne || 10, oe = oe | 0 || 1;
        var ce;
        if (ne === 16 || ne === "hex") {
          ce = "";
          for (var le = 0, pe = 0, ye = 0; ye < this.length; ye++) {
            var Ce = this.words[ye], be = ((Ce << le | pe) & 16777215).toString(16);
            pe = Ce >>> 24 - le & 16777215, le += 2, le >= 26 && (le -= 26, ye--), pe !== 0 || ye !== this.length - 1 ? ce = se[6 - be.length] + be + ce : ce = be + ce;
          }
          for (pe !== 0 && (ce = pe.toString(16) + ce); ce.length % oe !== 0; )
            ce = "0" + ce;
          return this.negative !== 0 && (ce = "-" + ce), ce;
        }
        if (ne === (ne | 0) && ne >= 2 && ne <= 36) {
          var ae = de[ne], ge = ue[ne];
          ce = "";
          var Se = this.clone();
          for (Se.negative = 0; !Se.isZero(); ) {
            var Le = Se.modn(ge).toString(ne);
            Se = Se.idivn(ge), Se.isZero() ? ce = Le + ce : ce = se[ae - Le.length] + Le + ce;
          }
          for (this.isZero() && (ce = "0" + ce); ce.length % oe !== 0; )
            ce = "0" + ce;
          return this.negative !== 0 && (ce = "-" + ce), ce;
        }
        $(!1, "Base should be between 2 and 36");
      }, J.prototype.toNumber = function() {
        var ne = this.words[0];
        return this.length === 2 ? ne += this.words[1] * 67108864 : this.length === 3 && this.words[2] === 1 ? ne += 4503599627370496 + this.words[1] * 67108864 : this.length > 2 && $(!1, "Number can only safely store up to 53 bits"), this.negative !== 0 ? -ne : ne;
      }, J.prototype.toJSON = function() {
        return this.toString(16);
      }, J.prototype.toBuffer = function(ne, oe) {
        return $(typeof ee < "u"), this.toArrayLike(ee, ne, oe);
      }, J.prototype.toArray = function(ne, oe) {
        return this.toArrayLike(Array, ne, oe);
      }, J.prototype.toArrayLike = function(ne, oe, ce) {
        var le = this.byteLength(), pe = ce || Math.max(1, le);
        $(le <= pe, "byte array longer than desired length"), $(pe > 0, "Requested array length <= 0"), this.strip();
        var ye = oe === "le", Ce = new ne(pe), be, ae, ge = this.clone();
        if (ye) {
          for (ae = 0; !ge.isZero(); ae++)
            be = ge.andln(255), ge.iushrn(8), Ce[ae] = be;
          for (; ae < pe; ae++)
            Ce[ae] = 0;
        } else {
          for (ae = 0; ae < pe - le; ae++)
            Ce[ae] = 0;
          for (ae = 0; !ge.isZero(); ae++)
            be = ge.andln(255), ge.iushrn(8), Ce[pe - ae - 1] = be;
        }
        return Ce;
      }, Math.clz32 ? J.prototype._countBits = function(ne) {
        return 32 - Math.clz32(ne);
      } : J.prototype._countBits = function(ne) {
        var oe = ne, ce = 0;
        return oe >= 4096 && (ce += 13, oe >>>= 13), oe >= 64 && (ce += 7, oe >>>= 7), oe >= 8 && (ce += 4, oe >>>= 4), oe >= 2 && (ce += 2, oe >>>= 2), ce + oe;
      }, J.prototype._zeroBits = function(ne) {
        if (ne === 0) return 26;
        var oe = ne, ce = 0;
        return oe & 8191 || (ce += 13, oe >>>= 13), oe & 127 || (ce += 7, oe >>>= 7), oe & 15 || (ce += 4, oe >>>= 4), oe & 3 || (ce += 2, oe >>>= 2), oe & 1 || ce++, ce;
      }, J.prototype.bitLength = function() {
        var ne = this.words[this.length - 1], oe = this._countBits(ne);
        return (this.length - 1) * 26 + oe;
      };
      function fe(Ae) {
        for (var ne = new Array(Ae.bitLength()), oe = 0; oe < ne.length; oe++) {
          var ce = oe / 26 | 0, le = oe % 26;
          ne[oe] = (Ae.words[ce] & 1 << le) >>> le;
        }
        return ne;
      }
      J.prototype.zeroBits = function() {
        if (this.isZero()) return 0;
        for (var ne = 0, oe = 0; oe < this.length; oe++) {
          var ce = this._zeroBits(this.words[oe]);
          if (ne += ce, ce !== 26) break;
        }
        return ne;
      }, J.prototype.byteLength = function() {
        return Math.ceil(this.bitLength() / 8);
      }, J.prototype.toTwos = function(ne) {
        return this.negative !== 0 ? this.abs().inotn(ne).iaddn(1) : this.clone();
      }, J.prototype.fromTwos = function(ne) {
        return this.testn(ne - 1) ? this.notn(ne).iaddn(1).ineg() : this.clone();
      }, J.prototype.isNeg = function() {
        return this.negative !== 0;
      }, J.prototype.neg = function() {
        return this.clone().ineg();
      }, J.prototype.ineg = function() {
        return this.isZero() || (this.negative ^= 1), this;
      }, J.prototype.iuor = function(ne) {
        for (; this.length < ne.length; )
          this.words[this.length++] = 0;
        for (var oe = 0; oe < ne.length; oe++)
          this.words[oe] = this.words[oe] | ne.words[oe];
        return this.strip();
      }, J.prototype.ior = function(ne) {
        return $((this.negative | ne.negative) === 0), this.iuor(ne);
      }, J.prototype.or = function(ne) {
        return this.length > ne.length ? this.clone().ior(ne) : ne.clone().ior(this);
      }, J.prototype.uor = function(ne) {
        return this.length > ne.length ? this.clone().iuor(ne) : ne.clone().iuor(this);
      }, J.prototype.iuand = function(ne) {
        var oe;
        this.length > ne.length ? oe = ne : oe = this;
        for (var ce = 0; ce < oe.length; ce++)
          this.words[ce] = this.words[ce] & ne.words[ce];
        return this.length = oe.length, this.strip();
      }, J.prototype.iand = function(ne) {
        return $((this.negative | ne.negative) === 0), this.iuand(ne);
      }, J.prototype.and = function(ne) {
        return this.length > ne.length ? this.clone().iand(ne) : ne.clone().iand(this);
      }, J.prototype.uand = function(ne) {
        return this.length > ne.length ? this.clone().iuand(ne) : ne.clone().iuand(this);
      }, J.prototype.iuxor = function(ne) {
        var oe, ce;
        this.length > ne.length ? (oe = this, ce = ne) : (oe = ne, ce = this);
        for (var le = 0; le < ce.length; le++)
          this.words[le] = oe.words[le] ^ ce.words[le];
        if (this !== oe)
          for (; le < oe.length; le++)
            this.words[le] = oe.words[le];
        return this.length = oe.length, this.strip();
      }, J.prototype.ixor = function(ne) {
        return $((this.negative | ne.negative) === 0), this.iuxor(ne);
      }, J.prototype.xor = function(ne) {
        return this.length > ne.length ? this.clone().ixor(ne) : ne.clone().ixor(this);
      }, J.prototype.uxor = function(ne) {
        return this.length > ne.length ? this.clone().iuxor(ne) : ne.clone().iuxor(this);
      }, J.prototype.inotn = function(ne) {
        $(typeof ne == "number" && ne >= 0);
        var oe = Math.ceil(ne / 26) | 0, ce = ne % 26;
        this._expand(oe), ce > 0 && oe--;
        for (var le = 0; le < oe; le++)
          this.words[le] = ~this.words[le] & 67108863;
        return ce > 0 && (this.words[le] = ~this.words[le] & 67108863 >> 26 - ce), this.strip();
      }, J.prototype.notn = function(ne) {
        return this.clone().inotn(ne);
      }, J.prototype.setn = function(ne, oe) {
        $(typeof ne == "number" && ne >= 0);
        var ce = ne / 26 | 0, le = ne % 26;
        return this._expand(ce + 1), oe ? this.words[ce] = this.words[ce] | 1 << le : this.words[ce] = this.words[ce] & ~(1 << le), this.strip();
      }, J.prototype.iadd = function(ne) {
        var oe;
        if (this.negative !== 0 && ne.negative === 0)
          return this.negative = 0, oe = this.isub(ne), this.negative ^= 1, this._normSign();
        if (this.negative === 0 && ne.negative !== 0)
          return ne.negative = 0, oe = this.isub(ne), ne.negative = 1, oe._normSign();
        var ce, le;
        this.length > ne.length ? (ce = this, le = ne) : (ce = ne, le = this);
        for (var pe = 0, ye = 0; ye < le.length; ye++)
          oe = (ce.words[ye] | 0) + (le.words[ye] | 0) + pe, this.words[ye] = oe & 67108863, pe = oe >>> 26;
        for (; pe !== 0 && ye < ce.length; ye++)
          oe = (ce.words[ye] | 0) + pe, this.words[ye] = oe & 67108863, pe = oe >>> 26;
        if (this.length = ce.length, pe !== 0)
          this.words[this.length] = pe, this.length++;
        else if (ce !== this)
          for (; ye < ce.length; ye++)
            this.words[ye] = ce.words[ye];
        return this;
      }, J.prototype.add = function(ne) {
        var oe;
        return ne.negative !== 0 && this.negative === 0 ? (ne.negative = 0, oe = this.sub(ne), ne.negative ^= 1, oe) : ne.negative === 0 && this.negative !== 0 ? (this.negative = 0, oe = ne.sub(this), this.negative = 1, oe) : this.length > ne.length ? this.clone().iadd(ne) : ne.clone().iadd(this);
      }, J.prototype.isub = function(ne) {
        if (ne.negative !== 0) {
          ne.negative = 0;
          var oe = this.iadd(ne);
          return ne.negative = 1, oe._normSign();
        } else if (this.negative !== 0)
          return this.negative = 0, this.iadd(ne), this.negative = 1, this._normSign();
        var ce = this.cmp(ne);
        if (ce === 0)
          return this.negative = 0, this.length = 1, this.words[0] = 0, this;
        var le, pe;
        ce > 0 ? (le = this, pe = ne) : (le = ne, pe = this);
        for (var ye = 0, Ce = 0; Ce < pe.length; Ce++)
          oe = (le.words[Ce] | 0) - (pe.words[Ce] | 0) + ye, ye = oe >> 26, this.words[Ce] = oe & 67108863;
        for (; ye !== 0 && Ce < le.length; Ce++)
          oe = (le.words[Ce] | 0) + ye, ye = oe >> 26, this.words[Ce] = oe & 67108863;
        if (ye === 0 && Ce < le.length && le !== this)
          for (; Ce < le.length; Ce++)
            this.words[Ce] = le.words[Ce];
        return this.length = Math.max(this.length, Ce), le !== this && (this.negative = 1), this.strip();
      }, J.prototype.sub = function(ne) {
        return this.clone().isub(ne);
      };
      function he(Ae, ne, oe) {
        oe.negative = ne.negative ^ Ae.negative;
        var ce = Ae.length + ne.length | 0;
        oe.length = ce, ce = ce - 1 | 0;
        var le = Ae.words[0] | 0, pe = ne.words[0] | 0, ye = le * pe, Ce = ye & 67108863, be = ye / 67108864 | 0;
        oe.words[0] = Ce;
        for (var ae = 1; ae < ce; ae++) {
          for (var ge = be >>> 26, Se = be & 67108863, Le = Math.min(ae, ne.length - 1), ze = Math.max(0, ae - Ae.length + 1); ze <= Le; ze++) {
            var Re = ae - ze | 0;
            le = Ae.words[Re] | 0, pe = ne.words[ze] | 0, ye = le * pe + Se, ge += ye / 67108864 | 0, Se = ye & 67108863;
          }
          oe.words[ae] = Se | 0, be = ge | 0;
        }
        return be !== 0 ? oe.words[ae] = be | 0 : oe.length--, oe.strip();
      }
      var me = function(ne, oe, ce) {
        var le = ne.words, pe = oe.words, ye = ce.words, Ce = 0, be, ae, ge, Se = le[0] | 0, Le = Se & 8191, ze = Se >>> 13, Re = le[1] | 0, We = Re & 8191, Be = Re >>> 13, Ue = le[2] | 0, Ge = Ue & 8191, je = Ue >>> 13, Oe = le[3] | 0, Ne = Oe & 8191, Ye = Oe >>> 13, Je = le[4] | 0, Xe = Je & 8191, st = Je >>> 13, ct = le[5] | 0, it = ct & 8191, ot = ct >>> 13, yt = le[6] | 0, dt = yt & 8191, mt = yt >>> 13, It = le[7] | 0, xt = It & 8191, Tt = It >>> 13, Yt = le[8] | 0, Ve = Yt & 8191, Pe = Yt >>> 13, $e = le[9] | 0, Ze = $e & 8191, at = $e >>> 13, wt = pe[0] | 0, ft = wt & 8191, Ct = wt >>> 13, Ut = pe[1] | 0, vt = Ut & 8191, Mt = Ut >>> 13, Xt = pe[2] | 0, St = Xt & 8191, Ot = Xt >>> 13, wn = pe[3] | 0, kt = wn & 8191, Bt = wn >>> 13, Tn = pe[4] | 0, Nt = Tn & 8191, Wt = Tn >>> 13, En = pe[5] | 0, Lt = En & 8191, Ht = En >>> 13, In = pe[6] | 0, Dt = In & 8191, Gt = In >>> 13, Ke = pe[7] | 0, Qe = Ke & 8191, et = Ke >>> 13, He = pe[8] | 0, nt = He & 8191, qe = He >>> 13, ht = pe[9] | 0, pt = ht & 8191, bt = ht >>> 13;
        ce.negative = ne.negative ^ oe.negative, ce.length = 19, be = Math.imul(Le, ft), ae = Math.imul(Le, Ct), ae = ae + Math.imul(ze, ft) | 0, ge = Math.imul(ze, Ct);
        var jt = (Ce + be | 0) + ((ae & 8191) << 13) | 0;
        Ce = (ge + (ae >>> 13) | 0) + (jt >>> 26) | 0, jt &= 67108863, be = Math.imul(We, ft), ae = Math.imul(We, Ct), ae = ae + Math.imul(Be, ft) | 0, ge = Math.imul(Be, Ct), be = be + Math.imul(Le, vt) | 0, ae = ae + Math.imul(Le, Mt) | 0, ae = ae + Math.imul(ze, vt) | 0, ge = ge + Math.imul(ze, Mt) | 0;
        var $t = (Ce + be | 0) + ((ae & 8191) << 13) | 0;
        Ce = (ge + (ae >>> 13) | 0) + ($t >>> 26) | 0, $t &= 67108863, be = Math.imul(Ge, ft), ae = Math.imul(Ge, Ct), ae = ae + Math.imul(je, ft) | 0, ge = Math.imul(je, Ct), be = be + Math.imul(We, vt) | 0, ae = ae + Math.imul(We, Mt) | 0, ae = ae + Math.imul(Be, vt) | 0, ge = ge + Math.imul(Be, Mt) | 0, be = be + Math.imul(Le, St) | 0, ae = ae + Math.imul(Le, Ot) | 0, ae = ae + Math.imul(ze, St) | 0, ge = ge + Math.imul(ze, Ot) | 0;
        var Jt = (Ce + be | 0) + ((ae & 8191) << 13) | 0;
        Ce = (ge + (ae >>> 13) | 0) + (Jt >>> 26) | 0, Jt &= 67108863, be = Math.imul(Ne, ft), ae = Math.imul(Ne, Ct), ae = ae + Math.imul(Ye, ft) | 0, ge = Math.imul(Ye, Ct), be = be + Math.imul(Ge, vt) | 0, ae = ae + Math.imul(Ge, Mt) | 0, ae = ae + Math.imul(je, vt) | 0, ge = ge + Math.imul(je, Mt) | 0, be = be + Math.imul(We, St) | 0, ae = ae + Math.imul(We, Ot) | 0, ae = ae + Math.imul(Be, St) | 0, ge = ge + Math.imul(Be, Ot) | 0, be = be + Math.imul(Le, kt) | 0, ae = ae + Math.imul(Le, Bt) | 0, ae = ae + Math.imul(ze, kt) | 0, ge = ge + Math.imul(ze, Bt) | 0;
        var zt = (Ce + be | 0) + ((ae & 8191) << 13) | 0;
        Ce = (ge + (ae >>> 13) | 0) + (zt >>> 26) | 0, zt &= 67108863, be = Math.imul(Xe, ft), ae = Math.imul(Xe, Ct), ae = ae + Math.imul(st, ft) | 0, ge = Math.imul(st, Ct), be = be + Math.imul(Ne, vt) | 0, ae = ae + Math.imul(Ne, Mt) | 0, ae = ae + Math.imul(Ye, vt) | 0, ge = ge + Math.imul(Ye, Mt) | 0, be = be + Math.imul(Ge, St) | 0, ae = ae + Math.imul(Ge, Ot) | 0, ae = ae + Math.imul(je, St) | 0, ge = ge + Math.imul(je, Ot) | 0, be = be + Math.imul(We, kt) | 0, ae = ae + Math.imul(We, Bt) | 0, ae = ae + Math.imul(Be, kt) | 0, ge = ge + Math.imul(Be, Bt) | 0, be = be + Math.imul(Le, Nt) | 0, ae = ae + Math.imul(Le, Wt) | 0, ae = ae + Math.imul(ze, Nt) | 0, ge = ge + Math.imul(ze, Wt) | 0;
        var Vt = (Ce + be | 0) + ((ae & 8191) << 13) | 0;
        Ce = (ge + (ae >>> 13) | 0) + (Vt >>> 26) | 0, Vt &= 67108863, be = Math.imul(it, ft), ae = Math.imul(it, Ct), ae = ae + Math.imul(ot, ft) | 0, ge = Math.imul(ot, Ct), be = be + Math.imul(Xe, vt) | 0, ae = ae + Math.imul(Xe, Mt) | 0, ae = ae + Math.imul(st, vt) | 0, ge = ge + Math.imul(st, Mt) | 0, be = be + Math.imul(Ne, St) | 0, ae = ae + Math.imul(Ne, Ot) | 0, ae = ae + Math.imul(Ye, St) | 0, ge = ge + Math.imul(Ye, Ot) | 0, be = be + Math.imul(Ge, kt) | 0, ae = ae + Math.imul(Ge, Bt) | 0, ae = ae + Math.imul(je, kt) | 0, ge = ge + Math.imul(je, Bt) | 0, be = be + Math.imul(We, Nt) | 0, ae = ae + Math.imul(We, Wt) | 0, ae = ae + Math.imul(Be, Nt) | 0, ge = ge + Math.imul(Be, Wt) | 0, be = be + Math.imul(Le, Lt) | 0, ae = ae + Math.imul(Le, Ht) | 0, ae = ae + Math.imul(ze, Lt) | 0, ge = ge + Math.imul(ze, Ht) | 0;
        var Kt = (Ce + be | 0) + ((ae & 8191) << 13) | 0;
        Ce = (ge + (ae >>> 13) | 0) + (Kt >>> 26) | 0, Kt &= 67108863, be = Math.imul(dt, ft), ae = Math.imul(dt, Ct), ae = ae + Math.imul(mt, ft) | 0, ge = Math.imul(mt, Ct), be = be + Math.imul(it, vt) | 0, ae = ae + Math.imul(it, Mt) | 0, ae = ae + Math.imul(ot, vt) | 0, ge = ge + Math.imul(ot, Mt) | 0, be = be + Math.imul(Xe, St) | 0, ae = ae + Math.imul(Xe, Ot) | 0, ae = ae + Math.imul(st, St) | 0, ge = ge + Math.imul(st, Ot) | 0, be = be + Math.imul(Ne, kt) | 0, ae = ae + Math.imul(Ne, Bt) | 0, ae = ae + Math.imul(Ye, kt) | 0, ge = ge + Math.imul(Ye, Bt) | 0, be = be + Math.imul(Ge, Nt) | 0, ae = ae + Math.imul(Ge, Wt) | 0, ae = ae + Math.imul(je, Nt) | 0, ge = ge + Math.imul(je, Wt) | 0, be = be + Math.imul(We, Lt) | 0, ae = ae + Math.imul(We, Ht) | 0, ae = ae + Math.imul(Be, Lt) | 0, ge = ge + Math.imul(Be, Ht) | 0, be = be + Math.imul(Le, Dt) | 0, ae = ae + Math.imul(Le, Gt) | 0, ae = ae + Math.imul(ze, Dt) | 0, ge = ge + Math.imul(ze, Gt) | 0;
        var pn = (Ce + be | 0) + ((ae & 8191) << 13) | 0;
        Ce = (ge + (ae >>> 13) | 0) + (pn >>> 26) | 0, pn &= 67108863, be = Math.imul(xt, ft), ae = Math.imul(xt, Ct), ae = ae + Math.imul(Tt, ft) | 0, ge = Math.imul(Tt, Ct), be = be + Math.imul(dt, vt) | 0, ae = ae + Math.imul(dt, Mt) | 0, ae = ae + Math.imul(mt, vt) | 0, ge = ge + Math.imul(mt, Mt) | 0, be = be + Math.imul(it, St) | 0, ae = ae + Math.imul(it, Ot) | 0, ae = ae + Math.imul(ot, St) | 0, ge = ge + Math.imul(ot, Ot) | 0, be = be + Math.imul(Xe, kt) | 0, ae = ae + Math.imul(Xe, Bt) | 0, ae = ae + Math.imul(st, kt) | 0, ge = ge + Math.imul(st, Bt) | 0, be = be + Math.imul(Ne, Nt) | 0, ae = ae + Math.imul(Ne, Wt) | 0, ae = ae + Math.imul(Ye, Nt) | 0, ge = ge + Math.imul(Ye, Wt) | 0, be = be + Math.imul(Ge, Lt) | 0, ae = ae + Math.imul(Ge, Ht) | 0, ae = ae + Math.imul(je, Lt) | 0, ge = ge + Math.imul(je, Ht) | 0, be = be + Math.imul(We, Dt) | 0, ae = ae + Math.imul(We, Gt) | 0, ae = ae + Math.imul(Be, Dt) | 0, ge = ge + Math.imul(Be, Gt) | 0, be = be + Math.imul(Le, Qe) | 0, ae = ae + Math.imul(Le, et) | 0, ae = ae + Math.imul(ze, Qe) | 0, ge = ge + Math.imul(ze, et) | 0;
        var An = (Ce + be | 0) + ((ae & 8191) << 13) | 0;
        Ce = (ge + (ae >>> 13) | 0) + (An >>> 26) | 0, An &= 67108863, be = Math.imul(Ve, ft), ae = Math.imul(Ve, Ct), ae = ae + Math.imul(Pe, ft) | 0, ge = Math.imul(Pe, Ct), be = be + Math.imul(xt, vt) | 0, ae = ae + Math.imul(xt, Mt) | 0, ae = ae + Math.imul(Tt, vt) | 0, ge = ge + Math.imul(Tt, Mt) | 0, be = be + Math.imul(dt, St) | 0, ae = ae + Math.imul(dt, Ot) | 0, ae = ae + Math.imul(mt, St) | 0, ge = ge + Math.imul(mt, Ot) | 0, be = be + Math.imul(it, kt) | 0, ae = ae + Math.imul(it, Bt) | 0, ae = ae + Math.imul(ot, kt) | 0, ge = ge + Math.imul(ot, Bt) | 0, be = be + Math.imul(Xe, Nt) | 0, ae = ae + Math.imul(Xe, Wt) | 0, ae = ae + Math.imul(st, Nt) | 0, ge = ge + Math.imul(st, Wt) | 0, be = be + Math.imul(Ne, Lt) | 0, ae = ae + Math.imul(Ne, Ht) | 0, ae = ae + Math.imul(Ye, Lt) | 0, ge = ge + Math.imul(Ye, Ht) | 0, be = be + Math.imul(Ge, Dt) | 0, ae = ae + Math.imul(Ge, Gt) | 0, ae = ae + Math.imul(je, Dt) | 0, ge = ge + Math.imul(je, Gt) | 0, be = be + Math.imul(We, Qe) | 0, ae = ae + Math.imul(We, et) | 0, ae = ae + Math.imul(Be, Qe) | 0, ge = ge + Math.imul(Be, et) | 0, be = be + Math.imul(Le, nt) | 0, ae = ae + Math.imul(Le, qe) | 0, ae = ae + Math.imul(ze, nt) | 0, ge = ge + Math.imul(ze, qe) | 0;
        var vn = (Ce + be | 0) + ((ae & 8191) << 13) | 0;
        Ce = (ge + (ae >>> 13) | 0) + (vn >>> 26) | 0, vn &= 67108863, be = Math.imul(Ze, ft), ae = Math.imul(Ze, Ct), ae = ae + Math.imul(at, ft) | 0, ge = Math.imul(at, Ct), be = be + Math.imul(Ve, vt) | 0, ae = ae + Math.imul(Ve, Mt) | 0, ae = ae + Math.imul(Pe, vt) | 0, ge = ge + Math.imul(Pe, Mt) | 0, be = be + Math.imul(xt, St) | 0, ae = ae + Math.imul(xt, Ot) | 0, ae = ae + Math.imul(Tt, St) | 0, ge = ge + Math.imul(Tt, Ot) | 0, be = be + Math.imul(dt, kt) | 0, ae = ae + Math.imul(dt, Bt) | 0, ae = ae + Math.imul(mt, kt) | 0, ge = ge + Math.imul(mt, Bt) | 0, be = be + Math.imul(it, Nt) | 0, ae = ae + Math.imul(it, Wt) | 0, ae = ae + Math.imul(ot, Nt) | 0, ge = ge + Math.imul(ot, Wt) | 0, be = be + Math.imul(Xe, Lt) | 0, ae = ae + Math.imul(Xe, Ht) | 0, ae = ae + Math.imul(st, Lt) | 0, ge = ge + Math.imul(st, Ht) | 0, be = be + Math.imul(Ne, Dt) | 0, ae = ae + Math.imul(Ne, Gt) | 0, ae = ae + Math.imul(Ye, Dt) | 0, ge = ge + Math.imul(Ye, Gt) | 0, be = be + Math.imul(Ge, Qe) | 0, ae = ae + Math.imul(Ge, et) | 0, ae = ae + Math.imul(je, Qe) | 0, ge = ge + Math.imul(je, et) | 0, be = be + Math.imul(We, nt) | 0, ae = ae + Math.imul(We, qe) | 0, ae = ae + Math.imul(Be, nt) | 0, ge = ge + Math.imul(Be, qe) | 0, be = be + Math.imul(Le, pt) | 0, ae = ae + Math.imul(Le, bt) | 0, ae = ae + Math.imul(ze, pt) | 0, ge = ge + Math.imul(ze, bt) | 0;
        var Cn = (Ce + be | 0) + ((ae & 8191) << 13) | 0;
        Ce = (ge + (ae >>> 13) | 0) + (Cn >>> 26) | 0, Cn &= 67108863, be = Math.imul(Ze, vt), ae = Math.imul(Ze, Mt), ae = ae + Math.imul(at, vt) | 0, ge = Math.imul(at, Mt), be = be + Math.imul(Ve, St) | 0, ae = ae + Math.imul(Ve, Ot) | 0, ae = ae + Math.imul(Pe, St) | 0, ge = ge + Math.imul(Pe, Ot) | 0, be = be + Math.imul(xt, kt) | 0, ae = ae + Math.imul(xt, Bt) | 0, ae = ae + Math.imul(Tt, kt) | 0, ge = ge + Math.imul(Tt, Bt) | 0, be = be + Math.imul(dt, Nt) | 0, ae = ae + Math.imul(dt, Wt) | 0, ae = ae + Math.imul(mt, Nt) | 0, ge = ge + Math.imul(mt, Wt) | 0, be = be + Math.imul(it, Lt) | 0, ae = ae + Math.imul(it, Ht) | 0, ae = ae + Math.imul(ot, Lt) | 0, ge = ge + Math.imul(ot, Ht) | 0, be = be + Math.imul(Xe, Dt) | 0, ae = ae + Math.imul(Xe, Gt) | 0, ae = ae + Math.imul(st, Dt) | 0, ge = ge + Math.imul(st, Gt) | 0, be = be + Math.imul(Ne, Qe) | 0, ae = ae + Math.imul(Ne, et) | 0, ae = ae + Math.imul(Ye, Qe) | 0, ge = ge + Math.imul(Ye, et) | 0, be = be + Math.imul(Ge, nt) | 0, ae = ae + Math.imul(Ge, qe) | 0, ae = ae + Math.imul(je, nt) | 0, ge = ge + Math.imul(je, qe) | 0, be = be + Math.imul(We, pt) | 0, ae = ae + Math.imul(We, bt) | 0, ae = ae + Math.imul(Be, pt) | 0, ge = ge + Math.imul(Be, bt) | 0;
        var yn = (Ce + be | 0) + ((ae & 8191) << 13) | 0;
        Ce = (ge + (ae >>> 13) | 0) + (yn >>> 26) | 0, yn &= 67108863, be = Math.imul(Ze, St), ae = Math.imul(Ze, Ot), ae = ae + Math.imul(at, St) | 0, ge = Math.imul(at, Ot), be = be + Math.imul(Ve, kt) | 0, ae = ae + Math.imul(Ve, Bt) | 0, ae = ae + Math.imul(Pe, kt) | 0, ge = ge + Math.imul(Pe, Bt) | 0, be = be + Math.imul(xt, Nt) | 0, ae = ae + Math.imul(xt, Wt) | 0, ae = ae + Math.imul(Tt, Nt) | 0, ge = ge + Math.imul(Tt, Wt) | 0, be = be + Math.imul(dt, Lt) | 0, ae = ae + Math.imul(dt, Ht) | 0, ae = ae + Math.imul(mt, Lt) | 0, ge = ge + Math.imul(mt, Ht) | 0, be = be + Math.imul(it, Dt) | 0, ae = ae + Math.imul(it, Gt) | 0, ae = ae + Math.imul(ot, Dt) | 0, ge = ge + Math.imul(ot, Gt) | 0, be = be + Math.imul(Xe, Qe) | 0, ae = ae + Math.imul(Xe, et) | 0, ae = ae + Math.imul(st, Qe) | 0, ge = ge + Math.imul(st, et) | 0, be = be + Math.imul(Ne, nt) | 0, ae = ae + Math.imul(Ne, qe) | 0, ae = ae + Math.imul(Ye, nt) | 0, ge = ge + Math.imul(Ye, qe) | 0, be = be + Math.imul(Ge, pt) | 0, ae = ae + Math.imul(Ge, bt) | 0, ae = ae + Math.imul(je, pt) | 0, ge = ge + Math.imul(je, bt) | 0;
        var dn = (Ce + be | 0) + ((ae & 8191) << 13) | 0;
        Ce = (ge + (ae >>> 13) | 0) + (dn >>> 26) | 0, dn &= 67108863, be = Math.imul(Ze, kt), ae = Math.imul(Ze, Bt), ae = ae + Math.imul(at, kt) | 0, ge = Math.imul(at, Bt), be = be + Math.imul(Ve, Nt) | 0, ae = ae + Math.imul(Ve, Wt) | 0, ae = ae + Math.imul(Pe, Nt) | 0, ge = ge + Math.imul(Pe, Wt) | 0, be = be + Math.imul(xt, Lt) | 0, ae = ae + Math.imul(xt, Ht) | 0, ae = ae + Math.imul(Tt, Lt) | 0, ge = ge + Math.imul(Tt, Ht) | 0, be = be + Math.imul(dt, Dt) | 0, ae = ae + Math.imul(dt, Gt) | 0, ae = ae + Math.imul(mt, Dt) | 0, ge = ge + Math.imul(mt, Gt) | 0, be = be + Math.imul(it, Qe) | 0, ae = ae + Math.imul(it, et) | 0, ae = ae + Math.imul(ot, Qe) | 0, ge = ge + Math.imul(ot, et) | 0, be = be + Math.imul(Xe, nt) | 0, ae = ae + Math.imul(Xe, qe) | 0, ae = ae + Math.imul(st, nt) | 0, ge = ge + Math.imul(st, qe) | 0, be = be + Math.imul(Ne, pt) | 0, ae = ae + Math.imul(Ne, bt) | 0, ae = ae + Math.imul(Ye, pt) | 0, ge = ge + Math.imul(Ye, bt) | 0;
        var xn = (Ce + be | 0) + ((ae & 8191) << 13) | 0;
        Ce = (ge + (ae >>> 13) | 0) + (xn >>> 26) | 0, xn &= 67108863, be = Math.imul(Ze, Nt), ae = Math.imul(Ze, Wt), ae = ae + Math.imul(at, Nt) | 0, ge = Math.imul(at, Wt), be = be + Math.imul(Ve, Lt) | 0, ae = ae + Math.imul(Ve, Ht) | 0, ae = ae + Math.imul(Pe, Lt) | 0, ge = ge + Math.imul(Pe, Ht) | 0, be = be + Math.imul(xt, Dt) | 0, ae = ae + Math.imul(xt, Gt) | 0, ae = ae + Math.imul(Tt, Dt) | 0, ge = ge + Math.imul(Tt, Gt) | 0, be = be + Math.imul(dt, Qe) | 0, ae = ae + Math.imul(dt, et) | 0, ae = ae + Math.imul(mt, Qe) | 0, ge = ge + Math.imul(mt, et) | 0, be = be + Math.imul(it, nt) | 0, ae = ae + Math.imul(it, qe) | 0, ae = ae + Math.imul(ot, nt) | 0, ge = ge + Math.imul(ot, qe) | 0, be = be + Math.imul(Xe, pt) | 0, ae = ae + Math.imul(Xe, bt) | 0, ae = ae + Math.imul(st, pt) | 0, ge = ge + Math.imul(st, bt) | 0;
        var ln = (Ce + be | 0) + ((ae & 8191) << 13) | 0;
        Ce = (ge + (ae >>> 13) | 0) + (ln >>> 26) | 0, ln &= 67108863, be = Math.imul(Ze, Lt), ae = Math.imul(Ze, Ht), ae = ae + Math.imul(at, Lt) | 0, ge = Math.imul(at, Ht), be = be + Math.imul(Ve, Dt) | 0, ae = ae + Math.imul(Ve, Gt) | 0, ae = ae + Math.imul(Pe, Dt) | 0, ge = ge + Math.imul(Pe, Gt) | 0, be = be + Math.imul(xt, Qe) | 0, ae = ae + Math.imul(xt, et) | 0, ae = ae + Math.imul(Tt, Qe) | 0, ge = ge + Math.imul(Tt, et) | 0, be = be + Math.imul(dt, nt) | 0, ae = ae + Math.imul(dt, qe) | 0, ae = ae + Math.imul(mt, nt) | 0, ge = ge + Math.imul(mt, qe) | 0, be = be + Math.imul(it, pt) | 0, ae = ae + Math.imul(it, bt) | 0, ae = ae + Math.imul(ot, pt) | 0, ge = ge + Math.imul(ot, bt) | 0;
        var mn = (Ce + be | 0) + ((ae & 8191) << 13) | 0;
        Ce = (ge + (ae >>> 13) | 0) + (mn >>> 26) | 0, mn &= 67108863, be = Math.imul(Ze, Dt), ae = Math.imul(Ze, Gt), ae = ae + Math.imul(at, Dt) | 0, ge = Math.imul(at, Gt), be = be + Math.imul(Ve, Qe) | 0, ae = ae + Math.imul(Ve, et) | 0, ae = ae + Math.imul(Pe, Qe) | 0, ge = ge + Math.imul(Pe, et) | 0, be = be + Math.imul(xt, nt) | 0, ae = ae + Math.imul(xt, qe) | 0, ae = ae + Math.imul(Tt, nt) | 0, ge = ge + Math.imul(Tt, qe) | 0, be = be + Math.imul(dt, pt) | 0, ae = ae + Math.imul(dt, bt) | 0, ae = ae + Math.imul(mt, pt) | 0, ge = ge + Math.imul(mt, bt) | 0;
        var gn = (Ce + be | 0) + ((ae & 8191) << 13) | 0;
        Ce = (ge + (ae >>> 13) | 0) + (gn >>> 26) | 0, gn &= 67108863, be = Math.imul(Ze, Qe), ae = Math.imul(Ze, et), ae = ae + Math.imul(at, Qe) | 0, ge = Math.imul(at, et), be = be + Math.imul(Ve, nt) | 0, ae = ae + Math.imul(Ve, qe) | 0, ae = ae + Math.imul(Pe, nt) | 0, ge = ge + Math.imul(Pe, qe) | 0, be = be + Math.imul(xt, pt) | 0, ae = ae + Math.imul(xt, bt) | 0, ae = ae + Math.imul(Tt, pt) | 0, ge = ge + Math.imul(Tt, bt) | 0;
        var cn = (Ce + be | 0) + ((ae & 8191) << 13) | 0;
        Ce = (ge + (ae >>> 13) | 0) + (cn >>> 26) | 0, cn &= 67108863, be = Math.imul(Ze, nt), ae = Math.imul(Ze, qe), ae = ae + Math.imul(at, nt) | 0, ge = Math.imul(at, qe), be = be + Math.imul(Ve, pt) | 0, ae = ae + Math.imul(Ve, bt) | 0, ae = ae + Math.imul(Pe, pt) | 0, ge = ge + Math.imul(Pe, bt) | 0;
        var Pt = (Ce + be | 0) + ((ae & 8191) << 13) | 0;
        Ce = (ge + (ae >>> 13) | 0) + (Pt >>> 26) | 0, Pt &= 67108863, be = Math.imul(Ze, pt), ae = Math.imul(Ze, bt), ae = ae + Math.imul(at, pt) | 0, ge = Math.imul(at, bt);
        var Rt = (Ce + be | 0) + ((ae & 8191) << 13) | 0;
        return Ce = (ge + (ae >>> 13) | 0) + (Rt >>> 26) | 0, Rt &= 67108863, ye[0] = jt, ye[1] = $t, ye[2] = Jt, ye[3] = zt, ye[4] = Vt, ye[5] = Kt, ye[6] = pn, ye[7] = An, ye[8] = vn, ye[9] = Cn, ye[10] = yn, ye[11] = dn, ye[12] = xn, ye[13] = ln, ye[14] = mn, ye[15] = gn, ye[16] = cn, ye[17] = Pt, ye[18] = Rt, Ce !== 0 && (ye[19] = Ce, ce.length++), ce;
      };
      Math.imul || (me = he);
      function xe(Ae, ne, oe) {
        oe.negative = ne.negative ^ Ae.negative, oe.length = Ae.length + ne.length;
        for (var ce = 0, le = 0, pe = 0; pe < oe.length - 1; pe++) {
          var ye = le;
          le = 0;
          for (var Ce = ce & 67108863, be = Math.min(pe, ne.length - 1), ae = Math.max(0, pe - Ae.length + 1); ae <= be; ae++) {
            var ge = pe - ae, Se = Ae.words[ge] | 0, Le = ne.words[ae] | 0, ze = Se * Le, Re = ze & 67108863;
            ye = ye + (ze / 67108864 | 0) | 0, Re = Re + Ce | 0, Ce = Re & 67108863, ye = ye + (Re >>> 26) | 0, le += ye >>> 26, ye &= 67108863;
          }
          oe.words[pe] = Ce, ce = ye, ye = le;
        }
        return ce !== 0 ? oe.words[pe] = ce : oe.length--, oe.strip();
      }
      function ve(Ae, ne, oe) {
        var ce = new Te();
        return ce.mulp(Ae, ne, oe);
      }
      J.prototype.mulTo = function(ne, oe) {
        var ce, le = this.length + ne.length;
        return this.length === 10 && ne.length === 10 ? ce = me(this, ne, oe) : le < 63 ? ce = he(this, ne, oe) : le < 1024 ? ce = xe(this, ne, oe) : ce = ve(this, ne, oe), ce;
      };
      function Te(Ae, ne) {
        this.x = Ae, this.y = ne;
      }
      Te.prototype.makeRBT = function(ne) {
        for (var oe = new Array(ne), ce = J.prototype._countBits(ne) - 1, le = 0; le < ne; le++)
          oe[le] = this.revBin(le, ce, ne);
        return oe;
      }, Te.prototype.revBin = function(ne, oe, ce) {
        if (ne === 0 || ne === ce - 1) return ne;
        for (var le = 0, pe = 0; pe < oe; pe++)
          le |= (ne & 1) << oe - pe - 1, ne >>= 1;
        return le;
      }, Te.prototype.permute = function(ne, oe, ce, le, pe, ye) {
        for (var Ce = 0; Ce < ye; Ce++)
          le[Ce] = oe[ne[Ce]], pe[Ce] = ce[ne[Ce]];
      }, Te.prototype.transform = function(ne, oe, ce, le, pe, ye) {
        this.permute(ye, ne, oe, ce, le, pe);
        for (var Ce = 1; Ce < pe; Ce <<= 1)
          for (var be = Ce << 1, ae = Math.cos(2 * Math.PI / be), ge = Math.sin(2 * Math.PI / be), Se = 0; Se < pe; Se += be)
            for (var Le = ae, ze = ge, Re = 0; Re < Ce; Re++) {
              var We = ce[Se + Re], Be = le[Se + Re], Ue = ce[Se + Re + Ce], Ge = le[Se + Re + Ce], je = Le * Ue - ze * Ge;
              Ge = Le * Ge + ze * Ue, Ue = je, ce[Se + Re] = We + Ue, le[Se + Re] = Be + Ge, ce[Se + Re + Ce] = We - Ue, le[Se + Re + Ce] = Be - Ge, Re !== be && (je = ae * Le - ge * ze, ze = ae * ze + ge * Le, Le = je);
            }
      }, Te.prototype.guessLen13b = function(ne, oe) {
        var ce = Math.max(oe, ne) | 1, le = ce & 1, pe = 0;
        for (ce = ce / 2 | 0; ce; ce = ce >>> 1)
          pe++;
        return 1 << pe + 1 + le;
      }, Te.prototype.conjugate = function(ne, oe, ce) {
        if (!(ce <= 1))
          for (var le = 0; le < ce / 2; le++) {
            var pe = ne[le];
            ne[le] = ne[ce - le - 1], ne[ce - le - 1] = pe, pe = oe[le], oe[le] = -oe[ce - le - 1], oe[ce - le - 1] = -pe;
          }
      }, Te.prototype.normalize13b = function(ne, oe) {
        for (var ce = 0, le = 0; le < oe / 2; le++) {
          var pe = Math.round(ne[2 * le + 1] / oe) * 8192 + Math.round(ne[2 * le] / oe) + ce;
          ne[le] = pe & 67108863, pe < 67108864 ? ce = 0 : ce = pe / 67108864 | 0;
        }
        return ne;
      }, Te.prototype.convert13b = function(ne, oe, ce, le) {
        for (var pe = 0, ye = 0; ye < oe; ye++)
          pe = pe + (ne[ye] | 0), ce[2 * ye] = pe & 8191, pe = pe >>> 13, ce[2 * ye + 1] = pe & 8191, pe = pe >>> 13;
        for (ye = 2 * oe; ye < le; ++ye)
          ce[ye] = 0;
        $(pe === 0), $((pe & -8192) === 0);
      }, Te.prototype.stub = function(ne) {
        for (var oe = new Array(ne), ce = 0; ce < ne; ce++)
          oe[ce] = 0;
        return oe;
      }, Te.prototype.mulp = function(ne, oe, ce) {
        var le = 2 * this.guessLen13b(ne.length, oe.length), pe = this.makeRBT(le), ye = this.stub(le), Ce = new Array(le), be = new Array(le), ae = new Array(le), ge = new Array(le), Se = new Array(le), Le = new Array(le), ze = ce.words;
        ze.length = le, this.convert13b(ne.words, ne.length, Ce, le), this.convert13b(oe.words, oe.length, ge, le), this.transform(Ce, ye, be, ae, le, pe), this.transform(ge, ye, Se, Le, le, pe);
        for (var Re = 0; Re < le; Re++) {
          var We = be[Re] * Se[Re] - ae[Re] * Le[Re];
          ae[Re] = be[Re] * Le[Re] + ae[Re] * Se[Re], be[Re] = We;
        }
        return this.conjugate(be, ae, le), this.transform(be, ae, ze, ye, le, pe), this.conjugate(ze, ye, le), this.normalize13b(ze, le), ce.negative = ne.negative ^ oe.negative, ce.length = ne.length + oe.length, ce.strip();
      }, J.prototype.mul = function(ne) {
        var oe = new J(null);
        return oe.words = new Array(this.length + ne.length), this.mulTo(ne, oe);
      }, J.prototype.mulf = function(ne) {
        var oe = new J(null);
        return oe.words = new Array(this.length + ne.length), ve(this, ne, oe);
      }, J.prototype.imul = function(ne) {
        return this.clone().mulTo(ne, this);
      }, J.prototype.imuln = function(ne) {
        $(typeof ne == "number"), $(ne < 67108864);
        for (var oe = 0, ce = 0; ce < this.length; ce++) {
          var le = (this.words[ce] | 0) * ne, pe = (le & 67108863) + (oe & 67108863);
          oe >>= 26, oe += le / 67108864 | 0, oe += pe >>> 26, this.words[ce] = pe & 67108863;
        }
        return oe !== 0 && (this.words[ce] = oe, this.length++), this;
      }, J.prototype.muln = function(ne) {
        return this.clone().imuln(ne);
      }, J.prototype.sqr = function() {
        return this.mul(this);
      }, J.prototype.isqr = function() {
        return this.imul(this.clone());
      }, J.prototype.pow = function(ne) {
        var oe = fe(ne);
        if (oe.length === 0) return new J(1);
        for (var ce = this, le = 0; le < oe.length && oe[le] === 0; le++, ce = ce.sqr())
          ;
        if (++le < oe.length)
          for (var pe = ce.sqr(); le < oe.length; le++, pe = pe.sqr())
            oe[le] !== 0 && (ce = ce.mul(pe));
        return ce;
      }, J.prototype.iushln = function(ne) {
        $(typeof ne == "number" && ne >= 0);
        var oe = ne % 26, ce = (ne - oe) / 26, le = 67108863 >>> 26 - oe << 26 - oe, pe;
        if (oe !== 0) {
          var ye = 0;
          for (pe = 0; pe < this.length; pe++) {
            var Ce = this.words[pe] & le, be = (this.words[pe] | 0) - Ce << oe;
            this.words[pe] = be | ye, ye = Ce >>> 26 - oe;
          }
          ye && (this.words[pe] = ye, this.length++);
        }
        if (ce !== 0) {
          for (pe = this.length - 1; pe >= 0; pe--)
            this.words[pe + ce] = this.words[pe];
          for (pe = 0; pe < ce; pe++)
            this.words[pe] = 0;
          this.length += ce;
        }
        return this.strip();
      }, J.prototype.ishln = function(ne) {
        return $(this.negative === 0), this.iushln(ne);
      }, J.prototype.iushrn = function(ne, oe, ce) {
        $(typeof ne == "number" && ne >= 0);
        var le;
        oe ? le = (oe - oe % 26) / 26 : le = 0;
        var pe = ne % 26, ye = Math.min((ne - pe) / 26, this.length), Ce = 67108863 ^ 67108863 >>> pe << pe, be = ce;
        if (le -= ye, le = Math.max(0, le), be) {
          for (var ae = 0; ae < ye; ae++)
            be.words[ae] = this.words[ae];
          be.length = ye;
        }
        if (ye !== 0) if (this.length > ye)
          for (this.length -= ye, ae = 0; ae < this.length; ae++)
            this.words[ae] = this.words[ae + ye];
        else
          this.words[0] = 0, this.length = 1;
        var ge = 0;
        for (ae = this.length - 1; ae >= 0 && (ge !== 0 || ae >= le); ae--) {
          var Se = this.words[ae] | 0;
          this.words[ae] = ge << 26 - pe | Se >>> pe, ge = Se & Ce;
        }
        return be && ge !== 0 && (be.words[be.length++] = ge), this.length === 0 && (this.words[0] = 0, this.length = 1), this.strip();
      }, J.prototype.ishrn = function(ne, oe, ce) {
        return $(this.negative === 0), this.iushrn(ne, oe, ce);
      }, J.prototype.shln = function(ne) {
        return this.clone().ishln(ne);
      }, J.prototype.ushln = function(ne) {
        return this.clone().iushln(ne);
      }, J.prototype.shrn = function(ne) {
        return this.clone().ishrn(ne);
      }, J.prototype.ushrn = function(ne) {
        return this.clone().iushrn(ne);
      }, J.prototype.testn = function(ne) {
        $(typeof ne == "number" && ne >= 0);
        var oe = ne % 26, ce = (ne - oe) / 26, le = 1 << oe;
        if (this.length <= ce) return !1;
        var pe = this.words[ce];
        return !!(pe & le);
      }, J.prototype.imaskn = function(ne) {
        $(typeof ne == "number" && ne >= 0);
        var oe = ne % 26, ce = (ne - oe) / 26;
        if ($(this.negative === 0, "imaskn works only with positive numbers"), this.length <= ce)
          return this;
        if (oe !== 0 && ce++, this.length = Math.min(ce, this.length), oe !== 0) {
          var le = 67108863 ^ 67108863 >>> oe << oe;
          this.words[this.length - 1] &= le;
        }
        return this.strip();
      }, J.prototype.maskn = function(ne) {
        return this.clone().imaskn(ne);
      }, J.prototype.iaddn = function(ne) {
        return $(typeof ne == "number"), $(ne < 67108864), ne < 0 ? this.isubn(-ne) : this.negative !== 0 ? this.length === 1 && (this.words[0] | 0) < ne ? (this.words[0] = ne - (this.words[0] | 0), this.negative = 0, this) : (this.negative = 0, this.isubn(ne), this.negative = 1, this) : this._iaddn(ne);
      }, J.prototype._iaddn = function(ne) {
        this.words[0] += ne;
        for (var oe = 0; oe < this.length && this.words[oe] >= 67108864; oe++)
          this.words[oe] -= 67108864, oe === this.length - 1 ? this.words[oe + 1] = 1 : this.words[oe + 1]++;
        return this.length = Math.max(this.length, oe + 1), this;
      }, J.prototype.isubn = function(ne) {
        if ($(typeof ne == "number"), $(ne < 67108864), ne < 0) return this.iaddn(-ne);
        if (this.negative !== 0)
          return this.negative = 0, this.iaddn(ne), this.negative = 1, this;
        if (this.words[0] -= ne, this.length === 1 && this.words[0] < 0)
          this.words[0] = -this.words[0], this.negative = 1;
        else
          for (var oe = 0; oe < this.length && this.words[oe] < 0; oe++)
            this.words[oe] += 67108864, this.words[oe + 1] -= 1;
        return this.strip();
      }, J.prototype.addn = function(ne) {
        return this.clone().iaddn(ne);
      }, J.prototype.subn = function(ne) {
        return this.clone().isubn(ne);
      }, J.prototype.iabs = function() {
        return this.negative = 0, this;
      }, J.prototype.abs = function() {
        return this.clone().iabs();
      }, J.prototype._ishlnsubmul = function(ne, oe, ce) {
        var le = ne.length + ce, pe;
        this._expand(le);
        var ye, Ce = 0;
        for (pe = 0; pe < ne.length; pe++) {
          ye = (this.words[pe + ce] | 0) + Ce;
          var be = (ne.words[pe] | 0) * oe;
          ye -= be & 67108863, Ce = (ye >> 26) - (be / 67108864 | 0), this.words[pe + ce] = ye & 67108863;
        }
        for (; pe < this.length - ce; pe++)
          ye = (this.words[pe + ce] | 0) + Ce, Ce = ye >> 26, this.words[pe + ce] = ye & 67108863;
        if (Ce === 0) return this.strip();
        for ($(Ce === -1), Ce = 0, pe = 0; pe < this.length; pe++)
          ye = -(this.words[pe] | 0) + Ce, Ce = ye >> 26, this.words[pe] = ye & 67108863;
        return this.negative = 1, this.strip();
      }, J.prototype._wordDiv = function(ne, oe) {
        var ce = this.length - ne.length, le = this.clone(), pe = ne, ye = pe.words[pe.length - 1] | 0, Ce = this._countBits(ye);
        ce = 26 - Ce, ce !== 0 && (pe = pe.ushln(ce), le.iushln(ce), ye = pe.words[pe.length - 1] | 0);
        var be = le.length - pe.length, ae;
        if (oe !== "mod") {
          ae = new J(null), ae.length = be + 1, ae.words = new Array(ae.length);
          for (var ge = 0; ge < ae.length; ge++)
            ae.words[ge] = 0;
        }
        var Se = le.clone()._ishlnsubmul(pe, 1, be);
        Se.negative === 0 && (le = Se, ae && (ae.words[be] = 1));
        for (var Le = be - 1; Le >= 0; Le--) {
          var ze = (le.words[pe.length + Le] | 0) * 67108864 + (le.words[pe.length + Le - 1] | 0);
          for (ze = Math.min(ze / ye | 0, 67108863), le._ishlnsubmul(pe, ze, Le); le.negative !== 0; )
            ze--, le.negative = 0, le._ishlnsubmul(pe, 1, Le), le.isZero() || (le.negative ^= 1);
          ae && (ae.words[Le] = ze);
        }
        return ae && ae.strip(), le.strip(), oe !== "div" && ce !== 0 && le.iushrn(ce), {
          div: ae || null,
          mod: le
        };
      }, J.prototype.divmod = function(ne, oe, ce) {
        if ($(!ne.isZero()), this.isZero())
          return {
            div: new J(0),
            mod: new J(0)
          };
        var le, pe, ye;
        return this.negative !== 0 && ne.negative === 0 ? (ye = this.neg().divmod(ne, oe), oe !== "mod" && (le = ye.div.neg()), oe !== "div" && (pe = ye.mod.neg(), ce && pe.negative !== 0 && pe.iadd(ne)), {
          div: le,
          mod: pe
        }) : this.negative === 0 && ne.negative !== 0 ? (ye = this.divmod(ne.neg(), oe), oe !== "mod" && (le = ye.div.neg()), {
          div: le,
          mod: ye.mod
        }) : this.negative & ne.negative ? (ye = this.neg().divmod(ne.neg(), oe), oe !== "div" && (pe = ye.mod.neg(), ce && pe.negative !== 0 && pe.isub(ne)), {
          div: ye.div,
          mod: pe
        }) : ne.length > this.length || this.cmp(ne) < 0 ? {
          div: new J(0),
          mod: this
        } : ne.length === 1 ? oe === "div" ? {
          div: this.divn(ne.words[0]),
          mod: null
        } : oe === "mod" ? {
          div: null,
          mod: new J(this.modn(ne.words[0]))
        } : {
          div: this.divn(ne.words[0]),
          mod: new J(this.modn(ne.words[0]))
        } : this._wordDiv(ne, oe);
      }, J.prototype.div = function(ne) {
        return this.divmod(ne, "div", !1).div;
      }, J.prototype.mod = function(ne) {
        return this.divmod(ne, "mod", !1).mod;
      }, J.prototype.umod = function(ne) {
        return this.divmod(ne, "mod", !0).mod;
      }, J.prototype.divRound = function(ne) {
        var oe = this.divmod(ne);
        if (oe.mod.isZero()) return oe.div;
        var ce = oe.div.negative !== 0 ? oe.mod.isub(ne) : oe.mod, le = ne.ushrn(1), pe = ne.andln(1), ye = ce.cmp(le);
        return ye < 0 || pe === 1 && ye === 0 ? oe.div : oe.div.negative !== 0 ? oe.div.isubn(1) : oe.div.iaddn(1);
      }, J.prototype.modn = function(ne) {
        $(ne <= 67108863);
        for (var oe = (1 << 26) % ne, ce = 0, le = this.length - 1; le >= 0; le--)
          ce = (oe * ce + (this.words[le] | 0)) % ne;
        return ce;
      }, J.prototype.idivn = function(ne) {
        $(ne <= 67108863);
        for (var oe = 0, ce = this.length - 1; ce >= 0; ce--) {
          var le = (this.words[ce] | 0) + oe * 67108864;
          this.words[ce] = le / ne | 0, oe = le % ne;
        }
        return this.strip();
      }, J.prototype.divn = function(ne) {
        return this.clone().idivn(ne);
      }, J.prototype.egcd = function(ne) {
        $(ne.negative === 0), $(!ne.isZero());
        var oe = this, ce = ne.clone();
        oe.negative !== 0 ? oe = oe.umod(ne) : oe = oe.clone();
        for (var le = new J(1), pe = new J(0), ye = new J(0), Ce = new J(1), be = 0; oe.isEven() && ce.isEven(); )
          oe.iushrn(1), ce.iushrn(1), ++be;
        for (var ae = ce.clone(), ge = oe.clone(); !oe.isZero(); ) {
          for (var Se = 0, Le = 1; !(oe.words[0] & Le) && Se < 26; ++Se, Le <<= 1) ;
          if (Se > 0)
            for (oe.iushrn(Se); Se-- > 0; )
              (le.isOdd() || pe.isOdd()) && (le.iadd(ae), pe.isub(ge)), le.iushrn(1), pe.iushrn(1);
          for (var ze = 0, Re = 1; !(ce.words[0] & Re) && ze < 26; ++ze, Re <<= 1) ;
          if (ze > 0)
            for (ce.iushrn(ze); ze-- > 0; )
              (ye.isOdd() || Ce.isOdd()) && (ye.iadd(ae), Ce.isub(ge)), ye.iushrn(1), Ce.iushrn(1);
          oe.cmp(ce) >= 0 ? (oe.isub(ce), le.isub(ye), pe.isub(Ce)) : (ce.isub(oe), ye.isub(le), Ce.isub(pe));
        }
        return {
          a: ye,
          b: Ce,
          gcd: ce.iushln(be)
        };
      }, J.prototype._invmp = function(ne) {
        $(ne.negative === 0), $(!ne.isZero());
        var oe = this, ce = ne.clone();
        oe.negative !== 0 ? oe = oe.umod(ne) : oe = oe.clone();
        for (var le = new J(1), pe = new J(0), ye = ce.clone(); oe.cmpn(1) > 0 && ce.cmpn(1) > 0; ) {
          for (var Ce = 0, be = 1; !(oe.words[0] & be) && Ce < 26; ++Ce, be <<= 1) ;
          if (Ce > 0)
            for (oe.iushrn(Ce); Ce-- > 0; )
              le.isOdd() && le.iadd(ye), le.iushrn(1);
          for (var ae = 0, ge = 1; !(ce.words[0] & ge) && ae < 26; ++ae, ge <<= 1) ;
          if (ae > 0)
            for (ce.iushrn(ae); ae-- > 0; )
              pe.isOdd() && pe.iadd(ye), pe.iushrn(1);
          oe.cmp(ce) >= 0 ? (oe.isub(ce), le.isub(pe)) : (ce.isub(oe), pe.isub(le));
        }
        var Se;
        return oe.cmpn(1) === 0 ? Se = le : Se = pe, Se.cmpn(0) < 0 && Se.iadd(ne), Se;
      }, J.prototype.gcd = function(ne) {
        if (this.isZero()) return ne.abs();
        if (ne.isZero()) return this.abs();
        var oe = this.clone(), ce = ne.clone();
        oe.negative = 0, ce.negative = 0;
        for (var le = 0; oe.isEven() && ce.isEven(); le++)
          oe.iushrn(1), ce.iushrn(1);
        do {
          for (; oe.isEven(); )
            oe.iushrn(1);
          for (; ce.isEven(); )
            ce.iushrn(1);
          var pe = oe.cmp(ce);
          if (pe < 0) {
            var ye = oe;
            oe = ce, ce = ye;
          } else if (pe === 0 || ce.cmpn(1) === 0)
            break;
          oe.isub(ce);
        } while (!0);
        return ce.iushln(le);
      }, J.prototype.invm = function(ne) {
        return this.egcd(ne).a.umod(ne);
      }, J.prototype.isEven = function() {
        return (this.words[0] & 1) === 0;
      }, J.prototype.isOdd = function() {
        return (this.words[0] & 1) === 1;
      }, J.prototype.andln = function(ne) {
        return this.words[0] & ne;
      }, J.prototype.bincn = function(ne) {
        $(typeof ne == "number");
        var oe = ne % 26, ce = (ne - oe) / 26, le = 1 << oe;
        if (this.length <= ce)
          return this._expand(ce + 1), this.words[ce] |= le, this;
        for (var pe = le, ye = ce; pe !== 0 && ye < this.length; ye++) {
          var Ce = this.words[ye] | 0;
          Ce += pe, pe = Ce >>> 26, Ce &= 67108863, this.words[ye] = Ce;
        }
        return pe !== 0 && (this.words[ye] = pe, this.length++), this;
      }, J.prototype.isZero = function() {
        return this.length === 1 && this.words[0] === 0;
      }, J.prototype.cmpn = function(ne) {
        var oe = ne < 0;
        if (this.negative !== 0 && !oe) return -1;
        if (this.negative === 0 && oe) return 1;
        this.strip();
        var ce;
        if (this.length > 1)
          ce = 1;
        else {
          oe && (ne = -ne), $(ne <= 67108863, "Number is too big");
          var le = this.words[0] | 0;
          ce = le === ne ? 0 : le < ne ? -1 : 1;
        }
        return this.negative !== 0 ? -ce | 0 : ce;
      }, J.prototype.cmp = function(ne) {
        if (this.negative !== 0 && ne.negative === 0) return -1;
        if (this.negative === 0 && ne.negative !== 0) return 1;
        var oe = this.ucmp(ne);
        return this.negative !== 0 ? -oe | 0 : oe;
      }, J.prototype.ucmp = function(ne) {
        if (this.length > ne.length) return 1;
        if (this.length < ne.length) return -1;
        for (var oe = 0, ce = this.length - 1; ce >= 0; ce--) {
          var le = this.words[ce] | 0, pe = ne.words[ce] | 0;
          if (le !== pe) {
            le < pe ? oe = -1 : le > pe && (oe = 1);
            break;
          }
        }
        return oe;
      }, J.prototype.gtn = function(ne) {
        return this.cmpn(ne) === 1;
      }, J.prototype.gt = function(ne) {
        return this.cmp(ne) === 1;
      }, J.prototype.gten = function(ne) {
        return this.cmpn(ne) >= 0;
      }, J.prototype.gte = function(ne) {
        return this.cmp(ne) >= 0;
      }, J.prototype.ltn = function(ne) {
        return this.cmpn(ne) === -1;
      }, J.prototype.lt = function(ne) {
        return this.cmp(ne) === -1;
      }, J.prototype.lten = function(ne) {
        return this.cmpn(ne) <= 0;
      }, J.prototype.lte = function(ne) {
        return this.cmp(ne) <= 0;
      }, J.prototype.eqn = function(ne) {
        return this.cmpn(ne) === 0;
      }, J.prototype.eq = function(ne) {
        return this.cmp(ne) === 0;
      }, J.red = function(ne) {
        return new De(ne);
      }, J.prototype.toRed = function(ne) {
        return $(!this.red, "Already a number in reduction context"), $(this.negative === 0, "red works only with positives"), ne.convertTo(this)._forceRed(ne);
      }, J.prototype.fromRed = function() {
        return $(this.red, "fromRed works only with numbers in reduction context"), this.red.convertFrom(this);
      }, J.prototype._forceRed = function(ne) {
        return this.red = ne, this;
      }, J.prototype.forceRed = function(ne) {
        return $(!this.red, "Already a number in reduction context"), this._forceRed(ne);
      }, J.prototype.redAdd = function(ne) {
        return $(this.red, "redAdd works only with red numbers"), this.red.add(this, ne);
      }, J.prototype.redIAdd = function(ne) {
        return $(this.red, "redIAdd works only with red numbers"), this.red.iadd(this, ne);
      }, J.prototype.redSub = function(ne) {
        return $(this.red, "redSub works only with red numbers"), this.red.sub(this, ne);
      }, J.prototype.redISub = function(ne) {
        return $(this.red, "redISub works only with red numbers"), this.red.isub(this, ne);
      }, J.prototype.redShl = function(ne) {
        return $(this.red, "redShl works only with red numbers"), this.red.shl(this, ne);
      }, J.prototype.redMul = function(ne) {
        return $(this.red, "redMul works only with red numbers"), this.red._verify2(this, ne), this.red.mul(this, ne);
      }, J.prototype.redIMul = function(ne) {
        return $(this.red, "redMul works only with red numbers"), this.red._verify2(this, ne), this.red.imul(this, ne);
      }, J.prototype.redSqr = function() {
        return $(this.red, "redSqr works only with red numbers"), this.red._verify1(this), this.red.sqr(this);
      }, J.prototype.redISqr = function() {
        return $(this.red, "redISqr works only with red numbers"), this.red._verify1(this), this.red.isqr(this);
      }, J.prototype.redSqrt = function() {
        return $(this.red, "redSqrt works only with red numbers"), this.red._verify1(this), this.red.sqrt(this);
      }, J.prototype.redInvm = function() {
        return $(this.red, "redInvm works only with red numbers"), this.red._verify1(this), this.red.invm(this);
      }, J.prototype.redNeg = function() {
        return $(this.red, "redNeg works only with red numbers"), this.red._verify1(this), this.red.neg(this);
      }, J.prototype.redPow = function(ne) {
        return $(this.red && !ne.red, "redPow(normalNum)"), this.red._verify1(this), this.red.pow(this, ne);
      };
      var we = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
      };
      function Ee(Ae, ne) {
        this.name = Ae, this.p = new J(ne, 16), this.n = this.p.bitLength(), this.k = new J(1).iushln(this.n).isub(this.p), this.tmp = this._tmp();
      }
      Ee.prototype._tmp = function() {
        var ne = new J(null);
        return ne.words = new Array(Math.ceil(this.n / 13)), ne;
      }, Ee.prototype.ireduce = function(ne) {
        var oe = ne, ce;
        do
          this.split(oe, this.tmp), oe = this.imulK(oe), oe = oe.iadd(this.tmp), ce = oe.bitLength();
        while (ce > this.n);
        var le = ce < this.n ? -1 : oe.ucmp(this.p);
        return le === 0 ? (oe.words[0] = 0, oe.length = 1) : le > 0 ? oe.isub(this.p) : oe.strip !== void 0 ? oe.strip() : oe._strip(), oe;
      }, Ee.prototype.split = function(ne, oe) {
        ne.iushrn(this.n, 0, oe);
      }, Ee.prototype.imulK = function(ne) {
        return ne.imul(this.k);
      };
      function Me() {
        Ee.call(
          this,
          "k256",
          "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f"
        );
      }
      V(Me, Ee), Me.prototype.split = function(ne, oe) {
        for (var ce = 4194303, le = Math.min(ne.length, 9), pe = 0; pe < le; pe++)
          oe.words[pe] = ne.words[pe];
        if (oe.length = le, ne.length <= 9) {
          ne.words[0] = 0, ne.length = 1;
          return;
        }
        var ye = ne.words[9];
        for (oe.words[oe.length++] = ye & ce, pe = 10; pe < ne.length; pe++) {
          var Ce = ne.words[pe] | 0;
          ne.words[pe - 10] = (Ce & ce) << 4 | ye >>> 22, ye = Ce;
        }
        ye >>>= 22, ne.words[pe - 10] = ye, ye === 0 && ne.length > 10 ? ne.length -= 10 : ne.length -= 9;
      }, Me.prototype.imulK = function(ne) {
        ne.words[ne.length] = 0, ne.words[ne.length + 1] = 0, ne.length += 2;
        for (var oe = 0, ce = 0; ce < ne.length; ce++) {
          var le = ne.words[ce] | 0;
          oe += le * 977, ne.words[ce] = oe & 67108863, oe = le * 64 + (oe / 67108864 | 0);
        }
        return ne.words[ne.length - 1] === 0 && (ne.length--, ne.words[ne.length - 1] === 0 && ne.length--), ne;
      };
      function Ie() {
        Ee.call(
          this,
          "p224",
          "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001"
        );
      }
      V(Ie, Ee);
      function ke() {
        Ee.call(
          this,
          "p192",
          "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff"
        );
      }
      V(ke, Ee);
      function _e() {
        Ee.call(
          this,
          "25519",
          "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed"
        );
      }
      V(_e, Ee), _e.prototype.imulK = function(ne) {
        for (var oe = 0, ce = 0; ce < ne.length; ce++) {
          var le = (ne.words[ce] | 0) * 19 + oe, pe = le & 67108863;
          le >>>= 26, ne.words[ce] = pe, oe = le;
        }
        return oe !== 0 && (ne.words[ne.length++] = oe), ne;
      }, J._prime = function(ne) {
        if (we[ne]) return we[ne];
        var oe;
        if (ne === "k256")
          oe = new Me();
        else if (ne === "p224")
          oe = new Ie();
        else if (ne === "p192")
          oe = new ke();
        else if (ne === "p25519")
          oe = new _e();
        else
          throw new Error("Unknown prime " + ne);
        return we[ne] = oe, oe;
      };
      function De(Ae) {
        if (typeof Ae == "string") {
          var ne = J._prime(Ae);
          this.m = ne.p, this.prime = ne;
        } else
          $(Ae.gtn(1), "modulus must be greater than 1"), this.m = Ae, this.prime = null;
      }
      De.prototype._verify1 = function(ne) {
        $(ne.negative === 0, "red works only with positives"), $(ne.red, "red works only with red numbers");
      }, De.prototype._verify2 = function(ne, oe) {
        $((ne.negative | oe.negative) === 0, "red works only with positives"), $(
          ne.red && ne.red === oe.red,
          "red works only with red numbers"
        );
      }, De.prototype.imod = function(ne) {
        return this.prime ? this.prime.ireduce(ne)._forceRed(this) : ne.umod(this.m)._forceRed(this);
      }, De.prototype.neg = function(ne) {
        return ne.isZero() ? ne.clone() : this.m.sub(ne)._forceRed(this);
      }, De.prototype.add = function(ne, oe) {
        this._verify2(ne, oe);
        var ce = ne.add(oe);
        return ce.cmp(this.m) >= 0 && ce.isub(this.m), ce._forceRed(this);
      }, De.prototype.iadd = function(ne, oe) {
        this._verify2(ne, oe);
        var ce = ne.iadd(oe);
        return ce.cmp(this.m) >= 0 && ce.isub(this.m), ce;
      }, De.prototype.sub = function(ne, oe) {
        this._verify2(ne, oe);
        var ce = ne.sub(oe);
        return ce.cmpn(0) < 0 && ce.iadd(this.m), ce._forceRed(this);
      }, De.prototype.isub = function(ne, oe) {
        this._verify2(ne, oe);
        var ce = ne.isub(oe);
        return ce.cmpn(0) < 0 && ce.iadd(this.m), ce;
      }, De.prototype.shl = function(ne, oe) {
        return this._verify1(ne), this.imod(ne.ushln(oe));
      }, De.prototype.imul = function(ne, oe) {
        return this._verify2(ne, oe), this.imod(ne.imul(oe));
      }, De.prototype.mul = function(ne, oe) {
        return this._verify2(ne, oe), this.imod(ne.mul(oe));
      }, De.prototype.isqr = function(ne) {
        return this.imul(ne, ne.clone());
      }, De.prototype.sqr = function(ne) {
        return this.mul(ne, ne);
      }, De.prototype.sqrt = function(ne) {
        if (ne.isZero()) return ne.clone();
        var oe = this.m.andln(3);
        if ($(oe % 2 === 1), oe === 3) {
          var ce = this.m.add(new J(1)).iushrn(2);
          return this.pow(ne, ce);
        }
        for (var le = this.m.subn(1), pe = 0; !le.isZero() && le.andln(1) === 0; )
          pe++, le.iushrn(1);
        $(!le.isZero());
        var ye = new J(1).toRed(this), Ce = ye.redNeg(), be = this.m.subn(1).iushrn(1), ae = this.m.bitLength();
        for (ae = new J(2 * ae * ae).toRed(this); this.pow(ae, be).cmp(Ce) !== 0; )
          ae.redIAdd(Ce);
        for (var ge = this.pow(ae, le), Se = this.pow(ne, le.addn(1).iushrn(1)), Le = this.pow(ne, le), ze = pe; Le.cmp(ye) !== 0; ) {
          for (var Re = Le, We = 0; Re.cmp(ye) !== 0; We++)
            Re = Re.redSqr();
          $(We < ze);
          var Be = this.pow(ge, new J(1).iushln(ze - We - 1));
          Se = Se.redMul(Be), ge = Be.redSqr(), Le = Le.redMul(ge), ze = We;
        }
        return Se;
      }, De.prototype.invm = function(ne) {
        var oe = ne._invmp(this.m);
        return oe.negative !== 0 ? (oe.negative = 0, this.imod(oe).redNeg()) : this.imod(oe);
      }, De.prototype.pow = function(ne, oe) {
        if (oe.isZero()) return new J(1).toRed(this);
        if (oe.cmpn(1) === 0) return ne.clone();
        var ce = 4, le = new Array(1 << ce);
        le[0] = new J(1).toRed(this), le[1] = ne;
        for (var pe = 2; pe < le.length; pe++)
          le[pe] = this.mul(le[pe - 1], ne);
        var ye = le[0], Ce = 0, be = 0, ae = oe.bitLength() % 26;
        for (ae === 0 && (ae = 26), pe = oe.length - 1; pe >= 0; pe--) {
          for (var ge = oe.words[pe], Se = ae - 1; Se >= 0; Se--) {
            var Le = ge >> Se & 1;
            if (ye !== le[0] && (ye = this.sqr(ye)), Le === 0 && Ce === 0) {
              be = 0;
              continue;
            }
            Ce <<= 1, Ce |= Le, be++, !(be !== ce && (pe !== 0 || Se !== 0)) && (ye = this.mul(ye, le[Ce]), be = 0, Ce = 0);
          }
          ae = 26;
        }
        return ye;
      }, De.prototype.convertTo = function(ne) {
        var oe = ne.umod(this.m);
        return oe === ne ? oe.clone() : oe;
      }, De.prototype.convertFrom = function(ne) {
        var oe = ne.clone();
        return oe.red = null, oe;
      }, J.mont = function(ne) {
        return new Fe(ne);
      };
      function Fe(Ae) {
        De.call(this, Ae), this.shift = this.m.bitLength(), this.shift % 26 !== 0 && (this.shift += 26 - this.shift % 26), this.r = new J(1).iushln(this.shift), this.r2 = this.imod(this.r.sqr()), this.rinv = this.r._invmp(this.m), this.minv = this.rinv.mul(this.r).isubn(1).div(this.m), this.minv = this.minv.umod(this.r), this.minv = this.r.sub(this.minv);
      }
      V(Fe, De), Fe.prototype.convertTo = function(ne) {
        return this.imod(ne.ushln(this.shift));
      }, Fe.prototype.convertFrom = function(ne) {
        var oe = this.imod(ne.mul(this.rinv));
        return oe.red = null, oe;
      }, Fe.prototype.imul = function(ne, oe) {
        if (ne.isZero() || oe.isZero())
          return ne.words[0] = 0, ne.length = 1, ne;
        var ce = ne.imul(oe), le = ce.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m), pe = ce.isub(le).iushrn(this.shift), ye = pe;
        return pe.cmp(this.m) >= 0 ? ye = pe.isub(this.m) : pe.cmpn(0) < 0 && (ye = pe.iadd(this.m)), ye._forceRed(this);
      }, Fe.prototype.mul = function(ne, oe) {
        if (ne.isZero() || oe.isZero()) return new J(0)._forceRed(this);
        var ce = ne.mul(oe), le = ce.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m), pe = ce.isub(le).iushrn(this.shift), ye = pe;
        return pe.cmp(this.m) >= 0 ? ye = pe.isub(this.m) : pe.cmpn(0) < 0 && (ye = pe.iadd(this.m)), ye._forceRed(this);
      }, Fe.prototype.invm = function(ne) {
        var oe = this.imod(ne._invmp(this.m).mul(this.r2));
        return oe._forceRed(this);
      };
    })(C, commonjsGlobal$1);
  }(bn$1)), bn$1.exports;
}
var browser$4, hasRequiredBrowser$2;
function requireBrowser$2() {
  if (hasRequiredBrowser$2) return browser$4;
  hasRequiredBrowser$2 = 1;
  var C = requireElliptic(), e = requireBn$1();
  browser$4 = function(ee) {
    return new $(ee);
  };
  var T = {
    secp256k1: {
      name: "secp256k1",
      byteLength: 32
    },
    secp224r1: {
      name: "p224",
      byteLength: 28
    },
    prime256v1: {
      name: "p256",
      byteLength: 32
    },
    prime192v1: {
      name: "p192",
      byteLength: 24
    },
    ed25519: {
      name: "ed25519",
      byteLength: 32
    },
    secp384r1: {
      name: "p384",
      byteLength: 48
    },
    secp521r1: {
      name: "p521",
      byteLength: 66
    }
  };
  T.p224 = T.secp224r1, T.p256 = T.secp256r1 = T.prime256v1, T.p192 = T.secp192r1 = T.prime192v1, T.p384 = T.secp384r1, T.p521 = T.secp521r1;
  function $(J) {
    this.curveType = T[J], this.curveType || (this.curveType = {
      name: J
    }), this.curve = new C.ec(this.curveType.name), this.keys = void 0;
  }
  $.prototype.generateKeys = function(J, ee) {
    return this.keys = this.curve.genKeyPair(), this.getPublicKey(J, ee);
  }, $.prototype.computeSecret = function(J, ee, te) {
    ee = ee || "utf8", dist$2.Buffer.isBuffer(J) || (J = new dist$2.Buffer(J, ee));
    var re = this.curve.keyFromPublic(J).getPublic(), ie = re.mul(this.keys.getPrivate()).getX();
    return V(ie, te, this.curveType.byteLength);
  }, $.prototype.getPublicKey = function(J, ee) {
    var te = this.keys.getPublic(ee === "compressed", !0);
    return ee === "hybrid" && (te[te.length - 1] % 2 ? te[0] = 7 : te[0] = 6), V(te, J);
  }, $.prototype.getPrivateKey = function(J) {
    return V(this.keys.getPrivate(), J);
  }, $.prototype.setPublicKey = function(J, ee) {
    return ee = ee || "utf8", dist$2.Buffer.isBuffer(J) || (J = new dist$2.Buffer(J, ee)), this.keys._importPublic(J), this;
  }, $.prototype.setPrivateKey = function(J, ee) {
    ee = ee || "utf8", dist$2.Buffer.isBuffer(J) || (J = new dist$2.Buffer(J, ee));
    var te = new e(J);
    return te = te.toString(16), this.keys = this.curve.genKeyPair(), this.keys._importPrivate(te), this;
  };
  function V(J, ee, te) {
    Array.isArray(J) || (J = J.toArray());
    var re = new dist$2.Buffer(J);
    if (te && re.length < te) {
      var ie = new dist$2.Buffer(te - re.length);
      ie.fill(0), re = dist$2.Buffer.concat([ie, re]);
    }
    return ee ? re.toString(ee) : re;
  }
  return browser$4;
}
var browser$3 = {}, mgf, hasRequiredMgf;
function requireMgf() {
  if (hasRequiredMgf) return mgf;
  hasRequiredMgf = 1;
  var C = requireBrowser$9(), e = safeBufferExports.Buffer;
  mgf = function($, V) {
    for (var J = e.alloc(0), ee = 0, te; J.length < V; )
      te = T(ee++), J = e.concat([J, C("sha1").update($).update(te).digest()]);
    return J.slice(0, V);
  };
  function T($) {
    var V = e.allocUnsafe(4);
    return V.writeUInt32BE($, 0), V;
  }
  return mgf;
}
var xor, hasRequiredXor;
function requireXor() {
  return hasRequiredXor || (hasRequiredXor = 1, xor = function(e, T) {
    for (var $ = e.length, V = -1; ++V < $; )
      e[V] ^= T[V];
    return e;
  }), xor;
}
var bn = { exports: {} };
bn.exports;
var hasRequiredBn;
function requireBn() {
  return hasRequiredBn || (hasRequiredBn = 1, function(C) {
    (function(e, T) {
      function $(Ae, ne) {
        if (!Ae) throw new Error(ne || "Assertion failed");
      }
      function V(Ae, ne) {
        Ae.super_ = ne;
        var oe = function() {
        };
        oe.prototype = ne.prototype, Ae.prototype = new oe(), Ae.prototype.constructor = Ae;
      }
      function J(Ae, ne, oe) {
        if (J.isBN(Ae))
          return Ae;
        this.negative = 0, this.words = null, this.length = 0, this.red = null, Ae !== null && ((ne === "le" || ne === "be") && (oe = ne, ne = 10), this._init(Ae || 0, ne || 10, oe || "be"));
      }
      typeof e == "object" ? e.exports = J : T.BN = J, J.BN = J, J.wordSize = 26;
      var ee;
      try {
        typeof window < "u" && typeof window.Buffer < "u" ? ee = window.Buffer : ee = bufferPolyfill.Buffer;
      } catch {
      }
      J.isBN = function(ne) {
        return ne instanceof J ? !0 : ne !== null && typeof ne == "object" && ne.constructor.wordSize === J.wordSize && Array.isArray(ne.words);
      }, J.max = function(ne, oe) {
        return ne.cmp(oe) > 0 ? ne : oe;
      }, J.min = function(ne, oe) {
        return ne.cmp(oe) < 0 ? ne : oe;
      }, J.prototype._init = function(ne, oe, ce) {
        if (typeof ne == "number")
          return this._initNumber(ne, oe, ce);
        if (typeof ne == "object")
          return this._initArray(ne, oe, ce);
        oe === "hex" && (oe = 16), $(oe === (oe | 0) && oe >= 2 && oe <= 36), ne = ne.toString().replace(/\s+/g, "");
        var le = 0;
        ne[0] === "-" && (le++, this.negative = 1), le < ne.length && (oe === 16 ? this._parseHex(ne, le, ce) : (this._parseBase(ne, oe, le), ce === "le" && this._initArray(this.toArray(), oe, ce)));
      }, J.prototype._initNumber = function(ne, oe, ce) {
        ne < 0 && (this.negative = 1, ne = -ne), ne < 67108864 ? (this.words = [ne & 67108863], this.length = 1) : ne < 4503599627370496 ? (this.words = [
          ne & 67108863,
          ne / 67108864 & 67108863
        ], this.length = 2) : ($(ne < 9007199254740992), this.words = [
          ne & 67108863,
          ne / 67108864 & 67108863,
          1
        ], this.length = 3), ce === "le" && this._initArray(this.toArray(), oe, ce);
      }, J.prototype._initArray = function(ne, oe, ce) {
        if ($(typeof ne.length == "number"), ne.length <= 0)
          return this.words = [0], this.length = 1, this;
        this.length = Math.ceil(ne.length / 3), this.words = new Array(this.length);
        for (var le = 0; le < this.length; le++)
          this.words[le] = 0;
        var pe, ye, Ce = 0;
        if (ce === "be")
          for (le = ne.length - 1, pe = 0; le >= 0; le -= 3)
            ye = ne[le] | ne[le - 1] << 8 | ne[le - 2] << 16, this.words[pe] |= ye << Ce & 67108863, this.words[pe + 1] = ye >>> 26 - Ce & 67108863, Ce += 24, Ce >= 26 && (Ce -= 26, pe++);
        else if (ce === "le")
          for (le = 0, pe = 0; le < ne.length; le += 3)
            ye = ne[le] | ne[le + 1] << 8 | ne[le + 2] << 16, this.words[pe] |= ye << Ce & 67108863, this.words[pe + 1] = ye >>> 26 - Ce & 67108863, Ce += 24, Ce >= 26 && (Ce -= 26, pe++);
        return this.strip();
      };
      function te(Ae, ne) {
        var oe = Ae.charCodeAt(ne);
        return oe >= 65 && oe <= 70 ? oe - 55 : oe >= 97 && oe <= 102 ? oe - 87 : oe - 48 & 15;
      }
      function re(Ae, ne, oe) {
        var ce = te(Ae, oe);
        return oe - 1 >= ne && (ce |= te(Ae, oe - 1) << 4), ce;
      }
      J.prototype._parseHex = function(ne, oe, ce) {
        this.length = Math.ceil((ne.length - oe) / 6), this.words = new Array(this.length);
        for (var le = 0; le < this.length; le++)
          this.words[le] = 0;
        var pe = 0, ye = 0, Ce;
        if (ce === "be")
          for (le = ne.length - 1; le >= oe; le -= 2)
            Ce = re(ne, oe, le) << pe, this.words[ye] |= Ce & 67108863, pe >= 18 ? (pe -= 18, ye += 1, this.words[ye] |= Ce >>> 26) : pe += 8;
        else {
          var be = ne.length - oe;
          for (le = be % 2 === 0 ? oe + 1 : oe; le < ne.length; le += 2)
            Ce = re(ne, oe, le) << pe, this.words[ye] |= Ce & 67108863, pe >= 18 ? (pe -= 18, ye += 1, this.words[ye] |= Ce >>> 26) : pe += 8;
        }
        this.strip();
      };
      function ie(Ae, ne, oe, ce) {
        for (var le = 0, pe = Math.min(Ae.length, oe), ye = ne; ye < pe; ye++) {
          var Ce = Ae.charCodeAt(ye) - 48;
          le *= ce, Ce >= 49 ? le += Ce - 49 + 10 : Ce >= 17 ? le += Ce - 17 + 10 : le += Ce;
        }
        return le;
      }
      J.prototype._parseBase = function(ne, oe, ce) {
        this.words = [0], this.length = 1;
        for (var le = 0, pe = 1; pe <= 67108863; pe *= oe)
          le++;
        le--, pe = pe / oe | 0;
        for (var ye = ne.length - ce, Ce = ye % le, be = Math.min(ye, ye - Ce) + ce, ae = 0, ge = ce; ge < be; ge += le)
          ae = ie(ne, ge, ge + le, oe), this.imuln(pe), this.words[0] + ae < 67108864 ? this.words[0] += ae : this._iaddn(ae);
        if (Ce !== 0) {
          var Se = 1;
          for (ae = ie(ne, ge, ne.length, oe), ge = 0; ge < Ce; ge++)
            Se *= oe;
          this.imuln(Se), this.words[0] + ae < 67108864 ? this.words[0] += ae : this._iaddn(ae);
        }
        this.strip();
      }, J.prototype.copy = function(ne) {
        ne.words = new Array(this.length);
        for (var oe = 0; oe < this.length; oe++)
          ne.words[oe] = this.words[oe];
        ne.length = this.length, ne.negative = this.negative, ne.red = this.red;
      }, J.prototype.clone = function() {
        var ne = new J(null);
        return this.copy(ne), ne;
      }, J.prototype._expand = function(ne) {
        for (; this.length < ne; )
          this.words[this.length++] = 0;
        return this;
      }, J.prototype.strip = function() {
        for (; this.length > 1 && this.words[this.length - 1] === 0; )
          this.length--;
        return this._normSign();
      }, J.prototype._normSign = function() {
        return this.length === 1 && this.words[0] === 0 && (this.negative = 0), this;
      }, J.prototype.inspect = function() {
        return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
      };
      var se = [
        "",
        "0",
        "00",
        "000",
        "0000",
        "00000",
        "000000",
        "0000000",
        "00000000",
        "000000000",
        "0000000000",
        "00000000000",
        "000000000000",
        "0000000000000",
        "00000000000000",
        "000000000000000",
        "0000000000000000",
        "00000000000000000",
        "000000000000000000",
        "0000000000000000000",
        "00000000000000000000",
        "000000000000000000000",
        "0000000000000000000000",
        "00000000000000000000000",
        "000000000000000000000000",
        "0000000000000000000000000"
      ], de = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
      ], ue = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        1e7,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64e6,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        243e5,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
      ];
      J.prototype.toString = function(ne, oe) {
        ne = ne || 10, oe = oe | 0 || 1;
        var ce;
        if (ne === 16 || ne === "hex") {
          ce = "";
          for (var le = 0, pe = 0, ye = 0; ye < this.length; ye++) {
            var Ce = this.words[ye], be = ((Ce << le | pe) & 16777215).toString(16);
            pe = Ce >>> 24 - le & 16777215, le += 2, le >= 26 && (le -= 26, ye--), pe !== 0 || ye !== this.length - 1 ? ce = se[6 - be.length] + be + ce : ce = be + ce;
          }
          for (pe !== 0 && (ce = pe.toString(16) + ce); ce.length % oe !== 0; )
            ce = "0" + ce;
          return this.negative !== 0 && (ce = "-" + ce), ce;
        }
        if (ne === (ne | 0) && ne >= 2 && ne <= 36) {
          var ae = de[ne], ge = ue[ne];
          ce = "";
          var Se = this.clone();
          for (Se.negative = 0; !Se.isZero(); ) {
            var Le = Se.modn(ge).toString(ne);
            Se = Se.idivn(ge), Se.isZero() ? ce = Le + ce : ce = se[ae - Le.length] + Le + ce;
          }
          for (this.isZero() && (ce = "0" + ce); ce.length % oe !== 0; )
            ce = "0" + ce;
          return this.negative !== 0 && (ce = "-" + ce), ce;
        }
        $(!1, "Base should be between 2 and 36");
      }, J.prototype.toNumber = function() {
        var ne = this.words[0];
        return this.length === 2 ? ne += this.words[1] * 67108864 : this.length === 3 && this.words[2] === 1 ? ne += 4503599627370496 + this.words[1] * 67108864 : this.length > 2 && $(!1, "Number can only safely store up to 53 bits"), this.negative !== 0 ? -ne : ne;
      }, J.prototype.toJSON = function() {
        return this.toString(16);
      }, J.prototype.toBuffer = function(ne, oe) {
        return $(typeof ee < "u"), this.toArrayLike(ee, ne, oe);
      }, J.prototype.toArray = function(ne, oe) {
        return this.toArrayLike(Array, ne, oe);
      }, J.prototype.toArrayLike = function(ne, oe, ce) {
        var le = this.byteLength(), pe = ce || Math.max(1, le);
        $(le <= pe, "byte array longer than desired length"), $(pe > 0, "Requested array length <= 0"), this.strip();
        var ye = oe === "le", Ce = new ne(pe), be, ae, ge = this.clone();
        if (ye) {
          for (ae = 0; !ge.isZero(); ae++)
            be = ge.andln(255), ge.iushrn(8), Ce[ae] = be;
          for (; ae < pe; ae++)
            Ce[ae] = 0;
        } else {
          for (ae = 0; ae < pe - le; ae++)
            Ce[ae] = 0;
          for (ae = 0; !ge.isZero(); ae++)
            be = ge.andln(255), ge.iushrn(8), Ce[pe - ae - 1] = be;
        }
        return Ce;
      }, Math.clz32 ? J.prototype._countBits = function(ne) {
        return 32 - Math.clz32(ne);
      } : J.prototype._countBits = function(ne) {
        var oe = ne, ce = 0;
        return oe >= 4096 && (ce += 13, oe >>>= 13), oe >= 64 && (ce += 7, oe >>>= 7), oe >= 8 && (ce += 4, oe >>>= 4), oe >= 2 && (ce += 2, oe >>>= 2), ce + oe;
      }, J.prototype._zeroBits = function(ne) {
        if (ne === 0) return 26;
        var oe = ne, ce = 0;
        return oe & 8191 || (ce += 13, oe >>>= 13), oe & 127 || (ce += 7, oe >>>= 7), oe & 15 || (ce += 4, oe >>>= 4), oe & 3 || (ce += 2, oe >>>= 2), oe & 1 || ce++, ce;
      }, J.prototype.bitLength = function() {
        var ne = this.words[this.length - 1], oe = this._countBits(ne);
        return (this.length - 1) * 26 + oe;
      };
      function fe(Ae) {
        for (var ne = new Array(Ae.bitLength()), oe = 0; oe < ne.length; oe++) {
          var ce = oe / 26 | 0, le = oe % 26;
          ne[oe] = (Ae.words[ce] & 1 << le) >>> le;
        }
        return ne;
      }
      J.prototype.zeroBits = function() {
        if (this.isZero()) return 0;
        for (var ne = 0, oe = 0; oe < this.length; oe++) {
          var ce = this._zeroBits(this.words[oe]);
          if (ne += ce, ce !== 26) break;
        }
        return ne;
      }, J.prototype.byteLength = function() {
        return Math.ceil(this.bitLength() / 8);
      }, J.prototype.toTwos = function(ne) {
        return this.negative !== 0 ? this.abs().inotn(ne).iaddn(1) : this.clone();
      }, J.prototype.fromTwos = function(ne) {
        return this.testn(ne - 1) ? this.notn(ne).iaddn(1).ineg() : this.clone();
      }, J.prototype.isNeg = function() {
        return this.negative !== 0;
      }, J.prototype.neg = function() {
        return this.clone().ineg();
      }, J.prototype.ineg = function() {
        return this.isZero() || (this.negative ^= 1), this;
      }, J.prototype.iuor = function(ne) {
        for (; this.length < ne.length; )
          this.words[this.length++] = 0;
        for (var oe = 0; oe < ne.length; oe++)
          this.words[oe] = this.words[oe] | ne.words[oe];
        return this.strip();
      }, J.prototype.ior = function(ne) {
        return $((this.negative | ne.negative) === 0), this.iuor(ne);
      }, J.prototype.or = function(ne) {
        return this.length > ne.length ? this.clone().ior(ne) : ne.clone().ior(this);
      }, J.prototype.uor = function(ne) {
        return this.length > ne.length ? this.clone().iuor(ne) : ne.clone().iuor(this);
      }, J.prototype.iuand = function(ne) {
        var oe;
        this.length > ne.length ? oe = ne : oe = this;
        for (var ce = 0; ce < oe.length; ce++)
          this.words[ce] = this.words[ce] & ne.words[ce];
        return this.length = oe.length, this.strip();
      }, J.prototype.iand = function(ne) {
        return $((this.negative | ne.negative) === 0), this.iuand(ne);
      }, J.prototype.and = function(ne) {
        return this.length > ne.length ? this.clone().iand(ne) : ne.clone().iand(this);
      }, J.prototype.uand = function(ne) {
        return this.length > ne.length ? this.clone().iuand(ne) : ne.clone().iuand(this);
      }, J.prototype.iuxor = function(ne) {
        var oe, ce;
        this.length > ne.length ? (oe = this, ce = ne) : (oe = ne, ce = this);
        for (var le = 0; le < ce.length; le++)
          this.words[le] = oe.words[le] ^ ce.words[le];
        if (this !== oe)
          for (; le < oe.length; le++)
            this.words[le] = oe.words[le];
        return this.length = oe.length, this.strip();
      }, J.prototype.ixor = function(ne) {
        return $((this.negative | ne.negative) === 0), this.iuxor(ne);
      }, J.prototype.xor = function(ne) {
        return this.length > ne.length ? this.clone().ixor(ne) : ne.clone().ixor(this);
      }, J.prototype.uxor = function(ne) {
        return this.length > ne.length ? this.clone().iuxor(ne) : ne.clone().iuxor(this);
      }, J.prototype.inotn = function(ne) {
        $(typeof ne == "number" && ne >= 0);
        var oe = Math.ceil(ne / 26) | 0, ce = ne % 26;
        this._expand(oe), ce > 0 && oe--;
        for (var le = 0; le < oe; le++)
          this.words[le] = ~this.words[le] & 67108863;
        return ce > 0 && (this.words[le] = ~this.words[le] & 67108863 >> 26 - ce), this.strip();
      }, J.prototype.notn = function(ne) {
        return this.clone().inotn(ne);
      }, J.prototype.setn = function(ne, oe) {
        $(typeof ne == "number" && ne >= 0);
        var ce = ne / 26 | 0, le = ne % 26;
        return this._expand(ce + 1), oe ? this.words[ce] = this.words[ce] | 1 << le : this.words[ce] = this.words[ce] & ~(1 << le), this.strip();
      }, J.prototype.iadd = function(ne) {
        var oe;
        if (this.negative !== 0 && ne.negative === 0)
          return this.negative = 0, oe = this.isub(ne), this.negative ^= 1, this._normSign();
        if (this.negative === 0 && ne.negative !== 0)
          return ne.negative = 0, oe = this.isub(ne), ne.negative = 1, oe._normSign();
        var ce, le;
        this.length > ne.length ? (ce = this, le = ne) : (ce = ne, le = this);
        for (var pe = 0, ye = 0; ye < le.length; ye++)
          oe = (ce.words[ye] | 0) + (le.words[ye] | 0) + pe, this.words[ye] = oe & 67108863, pe = oe >>> 26;
        for (; pe !== 0 && ye < ce.length; ye++)
          oe = (ce.words[ye] | 0) + pe, this.words[ye] = oe & 67108863, pe = oe >>> 26;
        if (this.length = ce.length, pe !== 0)
          this.words[this.length] = pe, this.length++;
        else if (ce !== this)
          for (; ye < ce.length; ye++)
            this.words[ye] = ce.words[ye];
        return this;
      }, J.prototype.add = function(ne) {
        var oe;
        return ne.negative !== 0 && this.negative === 0 ? (ne.negative = 0, oe = this.sub(ne), ne.negative ^= 1, oe) : ne.negative === 0 && this.negative !== 0 ? (this.negative = 0, oe = ne.sub(this), this.negative = 1, oe) : this.length > ne.length ? this.clone().iadd(ne) : ne.clone().iadd(this);
      }, J.prototype.isub = function(ne) {
        if (ne.negative !== 0) {
          ne.negative = 0;
          var oe = this.iadd(ne);
          return ne.negative = 1, oe._normSign();
        } else if (this.negative !== 0)
          return this.negative = 0, this.iadd(ne), this.negative = 1, this._normSign();
        var ce = this.cmp(ne);
        if (ce === 0)
          return this.negative = 0, this.length = 1, this.words[0] = 0, this;
        var le, pe;
        ce > 0 ? (le = this, pe = ne) : (le = ne, pe = this);
        for (var ye = 0, Ce = 0; Ce < pe.length; Ce++)
          oe = (le.words[Ce] | 0) - (pe.words[Ce] | 0) + ye, ye = oe >> 26, this.words[Ce] = oe & 67108863;
        for (; ye !== 0 && Ce < le.length; Ce++)
          oe = (le.words[Ce] | 0) + ye, ye = oe >> 26, this.words[Ce] = oe & 67108863;
        if (ye === 0 && Ce < le.length && le !== this)
          for (; Ce < le.length; Ce++)
            this.words[Ce] = le.words[Ce];
        return this.length = Math.max(this.length, Ce), le !== this && (this.negative = 1), this.strip();
      }, J.prototype.sub = function(ne) {
        return this.clone().isub(ne);
      };
      function he(Ae, ne, oe) {
        oe.negative = ne.negative ^ Ae.negative;
        var ce = Ae.length + ne.length | 0;
        oe.length = ce, ce = ce - 1 | 0;
        var le = Ae.words[0] | 0, pe = ne.words[0] | 0, ye = le * pe, Ce = ye & 67108863, be = ye / 67108864 | 0;
        oe.words[0] = Ce;
        for (var ae = 1; ae < ce; ae++) {
          for (var ge = be >>> 26, Se = be & 67108863, Le = Math.min(ae, ne.length - 1), ze = Math.max(0, ae - Ae.length + 1); ze <= Le; ze++) {
            var Re = ae - ze | 0;
            le = Ae.words[Re] | 0, pe = ne.words[ze] | 0, ye = le * pe + Se, ge += ye / 67108864 | 0, Se = ye & 67108863;
          }
          oe.words[ae] = Se | 0, be = ge | 0;
        }
        return be !== 0 ? oe.words[ae] = be | 0 : oe.length--, oe.strip();
      }
      var me = function(ne, oe, ce) {
        var le = ne.words, pe = oe.words, ye = ce.words, Ce = 0, be, ae, ge, Se = le[0] | 0, Le = Se & 8191, ze = Se >>> 13, Re = le[1] | 0, We = Re & 8191, Be = Re >>> 13, Ue = le[2] | 0, Ge = Ue & 8191, je = Ue >>> 13, Oe = le[3] | 0, Ne = Oe & 8191, Ye = Oe >>> 13, Je = le[4] | 0, Xe = Je & 8191, st = Je >>> 13, ct = le[5] | 0, it = ct & 8191, ot = ct >>> 13, yt = le[6] | 0, dt = yt & 8191, mt = yt >>> 13, It = le[7] | 0, xt = It & 8191, Tt = It >>> 13, Yt = le[8] | 0, Ve = Yt & 8191, Pe = Yt >>> 13, $e = le[9] | 0, Ze = $e & 8191, at = $e >>> 13, wt = pe[0] | 0, ft = wt & 8191, Ct = wt >>> 13, Ut = pe[1] | 0, vt = Ut & 8191, Mt = Ut >>> 13, Xt = pe[2] | 0, St = Xt & 8191, Ot = Xt >>> 13, wn = pe[3] | 0, kt = wn & 8191, Bt = wn >>> 13, Tn = pe[4] | 0, Nt = Tn & 8191, Wt = Tn >>> 13, En = pe[5] | 0, Lt = En & 8191, Ht = En >>> 13, In = pe[6] | 0, Dt = In & 8191, Gt = In >>> 13, Ke = pe[7] | 0, Qe = Ke & 8191, et = Ke >>> 13, He = pe[8] | 0, nt = He & 8191, qe = He >>> 13, ht = pe[9] | 0, pt = ht & 8191, bt = ht >>> 13;
        ce.negative = ne.negative ^ oe.negative, ce.length = 19, be = Math.imul(Le, ft), ae = Math.imul(Le, Ct), ae = ae + Math.imul(ze, ft) | 0, ge = Math.imul(ze, Ct);
        var jt = (Ce + be | 0) + ((ae & 8191) << 13) | 0;
        Ce = (ge + (ae >>> 13) | 0) + (jt >>> 26) | 0, jt &= 67108863, be = Math.imul(We, ft), ae = Math.imul(We, Ct), ae = ae + Math.imul(Be, ft) | 0, ge = Math.imul(Be, Ct), be = be + Math.imul(Le, vt) | 0, ae = ae + Math.imul(Le, Mt) | 0, ae = ae + Math.imul(ze, vt) | 0, ge = ge + Math.imul(ze, Mt) | 0;
        var $t = (Ce + be | 0) + ((ae & 8191) << 13) | 0;
        Ce = (ge + (ae >>> 13) | 0) + ($t >>> 26) | 0, $t &= 67108863, be = Math.imul(Ge, ft), ae = Math.imul(Ge, Ct), ae = ae + Math.imul(je, ft) | 0, ge = Math.imul(je, Ct), be = be + Math.imul(We, vt) | 0, ae = ae + Math.imul(We, Mt) | 0, ae = ae + Math.imul(Be, vt) | 0, ge = ge + Math.imul(Be, Mt) | 0, be = be + Math.imul(Le, St) | 0, ae = ae + Math.imul(Le, Ot) | 0, ae = ae + Math.imul(ze, St) | 0, ge = ge + Math.imul(ze, Ot) | 0;
        var Jt = (Ce + be | 0) + ((ae & 8191) << 13) | 0;
        Ce = (ge + (ae >>> 13) | 0) + (Jt >>> 26) | 0, Jt &= 67108863, be = Math.imul(Ne, ft), ae = Math.imul(Ne, Ct), ae = ae + Math.imul(Ye, ft) | 0, ge = Math.imul(Ye, Ct), be = be + Math.imul(Ge, vt) | 0, ae = ae + Math.imul(Ge, Mt) | 0, ae = ae + Math.imul(je, vt) | 0, ge = ge + Math.imul(je, Mt) | 0, be = be + Math.imul(We, St) | 0, ae = ae + Math.imul(We, Ot) | 0, ae = ae + Math.imul(Be, St) | 0, ge = ge + Math.imul(Be, Ot) | 0, be = be + Math.imul(Le, kt) | 0, ae = ae + Math.imul(Le, Bt) | 0, ae = ae + Math.imul(ze, kt) | 0, ge = ge + Math.imul(ze, Bt) | 0;
        var zt = (Ce + be | 0) + ((ae & 8191) << 13) | 0;
        Ce = (ge + (ae >>> 13) | 0) + (zt >>> 26) | 0, zt &= 67108863, be = Math.imul(Xe, ft), ae = Math.imul(Xe, Ct), ae = ae + Math.imul(st, ft) | 0, ge = Math.imul(st, Ct), be = be + Math.imul(Ne, vt) | 0, ae = ae + Math.imul(Ne, Mt) | 0, ae = ae + Math.imul(Ye, vt) | 0, ge = ge + Math.imul(Ye, Mt) | 0, be = be + Math.imul(Ge, St) | 0, ae = ae + Math.imul(Ge, Ot) | 0, ae = ae + Math.imul(je, St) | 0, ge = ge + Math.imul(je, Ot) | 0, be = be + Math.imul(We, kt) | 0, ae = ae + Math.imul(We, Bt) | 0, ae = ae + Math.imul(Be, kt) | 0, ge = ge + Math.imul(Be, Bt) | 0, be = be + Math.imul(Le, Nt) | 0, ae = ae + Math.imul(Le, Wt) | 0, ae = ae + Math.imul(ze, Nt) | 0, ge = ge + Math.imul(ze, Wt) | 0;
        var Vt = (Ce + be | 0) + ((ae & 8191) << 13) | 0;
        Ce = (ge + (ae >>> 13) | 0) + (Vt >>> 26) | 0, Vt &= 67108863, be = Math.imul(it, ft), ae = Math.imul(it, Ct), ae = ae + Math.imul(ot, ft) | 0, ge = Math.imul(ot, Ct), be = be + Math.imul(Xe, vt) | 0, ae = ae + Math.imul(Xe, Mt) | 0, ae = ae + Math.imul(st, vt) | 0, ge = ge + Math.imul(st, Mt) | 0, be = be + Math.imul(Ne, St) | 0, ae = ae + Math.imul(Ne, Ot) | 0, ae = ae + Math.imul(Ye, St) | 0, ge = ge + Math.imul(Ye, Ot) | 0, be = be + Math.imul(Ge, kt) | 0, ae = ae + Math.imul(Ge, Bt) | 0, ae = ae + Math.imul(je, kt) | 0, ge = ge + Math.imul(je, Bt) | 0, be = be + Math.imul(We, Nt) | 0, ae = ae + Math.imul(We, Wt) | 0, ae = ae + Math.imul(Be, Nt) | 0, ge = ge + Math.imul(Be, Wt) | 0, be = be + Math.imul(Le, Lt) | 0, ae = ae + Math.imul(Le, Ht) | 0, ae = ae + Math.imul(ze, Lt) | 0, ge = ge + Math.imul(ze, Ht) | 0;
        var Kt = (Ce + be | 0) + ((ae & 8191) << 13) | 0;
        Ce = (ge + (ae >>> 13) | 0) + (Kt >>> 26) | 0, Kt &= 67108863, be = Math.imul(dt, ft), ae = Math.imul(dt, Ct), ae = ae + Math.imul(mt, ft) | 0, ge = Math.imul(mt, Ct), be = be + Math.imul(it, vt) | 0, ae = ae + Math.imul(it, Mt) | 0, ae = ae + Math.imul(ot, vt) | 0, ge = ge + Math.imul(ot, Mt) | 0, be = be + Math.imul(Xe, St) | 0, ae = ae + Math.imul(Xe, Ot) | 0, ae = ae + Math.imul(st, St) | 0, ge = ge + Math.imul(st, Ot) | 0, be = be + Math.imul(Ne, kt) | 0, ae = ae + Math.imul(Ne, Bt) | 0, ae = ae + Math.imul(Ye, kt) | 0, ge = ge + Math.imul(Ye, Bt) | 0, be = be + Math.imul(Ge, Nt) | 0, ae = ae + Math.imul(Ge, Wt) | 0, ae = ae + Math.imul(je, Nt) | 0, ge = ge + Math.imul(je, Wt) | 0, be = be + Math.imul(We, Lt) | 0, ae = ae + Math.imul(We, Ht) | 0, ae = ae + Math.imul(Be, Lt) | 0, ge = ge + Math.imul(Be, Ht) | 0, be = be + Math.imul(Le, Dt) | 0, ae = ae + Math.imul(Le, Gt) | 0, ae = ae + Math.imul(ze, Dt) | 0, ge = ge + Math.imul(ze, Gt) | 0;
        var pn = (Ce + be | 0) + ((ae & 8191) << 13) | 0;
        Ce = (ge + (ae >>> 13) | 0) + (pn >>> 26) | 0, pn &= 67108863, be = Math.imul(xt, ft), ae = Math.imul(xt, Ct), ae = ae + Math.imul(Tt, ft) | 0, ge = Math.imul(Tt, Ct), be = be + Math.imul(dt, vt) | 0, ae = ae + Math.imul(dt, Mt) | 0, ae = ae + Math.imul(mt, vt) | 0, ge = ge + Math.imul(mt, Mt) | 0, be = be + Math.imul(it, St) | 0, ae = ae + Math.imul(it, Ot) | 0, ae = ae + Math.imul(ot, St) | 0, ge = ge + Math.imul(ot, Ot) | 0, be = be + Math.imul(Xe, kt) | 0, ae = ae + Math.imul(Xe, Bt) | 0, ae = ae + Math.imul(st, kt) | 0, ge = ge + Math.imul(st, Bt) | 0, be = be + Math.imul(Ne, Nt) | 0, ae = ae + Math.imul(Ne, Wt) | 0, ae = ae + Math.imul(Ye, Nt) | 0, ge = ge + Math.imul(Ye, Wt) | 0, be = be + Math.imul(Ge, Lt) | 0, ae = ae + Math.imul(Ge, Ht) | 0, ae = ae + Math.imul(je, Lt) | 0, ge = ge + Math.imul(je, Ht) | 0, be = be + Math.imul(We, Dt) | 0, ae = ae + Math.imul(We, Gt) | 0, ae = ae + Math.imul(Be, Dt) | 0, ge = ge + Math.imul(Be, Gt) | 0, be = be + Math.imul(Le, Qe) | 0, ae = ae + Math.imul(Le, et) | 0, ae = ae + Math.imul(ze, Qe) | 0, ge = ge + Math.imul(ze, et) | 0;
        var An = (Ce + be | 0) + ((ae & 8191) << 13) | 0;
        Ce = (ge + (ae >>> 13) | 0) + (An >>> 26) | 0, An &= 67108863, be = Math.imul(Ve, ft), ae = Math.imul(Ve, Ct), ae = ae + Math.imul(Pe, ft) | 0, ge = Math.imul(Pe, Ct), be = be + Math.imul(xt, vt) | 0, ae = ae + Math.imul(xt, Mt) | 0, ae = ae + Math.imul(Tt, vt) | 0, ge = ge + Math.imul(Tt, Mt) | 0, be = be + Math.imul(dt, St) | 0, ae = ae + Math.imul(dt, Ot) | 0, ae = ae + Math.imul(mt, St) | 0, ge = ge + Math.imul(mt, Ot) | 0, be = be + Math.imul(it, kt) | 0, ae = ae + Math.imul(it, Bt) | 0, ae = ae + Math.imul(ot, kt) | 0, ge = ge + Math.imul(ot, Bt) | 0, be = be + Math.imul(Xe, Nt) | 0, ae = ae + Math.imul(Xe, Wt) | 0, ae = ae + Math.imul(st, Nt) | 0, ge = ge + Math.imul(st, Wt) | 0, be = be + Math.imul(Ne, Lt) | 0, ae = ae + Math.imul(Ne, Ht) | 0, ae = ae + Math.imul(Ye, Lt) | 0, ge = ge + Math.imul(Ye, Ht) | 0, be = be + Math.imul(Ge, Dt) | 0, ae = ae + Math.imul(Ge, Gt) | 0, ae = ae + Math.imul(je, Dt) | 0, ge = ge + Math.imul(je, Gt) | 0, be = be + Math.imul(We, Qe) | 0, ae = ae + Math.imul(We, et) | 0, ae = ae + Math.imul(Be, Qe) | 0, ge = ge + Math.imul(Be, et) | 0, be = be + Math.imul(Le, nt) | 0, ae = ae + Math.imul(Le, qe) | 0, ae = ae + Math.imul(ze, nt) | 0, ge = ge + Math.imul(ze, qe) | 0;
        var vn = (Ce + be | 0) + ((ae & 8191) << 13) | 0;
        Ce = (ge + (ae >>> 13) | 0) + (vn >>> 26) | 0, vn &= 67108863, be = Math.imul(Ze, ft), ae = Math.imul(Ze, Ct), ae = ae + Math.imul(at, ft) | 0, ge = Math.imul(at, Ct), be = be + Math.imul(Ve, vt) | 0, ae = ae + Math.imul(Ve, Mt) | 0, ae = ae + Math.imul(Pe, vt) | 0, ge = ge + Math.imul(Pe, Mt) | 0, be = be + Math.imul(xt, St) | 0, ae = ae + Math.imul(xt, Ot) | 0, ae = ae + Math.imul(Tt, St) | 0, ge = ge + Math.imul(Tt, Ot) | 0, be = be + Math.imul(dt, kt) | 0, ae = ae + Math.imul(dt, Bt) | 0, ae = ae + Math.imul(mt, kt) | 0, ge = ge + Math.imul(mt, Bt) | 0, be = be + Math.imul(it, Nt) | 0, ae = ae + Math.imul(it, Wt) | 0, ae = ae + Math.imul(ot, Nt) | 0, ge = ge + Math.imul(ot, Wt) | 0, be = be + Math.imul(Xe, Lt) | 0, ae = ae + Math.imul(Xe, Ht) | 0, ae = ae + Math.imul(st, Lt) | 0, ge = ge + Math.imul(st, Ht) | 0, be = be + Math.imul(Ne, Dt) | 0, ae = ae + Math.imul(Ne, Gt) | 0, ae = ae + Math.imul(Ye, Dt) | 0, ge = ge + Math.imul(Ye, Gt) | 0, be = be + Math.imul(Ge, Qe) | 0, ae = ae + Math.imul(Ge, et) | 0, ae = ae + Math.imul(je, Qe) | 0, ge = ge + Math.imul(je, et) | 0, be = be + Math.imul(We, nt) | 0, ae = ae + Math.imul(We, qe) | 0, ae = ae + Math.imul(Be, nt) | 0, ge = ge + Math.imul(Be, qe) | 0, be = be + Math.imul(Le, pt) | 0, ae = ae + Math.imul(Le, bt) | 0, ae = ae + Math.imul(ze, pt) | 0, ge = ge + Math.imul(ze, bt) | 0;
        var Cn = (Ce + be | 0) + ((ae & 8191) << 13) | 0;
        Ce = (ge + (ae >>> 13) | 0) + (Cn >>> 26) | 0, Cn &= 67108863, be = Math.imul(Ze, vt), ae = Math.imul(Ze, Mt), ae = ae + Math.imul(at, vt) | 0, ge = Math.imul(at, Mt), be = be + Math.imul(Ve, St) | 0, ae = ae + Math.imul(Ve, Ot) | 0, ae = ae + Math.imul(Pe, St) | 0, ge = ge + Math.imul(Pe, Ot) | 0, be = be + Math.imul(xt, kt) | 0, ae = ae + Math.imul(xt, Bt) | 0, ae = ae + Math.imul(Tt, kt) | 0, ge = ge + Math.imul(Tt, Bt) | 0, be = be + Math.imul(dt, Nt) | 0, ae = ae + Math.imul(dt, Wt) | 0, ae = ae + Math.imul(mt, Nt) | 0, ge = ge + Math.imul(mt, Wt) | 0, be = be + Math.imul(it, Lt) | 0, ae = ae + Math.imul(it, Ht) | 0, ae = ae + Math.imul(ot, Lt) | 0, ge = ge + Math.imul(ot, Ht) | 0, be = be + Math.imul(Xe, Dt) | 0, ae = ae + Math.imul(Xe, Gt) | 0, ae = ae + Math.imul(st, Dt) | 0, ge = ge + Math.imul(st, Gt) | 0, be = be + Math.imul(Ne, Qe) | 0, ae = ae + Math.imul(Ne, et) | 0, ae = ae + Math.imul(Ye, Qe) | 0, ge = ge + Math.imul(Ye, et) | 0, be = be + Math.imul(Ge, nt) | 0, ae = ae + Math.imul(Ge, qe) | 0, ae = ae + Math.imul(je, nt) | 0, ge = ge + Math.imul(je, qe) | 0, be = be + Math.imul(We, pt) | 0, ae = ae + Math.imul(We, bt) | 0, ae = ae + Math.imul(Be, pt) | 0, ge = ge + Math.imul(Be, bt) | 0;
        var yn = (Ce + be | 0) + ((ae & 8191) << 13) | 0;
        Ce = (ge + (ae >>> 13) | 0) + (yn >>> 26) | 0, yn &= 67108863, be = Math.imul(Ze, St), ae = Math.imul(Ze, Ot), ae = ae + Math.imul(at, St) | 0, ge = Math.imul(at, Ot), be = be + Math.imul(Ve, kt) | 0, ae = ae + Math.imul(Ve, Bt) | 0, ae = ae + Math.imul(Pe, kt) | 0, ge = ge + Math.imul(Pe, Bt) | 0, be = be + Math.imul(xt, Nt) | 0, ae = ae + Math.imul(xt, Wt) | 0, ae = ae + Math.imul(Tt, Nt) | 0, ge = ge + Math.imul(Tt, Wt) | 0, be = be + Math.imul(dt, Lt) | 0, ae = ae + Math.imul(dt, Ht) | 0, ae = ae + Math.imul(mt, Lt) | 0, ge = ge + Math.imul(mt, Ht) | 0, be = be + Math.imul(it, Dt) | 0, ae = ae + Math.imul(it, Gt) | 0, ae = ae + Math.imul(ot, Dt) | 0, ge = ge + Math.imul(ot, Gt) | 0, be = be + Math.imul(Xe, Qe) | 0, ae = ae + Math.imul(Xe, et) | 0, ae = ae + Math.imul(st, Qe) | 0, ge = ge + Math.imul(st, et) | 0, be = be + Math.imul(Ne, nt) | 0, ae = ae + Math.imul(Ne, qe) | 0, ae = ae + Math.imul(Ye, nt) | 0, ge = ge + Math.imul(Ye, qe) | 0, be = be + Math.imul(Ge, pt) | 0, ae = ae + Math.imul(Ge, bt) | 0, ae = ae + Math.imul(je, pt) | 0, ge = ge + Math.imul(je, bt) | 0;
        var dn = (Ce + be | 0) + ((ae & 8191) << 13) | 0;
        Ce = (ge + (ae >>> 13) | 0) + (dn >>> 26) | 0, dn &= 67108863, be = Math.imul(Ze, kt), ae = Math.imul(Ze, Bt), ae = ae + Math.imul(at, kt) | 0, ge = Math.imul(at, Bt), be = be + Math.imul(Ve, Nt) | 0, ae = ae + Math.imul(Ve, Wt) | 0, ae = ae + Math.imul(Pe, Nt) | 0, ge = ge + Math.imul(Pe, Wt) | 0, be = be + Math.imul(xt, Lt) | 0, ae = ae + Math.imul(xt, Ht) | 0, ae = ae + Math.imul(Tt, Lt) | 0, ge = ge + Math.imul(Tt, Ht) | 0, be = be + Math.imul(dt, Dt) | 0, ae = ae + Math.imul(dt, Gt) | 0, ae = ae + Math.imul(mt, Dt) | 0, ge = ge + Math.imul(mt, Gt) | 0, be = be + Math.imul(it, Qe) | 0, ae = ae + Math.imul(it, et) | 0, ae = ae + Math.imul(ot, Qe) | 0, ge = ge + Math.imul(ot, et) | 0, be = be + Math.imul(Xe, nt) | 0, ae = ae + Math.imul(Xe, qe) | 0, ae = ae + Math.imul(st, nt) | 0, ge = ge + Math.imul(st, qe) | 0, be = be + Math.imul(Ne, pt) | 0, ae = ae + Math.imul(Ne, bt) | 0, ae = ae + Math.imul(Ye, pt) | 0, ge = ge + Math.imul(Ye, bt) | 0;
        var xn = (Ce + be | 0) + ((ae & 8191) << 13) | 0;
        Ce = (ge + (ae >>> 13) | 0) + (xn >>> 26) | 0, xn &= 67108863, be = Math.imul(Ze, Nt), ae = Math.imul(Ze, Wt), ae = ae + Math.imul(at, Nt) | 0, ge = Math.imul(at, Wt), be = be + Math.imul(Ve, Lt) | 0, ae = ae + Math.imul(Ve, Ht) | 0, ae = ae + Math.imul(Pe, Lt) | 0, ge = ge + Math.imul(Pe, Ht) | 0, be = be + Math.imul(xt, Dt) | 0, ae = ae + Math.imul(xt, Gt) | 0, ae = ae + Math.imul(Tt, Dt) | 0, ge = ge + Math.imul(Tt, Gt) | 0, be = be + Math.imul(dt, Qe) | 0, ae = ae + Math.imul(dt, et) | 0, ae = ae + Math.imul(mt, Qe) | 0, ge = ge + Math.imul(mt, et) | 0, be = be + Math.imul(it, nt) | 0, ae = ae + Math.imul(it, qe) | 0, ae = ae + Math.imul(ot, nt) | 0, ge = ge + Math.imul(ot, qe) | 0, be = be + Math.imul(Xe, pt) | 0, ae = ae + Math.imul(Xe, bt) | 0, ae = ae + Math.imul(st, pt) | 0, ge = ge + Math.imul(st, bt) | 0;
        var ln = (Ce + be | 0) + ((ae & 8191) << 13) | 0;
        Ce = (ge + (ae >>> 13) | 0) + (ln >>> 26) | 0, ln &= 67108863, be = Math.imul(Ze, Lt), ae = Math.imul(Ze, Ht), ae = ae + Math.imul(at, Lt) | 0, ge = Math.imul(at, Ht), be = be + Math.imul(Ve, Dt) | 0, ae = ae + Math.imul(Ve, Gt) | 0, ae = ae + Math.imul(Pe, Dt) | 0, ge = ge + Math.imul(Pe, Gt) | 0, be = be + Math.imul(xt, Qe) | 0, ae = ae + Math.imul(xt, et) | 0, ae = ae + Math.imul(Tt, Qe) | 0, ge = ge + Math.imul(Tt, et) | 0, be = be + Math.imul(dt, nt) | 0, ae = ae + Math.imul(dt, qe) | 0, ae = ae + Math.imul(mt, nt) | 0, ge = ge + Math.imul(mt, qe) | 0, be = be + Math.imul(it, pt) | 0, ae = ae + Math.imul(it, bt) | 0, ae = ae + Math.imul(ot, pt) | 0, ge = ge + Math.imul(ot, bt) | 0;
        var mn = (Ce + be | 0) + ((ae & 8191) << 13) | 0;
        Ce = (ge + (ae >>> 13) | 0) + (mn >>> 26) | 0, mn &= 67108863, be = Math.imul(Ze, Dt), ae = Math.imul(Ze, Gt), ae = ae + Math.imul(at, Dt) | 0, ge = Math.imul(at, Gt), be = be + Math.imul(Ve, Qe) | 0, ae = ae + Math.imul(Ve, et) | 0, ae = ae + Math.imul(Pe, Qe) | 0, ge = ge + Math.imul(Pe, et) | 0, be = be + Math.imul(xt, nt) | 0, ae = ae + Math.imul(xt, qe) | 0, ae = ae + Math.imul(Tt, nt) | 0, ge = ge + Math.imul(Tt, qe) | 0, be = be + Math.imul(dt, pt) | 0, ae = ae + Math.imul(dt, bt) | 0, ae = ae + Math.imul(mt, pt) | 0, ge = ge + Math.imul(mt, bt) | 0;
        var gn = (Ce + be | 0) + ((ae & 8191) << 13) | 0;
        Ce = (ge + (ae >>> 13) | 0) + (gn >>> 26) | 0, gn &= 67108863, be = Math.imul(Ze, Qe), ae = Math.imul(Ze, et), ae = ae + Math.imul(at, Qe) | 0, ge = Math.imul(at, et), be = be + Math.imul(Ve, nt) | 0, ae = ae + Math.imul(Ve, qe) | 0, ae = ae + Math.imul(Pe, nt) | 0, ge = ge + Math.imul(Pe, qe) | 0, be = be + Math.imul(xt, pt) | 0, ae = ae + Math.imul(xt, bt) | 0, ae = ae + Math.imul(Tt, pt) | 0, ge = ge + Math.imul(Tt, bt) | 0;
        var cn = (Ce + be | 0) + ((ae & 8191) << 13) | 0;
        Ce = (ge + (ae >>> 13) | 0) + (cn >>> 26) | 0, cn &= 67108863, be = Math.imul(Ze, nt), ae = Math.imul(Ze, qe), ae = ae + Math.imul(at, nt) | 0, ge = Math.imul(at, qe), be = be + Math.imul(Ve, pt) | 0, ae = ae + Math.imul(Ve, bt) | 0, ae = ae + Math.imul(Pe, pt) | 0, ge = ge + Math.imul(Pe, bt) | 0;
        var Pt = (Ce + be | 0) + ((ae & 8191) << 13) | 0;
        Ce = (ge + (ae >>> 13) | 0) + (Pt >>> 26) | 0, Pt &= 67108863, be = Math.imul(Ze, pt), ae = Math.imul(Ze, bt), ae = ae + Math.imul(at, pt) | 0, ge = Math.imul(at, bt);
        var Rt = (Ce + be | 0) + ((ae & 8191) << 13) | 0;
        return Ce = (ge + (ae >>> 13) | 0) + (Rt >>> 26) | 0, Rt &= 67108863, ye[0] = jt, ye[1] = $t, ye[2] = Jt, ye[3] = zt, ye[4] = Vt, ye[5] = Kt, ye[6] = pn, ye[7] = An, ye[8] = vn, ye[9] = Cn, ye[10] = yn, ye[11] = dn, ye[12] = xn, ye[13] = ln, ye[14] = mn, ye[15] = gn, ye[16] = cn, ye[17] = Pt, ye[18] = Rt, Ce !== 0 && (ye[19] = Ce, ce.length++), ce;
      };
      Math.imul || (me = he);
      function xe(Ae, ne, oe) {
        oe.negative = ne.negative ^ Ae.negative, oe.length = Ae.length + ne.length;
        for (var ce = 0, le = 0, pe = 0; pe < oe.length - 1; pe++) {
          var ye = le;
          le = 0;
          for (var Ce = ce & 67108863, be = Math.min(pe, ne.length - 1), ae = Math.max(0, pe - Ae.length + 1); ae <= be; ae++) {
            var ge = pe - ae, Se = Ae.words[ge] | 0, Le = ne.words[ae] | 0, ze = Se * Le, Re = ze & 67108863;
            ye = ye + (ze / 67108864 | 0) | 0, Re = Re + Ce | 0, Ce = Re & 67108863, ye = ye + (Re >>> 26) | 0, le += ye >>> 26, ye &= 67108863;
          }
          oe.words[pe] = Ce, ce = ye, ye = le;
        }
        return ce !== 0 ? oe.words[pe] = ce : oe.length--, oe.strip();
      }
      function ve(Ae, ne, oe) {
        var ce = new Te();
        return ce.mulp(Ae, ne, oe);
      }
      J.prototype.mulTo = function(ne, oe) {
        var ce, le = this.length + ne.length;
        return this.length === 10 && ne.length === 10 ? ce = me(this, ne, oe) : le < 63 ? ce = he(this, ne, oe) : le < 1024 ? ce = xe(this, ne, oe) : ce = ve(this, ne, oe), ce;
      };
      function Te(Ae, ne) {
        this.x = Ae, this.y = ne;
      }
      Te.prototype.makeRBT = function(ne) {
        for (var oe = new Array(ne), ce = J.prototype._countBits(ne) - 1, le = 0; le < ne; le++)
          oe[le] = this.revBin(le, ce, ne);
        return oe;
      }, Te.prototype.revBin = function(ne, oe, ce) {
        if (ne === 0 || ne === ce - 1) return ne;
        for (var le = 0, pe = 0; pe < oe; pe++)
          le |= (ne & 1) << oe - pe - 1, ne >>= 1;
        return le;
      }, Te.prototype.permute = function(ne, oe, ce, le, pe, ye) {
        for (var Ce = 0; Ce < ye; Ce++)
          le[Ce] = oe[ne[Ce]], pe[Ce] = ce[ne[Ce]];
      }, Te.prototype.transform = function(ne, oe, ce, le, pe, ye) {
        this.permute(ye, ne, oe, ce, le, pe);
        for (var Ce = 1; Ce < pe; Ce <<= 1)
          for (var be = Ce << 1, ae = Math.cos(2 * Math.PI / be), ge = Math.sin(2 * Math.PI / be), Se = 0; Se < pe; Se += be)
            for (var Le = ae, ze = ge, Re = 0; Re < Ce; Re++) {
              var We = ce[Se + Re], Be = le[Se + Re], Ue = ce[Se + Re + Ce], Ge = le[Se + Re + Ce], je = Le * Ue - ze * Ge;
              Ge = Le * Ge + ze * Ue, Ue = je, ce[Se + Re] = We + Ue, le[Se + Re] = Be + Ge, ce[Se + Re + Ce] = We - Ue, le[Se + Re + Ce] = Be - Ge, Re !== be && (je = ae * Le - ge * ze, ze = ae * ze + ge * Le, Le = je);
            }
      }, Te.prototype.guessLen13b = function(ne, oe) {
        var ce = Math.max(oe, ne) | 1, le = ce & 1, pe = 0;
        for (ce = ce / 2 | 0; ce; ce = ce >>> 1)
          pe++;
        return 1 << pe + 1 + le;
      }, Te.prototype.conjugate = function(ne, oe, ce) {
        if (!(ce <= 1))
          for (var le = 0; le < ce / 2; le++) {
            var pe = ne[le];
            ne[le] = ne[ce - le - 1], ne[ce - le - 1] = pe, pe = oe[le], oe[le] = -oe[ce - le - 1], oe[ce - le - 1] = -pe;
          }
      }, Te.prototype.normalize13b = function(ne, oe) {
        for (var ce = 0, le = 0; le < oe / 2; le++) {
          var pe = Math.round(ne[2 * le + 1] / oe) * 8192 + Math.round(ne[2 * le] / oe) + ce;
          ne[le] = pe & 67108863, pe < 67108864 ? ce = 0 : ce = pe / 67108864 | 0;
        }
        return ne;
      }, Te.prototype.convert13b = function(ne, oe, ce, le) {
        for (var pe = 0, ye = 0; ye < oe; ye++)
          pe = pe + (ne[ye] | 0), ce[2 * ye] = pe & 8191, pe = pe >>> 13, ce[2 * ye + 1] = pe & 8191, pe = pe >>> 13;
        for (ye = 2 * oe; ye < le; ++ye)
          ce[ye] = 0;
        $(pe === 0), $((pe & -8192) === 0);
      }, Te.prototype.stub = function(ne) {
        for (var oe = new Array(ne), ce = 0; ce < ne; ce++)
          oe[ce] = 0;
        return oe;
      }, Te.prototype.mulp = function(ne, oe, ce) {
        var le = 2 * this.guessLen13b(ne.length, oe.length), pe = this.makeRBT(le), ye = this.stub(le), Ce = new Array(le), be = new Array(le), ae = new Array(le), ge = new Array(le), Se = new Array(le), Le = new Array(le), ze = ce.words;
        ze.length = le, this.convert13b(ne.words, ne.length, Ce, le), this.convert13b(oe.words, oe.length, ge, le), this.transform(Ce, ye, be, ae, le, pe), this.transform(ge, ye, Se, Le, le, pe);
        for (var Re = 0; Re < le; Re++) {
          var We = be[Re] * Se[Re] - ae[Re] * Le[Re];
          ae[Re] = be[Re] * Le[Re] + ae[Re] * Se[Re], be[Re] = We;
        }
        return this.conjugate(be, ae, le), this.transform(be, ae, ze, ye, le, pe), this.conjugate(ze, ye, le), this.normalize13b(ze, le), ce.negative = ne.negative ^ oe.negative, ce.length = ne.length + oe.length, ce.strip();
      }, J.prototype.mul = function(ne) {
        var oe = new J(null);
        return oe.words = new Array(this.length + ne.length), this.mulTo(ne, oe);
      }, J.prototype.mulf = function(ne) {
        var oe = new J(null);
        return oe.words = new Array(this.length + ne.length), ve(this, ne, oe);
      }, J.prototype.imul = function(ne) {
        return this.clone().mulTo(ne, this);
      }, J.prototype.imuln = function(ne) {
        $(typeof ne == "number"), $(ne < 67108864);
        for (var oe = 0, ce = 0; ce < this.length; ce++) {
          var le = (this.words[ce] | 0) * ne, pe = (le & 67108863) + (oe & 67108863);
          oe >>= 26, oe += le / 67108864 | 0, oe += pe >>> 26, this.words[ce] = pe & 67108863;
        }
        return oe !== 0 && (this.words[ce] = oe, this.length++), this;
      }, J.prototype.muln = function(ne) {
        return this.clone().imuln(ne);
      }, J.prototype.sqr = function() {
        return this.mul(this);
      }, J.prototype.isqr = function() {
        return this.imul(this.clone());
      }, J.prototype.pow = function(ne) {
        var oe = fe(ne);
        if (oe.length === 0) return new J(1);
        for (var ce = this, le = 0; le < oe.length && oe[le] === 0; le++, ce = ce.sqr())
          ;
        if (++le < oe.length)
          for (var pe = ce.sqr(); le < oe.length; le++, pe = pe.sqr())
            oe[le] !== 0 && (ce = ce.mul(pe));
        return ce;
      }, J.prototype.iushln = function(ne) {
        $(typeof ne == "number" && ne >= 0);
        var oe = ne % 26, ce = (ne - oe) / 26, le = 67108863 >>> 26 - oe << 26 - oe, pe;
        if (oe !== 0) {
          var ye = 0;
          for (pe = 0; pe < this.length; pe++) {
            var Ce = this.words[pe] & le, be = (this.words[pe] | 0) - Ce << oe;
            this.words[pe] = be | ye, ye = Ce >>> 26 - oe;
          }
          ye && (this.words[pe] = ye, this.length++);
        }
        if (ce !== 0) {
          for (pe = this.length - 1; pe >= 0; pe--)
            this.words[pe + ce] = this.words[pe];
          for (pe = 0; pe < ce; pe++)
            this.words[pe] = 0;
          this.length += ce;
        }
        return this.strip();
      }, J.prototype.ishln = function(ne) {
        return $(this.negative === 0), this.iushln(ne);
      }, J.prototype.iushrn = function(ne, oe, ce) {
        $(typeof ne == "number" && ne >= 0);
        var le;
        oe ? le = (oe - oe % 26) / 26 : le = 0;
        var pe = ne % 26, ye = Math.min((ne - pe) / 26, this.length), Ce = 67108863 ^ 67108863 >>> pe << pe, be = ce;
        if (le -= ye, le = Math.max(0, le), be) {
          for (var ae = 0; ae < ye; ae++)
            be.words[ae] = this.words[ae];
          be.length = ye;
        }
        if (ye !== 0) if (this.length > ye)
          for (this.length -= ye, ae = 0; ae < this.length; ae++)
            this.words[ae] = this.words[ae + ye];
        else
          this.words[0] = 0, this.length = 1;
        var ge = 0;
        for (ae = this.length - 1; ae >= 0 && (ge !== 0 || ae >= le); ae--) {
          var Se = this.words[ae] | 0;
          this.words[ae] = ge << 26 - pe | Se >>> pe, ge = Se & Ce;
        }
        return be && ge !== 0 && (be.words[be.length++] = ge), this.length === 0 && (this.words[0] = 0, this.length = 1), this.strip();
      }, J.prototype.ishrn = function(ne, oe, ce) {
        return $(this.negative === 0), this.iushrn(ne, oe, ce);
      }, J.prototype.shln = function(ne) {
        return this.clone().ishln(ne);
      }, J.prototype.ushln = function(ne) {
        return this.clone().iushln(ne);
      }, J.prototype.shrn = function(ne) {
        return this.clone().ishrn(ne);
      }, J.prototype.ushrn = function(ne) {
        return this.clone().iushrn(ne);
      }, J.prototype.testn = function(ne) {
        $(typeof ne == "number" && ne >= 0);
        var oe = ne % 26, ce = (ne - oe) / 26, le = 1 << oe;
        if (this.length <= ce) return !1;
        var pe = this.words[ce];
        return !!(pe & le);
      }, J.prototype.imaskn = function(ne) {
        $(typeof ne == "number" && ne >= 0);
        var oe = ne % 26, ce = (ne - oe) / 26;
        if ($(this.negative === 0, "imaskn works only with positive numbers"), this.length <= ce)
          return this;
        if (oe !== 0 && ce++, this.length = Math.min(ce, this.length), oe !== 0) {
          var le = 67108863 ^ 67108863 >>> oe << oe;
          this.words[this.length - 1] &= le;
        }
        return this.strip();
      }, J.prototype.maskn = function(ne) {
        return this.clone().imaskn(ne);
      }, J.prototype.iaddn = function(ne) {
        return $(typeof ne == "number"), $(ne < 67108864), ne < 0 ? this.isubn(-ne) : this.negative !== 0 ? this.length === 1 && (this.words[0] | 0) < ne ? (this.words[0] = ne - (this.words[0] | 0), this.negative = 0, this) : (this.negative = 0, this.isubn(ne), this.negative = 1, this) : this._iaddn(ne);
      }, J.prototype._iaddn = function(ne) {
        this.words[0] += ne;
        for (var oe = 0; oe < this.length && this.words[oe] >= 67108864; oe++)
          this.words[oe] -= 67108864, oe === this.length - 1 ? this.words[oe + 1] = 1 : this.words[oe + 1]++;
        return this.length = Math.max(this.length, oe + 1), this;
      }, J.prototype.isubn = function(ne) {
        if ($(typeof ne == "number"), $(ne < 67108864), ne < 0) return this.iaddn(-ne);
        if (this.negative !== 0)
          return this.negative = 0, this.iaddn(ne), this.negative = 1, this;
        if (this.words[0] -= ne, this.length === 1 && this.words[0] < 0)
          this.words[0] = -this.words[0], this.negative = 1;
        else
          for (var oe = 0; oe < this.length && this.words[oe] < 0; oe++)
            this.words[oe] += 67108864, this.words[oe + 1] -= 1;
        return this.strip();
      }, J.prototype.addn = function(ne) {
        return this.clone().iaddn(ne);
      }, J.prototype.subn = function(ne) {
        return this.clone().isubn(ne);
      }, J.prototype.iabs = function() {
        return this.negative = 0, this;
      }, J.prototype.abs = function() {
        return this.clone().iabs();
      }, J.prototype._ishlnsubmul = function(ne, oe, ce) {
        var le = ne.length + ce, pe;
        this._expand(le);
        var ye, Ce = 0;
        for (pe = 0; pe < ne.length; pe++) {
          ye = (this.words[pe + ce] | 0) + Ce;
          var be = (ne.words[pe] | 0) * oe;
          ye -= be & 67108863, Ce = (ye >> 26) - (be / 67108864 | 0), this.words[pe + ce] = ye & 67108863;
        }
        for (; pe < this.length - ce; pe++)
          ye = (this.words[pe + ce] | 0) + Ce, Ce = ye >> 26, this.words[pe + ce] = ye & 67108863;
        if (Ce === 0) return this.strip();
        for ($(Ce === -1), Ce = 0, pe = 0; pe < this.length; pe++)
          ye = -(this.words[pe] | 0) + Ce, Ce = ye >> 26, this.words[pe] = ye & 67108863;
        return this.negative = 1, this.strip();
      }, J.prototype._wordDiv = function(ne, oe) {
        var ce = this.length - ne.length, le = this.clone(), pe = ne, ye = pe.words[pe.length - 1] | 0, Ce = this._countBits(ye);
        ce = 26 - Ce, ce !== 0 && (pe = pe.ushln(ce), le.iushln(ce), ye = pe.words[pe.length - 1] | 0);
        var be = le.length - pe.length, ae;
        if (oe !== "mod") {
          ae = new J(null), ae.length = be + 1, ae.words = new Array(ae.length);
          for (var ge = 0; ge < ae.length; ge++)
            ae.words[ge] = 0;
        }
        var Se = le.clone()._ishlnsubmul(pe, 1, be);
        Se.negative === 0 && (le = Se, ae && (ae.words[be] = 1));
        for (var Le = be - 1; Le >= 0; Le--) {
          var ze = (le.words[pe.length + Le] | 0) * 67108864 + (le.words[pe.length + Le - 1] | 0);
          for (ze = Math.min(ze / ye | 0, 67108863), le._ishlnsubmul(pe, ze, Le); le.negative !== 0; )
            ze--, le.negative = 0, le._ishlnsubmul(pe, 1, Le), le.isZero() || (le.negative ^= 1);
          ae && (ae.words[Le] = ze);
        }
        return ae && ae.strip(), le.strip(), oe !== "div" && ce !== 0 && le.iushrn(ce), {
          div: ae || null,
          mod: le
        };
      }, J.prototype.divmod = function(ne, oe, ce) {
        if ($(!ne.isZero()), this.isZero())
          return {
            div: new J(0),
            mod: new J(0)
          };
        var le, pe, ye;
        return this.negative !== 0 && ne.negative === 0 ? (ye = this.neg().divmod(ne, oe), oe !== "mod" && (le = ye.div.neg()), oe !== "div" && (pe = ye.mod.neg(), ce && pe.negative !== 0 && pe.iadd(ne)), {
          div: le,
          mod: pe
        }) : this.negative === 0 && ne.negative !== 0 ? (ye = this.divmod(ne.neg(), oe), oe !== "mod" && (le = ye.div.neg()), {
          div: le,
          mod: ye.mod
        }) : this.negative & ne.negative ? (ye = this.neg().divmod(ne.neg(), oe), oe !== "div" && (pe = ye.mod.neg(), ce && pe.negative !== 0 && pe.isub(ne)), {
          div: ye.div,
          mod: pe
        }) : ne.length > this.length || this.cmp(ne) < 0 ? {
          div: new J(0),
          mod: this
        } : ne.length === 1 ? oe === "div" ? {
          div: this.divn(ne.words[0]),
          mod: null
        } : oe === "mod" ? {
          div: null,
          mod: new J(this.modn(ne.words[0]))
        } : {
          div: this.divn(ne.words[0]),
          mod: new J(this.modn(ne.words[0]))
        } : this._wordDiv(ne, oe);
      }, J.prototype.div = function(ne) {
        return this.divmod(ne, "div", !1).div;
      }, J.prototype.mod = function(ne) {
        return this.divmod(ne, "mod", !1).mod;
      }, J.prototype.umod = function(ne) {
        return this.divmod(ne, "mod", !0).mod;
      }, J.prototype.divRound = function(ne) {
        var oe = this.divmod(ne);
        if (oe.mod.isZero()) return oe.div;
        var ce = oe.div.negative !== 0 ? oe.mod.isub(ne) : oe.mod, le = ne.ushrn(1), pe = ne.andln(1), ye = ce.cmp(le);
        return ye < 0 || pe === 1 && ye === 0 ? oe.div : oe.div.negative !== 0 ? oe.div.isubn(1) : oe.div.iaddn(1);
      }, J.prototype.modn = function(ne) {
        $(ne <= 67108863);
        for (var oe = (1 << 26) % ne, ce = 0, le = this.length - 1; le >= 0; le--)
          ce = (oe * ce + (this.words[le] | 0)) % ne;
        return ce;
      }, J.prototype.idivn = function(ne) {
        $(ne <= 67108863);
        for (var oe = 0, ce = this.length - 1; ce >= 0; ce--) {
          var le = (this.words[ce] | 0) + oe * 67108864;
          this.words[ce] = le / ne | 0, oe = le % ne;
        }
        return this.strip();
      }, J.prototype.divn = function(ne) {
        return this.clone().idivn(ne);
      }, J.prototype.egcd = function(ne) {
        $(ne.negative === 0), $(!ne.isZero());
        var oe = this, ce = ne.clone();
        oe.negative !== 0 ? oe = oe.umod(ne) : oe = oe.clone();
        for (var le = new J(1), pe = new J(0), ye = new J(0), Ce = new J(1), be = 0; oe.isEven() && ce.isEven(); )
          oe.iushrn(1), ce.iushrn(1), ++be;
        for (var ae = ce.clone(), ge = oe.clone(); !oe.isZero(); ) {
          for (var Se = 0, Le = 1; !(oe.words[0] & Le) && Se < 26; ++Se, Le <<= 1) ;
          if (Se > 0)
            for (oe.iushrn(Se); Se-- > 0; )
              (le.isOdd() || pe.isOdd()) && (le.iadd(ae), pe.isub(ge)), le.iushrn(1), pe.iushrn(1);
          for (var ze = 0, Re = 1; !(ce.words[0] & Re) && ze < 26; ++ze, Re <<= 1) ;
          if (ze > 0)
            for (ce.iushrn(ze); ze-- > 0; )
              (ye.isOdd() || Ce.isOdd()) && (ye.iadd(ae), Ce.isub(ge)), ye.iushrn(1), Ce.iushrn(1);
          oe.cmp(ce) >= 0 ? (oe.isub(ce), le.isub(ye), pe.isub(Ce)) : (ce.isub(oe), ye.isub(le), Ce.isub(pe));
        }
        return {
          a: ye,
          b: Ce,
          gcd: ce.iushln(be)
        };
      }, J.prototype._invmp = function(ne) {
        $(ne.negative === 0), $(!ne.isZero());
        var oe = this, ce = ne.clone();
        oe.negative !== 0 ? oe = oe.umod(ne) : oe = oe.clone();
        for (var le = new J(1), pe = new J(0), ye = ce.clone(); oe.cmpn(1) > 0 && ce.cmpn(1) > 0; ) {
          for (var Ce = 0, be = 1; !(oe.words[0] & be) && Ce < 26; ++Ce, be <<= 1) ;
          if (Ce > 0)
            for (oe.iushrn(Ce); Ce-- > 0; )
              le.isOdd() && le.iadd(ye), le.iushrn(1);
          for (var ae = 0, ge = 1; !(ce.words[0] & ge) && ae < 26; ++ae, ge <<= 1) ;
          if (ae > 0)
            for (ce.iushrn(ae); ae-- > 0; )
              pe.isOdd() && pe.iadd(ye), pe.iushrn(1);
          oe.cmp(ce) >= 0 ? (oe.isub(ce), le.isub(pe)) : (ce.isub(oe), pe.isub(le));
        }
        var Se;
        return oe.cmpn(1) === 0 ? Se = le : Se = pe, Se.cmpn(0) < 0 && Se.iadd(ne), Se;
      }, J.prototype.gcd = function(ne) {
        if (this.isZero()) return ne.abs();
        if (ne.isZero()) return this.abs();
        var oe = this.clone(), ce = ne.clone();
        oe.negative = 0, ce.negative = 0;
        for (var le = 0; oe.isEven() && ce.isEven(); le++)
          oe.iushrn(1), ce.iushrn(1);
        do {
          for (; oe.isEven(); )
            oe.iushrn(1);
          for (; ce.isEven(); )
            ce.iushrn(1);
          var pe = oe.cmp(ce);
          if (pe < 0) {
            var ye = oe;
            oe = ce, ce = ye;
          } else if (pe === 0 || ce.cmpn(1) === 0)
            break;
          oe.isub(ce);
        } while (!0);
        return ce.iushln(le);
      }, J.prototype.invm = function(ne) {
        return this.egcd(ne).a.umod(ne);
      }, J.prototype.isEven = function() {
        return (this.words[0] & 1) === 0;
      }, J.prototype.isOdd = function() {
        return (this.words[0] & 1) === 1;
      }, J.prototype.andln = function(ne) {
        return this.words[0] & ne;
      }, J.prototype.bincn = function(ne) {
        $(typeof ne == "number");
        var oe = ne % 26, ce = (ne - oe) / 26, le = 1 << oe;
        if (this.length <= ce)
          return this._expand(ce + 1), this.words[ce] |= le, this;
        for (var pe = le, ye = ce; pe !== 0 && ye < this.length; ye++) {
          var Ce = this.words[ye] | 0;
          Ce += pe, pe = Ce >>> 26, Ce &= 67108863, this.words[ye] = Ce;
        }
        return pe !== 0 && (this.words[ye] = pe, this.length++), this;
      }, J.prototype.isZero = function() {
        return this.length === 1 && this.words[0] === 0;
      }, J.prototype.cmpn = function(ne) {
        var oe = ne < 0;
        if (this.negative !== 0 && !oe) return -1;
        if (this.negative === 0 && oe) return 1;
        this.strip();
        var ce;
        if (this.length > 1)
          ce = 1;
        else {
          oe && (ne = -ne), $(ne <= 67108863, "Number is too big");
          var le = this.words[0] | 0;
          ce = le === ne ? 0 : le < ne ? -1 : 1;
        }
        return this.negative !== 0 ? -ce | 0 : ce;
      }, J.prototype.cmp = function(ne) {
        if (this.negative !== 0 && ne.negative === 0) return -1;
        if (this.negative === 0 && ne.negative !== 0) return 1;
        var oe = this.ucmp(ne);
        return this.negative !== 0 ? -oe | 0 : oe;
      }, J.prototype.ucmp = function(ne) {
        if (this.length > ne.length) return 1;
        if (this.length < ne.length) return -1;
        for (var oe = 0, ce = this.length - 1; ce >= 0; ce--) {
          var le = this.words[ce] | 0, pe = ne.words[ce] | 0;
          if (le !== pe) {
            le < pe ? oe = -1 : le > pe && (oe = 1);
            break;
          }
        }
        return oe;
      }, J.prototype.gtn = function(ne) {
        return this.cmpn(ne) === 1;
      }, J.prototype.gt = function(ne) {
        return this.cmp(ne) === 1;
      }, J.prototype.gten = function(ne) {
        return this.cmpn(ne) >= 0;
      }, J.prototype.gte = function(ne) {
        return this.cmp(ne) >= 0;
      }, J.prototype.ltn = function(ne) {
        return this.cmpn(ne) === -1;
      }, J.prototype.lt = function(ne) {
        return this.cmp(ne) === -1;
      }, J.prototype.lten = function(ne) {
        return this.cmpn(ne) <= 0;
      }, J.prototype.lte = function(ne) {
        return this.cmp(ne) <= 0;
      }, J.prototype.eqn = function(ne) {
        return this.cmpn(ne) === 0;
      }, J.prototype.eq = function(ne) {
        return this.cmp(ne) === 0;
      }, J.red = function(ne) {
        return new De(ne);
      }, J.prototype.toRed = function(ne) {
        return $(!this.red, "Already a number in reduction context"), $(this.negative === 0, "red works only with positives"), ne.convertTo(this)._forceRed(ne);
      }, J.prototype.fromRed = function() {
        return $(this.red, "fromRed works only with numbers in reduction context"), this.red.convertFrom(this);
      }, J.prototype._forceRed = function(ne) {
        return this.red = ne, this;
      }, J.prototype.forceRed = function(ne) {
        return $(!this.red, "Already a number in reduction context"), this._forceRed(ne);
      }, J.prototype.redAdd = function(ne) {
        return $(this.red, "redAdd works only with red numbers"), this.red.add(this, ne);
      }, J.prototype.redIAdd = function(ne) {
        return $(this.red, "redIAdd works only with red numbers"), this.red.iadd(this, ne);
      }, J.prototype.redSub = function(ne) {
        return $(this.red, "redSub works only with red numbers"), this.red.sub(this, ne);
      }, J.prototype.redISub = function(ne) {
        return $(this.red, "redISub works only with red numbers"), this.red.isub(this, ne);
      }, J.prototype.redShl = function(ne) {
        return $(this.red, "redShl works only with red numbers"), this.red.shl(this, ne);
      }, J.prototype.redMul = function(ne) {
        return $(this.red, "redMul works only with red numbers"), this.red._verify2(this, ne), this.red.mul(this, ne);
      }, J.prototype.redIMul = function(ne) {
        return $(this.red, "redMul works only with red numbers"), this.red._verify2(this, ne), this.red.imul(this, ne);
      }, J.prototype.redSqr = function() {
        return $(this.red, "redSqr works only with red numbers"), this.red._verify1(this), this.red.sqr(this);
      }, J.prototype.redISqr = function() {
        return $(this.red, "redISqr works only with red numbers"), this.red._verify1(this), this.red.isqr(this);
      }, J.prototype.redSqrt = function() {
        return $(this.red, "redSqrt works only with red numbers"), this.red._verify1(this), this.red.sqrt(this);
      }, J.prototype.redInvm = function() {
        return $(this.red, "redInvm works only with red numbers"), this.red._verify1(this), this.red.invm(this);
      }, J.prototype.redNeg = function() {
        return $(this.red, "redNeg works only with red numbers"), this.red._verify1(this), this.red.neg(this);
      }, J.prototype.redPow = function(ne) {
        return $(this.red && !ne.red, "redPow(normalNum)"), this.red._verify1(this), this.red.pow(this, ne);
      };
      var we = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
      };
      function Ee(Ae, ne) {
        this.name = Ae, this.p = new J(ne, 16), this.n = this.p.bitLength(), this.k = new J(1).iushln(this.n).isub(this.p), this.tmp = this._tmp();
      }
      Ee.prototype._tmp = function() {
        var ne = new J(null);
        return ne.words = new Array(Math.ceil(this.n / 13)), ne;
      }, Ee.prototype.ireduce = function(ne) {
        var oe = ne, ce;
        do
          this.split(oe, this.tmp), oe = this.imulK(oe), oe = oe.iadd(this.tmp), ce = oe.bitLength();
        while (ce > this.n);
        var le = ce < this.n ? -1 : oe.ucmp(this.p);
        return le === 0 ? (oe.words[0] = 0, oe.length = 1) : le > 0 ? oe.isub(this.p) : oe.strip !== void 0 ? oe.strip() : oe._strip(), oe;
      }, Ee.prototype.split = function(ne, oe) {
        ne.iushrn(this.n, 0, oe);
      }, Ee.prototype.imulK = function(ne) {
        return ne.imul(this.k);
      };
      function Me() {
        Ee.call(
          this,
          "k256",
          "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f"
        );
      }
      V(Me, Ee), Me.prototype.split = function(ne, oe) {
        for (var ce = 4194303, le = Math.min(ne.length, 9), pe = 0; pe < le; pe++)
          oe.words[pe] = ne.words[pe];
        if (oe.length = le, ne.length <= 9) {
          ne.words[0] = 0, ne.length = 1;
          return;
        }
        var ye = ne.words[9];
        for (oe.words[oe.length++] = ye & ce, pe = 10; pe < ne.length; pe++) {
          var Ce = ne.words[pe] | 0;
          ne.words[pe - 10] = (Ce & ce) << 4 | ye >>> 22, ye = Ce;
        }
        ye >>>= 22, ne.words[pe - 10] = ye, ye === 0 && ne.length > 10 ? ne.length -= 10 : ne.length -= 9;
      }, Me.prototype.imulK = function(ne) {
        ne.words[ne.length] = 0, ne.words[ne.length + 1] = 0, ne.length += 2;
        for (var oe = 0, ce = 0; ce < ne.length; ce++) {
          var le = ne.words[ce] | 0;
          oe += le * 977, ne.words[ce] = oe & 67108863, oe = le * 64 + (oe / 67108864 | 0);
        }
        return ne.words[ne.length - 1] === 0 && (ne.length--, ne.words[ne.length - 1] === 0 && ne.length--), ne;
      };
      function Ie() {
        Ee.call(
          this,
          "p224",
          "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001"
        );
      }
      V(Ie, Ee);
      function ke() {
        Ee.call(
          this,
          "p192",
          "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff"
        );
      }
      V(ke, Ee);
      function _e() {
        Ee.call(
          this,
          "25519",
          "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed"
        );
      }
      V(_e, Ee), _e.prototype.imulK = function(ne) {
        for (var oe = 0, ce = 0; ce < ne.length; ce++) {
          var le = (ne.words[ce] | 0) * 19 + oe, pe = le & 67108863;
          le >>>= 26, ne.words[ce] = pe, oe = le;
        }
        return oe !== 0 && (ne.words[ne.length++] = oe), ne;
      }, J._prime = function(ne) {
        if (we[ne]) return we[ne];
        var oe;
        if (ne === "k256")
          oe = new Me();
        else if (ne === "p224")
          oe = new Ie();
        else if (ne === "p192")
          oe = new ke();
        else if (ne === "p25519")
          oe = new _e();
        else
          throw new Error("Unknown prime " + ne);
        return we[ne] = oe, oe;
      };
      function De(Ae) {
        if (typeof Ae == "string") {
          var ne = J._prime(Ae);
          this.m = ne.p, this.prime = ne;
        } else
          $(Ae.gtn(1), "modulus must be greater than 1"), this.m = Ae, this.prime = null;
      }
      De.prototype._verify1 = function(ne) {
        $(ne.negative === 0, "red works only with positives"), $(ne.red, "red works only with red numbers");
      }, De.prototype._verify2 = function(ne, oe) {
        $((ne.negative | oe.negative) === 0, "red works only with positives"), $(
          ne.red && ne.red === oe.red,
          "red works only with red numbers"
        );
      }, De.prototype.imod = function(ne) {
        return this.prime ? this.prime.ireduce(ne)._forceRed(this) : ne.umod(this.m)._forceRed(this);
      }, De.prototype.neg = function(ne) {
        return ne.isZero() ? ne.clone() : this.m.sub(ne)._forceRed(this);
      }, De.prototype.add = function(ne, oe) {
        this._verify2(ne, oe);
        var ce = ne.add(oe);
        return ce.cmp(this.m) >= 0 && ce.isub(this.m), ce._forceRed(this);
      }, De.prototype.iadd = function(ne, oe) {
        this._verify2(ne, oe);
        var ce = ne.iadd(oe);
        return ce.cmp(this.m) >= 0 && ce.isub(this.m), ce;
      }, De.prototype.sub = function(ne, oe) {
        this._verify2(ne, oe);
        var ce = ne.sub(oe);
        return ce.cmpn(0) < 0 && ce.iadd(this.m), ce._forceRed(this);
      }, De.prototype.isub = function(ne, oe) {
        this._verify2(ne, oe);
        var ce = ne.isub(oe);
        return ce.cmpn(0) < 0 && ce.iadd(this.m), ce;
      }, De.prototype.shl = function(ne, oe) {
        return this._verify1(ne), this.imod(ne.ushln(oe));
      }, De.prototype.imul = function(ne, oe) {
        return this._verify2(ne, oe), this.imod(ne.imul(oe));
      }, De.prototype.mul = function(ne, oe) {
        return this._verify2(ne, oe), this.imod(ne.mul(oe));
      }, De.prototype.isqr = function(ne) {
        return this.imul(ne, ne.clone());
      }, De.prototype.sqr = function(ne) {
        return this.mul(ne, ne);
      }, De.prototype.sqrt = function(ne) {
        if (ne.isZero()) return ne.clone();
        var oe = this.m.andln(3);
        if ($(oe % 2 === 1), oe === 3) {
          var ce = this.m.add(new J(1)).iushrn(2);
          return this.pow(ne, ce);
        }
        for (var le = this.m.subn(1), pe = 0; !le.isZero() && le.andln(1) === 0; )
          pe++, le.iushrn(1);
        $(!le.isZero());
        var ye = new J(1).toRed(this), Ce = ye.redNeg(), be = this.m.subn(1).iushrn(1), ae = this.m.bitLength();
        for (ae = new J(2 * ae * ae).toRed(this); this.pow(ae, be).cmp(Ce) !== 0; )
          ae.redIAdd(Ce);
        for (var ge = this.pow(ae, le), Se = this.pow(ne, le.addn(1).iushrn(1)), Le = this.pow(ne, le), ze = pe; Le.cmp(ye) !== 0; ) {
          for (var Re = Le, We = 0; Re.cmp(ye) !== 0; We++)
            Re = Re.redSqr();
          $(We < ze);
          var Be = this.pow(ge, new J(1).iushln(ze - We - 1));
          Se = Se.redMul(Be), ge = Be.redSqr(), Le = Le.redMul(ge), ze = We;
        }
        return Se;
      }, De.prototype.invm = function(ne) {
        var oe = ne._invmp(this.m);
        return oe.negative !== 0 ? (oe.negative = 0, this.imod(oe).redNeg()) : this.imod(oe);
      }, De.prototype.pow = function(ne, oe) {
        if (oe.isZero()) return new J(1).toRed(this);
        if (oe.cmpn(1) === 0) return ne.clone();
        var ce = 4, le = new Array(1 << ce);
        le[0] = new J(1).toRed(this), le[1] = ne;
        for (var pe = 2; pe < le.length; pe++)
          le[pe] = this.mul(le[pe - 1], ne);
        var ye = le[0], Ce = 0, be = 0, ae = oe.bitLength() % 26;
        for (ae === 0 && (ae = 26), pe = oe.length - 1; pe >= 0; pe--) {
          for (var ge = oe.words[pe], Se = ae - 1; Se >= 0; Se--) {
            var Le = ge >> Se & 1;
            if (ye !== le[0] && (ye = this.sqr(ye)), Le === 0 && Ce === 0) {
              be = 0;
              continue;
            }
            Ce <<= 1, Ce |= Le, be++, !(be !== ce && (pe !== 0 || Se !== 0)) && (ye = this.mul(ye, le[Ce]), be = 0, Ce = 0);
          }
          ae = 26;
        }
        return ye;
      }, De.prototype.convertTo = function(ne) {
        var oe = ne.umod(this.m);
        return oe === ne ? oe.clone() : oe;
      }, De.prototype.convertFrom = function(ne) {
        var oe = ne.clone();
        return oe.red = null, oe;
      }, J.mont = function(ne) {
        return new Fe(ne);
      };
      function Fe(Ae) {
        De.call(this, Ae), this.shift = this.m.bitLength(), this.shift % 26 !== 0 && (this.shift += 26 - this.shift % 26), this.r = new J(1).iushln(this.shift), this.r2 = this.imod(this.r.sqr()), this.rinv = this.r._invmp(this.m), this.minv = this.rinv.mul(this.r).isubn(1).div(this.m), this.minv = this.minv.umod(this.r), this.minv = this.r.sub(this.minv);
      }
      V(Fe, De), Fe.prototype.convertTo = function(ne) {
        return this.imod(ne.ushln(this.shift));
      }, Fe.prototype.convertFrom = function(ne) {
        var oe = this.imod(ne.mul(this.rinv));
        return oe.red = null, oe;
      }, Fe.prototype.imul = function(ne, oe) {
        if (ne.isZero() || oe.isZero())
          return ne.words[0] = 0, ne.length = 1, ne;
        var ce = ne.imul(oe), le = ce.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m), pe = ce.isub(le).iushrn(this.shift), ye = pe;
        return pe.cmp(this.m) >= 0 ? ye = pe.isub(this.m) : pe.cmpn(0) < 0 && (ye = pe.iadd(this.m)), ye._forceRed(this);
      }, Fe.prototype.mul = function(ne, oe) {
        if (ne.isZero() || oe.isZero()) return new J(0)._forceRed(this);
        var ce = ne.mul(oe), le = ce.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m), pe = ce.isub(le).iushrn(this.shift), ye = pe;
        return pe.cmp(this.m) >= 0 ? ye = pe.isub(this.m) : pe.cmpn(0) < 0 && (ye = pe.iadd(this.m)), ye._forceRed(this);
      }, Fe.prototype.invm = function(ne) {
        var oe = this.imod(ne._invmp(this.m).mul(this.r2));
        return oe._forceRed(this);
      };
    })(C, commonjsGlobal$1);
  }(bn)), bn.exports;
}
var withPublic_1, hasRequiredWithPublic;
function requireWithPublic() {
  if (hasRequiredWithPublic) return withPublic_1;
  hasRequiredWithPublic = 1;
  var C = requireBn(), e = safeBufferExports.Buffer;
  function T($, V) {
    return e.from($.toRed(C.mont(V.modulus)).redPow(new C(V.publicExponent)).fromRed().toArray());
  }
  return withPublic_1 = T, withPublic_1;
}
var publicEncrypt, hasRequiredPublicEncrypt;
function requirePublicEncrypt() {
  if (hasRequiredPublicEncrypt) return publicEncrypt;
  hasRequiredPublicEncrypt = 1;
  var C = requireParseAsn1(), e = requireBrowser$b(), T = requireBrowser$9(), $ = requireMgf(), V = requireXor(), J = requireBn(), ee = requireWithPublic(), te = requireBrowserifyRsa(), re = safeBufferExports.Buffer;
  publicEncrypt = function(fe, he, me) {
    var xe;
    fe.padding ? xe = fe.padding : me ? xe = 1 : xe = 4;
    var ve = C(fe), Te;
    if (xe === 4)
      Te = ie(ve, he);
    else if (xe === 1)
      Te = se(ve, he, me);
    else if (xe === 3) {
      if (Te = new J(he), Te.cmp(ve.modulus) >= 0)
        throw new Error("data too long for modulus");
    } else
      throw new Error("unknown padding");
    return me ? te(Te, ve) : ee(Te, ve);
  };
  function ie(ue, fe) {
    var he = ue.modulus.byteLength(), me = fe.length, xe = T("sha1").update(re.alloc(0)).digest(), ve = xe.length, Te = 2 * ve;
    if (me > he - Te - 2)
      throw new Error("message too long");
    var we = re.alloc(he - me - Te - 2), Ee = he - ve - 1, Me = e(ve), Ie = V(re.concat([xe, we, re.alloc(1, 1), fe], Ee), $(Me, Ee)), ke = V(Me, $(Ie, ve));
    return new J(re.concat([re.alloc(1), ke, Ie], he));
  }
  function se(ue, fe, he) {
    var me = fe.length, xe = ue.modulus.byteLength();
    if (me > xe - 11)
      throw new Error("message too long");
    var ve;
    return he ? ve = re.alloc(xe - me - 3, 255) : ve = de(xe - me - 3), new J(re.concat([re.from([0, he ? 1 : 2]), ve, re.alloc(1), fe], xe));
  }
  function de(ue) {
    for (var fe = re.allocUnsafe(ue), he = 0, me = e(ue * 2), xe = 0, ve; he < ue; )
      xe === me.length && (me = e(ue * 2), xe = 0), ve = me[xe++], ve && (fe[he++] = ve);
    return fe;
  }
  return publicEncrypt;
}
var privateDecrypt, hasRequiredPrivateDecrypt;
function requirePrivateDecrypt() {
  if (hasRequiredPrivateDecrypt) return privateDecrypt;
  hasRequiredPrivateDecrypt = 1;
  var C = requireParseAsn1(), e = requireMgf(), T = requireXor(), $ = requireBn(), V = requireBrowserifyRsa(), J = requireBrowser$9(), ee = requireWithPublic(), te = safeBufferExports.Buffer;
  privateDecrypt = function(ue, fe, he) {
    var me;
    ue.padding ? me = ue.padding : he ? me = 1 : me = 4;
    var xe = C(ue), ve = xe.modulus.byteLength();
    if (fe.length > ve || new $(fe).cmp(xe.modulus) >= 0)
      throw new Error("decryption error");
    var Te;
    he ? Te = ee(new $(fe), xe) : Te = V(fe, xe);
    var we = te.alloc(ve - Te.length);
    if (Te = te.concat([we, Te], ve), me === 4)
      return re(xe, Te);
    if (me === 1)
      return ie(xe, Te, he);
    if (me === 3)
      return Te;
    throw new Error("unknown padding");
  };
  function re(de, ue) {
    var fe = de.modulus.byteLength(), he = J("sha1").update(te.alloc(0)).digest(), me = he.length;
    if (ue[0] !== 0)
      throw new Error("decryption error");
    var xe = ue.slice(1, me + 1), ve = ue.slice(me + 1), Te = T(xe, e(ve, me)), we = T(ve, e(Te, fe - me - 1));
    if (se(he, we.slice(0, me)))
      throw new Error("decryption error");
    for (var Ee = me; we[Ee] === 0; )
      Ee++;
    if (we[Ee++] !== 1)
      throw new Error("decryption error");
    return we.slice(Ee);
  }
  function ie(de, ue, fe) {
    for (var he = ue.slice(0, 2), me = 2, xe = 0; ue[me++] !== 0; )
      if (me >= ue.length) {
        xe++;
        break;
      }
    var ve = ue.slice(2, me - 1);
    if ((he.toString("hex") !== "0002" && !fe || he.toString("hex") !== "0001" && fe) && xe++, ve.length < 8 && xe++, xe)
      throw new Error("decryption error");
    return ue.slice(me);
  }
  function se(de, ue) {
    de = te.from(de), ue = te.from(ue);
    var fe = 0, he = de.length;
    de.length !== ue.length && (fe++, he = Math.min(de.length, ue.length));
    for (var me = -1; ++me < he; )
      fe += de[me] ^ ue[me];
    return fe;
  }
  return privateDecrypt;
}
var hasRequiredBrowser$1;
function requireBrowser$1() {
  return hasRequiredBrowser$1 || (hasRequiredBrowser$1 = 1, function(C) {
    C.publicEncrypt = requirePublicEncrypt(), C.privateDecrypt = requirePrivateDecrypt(), C.privateEncrypt = function(T, $) {
      return C.publicEncrypt(T, $, !0);
    }, C.publicDecrypt = function(T, $) {
      return C.privateDecrypt(T, $, !0);
    };
  }(browser$3)), browser$3;
}
var browser$2 = {}, hasRequiredBrowser;
function requireBrowser() {
  if (hasRequiredBrowser) return browser$2;
  hasRequiredBrowser = 1;
  function C() {
    throw new Error(`secure random number generation not supported by this browser
use chrome, FireFox or Internet Explorer 11`);
  }
  var e = safeBufferExports, T = requireBrowser$b(), $ = e.Buffer, V = e.kMaxLength, J = commonjsGlobal$1.crypto || commonjsGlobal$1.msCrypto, ee = Math.pow(2, 32) - 1;
  function te(ue, fe) {
    if (typeof ue != "number" || ue !== ue)
      throw new TypeError("offset must be a number");
    if (ue > ee || ue < 0)
      throw new TypeError("offset must be a uint32");
    if (ue > V || ue > fe)
      throw new RangeError("offset out of range");
  }
  function re(ue, fe, he) {
    if (typeof ue != "number" || ue !== ue)
      throw new TypeError("size must be a number");
    if (ue > ee || ue < 0)
      throw new TypeError("size must be a uint32");
    if (ue + fe > he || ue > V)
      throw new RangeError("buffer too small");
  }
  J && J.getRandomValues || !dist$2.process.browser ? (browser$2.randomFill = ie, browser$2.randomFillSync = de) : (browser$2.randomFill = C, browser$2.randomFillSync = C);
  function ie(ue, fe, he, me) {
    if (!$.isBuffer(ue) && !(ue instanceof commonjsGlobal$1.Uint8Array))
      throw new TypeError('"buf" argument must be a Buffer or Uint8Array');
    if (typeof fe == "function")
      me = fe, fe = 0, he = ue.length;
    else if (typeof he == "function")
      me = he, he = ue.length - fe;
    else if (typeof me != "function")
      throw new TypeError('"cb" argument must be a function');
    return te(fe, ue.length), re(he, fe, ue.length), se(ue, fe, he, me);
  }
  function se(ue, fe, he, me) {
    if (dist$2.process.browser) {
      var xe = ue.buffer, ve = new Uint8Array(xe, fe, he);
      if (J.getRandomValues(ve), me) {
        dist$2.process.nextTick(function() {
          me(null, ue);
        });
        return;
      }
      return ue;
    }
    if (me) {
      T(he, function(we, Ee) {
        if (we)
          return me(we);
        Ee.copy(ue, fe), me(null, ue);
      });
      return;
    }
    var Te = T(he);
    return Te.copy(ue, fe), ue;
  }
  function de(ue, fe, he) {
    if (typeof fe > "u" && (fe = 0), !$.isBuffer(ue) && !(ue instanceof commonjsGlobal$1.Uint8Array))
      throw new TypeError('"buf" argument must be a Buffer or Uint8Array');
    return te(fe, ue.length), he === void 0 && (he = ue.length - fe), re(he, fe, ue.length), se(ue, fe, he);
  }
  return browser$2;
}
var hasRequiredCryptoBrowserify;
function requireCryptoBrowserify() {
  if (hasRequiredCryptoBrowserify) return cryptoBrowserify;
  hasRequiredCryptoBrowserify = 1, cryptoBrowserify.randomBytes = cryptoBrowserify.rng = cryptoBrowserify.pseudoRandomBytes = cryptoBrowserify.prng = requireBrowser$b(), cryptoBrowserify.createHash = cryptoBrowserify.Hash = requireBrowser$9(), cryptoBrowserify.createHmac = cryptoBrowserify.Hmac = requireBrowser$8();
  var C = requireAlgos(), e = Object.keys(C), T = [
    "sha1",
    "sha224",
    "sha256",
    "sha384",
    "sha512",
    "md5",
    "rmd160"
  ].concat(e);
  cryptoBrowserify.getHashes = function() {
    return T;
  };
  var $ = requireBrowser$7();
  cryptoBrowserify.pbkdf2 = $.pbkdf2, cryptoBrowserify.pbkdf2Sync = $.pbkdf2Sync;
  var V = requireBrowser$5();
  cryptoBrowserify.Cipher = V.Cipher, cryptoBrowserify.createCipher = V.createCipher, cryptoBrowserify.Cipheriv = V.Cipheriv, cryptoBrowserify.createCipheriv = V.createCipheriv, cryptoBrowserify.Decipher = V.Decipher, cryptoBrowserify.createDecipher = V.createDecipher, cryptoBrowserify.Decipheriv = V.Decipheriv, cryptoBrowserify.createDecipheriv = V.createDecipheriv, cryptoBrowserify.getCiphers = V.getCiphers, cryptoBrowserify.listCiphers = V.listCiphers;
  var J = requireBrowser$4();
  cryptoBrowserify.DiffieHellmanGroup = J.DiffieHellmanGroup, cryptoBrowserify.createDiffieHellmanGroup = J.createDiffieHellmanGroup, cryptoBrowserify.getDiffieHellman = J.getDiffieHellman, cryptoBrowserify.createDiffieHellman = J.createDiffieHellman, cryptoBrowserify.DiffieHellman = J.DiffieHellman;
  var ee = requireBrowser$3();
  cryptoBrowserify.createSign = ee.createSign, cryptoBrowserify.Sign = ee.Sign, cryptoBrowserify.createVerify = ee.createVerify, cryptoBrowserify.Verify = ee.Verify, cryptoBrowserify.createECDH = requireBrowser$2();
  var te = requireBrowser$1();
  cryptoBrowserify.publicEncrypt = te.publicEncrypt, cryptoBrowserify.privateEncrypt = te.privateEncrypt, cryptoBrowserify.publicDecrypt = te.publicDecrypt, cryptoBrowserify.privateDecrypt = te.privateDecrypt;
  var re = requireBrowser();
  return cryptoBrowserify.randomFill = re.randomFill, cryptoBrowserify.randomFillSync = re.randomFillSync, cryptoBrowserify.createCredentials = function() {
    throw new Error(`sorry, createCredentials is not implemented yet
we accept pull requests
https://github.com/browserify/crypto-browserify`);
  }, cryptoBrowserify.constants = {
    DH_CHECK_P_NOT_SAFE_PRIME: 2,
    DH_CHECK_P_NOT_PRIME: 1,
    DH_UNABLE_TO_CHECK_GENERATOR: 4,
    DH_NOT_SUITABLE_GENERATOR: 8,
    NPN_ENABLED: 1,
    ALPN_ENABLED: 1,
    RSA_PKCS1_PADDING: 1,
    RSA_SSLV23_PADDING: 2,
    RSA_NO_PADDING: 3,
    RSA_PKCS1_OAEP_PADDING: 4,
    RSA_X931_PADDING: 5,
    RSA_PKCS1_PSS_PADDING: 6,
    POINT_CONVERSION_COMPRESSED: 2,
    POINT_CONVERSION_UNCOMPRESSED: 4,
    POINT_CONVERSION_HYBRID: 6
  }, cryptoBrowserify;
}
(function(C) {
  (function(e) {
    var T = function(Ke) {
      var Qe, et = new Float64Array(16);
      if (Ke) for (Qe = 0; Qe < Ke.length; Qe++) et[Qe] = Ke[Qe];
      return et;
    }, $ = function() {
      throw new Error("no PRNG");
    }, V = new Uint8Array(16), J = new Uint8Array(32);
    J[0] = 9;
    var ee = T(), te = T([1]), re = T([56129, 1]), ie = T([30883, 4953, 19914, 30187, 55467, 16705, 2637, 112, 59544, 30585, 16505, 36039, 65139, 11119, 27886, 20995]), se = T([61785, 9906, 39828, 60374, 45398, 33411, 5274, 224, 53552, 61171, 33010, 6542, 64743, 22239, 55772, 9222]), de = T([54554, 36645, 11616, 51542, 42930, 38181, 51040, 26924, 56412, 64982, 57905, 49316, 21502, 52590, 14035, 8553]), ue = T([26200, 26214, 26214, 26214, 26214, 26214, 26214, 26214, 26214, 26214, 26214, 26214, 26214, 26214, 26214, 26214]), fe = T([41136, 18958, 6951, 50414, 58488, 44335, 6150, 12099, 55207, 15867, 153, 11085, 57099, 20417, 9344, 11139]);
    function he(Ke, Qe, et, He) {
      Ke[Qe] = et >> 24 & 255, Ke[Qe + 1] = et >> 16 & 255, Ke[Qe + 2] = et >> 8 & 255, Ke[Qe + 3] = et & 255, Ke[Qe + 4] = He >> 24 & 255, Ke[Qe + 5] = He >> 16 & 255, Ke[Qe + 6] = He >> 8 & 255, Ke[Qe + 7] = He & 255;
    }
    function me(Ke, Qe, et, He, nt) {
      var qe, ht = 0;
      for (qe = 0; qe < nt; qe++) ht |= Ke[Qe + qe] ^ et[He + qe];
      return (1 & ht - 1 >>> 8) - 1;
    }
    function xe(Ke, Qe, et, He) {
      return me(Ke, Qe, et, He, 16);
    }
    function ve(Ke, Qe, et, He) {
      return me(Ke, Qe, et, He, 32);
    }
    function Te(Ke, Qe, et, He) {
      for (var nt = He[0] & 255 | (He[1] & 255) << 8 | (He[2] & 255) << 16 | (He[3] & 255) << 24, qe = et[0] & 255 | (et[1] & 255) << 8 | (et[2] & 255) << 16 | (et[3] & 255) << 24, ht = et[4] & 255 | (et[5] & 255) << 8 | (et[6] & 255) << 16 | (et[7] & 255) << 24, pt = et[8] & 255 | (et[9] & 255) << 8 | (et[10] & 255) << 16 | (et[11] & 255) << 24, bt = et[12] & 255 | (et[13] & 255) << 8 | (et[14] & 255) << 16 | (et[15] & 255) << 24, jt = He[4] & 255 | (He[5] & 255) << 8 | (He[6] & 255) << 16 | (He[7] & 255) << 24, $t = Qe[0] & 255 | (Qe[1] & 255) << 8 | (Qe[2] & 255) << 16 | (Qe[3] & 255) << 24, Jt = Qe[4] & 255 | (Qe[5] & 255) << 8 | (Qe[6] & 255) << 16 | (Qe[7] & 255) << 24, zt = Qe[8] & 255 | (Qe[9] & 255) << 8 | (Qe[10] & 255) << 16 | (Qe[11] & 255) << 24, Vt = Qe[12] & 255 | (Qe[13] & 255) << 8 | (Qe[14] & 255) << 16 | (Qe[15] & 255) << 24, Kt = He[8] & 255 | (He[9] & 255) << 8 | (He[10] & 255) << 16 | (He[11] & 255) << 24, pn = et[16] & 255 | (et[17] & 255) << 8 | (et[18] & 255) << 16 | (et[19] & 255) << 24, An = et[20] & 255 | (et[21] & 255) << 8 | (et[22] & 255) << 16 | (et[23] & 255) << 24, vn = et[24] & 255 | (et[25] & 255) << 8 | (et[26] & 255) << 16 | (et[27] & 255) << 24, Cn = et[28] & 255 | (et[29] & 255) << 8 | (et[30] & 255) << 16 | (et[31] & 255) << 24, yn = He[12] & 255 | (He[13] & 255) << 8 | (He[14] & 255) << 16 | (He[15] & 255) << 24, dn = nt, xn = qe, ln = ht, mn = pt, gn = bt, cn = jt, Pt = $t, Rt = Jt, sn = zt, qt = Vt, Zt = Kt, hn = pn, Mn = An, Sn = vn, Dn = Cn, kn = yn, Et, Pn = 0; Pn < 20; Pn += 2)
        Et = dn + Mn | 0, gn ^= Et << 7 | Et >>> 25, Et = gn + dn | 0, sn ^= Et << 9 | Et >>> 23, Et = sn + gn | 0, Mn ^= Et << 13 | Et >>> 19, Et = Mn + sn | 0, dn ^= Et << 18 | Et >>> 14, Et = cn + xn | 0, qt ^= Et << 7 | Et >>> 25, Et = qt + cn | 0, Sn ^= Et << 9 | Et >>> 23, Et = Sn + qt | 0, xn ^= Et << 13 | Et >>> 19, Et = xn + Sn | 0, cn ^= Et << 18 | Et >>> 14, Et = Zt + Pt | 0, Dn ^= Et << 7 | Et >>> 25, Et = Dn + Zt | 0, ln ^= Et << 9 | Et >>> 23, Et = ln + Dn | 0, Pt ^= Et << 13 | Et >>> 19, Et = Pt + ln | 0, Zt ^= Et << 18 | Et >>> 14, Et = kn + hn | 0, mn ^= Et << 7 | Et >>> 25, Et = mn + kn | 0, Rt ^= Et << 9 | Et >>> 23, Et = Rt + mn | 0, hn ^= Et << 13 | Et >>> 19, Et = hn + Rt | 0, kn ^= Et << 18 | Et >>> 14, Et = dn + mn | 0, xn ^= Et << 7 | Et >>> 25, Et = xn + dn | 0, ln ^= Et << 9 | Et >>> 23, Et = ln + xn | 0, mn ^= Et << 13 | Et >>> 19, Et = mn + ln | 0, dn ^= Et << 18 | Et >>> 14, Et = cn + gn | 0, Pt ^= Et << 7 | Et >>> 25, Et = Pt + cn | 0, Rt ^= Et << 9 | Et >>> 23, Et = Rt + Pt | 0, gn ^= Et << 13 | Et >>> 19, Et = gn + Rt | 0, cn ^= Et << 18 | Et >>> 14, Et = Zt + qt | 0, hn ^= Et << 7 | Et >>> 25, Et = hn + Zt | 0, sn ^= Et << 9 | Et >>> 23, Et = sn + hn | 0, qt ^= Et << 13 | Et >>> 19, Et = qt + sn | 0, Zt ^= Et << 18 | Et >>> 14, Et = kn + Dn | 0, Mn ^= Et << 7 | Et >>> 25, Et = Mn + kn | 0, Sn ^= Et << 9 | Et >>> 23, Et = Sn + Mn | 0, Dn ^= Et << 13 | Et >>> 19, Et = Dn + Sn | 0, kn ^= Et << 18 | Et >>> 14;
      dn = dn + nt | 0, xn = xn + qe | 0, ln = ln + ht | 0, mn = mn + pt | 0, gn = gn + bt | 0, cn = cn + jt | 0, Pt = Pt + $t | 0, Rt = Rt + Jt | 0, sn = sn + zt | 0, qt = qt + Vt | 0, Zt = Zt + Kt | 0, hn = hn + pn | 0, Mn = Mn + An | 0, Sn = Sn + vn | 0, Dn = Dn + Cn | 0, kn = kn + yn | 0, Ke[0] = dn >>> 0 & 255, Ke[1] = dn >>> 8 & 255, Ke[2] = dn >>> 16 & 255, Ke[3] = dn >>> 24 & 255, Ke[4] = xn >>> 0 & 255, Ke[5] = xn >>> 8 & 255, Ke[6] = xn >>> 16 & 255, Ke[7] = xn >>> 24 & 255, Ke[8] = ln >>> 0 & 255, Ke[9] = ln >>> 8 & 255, Ke[10] = ln >>> 16 & 255, Ke[11] = ln >>> 24 & 255, Ke[12] = mn >>> 0 & 255, Ke[13] = mn >>> 8 & 255, Ke[14] = mn >>> 16 & 255, Ke[15] = mn >>> 24 & 255, Ke[16] = gn >>> 0 & 255, Ke[17] = gn >>> 8 & 255, Ke[18] = gn >>> 16 & 255, Ke[19] = gn >>> 24 & 255, Ke[20] = cn >>> 0 & 255, Ke[21] = cn >>> 8 & 255, Ke[22] = cn >>> 16 & 255, Ke[23] = cn >>> 24 & 255, Ke[24] = Pt >>> 0 & 255, Ke[25] = Pt >>> 8 & 255, Ke[26] = Pt >>> 16 & 255, Ke[27] = Pt >>> 24 & 255, Ke[28] = Rt >>> 0 & 255, Ke[29] = Rt >>> 8 & 255, Ke[30] = Rt >>> 16 & 255, Ke[31] = Rt >>> 24 & 255, Ke[32] = sn >>> 0 & 255, Ke[33] = sn >>> 8 & 255, Ke[34] = sn >>> 16 & 255, Ke[35] = sn >>> 24 & 255, Ke[36] = qt >>> 0 & 255, Ke[37] = qt >>> 8 & 255, Ke[38] = qt >>> 16 & 255, Ke[39] = qt >>> 24 & 255, Ke[40] = Zt >>> 0 & 255, Ke[41] = Zt >>> 8 & 255, Ke[42] = Zt >>> 16 & 255, Ke[43] = Zt >>> 24 & 255, Ke[44] = hn >>> 0 & 255, Ke[45] = hn >>> 8 & 255, Ke[46] = hn >>> 16 & 255, Ke[47] = hn >>> 24 & 255, Ke[48] = Mn >>> 0 & 255, Ke[49] = Mn >>> 8 & 255, Ke[50] = Mn >>> 16 & 255, Ke[51] = Mn >>> 24 & 255, Ke[52] = Sn >>> 0 & 255, Ke[53] = Sn >>> 8 & 255, Ke[54] = Sn >>> 16 & 255, Ke[55] = Sn >>> 24 & 255, Ke[56] = Dn >>> 0 & 255, Ke[57] = Dn >>> 8 & 255, Ke[58] = Dn >>> 16 & 255, Ke[59] = Dn >>> 24 & 255, Ke[60] = kn >>> 0 & 255, Ke[61] = kn >>> 8 & 255, Ke[62] = kn >>> 16 & 255, Ke[63] = kn >>> 24 & 255;
    }
    function we(Ke, Qe, et, He) {
      for (var nt = He[0] & 255 | (He[1] & 255) << 8 | (He[2] & 255) << 16 | (He[3] & 255) << 24, qe = et[0] & 255 | (et[1] & 255) << 8 | (et[2] & 255) << 16 | (et[3] & 255) << 24, ht = et[4] & 255 | (et[5] & 255) << 8 | (et[6] & 255) << 16 | (et[7] & 255) << 24, pt = et[8] & 255 | (et[9] & 255) << 8 | (et[10] & 255) << 16 | (et[11] & 255) << 24, bt = et[12] & 255 | (et[13] & 255) << 8 | (et[14] & 255) << 16 | (et[15] & 255) << 24, jt = He[4] & 255 | (He[5] & 255) << 8 | (He[6] & 255) << 16 | (He[7] & 255) << 24, $t = Qe[0] & 255 | (Qe[1] & 255) << 8 | (Qe[2] & 255) << 16 | (Qe[3] & 255) << 24, Jt = Qe[4] & 255 | (Qe[5] & 255) << 8 | (Qe[6] & 255) << 16 | (Qe[7] & 255) << 24, zt = Qe[8] & 255 | (Qe[9] & 255) << 8 | (Qe[10] & 255) << 16 | (Qe[11] & 255) << 24, Vt = Qe[12] & 255 | (Qe[13] & 255) << 8 | (Qe[14] & 255) << 16 | (Qe[15] & 255) << 24, Kt = He[8] & 255 | (He[9] & 255) << 8 | (He[10] & 255) << 16 | (He[11] & 255) << 24, pn = et[16] & 255 | (et[17] & 255) << 8 | (et[18] & 255) << 16 | (et[19] & 255) << 24, An = et[20] & 255 | (et[21] & 255) << 8 | (et[22] & 255) << 16 | (et[23] & 255) << 24, vn = et[24] & 255 | (et[25] & 255) << 8 | (et[26] & 255) << 16 | (et[27] & 255) << 24, Cn = et[28] & 255 | (et[29] & 255) << 8 | (et[30] & 255) << 16 | (et[31] & 255) << 24, yn = He[12] & 255 | (He[13] & 255) << 8 | (He[14] & 255) << 16 | (He[15] & 255) << 24, dn = nt, xn = qe, ln = ht, mn = pt, gn = bt, cn = jt, Pt = $t, Rt = Jt, sn = zt, qt = Vt, Zt = Kt, hn = pn, Mn = An, Sn = vn, Dn = Cn, kn = yn, Et, Pn = 0; Pn < 20; Pn += 2)
        Et = dn + Mn | 0, gn ^= Et << 7 | Et >>> 25, Et = gn + dn | 0, sn ^= Et << 9 | Et >>> 23, Et = sn + gn | 0, Mn ^= Et << 13 | Et >>> 19, Et = Mn + sn | 0, dn ^= Et << 18 | Et >>> 14, Et = cn + xn | 0, qt ^= Et << 7 | Et >>> 25, Et = qt + cn | 0, Sn ^= Et << 9 | Et >>> 23, Et = Sn + qt | 0, xn ^= Et << 13 | Et >>> 19, Et = xn + Sn | 0, cn ^= Et << 18 | Et >>> 14, Et = Zt + Pt | 0, Dn ^= Et << 7 | Et >>> 25, Et = Dn + Zt | 0, ln ^= Et << 9 | Et >>> 23, Et = ln + Dn | 0, Pt ^= Et << 13 | Et >>> 19, Et = Pt + ln | 0, Zt ^= Et << 18 | Et >>> 14, Et = kn + hn | 0, mn ^= Et << 7 | Et >>> 25, Et = mn + kn | 0, Rt ^= Et << 9 | Et >>> 23, Et = Rt + mn | 0, hn ^= Et << 13 | Et >>> 19, Et = hn + Rt | 0, kn ^= Et << 18 | Et >>> 14, Et = dn + mn | 0, xn ^= Et << 7 | Et >>> 25, Et = xn + dn | 0, ln ^= Et << 9 | Et >>> 23, Et = ln + xn | 0, mn ^= Et << 13 | Et >>> 19, Et = mn + ln | 0, dn ^= Et << 18 | Et >>> 14, Et = cn + gn | 0, Pt ^= Et << 7 | Et >>> 25, Et = Pt + cn | 0, Rt ^= Et << 9 | Et >>> 23, Et = Rt + Pt | 0, gn ^= Et << 13 | Et >>> 19, Et = gn + Rt | 0, cn ^= Et << 18 | Et >>> 14, Et = Zt + qt | 0, hn ^= Et << 7 | Et >>> 25, Et = hn + Zt | 0, sn ^= Et << 9 | Et >>> 23, Et = sn + hn | 0, qt ^= Et << 13 | Et >>> 19, Et = qt + sn | 0, Zt ^= Et << 18 | Et >>> 14, Et = kn + Dn | 0, Mn ^= Et << 7 | Et >>> 25, Et = Mn + kn | 0, Sn ^= Et << 9 | Et >>> 23, Et = Sn + Mn | 0, Dn ^= Et << 13 | Et >>> 19, Et = Dn + Sn | 0, kn ^= Et << 18 | Et >>> 14;
      Ke[0] = dn >>> 0 & 255, Ke[1] = dn >>> 8 & 255, Ke[2] = dn >>> 16 & 255, Ke[3] = dn >>> 24 & 255, Ke[4] = cn >>> 0 & 255, Ke[5] = cn >>> 8 & 255, Ke[6] = cn >>> 16 & 255, Ke[7] = cn >>> 24 & 255, Ke[8] = Zt >>> 0 & 255, Ke[9] = Zt >>> 8 & 255, Ke[10] = Zt >>> 16 & 255, Ke[11] = Zt >>> 24 & 255, Ke[12] = kn >>> 0 & 255, Ke[13] = kn >>> 8 & 255, Ke[14] = kn >>> 16 & 255, Ke[15] = kn >>> 24 & 255, Ke[16] = Pt >>> 0 & 255, Ke[17] = Pt >>> 8 & 255, Ke[18] = Pt >>> 16 & 255, Ke[19] = Pt >>> 24 & 255, Ke[20] = Rt >>> 0 & 255, Ke[21] = Rt >>> 8 & 255, Ke[22] = Rt >>> 16 & 255, Ke[23] = Rt >>> 24 & 255, Ke[24] = sn >>> 0 & 255, Ke[25] = sn >>> 8 & 255, Ke[26] = sn >>> 16 & 255, Ke[27] = sn >>> 24 & 255, Ke[28] = qt >>> 0 & 255, Ke[29] = qt >>> 8 & 255, Ke[30] = qt >>> 16 & 255, Ke[31] = qt >>> 24 & 255;
    }
    function Ee(Ke, Qe, et, He) {
      Te(Ke, Qe, et, He);
    }
    function Me(Ke, Qe, et, He) {
      we(Ke, Qe, et, He);
    }
    var Ie = new Uint8Array([101, 120, 112, 97, 110, 100, 32, 51, 50, 45, 98, 121, 116, 101, 32, 107]);
    function ke(Ke, Qe, et, He, nt, qe, ht) {
      var pt = new Uint8Array(16), bt = new Uint8Array(64), jt, $t;
      for ($t = 0; $t < 16; $t++) pt[$t] = 0;
      for ($t = 0; $t < 8; $t++) pt[$t] = qe[$t];
      for (; nt >= 64; ) {
        for (Ee(bt, pt, ht, Ie), $t = 0; $t < 64; $t++) Ke[Qe + $t] = et[He + $t] ^ bt[$t];
        for (jt = 1, $t = 8; $t < 16; $t++)
          jt = jt + (pt[$t] & 255) | 0, pt[$t] = jt & 255, jt >>>= 8;
        nt -= 64, Qe += 64, He += 64;
      }
      if (nt > 0)
        for (Ee(bt, pt, ht, Ie), $t = 0; $t < nt; $t++) Ke[Qe + $t] = et[He + $t] ^ bt[$t];
      return 0;
    }
    function _e(Ke, Qe, et, He, nt) {
      var qe = new Uint8Array(16), ht = new Uint8Array(64), pt, bt;
      for (bt = 0; bt < 16; bt++) qe[bt] = 0;
      for (bt = 0; bt < 8; bt++) qe[bt] = He[bt];
      for (; et >= 64; ) {
        for (Ee(ht, qe, nt, Ie), bt = 0; bt < 64; bt++) Ke[Qe + bt] = ht[bt];
        for (pt = 1, bt = 8; bt < 16; bt++)
          pt = pt + (qe[bt] & 255) | 0, qe[bt] = pt & 255, pt >>>= 8;
        et -= 64, Qe += 64;
      }
      if (et > 0)
        for (Ee(ht, qe, nt, Ie), bt = 0; bt < et; bt++) Ke[Qe + bt] = ht[bt];
      return 0;
    }
    function De(Ke, Qe, et, He, nt) {
      var qe = new Uint8Array(32);
      Me(qe, He, nt, Ie);
      for (var ht = new Uint8Array(8), pt = 0; pt < 8; pt++) ht[pt] = He[pt + 16];
      return _e(Ke, Qe, et, ht, qe);
    }
    function Fe(Ke, Qe, et, He, nt, qe, ht) {
      var pt = new Uint8Array(32);
      Me(pt, qe, ht, Ie);
      for (var bt = new Uint8Array(8), jt = 0; jt < 8; jt++) bt[jt] = qe[jt + 16];
      return ke(Ke, Qe, et, He, nt, bt, pt);
    }
    var Ae = function(Ke) {
      this.buffer = new Uint8Array(16), this.r = new Uint16Array(10), this.h = new Uint16Array(10), this.pad = new Uint16Array(8), this.leftover = 0, this.fin = 0;
      var Qe, et, He, nt, qe, ht, pt, bt;
      Qe = Ke[0] & 255 | (Ke[1] & 255) << 8, this.r[0] = Qe & 8191, et = Ke[2] & 255 | (Ke[3] & 255) << 8, this.r[1] = (Qe >>> 13 | et << 3) & 8191, He = Ke[4] & 255 | (Ke[5] & 255) << 8, this.r[2] = (et >>> 10 | He << 6) & 7939, nt = Ke[6] & 255 | (Ke[7] & 255) << 8, this.r[3] = (He >>> 7 | nt << 9) & 8191, qe = Ke[8] & 255 | (Ke[9] & 255) << 8, this.r[4] = (nt >>> 4 | qe << 12) & 255, this.r[5] = qe >>> 1 & 8190, ht = Ke[10] & 255 | (Ke[11] & 255) << 8, this.r[6] = (qe >>> 14 | ht << 2) & 8191, pt = Ke[12] & 255 | (Ke[13] & 255) << 8, this.r[7] = (ht >>> 11 | pt << 5) & 8065, bt = Ke[14] & 255 | (Ke[15] & 255) << 8, this.r[8] = (pt >>> 8 | bt << 8) & 8191, this.r[9] = bt >>> 5 & 127, this.pad[0] = Ke[16] & 255 | (Ke[17] & 255) << 8, this.pad[1] = Ke[18] & 255 | (Ke[19] & 255) << 8, this.pad[2] = Ke[20] & 255 | (Ke[21] & 255) << 8, this.pad[3] = Ke[22] & 255 | (Ke[23] & 255) << 8, this.pad[4] = Ke[24] & 255 | (Ke[25] & 255) << 8, this.pad[5] = Ke[26] & 255 | (Ke[27] & 255) << 8, this.pad[6] = Ke[28] & 255 | (Ke[29] & 255) << 8, this.pad[7] = Ke[30] & 255 | (Ke[31] & 255) << 8;
    };
    Ae.prototype.blocks = function(Ke, Qe, et) {
      for (var He = this.fin ? 0 : 2048, nt, qe, ht, pt, bt, jt, $t, Jt, zt, Vt, Kt, pn, An, vn, Cn, yn, dn, xn, ln, mn = this.h[0], gn = this.h[1], cn = this.h[2], Pt = this.h[3], Rt = this.h[4], sn = this.h[5], qt = this.h[6], Zt = this.h[7], hn = this.h[8], Mn = this.h[9], Sn = this.r[0], Dn = this.r[1], kn = this.r[2], Et = this.r[3], Pn = this.r[4], Bn = this.r[5], jn = this.r[6], Nn = this.r[7], Ln = this.r[8], _n = this.r[9]; et >= 16; )
        nt = Ke[Qe + 0] & 255 | (Ke[Qe + 1] & 255) << 8, mn += nt & 8191, qe = Ke[Qe + 2] & 255 | (Ke[Qe + 3] & 255) << 8, gn += (nt >>> 13 | qe << 3) & 8191, ht = Ke[Qe + 4] & 255 | (Ke[Qe + 5] & 255) << 8, cn += (qe >>> 10 | ht << 6) & 8191, pt = Ke[Qe + 6] & 255 | (Ke[Qe + 7] & 255) << 8, Pt += (ht >>> 7 | pt << 9) & 8191, bt = Ke[Qe + 8] & 255 | (Ke[Qe + 9] & 255) << 8, Rt += (pt >>> 4 | bt << 12) & 8191, sn += bt >>> 1 & 8191, jt = Ke[Qe + 10] & 255 | (Ke[Qe + 11] & 255) << 8, qt += (bt >>> 14 | jt << 2) & 8191, $t = Ke[Qe + 12] & 255 | (Ke[Qe + 13] & 255) << 8, Zt += (jt >>> 11 | $t << 5) & 8191, Jt = Ke[Qe + 14] & 255 | (Ke[Qe + 15] & 255) << 8, hn += ($t >>> 8 | Jt << 8) & 8191, Mn += Jt >>> 5 | He, zt = 0, Vt = zt, Vt += mn * Sn, Vt += gn * (5 * _n), Vt += cn * (5 * Ln), Vt += Pt * (5 * Nn), Vt += Rt * (5 * jn), zt = Vt >>> 13, Vt &= 8191, Vt += sn * (5 * Bn), Vt += qt * (5 * Pn), Vt += Zt * (5 * Et), Vt += hn * (5 * kn), Vt += Mn * (5 * Dn), zt += Vt >>> 13, Vt &= 8191, Kt = zt, Kt += mn * Dn, Kt += gn * Sn, Kt += cn * (5 * _n), Kt += Pt * (5 * Ln), Kt += Rt * (5 * Nn), zt = Kt >>> 13, Kt &= 8191, Kt += sn * (5 * jn), Kt += qt * (5 * Bn), Kt += Zt * (5 * Pn), Kt += hn * (5 * Et), Kt += Mn * (5 * kn), zt += Kt >>> 13, Kt &= 8191, pn = zt, pn += mn * kn, pn += gn * Dn, pn += cn * Sn, pn += Pt * (5 * _n), pn += Rt * (5 * Ln), zt = pn >>> 13, pn &= 8191, pn += sn * (5 * Nn), pn += qt * (5 * jn), pn += Zt * (5 * Bn), pn += hn * (5 * Pn), pn += Mn * (5 * Et), zt += pn >>> 13, pn &= 8191, An = zt, An += mn * Et, An += gn * kn, An += cn * Dn, An += Pt * Sn, An += Rt * (5 * _n), zt = An >>> 13, An &= 8191, An += sn * (5 * Ln), An += qt * (5 * Nn), An += Zt * (5 * jn), An += hn * (5 * Bn), An += Mn * (5 * Pn), zt += An >>> 13, An &= 8191, vn = zt, vn += mn * Pn, vn += gn * Et, vn += cn * kn, vn += Pt * Dn, vn += Rt * Sn, zt = vn >>> 13, vn &= 8191, vn += sn * (5 * _n), vn += qt * (5 * Ln), vn += Zt * (5 * Nn), vn += hn * (5 * jn), vn += Mn * (5 * Bn), zt += vn >>> 13, vn &= 8191, Cn = zt, Cn += mn * Bn, Cn += gn * Pn, Cn += cn * Et, Cn += Pt * kn, Cn += Rt * Dn, zt = Cn >>> 13, Cn &= 8191, Cn += sn * Sn, Cn += qt * (5 * _n), Cn += Zt * (5 * Ln), Cn += hn * (5 * Nn), Cn += Mn * (5 * jn), zt += Cn >>> 13, Cn &= 8191, yn = zt, yn += mn * jn, yn += gn * Bn, yn += cn * Pn, yn += Pt * Et, yn += Rt * kn, zt = yn >>> 13, yn &= 8191, yn += sn * Dn, yn += qt * Sn, yn += Zt * (5 * _n), yn += hn * (5 * Ln), yn += Mn * (5 * Nn), zt += yn >>> 13, yn &= 8191, dn = zt, dn += mn * Nn, dn += gn * jn, dn += cn * Bn, dn += Pt * Pn, dn += Rt * Et, zt = dn >>> 13, dn &= 8191, dn += sn * kn, dn += qt * Dn, dn += Zt * Sn, dn += hn * (5 * _n), dn += Mn * (5 * Ln), zt += dn >>> 13, dn &= 8191, xn = zt, xn += mn * Ln, xn += gn * Nn, xn += cn * jn, xn += Pt * Bn, xn += Rt * Pn, zt = xn >>> 13, xn &= 8191, xn += sn * Et, xn += qt * kn, xn += Zt * Dn, xn += hn * Sn, xn += Mn * (5 * _n), zt += xn >>> 13, xn &= 8191, ln = zt, ln += mn * _n, ln += gn * Ln, ln += cn * Nn, ln += Pt * jn, ln += Rt * Bn, zt = ln >>> 13, ln &= 8191, ln += sn * Pn, ln += qt * Et, ln += Zt * kn, ln += hn * Dn, ln += Mn * Sn, zt += ln >>> 13, ln &= 8191, zt = (zt << 2) + zt | 0, zt = zt + Vt | 0, Vt = zt & 8191, zt = zt >>> 13, Kt += zt, mn = Vt, gn = Kt, cn = pn, Pt = An, Rt = vn, sn = Cn, qt = yn, Zt = dn, hn = xn, Mn = ln, Qe += 16, et -= 16;
      this.h[0] = mn, this.h[1] = gn, this.h[2] = cn, this.h[3] = Pt, this.h[4] = Rt, this.h[5] = sn, this.h[6] = qt, this.h[7] = Zt, this.h[8] = hn, this.h[9] = Mn;
    }, Ae.prototype.finish = function(Ke, Qe) {
      var et = new Uint16Array(10), He, nt, qe, ht;
      if (this.leftover) {
        for (ht = this.leftover, this.buffer[ht++] = 1; ht < 16; ht++) this.buffer[ht] = 0;
        this.fin = 1, this.blocks(this.buffer, 0, 16);
      }
      for (He = this.h[1] >>> 13, this.h[1] &= 8191, ht = 2; ht < 10; ht++)
        this.h[ht] += He, He = this.h[ht] >>> 13, this.h[ht] &= 8191;
      for (this.h[0] += He * 5, He = this.h[0] >>> 13, this.h[0] &= 8191, this.h[1] += He, He = this.h[1] >>> 13, this.h[1] &= 8191, this.h[2] += He, et[0] = this.h[0] + 5, He = et[0] >>> 13, et[0] &= 8191, ht = 1; ht < 10; ht++)
        et[ht] = this.h[ht] + He, He = et[ht] >>> 13, et[ht] &= 8191;
      for (et[9] -= 8192, nt = (He ^ 1) - 1, ht = 0; ht < 10; ht++) et[ht] &= nt;
      for (nt = ~nt, ht = 0; ht < 10; ht++) this.h[ht] = this.h[ht] & nt | et[ht];
      for (this.h[0] = (this.h[0] | this.h[1] << 13) & 65535, this.h[1] = (this.h[1] >>> 3 | this.h[2] << 10) & 65535, this.h[2] = (this.h[2] >>> 6 | this.h[3] << 7) & 65535, this.h[3] = (this.h[3] >>> 9 | this.h[4] << 4) & 65535, this.h[4] = (this.h[4] >>> 12 | this.h[5] << 1 | this.h[6] << 14) & 65535, this.h[5] = (this.h[6] >>> 2 | this.h[7] << 11) & 65535, this.h[6] = (this.h[7] >>> 5 | this.h[8] << 8) & 65535, this.h[7] = (this.h[8] >>> 8 | this.h[9] << 5) & 65535, qe = this.h[0] + this.pad[0], this.h[0] = qe & 65535, ht = 1; ht < 8; ht++)
        qe = (this.h[ht] + this.pad[ht] | 0) + (qe >>> 16) | 0, this.h[ht] = qe & 65535;
      Ke[Qe + 0] = this.h[0] >>> 0 & 255, Ke[Qe + 1] = this.h[0] >>> 8 & 255, Ke[Qe + 2] = this.h[1] >>> 0 & 255, Ke[Qe + 3] = this.h[1] >>> 8 & 255, Ke[Qe + 4] = this.h[2] >>> 0 & 255, Ke[Qe + 5] = this.h[2] >>> 8 & 255, Ke[Qe + 6] = this.h[3] >>> 0 & 255, Ke[Qe + 7] = this.h[3] >>> 8 & 255, Ke[Qe + 8] = this.h[4] >>> 0 & 255, Ke[Qe + 9] = this.h[4] >>> 8 & 255, Ke[Qe + 10] = this.h[5] >>> 0 & 255, Ke[Qe + 11] = this.h[5] >>> 8 & 255, Ke[Qe + 12] = this.h[6] >>> 0 & 255, Ke[Qe + 13] = this.h[6] >>> 8 & 255, Ke[Qe + 14] = this.h[7] >>> 0 & 255, Ke[Qe + 15] = this.h[7] >>> 8 & 255;
    }, Ae.prototype.update = function(Ke, Qe, et) {
      var He, nt;
      if (this.leftover) {
        for (nt = 16 - this.leftover, nt > et && (nt = et), He = 0; He < nt; He++)
          this.buffer[this.leftover + He] = Ke[Qe + He];
        if (et -= nt, Qe += nt, this.leftover += nt, this.leftover < 16)
          return;
        this.blocks(this.buffer, 0, 16), this.leftover = 0;
      }
      if (et >= 16 && (nt = et - et % 16, this.blocks(Ke, Qe, nt), Qe += nt, et -= nt), et) {
        for (He = 0; He < et; He++)
          this.buffer[this.leftover + He] = Ke[Qe + He];
        this.leftover += et;
      }
    };
    function ne(Ke, Qe, et, He, nt, qe) {
      var ht = new Ae(qe);
      return ht.update(et, He, nt), ht.finish(Ke, Qe), 0;
    }
    function oe(Ke, Qe, et, He, nt, qe) {
      var ht = new Uint8Array(16);
      return ne(ht, 0, et, He, nt, qe), xe(Ke, Qe, ht, 0);
    }
    function ce(Ke, Qe, et, He, nt) {
      var qe;
      if (et < 32) return -1;
      for (Fe(Ke, 0, Qe, 0, et, He, nt), ne(Ke, 16, Ke, 32, et - 32, Ke), qe = 0; qe < 16; qe++) Ke[qe] = 0;
      return 0;
    }
    function le(Ke, Qe, et, He, nt) {
      var qe, ht = new Uint8Array(32);
      if (et < 32 || (De(ht, 0, 32, He, nt), oe(Qe, 16, Qe, 32, et - 32, ht) !== 0)) return -1;
      for (Fe(Ke, 0, Qe, 0, et, He, nt), qe = 0; qe < 32; qe++) Ke[qe] = 0;
      return 0;
    }
    function pe(Ke, Qe) {
      var et;
      for (et = 0; et < 16; et++) Ke[et] = Qe[et] | 0;
    }
    function ye(Ke) {
      var Qe, et, He = 1;
      for (Qe = 0; Qe < 16; Qe++)
        et = Ke[Qe] + He + 65535, He = Math.floor(et / 65536), Ke[Qe] = et - He * 65536;
      Ke[0] += He - 1 + 37 * (He - 1);
    }
    function Ce(Ke, Qe, et) {
      for (var He, nt = ~(et - 1), qe = 0; qe < 16; qe++)
        He = nt & (Ke[qe] ^ Qe[qe]), Ke[qe] ^= He, Qe[qe] ^= He;
    }
    function be(Ke, Qe) {
      var et, He, nt, qe = T(), ht = T();
      for (et = 0; et < 16; et++) ht[et] = Qe[et];
      for (ye(ht), ye(ht), ye(ht), He = 0; He < 2; He++) {
        for (qe[0] = ht[0] - 65517, et = 1; et < 15; et++)
          qe[et] = ht[et] - 65535 - (qe[et - 1] >> 16 & 1), qe[et - 1] &= 65535;
        qe[15] = ht[15] - 32767 - (qe[14] >> 16 & 1), nt = qe[15] >> 16 & 1, qe[14] &= 65535, Ce(ht, qe, 1 - nt);
      }
      for (et = 0; et < 16; et++)
        Ke[2 * et] = ht[et] & 255, Ke[2 * et + 1] = ht[et] >> 8;
    }
    function ae(Ke, Qe) {
      var et = new Uint8Array(32), He = new Uint8Array(32);
      return be(et, Ke), be(He, Qe), ve(et, 0, He, 0);
    }
    function ge(Ke) {
      var Qe = new Uint8Array(32);
      return be(Qe, Ke), Qe[0] & 1;
    }
    function Se(Ke, Qe) {
      var et;
      for (et = 0; et < 16; et++) Ke[et] = Qe[2 * et] + (Qe[2 * et + 1] << 8);
      Ke[15] &= 32767;
    }
    function Le(Ke, Qe, et) {
      for (var He = 0; He < 16; He++) Ke[He] = Qe[He] + et[He];
    }
    function ze(Ke, Qe, et) {
      for (var He = 0; He < 16; He++) Ke[He] = Qe[He] - et[He];
    }
    function Re(Ke, Qe, et) {
      var He, nt, qe = 0, ht = 0, pt = 0, bt = 0, jt = 0, $t = 0, Jt = 0, zt = 0, Vt = 0, Kt = 0, pn = 0, An = 0, vn = 0, Cn = 0, yn = 0, dn = 0, xn = 0, ln = 0, mn = 0, gn = 0, cn = 0, Pt = 0, Rt = 0, sn = 0, qt = 0, Zt = 0, hn = 0, Mn = 0, Sn = 0, Dn = 0, kn = 0, Et = et[0], Pn = et[1], Bn = et[2], jn = et[3], Nn = et[4], Ln = et[5], _n = et[6], Hn = et[7], Fn = et[8], Un = et[9], zn = et[10], Wn = et[11], Gn = et[12], Kn = et[13], Zn = et[14], Qn = et[15];
      He = Qe[0], qe += He * Et, ht += He * Pn, pt += He * Bn, bt += He * jn, jt += He * Nn, $t += He * Ln, Jt += He * _n, zt += He * Hn, Vt += He * Fn, Kt += He * Un, pn += He * zn, An += He * Wn, vn += He * Gn, Cn += He * Kn, yn += He * Zn, dn += He * Qn, He = Qe[1], ht += He * Et, pt += He * Pn, bt += He * Bn, jt += He * jn, $t += He * Nn, Jt += He * Ln, zt += He * _n, Vt += He * Hn, Kt += He * Fn, pn += He * Un, An += He * zn, vn += He * Wn, Cn += He * Gn, yn += He * Kn, dn += He * Zn, xn += He * Qn, He = Qe[2], pt += He * Et, bt += He * Pn, jt += He * Bn, $t += He * jn, Jt += He * Nn, zt += He * Ln, Vt += He * _n, Kt += He * Hn, pn += He * Fn, An += He * Un, vn += He * zn, Cn += He * Wn, yn += He * Gn, dn += He * Kn, xn += He * Zn, ln += He * Qn, He = Qe[3], bt += He * Et, jt += He * Pn, $t += He * Bn, Jt += He * jn, zt += He * Nn, Vt += He * Ln, Kt += He * _n, pn += He * Hn, An += He * Fn, vn += He * Un, Cn += He * zn, yn += He * Wn, dn += He * Gn, xn += He * Kn, ln += He * Zn, mn += He * Qn, He = Qe[4], jt += He * Et, $t += He * Pn, Jt += He * Bn, zt += He * jn, Vt += He * Nn, Kt += He * Ln, pn += He * _n, An += He * Hn, vn += He * Fn, Cn += He * Un, yn += He * zn, dn += He * Wn, xn += He * Gn, ln += He * Kn, mn += He * Zn, gn += He * Qn, He = Qe[5], $t += He * Et, Jt += He * Pn, zt += He * Bn, Vt += He * jn, Kt += He * Nn, pn += He * Ln, An += He * _n, vn += He * Hn, Cn += He * Fn, yn += He * Un, dn += He * zn, xn += He * Wn, ln += He * Gn, mn += He * Kn, gn += He * Zn, cn += He * Qn, He = Qe[6], Jt += He * Et, zt += He * Pn, Vt += He * Bn, Kt += He * jn, pn += He * Nn, An += He * Ln, vn += He * _n, Cn += He * Hn, yn += He * Fn, dn += He * Un, xn += He * zn, ln += He * Wn, mn += He * Gn, gn += He * Kn, cn += He * Zn, Pt += He * Qn, He = Qe[7], zt += He * Et, Vt += He * Pn, Kt += He * Bn, pn += He * jn, An += He * Nn, vn += He * Ln, Cn += He * _n, yn += He * Hn, dn += He * Fn, xn += He * Un, ln += He * zn, mn += He * Wn, gn += He * Gn, cn += He * Kn, Pt += He * Zn, Rt += He * Qn, He = Qe[8], Vt += He * Et, Kt += He * Pn, pn += He * Bn, An += He * jn, vn += He * Nn, Cn += He * Ln, yn += He * _n, dn += He * Hn, xn += He * Fn, ln += He * Un, mn += He * zn, gn += He * Wn, cn += He * Gn, Pt += He * Kn, Rt += He * Zn, sn += He * Qn, He = Qe[9], Kt += He * Et, pn += He * Pn, An += He * Bn, vn += He * jn, Cn += He * Nn, yn += He * Ln, dn += He * _n, xn += He * Hn, ln += He * Fn, mn += He * Un, gn += He * zn, cn += He * Wn, Pt += He * Gn, Rt += He * Kn, sn += He * Zn, qt += He * Qn, He = Qe[10], pn += He * Et, An += He * Pn, vn += He * Bn, Cn += He * jn, yn += He * Nn, dn += He * Ln, xn += He * _n, ln += He * Hn, mn += He * Fn, gn += He * Un, cn += He * zn, Pt += He * Wn, Rt += He * Gn, sn += He * Kn, qt += He * Zn, Zt += He * Qn, He = Qe[11], An += He * Et, vn += He * Pn, Cn += He * Bn, yn += He * jn, dn += He * Nn, xn += He * Ln, ln += He * _n, mn += He * Hn, gn += He * Fn, cn += He * Un, Pt += He * zn, Rt += He * Wn, sn += He * Gn, qt += He * Kn, Zt += He * Zn, hn += He * Qn, He = Qe[12], vn += He * Et, Cn += He * Pn, yn += He * Bn, dn += He * jn, xn += He * Nn, ln += He * Ln, mn += He * _n, gn += He * Hn, cn += He * Fn, Pt += He * Un, Rt += He * zn, sn += He * Wn, qt += He * Gn, Zt += He * Kn, hn += He * Zn, Mn += He * Qn, He = Qe[13], Cn += He * Et, yn += He * Pn, dn += He * Bn, xn += He * jn, ln += He * Nn, mn += He * Ln, gn += He * _n, cn += He * Hn, Pt += He * Fn, Rt += He * Un, sn += He * zn, qt += He * Wn, Zt += He * Gn, hn += He * Kn, Mn += He * Zn, Sn += He * Qn, He = Qe[14], yn += He * Et, dn += He * Pn, xn += He * Bn, ln += He * jn, mn += He * Nn, gn += He * Ln, cn += He * _n, Pt += He * Hn, Rt += He * Fn, sn += He * Un, qt += He * zn, Zt += He * Wn, hn += He * Gn, Mn += He * Kn, Sn += He * Zn, Dn += He * Qn, He = Qe[15], dn += He * Et, xn += He * Pn, ln += He * Bn, mn += He * jn, gn += He * Nn, cn += He * Ln, Pt += He * _n, Rt += He * Hn, sn += He * Fn, qt += He * Un, Zt += He * zn, hn += He * Wn, Mn += He * Gn, Sn += He * Kn, Dn += He * Zn, kn += He * Qn, qe += 38 * xn, ht += 38 * ln, pt += 38 * mn, bt += 38 * gn, jt += 38 * cn, $t += 38 * Pt, Jt += 38 * Rt, zt += 38 * sn, Vt += 38 * qt, Kt += 38 * Zt, pn += 38 * hn, An += 38 * Mn, vn += 38 * Sn, Cn += 38 * Dn, yn += 38 * kn, nt = 1, He = qe + nt + 65535, nt = Math.floor(He / 65536), qe = He - nt * 65536, He = ht + nt + 65535, nt = Math.floor(He / 65536), ht = He - nt * 65536, He = pt + nt + 65535, nt = Math.floor(He / 65536), pt = He - nt * 65536, He = bt + nt + 65535, nt = Math.floor(He / 65536), bt = He - nt * 65536, He = jt + nt + 65535, nt = Math.floor(He / 65536), jt = He - nt * 65536, He = $t + nt + 65535, nt = Math.floor(He / 65536), $t = He - nt * 65536, He = Jt + nt + 65535, nt = Math.floor(He / 65536), Jt = He - nt * 65536, He = zt + nt + 65535, nt = Math.floor(He / 65536), zt = He - nt * 65536, He = Vt + nt + 65535, nt = Math.floor(He / 65536), Vt = He - nt * 65536, He = Kt + nt + 65535, nt = Math.floor(He / 65536), Kt = He - nt * 65536, He = pn + nt + 65535, nt = Math.floor(He / 65536), pn = He - nt * 65536, He = An + nt + 65535, nt = Math.floor(He / 65536), An = He - nt * 65536, He = vn + nt + 65535, nt = Math.floor(He / 65536), vn = He - nt * 65536, He = Cn + nt + 65535, nt = Math.floor(He / 65536), Cn = He - nt * 65536, He = yn + nt + 65535, nt = Math.floor(He / 65536), yn = He - nt * 65536, He = dn + nt + 65535, nt = Math.floor(He / 65536), dn = He - nt * 65536, qe += nt - 1 + 37 * (nt - 1), nt = 1, He = qe + nt + 65535, nt = Math.floor(He / 65536), qe = He - nt * 65536, He = ht + nt + 65535, nt = Math.floor(He / 65536), ht = He - nt * 65536, He = pt + nt + 65535, nt = Math.floor(He / 65536), pt = He - nt * 65536, He = bt + nt + 65535, nt = Math.floor(He / 65536), bt = He - nt * 65536, He = jt + nt + 65535, nt = Math.floor(He / 65536), jt = He - nt * 65536, He = $t + nt + 65535, nt = Math.floor(He / 65536), $t = He - nt * 65536, He = Jt + nt + 65535, nt = Math.floor(He / 65536), Jt = He - nt * 65536, He = zt + nt + 65535, nt = Math.floor(He / 65536), zt = He - nt * 65536, He = Vt + nt + 65535, nt = Math.floor(He / 65536), Vt = He - nt * 65536, He = Kt + nt + 65535, nt = Math.floor(He / 65536), Kt = He - nt * 65536, He = pn + nt + 65535, nt = Math.floor(He / 65536), pn = He - nt * 65536, He = An + nt + 65535, nt = Math.floor(He / 65536), An = He - nt * 65536, He = vn + nt + 65535, nt = Math.floor(He / 65536), vn = He - nt * 65536, He = Cn + nt + 65535, nt = Math.floor(He / 65536), Cn = He - nt * 65536, He = yn + nt + 65535, nt = Math.floor(He / 65536), yn = He - nt * 65536, He = dn + nt + 65535, nt = Math.floor(He / 65536), dn = He - nt * 65536, qe += nt - 1 + 37 * (nt - 1), Ke[0] = qe, Ke[1] = ht, Ke[2] = pt, Ke[3] = bt, Ke[4] = jt, Ke[5] = $t, Ke[6] = Jt, Ke[7] = zt, Ke[8] = Vt, Ke[9] = Kt, Ke[10] = pn, Ke[11] = An, Ke[12] = vn, Ke[13] = Cn, Ke[14] = yn, Ke[15] = dn;
    }
    function We(Ke, Qe) {
      Re(Ke, Qe, Qe);
    }
    function Be(Ke, Qe) {
      var et = T(), He;
      for (He = 0; He < 16; He++) et[He] = Qe[He];
      for (He = 253; He >= 0; He--)
        We(et, et), He !== 2 && He !== 4 && Re(et, et, Qe);
      for (He = 0; He < 16; He++) Ke[He] = et[He];
    }
    function Ue(Ke, Qe) {
      var et = T(), He;
      for (He = 0; He < 16; He++) et[He] = Qe[He];
      for (He = 250; He >= 0; He--)
        We(et, et), He !== 1 && Re(et, et, Qe);
      for (He = 0; He < 16; He++) Ke[He] = et[He];
    }
    function Ge(Ke, Qe, et) {
      var He = new Uint8Array(32), nt = new Float64Array(80), qe, ht, pt = T(), bt = T(), jt = T(), $t = T(), Jt = T(), zt = T();
      for (ht = 0; ht < 31; ht++) He[ht] = Qe[ht];
      for (He[31] = Qe[31] & 127 | 64, He[0] &= 248, Se(nt, et), ht = 0; ht < 16; ht++)
        bt[ht] = nt[ht], $t[ht] = pt[ht] = jt[ht] = 0;
      for (pt[0] = $t[0] = 1, ht = 254; ht >= 0; --ht)
        qe = He[ht >>> 3] >>> (ht & 7) & 1, Ce(pt, bt, qe), Ce(jt, $t, qe), Le(Jt, pt, jt), ze(pt, pt, jt), Le(jt, bt, $t), ze(bt, bt, $t), We($t, Jt), We(zt, pt), Re(pt, jt, pt), Re(jt, bt, Jt), Le(Jt, pt, jt), ze(pt, pt, jt), We(bt, pt), ze(jt, $t, zt), Re(pt, jt, re), Le(pt, pt, $t), Re(jt, jt, pt), Re(pt, $t, zt), Re($t, bt, nt), We(bt, Jt), Ce(pt, bt, qe), Ce(jt, $t, qe);
      for (ht = 0; ht < 16; ht++)
        nt[ht + 16] = pt[ht], nt[ht + 32] = jt[ht], nt[ht + 48] = bt[ht], nt[ht + 64] = $t[ht];
      var Vt = nt.subarray(32), Kt = nt.subarray(16);
      return Be(Vt, Vt), Re(Kt, Kt, Vt), be(Ke, Kt), 0;
    }
    function je(Ke, Qe) {
      return Ge(Ke, Qe, J);
    }
    function Oe(Ke, Qe) {
      return $(Qe, 32), je(Ke, Qe);
    }
    function Ne(Ke, Qe, et) {
      var He = new Uint8Array(32);
      return Ge(He, et, Qe), Me(Ke, V, He, Ie);
    }
    var Ye = ce, Je = le;
    function Xe(Ke, Qe, et, He, nt, qe) {
      var ht = new Uint8Array(32);
      return Ne(ht, nt, qe), Ye(Ke, Qe, et, He, ht);
    }
    function st(Ke, Qe, et, He, nt, qe) {
      var ht = new Uint8Array(32);
      return Ne(ht, nt, qe), Je(Ke, Qe, et, He, ht);
    }
    var ct = [
      1116352408,
      3609767458,
      1899447441,
      602891725,
      3049323471,
      3964484399,
      3921009573,
      2173295548,
      961987163,
      4081628472,
      1508970993,
      3053834265,
      2453635748,
      2937671579,
      2870763221,
      3664609560,
      3624381080,
      2734883394,
      310598401,
      1164996542,
      607225278,
      1323610764,
      1426881987,
      3590304994,
      1925078388,
      4068182383,
      2162078206,
      991336113,
      2614888103,
      633803317,
      3248222580,
      3479774868,
      3835390401,
      2666613458,
      4022224774,
      944711139,
      264347078,
      2341262773,
      604807628,
      2007800933,
      770255983,
      1495990901,
      1249150122,
      1856431235,
      1555081692,
      3175218132,
      1996064986,
      2198950837,
      2554220882,
      3999719339,
      2821834349,
      766784016,
      2952996808,
      2566594879,
      3210313671,
      3203337956,
      3336571891,
      1034457026,
      3584528711,
      2466948901,
      113926993,
      3758326383,
      338241895,
      168717936,
      666307205,
      1188179964,
      773529912,
      1546045734,
      1294757372,
      1522805485,
      1396182291,
      2643833823,
      1695183700,
      2343527390,
      1986661051,
      1014477480,
      2177026350,
      1206759142,
      2456956037,
      344077627,
      2730485921,
      1290863460,
      2820302411,
      3158454273,
      3259730800,
      3505952657,
      3345764771,
      106217008,
      3516065817,
      3606008344,
      3600352804,
      1432725776,
      4094571909,
      1467031594,
      275423344,
      851169720,
      430227734,
      3100823752,
      506948616,
      1363258195,
      659060556,
      3750685593,
      883997877,
      3785050280,
      958139571,
      3318307427,
      1322822218,
      3812723403,
      1537002063,
      2003034995,
      1747873779,
      3602036899,
      1955562222,
      1575990012,
      2024104815,
      1125592928,
      2227730452,
      2716904306,
      2361852424,
      442776044,
      2428436474,
      593698344,
      2756734187,
      3733110249,
      3204031479,
      2999351573,
      3329325298,
      3815920427,
      3391569614,
      3928383900,
      3515267271,
      566280711,
      3940187606,
      3454069534,
      4118630271,
      4000239992,
      116418474,
      1914138554,
      174292421,
      2731055270,
      289380356,
      3203993006,
      460393269,
      320620315,
      685471733,
      587496836,
      852142971,
      1086792851,
      1017036298,
      365543100,
      1126000580,
      2618297676,
      1288033470,
      3409855158,
      1501505948,
      4234509866,
      1607167915,
      987167468,
      1816402316,
      1246189591
    ];
    function it(Ke, Qe, et, He) {
      for (var nt = new Int32Array(16), qe = new Int32Array(16), ht, pt, bt, jt, $t, Jt, zt, Vt, Kt, pn, An, vn, Cn, yn, dn, xn, ln, mn, gn, cn, Pt, Rt, sn, qt, Zt, hn, Mn = Ke[0], Sn = Ke[1], Dn = Ke[2], kn = Ke[3], Et = Ke[4], Pn = Ke[5], Bn = Ke[6], jn = Ke[7], Nn = Qe[0], Ln = Qe[1], _n = Qe[2], Hn = Qe[3], Fn = Qe[4], Un = Qe[5], zn = Qe[6], Wn = Qe[7], Gn = 0; He >= 128; ) {
        for (gn = 0; gn < 16; gn++)
          cn = 8 * gn + Gn, nt[gn] = et[cn + 0] << 24 | et[cn + 1] << 16 | et[cn + 2] << 8 | et[cn + 3], qe[gn] = et[cn + 4] << 24 | et[cn + 5] << 16 | et[cn + 6] << 8 | et[cn + 7];
        for (gn = 0; gn < 80; gn++)
          if (ht = Mn, pt = Sn, bt = Dn, jt = kn, $t = Et, Jt = Pn, zt = Bn, Vt = jn, Kt = Nn, pn = Ln, An = _n, vn = Hn, Cn = Fn, yn = Un, dn = zn, xn = Wn, Pt = jn, Rt = Wn, sn = Rt & 65535, qt = Rt >>> 16, Zt = Pt & 65535, hn = Pt >>> 16, Pt = (Et >>> 14 | Fn << 18) ^ (Et >>> 18 | Fn << 14) ^ (Fn >>> 9 | Et << 23), Rt = (Fn >>> 14 | Et << 18) ^ (Fn >>> 18 | Et << 14) ^ (Et >>> 9 | Fn << 23), sn += Rt & 65535, qt += Rt >>> 16, Zt += Pt & 65535, hn += Pt >>> 16, Pt = Et & Pn ^ ~Et & Bn, Rt = Fn & Un ^ ~Fn & zn, sn += Rt & 65535, qt += Rt >>> 16, Zt += Pt & 65535, hn += Pt >>> 16, Pt = ct[gn * 2], Rt = ct[gn * 2 + 1], sn += Rt & 65535, qt += Rt >>> 16, Zt += Pt & 65535, hn += Pt >>> 16, Pt = nt[gn % 16], Rt = qe[gn % 16], sn += Rt & 65535, qt += Rt >>> 16, Zt += Pt & 65535, hn += Pt >>> 16, qt += sn >>> 16, Zt += qt >>> 16, hn += Zt >>> 16, ln = Zt & 65535 | hn << 16, mn = sn & 65535 | qt << 16, Pt = ln, Rt = mn, sn = Rt & 65535, qt = Rt >>> 16, Zt = Pt & 65535, hn = Pt >>> 16, Pt = (Mn >>> 28 | Nn << 4) ^ (Nn >>> 2 | Mn << 30) ^ (Nn >>> 7 | Mn << 25), Rt = (Nn >>> 28 | Mn << 4) ^ (Mn >>> 2 | Nn << 30) ^ (Mn >>> 7 | Nn << 25), sn += Rt & 65535, qt += Rt >>> 16, Zt += Pt & 65535, hn += Pt >>> 16, Pt = Mn & Sn ^ Mn & Dn ^ Sn & Dn, Rt = Nn & Ln ^ Nn & _n ^ Ln & _n, sn += Rt & 65535, qt += Rt >>> 16, Zt += Pt & 65535, hn += Pt >>> 16, qt += sn >>> 16, Zt += qt >>> 16, hn += Zt >>> 16, Vt = Zt & 65535 | hn << 16, xn = sn & 65535 | qt << 16, Pt = jt, Rt = vn, sn = Rt & 65535, qt = Rt >>> 16, Zt = Pt & 65535, hn = Pt >>> 16, Pt = ln, Rt = mn, sn += Rt & 65535, qt += Rt >>> 16, Zt += Pt & 65535, hn += Pt >>> 16, qt += sn >>> 16, Zt += qt >>> 16, hn += Zt >>> 16, jt = Zt & 65535 | hn << 16, vn = sn & 65535 | qt << 16, Sn = ht, Dn = pt, kn = bt, Et = jt, Pn = $t, Bn = Jt, jn = zt, Mn = Vt, Ln = Kt, _n = pn, Hn = An, Fn = vn, Un = Cn, zn = yn, Wn = dn, Nn = xn, gn % 16 === 15)
            for (cn = 0; cn < 16; cn++)
              Pt = nt[cn], Rt = qe[cn], sn = Rt & 65535, qt = Rt >>> 16, Zt = Pt & 65535, hn = Pt >>> 16, Pt = nt[(cn + 9) % 16], Rt = qe[(cn + 9) % 16], sn += Rt & 65535, qt += Rt >>> 16, Zt += Pt & 65535, hn += Pt >>> 16, ln = nt[(cn + 1) % 16], mn = qe[(cn + 1) % 16], Pt = (ln >>> 1 | mn << 31) ^ (ln >>> 8 | mn << 24) ^ ln >>> 7, Rt = (mn >>> 1 | ln << 31) ^ (mn >>> 8 | ln << 24) ^ (mn >>> 7 | ln << 25), sn += Rt & 65535, qt += Rt >>> 16, Zt += Pt & 65535, hn += Pt >>> 16, ln = nt[(cn + 14) % 16], mn = qe[(cn + 14) % 16], Pt = (ln >>> 19 | mn << 13) ^ (mn >>> 29 | ln << 3) ^ ln >>> 6, Rt = (mn >>> 19 | ln << 13) ^ (ln >>> 29 | mn << 3) ^ (mn >>> 6 | ln << 26), sn += Rt & 65535, qt += Rt >>> 16, Zt += Pt & 65535, hn += Pt >>> 16, qt += sn >>> 16, Zt += qt >>> 16, hn += Zt >>> 16, nt[cn] = Zt & 65535 | hn << 16, qe[cn] = sn & 65535 | qt << 16;
        Pt = Mn, Rt = Nn, sn = Rt & 65535, qt = Rt >>> 16, Zt = Pt & 65535, hn = Pt >>> 16, Pt = Ke[0], Rt = Qe[0], sn += Rt & 65535, qt += Rt >>> 16, Zt += Pt & 65535, hn += Pt >>> 16, qt += sn >>> 16, Zt += qt >>> 16, hn += Zt >>> 16, Ke[0] = Mn = Zt & 65535 | hn << 16, Qe[0] = Nn = sn & 65535 | qt << 16, Pt = Sn, Rt = Ln, sn = Rt & 65535, qt = Rt >>> 16, Zt = Pt & 65535, hn = Pt >>> 16, Pt = Ke[1], Rt = Qe[1], sn += Rt & 65535, qt += Rt >>> 16, Zt += Pt & 65535, hn += Pt >>> 16, qt += sn >>> 16, Zt += qt >>> 16, hn += Zt >>> 16, Ke[1] = Sn = Zt & 65535 | hn << 16, Qe[1] = Ln = sn & 65535 | qt << 16, Pt = Dn, Rt = _n, sn = Rt & 65535, qt = Rt >>> 16, Zt = Pt & 65535, hn = Pt >>> 16, Pt = Ke[2], Rt = Qe[2], sn += Rt & 65535, qt += Rt >>> 16, Zt += Pt & 65535, hn += Pt >>> 16, qt += sn >>> 16, Zt += qt >>> 16, hn += Zt >>> 16, Ke[2] = Dn = Zt & 65535 | hn << 16, Qe[2] = _n = sn & 65535 | qt << 16, Pt = kn, Rt = Hn, sn = Rt & 65535, qt = Rt >>> 16, Zt = Pt & 65535, hn = Pt >>> 16, Pt = Ke[3], Rt = Qe[3], sn += Rt & 65535, qt += Rt >>> 16, Zt += Pt & 65535, hn += Pt >>> 16, qt += sn >>> 16, Zt += qt >>> 16, hn += Zt >>> 16, Ke[3] = kn = Zt & 65535 | hn << 16, Qe[3] = Hn = sn & 65535 | qt << 16, Pt = Et, Rt = Fn, sn = Rt & 65535, qt = Rt >>> 16, Zt = Pt & 65535, hn = Pt >>> 16, Pt = Ke[4], Rt = Qe[4], sn += Rt & 65535, qt += Rt >>> 16, Zt += Pt & 65535, hn += Pt >>> 16, qt += sn >>> 16, Zt += qt >>> 16, hn += Zt >>> 16, Ke[4] = Et = Zt & 65535 | hn << 16, Qe[4] = Fn = sn & 65535 | qt << 16, Pt = Pn, Rt = Un, sn = Rt & 65535, qt = Rt >>> 16, Zt = Pt & 65535, hn = Pt >>> 16, Pt = Ke[5], Rt = Qe[5], sn += Rt & 65535, qt += Rt >>> 16, Zt += Pt & 65535, hn += Pt >>> 16, qt += sn >>> 16, Zt += qt >>> 16, hn += Zt >>> 16, Ke[5] = Pn = Zt & 65535 | hn << 16, Qe[5] = Un = sn & 65535 | qt << 16, Pt = Bn, Rt = zn, sn = Rt & 65535, qt = Rt >>> 16, Zt = Pt & 65535, hn = Pt >>> 16, Pt = Ke[6], Rt = Qe[6], sn += Rt & 65535, qt += Rt >>> 16, Zt += Pt & 65535, hn += Pt >>> 16, qt += sn >>> 16, Zt += qt >>> 16, hn += Zt >>> 16, Ke[6] = Bn = Zt & 65535 | hn << 16, Qe[6] = zn = sn & 65535 | qt << 16, Pt = jn, Rt = Wn, sn = Rt & 65535, qt = Rt >>> 16, Zt = Pt & 65535, hn = Pt >>> 16, Pt = Ke[7], Rt = Qe[7], sn += Rt & 65535, qt += Rt >>> 16, Zt += Pt & 65535, hn += Pt >>> 16, qt += sn >>> 16, Zt += qt >>> 16, hn += Zt >>> 16, Ke[7] = jn = Zt & 65535 | hn << 16, Qe[7] = Wn = sn & 65535 | qt << 16, Gn += 128, He -= 128;
      }
      return He;
    }
    function ot(Ke, Qe, et) {
      var He = new Int32Array(8), nt = new Int32Array(8), qe = new Uint8Array(256), ht, pt = et;
      for (He[0] = 1779033703, He[1] = 3144134277, He[2] = 1013904242, He[3] = 2773480762, He[4] = 1359893119, He[5] = 2600822924, He[6] = 528734635, He[7] = 1541459225, nt[0] = 4089235720, nt[1] = 2227873595, nt[2] = 4271175723, nt[3] = 1595750129, nt[4] = 2917565137, nt[5] = 725511199, nt[6] = 4215389547, nt[7] = 327033209, it(He, nt, Qe, et), et %= 128, ht = 0; ht < et; ht++) qe[ht] = Qe[pt - et + ht];
      for (qe[et] = 128, et = 256 - 128 * (et < 112 ? 1 : 0), qe[et - 9] = 0, he(qe, et - 8, pt / 536870912 | 0, pt << 3), it(He, nt, qe, et), ht = 0; ht < 8; ht++) he(Ke, 8 * ht, He[ht], nt[ht]);
      return 0;
    }
    function yt(Ke, Qe) {
      var et = T(), He = T(), nt = T(), qe = T(), ht = T(), pt = T(), bt = T(), jt = T(), $t = T();
      ze(et, Ke[1], Ke[0]), ze($t, Qe[1], Qe[0]), Re(et, et, $t), Le(He, Ke[0], Ke[1]), Le($t, Qe[0], Qe[1]), Re(He, He, $t), Re(nt, Ke[3], Qe[3]), Re(nt, nt, se), Re(qe, Ke[2], Qe[2]), Le(qe, qe, qe), ze(ht, He, et), ze(pt, qe, nt), Le(bt, qe, nt), Le(jt, He, et), Re(Ke[0], ht, pt), Re(Ke[1], jt, bt), Re(Ke[2], bt, pt), Re(Ke[3], ht, jt);
    }
    function dt(Ke, Qe, et) {
      var He;
      for (He = 0; He < 4; He++)
        Ce(Ke[He], Qe[He], et);
    }
    function mt(Ke, Qe) {
      var et = T(), He = T(), nt = T();
      Be(nt, Qe[2]), Re(et, Qe[0], nt), Re(He, Qe[1], nt), be(Ke, He), Ke[31] ^= ge(et) << 7;
    }
    function It(Ke, Qe, et) {
      var He, nt;
      for (pe(Ke[0], ee), pe(Ke[1], te), pe(Ke[2], te), pe(Ke[3], ee), nt = 255; nt >= 0; --nt)
        He = et[nt / 8 | 0] >> (nt & 7) & 1, dt(Ke, Qe, He), yt(Qe, Ke), yt(Ke, Ke), dt(Ke, Qe, He);
    }
    function xt(Ke, Qe) {
      var et = [T(), T(), T(), T()];
      pe(et[0], de), pe(et[1], ue), pe(et[2], te), Re(et[3], de, ue), It(Ke, et, Qe);
    }
    function Tt(Ke, Qe, et) {
      var He = new Uint8Array(64), nt = [T(), T(), T(), T()], qe;
      for (et || $(Qe, 32), ot(He, Qe, 32), He[0] &= 248, He[31] &= 127, He[31] |= 64, xt(nt, He), mt(Ke, nt), qe = 0; qe < 32; qe++) Qe[qe + 32] = Ke[qe];
      return 0;
    }
    var Yt = new Float64Array([237, 211, 245, 92, 26, 99, 18, 88, 214, 156, 247, 162, 222, 249, 222, 20, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 16]);
    function Ve(Ke, Qe) {
      var et, He, nt, qe;
      for (He = 63; He >= 32; --He) {
        for (et = 0, nt = He - 32, qe = He - 12; nt < qe; ++nt)
          Qe[nt] += et - 16 * Qe[He] * Yt[nt - (He - 32)], et = Math.floor((Qe[nt] + 128) / 256), Qe[nt] -= et * 256;
        Qe[nt] += et, Qe[He] = 0;
      }
      for (et = 0, nt = 0; nt < 32; nt++)
        Qe[nt] += et - (Qe[31] >> 4) * Yt[nt], et = Qe[nt] >> 8, Qe[nt] &= 255;
      for (nt = 0; nt < 32; nt++) Qe[nt] -= et * Yt[nt];
      for (He = 0; He < 32; He++)
        Qe[He + 1] += Qe[He] >> 8, Ke[He] = Qe[He] & 255;
    }
    function Pe(Ke) {
      var Qe = new Float64Array(64), et;
      for (et = 0; et < 64; et++) Qe[et] = Ke[et];
      for (et = 0; et < 64; et++) Ke[et] = 0;
      Ve(Ke, Qe);
    }
    function $e(Ke, Qe, et, He) {
      var nt = new Uint8Array(64), qe = new Uint8Array(64), ht = new Uint8Array(64), pt, bt, jt = new Float64Array(64), $t = [T(), T(), T(), T()];
      ot(nt, He, 32), nt[0] &= 248, nt[31] &= 127, nt[31] |= 64;
      var Jt = et + 64;
      for (pt = 0; pt < et; pt++) Ke[64 + pt] = Qe[pt];
      for (pt = 0; pt < 32; pt++) Ke[32 + pt] = nt[32 + pt];
      for (ot(ht, Ke.subarray(32), et + 32), Pe(ht), xt($t, ht), mt(Ke, $t), pt = 32; pt < 64; pt++) Ke[pt] = He[pt];
      for (ot(qe, Ke, et + 64), Pe(qe), pt = 0; pt < 64; pt++) jt[pt] = 0;
      for (pt = 0; pt < 32; pt++) jt[pt] = ht[pt];
      for (pt = 0; pt < 32; pt++)
        for (bt = 0; bt < 32; bt++)
          jt[pt + bt] += qe[pt] * nt[bt];
      return Ve(Ke.subarray(32), jt), Jt;
    }
    function Ze(Ke, Qe) {
      var et = T(), He = T(), nt = T(), qe = T(), ht = T(), pt = T(), bt = T();
      return pe(Ke[2], te), Se(Ke[1], Qe), We(nt, Ke[1]), Re(qe, nt, ie), ze(nt, nt, Ke[2]), Le(qe, Ke[2], qe), We(ht, qe), We(pt, ht), Re(bt, pt, ht), Re(et, bt, nt), Re(et, et, qe), Ue(et, et), Re(et, et, nt), Re(et, et, qe), Re(et, et, qe), Re(Ke[0], et, qe), We(He, Ke[0]), Re(He, He, qe), ae(He, nt) && Re(Ke[0], Ke[0], fe), We(He, Ke[0]), Re(He, He, qe), ae(He, nt) ? -1 : (ge(Ke[0]) === Qe[31] >> 7 && ze(Ke[0], ee, Ke[0]), Re(Ke[3], Ke[0], Ke[1]), 0);
    }
    function at(Ke, Qe, et, He) {
      var nt, qe = new Uint8Array(32), ht = new Uint8Array(64), pt = [T(), T(), T(), T()], bt = [T(), T(), T(), T()];
      if (et < 64 || Ze(bt, He)) return -1;
      for (nt = 0; nt < et; nt++) Ke[nt] = Qe[nt];
      for (nt = 0; nt < 32; nt++) Ke[nt + 32] = He[nt];
      if (ot(ht, Ke, et), Pe(ht), It(pt, bt, ht), xt(bt, Qe.subarray(32)), yt(pt, bt), mt(qe, pt), et -= 64, ve(Qe, 0, qe, 0)) {
        for (nt = 0; nt < et; nt++) Ke[nt] = 0;
        return -1;
      }
      for (nt = 0; nt < et; nt++) Ke[nt] = Qe[nt + 64];
      return et;
    }
    var wt = 32, ft = 24, Ct = 32, Ut = 16, vt = 32, Mt = 32, Xt = 32, St = 32, Ot = 32, wn = ft, kt = Ct, Bt = Ut, Tn = 64, Nt = 32, Wt = 64, En = 32, Lt = 64;
    e.lowlevel = {
      crypto_core_hsalsa20: Me,
      crypto_stream_xor: Fe,
      crypto_stream: De,
      crypto_stream_salsa20_xor: ke,
      crypto_stream_salsa20: _e,
      crypto_onetimeauth: ne,
      crypto_onetimeauth_verify: oe,
      crypto_verify_16: xe,
      crypto_verify_32: ve,
      crypto_secretbox: ce,
      crypto_secretbox_open: le,
      crypto_scalarmult: Ge,
      crypto_scalarmult_base: je,
      crypto_box_beforenm: Ne,
      crypto_box_afternm: Ye,
      crypto_box: Xe,
      crypto_box_open: st,
      crypto_box_keypair: Oe,
      crypto_hash: ot,
      crypto_sign: $e,
      crypto_sign_keypair: Tt,
      crypto_sign_open: at,
      crypto_secretbox_KEYBYTES: wt,
      crypto_secretbox_NONCEBYTES: ft,
      crypto_secretbox_ZEROBYTES: Ct,
      crypto_secretbox_BOXZEROBYTES: Ut,
      crypto_scalarmult_BYTES: vt,
      crypto_scalarmult_SCALARBYTES: Mt,
      crypto_box_PUBLICKEYBYTES: Xt,
      crypto_box_SECRETKEYBYTES: St,
      crypto_box_BEFORENMBYTES: Ot,
      crypto_box_NONCEBYTES: wn,
      crypto_box_ZEROBYTES: kt,
      crypto_box_BOXZEROBYTES: Bt,
      crypto_sign_BYTES: Tn,
      crypto_sign_PUBLICKEYBYTES: Nt,
      crypto_sign_SECRETKEYBYTES: Wt,
      crypto_sign_SEEDBYTES: En,
      crypto_hash_BYTES: Lt,
      gf: T,
      D: ie,
      L: Yt,
      pack25519: be,
      unpack25519: Se,
      M: Re,
      A: Le,
      S: We,
      Z: ze,
      pow2523: Ue,
      add: yt,
      set25519: pe,
      modL: Ve,
      scalarmult: It,
      scalarbase: xt
    };
    function Ht(Ke, Qe) {
      if (Ke.length !== wt) throw new Error("bad key size");
      if (Qe.length !== ft) throw new Error("bad nonce size");
    }
    function In(Ke, Qe) {
      if (Ke.length !== Xt) throw new Error("bad public key size");
      if (Qe.length !== St) throw new Error("bad secret key size");
    }
    function Dt() {
      for (var Ke = 0; Ke < arguments.length; Ke++)
        if (!(arguments[Ke] instanceof Uint8Array))
          throw new TypeError("unexpected type, use Uint8Array");
    }
    function Gt(Ke) {
      for (var Qe = 0; Qe < Ke.length; Qe++) Ke[Qe] = 0;
    }
    e.randomBytes = function(Ke) {
      var Qe = new Uint8Array(Ke);
      return $(Qe, Ke), Qe;
    }, e.secretbox = function(Ke, Qe, et) {
      Dt(Ke, Qe, et), Ht(et, Qe);
      for (var He = new Uint8Array(Ct + Ke.length), nt = new Uint8Array(He.length), qe = 0; qe < Ke.length; qe++) He[qe + Ct] = Ke[qe];
      return ce(nt, He, He.length, Qe, et), nt.subarray(Ut);
    }, e.secretbox.open = function(Ke, Qe, et) {
      Dt(Ke, Qe, et), Ht(et, Qe);
      for (var He = new Uint8Array(Ut + Ke.length), nt = new Uint8Array(He.length), qe = 0; qe < Ke.length; qe++) He[qe + Ut] = Ke[qe];
      return He.length < 32 || le(nt, He, He.length, Qe, et) !== 0 ? null : nt.subarray(Ct);
    }, e.secretbox.keyLength = wt, e.secretbox.nonceLength = ft, e.secretbox.overheadLength = Ut, e.scalarMult = function(Ke, Qe) {
      if (Dt(Ke, Qe), Ke.length !== Mt) throw new Error("bad n size");
      if (Qe.length !== vt) throw new Error("bad p size");
      var et = new Uint8Array(vt);
      return Ge(et, Ke, Qe), et;
    }, e.scalarMult.base = function(Ke) {
      if (Dt(Ke), Ke.length !== Mt) throw new Error("bad n size");
      var Qe = new Uint8Array(vt);
      return je(Qe, Ke), Qe;
    }, e.scalarMult.scalarLength = Mt, e.scalarMult.groupElementLength = vt, e.box = function(Ke, Qe, et, He) {
      var nt = e.box.before(et, He);
      return e.secretbox(Ke, Qe, nt);
    }, e.box.before = function(Ke, Qe) {
      Dt(Ke, Qe), In(Ke, Qe);
      var et = new Uint8Array(Ot);
      return Ne(et, Ke, Qe), et;
    }, e.box.after = e.secretbox, e.box.open = function(Ke, Qe, et, He) {
      var nt = e.box.before(et, He);
      return e.secretbox.open(Ke, Qe, nt);
    }, e.box.open.after = e.secretbox.open, e.box.keyPair = function() {
      var Ke = new Uint8Array(Xt), Qe = new Uint8Array(St);
      return Oe(Ke, Qe), { publicKey: Ke, secretKey: Qe };
    }, e.box.keyPair.fromSecretKey = function(Ke) {
      if (Dt(Ke), Ke.length !== St)
        throw new Error("bad secret key size");
      var Qe = new Uint8Array(Xt);
      return je(Qe, Ke), { publicKey: Qe, secretKey: new Uint8Array(Ke) };
    }, e.box.publicKeyLength = Xt, e.box.secretKeyLength = St, e.box.sharedKeyLength = Ot, e.box.nonceLength = wn, e.box.overheadLength = e.secretbox.overheadLength, e.sign = function(Ke, Qe) {
      if (Dt(Ke, Qe), Qe.length !== Wt)
        throw new Error("bad secret key size");
      var et = new Uint8Array(Tn + Ke.length);
      return $e(et, Ke, Ke.length, Qe), et;
    }, e.sign.open = function(Ke, Qe) {
      if (Dt(Ke, Qe), Qe.length !== Nt)
        throw new Error("bad public key size");
      var et = new Uint8Array(Ke.length), He = at(et, Ke, Ke.length, Qe);
      if (He < 0) return null;
      for (var nt = new Uint8Array(He), qe = 0; qe < nt.length; qe++) nt[qe] = et[qe];
      return nt;
    }, e.sign.detached = function(Ke, Qe) {
      for (var et = e.sign(Ke, Qe), He = new Uint8Array(Tn), nt = 0; nt < He.length; nt++) He[nt] = et[nt];
      return He;
    }, e.sign.detached.verify = function(Ke, Qe, et) {
      if (Dt(Ke, Qe, et), Qe.length !== Tn)
        throw new Error("bad signature size");
      if (et.length !== Nt)
        throw new Error("bad public key size");
      var He = new Uint8Array(Tn + Ke.length), nt = new Uint8Array(Tn + Ke.length), qe;
      for (qe = 0; qe < Tn; qe++) He[qe] = Qe[qe];
      for (qe = 0; qe < Ke.length; qe++) He[qe + Tn] = Ke[qe];
      return at(nt, He, He.length, et) >= 0;
    }, e.sign.keyPair = function() {
      var Ke = new Uint8Array(Nt), Qe = new Uint8Array(Wt);
      return Tt(Ke, Qe), { publicKey: Ke, secretKey: Qe };
    }, e.sign.keyPair.fromSecretKey = function(Ke) {
      if (Dt(Ke), Ke.length !== Wt)
        throw new Error("bad secret key size");
      for (var Qe = new Uint8Array(Nt), et = 0; et < Qe.length; et++) Qe[et] = Ke[32 + et];
      return { publicKey: Qe, secretKey: new Uint8Array(Ke) };
    }, e.sign.keyPair.fromSeed = function(Ke) {
      if (Dt(Ke), Ke.length !== En)
        throw new Error("bad seed size");
      for (var Qe = new Uint8Array(Nt), et = new Uint8Array(Wt), He = 0; He < 32; He++) et[He] = Ke[He];
      return Tt(Qe, et, !0), { publicKey: Qe, secretKey: et };
    }, e.sign.publicKeyLength = Nt, e.sign.secretKeyLength = Wt, e.sign.seedLength = En, e.sign.signatureLength = Tn, e.hash = function(Ke) {
      Dt(Ke);
      var Qe = new Uint8Array(Lt);
      return ot(Qe, Ke, Ke.length), Qe;
    }, e.hash.hashLength = Lt, e.verify = function(Ke, Qe) {
      return Dt(Ke, Qe), Ke.length === 0 || Qe.length === 0 || Ke.length !== Qe.length ? !1 : me(Ke, 0, Qe, 0, Ke.length) === 0;
    }, e.setPRNG = function(Ke) {
      $ = Ke;
    }, function() {
      var Ke = typeof self < "u" ? self.crypto || self.msCrypto : null;
      if (Ke && Ke.getRandomValues) {
        var Qe = 65536;
        e.setPRNG(function(et, He) {
          var nt, qe = new Uint8Array(He);
          for (nt = 0; nt < He; nt += Qe)
            Ke.getRandomValues(qe.subarray(nt, nt + Math.min(He - nt, Qe)));
          for (nt = 0; nt < He; nt++) et[nt] = qe[nt];
          Gt(qe);
        });
      } else typeof commonjsRequire < "u" && (Ke = requireCryptoBrowserify(), Ke && Ke.randomBytes && e.setPRNG(function(et, He) {
        var nt, qe = Ke.randomBytes(He);
        for (nt = 0; nt < He; nt++) et[nt] = qe[nt];
        Gt(qe);
      }));
    }();
  })(C.exports ? C.exports : self.nacl = self.nacl || {});
})(naclFast);
var naclFastExports = naclFast.exports;
const nacl = /* @__PURE__ */ getDefaultExportFromCjs$2(naclFastExports);
var sha512$1 = { exports: {} };
(function(C) {
  (function() {
    var e = "input is invalid type", T = "finalize already called", $ = typeof window == "object", V = $ ? window : {};
    V.JS_SHA512_NO_WINDOW && ($ = !1);
    var J = !$ && typeof self == "object", ee = !V.JS_SHA512_NO_NODE_JS && typeof dist$2.process == "object" && dist$2.process.versions && dist$2.process.versions.node;
    ee ? V = commonjsGlobal$1 : J && (V = self);
    var te = !V.JS_SHA512_NO_COMMON_JS && !0 && C.exports, re = !V.JS_SHA512_NO_ARRAY_BUFFER && typeof ArrayBuffer < "u", ie = "0123456789abcdef".split(""), se = [-2147483648, 8388608, 32768, 128], de = [24, 16, 8, 0], ue = [
      1116352408,
      3609767458,
      1899447441,
      602891725,
      3049323471,
      3964484399,
      3921009573,
      2173295548,
      961987163,
      4081628472,
      1508970993,
      3053834265,
      2453635748,
      2937671579,
      2870763221,
      3664609560,
      3624381080,
      2734883394,
      310598401,
      1164996542,
      607225278,
      1323610764,
      1426881987,
      3590304994,
      1925078388,
      4068182383,
      2162078206,
      991336113,
      2614888103,
      633803317,
      3248222580,
      3479774868,
      3835390401,
      2666613458,
      4022224774,
      944711139,
      264347078,
      2341262773,
      604807628,
      2007800933,
      770255983,
      1495990901,
      1249150122,
      1856431235,
      1555081692,
      3175218132,
      1996064986,
      2198950837,
      2554220882,
      3999719339,
      2821834349,
      766784016,
      2952996808,
      2566594879,
      3210313671,
      3203337956,
      3336571891,
      1034457026,
      3584528711,
      2466948901,
      113926993,
      3758326383,
      338241895,
      168717936,
      666307205,
      1188179964,
      773529912,
      1546045734,
      1294757372,
      1522805485,
      1396182291,
      2643833823,
      1695183700,
      2343527390,
      1986661051,
      1014477480,
      2177026350,
      1206759142,
      2456956037,
      344077627,
      2730485921,
      1290863460,
      2820302411,
      3158454273,
      3259730800,
      3505952657,
      3345764771,
      106217008,
      3516065817,
      3606008344,
      3600352804,
      1432725776,
      4094571909,
      1467031594,
      275423344,
      851169720,
      430227734,
      3100823752,
      506948616,
      1363258195,
      659060556,
      3750685593,
      883997877,
      3785050280,
      958139571,
      3318307427,
      1322822218,
      3812723403,
      1537002063,
      2003034995,
      1747873779,
      3602036899,
      1955562222,
      1575990012,
      2024104815,
      1125592928,
      2227730452,
      2716904306,
      2361852424,
      442776044,
      2428436474,
      593698344,
      2756734187,
      3733110249,
      3204031479,
      2999351573,
      3329325298,
      3815920427,
      3391569614,
      3928383900,
      3515267271,
      566280711,
      3940187606,
      3454069534,
      4118630271,
      4000239992,
      116418474,
      1914138554,
      174292421,
      2731055270,
      289380356,
      3203993006,
      460393269,
      320620315,
      685471733,
      587496836,
      852142971,
      1086792851,
      1017036298,
      365543100,
      1126000580,
      2618297676,
      1288033470,
      3409855158,
      1501505948,
      4234509866,
      1607167915,
      987167468,
      1816402316,
      1246189591
    ], fe = ["hex", "array", "digest", "arrayBuffer"], he = [];
    (V.JS_SHA512_NO_NODE_JS || !Array.isArray) && (Array.isArray = function(Ie) {
      return Object.prototype.toString.call(Ie) === "[object Array]";
    }), re && (V.JS_SHA512_NO_ARRAY_BUFFER_IS_VIEW || !ArrayBuffer.isView) && (ArrayBuffer.isView = function(Ie) {
      return typeof Ie == "object" && Ie.buffer && Ie.buffer.constructor === ArrayBuffer;
    });
    var me = function(Ie, ke) {
      return function(_e) {
        return new we(ke, !0).update(_e)[Ie]();
      };
    }, xe = function(Ie) {
      var ke = me("hex", Ie);
      ke.create = function() {
        return new we(Ie);
      }, ke.update = function(Fe) {
        return ke.create().update(Fe);
      };
      for (var _e = 0; _e < fe.length; ++_e) {
        var De = fe[_e];
        ke[De] = me(De, Ie);
      }
      return ke;
    }, ve = function(Ie, ke) {
      return function(_e, De) {
        return new Ee(_e, ke, !0).update(De)[Ie]();
      };
    }, Te = function(Ie) {
      var ke = ve("hex", Ie);
      ke.create = function(Fe) {
        return new Ee(Fe, Ie);
      }, ke.update = function(Fe, Ae) {
        return ke.create(Fe).update(Ae);
      };
      for (var _e = 0; _e < fe.length; ++_e) {
        var De = fe[_e];
        ke[De] = ve(De, Ie);
      }
      return ke;
    };
    function we(Ie, ke) {
      ke ? (he[0] = he[1] = he[2] = he[3] = he[4] = he[5] = he[6] = he[7] = he[8] = he[9] = he[10] = he[11] = he[12] = he[13] = he[14] = he[15] = he[16] = he[17] = he[18] = he[19] = he[20] = he[21] = he[22] = he[23] = he[24] = he[25] = he[26] = he[27] = he[28] = he[29] = he[30] = he[31] = he[32] = 0, this.blocks = he) : this.blocks = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], Ie == 384 ? (this.h0h = 3418070365, this.h0l = 3238371032, this.h1h = 1654270250, this.h1l = 914150663, this.h2h = 2438529370, this.h2l = 812702999, this.h3h = 355462360, this.h3l = 4144912697, this.h4h = 1731405415, this.h4l = 4290775857, this.h5h = 2394180231, this.h5l = 1750603025, this.h6h = 3675008525, this.h6l = 1694076839, this.h7h = 1203062813, this.h7l = 3204075428) : Ie == 256 ? (this.h0h = 573645204, this.h0l = 4230739756, this.h1h = 2673172387, this.h1l = 3360449730, this.h2h = 596883563, this.h2l = 1867755857, this.h3h = 2520282905, this.h3l = 1497426621, this.h4h = 2519219938, this.h4l = 2827943907, this.h5h = 3193839141, this.h5l = 1401305490, this.h6h = 721525244, this.h6l = 746961066, this.h7h = 246885852, this.h7l = 2177182882) : Ie == 224 ? (this.h0h = 2352822216, this.h0l = 424955298, this.h1h = 1944164710, this.h1l = 2312950998, this.h2h = 502970286, this.h2l = 855612546, this.h3h = 1738396948, this.h3l = 1479516111, this.h4h = 258812777, this.h4l = 2077511080, this.h5h = 2011393907, this.h5l = 79989058, this.h6h = 1067287976, this.h6l = 1780299464, this.h7h = 286451373, this.h7l = 2446758561) : (this.h0h = 1779033703, this.h0l = 4089235720, this.h1h = 3144134277, this.h1l = 2227873595, this.h2h = 1013904242, this.h2l = 4271175723, this.h3h = 2773480762, this.h3l = 1595750129, this.h4h = 1359893119, this.h4l = 2917565137, this.h5h = 2600822924, this.h5l = 725511199, this.h6h = 528734635, this.h6l = 4215389547, this.h7h = 1541459225, this.h7l = 327033209), this.bits = Ie, this.block = this.start = this.bytes = this.hBytes = 0, this.finalized = this.hashed = !1;
    }
    we.prototype.update = function(Ie) {
      if (this.finalized)
        throw new Error(T);
      var ke, _e = typeof Ie;
      if (_e !== "string") {
        if (_e === "object") {
          if (Ie === null)
            throw new Error(e);
          if (re && Ie.constructor === ArrayBuffer)
            Ie = new Uint8Array(Ie);
          else if (!Array.isArray(Ie) && (!re || !ArrayBuffer.isView(Ie)))
            throw new Error(e);
        } else
          throw new Error(e);
        ke = !0;
      }
      for (var De, Fe = 0, Ae, ne = Ie.length, oe = this.blocks; Fe < ne; ) {
        if (this.hashed && (this.hashed = !1, oe[0] = this.block, oe[1] = oe[2] = oe[3] = oe[4] = oe[5] = oe[6] = oe[7] = oe[8] = oe[9] = oe[10] = oe[11] = oe[12] = oe[13] = oe[14] = oe[15] = oe[16] = oe[17] = oe[18] = oe[19] = oe[20] = oe[21] = oe[22] = oe[23] = oe[24] = oe[25] = oe[26] = oe[27] = oe[28] = oe[29] = oe[30] = oe[31] = oe[32] = 0), ke)
          for (Ae = this.start; Fe < ne && Ae < 128; ++Fe)
            oe[Ae >> 2] |= Ie[Fe] << de[Ae++ & 3];
        else
          for (Ae = this.start; Fe < ne && Ae < 128; ++Fe)
            De = Ie.charCodeAt(Fe), De < 128 ? oe[Ae >> 2] |= De << de[Ae++ & 3] : De < 2048 ? (oe[Ae >> 2] |= (192 | De >> 6) << de[Ae++ & 3], oe[Ae >> 2] |= (128 | De & 63) << de[Ae++ & 3]) : De < 55296 || De >= 57344 ? (oe[Ae >> 2] |= (224 | De >> 12) << de[Ae++ & 3], oe[Ae >> 2] |= (128 | De >> 6 & 63) << de[Ae++ & 3], oe[Ae >> 2] |= (128 | De & 63) << de[Ae++ & 3]) : (De = 65536 + ((De & 1023) << 10 | Ie.charCodeAt(++Fe) & 1023), oe[Ae >> 2] |= (240 | De >> 18) << de[Ae++ & 3], oe[Ae >> 2] |= (128 | De >> 12 & 63) << de[Ae++ & 3], oe[Ae >> 2] |= (128 | De >> 6 & 63) << de[Ae++ & 3], oe[Ae >> 2] |= (128 | De & 63) << de[Ae++ & 3]);
        this.lastByteIndex = Ae, this.bytes += Ae - this.start, Ae >= 128 ? (this.block = oe[32], this.start = Ae - 128, this.hash(), this.hashed = !0) : this.start = Ae;
      }
      return this.bytes > 4294967295 && (this.hBytes += this.bytes / 4294967296 << 0, this.bytes = this.bytes % 4294967296), this;
    }, we.prototype.finalize = function() {
      if (!this.finalized) {
        this.finalized = !0;
        var Ie = this.blocks, ke = this.lastByteIndex;
        Ie[32] = this.block, Ie[ke >> 2] |= se[ke & 3], this.block = Ie[32], ke >= 112 && (this.hashed || this.hash(), Ie[0] = this.block, Ie[1] = Ie[2] = Ie[3] = Ie[4] = Ie[5] = Ie[6] = Ie[7] = Ie[8] = Ie[9] = Ie[10] = Ie[11] = Ie[12] = Ie[13] = Ie[14] = Ie[15] = Ie[16] = Ie[17] = Ie[18] = Ie[19] = Ie[20] = Ie[21] = Ie[22] = Ie[23] = Ie[24] = Ie[25] = Ie[26] = Ie[27] = Ie[28] = Ie[29] = Ie[30] = Ie[31] = Ie[32] = 0), Ie[30] = this.hBytes << 3 | this.bytes >>> 29, Ie[31] = this.bytes << 3, this.hash();
      }
    }, we.prototype.hash = function() {
      var Ie = this.h0h, ke = this.h0l, _e = this.h1h, De = this.h1l, Fe = this.h2h, Ae = this.h2l, ne = this.h3h, oe = this.h3l, ce = this.h4h, le = this.h4l, pe = this.h5h, ye = this.h5l, Ce = this.h6h, be = this.h6l, ae = this.h7h, ge = this.h7l, Se = this.blocks, Le, ze, Re, We, Be, Ue, Ge, je, Oe, Ne, Ye, Je, Xe, st, ct, it, ot, yt, dt, mt, It, xt, Tt, Yt, Ve;
      for (Le = 32; Le < 160; Le += 2)
        mt = Se[Le - 30], It = Se[Le - 29], ze = (mt >>> 1 | It << 31) ^ (mt >>> 8 | It << 24) ^ mt >>> 7, Re = (It >>> 1 | mt << 31) ^ (It >>> 8 | mt << 24) ^ (It >>> 7 | mt << 25), mt = Se[Le - 4], It = Se[Le - 3], We = (mt >>> 19 | It << 13) ^ (It >>> 29 | mt << 3) ^ mt >>> 6, Be = (It >>> 19 | mt << 13) ^ (mt >>> 29 | It << 3) ^ (It >>> 6 | mt << 26), mt = Se[Le - 32], It = Se[Le - 31], xt = Se[Le - 14], Tt = Se[Le - 13], Ue = (Tt & 65535) + (It & 65535) + (Re & 65535) + (Be & 65535), Ge = (Tt >>> 16) + (It >>> 16) + (Re >>> 16) + (Be >>> 16) + (Ue >>> 16), je = (xt & 65535) + (mt & 65535) + (ze & 65535) + (We & 65535) + (Ge >>> 16), Oe = (xt >>> 16) + (mt >>> 16) + (ze >>> 16) + (We >>> 16) + (je >>> 16), Se[Le] = Oe << 16 | je & 65535, Se[Le + 1] = Ge << 16 | Ue & 65535;
      var Pe = Ie, $e = ke, Ze = _e, at = De, wt = Fe, ft = Ae, Ct = ne, Ut = oe, vt = ce, Mt = le, Xt = pe, St = ye, Ot = Ce, wn = be, kt = ae, Bt = ge;
      for (it = Ze & wt, ot = at & ft, Le = 0; Le < 160; Le += 8)
        ze = (Pe >>> 28 | $e << 4) ^ ($e >>> 2 | Pe << 30) ^ ($e >>> 7 | Pe << 25), Re = ($e >>> 28 | Pe << 4) ^ (Pe >>> 2 | $e << 30) ^ (Pe >>> 7 | $e << 25), We = (vt >>> 14 | Mt << 18) ^ (vt >>> 18 | Mt << 14) ^ (Mt >>> 9 | vt << 23), Be = (Mt >>> 14 | vt << 18) ^ (Mt >>> 18 | vt << 14) ^ (vt >>> 9 | Mt << 23), Ne = Pe & Ze, Ye = $e & at, yt = Ne ^ Pe & wt ^ it, dt = Ye ^ $e & ft ^ ot, Yt = vt & Xt ^ ~vt & Ot, Ve = Mt & St ^ ~Mt & wn, mt = Se[Le], It = Se[Le + 1], xt = ue[Le], Tt = ue[Le + 1], Ue = (Tt & 65535) + (It & 65535) + (Ve & 65535) + (Be & 65535) + (Bt & 65535), Ge = (Tt >>> 16) + (It >>> 16) + (Ve >>> 16) + (Be >>> 16) + (Bt >>> 16) + (Ue >>> 16), je = (xt & 65535) + (mt & 65535) + (Yt & 65535) + (We & 65535) + (kt & 65535) + (Ge >>> 16), Oe = (xt >>> 16) + (mt >>> 16) + (Yt >>> 16) + (We >>> 16) + (kt >>> 16) + (je >>> 16), mt = Oe << 16 | je & 65535, It = Ge << 16 | Ue & 65535, Ue = (dt & 65535) + (Re & 65535), Ge = (dt >>> 16) + (Re >>> 16) + (Ue >>> 16), je = (yt & 65535) + (ze & 65535) + (Ge >>> 16), Oe = (yt >>> 16) + (ze >>> 16) + (je >>> 16), xt = Oe << 16 | je & 65535, Tt = Ge << 16 | Ue & 65535, Ue = (Ut & 65535) + (It & 65535), Ge = (Ut >>> 16) + (It >>> 16) + (Ue >>> 16), je = (Ct & 65535) + (mt & 65535) + (Ge >>> 16), Oe = (Ct >>> 16) + (mt >>> 16) + (je >>> 16), kt = Oe << 16 | je & 65535, Bt = Ge << 16 | Ue & 65535, Ue = (Tt & 65535) + (It & 65535), Ge = (Tt >>> 16) + (It >>> 16) + (Ue >>> 16), je = (xt & 65535) + (mt & 65535) + (Ge >>> 16), Oe = (xt >>> 16) + (mt >>> 16) + (je >>> 16), Ct = Oe << 16 | je & 65535, Ut = Ge << 16 | Ue & 65535, ze = (Ct >>> 28 | Ut << 4) ^ (Ut >>> 2 | Ct << 30) ^ (Ut >>> 7 | Ct << 25), Re = (Ut >>> 28 | Ct << 4) ^ (Ct >>> 2 | Ut << 30) ^ (Ct >>> 7 | Ut << 25), We = (kt >>> 14 | Bt << 18) ^ (kt >>> 18 | Bt << 14) ^ (Bt >>> 9 | kt << 23), Be = (Bt >>> 14 | kt << 18) ^ (Bt >>> 18 | kt << 14) ^ (kt >>> 9 | Bt << 23), Je = Ct & Pe, Xe = Ut & $e, yt = Je ^ Ct & Ze ^ Ne, dt = Xe ^ Ut & at ^ Ye, Yt = kt & vt ^ ~kt & Xt, Ve = Bt & Mt ^ ~Bt & St, mt = Se[Le + 2], It = Se[Le + 3], xt = ue[Le + 2], Tt = ue[Le + 3], Ue = (Tt & 65535) + (It & 65535) + (Ve & 65535) + (Be & 65535) + (wn & 65535), Ge = (Tt >>> 16) + (It >>> 16) + (Ve >>> 16) + (Be >>> 16) + (wn >>> 16) + (Ue >>> 16), je = (xt & 65535) + (mt & 65535) + (Yt & 65535) + (We & 65535) + (Ot & 65535) + (Ge >>> 16), Oe = (xt >>> 16) + (mt >>> 16) + (Yt >>> 16) + (We >>> 16) + (Ot >>> 16) + (je >>> 16), mt = Oe << 16 | je & 65535, It = Ge << 16 | Ue & 65535, Ue = (dt & 65535) + (Re & 65535), Ge = (dt >>> 16) + (Re >>> 16) + (Ue >>> 16), je = (yt & 65535) + (ze & 65535) + (Ge >>> 16), Oe = (yt >>> 16) + (ze >>> 16) + (je >>> 16), xt = Oe << 16 | je & 65535, Tt = Ge << 16 | Ue & 65535, Ue = (ft & 65535) + (It & 65535), Ge = (ft >>> 16) + (It >>> 16) + (Ue >>> 16), je = (wt & 65535) + (mt & 65535) + (Ge >>> 16), Oe = (wt >>> 16) + (mt >>> 16) + (je >>> 16), Ot = Oe << 16 | je & 65535, wn = Ge << 16 | Ue & 65535, Ue = (Tt & 65535) + (It & 65535), Ge = (Tt >>> 16) + (It >>> 16) + (Ue >>> 16), je = (xt & 65535) + (mt & 65535) + (Ge >>> 16), Oe = (xt >>> 16) + (mt >>> 16) + (je >>> 16), wt = Oe << 16 | je & 65535, ft = Ge << 16 | Ue & 65535, ze = (wt >>> 28 | ft << 4) ^ (ft >>> 2 | wt << 30) ^ (ft >>> 7 | wt << 25), Re = (ft >>> 28 | wt << 4) ^ (wt >>> 2 | ft << 30) ^ (wt >>> 7 | ft << 25), We = (Ot >>> 14 | wn << 18) ^ (Ot >>> 18 | wn << 14) ^ (wn >>> 9 | Ot << 23), Be = (wn >>> 14 | Ot << 18) ^ (wn >>> 18 | Ot << 14) ^ (Ot >>> 9 | wn << 23), st = wt & Ct, ct = ft & Ut, yt = st ^ wt & Pe ^ Je, dt = ct ^ ft & $e ^ Xe, Yt = Ot & kt ^ ~Ot & vt, Ve = wn & Bt ^ ~wn & Mt, mt = Se[Le + 4], It = Se[Le + 5], xt = ue[Le + 4], Tt = ue[Le + 5], Ue = (Tt & 65535) + (It & 65535) + (Ve & 65535) + (Be & 65535) + (St & 65535), Ge = (Tt >>> 16) + (It >>> 16) + (Ve >>> 16) + (Be >>> 16) + (St >>> 16) + (Ue >>> 16), je = (xt & 65535) + (mt & 65535) + (Yt & 65535) + (We & 65535) + (Xt & 65535) + (Ge >>> 16), Oe = (xt >>> 16) + (mt >>> 16) + (Yt >>> 16) + (We >>> 16) + (Xt >>> 16) + (je >>> 16), mt = Oe << 16 | je & 65535, It = Ge << 16 | Ue & 65535, Ue = (dt & 65535) + (Re & 65535), Ge = (dt >>> 16) + (Re >>> 16) + (Ue >>> 16), je = (yt & 65535) + (ze & 65535) + (Ge >>> 16), Oe = (yt >>> 16) + (ze >>> 16) + (je >>> 16), xt = Oe << 16 | je & 65535, Tt = Ge << 16 | Ue & 65535, Ue = (at & 65535) + (It & 65535), Ge = (at >>> 16) + (It >>> 16) + (Ue >>> 16), je = (Ze & 65535) + (mt & 65535) + (Ge >>> 16), Oe = (Ze >>> 16) + (mt >>> 16) + (je >>> 16), Xt = Oe << 16 | je & 65535, St = Ge << 16 | Ue & 65535, Ue = (Tt & 65535) + (It & 65535), Ge = (Tt >>> 16) + (It >>> 16) + (Ue >>> 16), je = (xt & 65535) + (mt & 65535) + (Ge >>> 16), Oe = (xt >>> 16) + (mt >>> 16) + (je >>> 16), Ze = Oe << 16 | je & 65535, at = Ge << 16 | Ue & 65535, ze = (Ze >>> 28 | at << 4) ^ (at >>> 2 | Ze << 30) ^ (at >>> 7 | Ze << 25), Re = (at >>> 28 | Ze << 4) ^ (Ze >>> 2 | at << 30) ^ (Ze >>> 7 | at << 25), We = (Xt >>> 14 | St << 18) ^ (Xt >>> 18 | St << 14) ^ (St >>> 9 | Xt << 23), Be = (St >>> 14 | Xt << 18) ^ (St >>> 18 | Xt << 14) ^ (Xt >>> 9 | St << 23), it = Ze & wt, ot = at & ft, yt = it ^ Ze & Ct ^ st, dt = ot ^ at & Ut ^ ct, Yt = Xt & Ot ^ ~Xt & kt, Ve = St & wn ^ ~St & Bt, mt = Se[Le + 6], It = Se[Le + 7], xt = ue[Le + 6], Tt = ue[Le + 7], Ue = (Tt & 65535) + (It & 65535) + (Ve & 65535) + (Be & 65535) + (Mt & 65535), Ge = (Tt >>> 16) + (It >>> 16) + (Ve >>> 16) + (Be >>> 16) + (Mt >>> 16) + (Ue >>> 16), je = (xt & 65535) + (mt & 65535) + (Yt & 65535) + (We & 65535) + (vt & 65535) + (Ge >>> 16), Oe = (xt >>> 16) + (mt >>> 16) + (Yt >>> 16) + (We >>> 16) + (vt >>> 16) + (je >>> 16), mt = Oe << 16 | je & 65535, It = Ge << 16 | Ue & 65535, Ue = (dt & 65535) + (Re & 65535), Ge = (dt >>> 16) + (Re >>> 16) + (Ue >>> 16), je = (yt & 65535) + (ze & 65535) + (Ge >>> 16), Oe = (yt >>> 16) + (ze >>> 16) + (je >>> 16), xt = Oe << 16 | je & 65535, Tt = Ge << 16 | Ue & 65535, Ue = ($e & 65535) + (It & 65535), Ge = ($e >>> 16) + (It >>> 16) + (Ue >>> 16), je = (Pe & 65535) + (mt & 65535) + (Ge >>> 16), Oe = (Pe >>> 16) + (mt >>> 16) + (je >>> 16), vt = Oe << 16 | je & 65535, Mt = Ge << 16 | Ue & 65535, Ue = (Tt & 65535) + (It & 65535), Ge = (Tt >>> 16) + (It >>> 16) + (Ue >>> 16), je = (xt & 65535) + (mt & 65535) + (Ge >>> 16), Oe = (xt >>> 16) + (mt >>> 16) + (je >>> 16), Pe = Oe << 16 | je & 65535, $e = Ge << 16 | Ue & 65535;
      Ue = (ke & 65535) + ($e & 65535), Ge = (ke >>> 16) + ($e >>> 16) + (Ue >>> 16), je = (Ie & 65535) + (Pe & 65535) + (Ge >>> 16), Oe = (Ie >>> 16) + (Pe >>> 16) + (je >>> 16), this.h0h = Oe << 16 | je & 65535, this.h0l = Ge << 16 | Ue & 65535, Ue = (De & 65535) + (at & 65535), Ge = (De >>> 16) + (at >>> 16) + (Ue >>> 16), je = (_e & 65535) + (Ze & 65535) + (Ge >>> 16), Oe = (_e >>> 16) + (Ze >>> 16) + (je >>> 16), this.h1h = Oe << 16 | je & 65535, this.h1l = Ge << 16 | Ue & 65535, Ue = (Ae & 65535) + (ft & 65535), Ge = (Ae >>> 16) + (ft >>> 16) + (Ue >>> 16), je = (Fe & 65535) + (wt & 65535) + (Ge >>> 16), Oe = (Fe >>> 16) + (wt >>> 16) + (je >>> 16), this.h2h = Oe << 16 | je & 65535, this.h2l = Ge << 16 | Ue & 65535, Ue = (oe & 65535) + (Ut & 65535), Ge = (oe >>> 16) + (Ut >>> 16) + (Ue >>> 16), je = (ne & 65535) + (Ct & 65535) + (Ge >>> 16), Oe = (ne >>> 16) + (Ct >>> 16) + (je >>> 16), this.h3h = Oe << 16 | je & 65535, this.h3l = Ge << 16 | Ue & 65535, Ue = (le & 65535) + (Mt & 65535), Ge = (le >>> 16) + (Mt >>> 16) + (Ue >>> 16), je = (ce & 65535) + (vt & 65535) + (Ge >>> 16), Oe = (ce >>> 16) + (vt >>> 16) + (je >>> 16), this.h4h = Oe << 16 | je & 65535, this.h4l = Ge << 16 | Ue & 65535, Ue = (ye & 65535) + (St & 65535), Ge = (ye >>> 16) + (St >>> 16) + (Ue >>> 16), je = (pe & 65535) + (Xt & 65535) + (Ge >>> 16), Oe = (pe >>> 16) + (Xt >>> 16) + (je >>> 16), this.h5h = Oe << 16 | je & 65535, this.h5l = Ge << 16 | Ue & 65535, Ue = (be & 65535) + (wn & 65535), Ge = (be >>> 16) + (wn >>> 16) + (Ue >>> 16), je = (Ce & 65535) + (Ot & 65535) + (Ge >>> 16), Oe = (Ce >>> 16) + (Ot >>> 16) + (je >>> 16), this.h6h = Oe << 16 | je & 65535, this.h6l = Ge << 16 | Ue & 65535, Ue = (ge & 65535) + (Bt & 65535), Ge = (ge >>> 16) + (Bt >>> 16) + (Ue >>> 16), je = (ae & 65535) + (kt & 65535) + (Ge >>> 16), Oe = (ae >>> 16) + (kt >>> 16) + (je >>> 16), this.h7h = Oe << 16 | je & 65535, this.h7l = Ge << 16 | Ue & 65535;
    }, we.prototype.hex = function() {
      this.finalize();
      var Ie = this.h0h, ke = this.h0l, _e = this.h1h, De = this.h1l, Fe = this.h2h, Ae = this.h2l, ne = this.h3h, oe = this.h3l, ce = this.h4h, le = this.h4l, pe = this.h5h, ye = this.h5l, Ce = this.h6h, be = this.h6l, ae = this.h7h, ge = this.h7l, Se = this.bits, Le = ie[Ie >> 28 & 15] + ie[Ie >> 24 & 15] + ie[Ie >> 20 & 15] + ie[Ie >> 16 & 15] + ie[Ie >> 12 & 15] + ie[Ie >> 8 & 15] + ie[Ie >> 4 & 15] + ie[Ie & 15] + ie[ke >> 28 & 15] + ie[ke >> 24 & 15] + ie[ke >> 20 & 15] + ie[ke >> 16 & 15] + ie[ke >> 12 & 15] + ie[ke >> 8 & 15] + ie[ke >> 4 & 15] + ie[ke & 15] + ie[_e >> 28 & 15] + ie[_e >> 24 & 15] + ie[_e >> 20 & 15] + ie[_e >> 16 & 15] + ie[_e >> 12 & 15] + ie[_e >> 8 & 15] + ie[_e >> 4 & 15] + ie[_e & 15] + ie[De >> 28 & 15] + ie[De >> 24 & 15] + ie[De >> 20 & 15] + ie[De >> 16 & 15] + ie[De >> 12 & 15] + ie[De >> 8 & 15] + ie[De >> 4 & 15] + ie[De & 15] + ie[Fe >> 28 & 15] + ie[Fe >> 24 & 15] + ie[Fe >> 20 & 15] + ie[Fe >> 16 & 15] + ie[Fe >> 12 & 15] + ie[Fe >> 8 & 15] + ie[Fe >> 4 & 15] + ie[Fe & 15] + ie[Ae >> 28 & 15] + ie[Ae >> 24 & 15] + ie[Ae >> 20 & 15] + ie[Ae >> 16 & 15] + ie[Ae >> 12 & 15] + ie[Ae >> 8 & 15] + ie[Ae >> 4 & 15] + ie[Ae & 15] + ie[ne >> 28 & 15] + ie[ne >> 24 & 15] + ie[ne >> 20 & 15] + ie[ne >> 16 & 15] + ie[ne >> 12 & 15] + ie[ne >> 8 & 15] + ie[ne >> 4 & 15] + ie[ne & 15];
      return Se >= 256 && (Le += ie[oe >> 28 & 15] + ie[oe >> 24 & 15] + ie[oe >> 20 & 15] + ie[oe >> 16 & 15] + ie[oe >> 12 & 15] + ie[oe >> 8 & 15] + ie[oe >> 4 & 15] + ie[oe & 15]), Se >= 384 && (Le += ie[ce >> 28 & 15] + ie[ce >> 24 & 15] + ie[ce >> 20 & 15] + ie[ce >> 16 & 15] + ie[ce >> 12 & 15] + ie[ce >> 8 & 15] + ie[ce >> 4 & 15] + ie[ce & 15] + ie[le >> 28 & 15] + ie[le >> 24 & 15] + ie[le >> 20 & 15] + ie[le >> 16 & 15] + ie[le >> 12 & 15] + ie[le >> 8 & 15] + ie[le >> 4 & 15] + ie[le & 15] + ie[pe >> 28 & 15] + ie[pe >> 24 & 15] + ie[pe >> 20 & 15] + ie[pe >> 16 & 15] + ie[pe >> 12 & 15] + ie[pe >> 8 & 15] + ie[pe >> 4 & 15] + ie[pe & 15] + ie[ye >> 28 & 15] + ie[ye >> 24 & 15] + ie[ye >> 20 & 15] + ie[ye >> 16 & 15] + ie[ye >> 12 & 15] + ie[ye >> 8 & 15] + ie[ye >> 4 & 15] + ie[ye & 15]), Se == 512 && (Le += ie[Ce >> 28 & 15] + ie[Ce >> 24 & 15] + ie[Ce >> 20 & 15] + ie[Ce >> 16 & 15] + ie[Ce >> 12 & 15] + ie[Ce >> 8 & 15] + ie[Ce >> 4 & 15] + ie[Ce & 15] + ie[be >> 28 & 15] + ie[be >> 24 & 15] + ie[be >> 20 & 15] + ie[be >> 16 & 15] + ie[be >> 12 & 15] + ie[be >> 8 & 15] + ie[be >> 4 & 15] + ie[be & 15] + ie[ae >> 28 & 15] + ie[ae >> 24 & 15] + ie[ae >> 20 & 15] + ie[ae >> 16 & 15] + ie[ae >> 12 & 15] + ie[ae >> 8 & 15] + ie[ae >> 4 & 15] + ie[ae & 15] + ie[ge >> 28 & 15] + ie[ge >> 24 & 15] + ie[ge >> 20 & 15] + ie[ge >> 16 & 15] + ie[ge >> 12 & 15] + ie[ge >> 8 & 15] + ie[ge >> 4 & 15] + ie[ge & 15]), Le;
    }, we.prototype.toString = we.prototype.hex, we.prototype.digest = function() {
      this.finalize();
      var Ie = this.h0h, ke = this.h0l, _e = this.h1h, De = this.h1l, Fe = this.h2h, Ae = this.h2l, ne = this.h3h, oe = this.h3l, ce = this.h4h, le = this.h4l, pe = this.h5h, ye = this.h5l, Ce = this.h6h, be = this.h6l, ae = this.h7h, ge = this.h7l, Se = this.bits, Le = [
        Ie >> 24 & 255,
        Ie >> 16 & 255,
        Ie >> 8 & 255,
        Ie & 255,
        ke >> 24 & 255,
        ke >> 16 & 255,
        ke >> 8 & 255,
        ke & 255,
        _e >> 24 & 255,
        _e >> 16 & 255,
        _e >> 8 & 255,
        _e & 255,
        De >> 24 & 255,
        De >> 16 & 255,
        De >> 8 & 255,
        De & 255,
        Fe >> 24 & 255,
        Fe >> 16 & 255,
        Fe >> 8 & 255,
        Fe & 255,
        Ae >> 24 & 255,
        Ae >> 16 & 255,
        Ae >> 8 & 255,
        Ae & 255,
        ne >> 24 & 255,
        ne >> 16 & 255,
        ne >> 8 & 255,
        ne & 255
      ];
      return Se >= 256 && Le.push(oe >> 24 & 255, oe >> 16 & 255, oe >> 8 & 255, oe & 255), Se >= 384 && Le.push(
        ce >> 24 & 255,
        ce >> 16 & 255,
        ce >> 8 & 255,
        ce & 255,
        le >> 24 & 255,
        le >> 16 & 255,
        le >> 8 & 255,
        le & 255,
        pe >> 24 & 255,
        pe >> 16 & 255,
        pe >> 8 & 255,
        pe & 255,
        ye >> 24 & 255,
        ye >> 16 & 255,
        ye >> 8 & 255,
        ye & 255
      ), Se == 512 && Le.push(
        Ce >> 24 & 255,
        Ce >> 16 & 255,
        Ce >> 8 & 255,
        Ce & 255,
        be >> 24 & 255,
        be >> 16 & 255,
        be >> 8 & 255,
        be & 255,
        ae >> 24 & 255,
        ae >> 16 & 255,
        ae >> 8 & 255,
        ae & 255,
        ge >> 24 & 255,
        ge >> 16 & 255,
        ge >> 8 & 255,
        ge & 255
      ), Le;
    }, we.prototype.array = we.prototype.digest, we.prototype.arrayBuffer = function() {
      this.finalize();
      var Ie = this.bits, ke = new ArrayBuffer(Ie / 8), _e = new DataView(ke);
      return _e.setUint32(0, this.h0h), _e.setUint32(4, this.h0l), _e.setUint32(8, this.h1h), _e.setUint32(12, this.h1l), _e.setUint32(16, this.h2h), _e.setUint32(20, this.h2l), _e.setUint32(24, this.h3h), Ie >= 256 && _e.setUint32(28, this.h3l), Ie >= 384 && (_e.setUint32(32, this.h4h), _e.setUint32(36, this.h4l), _e.setUint32(40, this.h5h), _e.setUint32(44, this.h5l)), Ie == 512 && (_e.setUint32(48, this.h6h), _e.setUint32(52, this.h6l), _e.setUint32(56, this.h7h), _e.setUint32(60, this.h7l)), ke;
    }, we.prototype.clone = function() {
      var Ie = new we(this.bits, !1);
      return this.copyTo(Ie), Ie;
    }, we.prototype.copyTo = function(Ie) {
      var ke = 0, _e = [
        "h0h",
        "h0l",
        "h1h",
        "h1l",
        "h2h",
        "h2l",
        "h3h",
        "h3l",
        "h4h",
        "h4l",
        "h5h",
        "h5l",
        "h6h",
        "h6l",
        "h7h",
        "h7l",
        "start",
        "bytes",
        "hBytes",
        "finalized",
        "hashed",
        "lastByteIndex"
      ];
      for (ke = 0; ke < _e.length; ++ke)
        Ie[_e[ke]] = this[_e[ke]];
      for (ke = 0; ke < this.blocks.length; ++ke)
        Ie.blocks[ke] = this.blocks[ke];
    };
    function Ee(Ie, ke, _e) {
      var De, Fe = typeof Ie;
      if (Fe !== "string") {
        if (Fe === "object") {
          if (Ie === null)
            throw new Error(e);
          if (re && Ie.constructor === ArrayBuffer)
            Ie = new Uint8Array(Ie);
          else if (!Array.isArray(Ie) && (!re || !ArrayBuffer.isView(Ie)))
            throw new Error(e);
        } else
          throw new Error(e);
        De = !0;
      }
      var Ae = Ie.length;
      if (!De) {
        for (var ne = [], Ae = Ie.length, oe = 0, ce, le = 0; le < Ae; ++le)
          ce = Ie.charCodeAt(le), ce < 128 ? ne[oe++] = ce : ce < 2048 ? (ne[oe++] = 192 | ce >> 6, ne[oe++] = 128 | ce & 63) : ce < 55296 || ce >= 57344 ? (ne[oe++] = 224 | ce >> 12, ne[oe++] = 128 | ce >> 6 & 63, ne[oe++] = 128 | ce & 63) : (ce = 65536 + ((ce & 1023) << 10 | Ie.charCodeAt(++le) & 1023), ne[oe++] = 240 | ce >> 18, ne[oe++] = 128 | ce >> 12 & 63, ne[oe++] = 128 | ce >> 6 & 63, ne[oe++] = 128 | ce & 63);
        Ie = ne;
      }
      Ie.length > 128 && (Ie = new we(ke, !0).update(Ie).array());
      for (var pe = [], ye = [], le = 0; le < 128; ++le) {
        var Ce = Ie[le] || 0;
        pe[le] = 92 ^ Ce, ye[le] = 54 ^ Ce;
      }
      we.call(this, ke, _e), this.update(ye), this.oKeyPad = pe, this.inner = !0, this.sharedMemory = _e;
    }
    Ee.prototype = new we(), Ee.prototype.finalize = function() {
      if (we.prototype.finalize.call(this), this.inner) {
        this.inner = !1;
        var Ie = this.array();
        we.call(this, this.bits, this.sharedMemory), this.update(this.oKeyPad), this.update(Ie), we.prototype.finalize.call(this);
      }
    }, Ee.prototype.clone = function() {
      var Ie = new Ee([], this.bits, !1);
      this.copyTo(Ie), Ie.inner = this.inner;
      for (var ke = 0; ke < this.oKeyPad.length; ++ke)
        Ie.oKeyPad[ke] = this.oKeyPad[ke];
      return Ie;
    };
    var Me = xe(512);
    Me.sha512 = Me, Me.sha384 = xe(384), Me.sha512_256 = xe(256), Me.sha512_224 = xe(224), Me.sha512.hmac = Te(512), Me.sha384.hmac = Te(384), Me.sha512_256.hmac = Te(256), Me.sha512_224.hmac = Te(224), te ? C.exports = Me : (V.sha512 = Me.sha512, V.sha384 = Me.sha384, V.sha512_256 = Me.sha512_256, V.sha512_224 = Me.sha512_224);
  })();
})(sha512$1);
var sha512Exports = sha512$1.exports;
const sha512 = /* @__PURE__ */ getDefaultExportFromCjs$2(sha512Exports);
var jsonBigint = { exports: {} }, stringify$1 = { exports: {} }, bignumber = { exports: {} };
(function(C) {
  (function(e) {
    var T, $ = /^-?(?:\d+(?:\.\d*)?|\.\d+)(?:e[+-]?\d+)?$/i, V = Math.ceil, J = Math.floor, ee = "[BigNumber Error] ", te = ee + "Number primitive has more than 15 significant digits: ", re = 1e14, ie = 14, se = 9007199254740991, de = [1, 10, 100, 1e3, 1e4, 1e5, 1e6, 1e7, 1e8, 1e9, 1e10, 1e11, 1e12, 1e13], ue = 1e7, fe = 1e9;
    function he(Ie) {
      var ke, _e, De, Fe = ze.prototype = { constructor: ze, toString: null, valueOf: null }, Ae = new ze(1), ne = 20, oe = 4, ce = -7, le = 21, pe = -1e7, ye = 1e7, Ce = !1, be = 1, ae = 0, ge = {
        prefix: "",
        groupSize: 3,
        secondaryGroupSize: 0,
        groupSeparator: ",",
        decimalSeparator: ".",
        fractionGroupSize: 0,
        fractionGroupSeparator: " ",
        // non-breaking space
        suffix: ""
      }, Se = "0123456789abcdefghijklmnopqrstuvwxyz", Le = !0;
      function ze(je, Oe) {
        var Ne, Ye, Je, Xe, st, ct, it, ot, yt = this;
        if (!(yt instanceof ze)) return new ze(je, Oe);
        if (Oe == null) {
          if (je && je._isBigNumber === !0) {
            yt.s = je.s, !je.c || je.e > ye ? yt.c = yt.e = null : je.e < pe ? yt.c = [yt.e = 0] : (yt.e = je.e, yt.c = je.c.slice());
            return;
          }
          if ((ct = typeof je == "number") && je * 0 == 0) {
            if (yt.s = 1 / je < 0 ? (je = -je, -1) : 1, je === ~~je) {
              for (Xe = 0, st = je; st >= 10; st /= 10, Xe++) ;
              Xe > ye ? yt.c = yt.e = null : (yt.e = Xe, yt.c = [je]);
              return;
            }
            ot = String(je);
          } else {
            if (!$.test(ot = String(je))) return De(yt, ot, ct);
            yt.s = ot.charCodeAt(0) == 45 ? (ot = ot.slice(1), -1) : 1;
          }
          (Xe = ot.indexOf(".")) > -1 && (ot = ot.replace(".", "")), (st = ot.search(/e/i)) > 0 ? (Xe < 0 && (Xe = st), Xe += +ot.slice(st + 1), ot = ot.substring(0, st)) : Xe < 0 && (Xe = ot.length);
        } else {
          if (Te(Oe, 2, Se.length, "Base"), Oe == 10 && Le)
            return yt = new ze(je), Ue(yt, ne + yt.e + 1, oe);
          if (ot = String(je), ct = typeof je == "number") {
            if (je * 0 != 0) return De(yt, ot, ct, Oe);
            if (yt.s = 1 / je < 0 ? (ot = ot.slice(1), -1) : 1, ze.DEBUG && ot.replace(/^0\.0*|\./, "").length > 15)
              throw Error(te + je);
          } else
            yt.s = ot.charCodeAt(0) === 45 ? (ot = ot.slice(1), -1) : 1;
          for (Ne = Se.slice(0, Oe), Xe = st = 0, it = ot.length; st < it; st++)
            if (Ne.indexOf(Ye = ot.charAt(st)) < 0) {
              if (Ye == ".") {
                if (st > Xe) {
                  Xe = it;
                  continue;
                }
              } else if (!Je && (ot == ot.toUpperCase() && (ot = ot.toLowerCase()) || ot == ot.toLowerCase() && (ot = ot.toUpperCase()))) {
                Je = !0, st = -1, Xe = 0;
                continue;
              }
              return De(yt, String(je), ct, Oe);
            }
          ct = !1, ot = _e(ot, Oe, 10, yt.s), (Xe = ot.indexOf(".")) > -1 ? ot = ot.replace(".", "") : Xe = ot.length;
        }
        for (st = 0; ot.charCodeAt(st) === 48; st++) ;
        for (it = ot.length; ot.charCodeAt(--it) === 48; ) ;
        if (ot = ot.slice(st, ++it)) {
          if (it -= st, ct && ze.DEBUG && it > 15 && (je > se || je !== J(je)))
            throw Error(te + yt.s * je);
          if ((Xe = Xe - st - 1) > ye)
            yt.c = yt.e = null;
          else if (Xe < pe)
            yt.c = [yt.e = 0];
          else {
            if (yt.e = Xe, yt.c = [], st = (Xe + 1) % ie, Xe < 0 && (st += ie), st < it) {
              for (st && yt.c.push(+ot.slice(0, st)), it -= ie; st < it; )
                yt.c.push(+ot.slice(st, st += ie));
              st = ie - (ot = ot.slice(st)).length;
            } else
              st -= it;
            for (; st--; ot += "0") ;
            yt.c.push(+ot);
          }
        } else
          yt.c = [yt.e = 0];
      }
      ze.clone = he, ze.ROUND_UP = 0, ze.ROUND_DOWN = 1, ze.ROUND_CEIL = 2, ze.ROUND_FLOOR = 3, ze.ROUND_HALF_UP = 4, ze.ROUND_HALF_DOWN = 5, ze.ROUND_HALF_EVEN = 6, ze.ROUND_HALF_CEIL = 7, ze.ROUND_HALF_FLOOR = 8, ze.EUCLID = 9, ze.config = ze.set = function(je) {
        var Oe, Ne;
        if (je != null)
          if (typeof je == "object") {
            if (je.hasOwnProperty(Oe = "DECIMAL_PLACES") && (Ne = je[Oe], Te(Ne, 0, fe, Oe), ne = Ne), je.hasOwnProperty(Oe = "ROUNDING_MODE") && (Ne = je[Oe], Te(Ne, 0, 8, Oe), oe = Ne), je.hasOwnProperty(Oe = "EXPONENTIAL_AT") && (Ne = je[Oe], Ne && Ne.pop ? (Te(Ne[0], -fe, 0, Oe), Te(Ne[1], 0, fe, Oe), ce = Ne[0], le = Ne[1]) : (Te(Ne, -fe, fe, Oe), ce = -(le = Ne < 0 ? -Ne : Ne))), je.hasOwnProperty(Oe = "RANGE"))
              if (Ne = je[Oe], Ne && Ne.pop)
                Te(Ne[0], -fe, -1, Oe), Te(Ne[1], 1, fe, Oe), pe = Ne[0], ye = Ne[1];
              else if (Te(Ne, -fe, fe, Oe), Ne)
                pe = -(ye = Ne < 0 ? -Ne : Ne);
              else
                throw Error(ee + Oe + " cannot be zero: " + Ne);
            if (je.hasOwnProperty(Oe = "CRYPTO"))
              if (Ne = je[Oe], Ne === !!Ne)
                if (Ne)
                  if (typeof crypto < "u" && crypto && (crypto.getRandomValues || crypto.randomBytes))
                    Ce = Ne;
                  else
                    throw Ce = !Ne, Error(ee + "crypto unavailable");
                else
                  Ce = Ne;
              else
                throw Error(ee + Oe + " not true or false: " + Ne);
            if (je.hasOwnProperty(Oe = "MODULO_MODE") && (Ne = je[Oe], Te(Ne, 0, 9, Oe), be = Ne), je.hasOwnProperty(Oe = "POW_PRECISION") && (Ne = je[Oe], Te(Ne, 0, fe, Oe), ae = Ne), je.hasOwnProperty(Oe = "FORMAT"))
              if (Ne = je[Oe], typeof Ne == "object") ge = Ne;
              else throw Error(ee + Oe + " not an object: " + Ne);
            if (je.hasOwnProperty(Oe = "ALPHABET"))
              if (Ne = je[Oe], typeof Ne == "string" && !/^.?$|[+\-.\s]|(.).*\1/.test(Ne))
                Le = Ne.slice(0, 10) == "0123456789", Se = Ne;
              else
                throw Error(ee + Oe + " invalid: " + Ne);
          } else
            throw Error(ee + "Object expected: " + je);
        return {
          DECIMAL_PLACES: ne,
          ROUNDING_MODE: oe,
          EXPONENTIAL_AT: [ce, le],
          RANGE: [pe, ye],
          CRYPTO: Ce,
          MODULO_MODE: be,
          POW_PRECISION: ae,
          FORMAT: ge,
          ALPHABET: Se
        };
      }, ze.isBigNumber = function(je) {
        if (!je || je._isBigNumber !== !0) return !1;
        if (!ze.DEBUG) return !0;
        var Oe, Ne, Ye = je.c, Je = je.e, Xe = je.s;
        e: if ({}.toString.call(Ye) == "[object Array]") {
          if ((Xe === 1 || Xe === -1) && Je >= -fe && Je <= fe && Je === J(Je)) {
            if (Ye[0] === 0) {
              if (Je === 0 && Ye.length === 1) return !0;
              break e;
            }
            if (Oe = (Je + 1) % ie, Oe < 1 && (Oe += ie), String(Ye[0]).length == Oe) {
              for (Oe = 0; Oe < Ye.length; Oe++)
                if (Ne = Ye[Oe], Ne < 0 || Ne >= re || Ne !== J(Ne)) break e;
              if (Ne !== 0) return !0;
            }
          }
        } else if (Ye === null && Je === null && (Xe === null || Xe === 1 || Xe === -1))
          return !0;
        throw Error(ee + "Invalid BigNumber: " + je);
      }, ze.maximum = ze.max = function() {
        return We(arguments, -1);
      }, ze.minimum = ze.min = function() {
        return We(arguments, 1);
      }, ze.random = function() {
        var je = 9007199254740992, Oe = Math.random() * je & 2097151 ? function() {
          return J(Math.random() * je);
        } : function() {
          return (Math.random() * 1073741824 | 0) * 8388608 + (Math.random() * 8388608 | 0);
        };
        return function(Ne) {
          var Ye, Je, Xe, st, ct, it = 0, ot = [], yt = new ze(Ae);
          if (Ne == null ? Ne = ne : Te(Ne, 0, fe), st = V(Ne / ie), Ce)
            if (crypto.getRandomValues) {
              for (Ye = crypto.getRandomValues(new Uint32Array(st *= 2)); it < st; )
                ct = Ye[it] * 131072 + (Ye[it + 1] >>> 11), ct >= 9e15 ? (Je = crypto.getRandomValues(new Uint32Array(2)), Ye[it] = Je[0], Ye[it + 1] = Je[1]) : (ot.push(ct % 1e14), it += 2);
              it = st / 2;
            } else if (crypto.randomBytes) {
              for (Ye = crypto.randomBytes(st *= 7); it < st; )
                ct = (Ye[it] & 31) * 281474976710656 + Ye[it + 1] * 1099511627776 + Ye[it + 2] * 4294967296 + Ye[it + 3] * 16777216 + (Ye[it + 4] << 16) + (Ye[it + 5] << 8) + Ye[it + 6], ct >= 9e15 ? crypto.randomBytes(7).copy(Ye, it) : (ot.push(ct % 1e14), it += 7);
              it = st / 7;
            } else
              throw Ce = !1, Error(ee + "crypto unavailable");
          if (!Ce)
            for (; it < st; )
              ct = Oe(), ct < 9e15 && (ot[it++] = ct % 1e14);
          for (st = ot[--it], Ne %= ie, st && Ne && (ct = de[ie - Ne], ot[it] = J(st / ct) * ct); ot[it] === 0; ot.pop(), it--) ;
          if (it < 0)
            ot = [Xe = 0];
          else {
            for (Xe = -1; ot[0] === 0; ot.splice(0, 1), Xe -= ie) ;
            for (it = 1, ct = ot[0]; ct >= 10; ct /= 10, it++) ;
            it < ie && (Xe -= ie - it);
          }
          return yt.e = Xe, yt.c = ot, yt;
        };
      }(), ze.sum = function() {
        for (var je = 1, Oe = arguments, Ne = new ze(Oe[0]); je < Oe.length; ) Ne = Ne.plus(Oe[je++]);
        return Ne;
      }, _e = /* @__PURE__ */ function() {
        var je = "0123456789";
        function Oe(Ne, Ye, Je, Xe) {
          for (var st, ct = [0], it, ot = 0, yt = Ne.length; ot < yt; ) {
            for (it = ct.length; it--; ct[it] *= Ye) ;
            for (ct[0] += Xe.indexOf(Ne.charAt(ot++)), st = 0; st < ct.length; st++)
              ct[st] > Je - 1 && (ct[st + 1] == null && (ct[st + 1] = 0), ct[st + 1] += ct[st] / Je | 0, ct[st] %= Je);
          }
          return ct.reverse();
        }
        return function(Ne, Ye, Je, Xe, st) {
          var ct, it, ot, yt, dt, mt, It, xt, Tt = Ne.indexOf("."), Yt = ne, Ve = oe;
          for (Tt >= 0 && (yt = ae, ae = 0, Ne = Ne.replace(".", ""), xt = new ze(Ye), mt = xt.pow(Ne.length - Tt), ae = yt, xt.c = Oe(
            Me(xe(mt.c), mt.e, "0"),
            10,
            Je,
            je
          ), xt.e = xt.c.length), It = Oe(Ne, Ye, Je, st ? (ct = Se, je) : (ct = je, Se)), ot = yt = It.length; It[--yt] == 0; It.pop()) ;
          if (!It[0]) return ct.charAt(0);
          if (Tt < 0 ? --ot : (mt.c = It, mt.e = ot, mt.s = Xe, mt = ke(mt, xt, Yt, Ve, Je), It = mt.c, dt = mt.r, ot = mt.e), it = ot + Yt + 1, Tt = It[it], yt = Je / 2, dt = dt || it < 0 || It[it + 1] != null, dt = Ve < 4 ? (Tt != null || dt) && (Ve == 0 || Ve == (mt.s < 0 ? 3 : 2)) : Tt > yt || Tt == yt && (Ve == 4 || dt || Ve == 6 && It[it - 1] & 1 || Ve == (mt.s < 0 ? 8 : 7)), it < 1 || !It[0])
            Ne = dt ? Me(ct.charAt(1), -Yt, ct.charAt(0)) : ct.charAt(0);
          else {
            if (It.length = it, dt)
              for (--Je; ++It[--it] > Je; )
                It[it] = 0, it || (++ot, It = [1].concat(It));
            for (yt = It.length; !It[--yt]; ) ;
            for (Tt = 0, Ne = ""; Tt <= yt; Ne += ct.charAt(It[Tt++])) ;
            Ne = Me(Ne, ot, ct.charAt(0));
          }
          return Ne;
        };
      }(), ke = /* @__PURE__ */ function() {
        function je(Ye, Je, Xe) {
          var st, ct, it, ot, yt = 0, dt = Ye.length, mt = Je % ue, It = Je / ue | 0;
          for (Ye = Ye.slice(); dt--; )
            it = Ye[dt] % ue, ot = Ye[dt] / ue | 0, st = It * it + ot * mt, ct = mt * it + st % ue * ue + yt, yt = (ct / Xe | 0) + (st / ue | 0) + It * ot, Ye[dt] = ct % Xe;
          return yt && (Ye = [yt].concat(Ye)), Ye;
        }
        function Oe(Ye, Je, Xe, st) {
          var ct, it;
          if (Xe != st)
            it = Xe > st ? 1 : -1;
          else
            for (ct = it = 0; ct < Xe; ct++)
              if (Ye[ct] != Je[ct]) {
                it = Ye[ct] > Je[ct] ? 1 : -1;
                break;
              }
          return it;
        }
        function Ne(Ye, Je, Xe, st) {
          for (var ct = 0; Xe--; )
            Ye[Xe] -= ct, ct = Ye[Xe] < Je[Xe] ? 1 : 0, Ye[Xe] = ct * st + Ye[Xe] - Je[Xe];
          for (; !Ye[0] && Ye.length > 1; Ye.splice(0, 1)) ;
        }
        return function(Ye, Je, Xe, st, ct) {
          var it, ot, yt, dt, mt, It, xt, Tt, Yt, Ve, Pe, $e, Ze, at, wt, ft, Ct, Ut = Ye.s == Je.s ? 1 : -1, vt = Ye.c, Mt = Je.c;
          if (!vt || !vt[0] || !Mt || !Mt[0])
            return new ze(
              // Return NaN if either NaN, or both Infinity or 0.
              !Ye.s || !Je.s || (vt ? Mt && vt[0] == Mt[0] : !Mt) ? NaN : (
                // Return ±0 if x is ±0 or y is ±Infinity, or return ±Infinity as y is ±0.
                vt && vt[0] == 0 || !Mt ? Ut * 0 : Ut / 0
              )
            );
          for (Tt = new ze(Ut), Yt = Tt.c = [], ot = Ye.e - Je.e, Ut = Xe + ot + 1, ct || (ct = re, ot = me(Ye.e / ie) - me(Je.e / ie), Ut = Ut / ie | 0), yt = 0; Mt[yt] == (vt[yt] || 0); yt++) ;
          if (Mt[yt] > (vt[yt] || 0) && ot--, Ut < 0)
            Yt.push(1), dt = !0;
          else {
            for (at = vt.length, ft = Mt.length, yt = 0, Ut += 2, mt = J(ct / (Mt[0] + 1)), mt > 1 && (Mt = je(Mt, mt, ct), vt = je(vt, mt, ct), ft = Mt.length, at = vt.length), Ze = ft, Ve = vt.slice(0, ft), Pe = Ve.length; Pe < ft; Ve[Pe++] = 0) ;
            Ct = Mt.slice(), Ct = [0].concat(Ct), wt = Mt[0], Mt[1] >= ct / 2 && wt++;
            do {
              if (mt = 0, it = Oe(Mt, Ve, ft, Pe), it < 0) {
                if ($e = Ve[0], ft != Pe && ($e = $e * ct + (Ve[1] || 0)), mt = J($e / wt), mt > 1)
                  for (mt >= ct && (mt = ct - 1), It = je(Mt, mt, ct), xt = It.length, Pe = Ve.length; Oe(It, Ve, xt, Pe) == 1; )
                    mt--, Ne(It, ft < xt ? Ct : Mt, xt, ct), xt = It.length, it = 1;
                else
                  mt == 0 && (it = mt = 1), It = Mt.slice(), xt = It.length;
                if (xt < Pe && (It = [0].concat(It)), Ne(Ve, It, Pe, ct), Pe = Ve.length, it == -1)
                  for (; Oe(Mt, Ve, ft, Pe) < 1; )
                    mt++, Ne(Ve, ft < Pe ? Ct : Mt, Pe, ct), Pe = Ve.length;
              } else it === 0 && (mt++, Ve = [0]);
              Yt[yt++] = mt, Ve[0] ? Ve[Pe++] = vt[Ze] || 0 : (Ve = [vt[Ze]], Pe = 1);
            } while ((Ze++ < at || Ve[0] != null) && Ut--);
            dt = Ve[0] != null, Yt[0] || Yt.splice(0, 1);
          }
          if (ct == re) {
            for (yt = 1, Ut = Yt[0]; Ut >= 10; Ut /= 10, yt++) ;
            Ue(Tt, Xe + (Tt.e = yt + ot * ie - 1) + 1, st, dt);
          } else
            Tt.e = ot, Tt.r = +dt;
          return Tt;
        };
      }();
      function Re(je, Oe, Ne, Ye) {
        var Je, Xe, st, ct, it;
        if (Ne == null ? Ne = oe : Te(Ne, 0, 8), !je.c) return je.toString();
        if (Je = je.c[0], st = je.e, Oe == null)
          it = xe(je.c), it = Ye == 1 || Ye == 2 && (st <= ce || st >= le) ? Ee(it, st) : Me(it, st, "0");
        else if (je = Ue(new ze(je), Oe, Ne), Xe = je.e, it = xe(je.c), ct = it.length, Ye == 1 || Ye == 2 && (Oe <= Xe || Xe <= ce)) {
          for (; ct < Oe; it += "0", ct++) ;
          it = Ee(it, Xe);
        } else if (Oe -= st, it = Me(it, Xe, "0"), Xe + 1 > ct) {
          if (--Oe > 0) for (it += "."; Oe--; it += "0") ;
        } else if (Oe += Xe - ct, Oe > 0)
          for (Xe + 1 == ct && (it += "."); Oe--; it += "0") ;
        return je.s < 0 && Je ? "-" + it : it;
      }
      function We(je, Oe) {
        for (var Ne, Ye, Je = 1, Xe = new ze(je[0]); Je < je.length; Je++)
          Ye = new ze(je[Je]), (!Ye.s || (Ne = ve(Xe, Ye)) === Oe || Ne === 0 && Xe.s === Oe) && (Xe = Ye);
        return Xe;
      }
      function Be(je, Oe, Ne) {
        for (var Ye = 1, Je = Oe.length; !Oe[--Je]; Oe.pop()) ;
        for (Je = Oe[0]; Je >= 10; Je /= 10, Ye++) ;
        return (Ne = Ye + Ne * ie - 1) > ye ? je.c = je.e = null : Ne < pe ? je.c = [je.e = 0] : (je.e = Ne, je.c = Oe), je;
      }
      De = /* @__PURE__ */ function() {
        var je = /^(-?)0([xbo])(?=\w[\w.]*$)/i, Oe = /^([^.]+)\.$/, Ne = /^\.([^.]+)$/, Ye = /^-?(Infinity|NaN)$/, Je = /^\s*\+(?=[\w.])|^\s+|\s+$/g;
        return function(Xe, st, ct, it) {
          var ot, yt = ct ? st : st.replace(Je, "");
          if (Ye.test(yt))
            Xe.s = isNaN(yt) ? null : yt < 0 ? -1 : 1;
          else {
            if (!ct && (yt = yt.replace(je, function(dt, mt, It) {
              return ot = (It = It.toLowerCase()) == "x" ? 16 : It == "b" ? 2 : 8, !it || it == ot ? mt : dt;
            }), it && (ot = it, yt = yt.replace(Oe, "$1").replace(Ne, "0.$1")), st != yt))
              return new ze(yt, ot);
            if (ze.DEBUG)
              throw Error(ee + "Not a" + (it ? " base " + it : "") + " number: " + st);
            Xe.s = null;
          }
          Xe.c = Xe.e = null;
        };
      }();
      function Ue(je, Oe, Ne, Ye) {
        var Je, Xe, st, ct, it, ot, yt, dt = je.c, mt = de;
        if (dt) {
          e: {
            for (Je = 1, ct = dt[0]; ct >= 10; ct /= 10, Je++) ;
            if (Xe = Oe - Je, Xe < 0)
              Xe += ie, st = Oe, it = dt[ot = 0], yt = J(it / mt[Je - st - 1] % 10);
            else if (ot = V((Xe + 1) / ie), ot >= dt.length)
              if (Ye) {
                for (; dt.length <= ot; dt.push(0)) ;
                it = yt = 0, Je = 1, Xe %= ie, st = Xe - ie + 1;
              } else
                break e;
            else {
              for (it = ct = dt[ot], Je = 1; ct >= 10; ct /= 10, Je++) ;
              Xe %= ie, st = Xe - ie + Je, yt = st < 0 ? 0 : J(it / mt[Je - st - 1] % 10);
            }
            if (Ye = Ye || Oe < 0 || // Are there any non-zero digits after the rounding digit?
            // The expression  n % pows10[d - j - 1]  returns all digits of n to the right
            // of the digit at j, e.g. if n is 908714 and j is 2, the expression gives 714.
            dt[ot + 1] != null || (st < 0 ? it : it % mt[Je - st - 1]), Ye = Ne < 4 ? (yt || Ye) && (Ne == 0 || Ne == (je.s < 0 ? 3 : 2)) : yt > 5 || yt == 5 && (Ne == 4 || Ye || Ne == 6 && // Check whether the digit to the left of the rounding digit is odd.
            (Xe > 0 ? st > 0 ? it / mt[Je - st] : 0 : dt[ot - 1]) % 10 & 1 || Ne == (je.s < 0 ? 8 : 7)), Oe < 1 || !dt[0])
              return dt.length = 0, Ye ? (Oe -= je.e + 1, dt[0] = mt[(ie - Oe % ie) % ie], je.e = -Oe || 0) : dt[0] = je.e = 0, je;
            if (Xe == 0 ? (dt.length = ot, ct = 1, ot--) : (dt.length = ot + 1, ct = mt[ie - Xe], dt[ot] = st > 0 ? J(it / mt[Je - st] % mt[st]) * ct : 0), Ye)
              for (; ; )
                if (ot == 0) {
                  for (Xe = 1, st = dt[0]; st >= 10; st /= 10, Xe++) ;
                  for (st = dt[0] += ct, ct = 1; st >= 10; st /= 10, ct++) ;
                  Xe != ct && (je.e++, dt[0] == re && (dt[0] = 1));
                  break;
                } else {
                  if (dt[ot] += ct, dt[ot] != re) break;
                  dt[ot--] = 0, ct = 1;
                }
            for (Xe = dt.length; dt[--Xe] === 0; dt.pop()) ;
          }
          je.e > ye ? je.c = je.e = null : je.e < pe && (je.c = [je.e = 0]);
        }
        return je;
      }
      function Ge(je) {
        var Oe, Ne = je.e;
        return Ne === null ? je.toString() : (Oe = xe(je.c), Oe = Ne <= ce || Ne >= le ? Ee(Oe, Ne) : Me(Oe, Ne, "0"), je.s < 0 ? "-" + Oe : Oe);
      }
      return Fe.absoluteValue = Fe.abs = function() {
        var je = new ze(this);
        return je.s < 0 && (je.s = 1), je;
      }, Fe.comparedTo = function(je, Oe) {
        return ve(this, new ze(je, Oe));
      }, Fe.decimalPlaces = Fe.dp = function(je, Oe) {
        var Ne, Ye, Je, Xe = this;
        if (je != null)
          return Te(je, 0, fe), Oe == null ? Oe = oe : Te(Oe, 0, 8), Ue(new ze(Xe), je + Xe.e + 1, Oe);
        if (!(Ne = Xe.c)) return null;
        if (Ye = ((Je = Ne.length - 1) - me(this.e / ie)) * ie, Je = Ne[Je]) for (; Je % 10 == 0; Je /= 10, Ye--) ;
        return Ye < 0 && (Ye = 0), Ye;
      }, Fe.dividedBy = Fe.div = function(je, Oe) {
        return ke(this, new ze(je, Oe), ne, oe);
      }, Fe.dividedToIntegerBy = Fe.idiv = function(je, Oe) {
        return ke(this, new ze(je, Oe), 0, 1);
      }, Fe.exponentiatedBy = Fe.pow = function(je, Oe) {
        var Ne, Ye, Je, Xe, st, ct, it, ot, yt, dt = this;
        if (je = new ze(je), je.c && !je.isInteger())
          throw Error(ee + "Exponent not an integer: " + Ge(je));
        if (Oe != null && (Oe = new ze(Oe)), ct = je.e > 14, !dt.c || !dt.c[0] || dt.c[0] == 1 && !dt.e && dt.c.length == 1 || !je.c || !je.c[0])
          return yt = new ze(Math.pow(+Ge(dt), ct ? je.s * (2 - we(je)) : +Ge(je))), Oe ? yt.mod(Oe) : yt;
        if (it = je.s < 0, Oe) {
          if (Oe.c ? !Oe.c[0] : !Oe.s) return new ze(NaN);
          Ye = !it && dt.isInteger() && Oe.isInteger(), Ye && (dt = dt.mod(Oe));
        } else {
          if (je.e > 9 && (dt.e > 0 || dt.e < -1 || (dt.e == 0 ? dt.c[0] > 1 || ct && dt.c[1] >= 24e7 : dt.c[0] < 8e13 || ct && dt.c[0] <= 9999975e7)))
            return Xe = dt.s < 0 && we(je) ? -0 : 0, dt.e > -1 && (Xe = 1 / Xe), new ze(it ? 1 / Xe : Xe);
          ae && (Xe = V(ae / ie + 2));
        }
        for (ct ? (Ne = new ze(0.5), it && (je.s = 1), ot = we(je)) : (Je = Math.abs(+Ge(je)), ot = Je % 2), yt = new ze(Ae); ; ) {
          if (ot) {
            if (yt = yt.times(dt), !yt.c) break;
            Xe ? yt.c.length > Xe && (yt.c.length = Xe) : Ye && (yt = yt.mod(Oe));
          }
          if (Je) {
            if (Je = J(Je / 2), Je === 0) break;
            ot = Je % 2;
          } else if (je = je.times(Ne), Ue(je, je.e + 1, 1), je.e > 14)
            ot = we(je);
          else {
            if (Je = +Ge(je), Je === 0) break;
            ot = Je % 2;
          }
          dt = dt.times(dt), Xe ? dt.c && dt.c.length > Xe && (dt.c.length = Xe) : Ye && (dt = dt.mod(Oe));
        }
        return Ye ? yt : (it && (yt = Ae.div(yt)), Oe ? yt.mod(Oe) : Xe ? Ue(yt, ae, oe, st) : yt);
      }, Fe.integerValue = function(je) {
        var Oe = new ze(this);
        return je == null ? je = oe : Te(je, 0, 8), Ue(Oe, Oe.e + 1, je);
      }, Fe.isEqualTo = Fe.eq = function(je, Oe) {
        return ve(this, new ze(je, Oe)) === 0;
      }, Fe.isFinite = function() {
        return !!this.c;
      }, Fe.isGreaterThan = Fe.gt = function(je, Oe) {
        return ve(this, new ze(je, Oe)) > 0;
      }, Fe.isGreaterThanOrEqualTo = Fe.gte = function(je, Oe) {
        return (Oe = ve(this, new ze(je, Oe))) === 1 || Oe === 0;
      }, Fe.isInteger = function() {
        return !!this.c && me(this.e / ie) > this.c.length - 2;
      }, Fe.isLessThan = Fe.lt = function(je, Oe) {
        return ve(this, new ze(je, Oe)) < 0;
      }, Fe.isLessThanOrEqualTo = Fe.lte = function(je, Oe) {
        return (Oe = ve(this, new ze(je, Oe))) === -1 || Oe === 0;
      }, Fe.isNaN = function() {
        return !this.s;
      }, Fe.isNegative = function() {
        return this.s < 0;
      }, Fe.isPositive = function() {
        return this.s > 0;
      }, Fe.isZero = function() {
        return !!this.c && this.c[0] == 0;
      }, Fe.minus = function(je, Oe) {
        var Ne, Ye, Je, Xe, st = this, ct = st.s;
        if (je = new ze(je, Oe), Oe = je.s, !ct || !Oe) return new ze(NaN);
        if (ct != Oe)
          return je.s = -Oe, st.plus(je);
        var it = st.e / ie, ot = je.e / ie, yt = st.c, dt = je.c;
        if (!it || !ot) {
          if (!yt || !dt) return yt ? (je.s = -Oe, je) : new ze(dt ? st : NaN);
          if (!yt[0] || !dt[0])
            return dt[0] ? (je.s = -Oe, je) : new ze(yt[0] ? st : (
              // IEEE 754 (2008) 6.3: n - n = -0 when rounding to -Infinity
              oe == 3 ? -0 : 0
            ));
        }
        if (it = me(it), ot = me(ot), yt = yt.slice(), ct = it - ot) {
          for ((Xe = ct < 0) ? (ct = -ct, Je = yt) : (ot = it, Je = dt), Je.reverse(), Oe = ct; Oe--; Je.push(0)) ;
          Je.reverse();
        } else
          for (Ye = (Xe = (ct = yt.length) < (Oe = dt.length)) ? ct : Oe, ct = Oe = 0; Oe < Ye; Oe++)
            if (yt[Oe] != dt[Oe]) {
              Xe = yt[Oe] < dt[Oe];
              break;
            }
        if (Xe && (Je = yt, yt = dt, dt = Je, je.s = -je.s), Oe = (Ye = dt.length) - (Ne = yt.length), Oe > 0) for (; Oe--; yt[Ne++] = 0) ;
        for (Oe = re - 1; Ye > ct; ) {
          if (yt[--Ye] < dt[Ye]) {
            for (Ne = Ye; Ne && !yt[--Ne]; yt[Ne] = Oe) ;
            --yt[Ne], yt[Ye] += re;
          }
          yt[Ye] -= dt[Ye];
        }
        for (; yt[0] == 0; yt.splice(0, 1), --ot) ;
        return yt[0] ? Be(je, yt, ot) : (je.s = oe == 3 ? -1 : 1, je.c = [je.e = 0], je);
      }, Fe.modulo = Fe.mod = function(je, Oe) {
        var Ne, Ye, Je = this;
        return je = new ze(je, Oe), !Je.c || !je.s || je.c && !je.c[0] ? new ze(NaN) : !je.c || Je.c && !Je.c[0] ? new ze(Je) : (be == 9 ? (Ye = je.s, je.s = 1, Ne = ke(Je, je, 0, 3), je.s = Ye, Ne.s *= Ye) : Ne = ke(Je, je, 0, be), je = Je.minus(Ne.times(je)), !je.c[0] && be == 1 && (je.s = Je.s), je);
      }, Fe.multipliedBy = Fe.times = function(je, Oe) {
        var Ne, Ye, Je, Xe, st, ct, it, ot, yt, dt, mt, It, xt, Tt, Yt, Ve = this, Pe = Ve.c, $e = (je = new ze(je, Oe)).c;
        if (!Pe || !$e || !Pe[0] || !$e[0])
          return !Ve.s || !je.s || Pe && !Pe[0] && !$e || $e && !$e[0] && !Pe ? je.c = je.e = je.s = null : (je.s *= Ve.s, !Pe || !$e ? je.c = je.e = null : (je.c = [0], je.e = 0)), je;
        for (Ye = me(Ve.e / ie) + me(je.e / ie), je.s *= Ve.s, it = Pe.length, dt = $e.length, it < dt && (xt = Pe, Pe = $e, $e = xt, Je = it, it = dt, dt = Je), Je = it + dt, xt = []; Je--; xt.push(0)) ;
        for (Tt = re, Yt = ue, Je = dt; --Je >= 0; ) {
          for (Ne = 0, mt = $e[Je] % Yt, It = $e[Je] / Yt | 0, st = it, Xe = Je + st; Xe > Je; )
            ot = Pe[--st] % Yt, yt = Pe[st] / Yt | 0, ct = It * ot + yt * mt, ot = mt * ot + ct % Yt * Yt + xt[Xe] + Ne, Ne = (ot / Tt | 0) + (ct / Yt | 0) + It * yt, xt[Xe--] = ot % Tt;
          xt[Xe] = Ne;
        }
        return Ne ? ++Ye : xt.splice(0, 1), Be(je, xt, Ye);
      }, Fe.negated = function() {
        var je = new ze(this);
        return je.s = -je.s || null, je;
      }, Fe.plus = function(je, Oe) {
        var Ne, Ye = this, Je = Ye.s;
        if (je = new ze(je, Oe), Oe = je.s, !Je || !Oe) return new ze(NaN);
        if (Je != Oe)
          return je.s = -Oe, Ye.minus(je);
        var Xe = Ye.e / ie, st = je.e / ie, ct = Ye.c, it = je.c;
        if (!Xe || !st) {
          if (!ct || !it) return new ze(Je / 0);
          if (!ct[0] || !it[0]) return it[0] ? je : new ze(ct[0] ? Ye : Je * 0);
        }
        if (Xe = me(Xe), st = me(st), ct = ct.slice(), Je = Xe - st) {
          for (Je > 0 ? (st = Xe, Ne = it) : (Je = -Je, Ne = ct), Ne.reverse(); Je--; Ne.push(0)) ;
          Ne.reverse();
        }
        for (Je = ct.length, Oe = it.length, Je - Oe < 0 && (Ne = it, it = ct, ct = Ne, Oe = Je), Je = 0; Oe; )
          Je = (ct[--Oe] = ct[Oe] + it[Oe] + Je) / re | 0, ct[Oe] = re === ct[Oe] ? 0 : ct[Oe] % re;
        return Je && (ct = [Je].concat(ct), ++st), Be(je, ct, st);
      }, Fe.precision = Fe.sd = function(je, Oe) {
        var Ne, Ye, Je, Xe = this;
        if (je != null && je !== !!je)
          return Te(je, 1, fe), Oe == null ? Oe = oe : Te(Oe, 0, 8), Ue(new ze(Xe), je, Oe);
        if (!(Ne = Xe.c)) return null;
        if (Je = Ne.length - 1, Ye = Je * ie + 1, Je = Ne[Je]) {
          for (; Je % 10 == 0; Je /= 10, Ye--) ;
          for (Je = Ne[0]; Je >= 10; Je /= 10, Ye++) ;
        }
        return je && Xe.e + 1 > Ye && (Ye = Xe.e + 1), Ye;
      }, Fe.shiftedBy = function(je) {
        return Te(je, -se, se), this.times("1e" + je);
      }, Fe.squareRoot = Fe.sqrt = function() {
        var je, Oe, Ne, Ye, Je, Xe = this, st = Xe.c, ct = Xe.s, it = Xe.e, ot = ne + 4, yt = new ze("0.5");
        if (ct !== 1 || !st || !st[0])
          return new ze(!ct || ct < 0 && (!st || st[0]) ? NaN : st ? Xe : 1 / 0);
        if (ct = Math.sqrt(+Ge(Xe)), ct == 0 || ct == 1 / 0 ? (Oe = xe(st), (Oe.length + it) % 2 == 0 && (Oe += "0"), ct = Math.sqrt(+Oe), it = me((it + 1) / 2) - (it < 0 || it % 2), ct == 1 / 0 ? Oe = "5e" + it : (Oe = ct.toExponential(), Oe = Oe.slice(0, Oe.indexOf("e") + 1) + it), Ne = new ze(Oe)) : Ne = new ze(ct + ""), Ne.c[0]) {
          for (it = Ne.e, ct = it + ot, ct < 3 && (ct = 0); ; )
            if (Je = Ne, Ne = yt.times(Je.plus(ke(Xe, Je, ot, 1))), xe(Je.c).slice(0, ct) === (Oe = xe(Ne.c)).slice(0, ct))
              if (Ne.e < it && --ct, Oe = Oe.slice(ct - 3, ct + 1), Oe == "9999" || !Ye && Oe == "4999") {
                if (!Ye && (Ue(Je, Je.e + ne + 2, 0), Je.times(Je).eq(Xe))) {
                  Ne = Je;
                  break;
                }
                ot += 4, ct += 4, Ye = 1;
              } else {
                (!+Oe || !+Oe.slice(1) && Oe.charAt(0) == "5") && (Ue(Ne, Ne.e + ne + 2, 1), je = !Ne.times(Ne).eq(Xe));
                break;
              }
        }
        return Ue(Ne, Ne.e + ne + 1, oe, je);
      }, Fe.toExponential = function(je, Oe) {
        return je != null && (Te(je, 0, fe), je++), Re(this, je, Oe, 1);
      }, Fe.toFixed = function(je, Oe) {
        return je != null && (Te(je, 0, fe), je = je + this.e + 1), Re(this, je, Oe);
      }, Fe.toFormat = function(je, Oe, Ne) {
        var Ye, Je = this;
        if (Ne == null)
          je != null && Oe && typeof Oe == "object" ? (Ne = Oe, Oe = null) : je && typeof je == "object" ? (Ne = je, je = Oe = null) : Ne = ge;
        else if (typeof Ne != "object")
          throw Error(ee + "Argument not an object: " + Ne);
        if (Ye = Je.toFixed(je, Oe), Je.c) {
          var Xe, st = Ye.split("."), ct = +Ne.groupSize, it = +Ne.secondaryGroupSize, ot = Ne.groupSeparator || "", yt = st[0], dt = st[1], mt = Je.s < 0, It = mt ? yt.slice(1) : yt, xt = It.length;
          if (it && (Xe = ct, ct = it, it = Xe, xt -= Xe), ct > 0 && xt > 0) {
            for (Xe = xt % ct || ct, yt = It.substr(0, Xe); Xe < xt; Xe += ct) yt += ot + It.substr(Xe, ct);
            it > 0 && (yt += ot + It.slice(Xe)), mt && (yt = "-" + yt);
          }
          Ye = dt ? yt + (Ne.decimalSeparator || "") + ((it = +Ne.fractionGroupSize) ? dt.replace(
            new RegExp("\\d{" + it + "}\\B", "g"),
            "$&" + (Ne.fractionGroupSeparator || "")
          ) : dt) : yt;
        }
        return (Ne.prefix || "") + Ye + (Ne.suffix || "");
      }, Fe.toFraction = function(je) {
        var Oe, Ne, Ye, Je, Xe, st, ct, it, ot, yt, dt, mt, It = this, xt = It.c;
        if (je != null && (ct = new ze(je), !ct.isInteger() && (ct.c || ct.s !== 1) || ct.lt(Ae)))
          throw Error(ee + "Argument " + (ct.isInteger() ? "out of range: " : "not an integer: ") + Ge(ct));
        if (!xt) return new ze(It);
        for (Oe = new ze(Ae), ot = Ne = new ze(Ae), Ye = it = new ze(Ae), mt = xe(xt), Xe = Oe.e = mt.length - It.e - 1, Oe.c[0] = de[(st = Xe % ie) < 0 ? ie + st : st], je = !je || ct.comparedTo(Oe) > 0 ? Xe > 0 ? Oe : ot : ct, st = ye, ye = 1 / 0, ct = new ze(mt), it.c[0] = 0; yt = ke(ct, Oe, 0, 1), Je = Ne.plus(yt.times(Ye)), Je.comparedTo(je) != 1; )
          Ne = Ye, Ye = Je, ot = it.plus(yt.times(Je = ot)), it = Je, Oe = ct.minus(yt.times(Je = Oe)), ct = Je;
        return Je = ke(je.minus(Ne), Ye, 0, 1), it = it.plus(Je.times(ot)), Ne = Ne.plus(Je.times(Ye)), it.s = ot.s = It.s, Xe = Xe * 2, dt = ke(ot, Ye, Xe, oe).minus(It).abs().comparedTo(
          ke(it, Ne, Xe, oe).minus(It).abs()
        ) < 1 ? [ot, Ye] : [it, Ne], ye = st, dt;
      }, Fe.toNumber = function() {
        return +Ge(this);
      }, Fe.toPrecision = function(je, Oe) {
        return je != null && Te(je, 1, fe), Re(this, je, Oe, 2);
      }, Fe.toString = function(je) {
        var Oe, Ne = this, Ye = Ne.s, Je = Ne.e;
        return Je === null ? Ye ? (Oe = "Infinity", Ye < 0 && (Oe = "-" + Oe)) : Oe = "NaN" : (je == null ? Oe = Je <= ce || Je >= le ? Ee(xe(Ne.c), Je) : Me(xe(Ne.c), Je, "0") : je === 10 && Le ? (Ne = Ue(new ze(Ne), ne + Je + 1, oe), Oe = Me(xe(Ne.c), Ne.e, "0")) : (Te(je, 2, Se.length, "Base"), Oe = _e(Me(xe(Ne.c), Je, "0"), 10, je, Ye, !0)), Ye < 0 && Ne.c[0] && (Oe = "-" + Oe)), Oe;
      }, Fe.valueOf = Fe.toJSON = function() {
        return Ge(this);
      }, Fe._isBigNumber = !0, Ie != null && ze.set(Ie), ze;
    }
    function me(Ie) {
      var ke = Ie | 0;
      return Ie > 0 || Ie === ke ? ke : ke - 1;
    }
    function xe(Ie) {
      for (var ke, _e, De = 1, Fe = Ie.length, Ae = Ie[0] + ""; De < Fe; ) {
        for (ke = Ie[De++] + "", _e = ie - ke.length; _e--; ke = "0" + ke) ;
        Ae += ke;
      }
      for (Fe = Ae.length; Ae.charCodeAt(--Fe) === 48; ) ;
      return Ae.slice(0, Fe + 1 || 1);
    }
    function ve(Ie, ke) {
      var _e, De, Fe = Ie.c, Ae = ke.c, ne = Ie.s, oe = ke.s, ce = Ie.e, le = ke.e;
      if (!ne || !oe) return null;
      if (_e = Fe && !Fe[0], De = Ae && !Ae[0], _e || De) return _e ? De ? 0 : -oe : ne;
      if (ne != oe) return ne;
      if (_e = ne < 0, De = ce == le, !Fe || !Ae) return De ? 0 : !Fe ^ _e ? 1 : -1;
      if (!De) return ce > le ^ _e ? 1 : -1;
      for (oe = (ce = Fe.length) < (le = Ae.length) ? ce : le, ne = 0; ne < oe; ne++) if (Fe[ne] != Ae[ne]) return Fe[ne] > Ae[ne] ^ _e ? 1 : -1;
      return ce == le ? 0 : ce > le ^ _e ? 1 : -1;
    }
    function Te(Ie, ke, _e, De) {
      if (Ie < ke || Ie > _e || Ie !== J(Ie))
        throw Error(ee + (De || "Argument") + (typeof Ie == "number" ? Ie < ke || Ie > _e ? " out of range: " : " not an integer: " : " not a primitive number: ") + String(Ie));
    }
    function we(Ie) {
      var ke = Ie.c.length - 1;
      return me(Ie.e / ie) == ke && Ie.c[ke] % 2 != 0;
    }
    function Ee(Ie, ke) {
      return (Ie.length > 1 ? Ie.charAt(0) + "." + Ie.slice(1) : Ie) + (ke < 0 ? "e" : "e+") + ke;
    }
    function Me(Ie, ke, _e) {
      var De, Fe;
      if (ke < 0) {
        for (Fe = _e + "."; ++ke; Fe += _e) ;
        Ie = Fe + Ie;
      } else if (De = Ie.length, ++ke > De) {
        for (Fe = _e, ke -= De; --ke; Fe += _e) ;
        Ie += Fe;
      } else ke < De && (Ie = Ie.slice(0, ke) + "." + Ie.slice(ke));
      return Ie;
    }
    T = he(), T.default = T.BigNumber = T, C.exports ? C.exports = T : (e || (e = typeof self < "u" && self ? self : window), e.BigNumber = T);
  })(commonjsGlobal$1);
})(bignumber);
var bignumberExports = bignumber.exports;
(function(C) {
  var e = bignumberExports, T = C.exports;
  (function() {
    var $ = /[\\\"\x00-\x1f\x7f-\x9f\u00ad\u0600-\u0604\u070f\u17b4\u17b5\u200c-\u200f\u2028-\u202f\u2060-\u206f\ufeff\ufff0-\uffff]/g, V, J, ee = {
      // table of character substitutions
      "\b": "\\b",
      "	": "\\t",
      "\n": "\\n",
      "\f": "\\f",
      "\r": "\\r",
      '"': '\\"',
      "\\": "\\\\"
    }, te;
    function re(se) {
      return $.lastIndex = 0, $.test(se) ? '"' + se.replace($, function(de) {
        var ue = ee[de];
        return typeof ue == "string" ? ue : "\\u" + ("0000" + de.charCodeAt(0).toString(16)).slice(-4);
      }) + '"' : '"' + se + '"';
    }
    function ie(se, de) {
      var ue, fe, he, me, xe = V, ve, Te = de[se], we = Te != null && (Te instanceof e || e.isBigNumber(Te));
      switch (Te && typeof Te == "object" && typeof Te.toJSON == "function" && (Te = Te.toJSON(se)), typeof te == "function" && (Te = te.call(de, se, Te)), typeof Te) {
        case "string":
          return we ? Te : re(Te);
        case "number":
          return isFinite(Te) ? String(Te) : "null";
        case "boolean":
        case "null":
        case "bigint":
          return String(Te);
        case "object":
          if (!Te)
            return "null";
          if (V += J, ve = [], Object.prototype.toString.apply(Te) === "[object Array]") {
            for (me = Te.length, ue = 0; ue < me; ue += 1)
              ve[ue] = ie(ue, Te) || "null";
            return he = ve.length === 0 ? "[]" : V ? `[
` + V + ve.join(`,
` + V) + `
` + xe + "]" : "[" + ve.join(",") + "]", V = xe, he;
          }
          if (te && typeof te == "object")
            for (me = te.length, ue = 0; ue < me; ue += 1)
              typeof te[ue] == "string" && (fe = te[ue], he = ie(fe, Te), he && ve.push(re(fe) + (V ? ": " : ":") + he));
          else
            Object.keys(Te).forEach(function(Ee) {
              var Me = ie(Ee, Te);
              Me && ve.push(re(Ee) + (V ? ": " : ":") + Me);
            });
          return he = ve.length === 0 ? "{}" : V ? `{
` + V + ve.join(`,
` + V) + `
` + xe + "}" : "{" + ve.join(",") + "}", V = xe, he;
      }
    }
    typeof T.stringify != "function" && (T.stringify = function(se, de, ue) {
      var fe;
      if (V = "", J = "", typeof ue == "number")
        for (fe = 0; fe < ue; fe += 1)
          J += " ";
      else typeof ue == "string" && (J = ue);
      if (te = de, de && typeof de != "function" && (typeof de != "object" || typeof de.length != "number"))
        throw new Error("JSON.stringify");
      return ie("", { "": se });
    });
  })();
})(stringify$1);
var stringifyExports = stringify$1.exports, BigNumber = null;
const suspectProtoRx = /(?:_|\\u005[Ff])(?:_|\\u005[Ff])(?:p|\\u0070)(?:r|\\u0072)(?:o|\\u006[Ff])(?:t|\\u0074)(?:o|\\u006[Ff])(?:_|\\u005[Ff])(?:_|\\u005[Ff])/, suspectConstructorRx = /(?:c|\\u0063)(?:o|\\u006[Ff])(?:n|\\u006[Ee])(?:s|\\u0073)(?:t|\\u0074)(?:r|\\u0072)(?:u|\\u0075)(?:c|\\u0063)(?:t|\\u0074)(?:o|\\u006[Ff])(?:r|\\u0072)/;
var json_parse$1 = function(C) {
  var e = {
    strict: !1,
    // not being strict means do not generate syntax errors for "duplicate key"
    storeAsString: !1,
    // toggles whether the values should be stored as BigNumber (default) or a string
    alwaysParseAsBig: !1,
    // toggles whether all numbers should be Big
    useNativeBigInt: !1,
    // toggles whether to use native BigInt instead of bignumber.js
    protoAction: "error",
    constructorAction: "error"
  };
  if (C != null) {
    if (C.strict === !0 && (e.strict = !0), C.storeAsString === !0 && (e.storeAsString = !0), e.alwaysParseAsBig = C.alwaysParseAsBig === !0 ? C.alwaysParseAsBig : !1, e.useNativeBigInt = C.useNativeBigInt === !0 ? C.useNativeBigInt : !1, typeof C.constructorAction < "u")
      if (C.constructorAction === "error" || C.constructorAction === "ignore" || C.constructorAction === "preserve")
        e.constructorAction = C.constructorAction;
      else
        throw new Error(
          `Incorrect value for constructorAction option, must be "error", "ignore" or undefined but passed ${C.constructorAction}`
        );
    if (typeof C.protoAction < "u")
      if (C.protoAction === "error" || C.protoAction === "ignore" || C.protoAction === "preserve")
        e.protoAction = C.protoAction;
      else
        throw new Error(
          `Incorrect value for protoAction option, must be "error", "ignore" or undefined but passed ${C.protoAction}`
        );
  }
  var T, $, V = {
    '"': '"',
    "\\": "\\",
    "/": "/",
    b: "\b",
    f: "\f",
    n: `
`,
    r: "\r",
    t: "	"
  }, J, ee = function(me) {
    throw {
      name: "SyntaxError",
      message: me,
      at: T,
      text: J
    };
  }, te = function(me) {
    return me && me !== $ && ee("Expected '" + me + "' instead of '" + $ + "'"), $ = J.charAt(T), T += 1, $;
  }, re = function() {
    var me, xe = "";
    for ($ === "-" && (xe = "-", te("-")); $ >= "0" && $ <= "9"; )
      xe += $, te();
    if ($ === ".")
      for (xe += "."; te() && $ >= "0" && $ <= "9"; )
        xe += $;
    if ($ === "e" || $ === "E")
      for (xe += $, te(), ($ === "-" || $ === "+") && (xe += $, te()); $ >= "0" && $ <= "9"; )
        xe += $, te();
    if (me = +xe, !isFinite(me))
      ee("Bad number");
    else
      return BigNumber == null && (BigNumber = bignumberExports), xe.length > 15 ? e.storeAsString ? xe : e.useNativeBigInt ? BigInt(xe) : new BigNumber(xe) : e.alwaysParseAsBig ? e.useNativeBigInt ? BigInt(me) : new BigNumber(me) : me;
  }, ie = function() {
    var me, xe, ve = "", Te;
    if ($ === '"')
      for (var we = T; te(); ) {
        if ($ === '"')
          return T - 1 > we && (ve += J.substring(we, T - 1)), te(), ve;
        if ($ === "\\") {
          if (T - 1 > we && (ve += J.substring(we, T - 1)), te(), $ === "u") {
            for (Te = 0, xe = 0; xe < 4 && (me = parseInt(te(), 16), !!isFinite(me)); xe += 1)
              Te = Te * 16 + me;
            ve += String.fromCharCode(Te);
          } else if (typeof V[$] == "string")
            ve += V[$];
          else
            break;
          we = T;
        }
      }
    ee("Bad string");
  }, se = function() {
    for (; $ && $ <= " "; )
      te();
  }, de = function() {
    switch ($) {
      case "t":
        return te("t"), te("r"), te("u"), te("e"), !0;
      case "f":
        return te("f"), te("a"), te("l"), te("s"), te("e"), !1;
      case "n":
        return te("n"), te("u"), te("l"), te("l"), null;
    }
    ee("Unexpected '" + $ + "'");
  }, ue, fe = function() {
    var me = [];
    if ($ === "[") {
      if (te("["), se(), $ === "]")
        return te("]"), me;
      for (; $; ) {
        if (me.push(ue()), se(), $ === "]")
          return te("]"), me;
        te(","), se();
      }
    }
    ee("Bad array");
  }, he = function() {
    var me, xe = /* @__PURE__ */ Object.create(null);
    if ($ === "{") {
      if (te("{"), se(), $ === "}")
        return te("}"), xe;
      for (; $; ) {
        if (me = ie(), se(), te(":"), e.strict === !0 && Object.hasOwnProperty.call(xe, me) && ee('Duplicate key "' + me + '"'), suspectProtoRx.test(me) === !0 ? e.protoAction === "error" ? ee("Object contains forbidden prototype property") : e.protoAction === "ignore" ? ue() : xe[me] = ue() : suspectConstructorRx.test(me) === !0 ? e.constructorAction === "error" ? ee("Object contains forbidden constructor property") : e.constructorAction === "ignore" ? ue() : xe[me] = ue() : xe[me] = ue(), se(), $ === "}")
          return te("}"), xe;
        te(","), se();
      }
    }
    ee("Bad object");
  };
  return ue = function() {
    switch (se(), $) {
      case "{":
        return he();
      case "[":
        return fe();
      case '"':
        return ie();
      case "-":
        return re();
      default:
        return $ >= "0" && $ <= "9" ? re() : de();
    }
  }, function(me, xe) {
    var ve;
    return J = me + "", T = 0, $ = " ", ve = ue(), se(), $ && ee("Syntax error"), typeof xe == "function" ? function Te(we, Ee) {
      var Me, Ie = we[Ee];
      return Ie && typeof Ie == "object" && Object.keys(Ie).forEach(function(ke) {
        Me = Te(Ie, ke), Me !== void 0 ? Ie[ke] = Me : delete Ie[ke];
      }), xe.call(we, Ee, Ie);
    }({ "": ve }, "") : ve;
  };
}, parse$2 = json_parse$1, json_stringify = stringifyExports.stringify, json_parse = parse$2;
jsonBigint.exports = function(C) {
  return {
    parse: json_parse(C),
    stringify: json_stringify
  };
};
jsonBigint.exports.parse = json_parse();
jsonBigint.exports.stringify = json_stringify;
var jsonBigintExports = jsonBigint.exports;
const JSONbigWithoutConfig = /* @__PURE__ */ getDefaultExportFromCjs$2(jsonBigintExports);
var IntDecoding;
(function(C) {
  C.DEFAULT = "default", C.SAFE = "safe", C.MIXED = "mixed", C.BIGINT = "bigint";
})(IntDecoding || (IntDecoding = {}));
JSONbigWithoutConfig({ useNativeBigInt: !0, strict: !0 });
function arrayEqual(C, e) {
  return C.length !== e.length ? !1 : Array.from(C).every((T, $) => T === e[$]);
}
function concatArrays(...C) {
  const e = C.reduce((V, J) => V + J.length, 0), T = new Uint8Array(e);
  let $ = 0;
  for (let V = 0; V < C.length; V++)
    T.set(C[V], $), $ += C[V].length;
  return T;
}
function genericHash(C) {
  return sha512.sha512_256.array(C);
}
const PUBLIC_KEY_LENGTH$1 = nacl.sign.publicKeyLength;
nacl.sign.secretKeyLength;
const HASH_BYTES_LENGTH = 32;
var base32$1 = { exports: {} };
(function(C) {
  (function() {
    var e = typeof window == "object" ? window : {}, T = !e.HI_BASE32_NO_NODE_JS && typeof dist$2.process == "object" && dist$2.process.versions && dist$2.process.versions.node;
    T && (e = commonjsGlobal$1);
    var $ = !e.HI_BASE32_NO_COMMON_JS && !0 && C.exports, V = "ABCDEFGHIJKLMNOPQRSTUVWXYZ234567".split(""), J = {
      A: 0,
      B: 1,
      C: 2,
      D: 3,
      E: 4,
      F: 5,
      G: 6,
      H: 7,
      I: 8,
      J: 9,
      K: 10,
      L: 11,
      M: 12,
      N: 13,
      O: 14,
      P: 15,
      Q: 16,
      R: 17,
      S: 18,
      T: 19,
      U: 20,
      V: 21,
      W: 22,
      X: 23,
      Y: 24,
      Z: 25,
      2: 26,
      3: 27,
      4: 28,
      5: 29,
      6: 30,
      7: 31
    }, ee = [0, 0, 0, 0, 0, 0, 0, 0], te = function(xe, ve) {
      ve.length > 10 && (ve = "..." + ve.substr(-10));
      var Te = new Error("Decoded data is not valid UTF-8. Maybe try base32.decode.asBytes()? Partial data after reading " + xe + " bytes: " + ve + " <-");
      throw Te.position = xe, Te;
    }, re = function(xe) {
      for (var ve = "", Te = xe.length, we = 0, Ee = 0, Me, Ie; we < Te; ) {
        if (Me = xe[we++], Me <= 127) {
          ve += String.fromCharCode(Me);
          continue;
        } else Me > 191 && Me <= 223 ? (Ie = Me & 31, Ee = 1) : Me <= 239 ? (Ie = Me & 15, Ee = 2) : Me <= 247 ? (Ie = Me & 7, Ee = 3) : te(we, ve);
        for (var ke = 0; ke < Ee; ++ke)
          Me = xe[we++], (Me < 128 || Me > 191) && te(we, ve), Ie <<= 6, Ie += Me & 63;
        Ie >= 55296 && Ie <= 57343 && te(we, ve), Ie > 1114111 && te(we, ve), Ie <= 65535 ? ve += String.fromCharCode(Ie) : (Ie -= 65536, ve += String.fromCharCode((Ie >> 10) + 55296), ve += String.fromCharCode((Ie & 1023) + 56320));
      }
      return ve;
    }, ie = function(xe) {
      if (xe === "")
        return [];
      if (!/^[A-Z2-7=]+$/.test(xe))
        throw new Error("Invalid base32 characters");
      xe = xe.replace(/=/g, "");
      for (var ve, Te, we, Ee, Me, Ie, ke, _e, De = [], Fe = 0, Ae = xe.length, ne = 0, oe = Ae >> 3 << 3; ne < oe; )
        ve = J[xe.charAt(ne++)], Te = J[xe.charAt(ne++)], we = J[xe.charAt(ne++)], Ee = J[xe.charAt(ne++)], Me = J[xe.charAt(ne++)], Ie = J[xe.charAt(ne++)], ke = J[xe.charAt(ne++)], _e = J[xe.charAt(ne++)], De[Fe++] = (ve << 3 | Te >>> 2) & 255, De[Fe++] = (Te << 6 | we << 1 | Ee >>> 4) & 255, De[Fe++] = (Ee << 4 | Me >>> 1) & 255, De[Fe++] = (Me << 7 | Ie << 2 | ke >>> 3) & 255, De[Fe++] = (ke << 5 | _e) & 255;
      var ce = Ae - oe;
      return ce === 2 ? (ve = J[xe.charAt(ne++)], Te = J[xe.charAt(ne++)], De[Fe++] = (ve << 3 | Te >>> 2) & 255) : ce === 4 ? (ve = J[xe.charAt(ne++)], Te = J[xe.charAt(ne++)], we = J[xe.charAt(ne++)], Ee = J[xe.charAt(ne++)], De[Fe++] = (ve << 3 | Te >>> 2) & 255, De[Fe++] = (Te << 6 | we << 1 | Ee >>> 4) & 255) : ce === 5 ? (ve = J[xe.charAt(ne++)], Te = J[xe.charAt(ne++)], we = J[xe.charAt(ne++)], Ee = J[xe.charAt(ne++)], Me = J[xe.charAt(ne++)], De[Fe++] = (ve << 3 | Te >>> 2) & 255, De[Fe++] = (Te << 6 | we << 1 | Ee >>> 4) & 255, De[Fe++] = (Ee << 4 | Me >>> 1) & 255) : ce === 7 && (ve = J[xe.charAt(ne++)], Te = J[xe.charAt(ne++)], we = J[xe.charAt(ne++)], Ee = J[xe.charAt(ne++)], Me = J[xe.charAt(ne++)], Ie = J[xe.charAt(ne++)], ke = J[xe.charAt(ne++)], De[Fe++] = (ve << 3 | Te >>> 2) & 255, De[Fe++] = (Te << 6 | we << 1 | Ee >>> 4) & 255, De[Fe++] = (Ee << 4 | Me >>> 1) & 255, De[Fe++] = (Me << 7 | Ie << 2 | ke >>> 3) & 255), De;
    }, se = function(xe) {
      for (var ve, Te, we, Ee, Me, Ie = "", ke = xe.length, _e = 0, De = parseInt(ke / 5) * 5; _e < De; )
        ve = xe.charCodeAt(_e++), Te = xe.charCodeAt(_e++), we = xe.charCodeAt(_e++), Ee = xe.charCodeAt(_e++), Me = xe.charCodeAt(_e++), Ie += V[ve >>> 3] + V[(ve << 2 | Te >>> 6) & 31] + V[Te >>> 1 & 31] + V[(Te << 4 | we >>> 4) & 31] + V[(we << 1 | Ee >>> 7) & 31] + V[Ee >>> 2 & 31] + V[(Ee << 3 | Me >>> 5) & 31] + V[Me & 31];
      var Fe = ke - De;
      return Fe === 1 ? (ve = xe.charCodeAt(_e), Ie += V[ve >>> 3] + V[ve << 2 & 31] + "======") : Fe === 2 ? (ve = xe.charCodeAt(_e++), Te = xe.charCodeAt(_e), Ie += V[ve >>> 3] + V[(ve << 2 | Te >>> 6) & 31] + V[Te >>> 1 & 31] + V[Te << 4 & 31] + "====") : Fe === 3 ? (ve = xe.charCodeAt(_e++), Te = xe.charCodeAt(_e++), we = xe.charCodeAt(_e), Ie += V[ve >>> 3] + V[(ve << 2 | Te >>> 6) & 31] + V[Te >>> 1 & 31] + V[(Te << 4 | we >>> 4) & 31] + V[we << 1 & 31] + "===") : Fe === 4 && (ve = xe.charCodeAt(_e++), Te = xe.charCodeAt(_e++), we = xe.charCodeAt(_e++), Ee = xe.charCodeAt(_e), Ie += V[ve >>> 3] + V[(ve << 2 | Te >>> 6) & 31] + V[Te >>> 1 & 31] + V[(Te << 4 | we >>> 4) & 31] + V[(we << 1 | Ee >>> 7) & 31] + V[Ee >>> 2 & 31] + V[Ee << 3 & 31] + "="), Ie;
    }, de = function(xe) {
      var ve, Te, we, Ee, Me, Ie, ke = !1, _e = "", De = 0, Fe, Ae = 0, ne = xe.length;
      if (xe === "")
        return _e;
      do {
        for (ee[0] = ee[5], ee[1] = ee[6], ee[2] = ee[7], Fe = Ae; De < ne && Fe < 5; ++De)
          Ie = xe.charCodeAt(De), Ie < 128 ? ee[Fe++] = Ie : Ie < 2048 ? (ee[Fe++] = 192 | Ie >> 6, ee[Fe++] = 128 | Ie & 63) : Ie < 55296 || Ie >= 57344 ? (ee[Fe++] = 224 | Ie >> 12, ee[Fe++] = 128 | Ie >> 6 & 63, ee[Fe++] = 128 | Ie & 63) : (Ie = 65536 + ((Ie & 1023) << 10 | xe.charCodeAt(++De) & 1023), ee[Fe++] = 240 | Ie >> 18, ee[Fe++] = 128 | Ie >> 12 & 63, ee[Fe++] = 128 | Ie >> 6 & 63, ee[Fe++] = 128 | Ie & 63);
        Ae = Fe - 5, De === ne && ++De, De > ne && Fe < 6 && (ke = !0), ve = ee[0], Fe > 4 ? (Te = ee[1], we = ee[2], Ee = ee[3], Me = ee[4], _e += V[ve >>> 3] + V[(ve << 2 | Te >>> 6) & 31] + V[Te >>> 1 & 31] + V[(Te << 4 | we >>> 4) & 31] + V[(we << 1 | Ee >>> 7) & 31] + V[Ee >>> 2 & 31] + V[(Ee << 3 | Me >>> 5) & 31] + V[Me & 31]) : Fe === 1 ? _e += V[ve >>> 3] + V[ve << 2 & 31] + "======" : Fe === 2 ? (Te = ee[1], _e += V[ve >>> 3] + V[(ve << 2 | Te >>> 6) & 31] + V[Te >>> 1 & 31] + V[Te << 4 & 31] + "====") : Fe === 3 ? (Te = ee[1], we = ee[2], _e += V[ve >>> 3] + V[(ve << 2 | Te >>> 6) & 31] + V[Te >>> 1 & 31] + V[(Te << 4 | we >>> 4) & 31] + V[we << 1 & 31] + "===") : (Te = ee[1], we = ee[2], Ee = ee[3], _e += V[ve >>> 3] + V[(ve << 2 | Te >>> 6) & 31] + V[Te >>> 1 & 31] + V[(Te << 4 | we >>> 4) & 31] + V[(we << 1 | Ee >>> 7) & 31] + V[Ee >>> 2 & 31] + V[Ee << 3 & 31] + "=");
      } while (!ke);
      return _e;
    }, ue = function(xe) {
      for (var ve, Te, we, Ee, Me, Ie = "", ke = xe.length, _e = 0, De = parseInt(ke / 5) * 5; _e < De; )
        ve = xe[_e++], Te = xe[_e++], we = xe[_e++], Ee = xe[_e++], Me = xe[_e++], Ie += V[ve >>> 3] + V[(ve << 2 | Te >>> 6) & 31] + V[Te >>> 1 & 31] + V[(Te << 4 | we >>> 4) & 31] + V[(we << 1 | Ee >>> 7) & 31] + V[Ee >>> 2 & 31] + V[(Ee << 3 | Me >>> 5) & 31] + V[Me & 31];
      var Fe = ke - De;
      return Fe === 1 ? (ve = xe[_e], Ie += V[ve >>> 3] + V[ve << 2 & 31] + "======") : Fe === 2 ? (ve = xe[_e++], Te = xe[_e], Ie += V[ve >>> 3] + V[(ve << 2 | Te >>> 6) & 31] + V[Te >>> 1 & 31] + V[Te << 4 & 31] + "====") : Fe === 3 ? (ve = xe[_e++], Te = xe[_e++], we = xe[_e], Ie += V[ve >>> 3] + V[(ve << 2 | Te >>> 6) & 31] + V[Te >>> 1 & 31] + V[(Te << 4 | we >>> 4) & 31] + V[we << 1 & 31] + "===") : Fe === 4 && (ve = xe[_e++], Te = xe[_e++], we = xe[_e++], Ee = xe[_e], Ie += V[ve >>> 3] + V[(ve << 2 | Te >>> 6) & 31] + V[Te >>> 1 & 31] + V[(Te << 4 | we >>> 4) & 31] + V[(we << 1 | Ee >>> 7) & 31] + V[Ee >>> 2 & 31] + V[Ee << 3 & 31] + "="), Ie;
    }, fe = function(xe, ve) {
      var Te = typeof xe != "string";
      return Te && xe.constructor === ArrayBuffer && (xe = new Uint8Array(xe)), Te ? ue(xe) : ve ? se(xe) : de(xe);
    }, he = function(xe, ve) {
      if (!ve)
        return re(ie(xe));
      if (xe === "")
        return "";
      if (!/^[A-Z2-7=]+$/.test(xe))
        throw new Error("Invalid base32 characters");
      var Te, we, Ee, Me, Ie, ke, _e, De, Fe = "", Ae = xe.indexOf("=");
      Ae === -1 && (Ae = xe.length);
      for (var ne = 0, oe = Ae >> 3 << 3; ne < oe; )
        Te = J[xe.charAt(ne++)], we = J[xe.charAt(ne++)], Ee = J[xe.charAt(ne++)], Me = J[xe.charAt(ne++)], Ie = J[xe.charAt(ne++)], ke = J[xe.charAt(ne++)], _e = J[xe.charAt(ne++)], De = J[xe.charAt(ne++)], Fe += String.fromCharCode((Te << 3 | we >>> 2) & 255) + String.fromCharCode((we << 6 | Ee << 1 | Me >>> 4) & 255) + String.fromCharCode((Me << 4 | Ie >>> 1) & 255) + String.fromCharCode((Ie << 7 | ke << 2 | _e >>> 3) & 255) + String.fromCharCode((_e << 5 | De) & 255);
      var ce = Ae - oe;
      return ce === 2 ? (Te = J[xe.charAt(ne++)], we = J[xe.charAt(ne++)], Fe += String.fromCharCode((Te << 3 | we >>> 2) & 255)) : ce === 4 ? (Te = J[xe.charAt(ne++)], we = J[xe.charAt(ne++)], Ee = J[xe.charAt(ne++)], Me = J[xe.charAt(ne++)], Fe += String.fromCharCode((Te << 3 | we >>> 2) & 255) + String.fromCharCode((we << 6 | Ee << 1 | Me >>> 4) & 255)) : ce === 5 ? (Te = J[xe.charAt(ne++)], we = J[xe.charAt(ne++)], Ee = J[xe.charAt(ne++)], Me = J[xe.charAt(ne++)], Ie = J[xe.charAt(ne++)], Fe += String.fromCharCode((Te << 3 | we >>> 2) & 255) + String.fromCharCode((we << 6 | Ee << 1 | Me >>> 4) & 255) + String.fromCharCode((Me << 4 | Ie >>> 1) & 255)) : ce === 7 && (Te = J[xe.charAt(ne++)], we = J[xe.charAt(ne++)], Ee = J[xe.charAt(ne++)], Me = J[xe.charAt(ne++)], Ie = J[xe.charAt(ne++)], ke = J[xe.charAt(ne++)], _e = J[xe.charAt(ne++)], Fe += String.fromCharCode((Te << 3 | we >>> 2) & 255) + String.fromCharCode((we << 6 | Ee << 1 | Me >>> 4) & 255) + String.fromCharCode((Me << 4 | Ie >>> 1) & 255) + String.fromCharCode((Ie << 7 | ke << 2 | _e >>> 3) & 255)), Fe;
    }, me = {
      encode: fe,
      decode: he
    };
    he.asBytes = ie, $ ? C.exports = me : e.base32 = me;
  })();
})(base32$1);
var base32Exports = base32$1.exports;
const base32 = /* @__PURE__ */ getDefaultExportFromCjs$2(base32Exports), ALGORAND_ADDRESS_BYTE_LENGTH = 36, ALGORAND_CHECKSUM_BYTE_LENGTH = 4, ALGORAND_ADDRESS_LENGTH = 58;
bufferPolyfill.Buffer.from("appID");
const MALFORMED_ADDRESS_ERROR_MSG = "address seems to be malformed", CHECKSUM_ADDRESS_ERROR_MSG = "wrong checksum for address";
function decodeAddress(C) {
  if (typeof C != "string" || C.length !== ALGORAND_ADDRESS_LENGTH)
    throw new Error(MALFORMED_ADDRESS_ERROR_MSG);
  const e = base32.decode.asBytes(C.toString());
  if (e.length !== ALGORAND_ADDRESS_BYTE_LENGTH)
    throw new Error(MALFORMED_ADDRESS_ERROR_MSG);
  const T = new Uint8Array(e.slice(0, ALGORAND_ADDRESS_BYTE_LENGTH - ALGORAND_CHECKSUM_BYTE_LENGTH)), $ = new Uint8Array(e.slice(PUBLIC_KEY_LENGTH$1, ALGORAND_ADDRESS_BYTE_LENGTH)), V = genericHash(T).slice(HASH_BYTES_LENGTH - ALGORAND_CHECKSUM_BYTE_LENGTH, HASH_BYTES_LENGTH);
  if (!arrayEqual(V, $))
    throw new Error(CHECKSUM_ADDRESS_ERROR_MSG);
  return { publicKey: T, checksum: $ };
}
function isValidAddress(C) {
  try {
    decodeAddress(C);
  } catch {
    return !1;
  }
  return !0;
}
function encodeAddress(C) {
  const e = genericHash(C).slice(PUBLIC_KEY_LENGTH$1 - ALGORAND_CHECKSUM_BYTE_LENGTH, PUBLIC_KEY_LENGTH$1);
  return base32.encode(concatArrays(C, e)).toString().slice(0, ALGORAND_ADDRESS_LENGTH);
}
var TransactionType$1;
(function(C) {
  C.pay = "pay", C.keyreg = "keyreg", C.acfg = "acfg", C.axfer = "axfer", C.afrz = "afrz", C.appl = "appl", C.stpf = "stpf";
})(TransactionType$1 || (TransactionType$1 = {}));
var OnApplicationComplete;
(function(C) {
  C[C.NoOpOC = 0] = "NoOpOC", C[C.OptInOC = 1] = "OptInOC", C[C.CloseOutOC = 2] = "CloseOutOC", C[C.ClearStateOC = 3] = "ClearStateOC", C[C.UpdateApplicationOC = 4] = "UpdateApplicationOC", C[C.DeleteApplicationOC = 5] = "DeleteApplicationOC";
})(OnApplicationComplete || (OnApplicationComplete = {}));
bufferPolyfill.Buffer.from("ProgData");
"ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=".split("").forEach(function(C, e) {
});
var ABITransactionType;
(function(C) {
  C.any = "txn", C.pay = "pay", C.keyreg = "keyreg", C.acfg = "acfg", C.axfer = "axfer", C.afrz = "afrz", C.appl = "appl";
})(ABITransactionType || (ABITransactionType = {}));
var ABIReferenceType;
(function(C) {
  C.account = "account", C.application = "application", C.asset = "asset";
})(ABIReferenceType || (ABIReferenceType = {}));
bufferPolyfill.Buffer.from([21, 31, 124, 117]);
var AtomicTransactionComposerStatus;
(function(C) {
  C[C.BUILDING = 0] = "BUILDING", C[C.BUILT = 1] = "BUILT", C[C.SIGNED = 2] = "SIGNED", C[C.SUBMITTED = 3] = "SUBMITTED", C[C.COMMITTED = 4] = "COMMITTED";
})(AtomicTransactionComposerStatus || (AtomicTransactionComposerStatus = {}));
bufferPolyfill.Buffer.from([77, 88]);
const _platform$4 = "Algorand";
function safeBigIntToNumber(C) {
  if (C < BigInt(Number.MIN_SAFE_INTEGER) || C > BigInt(Number.MAX_SAFE_INTEGER))
    throw new Error("Integer is unsafe");
  return Number(C);
}
const kr = class kr {
  constructor(e) {
    tt(this, "type", "Native");
    tt(this, "address");
    if (kr.instanceof(e))
      this.address = e.address;
    else if (UniversalAddress.instanceof(e))
      this.address = e.toUint8Array();
    else if (e instanceof Uint8Array && e.byteLength === kr.byteSize)
      this.address = e;
    else if (typeof e == "string" && isValidAddress(e))
      this.address = decodeAddress(e).publicKey;
    else if (typeof e == "string" && !isNaN(parseInt(e)))
      this.address = bytes.zpad(bignum.toBytes(BigInt(e), 8), kr.byteSize);
    else if (typeof e == "bigint")
      this.address = bytes.zpad(bignum.toBytes(e, 8), kr.byteSize);
    else if (e instanceof Uint8Array && e.byteLength === 8)
      this.address = bytes.zpad(e, kr.byteSize);
    else
      throw new Error(`Invalid Algorand address or ASA ID: ${e}`);
  }
  unwrap() {
    return this.toString();
  }
  toString() {
    return encodeAddress(this.address);
  }
  toNative() {
    return this;
  }
  toUint8Array() {
    return this.address;
  }
  toUniversalAddress() {
    return new UniversalAddress(this.toUint8Array());
  }
  toBigInt() {
    return bignum.decode(this.toUint8Array().slice(24, 32));
  }
  toInt() {
    return safeBigIntToNumber(this.toBigInt());
  }
  equals(e) {
    return kr.instanceof(e) ? e.address === this.address : this.toUniversalAddress().equals(e);
  }
  static instanceof(e) {
    return e.constructor.platform === _platform$4;
  }
};
tt(kr, "byteSize", 32), tt(kr, "platform", _platform$4);
let AlgorandAddress = kr;
registerNative(_platform$4, AlgorandAddress);
const APTOS_COIN = "0x1::aptos_coin::AptosCoin", APTOS_SEPARATOR = "::", _platform$3 = "Aptos", isValidAptosType$1 = (C) => /^(0x)?[0-9a-fA-F]+::\w+::\w+$/.test(C), coalesceModuleAddress = (C) => C.split(APTOS_SEPARATOR)[0];
function ensureFullAptosAddress(C) {
  return C.length % 2 !== 0 || C.length < 66 ? (C = C.startsWith("0x") ? C.slice(2) : C, "0x" + C.padStart(64, "0")) : C;
}
const ji = class ji {
  constructor(e) {
    tt(this, "type", "Native");
    // Full 32 bytes of Address
    tt(this, "address");
    // Optional module and contract name
    tt(this, "module");
    if (ji.instanceof(e))
      this.address = e.address, this.module = e.module;
    else if (UniversalAddress.instanceof(e))
      this.address = e.toUint8Array();
    else if (typeof e == "string") {
      if (isValidAptosType$1(e)) {
        const T = e.split(APTOS_SEPARATOR);
        this.module = T.slice(1).join(APTOS_SEPARATOR), e = T[0];
      }
      if (e = ensureFullAptosAddress(e), !hex$1.valid(e))
        throw new Error("Invalid Aptos address: " + e);
      this.address = hex$1.decode(e);
    } else
      this.address = e;
  }
  unwrap() {
    const e = hex$1.encode(this.address).replace(/^0+/, ""), T = this.module ? APTOS_SEPARATOR + this.module : "";
    return `0x${e}${T}`;
  }
  toString() {
    return this.unwrap();
  }
  toNative() {
    return this;
  }
  toUint8Array() {
    return this.address;
  }
  toUniversalAddress() {
    return new UniversalAddress(this.toUint8Array());
  }
  static instanceof(e) {
    return e.constructor.platform === ji.platform;
  }
  equals(e) {
    return ji.instanceof(e) ? e.unwrap() === this.unwrap() : this.toUniversalAddress().equals(e);
  }
};
tt(ji, "byteSize", 32), tt(ji, "platform", _platform$3);
let AptosAddress = ji;
registerNative(_platform$3, AptosAddress);
const cosmwasmAddressPrefix = [
  ["Cosmoshub", "cosmos"],
  ["Evmos", "evmos"],
  ["Injective", "inj"],
  ["Kujira", "kuji"],
  ["Osmosis", "osmo"],
  ["Sei", "sei"],
  ["Terra", "terra"],
  ["Terra2", "terra"],
  ["Wormchain", "wormhole"],
  ["Xpla", "xpla"],
  ["Celestia", "celestia"],
  ["Stargaze", "stars"],
  ["Dymension", "dym"],
  ["Neutron", "neutron"],
  ["Seda", "seda"],
  ["Provenance", "pb"],
  ["Noble", "noble"]
], chainToAddressPrefix = constMap(cosmwasmAddressPrefix);
constMap(cosmwasmAddressPrefix, [1, [0]]);
const cosmwasmNativeDenom = [
  [
    "Mainnet",
    [
      ["Cosmoshub", "uatom"],
      ["Evmos", "aevmos"],
      ["Injective", "inj"],
      ["Kujira", "kuji"],
      ["Osmosis", "uosmo"],
      ["Sei", "usei"],
      ["Terra", "luna"],
      ["Terra2", "uluna"],
      ["Wormchain", "uworm"],
      ["Xpla", "uxpla"],
      ["Celestia", "utia"],
      ["Dymension", "adym"],
      ["Stargaze", "ustars"],
      ["Neutron", "untrn"],
      ["Provenance", "nhash"],
      ["Noble", "uusdc"]
    ]
  ],
  [
    "Testnet",
    [
      ["Cosmoshub", "uatom"],
      ["Evmos", "atevmos"],
      ["Injective", "inj"],
      ["Kujira", "kuji"],
      ["Osmosis", "uosmo"],
      ["Sei", "usei"],
      ["Terra", "luna"],
      ["Terra2", "uluna"],
      ["Wormchain", "uworm"],
      ["Xpla", "uxpla"],
      ["Seda", "aseda"]
    ]
  ],
  [
    "Devnet",
    [
      ["Cosmoshub", "uatom"],
      ["Evmos", "atevmos"],
      ["Injective", "inj"],
      ["Kujira", "kuji"],
      ["Osmosis", "uosmo"],
      ["Sei", "usei"],
      ["Terra", "luna"],
      ["Terra2", "uluna"],
      ["Wormchain", "uworm"],
      ["Xpla", "uxpla"]
    ]
  ]
];
constMap(cosmwasmNativeDenom);
constMap(cosmwasmNativeDenom, [[0, 2], [1]]);
const gatewayConnections = [
  [
    "Mainnet",
    [
      [
        "Wormchain",
        {
          Osmosis: "channel-3",
          Evmos: "channel-5",
          Kujira: "channel-9",
          Stargaze: "channel-12",
          Injective: "channel-13",
          Dymension: "channel-15"
        }
      ],
      ["Osmosis", { Wormchain: "channel-2186" }],
      ["Evmos", { Wormchain: "channel-94" }],
      ["Kujira", { Wormchain: "channel-113" }],
      ["Injective", { Wormchain: "channel-183" }],
      ["Dymension", { Wormchain: "channel-36" }],
      ["Stargaze", { Wormchain: "channel-278" }]
    ]
  ],
  [
    "Testnet",
    [
      [
        "Wormchain",
        {
          Cosmoshub: "channel-5",
          Injective: "channel-15",
          Kujira: "channel-16",
          Stargaze: "channel-17",
          Osmosis: "channel-19",
          Dymension: "channel-18",
          Evmos: "channel-20"
        }
      ],
      ["Cosmoshub", { Wormchain: "channel-3086" }],
      ["Injective", { Wormchain: "channel-76973" }],
      ["Kujira", { Wormchain: "channel-114" }],
      ["Osmosis", { Wormchain: "channel-7904" }],
      ["Stargaze", { Wormchain: "channel-949" }],
      ["Evmos", { Wormchain: "channel-240" }],
      ["Dymension", { Wormchain: "channel-23" }]
    ]
  ],
  [
    "Devnet",
    [
      ["Wormchain", { Cosmoshub: "channel-1", Osmosis: "channel-2" }],
      ["Cosmoshub", { Wormchain: "channel-1" }],
      ["Osmosis", { Wormchain: "channel-1" }]
    ]
  ]
];
constMap(gatewayConnections);
const cosmwasmNetworkChainRestUrl = [
  [
    "Mainnet",
    [
      ["Injective", "https://lcd.injective.network"],
      ["Evmos", "https://rest.bd.evmos.org:1317"]
    ]
  ],
  [
    "Testnet",
    [
      ["Injective", "https://k8s.testnet.lcd.injective.network"],
      ["Evmos", "https://rest.bd.evmos.dev:1317"]
    ]
  ],
  [
    "Devnet",
    [
      ["Injective", "https://localhost:1234"],
      ["Evmos", "https://localhost:1233"]
    ]
  ]
];
constMap(cosmwasmNetworkChainRestUrl);
const avgPrices = [
  [
    "Mainnet",
    [
      ["Terra", "28.325"],
      ["Terra2", "0.015"],
      ["Osmosis", "0.025"],
      ["Sei", "0.02"],
      ["Cosmoshub", "0.025"],
      ["Kujira", "0.0051"],
      ["Neutron", "0.075"],
      ["Celestia", "0.02"],
      ["Stargaze", "1.1"],
      ["Injective", "700000000"],
      ["Xpla", "1147500000000"],
      ["Evmos", "25000000000"],
      ["Dymension", "5000000000"],
      ["Provenance", "2100"],
      ["Noble", "0.1"]
    ]
  ]
];
constMap(avgPrices);
const _platform$2 = "Cosmwasm";
function tryDecode(C) {
  try {
    const e = bech32.decodeToBytes(C);
    return { data: e.bytes, prefix: e.prefix };
  } catch {
  }
  try {
    return { data: hex$1.decode(C) };
  } catch {
  }
  try {
    return { data: b64.decode(C) };
  } catch {
  }
  throw new Error(`Cannot decode: ${C}`);
}
const Yn = class Yn {
  constructor(e) {
    // the actual bytes of the address
    tt(this, "address");
    // The domain is the prefix for the address, like "cosmos" or "ibc"
    tt(this, "domain");
    // The denom is the token name, like "uatom" or "usdc"
    tt(this, "denom");
    // The denomType is "native", "ibc", or "factory"
    tt(this, "denomType");
    if (Yn.instanceof(e)) {
      const T = e;
      this.address = T.address, this.domain = T.domain, this.denom = T.denom, this.denomType = T.denomType;
      return;
    }
    if (typeof e == "string") {
      if (e.length <= 8) {
        this.address = new Uint8Array(0), this.denom = e, this.denomType = "native";
        return;
      }
      if (e.indexOf("/") !== -1) {
        const T = e.split("/");
        if (T.length >= 3) {
          const { data: $, prefix: V } = tryDecode(T[T.length - 2]);
          this.address = $, this.domain = V, this.denom = T[T.length - 1], this.denomType = T.slice(0, T.length - 2).join("/");
        } else {
          const { data: $ } = tryDecode(T[1]);
          this.address = $, this.denomType = T[0];
        }
      } else {
        if (!Yn.isValidAddress(e))
          throw new Error(`Invalid Cosmwasm address:  ${e}`);
        const { bytes: T, prefix: $ } = bech32.decodeToBytes(e);
        this.address = T, this.domain = $;
      }
    } else if (e instanceof Uint8Array)
      this.address = e;
    else if (UniversalAddress.instanceof(e))
      this.address = e.toUint8Array();
    else
      throw new Error(`Invalid Cosmwasm address ${e}`);
    if (!Yn.validAddressLength(this.address))
      throw new Error("Expected 20 or 32 bytes address");
  }
  unwrap() {
    return this.toString();
  }
  toString() {
    return this.denomType !== void 0 ? this.denomType === "native" ? this.denom : this.denomType === "ibc" ? `${this.denomType.toLowerCase()}/${hex$1.encode(this.address).toUpperCase()}` : `${this.denomType}/${Yn.encode(this.domain, this.address)}/${this.denom}` : Yn.encode(this.domain, this.address);
  }
  toNative() {
    return this;
  }
  toUint8Array() {
    return this.address;
  }
  toUniversalAddress() {
    const e = new Uint8Array(UniversalAddress.byteSize);
    return e.set(this.address, UniversalAddress.byteSize - this.address.length), new UniversalAddress(e);
  }
  setChain(e) {
    this.domain = chainToAddressPrefix.get(e);
  }
  static isValidAddress(e) {
    try {
      const T = bech32.decodeToBytes(e);
      return Yn.validAddressLength(T.bytes);
    } catch {
    }
    return !1;
  }
  static encode(e, T) {
    return bech32.encode(e, bech32.toWords(T));
  }
  static validAddressLength(e) {
    if (e.length !== Yn.contractAddressByteSize && e.length !== Yn.accountAddressByteSize)
      throw new Error(`Invalid Cosmwasm address, expected ${Yn.contractAddressByteSize} or ${Yn.accountAddressByteSize} bytes but got ${e.length}`);
    return !0;
  }
  static instanceof(e) {
    return e.constructor.platform === Yn.platform;
  }
  equals(e) {
    return Yn.instanceof(e) ? this.toString() === e.toString() : e.equals(this.toUniversalAddress());
  }
};
tt(Yn, "contractAddressByteSize", 32), tt(Yn, "accountAddressByteSize", 20), tt(Yn, "platform", _platform$2);
let CosmwasmAddress = Yn;
registerNative(_platform$2, CosmwasmAddress);
const unusedNonce = 0, unusedArbiterFee = 0n, _platform$1 = "Evm", addFrom = (C, e) => ({
  ...C,
  from: e
}), addChainId = (C, e) => ({
  ...C,
  chainId: e
}), EvmZeroAddress = "0x0000000000000000000000000000000000000000", pr = class pr {
  constructor(e) {
    tt(this, "type", "Native");
    // stored as checksum address
    tt(this, "address");
    if (pr.instanceof(e)) {
      const T = e;
      this.address = T.address;
      return;
    }
    if (typeof e == "string") {
      if (!pr.isValidAddress(e))
        throw new Error(`Invalid EVM address, expected ${pr.byteSize}-byte hex string but got ${e}`);
      this.address = getAddress(e);
    } else if (e instanceof Uint8Array)
      e = this.trimUniversalAddress(e), this.address = getAddress(hex$1.encode(e));
    else if (UniversalAddress.instanceof(e)) {
      const T = this.trimUniversalAddress(e.toUint8Array());
      this.address = getAddress(hex$1.encode(T));
    } else
      throw new Error(`Invalid EVM address ${e}`);
  }
  unwrap() {
    return this.address;
  }
  toString() {
    return this.address;
  }
  toNative() {
    return this;
  }
  toUint8Array() {
    return hex$1.decode(this.address);
  }
  toUniversalAddress() {
    return new UniversalAddress(this.address, "hex");
  }
  trimUniversalAddress(e) {
    if (e.length === pr.byteSize)
      return e;
    if (e.length < pr.byteSize)
      throw new Error(`Invalid evm address, expected ${pr.byteSize} bytes`);
    if (e.length !== UniversalAddress.byteSize)
      throw new Error(`Invalid universal address, expected ${UniversalAddress.byteSize} bytes`);
    if (bignum.decode(e.slice(0, 12)) !== 0n)
      throw new Error(`Invalid EVM address ${e} expected first 12 bytes to be 0s`);
    return e.slice(12);
  }
  static isValidAddress(e) {
    return isAddress(e);
  }
  static instanceof(e) {
    return e.constructor.platform === pr.platform;
  }
  equals(e) {
    return pr.instanceof(e) ? e.address === this.address : e.equals(this.toUniversalAddress());
  }
};
tt(pr, "byteSize", 20), tt(pr, "platform", _platform$1);
let EvmAddress = pr;
registerNative(_platform$1, EvmAddress);
var _Buffer = safeBufferExports.Buffer;
function base$3(C) {
  if (C.length >= 255)
    throw new TypeError("Alphabet too long");
  for (var e = new Uint8Array(256), T = 0; T < e.length; T++)
    e[T] = 255;
  for (var $ = 0; $ < C.length; $++) {
    var V = C.charAt($), J = V.charCodeAt(0);
    if (e[J] !== 255)
      throw new TypeError(V + " is ambiguous");
    e[J] = $;
  }
  var ee = C.length, te = C.charAt(0), re = Math.log(ee) / Math.log(256), ie = Math.log(256) / Math.log(ee);
  function se(fe) {
    if ((Array.isArray(fe) || fe instanceof Uint8Array) && (fe = _Buffer.from(fe)), !_Buffer.isBuffer(fe))
      throw new TypeError("Expected Buffer");
    if (fe.length === 0)
      return "";
    for (var he = 0, me = 0, xe = 0, ve = fe.length; xe !== ve && fe[xe] === 0; )
      xe++, he++;
    for (var Te = (ve - xe) * ie + 1 >>> 0, we = new Uint8Array(Te); xe !== ve; ) {
      for (var Ee = fe[xe], Me = 0, Ie = Te - 1; (Ee !== 0 || Me < me) && Ie !== -1; Ie--, Me++)
        Ee += 256 * we[Ie] >>> 0, we[Ie] = Ee % ee >>> 0, Ee = Ee / ee >>> 0;
      if (Ee !== 0)
        throw new Error("Non-zero carry");
      me = Me, xe++;
    }
    for (var ke = Te - me; ke !== Te && we[ke] === 0; )
      ke++;
    for (var _e = te.repeat(he); ke < Te; ++ke)
      _e += C.charAt(we[ke]);
    return _e;
  }
  function de(fe) {
    if (typeof fe != "string")
      throw new TypeError("Expected String");
    if (fe.length === 0)
      return _Buffer.alloc(0);
    for (var he = 0, me = 0, xe = 0; fe[he] === te; )
      me++, he++;
    for (var ve = (fe.length - he) * re + 1 >>> 0, Te = new Uint8Array(ve); he < fe.length; ) {
      var we = e[fe.charCodeAt(he)];
      if (we === 255)
        return;
      for (var Ee = 0, Me = ve - 1; (we !== 0 || Ee < xe) && Me !== -1; Me--, Ee++)
        we += ee * Te[Me] >>> 0, Te[Me] = we % 256 >>> 0, we = we / 256 >>> 0;
      if (we !== 0)
        throw new Error("Non-zero carry");
      xe = Ee, he++;
    }
    for (var Ie = ve - xe; Ie !== ve && Te[Ie] === 0; )
      Ie++;
    var ke = _Buffer.allocUnsafe(me + (ve - Ie));
    ke.fill(0, 0, me);
    for (var _e = me; Ie !== ve; )
      ke[_e++] = Te[Ie++];
    return ke;
  }
  function ue(fe) {
    var he = de(fe);
    if (he)
      return he;
    throw new Error("Non-base" + ee + " character");
  }
  return {
    encode: se,
    decodeUnsafe: de,
    decode: ue
  };
}
var src$2 = base$3, basex$2 = src$2, ALPHABET$2 = "123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz", bs58$5 = basex$2(ALPHABET$2);
const bs58$6 = /* @__PURE__ */ getDefaultExportFromCjs$2(bs58$5);
var lib = {};
function inRange(C, e, T) {
  return e <= C && C <= T;
}
function ToDictionary(C) {
  if (C === void 0) return {};
  if (C === Object(C)) return C;
  throw TypeError("Could not convert argument to dictionary");
}
function stringToCodePoints(C) {
  for (var e = String(C), T = e.length, $ = 0, V = []; $ < T; ) {
    var J = e.charCodeAt($);
    if (J < 55296 || J > 57343)
      V.push(J);
    else if (56320 <= J && J <= 57343)
      V.push(65533);
    else if (55296 <= J && J <= 56319)
      if ($ === T - 1)
        V.push(65533);
      else {
        var ee = C.charCodeAt($ + 1);
        if (56320 <= ee && ee <= 57343) {
          var te = J & 1023, re = ee & 1023;
          V.push(65536 + (te << 10) + re), $ += 1;
        } else
          V.push(65533);
      }
    $ += 1;
  }
  return V;
}
function codePointsToString(C) {
  for (var e = "", T = 0; T < C.length; ++T) {
    var $ = C[T];
    $ <= 65535 ? e += String.fromCharCode($) : ($ -= 65536, e += String.fromCharCode(
      ($ >> 10) + 55296,
      ($ & 1023) + 56320
    ));
  }
  return e;
}
var end_of_stream = -1;
function Stream(C) {
  this.tokens = [].slice.call(C);
}
Stream.prototype = {
  /**
   * @return {boolean} True if end-of-stream has been hit.
   */
  endOfStream: function() {
    return !this.tokens.length;
  },
  /**
   * When a token is read from a stream, the first token in the
   * stream must be returned and subsequently removed, and
   * end-of-stream must be returned otherwise.
   *
   * @return {number} Get the next token from the stream, or
   * end_of_stream.
   */
  read: function() {
    return this.tokens.length ? this.tokens.shift() : end_of_stream;
  },
  /**
   * When one or more tokens are prepended to a stream, those tokens
   * must be inserted, in given order, before the first token in the
   * stream.
   *
   * @param {(number|!Array.<number>)} token The token(s) to prepend to the stream.
   */
  prepend: function(C) {
    if (Array.isArray(C))
      for (var e = (
        /**@type {!Array.<number>}*/
        C
      ); e.length; )
        this.tokens.unshift(e.pop());
    else
      this.tokens.unshift(C);
  },
  /**
   * When one or more tokens are pushed to a stream, those tokens
   * must be inserted, in given order, after the last token in the
   * stream.
   *
   * @param {(number|!Array.<number>)} token The tokens(s) to prepend to the stream.
   */
  push: function(C) {
    if (Array.isArray(C))
      for (var e = (
        /**@type {!Array.<number>}*/
        C
      ); e.length; )
        this.tokens.push(e.shift());
    else
      this.tokens.push(C);
  }
};
var finished = -1;
function decoderError(C, e) {
  if (C)
    throw TypeError("Decoder error");
  return e || 65533;
}
var DEFAULT_ENCODING = "utf-8";
function TextDecoder$1(C, e) {
  if (!(this instanceof TextDecoder$1))
    return new TextDecoder$1(C, e);
  if (C = C !== void 0 ? String(C).toLowerCase() : DEFAULT_ENCODING, C !== DEFAULT_ENCODING)
    throw new Error("Encoding not supported. Only utf-8 is supported");
  e = ToDictionary(e), this._streaming = !1, this._BOMseen = !1, this._decoder = null, this._fatal = !!e.fatal, this._ignoreBOM = !!e.ignoreBOM, Object.defineProperty(this, "encoding", { value: "utf-8" }), Object.defineProperty(this, "fatal", { value: this._fatal }), Object.defineProperty(this, "ignoreBOM", { value: this._ignoreBOM });
}
TextDecoder$1.prototype = {
  /**
   * @param {ArrayBufferView=} input The buffer of bytes to decode.
   * @param {Object=} options
   * @return {string} The decoded string.
   */
  decode: function(e, T) {
    var $;
    typeof e == "object" && e instanceof ArrayBuffer ? $ = new Uint8Array(e) : typeof e == "object" && "buffer" in e && e.buffer instanceof ArrayBuffer ? $ = new Uint8Array(
      e.buffer,
      e.byteOffset,
      e.byteLength
    ) : $ = new Uint8Array(0), T = ToDictionary(T), this._streaming || (this._decoder = new UTF8Decoder({ fatal: this._fatal }), this._BOMseen = !1), this._streaming = !!T.stream;
    for (var V = new Stream($), J = [], ee; !V.endOfStream() && (ee = this._decoder.handler(V, V.read()), ee !== finished); )
      ee !== null && (Array.isArray(ee) ? J.push.apply(
        J,
        /**@type {!Array.<number>}*/
        ee
      ) : J.push(ee));
    if (!this._streaming) {
      do {
        if (ee = this._decoder.handler(V, V.read()), ee === finished)
          break;
        ee !== null && (Array.isArray(ee) ? J.push.apply(
          J,
          /**@type {!Array.<number>}*/
          ee
        ) : J.push(ee));
      } while (!V.endOfStream());
      this._decoder = null;
    }
    return J.length && ["utf-8"].indexOf(this.encoding) !== -1 && !this._ignoreBOM && !this._BOMseen && (J[0] === 65279 ? (this._BOMseen = !0, J.shift()) : this._BOMseen = !0), codePointsToString(J);
  }
};
function TextEncoder$1(C, e) {
  if (!(this instanceof TextEncoder$1))
    return new TextEncoder$1(C, e);
  if (C = C !== void 0 ? String(C).toLowerCase() : DEFAULT_ENCODING, C !== DEFAULT_ENCODING)
    throw new Error("Encoding not supported. Only utf-8 is supported");
  e = ToDictionary(e), this._streaming = !1, this._encoder = null, this._options = { fatal: !!e.fatal }, Object.defineProperty(this, "encoding", { value: "utf-8" });
}
TextEncoder$1.prototype = {
  /**
   * @param {string=} opt_string The string to encode.
   * @param {Object=} options
   * @return {Uint8Array} Encoded bytes, as a Uint8Array.
   */
  encode: function(e, T) {
    e = e ? String(e) : "", T = ToDictionary(T), this._streaming || (this._encoder = new UTF8Encoder(this._options)), this._streaming = !!T.stream;
    for (var $ = [], V = new Stream(stringToCodePoints(e)), J; !V.endOfStream() && (J = this._encoder.handler(V, V.read()), J !== finished); )
      Array.isArray(J) ? $.push.apply(
        $,
        /**@type {!Array.<number>}*/
        J
      ) : $.push(J);
    if (!this._streaming) {
      for (; J = this._encoder.handler(V, V.read()), J !== finished; )
        Array.isArray(J) ? $.push.apply(
          $,
          /**@type {!Array.<number>}*/
          J
        ) : $.push(J);
      this._encoder = null;
    }
    return new Uint8Array($);
  }
};
function UTF8Decoder(C) {
  var e = C.fatal, T = 0, $ = 0, V = 0, J = 128, ee = 191;
  this.handler = function(te, re) {
    if (re === end_of_stream && V !== 0)
      return V = 0, decoderError(e);
    if (re === end_of_stream)
      return finished;
    if (V === 0) {
      if (inRange(re, 0, 127))
        return re;
      if (inRange(re, 194, 223))
        V = 1, T = re - 192;
      else if (inRange(re, 224, 239))
        re === 224 && (J = 160), re === 237 && (ee = 159), V = 2, T = re - 224;
      else if (inRange(re, 240, 244))
        re === 240 && (J = 144), re === 244 && (ee = 143), V = 3, T = re - 240;
      else
        return decoderError(e);
      return T = T << 6 * V, null;
    }
    if (!inRange(re, J, ee))
      return T = V = $ = 0, J = 128, ee = 191, te.prepend(re), decoderError(e);
    if (J = 128, ee = 191, $ += 1, T += re - 128 << 6 * (V - $), $ !== V)
      return null;
    var ie = T;
    return T = V = $ = 0, ie;
  };
}
function UTF8Encoder(C) {
  C.fatal, this.handler = function(e, T) {
    if (T === end_of_stream)
      return finished;
    if (inRange(T, 0, 127))
      return T;
    var $, V;
    inRange(T, 128, 2047) ? ($ = 1, V = 192) : inRange(T, 2048, 65535) ? ($ = 2, V = 224) : inRange(T, 65536, 1114111) && ($ = 3, V = 240);
    for (var J = [(T >> 6 * $) + V]; $ > 0; ) {
      var ee = T >> 6 * ($ - 1);
      J.push(128 | ee & 63), $ -= 1;
    }
    return J;
  };
}
const encoding$1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  TextDecoder: TextDecoder$1,
  TextEncoder: TextEncoder$1
}, Symbol.toStringTag, { value: "Module" })), require$$2 = /* @__PURE__ */ getAugmentedNamespace(encoding$1);
var __createBinding = commonjsGlobal$1 && commonjsGlobal$1.__createBinding || (Object.create ? function(C, e, T, $) {
  $ === void 0 && ($ = T), Object.defineProperty(C, $, { enumerable: !0, get: function() {
    return e[T];
  } });
} : function(C, e, T, $) {
  $ === void 0 && ($ = T), C[$] = e[T];
}), __setModuleDefault = commonjsGlobal$1 && commonjsGlobal$1.__setModuleDefault || (Object.create ? function(C, e) {
  Object.defineProperty(C, "default", { enumerable: !0, value: e });
} : function(C, e) {
  C.default = e;
}), __decorate = commonjsGlobal$1 && commonjsGlobal$1.__decorate || function(C, e, T, $) {
  var V = arguments.length, J = V < 3 ? e : $ === null ? $ = Object.getOwnPropertyDescriptor(e, T) : $, ee;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") J = Reflect.decorate(C, e, T, $);
  else for (var te = C.length - 1; te >= 0; te--) (ee = C[te]) && (J = (V < 3 ? ee(J) : V > 3 ? ee(e, T, J) : ee(e, T)) || J);
  return V > 3 && J && Object.defineProperty(e, T, J), J;
}, __importStar = commonjsGlobal$1 && commonjsGlobal$1.__importStar || function(C) {
  if (C && C.__esModule) return C;
  var e = {};
  if (C != null) for (var T in C) T !== "default" && Object.hasOwnProperty.call(C, T) && __createBinding(e, C, T);
  return __setModuleDefault(e, C), e;
}, __importDefault$1 = commonjsGlobal$1 && commonjsGlobal$1.__importDefault || function(C) {
  return C && C.__esModule ? C : { default: C };
};
Object.defineProperty(lib, "__esModule", { value: !0 });
var deserializeUnchecked_1 = lib.deserializeUnchecked = deserialize_1 = lib.deserialize = serialize_1 = lib.serialize = lib.BinaryReader = lib.BinaryWriter = lib.BorshError = lib.baseDecode = lib.baseEncode = void 0;
const bn_js_1 = __importDefault$1(bnExports), bs58_1 = __importDefault$1(bs58$5), encoding = __importStar(require$$2), ResolvedTextDecoder = typeof TextDecoder != "function" ? encoding.TextDecoder : TextDecoder, textDecoder = new ResolvedTextDecoder("utf-8", { fatal: !0 });
function baseEncode(C) {
  return typeof C == "string" && (C = dist$2.Buffer.from(C, "utf8")), bs58_1.default.encode(dist$2.Buffer.from(C));
}
lib.baseEncode = baseEncode;
function baseDecode(C) {
  return dist$2.Buffer.from(bs58_1.default.decode(C));
}
lib.baseDecode = baseDecode;
const INITIAL_LENGTH = 1024;
class BorshError extends Error {
  constructor(e) {
    super(e), this.fieldPath = [], this.originalMessage = e;
  }
  addToFieldPath(e) {
    this.fieldPath.splice(0, 0, e), this.message = this.originalMessage + ": " + this.fieldPath.join(".");
  }
}
lib.BorshError = BorshError;
class BinaryWriter {
  constructor() {
    this.buf = dist$2.Buffer.alloc(INITIAL_LENGTH), this.length = 0;
  }
  maybeResize() {
    this.buf.length < 16 + this.length && (this.buf = dist$2.Buffer.concat([this.buf, dist$2.Buffer.alloc(INITIAL_LENGTH)]));
  }
  writeU8(e) {
    this.maybeResize(), this.buf.writeUInt8(e, this.length), this.length += 1;
  }
  writeU16(e) {
    this.maybeResize(), this.buf.writeUInt16LE(e, this.length), this.length += 2;
  }
  writeU32(e) {
    this.maybeResize(), this.buf.writeUInt32LE(e, this.length), this.length += 4;
  }
  writeU64(e) {
    this.maybeResize(), this.writeBuffer(dist$2.Buffer.from(new bn_js_1.default(e).toArray("le", 8)));
  }
  writeU128(e) {
    this.maybeResize(), this.writeBuffer(dist$2.Buffer.from(new bn_js_1.default(e).toArray("le", 16)));
  }
  writeU256(e) {
    this.maybeResize(), this.writeBuffer(dist$2.Buffer.from(new bn_js_1.default(e).toArray("le", 32)));
  }
  writeU512(e) {
    this.maybeResize(), this.writeBuffer(dist$2.Buffer.from(new bn_js_1.default(e).toArray("le", 64)));
  }
  writeBuffer(e) {
    this.buf = dist$2.Buffer.concat([
      dist$2.Buffer.from(this.buf.subarray(0, this.length)),
      e,
      dist$2.Buffer.alloc(INITIAL_LENGTH)
    ]), this.length += e.length;
  }
  writeString(e) {
    this.maybeResize();
    const T = dist$2.Buffer.from(e, "utf8");
    this.writeU32(T.length), this.writeBuffer(T);
  }
  writeFixedArray(e) {
    this.writeBuffer(dist$2.Buffer.from(e));
  }
  writeArray(e, T) {
    this.maybeResize(), this.writeU32(e.length);
    for (const $ of e)
      this.maybeResize(), T($);
  }
  toArray() {
    return this.buf.subarray(0, this.length);
  }
}
lib.BinaryWriter = BinaryWriter;
function handlingRangeError(C, e, T) {
  const $ = T.value;
  T.value = function(...V) {
    try {
      return $.apply(this, V);
    } catch (J) {
      if (J instanceof RangeError) {
        const ee = J.code;
        if (["ERR_BUFFER_OUT_OF_BOUNDS", "ERR_OUT_OF_RANGE"].indexOf(ee) >= 0)
          throw new BorshError("Reached the end of buffer when deserializing");
      }
      throw J;
    }
  };
}
class BinaryReader {
  constructor(e) {
    this.buf = e, this.offset = 0;
  }
  readU8() {
    const e = this.buf.readUInt8(this.offset);
    return this.offset += 1, e;
  }
  readU16() {
    const e = this.buf.readUInt16LE(this.offset);
    return this.offset += 2, e;
  }
  readU32() {
    const e = this.buf.readUInt32LE(this.offset);
    return this.offset += 4, e;
  }
  readU64() {
    const e = this.readBuffer(8);
    return new bn_js_1.default(e, "le");
  }
  readU128() {
    const e = this.readBuffer(16);
    return new bn_js_1.default(e, "le");
  }
  readU256() {
    const e = this.readBuffer(32);
    return new bn_js_1.default(e, "le");
  }
  readU512() {
    const e = this.readBuffer(64);
    return new bn_js_1.default(e, "le");
  }
  readBuffer(e) {
    if (this.offset + e > this.buf.length)
      throw new BorshError(`Expected buffer length ${e} isn't within bounds`);
    const T = this.buf.slice(this.offset, this.offset + e);
    return this.offset += e, T;
  }
  readString() {
    const e = this.readU32(), T = this.readBuffer(e);
    try {
      return textDecoder.decode(T);
    } catch ($) {
      throw new BorshError(`Error decoding UTF-8 string: ${$}`);
    }
  }
  readFixedArray(e) {
    return new Uint8Array(this.readBuffer(e));
  }
  readArray(e) {
    const T = this.readU32(), $ = Array();
    for (let V = 0; V < T; ++V)
      $.push(e());
    return $;
  }
}
__decorate([
  handlingRangeError
], BinaryReader.prototype, "readU8", null);
__decorate([
  handlingRangeError
], BinaryReader.prototype, "readU16", null);
__decorate([
  handlingRangeError
], BinaryReader.prototype, "readU32", null);
__decorate([
  handlingRangeError
], BinaryReader.prototype, "readU64", null);
__decorate([
  handlingRangeError
], BinaryReader.prototype, "readU128", null);
__decorate([
  handlingRangeError
], BinaryReader.prototype, "readU256", null);
__decorate([
  handlingRangeError
], BinaryReader.prototype, "readU512", null);
__decorate([
  handlingRangeError
], BinaryReader.prototype, "readString", null);
__decorate([
  handlingRangeError
], BinaryReader.prototype, "readFixedArray", null);
__decorate([
  handlingRangeError
], BinaryReader.prototype, "readArray", null);
lib.BinaryReader = BinaryReader;
function capitalizeFirstLetter(C) {
  return C.charAt(0).toUpperCase() + C.slice(1);
}
function serializeField(C, e, T, $, V) {
  try {
    if (typeof $ == "string")
      V[`write${capitalizeFirstLetter($)}`](T);
    else if ($ instanceof Array)
      if (typeof $[0] == "number") {
        if (T.length !== $[0])
          throw new BorshError(`Expecting byte array of length ${$[0]}, but got ${T.length} bytes`);
        V.writeFixedArray(T);
      } else if ($.length === 2 && typeof $[1] == "number") {
        if (T.length !== $[1])
          throw new BorshError(`Expecting byte array of length ${$[1]}, but got ${T.length} bytes`);
        for (let J = 0; J < $[1]; J++)
          serializeField(C, null, T[J], $[0], V);
      } else
        V.writeArray(T, (J) => {
          serializeField(C, e, J, $[0], V);
        });
    else if ($.kind !== void 0)
      switch ($.kind) {
        case "option": {
          T == null ? V.writeU8(0) : (V.writeU8(1), serializeField(C, e, T, $.type, V));
          break;
        }
        case "map": {
          V.writeU32(T.size), T.forEach((J, ee) => {
            serializeField(C, e, ee, $.key, V), serializeField(C, e, J, $.value, V);
          });
          break;
        }
        default:
          throw new BorshError(`FieldType ${$} unrecognized`);
      }
    else
      serializeStruct(C, T, V);
  } catch (J) {
    throw J instanceof BorshError && J.addToFieldPath(e), J;
  }
}
function serializeStruct(C, e, T) {
  if (typeof e.borshSerialize == "function") {
    e.borshSerialize(T);
    return;
  }
  const $ = C.get(e.constructor);
  if (!$)
    throw new BorshError(`Class ${e.constructor.name} is missing in schema`);
  if ($.kind === "struct")
    $.fields.map(([V, J]) => {
      serializeField(C, V, e[V], J, T);
    });
  else if ($.kind === "enum") {
    const V = e[$.field];
    for (let J = 0; J < $.values.length; ++J) {
      const [ee, te] = $.values[J];
      if (ee === V) {
        T.writeU8(J), serializeField(C, ee, e[ee], te, T);
        break;
      }
    }
  } else
    throw new BorshError(`Unexpected schema kind: ${$.kind} for ${e.constructor.name}`);
}
function serialize(C, e, T = BinaryWriter) {
  const $ = new T();
  return serializeStruct(C, e, $), $.toArray();
}
var serialize_1 = lib.serialize = serialize;
function deserializeField(C, e, T, $) {
  try {
    if (typeof T == "string")
      return $[`read${capitalizeFirstLetter(T)}`]();
    if (T instanceof Array) {
      if (typeof T[0] == "number")
        return $.readFixedArray(T[0]);
      if (typeof T[1] == "number") {
        const V = [];
        for (let J = 0; J < T[1]; J++)
          V.push(deserializeField(C, null, T[0], $));
        return V;
      } else
        return $.readArray(() => deserializeField(C, e, T[0], $));
    }
    if (T.kind === "option")
      return $.readU8() ? deserializeField(C, e, T.type, $) : void 0;
    if (T.kind === "map") {
      let V = /* @__PURE__ */ new Map();
      const J = $.readU32();
      for (let ee = 0; ee < J; ee++) {
        const te = deserializeField(C, e, T.key, $), re = deserializeField(C, e, T.value, $);
        V.set(te, re);
      }
      return V;
    }
    return deserializeStruct(C, T, $);
  } catch (V) {
    throw V instanceof BorshError && V.addToFieldPath(e), V;
  }
}
function deserializeStruct(C, e, T) {
  if (typeof e.borshDeserialize == "function")
    return e.borshDeserialize(T);
  const $ = C.get(e);
  if (!$)
    throw new BorshError(`Class ${e.name} is missing in schema`);
  if ($.kind === "struct") {
    const V = {};
    for (const [J, ee] of C.get(e).fields)
      V[J] = deserializeField(C, J, ee, T);
    return new e(V);
  }
  if ($.kind === "enum") {
    const V = T.readU8();
    if (V >= $.values.length)
      throw new BorshError(`Enum index: ${V} is out of range`);
    const [J, ee] = $.values[V], te = deserializeField(C, J, ee, T);
    return new e({ [J]: te });
  }
  throw new BorshError(`Unexpected schema kind: ${$.kind} for ${e.constructor.name}`);
}
function deserialize(C, e, T, $ = BinaryReader) {
  const V = new $(T), J = deserializeStruct(C, e, V);
  if (V.offset < T.length)
    throw new BorshError(`Unexpected ${T.length - V.offset} bytes after deserialized data`);
  return J;
}
var deserialize_1 = lib.deserialize = deserialize;
function deserializeUnchecked(C, e, T, $ = BinaryReader) {
  const V = new $(T);
  return deserializeStruct(C, e, V);
}
deserializeUnchecked_1 = lib.deserializeUnchecked = deserializeUnchecked;
var Layout$4 = {};
Object.defineProperty(Layout$4, "__esModule", { value: !0 });
var s16 = Layout$4.s16 = Layout$4.s8 = Layout$4.nu64be = Layout$4.u48be = Layout$4.u40be = Layout$4.u32be = Layout$4.u24be = Layout$4.u16be = nu64$1 = Layout$4.nu64 = Layout$4.u48 = Layout$4.u40 = u32$1 = Layout$4.u32 = Layout$4.u24 = u16 = Layout$4.u16 = u8$1 = Layout$4.u8 = offset$3 = Layout$4.offset = greedy = Layout$4.greedy = Layout$4.Constant = Layout$4.UTF8 = Layout$4.CString = Layout$4.Blob = Layout$4.Boolean = Layout$4.BitField = Layout$4.BitStructure = Layout$4.VariantLayout = Layout$4.Union = Layout$4.UnionLayoutDiscriminator = Layout$4.UnionDiscriminator = Layout$4.Structure = Layout$4.Sequence = Layout$4.DoubleBE = Layout$4.Double = Layout$4.FloatBE = Layout$4.Float = Layout$4.NearInt64BE = Layout$4.NearInt64 = Layout$4.NearUInt64BE = Layout$4.NearUInt64 = Layout$4.IntBE = Layout$4.Int = Layout$4.UIntBE = Layout$4.UInt = Layout$4.OffsetLayout = Layout$4.GreedyCount = Layout$4.ExternalLayout = Layout$4.bindConstructorLayout = Layout$4.nameWithProperty = Layout$4.Layout = Layout$4.uint8ArrayToBuffer = Layout$4.checkUint8Array = void 0;
Layout$4.constant = Layout$4.utf8 = Layout$4.cstr = blob$1 = Layout$4.blob = Layout$4.unionLayoutDiscriminator = Layout$4.union = seq = Layout$4.seq = Layout$4.bits = struct$1 = Layout$4.struct = Layout$4.f64be = Layout$4.f64 = Layout$4.f32be = Layout$4.f32 = Layout$4.ns64be = Layout$4.s48be = Layout$4.s40be = Layout$4.s32be = Layout$4.s24be = Layout$4.s16be = ns64$1 = Layout$4.ns64 = Layout$4.s48 = Layout$4.s40 = Layout$4.s32 = Layout$4.s24 = void 0;
const buffer_1 = bufferPolyfill;
function checkUint8Array(C) {
  if (!(C instanceof Uint8Array))
    throw new TypeError("b must be a Uint8Array");
}
Layout$4.checkUint8Array = checkUint8Array;
function uint8ArrayToBuffer(C) {
  return checkUint8Array(C), buffer_1.Buffer.from(C.buffer, C.byteOffset, C.length);
}
Layout$4.uint8ArrayToBuffer = uint8ArrayToBuffer;
let Layout$3 = class {
  constructor(e, T) {
    if (!Number.isInteger(e))
      throw new TypeError("span must be an integer");
    this.span = e, this.property = T;
  }
  /** Function to create an Object into which decoded properties will
   * be written.
   *
   * Used only for layouts that {@link Layout#decode|decode} to Object
   * instances, which means:
   * * {@link Structure}
   * * {@link Union}
   * * {@link VariantLayout}
   * * {@link BitStructure}
   *
   * If left undefined the JavaScript representation of these layouts
   * will be Object instances.
   *
   * See {@link bindConstructorLayout}.
   */
  makeDestinationObject() {
    return {};
  }
  /**
   * Calculate the span of a specific instance of a layout.
   *
   * @param {Uint8Array} b - the buffer that contains an encoded instance.
   *
   * @param {Number} [offset] - the offset at which the encoded instance
   * starts.  If absent a zero offset is inferred.
   *
   * @return {Number} - the number of bytes covered by the layout
   * instance.  If this method is not overridden in a subclass the
   * definition-time constant {@link Layout#span|span} will be
   * returned.
   *
   * @throws {RangeError} - if the length of the value cannot be
   * determined.
   */
  getSpan(e, T) {
    if (0 > this.span)
      throw new RangeError("indeterminate span");
    return this.span;
  }
  /**
   * Replicate the layout using a new property.
   *
   * This function must be used to get a structurally-equivalent layout
   * with a different name since all {@link Layout} instances are
   * immutable.
   *
   * **NOTE** This is a shallow copy.  All fields except {@link
   * Layout#property|property} are strictly equal to the origin layout.
   *
   * @param {String} property - the value for {@link
   * Layout#property|property} in the replica.
   *
   * @returns {Layout} - the copy with {@link Layout#property|property}
   * set to `property`.
   */
  replicate(e) {
    const T = Object.create(this.constructor.prototype);
    return Object.assign(T, this), T.property = e, T;
  }
  /**
   * Create an object from layout properties and an array of values.
   *
   * **NOTE** This function returns `undefined` if invoked on a layout
   * that does not return its value as an Object.  Objects are
   * returned for things that are a {@link Structure}, which includes
   * {@link VariantLayout|variant layouts} if they are structures, and
   * excludes {@link Union}s.  If you want this feature for a union
   * you must use {@link Union.getVariant|getVariant} to select the
   * desired layout.
   *
   * @param {Array} values - an array of values that correspond to the
   * default order for properties.  As with {@link Layout#decode|decode}
   * layout elements that have no property name are skipped when
   * iterating over the array values.  Only the top-level properties are
   * assigned; arguments are not assigned to properties of contained
   * layouts.  Any unused values are ignored.
   *
   * @return {(Object|undefined)}
   */
  fromArray(e) {
  }
};
Layout$4.Layout = Layout$3;
function nameWithProperty$2(C, e) {
  return e.property ? C + "[" + e.property + "]" : C;
}
Layout$4.nameWithProperty = nameWithProperty$2;
function bindConstructorLayout$1(C, e) {
  if (typeof C != "function")
    throw new TypeError("Class must be constructor");
  if (Object.prototype.hasOwnProperty.call(C, "layout_"))
    throw new Error("Class is already bound to a layout");
  if (!(e && e instanceof Layout$3))
    throw new TypeError("layout must be a Layout");
  if (Object.prototype.hasOwnProperty.call(e, "boundConstructor_"))
    throw new Error("layout is already bound to a constructor");
  C.layout_ = e, e.boundConstructor_ = C, e.makeDestinationObject = () => new C(), Object.defineProperty(C.prototype, "encode", {
    value(T, $) {
      return e.encode(this, T, $);
    },
    writable: !0
  }), Object.defineProperty(C, "decode", {
    value(T, $) {
      return e.decode(T, $);
    },
    writable: !0
  });
}
Layout$4.bindConstructorLayout = bindConstructorLayout$1;
let ExternalLayout$2 = class extends Layout$3 {
  /**
   * Return `true` iff the external layout decodes to an unsigned
   * integer layout.
   *
   * In that case it can be used as the source of {@link
   * Sequence#count|Sequence counts}, {@link Blob#length|Blob lengths},
   * or as {@link UnionLayoutDiscriminator#layout|external union
   * discriminators}.
   *
   * @abstract
   */
  isCount() {
    throw new Error("ExternalLayout is abstract");
  }
};
Layout$4.ExternalLayout = ExternalLayout$2;
let GreedyCount$1 = class extends ExternalLayout$2 {
  constructor(e = 1, T) {
    if (!Number.isInteger(e) || 0 >= e)
      throw new TypeError("elementSpan must be a (positive) integer");
    super(-1, T), this.elementSpan = e;
  }
  /** @override */
  isCount() {
    return !0;
  }
  /** @override */
  decode(e, T = 0) {
    checkUint8Array(e);
    const $ = e.length - T;
    return Math.floor($ / this.elementSpan);
  }
  /** @override */
  encode(e, T, $) {
    return 0;
  }
};
Layout$4.GreedyCount = GreedyCount$1;
let OffsetLayout$2 = class extends ExternalLayout$2 {
  constructor(e, T = 0, $) {
    if (!(e instanceof Layout$3))
      throw new TypeError("layout must be a Layout");
    if (!Number.isInteger(T))
      throw new TypeError("offset must be integer or undefined");
    super(e.span, $ || e.property), this.layout = e, this.offset = T;
  }
  /** @override */
  isCount() {
    return this.layout instanceof UInt$2 || this.layout instanceof UIntBE$2;
  }
  /** @override */
  decode(e, T = 0) {
    return this.layout.decode(e, T + this.offset);
  }
  /** @override */
  encode(e, T, $ = 0) {
    return this.layout.encode(e, T, $ + this.offset);
  }
};
Layout$4.OffsetLayout = OffsetLayout$2;
let UInt$2 = class extends Layout$3 {
  constructor(e, T) {
    if (super(e, T), 6 < this.span)
      throw new RangeError("span must not exceed 6 bytes");
  }
  /** @override */
  decode(e, T = 0) {
    return uint8ArrayToBuffer(e).readUIntLE(T, this.span);
  }
  /** @override */
  encode(e, T, $ = 0) {
    return uint8ArrayToBuffer(T).writeUIntLE(e, $, this.span), this.span;
  }
};
Layout$4.UInt = UInt$2;
let UIntBE$2 = class extends Layout$3 {
  constructor(e, T) {
    if (super(e, T), 6 < this.span)
      throw new RangeError("span must not exceed 6 bytes");
  }
  /** @override */
  decode(e, T = 0) {
    return uint8ArrayToBuffer(e).readUIntBE(T, this.span);
  }
  /** @override */
  encode(e, T, $ = 0) {
    return uint8ArrayToBuffer(T).writeUIntBE(e, $, this.span), this.span;
  }
};
Layout$4.UIntBE = UIntBE$2;
let Int$1 = class extends Layout$3 {
  constructor(e, T) {
    if (super(e, T), 6 < this.span)
      throw new RangeError("span must not exceed 6 bytes");
  }
  /** @override */
  decode(e, T = 0) {
    return uint8ArrayToBuffer(e).readIntLE(T, this.span);
  }
  /** @override */
  encode(e, T, $ = 0) {
    return uint8ArrayToBuffer(T).writeIntLE(e, $, this.span), this.span;
  }
};
Layout$4.Int = Int$1;
let IntBE$1 = class extends Layout$3 {
  constructor(e, T) {
    if (super(e, T), 6 < this.span)
      throw new RangeError("span must not exceed 6 bytes");
  }
  /** @override */
  decode(e, T = 0) {
    return uint8ArrayToBuffer(e).readIntBE(T, this.span);
  }
  /** @override */
  encode(e, T, $ = 0) {
    return uint8ArrayToBuffer(T).writeIntBE(e, $, this.span), this.span;
  }
};
Layout$4.IntBE = IntBE$1;
const V2E32$2 = Math.pow(2, 32);
function divmodInt64$2(C) {
  const e = Math.floor(C / V2E32$2), T = C - e * V2E32$2;
  return { hi32: e, lo32: T };
}
function roundedInt64$2(C, e) {
  return C * V2E32$2 + e;
}
let NearUInt64$2 = class extends Layout$3 {
  constructor(e) {
    super(8, e);
  }
  /** @override */
  decode(e, T = 0) {
    const $ = uint8ArrayToBuffer(e), V = $.readUInt32LE(T), J = $.readUInt32LE(T + 4);
    return roundedInt64$2(J, V);
  }
  /** @override */
  encode(e, T, $ = 0) {
    const V = divmodInt64$2(e), J = uint8ArrayToBuffer(T);
    return J.writeUInt32LE(V.lo32, $), J.writeUInt32LE(V.hi32, $ + 4), 8;
  }
};
Layout$4.NearUInt64 = NearUInt64$2;
let NearUInt64BE$1 = class extends Layout$3 {
  constructor(e) {
    super(8, e);
  }
  /** @override */
  decode(e, T = 0) {
    const $ = uint8ArrayToBuffer(e), V = $.readUInt32BE(T), J = $.readUInt32BE(T + 4);
    return roundedInt64$2(V, J);
  }
  /** @override */
  encode(e, T, $ = 0) {
    const V = divmodInt64$2(e), J = uint8ArrayToBuffer(T);
    return J.writeUInt32BE(V.hi32, $), J.writeUInt32BE(V.lo32, $ + 4), 8;
  }
};
Layout$4.NearUInt64BE = NearUInt64BE$1;
let NearInt64$2 = class extends Layout$3 {
  constructor(e) {
    super(8, e);
  }
  /** @override */
  decode(e, T = 0) {
    const $ = uint8ArrayToBuffer(e), V = $.readUInt32LE(T), J = $.readInt32LE(T + 4);
    return roundedInt64$2(J, V);
  }
  /** @override */
  encode(e, T, $ = 0) {
    const V = divmodInt64$2(e), J = uint8ArrayToBuffer(T);
    return J.writeUInt32LE(V.lo32, $), J.writeInt32LE(V.hi32, $ + 4), 8;
  }
};
Layout$4.NearInt64 = NearInt64$2;
let NearInt64BE$1 = class extends Layout$3 {
  constructor(e) {
    super(8, e);
  }
  /** @override */
  decode(e, T = 0) {
    const $ = uint8ArrayToBuffer(e), V = $.readInt32BE(T), J = $.readUInt32BE(T + 4);
    return roundedInt64$2(V, J);
  }
  /** @override */
  encode(e, T, $ = 0) {
    const V = divmodInt64$2(e), J = uint8ArrayToBuffer(T);
    return J.writeInt32BE(V.hi32, $), J.writeUInt32BE(V.lo32, $ + 4), 8;
  }
};
Layout$4.NearInt64BE = NearInt64BE$1;
let Float$1 = class extends Layout$3 {
  constructor(e) {
    super(4, e);
  }
  /** @override */
  decode(e, T = 0) {
    return uint8ArrayToBuffer(e).readFloatLE(T);
  }
  /** @override */
  encode(e, T, $ = 0) {
    return uint8ArrayToBuffer(T).writeFloatLE(e, $), 4;
  }
};
Layout$4.Float = Float$1;
let FloatBE$1 = class extends Layout$3 {
  constructor(e) {
    super(4, e);
  }
  /** @override */
  decode(e, T = 0) {
    return uint8ArrayToBuffer(e).readFloatBE(T);
  }
  /** @override */
  encode(e, T, $ = 0) {
    return uint8ArrayToBuffer(T).writeFloatBE(e, $), 4;
  }
};
Layout$4.FloatBE = FloatBE$1;
let Double$1 = class extends Layout$3 {
  constructor(e) {
    super(8, e);
  }
  /** @override */
  decode(e, T = 0) {
    return uint8ArrayToBuffer(e).readDoubleLE(T);
  }
  /** @override */
  encode(e, T, $ = 0) {
    return uint8ArrayToBuffer(T).writeDoubleLE(e, $), 8;
  }
};
Layout$4.Double = Double$1;
let DoubleBE$1 = class extends Layout$3 {
  constructor(e) {
    super(8, e);
  }
  /** @override */
  decode(e, T = 0) {
    return uint8ArrayToBuffer(e).readDoubleBE(T);
  }
  /** @override */
  encode(e, T, $ = 0) {
    return uint8ArrayToBuffer(T).writeDoubleBE(e, $), 8;
  }
};
Layout$4.DoubleBE = DoubleBE$1;
let Sequence$1 = class extends Layout$3 {
  constructor(e, T, $) {
    if (!(e instanceof Layout$3))
      throw new TypeError("elementLayout must be a Layout");
    if (!(T instanceof ExternalLayout$2 && T.isCount() || Number.isInteger(T) && 0 <= T))
      throw new TypeError("count must be non-negative integer or an unsigned integer ExternalLayout");
    let V = -1;
    !(T instanceof ExternalLayout$2) && 0 < e.span && (V = T * e.span), super(V, $), this.elementLayout = e, this.count = T;
  }
  /** @override */
  getSpan(e, T = 0) {
    if (0 <= this.span)
      return this.span;
    let $ = 0, V = this.count;
    if (V instanceof ExternalLayout$2 && (V = V.decode(e, T)), 0 < this.elementLayout.span)
      $ = V * this.elementLayout.span;
    else {
      let J = 0;
      for (; J < V; )
        $ += this.elementLayout.getSpan(e, T + $), ++J;
    }
    return $;
  }
  /** @override */
  decode(e, T = 0) {
    const $ = [];
    let V = 0, J = this.count;
    for (J instanceof ExternalLayout$2 && (J = J.decode(e, T)); V < J; )
      $.push(this.elementLayout.decode(e, T)), T += this.elementLayout.getSpan(e, T), V += 1;
    return $;
  }
  /** Implement {@link Layout#encode|encode} for {@link Sequence}.
   *
   * **NOTE** If `src` is shorter than {@link Sequence#count|count} then
   * the unused space in the buffer is left unchanged.  If `src` is
   * longer than {@link Sequence#count|count} the unneeded elements are
   * ignored.
   *
   * **NOTE** If {@link Layout#count|count} is an instance of {@link
   * ExternalLayout} then the length of `src` will be encoded as the
   * count after `src` is encoded. */
  encode(e, T, $ = 0) {
    const V = this.elementLayout, J = e.reduce((ee, te) => ee + V.encode(te, T, $ + ee), 0);
    return this.count instanceof ExternalLayout$2 && this.count.encode(e.length, T, $), J;
  }
};
Layout$4.Sequence = Sequence$1;
let Structure$2 = class extends Layout$3 {
  constructor(e, T, $) {
    if (!(Array.isArray(e) && e.reduce((J, ee) => J && ee instanceof Layout$3, !0)))
      throw new TypeError("fields must be array of Layout instances");
    typeof T == "boolean" && $ === void 0 && ($ = T, T = void 0);
    for (const J of e)
      if (0 > J.span && J.property === void 0)
        throw new Error("fields cannot contain unnamed variable-length layout");
    let V = -1;
    try {
      V = e.reduce((J, ee) => J + ee.getSpan(), 0);
    } catch {
    }
    super(V, T), this.fields = e, this.decodePrefixes = !!$;
  }
  /** @override */
  getSpan(e, T = 0) {
    if (0 <= this.span)
      return this.span;
    let $ = 0;
    try {
      $ = this.fields.reduce((V, J) => {
        const ee = J.getSpan(e, T);
        return T += ee, V + ee;
      }, 0);
    } catch {
      throw new RangeError("indeterminate span");
    }
    return $;
  }
  /** @override */
  decode(e, T = 0) {
    checkUint8Array(e);
    const $ = this.makeDestinationObject();
    for (const V of this.fields)
      if (V.property !== void 0 && ($[V.property] = V.decode(e, T)), T += V.getSpan(e, T), this.decodePrefixes && e.length === T)
        break;
    return $;
  }
  /** Implement {@link Layout#encode|encode} for {@link Structure}.
   *
   * If `src` is missing a property for a member with a defined {@link
   * Layout#property|property} the corresponding region of the buffer is
   * left unmodified. */
  encode(e, T, $ = 0) {
    const V = $;
    let J = 0, ee = 0;
    for (const te of this.fields) {
      let re = te.span;
      if (ee = 0 < re ? re : 0, te.property !== void 0) {
        const ie = e[te.property];
        ie !== void 0 && (ee = te.encode(ie, T, $), 0 > re && (re = te.getSpan(T, $)));
      }
      J = $, $ += re;
    }
    return J + ee - V;
  }
  /** @override */
  fromArray(e) {
    const T = this.makeDestinationObject();
    for (const $ of this.fields)
      $.property !== void 0 && 0 < e.length && (T[$.property] = e.shift());
    return T;
  }
  /**
   * Get access to the layout of a given property.
   *
   * @param {String} property - the structure member of interest.
   *
   * @return {Layout} - the layout associated with `property`, or
   * undefined if there is no such property.
   */
  layoutFor(e) {
    if (typeof e != "string")
      throw new TypeError("property must be string");
    for (const T of this.fields)
      if (T.property === e)
        return T;
  }
  /**
   * Get the offset of a structure member.
   *
   * @param {String} property - the structure member of interest.
   *
   * @return {Number} - the offset in bytes to the start of `property`
   * within the structure, or undefined if `property` is not a field
   * within the structure.  If the property is a member but follows a
   * variable-length structure member a negative number will be
   * returned.
   */
  offsetOf(e) {
    if (typeof e != "string")
      throw new TypeError("property must be string");
    let T = 0;
    for (const $ of this.fields) {
      if ($.property === e)
        return T;
      0 > $.span ? T = -1 : 0 <= T && (T += $.span);
    }
  }
};
Layout$4.Structure = Structure$2;
let UnionDiscriminator$2 = class {
  constructor(e) {
    this.property = e;
  }
  /** Analog to {@link Layout#decode|Layout decode} for union discriminators.
   *
   * The implementation of this method need not reference the buffer if
   * variant information is available through other means. */
  decode(e, T) {
    throw new Error("UnionDiscriminator is abstract");
  }
  /** Analog to {@link Layout#decode|Layout encode} for union discriminators.
   *
   * The implementation of this method need not store the value if
   * variant information is maintained through other means. */
  encode(e, T, $) {
    throw new Error("UnionDiscriminator is abstract");
  }
};
Layout$4.UnionDiscriminator = UnionDiscriminator$2;
let UnionLayoutDiscriminator$2 = class extends UnionDiscriminator$2 {
  constructor(e, T) {
    if (!(e instanceof ExternalLayout$2 && e.isCount()))
      throw new TypeError("layout must be an unsigned integer ExternalLayout");
    super(T || e.property || "variant"), this.layout = e;
  }
  /** Delegate decoding to {@link UnionLayoutDiscriminator#layout|layout}. */
  decode(e, T) {
    return this.layout.decode(e, T);
  }
  /** Delegate encoding to {@link UnionLayoutDiscriminator#layout|layout}. */
  encode(e, T, $) {
    return this.layout.encode(e, T, $);
  }
};
Layout$4.UnionLayoutDiscriminator = UnionLayoutDiscriminator$2;
let Union$2 = class extends Layout$3 {
  constructor(e, T, $) {
    let V;
    if (e instanceof UInt$2 || e instanceof UIntBE$2)
      V = new UnionLayoutDiscriminator$2(new OffsetLayout$2(e));
    else if (e instanceof ExternalLayout$2 && e.isCount())
      V = new UnionLayoutDiscriminator$2(e);
    else if (e instanceof UnionDiscriminator$2)
      V = e;
    else
      throw new TypeError("discr must be a UnionDiscriminator or an unsigned integer layout");
    if (T === void 0 && (T = null), !(T === null || T instanceof Layout$3))
      throw new TypeError("defaultLayout must be null or a Layout");
    if (T !== null) {
      if (0 > T.span)
        throw new Error("defaultLayout must have constant span");
      T.property === void 0 && (T = T.replicate("content"));
    }
    let J = -1;
    T && (J = T.span, 0 <= J && (e instanceof UInt$2 || e instanceof UIntBE$2) && (J += V.layout.span)), super(J, $), this.discriminator = V, this.usesPrefixDiscriminator = e instanceof UInt$2 || e instanceof UIntBE$2, this.defaultLayout = T, this.registry = {};
    let ee = this.defaultGetSourceVariant.bind(this);
    this.getSourceVariant = function(te) {
      return ee(te);
    }, this.configGetSourceVariant = function(te) {
      ee = te.bind(this);
    };
  }
  /** @override */
  getSpan(e, T = 0) {
    if (0 <= this.span)
      return this.span;
    const $ = this.getVariant(e, T);
    if (!$)
      throw new Error("unable to determine span for unrecognized variant");
    return $.getSpan(e, T);
  }
  /**
   * Method to infer a registered Union variant compatible with `src`.
   *
   * The first satisfied rule in the following sequence defines the
   * return value:
   * * If `src` has properties matching the Union discriminator and
   *   the default layout, `undefined` is returned regardless of the
   *   value of the discriminator property (this ensures the default
   *   layout will be used);
   * * If `src` has a property matching the Union discriminator, the
   *   value of the discriminator identifies a registered variant, and
   *   either (a) the variant has no layout, or (b) `src` has the
   *   variant's property, then the variant is returned (because the
   *   source satisfies the constraints of the variant it identifies);
   * * If `src` does not have a property matching the Union
   *   discriminator, but does have a property matching a registered
   *   variant, then the variant is returned (because the source
   *   matches a variant without an explicit conflict);
   * * An error is thrown (because we either can't identify a variant,
   *   or we were explicitly told the variant but can't satisfy it).
   *
   * @param {Object} src - an object presumed to be compatible with
   * the content of the Union.
   *
   * @return {(undefined|VariantLayout)} - as described above.
   *
   * @throws {Error} - if `src` cannot be associated with a default or
   * registered variant.
   */
  defaultGetSourceVariant(e) {
    if (Object.prototype.hasOwnProperty.call(e, this.discriminator.property)) {
      if (this.defaultLayout && this.defaultLayout.property && Object.prototype.hasOwnProperty.call(e, this.defaultLayout.property))
        return;
      const T = this.registry[e[this.discriminator.property]];
      if (T && (!T.layout || T.property && Object.prototype.hasOwnProperty.call(e, T.property)))
        return T;
    } else
      for (const T in this.registry) {
        const $ = this.registry[T];
        if ($.property && Object.prototype.hasOwnProperty.call(e, $.property))
          return $;
      }
    throw new Error("unable to infer src variant");
  }
  /** Implement {@link Layout#decode|decode} for {@link Union}.
   *
   * If the variant is {@link Union#addVariant|registered} the return
   * value is an instance of that variant, with no explicit
   * discriminator.  Otherwise the {@link Union#defaultLayout|default
   * layout} is used to decode the content. */
  decode(e, T = 0) {
    let $;
    const V = this.discriminator, J = V.decode(e, T), ee = this.registry[J];
    if (ee === void 0) {
      const te = this.defaultLayout;
      let re = 0;
      this.usesPrefixDiscriminator && (re = V.layout.span), $ = this.makeDestinationObject(), $[V.property] = J, $[te.property] = te.decode(e, T + re);
    } else
      $ = ee.decode(e, T);
    return $;
  }
  /** Implement {@link Layout#encode|encode} for {@link Union}.
   *
   * This API assumes the `src` object is consistent with the union's
   * {@link Union#defaultLayout|default layout}.  To encode variants
   * use the appropriate variant-specific {@link VariantLayout#encode}
   * method. */
  encode(e, T, $ = 0) {
    const V = this.getSourceVariant(e);
    if (V === void 0) {
      const J = this.discriminator, ee = this.defaultLayout;
      let te = 0;
      return this.usesPrefixDiscriminator && (te = J.layout.span), J.encode(e[J.property], T, $), te + ee.encode(e[ee.property], T, $ + te);
    }
    return V.encode(e, T, $);
  }
  /** Register a new variant structure within a union.  The newly
   * created variant is returned.
   *
   * @param {Number} variant - initializer for {@link
   * VariantLayout#variant|variant}.
   *
   * @param {Layout} layout - initializer for {@link
   * VariantLayout#layout|layout}.
   *
   * @param {String} property - initializer for {@link
   * Layout#property|property}.
   *
   * @return {VariantLayout} */
  addVariant(e, T, $) {
    const V = new VariantLayout$2(this, e, T, $);
    return this.registry[e] = V, V;
  }
  /**
   * Get the layout associated with a registered variant.
   *
   * If `vb` does not produce a registered variant the function returns
   * `undefined`.
   *
   * @param {(Number|Uint8Array)} vb - either the variant number, or a
   * buffer from which the discriminator is to be read.
   *
   * @param {Number} offset - offset into `vb` for the start of the
   * union.  Used only when `vb` is an instance of {Uint8Array}.
   *
   * @return {({VariantLayout}|undefined)}
   */
  getVariant(e, T = 0) {
    let $;
    return e instanceof Uint8Array ? $ = this.discriminator.decode(e, T) : $ = e, this.registry[$];
  }
};
Layout$4.Union = Union$2;
let VariantLayout$2 = class extends Layout$3 {
  constructor(e, T, $, V) {
    if (!(e instanceof Union$2))
      throw new TypeError("union must be a Union");
    if (!Number.isInteger(T) || 0 > T)
      throw new TypeError("variant must be a (non-negative) integer");
    if (typeof $ == "string" && V === void 0 && (V = $, $ = null), $) {
      if (!($ instanceof Layout$3))
        throw new TypeError("layout must be a Layout");
      if (e.defaultLayout !== null && 0 <= $.span && $.span > e.defaultLayout.span)
        throw new Error("variant span exceeds span of containing union");
      if (typeof V != "string")
        throw new TypeError("variant must have a String property");
    }
    let J = e.span;
    0 > e.span && (J = $ ? $.span : 0, 0 <= J && e.usesPrefixDiscriminator && (J += e.discriminator.layout.span)), super(J, V), this.union = e, this.variant = T, this.layout = $ || null;
  }
  /** @override */
  getSpan(e, T = 0) {
    if (0 <= this.span)
      return this.span;
    let $ = 0;
    this.union.usesPrefixDiscriminator && ($ = this.union.discriminator.layout.span);
    let V = 0;
    return this.layout && (V = this.layout.getSpan(e, T + $)), $ + V;
  }
  /** @override */
  decode(e, T = 0) {
    const $ = this.makeDestinationObject();
    if (this !== this.union.getVariant(e, T))
      throw new Error("variant mismatch");
    let V = 0;
    return this.union.usesPrefixDiscriminator && (V = this.union.discriminator.layout.span), this.layout ? $[this.property] = this.layout.decode(e, T + V) : this.property ? $[this.property] = !0 : this.union.usesPrefixDiscriminator && ($[this.union.discriminator.property] = this.variant), $;
  }
  /** @override */
  encode(e, T, $ = 0) {
    let V = 0;
    if (this.union.usesPrefixDiscriminator && (V = this.union.discriminator.layout.span), this.layout && !Object.prototype.hasOwnProperty.call(e, this.property))
      throw new TypeError("variant lacks property " + this.property);
    this.union.discriminator.encode(this.variant, T, $);
    let J = V;
    if (this.layout && (this.layout.encode(e[this.property], T, $ + V), J += this.layout.getSpan(T, $ + V), 0 <= this.union.span && J > this.union.span))
      throw new Error("encoded variant overruns containing union");
    return J;
  }
  /** Delegate {@link Layout#fromArray|fromArray} to {@link
   * VariantLayout#layout|layout}. */
  fromArray(e) {
    if (this.layout)
      return this.layout.fromArray(e);
  }
};
Layout$4.VariantLayout = VariantLayout$2;
function fixBitwiseResult$1(C) {
  return 0 > C && (C += 4294967296), C;
}
let BitStructure$1 = class extends Layout$3 {
  constructor(e, T, $) {
    if (!(e instanceof UInt$2 || e instanceof UIntBE$2))
      throw new TypeError("word must be a UInt or UIntBE layout");
    if (typeof T == "string" && $ === void 0 && ($ = T, T = !1), 4 < e.span)
      throw new RangeError("word cannot exceed 32 bits");
    super(e.span, $), this.word = e, this.msb = !!T, this.fields = [];
    let V = 0;
    this._packedSetValue = function(J) {
      return V = fixBitwiseResult$1(J), this;
    }, this._packedGetValue = function() {
      return V;
    };
  }
  /** @override */
  decode(e, T = 0) {
    const $ = this.makeDestinationObject(), V = this.word.decode(e, T);
    this._packedSetValue(V);
    for (const J of this.fields)
      J.property !== void 0 && ($[J.property] = J.decode(e));
    return $;
  }
  /** Implement {@link Layout#encode|encode} for {@link BitStructure}.
   *
   * If `src` is missing a property for a member with a defined {@link
   * Layout#property|property} the corresponding region of the packed
   * value is left unmodified.  Unused bits are also left unmodified. */
  encode(e, T, $ = 0) {
    const V = this.word.decode(T, $);
    this._packedSetValue(V);
    for (const J of this.fields)
      if (J.property !== void 0) {
        const ee = e[J.property];
        ee !== void 0 && J.encode(ee);
      }
    return this.word.encode(this._packedGetValue(), T, $);
  }
  /** Register a new bitfield with a containing bit structure.  The
   * resulting bitfield is returned.
   *
   * @param {Number} bits - initializer for {@link BitField#bits|bits}.
   *
   * @param {string} property - initializer for {@link
   * Layout#property|property}.
   *
   * @return {BitField} */
  addField(e, T) {
    const $ = new BitField$1(this, e, T);
    return this.fields.push($), $;
  }
  /** As with {@link BitStructure#addField|addField} for single-bit
   * fields with `boolean` value representation.
   *
   * @param {string} property - initializer for {@link
   * Layout#property|property}.
   *
   * @return {Boolean} */
  // `Boolean` conflicts with the native primitive type
  // eslint-disable-next-line @typescript-eslint/ban-types
  addBoolean(e) {
    const T = new Boolean$2(this, e);
    return this.fields.push(T), T;
  }
  /**
   * Get access to the bit field for a given property.
   *
   * @param {String} property - the bit field of interest.
   *
   * @return {BitField} - the field associated with `property`, or
   * undefined if there is no such property.
   */
  fieldFor(e) {
    if (typeof e != "string")
      throw new TypeError("property must be string");
    for (const T of this.fields)
      if (T.property === e)
        return T;
  }
};
Layout$4.BitStructure = BitStructure$1;
let BitField$1 = class {
  constructor(e, T, $) {
    if (!(e instanceof BitStructure$1))
      throw new TypeError("container must be a BitStructure");
    if (!Number.isInteger(T) || 0 >= T)
      throw new TypeError("bits must be positive integer");
    const V = 8 * e.span, J = e.fields.reduce((ee, te) => ee + te.bits, 0);
    if (T + J > V)
      throw new Error("bits too long for span remainder (" + (V - J) + " of " + V + " remain)");
    this.container = e, this.bits = T, this.valueMask = (1 << T) - 1, T === 32 && (this.valueMask = 4294967295), this.start = J, this.container.msb && (this.start = V - J - T), this.wordMask = fixBitwiseResult$1(this.valueMask << this.start), this.property = $;
  }
  /** Store a value into the corresponding subsequence of the containing
   * bit field. */
  decode(e, T) {
    const $ = this.container._packedGetValue();
    return fixBitwiseResult$1($ & this.wordMask) >>> this.start;
  }
  /** Store a value into the corresponding subsequence of the containing
   * bit field.
   *
   * **NOTE** This is not a specialization of {@link
   * Layout#encode|Layout.encode} and there is no return value. */
  encode(e) {
    if (typeof e != "number" || !Number.isInteger(e) || e !== fixBitwiseResult$1(e & this.valueMask))
      throw new TypeError(nameWithProperty$2("BitField.encode", this) + " value must be integer not exceeding " + this.valueMask);
    const T = this.container._packedGetValue(), $ = fixBitwiseResult$1(e << this.start);
    this.container._packedSetValue(fixBitwiseResult$1(T & ~this.wordMask) | $);
  }
};
Layout$4.BitField = BitField$1;
let Boolean$2 = class extends BitField$1 {
  constructor(e, T) {
    super(e, 1, T);
  }
  /** Override {@link BitField#decode|decode} for {@link Boolean|Boolean}.
   *
   * @returns {boolean} */
  decode(e, T) {
    return !!super.decode(e, T);
  }
  /** @override */
  encode(e) {
    typeof e == "boolean" && (e = +e), super.encode(e);
  }
};
Layout$4.Boolean = Boolean$2;
let Blob$3 = class extends Layout$3 {
  constructor(e, T) {
    if (!(e instanceof ExternalLayout$2 && e.isCount() || Number.isInteger(e) && 0 <= e))
      throw new TypeError("length must be positive integer or an unsigned integer ExternalLayout");
    let $ = -1;
    e instanceof ExternalLayout$2 || ($ = e), super($, T), this.length = e;
  }
  /** @override */
  getSpan(e, T) {
    let $ = this.span;
    return 0 > $ && ($ = this.length.decode(e, T)), $;
  }
  /** @override */
  decode(e, T = 0) {
    let $ = this.span;
    return 0 > $ && ($ = this.length.decode(e, T)), uint8ArrayToBuffer(e).slice(T, T + $);
  }
  /** Implement {@link Layout#encode|encode} for {@link Blob}.
   *
   * **NOTE** If {@link Layout#count|count} is an instance of {@link
   * ExternalLayout} then the length of `src` will be encoded as the
   * count after `src` is encoded. */
  encode(e, T, $) {
    let V = this.length;
    if (this.length instanceof ExternalLayout$2 && (V = e.length), !(e instanceof Uint8Array && V === e.length))
      throw new TypeError(nameWithProperty$2("Blob.encode", this) + " requires (length " + V + ") Uint8Array as src");
    if ($ + V > T.length)
      throw new RangeError("encoding overruns Uint8Array");
    const J = uint8ArrayToBuffer(e);
    return uint8ArrayToBuffer(T).write(J.toString("hex"), $, V, "hex"), this.length instanceof ExternalLayout$2 && this.length.encode(V, T, $), V;
  }
};
Layout$4.Blob = Blob$3;
let CString$1 = class extends Layout$3 {
  constructor(e) {
    super(-1, e);
  }
  /** @override */
  getSpan(e, T = 0) {
    checkUint8Array(e);
    let $ = T;
    for (; $ < e.length && e[$] !== 0; )
      $ += 1;
    return 1 + $ - T;
  }
  /** @override */
  decode(e, T = 0) {
    const $ = this.getSpan(e, T);
    return uint8ArrayToBuffer(e).slice(T, T + $ - 1).toString("utf-8");
  }
  /** @override */
  encode(e, T, $ = 0) {
    typeof e != "string" && (e = String(e));
    const V = buffer_1.Buffer.from(e, "utf8"), J = V.length;
    if ($ + J > T.length)
      throw new RangeError("encoding overruns Buffer");
    const ee = uint8ArrayToBuffer(T);
    return V.copy(ee, $), ee[$ + J] = 0, J + 1;
  }
};
Layout$4.CString = CString$1;
let UTF8$1 = class extends Layout$3 {
  constructor(e, T) {
    if (typeof e == "string" && T === void 0 && (T = e, e = void 0), e === void 0)
      e = -1;
    else if (!Number.isInteger(e))
      throw new TypeError("maxSpan must be an integer");
    super(-1, T), this.maxSpan = e;
  }
  /** @override */
  getSpan(e, T = 0) {
    return checkUint8Array(e), e.length - T;
  }
  /** @override */
  decode(e, T = 0) {
    const $ = this.getSpan(e, T);
    if (0 <= this.maxSpan && this.maxSpan < $)
      throw new RangeError("text length exceeds maxSpan");
    return uint8ArrayToBuffer(e).slice(T, T + $).toString("utf-8");
  }
  /** @override */
  encode(e, T, $ = 0) {
    typeof e != "string" && (e = String(e));
    const V = buffer_1.Buffer.from(e, "utf8"), J = V.length;
    if (0 <= this.maxSpan && this.maxSpan < J)
      throw new RangeError("text length exceeds maxSpan");
    if ($ + J > T.length)
      throw new RangeError("encoding overruns Buffer");
    return V.copy(uint8ArrayToBuffer(T), $), J;
  }
};
Layout$4.UTF8 = UTF8$1;
let Constant$1 = class extends Layout$3 {
  constructor(e, T) {
    super(0, T), this.value = e;
  }
  /** @override */
  decode(e, T) {
    return this.value;
  }
  /** @override */
  encode(e, T, $) {
    return 0;
  }
};
Layout$4.Constant = Constant$1;
var greedy = Layout$4.greedy = (C, e) => new GreedyCount$1(C, e), offset$3 = Layout$4.offset = (C, e, T) => new OffsetLayout$2(C, e, T), u8$1 = Layout$4.u8 = (C) => new UInt$2(1, C), u16 = Layout$4.u16 = (C) => new UInt$2(2, C);
Layout$4.u24 = (C) => new UInt$2(3, C);
var u32$1 = Layout$4.u32 = (C) => new UInt$2(4, C);
Layout$4.u40 = (C) => new UInt$2(5, C);
Layout$4.u48 = (C) => new UInt$2(6, C);
var nu64$1 = Layout$4.nu64 = (C) => new NearUInt64$2(C);
Layout$4.u16be = (C) => new UIntBE$2(2, C);
Layout$4.u24be = (C) => new UIntBE$2(3, C);
Layout$4.u32be = (C) => new UIntBE$2(4, C);
Layout$4.u40be = (C) => new UIntBE$2(5, C);
Layout$4.u48be = (C) => new UIntBE$2(6, C);
Layout$4.nu64be = (C) => new NearUInt64BE$1(C);
Layout$4.s8 = (C) => new Int$1(1, C);
s16 = Layout$4.s16 = (C) => new Int$1(2, C);
Layout$4.s24 = (C) => new Int$1(3, C);
Layout$4.s32 = (C) => new Int$1(4, C);
Layout$4.s40 = (C) => new Int$1(5, C);
Layout$4.s48 = (C) => new Int$1(6, C);
var ns64$1 = Layout$4.ns64 = (C) => new NearInt64$2(C);
Layout$4.s16be = (C) => new IntBE$1(2, C);
Layout$4.s24be = (C) => new IntBE$1(3, C);
Layout$4.s32be = (C) => new IntBE$1(4, C);
Layout$4.s40be = (C) => new IntBE$1(5, C);
Layout$4.s48be = (C) => new IntBE$1(6, C);
Layout$4.ns64be = (C) => new NearInt64BE$1(C);
Layout$4.f32 = (C) => new Float$1(C);
Layout$4.f32be = (C) => new FloatBE$1(C);
Layout$4.f64 = (C) => new Double$1(C);
Layout$4.f64be = (C) => new DoubleBE$1(C);
var struct$1 = Layout$4.struct = (C, e, T) => new Structure$2(C, e, T);
Layout$4.bits = (C, e, T) => new BitStructure$1(C, e, T);
var seq = Layout$4.seq = (C, e, T) => new Sequence$1(C, e, T);
Layout$4.union = (C, e, T) => new Union$2(C, e, T);
Layout$4.unionLayoutDiscriminator = (C, e) => new UnionLayoutDiscriminator$2(C, e);
var blob$1 = Layout$4.blob = (C, e) => new Blob$3(C, e);
Layout$4.cstr = (C) => new CString$1(C);
Layout$4.utf8 = (C, e) => new UTF8$1(C, e);
Layout$4.constant = (C, e) => new Constant$1(C, e);
var browser$1 = {};
Object.defineProperty(browser$1, "__esModule", { value: !0 });
function toBigIntLE(C) {
  {
    const e = dist$2.Buffer.from(C);
    e.reverse();
    const T = e.toString("hex");
    return T.length === 0 ? BigInt(0) : BigInt(`0x${T}`);
  }
}
var toBigIntLE_1 = browser$1.toBigIntLE = toBigIntLE;
function toBigIntBE(C) {
  {
    const e = C.toString("hex");
    return e.length === 0 ? BigInt(0) : BigInt(`0x${e}`);
  }
}
browser$1.toBigIntBE = toBigIntBE;
function toBufferLE(C, e) {
  {
    const T = C.toString(16), $ = dist$2.Buffer.from(T.padStart(e * 2, "0").slice(0, e * 2), "hex");
    return $.reverse(), $;
  }
}
var toBufferLE_1 = browser$1.toBufferLE = toBufferLE;
function toBufferBE(C, e) {
  {
    const T = C.toString(16);
    return dist$2.Buffer.from(T.padStart(e * 2, "0").slice(0, e * 2), "hex");
  }
}
browser$1.toBufferBE = toBufferBE;
let StructError$2 = class extends TypeError {
  constructor(e, T) {
    let $;
    const { message: V, explanation: J, ...ee } = e, { path: te } = e, re = te.length === 0 ? V : `At path: ${te.join(".")} -- ${V}`;
    super(J ?? re), J != null && (this.cause = re), Object.assign(this, ee), this.name = this.constructor.name, this.failures = () => $ ?? ($ = [e, ...T()]);
  }
};
function isIterable$2(C) {
  return isObject$2(C) && typeof C[Symbol.iterator] == "function";
}
function isObject$2(C) {
  return typeof C == "object" && C != null;
}
function isNonArrayObject(C) {
  return isObject$2(C) && !Array.isArray(C);
}
function print$2(C) {
  return typeof C == "symbol" ? C.toString() : typeof C == "string" ? JSON.stringify(C) : `${C}`;
}
function shiftIterator$2(C) {
  const { done: e, value: T } = C.next();
  return e ? void 0 : T;
}
function toFailure$2(C, e, T, $) {
  if (C === !0)
    return;
  C === !1 ? C = {} : typeof C == "string" && (C = { message: C });
  const { path: V, branch: J } = e, { type: ee } = T, { refinement: te, message: re = `Expected a value of type \`${ee}\`${te ? ` with refinement \`${te}\`` : ""}, but received: \`${print$2($)}\`` } = C;
  return {
    value: $,
    type: ee,
    refinement: te,
    key: V[V.length - 1],
    path: V,
    branch: J,
    ...C,
    message: re
  };
}
function* toFailures$2(C, e, T, $) {
  isIterable$2(C) || (C = [C]);
  for (const V of C) {
    const J = toFailure$2(V, e, T, $);
    J && (yield J);
  }
}
function* run$2(C, e, T = {}) {
  const { path: $ = [], branch: V = [C], coerce: J = !1, mask: ee = !1 } = T, te = { path: $, branch: V, mask: ee };
  J && (C = e.coercer(C, te));
  let re = "valid";
  for (const ie of e.validator(C, te))
    ie.explanation = T.message, re = "not_valid", yield [ie, void 0];
  for (let [ie, se, de] of e.entries(C, te)) {
    const ue = run$2(se, de, {
      path: ie === void 0 ? $ : [...$, ie],
      branch: ie === void 0 ? V : [...V, se],
      coerce: J,
      mask: ee,
      message: T.message
    });
    for (const fe of ue)
      fe[0] ? (re = fe[0].refinement != null ? "not_refined" : "not_valid", yield [fe[0], void 0]) : J && (se = fe[1], ie === void 0 ? C = se : C instanceof Map ? C.set(ie, se) : C instanceof Set ? C.add(se) : isObject$2(C) && (se !== void 0 || ie in C) && (C[ie] = se));
  }
  if (re !== "not_valid")
    for (const ie of e.refiner(C, te))
      ie.explanation = T.message, re = "not_refined", yield [ie, void 0];
  re === "valid" && (yield [void 0, C]);
}
let Struct$3 = class {
  constructor(e) {
    const { type: T, schema: $, validator: V, refiner: J, coercer: ee = (re) => re, entries: te = function* () {
    } } = e;
    this.type = T, this.schema = $, this.entries = te, this.coercer = ee, V ? this.validator = (re, ie) => {
      const se = V(re, ie);
      return toFailures$2(se, ie, this, re);
    } : this.validator = () => [], J ? this.refiner = (re, ie) => {
      const se = J(re, ie);
      return toFailures$2(se, ie, this, re);
    } : this.refiner = () => [];
  }
  /**
   * Assert that a value passes the struct's validation, throwing if it doesn't.
   */
  assert(e, T) {
    return assert$4(e, this, T);
  }
  /**
   * Create a value with the struct's coercion logic, then validate it.
   */
  create(e, T) {
    return create$3(e, this, T);
  }
  /**
   * Check if a value passes the struct's validation.
   */
  is(e) {
    return is$2(e, this);
  }
  /**
   * Mask a value, coercing and validating it, but returning only the subset of
   * properties defined by the struct's schema. Masking applies recursively to
   * props of `object` structs only.
   */
  mask(e, T) {
    return mask$2(e, this, T);
  }
  /**
   * Validate a value with the struct's validation logic, returning a tuple
   * representing the result.
   *
   * You may optionally pass `true` for the `coerce` argument to coerce
   * the value before attempting to validate it. If you do, the result will
   * contain the coerced result when successful. Also, `mask` will turn on
   * masking of the unknown `object` props recursively if passed.
   */
  validate(e, T = {}) {
    return validate$4(e, this, T);
  }
};
function assert$4(C, e, T) {
  const $ = validate$4(C, e, { message: T });
  if ($[0])
    throw $[0];
}
function create$3(C, e, T) {
  const $ = validate$4(C, e, { coerce: !0, message: T });
  if ($[0])
    throw $[0];
  return $[1];
}
function mask$2(C, e, T) {
  const $ = validate$4(C, e, { coerce: !0, mask: !0, message: T });
  if ($[0])
    throw $[0];
  return $[1];
}
function is$2(C, e) {
  return !validate$4(C, e)[0];
}
function validate$4(C, e, T = {}) {
  const $ = run$2(C, e, T), V = shiftIterator$2($);
  return V[0] ? [new StructError$2(V[0], function* () {
    for (const ee of $)
      ee[0] && (yield ee[0]);
  }), void 0] : [void 0, V[1]];
}
function define$2(C, e) {
  return new Struct$3({ type: C, schema: null, validator: e });
}
function any$2() {
  return define$2("any", () => !0);
}
function array$2(C) {
  return new Struct$3({
    type: "array",
    schema: C,
    *entries(e) {
      if (C && Array.isArray(e))
        for (const [T, $] of e.entries())
          yield [T, $, C];
    },
    coercer(e) {
      return Array.isArray(e) ? e.slice() : e;
    },
    validator(e) {
      return Array.isArray(e) || `Expected an array value, but received: ${print$2(e)}`;
    }
  });
}
function boolean$2() {
  return define$2("boolean", (C) => typeof C == "boolean");
}
function instance(C) {
  return define$2("instance", (e) => e instanceof C || `Expected a \`${C.name}\` instance, but received: ${print$2(e)}`);
}
function literal$2(C) {
  const e = print$2(C), T = typeof C;
  return new Struct$3({
    type: "literal",
    schema: T === "string" || T === "number" || T === "boolean" ? C : null,
    validator($) {
      return $ === C || `Expected the literal \`${e}\`, but received: ${print$2($)}`;
    }
  });
}
function never$1() {
  return define$2("never", () => !1);
}
function nullable$2(C) {
  return new Struct$3({
    ...C,
    validator: (e, T) => e === null || C.validator(e, T),
    refiner: (e, T) => e === null || C.refiner(e, T)
  });
}
function number$2() {
  return define$2("number", (C) => typeof C == "number" && !isNaN(C) || `Expected a number, but received: ${print$2(C)}`);
}
function optional$2(C) {
  return new Struct$3({
    ...C,
    validator: (e, T) => e === void 0 || C.validator(e, T),
    refiner: (e, T) => e === void 0 || C.refiner(e, T)
  });
}
function record$1(C, e) {
  return new Struct$3({
    type: "record",
    schema: null,
    *entries(T) {
      if (isObject$2(T))
        for (const $ in T) {
          const V = T[$];
          yield [$, $, C], yield [$, V, e];
        }
    },
    validator(T) {
      return isNonArrayObject(T) || `Expected an object, but received: ${print$2(T)}`;
    },
    coercer(T) {
      return isNonArrayObject(T) ? { ...T } : T;
    }
  });
}
function string$2() {
  return define$2("string", (C) => typeof C == "string" || `Expected a string, but received: ${print$2(C)}`);
}
function tuple$1(C) {
  const e = never$1();
  return new Struct$3({
    type: "tuple",
    schema: null,
    *entries(T) {
      if (Array.isArray(T)) {
        const $ = Math.max(C.length, T.length);
        for (let V = 0; V < $; V++)
          yield [V, T[V], C[V] || e];
      }
    },
    validator(T) {
      return Array.isArray(T) || `Expected an array, but received: ${print$2(T)}`;
    },
    coercer(T) {
      return Array.isArray(T) ? T.slice() : T;
    }
  });
}
function type$2(C) {
  const e = Object.keys(C);
  return new Struct$3({
    type: "type",
    schema: C,
    *entries(T) {
      if (isObject$2(T))
        for (const $ of e)
          yield [$, T[$], C[$]];
    },
    validator(T) {
      return isNonArrayObject(T) || `Expected an object, but received: ${print$2(T)}`;
    },
    coercer(T) {
      return isNonArrayObject(T) ? { ...T } : T;
    }
  });
}
function union$3(C) {
  const e = C.map((T) => T.type).join(" | ");
  return new Struct$3({
    type: "union",
    schema: null,
    coercer(T, $) {
      for (const V of C) {
        const [J, ee] = V.validate(T, {
          coerce: !0,
          mask: $.mask
        });
        if (!J)
          return ee;
      }
      return T;
    },
    validator(T, $) {
      const V = [];
      for (const J of C) {
        const [...ee] = run$2(T, J, $), [te] = ee;
        if (te[0])
          for (const [re] of ee)
            re && V.push(re);
        else
          return [];
      }
      return [
        `Expected the value to satisfy a union of \`${e}\`, but received: ${print$2(T)}`,
        ...V
      ];
    }
  });
}
function unknown$1() {
  return define$2("unknown", () => !0);
}
function coerce$1(C, e, T) {
  return new Struct$3({
    ...C,
    coercer: ($, V) => is$2($, e) ? C.coercer(T($, V), V) : C.coercer($, V)
  });
}
var getRandomValues, rnds8 = new Uint8Array(16);
function rng() {
  if (!getRandomValues && (getRandomValues = typeof crypto < "u" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto < "u" && typeof msCrypto.getRandomValues == "function" && msCrypto.getRandomValues.bind(msCrypto), !getRandomValues))
    throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
  return getRandomValues(rnds8);
}
const REGEX = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;
function validate$3(C) {
  return typeof C == "string" && REGEX.test(C);
}
var byteToHex = [];
for (var i$1 = 0; i$1 < 256; ++i$1)
  byteToHex.push((i$1 + 256).toString(16).substr(1));
function stringify(C) {
  var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, T = (byteToHex[C[e + 0]] + byteToHex[C[e + 1]] + byteToHex[C[e + 2]] + byteToHex[C[e + 3]] + "-" + byteToHex[C[e + 4]] + byteToHex[C[e + 5]] + "-" + byteToHex[C[e + 6]] + byteToHex[C[e + 7]] + "-" + byteToHex[C[e + 8]] + byteToHex[C[e + 9]] + "-" + byteToHex[C[e + 10]] + byteToHex[C[e + 11]] + byteToHex[C[e + 12]] + byteToHex[C[e + 13]] + byteToHex[C[e + 14]] + byteToHex[C[e + 15]]).toLowerCase();
  if (!validate$3(T))
    throw TypeError("Stringified UUID is invalid");
  return T;
}
var _nodeId, _clockseq, _lastMSecs = 0, _lastNSecs = 0;
function v1(C, e, T) {
  var $ = e && T || 0, V = e || new Array(16);
  C = C || {};
  var J = C.node || _nodeId, ee = C.clockseq !== void 0 ? C.clockseq : _clockseq;
  if (J == null || ee == null) {
    var te = C.random || (C.rng || rng)();
    J == null && (J = _nodeId = [te[0] | 1, te[1], te[2], te[3], te[4], te[5]]), ee == null && (ee = _clockseq = (te[6] << 8 | te[7]) & 16383);
  }
  var re = C.msecs !== void 0 ? C.msecs : Date.now(), ie = C.nsecs !== void 0 ? C.nsecs : _lastNSecs + 1, se = re - _lastMSecs + (ie - _lastNSecs) / 1e4;
  if (se < 0 && C.clockseq === void 0 && (ee = ee + 1 & 16383), (se < 0 || re > _lastMSecs) && C.nsecs === void 0 && (ie = 0), ie >= 1e4)
    throw new Error("uuid.v1(): Can't create more than 10M uuids/sec");
  _lastMSecs = re, _lastNSecs = ie, _clockseq = ee, re += 122192928e5;
  var de = ((re & 268435455) * 1e4 + ie) % 4294967296;
  V[$++] = de >>> 24 & 255, V[$++] = de >>> 16 & 255, V[$++] = de >>> 8 & 255, V[$++] = de & 255;
  var ue = re / 4294967296 * 1e4 & 268435455;
  V[$++] = ue >>> 8 & 255, V[$++] = ue & 255, V[$++] = ue >>> 24 & 15 | 16, V[$++] = ue >>> 16 & 255, V[$++] = ee >>> 8 | 128, V[$++] = ee & 255;
  for (var fe = 0; fe < 6; ++fe)
    V[$ + fe] = J[fe];
  return e || stringify(V);
}
function parse$1(C) {
  if (!validate$3(C))
    throw TypeError("Invalid UUID");
  var e, T = new Uint8Array(16);
  return T[0] = (e = parseInt(C.slice(0, 8), 16)) >>> 24, T[1] = e >>> 16 & 255, T[2] = e >>> 8 & 255, T[3] = e & 255, T[4] = (e = parseInt(C.slice(9, 13), 16)) >>> 8, T[5] = e & 255, T[6] = (e = parseInt(C.slice(14, 18), 16)) >>> 8, T[7] = e & 255, T[8] = (e = parseInt(C.slice(19, 23), 16)) >>> 8, T[9] = e & 255, T[10] = (e = parseInt(C.slice(24, 36), 16)) / 1099511627776 & 255, T[11] = e / 4294967296 & 255, T[12] = e >>> 24 & 255, T[13] = e >>> 16 & 255, T[14] = e >>> 8 & 255, T[15] = e & 255, T;
}
function stringToBytes(C) {
  C = unescape(encodeURIComponent(C));
  for (var e = [], T = 0; T < C.length; ++T)
    e.push(C.charCodeAt(T));
  return e;
}
var DNS = "6ba7b810-9dad-11d1-80b4-00c04fd430c8", URL$1 = "6ba7b811-9dad-11d1-80b4-00c04fd430c8";
function v35(C, e, T) {
  function $(V, J, ee, te) {
    if (typeof V == "string" && (V = stringToBytes(V)), typeof J == "string" && (J = parse$1(J)), J.length !== 16)
      throw TypeError("Namespace must be array-like (16 iterable integer values, 0-255)");
    var re = new Uint8Array(16 + V.length);
    if (re.set(J), re.set(V, J.length), re = T(re), re[6] = re[6] & 15 | e, re[8] = re[8] & 63 | 128, ee) {
      te = te || 0;
      for (var ie = 0; ie < 16; ++ie)
        ee[te + ie] = re[ie];
      return ee;
    }
    return stringify(re);
  }
  try {
    $.name = C;
  } catch {
  }
  return $.DNS = DNS, $.URL = URL$1, $;
}
function md5(C) {
  if (typeof C == "string") {
    var e = unescape(encodeURIComponent(C));
    C = new Uint8Array(e.length);
    for (var T = 0; T < e.length; ++T)
      C[T] = e.charCodeAt(T);
  }
  return md5ToHexEncodedArray(wordsToMd5(bytesToWords(C), C.length * 8));
}
function md5ToHexEncodedArray(C) {
  for (var e = [], T = C.length * 32, $ = "0123456789abcdef", V = 0; V < T; V += 8) {
    var J = C[V >> 5] >>> V % 32 & 255, ee = parseInt($.charAt(J >>> 4 & 15) + $.charAt(J & 15), 16);
    e.push(ee);
  }
  return e;
}
function getOutputLength(C) {
  return (C + 64 >>> 9 << 4) + 14 + 1;
}
function wordsToMd5(C, e) {
  C[e >> 5] |= 128 << e % 32, C[getOutputLength(e) - 1] = e;
  for (var T = 1732584193, $ = -271733879, V = -1732584194, J = 271733878, ee = 0; ee < C.length; ee += 16) {
    var te = T, re = $, ie = V, se = J;
    T = md5ff(T, $, V, J, C[ee], 7, -680876936), J = md5ff(J, T, $, V, C[ee + 1], 12, -389564586), V = md5ff(V, J, T, $, C[ee + 2], 17, 606105819), $ = md5ff($, V, J, T, C[ee + 3], 22, -1044525330), T = md5ff(T, $, V, J, C[ee + 4], 7, -176418897), J = md5ff(J, T, $, V, C[ee + 5], 12, 1200080426), V = md5ff(V, J, T, $, C[ee + 6], 17, -1473231341), $ = md5ff($, V, J, T, C[ee + 7], 22, -45705983), T = md5ff(T, $, V, J, C[ee + 8], 7, 1770035416), J = md5ff(J, T, $, V, C[ee + 9], 12, -1958414417), V = md5ff(V, J, T, $, C[ee + 10], 17, -42063), $ = md5ff($, V, J, T, C[ee + 11], 22, -1990404162), T = md5ff(T, $, V, J, C[ee + 12], 7, 1804603682), J = md5ff(J, T, $, V, C[ee + 13], 12, -40341101), V = md5ff(V, J, T, $, C[ee + 14], 17, -1502002290), $ = md5ff($, V, J, T, C[ee + 15], 22, 1236535329), T = md5gg(T, $, V, J, C[ee + 1], 5, -165796510), J = md5gg(J, T, $, V, C[ee + 6], 9, -1069501632), V = md5gg(V, J, T, $, C[ee + 11], 14, 643717713), $ = md5gg($, V, J, T, C[ee], 20, -373897302), T = md5gg(T, $, V, J, C[ee + 5], 5, -701558691), J = md5gg(J, T, $, V, C[ee + 10], 9, 38016083), V = md5gg(V, J, T, $, C[ee + 15], 14, -660478335), $ = md5gg($, V, J, T, C[ee + 4], 20, -405537848), T = md5gg(T, $, V, J, C[ee + 9], 5, 568446438), J = md5gg(J, T, $, V, C[ee + 14], 9, -1019803690), V = md5gg(V, J, T, $, C[ee + 3], 14, -187363961), $ = md5gg($, V, J, T, C[ee + 8], 20, 1163531501), T = md5gg(T, $, V, J, C[ee + 13], 5, -1444681467), J = md5gg(J, T, $, V, C[ee + 2], 9, -51403784), V = md5gg(V, J, T, $, C[ee + 7], 14, 1735328473), $ = md5gg($, V, J, T, C[ee + 12], 20, -1926607734), T = md5hh(T, $, V, J, C[ee + 5], 4, -378558), J = md5hh(J, T, $, V, C[ee + 8], 11, -2022574463), V = md5hh(V, J, T, $, C[ee + 11], 16, 1839030562), $ = md5hh($, V, J, T, C[ee + 14], 23, -35309556), T = md5hh(T, $, V, J, C[ee + 1], 4, -1530992060), J = md5hh(J, T, $, V, C[ee + 4], 11, 1272893353), V = md5hh(V, J, T, $, C[ee + 7], 16, -155497632), $ = md5hh($, V, J, T, C[ee + 10], 23, -1094730640), T = md5hh(T, $, V, J, C[ee + 13], 4, 681279174), J = md5hh(J, T, $, V, C[ee], 11, -358537222), V = md5hh(V, J, T, $, C[ee + 3], 16, -722521979), $ = md5hh($, V, J, T, C[ee + 6], 23, 76029189), T = md5hh(T, $, V, J, C[ee + 9], 4, -640364487), J = md5hh(J, T, $, V, C[ee + 12], 11, -421815835), V = md5hh(V, J, T, $, C[ee + 15], 16, 530742520), $ = md5hh($, V, J, T, C[ee + 2], 23, -995338651), T = md5ii(T, $, V, J, C[ee], 6, -198630844), J = md5ii(J, T, $, V, C[ee + 7], 10, 1126891415), V = md5ii(V, J, T, $, C[ee + 14], 15, -1416354905), $ = md5ii($, V, J, T, C[ee + 5], 21, -57434055), T = md5ii(T, $, V, J, C[ee + 12], 6, 1700485571), J = md5ii(J, T, $, V, C[ee + 3], 10, -1894986606), V = md5ii(V, J, T, $, C[ee + 10], 15, -1051523), $ = md5ii($, V, J, T, C[ee + 1], 21, -2054922799), T = md5ii(T, $, V, J, C[ee + 8], 6, 1873313359), J = md5ii(J, T, $, V, C[ee + 15], 10, -30611744), V = md5ii(V, J, T, $, C[ee + 6], 15, -1560198380), $ = md5ii($, V, J, T, C[ee + 13], 21, 1309151649), T = md5ii(T, $, V, J, C[ee + 4], 6, -145523070), J = md5ii(J, T, $, V, C[ee + 11], 10, -1120210379), V = md5ii(V, J, T, $, C[ee + 2], 15, 718787259), $ = md5ii($, V, J, T, C[ee + 9], 21, -343485551), T = safeAdd(T, te), $ = safeAdd($, re), V = safeAdd(V, ie), J = safeAdd(J, se);
  }
  return [T, $, V, J];
}
function bytesToWords(C) {
  if (C.length === 0)
    return [];
  for (var e = C.length * 8, T = new Uint32Array(getOutputLength(e)), $ = 0; $ < e; $ += 8)
    T[$ >> 5] |= (C[$ / 8] & 255) << $ % 32;
  return T;
}
function safeAdd(C, e) {
  var T = (C & 65535) + (e & 65535), $ = (C >> 16) + (e >> 16) + (T >> 16);
  return $ << 16 | T & 65535;
}
function bitRotateLeft(C, e) {
  return C << e | C >>> 32 - e;
}
function md5cmn(C, e, T, $, V, J) {
  return safeAdd(bitRotateLeft(safeAdd(safeAdd(e, C), safeAdd($, J)), V), T);
}
function md5ff(C, e, T, $, V, J, ee) {
  return md5cmn(e & T | ~e & $, C, e, V, J, ee);
}
function md5gg(C, e, T, $, V, J, ee) {
  return md5cmn(e & $ | T & ~$, C, e, V, J, ee);
}
function md5hh(C, e, T, $, V, J, ee) {
  return md5cmn(e ^ T ^ $, C, e, V, J, ee);
}
function md5ii(C, e, T, $, V, J, ee) {
  return md5cmn(T ^ (e | ~$), C, e, V, J, ee);
}
var v3 = v35("v3", 48, md5);
function v4(C, e, T) {
  C = C || {};
  var $ = C.random || (C.rng || rng)();
  if ($[6] = $[6] & 15 | 64, $[8] = $[8] & 63 | 128, e) {
    T = T || 0;
    for (var V = 0; V < 16; ++V)
      e[T + V] = $[V];
    return e;
  }
  return stringify($);
}
function f(C, e, T, $) {
  switch (C) {
    case 0:
      return e & T ^ ~e & $;
    case 1:
      return e ^ T ^ $;
    case 2:
      return e & T ^ e & $ ^ T & $;
    case 3:
      return e ^ T ^ $;
  }
}
function ROTL(C, e) {
  return C << e | C >>> 32 - e;
}
function sha1(C) {
  var e = [1518500249, 1859775393, 2400959708, 3395469782], T = [1732584193, 4023233417, 2562383102, 271733878, 3285377520];
  if (typeof C == "string") {
    var $ = unescape(encodeURIComponent(C));
    C = [];
    for (var V = 0; V < $.length; ++V)
      C.push($.charCodeAt(V));
  } else Array.isArray(C) || (C = Array.prototype.slice.call(C));
  C.push(128);
  for (var J = C.length / 4 + 2, ee = Math.ceil(J / 16), te = new Array(ee), re = 0; re < ee; ++re) {
    for (var ie = new Uint32Array(16), se = 0; se < 16; ++se)
      ie[se] = C[re * 64 + se * 4] << 24 | C[re * 64 + se * 4 + 1] << 16 | C[re * 64 + se * 4 + 2] << 8 | C[re * 64 + se * 4 + 3];
    te[re] = ie;
  }
  te[ee - 1][14] = (C.length - 1) * 8 / Math.pow(2, 32), te[ee - 1][14] = Math.floor(te[ee - 1][14]), te[ee - 1][15] = (C.length - 1) * 8 & 4294967295;
  for (var de = 0; de < ee; ++de) {
    for (var ue = new Uint32Array(80), fe = 0; fe < 16; ++fe)
      ue[fe] = te[de][fe];
    for (var he = 16; he < 80; ++he)
      ue[he] = ROTL(ue[he - 3] ^ ue[he - 8] ^ ue[he - 14] ^ ue[he - 16], 1);
    for (var me = T[0], xe = T[1], ve = T[2], Te = T[3], we = T[4], Ee = 0; Ee < 80; ++Ee) {
      var Me = Math.floor(Ee / 20), Ie = ROTL(me, 5) + f(Me, xe, ve, Te) + we + e[Me] + ue[Ee] >>> 0;
      we = Te, Te = ve, ve = ROTL(xe, 30) >>> 0, xe = me, me = Ie;
    }
    T[0] = T[0] + me >>> 0, T[1] = T[1] + xe >>> 0, T[2] = T[2] + ve >>> 0, T[3] = T[3] + Te >>> 0, T[4] = T[4] + we >>> 0;
  }
  return [T[0] >> 24 & 255, T[0] >> 16 & 255, T[0] >> 8 & 255, T[0] & 255, T[1] >> 24 & 255, T[1] >> 16 & 255, T[1] >> 8 & 255, T[1] & 255, T[2] >> 24 & 255, T[2] >> 16 & 255, T[2] >> 8 & 255, T[2] & 255, T[3] >> 24 & 255, T[3] >> 16 & 255, T[3] >> 8 & 255, T[3] & 255, T[4] >> 24 & 255, T[4] >> 16 & 255, T[4] >> 8 & 255, T[4] & 255];
}
var v5 = v35("v5", 80, sha1);
const nil = "00000000-0000-0000-0000-000000000000";
function version$1(C) {
  if (!validate$3(C))
    throw TypeError("Invalid UUID");
  return parseInt(C.substr(14, 1), 16);
}
const esmBrowser = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  NIL: nil,
  parse: parse$1,
  stringify,
  v1,
  v3,
  v4,
  v5,
  validate: validate$3,
  version: version$1
}, Symbol.toStringTag, { value: "Module" })), require$$4 = /* @__PURE__ */ getAugmentedNamespace(esmBrowser), uuid$1 = require$$4.v4, generateRequest$1 = function(C, e, T, $) {
  if (typeof C != "string")
    throw new TypeError(C + " must be a string");
  $ = $ || {};
  const V = typeof $.version == "number" ? $.version : 2;
  if (V !== 1 && V !== 2)
    throw new TypeError(V + " must be 1 or 2");
  const J = {
    method: C
  };
  if (V === 2 && (J.jsonrpc = "2.0"), e) {
    if (typeof e != "object" && !Array.isArray(e))
      throw new TypeError(e + " must be an object, array or omitted");
    J.params = e;
  }
  if (typeof T > "u") {
    const ee = typeof $.generator == "function" ? $.generator : function() {
      return uuid$1();
    };
    J.id = ee(J, $);
  } else V === 2 && T === null ? $.notificationIdNull && (J.id = null) : J.id = T;
  return J;
};
var generateRequest_1 = generateRequest$1;
const uuid = require$$4.v4, generateRequest = generateRequest_1, ClientBrowser = function(C, e) {
  if (!(this instanceof ClientBrowser))
    return new ClientBrowser(C, e);
  e || (e = {}), this.options = {
    reviver: typeof e.reviver < "u" ? e.reviver : null,
    replacer: typeof e.replacer < "u" ? e.replacer : null,
    generator: typeof e.generator < "u" ? e.generator : function() {
      return uuid();
    },
    version: typeof e.version < "u" ? e.version : 2,
    notificationIdNull: typeof e.notificationIdNull == "boolean" ? e.notificationIdNull : !1
  }, this.callServer = C;
};
var browser = ClientBrowser;
ClientBrowser.prototype.request = function(C, e, T, $) {
  const V = this;
  let J = null;
  const ee = Array.isArray(C) && typeof e == "function";
  if (this.options.version === 1 && ee)
    throw new TypeError("JSON-RPC 1.0 does not support batching");
  if (ee || !ee && C && typeof C == "object" && typeof e == "function")
    $ = e, J = C;
  else {
    typeof T == "function" && ($ = T, T = void 0);
    const ie = typeof $ == "function";
    try {
      J = generateRequest(C, e, T, {
        generator: this.options.generator,
        version: this.options.version,
        notificationIdNull: this.options.notificationIdNull
      });
    } catch (se) {
      if (ie)
        return $(se);
      throw se;
    }
    if (!ie)
      return J;
  }
  let re;
  try {
    re = JSON.stringify(J, this.options.replacer);
  } catch (ie) {
    return $(ie);
  }
  return this.callServer(re, function(ie, se) {
    V._parseResponse(ie, se, $);
  }), J;
};
ClientBrowser.prototype._parseResponse = function(C, e, T) {
  if (C) {
    T(C);
    return;
  }
  if (!e)
    return T();
  let $;
  try {
    $ = JSON.parse(e, this.options.reviver);
  } catch (V) {
    return T(V);
  }
  if (T.length === 3)
    if (Array.isArray($)) {
      const V = function(ee) {
        return typeof ee.error < "u";
      }, J = function(ee) {
        return !V(ee);
      };
      return T(null, $.filter(V), $.filter(J));
    } else
      return T(null, $.error, $.result);
  T(null, $);
};
const RpcClient = /* @__PURE__ */ getDefaultExportFromCjs$2(browser);
var eventemitter3$2 = { exports: {} };
(function(C) {
  var e = Object.prototype.hasOwnProperty, T = "~";
  function $() {
  }
  Object.create && ($.prototype = /* @__PURE__ */ Object.create(null), new $().__proto__ || (T = !1));
  function V(re, ie, se) {
    this.fn = re, this.context = ie, this.once = se || !1;
  }
  function J(re, ie, se, de, ue) {
    if (typeof se != "function")
      throw new TypeError("The listener must be a function");
    var fe = new V(se, de || re, ue), he = T ? T + ie : ie;
    return re._events[he] ? re._events[he].fn ? re._events[he] = [re._events[he], fe] : re._events[he].push(fe) : (re._events[he] = fe, re._eventsCount++), re;
  }
  function ee(re, ie) {
    --re._eventsCount === 0 ? re._events = new $() : delete re._events[ie];
  }
  function te() {
    this._events = new $(), this._eventsCount = 0;
  }
  te.prototype.eventNames = function() {
    var ie = [], se, de;
    if (this._eventsCount === 0) return ie;
    for (de in se = this._events)
      e.call(se, de) && ie.push(T ? de.slice(1) : de);
    return Object.getOwnPropertySymbols ? ie.concat(Object.getOwnPropertySymbols(se)) : ie;
  }, te.prototype.listeners = function(ie) {
    var se = T ? T + ie : ie, de = this._events[se];
    if (!de) return [];
    if (de.fn) return [de.fn];
    for (var ue = 0, fe = de.length, he = new Array(fe); ue < fe; ue++)
      he[ue] = de[ue].fn;
    return he;
  }, te.prototype.listenerCount = function(ie) {
    var se = T ? T + ie : ie, de = this._events[se];
    return de ? de.fn ? 1 : de.length : 0;
  }, te.prototype.emit = function(ie, se, de, ue, fe, he) {
    var me = T ? T + ie : ie;
    if (!this._events[me]) return !1;
    var xe = this._events[me], ve = arguments.length, Te, we;
    if (xe.fn) {
      switch (xe.once && this.removeListener(ie, xe.fn, void 0, !0), ve) {
        case 1:
          return xe.fn.call(xe.context), !0;
        case 2:
          return xe.fn.call(xe.context, se), !0;
        case 3:
          return xe.fn.call(xe.context, se, de), !0;
        case 4:
          return xe.fn.call(xe.context, se, de, ue), !0;
        case 5:
          return xe.fn.call(xe.context, se, de, ue, fe), !0;
        case 6:
          return xe.fn.call(xe.context, se, de, ue, fe, he), !0;
      }
      for (we = 1, Te = new Array(ve - 1); we < ve; we++)
        Te[we - 1] = arguments[we];
      xe.fn.apply(xe.context, Te);
    } else {
      var Ee = xe.length, Me;
      for (we = 0; we < Ee; we++)
        switch (xe[we].once && this.removeListener(ie, xe[we].fn, void 0, !0), ve) {
          case 1:
            xe[we].fn.call(xe[we].context);
            break;
          case 2:
            xe[we].fn.call(xe[we].context, se);
            break;
          case 3:
            xe[we].fn.call(xe[we].context, se, de);
            break;
          case 4:
            xe[we].fn.call(xe[we].context, se, de, ue);
            break;
          default:
            if (!Te) for (Me = 1, Te = new Array(ve - 1); Me < ve; Me++)
              Te[Me - 1] = arguments[Me];
            xe[we].fn.apply(xe[we].context, Te);
        }
    }
    return !0;
  }, te.prototype.on = function(ie, se, de) {
    return J(this, ie, se, de, !1);
  }, te.prototype.once = function(ie, se, de) {
    return J(this, ie, se, de, !0);
  }, te.prototype.removeListener = function(ie, se, de, ue) {
    var fe = T ? T + ie : ie;
    if (!this._events[fe]) return this;
    if (!se)
      return ee(this, fe), this;
    var he = this._events[fe];
    if (he.fn)
      he.fn === se && (!ue || he.once) && (!de || he.context === de) && ee(this, fe);
    else {
      for (var me = 0, xe = [], ve = he.length; me < ve; me++)
        (he[me].fn !== se || ue && !he[me].once || de && he[me].context !== de) && xe.push(he[me]);
      xe.length ? this._events[fe] = xe.length === 1 ? xe[0] : xe : ee(this, fe);
    }
    return this;
  }, te.prototype.removeAllListeners = function(ie) {
    var se;
    return ie ? (se = T ? T + ie : ie, this._events[se] && ee(this, se)) : (this._events = new $(), this._eventsCount = 0), this;
  }, te.prototype.off = te.prototype.removeListener, te.prototype.addListener = te.prototype.on, te.prefixed = T, te.EventEmitter = te, C.exports = te;
})(eventemitter3$2);
var eventemitter3Exports$2 = eventemitter3$2.exports;
const EventEmitter$2 = /* @__PURE__ */ getDefaultExportFromCjs$2(eventemitter3Exports$2);
var WebSocketBrowserImpl$1 = class extends EventEmitter$2 {
  /** Instantiate a WebSocket class
  * @constructor
  * @param {String} address - url to a websocket server
  * @param {(Object)} options - websocket options
  * @param {(String|Array)} protocols - a list of protocols
  * @return {WebSocketBrowserImpl} - returns a WebSocket instance
  */
  constructor(T, $, V) {
    super();
    tt(this, "socket");
    this.socket = new window.WebSocket(T, V), this.socket.onopen = () => this.emit("open"), this.socket.onmessage = (J) => this.emit("message", J.data), this.socket.onerror = (J) => this.emit("error", J), this.socket.onclose = (J) => {
      this.emit("close", J.code, J.reason);
    };
  }
  /**
  * Sends data through a websocket connection
  * @method
  * @param {(String|Object)} data - data to be sent via websocket
  * @param {Object} optionsOrCallback - ws options
  * @param {Function} callback - a callback called once the data is sent
  * @return {Undefined}
  */
  send(T, $, V) {
    const J = V || $;
    try {
      this.socket.send(T), J();
    } catch (ee) {
      J(ee);
    }
  }
  /**
  * Closes an underlying socket
  * @method
  * @param {Number} code - status code explaining why the connection is being closed
  * @param {String} reason - a description why the connection is closing
  * @return {Undefined}
  * @throws {Error}
  */
  close(T, $) {
    this.socket.close(T, $);
  }
  addEventListener(T, $, V) {
    this.socket.addEventListener(T, $, V);
  }
};
function WebSocket(C, e) {
  return new WebSocketBrowserImpl$1(C, e);
}
var DefaultDataPack$1 = class {
  encode(e) {
    return JSON.stringify(e);
  }
  decode(e) {
    return JSON.parse(e);
  }
}, CommonClient$1 = class extends EventEmitter$2 {
  /**
  * Instantiate a Client class.
  * @constructor
  * @param {webSocketFactory} webSocketFactory - factory method for WebSocket
  * @param {String} address - url to a websocket server
  * @param {Object} options - ws options object with reconnect parameters
  * @param {Function} generate_request_id - custom generation request Id
  * @param {DataPack} dataPack - data pack contains encoder and decoder
  * @return {CommonClient}
  */
  constructor(T, $ = "ws://localhost:8080", {
    autoconnect: V = !0,
    reconnect: J = !0,
    reconnect_interval: ee = 1e3,
    max_reconnects: te = 5,
    ...re
  } = {}, ie, se) {
    super();
    tt(this, "address");
    tt(this, "rpc_id");
    tt(this, "queue");
    tt(this, "options");
    tt(this, "autoconnect");
    tt(this, "ready");
    tt(this, "reconnect");
    tt(this, "reconnect_timer_id");
    tt(this, "reconnect_interval");
    tt(this, "max_reconnects");
    tt(this, "rest_options");
    tt(this, "current_reconnects");
    tt(this, "generate_request_id");
    tt(this, "socket");
    tt(this, "webSocketFactory");
    tt(this, "dataPack");
    this.webSocketFactory = T, this.queue = {}, this.rpc_id = 0, this.address = $, this.autoconnect = V, this.ready = !1, this.reconnect = J, this.reconnect_timer_id = void 0, this.reconnect_interval = ee, this.max_reconnects = te, this.rest_options = re, this.current_reconnects = 0, this.generate_request_id = ie || (() => ++this.rpc_id), se ? this.dataPack = se : this.dataPack = new DefaultDataPack$1(), this.autoconnect && this._connect(this.address, {
      autoconnect: this.autoconnect,
      reconnect: this.reconnect,
      reconnect_interval: this.reconnect_interval,
      max_reconnects: this.max_reconnects,
      ...this.rest_options
    });
  }
  /**
  * Connects to a defined server if not connected already.
  * @method
  * @return {Undefined}
  */
  connect() {
    this.socket || this._connect(this.address, {
      autoconnect: this.autoconnect,
      reconnect: this.reconnect,
      reconnect_interval: this.reconnect_interval,
      max_reconnects: this.max_reconnects,
      ...this.rest_options
    });
  }
  /**
  * Calls a registered RPC method on server.
  * @method
  * @param {String} method - RPC method name
  * @param {Object|Array} params - optional method parameters
  * @param {Number} timeout - RPC reply timeout value
  * @param {Object} ws_opts - options passed to ws
  * @return {Promise}
  */
  call(T, $, V, J) {
    return !J && typeof V == "object" && (J = V, V = null), new Promise((ee, te) => {
      if (!this.ready) return te(new Error("socket not ready"));
      const re = this.generate_request_id(T, $), ie = {
        jsonrpc: "2.0",
        method: T,
        params: $ || void 0,
        id: re
      };
      this.socket.send(this.dataPack.encode(ie), J, (se) => {
        if (se) return te(se);
        this.queue[re] = { promise: [ee, te] }, V && (this.queue[re].timeout = setTimeout(() => {
          delete this.queue[re], te(new Error("reply timeout"));
        }, V));
      });
    });
  }
  /**
  * Logins with the other side of the connection.
  * @method
  * @param {Object} params - Login credentials object
  * @return {Promise}
  */
  async login(T) {
    const $ = await this.call("rpc.login", T);
    if (!$) throw new Error("authentication failed");
    return $;
  }
  /**
  * Fetches a list of client's methods registered on server.
  * @method
  * @return {Array}
  */
  async listMethods() {
    return await this.call("__listMethods");
  }
  /**
  * Sends a JSON-RPC 2.0 notification to server.
  * @method
  * @param {String} method - RPC method name
  * @param {Object} params - optional method parameters
  * @return {Promise}
  */
  notify(T, $) {
    return new Promise((V, J) => {
      if (!this.ready) return J(new Error("socket not ready"));
      const ee = {
        jsonrpc: "2.0",
        method: T,
        params: $
      };
      this.socket.send(this.dataPack.encode(ee), (te) => {
        if (te) return J(te);
        V();
      });
    });
  }
  /**
  * Subscribes for a defined event.
  * @method
  * @param {String|Array} event - event name
  * @return {Undefined}
  * @throws {Error}
  */
  async subscribe(T) {
    typeof T == "string" && (T = [T]);
    const $ = await this.call("rpc.on", T);
    if (typeof T == "string" && $[T] !== "ok")
      throw new Error(
        "Failed subscribing to an event '" + T + "' with: " + $[T]
      );
    return $;
  }
  /**
  * Unsubscribes from a defined event.
  * @method
  * @param {String|Array} event - event name
  * @return {Undefined}
  * @throws {Error}
  */
  async unsubscribe(T) {
    typeof T == "string" && (T = [T]);
    const $ = await this.call("rpc.off", T);
    if (typeof T == "string" && $[T] !== "ok")
      throw new Error("Failed unsubscribing from an event with: " + $);
    return $;
  }
  /**
  * Closes a WebSocket connection gracefully.
  * @method
  * @param {Number} code - socket close code
  * @param {String} data - optional data to be sent before closing
  * @return {Undefined}
  */
  close(T, $) {
    this.socket.close(T || 1e3, $);
  }
  /**
  * Enable / disable automatic reconnection.
  * @method
  * @param {Boolean} reconnect - enable / disable reconnection
  * @return {Undefined}
  */
  setAutoReconnect(T) {
    this.reconnect = T;
  }
  /**
  * Set the interval between reconnection attempts.
  * @method
  * @param {Number} interval - reconnection interval in milliseconds
  * @return {Undefined}
  */
  setReconnectInterval(T) {
    this.reconnect_interval = T;
  }
  /**
  * Set the maximum number of reconnection attempts.
  * @method
  * @param {Number} max_reconnects - maximum reconnection attempts
  * @return {Undefined}
  */
  setMaxReconnects(T) {
    this.max_reconnects = T;
  }
  /**
  * Connection/Message handler.
  * @method
  * @private
  * @param {String} address - WebSocket API address
  * @param {Object} options - ws options object
  * @return {Undefined}
  */
  _connect(T, $) {
    clearTimeout(this.reconnect_timer_id), this.socket = this.webSocketFactory(T, $), this.socket.addEventListener("open", () => {
      this.ready = !0, this.emit("open"), this.current_reconnects = 0;
    }), this.socket.addEventListener("message", ({ data: V }) => {
      V instanceof ArrayBuffer && (V = bufferPolyfill.Buffer.from(V).toString());
      try {
        V = this.dataPack.decode(V);
      } catch {
        return;
      }
      if (V.notification && this.listeners(V.notification).length) {
        if (!Object.keys(V.params).length)
          return this.emit(V.notification);
        const J = [V.notification];
        if (V.params.constructor === Object) J.push(V.params);
        else
          for (let ee = 0; ee < V.params.length; ee++)
            J.push(V.params[ee]);
        return Promise.resolve().then(() => {
          this.emit.apply(this, J);
        });
      }
      if (!this.queue[V.id])
        return V.method ? Promise.resolve().then(() => {
          this.emit(V.method, V == null ? void 0 : V.params);
        }) : void 0;
      "error" in V == "result" in V && this.queue[V.id].promise[1](
        new Error(
          'Server response malformed. Response must include either "result" or "error", but not both.'
        )
      ), this.queue[V.id].timeout && clearTimeout(this.queue[V.id].timeout), V.error ? this.queue[V.id].promise[1](V.error) : this.queue[V.id].promise[0](V.result), delete this.queue[V.id];
    }), this.socket.addEventListener("error", (V) => this.emit("error", V)), this.socket.addEventListener("close", ({ code: V, reason: J }) => {
      this.ready && setTimeout(() => this.emit("close", V, J), 0), this.ready = !1, this.socket = void 0, V !== 1e3 && (this.current_reconnects++, this.reconnect && (this.max_reconnects > this.current_reconnects || this.max_reconnects === 0) && (this.reconnect_timer_id = setTimeout(
        () => this._connect(T, $),
        this.reconnect_interval
      )));
    });
  }
};
const generatePrivateKey = ed25519.utils.randomPrivateKey, generateKeypair = () => {
  const C = ed25519.utils.randomPrivateKey(), e = getPublicKey(C), T = new Uint8Array(64);
  return T.set(C), T.set(e, 32), {
    publicKey: e,
    secretKey: T
  };
}, getPublicKey = ed25519.getPublicKey;
function isOnCurve(C) {
  try {
    return ed25519.ExtendedPoint.fromHex(C), !0;
  } catch {
    return !1;
  }
}
const sign = (C, e) => ed25519.sign(C, e.slice(0, 32)), verify = ed25519.verify, toBuffer = (C) => bufferPolyfill.Buffer.isBuffer(C) ? C : C instanceof Uint8Array ? bufferPolyfill.Buffer.from(C.buffer, C.byteOffset, C.byteLength) : bufferPolyfill.Buffer.from(C);
let Struct$2 = class {
  constructor(e) {
    Object.assign(this, e);
  }
  encode() {
    return bufferPolyfill.Buffer.from(serialize_1(SOLANA_SCHEMA, this));
  }
  static decode(e) {
    return deserialize_1(SOLANA_SCHEMA, this, e);
  }
  static decodeUnchecked(e) {
    return deserializeUnchecked_1(SOLANA_SCHEMA, this, e);
  }
};
class Enum extends Struct$2 {
  constructor(e) {
    if (super(e), this.enum = "", Object.keys(e).length !== 1)
      throw new Error("Enum can only take single value");
    Object.keys(e).map((T) => {
      this.enum = T;
    });
  }
}
const SOLANA_SCHEMA = /* @__PURE__ */ new Map();
var _PublicKey;
const MAX_SEED_LENGTH = 32, PUBLIC_KEY_LENGTH = 32;
function isPublicKeyData(C) {
  return C._bn !== void 0;
}
let uniquePublicKeyCounter = 1;
class PublicKey extends Struct$2 {
  /**
   * Create a new PublicKey object
   * @param value ed25519 public key as buffer or base-58 encoded string
   */
  constructor(e) {
    if (super({}), this._bn = void 0, isPublicKeyData(e))
      this._bn = e._bn;
    else {
      if (typeof e == "string") {
        const T = bs58$6.decode(e);
        if (T.length != PUBLIC_KEY_LENGTH)
          throw new Error("Invalid public key input");
        this._bn = new BN(T);
      } else
        this._bn = new BN(e);
      if (this._bn.byteLength() > PUBLIC_KEY_LENGTH)
        throw new Error("Invalid public key input");
    }
  }
  /**
   * Returns a unique PublicKey for tests and benchmarks using a counter
   */
  static unique() {
    const e = new PublicKey(uniquePublicKeyCounter);
    return uniquePublicKeyCounter += 1, new PublicKey(e.toBuffer());
  }
  /**
   * Default public key value. The base58-encoded string representation is all ones (as seen below)
   * The underlying BN number is 32 bytes that are all zeros
   */
  /**
   * Checks if two publicKeys are equal
   */
  equals(e) {
    return this._bn.eq(e._bn);
  }
  /**
   * Return the base-58 representation of the public key
   */
  toBase58() {
    return bs58$6.encode(this.toBytes());
  }
  toJSON() {
    return this.toBase58();
  }
  /**
   * Return the byte array representation of the public key in big endian
   */
  toBytes() {
    const e = this.toBuffer();
    return new Uint8Array(e.buffer, e.byteOffset, e.byteLength);
  }
  /**
   * Return the Buffer representation of the public key in big endian
   */
  toBuffer() {
    const e = this._bn.toArrayLike(bufferPolyfill.Buffer);
    if (e.length === PUBLIC_KEY_LENGTH)
      return e;
    const T = bufferPolyfill.Buffer.alloc(32);
    return e.copy(T, 32 - e.length), T;
  }
  get [Symbol.toStringTag]() {
    return `PublicKey(${this.toString()})`;
  }
  /**
   * Return the base-58 representation of the public key
   */
  toString() {
    return this.toBase58();
  }
  /**
   * Derive a public key from another key, a seed, and a program ID.
   * The program ID will also serve as the owner of the public key, giving
   * it permission to write data to the account.
   */
  /* eslint-disable require-await */
  static async createWithSeed(e, T, $) {
    const V = bufferPolyfill.Buffer.concat([e.toBuffer(), bufferPolyfill.Buffer.from(T), $.toBuffer()]), J = sha256$5(V);
    return new PublicKey(J);
  }
  /**
   * Derive a program address from seeds and a program ID.
   */
  /* eslint-disable require-await */
  static createProgramAddressSync(e, T) {
    let $ = bufferPolyfill.Buffer.alloc(0);
    e.forEach(function(J) {
      if (J.length > MAX_SEED_LENGTH)
        throw new TypeError("Max seed length exceeded");
      $ = bufferPolyfill.Buffer.concat([$, toBuffer(J)]);
    }), $ = bufferPolyfill.Buffer.concat([$, T.toBuffer(), bufferPolyfill.Buffer.from("ProgramDerivedAddress")]);
    const V = sha256$5($);
    if (isOnCurve(V))
      throw new Error("Invalid seeds, address must fall off the curve");
    return new PublicKey(V);
  }
  /**
   * Async version of createProgramAddressSync
   * For backwards compatibility
   *
   * @deprecated Use {@link createProgramAddressSync} instead
   */
  /* eslint-disable require-await */
  static async createProgramAddress(e, T) {
    return this.createProgramAddressSync(e, T);
  }
  /**
   * Find a valid program address
   *
   * Valid program addresses must fall off the ed25519 curve.  This function
   * iterates a nonce until it finds one that when combined with the seeds
   * results in a valid program address.
   */
  static findProgramAddressSync(e, T) {
    let $ = 255, V;
    for (; $ != 0; ) {
      try {
        const J = e.concat(bufferPolyfill.Buffer.from([$]));
        V = this.createProgramAddressSync(J, T);
      } catch (J) {
        if (J instanceof TypeError)
          throw J;
        $--;
        continue;
      }
      return [V, $];
    }
    throw new Error("Unable to find a viable program address nonce");
  }
  /**
   * Async version of findProgramAddressSync
   * For backwards compatibility
   *
   * @deprecated Use {@link findProgramAddressSync} instead
   */
  static async findProgramAddress(e, T) {
    return this.findProgramAddressSync(e, T);
  }
  /**
   * Check that a pubkey is on the ed25519 curve.
   */
  static isOnCurve(e) {
    const T = new PublicKey(e);
    return isOnCurve(T.toBytes());
  }
}
_PublicKey = PublicKey;
PublicKey.default = new _PublicKey("11111111111111111111111111111111");
SOLANA_SCHEMA.set(PublicKey, {
  kind: "struct",
  fields: [["_bn", "u256"]]
});
class Account {
  /**
   * Create a new Account object
   *
   * If the secretKey parameter is not provided a new key pair is randomly
   * created for the account
   *
   * @param secretKey Secret key for the account
   */
  constructor(e) {
    if (this._publicKey = void 0, this._secretKey = void 0, e) {
      const T = toBuffer(e);
      if (e.length !== 64)
        throw new Error("bad secret key size");
      this._publicKey = T.slice(32, 64), this._secretKey = T.slice(0, 32);
    } else
      this._secretKey = toBuffer(generatePrivateKey()), this._publicKey = toBuffer(getPublicKey(this._secretKey));
  }
  /**
   * The public key for this account
   */
  get publicKey() {
    return new PublicKey(this._publicKey);
  }
  /**
   * The **unencrypted** secret key for this account. The first 32 bytes
   * is the private scalar and the last 32 bytes is the public key.
   * Read more: https://blog.mozilla.org/warner/2011/11/29/ed25519-keys/
   */
  get secretKey() {
    return bufferPolyfill.Buffer.concat([this._secretKey, this._publicKey], 64);
  }
}
const BPF_LOADER_DEPRECATED_PROGRAM_ID = new PublicKey("BPFLoader1111111111111111111111111111111111"), PACKET_DATA_SIZE = 1232, VERSION_PREFIX_MASK = 127, SIGNATURE_LENGTH_IN_BYTES = 64;
class TransactionExpiredBlockheightExceededError extends Error {
  constructor(e) {
    super(`Signature ${e} has expired: block height exceeded.`), this.signature = void 0, this.signature = e;
  }
}
Object.defineProperty(TransactionExpiredBlockheightExceededError.prototype, "name", {
  value: "TransactionExpiredBlockheightExceededError"
});
class TransactionExpiredTimeoutError extends Error {
  constructor(e, T) {
    super(`Transaction was not confirmed in ${T.toFixed(2)} seconds. It is unknown if it succeeded or failed. Check signature ${e} using the Solana Explorer or CLI tools.`), this.signature = void 0, this.signature = e;
  }
}
Object.defineProperty(TransactionExpiredTimeoutError.prototype, "name", {
  value: "TransactionExpiredTimeoutError"
});
class TransactionExpiredNonceInvalidError extends Error {
  constructor(e) {
    super(`Signature ${e} has expired: the nonce is no longer valid.`), this.signature = void 0, this.signature = e;
  }
}
Object.defineProperty(TransactionExpiredNonceInvalidError.prototype, "name", {
  value: "TransactionExpiredNonceInvalidError"
});
class MessageAccountKeys {
  constructor(e, T) {
    this.staticAccountKeys = void 0, this.accountKeysFromLookups = void 0, this.staticAccountKeys = e, this.accountKeysFromLookups = T;
  }
  keySegments() {
    const e = [this.staticAccountKeys];
    return this.accountKeysFromLookups && (e.push(this.accountKeysFromLookups.writable), e.push(this.accountKeysFromLookups.readonly)), e;
  }
  get(e) {
    for (const T of this.keySegments()) {
      if (e < T.length)
        return T[e];
      e -= T.length;
    }
  }
  get length() {
    return this.keySegments().flat().length;
  }
  compileInstructions(e) {
    if (this.length > 256)
      throw new Error("Account index overflow encountered during compilation");
    const $ = /* @__PURE__ */ new Map();
    this.keySegments().flat().forEach((J, ee) => {
      $.set(J.toBase58(), ee);
    });
    const V = (J) => {
      const ee = $.get(J.toBase58());
      if (ee === void 0) throw new Error("Encountered an unknown instruction account key during compilation");
      return ee;
    };
    return e.map((J) => ({
      programIdIndex: V(J.programId),
      accountKeyIndexes: J.keys.map((ee) => V(ee.pubkey)),
      data: J.data
    }));
  }
}
const publicKey$4 = (C = "publicKey") => blob$1(32, C), signature = (C = "signature") => blob$1(64, C), rustString = (C = "string") => {
  const e = struct$1([u32$1("length"), u32$1("lengthPadding"), blob$1(offset$3(u32$1(), -8), "chars")], C), T = e.decode.bind(e), $ = e.encode.bind(e), V = e;
  return V.decode = (J, ee) => T(J, ee).chars.toString(), V.encode = (J, ee, te) => {
    const re = {
      chars: bufferPolyfill.Buffer.from(J, "utf8")
    };
    return $(re, ee, te);
  }, V.alloc = (J) => u32$1().span + u32$1().span + bufferPolyfill.Buffer.from(J, "utf8").length, V;
}, authorized = (C = "authorized") => struct$1([publicKey$4("staker"), publicKey$4("withdrawer")], C), lockup = (C = "lockup") => struct$1([ns64$1("unixTimestamp"), ns64$1("epoch"), publicKey$4("custodian")], C), voteInit = (C = "voteInit") => struct$1([publicKey$4("nodePubkey"), publicKey$4("authorizedVoter"), publicKey$4("authorizedWithdrawer"), u8$1("commission")], C), voteAuthorizeWithSeedArgs = (C = "voteAuthorizeWithSeedArgs") => struct$1([u32$1("voteAuthorizationType"), publicKey$4("currentAuthorityDerivedKeyOwnerPubkey"), rustString("currentAuthorityDerivedKeySeed"), publicKey$4("newAuthorized")], C);
function getAlloc(C, e) {
  const T = (V) => {
    if (V.span >= 0)
      return V.span;
    if (typeof V.alloc == "function")
      return V.alloc(e[V.property]);
    if ("count" in V && "elementLayout" in V) {
      const J = e[V.property];
      if (Array.isArray(J))
        return J.length * T(V.elementLayout);
    } else if ("fields" in V)
      return getAlloc({
        layout: V
      }, e[V.property]);
    return 0;
  };
  let $ = 0;
  return C.layout.fields.forEach((V) => {
    $ += T(V);
  }), $;
}
function decodeLength(C) {
  let e = 0, T = 0;
  for (; ; ) {
    let $ = C.shift();
    if (e |= ($ & 127) << T * 7, T += 1, !($ & 128))
      break;
  }
  return e;
}
function encodeLength(C, e) {
  let T = e;
  for (; ; ) {
    let $ = T & 127;
    if (T >>= 7, T == 0) {
      C.push($);
      break;
    } else
      $ |= 128, C.push($);
  }
}
function assert$3(C, e) {
  if (!C)
    throw new Error(e || "Assertion failed");
}
class CompiledKeys {
  constructor(e, T) {
    this.payer = void 0, this.keyMetaMap = void 0, this.payer = e, this.keyMetaMap = T;
  }
  static compile(e, T) {
    const $ = /* @__PURE__ */ new Map(), V = (ee) => {
      const te = ee.toBase58();
      let re = $.get(te);
      return re === void 0 && (re = {
        isSigner: !1,
        isWritable: !1,
        isInvoked: !1
      }, $.set(te, re)), re;
    }, J = V(T);
    J.isSigner = !0, J.isWritable = !0;
    for (const ee of e) {
      V(ee.programId).isInvoked = !0;
      for (const te of ee.keys) {
        const re = V(te.pubkey);
        re.isSigner || (re.isSigner = te.isSigner), re.isWritable || (re.isWritable = te.isWritable);
      }
    }
    return new CompiledKeys(T, $);
  }
  getMessageComponents() {
    const e = [...this.keyMetaMap.entries()];
    assert$3(e.length <= 256, "Max static account keys length exceeded");
    const T = e.filter(([, re]) => re.isSigner && re.isWritable), $ = e.filter(([, re]) => re.isSigner && !re.isWritable), V = e.filter(([, re]) => !re.isSigner && re.isWritable), J = e.filter(([, re]) => !re.isSigner && !re.isWritable), ee = {
      numRequiredSignatures: T.length + $.length,
      numReadonlySignedAccounts: $.length,
      numReadonlyUnsignedAccounts: J.length
    };
    {
      assert$3(T.length > 0, "Expected at least one writable signer key");
      const [re] = T[0];
      assert$3(re === this.payer.toBase58(), "Expected first writable signer key to be the fee payer");
    }
    const te = [...T.map(([re]) => new PublicKey(re)), ...$.map(([re]) => new PublicKey(re)), ...V.map(([re]) => new PublicKey(re)), ...J.map(([re]) => new PublicKey(re))];
    return [ee, te];
  }
  extractTableLookup(e) {
    const [T, $] = this.drainKeysFoundInLookupTable(e.state.addresses, (ee) => !ee.isSigner && !ee.isInvoked && ee.isWritable), [V, J] = this.drainKeysFoundInLookupTable(e.state.addresses, (ee) => !ee.isSigner && !ee.isInvoked && !ee.isWritable);
    if (!(T.length === 0 && V.length === 0))
      return [{
        accountKey: e.key,
        writableIndexes: T,
        readonlyIndexes: V
      }, {
        writable: $,
        readonly: J
      }];
  }
  /** @internal */
  drainKeysFoundInLookupTable(e, T) {
    const $ = new Array(), V = new Array();
    for (const [J, ee] of this.keyMetaMap.entries())
      if (T(ee)) {
        const te = new PublicKey(J), re = e.findIndex((ie) => ie.equals(te));
        re >= 0 && (assert$3(re < 256, "Max lookup table index exceeded"), $.push(re), V.push(te), this.keyMetaMap.delete(J));
      }
    return [$, V];
  }
}
const END_OF_BUFFER_ERROR_MESSAGE = "Reached end of buffer unexpectedly";
function guardedShift(C) {
  if (C.length === 0)
    throw new Error(END_OF_BUFFER_ERROR_MESSAGE);
  return C.shift();
}
function guardedSplice(C, ...e) {
  const [T] = e;
  if (e.length === 2 ? T + (e[1] ?? 0) > C.length : T >= C.length)
    throw new Error(END_OF_BUFFER_ERROR_MESSAGE);
  return C.splice(...e);
}
class Message {
  constructor(e) {
    this.header = void 0, this.accountKeys = void 0, this.recentBlockhash = void 0, this.instructions = void 0, this.indexToProgramIds = /* @__PURE__ */ new Map(), this.header = e.header, this.accountKeys = e.accountKeys.map((T) => new PublicKey(T)), this.recentBlockhash = e.recentBlockhash, this.instructions = e.instructions, this.instructions.forEach((T) => this.indexToProgramIds.set(T.programIdIndex, this.accountKeys[T.programIdIndex]));
  }
  get version() {
    return "legacy";
  }
  get staticAccountKeys() {
    return this.accountKeys;
  }
  get compiledInstructions() {
    return this.instructions.map((e) => ({
      programIdIndex: e.programIdIndex,
      accountKeyIndexes: e.accounts,
      data: bs58$6.decode(e.data)
    }));
  }
  get addressTableLookups() {
    return [];
  }
  getAccountKeys() {
    return new MessageAccountKeys(this.staticAccountKeys);
  }
  static compile(e) {
    const T = CompiledKeys.compile(e.instructions, e.payerKey), [$, V] = T.getMessageComponents(), ee = new MessageAccountKeys(V).compileInstructions(e.instructions).map((te) => ({
      programIdIndex: te.programIdIndex,
      accounts: te.accountKeyIndexes,
      data: bs58$6.encode(te.data)
    }));
    return new Message({
      header: $,
      accountKeys: V,
      recentBlockhash: e.recentBlockhash,
      instructions: ee
    });
  }
  isAccountSigner(e) {
    return e < this.header.numRequiredSignatures;
  }
  isAccountWritable(e) {
    const T = this.header.numRequiredSignatures;
    if (e >= this.header.numRequiredSignatures) {
      const $ = e - T, J = this.accountKeys.length - T - this.header.numReadonlyUnsignedAccounts;
      return $ < J;
    } else {
      const $ = T - this.header.numReadonlySignedAccounts;
      return e < $;
    }
  }
  isProgramId(e) {
    return this.indexToProgramIds.has(e);
  }
  programIds() {
    return [...this.indexToProgramIds.values()];
  }
  nonProgramIds() {
    return this.accountKeys.filter((e, T) => !this.isProgramId(T));
  }
  serialize() {
    const e = this.accountKeys.length;
    let T = [];
    encodeLength(T, e);
    const $ = this.instructions.map((de) => {
      const {
        accounts: ue,
        programIdIndex: fe
      } = de, he = Array.from(bs58$6.decode(de.data));
      let me = [];
      encodeLength(me, ue.length);
      let xe = [];
      return encodeLength(xe, he.length), {
        programIdIndex: fe,
        keyIndicesCount: bufferPolyfill.Buffer.from(me),
        keyIndices: ue,
        dataLength: bufferPolyfill.Buffer.from(xe),
        data: he
      };
    });
    let V = [];
    encodeLength(V, $.length);
    let J = bufferPolyfill.Buffer.alloc(PACKET_DATA_SIZE);
    bufferPolyfill.Buffer.from(V).copy(J);
    let ee = V.length;
    $.forEach((de) => {
      const fe = struct$1([u8$1("programIdIndex"), blob$1(de.keyIndicesCount.length, "keyIndicesCount"), seq(u8$1("keyIndex"), de.keyIndices.length, "keyIndices"), blob$1(de.dataLength.length, "dataLength"), seq(u8$1("userdatum"), de.data.length, "data")]).encode(de, J, ee);
      ee += fe;
    }), J = J.slice(0, ee);
    const te = struct$1([blob$1(1, "numRequiredSignatures"), blob$1(1, "numReadonlySignedAccounts"), blob$1(1, "numReadonlyUnsignedAccounts"), blob$1(T.length, "keyCount"), seq(publicKey$4("key"), e, "keys"), publicKey$4("recentBlockhash")]), re = {
      numRequiredSignatures: bufferPolyfill.Buffer.from([this.header.numRequiredSignatures]),
      numReadonlySignedAccounts: bufferPolyfill.Buffer.from([this.header.numReadonlySignedAccounts]),
      numReadonlyUnsignedAccounts: bufferPolyfill.Buffer.from([this.header.numReadonlyUnsignedAccounts]),
      keyCount: bufferPolyfill.Buffer.from(T),
      keys: this.accountKeys.map((de) => toBuffer(de.toBytes())),
      recentBlockhash: bs58$6.decode(this.recentBlockhash)
    };
    let ie = bufferPolyfill.Buffer.alloc(2048);
    const se = te.encode(re, ie);
    return J.copy(ie, se), ie.slice(0, se + J.length);
  }
  /**
   * Decode a compiled message into a Message object.
   */
  static from(e) {
    let T = [...e];
    const $ = guardedShift(T);
    if ($ !== ($ & VERSION_PREFIX_MASK))
      throw new Error("Versioned messages must be deserialized with VersionedMessage.deserialize()");
    const V = guardedShift(T), J = guardedShift(T), ee = decodeLength(T);
    let te = [];
    for (let ue = 0; ue < ee; ue++) {
      const fe = guardedSplice(T, 0, PUBLIC_KEY_LENGTH);
      te.push(new PublicKey(bufferPolyfill.Buffer.from(fe)));
    }
    const re = guardedSplice(T, 0, PUBLIC_KEY_LENGTH), ie = decodeLength(T);
    let se = [];
    for (let ue = 0; ue < ie; ue++) {
      const fe = guardedShift(T), he = decodeLength(T), me = guardedSplice(T, 0, he), xe = decodeLength(T), ve = guardedSplice(T, 0, xe), Te = bs58$6.encode(bufferPolyfill.Buffer.from(ve));
      se.push({
        programIdIndex: fe,
        accounts: me,
        data: Te
      });
    }
    const de = {
      header: {
        numRequiredSignatures: $,
        numReadonlySignedAccounts: V,
        numReadonlyUnsignedAccounts: J
      },
      recentBlockhash: bs58$6.encode(bufferPolyfill.Buffer.from(re)),
      accountKeys: te,
      instructions: se
    };
    return new Message(de);
  }
}
class MessageV0 {
  constructor(e) {
    this.header = void 0, this.staticAccountKeys = void 0, this.recentBlockhash = void 0, this.compiledInstructions = void 0, this.addressTableLookups = void 0, this.header = e.header, this.staticAccountKeys = e.staticAccountKeys, this.recentBlockhash = e.recentBlockhash, this.compiledInstructions = e.compiledInstructions, this.addressTableLookups = e.addressTableLookups;
  }
  get version() {
    return 0;
  }
  get numAccountKeysFromLookups() {
    let e = 0;
    for (const T of this.addressTableLookups)
      e += T.readonlyIndexes.length + T.writableIndexes.length;
    return e;
  }
  getAccountKeys(e) {
    let T;
    if (e && "accountKeysFromLookups" in e && e.accountKeysFromLookups) {
      if (this.numAccountKeysFromLookups != e.accountKeysFromLookups.writable.length + e.accountKeysFromLookups.readonly.length)
        throw new Error("Failed to get account keys because of a mismatch in the number of account keys from lookups");
      T = e.accountKeysFromLookups;
    } else if (e && "addressLookupTableAccounts" in e && e.addressLookupTableAccounts)
      T = this.resolveAddressTableLookups(e.addressLookupTableAccounts);
    else if (this.addressTableLookups.length > 0)
      throw new Error("Failed to get account keys because address table lookups were not resolved");
    return new MessageAccountKeys(this.staticAccountKeys, T);
  }
  isAccountSigner(e) {
    return e < this.header.numRequiredSignatures;
  }
  isAccountWritable(e) {
    const T = this.header.numRequiredSignatures, $ = this.staticAccountKeys.length;
    if (e >= $) {
      const V = e - $, J = this.addressTableLookups.reduce((ee, te) => ee + te.writableIndexes.length, 0);
      return V < J;
    } else if (e >= this.header.numRequiredSignatures) {
      const V = e - T, ee = $ - T - this.header.numReadonlyUnsignedAccounts;
      return V < ee;
    } else {
      const V = T - this.header.numReadonlySignedAccounts;
      return e < V;
    }
  }
  resolveAddressTableLookups(e) {
    const T = {
      writable: [],
      readonly: []
    };
    for (const $ of this.addressTableLookups) {
      const V = e.find((J) => J.key.equals($.accountKey));
      if (!V)
        throw new Error(`Failed to find address lookup table account for table key ${$.accountKey.toBase58()}`);
      for (const J of $.writableIndexes)
        if (J < V.state.addresses.length)
          T.writable.push(V.state.addresses[J]);
        else
          throw new Error(`Failed to find address for index ${J} in address lookup table ${$.accountKey.toBase58()}`);
      for (const J of $.readonlyIndexes)
        if (J < V.state.addresses.length)
          T.readonly.push(V.state.addresses[J]);
        else
          throw new Error(`Failed to find address for index ${J} in address lookup table ${$.accountKey.toBase58()}`);
    }
    return T;
  }
  static compile(e) {
    const T = CompiledKeys.compile(e.instructions, e.payerKey), $ = new Array(), V = {
      writable: new Array(),
      readonly: new Array()
    }, J = e.addressLookupTableAccounts || [];
    for (const se of J) {
      const de = T.extractTableLookup(se);
      if (de !== void 0) {
        const [ue, {
          writable: fe,
          readonly: he
        }] = de;
        $.push(ue), V.writable.push(...fe), V.readonly.push(...he);
      }
    }
    const [ee, te] = T.getMessageComponents(), ie = new MessageAccountKeys(te, V).compileInstructions(e.instructions);
    return new MessageV0({
      header: ee,
      staticAccountKeys: te,
      recentBlockhash: e.recentBlockhash,
      compiledInstructions: ie,
      addressTableLookups: $
    });
  }
  serialize() {
    const e = Array();
    encodeLength(e, this.staticAccountKeys.length);
    const T = this.serializeInstructions(), $ = Array();
    encodeLength($, this.compiledInstructions.length);
    const V = this.serializeAddressTableLookups(), J = Array();
    encodeLength(J, this.addressTableLookups.length);
    const ee = struct$1([u8$1("prefix"), struct$1([u8$1("numRequiredSignatures"), u8$1("numReadonlySignedAccounts"), u8$1("numReadonlyUnsignedAccounts")], "header"), blob$1(e.length, "staticAccountKeysLength"), seq(publicKey$4(), this.staticAccountKeys.length, "staticAccountKeys"), publicKey$4("recentBlockhash"), blob$1($.length, "instructionsLength"), blob$1(T.length, "serializedInstructions"), blob$1(J.length, "addressTableLookupsLength"), blob$1(V.length, "serializedAddressTableLookups")]), te = new Uint8Array(PACKET_DATA_SIZE), ie = ee.encode({
      prefix: 128,
      header: this.header,
      staticAccountKeysLength: new Uint8Array(e),
      staticAccountKeys: this.staticAccountKeys.map((se) => se.toBytes()),
      recentBlockhash: bs58$6.decode(this.recentBlockhash),
      instructionsLength: new Uint8Array($),
      serializedInstructions: T,
      addressTableLookupsLength: new Uint8Array(J),
      serializedAddressTableLookups: V
    }, te);
    return te.slice(0, ie);
  }
  serializeInstructions() {
    let e = 0;
    const T = new Uint8Array(PACKET_DATA_SIZE);
    for (const $ of this.compiledInstructions) {
      const V = Array();
      encodeLength(V, $.accountKeyIndexes.length);
      const J = Array();
      encodeLength(J, $.data.length);
      const ee = struct$1([u8$1("programIdIndex"), blob$1(V.length, "encodedAccountKeyIndexesLength"), seq(u8$1(), $.accountKeyIndexes.length, "accountKeyIndexes"), blob$1(J.length, "encodedDataLength"), blob$1($.data.length, "data")]);
      e += ee.encode({
        programIdIndex: $.programIdIndex,
        encodedAccountKeyIndexesLength: new Uint8Array(V),
        accountKeyIndexes: $.accountKeyIndexes,
        encodedDataLength: new Uint8Array(J),
        data: $.data
      }, T, e);
    }
    return T.slice(0, e);
  }
  serializeAddressTableLookups() {
    let e = 0;
    const T = new Uint8Array(PACKET_DATA_SIZE);
    for (const $ of this.addressTableLookups) {
      const V = Array();
      encodeLength(V, $.writableIndexes.length);
      const J = Array();
      encodeLength(J, $.readonlyIndexes.length);
      const ee = struct$1([publicKey$4("accountKey"), blob$1(V.length, "encodedWritableIndexesLength"), seq(u8$1(), $.writableIndexes.length, "writableIndexes"), blob$1(J.length, "encodedReadonlyIndexesLength"), seq(u8$1(), $.readonlyIndexes.length, "readonlyIndexes")]);
      e += ee.encode({
        accountKey: $.accountKey.toBytes(),
        encodedWritableIndexesLength: new Uint8Array(V),
        writableIndexes: $.writableIndexes,
        encodedReadonlyIndexesLength: new Uint8Array(J),
        readonlyIndexes: $.readonlyIndexes
      }, T, e);
    }
    return T.slice(0, e);
  }
  static deserialize(e) {
    let T = [...e];
    const $ = guardedShift(T), V = $ & VERSION_PREFIX_MASK;
    assert$3($ !== V, "Expected versioned message but received legacy message");
    const J = V;
    assert$3(J === 0, `Expected versioned message with version 0 but found version ${J}`);
    const ee = {
      numRequiredSignatures: guardedShift(T),
      numReadonlySignedAccounts: guardedShift(T),
      numReadonlyUnsignedAccounts: guardedShift(T)
    }, te = [], re = decodeLength(T);
    for (let he = 0; he < re; he++)
      te.push(new PublicKey(guardedSplice(T, 0, PUBLIC_KEY_LENGTH)));
    const ie = bs58$6.encode(guardedSplice(T, 0, PUBLIC_KEY_LENGTH)), se = decodeLength(T), de = [];
    for (let he = 0; he < se; he++) {
      const me = guardedShift(T), xe = decodeLength(T), ve = guardedSplice(T, 0, xe), Te = decodeLength(T), we = new Uint8Array(guardedSplice(T, 0, Te));
      de.push({
        programIdIndex: me,
        accountKeyIndexes: ve,
        data: we
      });
    }
    const ue = decodeLength(T), fe = [];
    for (let he = 0; he < ue; he++) {
      const me = new PublicKey(guardedSplice(T, 0, PUBLIC_KEY_LENGTH)), xe = decodeLength(T), ve = guardedSplice(T, 0, xe), Te = decodeLength(T), we = guardedSplice(T, 0, Te);
      fe.push({
        accountKey: me,
        writableIndexes: ve,
        readonlyIndexes: we
      });
    }
    return new MessageV0({
      header: ee,
      staticAccountKeys: te,
      recentBlockhash: ie,
      compiledInstructions: de,
      addressTableLookups: fe
    });
  }
}
const VersionedMessage = {
  deserializeMessageVersion(C) {
    const e = C[0], T = e & VERSION_PREFIX_MASK;
    return T === e ? "legacy" : T;
  },
  deserialize: (C) => {
    const e = VersionedMessage.deserializeMessageVersion(C);
    if (e === "legacy")
      return Message.from(C);
    if (e === 0)
      return MessageV0.deserialize(C);
    throw new Error(`Transaction message version ${e} deserialization is not supported`);
  }
};
let TransactionStatus = /* @__PURE__ */ function(C) {
  return C[C.BLOCKHEIGHT_EXCEEDED = 0] = "BLOCKHEIGHT_EXCEEDED", C[C.PROCESSED = 1] = "PROCESSED", C[C.TIMED_OUT = 2] = "TIMED_OUT", C[C.NONCE_INVALID = 3] = "NONCE_INVALID", C;
}({});
const DEFAULT_SIGNATURE = bufferPolyfill.Buffer.alloc(SIGNATURE_LENGTH_IN_BYTES).fill(0);
class TransactionInstruction {
  constructor(e) {
    this.keys = void 0, this.programId = void 0, this.data = bufferPolyfill.Buffer.alloc(0), this.programId = e.programId, this.keys = e.keys, e.data && (this.data = e.data);
  }
  /**
   * @internal
   */
  toJSON() {
    return {
      keys: this.keys.map(({
        pubkey: e,
        isSigner: T,
        isWritable: $
      }) => ({
        pubkey: e.toJSON(),
        isSigner: T,
        isWritable: $
      })),
      programId: this.programId.toJSON(),
      data: [...this.data]
    };
  }
}
class Transaction {
  /**
   * The first (payer) Transaction signature
   *
   * @returns {Buffer | null} Buffer of payer's signature
   */
  get signature() {
    return this.signatures.length > 0 ? this.signatures[0].signature : null;
  }
  /**
   * The transaction fee payer
   */
  // Construct a transaction with a blockhash and lastValidBlockHeight
  // Construct a transaction using a durable nonce
  /**
   * @deprecated `TransactionCtorFields` has been deprecated and will be removed in a future version.
   * Please supply a `TransactionBlockhashCtor` instead.
   */
  /**
   * Construct an empty Transaction
   */
  constructor(e) {
    if (this.signatures = [], this.feePayer = void 0, this.instructions = [], this.recentBlockhash = void 0, this.lastValidBlockHeight = void 0, this.nonceInfo = void 0, this.minNonceContextSlot = void 0, this._message = void 0, this._json = void 0, !!e)
      if (e.feePayer && (this.feePayer = e.feePayer), e.signatures && (this.signatures = e.signatures), Object.prototype.hasOwnProperty.call(e, "nonceInfo")) {
        const {
          minContextSlot: T,
          nonceInfo: $
        } = e;
        this.minNonceContextSlot = T, this.nonceInfo = $;
      } else if (Object.prototype.hasOwnProperty.call(e, "lastValidBlockHeight")) {
        const {
          blockhash: T,
          lastValidBlockHeight: $
        } = e;
        this.recentBlockhash = T, this.lastValidBlockHeight = $;
      } else {
        const {
          recentBlockhash: T,
          nonceInfo: $
        } = e;
        $ && (this.nonceInfo = $), this.recentBlockhash = T;
      }
  }
  /**
   * @internal
   */
  toJSON() {
    return {
      recentBlockhash: this.recentBlockhash || null,
      feePayer: this.feePayer ? this.feePayer.toJSON() : null,
      nonceInfo: this.nonceInfo ? {
        nonce: this.nonceInfo.nonce,
        nonceInstruction: this.nonceInfo.nonceInstruction.toJSON()
      } : null,
      instructions: this.instructions.map((e) => e.toJSON()),
      signers: this.signatures.map(({
        publicKey: e
      }) => e.toJSON())
    };
  }
  /**
   * Add one or more instructions to this Transaction
   *
   * @param {Array< Transaction | TransactionInstruction | TransactionInstructionCtorFields >} items - Instructions to add to the Transaction
   */
  add(...e) {
    if (e.length === 0)
      throw new Error("No instructions");
    return e.forEach((T) => {
      "instructions" in T ? this.instructions = this.instructions.concat(T.instructions) : "data" in T && "programId" in T && "keys" in T ? this.instructions.push(T) : this.instructions.push(new TransactionInstruction(T));
    }), this;
  }
  /**
   * Compile transaction data
   */
  compileMessage() {
    if (this._message && JSON.stringify(this.toJSON()) === JSON.stringify(this._json))
      return this._message;
    let e, T;
    if (this.nonceInfo ? (e = this.nonceInfo.nonce, this.instructions[0] != this.nonceInfo.nonceInstruction ? T = [this.nonceInfo.nonceInstruction, ...this.instructions] : T = this.instructions) : (e = this.recentBlockhash, T = this.instructions), !e)
      throw new Error("Transaction recentBlockhash required");
    T.length < 1 && console.warn("No instructions provided");
    let $;
    if (this.feePayer)
      $ = this.feePayer;
    else if (this.signatures.length > 0 && this.signatures[0].publicKey)
      $ = this.signatures[0].publicKey;
    else
      throw new Error("Transaction fee payer required");
    for (let me = 0; me < T.length; me++)
      if (T[me].programId === void 0)
        throw new Error(`Transaction instruction index ${me} has undefined program id`);
    const V = [], J = [];
    T.forEach((me) => {
      me.keys.forEach((ve) => {
        J.push({
          ...ve
        });
      });
      const xe = me.programId.toString();
      V.includes(xe) || V.push(xe);
    }), V.forEach((me) => {
      J.push({
        pubkey: new PublicKey(me),
        isSigner: !1,
        isWritable: !1
      });
    });
    const ee = [];
    J.forEach((me) => {
      const xe = me.pubkey.toString(), ve = ee.findIndex((Te) => Te.pubkey.toString() === xe);
      ve > -1 ? (ee[ve].isWritable = ee[ve].isWritable || me.isWritable, ee[ve].isSigner = ee[ve].isSigner || me.isSigner) : ee.push(me);
    }), ee.sort(function(me, xe) {
      if (me.isSigner !== xe.isSigner)
        return me.isSigner ? -1 : 1;
      if (me.isWritable !== xe.isWritable)
        return me.isWritable ? -1 : 1;
      const ve = {
        localeMatcher: "best fit",
        usage: "sort",
        sensitivity: "variant",
        ignorePunctuation: !1,
        numeric: !1,
        caseFirst: "lower"
      };
      return me.pubkey.toBase58().localeCompare(xe.pubkey.toBase58(), "en", ve);
    });
    const te = ee.findIndex((me) => me.pubkey.equals($));
    if (te > -1) {
      const [me] = ee.splice(te, 1);
      me.isSigner = !0, me.isWritable = !0, ee.unshift(me);
    } else
      ee.unshift({
        pubkey: $,
        isSigner: !0,
        isWritable: !0
      });
    for (const me of this.signatures) {
      const xe = ee.findIndex((ve) => ve.pubkey.equals(me.publicKey));
      if (xe > -1)
        ee[xe].isSigner || (ee[xe].isSigner = !0, console.warn("Transaction references a signature that is unnecessary, only the fee payer and instruction signer accounts should sign a transaction. This behavior is deprecated and will throw an error in the next major version release."));
      else
        throw new Error(`unknown signer: ${me.publicKey.toString()}`);
    }
    let re = 0, ie = 0, se = 0;
    const de = [], ue = [];
    ee.forEach(({
      pubkey: me,
      isSigner: xe,
      isWritable: ve
    }) => {
      xe ? (de.push(me.toString()), re += 1, ve || (ie += 1)) : (ue.push(me.toString()), ve || (se += 1));
    });
    const fe = de.concat(ue), he = T.map((me) => {
      const {
        data: xe,
        programId: ve
      } = me;
      return {
        programIdIndex: fe.indexOf(ve.toString()),
        accounts: me.keys.map((Te) => fe.indexOf(Te.pubkey.toString())),
        data: bs58$6.encode(xe)
      };
    });
    return he.forEach((me) => {
      assert$3(me.programIdIndex >= 0), me.accounts.forEach((xe) => assert$3(xe >= 0));
    }), new Message({
      header: {
        numRequiredSignatures: re,
        numReadonlySignedAccounts: ie,
        numReadonlyUnsignedAccounts: se
      },
      accountKeys: fe,
      recentBlockhash: e,
      instructions: he
    });
  }
  /**
   * @internal
   */
  _compile() {
    const e = this.compileMessage(), T = e.accountKeys.slice(0, e.header.numRequiredSignatures);
    return this.signatures.length === T.length && this.signatures.every((V, J) => T[J].equals(V.publicKey)) || (this.signatures = T.map(($) => ({
      signature: null,
      publicKey: $
    }))), e;
  }
  /**
   * Get a buffer of the Transaction data that need to be covered by signatures
   */
  serializeMessage() {
    return this._compile().serialize();
  }
  /**
   * Get the estimated fee associated with a transaction
   *
   * @param {Connection} connection Connection to RPC Endpoint.
   *
   * @returns {Promise<number | null>} The estimated fee for the transaction
   */
  async getEstimatedFee(e) {
    return (await e.getFeeForMessage(this.compileMessage())).value;
  }
  /**
   * Specify the public keys which will be used to sign the Transaction.
   * The first signer will be used as the transaction fee payer account.
   *
   * Signatures can be added with either `partialSign` or `addSignature`
   *
   * @deprecated Deprecated since v0.84.0. Only the fee payer needs to be
   * specified and it can be set in the Transaction constructor or with the
   * `feePayer` property.
   */
  setSigners(...e) {
    if (e.length === 0)
      throw new Error("No signers");
    const T = /* @__PURE__ */ new Set();
    this.signatures = e.filter(($) => {
      const V = $.toString();
      return T.has(V) ? !1 : (T.add(V), !0);
    }).map(($) => ({
      signature: null,
      publicKey: $
    }));
  }
  /**
   * Sign the Transaction with the specified signers. Multiple signatures may
   * be applied to a Transaction. The first signature is considered "primary"
   * and is used identify and confirm transactions.
   *
   * If the Transaction `feePayer` is not set, the first signer will be used
   * as the transaction fee payer account.
   *
   * Transaction fields should not be modified after the first call to `sign`,
   * as doing so may invalidate the signature and cause the Transaction to be
   * rejected.
   *
   * The Transaction must be assigned a valid `recentBlockhash` before invoking this method
   *
   * @param {Array<Signer>} signers Array of signers that will sign the transaction
   */
  sign(...e) {
    if (e.length === 0)
      throw new Error("No signers");
    const T = /* @__PURE__ */ new Set(), $ = [];
    for (const J of e) {
      const ee = J.publicKey.toString();
      T.has(ee) || (T.add(ee), $.push(J));
    }
    this.signatures = $.map((J) => ({
      signature: null,
      publicKey: J.publicKey
    }));
    const V = this._compile();
    this._partialSign(V, ...$);
  }
  /**
   * Partially sign a transaction with the specified accounts. All accounts must
   * correspond to either the fee payer or a signer account in the transaction
   * instructions.
   *
   * All the caveats from the `sign` method apply to `partialSign`
   *
   * @param {Array<Signer>} signers Array of signers that will sign the transaction
   */
  partialSign(...e) {
    if (e.length === 0)
      throw new Error("No signers");
    const T = /* @__PURE__ */ new Set(), $ = [];
    for (const J of e) {
      const ee = J.publicKey.toString();
      T.has(ee) || (T.add(ee), $.push(J));
    }
    const V = this._compile();
    this._partialSign(V, ...$);
  }
  /**
   * @internal
   */
  _partialSign(e, ...T) {
    const $ = e.serialize();
    T.forEach((V) => {
      const J = sign($, V.secretKey);
      this._addSignature(V.publicKey, toBuffer(J));
    });
  }
  /**
   * Add an externally created signature to a transaction. The public key
   * must correspond to either the fee payer or a signer account in the transaction
   * instructions.
   *
   * @param {PublicKey} pubkey Public key that will be added to the transaction.
   * @param {Buffer} signature An externally created signature to add to the transaction.
   */
  addSignature(e, T) {
    this._compile(), this._addSignature(e, T);
  }
  /**
   * @internal
   */
  _addSignature(e, T) {
    assert$3(T.length === 64);
    const $ = this.signatures.findIndex((V) => e.equals(V.publicKey));
    if ($ < 0)
      throw new Error(`unknown signer: ${e.toString()}`);
    this.signatures[$].signature = bufferPolyfill.Buffer.from(T);
  }
  /**
   * Verify signatures of a Transaction
   * Optional parameter specifies if we're expecting a fully signed Transaction or a partially signed one.
   * If no boolean is provided, we expect a fully signed Transaction by default.
   *
   * @param {boolean} [requireAllSignatures=true] Require a fully signed Transaction
   */
  verifySignatures(e = !0) {
    return !this._getMessageSignednessErrors(this.serializeMessage(), e);
  }
  /**
   * @internal
   */
  _getMessageSignednessErrors(e, T) {
    const $ = {};
    for (const {
      signature: V,
      publicKey: J
    } of this.signatures)
      V === null ? T && ($.missing || ($.missing = [])).push(J) : verify(V, e, J.toBytes()) || ($.invalid || ($.invalid = [])).push(J);
    return $.invalid || $.missing ? $ : void 0;
  }
  /**
   * Serialize the Transaction in the wire format.
   *
   * @param {Buffer} [config] Config of transaction.
   *
   * @returns {Buffer} Signature of transaction in wire format.
   */
  serialize(e) {
    const {
      requireAllSignatures: T,
      verifySignatures: $
    } = Object.assign({
      requireAllSignatures: !0,
      verifySignatures: !0
    }, e), V = this.serializeMessage();
    if ($) {
      const J = this._getMessageSignednessErrors(V, T);
      if (J) {
        let ee = "Signature verification failed.";
        throw J.invalid && (ee += `
Invalid signature for public key${J.invalid.length === 1 ? "" : "(s)"} [\`${J.invalid.map((te) => te.toBase58()).join("`, `")}\`].`), J.missing && (ee += `
Missing signature for public key${J.missing.length === 1 ? "" : "(s)"} [\`${J.missing.map((te) => te.toBase58()).join("`, `")}\`].`), new Error(ee);
      }
    }
    return this._serialize(V);
  }
  /**
   * @internal
   */
  _serialize(e) {
    const {
      signatures: T
    } = this, $ = [];
    encodeLength($, T.length);
    const V = $.length + T.length * 64 + e.length, J = bufferPolyfill.Buffer.alloc(V);
    return assert$3(T.length < 256), bufferPolyfill.Buffer.from($).copy(J, 0), T.forEach(({
      signature: ee
    }, te) => {
      ee !== null && (assert$3(ee.length === 64, "signature has invalid length"), bufferPolyfill.Buffer.from(ee).copy(J, $.length + te * 64));
    }), e.copy(J, $.length + T.length * 64), assert$3(J.length <= PACKET_DATA_SIZE, `Transaction too large: ${J.length} > ${PACKET_DATA_SIZE}`), J;
  }
  /**
   * Deprecated method
   * @internal
   */
  get keys() {
    return assert$3(this.instructions.length === 1), this.instructions[0].keys.map((e) => e.pubkey);
  }
  /**
   * Deprecated method
   * @internal
   */
  get programId() {
    return assert$3(this.instructions.length === 1), this.instructions[0].programId;
  }
  /**
   * Deprecated method
   * @internal
   */
  get data() {
    return assert$3(this.instructions.length === 1), this.instructions[0].data;
  }
  /**
   * Parse a wire transaction into a Transaction object.
   *
   * @param {Buffer | Uint8Array | Array<number>} buffer Signature of wire Transaction
   *
   * @returns {Transaction} Transaction associated with the signature
   */
  static from(e) {
    let T = [...e];
    const $ = decodeLength(T);
    let V = [];
    for (let J = 0; J < $; J++) {
      const ee = guardedSplice(T, 0, SIGNATURE_LENGTH_IN_BYTES);
      V.push(bs58$6.encode(bufferPolyfill.Buffer.from(ee)));
    }
    return Transaction.populate(Message.from(T), V);
  }
  /**
   * Populate Transaction object from message and signatures
   *
   * @param {Message} message Message of transaction
   * @param {Array<string>} signatures List of signatures to assign to the transaction
   *
   * @returns {Transaction} The populated Transaction
   */
  static populate(e, T = []) {
    const $ = new Transaction();
    return $.recentBlockhash = e.recentBlockhash, e.header.numRequiredSignatures > 0 && ($.feePayer = e.accountKeys[0]), T.forEach((V, J) => {
      const ee = {
        signature: V == bs58$6.encode(DEFAULT_SIGNATURE) ? null : bs58$6.decode(V),
        publicKey: e.accountKeys[J]
      };
      $.signatures.push(ee);
    }), e.instructions.forEach((V) => {
      const J = V.accounts.map((ee) => {
        const te = e.accountKeys[ee];
        return {
          pubkey: te,
          isSigner: $.signatures.some((re) => re.publicKey.toString() === te.toString()) || e.isAccountSigner(ee),
          isWritable: e.isAccountWritable(ee)
        };
      });
      $.instructions.push(new TransactionInstruction({
        keys: J,
        programId: e.accountKeys[V.programIdIndex],
        data: bs58$6.decode(V.data)
      }));
    }), $._message = e, $._json = $.toJSON(), $;
  }
}
class TransactionMessage {
  constructor(e) {
    this.payerKey = void 0, this.instructions = void 0, this.recentBlockhash = void 0, this.payerKey = e.payerKey, this.instructions = e.instructions, this.recentBlockhash = e.recentBlockhash;
  }
  static decompile(e, T) {
    const {
      header: $,
      compiledInstructions: V,
      recentBlockhash: J
    } = e, {
      numRequiredSignatures: ee,
      numReadonlySignedAccounts: te,
      numReadonlyUnsignedAccounts: re
    } = $, ie = ee - te;
    assert$3(ie > 0, "Message header is invalid");
    const se = e.staticAccountKeys.length - ee - re;
    assert$3(se >= 0, "Message header is invalid");
    const de = e.getAccountKeys(T), ue = de.get(0);
    if (ue === void 0)
      throw new Error("Failed to decompile message because no account keys were found");
    const fe = [];
    for (const he of V) {
      const me = [];
      for (const ve of he.accountKeyIndexes) {
        const Te = de.get(ve);
        if (Te === void 0)
          throw new Error(`Failed to find key for account key index ${ve}`);
        const we = ve < ee;
        let Ee;
        we ? Ee = ve < ie : ve < de.staticAccountKeys.length ? Ee = ve - ee < se : Ee = ve - de.staticAccountKeys.length < // accountKeysFromLookups cannot be undefined because we already found a pubkey for this index above
        de.accountKeysFromLookups.writable.length, me.push({
          pubkey: Te,
          isSigner: ve < $.numRequiredSignatures,
          isWritable: Ee
        });
      }
      const xe = de.get(he.programIdIndex);
      if (xe === void 0)
        throw new Error(`Failed to find program id for program id index ${he.programIdIndex}`);
      fe.push(new TransactionInstruction({
        programId: xe,
        data: toBuffer(he.data),
        keys: me
      }));
    }
    return new TransactionMessage({
      payerKey: ue,
      instructions: fe,
      recentBlockhash: J
    });
  }
  compileToLegacyMessage() {
    return Message.compile({
      payerKey: this.payerKey,
      recentBlockhash: this.recentBlockhash,
      instructions: this.instructions
    });
  }
  compileToV0Message(e) {
    return MessageV0.compile({
      payerKey: this.payerKey,
      recentBlockhash: this.recentBlockhash,
      instructions: this.instructions,
      addressLookupTableAccounts: e
    });
  }
}
class VersionedTransaction {
  get version() {
    return this.message.version;
  }
  constructor(e, T) {
    if (this.signatures = void 0, this.message = void 0, T !== void 0)
      assert$3(T.length === e.header.numRequiredSignatures, "Expected signatures length to be equal to the number of required signatures"), this.signatures = T;
    else {
      const $ = [];
      for (let V = 0; V < e.header.numRequiredSignatures; V++)
        $.push(new Uint8Array(SIGNATURE_LENGTH_IN_BYTES));
      this.signatures = $;
    }
    this.message = e;
  }
  serialize() {
    const e = this.message.serialize(), T = Array();
    encodeLength(T, this.signatures.length);
    const $ = struct$1([blob$1(T.length, "encodedSignaturesLength"), seq(signature(), this.signatures.length, "signatures"), blob$1(e.length, "serializedMessage")]), V = new Uint8Array(2048), J = $.encode({
      encodedSignaturesLength: new Uint8Array(T),
      signatures: this.signatures,
      serializedMessage: e
    }, V);
    return V.slice(0, J);
  }
  static deserialize(e) {
    let T = [...e];
    const $ = [], V = decodeLength(T);
    for (let ee = 0; ee < V; ee++)
      $.push(new Uint8Array(guardedSplice(T, 0, SIGNATURE_LENGTH_IN_BYTES)));
    const J = VersionedMessage.deserialize(new Uint8Array(T));
    return new VersionedTransaction(J, $);
  }
  sign(e) {
    const T = this.message.serialize(), $ = this.message.staticAccountKeys.slice(0, this.message.header.numRequiredSignatures);
    for (const V of e) {
      const J = $.findIndex((ee) => ee.equals(V.publicKey));
      assert$3(J >= 0, `Cannot sign with non signer key ${V.publicKey.toBase58()}`), this.signatures[J] = sign(T, V.secretKey);
    }
  }
  addSignature(e, T) {
    assert$3(T.byteLength === 64, "Signature must be 64 bytes long");
    const V = this.message.staticAccountKeys.slice(0, this.message.header.numRequiredSignatures).findIndex((J) => J.equals(e));
    assert$3(V >= 0, `Can not add signature; \`${e.toBase58()}\` is not required to sign this transaction`), this.signatures[V] = T;
  }
}
const NUM_TICKS_PER_SECOND = 160, DEFAULT_TICKS_PER_SLOT = 64, NUM_SLOTS_PER_SECOND = NUM_TICKS_PER_SECOND / DEFAULT_TICKS_PER_SLOT, MS_PER_SLOT = 1e3 / NUM_SLOTS_PER_SECOND, SYSVAR_CLOCK_PUBKEY = new PublicKey("SysvarC1ock11111111111111111111111111111111"), SYSVAR_EPOCH_SCHEDULE_PUBKEY = new PublicKey("SysvarEpochSchedu1e111111111111111111111111"), SYSVAR_INSTRUCTIONS_PUBKEY = new PublicKey("Sysvar1nstructions1111111111111111111111111"), SYSVAR_RECENT_BLOCKHASHES_PUBKEY = new PublicKey("SysvarRecentB1ockHashes11111111111111111111"), SYSVAR_RENT_PUBKEY = new PublicKey("SysvarRent111111111111111111111111111111111"), SYSVAR_REWARDS_PUBKEY = new PublicKey("SysvarRewards111111111111111111111111111111"), SYSVAR_SLOT_HASHES_PUBKEY = new PublicKey("SysvarS1otHashes111111111111111111111111111"), SYSVAR_SLOT_HISTORY_PUBKEY = new PublicKey("SysvarS1otHistory11111111111111111111111111"), SYSVAR_STAKE_HISTORY_PUBKEY = new PublicKey("SysvarStakeHistory1111111111111111111111111");
class SendTransactionError extends Error {
  constructor({
    action: e,
    signature: T,
    transactionMessage: $,
    logs: V
  }) {
    const J = V ? `Logs: 
${JSON.stringify(V.slice(-10), null, 2)}. ` : "", ee = "\nCatch the `SendTransactionError` and call `getLogs()` on it for full details.";
    let te;
    switch (e) {
      case "send":
        te = `Transaction ${T} resulted in an error. 
${$}. ` + J + ee;
        break;
      case "simulate":
        te = `Simulation failed. 
Message: ${$}. 
` + J + ee;
        break;
      default:
        te = `Unknown action '${/* @__PURE__ */ ((re) => re)(e)}'`;
    }
    super(te), this.signature = void 0, this.transactionMessage = void 0, this.transactionLogs = void 0, this.signature = T, this.transactionMessage = $, this.transactionLogs = V || void 0;
  }
  get transactionError() {
    return {
      message: this.transactionMessage,
      logs: Array.isArray(this.transactionLogs) ? this.transactionLogs : void 0
    };
  }
  /* @deprecated Use `await getLogs()` instead */
  get logs() {
    const e = this.transactionLogs;
    if (!(e != null && typeof e == "object" && "then" in e))
      return e;
  }
  async getLogs(e) {
    return Array.isArray(this.transactionLogs) || (this.transactionLogs = new Promise((T, $) => {
      e.getTransaction(this.signature).then((V) => {
        if (V && V.meta && V.meta.logMessages) {
          const J = V.meta.logMessages;
          this.transactionLogs = J, T(J);
        } else
          $(new Error("Log messages not found"));
      }).catch($);
    })), await this.transactionLogs;
  }
}
const SolanaJSONRPCErrorCode = {
  JSON_RPC_SERVER_ERROR_BLOCK_CLEANED_UP: -32001,
  JSON_RPC_SERVER_ERROR_SEND_TRANSACTION_PREFLIGHT_FAILURE: -32002,
  JSON_RPC_SERVER_ERROR_TRANSACTION_SIGNATURE_VERIFICATION_FAILURE: -32003,
  JSON_RPC_SERVER_ERROR_BLOCK_NOT_AVAILABLE: -32004,
  JSON_RPC_SERVER_ERROR_NODE_UNHEALTHY: -32005,
  JSON_RPC_SERVER_ERROR_TRANSACTION_PRECOMPILE_VERIFICATION_FAILURE: -32006,
  JSON_RPC_SERVER_ERROR_SLOT_SKIPPED: -32007,
  JSON_RPC_SERVER_ERROR_NO_SNAPSHOT: -32008,
  JSON_RPC_SERVER_ERROR_LONG_TERM_STORAGE_SLOT_SKIPPED: -32009,
  JSON_RPC_SERVER_ERROR_KEY_EXCLUDED_FROM_SECONDARY_INDEX: -32010,
  JSON_RPC_SERVER_ERROR_TRANSACTION_HISTORY_NOT_AVAILABLE: -32011,
  JSON_RPC_SCAN_ERROR: -32012,
  JSON_RPC_SERVER_ERROR_TRANSACTION_SIGNATURE_LEN_MISMATCH: -32013,
  JSON_RPC_SERVER_ERROR_BLOCK_STATUS_NOT_AVAILABLE_YET: -32014,
  JSON_RPC_SERVER_ERROR_UNSUPPORTED_TRANSACTION_VERSION: -32015,
  JSON_RPC_SERVER_ERROR_MIN_CONTEXT_SLOT_NOT_REACHED: -32016
};
class SolanaJSONRPCError extends Error {
  constructor({
    code: e,
    message: T,
    data: $
  }, V) {
    super(V != null ? `${V}: ${T}` : T), this.code = void 0, this.data = void 0, this.code = e, this.data = $, this.name = "SolanaJSONRPCError";
  }
}
async function sendAndConfirmTransaction(C, e, T, $) {
  const V = $ && {
    skipPreflight: $.skipPreflight,
    preflightCommitment: $.preflightCommitment || $.commitment,
    maxRetries: $.maxRetries,
    minContextSlot: $.minContextSlot
  }, J = await C.sendTransaction(e, T, V);
  let ee;
  if (e.recentBlockhash != null && e.lastValidBlockHeight != null)
    ee = (await C.confirmTransaction({
      abortSignal: $ == null ? void 0 : $.abortSignal,
      signature: J,
      blockhash: e.recentBlockhash,
      lastValidBlockHeight: e.lastValidBlockHeight
    }, $ && $.commitment)).value;
  else if (e.minNonceContextSlot != null && e.nonceInfo != null) {
    const {
      nonceInstruction: te
    } = e.nonceInfo, re = te.keys[0].pubkey;
    ee = (await C.confirmTransaction({
      abortSignal: $ == null ? void 0 : $.abortSignal,
      minContextSlot: e.minNonceContextSlot,
      nonceAccountPubkey: re,
      nonceValue: e.nonceInfo.nonce,
      signature: J
    }, $ && $.commitment)).value;
  } else
    ($ == null ? void 0 : $.abortSignal) != null && console.warn("sendAndConfirmTransaction(): A transaction with a deprecated confirmation strategy was supplied along with an `abortSignal`. Only transactions having `lastValidBlockHeight` or a combination of `nonceInfo` and `minNonceContextSlot` are abortable."), ee = (await C.confirmTransaction(J, $ && $.commitment)).value;
  if (ee.err)
    throw J != null ? new SendTransactionError({
      action: "send",
      signature: J,
      transactionMessage: `Status: (${JSON.stringify(ee)})`
    }) : new Error(`Transaction ${J} failed (${JSON.stringify(ee)})`);
  return J;
}
function sleep$1(C) {
  return new Promise((e) => setTimeout(e, C));
}
function encodeData(C, e) {
  const T = C.layout.span >= 0 ? C.layout.span : getAlloc(C, e), $ = bufferPolyfill.Buffer.alloc(T), V = Object.assign({
    instruction: C.index
  }, e);
  return C.layout.encode(V, $), $;
}
function decodeData$1(C, e) {
  let T;
  try {
    T = C.layout.decode(e);
  } catch ($) {
    throw new Error("invalid instruction; " + $);
  }
  if (T.instruction !== C.index)
    throw new Error(`invalid instruction; instruction index mismatch ${T.instruction} != ${C.index}`);
  return T;
}
const FeeCalculatorLayout = nu64$1("lamportsPerSignature"), NonceAccountLayout = struct$1([u32$1("version"), u32$1("state"), publicKey$4("authorizedPubkey"), publicKey$4("nonce"), struct$1([FeeCalculatorLayout], "feeCalculator")]), NONCE_ACCOUNT_LENGTH = NonceAccountLayout.span;
class NonceAccount {
  /**
   * @internal
   */
  constructor(e) {
    this.authorizedPubkey = void 0, this.nonce = void 0, this.feeCalculator = void 0, this.authorizedPubkey = e.authorizedPubkey, this.nonce = e.nonce, this.feeCalculator = e.feeCalculator;
  }
  /**
   * Deserialize NonceAccount from the account data.
   *
   * @param buffer account data
   * @return NonceAccount
   */
  static fromAccountData(e) {
    const T = NonceAccountLayout.decode(toBuffer(e), 0);
    return new NonceAccount({
      authorizedPubkey: new PublicKey(T.authorizedPubkey),
      nonce: new PublicKey(T.nonce).toString(),
      feeCalculator: T.feeCalculator
    });
  }
}
const encodeDecode$1 = (C) => {
  const e = C.decode.bind(C), T = C.encode.bind(C);
  return {
    decode: e,
    encode: T
  };
}, bigInt$1 = (C) => (e) => {
  const T = blob$1(C, e), {
    encode: $,
    decode: V
  } = encodeDecode$1(T), J = T;
  return J.decode = (ee, te) => {
    const re = V(ee, te);
    return toBigIntLE_1(bufferPolyfill.Buffer.from(re));
  }, J.encode = (ee, te, re) => {
    const ie = toBufferLE_1(ee, C);
    return $(ie, te, re);
  }, J;
}, u64$2 = bigInt$1(8);
class SystemInstruction {
  /**
   * @internal
   */
  constructor() {
  }
  /**
   * Decode a system instruction and retrieve the instruction type.
   */
  static decodeInstructionType(e) {
    this.checkProgramId(e.programId);
    const $ = u32$1("instruction").decode(e.data);
    let V;
    for (const [J, ee] of Object.entries(SYSTEM_INSTRUCTION_LAYOUTS))
      if (ee.index == $) {
        V = J;
        break;
      }
    if (!V)
      throw new Error("Instruction type incorrect; not a SystemInstruction");
    return V;
  }
  /**
   * Decode a create account system instruction and retrieve the instruction params.
   */
  static decodeCreateAccount(e) {
    this.checkProgramId(e.programId), this.checkKeyLength(e.keys, 2);
    const {
      lamports: T,
      space: $,
      programId: V
    } = decodeData$1(SYSTEM_INSTRUCTION_LAYOUTS.Create, e.data);
    return {
      fromPubkey: e.keys[0].pubkey,
      newAccountPubkey: e.keys[1].pubkey,
      lamports: T,
      space: $,
      programId: new PublicKey(V)
    };
  }
  /**
   * Decode a transfer system instruction and retrieve the instruction params.
   */
  static decodeTransfer(e) {
    this.checkProgramId(e.programId), this.checkKeyLength(e.keys, 2);
    const {
      lamports: T
    } = decodeData$1(SYSTEM_INSTRUCTION_LAYOUTS.Transfer, e.data);
    return {
      fromPubkey: e.keys[0].pubkey,
      toPubkey: e.keys[1].pubkey,
      lamports: T
    };
  }
  /**
   * Decode a transfer with seed system instruction and retrieve the instruction params.
   */
  static decodeTransferWithSeed(e) {
    this.checkProgramId(e.programId), this.checkKeyLength(e.keys, 3);
    const {
      lamports: T,
      seed: $,
      programId: V
    } = decodeData$1(SYSTEM_INSTRUCTION_LAYOUTS.TransferWithSeed, e.data);
    return {
      fromPubkey: e.keys[0].pubkey,
      basePubkey: e.keys[1].pubkey,
      toPubkey: e.keys[2].pubkey,
      lamports: T,
      seed: $,
      programId: new PublicKey(V)
    };
  }
  /**
   * Decode an allocate system instruction and retrieve the instruction params.
   */
  static decodeAllocate(e) {
    this.checkProgramId(e.programId), this.checkKeyLength(e.keys, 1);
    const {
      space: T
    } = decodeData$1(SYSTEM_INSTRUCTION_LAYOUTS.Allocate, e.data);
    return {
      accountPubkey: e.keys[0].pubkey,
      space: T
    };
  }
  /**
   * Decode an allocate with seed system instruction and retrieve the instruction params.
   */
  static decodeAllocateWithSeed(e) {
    this.checkProgramId(e.programId), this.checkKeyLength(e.keys, 1);
    const {
      base: T,
      seed: $,
      space: V,
      programId: J
    } = decodeData$1(SYSTEM_INSTRUCTION_LAYOUTS.AllocateWithSeed, e.data);
    return {
      accountPubkey: e.keys[0].pubkey,
      basePubkey: new PublicKey(T),
      seed: $,
      space: V,
      programId: new PublicKey(J)
    };
  }
  /**
   * Decode an assign system instruction and retrieve the instruction params.
   */
  static decodeAssign(e) {
    this.checkProgramId(e.programId), this.checkKeyLength(e.keys, 1);
    const {
      programId: T
    } = decodeData$1(SYSTEM_INSTRUCTION_LAYOUTS.Assign, e.data);
    return {
      accountPubkey: e.keys[0].pubkey,
      programId: new PublicKey(T)
    };
  }
  /**
   * Decode an assign with seed system instruction and retrieve the instruction params.
   */
  static decodeAssignWithSeed(e) {
    this.checkProgramId(e.programId), this.checkKeyLength(e.keys, 1);
    const {
      base: T,
      seed: $,
      programId: V
    } = decodeData$1(SYSTEM_INSTRUCTION_LAYOUTS.AssignWithSeed, e.data);
    return {
      accountPubkey: e.keys[0].pubkey,
      basePubkey: new PublicKey(T),
      seed: $,
      programId: new PublicKey(V)
    };
  }
  /**
   * Decode a create account with seed system instruction and retrieve the instruction params.
   */
  static decodeCreateWithSeed(e) {
    this.checkProgramId(e.programId), this.checkKeyLength(e.keys, 2);
    const {
      base: T,
      seed: $,
      lamports: V,
      space: J,
      programId: ee
    } = decodeData$1(SYSTEM_INSTRUCTION_LAYOUTS.CreateWithSeed, e.data);
    return {
      fromPubkey: e.keys[0].pubkey,
      newAccountPubkey: e.keys[1].pubkey,
      basePubkey: new PublicKey(T),
      seed: $,
      lamports: V,
      space: J,
      programId: new PublicKey(ee)
    };
  }
  /**
   * Decode a nonce initialize system instruction and retrieve the instruction params.
   */
  static decodeNonceInitialize(e) {
    this.checkProgramId(e.programId), this.checkKeyLength(e.keys, 3);
    const {
      authorized: T
    } = decodeData$1(SYSTEM_INSTRUCTION_LAYOUTS.InitializeNonceAccount, e.data);
    return {
      noncePubkey: e.keys[0].pubkey,
      authorizedPubkey: new PublicKey(T)
    };
  }
  /**
   * Decode a nonce advance system instruction and retrieve the instruction params.
   */
  static decodeNonceAdvance(e) {
    return this.checkProgramId(e.programId), this.checkKeyLength(e.keys, 3), decodeData$1(SYSTEM_INSTRUCTION_LAYOUTS.AdvanceNonceAccount, e.data), {
      noncePubkey: e.keys[0].pubkey,
      authorizedPubkey: e.keys[2].pubkey
    };
  }
  /**
   * Decode a nonce withdraw system instruction and retrieve the instruction params.
   */
  static decodeNonceWithdraw(e) {
    this.checkProgramId(e.programId), this.checkKeyLength(e.keys, 5);
    const {
      lamports: T
    } = decodeData$1(SYSTEM_INSTRUCTION_LAYOUTS.WithdrawNonceAccount, e.data);
    return {
      noncePubkey: e.keys[0].pubkey,
      toPubkey: e.keys[1].pubkey,
      authorizedPubkey: e.keys[4].pubkey,
      lamports: T
    };
  }
  /**
   * Decode a nonce authorize system instruction and retrieve the instruction params.
   */
  static decodeNonceAuthorize(e) {
    this.checkProgramId(e.programId), this.checkKeyLength(e.keys, 2);
    const {
      authorized: T
    } = decodeData$1(SYSTEM_INSTRUCTION_LAYOUTS.AuthorizeNonceAccount, e.data);
    return {
      noncePubkey: e.keys[0].pubkey,
      authorizedPubkey: e.keys[1].pubkey,
      newAuthorizedPubkey: new PublicKey(T)
    };
  }
  /**
   * @internal
   */
  static checkProgramId(e) {
    if (!e.equals(SystemProgram.programId))
      throw new Error("invalid instruction; programId is not SystemProgram");
  }
  /**
   * @internal
   */
  static checkKeyLength(e, T) {
    if (e.length < T)
      throw new Error(`invalid instruction; found ${e.length} keys, expected at least ${T}`);
  }
}
const SYSTEM_INSTRUCTION_LAYOUTS = Object.freeze({
  Create: {
    index: 0,
    layout: struct$1([u32$1("instruction"), ns64$1("lamports"), ns64$1("space"), publicKey$4("programId")])
  },
  Assign: {
    index: 1,
    layout: struct$1([u32$1("instruction"), publicKey$4("programId")])
  },
  Transfer: {
    index: 2,
    layout: struct$1([u32$1("instruction"), u64$2("lamports")])
  },
  CreateWithSeed: {
    index: 3,
    layout: struct$1([u32$1("instruction"), publicKey$4("base"), rustString("seed"), ns64$1("lamports"), ns64$1("space"), publicKey$4("programId")])
  },
  AdvanceNonceAccount: {
    index: 4,
    layout: struct$1([u32$1("instruction")])
  },
  WithdrawNonceAccount: {
    index: 5,
    layout: struct$1([u32$1("instruction"), ns64$1("lamports")])
  },
  InitializeNonceAccount: {
    index: 6,
    layout: struct$1([u32$1("instruction"), publicKey$4("authorized")])
  },
  AuthorizeNonceAccount: {
    index: 7,
    layout: struct$1([u32$1("instruction"), publicKey$4("authorized")])
  },
  Allocate: {
    index: 8,
    layout: struct$1([u32$1("instruction"), ns64$1("space")])
  },
  AllocateWithSeed: {
    index: 9,
    layout: struct$1([u32$1("instruction"), publicKey$4("base"), rustString("seed"), ns64$1("space"), publicKey$4("programId")])
  },
  AssignWithSeed: {
    index: 10,
    layout: struct$1([u32$1("instruction"), publicKey$4("base"), rustString("seed"), publicKey$4("programId")])
  },
  TransferWithSeed: {
    index: 11,
    layout: struct$1([u32$1("instruction"), u64$2("lamports"), rustString("seed"), publicKey$4("programId")])
  },
  UpgradeNonceAccount: {
    index: 12,
    layout: struct$1([u32$1("instruction")])
  }
});
class SystemProgram {
  /**
   * @internal
   */
  constructor() {
  }
  /**
   * Public key that identifies the System program
   */
  /**
   * Generate a transaction instruction that creates a new account
   */
  static createAccount(e) {
    const T = SYSTEM_INSTRUCTION_LAYOUTS.Create, $ = encodeData(T, {
      lamports: e.lamports,
      space: e.space,
      programId: toBuffer(e.programId.toBuffer())
    });
    return new TransactionInstruction({
      keys: [{
        pubkey: e.fromPubkey,
        isSigner: !0,
        isWritable: !0
      }, {
        pubkey: e.newAccountPubkey,
        isSigner: !0,
        isWritable: !0
      }],
      programId: this.programId,
      data: $
    });
  }
  /**
   * Generate a transaction instruction that transfers lamports from one account to another
   */
  static transfer(e) {
    let T, $;
    if ("basePubkey" in e) {
      const V = SYSTEM_INSTRUCTION_LAYOUTS.TransferWithSeed;
      T = encodeData(V, {
        lamports: BigInt(e.lamports),
        seed: e.seed,
        programId: toBuffer(e.programId.toBuffer())
      }), $ = [{
        pubkey: e.fromPubkey,
        isSigner: !1,
        isWritable: !0
      }, {
        pubkey: e.basePubkey,
        isSigner: !0,
        isWritable: !1
      }, {
        pubkey: e.toPubkey,
        isSigner: !1,
        isWritable: !0
      }];
    } else {
      const V = SYSTEM_INSTRUCTION_LAYOUTS.Transfer;
      T = encodeData(V, {
        lamports: BigInt(e.lamports)
      }), $ = [{
        pubkey: e.fromPubkey,
        isSigner: !0,
        isWritable: !0
      }, {
        pubkey: e.toPubkey,
        isSigner: !1,
        isWritable: !0
      }];
    }
    return new TransactionInstruction({
      keys: $,
      programId: this.programId,
      data: T
    });
  }
  /**
   * Generate a transaction instruction that assigns an account to a program
   */
  static assign(e) {
    let T, $;
    if ("basePubkey" in e) {
      const V = SYSTEM_INSTRUCTION_LAYOUTS.AssignWithSeed;
      T = encodeData(V, {
        base: toBuffer(e.basePubkey.toBuffer()),
        seed: e.seed,
        programId: toBuffer(e.programId.toBuffer())
      }), $ = [{
        pubkey: e.accountPubkey,
        isSigner: !1,
        isWritable: !0
      }, {
        pubkey: e.basePubkey,
        isSigner: !0,
        isWritable: !1
      }];
    } else {
      const V = SYSTEM_INSTRUCTION_LAYOUTS.Assign;
      T = encodeData(V, {
        programId: toBuffer(e.programId.toBuffer())
      }), $ = [{
        pubkey: e.accountPubkey,
        isSigner: !0,
        isWritable: !0
      }];
    }
    return new TransactionInstruction({
      keys: $,
      programId: this.programId,
      data: T
    });
  }
  /**
   * Generate a transaction instruction that creates a new account at
   *   an address generated with `from`, a seed, and programId
   */
  static createAccountWithSeed(e) {
    const T = SYSTEM_INSTRUCTION_LAYOUTS.CreateWithSeed, $ = encodeData(T, {
      base: toBuffer(e.basePubkey.toBuffer()),
      seed: e.seed,
      lamports: e.lamports,
      space: e.space,
      programId: toBuffer(e.programId.toBuffer())
    });
    let V = [{
      pubkey: e.fromPubkey,
      isSigner: !0,
      isWritable: !0
    }, {
      pubkey: e.newAccountPubkey,
      isSigner: !1,
      isWritable: !0
    }];
    return e.basePubkey.equals(e.fromPubkey) || V.push({
      pubkey: e.basePubkey,
      isSigner: !0,
      isWritable: !1
    }), new TransactionInstruction({
      keys: V,
      programId: this.programId,
      data: $
    });
  }
  /**
   * Generate a transaction that creates a new Nonce account
   */
  static createNonceAccount(e) {
    const T = new Transaction();
    "basePubkey" in e && "seed" in e ? T.add(SystemProgram.createAccountWithSeed({
      fromPubkey: e.fromPubkey,
      newAccountPubkey: e.noncePubkey,
      basePubkey: e.basePubkey,
      seed: e.seed,
      lamports: e.lamports,
      space: NONCE_ACCOUNT_LENGTH,
      programId: this.programId
    })) : T.add(SystemProgram.createAccount({
      fromPubkey: e.fromPubkey,
      newAccountPubkey: e.noncePubkey,
      lamports: e.lamports,
      space: NONCE_ACCOUNT_LENGTH,
      programId: this.programId
    }));
    const $ = {
      noncePubkey: e.noncePubkey,
      authorizedPubkey: e.authorizedPubkey
    };
    return T.add(this.nonceInitialize($)), T;
  }
  /**
   * Generate an instruction to initialize a Nonce account
   */
  static nonceInitialize(e) {
    const T = SYSTEM_INSTRUCTION_LAYOUTS.InitializeNonceAccount, $ = encodeData(T, {
      authorized: toBuffer(e.authorizedPubkey.toBuffer())
    }), V = {
      keys: [{
        pubkey: e.noncePubkey,
        isSigner: !1,
        isWritable: !0
      }, {
        pubkey: SYSVAR_RECENT_BLOCKHASHES_PUBKEY,
        isSigner: !1,
        isWritable: !1
      }, {
        pubkey: SYSVAR_RENT_PUBKEY,
        isSigner: !1,
        isWritable: !1
      }],
      programId: this.programId,
      data: $
    };
    return new TransactionInstruction(V);
  }
  /**
   * Generate an instruction to advance the nonce in a Nonce account
   */
  static nonceAdvance(e) {
    const T = SYSTEM_INSTRUCTION_LAYOUTS.AdvanceNonceAccount, $ = encodeData(T), V = {
      keys: [{
        pubkey: e.noncePubkey,
        isSigner: !1,
        isWritable: !0
      }, {
        pubkey: SYSVAR_RECENT_BLOCKHASHES_PUBKEY,
        isSigner: !1,
        isWritable: !1
      }, {
        pubkey: e.authorizedPubkey,
        isSigner: !0,
        isWritable: !1
      }],
      programId: this.programId,
      data: $
    };
    return new TransactionInstruction(V);
  }
  /**
   * Generate a transaction instruction that withdraws lamports from a Nonce account
   */
  static nonceWithdraw(e) {
    const T = SYSTEM_INSTRUCTION_LAYOUTS.WithdrawNonceAccount, $ = encodeData(T, {
      lamports: e.lamports
    });
    return new TransactionInstruction({
      keys: [{
        pubkey: e.noncePubkey,
        isSigner: !1,
        isWritable: !0
      }, {
        pubkey: e.toPubkey,
        isSigner: !1,
        isWritable: !0
      }, {
        pubkey: SYSVAR_RECENT_BLOCKHASHES_PUBKEY,
        isSigner: !1,
        isWritable: !1
      }, {
        pubkey: SYSVAR_RENT_PUBKEY,
        isSigner: !1,
        isWritable: !1
      }, {
        pubkey: e.authorizedPubkey,
        isSigner: !0,
        isWritable: !1
      }],
      programId: this.programId,
      data: $
    });
  }
  /**
   * Generate a transaction instruction that authorizes a new PublicKey as the authority
   * on a Nonce account.
   */
  static nonceAuthorize(e) {
    const T = SYSTEM_INSTRUCTION_LAYOUTS.AuthorizeNonceAccount, $ = encodeData(T, {
      authorized: toBuffer(e.newAuthorizedPubkey.toBuffer())
    });
    return new TransactionInstruction({
      keys: [{
        pubkey: e.noncePubkey,
        isSigner: !1,
        isWritable: !0
      }, {
        pubkey: e.authorizedPubkey,
        isSigner: !0,
        isWritable: !1
      }],
      programId: this.programId,
      data: $
    });
  }
  /**
   * Generate a transaction instruction that allocates space in an account without funding
   */
  static allocate(e) {
    let T, $;
    if ("basePubkey" in e) {
      const V = SYSTEM_INSTRUCTION_LAYOUTS.AllocateWithSeed;
      T = encodeData(V, {
        base: toBuffer(e.basePubkey.toBuffer()),
        seed: e.seed,
        space: e.space,
        programId: toBuffer(e.programId.toBuffer())
      }), $ = [{
        pubkey: e.accountPubkey,
        isSigner: !1,
        isWritable: !0
      }, {
        pubkey: e.basePubkey,
        isSigner: !0,
        isWritable: !1
      }];
    } else {
      const V = SYSTEM_INSTRUCTION_LAYOUTS.Allocate;
      T = encodeData(V, {
        space: e.space
      }), $ = [{
        pubkey: e.accountPubkey,
        isSigner: !0,
        isWritable: !0
      }];
    }
    return new TransactionInstruction({
      keys: $,
      programId: this.programId,
      data: T
    });
  }
}
SystemProgram.programId = new PublicKey("11111111111111111111111111111111");
const CHUNK_SIZE = PACKET_DATA_SIZE - 300;
class Loader {
  /**
   * @internal
   */
  constructor() {
  }
  /**
   * Amount of program data placed in each load Transaction
   */
  /**
   * Minimum number of signatures required to load a program not including
   * retries
   *
   * Can be used to calculate transaction fees
   */
  static getMinNumSignatures(e) {
    return 2 * // Every transaction requires two signatures (payer + program)
    (Math.ceil(e / Loader.chunkSize) + 1 + // Add one for Create transaction
    1);
  }
  /**
   * Loads a generic program
   *
   * @param connection The connection to use
   * @param payer System account that pays to load the program
   * @param program Account to load the program into
   * @param programId Public key that identifies the loader
   * @param data Program octets
   * @return true if program was loaded successfully, false if program was already loaded
   */
  static async load(e, T, $, V, J) {
    {
      const de = await e.getMinimumBalanceForRentExemption(J.length), ue = await e.getAccountInfo($.publicKey, "confirmed");
      let fe = null;
      if (ue !== null) {
        if (ue.executable)
          return console.error("Program load failed, account is already executable"), !1;
        ue.data.length !== J.length && (fe = fe || new Transaction(), fe.add(SystemProgram.allocate({
          accountPubkey: $.publicKey,
          space: J.length
        }))), ue.owner.equals(V) || (fe = fe || new Transaction(), fe.add(SystemProgram.assign({
          accountPubkey: $.publicKey,
          programId: V
        }))), ue.lamports < de && (fe = fe || new Transaction(), fe.add(SystemProgram.transfer({
          fromPubkey: T.publicKey,
          toPubkey: $.publicKey,
          lamports: de - ue.lamports
        })));
      } else
        fe = new Transaction().add(SystemProgram.createAccount({
          fromPubkey: T.publicKey,
          newAccountPubkey: $.publicKey,
          lamports: de > 0 ? de : 1,
          space: J.length,
          programId: V
        }));
      fe !== null && await sendAndConfirmTransaction(e, fe, [T, $], {
        commitment: "confirmed"
      });
    }
    const ee = struct$1([u32$1("instruction"), u32$1("offset"), u32$1("bytesLength"), u32$1("bytesLengthPadding"), seq(u8$1("byte"), offset$3(u32$1(), -8), "bytes")]), te = Loader.chunkSize;
    let re = 0, ie = J, se = [];
    for (; ie.length > 0; ) {
      const de = ie.slice(0, te), ue = bufferPolyfill.Buffer.alloc(te + 16);
      ee.encode({
        instruction: 0,
        // Load instruction
        offset: re,
        bytes: de,
        bytesLength: 0,
        bytesLengthPadding: 0
      }, ue);
      const fe = new Transaction().add({
        keys: [{
          pubkey: $.publicKey,
          isSigner: !0,
          isWritable: !0
        }],
        programId: V,
        data: ue
      });
      se.push(sendAndConfirmTransaction(e, fe, [T, $], {
        commitment: "confirmed"
      })), e._rpcEndpoint.includes("solana.com") && await sleep$1(1e3 / 4), re += te, ie = ie.slice(te);
    }
    await Promise.all(se);
    {
      const de = struct$1([u32$1("instruction")]), ue = bufferPolyfill.Buffer.alloc(de.span);
      de.encode({
        instruction: 1
        // Finalize instruction
      }, ue);
      const fe = new Transaction().add({
        keys: [{
          pubkey: $.publicKey,
          isSigner: !0,
          isWritable: !0
        }, {
          pubkey: SYSVAR_RENT_PUBKEY,
          isSigner: !1,
          isWritable: !1
        }],
        programId: V,
        data: ue
      }), he = "processed", me = await e.sendTransaction(fe, [T, $], {
        preflightCommitment: he
      }), {
        context: xe,
        value: ve
      } = await e.confirmTransaction({
        signature: me,
        lastValidBlockHeight: fe.lastValidBlockHeight,
        blockhash: fe.recentBlockhash
      }, he);
      if (ve.err)
        throw new Error(`Transaction ${me} failed (${JSON.stringify(ve)})`);
      for (; ; ) {
        try {
          if (await e.getSlot({
            commitment: he
          }) > xe.slot)
            break;
        } catch {
        }
        await new Promise((Te) => setTimeout(Te, Math.round(MS_PER_SLOT / 2)));
      }
    }
    return !0;
  }
}
Loader.chunkSize = CHUNK_SIZE;
const BPF_LOADER_PROGRAM_ID = new PublicKey("BPFLoader2111111111111111111111111111111111");
class BpfLoader {
  /**
   * Minimum number of signatures required to load a program not including
   * retries
   *
   * Can be used to calculate transaction fees
   */
  static getMinNumSignatures(e) {
    return Loader.getMinNumSignatures(e);
  }
  /**
   * Load a SBF program
   *
   * @param connection The connection to use
   * @param payer Account that will pay program loading fees
   * @param program Account to load the program into
   * @param elf The entire ELF containing the SBF program
   * @param loaderProgramId The program id of the BPF loader to use
   * @return true if program was loaded successfully, false if program was already loaded
   */
  static load(e, T, $, V, J) {
    return Loader.load(e, T, $, J, V);
  }
}
function getDefaultExportFromCjs$1(C) {
  return C && C.__esModule && Object.prototype.hasOwnProperty.call(C, "default") ? C.default : C;
}
var fastStableStringify$1, hasRequiredFastStableStringify;
function requireFastStableStringify() {
  if (hasRequiredFastStableStringify) return fastStableStringify$1;
  hasRequiredFastStableStringify = 1;
  var C = Object.prototype.toString, e = Object.keys || function($) {
    var V = [];
    for (var J in $)
      V.push(J);
    return V;
  };
  function T($, V) {
    var J, ee, te, re, ie, se, de;
    if ($ === !0)
      return "true";
    if ($ === !1)
      return "false";
    switch (typeof $) {
      case "object":
        if ($ === null)
          return null;
        if ($.toJSON && typeof $.toJSON == "function")
          return T($.toJSON(), V);
        if (de = C.call($), de === "[object Array]") {
          for (te = "[", ee = $.length - 1, J = 0; J < ee; J++)
            te += T($[J], !0) + ",";
          return ee > -1 && (te += T($[J], !0)), te + "]";
        } else if (de === "[object Object]") {
          for (re = e($).sort(), ee = re.length, te = "", J = 0; J < ee; )
            ie = re[J], se = T($[ie], !1), se !== void 0 && (te && (te += ","), te += JSON.stringify(ie) + ":" + se), J++;
          return "{" + te + "}";
        } else
          return JSON.stringify($);
      case "function":
      case "undefined":
        return V ? null : void 0;
      case "string":
        return JSON.stringify($);
      default:
        return isFinite($) ? $ : null;
    }
  }
  return fastStableStringify$1 = function($) {
    var V = T($, !1);
    if (V !== void 0)
      return "" + V;
  }, fastStableStringify$1;
}
var fastStableStringifyExports = /* @__PURE__ */ requireFastStableStringify(), fastStableStringify = /* @__PURE__ */ getDefaultExportFromCjs$1(fastStableStringifyExports);
const MINIMUM_SLOT_PER_EPOCH = 32;
function trailingZeros(C) {
  let e = 0;
  for (; C > 1; )
    C /= 2, e++;
  return e;
}
function nextPowerOfTwo(C) {
  return C === 0 ? 1 : (C--, C |= C >> 1, C |= C >> 2, C |= C >> 4, C |= C >> 8, C |= C >> 16, C |= C >> 32, C + 1);
}
class EpochSchedule {
  constructor(e, T, $, V, J) {
    this.slotsPerEpoch = void 0, this.leaderScheduleSlotOffset = void 0, this.warmup = void 0, this.firstNormalEpoch = void 0, this.firstNormalSlot = void 0, this.slotsPerEpoch = e, this.leaderScheduleSlotOffset = T, this.warmup = $, this.firstNormalEpoch = V, this.firstNormalSlot = J;
  }
  getEpoch(e) {
    return this.getEpochAndSlotIndex(e)[0];
  }
  getEpochAndSlotIndex(e) {
    if (e < this.firstNormalSlot) {
      const T = trailingZeros(nextPowerOfTwo(e + MINIMUM_SLOT_PER_EPOCH + 1)) - trailingZeros(MINIMUM_SLOT_PER_EPOCH) - 1, $ = this.getSlotsInEpoch(T), V = e - ($ - MINIMUM_SLOT_PER_EPOCH);
      return [T, V];
    } else {
      const T = e - this.firstNormalSlot, $ = Math.floor(T / this.slotsPerEpoch), V = this.firstNormalEpoch + $, J = T % this.slotsPerEpoch;
      return [V, J];
    }
  }
  getFirstSlotInEpoch(e) {
    return e <= this.firstNormalEpoch ? (Math.pow(2, e) - 1) * MINIMUM_SLOT_PER_EPOCH : (e - this.firstNormalEpoch) * this.slotsPerEpoch + this.firstNormalSlot;
  }
  getLastSlotInEpoch(e) {
    return this.getFirstSlotInEpoch(e) + this.getSlotsInEpoch(e) - 1;
  }
  getSlotsInEpoch(e) {
    return e < this.firstNormalEpoch ? Math.pow(2, e + trailingZeros(MINIMUM_SLOT_PER_EPOCH)) : this.slotsPerEpoch;
  }
}
var fetchImpl = globalThis.fetch;
class RpcWebSocketClient extends CommonClient$1 {
  constructor(e, T, $) {
    const V = (J) => {
      const ee = WebSocket(J, {
        autoconnect: !0,
        max_reconnects: 5,
        reconnect: !0,
        reconnect_interval: 1e3,
        ...T
      });
      return "socket" in ee ? this.underlyingSocket = ee.socket : this.underlyingSocket = ee, ee;
    };
    super(V, e, T, $), this.underlyingSocket = void 0;
  }
  call(...e) {
    var $;
    const T = ($ = this.underlyingSocket) == null ? void 0 : $.readyState;
    return T === 1 ? super.call(...e) : Promise.reject(new Error("Tried to call a JSON-RPC method `" + e[0] + "` but the socket was not `CONNECTING` or `OPEN` (`readyState` was " + T + ")"));
  }
  notify(...e) {
    var $;
    const T = ($ = this.underlyingSocket) == null ? void 0 : $.readyState;
    return T === 1 ? super.notify(...e) : Promise.reject(new Error("Tried to send a JSON-RPC notification `" + e[0] + "` but the socket was not `CONNECTING` or `OPEN` (`readyState` was " + T + ")"));
  }
}
function decodeData(C, e) {
  let T;
  try {
    T = C.layout.decode(e);
  } catch ($) {
    throw new Error("invalid instruction; " + $);
  }
  if (T.typeIndex !== C.index)
    throw new Error(`invalid account data; account type mismatch ${T.typeIndex} != ${C.index}`);
  return T;
}
const LOOKUP_TABLE_META_SIZE = 56;
class AddressLookupTableAccount {
  constructor(e) {
    this.key = void 0, this.state = void 0, this.key = e.key, this.state = e.state;
  }
  isActive() {
    const e = BigInt("0xffffffffffffffff");
    return this.state.deactivationSlot === e;
  }
  static deserialize(e) {
    const T = decodeData(LookupTableMetaLayout, e), $ = e.length - LOOKUP_TABLE_META_SIZE;
    assert$3($ >= 0, "lookup table is invalid"), assert$3($ % 32 === 0, "lookup table is invalid");
    const V = $ / 32, {
      addresses: J
    } = struct$1([seq(publicKey$4(), V, "addresses")]).decode(e.slice(LOOKUP_TABLE_META_SIZE));
    return {
      deactivationSlot: T.deactivationSlot,
      lastExtendedSlot: T.lastExtendedSlot,
      lastExtendedSlotStartIndex: T.lastExtendedStartIndex,
      authority: T.authority.length !== 0 ? new PublicKey(T.authority[0]) : void 0,
      addresses: J.map((ee) => new PublicKey(ee))
    };
  }
}
const LookupTableMetaLayout = {
  index: 1,
  layout: struct$1([
    u32$1("typeIndex"),
    u64$2("deactivationSlot"),
    nu64$1("lastExtendedSlot"),
    u8$1("lastExtendedStartIndex"),
    u8$1(),
    // option
    seq(publicKey$4(), offset$3(u8$1(), -1), "authority")
  ])
}, URL_RE = /^[^:]+:\/\/([^:[]+|\[[^\]]+\])(:\d+)?(.*)/i;
function makeWebsocketUrl(C) {
  const e = C.match(URL_RE);
  if (e == null)
    throw TypeError(`Failed to validate endpoint URL \`${C}\``);
  const [
    T,
    // eslint-disable-line @typescript-eslint/no-unused-vars
    $,
    V,
    J
  ] = e, ee = C.startsWith("https:") ? "wss:" : "ws:", te = V == null ? null : parseInt(V.slice(1), 10), re = (
    // Only shift the port by +1 as a convention for ws(s) only if given endpoint
    // is explicitly specifying the endpoint port (HTTP-based RPC), assuming
    // we're directly trying to connect to agave-validator's ws listening port.
    // When the endpoint omits the port, we're connecting to the protocol
    // default ports: http(80) or https(443) and it's assumed we're behind a reverse
    // proxy which manages WebSocket upgrade and backend port redirection.
    te == null ? "" : `:${te + 1}`
  );
  return `${ee}//${$}${re}${J}`;
}
const PublicKeyFromString = coerce$1(instance(PublicKey), string$2(), (C) => new PublicKey(C)), RawAccountDataResult = tuple$1([string$2(), literal$2("base64")]), BufferFromRawAccountData = coerce$1(instance(bufferPolyfill.Buffer), RawAccountDataResult, (C) => bufferPolyfill.Buffer.from(C[0], "base64")), BLOCKHASH_CACHE_TIMEOUT_MS = 30 * 1e3;
function assertEndpointUrl(C) {
  if (/^https?:/.test(C) === !1)
    throw new TypeError("Endpoint URL must start with `http:` or `https:`.");
  return C;
}
function extractCommitmentFromConfig(C) {
  let e, T;
  if (typeof C == "string")
    e = C;
  else if (C) {
    const {
      commitment: $,
      ...V
    } = C;
    e = $, T = V;
  }
  return {
    commitment: e,
    config: T
  };
}
function applyDefaultMemcmpEncodingToFilters(C) {
  return C.map((e) => "memcmp" in e ? {
    ...e,
    memcmp: {
      ...e.memcmp,
      encoding: e.memcmp.encoding ?? "base58"
    }
  } : e);
}
function createRpcResult$1(C) {
  return union$3([type$2({
    jsonrpc: literal$2("2.0"),
    id: string$2(),
    result: C
  }), type$2({
    jsonrpc: literal$2("2.0"),
    id: string$2(),
    error: type$2({
      code: unknown$1(),
      message: string$2(),
      data: optional$2(any$2())
    })
  })]);
}
const UnknownRpcResult$1 = createRpcResult$1(unknown$1());
function jsonRpcResult$1(C) {
  return coerce$1(createRpcResult$1(C), UnknownRpcResult$1, (e) => "error" in e ? e : {
    ...e,
    result: create$3(e.result, C)
  });
}
function jsonRpcResultAndContext$1(C) {
  return jsonRpcResult$1(type$2({
    context: type$2({
      slot: number$2()
    }),
    value: C
  }));
}
function notificationResultAndContext(C) {
  return type$2({
    context: type$2({
      slot: number$2()
    }),
    value: C
  });
}
function versionedMessageFromResponse(C, e) {
  return C === 0 ? new MessageV0({
    header: e.header,
    staticAccountKeys: e.accountKeys.map((T) => new PublicKey(T)),
    recentBlockhash: e.recentBlockhash,
    compiledInstructions: e.instructions.map((T) => ({
      programIdIndex: T.programIdIndex,
      accountKeyIndexes: T.accounts,
      data: bs58$6.decode(T.data)
    })),
    addressTableLookups: e.addressTableLookups
  }) : new Message(e);
}
const GetInflationGovernorResult = type$2({
  foundation: number$2(),
  foundationTerm: number$2(),
  initial: number$2(),
  taper: number$2(),
  terminal: number$2()
}), GetInflationRewardResult = jsonRpcResult$1(array$2(nullable$2(type$2({
  epoch: number$2(),
  effectiveSlot: number$2(),
  amount: number$2(),
  postBalance: number$2(),
  commission: optional$2(nullable$2(number$2()))
})))), GetRecentPrioritizationFeesResult = array$2(type$2({
  slot: number$2(),
  prioritizationFee: number$2()
})), GetInflationRateResult = type$2({
  total: number$2(),
  validator: number$2(),
  foundation: number$2(),
  epoch: number$2()
}), GetEpochInfoResult = type$2({
  epoch: number$2(),
  slotIndex: number$2(),
  slotsInEpoch: number$2(),
  absoluteSlot: number$2(),
  blockHeight: optional$2(number$2()),
  transactionCount: optional$2(number$2())
}), GetEpochScheduleResult = type$2({
  slotsPerEpoch: number$2(),
  leaderScheduleSlotOffset: number$2(),
  warmup: boolean$2(),
  firstNormalEpoch: number$2(),
  firstNormalSlot: number$2()
}), GetLeaderScheduleResult = record$1(string$2(), array$2(number$2())), TransactionErrorResult = nullable$2(union$3([type$2({}), string$2()])), SignatureStatusResult = type$2({
  err: TransactionErrorResult
}), SignatureReceivedResult = literal$2("receivedSignature"), VersionResult = type$2({
  "solana-core": string$2(),
  "feature-set": optional$2(number$2())
}), ParsedInstructionStruct = type$2({
  program: string$2(),
  programId: PublicKeyFromString,
  parsed: unknown$1()
}), PartiallyDecodedInstructionStruct = type$2({
  programId: PublicKeyFromString,
  accounts: array$2(PublicKeyFromString),
  data: string$2()
}), SimulatedTransactionResponseStruct$1 = jsonRpcResultAndContext$1(type$2({
  err: nullable$2(union$3([type$2({}), string$2()])),
  logs: nullable$2(array$2(string$2())),
  accounts: optional$2(nullable$2(array$2(nullable$2(type$2({
    executable: boolean$2(),
    owner: string$2(),
    lamports: number$2(),
    data: array$2(string$2()),
    rentEpoch: optional$2(number$2())
  }))))),
  unitsConsumed: optional$2(number$2()),
  returnData: optional$2(nullable$2(type$2({
    programId: string$2(),
    data: tuple$1([string$2(), literal$2("base64")])
  }))),
  innerInstructions: optional$2(nullable$2(array$2(type$2({
    index: number$2(),
    instructions: array$2(union$3([ParsedInstructionStruct, PartiallyDecodedInstructionStruct]))
  }))))
})), BlockProductionResponseStruct = jsonRpcResultAndContext$1(type$2({
  byIdentity: record$1(string$2(), array$2(number$2())),
  range: type$2({
    firstSlot: number$2(),
    lastSlot: number$2()
  })
}));
function createRpcClient(C, e, T, $, V, J) {
  const ee = T || fetchImpl;
  let te;
  J != null && console.warn("You have supplied an `httpAgent` when creating a `Connection` in a browser environment.It has been ignored; `httpAgent` is only used in Node environments.");
  let re;
  return $ && (re = async (se, de) => {
    const ue = await new Promise((fe, he) => {
      try {
        $(se, de, (me, xe) => fe([me, xe]));
      } catch (me) {
        he(me);
      }
    });
    return await ee(...ue);
  }), new RpcClient(async (se, de) => {
    const ue = {
      method: "POST",
      body: se,
      agent: te,
      headers: Object.assign({
        "Content-Type": "application/json"
      }, e || {}, COMMON_HTTP_HEADERS)
    };
    try {
      let fe = 5, he, me = 500;
      for (; re ? he = await re(C, ue) : he = await ee(C, ue), !(he.status !== 429 || V === !0 || (fe -= 1, fe === 0)); )
        console.error(`Server responded with ${he.status} ${he.statusText}.  Retrying after ${me}ms delay...`), await sleep$1(me), me *= 2;
      const xe = await he.text();
      he.ok ? de(null, xe) : de(new Error(`${he.status} ${he.statusText}: ${xe}`));
    } catch (fe) {
      fe instanceof Error && de(fe);
    }
  }, {});
}
function createRpcRequest(C) {
  return (e, T) => new Promise(($, V) => {
    C.request(e, T, (J, ee) => {
      if (J) {
        V(J);
        return;
      }
      $(ee);
    });
  });
}
function createRpcBatchRequest(C) {
  return (e) => new Promise((T, $) => {
    e.length === 0 && T([]);
    const V = e.map((J) => C.request(J.methodName, J.args));
    C.request(V, (J, ee) => {
      if (J) {
        $(J);
        return;
      }
      T(ee);
    });
  });
}
const GetInflationGovernorRpcResult = jsonRpcResult$1(GetInflationGovernorResult), GetInflationRateRpcResult = jsonRpcResult$1(GetInflationRateResult), GetRecentPrioritizationFeesRpcResult = jsonRpcResult$1(GetRecentPrioritizationFeesResult), GetEpochInfoRpcResult = jsonRpcResult$1(GetEpochInfoResult), GetEpochScheduleRpcResult = jsonRpcResult$1(GetEpochScheduleResult), GetLeaderScheduleRpcResult = jsonRpcResult$1(GetLeaderScheduleResult), SlotRpcResult = jsonRpcResult$1(number$2()), GetSupplyRpcResult = jsonRpcResultAndContext$1(type$2({
  total: number$2(),
  circulating: number$2(),
  nonCirculating: number$2(),
  nonCirculatingAccounts: array$2(PublicKeyFromString)
})), TokenAmountResult = type$2({
  amount: string$2(),
  uiAmount: nullable$2(number$2()),
  decimals: number$2(),
  uiAmountString: optional$2(string$2())
}), GetTokenLargestAccountsResult = jsonRpcResultAndContext$1(array$2(type$2({
  address: PublicKeyFromString,
  amount: string$2(),
  uiAmount: nullable$2(number$2()),
  decimals: number$2(),
  uiAmountString: optional$2(string$2())
}))), GetTokenAccountsByOwner = jsonRpcResultAndContext$1(array$2(type$2({
  pubkey: PublicKeyFromString,
  account: type$2({
    executable: boolean$2(),
    owner: PublicKeyFromString,
    lamports: number$2(),
    data: BufferFromRawAccountData,
    rentEpoch: number$2()
  })
}))), ParsedAccountDataResult = type$2({
  program: string$2(),
  parsed: unknown$1(),
  space: number$2()
}), GetParsedTokenAccountsByOwner = jsonRpcResultAndContext$1(array$2(type$2({
  pubkey: PublicKeyFromString,
  account: type$2({
    executable: boolean$2(),
    owner: PublicKeyFromString,
    lamports: number$2(),
    data: ParsedAccountDataResult,
    rentEpoch: number$2()
  })
}))), GetLargestAccountsRpcResult = jsonRpcResultAndContext$1(array$2(type$2({
  lamports: number$2(),
  address: PublicKeyFromString
}))), AccountInfoResult = type$2({
  executable: boolean$2(),
  owner: PublicKeyFromString,
  lamports: number$2(),
  data: BufferFromRawAccountData,
  rentEpoch: number$2()
}), KeyedAccountInfoResult = type$2({
  pubkey: PublicKeyFromString,
  account: AccountInfoResult
}), ParsedOrRawAccountData = coerce$1(union$3([instance(bufferPolyfill.Buffer), ParsedAccountDataResult]), union$3([RawAccountDataResult, ParsedAccountDataResult]), (C) => Array.isArray(C) ? create$3(C, BufferFromRawAccountData) : C), ParsedAccountInfoResult = type$2({
  executable: boolean$2(),
  owner: PublicKeyFromString,
  lamports: number$2(),
  data: ParsedOrRawAccountData,
  rentEpoch: number$2()
}), KeyedParsedAccountInfoResult = type$2({
  pubkey: PublicKeyFromString,
  account: ParsedAccountInfoResult
}), StakeActivationResult = type$2({
  state: union$3([literal$2("active"), literal$2("inactive"), literal$2("activating"), literal$2("deactivating")]),
  active: number$2(),
  inactive: number$2()
}), GetConfirmedSignaturesForAddress2RpcResult = jsonRpcResult$1(array$2(type$2({
  signature: string$2(),
  slot: number$2(),
  err: TransactionErrorResult,
  memo: nullable$2(string$2()),
  blockTime: optional$2(nullable$2(number$2()))
}))), GetSignaturesForAddressRpcResult = jsonRpcResult$1(array$2(type$2({
  signature: string$2(),
  slot: number$2(),
  err: TransactionErrorResult,
  memo: nullable$2(string$2()),
  blockTime: optional$2(nullable$2(number$2()))
}))), AccountNotificationResult = type$2({
  subscription: number$2(),
  result: notificationResultAndContext(AccountInfoResult)
}), ProgramAccountInfoResult = type$2({
  pubkey: PublicKeyFromString,
  account: AccountInfoResult
}), ProgramAccountNotificationResult = type$2({
  subscription: number$2(),
  result: notificationResultAndContext(ProgramAccountInfoResult)
}), SlotInfoResult = type$2({
  parent: number$2(),
  slot: number$2(),
  root: number$2()
}), SlotNotificationResult = type$2({
  subscription: number$2(),
  result: SlotInfoResult
}), SlotUpdateResult = union$3([type$2({
  type: union$3([literal$2("firstShredReceived"), literal$2("completed"), literal$2("optimisticConfirmation"), literal$2("root")]),
  slot: number$2(),
  timestamp: number$2()
}), type$2({
  type: literal$2("createdBank"),
  parent: number$2(),
  slot: number$2(),
  timestamp: number$2()
}), type$2({
  type: literal$2("frozen"),
  slot: number$2(),
  timestamp: number$2(),
  stats: type$2({
    numTransactionEntries: number$2(),
    numSuccessfulTransactions: number$2(),
    numFailedTransactions: number$2(),
    maxTransactionsPerEntry: number$2()
  })
}), type$2({
  type: literal$2("dead"),
  slot: number$2(),
  timestamp: number$2(),
  err: string$2()
})]), SlotUpdateNotificationResult = type$2({
  subscription: number$2(),
  result: SlotUpdateResult
}), SignatureNotificationResult = type$2({
  subscription: number$2(),
  result: notificationResultAndContext(union$3([SignatureStatusResult, SignatureReceivedResult]))
}), RootNotificationResult = type$2({
  subscription: number$2(),
  result: number$2()
}), ContactInfoResult = type$2({
  pubkey: string$2(),
  gossip: nullable$2(string$2()),
  tpu: nullable$2(string$2()),
  rpc: nullable$2(string$2()),
  version: nullable$2(string$2())
}), VoteAccountInfoResult = type$2({
  votePubkey: string$2(),
  nodePubkey: string$2(),
  activatedStake: number$2(),
  epochVoteAccount: boolean$2(),
  epochCredits: array$2(tuple$1([number$2(), number$2(), number$2()])),
  commission: number$2(),
  lastVote: number$2(),
  rootSlot: nullable$2(number$2())
}), GetVoteAccounts = jsonRpcResult$1(type$2({
  current: array$2(VoteAccountInfoResult),
  delinquent: array$2(VoteAccountInfoResult)
})), ConfirmationStatus = union$3([literal$2("processed"), literal$2("confirmed"), literal$2("finalized")]), SignatureStatusResponse = type$2({
  slot: number$2(),
  confirmations: nullable$2(number$2()),
  err: TransactionErrorResult,
  confirmationStatus: optional$2(ConfirmationStatus)
}), GetSignatureStatusesRpcResult = jsonRpcResultAndContext$1(array$2(nullable$2(SignatureStatusResponse))), GetMinimumBalanceForRentExemptionRpcResult = jsonRpcResult$1(number$2()), AddressTableLookupStruct = type$2({
  accountKey: PublicKeyFromString,
  writableIndexes: array$2(number$2()),
  readonlyIndexes: array$2(number$2())
}), ConfirmedTransactionResult = type$2({
  signatures: array$2(string$2()),
  message: type$2({
    accountKeys: array$2(string$2()),
    header: type$2({
      numRequiredSignatures: number$2(),
      numReadonlySignedAccounts: number$2(),
      numReadonlyUnsignedAccounts: number$2()
    }),
    instructions: array$2(type$2({
      accounts: array$2(number$2()),
      data: string$2(),
      programIdIndex: number$2()
    })),
    recentBlockhash: string$2(),
    addressTableLookups: optional$2(array$2(AddressTableLookupStruct))
  })
}), AnnotatedAccountKey = type$2({
  pubkey: PublicKeyFromString,
  signer: boolean$2(),
  writable: boolean$2(),
  source: optional$2(union$3([literal$2("transaction"), literal$2("lookupTable")]))
}), ConfirmedTransactionAccountsModeResult = type$2({
  accountKeys: array$2(AnnotatedAccountKey),
  signatures: array$2(string$2())
}), ParsedInstructionResult = type$2({
  parsed: unknown$1(),
  program: string$2(),
  programId: PublicKeyFromString
}), RawInstructionResult = type$2({
  accounts: array$2(PublicKeyFromString),
  data: string$2(),
  programId: PublicKeyFromString
}), InstructionResult = union$3([RawInstructionResult, ParsedInstructionResult]), UnknownInstructionResult = union$3([type$2({
  parsed: unknown$1(),
  program: string$2(),
  programId: string$2()
}), type$2({
  accounts: array$2(string$2()),
  data: string$2(),
  programId: string$2()
})]), ParsedOrRawInstruction = coerce$1(InstructionResult, UnknownInstructionResult, (C) => "accounts" in C ? create$3(C, RawInstructionResult) : create$3(C, ParsedInstructionResult)), ParsedConfirmedTransactionResult = type$2({
  signatures: array$2(string$2()),
  message: type$2({
    accountKeys: array$2(AnnotatedAccountKey),
    instructions: array$2(ParsedOrRawInstruction),
    recentBlockhash: string$2(),
    addressTableLookups: optional$2(nullable$2(array$2(AddressTableLookupStruct)))
  })
}), TokenBalanceResult = type$2({
  accountIndex: number$2(),
  mint: string$2(),
  owner: optional$2(string$2()),
  programId: optional$2(string$2()),
  uiTokenAmount: TokenAmountResult
}), LoadedAddressesResult = type$2({
  writable: array$2(PublicKeyFromString),
  readonly: array$2(PublicKeyFromString)
}), ConfirmedTransactionMetaResult = type$2({
  err: TransactionErrorResult,
  fee: number$2(),
  innerInstructions: optional$2(nullable$2(array$2(type$2({
    index: number$2(),
    instructions: array$2(type$2({
      accounts: array$2(number$2()),
      data: string$2(),
      programIdIndex: number$2()
    }))
  })))),
  preBalances: array$2(number$2()),
  postBalances: array$2(number$2()),
  logMessages: optional$2(nullable$2(array$2(string$2()))),
  preTokenBalances: optional$2(nullable$2(array$2(TokenBalanceResult))),
  postTokenBalances: optional$2(nullable$2(array$2(TokenBalanceResult))),
  loadedAddresses: optional$2(LoadedAddressesResult),
  computeUnitsConsumed: optional$2(number$2())
}), ParsedConfirmedTransactionMetaResult = type$2({
  err: TransactionErrorResult,
  fee: number$2(),
  innerInstructions: optional$2(nullable$2(array$2(type$2({
    index: number$2(),
    instructions: array$2(ParsedOrRawInstruction)
  })))),
  preBalances: array$2(number$2()),
  postBalances: array$2(number$2()),
  logMessages: optional$2(nullable$2(array$2(string$2()))),
  preTokenBalances: optional$2(nullable$2(array$2(TokenBalanceResult))),
  postTokenBalances: optional$2(nullable$2(array$2(TokenBalanceResult))),
  loadedAddresses: optional$2(LoadedAddressesResult),
  computeUnitsConsumed: optional$2(number$2())
}), TransactionVersionStruct = union$3([literal$2(0), literal$2("legacy")]), RewardsResult = type$2({
  pubkey: string$2(),
  lamports: number$2(),
  postBalance: nullable$2(number$2()),
  rewardType: nullable$2(string$2()),
  commission: optional$2(nullable$2(number$2()))
}), GetBlockRpcResult = jsonRpcResult$1(nullable$2(type$2({
  blockhash: string$2(),
  previousBlockhash: string$2(),
  parentSlot: number$2(),
  transactions: array$2(type$2({
    transaction: ConfirmedTransactionResult,
    meta: nullable$2(ConfirmedTransactionMetaResult),
    version: optional$2(TransactionVersionStruct)
  })),
  rewards: optional$2(array$2(RewardsResult)),
  blockTime: nullable$2(number$2()),
  blockHeight: nullable$2(number$2())
}))), GetNoneModeBlockRpcResult = jsonRpcResult$1(nullable$2(type$2({
  blockhash: string$2(),
  previousBlockhash: string$2(),
  parentSlot: number$2(),
  rewards: optional$2(array$2(RewardsResult)),
  blockTime: nullable$2(number$2()),
  blockHeight: nullable$2(number$2())
}))), GetAccountsModeBlockRpcResult = jsonRpcResult$1(nullable$2(type$2({
  blockhash: string$2(),
  previousBlockhash: string$2(),
  parentSlot: number$2(),
  transactions: array$2(type$2({
    transaction: ConfirmedTransactionAccountsModeResult,
    meta: nullable$2(ConfirmedTransactionMetaResult),
    version: optional$2(TransactionVersionStruct)
  })),
  rewards: optional$2(array$2(RewardsResult)),
  blockTime: nullable$2(number$2()),
  blockHeight: nullable$2(number$2())
}))), GetParsedBlockRpcResult = jsonRpcResult$1(nullable$2(type$2({
  blockhash: string$2(),
  previousBlockhash: string$2(),
  parentSlot: number$2(),
  transactions: array$2(type$2({
    transaction: ParsedConfirmedTransactionResult,
    meta: nullable$2(ParsedConfirmedTransactionMetaResult),
    version: optional$2(TransactionVersionStruct)
  })),
  rewards: optional$2(array$2(RewardsResult)),
  blockTime: nullable$2(number$2()),
  blockHeight: nullable$2(number$2())
}))), GetParsedAccountsModeBlockRpcResult = jsonRpcResult$1(nullable$2(type$2({
  blockhash: string$2(),
  previousBlockhash: string$2(),
  parentSlot: number$2(),
  transactions: array$2(type$2({
    transaction: ConfirmedTransactionAccountsModeResult,
    meta: nullable$2(ParsedConfirmedTransactionMetaResult),
    version: optional$2(TransactionVersionStruct)
  })),
  rewards: optional$2(array$2(RewardsResult)),
  blockTime: nullable$2(number$2()),
  blockHeight: nullable$2(number$2())
}))), GetParsedNoneModeBlockRpcResult = jsonRpcResult$1(nullable$2(type$2({
  blockhash: string$2(),
  previousBlockhash: string$2(),
  parentSlot: number$2(),
  rewards: optional$2(array$2(RewardsResult)),
  blockTime: nullable$2(number$2()),
  blockHeight: nullable$2(number$2())
}))), GetConfirmedBlockRpcResult = jsonRpcResult$1(nullable$2(type$2({
  blockhash: string$2(),
  previousBlockhash: string$2(),
  parentSlot: number$2(),
  transactions: array$2(type$2({
    transaction: ConfirmedTransactionResult,
    meta: nullable$2(ConfirmedTransactionMetaResult)
  })),
  rewards: optional$2(array$2(RewardsResult)),
  blockTime: nullable$2(number$2())
}))), GetBlockSignaturesRpcResult = jsonRpcResult$1(nullable$2(type$2({
  blockhash: string$2(),
  previousBlockhash: string$2(),
  parentSlot: number$2(),
  signatures: array$2(string$2()),
  blockTime: nullable$2(number$2())
}))), GetTransactionRpcResult = jsonRpcResult$1(nullable$2(type$2({
  slot: number$2(),
  meta: nullable$2(ConfirmedTransactionMetaResult),
  blockTime: optional$2(nullable$2(number$2())),
  transaction: ConfirmedTransactionResult,
  version: optional$2(TransactionVersionStruct)
}))), GetParsedTransactionRpcResult = jsonRpcResult$1(nullable$2(type$2({
  slot: number$2(),
  transaction: ParsedConfirmedTransactionResult,
  meta: nullable$2(ParsedConfirmedTransactionMetaResult),
  blockTime: optional$2(nullable$2(number$2())),
  version: optional$2(TransactionVersionStruct)
}))), GetLatestBlockhashRpcResult = jsonRpcResultAndContext$1(type$2({
  blockhash: string$2(),
  lastValidBlockHeight: number$2()
})), IsBlockhashValidRpcResult = jsonRpcResultAndContext$1(boolean$2()), PerfSampleResult = type$2({
  slot: number$2(),
  numTransactions: number$2(),
  numSlots: number$2(),
  samplePeriodSecs: number$2()
}), GetRecentPerformanceSamplesRpcResult = jsonRpcResult$1(array$2(PerfSampleResult)), GetFeeCalculatorRpcResult = jsonRpcResultAndContext$1(nullable$2(type$2({
  feeCalculator: type$2({
    lamportsPerSignature: number$2()
  })
}))), RequestAirdropRpcResult = jsonRpcResult$1(string$2()), SendTransactionRpcResult = jsonRpcResult$1(string$2()), LogsResult = type$2({
  err: TransactionErrorResult,
  logs: array$2(string$2()),
  signature: string$2()
}), LogsNotificationResult = type$2({
  result: notificationResultAndContext(LogsResult),
  subscription: number$2()
}), COMMON_HTTP_HEADERS = {
  "solana-client": "js/1.0.0-maintenance"
};
let Connection$1 = class {
  /**
   * Establish a JSON RPC connection
   *
   * @param endpoint URL to the fullnode JSON RPC endpoint
   * @param commitmentOrConfig optional default commitment level or optional ConnectionConfig configuration object
   */
  constructor(e, T) {
    this._commitment = void 0, this._confirmTransactionInitialTimeout = void 0, this._rpcEndpoint = void 0, this._rpcWsEndpoint = void 0, this._rpcClient = void 0, this._rpcRequest = void 0, this._rpcBatchRequest = void 0, this._rpcWebSocket = void 0, this._rpcWebSocketConnected = !1, this._rpcWebSocketHeartbeat = null, this._rpcWebSocketIdleTimeout = null, this._rpcWebSocketGeneration = 0, this._disableBlockhashCaching = !1, this._pollingBlockhash = !1, this._blockhashInfo = {
      latestBlockhash: null,
      lastFetch: 0,
      transactionSignatures: [],
      simulatedSignatures: []
    }, this._nextClientSubscriptionId = 0, this._subscriptionDisposeFunctionsByClientSubscriptionId = {}, this._subscriptionHashByClientSubscriptionId = {}, this._subscriptionStateChangeCallbacksByHash = {}, this._subscriptionCallbacksByServerSubscriptionId = {}, this._subscriptionsByHash = {}, this._subscriptionsAutoDisposedByRpc = /* @__PURE__ */ new Set(), this.getBlockHeight = /* @__PURE__ */ (() => {
      const ie = {};
      return async (se) => {
        const {
          commitment: de,
          config: ue
        } = extractCommitmentFromConfig(se), fe = this._buildArgs([], de, void 0, ue), he = fastStableStringify(fe);
        return ie[he] = ie[he] ?? (async () => {
          try {
            const me = await this._rpcRequest("getBlockHeight", fe), xe = create$3(me, jsonRpcResult$1(number$2()));
            if ("error" in xe)
              throw new SolanaJSONRPCError(xe.error, "failed to get block height information");
            return xe.result;
          } finally {
            delete ie[he];
          }
        })(), await ie[he];
      };
    })();
    let $, V, J, ee, te, re;
    T && typeof T == "string" ? this._commitment = T : T && (this._commitment = T.commitment, this._confirmTransactionInitialTimeout = T.confirmTransactionInitialTimeout, $ = T.wsEndpoint, V = T.httpHeaders, J = T.fetch, ee = T.fetchMiddleware, te = T.disableRetryOnRateLimit, re = T.httpAgent), this._rpcEndpoint = assertEndpointUrl(e), this._rpcWsEndpoint = $ || makeWebsocketUrl(e), this._rpcClient = createRpcClient(e, V, J, ee, te, re), this._rpcRequest = createRpcRequest(this._rpcClient), this._rpcBatchRequest = createRpcBatchRequest(this._rpcClient), this._rpcWebSocket = new RpcWebSocketClient(this._rpcWsEndpoint, {
      autoconnect: !1,
      max_reconnects: 1 / 0
    }), this._rpcWebSocket.on("open", this._wsOnOpen.bind(this)), this._rpcWebSocket.on("error", this._wsOnError.bind(this)), this._rpcWebSocket.on("close", this._wsOnClose.bind(this)), this._rpcWebSocket.on("accountNotification", this._wsOnAccountNotification.bind(this)), this._rpcWebSocket.on("programNotification", this._wsOnProgramAccountNotification.bind(this)), this._rpcWebSocket.on("slotNotification", this._wsOnSlotNotification.bind(this)), this._rpcWebSocket.on("slotsUpdatesNotification", this._wsOnSlotUpdatesNotification.bind(this)), this._rpcWebSocket.on("signatureNotification", this._wsOnSignatureNotification.bind(this)), this._rpcWebSocket.on("rootNotification", this._wsOnRootNotification.bind(this)), this._rpcWebSocket.on("logsNotification", this._wsOnLogsNotification.bind(this));
  }
  /**
   * The default commitment used for requests
   */
  get commitment() {
    return this._commitment;
  }
  /**
   * The RPC endpoint
   */
  get rpcEndpoint() {
    return this._rpcEndpoint;
  }
  /**
   * Fetch the balance for the specified public key, return with context
   */
  async getBalanceAndContext(e, T) {
    const {
      commitment: $,
      config: V
    } = extractCommitmentFromConfig(T), J = this._buildArgs([e.toBase58()], $, void 0, V), ee = await this._rpcRequest("getBalance", J), te = create$3(ee, jsonRpcResultAndContext$1(number$2()));
    if ("error" in te)
      throw new SolanaJSONRPCError(te.error, `failed to get balance for ${e.toBase58()}`);
    return te.result;
  }
  /**
   * Fetch the balance for the specified public key
   */
  async getBalance(e, T) {
    return await this.getBalanceAndContext(e, T).then(($) => $.value).catch(($) => {
      throw new Error("failed to get balance of account " + e.toBase58() + ": " + $);
    });
  }
  /**
   * Fetch the estimated production time of a block
   */
  async getBlockTime(e) {
    const T = await this._rpcRequest("getBlockTime", [e]), $ = create$3(T, jsonRpcResult$1(nullable$2(number$2())));
    if ("error" in $)
      throw new SolanaJSONRPCError($.error, `failed to get block time for slot ${e}`);
    return $.result;
  }
  /**
   * Fetch the lowest slot that the node has information about in its ledger.
   * This value may increase over time if the node is configured to purge older ledger data
   */
  async getMinimumLedgerSlot() {
    const e = await this._rpcRequest("minimumLedgerSlot", []), T = create$3(e, jsonRpcResult$1(number$2()));
    if ("error" in T)
      throw new SolanaJSONRPCError(T.error, "failed to get minimum ledger slot");
    return T.result;
  }
  /**
   * Fetch the slot of the lowest confirmed block that has not been purged from the ledger
   */
  async getFirstAvailableBlock() {
    const e = await this._rpcRequest("getFirstAvailableBlock", []), T = create$3(e, SlotRpcResult);
    if ("error" in T)
      throw new SolanaJSONRPCError(T.error, "failed to get first available block");
    return T.result;
  }
  /**
   * Fetch information about the current supply
   */
  async getSupply(e) {
    let T = {};
    typeof e == "string" ? T = {
      commitment: e
    } : e ? T = {
      ...e,
      commitment: e && e.commitment || this.commitment
    } : T = {
      commitment: this.commitment
    };
    const $ = await this._rpcRequest("getSupply", [T]), V = create$3($, GetSupplyRpcResult);
    if ("error" in V)
      throw new SolanaJSONRPCError(V.error, "failed to get supply");
    return V.result;
  }
  /**
   * Fetch the current supply of a token mint
   */
  async getTokenSupply(e, T) {
    const $ = this._buildArgs([e.toBase58()], T), V = await this._rpcRequest("getTokenSupply", $), J = create$3(V, jsonRpcResultAndContext$1(TokenAmountResult));
    if ("error" in J)
      throw new SolanaJSONRPCError(J.error, "failed to get token supply");
    return J.result;
  }
  /**
   * Fetch the current balance of a token account
   */
  async getTokenAccountBalance(e, T) {
    const $ = this._buildArgs([e.toBase58()], T), V = await this._rpcRequest("getTokenAccountBalance", $), J = create$3(V, jsonRpcResultAndContext$1(TokenAmountResult));
    if ("error" in J)
      throw new SolanaJSONRPCError(J.error, "failed to get token account balance");
    return J.result;
  }
  /**
   * Fetch all the token accounts owned by the specified account
   *
   * @return {Promise<RpcResponseAndContext<GetProgramAccountsResponse>}
   */
  async getTokenAccountsByOwner(e, T, $) {
    const {
      commitment: V,
      config: J
    } = extractCommitmentFromConfig($);
    let ee = [e.toBase58()];
    "mint" in T ? ee.push({
      mint: T.mint.toBase58()
    }) : ee.push({
      programId: T.programId.toBase58()
    });
    const te = this._buildArgs(ee, V, "base64", J), re = await this._rpcRequest("getTokenAccountsByOwner", te), ie = create$3(re, GetTokenAccountsByOwner);
    if ("error" in ie)
      throw new SolanaJSONRPCError(ie.error, `failed to get token accounts owned by account ${e.toBase58()}`);
    return ie.result;
  }
  /**
   * Fetch parsed token accounts owned by the specified account
   *
   * @return {Promise<RpcResponseAndContext<Array<{pubkey: PublicKey, account: AccountInfo<ParsedAccountData>}>>>}
   */
  async getParsedTokenAccountsByOwner(e, T, $) {
    let V = [e.toBase58()];
    "mint" in T ? V.push({
      mint: T.mint.toBase58()
    }) : V.push({
      programId: T.programId.toBase58()
    });
    const J = this._buildArgs(V, $, "jsonParsed"), ee = await this._rpcRequest("getTokenAccountsByOwner", J), te = create$3(ee, GetParsedTokenAccountsByOwner);
    if ("error" in te)
      throw new SolanaJSONRPCError(te.error, `failed to get token accounts owned by account ${e.toBase58()}`);
    return te.result;
  }
  /**
   * Fetch the 20 largest accounts with their current balances
   */
  async getLargestAccounts(e) {
    const T = {
      ...e,
      commitment: e && e.commitment || this.commitment
    }, $ = T.filter || T.commitment ? [T] : [], V = await this._rpcRequest("getLargestAccounts", $), J = create$3(V, GetLargestAccountsRpcResult);
    if ("error" in J)
      throw new SolanaJSONRPCError(J.error, "failed to get largest accounts");
    return J.result;
  }
  /**
   * Fetch the 20 largest token accounts with their current balances
   * for a given mint.
   */
  async getTokenLargestAccounts(e, T) {
    const $ = this._buildArgs([e.toBase58()], T), V = await this._rpcRequest("getTokenLargestAccounts", $), J = create$3(V, GetTokenLargestAccountsResult);
    if ("error" in J)
      throw new SolanaJSONRPCError(J.error, "failed to get token largest accounts");
    return J.result;
  }
  /**
   * Fetch all the account info for the specified public key, return with context
   */
  async getAccountInfoAndContext(e, T) {
    const {
      commitment: $,
      config: V
    } = extractCommitmentFromConfig(T), J = this._buildArgs([e.toBase58()], $, "base64", V), ee = await this._rpcRequest("getAccountInfo", J), te = create$3(ee, jsonRpcResultAndContext$1(nullable$2(AccountInfoResult)));
    if ("error" in te)
      throw new SolanaJSONRPCError(te.error, `failed to get info about account ${e.toBase58()}`);
    return te.result;
  }
  /**
   * Fetch parsed account info for the specified public key
   */
  async getParsedAccountInfo(e, T) {
    const {
      commitment: $,
      config: V
    } = extractCommitmentFromConfig(T), J = this._buildArgs([e.toBase58()], $, "jsonParsed", V), ee = await this._rpcRequest("getAccountInfo", J), te = create$3(ee, jsonRpcResultAndContext$1(nullable$2(ParsedAccountInfoResult)));
    if ("error" in te)
      throw new SolanaJSONRPCError(te.error, `failed to get info about account ${e.toBase58()}`);
    return te.result;
  }
  /**
   * Fetch all the account info for the specified public key
   */
  async getAccountInfo(e, T) {
    try {
      return (await this.getAccountInfoAndContext(e, T)).value;
    } catch ($) {
      throw new Error("failed to get info about account " + e.toBase58() + ": " + $);
    }
  }
  /**
   * Fetch all the account info for multiple accounts specified by an array of public keys, return with context
   */
  async getMultipleParsedAccounts(e, T) {
    const {
      commitment: $,
      config: V
    } = extractCommitmentFromConfig(T), J = e.map((ie) => ie.toBase58()), ee = this._buildArgs([J], $, "jsonParsed", V), te = await this._rpcRequest("getMultipleAccounts", ee), re = create$3(te, jsonRpcResultAndContext$1(array$2(nullable$2(ParsedAccountInfoResult))));
    if ("error" in re)
      throw new SolanaJSONRPCError(re.error, `failed to get info for accounts ${J}`);
    return re.result;
  }
  /**
   * Fetch all the account info for multiple accounts specified by an array of public keys, return with context
   */
  async getMultipleAccountsInfoAndContext(e, T) {
    const {
      commitment: $,
      config: V
    } = extractCommitmentFromConfig(T), J = e.map((ie) => ie.toBase58()), ee = this._buildArgs([J], $, "base64", V), te = await this._rpcRequest("getMultipleAccounts", ee), re = create$3(te, jsonRpcResultAndContext$1(array$2(nullable$2(AccountInfoResult))));
    if ("error" in re)
      throw new SolanaJSONRPCError(re.error, `failed to get info for accounts ${J}`);
    return re.result;
  }
  /**
   * Fetch all the account info for multiple accounts specified by an array of public keys
   */
  async getMultipleAccountsInfo(e, T) {
    return (await this.getMultipleAccountsInfoAndContext(e, T)).value;
  }
  /**
   * Returns epoch activation information for a stake account that has been delegated
   *
   * @deprecated Deprecated since RPC v1.18; will be removed in a future version.
   */
  async getStakeActivation(e, T, $) {
    const {
      commitment: V,
      config: J
    } = extractCommitmentFromConfig(T), ee = this._buildArgs([e.toBase58()], V, void 0, {
      ...J,
      epoch: $ ?? (J == null ? void 0 : J.epoch)
    }), te = await this._rpcRequest("getStakeActivation", ee), re = create$3(te, jsonRpcResult$1(StakeActivationResult));
    if ("error" in re)
      throw new SolanaJSONRPCError(re.error, `failed to get Stake Activation ${e.toBase58()}`);
    return re.result;
  }
  /**
   * Fetch all the accounts owned by the specified program id
   *
   * @return {Promise<Array<{pubkey: PublicKey, account: AccountInfo<Buffer>}>>}
   */
  // eslint-disable-next-line no-dupe-class-members
  // eslint-disable-next-line no-dupe-class-members
  async getProgramAccounts(e, T) {
    const {
      commitment: $,
      config: V
    } = extractCommitmentFromConfig(T), {
      encoding: J,
      ...ee
    } = V || {}, te = this._buildArgs([e.toBase58()], $, J || "base64", {
      ...ee,
      ...ee.filters ? {
        filters: applyDefaultMemcmpEncodingToFilters(ee.filters)
      } : null
    }), re = await this._rpcRequest("getProgramAccounts", te), ie = array$2(KeyedAccountInfoResult), se = ee.withContext === !0 ? create$3(re, jsonRpcResultAndContext$1(ie)) : create$3(re, jsonRpcResult$1(ie));
    if ("error" in se)
      throw new SolanaJSONRPCError(se.error, `failed to get accounts owned by program ${e.toBase58()}`);
    return se.result;
  }
  /**
   * Fetch and parse all the accounts owned by the specified program id
   *
   * @return {Promise<Array<{pubkey: PublicKey, account: AccountInfo<Buffer | ParsedAccountData>}>>}
   */
  async getParsedProgramAccounts(e, T) {
    const {
      commitment: $,
      config: V
    } = extractCommitmentFromConfig(T), J = this._buildArgs([e.toBase58()], $, "jsonParsed", V), ee = await this._rpcRequest("getProgramAccounts", J), te = create$3(ee, jsonRpcResult$1(array$2(KeyedParsedAccountInfoResult)));
    if ("error" in te)
      throw new SolanaJSONRPCError(te.error, `failed to get accounts owned by program ${e.toBase58()}`);
    return te.result;
  }
  /** @deprecated Instead, call `confirmTransaction` and pass in {@link TransactionConfirmationStrategy} */
  // eslint-disable-next-line no-dupe-class-members
  // eslint-disable-next-line no-dupe-class-members
  async confirmTransaction(e, T) {
    var J;
    let $;
    if (typeof e == "string")
      $ = e;
    else {
      const ee = e;
      if ((J = ee.abortSignal) != null && J.aborted)
        return Promise.reject(ee.abortSignal.reason);
      $ = ee.signature;
    }
    let V;
    try {
      V = bs58$6.decode($);
    } catch {
      throw new Error("signature must be base58 encoded: " + $);
    }
    return assert$3(V.length === 64, "signature has invalid length"), typeof e == "string" ? await this.confirmTransactionUsingLegacyTimeoutStrategy({
      commitment: T || this.commitment,
      signature: $
    }) : "lastValidBlockHeight" in e ? await this.confirmTransactionUsingBlockHeightExceedanceStrategy({
      commitment: T || this.commitment,
      strategy: e
    }) : await this.confirmTransactionUsingDurableNonceStrategy({
      commitment: T || this.commitment,
      strategy: e
    });
  }
  getCancellationPromise(e) {
    return new Promise((T, $) => {
      e != null && (e.aborted ? $(e.reason) : e.addEventListener("abort", () => {
        $(e.reason);
      }));
    });
  }
  getTransactionConfirmationPromise({
    commitment: e,
    signature: T
  }) {
    let $, V, J = !1;
    const ee = new Promise((re, ie) => {
      try {
        $ = this.onSignature(T, (de, ue) => {
          $ = void 0;
          const fe = {
            context: ue,
            value: de
          };
          re({
            __type: TransactionStatus.PROCESSED,
            response: fe
          });
        }, e);
        const se = new Promise((de) => {
          $ == null ? de() : V = this._onSubscriptionStateChange($, (ue) => {
            ue === "subscribed" && de();
          });
        });
        (async () => {
          if (await se, J) return;
          const de = await this.getSignatureStatus(T);
          if (J || de == null)
            return;
          const {
            context: ue,
            value: fe
          } = de;
          if (fe != null)
            if (fe != null && fe.err)
              ie(fe.err);
            else {
              switch (e) {
                case "confirmed":
                case "single":
                case "singleGossip": {
                  if (fe.confirmationStatus === "processed")
                    return;
                  break;
                }
                case "finalized":
                case "max":
                case "root": {
                  if (fe.confirmationStatus === "processed" || fe.confirmationStatus === "confirmed")
                    return;
                  break;
                }
                case "processed":
                case "recent":
              }
              J = !0, re({
                __type: TransactionStatus.PROCESSED,
                response: {
                  context: ue,
                  value: fe
                }
              });
            }
        })();
      } catch (se) {
        ie(se);
      }
    });
    return {
      abortConfirmation: () => {
        V && (V(), V = void 0), $ != null && (this.removeSignatureListener($), $ = void 0);
      },
      confirmationPromise: ee
    };
  }
  async confirmTransactionUsingBlockHeightExceedanceStrategy({
    commitment: e,
    strategy: {
      abortSignal: T,
      lastValidBlockHeight: $,
      signature: V
    }
  }) {
    let J = !1;
    const ee = new Promise((de) => {
      const ue = async () => {
        try {
          return await this.getBlockHeight(e);
        } catch {
          return -1;
        }
      };
      (async () => {
        let fe = await ue();
        if (!J) {
          for (; fe <= $; )
            if (await sleep$1(1e3), J || (fe = await ue(), J)) return;
          de({
            __type: TransactionStatus.BLOCKHEIGHT_EXCEEDED
          });
        }
      })();
    }), {
      abortConfirmation: te,
      confirmationPromise: re
    } = this.getTransactionConfirmationPromise({
      commitment: e,
      signature: V
    }), ie = this.getCancellationPromise(T);
    let se;
    try {
      const de = await Promise.race([ie, re, ee]);
      if (de.__type === TransactionStatus.PROCESSED)
        se = de.response;
      else
        throw new TransactionExpiredBlockheightExceededError(V);
    } finally {
      J = !0, te();
    }
    return se;
  }
  async confirmTransactionUsingDurableNonceStrategy({
    commitment: e,
    strategy: {
      abortSignal: T,
      minContextSlot: $,
      nonceAccountPubkey: V,
      nonceValue: J,
      signature: ee
    }
  }) {
    let te = !1;
    const re = new Promise((fe) => {
      let he = J, me = null;
      const xe = async () => {
        try {
          const {
            context: ve,
            value: Te
          } = await this.getNonceAndContext(V, {
            commitment: e,
            minContextSlot: $
          });
          return me = ve.slot, Te == null ? void 0 : Te.nonce;
        } catch {
          return he;
        }
      };
      (async () => {
        if (he = await xe(), !te)
          for (; ; ) {
            if (J !== he) {
              fe({
                __type: TransactionStatus.NONCE_INVALID,
                slotInWhichNonceDidAdvance: me
              });
              return;
            }
            if (await sleep$1(2e3), te || (he = await xe(), te)) return;
          }
      })();
    }), {
      abortConfirmation: ie,
      confirmationPromise: se
    } = this.getTransactionConfirmationPromise({
      commitment: e,
      signature: ee
    }), de = this.getCancellationPromise(T);
    let ue;
    try {
      const fe = await Promise.race([de, se, re]);
      if (fe.__type === TransactionStatus.PROCESSED)
        ue = fe.response;
      else {
        let he;
        for (; ; ) {
          const me = await this.getSignatureStatus(ee);
          if (me == null)
            break;
          if (me.context.slot < (fe.slotInWhichNonceDidAdvance ?? $)) {
            await sleep$1(400);
            continue;
          }
          he = me;
          break;
        }
        if (he != null && he.value) {
          const me = e || "finalized", {
            confirmationStatus: xe
          } = he.value;
          switch (me) {
            case "processed":
            case "recent":
              if (xe !== "processed" && xe !== "confirmed" && xe !== "finalized")
                throw new TransactionExpiredNonceInvalidError(ee);
              break;
            case "confirmed":
            case "single":
            case "singleGossip":
              if (xe !== "confirmed" && xe !== "finalized")
                throw new TransactionExpiredNonceInvalidError(ee);
              break;
            case "finalized":
            case "max":
            case "root":
              if (xe !== "finalized")
                throw new TransactionExpiredNonceInvalidError(ee);
              break;
            default:
          }
          ue = {
            context: he.context,
            value: {
              err: he.value.err
            }
          };
        } else
          throw new TransactionExpiredNonceInvalidError(ee);
      }
    } finally {
      te = !0, ie();
    }
    return ue;
  }
  async confirmTransactionUsingLegacyTimeoutStrategy({
    commitment: e,
    signature: T
  }) {
    let $;
    const V = new Promise((re) => {
      let ie = this._confirmTransactionInitialTimeout || 6e4;
      switch (e) {
        case "processed":
        case "recent":
        case "single":
        case "confirmed":
        case "singleGossip": {
          ie = this._confirmTransactionInitialTimeout || 3e4;
          break;
        }
      }
      $ = setTimeout(() => re({
        __type: TransactionStatus.TIMED_OUT,
        timeoutMs: ie
      }), ie);
    }), {
      abortConfirmation: J,
      confirmationPromise: ee
    } = this.getTransactionConfirmationPromise({
      commitment: e,
      signature: T
    });
    let te;
    try {
      const re = await Promise.race([ee, V]);
      if (re.__type === TransactionStatus.PROCESSED)
        te = re.response;
      else
        throw new TransactionExpiredTimeoutError(T, re.timeoutMs / 1e3);
    } finally {
      clearTimeout($), J();
    }
    return te;
  }
  /**
   * Return the list of nodes that are currently participating in the cluster
   */
  async getClusterNodes() {
    const e = await this._rpcRequest("getClusterNodes", []), T = create$3(e, jsonRpcResult$1(array$2(ContactInfoResult)));
    if ("error" in T)
      throw new SolanaJSONRPCError(T.error, "failed to get cluster nodes");
    return T.result;
  }
  /**
   * Return the list of nodes that are currently participating in the cluster
   */
  async getVoteAccounts(e) {
    const T = this._buildArgs([], e), $ = await this._rpcRequest("getVoteAccounts", T), V = create$3($, GetVoteAccounts);
    if ("error" in V)
      throw new SolanaJSONRPCError(V.error, "failed to get vote accounts");
    return V.result;
  }
  /**
   * Fetch the current slot that the node is processing
   */
  async getSlot(e) {
    const {
      commitment: T,
      config: $
    } = extractCommitmentFromConfig(e), V = this._buildArgs([], T, void 0, $), J = await this._rpcRequest("getSlot", V), ee = create$3(J, jsonRpcResult$1(number$2()));
    if ("error" in ee)
      throw new SolanaJSONRPCError(ee.error, "failed to get slot");
    return ee.result;
  }
  /**
   * Fetch the current slot leader of the cluster
   */
  async getSlotLeader(e) {
    const {
      commitment: T,
      config: $
    } = extractCommitmentFromConfig(e), V = this._buildArgs([], T, void 0, $), J = await this._rpcRequest("getSlotLeader", V), ee = create$3(J, jsonRpcResult$1(string$2()));
    if ("error" in ee)
      throw new SolanaJSONRPCError(ee.error, "failed to get slot leader");
    return ee.result;
  }
  /**
   * Fetch `limit` number of slot leaders starting from `startSlot`
   *
   * @param startSlot fetch slot leaders starting from this slot
   * @param limit number of slot leaders to return
   */
  async getSlotLeaders(e, T) {
    const $ = [e, T], V = await this._rpcRequest("getSlotLeaders", $), J = create$3(V, jsonRpcResult$1(array$2(PublicKeyFromString)));
    if ("error" in J)
      throw new SolanaJSONRPCError(J.error, "failed to get slot leaders");
    return J.result;
  }
  /**
   * Fetch the current status of a signature
   */
  async getSignatureStatus(e, T) {
    const {
      context: $,
      value: V
    } = await this.getSignatureStatuses([e], T);
    assert$3(V.length === 1);
    const J = V[0];
    return {
      context: $,
      value: J
    };
  }
  /**
   * Fetch the current statuses of a batch of signatures
   */
  async getSignatureStatuses(e, T) {
    const $ = [e];
    T && $.push(T);
    const V = await this._rpcRequest("getSignatureStatuses", $), J = create$3(V, GetSignatureStatusesRpcResult);
    if ("error" in J)
      throw new SolanaJSONRPCError(J.error, "failed to get signature status");
    return J.result;
  }
  /**
   * Fetch the current transaction count of the cluster
   */
  async getTransactionCount(e) {
    const {
      commitment: T,
      config: $
    } = extractCommitmentFromConfig(e), V = this._buildArgs([], T, void 0, $), J = await this._rpcRequest("getTransactionCount", V), ee = create$3(J, jsonRpcResult$1(number$2()));
    if ("error" in ee)
      throw new SolanaJSONRPCError(ee.error, "failed to get transaction count");
    return ee.result;
  }
  /**
   * Fetch the current total currency supply of the cluster in lamports
   *
   * @deprecated Deprecated since RPC v1.2.8. Please use {@link getSupply} instead.
   */
  async getTotalSupply(e) {
    return (await this.getSupply({
      commitment: e,
      excludeNonCirculatingAccountsList: !0
    })).value.total;
  }
  /**
   * Fetch the cluster InflationGovernor parameters
   */
  async getInflationGovernor(e) {
    const T = this._buildArgs([], e), $ = await this._rpcRequest("getInflationGovernor", T), V = create$3($, GetInflationGovernorRpcResult);
    if ("error" in V)
      throw new SolanaJSONRPCError(V.error, "failed to get inflation");
    return V.result;
  }
  /**
   * Fetch the inflation reward for a list of addresses for an epoch
   */
  async getInflationReward(e, T, $) {
    const {
      commitment: V,
      config: J
    } = extractCommitmentFromConfig($), ee = this._buildArgs([e.map((ie) => ie.toBase58())], V, void 0, {
      ...J,
      epoch: T ?? (J == null ? void 0 : J.epoch)
    }), te = await this._rpcRequest("getInflationReward", ee), re = create$3(te, GetInflationRewardResult);
    if ("error" in re)
      throw new SolanaJSONRPCError(re.error, "failed to get inflation reward");
    return re.result;
  }
  /**
   * Fetch the specific inflation values for the current epoch
   */
  async getInflationRate() {
    const e = await this._rpcRequest("getInflationRate", []), T = create$3(e, GetInflationRateRpcResult);
    if ("error" in T)
      throw new SolanaJSONRPCError(T.error, "failed to get inflation rate");
    return T.result;
  }
  /**
   * Fetch the Epoch Info parameters
   */
  async getEpochInfo(e) {
    const {
      commitment: T,
      config: $
    } = extractCommitmentFromConfig(e), V = this._buildArgs([], T, void 0, $), J = await this._rpcRequest("getEpochInfo", V), ee = create$3(J, GetEpochInfoRpcResult);
    if ("error" in ee)
      throw new SolanaJSONRPCError(ee.error, "failed to get epoch info");
    return ee.result;
  }
  /**
   * Fetch the Epoch Schedule parameters
   */
  async getEpochSchedule() {
    const e = await this._rpcRequest("getEpochSchedule", []), T = create$3(e, GetEpochScheduleRpcResult);
    if ("error" in T)
      throw new SolanaJSONRPCError(T.error, "failed to get epoch schedule");
    const $ = T.result;
    return new EpochSchedule($.slotsPerEpoch, $.leaderScheduleSlotOffset, $.warmup, $.firstNormalEpoch, $.firstNormalSlot);
  }
  /**
   * Fetch the leader schedule for the current epoch
   * @return {Promise<RpcResponseAndContext<LeaderSchedule>>}
   */
  async getLeaderSchedule() {
    const e = await this._rpcRequest("getLeaderSchedule", []), T = create$3(e, GetLeaderScheduleRpcResult);
    if ("error" in T)
      throw new SolanaJSONRPCError(T.error, "failed to get leader schedule");
    return T.result;
  }
  /**
   * Fetch the minimum balance needed to exempt an account of `dataLength`
   * size from rent
   */
  async getMinimumBalanceForRentExemption(e, T) {
    const $ = this._buildArgs([e], T), V = await this._rpcRequest("getMinimumBalanceForRentExemption", $), J = create$3(V, GetMinimumBalanceForRentExemptionRpcResult);
    return "error" in J ? (console.warn("Unable to fetch minimum balance for rent exemption"), 0) : J.result;
  }
  /**
   * Fetch a recent blockhash from the cluster, return with context
   * @return {Promise<RpcResponseAndContext<{blockhash: Blockhash, feeCalculator: FeeCalculator}>>}
   *
   * @deprecated Deprecated since RPC v1.9.0. Please use {@link getLatestBlockhash} instead.
   */
  async getRecentBlockhashAndContext(e) {
    const {
      context: T,
      value: {
        blockhash: $
      }
    } = await this.getLatestBlockhashAndContext(e);
    return {
      context: T,
      value: {
        blockhash: $,
        feeCalculator: {
          get lamportsPerSignature() {
            throw new Error("The capability to fetch `lamportsPerSignature` using the `getRecentBlockhash` API is no longer offered by the network. Use the `getFeeForMessage` API to obtain the fee for a given message.");
          },
          toJSON() {
            return {};
          }
        }
      }
    };
  }
  /**
   * Fetch recent performance samples
   * @return {Promise<Array<PerfSample>>}
   */
  async getRecentPerformanceSamples(e) {
    const T = await this._rpcRequest("getRecentPerformanceSamples", e ? [e] : []), $ = create$3(T, GetRecentPerformanceSamplesRpcResult);
    if ("error" in $)
      throw new SolanaJSONRPCError($.error, "failed to get recent performance samples");
    return $.result;
  }
  /**
   * Fetch the fee calculator for a recent blockhash from the cluster, return with context
   *
   * @deprecated Deprecated since RPC v1.9.0. Please use {@link getFeeForMessage} instead.
   */
  async getFeeCalculatorForBlockhash(e, T) {
    const $ = this._buildArgs([e], T), V = await this._rpcRequest("getFeeCalculatorForBlockhash", $), J = create$3(V, GetFeeCalculatorRpcResult);
    if ("error" in J)
      throw new SolanaJSONRPCError(J.error, "failed to get fee calculator");
    const {
      context: ee,
      value: te
    } = J.result;
    return {
      context: ee,
      value: te !== null ? te.feeCalculator : null
    };
  }
  /**
   * Fetch the fee for a message from the cluster, return with context
   */
  async getFeeForMessage(e, T) {
    const $ = toBuffer(e.serialize()).toString("base64"), V = this._buildArgs([$], T), J = await this._rpcRequest("getFeeForMessage", V), ee = create$3(J, jsonRpcResultAndContext$1(nullable$2(number$2())));
    if ("error" in ee)
      throw new SolanaJSONRPCError(ee.error, "failed to get fee for message");
    if (ee.result === null)
      throw new Error("invalid blockhash");
    return ee.result;
  }
  /**
   * Fetch a list of prioritization fees from recent blocks.
   */
  async getRecentPrioritizationFees(e) {
    var ee;
    const T = (ee = e == null ? void 0 : e.lockedWritableAccounts) == null ? void 0 : ee.map((te) => te.toBase58()), $ = T != null && T.length ? [T] : [], V = await this._rpcRequest("getRecentPrioritizationFees", $), J = create$3(V, GetRecentPrioritizationFeesRpcResult);
    if ("error" in J)
      throw new SolanaJSONRPCError(J.error, "failed to get recent prioritization fees");
    return J.result;
  }
  /**
   * Fetch a recent blockhash from the cluster
   * @return {Promise<{blockhash: Blockhash, feeCalculator: FeeCalculator}>}
   *
   * @deprecated Deprecated since RPC v1.8.0. Please use {@link getLatestBlockhash} instead.
   */
  async getRecentBlockhash(e) {
    try {
      return (await this.getRecentBlockhashAndContext(e)).value;
    } catch (T) {
      throw new Error("failed to get recent blockhash: " + T);
    }
  }
  /**
   * Fetch the latest blockhash from the cluster
   * @return {Promise<BlockhashWithExpiryBlockHeight>}
   */
  async getLatestBlockhash(e) {
    try {
      return (await this.getLatestBlockhashAndContext(e)).value;
    } catch (T) {
      throw new Error("failed to get recent blockhash: " + T);
    }
  }
  /**
   * Fetch the latest blockhash from the cluster
   * @return {Promise<BlockhashWithExpiryBlockHeight>}
   */
  async getLatestBlockhashAndContext(e) {
    const {
      commitment: T,
      config: $
    } = extractCommitmentFromConfig(e), V = this._buildArgs([], T, void 0, $), J = await this._rpcRequest("getLatestBlockhash", V), ee = create$3(J, GetLatestBlockhashRpcResult);
    if ("error" in ee)
      throw new SolanaJSONRPCError(ee.error, "failed to get latest blockhash");
    return ee.result;
  }
  /**
   * Returns whether a blockhash is still valid or not
   */
  async isBlockhashValid(e, T) {
    const {
      commitment: $,
      config: V
    } = extractCommitmentFromConfig(T), J = this._buildArgs([e], $, void 0, V), ee = await this._rpcRequest("isBlockhashValid", J), te = create$3(ee, IsBlockhashValidRpcResult);
    if ("error" in te)
      throw new SolanaJSONRPCError(te.error, "failed to determine if the blockhash `" + e + "`is valid");
    return te.result;
  }
  /**
   * Fetch the node version
   */
  async getVersion() {
    const e = await this._rpcRequest("getVersion", []), T = create$3(e, jsonRpcResult$1(VersionResult));
    if ("error" in T)
      throw new SolanaJSONRPCError(T.error, "failed to get version");
    return T.result;
  }
  /**
   * Fetch the genesis hash
   */
  async getGenesisHash() {
    const e = await this._rpcRequest("getGenesisHash", []), T = create$3(e, jsonRpcResult$1(string$2()));
    if ("error" in T)
      throw new SolanaJSONRPCError(T.error, "failed to get genesis hash");
    return T.result;
  }
  /**
   * Fetch a processed block from the cluster.
   *
   * @deprecated Instead, call `getBlock` using a `GetVersionedBlockConfig` by
   * setting the `maxSupportedTransactionVersion` property.
   */
  /**
   * @deprecated Instead, call `getBlock` using a `GetVersionedBlockConfig` by
   * setting the `maxSupportedTransactionVersion` property.
   */
  // eslint-disable-next-line no-dupe-class-members
  /**
   * @deprecated Instead, call `getBlock` using a `GetVersionedBlockConfig` by
   * setting the `maxSupportedTransactionVersion` property.
   */
  // eslint-disable-next-line no-dupe-class-members
  /**
   * Fetch a processed block from the cluster.
   */
  // eslint-disable-next-line no-dupe-class-members
  // eslint-disable-next-line no-dupe-class-members
  // eslint-disable-next-line no-dupe-class-members
  /**
   * Fetch a processed block from the cluster.
   */
  // eslint-disable-next-line no-dupe-class-members
  async getBlock(e, T) {
    const {
      commitment: $,
      config: V
    } = extractCommitmentFromConfig(T), J = this._buildArgsAtLeastConfirmed([e], $, void 0, V), ee = await this._rpcRequest("getBlock", J);
    try {
      switch (V == null ? void 0 : V.transactionDetails) {
        case "accounts": {
          const te = create$3(ee, GetAccountsModeBlockRpcResult);
          if ("error" in te)
            throw te.error;
          return te.result;
        }
        case "none": {
          const te = create$3(ee, GetNoneModeBlockRpcResult);
          if ("error" in te)
            throw te.error;
          return te.result;
        }
        default: {
          const te = create$3(ee, GetBlockRpcResult);
          if ("error" in te)
            throw te.error;
          const {
            result: re
          } = te;
          return re ? {
            ...re,
            transactions: re.transactions.map(({
              transaction: ie,
              meta: se,
              version: de
            }) => ({
              meta: se,
              transaction: {
                ...ie,
                message: versionedMessageFromResponse(de, ie.message)
              },
              version: de
            }))
          } : null;
        }
      }
    } catch (te) {
      throw new SolanaJSONRPCError(te, "failed to get confirmed block");
    }
  }
  /**
   * Fetch parsed transaction details for a confirmed or finalized block
   */
  // eslint-disable-next-line no-dupe-class-members
  // eslint-disable-next-line no-dupe-class-members
  // eslint-disable-next-line no-dupe-class-members
  async getParsedBlock(e, T) {
    const {
      commitment: $,
      config: V
    } = extractCommitmentFromConfig(T), J = this._buildArgsAtLeastConfirmed([e], $, "jsonParsed", V), ee = await this._rpcRequest("getBlock", J);
    try {
      switch (V == null ? void 0 : V.transactionDetails) {
        case "accounts": {
          const te = create$3(ee, GetParsedAccountsModeBlockRpcResult);
          if ("error" in te)
            throw te.error;
          return te.result;
        }
        case "none": {
          const te = create$3(ee, GetParsedNoneModeBlockRpcResult);
          if ("error" in te)
            throw te.error;
          return te.result;
        }
        default: {
          const te = create$3(ee, GetParsedBlockRpcResult);
          if ("error" in te)
            throw te.error;
          return te.result;
        }
      }
    } catch (te) {
      throw new SolanaJSONRPCError(te, "failed to get block");
    }
  }
  /*
   * Returns recent block production information from the current or previous epoch
   */
  async getBlockProduction(e) {
    let T, $;
    if (typeof e == "string")
      $ = e;
    else if (e) {
      const {
        commitment: te,
        ...re
      } = e;
      $ = te, T = re;
    }
    const V = this._buildArgs([], $, "base64", T), J = await this._rpcRequest("getBlockProduction", V), ee = create$3(J, BlockProductionResponseStruct);
    if ("error" in ee)
      throw new SolanaJSONRPCError(ee.error, "failed to get block production information");
    return ee.result;
  }
  /**
   * Fetch a confirmed or finalized transaction from the cluster.
   *
   * @deprecated Instead, call `getTransaction` using a
   * `GetVersionedTransactionConfig` by setting the
   * `maxSupportedTransactionVersion` property.
   */
  /**
   * Fetch a confirmed or finalized transaction from the cluster.
   */
  // eslint-disable-next-line no-dupe-class-members
  /**
   * Fetch a confirmed or finalized transaction from the cluster.
   */
  // eslint-disable-next-line no-dupe-class-members
  async getTransaction(e, T) {
    const {
      commitment: $,
      config: V
    } = extractCommitmentFromConfig(T), J = this._buildArgsAtLeastConfirmed([e], $, void 0, V), ee = await this._rpcRequest("getTransaction", J), te = create$3(ee, GetTransactionRpcResult);
    if ("error" in te)
      throw new SolanaJSONRPCError(te.error, "failed to get transaction");
    const re = te.result;
    return re && {
      ...re,
      transaction: {
        ...re.transaction,
        message: versionedMessageFromResponse(re.version, re.transaction.message)
      }
    };
  }
  /**
   * Fetch parsed transaction details for a confirmed or finalized transaction
   */
  async getParsedTransaction(e, T) {
    const {
      commitment: $,
      config: V
    } = extractCommitmentFromConfig(T), J = this._buildArgsAtLeastConfirmed([e], $, "jsonParsed", V), ee = await this._rpcRequest("getTransaction", J), te = create$3(ee, GetParsedTransactionRpcResult);
    if ("error" in te)
      throw new SolanaJSONRPCError(te.error, "failed to get transaction");
    return te.result;
  }
  /**
   * Fetch parsed transaction details for a batch of confirmed transactions
   */
  async getParsedTransactions(e, T) {
    const {
      commitment: $,
      config: V
    } = extractCommitmentFromConfig(T), J = e.map((re) => ({
      methodName: "getTransaction",
      args: this._buildArgsAtLeastConfirmed([re], $, "jsonParsed", V)
    }));
    return (await this._rpcBatchRequest(J)).map((re) => {
      const ie = create$3(re, GetParsedTransactionRpcResult);
      if ("error" in ie)
        throw new SolanaJSONRPCError(ie.error, "failed to get transactions");
      return ie.result;
    });
  }
  /**
   * Fetch transaction details for a batch of confirmed transactions.
   * Similar to {@link getParsedTransactions} but returns a {@link TransactionResponse}.
   *
   * @deprecated Instead, call `getTransactions` using a
   * `GetVersionedTransactionConfig` by setting the
   * `maxSupportedTransactionVersion` property.
   */
  /**
   * Fetch transaction details for a batch of confirmed transactions.
   * Similar to {@link getParsedTransactions} but returns a {@link
   * VersionedTransactionResponse}.
   */
  // eslint-disable-next-line no-dupe-class-members
  /**
   * Fetch transaction details for a batch of confirmed transactions.
   * Similar to {@link getParsedTransactions} but returns a {@link
   * VersionedTransactionResponse}.
   */
  // eslint-disable-next-line no-dupe-class-members
  async getTransactions(e, T) {
    const {
      commitment: $,
      config: V
    } = extractCommitmentFromConfig(T), J = e.map((re) => ({
      methodName: "getTransaction",
      args: this._buildArgsAtLeastConfirmed([re], $, void 0, V)
    }));
    return (await this._rpcBatchRequest(J)).map((re) => {
      const ie = create$3(re, GetTransactionRpcResult);
      if ("error" in ie)
        throw new SolanaJSONRPCError(ie.error, "failed to get transactions");
      const se = ie.result;
      return se && {
        ...se,
        transaction: {
          ...se.transaction,
          message: versionedMessageFromResponse(se.version, se.transaction.message)
        }
      };
    });
  }
  /**
   * Fetch a list of Transactions and transaction statuses from the cluster
   * for a confirmed block.
   *
   * @deprecated Deprecated since RPC v1.7.0. Please use {@link getBlock} instead.
   */
  async getConfirmedBlock(e, T) {
    const $ = this._buildArgsAtLeastConfirmed([e], T), V = await this._rpcRequest("getBlock", $), J = create$3(V, GetConfirmedBlockRpcResult);
    if ("error" in J)
      throw new SolanaJSONRPCError(J.error, "failed to get confirmed block");
    const ee = J.result;
    if (!ee)
      throw new Error("Confirmed block " + e + " not found");
    const te = {
      ...ee,
      transactions: ee.transactions.map(({
        transaction: re,
        meta: ie
      }) => {
        const se = new Message(re.message);
        return {
          meta: ie,
          transaction: {
            ...re,
            message: se
          }
        };
      })
    };
    return {
      ...te,
      transactions: te.transactions.map(({
        transaction: re,
        meta: ie
      }) => ({
        meta: ie,
        transaction: Transaction.populate(re.message, re.signatures)
      }))
    };
  }
  /**
   * Fetch confirmed blocks between two slots
   */
  async getBlocks(e, T, $) {
    const V = this._buildArgsAtLeastConfirmed(T !== void 0 ? [e, T] : [e], $), J = await this._rpcRequest("getBlocks", V), ee = create$3(J, jsonRpcResult$1(array$2(number$2())));
    if ("error" in ee)
      throw new SolanaJSONRPCError(ee.error, "failed to get blocks");
    return ee.result;
  }
  /**
   * Fetch a list of Signatures from the cluster for a block, excluding rewards
   */
  async getBlockSignatures(e, T) {
    const $ = this._buildArgsAtLeastConfirmed([e], T, void 0, {
      transactionDetails: "signatures",
      rewards: !1
    }), V = await this._rpcRequest("getBlock", $), J = create$3(V, GetBlockSignaturesRpcResult);
    if ("error" in J)
      throw new SolanaJSONRPCError(J.error, "failed to get block");
    const ee = J.result;
    if (!ee)
      throw new Error("Block " + e + " not found");
    return ee;
  }
  /**
   * Fetch a list of Signatures from the cluster for a confirmed block, excluding rewards
   *
   * @deprecated Deprecated since RPC v1.7.0. Please use {@link getBlockSignatures} instead.
   */
  async getConfirmedBlockSignatures(e, T) {
    const $ = this._buildArgsAtLeastConfirmed([e], T, void 0, {
      transactionDetails: "signatures",
      rewards: !1
    }), V = await this._rpcRequest("getBlock", $), J = create$3(V, GetBlockSignaturesRpcResult);
    if ("error" in J)
      throw new SolanaJSONRPCError(J.error, "failed to get confirmed block");
    const ee = J.result;
    if (!ee)
      throw new Error("Confirmed block " + e + " not found");
    return ee;
  }
  /**
   * Fetch a transaction details for a confirmed transaction
   *
   * @deprecated Deprecated since RPC v1.7.0. Please use {@link getTransaction} instead.
   */
  async getConfirmedTransaction(e, T) {
    const $ = this._buildArgsAtLeastConfirmed([e], T), V = await this._rpcRequest("getTransaction", $), J = create$3(V, GetTransactionRpcResult);
    if ("error" in J)
      throw new SolanaJSONRPCError(J.error, "failed to get transaction");
    const ee = J.result;
    if (!ee) return ee;
    const te = new Message(ee.transaction.message), re = ee.transaction.signatures;
    return {
      ...ee,
      transaction: Transaction.populate(te, re)
    };
  }
  /**
   * Fetch parsed transaction details for a confirmed transaction
   *
   * @deprecated Deprecated since RPC v1.7.0. Please use {@link getParsedTransaction} instead.
   */
  async getParsedConfirmedTransaction(e, T) {
    const $ = this._buildArgsAtLeastConfirmed([e], T, "jsonParsed"), V = await this._rpcRequest("getTransaction", $), J = create$3(V, GetParsedTransactionRpcResult);
    if ("error" in J)
      throw new SolanaJSONRPCError(J.error, "failed to get confirmed transaction");
    return J.result;
  }
  /**
   * Fetch parsed transaction details for a batch of confirmed transactions
   *
   * @deprecated Deprecated since RPC v1.7.0. Please use {@link getParsedTransactions} instead.
   */
  async getParsedConfirmedTransactions(e, T) {
    const $ = e.map((ee) => ({
      methodName: "getTransaction",
      args: this._buildArgsAtLeastConfirmed([ee], T, "jsonParsed")
    }));
    return (await this._rpcBatchRequest($)).map((ee) => {
      const te = create$3(ee, GetParsedTransactionRpcResult);
      if ("error" in te)
        throw new SolanaJSONRPCError(te.error, "failed to get confirmed transactions");
      return te.result;
    });
  }
  /**
   * Fetch a list of all the confirmed signatures for transactions involving an address
   * within a specified slot range. Max range allowed is 10,000 slots.
   *
   * @deprecated Deprecated since RPC v1.3. Please use {@link getConfirmedSignaturesForAddress2} instead.
   *
   * @param address queried address
   * @param startSlot start slot, inclusive
   * @param endSlot end slot, inclusive
   */
  async getConfirmedSignaturesForAddress(e, T, $) {
    let V = {}, J = await this.getFirstAvailableBlock();
    for (; !("until" in V) && (T--, !(T <= 0 || T < J)); )
      try {
        const re = await this.getConfirmedBlockSignatures(T, "finalized");
        re.signatures.length > 0 && (V.until = re.signatures[re.signatures.length - 1].toString());
      } catch (re) {
        if (re instanceof Error && re.message.includes("skipped"))
          continue;
        throw re;
      }
    let ee = await this.getSlot("finalized");
    for (; !("before" in V) && ($++, !($ > ee)); )
      try {
        const re = await this.getConfirmedBlockSignatures($);
        re.signatures.length > 0 && (V.before = re.signatures[re.signatures.length - 1].toString());
      } catch (re) {
        if (re instanceof Error && re.message.includes("skipped"))
          continue;
        throw re;
      }
    return (await this.getConfirmedSignaturesForAddress2(e, V)).map((re) => re.signature);
  }
  /**
   * Returns confirmed signatures for transactions involving an
   * address backwards in time from the provided signature or most recent confirmed block
   *
   * @deprecated Deprecated since RPC v1.7.0. Please use {@link getSignaturesForAddress} instead.
   */
  async getConfirmedSignaturesForAddress2(e, T, $) {
    const V = this._buildArgsAtLeastConfirmed([e.toBase58()], $, void 0, T), J = await this._rpcRequest("getConfirmedSignaturesForAddress2", V), ee = create$3(J, GetConfirmedSignaturesForAddress2RpcResult);
    if ("error" in ee)
      throw new SolanaJSONRPCError(ee.error, "failed to get confirmed signatures for address");
    return ee.result;
  }
  /**
   * Returns confirmed signatures for transactions involving an
   * address backwards in time from the provided signature or most recent confirmed block
   *
   *
   * @param address queried address
   * @param options
   */
  async getSignaturesForAddress(e, T, $) {
    const V = this._buildArgsAtLeastConfirmed([e.toBase58()], $, void 0, T), J = await this._rpcRequest("getSignaturesForAddress", V), ee = create$3(J, GetSignaturesForAddressRpcResult);
    if ("error" in ee)
      throw new SolanaJSONRPCError(ee.error, "failed to get signatures for address");
    return ee.result;
  }
  async getAddressLookupTable(e, T) {
    const {
      context: $,
      value: V
    } = await this.getAccountInfoAndContext(e, T);
    let J = null;
    return V !== null && (J = new AddressLookupTableAccount({
      key: e,
      state: AddressLookupTableAccount.deserialize(V.data)
    })), {
      context: $,
      value: J
    };
  }
  /**
   * Fetch the contents of a Nonce account from the cluster, return with context
   */
  async getNonceAndContext(e, T) {
    const {
      context: $,
      value: V
    } = await this.getAccountInfoAndContext(e, T);
    let J = null;
    return V !== null && (J = NonceAccount.fromAccountData(V.data)), {
      context: $,
      value: J
    };
  }
  /**
   * Fetch the contents of a Nonce account from the cluster
   */
  async getNonce(e, T) {
    return await this.getNonceAndContext(e, T).then(($) => $.value).catch(($) => {
      throw new Error("failed to get nonce for account " + e.toBase58() + ": " + $);
    });
  }
  /**
   * Request an allocation of lamports to the specified address
   *
   * ```typescript
   * import { Connection, PublicKey, LAMPORTS_PER_SOL } from "@solana/web3.js";
   *
   * (async () => {
   *   const connection = new Connection("https://api.testnet.solana.com", "confirmed");
   *   const myAddress = new PublicKey("2nr1bHFT86W9tGnyvmYW4vcHKsQB3sVQfnddasz4kExM");
   *   const signature = await connection.requestAirdrop(myAddress, LAMPORTS_PER_SOL);
   *   await connection.confirmTransaction(signature);
   * })();
   * ```
   */
  async requestAirdrop(e, T) {
    const $ = await this._rpcRequest("requestAirdrop", [e.toBase58(), T]), V = create$3($, RequestAirdropRpcResult);
    if ("error" in V)
      throw new SolanaJSONRPCError(V.error, `airdrop to ${e.toBase58()} failed`);
    return V.result;
  }
  /**
   * @internal
   */
  async _blockhashWithExpiryBlockHeight(e) {
    if (!e) {
      for (; this._pollingBlockhash; )
        await sleep$1(100);
      const $ = Date.now() - this._blockhashInfo.lastFetch >= BLOCKHASH_CACHE_TIMEOUT_MS;
      if (this._blockhashInfo.latestBlockhash !== null && !$)
        return this._blockhashInfo.latestBlockhash;
    }
    return await this._pollNewBlockhash();
  }
  /**
   * @internal
   */
  async _pollNewBlockhash() {
    this._pollingBlockhash = !0;
    try {
      const e = Date.now(), T = this._blockhashInfo.latestBlockhash, $ = T ? T.blockhash : null;
      for (let V = 0; V < 50; V++) {
        const J = await this.getLatestBlockhash("finalized");
        if ($ !== J.blockhash)
          return this._blockhashInfo = {
            latestBlockhash: J,
            lastFetch: Date.now(),
            transactionSignatures: [],
            simulatedSignatures: []
          }, J;
        await sleep$1(MS_PER_SLOT / 2);
      }
      throw new Error(`Unable to obtain a new blockhash after ${Date.now() - e}ms`);
    } finally {
      this._pollingBlockhash = !1;
    }
  }
  /**
   * get the stake minimum delegation
   */
  async getStakeMinimumDelegation(e) {
    const {
      commitment: T,
      config: $
    } = extractCommitmentFromConfig(e), V = this._buildArgs([], T, "base64", $), J = await this._rpcRequest("getStakeMinimumDelegation", V), ee = create$3(J, jsonRpcResultAndContext$1(number$2()));
    if ("error" in ee)
      throw new SolanaJSONRPCError(ee.error, "failed to get stake minimum delegation");
    return ee.result;
  }
  /**
   * Simulate a transaction
   *
   * @deprecated Instead, call {@link simulateTransaction} with {@link
   * VersionedTransaction} and {@link SimulateTransactionConfig} parameters
   */
  /**
   * Simulate a transaction
   */
  // eslint-disable-next-line no-dupe-class-members
  /**
   * Simulate a transaction
   */
  // eslint-disable-next-line no-dupe-class-members
  async simulateTransaction(e, T, $) {
    if ("message" in e) {
      const me = e.serialize(), xe = bufferPolyfill.Buffer.from(me).toString("base64");
      if (Array.isArray(T) || $ !== void 0)
        throw new Error("Invalid arguments");
      const ve = T || {};
      ve.encoding = "base64", "commitment" in ve || (ve.commitment = this.commitment), T && typeof T == "object" && "innerInstructions" in T && (ve.innerInstructions = T.innerInstructions);
      const Te = [xe, ve], we = await this._rpcRequest("simulateTransaction", Te), Ee = create$3(we, SimulatedTransactionResponseStruct$1);
      if ("error" in Ee)
        throw new Error("failed to simulate transaction: " + Ee.error.message);
      return Ee.result;
    }
    let V;
    if (e instanceof Transaction) {
      let he = e;
      V = new Transaction(), V.feePayer = he.feePayer, V.instructions = e.instructions, V.nonceInfo = he.nonceInfo, V.signatures = he.signatures;
    } else
      V = Transaction.populate(e), V._message = V._json = void 0;
    if (T !== void 0 && !Array.isArray(T))
      throw new Error("Invalid arguments");
    const J = T;
    if (V.nonceInfo && J)
      V.sign(...J);
    else {
      let he = this._disableBlockhashCaching;
      for (; ; ) {
        const me = await this._blockhashWithExpiryBlockHeight(he);
        if (V.lastValidBlockHeight = me.lastValidBlockHeight, V.recentBlockhash = me.blockhash, !J) break;
        if (V.sign(...J), !V.signature)
          throw new Error("!signature");
        const xe = V.signature.toString("base64");
        if (!this._blockhashInfo.simulatedSignatures.includes(xe) && !this._blockhashInfo.transactionSignatures.includes(xe)) {
          this._blockhashInfo.simulatedSignatures.push(xe);
          break;
        } else
          he = !0;
      }
    }
    const ee = V._compile(), te = ee.serialize(), ie = V._serialize(te).toString("base64"), se = {
      encoding: "base64",
      commitment: this.commitment
    };
    if ($) {
      const he = (Array.isArray($) ? $ : ee.nonProgramIds()).map((me) => me.toBase58());
      se.accounts = {
        encoding: "base64",
        addresses: he
      };
    }
    J && (se.sigVerify = !0), T && typeof T == "object" && "innerInstructions" in T && (se.innerInstructions = T.innerInstructions);
    const de = [ie, se], ue = await this._rpcRequest("simulateTransaction", de), fe = create$3(ue, SimulatedTransactionResponseStruct$1);
    if ("error" in fe) {
      let he;
      if ("data" in fe.error && (he = fe.error.data.logs, he && Array.isArray(he))) {
        const me = `
    `, xe = me + he.join(me);
        console.error(fe.error.message, xe);
      }
      throw new SendTransactionError({
        action: "simulate",
        signature: "",
        transactionMessage: fe.error.message,
        logs: he
      });
    }
    return fe.result;
  }
  /**
   * Sign and send a transaction
   *
   * @deprecated Instead, call {@link sendTransaction} with a {@link
   * VersionedTransaction}
   */
  /**
   * Send a signed transaction
   */
  // eslint-disable-next-line no-dupe-class-members
  /**
   * Sign and send a transaction
   */
  // eslint-disable-next-line no-dupe-class-members
  async sendTransaction(e, T, $) {
    if ("version" in e) {
      if (T && Array.isArray(T))
        throw new Error("Invalid arguments");
      const ee = e.serialize();
      return await this.sendRawTransaction(ee, T);
    }
    if (T === void 0 || !Array.isArray(T))
      throw new Error("Invalid arguments");
    const V = T;
    if (e.nonceInfo)
      e.sign(...V);
    else {
      let ee = this._disableBlockhashCaching;
      for (; ; ) {
        const te = await this._blockhashWithExpiryBlockHeight(ee);
        if (e.lastValidBlockHeight = te.lastValidBlockHeight, e.recentBlockhash = te.blockhash, e.sign(...V), !e.signature)
          throw new Error("!signature");
        const re = e.signature.toString("base64");
        if (this._blockhashInfo.transactionSignatures.includes(re))
          ee = !0;
        else {
          this._blockhashInfo.transactionSignatures.push(re);
          break;
        }
      }
    }
    const J = e.serialize();
    return await this.sendRawTransaction(J, $);
  }
  /**
   * Send a transaction that has already been signed and serialized into the
   * wire format
   */
  async sendRawTransaction(e, T) {
    const $ = toBuffer(e).toString("base64");
    return await this.sendEncodedTransaction($, T);
  }
  /**
   * Send a transaction that has already been signed, serialized into the
   * wire format, and encoded as a base64 string
   */
  async sendEncodedTransaction(e, T) {
    const $ = {
      encoding: "base64"
    }, V = T && T.skipPreflight, J = V === !0 ? "processed" : T && T.preflightCommitment || this.commitment;
    T && T.maxRetries != null && ($.maxRetries = T.maxRetries), T && T.minContextSlot != null && ($.minContextSlot = T.minContextSlot), V && ($.skipPreflight = V), J && ($.preflightCommitment = J);
    const ee = [e, $], te = await this._rpcRequest("sendTransaction", ee), re = create$3(te, SendTransactionRpcResult);
    if ("error" in re) {
      let ie;
      throw "data" in re.error && (ie = re.error.data.logs), new SendTransactionError({
        action: V ? "send" : "simulate",
        signature: "",
        transactionMessage: re.error.message,
        logs: ie
      });
    }
    return re.result;
  }
  /**
   * @internal
   */
  _wsOnOpen() {
    this._rpcWebSocketConnected = !0, this._rpcWebSocketHeartbeat = setInterval(() => {
      (async () => {
        try {
          await this._rpcWebSocket.notify("ping");
        } catch {
        }
      })();
    }, 5e3), this._updateSubscriptions();
  }
  /**
   * @internal
   */
  _wsOnError(e) {
    this._rpcWebSocketConnected = !1, console.error("ws error:", e.message);
  }
  /**
   * @internal
   */
  _wsOnClose(e) {
    if (this._rpcWebSocketConnected = !1, this._rpcWebSocketGeneration = (this._rpcWebSocketGeneration + 1) % Number.MAX_SAFE_INTEGER, this._rpcWebSocketIdleTimeout && (clearTimeout(this._rpcWebSocketIdleTimeout), this._rpcWebSocketIdleTimeout = null), this._rpcWebSocketHeartbeat && (clearInterval(this._rpcWebSocketHeartbeat), this._rpcWebSocketHeartbeat = null), e === 1e3) {
      this._updateSubscriptions();
      return;
    }
    this._subscriptionCallbacksByServerSubscriptionId = {}, Object.entries(this._subscriptionsByHash).forEach(([T, $]) => {
      this._setSubscription(T, {
        ...$,
        state: "pending"
      });
    });
  }
  /**
   * @internal
   */
  _setSubscription(e, T) {
    var V;
    const $ = (V = this._subscriptionsByHash[e]) == null ? void 0 : V.state;
    if (this._subscriptionsByHash[e] = T, $ !== T.state) {
      const J = this._subscriptionStateChangeCallbacksByHash[e];
      J && J.forEach((ee) => {
        try {
          ee(T.state);
        } catch {
        }
      });
    }
  }
  /**
   * @internal
   */
  _onSubscriptionStateChange(e, T) {
    var J;
    const $ = this._subscriptionHashByClientSubscriptionId[e];
    if ($ == null)
      return () => {
      };
    const V = (J = this._subscriptionStateChangeCallbacksByHash)[$] || (J[$] = /* @__PURE__ */ new Set());
    return V.add(T), () => {
      V.delete(T), V.size === 0 && delete this._subscriptionStateChangeCallbacksByHash[$];
    };
  }
  /**
   * @internal
   */
  async _updateSubscriptions() {
    if (Object.keys(this._subscriptionsByHash).length === 0) {
      this._rpcWebSocketConnected && (this._rpcWebSocketConnected = !1, this._rpcWebSocketIdleTimeout = setTimeout(() => {
        this._rpcWebSocketIdleTimeout = null;
        try {
          this._rpcWebSocket.close();
        } catch ($) {
          $ instanceof Error && console.log(`Error when closing socket connection: ${$.message}`);
        }
      }, 500));
      return;
    }
    if (this._rpcWebSocketIdleTimeout !== null && (clearTimeout(this._rpcWebSocketIdleTimeout), this._rpcWebSocketIdleTimeout = null, this._rpcWebSocketConnected = !0), !this._rpcWebSocketConnected) {
      this._rpcWebSocket.connect();
      return;
    }
    const e = this._rpcWebSocketGeneration, T = () => e === this._rpcWebSocketGeneration;
    await Promise.all(
      // Don't be tempted to change this to `Object.entries`. We call
      // `_updateSubscriptions` recursively when processing the state,
      // so it's important that we look up the *current* version of
      // each subscription, every time we process a hash.
      Object.keys(this._subscriptionsByHash).map(async ($) => {
        const V = this._subscriptionsByHash[$];
        if (V !== void 0)
          switch (V.state) {
            case "pending":
            case "unsubscribed":
              if (V.callbacks.size === 0) {
                delete this._subscriptionsByHash[$], V.state === "unsubscribed" && delete this._subscriptionCallbacksByServerSubscriptionId[V.serverSubscriptionId], await this._updateSubscriptions();
                return;
              }
              await (async () => {
                const {
                  args: J,
                  method: ee
                } = V;
                try {
                  this._setSubscription($, {
                    ...V,
                    state: "subscribing"
                  });
                  const te = await this._rpcWebSocket.call(ee, J);
                  this._setSubscription($, {
                    ...V,
                    serverSubscriptionId: te,
                    state: "subscribed"
                  }), this._subscriptionCallbacksByServerSubscriptionId[te] = V.callbacks, await this._updateSubscriptions();
                } catch (te) {
                  if (console.error(`Received ${te instanceof Error ? "" : "JSON-RPC "}error calling \`${ee}\``, {
                    args: J,
                    error: te
                  }), !T())
                    return;
                  this._setSubscription($, {
                    ...V,
                    state: "pending"
                  }), await this._updateSubscriptions();
                }
              })();
              break;
            case "subscribed":
              V.callbacks.size === 0 && await (async () => {
                const {
                  serverSubscriptionId: J,
                  unsubscribeMethod: ee
                } = V;
                if (this._subscriptionsAutoDisposedByRpc.has(J))
                  this._subscriptionsAutoDisposedByRpc.delete(J);
                else {
                  this._setSubscription($, {
                    ...V,
                    state: "unsubscribing"
                  }), this._setSubscription($, {
                    ...V,
                    state: "unsubscribing"
                  });
                  try {
                    await this._rpcWebSocket.call(ee, [J]);
                  } catch (te) {
                    if (te instanceof Error && console.error(`${ee} error:`, te.message), !T())
                      return;
                    this._setSubscription($, {
                      ...V,
                      state: "subscribed"
                    }), await this._updateSubscriptions();
                    return;
                  }
                }
                this._setSubscription($, {
                  ...V,
                  state: "unsubscribed"
                }), await this._updateSubscriptions();
              })();
              break;
          }
      })
    );
  }
  /**
   * @internal
   */
  _handleServerNotification(e, T) {
    const $ = this._subscriptionCallbacksByServerSubscriptionId[e];
    $ !== void 0 && $.forEach((V) => {
      try {
        V(
          ...T
        );
      } catch (J) {
        console.error(J);
      }
    });
  }
  /**
   * @internal
   */
  _wsOnAccountNotification(e) {
    const {
      result: T,
      subscription: $
    } = create$3(e, AccountNotificationResult);
    this._handleServerNotification($, [T.value, T.context]);
  }
  /**
   * @internal
   */
  _makeSubscription(e, T) {
    const $ = this._nextClientSubscriptionId++, V = fastStableStringify([e.method, T]), J = this._subscriptionsByHash[V];
    return J === void 0 ? this._subscriptionsByHash[V] = {
      ...e,
      args: T,
      callbacks: /* @__PURE__ */ new Set([e.callback]),
      state: "pending"
    } : J.callbacks.add(e.callback), this._subscriptionHashByClientSubscriptionId[$] = V, this._subscriptionDisposeFunctionsByClientSubscriptionId[$] = async () => {
      delete this._subscriptionDisposeFunctionsByClientSubscriptionId[$], delete this._subscriptionHashByClientSubscriptionId[$];
      const ee = this._subscriptionsByHash[V];
      assert$3(ee !== void 0, `Could not find a \`Subscription\` when tearing down client subscription #${$}`), ee.callbacks.delete(e.callback), await this._updateSubscriptions();
    }, this._updateSubscriptions(), $;
  }
  /**
   * Register a callback to be invoked whenever the specified account changes
   *
   * @param publicKey Public key of the account to monitor
   * @param callback Function to invoke whenever the account is changed
   * @param config
   * @return subscription id
   */
  /** @deprecated Instead, pass in an {@link AccountSubscriptionConfig} */
  // eslint-disable-next-line no-dupe-class-members
  // eslint-disable-next-line no-dupe-class-members
  onAccountChange(e, T, $) {
    const {
      commitment: V,
      config: J
    } = extractCommitmentFromConfig($), ee = this._buildArgs(
      [e.toBase58()],
      V || this._commitment || "finalized",
      // Apply connection/server default.
      "base64",
      J
    );
    return this._makeSubscription({
      callback: T,
      method: "accountSubscribe",
      unsubscribeMethod: "accountUnsubscribe"
    }, ee);
  }
  /**
   * Deregister an account notification callback
   *
   * @param clientSubscriptionId client subscription id to deregister
   */
  async removeAccountChangeListener(e) {
    await this._unsubscribeClientSubscription(e, "account change");
  }
  /**
   * @internal
   */
  _wsOnProgramAccountNotification(e) {
    const {
      result: T,
      subscription: $
    } = create$3(e, ProgramAccountNotificationResult);
    this._handleServerNotification($, [{
      accountId: T.value.pubkey,
      accountInfo: T.value.account
    }, T.context]);
  }
  /**
   * Register a callback to be invoked whenever accounts owned by the
   * specified program change
   *
   * @param programId Public key of the program to monitor
   * @param callback Function to invoke whenever the account is changed
   * @param config
   * @return subscription id
   */
  /** @deprecated Instead, pass in a {@link ProgramAccountSubscriptionConfig} */
  // eslint-disable-next-line no-dupe-class-members
  // eslint-disable-next-line no-dupe-class-members
  onProgramAccountChange(e, T, $, V) {
    const {
      commitment: J,
      config: ee
    } = extractCommitmentFromConfig($), te = this._buildArgs(
      [e.toBase58()],
      J || this._commitment || "finalized",
      // Apply connection/server default.
      "base64",
      ee || (V ? {
        filters: applyDefaultMemcmpEncodingToFilters(V)
      } : void 0)
      /* extra */
    );
    return this._makeSubscription({
      callback: T,
      method: "programSubscribe",
      unsubscribeMethod: "programUnsubscribe"
    }, te);
  }
  /**
   * Deregister an account notification callback
   *
   * @param clientSubscriptionId client subscription id to deregister
   */
  async removeProgramAccountChangeListener(e) {
    await this._unsubscribeClientSubscription(e, "program account change");
  }
  /**
   * Registers a callback to be invoked whenever logs are emitted.
   */
  onLogs(e, T, $) {
    const V = this._buildArgs(
      [typeof e == "object" ? {
        mentions: [e.toString()]
      } : e],
      $ || this._commitment || "finalized"
      // Apply connection/server default.
    );
    return this._makeSubscription({
      callback: T,
      method: "logsSubscribe",
      unsubscribeMethod: "logsUnsubscribe"
    }, V);
  }
  /**
   * Deregister a logs callback.
   *
   * @param clientSubscriptionId client subscription id to deregister.
   */
  async removeOnLogsListener(e) {
    await this._unsubscribeClientSubscription(e, "logs");
  }
  /**
   * @internal
   */
  _wsOnLogsNotification(e) {
    const {
      result: T,
      subscription: $
    } = create$3(e, LogsNotificationResult);
    this._handleServerNotification($, [T.value, T.context]);
  }
  /**
   * @internal
   */
  _wsOnSlotNotification(e) {
    const {
      result: T,
      subscription: $
    } = create$3(e, SlotNotificationResult);
    this._handleServerNotification($, [T]);
  }
  /**
   * Register a callback to be invoked upon slot changes
   *
   * @param callback Function to invoke whenever the slot changes
   * @return subscription id
   */
  onSlotChange(e) {
    return this._makeSubscription(
      {
        callback: e,
        method: "slotSubscribe",
        unsubscribeMethod: "slotUnsubscribe"
      },
      []
      /* args */
    );
  }
  /**
   * Deregister a slot notification callback
   *
   * @param clientSubscriptionId client subscription id to deregister
   */
  async removeSlotChangeListener(e) {
    await this._unsubscribeClientSubscription(e, "slot change");
  }
  /**
   * @internal
   */
  _wsOnSlotUpdatesNotification(e) {
    const {
      result: T,
      subscription: $
    } = create$3(e, SlotUpdateNotificationResult);
    this._handleServerNotification($, [T]);
  }
  /**
   * Register a callback to be invoked upon slot updates. {@link SlotUpdate}'s
   * may be useful to track live progress of a cluster.
   *
   * @param callback Function to invoke whenever the slot updates
   * @return subscription id
   */
  onSlotUpdate(e) {
    return this._makeSubscription(
      {
        callback: e,
        method: "slotsUpdatesSubscribe",
        unsubscribeMethod: "slotsUpdatesUnsubscribe"
      },
      []
      /* args */
    );
  }
  /**
   * Deregister a slot update notification callback
   *
   * @param clientSubscriptionId client subscription id to deregister
   */
  async removeSlotUpdateListener(e) {
    await this._unsubscribeClientSubscription(e, "slot update");
  }
  /**
   * @internal
   */
  async _unsubscribeClientSubscription(e, T) {
    const $ = this._subscriptionDisposeFunctionsByClientSubscriptionId[e];
    $ ? await $() : console.warn(`Ignored unsubscribe request because an active subscription with id \`${e}\` for '${T}' events could not be found.`);
  }
  _buildArgs(e, T, $, V) {
    const J = T || this._commitment;
    if (J || $ || V) {
      let ee = {};
      $ && (ee.encoding = $), J && (ee.commitment = J), V && (ee = Object.assign(ee, V)), e.push(ee);
    }
    return e;
  }
  /**
   * @internal
   */
  _buildArgsAtLeastConfirmed(e, T, $, V) {
    const J = T || this._commitment;
    if (J && !["confirmed", "finalized"].includes(J))
      throw new Error("Using Connection with default commitment: `" + this._commitment + "`, but method requires at least `confirmed`");
    return this._buildArgs(e, T, $, V);
  }
  /**
   * @internal
   */
  _wsOnSignatureNotification(e) {
    const {
      result: T,
      subscription: $
    } = create$3(e, SignatureNotificationResult);
    T.value !== "receivedSignature" && this._subscriptionsAutoDisposedByRpc.add($), this._handleServerNotification($, T.value === "receivedSignature" ? [{
      type: "received"
    }, T.context] : [{
      type: "status",
      result: T.value
    }, T.context]);
  }
  /**
   * Register a callback to be invoked upon signature updates
   *
   * @param signature Transaction signature string in base 58
   * @param callback Function to invoke on signature notifications
   * @param commitment Specify the commitment level signature must reach before notification
   * @return subscription id
   */
  onSignature(e, T, $) {
    const V = this._buildArgs(
      [e],
      $ || this._commitment || "finalized"
      // Apply connection/server default.
    ), J = this._makeSubscription({
      callback: (ee, te) => {
        if (ee.type === "status") {
          T(ee.result, te);
          try {
            this.removeSignatureListener(J);
          } catch {
          }
        }
      },
      method: "signatureSubscribe",
      unsubscribeMethod: "signatureUnsubscribe"
    }, V);
    return J;
  }
  /**
   * Register a callback to be invoked when a transaction is
   * received and/or processed.
   *
   * @param signature Transaction signature string in base 58
   * @param callback Function to invoke on signature notifications
   * @param options Enable received notifications and set the commitment
   *   level that signature must reach before notification
   * @return subscription id
   */
  onSignatureWithOptions(e, T, $) {
    const {
      commitment: V,
      ...J
    } = {
      ...$,
      commitment: $ && $.commitment || this._commitment || "finalized"
      // Apply connection/server default.
    }, ee = this._buildArgs([e], V, void 0, J), te = this._makeSubscription({
      callback: (re, ie) => {
        T(re, ie);
        try {
          this.removeSignatureListener(te);
        } catch {
        }
      },
      method: "signatureSubscribe",
      unsubscribeMethod: "signatureUnsubscribe"
    }, ee);
    return te;
  }
  /**
   * Deregister a signature notification callback
   *
   * @param clientSubscriptionId client subscription id to deregister
   */
  async removeSignatureListener(e) {
    await this._unsubscribeClientSubscription(e, "signature result");
  }
  /**
   * @internal
   */
  _wsOnRootNotification(e) {
    const {
      result: T,
      subscription: $
    } = create$3(e, RootNotificationResult);
    this._handleServerNotification($, [T]);
  }
  /**
   * Register a callback to be invoked upon root changes
   *
   * @param callback Function to invoke whenever the root changes
   * @return subscription id
   */
  onRootChange(e) {
    return this._makeSubscription(
      {
        callback: e,
        method: "rootSubscribe",
        unsubscribeMethod: "rootUnsubscribe"
      },
      []
      /* args */
    );
  }
  /**
   * Deregister a root notification callback
   *
   * @param clientSubscriptionId client subscription id to deregister
   */
  async removeRootChangeListener(e) {
    await this._unsubscribeClientSubscription(e, "root change");
  }
};
class Keypair {
  /**
   * Create a new keypair instance.
   * Generate random keypair if no {@link Ed25519Keypair} is provided.
   *
   * @param {Ed25519Keypair} keypair ed25519 keypair
   */
  constructor(e) {
    this._keypair = void 0, this._keypair = e ?? generateKeypair();
  }
  /**
   * Generate a new random keypair
   *
   * @returns {Keypair} Keypair
   */
  static generate() {
    return new Keypair(generateKeypair());
  }
  /**
   * Create a keypair from a raw secret key byte array.
   *
   * This method should only be used to recreate a keypair from a previously
   * generated secret key. Generating keypairs from a random seed should be done
   * with the {@link Keypair.fromSeed} method.
   *
   * @throws error if the provided secret key is invalid and validation is not skipped.
   *
   * @param secretKey secret key byte array
   * @param options skip secret key validation
   *
   * @returns {Keypair} Keypair
   */
  static fromSecretKey(e, T) {
    if (e.byteLength !== 64)
      throw new Error("bad secret key size");
    const $ = e.slice(32, 64);
    if (!T || !T.skipValidation) {
      const V = e.slice(0, 32), J = getPublicKey(V);
      for (let ee = 0; ee < 32; ee++)
        if ($[ee] !== J[ee])
          throw new Error("provided secretKey is invalid");
    }
    return new Keypair({
      publicKey: $,
      secretKey: e
    });
  }
  /**
   * Generate a keypair from a 32 byte seed.
   *
   * @param seed seed byte array
   *
   * @returns {Keypair} Keypair
   */
  static fromSeed(e) {
    const T = getPublicKey(e), $ = new Uint8Array(64);
    return $.set(e), $.set(T, 32), new Keypair({
      publicKey: T,
      secretKey: $
    });
  }
  /**
   * The public key for this keypair
   *
   * @returns {PublicKey} PublicKey
   */
  get publicKey() {
    return new PublicKey(this._keypair.publicKey);
  }
  /**
   * The raw secret key for this keypair
   * @returns {Uint8Array} Secret key in an array of Uint8 bytes
   */
  get secretKey() {
    return new Uint8Array(this._keypair.secretKey);
  }
}
const LOOKUP_TABLE_INSTRUCTION_LAYOUTS = Object.freeze({
  CreateLookupTable: {
    index: 0,
    layout: struct$1([u32$1("instruction"), u64$2("recentSlot"), u8$1("bumpSeed")])
  },
  FreezeLookupTable: {
    index: 1,
    layout: struct$1([u32$1("instruction")])
  },
  ExtendLookupTable: {
    index: 2,
    layout: struct$1([u32$1("instruction"), u64$2(), seq(publicKey$4(), offset$3(u32$1(), -8), "addresses")])
  },
  DeactivateLookupTable: {
    index: 3,
    layout: struct$1([u32$1("instruction")])
  },
  CloseLookupTable: {
    index: 4,
    layout: struct$1([u32$1("instruction")])
  }
});
class AddressLookupTableInstruction {
  /**
   * @internal
   */
  constructor() {
  }
  static decodeInstructionType(e) {
    this.checkProgramId(e.programId);
    const $ = u32$1("instruction").decode(e.data);
    let V;
    for (const [J, ee] of Object.entries(LOOKUP_TABLE_INSTRUCTION_LAYOUTS))
      if (ee.index == $) {
        V = J;
        break;
      }
    if (!V)
      throw new Error("Invalid Instruction. Should be a LookupTable Instruction");
    return V;
  }
  static decodeCreateLookupTable(e) {
    this.checkProgramId(e.programId), this.checkKeysLength(e.keys, 4);
    const {
      recentSlot: T
    } = decodeData$1(LOOKUP_TABLE_INSTRUCTION_LAYOUTS.CreateLookupTable, e.data);
    return {
      authority: e.keys[1].pubkey,
      payer: e.keys[2].pubkey,
      recentSlot: Number(T)
    };
  }
  static decodeExtendLookupTable(e) {
    if (this.checkProgramId(e.programId), e.keys.length < 2)
      throw new Error(`invalid instruction; found ${e.keys.length} keys, expected at least 2`);
    const {
      addresses: T
    } = decodeData$1(LOOKUP_TABLE_INSTRUCTION_LAYOUTS.ExtendLookupTable, e.data);
    return {
      lookupTable: e.keys[0].pubkey,
      authority: e.keys[1].pubkey,
      payer: e.keys.length > 2 ? e.keys[2].pubkey : void 0,
      addresses: T.map(($) => new PublicKey($))
    };
  }
  static decodeCloseLookupTable(e) {
    return this.checkProgramId(e.programId), this.checkKeysLength(e.keys, 3), {
      lookupTable: e.keys[0].pubkey,
      authority: e.keys[1].pubkey,
      recipient: e.keys[2].pubkey
    };
  }
  static decodeFreezeLookupTable(e) {
    return this.checkProgramId(e.programId), this.checkKeysLength(e.keys, 2), {
      lookupTable: e.keys[0].pubkey,
      authority: e.keys[1].pubkey
    };
  }
  static decodeDeactivateLookupTable(e) {
    return this.checkProgramId(e.programId), this.checkKeysLength(e.keys, 2), {
      lookupTable: e.keys[0].pubkey,
      authority: e.keys[1].pubkey
    };
  }
  /**
   * @internal
   */
  static checkProgramId(e) {
    if (!e.equals(AddressLookupTableProgram.programId))
      throw new Error("invalid instruction; programId is not AddressLookupTable Program");
  }
  /**
   * @internal
   */
  static checkKeysLength(e, T) {
    if (e.length < T)
      throw new Error(`invalid instruction; found ${e.length} keys, expected at least ${T}`);
  }
}
class AddressLookupTableProgram {
  /**
   * @internal
   */
  constructor() {
  }
  static createLookupTable(e) {
    const [T, $] = PublicKey.findProgramAddressSync([e.authority.toBuffer(), toBufferLE_1(BigInt(e.recentSlot), 8)], this.programId), V = LOOKUP_TABLE_INSTRUCTION_LAYOUTS.CreateLookupTable, J = encodeData(V, {
      recentSlot: BigInt(e.recentSlot),
      bumpSeed: $
    }), ee = [{
      pubkey: T,
      isSigner: !1,
      isWritable: !0
    }, {
      pubkey: e.authority,
      isSigner: !0,
      isWritable: !1
    }, {
      pubkey: e.payer,
      isSigner: !0,
      isWritable: !0
    }, {
      pubkey: SystemProgram.programId,
      isSigner: !1,
      isWritable: !1
    }];
    return [new TransactionInstruction({
      programId: this.programId,
      keys: ee,
      data: J
    }), T];
  }
  static freezeLookupTable(e) {
    const T = LOOKUP_TABLE_INSTRUCTION_LAYOUTS.FreezeLookupTable, $ = encodeData(T), V = [{
      pubkey: e.lookupTable,
      isSigner: !1,
      isWritable: !0
    }, {
      pubkey: e.authority,
      isSigner: !0,
      isWritable: !1
    }];
    return new TransactionInstruction({
      programId: this.programId,
      keys: V,
      data: $
    });
  }
  static extendLookupTable(e) {
    const T = LOOKUP_TABLE_INSTRUCTION_LAYOUTS.ExtendLookupTable, $ = encodeData(T, {
      addresses: e.addresses.map((J) => J.toBytes())
    }), V = [{
      pubkey: e.lookupTable,
      isSigner: !1,
      isWritable: !0
    }, {
      pubkey: e.authority,
      isSigner: !0,
      isWritable: !1
    }];
    return e.payer && V.push({
      pubkey: e.payer,
      isSigner: !0,
      isWritable: !0
    }, {
      pubkey: SystemProgram.programId,
      isSigner: !1,
      isWritable: !1
    }), new TransactionInstruction({
      programId: this.programId,
      keys: V,
      data: $
    });
  }
  static deactivateLookupTable(e) {
    const T = LOOKUP_TABLE_INSTRUCTION_LAYOUTS.DeactivateLookupTable, $ = encodeData(T), V = [{
      pubkey: e.lookupTable,
      isSigner: !1,
      isWritable: !0
    }, {
      pubkey: e.authority,
      isSigner: !0,
      isWritable: !1
    }];
    return new TransactionInstruction({
      programId: this.programId,
      keys: V,
      data: $
    });
  }
  static closeLookupTable(e) {
    const T = LOOKUP_TABLE_INSTRUCTION_LAYOUTS.CloseLookupTable, $ = encodeData(T), V = [{
      pubkey: e.lookupTable,
      isSigner: !1,
      isWritable: !0
    }, {
      pubkey: e.authority,
      isSigner: !0,
      isWritable: !1
    }, {
      pubkey: e.recipient,
      isSigner: !1,
      isWritable: !0
    }];
    return new TransactionInstruction({
      programId: this.programId,
      keys: V,
      data: $
    });
  }
}
AddressLookupTableProgram.programId = new PublicKey("AddressLookupTab1e1111111111111111111111111");
class ComputeBudgetInstruction {
  /**
   * @internal
   */
  constructor() {
  }
  /**
   * Decode a compute budget instruction and retrieve the instruction type.
   */
  static decodeInstructionType(e) {
    this.checkProgramId(e.programId);
    const $ = u8$1("instruction").decode(e.data);
    let V;
    for (const [J, ee] of Object.entries(COMPUTE_BUDGET_INSTRUCTION_LAYOUTS))
      if (ee.index == $) {
        V = J;
        break;
      }
    if (!V)
      throw new Error("Instruction type incorrect; not a ComputeBudgetInstruction");
    return V;
  }
  /**
   * Decode request units compute budget instruction and retrieve the instruction params.
   */
  static decodeRequestUnits(e) {
    this.checkProgramId(e.programId);
    const {
      units: T,
      additionalFee: $
    } = decodeData$1(COMPUTE_BUDGET_INSTRUCTION_LAYOUTS.RequestUnits, e.data);
    return {
      units: T,
      additionalFee: $
    };
  }
  /**
   * Decode request heap frame compute budget instruction and retrieve the instruction params.
   */
  static decodeRequestHeapFrame(e) {
    this.checkProgramId(e.programId);
    const {
      bytes: T
    } = decodeData$1(COMPUTE_BUDGET_INSTRUCTION_LAYOUTS.RequestHeapFrame, e.data);
    return {
      bytes: T
    };
  }
  /**
   * Decode set compute unit limit compute budget instruction and retrieve the instruction params.
   */
  static decodeSetComputeUnitLimit(e) {
    this.checkProgramId(e.programId);
    const {
      units: T
    } = decodeData$1(COMPUTE_BUDGET_INSTRUCTION_LAYOUTS.SetComputeUnitLimit, e.data);
    return {
      units: T
    };
  }
  /**
   * Decode set compute unit price compute budget instruction and retrieve the instruction params.
   */
  static decodeSetComputeUnitPrice(e) {
    this.checkProgramId(e.programId);
    const {
      microLamports: T
    } = decodeData$1(COMPUTE_BUDGET_INSTRUCTION_LAYOUTS.SetComputeUnitPrice, e.data);
    return {
      microLamports: T
    };
  }
  /**
   * @internal
   */
  static checkProgramId(e) {
    if (!e.equals(ComputeBudgetProgram.programId))
      throw new Error("invalid instruction; programId is not ComputeBudgetProgram");
  }
}
const COMPUTE_BUDGET_INSTRUCTION_LAYOUTS = Object.freeze({
  RequestUnits: {
    index: 0,
    layout: struct$1([u8$1("instruction"), u32$1("units"), u32$1("additionalFee")])
  },
  RequestHeapFrame: {
    index: 1,
    layout: struct$1([u8$1("instruction"), u32$1("bytes")])
  },
  SetComputeUnitLimit: {
    index: 2,
    layout: struct$1([u8$1("instruction"), u32$1("units")])
  },
  SetComputeUnitPrice: {
    index: 3,
    layout: struct$1([u8$1("instruction"), u64$2("microLamports")])
  }
});
class ComputeBudgetProgram {
  /**
   * @internal
   */
  constructor() {
  }
  /**
   * Public key that identifies the Compute Budget program
   */
  /**
   * @deprecated Instead, call {@link setComputeUnitLimit} and/or {@link setComputeUnitPrice}
   */
  static requestUnits(e) {
    const T = COMPUTE_BUDGET_INSTRUCTION_LAYOUTS.RequestUnits, $ = encodeData(T, e);
    return new TransactionInstruction({
      keys: [],
      programId: this.programId,
      data: $
    });
  }
  static requestHeapFrame(e) {
    const T = COMPUTE_BUDGET_INSTRUCTION_LAYOUTS.RequestHeapFrame, $ = encodeData(T, e);
    return new TransactionInstruction({
      keys: [],
      programId: this.programId,
      data: $
    });
  }
  static setComputeUnitLimit(e) {
    const T = COMPUTE_BUDGET_INSTRUCTION_LAYOUTS.SetComputeUnitLimit, $ = encodeData(T, e);
    return new TransactionInstruction({
      keys: [],
      programId: this.programId,
      data: $
    });
  }
  static setComputeUnitPrice(e) {
    const T = COMPUTE_BUDGET_INSTRUCTION_LAYOUTS.SetComputeUnitPrice, $ = encodeData(T, {
      microLamports: BigInt(e.microLamports)
    });
    return new TransactionInstruction({
      keys: [],
      programId: this.programId,
      data: $
    });
  }
}
ComputeBudgetProgram.programId = new PublicKey("ComputeBudget111111111111111111111111111111");
const PRIVATE_KEY_BYTES$1 = 64, PUBLIC_KEY_BYTES$1 = 32, SIGNATURE_BYTES = 64, ED25519_INSTRUCTION_LAYOUT = struct$1([u8$1("numSignatures"), u8$1("padding"), u16("signatureOffset"), u16("signatureInstructionIndex"), u16("publicKeyOffset"), u16("publicKeyInstructionIndex"), u16("messageDataOffset"), u16("messageDataSize"), u16("messageInstructionIndex")]);
class Ed25519Program {
  /**
   * @internal
   */
  constructor() {
  }
  /**
   * Public key that identifies the ed25519 program
   */
  /**
   * Create an ed25519 instruction with a public key and signature. The
   * public key must be a buffer that is 32 bytes long, and the signature
   * must be a buffer of 64 bytes.
   */
  static createInstructionWithPublicKey(e) {
    const {
      publicKey: T,
      message: $,
      signature: V,
      instructionIndex: J
    } = e;
    assert$3(T.length === PUBLIC_KEY_BYTES$1, `Public Key must be ${PUBLIC_KEY_BYTES$1} bytes but received ${T.length} bytes`), assert$3(V.length === SIGNATURE_BYTES, `Signature must be ${SIGNATURE_BYTES} bytes but received ${V.length} bytes`);
    const ee = ED25519_INSTRUCTION_LAYOUT.span, te = ee + T.length, re = te + V.length, ie = 1, se = bufferPolyfill.Buffer.alloc(re + $.length), de = J ?? 65535;
    return ED25519_INSTRUCTION_LAYOUT.encode({
      numSignatures: ie,
      padding: 0,
      signatureOffset: te,
      signatureInstructionIndex: de,
      publicKeyOffset: ee,
      publicKeyInstructionIndex: de,
      messageDataOffset: re,
      messageDataSize: $.length,
      messageInstructionIndex: de
    }, se), se.fill(T, ee), se.fill(V, te), se.fill($, re), new TransactionInstruction({
      keys: [],
      programId: Ed25519Program.programId,
      data: se
    });
  }
  /**
   * Create an ed25519 instruction with a private key. The private key
   * must be a buffer that is 64 bytes long.
   */
  static createInstructionWithPrivateKey(e) {
    const {
      privateKey: T,
      message: $,
      instructionIndex: V
    } = e;
    assert$3(T.length === PRIVATE_KEY_BYTES$1, `Private key must be ${PRIVATE_KEY_BYTES$1} bytes but received ${T.length} bytes`);
    try {
      const J = Keypair.fromSecretKey(T), ee = J.publicKey.toBytes(), te = sign($, J.secretKey);
      return this.createInstructionWithPublicKey({
        publicKey: ee,
        message: $,
        signature: te,
        instructionIndex: V
      });
    } catch (J) {
      throw new Error(`Error creating instruction; ${J}`);
    }
  }
}
Ed25519Program.programId = new PublicKey("Ed25519SigVerify111111111111111111111111111");
const ecdsaSign = (C, e) => {
  const T = secp256k1$1.sign(C, e);
  return [T.toCompactRawBytes(), T.recovery];
};
secp256k1$1.utils.isValidPrivateKey;
const publicKeyCreate = secp256k1$1.getPublicKey, PRIVATE_KEY_BYTES = 32, ETHEREUM_ADDRESS_BYTES = 20, PUBLIC_KEY_BYTES = 64, SIGNATURE_OFFSETS_SERIALIZED_SIZE = 11, SECP256K1_INSTRUCTION_LAYOUT = struct$1([u8$1("numSignatures"), u16("signatureOffset"), u8$1("signatureInstructionIndex"), u16("ethAddressOffset"), u8$1("ethAddressInstructionIndex"), u16("messageDataOffset"), u16("messageDataSize"), u8$1("messageInstructionIndex"), blob$1(20, "ethAddress"), blob$1(64, "signature"), u8$1("recoveryId")]);
class Secp256k1Program {
  /**
   * @internal
   */
  constructor() {
  }
  /**
   * Public key that identifies the secp256k1 program
   */
  /**
   * Construct an Ethereum address from a secp256k1 public key buffer.
   * @param {Buffer} publicKey a 64 byte secp256k1 public key buffer
   */
  static publicKeyToEthAddress(e) {
    assert$3(e.length === PUBLIC_KEY_BYTES, `Public key must be ${PUBLIC_KEY_BYTES} bytes but received ${e.length} bytes`);
    try {
      return bufferPolyfill.Buffer.from(keccak_256(toBuffer(e))).slice(-ETHEREUM_ADDRESS_BYTES);
    } catch (T) {
      throw new Error(`Error constructing Ethereum address: ${T}`);
    }
  }
  /**
   * Create an secp256k1 instruction with a public key. The public key
   * must be a buffer that is 64 bytes long.
   */
  static createInstructionWithPublicKey(e) {
    const {
      publicKey: T,
      message: $,
      signature: V,
      recoveryId: J,
      instructionIndex: ee
    } = e;
    return Secp256k1Program.createInstructionWithEthAddress({
      ethAddress: Secp256k1Program.publicKeyToEthAddress(T),
      message: $,
      signature: V,
      recoveryId: J,
      instructionIndex: ee
    });
  }
  /**
   * Create an secp256k1 instruction with an Ethereum address. The address
   * must be a hex string or a buffer that is 20 bytes long.
   */
  static createInstructionWithEthAddress(e) {
    const {
      ethAddress: T,
      message: $,
      signature: V,
      recoveryId: J,
      instructionIndex: ee = 0
    } = e;
    let te;
    typeof T == "string" ? T.startsWith("0x") ? te = bufferPolyfill.Buffer.from(T.substr(2), "hex") : te = bufferPolyfill.Buffer.from(T, "hex") : te = T, assert$3(te.length === ETHEREUM_ADDRESS_BYTES, `Address must be ${ETHEREUM_ADDRESS_BYTES} bytes but received ${te.length} bytes`);
    const re = 1 + SIGNATURE_OFFSETS_SERIALIZED_SIZE, ie = re, se = re + te.length, de = se + V.length + 1, ue = 1, fe = bufferPolyfill.Buffer.alloc(SECP256K1_INSTRUCTION_LAYOUT.span + $.length);
    return SECP256K1_INSTRUCTION_LAYOUT.encode({
      numSignatures: ue,
      signatureOffset: se,
      signatureInstructionIndex: ee,
      ethAddressOffset: ie,
      ethAddressInstructionIndex: ee,
      messageDataOffset: de,
      messageDataSize: $.length,
      messageInstructionIndex: ee,
      signature: toBuffer(V),
      ethAddress: toBuffer(te),
      recoveryId: J
    }, fe), fe.fill(toBuffer($), SECP256K1_INSTRUCTION_LAYOUT.span), new TransactionInstruction({
      keys: [],
      programId: Secp256k1Program.programId,
      data: fe
    });
  }
  /**
   * Create an secp256k1 instruction with a private key. The private key
   * must be a buffer that is 32 bytes long.
   */
  static createInstructionWithPrivateKey(e) {
    const {
      privateKey: T,
      message: $,
      instructionIndex: V
    } = e;
    assert$3(T.length === PRIVATE_KEY_BYTES, `Private key must be ${PRIVATE_KEY_BYTES} bytes but received ${T.length} bytes`);
    try {
      const J = toBuffer(T), ee = publicKeyCreate(
        J,
        !1
        /* isCompressed */
      ).slice(1), te = bufferPolyfill.Buffer.from(keccak_256(toBuffer($))), [re, ie] = ecdsaSign(te, J);
      return this.createInstructionWithPublicKey({
        publicKey: ee,
        message: $,
        signature: re,
        recoveryId: ie,
        instructionIndex: V
      });
    } catch (J) {
      throw new Error(`Error creating instruction; ${J}`);
    }
  }
}
Secp256k1Program.programId = new PublicKey("KeccakSecp256k11111111111111111111111111111");
var _Lockup;
const STAKE_CONFIG_ID = new PublicKey("StakeConfig11111111111111111111111111111111");
class Authorized {
  /**
   * Create a new Authorized object
   * @param staker the stake authority
   * @param withdrawer the withdraw authority
   */
  constructor(e, T) {
    this.staker = void 0, this.withdrawer = void 0, this.staker = e, this.withdrawer = T;
  }
}
class Lockup {
  /**
   * Create a new Lockup object
   */
  constructor(e, T, $) {
    this.unixTimestamp = void 0, this.epoch = void 0, this.custodian = void 0, this.unixTimestamp = e, this.epoch = T, this.custodian = $;
  }
  /**
   * Default, inactive Lockup value
   */
}
_Lockup = Lockup;
Lockup.default = new _Lockup(0, 0, PublicKey.default);
class StakeInstruction {
  /**
   * @internal
   */
  constructor() {
  }
  /**
   * Decode a stake instruction and retrieve the instruction type.
   */
  static decodeInstructionType(e) {
    this.checkProgramId(e.programId);
    const $ = u32$1("instruction").decode(e.data);
    let V;
    for (const [J, ee] of Object.entries(STAKE_INSTRUCTION_LAYOUTS))
      if (ee.index == $) {
        V = J;
        break;
      }
    if (!V)
      throw new Error("Instruction type incorrect; not a StakeInstruction");
    return V;
  }
  /**
   * Decode a initialize stake instruction and retrieve the instruction params.
   */
  static decodeInitialize(e) {
    this.checkProgramId(e.programId), this.checkKeyLength(e.keys, 2);
    const {
      authorized: T,
      lockup: $
    } = decodeData$1(STAKE_INSTRUCTION_LAYOUTS.Initialize, e.data);
    return {
      stakePubkey: e.keys[0].pubkey,
      authorized: new Authorized(new PublicKey(T.staker), new PublicKey(T.withdrawer)),
      lockup: new Lockup($.unixTimestamp, $.epoch, new PublicKey($.custodian))
    };
  }
  /**
   * Decode a delegate stake instruction and retrieve the instruction params.
   */
  static decodeDelegate(e) {
    return this.checkProgramId(e.programId), this.checkKeyLength(e.keys, 6), decodeData$1(STAKE_INSTRUCTION_LAYOUTS.Delegate, e.data), {
      stakePubkey: e.keys[0].pubkey,
      votePubkey: e.keys[1].pubkey,
      authorizedPubkey: e.keys[5].pubkey
    };
  }
  /**
   * Decode an authorize stake instruction and retrieve the instruction params.
   */
  static decodeAuthorize(e) {
    this.checkProgramId(e.programId), this.checkKeyLength(e.keys, 3);
    const {
      newAuthorized: T,
      stakeAuthorizationType: $
    } = decodeData$1(STAKE_INSTRUCTION_LAYOUTS.Authorize, e.data), V = {
      stakePubkey: e.keys[0].pubkey,
      authorizedPubkey: e.keys[2].pubkey,
      newAuthorizedPubkey: new PublicKey(T),
      stakeAuthorizationType: {
        index: $
      }
    };
    return e.keys.length > 3 && (V.custodianPubkey = e.keys[3].pubkey), V;
  }
  /**
   * Decode an authorize-with-seed stake instruction and retrieve the instruction params.
   */
  static decodeAuthorizeWithSeed(e) {
    this.checkProgramId(e.programId), this.checkKeyLength(e.keys, 2);
    const {
      newAuthorized: T,
      stakeAuthorizationType: $,
      authoritySeed: V,
      authorityOwner: J
    } = decodeData$1(STAKE_INSTRUCTION_LAYOUTS.AuthorizeWithSeed, e.data), ee = {
      stakePubkey: e.keys[0].pubkey,
      authorityBase: e.keys[1].pubkey,
      authoritySeed: V,
      authorityOwner: new PublicKey(J),
      newAuthorizedPubkey: new PublicKey(T),
      stakeAuthorizationType: {
        index: $
      }
    };
    return e.keys.length > 3 && (ee.custodianPubkey = e.keys[3].pubkey), ee;
  }
  /**
   * Decode a split stake instruction and retrieve the instruction params.
   */
  static decodeSplit(e) {
    this.checkProgramId(e.programId), this.checkKeyLength(e.keys, 3);
    const {
      lamports: T
    } = decodeData$1(STAKE_INSTRUCTION_LAYOUTS.Split, e.data);
    return {
      stakePubkey: e.keys[0].pubkey,
      splitStakePubkey: e.keys[1].pubkey,
      authorizedPubkey: e.keys[2].pubkey,
      lamports: T
    };
  }
  /**
   * Decode a merge stake instruction and retrieve the instruction params.
   */
  static decodeMerge(e) {
    return this.checkProgramId(e.programId), this.checkKeyLength(e.keys, 3), decodeData$1(STAKE_INSTRUCTION_LAYOUTS.Merge, e.data), {
      stakePubkey: e.keys[0].pubkey,
      sourceStakePubKey: e.keys[1].pubkey,
      authorizedPubkey: e.keys[4].pubkey
    };
  }
  /**
   * Decode a withdraw stake instruction and retrieve the instruction params.
   */
  static decodeWithdraw(e) {
    this.checkProgramId(e.programId), this.checkKeyLength(e.keys, 5);
    const {
      lamports: T
    } = decodeData$1(STAKE_INSTRUCTION_LAYOUTS.Withdraw, e.data), $ = {
      stakePubkey: e.keys[0].pubkey,
      toPubkey: e.keys[1].pubkey,
      authorizedPubkey: e.keys[4].pubkey,
      lamports: T
    };
    return e.keys.length > 5 && ($.custodianPubkey = e.keys[5].pubkey), $;
  }
  /**
   * Decode a deactivate stake instruction and retrieve the instruction params.
   */
  static decodeDeactivate(e) {
    return this.checkProgramId(e.programId), this.checkKeyLength(e.keys, 3), decodeData$1(STAKE_INSTRUCTION_LAYOUTS.Deactivate, e.data), {
      stakePubkey: e.keys[0].pubkey,
      authorizedPubkey: e.keys[2].pubkey
    };
  }
  /**
   * @internal
   */
  static checkProgramId(e) {
    if (!e.equals(StakeProgram.programId))
      throw new Error("invalid instruction; programId is not StakeProgram");
  }
  /**
   * @internal
   */
  static checkKeyLength(e, T) {
    if (e.length < T)
      throw new Error(`invalid instruction; found ${e.length} keys, expected at least ${T}`);
  }
}
const STAKE_INSTRUCTION_LAYOUTS = Object.freeze({
  Initialize: {
    index: 0,
    layout: struct$1([u32$1("instruction"), authorized(), lockup()])
  },
  Authorize: {
    index: 1,
    layout: struct$1([u32$1("instruction"), publicKey$4("newAuthorized"), u32$1("stakeAuthorizationType")])
  },
  Delegate: {
    index: 2,
    layout: struct$1([u32$1("instruction")])
  },
  Split: {
    index: 3,
    layout: struct$1([u32$1("instruction"), ns64$1("lamports")])
  },
  Withdraw: {
    index: 4,
    layout: struct$1([u32$1("instruction"), ns64$1("lamports")])
  },
  Deactivate: {
    index: 5,
    layout: struct$1([u32$1("instruction")])
  },
  Merge: {
    index: 7,
    layout: struct$1([u32$1("instruction")])
  },
  AuthorizeWithSeed: {
    index: 8,
    layout: struct$1([u32$1("instruction"), publicKey$4("newAuthorized"), u32$1("stakeAuthorizationType"), rustString("authoritySeed"), publicKey$4("authorityOwner")])
  }
}), StakeAuthorizationLayout = Object.freeze({
  Staker: {
    index: 0
  },
  Withdrawer: {
    index: 1
  }
});
class StakeProgram {
  /**
   * @internal
   */
  constructor() {
  }
  /**
   * Public key that identifies the Stake program
   */
  /**
   * Generate an Initialize instruction to add to a Stake Create transaction
   */
  static initialize(e) {
    const {
      stakePubkey: T,
      authorized: $,
      lockup: V
    } = e, J = V || Lockup.default, ee = STAKE_INSTRUCTION_LAYOUTS.Initialize, te = encodeData(ee, {
      authorized: {
        staker: toBuffer($.staker.toBuffer()),
        withdrawer: toBuffer($.withdrawer.toBuffer())
      },
      lockup: {
        unixTimestamp: J.unixTimestamp,
        epoch: J.epoch,
        custodian: toBuffer(J.custodian.toBuffer())
      }
    }), re = {
      keys: [{
        pubkey: T,
        isSigner: !1,
        isWritable: !0
      }, {
        pubkey: SYSVAR_RENT_PUBKEY,
        isSigner: !1,
        isWritable: !1
      }],
      programId: this.programId,
      data: te
    };
    return new TransactionInstruction(re);
  }
  /**
   * Generate a Transaction that creates a new Stake account at
   *   an address generated with `from`, a seed, and the Stake programId
   */
  static createAccountWithSeed(e) {
    const T = new Transaction();
    T.add(SystemProgram.createAccountWithSeed({
      fromPubkey: e.fromPubkey,
      newAccountPubkey: e.stakePubkey,
      basePubkey: e.basePubkey,
      seed: e.seed,
      lamports: e.lamports,
      space: this.space,
      programId: this.programId
    }));
    const {
      stakePubkey: $,
      authorized: V,
      lockup: J
    } = e;
    return T.add(this.initialize({
      stakePubkey: $,
      authorized: V,
      lockup: J
    }));
  }
  /**
   * Generate a Transaction that creates a new Stake account
   */
  static createAccount(e) {
    const T = new Transaction();
    T.add(SystemProgram.createAccount({
      fromPubkey: e.fromPubkey,
      newAccountPubkey: e.stakePubkey,
      lamports: e.lamports,
      space: this.space,
      programId: this.programId
    }));
    const {
      stakePubkey: $,
      authorized: V,
      lockup: J
    } = e;
    return T.add(this.initialize({
      stakePubkey: $,
      authorized: V,
      lockup: J
    }));
  }
  /**
   * Generate a Transaction that delegates Stake tokens to a validator
   * Vote PublicKey. This transaction can also be used to redelegate Stake
   * to a new validator Vote PublicKey.
   */
  static delegate(e) {
    const {
      stakePubkey: T,
      authorizedPubkey: $,
      votePubkey: V
    } = e, J = STAKE_INSTRUCTION_LAYOUTS.Delegate, ee = encodeData(J);
    return new Transaction().add({
      keys: [{
        pubkey: T,
        isSigner: !1,
        isWritable: !0
      }, {
        pubkey: V,
        isSigner: !1,
        isWritable: !1
      }, {
        pubkey: SYSVAR_CLOCK_PUBKEY,
        isSigner: !1,
        isWritable: !1
      }, {
        pubkey: SYSVAR_STAKE_HISTORY_PUBKEY,
        isSigner: !1,
        isWritable: !1
      }, {
        pubkey: STAKE_CONFIG_ID,
        isSigner: !1,
        isWritable: !1
      }, {
        pubkey: $,
        isSigner: !0,
        isWritable: !1
      }],
      programId: this.programId,
      data: ee
    });
  }
  /**
   * Generate a Transaction that authorizes a new PublicKey as Staker
   * or Withdrawer on the Stake account.
   */
  static authorize(e) {
    const {
      stakePubkey: T,
      authorizedPubkey: $,
      newAuthorizedPubkey: V,
      stakeAuthorizationType: J,
      custodianPubkey: ee
    } = e, te = STAKE_INSTRUCTION_LAYOUTS.Authorize, re = encodeData(te, {
      newAuthorized: toBuffer(V.toBuffer()),
      stakeAuthorizationType: J.index
    }), ie = [{
      pubkey: T,
      isSigner: !1,
      isWritable: !0
    }, {
      pubkey: SYSVAR_CLOCK_PUBKEY,
      isSigner: !1,
      isWritable: !0
    }, {
      pubkey: $,
      isSigner: !0,
      isWritable: !1
    }];
    return ee && ie.push({
      pubkey: ee,
      isSigner: !0,
      isWritable: !1
    }), new Transaction().add({
      keys: ie,
      programId: this.programId,
      data: re
    });
  }
  /**
   * Generate a Transaction that authorizes a new PublicKey as Staker
   * or Withdrawer on the Stake account.
   */
  static authorizeWithSeed(e) {
    const {
      stakePubkey: T,
      authorityBase: $,
      authoritySeed: V,
      authorityOwner: J,
      newAuthorizedPubkey: ee,
      stakeAuthorizationType: te,
      custodianPubkey: re
    } = e, ie = STAKE_INSTRUCTION_LAYOUTS.AuthorizeWithSeed, se = encodeData(ie, {
      newAuthorized: toBuffer(ee.toBuffer()),
      stakeAuthorizationType: te.index,
      authoritySeed: V,
      authorityOwner: toBuffer(J.toBuffer())
    }), de = [{
      pubkey: T,
      isSigner: !1,
      isWritable: !0
    }, {
      pubkey: $,
      isSigner: !0,
      isWritable: !1
    }, {
      pubkey: SYSVAR_CLOCK_PUBKEY,
      isSigner: !1,
      isWritable: !1
    }];
    return re && de.push({
      pubkey: re,
      isSigner: !0,
      isWritable: !1
    }), new Transaction().add({
      keys: de,
      programId: this.programId,
      data: se
    });
  }
  /**
   * @internal
   */
  static splitInstruction(e) {
    const {
      stakePubkey: T,
      authorizedPubkey: $,
      splitStakePubkey: V,
      lamports: J
    } = e, ee = STAKE_INSTRUCTION_LAYOUTS.Split, te = encodeData(ee, {
      lamports: J
    });
    return new TransactionInstruction({
      keys: [{
        pubkey: T,
        isSigner: !1,
        isWritable: !0
      }, {
        pubkey: V,
        isSigner: !1,
        isWritable: !0
      }, {
        pubkey: $,
        isSigner: !0,
        isWritable: !1
      }],
      programId: this.programId,
      data: te
    });
  }
  /**
   * Generate a Transaction that splits Stake tokens into another stake account
   */
  static split(e, T) {
    const $ = new Transaction();
    return $.add(SystemProgram.createAccount({
      fromPubkey: e.authorizedPubkey,
      newAccountPubkey: e.splitStakePubkey,
      lamports: T,
      space: this.space,
      programId: this.programId
    })), $.add(this.splitInstruction(e));
  }
  /**
   * Generate a Transaction that splits Stake tokens into another account
   * derived from a base public key and seed
   */
  static splitWithSeed(e, T) {
    const {
      stakePubkey: $,
      authorizedPubkey: V,
      splitStakePubkey: J,
      basePubkey: ee,
      seed: te,
      lamports: re
    } = e, ie = new Transaction();
    return ie.add(SystemProgram.allocate({
      accountPubkey: J,
      basePubkey: ee,
      seed: te,
      space: this.space,
      programId: this.programId
    })), T && T > 0 && ie.add(SystemProgram.transfer({
      fromPubkey: e.authorizedPubkey,
      toPubkey: J,
      lamports: T
    })), ie.add(this.splitInstruction({
      stakePubkey: $,
      authorizedPubkey: V,
      splitStakePubkey: J,
      lamports: re
    }));
  }
  /**
   * Generate a Transaction that merges Stake accounts.
   */
  static merge(e) {
    const {
      stakePubkey: T,
      sourceStakePubKey: $,
      authorizedPubkey: V
    } = e, J = STAKE_INSTRUCTION_LAYOUTS.Merge, ee = encodeData(J);
    return new Transaction().add({
      keys: [{
        pubkey: T,
        isSigner: !1,
        isWritable: !0
      }, {
        pubkey: $,
        isSigner: !1,
        isWritable: !0
      }, {
        pubkey: SYSVAR_CLOCK_PUBKEY,
        isSigner: !1,
        isWritable: !1
      }, {
        pubkey: SYSVAR_STAKE_HISTORY_PUBKEY,
        isSigner: !1,
        isWritable: !1
      }, {
        pubkey: V,
        isSigner: !0,
        isWritable: !1
      }],
      programId: this.programId,
      data: ee
    });
  }
  /**
   * Generate a Transaction that withdraws deactivated Stake tokens.
   */
  static withdraw(e) {
    const {
      stakePubkey: T,
      authorizedPubkey: $,
      toPubkey: V,
      lamports: J,
      custodianPubkey: ee
    } = e, te = STAKE_INSTRUCTION_LAYOUTS.Withdraw, re = encodeData(te, {
      lamports: J
    }), ie = [{
      pubkey: T,
      isSigner: !1,
      isWritable: !0
    }, {
      pubkey: V,
      isSigner: !1,
      isWritable: !0
    }, {
      pubkey: SYSVAR_CLOCK_PUBKEY,
      isSigner: !1,
      isWritable: !1
    }, {
      pubkey: SYSVAR_STAKE_HISTORY_PUBKEY,
      isSigner: !1,
      isWritable: !1
    }, {
      pubkey: $,
      isSigner: !0,
      isWritable: !1
    }];
    return ee && ie.push({
      pubkey: ee,
      isSigner: !0,
      isWritable: !1
    }), new Transaction().add({
      keys: ie,
      programId: this.programId,
      data: re
    });
  }
  /**
   * Generate a Transaction that deactivates Stake tokens.
   */
  static deactivate(e) {
    const {
      stakePubkey: T,
      authorizedPubkey: $
    } = e, V = STAKE_INSTRUCTION_LAYOUTS.Deactivate, J = encodeData(V);
    return new Transaction().add({
      keys: [{
        pubkey: T,
        isSigner: !1,
        isWritable: !0
      }, {
        pubkey: SYSVAR_CLOCK_PUBKEY,
        isSigner: !1,
        isWritable: !1
      }, {
        pubkey: $,
        isSigner: !0,
        isWritable: !1
      }],
      programId: this.programId,
      data: J
    });
  }
}
StakeProgram.programId = new PublicKey("Stake11111111111111111111111111111111111111");
StakeProgram.space = 200;
class VoteInit {
  /** [0, 100] */
  constructor(e, T, $, V) {
    this.nodePubkey = void 0, this.authorizedVoter = void 0, this.authorizedWithdrawer = void 0, this.commission = void 0, this.nodePubkey = e, this.authorizedVoter = T, this.authorizedWithdrawer = $, this.commission = V;
  }
}
class VoteInstruction {
  /**
   * @internal
   */
  constructor() {
  }
  /**
   * Decode a vote instruction and retrieve the instruction type.
   */
  static decodeInstructionType(e) {
    this.checkProgramId(e.programId);
    const $ = u32$1("instruction").decode(e.data);
    let V;
    for (const [J, ee] of Object.entries(VOTE_INSTRUCTION_LAYOUTS))
      if (ee.index == $) {
        V = J;
        break;
      }
    if (!V)
      throw new Error("Instruction type incorrect; not a VoteInstruction");
    return V;
  }
  /**
   * Decode an initialize vote instruction and retrieve the instruction params.
   */
  static decodeInitializeAccount(e) {
    this.checkProgramId(e.programId), this.checkKeyLength(e.keys, 4);
    const {
      voteInit: T
    } = decodeData$1(VOTE_INSTRUCTION_LAYOUTS.InitializeAccount, e.data);
    return {
      votePubkey: e.keys[0].pubkey,
      nodePubkey: e.keys[3].pubkey,
      voteInit: new VoteInit(new PublicKey(T.nodePubkey), new PublicKey(T.authorizedVoter), new PublicKey(T.authorizedWithdrawer), T.commission)
    };
  }
  /**
   * Decode an authorize instruction and retrieve the instruction params.
   */
  static decodeAuthorize(e) {
    this.checkProgramId(e.programId), this.checkKeyLength(e.keys, 3);
    const {
      newAuthorized: T,
      voteAuthorizationType: $
    } = decodeData$1(VOTE_INSTRUCTION_LAYOUTS.Authorize, e.data);
    return {
      votePubkey: e.keys[0].pubkey,
      authorizedPubkey: e.keys[2].pubkey,
      newAuthorizedPubkey: new PublicKey(T),
      voteAuthorizationType: {
        index: $
      }
    };
  }
  /**
   * Decode an authorize instruction and retrieve the instruction params.
   */
  static decodeAuthorizeWithSeed(e) {
    this.checkProgramId(e.programId), this.checkKeyLength(e.keys, 3);
    const {
      voteAuthorizeWithSeedArgs: {
        currentAuthorityDerivedKeyOwnerPubkey: T,
        currentAuthorityDerivedKeySeed: $,
        newAuthorized: V,
        voteAuthorizationType: J
      }
    } = decodeData$1(VOTE_INSTRUCTION_LAYOUTS.AuthorizeWithSeed, e.data);
    return {
      currentAuthorityDerivedKeyBasePubkey: e.keys[2].pubkey,
      currentAuthorityDerivedKeyOwnerPubkey: new PublicKey(T),
      currentAuthorityDerivedKeySeed: $,
      newAuthorizedPubkey: new PublicKey(V),
      voteAuthorizationType: {
        index: J
      },
      votePubkey: e.keys[0].pubkey
    };
  }
  /**
   * Decode a withdraw instruction and retrieve the instruction params.
   */
  static decodeWithdraw(e) {
    this.checkProgramId(e.programId), this.checkKeyLength(e.keys, 3);
    const {
      lamports: T
    } = decodeData$1(VOTE_INSTRUCTION_LAYOUTS.Withdraw, e.data);
    return {
      votePubkey: e.keys[0].pubkey,
      authorizedWithdrawerPubkey: e.keys[2].pubkey,
      lamports: T,
      toPubkey: e.keys[1].pubkey
    };
  }
  /**
   * @internal
   */
  static checkProgramId(e) {
    if (!e.equals(VoteProgram.programId))
      throw new Error("invalid instruction; programId is not VoteProgram");
  }
  /**
   * @internal
   */
  static checkKeyLength(e, T) {
    if (e.length < T)
      throw new Error(`invalid instruction; found ${e.length} keys, expected at least ${T}`);
  }
}
const VOTE_INSTRUCTION_LAYOUTS = Object.freeze({
  InitializeAccount: {
    index: 0,
    layout: struct$1([u32$1("instruction"), voteInit()])
  },
  Authorize: {
    index: 1,
    layout: struct$1([u32$1("instruction"), publicKey$4("newAuthorized"), u32$1("voteAuthorizationType")])
  },
  Withdraw: {
    index: 3,
    layout: struct$1([u32$1("instruction"), ns64$1("lamports")])
  },
  UpdateValidatorIdentity: {
    index: 4,
    layout: struct$1([u32$1("instruction")])
  },
  AuthorizeWithSeed: {
    index: 10,
    layout: struct$1([u32$1("instruction"), voteAuthorizeWithSeedArgs()])
  }
}), VoteAuthorizationLayout = Object.freeze({
  Voter: {
    index: 0
  },
  Withdrawer: {
    index: 1
  }
});
class VoteProgram {
  /**
   * @internal
   */
  constructor() {
  }
  /**
   * Public key that identifies the Vote program
   */
  /**
   * Generate an Initialize instruction.
   */
  static initializeAccount(e) {
    const {
      votePubkey: T,
      nodePubkey: $,
      voteInit: V
    } = e, J = VOTE_INSTRUCTION_LAYOUTS.InitializeAccount, ee = encodeData(J, {
      voteInit: {
        nodePubkey: toBuffer(V.nodePubkey.toBuffer()),
        authorizedVoter: toBuffer(V.authorizedVoter.toBuffer()),
        authorizedWithdrawer: toBuffer(V.authorizedWithdrawer.toBuffer()),
        commission: V.commission
      }
    }), te = {
      keys: [{
        pubkey: T,
        isSigner: !1,
        isWritable: !0
      }, {
        pubkey: SYSVAR_RENT_PUBKEY,
        isSigner: !1,
        isWritable: !1
      }, {
        pubkey: SYSVAR_CLOCK_PUBKEY,
        isSigner: !1,
        isWritable: !1
      }, {
        pubkey: $,
        isSigner: !0,
        isWritable: !1
      }],
      programId: this.programId,
      data: ee
    };
    return new TransactionInstruction(te);
  }
  /**
   * Generate a transaction that creates a new Vote account.
   */
  static createAccount(e) {
    const T = new Transaction();
    return T.add(SystemProgram.createAccount({
      fromPubkey: e.fromPubkey,
      newAccountPubkey: e.votePubkey,
      lamports: e.lamports,
      space: this.space,
      programId: this.programId
    })), T.add(this.initializeAccount({
      votePubkey: e.votePubkey,
      nodePubkey: e.voteInit.nodePubkey,
      voteInit: e.voteInit
    }));
  }
  /**
   * Generate a transaction that authorizes a new Voter or Withdrawer on the Vote account.
   */
  static authorize(e) {
    const {
      votePubkey: T,
      authorizedPubkey: $,
      newAuthorizedPubkey: V,
      voteAuthorizationType: J
    } = e, ee = VOTE_INSTRUCTION_LAYOUTS.Authorize, te = encodeData(ee, {
      newAuthorized: toBuffer(V.toBuffer()),
      voteAuthorizationType: J.index
    }), re = [{
      pubkey: T,
      isSigner: !1,
      isWritable: !0
    }, {
      pubkey: SYSVAR_CLOCK_PUBKEY,
      isSigner: !1,
      isWritable: !1
    }, {
      pubkey: $,
      isSigner: !0,
      isWritable: !1
    }];
    return new Transaction().add({
      keys: re,
      programId: this.programId,
      data: te
    });
  }
  /**
   * Generate a transaction that authorizes a new Voter or Withdrawer on the Vote account
   * where the current Voter or Withdrawer authority is a derived key.
   */
  static authorizeWithSeed(e) {
    const {
      currentAuthorityDerivedKeyBasePubkey: T,
      currentAuthorityDerivedKeyOwnerPubkey: $,
      currentAuthorityDerivedKeySeed: V,
      newAuthorizedPubkey: J,
      voteAuthorizationType: ee,
      votePubkey: te
    } = e, re = VOTE_INSTRUCTION_LAYOUTS.AuthorizeWithSeed, ie = encodeData(re, {
      voteAuthorizeWithSeedArgs: {
        currentAuthorityDerivedKeyOwnerPubkey: toBuffer($.toBuffer()),
        currentAuthorityDerivedKeySeed: V,
        newAuthorized: toBuffer(J.toBuffer()),
        voteAuthorizationType: ee.index
      }
    }), se = [{
      pubkey: te,
      isSigner: !1,
      isWritable: !0
    }, {
      pubkey: SYSVAR_CLOCK_PUBKEY,
      isSigner: !1,
      isWritable: !1
    }, {
      pubkey: T,
      isSigner: !0,
      isWritable: !1
    }];
    return new Transaction().add({
      keys: se,
      programId: this.programId,
      data: ie
    });
  }
  /**
   * Generate a transaction to withdraw from a Vote account.
   */
  static withdraw(e) {
    const {
      votePubkey: T,
      authorizedWithdrawerPubkey: $,
      lamports: V,
      toPubkey: J
    } = e, ee = VOTE_INSTRUCTION_LAYOUTS.Withdraw, te = encodeData(ee, {
      lamports: V
    }), re = [{
      pubkey: T,
      isSigner: !1,
      isWritable: !0
    }, {
      pubkey: J,
      isSigner: !1,
      isWritable: !0
    }, {
      pubkey: $,
      isSigner: !0,
      isWritable: !1
    }];
    return new Transaction().add({
      keys: re,
      programId: this.programId,
      data: te
    });
  }
  /**
   * Generate a transaction to withdraw safely from a Vote account.
   *
   * This function was created as a safeguard for vote accounts running validators, `safeWithdraw`
   * checks that the withdraw amount will not exceed the specified balance while leaving enough left
   * to cover rent. If you wish to close the vote account by withdrawing the full amount, call the
   * `withdraw` method directly.
   */
  static safeWithdraw(e, T, $) {
    if (e.lamports > T - $)
      throw new Error("Withdraw will leave vote account with insufficient funds.");
    return VoteProgram.withdraw(e);
  }
  /**
   * Generate a transaction to update the validator identity (node pubkey) of a Vote account.
   */
  static updateValidatorIdentity(e) {
    const {
      votePubkey: T,
      authorizedWithdrawerPubkey: $,
      nodePubkey: V
    } = e, J = VOTE_INSTRUCTION_LAYOUTS.UpdateValidatorIdentity, ee = encodeData(J), te = [{
      pubkey: T,
      isSigner: !1,
      isWritable: !0
    }, {
      pubkey: V,
      isSigner: !0,
      isWritable: !1
    }, {
      pubkey: $,
      isSigner: !0,
      isWritable: !1
    }];
    return new Transaction().add({
      keys: te,
      programId: this.programId,
      data: ee
    });
  }
}
VoteProgram.programId = new PublicKey("Vote111111111111111111111111111111111111111");
VoteProgram.space = 3762;
const VALIDATOR_INFO_KEY = new PublicKey("Va1idator1nfo111111111111111111111111111111"), InfoString = type$2({
  name: string$2(),
  website: optional$2(string$2()),
  details: optional$2(string$2()),
  iconUrl: optional$2(string$2()),
  keybaseUsername: optional$2(string$2())
});
class ValidatorInfo {
  /**
   * Construct a valid ValidatorInfo
   *
   * @param key validator public key
   * @param info validator information
   */
  constructor(e, T) {
    this.key = void 0, this.info = void 0, this.key = e, this.info = T;
  }
  /**
   * Deserialize ValidatorInfo from the config account data. Exactly two config
   * keys are required in the data.
   *
   * @param buffer config account data
   * @return null if info was not found
   */
  static fromConfigData(e) {
    let T = [...e];
    if (decodeLength(T) !== 2) return null;
    const V = [];
    for (let J = 0; J < 2; J++) {
      const ee = new PublicKey(guardedSplice(T, 0, PUBLIC_KEY_LENGTH)), te = guardedShift(T) === 1;
      V.push({
        publicKey: ee,
        isSigner: te
      });
    }
    if (V[0].publicKey.equals(VALIDATOR_INFO_KEY) && V[1].isSigner) {
      const J = rustString().decode(bufferPolyfill.Buffer.from(T)), ee = JSON.parse(J);
      return assert$4(ee, InfoString), new ValidatorInfo(V[1].publicKey, ee);
    }
    return null;
  }
}
const VOTE_PROGRAM_ID = new PublicKey("Vote111111111111111111111111111111111111111"), VoteAccountLayout = struct$1([
  publicKey$4("nodePubkey"),
  publicKey$4("authorizedWithdrawer"),
  u8$1("commission"),
  nu64$1(),
  // votes.length
  seq(struct$1([nu64$1("slot"), u32$1("confirmationCount")]), offset$3(u32$1(), -8), "votes"),
  u8$1("rootSlotValid"),
  nu64$1("rootSlot"),
  nu64$1(),
  // authorizedVoters.length
  seq(struct$1([nu64$1("epoch"), publicKey$4("authorizedVoter")]), offset$3(u32$1(), -8), "authorizedVoters"),
  struct$1([seq(struct$1([publicKey$4("authorizedPubkey"), nu64$1("epochOfLastAuthorizedSwitch"), nu64$1("targetEpoch")]), 32, "buf"), nu64$1("idx"), u8$1("isEmpty")], "priorVoters"),
  nu64$1(),
  // epochCredits.length
  seq(struct$1([nu64$1("epoch"), nu64$1("credits"), nu64$1("prevCredits")]), offset$3(u32$1(), -8), "epochCredits"),
  struct$1([nu64$1("slot"), nu64$1("timestamp")], "lastTimestamp")
]);
class VoteAccount {
  /**
   * @internal
   */
  constructor(e) {
    this.nodePubkey = void 0, this.authorizedWithdrawer = void 0, this.commission = void 0, this.rootSlot = void 0, this.votes = void 0, this.authorizedVoters = void 0, this.priorVoters = void 0, this.epochCredits = void 0, this.lastTimestamp = void 0, this.nodePubkey = e.nodePubkey, this.authorizedWithdrawer = e.authorizedWithdrawer, this.commission = e.commission, this.rootSlot = e.rootSlot, this.votes = e.votes, this.authorizedVoters = e.authorizedVoters, this.priorVoters = e.priorVoters, this.epochCredits = e.epochCredits, this.lastTimestamp = e.lastTimestamp;
  }
  /**
   * Deserialize VoteAccount from the account data.
   *
   * @param buffer account data
   * @return VoteAccount
   */
  static fromAccountData(e) {
    const $ = VoteAccountLayout.decode(toBuffer(e), 4);
    let V = $.rootSlot;
    return $.rootSlotValid || (V = null), new VoteAccount({
      nodePubkey: new PublicKey($.nodePubkey),
      authorizedWithdrawer: new PublicKey($.authorizedWithdrawer),
      commission: $.commission,
      votes: $.votes,
      rootSlot: V,
      authorizedVoters: $.authorizedVoters.map(parseAuthorizedVoter),
      priorVoters: getPriorVoters($.priorVoters),
      epochCredits: $.epochCredits,
      lastTimestamp: $.lastTimestamp
    });
  }
}
function parseAuthorizedVoter({
  authorizedVoter: C,
  epoch: e
}) {
  return {
    epoch: e,
    authorizedVoter: new PublicKey(C)
  };
}
function parsePriorVoters({
  authorizedPubkey: C,
  epochOfLastAuthorizedSwitch: e,
  targetEpoch: T
}) {
  return {
    authorizedPubkey: new PublicKey(C),
    epochOfLastAuthorizedSwitch: e,
    targetEpoch: T
  };
}
function getPriorVoters({
  buf: C,
  idx: e,
  isEmpty: T
}) {
  return T ? [] : [...C.slice(e + 1).map(parsePriorVoters), ...C.slice(0, e).map(parsePriorVoters)];
}
const endpoint = {
  http: {
    devnet: "http://api.devnet.solana.com",
    testnet: "http://api.testnet.solana.com",
    "mainnet-beta": "http://api.mainnet-beta.solana.com/"
  },
  https: {
    devnet: "https://api.devnet.solana.com",
    testnet: "https://api.testnet.solana.com",
    "mainnet-beta": "https://api.mainnet-beta.solana.com/"
  }
};
function clusterApiUrl(C, e) {
  const T = e === !1 ? "http" : "https";
  if (!C)
    return endpoint[T].devnet;
  const $ = endpoint[T][C];
  if (!$)
    throw new Error(`Unknown ${T} cluster: ${C}`);
  return $;
}
async function sendAndConfirmRawTransaction$1(C, e, T, $) {
  let V, J;
  T && Object.prototype.hasOwnProperty.call(T, "lastValidBlockHeight") || T && Object.prototype.hasOwnProperty.call(T, "nonceValue") ? (V = T, J = $) : J = T;
  const ee = J && {
    skipPreflight: J.skipPreflight,
    preflightCommitment: J.preflightCommitment || J.commitment,
    minContextSlot: J.minContextSlot
  }, te = await C.sendRawTransaction(e, ee), re = J && J.commitment, se = (await (V ? C.confirmTransaction(V, re) : C.confirmTransaction(te, re))).value;
  if (se.err)
    throw te != null ? new SendTransactionError({
      action: ee != null && ee.skipPreflight ? "send" : "simulate",
      signature: te,
      transactionMessage: `Status: (${JSON.stringify(se)})`
    }) : new Error(`Raw transaction ${te} failed (${JSON.stringify(se)})`);
  return te;
}
const LAMPORTS_PER_SOL = 1e9, index_browser_esm = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Account,
  AddressLookupTableAccount,
  AddressLookupTableInstruction,
  AddressLookupTableProgram,
  Authorized,
  BLOCKHASH_CACHE_TIMEOUT_MS,
  BPF_LOADER_DEPRECATED_PROGRAM_ID,
  BPF_LOADER_PROGRAM_ID,
  BpfLoader,
  COMPUTE_BUDGET_INSTRUCTION_LAYOUTS,
  ComputeBudgetInstruction,
  ComputeBudgetProgram,
  Connection: Connection$1,
  Ed25519Program,
  Enum,
  EpochSchedule,
  FeeCalculatorLayout,
  Keypair,
  LAMPORTS_PER_SOL,
  LOOKUP_TABLE_INSTRUCTION_LAYOUTS,
  Loader,
  Lockup,
  MAX_SEED_LENGTH,
  Message,
  MessageAccountKeys,
  MessageV0,
  NONCE_ACCOUNT_LENGTH,
  NonceAccount,
  PACKET_DATA_SIZE,
  PUBLIC_KEY_LENGTH,
  PublicKey,
  SIGNATURE_LENGTH_IN_BYTES,
  SOLANA_SCHEMA,
  STAKE_CONFIG_ID,
  STAKE_INSTRUCTION_LAYOUTS,
  SYSTEM_INSTRUCTION_LAYOUTS,
  SYSVAR_CLOCK_PUBKEY,
  SYSVAR_EPOCH_SCHEDULE_PUBKEY,
  SYSVAR_INSTRUCTIONS_PUBKEY,
  SYSVAR_RECENT_BLOCKHASHES_PUBKEY,
  SYSVAR_RENT_PUBKEY,
  SYSVAR_REWARDS_PUBKEY,
  SYSVAR_SLOT_HASHES_PUBKEY,
  SYSVAR_SLOT_HISTORY_PUBKEY,
  SYSVAR_STAKE_HISTORY_PUBKEY,
  Secp256k1Program,
  SendTransactionError,
  SolanaJSONRPCError,
  SolanaJSONRPCErrorCode,
  StakeAuthorizationLayout,
  StakeInstruction,
  StakeProgram,
  Struct: Struct$2,
  SystemInstruction,
  SystemProgram,
  Transaction,
  TransactionExpiredBlockheightExceededError,
  TransactionExpiredNonceInvalidError,
  TransactionExpiredTimeoutError,
  TransactionInstruction,
  TransactionMessage,
  TransactionStatus,
  VALIDATOR_INFO_KEY,
  VERSION_PREFIX_MASK,
  VOTE_PROGRAM_ID,
  ValidatorInfo,
  VersionedMessage,
  VersionedTransaction,
  VoteAccount,
  VoteAuthorizationLayout,
  VoteInit,
  VoteInstruction,
  VoteProgram,
  clusterApiUrl,
  sendAndConfirmRawTransaction: sendAndConfirmRawTransaction$1,
  sendAndConfirmTransaction
}, Symbol.toStringTag, { value: "Module" })), _platform = "Solana", SolanaZeroAddress = "11111111111111111111111111111111", Oi = class Oi {
  constructor(e) {
    tt(this, "type", "Native");
    tt(this, "address");
    Oi.instanceof(e) ? this.address = e.address : UniversalAddress.instanceof(e) ? this.address = new PublicKey(e.toUint8Array()) : typeof e == "string" && hex$1.valid(e) ? this.address = new PublicKey(hex$1.decode(e)) : this.address = new PublicKey(e);
  }
  unwrap() {
    return this.address;
  }
  toString() {
    return this.address.toBase58();
  }
  toUint8Array() {
    return new Uint8Array(this.address.toBytes());
  }
  toNative() {
    return this;
  }
  toUniversalAddress() {
    return new UniversalAddress(this.toUint8Array());
  }
  static instanceof(e) {
    return e.constructor.platform === Oi.platform;
  }
  equals(e) {
    return Oi.instanceof(e) ? e.unwrap().equals(this.unwrap()) : this.toUniversalAddress().equals(e);
  }
};
tt(Oi, "byteSize", 32), tt(Oi, "platform", _platform);
let SolanaAddress = Oi;
registerNative(_platform, SolanaAddress);
function base$2(C) {
  if (C.length >= 255)
    throw new TypeError("Alphabet too long");
  for (var e = new Uint8Array(256), T = 0; T < e.length; T++)
    e[T] = 255;
  for (var $ = 0; $ < C.length; $++) {
    var V = C.charAt($), J = V.charCodeAt(0);
    if (e[J] !== 255)
      throw new TypeError(V + " is ambiguous");
    e[J] = $;
  }
  var ee = C.length, te = C.charAt(0), re = Math.log(ee) / Math.log(256), ie = Math.log(256) / Math.log(ee);
  function se(fe) {
    if (fe instanceof Uint8Array || (ArrayBuffer.isView(fe) ? fe = new Uint8Array(fe.buffer, fe.byteOffset, fe.byteLength) : Array.isArray(fe) && (fe = Uint8Array.from(fe))), !(fe instanceof Uint8Array))
      throw new TypeError("Expected Uint8Array");
    if (fe.length === 0)
      return "";
    for (var he = 0, me = 0, xe = 0, ve = fe.length; xe !== ve && fe[xe] === 0; )
      xe++, he++;
    for (var Te = (ve - xe) * ie + 1 >>> 0, we = new Uint8Array(Te); xe !== ve; ) {
      for (var Ee = fe[xe], Me = 0, Ie = Te - 1; (Ee !== 0 || Me < me) && Ie !== -1; Ie--, Me++)
        Ee += 256 * we[Ie] >>> 0, we[Ie] = Ee % ee >>> 0, Ee = Ee / ee >>> 0;
      if (Ee !== 0)
        throw new Error("Non-zero carry");
      me = Me, xe++;
    }
    for (var ke = Te - me; ke !== Te && we[ke] === 0; )
      ke++;
    for (var _e = te.repeat(he); ke < Te; ++ke)
      _e += C.charAt(we[ke]);
    return _e;
  }
  function de(fe) {
    if (typeof fe != "string")
      throw new TypeError("Expected String");
    if (fe.length === 0)
      return new Uint8Array();
    for (var he = 0, me = 0, xe = 0; fe[he] === te; )
      me++, he++;
    for (var ve = (fe.length - he) * re + 1 >>> 0, Te = new Uint8Array(ve); fe[he]; ) {
      var we = e[fe.charCodeAt(he)];
      if (we === 255)
        return;
      for (var Ee = 0, Me = ve - 1; (we !== 0 || Ee < xe) && Me !== -1; Me--, Ee++)
        we += ee * Te[Me] >>> 0, Te[Me] = we % 256 >>> 0, we = we / 256 >>> 0;
      if (we !== 0)
        throw new Error("Non-zero carry");
      xe = Ee, he++;
    }
    for (var Ie = ve - xe; Ie !== ve && Te[Ie] === 0; )
      Ie++;
    for (var ke = new Uint8Array(me + (ve - Ie)), _e = me; Ie !== ve; )
      ke[_e++] = Te[Ie++];
    return ke;
  }
  function ue(fe) {
    var he = de(fe);
    if (he)
      return he;
    throw new Error("Non-base" + ee + " character");
  }
  return {
    encode: se,
    decodeUnsafe: de,
    decode: ue
  };
}
var src$1 = base$2;
const basex$1 = src$1, ALPHABET$1 = "123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz";
var bs58$3 = basex$1(ALPHABET$1);
const bs58$4 = /* @__PURE__ */ getDefaultExportFromCjs$2(bs58$3), toB58$1 = (C) => bs58$4.encode(C), fromB58$1 = (C) => bs58$4.decode(C), TX_DIGEST_LENGTH$1 = 32;
function isValidTransactionDigest$1(C) {
  try {
    return fromB58$1(C).length === TX_DIGEST_LENGTH$1;
  } catch {
    return !1;
  }
}
const SUI_ADDRESS_LENGTH$2 = 32;
function isValidSuiAddress$1(C) {
  return isHex$1(C) && getHexByteLength$1(C) === SUI_ADDRESS_LENGTH$2;
}
function isValidSuiObjectId$1(C) {
  return isValidSuiAddress$1(C);
}
function normalizeSuiAddress$1(C, e = !1) {
  let T = C.toLowerCase();
  return !e && T.startsWith("0x") && (T = T.slice(2)), `0x${T.padStart(SUI_ADDRESS_LENGTH$2 * 2, "0")}`;
}
function normalizeSuiObjectId$1(C, e = !1) {
  return normalizeSuiAddress$1(C, e);
}
function isHex$1(C) {
  return /^(0x|0X)?[a-fA-F0-9]+$/.test(C) && C.length % 2 === 0;
}
function getHexByteLength$1(C) {
  return /^(0x|0X)/.test(C) ? (C.length - 2) / 2 : C.length / 2;
}
BigInt(1e9);
const MOVE_STDLIB_ADDRESS$1 = "0x1", SUI_FRAMEWORK_ADDRESS$1 = "0x2";
normalizeSuiObjectId$1("0x6");
const SUI_TYPE_ARG$1 = `${SUI_FRAMEWORK_ADDRESS$1}::sui::SUI`;
normalizeSuiObjectId$1("0x5");
const SUI_SEPARATOR = "::", SUI_COIN = "0x2::sui::SUI", isValidSuiType = (C) => /^(0x)?[0-9a-fA-F]+::\w+::\w+$/.test(C), trimSuiType = (C) => C.replace(/(0x)(0*)/g, "0x");
function zpadSuiAddress(C) {
  return C = C.startsWith("0x") ? C.slice(2) : C, C = C.length % 2 === 0 ? C : "0" + C, `0x${C.length === 64 ? C : hex$1.encode(bytes.zpad(hex$1.decode(C), 32))}`;
}
const normalizeSuiType = (C) => {
  const e = C.split(SUI_SEPARATOR);
  if (e.length !== 3)
    throw new Error(`Invalid Sui type: ${C}`);
  return [normalizeSuiAddress$1(e[0]), e[1], e[2]].join(SUI_SEPARATOR);
}, getCoinTypeFromPackageId = (C) => new SuiAddress$1(C).getCoinType(), getPackageIdFromType = (C) => new SuiAddress$1(C).getPackageId(), getTableKeyType = (C) => {
  const e = trimSuiType(C).match(/0x2::table::Table<(.*)>/);
  if (!e)
    throw new Error(`Invalid table type: ${C}`);
  if (e.length < 2)
    throw new Error(`Invalid table type: ${C}`);
  const [T] = e[1].split(",");
  if (!T || !isValidSuiType(T))
    throw new Error(`Invalid key type: ${T}`);
  return T;
};
var Fr;
let SuiAddress$1 = (Fr = class {
  constructor(e) {
    // Full 32 bytes of Address
    tt(this, "address");
    // Optional module and contract name
    tt(this, "module");
    if (Fr.instanceof(e))
      this.address = e.address, this.module = e.module;
    else if (UniversalAddress.instanceof(e))
      this.address = e.toUint8Array();
    else if (typeof e == "string") {
      if (isValidSuiType(e)) {
        const T = e.split(SUI_SEPARATOR);
        this.module = T.slice(1).join(SUI_SEPARATOR), e = T[0];
      }
      if (e = zpadSuiAddress(e), !hex$1.valid(e))
        throw new Error("Invalid Sui address: " + e);
      this.address = hex$1.decode(e);
    } else
      this.address = e;
  }
  unwrap() {
    const e = this.getPackageId(), T = this.module ? SUI_SEPARATOR + this.module : "";
    return `${e}${T}`;
  }
  toString() {
    return this.unwrap();
  }
  toNative() {
    return this;
  }
  toUint8Array() {
    return this.address;
  }
  toUniversalAddress() {
    return new UniversalAddress(this.toUint8Array());
  }
  getPackageId() {
    return zpadSuiAddress(hex$1.encode(this.address));
  }
  getCoinType() {
    if (this.module === "sui::SUI")
      return SUI_COIN;
    if (!this.module)
      throw new Error("No module present in Sui token address");
    return this.unwrap();
  }
  static instanceof(e) {
    return e.constructor.platform === Fr.platform;
  }
  equals(e) {
    return Fr.instanceof(e) ? e.unwrap() === this.unwrap() : this.toUniversalAddress().equals(e);
  }
}, tt(Fr, "byteSize", 32), tt(Fr, "platform", "Sui"), Fr);
registerNative("Sui", SuiAddress$1);
async function loadPlatforms(C) {
  try {
    const e = await Promise.all(C.map(async (T) => T()));
    return await Promise.all(e.map(async (T) => await loadProtocols(T))), e;
  } catch (e) {
    throw console.error("Failed to load required packages", e), e;
  }
}
async function loadProtocols(C, e) {
  try {
    let T = Object.entries(C.protocols);
    await Promise.all(T.map(([, $]) => $()));
  } catch (T) {
    throw console.error("Failed to load required packages", T), T;
  }
}
async function wormhole(C, e, T) {
  const $ = (await loadPlatforms(e)).map((V) => V.Platform);
  return new Wormhole(C, $, T);
}
class WormholeContext extends MultiProvider {
  constructor(T, $) {
    super();
    tt(this, "conf");
    $ ? this.conf = $ : this.conf = WormholeContext.getConfig(T), this.registerProviders();
  }
  get environment() {
    return this.conf.env;
  }
  /**
   * Registers evm providers
   */
  registerProviders() {
    var T;
    for (const $ of Object.keys(this.conf.rpcs)) {
      const V = toChainId($);
      if (!V) throw new Error(`Unknown chain ${$}`);
      this.registerDomain({
        domain: V,
        name: $
      }), ((T = this.conf.chains[$]) == null ? void 0 : T.context) === Context.ETH && this.registerRpcProvider($, this.conf.rpcs[$]);
    }
  }
  /**
   * Returns the chain "context", i.e. the class with chain-specific logic and methods
   * @param chain the chain name or chain id
   * @returns the chain context class
   * @throws Errors if context is not found
   */
  getContext(T) {
    return this;
  }
  /**
   * Get the default config for Mainnet or Testnet
   *
   * @param environment 'MAINNET' or 'TESTNET'
   * @returns A Wormhole Config
   */
  static getConfig(T) {
    return T === "Mainnet" ? MAINNET_CONFIG : T === "Devnet" ? DEVNET_CONFIG : TESTNET_CONFIG;
  }
}
const fs = class fs extends Error {
  constructor() {
    super(fs.MESSAGE);
  }
};
tt(fs, "MESSAGE", "Insufficient funds for gas"), tt(fs, "MESSAGE_REGEX", /insufficient funds|Insufficient funds for gas/gm);
let InsufficientFundsForGasError = fs;
const CONFIG = {
  MAINNET: MAINNET_CONFIG,
  TESTNET: TESTNET_CONFIG,
  DEVNET: DEVNET_CONFIG
}, { chains: chains$3 } = CONFIG.MAINNET, MAINNET_CHAINS = {
  Ethereum: {
    ...chains$3.Ethereum,
    displayName: "Ethereum",
    explorerUrl: "https://etherscan.io/",
    explorerName: "Etherscan",
    gasToken: "ETH",
    chainId: 1,
    icon: "Ethereum",
    maxBlockSearch: 2e3,
    symbol: "ETH"
  },
  Bsc: {
    ...chains$3.Bsc,
    displayName: "BSC",
    explorerUrl: "https://bscscan.com/",
    explorerName: "BscScan",
    gasToken: "BNB",
    chainId: 56,
    icon: "Bsc",
    maxBlockSearch: 2e3,
    symbol: "BSC"
  },
  Polygon: {
    ...chains$3.Polygon,
    displayName: "Polygon",
    explorerUrl: "https://polygonscan.com/",
    explorerName: "PolygonScan",
    gasToken: "POL",
    chainId: 137,
    icon: "Polygon",
    maxBlockSearch: 1e3,
    symbol: "POL"
  },
  Avalanche: {
    ...chains$3.Avalanche,
    displayName: "Avalanche",
    explorerUrl: "https://avascan.info/blockchain/c/",
    explorerName: "Avascan",
    gasToken: "AVAX",
    chainId: 43114,
    icon: "Avalanche",
    maxBlockSearch: 2e3,
    symbol: "AVAX"
  },
  Fantom: {
    ...chains$3.Fantom,
    displayName: "Fantom",
    explorerUrl: "https://ftmscan.com/",
    explorerName: "FTMscan",
    gasToken: "FTM",
    chainId: 250,
    icon: "Fantom",
    maxBlockSearch: 2e3,
    symbol: "FTM"
  },
  Celo: {
    ...chains$3.Celo,
    displayName: "Celo",
    explorerUrl: "https://explorer.celo.org/mainnet/",
    explorerName: "Celo Explorer",
    gasToken: "CELO",
    chainId: 42220,
    icon: "Celo",
    maxBlockSearch: 2e3,
    symbol: "CELO"
  },
  Moonbeam: {
    ...chains$3.Moonbeam,
    displayName: "Moonbeam",
    explorerUrl: "https://moonscan.io/",
    explorerName: "Moonscan",
    gasToken: "GLMR",
    chainId: 1284,
    icon: "Moonbeam",
    maxBlockSearch: 2e3,
    symbol: "GLMR"
  },
  Solana: {
    ...chains$3.Solana,
    displayName: "Solana",
    explorerUrl: "https://explorer.solana.com/",
    explorerName: "Solana Explorer",
    gasToken: "SOL",
    chainId: 0,
    icon: "Solana",
    maxBlockSearch: 2e3,
    symbol: "SOL"
  },
  Sui: {
    ...chains$3.Sui,
    displayName: "Sui",
    explorerUrl: "https://suiscan.xyz/",
    explorerName: "Suiscan",
    gasToken: "SUI",
    chainId: 0,
    icon: "Sui",
    maxBlockSearch: 0,
    symbol: "SUI"
  },
  Aptos: {
    ...chains$3.Aptos,
    displayName: "Aptos",
    explorerUrl: "https://explorer.aptoslabs.com/",
    explorerName: "Aptos Explorer",
    gasToken: "APT",
    chainId: 0,
    icon: "Aptos",
    maxBlockSearch: 0,
    symbol: "APT"
  },
  Base: {
    ...chains$3.Base,
    displayName: "Base",
    explorerUrl: "https://basescan.org/",
    explorerName: "BaseScan",
    gasToken: "ETHbase",
    chainId: 8453,
    icon: "Base",
    maxBlockSearch: 2e3,
    symbol: "BASE"
  },
  // TODO: SDKV2 - re-enable cosmos chains once cosmos gateway route is implemented
  //Osmosis: {
  //  ...chains.Osmosis!,
  //  displayName: 'Osmosis',
  //  explorerUrl: 'https://mintscan.io/osmosis/',
  //  explorerName: 'MintScan',
  //  gasToken: 'OSMO',
  //  chainId: 'osmosis-1',
  //  icon: 'Osmosis,
  //  maxBlockSearch: 0,
  //},
  //Wormchain: {
  //  ...chains.Wormchain!,
  //  displayName: 'Wormchain',
  //  explorerUrl: '',
  //  explorerName: '',
  //  gasToken: 'WORM',
  //  chainId: '',
  //  icon: 'Osmosis,
  //  maxBlockSearch: 0,
  //},
  Arbitrum: {
    ...chains$3.Arbitrum,
    displayName: "Arbitrum",
    explorerUrl: "https://arbiscan.io/",
    explorerName: "Arbitrum Explorer",
    gasToken: "ETHarbitrum",
    chainId: 42161,
    icon: "Arbitrum",
    maxBlockSearch: 2e3,
    symbol: "ARB"
  },
  Optimism: {
    ...chains$3.Optimism,
    displayName: "Optimism",
    explorerUrl: "https://optimistic.etherscan.io/",
    explorerName: "Optimistic Etherscan",
    gasToken: "ETHoptimism",
    chainId: 10,
    icon: "Optimism",
    maxBlockSearch: 2e3,
    symbol: "OP"
  },
  Klaytn: {
    ...chains$3.Klaytn,
    displayName: "Kaia",
    explorerUrl: "https://kaiascope.com/",
    explorerName: "Kaia Scope",
    gasToken: "KLAY",
    chainId: 8217,
    icon: "Klaytn",
    maxBlockSearch: 2e3,
    symbol: "KLAY"
  },
  //Evmos: {
  //  ...chains.Evmos!,
  //  displayName: 'Evmos',
  //  explorerUrl: 'https://www.mintscan.io/evmos/',
  //  explorerName: 'MintScan',
  //  gasToken: 'EVMOS',
  //  chainId: 'evmos_9001-2',
  //  icon: 'Evmos',
  //  maxBlockSearch: 0,
  //},
  //Kujira: {
  //  ...chains.Kujira!,
  //  displayName: 'Kujira',
  //  explorerUrl: 'https://finder.kujira.app/kaiyo-1/',
  //  explorerName: 'Kujira Finder',
  //  gasToken: 'KUJI',
  //  chainId: 'kaiyo-1',
  //  icon: 'Kujira',
  //  maxBlockSearch: 0,
  //},
  //Injective: {
  //  ...chains.Injective!,
  //  displayName: 'Injective',
  //  explorerUrl: 'https://explorer.injective.network/',
  //  explorerName: 'Injective Explorer',
  //  gasToken: 'INJ',
  //  chainId: 'injective-1',
  //  icon: 'Injective',
  //  maxBlockSearch: 0,
  //},
  Scroll: {
    ...chains$3.Scroll,
    displayName: "Scroll",
    explorerUrl: "https://scrollscan.com/",
    explorerName: "Scrollscan",
    gasToken: "ETHscroll",
    chainId: 534352,
    icon: "Scroll",
    maxBlockSearch: 2e3,
    symbol: "SCR"
  },
  Blast: {
    ...chains$3.Blast,
    displayName: "Blast",
    explorerUrl: "https://blastscan.io/",
    explorerName: "Blastscan",
    gasToken: "ETHblast",
    chainId: 81457,
    icon: "Blast",
    maxBlockSearch: 2e3,
    symbol: "BLAST"
  },
  Xlayer: {
    ...chains$3.Xlayer,
    displayName: "X Layer",
    explorerUrl: "https://www.okx.com/web3/explorer/xlayer/",
    explorerName: "OKX Explorer",
    gasToken: "OKB",
    chainId: 196,
    icon: "Xlayer",
    maxBlockSearch: 2e3,
    symbol: "OKX"
  },
  Mantle: {
    ...chains$3.Mantle,
    displayName: "Mantle",
    explorerUrl: "https://explorer.mantle.xyz/",
    explorerName: "Mantle Explorer",
    gasToken: "MNT",
    chainId: 5e3,
    icon: "Mantle",
    maxBlockSearch: 2e3,
    symbol: "MNT"
  },
  Worldchain: {
    ...chains$3.Worldchain,
    displayName: "World Chain",
    explorerUrl: "https://worldscan.org/",
    explorerName: "World Scan",
    gasToken: "ETHworldchain",
    chainId: 480,
    icon: "Worldchain",
    maxBlockSearch: 2e3,
    symbol: "WORLD"
  }
}, error = (C) => {
  console.error(`Wormhole Connect: ${C}`);
}, populateRpcField = (C, e) => e ? { [C]: e } : {}, mergeCustomTokensConfig = (C, e) => {
  if (!e) return C;
  const $ = Object.values(C).map((V) => V.key);
  e: for (const V in e) {
    const J = e[V];
    if (V in C) {
      console.warn(
        `Skipping custom token config for "${V}" because it conflicts with a built-in`
      );
      continue;
    }
    for (const ee of Object.values(C))
      if (ee.nativeChain === J.nativeChain && ee.symbol === J.symbol) {
        console.warn(
          `Skipping custom token config for "${V}" because its symbol "${J.symbol}" and chain ${J.nativeChain} conflicts with a built-in`
        );
        continue e;
      }
    if ($.includes(J.key)) {
      console.warn(
        `Skipping custom token config for "${V}" because its key "${J.key}" conflicts with a built-in`
      );
      continue;
    }
    console.info(`Accepted custom token config for "${V}"`), C[V] = J;
  }
  return C;
}, mergeCustomWrappedTokens = (C, e) => {
  if (!e) return C;
  for (const T in e)
    C[T] = {
      ...e[T],
      // Prevent overwriting built-in wrapped token addresses
      ...C[T]
    };
  return C;
}, validateDefaults = (C, e, T) => {
  if (C) {
    if (C.fromChain && (e[C.fromChain] || (error(
      `Invalid chain name "${C.fromChain}" specified for defaultInputs.fromChain`
    ), delete C.fromChain)), C.toChain && (e[C.toChain] || (error(
      `Invalid chain name "${C.toChain}" specified for defaultInputs.toChain`
    ), delete C.fromChain)), C.fromChain && C.toChain && C.fromChain === C.toChain && error(
      "Source and destination chain cannot be the same, check the defaultInputs configuration"
    ), C.fromChain && C.toChain && C.requiredChain && (e[C.requiredChain] || error(
      `Invalid network value "${C.requiredChain}" specified for defaultInputs.requiredChain`
    ), C.toChain !== C.requiredChain && C.fromChain !== C.requiredChain && error(
      "Source chain or destination chain must equal the required network"
    )), C.tokenKey && (T[C.tokenKey] || (error(
      `Invalid token "${C.tokenKey}" specified for defaultInputs.tokenKey`
    ), delete C.tokenKey)), C.fromChain && C.tokenKey) {
      const $ = e[C.fromChain], { tokenId: V, nativeChain: J } = T[C.tokenKey];
      !V && J !== $.key && error(
        `Invalid token "${C.tokenKey}" specified for defaultInputs.tokenKey. It does not exist on "${C.fromChain}"`
      );
    }
    return C;
  }
}, capitalize$1 = (C) => C[0].toUpperCase() + C.slice(1), __vite_import_meta_env__$2 = { BASE_URL: "/", DEV: !1, MODE: "production", PROD: !0, REACT_APP_CONNECT_GIT_HASH: "f3e2348ce4d17de817ae4eea097fa890dc70f16b", REACT_APP_CONNECT_VERSION: "1.2.0", SSR: !1 }, {
  REACT_APP_ETHEREUM_RPC,
  REACT_APP_SOLANA_RPC,
  REACT_APP_POLYGON_RPC,
  REACT_APP_BSC_RPC,
  REACT_APP_AVALANCHE_RPC,
  REACT_APP_FANTOM_RPC,
  REACT_APP_CELO_RPC,
  REACT_APP_MOONBEAM_RPC,
  REACT_APP_SUI_RPC,
  REACT_APP_APTOS_RPC,
  REACT_APP_SEI_RPC,
  REACT_APP_BASE_RPC,
  REACT_APP_OSMOSIS_RPC,
  REACT_APP_INJECTIVE_RPC,
  REACT_APP_WORMCHAIN_RPC,
  REACT_APP_EVMOS_RPC,
  REACT_APP_KUJIRA_RPC,
  REACT_APP_KLAYTN_RPC,
  REACT_APP_SEI_REST: REACT_APP_SEI_REST$2,
  REACT_APP_EVMOS_REST: REACT_APP_EVMOS_REST$1,
  REACT_APP_ARBITRUM_RPC,
  REACT_APP_OPTIMISM_RPC,
  REACT_APP_APTOS_GRAPHQL,
  REACT_APP_SCROLL_RPC,
  REACT_APP_BLAST_RPC,
  REACT_APP_XLAYER_RPC,
  REACT_APP_MANTLE_RPC,
  REACT_APP_WORLDCHAIN_RPC
} = __vite_import_meta_env__$2, MAINNET_RPC_MAPPING = {
  ...populateRpcField("Ethereum", REACT_APP_ETHEREUM_RPC),
  ...populateRpcField("Solana", REACT_APP_SOLANA_RPC),
  ...populateRpcField("Polygon", REACT_APP_POLYGON_RPC),
  ...populateRpcField("Bsc", REACT_APP_BSC_RPC),
  ...populateRpcField("Avalanche", REACT_APP_AVALANCHE_RPC),
  ...populateRpcField("Fantom", REACT_APP_FANTOM_RPC),
  ...populateRpcField("Celo", REACT_APP_CELO_RPC),
  ...populateRpcField("Moonbeam", REACT_APP_MOONBEAM_RPC),
  ...populateRpcField("Sui", REACT_APP_SUI_RPC),
  ...populateRpcField("Aptos", REACT_APP_APTOS_RPC),
  ...populateRpcField("Sei", REACT_APP_SEI_RPC),
  ...populateRpcField("Base", REACT_APP_BASE_RPC),
  ...populateRpcField("Osmosis", REACT_APP_OSMOSIS_RPC),
  ...populateRpcField("Wormchain", REACT_APP_WORMCHAIN_RPC),
  ...populateRpcField("Arbitrum", REACT_APP_ARBITRUM_RPC),
  ...populateRpcField("Optimism", REACT_APP_OPTIMISM_RPC),
  ...populateRpcField("Evmos", REACT_APP_EVMOS_RPC),
  ...populateRpcField("Kujira", REACT_APP_KUJIRA_RPC),
  ...populateRpcField("Injective", REACT_APP_INJECTIVE_RPC),
  ...populateRpcField("Klaytn", REACT_APP_KLAYTN_RPC),
  ...populateRpcField("Scroll", REACT_APP_SCROLL_RPC),
  ...populateRpcField("Blast", REACT_APP_BLAST_RPC),
  ...populateRpcField("Xlayer", REACT_APP_XLAYER_RPC),
  ...populateRpcField("Mantle", REACT_APP_MANTLE_RPC),
  ...populateRpcField("Worldchain", REACT_APP_WORLDCHAIN_RPC)
}, MAINNET_REST_MAPPING = {
  ...populateRpcField("Sei", REACT_APP_SEI_REST$2),
  ...populateRpcField("Evmos", REACT_APP_EVMOS_REST$1)
}, MAINNET_GRAPHQL_MAPPING = {
  ...populateRpcField("Aptos", REACT_APP_APTOS_GRAPHQL)
};
var TokenIcon = /* @__PURE__ */ ((C) => (C[C.AVAX = 1] = "AVAX", C[C.BNB = 2] = "BNB", C[C.BSC = 3] = "BSC", C[C.CELO = 4] = "CELO", C[C.ETH = 5] = "ETH", C[C.FANTOM = 6] = "FANTOM", C[C.POLYGON = 7] = "POLYGON", C[C.SOLANA = 8] = "SOLANA", C[C.USDC = 9] = "USDC", C[C.GLMR = 10] = "GLMR", C[C.DAI = 11] = "DAI", C[C.USDT = 12] = "USDT", C[C.BUSD = 13] = "BUSD", C[C.WBTC = 14] = "WBTC", C[C.SUI = 15] = "SUI", C[C.APT = 16] = "APT", C[C.SEI = 17] = "SEI", C[C.BASE = 18] = "BASE", C[C.OSMO = 19] = "OSMO", C[C.TBTC = 20] = "TBTC", C[C.WSTETH = 21] = "WSTETH", C[C.ARBITRUM = 22] = "ARBITRUM", C[C.OPTIMISM = 23] = "OPTIMISM", C[C.ATOM = 24] = "ATOM", C[C.EVMOS = 25] = "EVMOS", C[C.KUJI = 26] = "KUJI", C[C.PYTH = 27] = "PYTH", C[C.INJ = 28] = "INJ", C[C.KLAY = 29] = "KLAY", C[C.NTT = 30] = "NTT", C[C.SCROLL = 31] = "SCROLL", C[C.BLAST = 32] = "BLAST", C[C.XLAYER = 33] = "XLAYER", C[C.MANTLE = 34] = "MANTLE", C[C.WORLDCHAIN = 35] = "WORLDCHAIN", C))(TokenIcon || {});
class WrappedTokenAddressCache {
  constructor(e, T) {
    tt(this, "caches");
    this.caches = {};
    for (const [$, V] of Object.entries(e)) {
      const J = T[$];
      if (J)
        for (const ee in J) {
          const te = J[ee], re = Wormhole.parseAddress(ee, te);
          this.set($, ee, re);
        }
      if (V.tokenId)
        try {
          this.set(
            $,
            V.nativeChain,
            Wormhole.parseAddress(V.nativeChain, V.tokenId.address)
          );
        } catch (ee) {
          console.error("Error caching foreign asset", V.tokenId, ee);
        }
    }
  }
  get(e, T) {
    const $ = this.caches[T];
    return $ && $[e] || null;
  }
  set(e, T, $) {
    this.caches[T] || (this.caches[T] = {});
    const V = this.caches[T];
    V[e] = $;
  }
}
const MAINNET_TOKENS = {
  ETH: {
    key: "ETH",
    symbol: "ETH",
    nativeChain: "Ethereum",
    icon: TokenIcon.ETH,
    coinGeckoId: "ethereum",
    color: "#38487d",
    decimals: 18,
    wrappedAsset: "WETH"
  },
  WETH: {
    key: "WETH",
    symbol: "WETH",
    nativeChain: "Ethereum",
    icon: TokenIcon.ETH,
    tokenId: {
      chain: "Ethereum",
      address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2"
    },
    coinGeckoId: "ethereum",
    color: "#62688F",
    decimals: 18
  },
  USDCeth: {
    key: "USDCeth",
    symbol: "USDC",
    nativeChain: "Ethereum",
    icon: TokenIcon.USDC,
    tokenId: {
      chain: "Ethereum",
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48"
    },
    coinGeckoId: "usd-coin",
    color: "#ffffff",
    decimals: 6
  },
  WBTC: {
    key: "WBTC",
    symbol: "WBTC",
    nativeChain: "Ethereum",
    icon: TokenIcon.WBTC,
    tokenId: {
      chain: "Ethereum",
      address: "0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599"
    },
    coinGeckoId: "wrapped-bitcoin",
    color: "#ffffff",
    decimals: 8
  },
  USDT: {
    key: "USDT",
    symbol: "USDT",
    nativeChain: "Ethereum",
    icon: TokenIcon.USDT,
    tokenId: {
      chain: "Ethereum",
      address: "0xdAC17F958D2ee523a2206206994597C13D831ec7"
    },
    coinGeckoId: "tether",
    color: "#ffffff",
    decimals: 6
  },
  DAI: {
    key: "DAI",
    symbol: "DAI",
    nativeChain: "Ethereum",
    icon: TokenIcon.DAI,
    tokenId: {
      chain: "Ethereum",
      address: "0x6B175474E89094C44Da98b954EedeAC495271d0F"
    },
    coinGeckoId: "dai",
    color: "#FEFEFD",
    decimals: 18
  },
  BUSD: {
    key: "BUSD",
    symbol: "BUSD",
    nativeChain: "Ethereum",
    icon: TokenIcon.BUSD,
    tokenId: {
      chain: "Ethereum",
      address: "0x4Fabb145d64652a948d72533023f6E7A623C7C53"
    },
    coinGeckoId: "binance-usd",
    color: "#F0B90B",
    decimals: 18
  },
  POL: {
    key: "POL",
    symbol: "POL",
    nativeChain: "Polygon",
    icon: TokenIcon.POLYGON,
    coinGeckoId: "matic-network",
    color: "#8247E5",
    decimals: 18,
    wrappedAsset: "WPOL"
  },
  WPOL: {
    key: "WPOL",
    symbol: "WPOL",
    nativeChain: "Polygon",
    icon: TokenIcon.POLYGON,
    tokenId: {
      chain: "Polygon",
      address: "0x0d500B1d8E8eF31E21C99d1Db9A6444d3ADf1270"
    },
    coinGeckoId: "matic-network",
    color: "#8247E5",
    decimals: 18
  },
  WETHpolygon: {
    key: "WETHpolygon",
    symbol: "WETH",
    nativeChain: "Polygon",
    icon: TokenIcon.ETH,
    tokenId: {
      chain: "Polygon",
      address: "0x7ceB23fD6bC0adD59E62ac25578270cFf1b9f619"
    },
    coinGeckoId: "ethereum",
    color: "#D53424",
    decimals: 18
  },
  USDCpolygon: {
    key: "USDCpolygon",
    symbol: "USDC",
    nativeChain: "Polygon",
    icon: TokenIcon.USDC,
    tokenId: {
      chain: "Polygon",
      address: "0x3c499c542cEF5E3811e1192ce70d8cC03d5c3359"
    },
    coinGeckoId: "usd-coin",
    color: "#2774CA",
    decimals: 6
  },
  USDTpolygon: {
    key: "USDTpolygon",
    symbol: "USDT",
    nativeChain: "Polygon",
    icon: TokenIcon.USDT,
    tokenId: {
      chain: "Polygon",
      address: "0xc2132D05D31c914a87C6611C10748AEb04B58e8F"
    },
    coinGeckoId: "tether",
    color: "#ffffff",
    decimals: 6
  },
  BNB: {
    key: "BNB",
    symbol: "BNB",
    nativeChain: "Bsc",
    icon: TokenIcon.BNB,
    coinGeckoId: "binancecoin",
    color: "#F3BA30",
    decimals: 18,
    wrappedAsset: "WBNB"
  },
  WBNB: {
    key: "WBNB",
    symbol: "WBNB",
    nativeChain: "Bsc",
    icon: TokenIcon.BNB,
    tokenId: {
      chain: "Bsc",
      address: "0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c"
    },
    coinGeckoId: "binancecoin",
    color: "#F3BA30",
    decimals: 18
  },
  USDCbnb: {
    key: "USDCbnb",
    symbol: "USDC",
    nativeChain: "Bsc",
    icon: TokenIcon.USDC,
    tokenId: {
      chain: "Bsc",
      address: "0x8AC76a51cc950d9822D68b83fE1Ad97B32Cd580d"
    },
    coinGeckoId: "usd-coin",
    color: "#2774CA",
    decimals: 18
  },
  AVAX: {
    key: "AVAX",
    symbol: "AVAX",
    nativeChain: "Avalanche",
    icon: TokenIcon.AVAX,
    coinGeckoId: "avalanche-2",
    color: "#E84141",
    decimals: 18,
    wrappedAsset: "WAVAX"
  },
  WAVAX: {
    key: "WAVAX",
    symbol: "WAVAX",
    nativeChain: "Avalanche",
    icon: TokenIcon.AVAX,
    tokenId: {
      chain: "Avalanche",
      address: "0xB31f66AA3C1e785363F0875A1B74E27b85FD66c7"
    },
    coinGeckoId: "avalanche-2",
    color: "#E84141",
    decimals: 18
  },
  USDCavax: {
    key: "USDCavax",
    symbol: "USDC",
    nativeChain: "Avalanche",
    icon: TokenIcon.USDC,
    tokenId: {
      chain: "Avalanche",
      address: "0xB97EF9Ef8734C71904D8002F8b6Bc66Dd9c48a6E"
    },
    coinGeckoId: "usd-coin",
    color: "#2774CA",
    decimals: 6
  },
  USDTavax: {
    key: "USDTavax",
    symbol: "USDT",
    nativeChain: "Avalanche",
    icon: TokenIcon.USDT,
    tokenId: {
      chain: "Avalanche",
      address: "0x9702230A8Ea53601f5cD2dc00fDBc13d4dF4A8c7"
    },
    coinGeckoId: "tether",
    color: "#ffffff",
    decimals: 6
  },
  WETHavax: {
    key: "WETHavax",
    symbol: "WETH",
    nativeChain: "Avalanche",
    icon: TokenIcon.ETH,
    tokenId: {
      chain: "Avalanche",
      address: "0x49D5c2BdFfac6CE2BFdB6640F4F80f226bc10bAB"
    },
    coinGeckoId: "ethereum",
    color: "#62688F",
    decimals: 18
  },
  FTM: {
    key: "FTM",
    symbol: "FTM",
    nativeChain: "Fantom",
    icon: TokenIcon.FANTOM,
    coinGeckoId: "fantom",
    color: "#12B4EC",
    decimals: 18,
    wrappedAsset: "WFTM"
  },
  WFTM: {
    key: "WFTM",
    symbol: "WFTM",
    nativeChain: "Fantom",
    icon: TokenIcon.FANTOM,
    tokenId: {
      chain: "Fantom",
      address: "0x21be370D5312f44cB42ce377BC9b8a0cEF1A4C83"
    },
    coinGeckoId: "fantom",
    color: "#12B4EC",
    decimals: 18
  },
  USDCfantom: {
    key: "USDCfantom",
    symbol: "USDC.e",
    nativeChain: "Fantom",
    icon: TokenIcon.USDC,
    tokenId: {
      chain: "Fantom",
      address: "0x2F733095B80A04b38b0D10cC884524a3d09b836a"
    },
    coinGeckoId: "usd-coin",
    color: "#2774CA",
    decimals: 6
  },
  CELO: {
    key: "CELO",
    symbol: "CELO",
    nativeChain: "Celo",
    icon: TokenIcon.CELO,
    tokenId: {
      chain: "Celo",
      address: "0x471EcE3750Da237f93B8E339c536989b8978a438"
    },
    coinGeckoId: "celo",
    color: "#35D07E",
    decimals: 18
  },
  USDTcelo: {
    key: "USDTcelo",
    symbol: "USDT",
    nativeChain: "Celo",
    icon: TokenIcon.USDT,
    tokenId: {
      chain: "Celo",
      address: "0x48065fbBE25f71C9282ddf5e1cD6D6A887483D5e"
    },
    coinGeckoId: "tether",
    color: "#ffffff",
    decimals: 6
  },
  GLMR: {
    key: "GLMR",
    symbol: "GLMR",
    nativeChain: "Moonbeam",
    icon: TokenIcon.GLMR,
    coinGeckoId: "moonbeam",
    color: "#e1147b",
    decimals: 18,
    wrappedAsset: "WGLMR"
  },
  WGLMR: {
    key: "WGLMR",
    symbol: "WGLMR",
    nativeChain: "Moonbeam",
    icon: TokenIcon.GLMR,
    tokenId: {
      chain: "Moonbeam",
      address: "0xAcc15dC74880C9944775448304B263D191c6077F"
    },
    coinGeckoId: "moonbeam",
    color: "#e1147b",
    decimals: 18
  },
  SOL: {
    key: "SOL",
    symbol: "SOL",
    nativeChain: "Solana",
    icon: TokenIcon.SOLANA,
    coinGeckoId: "solana",
    color: "#8457EF",
    decimals: 9,
    wrappedAsset: "WSOL"
  },
  WSOL: {
    key: "WSOL",
    symbol: "WSOL",
    nativeChain: "Solana",
    tokenId: {
      chain: "Solana",
      address: "So11111111111111111111111111111111111111112"
    },
    icon: TokenIcon.SOLANA,
    coinGeckoId: "solana",
    color: "#8457EF",
    decimals: 9
  },
  USDCsol: {
    key: "USDCsol",
    symbol: "USDC",
    nativeChain: "Solana",
    tokenId: {
      chain: "Solana",
      address: "EPjFWdd5AufqSSqeM2qN1xzybapC8G4wEGGkZwyTDt1v"
    },
    icon: TokenIcon.USDC,
    coinGeckoId: "usd-coin",
    color: "#2774CA",
    decimals: 6
  },
  USDTsol: {
    key: "USDTsol",
    symbol: "USDT",
    nativeChain: "Solana",
    icon: TokenIcon.USDT,
    tokenId: {
      chain: "Solana",
      address: "Es9vMFrzaCERmJfrF4H2FYD4KCoNkY11McCe8BenwNYB"
    },
    coinGeckoId: "tether",
    color: "#ffffff",
    decimals: 6
  },
  SUI: {
    key: "SUI",
    symbol: "SUI",
    nativeChain: "Sui",
    tokenId: { chain: "Sui", address: "0x2::sui::SUI" },
    icon: TokenIcon.SUI,
    coinGeckoId: "sui",
    color: "#8457EF",
    decimals: 9
  },
  USDCsui: {
    key: "USDCsui",
    symbol: "USDC",
    nativeChain: "Sui",
    tokenId: {
      chain: "Sui",
      address: "0xdba34672e30cb065b1f93e3ab55318768fd6fef66c15942c9f7cb846e2f900e7::usdc::USDC"
    },
    icon: TokenIcon.USDC,
    coinGeckoId: "usd-coin",
    color: "#2774CA",
    decimals: 6
  },
  APT: {
    key: "APT",
    symbol: "APT",
    nativeChain: "Aptos",
    tokenId: { chain: "Aptos", address: "0x1::aptos_coin::AptosCoin" },
    icon: TokenIcon.APT,
    coinGeckoId: "aptos",
    color: "#8457EF",
    decimals: 8
  },
  ETHarbitrum: {
    key: "ETHarbitrum",
    symbol: "ETH",
    nativeChain: "Arbitrum",
    icon: TokenIcon.ETH,
    coinGeckoId: "ethereum",
    color: "#5794EC",
    decimals: 18,
    wrappedAsset: "WETHarbitrum"
  },
  WETHarbitrum: {
    key: "WETHarbitrum",
    symbol: "WETH",
    nativeChain: "Arbitrum",
    icon: TokenIcon.ETH,
    tokenId: {
      chain: "Arbitrum",
      address: "0x82aF49447D8a07e3bd95BD0d56f35241523fBab1"
    },
    coinGeckoId: "ethereum",
    color: "#5794EC",
    decimals: 18
  },
  USDCarbitrum: {
    key: "USDCarbitrum",
    symbol: "USDC",
    nativeChain: "Arbitrum",
    icon: TokenIcon.USDC,
    tokenId: {
      chain: "Arbitrum",
      address: "0xaf88d065e77c8cC2239327C5EDb3A432268e5831"
    },
    coinGeckoId: "usd-coin",
    color: "#2774CA",
    decimals: 6
  },
  USDTarbitrum: {
    key: "USDTarbitrum",
    symbol: "USDT",
    nativeChain: "Arbitrum",
    icon: TokenIcon.USDT,
    tokenId: {
      chain: "Arbitrum",
      address: "0xFd086bC7CD5C481DCC9C85ebE478A1C0b69FCbb9"
    },
    coinGeckoId: "tether",
    color: "#ffffff",
    decimals: 6
  },
  ETHoptimism: {
    key: "ETHoptimism",
    symbol: "ETH",
    nativeChain: "Optimism",
    icon: TokenIcon.ETH,
    coinGeckoId: "ethereum",
    color: "#D53424",
    decimals: 18,
    wrappedAsset: "WETHoptimism"
  },
  WETHoptimism: {
    key: "WETHoptimism",
    symbol: "WETH",
    nativeChain: "Optimism",
    icon: TokenIcon.ETH,
    tokenId: {
      chain: "Optimism",
      address: "0x4200000000000000000000000000000000000006"
    },
    coinGeckoId: "ethereum",
    color: "#D53424",
    decimals: 18
  },
  USDCoptimism: {
    key: "USDCoptimism",
    symbol: "USDC",
    nativeChain: "Optimism",
    icon: TokenIcon.USDC,
    tokenId: {
      chain: "Optimism",
      address: "0x0b2C639c533813f4Aa9D7837CAf62653d097Ff85"
    },
    coinGeckoId: "usd-coin",
    color: "#2774CA",
    decimals: 6
  },
  USDToptimism: {
    key: "USDToptimism",
    symbol: "USDT",
    nativeChain: "Optimism",
    icon: TokenIcon.USDT,
    tokenId: {
      chain: "Optimism",
      address: "0x94b008aA00579c1307B0EF2c499aD98a8ce58e58"
    },
    coinGeckoId: "tether",
    color: "#ffffff",
    decimals: 6
  },
  WETHbsc: {
    key: "WETHbsc",
    symbol: "WETH",
    nativeChain: "Bsc",
    icon: TokenIcon.ETH,
    tokenId: {
      chain: "Bsc",
      address: "0x2170Ed0880ac9A755fd29B2688956BD959F933F8"
    },
    coinGeckoId: "ethereum",
    color: "#62688F",
    decimals: 18
  },
  USDTbsc: {
    key: "USDTbsc",
    symbol: "USDT",
    nativeChain: "Bsc",
    icon: TokenIcon.USDT,
    tokenId: {
      chain: "Bsc",
      address: "0x55d398326f99059fF775485246999027B3197955"
    },
    coinGeckoId: "tether",
    color: "#ffffff",
    decimals: 18
  },
  ETHbase: {
    key: "ETHbase",
    symbol: "ETH",
    nativeChain: "Base",
    icon: TokenIcon.ETH,
    coinGeckoId: "ethereum",
    color: "#62688F",
    decimals: 18,
    wrappedAsset: "WETHbase"
  },
  WETHbase: {
    key: "WETHbase",
    symbol: "WETH",
    nativeChain: "Base",
    icon: TokenIcon.ETH,
    tokenId: {
      chain: "Base",
      address: "0x4200000000000000000000000000000000000006"
    },
    coinGeckoId: "ethereum",
    color: "#62688F",
    decimals: 18
  },
  USDCbase: {
    key: "USDCbase",
    symbol: "USDC",
    nativeChain: "Base",
    icon: TokenIcon.USDC,
    tokenId: {
      chain: "Base",
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913"
    },
    coinGeckoId: "usd-coin",
    color: "#2774CA",
    decimals: 6
  },
  USDTbase: {
    key: "USDTbase",
    symbol: "USDT",
    nativeChain: "Base",
    icon: TokenIcon.USDT,
    tokenId: {
      chain: "Base",
      address: "0xfde4C96c8593536E31F229EA8f37b2ADa2699bb2"
    },
    coinGeckoId: "tether",
    color: "#ffffff",
    decimals: 6
  },
  wstETHbase: {
    key: "wstETHbase",
    symbol: "wstETH",
    nativeChain: "Base",
    tokenId: {
      chain: "Base",
      address: "0xc1CBa3fCea344f92D9239c08C0568f6F2F0ee452"
    },
    icon: TokenIcon.WSTETH,
    coinGeckoId: "wrapped-steth",
    color: "#3AA3FF",
    decimals: 18
  },
  wstETH: {
    key: "wstETH",
    symbol: "wstETH",
    nativeChain: "Ethereum",
    tokenId: {
      chain: "Ethereum",
      address: "0x7f39C581F595B53c5cb19bD0b3f8dA6c935E2Ca0"
    },
    icon: TokenIcon.WSTETH,
    coinGeckoId: "wrapped-steth",
    color: "#3AA3FF",
    decimals: 18
  },
  wstETHarbitrum: {
    key: "wstETHarbitrum",
    symbol: "wstETH",
    nativeChain: "Arbitrum",
    tokenId: {
      chain: "Arbitrum",
      address: "0x5979D7b546E38E414F7E9822514be443A4800529"
    },
    icon: TokenIcon.WSTETH,
    coinGeckoId: "wrapped-steth",
    color: "#3AA3FF",
    decimals: 18
  },
  wstETHoptimism: {
    key: "wstETHoptimism",
    symbol: "wstETH",
    nativeChain: "Optimism",
    tokenId: {
      chain: "Optimism",
      address: "0x1F32b1c2345538c0c6f582fCB022739c4A194Ebb"
    },
    icon: TokenIcon.WSTETH,
    coinGeckoId: "wrapped-steth",
    color: "#3AA3FF",
    decimals: 18
  },
  wstETHpolygon: {
    key: "wstETHpolygon",
    symbol: "wstETH",
    nativeChain: "Polygon",
    tokenId: {
      chain: "Polygon",
      address: "0x03b54A6e9a984069379fae1a4fC4dBAE93B3bCCD"
    },
    icon: TokenIcon.WSTETH,
    coinGeckoId: "wrapped-steth",
    color: "#3AA3FF",
    decimals: 18
  },
  KLAY: {
    key: "KLAY",
    symbol: "KLAY",
    decimals: 18,
    nativeChain: "Klaytn",
    icon: TokenIcon.KLAY,
    coinGeckoId: "klay-token",
    color: "#fa4212",
    wrappedAsset: "WKLAY"
  },
  WKLAY: {
    key: "WKLAY",
    symbol: "WKLAY",
    displayName: "wKLAY",
    nativeChain: "Klaytn",
    icon: TokenIcon.KLAY,
    tokenId: {
      chain: "Klaytn",
      address: "0xe4f05A66Ec68B54A58B17c22107b02e0232cC817"
    },
    coinGeckoId: "wrapped-klay",
    color: "#fa4212",
    decimals: 18
  },
  PYTH: {
    key: "PYTH",
    symbol: "PYTH",
    nativeChain: "Solana",
    tokenId: {
      chain: "Solana",
      address: "HZ1JovNiVvGrGNiiYvEozEVgZ58xaU3RKwX8eACQBCt3"
    },
    icon: TokenIcon.PYTH,
    coinGeckoId: "pyth-network",
    color: "#E6DAFE",
    decimals: 6
  },
  ETHscroll: {
    key: "ETHscroll",
    symbol: "ETH",
    nativeChain: "Scroll",
    icon: TokenIcon.SCROLL,
    coinGeckoId: "ethereum",
    decimals: 18,
    wrappedAsset: "WETHscroll"
  },
  WETHscroll: {
    key: "WETHscroll",
    symbol: "WETH",
    nativeChain: "Scroll",
    icon: TokenIcon.SCROLL,
    tokenId: {
      chain: "Scroll",
      address: "0x5300000000000000000000000000000000000004"
    },
    coinGeckoId: "ethereum",
    decimals: 18
  },
  ETHblast: {
    key: "ETHblast",
    symbol: "ETH",
    nativeChain: "Blast",
    icon: TokenIcon.BLAST,
    coinGeckoId: "ethereum",
    decimals: 18,
    wrappedAsset: "WETHblast"
  },
  WETHblast: {
    key: "WETHblast",
    symbol: "WETH",
    nativeChain: "Blast",
    icon: TokenIcon.BLAST,
    tokenId: {
      chain: "Blast",
      address: "0x9D020B1697035d9d54f115194c9e04a1e4Eb9aF7"
    },
    coinGeckoId: "ethereum",
    decimals: 18
  },
  OKB: {
    key: "OKB",
    symbol: "OKB",
    nativeChain: "Xlayer",
    icon: TokenIcon.XLAYER,
    coinGeckoId: "okb",
    decimals: 18,
    wrappedAsset: "WOKB"
  },
  WOKB: {
    key: "WOKB",
    symbol: "WOKB",
    nativeChain: "Xlayer",
    icon: TokenIcon.XLAYER,
    tokenId: {
      chain: "Xlayer",
      address: "0xe538905cf8410324e03A5A23C1c177a474D59b2b"
    },
    coinGeckoId: "okb",
    decimals: 18
  },
  MNT: {
    key: "MNT",
    symbol: "MNT",
    nativeChain: "Mantle",
    icon: TokenIcon.MANTLE,
    coinGeckoId: "mantle",
    decimals: 18,
    wrappedAsset: "WMNT"
  },
  WMNT: {
    key: "WMNT",
    symbol: "WMNT",
    nativeChain: "Mantle",
    icon: TokenIcon.MANTLE,
    tokenId: {
      chain: "Mantle",
      address: "0x78c1b0C915c4FAA5FffA6CAbf0219DA63d7f4cb8"
    },
    coinGeckoId: "mantle",
    decimals: 18
  },
  tBTC: {
    key: "tBTC",
    symbol: "tBTC",
    nativeChain: "Ethereum",
    tokenId: {
      chain: "Ethereum",
      address: "0x18084fbA666a33d37592fA2633fD49a74DD93a88"
    },
    icon: TokenIcon.TBTC,
    coinGeckoId: "tbtc",
    color: "#000000",
    decimals: 18
  },
  tBTCpolygon: {
    key: "tBTCpolygon",
    symbol: "tBTC",
    nativeChain: "Polygon",
    tokenId: {
      chain: "Polygon",
      address: "0x236aa50979D5f3De3Bd1Eeb40E81137F22ab794b"
    },
    icon: TokenIcon.TBTC,
    coinGeckoId: "tbtc",
    color: "#000000",
    decimals: 18
  },
  tBTCoptimism: {
    key: "tBTCoptimism",
    symbol: "tBTC",
    nativeChain: "Optimism",
    tokenId: {
      chain: "Optimism",
      address: "0x6c84a8f1c29108F47a79964b5Fe888D4f4D0dE40"
    },
    icon: TokenIcon.TBTC,
    coinGeckoId: "tbtc",
    color: "#000000",
    decimals: 18
  },
  tBTCarbitrum: {
    key: "tBTCarbitrum",
    symbol: "tBTC",
    nativeChain: "Arbitrum",
    tokenId: {
      chain: "Arbitrum",
      address: "0x6c84a8f1c29108F47a79964b5Fe888D4f4D0dE40"
    },
    icon: TokenIcon.TBTC,
    coinGeckoId: "tbtc",
    color: "#000000",
    decimals: 18
  },
  tBTCbase: {
    key: "tBTCbase",
    symbol: "tBTC",
    nativeChain: "Base",
    tokenId: {
      chain: "Base",
      address: "0x236aa50979D5f3De3Bd1Eeb40E81137F22ab794b"
    },
    icon: TokenIcon.TBTC,
    coinGeckoId: "tbtc",
    color: "#000000",
    decimals: 18
  },
  tBTCsol: {
    key: "tBTCsol",
    symbol: "tBTC",
    nativeChain: "Solana",
    tokenId: {
      chain: "Solana",
      address: "6DNSN2BJsaPFdFFc1zP37kkeNe4Usc1Sqkzr9C9vPWcU"
    },
    icon: TokenIcon.TBTC,
    coinGeckoId: "tbtc",
    color: "#000000",
    decimals: 8
  },
  ETHworldchain: {
    key: "ETHworldchain",
    symbol: "ETH",
    nativeChain: "Worldchain",
    icon: TokenIcon.WORLDCHAIN,
    coinGeckoId: "ethereum",
    decimals: 18,
    wrappedAsset: "WETHworldchain"
  },
  WETHworldchain: {
    key: "WETHworldchain",
    symbol: "WETH",
    nativeChain: "Worldchain",
    icon: TokenIcon.WORLDCHAIN,
    tokenId: {
      chain: "Worldchain",
      address: "0x4200000000000000000000000000000000000006"
    },
    coinGeckoId: "ethereum",
    decimals: 18
  }
}, MAINNET_WRAPPED_TOKENS = {
  WETH: {
    Bsc: "0x4DB5a66E937A9F4473fA95b1cAF1d1E1D62E29EA",
    Polygon: "0x11CD37bb86F65419713f30673A480EA33c826872",
    Avalanche: "0x8b82A291F83ca07Af22120ABa21632088fC92931",
    Fantom: "0x2A126f043BDEBe5A0A9841c51915E562D9B07289",
    Celo: "0x66803FB87aBd4aaC3cbB3fAd7C3aa01f6F3FB207",
    Moonbeam: "0xab3f0245B83feB11d15AAffeFD7AD465a59817eD",
    Solana: "7vfCXTUXx5WJV5JADk17DUJ4ksgau7utNKj4b963voxs",
    Sui: "0xaf8cd5edc19c4512f4259f0bee101a40d41ebed738ade5874359610ef8eeced5::coin::COIN",
    Aptos: "0xcc8a89c8dce9693d354449f1f73e60e14e347417854f029db5bc8e7454008abb::coin::T",
    Base: "0x71b35ECb35104773537f849FBC353F81303A5860",
    Arbitrum: "0xD8369C2EDA18dD6518eABb1F85BD60606dEb39Ec",
    Optimism: "0xb47bC3ed6D70F04fe759b2529c9bc7377889678f",
    Blast: "0xC09a79fCF76ab2917c685896E3693e04EEbab69C",
    Mantle: "0x115Fcc627AcE0457fbeb7Af3b8BcAcE7Ff6211A4",
    Klaytn: "0x98A8345bB9D3DDa9D808Ca1c9142a28F6b0430E1",
    Worldchain: "0x6938c3EfFEf84E5C69e3d7cc41eBC6Cff99EF8A7"
  },
  USDCeth: {
    Bsc: "0xB04906e95AB5D797aDA81508115611fee694c2b3",
    Polygon: "0x4318CB63A2b8edf2De971E2F17F77097e499459D",
    Avalanche: "0xB24CA28D4e2742907115fECda335b40dbda07a4C",
    Fantom: "0x2Ec752329c3EB419136ca5e4432Aa2CDb1eA23e6",
    Celo: "0x37f750B7cC259A2f741AF45294f6a16572CF5cAd",
    Moonbeam: "0x931715FEE2d06333043d11F658C8CE934aC61D0c",
    Solana: "A9mUU4qviSctJVPJdBJWkb28deg915LYJKrzQ19ji3FM",
    Sui: "0x5d4b302506645c37ff133b98c4b50a5ae14841659738d6d733d59d0d217a93bf::coin::COIN",
    Aptos: "0x5e156f1207d0ebfa19a9eeff00d62a282278fb8719f4fab3a586a0a2c0fffbea::coin::T",
    Base: "0xec267C53f53807c2337C257f8AC3Fc3cC07cc0ed",
    Arbitrum: "0xC96F2715E2a242d50D1b0bC923dbe1740b8eCf18",
    Optimism: "0x711e53D031ea9B0bb0C24dD506df11b41AEA419e",
    Klaytn: "0x608792Deb376CCE1c9FA4D0E6B7b44f507CfFa6A",
    Worldchain: "0x2cbD3491d687A76bb9C53c30B212855520D47b52"
  },
  WBTC: {
    Bsc: "0x43359676E1A3F9FbB5de095333f8e9c1B46dFA44",
    Polygon: "0x5D49c278340655B56609FdF8976eb0612aF3a0C3",
    Avalanche: "0x1C0e79C5292c59bbC13C9F9f209D204cf4d65aD6",
    Fantom: "0x87e9E225aD8a0755B9958fd95BE43DD6A91FF3A7",
    Celo: "0xd71Ffd0940c920786eC4DbB5A12306669b5b81EF",
    Moonbeam: "0xE57eBd2d67B462E9926e04a8e33f01cD0D64346D",
    Solana: "3NZ9JMVBmGAqocybic2c7LQCJScmgsAZ6vQqTDzcqmJh",
    Sui: "0x027792d9fed7f9844eb4839566001bb6f6cb4804f66aa2da6fe1ee242d896881::coin::COIN",
    Aptos: "0xae478ff7d83ed072dbc5e264250e67ef58f57c99d89b447efd8a0a2e8b2be76e::coin::T",
    Base: "0xE6396f780b543dF16ee3b784D789c75B68319db0",
    Arbitrum: "0x397846a8078d4845c7f5c6Ca76aeBbcFDc044fAe",
    Optimism: "0xB214C19d81c99E75e84706a3aa0A757319023e26",
    Klaytn: "0x981846bE8d2d697f4dfeF6689a161A25FfbAb8F9",
    Worldchain: "0x06c9ec7E18A7900E79Ad5BeCc6Cc29E3eebD81EC"
  },
  USDT: {
    Bsc: "0x524bC91Dc82d6b90EF29F76A3ECAaBAffFD490Bc",
    Polygon: "0x9417669fBF23357D2774e9D421307bd5eA1006d2",
    Avalanche: "0x9d228444FC4B7E15A2C481b48E10247A03351FD8",
    Fantom: "0x14BCb86aEed6a74D3452550a25D37f1c30AA0A66",
    Celo: "0x617f3112bf5397D0467D315cC709EF968D9ba546",
    Moonbeam: "0xc30E9cA94CF52f3Bf5692aaCF81353a27052c46f",
    Solana: "Dn4noZ5jgGfkntzcQSUZ8czkreiZ1ForXYoV2H8Dm7S1",
    Sui: "0xc060006111016b8a020ad5b33834984a437aaa7d3c74c18e09a95d48aceab08c::coin::COIN",
    Aptos: "0xa2eda21a58856fda86451436513b867c97eecb4ba099da5775520e0f7492e852::coin::T",
    Base: "0xFf0C62A4979400841eFaA6faADb07Ac7d5C98b27",
    Arbitrum: "0xE4728F3E48E94C6DA2B53610E677cc241DAFB134",
    Optimism: "0xf6B4185FCf8aF291c0E3927fbEab7046b4f6A8CA",
    Blast: "0x37C1dea9C51864cc6640FA9c09f4dac574b8285E",
    Klaytn: "0x5C13E303a62Fc5DEdf5B52D66873f2E59fEdADC2",
    Xlayer: "0x5866709f926f26C5870191F40333ac462B917bC0",
    Worldchain: "0x95dd0680Fd6B6c7546e75C1A4E6A3256072C0593"
  },
  DAI: {
    Bsc: "0x3413a030EF81a3dD5a302F4B4D11d911e12ed337",
    Polygon: "0x732EB1747ecCFC431fF19bc359ffc83755B1918c",
    Avalanche: "0xca319f81D147559e19A522A0a0310Dd43A96cA0F",
    Fantom: "0xEE786D3D73Ea645365c7248E4e40eDba08B1169F",
    Celo: "0x97926a82930bb7B33178E3c2f4ED1BFDc91A9FBF",
    Moonbeam: "0x06e605775296e851FF43b4dAa541Bb0984E9D6fD",
    Solana: "EjmyN6qEC1Tf1JxiG1ae7UTJhUxSwk1TCWNWqxWV4J6o",
    Aptos: "0x407a220699982ebb514568d007938d2447d33667e4418372ffec1ddb24491b6c::coin::T",
    Base: "0x617Edadb51BfB43A44Bb91C7402129C23bA52381",
    Arbitrum: "0x5c4f2FEFB97F7DF09E762d95C83f0Ccf8bCe8234",
    Optimism: "0x098EA47D630b46df1E08e389e5e4466119c7dd30",
    Blast: "0x286ebE2BacB0EBeF746DBDA24dED0fc001c6d0F6",
    Sui: "0xc01c54cd767a60835bf100b0a8f7aae66ac9f4e374f76746af60f02493b6f2cf::coin::COIN",
    Klaytn: "0xCB2C7998696Ef7a582dFD0aAFadCd008D03E791A",
    Worldchain: "0x69635e59E89000e08a13C3F7B9f7293160Dc83a2"
  },
  BUSD: {
    Bsc: "0x035de3679E692C471072d1A09bEb9298fBB2BD31",
    Polygon: "0x95ea750420da26bE1Ab0891e209e921bCd84763f",
    Celo: "0x1dd42c0785ca90B677adc2ABad01dfc5ECcD0b4d",
    Moonbeam: "0xa2284e1F98E4d0B7Eb6a6b4f3C57f1b209C755F3",
    Solana: "33fsBLA8djQm82RpHmE3SuVrPGtZBWNYExsEUeKX1HXX",
    Aptos: "0x77400d2f56a01bad2d7c8c6fa282f62647ce3c03f43f2a8742e47ea01a91e24a::coin::T",
    Worldchain: "0x276719Fc6a38E62B717c6FF6E39d1C336ee633AB"
  },
  WPOL: {
    Ethereum: "0x7c9f4C87d911613Fe9ca58b579f737911AAD2D43",
    Bsc: "0xc836d8dC361E44DbE64c4862D55BA041F88Ddd39",
    Avalanche: "0xf2f13f0B7008ab2FA4A2418F4ccC3684E49D20Eb",
    Fantom: "0xb88A6064B1F3FF5B9AE4A82fFD52560b0dF9FBD3",
    Celo: "0x9C234706292b1144133ED509ccc5B3CD193BF712",
    Moonbeam: "0x82DbDa803bb52434B1f4F41A6F0Acb1242A7dFa3",
    Solana: "Gz7VkD4MacbEB6yC5XD3HcumEiYx2EtDYYrfikGsvopG",
    Sui: "0xdbe380b13a6d0f5cdedd58de8f04625263f113b3f9db32b3e1983f49e2841676::coin::COIN",
    Aptos: "0x6781088e2a1629d38eda521467af4a8ca7bfa7e5516338017940389595c85c0f::coin::T",
    Base: "0xc863399E5c5C4011B1DC3fB602902C77BA72B709",
    Arbitrum: "0x3ab0E28C3F56616aD7061b4db38aE337E3809AEA",
    Optimism: "0x8f02B6a32cebcAe44D2Fd17d87966f5B5dD14c6d",
    Blast: "0xE00CB9206aCF0413aa9Dc12F01A22BB5Dd7A2866",
    Mantle: "0x1d15Dc3B3DB5A182eA8E3091F21EB0549d4a72E0",
    Klaytn: "0x9858e5A4f8202baD619D4BD39382CA67F4CA0E63",
    Scroll: "0x982D057feCD66c3af27b16EBC67C4db24810bcD8",
    Xlayer: "0xc97E2b2d7730C34adC389563721d9dF52EDA4A2a",
    Worldchain: "0xDcB507ECEA06724d8c4F2f03964f7EE4da504E8C"
  },
  WETHpolygon: {
    Bsc: "0x1384284E16e3375522Be54F50909Bc52A69e90e4",
    Solana: "DQyeU3oFezEGia761GQ4iPcMCnxnH8fuLrmHZUvTYuby",
    Aptos: "0x2692323828f627a45a75a05eba8281dd46690c538b4f6ccb7a35ffe8199a28b7::coin::T",
    Sui: "0xa1ed6e76b06ff8f959cc479fbbd423820a3349dad8707b98ff4309c677fa20ad::coin::COIN",
    Arbitrum: "0xd2b299eD76d1369Ac8762CFEc85245fFD302FC17",
    Ethereum: "0x32d222E1f6386B3dF7065d639870bE0ef76D3599",
    Avalanche: "0x061FE51530768889dc20Ac7fCD29b5307b823395",
    Optimism: "0x2740220fFa4b206280907ce12b7cDC57445f3B92",
    Fantom: "0x1cAFd8d3301E4E54Fc1462E7117Eb678bF50C765",
    Base: "0x7A79923734eDA9c7f7ff69ad9ec1e234F67E7CD6",
    Moonbeam: "0xf1BB9A987B9edC360580b0c9F28069C808c2a7da",
    Celo: "0x8Ed68859f162970258992168293232e3Bdd987d0",
    Klaytn: "0x3eb25C7098AC38a852Cd2366161c5e216af50Df3"
  },
  USDCpolygon: {
    Aptos: "0xc5fd7820e9f053e6dd8e7dd8ca3ce8e9b10d200ba1692bdeb7a035217180ad4a::coin::T",
    Base: "0xFe1579BAc60363c8572CB30Bf4DD1Fd85811BBF8",
    Moonbeam: "0x4415BfBDee669446550d55c749007EF60B520FC8",
    Sui: "0x5c8c9082401982e8c2519a5c12883a5475295bf5cec4a0a13c26d35dd9a20d73::coin::COIN",
    Bsc: "0xe6d82Bbe75041E42E51d755e922cE1BA91af9c4d",
    Celo: "0x42c76808f3179A091Ee007A2955aF2522978ADE7",
    Fantom: "0xB4DcfD221048a1Dad989D39456BBd87762c26F06",
    Avalanche: "0xDb2d08f5A9C9ADBBA0DE5a69bbB1E9Ca03411692",
    Arbitrum: "0x599ADB10E6A012dF34935D47407450f6D7170e3C",
    Optimism: "0xbB1EaB9Eb8fDf65F0E291D013DA07B4b65a27a01",
    Solana: "C321jHPwWBzgfSGndosDTp5pBsiXPyMU1irxKLVcedRB",
    Ethereum: "0xFbcE0f9e92AD1003e893Ba647bC055D845aAa507",
    Klaytn: "0x59AEaD999e018a00B162D34de7a81AFFAB88bAbB"
  },
  WBNB: {
    Ethereum: "0x418D75f65a02b3D53B2418FB8E1fe493759c7605",
    Polygon: "0xeCDCB5B88F8e3C15f95c720C51c71c9E2080525d",
    Avalanche: "0x442F7f22b1EE2c842bEAFf52880d4573E9201158",
    Fantom: "0xc033551e05907Ddd643AE14b6D4a9CA72BfF509B",
    Celo: "0xBf2554ce8A4D1351AFeB1aC3E5545AaF7591042d",
    Moonbeam: "0xE3b841C3f96e647E6dc01b468d6D0AD3562a9eeb",
    Solana: "9gP2kCy3wA1ctvYWQk75guqXuHfrEomqydHLtcTCqiLa",
    Sui: "0xb848cce11ef3a8f62eccea6eb5b35a12c4c2b1ee1af7755d02d7bd6218e8226f::coin::COIN",
    Aptos: "0x6312bc0a484bc4e37013befc9949df2d7c8a78e01c6fe14a34018449d136ba86::coin::T",
    Base: "0x7fdAa50d7399ac436943028edA6ed9a1BD89509f",
    Arbitrum: "0x7AF00405916D823eDb1121546EfA6F4972B51b84",
    Optimism: "0x6A09fE65ACa27C12573F04aAFa290bD75497E1BC",
    Blast: "0xdcd0Ec817d3ae2E82bCE8Cc9f92fFA7686A52160",
    Mantle: "0x9a7E85260d6F5d3c3d2a1FdDc3D980DBC78e508d",
    Klaytn: "0xaC9C1E4787139aF4c751B1C0fadfb513C44Ed833",
    Scroll: "0x5b0da0a36DC415714B53A4f24b56921332F42E7C",
    Xlayer: "0x8bC46166E06122603bA10D2bCA63b75091c25cAe",
    Worldchain: "0x59163d9c70E9b3852a504c5F1458e2daD33516Ff"
  },
  USDCbnb: {
    Ethereum: "0x7cd167B101D2808Cfd2C45d17b2E7EA9F46b74B6",
    Polygon: "0x4B3a922c773BDCF3BA8f1A4FDAc2029E1D0E9868",
    Avalanche: "0x6145E8a910aE937913426BF32De2b26039728ACF",
    Fantom: "0x0FcbDAC44c67A43607D3E95886dB19871ADc985F",
    Celo: "0x9d9abAE97a9344e3854527b4efbB366a1564bfEb",
    Moonbeam: "0x7f433E22366E03a3758CE22cCf82887d828078f8",
    Solana: "FCqfQSujuPxy6V42UvafBhsysWtEq1vhjfMN1PUbgaxA",
    Sui: "0x909cba62ce96d54de25bec9502de5ca7b4f28901747bbf96b76c2e63ec5f1cba::coin::COIN",
    Aptos: "0x79a6ed7a0607fdad2d18d67d1a0e552d4b09ebce5951f1e5c851732c02437595::coin::T",
    Base: "0x68E2b07F92ed506f92935d7359ECA84D5342dbb4",
    Arbitrum: "0x1a0590F951bc9C3818Ce75ba5Bbe92831b2cf57e",
    Optimism: "0x1C15057d1F3794C934a6cBC1f7EceE934050F219",
    Klaytn: "0x01B342d26FEF5749E87CBe412e16163771b0277c"
  },
  WAVAX: {
    Ethereum: "0x85f138bfEE4ef8e540890CFb48F620571d67Eda3",
    Bsc: "0x96412902aa9aFf61E13f085e70D3152C6ef2a817",
    Polygon: "0x7Bb11E7f8b10E9e571E5d8Eace04735fDFB2358a",
    Fantom: "0x358CE030DC6116Cc296E8B9F002728e65459C146",
    Celo: "0xFFdb274b4909fC2efE26C8e4Ddc9fe91963cAA4d",
    Moonbeam: "0xd4937A95BeC789CC1AE1640714C61c160279B22F",
    Solana: "KgV1GvrHQmRBY8sHQQeUKwTm2r2h8t4C8qt12Cw1HVE",
    Sui: "0x1e8b532cca6569cab9f9b9ebc73f8c13885012ade714729aa3b450e0339ac766::coin::COIN",
    Aptos: "0x5b1bbc25524d41b17a95dac402cf2f584f56400bf5cc06b53c36b331b1ec6e8f::coin::T",
    Base: "0xc449A60A31E1eebFE83c42E9465fd4Dc318aE9a7",
    Arbitrum: "0x565609fAF65B92F7be02468acF86f8979423e514",
    Optimism: "0x8418C1d909842f458c9394886b83F19d62bF1A0D",
    Blast: "0x7D86F00026c2cD8137D60ae85d53c5E5a15B2481",
    Mantle: "0x2cAb4233d42043AEBbbb1445af362Ef686f3C133",
    Klaytn: "0x45830b92443a8f750247da2A76C85c70d0f1EBF3",
    Scroll: "0xC043c8A3672f397e7b52bF0a04F47d6f1aA952Ed",
    Xlayer: "0x5208Fb676B2DBab7aFaFB56e8997237F0ceECF71",
    Worldchain: "0x5Bf2A0622aa1254D963A3074b593A379784C116a"
  },
  USDCavax: {
    Ethereum: "0x39EbF69137D98FB7659Ef8D4ea21ec26394389d7",
    Bsc: "0xc88Dc63bf0c8c8198C97Db0945E3eF25Ca89A8e4",
    Polygon: "0xAEA5CC14DefbC1b845FDE729E563B717Ee6825ae",
    Fantom: "0xEfE7701cb2B80664385Be226d0300912CA92f66A",
    Celo: "0x62FFf2D2D1692D52eAf043AeeC727F7918d269D3",
    Moonbeam: "0xd4918c40cA9f02d42Cb53d06587aF42017Bc345D",
    Solana: "FHfba3ov5P3RjaiLVgh8FTv4oirxQDoVXuoUUDvHuXax",
    Sui: "0xe596782fbaebef51ae99ffac8731aed98a80642b9dc193ed659c97fbc2cc0f84::coin::COIN",
    Aptos: "0x39d84c2af3b0c9895b45d4da098049e382c451ba63bec0ce0396ff7af4bb5dff::coin::T",
    Arbitrum: "0x93e0FcbEd43CD6fC30DF00CcBD4669718dc74e77",
    Optimism: "0x355f0a8a7ecAeD971b8Fbd50994558291ff2413a",
    Base: "0xD83385fE100E20c269a5975D4Bf92525BcE09F87",
    Blast: "0x3Db095413b5e1e5681c48028e31e8dc2505D8aD3",
    Klaytn: "0x9C97D4c09679Dfd00A39681f6d3b61A285312B13",
    Scroll: "0xbEFc3d0457fB88f82364Dd982F7BA195FEE96b74"
  },
  WETHavax: {
    Aptos: "0x25ff8e0c07552c392c9e5dd4c9c07cf0382765c1bca560e80b6296a702034219::coin::T",
    Solana: "F9B9qLwUN3TAWGV9EGsuzFzS2PxWvKAmLhvfeqYNaS7J",
    Bsc: "0xBDfe278268524de38Da89B3023C1F49deBDFdA8A",
    Sui: "0xc1ea686a329e35808c61484d95904d50522f1d1616cab4b416d9cfa9b274bc6c::coin::COIN",
    Base: "0xEfe64b52bc0bDfa109790736F25cefb79724adF0",
    Arbitrum: "0xdF64fB41b7f45304a786695E0D5daD8d033C01eF",
    Polygon: "0x2912b3a9586Fc2AB177dC869e878c688DAA7d06E",
    Ethereum: "0xD85a87Edbe9fB3Baf6a1Bbd1E46f1C04B291331d",
    Optimism: "0xBe6EA3e70e2bbB0dbD093B657fbbc0DFF0BA67eC",
    Moonbeam: "0x9C673c6b651D6FDEF57441125A6AC16b08bba939",
    Celo: "0xDac2C97b5E64d7C79d040cd2906EBe02341F1Ab5",
    Klaytn: "0x9971F9d9170D787C4e4E01c56E1BDB308291CacF",
    Fantom: "0x86a09597fc91b116511B990D29CB46ddedC0fCb0"
  },
  WFTM: {
    Ethereum: "0x4cD2690d86284e044cb63E60F1EB218a825a7e92",
    Bsc: "0xbF8413EE8612E0E4f66Aa63B5ebE27f3C5883d47",
    Polygon: "0x3726831304D77f585f1Aca9d9841cc3Ef80dAa62",
    Avalanche: "0xd19abc09B7b36F7558929b97a866f499a26c2f83",
    Celo: "0xd1A342eE2210238233a347FEd61EE7Faf9f251ce",
    Moonbeam: "0x609AedD990bf45926bca9E4eE988b4Fb98587D3A",
    Solana: "DRQBDBEWmwWGK13fRTLhSPzjbvMSUavhV6nW4RUH8W6T",
    Sui: "0x6081300950a4f1e2081580e919c210436a1bed49080502834950d31ee55a2396::coin::COIN",
    Aptos: "0xd1aa2ff36a0e93e1b4e4fecdecf8bb95bc5de399061c5e84b515281f48718842::coin::T",
    Base: "0x936Fa2DE8380Dc5BF34C80F1BaD53a9f3630263B",
    Arbitrum: "0x7f7dcDb91930033a4Eb269196EBb6fd5f0644E4B",
    Optimism: "0x0b0ecbe5C3995541876d27633B63296570FB34Af",
    Blast: "0xf1D0eEeB6B6B35dc7289E1AD5e523F68b82bd09A",
    Mantle: "0x6BFDc59ECBC5503aE16F71851064597D0a75dA76",
    Klaytn: "0xF3AebeA789F30C22F3657F70f4CaA0f8b49ed676",
    Scroll: "0x16f077e2e9bF99Adfb1FEEc8360ee002842C44A2",
    Xlayer: "0x956b5E88c311b976C76CB415C7E030A5Af87373b"
  },
  USDCfantom: {
    Bsc: "0x521af8b1c43B503BE91F542d82EEFEabc0C93340",
    Arbitrum: "0xF68734163731ad6A6108f76A8e09862C1d412B42",
    Ethereum: "0xfcC349c14013EdeFAAcAE09Ba30F4ef2571b8D2c"
  },
  CELO: {
    Ethereum: "0x3294395e62F4eB6aF3f1Fcf89f5602D90Fb3Ef69",
    Bsc: "0x2A335e327a55b177f5B40132fEC5D7298aa0D7e6",
    Polygon: "0x922F49a9911effc034eE756196E59BE7b90D43b3",
    Avalanche: "0x494317B8521c5a5287a06DEE467dd6fe285dA4a8",
    Fantom: "0xF432490C6c96C9d3bF523a499a1CEaFd8208A373",
    Moonbeam: "0xc1a792041985F65c17Eb65E66E254DC879CF380b",
    Solana: "9kvAcwQbqejuJMd59mKuw2bfSsLRaQ7zuvaTVHEeBBec",
    Sui: "0xa198f3be41cda8c07b3bf3fee02263526e535d682499806979a111e88a5a8d0f::coin::COIN",
    Aptos: "0xac0c3c35d50f6ef00e3b4db6998732fe9ed6331384925fe8ec95fcd7745a9112::coin::T",
    Base: "0x74df3823aA29D278cAD0A3632fCB56C896a38eD4",
    Arbitrum: "0x4E51aC49bC5e2d87e0EF713E9e5AB2D71EF4F336",
    Optimism: "0x9b88D293b7a791E40d36A39765FFd5A1B9b5c349",
    Blast: "0x75345Cc6a3333cca03aCE2a28C7de328122Db3b1",
    Klaytn: "0xB2b5bC9bc872c7107CBC8E8e0E2805Db0ac4FBc2",
    Worldchain: "0x2250A0E2532A745b585B69dd2CdC75207384917c"
  },
  WGLMR: {
    Ethereum: "0x93d3696A9F879b331f40CB5059e37015423A3Bd0",
    Bsc: "0x1C063db3c621BF901FC6C1D03328b08b2F9bbfba",
    Polygon: "0xcC48d6CF842083fEc0E01d913fB964b585975F05",
    Avalanche: "0x375aA6C67BF499fBf01804A9f92C03c0776F372d",
    Fantom: "0xBF227E92D6754EB4BFE26C40cb299ff2809Da45f",
    Celo: "0x383A5513AbE4Fe36e0E00d484F710148E348Aa9D",
    Solana: "7ixSaXGsHAFy34wogPk2YXiUX3BMmQMFdercdaHLnBby",
    Sui: "0x66f87084e49c38f76502d17f87d17f943f183bb94117561eb573e075fdc5ff75::coin::COIN",
    Aptos: "0x7ab1283a7b13c4254d4e1f803d7ce6578442c1d7a40d0faee41cd48ba4884c8a::coin::T",
    Base: "0xfdB7311BeC3b2CcCF8407d0585f81B97b3b5eff1",
    Arbitrum: "0x944C5b67a03e6Cb93Ae1E4B70081f13b04CDB6Bd",
    Optimism: "0xbffD46DFDb8d3a02b8D2E0F864a2cD712090a4D3",
    Blast: "0x43E43580A34c8FdD4694e1F9B5F9b1121a7044a5",
    Klaytn: "0x52a4558f98dDc7cb40cd9114C005f0B9571258Fc",
    Scroll: "0x2Aba1Ed24EaFC17F801b1A7dF1c3a06737F8aB72",
    Xlayer: "0xE2a44Dad57004517738FbD84cdf09Bd1451b4e43",
    Worldchain: "0xaAe2Bd4EB640f02dD3a53bd994ad19110b4191b0"
  },
  WSOL: {
    Ethereum: "0xD31a59c85aE9D8edEFeC411D448f90841571b89c",
    Bsc: "0xfA54fF1a158B5189Ebba6ae130CEd6bbd3aEA76e",
    Polygon: "0xd93f7E271cB87c23AaA73edC008A79646d1F9912",
    Avalanche: "0xFE6B19286885a4F7F55AdAD09C3Cd1f906D2478F",
    Fantom: "0xd99021C2A33e4Cf243010539c9e9b7c52E0236c1",
    Celo: "0x4581E64115d46CcdeE65Be2336bEc86c9BA54C01",
    Moonbeam: "0x99Fec54a5Ad36D50A4Bba3a41CAB983a5BB86A7d",
    Sui: "0xb7844e289a8410e50fb3ca48d69eb9cf29e27d223ef90353fe1bd8e27ff8f3f8::coin::COIN",
    Aptos: "0xdd89c0e695df0692205912fb69fc290418bed0dbe6e4573d744a6d5e6bab6c13::coin::T",
    Base: "0x1C61629598e4a901136a81BC138E5828dc150d67",
    Arbitrum: "0x2bcC6D6CdBbDC0a4071e48bb3B969b06B3330c07",
    Optimism: "0xba1Cf949c382A32a09A17B2AdF3587fc7fA664f1",
    Blast: "0xA5370b8e2413b23eA16F3B78D1d1ba3969678227",
    Mantle: "0xDA03239f428c76A527e1ceCa0ecA6cC367A2D945",
    Klaytn: "0xfAA03A2AC2d1B8481Ec3fF44A0152eA818340e6d",
    Xlayer: "0x3a859D92da2E16Ad32C5C6F3ADAddFBa4dE3A47e",
    Scroll: "0xCDf95E1F720caade4b1DC83ABfE15400D2a458AD",
    Worldchain: "0xEfae32D1c15EDBaEA3ebdDe1e2C51003AED04d30"
  },
  USDCsol: {
    Ethereum: "0x41f7B8b9b897276b7AAE926a9016935280b44E97",
    Bsc: "0x91Ca579B0D47E5cfD5D0862c21D5659d39C8eCf0",
    Polygon: "0x576Cf361711cd940CD9C397BB98C4C896cBd38De",
    Avalanche: "0x0950Fc1AD509358dAeaD5eB8020a3c7d8b43b9DA",
    Fantom: "0xb8398DA4FB3BC4306B9D9d9d13d9573e7d0E299f",
    Celo: "0x8B6eef6C449D3Ac723a9C06a9eaE2dCd7d308BA9",
    Moonbeam: "0x098d6eE48341D6a0a0A72dE5baaF80A10E0F6082",
    Sui: "0xb231fcda8bbddb31f2ef02e6161444aec64a514e2c89279584ac9806ce9cf037::coin::COIN",
    Aptos: "0xc91d826e29a3183eb3b6f6aa3a722089fdffb8e9642b94c5fcd4c48d035c0080::coin::T",
    Arbitrum: "0x3870546cfd600ba87e4180686d29dC993A45d3B7",
    Optimism: "0x6F974A6dfD5B166731704Be226795901c45Bb815",
    Base: "0xe8CE40EBBB844142400D21558a2F1c9683d69139",
    Klaytn: "0xa1a7feeD29EbFa38079D943486c23f401939Ce80",
    Scroll: "0x883Ccb5aEfD0084f1e4D04b133675acd6D5F123F"
  },
  SUI: {
    Ethereum: "0x84074EA631dEc7a4edcD5303d164D5dEa4c653D6",
    Bsc: "0x8314f6Bf1B4dd8604A0fC33C84F9AF2fc07AABC8",
    Polygon: "0x34bE049fEbfc6C64Ffd82Da08a8931A9a45f2cc8",
    Avalanche: "0x1703CB0F762D2a435199B64Ea47E5349B7C17480",
    Fantom: "0xC277423a21F6e32D886BF85Ef6cCB945d5D28347",
    Celo: "0x1Cb9859B1A16A67ef83A0c7b9A21eeC17d9a97Dc",
    Moonbeam: "0x484eCCE6775143D3335Ed2C7bCB22151C53B9F49",
    Solana: "G1vJEgzepqhnVu35BN4jrkv3wVwkujYWFFCxhbEZ1CZr",
    Aptos: "0xa72a97e872be9ee3d2f14d56fd511eb7e4a53f4055be3a267d8602e7685b41c0::coin::T",
    Base: "0x36c6FBF7B49bF65f5F82b674af219C05b2a4aDD1",
    Arbitrum: "0xCF79d86B8a830030aF6D835737d6eac3bE823fD7",
    Optimism: "0x27A533e438892DA192725b4C9AcA51447F457212",
    Mantle: "0x9ef1BB6072d7d6B9C935d9c040133036aD532119",
    Blast: "0x62c95Ffd6d2f893Ea2EF072d1EbBcb242a974b1A",
    Klaytn: "0xB0B40516293e0204fB376A18aA230A210cbE0305",
    Xlayer: "0xEa76dBFE6e449420f294e74E057518F750E99A16",
    Worldchain: "0xf69005c35B5d9AcC22E4DbCf52f892cAE21F83B0"
  },
  APT: {
    Ethereum: "0x8CDf7AF57E4c8B930e1B23c477c22f076530585e",
    Bsc: "0x2Ba98cf7Edd2c5C794e21bc3Dc6973D3C2585eE3",
    Polygon: "0xa4ef199d3ad524E9C3C51Ac46B303B103A307Cef",
    Avalanche: "0x43c588459b3243fA541B98CC4B2E995b3de553A2",
    Fantom: "0x3Cd9162Ca5256b8E26A0e3Ad14CCfF7C0Da0F174",
    Celo: "0x89F2b718Ca518db39d377F0ABBa6B42582b549F7",
    Moonbeam: "0x25331575641d35D9765e1934acC8F0991c58e904",
    Solana: "6LNeTYMqtNm1pBFN8PfhQaoLyegAH8GD32WmHU9erXKN",
    Sui: "0x3a5143bb1196e3bcdfab6203d1683ae29edd26294fc8bfeafe4aaa9d2704df37::coin::COIN",
    Base: "0x1d36126289Be1658297A35CC3EB2BB80A7D7A04b",
    Arbitrum: "0x4EdeF400eDe5309240814b5FC403F224504604e9",
    Optimism: "0xC5B3AC2DF8D8D7AC851F763a5b3Ff23B4A696d59",
    Blast: "0x2a3DdE20159FbDbC86f1da0e7a462711b610c815",
    Klaytn: "0x68d5254007BE3a6d3d2A37e2C1ad3921D049F46D",
    Xlayer: "0xEdF2AEaCE382A3c0722f110c4927d34b78bce34F",
    Worldchain: "0xfC5011f2037f2Dad9c9aC05CbB6749B383C3099c"
  },
  WETHarbitrum: {
    Ethereum: "0xb945E3F853B5f8033C8513Cf3cE9F8AD9beBB1c9",
    Bsc: "0xaA1eEdABC48D078350ccBdD620bD088848e299E5",
    Polygon: "0x6a5c59AB16268d2c872916054C50440B999e417C",
    Avalanche: "0xDfDA518A1612030536bD77Fd67eAcbe90dDC52Ab",
    Fantom: "0xE8367853A0823515D37b1538331B4704089becb4",
    Celo: "0xc6F962fCcb140ece554AfD0E589f971532A57f14",
    Solana: "CSD6JQMvLi46psjHdpfFdr826mF336pEVMJgjwcoS1m4",
    Sui: "0x33744e7df340a4d01c23f6b18c13563f767545ea95f976f8045f056358419da3::coin::COIN",
    Aptos: "0xe977796d7bfb3263609b90dffd264c7bd078ce35dac42b55302858d9fa3452b::coin::T",
    Base: "0x9D36e0edb8BBaBeec5edE8a218dc2B9a6Fce494F",
    Optimism: "0x825206E1D29456337769e6f1384101E997C6A732",
    Moonbeam: "0x18872b45c603eD2EbC508b9C5514a85c2e2791FB",
    Klaytn: "0x3CF1751E32c4225CB12ba953786C260C2cE89008"
  },
  USDCarbitrum: {
    Ethereum: "0xCFc006a32a98031C2338BF9d5ff8ED2c0Cae4a9e",
    Bsc: "0x5caa170b465122D15a6D20FD9A804a9613CE7882",
    Polygon: "0x7800FE8951cdc1cDea748d878fAce63018D97960",
    Avalanche: "0x4b5fE357Eb11c735078e47526D6e853DBff18541",
    Celo: "0xA41a62567d9eb960D84b72663FdaeBE0BCdE2683",
    Solana: "CR4xnGrhsu1fWNPoX4KbTUUtqGMF3mzRLfj4S6YEs1Yo",
    Sui: "0xc3f8927de33d3deb52c282a836082a413bc73c6ee0bd4d7ec7e3b6b4c28e9abf::coin::COIN",
    Aptos: "0xca3a2c28bc8c6c762f752dd2a4ebbfd00356ca99977ce6636e3af5897124a87a::coin::T",
    Optimism: "0xa6252F56cc6eEA21165d56744C795F91c8a3Cf68",
    Base: "0xb96B82Cd6D45d98Fb6897D16A5E4EE888329C513",
    Fantom: "0x2228703672906fEe5eD681Ec28e42B4506b8c336",
    Moonbeam: "0xbd2B6D665439514EEaA8519f4fE87CC8C46e9167",
    Klaytn: "0x3d5973fF7288f47857dAa5a32C53976A9A968928",
    Xlayer: "0xd53bD30985B4125fc561774e388d9f679BB84117"
  },
  WETHoptimism: {
    Fantom: "0xe8E8f941377A955bFA72880ec0dc2319dbC827a8",
    Celo: "0x8d53771b1Ec7461f8e45Bca2609c45bC0bbd0677",
    Solana: "8M6d63oL7dvMZ1gNbgGe3h8afMSWJEKEhtPTFM2u8h3c",
    Sui: "0x0aab14ec22908de73d1b0619f5e03842398f8e68262981bd35ef44b42d22b23a::coin::COIN",
    Aptos: "0x6a7a7f36ef5e2d0e65fcf72669c20d514d68298b0f76c7554517208f73260aaf::coin::T",
    Arbitrum: "0xB1fC645a86fB5085e12D8BDDb77702F728D2A26F",
    Avalanche: "0xDf11535274c0FD2Fe41A88bd1bBF802D72296037",
    Bsc: "0x94AEc09B5e2CE591e39DC6aa58A3A6E85Ed45265",
    Ethereum: "0x8B5653Ae095529155462eDa8CF664eD96773F557",
    Polygon: "0x8182De59485Bb646542Db8C7E5958148Dc699319",
    Base: "0xCb725aC8d9985D3bE306Dd9e1517d3702929176c",
    Moonbeam: "0xd4870F7F5AD8Ae5139E1a5D8AD4ac55204aE4490",
    Klaytn: "0x4ab77AF7059435b71dBC3B7c5255983C8628eFdf"
  },
  USDCoptimism: {
    Fantom: "0x385b219f0C4fa2e84EfE5aaf9692a821C57B8248",
    Celo: "0xEe48963C003e21EaCEdFA8a0A19BB3cbF7E776Fe",
    Moonbeam: "0x7143e8EA96e158381057a58AfdDF44601c7e532C",
    Base: "0xc6bfBeb3002aD563D2d1f72614C61C83Bf147Acd",
    Arbitrum: "0x3A5C2Da9E30741cb59a5e9446A23A86886fC9DC2",
    Aptos: "0x4f6ecb05a797902d472abc2f5804bde93a53d8b75f14f767824cdb1623a4ee83::coin::T",
    Bsc: "0xa41ae127D04F7ee73B5058E2C60Fb7c7A2D21F79",
    Avalanche: "0xBe04f76A0ba2100c3F2d6Aa1FD8484F415469573",
    Polygon: "0x31F12aCb60C3c32EE884F3894a873347C097D925",
    Sui: "0x6037801f060f0f54b3817bca05e3c8b9b9ffaa2da8e93fd5b80fa662aa3c9e55::coin::COIN",
    Solana: "J8kcD4Wnd1ehne1dpL8WNtgZQR6Jpui2cTZcrmg5ybAa",
    Klaytn: "0x7Ee2AB1443fDB59AECEa3aDD8F81296d68c2D1e3",
    Ethereum: "0xe77C99b64414e0fd9aeEA48AFFBBD2E97A895020"
  },
  WETHbsc: {
    Aptos: "0xd9fc4259ec5def95477dba9f0861c2882d1f8bee9a4138b476dd0720a3444547::coin::T",
    Solana: "FzjTz2cD1DfqYvafrbHWZvf1dK9qjwXGLuaU7xYXQjxP",
    Sui: "0x5029d5a94429a73b8036cd67192d9c5e09bbc2c0fee942d50075a9edba66744f::coin::COIN",
    Base: "0xf50509Bb6aF76E20c6E1eD493699c5f70764BcCC",
    Arbitrum: "0x6478377A399bE8c92bD35254aA7bF287836de32e",
    Ethereum: "0x5DbBB101CDc29443d12055eCDDdD7ca037Dce721",
    Fantom: "0xc511E3aec79CABD605021C237c475Ec553B002d4",
    Celo: "0x09F236D3708894581b1Cf679e582ba9eA5BE16f0",
    Klaytn: "0x4C07075BB44076106f3389766946b79784Fb5C58",
    Avalanche: "0xf0e509144CfA602d0A5e8C75d76FF74077f52f2b",
    Optimism: "0x8088Bc767c392b5769b94c9ec1D07c62874c8d5f",
    Polygon: "0x2D291e940DbDdaa9E847Ba5cC49451575f086b27",
    Moonbeam: "0xBefd7902B682938b29B3FD3D4AdECD9A984D5930"
  },
  WETHbase: {
    Ethereum: "0x1D4241F7370253C0f12EFC536B7e16E462Fb3526",
    Bsc: "0x9dc152F4941cE1A138326e70c3600385bf0C22dD",
    Polygon: "0x5BCf8d8c097FbB35C371F921E3FF3e6F6Eb54B41",
    Avalanche: "0xFA83178c66fE51ee99109b5cC912f8098Ff812eF",
    Fantom: "0xd3365E7355230c78098b44B172eE27DAB95B041A",
    Celo: "0x905CADB645684140E285e2D09D39dF5a2082BC87",
    Moonbeam: "0x6C6f83366A42fcA4D30a2D3f1914284de995Ac3a",
    Solana: "DWXe1hxpnb8LAH21iyXcjvMbiAGzoYyuCVQtRLvZdLYd",
    Sui: "0xaecbc804fa7ca7cffc74c9a05eb6ae86fda0c68375b5c1724204a1065bcb239a::coin::COIN",
    Aptos: "0x5b5f14781164cf77185a7b6acd8e4f3cbb7e7cfb1cd5760d2b8af81075fc153d::coin::T",
    Arbitrum: "0xBAfbCB010D920e0Dab9DFdcF634De1B777028a85",
    Optimism: "0x3F369a664fa665e01e8EB9f20bFcE03A0CAb8971",
    Mantle: "0x4a2176DE2Fb36485704965bd1Cc471854f21303B",
    Klaytn: "0x7Bf9ad1D104dEAE4B59Ef1be6a273Cb46BA16362"
  },
  USDCbase: {
    Solana: "EfqRM8ZGWhDTKJ7BHmFvNagKVu3AxQRDQs8WMMaoBCu6",
    Moonbeam: "0xE6d02a875CcC153c076fe418f33De3A5C420f505",
    Celo: "0x2e2acb1782Aad0490f8446b6fD4626C467987bD6",
    Bsc: "0x55CaD531c8E303Cab8B3BE4bB4744Db4f896ac81",
    Optimism: "0xb931c7BbD87A6e249EaA7355B13927F9c99Bce87",
    Arbitrum: "0x8619F97D4d08382548F536E5CE1D3e0D9bA40326",
    Polygon: "0x1eeCaB0F75fE93abbFa0cDFfb4fB13d1dC8706c8",
    Avalanche: "0xab933e939a9236BD439F7d29b87CE712f42bAC06",
    Fantom: "0xd9E4C283d8A49Dc3767A6F5a4dFdc1d0cEf21604",
    Sui: "0x7e3e74afcc1913aa9491c8cee89b02131a6e5519b090f16b54321835c1241cfb::coin::COIN",
    Aptos: "0xfcc4fcd734d5b8578fb629d238d15264a49eca6165c7444c21feec3b4962eb88::coin::T",
    Blast: "0x35a926D55A726cdF70Ac498972F22426363F3C77",
    Mantle: "0x5D628a3285a10fdd93AEa704007957F294e05F91",
    Ethereum: "0xc38261846c42C1E1D59E04dA675Eb1974E9cE7b1",
    Klaytn: "0x0a2330c1C46E9A74e8651F7117a1264410eA3C88",
    Scroll: "0x22C9bde4Ad49C4b6CCFB8D394B5ED42A57853d58"
  },
  wstETHbase: {
    Arbitrum: "0x09E79693E44c8813A8CA25EeD7A40e5E24cD9c01",
    Ethereum: "0x187175c7a526f48c905202Bd2Bf8D25A457F479F",
    Polygon: "0x95d4C8e851D9E8c6B92aa518474E991c373E9Fb2",
    Optimism: "0x6ee40855c0BaB20585d17D2b9dd8d2Cd1cd41801",
    Avalanche: "0x5e513CA12DbD8424bDFc5B50711dF4AE999a8C58"
  },
  wstETH: {
    Polygon: "0xe082a7Fc696De18172Ad08D956569Ee80BC37f06",
    Solana: "ZScHuTtqZukUrtZS43teTKGs2VqkKL8k4QCouR2n6Uo",
    Arbitrum: "0xf2717122Dfdbe988ae811E7eFB157aAa07Ff9D0F",
    Optimism: "0x855CFcEEe998c8ca34F9c914F584AbF72dC88B87",
    Base: "0xEd4e2FD35161c3c0e33cA187fce64C70d44Ce32b",
    Bsc: "0xad80E1A9B5824234afA9dE1F3bbDb8a994796169",
    Avalanche: "0x11449fd2F05D93827972b40adE96F6ffBE42E35a",
    Fantom: "0x2a2Ec6Ad3e47C536F47934F63b95BD647F1C730E",
    Worldchain: "0xd977e0251db8d38155dC5d212944AB7B7a6777Ad"
  },
  wstETHarbitrum: {
    Bsc: "0x159167e842C586a81f02E55bc043AC8EdB033E0b",
    Aptos: "0xd2ca17516bc4ca57c1c69577e0c9cc0129153286695b46b97f438ecc138c225e::coin::T",
    Solana: "8wJakbZuv7WApfHmRo2sdkeQfu6hXqfEqjb7BYXDKpKe",
    Sui: "0xb607aed1c09e676384d14ae638dbcb08523fc691d309e71c856c7fdcb60d4430::coin::COIN",
    Base: "0xbE3981b37CcE5eCb6925d2ad9D9E28dE7b165793",
    Optimism: "0xEae5ccc3c36beF59f6794b467e7e228CB3720415",
    Fantom: "0xf65BF40A3299Df500D440520dF7e6ce1BEa53E73",
    Ethereum: "0x906310cE867C22c5016248Bd791FA5dd162c9D6d",
    Polygon: "0xcf0aa97c2fD78Ee0f0C3090B9EB65d2bd6C1D81a"
  },
  wstETHoptimism: {
    Bsc: "0x1f29fAD000255BF49D72803b2A8FaC8e31947eF8",
    Base: "0xBb0BeaB819dEAf091C193bE4bBEeA9D5b0F5227C",
    Arbitrum: "0xf99C5EEd186601955a9a1027536D1b46b1f909F8",
    Polygon: "0x9065e1D25E65F7A1D60bb6197154386B52faA469",
    Ethereum: "0xB3ceE6DCa1dD528CB7CC258e32D8B50ce9Ee46f5"
  },
  wstETHpolygon: {
    Base: "0xcB6D47199d60747152d7671D6497ce8D23cc1D75",
    Arbitrum: "0x23D3901A635fDd98D8d6509bc0720281f80a8E6D",
    Ethereum: "0x302F636d723c8Ed75C0d1E9D9C714009184C5624",
    Optimism: "0x4fad81d2268a7D9E1e0fE7dB38af07FFFA0aA56E",
    Celo: "0xA4c7302659eCF88a90e62e915Bd486E66B616A4C"
  },
  WKLAY: {
    Aptos: "0x539b652f8230a0e42adaeda4706b5639893d22362eda6ea897493c210cb48219::coin::T",
    Ethereum: "0x9AEA32B459e96C8eF5010f69130bf95fd129ac05",
    Celo: "0xe304254de5c2048F9bFb042dDFB54f84d1d77730",
    Polygon: "0x415ce980fde17F1FF102e1c6e4ce860Acc615D74",
    Base: "0x41c433c146c47Dc53FC48cDc69e406e365e298E1",
    Arbitrum: "0xFA95f6c796E54F9C4a99392CAE84410a25794BB3",
    Moonbeam: "0xf0a9476E4712123A807859f9Fd25fe98213379BD",
    Fantom: "0x787e2F3509583C0F03A339Be0826463C839CBE5E",
    Sui: "0xa5ec915864d7f37b25ca9144b2db6ebcf29e73603c2ccf9d0e765adcd9049a98::coin::COIN",
    Avalanche: "0x126C03982Ad6D7ef7E6aF020bF219e87185a6BC3",
    Bsc: "0xEA970e7b7D131Ea36c3051C9Ca11e785462fE00c",
    Optimism: "0xbbeF8233a0d10EEAb84E913FaDB337ab9b62F683",
    Solana: "2b8fZGLBZjpxFugCdnJbbLLBYxvx23rsrsvLYYueiHb7",
    Blast: "0x5F6fE613528df9AE4Bf6f667fbCB923263098617",
    Scroll: "0xA55FB7A046454998b2f6d8D99Df5F0E108b38229",
    Worldchain: "0xC080f0082029fC6e8A4Bb33a9B0655B8d4f2BAB0"
  },
  PYTH: {
    Aptos: "0x770211b47954e15bec1a4271bf33bacebc2d2adb43b7dc1ca45efa787615dd4c::coin::T",
    Bsc: "0xb0188B0bb2cD4a6D2744637fC83C94a284B247Da",
    Base: "0x4c5d8A75F3762c1561D96f177694f67378705E98",
    Celo: "0x985aa4814419ba338379A634785216301e51113D",
    Avalanche: "0x8A0691e602B7a5FCc51a27E4a08376dE50889B42",
    Polygon: "0xFa4B761A1e07909Ba31331a5dfa12390E3ff5583",
    Fantom: "0x77ad3B2dA29FBd208F12c3C701E969F4422aAD79",
    Optimism: "0x99C59ACeBFEF3BBFB7129DC90D1a11DB0E91187f",
    Ethereum: "0xeFc0CED4B3D536103e76a1c4c74F0385C8F4Bdd3",
    Arbitrum: "0xE4D5c6aE46ADFAF04313081e8C0052A30b6Dd724",
    Sui: "0x9c6d76eb273e6b5ba2ec8d708b7fa336a5531f6be59f326b5be8d4d8b12348a4::coin::COIN",
    Moonbeam: "0x27cc3FDbDD1F415b09a41232D0fD71345DAB8030",
    Xlayer: "0x057b766b3fB76527cf815c3b5C38Dfa8144335CF",
    Worldchain: "0x838f3045F3B2dcDFF8cB4e5CaB0c0092A69B790a"
  },
  WETHscroll: { Arbitrum: "0xAe81a542e20270b48Bd5297E3e0f280f79E46C42" },
  WMNT: { Optimism: "0xf704F6a3241609Cfb3E44Db1237E68EB6CaC7C04" }
}, MAINNET = {
  chains: MAINNET_CHAINS,
  tokens: MAINNET_TOKENS,
  wrappedTokens: MAINNET_WRAPPED_TOKENS,
  rpcs: MAINNET_RPC_MAPPING,
  rest: MAINNET_REST_MAPPING,
  graphql: MAINNET_GRAPHQL_MAPPING,
  // From VAA https://wormholescan.io/#/tx/1/0000000000000000000000000000000000000000000000000000000000000004/18252082506122526004
  guardianSet: {
    index: 4,
    keys: [
      "0x5893b5a76c3f739645648885bdccc06cd70a3cd3",
      "0xff6cb952589bde862c25ef4392132fb9d4a42157",
      "0x114de8460193bdf3a2fcf81f86a09765f4762fd1",
      "0x107a0086b32d7a0977926a205131d8731d39cbeb",
      "0x8c82b2fd82faed2711d59af0f2499d16e726f6b2",
      "0x11b39756c042441be6d8650b69b54ebe715e2343",
      "0x54ce5b4d348fb74b958e8966e2ec3dbd4958a7cd",
      "0x15e7caf07c4e3dc8e7c469f92c8cd88fb8005a20",
      "0x74a3bf913953d695260d88bc1aa25a4eee363ef0",
      "0x000ac0076727b35fbea2dac28fee5ccb0fea768e",
      "0xaf45ced136b9d9e24903464ae889f5c8a723fc14",
      "0xf93124b7c738843cbb89e864c862c38cddcccf95",
      "0xd2cc37a4dc036a8d232b48f62cdd4731412f4890",
      "0xda798f6896a3331f64b48c12d1d57fd9cbe70811",
      "0x71aa1be1d36cafe3867910f99c09e347899c19c3",
      "0x8192b6e7387ccd768277c17dab1b7a5027c0b3cf",
      "0x178e21ad2e77ae06711549cfbb1f9c7a9d8096e8",
      "0x5e1487f35515d02a92753504a8d75471b9f49edb",
      "0x6fbebc898f403e4773e95feb15e80c9a99c8348d"
    ]
  }
}, { chains: chains$2 } = CONFIG.TESTNET, TESTNET_CHAINS = {
  Bsc: {
    ...chains$2.Bsc,
    displayName: "BSC",
    explorerUrl: "https://testnet.bscscan.com/",
    explorerName: "BscScan",
    gasToken: "BNB",
    chainId: 97,
    icon: "Bsc",
    maxBlockSearch: 2e3,
    symbol: "BSC"
  },
  Avalanche: {
    ...chains$2.Avalanche,
    displayName: "Fuji",
    explorerUrl: "https://testnet.avascan.info/blockchain/c/",
    explorerName: "Avascan",
    gasToken: "AVAX",
    chainId: 43113,
    icon: "Avalanche",
    maxBlockSearch: 2e3,
    symbol: "AVAX"
  },
  Fantom: {
    ...chains$2.Fantom,
    displayName: "Fantom",
    explorerUrl: "https://testnet.ftmscan.com/",
    explorerName: "FtmScan",
    gasToken: "FTM",
    chainId: 4002,
    icon: "Fantom",
    maxBlockSearch: 2e3,
    symbol: "FTM"
  },
  Celo: {
    ...chains$2.Celo,
    displayName: "Alfajores",
    explorerUrl: "https://explorer.celo.org/alfajores/",
    explorerName: "Celo Explorer",
    gasToken: "CELO",
    chainId: 44787,
    icon: "Celo",
    maxBlockSearch: 2e3,
    symbol: "CELO"
  },
  Moonbeam: {
    ...chains$2.Moonbeam,
    displayName: "Moonbase",
    explorerUrl: "https://moonbase.moonscan.io/",
    explorerName: "Moonscan",
    gasToken: "GLMR",
    chainId: 1287,
    icon: "Moonbeam",
    maxBlockSearch: 2e3,
    symbol: "GLMR"
  },
  Solana: {
    ...chains$2.Solana,
    displayName: "Solana",
    explorerUrl: "https://explorer.solana.com/",
    explorerName: "Solana Explorer",
    gasToken: "SOL",
    chainId: 0,
    icon: "Solana",
    maxBlockSearch: 2e3,
    symbol: "SOL"
  },
  Sui: {
    ...chains$2.Sui,
    displayName: "Sui",
    explorerUrl: "https://suiscan.xyz/testnet/",
    explorerName: "Suiscan",
    gasToken: "SUI",
    chainId: 0,
    icon: "Sui",
    maxBlockSearch: 0,
    symbol: "SUI"
  },
  Aptos: {
    ...chains$2.Aptos,
    displayName: "Aptos",
    explorerUrl: "https://explorer.aptoslabs.com/",
    explorerName: "Aptos Explorer",
    gasToken: "APT",
    chainId: 0,
    icon: "Aptos",
    maxBlockSearch: 0,
    symbol: "APT"
  },
  Klaytn: {
    ...chains$2.Klaytn,
    displayName: "Kaia",
    explorerUrl: "https://kairos.kaiascope.com/",
    explorerName: "Kaia Scope",
    gasToken: "KLAY",
    chainId: 1001,
    icon: "Klaytn",
    maxBlockSearch: 2e3,
    symbol: "KLAY"
  },
  // TODO: SDKV2 - re-enable cosmos chains once cosmos gateway route is implemented
  //Sei: {
  //  ...chains.Sei!,
  //  displayName: 'Sei',
  //  explorerUrl: 'https://testnet.sei.explorers.guru/',
  //  explorerName: 'Sei Explorer',
  //  gasToken: 'SEI',
  //  chainId: 0,
  //  icon: 'Sei',
  //  maxBlockSearch: 0,
  //},
  //Osmosis: {
  //  ...chains.Osmosis!,
  //  displayName: 'Osmosis',
  //  explorerUrl: 'https://testnet.mintscan.io/osmosis-testnet/',
  //  explorerName: 'MintScan',
  //  gasToken: 'OSMO',
  //  chainId: 'osmo-test-5',
  //  icon: 'Osmosis',
  //  maxBlockSearch: 0,
  //},
  //Wormchain: {
  //  ...chains.Wormchain!,
  //  displayName: 'Wormchain',
  //  explorerUrl: '',
  //  explorerName: '',
  //  gasToken: 'WORM',
  //  chainId: 'wormchain-testnet-0',
  //  icon: 'Osmosis',
  //  maxBlockSearch: 0,
  //},
  //Cosmoshub: {
  //  ...chains.Cosmoshub!,
  //  displayName: 'Cosmoshub',
  //  explorerUrl: 'https://testnet.mintscan.io/cosmoshub-testnet/',
  //  explorerName: 'MintScan',
  //  gasToken: 'ATOM',
  //  chainId: 'theta-testnet-001',
  //  icon: 'Cosmoshub',
  //  maxBlockSearch: 0,
  //},
  //Evmos: {
  //  ...chains.Evmos!,
  //  displayName: 'Evmos',
  //  explorerUrl: 'https://testnet.mintscan.io/evmos-testnet/',
  //  explorerName: 'MintScan',
  //  gasToken: 'EVMOS',
  //  chainId: 'evmos_9000-4',
  //  icon: 'Evmos',
  //  maxBlockSearch: 0,
  //},
  //Kujira: {
  //  ...chains.Kujira!,
  //  displayName: 'Kujira',
  //  explorerUrl: 'https://finder.kujira.app/harpoon-4/',
  //  explorerName: 'Kujira Finder',
  //  gasToken: 'KUJI',
  //  chainId: 'harpoon-4',
  //  icon: 'Kujira',
  //  maxBlockSearch: 0,
  //},
  Sepolia: {
    ...chains$2.Sepolia,
    displayName: "Sepolia",
    explorerUrl: "https://sepolia.etherscan.io/",
    explorerName: "Etherscan",
    gasToken: "ETHsepolia",
    chainId: 11155111,
    icon: "Ethereum",
    maxBlockSearch: 2e3,
    symbol: "ETH"
  },
  ArbitrumSepolia: {
    ...chains$2.ArbitrumSepolia,
    displayName: "Arbitrum Sepolia",
    explorerUrl: "https://sepolia.arbiscan.io/",
    explorerName: "Etherscan",
    gasToken: "ETHarbitrum_sepolia",
    chainId: 421614,
    icon: "Arbitrum",
    maxBlockSearch: 2e3,
    symbol: "ARB"
  },
  BaseSepolia: {
    ...chains$2.BaseSepolia,
    displayName: "Base Sepolia",
    explorerUrl: "https://base-sepolia.blockscout.com/",
    explorerName: "Etherscan",
    gasToken: "ETHbase_sepolia",
    chainId: 84532,
    icon: "Base",
    maxBlockSearch: 2e3,
    symbol: "BASE"
  },
  OptimismSepolia: {
    ...chains$2.OptimismSepolia,
    displayName: "Optimism Sepolia",
    explorerUrl: "https://sepolia-optimistic.etherscan.io/",
    explorerName: "Etherscan",
    gasToken: "ETHoptimism_sepolia",
    chainId: 11155420,
    icon: "Optimism",
    maxBlockSearch: 2e3,
    symbol: "OP"
  },
  //Injective: {
  //  ...chains.Injective!,
  //  displayName: 'Injective',
  //  explorerUrl: 'https://testnet.explorer.injective.network',
  //  explorerName: 'Injective Explorer',
  //  gasToken: 'INJ',
  //  chainId: 'injective-888',
  //  icon: 'Injective',
  //  maxBlockSearch: 0,
  //},
  Scroll: {
    ...chains$2.Scroll,
    displayName: "Scroll",
    explorerUrl: "https://sepolia.scrollscan.dev/",
    explorerName: "Scrollscan",
    gasToken: "ETHscroll",
    chainId: 534351,
    icon: "Scroll",
    maxBlockSearch: 2e3,
    symbol: "SCR"
  },
  Blast: {
    ...chains$2.Blast,
    displayName: "Blast",
    explorerUrl: "https://testnet.blastscan.io/",
    explorerName: "Blastscan",
    gasToken: "ETHblast",
    chainId: 168587773,
    icon: "Blast",
    maxBlockSearch: 2e3,
    symbol: "BLAST"
  },
  Xlayer: {
    ...chains$2.Xlayer,
    displayName: "X Layer",
    explorerUrl: "https://www.okx.com/web3/explorer/xlayer-test/",
    explorerName: "OKX Explorer",
    gasToken: "OKB",
    chainId: 195,
    icon: "Xlayer",
    maxBlockSearch: 2e3,
    symbol: "OKX"
  },
  Mantle: {
    ...chains$2.Mantle,
    displayName: "Mantle",
    explorerUrl: "https://explorer.testnet.mantle.xyz/",
    explorerName: "Mantle Explorer",
    gasToken: "MNT",
    chainId: 5003,
    icon: "Mantle",
    maxBlockSearch: 2e3,
    symbol: "MNT"
  },
  Worldchain: {
    ...chains$2.Worldchain,
    displayName: "World Chain",
    explorerUrl: "https://worldchain-sepolia.explorer.alchemy.com/",
    explorerName: "World Scan",
    gasToken: "ETHworldchain",
    chainId: 4801,
    icon: "Worldchain",
    maxBlockSearch: 2e3,
    symbol: "WORLD"
  }
}, __vite_import_meta_env__$1 = { BASE_URL: "/", DEV: !1, MODE: "production", PROD: !0, REACT_APP_CONNECT_GIT_HASH: "f3e2348ce4d17de817ae4eea097fa890dc70f16b", REACT_APP_CONNECT_VERSION: "1.2.0", SSR: !1 }, {
  REACT_APP_SEPOLIA_RPC,
  REACT_APP_BSC_TESTNET_RPC,
  REACT_APP_FUJI_RPC,
  REACT_APP_FANTOM_TESTNET_RPC,
  REACT_APP_ALFAJORES_RPC,
  REACT_APP_SOLANA_DEVNET_RPC,
  REACT_APP_MOONBASE_RPC,
  REACT_APP_SUI_TESTNET_RPC,
  REACT_APP_APTOS_TESTNET_RPC,
  REACT_APP_SEI_TESTNET_RPC,
  REACT_APP_BASE_SEPOLIA_RPC,
  REACT_APP_OSMOSIS_TESTNET_RPC,
  REACT_APP_INJECTIVE_TESTNET_RPC,
  REACT_APP_WORMCHAIN_TESTNET_RPC,
  REACT_APP_EVMOS_TESTNET_RPC,
  REACT_APP_COSMOSHUB_TESTNET_RPC,
  REACT_APP_KUJIRA_TESTNET_RPC,
  REACT_APP_KLAYTN_TESTNET_RPC,
  REACT_APP_SEI_REST: REACT_APP_SEI_REST$1,
  REACT_APP_EVMOS_REST,
  REACT_APP_ARBITRUM_SEPOLIA_RPC,
  REACT_APP_OPTIMISM_SEPOLIA_RPC,
  REACT_APP_APTOS_TESTNET_GRAPHQL,
  REACT_APP_SCROLL_TESTNET_RPC,
  REACT_APP_BLAST_TESTNET_RPC,
  REACT_APP_XLAYER_TESTNET_RPC,
  REACT_APP_MANTLE_TESTNET_RPC,
  REACT_APP_WORLDCHAIN_TESTNET_RPC
} = __vite_import_meta_env__$1, TESTNET_RPC_MAPPING = {
  ...populateRpcField("Sepolia", REACT_APP_SEPOLIA_RPC),
  ...populateRpcField("Bsc", REACT_APP_BSC_TESTNET_RPC),
  ...populateRpcField("Avalanche", REACT_APP_FUJI_RPC),
  ...populateRpcField("Fantom", REACT_APP_FANTOM_TESTNET_RPC),
  ...populateRpcField("Celo", REACT_APP_ALFAJORES_RPC),
  ...populateRpcField("Solana", REACT_APP_SOLANA_DEVNET_RPC),
  ...populateRpcField("Moonbeam", REACT_APP_MOONBASE_RPC),
  ...populateRpcField("Sui", REACT_APP_SUI_TESTNET_RPC),
  ...populateRpcField("Aptos", REACT_APP_APTOS_TESTNET_RPC),
  ...populateRpcField("Sei", REACT_APP_SEI_TESTNET_RPC),
  ...populateRpcField("BaseSepolia", REACT_APP_BASE_SEPOLIA_RPC),
  ...populateRpcField("Osmosis", REACT_APP_OSMOSIS_TESTNET_RPC),
  ...populateRpcField("Wormchain", REACT_APP_WORMCHAIN_TESTNET_RPC),
  ...populateRpcField("ArbitrumSepolia", REACT_APP_ARBITRUM_SEPOLIA_RPC),
  ...populateRpcField("OptimismSepolia", REACT_APP_OPTIMISM_SEPOLIA_RPC),
  ...populateRpcField("Cosmoshub", REACT_APP_COSMOSHUB_TESTNET_RPC),
  ...populateRpcField("Evmos", REACT_APP_EVMOS_TESTNET_RPC),
  ...populateRpcField("Kujira", REACT_APP_KUJIRA_TESTNET_RPC),
  ...populateRpcField("Injective", REACT_APP_INJECTIVE_TESTNET_RPC),
  ...populateRpcField("Klaytn", REACT_APP_KLAYTN_TESTNET_RPC),
  ...populateRpcField("Scroll", REACT_APP_SCROLL_TESTNET_RPC),
  ...populateRpcField("Blast", REACT_APP_BLAST_TESTNET_RPC),
  ...populateRpcField("Xlayer", REACT_APP_XLAYER_TESTNET_RPC),
  ...populateRpcField("Mantle", REACT_APP_MANTLE_TESTNET_RPC),
  ...populateRpcField("Worldchain", REACT_APP_WORLDCHAIN_TESTNET_RPC)
}, TESTNET_REST_MAPPING = {
  ...populateRpcField("Sei", REACT_APP_SEI_REST$1),
  ...populateRpcField("Evmos", REACT_APP_EVMOS_REST)
}, TESTNET_GRAPHQL_MAPPING = {
  ...populateRpcField("Aptos", REACT_APP_APTOS_TESTNET_GRAPHQL)
}, TESTNET_TOKENS = {
  BNB: {
    key: "BNB",
    symbol: "BNB",
    nativeChain: "Bsc",
    icon: TokenIcon.BNB,
    coinGeckoId: "binancecoin",
    color: "#F3BA30",
    decimals: 18,
    wrappedAsset: "WBNB"
  },
  WBNB: {
    key: "WBNB",
    symbol: "WBNB",
    nativeChain: "Bsc",
    icon: TokenIcon.BNB,
    tokenId: {
      chain: "Bsc",
      address: "0xae13d989daC2f0dEbFf460aC112a837C89BAa7cd"
    },
    coinGeckoId: "binancecoin",
    color: "#F3BA30",
    decimals: 18
  },
  AVAX: {
    key: "AVAX",
    symbol: "AVAX",
    nativeChain: "Avalanche",
    icon: TokenIcon.AVAX,
    coinGeckoId: "avalanche-2",
    color: "#E84141",
    decimals: 18,
    wrappedAsset: "WAVAX"
  },
  WAVAX: {
    key: "WAVAX",
    symbol: "WAVAX",
    nativeChain: "Avalanche",
    icon: TokenIcon.AVAX,
    tokenId: {
      chain: "Avalanche",
      address: "0xd00ae08403B9bbb9124bB305C09058E32C39A48c"
    },
    coinGeckoId: "avalanche-2",
    color: "#E84141",
    decimals: 18
  },
  USDCavax: {
    key: "USDCavax",
    symbol: "USDC",
    nativeChain: "Avalanche",
    icon: TokenIcon.USDC,
    tokenId: {
      chain: "Avalanche",
      address: "0x5425890298aed601595a70AB815c96711a31Bc65"
    },
    coinGeckoId: "usd-coin",
    color: "#2774CA",
    decimals: 6
  },
  FTM: {
    key: "FTM",
    symbol: "FTM",
    nativeChain: "Fantom",
    icon: TokenIcon.FANTOM,
    coinGeckoId: "Fantom",
    color: "#12B4EC",
    decimals: 18,
    wrappedAsset: "WFTM"
  },
  WFTM: {
    key: "WFTM",
    symbol: "WFTM",
    nativeChain: "Fantom",
    icon: TokenIcon.FANTOM,
    tokenId: {
      chain: "Fantom",
      address: "0xf1277d1Ed8AD466beddF92ef448A132661956621"
    },
    coinGeckoId: "Fantom",
    color: "#12B4EC",
    decimals: 18
  },
  CELO: {
    key: "CELO",
    symbol: "CELO",
    nativeChain: "Celo",
    icon: TokenIcon.CELO,
    tokenId: {
      chain: "Celo",
      address: "0xF194afDf50B03e69Bd7D057c1Aa9e10c9954E4C9"
    },
    coinGeckoId: "Celo",
    color: "#35D07E",
    decimals: 18
  },
  USDCalfajores: {
    key: "USDCalfajores",
    symbol: "USDC.e",
    nativeChain: "Celo",
    icon: TokenIcon.USDC,
    tokenId: {
      chain: "Celo",
      address: "0x72CAaa7e9889E0a63e016748179b43911A3ec9e5"
    },
    coinGeckoId: "usd-coin",
    color: "#2774CA",
    decimals: 6
  },
  GLMR: {
    key: "GLMR",
    symbol: "GLMR",
    nativeChain: "Moonbeam",
    icon: TokenIcon.GLMR,
    coinGeckoId: "moonbeam",
    color: "#e1147b",
    decimals: 18,
    wrappedAsset: "WGLMR"
  },
  WGLMR: {
    key: "WGLMR",
    symbol: "WGLMR",
    nativeChain: "Moonbeam",
    icon: TokenIcon.GLMR,
    tokenId: {
      chain: "Moonbeam",
      address: "0xD909178CC99d318e4D46e7E66a972955859670E1"
    },
    coinGeckoId: "moonbeam",
    color: "#e1147b",
    decimals: 18
  },
  SOL: {
    key: "SOL",
    symbol: "SOL",
    nativeChain: "Solana",
    icon: TokenIcon.SOLANA,
    coinGeckoId: "solana",
    color: "#8457EF",
    decimals: 9,
    wrappedAsset: "WSOL"
  },
  WSOL: {
    key: "WSOL",
    symbol: "WSOL",
    nativeChain: "Solana",
    tokenId: {
      chain: "Solana",
      address: "So11111111111111111111111111111111111111112"
    },
    icon: TokenIcon.SOLANA,
    coinGeckoId: "solana",
    color: "#8457EF",
    decimals: 9
  },
  USDCsol: {
    key: "USDCsol",
    symbol: "USDC",
    nativeChain: "Solana",
    tokenId: {
      chain: "Solana",
      address: "4zMMC9srt5Ri5X14GAgXhaHii3GnPAEERYPJgZJDncDU"
    },
    icon: TokenIcon.USDC,
    coinGeckoId: "usd-coin",
    color: "#2774CA",
    decimals: 6
  },
  SUI: {
    key: "SUI",
    symbol: "SUI",
    nativeChain: "Sui",
    tokenId: { chain: "Sui", address: "0x2::sui::SUI" },
    icon: TokenIcon.SUI,
    coinGeckoId: "Sui",
    color: "#8457EF",
    decimals: 9
  },
  USDCsui: {
    key: "USDCsui",
    symbol: "USDC",
    nativeChain: "Sui",
    tokenId: {
      chain: "Sui",
      address: "0xa1ec7fc00a6f40db9693ad1415d0c193ad3906494428cf252621037bd7117e29::usdc::USDC"
    },
    icon: TokenIcon.USDC,
    coinGeckoId: "usd-coin",
    color: "#2774CA",
    decimals: 6
  },
  APT: {
    key: "APT",
    symbol: "APT",
    nativeChain: "Aptos",
    tokenId: { chain: "Aptos", address: "0x1::aptos_coin::AptosCoin" },
    icon: TokenIcon.APT,
    coinGeckoId: "Aptos",
    color: "#8457EF",
    decimals: 8
  },
  KLAY: {
    key: "KLAY",
    symbol: "KLAY",
    decimals: 18,
    nativeChain: "Klaytn",
    icon: TokenIcon.KLAY,
    coinGeckoId: "klay-token",
    color: "#fa4212",
    wrappedAsset: "WKLAY"
  },
  WKLAY: {
    key: "WKLAY",
    symbol: "WKLAY",
    displayName: "wKLAY",
    nativeChain: "Klaytn",
    icon: TokenIcon.KLAY,
    tokenId: {
      chain: "Klaytn",
      address: "0x0339d5Eb6D195Ba90B13ed1BCeAa97EbD198b106"
    },
    coinGeckoId: "wrapped-klay",
    color: "#fa4212",
    decimals: 18
  },
  ETHsepolia: {
    key: "ETHsepolia",
    symbol: "ETH",
    nativeChain: "Sepolia",
    icon: TokenIcon.ETH,
    coinGeckoId: "Ethereum",
    color: "#5794EC",
    decimals: 18,
    wrappedAsset: "WETHsepolia"
  },
  WETHsepolia: {
    key: "WETHsepolia",
    symbol: "WETH",
    nativeChain: "Sepolia",
    icon: TokenIcon.ETH,
    tokenId: {
      chain: "Sepolia",
      address: "0xeef12A83EE5b7161D3873317c8E0E7B76e0B5D9c"
    },
    coinGeckoId: "Ethereum",
    color: "#5794EC",
    decimals: 18
  },
  USDCsepolia: {
    key: "USDCsepolia",
    symbol: "USDC",
    nativeChain: "Sepolia",
    icon: TokenIcon.USDC,
    tokenId: {
      chain: "Sepolia",
      address: "0x1c7D4B196Cb0C7B01d743Fbc6116a902379C7238"
    },
    coinGeckoId: "usd-coin",
    color: "#2774CA",
    decimals: 6
  },
  ETHarbitrum_sepolia: {
    key: "ETHarbitrum_sepolia",
    symbol: "ETH",
    nativeChain: "ArbitrumSepolia",
    icon: TokenIcon.ETH,
    coinGeckoId: "Ethereum",
    color: "#5794EC",
    decimals: 18,
    wrappedAsset: "WETHarbitrum_sepolia"
  },
  WETHarbitrum_sepolia: {
    key: "WETHarbitrum_sepolia",
    symbol: "WETH",
    nativeChain: "ArbitrumSepolia",
    icon: TokenIcon.ETH,
    tokenId: {
      chain: "ArbitrumSepolia",
      address: "0x980B62Da83eFf3D4576C647993b0c1D7faf17c73"
    },
    coinGeckoId: "Ethereum",
    color: "#5794EC",
    decimals: 18
  },
  ETHbase_sepolia: {
    key: "ETHbase_sepolia",
    symbol: "ETH",
    nativeChain: "BaseSepolia",
    icon: TokenIcon.ETH,
    coinGeckoId: "Ethereum",
    color: "#5794EC",
    decimals: 18,
    wrappedAsset: "WETHbase_sepolia"
  },
  WETHbase_sepolia: {
    key: "WETHbase_sepolia",
    symbol: "WETH",
    nativeChain: "BaseSepolia",
    icon: TokenIcon.ETH,
    tokenId: {
      chain: "BaseSepolia",
      address: "0x4200000000000000000000000000000000000006"
    },
    coinGeckoId: "Ethereum",
    color: "#5794EC",
    decimals: 18
  },
  ETHoptimism_sepolia: {
    key: "ETHoptimism_sepolia",
    symbol: "ETH",
    nativeChain: "OptimismSepolia",
    icon: TokenIcon.ETH,
    coinGeckoId: "Ethereum",
    color: "#5794EC",
    decimals: 18,
    wrappedAsset: "WETHoptimism_sepolia"
  },
  WETHoptimism_sepolia: {
    key: "WETHoptimism_sepolia",
    symbol: "WETH",
    nativeChain: "OptimismSepolia",
    icon: TokenIcon.ETH,
    tokenId: {
      chain: "OptimismSepolia",
      address: "0x4200000000000000000000000000000000000006"
    },
    coinGeckoId: "Ethereum",
    color: "#5794EC",
    decimals: 18
  },
  ETHscroll: {
    key: "ETHscroll",
    symbol: "ETH",
    nativeChain: "Scroll",
    icon: TokenIcon.SCROLL,
    coinGeckoId: "Ethereum",
    decimals: 18,
    wrappedAsset: "WETHscroll"
  },
  WETHscroll: {
    key: "WETHscroll",
    symbol: "WETH",
    nativeChain: "Scroll",
    icon: TokenIcon.SCROLL,
    tokenId: {
      chain: "Scroll",
      address: "0x5300000000000000000000000000000000000004"
    },
    coinGeckoId: "Ethereum",
    decimals: 18
  },
  ETHblast: {
    key: "ETHblast",
    symbol: "ETH",
    nativeChain: "Blast",
    icon: TokenIcon.BLAST,
    coinGeckoId: "Ethereum",
    decimals: 18,
    wrappedAsset: "WETHblast"
  },
  WETHblast: {
    key: "WETHblast",
    symbol: "WETH",
    nativeChain: "Blast",
    icon: TokenIcon.BLAST,
    tokenId: {
      chain: "Blast",
      address: "0x9D020B1697035d9d54f115194c9e04a1e4Eb9aF7"
    },
    coinGeckoId: "Ethereum",
    decimals: 18
  },
  OKB: {
    key: "OKB",
    symbol: "OKB",
    nativeChain: "Xlayer",
    icon: TokenIcon.XLAYER,
    coinGeckoId: "okb",
    decimals: 18,
    wrappedAsset: "WOKB"
  },
  WOKB: {
    key: "WOKB",
    symbol: "WOKB",
    nativeChain: "Xlayer",
    icon: TokenIcon.XLAYER,
    tokenId: {
      chain: "Xlayer",
      address: "0xa2aFfd8301BfB3c5b815829f2F509f053556D21B"
    },
    coinGeckoId: "okb",
    decimals: 18
  },
  MNT: {
    key: "MNT",
    symbol: "MNT",
    nativeChain: "Mantle",
    icon: TokenIcon.MANTLE,
    coinGeckoId: "mantle",
    decimals: 18,
    wrappedAsset: "WMNT"
  },
  WMNT: {
    key: "WMNT",
    symbol: "WMNT",
    nativeChain: "Mantle",
    icon: TokenIcon.MANTLE,
    tokenId: {
      chain: "Mantle",
      address: "0xa4c4cb2A072eE99f77212Fa18c2B7Ca26DA23905"
    },
    coinGeckoId: "mantle",
    decimals: 18
  },
  ETHworldchain: {
    key: "ETHworldchain",
    symbol: "ETH",
    nativeChain: "Worldchain",
    icon: TokenIcon.WORLDCHAIN,
    coinGeckoId: "ethereum",
    decimals: 18,
    wrappedAsset: "WETHworldchain"
  },
  WETHworldchain: {
    key: "WETHworldchain",
    symbol: "WETH",
    nativeChain: "Worldchain",
    icon: TokenIcon.WORLDCHAIN,
    tokenId: {
      chain: "Worldchain",
      address: "0x4200000000000000000000000000000000000006"
    },
    coinGeckoId: "ethereum",
    decimals: 18
  }
}, TESTNET_WRAPPED_TOKENS = {
  WBNB: {
    Avalanche: "0x10F1053bF2884b28ee0Bd7a2dDBa237Af3511d29",
    Fantom: "0xfB174b43228950C2055CFc25AE93f2DCe8E2beF0",
    Celo: "0xa8050be9389466c3c524F10F131f244ACbf21A0D",
    Moonbeam: "0x6097E80331B0c6aF4F74D7F2363E70Cb2Fd078A5",
    Solana: "BaGfF51MQ3a61papTRDYaNefBgTQ9ywnVne5fCff4bxT",
    Sui: "0xddcf8680a8a4b8a527d8c85ec203274991590c2ea898d1c4635b70164d9c584b::coin::COIN",
    Aptos: "0xa5894f5ddb8647e6143102aa336ff07374f7b32e88c1c703aef5b7c9a370bf80::coin::T",
    Klaytn: "0xEFa3626825C33C4cd83850920Ad7Ac0a392E1faE",
    Sepolia: "0x02CdD5eB55934663F0aD8fbA3516dC7DE4E22894"
  },
  WAVAX: {
    Bsc: "0x6cE9E2c8b59bbcf65dA375D3d8AB503c8524caf7",
    Fantom: "0x0f545Be981C37fB15ab7c65404648761e99016e4",
    Celo: "0x502c8C83008D9Dd812a7C5fB886C063060C73Dbf",
    Moonbeam: "0x2E8afeCC19842229358f3650cc3F091908dcbaB4",
    Solana: "3Ftc5hTz9sG4huk79onufGiebJNDMZNL8HYgdMJ9E7JR",
    Sui: "0xa600741c469fb57ed01497ddf101e798fa79a9c529bd176675c5c4d970811f80::coin::COIN",
    Aptos: "0xbe8f4301c0b54e870902b9a23eeb95ce74ac190531782aa3262337ceb145401a::coin::T",
    Blast: "0x74C6aA987658FcBaB9FdC2ee65f52Ddd5B2cEd95",
    Klaytn: "0x10257392a2B5e3C4D4bEe1607650a1C0C738202a",
    Scroll: "0x5Bd1ba0040C16b13894A6EbE3d55708c91eF08bb",
    Xlayer: "0xb13a464ceE7455A9b2941bFAe1bB1eB5A6833867"
  },
  USDCavax: {
    Bsc: "0x1cfeCf72bcBE1E429A21A5B11E708C7c397AaC54",
    Fantom: "0x6BC4E8D8c1d54656D1DeBCa96efc53aFd1408aD2",
    Celo: "0xDDB349c976cA2C873644F21f594767Eb5390C831",
    Moonbeam: "0x6533CE14804D113b1F494dC56c5D60A43cb5C3b5",
    Solana: "GQtMXZxnuacCFTXVeTvyHi6P9F6chbtzhVc8JgD8hv7c",
    Sui: "0x2aa8c885d04e676c4e87b7d0f94d4f3b243b1b5d93239d1cc41d5528ce1714c1::coin::COIN",
    Aptos: "0x2ef7697bdb33361ca39d228671203afc0dea3202e792d79d2072b761d87c834::coin::T"
  },
  WFTM: {
    Bsc: "0x9aB305B792DBdb8253bEE909E7006611Cb45175b",
    Avalanche: "0x094cB577C21Ab1360178beE74B9591fa12216dAD",
    Celo: "0xE6F8710cA14CFe7F5aAAD3A799C3d1D92dCba938",
    Moonbeam: "0x566c1cebc6A4AFa1C122E039C4BEBe77043148Ee",
    Solana: "DMw2tLaq1bVoAEKtkoUtieSk9bfCPUvubYLatTMsSVop",
    Sui: "0x14e756ff65e0ac810a5f69ca5276ef5b899a6df3c4717de1f85559d8b5ae6ea6::coin::COIN",
    Aptos: "0x533c6ade00d15d1e014c41e29e34853e87df92c4e01a6a3f41318dbd098048d6::coin::T",
    Klaytn: "0x097c8878A0d852581Dc4D8820151094Ddd3663Ac",
    Sepolia: "0x852132647d301B7EED02589B1dc73545E73c8596"
  },
  CELO: {
    Bsc: "0x1471698cBD9cAB0228F2EEA9303A2b3aA0ABDC2B",
    Avalanche: "0xC66d9c2b33c347d4A4441975f4688fcD5DD4c441",
    Fantom: "0xB18E73a69c3Aaea39a610372537Cf8482622d199",
    Moonbeam: "0x3406a9b09adf0cb36DC04c1523C4b294C6b79513",
    Solana: "84F2QX9278ToDmA98u4A86xSV9hz1ovazr8zwGaX6qjS",
    Sui: "0x81868174a6b11e1acc337b3414f9912455435d486609fb8d50b34312865085f2::coin::COIN",
    Aptos: "0xecbb0f7e7d049499ca83ca1358344f56557886f6f7adc740d6734cce7bfc9a14::coin::T",
    Klaytn: "0xC951826bbB310a8160BB78c2eEe6C98246292ba7",
    Sepolia: "0x648f226f3bDcAEdc844622d604F76935DC05bC24"
  },
  WGLMR: {
    Bsc: "0x5C31B36599ED7f06b09c0ffC7A2F928cE496F046",
    Avalanche: "0xf080782DF38eD5228D2FC2882d13D56c8f1D6f21",
    Fantom: "0x41E3CFDFC255A4bF3C8D3560Bc8D3D9b5080338e",
    Celo: "0x132D2172D89cd9CfD480A8887c6bF92360fB460e",
    Solana: "8987WGkYa5viiZ9DD8sS3PB5XghKmWjkEgmzvwDuoAEc",
    Sui: "0xeffae382de96981f7ddd2d294429924827e8f325d612487a12d6a0b249171002::coin::COIN",
    Aptos: "0x338373b6694f71dbeac5ca4a30503bf5f083888d71678aed31255de416be37c0::coin::T",
    Sepolia: "0x3F7CD70ECd402BBe71f45A95156A2CAC0d6A822E"
  },
  WSOL: {
    Bsc: "0x30f19eBba919954FDc020B8A20aEF13ab5e02Af0",
    Avalanche: "0xb10563644a6AB8948ee6d7f5b0a1fb15AaEa1E03",
    Fantom: "0xED1a08Fc69A7008d225890A96aaE258c465CC7ad",
    Celo: "0x05EEF2AE1A7A938D78598F7d9e8b97A9bED0c9eC",
    Sui: "0xbc03aaab4c11eb84df8bf39fdc714fa5d5b65b16eb7d155e22c74a68c8d4e17f::coin::COIN",
    Aptos: "0xdd89c0e695df0692205912fb69fc290418bed0dbe6e4573d744a6d5e6bab6c13::coin::T",
    Klaytn: "0x48D99C16638E6FFD2ED60375cD35ef6c139e5f41",
    Moonbeam: "0x5babD0d267Adf2081626654E51d1cABF8c477440",
    Sepolia: "0x824CB8fC742F8D3300d29f16cA8beE94471169f5"
  },
  USDCsol: {
    Bsc: "0x51a3cc54eA30Da607974C5D07B8502599801AC08"
  },
  SUI: {
    Bsc: "0x5A73D76e09Af2E428EC64aE10F91B78AC990B298",
    Avalanche: "0xfc5128F8556a6F059466E67740e6cC31EE5C2C47",
    Fantom: "0xd882AB49372eC093E8697B5153f54ab5e7738e3b",
    Celo: "0xa40d9E69ca9867C4bFbeC11Ce79C939991e9bf26",
    Solana: "BJZ72CjPQojVoH68mzrd4VQ4nr6KuhbAGnhZEZCujKxY",
    Aptos: "0x7b22d0e02f653d4fd1caddcfa4719a2b329da56eb81d8f27db703f02466c26a5::coin::T",
    Moonbeam: "0x2ed4B5B1071A3C676664E9085C0e3826542C1b27",
    Klaytn: "0xbA5F07a20681Add3A396E7606c6DC9B03d71d28A"
  },
  APT: {
    Bsc: "0x4A7Bd5E135f421057F97BbA8BCeeE5c18334f454",
    Avalanche: "0x996a3f12C1FcD7339Ea8801f629201e4d42EAD04",
    Fantom: "0xAb2297E8994149BA91737944E40891881aF762a4",
    Celo: "0xAC0a2fF7DD597de863878a3372142b07B614C125",
    Moonbeam: "0xCaa2A1d3BbbA0D1466571e83b4E2CbE04252593D",
    Solana: "7EvFD3JKCJVdtkAYdaSVKJsrPEJCzy2neJha7TREGrCa",
    Sui: "0x812d6feb8b84e55d47a0bfcae9fb6a4e7e09be5ec86ce0a729e0f67d5f59f477::coin::COIN"
  },
  WKLAY: {
    Bsc: "0x79D34FDb686B5D139949E4F92D83EEe376489176",
    Aptos: "0xa8ffe1ffe3057756019345cdf9cf3d1f1a3d9a355147dd9440878c448a057579::coin::T",
    Celo: "0x8e50fC4b7F8B7018E72475f78C640F973218C8Cf",
    Avalanche: "0x84f3298Bcc019BD5B995756494095e1Eb72B565C",
    Solana: "6p7qTfX4tRFtQovxwT77Jn9HFQEV7nxLbux9C31Tgm23",
    Fantom: "0x72A1C24dA7F08d11a7668E228Ec287Fc6ec16E48",
    Sepolia: "0x142D0E977768cA4De6f2161D9E5B5C9F00435F9e",
    Moonbeam: "0x6eFf019D79D4136e57A7FC141967F3D0AD41089a",
    Sui: "0xd4a59fb612b162df75a9d190c0f72098dcae883e88bd0eb28667c31f8208dc3c::coin::COIN"
  },
  WETHsepolia: {
    Solana: "6F5YWWrUMNpee8C6BDUc6DmRvYRMDDTgJHwKhbXuifWs",
    Celo: "0x890ad4a7eD5bD08b7d6638515157dF3bF4BaD1Bc",
    Bsc: "0x667a61Efa611399970AE927637dD6f9A16f51e40",
    Moonbeam: "0xa7276055a1d45fB9982575411801e10ac9970Da8",
    ArbitrumSepolia: "0x97Ee87C7Db6049669a518730a2Ee60d1Fc58844E",
    Avalanche: "0x12bFE94230daaE3d48067577F45b7b031dD357f3",
    Fantom: "0x7F96D67186561Aa17cEb699494E94bEE3F3499D4"
  },
  USDCsepolia: {
    Aptos: "0x3f2912a313c5bea312dbf19f9080101d2e762df6546a6fe9f60a4de72c93d015::coin::T",
    Solana: "23Adx8na44L3M1Nf9RrUpQPb41eufdRXKseg25FfcJtw",
    Celo: "0xD6A34325e5F6BE27b7006bf06651444196Da579a",
    Bsc: "0xb8850F591019F0794F813426d4A4A9b5fB8f23C8",
    BaseSepolia: "0x3F872340B6A75397aa9b0A463000349962a8795D",
    ArbitrumSepolia: "0x27B8F40Cf0915e729ae5A96970E91045Fe9724dF",
    Fantom: "0xa686203C86140142230f44A724281E1BEd09c369",
    Klaytn: "0x25f2a470a2e1E75DDAc40289AB277eDE4DD98aFa",
    Sui: "0x6529fef82a8a09470c550a3129bbd889030b62306f0c14161224b1a40ef1346f::coin::COIN"
  },
  WETHoptimism_sepolia: {
    ArbitrumSepolia: "0xa2610700cCA8361DECD27dB2564848C530f20813"
  }
}, TESTNET = {
  chains: TESTNET_CHAINS,
  tokens: TESTNET_TOKENS,
  wrappedTokens: TESTNET_WRAPPED_TOKENS,
  rpcs: TESTNET_RPC_MAPPING,
  rest: TESTNET_REST_MAPPING,
  graphql: TESTNET_GRAPHQL_MAPPING,
  guardianSet: {
    index: 0,
    keys: ["0x13947Bd48b18E53fdAeEe77F3473391aC727C638"]
  }
}, { chains: chains$1 } = CONFIG.DEVNET, DEVNET_CHAINS = {
  Ethereum: {
    ...chains$1.Ethereum,
    displayName: "EVM",
    explorerUrl: "",
    explorerName: "",
    gasToken: "ETH",
    chainId: 1,
    icon: "Ethereum",
    maxBlockSearch: 0,
    symbol: "ETH"
  },
  Osmosis: {
    ...chains$1.Osmosis,
    displayName: "Osmosis",
    explorerUrl: "",
    explorerName: "",
    gasToken: "OSMO",
    chainId: "osmosis-1002",
    icon: "Osmosis",
    maxBlockSearch: 0,
    symbol: "OSMO"
  },
  Wormchain: {
    ...chains$1.Wormchain,
    displayName: "Wormchain",
    explorerUrl: "",
    explorerName: "",
    gasToken: "WORM",
    chainId: "wormchain-1",
    icon: "Osmosis",
    maxBlockSearch: 0,
    symbol: "OSMO"
  },
  Terra2: {
    ...chains$1.Terra2,
    displayName: "Terra",
    explorerUrl: "",
    explorerName: "",
    gasToken: "LUNA",
    chainId: "localterra",
    icon: "Terra2",
    maxBlockSearch: 0,
    symbol: "OSMO"
  }
}, __vite_import_meta_env__ = { BASE_URL: "/", DEV: !1, MODE: "production", PROD: !0, REACT_APP_CONNECT_GIT_HASH: "f3e2348ce4d17de817ae4eea097fa890dc70f16b", REACT_APP_CONNECT_VERSION: "1.2.0", SSR: !1 }, {
  REACT_APP_ETHEREUM_DEVNET_RPC,
  REACT_APP_OSMOSIS_DEVNET_RPC,
  REACT_APP_WORMCHAIN_DEVNET_RPC,
  REACT_APP_TERRA2_DEVNET_RPC,
  REACT_APP_SEI_REST,
  REACT_APP_APTOS_DEVNET_REST
} = __vite_import_meta_env__, DEVNET_RPC_MAPPING = {
  ...populateRpcField("Ethereum", REACT_APP_ETHEREUM_DEVNET_RPC),
  ...populateRpcField("Osmosis", REACT_APP_OSMOSIS_DEVNET_RPC),
  ...populateRpcField("Wormchain", REACT_APP_WORMCHAIN_DEVNET_RPC),
  ...populateRpcField("Terra2", REACT_APP_TERRA2_DEVNET_RPC)
}, DEVNET_REST_MAPPING = {
  ...populateRpcField("Sei", REACT_APP_SEI_REST)
}, DEVNET_GRAPHQL_MAPPING = {
  ...populateRpcField("Aptos", REACT_APP_APTOS_DEVNET_REST)
}, DEVNET_TOKENS = {
  ETH: {
    key: "ETH",
    symbol: "ETH",
    nativeChain: "Ethereum",
    icon: TokenIcon.ETH,
    coinGeckoId: "ethereum",
    color: "#62688F",
    decimals: 18,
    wrappedAsset: "WETH"
  },
  WETH: {
    key: "WETH",
    symbol: "WETH",
    nativeChain: "Ethereum",
    icon: TokenIcon.ETH,
    tokenId: {
      chain: "Ethereum",
      address: "0xDDb64fE46a91D46ee29420539FC25FD07c5FEa3E"
    },
    coinGeckoId: "ethereum",
    color: "#62688F",
    decimals: 18
  },
  TKN: {
    key: "TKN",
    symbol: "TKN",
    nativeChain: "Ethereum",
    icon: TokenIcon.ETH,
    tokenId: {
      chain: "Ethereum",
      address: "0x2D8BE6BF0baA74e0A907016679CaE9190e80dD0A"
    },
    coinGeckoId: "ethereum",
    color: "#62688F",
    decimals: 18
  }
}, DEVNET_WRAPPED_TOKENS = {}, DEVNET = {
  chains: DEVNET_CHAINS,
  tokens: DEVNET_TOKENS,
  wrappedTokens: DEVNET_WRAPPED_TOKENS,
  rpcs: DEVNET_RPC_MAPPING,
  rest: DEVNET_REST_MAPPING,
  graphql: DEVNET_GRAPHQL_MAPPING,
  guardianSet: {
    index: 0,
    keys: ["0x13947Bd48b18E53fdAeEe77F3473391aC727C638"]
  }
}, WORMSCAN = "https://wormholescan.io/#/", CONNECT_VERSION = "1.2.0", CONNECT_GIT_HASH = "f3e2348ce4d17de817ae4eea097fa890dc70f16b", CHAIN_ORDER = [
  "Ethereum",
  "Solana",
  "Arbitrum",
  "Base",
  "Sui",
  "Bsc",
  "Optimism",
  "Fantom",
  "Polygon",
  "Avalanche",
  "Osmosis",
  "Celo",
  "Moonbeam",
  "Klaytn",
  "Injective",
  "Kujira",
  "Scroll",
  "Evmos",
  "Mantle"
];
function wrapEventHandler(C) {
  return function(e) {
    var $;
    const T = {
      meta: {
        version: CONNECT_VERSION,
        hash: CONNECT_GIT_HASH,
        host: ($ = window == null ? void 0 : window.location) == null ? void 0 : $.host
      },
      ...e
    };
    if (console.info("Wormhole Connect event:", T), C)
      try {
        C(T);
      } catch (V) {
        console.error("Error handling event:", V);
      }
  };
}
const TOKEN_PROGRAM_ID$3 = new PublicKey("TokenkegQfeZyiNwAJbNbGKPFXCWuBvf9Ss623VQ5DA"), TOKEN_2022_PROGRAM_ID$1 = new PublicKey("TokenzQdBNbLqP5VEhdkAS6EPFLC1PHnBqCXEpPxuEb"), ASSOCIATED_TOKEN_PROGRAM_ID$2 = new PublicKey("ATokenGPvbdGVxr1b2hvZbsiqW5xWH25efTNsLJA8knL");
new PublicKey("So11111111111111111111111111111111111111112");
new PublicKey("9pan9bMn5HatX4EJdBwg9VgCa7Uz5HL8N1m5D3NdXejP");
const encodeDecode = (C) => {
  const e = C.decode.bind(C), T = C.encode.bind(C);
  return { decode: e, encode: T };
}, bigInt = (C) => (e) => {
  const T = blob$1(C, e), { encode: $, decode: V } = encodeDecode(T), J = T;
  return J.decode = (ee, te) => {
    const re = V(ee, te);
    return toBigIntLE_1(dist$2.Buffer.from(re));
  }, J.encode = (ee, te, re) => {
    const ie = toBufferLE_1(ee, C);
    return $(ie, te, re);
  }, J;
}, u64$1 = bigInt(8), bool = (C) => {
  const e = u8$1(C), { encode: T, decode: $ } = encodeDecode(e), V = e;
  return V.decode = (J, ee) => !!$(J, ee), V.encode = (J, ee, te) => {
    const re = Number(J);
    return T(re, ee, te);
  }, V;
}, publicKey$3 = (C) => {
  const e = blob$1(32, C), { encode: T, decode: $ } = encodeDecode(e), V = e;
  return V.decode = (J, ee) => {
    const te = $(J, ee);
    return new PublicKey(te);
  }, V.encode = (J, ee, te) => {
    const re = J.toBuffer();
    return T(re, ee, te);
  }, V;
};
let TokenError$1 = class extends Error {
  constructor(e) {
    super(e);
  }
}, TokenAccountNotFoundError$1 = class extends TokenError$1 {
  constructor() {
    super(...arguments), this.name = "TokenAccountNotFoundError";
  }
};
class TokenInvalidAccountError extends TokenError$1 {
  constructor() {
    super(...arguments), this.name = "TokenInvalidAccountError";
  }
}
let TokenInvalidAccountOwnerError$1 = class extends TokenError$1 {
  constructor() {
    super(...arguments), this.name = "TokenInvalidAccountOwnerError";
  }
}, TokenInvalidAccountSizeError$1 = class extends TokenError$1 {
  constructor() {
    super(...arguments), this.name = "TokenInvalidAccountSizeError";
  }
}, TokenOwnerOffCurveError$1 = class extends TokenError$1 {
  constructor() {
    super(...arguments), this.name = "TokenOwnerOffCurveError";
  }
};
var AccountType$1;
(function(C) {
  C[C.Uninitialized = 0] = "Uninitialized", C[C.Mint = 1] = "Mint", C[C.Account = 2] = "Account";
})(AccountType$1 || (AccountType$1 = {}));
const ACCOUNT_TYPE_SIZE$1 = 1, MultisigLayout$1 = struct$1([
  u8$1("m"),
  u8$1("n"),
  bool("isInitialized"),
  publicKey$3("signer1"),
  publicKey$3("signer2"),
  publicKey$3("signer3"),
  publicKey$3("signer4"),
  publicKey$3("signer5"),
  publicKey$3("signer6"),
  publicKey$3("signer7"),
  publicKey$3("signer8"),
  publicKey$3("signer9"),
  publicKey$3("signer10"),
  publicKey$3("signer11")
]), MULTISIG_SIZE$1 = MultisigLayout$1.span;
var AccountState$1;
(function(C) {
  C[C.Uninitialized = 0] = "Uninitialized", C[C.Initialized = 1] = "Initialized", C[C.Frozen = 2] = "Frozen";
})(AccountState$1 || (AccountState$1 = {}));
const AccountLayout$1 = struct$1([
  publicKey$3("mint"),
  publicKey$3("owner"),
  u64$1("amount"),
  u32$1("delegateOption"),
  publicKey$3("delegate"),
  u8$1("state"),
  u32$1("isNativeOption"),
  u64$1("isNative"),
  u64$1("delegatedAmount"),
  u32$1("closeAuthorityOption"),
  publicKey$3("closeAuthority")
]), ACCOUNT_SIZE$1 = AccountLayout$1.span;
async function getAccount(C, e, T, $ = TOKEN_PROGRAM_ID$3) {
  const V = await C.getAccountInfo(e, T);
  return unpackAccount(e, V, $);
}
function unpackAccount(C, e, T = TOKEN_PROGRAM_ID$3) {
  if (!e)
    throw new TokenAccountNotFoundError$1();
  if (!e.owner.equals(T))
    throw new TokenInvalidAccountOwnerError$1();
  if (e.data.length < ACCOUNT_SIZE$1)
    throw new TokenInvalidAccountSizeError$1();
  const $ = AccountLayout$1.decode(e.data.slice(0, ACCOUNT_SIZE$1));
  let V = dist$2.Buffer.alloc(0);
  if (e.data.length > ACCOUNT_SIZE$1) {
    if (e.data.length === MULTISIG_SIZE$1)
      throw new TokenInvalidAccountSizeError$1();
    if (e.data[ACCOUNT_SIZE$1] != AccountType$1.Account)
      throw new TokenInvalidAccountError();
    V = e.data.slice(ACCOUNT_SIZE$1 + ACCOUNT_TYPE_SIZE$1);
  }
  return {
    address: C,
    mint: $.mint,
    owner: $.owner,
    amount: $.amount,
    delegate: $.delegateOption ? $.delegate : null,
    delegatedAmount: $.delegatedAmount,
    isInitialized: $.state !== AccountState$1.Uninitialized,
    isFrozen: $.state === AccountState$1.Frozen,
    isNative: !!$.isNativeOption,
    rentExemptReserve: $.isNativeOption ? $.isNative : null,
    closeAuthority: $.closeAuthorityOption ? $.closeAuthority : null,
    tlvData: V
  };
}
const MintLayout$1 = struct$1([
  u32$1("mintAuthorityOption"),
  publicKey$3("mintAuthority"),
  u64$1("supply"),
  u8$1("decimals"),
  bool("isInitialized"),
  u32$1("freezeAuthorityOption"),
  publicKey$3("freezeAuthority")
]);
MintLayout$1.span;
function getAssociatedTokenAddressSync$1(C, e, T = !1, $ = TOKEN_PROGRAM_ID$3, V = ASSOCIATED_TOKEN_PROGRAM_ID$2) {
  if (!T && !PublicKey.isOnCurve(e.toBuffer()))
    throw new TokenOwnerOffCurveError$1();
  const [J] = PublicKey.findProgramAddressSync([e.toBuffer(), $.toBuffer(), C.toBuffer()], V);
  return J;
}
function base$1(C) {
  if (C.length >= 255)
    throw new TypeError("Alphabet too long");
  for (var e = new Uint8Array(256), T = 0; T < e.length; T++)
    e[T] = 255;
  for (var $ = 0; $ < C.length; $++) {
    var V = C.charAt($), J = V.charCodeAt(0);
    if (e[J] !== 255)
      throw new TypeError(V + " is ambiguous");
    e[J] = $;
  }
  var ee = C.length, te = C.charAt(0), re = Math.log(ee) / Math.log(256), ie = Math.log(256) / Math.log(ee);
  function se(fe) {
    if (fe instanceof Uint8Array || (ArrayBuffer.isView(fe) ? fe = new Uint8Array(fe.buffer, fe.byteOffset, fe.byteLength) : Array.isArray(fe) && (fe = Uint8Array.from(fe))), !(fe instanceof Uint8Array))
      throw new TypeError("Expected Uint8Array");
    if (fe.length === 0)
      return "";
    for (var he = 0, me = 0, xe = 0, ve = fe.length; xe !== ve && fe[xe] === 0; )
      xe++, he++;
    for (var Te = (ve - xe) * ie + 1 >>> 0, we = new Uint8Array(Te); xe !== ve; ) {
      for (var Ee = fe[xe], Me = 0, Ie = Te - 1; (Ee !== 0 || Me < me) && Ie !== -1; Ie--, Me++)
        Ee += 256 * we[Ie] >>> 0, we[Ie] = Ee % ee >>> 0, Ee = Ee / ee >>> 0;
      if (Ee !== 0)
        throw new Error("Non-zero carry");
      me = Me, xe++;
    }
    for (var ke = Te - me; ke !== Te && we[ke] === 0; )
      ke++;
    for (var _e = te.repeat(he); ke < Te; ++ke)
      _e += C.charAt(we[ke]);
    return _e;
  }
  function de(fe) {
    if (typeof fe != "string")
      throw new TypeError("Expected String");
    if (fe.length === 0)
      return new Uint8Array();
    for (var he = 0, me = 0, xe = 0; fe[he] === te; )
      me++, he++;
    for (var ve = (fe.length - he) * re + 1 >>> 0, Te = new Uint8Array(ve); fe[he]; ) {
      var we = e[fe.charCodeAt(he)];
      if (we === 255)
        return;
      for (var Ee = 0, Me = ve - 1; (we !== 0 || Ee < xe) && Me !== -1; Me--, Ee++)
        we += ee * Te[Me] >>> 0, Te[Me] = we % 256 >>> 0, we = we / 256 >>> 0;
      if (we !== 0)
        throw new Error("Non-zero carry");
      xe = Ee, he++;
    }
    for (var Ie = ve - xe; Ie !== ve && Te[Ie] === 0; )
      Ie++;
    for (var ke = new Uint8Array(me + (ve - Ie)), _e = me; Ie !== ve; )
      ke[_e++] = Te[Ie++];
    return ke;
  }
  function ue(fe) {
    var he = de(fe);
    if (he)
      return he;
    throw new Error("Non-base" + ee + " character");
  }
  return {
    encode: se,
    decodeUnsafe: de,
    decode: ue
  };
}
var src = base$1;
const basex = src, ALPHABET = "123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz";
var bs58$1 = basex(ALPHABET);
const bs58$2 = /* @__PURE__ */ getDefaultExportFromCjs$2(bs58$1);
function b64ToUint6(C) {
  return C > 64 && C < 91 ? C - 65 : C > 96 && C < 123 ? C - 71 : C > 47 && C < 58 ? C + 4 : C === 43 ? 62 : C === 47 ? 63 : 0;
}
function fromB64(C, e) {
  for (var T = C.replace(/[^A-Za-z0-9+/]/g, ""), $ = T.length, V = $ * 3 + 1 >> 2, J = new Uint8Array(V), ee, te, re = 0, ie = 0, se = 0; se < $; se++)
    if (te = se & 3, re |= b64ToUint6(T.charCodeAt(se)) << 6 * (3 - te), te === 3 || $ - se === 1) {
      for (ee = 0; ee < 3 && ie < V; ee++, ie++)
        J[ie] = re >>> (16 >>> ee & 24) & 255;
      re = 0;
    }
  return J;
}
function uint6ToB64(C) {
  return C < 26 ? C + 65 : C < 52 ? C + 71 : C < 62 ? C - 4 : C === 62 ? 43 : C === 63 ? 47 : 65;
}
function toB64(C) {
  for (var e = 2, T = "", $ = C.length, V = 0, J = 0; J < $; J++)
    e = J % 3, J > 0 && J * 4 / 3 % 76 === 0 && (T += ""), V |= C[J] << (16 >>> e & 24), (e === 2 || C.length - J === 1) && (T += String.fromCodePoint(
      uint6ToB64(V >>> 18 & 63),
      uint6ToB64(V >>> 12 & 63),
      uint6ToB64(V >>> 6 & 63),
      uint6ToB64(V & 63)
    ), V = 0);
  return T.slice(0, T.length - 2 + e) + (e === 2 ? "" : e === 1 ? "=" : "==");
}
function fromHEX(C) {
  let e = C.replace("0x", "").match(/.{1,2}/g).map((T) => parseInt(T, 16));
  if (e === null)
    throw new Error(`Unable to parse HEX: ${C}`);
  return Uint8Array.from(e);
}
function toHEX(C) {
  return C.reduce(
    (e, T) => e + T.toString(16).padStart(2, "0"),
    ""
  );
}
var SUI_ADDRESS_LENGTH$1 = 32;
function toLittleEndian(C, e) {
  let T = new Uint8Array(e), $ = 0;
  for (; C > 0; )
    T[$] = Number(C % BigInt(256)), C = C / BigInt(256), $ += 1;
  return T;
}
var toB58 = (C) => bs58$2.encode(C), fromB58 = (C) => bs58$2.decode(C), BcsReader = class {
  /**
   * @param {Uint8Array} data Data to use as a buffer.
   */
  constructor(C) {
    this.bytePosition = 0, this.dataView = new DataView(C.buffer);
  }
  /**
   * Shift current cursor position by `bytes`.
   *
   * @param {Number} bytes Number of bytes to
   * @returns {this} Self for possible chaining.
   */
  shift(C) {
    return this.bytePosition += C, this;
  }
  /**
   * Read U8 value from the buffer and shift cursor by 1.
   * @returns
   */
  read8() {
    let C = this.dataView.getUint8(this.bytePosition);
    return this.shift(1), C;
  }
  /**
   * Read U16 value from the buffer and shift cursor by 2.
   * @returns
   */
  read16() {
    let C = this.dataView.getUint16(this.bytePosition, !0);
    return this.shift(2), C;
  }
  /**
   * Read U32 value from the buffer and shift cursor by 4.
   * @returns
   */
  read32() {
    let C = this.dataView.getUint32(this.bytePosition, !0);
    return this.shift(4), C;
  }
  /**
   * Read U64 value from the buffer and shift cursor by 8.
   * @returns
   */
  read64() {
    let C = this.read32(), T = this.read32().toString(16) + C.toString(16).padStart(8, "0");
    return BigInt("0x" + T).toString(10);
  }
  /**
   * Read U128 value from the buffer and shift cursor by 16.
   */
  read128() {
    let C = BigInt(this.read64()), T = BigInt(this.read64()).toString(16) + C.toString(16).padStart(8, "0");
    return BigInt("0x" + T).toString(10);
  }
  /**
   * Read U128 value from the buffer and shift cursor by 32.
   * @returns
   */
  read256() {
    let C = BigInt(this.read128()), T = BigInt(this.read128()).toString(16) + C.toString(16).padStart(16, "0");
    return BigInt("0x" + T).toString(10);
  }
  /**
   * Read `num` number of bytes from the buffer and shift cursor by `num`.
   * @param num Number of bytes to read.
   */
  readBytes(C) {
    let e = this.bytePosition + this.dataView.byteOffset, T = new Uint8Array(this.dataView.buffer, e, C);
    return this.shift(C), T;
  }
  /**
   * Read ULEB value - an integer of varying size. Used for enum indexes and
   * vector lengths.
   * @returns {Number} The ULEB value.
   */
  readULEB() {
    let C = this.bytePosition + this.dataView.byteOffset, e = new Uint8Array(this.dataView.buffer, C), { value: T, length: $ } = ulebDecode(e);
    return this.shift($), T;
  }
  /**
   * Read a BCS vector: read a length and then apply function `cb` X times
   * where X is the length of the vector, defined as ULEB in BCS bytes.
   * @param cb Callback to process elements of vector.
   * @returns {Array<Any>} Array of the resulting values, returned by callback.
   */
  readVec(C) {
    let e = this.readULEB(), T = [];
    for (let $ = 0; $ < e; $++)
      T.push(C(this, $, e));
    return T;
  }
}, BcsWriter = class {
  constructor({
    size: C = 1024,
    maxSize: e,
    allocateSize: T = 1024
  } = {}) {
    this.bytePosition = 0, this.size = C, this.maxSize = e || C, this.allocateSize = T, this.dataView = new DataView(new ArrayBuffer(C));
  }
  ensureSizeOrGrow(C) {
    const e = this.bytePosition + C;
    if (e > this.size) {
      const T = Math.min(this.maxSize, this.size + this.allocateSize);
      if (e > T)
        throw new Error(
          `Attempting to serialize to BCS, but buffer does not have enough size. Allocated size: ${this.size}, Max size: ${this.maxSize}, Required size: ${e}`
        );
      this.size = T;
      const $ = new ArrayBuffer(this.size);
      new Uint8Array($).set(new Uint8Array(this.dataView.buffer)), this.dataView = new DataView($);
    }
  }
  /**
   * Shift current cursor position by `bytes`.
   *
   * @param {Number} bytes Number of bytes to
   * @returns {this} Self for possible chaining.
   */
  shift(C) {
    return this.bytePosition += C, this;
  }
  /**
   * Write a U8 value into a buffer and shift cursor position by 1.
   * @param {Number} value Value to write.
   * @returns {this}
   */
  write8(C) {
    return this.ensureSizeOrGrow(1), this.dataView.setUint8(this.bytePosition, Number(C)), this.shift(1);
  }
  /**
   * Write a U16 value into a buffer and shift cursor position by 2.
   * @param {Number} value Value to write.
   * @returns {this}
   */
  write16(C) {
    return this.ensureSizeOrGrow(2), this.dataView.setUint16(this.bytePosition, Number(C), !0), this.shift(2);
  }
  /**
   * Write a U32 value into a buffer and shift cursor position by 4.
   * @param {Number} value Value to write.
   * @returns {this}
   */
  write32(C) {
    return this.ensureSizeOrGrow(4), this.dataView.setUint32(this.bytePosition, Number(C), !0), this.shift(4);
  }
  /**
   * Write a U64 value into a buffer and shift cursor position by 8.
   * @param {bigint} value Value to write.
   * @returns {this}
   */
  write64(C) {
    return toLittleEndian(BigInt(C), 8).forEach((e) => this.write8(e)), this;
  }
  /**
   * Write a U128 value into a buffer and shift cursor position by 16.
   *
   * @param {bigint} value Value to write.
   * @returns {this}
   */
  write128(C) {
    return toLittleEndian(BigInt(C), 16).forEach((e) => this.write8(e)), this;
  }
  /**
   * Write a U256 value into a buffer and shift cursor position by 16.
   *
   * @param {bigint} value Value to write.
   * @returns {this}
   */
  write256(C) {
    return toLittleEndian(BigInt(C), 32).forEach((e) => this.write8(e)), this;
  }
  /**
   * Write a ULEB value into a buffer and shift cursor position by number of bytes
   * written.
   * @param {Number} value Value to write.
   * @returns {this}
   */
  writeULEB(C) {
    return ulebEncode(C).forEach((e) => this.write8(e)), this;
  }
  /**
   * Write a vector into a buffer by first writing the vector length and then calling
   * a callback on each passed value.
   *
   * @param {Array<Any>} vector Array of elements to write.
   * @param {WriteVecCb} cb Callback to call on each element of the vector.
   * @returns {this}
   */
  writeVec(C, e) {
    return this.writeULEB(C.length), Array.from(C).forEach((T, $) => e(this, T, $, C.length)), this;
  }
  /**
   * Adds support for iterations over the object.
   * @returns {Uint8Array}
   */
  *[Symbol.iterator]() {
    for (let C = 0; C < this.bytePosition; C++)
      yield this.dataView.getUint8(C);
    return this.toBytes();
  }
  /**
   * Get underlying buffer taking only value bytes (in case initial buffer size was bigger).
   * @returns {Uint8Array} Resulting bcs.
   */
  toBytes() {
    return new Uint8Array(this.dataView.buffer.slice(0, this.bytePosition));
  }
  /**
   * Represent data as 'hex' or 'base64'
   * @param encoding Encoding to use: 'base64' or 'hex'
   */
  toString(C) {
    return encodeStr(this.toBytes(), C);
  }
};
function ulebEncode(C) {
  let e = [], T = 0;
  if (C === 0)
    return [0];
  for (; C > 0; )
    e[T] = C & 127, (C >>= 7) && (e[T] |= 128), T += 1;
  return e;
}
function ulebDecode(C) {
  let e = 0, T = 0, $ = 0;
  for (; ; ) {
    let V = C[$];
    if ($ += 1, e |= (V & 127) << T, !(V & 128))
      break;
    T += 7;
  }
  return {
    value: e,
    length: $
  };
}
var _BCS = class {
  /**
   * Construct a BCS instance with a prepared schema.
   *
   * @param schema A prepared schema with type definitions
   * @param withPrimitives Whether to register primitive types by default
   */
  constructor(C) {
    if (this.types = /* @__PURE__ */ new Map(), this.counter = 0, C instanceof _BCS) {
      this.schema = C.schema, this.types = new Map(C.types);
      return;
    }
    if (this.schema = C, this.registerAddressType(
      _BCS.ADDRESS,
      C.addressLength,
      C.addressEncoding
    ), this.registerVectorType(C.vectorType), C.types && C.types.structs)
      for (let e of Object.keys(C.types.structs))
        this.registerStructType(e, C.types.structs[e]);
    if (C.types && C.types.enums)
      for (let e of Object.keys(C.types.enums))
        this.registerEnumType(e, C.types.enums[e]);
    if (C.types && C.types.aliases)
      for (let e of Object.keys(C.types.aliases))
        this.registerAlias(e, C.types.aliases[e]);
    C.withPrimitives !== !1 && registerPrimitives(this);
  }
  /**
   * Name of the key to use for temporary struct definitions.
   * Returns a temp key + index (for a case when multiple temp
   * structs are processed).
   */
  tempKey() {
    return `bcs-struct-${++this.counter}`;
  }
  /**
   * Serialize data into bcs.
   *
   * @example
   * bcs.registerVectorType('vector<u8>', 'u8');
   *
   * let serialized = BCS
   *   .set('vector<u8>', [1,2,3,4,5,6])
   *   .toBytes();
   *
   * console.assert(toHex(serialized) === '06010203040506');
   *
   * @param type Name of the type to serialize (must be registered) or a struct type.
   * @param data Data to serialize.
   * @param size Serialization buffer size. Default 1024 = 1KB.
   * @return A BCS reader instance. Usually you'd want to call `.toBytes()`
   */
  ser(C, e, T) {
    if (typeof C == "string" || Array.isArray(C)) {
      const { name: $, params: V } = this.parseTypeName(C);
      return this.getTypeInterface($).encode(
        this,
        e,
        T,
        V
      );
    }
    if (typeof C == "object") {
      const $ = this.tempKey();
      return new _BCS(this).registerStructType($, C).ser($, e, T);
    }
    throw new Error(
      `Incorrect type passed into the '.ser()' function. 
${JSON.stringify(
        C
      )}`
    );
  }
  /**
   * Deserialize BCS into a JS type.
   *
   * @example
   * let num = bcs.ser('u64', '4294967295').toString('hex');
   * let deNum = bcs.de('u64', num, 'hex');
   * console.assert(deNum.toString(10) === '4294967295');
   *
   * @param type Name of the type to deserialize (must be registered) or a struct type definition.
   * @param data Data to deserialize.
   * @param encoding Optional - encoding to use if data is of type String
   * @return Deserialized data.
   */
  de(C, e, T) {
    if (typeof e == "string")
      if (T)
        e = decodeStr(e, T);
      else
        throw new Error("To pass a string to `bcs.de`, specify encoding");
    if (typeof C == "string" || Array.isArray(C)) {
      const { name: $, params: V } = this.parseTypeName(C);
      return this.getTypeInterface($).decode(this, e, V);
    }
    if (typeof C == "object") {
      const $ = new _BCS(this), V = this.tempKey();
      return $.registerStructType(V, C).de(V, e, T);
    }
    throw new Error(
      `Incorrect type passed into the '.de()' function. 
${JSON.stringify(
        C
      )}`
    );
  }
  /**
   * Check whether a `TypeInterface` has been loaded for a `type`.
   * @param type Name of the type to check.
   * @returns
   */
  hasType(C) {
    return this.types.has(C);
  }
  /**
   * Create an alias for a type.
   * WARNING: this can potentially lead to recursion
   * @param name Alias to use
   * @param forType Type to reference
   * @returns
   *
   * @example
   * ```
   * let bcs = new BCS(getSuiMoveConfig());
   * bcs.registerAlias('ObjectDigest', BCS.BASE58);
   * let b58_digest = bcs.de('ObjectDigest', '<digest_bytes>', 'base64');
   * ```
   */
  registerAlias(C, e) {
    return this.types.set(C, e), this;
  }
  /**
   * Method to register new types for BCS internal representation.
   * For each registered type 2 callbacks must be specified and one is optional:
   *
   * - encodeCb(writer, data) - write a way to serialize data with BcsWriter;
   * - decodeCb(reader) - write a way to deserialize data with BcsReader;
   * - validateCb(data) - validate data - either return bool or throw an error
   *
   * @example
   * // our type would be a string that consists only of numbers
   * bcs.registerType('number_string',
   *    (writer, data) => writer.writeVec(data, (w, el) => w.write8(el)),
   *    (reader) => reader.readVec((r) => r.read8()).join(''), // read each value as u8
   *    (value) => /[0-9]+/.test(value) // test that it has at least one digit
   * );
   * console.log(Array.from(bcs.ser('number_string', '12345').toBytes()) == [5,1,2,3,4,5]);
   *
   * @param name
   * @param encodeCb Callback to encode a value.
   * @param decodeCb Callback to decode a value.
   * @param validateCb Optional validator Callback to check type before serialization.
   */
  registerType(C, e, T, $ = () => !0) {
    const { name: V, params: J } = this.parseTypeName(C);
    return this.types.set(V, {
      encode(ee, te, re, ie) {
        const se = J.reduce(
          (de, ue, fe) => Object.assign(de, { [ue]: ie[fe] }),
          {}
        );
        return this._encodeRaw.call(
          ee,
          new BcsWriter(re),
          te,
          ie,
          se
        );
      },
      decode(ee, te, re) {
        const ie = J.reduce(
          (se, de, ue) => Object.assign(se, { [de]: re[ue] }),
          {}
        );
        return this._decodeRaw.call(
          ee,
          new BcsReader(te),
          re,
          ie
        );
      },
      // these methods should always be used with caution as they require pre-defined
      // reader and writer and mainly exist to allow multi-field (de)serialization;
      _encodeRaw(ee, te, re, ie) {
        if ($(te))
          return e.call(this, ee, te, re, ie);
        throw new Error(`Validation failed for type ${V}, data: ${te}`);
      },
      _decodeRaw(ee, te, re) {
        return T.call(this, ee, te, re);
      }
    }), this;
  }
  /**
   * Register an address type which is a sequence of U8s of specified length.
   * @example
   * bcs.registerAddressType('address', SUI_ADDRESS_LENGTH);
   * let addr = bcs.de('address', 'c3aca510c785c7094ac99aeaa1e69d493122444df50bb8a99dfa790c654a79af');
   *
   * @param name Name of the address type.
   * @param length Byte length of the address.
   * @param encoding Encoding to use for the address type
   * @returns
   */
  registerAddressType(C, e, T = "hex") {
    switch (T) {
      case "base64":
        return this.registerType(
          C,
          function(V, J) {
            return fromB64(J).reduce(
              (ee, te) => ee.write8(te),
              V
            );
          },
          function(V) {
            return toB64(V.readBytes(e));
          }
        );
      case "hex":
        return this.registerType(
          C,
          function(V, J) {
            return fromHEX(J).reduce(
              (ee, te) => ee.write8(te),
              V
            );
          },
          function(V) {
            return toHEX(V.readBytes(e));
          }
        );
      default:
        throw new Error("Unsupported encoding! Use either hex or base64");
    }
  }
  /**
   * Register custom vector type inside the bcs.
   *
   * @example
   * bcs.registerVectorType('vector<T>'); // generic registration
   * let array = bcs.de('vector<u8>', '06010203040506', 'hex'); // [1,2,3,4,5,6];
   * let again = bcs.ser('vector<u8>', [1,2,3,4,5,6]).toString('hex');
   *
   * @param name Name of the type to register
   * @param elementType Optional name of the inner type of the vector
   * @return Returns self for chaining.
   */
  registerVectorType(C) {
    let { name: e, params: T } = this.parseTypeName(C);
    if (T.length > 1)
      throw new Error("Vector can have only one type parameter; got " + e);
    return this.registerType(
      C,
      function(V, J, ee, te) {
        return V.writeVec(J, (re, ie) => {
          let se = ee[0];
          if (!se)
            throw new Error(
              `Incorrect number of type parameters passed a to vector '${C}'`
            );
          let { name: de, params: ue } = this.parseTypeName(se);
          if (this.hasType(de))
            return this.getTypeInterface(de)._encodeRaw.call(
              this,
              re,
              ie,
              ue,
              te
            );
          if (!(de in te))
            throw new Error(
              `Unable to find a matching type definition for ${de} in vector; make sure you passed a generic`
            );
          let { name: fe, params: he } = this.parseTypeName(
            te[de]
          );
          return this.getTypeInterface(fe)._encodeRaw.call(
            this,
            re,
            ie,
            he,
            te
          );
        });
      },
      function(V, J, ee) {
        return V.readVec((te) => {
          let re = J[0];
          if (!re)
            throw new Error(
              `Incorrect number of type parameters passed to a vector '${C}'`
            );
          let { name: ie, params: se } = this.parseTypeName(re);
          if (this.hasType(ie))
            return this.getTypeInterface(ie)._decodeRaw.call(
              this,
              te,
              se,
              ee
            );
          if (!(ie in ee))
            throw new Error(
              `Unable to find a matching type definition for ${ie} in vector; make sure you passed a generic`
            );
          let { name: de, params: ue } = this.parseTypeName(
            ee[ie]
          );
          this.getTypeInterface(de)._decodeRaw.call(
            this,
            te,
            ue,
            ee
          );
        });
      }
    );
  }
  /**
   * Safe method to register a custom Move struct. The first argument is a name of the
   * struct which is only used on the FrontEnd and has no affect on serialization results,
   * and the second is a struct description passed as an Object.
   *
   * The description object MUST have the same order on all of the platforms (ie in Move
   * or in Rust).
   *
   * @example
   * // Move / Rust struct
   * // struct Coin {
   * //   value: u64,
   * //   owner: vector<u8>, // name // Vec<u8> in Rust
   * //   is_locked: bool,
   * // }
   *
   * bcs.registerStructType('Coin', {
   *   value: bcs.U64,
   *   owner: bcs.STRING,
   *   is_locked: bcs.BOOL
   * });
   *
   * // Created in Rust with diem/bcs
   * // let rust_bcs_str = '80d1b105600000000e4269672057616c6c65742047757900';
   * let rust_bcs_str = [ // using an Array here as BCS works with Uint8Array
   *  128, 209, 177,   5,  96,  0,  0,
   *    0,  14,  66, 105, 103, 32, 87,
   *   97, 108, 108, 101, 116, 32, 71,
   *  117, 121,   0
   * ];
   *
   * // Let's encode the value as well
   * let test_set = bcs.ser('Coin', {
   *   owner: 'Big Wallet Guy',
   *   value: '412412400000',
   *   is_locked: false,
   * });
   *
   * console.assert(Array.from(test_set.toBytes()) === rust_bcs_str, 'Whoopsie, result mismatch');
   *
   * @param name Name of the type to register.
   * @param fields Fields of the struct. Must be in the correct order.
   * @return Returns BCS for chaining.
   */
  registerStructType(C, e) {
    for (let ee in e) {
      let te = this.tempKey(), re = e[ee];
      !Array.isArray(re) && typeof re != "string" && (e[ee] = te, this.registerStructType(te, re));
    }
    let T = Object.freeze(e), $ = Object.keys(T), { name: V, params: J } = this.parseTypeName(C);
    return this.registerType(
      C,
      function(te, re, ie, se) {
        if (!re || re.constructor !== Object)
          throw new Error(
            `Expected ${V} to be an Object, got: ${re}`
          );
        if (ie.length !== J.length)
          throw new Error(
            `Incorrect number of generic parameters passed; expected: ${J.length}, got: ${ie.length}`
          );
        for (let de of $) {
          if (!(de in re))
            throw new Error(
              `Struct ${V} requires field ${de}:${T[de]}`
            );
          const { name: ue, params: fe } = this.parseTypeName(
            T[de]
          );
          if (!J.includes(ue))
            this.getTypeInterface(ue)._encodeRaw.call(
              this,
              te,
              re[de],
              fe,
              se
            );
          else {
            const he = J.indexOf(ue);
            let { name: me, params: xe } = this.parseTypeName(ie[he]);
            if (this.hasType(me)) {
              this.getTypeInterface(me)._encodeRaw.call(
                this,
                te,
                re[de],
                xe,
                se
              );
              continue;
            }
            if (!(me in se))
              throw new Error(
                `Unable to find a matching type definition for ${me} in ${V}; make sure you passed a generic`
              );
            let { name: ve, params: Te } = this.parseTypeName(
              se[me]
            );
            this.getTypeInterface(ve)._encodeRaw.call(
              this,
              te,
              re[de],
              Te,
              se
            );
          }
        }
        return te;
      },
      function(te, re, ie) {
        if (re.length !== J.length)
          throw new Error(
            `Incorrect number of generic parameters passed; expected: ${J.length}, got: ${re.length}`
          );
        let se = {};
        for (let de of $) {
          const { name: ue, params: fe } = this.parseTypeName(
            T[de]
          );
          if (!J.includes(ue))
            se[de] = this.getTypeInterface(ue)._decodeRaw.call(
              this,
              te,
              fe,
              ie
            );
          else {
            const he = J.indexOf(ue);
            let { name: me, params: xe } = this.parseTypeName(re[he]);
            if (this.hasType(me)) {
              se[de] = this.getTypeInterface(me)._decodeRaw.call(
                this,
                te,
                xe,
                ie
              );
              continue;
            }
            if (!(me in ie))
              throw new Error(
                `Unable to find a matching type definition for ${me} in ${V}; make sure you passed a generic`
              );
            let { name: ve, params: Te } = this.parseTypeName(
              ie[me]
            );
            se[de] = this.getTypeInterface(ve)._decodeRaw.call(
              this,
              te,
              Te,
              ie
            );
          }
        }
        return se;
      }
    );
  }
  /**
   * Safe method to register custom enum type where each invariant holds the value of another type.
   * @example
   * bcs.registerStructType('Coin', { value: 'u64' });
   * bcs.registerEnumType('MyEnum', {
   *  single: 'Coin',
   *  multi: 'vector<Coin>',
   *  empty: null
   * });
   *
   * console.log(
   *  bcs.de('MyEnum', 'AICWmAAAAAAA', 'base64'), // { single: { value: 10000000 } }
   *  bcs.de('MyEnum', 'AQIBAAAAAAAAAAIAAAAAAAAA', 'base64')  // { multi: [ { value: 1 }, { value: 2 } ] }
   * )
   *
   * // and serialization
   * bcs.ser('MyEnum', { single: { value: 10000000 } }).toBytes();
   * bcs.ser('MyEnum', { multi: [ { value: 1 }, { value: 2 } ] });
   *
   * @param name
   * @param variants
   */
  registerEnumType(C, e) {
    for (let ee in e) {
      let te = this.tempKey(), re = e[ee];
      re !== null && !Array.isArray(re) && typeof re != "string" && (e[ee] = te, this.registerStructType(te, re));
    }
    let T = Object.freeze(e), $ = Object.keys(T), { name: V, params: J } = this.parseTypeName(C);
    return this.registerType(
      C,
      function(te, re, ie, se) {
        if (!re)
          throw new Error(
            `Unable to write enum "${V}", missing data.
Received: "${re}"`
          );
        if (typeof re != "object")
          throw new Error(
            `Incorrect data passed into enum "${V}", expected object with properties: "${$.join(
              " | "
            )}".
Received: "${JSON.stringify(re)}"`
          );
        let de = Object.keys(re)[0];
        if (de === void 0)
          throw new Error(
            `Empty object passed as invariant of the enum "${V}"`
          );
        let ue = $.indexOf(de);
        if (ue === -1)
          throw new Error(
            `Unknown invariant of the enum "${V}", allowed values: "${$.join(
              " | "
            )}"; received "${de}"`
          );
        let fe = $[ue], he = T[fe];
        if (te.write8(ue), he === null)
          return te;
        let me = J.indexOf(he), xe = me === -1 ? he : ie[me];
        {
          let { name: ve, params: Te } = this.parseTypeName(xe);
          return this.getTypeInterface(ve)._encodeRaw.call(
            this,
            te,
            re[de],
            Te,
            se
          );
        }
      },
      function(te, re, ie) {
        let se = te.readULEB(), de = $[se], ue = T[de];
        if (se === -1)
          throw new Error(
            `Decoding type mismatch, expected enum "${V}" invariant index, received "${se}"`
          );
        if (ue === null)
          return { [de]: !0 };
        let fe = J.indexOf(ue), he = fe === -1 ? ue : re[fe];
        {
          let { name: me, params: xe } = this.parseTypeName(he);
          return {
            [de]: this.getTypeInterface(me)._decodeRaw.call(
              this,
              te,
              xe,
              ie
            )
          };
        }
      }
    );
  }
  /**
   * Get a set of encoders/decoders for specific type.
   * Mainly used to define custom type de/serialization logic.
   *
   * @param type
   * @returns {TypeInterface}
   */
  getTypeInterface(C) {
    let e = this.types.get(C);
    if (typeof e == "string") {
      let T = [];
      for (; typeof e == "string"; ) {
        if (T.includes(e))
          throw new Error(
            `Recursive definition found: ${T.join(
              " -> "
            )} -> ${e}`
          );
        T.push(e), e = this.types.get(e);
      }
    }
    if (e === void 0)
      throw new Error(`Type ${C} is not registered`);
    return e;
  }
  /**
   * Parse a type name and get the type's generics.
   * @example
   * let { typeName, typeParams } = parseTypeName('Option<Coin<SUI>>');
   * // typeName: Option
   * // typeParams: [ 'Coin<SUI>' ]
   *
   * @param name Name of the type to process
   * @returns Object with typeName and typeParams listed as Array
   */
  parseTypeName(C) {
    if (Array.isArray(C)) {
      let [te, ...re] = C;
      return { name: te, params: re };
    }
    if (typeof C != "string")
      throw new Error(`Illegal type passed as a name of the type: ${C}`);
    let [e, T] = this.schema.genericSeparators || ["<", ">"], $ = C.indexOf(e), V = Array.from(C).reverse().indexOf(T);
    if ($ === -1 && V === -1)
      return { name: C, params: [] };
    if ($ === -1 || V === -1)
      throw new Error(`Unclosed generic in name '${C}'`);
    let J = C.slice(0, $), ee = C.slice($ + 1, C.length - V - 1).split(",").map((te) => te.trim());
    return { name: J, params: ee };
  }
}, BCS = _BCS;
BCS.U8 = "u8";
BCS.U16 = "u16";
BCS.U32 = "u32";
BCS.U64 = "u64";
BCS.U128 = "u128";
BCS.U256 = "u256";
BCS.BOOL = "bool";
BCS.VECTOR = "vector";
BCS.ADDRESS = "address";
BCS.STRING = "string";
BCS.HEX = "hex-string";
BCS.BASE58 = "base58-string";
BCS.BASE64 = "base64-string";
function encodeStr(C, e) {
  switch (e) {
    case "base58":
      return toB58(C);
    case "base64":
      return toB64(C);
    case "hex":
      return toHEX(C);
    default:
      throw new Error(
        "Unsupported encoding, supported values are: base64, hex"
      );
  }
}
function decodeStr(C, e) {
  switch (e) {
    case "base58":
      return fromB58(C);
    case "base64":
      return fromB64(C);
    case "hex":
      return fromHEX(C);
    default:
      throw new Error(
        "Unsupported encoding, supported values are: base64, hex"
      );
  }
}
function registerPrimitives(C) {
  C.registerType(
    BCS.U8,
    function(e, T) {
      return e.write8(T);
    },
    function(e) {
      return e.read8();
    },
    (e) => e < 256
  ), C.registerType(
    BCS.U16,
    function(e, T) {
      return e.write16(T);
    },
    function(e) {
      return e.read16();
    },
    (e) => e < 65536
  ), C.registerType(
    BCS.U32,
    function(e, T) {
      return e.write32(T);
    },
    function(e) {
      return e.read32();
    },
    (e) => e <= 4294967296n
  ), C.registerType(
    BCS.U64,
    function(e, T) {
      return e.write64(T);
    },
    function(e) {
      return e.read64();
    }
  ), C.registerType(
    BCS.U128,
    function(e, T) {
      return e.write128(T);
    },
    function(e) {
      return e.read128();
    }
  ), C.registerType(
    BCS.U256,
    function(e, T) {
      return e.write256(T);
    },
    function(e) {
      return e.read256();
    }
  ), C.registerType(
    BCS.BOOL,
    function(e, T) {
      return e.write8(T);
    },
    function(e) {
      return e.read8().toString(10) === "1";
    }
  ), C.registerType(
    BCS.STRING,
    function(e, T) {
      return e.writeVec(
        Array.from(T),
        ($, V) => $.write8(V.charCodeAt(0))
      );
    },
    function(e) {
      return e.readVec((T) => T.read8()).map((T) => String.fromCharCode(Number(T))).join("");
    },
    (e) => !0
  ), C.registerType(
    BCS.HEX,
    function(e, T) {
      return e.writeVec(
        Array.from(fromHEX(T)),
        ($, V) => $.write8(V)
      );
    },
    function(e) {
      let T = e.readVec(($) => $.read8());
      return toHEX(new Uint8Array(T));
    }
  ), C.registerType(
    BCS.BASE58,
    function(e, T) {
      return e.writeVec(
        Array.from(fromB58(T)),
        ($, V) => $.write8(V)
      );
    },
    function(e) {
      let T = e.readVec(($) => $.read8());
      return toB58(new Uint8Array(T));
    }
  ), C.registerType(
    BCS.BASE64,
    function(e, T) {
      return e.writeVec(
        Array.from(fromB64(T)),
        ($, V) => $.write8(V)
      );
    },
    function(e) {
      let T = e.readVec(($) => $.read8());
      return toB64(new Uint8Array(T));
    }
  );
}
function getSuiMoveConfig() {
  return {
    genericSeparators: ["<", ">"],
    vectorType: "vector",
    addressLength: SUI_ADDRESS_LENGTH$1,
    addressEncoding: "hex"
  };
}
const SIGMA = /* @__PURE__ */ new Uint8Array([
  0,
  1,
  2,
  3,
  4,
  5,
  6,
  7,
  8,
  9,
  10,
  11,
  12,
  13,
  14,
  15,
  14,
  10,
  4,
  8,
  9,
  15,
  13,
  6,
  1,
  12,
  0,
  2,
  11,
  7,
  5,
  3,
  11,
  8,
  12,
  0,
  5,
  2,
  15,
  13,
  10,
  14,
  3,
  6,
  7,
  1,
  9,
  4,
  7,
  9,
  3,
  1,
  13,
  12,
  11,
  14,
  2,
  6,
  5,
  10,
  4,
  0,
  15,
  8,
  9,
  0,
  5,
  7,
  2,
  4,
  10,
  15,
  14,
  1,
  11,
  12,
  6,
  8,
  3,
  13,
  2,
  12,
  6,
  10,
  0,
  11,
  8,
  3,
  4,
  13,
  7,
  5,
  15,
  14,
  1,
  9,
  12,
  5,
  1,
  15,
  14,
  13,
  4,
  10,
  0,
  7,
  6,
  3,
  9,
  2,
  8,
  11,
  13,
  11,
  7,
  14,
  12,
  1,
  3,
  9,
  5,
  0,
  15,
  4,
  8,
  6,
  2,
  10,
  6,
  15,
  14,
  9,
  11,
  3,
  0,
  8,
  12,
  2,
  13,
  7,
  1,
  4,
  10,
  5,
  10,
  2,
  8,
  4,
  7,
  6,
  1,
  5,
  15,
  11,
  9,
  14,
  3,
  12,
  13,
  0,
  0,
  1,
  2,
  3,
  4,
  5,
  6,
  7,
  8,
  9,
  10,
  11,
  12,
  13,
  14,
  15,
  14,
  10,
  4,
  8,
  9,
  15,
  13,
  6,
  1,
  12,
  0,
  2,
  11,
  7,
  5,
  3
]);
class BLAKE extends Hash$1 {
  constructor(e, T, $ = {}, V, J, ee) {
    if (super(), this.blockLen = e, this.outputLen = T, this.length = 0, this.pos = 0, this.finished = !1, this.destroyed = !1, anumber$1(e), anumber$1(T), anumber$1(V), T < 0 || T > V)
      throw new Error("outputLen bigger than keyLen");
    if ($.key !== void 0 && ($.key.length < 1 || $.key.length > V))
      throw new Error("key length must be undefined or 1.." + V);
    if ($.salt !== void 0 && $.salt.length !== J)
      throw new Error("salt must be undefined or " + J);
    if ($.personalization !== void 0 && $.personalization.length !== ee)
      throw new Error("personalization must be undefined or " + ee);
    this.buffer = new Uint8Array(e), this.buffer32 = u32$2(this.buffer);
  }
  update(e) {
    aexists$1(this);
    const { blockLen: T, buffer: $, buffer32: V } = this;
    e = toBytes$2(e);
    const J = e.length, ee = e.byteOffset, te = e.buffer;
    for (let re = 0; re < J; ) {
      this.pos === T && (isLE || byteSwap32(V), this.compress(V, 0, !1), isLE || byteSwap32(V), this.pos = 0);
      const ie = Math.min(T - this.pos, J - re), se = ee + re;
      if (ie === T && !(se % 4) && re + ie < J) {
        const de = new Uint32Array(te, se, Math.floor((J - re) / 4));
        isLE || byteSwap32(de);
        for (let ue = 0; re + T < J; ue += V.length, re += T)
          this.length += T, this.compress(de, ue, !1);
        isLE || byteSwap32(de);
        continue;
      }
      $.set(e.subarray(re, re + ie), this.pos), this.pos += ie, this.length += ie, re += ie;
    }
    return this;
  }
  digestInto(e) {
    aexists$1(this), aoutput$1(e, this);
    const { pos: T, buffer32: $ } = this;
    this.finished = !0, this.buffer.subarray(T).fill(0), isLE || byteSwap32($), this.compress($, 0, !0), isLE || byteSwap32($);
    const V = u32$2(e);
    this.get().forEach((J, ee) => V[ee] = byteSwapIfBE(J));
  }
  digest() {
    const { buffer: e, outputLen: T } = this;
    this.digestInto(e);
    const $ = e.slice(0, T);
    return this.destroy(), $;
  }
  _cloneInto(e) {
    const { buffer: T, length: $, finished: V, destroyed: J, outputLen: ee, pos: te } = this;
    return e || (e = new this.constructor({ dkLen: ee })), e.set(...this.get()), e.length = $, e.finished = V, e.destroyed = J, e.outputLen = ee, e.buffer.set(T), e.pos = te, e;
  }
}
const B2B_IV = /* @__PURE__ */ new Uint32Array([
  4089235720,
  1779033703,
  2227873595,
  3144134277,
  4271175723,
  1013904242,
  1595750129,
  2773480762,
  2917565137,
  1359893119,
  725511199,
  2600822924,
  4215389547,
  528734635,
  327033209,
  1541459225
]), BBUF = /* @__PURE__ */ new Uint32Array(32);
function G1b(C, e, T, $, V, J) {
  const ee = V[J], te = V[J + 1];
  let re = BBUF[2 * C], ie = BBUF[2 * C + 1], se = BBUF[2 * e], de = BBUF[2 * e + 1], ue = BBUF[2 * T], fe = BBUF[2 * T + 1], he = BBUF[2 * $], me = BBUF[2 * $ + 1], xe = u64$4.add3L(re, se, ee);
  ie = u64$4.add3H(xe, ie, de, te), re = xe | 0, { Dh: me, Dl: he } = { Dh: me ^ ie, Dl: he ^ re }, { Dh: me, Dl: he } = { Dh: u64$4.rotr32H(me, he), Dl: u64$4.rotr32L(me, he) }, { h: fe, l: ue } = u64$4.add(fe, ue, me, he), { Bh: de, Bl: se } = { Bh: de ^ fe, Bl: se ^ ue }, { Bh: de, Bl: se } = { Bh: u64$4.rotrSH(de, se, 24), Bl: u64$4.rotrSL(de, se, 24) }, BBUF[2 * C] = re, BBUF[2 * C + 1] = ie, BBUF[2 * e] = se, BBUF[2 * e + 1] = de, BBUF[2 * T] = ue, BBUF[2 * T + 1] = fe, BBUF[2 * $] = he, BBUF[2 * $ + 1] = me;
}
function G2b(C, e, T, $, V, J) {
  const ee = V[J], te = V[J + 1];
  let re = BBUF[2 * C], ie = BBUF[2 * C + 1], se = BBUF[2 * e], de = BBUF[2 * e + 1], ue = BBUF[2 * T], fe = BBUF[2 * T + 1], he = BBUF[2 * $], me = BBUF[2 * $ + 1], xe = u64$4.add3L(re, se, ee);
  ie = u64$4.add3H(xe, ie, de, te), re = xe | 0, { Dh: me, Dl: he } = { Dh: me ^ ie, Dl: he ^ re }, { Dh: me, Dl: he } = { Dh: u64$4.rotrSH(me, he, 16), Dl: u64$4.rotrSL(me, he, 16) }, { h: fe, l: ue } = u64$4.add(fe, ue, me, he), { Bh: de, Bl: se } = { Bh: de ^ fe, Bl: se ^ ue }, { Bh: de, Bl: se } = { Bh: u64$4.rotrBH(de, se, 63), Bl: u64$4.rotrBL(de, se, 63) }, BBUF[2 * C] = re, BBUF[2 * C + 1] = ie, BBUF[2 * e] = se, BBUF[2 * e + 1] = de, BBUF[2 * T] = ue, BBUF[2 * T + 1] = fe, BBUF[2 * $] = he, BBUF[2 * $ + 1] = me;
}
class BLAKE2b extends BLAKE {
  constructor(e = {}) {
    super(128, e.dkLen === void 0 ? 64 : e.dkLen, e, 64, 16, 16), this.v0l = B2B_IV[0] | 0, this.v0h = B2B_IV[1] | 0, this.v1l = B2B_IV[2] | 0, this.v1h = B2B_IV[3] | 0, this.v2l = B2B_IV[4] | 0, this.v2h = B2B_IV[5] | 0, this.v3l = B2B_IV[6] | 0, this.v3h = B2B_IV[7] | 0, this.v4l = B2B_IV[8] | 0, this.v4h = B2B_IV[9] | 0, this.v5l = B2B_IV[10] | 0, this.v5h = B2B_IV[11] | 0, this.v6l = B2B_IV[12] | 0, this.v6h = B2B_IV[13] | 0, this.v7l = B2B_IV[14] | 0, this.v7h = B2B_IV[15] | 0;
    const T = e.key ? e.key.length : 0;
    if (this.v0l ^= this.outputLen | T << 8 | 65536 | 1 << 24, e.salt) {
      const $ = u32$2(toBytes$2(e.salt));
      this.v4l ^= byteSwapIfBE($[0]), this.v4h ^= byteSwapIfBE($[1]), this.v5l ^= byteSwapIfBE($[2]), this.v5h ^= byteSwapIfBE($[3]);
    }
    if (e.personalization) {
      const $ = u32$2(toBytes$2(e.personalization));
      this.v6l ^= byteSwapIfBE($[0]), this.v6h ^= byteSwapIfBE($[1]), this.v7l ^= byteSwapIfBE($[2]), this.v7h ^= byteSwapIfBE($[3]);
    }
    if (e.key) {
      const $ = new Uint8Array(this.blockLen);
      $.set(toBytes$2(e.key)), this.update($);
    }
  }
  // prettier-ignore
  get() {
    let { v0l: e, v0h: T, v1l: $, v1h: V, v2l: J, v2h: ee, v3l: te, v3h: re, v4l: ie, v4h: se, v5l: de, v5h: ue, v6l: fe, v6h: he, v7l: me, v7h: xe } = this;
    return [e, T, $, V, J, ee, te, re, ie, se, de, ue, fe, he, me, xe];
  }
  // prettier-ignore
  set(e, T, $, V, J, ee, te, re, ie, se, de, ue, fe, he, me, xe) {
    this.v0l = e | 0, this.v0h = T | 0, this.v1l = $ | 0, this.v1h = V | 0, this.v2l = J | 0, this.v2h = ee | 0, this.v3l = te | 0, this.v3h = re | 0, this.v4l = ie | 0, this.v4h = se | 0, this.v5l = de | 0, this.v5h = ue | 0, this.v6l = fe | 0, this.v6h = he | 0, this.v7l = me | 0, this.v7h = xe | 0;
  }
  compress(e, T, $) {
    this.get().forEach((re, ie) => BBUF[ie] = re), BBUF.set(B2B_IV, 16);
    let { h: V, l: J } = u64$4.fromBig(BigInt(this.length));
    BBUF[24] = B2B_IV[8] ^ J, BBUF[25] = B2B_IV[9] ^ V, $ && (BBUF[28] = ~BBUF[28], BBUF[29] = ~BBUF[29]);
    let ee = 0;
    const te = SIGMA;
    for (let re = 0; re < 12; re++)
      G1b(0, 4, 8, 12, e, T + 2 * te[ee++]), G2b(0, 4, 8, 12, e, T + 2 * te[ee++]), G1b(1, 5, 9, 13, e, T + 2 * te[ee++]), G2b(1, 5, 9, 13, e, T + 2 * te[ee++]), G1b(2, 6, 10, 14, e, T + 2 * te[ee++]), G2b(2, 6, 10, 14, e, T + 2 * te[ee++]), G1b(3, 7, 11, 15, e, T + 2 * te[ee++]), G2b(3, 7, 11, 15, e, T + 2 * te[ee++]), G1b(0, 5, 10, 15, e, T + 2 * te[ee++]), G2b(0, 5, 10, 15, e, T + 2 * te[ee++]), G1b(1, 6, 11, 12, e, T + 2 * te[ee++]), G2b(1, 6, 11, 12, e, T + 2 * te[ee++]), G1b(2, 7, 8, 13, e, T + 2 * te[ee++]), G2b(2, 7, 8, 13, e, T + 2 * te[ee++]), G1b(3, 4, 9, 14, e, T + 2 * te[ee++]), G2b(3, 4, 9, 14, e, T + 2 * te[ee++]);
    this.v0l ^= BBUF[0] ^ BBUF[16], this.v0h ^= BBUF[1] ^ BBUF[17], this.v1l ^= BBUF[2] ^ BBUF[18], this.v1h ^= BBUF[3] ^ BBUF[19], this.v2l ^= BBUF[4] ^ BBUF[20], this.v2h ^= BBUF[5] ^ BBUF[21], this.v3l ^= BBUF[6] ^ BBUF[22], this.v3h ^= BBUF[7] ^ BBUF[23], this.v4l ^= BBUF[8] ^ BBUF[24], this.v4h ^= BBUF[9] ^ BBUF[25], this.v5l ^= BBUF[10] ^ BBUF[26], this.v5h ^= BBUF[11] ^ BBUF[27], this.v6l ^= BBUF[12] ^ BBUF[28], this.v6h ^= BBUF[13] ^ BBUF[29], this.v7l ^= BBUF[14] ^ BBUF[30], this.v7h ^= BBUF[15] ^ BBUF[31], BBUF.fill(0);
  }
  destroy() {
    this.destroyed = !0, this.buffer32.fill(0), this.set(0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0);
  }
}
const blake2b = /* @__PURE__ */ wrapConstructorWithOpts((C) => new BLAKE2b(C));
let StructError$1 = class extends TypeError {
  constructor(e, T) {
    let $;
    const { message: V, explanation: J, ...ee } = e, { path: te } = e, re = te.length === 0 ? V : `At path: ${te.join(".")} -- ${V}`;
    super(J ?? re), J != null && (this.cause = re), Object.assign(this, ee), this.name = this.constructor.name, this.failures = () => $ ?? ($ = [e, ...T()]);
  }
};
function isIterable$1(C) {
  return isObject$1(C) && typeof C[Symbol.iterator] == "function";
}
function isObject$1(C) {
  return typeof C == "object" && C != null;
}
function print$1(C) {
  return typeof C == "symbol" ? C.toString() : typeof C == "string" ? JSON.stringify(C) : `${C}`;
}
function shiftIterator$1(C) {
  const { done: e, value: T } = C.next();
  return e ? void 0 : T;
}
function toFailure$1(C, e, T, $) {
  if (C === !0)
    return;
  C === !1 ? C = {} : typeof C == "string" && (C = { message: C });
  const { path: V, branch: J } = e, { type: ee } = T, { refinement: te, message: re = `Expected a value of type \`${ee}\`${te ? ` with refinement \`${te}\`` : ""}, but received: \`${print$1($)}\`` } = C;
  return {
    value: $,
    type: ee,
    refinement: te,
    key: V[V.length - 1],
    path: V,
    branch: J,
    ...C,
    message: re
  };
}
function* toFailures$1(C, e, T, $) {
  isIterable$1(C) || (C = [C]);
  for (const V of C) {
    const J = toFailure$1(V, e, T, $);
    J && (yield J);
  }
}
function* run$1(C, e, T = {}) {
  const { path: $ = [], branch: V = [C], coerce: J = !1, mask: ee = !1 } = T, te = { path: $, branch: V };
  if (J && (C = e.coercer(C, te), ee && e.type !== "type" && isObject$1(e.schema) && isObject$1(C) && !Array.isArray(C)))
    for (const ie in C)
      e.schema[ie] === void 0 && delete C[ie];
  let re = "valid";
  for (const ie of e.validator(C, te))
    ie.explanation = T.message, re = "not_valid", yield [ie, void 0];
  for (let [ie, se, de] of e.entries(C, te)) {
    const ue = run$1(se, de, {
      path: ie === void 0 ? $ : [...$, ie],
      branch: ie === void 0 ? V : [...V, se],
      coerce: J,
      mask: ee,
      message: T.message
    });
    for (const fe of ue)
      fe[0] ? (re = fe[0].refinement != null ? "not_refined" : "not_valid", yield [fe[0], void 0]) : J && (se = fe[1], ie === void 0 ? C = se : C instanceof Map ? C.set(ie, se) : C instanceof Set ? C.add(se) : isObject$1(C) && (se !== void 0 || ie in C) && (C[ie] = se));
  }
  if (re !== "not_valid")
    for (const ie of e.refiner(C, te))
      ie.explanation = T.message, re = "not_refined", yield [ie, void 0];
  re === "valid" && (yield [void 0, C]);
}
let Struct$1 = class {
  constructor(e) {
    const { type: T, schema: $, validator: V, refiner: J, coercer: ee = (re) => re, entries: te = function* () {
    } } = e;
    this.type = T, this.schema = $, this.entries = te, this.coercer = ee, V ? this.validator = (re, ie) => {
      const se = V(re, ie);
      return toFailures$1(se, ie, this, re);
    } : this.validator = () => [], J ? this.refiner = (re, ie) => {
      const se = J(re, ie);
      return toFailures$1(se, ie, this, re);
    } : this.refiner = () => [];
  }
  /**
   * Assert that a value passes the struct's validation, throwing if it doesn't.
   */
  assert(e, T) {
    return assert$2(e, this, T);
  }
  /**
   * Create a value with the struct's coercion logic, then validate it.
   */
  create(e, T) {
    return create$2(e, this, T);
  }
  /**
   * Check if a value passes the struct's validation.
   */
  is(e) {
    return is$1(e, this);
  }
  /**
   * Mask a value, coercing and validating it, but returning only the subset of
   * properties defined by the struct's schema.
   */
  mask(e, T) {
    return mask$1(e, this, T);
  }
  /**
   * Validate a value with the struct's validation logic, returning a tuple
   * representing the result.
   *
   * You may optionally pass `true` for the `withCoercion` argument to coerce
   * the value before attempting to validate it. If you do, the result will
   * contain the coerced result when successful.
   */
  validate(e, T = {}) {
    return validate$2(e, this, T);
  }
};
function assert$2(C, e, T) {
  const $ = validate$2(C, e, { message: T });
  if ($[0])
    throw $[0];
}
function create$2(C, e, T) {
  const $ = validate$2(C, e, { coerce: !0, message: T });
  if ($[0])
    throw $[0];
  return $[1];
}
function mask$1(C, e, T) {
  const $ = validate$2(C, e, { coerce: !0, mask: !0, message: T });
  if ($[0])
    throw $[0];
  return $[1];
}
function is$1(C, e) {
  return !validate$2(C, e)[0];
}
function validate$2(C, e, T = {}) {
  const $ = run$1(C, e, T), V = shiftIterator$1($);
  return V[0] ? [new StructError$1(V[0], function* () {
    for (const ee of $)
      ee[0] && (yield ee[0]);
  }), void 0] : [void 0, V[1]];
}
function assign$1(...C) {
  const e = C[0].type === "type", T = C.map((V) => V.schema), $ = Object.assign({}, ...T);
  return e ? type$1($) : object($);
}
function define$1(C, e) {
  return new Struct$1({ type: C, schema: null, validator: e });
}
function any$1() {
  return define$1("any", () => !0);
}
function array$1(C) {
  return new Struct$1({
    type: "array",
    schema: C,
    *entries(e) {
      if (C && Array.isArray(e))
        for (const [T, $] of e.entries())
          yield [T, $, C];
    },
    coercer(e) {
      return Array.isArray(e) ? e.slice() : e;
    },
    validator(e) {
      return Array.isArray(e) || `Expected an array value, but received: ${print$1(e)}`;
    }
  });
}
function boolean$1() {
  return define$1("boolean", (C) => typeof C == "boolean");
}
function integer() {
  return define$1("integer", (C) => typeof C == "number" && !isNaN(C) && Number.isInteger(C) || `Expected an integer, but received: ${print$1(C)}`);
}
function literal$1(C) {
  const e = print$1(C), T = typeof C;
  return new Struct$1({
    type: "literal",
    schema: T === "string" || T === "number" || T === "boolean" ? C : null,
    validator($) {
      return $ === C || `Expected the literal \`${e}\`, but received: ${print$1($)}`;
    }
  });
}
function never() {
  return define$1("never", () => !1);
}
function nullable$1(C) {
  return new Struct$1({
    ...C,
    validator: (e, T) => e === null || C.validator(e, T),
    refiner: (e, T) => e === null || C.refiner(e, T)
  });
}
function number$1() {
  return define$1("number", (C) => typeof C == "number" && !isNaN(C) || `Expected a number, but received: ${print$1(C)}`);
}
function object(C) {
  const e = C ? Object.keys(C) : [], T = never();
  return new Struct$1({
    type: "object",
    schema: C || null,
    *entries($) {
      if (C && isObject$1($)) {
        const V = new Set(Object.keys($));
        for (const J of e)
          V.delete(J), yield [J, $[J], C[J]];
        for (const J of V)
          yield [J, $[J], T];
      }
    },
    validator($) {
      return isObject$1($) || `Expected an object, but received: ${print$1($)}`;
    },
    coercer($) {
      return isObject$1($) ? { ...$ } : $;
    }
  });
}
function optional$1(C) {
  return new Struct$1({
    ...C,
    validator: (e, T) => e === void 0 || C.validator(e, T),
    refiner: (e, T) => e === void 0 || C.refiner(e, T)
  });
}
function record(C, e) {
  return new Struct$1({
    type: "record",
    schema: null,
    *entries(T) {
      if (isObject$1(T))
        for (const $ in T) {
          const V = T[$];
          yield [$, $, C], yield [$, V, e];
        }
    },
    validator(T) {
      return isObject$1(T) || `Expected an object, but received: ${print$1(T)}`;
    }
  });
}
function string$1() {
  return define$1("string", (C) => typeof C == "string" || `Expected a string, but received: ${print$1(C)}`);
}
function tuple(C) {
  const e = never();
  return new Struct$1({
    type: "tuple",
    schema: null,
    *entries(T) {
      if (Array.isArray(T)) {
        const $ = Math.max(C.length, T.length);
        for (let V = 0; V < $; V++)
          yield [V, T[V], C[V] || e];
      }
    },
    validator(T) {
      return Array.isArray(T) || `Expected an array, but received: ${print$1(T)}`;
    }
  });
}
function type$1(C) {
  const e = Object.keys(C);
  return new Struct$1({
    type: "type",
    schema: C,
    *entries(T) {
      if (isObject$1(T))
        for (const $ of e)
          yield [$, T[$], C[$]];
    },
    validator(T) {
      return isObject$1(T) || `Expected an object, but received: ${print$1(T)}`;
    },
    coercer(T) {
      return isObject$1(T) ? { ...T } : T;
    }
  });
}
function union$2(C) {
  const e = C.map((T) => T.type).join(" | ");
  return new Struct$1({
    type: "union",
    schema: null,
    coercer(T) {
      for (const $ of C) {
        const [V, J] = $.validate(T, { coerce: !0 });
        if (!V)
          return J;
      }
      return T;
    },
    validator(T, $) {
      const V = [];
      for (const J of C) {
        const [...ee] = run$1(T, J, $), [te] = ee;
        if (te[0])
          for (const [re] of ee)
            re && V.push(re);
        else
          return [];
      }
      return [
        `Expected the value to satisfy a union of \`${e}\`, but received: ${print$1(T)}`,
        ...V
      ];
    }
  });
}
var index_browser = {}, websocket_browser = {}, eventemitter3$1 = { exports: {} };
(function(C) {
  var e = Object.prototype.hasOwnProperty, T = "~";
  function $() {
  }
  Object.create && ($.prototype = /* @__PURE__ */ Object.create(null), new $().__proto__ || (T = !1));
  function V(re, ie, se) {
    this.fn = re, this.context = ie, this.once = se || !1;
  }
  function J(re, ie, se, de, ue) {
    if (typeof se != "function")
      throw new TypeError("The listener must be a function");
    var fe = new V(se, de || re, ue), he = T ? T + ie : ie;
    return re._events[he] ? re._events[he].fn ? re._events[he] = [re._events[he], fe] : re._events[he].push(fe) : (re._events[he] = fe, re._eventsCount++), re;
  }
  function ee(re, ie) {
    --re._eventsCount === 0 ? re._events = new $() : delete re._events[ie];
  }
  function te() {
    this._events = new $(), this._eventsCount = 0;
  }
  te.prototype.eventNames = function() {
    var ie = [], se, de;
    if (this._eventsCount === 0) return ie;
    for (de in se = this._events)
      e.call(se, de) && ie.push(T ? de.slice(1) : de);
    return Object.getOwnPropertySymbols ? ie.concat(Object.getOwnPropertySymbols(se)) : ie;
  }, te.prototype.listeners = function(ie) {
    var se = T ? T + ie : ie, de = this._events[se];
    if (!de) return [];
    if (de.fn) return [de.fn];
    for (var ue = 0, fe = de.length, he = new Array(fe); ue < fe; ue++)
      he[ue] = de[ue].fn;
    return he;
  }, te.prototype.listenerCount = function(ie) {
    var se = T ? T + ie : ie, de = this._events[se];
    return de ? de.fn ? 1 : de.length : 0;
  }, te.prototype.emit = function(ie, se, de, ue, fe, he) {
    var me = T ? T + ie : ie;
    if (!this._events[me]) return !1;
    var xe = this._events[me], ve = arguments.length, Te, we;
    if (xe.fn) {
      switch (xe.once && this.removeListener(ie, xe.fn, void 0, !0), ve) {
        case 1:
          return xe.fn.call(xe.context), !0;
        case 2:
          return xe.fn.call(xe.context, se), !0;
        case 3:
          return xe.fn.call(xe.context, se, de), !0;
        case 4:
          return xe.fn.call(xe.context, se, de, ue), !0;
        case 5:
          return xe.fn.call(xe.context, se, de, ue, fe), !0;
        case 6:
          return xe.fn.call(xe.context, se, de, ue, fe, he), !0;
      }
      for (we = 1, Te = new Array(ve - 1); we < ve; we++)
        Te[we - 1] = arguments[we];
      xe.fn.apply(xe.context, Te);
    } else {
      var Ee = xe.length, Me;
      for (we = 0; we < Ee; we++)
        switch (xe[we].once && this.removeListener(ie, xe[we].fn, void 0, !0), ve) {
          case 1:
            xe[we].fn.call(xe[we].context);
            break;
          case 2:
            xe[we].fn.call(xe[we].context, se);
            break;
          case 3:
            xe[we].fn.call(xe[we].context, se, de);
            break;
          case 4:
            xe[we].fn.call(xe[we].context, se, de, ue);
            break;
          default:
            if (!Te) for (Me = 1, Te = new Array(ve - 1); Me < ve; Me++)
              Te[Me - 1] = arguments[Me];
            xe[we].fn.apply(xe[we].context, Te);
        }
    }
    return !0;
  }, te.prototype.on = function(ie, se, de) {
    return J(this, ie, se, de, !1);
  }, te.prototype.once = function(ie, se, de) {
    return J(this, ie, se, de, !0);
  }, te.prototype.removeListener = function(ie, se, de, ue) {
    var fe = T ? T + ie : ie;
    if (!this._events[fe]) return this;
    if (!se)
      return ee(this, fe), this;
    var he = this._events[fe];
    if (he.fn)
      he.fn === se && (!ue || he.once) && (!de || he.context === de) && ee(this, fe);
    else {
      for (var me = 0, xe = [], ve = he.length; me < ve; me++)
        (he[me].fn !== se || ue && !he[me].once || de && he[me].context !== de) && xe.push(he[me]);
      xe.length ? this._events[fe] = xe.length === 1 ? xe[0] : xe : ee(this, fe);
    }
    return this;
  }, te.prototype.removeAllListeners = function(ie) {
    var se;
    return ie ? (se = T ? T + ie : ie, this._events[se] && ee(this, se)) : (this._events = new $(), this._eventsCount = 0), this;
  }, te.prototype.off = te.prototype.removeListener, te.prototype.addListener = te.prototype.on, te.prefixed = T, te.EventEmitter = te, C.exports = te;
})(eventemitter3$1);
var eventemitter3Exports$1 = eventemitter3$1.exports;
const EventEmitter$1 = /* @__PURE__ */ getDefaultExportFromCjs$2(eventemitter3Exports$1);
Object.defineProperty(websocket_browser, "__esModule", { value: !0 });
const eventemitter3_1$1 = eventemitter3Exports$1;
class WebSocketBrowserImpl extends eventemitter3_1$1.EventEmitter {
  /** Instantiate a WebSocket class
   * @constructor
   * @param {String} address - url to a websocket server
   * @param {(Object)} options - websocket options
   * @param {(String|Array)} protocols - a list of protocols
   * @return {WebSocketBrowserImpl} - returns a WebSocket instance
   */
  constructor(T, $, V) {
    super();
    tt(this, "socket");
    this.socket = new window.WebSocket(T, V), this.socket.onopen = () => this.emit("open"), this.socket.onmessage = (J) => this.emit("message", J.data), this.socket.onerror = (J) => this.emit("error", J), this.socket.onclose = (J) => {
      this.emit("close", J.code, J.reason);
    };
  }
  /**
   * Sends data through a websocket connection
   * @method
   * @param {(String|Object)} data - data to be sent via websocket
   * @param {Object} optionsOrCallback - ws options
   * @param {Function} callback - a callback called once the data is sent
   * @return {Undefined}
   */
  send(T, $, V) {
    const J = V || $;
    try {
      this.socket.send(T), J();
    } catch (ee) {
      J(ee);
    }
  }
  /**
   * Closes an underlying socket
   * @method
   * @param {Number} code - status code explaining why the connection is being closed
   * @param {String} reason - a description why the connection is closing
   * @return {Undefined}
   * @throws {Error}
   */
  close(T, $) {
    this.socket.close(T, $);
  }
  addEventListener(T, $, V) {
    this.socket.addEventListener(T, $, V);
  }
}
function default_1$d(C, e) {
  return new WebSocketBrowserImpl(C, e);
}
websocket_browser.default = default_1$d;
var client = {}, utils$1 = {};
Object.defineProperty(utils$1, "__esModule", { value: !0 });
utils$1.createError = utils$1.DefaultDataPack = void 0;
const errors$1 = /* @__PURE__ */ new Map([
  [-32e3, "Event not provided"],
  [-32600, "Invalid Request"],
  [-32601, "Method not found"],
  [-32602, "Invalid params"],
  [-32603, "Internal error"],
  [-32604, "Params not found"],
  [-32605, "Method forbidden"],
  [-32606, "Event forbidden"],
  [-32700, "Parse error"]
]);
class DefaultDataPack {
  encode(e) {
    return JSON.stringify(e);
  }
  decode(e) {
    return JSON.parse(e);
  }
}
utils$1.DefaultDataPack = DefaultDataPack;
function createError(C, e) {
  const T = {
    code: C,
    message: errors$1.get(C) || "Internal Server Error"
  };
  return e && (T.data = e), T;
}
utils$1.createError = createError;
Object.defineProperty(client, "__esModule", { value: !0 });
const eventemitter3_1 = eventemitter3Exports$1, utils_cjs_1 = utils$1;
class CommonClient extends eventemitter3_1.EventEmitter {
  /**
   * Instantiate a Client class.
   * @constructor
   * @param {webSocketFactory} webSocketFactory - factory method for WebSocket
   * @param {String} address - url to a websocket server
   * @param {Object} options - ws options object with reconnect parameters
   * @param {Function} generate_request_id - custom generation request Id
   * @param {DataPack} dataPack - data pack contains encoder and decoder
   * @return {CommonClient}
   */
  constructor(T, $ = "ws://localhost:8080", { autoconnect: V = !0, reconnect: J = !0, reconnect_interval: ee = 1e3, max_reconnects: te = 5, ...re } = {}, ie, se) {
    super();
    tt(this, "address");
    tt(this, "rpc_id");
    tt(this, "queue");
    tt(this, "options");
    tt(this, "autoconnect");
    tt(this, "ready");
    tt(this, "reconnect");
    tt(this, "reconnect_timer_id");
    tt(this, "reconnect_interval");
    tt(this, "max_reconnects");
    tt(this, "rest_options");
    tt(this, "current_reconnects");
    tt(this, "generate_request_id");
    tt(this, "socket");
    tt(this, "webSocketFactory");
    tt(this, "dataPack");
    this.webSocketFactory = T, this.queue = {}, this.rpc_id = 0, this.address = $, this.autoconnect = V, this.ready = !1, this.reconnect = J, this.reconnect_timer_id = void 0, this.reconnect_interval = ee, this.max_reconnects = te, this.rest_options = re, this.current_reconnects = 0, this.generate_request_id = ie || (() => ++this.rpc_id), se ? this.dataPack = se : this.dataPack = new utils_cjs_1.DefaultDataPack(), this.autoconnect && this._connect(this.address, {
      autoconnect: this.autoconnect,
      reconnect: this.reconnect,
      reconnect_interval: this.reconnect_interval,
      max_reconnects: this.max_reconnects,
      ...this.rest_options
    });
  }
  /**
   * Connects to a defined server if not connected already.
   * @method
   * @return {Undefined}
   */
  connect() {
    this.socket || this._connect(this.address, {
      autoconnect: this.autoconnect,
      reconnect: this.reconnect,
      reconnect_interval: this.reconnect_interval,
      max_reconnects: this.max_reconnects,
      ...this.rest_options
    });
  }
  /**
   * Calls a registered RPC method on server.
   * @method
   * @param {String} method - RPC method name
   * @param {Object|Array} params - optional method parameters
   * @param {Number} timeout - RPC reply timeout value
   * @param {Object} ws_opts - options passed to ws
   * @return {Promise}
   */
  call(T, $, V, J) {
    return !J && typeof V == "object" && (J = V, V = null), new Promise((ee, te) => {
      if (!this.ready)
        return te(new Error("socket not ready"));
      const re = this.generate_request_id(T, $), ie = {
        jsonrpc: "2.0",
        method: T,
        params: $ || void 0,
        id: re
      };
      this.socket.send(this.dataPack.encode(ie), J, (se) => {
        if (se)
          return te(se);
        this.queue[re] = { promise: [ee, te] }, V && (this.queue[re].timeout = setTimeout(() => {
          delete this.queue[re], te(new Error("reply timeout"));
        }, V));
      });
    });
  }
  /**
   * Logins with the other side of the connection.
   * @method
   * @param {Object} params - Login credentials object
   * @return {Promise}
   */
  async login(T) {
    const $ = await this.call("rpc.login", T);
    if (!$)
      throw new Error("authentication failed");
    return $;
  }
  /**
   * Fetches a list of client's methods registered on server.
   * @method
   * @return {Array}
   */
  async listMethods() {
    return await this.call("__listMethods");
  }
  /**
   * Sends a JSON-RPC 2.0 notification to server.
   * @method
   * @param {String} method - RPC method name
   * @param {Object} params - optional method parameters
   * @return {Promise}
   */
  notify(T, $) {
    return new Promise((V, J) => {
      if (!this.ready)
        return J(new Error("socket not ready"));
      const ee = {
        jsonrpc: "2.0",
        method: T,
        params: $
      };
      this.socket.send(this.dataPack.encode(ee), (te) => {
        if (te)
          return J(te);
        V();
      });
    });
  }
  /**
   * Subscribes for a defined event.
   * @method
   * @param {String|Array} event - event name
   * @return {Undefined}
   * @throws {Error}
   */
  async subscribe(T) {
    typeof T == "string" && (T = [T]);
    const $ = await this.call("rpc.on", T);
    if (typeof T == "string" && $[T] !== "ok")
      throw new Error("Failed subscribing to an event '" + T + "' with: " + $[T]);
    return $;
  }
  /**
   * Unsubscribes from a defined event.
   * @method
   * @param {String|Array} event - event name
   * @return {Undefined}
   * @throws {Error}
   */
  async unsubscribe(T) {
    typeof T == "string" && (T = [T]);
    const $ = await this.call("rpc.off", T);
    if (typeof T == "string" && $[T] !== "ok")
      throw new Error("Failed unsubscribing from an event with: " + $);
    return $;
  }
  /**
   * Closes a WebSocket connection gracefully.
   * @method
   * @param {Number} code - socket close code
   * @param {String} data - optional data to be sent before closing
   * @return {Undefined}
   */
  close(T, $) {
    this.socket.close(T || 1e3, $);
  }
  /**
   * Enable / disable automatic reconnection.
   * @method
   * @param {Boolean} reconnect - enable / disable reconnection
   * @return {Undefined}
   */
  setAutoReconnect(T) {
    this.reconnect = T;
  }
  /**
   * Set the interval between reconnection attempts.
   * @method
   * @param {Number} interval - reconnection interval in milliseconds
   * @return {Undefined}
   */
  setReconnectInterval(T) {
    this.reconnect_interval = T;
  }
  /**
   * Set the maximum number of reconnection attempts.
   * @method
   * @param {Number} max_reconnects - maximum reconnection attempts
   * @return {Undefined}
   */
  setMaxReconnects(T) {
    this.max_reconnects = T;
  }
  /**
   * Connection/Message handler.
   * @method
   * @private
   * @param {String} address - WebSocket API address
   * @param {Object} options - ws options object
   * @return {Undefined}
   */
  _connect(T, $) {
    clearTimeout(this.reconnect_timer_id), this.socket = this.webSocketFactory(T, $), this.socket.addEventListener("open", () => {
      this.ready = !0, this.emit("open"), this.current_reconnects = 0;
    }), this.socket.addEventListener("message", ({ data: V }) => {
      V instanceof ArrayBuffer && (V = dist$2.Buffer.from(V).toString());
      try {
        V = this.dataPack.decode(V);
      } catch {
        return;
      }
      if (V.notification && this.listeners(V.notification).length) {
        if (!Object.keys(V.params).length)
          return this.emit(V.notification);
        const J = [V.notification];
        if (V.params.constructor === Object)
          J.push(V.params);
        else
          for (let ee = 0; ee < V.params.length; ee++)
            J.push(V.params[ee]);
        return Promise.resolve().then(() => {
          this.emit.apply(this, J);
        });
      }
      if (!this.queue[V.id])
        return V.method ? Promise.resolve().then(() => {
          this.emit(V.method, V == null ? void 0 : V.params);
        }) : void 0;
      "error" in V == "result" in V && this.queue[V.id].promise[1](new Error('Server response malformed. Response must include either "result" or "error", but not both.')), this.queue[V.id].timeout && clearTimeout(this.queue[V.id].timeout), V.error ? this.queue[V.id].promise[1](V.error) : this.queue[V.id].promise[0](V.result), delete this.queue[V.id];
    }), this.socket.addEventListener("error", (V) => this.emit("error", V)), this.socket.addEventListener("close", ({ code: V, reason: J }) => {
      this.ready && setTimeout(() => this.emit("close", V, J), 0), this.ready = !1, this.socket = void 0, V !== 1e3 && (this.current_reconnects++, this.reconnect && (this.max_reconnects > this.current_reconnects || this.max_reconnects === 0) && (this.reconnect_timer_id = setTimeout(() => this._connect(T, $), this.reconnect_interval)));
    });
  }
}
client.default = CommonClient;
var __importDefault = commonjsGlobal$1 && commonjsGlobal$1.__importDefault || function(C) {
  return C && C.__esModule ? C : { default: C };
};
Object.defineProperty(index_browser, "__esModule", { value: !0 });
var Client_1 = index_browser.Client = void 0;
const websocket_browser_cjs_1 = __importDefault(websocket_browser), client_cjs_1 = __importDefault(client);
class Client extends client_cjs_1.default {
  constructor(e = "ws://localhost:8080", { autoconnect: T = !0, reconnect: $ = !0, reconnect_interval: V = 1e3, max_reconnects: J = 5 } = {}, ee) {
    super(websocket_browser_cjs_1.default, e, {
      autoconnect: T,
      reconnect: $,
      reconnect_interval: V,
      max_reconnects: J
    }, ee);
  }
}
Client_1 = index_browser.Client = Client;
function isValid(C) {
  return /^\d+\.\d+\.\d+$/.test(C);
}
function parse(C) {
  if (!isValid(C))
    throw new Error("Invalid semver version: " + C);
  const [e, T, $] = C.split(".").map((V) => parseInt(V, 10));
  return { major: e, minor: T, patch: $ };
}
function lt(C, e) {
  const T = parse(C), $ = parse(e);
  return T.major !== $.major ? T.major < $.major : T.minor !== $.minor ? T.minor < $.minor : T.patch !== $.patch ? T.patch < $.patch : !1;
}
function lte(C, e) {
  const T = parse(C), $ = parse(e);
  return T.major !== $.major ? T.major <= $.major : T.minor !== $.minor ? T.minor <= $.minor : T.patch !== $.patch ? T.patch <= $.patch : !0;
}
function gt(C, e) {
  const T = parse(C), $ = parse(e);
  return T.major !== $.major ? T.major > $.major : T.minor !== $.minor ? T.minor > $.minor : T.patch !== $.patch ? T.patch > $.patch : !1;
}
function gte(C, e) {
  const T = parse(C), $ = parse(e);
  return T.major !== $.major ? T.major >= $.major : T.minor !== $.minor ? T.minor >= $.minor : T.patch !== $.patch ? T.patch >= $.patch : !0;
}
function eq(C, e) {
  return parse(C), parse(e), C === e;
}
var femver = {
  isValid,
  parse,
  lt,
  lte,
  gt,
  gte,
  eq
}, __accessCheck = (C, e, T) => {
  if (!e.has(C))
    throw TypeError("Cannot " + T);
}, __privateGet = (C, e, T) => (__accessCheck(C, e, "read from private field"), T ? T.call(C) : e.get(C)), __privateAdd = (C, e, T) => {
  if (e.has(C))
    throw TypeError("Cannot add the same private member more than once");
  e instanceof WeakSet ? e.add(C) : e.set(C, T);
}, __privateSet = (C, e, T, $) => (__accessCheck(C, e, "write to private field"), e.set(C, T), T), __privateMethod = (C, e, T) => (__accessCheck(C, e, "access private method"), T), TransactionDigest = string$1(), TransactionEffectsDigest = string$1(), TransactionEventDigest = string$1(), ObjectId = string$1(), SuiAddress = string$1(), SequenceNumber = string$1(), ObjectOwner = union$2([
  object({
    AddressOwner: SuiAddress
  }),
  object({
    ObjectOwner: SuiAddress
  }),
  object({
    Shared: object({
      initial_shared_version: number$1()
    })
  }),
  literal$1("Immutable")
]), SuiJsonValue = define$1("SuiJsonValue", () => !0), TX_DIGEST_LENGTH = 32;
function isValidTransactionDigest(C) {
  try {
    return fromB58(C).length === TX_DIGEST_LENGTH;
  } catch {
    return !1;
  }
}
var SUI_ADDRESS_LENGTH = 32;
function isValidSuiAddress(C) {
  return isHex(C) && getHexByteLength(C) === SUI_ADDRESS_LENGTH;
}
function isValidSuiObjectId(C) {
  return isValidSuiAddress(C);
}
function normalizeSuiAddress(C, e = !1) {
  let T = C.toLowerCase();
  return !e && T.startsWith("0x") && (T = T.slice(2)), `0x${T.padStart(SUI_ADDRESS_LENGTH * 2, "0")}`;
}
function normalizeSuiObjectId(C, e = !1) {
  return normalizeSuiAddress(C, e);
}
function isHex(C) {
  return /^(0x|0X)?[a-fA-F0-9]+$/.test(C) && C.length % 2 === 0;
}
function getHexByteLength(C) {
  return /^(0x|0X)/.test(C) ? (C.length - 2) / 2 : C.length / 2;
}
union$2([string$1(), literal$1("package")]);
var SuiObjectRef = object({
  /** Base64 string representing the object digest */
  digest: TransactionDigest,
  /** Hex code as string representing the object id */
  objectId: string$1(),
  /** Object version */
  version: union$2([number$1(), string$1()])
}), SuiGasData = object({
  payment: array$1(SuiObjectRef),
  /** Gas Object's owner */
  owner: string$1(),
  price: string$1(),
  budget: string$1()
}), SuiObjectInfo = assign$1(
  SuiObjectRef,
  object({
    type: string$1(),
    owner: ObjectOwner,
    previousTransaction: TransactionDigest
  })
), ObjectContentFields = record(string$1(), any$1()), MovePackageContent = record(string$1(), string$1()), SuiMoveObject = object({
  /** Move type (e.g., "0x2::coin::Coin<0x2::sui::SUI>") */
  type: string$1(),
  /** Fields and values stored inside the Move object */
  fields: ObjectContentFields,
  hasPublicTransfer: boolean$1()
}), SuiMovePackage = object({
  /** A mapping from module name to disassembled Move bytecode */
  disassembled: MovePackageContent
}), SuiParsedData = union$2([
  assign$1(SuiMoveObject, object({ dataType: literal$1("moveObject") })),
  assign$1(SuiMovePackage, object({ dataType: literal$1("package") }))
]);
object({
  /** Move type (e.g., "0x2::coin::Coin<0x2::sui::SUI>") */
  type: string$1(),
  hasPublicTransfer: boolean$1(),
  version: SequenceNumber,
  bcsBytes: array$1(number$1())
});
var SuiRawMovePackage = object({
  id: ObjectId,
  /** A mapping from module name to Move bytecode enocded in base64*/
  moduleMap: record(string$1(), string$1())
}), SuiRawData = union$2([
  assign$1(SuiMoveObject, object({ dataType: literal$1("moveObject") })),
  assign$1(SuiRawMovePackage, object({ dataType: literal$1("package") }))
]);
BigInt(1e9);
var ObjectDigest = string$1(), SuiObjectResponseError = object({
  code: string$1(),
  error: optional$1(string$1()),
  object_id: optional$1(ObjectId),
  version: optional$1(SequenceNumber),
  digest: optional$1(ObjectDigest)
}), DisplayFieldsResponse = object({
  data: nullable$1(record(string$1(), string$1())),
  error: nullable$1(SuiObjectResponseError)
}), DisplayFieldsBackwardCompatibleResponse = union$2([
  DisplayFieldsResponse,
  optional$1(record(string$1(), string$1()))
]), SuiObjectData = object({
  objectId: ObjectId,
  version: SequenceNumber,
  digest: ObjectDigest,
  /**
   * Type of the object, default to be undefined unless SuiObjectDataOptions.showType is set to true
   */
  type: optional$1(string$1()),
  /**
   * Move object content or package content, default to be undefined unless SuiObjectDataOptions.showContent is set to true
   */
  content: optional$1(SuiParsedData),
  /**
   * Move object content or package content in BCS bytes, default to be undefined unless SuiObjectDataOptions.showBcs is set to true
   */
  bcs: optional$1(SuiRawData),
  /**
   * The owner of this object. Default to be undefined unless SuiObjectDataOptions.showOwner is set to true
   */
  owner: optional$1(ObjectOwner),
  /**
   * The digest of the transaction that created or last mutated this object.
   * Default to be undefined unless SuiObjectDataOptions.showPreviousTransaction is set to true
   */
  previousTransaction: optional$1(TransactionDigest),
  /**
   * The amount of SUI we would rebate if this object gets deleted.
   * This number is re-calculated each time the object is mutated based on
   * the present storage gas price.
   * Default to be undefined unless SuiObjectDataOptions.showStorageRebate is set to true
   */
  storageRebate: optional$1(string$1()),
  /**
   * Display metadata for this object, default to be undefined unless SuiObjectDataOptions.showDisplay is set to true
   * This can also be None if the struct type does not have Display defined
   * See more details in https://forums.sui.io/t/nft-object-display-proposal/4872
   */
  display: optional$1(DisplayFieldsBackwardCompatibleResponse)
});
object({
  /* Whether to fetch the object type, default to be true */
  showType: optional$1(boolean$1()),
  /* Whether to fetch the object content, default to be false */
  showContent: optional$1(boolean$1()),
  /* Whether to fetch the object content in BCS bytes, default to be false */
  showBcs: optional$1(boolean$1()),
  /* Whether to fetch the object owner, default to be false */
  showOwner: optional$1(boolean$1()),
  /* Whether to fetch the previous transaction digest, default to be false */
  showPreviousTransaction: optional$1(boolean$1()),
  /* Whether to fetch the storage rebate, default to be false */
  showStorageRebate: optional$1(boolean$1()),
  /* Whether to fetch the display metadata, default to be false */
  showDisplay: optional$1(boolean$1())
});
union$2([
  literal$1("Exists"),
  literal$1("notExists"),
  literal$1("Deleted")
]);
array$1(SuiObjectInfo);
var SuiObjectResponse = object({
  data: optional$1(SuiObjectData),
  error: optional$1(SuiObjectResponseError)
});
function getSuiObjectData(C) {
  return C.data;
}
function getObjectDeletedResponse(C) {
  if (C.error && "object_id" in C.error && "version" in C.error && "digest" in C.error) {
    const e = C.error;
    return {
      objectId: e.object_id,
      version: e.version,
      digest: e.digest
    };
  }
}
function getObjectReference(C) {
  if ("reference" in C)
    return C.reference;
  const e = getSuiObjectData(C);
  return e ? {
    objectId: e.objectId,
    version: e.version,
    digest: e.digest
  } : getObjectDeletedResponse(C);
}
function getObjectOwner(C) {
  var e;
  return is$1(C, ObjectOwner) ? C : (e = getSuiObjectData(C)) == null ? void 0 : e.owner;
}
function getSharedObjectInitialVersion(C) {
  const e = getObjectOwner(C);
  if (typeof e == "object" && "Shared" in e)
    return e.Shared.initial_shared_version;
}
var CheckpointedObjectId = object({
  objectId: ObjectId,
  atCheckpoint: optional$1(number$1())
}), PaginatedObjectsResponse = object({
  data: array$1(SuiObjectResponse),
  // TODO: remove union after 0.30.0 is released
  nextCursor: union$2([nullable$1(ObjectId), nullable$1(CheckpointedObjectId)]),
  hasNextPage: boolean$1()
}), EventId = object({
  txDigest: TransactionDigest,
  eventSeq: SequenceNumber
}), SuiEvent = object({
  id: EventId,
  // Move package where this event was emitted.
  packageId: ObjectId,
  // Move module where this event was emitted.
  transactionModule: string$1(),
  // Sender's Sui address.
  sender: SuiAddress,
  // Move event type.
  type: string$1(),
  // Parsed json value of the event
  parsedJson: optional$1(record(string$1(), any$1())),
  // Base 58 encoded bcs bytes of the move event
  bcs: optional$1(string$1()),
  timestampMs: optional$1(string$1())
}), PaginatedEvents = object({
  data: array$1(SuiEvent),
  nextCursor: nullable$1(EventId),
  hasNextPage: boolean$1()
}), SubscriptionId = number$1(), SubscriptionEvent = object({
  subscription: SubscriptionId,
  result: SuiEvent
}), EpochId = string$1(), SuiChangeEpoch = object({
  epoch: EpochId,
  storage_charge: string$1(),
  computation_charge: string$1(),
  storage_rebate: string$1(),
  epoch_start_timestamp_ms: optional$1(string$1())
}), SuiConsensusCommitPrologue = object({
  epoch: EpochId,
  round: string$1(),
  commit_timestamp_ms: string$1()
}), Genesis = object({
  objects: array$1(ObjectId)
}), SuiArgument = union$2([
  literal$1("GasCoin"),
  object({ Input: number$1() }),
  object({ Result: number$1() }),
  object({ NestedResult: tuple([number$1(), number$1()]) })
]), MoveCallSuiTransaction = object({
  arguments: optional$1(array$1(SuiArgument)),
  type_arguments: optional$1(array$1(string$1())),
  package: ObjectId,
  module: string$1(),
  function: string$1()
}), SuiTransaction = union$2([
  object({ MoveCall: MoveCallSuiTransaction }),
  object({ TransferObjects: tuple([array$1(SuiArgument), SuiArgument]) }),
  object({ SplitCoins: tuple([SuiArgument, array$1(SuiArgument)]) }),
  object({ MergeCoins: tuple([SuiArgument, array$1(SuiArgument)]) }),
  object({ Publish: tuple([SuiMovePackage, array$1(ObjectId)]) }),
  object({
    Upgrade: tuple([SuiMovePackage, array$1(ObjectId), ObjectId, SuiArgument])
  }),
  object({ MakeMoveVec: tuple([nullable$1(string$1()), array$1(SuiArgument)]) })
]), SuiCallArg = union$2([
  object({
    type: literal$1("pure"),
    valueType: optional$1(string$1()),
    value: SuiJsonValue
  }),
  object({
    type: literal$1("object"),
    objectType: literal$1("immOrOwnedObject"),
    objectId: ObjectId,
    version: SequenceNumber,
    digest: ObjectDigest
  }),
  object({
    type: literal$1("object"),
    objectType: literal$1("sharedObject"),
    objectId: ObjectId,
    initialSharedVersion: SequenceNumber,
    mutable: boolean$1()
  })
]), ProgrammableTransaction = object({
  transactions: array$1(SuiTransaction),
  inputs: array$1(SuiCallArg)
}), SuiTransactionBlockKind = union$2([
  assign$1(SuiChangeEpoch, object({ kind: literal$1("ChangeEpoch") })),
  assign$1(
    SuiConsensusCommitPrologue,
    object({
      kind: literal$1("ConsensusCommitPrologue")
    })
  ),
  assign$1(Genesis, object({ kind: literal$1("Genesis") })),
  assign$1(
    ProgrammableTransaction,
    object({ kind: literal$1("ProgrammableTransaction") })
  )
]), SuiTransactionBlockData = object({
  // Eventually this will become union(literal('v1'), literal('v2'), ...)
  messageVersion: literal$1("v1"),
  transaction: SuiTransactionBlockKind,
  sender: SuiAddress,
  gasData: SuiGasData
  // this shit is diff bw wallet and explorer
}), AuthoritySignature = string$1(), GenericAuthoritySignature = union$2([
  AuthoritySignature,
  array$1(AuthoritySignature)
]);
object({
  epoch: EpochId,
  signature: GenericAuthoritySignature,
  signers_map: array$1(number$1())
});
var GasCostSummary = object({
  computationCost: string$1(),
  storageCost: string$1(),
  storageRebate: string$1(),
  nonRefundableStorageFee: string$1()
}), ExecutionStatusType = union$2([
  literal$1("success"),
  literal$1("failure")
]), ExecutionStatus = object({
  status: ExecutionStatusType,
  error: optional$1(string$1())
}), OwnedObjectRef = object({
  owner: ObjectOwner,
  reference: SuiObjectRef
}), TransactionEffectsModifiedAtVersions = object({
  objectId: ObjectId,
  sequenceNumber: SequenceNumber
}), TransactionEffects = object({
  // Eventually this will become union(literal('v1'), literal('v2'), ...)
  messageVersion: literal$1("v1"),
  /** The status of the execution */
  status: ExecutionStatus,
  /** The epoch when this transaction was executed */
  executedEpoch: EpochId,
  /** The version that every modified (mutated or deleted) object had before it was modified by this transaction. **/
  modifiedAtVersions: optional$1(array$1(TransactionEffectsModifiedAtVersions)),
  gasUsed: GasCostSummary,
  /** The object references of the shared objects used in this transaction. Empty if no shared objects were used. */
  sharedObjects: optional$1(array$1(SuiObjectRef)),
  /** The transaction digest */
  transactionDigest: TransactionDigest,
  /** ObjectRef and owner of new objects created */
  created: optional$1(array$1(OwnedObjectRef)),
  /** ObjectRef and owner of mutated objects, including gas object */
  mutated: optional$1(array$1(OwnedObjectRef)),
  /**
   * ObjectRef and owner of objects that are unwrapped in this transaction.
   * Unwrapped objects are objects that were wrapped into other objects in the past,
   * and just got extracted out.
   */
  unwrapped: optional$1(array$1(OwnedObjectRef)),
  /** Object Refs of objects now deleted (the old refs) */
  deleted: optional$1(array$1(SuiObjectRef)),
  /** Object Refs of objects now deleted (the old refs) */
  unwrapped_then_deleted: optional$1(array$1(SuiObjectRef)),
  /** Object refs of objects now wrapped in other objects */
  wrapped: optional$1(array$1(SuiObjectRef)),
  /**
   * The updated gas object reference. Have a dedicated field for convenient access.
   * It's also included in mutated.
   */
  gasObject: OwnedObjectRef,
  /** The events emitted during execution. Note that only successful transactions emit events */
  eventsDigest: optional$1(TransactionEventDigest),
  /** The set of transaction digests this transaction depends on */
  dependencies: optional$1(array$1(TransactionDigest))
}), TransactionEvents = array$1(SuiEvent), ReturnValueType = tuple([array$1(number$1()), string$1()]), MutableReferenceOutputType = tuple([
  SuiArgument,
  array$1(number$1()),
  string$1()
]), ExecutionResultType = object({
  mutableReferenceOutputs: optional$1(array$1(MutableReferenceOutputType)),
  returnValues: optional$1(array$1(ReturnValueType))
}), DevInspectResults = object({
  effects: TransactionEffects,
  events: TransactionEvents,
  results: optional$1(array$1(ExecutionResultType)),
  error: optional$1(string$1())
}), AuthorityName = string$1(), SuiTransactionBlock = object({
  data: SuiTransactionBlockData,
  txSignatures: array$1(string$1())
}), SuiObjectChangePublished = object({
  type: literal$1("published"),
  packageId: ObjectId,
  version: SequenceNumber,
  digest: ObjectDigest,
  modules: array$1(string$1())
}), SuiObjectChangeTransferred = object({
  type: literal$1("transferred"),
  sender: SuiAddress,
  recipient: ObjectOwner,
  objectType: string$1(),
  objectId: ObjectId,
  version: SequenceNumber,
  digest: ObjectDigest
}), SuiObjectChangeMutated = object({
  type: literal$1("mutated"),
  sender: SuiAddress,
  owner: ObjectOwner,
  objectType: string$1(),
  objectId: ObjectId,
  version: SequenceNumber,
  previousVersion: SequenceNumber,
  digest: ObjectDigest
}), SuiObjectChangeDeleted = object({
  type: literal$1("deleted"),
  sender: SuiAddress,
  objectType: string$1(),
  objectId: ObjectId,
  version: SequenceNumber
}), SuiObjectChangeWrapped = object({
  type: literal$1("wrapped"),
  sender: SuiAddress,
  objectType: string$1(),
  objectId: ObjectId,
  version: SequenceNumber
}), SuiObjectChangeCreated = object({
  type: literal$1("created"),
  sender: SuiAddress,
  owner: ObjectOwner,
  objectType: string$1(),
  objectId: ObjectId,
  version: SequenceNumber,
  digest: ObjectDigest
}), SuiObjectChange = union$2([
  SuiObjectChangePublished,
  SuiObjectChangeTransferred,
  SuiObjectChangeMutated,
  SuiObjectChangeDeleted,
  SuiObjectChangeWrapped,
  SuiObjectChangeCreated
]), BalanceChange = object({
  owner: ObjectOwner,
  coinType: string$1(),
  /* Coin balance change(positive means receive, negative means send) */
  amount: string$1()
}), SuiTransactionBlockResponse = object({
  digest: TransactionDigest,
  transaction: optional$1(SuiTransactionBlock),
  effects: optional$1(TransactionEffects),
  events: optional$1(TransactionEvents),
  timestampMs: optional$1(string$1()),
  checkpoint: optional$1(string$1()),
  confirmedLocalExecution: optional$1(boolean$1()),
  objectChanges: optional$1(array$1(SuiObjectChange)),
  balanceChanges: optional$1(array$1(BalanceChange)),
  /* Errors that occurred in fetching/serializing the transaction. */
  errors: optional$1(array$1(string$1()))
});
object({
  /* Whether to show transaction input data. Default to be false. */
  showInput: optional$1(boolean$1()),
  /* Whether to show transaction effects. Default to be false. */
  showEffects: optional$1(boolean$1()),
  /* Whether to show transaction events. Default to be false. */
  showEvents: optional$1(boolean$1()),
  /* Whether to show object changes. Default to be false. */
  showObjectChanges: optional$1(boolean$1()),
  /* Whether to show coin balance changes. Default to be false. */
  showBalanceChanges: optional$1(boolean$1())
});
var PaginatedTransactionResponse = object({
  data: array$1(SuiTransactionBlockResponse),
  nextCursor: nullable$1(TransactionDigest),
  hasNextPage: boolean$1()
}), DryRunTransactionBlockResponse = object({
  effects: TransactionEffects,
  events: TransactionEvents,
  objectChanges: array$1(SuiObjectChange),
  balanceChanges: array$1(BalanceChange),
  // TODO: Remove optional when this is rolled out to all networks:
  input: optional$1(SuiTransactionBlockData)
}), SUI_FRAMEWORK_ADDRESS = "0x2", MOVE_STDLIB_ADDRESS = "0x1", OBJECT_MODULE_NAME = "object", ID_STRUCT_NAME = "ID", SUI_TYPE_ARG = `${SUI_FRAMEWORK_ADDRESS}::sui::SUI`;
normalizeSuiObjectId("0x6");
var CoinMetadataStruct = object({
  decimals: number$1(),
  name: string$1(),
  symbol: string$1(),
  description: string$1(),
  iconUrl: nullable$1(string$1()),
  id: nullable$1(ObjectId)
}), VECTOR = "vector", TransactionDataV1 = {
  kind: "TransactionKind",
  sender: BCS.ADDRESS,
  gasData: "GasData",
  expiration: "TransactionExpiration"
}, BCS_SPEC = {
  enums: {
    "Option<T>": {
      None: null,
      Some: "T"
    },
    ObjectArg: {
      ImmOrOwned: "SuiObjectRef",
      Shared: "SharedObjectRef"
    },
    CallArg: {
      Pure: [VECTOR, BCS.U8],
      Object: "ObjectArg",
      ObjVec: [VECTOR, "ObjectArg"]
    },
    TypeTag: {
      bool: null,
      u8: null,
      u64: null,
      u128: null,
      address: null,
      signer: null,
      vector: "TypeTag",
      struct: "StructTag",
      u16: null,
      u32: null,
      u256: null
    },
    TransactionKind: {
      // can not be called from sui.js; dummy placement
      // to set the enum counter right for ProgrammableTransact
      ProgrammableTransaction: "ProgrammableTransaction",
      ChangeEpoch: null,
      Genesis: null,
      ConsensusCommitPrologue: null
    },
    TransactionExpiration: {
      None: null,
      Epoch: BCS.U64
    },
    TransactionData: {
      V1: "TransactionDataV1"
    }
  },
  structs: {
    SuiObjectRef: {
      objectId: BCS.ADDRESS,
      version: BCS.U64,
      digest: "ObjectDigest"
    },
    SharedObjectRef: {
      objectId: BCS.ADDRESS,
      initialSharedVersion: BCS.U64,
      mutable: BCS.BOOL
    },
    StructTag: {
      address: BCS.ADDRESS,
      module: BCS.STRING,
      name: BCS.STRING,
      typeParams: [VECTOR, "TypeTag"]
    },
    GasData: {
      payment: [VECTOR, "SuiObjectRef"],
      owner: BCS.ADDRESS,
      price: BCS.U64,
      budget: BCS.U64
    },
    // Signed transaction data needed to generate transaction digest.
    SenderSignedData: {
      data: "TransactionData",
      txSignatures: [VECTOR, [VECTOR, BCS.U8]]
    },
    TransactionDataV1
  },
  aliases: {
    ObjectDigest: BCS.BASE58
  }
}, bcs = new BCS({ ...getSuiMoveConfig(), types: BCS_SPEC });
bcs.registerType(
  "utf8string",
  (C, e) => {
    const T = Array.from(new TextEncoder().encode(e));
    return C.writeVec(T, ($, V) => $.write8(V));
  },
  (C) => {
    let e = C.readVec((T) => T.read8());
    return new TextDecoder().decode(new Uint8Array(e));
  }
);
var FaucetCoinInfo = object({
  amount: number$1(),
  id: ObjectId,
  transferTxDigest: TransactionDigest
});
object({
  transferredGasObjects: array$1(FaucetCoinInfo),
  error: nullable$1(string$1())
});
var SuiMoveFunctionArgType = union$2([
  string$1(),
  object({ Object: string$1() })
]), SuiMoveFunctionArgTypes = array$1(SuiMoveFunctionArgType), SuiMoveModuleId = object({
  address: string$1(),
  name: string$1()
}), SuiMoveVisibility = union$2([
  literal$1("Private"),
  literal$1("Public"),
  literal$1("Friend")
]), SuiMoveAbilitySet = object({
  abilities: array$1(string$1())
}), SuiMoveStructTypeParameter = object({
  constraints: SuiMoveAbilitySet,
  isPhantom: boolean$1()
}), SuiMoveNormalizedTypeParameterType = object({
  TypeParameter: number$1()
});
function isSuiMoveNormalizedType(C) {
  if (!C)
    return !1;
  if (typeof C == "string" || is$1(C, SuiMoveNormalizedTypeParameterType) || isSuiMoveNormalizedStructType(C))
    return !0;
  if (typeof C != "object")
    return !1;
  const e = C;
  return !!(is$1(e.Reference, SuiMoveNormalizedType) || is$1(e.MutableReference, SuiMoveNormalizedType) || is$1(e.Vector, SuiMoveNormalizedType));
}
var SuiMoveNormalizedType = define$1(
  "SuiMoveNormalizedType",
  isSuiMoveNormalizedType
);
function isSuiMoveNormalizedStructType(C) {
  if (!C || typeof C != "object")
    return !1;
  const e = C;
  if (!e.Struct || typeof e.Struct != "object")
    return !1;
  const T = e.Struct;
  return !(typeof T.address != "string" || typeof T.module != "string" || typeof T.name != "string" || !Array.isArray(T.typeArguments) || !T.typeArguments.every(
    ($) => isSuiMoveNormalizedType($)
  ));
}
define$1(
  "SuiMoveNormalizedStructType",
  isSuiMoveNormalizedStructType
);
var SuiMoveNormalizedFunction = object({
  visibility: SuiMoveVisibility,
  isEntry: boolean$1(),
  typeParameters: array$1(SuiMoveAbilitySet),
  parameters: array$1(SuiMoveNormalizedType),
  return: array$1(SuiMoveNormalizedType)
}), SuiMoveNormalizedField = object({
  name: string$1(),
  type: SuiMoveNormalizedType
}), SuiMoveNormalizedStruct = object({
  abilities: SuiMoveAbilitySet,
  typeParameters: array$1(SuiMoveStructTypeParameter),
  fields: array$1(SuiMoveNormalizedField)
}), SuiMoveNormalizedModule = object({
  fileFormatVersion: number$1(),
  address: string$1(),
  name: string$1(),
  friends: array$1(SuiMoveModuleId),
  structs: record(string$1(), SuiMoveNormalizedStruct),
  exposedFunctions: record(string$1(), SuiMoveNormalizedFunction)
}), SuiMoveNormalizedModules = record(
  string$1(),
  SuiMoveNormalizedModule
);
function extractMutableReference(C) {
  return typeof C == "object" && "MutableReference" in C ? C.MutableReference : void 0;
}
function extractReference(C) {
  return typeof C == "object" && "Reference" in C ? C.Reference : void 0;
}
function extractStructTag(C) {
  if (typeof C == "object" && "Struct" in C)
    return C;
  const e = extractReference(C), T = extractMutableReference(C);
  if (typeof e == "object" && "Struct" in e)
    return e;
  if (typeof T == "object" && "Struct" in T)
    return T;
}
object({
  value: number$1()
});
var StakeObject = object({
  stakedSuiId: ObjectId,
  stakeRequestEpoch: EpochId,
  stakeActiveEpoch: EpochId,
  principal: string$1(),
  status: union$2([literal$1("Active"), literal$1("Pending"), literal$1("Unstaked")]),
  estimatedReward: optional$1(string$1())
}), DelegatedStake = object({
  validatorAddress: SuiAddress,
  stakingPool: ObjectId,
  stakes: array$1(StakeObject)
}), StakeSubsidyFields = object({
  balance: object({ value: number$1() }),
  distribution_counter: number$1(),
  current_distribution_amount: number$1(),
  stake_subsidy_period_length: number$1(),
  stake_subsidy_decrease_rate: number$1()
});
object({
  type: string$1(),
  fields: StakeSubsidyFields
});
object({
  value: number$1()
});
var ContentsFields = object({
  id: string$1(),
  size: number$1(),
  head: object({ vec: array$1() }),
  tail: object({ vec: array$1() })
});
object({
  id: string$1(),
  size: number$1()
});
object({
  type: string$1(),
  fields: ContentsFields
});
var DelegationStakingPoolFields = object({
  exchangeRates: object({
    id: string$1(),
    size: number$1()
  }),
  id: string$1(),
  pendingStake: number$1(),
  pendingPoolTokenWithdraw: number$1(),
  pendingTotalSuiWithdraw: number$1(),
  poolTokenBalance: number$1(),
  rewardsPool: object({ value: number$1() }),
  activationEpoch: object({ vec: array$1() }),
  deactivationEpoch: object({ vec: array$1() }),
  suiBalance: number$1()
});
object({
  type: string$1(),
  fields: DelegationStakingPoolFields
});
var Validators = array$1(tuple([AuthorityName, string$1()])), CommitteeInfo = object({
  epoch: EpochId,
  /** Array of (validator public key, stake unit) tuple */
  validators: Validators
}), SuiValidatorSummary = object({
  suiAddress: SuiAddress,
  protocolPubkeyBytes: string$1(),
  networkPubkeyBytes: string$1(),
  workerPubkeyBytes: string$1(),
  proofOfPossessionBytes: string$1(),
  operationCapId: string$1(),
  name: string$1(),
  description: string$1(),
  imageUrl: string$1(),
  projectUrl: string$1(),
  p2pAddress: string$1(),
  netAddress: string$1(),
  primaryAddress: string$1(),
  workerAddress: string$1(),
  nextEpochProtocolPubkeyBytes: nullable$1(string$1()),
  nextEpochProofOfPossession: nullable$1(string$1()),
  nextEpochNetworkPubkeyBytes: nullable$1(string$1()),
  nextEpochWorkerPubkeyBytes: nullable$1(string$1()),
  nextEpochNetAddress: nullable$1(string$1()),
  nextEpochP2pAddress: nullable$1(string$1()),
  nextEpochPrimaryAddress: nullable$1(string$1()),
  nextEpochWorkerAddress: nullable$1(string$1()),
  votingPower: string$1(),
  gasPrice: string$1(),
  commissionRate: string$1(),
  nextEpochStake: string$1(),
  nextEpochGasPrice: string$1(),
  nextEpochCommissionRate: string$1(),
  stakingPoolId: string$1(),
  stakingPoolActivationEpoch: nullable$1(string$1()),
  stakingPoolDeactivationEpoch: nullable$1(string$1()),
  stakingPoolSuiBalance: string$1(),
  rewardsPool: string$1(),
  poolTokenBalance: string$1(),
  pendingStake: string$1(),
  pendingPoolTokenWithdraw: string$1(),
  pendingTotalSuiWithdraw: string$1(),
  exchangeRatesId: string$1(),
  exchangeRatesSize: string$1()
}), SuiSystemStateSummary = object({
  epoch: string$1(),
  protocolVersion: string$1(),
  systemStateVersion: string$1(),
  storageFundTotalObjectStorageRebates: string$1(),
  storageFundNonRefundableBalance: string$1(),
  referenceGasPrice: string$1(),
  safeMode: boolean$1(),
  safeModeStorageRewards: string$1(),
  safeModeComputationRewards: string$1(),
  safeModeStorageRebates: string$1(),
  safeModeNonRefundableStorageFee: string$1(),
  epochStartTimestampMs: string$1(),
  epochDurationMs: string$1(),
  stakeSubsidyStartEpoch: string$1(),
  maxValidatorCount: string$1(),
  minValidatorJoiningStake: string$1(),
  validatorLowStakeThreshold: string$1(),
  validatorVeryLowStakeThreshold: string$1(),
  validatorLowStakeGracePeriod: string$1(),
  stakeSubsidyBalance: string$1(),
  stakeSubsidyDistributionCounter: string$1(),
  stakeSubsidyCurrentDistributionAmount: string$1(),
  stakeSubsidyPeriodLength: string$1(),
  stakeSubsidyDecreaseRate: number$1(),
  totalStake: string$1(),
  activeValidators: array$1(SuiValidatorSummary),
  pendingActiveValidatorsId: string$1(),
  pendingActiveValidatorsSize: string$1(),
  pendingRemovals: array$1(string$1()),
  stakingPoolMappingsId: string$1(),
  stakingPoolMappingsSize: string$1(),
  inactivePoolsId: string$1(),
  inactivePoolsSize: string$1(),
  validatorCandidatesId: string$1(),
  validatorCandidatesSize: string$1(),
  atRiskValidators: array$1(tuple([SuiAddress, string$1()])),
  validatorReportRecords: array$1(tuple([SuiAddress, array$1(SuiAddress)]))
}), CoinStruct = object({
  coinType: string$1(),
  // TODO(chris): rename this to objectId
  coinObjectId: ObjectId,
  version: string$1(),
  digest: TransactionDigest,
  balance: string$1(),
  // TODO (jian): remove this when we move to 0.34
  lockedUntilEpoch: optional$1(nullable$1(number$1())),
  previousTransaction: TransactionDigest
}), PaginatedCoins = object({
  data: array$1(CoinStruct),
  nextCursor: nullable$1(ObjectId),
  hasNextPage: boolean$1()
}), CoinBalance = object({
  coinType: string$1(),
  coinObjectCount: number$1(),
  totalBalance: string$1(),
  lockedBalance: object({
    epochId: optional$1(number$1()),
    number: optional$1(number$1())
  })
}), CoinSupply = object({
  value: string$1()
}), EndOfEpochInfo = object({
  lastCheckpointId: string$1(),
  epochEndTimestamp: string$1(),
  protocolVersion: string$1(),
  referenceGasPrice: string$1(),
  totalStake: string$1(),
  storageFundReinvestment: string$1(),
  storageCharge: string$1(),
  storageRebate: string$1(),
  storageFundBalance: string$1(),
  stakeSubsidyAmount: string$1(),
  totalGasFees: string$1(),
  totalStakeRewardsDistributed: string$1(),
  leftoverStorageFundInflow: string$1()
}), EpochInfo = object({
  epoch: string$1(),
  validators: array$1(SuiValidatorSummary),
  epochTotalTransactions: string$1(),
  firstCheckpointId: string$1(),
  epochStartTimestamp: string$1(),
  endOfEpochInfo: nullable$1(EndOfEpochInfo)
}), EpochPage = object({
  data: array$1(EpochInfo),
  nextCursor: nullable$1(string$1()),
  hasNextPage: boolean$1()
}), GasCostSummary2 = object({
  computationCost: string$1(),
  storageCost: string$1(),
  storageRebate: string$1(),
  nonRefundableStorageFee: string$1()
});
string$1();
var CheckpointDigest = string$1();
object({
  digest: array$1(number$1())
});
var CheckpointCommitment = any$1(), ValidatorSignature = string$1(), EndOfEpochData = object({
  nextEpochCommittee: array$1(tuple([string$1(), string$1()])),
  nextEpochProtocolVersion: string$1(),
  epochCommitments: array$1(CheckpointCommitment)
});
object({
  transaction: TransactionDigest,
  effects: TransactionEffectsDigest
});
var Checkpoint = object({
  epoch: string$1(),
  sequenceNumber: string$1(),
  digest: CheckpointDigest,
  networkTotalTransactions: string$1(),
  previousDigest: optional$1(CheckpointDigest),
  epochRollingGasCostSummary: GasCostSummary2,
  timestampMs: string$1(),
  endOfEpochData: optional$1(EndOfEpochData),
  // TODO(jian): remove optional after 0.30.0 is released
  validatorSignature: optional$1(ValidatorSignature),
  transactions: array$1(TransactionDigest),
  checkpointCommitments: array$1(CheckpointCommitment)
}), CheckpointPage = object({
  data: array$1(Checkpoint),
  nextCursor: nullable$1(string$1()),
  hasNextPage: boolean$1()
}), PACKAGE_VERSION = "0.32.2", TARGETED_RPC_VERSION = "0.34.0", RPCError = class extends Error {
  constructor(C) {
    super(
      C.cause ? `RPC Error: ${C.cause.message}` : "Unknown RPC Error",
      { cause: C.cause }
    ), this.req = C.req, this.code = C.code, this.data = C.data;
  }
}, RPCValidationError = class extends Error {
  constructor(C) {
    super(
      "RPC Validation Error: The response returned from RPC server does not match the TypeScript definition. This is likely because the SDK version is not compatible with the RPC server.",
      { cause: C.cause }
    ), this.req = C.req, this.result = C.result, this.message = this.toString();
  }
  toString() {
    let C = super.toString();
    return this.cause && (C += `
Cause: ${this.cause}`), this.result && (C += `
Reponse Received: ${JSON.stringify(this.result, null, 2)}`), C;
  }
}, FaucetRateLimitError = class extends Error {
}, ValidResponse = object({
  jsonrpc: literal$1("2.0"),
  id: string$1(),
  result: any$1()
}), ErrorResponse = object({
  jsonrpc: literal$1("2.0"),
  id: string$1(),
  error: object({
    code: any$1(),
    message: string$1(),
    data: optional$1(any$1())
  })
}), JsonRpcClient = class {
  constructor(C, e) {
    this.rpcClient = new RpcClient(
      async (T, $) => {
        const V = {
          method: "POST",
          body: T,
          headers: {
            "Content-Type": "application/json",
            "Client-Sdk-Type": "typescript",
            "Client-Sdk-Version": PACKAGE_VERSION,
            "Client-Target-Api-Version": TARGETED_RPC_VERSION,
            ...e
          }
        };
        try {
          let J = await fetch(C, V);
          const ee = await J.text();
          if (J.ok)
            $(null, ee);
          else {
            const te = J.headers.get("content-type") === "text/html";
            $(
              new Error(
                `${J.status} ${J.statusText}${te ? "" : `: ${ee}`}`
              )
            );
          }
        } catch (J) {
          $(J);
        }
      },
      {}
    );
  }
  async requestWithType(C, e, T) {
    const $ = { method: C, args: e }, V = await this.request(C, e);
    if (is$1(V, ErrorResponse))
      throw new RPCError({
        req: $,
        code: V.error.code,
        data: V.error.data,
        cause: new Error(V.error.message)
      });
    if (is$1(V, ValidResponse)) {
      const [J] = validate$2(V.result, T);
      return J && console.warn(
        new RPCValidationError({
          req: $,
          result: V.result,
          cause: J
        })
      ), V.result;
    }
    throw new RPCError({ req: $, data: V });
  }
  async request(C, e) {
    return new Promise((T, $) => {
      this.rpcClient.request(C, e, (V, J) => {
        if (V) {
          $(V);
          return;
        }
        T(J);
      });
    });
  }
}, DynamicFieldType = union$2([
  literal$1("DynamicField"),
  literal$1("DynamicObject")
]), DynamicFieldName = object({
  type: string$1(),
  value: any$1()
}), DynamicFieldInfo = object({
  name: DynamicFieldName,
  bcsName: string$1(),
  type: DynamicFieldType,
  objectType: string$1(),
  objectId: ObjectId,
  version: number$1(),
  digest: string$1()
}), DynamicFieldPage = object({
  data: array$1(DynamicFieldInfo),
  nextCursor: nullable$1(ObjectId),
  hasNextPage: boolean$1()
}), getWebsocketUrl = (C, e) => {
  const T = new URL(C);
  return T.protocol = T.protocol.replace("http", "ws"), T.toString();
}, isMinimumSubscriptionMessage = (C) => C && "subscription" in C && typeof C.subscription == "number" && "result" in C && typeof C.result == "object", DEFAULT_CLIENT_OPTIONS = {
  connectTimeout: 15e3,
  callTimeout: 3e4,
  reconnectInterval: 3e3,
  maxReconnects: 5
}, SUBSCRIBE_EVENT_METHOD = "suix_subscribeEvent", UNSUBSCRIBE_EVENT_METHOD = "suix_unsubscribeEvent", WebsocketClient = class {
  /**
   * @param endpoint Sui node endpoint to connect to (accepts websocket & http)
   * @param options Configuration options, such as timeouts & connection behavior
   */
  constructor(C, e = DEFAULT_CLIENT_OPTIONS) {
    this.endpoint = C, this.options = e, this.connectionState = 0, this.connectionTimeout = null, this.isSetup = !1, this.connectionPromise = null, this.eventSubscriptions = /* @__PURE__ */ new Map(), this.endpoint.startsWith("http") && (this.endpoint = getWebsocketUrl(this.endpoint)), this.rpcClient = new Client_1(this.endpoint, {
      reconnect_interval: this.options.reconnectInterval,
      max_reconnects: this.options.maxReconnects,
      autoconnect: !1
    });
  }
  setupSocket() {
    this.isSetup || (this.rpcClient.on("open", () => {
      this.connectionTimeout && (clearTimeout(this.connectionTimeout), this.connectionTimeout = null), this.connectionState = 2, this.rpcClient.socket.on(
        "message",
        this.onSocketMessage.bind(this)
      );
    }), this.rpcClient.on("close", () => {
      this.connectionState = 0;
    }), this.rpcClient.on("error", console.error), this.isSetup = !0);
  }
  // called for every message received from the node over websocket
  onSocketMessage(C) {
    const e = JSON.parse(C), T = e.params;
    if (e.method === SUBSCRIBE_EVENT_METHOD) {
      if (isMinimumSubscriptionMessage(T)) {
        const $ = this.eventSubscriptions.get(T.subscription);
        $ && $.onMessage(T.result);
      } else if (is$1(T, SubscriptionEvent)) {
        const $ = this.eventSubscriptions.get(T.subscription);
        $ && $.onMessage(T.result);
      }
    }
  }
  async connect() {
    return this.connectionPromise ? this.connectionPromise : this.connectionState === 2 ? Promise.resolve() : (this.setupSocket(), this.rpcClient.connect(), this.connectionState = 1, this.connectionPromise = new Promise((C, e) => {
      this.connectionTimeout = setTimeout(
        () => e(new Error("timeout")),
        this.options.connectTimeout
      ), this.rpcClient.once("open", () => {
        this.refreshSubscriptions(), this.connectionPromise = null, C();
      }), this.rpcClient.once("error", (T) => {
        this.connectionPromise = null, e(T);
      });
    }), this.connectionPromise);
  }
  /**
    call only upon reconnecting to a node over websocket.
    calling multiple times on the same connection will result
    in multiple message handlers firing each time
  */
  async refreshSubscriptions() {
    if (this.eventSubscriptions.size !== 0)
      try {
        let C = /* @__PURE__ */ new Map();
        (await Promise.all(
          Array.from(this.eventSubscriptions.values()).map(async (T) => {
            const $ = T.onMessage, V = T.filter;
            return !V || !$ ? Promise.resolve(null) : { id: await this.subscribeEvent(V, $), onMessage: $, filter: V };
          })
        )).forEach((T) => {
          if (T === null)
            return;
          const $ = T.filter, V = T.onMessage;
          C.set(T.id, { filter: $, onMessage: V });
        }), this.eventSubscriptions = C;
      } catch (C) {
        throw new Error(`error refreshing event subscriptions: ${C}`);
      }
  }
  async subscribeEvent(C, e) {
    try {
      this.connectionState !== 2 && await this.connect();
      let T = await this.rpcClient.call(
        SUBSCRIBE_EVENT_METHOD,
        [C],
        this.options.callTimeout
      );
      return this.eventSubscriptions.set(T, { filter: C, onMessage: e }), T;
    } catch (T) {
      throw new Error(
        `Error subscribing to event: ${JSON.stringify(
          T,
          null,
          2
        )}, filter: ${JSON.stringify(C)}`
      );
    }
  }
  async unsubscribeEvent(C) {
    try {
      this.connectionState !== 2 && await this.connect();
      let e = await this.rpcClient.call(
        UNSUBSCRIBE_EVENT_METHOD,
        [C],
        this.options.callTimeout
      );
      return this.eventSubscriptions.delete(C) || e;
    } catch (e) {
      throw new Error(
        `Error unsubscribing from event: ${e}, subscription: ${C}`
      );
    }
  }
};
async function requestSuiFromFaucet(C, e, T) {
  const $ = await fetch(C, {
    method: "POST",
    body: JSON.stringify({
      FixedAmountRequest: {
        recipient: e
      }
    }),
    headers: {
      "Content-Type": "application/json",
      ...T || {}
    }
  });
  if ($.status === 429)
    throw new FaucetRateLimitError(
      "Too many requests from this client have been sent to the faucet. Please retry later"
    );
  let V;
  try {
    V = await $.json();
  } catch (J) {
    throw new Error(
      `Encountered error when parsing response from faucet, error: ${J}, status ${$.status}, response ${$}`
    );
  }
  if (V.error)
    throw new Error(`Faucet returns error: ${V.error}`);
  return V;
}
var _options, Connection = class {
  constructor(C) {
    __privateAdd(this, _options, void 0), __privateSet(this, _options, C);
  }
  get fullnode() {
    return __privateGet(this, _options).fullnode;
  }
  // TODO: Decide if we should default the websocket URL like this:
  get websocket() {
    return __privateGet(this, _options).websocket || __privateGet(this, _options).fullnode;
  }
  get faucet() {
    return __privateGet(this, _options).faucet;
  }
};
_options = /* @__PURE__ */ new WeakMap();
new Connection({
  fullnode: "http://127.0.0.1:9000",
  faucet: "http://127.0.0.1:9123/gas"
});
var devnetConnection = new Connection({
  fullnode: "https://fullnode.devnet.sui.io:443/",
  faucet: "https://faucet.devnet.sui.io/gas"
});
new Connection({
  fullnode: "https://fullnode.testnet.sui.io:443/",
  faucet: "https://faucet.testnet.sui.io/gas"
});
function create$1(C, e) {
  return create$2(C, e);
}
var TRANSACTION_TYPE = Symbol("transaction-argument-type"), option = (C) => union$2([object({ None: literal$1(null) }), object({ Some: C })]), TransactionBlockInput = object({
  kind: literal$1("Input"),
  index: integer(),
  value: optional$1(any$1()),
  type: optional$1(union$2([literal$1("pure"), literal$1("object")]))
}), TransactionArgumentTypes = [
  TransactionBlockInput,
  object({ kind: literal$1("GasCoin") }),
  object({ kind: literal$1("Result"), index: integer() }),
  object({
    kind: literal$1("NestedResult"),
    index: integer(),
    resultIndex: integer()
  })
], TransactionArgument = union$2([...TransactionArgumentTypes]), ObjectTransactionArgument = union$2([...TransactionArgumentTypes]);
ObjectTransactionArgument[TRANSACTION_TYPE] = {
  kind: "object"
};
var PureTransactionArgument = (C) => {
  const e = union$2([...TransactionArgumentTypes]);
  return e[TRANSACTION_TYPE] = {
    kind: "pure",
    type: C
  }, e;
}, MoveCallTransaction = object({
  kind: literal$1("MoveCall"),
  target: define$1(
    "target",
    string$1().validator
  ),
  typeArguments: array$1(string$1()),
  arguments: array$1(TransactionArgument)
}), TransferObjectsTransaction = object({
  kind: literal$1("TransferObjects"),
  objects: array$1(ObjectTransactionArgument),
  address: PureTransactionArgument(BCS.ADDRESS)
}), SplitCoinsTransaction = object({
  kind: literal$1("SplitCoins"),
  coin: ObjectTransactionArgument,
  amounts: array$1(PureTransactionArgument("u64"))
}), MergeCoinsTransaction = object({
  kind: literal$1("MergeCoins"),
  destination: ObjectTransactionArgument,
  sources: array$1(ObjectTransactionArgument)
}), MakeMoveVecTransaction = object({
  kind: literal$1("MakeMoveVec"),
  type: optional$1(option(string$1())),
  objects: array$1(ObjectTransactionArgument)
}), PublishTransaction = object({
  kind: literal$1("Publish"),
  modules: array$1(array$1(integer())),
  dependencies: array$1(ObjectId)
}), UpgradeTransaction = object({
  kind: literal$1("Upgrade"),
  modules: array$1(array$1(integer())),
  dependencies: array$1(ObjectId),
  packageId: ObjectId,
  ticket: ObjectTransactionArgument
}), TransactionTypes = [
  MoveCallTransaction,
  TransferObjectsTransaction,
  SplitCoinsTransaction,
  MergeCoinsTransaction,
  PublishTransaction,
  UpgradeTransaction,
  MakeMoveVecTransaction
], TransactionType = union$2([...TransactionTypes]);
function getTransactionType(C) {
  return assert$2(C, TransactionType), TransactionTypes.find((e) => is$1(C, e));
}
var Transactions = {
  MoveCall(C) {
    return create$1(
      {
        kind: "MoveCall",
        target: C.target,
        arguments: C.arguments ?? [],
        typeArguments: C.typeArguments ?? []
      },
      MoveCallTransaction
    );
  },
  TransferObjects(C, e) {
    return create$1(
      { kind: "TransferObjects", objects: C, address: e },
      TransferObjectsTransaction
    );
  },
  SplitCoins(C, e) {
    return create$1({ kind: "SplitCoins", coin: C, amounts: e }, SplitCoinsTransaction);
  },
  MergeCoins(C, e) {
    return create$1(
      { kind: "MergeCoins", destination: C, sources: e },
      MergeCoinsTransaction
    );
  },
  Publish({
    modules: C,
    dependencies: e
  }) {
    return create$1(
      {
        kind: "Publish",
        modules: C.map(
          (T) => typeof T == "string" ? Array.from(fromB64(T)) : T
        ),
        dependencies: e.map((T) => normalizeSuiObjectId(T))
      },
      PublishTransaction
    );
  },
  Upgrade({
    modules: C,
    dependencies: e,
    packageId: T,
    ticket: $
  }) {
    return create$1(
      {
        kind: "Upgrade",
        modules: C.map(
          (V) => typeof V == "string" ? Array.from(fromB64(V)) : V
        ),
        dependencies: e.map((V) => normalizeSuiObjectId(V)),
        packageId: T,
        ticket: $
      },
      UpgradeTransaction
    );
  },
  MakeMoveVec({
    type: C,
    objects: e
  }) {
    return create$1(
      {
        kind: "MakeMoveVec",
        type: C ? { Some: C } : { None: null },
        objects: e
      },
      MakeMoveVecTransaction
    );
  }
}, VECTOR_REGEX = /^vector<(.+)>$/, STRUCT_REGEX = /^([^:]+)::([^:]+)::([^<]+)(<(.+)>)?/, TypeTagSerializer = class {
  static parseFromStr(C, e = !1) {
    if (C === "address")
      return { address: null };
    if (C === "bool")
      return { bool: null };
    if (C === "u8")
      return { u8: null };
    if (C === "u16")
      return { u16: null };
    if (C === "u32")
      return { u32: null };
    if (C === "u64")
      return { u64: null };
    if (C === "u128")
      return { u128: null };
    if (C === "u256")
      return { u256: null };
    if (C === "signer")
      return { signer: null };
    const T = C.match(VECTOR_REGEX);
    if (T)
      return {
        vector: TypeTagSerializer.parseFromStr(
          T[1],
          e
        )
      };
    const $ = C.match(STRUCT_REGEX);
    if ($)
      return {
        struct: {
          address: e ? normalizeSuiAddress($[1]) : $[1],
          module: $[2],
          name: $[3],
          typeParams: $[5] === void 0 ? [] : TypeTagSerializer.parseStructTypeArgs(
            $[5],
            e
          )
        }
      };
    throw new Error(
      `Encountered unexpected token when parsing type args for ${C}`
    );
  }
  static parseStructTypeArgs(C, e = !1) {
    const T = [];
    let $ = "", V = 0;
    for (let J = 0; J < C.length; J++) {
      const ee = C[J];
      if (ee === "<" && V++, ee === ">" && V--, V === 0 && ee === ",") {
        T.push($.trim()), $ = "";
        continue;
      }
      $ += ee;
    }
    return T.push($.trim()), T.map(
      (J) => TypeTagSerializer.parseFromStr(J, e)
    );
  }
  static tagToString(C) {
    if ("bool" in C)
      return "bool";
    if ("u8" in C)
      return "u8";
    if ("u16" in C)
      return "u16";
    if ("u32" in C)
      return "u32";
    if ("u64" in C)
      return "u64";
    if ("u128" in C)
      return "u128";
    if ("u256" in C)
      return "u256";
    if ("address" in C)
      return "address";
    if ("signer" in C)
      return "signer";
    if ("vector" in C)
      return `vector<${TypeTagSerializer.tagToString(C.vector)}>`;
    if ("struct" in C) {
      const e = C.struct, T = e.typeParams.map(TypeTagSerializer.tagToString).join(", ");
      return `${e.address}::${e.module}::${e.name}${T ? `<${T}>` : ""}`;
    }
    throw new Error("Invalid TypeTag");
  }
}, ARGUMENT_INNER = "Argument", VECTOR2 = "vector", OPTION = "Option", CALL_ARG = "CallArg", TYPE_TAG = "TypeTag", PROGRAMMABLE_TX_BLOCK = "ProgrammableTransaction", PROGRAMMABLE_CALL_INNER = "ProgrammableMoveCall", TRANSACTION_INNER = "Transaction", ENUM_KIND = "EnumKind", TRANSACTION = [ENUM_KIND, TRANSACTION_INNER], ARGUMENT = [ENUM_KIND, ARGUMENT_INNER], PROGRAMMABLE_CALL = "SimpleProgrammableMoveCall", builder = new BCS(bcs).registerStructType(PROGRAMMABLE_TX_BLOCK, {
  inputs: [VECTOR2, CALL_ARG],
  transactions: [VECTOR2, TRANSACTION]
}).registerEnumType(ARGUMENT_INNER, {
  GasCoin: null,
  Input: { index: BCS.U16 },
  Result: { index: BCS.U16 },
  NestedResult: { index: BCS.U16, resultIndex: BCS.U16 }
}).registerStructType(PROGRAMMABLE_CALL_INNER, {
  package: BCS.ADDRESS,
  module: BCS.STRING,
  function: BCS.STRING,
  type_arguments: [VECTOR2, TYPE_TAG],
  arguments: [VECTOR2, ARGUMENT]
}).registerEnumType(TRANSACTION_INNER, {
  /**
   * A Move Call - any public Move function can be called via
   * this transaction. The results can be used that instant to pass
   * into the next transaction.
   */
  MoveCall: PROGRAMMABLE_CALL,
  /**
   * Transfer vector of objects to a receiver.
   */
  TransferObjects: {
    objects: [VECTOR2, ARGUMENT],
    address: ARGUMENT
  },
  /**
   * Split `amount` from a `coin`.
   */
  SplitCoins: { coin: ARGUMENT, amounts: [VECTOR2, ARGUMENT] },
  /**
   * Merge Vector of Coins (`sources`) into a `destination`.
   */
  MergeCoins: { destination: ARGUMENT, sources: [VECTOR2, ARGUMENT] },
  /**
   * Publish a Move module.
   */
  Publish: {
    modules: [VECTOR2, [VECTOR2, BCS.U8]],
    dependencies: [VECTOR2, BCS.ADDRESS]
  },
  /**
   * Build a vector of objects using the input arguments.
   * It is impossible to construct a `vector<T: key>` otherwise,
   * so this call serves a utility function.
   */
  MakeMoveVec: {
    type: [OPTION, TYPE_TAG],
    objects: [VECTOR2, ARGUMENT]
  },
  /**  */
  Upgrade: {
    modules: [VECTOR2, [VECTOR2, BCS.U8]],
    dependencies: [VECTOR2, BCS.ADDRESS],
    packageId: BCS.ADDRESS,
    ticket: ARGUMENT
  }
});
builder.registerType(
  [ENUM_KIND, "T"],
  function(e, T, $, V) {
    const ee = { [T.kind]: T }, [te] = $;
    return this.getTypeInterface(te)._encodeRaw.call(
      this,
      e,
      ee,
      $,
      V
    );
  },
  function(e, T, $) {
    const [V] = T, J = this.getTypeInterface(V)._decodeRaw.call(
      this,
      e,
      T,
      $
    ), ee = Object.keys(J)[0];
    return { kind: ee, ...J[ee] };
  },
  (C) => {
    if (typeof C != "object" && !("kind" in C))
      throw new Error(
        `EnumKind: Missing property "kind" in the input ${JSON.stringify(
          C
        )}`
      );
    return !0;
  }
);
builder.registerType(
  PROGRAMMABLE_CALL,
  function(e, T, $, V) {
    const [J, ee, te] = T.target.split("::"), re = T.typeArguments.map(
      (ie) => TypeTagSerializer.parseFromStr(ie, !0)
    );
    return this.getTypeInterface(PROGRAMMABLE_CALL_INNER)._encodeRaw.call(
      this,
      e,
      {
        package: normalizeSuiAddress(J),
        module: ee,
        function: te,
        type_arguments: re,
        arguments: T.arguments
      },
      $,
      V
    );
  },
  function(e, T, $) {
    let V = builder.getTypeInterface(PROGRAMMABLE_CALL_INNER)._decodeRaw.call(this, e, T, $);
    return {
      target: [V.package, V.module, V.function].join("::"),
      arguments: V.arguments,
      typeArguments: V.type_arguments.map(TypeTagSerializer.tagToString)
    };
  },
  // Validation callback to error out if the data format is invalid.
  // TODO: make sure TypeTag can be parsed.
  (C) => C.target.split("::").length === 3
);
var ObjectArg = union$2([
  object({ ImmOrOwned: SuiObjectRef }),
  object({
    Shared: object({
      objectId: string$1(),
      initialSharedVersion: union$2([integer(), string$1()]),
      mutable: boolean$1()
    })
  })
]), PureCallArg = object({ Pure: array$1(integer()) }), ObjectCallArg = object({ Object: ObjectArg }), BuilderCallArg = union$2([PureCallArg, ObjectCallArg]), Inputs = {
  Pure(C, e) {
    return {
      Pure: Array.from(
        C instanceof Uint8Array ? C : builder.ser(e, C).toBytes()
      )
    };
  },
  ObjectRef({ objectId: C, digest: e, version: T }) {
    return {
      Object: {
        ImmOrOwned: {
          digest: e,
          version: T,
          objectId: normalizeSuiAddress(C)
        }
      }
    };
  },
  SharedObjectRef({
    objectId: C,
    mutable: e,
    initialSharedVersion: T
  }) {
    return {
      Object: {
        Shared: {
          mutable: e,
          initialSharedVersion: T,
          objectId: normalizeSuiAddress(C)
        }
      }
    };
  }
};
function getIdFromCallArg(C) {
  return typeof C == "string" ? normalizeSuiAddress(C) : "ImmOrOwned" in C.Object ? normalizeSuiAddress(C.Object.ImmOrOwned.objectId) : normalizeSuiAddress(C.Object.Shared.objectId);
}
function getSharedObjectInput(C) {
  return typeof C == "object" && "Object" in C && "Shared" in C.Object ? C.Object.Shared : void 0;
}
function isMutableSharedObjectInput(C) {
  var e;
  return ((e = getSharedObjectInput(C)) == null ? void 0 : e.mutable) ?? !1;
}
var STD_ASCII_MODULE_NAME = "ascii", STD_ASCII_STRUCT_NAME = "String", STD_UTF8_MODULE_NAME = "string", STD_UTF8_STRUCT_NAME = "String", STD_OPTION_MODULE_NAME = "option", STD_OPTION_STRUCT_NAME = "Option", RESOLVED_SUI_ID = {
  address: SUI_FRAMEWORK_ADDRESS,
  module: OBJECT_MODULE_NAME,
  name: ID_STRUCT_NAME
}, RESOLVED_ASCII_STR = {
  address: MOVE_STDLIB_ADDRESS,
  module: STD_ASCII_MODULE_NAME,
  name: STD_ASCII_STRUCT_NAME
}, RESOLVED_UTF8_STR = {
  address: MOVE_STDLIB_ADDRESS,
  module: STD_UTF8_MODULE_NAME,
  name: STD_UTF8_STRUCT_NAME
}, RESOLVED_STD_OPTION = {
  address: MOVE_STDLIB_ADDRESS,
  module: STD_OPTION_MODULE_NAME,
  name: STD_OPTION_STRUCT_NAME
}, isSameStruct = (C, e) => C.address === e.address && C.module === e.module && C.name === e.name;
function isTxContext(C) {
  var T;
  const e = (T = extractStructTag(C)) == null ? void 0 : T.Struct;
  return (e == null ? void 0 : e.address) === "0x2" && (e == null ? void 0 : e.module) === "tx_context" && (e == null ? void 0 : e.name) === "TxContext";
}
function expectType(C, e) {
  if (!(typeof e > "u") && typeof e !== C)
    throw new Error(
      `Expect ${e} to be ${C}, received ${typeof e}`
    );
}
var allowedTypes = [
  "Address",
  "Bool",
  "U8",
  "U16",
  "U32",
  "U64",
  "U128",
  "U256"
];
function getPureSerializationType(C, e) {
  if (typeof C == "string" && allowedTypes.includes(C)) {
    if (C in ["U8", "U16", "U32", "U64", "U128", "U256"])
      expectType("number", e);
    else if (C === "Bool")
      expectType("boolean", e);
    else if (C === "Address" && (expectType("string", e), e && !isValidSuiAddress(e)))
      throw new Error("Invalid Sui Address");
    return C.toLowerCase();
  } else if (typeof C == "string")
    throw new Error(
      `Unknown pure normalized type ${JSON.stringify(C, null, 2)}`
    );
  if ("Vector" in C) {
    if ((e === void 0 || typeof e == "string") && C.Vector === "U8")
      return "string";
    if (e !== void 0 && !Array.isArray(e))
      throw new Error(
        `Expect ${e} to be a array, received ${typeof e}`
      );
    const T = getPureSerializationType(
      C.Vector,
      // undefined when argVal is empty
      e ? e[0] : void 0
    );
    return T === void 0 ? void 0 : `vector<${T}>`;
  }
  if ("Struct" in C) {
    if (isSameStruct(C.Struct, RESOLVED_ASCII_STR))
      return "string";
    if (isSameStruct(C.Struct, RESOLVED_UTF8_STR))
      return "utf8string";
    if (isSameStruct(C.Struct, RESOLVED_SUI_ID))
      return "address";
    if (isSameStruct(C.Struct, RESOLVED_STD_OPTION)) {
      const T = {
        Vector: C.Struct.typeArguments[0]
      };
      return getPureSerializationType(T, e);
    }
  }
}
function hashTypedData(C, e) {
  const T = Array.from(`${C}::`).map((V) => V.charCodeAt(0)), $ = new Uint8Array(T.length + e.length);
  return $.set(T), $.set(e, T.length), blake2b($, { dkLen: 32 });
}
var TransactionExpiration = optional$1(
  nullable$1(
    union$2([
      object({ Epoch: integer() }),
      object({ None: union$2([literal$1(!0), literal$1(null)]) })
    ])
  )
), SuiAddress3 = string$1(), StringEncodedBigint = define$1("StringEncodedBigint", (C) => {
  if (!["string", "number", "bigint"].includes(typeof C))
    return !1;
  try {
    return BigInt(C), !0;
  } catch {
    return !1;
  }
}), GasConfig = object({
  budget: optional$1(StringEncodedBigint),
  price: optional$1(StringEncodedBigint),
  payment: optional$1(array$1(SuiObjectRef)),
  owner: optional$1(SuiAddress3)
}), SerializedTransactionDataBuilder = object({
  version: literal$1(1),
  sender: optional$1(SuiAddress3),
  expiration: TransactionExpiration,
  gasConfig: GasConfig,
  inputs: array$1(TransactionBlockInput),
  transactions: array$1(TransactionType)
});
function prepareSuiAddress(C) {
  return normalizeSuiAddress(C).replace("0x", "");
}
var TRANSACTION_DATA_MAX_SIZE = 128 * 1024, TransactionBlockDataBuilder = class {
  constructor(C) {
    this.version = 1, this.sender = C == null ? void 0 : C.sender, this.expiration = C == null ? void 0 : C.expiration, this.gasConfig = (C == null ? void 0 : C.gasConfig) ?? {}, this.inputs = (C == null ? void 0 : C.inputs) ?? [], this.transactions = (C == null ? void 0 : C.transactions) ?? [];
  }
  static fromKindBytes(C) {
    const e = builder.de("TransactionKind", C), T = e == null ? void 0 : e.ProgrammableTransaction;
    if (!T)
      throw new Error("Unable to deserialize from bytes.");
    const $ = create$1(
      {
        version: 1,
        gasConfig: {},
        inputs: T.inputs.map(
          (V, J) => create$1(
            {
              kind: "Input",
              value: V,
              index: J,
              type: is$1(V, PureCallArg) ? "pure" : "object"
            },
            TransactionBlockInput
          )
        ),
        transactions: T.transactions
      },
      SerializedTransactionDataBuilder
    );
    return TransactionBlockDataBuilder.restore($);
  }
  static fromBytes(C) {
    var J;
    const e = builder.de("TransactionData", C), T = e == null ? void 0 : e.V1, $ = (J = T == null ? void 0 : T.kind) == null ? void 0 : J.ProgrammableTransaction;
    if (!T || !$)
      throw new Error("Unable to deserialize from bytes.");
    const V = create$1(
      {
        version: 1,
        sender: T.sender,
        expiration: T.expiration,
        gasConfig: T.gasData,
        inputs: $.inputs.map(
          (ee, te) => create$1(
            {
              kind: "Input",
              value: ee,
              index: te,
              type: is$1(ee, PureCallArg) ? "pure" : "object"
            },
            TransactionBlockInput
          )
        ),
        transactions: $.transactions
      },
      SerializedTransactionDataBuilder
    );
    return TransactionBlockDataBuilder.restore(V);
  }
  static restore(C) {
    assert$2(C, SerializedTransactionDataBuilder);
    const e = new TransactionBlockDataBuilder();
    return Object.assign(e, C), e;
  }
  /**
   * Generate transaction digest.
   *
   * @param bytes BCS serialized transaction data
   * @returns transaction digest.
   */
  static getDigestFromBytes(C) {
    const e = hashTypedData("TransactionData", C);
    return toB58(e);
  }
  build({
    overrides: C,
    onlyTransactionKind: e
  } = {}) {
    const T = this.inputs.map((re) => (assert$2(re.value, BuilderCallArg), re.value)), $ = {
      ProgrammableTransaction: {
        inputs: T,
        transactions: this.transactions
      }
    };
    if (e)
      return builder.ser("TransactionKind", $, { maxSize: TRANSACTION_DATA_MAX_SIZE }).toBytes();
    const V = (C == null ? void 0 : C.expiration) ?? this.expiration, J = (C == null ? void 0 : C.sender) ?? this.sender, ee = { ...this.gasConfig, ...C == null ? void 0 : C.gasConfig };
    if (!J)
      throw new Error("Missing transaction sender");
    if (!ee.budget)
      throw new Error("Missing gas budget");
    if (!ee.payment)
      throw new Error("Missing gas payment");
    if (!ee.price)
      throw new Error("Missing gas price");
    const te = {
      sender: prepareSuiAddress(J),
      expiration: V || { None: !0 },
      gasData: {
        payment: ee.payment,
        owner: prepareSuiAddress(this.gasConfig.owner ?? J),
        price: BigInt(ee.price),
        budget: BigInt(ee.budget)
      },
      kind: {
        ProgrammableTransaction: {
          inputs: T,
          transactions: this.transactions
        }
      }
    };
    return builder.ser(
      "TransactionData",
      { V1: te },
      { maxSize: TRANSACTION_DATA_MAX_SIZE }
    ).toBytes();
  }
  getDigest() {
    const C = this.build({ onlyTransactionKind: !1 });
    return TransactionBlockDataBuilder.getDigestFromBytes(C);
  }
  snapshot() {
    return create$1(this, SerializedTransactionDataBuilder);
  }
};
function createTransactionResult(C) {
  const e = { kind: "Result", index: C }, T = [], $ = (V) => T[V] ?? (T[V] = {
    kind: "NestedResult",
    index: C,
    resultIndex: V
  });
  return new Proxy(e, {
    set() {
      throw new Error(
        "The transaction result is a proxy, and does not support setting properties directly"
      );
    },
    // TODO: Instead of making this return a concrete argument, we should ideally
    // make it reference-based (so that this gets resolved at build-time), which
    // allows re-ordering transactions.
    get(V, J) {
      if (J in V)
        return Reflect.get(V, J);
      if (J === Symbol.iterator)
        return function* () {
          let te = 0;
          for (; ; )
            yield $(te), te++;
        };
      if (typeof J == "symbol")
        return;
      const ee = parseInt(J, 10);
      if (!(Number.isNaN(ee) || ee < 0))
        return $(ee);
    }
  });
}
function expectProvider(C) {
  if (!C)
    throw new Error(
      "No provider passed to Transaction#build, but transaction data was not sufficient to build offline."
    );
  return C;
}
var TRANSACTION_BRAND = Symbol.for("@mysten/transaction"), MAX_GAS_OBJECTS = 256, MAX_GAS = 5e10, GAS_SAFE_OVERHEAD = 1000n, _blockData, _input, input_fn, _selectGasPayment, selectGasPayment_fn, _prepare, prepare_fn, _TransactionBlock = class {
  constructor(C) {
    __privateAdd(this, _input), __privateAdd(this, _selectGasPayment), __privateAdd(this, _prepare), __privateAdd(this, _blockData, void 0), __privateSet(this, _blockData, new TransactionBlockDataBuilder(
      C ? C.blockData : void 0
    ));
  }
  /** Returns `true` if the object is an instance of the Transaction builder class. */
  static is(C) {
    return !!C && typeof C == "object" && C[TRANSACTION_BRAND] === !0;
  }
  /**
   * Converts from a serialize transaction kind (built with `build({ onlyTransactionKind: true })`) to a `Transaction` class.
   * Supports either a byte array, or base64-encoded bytes.
   */
  static fromKind(C) {
    const e = new _TransactionBlock();
    return __privateSet(e, _blockData, TransactionBlockDataBuilder.fromKindBytes(
      typeof C == "string" ? fromB64(C) : C
    )), e;
  }
  /**
   * Converts from a serialized transaction format to a `Transaction` class.
   * There are two supported serialized formats:
   * - A string returned from `Transaction#serialize`. The serialized format must be compatible, or it will throw an error.
   * - A byte array (or base64-encoded bytes) containing BCS transaction data.
   */
  static from(C) {
    const e = new _TransactionBlock();
    return typeof C != "string" || !C.startsWith("{") ? __privateSet(e, _blockData, TransactionBlockDataBuilder.fromBytes(
      typeof C == "string" ? fromB64(C) : C
    )) : __privateSet(e, _blockData, TransactionBlockDataBuilder.restore(
      JSON.parse(C)
    )), e;
  }
  /** A helper to retrieve the Transaction builder `Transactions` */
  static get Transactions() {
    return Transactions;
  }
  /** A helper to retrieve the Transaction builder `Inputs` */
  static get Inputs() {
    return Inputs;
  }
  setSender(C) {
    __privateGet(this, _blockData).sender = C;
  }
  /**
   * Sets the sender only if it has not already been set.
   * This is useful for sponsored transaction flows where the sender may not be the same as the signer address.
   */
  setSenderIfNotSet(C) {
    __privateGet(this, _blockData).sender || (__privateGet(this, _blockData).sender = C);
  }
  setExpiration(C) {
    __privateGet(this, _blockData).expiration = C;
  }
  setGasPrice(C) {
    __privateGet(this, _blockData).gasConfig.price = String(C);
  }
  setGasBudget(C) {
    __privateGet(this, _blockData).gasConfig.budget = String(C);
  }
  setGasOwner(C) {
    __privateGet(this, _blockData).gasConfig.owner = C;
  }
  setGasPayment(C) {
    if (C.length >= MAX_GAS_OBJECTS)
      throw new Error(
        `Payment objects exceed maximum amount ${MAX_GAS_OBJECTS}`
      );
    __privateGet(this, _blockData).gasConfig.payment = C.map(
      (e) => mask$1(e, SuiObjectRef)
    );
  }
  /** Get a snapshot of the transaction data, in JSON form: */
  get blockData() {
    return __privateGet(this, _blockData).snapshot();
  }
  // Used to brand transaction classes so that they can be identified, even between multiple copies
  // of the builder.
  get [TRANSACTION_BRAND]() {
    return !0;
  }
  /** Returns an argument for the gas coin, to be used in a transaction. */
  get gas() {
    return { kind: "GasCoin" };
  }
  /**
   * Add a new object input to the transaction.
   */
  object(C) {
    const e = getIdFromCallArg(C);
    return __privateGet(this, _blockData).inputs.find(
      ($) => $.type === "object" && e === getIdFromCallArg($.value)
    ) ?? __privateMethod(this, _input, input_fn).call(this, "object", C);
  }
  /**
   * Add a new object input to the transaction using the fully-resolved object reference.
   * If you only have an object ID, use `builder.object(id)` instead.
   */
  objectRef(...C) {
    return this.object(Inputs.ObjectRef(...C));
  }
  /**
   * Add a new shared object input to the transaction using the fully-resolved shared object reference.
   * If you only have an object ID, use `builder.object(id)` instead.
   */
  sharedObjectRef(...C) {
    return this.object(Inputs.SharedObjectRef(...C));
  }
  /**
   * Add a new non-object input to the transaction.
   */
  pure(C, e) {
    return __privateMethod(this, _input, input_fn).call(this, "pure", C instanceof Uint8Array ? Inputs.Pure(C) : e ? Inputs.Pure(C, e) : C);
  }
  /** Add a transaction to the transaction block. */
  add(C) {
    const e = __privateGet(this, _blockData).transactions.push(C);
    return createTransactionResult(e - 1);
  }
  // Method shorthands:
  splitCoins(...C) {
    return this.add(Transactions.SplitCoins(...C));
  }
  mergeCoins(...C) {
    return this.add(Transactions.MergeCoins(...C));
  }
  publish(...C) {
    return this.add(Transactions.Publish(...C));
  }
  upgrade(...C) {
    return this.add(Transactions.Upgrade(...C));
  }
  moveCall(...C) {
    return this.add(Transactions.MoveCall(...C));
  }
  transferObjects(...C) {
    return this.add(Transactions.TransferObjects(...C));
  }
  makeMoveVec(...C) {
    return this.add(Transactions.MakeMoveVec(...C));
  }
  /**
   * Serialize the transaction to a string so that it can be sent to a separate context.
   * This is different from `build` in that it does not serialize to BCS bytes, and instead
   * uses a separate format that is unique to the transaction builder. This allows
   * us to serialize partially-complete transactions, that can then be completed and
   * built in a separate context.
   *
   * For example, a dapp can construct a transaction, but not provide gas objects
   * or a gas budget. The transaction then can be sent to the wallet, where this
   * information is automatically filled in (e.g. by querying for coin objects
   * and performing a dry run).
   */
  serialize() {
    return JSON.stringify(__privateGet(this, _blockData).snapshot());
  }
  /** Build the transaction to BCS bytes. */
  async build({
    provider: C,
    onlyTransactionKind: e
  } = {}) {
    return await __privateMethod(this, _prepare, prepare_fn).call(this, { provider: C, onlyTransactionKind: e }), __privateGet(this, _blockData).build({ onlyTransactionKind: e });
  }
  /** Derive transaction digest */
  async getDigest({
    provider: C
  } = {}) {
    return await __privateMethod(this, _prepare, prepare_fn).call(this, { provider: C }), __privateGet(this, _blockData).getDigest();
  }
}, TransactionBlock = _TransactionBlock;
_blockData = /* @__PURE__ */ new WeakMap();
_input = /* @__PURE__ */ new WeakSet();
input_fn = function(C, e) {
  const T = __privateGet(this, _blockData).inputs.length, $ = create$1(
    {
      kind: "Input",
      // bigints can't be serialized to JSON, so just string-convert them here:
      value: typeof e == "bigint" ? String(e) : e,
      index: T,
      type: C
    },
    TransactionBlockInput
  );
  return __privateGet(this, _blockData).inputs.push($), $;
};
_selectGasPayment = /* @__PURE__ */ new WeakSet();
selectGasPayment_fn = async function(C) {
  const e = __privateGet(this, _blockData).gasConfig.owner ?? __privateGet(this, _blockData).sender, $ = (await expectProvider(C).getCoins({
    owner: e,
    coinType: SUI_TYPE_ARG
  })).data.filter((V) => !__privateGet(this, _blockData).inputs.find((ee) => is$1(ee.value, BuilderCallArg) && "Object" in ee.value && "ImmOrOwned" in ee.value.Object ? V.coinObjectId === ee.value.Object.ImmOrOwned.objectId : !1)).slice(0, MAX_GAS_OBJECTS - 1).map((V) => ({
    objectId: V.coinObjectId,
    digest: V.digest,
    version: V.version
  }));
  if (!$.length)
    throw new Error("No valid gas coins found for the transaction.");
  return $;
};
_prepare = /* @__PURE__ */ new WeakSet();
prepare_fn = async function({ provider: C, onlyTransactionKind: e }) {
  if (!e && !__privateGet(this, _blockData).sender)
    throw new Error("Missing transaction sender");
  const { inputs: T, transactions: $ } = __privateGet(this, _blockData), V = [], J = [];
  if ($.forEach((ee) => {
    if (ee.kind === "MoveCall") {
      ee.arguments.some(
        (ie) => ie.kind === "Input" && !is$1(T[ie.index].value, BuilderCallArg)
      ) && V.push(ee);
      return;
    }
    const te = getTransactionType(ee);
    te.schema && Object.entries(ee).forEach(([re, ie]) => {
      if (re === "kind")
        return;
      const se = te.schema[re], de = se.type === "array", ue = de ? se.schema[TRANSACTION_TYPE] : se[TRANSACTION_TYPE];
      if (!ue)
        return;
      const fe = (he) => {
        const me = T[he];
        if (!me)
          throw new Error(`Missing input ${ie.index}`);
        if (!is$1(me.value, BuilderCallArg))
          if (ue.kind === "object" && typeof me.value == "string")
            J.push({ id: me.value, input: me });
          else if (ue.kind === "pure")
            me.value = Inputs.Pure(me.value, ue.type);
          else
            throw new Error("Unexpected input format.");
      };
      if (de)
        ie.forEach((he) => {
          he.kind === "Input" && fe(he.index);
        });
      else {
        if (ie.kind !== "Input")
          return;
        fe(ie.index);
      }
    });
  }), V.length && await Promise.all(
    V.map(async (ee) => {
      const [te, re, ie] = ee.target.split("::"), se = await expectProvider(
        C
      ).getNormalizedMoveFunction({
        package: normalizeSuiObjectId(te),
        module: re,
        function: ie
      }), ue = se.parameters.length > 0 && isTxContext(se.parameters.at(-1)) ? se.parameters.slice(0, se.parameters.length - 1) : se.parameters;
      if (ue.length !== ee.arguments.length)
        throw new Error("Incorrect number of arguments.");
      ue.forEach((fe, he) => {
        const me = ee.arguments[he];
        if (me.kind !== "Input")
          return;
        const xe = T[me.index];
        if (is$1(xe.value, BuilderCallArg))
          return;
        const ve = xe.value, Te = getPureSerializationType(fe, ve);
        if (Te) {
          xe.value = Inputs.Pure(ve, Te);
          return;
        }
        if (extractStructTag(fe) != null || typeof fe == "object" && "TypeParameter" in fe) {
          if (typeof ve != "string")
            throw new Error(
              `Expect the argument to be an object id string, got ${JSON.stringify(
                ve,
                null,
                2
              )}`
            );
          J.push({
            id: ve,
            input: xe,
            normalizedType: fe
          });
          return;
        }
        throw new Error(
          `Unknown call arg type ${JSON.stringify(
            fe,
            null,
            2
          )} for value ${JSON.stringify(ve, null, 2)}`
        );
      });
    })
  ), J.length) {
    const ee = [...new Set(J.map(({ id: se }) => se))], te = await expectProvider(C).multiGetObjects({
      ids: ee,
      options: { showOwner: !0 }
    });
    let re = new Map(
      ee.map((se, de) => [se, te[de]])
    );
    const ie = Array.from(re).filter(([se, de]) => de.error).map(([se, de]) => se);
    if (ie.length)
      throw new Error(
        `The following input objects are not invalid: ${ie.join(
          ", "
        )}`
      );
    J.forEach(({ id: se, input: de, normalizedType: ue }) => {
      const fe = re.get(se), he = getSharedObjectInitialVersion(fe);
      if (he) {
        const me = isMutableSharedObjectInput(de.value) || ue != null && extractMutableReference(ue) != null;
        de.value = Inputs.SharedObjectRef({
          objectId: se,
          initialSharedVersion: he,
          mutable: me
        });
      } else
        de.value = Inputs.ObjectRef(getObjectReference(fe));
    });
  }
  if (!e && (__privateGet(this, _blockData).gasConfig.price || this.setGasPrice(await expectProvider(C).getReferenceGasPrice()), __privateGet(this, _blockData).gasConfig.payment || (__privateGet(this, _blockData).gasConfig.payment = await __privateMethod(this, _selectGasPayment, selectGasPayment_fn).call(this, C)), !this.blockData.gasConfig.budget)) {
    const ee = await expectProvider(
      C
    ).dryRunTransactionBlock({
      transactionBlock: __privateGet(this, _blockData).build({
        overrides: {
          gasConfig: {
            budget: String(MAX_GAS),
            payment: []
          }
        }
      })
    });
    if (ee.effects.status.status !== "success")
      throw new Error(
        `Dry run failed, could not automatically determine a budget: ${ee.effects.status.error}`,
        { cause: ee }
      );
    const te = GAS_SAFE_OVERHEAD * BigInt(this.blockData.gasConfig.price || 1n), re = BigInt(ee.effects.gasUsed.computationCost) + te, ie = re + BigInt(ee.effects.gasUsed.storageCost) - BigInt(ee.effects.gasUsed.storageRebate);
    this.setGasBudget(
      ie > re ? ie : re
    );
  }
};
var NetworkMetrics = object({
  currentTps: number$1(),
  tps30Days: number$1(),
  currentCheckpoint: string$1(),
  currentEpoch: string$1(),
  totalAddresses: string$1(),
  totalObjects: string$1(),
  totalPackages: string$1()
}), DEFAULT_OPTIONS$1 = {
  socketOptions: DEFAULT_CLIENT_OPTIONS,
  versionCacheTimeoutInSeconds: 600
}, JsonRpcProvider = class {
  /**
   * Establish a connection to a Sui RPC endpoint
   *
   * @param connection The `Connection` object containing configuration for the network.
   * @param options configuration options for the provider
   */
  constructor(C = devnetConnection, e = DEFAULT_OPTIONS$1) {
    this.options = e, this.connection = C;
    const T = { ...DEFAULT_OPTIONS$1, ...e };
    this.options = T, this.client = T.rpcClient ?? new JsonRpcClient(this.connection.fullnode), this.wsClient = T.websocketClient ?? new WebsocketClient(this.connection.websocket, T.socketOptions);
  }
  async getRpcApiVersion() {
    if (this.rpcApiVersion && this.cacheExpiry && this.cacheExpiry <= Date.now())
      return this.rpcApiVersion;
    try {
      const C = await this.client.requestWithType("rpc.discover", [], any$1());
      return this.rpcApiVersion = C.info.version, this.cacheExpiry = // Date.now() is in milliseconds, but the timeout is in seconds
      Date.now() + (this.options.versionCacheTimeoutInSeconds ?? 0) * 1e3, this.rpcApiVersion;
    } catch (C) {
      console.warn("Error fetching version number of the RPC API", C);
    }
  }
  async requestSuiFromFaucet(C, e) {
    if (!this.connection.faucet)
      throw new Error("Faucet URL is not specified");
    return requestSuiFromFaucet(this.connection.faucet, C, e);
  }
  /**
   * Get all Coin<`coin_type`> objects owned by an address.
   */
  async getCoins(C) {
    if (!C.owner || !isValidSuiAddress(normalizeSuiAddress(C.owner)))
      throw new Error("Invalid Sui address");
    return await this.client.requestWithType(
      "suix_getCoins",
      [C.owner, C.coinType, C.cursor, C.limit],
      PaginatedCoins
    );
  }
  /**
   * Get all Coin objects owned by an address.
   */
  async getAllCoins(C) {
    if (!C.owner || !isValidSuiAddress(normalizeSuiAddress(C.owner)))
      throw new Error("Invalid Sui address");
    return await this.client.requestWithType(
      "suix_getAllCoins",
      [C.owner, C.cursor, C.limit],
      PaginatedCoins
    );
  }
  /**
   * Get the total coin balance for one coin type, owned by the address owner.
   */
  async getBalance(C) {
    if (!C.owner || !isValidSuiAddress(normalizeSuiAddress(C.owner)))
      throw new Error("Invalid Sui address");
    return await this.client.requestWithType(
      "suix_getBalance",
      [C.owner, C.coinType],
      CoinBalance
    );
  }
  /**
   * Get the total coin balance for all coin types, owned by the address owner.
   */
  async getAllBalances(C) {
    if (!C.owner || !isValidSuiAddress(normalizeSuiAddress(C.owner)))
      throw new Error("Invalid Sui address");
    return await this.client.requestWithType(
      "suix_getAllBalances",
      [C.owner],
      array$1(CoinBalance)
    );
  }
  /**
   * Fetch CoinMetadata for a given coin type
   */
  async getCoinMetadata(C) {
    return await this.client.requestWithType(
      "suix_getCoinMetadata",
      [C.coinType],
      CoinMetadataStruct
    );
  }
  /**
   *  Fetch total supply for a coin
   */
  async getTotalSupply(C) {
    return await this.client.requestWithType(
      "suix_getTotalSupply",
      [C.coinType],
      CoinSupply
    );
  }
  /**
   * Invoke any RPC method
   * @param method the method to be invoked
   * @param args the arguments to be passed to the RPC request
   */
  async call(C, e) {
    const T = await this.client.request(C, e);
    if (is$1(T, ErrorResponse))
      throw new RPCError({
        req: { method: C, args: e },
        code: T.error.code,
        data: T.error.data,
        cause: new Error(T.error.message)
      });
    return T.result;
  }
  /**
   * Get Move function argument types like read, write and full access
   */
  async getMoveFunctionArgTypes(C) {
    return await this.client.requestWithType(
      "sui_getMoveFunctionArgTypes",
      [C.package, C.module, C.function],
      SuiMoveFunctionArgTypes
    );
  }
  /**
   * Get a map from module name to
   * structured representations of Move modules
   */
  async getNormalizedMoveModulesByPackage(C) {
    return await this.client.requestWithType(
      "sui_getNormalizedMoveModulesByPackage",
      [C.package],
      SuiMoveNormalizedModules
    );
  }
  /**
   * Get a structured representation of Move module
   */
  async getNormalizedMoveModule(C) {
    return await this.client.requestWithType(
      "sui_getNormalizedMoveModule",
      [C.package, C.module],
      SuiMoveNormalizedModule
    );
  }
  /**
   * Get a structured representation of Move function
   */
  async getNormalizedMoveFunction(C) {
    return await this.client.requestWithType(
      "sui_getNormalizedMoveFunction",
      [C.package, C.module, C.function],
      SuiMoveNormalizedFunction
    );
  }
  /**
   * Get a structured representation of Move struct
   */
  async getNormalizedMoveStruct(C) {
    return await this.client.requestWithType(
      "sui_getNormalizedMoveStruct",
      [C.package, C.module, C.struct],
      SuiMoveNormalizedStruct
    );
  }
  /**
   * Get all objects owned by an address
   */
  async getOwnedObjects(C) {
    if (!C.owner || !isValidSuiAddress(normalizeSuiAddress(C.owner)))
      throw new Error("Invalid Sui address");
    return await this.client.requestWithType(
      "suix_getOwnedObjects",
      [
        C.owner,
        {
          filter: C.filter,
          options: C.options
        },
        C.cursor,
        C.limit
      ],
      PaginatedObjectsResponse
    );
  }
  /**
   * Get details about an object
   */
  async getObject(C) {
    if (!C.id || !isValidSuiObjectId(normalizeSuiObjectId(C.id)))
      throw new Error("Invalid Sui Object id");
    return await this.client.requestWithType(
      "sui_getObject",
      [C.id, C.options],
      SuiObjectResponse
    );
  }
  /**
   * Batch get details about a list of objects. If any of the object ids are duplicates the call will fail
   */
  async multiGetObjects(C) {
    if (C.ids.forEach((T) => {
      if (!T || !isValidSuiObjectId(normalizeSuiObjectId(T)))
        throw new Error(`Invalid Sui Object id ${T}`);
    }), C.ids.length !== new Set(C.ids).size)
      throw new Error(`Duplicate object ids in batch call ${C.ids}`);
    return await this.client.requestWithType(
      "sui_multiGetObjects",
      [C.ids, C.options],
      array$1(SuiObjectResponse)
    );
  }
  /**
   * Get transaction blocks for a given query criteria
   */
  async queryTransactionBlocks(C) {
    return await this.client.requestWithType(
      "suix_queryTransactionBlocks",
      [
        {
          filter: C.filter,
          options: C.options
        },
        C.cursor,
        C.limit,
        (C.order || "descending") === "descending"
      ],
      PaginatedTransactionResponse
    );
  }
  async getTransactionBlock(C) {
    if (!isValidTransactionDigest(C.digest))
      throw new Error("Invalid Transaction digest");
    return await this.client.requestWithType(
      "sui_getTransactionBlock",
      [C.digest, C.options],
      SuiTransactionBlockResponse
    );
  }
  async multiGetTransactionBlocks(C) {
    if (C.digests.forEach((T) => {
      if (!isValidTransactionDigest(T))
        throw new Error(`Invalid Transaction digest ${T}`);
    }), C.digests.length !== new Set(C.digests).size)
      throw new Error(`Duplicate digests in batch call ${C.digests}`);
    return await this.client.requestWithType(
      "sui_multiGetTransactionBlocks",
      [C.digests, C.options],
      array$1(SuiTransactionBlockResponse)
    );
  }
  async executeTransactionBlock(C) {
    return await this.client.requestWithType(
      "sui_executeTransactionBlock",
      [
        typeof C.transactionBlock == "string" ? C.transactionBlock : toB64(C.transactionBlock),
        Array.isArray(C.signature) ? C.signature : [C.signature],
        C.options,
        C.requestType
      ],
      SuiTransactionBlockResponse
    );
  }
  /**
   * Get total number of transactions
   */
  async getTotalTransactionBlocks() {
    const C = await this.client.requestWithType(
      "sui_getTotalTransactionBlocks",
      [],
      string$1()
    );
    return BigInt(C);
  }
  /**
   * Getting the reference gas price for the network
   */
  async getReferenceGasPrice() {
    const C = await this.client.requestWithType(
      "suix_getReferenceGasPrice",
      [],
      string$1()
    );
    return BigInt(C);
  }
  /**
   * Return the delegated stakes for an address
   */
  async getStakes(C) {
    if (!C.owner || !isValidSuiAddress(normalizeSuiAddress(C.owner)))
      throw new Error("Invalid Sui address");
    return await this.client.requestWithType(
      "suix_getStakes",
      [C.owner],
      array$1(DelegatedStake)
    );
  }
  /**
   * Return the delegated stakes queried by id.
   */
  async getStakesByIds(C) {
    return C.stakedSuiIds.forEach((e) => {
      if (!e || !isValidSuiObjectId(normalizeSuiObjectId(e)))
        throw new Error(`Invalid Sui Stake id ${e}`);
    }), await this.client.requestWithType(
      "suix_getStakesByIds",
      [C.stakedSuiIds],
      array$1(DelegatedStake)
    );
  }
  /**
   * Return the latest system state content.
   */
  async getLatestSuiSystemState() {
    return await this.client.requestWithType(
      "suix_getLatestSuiSystemState",
      [],
      SuiSystemStateSummary
    );
  }
  /**
   * Get events for a given query criteria
   */
  async queryEvents(C) {
    return await this.client.requestWithType(
      "suix_queryEvents",
      [
        C.query,
        C.cursor,
        C.limit,
        (C.order || "descending") === "descending"
      ],
      PaginatedEvents
    );
  }
  /**
   * Subscribe to get notifications whenever an event matching the filter occurs
   */
  async subscribeEvent(C) {
    return this.wsClient.subscribeEvent(C.filter, C.onMessage);
  }
  /**
   * Unsubscribe from an event subscription
   */
  async unsubscribeEvent(C) {
    return this.wsClient.unsubscribeEvent(C.id);
  }
  /**
   * Runs the transaction block in dev-inspect mode. Which allows for nearly any
   * transaction (or Move call) with any arguments. Detailed results are
   * provided, including both the transaction effects and any return values.
   */
  async devInspectTransactionBlock(C) {
    let e;
    if (TransactionBlock.is(C.transactionBlock))
      C.transactionBlock.setSenderIfNotSet(C.sender), e = toB64(
        await C.transactionBlock.build({
          provider: this,
          onlyTransactionKind: !0
        })
      );
    else if (typeof C.transactionBlock == "string")
      e = C.transactionBlock;
    else if (C.transactionBlock instanceof Uint8Array)
      e = toB64(C.transactionBlock);
    else
      throw new Error("Unknown transaction block format.");
    return await this.client.requestWithType(
      "sui_devInspectTransactionBlock",
      [C.sender, e, C.gasPrice, C.epoch],
      DevInspectResults
    );
  }
  /**
   * Dry run a transaction block and return the result.
   */
  async dryRunTransactionBlock(C) {
    return await this.client.requestWithType(
      "sui_dryRunTransactionBlock",
      [
        typeof C.transactionBlock == "string" ? C.transactionBlock : toB64(C.transactionBlock)
      ],
      DryRunTransactionBlockResponse
    );
  }
  /**
   * Return the list of dynamic field objects owned by an object
   */
  async getDynamicFields(C) {
    if (!C.parentId || !isValidSuiObjectId(normalizeSuiObjectId(C.parentId)))
      throw new Error("Invalid Sui Object id");
    return await this.client.requestWithType(
      "suix_getDynamicFields",
      [C.parentId, C.cursor, C.limit],
      DynamicFieldPage
    );
  }
  /**
   * Return the dynamic field object information for a specified object
   */
  async getDynamicFieldObject(C) {
    return await this.client.requestWithType(
      "suix_getDynamicFieldObject",
      [C.parentId, C.name],
      SuiObjectResponse
    );
  }
  /**
   * Get the sequence number of the latest checkpoint that has been executed
   */
  async getLatestCheckpointSequenceNumber() {
    const C = await this.client.requestWithType(
      "sui_getLatestCheckpointSequenceNumber",
      [],
      string$1()
    );
    return String(C);
  }
  /**
   * Returns information about a given checkpoint
   */
  async getCheckpoint(C) {
    return await this.client.requestWithType(
      "sui_getCheckpoint",
      [C.id],
      Checkpoint
    );
  }
  /**
   * Returns historical checkpoints paginated
   */
  async getCheckpoints(C) {
    const e = await this.getRpcApiVersion();
    return await this.client.requestWithType(
      "sui_getCheckpoints",
      [
        C.cursor,
        e && femver.lt(e, "0.32.0") ? String(C == null ? void 0 : C.limit) : C == null ? void 0 : C.limit,
        C.descendingOrder
      ],
      CheckpointPage
    );
  }
  /**
   * Return the committee information for the asked epoch
   */
  async getCommitteeInfo(C) {
    return await this.client.requestWithType(
      "suix_getCommitteeInfo",
      [C == null ? void 0 : C.epoch],
      CommitteeInfo
    );
  }
  async getNetworkMetrics() {
    return await this.client.requestWithType(
      "suix_getNetworkMetrics",
      [],
      NetworkMetrics
    );
  }
  /**
   * Return the committee information for the asked epoch
   */
  async getEpochs(C) {
    const e = await this.getRpcApiVersion();
    return await this.client.requestWithType(
      "suix_getEpochs",
      [
        C == null ? void 0 : C.cursor,
        e && femver.lt(e, "0.32.0") ? String(C == null ? void 0 : C.limit) : C == null ? void 0 : C.limit,
        C == null ? void 0 : C.descendingOrder
      ],
      EpochPage
    );
  }
  /**
   * Return the committee information for the asked epoch
   */
  async getCurrentEpoch() {
    return await this.client.requestWithType(
      "suix_getCurrentEpoch",
      [],
      EpochInfo
    );
  }
  /**
   * Wait for a transaction block result to be available over the API.
   * This can be used in conjunction with `executeTransactionBlock` to wait for the transaction to
   * be available via the API.
   * This currently polls the `getTransactionBlock` API to check for the transaction.
   */
  async waitForTransactionBlock({
    signal: C,
    timeout: e = 60 * 1e3,
    pollInterval: T = 2 * 1e3,
    ...$
  }) {
    const V = AbortSignal.timeout(e), J = new Promise((ee, te) => {
      V.addEventListener(
        "abort",
        () => te(V.reason)
      );
    });
    for (; !V.aborted; ) {
      C == null || C.throwIfAborted();
      try {
        return await this.getTransactionBlock($);
      } catch {
        await Promise.race([
          new Promise((te) => setTimeout(te, T)),
          J
        ]);
      }
    }
    throw V.throwIfAborted(), new Error("Unexpected error while waiting for transaction block.");
  }
};
normalizeSuiObjectId("0x5");
function convertAddress(C) {
  return C.length === 22 ? C : `0x${C.slice(C.length - 40, C.length)}`;
}
function isNative(C) {
  return C === SUI_TYPE_ARG || C === "0x1::aptos_coin::AptosCoin";
}
function trimAddress(C, e = 6) {
  return isNative(C) ? C : C.slice(0, e) + "..." + C.slice(C.length - 4, C.length);
}
function trimTxHash(C, e = 6, T = 4) {
  const $ = C.slice(0, e), V = C.slice(C.length - T, C.length);
  return `${$}...${V}`;
}
function displayWalletAddress(C, e) {
  return C ? C === Context.ETH ? trimAddress(convertAddress(e)) : C === Context.SOLANA ? trimAddress(e, 4) : trimAddress(e) : "";
}
function getChainByChainId(C) {
  return config$1.chainsArr.filter((e) => C === e.chainId)[0];
}
function getChainConfig(C) {
  const e = config$1.chains[C];
  if (!e) throw new Error(`chain config for ${C} not found`);
  return e;
}
function getWrappedToken(C) {
  if (!C) throw new Error("token must be defined");
  if (C.tokenId) return C;
  if (!C.tokenId && !C.wrappedAsset)
    throw new Error(`token details misconfigured for ${C.key}`);
  if (!C.tokenId && C.wrappedAsset) {
    const e = config$1.tokens[C.wrappedAsset];
    if (!e) throw new Error("wrapped token not found");
    return e;
  }
  return C;
}
function getWrappedTokenId(C) {
  return getWrappedToken(C).tokenId;
}
function getTokenById(C) {
  return config$1.tokensArr.find(
    (e) => e.tokenId && C.chain === e.tokenId.chain && C.address.toLowerCase() === e.tokenId.address.toLowerCase()
  );
}
function getDisplayName(C, e) {
  const T = isWrappedToken(C, e), $ = C.displayName ?? C.symbol;
  if (!T)
    return $;
  const V = C.nativeChain === "Ethereum";
  return isStableCoin(C) && !V && e === "Sui" ? `Wormhole-wrapped ${C.nativeChain} ${$}` : `${`Wormhole-wrapped ${isFrankensteinToken(C, e) ? V ? "" : `${C.nativeChain} ` : ""}`}${$}`;
}
function getGasToken(C) {
  const e = config$1.tokens[getChainConfig(C).gasToken];
  if (!e) throw new Error(`gas token not found for ${C}`);
  return e;
}
function getTokenDecimals(C, e) {
  if (!config$1.chains[C]) throw new Error(`chain config for ${C} not found`);
  const { nativeChain: $, decimals: V } = e, J = chainToPlatform(C), ee = chainToPlatform($);
  return J === ee ? V : Math.min(V, J === "Evm" ? 18 : 8);
}
function fallbackCopyTextToClipboard(C) {
  const e = document.createElement("textarea");
  e.value = C, e.style.top = "0", e.style.left = "0", e.style.position = "fixed", document.body.appendChild(e), e.focus(), e.select();
  try {
    return document.execCommand("copy"), !0;
  } catch {
    return !1;
  } finally {
    document.body.removeChild(e);
  }
}
function copyTextToClipboard(C) {
  return navigator.clipboard && navigator.clipboard.writeText(C).then(
    function() {
      return !0;
    },
    function() {
      return fallbackCopyTextToClipboard(C);
    }
  ), fallbackCopyTextToClipboard(C);
}
function hexPrefix(C) {
  return C.startsWith("0x") ? C : `0x${C}`;
}
function isValidTxId(C, e) {
  return C === "Sui" ? isValidTransactionDigest(e) : C === "Sei" ? isHexString(hexPrefix(e), 32) : e.startsWith("0x") && e.length === 66 ? !0 : e.length > 70 && e.length < 100;
}
function usePrevious(C) {
  const e = useRef();
  return useEffect(() => {
    e.current = C;
  }), e.current;
}
async function sleep(C) {
  return new Promise((e) => setTimeout(e, C));
}
const getTokenPrice = (C, e) => {
  var T;
  if (C && e)
    return (T = C[e.coinGeckoId]) == null ? void 0 : T.usd;
}, getUSDFormat = (C) => typeof C > "u" ? "" : C === 0 ? "$0" : Intl.NumberFormat("en-EN", {
  style: "currency",
  currency: "USD"
}).format(C), calculateUSDPriceRaw = (C, e, T) => {
  if (typeof C > "u" || !e || !T)
    return;
  const $ = getTokenPrice(e || {}, T) || 0;
  if ($ > 0)
    return typeof C == "number" ? C * $ : whole(C) * $;
}, calculateUSDPrice = (C, e, T) => getUSDFormat(calculateUSDPriceRaw(C, e, T)), isEmptyObject = (C) => {
  if (C == null)
    return !0;
  for (const e in C)
    if (C.hasOwnProperty.call(C, e))
      return !1;
  return !0;
}, getExplorerUrl = (C, e) => {
  const T = config$1.chains[C];
  let $ = "";
  return C === "Sui" ? $ = `${T.explorerUrl}coin/${e}` : $ = `${T.explorerUrl}address/${e}`, $;
}, isFrankensteinToken = (C, e) => {
  const { nativeChain: T, symbol: $ } = C;
  return $ === "USDC" && T === "Ethereum" && e === "Fantom" ? !0 : isWrappedToken(C, e) ? getNativeVersionOfToken(C.symbol, e) || C.symbol === "tBTC" ? !0 : C.symbol === "USDC" && e === "Sui" ? !1 : !["Ethereum", "Sepolia"].includes(T) && ["ETH", "WETH", "wstETH", "USDT", "USDC", "USDC.e"].includes($) : !1;
}, isWrappedToken = (C, e) => C.nativeChain !== e, isCanonicalToken = (C, e) => C.key === "USDCeth" && e === "Sui", isStableCoin = (C) => ["USDC", "USDT", "DAI"].includes(C.symbol), millisToHumanString = (C) => C > 6e4 ? `~${Math.ceil(C / 6e4)} min` : `~${Math.ceil(C / 1e3)} sec`, millisToRelativeTime = (C) => {
  if (C > 864e5) {
    const V = Math.floor(C / 864e5);
    return `~${V} ${V === 1 ? "day" : "days"} ago`;
  } else if (C > 36e5) {
    const V = Math.floor(C / 36e5);
    return `~${V} ${V === 1 ? "hour" : "hours"} ago`;
  } else if (C > 6e4) {
    const V = Math.floor(C / 6e4);
    return `~${V} ${V === 1 ? "minute" : "minutes"} ago`;
  } else
    return "~1 minute ago";
}, formatDuration = (C) => {
  if (C < 60)
    return C === 1 ? `${C} second` : `${C} seconds`;
  if (C < 3600) {
    const e = Math.floor(C / 60);
    return e === 1 ? `${e} minute` : `${e} minutes`;
  } else {
    const e = Math.floor(C / 3600);
    return e === 1 ? `${e} hour` : `${e} hours`;
  }
};
async function getTokenBridgeWrappedTokenAddress(C, e) {
  const T = config$1.wrappedTokenAddressCache.get(C.key, e);
  if (T)
    return T;
  const J = await (await getWormholeContextV2()).getChain(e).getTokenBridge();
  console.info(
    `Resolving foreign address for token ${C.key} on chain ${e}`
  );
  const ee = config$1.sdkConverter.toTokenIdV2(C);
  try {
    const te = await J.getWrappedAsset(ee);
    return te && config$1.wrappedTokenAddressCache.set(C.key, e, te), te;
  } catch {
    return null;
  }
}
function getTokenBridgeWrappedTokenAddressSync(C, e) {
  return config$1.wrappedTokenAddressCache.get(C.key, e);
}
function getExplorerInfo(C, e) {
  return (typeof C == "string" ? C : C.constructor.meta.name).startsWith("MayanSwap") ? {
    url: `https://explorer.mayan.finance/swap/${e}`,
    name: "Mayan Explorer",
    apiUrl: `${config$1.mayanApi}/v3/swap/trx/${e}`
  } : {
    url: `${WORMSCAN}tx/${e}${config$1.isMainnet ? "" : "?network=TESTNET"}`,
    name: "Wormholescan",
    apiUrl: `${config$1.wormholeApi}api/v1/operations?txHash=${e}`
  };
}
async function parseReceipt(C, e) {
  switch (C) {
    case "ManualTokenBridge":
      return await parseTokenBridgeReceipt(
        e
      );
    case "ManualCCTP":
      return await parseCCTPReceipt(
        e
      );
    case "ManualNtt":
      return parseNttReceipt(
        e
      );
    case "AutomaticNtt":
      return parseNttReceipt(
        e
      );
    default:
      throw new Error(`Unknown route type ${C}`);
  }
}
const parseTokenBridgeReceipt = async (C) => {
  var $, V;
  const e = {
    toChain: C.to,
    fromChain: C.from
  };
  if ("originTxs" in C && C.originTxs.length > 0)
    e.sendTx = C.originTxs[C.originTxs.length - 1].txid;
  else
    throw new Error("Can't find txid in receipt");
  const { payload: T } = C.attestation.attestation;
  if (!T.token)
    throw new Error("Attestation is missing token.");
  if (T.token) {
    const re = (await (await (await getWormholeContextV2()).getChain(T.token.chain).getTokenBridge()).getTokenNativeAddress(T.token.chain, T.token.address)).toString(), ie = Wormhole.tokenId(T.token.chain, re), se = config$1.sdkConverter.findTokenConfigV1(
      ie,
      config$1.tokensArr
    );
    if (!se)
      throw new Error("Unknown token");
    const de = C.from, ue = getTokenDecimals(de, getWrappedToken(se));
    e.tokenDecimals = ue, e.amount = fromBaseUnits(
      T.token.amount,
      // VAAs are truncated to a max of 8 decimal places
      Math.min(8, ue)
    ), e.tokenAddress = re, e.tokenKey = se.key, e.receivedTokenKey = se.key, e.receiveAmount = e.amount, ($ = T.payload) != null && $.toNativeTokenAmount && (e.receiveNativeAmount = fromBaseUnits(
      T.payload.toNativeTokenAmount,
      Math.min(8, ue)
    )), (V = T.payload) != null && V.targetRelayerFee && (e.relayerFee = {
      fee: Number(
        fmt(T.payload.targetRelayerFee, Math.min(8, ue))
      ),
      tokenKey: se.key
    });
  }
  if (T.to)
    if (C.to === "Solana") {
      if (!config$1.rpcs.Solana)
        throw new Error("Missing Solana RPC");
      const J = T.to.address.toNative(C.to).toString(), ee = new Connection$1(config$1.rpcs.Solana);
      try {
        const te = await getAccount(
          ee,
          new PublicKey(J)
        );
        e.recipient = te.owner.toBase58();
      } catch (te) {
        console.error(te), e.recipient = J;
      }
    } else
      e.recipient = T.to.address.toNative(C.to).toString();
  return e;
}, parseCCTPReceipt = async (C) => {
  const e = {
    toChain: C.to,
    fromChain: C.from
  };
  if ("originTxs" in C && C.originTxs.length > 0)
    e.sendTx = C.originTxs[C.originTxs.length - 1].txid;
  else
    throw new Error("Can't find txid in receipt");
  if (!C.attestation.attestation)
    throw new Error("Missing Circle attestation");
  const { payload: T } = C.attestation.attestation.message, $ = Wormhole.tokenId(
    C.from,
    C.from === "Sui" ? (
      // The `burnToken` from Sui is the keccak256 hash of the USDC token address,
      // so we need to override it with the actual USDC address
      usdcContract.get(config$1.network, C.from)
    ) : T.burnToken.toNative(C.from).toString()
  ), V = config$1.sdkConverter.findTokenConfigV1(
    $,
    config$1.tokensArr
  );
  if (!V)
    throw new Error("Couldn't find USDC for source chain");
  e.tokenAddress = $.address.toString(), e.tokenKey = V.key;
  const J = getTokenDecimals(C.from, getWrappedToken(V));
  if (e.tokenDecimals = J, e.amount = fromBaseUnits(T.amount, J), e.receiveAmount = e.amount, e.sender = T.messageSender.toNative(C.from).toString(), C.to === "Solana") {
    if (!config$1.rpcs.Solana)
      throw new Error("Missing Solana RPC");
    const te = T.mintRecipient.toNative(C.to).toString(), re = new Connection$1(config$1.rpcs.Solana);
    try {
      const ie = await getAccount(re, new PublicKey(te));
      e.recipient = ie.owner.toBase58();
    } catch (ie) {
      console.error(ie), e.recipient = te;
    }
  } else
    e.recipient = T.mintRecipient.toNative(C.to).toString();
  const ee = config$1.tokensArr.find((te) => te.symbol === "USDC" && te.nativeChain === e.toChain);
  if (!ee)
    throw new Error("Couldn't find USDC for destination chain");
  return e.receivedTokenKey = ee.key, e;
}, parseNttReceipt = (C) => {
  let e = "";
  if ("originTxs" in C && C.originTxs.length > 0)
    e = C.originTxs[C.originTxs.length - 1].txid;
  else
    throw new Error("Can't find txid in receipt");
  const T = Wormhole.tokenId(
    C.from,
    C.params.normalizedParams.sourceContracts.token
  ), $ = config$1.sdkConverter.findTokenConfigV1(
    T,
    config$1.tokensArr
  );
  if (!$)
    throw new Error("Unknown src token");
  const V = Wormhole.tokenId(
    C.to,
    C.params.normalizedParams.destinationContracts.token
  ), J = config$1.sdkConverter.findTokenConfigV1(
    V,
    config$1.tokensArr
  );
  if (!J)
    throw new Error("Unknown dst token");
  const { attestation: ee } = C.attestation, { payload: te } = ee.payloadName === "WormholeTransfer" ? ee : ee.payload, { trimmedAmount: re } = te.nttManagerPayload.payload, ie = fromBaseUnits(
    re.amount,
    re.decimals
  );
  return {
    toChain: C.to,
    fromChain: C.from,
    sendTx: e,
    sender: te.nttManagerPayload.sender.toNative(C.from).toString(),
    recipient: te.nttManagerPayload.payload.recipientAddress.toNative(C.to).toString(),
    amount: ie,
    tokenAddress: $.tokenId.address.toString(),
    tokenKey: $.key,
    tokenDecimals: re.decimals,
    receivedTokenKey: J.key,
    receiveAmount: ie,
    relayerFee: void 0
    // TODO: how to get?
  };
}, isAmount = (C) => typeof C == "object" && typeof C.amount == "string" && typeof C.decimals == "number", isMinAmountError = (C) => {
  const e = C;
  return isAmount(e == null ? void 0 : e.min);
};
class SDKConverter {
  constructor(e) {
    tt(this, "wh");
    this.wh = e;
  }
  // Token conversion
  toTokenIdV1(e) {
    if (e.address !== "native")
      return {
        chain: e.chain,
        address: e.address.toString()
      };
  }
  toTokenIdV2(e, T) {
    if (this.isTokenConfigV1(e))
      if (T && T != e.nativeChain) {
        const $ = getTokenBridgeWrappedTokenAddressSync(
          e,
          T
        );
        if ($)
          return Wormhole.tokenId(T, $.toString());
        throw new Error("no foreign asset");
      } else {
        const $ = this.getNativeTokenAddressV2(e);
        if (!$) throw new Error("no address");
        return Wormhole.tokenId(e.nativeChain, $);
      }
    else
      return Wormhole.tokenId(e.chain, e.address);
  }
  tokenIdV2(e, T) {
    return Wormhole.tokenId(e, T);
  }
  isTokenConfigV1(e) {
    return "key" in e;
  }
  // Attempts to find the Connect TokenConfig, which is commonly used in Connect code base,
  // given a v2.TokenId
  findTokenConfigV1(e, T) {
    var J;
    const $ = e.address === "native", V = e.chain;
    for (const ee in T) {
      const te = T[ee];
      if (te.nativeChain === V) {
        if ($ && te.key === getGasToken(V).key)
          return te;
        if (((J = te.tokenId) == null ? void 0 : J.address.toLowerCase()) === e.address.toString().toLowerCase())
          return te;
      } else {
        const re = getTokenBridgeWrappedTokenAddressSync(te, V);
        if (re && re.toString() === e.address.toString())
          return te;
      }
    }
  }
  async getTokenIdV2ForKey(e, T, $) {
    const V = $[e];
    if (V)
      if (V.nativeChain === T) {
        const J = this.getNativeTokenAddressV2(V);
        return J ? this.tokenIdV2(T, J) : void 0;
      } else {
        const J = await getTokenBridgeWrappedTokenAddress(
          $[e],
          T
        );
        return J ? this.tokenIdV2(T, J.toString()) : void 0;
      }
  }
  getNativeTokenAddressV2(e) {
    var $;
    return (
      // If the token is the native gas token, return 'native'
      // Note: We don't set the address to 'native' for CELO because the Celo token bridge
      // doesn't have WETH set. Celo also has multiple native gas tokens.
      getGasToken(e.nativeChain).key === e.key && e.key !== "CELO" ? "native" : ($ = e.tokenId) == null ? void 0 : $.address
    );
  }
}
const evm = async () => (await import("./evm-Cp51KdvE.mjs")).default, solana$1 = async () => (await import("./solana-C6737uHL.mjs")).default, aptos$1 = async () => (await import("./aptos-C_1y990s.mjs").then((C) => C.a)).default, sui = async () => (await import("./sui-CFiY7cJ1.mjs").then((C) => C.s)).default;
var eventemitter3 = { exports: {} };
(function(C) {
  var e = Object.prototype.hasOwnProperty, T = "~";
  function $() {
  }
  Object.create && ($.prototype = /* @__PURE__ */ Object.create(null), new $().__proto__ || (T = !1));
  function V(re, ie, se) {
    this.fn = re, this.context = ie, this.once = se || !1;
  }
  function J(re, ie, se, de, ue) {
    if (typeof se != "function")
      throw new TypeError("The listener must be a function");
    var fe = new V(se, de || re, ue), he = T ? T + ie : ie;
    return re._events[he] ? re._events[he].fn ? re._events[he] = [re._events[he], fe] : re._events[he].push(fe) : (re._events[he] = fe, re._eventsCount++), re;
  }
  function ee(re, ie) {
    --re._eventsCount === 0 ? re._events = new $() : delete re._events[ie];
  }
  function te() {
    this._events = new $(), this._eventsCount = 0;
  }
  te.prototype.eventNames = function() {
    var ie = [], se, de;
    if (this._eventsCount === 0) return ie;
    for (de in se = this._events)
      e.call(se, de) && ie.push(T ? de.slice(1) : de);
    return Object.getOwnPropertySymbols ? ie.concat(Object.getOwnPropertySymbols(se)) : ie;
  }, te.prototype.listeners = function(ie) {
    var se = T ? T + ie : ie, de = this._events[se];
    if (!de) return [];
    if (de.fn) return [de.fn];
    for (var ue = 0, fe = de.length, he = new Array(fe); ue < fe; ue++)
      he[ue] = de[ue].fn;
    return he;
  }, te.prototype.listenerCount = function(ie) {
    var se = T ? T + ie : ie, de = this._events[se];
    return de ? de.fn ? 1 : de.length : 0;
  }, te.prototype.emit = function(ie, se, de, ue, fe, he) {
    var me = T ? T + ie : ie;
    if (!this._events[me]) return !1;
    var xe = this._events[me], ve = arguments.length, Te, we;
    if (xe.fn) {
      switch (xe.once && this.removeListener(ie, xe.fn, void 0, !0), ve) {
        case 1:
          return xe.fn.call(xe.context), !0;
        case 2:
          return xe.fn.call(xe.context, se), !0;
        case 3:
          return xe.fn.call(xe.context, se, de), !0;
        case 4:
          return xe.fn.call(xe.context, se, de, ue), !0;
        case 5:
          return xe.fn.call(xe.context, se, de, ue, fe), !0;
        case 6:
          return xe.fn.call(xe.context, se, de, ue, fe, he), !0;
      }
      for (we = 1, Te = new Array(ve - 1); we < ve; we++)
        Te[we - 1] = arguments[we];
      xe.fn.apply(xe.context, Te);
    } else {
      var Ee = xe.length, Me;
      for (we = 0; we < Ee; we++)
        switch (xe[we].once && this.removeListener(ie, xe[we].fn, void 0, !0), ve) {
          case 1:
            xe[we].fn.call(xe[we].context);
            break;
          case 2:
            xe[we].fn.call(xe[we].context, se);
            break;
          case 3:
            xe[we].fn.call(xe[we].context, se, de);
            break;
          case 4:
            xe[we].fn.call(xe[we].context, se, de, ue);
            break;
          default:
            if (!Te) for (Me = 1, Te = new Array(ve - 1); Me < ve; Me++)
              Te[Me - 1] = arguments[Me];
            xe[we].fn.apply(xe[we].context, Te);
        }
    }
    return !0;
  }, te.prototype.on = function(ie, se, de) {
    return J(this, ie, se, de, !1);
  }, te.prototype.once = function(ie, se, de) {
    return J(this, ie, se, de, !0);
  }, te.prototype.removeListener = function(ie, se, de, ue) {
    var fe = T ? T + ie : ie;
    if (!this._events[fe]) return this;
    if (!se)
      return ee(this, fe), this;
    var he = this._events[fe];
    if (he.fn)
      he.fn === se && (!ue || he.once) && (!de || he.context === de) && ee(this, fe);
    else {
      for (var me = 0, xe = [], ve = he.length; me < ve; me++)
        (he[me].fn !== se || ue && !he[me].once || de && he[me].context !== de) && xe.push(he[me]);
      xe.length ? this._events[fe] = xe.length === 1 ? xe[0] : xe : ee(this, fe);
    }
    return this;
  }, te.prototype.removeAllListeners = function(ie) {
    var se;
    return ie ? (se = T ? T + ie : ie, this._events[se] && ee(this, se)) : (this._events = new $(), this._eventsCount = 0), this;
  }, te.prototype.off = te.prototype.removeListener, te.prototype.addListener = te.prototype.on, te.prefixed = T, te.EventEmitter = te, C.exports = te;
})(eventemitter3);
var eventemitter3Exports = eventemitter3.exports;
const EventEmitter = /* @__PURE__ */ getDefaultExportFromCjs$2(eventemitter3Exports);
class NotSupported extends Error {
  constructor() {
    super("Not supported");
  }
}
class NotConnected extends Error {
  constructor() {
    super("Not connected");
  }
}
var BaseFeatures;
(function(C) {
  C.SignTransaction = "SignTransaction", C.SendTransaction = "SendTransaction", C.SignAndSendTransaction = "SignAndSendTransaction", C.SignMessage = "SignMessage";
})(BaseFeatures || (BaseFeatures = {}));
var WalletState;
(function(C) {
  C.Installed = "Installed", C.NotDetected = "NotDetected", C.Loadable = "Loadable", C.Unsupported = "Unsupported";
})(WalletState || (WalletState = {}));
class Wallet extends EventEmitter {
  /**
   * Retrieve the wallet's current state
   *
   * The possible states are as those used by the {@link https://github.com/solana-labs/wallet-adapter solana} and {@link https://github.com/aptos-labs/aptos-wallet-adapter aptos} libraries, summarized as follows:
   *  * `Installed`: the wallet was detected through the global scope or any other mechanism and can be interacted with. Example: `window.ethereum` for Metamask or `window.phantom` for Phantom wallet)
   *  * `NotDetected`: as opposed to `Installed`, no point of interaction with the wallet was found, and thus it is not available. Users can be redirected to the project url offered by `getUrl`
   *  * `Loadable`: the wallet might not require installation, and thus can be interacted with after being loaded
   *  * `Unsupported`: the wallet is not supported by the environment
   *
   * @returns The wallet's state. Defaults to Installed.
   */
  getWalletState() {
    return WalletState.Installed;
  }
  /**
   * Query whether a feature or set of features is supported by the wallet.
   * For a list of features see {@link BaseFeatures}.
   * Some chains might add additional features of their own.
   */
  supportsFeature(e) {
    const T = this.getFeatures();
    return Array.isArray(e) ? e.every(($) => T.includes($)) : T.includes(e);
  }
}
const CHAINS = {
  unset: 0,
  solana: 1,
  ethereum: 2,
  terra: 3,
  bsc: 4,
  polygon: 5,
  avalanche: 6,
  oasis: 7,
  algorand: 8,
  aurora: 9,
  fantom: 10,
  karura: 11,
  acala: 12,
  klaytn: 13,
  celo: 14,
  near: 15,
  moonbeam: 16,
  neon: 17,
  terra2: 18,
  injective: 19,
  osmosis: 20,
  sui: 21,
  aptos: 22,
  arbitrum: 23,
  optimism: 24,
  gnosis: 25,
  pythnet: 26,
  xpla: 28,
  btc: 29,
  base: 30,
  sei: 32,
  rootstock: 33,
  //
  scroll: 34,
  mantle: 35,
  blast: 36,
  xlayer: 37,
  linea: 38,
  berachain: 39,
  seievm: 40,
  worldchain: 45,
  wormchain: 3104,
  cosmoshub: 4e3,
  evmos: 4001,
  kujira: 4002,
  neutron: 4003,
  celestia: 4004,
  stargaze: 4005,
  seda: 4006,
  dymension: 4007,
  provenance: 4008,
  sepolia: 10002,
  arbitrum_sepolia: 10003,
  base_sepolia: 10004,
  optimism_sepolia: 10005,
  holesky: 10006,
  polygon_sepolia: 10007
};
Object.entries(CHAINS).reduce(
  (C, [e, T]) => (C[T] = e, C),
  {}
  // eslint-disable-line
);
const CHAIN_ID_SOLANA = CHAINS.solana, CHAIN_ID_ETH = CHAINS.ethereum, CHAIN_ID_BSC = CHAINS.bsc, CHAIN_ID_POLYGON = CHAINS.polygon, CHAIN_ID_AVAX = CHAINS.avalanche, CHAIN_ID_OASIS = CHAINS.oasis, CHAIN_ID_AURORA = CHAINS.aurora, CHAIN_ID_FANTOM = CHAINS.fantom, CHAIN_ID_KARURA = CHAINS.karura, CHAIN_ID_ACALA = CHAINS.acala, CHAIN_ID_KLAYTN = CHAINS.klaytn, CHAIN_ID_CELO = CHAINS.celo, CHAIN_ID_MOONBEAM = CHAINS.moonbeam, CHAIN_ID_NEON = CHAINS.neon, CHAIN_ID_SUI = CHAINS.sui, CHAIN_ID_APTOS = CHAINS.aptos, CHAIN_ID_ARBITRUM = CHAINS.arbitrum, CHAIN_ID_OPTIMISM = CHAINS.optimism, CHAIN_ID_GNOSIS = CHAINS.gnosis, CHAIN_ID_BASE = CHAINS.base, CHAIN_ID_SCROLL = CHAINS.scroll, CHAIN_ID_MANTLE = CHAINS.mantle, CHAIN_ID_BLAST = CHAINS.blast, CHAIN_ID_XLAYER = CHAINS.xlayer, CHAIN_ID_WORLDCHAIN = CHAINS.worldchain;
function isEVMChain(C) {
  return C === CHAIN_ID_ETH || C === CHAIN_ID_BSC || C === CHAIN_ID_AVAX || C === CHAIN_ID_POLYGON || C === CHAIN_ID_OASIS || C === CHAIN_ID_AURORA || C === CHAIN_ID_FANTOM || C === CHAIN_ID_KARURA || C === CHAIN_ID_ACALA || C === CHAIN_ID_KLAYTN || C === CHAIN_ID_CELO || C === CHAIN_ID_MOONBEAM || C === CHAIN_ID_NEON || C === CHAIN_ID_ARBITRUM || C === CHAIN_ID_OPTIMISM || C === CHAIN_ID_GNOSIS || C === CHAIN_ID_BASE || C === CHAIN_ID_SCROLL || C === CHAIN_ID_WORLDCHAIN || C === CHAIN_ID_BLAST || C === CHAIN_ID_XLAYER || C === CHAIN_ID_MANTLE;
}
const Zs = class Zs extends Wallet {
  constructor(T, $) {
    super();
    tt(this, "_isConnected", !0);
    this._address = T, this._chain = $;
  }
  getName() {
    return Zs.NAME;
  }
  getUrl() {
    return "";
  }
  async connect() {
    return this._isConnected = !0, this.emit("connect"), [this._address.toString()];
  }
  async disconnect() {
    this._isConnected = !1, this.emit("disconnect");
  }
  getChainId() {
    return chainToChainId(this._chain);
  }
  getNetworkInfo() {
    throw new Error("Method not implemented.");
  }
  getAddress() {
    return this._address.toString();
  }
  getAddresses() {
    return [this.getAddress()];
  }
  setMainAddress(T) {
  }
  async getBalance() {
    throw new Error("Address only wallet cannot fetch balance");
  }
  isConnected() {
    return this._isConnected;
  }
  getIcon() {
    return "";
  }
  async signTransaction(T) {
    throw new Error("Address only wallet cannot sign transactions");
  }
  async sendTransaction(T) {
    throw new Error("Address only wallet cannot send transactions");
  }
  async signMessage(T) {
    throw new Error("Address only wallet cannot sign messages");
  }
  async signAndSendTransaction(T) {
    throw new Error("Address only wallet cannot sign or send transactions");
  }
  getFeatures() {
    return [];
  }
  supportsChain(T) {
    return this.getChainId() === T;
  }
};
tt(Zs, "NAME", "ReadyOnlyWallet");
let ReadOnlyWallet = Zs;
const NO_WALLET = {
  address: "",
  type: void 0,
  currentAddress: "",
  error: "",
  icon: void 0,
  name: ""
}, initialState$3 = {
  sending: NO_WALLET,
  receiving: NO_WALLET
}, walletSlice = createSlice({
  name: "wallet",
  initialState: initialState$3,
  reducers: {
    connectWallet: (C, { payload: e }) => {
      C.sending.address = e.address, C.sending.currentAddress = e.address, C.sending.type = e.type, C.sending.name = e.name, C.sending.error = "", C.sending.icon = e.icon;
    },
    connectReceivingWallet: (C, { payload: e }) => {
      C.receiving.address = e.address, C.receiving.currentAddress = e.address, C.receiving.type = e.type, C.receiving.name = e.name, C.receiving.error = "", C.receiving.icon = e.icon;
    },
    clearWallet: (C, { payload: e }) => {
      C[e] = NO_WALLET;
    },
    disconnectWallet: (C, { payload: e }) => {
      disconnect(e), C[e] = NO_WALLET;
    },
    setWalletError: (C, { payload: e }) => {
      const { type: T, error: $ } = e;
      C[T].error = $;
    },
    setAddress: (C, { payload: e }) => {
      const { type: T, address: $ } = e;
      C[T].address = $, C[T].currentAddress = $;
    },
    clearWallets: (C) => {
      Object.keys(C).forEach((e) => {
        C[e] = initialState$3[e];
      });
    },
    swapWallets: (C) => {
      const e = C.sending;
      C.sending = C.receiving, C.receiving = e, swapWalletConnections(), C.sending.name === ReadOnlyWallet.NAME && (disconnect(TransferWallet.SENDING), C[TransferWallet.SENDING] = NO_WALLET);
    }
  }
}), {
  connectWallet: connectWallet$1,
  connectReceivingWallet,
  clearWallet,
  setAddress,
  setWalletError,
  clearWallets,
  disconnectWallet,
  swapWallets
} = walletSlice.actions, walletReducer = walletSlice.reducer;
var TransferWallet = /* @__PURE__ */ ((C) => (C.SENDING = "sending", C.RECEIVING = "receiving", C))(TransferWallet || {});
const walletConnection = {
  sending: void 0,
  receiving: void 0
}, walletAcceptedChains = (C) => C ? config$1.chainsArr.filter((e) => e.context === C).map((e) => e.key) : config$1.chainsArr.map((e) => e.key), setWalletConnection = (C, e) => {
  walletConnection[C] = e;
}, connectWallet = async (C, e, T, $) => {
  const { wallet: V, name: J } = T;
  setWalletConnection(C, V);
  const ee = config$1.chains[e];
  if (!ee)
    throw new Error(`Unable to find wallets for chain ${e}`);
  const { chainId: te, context: re } = ee;
  await V.connect({ chainId: te }), config$1.triggerEvent({
    type: "wallet.connect",
    details: {
      side: C,
      chain: e,
      wallet: T.name.toLowerCase()
    }
  });
  const ie = V.getAddress(), se = {
    address: ie,
    type: T.type,
    icon: V.getIcon(),
    name: V.getName()
  };
  $(C === "sending" ? connectWallet$1(se) : connectReceivingWallet(se)), V.on("disconnect", () => {
    V.removeAllListeners(), setTimeout(() => {
      $(clearWallet(C));
    }, 0), localStorage.removeItem(`wormhole-connect:wallet:${re}`);
  }), V.on("accountsChanged", (de) => {
    (de.length === 0 || de.length && ie && de[0] !== ie) && V.disconnect();
  }), J !== ReadOnlyWallet.NAME && localStorage.setItem(`wormhole-connect:wallet:${re}`, J);
}, connectLastUsedWallet = async (C, e, T) => {
  const $ = config$1.chains[e], V = localStorage.getItem(
    `wormhole-connect:wallet:${$.context}`
  );
  if (V && V !== "WalletConnect") {
    const ee = (await getWalletOptions($)).find((te) => te.name === V);
    ee && await connectWallet(C, e, ee, T);
  }
}, useConnectToLastUsedWallet = () => {
  const C = useDispatch(), { toChain: e, fromChain: T } = useSelector(
    ($) => $.transferInput
  );
  useEffect(() => {
    T && connectLastUsedWallet("sending", T, C), e && connectLastUsedWallet("receiving", e, C);
  }, [T, e]);
}, swapWalletConnections = () => {
  const C = walletConnection.sending;
  walletConnection.sending = walletConnection.receiving, walletConnection.receiving = C;
}, registerWalletSigner = async (C, e) => {
  const T = walletConnection[e];
  if (!T) throw new Error("must connect wallet");
  const $ = await T.getSigner();
  config$1.whLegacy.registerSigner(C, $);
}, switchChain = async (C, e) => {
  const T = walletConnection[e];
  if (!T) throw new Error("must connect wallet");
  const $ = getChainByChainId(C);
  if (T.getNetworkInfo().chainId !== C) {
    if ($.context === Context.ETH)
      try {
        await (await import("./evm-Bh7GDRTT.mjs").then((ee) => ee.f)).switchChain(T, C);
      } catch (J) {
        if (J instanceof NotSupported) return;
        throw J;
      }
    return T.getAddress();
  }
}, disconnect = async (C) => {
  const e = walletConnection[C];
  e && await e.disconnect();
}, signAndSendTransaction = async (C, e, T, $ = {}) => {
  const V = config$1.chains[C], J = walletConnection[T];
  if (!J)
    throw new Error("wallet is undefined");
  if (V.context === Context.ETH)
    return await (await import("./evm-Bh7GDRTT.mjs").then((re) => re.f)).signAndSendTransaction(
      e,
      J,
      C,
      $
    );
  if (V.context === Context.SOLANA)
    return await (await import("./solana-BCM3ZFY6.mjs")).signAndSendTransaction(
      e,
      J,
      $
    );
  if (V.context === Context.SUI)
    return (await (await import("./sui-YN64mBRE.mjs")).signAndSendTransaction(
      e,
      J
    )).id;
  if (V.context === Context.APTOS)
    return (await (await import("./aptos-A7VVhV0v.mjs")).signAndSendTransaction(
      e,
      J
    )).id;
  throw new Error("unimplemented");
}, getReady = (C) => {
  const e = C.getWalletState();
  return e !== WalletState.Unsupported && e !== WalletState.NotDetected;
}, mapWallets = (C, e, T = []) => Object.values(C).filter(
  ($, V, J) => V === J.findIndex((ee) => ee.getName() === $.getName())
).filter(($) => !T.includes($.getName())).map(($) => ({
  wallet: $,
  type: e,
  name: $.getName(),
  icon: $.getIcon(),
  isReady: getReady($)
})), getWalletOptions = async (C) => {
  if (C === void 0)
    return [];
  if (C.context === Context.ETH) {
    const e = await import("./evm-Bh7GDRTT.mjs").then((T) => T.f);
    return Object.values(mapWallets(e.wallets, Context.ETH));
  } else if (C.context === Context.SOLANA) {
    const T = (await import("./solana-BCM3ZFY6.mjs")).fetchOptions();
    return Object.values(mapWallets(T, Context.SOLANA));
  } else if (C.context === Context.SUI) {
    const T = await (await import("./sui-YN64mBRE.mjs")).fetchOptions();
    return Object.values(mapWallets(T, Context.SUI));
  } else if (C.context === Context.APTOS) {
    const T = (await import("./aptos-A7VVhV0v.mjs")).fetchOptions();
    return Object.values(mapWallets(T, Context.APTOS));
  }
  return [];
};
class SDKv2Signer {
  constructor(e, T, $, V, J) {
    tt(this, "_chain");
    tt(this, "_chainContextV2");
    tt(this, "_address");
    tt(this, "_options");
    tt(this, "_walletType");
    this._chain = e, this._chainContextV2 = T, this._address = $, this._options = V, this._walletType = J;
  }
  static async fromChain(e, T, $, V) {
    const ee = (await getWormholeContextV2()).getPlatform(chainToPlatform(e)).getChain(e);
    return new SDKv2Signer(e, ee, T, $, V);
  }
  async signAndSend(e) {
    const T = [];
    for (const $ of e) {
      const V = await signAndSendTransaction(
        this._chain,
        $,
        this._walletType,
        this._options
      );
      T.push(V);
    }
    return T;
  }
  chain() {
    return this._chainContextV2.chain;
  }
  address() {
    return this._address;
  }
}
class SDKv2Route {
  constructor(e) {
    // TODO: remove this
    tt(this, "IS_TOKEN_BRIDGE_ROUTE", !1);
    this.rc = e, this.IS_TOKEN_BRIDGE_ROUTE = [
      "ManualTokenBridge",
      "AutomaticTokenBridge",
      "CosmosGateway"
    ].includes(e.meta.name);
  }
  get AUTOMATIC_DEPOSIT() {
    return this.rc.IS_AUTOMATIC;
  }
  get NATIVE_GAS_DROPOFF_SUPPORTED() {
    return this.rc.NATIVE_GAS_DROPOFF_SUPPORTED;
  }
  async getV2ChainContext(e) {
    const $ = (await getWormholeContextV2()).getPlatform(chainToPlatform(e)).getChain(e);
    return {
      chain: e,
      context: $
    };
  }
  async isRouteSupported(e, T, $, V) {
    const J = await this.getV2ChainContext($), ee = await this.getV2ChainContext(V), te = this.rc.supportedChains(config$1.network), re = te.includes(J.chain), ie = te.includes(ee.chain), se = await config$1.sdkConverter.getTokenIdV2ForKey(
      e,
      $,
      config$1.tokens
    ), de = await config$1.sdkConverter.getTokenIdV2ForKey(
      T,
      V,
      config$1.tokens
    );
    if (!se || !de || this.IS_TOKEN_BRIDGE_ROUTE && await isNttSupportedToken(
      se,
      J.context,
      ee.context
    ))
      return !1;
    const ue = !!(await this.rc.supportedSourceTokens(J.context)).find((xe) => isSameToken(xe, se)), he = !!(await this.rc.supportedDestinationTokens(
      se,
      J.context,
      ee.context
    )).find((xe) => {
      let ve = de;
      if (this.IS_TOKEN_BRIDGE_ROUTE && isNative$1(de.address)) {
        const Te = getWrappedTokenId(getGasToken(V));
        ve = config$1.sdkConverter.tokenIdV2(V, Te.address);
      }
      return isSameToken(xe, ve);
    });
    return re && ie && ue && he;
  }
  isSupportedChain(e) {
    return this.rc.supportedChains(config$1.network).includes(e);
  }
  async supportedSourceTokens(e, T, $, V) {
    if (!$) return [];
    const J = await this.getV2ChainContext($);
    return (await this.rc.supportedSourceTokens(J.context)).map((ee) => config$1.sdkConverter.findTokenConfigV1(ee, e)).filter((ee) => ee != null);
  }
  async supportedDestTokens(e, T, $, V) {
    if (!$ || !V || !T) return [];
    if (this.IS_TOKEN_BRIDGE_ROUTE && this.isIlliquidDestToken(T, V))
      return [];
    const J = await this.getV2ChainContext($), ee = await this.getV2ChainContext(V), te = config$1.sdkConverter.toTokenIdV2(
      T,
      $
    ), re = await this.rc.supportedDestinationTokens(
      te,
      J.context,
      ee.context
    );
    if (this.IS_TOKEN_BRIDGE_ROUTE && re.length > 0) {
      const ie = isWrappedToken(T, V), se = getTokenBridgeWrappedTokenAddressSync(
        getWrappedToken(T),
        V
      );
      return ie && !se ? [] : [getWrappedToken(T)];
    }
    return re.map(
      (ie) => config$1.sdkConverter.findTokenConfigV1(ie, e)
    ).filter((ie) => ie != null);
  }
  async getQuote(e, T, $, V, J, ee) {
    const te = await this.createRequest(
      e,
      T,
      $,
      V,
      J
    ), re = await getWormholeContextV2(), ie = new this.rc(re), se = await ie.validate(te, {
      amount: display(e),
      options: ee
    });
    if (!se.valid)
      throw se.error;
    const de = await ie.quote(te, se.params);
    return [ie, de, te];
  }
  async createRequest(e, T, $, V, J) {
    const ee = await config$1.sdkConverter.getTokenIdV2ForKey(
      T,
      V,
      config$1.tokens
    ), te = await config$1.sdkConverter.getTokenIdV2ForKey(
      $,
      J,
      config$1.tokens
    );
    if (ee === void 0)
      throw new Error(`Failed to find TokenId for ${T}`);
    if (te === void 0)
      throw new Error(`Failed to find TokenId for ${$}`);
    const re = (await this.getV2ChainContext(V)).context, ie = (await this.getV2ChainContext(J)).context, se = await getWormholeContextV2();
    return await RouteTransferRequest.create(
      se,
      /* @ts-ignore */
      {
        source: ee,
        destination: te
      },
      re,
      ie
    );
  }
  async computeReceiveAmount(e, T, $, V, J, ee) {
    if (!V || !J)
      throw new Error("Need both chains to get a quote from SDKv2");
    const [, te] = await this.getQuote(
      e,
      T,
      $,
      V,
      J,
      ee
    );
    if (te.success)
      return te.destinationToken.amount;
    throw te.error;
  }
  async computeQuote(e, T, $, V, J, ee) {
    if (!V || !J)
      throw new Error("Need both chains to get a quote from SDKv2");
    const [, te] = await this.getQuote(
      e,
      T,
      $,
      V,
      J,
      ee
    );
    if (!te.success)
      throw te.error;
    return te;
  }
  async send(e, T, $, V, J, ee, te, re) {
    const [ie, se, de] = await this.getQuote(
      T,
      e.key,
      te,
      $,
      J,
      re
    );
    if (!se.success)
      throw se.error;
    const ue = await SDKv2Signer.fromChain(
      $,
      V,
      {},
      TransferWallet.SENDING
    );
    let fe = await ie.initiate(
      de,
      ue,
      se,
      Wormhole.chainAddress(J, ee)
    );
    if (fe.state === TransferState.SourceInitiated || fe.state === TransferState.SourceFinalized)
      return [ie, fe];
    let he = 0;
    const me = 5, xe = 1e3;
    for (; he < me; )
      try {
        for await (fe of ie.track(fe, 120 * 1e3))
          if (fe.state >= TransferState.SourceInitiated)
            return [ie, fe];
      } catch (ve) {
        console.error(
          `Error tracking transfer (attempt ${he + 1} / ${me}):`,
          ve
        );
        const Te = xe * Math.pow(2, he);
        await sleep(Te), he++;
      }
    throw new Error("Never got a SourceInitiated state in receipt");
  }
  async resumeIfManual(e) {
    const T = await getWormholeContextV2(), $ = new this.rc(T);
    return isManual($) || isFinalizable($) ? $.resume(e) : null;
  }
  // Prevent receiving illiquid wormhole-wrapped tokens
  // This is not a perfect solution or an exhaustive list of all illiquid tokens,
  // but it should cover the most common cases
  isIlliquidDestToken(e, T) {
    const { symbol: $, nativeChain: V } = e;
    return !!(isFrankensteinToken(e, T) || ["ETH", "WETH"].includes($) && V === "Ethereum" && ["Scroll", "Blast", "Xlayer", "Mantle"].includes(T));
  }
}
const isNttSupportedToken = async (C, e, T) => {
  const $ = async (ee) => {
    const te = config$1.routes.get(ee);
    if (!te) return !1;
    const [re, ie] = await Promise.all([
      te.rc.supportedSourceTokens(e),
      te.rc.supportedDestinationTokens(C, e, T)
    ]);
    return re.some(
      (de) => isSameToken(de, C)
    ) && ie.length > 0;
  }, [V, J] = await Promise.all([
    $("ManualNtt"),
    $("AutomaticNtt")
  ]);
  return V || J;
};
var NttRoute;
(function(C) {
  C.TRIMMED_DECIMALS = 8, C.ManualOptions = {
    automatic: !1
  }, C.AutomaticOptions = {
    automatic: !0,
    gasDropoff: "0.0"
  };
  function e(ie) {
    return ["Mainnet", "Testnet"];
  }
  C.resolveSupportedNetworks = e;
  function T(ie, se) {
    return Object.values(ie.tokens).flatMap((ue) => ue.map((fe) => fe.chain));
  }
  C.resolveSupportedChains = T;
  function $(ie, se) {
    return Object.entries(ie.tokens).map(([, ue]) => {
      const fe = ue.find((he) => he.chain === se.chain);
      return fe ? Wormhole.tokenId(se.chain, fe.token) : null;
    }).filter((ue) => !!ue);
  }
  C.resolveSourceTokens = $;
  function V(ie, se, de, ue) {
    return Object.entries(ie.tokens).map(([, fe]) => {
      if (!fe.find((xe) => xe.chain === de.chain && xe.token.toLowerCase() === canonicalAddress(se).toLowerCase()))
        return;
      const me = fe.find((xe) => xe.chain === ue.chain);
      if (me)
        return Wormhole.tokenId(ue.chain, me.token);
    }).filter((fe) => !!fe);
  }
  C.resolveDestinationTokens = V;
  function J(ie, se) {
    const de = Object.values(ie.tokens), ue = canonicalAddress(se);
    for (const fe of de) {
      const he = fe.find((me) => me.token.toLowerCase() === ue.toLowerCase() && me.chain === se.chain);
      if (he)
        return {
          token: he.token,
          manager: he.manager,
          transceiver: {
            wormhole: he.transceiver.find((me) => me.type === "wormhole").address
          },
          quoter: he.quoter
        };
    }
    throw new Error("Cannot find Ntt contracts in config for: " + ue);
  }
  C.resolveNttContracts = J;
  function ee(ie, se, de) {
    const ue = Object.values(ie.tokens), fe = canonicalAddress(se);
    for (const he of ue)
      if (he.find((xe) => xe.manager.toLowerCase() === fe.toLowerCase() && xe.chain === se.chain)) {
        const xe = he.find((ve) => ve.chain === de);
        if (!xe)
          throw new Error(`Cannot find destination Ntt contracts in config for: ${fe}`);
        return {
          token: xe.token,
          manager: xe.manager,
          transceiver: {
            wormhole: xe.transceiver.find((ve) => ve.type === "wormhole").address
          },
          quoter: xe.quoter
        };
      }
    throw new Error("Cannot find Ntt contracts in config for: " + fe);
  }
  C.resolveDestinationNttContracts = ee;
  function te(ie, se) {
    const de = se * 95n / 100n;
    return ie > de;
  }
  C.isCapacityThresholdExceeded = te;
  function re(ie, se) {
    return truncate(ie, Math.min(ie.decimals, se, C.TRIMMED_DECIMALS));
  }
  C.trimAmount = re;
})(NttRoute || (NttRoute = {}));
const nttManagerMessageLayout = (C) => [
  { name: "id", binary: "bytes", size: 32 },
  { name: "sender", ...universalAddressItem },
  customizableBytes({ name: "payload", lengthSize: 2 }, C)
], prefixItem = (C) => ({
  name: "prefix",
  binary: "bytes",
  custom: Uint8Array.from(C),
  omit: !0
}), transceiverMessageLayout = (C, e, T) => [
  prefixItem(C),
  { name: "sourceNttManager", ...universalAddressItem },
  { name: "recipientNttManager", ...universalAddressItem },
  customizableBytes({ name: "nttManagerPayload", lengthSize: 2 }, e),
  customizableBytes({ name: "transceiverPayload", lengthSize: 2 }, T)
], transceiverInfo = [
  prefixItem([156, 35, 189, 59]),
  { name: "managerAddress", ...universalAddressItem },
  { name: "mode", binary: "uint", size: 1 },
  { name: "token", ...universalAddressItem },
  { name: "decimals", binary: "uint", size: 1 }
], transceiverRegistration = [
  prefixItem([24, 252, 103, 194]),
  { name: "chain", ...chainItem() },
  { name: "transceiver", ...universalAddressItem }
], trimmedAmountLayout = [
  { name: "decimals", binary: "uint", size: 1 },
  { name: "amount", binary: "uint", size: 8 }
], trimmedAmountItem = {
  binary: "bytes",
  layout: trimmedAmountLayout
};
function deserializeNum(C, e) {
  let T = 0n;
  for (let $ = 0; $ < e; ++$)
    T |= BigInt(C[$]) << BigInt(8 * (e - $ - 1));
  return Number(T);
}
function serializeNum(C, e) {
  const T = 2n ** BigInt(e * 8);
  if (C >= T)
    throw new Error(`Value ${C} is too large for ${e} bytes`);
  const $ = new Uint8Array(e);
  for (let V = 0; V < e; ++V)
    $[V] = Number(BigInt(C) >> BigInt(8 * (e - V - 1)) & 0xffn);
  return $;
}
const optionalAdditionalPayloadItem = {
  binary: "bytes",
  custom: {
    to: (C) => {
      if (C.byteLength >= 2) {
        const e = deserializeNum(C, 2);
        return C.slice(2, 2 + e);
      }
      return new Uint8Array();
    },
    from: (C) => C.byteLength > 0 ? new Uint8Array([...serializeNum(C.byteLength, 2), ...C]) : new Uint8Array()
  }
}, nativeTokenTransferLayout = [
  prefixItem([153, 78, 84, 84]),
  { name: "trimmedAmount", ...trimmedAmountItem },
  { name: "sourceToken", ...universalAddressItem },
  { name: "recipientAddress", ...universalAddressItem },
  { name: "recipientChain", ...chainItem() },
  { name: "additionalPayload", ...optionalAdditionalPayloadItem }
], wormholeTransceiverMessageLayout = (C) => transceiverMessageLayout([153, 69, 255, 16], C, new Uint8Array(0)), transceiverInstructionLayout = (C) => [
  { name: "index", binary: "uint", size: 1 },
  customizableBytes({ name: "payload", lengthSize: 1 }, C)
], nttNamedPayloads = [
  [
    "WormholeTransfer",
    wormholeTransceiverMessageLayout(nttManagerMessageLayout(nativeTokenTransferLayout))
  ],
  [
    "WormholeTransferStandardRelayer",
    deliveryInstructionLayout(wormholeTransceiverMessageLayout(nttManagerMessageLayout(nativeTokenTransferLayout)))
  ],
  ["TransceiverInfo", transceiverInfo],
  ["TransceiverRegistration", transceiverRegistration]
];
var Ntt;
(function(C) {
  function e(V) {
    if (V.length > 255)
      throw new Error(`Too many instructions (${V.length})`);
    return bytes.concat(new Uint8Array([V.length]), ...V.map((J) => serialize$2(transceiverInstructionLayout(), J)));
  }
  C.encodeTransceiverInstructions = e;
  function T(V, J) {
    return keccak_256(bytes.concat(bignum.toBytes(toChainId(V), 2), serialize$2(nttManagerMessageLayout(nativeTokenTransferLayout), J)));
  }
  C.messageDigest = T;
  function $(V, J) {
    const ee = (de) => {
      const ue = /^(\d+)\.(\d+)\.(.*)$/, fe = de.match(ue);
      if (!fe)
        throw new Error(`Invalid version format: ${de}`);
      const [, he, me, xe] = fe;
      return { major: Number(he), minor: Number(me), patchAndTag: xe };
    }, { major: te, minor: re } = ee(V), { major: ie, minor: se } = ee(J);
    return te === ie && re >= se;
  }
  C.abiVersionMatches = $;
})(Ntt || (Ntt = {}));
registerPayloadTypes("Ntt", nttNamedPayloads);
function nttManualRoute(C) {
  class e extends NttManualRoute {
  }
  return tt(e, "config", C), e;
}
class NttManualRoute extends FinalizableRoute {
  constructor() {
    super(...arguments);
    // @ts-ignore
    // Since we set the config on the static class, access it with this param
    // the NttManualRoute.config will always be empty
    tt(this, "staticConfig", this.constructor.config);
  }
  static supportedNetworks() {
    return NttRoute.resolveSupportedNetworks(this.config);
  }
  static supportedChains(T) {
    return NttRoute.resolveSupportedChains(this.config, T);
  }
  static async supportedSourceTokens(T) {
    return NttRoute.resolveSourceTokens(this.config, T);
  }
  static async supportedDestinationTokens(T, $, V) {
    return NttRoute.resolveDestinationTokens(this.config, T, $, V);
  }
  static isProtocolSupported(T) {
    return T.supportsProtocol("Ntt");
  }
  getDefaultOptions() {
    return NttRoute.ManualOptions;
  }
  async validate(T, $) {
    const V = $.options ?? this.getDefaultOptions(), J = parse$3($.amount, T.source.decimals), ee = NttRoute.trimAmount(J, T.destination.decimals), te = units(parse$3(V.gasDropoff ?? "0.0", T.toChain.config.nativeTokenDecimals));
    return { valid: !0, params: {
      amount: $.amount,
      normalizedParams: {
        amount: ee,
        sourceContracts: NttRoute.resolveNttContracts(this.staticConfig, T.source.id),
        destinationContracts: NttRoute.resolveNttContracts(this.staticConfig, T.destination.id),
        options: {
          queue: !1,
          automatic: !1,
          gasDropoff: te
        }
      },
      options: V
    } };
  }
  async quote(T, $) {
    const V = scale$1($.normalizedParams.amount, T.destination.decimals), J = {
      success: !0,
      params: $,
      sourceToken: {
        token: T.source.id,
        amount: $.normalizedParams.amount
      },
      destinationToken: {
        token: T.destination.id,
        amount: V
      },
      eta: estimateFinalityTime(T.fromChain.chain)
    }, { fromChain: ee, toChain: te } = T, re = await te.getProtocol("Ntt", {
      ntt: $.normalizedParams.destinationContracts
    }), ie = await re.getRateLimitDuration();
    if (ie > 0n) {
      const se = await re.getCurrentInboundCapacity(ee.chain);
      NttRoute.isCapacityThresholdExceeded(units(V), se) && (J.warnings = [
        {
          type: "DestinationCapacityWarning",
          delayDurationSec: Number(ie)
        }
      ]);
    }
    return J;
  }
  async initiate(T, $, V, J) {
    const { params: ee } = V, { fromChain: te } = T, re = Wormhole.parseAddress($.chain(), $.address()), se = (await te.getProtocol("Ntt", {
      ntt: ee.normalizedParams.sourceContracts
    })).transfer(re, units(ee.normalizedParams.amount), J, ee.normalizedParams.options), de = await signSendWait(te, se, $);
    return {
      from: te.chain,
      to: J.chain,
      state: TransferState.SourceInitiated,
      originTxs: de,
      params: ee
    };
  }
  async complete(T, $) {
    if (!isAttested($)) {
      if (isRedeemed($))
        return $;
      throw new Error("The source must be finalized in order to complete the transfer");
    }
    const V = this.wh.getChain($.to), J = await V.getProtocol("Ntt", {
      ntt: $.params.normalizedParams.destinationContracts
    }), ee = Wormhole.parseAddress(T.chain(), T.address()), te = J.redeem([$.attestation.attestation], ee), re = await signSendWait(V, te, T);
    return {
      ...$,
      state: TransferState.DestinationInitiated,
      destinationTxs: re
    };
  }
  async resume(T) {
    const $ = await this.wh.getVaa(T.txid, "Ntt:WormholeTransfer");
    if (!$)
      throw new Error("No VAA found for transaction: " + T.txid);
    const V = {
      chain: $.emitterChain,
      emitter: $.emitterAddress,
      sequence: $.sequence
    }, { recipientChain: J, trimmedAmount: ee } = $.payload.nttManagerPayload.payload, te = canonicalAddress({
      chain: $.emitterChain,
      address: $.payload.nttManagerPayload.payload.sourceToken
    }), re = canonicalAddress({
      chain: $.emitterChain,
      address: $.payload.sourceNttManager
    }), ie = $.emitterChain === "Solana" ? re : canonicalAddress({
      chain: $.emitterChain,
      address: $.emitterAddress
    }), se = NttRoute.resolveDestinationNttContracts(this.staticConfig, {
      chain: $.emitterChain,
      address: $.payload.sourceNttManager
    }, J), de = fromBaseUnits(ee.amount, ee.decimals);
    return {
      from: $.emitterChain,
      to: J,
      state: TransferState.Attested,
      originTxs: [T],
      attestation: {
        id: V,
        attestation: $
      },
      params: {
        amount: display(de),
        options: { automatic: !1 },
        normalizedParams: {
          amount: de,
          options: { queue: !1 },
          sourceContracts: {
            token: te,
            manager: re,
            transceiver: {
              wormhole: ie
            }
          },
          destinationContracts: {
            token: se.token,
            manager: se.manager,
            transceiver: {
              wormhole: se.transceiver.wormhole
            }
          }
        }
      }
    };
  }
  async finalize(T, $) {
    if (!isDestinationQueued($))
      throw new Error("The transfer must be destination queued in order to finalize");
    const { attestation: { attestation: V } } = $, J = this.wh.getChain($.to), ee = await J.getProtocol("Ntt", {
      ntt: $.params.normalizedParams.destinationContracts
    }), te = Wormhole.chainAddress(T.chain(), T.address()), re = ee.completeInboundQueuedTransfer($.from, V.payload.nttManagerPayload, te.address), ie = await signSendWait(J, re, T);
    return {
      ...$,
      state: TransferState.DestinationFinalized,
      destinationTxs: [...$.destinationTxs ?? [], ...ie]
    };
  }
  async *track(T, $) {
    if (isSourceInitiated(T) || isSourceFinalized(T)) {
      const { txid: ee } = T.originTxs[T.originTxs.length - 1], te = await this.wh.getVaa(ee, "Ntt:WormholeTransfer", $);
      if (!te)
        throw new Error("No VAA found for transaction: " + ee);
      const re = {
        chain: te.emitterChain,
        emitter: te.emitterAddress,
        sequence: te.sequence
      };
      T = {
        ...T,
        state: TransferState.Attested,
        attestation: {
          id: re,
          attestation: te
        }
      }, yield T;
    }
    const J = await this.wh.getChain(T.to).getProtocol("Ntt", {
      ntt: T.params.normalizedParams.destinationContracts
    });
    if (isAttested(T)) {
      const { attestation: { attestation: ee } } = T;
      await J.getIsApproved(ee) && (T = {
        ...T,
        state: TransferState.DestinationInitiated
        // TODO: check for destination event transactions to get dest Txids
      }, yield T);
    }
    if (isRedeemed(T) || isDestinationQueued(T)) {
      const { attestation: { attestation: ee } } = T, te = await J.getInboundQueuedTransfer(ee.emitterChain, ee.payload.nttManagerPayload);
      te !== null ? (T = {
        ...T,
        state: TransferState.DestinationQueued,
        queueReleaseTime: new Date(te.rateLimitExpiryTimestamp * 1e3)
      }, yield T) : await J.getIsExecuted(ee) && (T = {
        ...T,
        state: TransferState.DestinationFinalized
      }, yield T);
    }
    yield T;
  }
}
tt(NttManualRoute, "NATIVE_GAS_DROPOFF_SUPPORTED", !1), tt(NttManualRoute, "IS_AUTOMATIC", !1), tt(NttManualRoute, "config", { tokens: {} }), tt(NttManualRoute, "meta", { name: "ManualNtt" });
function nttAutomaticRoute(C) {
  class e extends NttAutomaticRoute {
  }
  return tt(e, "config", C), e;
}
class NttAutomaticRoute extends AutomaticRoute {
  constructor() {
    super(...arguments);
    // @ts-ignore
    // Since we set the config on the static class, access it with this param
    // the NttManualRoute.config will always be empty
    tt(this, "staticConfig", this.constructor.config);
  }
  static supportedNetworks() {
    return NttRoute.resolveSupportedNetworks(this.config);
  }
  static supportedChains(T) {
    return NttRoute.resolveSupportedChains(this.config, T);
  }
  static async supportedSourceTokens(T) {
    return NttRoute.resolveSourceTokens(this.config, T);
  }
  static async supportedDestinationTokens(T, $, V) {
    return NttRoute.resolveDestinationTokens(this.config, T, $, V);
  }
  static isProtocolSupported(T) {
    return T.supportsProtocol("Ntt");
  }
  getDefaultOptions() {
    return NttRoute.AutomaticOptions;
  }
  async isAvailable(T) {
    const $ = NttRoute.resolveNttContracts(this.staticConfig, T.source.id);
    return (await T.fromChain.getProtocol("Ntt", {
      ntt: $
    })).isRelayingAvailable(T.toChain.chain);
  }
  async validate(T, $) {
    const V = $.options ?? this.getDefaultOptions(), J = parse$3(V.gasDropoff ?? "0.0", T.toChain.config.nativeTokenDecimals), ee = parse$3($.amount, T.source.decimals), te = NttRoute.trimAmount(ee, T.destination.decimals);
    return { valid: !0, params: {
      amount: $.amount,
      normalizedParams: {
        amount: te,
        sourceContracts: NttRoute.resolveNttContracts(this.staticConfig, T.source.id),
        destinationContracts: NttRoute.resolveNttContracts(this.staticConfig, T.destination.id),
        options: {
          queue: !1,
          automatic: !0,
          gasDropoff: units(J)
        }
      },
      options: V
    } };
  }
  async quote(T, $) {
    const { fromChain: V, toChain: J } = T, ee = await V.getProtocol("Ntt", {
      ntt: $.normalizedParams.sourceContracts
    });
    if (!await ee.isRelayingAvailable(J.chain))
      return {
        success: !1,
        error: new Error(`Relaying to chain ${J.chain} is not available`)
      };
    const te = await ee.quoteDeliveryPrice(J.chain, $.normalizedParams.options), re = scale$1($.normalizedParams.amount, T.destination.decimals), ie = {
      success: !0,
      params: $,
      sourceToken: {
        token: T.source.id,
        amount: $.normalizedParams.amount
      },
      destinationToken: {
        token: T.destination.id,
        amount: re
      },
      relayFee: {
        token: Wormhole.tokenId(V.chain, "native"),
        amount: fromBaseUnits(te, V.config.nativeTokenDecimals)
      },
      destinationNativeGas: fromBaseUnits($.normalizedParams.options.gasDropoff ?? 0n, J.config.nativeTokenDecimals),
      eta: estimateFinalityTime(T.fromChain.chain)
    }, se = await J.getProtocol("Ntt", {
      ntt: $.normalizedParams.destinationContracts
    }), de = await se.getRateLimitDuration();
    if (de > 0n) {
      const ue = await se.getCurrentInboundCapacity(V.chain);
      NttRoute.isCapacityThresholdExceeded(units(re), ue) && (ie.warnings = [
        {
          type: "DestinationCapacityWarning",
          delayDurationSec: Number(de)
        }
      ]);
    }
    return ie;
  }
  async initiate(T, $, V, J) {
    const { params: ee } = V, { fromChain: te } = T, re = Wormhole.parseAddress($.chain(), $.address()), se = (await te.getProtocol("Ntt", {
      ntt: ee.normalizedParams.sourceContracts
    })).transfer(re, units(ee.normalizedParams.amount), J, ee.normalizedParams.options), de = await signSendWait(te, se, $);
    return {
      from: te.chain,
      to: J.chain,
      state: TransferState.SourceInitiated,
      originTxs: de,
      params: ee
    };
  }
  async resume(T) {
    const $ = await this.wh.getVaa(T.txid, "Ntt:WormholeTransferStandardRelayer");
    if (!$)
      throw new Error("No VAA found for transaction: " + T.txid);
    const V = {
      chain: $.emitterChain,
      emitter: $.emitterAddress,
      sequence: $.sequence
    }, { payload: J } = $.payload, { recipientChain: ee, trimmedAmount: te } = J.nttManagerPayload.payload, re = canonicalAddress({
      chain: $.emitterChain,
      address: J.nttManagerPayload.payload.sourceToken
    }), ie = canonicalAddress({
      chain: $.emitterChain,
      address: J.sourceNttManager
    }), se = $.emitterChain === "Solana" ? ie : canonicalAddress({
      chain: $.emitterChain,
      address: $.emitterAddress
    }), de = NttRoute.resolveDestinationNttContracts(this.staticConfig, {
      chain: $.emitterChain,
      address: J.sourceNttManager
    }, ee), ue = fromBaseUnits(te.amount, te.decimals);
    return {
      from: $.emitterChain,
      to: ee,
      state: TransferState.Attested,
      originTxs: [T],
      attestation: {
        id: V,
        attestation: $
      },
      params: {
        amount: display(ue),
        options: { automatic: !0 },
        normalizedParams: {
          amount: ue,
          options: { queue: !1, automatic: !0 },
          sourceContracts: {
            token: re,
            manager: ie,
            transceiver: {
              wormhole: se
            }
          },
          destinationContracts: {
            token: de.token,
            manager: de.manager,
            transceiver: {
              wormhole: de.transceiver.wormhole
            }
          }
        }
      }
    };
  }
  // Even though this is an automatic route, the transfer may need to be
  // manually finalized if it was queued
  async finalize(T, $) {
    if (!isDestinationQueued($))
      throw new Error("The transfer must be destination queued in order to finalize");
    const { attestation: { attestation: V } } = $, J = this.wh.getChain($.to), ee = await J.getProtocol("Ntt", {
      ntt: $.params.normalizedParams.destinationContracts
    }), te = Wormhole.chainAddress(T.chain(), T.address()), re = V.payloadName === "WormholeTransfer" ? V.payload : V.payload.payload, ie = ee.completeInboundQueuedTransfer($.from, re.nttManagerPayload, te.address), se = await signSendWait(J, ie, T);
    return {
      ...$,
      state: TransferState.DestinationFinalized,
      destinationTxs: [...$.destinationTxs ?? [], ...se]
    };
  }
  async *track(T, $) {
    if (isSourceInitiated(T) || isSourceFinalized(T)) {
      const { txid: ee } = T.originTxs[T.originTxs.length - 1], te = (de) => chainToPlatform(de) === "Evm", re = te(T.from) && te(T.to) ? (
        // Automatic NTT transfers between EVM chains use standard relayers
        "Ntt:WormholeTransferStandardRelayer"
      ) : "Ntt:WormholeTransfer", ie = await this.wh.getVaa(ee, re, $);
      if (!ie)
        throw new Error(`No VAA found for transaction: ${ee}`);
      const se = {
        chain: ie.emitterChain,
        emitter: ie.emitterAddress,
        sequence: ie.sequence
      };
      T = {
        ...T,
        state: TransferState.Attested,
        attestation: {
          id: se,
          attestation: ie
        }
      }, yield T;
    }
    const J = await this.wh.getChain(T.to).getProtocol("Ntt", {
      ntt: T.params.normalizedParams.destinationContracts
    });
    if (isAttested(T)) {
      const { attestation: { attestation: ee } } = T;
      await J.getIsApproved(ee) && (T = {
        ...T,
        state: TransferState.DestinationInitiated
        // TODO: check for destination event transactions to get dest Txids
      }, yield T);
    }
    if (isRedeemed(T) || isDestinationQueued(T)) {
      const { attestation: { attestation: ee } } = T, te = ee.payloadName === "WormholeTransfer" ? ee.payload : ee.payload.payload, re = await J.getInboundQueuedTransfer(ee.emitterChain, te.nttManagerPayload);
      re !== null ? (T = {
        ...T,
        state: TransferState.DestinationQueued,
        queueReleaseTime: new Date(re.rateLimitExpiryTimestamp * 1e3)
      }, yield T) : await J.getIsExecuted(ee) && (T = {
        ...T,
        state: TransferState.DestinationFinalized
      }, yield T);
    }
    yield T;
  }
}
// ntt does not support gas drop-off currently
tt(NttAutomaticRoute, "NATIVE_GAS_DROPOFF_SUPPORTED", !1), tt(NttAutomaticRoute, "config", { tokens: {} }), tt(NttAutomaticRoute, "meta", { name: "AutomaticNtt" });
class EvmUnsignedTransaction {
  constructor(e, T, $, V, J = !1) {
    tt(this, "transaction");
    tt(this, "network");
    tt(this, "chain");
    tt(this, "description");
    tt(this, "parallelizable");
    this.transaction = e, this.network = T, this.chain = $, this.description = V, this.parallelizable = J;
  }
}
const _abi$7 = [
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !0,
        internalType: "address",
        name: "owner",
        type: "address"
      },
      {
        indexed: !0,
        internalType: "address",
        name: "spender",
        type: "address"
      },
      {
        indexed: !1,
        internalType: "uint256",
        name: "value",
        type: "uint256"
      }
    ],
    name: "Approval",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !0,
        internalType: "address",
        name: "from",
        type: "address"
      },
      {
        indexed: !0,
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        indexed: !1,
        internalType: "uint256",
        name: "value",
        type: "uint256"
      }
    ],
    name: "Transfer",
    type: "event"
  },
  {
    inputs: [],
    name: "DOMAIN_SEPARATOR",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner_",
        type: "address"
      },
      {
        internalType: "address",
        name: "spender_",
        type: "address"
      }
    ],
    name: "allowance",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "spender_",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "amount_",
        type: "uint256"
      }
    ],
    name: "approve",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account_",
        type: "address"
      }
    ],
    name: "balanceOf",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account_",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "amount_",
        type: "uint256"
      }
    ],
    name: "burn",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "chainId",
    outputs: [
      {
        internalType: "uint16",
        name: "",
        type: "uint16"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "decimals",
    outputs: [
      {
        internalType: "uint8",
        name: "",
        type: "uint8"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "spender_",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "subtractedValue_",
        type: "uint256"
      }
    ],
    name: "decreaseAllowance",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "eip712Domain",
    outputs: [
      {
        internalType: "bytes1",
        name: "domainFields",
        type: "bytes1"
      },
      {
        internalType: "string",
        name: "domainName",
        type: "string"
      },
      {
        internalType: "string",
        name: "domainVersion",
        type: "string"
      },
      {
        internalType: "uint256",
        name: "domainChainId",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "domainVerifyingContract",
        type: "address"
      },
      {
        internalType: "bytes32",
        name: "domainSalt",
        type: "bytes32"
      },
      {
        internalType: "uint256[]",
        name: "domainExtensions",
        type: "uint256[]"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "spender_",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "addedValue_",
        type: "uint256"
      }
    ],
    name: "increaseAllowance",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "name_",
        type: "string"
      },
      {
        internalType: "string",
        name: "symbol_",
        type: "string"
      },
      {
        internalType: "uint8",
        name: "decimals_",
        type: "uint8"
      },
      {
        internalType: "uint64",
        name: "sequence_",
        type: "uint64"
      },
      {
        internalType: "address",
        name: "owner_",
        type: "address"
      },
      {
        internalType: "uint16",
        name: "chainId_",
        type: "uint16"
      },
      {
        internalType: "bytes32",
        name: "nativeContract_",
        type: "bytes32"
      }
    ],
    name: "initialize",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account_",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "amount_",
        type: "uint256"
      }
    ],
    name: "mint",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "name",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "nativeContract",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner_",
        type: "address"
      }
    ],
    name: "nonces",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner_",
        type: "address"
      },
      {
        internalType: "address",
        name: "spender_",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "value_",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "deadline_",
        type: "uint256"
      },
      {
        internalType: "uint8",
        name: "v_",
        type: "uint8"
      },
      {
        internalType: "bytes32",
        name: "r_",
        type: "bytes32"
      },
      {
        internalType: "bytes32",
        name: "s_",
        type: "bytes32"
      }
    ],
    name: "permit",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "symbol",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "totalSupply",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "recipient_",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "amount_",
        type: "uint256"
      }
    ],
    name: "transfer",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "sender_",
        type: "address"
      },
      {
        internalType: "address",
        name: "recipient_",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "amount_",
        type: "uint256"
      }
    ],
    name: "transferFrom",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "name_",
        type: "string"
      },
      {
        internalType: "string",
        name: "symbol_",
        type: "string"
      },
      {
        internalType: "uint64",
        name: "sequence_",
        type: "uint64"
      }
    ],
    name: "updateDetails",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  }
], _bytecode$7 = "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", isSuperArgs$7 = (C) => C.length > 1;
class TokenImplementation__factory extends ContractFactory {
  constructor(...e) {
    isSuperArgs$7(e) ? super(...e) : super(_abi$7, _bytecode$7, e[0]);
  }
  getDeployTransaction(e) {
    return super.getDeployTransaction(e || {});
  }
  deploy(e) {
    return super.deploy(e || {});
  }
  connect(e) {
    return super.connect(e);
  }
  static createInterface() {
    return new Interface(_abi$7);
  }
  static connect(e, T) {
    return new Contract(e, _abi$7, T);
  }
}
tt(TokenImplementation__factory, "bytecode", _bytecode$7), tt(TokenImplementation__factory, "abi", _abi$7);
class EvmChain extends ChainContext {
}
const hr = class hr extends PlatformContext {
  constructor(e, T) {
    super(e, T ?? networkPlatformConfigs(e, hr._platform));
  }
  getRpc(e) {
    if (e in this.config && this.config[e].rpc)
      return new JsonRpcProvider$1(this.config[e].rpc);
    throw new Error("No configuration available for chain: " + e);
  }
  getChain(e, T) {
    if (e in this.config)
      return new EvmChain(e, this, T);
    throw new Error("No configuration available for chain: " + e);
  }
  static nativeTokenId(e, T) {
    if (!hr.isSupportedChain(T))
      throw new Error(`invalid chain for EVM: ${T}`);
    return Wormhole.tokenId(T, EvmZeroAddress);
  }
  static isNativeTokenId(e, T, $) {
    return !hr.isSupportedChain(T) || $.chain !== T ? !1 : $.address.toString() === EvmZeroAddress;
  }
  static isSupportedChain(e) {
    return chainToPlatform(e) === hr._platform;
  }
  static async getDecimals(e, T, $) {
    if (isNative$1($))
      return nativeDecimals(hr._platform);
    const V = hr.getTokenImplementation(T, new EvmAddress($).toString());
    return Number(await V.decimals());
  }
  static async getBalance(e, T, $, V) {
    return isNative$1(V) ? T.getBalance($) : hr.getTokenImplementation(T, new EvmAddress(V).toString()).balanceOf($);
  }
  static async getBalances(e, T, $, V) {
    return (await Promise.all(V.map(async (ee) => {
      const te = await this.getBalance(e, T, $, ee);
      return { [isNative$1(ee) ? "native" : new EvmAddress(ee).toString()]: te };
    }))).reduce((ee, te) => Object.assign(ee, te), {});
  }
  static async sendWait(e, T, $) {
    const V = [];
    for (const J of $) {
      const ee = await T.broadcastTransaction(J);
      if (V.push(ee.hash), e === "Celo") {
        console.error("TODO: override celo block fetching");
        continue;
      }
      if (await ee.wait() === null)
        throw new Error("Received null TxReceipt");
    }
    return V;
  }
  static async getLatestBlock(e) {
    return await e.getBlockNumber();
  }
  static async getLatestFinalizedBlock(e) {
    const T = await e.getBlock("finalized");
    if (!T)
      throw new Error("Could not get finalized block");
    return T == null ? void 0 : T.number;
  }
  // Look up the Wormhole Canonical Network and Chain from the EVM chainId
  static chainFromChainId(e) {
    const T = platformNativeChainIdToNetworkChain(hr._platform, BigInt(e));
    if (T === void 0)
      throw new Error(`Unknown EVM chainId ${e}`);
    const [$, V] = T;
    return [$, V];
  }
  static async chainFromRpc(e) {
    const { chainId: T } = await e.getNetwork();
    return hr.chainFromChainId(bignum.encode(T, !0));
  }
  static getTokenImplementation(e, T) {
    const $ = TokenImplementation__factory.connect(T, e);
    if (!$)
      throw new Error(`No token implementation available for: ${T}`);
    return $;
  }
};
tt(hr, "_platform", _platform$1);
let EvmPlatform = hr;
class EvmWormholeCore {
  constructor(e, T, $, V) {
    tt(this, "network");
    tt(this, "chain");
    tt(this, "provider");
    tt(this, "contracts");
    tt(this, "chainId");
    tt(this, "coreAddress");
    tt(this, "core");
    tt(this, "coreIface");
    this.network = e, this.chain = T, this.provider = $, this.contracts = V, this.chainId = networkChainToNativeChainId.get(e, T), this.coreIface = Implementation__factory.createInterface();
    const J = this.contracts.coreBridge;
    if (!J)
      throw new Error("Core bridge address not found");
    this.coreAddress = J, this.core = Implementation__factory.connect(J, $);
  }
  async getMessageFee() {
    return await this.core.messageFee.staticCall();
  }
  async getGuardianSetIndex() {
    return Number(await this.core.getCurrentGuardianSetIndex.staticCall());
  }
  async getGuardianSet(e) {
    const T = await this.core.getGuardianSet(e);
    return {
      index: e,
      keys: T[0],
      expiry: T[1]
    };
  }
  static async fromRpc(e, T) {
    const [$, V] = await EvmPlatform.chainFromRpc(e), J = T[V];
    if (J.network !== $)
      throw new Error(`Network mismatch: ${J.network} != ${$}`);
    return new EvmWormholeCore($, V, e, J.contracts);
  }
  async *publishMessage(e, T, $, V) {
    const J = new EvmAddress(e).toString(), ee = await this.core.publishMessage.populateTransaction($, T, V);
    yield this.createUnsignedTx(addFrom(ee, J), "WormholeCore.publishMessage");
  }
  async *verifyMessage(e, T) {
    const $ = new EvmAddress(e).toString(), V = await this.core.parseAndVerifyVM.populateTransaction(serialize$1(T));
    yield this.createUnsignedTx(addFrom(V, $), "WormholeCore.verifyMessage");
  }
  async parseTransaction(e) {
    const T = await this.provider.getTransactionReceipt(e);
    return T === null ? [] : T.logs.filter(($) => $.address === this.coreAddress).map(($) => {
      const { topics: V, data: J } = $, ee = this.coreIface.parseLog({
        topics: V.slice(),
        data: J
      });
      if (ee === null)
        return;
      const te = new EvmAddress(ee.args.sender);
      return {
        chain: this.chain,
        emitter: te.toUniversalAddress(),
        sequence: ee.args.sequence
      };
    }).filter(isWormholeMessageId);
  }
  async parseMessages(e) {
    const T = await this.provider.getTransactionReceipt(e);
    if (T === null)
      throw new Error("Could not get transaction receipt");
    const $ = await this.getGuardianSetIndex();
    return T.logs.filter((V) => V.address === this.coreAddress).map((V) => {
      const { topics: J, data: ee } = V, te = this.coreIface.parseLog({
        topics: J.slice(),
        data: ee
      });
      if (te === null)
        return null;
      const re = new EvmAddress(te.args.sender);
      return createVAA("Uint8Array", {
        guardianSet: $,
        // TODO: should we get this from the contract on init?
        timestamp: 0,
        // TODO: Would need to get the full block to get the timestamp
        emitterChain: this.chain,
        emitterAddress: re.toUniversalAddress(),
        consistencyLevel: Number(te.args.consistencyLevel),
        sequence: BigInt(te.args.sequence),
        nonce: Number(te.args.nonce),
        signatures: [],
        payload: hex$1.decode(te.args.payload)
      });
    }).filter((V) => !!V);
  }
  createUnsignedTx(e, T, $ = !1) {
    return new EvmUnsignedTransaction(addChainId(e, this.chainId), this.network, this.chain, T, $);
  }
}
const _abi$6 = [
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !1,
        internalType: "address",
        name: "previousAdmin",
        type: "address"
      },
      {
        indexed: !1,
        internalType: "address",
        name: "newAdmin",
        type: "address"
      }
    ],
    name: "AdminChanged",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !0,
        internalType: "address",
        name: "beacon",
        type: "address"
      }
    ],
    name: "BeaconUpgraded",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !0,
        internalType: "address",
        name: "oldContract",
        type: "address"
      },
      {
        indexed: !0,
        internalType: "address",
        name: "newContract",
        type: "address"
      }
    ],
    name: "ContractUpgraded",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !0,
        internalType: "uint32",
        name: "index",
        type: "uint32"
      }
    ],
    name: "GuardianSetAdded",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !0,
        internalType: "address",
        name: "sender",
        type: "address"
      },
      {
        indexed: !1,
        internalType: "uint64",
        name: "sequence",
        type: "uint64"
      },
      {
        indexed: !1,
        internalType: "uint32",
        name: "nonce",
        type: "uint32"
      },
      {
        indexed: !1,
        internalType: "bytes",
        name: "payload",
        type: "bytes"
      },
      {
        indexed: !1,
        internalType: "uint8",
        name: "consistencyLevel",
        type: "uint8"
      }
    ],
    name: "LogMessagePublished",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !0,
        internalType: "address",
        name: "implementation",
        type: "address"
      }
    ],
    name: "Upgraded",
    type: "event"
  },
  {
    stateMutability: "payable",
    type: "fallback"
  },
  {
    inputs: [],
    name: "chainId",
    outputs: [
      {
        internalType: "uint16",
        name: "",
        type: "uint16"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "evmChainId",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "getCurrentGuardianSetIndex",
    outputs: [
      {
        internalType: "uint32",
        name: "",
        type: "uint32"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint32",
        name: "index",
        type: "uint32"
      }
    ],
    name: "getGuardianSet",
    outputs: [
      {
        components: [
          {
            internalType: "address[]",
            name: "keys",
            type: "address[]"
          },
          {
            internalType: "uint32",
            name: "expirationTime",
            type: "uint32"
          }
        ],
        internalType: "struct Structs.GuardianSet",
        name: "",
        type: "tuple"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "getGuardianSetExpiry",
    outputs: [
      {
        internalType: "uint32",
        name: "",
        type: "uint32"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "hash",
        type: "bytes32"
      }
    ],
    name: "governanceActionIsConsumed",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "governanceChainId",
    outputs: [
      {
        internalType: "uint16",
        name: "",
        type: "uint16"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "governanceContract",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "initialize",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "isFork",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "impl",
        type: "address"
      }
    ],
    name: "isInitialized",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "messageFee",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "emitter",
        type: "address"
      }
    ],
    name: "nextSequence",
    outputs: [
      {
        internalType: "uint64",
        name: "",
        type: "uint64"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "bytes",
        name: "encodedVM",
        type: "bytes"
      }
    ],
    name: "parseAndVerifyVM",
    outputs: [
      {
        components: [
          {
            internalType: "uint8",
            name: "version",
            type: "uint8"
          },
          {
            internalType: "uint32",
            name: "timestamp",
            type: "uint32"
          },
          {
            internalType: "uint32",
            name: "nonce",
            type: "uint32"
          },
          {
            internalType: "uint16",
            name: "emitterChainId",
            type: "uint16"
          },
          {
            internalType: "bytes32",
            name: "emitterAddress",
            type: "bytes32"
          },
          {
            internalType: "uint64",
            name: "sequence",
            type: "uint64"
          },
          {
            internalType: "uint8",
            name: "consistencyLevel",
            type: "uint8"
          },
          {
            internalType: "bytes",
            name: "payload",
            type: "bytes"
          },
          {
            internalType: "uint32",
            name: "guardianSetIndex",
            type: "uint32"
          },
          {
            components: [
              {
                internalType: "bytes32",
                name: "r",
                type: "bytes32"
              },
              {
                internalType: "bytes32",
                name: "s",
                type: "bytes32"
              },
              {
                internalType: "uint8",
                name: "v",
                type: "uint8"
              },
              {
                internalType: "uint8",
                name: "guardianIndex",
                type: "uint8"
              }
            ],
            internalType: "struct Structs.Signature[]",
            name: "signatures",
            type: "tuple[]"
          },
          {
            internalType: "bytes32",
            name: "hash",
            type: "bytes32"
          }
        ],
        internalType: "struct Structs.VM",
        name: "vm",
        type: "tuple"
      },
      {
        internalType: "bool",
        name: "valid",
        type: "bool"
      },
      {
        internalType: "string",
        name: "reason",
        type: "string"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "bytes",
        name: "encodedUpgrade",
        type: "bytes"
      }
    ],
    name: "parseContractUpgrade",
    outputs: [
      {
        components: [
          {
            internalType: "bytes32",
            name: "module",
            type: "bytes32"
          },
          {
            internalType: "uint8",
            name: "action",
            type: "uint8"
          },
          {
            internalType: "uint16",
            name: "chain",
            type: "uint16"
          },
          {
            internalType: "address",
            name: "newContract",
            type: "address"
          }
        ],
        internalType: "struct GovernanceStructs.ContractUpgrade",
        name: "cu",
        type: "tuple"
      }
    ],
    stateMutability: "pure",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "bytes",
        name: "encodedUpgrade",
        type: "bytes"
      }
    ],
    name: "parseGuardianSetUpgrade",
    outputs: [
      {
        components: [
          {
            internalType: "bytes32",
            name: "module",
            type: "bytes32"
          },
          {
            internalType: "uint8",
            name: "action",
            type: "uint8"
          },
          {
            internalType: "uint16",
            name: "chain",
            type: "uint16"
          },
          {
            components: [
              {
                internalType: "address[]",
                name: "keys",
                type: "address[]"
              },
              {
                internalType: "uint32",
                name: "expirationTime",
                type: "uint32"
              }
            ],
            internalType: "struct Structs.GuardianSet",
            name: "newGuardianSet",
            type: "tuple"
          },
          {
            internalType: "uint32",
            name: "newGuardianSetIndex",
            type: "uint32"
          }
        ],
        internalType: "struct GovernanceStructs.GuardianSetUpgrade",
        name: "gsu",
        type: "tuple"
      }
    ],
    stateMutability: "pure",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "bytes",
        name: "encodedRecoverChainId",
        type: "bytes"
      }
    ],
    name: "parseRecoverChainId",
    outputs: [
      {
        components: [
          {
            internalType: "bytes32",
            name: "module",
            type: "bytes32"
          },
          {
            internalType: "uint8",
            name: "action",
            type: "uint8"
          },
          {
            internalType: "uint256",
            name: "evmChainId",
            type: "uint256"
          },
          {
            internalType: "uint16",
            name: "newChainId",
            type: "uint16"
          }
        ],
        internalType: "struct GovernanceStructs.RecoverChainId",
        name: "rci",
        type: "tuple"
      }
    ],
    stateMutability: "pure",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "bytes",
        name: "encodedSetMessageFee",
        type: "bytes"
      }
    ],
    name: "parseSetMessageFee",
    outputs: [
      {
        components: [
          {
            internalType: "bytes32",
            name: "module",
            type: "bytes32"
          },
          {
            internalType: "uint8",
            name: "action",
            type: "uint8"
          },
          {
            internalType: "uint16",
            name: "chain",
            type: "uint16"
          },
          {
            internalType: "uint256",
            name: "messageFee",
            type: "uint256"
          }
        ],
        internalType: "struct GovernanceStructs.SetMessageFee",
        name: "smf",
        type: "tuple"
      }
    ],
    stateMutability: "pure",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "bytes",
        name: "encodedTransferFees",
        type: "bytes"
      }
    ],
    name: "parseTransferFees",
    outputs: [
      {
        components: [
          {
            internalType: "bytes32",
            name: "module",
            type: "bytes32"
          },
          {
            internalType: "uint8",
            name: "action",
            type: "uint8"
          },
          {
            internalType: "uint16",
            name: "chain",
            type: "uint16"
          },
          {
            internalType: "uint256",
            name: "amount",
            type: "uint256"
          },
          {
            internalType: "bytes32",
            name: "recipient",
            type: "bytes32"
          }
        ],
        internalType: "struct GovernanceStructs.TransferFees",
        name: "tf",
        type: "tuple"
      }
    ],
    stateMutability: "pure",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "bytes",
        name: "encodedVM",
        type: "bytes"
      }
    ],
    name: "parseVM",
    outputs: [
      {
        components: [
          {
            internalType: "uint8",
            name: "version",
            type: "uint8"
          },
          {
            internalType: "uint32",
            name: "timestamp",
            type: "uint32"
          },
          {
            internalType: "uint32",
            name: "nonce",
            type: "uint32"
          },
          {
            internalType: "uint16",
            name: "emitterChainId",
            type: "uint16"
          },
          {
            internalType: "bytes32",
            name: "emitterAddress",
            type: "bytes32"
          },
          {
            internalType: "uint64",
            name: "sequence",
            type: "uint64"
          },
          {
            internalType: "uint8",
            name: "consistencyLevel",
            type: "uint8"
          },
          {
            internalType: "bytes",
            name: "payload",
            type: "bytes"
          },
          {
            internalType: "uint32",
            name: "guardianSetIndex",
            type: "uint32"
          },
          {
            components: [
              {
                internalType: "bytes32",
                name: "r",
                type: "bytes32"
              },
              {
                internalType: "bytes32",
                name: "s",
                type: "bytes32"
              },
              {
                internalType: "uint8",
                name: "v",
                type: "uint8"
              },
              {
                internalType: "uint8",
                name: "guardianIndex",
                type: "uint8"
              }
            ],
            internalType: "struct Structs.Signature[]",
            name: "signatures",
            type: "tuple[]"
          },
          {
            internalType: "bytes32",
            name: "hash",
            type: "bytes32"
          }
        ],
        internalType: "struct Structs.VM",
        name: "vm",
        type: "tuple"
      }
    ],
    stateMutability: "pure",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint32",
        name: "nonce",
        type: "uint32"
      },
      {
        internalType: "bytes",
        name: "payload",
        type: "bytes"
      },
      {
        internalType: "uint8",
        name: "consistencyLevel",
        type: "uint8"
      }
    ],
    name: "publishMessage",
    outputs: [
      {
        internalType: "uint64",
        name: "sequence",
        type: "uint64"
      }
    ],
    stateMutability: "payable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "numGuardians",
        type: "uint256"
      }
    ],
    name: "quorum",
    outputs: [
      {
        internalType: "uint256",
        name: "numSignaturesRequiredForQuorum",
        type: "uint256"
      }
    ],
    stateMutability: "pure",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "bytes",
        name: "_vm",
        type: "bytes"
      }
    ],
    name: "submitContractUpgrade",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "bytes",
        name: "_vm",
        type: "bytes"
      }
    ],
    name: "submitNewGuardianSet",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "bytes",
        name: "_vm",
        type: "bytes"
      }
    ],
    name: "submitRecoverChainId",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "bytes",
        name: "_vm",
        type: "bytes"
      }
    ],
    name: "submitSetMessageFee",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "bytes",
        name: "_vm",
        type: "bytes"
      }
    ],
    name: "submitTransferFees",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "hash",
        type: "bytes32"
      },
      {
        components: [
          {
            internalType: "bytes32",
            name: "r",
            type: "bytes32"
          },
          {
            internalType: "bytes32",
            name: "s",
            type: "bytes32"
          },
          {
            internalType: "uint8",
            name: "v",
            type: "uint8"
          },
          {
            internalType: "uint8",
            name: "guardianIndex",
            type: "uint8"
          }
        ],
        internalType: "struct Structs.Signature[]",
        name: "signatures",
        type: "tuple[]"
      },
      {
        components: [
          {
            internalType: "address[]",
            name: "keys",
            type: "address[]"
          },
          {
            internalType: "uint32",
            name: "expirationTime",
            type: "uint32"
          }
        ],
        internalType: "struct Structs.GuardianSet",
        name: "guardianSet",
        type: "tuple"
      }
    ],
    name: "verifySignatures",
    outputs: [
      {
        internalType: "bool",
        name: "valid",
        type: "bool"
      },
      {
        internalType: "string",
        name: "reason",
        type: "string"
      }
    ],
    stateMutability: "pure",
    type: "function"
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "uint8",
            name: "version",
            type: "uint8"
          },
          {
            internalType: "uint32",
            name: "timestamp",
            type: "uint32"
          },
          {
            internalType: "uint32",
            name: "nonce",
            type: "uint32"
          },
          {
            internalType: "uint16",
            name: "emitterChainId",
            type: "uint16"
          },
          {
            internalType: "bytes32",
            name: "emitterAddress",
            type: "bytes32"
          },
          {
            internalType: "uint64",
            name: "sequence",
            type: "uint64"
          },
          {
            internalType: "uint8",
            name: "consistencyLevel",
            type: "uint8"
          },
          {
            internalType: "bytes",
            name: "payload",
            type: "bytes"
          },
          {
            internalType: "uint32",
            name: "guardianSetIndex",
            type: "uint32"
          },
          {
            components: [
              {
                internalType: "bytes32",
                name: "r",
                type: "bytes32"
              },
              {
                internalType: "bytes32",
                name: "s",
                type: "bytes32"
              },
              {
                internalType: "uint8",
                name: "v",
                type: "uint8"
              },
              {
                internalType: "uint8",
                name: "guardianIndex",
                type: "uint8"
              }
            ],
            internalType: "struct Structs.Signature[]",
            name: "signatures",
            type: "tuple[]"
          },
          {
            internalType: "bytes32",
            name: "hash",
            type: "bytes32"
          }
        ],
        internalType: "struct Structs.VM",
        name: "vm",
        type: "tuple"
      }
    ],
    name: "verifyVM",
    outputs: [
      {
        internalType: "bool",
        name: "valid",
        type: "bool"
      },
      {
        internalType: "string",
        name: "reason",
        type: "string"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    stateMutability: "payable",
    type: "receive"
  }
], _bytecode$6 = "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", isSuperArgs$6 = (C) => C.length > 1;
class Implementation__factory extends ContractFactory {
  constructor(...e) {
    isSuperArgs$6(e) ? super(...e) : super(_abi$6, _bytecode$6, e[0]);
  }
  getDeployTransaction(e) {
    return super.getDeployTransaction(e || {});
  }
  deploy(e) {
    return super.deploy(e || {});
  }
  connect(e) {
    return super.connect(e);
  }
  static createInterface() {
    return new Interface(_abi$6);
  }
  static connect(e, T) {
    return new Contract(e, _abi$6, T);
  }
}
tt(Implementation__factory, "bytecode", _bytecode$6), tt(Implementation__factory, "abi", _abi$6);
const index$4 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Implementation__factory
}, Symbol.toStringTag, { value: "Module" }));
registerProtocol(_platform$1, "WormholeCore", EvmWormholeCore);
const index$3 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  EvmWormholeCore,
  ethers_contracts: index$4
}, Symbol.toStringTag, { value: "Module" })), _abi$5 = [
  {
    type: "constructor",
    inputs: [
      {
        name: "_token",
        type: "address",
        internalType: "address"
      },
      {
        name: "_mode",
        type: "uint8",
        internalType: "enum IManagerBase.Mode"
      },
      {
        name: "_chainId",
        type: "uint16",
        internalType: "uint16"
      },
      {
        name: "_rateLimitDuration",
        type: "uint64",
        internalType: "uint64"
      },
      {
        name: "_skipRateLimiting",
        type: "bool",
        internalType: "bool"
      }
    ],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    name: "NTT_MANAGER_VERSION",
    inputs: [],
    outputs: [
      {
        name: "",
        type: "string",
        internalType: "string"
      }
    ],
    stateMutability: "view"
  },
  {
    type: "function",
    name: "attestationReceived",
    inputs: [
      {
        name: "sourceChainId",
        type: "uint16",
        internalType: "uint16"
      },
      {
        name: "sourceNttManagerAddress",
        type: "bytes32",
        internalType: "bytes32"
      },
      {
        name: "payload",
        type: "tuple",
        internalType: "struct TransceiverStructs.NttManagerMessage",
        components: [
          {
            name: "id",
            type: "bytes32",
            internalType: "bytes32"
          },
          {
            name: "sender",
            type: "bytes32",
            internalType: "bytes32"
          },
          {
            name: "payload",
            type: "bytes",
            internalType: "bytes"
          }
        ]
      }
    ],
    outputs: [],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    name: "cancelOutboundQueuedTransfer",
    inputs: [
      {
        name: "messageSequence",
        type: "uint64",
        internalType: "uint64"
      }
    ],
    outputs: [],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    name: "chainId",
    inputs: [],
    outputs: [
      {
        name: "",
        type: "uint16",
        internalType: "uint16"
      }
    ],
    stateMutability: "view"
  },
  {
    type: "function",
    name: "completeInboundQueuedTransfer",
    inputs: [
      {
        name: "digest",
        type: "bytes32",
        internalType: "bytes32"
      }
    ],
    outputs: [],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    name: "completeOutboundQueuedTransfer",
    inputs: [
      {
        name: "messageSequence",
        type: "uint64",
        internalType: "uint64"
      }
    ],
    outputs: [
      {
        name: "",
        type: "uint64",
        internalType: "uint64"
      }
    ],
    stateMutability: "payable"
  },
  {
    type: "function",
    name: "executeMsg",
    inputs: [
      {
        name: "sourceChainId",
        type: "uint16",
        internalType: "uint16"
      },
      {
        name: "sourceNttManagerAddress",
        type: "bytes32",
        internalType: "bytes32"
      },
      {
        name: "message",
        type: "tuple",
        internalType: "struct TransceiverStructs.NttManagerMessage",
        components: [
          {
            name: "id",
            type: "bytes32",
            internalType: "bytes32"
          },
          {
            name: "sender",
            type: "bytes32",
            internalType: "bytes32"
          },
          {
            name: "payload",
            type: "bytes",
            internalType: "bytes"
          }
        ]
      }
    ],
    outputs: [],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    name: "getCurrentInboundCapacity",
    inputs: [
      {
        name: "chainId_",
        type: "uint16",
        internalType: "uint16"
      }
    ],
    outputs: [
      {
        name: "",
        type: "uint256",
        internalType: "uint256"
      }
    ],
    stateMutability: "view"
  },
  {
    type: "function",
    name: "getCurrentOutboundCapacity",
    inputs: [],
    outputs: [
      {
        name: "",
        type: "uint256",
        internalType: "uint256"
      }
    ],
    stateMutability: "view"
  },
  {
    type: "function",
    name: "getInboundLimitParams",
    inputs: [
      {
        name: "chainId_",
        type: "uint16",
        internalType: "uint16"
      }
    ],
    outputs: [
      {
        name: "",
        type: "tuple",
        internalType: "struct IRateLimiter.RateLimitParams",
        components: [
          {
            name: "limit",
            type: "uint72",
            internalType: "TrimmedAmount"
          },
          {
            name: "currentCapacity",
            type: "uint72",
            internalType: "TrimmedAmount"
          },
          {
            name: "lastTxTimestamp",
            type: "uint64",
            internalType: "uint64"
          }
        ]
      }
    ],
    stateMutability: "view"
  },
  {
    type: "function",
    name: "getInboundQueuedTransfer",
    inputs: [
      {
        name: "digest",
        type: "bytes32",
        internalType: "bytes32"
      }
    ],
    outputs: [
      {
        name: "",
        type: "tuple",
        internalType: "struct IRateLimiter.InboundQueuedTransfer",
        components: [
          {
            name: "amount",
            type: "uint72",
            internalType: "TrimmedAmount"
          },
          {
            name: "txTimestamp",
            type: "uint64",
            internalType: "uint64"
          },
          {
            name: "recipient",
            type: "address",
            internalType: "address"
          }
        ]
      }
    ],
    stateMutability: "view"
  },
  {
    type: "function",
    name: "getMigratesImmutables",
    inputs: [],
    outputs: [
      {
        name: "",
        type: "bool",
        internalType: "bool"
      }
    ],
    stateMutability: "view"
  },
  {
    type: "function",
    name: "getMode",
    inputs: [],
    outputs: [
      {
        name: "",
        type: "uint8",
        internalType: "uint8"
      }
    ],
    stateMutability: "view"
  },
  {
    type: "function",
    name: "getOutboundLimitParams",
    inputs: [],
    outputs: [
      {
        name: "",
        type: "tuple",
        internalType: "struct IRateLimiter.RateLimitParams",
        components: [
          {
            name: "limit",
            type: "uint72",
            internalType: "TrimmedAmount"
          },
          {
            name: "currentCapacity",
            type: "uint72",
            internalType: "TrimmedAmount"
          },
          {
            name: "lastTxTimestamp",
            type: "uint64",
            internalType: "uint64"
          }
        ]
      }
    ],
    stateMutability: "pure"
  },
  {
    type: "function",
    name: "getOutboundQueuedTransfer",
    inputs: [
      {
        name: "queueSequence",
        type: "uint64",
        internalType: "uint64"
      }
    ],
    outputs: [
      {
        name: "",
        type: "tuple",
        internalType: "struct IRateLimiter.OutboundQueuedTransfer",
        components: [
          {
            name: "recipient",
            type: "bytes32",
            internalType: "bytes32"
          },
          {
            name: "refundAddress",
            type: "bytes32",
            internalType: "bytes32"
          },
          {
            name: "amount",
            type: "uint72",
            internalType: "TrimmedAmount"
          },
          {
            name: "txTimestamp",
            type: "uint64",
            internalType: "uint64"
          },
          {
            name: "recipientChain",
            type: "uint16",
            internalType: "uint16"
          },
          {
            name: "sender",
            type: "address",
            internalType: "address"
          },
          {
            name: "transceiverInstructions",
            type: "bytes",
            internalType: "bytes"
          }
        ]
      }
    ],
    stateMutability: "view"
  },
  {
    type: "function",
    name: "getPeer",
    inputs: [
      {
        name: "chainId_",
        type: "uint16",
        internalType: "uint16"
      }
    ],
    outputs: [
      {
        name: "",
        type: "tuple",
        internalType: "struct INttManager.NttManagerPeer",
        components: [
          {
            name: "peerAddress",
            type: "bytes32",
            internalType: "bytes32"
          },
          {
            name: "tokenDecimals",
            type: "uint8",
            internalType: "uint8"
          }
        ]
      }
    ],
    stateMutability: "view"
  },
  {
    type: "function",
    name: "getThreshold",
    inputs: [],
    outputs: [
      {
        name: "",
        type: "uint8",
        internalType: "uint8"
      }
    ],
    stateMutability: "view"
  },
  {
    type: "function",
    name: "getTransceivers",
    inputs: [],
    outputs: [
      {
        name: "result",
        type: "address[]",
        internalType: "address[]"
      }
    ],
    stateMutability: "pure"
  },
  {
    type: "function",
    name: "initialize",
    inputs: [],
    outputs: [],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    name: "isMessageApproved",
    inputs: [
      {
        name: "digest",
        type: "bytes32",
        internalType: "bytes32"
      }
    ],
    outputs: [
      {
        name: "",
        type: "bool",
        internalType: "bool"
      }
    ],
    stateMutability: "view"
  },
  {
    type: "function",
    name: "isMessageExecuted",
    inputs: [
      {
        name: "digest",
        type: "bytes32",
        internalType: "bytes32"
      }
    ],
    outputs: [
      {
        name: "",
        type: "bool",
        internalType: "bool"
      }
    ],
    stateMutability: "view"
  },
  {
    type: "function",
    name: "isPaused",
    inputs: [],
    outputs: [
      {
        name: "",
        type: "bool",
        internalType: "bool"
      }
    ],
    stateMutability: "view"
  },
  {
    type: "function",
    name: "messageAttestations",
    inputs: [
      {
        name: "digest",
        type: "bytes32",
        internalType: "bytes32"
      }
    ],
    outputs: [
      {
        name: "count",
        type: "uint8",
        internalType: "uint8"
      }
    ],
    stateMutability: "view"
  },
  {
    type: "function",
    name: "migrate",
    inputs: [],
    outputs: [],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    name: "mode",
    inputs: [],
    outputs: [
      {
        name: "",
        type: "uint8",
        internalType: "enum IManagerBase.Mode"
      }
    ],
    stateMutability: "view"
  },
  {
    type: "function",
    name: "nextMessageSequence",
    inputs: [],
    outputs: [
      {
        name: "",
        type: "uint64",
        internalType: "uint64"
      }
    ],
    stateMutability: "view"
  },
  {
    type: "function",
    name: "owner",
    inputs: [],
    outputs: [
      {
        name: "",
        type: "address",
        internalType: "address"
      }
    ],
    stateMutability: "view"
  },
  {
    type: "function",
    name: "pause",
    inputs: [],
    outputs: [],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    name: "pauser",
    inputs: [],
    outputs: [
      {
        name: "",
        type: "address",
        internalType: "address"
      }
    ],
    stateMutability: "view"
  },
  {
    type: "function",
    name: "quoteDeliveryPrice",
    inputs: [
      {
        name: "recipientChain",
        type: "uint16",
        internalType: "uint16"
      },
      {
        name: "transceiverInstructions",
        type: "bytes",
        internalType: "bytes"
      }
    ],
    outputs: [
      {
        name: "",
        type: "uint256[]",
        internalType: "uint256[]"
      },
      {
        name: "",
        type: "uint256",
        internalType: "uint256"
      }
    ],
    stateMutability: "view"
  },
  {
    type: "function",
    name: "rateLimitDuration",
    inputs: [],
    outputs: [
      {
        name: "",
        type: "uint64",
        internalType: "uint64"
      }
    ],
    stateMutability: "view"
  },
  {
    type: "function",
    name: "removeTransceiver",
    inputs: [
      {
        name: "transceiver",
        type: "address",
        internalType: "address"
      }
    ],
    outputs: [],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    name: "setInboundLimit",
    inputs: [
      {
        name: "limit",
        type: "uint256",
        internalType: "uint256"
      },
      {
        name: "chainId_",
        type: "uint16",
        internalType: "uint16"
      }
    ],
    outputs: [],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    name: "setOutboundLimit",
    inputs: [
      {
        name: "limit",
        type: "uint256",
        internalType: "uint256"
      }
    ],
    outputs: [],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    name: "setPeer",
    inputs: [
      {
        name: "peerChainId",
        type: "uint16",
        internalType: "uint16"
      },
      {
        name: "peerContract",
        type: "bytes32",
        internalType: "bytes32"
      },
      {
        name: "decimals",
        type: "uint8",
        internalType: "uint8"
      },
      {
        name: "inboundLimit",
        type: "uint256",
        internalType: "uint256"
      }
    ],
    outputs: [],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    name: "setThreshold",
    inputs: [
      {
        name: "threshold",
        type: "uint8",
        internalType: "uint8"
      }
    ],
    outputs: [],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    name: "setTransceiver",
    inputs: [
      {
        name: "transceiver",
        type: "address",
        internalType: "address"
      }
    ],
    outputs: [],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    name: "token",
    inputs: [],
    outputs: [
      {
        name: "",
        type: "address",
        internalType: "address"
      }
    ],
    stateMutability: "view"
  },
  {
    type: "function",
    name: "tokenDecimals",
    inputs: [],
    outputs: [
      {
        name: "",
        type: "uint8",
        internalType: "uint8"
      }
    ],
    stateMutability: "view"
  },
  {
    type: "function",
    name: "transceiverAttestedToMessage",
    inputs: [
      {
        name: "digest",
        type: "bytes32",
        internalType: "bytes32"
      },
      {
        name: "index",
        type: "uint8",
        internalType: "uint8"
      }
    ],
    outputs: [
      {
        name: "",
        type: "bool",
        internalType: "bool"
      }
    ],
    stateMutability: "view"
  },
  {
    type: "function",
    name: "transfer",
    inputs: [
      {
        name: "amount",
        type: "uint256",
        internalType: "uint256"
      },
      {
        name: "recipientChain",
        type: "uint16",
        internalType: "uint16"
      },
      {
        name: "recipient",
        type: "bytes32",
        internalType: "bytes32"
      }
    ],
    outputs: [
      {
        name: "",
        type: "uint64",
        internalType: "uint64"
      }
    ],
    stateMutability: "payable"
  },
  {
    type: "function",
    name: "transfer",
    inputs: [
      {
        name: "amount",
        type: "uint256",
        internalType: "uint256"
      },
      {
        name: "recipientChain",
        type: "uint16",
        internalType: "uint16"
      },
      {
        name: "recipient",
        type: "bytes32",
        internalType: "bytes32"
      },
      {
        name: "refundAddress",
        type: "bytes32",
        internalType: "bytes32"
      },
      {
        name: "shouldQueue",
        type: "bool",
        internalType: "bool"
      },
      {
        name: "transceiverInstructions",
        type: "bytes",
        internalType: "bytes"
      }
    ],
    outputs: [
      {
        name: "",
        type: "uint64",
        internalType: "uint64"
      }
    ],
    stateMutability: "payable"
  },
  {
    type: "function",
    name: "transferOwnership",
    inputs: [
      {
        name: "newOwner",
        type: "address",
        internalType: "address"
      }
    ],
    outputs: [],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    name: "transferPauserCapability",
    inputs: [
      {
        name: "newPauser",
        type: "address",
        internalType: "address"
      }
    ],
    outputs: [],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    name: "unpause",
    inputs: [],
    outputs: [],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    name: "upgrade",
    inputs: [
      {
        name: "newImplementation",
        type: "address",
        internalType: "address"
      }
    ],
    outputs: [],
    stateMutability: "nonpayable"
  },
  {
    type: "event",
    name: "AdminChanged",
    inputs: [
      {
        name: "previousAdmin",
        type: "address",
        indexed: !1,
        internalType: "address"
      },
      {
        name: "newAdmin",
        type: "address",
        indexed: !1,
        internalType: "address"
      }
    ],
    anonymous: !1
  },
  {
    type: "event",
    name: "BeaconUpgraded",
    inputs: [
      {
        name: "beacon",
        type: "address",
        indexed: !0,
        internalType: "address"
      }
    ],
    anonymous: !1
  },
  {
    type: "event",
    name: "InboundTransferQueued",
    inputs: [
      {
        name: "digest",
        type: "bytes32",
        indexed: !1,
        internalType: "bytes32"
      }
    ],
    anonymous: !1
  },
  {
    type: "event",
    name: "Initialized",
    inputs: [
      {
        name: "version",
        type: "uint64",
        indexed: !1,
        internalType: "uint64"
      }
    ],
    anonymous: !1
  },
  {
    type: "event",
    name: "MessageAlreadyExecuted",
    inputs: [
      {
        name: "sourceNttManager",
        type: "bytes32",
        indexed: !0,
        internalType: "bytes32"
      },
      {
        name: "msgHash",
        type: "bytes32",
        indexed: !0,
        internalType: "bytes32"
      }
    ],
    anonymous: !1
  },
  {
    type: "event",
    name: "MessageAttestedTo",
    inputs: [
      {
        name: "digest",
        type: "bytes32",
        indexed: !1,
        internalType: "bytes32"
      },
      {
        name: "transceiver",
        type: "address",
        indexed: !1,
        internalType: "address"
      },
      {
        name: "index",
        type: "uint8",
        indexed: !1,
        internalType: "uint8"
      }
    ],
    anonymous: !1
  },
  {
    type: "event",
    name: "NotPaused",
    inputs: [
      {
        name: "notPaused",
        type: "bool",
        indexed: !1,
        internalType: "bool"
      }
    ],
    anonymous: !1
  },
  {
    type: "event",
    name: "OutboundTransferCancelled",
    inputs: [
      {
        name: "sequence",
        type: "uint256",
        indexed: !1,
        internalType: "uint256"
      },
      {
        name: "recipient",
        type: "address",
        indexed: !1,
        internalType: "address"
      },
      {
        name: "amount",
        type: "uint256",
        indexed: !1,
        internalType: "uint256"
      }
    ],
    anonymous: !1
  },
  {
    type: "event",
    name: "OutboundTransferQueued",
    inputs: [
      {
        name: "queueSequence",
        type: "uint64",
        indexed: !1,
        internalType: "uint64"
      }
    ],
    anonymous: !1
  },
  {
    type: "event",
    name: "OutboundTransferRateLimited",
    inputs: [
      {
        name: "sender",
        type: "address",
        indexed: !0,
        internalType: "address"
      },
      {
        name: "sequence",
        type: "uint64",
        indexed: !1,
        internalType: "uint64"
      },
      {
        name: "amount",
        type: "uint256",
        indexed: !1,
        internalType: "uint256"
      },
      {
        name: "currentCapacity",
        type: "uint256",
        indexed: !1,
        internalType: "uint256"
      }
    ],
    anonymous: !1
  },
  {
    type: "event",
    name: "OwnershipTransferred",
    inputs: [
      {
        name: "previousOwner",
        type: "address",
        indexed: !0,
        internalType: "address"
      },
      {
        name: "newOwner",
        type: "address",
        indexed: !0,
        internalType: "address"
      }
    ],
    anonymous: !1
  },
  {
    type: "event",
    name: "Paused",
    inputs: [
      {
        name: "paused",
        type: "bool",
        indexed: !1,
        internalType: "bool"
      }
    ],
    anonymous: !1
  },
  {
    type: "event",
    name: "PauserTransferred",
    inputs: [
      {
        name: "oldPauser",
        type: "address",
        indexed: !0,
        internalType: "address"
      },
      {
        name: "newPauser",
        type: "address",
        indexed: !0,
        internalType: "address"
      }
    ],
    anonymous: !1
  },
  {
    type: "event",
    name: "PeerUpdated",
    inputs: [
      {
        name: "chainId_",
        type: "uint16",
        indexed: !0,
        internalType: "uint16"
      },
      {
        name: "oldPeerContract",
        type: "bytes32",
        indexed: !1,
        internalType: "bytes32"
      },
      {
        name: "oldPeerDecimals",
        type: "uint8",
        indexed: !1,
        internalType: "uint8"
      },
      {
        name: "peerContract",
        type: "bytes32",
        indexed: !1,
        internalType: "bytes32"
      },
      {
        name: "peerDecimals",
        type: "uint8",
        indexed: !1,
        internalType: "uint8"
      }
    ],
    anonymous: !1
  },
  {
    type: "event",
    name: "ThresholdChanged",
    inputs: [
      {
        name: "oldThreshold",
        type: "uint8",
        indexed: !1,
        internalType: "uint8"
      },
      {
        name: "threshold",
        type: "uint8",
        indexed: !1,
        internalType: "uint8"
      }
    ],
    anonymous: !1
  },
  {
    type: "event",
    name: "TransceiverAdded",
    inputs: [
      {
        name: "transceiver",
        type: "address",
        indexed: !1,
        internalType: "address"
      },
      {
        name: "transceiversNum",
        type: "uint256",
        indexed: !1,
        internalType: "uint256"
      },
      {
        name: "threshold",
        type: "uint8",
        indexed: !1,
        internalType: "uint8"
      }
    ],
    anonymous: !1
  },
  {
    type: "event",
    name: "TransceiverRemoved",
    inputs: [
      {
        name: "transceiver",
        type: "address",
        indexed: !1,
        internalType: "address"
      },
      {
        name: "threshold",
        type: "uint8",
        indexed: !1,
        internalType: "uint8"
      }
    ],
    anonymous: !1
  },
  {
    type: "event",
    name: "TransferRedeemed",
    inputs: [
      {
        name: "digest",
        type: "bytes32",
        indexed: !0,
        internalType: "bytes32"
      }
    ],
    anonymous: !1
  },
  {
    type: "event",
    name: "TransferSent",
    inputs: [
      {
        name: "recipient",
        type: "bytes32",
        indexed: !1,
        internalType: "bytes32"
      },
      {
        name: "refundAddress",
        type: "bytes32",
        indexed: !1,
        internalType: "bytes32"
      },
      {
        name: "amount",
        type: "uint256",
        indexed: !1,
        internalType: "uint256"
      },
      {
        name: "fee",
        type: "uint256",
        indexed: !1,
        internalType: "uint256"
      },
      {
        name: "recipientChain",
        type: "uint16",
        indexed: !1,
        internalType: "uint16"
      },
      {
        name: "msgSequence",
        type: "uint64",
        indexed: !1,
        internalType: "uint64"
      }
    ],
    anonymous: !1
  },
  {
    type: "event",
    name: "Upgraded",
    inputs: [
      {
        name: "implementation",
        type: "address",
        indexed: !0,
        internalType: "address"
      }
    ],
    anonymous: !1
  },
  {
    type: "error",
    name: "BurnAmountDifferentThanBalanceDiff",
    inputs: [
      {
        name: "burnAmount",
        type: "uint256",
        internalType: "uint256"
      },
      {
        name: "balanceDiff",
        type: "uint256",
        internalType: "uint256"
      }
    ]
  },
  {
    type: "error",
    name: "CallerNotTransceiver",
    inputs: [
      {
        name: "caller",
        type: "address",
        internalType: "address"
      }
    ]
  },
  {
    type: "error",
    name: "CancellerNotSender",
    inputs: [
      {
        name: "canceller",
        type: "address",
        internalType: "address"
      },
      {
        name: "sender",
        type: "address",
        internalType: "address"
      }
    ]
  },
  {
    type: "error",
    name: "CapacityCannotExceedLimit",
    inputs: [
      {
        name: "newCurrentCapacity",
        type: "uint72",
        internalType: "TrimmedAmount"
      },
      {
        name: "newLimit",
        type: "uint72",
        internalType: "TrimmedAmount"
      }
    ]
  },
  {
    type: "error",
    name: "DeliveryPaymentTooLow",
    inputs: [
      {
        name: "requiredPayment",
        type: "uint256",
        internalType: "uint256"
      },
      {
        name: "providedPayment",
        type: "uint256",
        internalType: "uint256"
      }
    ]
  },
  {
    type: "error",
    name: "DisabledTransceiver",
    inputs: [
      {
        name: "transceiver",
        type: "address",
        internalType: "address"
      }
    ]
  },
  {
    type: "error",
    name: "InboundQueuedTransferNotFound",
    inputs: [
      {
        name: "digest",
        type: "bytes32",
        internalType: "bytes32"
      }
    ]
  },
  {
    type: "error",
    name: "InboundQueuedTransferStillQueued",
    inputs: [
      {
        name: "digest",
        type: "bytes32",
        internalType: "bytes32"
      },
      {
        name: "transferTimestamp",
        type: "uint256",
        internalType: "uint256"
      }
    ]
  },
  {
    type: "error",
    name: "InvalidFork",
    inputs: [
      {
        name: "evmChainId",
        type: "uint256",
        internalType: "uint256"
      },
      {
        name: "blockChainId",
        type: "uint256",
        internalType: "uint256"
      }
    ]
  },
  {
    type: "error",
    name: "InvalidInitialization",
    inputs: []
  },
  {
    type: "error",
    name: "InvalidMode",
    inputs: [
      {
        name: "mode",
        type: "uint8",
        internalType: "uint8"
      }
    ]
  },
  {
    type: "error",
    name: "InvalidPauser",
    inputs: [
      {
        name: "account",
        type: "address",
        internalType: "address"
      }
    ]
  },
  {
    type: "error",
    name: "InvalidPeer",
    inputs: [
      {
        name: "chainId",
        type: "uint16",
        internalType: "uint16"
      },
      {
        name: "peerAddress",
        type: "bytes32",
        internalType: "bytes32"
      }
    ]
  },
  {
    type: "error",
    name: "InvalidPeerChainIdZero",
    inputs: []
  },
  {
    type: "error",
    name: "InvalidPeerDecimals",
    inputs: []
  },
  {
    type: "error",
    name: "InvalidPeerZeroAddress",
    inputs: []
  },
  {
    type: "error",
    name: "InvalidRecipient",
    inputs: []
  },
  {
    type: "error",
    name: "InvalidRefundAddress",
    inputs: []
  },
  {
    type: "error",
    name: "InvalidTargetChain",
    inputs: [
      {
        name: "targetChain",
        type: "uint16",
        internalType: "uint16"
      },
      {
        name: "thisChain",
        type: "uint16",
        internalType: "uint16"
      }
    ]
  },
  {
    type: "error",
    name: "InvalidTransceiverZeroAddress",
    inputs: []
  },
  {
    type: "error",
    name: "MessageNotApproved",
    inputs: [
      {
        name: "msgHash",
        type: "bytes32",
        internalType: "bytes32"
      }
    ]
  },
  {
    type: "error",
    name: "NoEnabledTransceivers",
    inputs: []
  },
  {
    type: "error",
    name: "NonRegisteredTransceiver",
    inputs: [
      {
        name: "transceiver",
        type: "address",
        internalType: "address"
      }
    ]
  },
  {
    type: "error",
    name: "NotAnEvmAddress",
    inputs: [
      {
        name: "",
        type: "bytes32",
        internalType: "bytes32"
      }
    ]
  },
  {
    type: "error",
    name: "NotEnoughCapacity",
    inputs: [
      {
        name: "currentCapacity",
        type: "uint256",
        internalType: "uint256"
      },
      {
        name: "amount",
        type: "uint256",
        internalType: "uint256"
      }
    ]
  },
  {
    type: "error",
    name: "NotInitializing",
    inputs: []
  },
  {
    type: "error",
    name: "NotMigrating",
    inputs: []
  },
  {
    type: "error",
    name: "NumberOfDecimalsNotEqual",
    inputs: [
      {
        name: "decimals",
        type: "uint8",
        internalType: "uint8"
      },
      {
        name: "decimalsOther",
        type: "uint8",
        internalType: "uint8"
      }
    ]
  },
  {
    type: "error",
    name: "OnlyDelegateCall",
    inputs: []
  },
  {
    type: "error",
    name: "OutboundQueuedTransferNotFound",
    inputs: [
      {
        name: "queueSequence",
        type: "uint64",
        internalType: "uint64"
      }
    ]
  },
  {
    type: "error",
    name: "OutboundQueuedTransferStillQueued",
    inputs: [
      {
        name: "queueSequence",
        type: "uint64",
        internalType: "uint64"
      },
      {
        name: "transferTimestamp",
        type: "uint256",
        internalType: "uint256"
      }
    ]
  },
  {
    type: "error",
    name: "OwnableInvalidOwner",
    inputs: [
      {
        name: "owner",
        type: "address",
        internalType: "address"
      }
    ]
  },
  {
    type: "error",
    name: "OwnableUnauthorizedAccount",
    inputs: [
      {
        name: "account",
        type: "address",
        internalType: "address"
      }
    ]
  },
  {
    type: "error",
    name: "PeerNotRegistered",
    inputs: [
      {
        name: "chainId",
        type: "uint16",
        internalType: "uint16"
      }
    ]
  },
  {
    type: "error",
    name: "ReentrancyGuardReentrantCall",
    inputs: []
  },
  {
    type: "error",
    name: "RefundFailed",
    inputs: [
      {
        name: "refundAmount",
        type: "uint256",
        internalType: "uint256"
      }
    ]
  },
  {
    type: "error",
    name: "RequireContractIsNotPaused",
    inputs: []
  },
  {
    type: "error",
    name: "RequireContractIsPaused",
    inputs: []
  },
  {
    type: "error",
    name: "RetrievedIncorrectRegisteredTransceivers",
    inputs: [
      {
        name: "retrieved",
        type: "uint256",
        internalType: "uint256"
      },
      {
        name: "registered",
        type: "uint256",
        internalType: "uint256"
      }
    ]
  },
  {
    type: "error",
    name: "ThresholdTooHigh",
    inputs: [
      {
        name: "threshold",
        type: "uint256",
        internalType: "uint256"
      },
      {
        name: "transceivers",
        type: "uint256",
        internalType: "uint256"
      }
    ]
  },
  {
    type: "error",
    name: "TooManyTransceivers",
    inputs: []
  },
  {
    type: "error",
    name: "TransceiverAlreadyAttestedToMessage",
    inputs: [
      {
        name: "nttManagerMessageHash",
        type: "bytes32",
        internalType: "bytes32"
      }
    ]
  },
  {
    type: "error",
    name: "TransceiverAlreadyEnabled",
    inputs: [
      {
        name: "transceiver",
        type: "address",
        internalType: "address"
      }
    ]
  },
  {
    type: "error",
    name: "TransferAmountHasDust",
    inputs: [
      {
        name: "amount",
        type: "uint256",
        internalType: "uint256"
      },
      {
        name: "dust",
        type: "uint256",
        internalType: "uint256"
      }
    ]
  },
  {
    type: "error",
    name: "UndefinedRateLimiting",
    inputs: []
  },
  {
    type: "error",
    name: "UnexpectedDeployer",
    inputs: [
      {
        name: "expectedOwner",
        type: "address",
        internalType: "address"
      },
      {
        name: "owner",
        type: "address",
        internalType: "address"
      }
    ]
  },
  {
    type: "error",
    name: "ZeroAmount",
    inputs: []
  },
  {
    type: "error",
    name: "ZeroThreshold",
    inputs: []
  }
], _bytecode$5 = "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$93083e246e55d56d98f3df2872cd16bfd0$__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__$93083e246e55d56d98f3df2872cd16bfd0$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$93083e246e55d56d98f3df2872cd16bfd0$__5af4938415613439576000946133c4575b5061ffff9283606086015116847f0000000000000000000000000000000000000000000000000000000000000000168082036133a95750506131fc6149cd565b8161322587519280613220816001600160401b03968760ff82169160081c166158bf565b61591a565b960151908160a01c613392576001600160a01b039182169560007f000000000000000000000000000000000000000000000000000000000000000083161561338b57506132706151f2565b508816600052600080516020615bc18339815191528452613296612a9084600020614dcd565b6132a08882615853565b81808960081c169160081c16105b6132d357505050506132c36132d194846155b1565b6132cc83615491565b614893565b565b7f7f63c9251d82a933210c2b6d0b0f116252c3c116788120e64e8e8215df6f316297509561336f839596949760019394519261330e84612b35565b6001600160481b038091168452898401908242168252888501978852896000527f4e8909a01183a67951f5a6147d6e76ed02ea890c72afea01a9edee91edc609b88b52886000209451166001600160481b03198554161784555116826157a0565b019151166001600160601b0360a01b82541617905551908152a1565b90506132ae565b50602491519063033b960d60e41b82526004820152fd5b6044925191631ee5902560e11b835260048301526024820152fd5b6080949194813d8211613431575b816133df60809383612ba1565b810103126106ae578351916133f383612b6b565b8151906001600160481b038216820361026c57508252848101518583015283810151848301526134259060600161311a565b606082015292386131bc565b3d91506133d2565b83513d6000823e3d90fd5b505050565b604490604051906377d879fb60e01b82526004820152466024820152fd5b60405163b3f07bbd60e01b81529193926020918391829161348c9190600484016130ff565b038173__$93083e246e55d56d98f3df2872cd16bfd0$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$93083e246e55d56d98f3df2872cd16bfd0$__5af49182156105a557600092614842575b506144ef818388612e24565b95863410614823576145018734612f7f565b80614814575b506040519061451582612b6b565b6001600160481b0386811683527f00000000000000000000000000000000000000000000000000000000000000006001600160a01b03166020840190815260408085018d815261ffff8d81166060880190815292516315cfa3cb60e11b81529651909416600487015291516024860152905160448501525116606483015260008260848173__$93083e246e55d56d98f3df2872cd16bfd0$__5af49182156105a557614614926000928d9284926147f8575b506001600160401b03604051936145dd85612b35565b16835260018060a01b031660208301526040820152604051809381926311692f3760e31b83526020600484015260248301906130d8565b038173__$93083e246e55d56d98f3df2872cd16bfd0$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", isSuperArgs$5 = (C) => typeof C[0] == "string" || Array.isArray(C[0]) || "_isInterface" in C[0];
var Ii;
let NttManager__factory$2 = (Ii = class extends ContractFactory {
  constructor(...e) {
    if (isSuperArgs$5(e))
      super(...e);
    else {
      const [T, $] = e;
      super(_abi$5, Ii.linkBytecode(T), $);
    }
  }
  static linkBytecode(e) {
    let T = _bytecode$5;
    return T = T.replace(new RegExp("__\\$93083e246e55d56d98f3df2872cd16bfd0\\$__", "g"), e["src/libraries/TransceiverStructs.sol:TransceiverStructs"].replace(/^0x/, "").toLowerCase()), T;
  }
  getDeployTransaction(e, T, $, V, J, ee) {
    return super.getDeployTransaction(e, T, $, V, J, ee || {});
  }
  deploy(e, T, $, V, J, ee) {
    return super.deploy(e, T, $, V, J, ee || {});
  }
  connect(e) {
    return super.connect(e);
  }
  static createInterface() {
    return new Interface(_abi$5);
  }
  static connect(e, T) {
    return new Contract(e, _abi$5, T);
  }
}, tt(Ii, "bytecode", _bytecode$5), tt(Ii, "abi", _abi$5), Ii);
const _abi$4 = [
  {
    type: "constructor",
    inputs: [
      {
        name: "nttManager",
        type: "address",
        internalType: "address"
      },
      {
        name: "wormholeCoreBridge",
        type: "address",
        internalType: "address"
      },
      {
        name: "wormholeRelayerAddr",
        type: "address",
        internalType: "address"
      },
      {
        name: "specialRelayerAddr",
        type: "address",
        internalType: "address"
      },
      {
        name: "_consistencyLevel",
        type: "uint8",
        internalType: "uint8"
      },
      {
        name: "_gasLimit",
        type: "uint256",
        internalType: "uint256"
      }
    ],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    name: "WORMHOLE_TRANSCEIVER_VERSION",
    inputs: [],
    outputs: [
      {
        name: "",
        type: "string",
        internalType: "string"
      }
    ],
    stateMutability: "view"
  },
  {
    type: "function",
    name: "consistencyLevel",
    inputs: [],
    outputs: [
      {
        name: "",
        type: "uint8",
        internalType: "uint8"
      }
    ],
    stateMutability: "view"
  },
  {
    type: "function",
    name: "encodeWormholeTransceiverInstruction",
    inputs: [
      {
        name: "instruction",
        type: "tuple",
        internalType: "struct IWormholeTransceiver.WormholeTransceiverInstruction",
        components: [
          {
            name: "shouldSkipRelayerSend",
            type: "bool",
            internalType: "bool"
          }
        ]
      }
    ],
    outputs: [
      {
        name: "",
        type: "bytes",
        internalType: "bytes"
      }
    ],
    stateMutability: "pure"
  },
  {
    type: "function",
    name: "gasLimit",
    inputs: [],
    outputs: [
      {
        name: "",
        type: "uint256",
        internalType: "uint256"
      }
    ],
    stateMutability: "view"
  },
  {
    type: "function",
    name: "getMigratesImmutables",
    inputs: [],
    outputs: [
      {
        name: "",
        type: "bool",
        internalType: "bool"
      }
    ],
    stateMutability: "view"
  },
  {
    type: "function",
    name: "getNttManagerOwner",
    inputs: [],
    outputs: [
      {
        name: "",
        type: "address",
        internalType: "address"
      }
    ],
    stateMutability: "view"
  },
  {
    type: "function",
    name: "getNttManagerToken",
    inputs: [],
    outputs: [
      {
        name: "",
        type: "address",
        internalType: "address"
      }
    ],
    stateMutability: "view"
  },
  {
    type: "function",
    name: "getWormholePeer",
    inputs: [
      {
        name: "chainId",
        type: "uint16",
        internalType: "uint16"
      }
    ],
    outputs: [
      {
        name: "",
        type: "bytes32",
        internalType: "bytes32"
      }
    ],
    stateMutability: "view"
  },
  {
    type: "function",
    name: "initialize",
    inputs: [],
    outputs: [],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    name: "isPaused",
    inputs: [],
    outputs: [
      {
        name: "",
        type: "bool",
        internalType: "bool"
      }
    ],
    stateMutability: "view"
  },
  {
    type: "function",
    name: "isSpecialRelayingEnabled",
    inputs: [
      {
        name: "chainId",
        type: "uint16",
        internalType: "uint16"
      }
    ],
    outputs: [
      {
        name: "",
        type: "bool",
        internalType: "bool"
      }
    ],
    stateMutability: "view"
  },
  {
    type: "function",
    name: "isVAAConsumed",
    inputs: [
      {
        name: "hash",
        type: "bytes32",
        internalType: "bytes32"
      }
    ],
    outputs: [
      {
        name: "",
        type: "bool",
        internalType: "bool"
      }
    ],
    stateMutability: "view"
  },
  {
    type: "function",
    name: "isWormholeEvmChain",
    inputs: [
      {
        name: "chainId",
        type: "uint16",
        internalType: "uint16"
      }
    ],
    outputs: [
      {
        name: "",
        type: "bool",
        internalType: "bool"
      }
    ],
    stateMutability: "view"
  },
  {
    type: "function",
    name: "isWormholeRelayingEnabled",
    inputs: [
      {
        name: "chainId",
        type: "uint16",
        internalType: "uint16"
      }
    ],
    outputs: [
      {
        name: "",
        type: "bool",
        internalType: "bool"
      }
    ],
    stateMutability: "view"
  },
  {
    type: "function",
    name: "migrate",
    inputs: [],
    outputs: [],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    name: "nttManager",
    inputs: [],
    outputs: [
      {
        name: "",
        type: "address",
        internalType: "address"
      }
    ],
    stateMutability: "view"
  },
  {
    type: "function",
    name: "nttManagerToken",
    inputs: [],
    outputs: [
      {
        name: "",
        type: "address",
        internalType: "address"
      }
    ],
    stateMutability: "view"
  },
  {
    type: "function",
    name: "owner",
    inputs: [],
    outputs: [
      {
        name: "",
        type: "address",
        internalType: "address"
      }
    ],
    stateMutability: "view"
  },
  {
    type: "function",
    name: "parseWormholeTransceiverInstruction",
    inputs: [
      {
        name: "encoded",
        type: "bytes",
        internalType: "bytes"
      }
    ],
    outputs: [
      {
        name: "instruction",
        type: "tuple",
        internalType: "struct IWormholeTransceiver.WormholeTransceiverInstruction",
        components: [
          {
            name: "shouldSkipRelayerSend",
            type: "bool",
            internalType: "bool"
          }
        ]
      }
    ],
    stateMutability: "pure"
  },
  {
    type: "function",
    name: "pauser",
    inputs: [],
    outputs: [
      {
        name: "",
        type: "address",
        internalType: "address"
      }
    ],
    stateMutability: "view"
  },
  {
    type: "function",
    name: "quoteDeliveryPrice",
    inputs: [
      {
        name: "targetChain",
        type: "uint16",
        internalType: "uint16"
      },
      {
        name: "instruction",
        type: "tuple",
        internalType: "struct TransceiverStructs.TransceiverInstruction",
        components: [
          {
            name: "index",
            type: "uint8",
            internalType: "uint8"
          },
          {
            name: "payload",
            type: "bytes",
            internalType: "bytes"
          }
        ]
      }
    ],
    outputs: [
      {
        name: "",
        type: "uint256",
        internalType: "uint256"
      }
    ],
    stateMutability: "view"
  },
  {
    type: "function",
    name: "receiveMessage",
    inputs: [
      {
        name: "encodedMessage",
        type: "bytes",
        internalType: "bytes"
      }
    ],
    outputs: [],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    name: "receiveWormholeMessages",
    inputs: [
      {
        name: "payload",
        type: "bytes",
        internalType: "bytes"
      },
      {
        name: "additionalMessages",
        type: "bytes[]",
        internalType: "bytes[]"
      },
      {
        name: "sourceAddress",
        type: "bytes32",
        internalType: "bytes32"
      },
      {
        name: "sourceChain",
        type: "uint16",
        internalType: "uint16"
      },
      {
        name: "deliveryHash",
        type: "bytes32",
        internalType: "bytes32"
      }
    ],
    outputs: [],
    stateMutability: "payable"
  },
  {
    type: "function",
    name: "sendMessage",
    inputs: [
      {
        name: "recipientChain",
        type: "uint16",
        internalType: "uint16"
      },
      {
        name: "instruction",
        type: "tuple",
        internalType: "struct TransceiverStructs.TransceiverInstruction",
        components: [
          {
            name: "index",
            type: "uint8",
            internalType: "uint8"
          },
          {
            name: "payload",
            type: "bytes",
            internalType: "bytes"
          }
        ]
      },
      {
        name: "nttManagerMessage",
        type: "bytes",
        internalType: "bytes"
      },
      {
        name: "recipientNttManagerAddress",
        type: "bytes32",
        internalType: "bytes32"
      },
      {
        name: "refundAddress",
        type: "bytes32",
        internalType: "bytes32"
      }
    ],
    outputs: [],
    stateMutability: "payable"
  },
  {
    type: "function",
    name: "setIsSpecialRelayingEnabled",
    inputs: [
      {
        name: "chainId",
        type: "uint16",
        internalType: "uint16"
      },
      {
        name: "isEnabled",
        type: "bool",
        internalType: "bool"
      }
    ],
    outputs: [],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    name: "setIsWormholeEvmChain",
    inputs: [
      {
        name: "chainId",
        type: "uint16",
        internalType: "uint16"
      },
      {
        name: "isEvm",
        type: "bool",
        internalType: "bool"
      }
    ],
    outputs: [],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    name: "setIsWormholeRelayingEnabled",
    inputs: [
      {
        name: "chainId",
        type: "uint16",
        internalType: "uint16"
      },
      {
        name: "isEnabled",
        type: "bool",
        internalType: "bool"
      }
    ],
    outputs: [],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    name: "setWormholePeer",
    inputs: [
      {
        name: "peerChainId",
        type: "uint16",
        internalType: "uint16"
      },
      {
        name: "peerContract",
        type: "bytes32",
        internalType: "bytes32"
      }
    ],
    outputs: [],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    name: "specialRelayer",
    inputs: [],
    outputs: [
      {
        name: "",
        type: "address",
        internalType: "contract ISpecialRelayer"
      }
    ],
    stateMutability: "view"
  },
  {
    type: "function",
    name: "transferOwnership",
    inputs: [
      {
        name: "newOwner",
        type: "address",
        internalType: "address"
      }
    ],
    outputs: [],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    name: "transferPauserCapability",
    inputs: [
      {
        name: "newPauser",
        type: "address",
        internalType: "address"
      }
    ],
    outputs: [],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    name: "transferTransceiverOwnership",
    inputs: [
      {
        name: "newOwner",
        type: "address",
        internalType: "address"
      }
    ],
    outputs: [],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    name: "upgrade",
    inputs: [
      {
        name: "newImplementation",
        type: "address",
        internalType: "address"
      }
    ],
    outputs: [],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    name: "wormhole",
    inputs: [],
    outputs: [
      {
        name: "",
        type: "address",
        internalType: "contract IWormhole"
      }
    ],
    stateMutability: "view"
  },
  {
    type: "function",
    name: "wormholeRelayer",
    inputs: [],
    outputs: [
      {
        name: "",
        type: "address",
        internalType: "contract IWormholeRelayer"
      }
    ],
    stateMutability: "view"
  },
  {
    type: "event",
    name: "AdminChanged",
    inputs: [
      {
        name: "previousAdmin",
        type: "address",
        indexed: !1,
        internalType: "address"
      },
      {
        name: "newAdmin",
        type: "address",
        indexed: !1,
        internalType: "address"
      }
    ],
    anonymous: !1
  },
  {
    type: "event",
    name: "BeaconUpgraded",
    inputs: [
      {
        name: "beacon",
        type: "address",
        indexed: !0,
        internalType: "address"
      }
    ],
    anonymous: !1
  },
  {
    type: "event",
    name: "Initialized",
    inputs: [
      {
        name: "version",
        type: "uint64",
        indexed: !1,
        internalType: "uint64"
      }
    ],
    anonymous: !1
  },
  {
    type: "event",
    name: "NotPaused",
    inputs: [
      {
        name: "notPaused",
        type: "bool",
        indexed: !1,
        internalType: "bool"
      }
    ],
    anonymous: !1
  },
  {
    type: "event",
    name: "OwnershipTransferred",
    inputs: [
      {
        name: "previousOwner",
        type: "address",
        indexed: !0,
        internalType: "address"
      },
      {
        name: "newOwner",
        type: "address",
        indexed: !0,
        internalType: "address"
      }
    ],
    anonymous: !1
  },
  {
    type: "event",
    name: "Paused",
    inputs: [
      {
        name: "paused",
        type: "bool",
        indexed: !1,
        internalType: "bool"
      }
    ],
    anonymous: !1
  },
  {
    type: "event",
    name: "PauserTransferred",
    inputs: [
      {
        name: "oldPauser",
        type: "address",
        indexed: !0,
        internalType: "address"
      },
      {
        name: "newPauser",
        type: "address",
        indexed: !0,
        internalType: "address"
      }
    ],
    anonymous: !1
  },
  {
    type: "event",
    name: "ReceivedMessage",
    inputs: [
      {
        name: "digest",
        type: "bytes32",
        indexed: !1,
        internalType: "bytes32"
      },
      {
        name: "emitterChainId",
        type: "uint16",
        indexed: !1,
        internalType: "uint16"
      },
      {
        name: "emitterAddress",
        type: "bytes32",
        indexed: !1,
        internalType: "bytes32"
      },
      {
        name: "sequence",
        type: "uint64",
        indexed: !1,
        internalType: "uint64"
      }
    ],
    anonymous: !1
  },
  {
    type: "event",
    name: "ReceivedRelayedMessage",
    inputs: [
      {
        name: "digest",
        type: "bytes32",
        indexed: !1,
        internalType: "bytes32"
      },
      {
        name: "emitterChainId",
        type: "uint16",
        indexed: !1,
        internalType: "uint16"
      },
      {
        name: "emitterAddress",
        type: "bytes32",
        indexed: !1,
        internalType: "bytes32"
      }
    ],
    anonymous: !1
  },
  {
    type: "event",
    name: "RelayingInfo",
    inputs: [
      {
        name: "relayingType",
        type: "uint8",
        indexed: !1,
        internalType: "uint8"
      },
      {
        name: "refundAddress",
        type: "bytes32",
        indexed: !1,
        internalType: "bytes32"
      },
      {
        name: "deliveryPayment",
        type: "uint256",
        indexed: !1,
        internalType: "uint256"
      }
    ],
    anonymous: !1
  },
  {
    type: "event",
    name: "SendTransceiverMessage",
    inputs: [
      {
        name: "recipientChain",
        type: "uint16",
        indexed: !1,
        internalType: "uint16"
      },
      {
        name: "message",
        type: "tuple",
        indexed: !1,
        internalType: "struct TransceiverStructs.TransceiverMessage",
        components: [
          {
            name: "sourceNttManagerAddress",
            type: "bytes32",
            internalType: "bytes32"
          },
          {
            name: "recipientNttManagerAddress",
            type: "bytes32",
            internalType: "bytes32"
          },
          {
            name: "nttManagerPayload",
            type: "bytes",
            internalType: "bytes"
          },
          {
            name: "transceiverPayload",
            type: "bytes",
            internalType: "bytes"
          }
        ]
      }
    ],
    anonymous: !1
  },
  {
    type: "event",
    name: "SetIsSpecialRelayingEnabled",
    inputs: [
      {
        name: "chainId",
        type: "uint16",
        indexed: !1,
        internalType: "uint16"
      },
      {
        name: "isRelayingEnabled",
        type: "bool",
        indexed: !1,
        internalType: "bool"
      }
    ],
    anonymous: !1
  },
  {
    type: "event",
    name: "SetIsWormholeEvmChain",
    inputs: [
      {
        name: "chainId",
        type: "uint16",
        indexed: !1,
        internalType: "uint16"
      },
      {
        name: "isEvm",
        type: "bool",
        indexed: !1,
        internalType: "bool"
      }
    ],
    anonymous: !1
  },
  {
    type: "event",
    name: "SetIsWormholeRelayingEnabled",
    inputs: [
      {
        name: "chainId",
        type: "uint16",
        indexed: !1,
        internalType: "uint16"
      },
      {
        name: "isRelayingEnabled",
        type: "bool",
        indexed: !1,
        internalType: "bool"
      }
    ],
    anonymous: !1
  },
  {
    type: "event",
    name: "SetWormholePeer",
    inputs: [
      {
        name: "chainId",
        type: "uint16",
        indexed: !1,
        internalType: "uint16"
      },
      {
        name: "peerContract",
        type: "bytes32",
        indexed: !1,
        internalType: "bytes32"
      }
    ],
    anonymous: !1
  },
  {
    type: "event",
    name: "Upgraded",
    inputs: [
      {
        name: "implementation",
        type: "address",
        indexed: !0,
        internalType: "address"
      }
    ],
    anonymous: !1
  },
  {
    type: "error",
    name: "CallerNotNttManager",
    inputs: [
      {
        name: "caller",
        type: "address",
        internalType: "address"
      }
    ]
  },
  {
    type: "error",
    name: "CallerNotRelayer",
    inputs: [
      {
        name: "caller",
        type: "address",
        internalType: "address"
      }
    ]
  },
  {
    type: "error",
    name: "CannotRenounceTransceiverOwnership",
    inputs: [
      {
        name: "currentOwner",
        type: "address",
        internalType: "address"
      }
    ]
  },
  {
    type: "error",
    name: "CannotTransferTransceiverOwnership",
    inputs: [
      {
        name: "currentOwner",
        type: "address",
        internalType: "address"
      },
      {
        name: "newOwner",
        type: "address",
        internalType: "address"
      }
    ]
  },
  {
    type: "error",
    name: "InvalidBoolVal",
    inputs: [
      {
        name: "val",
        type: "uint8",
        internalType: "uint8"
      }
    ]
  },
  {
    type: "error",
    name: "InvalidBoolValue",
    inputs: [
      {
        name: "value",
        type: "uint256",
        internalType: "BooleanFlag"
      }
    ]
  },
  {
    type: "error",
    name: "InvalidFork",
    inputs: [
      {
        name: "evmChainId",
        type: "uint256",
        internalType: "uint256"
      },
      {
        name: "blockChainId",
        type: "uint256",
        internalType: "uint256"
      }
    ]
  },
  {
    type: "error",
    name: "InvalidInitialization",
    inputs: []
  },
  {
    type: "error",
    name: "InvalidPauser",
    inputs: [
      {
        name: "account",
        type: "address",
        internalType: "address"
      }
    ]
  },
  {
    type: "error",
    name: "InvalidRelayingConfig",
    inputs: [
      {
        name: "chainId",
        type: "uint16",
        internalType: "uint16"
      }
    ]
  },
  {
    type: "error",
    name: "InvalidVaa",
    inputs: [
      {
        name: "reason",
        type: "string",
        internalType: "string"
      }
    ]
  },
  {
    type: "error",
    name: "InvalidWormholeChainIdZero",
    inputs: []
  },
  {
    type: "error",
    name: "InvalidWormholePeer",
    inputs: [
      {
        name: "chainId",
        type: "uint16",
        internalType: "uint16"
      },
      {
        name: "peerAddress",
        type: "bytes32",
        internalType: "bytes32"
      }
    ]
  },
  {
    type: "error",
    name: "InvalidWormholePeerZeroAddress",
    inputs: []
  },
  {
    type: "error",
    name: "LengthMismatch",
    inputs: [
      {
        name: "encodedLength",
        type: "uint256",
        internalType: "uint256"
      },
      {
        name: "expectedLength",
        type: "uint256",
        internalType: "uint256"
      }
    ]
  },
  {
    type: "error",
    name: "NotAnEvmAddress",
    inputs: [
      {
        name: "",
        type: "bytes32",
        internalType: "bytes32"
      }
    ]
  },
  {
    type: "error",
    name: "NotInitializing",
    inputs: []
  },
  {
    type: "error",
    name: "NotMigrating",
    inputs: []
  },
  {
    type: "error",
    name: "OnlyDelegateCall",
    inputs: []
  },
  {
    type: "error",
    name: "OwnableInvalidOwner",
    inputs: [
      {
        name: "owner",
        type: "address",
        internalType: "address"
      }
    ]
  },
  {
    type: "error",
    name: "OwnableUnauthorizedAccount",
    inputs: [
      {
        name: "account",
        type: "address",
        internalType: "address"
      }
    ]
  },
  {
    type: "error",
    name: "PeerAlreadySet",
    inputs: [
      {
        name: "chainId",
        type: "uint16",
        internalType: "uint16"
      },
      {
        name: "peerAddress",
        type: "bytes32",
        internalType: "bytes32"
      }
    ]
  },
  {
    type: "error",
    name: "ReentrancyGuardReentrantCall",
    inputs: []
  },
  {
    type: "error",
    name: "RequireContractIsNotPaused",
    inputs: []
  },
  {
    type: "error",
    name: "RequireContractIsPaused",
    inputs: []
  },
  {
    type: "error",
    name: "TransferAlreadyCompleted",
    inputs: [
      {
        name: "vaaHash",
        type: "bytes32",
        internalType: "bytes32"
      }
    ]
  },
  {
    type: "error",
    name: "UnexpectedAdditionalMessages",
    inputs: []
  },
  {
    type: "error",
    name: "UnexpectedDeployer",
    inputs: [
      {
        name: "deployer",
        type: "address",
        internalType: "address"
      },
      {
        name: "caller",
        type: "address",
        internalType: "address"
      }
    ]
  },
  {
    type: "error",
    name: "UnexpectedRecipientNttManagerAddress",
    inputs: [
      {
        name: "recipientNttManagerAddress",
        type: "bytes32",
        internalType: "bytes32"
      },
      {
        name: "expectedRecipientNttManagerAddress",
        type: "bytes32",
        internalType: "bytes32"
      }
    ]
  }
], _bytecode$4 = "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__$93083e246e55d56d98f3df2872cd16bfd0$__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__$93083e246e55d56d98f3df2872cd16bfd0$__5af49081156110045791610f27939187938a91610fe2575b508987518096819582946358cd21bf60e11b84527f0000000000000000000000000000000000000000000000000000000000000000918401612fb5565b03927f0000000000000000000000000000000000000000000000000000000000000000165af18015610fd857610fa0575b50610f61578380f35b7fc7f505b2f371ae2175ee4913f4499e1f2633a7b5936321eed1cdaeb6115181d29268ff00000000000000001981541690555160018152a13880808380f35b8381813d8311610fd1575b610fb58183612718565b81010312610fcd57610fc690612fa1565b5038610f58565b8580fd5b503d610fab565b83513d88823e3d90fd5b610ffe91503d808c833e610ff68183612718565b810190613035565b38610eea565b85513d8a823e3d90fd5b9092508881813d831161103e575b6110268183612718565b810103126106575761103790613009565b9138610e1b565b503d61101c565b88513d8d823e3d90fd5b9091508781813d831161107f575b6110678183612718565b810103126105f85761107890613009565b9038610df8565b503d61105d565b87513d8c823e3d90fd5b82604491865191636345072160e11b8352820152336024820152fd5b68ffffffffffffffffff19166801000000000000000117855538610cbf565b50825163f92ee8a960e01b8152fd5b90501538610ca3565b303b159150610c9b565b849150610c91565b50913461067e57602036600319011261067e575061070b6020923560005260008051602061329183398151915260205260ff6040600020541690565b503461068557816003193601126106855761114a612672565b602435916111566131c1565b61ffff80831690811561138157841561137157816000526000805160206132718339815191529160209280845287600020548061134857508160005283528587600020558651916111a6836126c7565b630c7e33e160e11b8352838301918252878301878152885163077650fb60e51b815293516001600160e01b031916868501529151166024830152516044820152868160648173__$93083e246e55d56d98f3df2872cd16bfd0$__5af492831561133e576112519383928991611324575b5087516358cd21bf60e11b815294859283927f0000000000000000000000000000000000000000000000000000000000000000918401612fb5565b0381897f00000000000000000000000000000000000000000000000000000000000000006001600160a01b03165af18015610674576112c8575b5050915161ffff909216825260208201527fa559263ee060c7a2560843b3a064ff0376c9753ae3e2449b595a3b615d3264669080604081016109b3565b81813d831161131d575b6112dc8183612718565b81010312611319577fa559263ee060c7a2560843b3a064ff0376c9753ae3e2449b595a3b615d326466936113126109b392612fa1565b509361128b565b8480fd5b503d6112d2565b61133891503d808b833e610ff68183612718565b38611216565b86513d89823e3d90fd5b885163b55eeae960e01b815261ffff881681880190815260208101929092529081906040010390fd5b855163137063ef60e11b81528390fd5b8551630f7662c960e21b81528390fd5b61262d565b5050346106c457816003193601126106c45760209060ff7f5443fea4dc453d96b81ce55b62e11a4094cc4cbb8a360956a7253cfdb42506cb541690519015158152f35b50913461067e57602036600319011261067e57508051916113f9836126ac565b35908115159182810361143557610c32935280519160f81b602083015260018252611423826126fd565b5191829160208352602083019061283d565b600080fd5b508290346106c457826003193601126106c457611455612672565b61145d6127f4565b916114666131c1565b61ffff82169081156109b957507f528b18a533e892b5401d1fb63597275df9d2bb45b13e7695c3147cd07b9746c393946109b3916114a3856130df565b906000526000805160206132d18339815191526020528160002055519283928390929160209061ffff60408401951683521515910152565b5034610685576020366003190112610685578035916001600160a01b038084168403611319577f000000000000000000000000000000000000000000000000000000000000000016330361153357836103b3846131fa565b60249250519063c5aa615360e01b82523390820152fd5b5060a0366003190112610685576001600160401b038135818111611319576115759036908401612754565b602492833593838511611750573660238601121561175057848201359361159b85612803565b946115a888519687612718565b808652602096838888019260051b8201019236841161065757848201925b84841061172a5750505050506044356064359461ffff86169081870361143557608435937f00000000000000000000000000000000000000000000000000000000000000006001600160a01b0316330361171757826000526000805160206132718339815191528952838a60002054036116f057848b52600080516020613291833981519152895260ff8a8c2054166116dc5750611685846000526000805160206132918339815191526020526040600020600160ff19825416179055565b516116cc57606061037995938a95937ff557dbbb087662f52c815f6c7ee350628a37a51eae9608ff840d996b65f87475938b519283528a8301528a820152a16103576128f9565b875163c504ea2960e01b81528490fd5b8951632d30ec0360e21b8152808701869052fd5b8951633cd8e72b60e11b815261ffff89168188019081526020810186905281906040010390fd5b8951631c26958960e01b81523381880152fd5b833582811161064f578a916117458392893691880101612754565b8152019301926115c6565b8680fd5b508290346106c457826003193601126106c45761176f612672565b6117776127f4565b916117806131c1565b61ffff82169081156109b957507f0fe301480713b2c2072ee91b3bcfcbf2c0014f0447c89046f020f0f80727003c93946109b3916117bd856130df565b906000526000805160206132518339815191526020528160002055519283928390929160209061ffff60408401951683521515910152565b509060031960a0368201126106815761180c612672565b9060249283356001600160401b03908181116106705761182f903690880161279b565b906044358181116105f4576118479036908901612754565b90608435977f9b779b17422d0df92223018b32b4d1fa46e071723d6817e2486d003becc55f00976002895414611f5e57600289556001600160a01b03937f000000000000000000000000000000000000000000000000000000000000000085163303611f4857908b61190181936119108a519b6118c38d6126ac565b848d528b516304616c8f60e21b81526309945ff160e41b89820152338782015260648035604483015260a0908201529c8d94859460a486019061283d565b9184830301608485015261283d565b038173__$93083e246e55d56d98f3df2872cd16bfd0$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", isSuperArgs$4 = (C) => typeof C[0] == "string" || Array.isArray(C[0]) || "_isInterface" in C[0];
var ki;
let WormholeTransceiver__factory$2 = (ki = class extends ContractFactory {
  constructor(...e) {
    if (isSuperArgs$4(e))
      super(...e);
    else {
      const [T, $] = e;
      super(_abi$4, ki.linkBytecode(T), $);
    }
  }
  static linkBytecode(e) {
    let T = _bytecode$4;
    return T = T.replace(new RegExp("__\\$93083e246e55d56d98f3df2872cd16bfd0\\$__", "g"), e["src/libraries/TransceiverStructs.sol:TransceiverStructs"].replace(/^0x/, "").toLowerCase()), T;
  }
  getDeployTransaction(e, T, $, V, J, ee, te) {
    return super.getDeployTransaction(e, T, $, V, J, ee, te || {});
  }
  deploy(e, T, $, V, J, ee, te) {
    return super.deploy(e, T, $, V, J, ee, te || {});
  }
  connect(e) {
    return super.connect(e);
  }
  static createInterface() {
    return new Interface(_abi$4);
  }
  static connect(e, T) {
    return new Contract(e, _abi$4, T);
  }
}, tt(ki, "bytecode", _bytecode$4), tt(ki, "abi", _abi$4), ki);
const _abi$3 = [
  {
    type: "constructor",
    inputs: [
      {
        name: "_token",
        type: "address",
        internalType: "address"
      },
      {
        name: "_mode",
        type: "uint8",
        internalType: "enum IManagerBase.Mode"
      },
      {
        name: "_chainId",
        type: "uint16",
        internalType: "uint16"
      },
      {
        name: "_rateLimitDuration",
        type: "uint64",
        internalType: "uint64"
      },
      {
        name: "_skipRateLimiting",
        type: "bool",
        internalType: "bool"
      }
    ],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    name: "NTT_MANAGER_VERSION",
    inputs: [],
    outputs: [
      {
        name: "",
        type: "string",
        internalType: "string"
      }
    ],
    stateMutability: "view"
  },
  {
    type: "function",
    name: "attestationReceived",
    inputs: [
      {
        name: "sourceChainId",
        type: "uint16",
        internalType: "uint16"
      },
      {
        name: "sourceNttManagerAddress",
        type: "bytes32",
        internalType: "bytes32"
      },
      {
        name: "payload",
        type: "tuple",
        internalType: "struct TransceiverStructs.NttManagerMessage",
        components: [
          {
            name: "id",
            type: "bytes32",
            internalType: "bytes32"
          },
          {
            name: "sender",
            type: "bytes32",
            internalType: "bytes32"
          },
          {
            name: "payload",
            type: "bytes",
            internalType: "bytes"
          }
        ]
      }
    ],
    outputs: [],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    name: "cancelOutboundQueuedTransfer",
    inputs: [
      {
        name: "messageSequence",
        type: "uint64",
        internalType: "uint64"
      }
    ],
    outputs: [],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    name: "chainId",
    inputs: [],
    outputs: [
      {
        name: "",
        type: "uint16",
        internalType: "uint16"
      }
    ],
    stateMutability: "view"
  },
  {
    type: "function",
    name: "completeInboundQueuedTransfer",
    inputs: [
      {
        name: "digest",
        type: "bytes32",
        internalType: "bytes32"
      }
    ],
    outputs: [],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    name: "completeOutboundQueuedTransfer",
    inputs: [
      {
        name: "messageSequence",
        type: "uint64",
        internalType: "uint64"
      }
    ],
    outputs: [
      {
        name: "",
        type: "uint64",
        internalType: "uint64"
      }
    ],
    stateMutability: "payable"
  },
  {
    type: "function",
    name: "executeMsg",
    inputs: [
      {
        name: "sourceChainId",
        type: "uint16",
        internalType: "uint16"
      },
      {
        name: "sourceNttManagerAddress",
        type: "bytes32",
        internalType: "bytes32"
      },
      {
        name: "message",
        type: "tuple",
        internalType: "struct TransceiverStructs.NttManagerMessage",
        components: [
          {
            name: "id",
            type: "bytes32",
            internalType: "bytes32"
          },
          {
            name: "sender",
            type: "bytes32",
            internalType: "bytes32"
          },
          {
            name: "payload",
            type: "bytes",
            internalType: "bytes"
          }
        ]
      }
    ],
    outputs: [],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    name: "getCurrentInboundCapacity",
    inputs: [
      {
        name: "chainId_",
        type: "uint16",
        internalType: "uint16"
      }
    ],
    outputs: [
      {
        name: "",
        type: "uint256",
        internalType: "uint256"
      }
    ],
    stateMutability: "view"
  },
  {
    type: "function",
    name: "getCurrentOutboundCapacity",
    inputs: [],
    outputs: [
      {
        name: "",
        type: "uint256",
        internalType: "uint256"
      }
    ],
    stateMutability: "view"
  },
  {
    type: "function",
    name: "getInboundLimitParams",
    inputs: [
      {
        name: "chainId_",
        type: "uint16",
        internalType: "uint16"
      }
    ],
    outputs: [
      {
        name: "",
        type: "tuple",
        internalType: "struct IRateLimiter.RateLimitParams",
        components: [
          {
            name: "limit",
            type: "uint72",
            internalType: "TrimmedAmount"
          },
          {
            name: "currentCapacity",
            type: "uint72",
            internalType: "TrimmedAmount"
          },
          {
            name: "lastTxTimestamp",
            type: "uint64",
            internalType: "uint64"
          }
        ]
      }
    ],
    stateMutability: "view"
  },
  {
    type: "function",
    name: "getInboundQueuedTransfer",
    inputs: [
      {
        name: "digest",
        type: "bytes32",
        internalType: "bytes32"
      }
    ],
    outputs: [
      {
        name: "",
        type: "tuple",
        internalType: "struct IRateLimiter.InboundQueuedTransfer",
        components: [
          {
            name: "amount",
            type: "uint72",
            internalType: "TrimmedAmount"
          },
          {
            name: "txTimestamp",
            type: "uint64",
            internalType: "uint64"
          },
          {
            name: "recipient",
            type: "address",
            internalType: "address"
          }
        ]
      }
    ],
    stateMutability: "view"
  },
  {
    type: "function",
    name: "getMigratesImmutables",
    inputs: [],
    outputs: [
      {
        name: "",
        type: "bool",
        internalType: "bool"
      }
    ],
    stateMutability: "view"
  },
  {
    type: "function",
    name: "getMode",
    inputs: [],
    outputs: [
      {
        name: "",
        type: "uint8",
        internalType: "uint8"
      }
    ],
    stateMutability: "view"
  },
  {
    type: "function",
    name: "getOutboundLimitParams",
    inputs: [],
    outputs: [
      {
        name: "",
        type: "tuple",
        internalType: "struct IRateLimiter.RateLimitParams",
        components: [
          {
            name: "limit",
            type: "uint72",
            internalType: "TrimmedAmount"
          },
          {
            name: "currentCapacity",
            type: "uint72",
            internalType: "TrimmedAmount"
          },
          {
            name: "lastTxTimestamp",
            type: "uint64",
            internalType: "uint64"
          }
        ]
      }
    ],
    stateMutability: "pure"
  },
  {
    type: "function",
    name: "getOutboundQueuedTransfer",
    inputs: [
      {
        name: "queueSequence",
        type: "uint64",
        internalType: "uint64"
      }
    ],
    outputs: [
      {
        name: "",
        type: "tuple",
        internalType: "struct IRateLimiter.OutboundQueuedTransfer",
        components: [
          {
            name: "recipient",
            type: "bytes32",
            internalType: "bytes32"
          },
          {
            name: "refundAddress",
            type: "bytes32",
            internalType: "bytes32"
          },
          {
            name: "amount",
            type: "uint72",
            internalType: "TrimmedAmount"
          },
          {
            name: "txTimestamp",
            type: "uint64",
            internalType: "uint64"
          },
          {
            name: "recipientChain",
            type: "uint16",
            internalType: "uint16"
          },
          {
            name: "sender",
            type: "address",
            internalType: "address"
          },
          {
            name: "transceiverInstructions",
            type: "bytes",
            internalType: "bytes"
          }
        ]
      }
    ],
    stateMutability: "view"
  },
  {
    type: "function",
    name: "getPeer",
    inputs: [
      {
        name: "chainId_",
        type: "uint16",
        internalType: "uint16"
      }
    ],
    outputs: [
      {
        name: "",
        type: "tuple",
        internalType: "struct INttManager.NttManagerPeer",
        components: [
          {
            name: "peerAddress",
            type: "bytes32",
            internalType: "bytes32"
          },
          {
            name: "tokenDecimals",
            type: "uint8",
            internalType: "uint8"
          }
        ]
      }
    ],
    stateMutability: "view"
  },
  {
    type: "function",
    name: "getThreshold",
    inputs: [],
    outputs: [
      {
        name: "",
        type: "uint8",
        internalType: "uint8"
      }
    ],
    stateMutability: "view"
  },
  {
    type: "function",
    name: "getTransceiverInfo",
    inputs: [],
    outputs: [
      {
        name: "",
        type: "tuple[]",
        internalType: "struct TransceiverRegistry.TransceiverInfo[]",
        components: [
          {
            name: "registered",
            type: "bool",
            internalType: "bool"
          },
          {
            name: "enabled",
            type: "bool",
            internalType: "bool"
          },
          {
            name: "index",
            type: "uint8",
            internalType: "uint8"
          }
        ]
      }
    ],
    stateMutability: "view"
  },
  {
    type: "function",
    name: "getTransceivers",
    inputs: [],
    outputs: [
      {
        name: "result",
        type: "address[]",
        internalType: "address[]"
      }
    ],
    stateMutability: "pure"
  },
  {
    type: "function",
    name: "initialize",
    inputs: [],
    outputs: [],
    stateMutability: "payable"
  },
  {
    type: "function",
    name: "isMessageApproved",
    inputs: [
      {
        name: "digest",
        type: "bytes32",
        internalType: "bytes32"
      }
    ],
    outputs: [
      {
        name: "",
        type: "bool",
        internalType: "bool"
      }
    ],
    stateMutability: "view"
  },
  {
    type: "function",
    name: "isMessageExecuted",
    inputs: [
      {
        name: "digest",
        type: "bytes32",
        internalType: "bytes32"
      }
    ],
    outputs: [
      {
        name: "",
        type: "bool",
        internalType: "bool"
      }
    ],
    stateMutability: "view"
  },
  {
    type: "function",
    name: "isPaused",
    inputs: [],
    outputs: [
      {
        name: "",
        type: "bool",
        internalType: "bool"
      }
    ],
    stateMutability: "view"
  },
  {
    type: "function",
    name: "messageAttestations",
    inputs: [
      {
        name: "digest",
        type: "bytes32",
        internalType: "bytes32"
      }
    ],
    outputs: [
      {
        name: "count",
        type: "uint8",
        internalType: "uint8"
      }
    ],
    stateMutability: "view"
  },
  {
    type: "function",
    name: "migrate",
    inputs: [],
    outputs: [],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    name: "mode",
    inputs: [],
    outputs: [
      {
        name: "",
        type: "uint8",
        internalType: "enum IManagerBase.Mode"
      }
    ],
    stateMutability: "view"
  },
  {
    type: "function",
    name: "nextMessageSequence",
    inputs: [],
    outputs: [
      {
        name: "",
        type: "uint64",
        internalType: "uint64"
      }
    ],
    stateMutability: "view"
  },
  {
    type: "function",
    name: "owner",
    inputs: [],
    outputs: [
      {
        name: "",
        type: "address",
        internalType: "address"
      }
    ],
    stateMutability: "view"
  },
  {
    type: "function",
    name: "pause",
    inputs: [],
    outputs: [],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    name: "pauser",
    inputs: [],
    outputs: [
      {
        name: "",
        type: "address",
        internalType: "address"
      }
    ],
    stateMutability: "view"
  },
  {
    type: "function",
    name: "quoteDeliveryPrice",
    inputs: [
      {
        name: "recipientChain",
        type: "uint16",
        internalType: "uint16"
      },
      {
        name: "transceiverInstructions",
        type: "bytes",
        internalType: "bytes"
      }
    ],
    outputs: [
      {
        name: "",
        type: "uint256[]",
        internalType: "uint256[]"
      },
      {
        name: "",
        type: "uint256",
        internalType: "uint256"
      }
    ],
    stateMutability: "view"
  },
  {
    type: "function",
    name: "rateLimitDuration",
    inputs: [],
    outputs: [
      {
        name: "",
        type: "uint64",
        internalType: "uint64"
      }
    ],
    stateMutability: "view"
  },
  {
    type: "function",
    name: "removeTransceiver",
    inputs: [
      {
        name: "transceiver",
        type: "address",
        internalType: "address"
      }
    ],
    outputs: [],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    name: "setInboundLimit",
    inputs: [
      {
        name: "limit",
        type: "uint256",
        internalType: "uint256"
      },
      {
        name: "chainId_",
        type: "uint16",
        internalType: "uint16"
      }
    ],
    outputs: [],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    name: "setOutboundLimit",
    inputs: [
      {
        name: "limit",
        type: "uint256",
        internalType: "uint256"
      }
    ],
    outputs: [],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    name: "setPeer",
    inputs: [
      {
        name: "peerChainId",
        type: "uint16",
        internalType: "uint16"
      },
      {
        name: "peerContract",
        type: "bytes32",
        internalType: "bytes32"
      },
      {
        name: "decimals",
        type: "uint8",
        internalType: "uint8"
      },
      {
        name: "inboundLimit",
        type: "uint256",
        internalType: "uint256"
      }
    ],
    outputs: [],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    name: "setThreshold",
    inputs: [
      {
        name: "threshold",
        type: "uint8",
        internalType: "uint8"
      }
    ],
    outputs: [],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    name: "setTransceiver",
    inputs: [
      {
        name: "transceiver",
        type: "address",
        internalType: "address"
      }
    ],
    outputs: [],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    name: "token",
    inputs: [],
    outputs: [
      {
        name: "",
        type: "address",
        internalType: "address"
      }
    ],
    stateMutability: "view"
  },
  {
    type: "function",
    name: "tokenDecimals",
    inputs: [],
    outputs: [
      {
        name: "",
        type: "uint8",
        internalType: "uint8"
      }
    ],
    stateMutability: "view"
  },
  {
    type: "function",
    name: "transceiverAttestedToMessage",
    inputs: [
      {
        name: "digest",
        type: "bytes32",
        internalType: "bytes32"
      },
      {
        name: "index",
        type: "uint8",
        internalType: "uint8"
      }
    ],
    outputs: [
      {
        name: "",
        type: "bool",
        internalType: "bool"
      }
    ],
    stateMutability: "view"
  },
  {
    type: "function",
    name: "transfer",
    inputs: [
      {
        name: "amount",
        type: "uint256",
        internalType: "uint256"
      },
      {
        name: "recipientChain",
        type: "uint16",
        internalType: "uint16"
      },
      {
        name: "recipient",
        type: "bytes32",
        internalType: "bytes32"
      }
    ],
    outputs: [
      {
        name: "",
        type: "uint64",
        internalType: "uint64"
      }
    ],
    stateMutability: "payable"
  },
  {
    type: "function",
    name: "transfer",
    inputs: [
      {
        name: "amount",
        type: "uint256",
        internalType: "uint256"
      },
      {
        name: "recipientChain",
        type: "uint16",
        internalType: "uint16"
      },
      {
        name: "recipient",
        type: "bytes32",
        internalType: "bytes32"
      },
      {
        name: "refundAddress",
        type: "bytes32",
        internalType: "bytes32"
      },
      {
        name: "shouldQueue",
        type: "bool",
        internalType: "bool"
      },
      {
        name: "transceiverInstructions",
        type: "bytes",
        internalType: "bytes"
      }
    ],
    outputs: [
      {
        name: "",
        type: "uint64",
        internalType: "uint64"
      }
    ],
    stateMutability: "payable"
  },
  {
    type: "function",
    name: "transferOwnership",
    inputs: [
      {
        name: "newOwner",
        type: "address",
        internalType: "address"
      }
    ],
    outputs: [],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    name: "transferPauserCapability",
    inputs: [
      {
        name: "newPauser",
        type: "address",
        internalType: "address"
      }
    ],
    outputs: [],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    name: "unpause",
    inputs: [],
    outputs: [],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    name: "upgrade",
    inputs: [
      {
        name: "newImplementation",
        type: "address",
        internalType: "address"
      }
    ],
    outputs: [],
    stateMutability: "nonpayable"
  },
  {
    type: "event",
    name: "AdminChanged",
    inputs: [
      {
        name: "previousAdmin",
        type: "address",
        indexed: !1,
        internalType: "address"
      },
      {
        name: "newAdmin",
        type: "address",
        indexed: !1,
        internalType: "address"
      }
    ],
    anonymous: !1
  },
  {
    type: "event",
    name: "BeaconUpgraded",
    inputs: [
      {
        name: "beacon",
        type: "address",
        indexed: !0,
        internalType: "address"
      }
    ],
    anonymous: !1
  },
  {
    type: "event",
    name: "InboundTransferQueued",
    inputs: [
      {
        name: "digest",
        type: "bytes32",
        indexed: !1,
        internalType: "bytes32"
      }
    ],
    anonymous: !1
  },
  {
    type: "event",
    name: "Initialized",
    inputs: [
      {
        name: "version",
        type: "uint64",
        indexed: !1,
        internalType: "uint64"
      }
    ],
    anonymous: !1
  },
  {
    type: "event",
    name: "MessageAlreadyExecuted",
    inputs: [
      {
        name: "sourceNttManager",
        type: "bytes32",
        indexed: !0,
        internalType: "bytes32"
      },
      {
        name: "msgHash",
        type: "bytes32",
        indexed: !0,
        internalType: "bytes32"
      }
    ],
    anonymous: !1
  },
  {
    type: "event",
    name: "MessageAttestedTo",
    inputs: [
      {
        name: "digest",
        type: "bytes32",
        indexed: !1,
        internalType: "bytes32"
      },
      {
        name: "transceiver",
        type: "address",
        indexed: !1,
        internalType: "address"
      },
      {
        name: "index",
        type: "uint8",
        indexed: !1,
        internalType: "uint8"
      }
    ],
    anonymous: !1
  },
  {
    type: "event",
    name: "NotPaused",
    inputs: [
      {
        name: "notPaused",
        type: "bool",
        indexed: !1,
        internalType: "bool"
      }
    ],
    anonymous: !1
  },
  {
    type: "event",
    name: "OutboundTransferCancelled",
    inputs: [
      {
        name: "sequence",
        type: "uint256",
        indexed: !1,
        internalType: "uint256"
      },
      {
        name: "recipient",
        type: "address",
        indexed: !1,
        internalType: "address"
      },
      {
        name: "amount",
        type: "uint256",
        indexed: !1,
        internalType: "uint256"
      }
    ],
    anonymous: !1
  },
  {
    type: "event",
    name: "OutboundTransferQueued",
    inputs: [
      {
        name: "queueSequence",
        type: "uint64",
        indexed: !1,
        internalType: "uint64"
      }
    ],
    anonymous: !1
  },
  {
    type: "event",
    name: "OutboundTransferRateLimited",
    inputs: [
      {
        name: "sender",
        type: "address",
        indexed: !0,
        internalType: "address"
      },
      {
        name: "sequence",
        type: "uint64",
        indexed: !1,
        internalType: "uint64"
      },
      {
        name: "amount",
        type: "uint256",
        indexed: !1,
        internalType: "uint256"
      },
      {
        name: "currentCapacity",
        type: "uint256",
        indexed: !1,
        internalType: "uint256"
      }
    ],
    anonymous: !1
  },
  {
    type: "event",
    name: "OwnershipTransferred",
    inputs: [
      {
        name: "previousOwner",
        type: "address",
        indexed: !0,
        internalType: "address"
      },
      {
        name: "newOwner",
        type: "address",
        indexed: !0,
        internalType: "address"
      }
    ],
    anonymous: !1
  },
  {
    type: "event",
    name: "Paused",
    inputs: [
      {
        name: "paused",
        type: "bool",
        indexed: !1,
        internalType: "bool"
      }
    ],
    anonymous: !1
  },
  {
    type: "event",
    name: "PauserTransferred",
    inputs: [
      {
        name: "oldPauser",
        type: "address",
        indexed: !0,
        internalType: "address"
      },
      {
        name: "newPauser",
        type: "address",
        indexed: !0,
        internalType: "address"
      }
    ],
    anonymous: !1
  },
  {
    type: "event",
    name: "PeerUpdated",
    inputs: [
      {
        name: "chainId_",
        type: "uint16",
        indexed: !0,
        internalType: "uint16"
      },
      {
        name: "oldPeerContract",
        type: "bytes32",
        indexed: !1,
        internalType: "bytes32"
      },
      {
        name: "oldPeerDecimals",
        type: "uint8",
        indexed: !1,
        internalType: "uint8"
      },
      {
        name: "peerContract",
        type: "bytes32",
        indexed: !1,
        internalType: "bytes32"
      },
      {
        name: "peerDecimals",
        type: "uint8",
        indexed: !1,
        internalType: "uint8"
      }
    ],
    anonymous: !1
  },
  {
    type: "event",
    name: "ThresholdChanged",
    inputs: [
      {
        name: "oldThreshold",
        type: "uint8",
        indexed: !1,
        internalType: "uint8"
      },
      {
        name: "threshold",
        type: "uint8",
        indexed: !1,
        internalType: "uint8"
      }
    ],
    anonymous: !1
  },
  {
    type: "event",
    name: "TransceiverAdded",
    inputs: [
      {
        name: "transceiver",
        type: "address",
        indexed: !1,
        internalType: "address"
      },
      {
        name: "transceiversNum",
        type: "uint256",
        indexed: !1,
        internalType: "uint256"
      },
      {
        name: "threshold",
        type: "uint8",
        indexed: !1,
        internalType: "uint8"
      }
    ],
    anonymous: !1
  },
  {
    type: "event",
    name: "TransceiverRemoved",
    inputs: [
      {
        name: "transceiver",
        type: "address",
        indexed: !1,
        internalType: "address"
      },
      {
        name: "threshold",
        type: "uint8",
        indexed: !1,
        internalType: "uint8"
      }
    ],
    anonymous: !1
  },
  {
    type: "event",
    name: "TransferRedeemed",
    inputs: [
      {
        name: "digest",
        type: "bytes32",
        indexed: !0,
        internalType: "bytes32"
      }
    ],
    anonymous: !1
  },
  {
    type: "event",
    name: "TransferSent",
    inputs: [
      {
        name: "recipient",
        type: "bytes32",
        indexed: !1,
        internalType: "bytes32"
      },
      {
        name: "refundAddress",
        type: "bytes32",
        indexed: !1,
        internalType: "bytes32"
      },
      {
        name: "amount",
        type: "uint256",
        indexed: !1,
        internalType: "uint256"
      },
      {
        name: "fee",
        type: "uint256",
        indexed: !1,
        internalType: "uint256"
      },
      {
        name: "recipientChain",
        type: "uint16",
        indexed: !1,
        internalType: "uint16"
      },
      {
        name: "msgSequence",
        type: "uint64",
        indexed: !1,
        internalType: "uint64"
      }
    ],
    anonymous: !1
  },
  {
    type: "event",
    name: "Upgraded",
    inputs: [
      {
        name: "implementation",
        type: "address",
        indexed: !0,
        internalType: "address"
      }
    ],
    anonymous: !1
  },
  {
    type: "error",
    name: "BurnAmountDifferentThanBalanceDiff",
    inputs: [
      {
        name: "burnAmount",
        type: "uint256",
        internalType: "uint256"
      },
      {
        name: "balanceDiff",
        type: "uint256",
        internalType: "uint256"
      }
    ]
  },
  {
    type: "error",
    name: "CallerNotTransceiver",
    inputs: [
      {
        name: "caller",
        type: "address",
        internalType: "address"
      }
    ]
  },
  {
    type: "error",
    name: "CancellerNotSender",
    inputs: [
      {
        name: "canceller",
        type: "address",
        internalType: "address"
      },
      {
        name: "sender",
        type: "address",
        internalType: "address"
      }
    ]
  },
  {
    type: "error",
    name: "CapacityCannotExceedLimit",
    inputs: [
      {
        name: "newCurrentCapacity",
        type: "uint72",
        internalType: "TrimmedAmount"
      },
      {
        name: "newLimit",
        type: "uint72",
        internalType: "TrimmedAmount"
      }
    ]
  },
  {
    type: "error",
    name: "DeliveryPaymentTooLow",
    inputs: [
      {
        name: "requiredPayment",
        type: "uint256",
        internalType: "uint256"
      },
      {
        name: "providedPayment",
        type: "uint256",
        internalType: "uint256"
      }
    ]
  },
  {
    type: "error",
    name: "DisabledTransceiver",
    inputs: [
      {
        name: "transceiver",
        type: "address",
        internalType: "address"
      }
    ]
  },
  {
    type: "error",
    name: "InboundQueuedTransferNotFound",
    inputs: [
      {
        name: "digest",
        type: "bytes32",
        internalType: "bytes32"
      }
    ]
  },
  {
    type: "error",
    name: "InboundQueuedTransferStillQueued",
    inputs: [
      {
        name: "digest",
        type: "bytes32",
        internalType: "bytes32"
      },
      {
        name: "transferTimestamp",
        type: "uint256",
        internalType: "uint256"
      }
    ]
  },
  {
    type: "error",
    name: "InvalidFork",
    inputs: [
      {
        name: "evmChainId",
        type: "uint256",
        internalType: "uint256"
      },
      {
        name: "blockChainId",
        type: "uint256",
        internalType: "uint256"
      }
    ]
  },
  {
    type: "error",
    name: "InvalidInitialization",
    inputs: []
  },
  {
    type: "error",
    name: "InvalidMode",
    inputs: [
      {
        name: "mode",
        type: "uint8",
        internalType: "uint8"
      }
    ]
  },
  {
    type: "error",
    name: "InvalidPauser",
    inputs: [
      {
        name: "account",
        type: "address",
        internalType: "address"
      }
    ]
  },
  {
    type: "error",
    name: "InvalidPeer",
    inputs: [
      {
        name: "chainId",
        type: "uint16",
        internalType: "uint16"
      },
      {
        name: "peerAddress",
        type: "bytes32",
        internalType: "bytes32"
      }
    ]
  },
  {
    type: "error",
    name: "InvalidPeerChainIdZero",
    inputs: []
  },
  {
    type: "error",
    name: "InvalidPeerDecimals",
    inputs: []
  },
  {
    type: "error",
    name: "InvalidPeerSameChainId",
    inputs: []
  },
  {
    type: "error",
    name: "InvalidPeerZeroAddress",
    inputs: []
  },
  {
    type: "error",
    name: "InvalidRecipient",
    inputs: []
  },
  {
    type: "error",
    name: "InvalidRefundAddress",
    inputs: []
  },
  {
    type: "error",
    name: "InvalidTargetChain",
    inputs: [
      {
        name: "targetChain",
        type: "uint16",
        internalType: "uint16"
      },
      {
        name: "thisChain",
        type: "uint16",
        internalType: "uint16"
      }
    ]
  },
  {
    type: "error",
    name: "InvalidTransceiverZeroAddress",
    inputs: []
  },
  {
    type: "error",
    name: "MessageNotApproved",
    inputs: [
      {
        name: "msgHash",
        type: "bytes32",
        internalType: "bytes32"
      }
    ]
  },
  {
    type: "error",
    name: "NoEnabledTransceivers",
    inputs: []
  },
  {
    type: "error",
    name: "NonRegisteredTransceiver",
    inputs: [
      {
        name: "transceiver",
        type: "address",
        internalType: "address"
      }
    ]
  },
  {
    type: "error",
    name: "NotAnEvmAddress",
    inputs: [
      {
        name: "",
        type: "bytes32",
        internalType: "bytes32"
      }
    ]
  },
  {
    type: "error",
    name: "NotEnoughCapacity",
    inputs: [
      {
        name: "currentCapacity",
        type: "uint256",
        internalType: "uint256"
      },
      {
        name: "amount",
        type: "uint256",
        internalType: "uint256"
      }
    ]
  },
  {
    type: "error",
    name: "NotInitializing",
    inputs: []
  },
  {
    type: "error",
    name: "NotMigrating",
    inputs: []
  },
  {
    type: "error",
    name: "NumberOfDecimalsNotEqual",
    inputs: [
      {
        name: "decimals",
        type: "uint8",
        internalType: "uint8"
      },
      {
        name: "decimalsOther",
        type: "uint8",
        internalType: "uint8"
      }
    ]
  },
  {
    type: "error",
    name: "OnlyDelegateCall",
    inputs: []
  },
  {
    type: "error",
    name: "OutboundQueuedTransferNotFound",
    inputs: [
      {
        name: "queueSequence",
        type: "uint64",
        internalType: "uint64"
      }
    ]
  },
  {
    type: "error",
    name: "OutboundQueuedTransferStillQueued",
    inputs: [
      {
        name: "queueSequence",
        type: "uint64",
        internalType: "uint64"
      },
      {
        name: "transferTimestamp",
        type: "uint256",
        internalType: "uint256"
      }
    ]
  },
  {
    type: "error",
    name: "OwnableInvalidOwner",
    inputs: [
      {
        name: "owner",
        type: "address",
        internalType: "address"
      }
    ]
  },
  {
    type: "error",
    name: "OwnableUnauthorizedAccount",
    inputs: [
      {
        name: "account",
        type: "address",
        internalType: "address"
      }
    ]
  },
  {
    type: "error",
    name: "PeerNotRegistered",
    inputs: [
      {
        name: "chainId",
        type: "uint16",
        internalType: "uint16"
      }
    ]
  },
  {
    type: "error",
    name: "ReentrancyGuardReentrantCall",
    inputs: []
  },
  {
    type: "error",
    name: "RefundFailed",
    inputs: [
      {
        name: "refundAmount",
        type: "uint256",
        internalType: "uint256"
      }
    ]
  },
  {
    type: "error",
    name: "RequireContractIsNotPaused",
    inputs: []
  },
  {
    type: "error",
    name: "RequireContractIsPaused",
    inputs: []
  },
  {
    type: "error",
    name: "RetrievedIncorrectRegisteredTransceivers",
    inputs: [
      {
        name: "retrieved",
        type: "uint256",
        internalType: "uint256"
      },
      {
        name: "registered",
        type: "uint256",
        internalType: "uint256"
      }
    ]
  },
  {
    type: "error",
    name: "StaticcallFailed",
    inputs: []
  },
  {
    type: "error",
    name: "ThresholdTooHigh",
    inputs: [
      {
        name: "threshold",
        type: "uint256",
        internalType: "uint256"
      },
      {
        name: "transceivers",
        type: "uint256",
        internalType: "uint256"
      }
    ]
  },
  {
    type: "error",
    name: "TooManyTransceivers",
    inputs: []
  },
  {
    type: "error",
    name: "TransceiverAlreadyAttestedToMessage",
    inputs: [
      {
        name: "nttManagerMessageHash",
        type: "bytes32",
        internalType: "bytes32"
      }
    ]
  },
  {
    type: "error",
    name: "TransceiverAlreadyEnabled",
    inputs: [
      {
        name: "transceiver",
        type: "address",
        internalType: "address"
      }
    ]
  },
  {
    type: "error",
    name: "TransferAmountHasDust",
    inputs: [
      {
        name: "amount",
        type: "uint256",
        internalType: "uint256"
      },
      {
        name: "dust",
        type: "uint256",
        internalType: "uint256"
      }
    ]
  },
  {
    type: "error",
    name: "UndefinedRateLimiting",
    inputs: []
  },
  {
    type: "error",
    name: "UnexpectedDeployer",
    inputs: [
      {
        name: "expectedOwner",
        type: "address",
        internalType: "address"
      },
      {
        name: "owner",
        type: "address",
        internalType: "address"
      }
    ]
  },
  {
    type: "error",
    name: "UnexpectedMsgValue",
    inputs: []
  },
  {
    type: "error",
    name: "ZeroAmount",
    inputs: []
  },
  {
    type: "error",
    name: "ZeroThreshold",
    inputs: []
  }
], _bytecode$3 = "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$93083e246e55d56d98f3df2872cd16bfd0$__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__$93083e246e55d56d98f3df2872cd16bfd0$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$93083e246e55d56d98f3df2872cd16bfd0$__5af493841561363f576000946135ca575b5061ffff9283606086015116847f0000000000000000000000000000000000000000000000000000000000000000168082036135af575050613402614c50565b8161342b87519280613426816001600160401b03968760ff82169160081c16615b86565b615be1565b960151908160a01c613598576001600160a01b039182169560007f00000000000000000000000000000000000000000000000000000000000000008316156135915750613476614d5b565b508816600052600080516020615e88833981519152845261349c612cc78460002061508b565b6134a68882615b1a565b81808960081c169160081c16105b6134d957505050506134c96134d79484615850565b6134d283615730565b614af5565b565b7f7f63c9251d82a933210c2b6d0b0f116252c3c116788120e64e8e8215df6f3162975095613575839596949760019394519261351484612d64565b6001600160481b038091168452898401908242168252888501978852896000527f4e8909a01183a67951f5a6147d6e76ed02ea890c72afea01a9edee91edc609b88b52886000209451166001600160481b0319855416178455511682615a3f565b019151166001600160601b0360a01b82541617905551908152a1565b90506134b4565b50602491519063033b960d60e41b82526004820152fd5b6044925191631ee5902560e11b835260048301526024820152fd5b6080949194813d8211613637575b816135e560809383612dd0565b810103126106e2578351916135f983612d9a565b8151906001600160481b0382168203610277575082528481015185830152838101518483015261362b90606001613349565b606082015292386133c2565b3d91506135d8565b83513d6000823e3d90fd5b505050565b60405163b3f07bbd60e01b81529193926020918391829161367491906004840161332e565b038173__$93083e246e55d56d98f3df2872cd16bfd0$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$93083e246e55d56d98f3df2872cd16bfd0$__5af49182156105d957600092614aa4575b50614752818388613053565b95863410614a855761476487346131ae565b80614a76575b506040519061477882612d9a565b6001600160481b0386811683527f00000000000000000000000000000000000000000000000000000000000000006001600160a01b03166020840190815260408085018d815261ffff8d81166060880190815292516315cfa3cb60e11b81529651909416600487015291516024860152905160448501525116606483015260008260848173__$93083e246e55d56d98f3df2872cd16bfd0$__5af49182156105d957614877926000928d928492614a5a575b506001600160401b036040519361484085612d64565b16835260018060a01b031660208301526040820152604051809381926311692f3760e31b8352602060048401526024830190613307565b038173__$93083e246e55d56d98f3df2872cd16bfd0$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", isSuperArgs$3 = (C) => typeof C[0] == "string" || Array.isArray(C[0]) || "_isInterface" in C[0];
var Di;
let NttManager__factory$1 = (Di = class extends ContractFactory {
  constructor(...e) {
    if (isSuperArgs$3(e))
      super(...e);
    else {
      const [T, $] = e;
      super(_abi$3, Di.linkBytecode(T), $);
    }
  }
  static linkBytecode(e) {
    let T = _bytecode$3;
    return T = T.replace(new RegExp("__\\$93083e246e55d56d98f3df2872cd16bfd0\\$__", "g"), e["src/libraries/TransceiverStructs.sol:TransceiverStructs"].replace(/^0x/, "").toLowerCase()), T;
  }
  getDeployTransaction(e, T, $, V, J, ee) {
    return super.getDeployTransaction(e, T, $, V, J, ee || {});
  }
  deploy(e, T, $, V, J, ee) {
    return super.deploy(e, T, $, V, J, ee || {});
  }
  connect(e) {
    return super.connect(e);
  }
  static createInterface() {
    return new Interface(_abi$3);
  }
  static connect(e, T) {
    return new Contract(e, _abi$3, T);
  }
}, tt(Di, "bytecode", _bytecode$3), tt(Di, "abi", _abi$3), Di);
const _abi$2 = [
  {
    type: "constructor",
    inputs: [
      {
        name: "nttManager",
        type: "address",
        internalType: "address"
      },
      {
        name: "wormholeCoreBridge",
        type: "address",
        internalType: "address"
      },
      {
        name: "wormholeRelayerAddr",
        type: "address",
        internalType: "address"
      },
      {
        name: "specialRelayerAddr",
        type: "address",
        internalType: "address"
      },
      {
        name: "_consistencyLevel",
        type: "uint8",
        internalType: "uint8"
      },
      {
        name: "_gasLimit",
        type: "uint256",
        internalType: "uint256"
      }
    ],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    name: "WORMHOLE_TRANSCEIVER_VERSION",
    inputs: [],
    outputs: [
      {
        name: "",
        type: "string",
        internalType: "string"
      }
    ],
    stateMutability: "view"
  },
  {
    type: "function",
    name: "consistencyLevel",
    inputs: [],
    outputs: [
      {
        name: "",
        type: "uint8",
        internalType: "uint8"
      }
    ],
    stateMutability: "view"
  },
  {
    type: "function",
    name: "encodeWormholeTransceiverInstruction",
    inputs: [
      {
        name: "instruction",
        type: "tuple",
        internalType: "struct IWormholeTransceiver.WormholeTransceiverInstruction",
        components: [
          {
            name: "shouldSkipRelayerSend",
            type: "bool",
            internalType: "bool"
          }
        ]
      }
    ],
    outputs: [
      {
        name: "",
        type: "bytes",
        internalType: "bytes"
      }
    ],
    stateMutability: "pure"
  },
  {
    type: "function",
    name: "gasLimit",
    inputs: [],
    outputs: [
      {
        name: "",
        type: "uint256",
        internalType: "uint256"
      }
    ],
    stateMutability: "view"
  },
  {
    type: "function",
    name: "getMigratesImmutables",
    inputs: [],
    outputs: [
      {
        name: "",
        type: "bool",
        internalType: "bool"
      }
    ],
    stateMutability: "view"
  },
  {
    type: "function",
    name: "getNttManagerOwner",
    inputs: [],
    outputs: [
      {
        name: "",
        type: "address",
        internalType: "address"
      }
    ],
    stateMutability: "view"
  },
  {
    type: "function",
    name: "getNttManagerToken",
    inputs: [],
    outputs: [
      {
        name: "",
        type: "address",
        internalType: "address"
      }
    ],
    stateMutability: "view"
  },
  {
    type: "function",
    name: "getWormholePeer",
    inputs: [
      {
        name: "chainId",
        type: "uint16",
        internalType: "uint16"
      }
    ],
    outputs: [
      {
        name: "",
        type: "bytes32",
        internalType: "bytes32"
      }
    ],
    stateMutability: "view"
  },
  {
    type: "function",
    name: "initialize",
    inputs: [],
    outputs: [],
    stateMutability: "payable"
  },
  {
    type: "function",
    name: "isPaused",
    inputs: [],
    outputs: [
      {
        name: "",
        type: "bool",
        internalType: "bool"
      }
    ],
    stateMutability: "view"
  },
  {
    type: "function",
    name: "isSpecialRelayingEnabled",
    inputs: [
      {
        name: "chainId",
        type: "uint16",
        internalType: "uint16"
      }
    ],
    outputs: [
      {
        name: "",
        type: "bool",
        internalType: "bool"
      }
    ],
    stateMutability: "view"
  },
  {
    type: "function",
    name: "isVAAConsumed",
    inputs: [
      {
        name: "hash",
        type: "bytes32",
        internalType: "bytes32"
      }
    ],
    outputs: [
      {
        name: "",
        type: "bool",
        internalType: "bool"
      }
    ],
    stateMutability: "view"
  },
  {
    type: "function",
    name: "isWormholeEvmChain",
    inputs: [
      {
        name: "chainId",
        type: "uint16",
        internalType: "uint16"
      }
    ],
    outputs: [
      {
        name: "",
        type: "bool",
        internalType: "bool"
      }
    ],
    stateMutability: "view"
  },
  {
    type: "function",
    name: "isWormholeRelayingEnabled",
    inputs: [
      {
        name: "chainId",
        type: "uint16",
        internalType: "uint16"
      }
    ],
    outputs: [
      {
        name: "",
        type: "bool",
        internalType: "bool"
      }
    ],
    stateMutability: "view"
  },
  {
    type: "function",
    name: "migrate",
    inputs: [],
    outputs: [],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    name: "nttManager",
    inputs: [],
    outputs: [
      {
        name: "",
        type: "address",
        internalType: "address"
      }
    ],
    stateMutability: "view"
  },
  {
    type: "function",
    name: "nttManagerToken",
    inputs: [],
    outputs: [
      {
        name: "",
        type: "address",
        internalType: "address"
      }
    ],
    stateMutability: "view"
  },
  {
    type: "function",
    name: "owner",
    inputs: [],
    outputs: [
      {
        name: "",
        type: "address",
        internalType: "address"
      }
    ],
    stateMutability: "view"
  },
  {
    type: "function",
    name: "parseWormholeTransceiverInstruction",
    inputs: [
      {
        name: "encoded",
        type: "bytes",
        internalType: "bytes"
      }
    ],
    outputs: [
      {
        name: "instruction",
        type: "tuple",
        internalType: "struct IWormholeTransceiver.WormholeTransceiverInstruction",
        components: [
          {
            name: "shouldSkipRelayerSend",
            type: "bool",
            internalType: "bool"
          }
        ]
      }
    ],
    stateMutability: "pure"
  },
  {
    type: "function",
    name: "pauser",
    inputs: [],
    outputs: [
      {
        name: "",
        type: "address",
        internalType: "address"
      }
    ],
    stateMutability: "view"
  },
  {
    type: "function",
    name: "quoteDeliveryPrice",
    inputs: [
      {
        name: "targetChain",
        type: "uint16",
        internalType: "uint16"
      },
      {
        name: "instruction",
        type: "tuple",
        internalType: "struct TransceiverStructs.TransceiverInstruction",
        components: [
          {
            name: "index",
            type: "uint8",
            internalType: "uint8"
          },
          {
            name: "payload",
            type: "bytes",
            internalType: "bytes"
          }
        ]
      }
    ],
    outputs: [
      {
        name: "",
        type: "uint256",
        internalType: "uint256"
      }
    ],
    stateMutability: "view"
  },
  {
    type: "function",
    name: "receiveMessage",
    inputs: [
      {
        name: "encodedMessage",
        type: "bytes",
        internalType: "bytes"
      }
    ],
    outputs: [],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    name: "receiveWormholeMessages",
    inputs: [
      {
        name: "payload",
        type: "bytes",
        internalType: "bytes"
      },
      {
        name: "additionalMessages",
        type: "bytes[]",
        internalType: "bytes[]"
      },
      {
        name: "sourceAddress",
        type: "bytes32",
        internalType: "bytes32"
      },
      {
        name: "sourceChain",
        type: "uint16",
        internalType: "uint16"
      },
      {
        name: "deliveryHash",
        type: "bytes32",
        internalType: "bytes32"
      }
    ],
    outputs: [],
    stateMutability: "payable"
  },
  {
    type: "function",
    name: "sendMessage",
    inputs: [
      {
        name: "recipientChain",
        type: "uint16",
        internalType: "uint16"
      },
      {
        name: "instruction",
        type: "tuple",
        internalType: "struct TransceiverStructs.TransceiverInstruction",
        components: [
          {
            name: "index",
            type: "uint8",
            internalType: "uint8"
          },
          {
            name: "payload",
            type: "bytes",
            internalType: "bytes"
          }
        ]
      },
      {
        name: "nttManagerMessage",
        type: "bytes",
        internalType: "bytes"
      },
      {
        name: "recipientNttManagerAddress",
        type: "bytes32",
        internalType: "bytes32"
      },
      {
        name: "refundAddress",
        type: "bytes32",
        internalType: "bytes32"
      }
    ],
    outputs: [],
    stateMutability: "payable"
  },
  {
    type: "function",
    name: "setIsSpecialRelayingEnabled",
    inputs: [
      {
        name: "chainId",
        type: "uint16",
        internalType: "uint16"
      },
      {
        name: "isEnabled",
        type: "bool",
        internalType: "bool"
      }
    ],
    outputs: [],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    name: "setIsWormholeEvmChain",
    inputs: [
      {
        name: "chainId",
        type: "uint16",
        internalType: "uint16"
      },
      {
        name: "isEvm",
        type: "bool",
        internalType: "bool"
      }
    ],
    outputs: [],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    name: "setIsWormholeRelayingEnabled",
    inputs: [
      {
        name: "chainId",
        type: "uint16",
        internalType: "uint16"
      },
      {
        name: "isEnabled",
        type: "bool",
        internalType: "bool"
      }
    ],
    outputs: [],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    name: "setWormholePeer",
    inputs: [
      {
        name: "peerChainId",
        type: "uint16",
        internalType: "uint16"
      },
      {
        name: "peerContract",
        type: "bytes32",
        internalType: "bytes32"
      }
    ],
    outputs: [],
    stateMutability: "payable"
  },
  {
    type: "function",
    name: "specialRelayer",
    inputs: [],
    outputs: [
      {
        name: "",
        type: "address",
        internalType: "contract ISpecialRelayer"
      }
    ],
    stateMutability: "view"
  },
  {
    type: "function",
    name: "transferOwnership",
    inputs: [
      {
        name: "newOwner",
        type: "address",
        internalType: "address"
      }
    ],
    outputs: [],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    name: "transferPauserCapability",
    inputs: [
      {
        name: "newPauser",
        type: "address",
        internalType: "address"
      }
    ],
    outputs: [],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    name: "transferTransceiverOwnership",
    inputs: [
      {
        name: "newOwner",
        type: "address",
        internalType: "address"
      }
    ],
    outputs: [],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    name: "upgrade",
    inputs: [
      {
        name: "newImplementation",
        type: "address",
        internalType: "address"
      }
    ],
    outputs: [],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    name: "wormhole",
    inputs: [],
    outputs: [
      {
        name: "",
        type: "address",
        internalType: "contract IWormhole"
      }
    ],
    stateMutability: "view"
  },
  {
    type: "function",
    name: "wormholeRelayer",
    inputs: [],
    outputs: [
      {
        name: "",
        type: "address",
        internalType: "contract IWormholeRelayer"
      }
    ],
    stateMutability: "view"
  },
  {
    type: "event",
    name: "AdminChanged",
    inputs: [
      {
        name: "previousAdmin",
        type: "address",
        indexed: !1,
        internalType: "address"
      },
      {
        name: "newAdmin",
        type: "address",
        indexed: !1,
        internalType: "address"
      }
    ],
    anonymous: !1
  },
  {
    type: "event",
    name: "BeaconUpgraded",
    inputs: [
      {
        name: "beacon",
        type: "address",
        indexed: !0,
        internalType: "address"
      }
    ],
    anonymous: !1
  },
  {
    type: "event",
    name: "Initialized",
    inputs: [
      {
        name: "version",
        type: "uint64",
        indexed: !1,
        internalType: "uint64"
      }
    ],
    anonymous: !1
  },
  {
    type: "event",
    name: "NotPaused",
    inputs: [
      {
        name: "notPaused",
        type: "bool",
        indexed: !1,
        internalType: "bool"
      }
    ],
    anonymous: !1
  },
  {
    type: "event",
    name: "OwnershipTransferred",
    inputs: [
      {
        name: "previousOwner",
        type: "address",
        indexed: !0,
        internalType: "address"
      },
      {
        name: "newOwner",
        type: "address",
        indexed: !0,
        internalType: "address"
      }
    ],
    anonymous: !1
  },
  {
    type: "event",
    name: "Paused",
    inputs: [
      {
        name: "paused",
        type: "bool",
        indexed: !1,
        internalType: "bool"
      }
    ],
    anonymous: !1
  },
  {
    type: "event",
    name: "PauserTransferred",
    inputs: [
      {
        name: "oldPauser",
        type: "address",
        indexed: !0,
        internalType: "address"
      },
      {
        name: "newPauser",
        type: "address",
        indexed: !0,
        internalType: "address"
      }
    ],
    anonymous: !1
  },
  {
    type: "event",
    name: "ReceivedMessage",
    inputs: [
      {
        name: "digest",
        type: "bytes32",
        indexed: !1,
        internalType: "bytes32"
      },
      {
        name: "emitterChainId",
        type: "uint16",
        indexed: !1,
        internalType: "uint16"
      },
      {
        name: "emitterAddress",
        type: "bytes32",
        indexed: !1,
        internalType: "bytes32"
      },
      {
        name: "sequence",
        type: "uint64",
        indexed: !1,
        internalType: "uint64"
      }
    ],
    anonymous: !1
  },
  {
    type: "event",
    name: "ReceivedRelayedMessage",
    inputs: [
      {
        name: "digest",
        type: "bytes32",
        indexed: !1,
        internalType: "bytes32"
      },
      {
        name: "emitterChainId",
        type: "uint16",
        indexed: !1,
        internalType: "uint16"
      },
      {
        name: "emitterAddress",
        type: "bytes32",
        indexed: !1,
        internalType: "bytes32"
      }
    ],
    anonymous: !1
  },
  {
    type: "event",
    name: "RelayingInfo",
    inputs: [
      {
        name: "relayingType",
        type: "uint8",
        indexed: !1,
        internalType: "uint8"
      },
      {
        name: "refundAddress",
        type: "bytes32",
        indexed: !1,
        internalType: "bytes32"
      },
      {
        name: "deliveryPayment",
        type: "uint256",
        indexed: !1,
        internalType: "uint256"
      }
    ],
    anonymous: !1
  },
  {
    type: "event",
    name: "SendTransceiverMessage",
    inputs: [
      {
        name: "recipientChain",
        type: "uint16",
        indexed: !1,
        internalType: "uint16"
      },
      {
        name: "message",
        type: "tuple",
        indexed: !1,
        internalType: "struct TransceiverStructs.TransceiverMessage",
        components: [
          {
            name: "sourceNttManagerAddress",
            type: "bytes32",
            internalType: "bytes32"
          },
          {
            name: "recipientNttManagerAddress",
            type: "bytes32",
            internalType: "bytes32"
          },
          {
            name: "nttManagerPayload",
            type: "bytes",
            internalType: "bytes"
          },
          {
            name: "transceiverPayload",
            type: "bytes",
            internalType: "bytes"
          }
        ]
      }
    ],
    anonymous: !1
  },
  {
    type: "event",
    name: "SetIsSpecialRelayingEnabled",
    inputs: [
      {
        name: "chainId",
        type: "uint16",
        indexed: !1,
        internalType: "uint16"
      },
      {
        name: "isRelayingEnabled",
        type: "bool",
        indexed: !1,
        internalType: "bool"
      }
    ],
    anonymous: !1
  },
  {
    type: "event",
    name: "SetIsWormholeEvmChain",
    inputs: [
      {
        name: "chainId",
        type: "uint16",
        indexed: !1,
        internalType: "uint16"
      },
      {
        name: "isEvm",
        type: "bool",
        indexed: !1,
        internalType: "bool"
      }
    ],
    anonymous: !1
  },
  {
    type: "event",
    name: "SetIsWormholeRelayingEnabled",
    inputs: [
      {
        name: "chainId",
        type: "uint16",
        indexed: !1,
        internalType: "uint16"
      },
      {
        name: "isRelayingEnabled",
        type: "bool",
        indexed: !1,
        internalType: "bool"
      }
    ],
    anonymous: !1
  },
  {
    type: "event",
    name: "SetWormholePeer",
    inputs: [
      {
        name: "chainId",
        type: "uint16",
        indexed: !1,
        internalType: "uint16"
      },
      {
        name: "peerContract",
        type: "bytes32",
        indexed: !1,
        internalType: "bytes32"
      }
    ],
    anonymous: !1
  },
  {
    type: "event",
    name: "Upgraded",
    inputs: [
      {
        name: "implementation",
        type: "address",
        indexed: !0,
        internalType: "address"
      }
    ],
    anonymous: !1
  },
  {
    type: "error",
    name: "CallerNotNttManager",
    inputs: [
      {
        name: "caller",
        type: "address",
        internalType: "address"
      }
    ]
  },
  {
    type: "error",
    name: "CallerNotRelayer",
    inputs: [
      {
        name: "caller",
        type: "address",
        internalType: "address"
      }
    ]
  },
  {
    type: "error",
    name: "CannotRenounceTransceiverOwnership",
    inputs: [
      {
        name: "currentOwner",
        type: "address",
        internalType: "address"
      }
    ]
  },
  {
    type: "error",
    name: "CannotTransferTransceiverOwnership",
    inputs: [
      {
        name: "currentOwner",
        type: "address",
        internalType: "address"
      },
      {
        name: "newOwner",
        type: "address",
        internalType: "address"
      }
    ]
  },
  {
    type: "error",
    name: "InvalidBoolVal",
    inputs: [
      {
        name: "val",
        type: "uint8",
        internalType: "uint8"
      }
    ]
  },
  {
    type: "error",
    name: "InvalidBoolValue",
    inputs: [
      {
        name: "value",
        type: "uint256",
        internalType: "BooleanFlag"
      }
    ]
  },
  {
    type: "error",
    name: "InvalidFork",
    inputs: [
      {
        name: "evmChainId",
        type: "uint256",
        internalType: "uint256"
      },
      {
        name: "blockChainId",
        type: "uint256",
        internalType: "uint256"
      }
    ]
  },
  {
    type: "error",
    name: "InvalidInitialization",
    inputs: []
  },
  {
    type: "error",
    name: "InvalidPauser",
    inputs: [
      {
        name: "account",
        type: "address",
        internalType: "address"
      }
    ]
  },
  {
    type: "error",
    name: "InvalidRelayingConfig",
    inputs: [
      {
        name: "chainId",
        type: "uint16",
        internalType: "uint16"
      }
    ]
  },
  {
    type: "error",
    name: "InvalidVaa",
    inputs: [
      {
        name: "reason",
        type: "string",
        internalType: "string"
      }
    ]
  },
  {
    type: "error",
    name: "InvalidWormholeChainIdZero",
    inputs: []
  },
  {
    type: "error",
    name: "InvalidWormholePeer",
    inputs: [
      {
        name: "chainId",
        type: "uint16",
        internalType: "uint16"
      },
      {
        name: "peerAddress",
        type: "bytes32",
        internalType: "bytes32"
      }
    ]
  },
  {
    type: "error",
    name: "InvalidWormholePeerZeroAddress",
    inputs: []
  },
  {
    type: "error",
    name: "LengthMismatch",
    inputs: [
      {
        name: "encodedLength",
        type: "uint256",
        internalType: "uint256"
      },
      {
        name: "expectedLength",
        type: "uint256",
        internalType: "uint256"
      }
    ]
  },
  {
    type: "error",
    name: "NotAnEvmAddress",
    inputs: [
      {
        name: "",
        type: "bytes32",
        internalType: "bytes32"
      }
    ]
  },
  {
    type: "error",
    name: "NotInitializing",
    inputs: []
  },
  {
    type: "error",
    name: "NotMigrating",
    inputs: []
  },
  {
    type: "error",
    name: "OnlyDelegateCall",
    inputs: []
  },
  {
    type: "error",
    name: "OwnableInvalidOwner",
    inputs: [
      {
        name: "owner",
        type: "address",
        internalType: "address"
      }
    ]
  },
  {
    type: "error",
    name: "OwnableUnauthorizedAccount",
    inputs: [
      {
        name: "account",
        type: "address",
        internalType: "address"
      }
    ]
  },
  {
    type: "error",
    name: "PeerAlreadySet",
    inputs: [
      {
        name: "chainId",
        type: "uint16",
        internalType: "uint16"
      },
      {
        name: "peerAddress",
        type: "bytes32",
        internalType: "bytes32"
      }
    ]
  },
  {
    type: "error",
    name: "ReentrancyGuardReentrantCall",
    inputs: []
  },
  {
    type: "error",
    name: "RequireContractIsNotPaused",
    inputs: []
  },
  {
    type: "error",
    name: "RequireContractIsPaused",
    inputs: []
  },
  {
    type: "error",
    name: "TransferAlreadyCompleted",
    inputs: [
      {
        name: "vaaHash",
        type: "bytes32",
        internalType: "bytes32"
      }
    ]
  },
  {
    type: "error",
    name: "UnexpectedAdditionalMessages",
    inputs: []
  },
  {
    type: "error",
    name: "UnexpectedDeployer",
    inputs: [
      {
        name: "deployer",
        type: "address",
        internalType: "address"
      },
      {
        name: "caller",
        type: "address",
        internalType: "address"
      }
    ]
  },
  {
    type: "error",
    name: "UnexpectedRecipientNttManagerAddress",
    inputs: [
      {
        name: "recipientNttManagerAddress",
        type: "bytes32",
        internalType: "bytes32"
      },
      {
        name: "expectedRecipientNttManagerAddress",
        type: "bytes32",
        internalType: "bytes32"
      }
    ]
  }
], _bytecode$2 = "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__$93083e246e55d56d98f3df2872cd16bfd0$__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__$93083e246e55d56d98f3df2872cd16bfd0$__5af49081156110005791610f21939187938a91610fde575b5086518095819482936358cd21bf60e11b84527f0000000000000000000000000000000000000000000000000000000000000000918401612fac565b039134907f0000000000000000000000000000000000000000000000000000000000000000165af18015610fd457610f9c575b50610f5d578380f35b7fc7f505b2f371ae2175ee4913f4499e1f2633a7b5936321eed1cdaeb6115181d29268ff00000000000000001981541690555160018152a13880808380f35b8381813d8311610fcd575b610fb1818361270f565b81010312610fc957610fc290612f98565b5038610f54565b8580fd5b503d610fa7565b83513d88823e3d90fd5b610ffa91503d808c833e610ff2818361270f565b81019061302c565b38610ee5565b85513d8a823e3d90fd5b9092508881813d831161103a575b611022818361270f565b810103126106575761103390613000565b9138610e16565b503d611018565b88513d8d823e3d90fd5b9091508781813d831161107b575b611063818361270f565b810103126105f85761107490613000565b9038610df3565b503d611059565b87513d8c823e3d90fd5b82604491865191636345072160e11b8352820152336024820152fd5b68ffffffffffffffffff19166801000000000000000117855538610cba565b50825163f92ee8a960e01b8152fd5b90501538610c9e565b303b159150610c96565b849150610c8c565b50913461067e57602036600319011261067e575061070b6020923560005260008051602061328883398151915260205260ff6040600020541690565b508160031936011261068557611141612669565b6024359161114d6131b8565b61ffff80831690811561137857841561136857816000526000805160206132688339815191529160209280845287600020548061133f575081600052835285876000205586519161119d836126be565b630c7e33e160e11b8352838301918252878301878152885163077650fb60e51b815293516001600160e01b031916868501529151166024830152516044820152868160648173__$93083e246e55d56d98f3df2872cd16bfd0$__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__$93083e246e55d56d98f3df2872cd16bfd0$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", isSuperArgs$2 = (C) => typeof C[0] == "string" || Array.isArray(C[0]) || "_isInterface" in C[0];
var Ni;
let WormholeTransceiver__factory$1 = (Ni = class extends ContractFactory {
  constructor(...e) {
    if (isSuperArgs$2(e))
      super(...e);
    else {
      const [T, $] = e;
      super(_abi$2, Ni.linkBytecode(T), $);
    }
  }
  static linkBytecode(e) {
    let T = _bytecode$2;
    return T = T.replace(new RegExp("__\\$93083e246e55d56d98f3df2872cd16bfd0\\$__", "g"), e["src/libraries/TransceiverStructs.sol:TransceiverStructs"].replace(/^0x/, "").toLowerCase()), T;
  }
  getDeployTransaction(e, T, $, V, J, ee, te) {
    return super.getDeployTransaction(e, T, $, V, J, ee, te || {});
  }
  deploy(e, T, $, V, J, ee, te) {
    return super.deploy(e, T, $, V, J, ee, te || {});
  }
  connect(e) {
    return super.connect(e);
  }
  static createInterface() {
    return new Interface(_abi$2);
  }
  static connect(e, T) {
    return new Contract(e, _abi$2, T);
  }
}, tt(Ni, "bytecode", _bytecode$2), tt(Ni, "abi", _abi$2), Ni);
const _abi$1 = [
  {
    type: "constructor",
    inputs: [
      {
        name: "_token",
        type: "address",
        internalType: "address"
      },
      {
        name: "_mode",
        type: "uint8",
        internalType: "enum IManagerBase.Mode"
      },
      {
        name: "_chainId",
        type: "uint16",
        internalType: "uint16"
      },
      {
        name: "_rateLimitDuration",
        type: "uint64",
        internalType: "uint64"
      },
      {
        name: "_skipRateLimiting",
        type: "bool",
        internalType: "bool"
      }
    ],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    name: "NTT_MANAGER_VERSION",
    inputs: [],
    outputs: [
      {
        name: "",
        type: "string",
        internalType: "string"
      }
    ],
    stateMutability: "view"
  },
  {
    type: "function",
    name: "attestationReceived",
    inputs: [
      {
        name: "sourceChainId",
        type: "uint16",
        internalType: "uint16"
      },
      {
        name: "sourceNttManagerAddress",
        type: "bytes32",
        internalType: "bytes32"
      },
      {
        name: "payload",
        type: "tuple",
        internalType: "struct TransceiverStructs.NttManagerMessage",
        components: [
          {
            name: "id",
            type: "bytes32",
            internalType: "bytes32"
          },
          {
            name: "sender",
            type: "bytes32",
            internalType: "bytes32"
          },
          {
            name: "payload",
            type: "bytes",
            internalType: "bytes"
          }
        ]
      }
    ],
    outputs: [],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    name: "cancelOutboundQueuedTransfer",
    inputs: [
      {
        name: "messageSequence",
        type: "uint64",
        internalType: "uint64"
      }
    ],
    outputs: [],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    name: "chainId",
    inputs: [],
    outputs: [
      {
        name: "",
        type: "uint16",
        internalType: "uint16"
      }
    ],
    stateMutability: "view"
  },
  {
    type: "function",
    name: "completeInboundQueuedTransfer",
    inputs: [
      {
        name: "digest",
        type: "bytes32",
        internalType: "bytes32"
      }
    ],
    outputs: [],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    name: "completeOutboundQueuedTransfer",
    inputs: [
      {
        name: "messageSequence",
        type: "uint64",
        internalType: "uint64"
      }
    ],
    outputs: [
      {
        name: "",
        type: "uint64",
        internalType: "uint64"
      }
    ],
    stateMutability: "payable"
  },
  {
    type: "function",
    name: "executeMsg",
    inputs: [
      {
        name: "sourceChainId",
        type: "uint16",
        internalType: "uint16"
      },
      {
        name: "sourceNttManagerAddress",
        type: "bytes32",
        internalType: "bytes32"
      },
      {
        name: "message",
        type: "tuple",
        internalType: "struct TransceiverStructs.NttManagerMessage",
        components: [
          {
            name: "id",
            type: "bytes32",
            internalType: "bytes32"
          },
          {
            name: "sender",
            type: "bytes32",
            internalType: "bytes32"
          },
          {
            name: "payload",
            type: "bytes",
            internalType: "bytes"
          }
        ]
      }
    ],
    outputs: [],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    name: "getCurrentInboundCapacity",
    inputs: [
      {
        name: "chainId_",
        type: "uint16",
        internalType: "uint16"
      }
    ],
    outputs: [
      {
        name: "",
        type: "uint256",
        internalType: "uint256"
      }
    ],
    stateMutability: "view"
  },
  {
    type: "function",
    name: "getCurrentOutboundCapacity",
    inputs: [],
    outputs: [
      {
        name: "",
        type: "uint256",
        internalType: "uint256"
      }
    ],
    stateMutability: "view"
  },
  {
    type: "function",
    name: "getInboundLimitParams",
    inputs: [
      {
        name: "chainId_",
        type: "uint16",
        internalType: "uint16"
      }
    ],
    outputs: [
      {
        name: "",
        type: "tuple",
        internalType: "struct IRateLimiter.RateLimitParams",
        components: [
          {
            name: "limit",
            type: "uint72",
            internalType: "TrimmedAmount"
          },
          {
            name: "currentCapacity",
            type: "uint72",
            internalType: "TrimmedAmount"
          },
          {
            name: "lastTxTimestamp",
            type: "uint64",
            internalType: "uint64"
          }
        ]
      }
    ],
    stateMutability: "view"
  },
  {
    type: "function",
    name: "getInboundQueuedTransfer",
    inputs: [
      {
        name: "digest",
        type: "bytes32",
        internalType: "bytes32"
      }
    ],
    outputs: [
      {
        name: "",
        type: "tuple",
        internalType: "struct IRateLimiter.InboundQueuedTransfer",
        components: [
          {
            name: "amount",
            type: "uint72",
            internalType: "TrimmedAmount"
          },
          {
            name: "txTimestamp",
            type: "uint64",
            internalType: "uint64"
          },
          {
            name: "recipient",
            type: "address",
            internalType: "address"
          }
        ]
      }
    ],
    stateMutability: "view"
  },
  {
    type: "function",
    name: "getMigratesImmutables",
    inputs: [],
    outputs: [
      {
        name: "",
        type: "bool",
        internalType: "bool"
      }
    ],
    stateMutability: "view"
  },
  {
    type: "function",
    name: "getMode",
    inputs: [],
    outputs: [
      {
        name: "",
        type: "uint8",
        internalType: "uint8"
      }
    ],
    stateMutability: "view"
  },
  {
    type: "function",
    name: "getOutboundLimitParams",
    inputs: [],
    outputs: [
      {
        name: "",
        type: "tuple",
        internalType: "struct IRateLimiter.RateLimitParams",
        components: [
          {
            name: "limit",
            type: "uint72",
            internalType: "TrimmedAmount"
          },
          {
            name: "currentCapacity",
            type: "uint72",
            internalType: "TrimmedAmount"
          },
          {
            name: "lastTxTimestamp",
            type: "uint64",
            internalType: "uint64"
          }
        ]
      }
    ],
    stateMutability: "pure"
  },
  {
    type: "function",
    name: "getOutboundQueuedTransfer",
    inputs: [
      {
        name: "queueSequence",
        type: "uint64",
        internalType: "uint64"
      }
    ],
    outputs: [
      {
        name: "",
        type: "tuple",
        internalType: "struct IRateLimiter.OutboundQueuedTransfer",
        components: [
          {
            name: "recipient",
            type: "bytes32",
            internalType: "bytes32"
          },
          {
            name: "refundAddress",
            type: "bytes32",
            internalType: "bytes32"
          },
          {
            name: "amount",
            type: "uint72",
            internalType: "TrimmedAmount"
          },
          {
            name: "txTimestamp",
            type: "uint64",
            internalType: "uint64"
          },
          {
            name: "recipientChain",
            type: "uint16",
            internalType: "uint16"
          },
          {
            name: "sender",
            type: "address",
            internalType: "address"
          },
          {
            name: "transceiverInstructions",
            type: "bytes",
            internalType: "bytes"
          }
        ]
      }
    ],
    stateMutability: "view"
  },
  {
    type: "function",
    name: "getPeer",
    inputs: [
      {
        name: "chainId_",
        type: "uint16",
        internalType: "uint16"
      }
    ],
    outputs: [
      {
        name: "",
        type: "tuple",
        internalType: "struct INttManager.NttManagerPeer",
        components: [
          {
            name: "peerAddress",
            type: "bytes32",
            internalType: "bytes32"
          },
          {
            name: "tokenDecimals",
            type: "uint8",
            internalType: "uint8"
          }
        ]
      }
    ],
    stateMutability: "view"
  },
  {
    type: "function",
    name: "getThreshold",
    inputs: [],
    outputs: [
      {
        name: "",
        type: "uint8",
        internalType: "uint8"
      }
    ],
    stateMutability: "view"
  },
  {
    type: "function",
    name: "getTransceiverInfo",
    inputs: [],
    outputs: [
      {
        name: "",
        type: "tuple[]",
        internalType: "struct TransceiverRegistry.TransceiverInfo[]",
        components: [
          {
            name: "registered",
            type: "bool",
            internalType: "bool"
          },
          {
            name: "enabled",
            type: "bool",
            internalType: "bool"
          },
          {
            name: "index",
            type: "uint8",
            internalType: "uint8"
          }
        ]
      }
    ],
    stateMutability: "view"
  },
  {
    type: "function",
    name: "getTransceivers",
    inputs: [],
    outputs: [
      {
        name: "result",
        type: "address[]",
        internalType: "address[]"
      }
    ],
    stateMutability: "pure"
  },
  {
    type: "function",
    name: "initialize",
    inputs: [],
    outputs: [],
    stateMutability: "payable"
  },
  {
    type: "function",
    name: "isMessageApproved",
    inputs: [
      {
        name: "digest",
        type: "bytes32",
        internalType: "bytes32"
      }
    ],
    outputs: [
      {
        name: "",
        type: "bool",
        internalType: "bool"
      }
    ],
    stateMutability: "view"
  },
  {
    type: "function",
    name: "isMessageExecuted",
    inputs: [
      {
        name: "digest",
        type: "bytes32",
        internalType: "bytes32"
      }
    ],
    outputs: [
      {
        name: "",
        type: "bool",
        internalType: "bool"
      }
    ],
    stateMutability: "view"
  },
  {
    type: "function",
    name: "isPaused",
    inputs: [],
    outputs: [
      {
        name: "",
        type: "bool",
        internalType: "bool"
      }
    ],
    stateMutability: "view"
  },
  {
    type: "function",
    name: "messageAttestations",
    inputs: [
      {
        name: "digest",
        type: "bytes32",
        internalType: "bytes32"
      }
    ],
    outputs: [
      {
        name: "count",
        type: "uint8",
        internalType: "uint8"
      }
    ],
    stateMutability: "view"
  },
  {
    type: "function",
    name: "migrate",
    inputs: [],
    outputs: [],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    name: "mode",
    inputs: [],
    outputs: [
      {
        name: "",
        type: "uint8",
        internalType: "enum IManagerBase.Mode"
      }
    ],
    stateMutability: "view"
  },
  {
    type: "function",
    name: "nextMessageSequence",
    inputs: [],
    outputs: [
      {
        name: "",
        type: "uint64",
        internalType: "uint64"
      }
    ],
    stateMutability: "view"
  },
  {
    type: "function",
    name: "owner",
    inputs: [],
    outputs: [
      {
        name: "",
        type: "address",
        internalType: "address"
      }
    ],
    stateMutability: "view"
  },
  {
    type: "function",
    name: "pause",
    inputs: [],
    outputs: [],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    name: "pauser",
    inputs: [],
    outputs: [
      {
        name: "",
        type: "address",
        internalType: "address"
      }
    ],
    stateMutability: "view"
  },
  {
    type: "function",
    name: "quoteDeliveryPrice",
    inputs: [
      {
        name: "recipientChain",
        type: "uint16",
        internalType: "uint16"
      },
      {
        name: "transceiverInstructions",
        type: "bytes",
        internalType: "bytes"
      }
    ],
    outputs: [
      {
        name: "",
        type: "uint256[]",
        internalType: "uint256[]"
      },
      {
        name: "",
        type: "uint256",
        internalType: "uint256"
      }
    ],
    stateMutability: "view"
  },
  {
    type: "function",
    name: "rateLimitDuration",
    inputs: [],
    outputs: [
      {
        name: "",
        type: "uint64",
        internalType: "uint64"
      }
    ],
    stateMutability: "view"
  },
  {
    type: "function",
    name: "removeTransceiver",
    inputs: [
      {
        name: "transceiver",
        type: "address",
        internalType: "address"
      }
    ],
    outputs: [],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    name: "setInboundLimit",
    inputs: [
      {
        name: "limit",
        type: "uint256",
        internalType: "uint256"
      },
      {
        name: "chainId_",
        type: "uint16",
        internalType: "uint16"
      }
    ],
    outputs: [],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    name: "setOutboundLimit",
    inputs: [
      {
        name: "limit",
        type: "uint256",
        internalType: "uint256"
      }
    ],
    outputs: [],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    name: "setPeer",
    inputs: [
      {
        name: "peerChainId",
        type: "uint16",
        internalType: "uint16"
      },
      {
        name: "peerContract",
        type: "bytes32",
        internalType: "bytes32"
      },
      {
        name: "decimals",
        type: "uint8",
        internalType: "uint8"
      },
      {
        name: "inboundLimit",
        type: "uint256",
        internalType: "uint256"
      }
    ],
    outputs: [],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    name: "setThreshold",
    inputs: [
      {
        name: "threshold",
        type: "uint8",
        internalType: "uint8"
      }
    ],
    outputs: [],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    name: "setTransceiver",
    inputs: [
      {
        name: "transceiver",
        type: "address",
        internalType: "address"
      }
    ],
    outputs: [],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    name: "token",
    inputs: [],
    outputs: [
      {
        name: "",
        type: "address",
        internalType: "address"
      }
    ],
    stateMutability: "view"
  },
  {
    type: "function",
    name: "tokenDecimals",
    inputs: [],
    outputs: [
      {
        name: "",
        type: "uint8",
        internalType: "uint8"
      }
    ],
    stateMutability: "view"
  },
  {
    type: "function",
    name: "transceiverAttestedToMessage",
    inputs: [
      {
        name: "digest",
        type: "bytes32",
        internalType: "bytes32"
      },
      {
        name: "index",
        type: "uint8",
        internalType: "uint8"
      }
    ],
    outputs: [
      {
        name: "",
        type: "bool",
        internalType: "bool"
      }
    ],
    stateMutability: "view"
  },
  {
    type: "function",
    name: "transfer",
    inputs: [
      {
        name: "amount",
        type: "uint256",
        internalType: "uint256"
      },
      {
        name: "recipientChain",
        type: "uint16",
        internalType: "uint16"
      },
      {
        name: "recipient",
        type: "bytes32",
        internalType: "bytes32"
      }
    ],
    outputs: [
      {
        name: "",
        type: "uint64",
        internalType: "uint64"
      }
    ],
    stateMutability: "payable"
  },
  {
    type: "function",
    name: "transfer",
    inputs: [
      {
        name: "amount",
        type: "uint256",
        internalType: "uint256"
      },
      {
        name: "recipientChain",
        type: "uint16",
        internalType: "uint16"
      },
      {
        name: "recipient",
        type: "bytes32",
        internalType: "bytes32"
      },
      {
        name: "refundAddress",
        type: "bytes32",
        internalType: "bytes32"
      },
      {
        name: "shouldQueue",
        type: "bool",
        internalType: "bool"
      },
      {
        name: "transceiverInstructions",
        type: "bytes",
        internalType: "bytes"
      }
    ],
    outputs: [
      {
        name: "",
        type: "uint64",
        internalType: "uint64"
      }
    ],
    stateMutability: "payable"
  },
  {
    type: "function",
    name: "transferOwnership",
    inputs: [
      {
        name: "newOwner",
        type: "address",
        internalType: "address"
      }
    ],
    outputs: [],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    name: "transferPauserCapability",
    inputs: [
      {
        name: "newPauser",
        type: "address",
        internalType: "address"
      }
    ],
    outputs: [],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    name: "unpause",
    inputs: [],
    outputs: [],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    name: "upgrade",
    inputs: [
      {
        name: "newImplementation",
        type: "address",
        internalType: "address"
      }
    ],
    outputs: [],
    stateMutability: "nonpayable"
  },
  {
    type: "event",
    name: "AdminChanged",
    inputs: [
      {
        name: "previousAdmin",
        type: "address",
        indexed: !1,
        internalType: "address"
      },
      {
        name: "newAdmin",
        type: "address",
        indexed: !1,
        internalType: "address"
      }
    ],
    anonymous: !1
  },
  {
    type: "event",
    name: "BeaconUpgraded",
    inputs: [
      {
        name: "beacon",
        type: "address",
        indexed: !0,
        internalType: "address"
      }
    ],
    anonymous: !1
  },
  {
    type: "event",
    name: "InboundTransferQueued",
    inputs: [
      {
        name: "digest",
        type: "bytes32",
        indexed: !1,
        internalType: "bytes32"
      }
    ],
    anonymous: !1
  },
  {
    type: "event",
    name: "Initialized",
    inputs: [
      {
        name: "version",
        type: "uint64",
        indexed: !1,
        internalType: "uint64"
      }
    ],
    anonymous: !1
  },
  {
    type: "event",
    name: "MessageAlreadyExecuted",
    inputs: [
      {
        name: "sourceNttManager",
        type: "bytes32",
        indexed: !0,
        internalType: "bytes32"
      },
      {
        name: "msgHash",
        type: "bytes32",
        indexed: !0,
        internalType: "bytes32"
      }
    ],
    anonymous: !1
  },
  {
    type: "event",
    name: "MessageAttestedTo",
    inputs: [
      {
        name: "digest",
        type: "bytes32",
        indexed: !1,
        internalType: "bytes32"
      },
      {
        name: "transceiver",
        type: "address",
        indexed: !1,
        internalType: "address"
      },
      {
        name: "index",
        type: "uint8",
        indexed: !1,
        internalType: "uint8"
      }
    ],
    anonymous: !1
  },
  {
    type: "event",
    name: "NotPaused",
    inputs: [
      {
        name: "notPaused",
        type: "bool",
        indexed: !1,
        internalType: "bool"
      }
    ],
    anonymous: !1
  },
  {
    type: "event",
    name: "OutboundTransferCancelled",
    inputs: [
      {
        name: "sequence",
        type: "uint256",
        indexed: !1,
        internalType: "uint256"
      },
      {
        name: "recipient",
        type: "address",
        indexed: !1,
        internalType: "address"
      },
      {
        name: "amount",
        type: "uint256",
        indexed: !1,
        internalType: "uint256"
      }
    ],
    anonymous: !1
  },
  {
    type: "event",
    name: "OutboundTransferQueued",
    inputs: [
      {
        name: "queueSequence",
        type: "uint64",
        indexed: !1,
        internalType: "uint64"
      }
    ],
    anonymous: !1
  },
  {
    type: "event",
    name: "OutboundTransferRateLimited",
    inputs: [
      {
        name: "sender",
        type: "address",
        indexed: !0,
        internalType: "address"
      },
      {
        name: "sequence",
        type: "uint64",
        indexed: !1,
        internalType: "uint64"
      },
      {
        name: "amount",
        type: "uint256",
        indexed: !1,
        internalType: "uint256"
      },
      {
        name: "currentCapacity",
        type: "uint256",
        indexed: !1,
        internalType: "uint256"
      }
    ],
    anonymous: !1
  },
  {
    type: "event",
    name: "OwnershipTransferred",
    inputs: [
      {
        name: "previousOwner",
        type: "address",
        indexed: !0,
        internalType: "address"
      },
      {
        name: "newOwner",
        type: "address",
        indexed: !0,
        internalType: "address"
      }
    ],
    anonymous: !1
  },
  {
    type: "event",
    name: "Paused",
    inputs: [
      {
        name: "paused",
        type: "bool",
        indexed: !1,
        internalType: "bool"
      }
    ],
    anonymous: !1
  },
  {
    type: "event",
    name: "PauserTransferred",
    inputs: [
      {
        name: "oldPauser",
        type: "address",
        indexed: !0,
        internalType: "address"
      },
      {
        name: "newPauser",
        type: "address",
        indexed: !0,
        internalType: "address"
      }
    ],
    anonymous: !1
  },
  {
    type: "event",
    name: "PeerUpdated",
    inputs: [
      {
        name: "chainId_",
        type: "uint16",
        indexed: !0,
        internalType: "uint16"
      },
      {
        name: "oldPeerContract",
        type: "bytes32",
        indexed: !1,
        internalType: "bytes32"
      },
      {
        name: "oldPeerDecimals",
        type: "uint8",
        indexed: !1,
        internalType: "uint8"
      },
      {
        name: "peerContract",
        type: "bytes32",
        indexed: !1,
        internalType: "bytes32"
      },
      {
        name: "peerDecimals",
        type: "uint8",
        indexed: !1,
        internalType: "uint8"
      }
    ],
    anonymous: !1
  },
  {
    type: "event",
    name: "ThresholdChanged",
    inputs: [
      {
        name: "oldThreshold",
        type: "uint8",
        indexed: !1,
        internalType: "uint8"
      },
      {
        name: "threshold",
        type: "uint8",
        indexed: !1,
        internalType: "uint8"
      }
    ],
    anonymous: !1
  },
  {
    type: "event",
    name: "TransceiverAdded",
    inputs: [
      {
        name: "transceiver",
        type: "address",
        indexed: !1,
        internalType: "address"
      },
      {
        name: "transceiversNum",
        type: "uint256",
        indexed: !1,
        internalType: "uint256"
      },
      {
        name: "threshold",
        type: "uint8",
        indexed: !1,
        internalType: "uint8"
      }
    ],
    anonymous: !1
  },
  {
    type: "event",
    name: "TransceiverRemoved",
    inputs: [
      {
        name: "transceiver",
        type: "address",
        indexed: !1,
        internalType: "address"
      },
      {
        name: "threshold",
        type: "uint8",
        indexed: !1,
        internalType: "uint8"
      }
    ],
    anonymous: !1
  },
  {
    type: "event",
    name: "TransferRedeemed",
    inputs: [
      {
        name: "digest",
        type: "bytes32",
        indexed: !0,
        internalType: "bytes32"
      }
    ],
    anonymous: !1
  },
  {
    type: "event",
    name: "TransferSent",
    inputs: [
      {
        name: "recipient",
        type: "bytes32",
        indexed: !1,
        internalType: "bytes32"
      },
      {
        name: "refundAddress",
        type: "bytes32",
        indexed: !1,
        internalType: "bytes32"
      },
      {
        name: "amount",
        type: "uint256",
        indexed: !1,
        internalType: "uint256"
      },
      {
        name: "fee",
        type: "uint256",
        indexed: !1,
        internalType: "uint256"
      },
      {
        name: "recipientChain",
        type: "uint16",
        indexed: !1,
        internalType: "uint16"
      },
      {
        name: "msgSequence",
        type: "uint64",
        indexed: !1,
        internalType: "uint64"
      }
    ],
    anonymous: !1
  },
  {
    type: "event",
    name: "Upgraded",
    inputs: [
      {
        name: "implementation",
        type: "address",
        indexed: !0,
        internalType: "address"
      }
    ],
    anonymous: !1
  },
  {
    type: "error",
    name: "BurnAmountDifferentThanBalanceDiff",
    inputs: [
      {
        name: "burnAmount",
        type: "uint256",
        internalType: "uint256"
      },
      {
        name: "balanceDiff",
        type: "uint256",
        internalType: "uint256"
      }
    ]
  },
  {
    type: "error",
    name: "CallerNotTransceiver",
    inputs: [
      {
        name: "caller",
        type: "address",
        internalType: "address"
      }
    ]
  },
  {
    type: "error",
    name: "CancellerNotSender",
    inputs: [
      {
        name: "canceller",
        type: "address",
        internalType: "address"
      },
      {
        name: "sender",
        type: "address",
        internalType: "address"
      }
    ]
  },
  {
    type: "error",
    name: "CapacityCannotExceedLimit",
    inputs: [
      {
        name: "newCurrentCapacity",
        type: "uint72",
        internalType: "TrimmedAmount"
      },
      {
        name: "newLimit",
        type: "uint72",
        internalType: "TrimmedAmount"
      }
    ]
  },
  {
    type: "error",
    name: "DeliveryPaymentTooLow",
    inputs: [
      {
        name: "requiredPayment",
        type: "uint256",
        internalType: "uint256"
      },
      {
        name: "providedPayment",
        type: "uint256",
        internalType: "uint256"
      }
    ]
  },
  {
    type: "error",
    name: "DisabledTransceiver",
    inputs: [
      {
        name: "transceiver",
        type: "address",
        internalType: "address"
      }
    ]
  },
  {
    type: "error",
    name: "InboundQueuedTransferNotFound",
    inputs: [
      {
        name: "digest",
        type: "bytes32",
        internalType: "bytes32"
      }
    ]
  },
  {
    type: "error",
    name: "InboundQueuedTransferStillQueued",
    inputs: [
      {
        name: "digest",
        type: "bytes32",
        internalType: "bytes32"
      },
      {
        name: "transferTimestamp",
        type: "uint256",
        internalType: "uint256"
      }
    ]
  },
  {
    type: "error",
    name: "InvalidFork",
    inputs: [
      {
        name: "evmChainId",
        type: "uint256",
        internalType: "uint256"
      },
      {
        name: "blockChainId",
        type: "uint256",
        internalType: "uint256"
      }
    ]
  },
  {
    type: "error",
    name: "InvalidInitialization",
    inputs: []
  },
  {
    type: "error",
    name: "InvalidMode",
    inputs: [
      {
        name: "mode",
        type: "uint8",
        internalType: "uint8"
      }
    ]
  },
  {
    type: "error",
    name: "InvalidPauser",
    inputs: [
      {
        name: "account",
        type: "address",
        internalType: "address"
      }
    ]
  },
  {
    type: "error",
    name: "InvalidPeer",
    inputs: [
      {
        name: "chainId",
        type: "uint16",
        internalType: "uint16"
      },
      {
        name: "peerAddress",
        type: "bytes32",
        internalType: "bytes32"
      }
    ]
  },
  {
    type: "error",
    name: "InvalidPeerChainIdZero",
    inputs: []
  },
  {
    type: "error",
    name: "InvalidPeerDecimals",
    inputs: []
  },
  {
    type: "error",
    name: "InvalidPeerSameChainId",
    inputs: []
  },
  {
    type: "error",
    name: "InvalidPeerZeroAddress",
    inputs: []
  },
  {
    type: "error",
    name: "InvalidRecipient",
    inputs: []
  },
  {
    type: "error",
    name: "InvalidRefundAddress",
    inputs: []
  },
  {
    type: "error",
    name: "InvalidTargetChain",
    inputs: [
      {
        name: "targetChain",
        type: "uint16",
        internalType: "uint16"
      },
      {
        name: "thisChain",
        type: "uint16",
        internalType: "uint16"
      }
    ]
  },
  {
    type: "error",
    name: "InvalidTransceiverZeroAddress",
    inputs: []
  },
  {
    type: "error",
    name: "MessageNotApproved",
    inputs: [
      {
        name: "msgHash",
        type: "bytes32",
        internalType: "bytes32"
      }
    ]
  },
  {
    type: "error",
    name: "NoEnabledTransceivers",
    inputs: []
  },
  {
    type: "error",
    name: "NonRegisteredTransceiver",
    inputs: [
      {
        name: "transceiver",
        type: "address",
        internalType: "address"
      }
    ]
  },
  {
    type: "error",
    name: "NotAnEvmAddress",
    inputs: [
      {
        name: "",
        type: "bytes32",
        internalType: "bytes32"
      }
    ]
  },
  {
    type: "error",
    name: "NotEnoughCapacity",
    inputs: [
      {
        name: "currentCapacity",
        type: "uint256",
        internalType: "uint256"
      },
      {
        name: "amount",
        type: "uint256",
        internalType: "uint256"
      }
    ]
  },
  {
    type: "error",
    name: "NotInitializing",
    inputs: []
  },
  {
    type: "error",
    name: "NotMigrating",
    inputs: []
  },
  {
    type: "error",
    name: "NumberOfDecimalsNotEqual",
    inputs: [
      {
        name: "decimals",
        type: "uint8",
        internalType: "uint8"
      },
      {
        name: "decimalsOther",
        type: "uint8",
        internalType: "uint8"
      }
    ]
  },
  {
    type: "error",
    name: "OnlyDelegateCall",
    inputs: []
  },
  {
    type: "error",
    name: "OutboundQueuedTransferNotFound",
    inputs: [
      {
        name: "queueSequence",
        type: "uint64",
        internalType: "uint64"
      }
    ]
  },
  {
    type: "error",
    name: "OutboundQueuedTransferStillQueued",
    inputs: [
      {
        name: "queueSequence",
        type: "uint64",
        internalType: "uint64"
      },
      {
        name: "transferTimestamp",
        type: "uint256",
        internalType: "uint256"
      }
    ]
  },
  {
    type: "error",
    name: "OwnableInvalidOwner",
    inputs: [
      {
        name: "owner",
        type: "address",
        internalType: "address"
      }
    ]
  },
  {
    type: "error",
    name: "OwnableUnauthorizedAccount",
    inputs: [
      {
        name: "account",
        type: "address",
        internalType: "address"
      }
    ]
  },
  {
    type: "error",
    name: "PeerNotRegistered",
    inputs: [
      {
        name: "chainId",
        type: "uint16",
        internalType: "uint16"
      }
    ]
  },
  {
    type: "error",
    name: "ReentrancyGuardReentrantCall",
    inputs: []
  },
  {
    type: "error",
    name: "RefundFailed",
    inputs: [
      {
        name: "refundAmount",
        type: "uint256",
        internalType: "uint256"
      }
    ]
  },
  {
    type: "error",
    name: "RequireContractIsNotPaused",
    inputs: []
  },
  {
    type: "error",
    name: "RequireContractIsPaused",
    inputs: []
  },
  {
    type: "error",
    name: "RetrievedIncorrectRegisteredTransceivers",
    inputs: [
      {
        name: "retrieved",
        type: "uint256",
        internalType: "uint256"
      },
      {
        name: "registered",
        type: "uint256",
        internalType: "uint256"
      }
    ]
  },
  {
    type: "error",
    name: "StaticcallFailed",
    inputs: []
  },
  {
    type: "error",
    name: "ThresholdTooHigh",
    inputs: [
      {
        name: "threshold",
        type: "uint256",
        internalType: "uint256"
      },
      {
        name: "transceivers",
        type: "uint256",
        internalType: "uint256"
      }
    ]
  },
  {
    type: "error",
    name: "TooManyTransceivers",
    inputs: []
  },
  {
    type: "error",
    name: "TransceiverAlreadyAttestedToMessage",
    inputs: [
      {
        name: "nttManagerMessageHash",
        type: "bytes32",
        internalType: "bytes32"
      }
    ]
  },
  {
    type: "error",
    name: "TransceiverAlreadyEnabled",
    inputs: [
      {
        name: "transceiver",
        type: "address",
        internalType: "address"
      }
    ]
  },
  {
    type: "error",
    name: "TransferAmountHasDust",
    inputs: [
      {
        name: "amount",
        type: "uint256",
        internalType: "uint256"
      },
      {
        name: "dust",
        type: "uint256",
        internalType: "uint256"
      }
    ]
  },
  {
    type: "error",
    name: "UndefinedRateLimiting",
    inputs: []
  },
  {
    type: "error",
    name: "UnexpectedDeployer",
    inputs: [
      {
        name: "expectedOwner",
        type: "address",
        internalType: "address"
      },
      {
        name: "owner",
        type: "address",
        internalType: "address"
      }
    ]
  },
  {
    type: "error",
    name: "UnexpectedMsgValue",
    inputs: []
  },
  {
    type: "error",
    name: "ZeroAmount",
    inputs: []
  },
  {
    type: "error",
    name: "ZeroThreshold",
    inputs: []
  }
], _bytecode$1 = "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$93083e246e55d56d98f3df2872cd16bfd0$__5af49283156113205788936112f1575b503360005280825261120360ff60406000205460101c168461320e565b6112d85760606112b793927f35a2101eaac94b493e0dfca061f9a7f087913fde8678e7cde0aca9897edba0e592336000528082528a6001600160401b03610100600160481b03604082600160ff836000205460101c161b1693898152600080516020615d8e833981519152875220928354928360081c161760081b1690610100600160481b03191617905533600052815260ff60406000205460101c166040519185835233908301526040820152a16131a1565b6112bf578480f35b546002146106d0576112d09261333e565b388080808480f35b604051631089c4a160e11b815260048101849052602490fd5b9092508181813d8311611319575b6113098183612db6565b810103126105e5575191386111e6565b503d6112ff565b6040513d8a823e3d90fd5b6044908560405191635788c0fd60e11b835260048301526024820152fd5b60405163a0ae911d60e01b8152336004820152602490fd5b5034610277578060031936011261027757602060405161ffff7f0000000000000000000000000000000000000000000000000000000000000000168152f35b506020366003190112610277576001600160401b0360043516908160043503610277576113cb615cfd565b6002600080516020615dce83398151915254146106d05781600052600080516020615eae8339815191526020526040600020916040519261140b84612d2f565b805484526001810154602085015261ffff60028201546001600160481b03811660408701526001600160401b038160481c16606087015260881c16608085015260018060a01b0360038201541660a08501526040518381949060048401549361147385613755565b808552946001811690811561160457506001146115bf575b505061149992500383612db6565b60c083019182526001600160401b03606084015116156115a7576114ca6001600160401b0360608501511642613194565b6001600160401b037f0000000000000000000000000000000000000000000000000000000000000000161161157c579161155991602093600052600080516020615eae833981519152845261152260406000206137a6565b6001600160481b036040830151169161ffff608082015116815190868301519260a0600180821b0391015116935194600435614632565b6001600080516020615ece833981519152556001600160401b0360405191168152f35b6044906001600160401b036060850151166040519163c06cf05f60e01b835260048301526024820152fd5b60249060405190635feafa3160e11b82526004820152fd5b60049193949250018252602082205b8183106115e857505090602061149992820101388061148b565b60209193508060019154838589010152019101909184926115ce565b9150506020925061149994915060ff191682840152151560051b820101388061148b565b5060603660031901126102775761163d612cc3565b604435611648615cfd565b6002600080516020615dce83398151915254146106d05760209181611559926040519261167484612d65565b60018452853681860137600435613808565b5034610277576040366003190112610277576116a0612cb2565b6024356001600160401b0381116117ff576116bf903690600401612df2565b91604051918290600080516020615e0e833981519152828154918287526020809701908652600080516020615d6e83398151915292865b888282106117e05750505061170d92500383612db6565b826117378351966040519788928392635b10743960e11b8452604060048501526044840190612cf7565b906024830152038173__$93083e246e55d56d98f3df2872cd16bfd0$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$93083e246e55d56d98f3df2872cd16bfd0$__5af4938415613625576000946135b0575b5061ffff9283606086015116847f0000000000000000000000000000000000000000000000000000000000000000168082036135955750506133e8614c36565b816134118751928061340c816001600160401b03968760ff82169160081c16615b6c565b615bc7565b960151908160a01c61357e576001600160a01b039182169560007f0000000000000000000000000000000000000000000000000000000000000000831615613577575061345c614d41565b508816600052600080516020615e6e8339815191528452613482612cad84600020615071565b61348c8882615b00565b81808960081c169160081c16105b6134bf57505050506134af6134bd9484615836565b6134b883615716565b614adb565b565b7f7f63c9251d82a933210c2b6d0b0f116252c3c116788120e64e8e8215df6f316297509561355b83959694976001939451926134fa84612d4a565b6001600160481b038091168452898401908242168252888501978852896000527f4e8909a01183a67951f5a6147d6e76ed02ea890c72afea01a9edee91edc609b88b52886000209451166001600160481b0319855416178455511682615a25565b019151166001600160601b0360a01b82541617905551908152a1565b905061349a565b50602491519063033b960d60e41b82526004820152fd5b6044925191631ee5902560e11b835260048301526024820152fd5b6080949194813d821161361d575b816135cb60809383612db6565b810103126106e2578351916135df83612d80565b8151906001600160481b038216820361027757508252848101518583015283810151848301526136119060600161332f565b606082015292386133a8565b3d91506135be565b83513d6000823e3d90fd5b505050565b60405163b3f07bbd60e01b81529193926020918391829161365a919060048401613314565b038173__$93083e246e55d56d98f3df2872cd16bfd0$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$93083e246e55d56d98f3df2872cd16bfd0$__5af49182156105d957600092614a8a575b50614738818388613039565b95863410614a6b5761474a8734613194565b80614a5c575b506040519061475e82612d80565b6001600160481b0386811683527f00000000000000000000000000000000000000000000000000000000000000006001600160a01b03166020840190815260408085018d815261ffff8d81166060880190815292516315cfa3cb60e11b81529651909416600487015291516024860152905160448501525116606483015260008260848173__$93083e246e55d56d98f3df2872cd16bfd0$__5af49182156105d95761485d926000928d928492614a40575b506001600160401b036040519361482685612d4a565b16835260018060a01b031660208301526040820152604051809381926311692f3760e31b83526020600484015260248301906132ed565b038173__$93083e246e55d56d98f3df2872cd16bfd0$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", isSuperArgs$1 = (C) => typeof C[0] == "string" || Array.isArray(C[0]) || "_isInterface" in C[0], ps = class ps extends ContractFactory {
  constructor(...e) {
    if (isSuperArgs$1(e))
      super(...e);
    else {
      const [T, $] = e;
      super(_abi$1, ps.linkBytecode(T), $);
    }
  }
  static linkBytecode(e) {
    let T = _bytecode$1;
    return T = T.replace(new RegExp("__\\$93083e246e55d56d98f3df2872cd16bfd0\\$__", "g"), e["src/libraries/TransceiverStructs.sol:TransceiverStructs"].replace(/^0x/, "").toLowerCase()), T;
  }
  getDeployTransaction(e, T, $, V, J, ee) {
    return super.getDeployTransaction(e, T, $, V, J, ee || {});
  }
  deploy(e, T, $, V, J, ee) {
    return super.deploy(e, T, $, V, J, ee || {});
  }
  connect(e) {
    return super.connect(e);
  }
  static createInterface() {
    return new Interface(_abi$1);
  }
  static connect(e, T) {
    return new Contract(e, _abi$1, T);
  }
};
tt(ps, "bytecode", _bytecode$1), tt(ps, "abi", _abi$1);
let NttManager__factory = ps;
const _abi = [
  {
    type: "constructor",
    inputs: [
      {
        name: "nttManager",
        type: "address",
        internalType: "address"
      },
      {
        name: "wormholeCoreBridge",
        type: "address",
        internalType: "address"
      },
      {
        name: "wormholeRelayerAddr",
        type: "address",
        internalType: "address"
      },
      {
        name: "specialRelayerAddr",
        type: "address",
        internalType: "address"
      },
      {
        name: "_consistencyLevel",
        type: "uint8",
        internalType: "uint8"
      },
      {
        name: "_gasLimit",
        type: "uint256",
        internalType: "uint256"
      }
    ],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    name: "WORMHOLE_TRANSCEIVER_VERSION",
    inputs: [],
    outputs: [
      {
        name: "",
        type: "string",
        internalType: "string"
      }
    ],
    stateMutability: "view"
  },
  {
    type: "function",
    name: "consistencyLevel",
    inputs: [],
    outputs: [
      {
        name: "",
        type: "uint8",
        internalType: "uint8"
      }
    ],
    stateMutability: "view"
  },
  {
    type: "function",
    name: "encodeWormholeTransceiverInstruction",
    inputs: [
      {
        name: "instruction",
        type: "tuple",
        internalType: "struct IWormholeTransceiver.WormholeTransceiverInstruction",
        components: [
          {
            name: "shouldSkipRelayerSend",
            type: "bool",
            internalType: "bool"
          }
        ]
      }
    ],
    outputs: [
      {
        name: "",
        type: "bytes",
        internalType: "bytes"
      }
    ],
    stateMutability: "pure"
  },
  {
    type: "function",
    name: "gasLimit",
    inputs: [],
    outputs: [
      {
        name: "",
        type: "uint256",
        internalType: "uint256"
      }
    ],
    stateMutability: "view"
  },
  {
    type: "function",
    name: "getMigratesImmutables",
    inputs: [],
    outputs: [
      {
        name: "",
        type: "bool",
        internalType: "bool"
      }
    ],
    stateMutability: "view"
  },
  {
    type: "function",
    name: "getNttManagerOwner",
    inputs: [],
    outputs: [
      {
        name: "",
        type: "address",
        internalType: "address"
      }
    ],
    stateMutability: "view"
  },
  {
    type: "function",
    name: "getNttManagerToken",
    inputs: [],
    outputs: [
      {
        name: "",
        type: "address",
        internalType: "address"
      }
    ],
    stateMutability: "view"
  },
  {
    type: "function",
    name: "getTransceiverType",
    inputs: [],
    outputs: [
      {
        name: "",
        type: "string",
        internalType: "string"
      }
    ],
    stateMutability: "pure"
  },
  {
    type: "function",
    name: "getWormholePeer",
    inputs: [
      {
        name: "chainId",
        type: "uint16",
        internalType: "uint16"
      }
    ],
    outputs: [
      {
        name: "",
        type: "bytes32",
        internalType: "bytes32"
      }
    ],
    stateMutability: "view"
  },
  {
    type: "function",
    name: "initialize",
    inputs: [],
    outputs: [],
    stateMutability: "payable"
  },
  {
    type: "function",
    name: "isPaused",
    inputs: [],
    outputs: [
      {
        name: "",
        type: "bool",
        internalType: "bool"
      }
    ],
    stateMutability: "view"
  },
  {
    type: "function",
    name: "isSpecialRelayingEnabled",
    inputs: [
      {
        name: "chainId",
        type: "uint16",
        internalType: "uint16"
      }
    ],
    outputs: [
      {
        name: "",
        type: "bool",
        internalType: "bool"
      }
    ],
    stateMutability: "view"
  },
  {
    type: "function",
    name: "isVAAConsumed",
    inputs: [
      {
        name: "hash",
        type: "bytes32",
        internalType: "bytes32"
      }
    ],
    outputs: [
      {
        name: "",
        type: "bool",
        internalType: "bool"
      }
    ],
    stateMutability: "view"
  },
  {
    type: "function",
    name: "isWormholeEvmChain",
    inputs: [
      {
        name: "chainId",
        type: "uint16",
        internalType: "uint16"
      }
    ],
    outputs: [
      {
        name: "",
        type: "bool",
        internalType: "bool"
      }
    ],
    stateMutability: "view"
  },
  {
    type: "function",
    name: "isWormholeRelayingEnabled",
    inputs: [
      {
        name: "chainId",
        type: "uint16",
        internalType: "uint16"
      }
    ],
    outputs: [
      {
        name: "",
        type: "bool",
        internalType: "bool"
      }
    ],
    stateMutability: "view"
  },
  {
    type: "function",
    name: "migrate",
    inputs: [],
    outputs: [],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    name: "nttManager",
    inputs: [],
    outputs: [
      {
        name: "",
        type: "address",
        internalType: "address"
      }
    ],
    stateMutability: "view"
  },
  {
    type: "function",
    name: "nttManagerToken",
    inputs: [],
    outputs: [
      {
        name: "",
        type: "address",
        internalType: "address"
      }
    ],
    stateMutability: "view"
  },
  {
    type: "function",
    name: "owner",
    inputs: [],
    outputs: [
      {
        name: "",
        type: "address",
        internalType: "address"
      }
    ],
    stateMutability: "view"
  },
  {
    type: "function",
    name: "parseWormholeTransceiverInstruction",
    inputs: [
      {
        name: "encoded",
        type: "bytes",
        internalType: "bytes"
      }
    ],
    outputs: [
      {
        name: "instruction",
        type: "tuple",
        internalType: "struct IWormholeTransceiver.WormholeTransceiverInstruction",
        components: [
          {
            name: "shouldSkipRelayerSend",
            type: "bool",
            internalType: "bool"
          }
        ]
      }
    ],
    stateMutability: "pure"
  },
  {
    type: "function",
    name: "pauser",
    inputs: [],
    outputs: [
      {
        name: "",
        type: "address",
        internalType: "address"
      }
    ],
    stateMutability: "view"
  },
  {
    type: "function",
    name: "quoteDeliveryPrice",
    inputs: [
      {
        name: "targetChain",
        type: "uint16",
        internalType: "uint16"
      },
      {
        name: "instruction",
        type: "tuple",
        internalType: "struct TransceiverStructs.TransceiverInstruction",
        components: [
          {
            name: "index",
            type: "uint8",
            internalType: "uint8"
          },
          {
            name: "payload",
            type: "bytes",
            internalType: "bytes"
          }
        ]
      }
    ],
    outputs: [
      {
        name: "",
        type: "uint256",
        internalType: "uint256"
      }
    ],
    stateMutability: "view"
  },
  {
    type: "function",
    name: "receiveMessage",
    inputs: [
      {
        name: "encodedMessage",
        type: "bytes",
        internalType: "bytes"
      }
    ],
    outputs: [],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    name: "receiveWormholeMessages",
    inputs: [
      {
        name: "payload",
        type: "bytes",
        internalType: "bytes"
      },
      {
        name: "additionalMessages",
        type: "bytes[]",
        internalType: "bytes[]"
      },
      {
        name: "sourceAddress",
        type: "bytes32",
        internalType: "bytes32"
      },
      {
        name: "sourceChain",
        type: "uint16",
        internalType: "uint16"
      },
      {
        name: "deliveryHash",
        type: "bytes32",
        internalType: "bytes32"
      }
    ],
    outputs: [],
    stateMutability: "payable"
  },
  {
    type: "function",
    name: "sendMessage",
    inputs: [
      {
        name: "recipientChain",
        type: "uint16",
        internalType: "uint16"
      },
      {
        name: "instruction",
        type: "tuple",
        internalType: "struct TransceiverStructs.TransceiverInstruction",
        components: [
          {
            name: "index",
            type: "uint8",
            internalType: "uint8"
          },
          {
            name: "payload",
            type: "bytes",
            internalType: "bytes"
          }
        ]
      },
      {
        name: "nttManagerMessage",
        type: "bytes",
        internalType: "bytes"
      },
      {
        name: "recipientNttManagerAddress",
        type: "bytes32",
        internalType: "bytes32"
      },
      {
        name: "refundAddress",
        type: "bytes32",
        internalType: "bytes32"
      }
    ],
    outputs: [],
    stateMutability: "payable"
  },
  {
    type: "function",
    name: "setIsSpecialRelayingEnabled",
    inputs: [
      {
        name: "chainId",
        type: "uint16",
        internalType: "uint16"
      },
      {
        name: "isEnabled",
        type: "bool",
        internalType: "bool"
      }
    ],
    outputs: [],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    name: "setIsWormholeEvmChain",
    inputs: [
      {
        name: "chainId",
        type: "uint16",
        internalType: "uint16"
      },
      {
        name: "isEvm",
        type: "bool",
        internalType: "bool"
      }
    ],
    outputs: [],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    name: "setIsWormholeRelayingEnabled",
    inputs: [
      {
        name: "chainId",
        type: "uint16",
        internalType: "uint16"
      },
      {
        name: "isEnabled",
        type: "bool",
        internalType: "bool"
      }
    ],
    outputs: [],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    name: "setWormholePeer",
    inputs: [
      {
        name: "peerChainId",
        type: "uint16",
        internalType: "uint16"
      },
      {
        name: "peerContract",
        type: "bytes32",
        internalType: "bytes32"
      }
    ],
    outputs: [],
    stateMutability: "payable"
  },
  {
    type: "function",
    name: "specialRelayer",
    inputs: [],
    outputs: [
      {
        name: "",
        type: "address",
        internalType: "contract ISpecialRelayer"
      }
    ],
    stateMutability: "view"
  },
  {
    type: "function",
    name: "transferOwnership",
    inputs: [
      {
        name: "newOwner",
        type: "address",
        internalType: "address"
      }
    ],
    outputs: [],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    name: "transferPauserCapability",
    inputs: [
      {
        name: "newPauser",
        type: "address",
        internalType: "address"
      }
    ],
    outputs: [],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    name: "transferTransceiverOwnership",
    inputs: [
      {
        name: "newOwner",
        type: "address",
        internalType: "address"
      }
    ],
    outputs: [],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    name: "upgrade",
    inputs: [
      {
        name: "newImplementation",
        type: "address",
        internalType: "address"
      }
    ],
    outputs: [],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    name: "wormhole",
    inputs: [],
    outputs: [
      {
        name: "",
        type: "address",
        internalType: "contract IWormhole"
      }
    ],
    stateMutability: "view"
  },
  {
    type: "function",
    name: "wormholeRelayer",
    inputs: [],
    outputs: [
      {
        name: "",
        type: "address",
        internalType: "contract IWormholeRelayer"
      }
    ],
    stateMutability: "view"
  },
  {
    type: "event",
    name: "AdminChanged",
    inputs: [
      {
        name: "previousAdmin",
        type: "address",
        indexed: !1,
        internalType: "address"
      },
      {
        name: "newAdmin",
        type: "address",
        indexed: !1,
        internalType: "address"
      }
    ],
    anonymous: !1
  },
  {
    type: "event",
    name: "BeaconUpgraded",
    inputs: [
      {
        name: "beacon",
        type: "address",
        indexed: !0,
        internalType: "address"
      }
    ],
    anonymous: !1
  },
  {
    type: "event",
    name: "Initialized",
    inputs: [
      {
        name: "version",
        type: "uint64",
        indexed: !1,
        internalType: "uint64"
      }
    ],
    anonymous: !1
  },
  {
    type: "event",
    name: "NotPaused",
    inputs: [
      {
        name: "notPaused",
        type: "bool",
        indexed: !1,
        internalType: "bool"
      }
    ],
    anonymous: !1
  },
  {
    type: "event",
    name: "OwnershipTransferred",
    inputs: [
      {
        name: "previousOwner",
        type: "address",
        indexed: !0,
        internalType: "address"
      },
      {
        name: "newOwner",
        type: "address",
        indexed: !0,
        internalType: "address"
      }
    ],
    anonymous: !1
  },
  {
    type: "event",
    name: "Paused",
    inputs: [
      {
        name: "paused",
        type: "bool",
        indexed: !1,
        internalType: "bool"
      }
    ],
    anonymous: !1
  },
  {
    type: "event",
    name: "PauserTransferred",
    inputs: [
      {
        name: "oldPauser",
        type: "address",
        indexed: !0,
        internalType: "address"
      },
      {
        name: "newPauser",
        type: "address",
        indexed: !0,
        internalType: "address"
      }
    ],
    anonymous: !1
  },
  {
    type: "event",
    name: "ReceivedMessage",
    inputs: [
      {
        name: "digest",
        type: "bytes32",
        indexed: !1,
        internalType: "bytes32"
      },
      {
        name: "emitterChainId",
        type: "uint16",
        indexed: !1,
        internalType: "uint16"
      },
      {
        name: "emitterAddress",
        type: "bytes32",
        indexed: !1,
        internalType: "bytes32"
      },
      {
        name: "sequence",
        type: "uint64",
        indexed: !1,
        internalType: "uint64"
      }
    ],
    anonymous: !1
  },
  {
    type: "event",
    name: "ReceivedRelayedMessage",
    inputs: [
      {
        name: "digest",
        type: "bytes32",
        indexed: !1,
        internalType: "bytes32"
      },
      {
        name: "emitterChainId",
        type: "uint16",
        indexed: !1,
        internalType: "uint16"
      },
      {
        name: "emitterAddress",
        type: "bytes32",
        indexed: !1,
        internalType: "bytes32"
      }
    ],
    anonymous: !1
  },
  {
    type: "event",
    name: "RelayingInfo",
    inputs: [
      {
        name: "relayingType",
        type: "uint8",
        indexed: !1,
        internalType: "uint8"
      },
      {
        name: "refundAddress",
        type: "bytes32",
        indexed: !1,
        internalType: "bytes32"
      },
      {
        name: "deliveryPayment",
        type: "uint256",
        indexed: !1,
        internalType: "uint256"
      }
    ],
    anonymous: !1
  },
  {
    type: "event",
    name: "SendTransceiverMessage",
    inputs: [
      {
        name: "recipientChain",
        type: "uint16",
        indexed: !1,
        internalType: "uint16"
      },
      {
        name: "message",
        type: "tuple",
        indexed: !1,
        internalType: "struct TransceiverStructs.TransceiverMessage",
        components: [
          {
            name: "sourceNttManagerAddress",
            type: "bytes32",
            internalType: "bytes32"
          },
          {
            name: "recipientNttManagerAddress",
            type: "bytes32",
            internalType: "bytes32"
          },
          {
            name: "nttManagerPayload",
            type: "bytes",
            internalType: "bytes"
          },
          {
            name: "transceiverPayload",
            type: "bytes",
            internalType: "bytes"
          }
        ]
      }
    ],
    anonymous: !1
  },
  {
    type: "event",
    name: "SetIsSpecialRelayingEnabled",
    inputs: [
      {
        name: "chainId",
        type: "uint16",
        indexed: !1,
        internalType: "uint16"
      },
      {
        name: "isRelayingEnabled",
        type: "bool",
        indexed: !1,
        internalType: "bool"
      }
    ],
    anonymous: !1
  },
  {
    type: "event",
    name: "SetIsWormholeEvmChain",
    inputs: [
      {
        name: "chainId",
        type: "uint16",
        indexed: !1,
        internalType: "uint16"
      },
      {
        name: "isEvm",
        type: "bool",
        indexed: !1,
        internalType: "bool"
      }
    ],
    anonymous: !1
  },
  {
    type: "event",
    name: "SetIsWormholeRelayingEnabled",
    inputs: [
      {
        name: "chainId",
        type: "uint16",
        indexed: !1,
        internalType: "uint16"
      },
      {
        name: "isRelayingEnabled",
        type: "bool",
        indexed: !1,
        internalType: "bool"
      }
    ],
    anonymous: !1
  },
  {
    type: "event",
    name: "SetWormholePeer",
    inputs: [
      {
        name: "chainId",
        type: "uint16",
        indexed: !1,
        internalType: "uint16"
      },
      {
        name: "peerContract",
        type: "bytes32",
        indexed: !1,
        internalType: "bytes32"
      }
    ],
    anonymous: !1
  },
  {
    type: "event",
    name: "Upgraded",
    inputs: [
      {
        name: "implementation",
        type: "address",
        indexed: !0,
        internalType: "address"
      }
    ],
    anonymous: !1
  },
  {
    type: "error",
    name: "CallerNotNttManager",
    inputs: [
      {
        name: "caller",
        type: "address",
        internalType: "address"
      }
    ]
  },
  {
    type: "error",
    name: "CallerNotRelayer",
    inputs: [
      {
        name: "caller",
        type: "address",
        internalType: "address"
      }
    ]
  },
  {
    type: "error",
    name: "CannotRenounceTransceiverOwnership",
    inputs: [
      {
        name: "currentOwner",
        type: "address",
        internalType: "address"
      }
    ]
  },
  {
    type: "error",
    name: "CannotTransferTransceiverOwnership",
    inputs: [
      {
        name: "currentOwner",
        type: "address",
        internalType: "address"
      },
      {
        name: "newOwner",
        type: "address",
        internalType: "address"
      }
    ]
  },
  {
    type: "error",
    name: "InvalidBoolVal",
    inputs: [
      {
        name: "val",
        type: "uint8",
        internalType: "uint8"
      }
    ]
  },
  {
    type: "error",
    name: "InvalidBoolValue",
    inputs: [
      {
        name: "value",
        type: "uint256",
        internalType: "BooleanFlag"
      }
    ]
  },
  {
    type: "error",
    name: "InvalidFork",
    inputs: [
      {
        name: "evmChainId",
        type: "uint256",
        internalType: "uint256"
      },
      {
        name: "blockChainId",
        type: "uint256",
        internalType: "uint256"
      }
    ]
  },
  {
    type: "error",
    name: "InvalidInitialization",
    inputs: []
  },
  {
    type: "error",
    name: "InvalidPauser",
    inputs: [
      {
        name: "account",
        type: "address",
        internalType: "address"
      }
    ]
  },
  {
    type: "error",
    name: "InvalidRelayingConfig",
    inputs: [
      {
        name: "chainId",
        type: "uint16",
        internalType: "uint16"
      }
    ]
  },
  {
    type: "error",
    name: "InvalidVaa",
    inputs: [
      {
        name: "reason",
        type: "string",
        internalType: "string"
      }
    ]
  },
  {
    type: "error",
    name: "InvalidWormholeChainIdZero",
    inputs: []
  },
  {
    type: "error",
    name: "InvalidWormholePeer",
    inputs: [
      {
        name: "chainId",
        type: "uint16",
        internalType: "uint16"
      },
      {
        name: "peerAddress",
        type: "bytes32",
        internalType: "bytes32"
      }
    ]
  },
  {
    type: "error",
    name: "InvalidWormholePeerZeroAddress",
    inputs: []
  },
  {
    type: "error",
    name: "LengthMismatch",
    inputs: [
      {
        name: "encodedLength",
        type: "uint256",
        internalType: "uint256"
      },
      {
        name: "expectedLength",
        type: "uint256",
        internalType: "uint256"
      }
    ]
  },
  {
    type: "error",
    name: "NotAnEvmAddress",
    inputs: [
      {
        name: "",
        type: "bytes32",
        internalType: "bytes32"
      }
    ]
  },
  {
    type: "error",
    name: "NotInitializing",
    inputs: []
  },
  {
    type: "error",
    name: "NotMigrating",
    inputs: []
  },
  {
    type: "error",
    name: "OnlyDelegateCall",
    inputs: []
  },
  {
    type: "error",
    name: "OwnableInvalidOwner",
    inputs: [
      {
        name: "owner",
        type: "address",
        internalType: "address"
      }
    ]
  },
  {
    type: "error",
    name: "OwnableUnauthorizedAccount",
    inputs: [
      {
        name: "account",
        type: "address",
        internalType: "address"
      }
    ]
  },
  {
    type: "error",
    name: "PeerAlreadySet",
    inputs: [
      {
        name: "chainId",
        type: "uint16",
        internalType: "uint16"
      },
      {
        name: "peerAddress",
        type: "bytes32",
        internalType: "bytes32"
      }
    ]
  },
  {
    type: "error",
    name: "ReentrancyGuardReentrantCall",
    inputs: []
  },
  {
    type: "error",
    name: "RequireContractIsNotPaused",
    inputs: []
  },
  {
    type: "error",
    name: "RequireContractIsPaused",
    inputs: []
  },
  {
    type: "error",
    name: "TransferAlreadyCompleted",
    inputs: [
      {
        name: "vaaHash",
        type: "bytes32",
        internalType: "bytes32"
      }
    ]
  },
  {
    type: "error",
    name: "UnexpectedAdditionalMessages",
    inputs: []
  },
  {
    type: "error",
    name: "UnexpectedDeployer",
    inputs: [
      {
        name: "deployer",
        type: "address",
        internalType: "address"
      },
      {
        name: "caller",
        type: "address",
        internalType: "address"
      }
    ]
  },
  {
    type: "error",
    name: "UnexpectedRecipientNttManagerAddress",
    inputs: [
      {
        name: "recipientNttManagerAddress",
        type: "bytes32",
        internalType: "bytes32"
      },
      {
        name: "expectedRecipientNttManagerAddress",
        type: "bytes32",
        internalType: "bytes32"
      }
    ]
  }
], _bytecode = "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__$93083e246e55d56d98f3df2872cd16bfd0$__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__$93083e246e55d56d98f3df2872cd16bfd0$__5af49081156110535791610f74939187938a91611031575b5086518095819482936358cd21bf60e11b84527f0000000000000000000000000000000000000000000000000000000000000000918401612fff565b039134907f0000000000000000000000000000000000000000000000000000000000000000165af1801561102757610fef575b50610fb0578380f35b7fc7f505b2f371ae2175ee4913f4499e1f2633a7b5936321eed1cdaeb6115181d29268ff00000000000000001981541690555160018152a13880808380f35b8381813d8311611020575b6110048183612762565b8101031261101c5761101590612feb565b5038610fa7565b8580fd5b503d610ffa565b83513d88823e3d90fd5b61104d91503d808c833e6110458183612762565b81019061307f565b38610f38565b85513d8a823e3d90fd5b9092508881813d831161108d575b6110758183612762565b810103126106625761108690613053565b9138610e69565b503d61106b565b88513d8d823e3d90fd5b9091508781813d83116110ce575b6110b68183612762565b81010312610603576110c790613053565b9038610e46565b503d6110ac565b87513d8c823e3d90fd5b82604491865191636345072160e11b8352820152336024820152fd5b68ffffffffffffffffff19166801000000000000000117855538610d0d565b50825163f92ee8a960e01b8152fd5b90501538610cf1565b303b159150610ce9565b849150610cdf565b5091346106895760203660031901126106895750610716602092356000526000805160206132db83398151915260205260ff6040600020541690565b5081600319360112610690576111946126bc565b602435916111a061320b565b61ffff8083169081156113cb5784156113bb57816000526000805160206132bb8339815191529160209280845287600020548061139257508160005283528587600020558651916111f083612711565b630c7e33e160e11b8352838301918252878301878152885163077650fb60e51b815293516001600160e01b031916868501529151166024830152516044820152868160648173__$93083e246e55d56d98f3df2872cd16bfd0$__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__$93083e246e55d56d98f3df2872cd16bfd0$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", isSuperArgs = (C) => typeof C[0] == "string" || Array.isArray(C[0]) || "_isInterface" in C[0], hs = class hs extends ContractFactory {
  constructor(...e) {
    if (isSuperArgs(e))
      super(...e);
    else {
      const [T, $] = e;
      super(_abi, hs.linkBytecode(T), $);
    }
  }
  static linkBytecode(e) {
    let T = _bytecode;
    return T = T.replace(new RegExp("__\\$93083e246e55d56d98f3df2872cd16bfd0\\$__", "g"), e["src/libraries/TransceiverStructs.sol:TransceiverStructs"].replace(/^0x/, "").toLowerCase()), T;
  }
  getDeployTransaction(e, T, $, V, J, ee, te) {
    return super.getDeployTransaction(e, T, $, V, J, ee, te || {});
  }
  deploy(e, T, $, V, J, ee, te) {
    return super.deploy(e, T, $, V, J, ee, te || {});
  }
  connect(e) {
    return super.connect(e);
  }
  static createInterface() {
    return new Interface(_abi);
  }
  static connect(e, T) {
    return new Contract(e, _abi, T);
  }
};
tt(hs, "bytecode", _bytecode), tt(hs, "abi", _abi);
let WormholeTransceiver__factory = hs;
const _0_1_0 = {
  NttManager: {
    connect: NttManager__factory$2.connect
  },
  NttTransceiver: {
    connect: WormholeTransceiver__factory$2.connect
  }
}, _1_0_0$1 = {
  NttManager: {
    connect: NttManager__factory$1.connect
  },
  NttTransceiver: {
    connect: WormholeTransceiver__factory$1.connect
  }
}, _1_1_0 = {
  NttManager: {
    connect: NttManager__factory.connect
  },
  NttTransceiver: {
    connect: WormholeTransceiver__factory.connect
  }
}, abiVersions = [
  ["1.1.0", _1_1_0],
  ["1.0.0", _1_0_0$1],
  ["0.1.0", _0_1_0]
];
function loadAbiVersion(C) {
  for (const [e, T] of abiVersions)
    if (Ntt.abiVersionMatches(C, e))
      return T;
  throw new Error(`Unknown ABI version: ${C}`);
}
class EvmNttWormholeTranceiver {
  constructor(e, T, $) {
    tt(this, "manager");
    tt(this, "address");
    tt(this, "transceiver");
    this.manager = e, this.address = T, this.transceiver = $.NttTransceiver.connect(T, e.provider);
  }
  async getTransceiverType() {
    return "wormhole";
  }
  getAddress() {
    return {
      chain: this.manager.chain,
      address: toUniversal(this.manager.chain, this.address)
    };
  }
  encodeFlags(e) {
    return new Uint8Array([e.skipRelay ? 1 : 0]);
  }
  async *setPeer(e) {
    const T = await this.transceiver.setWormholePeer.populateTransaction(toChainId(e.chain), universalAddress(e));
    yield this.manager.createUnsignedTx(T, "WormholeTransceiver.registerPeer");
  }
  async getPauser() {
    const e = await this.transceiver.pauser();
    return new EvmAddress(e);
  }
  async *setPauser(e) {
    const T = canonicalAddress({
      chain: this.manager.chain,
      address: e
    }), $ = await this.transceiver.transferPauserCapability.populateTransaction(T);
    yield this.manager.createUnsignedTx($, "WormholeTransceiver.setPauser");
  }
  async getPeer(e) {
    const T = await this.transceiver.getWormholePeer(toChainId(e)), $ = hex$1.decode(T), V = new Uint8Array(32);
    return bytes.equals(V, $) ? null : {
      chain: e,
      address: toUniversal(e, $)
    };
  }
  async isEvmChain(e) {
    return await this.transceiver.isWormholeEvmChain(toChainId(e));
  }
  async *setIsEvmChain(e, T) {
    const $ = await this.transceiver.setIsWormholeEvmChain.populateTransaction(toChainId(e), T);
    yield this.manager.createUnsignedTx($, "WormholeTransceiver.setIsEvmChain");
  }
  async *receive(e) {
    const T = await this.transceiver.receiveMessage.populateTransaction(serialize$1(e));
    yield this.manager.createUnsignedTx(T, "WormholeTransceiver.receiveMessage");
  }
  async isWormholeRelayingEnabled(e) {
    return await this.transceiver.isWormholeRelayingEnabled(toChainId(e));
  }
  async *setIsWormholeRelayingEnabled(e, T) {
    const $ = await this.transceiver.setIsWormholeRelayingEnabled.populateTransaction(toChainId(e), T);
    yield this.manager.createUnsignedTx($, "WormholeTransceiver.setWormholeRelayingEnabled");
  }
  async isSpecialRelayingEnabled(e) {
    return await this.transceiver.isSpecialRelayingEnabled(toChainId(e));
  }
  async *setIsSpecialRelayingEnabled(e, T) {
    const $ = await this.transceiver.setIsSpecialRelayingEnabled.populateTransaction(toChainId(e), T);
    yield this.manager.createUnsignedTx($, "WormholeTransceiver.setSpecialRelayingEnabled");
  }
}
class EvmNtt {
  constructor(e, T, $, V, J = "1.0.0") {
    tt(this, "network");
    tt(this, "chain");
    tt(this, "provider");
    tt(this, "contracts");
    tt(this, "version");
    tt(this, "tokenAddress");
    tt(this, "chainId");
    tt(this, "manager");
    tt(this, "xcvrs");
    tt(this, "managerAddress");
    if (this.network = e, this.chain = T, this.provider = $, this.contracts = V, this.version = J, !V.ntt)
      throw new Error("No Ntt Contracts provided");
    this.chainId = networkChainToNativeChainId.get(e, T), this.tokenAddress = V.ntt.token, this.managerAddress = V.ntt.manager;
    const ee = loadAbiVersion(this.version);
    this.manager = ee.NttManager.connect(V.ntt.manager, this.provider), this.xcvrs = [], "wormhole" in V.ntt.transceiver && V.ntt.transceiver.wormhole && [
      "wormhole",
      // wormhole xcvr should be ix 0
      ...Object.keys(V.ntt.transceiver).filter((re) => {
      })
    ].map((re) => {
      if (re !== "wormhole")
        throw new Error(`Unsupported transceiver type: ${re}`);
      this.xcvrs.push(new EvmNttWormholeTranceiver(this, V.ntt.transceiver[re], ee));
    });
  }
  async getTransceiver(e) {
    return this.xcvrs[e] || null;
  }
  async getMode() {
    return await this.manager.getMode() === 0n ? "locking" : "burning";
  }
  async isPaused() {
    return await this.manager.isPaused();
  }
  async *pause() {
    const e = await this.manager.pause.populateTransaction();
    yield this.createUnsignedTx(e, "Ntt.pause");
  }
  async *unpause() {
    const e = await this.manager.unpause.populateTransaction();
    yield this.createUnsignedTx(e, "Ntt.unpause");
  }
  async getOwner() {
    return new EvmAddress(await this.manager.owner());
  }
  async getPauser() {
    return new EvmAddress(await this.manager.pauser());
  }
  async *setOwner(e) {
    const T = new EvmAddress(e).toString(), $ = await this.manager.transferOwnership.populateTransaction(T);
    yield this.createUnsignedTx($, "Ntt.setOwner");
  }
  async *setPauser(e) {
    const T = new EvmAddress(e).toString(), $ = await this.manager.transferPauserCapability.populateTransaction(T);
    yield this.createUnsignedTx($, "Ntt.setPauser");
  }
  async getThreshold() {
    return Number(await this.manager.getThreshold());
  }
  async isRelayingAvailable(e) {
    return (await Promise.all(this.xcvrs.map(async ($) => {
      const [V, J] = await Promise.all([
        $.isWormholeRelayingEnabled(e),
        $.isSpecialRelayingEnabled(e)
      ]);
      return V || J;
    }))).filter(($) => $).length > 0;
  }
  async getIsExecuted(e) {
    const T = e.payloadName === "WormholeTransfer" ? e.payload : e.payload.payload;
    return await this.manager.isMessageExecuted(Ntt.messageDigest(e.emitterChain, T.nttManagerPayload)) ? !await this.getIsTransferInboundQueued(e) : !1;
  }
  async getIsTransferInboundQueued(e) {
    const T = e.payloadName === "WormholeTransfer" ? e.payload : e.payload.payload;
    return await this.getInboundQueuedTransfer(e.emitterChain, T.nttManagerPayload) !== null;
  }
  getIsApproved(e) {
    const T = e.payloadName === "WormholeTransfer" ? e.payload : e.payload.payload;
    return this.manager.isMessageApproved(Ntt.messageDigest(e.emitterChain, T.nttManagerPayload));
  }
  async getTokenDecimals() {
    return await EvmPlatform.getDecimals(this.chain, this.provider, this.tokenAddress);
  }
  async getPeer(e) {
    const T = await this.manager.getPeer(toChainId(e)), $ = hex$1.decode(T.peerAddress), V = new Uint8Array(32);
    return bytes.equals(V, $) ? null : {
      address: { chain: e, address: toUniversal(e, $) },
      tokenDecimals: Number(T.tokenDecimals),
      inboundLimit: await this.getInboundLimit(e)
    };
  }
  static async fromRpc(e, T) {
    const [$, V] = await EvmPlatform.chainFromRpc(e), J = T[V];
    if (J.network !== $)
      throw new Error(`Network mismatch: ${J.network} != ${$}`);
    const ee = await EvmNtt.getVersion(e, J.contracts);
    return new EvmNtt($, V, e, J.contracts, ee);
  }
  encodeOptions(e) {
    const T = [];
    return T.push({
      index: 0,
      payload: this.xcvrs[0].encodeFlags({ skipRelay: !e.automatic })
    }), T;
  }
  static async getVersion(e, T) {
    var V;
    const $ = new Contract(T.ntt.manager, ["function NTT_MANAGER_VERSION() public view returns (string)"], e);
    try {
      const J = await $.getFunction("NTT_MANAGER_VERSION").staticCall();
      if (!J)
        throw new Error("NTT_MANAGER_VERSION not found");
      return J;
    } catch (J) {
      throw console.error(`Failed to get NTT_MANAGER_VERSION from contract ${(V = T.ntt) == null ? void 0 : V.manager}`), J;
    }
  }
  async getCustodyAddress() {
    return this.managerAddress;
  }
  async quoteDeliveryPrice(e, T) {
    const [, $] = await this.manager.quoteDeliveryPrice(toChainId(e), Ntt.encodeTransceiverInstructions(this.encodeOptions(T)));
    return $;
  }
  async *setPeer(e, T, $) {
    const V = await this.manager.setPeer.populateTransaction(toChainId(e.chain), universalAddress(e), T, $);
    yield this.createUnsignedTx(V, "Ntt.setPeer");
  }
  async *setWormholeTransceiverPeer(e) {
    yield* this.setTransceiverPeer(0, e);
  }
  async *setTransceiverPeer(e, T) {
    if (e >= this.xcvrs.length)
      throw new Error("Transceiver not found");
    yield* this.xcvrs[e].setPeer(T);
  }
  async *transfer(e, T, $, V) {
    const J = new EvmAddress(e).toString(), ee = await this.quoteDeliveryPrice($.chain, V), te = EvmPlatform.getTokenImplementation(this.provider, this.tokenAddress);
    if (await te.allowance(J, this.managerAddress) < T) {
      const de = await te.approve.populateTransaction(this.managerAddress, T);
      yield this.createUnsignedTx(addFrom(de, J), "Ntt.Approve");
    }
    const ie = universalAddress($), se = await this.manager.getFunction("transfer(uint256,uint16,bytes32,bytes32,bool,bytes)").populateTransaction(T, toChainId($.chain), ie, ie, V.queue, Ntt.encodeTransceiverInstructions(this.encodeOptions(V)), { value: ee });
    yield this.createUnsignedTx(addFrom(se, J), "Ntt.transfer");
  }
  // TODO: should this be some map of idx to transceiver?
  async *redeem(e) {
    if (e.length !== this.xcvrs.length)
      throw new Error("Not enough attestations for the registered Transceivers");
    for (const T in this.xcvrs) {
      const $ = this.xcvrs[T], V = e[T];
      if ((V == null ? void 0 : V.payloadName) !== "WormholeTransfer")
        throw new Error("Invalid attestation type for redeem");
      yield* $.receive(V);
    }
  }
  async getCurrentOutboundCapacity() {
    return await this.manager.getCurrentOutboundCapacity();
  }
  async getOutboundLimit() {
    const e = (await this.manager.getOutboundLimitParams()).limit, T = decodeTrimmedAmount(e), $ = await this.getTokenDecimals();
    return untrim(T, $);
  }
  async *setOutboundLimit(e) {
    const T = await this.manager.setOutboundLimit.populateTransaction(e);
    yield this.createUnsignedTx(T, "Ntt.setOutboundLimit");
  }
  async getCurrentInboundCapacity(e) {
    return await this.manager.getCurrentInboundCapacity(toChainId(e));
  }
  async getInboundLimit(e) {
    const T = (await this.manager.getInboundLimitParams(toChainId(e))).limit, $ = decodeTrimmedAmount(T), V = await this.getTokenDecimals();
    return untrim($, V);
  }
  async *setInboundLimit(e, T) {
    const $ = await this.manager.setInboundLimit.populateTransaction(T, toChainId(e));
    yield this.createUnsignedTx($, "Ntt.setInboundLimit");
  }
  async getRateLimitDuration() {
    return await this.manager.rateLimitDuration();
  }
  async getInboundQueuedTransfer(e, T) {
    const $ = await this.manager.getInboundQueuedTransfer(Ntt.messageDigest(e, T));
    if ($.txTimestamp > 0n) {
      const { recipient: V, amount: J, txTimestamp: ee } = $, te = await this.getRateLimitDuration();
      return {
        recipient: new EvmAddress(V),
        amount: J,
        rateLimitExpiryTimestamp: Number(ee + te)
      };
    }
    return null;
  }
  async *completeInboundQueuedTransfer(e, T, $) {
    const V = await this.manager.completeInboundQueuedTransfer.populateTransaction(Ntt.messageDigest(e, T));
    yield this.createUnsignedTx(V, "Ntt.completeInboundQueuedTransfer");
  }
  async verifyAddresses() {
    const e = {
      manager: this.managerAddress,
      token: this.tokenAddress,
      transceiver: {
        ...this.xcvrs.length > 0 && { wormhole: this.xcvrs[0].address }
      }
      // TODO: what about the quoter?
    }, T = {
      manager: this.managerAddress,
      token: await this.manager.token(),
      transceiver: {
        wormhole: (await this.manager.getTransceivers())[0]
        // TODO: make this more generic
      }
    }, $ = (V, J) => {
      for (const ee in V)
        typeof V[ee] == "object" ? ($(V[ee], J[ee]), Object.keys(V[ee]).length === 0 && delete V[ee]) : V[ee] === J[ee] && delete V[ee];
    };
    return $(T, e), Object.keys(T).length > 0 ? T : null;
  }
  createUnsignedTx(e, T, $ = !1) {
    return new EvmUnsignedTransaction(addChainId(e, this.chainId), this.network, this.chain, T, $);
  }
}
function decodeTrimmedAmount(C) {
  const e = Number(C & 0xffn);
  return {
    amount: C >> 8n,
    decimals: e
  };
}
function untrim(C, e) {
  const { amount: T, decimals: $ } = C;
  return scale(T, $, e);
}
function scale(C, e, T) {
  return e == T ? C : e > T ? C / 10n ** BigInt(e - T) : C * 10n ** BigInt(T - e);
}
registerProtocol(_platform$1, "Ntt", EvmNtt);
class SolanaChain extends ChainContext {
  async getTokenAccount(e, T) {
    const { getAssociatedTokenAddress: $ } = await import("./index-CP6rlk6M.mjs"), V = new SolanaAddress(T).unwrap(), J = new SolanaAddress(e).unwrap(), ee = await $(V, J);
    return {
      chain: this.chain,
      address: new SolanaAddress(ee.toString())
    };
  }
}
const TOKEN_PROGRAM_ID$2 = new PublicKey("TokenkegQfeZyiNwAJbNbGKPFXCWuBvf9Ss623VQ5DA"), TOKEN_2022_PROGRAM_ID = new PublicKey("TokenzQdBNbLqP5VEhdkAS6EPFLC1PHnBqCXEpPxuEb"), ASSOCIATED_TOKEN_PROGRAM_ID$1 = new PublicKey("ATokenGPvbdGVxr1b2hvZbsiqW5xWH25efTNsLJA8knL");
new PublicKey("So11111111111111111111111111111111111111112");
new PublicKey("9pan9bMn5HatX4EJdBwg9VgCa7Uz5HL8N1m5D3NdXejP");
const Gr = class Gr extends PlatformContext {
  constructor(e, T) {
    super(e, T ?? networkPlatformConfigs(e, Gr._platform));
  }
  getRpc(e, T = {
    commitment: "confirmed",
    disableRetryOnRateLimit: !0
  }) {
    if (e in this.config)
      return new Connection$1(this.config[e].rpc, T);
    throw new Error("No configuration available for chain: " + e);
  }
  getChain(e, T) {
    if (e in this.config)
      return new SolanaChain(e, this, T);
    throw new Error("No configuration available for chain: " + e);
  }
  static nativeTokenId(e, T) {
    if (!Gr.isSupportedChain(T))
      throw new Error(`invalid chain: ${T}`);
    return Wormhole.chainAddress(T, SolanaZeroAddress);
  }
  static isNativeTokenId(e, T, $) {
    return !this.isSupportedChain(T) || $.chain !== T ? !1 : this.nativeTokenId(e, T) == $;
  }
  static isSupportedChain(e) {
    return chainToPlatform(e) === Gr._platform;
  }
  static async getDecimals(e, T, $) {
    if (isNative$1($))
      return nativeDecimals(Gr._platform);
    let V = await T.getParsedAccountInfo(new SolanaAddress($).unwrap());
    if (!V || !V.value)
      throw new Error("could not fetch token details");
    const { decimals: J } = V.value.data.parsed.info;
    return J;
  }
  static async getBalance(e, T, $, V) {
    const J = new PublicKey($);
    if (isNative$1(V))
      return BigInt(await T.getBalance(J));
    const ee = await T.getTokenAccountsByOwner(J, {
      mint: new SolanaAddress(V).unwrap()
    }), te = ee.value.length > 0 ? ee.value[0].pubkey : J, re = await T.getTokenAccountBalance(te);
    return BigInt(re.value.amount);
  }
  static async getBalances(e, T, $, V) {
    let J;
    V.includes("native") && (J = BigInt(await T.getBalance(new PublicKey($))));
    const ee = (await Promise.all([TOKEN_PROGRAM_ID$2, TOKEN_2022_PROGRAM_ID].map((re) => new PublicKey(re)).map((re) => T.getParsedTokenAccountsByOwner(new PublicKey($), { programId: re })))).reduce((re, ie) => re.concat(ie.value), []);
    return V.map((re) => {
      var de, ue, fe, he;
      if (isNative$1(re))
        return { native: J };
      const ie = new SolanaAddress(re).toString(), se = (he = (fe = (ue = (de = ee.find((me) => {
        var xe, ve;
        return ((ve = (xe = me == null ? void 0 : me.account.data.parsed) == null ? void 0 : xe.info) == null ? void 0 : ve.mint) === re.toString();
      })) == null ? void 0 : de.account.data.parsed) == null ? void 0 : ue.info) == null ? void 0 : fe.tokenAmount) == null ? void 0 : he.amount;
      return se ? { [ie]: BigInt(se) } : { [ie]: null };
    }).reduce((re, ie) => Object.assign(re, ie), {});
  }
  static async sendWait(e, T, $, V) {
    const J = await Promise.all($.map((re) => this.sendTxWithRetry(T, re, V))), ee = J.map((re) => re.signature), te = J.filter((re) => re.response.value.err).map((re) => re.response.value.err);
    if (te.length > 0)
      throw new Error(`Failed to confirm transaction: ${te}`);
    return ee;
  }
  static async sendTxWithRetry(e, T, $ = {}, V = 5e3) {
    const J = $.preflightCommitment ?? e.commitment, ee = await e.sendRawTransaction(T, {
      ...$,
      skipPreflight: !1,
      // The first send should not skip preflight to catch any errors
      maxRetries: 0,
      preflightCommitment: J
    }), { blockhash: te, lastValidBlockHeight: re } = await e.getLatestBlockhash(), ie = e.confirmTransaction({
      signature: ee,
      blockhash: te,
      lastValidBlockHeight: re
    }, J);
    let se = null;
    for (; !se && (se = await Promise.race([
      ie,
      new Promise((de) => setTimeout(() => {
        de(null);
      }, V))
    ]), !se); )
      await e.sendRawTransaction(T, {
        ...$,
        skipPreflight: !0,
        maxRetries: 0,
        preflightCommitment: J
      });
    return { signature: ee, response: se };
  }
  static async latestBlock(e, T) {
    return e.getLatestBlockhash(T ?? e.commitment);
  }
  static async getLatestBlock(e) {
    return await e.getSlot();
  }
  static async getLatestFinalizedBlock(e) {
    const { lastValidBlockHeight: T } = await this.latestBlock(e, "finalized");
    return T;
  }
  static chainFromChainId(e) {
    const T = platformNativeChainIdToNetworkChain(Gr._platform, e);
    if (!T)
      throw new Error(`No matching genesis hash to determine network and chain: ${e}`);
    const [$, V] = T;
    return [$, V];
  }
  static async chainFromRpc(e) {
    try {
      const T = await e.getGenesisHash();
      return Gr.chainFromChainId(T);
    } catch (T) {
      if (e.rpcEndpoint.includes("http://127") || e.rpcEndpoint.includes("http://localhost") || e.rpcEndpoint === "http://solana-devnet:8899")
        return ["Devnet", "Solana"];
      throw T;
    }
  }
};
tt(Gr, "_platform", _platform);
let SolanaPlatform = Gr;
class SolanaUnsignedTransaction {
  constructor(e, T, $, V, J = !1) {
    tt(this, "transaction");
    tt(this, "network");
    tt(this, "chain");
    tt(this, "description");
    tt(this, "parallelizable");
    this.transaction = e, this.network = T, this.chain = $, this.description = V, this.parallelizable = J;
  }
}
function isVersionedTransaction$1(C) {
  return C.signatures !== void 0 && C.message !== void 0;
}
const toBytes = (C) => typeof C == "string" ? dist$2.Buffer.from(C) : C;
function deriveAddress(C, e) {
  return PublicKey.findProgramAddressSync(Array.isArray(C) ? C.map(toBytes) : [toBytes(C)], new PublicKey(e))[0];
}
function newAccountMeta(C, e) {
  return {
    pubkey: new PublicKey(C),
    isWritable: !0,
    isSigner: e
  };
}
function newReadOnlyAccountMeta(C, e) {
  return {
    pubkey: new PublicKey(C),
    isWritable: !1,
    isSigner: e
  };
}
function getAccountData(C) {
  if (C === null)
    throw Error("account info is null");
  return C.data;
}
const BPF_LOADER_UPGRADEABLE_PROGRAM_ID$1 = new PublicKey("BPFLoaderUpgradeab1e11111111111111111111111");
function deriveProgramDataAddress(C) {
  return deriveAddress([new PublicKey(C).toBuffer()], BPF_LOADER_UPGRADEABLE_PROGRAM_ID$1);
}
function createReadOnlyProvider(C) {
  if (C !== void 0)
    return { connection: C };
}
let IdlError$1 = class extends Error {
  constructor(e) {
    super(e), this.name = "IdlError";
  }
};
var dist$1 = {}, Layout$2 = {};
let Layout$1 = class {
  constructor(e, T) {
    if (!Number.isInteger(e))
      throw new TypeError("span must be an integer");
    this.span = e, this.property = T;
  }
  /** Function to create an Object into which decoded properties will
   * be written.
   *
   * Used only for layouts that {@link Layout#decode|decode} to Object
   * instances, which means:
   * * {@link Structure}
   * * {@link Union}
   * * {@link VariantLayout}
   * * {@link BitStructure}
   *
   * If left undefined the JavaScript representation of these layouts
   * will be Object instances.
   *
   * See {@link bindConstructorLayout}.
   */
  makeDestinationObject() {
    return {};
  }
  /**
   * Decode from a Buffer into an JavaScript value.
   *
   * @param {Buffer} b - the buffer from which encoded data is read.
   *
   * @param {Number} [offset] - the offset at which the encoded data
   * starts.  If absent a zero offset is inferred.
   *
   * @returns {(Number|Array|Object)} - the value of the decoded data.
   *
   * @abstract
   */
  decode(e, T) {
    throw new Error("Layout is abstract");
  }
  /**
   * Encode a JavaScript value into a Buffer.
   *
   * @param {(Number|Array|Object)} src - the value to be encoded into
   * the buffer.  The type accepted depends on the (sub-)type of {@link
   * Layout}.
   *
   * @param {Buffer} b - the buffer into which encoded data will be
   * written.
   *
   * @param {Number} [offset] - the offset at which the encoded data
   * starts.  If absent a zero offset is inferred.
   *
   * @returns {Number} - the number of bytes encoded, including the
   * space skipped for internal padding, but excluding data such as
   * {@link Sequence#count|lengths} when stored {@link
   * ExternalLayout|externally}.  This is the adjustment to `offset`
   * producing the offset where data for the next layout would be
   * written.
   *
   * @abstract
   */
  encode(e, T, $) {
    throw new Error("Layout is abstract");
  }
  /**
   * Calculate the span of a specific instance of a layout.
   *
   * @param {Buffer} b - the buffer that contains an encoded instance.
   *
   * @param {Number} [offset] - the offset at which the encoded instance
   * starts.  If absent a zero offset is inferred.
   *
   * @return {Number} - the number of bytes covered by the layout
   * instance.  If this method is not overridden in a subclass the
   * definition-time constant {@link Layout#span|span} will be
   * returned.
   *
   * @throws {RangeError} - if the length of the value cannot be
   * determined.
   */
  getSpan(e, T) {
    if (0 > this.span)
      throw new RangeError("indeterminate span");
    return this.span;
  }
  /**
   * Replicate the layout using a new property.
   *
   * This function must be used to get a structurally-equivalent layout
   * with a different name since all {@link Layout} instances are
   * immutable.
   *
   * **NOTE** This is a shallow copy.  All fields except {@link
   * Layout#property|property} are strictly equal to the origin layout.
   *
   * @param {String} property - the value for {@link
   * Layout#property|property} in the replica.
   *
   * @returns {Layout} - the copy with {@link Layout#property|property}
   * set to `property`.
   */
  replicate(e) {
    const T = Object.create(this.constructor.prototype);
    return Object.assign(T, this), T.property = e, T;
  }
  /**
   * Create an object from layout properties and an array of values.
   *
   * **NOTE** This function returns `undefined` if invoked on a layout
   * that does not return its value as an Object.  Objects are
   * returned for things that are a {@link Structure}, which includes
   * {@link VariantLayout|variant layouts} if they are structures, and
   * excludes {@link Union}s.  If you want this feature for a union
   * you must use {@link Union.getVariant|getVariant} to select the
   * desired layout.
   *
   * @param {Array} values - an array of values that correspond to the
   * default order for properties.  As with {@link Layout#decode|decode}
   * layout elements that have no property name are skipped when
   * iterating over the array values.  Only the top-level properties are
   * assigned; arguments are not assigned to properties of contained
   * layouts.  Any unused values are ignored.
   *
   * @return {(Object|undefined)}
   */
  fromArray(e) {
  }
};
Layout$2.Layout = Layout$1;
function nameWithProperty$1(C, e) {
  return e.property ? C + "[" + e.property + "]" : C;
}
Layout$2.nameWithProperty = nameWithProperty$1;
function bindConstructorLayout(C, e) {
  if (typeof C != "function")
    throw new TypeError("Class must be constructor");
  if (C.hasOwnProperty("layout_"))
    throw new Error("Class is already bound to a layout");
  if (!(e && e instanceof Layout$1))
    throw new TypeError("layout must be a Layout");
  if (e.hasOwnProperty("boundConstructor_"))
    throw new Error("layout is already bound to a constructor");
  C.layout_ = e, e.boundConstructor_ = C, e.makeDestinationObject = () => new C(), Object.defineProperty(C.prototype, "encode", {
    value: function(T, $) {
      return e.encode(this, T, $);
    },
    writable: !0
  }), Object.defineProperty(C, "decode", {
    value: function(T, $) {
      return e.decode(T, $);
    },
    writable: !0
  });
}
Layout$2.bindConstructorLayout = bindConstructorLayout;
let ExternalLayout$1 = class extends Layout$1 {
  /**
   * Return `true` iff the external layout decodes to an unsigned
   * integer layout.
   *
   * In that case it can be used as the source of {@link
   * Sequence#count|Sequence counts}, {@link Blob#length|Blob lengths},
   * or as {@link UnionLayoutDiscriminator#layout|external union
   * discriminators}.
   *
   * @abstract
   */
  isCount() {
    throw new Error("ExternalLayout is abstract");
  }
};
class GreedyCount extends ExternalLayout$1 {
  constructor(e, T) {
    if (e === void 0 && (e = 1), !Number.isInteger(e) || 0 >= e)
      throw new TypeError("elementSpan must be a (positive) integer");
    super(-1, T), this.elementSpan = e;
  }
  /** @override */
  isCount() {
    return !0;
  }
  /** @override */
  decode(e, T) {
    T === void 0 && (T = 0);
    const $ = e.length - T;
    return Math.floor($ / this.elementSpan);
  }
  /** @override */
  encode(e, T, $) {
    return 0;
  }
}
let OffsetLayout$1 = class extends ExternalLayout$1 {
  constructor(e, T, $) {
    if (!(e instanceof Layout$1))
      throw new TypeError("layout must be a Layout");
    if (T === void 0)
      T = 0;
    else if (!Number.isInteger(T))
      throw new TypeError("offset must be integer or undefined");
    super(e.span, $ || e.property), this.layout = e, this.offset = T;
  }
  /** @override */
  isCount() {
    return this.layout instanceof UInt$1 || this.layout instanceof UIntBE$1;
  }
  /** @override */
  decode(e, T) {
    return T === void 0 && (T = 0), this.layout.decode(e, T + this.offset);
  }
  /** @override */
  encode(e, T, $) {
    return $ === void 0 && ($ = 0), this.layout.encode(e, T, $ + this.offset);
  }
}, UInt$1 = class extends Layout$1 {
  constructor(e, T) {
    if (super(e, T), 6 < this.span)
      throw new RangeError("span must not exceed 6 bytes");
  }
  /** @override */
  decode(e, T) {
    return T === void 0 && (T = 0), e.readUIntLE(T, this.span);
  }
  /** @override */
  encode(e, T, $) {
    return $ === void 0 && ($ = 0), T.writeUIntLE(e, $, this.span), this.span;
  }
}, UIntBE$1 = class extends Layout$1 {
  constructor(e, T) {
    if (super(e, T), 6 < this.span)
      throw new RangeError("span must not exceed 6 bytes");
  }
  /** @override */
  decode(e, T) {
    return T === void 0 && (T = 0), e.readUIntBE(T, this.span);
  }
  /** @override */
  encode(e, T, $) {
    return $ === void 0 && ($ = 0), T.writeUIntBE(e, $, this.span), this.span;
  }
};
class Int extends Layout$1 {
  constructor(e, T) {
    if (super(e, T), 6 < this.span)
      throw new RangeError("span must not exceed 6 bytes");
  }
  /** @override */
  decode(e, T) {
    return T === void 0 && (T = 0), e.readIntLE(T, this.span);
  }
  /** @override */
  encode(e, T, $) {
    return $ === void 0 && ($ = 0), T.writeIntLE(e, $, this.span), this.span;
  }
}
class IntBE extends Layout$1 {
  constructor(e, T) {
    if (super(e, T), 6 < this.span)
      throw new RangeError("span must not exceed 6 bytes");
  }
  /** @override */
  decode(e, T) {
    return T === void 0 && (T = 0), e.readIntBE(T, this.span);
  }
  /** @override */
  encode(e, T, $) {
    return $ === void 0 && ($ = 0), T.writeIntBE(e, $, this.span), this.span;
  }
}
const V2E32$1 = Math.pow(2, 32);
function divmodInt64$1(C) {
  const e = Math.floor(C / V2E32$1), T = C - e * V2E32$1;
  return { hi32: e, lo32: T };
}
function roundedInt64$1(C, e) {
  return C * V2E32$1 + e;
}
let NearUInt64$1 = class extends Layout$1 {
  constructor(e) {
    super(8, e);
  }
  /** @override */
  decode(e, T) {
    T === void 0 && (T = 0);
    const $ = e.readUInt32LE(T), V = e.readUInt32LE(T + 4);
    return roundedInt64$1(V, $);
  }
  /** @override */
  encode(e, T, $) {
    $ === void 0 && ($ = 0);
    const V = divmodInt64$1(e);
    return T.writeUInt32LE(V.lo32, $), T.writeUInt32LE(V.hi32, $ + 4), 8;
  }
};
class NearUInt64BE extends Layout$1 {
  constructor(e) {
    super(8, e);
  }
  /** @override */
  decode(e, T) {
    T === void 0 && (T = 0);
    const $ = e.readUInt32BE(T), V = e.readUInt32BE(T + 4);
    return roundedInt64$1($, V);
  }
  /** @override */
  encode(e, T, $) {
    $ === void 0 && ($ = 0);
    const V = divmodInt64$1(e);
    return T.writeUInt32BE(V.hi32, $), T.writeUInt32BE(V.lo32, $ + 4), 8;
  }
}
let NearInt64$1 = class extends Layout$1 {
  constructor(e) {
    super(8, e);
  }
  /** @override */
  decode(e, T) {
    T === void 0 && (T = 0);
    const $ = e.readUInt32LE(T), V = e.readInt32LE(T + 4);
    return roundedInt64$1(V, $);
  }
  /** @override */
  encode(e, T, $) {
    $ === void 0 && ($ = 0);
    const V = divmodInt64$1(e);
    return T.writeUInt32LE(V.lo32, $), T.writeInt32LE(V.hi32, $ + 4), 8;
  }
};
class NearInt64BE extends Layout$1 {
  constructor(e) {
    super(8, e);
  }
  /** @override */
  decode(e, T) {
    T === void 0 && (T = 0);
    const $ = e.readInt32BE(T), V = e.readUInt32BE(T + 4);
    return roundedInt64$1($, V);
  }
  /** @override */
  encode(e, T, $) {
    $ === void 0 && ($ = 0);
    const V = divmodInt64$1(e);
    return T.writeInt32BE(V.hi32, $), T.writeUInt32BE(V.lo32, $ + 4), 8;
  }
}
class Float extends Layout$1 {
  constructor(e) {
    super(4, e);
  }
  /** @override */
  decode(e, T) {
    return T === void 0 && (T = 0), e.readFloatLE(T);
  }
  /** @override */
  encode(e, T, $) {
    return $ === void 0 && ($ = 0), T.writeFloatLE(e, $), 4;
  }
}
class FloatBE extends Layout$1 {
  constructor(e) {
    super(4, e);
  }
  /** @override */
  decode(e, T) {
    return T === void 0 && (T = 0), e.readFloatBE(T);
  }
  /** @override */
  encode(e, T, $) {
    return $ === void 0 && ($ = 0), T.writeFloatBE(e, $), 4;
  }
}
class Double extends Layout$1 {
  constructor(e) {
    super(8, e);
  }
  /** @override */
  decode(e, T) {
    return T === void 0 && (T = 0), e.readDoubleLE(T);
  }
  /** @override */
  encode(e, T, $) {
    return $ === void 0 && ($ = 0), T.writeDoubleLE(e, $), 8;
  }
}
class DoubleBE extends Layout$1 {
  constructor(e) {
    super(8, e);
  }
  /** @override */
  decode(e, T) {
    return T === void 0 && (T = 0), e.readDoubleBE(T);
  }
  /** @override */
  encode(e, T, $) {
    return $ === void 0 && ($ = 0), T.writeDoubleBE(e, $), 8;
  }
}
class Sequence extends Layout$1 {
  constructor(e, T, $) {
    if (!(e instanceof Layout$1))
      throw new TypeError("elementLayout must be a Layout");
    if (!(T instanceof ExternalLayout$1 && T.isCount() || Number.isInteger(T) && 0 <= T))
      throw new TypeError("count must be non-negative integer or an unsigned integer ExternalLayout");
    let V = -1;
    !(T instanceof ExternalLayout$1) && 0 < e.span && (V = T * e.span), super(V, $), this.elementLayout = e, this.count = T;
  }
  /** @override */
  getSpan(e, T) {
    if (0 <= this.span)
      return this.span;
    T === void 0 && (T = 0);
    let $ = 0, V = this.count;
    if (V instanceof ExternalLayout$1 && (V = V.decode(e, T)), 0 < this.elementLayout.span)
      $ = V * this.elementLayout.span;
    else {
      let J = 0;
      for (; J < V; )
        $ += this.elementLayout.getSpan(e, T + $), ++J;
    }
    return $;
  }
  /** @override */
  decode(e, T) {
    T === void 0 && (T = 0);
    const $ = [];
    let V = 0, J = this.count;
    for (J instanceof ExternalLayout$1 && (J = J.decode(e, T)); V < J; )
      $.push(this.elementLayout.decode(e, T)), T += this.elementLayout.getSpan(e, T), V += 1;
    return $;
  }
  /** Implement {@link Layout#encode|encode} for {@link Sequence}.
   *
   * **NOTE** If `src` is shorter than {@link Sequence#count|count} then
   * the unused space in the buffer is left unchanged.  If `src` is
   * longer than {@link Sequence#count|count} the unneeded elements are
   * ignored.
   *
   * **NOTE** If {@link Layout#count|count} is an instance of {@link
   * ExternalLayout} then the length of `src` will be encoded as the
   * count after `src` is encoded. */
  encode(e, T, $) {
    $ === void 0 && ($ = 0);
    const V = this.elementLayout, J = e.reduce((ee, te) => ee + V.encode(te, T, $ + ee), 0);
    return this.count instanceof ExternalLayout$1 && this.count.encode(e.length, T, $), J;
  }
}
let Structure$1 = class extends Layout$1 {
  constructor(e, T, $) {
    if (!(Array.isArray(e) && e.reduce((J, ee) => J && ee instanceof Layout$1, !0)))
      throw new TypeError("fields must be array of Layout instances");
    typeof T == "boolean" && $ === void 0 && ($ = T, T = void 0);
    for (const J of e)
      if (0 > J.span && J.property === void 0)
        throw new Error("fields cannot contain unnamed variable-length layout");
    let V = -1;
    try {
      V = e.reduce((J, ee) => J + ee.getSpan(), 0);
    } catch {
    }
    super(V, T), this.fields = e, this.decodePrefixes = !!$;
  }
  /** @override */
  getSpan(e, T) {
    if (0 <= this.span)
      return this.span;
    T === void 0 && (T = 0);
    let $ = 0;
    try {
      $ = this.fields.reduce((V, J) => {
        const ee = J.getSpan(e, T);
        return T += ee, V + ee;
      }, 0);
    } catch {
      throw new RangeError("indeterminate span");
    }
    return $;
  }
  /** @override */
  decode(e, T) {
    T === void 0 && (T = 0);
    const $ = this.makeDestinationObject();
    for (const V of this.fields)
      if (V.property !== void 0 && ($[V.property] = V.decode(e, T)), T += V.getSpan(e, T), this.decodePrefixes && e.length === T)
        break;
    return $;
  }
  /** Implement {@link Layout#encode|encode} for {@link Structure}.
   *
   * If `src` is missing a property for a member with a defined {@link
   * Layout#property|property} the corresponding region of the buffer is
   * left unmodified. */
  encode(e, T, $) {
    $ === void 0 && ($ = 0);
    const V = $;
    let J = 0, ee = 0;
    for (const te of this.fields) {
      let re = te.span;
      if (ee = 0 < re ? re : 0, te.property !== void 0) {
        const ie = e[te.property];
        ie !== void 0 && (ee = te.encode(ie, T, $), 0 > re && (re = te.getSpan(T, $)));
      }
      J = $, $ += re;
    }
    return J + ee - V;
  }
  /** @override */
  fromArray(e) {
    const T = this.makeDestinationObject();
    for (const $ of this.fields)
      $.property !== void 0 && 0 < e.length && (T[$.property] = e.shift());
    return T;
  }
  /**
   * Get access to the layout of a given property.
   *
   * @param {String} property - the structure member of interest.
   *
   * @return {Layout} - the layout associated with `property`, or
   * undefined if there is no such property.
   */
  layoutFor(e) {
    if (typeof e != "string")
      throw new TypeError("property must be string");
    for (const T of this.fields)
      if (T.property === e)
        return T;
  }
  /**
   * Get the offset of a structure member.
   *
   * @param {String} property - the structure member of interest.
   *
   * @return {Number} - the offset in bytes to the start of `property`
   * within the structure, or undefined if `property` is not a field
   * within the structure.  If the property is a member but follows a
   * variable-length structure member a negative number will be
   * returned.
   */
  offsetOf(e) {
    if (typeof e != "string")
      throw new TypeError("property must be string");
    let T = 0;
    for (const $ of this.fields) {
      if ($.property === e)
        return T;
      0 > $.span ? T = -1 : 0 <= T && (T += $.span);
    }
  }
}, UnionDiscriminator$1 = class {
  constructor(e) {
    this.property = e;
  }
  /** Analog to {@link Layout#decode|Layout decode} for union discriminators.
   *
   * The implementation of this method need not reference the buffer if
   * variant information is available through other means. */
  decode() {
    throw new Error("UnionDiscriminator is abstract");
  }
  /** Analog to {@link Layout#decode|Layout encode} for union discriminators.
   *
   * The implementation of this method need not store the value if
   * variant information is maintained through other means. */
  encode() {
    throw new Error("UnionDiscriminator is abstract");
  }
}, UnionLayoutDiscriminator$1 = class extends UnionDiscriminator$1 {
  constructor(e, T) {
    if (!(e instanceof ExternalLayout$1 && e.isCount()))
      throw new TypeError("layout must be an unsigned integer ExternalLayout");
    super(T || e.property || "variant"), this.layout = e;
  }
  /** Delegate decoding to {@link UnionLayoutDiscriminator#layout|layout}. */
  decode(e, T) {
    return this.layout.decode(e, T);
  }
  /** Delegate encoding to {@link UnionLayoutDiscriminator#layout|layout}. */
  encode(e, T, $) {
    return this.layout.encode(e, T, $);
  }
}, Union$1 = class extends Layout$1 {
  constructor(e, T, $) {
    const V = e instanceof UInt$1 || e instanceof UIntBE$1;
    if (V)
      e = new UnionLayoutDiscriminator$1(new OffsetLayout$1(e));
    else if (e instanceof ExternalLayout$1 && e.isCount())
      e = new UnionLayoutDiscriminator$1(e);
    else if (!(e instanceof UnionDiscriminator$1))
      throw new TypeError("discr must be a UnionDiscriminator or an unsigned integer layout");
    if (T === void 0 && (T = null), !(T === null || T instanceof Layout$1))
      throw new TypeError("defaultLayout must be null or a Layout");
    if (T !== null) {
      if (0 > T.span)
        throw new Error("defaultLayout must have constant span");
      T.property === void 0 && (T = T.replicate("content"));
    }
    let J = -1;
    T && (J = T.span, 0 <= J && V && (J += e.layout.span)), super(J, $), this.discriminator = e, this.usesPrefixDiscriminator = V, this.defaultLayout = T, this.registry = {};
    let ee = this.defaultGetSourceVariant.bind(this);
    this.getSourceVariant = function(te) {
      return ee(te);
    }, this.configGetSourceVariant = function(te) {
      ee = te.bind(this);
    };
  }
  /** @override */
  getSpan(e, T) {
    if (0 <= this.span)
      return this.span;
    T === void 0 && (T = 0);
    const $ = this.getVariant(e, T);
    if (!$)
      throw new Error("unable to determine span for unrecognized variant");
    return $.getSpan(e, T);
  }
  /**
   * Method to infer a registered Union variant compatible with `src`.
   *
   * The first satisified rule in the following sequence defines the
   * return value:
   * * If `src` has properties matching the Union discriminator and
   *   the default layout, `undefined` is returned regardless of the
   *   value of the discriminator property (this ensures the default
   *   layout will be used);
   * * If `src` has a property matching the Union discriminator, the
   *   value of the discriminator identifies a registered variant, and
   *   either (a) the variant has no layout, or (b) `src` has the
   *   variant's property, then the variant is returned (because the
   *   source satisfies the constraints of the variant it identifies);
   * * If `src` does not have a property matching the Union
   *   discriminator, but does have a property matching a registered
   *   variant, then the variant is returned (because the source
   *   matches a variant without an explicit conflict);
   * * An error is thrown (because we either can't identify a variant,
   *   or we were explicitly told the variant but can't satisfy it).
   *
   * @param {Object} src - an object presumed to be compatible with
   * the content of the Union.
   *
   * @return {(undefined|VariantLayout)} - as described above.
   *
   * @throws {Error} - if `src` cannot be associated with a default or
   * registered variant.
   */
  defaultGetSourceVariant(e) {
    if (e.hasOwnProperty(this.discriminator.property)) {
      if (this.defaultLayout && e.hasOwnProperty(this.defaultLayout.property))
        return;
      const T = this.registry[e[this.discriminator.property]];
      if (T && (!T.layout || e.hasOwnProperty(T.property)))
        return T;
    } else
      for (const T in this.registry) {
        const $ = this.registry[T];
        if (e.hasOwnProperty($.property))
          return $;
      }
    throw new Error("unable to infer src variant");
  }
  /** Implement {@link Layout#decode|decode} for {@link Union}.
   *
   * If the variant is {@link Union#addVariant|registered} the return
   * value is an instance of that variant, with no explicit
   * discriminator.  Otherwise the {@link Union#defaultLayout|default
   * layout} is used to decode the content. */
  decode(e, T) {
    T === void 0 && (T = 0);
    let $;
    const V = this.discriminator, J = V.decode(e, T);
    let ee = this.registry[J];
    if (ee === void 0) {
      let te = 0;
      ee = this.defaultLayout, this.usesPrefixDiscriminator && (te = V.layout.span), $ = this.makeDestinationObject(), $[V.property] = J, $[ee.property] = this.defaultLayout.decode(e, T + te);
    } else
      $ = ee.decode(e, T);
    return $;
  }
  /** Implement {@link Layout#encode|encode} for {@link Union}.
   *
   * This API assumes the `src` object is consistent with the union's
   * {@link Union#defaultLayout|default layout}.  To encode variants
   * use the appropriate variant-specific {@link VariantLayout#encode}
   * method. */
  encode(e, T, $) {
    $ === void 0 && ($ = 0);
    const V = this.getSourceVariant(e);
    if (V === void 0) {
      const J = this.discriminator, ee = this.defaultLayout;
      let te = 0;
      return this.usesPrefixDiscriminator && (te = J.layout.span), J.encode(e[J.property], T, $), te + ee.encode(
        e[ee.property],
        T,
        $ + te
      );
    }
    return V.encode(e, T, $);
  }
  /** Register a new variant structure within a union.  The newly
   * created variant is returned.
   *
   * @param {Number} variant - initializer for {@link
   * VariantLayout#variant|variant}.
   *
   * @param {Layout} layout - initializer for {@link
   * VariantLayout#layout|layout}.
   *
   * @param {String} property - initializer for {@link
   * Layout#property|property}.
   *
   * @return {VariantLayout} */
  addVariant(e, T, $) {
    const V = new VariantLayout$1(this, e, T, $);
    return this.registry[e] = V, V;
  }
  /**
   * Get the layout associated with a registered variant.
   *
   * If `vb` does not produce a registered variant the function returns
   * `undefined`.
   *
   * @param {(Number|Buffer)} vb - either the variant number, or a
   * buffer from which the discriminator is to be read.
   *
   * @param {Number} offset - offset into `vb` for the start of the
   * union.  Used only when `vb` is an instance of {Buffer}.
   *
   * @return {({VariantLayout}|undefined)}
   */
  getVariant(e, T) {
    let $ = e;
    return dist$2.Buffer.isBuffer(e) && (T === void 0 && (T = 0), $ = this.discriminator.decode(e, T)), this.registry[$];
  }
}, VariantLayout$1 = class extends Layout$1 {
  constructor(e, T, $, V) {
    if (!(e instanceof Union$1))
      throw new TypeError("union must be a Union");
    if (!Number.isInteger(T) || 0 > T)
      throw new TypeError("variant must be a (non-negative) integer");
    if (typeof $ == "string" && V === void 0 && (V = $, $ = null), $) {
      if (!($ instanceof Layout$1))
        throw new TypeError("layout must be a Layout");
      if (e.defaultLayout !== null && 0 <= $.span && $.span > e.defaultLayout.span)
        throw new Error("variant span exceeds span of containing union");
      if (typeof V != "string")
        throw new TypeError("variant must have a String property");
    }
    let J = e.span;
    0 > e.span && (J = $ ? $.span : 0, 0 <= J && e.usesPrefixDiscriminator && (J += e.discriminator.layout.span)), super(J, V), this.union = e, this.variant = T, this.layout = $ || null;
  }
  /** @override */
  getSpan(e, T) {
    if (0 <= this.span)
      return this.span;
    T === void 0 && (T = 0);
    let $ = 0;
    return this.union.usesPrefixDiscriminator && ($ = this.union.discriminator.layout.span), $ + this.layout.getSpan(e, T + $);
  }
  /** @override */
  decode(e, T) {
    const $ = this.makeDestinationObject();
    if (T === void 0 && (T = 0), this !== this.union.getVariant(e, T))
      throw new Error("variant mismatch");
    let V = 0;
    return this.union.usesPrefixDiscriminator && (V = this.union.discriminator.layout.span), this.layout ? $[this.property] = this.layout.decode(e, T + V) : this.property ? $[this.property] = !0 : this.union.usesPrefixDiscriminator && ($[this.union.discriminator.property] = this.variant), $;
  }
  /** @override */
  encode(e, T, $) {
    $ === void 0 && ($ = 0);
    let V = 0;
    if (this.union.usesPrefixDiscriminator && (V = this.union.discriminator.layout.span), this.layout && !e.hasOwnProperty(this.property))
      throw new TypeError("variant lacks property " + this.property);
    this.union.discriminator.encode(this.variant, T, $);
    let J = V;
    if (this.layout && (this.layout.encode(e[this.property], T, $ + V), J += this.layout.getSpan(T, $ + V), 0 <= this.union.span && J > this.union.span))
      throw new Error("encoded variant overruns containing union");
    return J;
  }
  /** Delegate {@link Layout#fromArray|fromArray} to {@link
   * VariantLayout#layout|layout}. */
  fromArray(e) {
    if (this.layout)
      return this.layout.fromArray(e);
  }
};
function fixBitwiseResult(C) {
  return 0 > C && (C += 4294967296), C;
}
class BitStructure extends Layout$1 {
  constructor(e, T, $) {
    if (!(e instanceof UInt$1 || e instanceof UIntBE$1))
      throw new TypeError("word must be a UInt or UIntBE layout");
    if (typeof T == "string" && $ === void 0 && ($ = T, T = void 0), 4 < e.span)
      throw new RangeError("word cannot exceed 32 bits");
    super(e.span, $), this.word = e, this.msb = !!T, this.fields = [];
    let V = 0;
    this._packedSetValue = function(J) {
      return V = fixBitwiseResult(J), this;
    }, this._packedGetValue = function() {
      return V;
    };
  }
  /** @override */
  decode(e, T) {
    const $ = this.makeDestinationObject();
    T === void 0 && (T = 0);
    const V = this.word.decode(e, T);
    this._packedSetValue(V);
    for (const J of this.fields)
      J.property !== void 0 && ($[J.property] = J.decode(V));
    return $;
  }
  /** Implement {@link Layout#encode|encode} for {@link BitStructure}.
   *
   * If `src` is missing a property for a member with a defined {@link
   * Layout#property|property} the corresponding region of the packed
   * value is left unmodified.  Unused bits are also left unmodified. */
  encode(e, T, $) {
    $ === void 0 && ($ = 0);
    const V = this.word.decode(T, $);
    this._packedSetValue(V);
    for (const J of this.fields)
      if (J.property !== void 0) {
        const ee = e[J.property];
        ee !== void 0 && J.encode(ee);
      }
    return this.word.encode(this._packedGetValue(), T, $);
  }
  /** Register a new bitfield with a containing bit structure.  The
   * resulting bitfield is returned.
   *
   * @param {Number} bits - initializer for {@link BitField#bits|bits}.
   *
   * @param {string} property - initializer for {@link
   * Layout#property|property}.
   *
   * @return {BitField} */
  addField(e, T) {
    const $ = new BitField(this, e, T);
    return this.fields.push($), $;
  }
  /** As with {@link BitStructure#addField|addField} for single-bit
   * fields with `boolean` value representation.
   *
   * @param {string} property - initializer for {@link
   * Layout#property|property}.
   *
   * @return {Boolean} */
  addBoolean(e) {
    const T = new Boolean$1(this, e);
    return this.fields.push(T), T;
  }
  /**
   * Get access to the bit field for a given property.
   *
   * @param {String} property - the bit field of interest.
   *
   * @return {BitField} - the field associated with `property`, or
   * undefined if there is no such property.
   */
  fieldFor(e) {
    if (typeof e != "string")
      throw new TypeError("property must be string");
    for (const T of this.fields)
      if (T.property === e)
        return T;
  }
}
class BitField {
  constructor(e, T, $) {
    if (!(e instanceof BitStructure))
      throw new TypeError("container must be a BitStructure");
    if (!Number.isInteger(T) || 0 >= T)
      throw new TypeError("bits must be positive integer");
    const V = 8 * e.span, J = e.fields.reduce((ee, te) => ee + te.bits, 0);
    if (T + J > V)
      throw new Error("bits too long for span remainder (" + (V - J) + " of " + V + " remain)");
    this.container = e, this.bits = T, this.valueMask = (1 << T) - 1, T === 32 && (this.valueMask = 4294967295), this.start = J, this.container.msb && (this.start = V - J - T), this.wordMask = fixBitwiseResult(this.valueMask << this.start), this.property = $;
  }
  /** Store a value into the corresponding subsequence of the containing
   * bit field. */
  decode() {
    const e = this.container._packedGetValue();
    return fixBitwiseResult(e & this.wordMask) >>> this.start;
  }
  /** Store a value into the corresponding subsequence of the containing
   * bit field.
   *
   * **NOTE** This is not a specialization of {@link
   * Layout#encode|Layout.encode} and there is no return value. */
  encode(e) {
    if (!Number.isInteger(e) || e !== fixBitwiseResult(e & this.valueMask))
      throw new TypeError(nameWithProperty$1("BitField.encode", this) + " value must be integer not exceeding " + this.valueMask);
    const T = this.container._packedGetValue(), $ = fixBitwiseResult(e << this.start);
    this.container._packedSetValue(fixBitwiseResult(T & ~this.wordMask) | $);
  }
}
let Boolean$1 = class extends BitField {
  constructor(e, T) {
    super(e, 1, T);
  }
  /** Override {@link BitField#decode|decode} for {@link Boolean|Boolean}.
   *
   * @returns {boolean} */
  decode(e, T) {
    return !!BitField.prototype.decode.call(this, e, T);
  }
  /** @override */
  encode(e) {
    return typeof e == "boolean" && (e = +e), BitField.prototype.encode.call(this, e);
  }
}, Blob$2 = class extends Layout$1 {
  constructor(e, T) {
    if (!(e instanceof ExternalLayout$1 && e.isCount() || Number.isInteger(e) && 0 <= e))
      throw new TypeError("length must be positive integer or an unsigned integer ExternalLayout");
    let $ = -1;
    e instanceof ExternalLayout$1 || ($ = e), super($, T), this.length = e;
  }
  /** @override */
  getSpan(e, T) {
    let $ = this.span;
    return 0 > $ && ($ = this.length.decode(e, T)), $;
  }
  /** @override */
  decode(e, T) {
    T === void 0 && (T = 0);
    let $ = this.span;
    return 0 > $ && ($ = this.length.decode(e, T)), e.slice(T, T + $);
  }
  /** Implement {@link Layout#encode|encode} for {@link Blob}.
   *
   * **NOTE** If {@link Layout#count|count} is an instance of {@link
   * ExternalLayout} then the length of `src` will be encoded as the
   * count after `src` is encoded. */
  encode(e, T, $) {
    let V = this.length;
    if (this.length instanceof ExternalLayout$1 && (V = e.length), !(dist$2.Buffer.isBuffer(e) && V === e.length))
      throw new TypeError(nameWithProperty$1("Blob.encode", this) + " requires (length " + V + ") Buffer as src");
    if ($ + V > T.length)
      throw new RangeError("encoding overruns Buffer");
    return T.write(e.toString("hex"), $, V, "hex"), this.length instanceof ExternalLayout$1 && this.length.encode(V, T, $), V;
  }
};
class CString extends Layout$1 {
  constructor(e) {
    super(-1, e);
  }
  /** @override */
  getSpan(e, T) {
    if (!dist$2.Buffer.isBuffer(e))
      throw new TypeError("b must be a Buffer");
    T === void 0 && (T = 0);
    let $ = T;
    for (; $ < e.length && e[$] !== 0; )
      $ += 1;
    return 1 + $ - T;
  }
  /** @override */
  decode(e, T, $) {
    T === void 0 && (T = 0);
    let V = this.getSpan(e, T);
    return e.slice(T, T + V - 1).toString("utf-8");
  }
  /** @override */
  encode(e, T, $) {
    $ === void 0 && ($ = 0), typeof e != "string" && (e = e.toString());
    const V = new dist$2.Buffer(e, "utf8"), J = V.length;
    if ($ + J > T.length)
      throw new RangeError("encoding overruns Buffer");
    return V.copy(T, $), T[$ + J] = 0, J + 1;
  }
}
class UTF8 extends Layout$1 {
  constructor(e, T) {
    if (typeof e == "string" && T === void 0 && (T = e, e = void 0), e === void 0)
      e = -1;
    else if (!Number.isInteger(e))
      throw new TypeError("maxSpan must be an integer");
    super(-1, T), this.maxSpan = e;
  }
  /** @override */
  getSpan(e, T) {
    if (!dist$2.Buffer.isBuffer(e))
      throw new TypeError("b must be a Buffer");
    return T === void 0 && (T = 0), e.length - T;
  }
  /** @override */
  decode(e, T, $) {
    T === void 0 && (T = 0);
    let V = this.getSpan(e, T);
    if (0 <= this.maxSpan && this.maxSpan < V)
      throw new RangeError("text length exceeds maxSpan");
    return e.slice(T, T + V).toString("utf-8");
  }
  /** @override */
  encode(e, T, $) {
    $ === void 0 && ($ = 0), typeof e != "string" && (e = e.toString());
    const V = new dist$2.Buffer(e, "utf8"), J = V.length;
    if (0 <= this.maxSpan && this.maxSpan < J)
      throw new RangeError("text length exceeds maxSpan");
    if ($ + J > T.length)
      throw new RangeError("encoding overruns Buffer");
    return V.copy(T, $), J;
  }
}
class Constant extends Layout$1 {
  constructor(e, T) {
    super(0, T), this.value = e;
  }
  /** @override */
  decode(e, T, $) {
    return this.value;
  }
  /** @override */
  encode(e, T, $) {
    return 0;
  }
}
Layout$2.ExternalLayout = ExternalLayout$1;
Layout$2.GreedyCount = GreedyCount;
Layout$2.OffsetLayout = OffsetLayout$1;
Layout$2.UInt = UInt$1;
Layout$2.UIntBE = UIntBE$1;
Layout$2.Int = Int;
Layout$2.IntBE = IntBE;
Layout$2.Float = Float;
Layout$2.FloatBE = FloatBE;
Layout$2.Double = Double;
Layout$2.DoubleBE = DoubleBE;
Layout$2.Sequence = Sequence;
Layout$2.Structure = Structure$1;
Layout$2.UnionDiscriminator = UnionDiscriminator$1;
Layout$2.UnionLayoutDiscriminator = UnionLayoutDiscriminator$1;
Layout$2.Union = Union$1;
Layout$2.VariantLayout = VariantLayout$1;
Layout$2.BitStructure = BitStructure;
Layout$2.BitField = BitField;
Layout$2.Boolean = Boolean$1;
Layout$2.Blob = Blob$2;
Layout$2.CString = CString;
Layout$2.UTF8 = UTF8;
Layout$2.Constant = Constant;
Layout$2.greedy = (C, e) => new GreedyCount(C, e);
Layout$2.offset = (C, e, T) => new OffsetLayout$1(C, e, T);
Layout$2.u8 = (C) => new UInt$1(1, C);
Layout$2.u16 = (C) => new UInt$1(2, C);
Layout$2.u24 = (C) => new UInt$1(3, C);
Layout$2.u32 = (C) => new UInt$1(4, C);
Layout$2.u40 = (C) => new UInt$1(5, C);
Layout$2.u48 = (C) => new UInt$1(6, C);
Layout$2.nu64 = (C) => new NearUInt64$1(C);
Layout$2.u16be = (C) => new UIntBE$1(2, C);
Layout$2.u24be = (C) => new UIntBE$1(3, C);
Layout$2.u32be = (C) => new UIntBE$1(4, C);
Layout$2.u40be = (C) => new UIntBE$1(5, C);
Layout$2.u48be = (C) => new UIntBE$1(6, C);
Layout$2.nu64be = (C) => new NearUInt64BE(C);
Layout$2.s8 = (C) => new Int(1, C);
Layout$2.s16 = (C) => new Int(2, C);
Layout$2.s24 = (C) => new Int(3, C);
Layout$2.s32 = (C) => new Int(4, C);
Layout$2.s40 = (C) => new Int(5, C);
Layout$2.s48 = (C) => new Int(6, C);
Layout$2.ns64 = (C) => new NearInt64$1(C);
Layout$2.s16be = (C) => new IntBE(2, C);
Layout$2.s24be = (C) => new IntBE(3, C);
Layout$2.s32be = (C) => new IntBE(4, C);
Layout$2.s40be = (C) => new IntBE(5, C);
Layout$2.s48be = (C) => new IntBE(6, C);
Layout$2.ns64be = (C) => new NearInt64BE(C);
Layout$2.f32 = (C) => new Float(C);
Layout$2.f32be = (C) => new FloatBE(C);
Layout$2.f64 = (C) => new Double(C);
Layout$2.f64be = (C) => new DoubleBE(C);
Layout$2.struct = (C, e, T) => new Structure$1(C, e, T);
Layout$2.bits = (C, e, T) => new BitStructure(C, e, T);
Layout$2.seq = (C, e, T) => new Sequence(C, e, T);
Layout$2.union = (C, e, T) => new Union$1(C, e, T);
Layout$2.unionLayoutDiscriminator = (C, e) => new UnionLayoutDiscriminator$1(C, e);
Layout$2.blob = (C, e) => new Blob$2(C, e);
Layout$2.cstr = (C) => new CString(C);
Layout$2.utf8 = (C, e) => new UTF8(C, e);
Layout$2.const = (C, e) => new Constant(C, e);
const require$$5 = /* @__PURE__ */ getAugmentedNamespace(index_browser_esm);
(function(C) {
  var e = commonjsGlobal$1 && commonjsGlobal$1.__importDefault || function(ne) {
    return ne && ne.__esModule ? ne : { default: ne };
  };
  Object.defineProperty(C, "__esModule", { value: !0 }), C.map = C.array = C.rustEnum = C.str = C.vecU8 = C.tagged = C.vec = C.bool = C.option = C.publicKey = C.i256 = C.u256 = C.i128 = C.u128 = C.i64 = C.u64 = C.struct = C.f64 = C.f32 = C.i32 = C.u32 = C.i16 = C.u16 = C.i8 = C.u8 = void 0;
  const T = Layout$2, $ = require$$5, V = e(bnExports);
  var J = Layout$2;
  Object.defineProperty(C, "u8", { enumerable: !0, get: function() {
    return J.u8;
  } }), Object.defineProperty(C, "i8", { enumerable: !0, get: function() {
    return J.s8;
  } }), Object.defineProperty(C, "u16", { enumerable: !0, get: function() {
    return J.u16;
  } }), Object.defineProperty(C, "i16", { enumerable: !0, get: function() {
    return J.s16;
  } }), Object.defineProperty(C, "u32", { enumerable: !0, get: function() {
    return J.u32;
  } }), Object.defineProperty(C, "i32", { enumerable: !0, get: function() {
    return J.s32;
  } }), Object.defineProperty(C, "f32", { enumerable: !0, get: function() {
    return J.f32;
  } }), Object.defineProperty(C, "f64", { enumerable: !0, get: function() {
    return J.f64;
  } }), Object.defineProperty(C, "struct", { enumerable: !0, get: function() {
    return J.struct;
  } });
  class ee extends T.Layout {
    constructor(oe, ce, le) {
      super(oe, le), this.blob = (0, T.blob)(oe), this.signed = ce;
    }
    decode(oe, ce = 0) {
      const le = new V.default(this.blob.decode(oe, ce), 10, "le");
      return this.signed ? le.fromTwos(this.span * 8).clone() : le;
    }
    encode(oe, ce, le = 0) {
      return this.signed && (oe = oe.toTwos(this.span * 8)), this.blob.encode(oe.toArrayLike(dist$2.Buffer, "le", this.span), ce, le);
    }
  }
  function te(ne) {
    return new ee(8, !1, ne);
  }
  C.u64 = te;
  function re(ne) {
    return new ee(8, !0, ne);
  }
  C.i64 = re;
  function ie(ne) {
    return new ee(16, !1, ne);
  }
  C.u128 = ie;
  function se(ne) {
    return new ee(16, !0, ne);
  }
  C.i128 = se;
  function de(ne) {
    return new ee(32, !1, ne);
  }
  C.u256 = de;
  function ue(ne) {
    return new ee(32, !0, ne);
  }
  C.i256 = ue;
  class fe extends T.Layout {
    constructor(oe, ce, le, pe) {
      super(oe.span, pe), this.layout = oe, this.decoder = ce, this.encoder = le;
    }
    decode(oe, ce) {
      return this.decoder(this.layout.decode(oe, ce));
    }
    encode(oe, ce, le) {
      return this.layout.encode(this.encoder(oe), ce, le);
    }
    getSpan(oe, ce) {
      return this.layout.getSpan(oe, ce);
    }
  }
  function he(ne) {
    return new fe((0, T.blob)(32), (oe) => new $.PublicKey(oe), (oe) => oe.toBuffer(), ne);
  }
  C.publicKey = he;
  class me extends T.Layout {
    constructor(oe, ce) {
      super(-1, ce), this.layout = oe, this.discriminator = (0, T.u8)();
    }
    encode(oe, ce, le = 0) {
      return oe == null ? this.discriminator.encode(0, ce, le) : (this.discriminator.encode(1, ce, le), this.layout.encode(oe, ce, le + 1) + 1);
    }
    decode(oe, ce = 0) {
      const le = this.discriminator.decode(oe, ce);
      if (le === 0)
        return null;
      if (le === 1)
        return this.layout.decode(oe, ce + 1);
      throw new Error("Invalid option " + this.property);
    }
    getSpan(oe, ce = 0) {
      const le = this.discriminator.decode(oe, ce);
      if (le === 0)
        return 1;
      if (le === 1)
        return this.layout.getSpan(oe, ce + 1) + 1;
      throw new Error("Invalid option " + this.property);
    }
  }
  function xe(ne, oe) {
    return new me(ne, oe);
  }
  C.option = xe;
  function ve(ne) {
    return new fe((0, T.u8)(), Te, we, ne);
  }
  C.bool = ve;
  function Te(ne) {
    if (ne === 0)
      return !1;
    if (ne === 1)
      return !0;
    throw new Error("Invalid bool: " + ne);
  }
  function we(ne) {
    return ne ? 1 : 0;
  }
  function Ee(ne, oe) {
    const ce = (0, T.u32)("length"), le = (0, T.struct)([
      ce,
      (0, T.seq)(ne, (0, T.offset)(ce, -ce.span), "values")
    ]);
    return new fe(le, ({ values: pe }) => pe, (pe) => ({ values: pe }), oe);
  }
  C.vec = Ee;
  function Me(ne, oe, ce) {
    const le = (0, T.struct)([
      te("tag"),
      oe.replicate("data")
    ]);
    function pe({ tag: ye, data: Ce }) {
      if (!ye.eq(ne))
        throw new Error("Invalid tag, expected: " + ne.toString("hex") + ", got: " + ye.toString("hex"));
      return Ce;
    }
    return new fe(le, pe, (ye) => ({ tag: ne, data: ye }), ce);
  }
  C.tagged = Me;
  function Ie(ne) {
    const oe = (0, T.u32)("length"), ce = (0, T.struct)([
      oe,
      (0, T.blob)((0, T.offset)(oe, -oe.span), "data")
    ]);
    return new fe(ce, ({ data: le }) => le, (le) => ({ data: le }), ne);
  }
  C.vecU8 = Ie;
  function ke(ne) {
    return new fe(Ie(), (oe) => oe.toString("utf-8"), (oe) => dist$2.Buffer.from(oe, "utf-8"), ne);
  }
  C.str = ke;
  function _e(ne, oe, ce) {
    const le = (0, T.union)(ce ?? (0, T.u8)(), oe);
    return ne.forEach((pe, ye) => le.addVariant(ye, pe, pe.property)), le;
  }
  C.rustEnum = _e;
  function De(ne, oe, ce) {
    const le = (0, T.struct)([
      (0, T.seq)(ne, oe, "values")
    ]);
    return new fe(le, ({ values: pe }) => pe, (pe) => ({ values: pe }), ce);
  }
  C.array = De;
  class Fe extends T.Layout {
    constructor(oe, ce, le) {
      super(oe.span + ce.span, le), this.keyLayout = oe, this.valueLayout = ce;
    }
    decode(oe, ce) {
      ce = ce || 0;
      const le = this.keyLayout.decode(oe, ce), pe = this.valueLayout.decode(oe, ce + this.keyLayout.getSpan(oe, ce));
      return [le, pe];
    }
    encode(oe, ce, le) {
      le = le || 0;
      const pe = this.keyLayout.encode(oe[0], ce, le), ye = this.valueLayout.encode(oe[1], ce, le + pe);
      return pe + ye;
    }
    getSpan(oe, ce) {
      return this.keyLayout.getSpan(oe, ce) + this.valueLayout.getSpan(oe, ce);
    }
  }
  function Ae(ne, oe, ce) {
    const le = (0, T.u32)("length"), pe = (0, T.struct)([
      le,
      (0, T.seq)(new Fe(ne, oe), (0, T.offset)(le, -le.span), "values")
    ]);
    return new fe(pe, ({ values: ye }) => new Map(ye), (ye) => ({ values: Array.from(ye.entries()) }), ce);
  }
  C.map = Ae;
})(dist$1);
function accountSize$1(C, e) {
  switch (e.type.kind) {
    case "struct":
      return e.type.fields.map((T) => typeSize$1(C, T.type)).reduce((T, $) => T + $, 0);
    case "enum": {
      const T = e.type.variants.map(($) => $.fields ? $.fields.map((V) => typeof V == "object" && "name" in V ? typeSize$1(C, V.type) : typeSize$1(C, V)).reduce((V, J) => V + J, 0) : 0);
      return Math.max(...T) + 1;
    }
    case "alias":
      return typeSize$1(C, e.type.value);
  }
}
function typeSize$1(C, e) {
  var T;
  switch (e) {
    case "bool":
      return 1;
    case "u8":
      return 1;
    case "i8":
      return 1;
    case "i16":
      return 2;
    case "u16":
      return 2;
    case "u32":
      return 4;
    case "i32":
      return 4;
    case "f32":
      return 4;
    case "u64":
      return 8;
    case "i64":
      return 8;
    case "f64":
      return 8;
    case "u128":
      return 16;
    case "i128":
      return 16;
    case "u256":
      return 32;
    case "i256":
      return 32;
    case "bytes":
      return 1;
    case "string":
      return 1;
    case "publicKey":
      return 32;
    default:
      if ("vec" in e)
        return 1;
      if ("option" in e)
        return 1 + typeSize$1(C, e.option);
      if ("coption" in e)
        return 4 + typeSize$1(C, e.coption);
      if ("defined" in e) {
        const $ = ((T = C.types) == null ? void 0 : T.filter((J) => J.name === e.defined)) ?? [];
        if ($.length !== 1)
          throw new IdlError$1(`Type not found: ${JSON.stringify(e)}`);
        let V = $[0];
        return accountSize$1(C, V);
      }
      if ("array" in e) {
        let $ = e.array[0], V = e.array[1];
        return typeSize$1(C, $) * V;
      }
      throw new Error(`Invalid type ${JSON.stringify(e)}`);
  }
}
function camelCase$2(C) {
  return C.replace(/(?:^\w|[A-Z]|\b\w)/g, function(e, T) {
    return T === 0 ? e.toLowerCase() : e.toUpperCase();
  }).replace(/[\s\-_]+/g, "");
}
function upperFirst(C) {
  return C.charAt(0).toUpperCase() + C.slice(1);
}
var camelcase = { exports: {} };
const UPPERCASE = /[\p{Lu}]/u, LOWERCASE = /[\p{Ll}]/u, LEADING_CAPITAL = /^[\p{Lu}](?![\p{Lu}])/gu, IDENTIFIER = /([\p{Alpha}\p{N}_]|$)/u, SEPARATORS = /[_.\- ]+/, LEADING_SEPARATORS = new RegExp("^" + SEPARATORS.source), SEPARATORS_AND_IDENTIFIER = new RegExp(SEPARATORS.source + IDENTIFIER.source, "gu"), NUMBERS_AND_IDENTIFIER = new RegExp("\\d+" + IDENTIFIER.source, "gu"), preserveCamelCase = (C, e, T) => {
  let $ = !1, V = !1, J = !1;
  for (let ee = 0; ee < C.length; ee++) {
    const te = C[ee];
    $ && UPPERCASE.test(te) ? (C = C.slice(0, ee) + "-" + C.slice(ee), $ = !1, J = V, V = !0, ee++) : V && J && LOWERCASE.test(te) ? (C = C.slice(0, ee - 1) + "-" + C.slice(ee - 1), J = V, V = !1, $ = !0) : ($ = e(te) === te && T(te) !== te, J = V, V = T(te) === te && e(te) !== te);
  }
  return C;
}, preserveConsecutiveUppercase = (C, e) => (LEADING_CAPITAL.lastIndex = 0, C.replace(LEADING_CAPITAL, (T) => e(T))), postProcess = (C, e) => (SEPARATORS_AND_IDENTIFIER.lastIndex = 0, NUMBERS_AND_IDENTIFIER.lastIndex = 0, C.replace(SEPARATORS_AND_IDENTIFIER, (T, $) => e($)).replace(NUMBERS_AND_IDENTIFIER, (T) => e(T))), camelCase = (C, e) => {
  if (!(typeof C == "string" || Array.isArray(C)))
    throw new TypeError("Expected the input to be `string | string[]`");
  if (e = {
    pascalCase: !1,
    preserveConsecutiveUppercase: !1,
    ...e
  }, Array.isArray(C) ? C = C.map((J) => J.trim()).filter((J) => J.length).join("-") : C = C.trim(), C.length === 0)
    return "";
  const T = e.locale === !1 ? (J) => J.toLowerCase() : (J) => J.toLocaleLowerCase(e.locale), $ = e.locale === !1 ? (J) => J.toUpperCase() : (J) => J.toLocaleUpperCase(e.locale);
  return C.length === 1 ? e.pascalCase ? $(C) : T(C) : (C !== T(C) && (C = preserveCamelCase(C, T, $)), C = C.replace(LEADING_SEPARATORS, ""), e.preserveConsecutiveUppercase ? C = preserveConsecutiveUppercase(C, T) : C = T(C), e.pascalCase && (C = $(C.charAt(0)) + C.slice(1)), postProcess(C, $));
};
camelcase.exports = camelCase;
camelcase.exports.default = camelCase;
var camelcaseExports = camelcase.exports;
const camelCase$1 = /* @__PURE__ */ getDefaultExportFromCjs$2(camelcaseExports);
/*! pako 2.1.0 https://github.com/nodeca/pako @license (MIT AND Zlib) */
const Z_FIXED$1 = 4, Z_BINARY = 0, Z_TEXT = 1, Z_UNKNOWN$1 = 2;
function zero$1(C) {
  let e = C.length;
  for (; --e >= 0; )
    C[e] = 0;
}
const STORED_BLOCK = 0, STATIC_TREES = 1, DYN_TREES = 2, MIN_MATCH$1 = 3, MAX_MATCH$1 = 258, LENGTH_CODES$1 = 29, LITERALS$1 = 256, L_CODES$1 = LITERALS$1 + 1 + LENGTH_CODES$1, D_CODES$1 = 30, BL_CODES$1 = 19, HEAP_SIZE$1 = 2 * L_CODES$1 + 1, MAX_BITS$1 = 15, Buf_size = 16, MAX_BL_BITS = 7, END_BLOCK = 256, REP_3_6 = 16, REPZ_3_10 = 17, REPZ_11_138 = 18, extra_lbits = (
  /* extra bits for each length code */
  new Uint8Array([0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 2, 2, 2, 2, 3, 3, 3, 3, 4, 4, 4, 4, 5, 5, 5, 5, 0])
), extra_dbits = (
  /* extra bits for each distance code */
  new Uint8Array([0, 0, 0, 0, 1, 1, 2, 2, 3, 3, 4, 4, 5, 5, 6, 6, 7, 7, 8, 8, 9, 9, 10, 10, 11, 11, 12, 12, 13, 13])
), extra_blbits = (
  /* extra bits for each bit length code */
  new Uint8Array([0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 2, 3, 7])
), bl_order = new Uint8Array([16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15]), DIST_CODE_LEN = 512, static_ltree = new Array((L_CODES$1 + 2) * 2);
zero$1(static_ltree);
const static_dtree = new Array(D_CODES$1 * 2);
zero$1(static_dtree);
const _dist_code = new Array(DIST_CODE_LEN);
zero$1(_dist_code);
const _length_code = new Array(MAX_MATCH$1 - MIN_MATCH$1 + 1);
zero$1(_length_code);
const base_length = new Array(LENGTH_CODES$1);
zero$1(base_length);
const base_dist = new Array(D_CODES$1);
zero$1(base_dist);
function StaticTreeDesc(C, e, T, $, V) {
  this.static_tree = C, this.extra_bits = e, this.extra_base = T, this.elems = $, this.max_length = V, this.has_stree = C && C.length;
}
let static_l_desc, static_d_desc, static_bl_desc;
function TreeDesc(C, e) {
  this.dyn_tree = C, this.max_code = 0, this.stat_desc = e;
}
const d_code = (C) => C < 256 ? _dist_code[C] : _dist_code[256 + (C >>> 7)], put_short = (C, e) => {
  C.pending_buf[C.pending++] = e & 255, C.pending_buf[C.pending++] = e >>> 8 & 255;
}, send_bits = (C, e, T) => {
  C.bi_valid > Buf_size - T ? (C.bi_buf |= e << C.bi_valid & 65535, put_short(C, C.bi_buf), C.bi_buf = e >> Buf_size - C.bi_valid, C.bi_valid += T - Buf_size) : (C.bi_buf |= e << C.bi_valid & 65535, C.bi_valid += T);
}, send_code = (C, e, T) => {
  send_bits(
    C,
    T[e * 2],
    T[e * 2 + 1]
    /*.Len*/
  );
}, bi_reverse = (C, e) => {
  let T = 0;
  do
    T |= C & 1, C >>>= 1, T <<= 1;
  while (--e > 0);
  return T >>> 1;
}, bi_flush = (C) => {
  C.bi_valid === 16 ? (put_short(C, C.bi_buf), C.bi_buf = 0, C.bi_valid = 0) : C.bi_valid >= 8 && (C.pending_buf[C.pending++] = C.bi_buf & 255, C.bi_buf >>= 8, C.bi_valid -= 8);
}, gen_bitlen = (C, e) => {
  const T = e.dyn_tree, $ = e.max_code, V = e.stat_desc.static_tree, J = e.stat_desc.has_stree, ee = e.stat_desc.extra_bits, te = e.stat_desc.extra_base, re = e.stat_desc.max_length;
  let ie, se, de, ue, fe, he, me = 0;
  for (ue = 0; ue <= MAX_BITS$1; ue++)
    C.bl_count[ue] = 0;
  for (T[C.heap[C.heap_max] * 2 + 1] = 0, ie = C.heap_max + 1; ie < HEAP_SIZE$1; ie++)
    se = C.heap[ie], ue = T[T[se * 2 + 1] * 2 + 1] + 1, ue > re && (ue = re, me++), T[se * 2 + 1] = ue, !(se > $) && (C.bl_count[ue]++, fe = 0, se >= te && (fe = ee[se - te]), he = T[se * 2], C.opt_len += he * (ue + fe), J && (C.static_len += he * (V[se * 2 + 1] + fe)));
  if (me !== 0) {
    do {
      for (ue = re - 1; C.bl_count[ue] === 0; )
        ue--;
      C.bl_count[ue]--, C.bl_count[ue + 1] += 2, C.bl_count[re]--, me -= 2;
    } while (me > 0);
    for (ue = re; ue !== 0; ue--)
      for (se = C.bl_count[ue]; se !== 0; )
        de = C.heap[--ie], !(de > $) && (T[de * 2 + 1] !== ue && (C.opt_len += (ue - T[de * 2 + 1]) * T[de * 2], T[de * 2 + 1] = ue), se--);
  }
}, gen_codes = (C, e, T) => {
  const $ = new Array(MAX_BITS$1 + 1);
  let V = 0, J, ee;
  for (J = 1; J <= MAX_BITS$1; J++)
    V = V + T[J - 1] << 1, $[J] = V;
  for (ee = 0; ee <= e; ee++) {
    let te = C[ee * 2 + 1];
    te !== 0 && (C[ee * 2] = bi_reverse($[te]++, te));
  }
}, tr_static_init = () => {
  let C, e, T, $, V;
  const J = new Array(MAX_BITS$1 + 1);
  for (T = 0, $ = 0; $ < LENGTH_CODES$1 - 1; $++)
    for (base_length[$] = T, C = 0; C < 1 << extra_lbits[$]; C++)
      _length_code[T++] = $;
  for (_length_code[T - 1] = $, V = 0, $ = 0; $ < 16; $++)
    for (base_dist[$] = V, C = 0; C < 1 << extra_dbits[$]; C++)
      _dist_code[V++] = $;
  for (V >>= 7; $ < D_CODES$1; $++)
    for (base_dist[$] = V << 7, C = 0; C < 1 << extra_dbits[$] - 7; C++)
      _dist_code[256 + V++] = $;
  for (e = 0; e <= MAX_BITS$1; e++)
    J[e] = 0;
  for (C = 0; C <= 143; )
    static_ltree[C * 2 + 1] = 8, C++, J[8]++;
  for (; C <= 255; )
    static_ltree[C * 2 + 1] = 9, C++, J[9]++;
  for (; C <= 279; )
    static_ltree[C * 2 + 1] = 7, C++, J[7]++;
  for (; C <= 287; )
    static_ltree[C * 2 + 1] = 8, C++, J[8]++;
  for (gen_codes(static_ltree, L_CODES$1 + 1, J), C = 0; C < D_CODES$1; C++)
    static_dtree[C * 2 + 1] = 5, static_dtree[C * 2] = bi_reverse(C, 5);
  static_l_desc = new StaticTreeDesc(static_ltree, extra_lbits, LITERALS$1 + 1, L_CODES$1, MAX_BITS$1), static_d_desc = new StaticTreeDesc(static_dtree, extra_dbits, 0, D_CODES$1, MAX_BITS$1), static_bl_desc = new StaticTreeDesc(new Array(0), extra_blbits, 0, BL_CODES$1, MAX_BL_BITS);
}, init_block = (C) => {
  let e;
  for (e = 0; e < L_CODES$1; e++)
    C.dyn_ltree[e * 2] = 0;
  for (e = 0; e < D_CODES$1; e++)
    C.dyn_dtree[e * 2] = 0;
  for (e = 0; e < BL_CODES$1; e++)
    C.bl_tree[e * 2] = 0;
  C.dyn_ltree[END_BLOCK * 2] = 1, C.opt_len = C.static_len = 0, C.sym_next = C.matches = 0;
}, bi_windup = (C) => {
  C.bi_valid > 8 ? put_short(C, C.bi_buf) : C.bi_valid > 0 && (C.pending_buf[C.pending++] = C.bi_buf), C.bi_buf = 0, C.bi_valid = 0;
}, smaller = (C, e, T, $) => {
  const V = e * 2, J = T * 2;
  return C[V] < C[J] || C[V] === C[J] && $[e] <= $[T];
}, pqdownheap = (C, e, T) => {
  const $ = C.heap[T];
  let V = T << 1;
  for (; V <= C.heap_len && (V < C.heap_len && smaller(e, C.heap[V + 1], C.heap[V], C.depth) && V++, !smaller(e, $, C.heap[V], C.depth)); )
    C.heap[T] = C.heap[V], T = V, V <<= 1;
  C.heap[T] = $;
}, compress_block = (C, e, T) => {
  let $, V, J = 0, ee, te;
  if (C.sym_next !== 0)
    do
      $ = C.pending_buf[C.sym_buf + J++] & 255, $ += (C.pending_buf[C.sym_buf + J++] & 255) << 8, V = C.pending_buf[C.sym_buf + J++], $ === 0 ? send_code(C, V, e) : (ee = _length_code[V], send_code(C, ee + LITERALS$1 + 1, e), te = extra_lbits[ee], te !== 0 && (V -= base_length[ee], send_bits(C, V, te)), $--, ee = d_code($), send_code(C, ee, T), te = extra_dbits[ee], te !== 0 && ($ -= base_dist[ee], send_bits(C, $, te)));
    while (J < C.sym_next);
  send_code(C, END_BLOCK, e);
}, build_tree = (C, e) => {
  const T = e.dyn_tree, $ = e.stat_desc.static_tree, V = e.stat_desc.has_stree, J = e.stat_desc.elems;
  let ee, te, re = -1, ie;
  for (C.heap_len = 0, C.heap_max = HEAP_SIZE$1, ee = 0; ee < J; ee++)
    T[ee * 2] !== 0 ? (C.heap[++C.heap_len] = re = ee, C.depth[ee] = 0) : T[ee * 2 + 1] = 0;
  for (; C.heap_len < 2; )
    ie = C.heap[++C.heap_len] = re < 2 ? ++re : 0, T[ie * 2] = 1, C.depth[ie] = 0, C.opt_len--, V && (C.static_len -= $[ie * 2 + 1]);
  for (e.max_code = re, ee = C.heap_len >> 1; ee >= 1; ee--)
    pqdownheap(C, T, ee);
  ie = J;
  do
    ee = C.heap[
      1
      /*SMALLEST*/
    ], C.heap[
      1
      /*SMALLEST*/
    ] = C.heap[C.heap_len--], pqdownheap(
      C,
      T,
      1
      /*SMALLEST*/
    ), te = C.heap[
      1
      /*SMALLEST*/
    ], C.heap[--C.heap_max] = ee, C.heap[--C.heap_max] = te, T[ie * 2] = T[ee * 2] + T[te * 2], C.depth[ie] = (C.depth[ee] >= C.depth[te] ? C.depth[ee] : C.depth[te]) + 1, T[ee * 2 + 1] = T[te * 2 + 1] = ie, C.heap[
      1
      /*SMALLEST*/
    ] = ie++, pqdownheap(
      C,
      T,
      1
      /*SMALLEST*/
    );
  while (C.heap_len >= 2);
  C.heap[--C.heap_max] = C.heap[
    1
    /*SMALLEST*/
  ], gen_bitlen(C, e), gen_codes(T, re, C.bl_count);
}, scan_tree = (C, e, T) => {
  let $, V = -1, J, ee = e[0 * 2 + 1], te = 0, re = 7, ie = 4;
  for (ee === 0 && (re = 138, ie = 3), e[(T + 1) * 2 + 1] = 65535, $ = 0; $ <= T; $++)
    J = ee, ee = e[($ + 1) * 2 + 1], !(++te < re && J === ee) && (te < ie ? C.bl_tree[J * 2] += te : J !== 0 ? (J !== V && C.bl_tree[J * 2]++, C.bl_tree[REP_3_6 * 2]++) : te <= 10 ? C.bl_tree[REPZ_3_10 * 2]++ : C.bl_tree[REPZ_11_138 * 2]++, te = 0, V = J, ee === 0 ? (re = 138, ie = 3) : J === ee ? (re = 6, ie = 3) : (re = 7, ie = 4));
}, send_tree = (C, e, T) => {
  let $, V = -1, J, ee = e[0 * 2 + 1], te = 0, re = 7, ie = 4;
  for (ee === 0 && (re = 138, ie = 3), $ = 0; $ <= T; $++)
    if (J = ee, ee = e[($ + 1) * 2 + 1], !(++te < re && J === ee)) {
      if (te < ie)
        do
          send_code(C, J, C.bl_tree);
        while (--te !== 0);
      else J !== 0 ? (J !== V && (send_code(C, J, C.bl_tree), te--), send_code(C, REP_3_6, C.bl_tree), send_bits(C, te - 3, 2)) : te <= 10 ? (send_code(C, REPZ_3_10, C.bl_tree), send_bits(C, te - 3, 3)) : (send_code(C, REPZ_11_138, C.bl_tree), send_bits(C, te - 11, 7));
      te = 0, V = J, ee === 0 ? (re = 138, ie = 3) : J === ee ? (re = 6, ie = 3) : (re = 7, ie = 4);
    }
}, build_bl_tree = (C) => {
  let e;
  for (scan_tree(C, C.dyn_ltree, C.l_desc.max_code), scan_tree(C, C.dyn_dtree, C.d_desc.max_code), build_tree(C, C.bl_desc), e = BL_CODES$1 - 1; e >= 3 && C.bl_tree[bl_order[e] * 2 + 1] === 0; e--)
    ;
  return C.opt_len += 3 * (e + 1) + 5 + 5 + 4, e;
}, send_all_trees = (C, e, T, $) => {
  let V;
  for (send_bits(C, e - 257, 5), send_bits(C, T - 1, 5), send_bits(C, $ - 4, 4), V = 0; V < $; V++)
    send_bits(C, C.bl_tree[bl_order[V] * 2 + 1], 3);
  send_tree(C, C.dyn_ltree, e - 1), send_tree(C, C.dyn_dtree, T - 1);
}, detect_data_type = (C) => {
  let e = 4093624447, T;
  for (T = 0; T <= 31; T++, e >>>= 1)
    if (e & 1 && C.dyn_ltree[T * 2] !== 0)
      return Z_BINARY;
  if (C.dyn_ltree[9 * 2] !== 0 || C.dyn_ltree[10 * 2] !== 0 || C.dyn_ltree[13 * 2] !== 0)
    return Z_TEXT;
  for (T = 32; T < LITERALS$1; T++)
    if (C.dyn_ltree[T * 2] !== 0)
      return Z_TEXT;
  return Z_BINARY;
};
let static_init_done = !1;
const _tr_init$1 = (C) => {
  static_init_done || (tr_static_init(), static_init_done = !0), C.l_desc = new TreeDesc(C.dyn_ltree, static_l_desc), C.d_desc = new TreeDesc(C.dyn_dtree, static_d_desc), C.bl_desc = new TreeDesc(C.bl_tree, static_bl_desc), C.bi_buf = 0, C.bi_valid = 0, init_block(C);
}, _tr_stored_block$1 = (C, e, T, $) => {
  send_bits(C, (STORED_BLOCK << 1) + ($ ? 1 : 0), 3), bi_windup(C), put_short(C, T), put_short(C, ~T), T && C.pending_buf.set(C.window.subarray(e, e + T), C.pending), C.pending += T;
}, _tr_align$1 = (C) => {
  send_bits(C, STATIC_TREES << 1, 3), send_code(C, END_BLOCK, static_ltree), bi_flush(C);
}, _tr_flush_block$1 = (C, e, T, $) => {
  let V, J, ee = 0;
  C.level > 0 ? (C.strm.data_type === Z_UNKNOWN$1 && (C.strm.data_type = detect_data_type(C)), build_tree(C, C.l_desc), build_tree(C, C.d_desc), ee = build_bl_tree(C), V = C.opt_len + 3 + 7 >>> 3, J = C.static_len + 3 + 7 >>> 3, J <= V && (V = J)) : V = J = T + 5, T + 4 <= V && e !== -1 ? _tr_stored_block$1(C, e, T, $) : C.strategy === Z_FIXED$1 || J === V ? (send_bits(C, (STATIC_TREES << 1) + ($ ? 1 : 0), 3), compress_block(C, static_ltree, static_dtree)) : (send_bits(C, (DYN_TREES << 1) + ($ ? 1 : 0), 3), send_all_trees(C, C.l_desc.max_code + 1, C.d_desc.max_code + 1, ee + 1), compress_block(C, C.dyn_ltree, C.dyn_dtree)), init_block(C), $ && bi_windup(C);
}, _tr_tally$1 = (C, e, T) => (C.pending_buf[C.sym_buf + C.sym_next++] = e, C.pending_buf[C.sym_buf + C.sym_next++] = e >> 8, C.pending_buf[C.sym_buf + C.sym_next++] = T, e === 0 ? C.dyn_ltree[T * 2]++ : (C.matches++, e--, C.dyn_ltree[(_length_code[T] + LITERALS$1 + 1) * 2]++, C.dyn_dtree[d_code(e) * 2]++), C.sym_next === C.sym_end);
var _tr_init_1 = _tr_init$1, _tr_stored_block_1 = _tr_stored_block$1, _tr_flush_block_1 = _tr_flush_block$1, _tr_tally_1 = _tr_tally$1, _tr_align_1 = _tr_align$1, trees = {
  _tr_init: _tr_init_1,
  _tr_stored_block: _tr_stored_block_1,
  _tr_flush_block: _tr_flush_block_1,
  _tr_tally: _tr_tally_1,
  _tr_align: _tr_align_1
};
const adler32 = (C, e, T, $) => {
  let V = C & 65535 | 0, J = C >>> 16 & 65535 | 0, ee = 0;
  for (; T !== 0; ) {
    ee = T > 2e3 ? 2e3 : T, T -= ee;
    do
      V = V + e[$++] | 0, J = J + V | 0;
    while (--ee);
    V %= 65521, J %= 65521;
  }
  return V | J << 16 | 0;
};
var adler32_1 = adler32;
const makeTable = () => {
  let C, e = [];
  for (var T = 0; T < 256; T++) {
    C = T;
    for (var $ = 0; $ < 8; $++)
      C = C & 1 ? 3988292384 ^ C >>> 1 : C >>> 1;
    e[T] = C;
  }
  return e;
}, crcTable = new Uint32Array(makeTable()), crc32 = (C, e, T, $) => {
  const V = crcTable, J = $ + T;
  C ^= -1;
  for (let ee = $; ee < J; ee++)
    C = C >>> 8 ^ V[(C ^ e[ee]) & 255];
  return C ^ -1;
};
var crc32_1 = crc32, messages = {
  2: "need dictionary",
  /* Z_NEED_DICT       2  */
  1: "stream end",
  /* Z_STREAM_END      1  */
  0: "",
  /* Z_OK              0  */
  "-1": "file error",
  /* Z_ERRNO         (-1) */
  "-2": "stream error",
  /* Z_STREAM_ERROR  (-2) */
  "-3": "data error",
  /* Z_DATA_ERROR    (-3) */
  "-4": "insufficient memory",
  /* Z_MEM_ERROR     (-4) */
  "-5": "buffer error",
  /* Z_BUF_ERROR     (-5) */
  "-6": "incompatible version"
  /* Z_VERSION_ERROR (-6) */
}, constants$2 = {
  /* Allowed flush values; see deflate() and inflate() below for details */
  Z_NO_FLUSH: 0,
  Z_PARTIAL_FLUSH: 1,
  Z_SYNC_FLUSH: 2,
  Z_FULL_FLUSH: 3,
  Z_FINISH: 4,
  Z_BLOCK: 5,
  Z_TREES: 6,
  /* Return codes for the compression/decompression functions. Negative values
  * are errors, positive values are used for special but normal events.
  */
  Z_OK: 0,
  Z_STREAM_END: 1,
  Z_NEED_DICT: 2,
  Z_ERRNO: -1,
  Z_STREAM_ERROR: -2,
  Z_DATA_ERROR: -3,
  Z_MEM_ERROR: -4,
  Z_BUF_ERROR: -5,
  //Z_VERSION_ERROR: -6,
  /* compression levels */
  Z_NO_COMPRESSION: 0,
  Z_BEST_SPEED: 1,
  Z_BEST_COMPRESSION: 9,
  Z_DEFAULT_COMPRESSION: -1,
  Z_FILTERED: 1,
  Z_HUFFMAN_ONLY: 2,
  Z_RLE: 3,
  Z_FIXED: 4,
  Z_DEFAULT_STRATEGY: 0,
  /* Possible values of the data_type field (though see inflate()) */
  Z_BINARY: 0,
  Z_TEXT: 1,
  //Z_ASCII:                1, // = Z_TEXT (deprecated)
  Z_UNKNOWN: 2,
  /* The deflate compression method */
  Z_DEFLATED: 8
  //Z_NULL:                 null // Use -1 or null inline, depending on var type
};
const { _tr_init, _tr_stored_block, _tr_flush_block, _tr_tally, _tr_align } = trees, {
  Z_NO_FLUSH: Z_NO_FLUSH$2,
  Z_PARTIAL_FLUSH,
  Z_FULL_FLUSH: Z_FULL_FLUSH$1,
  Z_FINISH: Z_FINISH$3,
  Z_BLOCK: Z_BLOCK$1,
  Z_OK: Z_OK$3,
  Z_STREAM_END: Z_STREAM_END$3,
  Z_STREAM_ERROR: Z_STREAM_ERROR$2,
  Z_DATA_ERROR: Z_DATA_ERROR$2,
  Z_BUF_ERROR: Z_BUF_ERROR$1,
  Z_DEFAULT_COMPRESSION: Z_DEFAULT_COMPRESSION$1,
  Z_FILTERED,
  Z_HUFFMAN_ONLY,
  Z_RLE,
  Z_FIXED,
  Z_DEFAULT_STRATEGY: Z_DEFAULT_STRATEGY$1,
  Z_UNKNOWN,
  Z_DEFLATED: Z_DEFLATED$2
} = constants$2, MAX_MEM_LEVEL = 9, MAX_WBITS$1 = 15, DEF_MEM_LEVEL = 8, LENGTH_CODES = 29, LITERALS = 256, L_CODES = LITERALS + 1 + LENGTH_CODES, D_CODES = 30, BL_CODES = 19, HEAP_SIZE = 2 * L_CODES + 1, MAX_BITS = 15, MIN_MATCH = 3, MAX_MATCH = 258, MIN_LOOKAHEAD = MAX_MATCH + MIN_MATCH + 1, PRESET_DICT = 32, INIT_STATE = 42, GZIP_STATE = 57, EXTRA_STATE = 69, NAME_STATE = 73, COMMENT_STATE = 91, HCRC_STATE = 103, BUSY_STATE = 113, FINISH_STATE = 666, BS_NEED_MORE = 1, BS_BLOCK_DONE = 2, BS_FINISH_STARTED = 3, BS_FINISH_DONE = 4, OS_CODE = 3, err = (C, e) => (C.msg = messages[e], e), rank = (C) => C * 2 - (C > 4 ? 9 : 0), zero = (C) => {
  let e = C.length;
  for (; --e >= 0; )
    C[e] = 0;
}, slide_hash = (C) => {
  let e, T, $, V = C.w_size;
  e = C.hash_size, $ = e;
  do
    T = C.head[--$], C.head[$] = T >= V ? T - V : 0;
  while (--e);
  e = V, $ = e;
  do
    T = C.prev[--$], C.prev[$] = T >= V ? T - V : 0;
  while (--e);
};
let HASH_ZLIB = (C, e, T) => (e << C.hash_shift ^ T) & C.hash_mask, HASH = HASH_ZLIB;
const flush_pending = (C) => {
  const e = C.state;
  let T = e.pending;
  T > C.avail_out && (T = C.avail_out), T !== 0 && (C.output.set(e.pending_buf.subarray(e.pending_out, e.pending_out + T), C.next_out), C.next_out += T, e.pending_out += T, C.total_out += T, C.avail_out -= T, e.pending -= T, e.pending === 0 && (e.pending_out = 0));
}, flush_block_only = (C, e) => {
  _tr_flush_block(C, C.block_start >= 0 ? C.block_start : -1, C.strstart - C.block_start, e), C.block_start = C.strstart, flush_pending(C.strm);
}, put_byte = (C, e) => {
  C.pending_buf[C.pending++] = e;
}, putShortMSB = (C, e) => {
  C.pending_buf[C.pending++] = e >>> 8 & 255, C.pending_buf[C.pending++] = e & 255;
}, read_buf = (C, e, T, $) => {
  let V = C.avail_in;
  return V > $ && (V = $), V === 0 ? 0 : (C.avail_in -= V, e.set(C.input.subarray(C.next_in, C.next_in + V), T), C.state.wrap === 1 ? C.adler = adler32_1(C.adler, e, V, T) : C.state.wrap === 2 && (C.adler = crc32_1(C.adler, e, V, T)), C.next_in += V, C.total_in += V, V);
}, longest_match = (C, e) => {
  let T = C.max_chain_length, $ = C.strstart, V, J, ee = C.prev_length, te = C.nice_match;
  const re = C.strstart > C.w_size - MIN_LOOKAHEAD ? C.strstart - (C.w_size - MIN_LOOKAHEAD) : 0, ie = C.window, se = C.w_mask, de = C.prev, ue = C.strstart + MAX_MATCH;
  let fe = ie[$ + ee - 1], he = ie[$ + ee];
  C.prev_length >= C.good_match && (T >>= 2), te > C.lookahead && (te = C.lookahead);
  do
    if (V = e, !(ie[V + ee] !== he || ie[V + ee - 1] !== fe || ie[V] !== ie[$] || ie[++V] !== ie[$ + 1])) {
      $ += 2, V++;
      do
        ;
      while (ie[++$] === ie[++V] && ie[++$] === ie[++V] && ie[++$] === ie[++V] && ie[++$] === ie[++V] && ie[++$] === ie[++V] && ie[++$] === ie[++V] && ie[++$] === ie[++V] && ie[++$] === ie[++V] && $ < ue);
      if (J = MAX_MATCH - (ue - $), $ = ue - MAX_MATCH, J > ee) {
        if (C.match_start = e, ee = J, J >= te)
          break;
        fe = ie[$ + ee - 1], he = ie[$ + ee];
      }
    }
  while ((e = de[e & se]) > re && --T !== 0);
  return ee <= C.lookahead ? ee : C.lookahead;
}, fill_window = (C) => {
  const e = C.w_size;
  let T, $, V;
  do {
    if ($ = C.window_size - C.lookahead - C.strstart, C.strstart >= e + (e - MIN_LOOKAHEAD) && (C.window.set(C.window.subarray(e, e + e - $), 0), C.match_start -= e, C.strstart -= e, C.block_start -= e, C.insert > C.strstart && (C.insert = C.strstart), slide_hash(C), $ += e), C.strm.avail_in === 0)
      break;
    if (T = read_buf(C.strm, C.window, C.strstart + C.lookahead, $), C.lookahead += T, C.lookahead + C.insert >= MIN_MATCH)
      for (V = C.strstart - C.insert, C.ins_h = C.window[V], C.ins_h = HASH(C, C.ins_h, C.window[V + 1]); C.insert && (C.ins_h = HASH(C, C.ins_h, C.window[V + MIN_MATCH - 1]), C.prev[V & C.w_mask] = C.head[C.ins_h], C.head[C.ins_h] = V, V++, C.insert--, !(C.lookahead + C.insert < MIN_MATCH)); )
        ;
  } while (C.lookahead < MIN_LOOKAHEAD && C.strm.avail_in !== 0);
}, deflate_stored = (C, e) => {
  let T = C.pending_buf_size - 5 > C.w_size ? C.w_size : C.pending_buf_size - 5, $, V, J, ee = 0, te = C.strm.avail_in;
  do {
    if ($ = 65535, J = C.bi_valid + 42 >> 3, C.strm.avail_out < J || (J = C.strm.avail_out - J, V = C.strstart - C.block_start, $ > V + C.strm.avail_in && ($ = V + C.strm.avail_in), $ > J && ($ = J), $ < T && ($ === 0 && e !== Z_FINISH$3 || e === Z_NO_FLUSH$2 || $ !== V + C.strm.avail_in)))
      break;
    ee = e === Z_FINISH$3 && $ === V + C.strm.avail_in ? 1 : 0, _tr_stored_block(C, 0, 0, ee), C.pending_buf[C.pending - 4] = $, C.pending_buf[C.pending - 3] = $ >> 8, C.pending_buf[C.pending - 2] = ~$, C.pending_buf[C.pending - 1] = ~$ >> 8, flush_pending(C.strm), V && (V > $ && (V = $), C.strm.output.set(C.window.subarray(C.block_start, C.block_start + V), C.strm.next_out), C.strm.next_out += V, C.strm.avail_out -= V, C.strm.total_out += V, C.block_start += V, $ -= V), $ && (read_buf(C.strm, C.strm.output, C.strm.next_out, $), C.strm.next_out += $, C.strm.avail_out -= $, C.strm.total_out += $);
  } while (ee === 0);
  return te -= C.strm.avail_in, te && (te >= C.w_size ? (C.matches = 2, C.window.set(C.strm.input.subarray(C.strm.next_in - C.w_size, C.strm.next_in), 0), C.strstart = C.w_size, C.insert = C.strstart) : (C.window_size - C.strstart <= te && (C.strstart -= C.w_size, C.window.set(C.window.subarray(C.w_size, C.w_size + C.strstart), 0), C.matches < 2 && C.matches++, C.insert > C.strstart && (C.insert = C.strstart)), C.window.set(C.strm.input.subarray(C.strm.next_in - te, C.strm.next_in), C.strstart), C.strstart += te, C.insert += te > C.w_size - C.insert ? C.w_size - C.insert : te), C.block_start = C.strstart), C.high_water < C.strstart && (C.high_water = C.strstart), ee ? BS_FINISH_DONE : e !== Z_NO_FLUSH$2 && e !== Z_FINISH$3 && C.strm.avail_in === 0 && C.strstart === C.block_start ? BS_BLOCK_DONE : (J = C.window_size - C.strstart, C.strm.avail_in > J && C.block_start >= C.w_size && (C.block_start -= C.w_size, C.strstart -= C.w_size, C.window.set(C.window.subarray(C.w_size, C.w_size + C.strstart), 0), C.matches < 2 && C.matches++, J += C.w_size, C.insert > C.strstart && (C.insert = C.strstart)), J > C.strm.avail_in && (J = C.strm.avail_in), J && (read_buf(C.strm, C.window, C.strstart, J), C.strstart += J, C.insert += J > C.w_size - C.insert ? C.w_size - C.insert : J), C.high_water < C.strstart && (C.high_water = C.strstart), J = C.bi_valid + 42 >> 3, J = C.pending_buf_size - J > 65535 ? 65535 : C.pending_buf_size - J, T = J > C.w_size ? C.w_size : J, V = C.strstart - C.block_start, (V >= T || (V || e === Z_FINISH$3) && e !== Z_NO_FLUSH$2 && C.strm.avail_in === 0 && V <= J) && ($ = V > J ? J : V, ee = e === Z_FINISH$3 && C.strm.avail_in === 0 && $ === V ? 1 : 0, _tr_stored_block(C, C.block_start, $, ee), C.block_start += $, flush_pending(C.strm)), ee ? BS_FINISH_STARTED : BS_NEED_MORE);
}, deflate_fast = (C, e) => {
  let T, $;
  for (; ; ) {
    if (C.lookahead < MIN_LOOKAHEAD) {
      if (fill_window(C), C.lookahead < MIN_LOOKAHEAD && e === Z_NO_FLUSH$2)
        return BS_NEED_MORE;
      if (C.lookahead === 0)
        break;
    }
    if (T = 0, C.lookahead >= MIN_MATCH && (C.ins_h = HASH(C, C.ins_h, C.window[C.strstart + MIN_MATCH - 1]), T = C.prev[C.strstart & C.w_mask] = C.head[C.ins_h], C.head[C.ins_h] = C.strstart), T !== 0 && C.strstart - T <= C.w_size - MIN_LOOKAHEAD && (C.match_length = longest_match(C, T)), C.match_length >= MIN_MATCH)
      if ($ = _tr_tally(C, C.strstart - C.match_start, C.match_length - MIN_MATCH), C.lookahead -= C.match_length, C.match_length <= C.max_lazy_match && C.lookahead >= MIN_MATCH) {
        C.match_length--;
        do
          C.strstart++, C.ins_h = HASH(C, C.ins_h, C.window[C.strstart + MIN_MATCH - 1]), T = C.prev[C.strstart & C.w_mask] = C.head[C.ins_h], C.head[C.ins_h] = C.strstart;
        while (--C.match_length !== 0);
        C.strstart++;
      } else
        C.strstart += C.match_length, C.match_length = 0, C.ins_h = C.window[C.strstart], C.ins_h = HASH(C, C.ins_h, C.window[C.strstart + 1]);
    else
      $ = _tr_tally(C, 0, C.window[C.strstart]), C.lookahead--, C.strstart++;
    if ($ && (flush_block_only(C, !1), C.strm.avail_out === 0))
      return BS_NEED_MORE;
  }
  return C.insert = C.strstart < MIN_MATCH - 1 ? C.strstart : MIN_MATCH - 1, e === Z_FINISH$3 ? (flush_block_only(C, !0), C.strm.avail_out === 0 ? BS_FINISH_STARTED : BS_FINISH_DONE) : C.sym_next && (flush_block_only(C, !1), C.strm.avail_out === 0) ? BS_NEED_MORE : BS_BLOCK_DONE;
}, deflate_slow = (C, e) => {
  let T, $, V;
  for (; ; ) {
    if (C.lookahead < MIN_LOOKAHEAD) {
      if (fill_window(C), C.lookahead < MIN_LOOKAHEAD && e === Z_NO_FLUSH$2)
        return BS_NEED_MORE;
      if (C.lookahead === 0)
        break;
    }
    if (T = 0, C.lookahead >= MIN_MATCH && (C.ins_h = HASH(C, C.ins_h, C.window[C.strstart + MIN_MATCH - 1]), T = C.prev[C.strstart & C.w_mask] = C.head[C.ins_h], C.head[C.ins_h] = C.strstart), C.prev_length = C.match_length, C.prev_match = C.match_start, C.match_length = MIN_MATCH - 1, T !== 0 && C.prev_length < C.max_lazy_match && C.strstart - T <= C.w_size - MIN_LOOKAHEAD && (C.match_length = longest_match(C, T), C.match_length <= 5 && (C.strategy === Z_FILTERED || C.match_length === MIN_MATCH && C.strstart - C.match_start > 4096) && (C.match_length = MIN_MATCH - 1)), C.prev_length >= MIN_MATCH && C.match_length <= C.prev_length) {
      V = C.strstart + C.lookahead - MIN_MATCH, $ = _tr_tally(C, C.strstart - 1 - C.prev_match, C.prev_length - MIN_MATCH), C.lookahead -= C.prev_length - 1, C.prev_length -= 2;
      do
        ++C.strstart <= V && (C.ins_h = HASH(C, C.ins_h, C.window[C.strstart + MIN_MATCH - 1]), T = C.prev[C.strstart & C.w_mask] = C.head[C.ins_h], C.head[C.ins_h] = C.strstart);
      while (--C.prev_length !== 0);
      if (C.match_available = 0, C.match_length = MIN_MATCH - 1, C.strstart++, $ && (flush_block_only(C, !1), C.strm.avail_out === 0))
        return BS_NEED_MORE;
    } else if (C.match_available) {
      if ($ = _tr_tally(C, 0, C.window[C.strstart - 1]), $ && flush_block_only(C, !1), C.strstart++, C.lookahead--, C.strm.avail_out === 0)
        return BS_NEED_MORE;
    } else
      C.match_available = 1, C.strstart++, C.lookahead--;
  }
  return C.match_available && ($ = _tr_tally(C, 0, C.window[C.strstart - 1]), C.match_available = 0), C.insert = C.strstart < MIN_MATCH - 1 ? C.strstart : MIN_MATCH - 1, e === Z_FINISH$3 ? (flush_block_only(C, !0), C.strm.avail_out === 0 ? BS_FINISH_STARTED : BS_FINISH_DONE) : C.sym_next && (flush_block_only(C, !1), C.strm.avail_out === 0) ? BS_NEED_MORE : BS_BLOCK_DONE;
}, deflate_rle = (C, e) => {
  let T, $, V, J;
  const ee = C.window;
  for (; ; ) {
    if (C.lookahead <= MAX_MATCH) {
      if (fill_window(C), C.lookahead <= MAX_MATCH && e === Z_NO_FLUSH$2)
        return BS_NEED_MORE;
      if (C.lookahead === 0)
        break;
    }
    if (C.match_length = 0, C.lookahead >= MIN_MATCH && C.strstart > 0 && (V = C.strstart - 1, $ = ee[V], $ === ee[++V] && $ === ee[++V] && $ === ee[++V])) {
      J = C.strstart + MAX_MATCH;
      do
        ;
      while ($ === ee[++V] && $ === ee[++V] && $ === ee[++V] && $ === ee[++V] && $ === ee[++V] && $ === ee[++V] && $ === ee[++V] && $ === ee[++V] && V < J);
      C.match_length = MAX_MATCH - (J - V), C.match_length > C.lookahead && (C.match_length = C.lookahead);
    }
    if (C.match_length >= MIN_MATCH ? (T = _tr_tally(C, 1, C.match_length - MIN_MATCH), C.lookahead -= C.match_length, C.strstart += C.match_length, C.match_length = 0) : (T = _tr_tally(C, 0, C.window[C.strstart]), C.lookahead--, C.strstart++), T && (flush_block_only(C, !1), C.strm.avail_out === 0))
      return BS_NEED_MORE;
  }
  return C.insert = 0, e === Z_FINISH$3 ? (flush_block_only(C, !0), C.strm.avail_out === 0 ? BS_FINISH_STARTED : BS_FINISH_DONE) : C.sym_next && (flush_block_only(C, !1), C.strm.avail_out === 0) ? BS_NEED_MORE : BS_BLOCK_DONE;
}, deflate_huff = (C, e) => {
  let T;
  for (; ; ) {
    if (C.lookahead === 0 && (fill_window(C), C.lookahead === 0)) {
      if (e === Z_NO_FLUSH$2)
        return BS_NEED_MORE;
      break;
    }
    if (C.match_length = 0, T = _tr_tally(C, 0, C.window[C.strstart]), C.lookahead--, C.strstart++, T && (flush_block_only(C, !1), C.strm.avail_out === 0))
      return BS_NEED_MORE;
  }
  return C.insert = 0, e === Z_FINISH$3 ? (flush_block_only(C, !0), C.strm.avail_out === 0 ? BS_FINISH_STARTED : BS_FINISH_DONE) : C.sym_next && (flush_block_only(C, !1), C.strm.avail_out === 0) ? BS_NEED_MORE : BS_BLOCK_DONE;
};
function Config(C, e, T, $, V) {
  this.good_length = C, this.max_lazy = e, this.nice_length = T, this.max_chain = $, this.func = V;
}
const configuration_table = [
  /*      good lazy nice chain */
  new Config(0, 0, 0, 0, deflate_stored),
  /* 0 store only */
  new Config(4, 4, 8, 4, deflate_fast),
  /* 1 max speed, no lazy matches */
  new Config(4, 5, 16, 8, deflate_fast),
  /* 2 */
  new Config(4, 6, 32, 32, deflate_fast),
  /* 3 */
  new Config(4, 4, 16, 16, deflate_slow),
  /* 4 lazy matches */
  new Config(8, 16, 32, 32, deflate_slow),
  /* 5 */
  new Config(8, 16, 128, 128, deflate_slow),
  /* 6 */
  new Config(8, 32, 128, 256, deflate_slow),
  /* 7 */
  new Config(32, 128, 258, 1024, deflate_slow),
  /* 8 */
  new Config(32, 258, 258, 4096, deflate_slow)
  /* 9 max compression */
], lm_init = (C) => {
  C.window_size = 2 * C.w_size, zero(C.head), C.max_lazy_match = configuration_table[C.level].max_lazy, C.good_match = configuration_table[C.level].good_length, C.nice_match = configuration_table[C.level].nice_length, C.max_chain_length = configuration_table[C.level].max_chain, C.strstart = 0, C.block_start = 0, C.lookahead = 0, C.insert = 0, C.match_length = C.prev_length = MIN_MATCH - 1, C.match_available = 0, C.ins_h = 0;
};
function DeflateState() {
  this.strm = null, this.status = 0, this.pending_buf = null, this.pending_buf_size = 0, this.pending_out = 0, this.pending = 0, this.wrap = 0, this.gzhead = null, this.gzindex = 0, this.method = Z_DEFLATED$2, this.last_flush = -1, this.w_size = 0, this.w_bits = 0, this.w_mask = 0, this.window = null, this.window_size = 0, this.prev = null, this.head = null, this.ins_h = 0, this.hash_size = 0, this.hash_bits = 0, this.hash_mask = 0, this.hash_shift = 0, this.block_start = 0, this.match_length = 0, this.prev_match = 0, this.match_available = 0, this.strstart = 0, this.match_start = 0, this.lookahead = 0, this.prev_length = 0, this.max_chain_length = 0, this.max_lazy_match = 0, this.level = 0, this.strategy = 0, this.good_match = 0, this.nice_match = 0, this.dyn_ltree = new Uint16Array(HEAP_SIZE * 2), this.dyn_dtree = new Uint16Array((2 * D_CODES + 1) * 2), this.bl_tree = new Uint16Array((2 * BL_CODES + 1) * 2), zero(this.dyn_ltree), zero(this.dyn_dtree), zero(this.bl_tree), this.l_desc = null, this.d_desc = null, this.bl_desc = null, this.bl_count = new Uint16Array(MAX_BITS + 1), this.heap = new Uint16Array(2 * L_CODES + 1), zero(this.heap), this.heap_len = 0, this.heap_max = 0, this.depth = new Uint16Array(2 * L_CODES + 1), zero(this.depth), this.sym_buf = 0, this.lit_bufsize = 0, this.sym_next = 0, this.sym_end = 0, this.opt_len = 0, this.static_len = 0, this.matches = 0, this.insert = 0, this.bi_buf = 0, this.bi_valid = 0;
}
const deflateStateCheck = (C) => {
  if (!C)
    return 1;
  const e = C.state;
  return !e || e.strm !== C || e.status !== INIT_STATE && //#ifdef GZIP
  e.status !== GZIP_STATE && //#endif
  e.status !== EXTRA_STATE && e.status !== NAME_STATE && e.status !== COMMENT_STATE && e.status !== HCRC_STATE && e.status !== BUSY_STATE && e.status !== FINISH_STATE ? 1 : 0;
}, deflateResetKeep = (C) => {
  if (deflateStateCheck(C))
    return err(C, Z_STREAM_ERROR$2);
  C.total_in = C.total_out = 0, C.data_type = Z_UNKNOWN;
  const e = C.state;
  return e.pending = 0, e.pending_out = 0, e.wrap < 0 && (e.wrap = -e.wrap), e.status = //#ifdef GZIP
  e.wrap === 2 ? GZIP_STATE : (
    //#endif
    e.wrap ? INIT_STATE : BUSY_STATE
  ), C.adler = e.wrap === 2 ? 0 : 1, e.last_flush = -2, _tr_init(e), Z_OK$3;
}, deflateReset = (C) => {
  const e = deflateResetKeep(C);
  return e === Z_OK$3 && lm_init(C.state), e;
}, deflateSetHeader = (C, e) => deflateStateCheck(C) || C.state.wrap !== 2 ? Z_STREAM_ERROR$2 : (C.state.gzhead = e, Z_OK$3), deflateInit2 = (C, e, T, $, V, J) => {
  if (!C)
    return Z_STREAM_ERROR$2;
  let ee = 1;
  if (e === Z_DEFAULT_COMPRESSION$1 && (e = 6), $ < 0 ? (ee = 0, $ = -$) : $ > 15 && (ee = 2, $ -= 16), V < 1 || V > MAX_MEM_LEVEL || T !== Z_DEFLATED$2 || $ < 8 || $ > 15 || e < 0 || e > 9 || J < 0 || J > Z_FIXED || $ === 8 && ee !== 1)
    return err(C, Z_STREAM_ERROR$2);
  $ === 8 && ($ = 9);
  const te = new DeflateState();
  return C.state = te, te.strm = C, te.status = INIT_STATE, te.wrap = ee, te.gzhead = null, te.w_bits = $, te.w_size = 1 << te.w_bits, te.w_mask = te.w_size - 1, te.hash_bits = V + 7, te.hash_size = 1 << te.hash_bits, te.hash_mask = te.hash_size - 1, te.hash_shift = ~~((te.hash_bits + MIN_MATCH - 1) / MIN_MATCH), te.window = new Uint8Array(te.w_size * 2), te.head = new Uint16Array(te.hash_size), te.prev = new Uint16Array(te.w_size), te.lit_bufsize = 1 << V + 6, te.pending_buf_size = te.lit_bufsize * 4, te.pending_buf = new Uint8Array(te.pending_buf_size), te.sym_buf = te.lit_bufsize, te.sym_end = (te.lit_bufsize - 1) * 3, te.level = e, te.strategy = J, te.method = T, deflateReset(C);
}, deflateInit = (C, e) => deflateInit2(C, e, Z_DEFLATED$2, MAX_WBITS$1, DEF_MEM_LEVEL, Z_DEFAULT_STRATEGY$1), deflate$2 = (C, e) => {
  if (deflateStateCheck(C) || e > Z_BLOCK$1 || e < 0)
    return C ? err(C, Z_STREAM_ERROR$2) : Z_STREAM_ERROR$2;
  const T = C.state;
  if (!C.output || C.avail_in !== 0 && !C.input || T.status === FINISH_STATE && e !== Z_FINISH$3)
    return err(C, C.avail_out === 0 ? Z_BUF_ERROR$1 : Z_STREAM_ERROR$2);
  const $ = T.last_flush;
  if (T.last_flush = e, T.pending !== 0) {
    if (flush_pending(C), C.avail_out === 0)
      return T.last_flush = -1, Z_OK$3;
  } else if (C.avail_in === 0 && rank(e) <= rank($) && e !== Z_FINISH$3)
    return err(C, Z_BUF_ERROR$1);
  if (T.status === FINISH_STATE && C.avail_in !== 0)
    return err(C, Z_BUF_ERROR$1);
  if (T.status === INIT_STATE && T.wrap === 0 && (T.status = BUSY_STATE), T.status === INIT_STATE) {
    let V = Z_DEFLATED$2 + (T.w_bits - 8 << 4) << 8, J = -1;
    if (T.strategy >= Z_HUFFMAN_ONLY || T.level < 2 ? J = 0 : T.level < 6 ? J = 1 : T.level === 6 ? J = 2 : J = 3, V |= J << 6, T.strstart !== 0 && (V |= PRESET_DICT), V += 31 - V % 31, putShortMSB(T, V), T.strstart !== 0 && (putShortMSB(T, C.adler >>> 16), putShortMSB(T, C.adler & 65535)), C.adler = 1, T.status = BUSY_STATE, flush_pending(C), T.pending !== 0)
      return T.last_flush = -1, Z_OK$3;
  }
  if (T.status === GZIP_STATE) {
    if (C.adler = 0, put_byte(T, 31), put_byte(T, 139), put_byte(T, 8), T.gzhead)
      put_byte(
        T,
        (T.gzhead.text ? 1 : 0) + (T.gzhead.hcrc ? 2 : 0) + (T.gzhead.extra ? 4 : 0) + (T.gzhead.name ? 8 : 0) + (T.gzhead.comment ? 16 : 0)
      ), put_byte(T, T.gzhead.time & 255), put_byte(T, T.gzhead.time >> 8 & 255), put_byte(T, T.gzhead.time >> 16 & 255), put_byte(T, T.gzhead.time >> 24 & 255), put_byte(T, T.level === 9 ? 2 : T.strategy >= Z_HUFFMAN_ONLY || T.level < 2 ? 4 : 0), put_byte(T, T.gzhead.os & 255), T.gzhead.extra && T.gzhead.extra.length && (put_byte(T, T.gzhead.extra.length & 255), put_byte(T, T.gzhead.extra.length >> 8 & 255)), T.gzhead.hcrc && (C.adler = crc32_1(C.adler, T.pending_buf, T.pending, 0)), T.gzindex = 0, T.status = EXTRA_STATE;
    else if (put_byte(T, 0), put_byte(T, 0), put_byte(T, 0), put_byte(T, 0), put_byte(T, 0), put_byte(T, T.level === 9 ? 2 : T.strategy >= Z_HUFFMAN_ONLY || T.level < 2 ? 4 : 0), put_byte(T, OS_CODE), T.status = BUSY_STATE, flush_pending(C), T.pending !== 0)
      return T.last_flush = -1, Z_OK$3;
  }
  if (T.status === EXTRA_STATE) {
    if (T.gzhead.extra) {
      let V = T.pending, J = (T.gzhead.extra.length & 65535) - T.gzindex;
      for (; T.pending + J > T.pending_buf_size; ) {
        let te = T.pending_buf_size - T.pending;
        if (T.pending_buf.set(T.gzhead.extra.subarray(T.gzindex, T.gzindex + te), T.pending), T.pending = T.pending_buf_size, T.gzhead.hcrc && T.pending > V && (C.adler = crc32_1(C.adler, T.pending_buf, T.pending - V, V)), T.gzindex += te, flush_pending(C), T.pending !== 0)
          return T.last_flush = -1, Z_OK$3;
        V = 0, J -= te;
      }
      let ee = new Uint8Array(T.gzhead.extra);
      T.pending_buf.set(ee.subarray(T.gzindex, T.gzindex + J), T.pending), T.pending += J, T.gzhead.hcrc && T.pending > V && (C.adler = crc32_1(C.adler, T.pending_buf, T.pending - V, V)), T.gzindex = 0;
    }
    T.status = NAME_STATE;
  }
  if (T.status === NAME_STATE) {
    if (T.gzhead.name) {
      let V = T.pending, J;
      do {
        if (T.pending === T.pending_buf_size) {
          if (T.gzhead.hcrc && T.pending > V && (C.adler = crc32_1(C.adler, T.pending_buf, T.pending - V, V)), flush_pending(C), T.pending !== 0)
            return T.last_flush = -1, Z_OK$3;
          V = 0;
        }
        T.gzindex < T.gzhead.name.length ? J = T.gzhead.name.charCodeAt(T.gzindex++) & 255 : J = 0, put_byte(T, J);
      } while (J !== 0);
      T.gzhead.hcrc && T.pending > V && (C.adler = crc32_1(C.adler, T.pending_buf, T.pending - V, V)), T.gzindex = 0;
    }
    T.status = COMMENT_STATE;
  }
  if (T.status === COMMENT_STATE) {
    if (T.gzhead.comment) {
      let V = T.pending, J;
      do {
        if (T.pending === T.pending_buf_size) {
          if (T.gzhead.hcrc && T.pending > V && (C.adler = crc32_1(C.adler, T.pending_buf, T.pending - V, V)), flush_pending(C), T.pending !== 0)
            return T.last_flush = -1, Z_OK$3;
          V = 0;
        }
        T.gzindex < T.gzhead.comment.length ? J = T.gzhead.comment.charCodeAt(T.gzindex++) & 255 : J = 0, put_byte(T, J);
      } while (J !== 0);
      T.gzhead.hcrc && T.pending > V && (C.adler = crc32_1(C.adler, T.pending_buf, T.pending - V, V));
    }
    T.status = HCRC_STATE;
  }
  if (T.status === HCRC_STATE) {
    if (T.gzhead.hcrc) {
      if (T.pending + 2 > T.pending_buf_size && (flush_pending(C), T.pending !== 0))
        return T.last_flush = -1, Z_OK$3;
      put_byte(T, C.adler & 255), put_byte(T, C.adler >> 8 & 255), C.adler = 0;
    }
    if (T.status = BUSY_STATE, flush_pending(C), T.pending !== 0)
      return T.last_flush = -1, Z_OK$3;
  }
  if (C.avail_in !== 0 || T.lookahead !== 0 || e !== Z_NO_FLUSH$2 && T.status !== FINISH_STATE) {
    let V = T.level === 0 ? deflate_stored(T, e) : T.strategy === Z_HUFFMAN_ONLY ? deflate_huff(T, e) : T.strategy === Z_RLE ? deflate_rle(T, e) : configuration_table[T.level].func(T, e);
    if ((V === BS_FINISH_STARTED || V === BS_FINISH_DONE) && (T.status = FINISH_STATE), V === BS_NEED_MORE || V === BS_FINISH_STARTED)
      return C.avail_out === 0 && (T.last_flush = -1), Z_OK$3;
    if (V === BS_BLOCK_DONE && (e === Z_PARTIAL_FLUSH ? _tr_align(T) : e !== Z_BLOCK$1 && (_tr_stored_block(T, 0, 0, !1), e === Z_FULL_FLUSH$1 && (zero(T.head), T.lookahead === 0 && (T.strstart = 0, T.block_start = 0, T.insert = 0))), flush_pending(C), C.avail_out === 0))
      return T.last_flush = -1, Z_OK$3;
  }
  return e !== Z_FINISH$3 ? Z_OK$3 : T.wrap <= 0 ? Z_STREAM_END$3 : (T.wrap === 2 ? (put_byte(T, C.adler & 255), put_byte(T, C.adler >> 8 & 255), put_byte(T, C.adler >> 16 & 255), put_byte(T, C.adler >> 24 & 255), put_byte(T, C.total_in & 255), put_byte(T, C.total_in >> 8 & 255), put_byte(T, C.total_in >> 16 & 255), put_byte(T, C.total_in >> 24 & 255)) : (putShortMSB(T, C.adler >>> 16), putShortMSB(T, C.adler & 65535)), flush_pending(C), T.wrap > 0 && (T.wrap = -T.wrap), T.pending !== 0 ? Z_OK$3 : Z_STREAM_END$3);
}, deflateEnd = (C) => {
  if (deflateStateCheck(C))
    return Z_STREAM_ERROR$2;
  const e = C.state.status;
  return C.state = null, e === BUSY_STATE ? err(C, Z_DATA_ERROR$2) : Z_OK$3;
}, deflateSetDictionary = (C, e) => {
  let T = e.length;
  if (deflateStateCheck(C))
    return Z_STREAM_ERROR$2;
  const $ = C.state, V = $.wrap;
  if (V === 2 || V === 1 && $.status !== INIT_STATE || $.lookahead)
    return Z_STREAM_ERROR$2;
  if (V === 1 && (C.adler = adler32_1(C.adler, e, T, 0)), $.wrap = 0, T >= $.w_size) {
    V === 0 && (zero($.head), $.strstart = 0, $.block_start = 0, $.insert = 0);
    let re = new Uint8Array($.w_size);
    re.set(e.subarray(T - $.w_size, T), 0), e = re, T = $.w_size;
  }
  const J = C.avail_in, ee = C.next_in, te = C.input;
  for (C.avail_in = T, C.next_in = 0, C.input = e, fill_window($); $.lookahead >= MIN_MATCH; ) {
    let re = $.strstart, ie = $.lookahead - (MIN_MATCH - 1);
    do
      $.ins_h = HASH($, $.ins_h, $.window[re + MIN_MATCH - 1]), $.prev[re & $.w_mask] = $.head[$.ins_h], $.head[$.ins_h] = re, re++;
    while (--ie);
    $.strstart = re, $.lookahead = MIN_MATCH - 1, fill_window($);
  }
  return $.strstart += $.lookahead, $.block_start = $.strstart, $.insert = $.lookahead, $.lookahead = 0, $.match_length = $.prev_length = MIN_MATCH - 1, $.match_available = 0, C.next_in = ee, C.input = te, C.avail_in = J, $.wrap = V, Z_OK$3;
};
var deflateInit_1 = deflateInit, deflateInit2_1 = deflateInit2, deflateReset_1 = deflateReset, deflateResetKeep_1 = deflateResetKeep, deflateSetHeader_1 = deflateSetHeader, deflate_2$1 = deflate$2, deflateEnd_1 = deflateEnd, deflateSetDictionary_1 = deflateSetDictionary, deflateInfo = "pako deflate (from Nodeca project)", deflate_1$2 = {
  deflateInit: deflateInit_1,
  deflateInit2: deflateInit2_1,
  deflateReset: deflateReset_1,
  deflateResetKeep: deflateResetKeep_1,
  deflateSetHeader: deflateSetHeader_1,
  deflate: deflate_2$1,
  deflateEnd: deflateEnd_1,
  deflateSetDictionary: deflateSetDictionary_1,
  deflateInfo
};
const _has = (C, e) => Object.prototype.hasOwnProperty.call(C, e);
var assign = function(C) {
  const e = Array.prototype.slice.call(arguments, 1);
  for (; e.length; ) {
    const T = e.shift();
    if (T) {
      if (typeof T != "object")
        throw new TypeError(T + "must be non-object");
      for (const $ in T)
        _has(T, $) && (C[$] = T[$]);
    }
  }
  return C;
}, flattenChunks = (C) => {
  let e = 0;
  for (let $ = 0, V = C.length; $ < V; $++)
    e += C[$].length;
  const T = new Uint8Array(e);
  for (let $ = 0, V = 0, J = C.length; $ < J; $++) {
    let ee = C[$];
    T.set(ee, V), V += ee.length;
  }
  return T;
}, common = {
  assign,
  flattenChunks
};
let STR_APPLY_UIA_OK = !0;
try {
  String.fromCharCode.apply(null, new Uint8Array(1));
} catch {
  STR_APPLY_UIA_OK = !1;
}
const _utf8len = new Uint8Array(256);
for (let C = 0; C < 256; C++)
  _utf8len[C] = C >= 252 ? 6 : C >= 248 ? 5 : C >= 240 ? 4 : C >= 224 ? 3 : C >= 192 ? 2 : 1;
_utf8len[254] = _utf8len[254] = 1;
var string2buf = (C) => {
  if (typeof TextEncoder == "function" && TextEncoder.prototype.encode)
    return new TextEncoder().encode(C);
  let e, T, $, V, J, ee = C.length, te = 0;
  for (V = 0; V < ee; V++)
    T = C.charCodeAt(V), (T & 64512) === 55296 && V + 1 < ee && ($ = C.charCodeAt(V + 1), ($ & 64512) === 56320 && (T = 65536 + (T - 55296 << 10) + ($ - 56320), V++)), te += T < 128 ? 1 : T < 2048 ? 2 : T < 65536 ? 3 : 4;
  for (e = new Uint8Array(te), J = 0, V = 0; J < te; V++)
    T = C.charCodeAt(V), (T & 64512) === 55296 && V + 1 < ee && ($ = C.charCodeAt(V + 1), ($ & 64512) === 56320 && (T = 65536 + (T - 55296 << 10) + ($ - 56320), V++)), T < 128 ? e[J++] = T : T < 2048 ? (e[J++] = 192 | T >>> 6, e[J++] = 128 | T & 63) : T < 65536 ? (e[J++] = 224 | T >>> 12, e[J++] = 128 | T >>> 6 & 63, e[J++] = 128 | T & 63) : (e[J++] = 240 | T >>> 18, e[J++] = 128 | T >>> 12 & 63, e[J++] = 128 | T >>> 6 & 63, e[J++] = 128 | T & 63);
  return e;
};
const buf2binstring = (C, e) => {
  if (e < 65534 && C.subarray && STR_APPLY_UIA_OK)
    return String.fromCharCode.apply(null, C.length === e ? C : C.subarray(0, e));
  let T = "";
  for (let $ = 0; $ < e; $++)
    T += String.fromCharCode(C[$]);
  return T;
};
var buf2string = (C, e) => {
  const T = e || C.length;
  if (typeof TextDecoder == "function" && TextDecoder.prototype.decode)
    return new TextDecoder().decode(C.subarray(0, e));
  let $, V;
  const J = new Array(T * 2);
  for (V = 0, $ = 0; $ < T; ) {
    let ee = C[$++];
    if (ee < 128) {
      J[V++] = ee;
      continue;
    }
    let te = _utf8len[ee];
    if (te > 4) {
      J[V++] = 65533, $ += te - 1;
      continue;
    }
    for (ee &= te === 2 ? 31 : te === 3 ? 15 : 7; te > 1 && $ < T; )
      ee = ee << 6 | C[$++] & 63, te--;
    if (te > 1) {
      J[V++] = 65533;
      continue;
    }
    ee < 65536 ? J[V++] = ee : (ee -= 65536, J[V++] = 55296 | ee >> 10 & 1023, J[V++] = 56320 | ee & 1023);
  }
  return buf2binstring(J, V);
}, utf8border = (C, e) => {
  e = e || C.length, e > C.length && (e = C.length);
  let T = e - 1;
  for (; T >= 0 && (C[T] & 192) === 128; )
    T--;
  return T < 0 || T === 0 ? e : T + _utf8len[C[T]] > e ? T : e;
}, strings = {
  string2buf,
  buf2string,
  utf8border
};
function ZStream() {
  this.input = null, this.next_in = 0, this.avail_in = 0, this.total_in = 0, this.output = null, this.next_out = 0, this.avail_out = 0, this.total_out = 0, this.msg = "", this.state = null, this.data_type = 2, this.adler = 0;
}
var zstream = ZStream;
const toString$1 = Object.prototype.toString, {
  Z_NO_FLUSH: Z_NO_FLUSH$1,
  Z_SYNC_FLUSH,
  Z_FULL_FLUSH,
  Z_FINISH: Z_FINISH$2,
  Z_OK: Z_OK$2,
  Z_STREAM_END: Z_STREAM_END$2,
  Z_DEFAULT_COMPRESSION,
  Z_DEFAULT_STRATEGY,
  Z_DEFLATED: Z_DEFLATED$1
} = constants$2;
function Deflate$1(C) {
  this.options = common.assign({
    level: Z_DEFAULT_COMPRESSION,
    method: Z_DEFLATED$1,
    chunkSize: 16384,
    windowBits: 15,
    memLevel: 8,
    strategy: Z_DEFAULT_STRATEGY
  }, C || {});
  let e = this.options;
  e.raw && e.windowBits > 0 ? e.windowBits = -e.windowBits : e.gzip && e.windowBits > 0 && e.windowBits < 16 && (e.windowBits += 16), this.err = 0, this.msg = "", this.ended = !1, this.chunks = [], this.strm = new zstream(), this.strm.avail_out = 0;
  let T = deflate_1$2.deflateInit2(
    this.strm,
    e.level,
    e.method,
    e.windowBits,
    e.memLevel,
    e.strategy
  );
  if (T !== Z_OK$2)
    throw new Error(messages[T]);
  if (e.header && deflate_1$2.deflateSetHeader(this.strm, e.header), e.dictionary) {
    let $;
    if (typeof e.dictionary == "string" ? $ = strings.string2buf(e.dictionary) : toString$1.call(e.dictionary) === "[object ArrayBuffer]" ? $ = new Uint8Array(e.dictionary) : $ = e.dictionary, T = deflate_1$2.deflateSetDictionary(this.strm, $), T !== Z_OK$2)
      throw new Error(messages[T]);
    this._dict_set = !0;
  }
}
Deflate$1.prototype.push = function(C, e) {
  const T = this.strm, $ = this.options.chunkSize;
  let V, J;
  if (this.ended)
    return !1;
  for (e === ~~e ? J = e : J = e === !0 ? Z_FINISH$2 : Z_NO_FLUSH$1, typeof C == "string" ? T.input = strings.string2buf(C) : toString$1.call(C) === "[object ArrayBuffer]" ? T.input = new Uint8Array(C) : T.input = C, T.next_in = 0, T.avail_in = T.input.length; ; ) {
    if (T.avail_out === 0 && (T.output = new Uint8Array($), T.next_out = 0, T.avail_out = $), (J === Z_SYNC_FLUSH || J === Z_FULL_FLUSH) && T.avail_out <= 6) {
      this.onData(T.output.subarray(0, T.next_out)), T.avail_out = 0;
      continue;
    }
    if (V = deflate_1$2.deflate(T, J), V === Z_STREAM_END$2)
      return T.next_out > 0 && this.onData(T.output.subarray(0, T.next_out)), V = deflate_1$2.deflateEnd(this.strm), this.onEnd(V), this.ended = !0, V === Z_OK$2;
    if (T.avail_out === 0) {
      this.onData(T.output);
      continue;
    }
    if (J > 0 && T.next_out > 0) {
      this.onData(T.output.subarray(0, T.next_out)), T.avail_out = 0;
      continue;
    }
    if (T.avail_in === 0) break;
  }
  return !0;
};
Deflate$1.prototype.onData = function(C) {
  this.chunks.push(C);
};
Deflate$1.prototype.onEnd = function(C) {
  C === Z_OK$2 && (this.result = common.flattenChunks(this.chunks)), this.chunks = [], this.err = C, this.msg = this.strm.msg;
};
const BAD$1 = 16209, TYPE$1 = 16191;
var inffast = function(e, T) {
  let $, V, J, ee, te, re, ie, se, de, ue, fe, he, me, xe, ve, Te, we, Ee, Me, Ie, ke, _e, De, Fe;
  const Ae = e.state;
  $ = e.next_in, De = e.input, V = $ + (e.avail_in - 5), J = e.next_out, Fe = e.output, ee = J - (T - e.avail_out), te = J + (e.avail_out - 257), re = Ae.dmax, ie = Ae.wsize, se = Ae.whave, de = Ae.wnext, ue = Ae.window, fe = Ae.hold, he = Ae.bits, me = Ae.lencode, xe = Ae.distcode, ve = (1 << Ae.lenbits) - 1, Te = (1 << Ae.distbits) - 1;
  e:
    do {
      he < 15 && (fe += De[$++] << he, he += 8, fe += De[$++] << he, he += 8), we = me[fe & ve];
      t:
        for (; ; ) {
          if (Ee = we >>> 24, fe >>>= Ee, he -= Ee, Ee = we >>> 16 & 255, Ee === 0)
            Fe[J++] = we & 65535;
          else if (Ee & 16) {
            Me = we & 65535, Ee &= 15, Ee && (he < Ee && (fe += De[$++] << he, he += 8), Me += fe & (1 << Ee) - 1, fe >>>= Ee, he -= Ee), he < 15 && (fe += De[$++] << he, he += 8, fe += De[$++] << he, he += 8), we = xe[fe & Te];
            n:
              for (; ; ) {
                if (Ee = we >>> 24, fe >>>= Ee, he -= Ee, Ee = we >>> 16 & 255, Ee & 16) {
                  if (Ie = we & 65535, Ee &= 15, he < Ee && (fe += De[$++] << he, he += 8, he < Ee && (fe += De[$++] << he, he += 8)), Ie += fe & (1 << Ee) - 1, Ie > re) {
                    e.msg = "invalid distance too far back", Ae.mode = BAD$1;
                    break e;
                  }
                  if (fe >>>= Ee, he -= Ee, Ee = J - ee, Ie > Ee) {
                    if (Ee = Ie - Ee, Ee > se && Ae.sane) {
                      e.msg = "invalid distance too far back", Ae.mode = BAD$1;
                      break e;
                    }
                    if (ke = 0, _e = ue, de === 0) {
                      if (ke += ie - Ee, Ee < Me) {
                        Me -= Ee;
                        do
                          Fe[J++] = ue[ke++];
                        while (--Ee);
                        ke = J - Ie, _e = Fe;
                      }
                    } else if (de < Ee) {
                      if (ke += ie + de - Ee, Ee -= de, Ee < Me) {
                        Me -= Ee;
                        do
                          Fe[J++] = ue[ke++];
                        while (--Ee);
                        if (ke = 0, de < Me) {
                          Ee = de, Me -= Ee;
                          do
                            Fe[J++] = ue[ke++];
                          while (--Ee);
                          ke = J - Ie, _e = Fe;
                        }
                      }
                    } else if (ke += de - Ee, Ee < Me) {
                      Me -= Ee;
                      do
                        Fe[J++] = ue[ke++];
                      while (--Ee);
                      ke = J - Ie, _e = Fe;
                    }
                    for (; Me > 2; )
                      Fe[J++] = _e[ke++], Fe[J++] = _e[ke++], Fe[J++] = _e[ke++], Me -= 3;
                    Me && (Fe[J++] = _e[ke++], Me > 1 && (Fe[J++] = _e[ke++]));
                  } else {
                    ke = J - Ie;
                    do
                      Fe[J++] = Fe[ke++], Fe[J++] = Fe[ke++], Fe[J++] = Fe[ke++], Me -= 3;
                    while (Me > 2);
                    Me && (Fe[J++] = Fe[ke++], Me > 1 && (Fe[J++] = Fe[ke++]));
                  }
                } else if (Ee & 64) {
                  e.msg = "invalid distance code", Ae.mode = BAD$1;
                  break e;
                } else {
                  we = xe[(we & 65535) + (fe & (1 << Ee) - 1)];
                  continue n;
                }
                break;
              }
          } else if (Ee & 64)
            if (Ee & 32) {
              Ae.mode = TYPE$1;
              break e;
            } else {
              e.msg = "invalid literal/length code", Ae.mode = BAD$1;
              break e;
            }
          else {
            we = me[(we & 65535) + (fe & (1 << Ee) - 1)];
            continue t;
          }
          break;
        }
    } while ($ < V && J < te);
  Me = he >> 3, $ -= Me, he -= Me << 3, fe &= (1 << he) - 1, e.next_in = $, e.next_out = J, e.avail_in = $ < V ? 5 + (V - $) : 5 - ($ - V), e.avail_out = J < te ? 257 + (te - J) : 257 - (J - te), Ae.hold = fe, Ae.bits = he;
};
const MAXBITS = 15, ENOUGH_LENS$1 = 852, ENOUGH_DISTS$1 = 592, CODES$1 = 0, LENS$1 = 1, DISTS$1 = 2, lbase = new Uint16Array([
  /* Length codes 257..285 base */
  3,
  4,
  5,
  6,
  7,
  8,
  9,
  10,
  11,
  13,
  15,
  17,
  19,
  23,
  27,
  31,
  35,
  43,
  51,
  59,
  67,
  83,
  99,
  115,
  131,
  163,
  195,
  227,
  258,
  0,
  0
]), lext = new Uint8Array([
  /* Length codes 257..285 extra */
  16,
  16,
  16,
  16,
  16,
  16,
  16,
  16,
  17,
  17,
  17,
  17,
  18,
  18,
  18,
  18,
  19,
  19,
  19,
  19,
  20,
  20,
  20,
  20,
  21,
  21,
  21,
  21,
  16,
  72,
  78
]), dbase = new Uint16Array([
  /* Distance codes 0..29 base */
  1,
  2,
  3,
  4,
  5,
  7,
  9,
  13,
  17,
  25,
  33,
  49,
  65,
  97,
  129,
  193,
  257,
  385,
  513,
  769,
  1025,
  1537,
  2049,
  3073,
  4097,
  6145,
  8193,
  12289,
  16385,
  24577,
  0,
  0
]), dext = new Uint8Array([
  /* Distance codes 0..29 extra */
  16,
  16,
  16,
  16,
  17,
  17,
  18,
  18,
  19,
  19,
  20,
  20,
  21,
  21,
  22,
  22,
  23,
  23,
  24,
  24,
  25,
  25,
  26,
  26,
  27,
  27,
  28,
  28,
  29,
  29,
  64,
  64
]), inflate_table = (C, e, T, $, V, J, ee, te) => {
  const re = te.bits;
  let ie = 0, se = 0, de = 0, ue = 0, fe = 0, he = 0, me = 0, xe = 0, ve = 0, Te = 0, we, Ee, Me, Ie, ke, _e = null, De;
  const Fe = new Uint16Array(MAXBITS + 1), Ae = new Uint16Array(MAXBITS + 1);
  let ne = null, oe, ce, le;
  for (ie = 0; ie <= MAXBITS; ie++)
    Fe[ie] = 0;
  for (se = 0; se < $; se++)
    Fe[e[T + se]]++;
  for (fe = re, ue = MAXBITS; ue >= 1 && Fe[ue] === 0; ue--)
    ;
  if (fe > ue && (fe = ue), ue === 0)
    return V[J++] = 1 << 24 | 64 << 16 | 0, V[J++] = 1 << 24 | 64 << 16 | 0, te.bits = 1, 0;
  for (de = 1; de < ue && Fe[de] === 0; de++)
    ;
  for (fe < de && (fe = de), xe = 1, ie = 1; ie <= MAXBITS; ie++)
    if (xe <<= 1, xe -= Fe[ie], xe < 0)
      return -1;
  if (xe > 0 && (C === CODES$1 || ue !== 1))
    return -1;
  for (Ae[1] = 0, ie = 1; ie < MAXBITS; ie++)
    Ae[ie + 1] = Ae[ie] + Fe[ie];
  for (se = 0; se < $; se++)
    e[T + se] !== 0 && (ee[Ae[e[T + se]]++] = se);
  if (C === CODES$1 ? (_e = ne = ee, De = 20) : C === LENS$1 ? (_e = lbase, ne = lext, De = 257) : (_e = dbase, ne = dext, De = 0), Te = 0, se = 0, ie = de, ke = J, he = fe, me = 0, Me = -1, ve = 1 << fe, Ie = ve - 1, C === LENS$1 && ve > ENOUGH_LENS$1 || C === DISTS$1 && ve > ENOUGH_DISTS$1)
    return 1;
  for (; ; ) {
    oe = ie - me, ee[se] + 1 < De ? (ce = 0, le = ee[se]) : ee[se] >= De ? (ce = ne[ee[se] - De], le = _e[ee[se] - De]) : (ce = 96, le = 0), we = 1 << ie - me, Ee = 1 << he, de = Ee;
    do
      Ee -= we, V[ke + (Te >> me) + Ee] = oe << 24 | ce << 16 | le | 0;
    while (Ee !== 0);
    for (we = 1 << ie - 1; Te & we; )
      we >>= 1;
    if (we !== 0 ? (Te &= we - 1, Te += we) : Te = 0, se++, --Fe[ie] === 0) {
      if (ie === ue)
        break;
      ie = e[T + ee[se]];
    }
    if (ie > fe && (Te & Ie) !== Me) {
      for (me === 0 && (me = fe), ke += de, he = ie - me, xe = 1 << he; he + me < ue && (xe -= Fe[he + me], !(xe <= 0)); )
        he++, xe <<= 1;
      if (ve += 1 << he, C === LENS$1 && ve > ENOUGH_LENS$1 || C === DISTS$1 && ve > ENOUGH_DISTS$1)
        return 1;
      Me = Te & Ie, V[Me] = fe << 24 | he << 16 | ke - J | 0;
    }
  }
  return Te !== 0 && (V[ke + Te] = ie - me << 24 | 64 << 16 | 0), te.bits = fe, 0;
};
var inftrees = inflate_table;
const CODES = 0, LENS = 1, DISTS = 2, {
  Z_FINISH: Z_FINISH$1,
  Z_BLOCK,
  Z_TREES,
  Z_OK: Z_OK$1,
  Z_STREAM_END: Z_STREAM_END$1,
  Z_NEED_DICT: Z_NEED_DICT$1,
  Z_STREAM_ERROR: Z_STREAM_ERROR$1,
  Z_DATA_ERROR: Z_DATA_ERROR$1,
  Z_MEM_ERROR: Z_MEM_ERROR$1,
  Z_BUF_ERROR,
  Z_DEFLATED
} = constants$2, HEAD = 16180, FLAGS = 16181, TIME = 16182, OS = 16183, EXLEN = 16184, EXTRA = 16185, NAME = 16186, COMMENT = 16187, HCRC = 16188, DICTID = 16189, DICT = 16190, TYPE = 16191, TYPEDO = 16192, STORED = 16193, COPY_ = 16194, COPY = 16195, TABLE = 16196, LENLENS = 16197, CODELENS = 16198, LEN_ = 16199, LEN = 16200, LENEXT = 16201, DIST = 16202, DISTEXT = 16203, MATCH = 16204, LIT = 16205, CHECK = 16206, LENGTH = 16207, DONE = 16208, BAD = 16209, MEM = 16210, SYNC = 16211, ENOUGH_LENS = 852, ENOUGH_DISTS = 592, MAX_WBITS = 15, DEF_WBITS = MAX_WBITS, zswap32 = (C) => (C >>> 24 & 255) + (C >>> 8 & 65280) + ((C & 65280) << 8) + ((C & 255) << 24);
function InflateState() {
  this.strm = null, this.mode = 0, this.last = !1, this.wrap = 0, this.havedict = !1, this.flags = 0, this.dmax = 0, this.check = 0, this.total = 0, this.head = null, this.wbits = 0, this.wsize = 0, this.whave = 0, this.wnext = 0, this.window = null, this.hold = 0, this.bits = 0, this.length = 0, this.offset = 0, this.extra = 0, this.lencode = null, this.distcode = null, this.lenbits = 0, this.distbits = 0, this.ncode = 0, this.nlen = 0, this.ndist = 0, this.have = 0, this.next = null, this.lens = new Uint16Array(320), this.work = new Uint16Array(288), this.lendyn = null, this.distdyn = null, this.sane = 0, this.back = 0, this.was = 0;
}
const inflateStateCheck = (C) => {
  if (!C)
    return 1;
  const e = C.state;
  return !e || e.strm !== C || e.mode < HEAD || e.mode > SYNC ? 1 : 0;
}, inflateResetKeep = (C) => {
  if (inflateStateCheck(C))
    return Z_STREAM_ERROR$1;
  const e = C.state;
  return C.total_in = C.total_out = e.total = 0, C.msg = "", e.wrap && (C.adler = e.wrap & 1), e.mode = HEAD, e.last = 0, e.havedict = 0, e.flags = -1, e.dmax = 32768, e.head = null, e.hold = 0, e.bits = 0, e.lencode = e.lendyn = new Int32Array(ENOUGH_LENS), e.distcode = e.distdyn = new Int32Array(ENOUGH_DISTS), e.sane = 1, e.back = -1, Z_OK$1;
}, inflateReset = (C) => {
  if (inflateStateCheck(C))
    return Z_STREAM_ERROR$1;
  const e = C.state;
  return e.wsize = 0, e.whave = 0, e.wnext = 0, inflateResetKeep(C);
}, inflateReset2 = (C, e) => {
  let T;
  if (inflateStateCheck(C))
    return Z_STREAM_ERROR$1;
  const $ = C.state;
  return e < 0 ? (T = 0, e = -e) : (T = (e >> 4) + 5, e < 48 && (e &= 15)), e && (e < 8 || e > 15) ? Z_STREAM_ERROR$1 : ($.window !== null && $.wbits !== e && ($.window = null), $.wrap = T, $.wbits = e, inflateReset(C));
}, inflateInit2 = (C, e) => {
  if (!C)
    return Z_STREAM_ERROR$1;
  const T = new InflateState();
  C.state = T, T.strm = C, T.window = null, T.mode = HEAD;
  const $ = inflateReset2(C, e);
  return $ !== Z_OK$1 && (C.state = null), $;
}, inflateInit = (C) => inflateInit2(C, DEF_WBITS);
let virgin = !0, lenfix, distfix;
const fixedtables = (C) => {
  if (virgin) {
    lenfix = new Int32Array(512), distfix = new Int32Array(32);
    let e = 0;
    for (; e < 144; )
      C.lens[e++] = 8;
    for (; e < 256; )
      C.lens[e++] = 9;
    for (; e < 280; )
      C.lens[e++] = 7;
    for (; e < 288; )
      C.lens[e++] = 8;
    for (inftrees(LENS, C.lens, 0, 288, lenfix, 0, C.work, { bits: 9 }), e = 0; e < 32; )
      C.lens[e++] = 5;
    inftrees(DISTS, C.lens, 0, 32, distfix, 0, C.work, { bits: 5 }), virgin = !1;
  }
  C.lencode = lenfix, C.lenbits = 9, C.distcode = distfix, C.distbits = 5;
}, updatewindow = (C, e, T, $) => {
  let V;
  const J = C.state;
  return J.window === null && (J.wsize = 1 << J.wbits, J.wnext = 0, J.whave = 0, J.window = new Uint8Array(J.wsize)), $ >= J.wsize ? (J.window.set(e.subarray(T - J.wsize, T), 0), J.wnext = 0, J.whave = J.wsize) : (V = J.wsize - J.wnext, V > $ && (V = $), J.window.set(e.subarray(T - $, T - $ + V), J.wnext), $ -= V, $ ? (J.window.set(e.subarray(T - $, T), 0), J.wnext = $, J.whave = J.wsize) : (J.wnext += V, J.wnext === J.wsize && (J.wnext = 0), J.whave < J.wsize && (J.whave += V))), 0;
}, inflate$2 = (C, e) => {
  let T, $, V, J, ee, te, re, ie, se, de, ue, fe, he, me, xe = 0, ve, Te, we, Ee, Me, Ie, ke, _e;
  const De = new Uint8Array(4);
  let Fe, Ae;
  const ne = (
    /* permutation of code lengths */
    new Uint8Array([16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15])
  );
  if (inflateStateCheck(C) || !C.output || !C.input && C.avail_in !== 0)
    return Z_STREAM_ERROR$1;
  T = C.state, T.mode === TYPE && (T.mode = TYPEDO), ee = C.next_out, V = C.output, re = C.avail_out, J = C.next_in, $ = C.input, te = C.avail_in, ie = T.hold, se = T.bits, de = te, ue = re, _e = Z_OK$1;
  e:
    for (; ; )
      switch (T.mode) {
        case HEAD:
          if (T.wrap === 0) {
            T.mode = TYPEDO;
            break;
          }
          for (; se < 16; ) {
            if (te === 0)
              break e;
            te--, ie += $[J++] << se, se += 8;
          }
          if (T.wrap & 2 && ie === 35615) {
            T.wbits === 0 && (T.wbits = 15), T.check = 0, De[0] = ie & 255, De[1] = ie >>> 8 & 255, T.check = crc32_1(T.check, De, 2, 0), ie = 0, se = 0, T.mode = FLAGS;
            break;
          }
          if (T.head && (T.head.done = !1), !(T.wrap & 1) || /* check if zlib header allowed */
          (((ie & 255) << 8) + (ie >> 8)) % 31) {
            C.msg = "incorrect header check", T.mode = BAD;
            break;
          }
          if ((ie & 15) !== Z_DEFLATED) {
            C.msg = "unknown compression method", T.mode = BAD;
            break;
          }
          if (ie >>>= 4, se -= 4, ke = (ie & 15) + 8, T.wbits === 0 && (T.wbits = ke), ke > 15 || ke > T.wbits) {
            C.msg = "invalid window size", T.mode = BAD;
            break;
          }
          T.dmax = 1 << T.wbits, T.flags = 0, C.adler = T.check = 1, T.mode = ie & 512 ? DICTID : TYPE, ie = 0, se = 0;
          break;
        case FLAGS:
          for (; se < 16; ) {
            if (te === 0)
              break e;
            te--, ie += $[J++] << se, se += 8;
          }
          if (T.flags = ie, (T.flags & 255) !== Z_DEFLATED) {
            C.msg = "unknown compression method", T.mode = BAD;
            break;
          }
          if (T.flags & 57344) {
            C.msg = "unknown header flags set", T.mode = BAD;
            break;
          }
          T.head && (T.head.text = ie >> 8 & 1), T.flags & 512 && T.wrap & 4 && (De[0] = ie & 255, De[1] = ie >>> 8 & 255, T.check = crc32_1(T.check, De, 2, 0)), ie = 0, se = 0, T.mode = TIME;
        case TIME:
          for (; se < 32; ) {
            if (te === 0)
              break e;
            te--, ie += $[J++] << se, se += 8;
          }
          T.head && (T.head.time = ie), T.flags & 512 && T.wrap & 4 && (De[0] = ie & 255, De[1] = ie >>> 8 & 255, De[2] = ie >>> 16 & 255, De[3] = ie >>> 24 & 255, T.check = crc32_1(T.check, De, 4, 0)), ie = 0, se = 0, T.mode = OS;
        case OS:
          for (; se < 16; ) {
            if (te === 0)
              break e;
            te--, ie += $[J++] << se, se += 8;
          }
          T.head && (T.head.xflags = ie & 255, T.head.os = ie >> 8), T.flags & 512 && T.wrap & 4 && (De[0] = ie & 255, De[1] = ie >>> 8 & 255, T.check = crc32_1(T.check, De, 2, 0)), ie = 0, se = 0, T.mode = EXLEN;
        case EXLEN:
          if (T.flags & 1024) {
            for (; se < 16; ) {
              if (te === 0)
                break e;
              te--, ie += $[J++] << se, se += 8;
            }
            T.length = ie, T.head && (T.head.extra_len = ie), T.flags & 512 && T.wrap & 4 && (De[0] = ie & 255, De[1] = ie >>> 8 & 255, T.check = crc32_1(T.check, De, 2, 0)), ie = 0, se = 0;
          } else T.head && (T.head.extra = null);
          T.mode = EXTRA;
        case EXTRA:
          if (T.flags & 1024 && (fe = T.length, fe > te && (fe = te), fe && (T.head && (ke = T.head.extra_len - T.length, T.head.extra || (T.head.extra = new Uint8Array(T.head.extra_len)), T.head.extra.set(
            $.subarray(
              J,
              // extra field is limited to 65536 bytes
              // - no need for additional size check
              J + fe
            ),
            /*len + copy > state.head.extra_max - len ? state.head.extra_max : copy,*/
            ke
          )), T.flags & 512 && T.wrap & 4 && (T.check = crc32_1(T.check, $, fe, J)), te -= fe, J += fe, T.length -= fe), T.length))
            break e;
          T.length = 0, T.mode = NAME;
        case NAME:
          if (T.flags & 2048) {
            if (te === 0)
              break e;
            fe = 0;
            do
              ke = $[J + fe++], T.head && ke && T.length < 65536 && (T.head.name += String.fromCharCode(ke));
            while (ke && fe < te);
            if (T.flags & 512 && T.wrap & 4 && (T.check = crc32_1(T.check, $, fe, J)), te -= fe, J += fe, ke)
              break e;
          } else T.head && (T.head.name = null);
          T.length = 0, T.mode = COMMENT;
        case COMMENT:
          if (T.flags & 4096) {
            if (te === 0)
              break e;
            fe = 0;
            do
              ke = $[J + fe++], T.head && ke && T.length < 65536 && (T.head.comment += String.fromCharCode(ke));
            while (ke && fe < te);
            if (T.flags & 512 && T.wrap & 4 && (T.check = crc32_1(T.check, $, fe, J)), te -= fe, J += fe, ke)
              break e;
          } else T.head && (T.head.comment = null);
          T.mode = HCRC;
        case HCRC:
          if (T.flags & 512) {
            for (; se < 16; ) {
              if (te === 0)
                break e;
              te--, ie += $[J++] << se, se += 8;
            }
            if (T.wrap & 4 && ie !== (T.check & 65535)) {
              C.msg = "header crc mismatch", T.mode = BAD;
              break;
            }
            ie = 0, se = 0;
          }
          T.head && (T.head.hcrc = T.flags >> 9 & 1, T.head.done = !0), C.adler = T.check = 0, T.mode = TYPE;
          break;
        case DICTID:
          for (; se < 32; ) {
            if (te === 0)
              break e;
            te--, ie += $[J++] << se, se += 8;
          }
          C.adler = T.check = zswap32(ie), ie = 0, se = 0, T.mode = DICT;
        case DICT:
          if (T.havedict === 0)
            return C.next_out = ee, C.avail_out = re, C.next_in = J, C.avail_in = te, T.hold = ie, T.bits = se, Z_NEED_DICT$1;
          C.adler = T.check = 1, T.mode = TYPE;
        case TYPE:
          if (e === Z_BLOCK || e === Z_TREES)
            break e;
        case TYPEDO:
          if (T.last) {
            ie >>>= se & 7, se -= se & 7, T.mode = CHECK;
            break;
          }
          for (; se < 3; ) {
            if (te === 0)
              break e;
            te--, ie += $[J++] << se, se += 8;
          }
          switch (T.last = ie & 1, ie >>>= 1, se -= 1, ie & 3) {
            case 0:
              T.mode = STORED;
              break;
            case 1:
              if (fixedtables(T), T.mode = LEN_, e === Z_TREES) {
                ie >>>= 2, se -= 2;
                break e;
              }
              break;
            case 2:
              T.mode = TABLE;
              break;
            case 3:
              C.msg = "invalid block type", T.mode = BAD;
          }
          ie >>>= 2, se -= 2;
          break;
        case STORED:
          for (ie >>>= se & 7, se -= se & 7; se < 32; ) {
            if (te === 0)
              break e;
            te--, ie += $[J++] << se, se += 8;
          }
          if ((ie & 65535) !== (ie >>> 16 ^ 65535)) {
            C.msg = "invalid stored block lengths", T.mode = BAD;
            break;
          }
          if (T.length = ie & 65535, ie = 0, se = 0, T.mode = COPY_, e === Z_TREES)
            break e;
        case COPY_:
          T.mode = COPY;
        case COPY:
          if (fe = T.length, fe) {
            if (fe > te && (fe = te), fe > re && (fe = re), fe === 0)
              break e;
            V.set($.subarray(J, J + fe), ee), te -= fe, J += fe, re -= fe, ee += fe, T.length -= fe;
            break;
          }
          T.mode = TYPE;
          break;
        case TABLE:
          for (; se < 14; ) {
            if (te === 0)
              break e;
            te--, ie += $[J++] << se, se += 8;
          }
          if (T.nlen = (ie & 31) + 257, ie >>>= 5, se -= 5, T.ndist = (ie & 31) + 1, ie >>>= 5, se -= 5, T.ncode = (ie & 15) + 4, ie >>>= 4, se -= 4, T.nlen > 286 || T.ndist > 30) {
            C.msg = "too many length or distance symbols", T.mode = BAD;
            break;
          }
          T.have = 0, T.mode = LENLENS;
        case LENLENS:
          for (; T.have < T.ncode; ) {
            for (; se < 3; ) {
              if (te === 0)
                break e;
              te--, ie += $[J++] << se, se += 8;
            }
            T.lens[ne[T.have++]] = ie & 7, ie >>>= 3, se -= 3;
          }
          for (; T.have < 19; )
            T.lens[ne[T.have++]] = 0;
          if (T.lencode = T.lendyn, T.lenbits = 7, Fe = { bits: T.lenbits }, _e = inftrees(CODES, T.lens, 0, 19, T.lencode, 0, T.work, Fe), T.lenbits = Fe.bits, _e) {
            C.msg = "invalid code lengths set", T.mode = BAD;
            break;
          }
          T.have = 0, T.mode = CODELENS;
        case CODELENS:
          for (; T.have < T.nlen + T.ndist; ) {
            for (; xe = T.lencode[ie & (1 << T.lenbits) - 1], ve = xe >>> 24, Te = xe >>> 16 & 255, we = xe & 65535, !(ve <= se); ) {
              if (te === 0)
                break e;
              te--, ie += $[J++] << se, se += 8;
            }
            if (we < 16)
              ie >>>= ve, se -= ve, T.lens[T.have++] = we;
            else {
              if (we === 16) {
                for (Ae = ve + 2; se < Ae; ) {
                  if (te === 0)
                    break e;
                  te--, ie += $[J++] << se, se += 8;
                }
                if (ie >>>= ve, se -= ve, T.have === 0) {
                  C.msg = "invalid bit length repeat", T.mode = BAD;
                  break;
                }
                ke = T.lens[T.have - 1], fe = 3 + (ie & 3), ie >>>= 2, se -= 2;
              } else if (we === 17) {
                for (Ae = ve + 3; se < Ae; ) {
                  if (te === 0)
                    break e;
                  te--, ie += $[J++] << se, se += 8;
                }
                ie >>>= ve, se -= ve, ke = 0, fe = 3 + (ie & 7), ie >>>= 3, se -= 3;
              } else {
                for (Ae = ve + 7; se < Ae; ) {
                  if (te === 0)
                    break e;
                  te--, ie += $[J++] << se, se += 8;
                }
                ie >>>= ve, se -= ve, ke = 0, fe = 11 + (ie & 127), ie >>>= 7, se -= 7;
              }
              if (T.have + fe > T.nlen + T.ndist) {
                C.msg = "invalid bit length repeat", T.mode = BAD;
                break;
              }
              for (; fe--; )
                T.lens[T.have++] = ke;
            }
          }
          if (T.mode === BAD)
            break;
          if (T.lens[256] === 0) {
            C.msg = "invalid code -- missing end-of-block", T.mode = BAD;
            break;
          }
          if (T.lenbits = 9, Fe = { bits: T.lenbits }, _e = inftrees(LENS, T.lens, 0, T.nlen, T.lencode, 0, T.work, Fe), T.lenbits = Fe.bits, _e) {
            C.msg = "invalid literal/lengths set", T.mode = BAD;
            break;
          }
          if (T.distbits = 6, T.distcode = T.distdyn, Fe = { bits: T.distbits }, _e = inftrees(DISTS, T.lens, T.nlen, T.ndist, T.distcode, 0, T.work, Fe), T.distbits = Fe.bits, _e) {
            C.msg = "invalid distances set", T.mode = BAD;
            break;
          }
          if (T.mode = LEN_, e === Z_TREES)
            break e;
        case LEN_:
          T.mode = LEN;
        case LEN:
          if (te >= 6 && re >= 258) {
            C.next_out = ee, C.avail_out = re, C.next_in = J, C.avail_in = te, T.hold = ie, T.bits = se, inffast(C, ue), ee = C.next_out, V = C.output, re = C.avail_out, J = C.next_in, $ = C.input, te = C.avail_in, ie = T.hold, se = T.bits, T.mode === TYPE && (T.back = -1);
            break;
          }
          for (T.back = 0; xe = T.lencode[ie & (1 << T.lenbits) - 1], ve = xe >>> 24, Te = xe >>> 16 & 255, we = xe & 65535, !(ve <= se); ) {
            if (te === 0)
              break e;
            te--, ie += $[J++] << se, se += 8;
          }
          if (Te && !(Te & 240)) {
            for (Ee = ve, Me = Te, Ie = we; xe = T.lencode[Ie + ((ie & (1 << Ee + Me) - 1) >> Ee)], ve = xe >>> 24, Te = xe >>> 16 & 255, we = xe & 65535, !(Ee + ve <= se); ) {
              if (te === 0)
                break e;
              te--, ie += $[J++] << se, se += 8;
            }
            ie >>>= Ee, se -= Ee, T.back += Ee;
          }
          if (ie >>>= ve, se -= ve, T.back += ve, T.length = we, Te === 0) {
            T.mode = LIT;
            break;
          }
          if (Te & 32) {
            T.back = -1, T.mode = TYPE;
            break;
          }
          if (Te & 64) {
            C.msg = "invalid literal/length code", T.mode = BAD;
            break;
          }
          T.extra = Te & 15, T.mode = LENEXT;
        case LENEXT:
          if (T.extra) {
            for (Ae = T.extra; se < Ae; ) {
              if (te === 0)
                break e;
              te--, ie += $[J++] << se, se += 8;
            }
            T.length += ie & (1 << T.extra) - 1, ie >>>= T.extra, se -= T.extra, T.back += T.extra;
          }
          T.was = T.length, T.mode = DIST;
        case DIST:
          for (; xe = T.distcode[ie & (1 << T.distbits) - 1], ve = xe >>> 24, Te = xe >>> 16 & 255, we = xe & 65535, !(ve <= se); ) {
            if (te === 0)
              break e;
            te--, ie += $[J++] << se, se += 8;
          }
          if (!(Te & 240)) {
            for (Ee = ve, Me = Te, Ie = we; xe = T.distcode[Ie + ((ie & (1 << Ee + Me) - 1) >> Ee)], ve = xe >>> 24, Te = xe >>> 16 & 255, we = xe & 65535, !(Ee + ve <= se); ) {
              if (te === 0)
                break e;
              te--, ie += $[J++] << se, se += 8;
            }
            ie >>>= Ee, se -= Ee, T.back += Ee;
          }
          if (ie >>>= ve, se -= ve, T.back += ve, Te & 64) {
            C.msg = "invalid distance code", T.mode = BAD;
            break;
          }
          T.offset = we, T.extra = Te & 15, T.mode = DISTEXT;
        case DISTEXT:
          if (T.extra) {
            for (Ae = T.extra; se < Ae; ) {
              if (te === 0)
                break e;
              te--, ie += $[J++] << se, se += 8;
            }
            T.offset += ie & (1 << T.extra) - 1, ie >>>= T.extra, se -= T.extra, T.back += T.extra;
          }
          if (T.offset > T.dmax) {
            C.msg = "invalid distance too far back", T.mode = BAD;
            break;
          }
          T.mode = MATCH;
        case MATCH:
          if (re === 0)
            break e;
          if (fe = ue - re, T.offset > fe) {
            if (fe = T.offset - fe, fe > T.whave && T.sane) {
              C.msg = "invalid distance too far back", T.mode = BAD;
              break;
            }
            fe > T.wnext ? (fe -= T.wnext, he = T.wsize - fe) : he = T.wnext - fe, fe > T.length && (fe = T.length), me = T.window;
          } else
            me = V, he = ee - T.offset, fe = T.length;
          fe > re && (fe = re), re -= fe, T.length -= fe;
          do
            V[ee++] = me[he++];
          while (--fe);
          T.length === 0 && (T.mode = LEN);
          break;
        case LIT:
          if (re === 0)
            break e;
          V[ee++] = T.length, re--, T.mode = LEN;
          break;
        case CHECK:
          if (T.wrap) {
            for (; se < 32; ) {
              if (te === 0)
                break e;
              te--, ie |= $[J++] << se, se += 8;
            }
            if (ue -= re, C.total_out += ue, T.total += ue, T.wrap & 4 && ue && (C.adler = T.check = /*UPDATE_CHECK(state.check, put - _out, _out);*/
            T.flags ? crc32_1(T.check, V, ue, ee - ue) : adler32_1(T.check, V, ue, ee - ue)), ue = re, T.wrap & 4 && (T.flags ? ie : zswap32(ie)) !== T.check) {
              C.msg = "incorrect data check", T.mode = BAD;
              break;
            }
            ie = 0, se = 0;
          }
          T.mode = LENGTH;
        case LENGTH:
          if (T.wrap && T.flags) {
            for (; se < 32; ) {
              if (te === 0)
                break e;
              te--, ie += $[J++] << se, se += 8;
            }
            if (T.wrap & 4 && ie !== (T.total & 4294967295)) {
              C.msg = "incorrect length check", T.mode = BAD;
              break;
            }
            ie = 0, se = 0;
          }
          T.mode = DONE;
        case DONE:
          _e = Z_STREAM_END$1;
          break e;
        case BAD:
          _e = Z_DATA_ERROR$1;
          break e;
        case MEM:
          return Z_MEM_ERROR$1;
        case SYNC:
        default:
          return Z_STREAM_ERROR$1;
      }
  return C.next_out = ee, C.avail_out = re, C.next_in = J, C.avail_in = te, T.hold = ie, T.bits = se, (T.wsize || ue !== C.avail_out && T.mode < BAD && (T.mode < CHECK || e !== Z_FINISH$1)) && updatewindow(C, C.output, C.next_out, ue - C.avail_out), de -= C.avail_in, ue -= C.avail_out, C.total_in += de, C.total_out += ue, T.total += ue, T.wrap & 4 && ue && (C.adler = T.check = /*UPDATE_CHECK(state.check, strm.next_out - _out, _out);*/
  T.flags ? crc32_1(T.check, V, ue, C.next_out - ue) : adler32_1(T.check, V, ue, C.next_out - ue)), C.data_type = T.bits + (T.last ? 64 : 0) + (T.mode === TYPE ? 128 : 0) + (T.mode === LEN_ || T.mode === COPY_ ? 256 : 0), (de === 0 && ue === 0 || e === Z_FINISH$1) && _e === Z_OK$1 && (_e = Z_BUF_ERROR), _e;
}, inflateEnd = (C) => {
  if (inflateStateCheck(C))
    return Z_STREAM_ERROR$1;
  let e = C.state;
  return e.window && (e.window = null), C.state = null, Z_OK$1;
}, inflateGetHeader = (C, e) => {
  if (inflateStateCheck(C))
    return Z_STREAM_ERROR$1;
  const T = C.state;
  return T.wrap & 2 ? (T.head = e, e.done = !1, Z_OK$1) : Z_STREAM_ERROR$1;
}, inflateSetDictionary = (C, e) => {
  const T = e.length;
  let $, V, J;
  return inflateStateCheck(C) || ($ = C.state, $.wrap !== 0 && $.mode !== DICT) ? Z_STREAM_ERROR$1 : $.mode === DICT && (V = 1, V = adler32_1(V, e, T, 0), V !== $.check) ? Z_DATA_ERROR$1 : (J = updatewindow(C, e, T, T), J ? ($.mode = MEM, Z_MEM_ERROR$1) : ($.havedict = 1, Z_OK$1));
};
var inflateReset_1 = inflateReset, inflateReset2_1 = inflateReset2, inflateResetKeep_1 = inflateResetKeep, inflateInit_1 = inflateInit, inflateInit2_1 = inflateInit2, inflate_2$1 = inflate$2, inflateEnd_1 = inflateEnd, inflateGetHeader_1 = inflateGetHeader, inflateSetDictionary_1 = inflateSetDictionary, inflateInfo = "pako inflate (from Nodeca project)", inflate_1$2 = {
  inflateReset: inflateReset_1,
  inflateReset2: inflateReset2_1,
  inflateResetKeep: inflateResetKeep_1,
  inflateInit: inflateInit_1,
  inflateInit2: inflateInit2_1,
  inflate: inflate_2$1,
  inflateEnd: inflateEnd_1,
  inflateGetHeader: inflateGetHeader_1,
  inflateSetDictionary: inflateSetDictionary_1,
  inflateInfo
};
function GZheader() {
  this.text = 0, this.time = 0, this.xflags = 0, this.os = 0, this.extra = null, this.extra_len = 0, this.name = "", this.comment = "", this.hcrc = 0, this.done = !1;
}
var gzheader = GZheader;
const toString = Object.prototype.toString, {
  Z_NO_FLUSH,
  Z_FINISH,
  Z_OK,
  Z_STREAM_END,
  Z_NEED_DICT,
  Z_STREAM_ERROR,
  Z_DATA_ERROR,
  Z_MEM_ERROR
} = constants$2;
function Inflate$1(C) {
  this.options = common.assign({
    chunkSize: 1024 * 64,
    windowBits: 15,
    to: ""
  }, C || {});
  const e = this.options;
  e.raw && e.windowBits >= 0 && e.windowBits < 16 && (e.windowBits = -e.windowBits, e.windowBits === 0 && (e.windowBits = -15)), e.windowBits >= 0 && e.windowBits < 16 && !(C && C.windowBits) && (e.windowBits += 32), e.windowBits > 15 && e.windowBits < 48 && (e.windowBits & 15 || (e.windowBits |= 15)), this.err = 0, this.msg = "", this.ended = !1, this.chunks = [], this.strm = new zstream(), this.strm.avail_out = 0;
  let T = inflate_1$2.inflateInit2(
    this.strm,
    e.windowBits
  );
  if (T !== Z_OK)
    throw new Error(messages[T]);
  if (this.header = new gzheader(), inflate_1$2.inflateGetHeader(this.strm, this.header), e.dictionary && (typeof e.dictionary == "string" ? e.dictionary = strings.string2buf(e.dictionary) : toString.call(e.dictionary) === "[object ArrayBuffer]" && (e.dictionary = new Uint8Array(e.dictionary)), e.raw && (T = inflate_1$2.inflateSetDictionary(this.strm, e.dictionary), T !== Z_OK)))
    throw new Error(messages[T]);
}
Inflate$1.prototype.push = function(C, e) {
  const T = this.strm, $ = this.options.chunkSize, V = this.options.dictionary;
  let J, ee, te;
  if (this.ended) return !1;
  for (e === ~~e ? ee = e : ee = e === !0 ? Z_FINISH : Z_NO_FLUSH, toString.call(C) === "[object ArrayBuffer]" ? T.input = new Uint8Array(C) : T.input = C, T.next_in = 0, T.avail_in = T.input.length; ; ) {
    for (T.avail_out === 0 && (T.output = new Uint8Array($), T.next_out = 0, T.avail_out = $), J = inflate_1$2.inflate(T, ee), J === Z_NEED_DICT && V && (J = inflate_1$2.inflateSetDictionary(T, V), J === Z_OK ? J = inflate_1$2.inflate(T, ee) : J === Z_DATA_ERROR && (J = Z_NEED_DICT)); T.avail_in > 0 && J === Z_STREAM_END && T.state.wrap > 0 && C[T.next_in] !== 0; )
      inflate_1$2.inflateReset(T), J = inflate_1$2.inflate(T, ee);
    switch (J) {
      case Z_STREAM_ERROR:
      case Z_DATA_ERROR:
      case Z_NEED_DICT:
      case Z_MEM_ERROR:
        return this.onEnd(J), this.ended = !0, !1;
    }
    if (te = T.avail_out, T.next_out && (T.avail_out === 0 || J === Z_STREAM_END))
      if (this.options.to === "string") {
        let re = strings.utf8border(T.output, T.next_out), ie = T.next_out - re, se = strings.buf2string(T.output, re);
        T.next_out = ie, T.avail_out = $ - ie, ie && T.output.set(T.output.subarray(re, re + ie), 0), this.onData(se);
      } else
        this.onData(T.output.length === T.next_out ? T.output : T.output.subarray(0, T.next_out));
    if (!(J === Z_OK && te === 0)) {
      if (J === Z_STREAM_END)
        return J = inflate_1$2.inflateEnd(this.strm), this.onEnd(J), this.ended = !0, !0;
      if (T.avail_in === 0) break;
    }
  }
  return !0;
};
Inflate$1.prototype.onData = function(C) {
  this.chunks.push(C);
};
Inflate$1.prototype.onEnd = function(C) {
  C === Z_OK && (this.options.to === "string" ? this.result = this.chunks.join("") : this.result = common.flattenChunks(this.chunks)), this.chunks = [], this.err = C, this.msg = this.strm.msg;
};
function inflate$1(C, e) {
  const T = new Inflate$1(e);
  if (T.push(C), T.err) throw T.msg || messages[T.err];
  return T.result;
}
function inflateRaw$1(C, e) {
  return e = e || {}, e.raw = !0, inflate$1(C, e);
}
var Inflate_1$1 = Inflate$1, inflate_2 = inflate$1, inflateRaw_1$1 = inflateRaw$1, ungzip$1 = inflate$1, constants = constants$2, inflate_1$1 = {
  Inflate: Inflate_1$1,
  inflate: inflate_2,
  inflateRaw: inflateRaw_1$1,
  ungzip: ungzip$1,
  constants
};
const { Inflate, inflate, inflateRaw, ungzip } = inflate_1$1;
var inflate_1 = inflate;
function chunks(C, e) {
  return Array.apply(0, new Array(Math.ceil(C.length / e))).map((T, $) => C.slice($ * e, ($ + 1) * e));
}
const isVersionedTransaction = (C) => "version" in C;
function encode$3(C) {
  return C.reduce((e, T) => e + T.toString(16).padStart(2, "0"), "0x");
}
function decode$3(C) {
  C.indexOf("0x") === 0 && (C = C.substr(2)), C.length % 2 === 1 && (C = "0" + C);
  let e = C.match(/.{2}/g);
  return e === null ? bufferPolyfill.Buffer.from([]) : bufferPolyfill.Buffer.from(e.map((T) => parseInt(T, 16)));
}
var hex = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  encode: encode$3,
  decode: decode$3
});
function decode$2(C) {
  return new TextDecoder("utf-8").decode(C);
}
function encode$2(C) {
  return new TextEncoder().encode(C);
}
var utf8 = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  decode: decode$2,
  encode: encode$2
});
function encode$1(C) {
  return bs58$6.encode(C);
}
function decode$1(C) {
  return bs58$6.decode(C);
}
var bs58 = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  encode: encode$1,
  decode: decode$1
});
function encode(C) {
  return C.toString("base64");
}
function decode(C) {
  return bufferPolyfill.Buffer.from(C, "base64");
}
var base64 = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  encode,
  decode
}), index$1$1 = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  hex,
  utf8,
  bs58,
  base64
});
function parseIdlErrors(C) {
  const e = /* @__PURE__ */ new Map();
  return C.errors && C.errors.forEach((T) => {
    var $;
    let V = ($ = T.msg) !== null && $ !== void 0 ? $ : T.name;
    e.set(T.code, V);
  }), e;
}
function toInstruction(C, ...e) {
  if (C.args.length != e.length)
    throw new Error("Invalid argument length");
  const T = {};
  let $ = 0;
  return C.args.forEach((V) => {
    T[V.name] = e[$], $ += 1;
  }), T;
}
function validateAccounts(C, e = {}) {
  C.forEach((T) => {
    if ("accounts" in T)
      validateAccounts(T.accounts, e[T.name]);
    else if (e[T.name] === void 0)
      throw new Error(`Invalid arguments: ${T.name} not provided.`);
  });
}
function translateAddress(C) {
  return C instanceof PublicKey ? C : new PublicKey(C);
}
class StructError extends TypeError {
  constructor(e, T) {
    let $;
    const {
      message: V,
      ...J
    } = e, {
      path: ee
    } = e, te = ee.length === 0 ? V : "At path: " + ee.join(".") + " -- " + V;
    super(te), this.value = void 0, this.key = void 0, this.type = void 0, this.refinement = void 0, this.path = void 0, this.branch = void 0, this.failures = void 0, Object.assign(this, J), this.name = this.constructor.name, this.failures = () => {
      var re;
      return (re = $) != null ? re : $ = [e, ...T()];
    };
  }
}
function isIterable(C) {
  return isObject(C) && typeof C[Symbol.iterator] == "function";
}
function isObject(C) {
  return typeof C == "object" && C != null;
}
function print(C) {
  return typeof C == "string" ? JSON.stringify(C) : "" + C;
}
function shiftIterator(C) {
  const {
    done: e,
    value: T
  } = C.next();
  return e ? void 0 : T;
}
function toFailure(C, e, T, $) {
  if (C === !0)
    return;
  C === !1 ? C = {} : typeof C == "string" && (C = {
    message: C
  });
  const {
    path: V,
    branch: J
  } = e, {
    type: ee
  } = T, {
    refinement: te,
    message: re = "Expected a value of type `" + ee + "`" + (te ? " with refinement `" + te + "`" : "") + ", but received: `" + print($) + "`"
  } = C;
  return {
    value: $,
    type: ee,
    refinement: te,
    key: V[V.length - 1],
    path: V,
    branch: J,
    ...C,
    message: re
  };
}
function* toFailures(C, e, T, $) {
  isIterable(C) || (C = [C]);
  for (const V of C) {
    const J = toFailure(V, e, T, $);
    J && (yield J);
  }
}
function* run(C, e, T) {
  T === void 0 && (T = {});
  const {
    path: $ = [],
    branch: V = [C],
    coerce: J = !1,
    mask: ee = !1
  } = T, te = {
    path: $,
    branch: V
  };
  if (J && (C = e.coercer(C, te), ee && e.type !== "type" && isObject(e.schema) && isObject(C) && !Array.isArray(C)))
    for (const ie in C)
      e.schema[ie] === void 0 && delete C[ie];
  let re = !0;
  for (const ie of e.validator(C, te))
    re = !1, yield [ie, void 0];
  for (let [ie, se, de] of e.entries(C, te)) {
    const ue = run(se, de, {
      path: ie === void 0 ? $ : [...$, ie],
      branch: ie === void 0 ? V : [...V, se],
      coerce: J,
      mask: ee
    });
    for (const fe of ue)
      fe[0] ? (re = !1, yield [fe[0], void 0]) : J && (se = fe[1], ie === void 0 ? C = se : C instanceof Map ? C.set(ie, se) : C instanceof Set ? C.add(se) : isObject(C) && (C[ie] = se));
  }
  if (re)
    for (const ie of e.refiner(C, te))
      re = !1, yield [ie, void 0];
  re && (yield [void 0, C]);
}
class Struct {
  constructor(e) {
    this.TYPE = void 0, this.type = void 0, this.schema = void 0, this.coercer = void 0, this.validator = void 0, this.refiner = void 0, this.entries = void 0;
    const {
      type: T,
      schema: $,
      validator: V,
      refiner: J,
      coercer: ee = (re) => re,
      entries: te = function* () {
      }
    } = e;
    this.type = T, this.schema = $, this.entries = te, this.coercer = ee, V ? this.validator = (re, ie) => {
      const se = V(re, ie);
      return toFailures(se, ie, this, re);
    } : this.validator = () => [], J ? this.refiner = (re, ie) => {
      const se = J(re, ie);
      return toFailures(se, ie, this, re);
    } : this.refiner = () => [];
  }
  /**
   * Assert that a value passes the struct's validation, throwing if it doesn't.
   */
  assert(e) {
    return assert$1(e, this);
  }
  /**
   * Create a value with the struct's coercion logic, then validate it.
   */
  create(e) {
    return create(e, this);
  }
  /**
   * Check if a value passes the struct's validation.
   */
  is(e) {
    return is(e, this);
  }
  /**
   * Mask a value, coercing and validating it, but returning only the subset of
   * properties defined by the struct's schema.
   */
  mask(e) {
    return mask(e, this);
  }
  /**
   * Validate a value with the struct's validation logic, returning a tuple
   * representing the result.
   *
   * You may optionally pass `true` for the `withCoercion` argument to coerce
   * the value before attempting to validate it. If you do, the result will
   * contain the coerced result when successful.
   */
  validate(e, T) {
    return T === void 0 && (T = {}), validate$1(e, this, T);
  }
}
function assert$1(C, e) {
  const T = validate$1(C, e);
  if (T[0])
    throw T[0];
}
function create(C, e) {
  const T = validate$1(C, e, {
    coerce: !0
  });
  if (T[0])
    throw T[0];
  return T[1];
}
function mask(C, e) {
  const T = validate$1(C, e, {
    coerce: !0,
    mask: !0
  });
  if (T[0])
    throw T[0];
  return T[1];
}
function is(C, e) {
  return !validate$1(C, e)[0];
}
function validate$1(C, e, T) {
  T === void 0 && (T = {});
  const $ = run(C, e, T), V = shiftIterator($);
  return V[0] ? [new StructError(V[0], function* () {
    for (const ee of $)
      ee[0] && (yield ee[0]);
  }), void 0] : [void 0, V[1]];
}
function define(C, e) {
  return new Struct({
    type: C,
    schema: null,
    validator: e
  });
}
function any() {
  return define("any", () => !0);
}
function array(C) {
  return new Struct({
    type: "array",
    schema: C,
    *entries(e) {
      if (C && Array.isArray(e))
        for (const [T, $] of e.entries())
          yield [T, $, C];
    },
    coercer(e) {
      return Array.isArray(e) ? e.slice() : e;
    },
    validator(e) {
      return Array.isArray(e) || "Expected an array value, but received: " + print(e);
    }
  });
}
function boolean() {
  return define("boolean", (C) => typeof C == "boolean");
}
function literal(C) {
  const e = print(C);
  return new Struct({
    type: "literal",
    schema: C,
    validator(T) {
      return T === C || "Expected the literal `" + e + "`, but received: " + print(T);
    }
  });
}
function nullable(C) {
  return new Struct({
    ...C,
    validator: (e, T) => e === null || C.validator(e, T),
    refiner: (e, T) => e === null || C.refiner(e, T)
  });
}
function number() {
  return define("number", (C) => typeof C == "number" && !isNaN(C) || "Expected a number, but received: " + print(C));
}
function optional(C) {
  return new Struct({
    ...C,
    validator: (e, T) => e === void 0 || C.validator(e, T),
    refiner: (e, T) => e === void 0 || C.refiner(e, T)
  });
}
function string() {
  return define("string", (C) => typeof C == "string" || "Expected a string, but received: " + print(C));
}
function type(C) {
  const e = Object.keys(C);
  return new Struct({
    type: "type",
    schema: C,
    *entries(T) {
      if (isObject(T))
        for (const $ of e)
          yield [$, T[$], C[$]];
    },
    validator(T) {
      return isObject(T) || "Expected an object, but received: " + print(T);
    }
  });
}
function union$1(C) {
  const e = C.map((T) => T.type).join(" | ");
  return new Struct({
    type: "union",
    schema: null,
    coercer(T, $) {
      return (C.find((J) => {
        const [ee] = J.validate(T, {
          coerce: !0
        });
        return !ee;
      }) || unknown()).coercer(T, $);
    },
    validator(T, $) {
      const V = [];
      for (const J of C) {
        const [...ee] = run(T, J, $), [te] = ee;
        if (te[0])
          for (const [re] of ee)
            re && V.push(re);
        else
          return [];
      }
      return ["Expected the value to satisfy a union of `" + e + "`, but received: " + print(T), ...V];
    }
  });
}
function unknown() {
  return define("unknown", () => !0);
}
function coerce(C, e, T) {
  return new Struct({
    ...C,
    coercer: ($, V) => is($, e) ? C.coercer(T($, V), V) : C.coercer($, V)
  });
}
async function invoke(C, e, T, $) {
  C = translateAddress(C), $ || ($ = getProvider());
  const V = new Transaction();
  if (V.add(new TransactionInstruction({
    programId: C,
    keys: e ?? [],
    data: T
  })), $.sendAndConfirm === void 0)
    throw new Error("This function requires 'Provider.sendAndConfirm' to be implemented.");
  return await $.sendAndConfirm(V, []);
}
const GET_MULTIPLE_ACCOUNTS_LIMIT = 99;
async function getMultipleAccounts(C, e, T) {
  return (await getMultipleAccountsAndContext(C, e, T)).map((V) => V ? { publicKey: V.publicKey, account: V.account } : null);
}
async function getMultipleAccountsAndContext(C, e, T) {
  if (e.length <= GET_MULTIPLE_ACCOUNTS_LIMIT)
    return await getMultipleAccountsAndContextCore(C, e, T);
  {
    const $ = chunks(e, GET_MULTIPLE_ACCOUNTS_LIMIT);
    return (await Promise.all($.map((J) => getMultipleAccountsAndContextCore(C, J, T)))).flat();
  }
}
async function getMultipleAccountsAndContextCore(C, e, T) {
  const $ = T ?? C.commitment, { value: V, context: J } = await C.getMultipleAccountsInfoAndContext(e, $);
  return V.map((te, re) => te === null ? null : {
    publicKey: e[re],
    account: te,
    context: J
  });
}
async function simulateTransaction(C, e, T, $, V) {
  var J;
  T && T.length > 0 && e.sign(...T);
  const ee = e._compile(), te = ee.serialize(), ie = e._serialize(te).toString("base64"), se = {
    encoding: "base64",
    commitment: $ ?? C.commitment
  };
  if (V) {
    const he = (Array.isArray(V) ? V : ee.nonProgramIds()).map((me) => me.toBase58());
    se.accounts = {
      encoding: "base64",
      addresses: he
    };
  }
  T && (se.sigVerify = !0);
  const de = [ie, se], ue = await C._rpcRequest("simulateTransaction", de), fe = create(ue, SimulatedTransactionResponseStruct);
  if ("error" in fe) {
    let he;
    if ("data" in fe.error && (he = (J = fe.error.data) === null || J === void 0 ? void 0 : J.logs, he && Array.isArray(he))) {
      const me = `
    `, xe = me + he.join(me);
      console.error(fe.error.message, xe);
    }
    throw new SendTransactionError("failed to simulate transaction: " + fe.error.message, he);
  }
  return fe.result;
}
function jsonRpcResult(C) {
  return coerce(createRpcResult(C), UnknownRpcResult, (e) => "error" in e ? e : {
    ...e,
    result: create(e.result, C)
  });
}
const UnknownRpcResult = createRpcResult(unknown());
function createRpcResult(C) {
  return union$1([
    type({
      jsonrpc: literal("2.0"),
      id: string(),
      result: C
    }),
    type({
      jsonrpc: literal("2.0"),
      id: string(),
      error: type({
        code: unknown(),
        message: string(),
        data: optional(any())
      })
    })
  ]);
}
function jsonRpcResultAndContext(C) {
  return jsonRpcResult(type({
    context: type({
      slot: number()
    }),
    value: C
  }));
}
const SimulatedTransactionResponseStruct = jsonRpcResultAndContext(type({
  err: nullable(union$1([type({}), string()])),
  logs: nullable(array(string())),
  accounts: optional(nullable(array(nullable(type({
    executable: boolean(),
    owner: string(),
    lamports: number(),
    data: array(string()),
    rentEpoch: optional(number())
  }))))),
  unitsConsumed: optional(number())
}));
var rpc = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  invoke,
  getMultipleAccounts,
  getMultipleAccountsAndContext,
  simulateTransaction
});
class AnchorProvider {
  /**
   * @param connection The cluster connection where the program is deployed.
   * @param wallet     The wallet used to pay for and sign all transactions.
   * @param opts       Transaction confirmation options to use by default.
   */
  constructor(e, T, $) {
    this.connection = e, this.wallet = T, this.opts = $, this.publicKey = T == null ? void 0 : T.publicKey;
  }
  static defaultOptions() {
    return {
      preflightCommitment: "processed",
      commitment: "processed"
    };
  }
  /**
   * Returns a `Provider` with a wallet read from the local filesystem.
   *
   * @param url  The network cluster url.
   * @param opts The default transaction confirmation options.
   *
   * (This api is for Node only.)
   */
  static local(e, T) {
    throw new Error("Provider local is not available on browser.");
  }
  /**
   * Returns a `Provider` read from the `ANCHOR_PROVIDER_URL` environment
   * variable
   *
   * (This api is for Node only.)
   */
  static env() {
    throw new Error("Provider env is not available on browser.");
  }
  /**
   * Sends the given transaction, paid for and signed by the provider's wallet.
   *
   * @param tx      The transaction to send.
   * @param signers The signers of the transaction.
   * @param opts    Transaction confirmation options.
   */
  async sendAndConfirm(e, T, $) {
    var V, J, ee, te;
    if ($ === void 0 && ($ = this.opts), isVersionedTransaction(e))
      T && e.sign(T);
    else if (e.feePayer = (V = e.feePayer) !== null && V !== void 0 ? V : this.wallet.publicKey, e.recentBlockhash = (await this.connection.getLatestBlockhash($.preflightCommitment)).blockhash, T)
      for (const ie of T)
        e.partialSign(ie);
    e = await this.wallet.signTransaction(e);
    const re = e.serialize();
    try {
      return await sendAndConfirmRawTransaction(this.connection, re, $);
    } catch (ie) {
      if (ie instanceof ConfirmError) {
        const se = encode$1(isVersionedTransaction(e) ? ((J = e.signatures) === null || J === void 0 ? void 0 : J[0]) || new Uint8Array() : (ee = e.signature) !== null && ee !== void 0 ? ee : new Uint8Array()), de = await this.connection.getTransaction(se, {
          commitment: "confirmed"
        });
        if (de) {
          const ue = (te = de.meta) === null || te === void 0 ? void 0 : te.logMessages;
          throw ue ? new SendTransactionError(ie.message, ue) : ie;
        } else
          throw ie;
      } else
        throw ie;
    }
  }
  /**
   * Similar to `send`, but for an array of transactions and signers.
   * All transactions need to be of the same type, it doesn't support a mix of `VersionedTransaction`s and `Transaction`s.
   *
   * @param txWithSigners Array of transactions and signers.
   * @param opts          Transaction confirmation options.
   */
  async sendAll(e, T) {
    var $, V, J;
    T === void 0 && (T = this.opts);
    const ee = (await this.connection.getLatestBlockhash(T.preflightCommitment)).blockhash;
    let te = e.map((se) => {
      var de, ue;
      if (isVersionedTransaction(se.tx)) {
        let fe = se.tx;
        return se.signers && fe.sign(se.signers), fe;
      } else {
        let fe = se.tx, he = (de = se.signers) !== null && de !== void 0 ? de : [];
        return fe.feePayer = (ue = fe.feePayer) !== null && ue !== void 0 ? ue : this.wallet.publicKey, fe.recentBlockhash = ee, he.forEach((me) => {
          fe.partialSign(me);
        }), fe;
      }
    });
    const re = await this.wallet.signAllTransactions(te), ie = [];
    for (let se = 0; se < te.length; se += 1) {
      const de = re[se], ue = de.serialize();
      try {
        ie.push(await sendAndConfirmRawTransaction(this.connection, ue, T));
      } catch (fe) {
        if (fe instanceof ConfirmError) {
          const he = encode$1(isVersionedTransaction(de) ? (($ = de.signatures) === null || $ === void 0 ? void 0 : $[0]) || new Uint8Array() : (V = de.signature) !== null && V !== void 0 ? V : new Uint8Array()), me = await this.connection.getTransaction(he, {
            commitment: "confirmed"
          });
          if (me) {
            const xe = (J = me.meta) === null || J === void 0 ? void 0 : J.logMessages;
            throw xe ? new SendTransactionError(fe.message, xe) : fe;
          } else
            throw fe;
        } else
          throw fe;
      }
    }
    return ie;
  }
  /**
   * Simulates the given transaction, returning emitted logs from execution.
   *
   * @param tx      The transaction to send.
   * @param signers The signers of the transaction. If unset, the transaction
   *                will be simulated with the "sigVerify: false" option. This
   *                allows for simulation of transactions without asking the
   *                wallet for a signature.
   * @param opts    Transaction confirmation options.
   */
  async simulate(e, T, $, V) {
    let J = (await this.connection.getLatestBlockhash($ ?? this.connection.commitment)).blockhash, ee;
    if (isVersionedTransaction(e) ? (T && (e.sign(T), e = await this.wallet.signTransaction(e)), ee = await this.connection.simulateTransaction(e, { commitment: $ })) : (e.feePayer = e.feePayer || this.wallet.publicKey, e.recentBlockhash = J, T && (e = await this.wallet.signTransaction(e)), ee = await simulateTransaction(this.connection, e, T, $, V)), ee.value.err)
      throw new SimulateError(ee.value);
    return ee.value;
  }
}
class SimulateError extends Error {
  constructor(e, T) {
    super(T), this.simulationResponse = e;
  }
}
async function sendAndConfirmRawTransaction(C, e, T) {
  const $ = T && {
    skipPreflight: T.skipPreflight,
    preflightCommitment: T.preflightCommitment || T.commitment
  }, V = await C.sendRawTransaction(e, $), J = (await C.confirmTransaction(V, T && T.commitment)).value;
  if (J.err)
    throw new ConfirmError(`Raw transaction ${V} failed (${JSON.stringify(J)})`);
  return V;
}
class ConfirmError extends Error {
  constructor(e) {
    super(e);
  }
}
function getProvider() {
  return AnchorProvider.local();
}
const _AVAILABLE_FEATURES = /* @__PURE__ */ new Set(["anchor-deprecated-state", "debug-logs"]), _FEATURES = /* @__PURE__ */ new Map();
function set(C) {
  if (!_AVAILABLE_FEATURES.has(C))
    throw new Error("Invalid feature");
  _FEATURES.set(C, !0);
}
function isSet(C) {
  return _FEATURES.get(C) !== void 0;
}
var features = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  set,
  isSet
});
class IdlError extends Error {
  constructor(e) {
    super(e), this.name = "IdlError";
  }
}
class ProgramErrorStack {
  constructor(e) {
    this.stack = e;
  }
  static parse(e) {
    var T;
    const $ = /^Program (\w*) invoke/, V = /^Program \w* success/, J = [];
    for (let ee = 0; ee < e.length; ee++) {
      if (V.exec(e[ee])) {
        J.pop();
        continue;
      }
      const te = (T = $.exec(e[ee])) === null || T === void 0 ? void 0 : T[1];
      te && J.push(new PublicKey(te));
    }
    return new ProgramErrorStack(J);
  }
}
class AnchorError extends Error {
  constructor(e, T, $, V, J, ee) {
    super($.join(`
`).replace("Program log: ", "")), this.errorLogs = $, this.logs = V, this.error = { errorCode: e, errorMessage: T, comparedValues: ee, origin: J }, this._programErrorStack = ProgramErrorStack.parse(V);
  }
  static parse(e) {
    if (!e)
      return null;
    const T = e.findIndex((ue) => ue.startsWith("Program log: AnchorError"));
    if (T === -1)
      return null;
    const $ = e[T], V = [$];
    let J;
    if (T + 1 < e.length) {
      if (e[T + 1] === "Program log: Left:") {
        const ue = /^Program log: (.*)$/, fe = ue.exec(e[T + 2])[1], he = ue.exec(e[T + 4])[1];
        J = [
          new PublicKey(fe),
          new PublicKey(he)
        ], V.push(...e.slice(T + 1, T + 5));
      } else if (e[T + 1].startsWith("Program log: Left:")) {
        const ue = /^Program log: (Left|Right): (.*)$/, fe = ue.exec(e[T + 1])[2], he = ue.exec(e[T + 2])[2];
        V.push(...e.slice(T + 1, T + 3)), J = [fe, he];
      }
    }
    const te = /^Program log: AnchorError occurred\. Error Code: (.*)\. Error Number: (\d*)\. Error Message: (.*)\./.exec($), ie = /^Program log: AnchorError thrown in (.*):(\d*)\. Error Code: (.*)\. Error Number: (\d*)\. Error Message: (.*)\./.exec($), de = /^Program log: AnchorError caused by account: (.*)\. Error Code: (.*)\. Error Number: (\d*)\. Error Message: (.*)\./.exec($);
    if (te) {
      const [ue, fe, he] = te.slice(1, 4), me = {
        code: ue,
        number: parseInt(fe)
      };
      return new AnchorError(me, he, V, e, void 0, J);
    } else if (ie) {
      const [ue, fe, he, me, xe] = ie.slice(1, 6), ve = {
        code: he,
        number: parseInt(me)
      }, Te = { file: ue, line: parseInt(fe) };
      return new AnchorError(ve, xe, V, e, Te, J);
    } else if (de) {
      const [ue, fe, he, me] = de.slice(1, 5), xe = ue, ve = {
        code: fe,
        number: parseInt(he)
      };
      return new AnchorError(ve, me, V, e, xe, J);
    } else
      return null;
  }
  get program() {
    return this._programErrorStack.stack[this._programErrorStack.stack.length - 1];
  }
  get programErrorStack() {
    return this._programErrorStack.stack;
  }
  toString() {
    return this.message;
  }
}
class ProgramError extends Error {
  constructor(e, T, $) {
    super(), this.code = e, this.msg = T, this.logs = $, $ && (this._programErrorStack = ProgramErrorStack.parse($));
  }
  static parse(e, T) {
    const $ = e.toString();
    let V;
    if ($.includes("custom program error:")) {
      let te = $.split("custom program error: ");
      if (te.length !== 2)
        return null;
      V = te[1];
    } else {
      const te = $.match(/"Custom":([0-9]+)}/g);
      if (!te || te.length > 1)
        return null;
      V = te[0].match(/([0-9]+)/g)[0];
    }
    let J;
    try {
      J = parseInt(V);
    } catch {
      return null;
    }
    let ee = T.get(J);
    return ee !== void 0 ? new ProgramError(J, ee, e.logs) : (ee = LangErrorMessage.get(J), ee !== void 0 ? new ProgramError(J, ee, e.logs) : null);
  }
  get program() {
    var e;
    return (e = this._programErrorStack) === null || e === void 0 ? void 0 : e.stack[this._programErrorStack.stack.length - 1];
  }
  get programErrorStack() {
    var e;
    return (e = this._programErrorStack) === null || e === void 0 ? void 0 : e.stack;
  }
  toString() {
    return this.msg;
  }
}
function translateError(C, e) {
  isSet("debug-logs") && console.log("Translating error:", C);
  const T = AnchorError.parse(C.logs);
  if (T)
    return T;
  const $ = ProgramError.parse(C, e);
  if ($)
    return $;
  if (C.logs) {
    const V = {
      get: function(J, ee) {
        return ee === "programErrorStack" ? J.programErrorStack.stack : ee === "program" ? J.programErrorStack.stack[C.programErrorStack.stack.length - 1] : Reflect.get(...arguments);
      }
    };
    return C.programErrorStack = ProgramErrorStack.parse(C.logs), new Proxy(C, V);
  }
  return C;
}
const LangErrorCode = {
  // Instructions.
  InstructionMissing: 100,
  InstructionFallbackNotFound: 101,
  InstructionDidNotDeserialize: 102,
  InstructionDidNotSerialize: 103,
  // IDL instructions.
  IdlInstructionStub: 1e3,
  IdlInstructionInvalidProgram: 1001,
  // Constraints.
  ConstraintMut: 2e3,
  ConstraintHasOne: 2001,
  ConstraintSigner: 2002,
  ConstraintRaw: 2003,
  ConstraintOwner: 2004,
  ConstraintRentExempt: 2005,
  ConstraintSeeds: 2006,
  ConstraintExecutable: 2007,
  ConstraintState: 2008,
  ConstraintAssociated: 2009,
  ConstraintAssociatedInit: 2010,
  ConstraintClose: 2011,
  ConstraintAddress: 2012,
  ConstraintZero: 2013,
  ConstraintTokenMint: 2014,
  ConstraintTokenOwner: 2015,
  ConstraintMintMintAuthority: 2016,
  ConstraintMintFreezeAuthority: 2017,
  ConstraintMintDecimals: 2018,
  ConstraintSpace: 2019,
  ConstraintAccountIsNone: 2020,
  // Require.
  RequireViolated: 2500,
  RequireEqViolated: 2501,
  RequireKeysEqViolated: 2502,
  RequireNeqViolated: 2503,
  RequireKeysNeqViolated: 2504,
  RequireGtViolated: 2505,
  RequireGteViolated: 2506,
  // Accounts.
  AccountDiscriminatorAlreadySet: 3e3,
  AccountDiscriminatorNotFound: 3001,
  AccountDiscriminatorMismatch: 3002,
  AccountDidNotDeserialize: 3003,
  AccountDidNotSerialize: 3004,
  AccountNotEnoughKeys: 3005,
  AccountNotMutable: 3006,
  AccountOwnedByWrongProgram: 3007,
  InvalidProgramId: 3008,
  InvalidProgramExecutable: 3009,
  AccountNotSigner: 3010,
  AccountNotSystemOwned: 3011,
  AccountNotInitialized: 3012,
  AccountNotProgramData: 3013,
  AccountNotAssociatedTokenAccount: 3014,
  AccountSysvarMismatch: 3015,
  AccountReallocExceedsLimit: 3016,
  AccountDuplicateReallocs: 3017,
  // Miscellaneous
  DeclaredProgramIdMismatch: 4100,
  // Used for APIs that shouldn't be used anymore.
  Deprecated: 5e3
}, LangErrorMessage = /* @__PURE__ */ new Map([
  // Instructions.
  [
    LangErrorCode.InstructionMissing,
    "8 byte instruction identifier not provided"
  ],
  [
    LangErrorCode.InstructionFallbackNotFound,
    "Fallback functions are not supported"
  ],
  [
    LangErrorCode.InstructionDidNotDeserialize,
    "The program could not deserialize the given instruction"
  ],
  [
    LangErrorCode.InstructionDidNotSerialize,
    "The program could not serialize the given instruction"
  ],
  // Idl instructions.
  [
    LangErrorCode.IdlInstructionStub,
    "The program was compiled without idl instructions"
  ],
  [
    LangErrorCode.IdlInstructionInvalidProgram,
    "The transaction was given an invalid program for the IDL instruction"
  ],
  // Constraints.
  [LangErrorCode.ConstraintMut, "A mut constraint was violated"],
  [LangErrorCode.ConstraintHasOne, "A has one constraint was violated"],
  [LangErrorCode.ConstraintSigner, "A signer constraint was violated"],
  [LangErrorCode.ConstraintRaw, "A raw constraint was violated"],
  [LangErrorCode.ConstraintOwner, "An owner constraint was violated"],
  [
    LangErrorCode.ConstraintRentExempt,
    "A rent exemption constraint was violated"
  ],
  [LangErrorCode.ConstraintSeeds, "A seeds constraint was violated"],
  [LangErrorCode.ConstraintExecutable, "An executable constraint was violated"],
  [
    LangErrorCode.ConstraintState,
    "Deprecated Error, feel free to replace with something else"
  ],
  [LangErrorCode.ConstraintAssociated, "An associated constraint was violated"],
  [
    LangErrorCode.ConstraintAssociatedInit,
    "An associated init constraint was violated"
  ],
  [LangErrorCode.ConstraintClose, "A close constraint was violated"],
  [LangErrorCode.ConstraintAddress, "An address constraint was violated"],
  [LangErrorCode.ConstraintZero, "Expected zero account discriminant"],
  [LangErrorCode.ConstraintTokenMint, "A token mint constraint was violated"],
  [LangErrorCode.ConstraintTokenOwner, "A token owner constraint was violated"],
  [
    LangErrorCode.ConstraintMintMintAuthority,
    "A mint mint authority constraint was violated"
  ],
  [
    LangErrorCode.ConstraintMintFreezeAuthority,
    "A mint freeze authority constraint was violated"
  ],
  [
    LangErrorCode.ConstraintMintDecimals,
    "A mint decimals constraint was violated"
  ],
  [LangErrorCode.ConstraintSpace, "A space constraint was violated"],
  [
    LangErrorCode.ConstraintAccountIsNone,
    "A required account for the constraint is None"
  ],
  // Require.
  [LangErrorCode.RequireViolated, "A require expression was violated"],
  [LangErrorCode.RequireEqViolated, "A require_eq expression was violated"],
  [
    LangErrorCode.RequireKeysEqViolated,
    "A require_keys_eq expression was violated"
  ],
  [LangErrorCode.RequireNeqViolated, "A require_neq expression was violated"],
  [
    LangErrorCode.RequireKeysNeqViolated,
    "A require_keys_neq expression was violated"
  ],
  [LangErrorCode.RequireGtViolated, "A require_gt expression was violated"],
  [LangErrorCode.RequireGteViolated, "A require_gte expression was violated"],
  // Accounts.
  [
    LangErrorCode.AccountDiscriminatorAlreadySet,
    "The account discriminator was already set on this account"
  ],
  [
    LangErrorCode.AccountDiscriminatorNotFound,
    "No 8 byte discriminator was found on the account"
  ],
  [
    LangErrorCode.AccountDiscriminatorMismatch,
    "8 byte discriminator did not match what was expected"
  ],
  [LangErrorCode.AccountDidNotDeserialize, "Failed to deserialize the account"],
  [LangErrorCode.AccountDidNotSerialize, "Failed to serialize the account"],
  [
    LangErrorCode.AccountNotEnoughKeys,
    "Not enough account keys given to the instruction"
  ],
  [LangErrorCode.AccountNotMutable, "The given account is not mutable"],
  [
    LangErrorCode.AccountOwnedByWrongProgram,
    "The given account is owned by a different program than expected"
  ],
  [LangErrorCode.InvalidProgramId, "Program ID was not as expected"],
  [LangErrorCode.InvalidProgramExecutable, "Program account is not executable"],
  [LangErrorCode.AccountNotSigner, "The given account did not sign"],
  [
    LangErrorCode.AccountNotSystemOwned,
    "The given account is not owned by the system program"
  ],
  [
    LangErrorCode.AccountNotInitialized,
    "The program expected this account to be already initialized"
  ],
  [
    LangErrorCode.AccountNotProgramData,
    "The given account is not a program data account"
  ],
  [
    LangErrorCode.AccountNotAssociatedTokenAccount,
    "The given account is not the associated token account"
  ],
  [
    LangErrorCode.AccountSysvarMismatch,
    "The given public key does not match the required sysvar"
  ],
  [
    LangErrorCode.AccountReallocExceedsLimit,
    "The account reallocation exceeds the MAX_PERMITTED_DATA_INCREASE limit"
  ],
  [
    LangErrorCode.AccountDuplicateReallocs,
    "The account was duplicated for more than one reallocation"
  ],
  // Miscellaneous
  [
    LangErrorCode.DeclaredProgramIdMismatch,
    "The declared program id does not match the actual program id"
  ],
  // Deprecated
  [
    LangErrorCode.Deprecated,
    "The API being used is deprecated and should no longer be used"
  ]
]);
var __assign$1 = function() {
  return __assign$1 = Object.assign || function(e) {
    for (var T, $ = 1, V = arguments.length; $ < V; $++) {
      T = arguments[$];
      for (var J in T) Object.prototype.hasOwnProperty.call(T, J) && (e[J] = T[J]);
    }
    return e;
  }, __assign$1.apply(this, arguments);
}, __assign = function() {
  return __assign = Object.assign || function(e) {
    for (var T, $ = 1, V = arguments.length; $ < V; $++) {
      T = arguments[$];
      for (var J in T) Object.prototype.hasOwnProperty.call(T, J) && (e[J] = T[J]);
    }
    return e;
  }, __assign.apply(this, arguments);
};
function lowerCase(C) {
  return C.toLowerCase();
}
var DEFAULT_SPLIT_REGEXP = [/([a-z0-9])([A-Z])/g, /([A-Z])([A-Z][a-z])/g], DEFAULT_STRIP_REGEXP = /[^A-Z0-9]+/gi;
function noCase(C, e) {
  e === void 0 && (e = {});
  for (var T = e.splitRegexp, $ = T === void 0 ? DEFAULT_SPLIT_REGEXP : T, V = e.stripRegexp, J = V === void 0 ? DEFAULT_STRIP_REGEXP : V, ee = e.transform, te = ee === void 0 ? lowerCase : ee, re = e.delimiter, ie = re === void 0 ? " " : re, se = replace(replace(C, $, "$1\0$2"), J, "\0"), de = 0, ue = se.length; se.charAt(de) === "\0"; )
    de++;
  for (; se.charAt(ue - 1) === "\0"; )
    ue--;
  return se.slice(de, ue).split("\0").map(te).join(ie);
}
function replace(C, e, T) {
  return e instanceof RegExp ? C.replace(e, T) : e.reduce(function($, V) {
    return $.replace(V, T);
  }, C);
}
function dotCase(C, e) {
  return e === void 0 && (e = {}), noCase(C, __assign({ delimiter: "." }, e));
}
function snakeCase(C, e) {
  return e === void 0 && (e = {}), dotCase(C, __assign$1({ delimiter: "_" }, e));
}
let IdlCoder$1 = class Wr {
  static fieldLayout(e, T) {
    const $ = e.name !== void 0 ? camelCase$1(e.name) : void 0;
    switch (e.type) {
      case "bool":
        return dist$1.bool($);
      case "u8":
        return dist$1.u8($);
      case "i8":
        return dist$1.i8($);
      case "u16":
        return dist$1.u16($);
      case "i16":
        return dist$1.i16($);
      case "u32":
        return dist$1.u32($);
      case "i32":
        return dist$1.i32($);
      case "f32":
        return dist$1.f32($);
      case "u64":
        return dist$1.u64($);
      case "i64":
        return dist$1.i64($);
      case "f64":
        return dist$1.f64($);
      case "u128":
        return dist$1.u128($);
      case "i128":
        return dist$1.i128($);
      case "u256":
        return dist$1.u256($);
      case "i256":
        return dist$1.i256($);
      case "bytes":
        return dist$1.vecU8($);
      case "string":
        return dist$1.str($);
      case "publicKey":
        return dist$1.publicKey($);
      default: {
        if ("vec" in e.type)
          return dist$1.vec(Wr.fieldLayout({
            name: void 0,
            type: e.type.vec
          }, T), $);
        if ("option" in e.type)
          return dist$1.option(Wr.fieldLayout({
            name: void 0,
            type: e.type.option
          }, T), $);
        if ("defined" in e.type) {
          if (!T)
            throw new IdlError("User defined types not provided");
          const V = e.type.defined, J = T.filter((ee) => ee.name === V);
          if (J.length !== 1)
            throw new IdlError(`Type not found: ${JSON.stringify(e)}`);
          return Wr.typeDefLayout(J[0], T, $);
        } else if ("array" in e.type) {
          let V = e.type.array[0], J = e.type.array[1], ee = Wr.fieldLayout({
            name: void 0,
            type: V
          }, T);
          return dist$1.array(ee, J, $);
        } else
          throw new Error(`Not yet implemented: ${e}`);
      }
    }
  }
  static typeDefLayout(e, T = [], $) {
    switch (e.type.kind) {
      case "struct": {
        const V = e.type.fields.map((J) => Wr.fieldLayout(J, T));
        return dist$1.struct(V, $);
      }
      case "enum": {
        let V = e.type.variants.map((J) => {
          const ee = camelCase$1(J.name);
          if (!J.fields)
            return dist$1.struct([], ee);
          const te = J.fields.map((re, ie) => re != null && re.name ? Wr.fieldLayout(re, T) : Wr.fieldLayout({ type: re, name: ie.toString() }, T));
          return dist$1.struct(te, ee);
        });
        return $ !== void 0 ? dist$1.rustEnum(V).replicate($) : dist$1.rustEnum(V, $);
      }
      case "alias":
        return Wr.fieldLayout({ type: e.type.value, name: e.name }, T);
    }
  }
};
const SIGHASH_GLOBAL_NAMESPACE = "global";
class BorshInstructionCoder {
  constructor(e) {
    this.idl = e, this.ixLayout = BorshInstructionCoder.parseIxLayout(e);
    const T = /* @__PURE__ */ new Map();
    e.instructions.forEach(($) => {
      const V = sighash(SIGHASH_GLOBAL_NAMESPACE, $.name);
      T.set(bs58$6.encode(V), {
        layout: this.ixLayout.get($.name),
        name: $.name
      });
    }), this.sighashLayouts = T;
  }
  /**
   * Encodes a program instruction.
   */
  encode(e, T) {
    return this._encode(SIGHASH_GLOBAL_NAMESPACE, e, T);
  }
  _encode(e, T, $) {
    const V = bufferPolyfill.Buffer.alloc(1e3), J = camelCase$1(T), ee = this.ixLayout.get(J);
    if (!ee)
      throw new Error(`Unknown method: ${J}`);
    const te = ee.encode($, V), re = V.slice(0, te);
    return bufferPolyfill.Buffer.concat([sighash(e, T), re]);
  }
  static parseIxLayout(e) {
    const T = e.instructions.map(($) => {
      let V = $.args.map((ee) => {
        var te, re;
        return IdlCoder$1.fieldLayout(ee, Array.from([...(te = e.accounts) !== null && te !== void 0 ? te : [], ...(re = e.types) !== null && re !== void 0 ? re : []]));
      });
      const J = camelCase$1($.name);
      return [J, dist$1.struct(V, J)];
    });
    return new Map(T);
  }
  /**
   * Decodes a program instruction.
   */
  decode(e, T = "hex") {
    typeof e == "string" && (e = T === "hex" ? bufferPolyfill.Buffer.from(e, "hex") : bs58$6.decode(e));
    let $ = bs58$6.encode(e.slice(0, 8)), V = e.slice(8);
    const J = this.sighashLayouts.get($);
    return J ? {
      data: J.layout.decode(V),
      name: J.name
    } : null;
  }
  /**
   * Returns a formatted table of all the fields in the given instruction data.
   */
  format(e, T) {
    return InstructionFormatter.format(e, T, this.idl);
  }
}
class InstructionFormatter {
  static format(e, T, $) {
    const V = $.instructions.filter((re) => e.name === re.name)[0];
    if (V === void 0)
      return console.error("Invalid instruction given"), null;
    const J = V.args.map((re) => ({
      name: re.name,
      type: InstructionFormatter.formatIdlType(re.type),
      data: InstructionFormatter.formatIdlData(re, e.data[re.name], $.types)
    })), ee = InstructionFormatter.flattenIdlAccounts(V.accounts), te = T.map((re, ie) => ie < ee.length ? {
      name: ee[ie].name,
      ...re
    } : {
      name: void 0,
      ...re
    });
    return {
      args: J,
      accounts: te
    };
  }
  static formatIdlType(e) {
    if (typeof e == "string")
      return e;
    if ("vec" in e)
      return `Vec<${this.formatIdlType(e.vec)}>`;
    if ("option" in e)
      return `Option<${this.formatIdlType(e.option)}>`;
    if ("defined" in e)
      return e.defined;
    if ("array" in e)
      return `Array<${e.array[0]}; ${e.array[1]}>`;
    throw new Error(`Unknown IDL type: ${e}`);
  }
  static formatIdlData(e, T, $) {
    if (typeof e.type == "string")
      return T.toString();
    if (e.type.hasOwnProperty("vec"))
      return "[" + T.map((V) => this.formatIdlData({ name: "", type: e.type.vec }, V)).join(", ") + "]";
    if (e.type.hasOwnProperty("option"))
      return T === null ? "null" : this.formatIdlData({ name: "", type: e.type.option }, T, $);
    if (e.type.hasOwnProperty("defined")) {
      if ($ === void 0)
        throw new Error("User defined types not provided");
      const V = $.filter((J) => J.name === e.type.defined);
      if (V.length !== 1)
        throw new Error(`Type not found: ${e.type.defined}`);
      return InstructionFormatter.formatIdlDataDefined(V[0], T, $);
    }
    return "unknown";
  }
  static formatIdlDataDefined(e, T, $) {
    switch (e.type.kind) {
      case "struct": {
        const V = e.type;
        return "{ " + Object.keys(T).map((ee) => {
          const te = V.fields.find((re) => re.name === ee);
          if (!te)
            throw new Error("Unable to find type");
          return ee + ": " + InstructionFormatter.formatIdlData(te, T[ee], $);
        }).join(", ") + " }";
      }
      case "enum": {
        if (e.type.variants.length === 0)
          return "{}";
        if (e.type.variants[0].name) {
          const V = e.type.variants, J = Object.keys(T)[0], ee = T[J], te = Object.keys(ee).map((ie) => {
            var se;
            const de = ee[ie], ue = (se = V[J]) === null || se === void 0 ? void 0 : se.find((fe) => fe.name === ie);
            if (!ue)
              throw new Error("Unable to find variant");
            return ie + ": " + InstructionFormatter.formatIdlData(ue, de, $);
          }).join(", "), re = camelCase$1(J, { pascalCase: !0 });
          return te.length === 0 ? re : `${re} { ${te} }`;
        } else
          return "Tuple formatting not yet implemented";
      }
      case "alias":
        return InstructionFormatter.formatIdlType(e.type.value);
    }
  }
  static flattenIdlAccounts(e, T) {
    return e.map(($) => {
      const V = sentenceCase($.name);
      if ($.hasOwnProperty("accounts")) {
        const J = T ? `${T} > ${V}` : V;
        return InstructionFormatter.flattenIdlAccounts($.accounts, J);
      } else
        return {
          ...$,
          name: T ? `${T} > ${V}` : V
        };
    }).flat();
  }
}
function sentenceCase(C) {
  const e = C.replace(/([A-Z])/g, " $1");
  return e.charAt(0).toUpperCase() + e.slice(1);
}
function sighash(C, e) {
  let T = snakeCase(e), $ = `${C}:${T}`;
  return bufferPolyfill.Buffer.from(sha256$5($).slice(0, 8));
}
function accountSize(C, e) {
  switch (e.type.kind) {
    case "struct":
      return e.type.fields.map((T) => typeSize(C, T.type)).reduce((T, $) => T + $, 0);
    case "enum": {
      const T = e.type.variants.map(($) => $.fields ? $.fields.map((V) => typeof V == "object" && "name" in V ? typeSize(C, V.type) : typeSize(C, V)).reduce((V, J) => V + J, 0) : 0);
      return Math.max(...T) + 1;
    }
    case "alias":
      return typeSize(C, e.type.value);
  }
}
function typeSize(C, e) {
  var T, $;
  switch (e) {
    case "bool":
      return 1;
    case "u8":
      return 1;
    case "i8":
      return 1;
    case "i16":
      return 2;
    case "u16":
      return 2;
    case "u32":
      return 4;
    case "i32":
      return 4;
    case "f32":
      return 4;
    case "u64":
      return 8;
    case "i64":
      return 8;
    case "f64":
      return 8;
    case "u128":
      return 16;
    case "i128":
      return 16;
    case "u256":
      return 32;
    case "i256":
      return 32;
    case "bytes":
      return 1;
    case "string":
      return 1;
    case "publicKey":
      return 32;
    default:
      if ("vec" in e)
        return 1;
      if ("option" in e)
        return 1 + typeSize(C, e.option);
      if ("coption" in e)
        return 4 + typeSize(C, e.coption);
      if ("defined" in e) {
        const V = ($ = (T = C.types) === null || T === void 0 ? void 0 : T.filter((ee) => ee.name === e.defined)) !== null && $ !== void 0 ? $ : [];
        if (V.length !== 1)
          throw new IdlError(`Type not found: ${JSON.stringify(e)}`);
        let J = V[0];
        return accountSize(C, J);
      }
      if ("array" in e) {
        let V = e.array[0], J = e.array[1];
        return typeSize(C, V) * J;
      }
      throw new Error(`Invalid type ${JSON.stringify(e)}`);
  }
}
const DISCRIMINATOR_SIZE = 8;
function discriminator(C) {
  return dist$2.Buffer.from(sha256$5(C).slice(0, DISCRIMINATOR_SIZE));
}
class BorshAccountsCoder {
  constructor(e) {
    if (e.accounts === void 0) {
      this.accountLayouts = /* @__PURE__ */ new Map();
      return;
    }
    const T = e.accounts.map(($) => [$.name, IdlCoder$1.typeDefLayout($, e.types)]);
    this.accountLayouts = new Map(T), this.idl = e;
  }
  async encode(e, T) {
    const $ = bufferPolyfill.Buffer.alloc(1e3), V = this.accountLayouts.get(e);
    if (!V)
      throw new Error(`Unknown account: ${e}`);
    const J = V.encode(T, $);
    let ee = $.slice(0, J), te = BorshAccountsCoder.accountDiscriminator(e);
    return bufferPolyfill.Buffer.concat([te, ee]);
  }
  decode(e, T) {
    if (BorshAccountsCoder.accountDiscriminator(e).compare(T.slice(0, 8)))
      throw new Error("Invalid account discriminator");
    return this.decodeUnchecked(e, T);
  }
  decodeAny(e) {
    const T = e.slice(0, 8), $ = Array.from(this.accountLayouts.keys()).find((V) => BorshAccountsCoder.accountDiscriminator(V).equals(T));
    if (!$)
      throw new Error("Account descriminator not found");
    return this.decodeUnchecked($, e);
  }
  decodeUnchecked(e, T) {
    const $ = T.subarray(DISCRIMINATOR_SIZE), V = this.accountLayouts.get(e);
    if (!V)
      throw new Error(`Unknown account: ${e}`);
    return V.decode($);
  }
  memcmp(e, T) {
    const $ = BorshAccountsCoder.accountDiscriminator(e);
    return {
      offset: 0,
      bytes: bs58$6.encode(T ? bufferPolyfill.Buffer.concat([$, T]) : $)
    };
  }
  size(e) {
    var T;
    return DISCRIMINATOR_SIZE + ((T = accountSize(this.idl, e)) !== null && T !== void 0 ? T : 0);
  }
  /**
   * Calculates and returns a unique 8 byte discriminator prepended to all anchor accounts.
   *
   * @param name The name of the account to calculate the discriminator.
   */
  static accountDiscriminator(e) {
    const T = `account:${camelCase$1(e, {
      pascalCase: !0,
      preserveConsecutiveUppercase: !0
    })}`;
    return discriminator(T);
  }
}
class BorshEventCoder {
  constructor(e) {
    if (e.events === void 0) {
      this.layouts = /* @__PURE__ */ new Map();
      return;
    }
    const T = e.events.map(($) => {
      let V = {
        name: $.name,
        type: {
          kind: "struct",
          fields: $.fields.map((J) => ({ name: J.name, type: J.type }))
        }
      };
      return [$.name, IdlCoder$1.typeDefLayout(V, e.types)];
    });
    this.layouts = new Map(T), this.discriminators = new Map(e.events === void 0 ? [] : e.events.map(($) => [
      encode(eventDiscriminator($.name)),
      $.name
    ]));
  }
  decode(e) {
    let T;
    try {
      T = decode(e);
    } catch {
      return null;
    }
    const $ = encode(T.slice(0, 8)), V = this.discriminators.get($);
    if (V === void 0)
      return null;
    const J = this.layouts.get(V);
    if (!J)
      throw new Error(`Unknown event: ${V}`);
    return { data: J.decode(T.slice(8)), name: V };
  }
}
function eventDiscriminator(C) {
  return discriminator(`event:${C}`);
}
class BorshTypesCoder {
  constructor(e) {
    if (e.types === void 0) {
      this.typeLayouts = /* @__PURE__ */ new Map();
      return;
    }
    const T = e.types.map(($) => [$.name, IdlCoder$1.typeDefLayout($, e.types)]);
    this.typeLayouts = new Map(T), this.idl = e;
  }
  encode(e, T) {
    const $ = bufferPolyfill.Buffer.alloc(1e3), V = this.typeLayouts.get(e);
    if (!V)
      throw new Error(`Unknown type: ${e}`);
    const J = V.encode(T, $);
    return $.slice(0, J);
  }
  decode(e, T) {
    const $ = this.typeLayouts.get(e);
    if (!$)
      throw new Error(`Unknown type: ${e}`);
    return $.decode(T);
  }
}
class BorshCoder {
  constructor(e) {
    this.instruction = new BorshInstructionCoder(e), this.accounts = new BorshAccountsCoder(e), this.events = new BorshEventCoder(e), this.types = new BorshTypesCoder(e);
  }
}
var commonjsGlobal = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof dist$2.global < "u" ? dist$2.global : typeof self < "u" ? self : {};
function getDefaultExportFromCjs(C) {
  return C && C.__esModule && Object.prototype.hasOwnProperty.call(C, "default") ? C.default : C;
}
class Layout {
  constructor(e, T) {
    if (!Number.isInteger(e))
      throw new TypeError("span must be an integer");
    this.span = e, this.property = T;
  }
  /** Function to create an Object into which decoded properties will
   * be written.
   *
   * Used only for layouts that {@link Layout#decode|decode} to Object
   * instances, which means:
   * * {@link Structure}
   * * {@link Union}
   * * {@link VariantLayout}
   * * {@link BitStructure}
   *
   * If left undefined the JavaScript representation of these layouts
   * will be Object instances.
   *
   * See {@link bindConstructorLayout}.
   */
  makeDestinationObject() {
    return {};
  }
  /**
   * Decode from a Buffer into an JavaScript value.
   *
   * @param {Buffer} b - the buffer from which encoded data is read.
   *
   * @param {Number} [offset] - the offset at which the encoded data
   * starts.  If absent a zero offset is inferred.
   *
   * @returns {(Number|Array|Object)} - the value of the decoded data.
   *
   * @abstract
   */
  decode(e, T) {
    throw new Error("Layout is abstract");
  }
  /**
   * Encode a JavaScript value into a Buffer.
   *
   * @param {(Number|Array|Object)} src - the value to be encoded into
   * the buffer.  The type accepted depends on the (sub-)type of {@link
   * Layout}.
   *
   * @param {Buffer} b - the buffer into which encoded data will be
   * written.
   *
   * @param {Number} [offset] - the offset at which the encoded data
   * starts.  If absent a zero offset is inferred.
   *
   * @returns {Number} - the number of bytes encoded, including the
   * space skipped for internal padding, but excluding data such as
   * {@link Sequence#count|lengths} when stored {@link
   * ExternalLayout|externally}.  This is the adjustment to `offset`
   * producing the offset where data for the next layout would be
   * written.
   *
   * @abstract
   */
  encode(e, T, $) {
    throw new Error("Layout is abstract");
  }
  /**
   * Calculate the span of a specific instance of a layout.
   *
   * @param {Buffer} b - the buffer that contains an encoded instance.
   *
   * @param {Number} [offset] - the offset at which the encoded instance
   * starts.  If absent a zero offset is inferred.
   *
   * @return {Number} - the number of bytes covered by the layout
   * instance.  If this method is not overridden in a subclass the
   * definition-time constant {@link Layout#span|span} will be
   * returned.
   *
   * @throws {RangeError} - if the length of the value cannot be
   * determined.
   */
  getSpan(e, T) {
    if (0 > this.span)
      throw new RangeError("indeterminate span");
    return this.span;
  }
  /**
   * Replicate the layout using a new property.
   *
   * This function must be used to get a structurally-equivalent layout
   * with a different name since all {@link Layout} instances are
   * immutable.
   *
   * **NOTE** This is a shallow copy.  All fields except {@link
   * Layout#property|property} are strictly equal to the origin layout.
   *
   * @param {String} property - the value for {@link
   * Layout#property|property} in the replica.
   *
   * @returns {Layout} - the copy with {@link Layout#property|property}
   * set to `property`.
   */
  replicate(e) {
    const T = Object.create(this.constructor.prototype);
    return Object.assign(T, this), T.property = e, T;
  }
  /**
   * Create an object from layout properties and an array of values.
   *
   * **NOTE** This function returns `undefined` if invoked on a layout
   * that does not return its value as an Object.  Objects are
   * returned for things that are a {@link Structure}, which includes
   * {@link VariantLayout|variant layouts} if they are structures, and
   * excludes {@link Union}s.  If you want this feature for a union
   * you must use {@link Union.getVariant|getVariant} to select the
   * desired layout.
   *
   * @param {Array} values - an array of values that correspond to the
   * default order for properties.  As with {@link Layout#decode|decode}
   * layout elements that have no property name are skipped when
   * iterating over the array values.  Only the top-level properties are
   * assigned; arguments are not assigned to properties of contained
   * layouts.  Any unused values are ignored.
   *
   * @return {(Object|undefined)}
   */
  fromArray(e) {
  }
}
var Layout_2 = Layout;
function nameWithProperty(C, e) {
  return e.property ? C + "[" + e.property + "]" : C;
}
class ExternalLayout extends Layout {
  /**
   * Return `true` iff the external layout decodes to an unsigned
   * integer layout.
   *
   * In that case it can be used as the source of {@link
   * Sequence#count|Sequence counts}, {@link Blob#length|Blob lengths},
   * or as {@link UnionLayoutDiscriminator#layout|external union
   * discriminators}.
   *
   * @abstract
   */
  isCount() {
    throw new Error("ExternalLayout is abstract");
  }
}
class OffsetLayout extends ExternalLayout {
  constructor(e, T, $) {
    if (!(e instanceof Layout))
      throw new TypeError("layout must be a Layout");
    if (T === void 0)
      T = 0;
    else if (!Number.isInteger(T))
      throw new TypeError("offset must be integer or undefined");
    super(e.span, $ || e.property), this.layout = e, this.offset = T;
  }
  /** @override */
  isCount() {
    return this.layout instanceof UInt || this.layout instanceof UIntBE;
  }
  /** @override */
  decode(e, T) {
    return T === void 0 && (T = 0), this.layout.decode(e, T + this.offset);
  }
  /** @override */
  encode(e, T, $) {
    return $ === void 0 && ($ = 0), this.layout.encode(e, T, $ + this.offset);
  }
}
class UInt extends Layout {
  constructor(e, T) {
    if (super(e, T), 6 < this.span)
      throw new RangeError("span must not exceed 6 bytes");
  }
  /** @override */
  decode(e, T) {
    return T === void 0 && (T = 0), e.readUIntLE(T, this.span);
  }
  /** @override */
  encode(e, T, $) {
    return $ === void 0 && ($ = 0), T.writeUIntLE(e, $, this.span), this.span;
  }
}
class UIntBE extends Layout {
  constructor(e, T) {
    if (super(e, T), 6 < this.span)
      throw new RangeError("span must not exceed 6 bytes");
  }
  /** @override */
  decode(e, T) {
    return T === void 0 && (T = 0), e.readUIntBE(T, this.span);
  }
  /** @override */
  encode(e, T, $) {
    return $ === void 0 && ($ = 0), T.writeUIntBE(e, $, this.span), this.span;
  }
}
const V2E32 = Math.pow(2, 32);
function divmodInt64(C) {
  const e = Math.floor(C / V2E32), T = C - e * V2E32;
  return { hi32: e, lo32: T };
}
function roundedInt64(C, e) {
  return C * V2E32 + e;
}
class NearUInt64 extends Layout {
  constructor(e) {
    super(8, e);
  }
  /** @override */
  decode(e, T) {
    T === void 0 && (T = 0);
    const $ = e.readUInt32LE(T), V = e.readUInt32LE(T + 4);
    return roundedInt64(V, $);
  }
  /** @override */
  encode(e, T, $) {
    $ === void 0 && ($ = 0);
    const V = divmodInt64(e);
    return T.writeUInt32LE(V.lo32, $), T.writeUInt32LE(V.hi32, $ + 4), 8;
  }
}
class NearInt64 extends Layout {
  constructor(e) {
    super(8, e);
  }
  /** @override */
  decode(e, T) {
    T === void 0 && (T = 0);
    const $ = e.readUInt32LE(T), V = e.readInt32LE(T + 4);
    return roundedInt64(V, $);
  }
  /** @override */
  encode(e, T, $) {
    $ === void 0 && ($ = 0);
    const V = divmodInt64(e);
    return T.writeUInt32LE(V.lo32, $), T.writeInt32LE(V.hi32, $ + 4), 8;
  }
}
class Structure extends Layout {
  constructor(e, T, $) {
    if (!(Array.isArray(e) && e.reduce((J, ee) => J && ee instanceof Layout, !0)))
      throw new TypeError("fields must be array of Layout instances");
    typeof T == "boolean" && $ === void 0 && ($ = T, T = void 0);
    for (const J of e)
      if (0 > J.span && J.property === void 0)
        throw new Error("fields cannot contain unnamed variable-length layout");
    let V = -1;
    try {
      V = e.reduce((J, ee) => J + ee.getSpan(), 0);
    } catch {
    }
    super(V, T), this.fields = e, this.decodePrefixes = !!$;
  }
  /** @override */
  getSpan(e, T) {
    if (0 <= this.span)
      return this.span;
    T === void 0 && (T = 0);
    let $ = 0;
    try {
      $ = this.fields.reduce((V, J) => {
        const ee = J.getSpan(e, T);
        return T += ee, V + ee;
      }, 0);
    } catch {
      throw new RangeError("indeterminate span");
    }
    return $;
  }
  /** @override */
  decode(e, T) {
    T === void 0 && (T = 0);
    const $ = this.makeDestinationObject();
    for (const V of this.fields)
      if (V.property !== void 0 && ($[V.property] = V.decode(e, T)), T += V.getSpan(e, T), this.decodePrefixes && e.length === T)
        break;
    return $;
  }
  /** Implement {@link Layout#encode|encode} for {@link Structure}.
   *
   * If `src` is missing a property for a member with a defined {@link
   * Layout#property|property} the corresponding region of the buffer is
   * left unmodified. */
  encode(e, T, $) {
    $ === void 0 && ($ = 0);
    const V = $;
    let J = 0, ee = 0;
    for (const te of this.fields) {
      let re = te.span;
      if (ee = 0 < re ? re : 0, te.property !== void 0) {
        const ie = e[te.property];
        ie !== void 0 && (ee = te.encode(ie, T, $), 0 > re && (re = te.getSpan(T, $)));
      }
      J = $, $ += re;
    }
    return J + ee - V;
  }
  /** @override */
  fromArray(e) {
    const T = this.makeDestinationObject();
    for (const $ of this.fields)
      $.property !== void 0 && 0 < e.length && (T[$.property] = e.shift());
    return T;
  }
  /**
   * Get access to the layout of a given property.
   *
   * @param {String} property - the structure member of interest.
   *
   * @return {Layout} - the layout associated with `property`, or
   * undefined if there is no such property.
   */
  layoutFor(e) {
    if (typeof e != "string")
      throw new TypeError("property must be string");
    for (const T of this.fields)
      if (T.property === e)
        return T;
  }
  /**
   * Get the offset of a structure member.
   *
   * @param {String} property - the structure member of interest.
   *
   * @return {Number} - the offset in bytes to the start of `property`
   * within the structure, or undefined if `property` is not a field
   * within the structure.  If the property is a member but follows a
   * variable-length structure member a negative number will be
   * returned.
   */
  offsetOf(e) {
    if (typeof e != "string")
      throw new TypeError("property must be string");
    let T = 0;
    for (const $ of this.fields) {
      if ($.property === e)
        return T;
      0 > $.span ? T = -1 : 0 <= T && (T += $.span);
    }
  }
}
class UnionDiscriminator {
  constructor(e) {
    this.property = e;
  }
  /** Analog to {@link Layout#decode|Layout decode} for union discriminators.
   *
   * The implementation of this method need not reference the buffer if
   * variant information is available through other means. */
  decode() {
    throw new Error("UnionDiscriminator is abstract");
  }
  /** Analog to {@link Layout#decode|Layout encode} for union discriminators.
   *
   * The implementation of this method need not store the value if
   * variant information is maintained through other means. */
  encode() {
    throw new Error("UnionDiscriminator is abstract");
  }
}
class UnionLayoutDiscriminator extends UnionDiscriminator {
  constructor(e, T) {
    if (!(e instanceof ExternalLayout && e.isCount()))
      throw new TypeError("layout must be an unsigned integer ExternalLayout");
    super(T || e.property || "variant"), this.layout = e;
  }
  /** Delegate decoding to {@link UnionLayoutDiscriminator#layout|layout}. */
  decode(e, T) {
    return this.layout.decode(e, T);
  }
  /** Delegate encoding to {@link UnionLayoutDiscriminator#layout|layout}. */
  encode(e, T, $) {
    return this.layout.encode(e, T, $);
  }
}
class Union extends Layout {
  constructor(e, T, $) {
    const V = e instanceof UInt || e instanceof UIntBE;
    if (V)
      e = new UnionLayoutDiscriminator(new OffsetLayout(e));
    else if (e instanceof ExternalLayout && e.isCount())
      e = new UnionLayoutDiscriminator(e);
    else if (!(e instanceof UnionDiscriminator))
      throw new TypeError("discr must be a UnionDiscriminator or an unsigned integer layout");
    if (T === void 0 && (T = null), !(T === null || T instanceof Layout))
      throw new TypeError("defaultLayout must be null or a Layout");
    if (T !== null) {
      if (0 > T.span)
        throw new Error("defaultLayout must have constant span");
      T.property === void 0 && (T = T.replicate("content"));
    }
    let J = -1;
    T && (J = T.span, 0 <= J && V && (J += e.layout.span)), super(J, $), this.discriminator = e, this.usesPrefixDiscriminator = V, this.defaultLayout = T, this.registry = {};
    let ee = this.defaultGetSourceVariant.bind(this);
    this.getSourceVariant = function(te) {
      return ee(te);
    }, this.configGetSourceVariant = function(te) {
      ee = te.bind(this);
    };
  }
  /** @override */
  getSpan(e, T) {
    if (0 <= this.span)
      return this.span;
    T === void 0 && (T = 0);
    const $ = this.getVariant(e, T);
    if (!$)
      throw new Error("unable to determine span for unrecognized variant");
    return $.getSpan(e, T);
  }
  /**
   * Method to infer a registered Union variant compatible with `src`.
   *
   * The first satisified rule in the following sequence defines the
   * return value:
   * * If `src` has properties matching the Union discriminator and
   *   the default layout, `undefined` is returned regardless of the
   *   value of the discriminator property (this ensures the default
   *   layout will be used);
   * * If `src` has a property matching the Union discriminator, the
   *   value of the discriminator identifies a registered variant, and
   *   either (a) the variant has no layout, or (b) `src` has the
   *   variant's property, then the variant is returned (because the
   *   source satisfies the constraints of the variant it identifies);
   * * If `src` does not have a property matching the Union
   *   discriminator, but does have a property matching a registered
   *   variant, then the variant is returned (because the source
   *   matches a variant without an explicit conflict);
   * * An error is thrown (because we either can't identify a variant,
   *   or we were explicitly told the variant but can't satisfy it).
   *
   * @param {Object} src - an object presumed to be compatible with
   * the content of the Union.
   *
   * @return {(undefined|VariantLayout)} - as described above.
   *
   * @throws {Error} - if `src` cannot be associated with a default or
   * registered variant.
   */
  defaultGetSourceVariant(e) {
    if (e.hasOwnProperty(this.discriminator.property)) {
      if (this.defaultLayout && e.hasOwnProperty(this.defaultLayout.property))
        return;
      const T = this.registry[e[this.discriminator.property]];
      if (T && (!T.layout || e.hasOwnProperty(T.property)))
        return T;
    } else
      for (const T in this.registry) {
        const $ = this.registry[T];
        if (e.hasOwnProperty($.property))
          return $;
      }
    throw new Error("unable to infer src variant");
  }
  /** Implement {@link Layout#decode|decode} for {@link Union}.
   *
   * If the variant is {@link Union#addVariant|registered} the return
   * value is an instance of that variant, with no explicit
   * discriminator.  Otherwise the {@link Union#defaultLayout|default
   * layout} is used to decode the content. */
  decode(e, T) {
    T === void 0 && (T = 0);
    let $;
    const V = this.discriminator, J = V.decode(e, T);
    let ee = this.registry[J];
    if (ee === void 0) {
      let te = 0;
      ee = this.defaultLayout, this.usesPrefixDiscriminator && (te = V.layout.span), $ = this.makeDestinationObject(), $[V.property] = J, $[ee.property] = this.defaultLayout.decode(e, T + te);
    } else
      $ = ee.decode(e, T);
    return $;
  }
  /** Implement {@link Layout#encode|encode} for {@link Union}.
   *
   * This API assumes the `src` object is consistent with the union's
   * {@link Union#defaultLayout|default layout}.  To encode variants
   * use the appropriate variant-specific {@link VariantLayout#encode}
   * method. */
  encode(e, T, $) {
    $ === void 0 && ($ = 0);
    const V = this.getSourceVariant(e);
    if (V === void 0) {
      const J = this.discriminator, ee = this.defaultLayout;
      let te = 0;
      return this.usesPrefixDiscriminator && (te = J.layout.span), J.encode(e[J.property], T, $), te + ee.encode(
        e[ee.property],
        T,
        $ + te
      );
    }
    return V.encode(e, T, $);
  }
  /** Register a new variant structure within a union.  The newly
   * created variant is returned.
   *
   * @param {Number} variant - initializer for {@link
   * VariantLayout#variant|variant}.
   *
   * @param {Layout} layout - initializer for {@link
   * VariantLayout#layout|layout}.
   *
   * @param {String} property - initializer for {@link
   * Layout#property|property}.
   *
   * @return {VariantLayout} */
  addVariant(e, T, $) {
    const V = new VariantLayout(this, e, T, $);
    return this.registry[e] = V, V;
  }
  /**
   * Get the layout associated with a registered variant.
   *
   * If `vb` does not produce a registered variant the function returns
   * `undefined`.
   *
   * @param {(Number|Buffer)} vb - either the variant number, or a
   * buffer from which the discriminator is to be read.
   *
   * @param {Number} offset - offset into `vb` for the start of the
   * union.  Used only when `vb` is an instance of {Buffer}.
   *
   * @return {({VariantLayout}|undefined)}
   */
  getVariant(e, T) {
    let $ = e;
    return dist$2.Buffer.isBuffer(e) && (T === void 0 && (T = 0), $ = this.discriminator.decode(e, T)), this.registry[$];
  }
}
class VariantLayout extends Layout {
  constructor(e, T, $, V) {
    if (!(e instanceof Union))
      throw new TypeError("union must be a Union");
    if (!Number.isInteger(T) || 0 > T)
      throw new TypeError("variant must be a (non-negative) integer");
    if (typeof $ == "string" && V === void 0 && (V = $, $ = null), $) {
      if (!($ instanceof Layout))
        throw new TypeError("layout must be a Layout");
      if (e.defaultLayout !== null && 0 <= $.span && $.span > e.defaultLayout.span)
        throw new Error("variant span exceeds span of containing union");
      if (typeof V != "string")
        throw new TypeError("variant must have a String property");
    }
    let J = e.span;
    0 > e.span && (J = $ ? $.span : 0, 0 <= J && e.usesPrefixDiscriminator && (J += e.discriminator.layout.span)), super(J, V), this.union = e, this.variant = T, this.layout = $ || null;
  }
  /** @override */
  getSpan(e, T) {
    if (0 <= this.span)
      return this.span;
    T === void 0 && (T = 0);
    let $ = 0;
    return this.union.usesPrefixDiscriminator && ($ = this.union.discriminator.layout.span), $ + this.layout.getSpan(e, T + $);
  }
  /** @override */
  decode(e, T) {
    const $ = this.makeDestinationObject();
    if (T === void 0 && (T = 0), this !== this.union.getVariant(e, T))
      throw new Error("variant mismatch");
    let V = 0;
    return this.union.usesPrefixDiscriminator && (V = this.union.discriminator.layout.span), this.layout ? $[this.property] = this.layout.decode(e, T + V) : this.property ? $[this.property] = !0 : this.union.usesPrefixDiscriminator && ($[this.union.discriminator.property] = this.variant), $;
  }
  /** @override */
  encode(e, T, $) {
    $ === void 0 && ($ = 0);
    let V = 0;
    if (this.union.usesPrefixDiscriminator && (V = this.union.discriminator.layout.span), this.layout && !e.hasOwnProperty(this.property))
      throw new TypeError("variant lacks property " + this.property);
    this.union.discriminator.encode(this.variant, T, $);
    let J = V;
    if (this.layout && (this.layout.encode(e[this.property], T, $ + V), J += this.layout.getSpan(T, $ + V), 0 <= this.union.span && J > this.union.span))
      throw new Error("encoded variant overruns containing union");
    return J;
  }
  /** Delegate {@link Layout#fromArray|fromArray} to {@link
   * VariantLayout#layout|layout}. */
  fromArray(e) {
    if (this.layout)
      return this.layout.fromArray(e);
  }
}
class Blob$1 extends Layout {
  constructor(e, T) {
    if (!(e instanceof ExternalLayout && e.isCount() || Number.isInteger(e) && 0 <= e))
      throw new TypeError("length must be positive integer or an unsigned integer ExternalLayout");
    let $ = -1;
    e instanceof ExternalLayout || ($ = e), super($, T), this.length = e;
  }
  /** @override */
  getSpan(e, T) {
    let $ = this.span;
    return 0 > $ && ($ = this.length.decode(e, T)), $;
  }
  /** @override */
  decode(e, T) {
    T === void 0 && (T = 0);
    let $ = this.span;
    return 0 > $ && ($ = this.length.decode(e, T)), e.slice(T, T + $);
  }
  /** Implement {@link Layout#encode|encode} for {@link Blob}.
   *
   * **NOTE** If {@link Layout#count|count} is an instance of {@link
   * ExternalLayout} then the length of `src` will be encoded as the
   * count after `src` is encoded. */
  encode(e, T, $) {
    let V = this.length;
    if (this.length instanceof ExternalLayout && (V = e.length), !(dist$2.Buffer.isBuffer(e) && V === e.length))
      throw new TypeError(nameWithProperty("Blob.encode", this) + " requires (length " + V + ") Buffer as src");
    if ($ + V > T.length)
      throw new RangeError("encoding overruns Buffer");
    return T.write(e.toString("hex"), $, V, "hex"), this.length instanceof ExternalLayout && this.length.encode(V, T, $), V;
  }
}
var offset$2 = (C, e, T) => new OffsetLayout(C, e, T), u8 = (C) => new UInt(1, C), u32 = (C) => new UInt(4, C), nu64 = (C) => new NearUInt64(C), ns64 = (C) => new NearInt64(C), struct = (C, e, T) => new Structure(C, e, T), union = (C, e, T) => new Union(C, e, T), blob = (C, e) => new Blob$1(C, e);
class RustStringLayout extends Layout_2 {
  constructor(e) {
    super(-1, e), this.property = e, this.layout = struct([
      u32("length"),
      u32("lengthPadding"),
      blob(offset$2(u32(), -8), "chars")
    ], this.property);
  }
  encode(e, T, $ = 0) {
    if (e == null)
      return this.layout.span;
    const V = {
      chars: dist$2.Buffer.from(e, "utf8")
    };
    return this.layout.encode(V, T, $);
  }
  decode(e, T = 0) {
    return this.layout.decode(e, T).chars.toString();
  }
  getSpan(e, T = 0) {
    return u32().span + u32().span + new BN(new Uint8Array(e).slice(T, T + 4), 10, "le").toNumber();
  }
}
function rustStringLayout(C) {
  return new RustStringLayout(C);
}
function publicKey$2(C) {
  return blob(32, C);
}
const LAYOUT = union(u32("instruction"));
LAYOUT.addVariant(0, struct([
  ns64("lamports"),
  ns64("space"),
  publicKey$2("owner")
]), "createAccount");
LAYOUT.addVariant(1, struct([publicKey$2("owner")]), "assign");
LAYOUT.addVariant(2, struct([ns64("lamports")]), "transfer");
LAYOUT.addVariant(3, struct([
  publicKey$2("base"),
  rustStringLayout("seed"),
  ns64("lamports"),
  ns64("space"),
  publicKey$2("owner")
]), "createAccountWithSeed");
LAYOUT.addVariant(4, struct([publicKey$2("authorized")]), "advanceNonceAccount");
LAYOUT.addVariant(5, struct([ns64("lamports")]), "withdrawNonceAccount");
LAYOUT.addVariant(6, struct([publicKey$2("authorized")]), "initializeNonceAccount");
LAYOUT.addVariant(7, struct([publicKey$2("authorized")]), "authorizeNonceAccount");
LAYOUT.addVariant(8, struct([ns64("space")]), "allocate");
LAYOUT.addVariant(9, struct([
  publicKey$2("base"),
  rustStringLayout("seed"),
  ns64("space"),
  publicKey$2("owner")
]), "allocateWithSeed");
LAYOUT.addVariant(10, struct([
  publicKey$2("base"),
  rustStringLayout("seed"),
  publicKey$2("owner")
]), "assignWithSeed");
LAYOUT.addVariant(11, struct([
  ns64("lamports"),
  rustStringLayout("seed"),
  publicKey$2("owner")
]), "transferWithSeed");
Math.max(...Object.values(LAYOUT.registry).map((C) => C.span));
class WrappedLayout$1 extends Layout_2 {
  constructor(e, T, $, V) {
    super(e.span, V), this.layout = e, this.decoder = T, this.encoder = $;
  }
  decode(e, T) {
    return this.decoder(this.layout.decode(e, T));
  }
  encode(e, T, $) {
    return this.layout.encode(this.encoder(e), T, $);
  }
  getSpan(e, T) {
    return this.layout.getSpan(e, T);
  }
}
function publicKey$1(C) {
  return new WrappedLayout$1(blob(32), (e) => new PublicKey(e), (e) => e.toBuffer(), C);
}
struct([
  u32("version"),
  u32("state"),
  publicKey$1("authorizedPubkey"),
  publicKey$1("nonce"),
  struct([nu64("lamportsPerSignature")], "feeCalculator")
]);
function hash$2(C) {
  return new TextDecoder().decode(sha256$5(C));
}
var sha256$1 = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  hash: hash$2
});
function createWithSeedSync(C, e, T) {
  const $ = bufferPolyfill.Buffer.concat([
    C.toBuffer(),
    bufferPolyfill.Buffer.from(e),
    T.toBuffer()
  ]);
  return new PublicKey(sha256$5($));
}
function associated(C, ...e) {
  let T = [bufferPolyfill.Buffer.from([97, 110, 99, 104, 111, 114])];
  e.forEach((V) => {
    T.push(V instanceof bufferPolyfill.Buffer ? V : translateAddress(V).toBuffer());
  });
  const [$] = PublicKey.findProgramAddressSync(T, translateAddress(C));
  return $;
}
var pubkey = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  createWithSeedSync,
  associated
});
const TOKEN_PROGRAM_ID$1 = new PublicKey("TokenkegQfeZyiNwAJbNbGKPFXCWuBvf9Ss623VQ5DA"), ASSOCIATED_PROGRAM_ID = new PublicKey("ATokenGPvbdGVxr1b2hvZbsiqW5xWH25efTNsLJA8knL");
function associatedAddress({ mint: C, owner: e }) {
  return PublicKey.findProgramAddressSync([e.toBuffer(), TOKEN_PROGRAM_ID$1.toBuffer(), C.toBuffer()], ASSOCIATED_PROGRAM_ID)[0];
}
var token = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  TOKEN_PROGRAM_ID: TOKEN_PROGRAM_ID$1,
  ASSOCIATED_PROGRAM_ID,
  associatedAddress
}), browserPonyfill$1 = { exports: {} };
(function(C, e) {
  var T = typeof self < "u" ? self : commonjsGlobal, $ = function() {
    function J() {
      this.fetch = !1, this.DOMException = T.DOMException;
    }
    return J.prototype = T, new J();
  }();
  (function(J) {
    (function(ee) {
      var te = {
        searchParams: "URLSearchParams" in J,
        iterable: "Symbol" in J && "iterator" in Symbol,
        blob: "FileReader" in J && "Blob" in J && function() {
          try {
            return new Blob(), !0;
          } catch {
            return !1;
          }
        }(),
        formData: "FormData" in J,
        arrayBuffer: "ArrayBuffer" in J
      };
      function re(ce) {
        return ce && DataView.prototype.isPrototypeOf(ce);
      }
      if (te.arrayBuffer)
        var ie = [
          "[object Int8Array]",
          "[object Uint8Array]",
          "[object Uint8ClampedArray]",
          "[object Int16Array]",
          "[object Uint16Array]",
          "[object Int32Array]",
          "[object Uint32Array]",
          "[object Float32Array]",
          "[object Float64Array]"
        ], se = ArrayBuffer.isView || function(ce) {
          return ce && ie.indexOf(Object.prototype.toString.call(ce)) > -1;
        };
      function de(ce) {
        if (typeof ce != "string" && (ce = String(ce)), /[^a-z0-9\-#$%&'*+.^_`|~]/i.test(ce))
          throw new TypeError("Invalid character in header field name");
        return ce.toLowerCase();
      }
      function ue(ce) {
        return typeof ce != "string" && (ce = String(ce)), ce;
      }
      function fe(ce) {
        var le = {
          next: function() {
            var pe = ce.shift();
            return { done: pe === void 0, value: pe };
          }
        };
        return te.iterable && (le[Symbol.iterator] = function() {
          return le;
        }), le;
      }
      function he(ce) {
        this.map = {}, ce instanceof he ? ce.forEach(function(le, pe) {
          this.append(pe, le);
        }, this) : Array.isArray(ce) ? ce.forEach(function(le) {
          this.append(le[0], le[1]);
        }, this) : ce && Object.getOwnPropertyNames(ce).forEach(function(le) {
          this.append(le, ce[le]);
        }, this);
      }
      he.prototype.append = function(ce, le) {
        ce = de(ce), le = ue(le);
        var pe = this.map[ce];
        this.map[ce] = pe ? pe + ", " + le : le;
      }, he.prototype.delete = function(ce) {
        delete this.map[de(ce)];
      }, he.prototype.get = function(ce) {
        return ce = de(ce), this.has(ce) ? this.map[ce] : null;
      }, he.prototype.has = function(ce) {
        return this.map.hasOwnProperty(de(ce));
      }, he.prototype.set = function(ce, le) {
        this.map[de(ce)] = ue(le);
      }, he.prototype.forEach = function(ce, le) {
        for (var pe in this.map)
          this.map.hasOwnProperty(pe) && ce.call(le, this.map[pe], pe, this);
      }, he.prototype.keys = function() {
        var ce = [];
        return this.forEach(function(le, pe) {
          ce.push(pe);
        }), fe(ce);
      }, he.prototype.values = function() {
        var ce = [];
        return this.forEach(function(le) {
          ce.push(le);
        }), fe(ce);
      }, he.prototype.entries = function() {
        var ce = [];
        return this.forEach(function(le, pe) {
          ce.push([pe, le]);
        }), fe(ce);
      }, te.iterable && (he.prototype[Symbol.iterator] = he.prototype.entries);
      function me(ce) {
        if (ce.bodyUsed)
          return Promise.reject(new TypeError("Already read"));
        ce.bodyUsed = !0;
      }
      function xe(ce) {
        return new Promise(function(le, pe) {
          ce.onload = function() {
            le(ce.result);
          }, ce.onerror = function() {
            pe(ce.error);
          };
        });
      }
      function ve(ce) {
        var le = new FileReader(), pe = xe(le);
        return le.readAsArrayBuffer(ce), pe;
      }
      function Te(ce) {
        var le = new FileReader(), pe = xe(le);
        return le.readAsText(ce), pe;
      }
      function we(ce) {
        for (var le = new Uint8Array(ce), pe = new Array(le.length), ye = 0; ye < le.length; ye++)
          pe[ye] = String.fromCharCode(le[ye]);
        return pe.join("");
      }
      function Ee(ce) {
        if (ce.slice)
          return ce.slice(0);
        var le = new Uint8Array(ce.byteLength);
        return le.set(new Uint8Array(ce)), le.buffer;
      }
      function Me() {
        return this.bodyUsed = !1, this._initBody = function(ce) {
          this._bodyInit = ce, ce ? typeof ce == "string" ? this._bodyText = ce : te.blob && Blob.prototype.isPrototypeOf(ce) ? this._bodyBlob = ce : te.formData && FormData.prototype.isPrototypeOf(ce) ? this._bodyFormData = ce : te.searchParams && URLSearchParams.prototype.isPrototypeOf(ce) ? this._bodyText = ce.toString() : te.arrayBuffer && te.blob && re(ce) ? (this._bodyArrayBuffer = Ee(ce.buffer), this._bodyInit = new Blob([this._bodyArrayBuffer])) : te.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(ce) || se(ce)) ? this._bodyArrayBuffer = Ee(ce) : this._bodyText = ce = Object.prototype.toString.call(ce) : this._bodyText = "", this.headers.get("content-type") || (typeof ce == "string" ? this.headers.set("content-type", "text/plain;charset=UTF-8") : this._bodyBlob && this._bodyBlob.type ? this.headers.set("content-type", this._bodyBlob.type) : te.searchParams && URLSearchParams.prototype.isPrototypeOf(ce) && this.headers.set("content-type", "application/x-www-form-urlencoded;charset=UTF-8"));
        }, te.blob && (this.blob = function() {
          var ce = me(this);
          if (ce)
            return ce;
          if (this._bodyBlob)
            return Promise.resolve(this._bodyBlob);
          if (this._bodyArrayBuffer)
            return Promise.resolve(new Blob([this._bodyArrayBuffer]));
          if (this._bodyFormData)
            throw new Error("could not read FormData body as blob");
          return Promise.resolve(new Blob([this._bodyText]));
        }, this.arrayBuffer = function() {
          return this._bodyArrayBuffer ? me(this) || Promise.resolve(this._bodyArrayBuffer) : this.blob().then(ve);
        }), this.text = function() {
          var ce = me(this);
          if (ce)
            return ce;
          if (this._bodyBlob)
            return Te(this._bodyBlob);
          if (this._bodyArrayBuffer)
            return Promise.resolve(we(this._bodyArrayBuffer));
          if (this._bodyFormData)
            throw new Error("could not read FormData body as text");
          return Promise.resolve(this._bodyText);
        }, te.formData && (this.formData = function() {
          return this.text().then(De);
        }), this.json = function() {
          return this.text().then(JSON.parse);
        }, this;
      }
      var Ie = ["DELETE", "GET", "HEAD", "OPTIONS", "POST", "PUT"];
      function ke(ce) {
        var le = ce.toUpperCase();
        return Ie.indexOf(le) > -1 ? le : ce;
      }
      function _e(ce, le) {
        le = le || {};
        var pe = le.body;
        if (ce instanceof _e) {
          if (ce.bodyUsed)
            throw new TypeError("Already read");
          this.url = ce.url, this.credentials = ce.credentials, le.headers || (this.headers = new he(ce.headers)), this.method = ce.method, this.mode = ce.mode, this.signal = ce.signal, !pe && ce._bodyInit != null && (pe = ce._bodyInit, ce.bodyUsed = !0);
        } else
          this.url = String(ce);
        if (this.credentials = le.credentials || this.credentials || "same-origin", (le.headers || !this.headers) && (this.headers = new he(le.headers)), this.method = ke(le.method || this.method || "GET"), this.mode = le.mode || this.mode || null, this.signal = le.signal || this.signal, this.referrer = null, (this.method === "GET" || this.method === "HEAD") && pe)
          throw new TypeError("Body not allowed for GET or HEAD requests");
        this._initBody(pe);
      }
      _e.prototype.clone = function() {
        return new _e(this, { body: this._bodyInit });
      };
      function De(ce) {
        var le = new FormData();
        return ce.trim().split("&").forEach(function(pe) {
          if (pe) {
            var ye = pe.split("="), Ce = ye.shift().replace(/\+/g, " "), be = ye.join("=").replace(/\+/g, " ");
            le.append(decodeURIComponent(Ce), decodeURIComponent(be));
          }
        }), le;
      }
      function Fe(ce) {
        var le = new he(), pe = ce.replace(/\r?\n[\t ]+/g, " ");
        return pe.split(/\r?\n/).forEach(function(ye) {
          var Ce = ye.split(":"), be = Ce.shift().trim();
          if (be) {
            var ae = Ce.join(":").trim();
            le.append(be, ae);
          }
        }), le;
      }
      Me.call(_e.prototype);
      function Ae(ce, le) {
        le || (le = {}), this.type = "default", this.status = le.status === void 0 ? 200 : le.status, this.ok = this.status >= 200 && this.status < 300, this.statusText = "statusText" in le ? le.statusText : "OK", this.headers = new he(le.headers), this.url = le.url || "", this._initBody(ce);
      }
      Me.call(Ae.prototype), Ae.prototype.clone = function() {
        return new Ae(this._bodyInit, {
          status: this.status,
          statusText: this.statusText,
          headers: new he(this.headers),
          url: this.url
        });
      }, Ae.error = function() {
        var ce = new Ae(null, { status: 0, statusText: "" });
        return ce.type = "error", ce;
      };
      var ne = [301, 302, 303, 307, 308];
      Ae.redirect = function(ce, le) {
        if (ne.indexOf(le) === -1)
          throw new RangeError("Invalid status code");
        return new Ae(null, { status: le, headers: { location: ce } });
      }, ee.DOMException = J.DOMException;
      try {
        new ee.DOMException();
      } catch {
        ee.DOMException = function(le, pe) {
          this.message = le, this.name = pe;
          var ye = Error(le);
          this.stack = ye.stack;
        }, ee.DOMException.prototype = Object.create(Error.prototype), ee.DOMException.prototype.constructor = ee.DOMException;
      }
      function oe(ce, le) {
        return new Promise(function(pe, ye) {
          var Ce = new _e(ce, le);
          if (Ce.signal && Ce.signal.aborted)
            return ye(new ee.DOMException("Aborted", "AbortError"));
          var be = new XMLHttpRequest();
          function ae() {
            be.abort();
          }
          be.onload = function() {
            var ge = {
              status: be.status,
              statusText: be.statusText,
              headers: Fe(be.getAllResponseHeaders() || "")
            };
            ge.url = "responseURL" in be ? be.responseURL : ge.headers.get("X-Request-URL");
            var Se = "response" in be ? be.response : be.responseText;
            pe(new Ae(Se, ge));
          }, be.onerror = function() {
            ye(new TypeError("Network request failed"));
          }, be.ontimeout = function() {
            ye(new TypeError("Network request failed"));
          }, be.onabort = function() {
            ye(new ee.DOMException("Aborted", "AbortError"));
          }, be.open(Ce.method, Ce.url, !0), Ce.credentials === "include" ? be.withCredentials = !0 : Ce.credentials === "omit" && (be.withCredentials = !1), "responseType" in be && te.blob && (be.responseType = "blob"), Ce.headers.forEach(function(ge, Se) {
            be.setRequestHeader(Se, ge);
          }), Ce.signal && (Ce.signal.addEventListener("abort", ae), be.onreadystatechange = function() {
            be.readyState === 4 && Ce.signal.removeEventListener("abort", ae);
          }), be.send(typeof Ce._bodyInit > "u" ? null : Ce._bodyInit);
        });
      }
      return oe.polyfill = !0, J.fetch || (J.fetch = oe, J.Headers = he, J.Request = _e, J.Response = Ae), ee.Headers = he, ee.Request = _e, ee.Response = Ae, ee.fetch = oe, Object.defineProperty(ee, "__esModule", { value: !0 }), ee;
    })({});
  })($), $.fetch.ponyfill = !0, delete $.fetch.polyfill;
  var V = $;
  e = V.fetch, e.default = V.fetch, e.fetch = V.fetch, e.Headers = V.Headers, e.Request = V.Request, e.Response = V.Response, C.exports = e;
})(browserPonyfill$1, browserPonyfill$1.exports);
var fetch$1 = /* @__PURE__ */ getDefaultExportFromCjs(browserPonyfill$1.exports);
async function verifiedBuild(C, e, T = 5) {
  const $ = `https://api.apr.dev/api/v0/program/${e.toString()}/latest?limit=${T}`, [V, J] = await Promise.all([
    fetchData(C, e),
    fetch$1($)
  ]), ee = (await J.json()).filter((re) => !re.aborted && re.state === "Built" && re.verified === "Verified");
  if (ee.length === 0)
    return null;
  const te = ee[0];
  return V.slot.toNumber() !== te.verified_slot ? null : te;
}
async function fetchData(C, e) {
  const T = await C.getAccountInfo(e);
  if (T === null)
    throw new Error("program account not found");
  const { program: $ } = decodeUpgradeableLoaderState(T.data), V = await C.getAccountInfo($.programdataAddress);
  if (V === null)
    throw new Error("program data account not found");
  const { programData: J } = decodeUpgradeableLoaderState(V.data);
  return J;
}
const UPGRADEABLE_LOADER_STATE_LAYOUT = dist$1.rustEnum([
  dist$1.struct([], "uninitialized"),
  dist$1.struct([dist$1.option(dist$1.publicKey(), "authorityAddress")], "buffer"),
  dist$1.struct([dist$1.publicKey("programdataAddress")], "program"),
  dist$1.struct([
    dist$1.u64("slot"),
    dist$1.option(dist$1.publicKey(), "upgradeAuthorityAddress")
  ], "programData")
], void 0, dist$1.u32());
function decodeUpgradeableLoaderState(C) {
  return UPGRADEABLE_LOADER_STATE_LAYOUT.decode(C);
}
var registry = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  verifiedBuild,
  fetchData,
  decodeUpgradeableLoaderState
}), index$2 = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  sha256: sha256$1,
  rpc,
  publicKey: pubkey,
  bytes: index$1$1,
  token,
  features,
  registry
});
function isIdlAccounts(C) {
  return "accounts" in C;
}
async function idlAddress(C) {
  const e = (await PublicKey.findProgramAddress([], C))[0];
  return await PublicKey.createWithSeed(e, seed(), C);
}
function seed() {
  return "anchor:idl";
}
const IDL_ACCOUNT_LAYOUT = dist$1.struct([
  dist$1.publicKey("authority"),
  dist$1.vecU8("data")
]);
function decodeIdlAccount(C) {
  return IDL_ACCOUNT_LAYOUT.decode(C);
}
function splitArgsAndCtx(C, e) {
  var T, $;
  let V = {};
  const J = C.args ? C.args.length : 0;
  if (e.length > J) {
    if (e.length !== J + 1)
      throw new Error(`provided too many arguments ${e} to instruction ${C == null ? void 0 : C.name} expecting: ${($ = (T = C.args) === null || T === void 0 ? void 0 : T.map((ee) => ee.name)) !== null && $ !== void 0 ? $ : []}`);
    V = e.pop();
  }
  return [e, V];
}
class InstructionNamespaceFactory {
  static build(e, T, $) {
    if (e.name === "_inner")
      throw new IdlError("the _inner name is reserved");
    const V = (...J) => {
      const [ee, te] = splitArgsAndCtx(e, [...J]);
      validateAccounts(e.accounts, te.accounts), validateInstruction(e, ...J);
      const re = V.accounts(te.accounts);
      return te.remainingAccounts !== void 0 && re.push(...te.remainingAccounts), isSet("debug-logs") && console.log("Outgoing account metas:", re), new TransactionInstruction({
        keys: re,
        programId: $,
        data: T(e.name, toInstruction(e, ...ee))
      });
    };
    return V.accounts = (J) => InstructionNamespaceFactory.accountsArray(J, e.accounts, $, e.name), V;
  }
  static accountsArray(e, T, $, V) {
    return e ? T.map((J) => {
      if (("accounts" in J ? J.accounts : void 0) !== void 0) {
        const te = e[J.name];
        return InstructionNamespaceFactory.accountsArray(te, J.accounts, $, V).flat();
      } else {
        const te = J;
        let re;
        try {
          re = translateAddress(e[J.name]);
        } catch {
          throw new Error(`Wrong input type for account "${J.name}" in the instruction accounts object${V !== void 0 ? ' for instruction "' + V + '"' : ""}. Expected PublicKey or string.`);
        }
        const ie = te.isOptional && re.equals($), se = te.isMut && !ie, de = te.isSigner && !ie;
        return {
          pubkey: re,
          isWritable: se,
          isSigner: de
        };
      }
    }).flat() : [];
  }
}
function validateInstruction(C, ...e) {
}
class TransactionFactory {
  static build(e, T) {
    return (...V) => {
      var J, ee, te;
      const [, re] = splitArgsAndCtx(e, [...V]), ie = new Transaction();
      if (re.preInstructions && re.instructions)
        throw new Error("instructions is deprecated, use preInstructions");
      return (J = re.preInstructions) === null || J === void 0 || J.forEach((se) => ie.add(se)), (ee = re.instructions) === null || ee === void 0 || ee.forEach((se) => ie.add(se)), ie.add(T(...V)), (te = re.postInstructions) === null || te === void 0 || te.forEach((se) => ie.add(se)), ie;
    };
  }
}
class RpcFactory {
  static build(e, T, $, V) {
    return async (...ee) => {
      var te;
      const re = T(...ee), [, ie] = splitArgsAndCtx(e, [...ee]);
      if (V.sendAndConfirm === void 0)
        throw new Error("This function requires 'Provider.sendAndConfirm' to be implemented.");
      try {
        return await V.sendAndConfirm(re, (te = ie.signers) !== null && te !== void 0 ? te : [], ie.options);
      } catch (se) {
        throw translateError(se, $);
      }
    };
  }
}
class AccountFactory {
  static build(e, T, $, V) {
    var J;
    const ee = {};
    return (J = e.accounts) === null || J === void 0 || J.forEach((te) => {
      const re = camelCase$1(te.name);
      ee[re] = new AccountClient(e, te, $, V, T);
    }), ee;
  }
}
class AccountClient {
  /**
   * Returns the number of bytes in this account.
   */
  get size() {
    return this._size;
  }
  /**
   * Returns the program ID owning all accounts.
   */
  get programId() {
    return this._programId;
  }
  /**
   * Returns the client's wallet and network provider.
   */
  get provider() {
    return this._provider;
  }
  /**
   * Returns the coder.
   */
  get coder() {
    return this._coder;
  }
  /**
   * Returns the idl account.
   */
  get idlAccount() {
    return this._idlAccount;
  }
  constructor(e, T, $, V, J) {
    this._idlAccount = T, this._programId = $, this._provider = V ?? getProvider(), this._coder = J ?? new BorshCoder(e), this._size = this._coder.accounts.size(T);
  }
  /**
   * Returns a deserialized account, returning null if it doesn't exist.
   *
   * @param address The address of the account to fetch.
   */
  async fetchNullable(e, T) {
    const { data: $ } = await this.fetchNullableAndContext(e, T);
    return $;
  }
  /**
   * Returns a deserialized account along with the associated rpc response context, returning null if it doesn't exist.
   *
   * @param address The address of the account to fetch.
   */
  async fetchNullableAndContext(e, T) {
    const $ = await this.getAccountInfoAndContext(e, T), { value: V, context: J } = $;
    return {
      data: V && V.data.length !== 0 ? this._coder.accounts.decode(this._idlAccount.name, V.data) : null,
      context: J
    };
  }
  /**
   * Returns a deserialized account.
   *
   * @param address The address of the account to fetch.
   */
  async fetch(e, T) {
    const { data: $ } = await this.fetchNullableAndContext(e, T);
    if ($ === null)
      throw new Error(`Account does not exist or has no data ${e.toString()}`);
    return $;
  }
  /**
   * Returns a deserialized account along with the associated rpc response context.
   *
   * @param address The address of the account to fetch.
   */
  async fetchAndContext(e, T) {
    const { data: $, context: V } = await this.fetchNullableAndContext(e, T);
    if ($ === null)
      throw new Error(`Account does not exist ${e.toString()}`);
    return { data: $, context: V };
  }
  /**
   * Returns multiple deserialized accounts.
   * Accounts not found or with wrong discriminator are returned as null.
   *
   * @param addresses The addresses of the accounts to fetch.
   */
  async fetchMultiple(e, T) {
    return (await this.fetchMultipleAndContext(e, T)).map((V) => V ? V.data : null);
  }
  /**
   * Returns multiple deserialized accounts.
   * Accounts not found or with wrong discriminator are returned as null.
   *
   * @param addresses The addresses of the accounts to fetch.
   */
  async fetchMultipleAndContext(e, T) {
    return (await getMultipleAccountsAndContext(this._provider.connection, e.map((V) => translateAddress(V)), T)).map((V) => {
      if (V == null)
        return null;
      const { account: J, context: ee } = V;
      return {
        data: this._coder.accounts.decode(this._idlAccount.name, J.data),
        context: ee
      };
    });
  }
  /**
   * Returns all instances of this account type for the program.
   *
   * @param filters User-provided filters to narrow the results from `connection.getProgramAccounts`.
   *
   *                When filters are not defined this method returns all
   *                the account instances.
   *
   *                When filters are of type `Buffer`, the filters are appended
   *                after the discriminator.
   *
   *                When filters are of type `GetProgramAccountsFilter[]`,
   *                filters are appended after the discriminator filter.
   */
  async all(e) {
    const T = this.coder.accounts.memcmp(this._idlAccount.name, e instanceof dist$2.Buffer ? e : void 0), $ = [];
    return (T == null ? void 0 : T.offset) != null && (T == null ? void 0 : T.bytes) != null && $.push({
      memcmp: { offset: T.offset, bytes: T.bytes }
    }), (T == null ? void 0 : T.dataSize) != null && $.push({ dataSize: T.dataSize }), (await this._provider.connection.getProgramAccounts(this._programId, {
      commitment: this._provider.connection.commitment,
      filters: [...$, ...Array.isArray(e) ? e : []]
    })).map(({ pubkey: J, account: ee }) => ({
      publicKey: J,
      account: this._coder.accounts.decode(this._idlAccount.name, ee.data)
    }));
  }
  /**
   * Returns an `EventEmitter` emitting a "change" event whenever the account
   * changes.
   */
  subscribe(e, T) {
    const $ = subscriptions.get(e.toString());
    if ($)
      return $.ee;
    const V = new EventEmitter$1();
    e = translateAddress(e);
    const J = this._provider.connection.onAccountChange(e, (ee) => {
      const te = this._coder.accounts.decode(this._idlAccount.name, ee.data);
      V.emit("change", te);
    }, T);
    return subscriptions.set(e.toString(), {
      ee: V,
      listener: J
    }), V;
  }
  /**
   * Unsubscribes from the account at the given address.
   */
  async unsubscribe(e) {
    let T = subscriptions.get(e.toString());
    if (!T) {
      console.warn("Address is not subscribed");
      return;
    }
    subscriptions && await this._provider.connection.removeAccountChangeListener(T.listener).then(() => {
      subscriptions.delete(e.toString());
    }).catch(console.error);
  }
  /**
   * Returns an instruction for creating this account.
   */
  async createInstruction(e, T) {
    const $ = this.size;
    if (this._provider.publicKey === void 0)
      throw new Error("This function requires the Provider interface implementor to have a 'publicKey' field.");
    return SystemProgram.createAccount({
      fromPubkey: this._provider.publicKey,
      newAccountPubkey: e.publicKey,
      space: T ?? $,
      lamports: await this._provider.connection.getMinimumBalanceForRentExemption(T ?? $),
      programId: this._programId
    });
  }
  /**
   * @deprecated since version 14.0.
   *
   * Function returning the associated account. Args are keys to associate.
   * Order matters.
   */
  async associated(...e) {
    const T = await this.associatedAddress(...e);
    return await this.fetch(T);
  }
  /**
   * @deprecated since version 14.0.
   *
   * Function returning the associated address. Args are keys to associate.
   * Order matters.
   */
  async associatedAddress(...e) {
    return await associated(this._programId, ...e);
  }
  async getAccountInfo(e, T) {
    return await this._provider.connection.getAccountInfo(translateAddress(e), T);
  }
  async getAccountInfoAndContext(e, T) {
    return await this._provider.connection.getAccountInfoAndContext(translateAddress(e), T);
  }
}
const subscriptions = /* @__PURE__ */ new Map(), PROGRAM_LOG = "Program log: ", PROGRAM_DATA = "Program data: ", PROGRAM_LOG_START_INDEX = PROGRAM_LOG.length, PROGRAM_DATA_START_INDEX = PROGRAM_DATA.length;
class EventManager {
  constructor(e, T, $) {
    this._programId = e, this._provider = T, this._eventParser = new EventParser(e, $), this._eventCallbacks = /* @__PURE__ */ new Map(), this._eventListeners = /* @__PURE__ */ new Map(), this._listenerIdCount = 0;
  }
  addEventListener(e, T) {
    var $;
    let V = this._listenerIdCount;
    return this._listenerIdCount += 1, this._eventListeners.has(e) || this._eventListeners.set(e, []), this._eventListeners.set(e, (($ = this._eventListeners.get(e)) !== null && $ !== void 0 ? $ : []).concat(V)), this._eventCallbacks.set(V, [e, T]), this._onLogsSubscriptionId !== void 0 || (this._onLogsSubscriptionId = this._provider.connection.onLogs(this._programId, (J, ee) => {
      if (!J.err)
        for (const te of this._eventParser.parseLogs(J.logs)) {
          const re = this._eventListeners.get(te.name);
          re && re.forEach((ie) => {
            const se = this._eventCallbacks.get(ie);
            if (se) {
              const [, de] = se;
              de(te.data, ee.slot, J.signature);
            }
          });
        }
    })), V;
  }
  async removeEventListener(e) {
    const T = this._eventCallbacks.get(e);
    if (!T)
      throw new Error(`Event listener ${e} doesn't exist!`);
    const [$] = T;
    let V = this._eventListeners.get($);
    if (!V)
      throw new Error(`Event listeners don't exist for ${$}!`);
    if (this._eventCallbacks.delete(e), V = V.filter((J) => J !== e), this._eventListeners.set($, V), V.length === 0 && this._eventListeners.delete($), this._eventCallbacks.size === 0) {
      if (this._eventListeners.size !== 0)
        throw new Error(`Expected event listeners size to be 0 but got ${this._eventListeners.size}`);
      this._onLogsSubscriptionId !== void 0 && (await this._provider.connection.removeOnLogsListener(this._onLogsSubscriptionId), this._onLogsSubscriptionId = void 0);
    }
  }
}
class EventParser {
  constructor(e, T) {
    this.coder = T, this.programId = e;
  }
  // Each log given, represents an array of messages emitted by
  // a single transaction, which can execute many different programs across
  // CPI boundaries. However, the subscription is only interested in the
  // events emitted by *this* program. In achieving this, we keep track of the
  // program execution context by parsing each log and looking for a CPI
  // `invoke` call. If one exists, we know a new program is executing. So we
  // push the programId onto a stack and switch the program context. This
  // allows us to track, for a given log, which program was executing during
  // its emission, thereby allowing us to know if a given log event was
  // emitted by *this* program. If it was, then we parse the raw string and
  // emit the event if the string matches the event being subscribed to.
  *parseLogs(e, T = !1) {
    const $ = new LogScanner(e), V = new ExecutionContext();
    let J = $.next();
    for (; J !== null; ) {
      let [ee, te, re] = this.handleLog(V, J, T);
      ee && (yield ee), te && V.push(te), re && V.pop(), J = $.next();
    }
  }
  // Main log handler. Returns a three element array of the event, the
  // next program that was invoked for CPI, and a boolean indicating if
  // a program has completed execution (and thus should be popped off the
  // execution stack).
  handleLog(e, T, $) {
    return e.stack.length > 0 && e.program() === this.programId.toString() ? this.handleProgramLog(T, $) : [null, ...this.handleSystemLog(T)];
  }
  // Handles logs from *this* program.
  handleProgramLog(e, T) {
    if (e.startsWith(PROGRAM_LOG) || e.startsWith(PROGRAM_DATA)) {
      const $ = e.startsWith(PROGRAM_LOG) ? e.slice(PROGRAM_LOG_START_INDEX) : e.slice(PROGRAM_DATA_START_INDEX), V = this.coder.events.decode($);
      if (T && V === null)
        throw new Error(`Unable to decode event ${$}`);
      return [V, null, !1];
    } else
      return [null, ...this.handleSystemLog(e)];
  }
  // Handles logs when the current program being executing is *not* this.
  handleSystemLog(e) {
    const T = e.split(":")[0];
    return T.match(/^Program (.*) success/g) !== null ? [null, !0] : T.startsWith(`Program ${this.programId.toString()} invoke`) ? [this.programId.toString(), !1] : T.includes("invoke") ? ["cpi", !1] : [null, !1];
  }
}
class ExecutionContext {
  constructor() {
    this.stack = [];
  }
  program() {
    if (!this.stack.length)
      throw new Error("Expected the stack to have elements");
    return this.stack[this.stack.length - 1];
  }
  push(e) {
    this.stack.push(e);
  }
  pop() {
    if (!this.stack.length)
      throw new Error("Expected the stack to have elements");
    this.stack.pop();
  }
}
class LogScanner {
  constructor(e) {
    this.logs = e;
  }
  next() {
    if (this.logs.length === 0)
      return null;
    let e = this.logs[0];
    return this.logs = this.logs.slice(1), e;
  }
}
class SimulateFactory {
  static build(e, T, $, V, J, ee, te) {
    return async (...ie) => {
      var se;
      const de = T(...ie), [, ue] = splitArgsAndCtx(e, [...ie]);
      let fe;
      if (V.simulate === void 0)
        throw new Error("This function requires 'Provider.simulate' to be implemented.");
      try {
        fe = await V.simulate(de, ue.signers, (se = ue.options) === null || se === void 0 ? void 0 : se.commitment);
      } catch (xe) {
        throw translateError(xe, $);
      }
      if (fe === void 0)
        throw new Error("Unable to simulate transaction");
      const he = fe.logs;
      if (!he)
        throw new Error("Simulated logs not found");
      const me = [];
      if (te.events) {
        let xe = new EventParser(ee, J);
        for (const ve of xe.parseLogs(he))
          me.push(ve);
      }
      return { events: me, raw: he };
    };
  }
}
function uint64(C) {
  return new WrappedLayout(blob(8), (e) => u64.fromBuffer(e), (e) => e.toBuffer(), C);
}
function publicKey(C) {
  return new WrappedLayout(blob(32), (e) => new PublicKey(e), (e) => e.toBuffer(), C);
}
function coption(C, e) {
  return new COptionLayout(C, e);
}
class WrappedLayout extends Layout_2 {
  constructor(e, T, $, V) {
    super(e.span, V), this.layout = e, this.decoder = T, this.encoder = $;
  }
  decode(e, T) {
    return this.decoder(this.layout.decode(e, T));
  }
  encode(e, T, $) {
    return this.layout.encode(this.encoder(e), T, $);
  }
  getSpan(e, T) {
    return this.layout.getSpan(e, T);
  }
}
class COptionLayout extends Layout_2 {
  constructor(e, T) {
    super(-1, T), this.layout = e, this.discriminator = u32();
  }
  encode(e, T, $ = 0) {
    return e == null ? this.layout.span + this.discriminator.encode(0, T, $) : (this.discriminator.encode(1, T, $), this.layout.encode(e, T, $ + 4) + 4);
  }
  decode(e, T = 0) {
    const $ = this.discriminator.decode(e, T);
    if ($ === 0)
      return null;
    if ($ === 1)
      return this.layout.decode(e, T + 4);
    throw new Error("Invalid coption " + this.layout.property);
  }
  getSpan(e, T = 0) {
    return this.layout.getSpan(e, T + 4) + 4;
  }
}
class u64 extends BN {
  /**
   * Convert to Buffer representation
   */
  toBuffer() {
    const e = super.toArray().reverse(), T = dist$2.Buffer.from(e);
    if (T.length === 8)
      return T;
    if (T.length >= 8)
      throw new Error("u64 too large");
    const $ = dist$2.Buffer.alloc(8);
    return T.copy($), $;
  }
  /**
   * Construct a u64 from Buffer representation
   */
  static fromBuffer(e) {
    if (e.length !== 8)
      throw new Error(`Invalid buffer length: ${e.length}`);
    return new u64([...e].reverse().map((T) => `00${T.toString(16)}`.slice(-2)).join(""), 16);
  }
}
const TOKEN_ACCOUNT_LAYOUT = struct([
  publicKey("mint"),
  publicKey("owner"),
  uint64("amount"),
  coption(publicKey(), "delegate"),
  ((C) => {
    const e = union(u8("discriminator"), null, C);
    return e.addVariant(0, struct([]), "uninitialized"), e.addVariant(1, struct([]), "initialized"), e.addVariant(2, struct([]), "frozen"), e;
  })("state"),
  coption(uint64(), "isNative"),
  uint64("delegatedAmount"),
  coption(publicKey(), "closeAuthority")
]);
function decodeTokenAccount(C) {
  return TOKEN_ACCOUNT_LAYOUT.decode(C);
}
class AccountsResolver {
  constructor(e, T, $, V, J, ee, te, re) {
    this._accounts = T, this._provider = $, this._programId = V, this._idlIx = J, this._idlTypes = te, this._customResolver = re, this._args = e, this._accountStore = new AccountStore($, ee, this._programId);
  }
  args(e) {
    this._args = e;
  }
  // Note: We serially resolve PDAs one by one rather than doing them
  //       in parallel because there can be dependencies between
  //       addresses. That is, one PDA can be used as a seed in another.
  async resolve() {
    for (await this.resolveConst(this._idlIx.accounts), this._resolveEventCpi(this._idlIx.accounts); await this.resolvePdas(this._idlIx.accounts) + await this.resolveRelations(this._idlIx.accounts) + await this.resolveCustom() > 0; )
      ;
  }
  async resolveCustom() {
    if (this._customResolver) {
      const { accounts: e, resolved: T } = await this._customResolver({
        args: this._args,
        accounts: this._accounts,
        provider: this._provider,
        programId: this._programId,
        idlIx: this._idlIx
      });
      return this._accounts = e, T;
    }
    return 0;
  }
  resolveOptionalsHelper(e, T) {
    const $ = {};
    for (const V of T) {
      const J = V.name, ee = e[J];
      ee !== void 0 && (isPartialAccounts(ee) ? isIdlAccounts(V) ? $[J] = this.resolveOptionalsHelper(ee, V.accounts) : $[J] = flattenPartialAccounts(ee) : ee !== null ? $[J] = translateAddress(ee) : V.isOptional && ($[J] = this._programId));
    }
    return $;
  }
  resolveOptionals(e) {
    Object.assign(this._accounts, this.resolveOptionalsHelper(e, this._idlIx.accounts));
  }
  get(e) {
    const T = e.reduce(($, V) => $ && $[V], this._accounts);
    if (T && T.toBase58)
      return T;
  }
  set(e, T) {
    let $ = this._accounts;
    e.forEach((V, J) => {
      J == e.length - 1 && ($[V] = T), $[V] = $[V] || {}, $ = $[V];
    });
  }
  async resolveConst(e, T = []) {
    for (let $ = 0; $ < e.length; $ += 1) {
      const V = e[$], J = V.accounts;
      J && await this.resolveConst(J, [
        ...T,
        camelCase$1(V.name)
      ]);
      const ee = V, te = camelCase$1(V.name);
      if (ee.isSigner && !this.get([...T, te])) {
        if (this._provider.wallet === void 0)
          throw new Error("This function requires the Provider interface implementor to have a 'wallet' field.");
        this.set([...T, te], this._provider.wallet.publicKey);
      }
      Reflect.has(AccountsResolver.CONST_ACCOUNTS, te) && !this.get([...T, te]) && this.set([...T, te], AccountsResolver.CONST_ACCOUNTS[te]);
    }
  }
  /**
   * Resolve event CPI accounts `eventAuthority` and `program`.
   *
   * Accounts will only be resolved if they are declared next to each other to
   * reduce the chance of name collision.
   */
  _resolveEventCpi(e, T = []) {
    for (const $ in e) {
      const V = e[$], J = V.accounts;
      J && this._resolveEventCpi(J, [
        ...T,
        camelCase$1(V.name)
      ]);
      const ee = +$ + 1;
      if (ee === e.length)
        return;
      const te = camelCase$1(e[$].name), re = camelCase$1(e[ee].name);
      if (te === "eventAuthority" && re === "program") {
        const ie = [...T, te], se = [...T, re];
        this.get(ie) || this.set(ie, PublicKey.findProgramAddressSync([dist$2.Buffer.from("__event_authority")], this._programId)[0]), this.get(se) || this.set(se, this._programId);
        return;
      }
    }
  }
  async resolvePdas(e, T = []) {
    let $ = 0;
    for (let V = 0; V < e.length; V += 1) {
      const J = e[V], ee = J.accounts;
      ee && ($ += await this.resolvePdas(ee, [
        ...T,
        camelCase$1(J.name)
      ]));
      const te = J, re = camelCase$1(J.name);
      te.pda && te.pda.seeds.length > 0 && !this.get([...T, re]) && await this.autoPopulatePda(te, T) && ($ += 1);
    }
    return $;
  }
  async resolveRelations(e, T = []) {
    let $ = 0;
    for (let V = 0; V < e.length; V += 1) {
      const J = e[V], ee = J.accounts;
      ee && ($ += await this.resolveRelations(ee, [
        ...T,
        camelCase$1(J.name)
      ]));
      const te = J.relations || [], re = camelCase$1(J.name), ie = [...T, re], se = this.get(ie);
      if (se) {
        const de = te.filter((ue) => !this.get([...T, camelCase$1(ue)]));
        if ($ += de.length, de.length > 0) {
          const ue = await this._accountStore.fetchAccount({
            publicKey: se
          });
          await Promise.all(de.map(async (fe) => {
            const he = camelCase$1(fe);
            return this.set([...T, he], ue[he]), ue[he];
          }));
        }
      }
    }
    return $;
  }
  async autoPopulatePda(e, T = []) {
    if (!e.pda || !e.pda.seeds)
      throw new Error("Must have seeds");
    const $ = await Promise.all(e.pda.seeds.map((ee) => this.toBuffer(ee, T)));
    if ($.some((ee) => typeof ee > "u"))
      return;
    const V = await this.parseProgramId(e, T);
    if (!V)
      return;
    const [J] = await PublicKey.findProgramAddress($, V);
    this.set([...T, camelCase$1(e.name)], J);
  }
  async parseProgramId(e, T = []) {
    var $;
    if (!(!(($ = e.pda) === null || $ === void 0) && $.programId))
      return this._programId;
    switch (e.pda.programId.kind) {
      case "const":
        return new PublicKey(this.toBufferConst(e.pda.programId.value));
      case "arg":
        return this.argValue(e.pda.programId);
      case "account":
        return await this.accountValue(e.pda.programId, T);
      default:
        throw new Error(`Unexpected program seed kind: ${e.pda.programId.kind}`);
    }
  }
  async toBuffer(e, T = []) {
    switch (e.kind) {
      case "const":
        return this.toBufferConst(e);
      case "arg":
        return await this.toBufferArg(e);
      case "account":
        return await this.toBufferAccount(e, T);
      default:
        throw new Error(`Unexpected seed kind: ${e.kind}`);
    }
  }
  /**
   * Recursively get the type at some path of either a primitive or a user defined struct.
   */
  getType(e, T = []) {
    if (T.length > 0 && e.defined) {
      const $ = this._idlTypes.find((ee) => ee.name === e.defined);
      if (!$)
        throw new Error(`Cannot find type ${e.defined}`);
      const J = $.type.fields.find((ee) => ee.name === T[0]);
      return this.getType(J.type, T.slice(1));
    }
    return e;
  }
  toBufferConst(e) {
    return this.toBufferValue(this.getType(e.type, (e.path || "").split(".").slice(1)), e.value);
  }
  async toBufferArg(e) {
    const T = this.argValue(e);
    if (!(typeof T > "u"))
      return this.toBufferValue(this.getType(e.type, (e.path || "").split(".").slice(1)), T);
  }
  argValue(e) {
    const T = e.path.split("."), $ = camelCase$1(T[0]), V = this._idlIx.args.findIndex((J) => J.name === $);
    if (V === -1)
      throw new Error(`Unable to find argument for seed: ${$}`);
    return T.slice(1).reduce((J, ee) => (J || {})[ee], this._args[V]);
  }
  async toBufferAccount(e, T = []) {
    const $ = await this.accountValue(e, T);
    if ($)
      return this.toBufferValue(e.type, $);
  }
  async accountValue(e, T = []) {
    const $ = e.path.split("."), V = $[0], J = this.get([...T, camelCase$1(V)]);
    if (J === null)
      throw new Error("fieldPubkey is null");
    if ($.length === 1)
      return J;
    const ee = await this._accountStore.fetchAccount({
      publicKey: J,
      name: e.account
    });
    return this.parseAccountValue(ee, $.slice(1));
  }
  parseAccountValue(e, T) {
    let $;
    for (; T.length > 0; )
      $ = e[camelCase$1(T[0])], T = T.slice(1);
    return $;
  }
  // Converts the given idl valaue into a Buffer. The values here must be
  // primitives. E.g. no structs.
  //
  // TODO: add more types here as needed.
  toBufferValue(e, T) {
    switch (e) {
      case "u8":
        return dist$2.Buffer.from([T]);
      case "u16":
        let $ = dist$2.Buffer.alloc(2);
        return $.writeUInt16LE(T), $;
      case "u32":
        let V = dist$2.Buffer.alloc(4);
        return V.writeUInt32LE(T), V;
      case "u64":
        let J = dist$2.Buffer.alloc(8);
        return J.writeBigUInt64LE(BigInt(T)), J;
      case "string":
        return dist$2.Buffer.from(encode$2(T));
      case "publicKey":
        return T.toBuffer();
      default:
        if (e.array)
          return dist$2.Buffer.from(T);
        throw new Error(`Unexpected seed type: ${e}`);
    }
  }
}
AccountsResolver.CONST_ACCOUNTS = {
  associatedTokenProgram: ASSOCIATED_PROGRAM_ID,
  rent: SYSVAR_RENT_PUBKEY,
  systemProgram: SystemProgram.programId,
  tokenProgram: TOKEN_PROGRAM_ID$1,
  clock: SYSVAR_CLOCK_PUBKEY
};
class AccountStore {
  // todo: don't use the progrma use the account namespace.
  constructor(e, T, $) {
    this._provider = e, this._programId = $, this._cache = /* @__PURE__ */ new Map(), this._idls = {}, this._idls[$.toBase58()] = T;
  }
  async ensureIdl(e) {
    if (!this._idls[e.toBase58()]) {
      const T = await Program.fetchIdl(e, this._provider);
      if (T) {
        const $ = new Program(T, e, this._provider);
        this._idls[e.toBase58()] = $.account;
      }
    }
    return this._idls[e.toBase58()];
  }
  async fetchAccount({ publicKey: e, name: T, programId: $ = this._programId }) {
    const V = e.toString();
    if (!this._cache.has(V))
      if (T === "TokenAccount") {
        const J = await this._provider.connection.getAccountInfo(e);
        if (J === null)
          throw new Error(`invalid account info for ${V}`);
        const ee = decodeTokenAccount(J.data);
        this._cache.set(V, ee);
      } else if (T) {
        const J = await this.ensureIdl($);
        if (J) {
          const ee = J[camelCase$1(T)];
          if (ee) {
            const te = await ee.fetch(e);
            this._cache.set(V, te);
          }
        }
      } else {
        const J = await this._provider.connection.getAccountInfo(e);
        if (J === null)
          throw new Error(`invalid account info for ${V}`);
        const ee = J.data, te = await this.ensureIdl(J.owner);
        if (te) {
          const re = Object.values(te)[0];
          if (!re)
            throw new Error("No accounts for this program");
          const ie = re.coder.accounts.decodeAny(ee);
          this._cache.set(V, ie);
        }
      }
    return this._cache.get(V);
  }
}
class MethodsBuilderFactory {
  static build(e, T, $, V, J, ee, te, re, ie, se, de) {
    return (...ue) => new MethodsBuilder(ue, V, J, ee, te, re, e, T, $, ie, se, de);
  }
}
function isPartialAccounts(C) {
  return typeof C == "object" && C !== null && !("_bn" in C);
}
function flattenPartialAccounts(C, e) {
  const T = {};
  for (const $ in C) {
    const V = C[$];
    if (V === null)
      throw new Error("Failed to resolve optionals due to IDL type mismatch with input accounts!");
    T[$] = isPartialAccounts(V) ? flattenPartialAccounts(V) : translateAddress(V);
  }
  return T;
}
class MethodsBuilder {
  constructor(e, T, $, V, J, ee, te, re, ie, se, de, ue) {
    this._ixFn = T, this._txFn = $, this._rpcFn = V, this._simulateFn = J, this._viewFn = ee, this._programId = re, this._accounts = {}, this._remainingAccounts = [], this._signers = [], this._preInstructions = [], this._postInstructions = [], this._autoResolveAccounts = !0, this._args = e, this._accountsResolver = new AccountsResolver(e, this._accounts, te, re, ie, se, de, ue);
  }
  args(e) {
    this._args = e, this._accountsResolver.args(e);
  }
  async pubkeys() {
    return this._autoResolveAccounts && await this._accountsResolver.resolve(), this._accounts;
  }
  accounts(e) {
    return this._autoResolveAccounts = !0, this._accountsResolver.resolveOptionals(e), this;
  }
  accountsStrict(e) {
    return this._autoResolveAccounts = !1, this._accountsResolver.resolveOptionals(e), this;
  }
  signers(e) {
    return this._signers = this._signers.concat(e), this;
  }
  remainingAccounts(e) {
    return this._remainingAccounts = this._remainingAccounts.concat(e), this;
  }
  preInstructions(e) {
    return this._preInstructions = this._preInstructions.concat(e), this;
  }
  postInstructions(e) {
    return this._postInstructions = this._postInstructions.concat(e), this;
  }
  async rpc(e) {
    return this._autoResolveAccounts && await this._accountsResolver.resolve(), this._rpcFn(...this._args, {
      accounts: this._accounts,
      signers: this._signers,
      remainingAccounts: this._remainingAccounts,
      preInstructions: this._preInstructions,
      postInstructions: this._postInstructions,
      options: e
    });
  }
  async rpcAndKeys(e) {
    return {
      pubkeys: await this.pubkeys(),
      signature: await this.rpc(e)
    };
  }
  async view(e) {
    if (this._autoResolveAccounts && await this._accountsResolver.resolve(), !this._viewFn)
      throw new Error("Method does not support views");
    return this._viewFn(...this._args, {
      accounts: this._accounts,
      signers: this._signers,
      remainingAccounts: this._remainingAccounts,
      preInstructions: this._preInstructions,
      postInstructions: this._postInstructions,
      options: e
    });
  }
  async simulate(e) {
    return this._autoResolveAccounts && await this._accountsResolver.resolve(), this._simulateFn(...this._args, {
      accounts: this._accounts,
      signers: this._signers,
      remainingAccounts: this._remainingAccounts,
      preInstructions: this._preInstructions,
      postInstructions: this._postInstructions,
      options: e
    });
  }
  async instruction() {
    return this._autoResolveAccounts && await this._accountsResolver.resolve(), this._ixFn(...this._args, {
      accounts: this._accounts,
      signers: this._signers,
      remainingAccounts: this._remainingAccounts,
      preInstructions: this._preInstructions,
      postInstructions: this._postInstructions
    });
  }
  /**
   * Convenient shortcut to get instructions and pubkeys via
   * const { pubkeys, instructions } = await prepare();
   */
  async prepare() {
    return {
      instruction: await this.instruction(),
      pubkeys: await this.pubkeys(),
      signers: await this._signers
    };
  }
  async transaction() {
    return this._autoResolveAccounts && await this._accountsResolver.resolve(), this._txFn(...this._args, {
      accounts: this._accounts,
      signers: this._signers,
      remainingAccounts: this._remainingAccounts,
      preInstructions: this._preInstructions,
      postInstructions: this._postInstructions
    });
  }
}
class ViewFactory {
  static build(e, T, $, V) {
    const J = T.accounts.find((re) => re.isMut), ee = !!T.returns;
    return J || !ee ? void 0 : async (...re) => {
      var ie, se;
      let de = await $(...re);
      const ue = `Program return: ${e} `;
      let fe = de.raw.find((ve) => ve.startsWith(ue));
      if (!fe)
        throw new Error("View expected return log");
      let he = decode(fe.slice(ue.length)), me = T.returns;
      if (!me)
        throw new Error("View expected return type");
      return IdlCoder$1.fieldLayout({ type: me }, Array.from([...(ie = V.accounts) !== null && ie !== void 0 ? ie : [], ...(se = V.types) !== null && se !== void 0 ? se : []])).decode(he);
    };
  }
}
class NamespaceFactory {
  /**
   * Generates all namespaces for a given program.
   */
  static build(e, T, $, V, J) {
    const ee = {}, te = {}, re = {}, ie = {}, se = {}, de = {}, ue = parseIdlErrors(e), fe = e.accounts ? AccountFactory.build(e, T, $, V) : {};
    return e.instructions.forEach((he) => {
      const me = InstructionNamespaceFactory.build(he, (Ie, ke) => T.instruction.encode(Ie, ke), $), xe = TransactionFactory.build(he, me), ve = RpcFactory.build(he, xe, ue, V), Te = SimulateFactory.build(he, xe, ue, V, T, $, e), we = ViewFactory.build($, he, Te, e), Ee = MethodsBuilderFactory.build(V, $, he, me, xe, ve, Te, we, fe, e.types || [], J && J(he)), Me = camelCase$1(he.name);
      te[Me] = me, re[Me] = xe, ee[Me] = ve, ie[Me] = Te, se[Me] = Ee, we && (de[Me] = we);
    }), [
      ee,
      te,
      re,
      fe,
      ie,
      se,
      de
    ];
  }
}
class Program {
  /**
   * Address of the program.
   */
  get programId() {
    return this._programId;
  }
  /**
   * IDL defining the program's interface.
   */
  get idl() {
    return this._idl;
  }
  /**
   * Coder for serializing requests.
   */
  get coder() {
    return this._coder;
  }
  /**
   * Wallet and network provider.
   */
  get provider() {
    return this._provider;
  }
  /**
   * @param idl       The interface definition.
   * @param programId The on-chain address of the program.
   * @param provider  The network and wallet context to use. If not provided
   *                  then uses [[getProvider]].
   * @param getCustomResolver A function that returns a custom account resolver
   *                          for the given instruction. This is useful for resolving
   *                          public keys of missing accounts when building instructions
   */
  constructor(e, T, $, V, J) {
    T = translateAddress(T), $ || ($ = getProvider()), this._idl = e, this._provider = $, this._programId = T, this._coder = V ?? new BorshCoder(e), this._events = new EventManager(this._programId, $, this._coder);
    const [ee, te, re, ie, se, de, ue] = NamespaceFactory.build(e, this._coder, T, $, J ?? (() => {
    }));
    this.rpc = ee, this.instruction = te, this.transaction = re, this.account = ie, this.simulate = se, this.methods = de, this.views = ue;
  }
  /**
   * Generates a Program client by fetching the IDL from the network.
   *
   * In order to use this method, an IDL must have been previously initialized
   * via the anchor CLI's `anchor idl init` command.
   *
   * @param programId The on-chain address of the program.
   * @param provider  The network and wallet context.
   */
  static async at(e, T) {
    const $ = translateAddress(e), V = await Program.fetchIdl($, T);
    if (!V)
      throw new Error(`IDL not found for program: ${e.toString()}`);
    return new Program(V, $, T);
  }
  /**
   * Fetches an idl from the blockchain.
   *
   * In order to use this method, an IDL must have been previously initialized
   * via the anchor CLI's `anchor idl init` command.
   *
   * @param programId The on-chain address of the program.
   * @param provider  The network and wallet context.
   */
  static async fetchIdl(e, T) {
    T = T ?? getProvider();
    const $ = translateAddress(e), V = await idlAddress($), J = await T.connection.getAccountInfo(V);
    if (!J)
      return null;
    let ee = decodeIdlAccount(J.data.slice(8));
    const te = inflate_1(ee.data);
    return JSON.parse(decode$2(te));
  }
  /**
   * Invokes the given callback every time the given event is emitted.
   *
   * @param eventName The PascalCase name of the event, provided by the IDL.
   * @param callback  The function to invoke whenever the event is emitted from
   *                  program logs.
   */
  addEventListener(e, T) {
    return this._events.addEventListener(e, T);
  }
  /**
   * Unsubscribes from the given eventName.
   */
  async removeEventListener(e) {
    return await this._events.removeEventListener(e);
  }
}
new PublicKey("11111111111111111111111111111111");
const TOKEN_PROGRAM_ID = new PublicKey("TokenkegQfeZyiNwAJbNbGKPFXCWuBvf9Ss623VQ5DA");
new PublicKey("TokenzQdBNbLqP5VEhdkAS6EPFLC1PHnBqCXEpPxuEb");
const ASSOCIATED_TOKEN_PROGRAM_ID = new PublicKey("ATokenGPvbdGVxr1b2hvZbsiqW5xWH25efTNsLJA8knL");
new PublicKey("So11111111111111111111111111111111111111112");
new PublicKey("9pan9bMn5HatX4EJdBwg9VgCa7Uz5HL8N1m5D3NdXejP");
class TokenError extends Error {
  constructor(e) {
    super(e);
  }
}
class TokenAccountNotFoundError extends TokenError {
  constructor() {
    super(...arguments), this.name = "TokenAccountNotFoundError";
  }
}
class TokenInvalidAccountOwnerError extends TokenError {
  constructor() {
    super(...arguments), this.name = "TokenInvalidAccountOwnerError";
  }
}
class TokenInvalidAccountSizeError extends TokenError {
  constructor() {
    super(...arguments), this.name = "TokenInvalidAccountSizeError";
  }
}
class TokenInvalidMintError extends TokenError {
  constructor() {
    super(...arguments), this.name = "TokenInvalidMintError";
  }
}
class TokenOwnerOffCurveError extends TokenError {
  constructor() {
    super(...arguments), this.name = "TokenOwnerOffCurveError";
  }
}
class TokenTransferHookAccountNotFound extends TokenError {
  constructor() {
    super(...arguments), this.name = "TokenTransferHookAccountNotFound";
  }
}
class TokenTransferHookInvalidSeed extends TokenError {
  constructor() {
    super(...arguments), this.name = "TokenTransferHookInvalidSeed";
  }
}
class TokenTransferHookAccountDataNotFound extends TokenError {
  constructor() {
    super(...arguments), this.name = "TokenTransferHookAccountDataNotFound";
  }
}
var TokenInstruction;
(function(C) {
  C[C.InitializeMint = 0] = "InitializeMint", C[C.InitializeAccount = 1] = "InitializeAccount", C[C.InitializeMultisig = 2] = "InitializeMultisig", C[C.Transfer = 3] = "Transfer", C[C.Approve = 4] = "Approve", C[C.Revoke = 5] = "Revoke", C[C.SetAuthority = 6] = "SetAuthority", C[C.MintTo = 7] = "MintTo", C[C.Burn = 8] = "Burn", C[C.CloseAccount = 9] = "CloseAccount", C[C.FreezeAccount = 10] = "FreezeAccount", C[C.ThawAccount = 11] = "ThawAccount", C[C.TransferChecked = 12] = "TransferChecked", C[C.ApproveChecked = 13] = "ApproveChecked", C[C.MintToChecked = 14] = "MintToChecked", C[C.BurnChecked = 15] = "BurnChecked", C[C.InitializeAccount2 = 16] = "InitializeAccount2", C[C.SyncNative = 17] = "SyncNative", C[C.InitializeAccount3 = 18] = "InitializeAccount3", C[C.InitializeMultisig2 = 19] = "InitializeMultisig2", C[C.InitializeMint2 = 20] = "InitializeMint2", C[C.GetAccountDataSize = 21] = "GetAccountDataSize", C[C.InitializeImmutableOwner = 22] = "InitializeImmutableOwner", C[C.AmountToUiAmount = 23] = "AmountToUiAmount", C[C.UiAmountToAmount = 24] = "UiAmountToAmount", C[C.InitializeMintCloseAuthority = 25] = "InitializeMintCloseAuthority", C[C.TransferFeeExtension = 26] = "TransferFeeExtension", C[C.ConfidentialTransferExtension = 27] = "ConfidentialTransferExtension", C[C.DefaultAccountStateExtension = 28] = "DefaultAccountStateExtension", C[C.Reallocate = 29] = "Reallocate", C[C.MemoTransferExtension = 30] = "MemoTransferExtension", C[C.CreateNativeMint = 31] = "CreateNativeMint", C[C.InitializeNonTransferableMint = 32] = "InitializeNonTransferableMint", C[C.InterestBearingMintExtension = 33] = "InterestBearingMintExtension", C[C.CpiGuardExtension = 34] = "CpiGuardExtension", C[C.InitializePermanentDelegate = 35] = "InitializePermanentDelegate", C[C.TransferHookExtension = 36] = "TransferHookExtension", C[C.MetadataPointerExtension = 39] = "MetadataPointerExtension";
})(TokenInstruction || (TokenInstruction = {}));
function addSigners(C, e, T) {
  if (T.length) {
    C.push({ pubkey: e, isSigner: !1, isWritable: !1 });
    for (const $ of T)
      C.push({
        pubkey: $ instanceof PublicKey ? $ : $.publicKey,
        isSigner: !0,
        isWritable: !1
      });
  } else
    C.push({ pubkey: e, isSigner: !0, isWritable: !1 });
  return C;
}
const approveInstructionData = struct$1([u8$1("instruction"), u64$1("amount")]);
function createApproveInstruction$1(C, e, T, $, V = [], J = TOKEN_PROGRAM_ID) {
  const ee = addSigners([
    { pubkey: C, isSigner: !1, isWritable: !0 },
    { pubkey: e, isSigner: !1, isWritable: !1 }
  ], T, V), te = dist$2.Buffer.alloc(approveInstructionData.span);
  return approveInstructionData.encode({
    instruction: TokenInstruction.Approve,
    amount: BigInt($)
  }, te), new TransactionInstruction({ keys: ee, programId: J, data: te });
}
var AccountType;
(function(C) {
  C[C.Uninitialized = 0] = "Uninitialized", C[C.Mint = 1] = "Mint", C[C.Account = 2] = "Account";
})(AccountType || (AccountType = {}));
const ACCOUNT_TYPE_SIZE = 1, MultisigLayout = struct$1([
  u8$1("m"),
  u8$1("n"),
  bool("isInitialized"),
  publicKey$3("signer1"),
  publicKey$3("signer2"),
  publicKey$3("signer3"),
  publicKey$3("signer4"),
  publicKey$3("signer5"),
  publicKey$3("signer6"),
  publicKey$3("signer7"),
  publicKey$3("signer8"),
  publicKey$3("signer9"),
  publicKey$3("signer10"),
  publicKey$3("signer11")
]), MULTISIG_SIZE = MultisigLayout.span;
var AccountState;
(function(C) {
  C[C.Uninitialized = 0] = "Uninitialized", C[C.Initialized = 1] = "Initialized", C[C.Frozen = 2] = "Frozen";
})(AccountState || (AccountState = {}));
const AccountLayout = struct$1([
  publicKey$3("mint"),
  publicKey$3("owner"),
  u64$1("amount"),
  u32$1("delegateOption"),
  publicKey$3("delegate"),
  u8$1("state"),
  u32$1("isNativeOption"),
  u64$1("isNative"),
  u64$1("delegatedAmount"),
  u32$1("closeAuthorityOption"),
  publicKey$3("closeAuthority")
]), ACCOUNT_SIZE = AccountLayout.span, MintLayout = struct$1([
  u32$1("mintAuthorityOption"),
  publicKey$3("mintAuthority"),
  u64$1("supply"),
  u8$1("decimals"),
  bool("isInitialized"),
  u32$1("freezeAuthorityOption"),
  publicKey$3("freezeAuthority")
]), MINT_SIZE = MintLayout.span;
async function getMint(C, e, T, $ = TOKEN_PROGRAM_ID) {
  const V = await C.getAccountInfo(e, T);
  return unpackMint(e, V, $);
}
function unpackMint(C, e, T = TOKEN_PROGRAM_ID) {
  if (!e)
    throw new TokenAccountNotFoundError();
  if (!e.owner.equals(T))
    throw new TokenInvalidAccountOwnerError();
  if (e.data.length < MINT_SIZE)
    throw new TokenInvalidAccountSizeError();
  const $ = MintLayout.decode(e.data.slice(0, MINT_SIZE));
  let V = dist$2.Buffer.alloc(0);
  if (e.data.length > MINT_SIZE) {
    if (e.data.length <= ACCOUNT_SIZE)
      throw new TokenInvalidAccountSizeError();
    if (e.data.length === MULTISIG_SIZE)
      throw new TokenInvalidAccountSizeError();
    if (e.data[ACCOUNT_SIZE] != AccountType.Mint)
      throw new TokenInvalidMintError();
    V = e.data.slice(ACCOUNT_SIZE + ACCOUNT_TYPE_SIZE);
  }
  return {
    address: C,
    mintAuthority: $.mintAuthorityOption ? $.mintAuthority : null,
    supply: $.supply,
    decimals: $.decimals,
    isInitialized: $.isInitialized,
    freezeAuthority: $.freezeAuthorityOption ? $.freezeAuthority : null,
    tlvData: V
  };
}
async function getAssociatedTokenAddress$1(C, e, T = !1, $ = TOKEN_PROGRAM_ID, V = ASSOCIATED_TOKEN_PROGRAM_ID) {
  if (!T && !PublicKey.isOnCurve(e.toBuffer()))
    throw new TokenOwnerOffCurveError();
  const [J] = await PublicKey.findProgramAddress([e.toBuffer(), $.toBuffer(), C.toBuffer()], V);
  return J;
}
function getAssociatedTokenAddressSync(C, e, T = !1, $ = TOKEN_PROGRAM_ID, V = ASSOCIATED_TOKEN_PROGRAM_ID) {
  if (!T && !PublicKey.isOnCurve(e.toBuffer()))
    throw new TokenOwnerOffCurveError();
  const [J] = PublicKey.findProgramAddressSync([e.toBuffer(), $.toBuffer(), C.toBuffer()], V);
  return J;
}
const DISCRIMINATOR_SPAN = 1, LITERAL_LENGTH_SPAN = 1, INSTRUCTION_ARG_OFFSET_SPAN = 1, INSTRUCTION_ARG_LENGTH_SPAN = 1, ACCOUNT_KEY_INDEX_SPAN = 1, ACCOUNT_DATA_ACCOUNT_INDEX_SPAN = 1, ACCOUNT_DATA_OFFSET_SPAN = 1, ACCOUNT_DATA_LENGTH_SPAN = 1;
function unpackSeedLiteral(C) {
  if (C.length < 1)
    throw new TokenTransferHookInvalidSeed();
  const [e, ...T] = C;
  if (T.length < e)
    throw new TokenTransferHookInvalidSeed();
  return {
    data: dist$2.Buffer.from(T.slice(0, e)),
    packedLength: DISCRIMINATOR_SPAN + LITERAL_LENGTH_SPAN + e
  };
}
function unpackSeedInstructionArg(C, e) {
  if (C.length < 2)
    throw new TokenTransferHookInvalidSeed();
  const [T, $] = C;
  if (e.length < $ + T)
    throw new TokenTransferHookInvalidSeed();
  return {
    data: e.subarray(T, T + $),
    packedLength: DISCRIMINATOR_SPAN + INSTRUCTION_ARG_OFFSET_SPAN + INSTRUCTION_ARG_LENGTH_SPAN
  };
}
function unpackSeedAccountKey(C, e) {
  if (C.length < 1)
    throw new TokenTransferHookInvalidSeed();
  const [T] = C;
  if (e.length <= T)
    throw new TokenTransferHookInvalidSeed();
  return {
    data: e[T].pubkey.toBuffer(),
    packedLength: DISCRIMINATOR_SPAN + ACCOUNT_KEY_INDEX_SPAN
  };
}
async function unpackSeedAccountData(C, e, T) {
  if (C.length < 3)
    throw new TokenTransferHookInvalidSeed();
  const [$, V, J] = C;
  if (e.length <= $)
    throw new TokenTransferHookInvalidSeed();
  const ee = await T.getAccountInfo(e[$].pubkey);
  if (ee == null)
    throw new TokenTransferHookAccountDataNotFound();
  if (ee.data.length < V + J)
    throw new TokenTransferHookInvalidSeed();
  return {
    data: ee.data.subarray(V, V + J),
    packedLength: DISCRIMINATOR_SPAN + ACCOUNT_DATA_ACCOUNT_INDEX_SPAN + ACCOUNT_DATA_OFFSET_SPAN + ACCOUNT_DATA_LENGTH_SPAN
  };
}
async function unpackFirstSeed(C, e, T, $) {
  const [V, ...J] = C, ee = new Uint8Array(J);
  switch (V) {
    case 0:
      return null;
    case 1:
      return unpackSeedLiteral(ee);
    case 2:
      return unpackSeedInstructionArg(ee, T);
    case 3:
      return unpackSeedAccountKey(ee, e);
    case 4:
      return unpackSeedAccountData(ee, e, $);
    default:
      throw new TokenTransferHookInvalidSeed();
  }
}
async function unpackSeeds(C, e, T, $) {
  const V = [];
  let J = 0;
  for (; J < 32; ) {
    const ee = await unpackFirstSeed(C.slice(J), e, T, $);
    if (ee == null)
      break;
    V.push(ee.data), J += ee.packedLength;
  }
  return V;
}
const TransferHookLayout = struct$1([publicKey$3("authority"), publicKey$3("programId")]);
TransferHookLayout.span;
function getTransferHook(C) {
  const e = getExtensionData(ExtensionType.TransferHook, C.tlvData);
  return e !== null ? TransferHookLayout.decode(e) : null;
}
const TransferHookAccountLayout = struct$1([bool("transferring")]);
TransferHookAccountLayout.span;
function getExtraAccountMetaAddress(C, e) {
  const T = [dist$2.Buffer.from("extra-account-metas"), C.toBuffer()];
  return PublicKey.findProgramAddressSync(T, e)[0];
}
const ExtraAccountMetaLayout = struct$1([
  u8$1("discriminator"),
  blob$1(32, "addressConfig"),
  bool("isSigner"),
  bool("isWritable")
]), ExtraAccountMetaListLayout = struct$1([
  u32$1("count"),
  seq(ExtraAccountMetaLayout, greedy(ExtraAccountMetaLayout.span), "extraAccounts")
]), ExtraAccountMetaAccountDataLayout = struct$1([
  u64$1("instructionDiscriminator"),
  u32$1("length"),
  ExtraAccountMetaListLayout.replicate("extraAccountsList")
]);
function getExtraAccountMetas(C) {
  const e = ExtraAccountMetaAccountDataLayout.decode(C.data).extraAccountsList;
  return e.extraAccounts.slice(0, e.count);
}
async function resolveExtraAccountMeta(C, e, T, $, V) {
  if (e.discriminator === 0)
    return {
      pubkey: new PublicKey(e.addressConfig),
      isSigner: e.isSigner,
      isWritable: e.isWritable
    };
  let J = PublicKey.default;
  if (e.discriminator === 1)
    J = V;
  else {
    const re = e.discriminator - 128;
    if (T.length <= re)
      throw new TokenTransferHookAccountNotFound();
    J = T[re].pubkey;
  }
  const ee = await unpackSeeds(e.addressConfig, T, $, C);
  return { pubkey: PublicKey.findProgramAddressSync(ee, J)[0], isSigner: e.isSigner, isWritable: e.isWritable };
}
var TransferHookInstruction;
(function(C) {
  C[C.Initialize = 0] = "Initialize", C[C.Update = 1] = "Update";
})(TransferHookInstruction || (TransferHookInstruction = {}));
struct$1([
  u8$1("instruction"),
  u8$1("transferHookInstruction"),
  publicKey$3("authority"),
  publicKey$3("transferHookProgramId")
]);
struct$1([
  u8$1("instruction"),
  u8$1("transferHookInstruction"),
  publicKey$3("transferHookProgramId")
]);
function createExecuteInstruction(C, e, T, $, V, J, ee) {
  const te = [e, T, $, V, J].map((ie) => ({
    pubkey: ie,
    isSigner: !1,
    isWritable: !1
  })), re = dist$2.Buffer.alloc(16);
  return re.set(dist$2.Buffer.from([105, 37, 101, 197, 75, 251, 102, 26]), 0), re.writeBigUInt64LE(BigInt(ee), 8), new TransactionInstruction({ keys: te, programId: C, data: re });
}
var ExtensionType;
(function(C) {
  C[C.Uninitialized = 0] = "Uninitialized", C[C.TransferFeeConfig = 1] = "TransferFeeConfig", C[C.TransferFeeAmount = 2] = "TransferFeeAmount", C[C.MintCloseAuthority = 3] = "MintCloseAuthority", C[C.ConfidentialTransferMint = 4] = "ConfidentialTransferMint", C[C.ConfidentialTransferAccount = 5] = "ConfidentialTransferAccount", C[C.DefaultAccountState = 6] = "DefaultAccountState", C[C.ImmutableOwner = 7] = "ImmutableOwner", C[C.MemoTransfer = 8] = "MemoTransfer", C[C.NonTransferable = 9] = "NonTransferable", C[C.InterestBearingConfig = 10] = "InterestBearingConfig", C[C.CpiGuard = 11] = "CpiGuard", C[C.PermanentDelegate = 12] = "PermanentDelegate", C[C.NonTransferableAccount = 13] = "NonTransferableAccount", C[C.TransferHook = 14] = "TransferHook", C[C.TransferHookAccount = 15] = "TransferHookAccount", C[C.MetadataPointer = 18] = "MetadataPointer", C[C.TokenMetadata = 19] = "TokenMetadata";
})(ExtensionType || (ExtensionType = {}));
const TYPE_SIZE = 2, LENGTH_SIZE = 2;
function addTypeAndLengthToLen(C) {
  return C + TYPE_SIZE + LENGTH_SIZE;
}
function getExtensionData(C, e) {
  let T = 0;
  for (; addTypeAndLengthToLen(T) <= e.length; ) {
    const $ = e.readUInt16LE(T), V = e.readUInt16LE(T + TYPE_SIZE), J = addTypeAndLengthToLen(T);
    if ($ == C)
      return e.slice(J, J + V);
    T = J + V;
  }
  return null;
}
function createAssociatedTokenAccountInstruction$1(C, e, T, $, V = TOKEN_PROGRAM_ID, J = ASSOCIATED_TOKEN_PROGRAM_ID) {
  return buildAssociatedTokenAccountInstruction(C, e, T, $, dist$2.Buffer.alloc(0), V, J);
}
function buildAssociatedTokenAccountInstruction(C, e, T, $, V, J = TOKEN_PROGRAM_ID, ee = ASSOCIATED_TOKEN_PROGRAM_ID) {
  const te = [
    { pubkey: C, isSigner: !0, isWritable: !0 },
    { pubkey: e, isSigner: !1, isWritable: !0 },
    { pubkey: T, isSigner: !1, isWritable: !1 },
    { pubkey: $, isSigner: !1, isWritable: !1 },
    { pubkey: SystemProgram.programId, isSigner: !1, isWritable: !1 },
    { pubkey: J, isSigner: !1, isWritable: !1 }
  ];
  return new TransactionInstruction({
    keys: te,
    programId: ee,
    data: V
  });
}
const postMessageLayout = [
  { name: "discriminator", binary: "bytes", size: 4 },
  { name: "consistencyLevel", binary: "uint", size: 1, endianness: "little" },
  { name: "emitterAuthority", ...universalAddressItem },
  { name: "messageStatus", binary: "uint", size: 1, endianness: "little" },
  { name: "gap", binary: "uint", size: 3 },
  { name: "timestamp", binary: "uint", size: 4, endianness: "little" },
  { name: "nonce", binary: "uint", size: 4, endianness: "little" },
  { name: "sequence", binary: "uint", size: 8, endianness: "little" },
  { name: "emitterChain", binary: "uint", size: 2, endianness: "little" },
  { name: "emitterAddress", ...universalAddressItem },
  { name: "payloadLength", binary: "uint", size: 4, endianness: "little" },
  { name: "payload", binary: "bytes" }
];
function deserializePostMessage(C) {
  return deserialize$2(postMessageLayout, C);
}
function deriveClaimKey(C, e, T, $) {
  const V = typeof e == "string" ? dist$2.Buffer.from(e, "hex") : dist$2.Buffer.from(e);
  if (V.length != 32)
    throw Error("address.length != 32");
  const J = dist$2.Buffer.alloc(8);
  return J.writeBigUInt64BE(typeof $ == "number" ? BigInt($) : $), deriveAddress([
    V,
    (() => {
      const ee = dist$2.Buffer.alloc(2);
      return ee.writeUInt16BE(T), ee;
    })(),
    J
  ], C);
}
async function getClaim(C, e, T, $, V, J) {
  return C.getAccountInfo(deriveClaimKey(e, T, $, V), J).then((ee) => !!getAccountData(ee)[0]);
}
function deriveWormholeBridgeDataKey(C) {
  return deriveAddress([dist$2.Buffer.from("Bridge")], C);
}
async function getWormholeBridgeData(C, e, T) {
  return C.getAccountInfo(deriveWormholeBridgeDataKey(e), T).then(($) => BridgeData.deserialize(getAccountData($)));
}
class BridgeConfig {
  constructor(e, T) {
    tt(this, "guardianSetExpirationTime");
    tt(this, "fee");
    this.guardianSetExpirationTime = e, this.fee = T;
  }
  static deserialize(e) {
    if (e.length != 12)
      throw new Error("data.length != 12");
    const T = e.readUInt32LE(0), $ = e.readBigUInt64LE(4);
    return new BridgeConfig(T, $);
  }
}
class BridgeData {
  constructor(e, T, $) {
    tt(this, "guardianSetIndex");
    tt(this, "lastLamports");
    tt(this, "config");
    this.guardianSetIndex = e, this.lastLamports = T, this.config = $;
  }
  static deserialize(e) {
    if (e.length != 24)
      throw new Error("data.length != 24");
    const T = e.readUInt32LE(0), $ = e.readBigUInt64LE(4), V = BridgeConfig.deserialize(e.subarray(12));
    return new BridgeData(T, $, V);
  }
}
function deriveEmitterSequenceKey(C, e) {
  return deriveAddress([dist$2.Buffer.from("Sequence"), new PublicKey(C).toBytes()], e);
}
async function getSequenceTracker(C, e, T, $) {
  return C.getAccountInfo(deriveEmitterSequenceKey(e, T), $).then((V) => SequenceTracker.deserialize(getAccountData(V)));
}
class SequenceTracker {
  constructor(e, T, $) {
    tt(this, "sequence");
    tt(this, "bump");
    tt(this, "emitterType");
    this.sequence = e, this.bump = T, this.emitterType = $;
  }
  static deserialize(e) {
    if (e.length !== 8 && e.length !== 10)
      throw new Error("data.length != 8 or data.length != 10");
    let T, $;
    const V = e.readBigUInt64LE(0);
    return e.length === 10 && (T = e[8], $ = e[9]), new SequenceTracker(V, T, $);
  }
  value() {
    return this.sequence;
  }
}
function deriveWormholeEmitterKey(C) {
  return deriveAddress([dist$2.Buffer.from("emitter")], C);
}
function getEmitterKeys(C, e) {
  const T = deriveWormholeEmitterKey(C);
  return {
    emitter: T,
    sequence: deriveEmitterSequenceKey(T, e)
  };
}
async function getProgramSequenceTracker(C, e, T, $) {
  return getSequenceTracker(C, deriveWormholeEmitterKey(e), T, $);
}
function deriveFeeCollectorKey(C) {
  return deriveAddress([dist$2.Buffer.from("fee_collector")], C);
}
const SIGNATURE_LENGTH = 65, ETHEREUM_KEY_LENGTH = 20;
function createSecp256k1Instruction(C, e, T) {
  return new TransactionInstruction({
    keys: [],
    programId: Secp256k1Program.programId,
    data: Secp256k1SignatureOffsets.serialize(C, e, T)
  });
}
class Secp256k1SignatureOffsets {
  // https://docs.solana.com/developing/runtime-facilities/programs#secp256k1-program
  //
  // struct Secp256k1SignatureOffsets {
  //     secp_signature_key_offset: u16,        // offset to [signature,recovery_id,etherum_address] of 64+1+20 bytes
  //     secp_signature_instruction_index: u8,  // instruction index to find data
  //     secp_pubkey_offset: u16,               // offset to [signature,recovery_id] of 64+1 bytes
  //     secp_signature_instruction_index: u8,  // instruction index to find data
  //     secp_message_data_offset: u16,         // offset to start of message data
  //     secp_message_data_size: u16,           // size of message data
  //     secp_message_instruction_index: u8,    // index of instruction data to get message data
  // }
  //
  // Pseudo code of the operation:
  //
  // process_instruction() {
  //     for i in 0..count {
  //         // i'th index values referenced:
  //         instructions = &transaction.message().instructions
  //         signature = instructions[secp_signature_instruction_index].data[secp_signature_offset..secp_signature_offset + 64]
  //         recovery_id = instructions[secp_signature_instruction_index].data[secp_signature_offset + 64]
  //         ref_eth_pubkey = instructions[secp_pubkey_instruction_index].data[secp_pubkey_offset..secp_pubkey_offset + 32]
  //         message_hash = keccak256(instructions[secp_message_instruction_index].data[secp_message_data_offset..secp_message_data_offset + secp_message_data_size])
  //         pubkey = ecrecover(signature, recovery_id, message_hash)
  //         eth_pubkey = keccak256(pubkey[1..])[12..]
  //         if eth_pubkey != ref_eth_pubkey {
  //             return Error
  //         }
  //     }
  //     return Success
  //   }
  /**
   * Serialize multiple signatures, ethereum public keys and message as Secp256k1 instruction data.
   *
   * @param {Buffer[]} signatures - 65-byte signatures (64 + 1 recovery id)
   * @param {Buffer[]} keys - ethereum public keys
   * @param {Buffer} message - 32-byte hash
   * @returns serialized Secp256k1 instruction data
   */
  static serialize(e, T, $) {
    if (e.length == 0)
      throw Error("signatures.length == 0");
    if (e.length != T.length)
      throw Error("signatures.length != keys.length");
    if ($.length != 32)
      throw Error("message.length != 32");
    const V = e.length, J = 11, ee = 1 + V * J, te = SIGNATURE_LENGTH + ETHEREUM_KEY_LENGTH, re = ee + V * te, ie = 32, se = dist$2.Buffer.alloc(re + ie);
    se.writeUInt8(V, 0), se.write($.toString("hex"), re, "hex");
    for (let de = 0; de < V; ++de) {
      const ue = e.at(de);
      if ((ue == null ? void 0 : ue.length) != SIGNATURE_LENGTH)
        throw Error(`signatures[${de}].length != 65`);
      const fe = T.at(de);
      if ((fe == null ? void 0 : fe.length) != ETHEREUM_KEY_LENGTH)
        throw Error(`keys[${de}].length != 20`);
      const he = ee + te * de, me = he + 65;
      se.writeUInt16LE(he, 1 + de * J), se.writeUInt8(0, 3 + de * J), se.writeUInt16LE(me, 4 + de * J), se.writeUInt8(0, 6 + de * J), se.writeUInt16LE(re, 7 + de * J), se.writeUInt16LE(ie, 9 + de * J), se.writeUInt8(0, 10 + de * J), se.write(ue.toString("hex"), he, "hex"), se.write(fe.toString("hex"), me, "hex");
    }
    return se;
  }
}
function deriveGuardianSetKey(C, e) {
  return deriveAddress([
    dist$2.Buffer.from("GuardianSet"),
    (() => {
      const T = dist$2.Buffer.alloc(4);
      return T.writeUInt32BE(e), T;
    })()
  ], C);
}
async function getGuardianSet(C, e, T, $) {
  return C.getAccountInfo(deriveGuardianSetKey(e, T), $).then((V) => GuardianSetData.deserialize(getAccountData(V)));
}
class GuardianSetData {
  constructor(e, T, $, V) {
    tt(this, "index");
    tt(this, "keys");
    tt(this, "creationTime");
    tt(this, "expirationTime");
    this.index = e, this.keys = T, this.creationTime = $, this.expirationTime = V;
  }
  static deserialize(e) {
    const T = e.readUInt32LE(0), $ = e.readUInt32LE(4), V = 8 + $ * ETHEREUM_KEY_LENGTH, J = e.readUInt32LE(V), ee = e.readUInt32LE(4 + V), te = [];
    for (let re = 0; re < $; ++re) {
      const ie = 8 + re * ETHEREUM_KEY_LENGTH;
      te.push(e.subarray(ie, ie + ETHEREUM_KEY_LENGTH));
    }
    return new GuardianSetData(T, te, J, ee);
  }
}
function derivePostedVaaKey(C, e) {
  return deriveAddress([dist$2.Buffer.from("PostedVAA"), e], C);
}
async function getSignatureSetData(C, e, T) {
  return C.getAccountInfo(new PublicKey(e), T).then(($) => SignatureSetData.deserialize(getAccountData($)));
}
class SignatureSetData {
  constructor(e, T, $) {
    tt(this, "signatures");
    tt(this, "hash");
    tt(this, "guardianSetIndex");
    this.signatures = e, this.hash = T, this.guardianSetIndex = $;
  }
  static deserialize(e) {
    const T = e.readUInt32LE(0), $ = [...e.subarray(4, 4 + T)].map((te) => te != 0), V = 4 + T, J = e.subarray(V, V + 32), ee = e.readUInt32LE(V + 32);
    return new SignatureSetData($, J, ee);
  }
}
function deriveUpgradeAuthorityKey(C) {
  return deriveAddress([dist$2.Buffer.from("upgrade")], C);
}
function createBridgeFeeTransferInstruction(C, e, T) {
  return SystemProgram.transfer({
    fromPubkey: new PublicKey(e),
    toPubkey: deriveFeeCollectorKey(C),
    lamports: T
  });
}
class WormholeAccountsCoder {
  constructor(e) {
    tt(this, "idl");
    this.idl = e;
  }
  async encode(e, T) {
    switch (e) {
      default:
        throw new Error(`Invalid account name: ${e}`);
    }
  }
  decode(e, T) {
    return this.decodeUnchecked(e, T);
  }
  decodeUnchecked(e, T) {
    switch (e) {
      default:
        throw new Error(`Invalid account name: ${e}`);
    }
  }
  memcmp(e, T) {
    switch (e) {
      case "postVaa":
        return {
          dataSize: 56
          // + 4 + payload.length
        };
      default:
        throw new Error(`Invalid account name: ${e}`);
    }
  }
  size(e) {
    return accountSize$1(this.idl, e) ?? 0;
  }
}
class WormholeEventsCoder {
  constructor(e) {
  }
  decode(e) {
    throw new Error("Wormhole program does not have events");
  }
}
class IdlCoder {
  static fieldLayout(e, T) {
    const $ = e.name !== void 0 ? camelCase$2(e.name) : void 0;
    switch (e.type) {
      case "bool":
        return dist$1.bool($);
      case "u8":
        return dist$1.u8($);
      case "i8":
        return dist$1.i8($);
      case "u16":
        return dist$1.u16($);
      case "i16":
        return dist$1.i16($);
      case "u32":
        return dist$1.u32($);
      case "i32":
        return dist$1.i32($);
      case "f32":
        return dist$1.f32($);
      case "u64":
        return dist$1.u64($);
      case "i64":
        return dist$1.i64($);
      case "f64":
        return dist$1.f64($);
      case "u128":
        return dist$1.u128($);
      case "i128":
        return dist$1.i128($);
      case "u256":
        return dist$1.u256($);
      case "i256":
        return dist$1.i256($);
      case "bytes":
        return dist$1.vecU8($);
      case "string":
        return dist$1.str($);
      case "publicKey":
        return dist$1.publicKey($);
      default: {
        if ("vec" in e.type)
          return dist$1.vec(IdlCoder.fieldLayout({
            name: void 0,
            type: e.type.vec
          }, T), $);
        if ("option" in e.type)
          return dist$1.option(IdlCoder.fieldLayout({
            name: void 0,
            type: e.type.option
          }, T), $);
        if ("array" in e.type) {
          let V = e.type.array[0], J = e.type.array[1], ee = IdlCoder.fieldLayout({
            name: void 0,
            type: V
          }, T);
          return dist$1.array(ee, J, $);
        } else
          throw new Error(`Not yet implemented: ${e}`);
      }
    }
  }
}
class WormholeInstructionCoder {
  constructor(e) {
    tt(this, "ixLayout");
    this.ixLayout = WormholeInstructionCoder.parseIxLayout(e);
  }
  static parseIxLayout(e) {
    const $ = (e.instructions ? e.instructions : []).map((V) => {
      let J = V.args.map((te) => IdlCoder.fieldLayout(te, Array.from([...e.accounts ?? [], ...e.types ?? []])));
      const ee = camelCase$2(V.name);
      return [ee, dist$1.struct(J, ee)];
    }).concat(e.instructions.map((V) => {
      let J = V.args.map((te) => IdlCoder.fieldLayout(te, Array.from([...e.accounts ?? [], ...e.types ?? []])));
      const ee = camelCase$2(V.name);
      return [ee, dist$1.struct(J, ee)];
    }));
    return new Map($);
  }
  encode(e, T) {
    const $ = dist$2.Buffer.alloc(1e3), V = camelCase$2(e), J = this.ixLayout.get(V);
    if (!J)
      throw new Error(`Unknown method: ${V}`);
    const ee = J.encode(T, $), te = $.slice(0, ee);
    return encodeWormholeInstructionData(WormholeInstruction[upperFirst(V)], te);
  }
  encodeState(e, T) {
    throw new Error("Wormhole program does not have state");
  }
  decode(e, T = "hex") {
    var te;
    typeof e == "string" && (e = T === "hex" ? dist$2.Buffer.from(e, "hex") : b58.decode(e));
    let $ = dist$2.Buffer.from(e.slice(0, 1)).readInt8(), V = dist$2.Buffer.from(e.slice(1)), J = camelCase$2(WormholeInstruction[$] ?? "");
    return this.ixLayout.get(J) ? { data: (te = this.ixLayout.get(J)) == null ? void 0 : te.decode(V), name: J } : null;
  }
}
var WormholeInstruction;
(function(C) {
  C[C.Initialize = 0] = "Initialize", C[C.PostMessage = 1] = "PostMessage", C[C.PostVaa = 2] = "PostVaa", C[C.SetFees = 3] = "SetFees", C[C.TransferFees = 4] = "TransferFees", C[C.UpgradeContract = 5] = "UpgradeContract", C[C.UpgradeGuardianSet = 6] = "UpgradeGuardianSet", C[C.VerifySignatures = 7] = "VerifySignatures", C[C.PostMessageUnreliable = 8] = "PostMessageUnreliable";
})(WormholeInstruction || (WormholeInstruction = {}));
function encodeWormholeInstructionData(C, e) {
  const T = dist$2.Buffer.alloc(1 + (e === void 0 ? 0 : e.length));
  return T.writeUInt8(C, 0), e !== void 0 && T.write(e.toString("hex"), 1, "hex"), T;
}
class WormholeStateCoder {
  constructor(e) {
  }
  encode(e, T) {
    throw new Error("Wormhole program does not have state");
  }
  decode(e) {
    throw new Error("Wormhole program does not have state");
  }
}
class WormholeTypesCoder {
  constructor(e) {
  }
  encode(e, T) {
    throw new Error("Wormhole program does not have user-defined types");
  }
  decode(e, T) {
    throw new Error("Wormhole program does not have user-defined types");
  }
}
class WormholeCoder {
  constructor(e) {
    tt(this, "instruction");
    tt(this, "accounts");
    tt(this, "state");
    tt(this, "events");
    tt(this, "types");
    this.instruction = new WormholeInstructionCoder(e), this.accounts = new WormholeAccountsCoder(e), this.state = new WormholeStateCoder(e), this.events = new WormholeEventsCoder(e), this.types = new WormholeTypesCoder(e);
  }
}
const IDL$b = {
  version: "0.1.0",
  name: "wormhole",
  instructions: [
    {
      name: "initialize",
      accounts: [
        {
          name: "bridge",
          isMut: !0,
          isSigner: !1
        },
        {
          name: "guardianSet",
          isMut: !0,
          isSigner: !1
        },
        {
          name: "feeCollector",
          isMut: !0,
          isSigner: !1
        },
        {
          name: "payer",
          isMut: !0,
          isSigner: !0
        },
        {
          name: "clock",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "rent",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "systemProgram",
          isMut: !1,
          isSigner: !1
        }
      ],
      args: [
        {
          name: "guardianSetExpirationTime",
          type: "u32"
        },
        {
          name: "fee",
          type: "u64"
        },
        {
          name: "initialGuardians",
          type: {
            vec: {
              array: ["u8", 20]
            }
          }
        }
      ]
    },
    {
      name: "postMessage",
      accounts: [
        {
          name: "bridge",
          isMut: !0,
          isSigner: !1
        },
        {
          name: "message",
          isMut: !0,
          isSigner: !0
        },
        {
          name: "emitter",
          isMut: !1,
          isSigner: !0
        },
        {
          name: "sequence",
          isMut: !0,
          isSigner: !1
        },
        {
          name: "payer",
          isMut: !0,
          isSigner: !0
        },
        {
          name: "feeCollector",
          isMut: !0,
          isSigner: !1
        },
        {
          name: "clock",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "rent",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "systemProgram",
          isMut: !1,
          isSigner: !1
        }
      ],
      args: [
        {
          name: "nonce",
          type: "u32"
        },
        {
          name: "payload",
          type: "bytes"
        },
        {
          name: "consistencyLevel",
          type: "u8"
        }
      ]
    },
    {
      name: "postVaa",
      accounts: [
        {
          name: "guardianSet",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "bridge",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "signatureSet",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "vaa",
          isMut: !0,
          isSigner: !1
        },
        {
          name: "payer",
          isMut: !0,
          isSigner: !0
        },
        {
          name: "clock",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "rent",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "systemProgram",
          isMut: !1,
          isSigner: !1
        }
      ],
      args: [
        {
          name: "version",
          type: "u8"
        },
        {
          name: "guardianSetIndex",
          type: "u32"
        },
        {
          name: "timestamp",
          type: "u32"
        },
        {
          name: "nonce",
          type: "u32"
        },
        {
          name: "emitterChain",
          type: "u16"
        },
        {
          name: "emitterAddress",
          type: {
            array: ["u8", 32]
          }
        },
        {
          name: "sequence",
          type: "u64"
        },
        {
          name: "consistencyLevel",
          type: "u8"
        },
        {
          name: "payload",
          type: "bytes"
        }
      ]
    },
    {
      name: "setFees",
      accounts: [
        {
          name: "payer",
          isMut: !0,
          isSigner: !0
        },
        {
          name: "bridge",
          isMut: !0,
          isSigner: !1
        },
        {
          name: "vaa",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "claim",
          isMut: !0,
          isSigner: !1
        },
        {
          name: "systemProgram",
          isMut: !1,
          isSigner: !1
        }
      ],
      args: []
    },
    {
      name: "transferFees",
      accounts: [
        {
          name: "payer",
          isMut: !0,
          isSigner: !0
        },
        {
          name: "bridge",
          isMut: !0,
          isSigner: !1
        },
        {
          name: "vaa",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "claim",
          isMut: !0,
          isSigner: !1
        },
        {
          name: "feeCollector",
          isMut: !0,
          isSigner: !1
        },
        {
          name: "recipient",
          isMut: !0,
          isSigner: !1
        },
        {
          name: "rent",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "systemProgram",
          isMut: !1,
          isSigner: !1
        }
      ],
      args: []
    },
    {
      name: "upgradeContract",
      accounts: [
        {
          name: "payer",
          isMut: !0,
          isSigner: !0
        },
        {
          name: "bridge",
          isMut: !0,
          isSigner: !1
        },
        {
          name: "vaa",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "claim",
          isMut: !0,
          isSigner: !1
        },
        {
          name: "upgradeAuthority",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "spill",
          isMut: !0,
          isSigner: !1
        },
        {
          name: "implementation",
          isMut: !0,
          isSigner: !1
        },
        {
          name: "programData",
          isMut: !0,
          isSigner: !1
        },
        {
          name: "wormholeProgram",
          isMut: !0,
          isSigner: !1
        },
        {
          name: "rent",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "clock",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "bpfLoaderUpgradeable",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "systemProgram",
          isMut: !1,
          isSigner: !1
        }
      ],
      args: []
    },
    {
      name: "upgradeGuardianSet",
      accounts: [
        {
          name: "payer",
          isMut: !0,
          isSigner: !0
        },
        {
          name: "bridge",
          isMut: !0,
          isSigner: !1
        },
        {
          name: "vaa",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "claim",
          isMut: !0,
          isSigner: !1
        },
        {
          name: "guardianSetOld",
          isMut: !0,
          isSigner: !1
        },
        {
          name: "guardianSetNew",
          isMut: !0,
          isSigner: !1
        },
        {
          name: "systemProgram",
          isMut: !1,
          isSigner: !1
        }
      ],
      args: []
    },
    {
      name: "verifySignatures",
      accounts: [
        {
          name: "payer",
          isMut: !0,
          isSigner: !0
        },
        {
          name: "guardianSet",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "signatureSet",
          isMut: !0,
          isSigner: !0
        },
        {
          name: "instructions",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "rent",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "systemProgram",
          isMut: !1,
          isSigner: !1
        }
      ],
      args: [
        {
          name: "signatureStatus",
          type: {
            array: ["i8", 19]
          }
        }
      ]
    },
    {
      name: "postMessageUnreliable",
      accounts: [
        {
          name: "bridge",
          isMut: !0,
          isSigner: !1
        },
        {
          name: "message",
          isMut: !0,
          isSigner: !0
        },
        {
          name: "emitter",
          isMut: !1,
          isSigner: !0
        },
        {
          name: "sequence",
          isMut: !0,
          isSigner: !1
        },
        {
          name: "payer",
          isMut: !0,
          isSigner: !0
        },
        {
          name: "feeCollector",
          isMut: !0,
          isSigner: !1
        },
        {
          name: "clock",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "rent",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "systemProgram",
          isMut: !1,
          isSigner: !1
        }
      ],
      args: [
        {
          name: "nonce",
          type: "u32"
        },
        {
          name: "payload",
          type: "bytes"
        },
        {
          name: "consistencyLevel",
          type: "u8"
        }
      ]
    }
  ],
  accounts: [
    {
      name: "PostedMessage",
      type: {
        kind: "struct",
        fields: [
          {
            name: "vaaVersion",
            type: "u8"
          },
          {
            name: "consistencyLevel",
            type: "u8"
          },
          {
            name: "vaaTime",
            type: "u32"
          },
          {
            name: "vaaSignatureAccount",
            type: "publicKey"
          },
          {
            name: "submissionTime",
            type: "u32"
          },
          {
            name: "nonce",
            type: "u32"
          },
          {
            name: "sequence",
            type: "u64"
          },
          {
            name: "emitterChain",
            type: "u16"
          },
          {
            name: "emitterAddress",
            type: {
              array: ["u8", 32]
            }
          },
          {
            name: "payload",
            type: "bytes"
          }
        ]
      }
    },
    {
      name: "PostedVAA",
      type: {
        kind: "struct",
        fields: [
          {
            name: "vaaVersion",
            type: "u8"
          },
          {
            name: "consistencyLevel",
            type: "u8"
          },
          {
            name: "vaaTime",
            type: "u32"
          },
          {
            name: "vaaSignatureAccount",
            type: "publicKey"
          },
          {
            name: "submissionTime",
            type: "u32"
          },
          {
            name: "nonce",
            type: "u32"
          },
          {
            name: "sequence",
            type: "u64"
          },
          {
            name: "emitterChain",
            type: "u16"
          },
          {
            name: "emitterAddress",
            type: {
              array: ["u8", 32]
            }
          },
          {
            name: "payload",
            type: "bytes"
          }
        ]
      }
    }
  ]
};
function createWormholeProgramInterface(C, e) {
  return new Program(IDL$b, new PublicKey(C), e === void 0 ? { connection: null } : e, coder());
}
function createReadOnlyWormholeProgramInterface(C, e) {
  return createWormholeProgramInterface(C, createReadOnlyProvider(e));
}
function coder() {
  return new WormholeCoder(IDL$b);
}
function createSetFeesInstruction(C, e, T, $) {
  const V = createReadOnlyWormholeProgramInterface(e, C).methods.setFees();
  return V._ixFn(...V._args, {
    accounts: getSetFeesAccounts(e, T, $),
    signers: void 0,
    remainingAccounts: void 0,
    preInstructions: void 0,
    postInstructions: void 0
  });
}
function getSetFeesAccounts(C, e, T) {
  return {
    payer: new PublicKey(e),
    bridge: deriveWormholeBridgeDataKey(C),
    vaa: derivePostedVaaKey(C, dist$2.Buffer.from(T.hash)),
    claim: deriveClaimKey(C, T.emitterAddress.toString(), toChainId(T.emitterChain), T.sequence),
    systemProgram: SystemProgram.programId
  };
}
function createTransferFeesInstruction(C, e, T, $, V) {
  const J = createReadOnlyWormholeProgramInterface(e, C).methods.transferFees();
  return J._ixFn(...J._args, {
    accounts: getTransferFeesAccounts(e, T, $, V),
    signers: void 0,
    remainingAccounts: void 0,
    preInstructions: void 0,
    postInstructions: void 0
  });
}
function getTransferFeesAccounts(C, e, T, $) {
  return {
    payer: new PublicKey(e),
    bridge: deriveWormholeBridgeDataKey(C),
    vaa: derivePostedVaaKey(C, dist$2.Buffer.from($.hash)),
    claim: deriveClaimKey(C, $.emitterAddress.toString(), toChainId($.emitterChain), $.sequence),
    feeCollector: deriveFeeCollectorKey(C),
    recipient: new PublicKey(T),
    rent: SYSVAR_RENT_PUBKEY,
    systemProgram: SystemProgram.programId
  };
}
function createUpgradeGuardianSetInstruction(C, e, T, $) {
  const V = createReadOnlyWormholeProgramInterface(e, C).methods.upgradeGuardianSet();
  return V._ixFn(...V._args, {
    accounts: getUpgradeGuardianSetAccounts(e, T, $),
    signers: void 0,
    remainingAccounts: void 0,
    preInstructions: void 0,
    postInstructions: void 0
  });
}
function getUpgradeGuardianSetAccounts(C, e, T) {
  return {
    payer: new PublicKey(e),
    bridge: deriveWormholeBridgeDataKey(C),
    vaa: derivePostedVaaKey(C, dist$2.Buffer.from(T.hash)),
    claim: deriveClaimKey(C, T.emitterAddress.toString(), toChainId(T.emitterChain), T.sequence),
    guardianSetOld: deriveGuardianSetKey(C, T.guardianSet),
    guardianSetNew: deriveGuardianSetKey(C, T.guardianSet + 1),
    systemProgram: SystemProgram.programId
  };
}
function createUpgradeContractInstruction(C, e, T, $) {
  const V = createReadOnlyWormholeProgramInterface(e, C).methods.upgradeContract();
  return V._ixFn(...V._args, {
    accounts: getUpgradeContractAccounts(e, T, $),
    signers: void 0,
    remainingAccounts: void 0,
    preInstructions: void 0,
    postInstructions: void 0
  });
}
function getUpgradeContractAccounts(C, e, T, $) {
  const { newContract: V } = T.payload.actionArgs;
  return {
    payer: new PublicKey(e),
    bridge: deriveWormholeBridgeDataKey(C),
    vaa: derivePostedVaaKey(C, dist$2.Buffer.from(T.hash)),
    claim: deriveClaimKey(C, T.emitterAddress.toString(), toChainId(T.emitterChain), T.sequence),
    upgradeAuthority: deriveUpgradeAuthorityKey(C),
    spill: new PublicKey($ === void 0 ? e : $),
    implementation: new SolanaAddress(V).unwrap(),
    programData: deriveProgramDataAddress(C),
    wormholeProgram: new PublicKey(C),
    rent: SYSVAR_RENT_PUBKEY,
    clock: SYSVAR_CLOCK_PUBKEY,
    bpfLoaderUpgradeable: BPF_LOADER_UPGRADEABLE_PROGRAM_ID$1,
    systemProgram: SystemProgram.programId
  };
}
function createInitializeInstruction(C, e, T, $, V, J) {
  const ee = createReadOnlyWormholeProgramInterface(e, C).methods.initialize($, new BN(V.toString()), [
    ...J.map((te) => [...new Uint8Array(te)])
  ]);
  return ee._ixFn(...ee._args, {
    accounts: getInitializeAccounts(e, T),
    signers: void 0,
    remainingAccounts: void 0,
    preInstructions: void 0,
    postInstructions: void 0
  });
}
function getInitializeAccounts(C, e) {
  return {
    bridge: deriveWormholeBridgeDataKey(C),
    guardianSet: deriveGuardianSetKey(C, 0),
    feeCollector: deriveFeeCollectorKey(C),
    payer: new PublicKey(e),
    clock: SYSVAR_CLOCK_PUBKEY,
    rent: SYSVAR_RENT_PUBKEY,
    systemProgram: SystemProgram.programId
  };
}
function createPostMessageInstruction(C, e, T, $, V, J, ee) {
  const te = createReadOnlyWormholeProgramInterface(e, C).methods.postMessage(J, dist$2.Buffer.from(V), ee);
  return te._ixFn(...te._args, {
    accounts: getPostMessageAccounts(e, T, $),
    signers: void 0,
    remainingAccounts: void 0,
    preInstructions: void 0,
    postInstructions: void 0
  });
}
function getPostMessageAccounts(C, e, T, $) {
  let V;
  return $ ? { emitter: $, sequence: V } = getEmitterKeys($, C) : ($ = e, V = deriveEmitterSequenceKey($, C)), {
    bridge: deriveWormholeBridgeDataKey(C),
    message: new PublicKey(T),
    emitter: new PublicKey($),
    sequence: V,
    payer: new PublicKey(e),
    feeCollector: deriveFeeCollectorKey(C),
    clock: SYSVAR_CLOCK_PUBKEY,
    rent: SYSVAR_RENT_PUBKEY,
    systemProgram: SystemProgram.programId
  };
}
function createPostVaaInstruction(C, e, T, $, V) {
  const J = createReadOnlyWormholeProgramInterface(e, C).methods.postVaa(
    1,
    // TODO: hardcoded VAA version
    $.guardianSet,
    $.timestamp,
    $.nonce,
    toChainId($.emitterChain),
    [...$.emitterAddress.toUint8Array()],
    new BN($.sequence.toString()),
    $.consistencyLevel,
    // Note: This _must_ be a Buffer, a Uint8Array does not work
    dist$2.Buffer.from(serializePayload($.payloadLiteral, $.payload))
  );
  return J._ixFn(...J._args, {
    accounts: getPostVaaAccounts(e, T, V, $),
    signers: void 0,
    remainingAccounts: void 0,
    preInstructions: void 0,
    postInstructions: void 0
  });
}
function getPostVaaAccounts(C, e, T, $) {
  return {
    guardianSet: deriveGuardianSetKey(C, $.guardianSet),
    bridge: deriveWormholeBridgeDataKey(C),
    signatureSet: new PublicKey(T),
    vaa: derivePostedVaaKey(C, dist$2.Buffer.from($.hash)),
    payer: new PublicKey(e),
    clock: SYSVAR_CLOCK_PUBKEY,
    rent: SYSVAR_RENT_PUBKEY,
    systemProgram: SystemProgram.programId
  };
}
const MAX_LEN_GUARDIAN_KEYS = 19;
async function createVerifySignaturesInstructions(C, e, T, $, V, J) {
  const ee = $.guardianSet, te = await getGuardianSet(C, e, ee, J), re = $.signatures, ie = te.keys, se = 7, de = [];
  for (let ue = 0; ue < Math.ceil(re.length / se); ++ue) {
    const fe = ue * se, he = Math.min(re.length, (ue + 1) * se), me = new Array(MAX_LEN_GUARDIAN_KEYS).fill(-1), xe = [], ve = [];
    for (let Te = 0; Te < he - fe; ++Te) {
      const we = re.at(Te + fe);
      xe.push(dist$2.Buffer.from(we.signature.encode())), ve.push(ie.at(we.guardianIndex)), me[we.guardianIndex] = Te;
    }
    de.push(createSecp256k1Instruction(xe, ve, dist$2.Buffer.from($.hash))), de.push(createVerifySignaturesInstruction(C, e, T, $, V, me));
  }
  return de;
}
function createVerifySignaturesInstruction(C, e, T, $, V, J) {
  const ee = createReadOnlyWormholeProgramInterface(e, C).methods.verifySignatures(J);
  return ee._ixFn(...ee._args, {
    accounts: getVerifySignatureAccounts(e, T, V, $),
    signers: void 0,
    remainingAccounts: void 0,
    preInstructions: void 0,
    postInstructions: void 0
  });
}
function getVerifySignatureAccounts(C, e, T, $) {
  return {
    payer: new PublicKey(e),
    guardianSet: deriveGuardianSetKey(C, $.guardianSet),
    signatureSet: new PublicKey(T),
    instructions: SYSVAR_INSTRUCTIONS_PUBKEY,
    rent: SYSVAR_RENT_PUBKEY,
    systemProgram: SystemProgram.programId
  };
}
function getWormholeDerivedAccounts(C, e) {
  const { emitter: T, sequence: $ } = getEmitterKeys(C, e);
  return {
    wormholeBridge: deriveWormholeBridgeDataKey(e),
    wormholeEmitter: T,
    wormholeSequence: $,
    wormholeFeeCollector: deriveFeeCollectorKey(e)
  };
}
function getPostMessageCpiAccounts(C, e, T, $) {
  const V = getPostMessageAccounts(e, T, $, C);
  return {
    payer: V.payer,
    wormholeBridge: V.bridge,
    wormholeMessage: V.message,
    wormholeEmitter: V.emitter,
    wormholeSequence: V.sequence,
    wormholeFeeCollector: V.feeCollector,
    clock: V.clock,
    rent: V.rent,
    systemProgram: V.systemProgram
  };
}
const index$1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  BridgeConfig,
  BridgeData,
  GuardianSetData,
  SequenceTracker,
  SignatureSetData,
  coder,
  createBridgeFeeTransferInstruction,
  createInitializeInstruction,
  createPostMessageInstruction,
  createPostVaaInstruction,
  createReadOnlyWormholeProgramInterface,
  createSetFeesInstruction,
  createTransferFeesInstruction,
  createUpgradeContractInstruction,
  createUpgradeGuardianSetInstruction,
  createVerifySignaturesInstructions,
  createWormholeProgramInterface,
  deriveClaimKey,
  deriveEmitterSequenceKey,
  deriveFeeCollectorKey,
  deriveGuardianSetKey,
  derivePostedVaaKey,
  deriveUpgradeAuthorityKey,
  deriveWormholeBridgeDataKey,
  deriveWormholeEmitterKey,
  getClaim,
  getEmitterKeys,
  getGuardianSet,
  getInitializeAccounts,
  getPostMessageAccounts,
  getPostMessageCpiAccounts,
  getPostVaaAccounts,
  getProgramSequenceTracker,
  getSequenceTracker,
  getSetFeesAccounts,
  getSignatureSetData,
  getTransferFeesAccounts,
  getUpgradeContractAccounts,
  getUpgradeGuardianSetAccounts,
  getVerifySignatureAccounts,
  getWormholeBridgeData,
  getWormholeDerivedAccounts
}, Symbol.toStringTag, { value: "Module" })), SOLANA_SEQ_LOG = "Program log: Sequence: ";
class SolanaWormholeCore {
  constructor(e, T, $, V) {
    tt(this, "network");
    tt(this, "chain");
    tt(this, "connection");
    tt(this, "contracts");
    tt(this, "chainId");
    tt(this, "coreBridge");
    tt(this, "address");
    tt(this, "bridgeData");
    this.network = e, this.chain = T, this.connection = $, this.contracts = V, this.chainId = toChainId(T);
    const J = V.coreBridge;
    if (!J)
      throw new Error(`CoreBridge contract Address for chain ${T} not found`);
    this.address = J, this.coreBridge = createReadOnlyWormholeProgramInterface(J, $);
  }
  async getGuardianSet(e) {
    const T = await getGuardianSet(this.connection, this.coreBridge.programId, e);
    return {
      index: T.index,
      keys: T.keys.map(($) => $.toString("hex")),
      expiry: BigInt(T.expirationTime)
    };
  }
  static async fromRpc(e, T) {
    const [$, V] = await SolanaPlatform.chainFromRpc(e), J = T[V];
    if (J.network !== $)
      throw new Error(`Network mismatch for chain ${V}: ${J.network} != ${$}`);
    return new SolanaWormholeCore($, V, e, T[V].contracts);
  }
  async ensureBridgeConfig() {
    this.bridgeData || (this.bridgeData = await getWormholeBridgeData(this.connection, this.coreBridge.programId));
  }
  async getMessageFee() {
    return await this.ensureBridgeConfig(), this.bridgeData.config.fee;
  }
  async getGuardianSetIndex() {
    return await this.ensureBridgeConfig(), this.bridgeData.guardianSetIndex;
  }
  async *publishMessage(e, T, $, V) {
    const J = Keypair.generate(), ee = new SolanaAddress(e).unwrap(), te = createPostMessageInstruction(this.connection, this.coreBridge.programId, ee, J.publicKey, T, $, V), re = await this.getMessageFee(), ie = createBridgeFeeTransferInstruction(this.coreBridge.programId, ee, re), se = new Transaction();
    se.feePayer = ee, se.add(ie, te), yield this.createUnsignedTx({ transaction: se, signers: [J] }, "Core.PublishMessage");
  }
  async *verifyMessage(e, T) {
    yield* this.postVaa(e, T);
  }
  async *postVaa(e, T) {
    const $ = derivePostedVaaKey(this.coreBridge.programId, dist$2.Buffer.from(T.hash));
    if (await this.connection.getAccountInfo($))
      return;
    const J = new SolanaAddress(e).unwrap(), ee = Keypair.generate(), te = await createVerifySignaturesInstructions(this.connection, this.coreBridge.programId, J, T, ee.publicKey);
    for (let ie = 0; ie < te.length; ie += 2) {
      const se = new Transaction().add(...te.slice(ie, ie + 2));
      se.feePayer = J, yield this.createUnsignedTx({ transaction: se, signers: [ee] }, "Core.VerifySignature", !0);
    }
    const re = new Transaction().add(createPostVaaInstruction(this.connection, this.coreBridge.programId, J, T, ee.publicKey));
    re.feePayer = J, yield this.createUnsignedTx({ transaction: re }, "Core.PostVAA");
  }
  static parseSequenceFromLog(e, T) {
    var re, ie, se, de;
    const { meta: $, transaction: { message: V } } = T;
    if (!((re = $ == null ? void 0 : $.innerInstructions) != null && re.length))
      return [];
    const J = V.staticAccountKeys;
    if (J.filter((ue) => ue.toString() === e).length === 0)
      return [];
    const ee = (de = (se = (ie = $ == null ? void 0 : $.logMessages) == null ? void 0 : ie.filter((ue) => ue.startsWith(SOLANA_SEQ_LOG))) == null ? void 0 : se[0]) == null ? void 0 : de.replace(SOLANA_SEQ_LOG, "");
    if (!ee)
      return [];
    const te = [];
    for (const ue of $ == null ? void 0 : $.innerInstructions) {
      const fe = ue.instructions;
      te.push(...fe.filter((he) => he.programIdIndex in J && J[he.programIdIndex].toString() === e));
    }
    return te.length < 1 ? [] : J.length < 3 ? [] : te.map((ue) => [new SolanaAddress(J[ue.accounts[2]]).toUniversalAddress(), BigInt(ee)]).filter((ue) => ue !== null);
  }
  async getMessageAccountKeys(e) {
    let T;
    if (typeof e.transaction.message.version != "string")
      if (e.meta.loadedAddresses)
        T = e.transaction.message.getAccountKeys({
          accountKeysFromLookups: e.meta.loadedAddresses
        });
      else {
        const $ = await Promise.all(e.transaction.message.addressTableLookups.map(async (V) => {
          const J = await this.connection.getAddressLookupTable(V.accountKey);
          if (!J || !J.value)
            throw new Error("Could not resolve lookup table: " + V.accountKey.toBase58());
          return J.value;
        }));
        T = e.transaction.message.getAccountKeys({
          addressLookupTableAccounts: $
        });
      }
    else
      T = e.transaction.message.getAccountKeys();
    return T;
  }
  async findInstructions(e, T) {
    var re;
    const { meta: $, transaction: { message: V } } = T, J = this.coreBridge.programId, ee = (re = $.innerInstructions) == null ? void 0 : re.flatMap((ie) => ie.instructions.filter(
      // find the instructions where the programId equals the Wormhole ProgramId
      (se) => J.toString() === e.get(se.programIdIndex).toString()
    )).map((ie) => ({
      programIdIndex: ie.programIdIndex,
      accountKeyIndexes: ie.accounts
    })), te = V.compiledInstructions.filter((ie) => J.toString() === e.get(ie.programIdIndex).toString());
    return [...ee, ...te];
  }
  async parsePostMessageAccount(e) {
    const T = await this.connection.getAccountInfo(e);
    if (!(T != null && T.data))
      throw new Error("No data found in message account");
    const { timestamp: $, emitterAddress: V, emitterChain: J, consistencyLevel: ee, sequence: te, nonce: re, payload: ie } = deserializePostMessage(new Uint8Array(T == null ? void 0 : T.data));
    return createVAA("Uint8Array", {
      guardianSet: await this.getGuardianSetIndex(),
      emitterChain: toChain(J),
      timestamp: $,
      emitterAddress: V,
      consistencyLevel: ee,
      sequence: te,
      nonce: re,
      payload: ie,
      signatures: []
    });
  }
  async parseTransaction(e) {
    const T = await this.connection.getTransaction(e, {
      maxSupportedTransactionVersion: 0
    });
    if (!T || !T.meta || !T.meta.innerInstructions)
      throw new Error("transaction not found");
    try {
      const ee = SolanaWormholeCore.parseSequenceFromLog(this.coreBridge.programId.toBase58(), T);
      if (ee.length > 0) {
        const [te, re] = ee[0];
        return [
          {
            chain: this.chain,
            emitter: te,
            sequence: re
          }
        ];
      }
    } catch {
    }
    const $ = await this.getMessageAccountKeys(T), V = await this.findInstructions($, T);
    if (!V || V.length === 0)
      throw new Error("no bridge messages found");
    const J = V.map(async (ee) => {
      const te = $.get(ee.accountKeyIndexes[1]), re = await this.parsePostMessageAccount(te);
      return {
        chain: re.emitterChain,
        emitter: re.emitterAddress,
        sequence: re.sequence
      };
    });
    return await Promise.all(J);
  }
  async parseMessages(e) {
    const T = await this.connection.getTransaction(e, {
      maxSupportedTransactionVersion: 0
    });
    if (!T || !T.meta || !T.meta.innerInstructions)
      throw new Error("transaction not found");
    const $ = await this.getMessageAccountKeys(T), V = await this.findInstructions($, T);
    if (!V || V.length === 0)
      throw new Error("no bridge messages found");
    const J = V.map(async (ee) => {
      const te = $.get(ee.accountKeyIndexes[1]);
      return await this.parsePostMessageAccount(te);
    });
    return await Promise.all(J);
  }
  createUnsignedTx(e, T, $ = !1) {
    return new SolanaUnsignedTransaction(e, this.network, this.chain, T, $);
  }
}
registerProtocol(_platform, "WormholeCore", SolanaWormholeCore);
const index = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  IDL: IDL$b,
  SolanaWormholeCore,
  deserializePostMessage,
  postMessageLayout,
  utils: index$1
}, Symbol.toStringTag, { value: "Module" })), IDL$a = {
  version: "1.0.0",
  name: "example_native_token_transfers",
  instructions: [
    {
      name: "initialize",
      accounts: [
        {
          name: "payer",
          isMut: !0,
          isSigner: !0
        },
        {
          name: "deployer",
          isMut: !1,
          isSigner: !0
        },
        {
          name: "programData",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "config",
          isMut: !0,
          isSigner: !1
        },
        {
          name: "mint",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "rateLimit",
          isMut: !0,
          isSigner: !1
        },
        {
          name: "tokenAuthority",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "custody",
          isMut: !0,
          isSigner: !1,
          docs: [
            "The custody account that holds tokens in locking mode.",
            "NOTE: the account is unconditionally initialized, but not used in",
            "burning mode.",
            "function if  the token account has already been created."
          ]
        },
        {
          name: "tokenProgram",
          isMut: !1,
          isSigner: !1,
          docs: ["associated token account for the given mint."]
        },
        {
          name: "associatedTokenProgram",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "bpfLoaderUpgradeableProgram",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "systemProgram",
          isMut: !1,
          isSigner: !1
        }
      ],
      args: [
        {
          name: "args",
          type: {
            defined: "InitializeArgs"
          }
        }
      ]
    },
    {
      name: "version",
      accounts: [],
      args: [],
      returns: "string"
    },
    {
      name: "transferBurn",
      accounts: [
        {
          name: "common",
          accounts: [
            {
              name: "payer",
              isMut: !0,
              isSigner: !0
            },
            {
              name: "config",
              accounts: [
                {
                  name: "config",
                  isMut: !1,
                  isSigner: !1
                }
              ]
            },
            {
              name: "mint",
              isMut: !0,
              isSigner: !1
            },
            {
              name: "from",
              isMut: !0,
              isSigner: !1,
              docs: ["account can spend these tokens."]
            },
            {
              name: "tokenProgram",
              isMut: !1,
              isSigner: !1
            },
            {
              name: "outboxItem",
              isMut: !0,
              isSigner: !0
            },
            {
              name: "outboxRateLimit",
              isMut: !0,
              isSigner: !1
            },
            {
              name: "systemProgram",
              isMut: !1,
              isSigner: !1
            }
          ]
        },
        {
          name: "inboxRateLimit",
          isMut: !0,
          isSigner: !1
        },
        {
          name: "peer",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "sessionAuthority",
          isMut: !1,
          isSigner: !1
        }
      ],
      args: [
        {
          name: "args",
          type: {
            defined: "TransferArgs"
          }
        }
      ]
    },
    {
      name: "transferLock",
      accounts: [
        {
          name: "common",
          accounts: [
            {
              name: "payer",
              isMut: !0,
              isSigner: !0
            },
            {
              name: "config",
              accounts: [
                {
                  name: "config",
                  isMut: !1,
                  isSigner: !1
                }
              ]
            },
            {
              name: "mint",
              isMut: !0,
              isSigner: !1
            },
            {
              name: "from",
              isMut: !0,
              isSigner: !1,
              docs: ["account can spend these tokens."]
            },
            {
              name: "tokenProgram",
              isMut: !1,
              isSigner: !1
            },
            {
              name: "outboxItem",
              isMut: !0,
              isSigner: !0
            },
            {
              name: "outboxRateLimit",
              isMut: !0,
              isSigner: !1
            },
            {
              name: "systemProgram",
              isMut: !1,
              isSigner: !1
            }
          ]
        },
        {
          name: "inboxRateLimit",
          isMut: !0,
          isSigner: !1
        },
        {
          name: "peer",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "sessionAuthority",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "custody",
          isMut: !0,
          isSigner: !1
        }
      ],
      args: [
        {
          name: "args",
          type: {
            defined: "TransferArgs"
          }
        }
      ]
    },
    {
      name: "redeem",
      accounts: [
        {
          name: "payer",
          isMut: !0,
          isSigner: !0
        },
        {
          name: "config",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "peer",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "transceiverMessage",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "transceiver",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "mint",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "inboxItem",
          isMut: !0,
          isSigner: !1,
          docs: [
            "NOTE: This account is content-addressed (PDA seeded by the message hash).",
            "This is because in a multi-transceiver configuration, the different",
            'transceivers "vote" on messages (by delivering them). By making the inbox',
            "items content-addressed, we can ensure that disagreeing votes don't",
            "interfere with each other.",
            "On the first call to [`redeem()`], [`InboxItem`] will be allocated and initialized with",
            "default values.",
            'On subsequent calls, we want to modify the `InboxItem` by "voting" on it. Therefore the',
            "program should not fail which would occur when using the `init` constraint.",
            "The [`InboxItem::init`] field is used to guard against malicious or accidental modification",
            "InboxItem fields that should remain constant."
          ]
        },
        {
          name: "inboxRateLimit",
          isMut: !0,
          isSigner: !1
        },
        {
          name: "outboxRateLimit",
          isMut: !0,
          isSigner: !1
        },
        {
          name: "systemProgram",
          isMut: !1,
          isSigner: !1
        }
      ],
      args: [
        {
          name: "args",
          type: {
            defined: "RedeemArgs"
          }
        }
      ]
    },
    {
      name: "releaseInboundMint",
      accounts: [
        {
          name: "common",
          accounts: [
            {
              name: "payer",
              isMut: !0,
              isSigner: !0
            },
            {
              name: "config",
              accounts: [
                {
                  name: "config",
                  isMut: !1,
                  isSigner: !1
                }
              ]
            },
            {
              name: "inboxItem",
              isMut: !0,
              isSigner: !1
            },
            {
              name: "recipient",
              isMut: !0,
              isSigner: !1
            },
            {
              name: "tokenAuthority",
              isMut: !1,
              isSigner: !1
            },
            {
              name: "mint",
              isMut: !0,
              isSigner: !1
            },
            {
              name: "tokenProgram",
              isMut: !1,
              isSigner: !1
            }
          ]
        }
      ],
      args: [
        {
          name: "args",
          type: {
            defined: "ReleaseInboundArgs"
          }
        }
      ]
    },
    {
      name: "releaseInboundUnlock",
      accounts: [
        {
          name: "common",
          accounts: [
            {
              name: "payer",
              isMut: !0,
              isSigner: !0
            },
            {
              name: "config",
              accounts: [
                {
                  name: "config",
                  isMut: !1,
                  isSigner: !1
                }
              ]
            },
            {
              name: "inboxItem",
              isMut: !0,
              isSigner: !1
            },
            {
              name: "recipient",
              isMut: !0,
              isSigner: !1
            },
            {
              name: "tokenAuthority",
              isMut: !1,
              isSigner: !1
            },
            {
              name: "mint",
              isMut: !0,
              isSigner: !1
            },
            {
              name: "tokenProgram",
              isMut: !1,
              isSigner: !1
            }
          ]
        },
        {
          name: "custody",
          isMut: !0,
          isSigner: !1
        }
      ],
      args: [
        {
          name: "args",
          type: {
            defined: "ReleaseInboundArgs"
          }
        }
      ]
    },
    {
      name: "transferOwnership",
      accounts: [
        {
          name: "config",
          isMut: !0,
          isSigner: !1
        },
        {
          name: "owner",
          isMut: !1,
          isSigner: !0
        },
        {
          name: "newOwner",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "upgradeLock",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "programData",
          isMut: !0,
          isSigner: !1
        },
        {
          name: "bpfLoaderUpgradeableProgram",
          isMut: !1,
          isSigner: !1
        }
      ],
      args: []
    },
    {
      name: "claimOwnership",
      accounts: [
        {
          name: "config",
          isMut: !0,
          isSigner: !1
        },
        {
          name: "upgradeLock",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "newOwner",
          isMut: !1,
          isSigner: !0
        },
        {
          name: "programData",
          isMut: !0,
          isSigner: !1
        },
        {
          name: "bpfLoaderUpgradeableProgram",
          isMut: !1,
          isSigner: !1
        }
      ],
      args: []
    },
    {
      name: "setPaused",
      accounts: [
        {
          name: "owner",
          isMut: !1,
          isSigner: !0
        },
        {
          name: "config",
          isMut: !0,
          isSigner: !1
        }
      ],
      args: [
        {
          name: "pause",
          type: "bool"
        }
      ]
    },
    {
      name: "setPeer",
      accounts: [
        {
          name: "payer",
          isMut: !0,
          isSigner: !0
        },
        {
          name: "owner",
          isMut: !1,
          isSigner: !0
        },
        {
          name: "config",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "peer",
          isMut: !0,
          isSigner: !1
        },
        {
          name: "inboxRateLimit",
          isMut: !0,
          isSigner: !1
        },
        {
          name: "systemProgram",
          isMut: !1,
          isSigner: !1
        }
      ],
      args: [
        {
          name: "args",
          type: {
            defined: "SetPeerArgs"
          }
        }
      ]
    },
    {
      name: "registerTransceiver",
      accounts: [
        {
          name: "config",
          isMut: !0,
          isSigner: !1
        },
        {
          name: "owner",
          isMut: !1,
          isSigner: !0
        },
        {
          name: "payer",
          isMut: !0,
          isSigner: !0
        },
        {
          name: "transceiver",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "registeredTransceiver",
          isMut: !0,
          isSigner: !1
        },
        {
          name: "systemProgram",
          isMut: !1,
          isSigner: !1
        }
      ],
      args: []
    },
    {
      name: "setOutboundLimit",
      accounts: [
        {
          name: "config",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "owner",
          isMut: !1,
          isSigner: !0
        },
        {
          name: "rateLimit",
          isMut: !0,
          isSigner: !1
        }
      ],
      args: [
        {
          name: "args",
          type: {
            defined: "SetOutboundLimitArgs"
          }
        }
      ]
    },
    {
      name: "setInboundLimit",
      accounts: [
        {
          name: "config",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "owner",
          isMut: !1,
          isSigner: !0
        },
        {
          name: "rateLimit",
          isMut: !0,
          isSigner: !1
        }
      ],
      args: [
        {
          name: "args",
          type: {
            defined: "SetInboundLimitArgs"
          }
        }
      ]
    },
    {
      name: "setWormholePeer",
      accounts: [
        {
          name: "config",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "owner",
          isMut: !1,
          isSigner: !0
        },
        {
          name: "payer",
          isMut: !0,
          isSigner: !0
        },
        {
          name: "peer",
          isMut: !0,
          isSigner: !1
        },
        {
          name: "systemProgram",
          isMut: !1,
          isSigner: !1
        }
      ],
      args: [
        {
          name: "args",
          type: {
            defined: "SetTransceiverPeerArgs"
          }
        }
      ]
    },
    {
      name: "receiveWormholeMessage",
      accounts: [
        {
          name: "payer",
          isMut: !0,
          isSigner: !0
        },
        {
          name: "config",
          accounts: [
            {
              name: "config",
              isMut: !1,
              isSigner: !1
            }
          ]
        },
        {
          name: "peer",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "vaa",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "transceiverMessage",
          isMut: !0,
          isSigner: !1
        },
        {
          name: "systemProgram",
          isMut: !1,
          isSigner: !1
        }
      ],
      args: []
    },
    {
      name: "releaseWormholeOutbound",
      accounts: [
        {
          name: "payer",
          isMut: !0,
          isSigner: !0
        },
        {
          name: "config",
          accounts: [
            {
              name: "config",
              isMut: !1,
              isSigner: !1
            }
          ]
        },
        {
          name: "outboxItem",
          isMut: !0,
          isSigner: !1
        },
        {
          name: "transceiver",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "wormholeMessage",
          isMut: !0,
          isSigner: !1
        },
        {
          name: "emitter",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "wormhole",
          accounts: [
            {
              name: "bridge",
              isMut: !0,
              isSigner: !1
            },
            {
              name: "feeCollector",
              isMut: !0,
              isSigner: !1
            },
            {
              name: "sequence",
              isMut: !0,
              isSigner: !1
            },
            {
              name: "program",
              isMut: !1,
              isSigner: !1
            },
            {
              name: "systemProgram",
              isMut: !1,
              isSigner: !1
            },
            {
              name: "clock",
              isMut: !1,
              isSigner: !1
            },
            {
              name: "rent",
              isMut: !1,
              isSigner: !1
            }
          ]
        }
      ],
      args: [
        {
          name: "args",
          type: {
            defined: "ReleaseOutboundArgs"
          }
        }
      ]
    },
    {
      name: "broadcastWormholeId",
      accounts: [
        {
          name: "payer",
          isMut: !0,
          isSigner: !0
        },
        {
          name: "config",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "mint",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "wormholeMessage",
          isMut: !0,
          isSigner: !0
        },
        {
          name: "emitter",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "wormhole",
          accounts: [
            {
              name: "bridge",
              isMut: !0,
              isSigner: !1
            },
            {
              name: "feeCollector",
              isMut: !0,
              isSigner: !1
            },
            {
              name: "sequence",
              isMut: !0,
              isSigner: !1
            },
            {
              name: "program",
              isMut: !1,
              isSigner: !1
            },
            {
              name: "systemProgram",
              isMut: !1,
              isSigner: !1
            },
            {
              name: "clock",
              isMut: !1,
              isSigner: !1
            },
            {
              name: "rent",
              isMut: !1,
              isSigner: !1
            }
          ]
        }
      ],
      args: []
    },
    {
      name: "broadcastWormholePeer",
      accounts: [
        {
          name: "payer",
          isMut: !0,
          isSigner: !0
        },
        {
          name: "config",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "peer",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "wormholeMessage",
          isMut: !0,
          isSigner: !0
        },
        {
          name: "emitter",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "wormhole",
          accounts: [
            {
              name: "bridge",
              isMut: !0,
              isSigner: !1
            },
            {
              name: "feeCollector",
              isMut: !0,
              isSigner: !1
            },
            {
              name: "sequence",
              isMut: !0,
              isSigner: !1
            },
            {
              name: "program",
              isMut: !1,
              isSigner: !1
            },
            {
              name: "systemProgram",
              isMut: !1,
              isSigner: !1
            },
            {
              name: "clock",
              isMut: !1,
              isSigner: !1
            },
            {
              name: "rent",
              isMut: !1,
              isSigner: !1
            }
          ]
        }
      ],
      args: [
        {
          name: "args",
          type: {
            defined: "BroadcastPeerArgs"
          }
        }
      ]
    }
  ],
  accounts: [
    {
      name: "config",
      type: {
        kind: "struct",
        fields: [
          {
            name: "bump",
            type: "u8"
          },
          {
            name: "owner",
            docs: ["Owner of the program."],
            type: "publicKey"
          },
          {
            name: "pendingOwner",
            docs: ["Pending next owner (before claiming ownership)."],
            type: {
              option: "publicKey"
            }
          },
          {
            name: "mint",
            docs: ["Mint address of the token managed by this program."],
            type: "publicKey"
          },
          {
            name: "tokenProgram",
            docs: [
              "Address of the token program (token or token22). This could always be queried",
              "from the [`mint`] account's owner, but storing it here avoids an indirection",
              "on the client side."
            ],
            type: "publicKey"
          },
          {
            name: "mode",
            docs: [
              "The mode that this program is running in. This is used to determine",
              "whether the program is burning tokens or locking tokens."
            ],
            type: {
              defined: "Mode"
            }
          },
          {
            name: "chainId",
            docs: [
              "The chain id of the chain that this program is running on. We don't",
              "hardcode this so that the program is deployable on any potential SVM",
              "forks."
            ],
            type: {
              defined: "ChainId"
            }
          },
          {
            name: "nextTransceiverId",
            docs: [
              "The next transceiver id to use when registering an transceiver."
            ],
            type: "u8"
          },
          {
            name: "threshold",
            docs: [
              "The number of transceivers that must attest to a transfer before it is",
              "accepted."
            ],
            type: "u8"
          },
          {
            name: "enabledTransceivers",
            docs: [
              "Bitmap of enabled transceivers.",
              "The maximum number of transceivers is equal to [`Bitmap::BITS`]."
            ],
            type: {
              defined: "Bitmap"
            }
          },
          {
            name: "paused",
            docs: [
              "Pause the program. This is useful for upgrades and other maintenance."
            ],
            type: "bool"
          },
          {
            name: "custody",
            docs: ["The custody account that holds tokens in locking mode."],
            type: "publicKey"
          }
        ]
      }
    },
    {
      name: "nttManagerPeer",
      docs: [
        "A peer on another chain. Stored in a PDA seeded by the chain id."
      ],
      type: {
        kind: "struct",
        fields: [
          {
            name: "bump",
            type: "u8"
          },
          {
            name: "address",
            type: {
              array: ["u8", 32]
            }
          },
          {
            name: "tokenDecimals",
            type: "u8"
          }
        ]
      }
    },
    {
      name: "inboxItem",
      type: {
        kind: "struct",
        fields: [
          {
            name: "init",
            type: "bool"
          },
          {
            name: "bump",
            type: "u8"
          },
          {
            name: "amount",
            type: "u64"
          },
          {
            name: "recipientAddress",
            type: "publicKey"
          },
          {
            name: "votes",
            type: {
              defined: "Bitmap"
            }
          },
          {
            name: "releaseStatus",
            type: {
              defined: "ReleaseStatus"
            }
          }
        ]
      }
    },
    {
      name: "inboxRateLimit",
      docs: [
        "Inbound rate limit per chain.",
        "SECURITY: must check the PDA (since there are multiple PDAs, namely one for each chain.)"
      ],
      type: {
        kind: "struct",
        fields: [
          {
            name: "bump",
            type: "u8"
          },
          {
            name: "rateLimit",
            type: {
              defined: "RateLimitState"
            }
          }
        ]
      }
    },
    {
      name: "outboxItem",
      type: {
        kind: "struct",
        fields: [
          {
            name: "amount",
            type: {
              defined: "TrimmedAmount"
            }
          },
          {
            name: "sender",
            type: "publicKey"
          },
          {
            name: "recipientChain",
            type: {
              defined: "ChainId"
            }
          },
          {
            name: "recipientNttManager",
            type: {
              array: ["u8", 32]
            }
          },
          {
            name: "recipientAddress",
            type: {
              array: ["u8", 32]
            }
          },
          {
            name: "releaseTimestamp",
            type: "i64"
          },
          {
            name: "released",
            type: {
              defined: "Bitmap"
            }
          }
        ]
      }
    },
    {
      name: "outboxRateLimit",
      type: {
        kind: "struct",
        fields: [
          {
            name: "rateLimit",
            type: {
              defined: "RateLimitState"
            }
          }
        ]
      }
    },
    {
      name: "registeredTransceiver",
      type: {
        kind: "struct",
        fields: [
          {
            name: "bump",
            type: "u8"
          },
          {
            name: "id",
            type: "u8"
          },
          {
            name: "transceiverAddress",
            type: "publicKey"
          }
        ]
      }
    },
    {
      name: "transceiverPeer",
      docs: [
        "A peer on another chain. Stored in a PDA seeded by the chain id."
      ],
      type: {
        kind: "struct",
        fields: [
          {
            name: "bump",
            type: "u8"
          },
          {
            name: "address",
            type: {
              array: ["u8", 32]
            }
          }
        ]
      }
    },
    {
      name: "bridgeData",
      type: {
        kind: "struct",
        fields: [
          {
            name: "guardianSetIndex",
            docs: [
              "The current guardian set index, used to decide which signature sets to accept."
            ],
            type: "u32"
          },
          {
            name: "lastLamports",
            docs: ["Lamports in the collection account"],
            type: "u64"
          },
          {
            name: "config",
            docs: [
              "Bridge configuration, which is set once upon initialization."
            ],
            type: {
              defined: "BridgeConfig"
            }
          }
        ]
      }
    }
  ],
  types: [
    {
      name: "Bitmap",
      type: {
        kind: "struct",
        fields: [
          {
            name: "map",
            type: "u128"
          }
        ]
      }
    },
    {
      name: "SetInboundLimitArgs",
      type: {
        kind: "struct",
        fields: [
          {
            name: "limit",
            type: "u64"
          },
          {
            name: "chainId",
            type: {
              defined: "ChainId"
            }
          }
        ]
      }
    },
    {
      name: "SetOutboundLimitArgs",
      type: {
        kind: "struct",
        fields: [
          {
            name: "limit",
            type: "u64"
          }
        ]
      }
    },
    {
      name: "SetPeerArgs",
      type: {
        kind: "struct",
        fields: [
          {
            name: "chainId",
            type: {
              defined: "ChainId"
            }
          },
          {
            name: "address",
            type: {
              array: ["u8", 32]
            }
          },
          {
            name: "limit",
            type: "u64"
          },
          {
            name: "tokenDecimals",
            docs: ["The token decimals on the peer chain."],
            type: "u8"
          }
        ]
      }
    },
    {
      name: "InitializeArgs",
      type: {
        kind: "struct",
        fields: [
          {
            name: "chainId",
            type: "u16"
          },
          {
            name: "limit",
            type: "u64"
          },
          {
            name: "mode",
            type: {
              defined: "Mode"
            }
          }
        ]
      }
    },
    {
      name: "RedeemArgs",
      type: {
        kind: "struct",
        fields: []
      }
    },
    {
      name: "ReleaseInboundArgs",
      type: {
        kind: "struct",
        fields: [
          {
            name: "revertOnDelay",
            type: "bool"
          }
        ]
      }
    },
    {
      name: "TransferArgs",
      type: {
        kind: "struct",
        fields: [
          {
            name: "amount",
            type: "u64"
          },
          {
            name: "recipientChain",
            type: {
              defined: "ChainId"
            }
          },
          {
            name: "recipientAddress",
            type: {
              array: ["u8", 32]
            }
          },
          {
            name: "shouldQueue",
            type: "bool"
          }
        ]
      }
    },
    {
      name: "ReleaseStatus",
      docs: [
        "The status of an InboxItem. This determines whether the tokens are minted/unlocked to the recipient. As",
        "such, this must be used as a state machine that moves forward in a linear manner. A state",
        'should never "move backward" to a previous state (e.g. should never move from `Released` to',
        "`ReleaseAfter`)."
      ],
      type: {
        kind: "enum",
        variants: [
          {
            name: "NotApproved"
          },
          {
            name: "ReleaseAfter",
            fields: ["i64"]
          },
          {
            name: "Released"
          }
        ]
      }
    },
    {
      name: "RateLimitState",
      type: {
        kind: "struct",
        fields: [
          {
            name: "limit",
            docs: ["The maximum capacity of the rate limiter."],
            type: "u64"
          },
          {
            name: "capacityAtLastTx",
            docs: [
              "The capacity of the rate limiter at `last_tx_timestamp`.",
              "The actual current capacity is calculated in `capacity_at`, by",
              "accounting for the time that has passed since `last_tx_timestamp` and",
              "the refill rate."
            ],
            type: "u64"
          },
          {
            name: "lastTxTimestamp",
            docs: [
              "The timestamp of the last transaction that counted towards the current",
              "capacity. Transactions that exceeded the capacity do not count, they are",
              "just delayed."
            ],
            type: "i64"
          }
        ]
      }
    },
    {
      name: "SetTransceiverPeerArgs",
      type: {
        kind: "struct",
        fields: [
          {
            name: "chainId",
            type: {
              defined: "ChainId"
            }
          },
          {
            name: "address",
            type: {
              array: ["u8", 32]
            }
          }
        ]
      }
    },
    {
      name: "BroadcastPeerArgs",
      type: {
        kind: "struct",
        fields: [
          {
            name: "chainId",
            type: "u16"
          }
        ]
      }
    },
    {
      name: "ReleaseOutboundArgs",
      type: {
        kind: "struct",
        fields: [
          {
            name: "revertOnDelay",
            type: "bool"
          }
        ]
      }
    },
    {
      name: "ChainId",
      type: {
        kind: "struct",
        fields: [
          {
            name: "id",
            type: "u16"
          }
        ]
      }
    },
    {
      name: "Mode",
      type: {
        kind: "enum",
        variants: [
          {
            name: "Locking"
          },
          {
            name: "Burning"
          }
        ]
      }
    },
    {
      name: "TrimmedAmount",
      type: {
        kind: "struct",
        fields: [
          {
            name: "amount",
            type: "u64"
          },
          {
            name: "decimals",
            type: "u8"
          }
        ]
      }
    },
    {
      name: "BridgeConfig",
      type: {
        kind: "struct",
        fields: [
          {
            name: "guardianSetExpirationTime",
            docs: [
              "Period for how long a guardian set is valid after it has been replaced by a new one.  This",
              "guarantees that VAAs issued by that set can still be submitted for a certain period.  In",
              "this period we still trust the old guardian set."
            ],
            type: "u32"
          },
          {
            name: "fee",
            docs: [
              "Amount of lamports that needs to be paid to the protocol to post a message"
            ],
            type: "u64"
          }
        ]
      }
    }
  ],
  errors: [
    {
      code: 6e3,
      name: "CantReleaseYet",
      msg: "CantReleaseYet"
    },
    {
      code: 6001,
      name: "InvalidPendingOwner",
      msg: "InvalidPendingOwner"
    },
    {
      code: 6002,
      name: "InvalidChainId",
      msg: "InvalidChainId"
    },
    {
      code: 6003,
      name: "InvalidRecipientAddress",
      msg: "InvalidRecipientAddress"
    },
    {
      code: 6004,
      name: "InvalidTransceiverPeer",
      msg: "InvalidTransceiverPeer"
    },
    {
      code: 6005,
      name: "InvalidNttManagerPeer",
      msg: "InvalidNttManagerPeer"
    },
    {
      code: 6006,
      name: "InvalidRecipientNttManager",
      msg: "InvalidRecipientNttManager"
    },
    {
      code: 6007,
      name: "TransferAlreadyRedeemed",
      msg: "TransferAlreadyRedeemed"
    },
    {
      code: 6008,
      name: "TransferCannotBeRedeemed",
      msg: "TransferCannotBeRedeemed"
    },
    {
      code: 6009,
      name: "TransferNotApproved",
      msg: "TransferNotApproved"
    },
    {
      code: 6010,
      name: "MessageAlreadySent",
      msg: "MessageAlreadySent"
    },
    {
      code: 6011,
      name: "InvalidMode",
      msg: "InvalidMode"
    },
    {
      code: 6012,
      name: "InvalidMintAuthority",
      msg: "InvalidMintAuthority"
    },
    {
      code: 6013,
      name: "TransferExceedsRateLimit",
      msg: "TransferExceedsRateLimit"
    },
    {
      code: 6014,
      name: "Paused",
      msg: "Paused"
    },
    {
      code: 6015,
      name: "DisabledTransceiver",
      msg: "DisabledTransceiver"
    },
    {
      code: 6016,
      name: "InvalidDeployer",
      msg: "InvalidDeployer"
    },
    {
      code: 6017,
      name: "BadAmountAfterTransfer",
      msg: "BadAmountAfterTransfer"
    },
    {
      code: 6018,
      name: "BadAmountAfterBurn",
      msg: "BadAmountAfterBurn"
    },
    {
      code: 6019,
      name: "ZeroThreshold",
      msg: "ZeroThreshold"
    },
    {
      code: 6020,
      name: "OverflowExponent",
      msg: "OverflowExponent"
    },
    {
      code: 6021,
      name: "OverflowScaledAmount",
      msg: "OverflowScaledAmount"
    },
    {
      code: 6022,
      name: "BitmapIndexOutOfBounds",
      msg: "BitmapIndexOutOfBounds"
    }
  ]
}, IDL$9 = {
  version: "2.0.0",
  name: "ntt_quoter",
  instructions: [
    {
      name: "requestRelay",
      accounts: [
        {
          name: "payer",
          isMut: !0,
          isSigner: !0
        },
        {
          name: "instance",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "registeredChain",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "registeredNtt",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "outboxItem",
          isMut: !1,
          isSigner: !1,
          docs: [
            "and checking the release constraint into a single function"
          ]
        },
        {
          name: "relayRequest",
          isMut: !0,
          isSigner: !1
        },
        {
          name: "systemProgram",
          isMut: !1,
          isSigner: !1
        }
      ],
      args: [
        {
          name: "args",
          type: {
            defined: "RequestRelayArgs"
          }
        }
      ]
    },
    {
      name: "closeRelay",
      accounts: [
        {
          name: "authority",
          isMut: !1,
          isSigner: !0
        },
        {
          name: "instance",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "feeRecipient",
          isMut: !0,
          isSigner: !1
        },
        {
          name: "relayRequest",
          isMut: !0,
          isSigner: !1
        },
        {
          name: "systemProgram",
          isMut: !1,
          isSigner: !1
        }
      ],
      args: []
    },
    {
      name: "initialize",
      accounts: [
        {
          name: "owner",
          isMut: !0,
          isSigner: !0
        },
        {
          name: "instance",
          isMut: !0,
          isSigner: !1
        },
        {
          name: "feeRecipient",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "programData",
          isMut: !0,
          isSigner: !1,
          docs: [
            "We use the program data to make sure this owner is the upgrade authority (the true owner,",
            "who deployed this program)."
          ]
        },
        {
          name: "systemProgram",
          isMut: !1,
          isSigner: !1
        }
      ],
      args: []
    },
    {
      name: "setAssistant",
      accounts: [
        {
          name: "owner",
          isMut: !1,
          isSigner: !0
        },
        {
          name: "instance",
          isMut: !0,
          isSigner: !1
        },
        {
          name: "assistant",
          isMut: !1,
          isSigner: !1,
          isOptional: !0
        }
      ],
      args: []
    },
    {
      name: "setFeeRecipient",
      accounts: [
        {
          name: "owner",
          isMut: !1,
          isSigner: !0
        },
        {
          name: "instance",
          isMut: !0,
          isSigner: !1
        },
        {
          name: "feeRecipient",
          isMut: !1,
          isSigner: !1
        }
      ],
      args: []
    },
    {
      name: "registerChain",
      accounts: [
        {
          name: "authority",
          isMut: !0,
          isSigner: !0
        },
        {
          name: "instance",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "registeredChain",
          isMut: !0,
          isSigner: !1
        },
        {
          name: "systemProgram",
          isMut: !1,
          isSigner: !1
        }
      ],
      args: [
        {
          name: "args",
          type: {
            defined: "RegisterChainArgs"
          }
        }
      ]
    },
    {
      name: "registerNtt",
      accounts: [
        {
          name: "authority",
          isMut: !0,
          isSigner: !0
        },
        {
          name: "instance",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "registeredNtt",
          isMut: !0,
          isSigner: !1
        },
        {
          name: "systemProgram",
          isMut: !1,
          isSigner: !1
        }
      ],
      args: [
        {
          name: "args",
          type: {
            defined: "RegisterNttArgs"
          }
        }
      ]
    },
    {
      name: "deregisterNtt",
      accounts: [
        {
          name: "authority",
          isMut: !0,
          isSigner: !0
        },
        {
          name: "instance",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "registeredNtt",
          isMut: !0,
          isSigner: !1
        },
        {
          name: "systemProgram",
          isMut: !1,
          isSigner: !1
        }
      ],
      args: [
        {
          name: "args",
          type: {
            defined: "DeregisterNttArgs"
          }
        }
      ]
    },
    {
      name: "updateSolPrice",
      accounts: [
        {
          name: "authority",
          isMut: !1,
          isSigner: !0
        },
        {
          name: "instance",
          isMut: !0,
          isSigner: !1
        }
      ],
      args: [
        {
          name: "args",
          type: {
            defined: "UpdateSolPriceArgs"
          }
        }
      ]
    },
    {
      name: "updateChainPrices",
      accounts: [
        {
          name: "authority",
          isMut: !1,
          isSigner: !0
        },
        {
          name: "instance",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "registeredChain",
          isMut: !0,
          isSigner: !1
        }
      ],
      args: [
        {
          name: "args",
          type: {
            defined: "UpdateChainPricesArgs"
          }
        }
      ]
    },
    {
      name: "updateChainParams",
      accounts: [
        {
          name: "authority",
          isMut: !1,
          isSigner: !0
        },
        {
          name: "instance",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "registeredChain",
          isMut: !0,
          isSigner: !1
        }
      ],
      args: [
        {
          name: "args",
          type: {
            defined: "UpdateChainParamsArgs"
          }
        }
      ]
    }
  ],
  accounts: [
    {
      name: "instance",
      type: {
        kind: "struct",
        fields: [
          {
            name: "owner",
            type: "publicKey"
          },
          {
            name: "assistant",
            type: "publicKey"
          },
          {
            name: "feeRecipient",
            type: "publicKey"
          },
          {
            name: "solPrice",
            type: "u64"
          }
        ]
      }
    },
    {
      name: "registeredChain",
      type: {
        kind: "struct",
        fields: [
          {
            name: "bump",
            type: "u8"
          },
          {
            name: "maxGasDropoff",
            type: "u64"
          },
          {
            name: "basePrice",
            type: "u64"
          },
          {
            name: "nativePrice",
            type: "u64"
          },
          {
            name: "gasPrice",
            type: "u64"
          }
        ]
      }
    },
    {
      name: "registeredNtt",
      type: {
        kind: "struct",
        fields: [
          {
            name: "bump",
            type: "u8"
          },
          {
            name: "wormholeTransceiverIndex",
            type: "u8"
          },
          {
            name: "gasCost",
            type: "u32"
          }
        ]
      }
    },
    {
      name: "relayRequest",
      type: {
        kind: "struct",
        fields: [
          {
            name: "requestedGasDropoff",
            type: "u64"
          }
        ]
      }
    }
  ],
  types: [
    {
      name: "RegisterChainArgs",
      type: {
        kind: "struct",
        fields: [
          {
            name: "chainId",
            type: "u16"
          }
        ]
      }
    },
    {
      name: "RegisterNttArgs",
      type: {
        kind: "struct",
        fields: [
          {
            name: "nttProgramId",
            type: "publicKey"
          },
          {
            name: "wormholeTransceiverIndex",
            type: "u8"
          },
          {
            name: "gasCost",
            type: "u32"
          }
        ]
      }
    },
    {
      name: "DeregisterNttArgs",
      type: {
        kind: "struct",
        fields: [
          {
            name: "nttProgramId",
            type: "publicKey"
          }
        ]
      }
    },
    {
      name: "RequestRelayArgs",
      type: {
        kind: "struct",
        fields: [
          {
            name: "gasDropoff",
            type: "u64"
          },
          {
            name: "maxFee",
            type: "u64"
          }
        ]
      }
    },
    {
      name: "UpdateSolPriceArgs",
      type: {
        kind: "struct",
        fields: [
          {
            name: "solPrice",
            type: "u64"
          }
        ]
      }
    },
    {
      name: "UpdateChainPricesArgs",
      type: {
        kind: "struct",
        fields: [
          {
            name: "nativePrice",
            type: "u64"
          },
          {
            name: "gasPrice",
            type: "u64"
          }
        ]
      }
    },
    {
      name: "UpdateChainParamsArgs",
      type: {
        kind: "struct",
        fields: [
          {
            name: "maxGasDropoff",
            type: "u64"
          },
          {
            name: "basePrice",
            type: "u64"
          }
        ]
      }
    }
  ],
  errors: [
    {
      code: 6001,
      name: "ExceedsUserMaxFee",
      msg: "Relay fees exceeds specified max"
    },
    {
      code: 6002,
      name: "ExceedsMaxGasDropoff",
      msg: "Requested gas dropoff exceeds max allowed for chain"
    },
    {
      code: 6003,
      name: "InvalidFeeRecipient",
      msg: "The specified fee recipient does not match the address in the instance accound"
    },
    {
      code: 6004,
      name: "RelayingToChainDisabled",
      msg: "Relaying to the specified chain is disabled"
    },
    {
      code: 6005,
      name: "OutboxItemNotReleased",
      msg: "Relaying to the specified chain is disabled"
    },
    {
      code: 6006,
      name: "ScalingOverflow",
      msg: "Scaled value exceeds u64::MAX"
    },
    {
      code: 6007,
      name: "DivByZero",
      msg: "Cannot divide by zero"
    },
    {
      code: 6257,
      name: "FeeRecipientCannotBeDefault",
      msg: "The fee recipient cannot be the default address (0x0)"
    },
    {
      code: 6258,
      name: "NotAuthorized",
      msg: "Must be owner or assistant"
    },
    {
      code: 6259,
      name: "PriceCannotBeZero",
      msg: "The price cannot be zero"
    }
  ]
}, IDL$8 = {
  version: "1.0.0",
  name: "wormhole_governance",
  instructions: [
    {
      name: "governance",
      accounts: [
        {
          name: "payer",
          isMut: !0,
          isSigner: !0
        },
        {
          name: "governance",
          isMut: !0,
          isSigner: !1
        },
        {
          name: "vaa",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "program",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "replay",
          isMut: !0,
          isSigner: !1
        },
        {
          name: "systemProgram",
          isMut: !1,
          isSigner: !1
        }
      ],
      args: []
    }
  ],
  accounts: [
    {
      name: "replayProtection",
      type: {
        kind: "struct",
        fields: [
          {
            name: "bump",
            type: "u8"
          }
        ]
      }
    }
  ],
  errors: [
    {
      code: 6e3,
      name: "InvalidGovernanceChain",
      msg: "InvalidGovernanceChain"
    },
    {
      code: 6001,
      name: "InvalidGovernanceEmitter",
      msg: "InvalidGovernanceEmitter"
    }
  ]
};
var _1_0_0;
(function(C) {
  C.idl = { ntt: IDL$a, transceiver: IDL$a, quoter: IDL$9, governance: IDL$8 };
})(_1_0_0 || (_1_0_0 = {}));
const IDL$7 = {
  version: "2.0.0",
  name: "example_native_token_transfers",
  instructions: [
    {
      name: "initialize",
      accounts: [
        {
          name: "payer",
          isMut: !0,
          isSigner: !0
        },
        {
          name: "deployer",
          isMut: !1,
          isSigner: !0
        },
        {
          name: "programData",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "config",
          isMut: !0,
          isSigner: !1
        },
        {
          name: "mint",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "rateLimit",
          isMut: !0,
          isSigner: !1
        },
        {
          name: "tokenAuthority",
          isMut: !1,
          isSigner: !1,
          docs: [
            "In any case, this function is used to set the Config and initialize the program so we",
            "assume the caller of this function will have total control over the program.",
            "",
            'TODO: Using `UncheckedAccount` here leads to "Access violation in stack frame ...".',
            "Could refactor code to use `Box<_>` to reduce stack size."
          ]
        },
        {
          name: "custody",
          isMut: !0,
          isSigner: !1,
          docs: [
            "The custody account that holds tokens in locking mode and temporarily",
            "holds tokens in burning mode.",
            "function if  the token account has already been created."
          ]
        },
        {
          name: "tokenProgram",
          isMut: !1,
          isSigner: !1,
          docs: ["associated token account for the given mint."]
        },
        {
          name: "associatedTokenProgram",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "bpfLoaderUpgradeableProgram",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "systemProgram",
          isMut: !1,
          isSigner: !1
        }
      ],
      args: [
        {
          name: "args",
          type: {
            defined: "InitializeArgs"
          }
        }
      ]
    },
    {
      name: "initializeLut",
      accounts: [
        {
          name: "payer",
          isMut: !0,
          isSigner: !0
        },
        {
          name: "authority",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "lutAddress",
          isMut: !0,
          isSigner: !1
        },
        {
          name: "lut",
          isMut: !0,
          isSigner: !1
        },
        {
          name: "lutProgram",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "systemProgram",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "entries",
          accounts: [
            {
              name: "config",
              isMut: !1,
              isSigner: !1
            },
            {
              name: "custody",
              isMut: !1,
              isSigner: !1
            },
            {
              name: "tokenProgram",
              isMut: !1,
              isSigner: !1
            },
            {
              name: "mint",
              isMut: !1,
              isSigner: !1
            },
            {
              name: "tokenAuthority",
              isMut: !1,
              isSigner: !1
            },
            {
              name: "outboxRateLimit",
              isMut: !1,
              isSigner: !1
            },
            {
              name: "wormhole",
              accounts: [
                {
                  name: "bridge",
                  isMut: !0,
                  isSigner: !1
                },
                {
                  name: "feeCollector",
                  isMut: !0,
                  isSigner: !1
                },
                {
                  name: "sequence",
                  isMut: !0,
                  isSigner: !1
                },
                {
                  name: "program",
                  isMut: !1,
                  isSigner: !1
                },
                {
                  name: "systemProgram",
                  isMut: !1,
                  isSigner: !1
                },
                {
                  name: "clock",
                  isMut: !1,
                  isSigner: !1
                },
                {
                  name: "rent",
                  isMut: !1,
                  isSigner: !1
                }
              ]
            }
          ]
        }
      ],
      args: [
        {
          name: "recentSlot",
          type: "u64"
        }
      ]
    },
    {
      name: "version",
      accounts: [],
      args: [],
      returns: "string"
    },
    {
      name: "transferBurn",
      accounts: [
        {
          name: "common",
          accounts: [
            {
              name: "payer",
              isMut: !0,
              isSigner: !0
            },
            {
              name: "config",
              accounts: [
                {
                  name: "config",
                  isMut: !1,
                  isSigner: !1
                }
              ]
            },
            {
              name: "mint",
              isMut: !0,
              isSigner: !1
            },
            {
              name: "from",
              isMut: !0,
              isSigner: !1,
              docs: ["account can spend these tokens."]
            },
            {
              name: "tokenProgram",
              isMut: !1,
              isSigner: !1
            },
            {
              name: "outboxItem",
              isMut: !0,
              isSigner: !0
            },
            {
              name: "outboxRateLimit",
              isMut: !0,
              isSigner: !1
            },
            {
              name: "custody",
              isMut: !0,
              isSigner: !1,
              docs: [
                "Tokens are always transferred to the custody account first regardless of",
                "the mode.",
                "For an explanation, see the note in [`transfer_burn`]."
              ]
            },
            {
              name: "systemProgram",
              isMut: !1,
              isSigner: !1
            }
          ]
        },
        {
          name: "inboxRateLimit",
          isMut: !0,
          isSigner: !1
        },
        {
          name: "peer",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "sessionAuthority",
          isMut: !1,
          isSigner: !1,
          docs: [
            "See [`crate::SESSION_AUTHORITY_SEED`] for an explanation of the flow."
          ]
        },
        {
          name: "tokenAuthority",
          isMut: !1,
          isSigner: !1
        }
      ],
      args: [
        {
          name: "args",
          type: {
            defined: "TransferArgs"
          }
        }
      ]
    },
    {
      name: "transferLock",
      accounts: [
        {
          name: "common",
          accounts: [
            {
              name: "payer",
              isMut: !0,
              isSigner: !0
            },
            {
              name: "config",
              accounts: [
                {
                  name: "config",
                  isMut: !1,
                  isSigner: !1
                }
              ]
            },
            {
              name: "mint",
              isMut: !0,
              isSigner: !1
            },
            {
              name: "from",
              isMut: !0,
              isSigner: !1,
              docs: ["account can spend these tokens."]
            },
            {
              name: "tokenProgram",
              isMut: !1,
              isSigner: !1
            },
            {
              name: "outboxItem",
              isMut: !0,
              isSigner: !0
            },
            {
              name: "outboxRateLimit",
              isMut: !0,
              isSigner: !1
            },
            {
              name: "custody",
              isMut: !0,
              isSigner: !1,
              docs: [
                "Tokens are always transferred to the custody account first regardless of",
                "the mode.",
                "For an explanation, see the note in [`transfer_burn`]."
              ]
            },
            {
              name: "systemProgram",
              isMut: !1,
              isSigner: !1
            }
          ]
        },
        {
          name: "inboxRateLimit",
          isMut: !0,
          isSigner: !1
        },
        {
          name: "peer",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "sessionAuthority",
          isMut: !1,
          isSigner: !1,
          docs: [
            "See [`crate::SESSION_AUTHORITY_SEED`] for an explanation of the flow."
          ]
        }
      ],
      args: [
        {
          name: "args",
          type: {
            defined: "TransferArgs"
          }
        }
      ]
    },
    {
      name: "redeem",
      accounts: [
        {
          name: "payer",
          isMut: !0,
          isSigner: !0
        },
        {
          name: "config",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "peer",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "transceiverMessage",
          isMut: !1,
          isSigner: !1,
          docs: ["`Account<T>` and `owner` constraints are mutually-exclusive"]
        },
        {
          name: "transceiver",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "mint",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "inboxItem",
          isMut: !0,
          isSigner: !1,
          docs: [
            "NOTE: This account is content-addressed (PDA seeded by the message hash).",
            "This is because in a multi-transceiver configuration, the different",
            'transceivers "vote" on messages (by delivering them). By making the inbox',
            "items content-addressed, we can ensure that disagreeing votes don't",
            "interfere with each other.",
            "On the first call to [`redeem()`], [`InboxItem`] will be allocated and initialized with",
            "default values.",
            'On subsequent calls, we want to modify the `InboxItem` by "voting" on it. Therefore the',
            "program should not fail which would occur when using the `init` constraint.",
            "The [`InboxItem::init`] field is used to guard against malicious or accidental modification",
            "InboxItem fields that should remain constant."
          ]
        },
        {
          name: "inboxRateLimit",
          isMut: !0,
          isSigner: !1
        },
        {
          name: "outboxRateLimit",
          isMut: !0,
          isSigner: !1
        },
        {
          name: "systemProgram",
          isMut: !1,
          isSigner: !1
        }
      ],
      args: [
        {
          name: "args",
          type: {
            defined: "RedeemArgs"
          }
        }
      ]
    },
    {
      name: "releaseInboundMint",
      accounts: [
        {
          name: "common",
          accounts: [
            {
              name: "payer",
              isMut: !0,
              isSigner: !0
            },
            {
              name: "config",
              accounts: [
                {
                  name: "config",
                  isMut: !1,
                  isSigner: !1
                }
              ]
            },
            {
              name: "inboxItem",
              isMut: !0,
              isSigner: !1
            },
            {
              name: "recipient",
              isMut: !0,
              isSigner: !1
            },
            {
              name: "tokenAuthority",
              isMut: !1,
              isSigner: !1,
              docs: [
                "CHECK The seeds constraint ensures that this is the correct address"
              ]
            },
            {
              name: "mint",
              isMut: !0,
              isSigner: !1
            },
            {
              name: "tokenProgram",
              isMut: !1,
              isSigner: !1
            },
            {
              name: "custody",
              isMut: !0,
              isSigner: !1
            }
          ]
        }
      ],
      args: [
        {
          name: "args",
          type: {
            defined: "ReleaseInboundArgs"
          }
        }
      ]
    },
    {
      name: "releaseInboundUnlock",
      accounts: [
        {
          name: "common",
          accounts: [
            {
              name: "payer",
              isMut: !0,
              isSigner: !0
            },
            {
              name: "config",
              accounts: [
                {
                  name: "config",
                  isMut: !1,
                  isSigner: !1
                }
              ]
            },
            {
              name: "inboxItem",
              isMut: !0,
              isSigner: !1
            },
            {
              name: "recipient",
              isMut: !0,
              isSigner: !1
            },
            {
              name: "tokenAuthority",
              isMut: !1,
              isSigner: !1,
              docs: [
                "CHECK The seeds constraint ensures that this is the correct address"
              ]
            },
            {
              name: "mint",
              isMut: !0,
              isSigner: !1
            },
            {
              name: "tokenProgram",
              isMut: !1,
              isSigner: !1
            },
            {
              name: "custody",
              isMut: !0,
              isSigner: !1
            }
          ]
        }
      ],
      args: [
        {
          name: "args",
          type: {
            defined: "ReleaseInboundArgs"
          }
        }
      ]
    },
    {
      name: "transferOwnership",
      accounts: [
        {
          name: "config",
          isMut: !0,
          isSigner: !1
        },
        {
          name: "owner",
          isMut: !1,
          isSigner: !0
        },
        {
          name: "newOwner",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "upgradeLock",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "programData",
          isMut: !0,
          isSigner: !1
        },
        {
          name: "bpfLoaderUpgradeableProgram",
          isMut: !1,
          isSigner: !1
        }
      ],
      args: []
    },
    {
      name: "claimOwnership",
      accounts: [
        {
          name: "config",
          isMut: !0,
          isSigner: !1
        },
        {
          name: "upgradeLock",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "newOwner",
          isMut: !1,
          isSigner: !0
        },
        {
          name: "programData",
          isMut: !0,
          isSigner: !1
        },
        {
          name: "bpfLoaderUpgradeableProgram",
          isMut: !1,
          isSigner: !1
        }
      ],
      args: []
    },
    {
      name: "setPaused",
      accounts: [
        {
          name: "owner",
          isMut: !1,
          isSigner: !0
        },
        {
          name: "config",
          isMut: !0,
          isSigner: !1
        }
      ],
      args: [
        {
          name: "pause",
          type: "bool"
        }
      ]
    },
    {
      name: "setPeer",
      accounts: [
        {
          name: "payer",
          isMut: !0,
          isSigner: !0
        },
        {
          name: "owner",
          isMut: !1,
          isSigner: !0
        },
        {
          name: "config",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "peer",
          isMut: !0,
          isSigner: !1
        },
        {
          name: "inboxRateLimit",
          isMut: !0,
          isSigner: !1
        },
        {
          name: "systemProgram",
          isMut: !1,
          isSigner: !1
        }
      ],
      args: [
        {
          name: "args",
          type: {
            defined: "SetPeerArgs"
          }
        }
      ]
    },
    {
      name: "registerTransceiver",
      accounts: [
        {
          name: "config",
          isMut: !0,
          isSigner: !1
        },
        {
          name: "owner",
          isMut: !1,
          isSigner: !0
        },
        {
          name: "payer",
          isMut: !0,
          isSigner: !0
        },
        {
          name: "transceiver",
          isMut: !1,
          isSigner: !1,
          docs: ["used here that wraps the Transceiver account type."]
        },
        {
          name: "registeredTransceiver",
          isMut: !0,
          isSigner: !1
        },
        {
          name: "systemProgram",
          isMut: !1,
          isSigner: !1
        }
      ],
      args: []
    },
    {
      name: "setOutboundLimit",
      accounts: [
        {
          name: "config",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "owner",
          isMut: !1,
          isSigner: !0
        },
        {
          name: "rateLimit",
          isMut: !0,
          isSigner: !1
        }
      ],
      args: [
        {
          name: "args",
          type: {
            defined: "SetOutboundLimitArgs"
          }
        }
      ]
    },
    {
      name: "setInboundLimit",
      accounts: [
        {
          name: "config",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "owner",
          isMut: !1,
          isSigner: !0
        },
        {
          name: "rateLimit",
          isMut: !0,
          isSigner: !1
        }
      ],
      args: [
        {
          name: "args",
          type: {
            defined: "SetInboundLimitArgs"
          }
        }
      ]
    },
    {
      name: "setWormholePeer",
      accounts: [
        {
          name: "config",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "owner",
          isMut: !1,
          isSigner: !0
        },
        {
          name: "payer",
          isMut: !0,
          isSigner: !0
        },
        {
          name: "peer",
          isMut: !0,
          isSigner: !1
        },
        {
          name: "systemProgram",
          isMut: !1,
          isSigner: !1
        }
      ],
      args: [
        {
          name: "args",
          type: {
            defined: "SetTransceiverPeerArgs"
          }
        }
      ]
    },
    {
      name: "receiveWormholeMessage",
      accounts: [
        {
          name: "payer",
          isMut: !0,
          isSigner: !0
        },
        {
          name: "config",
          accounts: [
            {
              name: "config",
              isMut: !1,
              isSigner: !1
            }
          ]
        },
        {
          name: "peer",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "vaa",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "transceiverMessage",
          isMut: !0,
          isSigner: !1
        },
        {
          name: "systemProgram",
          isMut: !1,
          isSigner: !1
        }
      ],
      args: []
    },
    {
      name: "releaseWormholeOutbound",
      accounts: [
        {
          name: "payer",
          isMut: !0,
          isSigner: !0
        },
        {
          name: "config",
          accounts: [
            {
              name: "config",
              isMut: !1,
              isSigner: !1
            }
          ]
        },
        {
          name: "outboxItem",
          isMut: !0,
          isSigner: !1
        },
        {
          name: "transceiver",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "wormholeMessage",
          isMut: !0,
          isSigner: !1
        },
        {
          name: "emitter",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "wormhole",
          accounts: [
            {
              name: "bridge",
              isMut: !0,
              isSigner: !1
            },
            {
              name: "feeCollector",
              isMut: !0,
              isSigner: !1
            },
            {
              name: "sequence",
              isMut: !0,
              isSigner: !1
            },
            {
              name: "program",
              isMut: !1,
              isSigner: !1
            },
            {
              name: "systemProgram",
              isMut: !1,
              isSigner: !1
            },
            {
              name: "clock",
              isMut: !1,
              isSigner: !1
            },
            {
              name: "rent",
              isMut: !1,
              isSigner: !1
            }
          ]
        }
      ],
      args: [
        {
          name: "args",
          type: {
            defined: "ReleaseOutboundArgs"
          }
        }
      ]
    },
    {
      name: "broadcastWormholeId",
      accounts: [
        {
          name: "payer",
          isMut: !0,
          isSigner: !0
        },
        {
          name: "config",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "mint",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "wormholeMessage",
          isMut: !0,
          isSigner: !0
        },
        {
          name: "emitter",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "wormhole",
          accounts: [
            {
              name: "bridge",
              isMut: !0,
              isSigner: !1
            },
            {
              name: "feeCollector",
              isMut: !0,
              isSigner: !1
            },
            {
              name: "sequence",
              isMut: !0,
              isSigner: !1
            },
            {
              name: "program",
              isMut: !1,
              isSigner: !1
            },
            {
              name: "systemProgram",
              isMut: !1,
              isSigner: !1
            },
            {
              name: "clock",
              isMut: !1,
              isSigner: !1
            },
            {
              name: "rent",
              isMut: !1,
              isSigner: !1
            }
          ]
        }
      ],
      args: []
    },
    {
      name: "broadcastWormholePeer",
      accounts: [
        {
          name: "payer",
          isMut: !0,
          isSigner: !0
        },
        {
          name: "config",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "peer",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "wormholeMessage",
          isMut: !0,
          isSigner: !0
        },
        {
          name: "emitter",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "wormhole",
          accounts: [
            {
              name: "bridge",
              isMut: !0,
              isSigner: !1
            },
            {
              name: "feeCollector",
              isMut: !0,
              isSigner: !1
            },
            {
              name: "sequence",
              isMut: !0,
              isSigner: !1
            },
            {
              name: "program",
              isMut: !1,
              isSigner: !1
            },
            {
              name: "systemProgram",
              isMut: !1,
              isSigner: !1
            },
            {
              name: "clock",
              isMut: !1,
              isSigner: !1
            },
            {
              name: "rent",
              isMut: !1,
              isSigner: !1
            }
          ]
        }
      ],
      args: [
        {
          name: "args",
          type: {
            defined: "BroadcastPeerArgs"
          }
        }
      ]
    }
  ],
  accounts: [
    {
      name: "config",
      type: {
        kind: "struct",
        fields: [
          {
            name: "bump",
            type: "u8"
          },
          {
            name: "owner",
            docs: ["Owner of the program."],
            type: "publicKey"
          },
          {
            name: "pendingOwner",
            docs: ["Pending next owner (before claiming ownership)."],
            type: {
              option: "publicKey"
            }
          },
          {
            name: "mint",
            docs: ["Mint address of the token managed by this program."],
            type: "publicKey"
          },
          {
            name: "tokenProgram",
            docs: [
              "Address of the token program (token or token22). This could always be queried",
              "from the [`mint`] account's owner, but storing it here avoids an indirection",
              "on the client side."
            ],
            type: "publicKey"
          },
          {
            name: "mode",
            docs: [
              "The mode that this program is running in. This is used to determine",
              "whether the program is burning tokens or locking tokens."
            ],
            type: {
              defined: "Mode"
            }
          },
          {
            name: "chainId",
            docs: [
              "The chain id of the chain that this program is running on. We don't",
              "hardcode this so that the program is deployable on any potential SVM",
              "forks."
            ],
            type: {
              defined: "ChainId"
            }
          },
          {
            name: "nextTransceiverId",
            docs: [
              "The next transceiver id to use when registering an transceiver."
            ],
            type: "u8"
          },
          {
            name: "threshold",
            docs: [
              "The number of transceivers that must attest to a transfer before it is",
              "accepted."
            ],
            type: "u8"
          },
          {
            name: "enabledTransceivers",
            docs: [
              "Bitmap of enabled transceivers.",
              "The maximum number of transceivers is equal to [`Bitmap::BITS`]."
            ],
            type: {
              defined: "Bitmap"
            }
          },
          {
            name: "paused",
            docs: [
              "Pause the program. This is useful for upgrades and other maintenance."
            ],
            type: "bool"
          },
          {
            name: "custody",
            docs: ["The custody account that holds tokens in locking mode."],
            type: "publicKey"
          }
        ]
      }
    },
    {
      name: "LUT",
      type: {
        kind: "struct",
        fields: [
          {
            name: "bump",
            type: "u8"
          },
          {
            name: "address",
            type: "publicKey"
          }
        ]
      }
    },
    {
      name: "nttManagerPeer",
      docs: [
        "A peer on another chain. Stored in a PDA seeded by the chain id."
      ],
      type: {
        kind: "struct",
        fields: [
          {
            name: "bump",
            type: "u8"
          },
          {
            name: "address",
            type: {
              array: ["u8", 32]
            }
          },
          {
            name: "tokenDecimals",
            type: "u8"
          }
        ]
      }
    },
    {
      name: "inboxItem",
      type: {
        kind: "struct",
        fields: [
          {
            name: "init",
            type: "bool"
          },
          {
            name: "bump",
            type: "u8"
          },
          {
            name: "amount",
            type: "u64"
          },
          {
            name: "recipientAddress",
            type: "publicKey"
          },
          {
            name: "votes",
            type: {
              defined: "Bitmap"
            }
          },
          {
            name: "releaseStatus",
            type: {
              defined: "ReleaseStatus"
            }
          }
        ]
      }
    },
    {
      name: "inboxRateLimit",
      docs: [
        "Inbound rate limit per chain.",
        "SECURITY: must check the PDA (since there are multiple PDAs, namely one for each chain.)"
      ],
      type: {
        kind: "struct",
        fields: [
          {
            name: "bump",
            type: "u8"
          },
          {
            name: "rateLimit",
            type: {
              defined: "RateLimitState"
            }
          }
        ]
      }
    },
    {
      name: "outboxItem",
      type: {
        kind: "struct",
        fields: [
          {
            name: "amount",
            type: {
              defined: "TrimmedAmount"
            }
          },
          {
            name: "sender",
            type: "publicKey"
          },
          {
            name: "recipientChain",
            type: {
              defined: "ChainId"
            }
          },
          {
            name: "recipientNttManager",
            type: {
              array: ["u8", 32]
            }
          },
          {
            name: "recipientAddress",
            type: {
              array: ["u8", 32]
            }
          },
          {
            name: "releaseTimestamp",
            type: "i64"
          },
          {
            name: "released",
            type: {
              defined: "Bitmap"
            }
          }
        ]
      }
    },
    {
      name: "outboxRateLimit",
      type: {
        kind: "struct",
        fields: [
          {
            name: "rateLimit",
            type: {
              defined: "RateLimitState"
            }
          }
        ]
      }
    },
    {
      name: "registeredTransceiver",
      type: {
        kind: "struct",
        fields: [
          {
            name: "bump",
            type: "u8"
          },
          {
            name: "id",
            type: "u8"
          },
          {
            name: "transceiverAddress",
            type: "publicKey"
          }
        ]
      }
    },
    {
      name: "transceiverPeer",
      docs: [
        "A peer on another chain. Stored in a PDA seeded by the chain id."
      ],
      type: {
        kind: "struct",
        fields: [
          {
            name: "bump",
            type: "u8"
          },
          {
            name: "address",
            type: {
              array: ["u8", 32]
            }
          }
        ]
      }
    },
    {
      name: "bridgeData",
      type: {
        kind: "struct",
        fields: [
          {
            name: "guardianSetIndex",
            docs: [
              "The current guardian set index, used to decide which signature sets to accept."
            ],
            type: "u32"
          },
          {
            name: "lastLamports",
            docs: ["Lamports in the collection account"],
            type: "u64"
          },
          {
            name: "config",
            docs: [
              "Bridge configuration, which is set once upon initialization."
            ],
            type: {
              defined: "BridgeConfig"
            }
          }
        ]
      }
    }
  ],
  types: [
    {
      name: "Bitmap",
      type: {
        kind: "struct",
        fields: [
          {
            name: "map",
            type: "u128"
          }
        ]
      }
    },
    {
      name: "SetInboundLimitArgs",
      type: {
        kind: "struct",
        fields: [
          {
            name: "limit",
            type: "u64"
          },
          {
            name: "chainId",
            type: {
              defined: "ChainId"
            }
          }
        ]
      }
    },
    {
      name: "SetOutboundLimitArgs",
      type: {
        kind: "struct",
        fields: [
          {
            name: "limit",
            type: "u64"
          }
        ]
      }
    },
    {
      name: "SetPeerArgs",
      type: {
        kind: "struct",
        fields: [
          {
            name: "chainId",
            type: {
              defined: "ChainId"
            }
          },
          {
            name: "address",
            type: {
              array: ["u8", 32]
            }
          },
          {
            name: "limit",
            type: "u64"
          },
          {
            name: "tokenDecimals",
            docs: ["The token decimals on the peer chain."],
            type: "u8"
          }
        ]
      }
    },
    {
      name: "InitializeArgs",
      type: {
        kind: "struct",
        fields: [
          {
            name: "chainId",
            type: "u16"
          },
          {
            name: "limit",
            type: "u64"
          },
          {
            name: "mode",
            type: {
              defined: "Mode"
            }
          }
        ]
      }
    },
    {
      name: "RedeemArgs",
      type: {
        kind: "struct",
        fields: []
      }
    },
    {
      name: "ReleaseInboundArgs",
      type: {
        kind: "struct",
        fields: [
          {
            name: "revertOnDelay",
            type: "bool"
          }
        ]
      }
    },
    {
      name: "TransferArgs",
      type: {
        kind: "struct",
        fields: [
          {
            name: "amount",
            type: "u64"
          },
          {
            name: "recipientChain",
            type: {
              defined: "ChainId"
            }
          },
          {
            name: "recipientAddress",
            type: {
              array: ["u8", 32]
            }
          },
          {
            name: "shouldQueue",
            type: "bool"
          }
        ]
      }
    },
    {
      name: "ReleaseStatus",
      docs: [
        "The status of an InboxItem. This determines whether the tokens are minted/unlocked to the recipient. As",
        "such, this must be used as a state machine that moves forward in a linear manner. A state",
        'should never "move backward" to a previous state (e.g. should never move from `Released` to',
        "`ReleaseAfter`)."
      ],
      type: {
        kind: "enum",
        variants: [
          {
            name: "NotApproved"
          },
          {
            name: "ReleaseAfter",
            fields: ["i64"]
          },
          {
            name: "Released"
          }
        ]
      }
    },
    {
      name: "RateLimitState",
      type: {
        kind: "struct",
        fields: [
          {
            name: "limit",
            docs: ["The maximum capacity of the rate limiter."],
            type: "u64"
          },
          {
            name: "capacityAtLastTx",
            docs: [
              "The capacity of the rate limiter at `last_tx_timestamp`.",
              "The actual current capacity is calculated in `capacity_at`, by",
              "accounting for the time that has passed since `last_tx_timestamp` and",
              "the refill rate."
            ],
            type: "u64"
          },
          {
            name: "lastTxTimestamp",
            docs: [
              "The timestamp of the last transaction that counted towards the current",
              "capacity. Transactions that exceeded the capacity do not count, they are",
              "just delayed."
            ],
            type: "i64"
          }
        ]
      }
    },
    {
      name: "SetTransceiverPeerArgs",
      type: {
        kind: "struct",
        fields: [
          {
            name: "chainId",
            type: {
              defined: "ChainId"
            }
          },
          {
            name: "address",
            type: {
              array: ["u8", 32]
            }
          }
        ]
      }
    },
    {
      name: "BroadcastPeerArgs",
      type: {
        kind: "struct",
        fields: [
          {
            name: "chainId",
            type: "u16"
          }
        ]
      }
    },
    {
      name: "ReleaseOutboundArgs",
      type: {
        kind: "struct",
        fields: [
          {
            name: "revertOnDelay",
            type: "bool"
          }
        ]
      }
    },
    {
      name: "ChainId",
      type: {
        kind: "struct",
        fields: [
          {
            name: "id",
            type: "u16"
          }
        ]
      }
    },
    {
      name: "Mode",
      type: {
        kind: "enum",
        variants: [
          {
            name: "Locking"
          },
          {
            name: "Burning"
          }
        ]
      }
    },
    {
      name: "TrimmedAmount",
      type: {
        kind: "struct",
        fields: [
          {
            name: "amount",
            type: "u64"
          },
          {
            name: "decimals",
            type: "u8"
          }
        ]
      }
    },
    {
      name: "BridgeConfig",
      type: {
        kind: "struct",
        fields: [
          {
            name: "guardianSetExpirationTime",
            docs: [
              "Period for how long a guardian set is valid after it has been replaced by a new one.  This",
              "guarantees that VAAs issued by that set can still be submitted for a certain period.  In",
              "this period we still trust the old guardian set."
            ],
            type: "u32"
          },
          {
            name: "fee",
            docs: [
              "Amount of lamports that needs to be paid to the protocol to post a message"
            ],
            type: "u64"
          }
        ]
      }
    }
  ],
  errors: [
    {
      code: 6e3,
      name: "CantReleaseYet",
      msg: "CantReleaseYet"
    },
    {
      code: 6001,
      name: "InvalidPendingOwner",
      msg: "InvalidPendingOwner"
    },
    {
      code: 6002,
      name: "InvalidChainId",
      msg: "InvalidChainId"
    },
    {
      code: 6003,
      name: "InvalidRecipientAddress",
      msg: "InvalidRecipientAddress"
    },
    {
      code: 6004,
      name: "InvalidTransceiverPeer",
      msg: "InvalidTransceiverPeer"
    },
    {
      code: 6005,
      name: "InvalidNttManagerPeer",
      msg: "InvalidNttManagerPeer"
    },
    {
      code: 6006,
      name: "InvalidRecipientNttManager",
      msg: "InvalidRecipientNttManager"
    },
    {
      code: 6007,
      name: "TransferAlreadyRedeemed",
      msg: "TransferAlreadyRedeemed"
    },
    {
      code: 6008,
      name: "TransferCannotBeRedeemed",
      msg: "TransferCannotBeRedeemed"
    },
    {
      code: 6009,
      name: "TransferNotApproved",
      msg: "TransferNotApproved"
    },
    {
      code: 6010,
      name: "MessageAlreadySent",
      msg: "MessageAlreadySent"
    },
    {
      code: 6011,
      name: "InvalidMode",
      msg: "InvalidMode"
    },
    {
      code: 6012,
      name: "InvalidMintAuthority",
      msg: "InvalidMintAuthority"
    },
    {
      code: 6013,
      name: "TransferExceedsRateLimit",
      msg: "TransferExceedsRateLimit"
    },
    {
      code: 6014,
      name: "Paused",
      msg: "Paused"
    },
    {
      code: 6015,
      name: "DisabledTransceiver",
      msg: "DisabledTransceiver"
    },
    {
      code: 6016,
      name: "InvalidDeployer",
      msg: "InvalidDeployer"
    },
    {
      code: 6017,
      name: "BadAmountAfterTransfer",
      msg: "BadAmountAfterTransfer"
    },
    {
      code: 6018,
      name: "BadAmountAfterBurn",
      msg: "BadAmountAfterBurn"
    },
    {
      code: 6019,
      name: "ZeroThreshold",
      msg: "ZeroThreshold"
    },
    {
      code: 6020,
      name: "OverflowExponent",
      msg: "OverflowExponent"
    },
    {
      code: 6021,
      name: "OverflowScaledAmount",
      msg: "OverflowScaledAmount"
    },
    {
      code: 6022,
      name: "BitmapIndexOutOfBounds",
      msg: "BitmapIndexOutOfBounds"
    },
    {
      code: 6023,
      name: "NoRegisteredTransceivers",
      msg: "NoRegisteredTransceivers"
    }
  ]
}, IDL$6 = {
  version: "2.0.0",
  name: "ntt_quoter",
  instructions: [
    {
      name: "requestRelay",
      accounts: [
        {
          name: "payer",
          isMut: !0,
          isSigner: !0
        },
        {
          name: "instance",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "registeredChain",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "registeredNtt",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "outboxItem",
          isMut: !1,
          isSigner: !1,
          docs: [
            "and checking the release constraint into a single function"
          ]
        },
        {
          name: "relayRequest",
          isMut: !0,
          isSigner: !1
        },
        {
          name: "systemProgram",
          isMut: !1,
          isSigner: !1
        }
      ],
      args: [
        {
          name: "args",
          type: {
            defined: "RequestRelayArgs"
          }
        }
      ]
    },
    {
      name: "closeRelay",
      accounts: [
        {
          name: "authority",
          isMut: !1,
          isSigner: !0
        },
        {
          name: "instance",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "feeRecipient",
          isMut: !0,
          isSigner: !1
        },
        {
          name: "relayRequest",
          isMut: !0,
          isSigner: !1
        },
        {
          name: "systemProgram",
          isMut: !1,
          isSigner: !1
        }
      ],
      args: []
    },
    {
      name: "initialize",
      accounts: [
        {
          name: "owner",
          isMut: !0,
          isSigner: !0
        },
        {
          name: "instance",
          isMut: !0,
          isSigner: !1
        },
        {
          name: "feeRecipient",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "programData",
          isMut: !0,
          isSigner: !1,
          docs: [
            "We use the program data to make sure this owner is the upgrade authority (the true owner,",
            "who deployed this program)."
          ]
        },
        {
          name: "systemProgram",
          isMut: !1,
          isSigner: !1
        }
      ],
      args: []
    },
    {
      name: "setAssistant",
      accounts: [
        {
          name: "owner",
          isMut: !1,
          isSigner: !0
        },
        {
          name: "instance",
          isMut: !0,
          isSigner: !1
        },
        {
          name: "assistant",
          isMut: !1,
          isSigner: !1,
          isOptional: !0
        }
      ],
      args: []
    },
    {
      name: "setFeeRecipient",
      accounts: [
        {
          name: "owner",
          isMut: !1,
          isSigner: !0
        },
        {
          name: "instance",
          isMut: !0,
          isSigner: !1
        },
        {
          name: "feeRecipient",
          isMut: !1,
          isSigner: !1
        }
      ],
      args: []
    },
    {
      name: "registerChain",
      accounts: [
        {
          name: "authority",
          isMut: !0,
          isSigner: !0
        },
        {
          name: "instance",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "registeredChain",
          isMut: !0,
          isSigner: !1
        },
        {
          name: "systemProgram",
          isMut: !1,
          isSigner: !1
        }
      ],
      args: [
        {
          name: "args",
          type: {
            defined: "RegisterChainArgs"
          }
        }
      ]
    },
    {
      name: "registerNtt",
      accounts: [
        {
          name: "authority",
          isMut: !0,
          isSigner: !0
        },
        {
          name: "instance",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "registeredNtt",
          isMut: !0,
          isSigner: !1
        },
        {
          name: "systemProgram",
          isMut: !1,
          isSigner: !1
        }
      ],
      args: [
        {
          name: "args",
          type: {
            defined: "RegisterNttArgs"
          }
        }
      ]
    },
    {
      name: "deregisterNtt",
      accounts: [
        {
          name: "authority",
          isMut: !0,
          isSigner: !0
        },
        {
          name: "instance",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "registeredNtt",
          isMut: !0,
          isSigner: !1
        },
        {
          name: "systemProgram",
          isMut: !1,
          isSigner: !1
        }
      ],
      args: [
        {
          name: "args",
          type: {
            defined: "DeregisterNttArgs"
          }
        }
      ]
    },
    {
      name: "updateSolPrice",
      accounts: [
        {
          name: "authority",
          isMut: !1,
          isSigner: !0
        },
        {
          name: "instance",
          isMut: !0,
          isSigner: !1
        }
      ],
      args: [
        {
          name: "args",
          type: {
            defined: "UpdateSolPriceArgs"
          }
        }
      ]
    },
    {
      name: "updateChainPrices",
      accounts: [
        {
          name: "authority",
          isMut: !1,
          isSigner: !0
        },
        {
          name: "instance",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "registeredChain",
          isMut: !0,
          isSigner: !1
        }
      ],
      args: [
        {
          name: "args",
          type: {
            defined: "UpdateChainPricesArgs"
          }
        }
      ]
    },
    {
      name: "updateChainParams",
      accounts: [
        {
          name: "authority",
          isMut: !1,
          isSigner: !0
        },
        {
          name: "instance",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "registeredChain",
          isMut: !0,
          isSigner: !1
        }
      ],
      args: [
        {
          name: "args",
          type: {
            defined: "UpdateChainParamsArgs"
          }
        }
      ]
    }
  ],
  accounts: [
    {
      name: "instance",
      type: {
        kind: "struct",
        fields: [
          {
            name: "owner",
            type: "publicKey"
          },
          {
            name: "assistant",
            type: "publicKey"
          },
          {
            name: "feeRecipient",
            type: "publicKey"
          },
          {
            name: "solPrice",
            type: "u64"
          }
        ]
      }
    },
    {
      name: "registeredChain",
      type: {
        kind: "struct",
        fields: [
          {
            name: "bump",
            type: "u8"
          },
          {
            name: "maxGasDropoff",
            type: "u64"
          },
          {
            name: "basePrice",
            type: "u64"
          },
          {
            name: "nativePrice",
            type: "u64"
          },
          {
            name: "gasPrice",
            type: "u64"
          }
        ]
      }
    },
    {
      name: "registeredNtt",
      type: {
        kind: "struct",
        fields: [
          {
            name: "bump",
            type: "u8"
          },
          {
            name: "wormholeTransceiverIndex",
            type: "u8"
          },
          {
            name: "gasCost",
            type: "u32"
          }
        ]
      }
    },
    {
      name: "relayRequest",
      type: {
        kind: "struct",
        fields: [
          {
            name: "requestedGasDropoff",
            type: "u64"
          }
        ]
      }
    }
  ],
  types: [
    {
      name: "RegisterChainArgs",
      type: {
        kind: "struct",
        fields: [
          {
            name: "chainId",
            type: "u16"
          }
        ]
      }
    },
    {
      name: "RegisterNttArgs",
      type: {
        kind: "struct",
        fields: [
          {
            name: "nttProgramId",
            type: "publicKey"
          },
          {
            name: "wormholeTransceiverIndex",
            type: "u8"
          },
          {
            name: "gasCost",
            type: "u32"
          }
        ]
      }
    },
    {
      name: "DeregisterNttArgs",
      type: {
        kind: "struct",
        fields: [
          {
            name: "nttProgramId",
            type: "publicKey"
          }
        ]
      }
    },
    {
      name: "RequestRelayArgs",
      type: {
        kind: "struct",
        fields: [
          {
            name: "gasDropoff",
            type: "u64"
          },
          {
            name: "maxFee",
            type: "u64"
          }
        ]
      }
    },
    {
      name: "UpdateSolPriceArgs",
      type: {
        kind: "struct",
        fields: [
          {
            name: "solPrice",
            type: "u64"
          }
        ]
      }
    },
    {
      name: "UpdateChainPricesArgs",
      type: {
        kind: "struct",
        fields: [
          {
            name: "nativePrice",
            type: "u64"
          },
          {
            name: "gasPrice",
            type: "u64"
          }
        ]
      }
    },
    {
      name: "UpdateChainParamsArgs",
      type: {
        kind: "struct",
        fields: [
          {
            name: "maxGasDropoff",
            type: "u64"
          },
          {
            name: "basePrice",
            type: "u64"
          }
        ]
      }
    }
  ],
  errors: [
    {
      code: 6001,
      name: "ExceedsUserMaxFee",
      msg: "Relay fees exceeds specified max"
    },
    {
      code: 6002,
      name: "ExceedsMaxGasDropoff",
      msg: "Requested gas dropoff exceeds max allowed for chain"
    },
    {
      code: 6003,
      name: "InvalidFeeRecipient",
      msg: "The specified fee recipient does not match the address in the instance accound"
    },
    {
      code: 6004,
      name: "RelayingToChainDisabled",
      msg: "Relaying to the specified chain is disabled"
    },
    {
      code: 6005,
      name: "OutboxItemNotReleased",
      msg: "Relaying to the specified chain is disabled"
    },
    {
      code: 6006,
      name: "ScalingOverflow",
      msg: "Scaled value exceeds u64::MAX"
    },
    {
      code: 6007,
      name: "DivByZero",
      msg: "Cannot divide by zero"
    },
    {
      code: 6257,
      name: "FeeRecipientCannotBeDefault",
      msg: "The fee recipient cannot be the default address (0x0)"
    },
    {
      code: 6258,
      name: "NotAuthorized",
      msg: "Must be owner or assistant"
    },
    {
      code: 6259,
      name: "PriceCannotBeZero",
      msg: "The price cannot be zero"
    }
  ]
}, IDL$5 = {
  version: "2.0.0",
  name: "wormhole_governance",
  instructions: [
    {
      name: "governance",
      accounts: [
        {
          name: "payer",
          isMut: !0,
          isSigner: !0
        },
        {
          name: "governance",
          isMut: !0,
          isSigner: !1,
          docs: [
            "governed program. This account is validated by Wormhole, not this program."
          ]
        },
        {
          name: "vaa",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "program",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "replay",
          isMut: !0,
          isSigner: !1
        },
        {
          name: "systemProgram",
          isMut: !1,
          isSigner: !1
        }
      ],
      args: []
    }
  ],
  accounts: [
    {
      name: "replayProtection",
      type: {
        kind: "struct",
        fields: [
          {
            name: "bump",
            type: "u8"
          }
        ]
      }
    }
  ],
  errors: [
    {
      code: 6e3,
      name: "InvalidGovernanceChain",
      msg: "InvalidGovernanceChain"
    },
    {
      code: 6001,
      name: "InvalidGovernanceEmitter",
      msg: "InvalidGovernanceEmitter"
    },
    {
      code: 6002,
      name: "InvalidGovernanceProgram",
      msg: "InvalidGovernanceProgram"
    }
  ]
};
var _2_0_0;
(function(C) {
  C.idl = { ntt: IDL$7, transceiver: IDL$7, quoter: IDL$6, governance: IDL$5 };
})(_2_0_0 || (_2_0_0 = {}));
const IDL$4 = {
  version: "3.0.0",
  name: "example_native_token_transfers",
  instructions: [
    {
      name: "initialize",
      accounts: [
        {
          name: "payer",
          isMut: !0,
          isSigner: !0
        },
        {
          name: "deployer",
          isMut: !1,
          isSigner: !0
        },
        {
          name: "programData",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "config",
          isMut: !0,
          isSigner: !1
        },
        {
          name: "mint",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "rateLimit",
          isMut: !0,
          isSigner: !1
        },
        {
          name: "tokenAuthority",
          isMut: !1,
          isSigner: !1,
          docs: [
            "In any case, this function is used to set the Config and initialize the program so we",
            "assume the caller of this function will have total control over the program.",
            "",
            'TODO: Using `UncheckedAccount` here leads to "Access violation in stack frame ...".',
            "Could refactor code to use `Box<_>` to reduce stack size."
          ]
        },
        {
          name: "custody",
          isMut: !0,
          isSigner: !1,
          docs: [
            "The custody account that holds tokens in locking mode and temporarily",
            "holds tokens in burning mode.",
            "function if  the token account has already been created."
          ]
        },
        {
          name: "tokenProgram",
          isMut: !1,
          isSigner: !1,
          docs: [
            "associated token account for the given mint."
          ]
        },
        {
          name: "associatedTokenProgram",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "bpfLoaderUpgradeableProgram",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "systemProgram",
          isMut: !1,
          isSigner: !1
        }
      ],
      args: [
        {
          name: "args",
          type: {
            defined: "InitializeArgs"
          }
        }
      ]
    },
    {
      name: "initializeLut",
      accounts: [
        {
          name: "payer",
          isMut: !0,
          isSigner: !0
        },
        {
          name: "authority",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "lutAddress",
          isMut: !0,
          isSigner: !1
        },
        {
          name: "lut",
          isMut: !0,
          isSigner: !1
        },
        {
          name: "lutProgram",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "systemProgram",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "entries",
          accounts: [
            {
              name: "config",
              isMut: !1,
              isSigner: !1
            },
            {
              name: "custody",
              isMut: !1,
              isSigner: !1
            },
            {
              name: "tokenProgram",
              isMut: !1,
              isSigner: !1
            },
            {
              name: "mint",
              isMut: !1,
              isSigner: !1
            },
            {
              name: "tokenAuthority",
              isMut: !1,
              isSigner: !1
            },
            {
              name: "outboxRateLimit",
              isMut: !1,
              isSigner: !1
            },
            {
              name: "wormhole",
              accounts: [
                {
                  name: "bridge",
                  isMut: !0,
                  isSigner: !1
                },
                {
                  name: "feeCollector",
                  isMut: !0,
                  isSigner: !1
                },
                {
                  name: "sequence",
                  isMut: !0,
                  isSigner: !1
                },
                {
                  name: "program",
                  isMut: !1,
                  isSigner: !1
                },
                {
                  name: "systemProgram",
                  isMut: !1,
                  isSigner: !1
                },
                {
                  name: "clock",
                  isMut: !1,
                  isSigner: !1
                },
                {
                  name: "rent",
                  isMut: !1,
                  isSigner: !1
                }
              ]
            }
          ]
        }
      ],
      args: [
        {
          name: "recentSlot",
          type: "u64"
        }
      ]
    },
    {
      name: "version",
      accounts: [],
      args: [],
      returns: "string"
    },
    {
      name: "transferBurn",
      accounts: [
        {
          name: "common",
          accounts: [
            {
              name: "payer",
              isMut: !0,
              isSigner: !0
            },
            {
              name: "config",
              accounts: [
                {
                  name: "config",
                  isMut: !1,
                  isSigner: !1
                }
              ]
            },
            {
              name: "mint",
              isMut: !0,
              isSigner: !1
            },
            {
              name: "from",
              isMut: !0,
              isSigner: !1,
              docs: [
                "account can spend these tokens."
              ]
            },
            {
              name: "tokenProgram",
              isMut: !1,
              isSigner: !1
            },
            {
              name: "outboxItem",
              isMut: !0,
              isSigner: !0
            },
            {
              name: "outboxRateLimit",
              isMut: !0,
              isSigner: !1
            },
            {
              name: "custody",
              isMut: !0,
              isSigner: !1,
              docs: [
                "Tokens are always transferred to the custody account first regardless of",
                "the mode.",
                "For an explanation, see the note in [`transfer_burn`]."
              ]
            },
            {
              name: "systemProgram",
              isMut: !1,
              isSigner: !1
            }
          ]
        },
        {
          name: "inboxRateLimit",
          isMut: !0,
          isSigner: !1
        },
        {
          name: "peer",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "sessionAuthority",
          isMut: !1,
          isSigner: !1,
          docs: [
            "See [`crate::SESSION_AUTHORITY_SEED`] for an explanation of the flow."
          ]
        },
        {
          name: "tokenAuthority",
          isMut: !1,
          isSigner: !1
        }
      ],
      args: [
        {
          name: "args",
          type: {
            defined: "TransferArgs"
          }
        }
      ]
    },
    {
      name: "transferLock",
      accounts: [
        {
          name: "common",
          accounts: [
            {
              name: "payer",
              isMut: !0,
              isSigner: !0
            },
            {
              name: "config",
              accounts: [
                {
                  name: "config",
                  isMut: !1,
                  isSigner: !1
                }
              ]
            },
            {
              name: "mint",
              isMut: !0,
              isSigner: !1
            },
            {
              name: "from",
              isMut: !0,
              isSigner: !1,
              docs: [
                "account can spend these tokens."
              ]
            },
            {
              name: "tokenProgram",
              isMut: !1,
              isSigner: !1
            },
            {
              name: "outboxItem",
              isMut: !0,
              isSigner: !0
            },
            {
              name: "outboxRateLimit",
              isMut: !0,
              isSigner: !1
            },
            {
              name: "custody",
              isMut: !0,
              isSigner: !1,
              docs: [
                "Tokens are always transferred to the custody account first regardless of",
                "the mode.",
                "For an explanation, see the note in [`transfer_burn`]."
              ]
            },
            {
              name: "systemProgram",
              isMut: !1,
              isSigner: !1
            }
          ]
        },
        {
          name: "inboxRateLimit",
          isMut: !0,
          isSigner: !1
        },
        {
          name: "peer",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "sessionAuthority",
          isMut: !1,
          isSigner: !1,
          docs: [
            "See [`crate::SESSION_AUTHORITY_SEED`] for an explanation of the flow."
          ]
        }
      ],
      args: [
        {
          name: "args",
          type: {
            defined: "TransferArgs"
          }
        }
      ]
    },
    {
      name: "redeem",
      accounts: [
        {
          name: "payer",
          isMut: !0,
          isSigner: !0
        },
        {
          name: "config",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "peer",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "transceiverMessage",
          isMut: !1,
          isSigner: !1,
          docs: [
            "`Account<T>` and `owner` constraints are mutually-exclusive"
          ]
        },
        {
          name: "transceiver",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "mint",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "inboxItem",
          isMut: !0,
          isSigner: !1,
          docs: [
            "NOTE: This account is content-addressed (PDA seeded by the message hash).",
            "This is because in a multi-transceiver configuration, the different",
            'transceivers "vote" on messages (by delivering them). By making the inbox',
            "items content-addressed, we can ensure that disagreeing votes don't",
            "interfere with each other.",
            "On the first call to [`redeem()`], [`InboxItem`] will be allocated and initialized with",
            "default values.",
            'On subsequent calls, we want to modify the `InboxItem` by "voting" on it. Therefore the',
            "program should not fail which would occur when using the `init` constraint.",
            "The [`InboxItem::init`] field is used to guard against malicious or accidental modification",
            "InboxItem fields that should remain constant."
          ]
        },
        {
          name: "inboxRateLimit",
          isMut: !0,
          isSigner: !1
        },
        {
          name: "outboxRateLimit",
          isMut: !0,
          isSigner: !1
        },
        {
          name: "systemProgram",
          isMut: !1,
          isSigner: !1
        }
      ],
      args: [
        {
          name: "args",
          type: {
            defined: "RedeemArgs"
          }
        }
      ]
    },
    {
      name: "releaseInboundMint",
      accounts: [
        {
          name: "common",
          accounts: [
            {
              name: "payer",
              isMut: !0,
              isSigner: !0
            },
            {
              name: "config",
              accounts: [
                {
                  name: "config",
                  isMut: !1,
                  isSigner: !1
                }
              ]
            },
            {
              name: "inboxItem",
              isMut: !0,
              isSigner: !1
            },
            {
              name: "recipient",
              isMut: !0,
              isSigner: !1
            },
            {
              name: "tokenAuthority",
              isMut: !1,
              isSigner: !1,
              docs: [
                "CHECK The seeds constraint ensures that this is the correct address"
              ]
            },
            {
              name: "mint",
              isMut: !0,
              isSigner: !1
            },
            {
              name: "tokenProgram",
              isMut: !1,
              isSigner: !1
            },
            {
              name: "custody",
              isMut: !0,
              isSigner: !1
            }
          ]
        }
      ],
      args: [
        {
          name: "args",
          type: {
            defined: "ReleaseInboundArgs"
          }
        }
      ]
    },
    {
      name: "releaseInboundUnlock",
      accounts: [
        {
          name: "common",
          accounts: [
            {
              name: "payer",
              isMut: !0,
              isSigner: !0
            },
            {
              name: "config",
              accounts: [
                {
                  name: "config",
                  isMut: !1,
                  isSigner: !1
                }
              ]
            },
            {
              name: "inboxItem",
              isMut: !0,
              isSigner: !1
            },
            {
              name: "recipient",
              isMut: !0,
              isSigner: !1
            },
            {
              name: "tokenAuthority",
              isMut: !1,
              isSigner: !1,
              docs: [
                "CHECK The seeds constraint ensures that this is the correct address"
              ]
            },
            {
              name: "mint",
              isMut: !0,
              isSigner: !1
            },
            {
              name: "tokenProgram",
              isMut: !1,
              isSigner: !1
            },
            {
              name: "custody",
              isMut: !0,
              isSigner: !1
            }
          ]
        }
      ],
      args: [
        {
          name: "args",
          type: {
            defined: "ReleaseInboundArgs"
          }
        }
      ]
    },
    {
      name: "transferOwnership",
      accounts: [
        {
          name: "config",
          isMut: !0,
          isSigner: !1
        },
        {
          name: "owner",
          isMut: !1,
          isSigner: !0
        },
        {
          name: "newOwner",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "upgradeLock",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "programData",
          isMut: !0,
          isSigner: !1
        },
        {
          name: "bpfLoaderUpgradeableProgram",
          isMut: !1,
          isSigner: !1
        }
      ],
      args: []
    },
    {
      name: "transferOwnershipOneStepUnchecked",
      accounts: [
        {
          name: "config",
          isMut: !0,
          isSigner: !1
        },
        {
          name: "owner",
          isMut: !1,
          isSigner: !0
        },
        {
          name: "newOwner",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "upgradeLock",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "programData",
          isMut: !0,
          isSigner: !1
        },
        {
          name: "bpfLoaderUpgradeableProgram",
          isMut: !1,
          isSigner: !1
        }
      ],
      args: []
    },
    {
      name: "claimOwnership",
      accounts: [
        {
          name: "config",
          isMut: !0,
          isSigner: !1
        },
        {
          name: "upgradeLock",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "newOwner",
          isMut: !1,
          isSigner: !0
        },
        {
          name: "programData",
          isMut: !0,
          isSigner: !1
        },
        {
          name: "bpfLoaderUpgradeableProgram",
          isMut: !1,
          isSigner: !1
        }
      ],
      args: []
    },
    {
      name: "setPaused",
      accounts: [
        {
          name: "owner",
          isMut: !1,
          isSigner: !0
        },
        {
          name: "config",
          isMut: !0,
          isSigner: !1
        }
      ],
      args: [
        {
          name: "pause",
          type: "bool"
        }
      ]
    },
    {
      name: "setPeer",
      accounts: [
        {
          name: "payer",
          isMut: !0,
          isSigner: !0
        },
        {
          name: "owner",
          isMut: !1,
          isSigner: !0
        },
        {
          name: "config",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "peer",
          isMut: !0,
          isSigner: !1
        },
        {
          name: "inboxRateLimit",
          isMut: !0,
          isSigner: !1
        },
        {
          name: "systemProgram",
          isMut: !1,
          isSigner: !1
        }
      ],
      args: [
        {
          name: "args",
          type: {
            defined: "SetPeerArgs"
          }
        }
      ]
    },
    {
      name: "registerTransceiver",
      accounts: [
        {
          name: "config",
          isMut: !0,
          isSigner: !1
        },
        {
          name: "owner",
          isMut: !1,
          isSigner: !0
        },
        {
          name: "payer",
          isMut: !0,
          isSigner: !0
        },
        {
          name: "transceiver",
          isMut: !1,
          isSigner: !1,
          docs: [
            "used here that wraps the Transceiver account type."
          ]
        },
        {
          name: "registeredTransceiver",
          isMut: !0,
          isSigner: !1
        },
        {
          name: "systemProgram",
          isMut: !1,
          isSigner: !1
        }
      ],
      args: []
    },
    {
      name: "setOutboundLimit",
      accounts: [
        {
          name: "config",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "owner",
          isMut: !1,
          isSigner: !0
        },
        {
          name: "rateLimit",
          isMut: !0,
          isSigner: !1
        }
      ],
      args: [
        {
          name: "args",
          type: {
            defined: "SetOutboundLimitArgs"
          }
        }
      ]
    },
    {
      name: "setInboundLimit",
      accounts: [
        {
          name: "config",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "owner",
          isMut: !1,
          isSigner: !0
        },
        {
          name: "rateLimit",
          isMut: !0,
          isSigner: !1
        }
      ],
      args: [
        {
          name: "args",
          type: {
            defined: "SetInboundLimitArgs"
          }
        }
      ]
    },
    {
      name: "markOutboxItemAsReleased",
      accounts: [
        {
          name: "signer",
          isMut: !1,
          isSigner: !0
        },
        {
          name: "config",
          accounts: [
            {
              name: "config",
              isMut: !1,
              isSigner: !1
            }
          ]
        },
        {
          name: "outboxItem",
          isMut: !0,
          isSigner: !1
        },
        {
          name: "transceiver",
          isMut: !1,
          isSigner: !1
        }
      ],
      args: [],
      returns: "bool"
    },
    {
      name: "setWormholePeer",
      accounts: [
        {
          name: "config",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "owner",
          isMut: !1,
          isSigner: !0
        },
        {
          name: "payer",
          isMut: !0,
          isSigner: !0
        },
        {
          name: "peer",
          isMut: !0,
          isSigner: !1
        },
        {
          name: "systemProgram",
          isMut: !1,
          isSigner: !1
        }
      ],
      args: [
        {
          name: "args",
          type: {
            defined: "SetTransceiverPeerArgs"
          }
        }
      ]
    },
    {
      name: "receiveWormholeMessage",
      accounts: [
        {
          name: "payer",
          isMut: !0,
          isSigner: !0
        },
        {
          name: "config",
          accounts: [
            {
              name: "config",
              isMut: !1,
              isSigner: !1
            }
          ]
        },
        {
          name: "peer",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "vaa",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "transceiverMessage",
          isMut: !0,
          isSigner: !1
        },
        {
          name: "systemProgram",
          isMut: !1,
          isSigner: !1
        }
      ],
      args: []
    },
    {
      name: "releaseWormholeOutbound",
      accounts: [
        {
          name: "payer",
          isMut: !0,
          isSigner: !0
        },
        {
          name: "config",
          accounts: [
            {
              name: "config",
              isMut: !1,
              isSigner: !1
            }
          ]
        },
        {
          name: "outboxItem",
          isMut: !0,
          isSigner: !1
        },
        {
          name: "transceiver",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "wormholeMessage",
          isMut: !0,
          isSigner: !1
        },
        {
          name: "emitter",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "wormhole",
          accounts: [
            {
              name: "bridge",
              isMut: !0,
              isSigner: !1
            },
            {
              name: "feeCollector",
              isMut: !0,
              isSigner: !1
            },
            {
              name: "sequence",
              isMut: !0,
              isSigner: !1
            },
            {
              name: "program",
              isMut: !1,
              isSigner: !1
            },
            {
              name: "systemProgram",
              isMut: !1,
              isSigner: !1
            },
            {
              name: "clock",
              isMut: !1,
              isSigner: !1
            },
            {
              name: "rent",
              isMut: !1,
              isSigner: !1
            }
          ]
        }
      ],
      args: [
        {
          name: "args",
          type: {
            defined: "ReleaseOutboundArgs"
          }
        }
      ]
    },
    {
      name: "broadcastWormholeId",
      accounts: [
        {
          name: "payer",
          isMut: !0,
          isSigner: !0
        },
        {
          name: "config",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "mint",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "wormholeMessage",
          isMut: !0,
          isSigner: !0
        },
        {
          name: "emitter",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "wormhole",
          accounts: [
            {
              name: "bridge",
              isMut: !0,
              isSigner: !1
            },
            {
              name: "feeCollector",
              isMut: !0,
              isSigner: !1
            },
            {
              name: "sequence",
              isMut: !0,
              isSigner: !1
            },
            {
              name: "program",
              isMut: !1,
              isSigner: !1
            },
            {
              name: "systemProgram",
              isMut: !1,
              isSigner: !1
            },
            {
              name: "clock",
              isMut: !1,
              isSigner: !1
            },
            {
              name: "rent",
              isMut: !1,
              isSigner: !1
            }
          ]
        }
      ],
      args: []
    },
    {
      name: "broadcastWormholePeer",
      accounts: [
        {
          name: "payer",
          isMut: !0,
          isSigner: !0
        },
        {
          name: "config",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "peer",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "wormholeMessage",
          isMut: !0,
          isSigner: !0
        },
        {
          name: "emitter",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "wormhole",
          accounts: [
            {
              name: "bridge",
              isMut: !0,
              isSigner: !1
            },
            {
              name: "feeCollector",
              isMut: !0,
              isSigner: !1
            },
            {
              name: "sequence",
              isMut: !0,
              isSigner: !1
            },
            {
              name: "program",
              isMut: !1,
              isSigner: !1
            },
            {
              name: "systemProgram",
              isMut: !1,
              isSigner: !1
            },
            {
              name: "clock",
              isMut: !1,
              isSigner: !1
            },
            {
              name: "rent",
              isMut: !1,
              isSigner: !1
            }
          ]
        }
      ],
      args: [
        {
          name: "args",
          type: {
            defined: "BroadcastPeerArgs"
          }
        }
      ]
    }
  ],
  accounts: [
    {
      name: "config",
      type: {
        kind: "struct",
        fields: [
          {
            name: "bump",
            type: "u8"
          },
          {
            name: "owner",
            docs: [
              "Owner of the program."
            ],
            type: "publicKey"
          },
          {
            name: "pendingOwner",
            docs: [
              "Pending next owner (before claiming ownership)."
            ],
            type: {
              option: "publicKey"
            }
          },
          {
            name: "mint",
            docs: [
              "Mint address of the token managed by this program."
            ],
            type: "publicKey"
          },
          {
            name: "tokenProgram",
            docs: [
              "Address of the token program (token or token22). This could always be queried",
              "from the [`mint`] account's owner, but storing it here avoids an indirection",
              "on the client side."
            ],
            type: "publicKey"
          },
          {
            name: "mode",
            docs: [
              "The mode that this program is running in. This is used to determine",
              "whether the program is burning tokens or locking tokens."
            ],
            type: {
              defined: "Mode"
            }
          },
          {
            name: "chainId",
            docs: [
              "The chain id of the chain that this program is running on. We don't",
              "hardcode this so that the program is deployable on any potential SVM",
              "forks."
            ],
            type: {
              defined: "ChainId"
            }
          },
          {
            name: "nextTransceiverId",
            docs: [
              "The next transceiver id to use when registering an transceiver."
            ],
            type: "u8"
          },
          {
            name: "threshold",
            docs: [
              "The number of transceivers that must attest to a transfer before it is",
              "accepted."
            ],
            type: "u8"
          },
          {
            name: "enabledTransceivers",
            docs: [
              "Bitmap of enabled transceivers.",
              "The maximum number of transceivers is equal to [`Bitmap::BITS`]."
            ],
            type: {
              defined: "Bitmap"
            }
          },
          {
            name: "paused",
            docs: [
              "Pause the program. This is useful for upgrades and other maintenance."
            ],
            type: "bool"
          },
          {
            name: "custody",
            docs: [
              "The custody account that holds tokens in locking mode."
            ],
            type: "publicKey"
          }
        ]
      }
    },
    {
      name: "LUT",
      type: {
        kind: "struct",
        fields: [
          {
            name: "bump",
            type: "u8"
          },
          {
            name: "address",
            type: "publicKey"
          }
        ]
      }
    },
    {
      name: "nttManagerPeer",
      docs: [
        "A peer on another chain. Stored in a PDA seeded by the chain id."
      ],
      type: {
        kind: "struct",
        fields: [
          {
            name: "bump",
            type: "u8"
          },
          {
            name: "address",
            type: {
              array: [
                "u8",
                32
              ]
            }
          },
          {
            name: "tokenDecimals",
            type: "u8"
          }
        ]
      }
    },
    {
      name: "inboxItem",
      type: {
        kind: "struct",
        fields: [
          {
            name: "init",
            type: "bool"
          },
          {
            name: "bump",
            type: "u8"
          },
          {
            name: "amount",
            type: "u64"
          },
          {
            name: "recipientAddress",
            type: "publicKey"
          },
          {
            name: "votes",
            type: {
              defined: "Bitmap"
            }
          },
          {
            name: "releaseStatus",
            type: {
              defined: "ReleaseStatus"
            }
          }
        ]
      }
    },
    {
      name: "inboxRateLimit",
      docs: [
        "Inbound rate limit per chain.",
        "SECURITY: must check the PDA (since there are multiple PDAs, namely one for each chain.)"
      ],
      type: {
        kind: "struct",
        fields: [
          {
            name: "bump",
            type: "u8"
          },
          {
            name: "rateLimit",
            type: {
              defined: "RateLimitState"
            }
          }
        ]
      }
    },
    {
      name: "outboxItem",
      type: {
        kind: "struct",
        fields: [
          {
            name: "amount",
            type: {
              defined: "TrimmedAmount"
            }
          },
          {
            name: "sender",
            type: "publicKey"
          },
          {
            name: "recipientChain",
            type: {
              defined: "ChainId"
            }
          },
          {
            name: "recipientNttManager",
            type: {
              array: [
                "u8",
                32
              ]
            }
          },
          {
            name: "recipientAddress",
            type: {
              array: [
                "u8",
                32
              ]
            }
          },
          {
            name: "releaseTimestamp",
            type: "i64"
          },
          {
            name: "released",
            type: {
              defined: "Bitmap"
            }
          }
        ]
      }
    },
    {
      name: "outboxRateLimit",
      type: {
        kind: "struct",
        fields: [
          {
            name: "rateLimit",
            type: {
              defined: "RateLimitState"
            }
          }
        ]
      }
    },
    {
      name: "registeredTransceiver",
      type: {
        kind: "struct",
        fields: [
          {
            name: "bump",
            type: "u8"
          },
          {
            name: "id",
            type: "u8"
          },
          {
            name: "transceiverAddress",
            type: "publicKey"
          }
        ]
      }
    },
    {
      name: "transceiverPeer",
      docs: [
        "A peer on another chain. Stored in a PDA seeded by the chain id."
      ],
      type: {
        kind: "struct",
        fields: [
          {
            name: "bump",
            type: "u8"
          },
          {
            name: "address",
            type: {
              array: [
                "u8",
                32
              ]
            }
          }
        ]
      }
    },
    {
      name: "bridgeData",
      type: {
        kind: "struct",
        fields: [
          {
            name: "guardianSetIndex",
            docs: [
              "The current guardian set index, used to decide which signature sets to accept."
            ],
            type: "u32"
          },
          {
            name: "lastLamports",
            docs: [
              "Lamports in the collection account"
            ],
            type: "u64"
          },
          {
            name: "config",
            docs: [
              "Bridge configuration, which is set once upon initialization."
            ],
            type: {
              defined: "BridgeConfig"
            }
          }
        ]
      }
    }
  ],
  types: [
    {
      name: "Bitmap",
      type: {
        kind: "struct",
        fields: [
          {
            name: "map",
            type: "u128"
          }
        ]
      }
    },
    {
      name: "SetInboundLimitArgs",
      type: {
        kind: "struct",
        fields: [
          {
            name: "limit",
            type: "u64"
          },
          {
            name: "chainId",
            type: {
              defined: "ChainId"
            }
          }
        ]
      }
    },
    {
      name: "SetOutboundLimitArgs",
      type: {
        kind: "struct",
        fields: [
          {
            name: "limit",
            type: "u64"
          }
        ]
      }
    },
    {
      name: "SetPeerArgs",
      type: {
        kind: "struct",
        fields: [
          {
            name: "chainId",
            type: {
              defined: "ChainId"
            }
          },
          {
            name: "address",
            type: {
              array: [
                "u8",
                32
              ]
            }
          },
          {
            name: "limit",
            type: "u64"
          },
          {
            name: "tokenDecimals",
            docs: [
              "The token decimals on the peer chain."
            ],
            type: "u8"
          }
        ]
      }
    },
    {
      name: "InitializeArgs",
      type: {
        kind: "struct",
        fields: [
          {
            name: "chainId",
            type: "u16"
          },
          {
            name: "limit",
            type: "u64"
          },
          {
            name: "mode",
            type: {
              defined: "Mode"
            }
          }
        ]
      }
    },
    {
      name: "RedeemArgs",
      type: {
        kind: "struct",
        fields: []
      }
    },
    {
      name: "ReleaseInboundArgs",
      type: {
        kind: "struct",
        fields: [
          {
            name: "revertOnDelay",
            type: "bool"
          }
        ]
      }
    },
    {
      name: "TransferArgs",
      type: {
        kind: "struct",
        fields: [
          {
            name: "amount",
            type: "u64"
          },
          {
            name: "recipientChain",
            type: {
              defined: "ChainId"
            }
          },
          {
            name: "recipientAddress",
            type: {
              array: [
                "u8",
                32
              ]
            }
          },
          {
            name: "shouldQueue",
            type: "bool"
          }
        ]
      }
    },
    {
      name: "ReleaseStatus",
      docs: [
        "The status of an InboxItem. This determines whether the tokens are minted/unlocked to the recipient. As",
        "such, this must be used as a state machine that moves forward in a linear manner. A state",
        'should never "move backward" to a previous state (e.g. should never move from `Released` to',
        "`ReleaseAfter`)."
      ],
      type: {
        kind: "enum",
        variants: [
          {
            name: "NotApproved"
          },
          {
            name: "ReleaseAfter",
            fields: [
              "i64"
            ]
          },
          {
            name: "Released"
          }
        ]
      }
    },
    {
      name: "RateLimitState",
      type: {
        kind: "struct",
        fields: [
          {
            name: "limit",
            docs: [
              "The maximum capacity of the rate limiter."
            ],
            type: "u64"
          },
          {
            name: "capacityAtLastTx",
            docs: [
              "The capacity of the rate limiter at `last_tx_timestamp`.",
              "The actual current capacity is calculated in `capacity_at`, by",
              "accounting for the time that has passed since `last_tx_timestamp` and",
              "the refill rate."
            ],
            type: "u64"
          },
          {
            name: "lastTxTimestamp",
            docs: [
              "The timestamp of the last transaction that counted towards the current",
              "capacity. Transactions that exceeded the capacity do not count, they are",
              "just delayed."
            ],
            type: "i64"
          }
        ]
      }
    },
    {
      name: "SetTransceiverPeerArgs",
      type: {
        kind: "struct",
        fields: [
          {
            name: "chainId",
            type: {
              defined: "ChainId"
            }
          },
          {
            name: "address",
            type: {
              array: [
                "u8",
                32
              ]
            }
          }
        ]
      }
    },
    {
      name: "BroadcastPeerArgs",
      type: {
        kind: "struct",
        fields: [
          {
            name: "chainId",
            type: "u16"
          }
        ]
      }
    },
    {
      name: "ReleaseOutboundArgs",
      type: {
        kind: "struct",
        fields: [
          {
            name: "revertOnDelay",
            type: "bool"
          }
        ]
      }
    },
    {
      name: "ChainId",
      type: {
        kind: "struct",
        fields: [
          {
            name: "id",
            type: "u16"
          }
        ]
      }
    },
    {
      name: "Mode",
      type: {
        kind: "enum",
        variants: [
          {
            name: "Locking"
          },
          {
            name: "Burning"
          }
        ]
      }
    },
    {
      name: "TrimmedAmount",
      type: {
        kind: "struct",
        fields: [
          {
            name: "amount",
            type: "u64"
          },
          {
            name: "decimals",
            type: "u8"
          }
        ]
      }
    },
    {
      name: "BridgeConfig",
      type: {
        kind: "struct",
        fields: [
          {
            name: "guardianSetExpirationTime",
            docs: [
              "Period for how long a guardian set is valid after it has been replaced by a new one.  This",
              "guarantees that VAAs issued by that set can still be submitted for a certain period.  In",
              "this period we still trust the old guardian set."
            ],
            type: "u32"
          },
          {
            name: "fee",
            docs: [
              "Amount of lamports that needs to be paid to the protocol to post a message"
            ],
            type: "u64"
          }
        ]
      }
    }
  ],
  errors: [
    {
      code: 6e3,
      name: "CantReleaseYet",
      msg: "CantReleaseYet"
    },
    {
      code: 6001,
      name: "InvalidPendingOwner",
      msg: "InvalidPendingOwner"
    },
    {
      code: 6002,
      name: "InvalidChainId",
      msg: "InvalidChainId"
    },
    {
      code: 6003,
      name: "InvalidRecipientAddress",
      msg: "InvalidRecipientAddress"
    },
    {
      code: 6004,
      name: "InvalidTransceiverPeer",
      msg: "InvalidTransceiverPeer"
    },
    {
      code: 6005,
      name: "InvalidNttManagerPeer",
      msg: "InvalidNttManagerPeer"
    },
    {
      code: 6006,
      name: "InvalidRecipientNttManager",
      msg: "InvalidRecipientNttManager"
    },
    {
      code: 6007,
      name: "TransferAlreadyRedeemed",
      msg: "TransferAlreadyRedeemed"
    },
    {
      code: 6008,
      name: "TransferCannotBeRedeemed",
      msg: "TransferCannotBeRedeemed"
    },
    {
      code: 6009,
      name: "TransferNotApproved",
      msg: "TransferNotApproved"
    },
    {
      code: 6010,
      name: "MessageAlreadySent",
      msg: "MessageAlreadySent"
    },
    {
      code: 6011,
      name: "InvalidMode",
      msg: "InvalidMode"
    },
    {
      code: 6012,
      name: "InvalidMintAuthority",
      msg: "InvalidMintAuthority"
    },
    {
      code: 6013,
      name: "TransferExceedsRateLimit",
      msg: "TransferExceedsRateLimit"
    },
    {
      code: 6014,
      name: "Paused",
      msg: "Paused"
    },
    {
      code: 6015,
      name: "DisabledTransceiver",
      msg: "DisabledTransceiver"
    },
    {
      code: 6016,
      name: "InvalidDeployer",
      msg: "InvalidDeployer"
    },
    {
      code: 6017,
      name: "BadAmountAfterTransfer",
      msg: "BadAmountAfterTransfer"
    },
    {
      code: 6018,
      name: "BadAmountAfterBurn",
      msg: "BadAmountAfterBurn"
    },
    {
      code: 6019,
      name: "ZeroThreshold",
      msg: "ZeroThreshold"
    },
    {
      code: 6020,
      name: "OverflowExponent",
      msg: "OverflowExponent"
    },
    {
      code: 6021,
      name: "OverflowScaledAmount",
      msg: "OverflowScaledAmount"
    },
    {
      code: 6022,
      name: "BitmapIndexOutOfBounds",
      msg: "BitmapIndexOutOfBounds"
    },
    {
      code: 6023,
      name: "NoRegisteredTransceivers",
      msg: "NoRegisteredTransceivers"
    }
  ]
}, IDL$3 = {
  version: "3.0.0",
  name: "ntt_transceiver",
  instructions: [
    {
      name: "transceiverType",
      accounts: [],
      args: [],
      returns: "string"
    },
    {
      name: "setWormholePeer",
      accounts: [
        {
          name: "config",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "owner",
          isMut: !1,
          isSigner: !0
        },
        {
          name: "payer",
          isMut: !0,
          isSigner: !0
        },
        {
          name: "peer",
          isMut: !0,
          isSigner: !1
        },
        {
          name: "systemProgram",
          isMut: !1,
          isSigner: !1
        }
      ],
      args: [
        {
          name: "args",
          type: {
            defined: "SetTransceiverPeerArgs"
          }
        }
      ]
    },
    {
      name: "receiveWormholeMessage",
      accounts: [
        {
          name: "payer",
          isMut: !0,
          isSigner: !0
        },
        {
          name: "config",
          accounts: [
            {
              name: "config",
              isMut: !1,
              isSigner: !1
            }
          ]
        },
        {
          name: "peer",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "vaa",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "transceiverMessage",
          isMut: !0,
          isSigner: !1
        },
        {
          name: "systemProgram",
          isMut: !1,
          isSigner: !1
        }
      ],
      args: []
    },
    {
      name: "releaseWormholeOutbound",
      accounts: [
        {
          name: "payer",
          isMut: !0,
          isSigner: !0
        },
        {
          name: "config",
          accounts: [
            {
              name: "config",
              isMut: !1,
              isSigner: !1
            }
          ]
        },
        {
          name: "outboxItem",
          isMut: !0,
          isSigner: !1
        },
        {
          name: "transceiver",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "wormholeMessage",
          isMut: !0,
          isSigner: !1
        },
        {
          name: "emitter",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "wormhole",
          accounts: [
            {
              name: "bridge",
              isMut: !0,
              isSigner: !1
            },
            {
              name: "feeCollector",
              isMut: !0,
              isSigner: !1
            },
            {
              name: "sequence",
              isMut: !0,
              isSigner: !1
            },
            {
              name: "program",
              isMut: !1,
              isSigner: !1
            },
            {
              name: "systemProgram",
              isMut: !1,
              isSigner: !1
            },
            {
              name: "clock",
              isMut: !1,
              isSigner: !1
            },
            {
              name: "rent",
              isMut: !1,
              isSigner: !1
            }
          ]
        },
        {
          name: "manager",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "outboxItemSigner",
          isMut: !1,
          isSigner: !1
        }
      ],
      args: [
        {
          name: "args",
          type: {
            defined: "ReleaseOutboundArgs"
          }
        }
      ]
    },
    {
      name: "broadcastWormholeId",
      accounts: [
        {
          name: "payer",
          isMut: !0,
          isSigner: !0
        },
        {
          name: "config",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "mint",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "wormholeMessage",
          isMut: !0,
          isSigner: !0
        },
        {
          name: "emitter",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "wormhole",
          accounts: [
            {
              name: "bridge",
              isMut: !0,
              isSigner: !1
            },
            {
              name: "feeCollector",
              isMut: !0,
              isSigner: !1
            },
            {
              name: "sequence",
              isMut: !0,
              isSigner: !1
            },
            {
              name: "program",
              isMut: !1,
              isSigner: !1
            },
            {
              name: "systemProgram",
              isMut: !1,
              isSigner: !1
            },
            {
              name: "clock",
              isMut: !1,
              isSigner: !1
            },
            {
              name: "rent",
              isMut: !1,
              isSigner: !1
            }
          ]
        }
      ],
      args: []
    },
    {
      name: "broadcastWormholePeer",
      accounts: [
        {
          name: "payer",
          isMut: !0,
          isSigner: !0
        },
        {
          name: "config",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "peer",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "wormholeMessage",
          isMut: !0,
          isSigner: !0
        },
        {
          name: "emitter",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "wormhole",
          accounts: [
            {
              name: "bridge",
              isMut: !0,
              isSigner: !1
            },
            {
              name: "feeCollector",
              isMut: !0,
              isSigner: !1
            },
            {
              name: "sequence",
              isMut: !0,
              isSigner: !1
            },
            {
              name: "program",
              isMut: !1,
              isSigner: !1
            },
            {
              name: "systemProgram",
              isMut: !1,
              isSigner: !1
            },
            {
              name: "clock",
              isMut: !1,
              isSigner: !1
            },
            {
              name: "rent",
              isMut: !1,
              isSigner: !1
            }
          ]
        }
      ],
      args: [
        {
          name: "args",
          type: {
            defined: "BroadcastPeerArgs"
          }
        }
      ]
    }
  ],
  accounts: [
    {
      name: "config",
      type: {
        kind: "struct",
        fields: [
          {
            name: "bump",
            type: "u8"
          },
          {
            name: "owner",
            docs: [
              "Owner of the program."
            ],
            type: "publicKey"
          },
          {
            name: "pendingOwner",
            docs: [
              "Pending next owner (before claiming ownership)."
            ],
            type: {
              option: "publicKey"
            }
          },
          {
            name: "mint",
            docs: [
              "Mint address of the token managed by this program."
            ],
            type: "publicKey"
          },
          {
            name: "tokenProgram",
            docs: [
              "Address of the token program (token or token22). This could always be queried",
              "from the [`mint`] account's owner, but storing it here avoids an indirection",
              "on the client side."
            ],
            type: "publicKey"
          },
          {
            name: "mode",
            docs: [
              "The mode that this program is running in. This is used to determine",
              "whether the program is burning tokens or locking tokens."
            ],
            type: {
              defined: "Mode"
            }
          },
          {
            name: "chainId",
            docs: [
              "The chain id of the chain that this program is running on. We don't",
              "hardcode this so that the program is deployable on any potential SVM",
              "forks."
            ],
            type: {
              defined: "ChainId"
            }
          },
          {
            name: "nextTransceiverId",
            docs: [
              "The next transceiver id to use when registering an transceiver."
            ],
            type: "u8"
          },
          {
            name: "threshold",
            docs: [
              "The number of transceivers that must attest to a transfer before it is",
              "accepted."
            ],
            type: "u8"
          },
          {
            name: "enabledTransceivers",
            docs: [
              "Bitmap of enabled transceivers.",
              "The maximum number of transceivers is equal to [`Bitmap::BITS`]."
            ],
            type: {
              defined: "Bitmap"
            }
          },
          {
            name: "paused",
            docs: [
              "Pause the program. This is useful for upgrades and other maintenance."
            ],
            type: "bool"
          },
          {
            name: "custody",
            docs: [
              "The custody account that holds tokens in locking mode."
            ],
            type: "publicKey"
          }
        ]
      }
    },
    {
      name: "outboxItem",
      type: {
        kind: "struct",
        fields: [
          {
            name: "amount",
            type: {
              defined: "TrimmedAmount"
            }
          },
          {
            name: "sender",
            type: "publicKey"
          },
          {
            name: "recipientChain",
            type: {
              defined: "ChainId"
            }
          },
          {
            name: "recipientNttManager",
            type: {
              array: [
                "u8",
                32
              ]
            }
          },
          {
            name: "recipientAddress",
            type: {
              array: [
                "u8",
                32
              ]
            }
          },
          {
            name: "releaseTimestamp",
            type: "i64"
          },
          {
            name: "released",
            type: {
              defined: "Bitmap"
            }
          }
        ]
      }
    },
    {
      name: "registeredTransceiver",
      type: {
        kind: "struct",
        fields: [
          {
            name: "bump",
            type: "u8"
          },
          {
            name: "id",
            type: "u8"
          },
          {
            name: "transceiverAddress",
            type: "publicKey"
          }
        ]
      }
    },
    {
      name: "transceiverPeer",
      docs: [
        "A peer on another chain. Stored in a PDA seeded by the chain id."
      ],
      type: {
        kind: "struct",
        fields: [
          {
            name: "bump",
            type: "u8"
          },
          {
            name: "address",
            type: {
              array: [
                "u8",
                32
              ]
            }
          }
        ]
      }
    },
    {
      name: "bridgeData",
      type: {
        kind: "struct",
        fields: [
          {
            name: "guardianSetIndex",
            docs: [
              "The current guardian set index, used to decide which signature sets to accept."
            ],
            type: "u32"
          },
          {
            name: "lastLamports",
            docs: [
              "Lamports in the collection account"
            ],
            type: "u64"
          },
          {
            name: "config",
            docs: [
              "Bridge configuration, which is set once upon initialization."
            ],
            type: {
              defined: "BridgeConfig"
            }
          }
        ]
      }
    }
  ],
  types: [
    {
      name: "Bitmap",
      type: {
        kind: "struct",
        fields: [
          {
            name: "map",
            type: "u128"
          }
        ]
      }
    },
    {
      name: "ChainId",
      type: {
        kind: "struct",
        fields: [
          {
            name: "id",
            type: "u16"
          }
        ]
      }
    },
    {
      name: "Mode",
      type: {
        kind: "enum",
        variants: [
          {
            name: "Locking"
          },
          {
            name: "Burning"
          }
        ]
      }
    },
    {
      name: "TrimmedAmount",
      type: {
        kind: "struct",
        fields: [
          {
            name: "amount",
            type: "u64"
          },
          {
            name: "decimals",
            type: "u8"
          }
        ]
      }
    },
    {
      name: "SetTransceiverPeerArgs",
      type: {
        kind: "struct",
        fields: [
          {
            name: "chainId",
            type: {
              defined: "ChainId"
            }
          },
          {
            name: "address",
            type: {
              array: [
                "u8",
                32
              ]
            }
          }
        ]
      }
    },
    {
      name: "BroadcastPeerArgs",
      type: {
        kind: "struct",
        fields: [
          {
            name: "chainId",
            type: "u16"
          }
        ]
      }
    },
    {
      name: "ReleaseOutboundArgs",
      type: {
        kind: "struct",
        fields: [
          {
            name: "revertOnDelay",
            type: "bool"
          }
        ]
      }
    },
    {
      name: "BridgeConfig",
      type: {
        kind: "struct",
        fields: [
          {
            name: "guardianSetExpirationTime",
            docs: [
              "Period for how long a guardian set is valid after it has been replaced by a new one.  This",
              "guarantees that VAAs issued by that set can still be submitted for a certain period.  In",
              "this period we still trust the old guardian set."
            ],
            type: "u32"
          },
          {
            name: "fee",
            docs: [
              "Amount of lamports that needs to be paid to the protocol to post a message"
            ],
            type: "u64"
          }
        ]
      }
    }
  ]
}, IDL$2 = {
  version: "3.0.0",
  name: "ntt_quoter",
  instructions: [
    {
      name: "requestRelay",
      accounts: [
        {
          name: "payer",
          isMut: !0,
          isSigner: !0
        },
        {
          name: "instance",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "registeredChain",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "registeredNtt",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "outboxItem",
          isMut: !1,
          isSigner: !1,
          docs: [
            "and checking the release constraint into a single function"
          ]
        },
        {
          name: "relayRequest",
          isMut: !0,
          isSigner: !1
        },
        {
          name: "systemProgram",
          isMut: !1,
          isSigner: !1
        }
      ],
      args: [
        {
          name: "args",
          type: {
            defined: "RequestRelayArgs"
          }
        }
      ]
    },
    {
      name: "closeRelay",
      accounts: [
        {
          name: "authority",
          isMut: !1,
          isSigner: !0
        },
        {
          name: "instance",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "feeRecipient",
          isMut: !0,
          isSigner: !1
        },
        {
          name: "relayRequest",
          isMut: !0,
          isSigner: !1
        },
        {
          name: "systemProgram",
          isMut: !1,
          isSigner: !1
        }
      ],
      args: []
    },
    {
      name: "initialize",
      accounts: [
        {
          name: "owner",
          isMut: !0,
          isSigner: !0
        },
        {
          name: "instance",
          isMut: !0,
          isSigner: !1
        },
        {
          name: "feeRecipient",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "programData",
          isMut: !0,
          isSigner: !1,
          docs: [
            "We use the program data to make sure this owner is the upgrade authority (the true owner,",
            "who deployed this program)."
          ]
        },
        {
          name: "systemProgram",
          isMut: !1,
          isSigner: !1
        }
      ],
      args: []
    },
    {
      name: "setAssistant",
      accounts: [
        {
          name: "owner",
          isMut: !1,
          isSigner: !0
        },
        {
          name: "instance",
          isMut: !0,
          isSigner: !1
        },
        {
          name: "assistant",
          isMut: !1,
          isSigner: !1,
          isOptional: !0
        }
      ],
      args: []
    },
    {
      name: "setFeeRecipient",
      accounts: [
        {
          name: "owner",
          isMut: !1,
          isSigner: !0
        },
        {
          name: "instance",
          isMut: !0,
          isSigner: !1
        },
        {
          name: "feeRecipient",
          isMut: !1,
          isSigner: !1
        }
      ],
      args: []
    },
    {
      name: "registerChain",
      accounts: [
        {
          name: "authority",
          isMut: !0,
          isSigner: !0
        },
        {
          name: "instance",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "registeredChain",
          isMut: !0,
          isSigner: !1
        },
        {
          name: "systemProgram",
          isMut: !1,
          isSigner: !1
        }
      ],
      args: [
        {
          name: "args",
          type: {
            defined: "RegisterChainArgs"
          }
        }
      ]
    },
    {
      name: "registerNtt",
      accounts: [
        {
          name: "authority",
          isMut: !0,
          isSigner: !0
        },
        {
          name: "instance",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "registeredNtt",
          isMut: !0,
          isSigner: !1
        },
        {
          name: "systemProgram",
          isMut: !1,
          isSigner: !1
        }
      ],
      args: [
        {
          name: "args",
          type: {
            defined: "RegisterNttArgs"
          }
        }
      ]
    },
    {
      name: "deregisterNtt",
      accounts: [
        {
          name: "authority",
          isMut: !0,
          isSigner: !0
        },
        {
          name: "instance",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "registeredNtt",
          isMut: !0,
          isSigner: !1
        },
        {
          name: "systemProgram",
          isMut: !1,
          isSigner: !1
        }
      ],
      args: [
        {
          name: "args",
          type: {
            defined: "DeregisterNttArgs"
          }
        }
      ]
    },
    {
      name: "updateSolPrice",
      accounts: [
        {
          name: "authority",
          isMut: !1,
          isSigner: !0
        },
        {
          name: "instance",
          isMut: !0,
          isSigner: !1
        }
      ],
      args: [
        {
          name: "args",
          type: {
            defined: "UpdateSolPriceArgs"
          }
        }
      ]
    },
    {
      name: "updateChainPrices",
      accounts: [
        {
          name: "authority",
          isMut: !1,
          isSigner: !0
        },
        {
          name: "instance",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "registeredChain",
          isMut: !0,
          isSigner: !1
        }
      ],
      args: [
        {
          name: "args",
          type: {
            defined: "UpdateChainPricesArgs"
          }
        }
      ]
    },
    {
      name: "updateChainParams",
      accounts: [
        {
          name: "authority",
          isMut: !1,
          isSigner: !0
        },
        {
          name: "instance",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "registeredChain",
          isMut: !0,
          isSigner: !1
        }
      ],
      args: [
        {
          name: "args",
          type: {
            defined: "UpdateChainParamsArgs"
          }
        }
      ]
    }
  ],
  accounts: [
    {
      name: "instance",
      type: {
        kind: "struct",
        fields: [
          {
            name: "owner",
            type: "publicKey"
          },
          {
            name: "assistant",
            type: "publicKey"
          },
          {
            name: "feeRecipient",
            type: "publicKey"
          },
          {
            name: "solPrice",
            type: "u64"
          }
        ]
      }
    },
    {
      name: "registeredChain",
      type: {
        kind: "struct",
        fields: [
          {
            name: "bump",
            type: "u8"
          },
          {
            name: "maxGasDropoff",
            type: "u64"
          },
          {
            name: "basePrice",
            type: "u64"
          },
          {
            name: "nativePrice",
            type: "u64"
          },
          {
            name: "gasPrice",
            type: "u64"
          }
        ]
      }
    },
    {
      name: "registeredNtt",
      type: {
        kind: "struct",
        fields: [
          {
            name: "bump",
            type: "u8"
          },
          {
            name: "wormholeTransceiverIndex",
            type: "u8"
          },
          {
            name: "gasCost",
            type: "u32"
          }
        ]
      }
    },
    {
      name: "relayRequest",
      type: {
        kind: "struct",
        fields: [
          {
            name: "requestedGasDropoff",
            type: "u64"
          }
        ]
      }
    }
  ],
  types: [
    {
      name: "RegisterChainArgs",
      type: {
        kind: "struct",
        fields: [
          {
            name: "chainId",
            type: "u16"
          }
        ]
      }
    },
    {
      name: "RegisterNttArgs",
      type: {
        kind: "struct",
        fields: [
          {
            name: "nttProgramId",
            type: "publicKey"
          },
          {
            name: "wormholeTransceiverIndex",
            type: "u8"
          },
          {
            name: "gasCost",
            type: "u32"
          }
        ]
      }
    },
    {
      name: "DeregisterNttArgs",
      type: {
        kind: "struct",
        fields: [
          {
            name: "nttProgramId",
            type: "publicKey"
          }
        ]
      }
    },
    {
      name: "RequestRelayArgs",
      type: {
        kind: "struct",
        fields: [
          {
            name: "gasDropoff",
            type: "u64"
          },
          {
            name: "maxFee",
            type: "u64"
          }
        ]
      }
    },
    {
      name: "UpdateSolPriceArgs",
      type: {
        kind: "struct",
        fields: [
          {
            name: "solPrice",
            type: "u64"
          }
        ]
      }
    },
    {
      name: "UpdateChainPricesArgs",
      type: {
        kind: "struct",
        fields: [
          {
            name: "nativePrice",
            type: "u64"
          },
          {
            name: "gasPrice",
            type: "u64"
          }
        ]
      }
    },
    {
      name: "UpdateChainParamsArgs",
      type: {
        kind: "struct",
        fields: [
          {
            name: "maxGasDropoff",
            type: "u64"
          },
          {
            name: "basePrice",
            type: "u64"
          }
        ]
      }
    }
  ],
  errors: [
    {
      code: 6001,
      name: "ExceedsUserMaxFee",
      msg: "Relay fees exceeds specified max"
    },
    {
      code: 6002,
      name: "ExceedsMaxGasDropoff",
      msg: "Requested gas dropoff exceeds max allowed for chain"
    },
    {
      code: 6003,
      name: "InvalidFeeRecipient",
      msg: "The specified fee recipient does not match the address in the instance accound"
    },
    {
      code: 6004,
      name: "RelayingToChainDisabled",
      msg: "Relaying to the specified chain is disabled"
    },
    {
      code: 6005,
      name: "OutboxItemNotReleased",
      msg: "Relaying to the specified chain is disabled"
    },
    {
      code: 6006,
      name: "ScalingOverflow",
      msg: "Scaled value exceeds u64::MAX"
    },
    {
      code: 6007,
      name: "DivByZero",
      msg: "Cannot divide by zero"
    },
    {
      code: 6257,
      name: "FeeRecipientCannotBeDefault",
      msg: "The fee recipient cannot be the default address (0x0)"
    },
    {
      code: 6258,
      name: "NotAuthorized",
      msg: "Must be owner or assistant"
    },
    {
      code: 6259,
      name: "PriceCannotBeZero",
      msg: "The price cannot be zero"
    }
  ]
}, IDL$1 = {
  version: "3.0.0",
  name: "wormhole_governance",
  instructions: [
    {
      name: "governance",
      accounts: [
        {
          name: "payer",
          isMut: !0,
          isSigner: !0
        },
        {
          name: "governance",
          isMut: !0,
          isSigner: !1,
          docs: [
            "governed program. This account is validated by Wormhole, not this program."
          ]
        },
        {
          name: "vaa",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "program",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "replay",
          isMut: !0,
          isSigner: !1
        },
        {
          name: "systemProgram",
          isMut: !1,
          isSigner: !1
        }
      ],
      args: []
    }
  ],
  accounts: [
    {
      name: "replayProtection",
      type: {
        kind: "struct",
        fields: [
          {
            name: "bump",
            type: "u8"
          }
        ]
      }
    }
  ],
  errors: [
    {
      code: 6e3,
      name: "InvalidGovernanceChain",
      msg: "InvalidGovernanceChain"
    },
    {
      code: 6001,
      name: "InvalidGovernanceEmitter",
      msg: "InvalidGovernanceEmitter"
    },
    {
      code: 6002,
      name: "InvalidGovernanceProgram",
      msg: "InvalidGovernanceProgram"
    }
  ]
};
var _3_0_0;
(function(C) {
  C.idl = { ntt: IDL$4, transceiver: IDL$3, quoter: IDL$2, governance: IDL$1 };
})(_3_0_0 || (_3_0_0 = {}));
const IdlVersions = [
  ["3.0.0", _3_0_0],
  ["2.0.0", _2_0_0],
  ["1.0.0", _1_0_0]
];
function loadIdlVersion(C) {
  for (const [e, T] of IdlVersions)
    if (Ntt.abiVersionMatches(C, e))
      return T;
  throw new Error(`Unknown IDL version: ${C}`);
}
function getNttProgram(C, e, T) {
  const { idl: { ntt: $ } } = loadIdlVersion(T);
  return new Program($, e, {
    connection: C
  });
}
function getTransceiverProgram(C, e, T) {
  const { idl: { transceiver: $ } } = loadIdlVersion(T);
  return new Program($, e, {
    connection: C
  });
}
const BPF_LOADER_UPGRADEABLE_PROGRAM_ID = new PublicKey("BPFLoaderUpgradeab1e11111111111111111111111");
function programDataAddress(C) {
  return PublicKey.findProgramAddressSync([new PublicKey(C).toBytes()], BPF_LOADER_UPGRADEABLE_PROGRAM_ID)[0];
}
function parseVersion(C) {
  const e = C.split(".");
  if (e.length < 3)
    throw new Error("Invalid version string");
  const T = e[2], $ = T.split(/[^0-9]/)[0], V = T.slice($.length);
  return [
    Number(e[0]),
    Number(e[1]),
    Number($),
    V
  ];
}
const pubKeyConversion = {
  to: (C) => new PublicKey(C),
  from: (C) => C.toBytes()
}, programDataLayout = [
  { name: "slot", binary: "uint", endianness: "little", size: 8 },
  {
    name: "upgradeAuthority",
    binary: "switch",
    idSize: 1,
    idTag: "isSome",
    layouts: [
      [[0, !1], []],
      [
        [1, !0],
        [
          {
            name: "value",
            binary: "bytes",
            size: 32,
            custom: pubKeyConversion
          }
        ]
      ]
    ]
  }
], programVersionLayout = [
  { name: "length", binary: "uint", endianness: "little", size: 4 },
  { name: "version", binary: "bytes" }
], U64 = {
  MAX: new BN((2n ** 64n - 1n).toString()),
  to: (C, e) => {
    const T = new BN(Math.round(C * e));
    if (T.isNeg())
      throw new Error("Value negative");
    if (T.bitLength() > 64)
      throw new Error("Value too large");
    return T;
  },
  from: (C, e) => C.toNumber() / e
};
function derivePda(C, e) {
  const T = ($) => typeof $ == "string" ? bytes.encode($) : $;
  return PublicKey.findProgramAddressSync(Array.isArray(C) ? C.map(T) : [T(C)], new PublicKey(e))[0];
}
const chainToBytes = (C) => bignum.toBytes(toChainId(C), 2), quoterAddresses = (C) => ({
  relayRequestAccount: (J) => derivePda(["relay_request", J.toBytes()], C),
  instanceAccount: () => derivePda("instance", C),
  registeredChainAccount: (J) => derivePda(["registered_chain", chainToBytes(J)], C),
  registeredNttAccount: (J) => derivePda(["registered_ntt", J.toBytes()], C)
});
var NTT$1;
(function(C) {
  function e(we, Ee, Me) {
    return {
      amount: new BN(we.toString()),
      recipientChain: { id: toChainId(Ee.chain) },
      recipientAddress: Array.from(Ee.address.toUniversalAddress().toUint8Array()),
      shouldQueue: Me
    };
  }
  C.transferArgs = e, C.pdas = (we) => ({
    configAccount: () => derivePda("config", we),
    outboxRateLimitAccount: () => derivePda("outbox_rate_limit", we),
    inboxRateLimitAccount: (ce) => derivePda(["inbox_rate_limit", chainToBytes(ce)], we),
    inboxItemAccount: (ce, le) => derivePda(["inbox_item", Ntt.messageDigest(ce, le)], we),
    sessionAuthority: (ce, le) => derivePda([
      "session_authority",
      ce.toBytes(),
      keccak_256(bytes.concat(bytes.zpad(new Uint8Array(le.amount.toArray()), 8), chainToBytes(le.recipientChain.id), new Uint8Array(le.recipientAddress), new Uint8Array([le.shouldQueue ? 1 : 0])))
    ], we),
    tokenAuthority: () => derivePda("token_authority", we),
    peerAccount: (ce) => derivePda(["peer", chainToBytes(ce)], we),
    registeredTransceiver: (ce) => derivePda(["registered_transceiver", ce.toBytes()], we),
    lutAccount: () => derivePda("lut", we),
    lutAuthority: () => derivePda("lut_authority", we)
  }), C.transceiverPdas = (we) => ({
    emitterAccount: () => derivePda("emitter", we),
    outboxItemSigner: () => derivePda(["outbox_item_signer"], we),
    transceiverPeerAccount: (De) => derivePda(["transceiver_peer", chainToBytes(De)], we),
    transceiverMessageAccount: (De, Fe) => derivePda(["transceiver_message", chainToBytes(De), Fe], we),
    wormholeMessageAccount: (De) => derivePda(["message", De.toBytes()], we)
  });
  async function T(we, Ee, Me) {
    var le;
    if (!Me) {
      const pe = we.rpcEndpoint === rpcAddress("Devnet", "Solana") ? "6sbzC1eH4FTujJXWj51eQe25cYvr4xfXbJ1vAj7j2k5J" : we.rpcEndpoint.startsWith("http://localhost") ? "98evdAiWr7ey9MAQzoQQMwFQkTsSR6KkWQuFqKrgwNwb" : "Hk3SdYTJFpawrvRz4qRztuEt2SqoCG7BGj2yJfDJSFbJ";
      Me = new PublicKey(pe);
    }
    const Ie = getNttProgram(we, Ee.toString(), "1.0.0"), ke = await Ie.methods.version().accountsStrict({}).instruction(), { blockhash: _e } = await Ie.provider.connection.getLatestBlockhash("finalized"), De = new TransactionMessage({
      payerKey: Me,
      recentBlockhash: _e,
      instructions: [ke]
    }).compileToV0Message(), Fe = new VersionedTransaction(De), Ae = await Ie.provider.connection.simulateTransaction(Fe, { sigVerify: !1 });
    if (!Ae.value.returnData || Ae.value.err)
      throw new Error("Could not fetch IDL version: " + JSON.stringify(translateError(Ae.value.err, parseIdlErrors(Ie.idl))));
    const ne = b64.decode((le = Ae.value.returnData) == null ? void 0 : le.data[0]), oe = deserialize$2(programVersionLayout, ne), ce = bytes.decode(oe.version);
    for (const [pe] of IdlVersions)
      if (Ntt.abiVersionMatches(ce, pe))
        return pe;
    throw new Error(`Unknown IDL version: ${ce}`);
  }
  C.getVersion = T;
  async function $(we, Ee, Me) {
    const Ie = Ee.mode === "burning" ? { burning: {} } : { locking: {} }, ke = toChainId(Ee.chain);
    Me = Me ?? C.pdas(we.programId);
    const _e = new BN(Ee.outboundLimit.toString());
    return await we.methods.initialize({ chainId: ke, limit: _e, mode: Ie }).accountsStrict({
      payer: Ee.payer,
      deployer: Ee.owner,
      programData: programDataAddress(we.programId),
      config: Me.configAccount(),
      mint: Ee.mint,
      rateLimit: Me.outboxRateLimitAccount(),
      tokenProgram: Ee.tokenProgram,
      tokenAuthority: Me.tokenAuthority(),
      custody: await C.custodyAccountAddress(Me, Ee.mint, Ee.tokenProgram),
      bpfLoaderUpgradeableProgram: BPF_LOADER_UPGRADEABLE_PROGRAM_ID,
      associatedTokenProgram: ASSOCIATED_TOKEN_PROGRAM_ID,
      systemProgram: SystemProgram.programId
    }).instruction();
  }
  C.createInitializeInstruction = $;
  async function V(we, Ee, Me, Ie, ke) {
    var ye;
    const [_e, , ,] = parseVersion(we.idl.version);
    if (_e < 2)
      return;
    ke = ke ?? C.pdas(we.programId);
    const De = await we.provider.connection.getSlot() - 1, [Fe, Ae] = AddressLookupTableProgram.createLookupTable({
      authority: ke.lutAuthority(),
      payer: Ie.payer,
      recentSlot: De
    }), ne = getWormholeDerivedAccounts(Me, Ie.wormholeId.toString()), oe = {
      config: ke.configAccount(),
      custody: Ee.custody,
      tokenProgram: Ee.tokenProgram,
      mint: Ee.mint,
      tokenAuthority: ke.tokenAuthority(),
      outboxRateLimit: ke.outboxRateLimitAccount(),
      wormhole: {
        bridge: ne.wormholeBridge,
        feeCollector: ne.wormholeFeeCollector,
        sequence: ne.wormholeSequence,
        program: Ie.wormholeId,
        systemProgram: SystemProgram.programId,
        clock: SYSVAR_CLOCK_PUBKEY,
        rent: SYSVAR_RENT_PUBKEY
      }
    }, ce = (Ce) => {
      const be = new Array();
      for (const ae in Ce) {
        const ge = Ce[ae];
        ge instanceof PublicKey ? be.push(ge) : typeof ge == "object" && be.push(...ce(ge));
      }
      return be;
    }, le = ce(oe).map((Ce) => Ce.toBase58()), pe = await ve(we, ke);
    if (pe !== null) {
      const Ce = ((ye = pe.state.addresses) == null ? void 0 : ye.map((ae) => ae.toBase58())) ?? [];
      if (le.filter((ae) => !Ce.includes(ae)).length === 0)
        return null;
    }
    return await we.methods.initializeLut(new BN(De)).accountsStrict({
      payer: Ie.payer,
      authority: ke.lutAuthority(),
      lutAddress: Ae,
      lut: ke.lutAccount(),
      lutProgram: AddressLookupTableProgram.programId,
      systemProgram: SystemProgram.programId,
      entries: oe
    }).instruction();
  }
  C.initializeOrUpdateLUT = V;
  async function J(we, Ee, Me, Ie) {
    Ie = Ie ?? C.pdas(we.programId);
    const ke = await Te(Ie, Ee), _e = toChain(Me.transferArgs.recipientChain.id), De = await we.methods.transferBurn(Me.transferArgs).accountsStrict({
      common: {
        payer: Me.payer,
        config: { config: Ie.configAccount() },
        mint: Ee.mint,
        from: Me.from,
        tokenProgram: Ee.tokenProgram,
        outboxItem: Me.outboxItem,
        outboxRateLimit: Ie.outboxRateLimitAccount(),
        systemProgram: SystemProgram.programId,
        custody: ke
      },
      peer: Ie.peerAccount(_e),
      inboxRateLimit: Ie.inboxRateLimitAccount(_e),
      sessionAuthority: Ie.sessionAuthority(Me.fromAuthority, Me.transferArgs),
      tokenAuthority: Ie.tokenAuthority()
    }).instruction(), Fe = await getMint(we.provider.connection, Ee.mint, void 0, Ee.tokenProgram), Ae = getTransferHook(Fe);
    if (Ae) {
      const ne = Me.from, oe = Ee.mint, ce = await Te(Ie, Ee), le = Ie.sessionAuthority(Me.fromAuthority, Me.transferArgs);
      await addExtraAccountMetasForExecute(
        we.provider.connection,
        De,
        Ae.programId,
        ne,
        oe,
        ce,
        le,
        // TODO(csongor): compute the amount that's passed into transfer.
        // Leaving this 0 is fine unless the transfer hook accounts addresses
        // depend on the amount (which is unlikely).
        // If this turns out to be the case, the amount to put here is the
        // untrimmed amount after removing dust.
        0
      );
    }
    return De;
  }
  C.createTransferBurnInstruction = J;
  async function ee(we, Ee, Me, Ie) {
    if (Ee.paused)
      throw new Error("Contract is paused");
    Ie = Ie ?? C.pdas(we.programId);
    const ke = toChain(Me.transferArgs.recipientChain.id), _e = await Te(Ie, Ee), De = await we.methods.transferLock(Me.transferArgs).accountsStrict({
      common: {
        payer: Me.payer,
        config: { config: Ie.configAccount() },
        mint: Ee.mint,
        from: Me.from,
        tokenProgram: Ee.tokenProgram,
        outboxItem: Me.outboxItem,
        outboxRateLimit: Ie.outboxRateLimitAccount(),
        custody: _e,
        systemProgram: SystemProgram.programId
      },
      peer: Ie.peerAccount(ke),
      inboxRateLimit: Ie.inboxRateLimitAccount(ke),
      sessionAuthority: Ie.sessionAuthority(Me.fromAuthority, Me.transferArgs),
      custody: _e
    }).instruction(), Fe = await getMint(we.provider.connection, Ee.mint, void 0, Ee.tokenProgram), Ae = getTransferHook(Fe);
    if (Ae) {
      const ne = Me.from, oe = await Te(Ie, Ee), ce = Ie.sessionAuthority(Me.fromAuthority, Me.transferArgs);
      await addExtraAccountMetasForExecute(
        we.provider.connection,
        De,
        Ae.programId,
        ne,
        Ee.mint,
        oe,
        ce,
        // TODO(csongor): compute the amount that's passed into transfer.
        // Leaving this 0 is fine unless the transfer hook accounts addresses
        // depend on the amount (which is unlikely).
        // If this turns out to be the case, the amount to put here is the
        // untrimmed amount after removing dust.
        0
      );
    }
    return De;
  }
  C.createTransferLockInstruction = ee;
  async function te(we, Ee, Me, Ie) {
    Ie = Ie ?? C.pdas(we.programId);
    const ke = Me.recipient ?? (await xe(we, Me.chain, Me.nttMessage)).recipientAddress, _e = await we.methods.releaseInboundMint({
      revertOnDelay: Me.revertOnDelay
    }).accountsStrict({
      common: {
        payer: Me.payer,
        config: { config: Ie.configAccount() },
        inboxItem: Ie.inboxItemAccount(Me.chain, Me.nttMessage),
        recipient: getAssociatedTokenAddressSync(Ee.mint, ke, !0, Ee.tokenProgram),
        mint: Ee.mint,
        tokenAuthority: Ie.tokenAuthority(),
        tokenProgram: Ee.tokenProgram,
        custody: await Te(Ie, Ee)
      }
    }).instruction(), De = await getMint(we.provider.connection, Ee.mint, void 0, Ee.tokenProgram), Fe = getTransferHook(De);
    if (Fe) {
      const Ae = await Te(Ie, Ee), ne = Ee.mint, oe = getAssociatedTokenAddressSync(ne, ke, !0, Ee.tokenProgram), ce = Ie.tokenAuthority();
      await addExtraAccountMetasForExecute(
        we.provider.connection,
        _e,
        Fe.programId,
        Ae,
        ne,
        oe,
        ce,
        // TODO(csongor): compute the amount that's passed into transfer.
        // Leaving this 0 is fine unless the transfer hook accounts addresses
        // depend on the amount (which is unlikely).
        // If this turns out to be the case, the amount to put here is the
        // untrimmed amount after removing dust.
        0
      );
    }
    return _e;
  }
  C.createReleaseInboundMintInstruction = te;
  async function re(we, Ee, Me, Ie) {
    const ke = Me.recipient ?? (await C.getInboxItem(we, Me.chain, Me.nttMessage)).recipientAddress;
    Ie = Ie ?? C.pdas(we.programId);
    const _e = await Te(Ie, Ee), De = await we.methods.releaseInboundUnlock({
      revertOnDelay: Me.revertOnDelay
    }).accountsStrict({
      common: {
        payer: Me.payer,
        config: { config: Ie.configAccount() },
        inboxItem: Ie.inboxItemAccount(Me.chain, Me.nttMessage),
        recipient: getAssociatedTokenAddressSync(Ee.mint, ke, !0, Ee.tokenProgram),
        mint: Ee.mint,
        tokenAuthority: Ie.tokenAuthority(),
        tokenProgram: Ee.tokenProgram,
        custody: _e
      },
      custody: _e
    }).instruction(), Fe = await getMint(we.provider.connection, Ee.mint, void 0, Ee.tokenProgram), Ae = getTransferHook(Fe);
    if (Ae) {
      const ne = await Te(Ie, Ee), oe = Ee.mint, ce = getAssociatedTokenAddressSync(oe, ke, !0, Ee.tokenProgram), le = Ie.tokenAuthority();
      await addExtraAccountMetasForExecute(
        we.provider.connection,
        De,
        Ae.programId,
        ne,
        oe,
        ce,
        le,
        // TODO(csongor): compute the amount that's passed into transfer.
        // Leaving this 0 is fine unless the transfer hook accounts addresses
        // depend on the amount (which is unlikely).
        // If this turns out to be the case, the amount to put here is the
        // untrimmed amount after removing dust.
        0
      );
    }
    return De;
  }
  C.createReleaseInboundUnlockInstruction = re;
  async function ie(we, Ee, Me) {
    return Me = Me ?? C.pdas(we.programId), await we.methods.transferOwnership().accounts({
      config: Me.configAccount(),
      newOwner: Ee.newOwner
    }).instruction();
  }
  C.createTransferOwnershipInstruction = ie;
  async function se(we, Ee, Me) {
    return Me = Me ?? C.pdas(we.programId), await we.methods.setPeer({
      chainId: { id: toChainId(Ee.chain) },
      address: Array.from(Ee.address),
      limit: Ee.limit,
      tokenDecimals: Ee.tokenDecimals
    }).accounts({
      payer: Ee.payer,
      owner: Ee.owner,
      config: Me.configAccount(),
      peer: Me.peerAccount(Ee.chain),
      inboxRateLimit: Me.inboxRateLimitAccount(Ee.chain)
    }).instruction();
  }
  C.createSetPeerInstruction = se;
  async function de(we, Ee, Me) {
    return Me = Me ?? C.pdas(we.programId), await we.methods.setPaused(Ee.paused).accountsStrict({
      owner: Ee.owner,
      config: Me.configAccount()
    }).instruction();
  }
  C.createSetPausedInstruction = de;
  async function ue(we, Ee, Me) {
    return Me = Me ?? C.pdas(we.programId), await we.methods.setOutboundLimit({
      limit: Ee.limit
    }).accounts({
      owner: Ee.owner,
      config: Me.configAccount(),
      rateLimit: Me.outboxRateLimitAccount()
    }).instruction();
  }
  C.createSetOutboundLimitInstruction = ue;
  async function fe(we, Ee, Me) {
    return Me = Me ?? C.pdas(we.programId), await we.methods.setInboundLimit({
      chainId: { id: toChainId(Ee.chain) },
      limit: Ee.limit
    }).accounts({
      owner: Ee.owner,
      config: Me.configAccount(),
      rateLimit: Me.inboxRateLimitAccount(Ee.chain)
    }).instruction();
  }
  C.setInboundLimit = fe;
  async function he(we, Ee, Me, Ie, ke, _e) {
    ke = ke ?? C.pdas(we.programId), _e = _e ?? C.transceiverPdas(Me);
    const De = Ie.vaa, Fe = De.payload.nttManagerPayload, Ae = De.emitterChain;
    return we.methods.redeem({}).accounts({
      payer: Ie.payer,
      config: ke.configAccount(),
      peer: ke.peerAccount(Ae),
      transceiverMessage: _e.transceiverMessageAccount(Ae, Fe.id),
      transceiver: ke.registeredTransceiver(Me),
      mint: Ee.mint,
      inboxItem: ke.inboxItemAccount(Ae, Fe),
      inboxRateLimit: ke.inboxRateLimitAccount(Ae),
      outboxRateLimit: ke.outboxRateLimitAccount()
    }).instruction();
  }
  C.createRedeemInstruction = he;
  async function me(we, Ee) {
    return await we.account.config.fetch(Ee.configAccount());
  }
  C.getConfig = me;
  async function xe(we, Ee, Me) {
    return await we.account.inboxItem.fetch(C.pdas(we.programId).inboxItemAccount(Ee, Me));
  }
  C.getInboxItem = xe;
  async function ve(we, Ee) {
    const [Me, , ,] = parseVersion(we.idl.version);
    if (Me < 2)
      return null;
    Ee = Ee ?? C.pdas(we.programId);
    const Ie = await we.account.lut.fetchNullable(Ee.lutAccount());
    if (!Ie)
      return null;
    const ke = await we.provider.connection.getAddressLookupTable(Ie.address);
    if (ke.value === null)
      throw new Error("Could not fetch LUT");
    return ke.value;
  }
  C.getAddressLookupTable = ve;
  async function Te(we, Ee, Me = TOKEN_PROGRAM_ID) {
    return Ee instanceof PublicKey ? getAssociatedTokenAddress$1(Ee, we.tokenAuthority(), !0, Me) : getAssociatedTokenAddress$1(Ee.mint, we.tokenAuthority(), !0, Ee.tokenProgram);
  }
  C.custodyAccountAddress = Te;
})(NTT$1 || (NTT$1 = {}));
async function addExtraAccountMetasForExecute(C, e, T, $, V, J, ee, te, re) {
  const ie = getExtraAccountMetaAddress(V, T), se = await C.getAccountInfo(ie, re);
  if (se == null)
    return e;
  const de = getExtraAccountMetas(se);
  if (![$, V, J, ee].every((fe) => e.keys.some((he) => he.pubkey.equals(fe))))
    throw new Error("Missing required account in instruction");
  const ue = createExecuteInstruction(T, $, V, J, ee, ie, BigInt(te));
  for (const fe of de)
    ue.keys.push(deEscalateAccountMeta(await resolveExtraAccountMeta(C, fe, ue.keys, ue.data, ue.programId), ue.keys));
  e.keys.push(...ue.keys.slice(5)), e.keys.push({
    pubkey: T,
    isSigner: !1,
    isWritable: !1
  }), e.keys.push({
    pubkey: ie,
    isSigner: !1,
    isWritable: !1
  });
}
function deEscalateAccountMeta(C, e) {
  const T = e.filter(($) => $.pubkey.equals(C.pubkey)).reduce(($, V) => $ ? {
    isSigner: $.isSigner || V.isSigner,
    isWritable: $.isWritable || V.isWritable
  } : { isSigner: V.isSigner, isWritable: V.isWritable }, void 0);
  if (T) {
    const { isSigner: $, isWritable: V } = T;
    !$ && $ !== C.isSigner && (C.isSigner = !1), !V && V !== C.isWritable && (C.isWritable = !1);
  }
  return C;
}
const version = "2.0.0", name = "ntt_quoter", instructions = [
  {
    name: "requestRelay",
    accounts: [
      {
        name: "payer",
        isMut: !0,
        isSigner: !0
      },
      {
        name: "instance",
        isMut: !1,
        isSigner: !1
      },
      {
        name: "registeredChain",
        isMut: !1,
        isSigner: !1
      },
      {
        name: "registeredNtt",
        isMut: !1,
        isSigner: !1
      },
      {
        name: "outboxItem",
        isMut: !1,
        isSigner: !1,
        docs: [
          "and checking the release constraint into a single function"
        ]
      },
      {
        name: "relayRequest",
        isMut: !0,
        isSigner: !1
      },
      {
        name: "systemProgram",
        isMut: !1,
        isSigner: !1
      }
    ],
    args: [
      {
        name: "args",
        type: {
          defined: "RequestRelayArgs"
        }
      }
    ]
  },
  {
    name: "closeRelay",
    accounts: [
      {
        name: "authority",
        isMut: !1,
        isSigner: !0
      },
      {
        name: "instance",
        isMut: !1,
        isSigner: !1
      },
      {
        name: "feeRecipient",
        isMut: !0,
        isSigner: !1
      },
      {
        name: "relayRequest",
        isMut: !0,
        isSigner: !1
      },
      {
        name: "systemProgram",
        isMut: !1,
        isSigner: !1
      }
    ],
    args: []
  },
  {
    name: "initialize",
    accounts: [
      {
        name: "owner",
        isMut: !0,
        isSigner: !0
      },
      {
        name: "instance",
        isMut: !0,
        isSigner: !1
      },
      {
        name: "feeRecipient",
        isMut: !1,
        isSigner: !1
      },
      {
        name: "programData",
        isMut: !0,
        isSigner: !1,
        docs: [
          "We use the program data to make sure this owner is the upgrade authority (the true owner,",
          "who deployed this program)."
        ]
      },
      {
        name: "systemProgram",
        isMut: !1,
        isSigner: !1
      }
    ],
    args: []
  },
  {
    name: "setAssistant",
    accounts: [
      {
        name: "owner",
        isMut: !1,
        isSigner: !0
      },
      {
        name: "instance",
        isMut: !0,
        isSigner: !1
      },
      {
        name: "assistant",
        isMut: !1,
        isSigner: !1,
        isOptional: !0
      }
    ],
    args: []
  },
  {
    name: "setFeeRecipient",
    accounts: [
      {
        name: "owner",
        isMut: !1,
        isSigner: !0
      },
      {
        name: "instance",
        isMut: !0,
        isSigner: !1
      },
      {
        name: "feeRecipient",
        isMut: !1,
        isSigner: !1
      }
    ],
    args: []
  },
  {
    name: "registerChain",
    accounts: [
      {
        name: "authority",
        isMut: !0,
        isSigner: !0
      },
      {
        name: "instance",
        isMut: !1,
        isSigner: !1
      },
      {
        name: "registeredChain",
        isMut: !0,
        isSigner: !1
      },
      {
        name: "systemProgram",
        isMut: !1,
        isSigner: !1
      }
    ],
    args: [
      {
        name: "args",
        type: {
          defined: "RegisterChainArgs"
        }
      }
    ]
  },
  {
    name: "registerNtt",
    accounts: [
      {
        name: "authority",
        isMut: !0,
        isSigner: !0
      },
      {
        name: "instance",
        isMut: !1,
        isSigner: !1
      },
      {
        name: "registeredNtt",
        isMut: !0,
        isSigner: !1
      },
      {
        name: "systemProgram",
        isMut: !1,
        isSigner: !1
      }
    ],
    args: [
      {
        name: "args",
        type: {
          defined: "RegisterNttArgs"
        }
      }
    ]
  },
  {
    name: "deregisterNtt",
    accounts: [
      {
        name: "authority",
        isMut: !0,
        isSigner: !0
      },
      {
        name: "instance",
        isMut: !1,
        isSigner: !1
      },
      {
        name: "registeredNtt",
        isMut: !0,
        isSigner: !1
      },
      {
        name: "systemProgram",
        isMut: !1,
        isSigner: !1
      }
    ],
    args: [
      {
        name: "args",
        type: {
          defined: "DeregisterNttArgs"
        }
      }
    ]
  },
  {
    name: "updateSolPrice",
    accounts: [
      {
        name: "authority",
        isMut: !1,
        isSigner: !0
      },
      {
        name: "instance",
        isMut: !0,
        isSigner: !1
      }
    ],
    args: [
      {
        name: "args",
        type: {
          defined: "UpdateSolPriceArgs"
        }
      }
    ]
  },
  {
    name: "updateChainPrices",
    accounts: [
      {
        name: "authority",
        isMut: !1,
        isSigner: !0
      },
      {
        name: "instance",
        isMut: !1,
        isSigner: !1
      },
      {
        name: "registeredChain",
        isMut: !0,
        isSigner: !1
      }
    ],
    args: [
      {
        name: "args",
        type: {
          defined: "UpdateChainPricesArgs"
        }
      }
    ]
  },
  {
    name: "updateChainParams",
    accounts: [
      {
        name: "authority",
        isMut: !1,
        isSigner: !0
      },
      {
        name: "instance",
        isMut: !1,
        isSigner: !1
      },
      {
        name: "registeredChain",
        isMut: !0,
        isSigner: !1
      }
    ],
    args: [
      {
        name: "args",
        type: {
          defined: "UpdateChainParamsArgs"
        }
      }
    ]
  }
], accounts = [
  {
    name: "Instance",
    type: {
      kind: "struct",
      fields: [
        {
          name: "owner",
          type: "publicKey"
        },
        {
          name: "assistant",
          type: "publicKey"
        },
        {
          name: "feeRecipient",
          type: "publicKey"
        },
        {
          name: "solPrice",
          type: "u64"
        }
      ]
    }
  },
  {
    name: "RegisteredChain",
    type: {
      kind: "struct",
      fields: [
        {
          name: "bump",
          type: "u8"
        },
        {
          name: "maxGasDropoff",
          type: "u64"
        },
        {
          name: "basePrice",
          type: "u64"
        },
        {
          name: "nativePrice",
          type: "u64"
        },
        {
          name: "gasPrice",
          type: "u64"
        }
      ]
    }
  },
  {
    name: "RegisteredNtt",
    type: {
      kind: "struct",
      fields: [
        {
          name: "bump",
          type: "u8"
        },
        {
          name: "wormholeTransceiverIndex",
          type: "u8"
        },
        {
          name: "gasCost",
          type: "u32"
        }
      ]
    }
  },
  {
    name: "RelayRequest",
    type: {
      kind: "struct",
      fields: [
        {
          name: "requestedGasDropoff",
          type: "u64"
        }
      ]
    }
  }
], types = [
  {
    name: "RegisterChainArgs",
    type: {
      kind: "struct",
      fields: [
        {
          name: "chainId",
          type: "u16"
        }
      ]
    }
  },
  {
    name: "RegisterNttArgs",
    type: {
      kind: "struct",
      fields: [
        {
          name: "nttProgramId",
          type: "publicKey"
        },
        {
          name: "wormholeTransceiverIndex",
          type: "u8"
        },
        {
          name: "gasCost",
          type: "u32"
        }
      ]
    }
  },
  {
    name: "DeregisterNttArgs",
    type: {
      kind: "struct",
      fields: [
        {
          name: "nttProgramId",
          type: "publicKey"
        }
      ]
    }
  },
  {
    name: "RequestRelayArgs",
    type: {
      kind: "struct",
      fields: [
        {
          name: "gasDropoff",
          type: "u64"
        },
        {
          name: "maxFee",
          type: "u64"
        }
      ]
    }
  },
  {
    name: "UpdateSolPriceArgs",
    type: {
      kind: "struct",
      fields: [
        {
          name: "solPrice",
          type: "u64"
        }
      ]
    }
  },
  {
    name: "UpdateChainPricesArgs",
    type: {
      kind: "struct",
      fields: [
        {
          name: "nativePrice",
          type: "u64"
        },
        {
          name: "gasPrice",
          type: "u64"
        }
      ]
    }
  },
  {
    name: "UpdateChainParamsArgs",
    type: {
      kind: "struct",
      fields: [
        {
          name: "maxGasDropoff",
          type: "u64"
        },
        {
          name: "basePrice",
          type: "u64"
        }
      ]
    }
  }
], errors = [
  {
    code: 6001,
    name: "ExceedsUserMaxFee",
    msg: "Relay fees exceeds specified max"
  },
  {
    code: 6002,
    name: "ExceedsMaxGasDropoff",
    msg: "Requested gas dropoff exceeds max allowed for chain"
  },
  {
    code: 6003,
    name: "InvalidFeeRecipient",
    msg: "The specified fee recipient does not match the address in the instance accound"
  },
  {
    code: 6004,
    name: "RelayingToChainDisabled",
    msg: "Relaying to the specified chain is disabled"
  },
  {
    code: 6005,
    name: "OutboxItemNotReleased",
    msg: "Relaying to the specified chain is disabled"
  },
  {
    code: 6006,
    name: "ScalingOverflow",
    msg: "Scaled value exceeds u64::MAX"
  },
  {
    code: 6007,
    name: "DivByZero",
    msg: "Cannot divide by zero"
  },
  {
    code: 6257,
    name: "FeeRecipientCannotBeDefault",
    msg: "The fee recipient cannot be the default address (0x0)"
  },
  {
    code: 6258,
    name: "NotAuthorized",
    msg: "Must be owner or assistant"
  },
  {
    code: 6259,
    name: "PriceCannotBeZero",
    msg: "The price cannot be zero"
  }
], IDL = {
  version,
  name,
  instructions,
  accounts,
  types,
  errors
}, USD_UNIT = 1e6, GWEI_PER_ETH = 1e9, WEI_PER_GWEI = 1e9, SEED_PREFIX_INSTANCE = "instance", SEED_PREFIX_REGISTERED_CHAIN = "registered_chain", SEED_PREFIX_REGISTERED_NTT = "registered_ntt", SEED_PREFIX_RELAY_REQUEST = "relay_request";
class NttQuoter {
  constructor(e, T, $) {
    tt(this, "instance");
    tt(this, "program");
    tt(this, "nttProgramId");
    tt(this, "pdas");
    this.program = new Program(IDL, new PublicKey(T), {
      connection: e
    }), this.nttProgramId = new PublicKey($), this.pdas = quoterAddresses(this.program.programId), this.instance = derivePda([SEED_PREFIX_INSTANCE], this.program.programId);
  }
  // ---- user relevant functions ----
  async isRelayEnabled(e) {
    var T;
    try {
      const { paused: $ } = await this.getRegisteredChain(e);
      return !$;
    } catch ($) {
      if ((T = $.message) != null && T.includes("Account does not exist"))
        return !1;
      throw $;
    }
  }
  async calcRelayCostInSol(e, T, $) {
    const [V, J, ee, te] = await Promise.all([
      this.getRegisteredChain(T),
      this.getRegisteredNtt(e),
      this.getInstance(),
      this.program.provider.connection.getMinimumBalanceForRentExemption(this.program.account.relayRequest.size)
    ]);
    if ($ > V.maxGasDropoffEth)
      throw new Error("Requested gas dropoff exceeds allowed maximum");
    const re = V.nativePriceUsd * ($ + V.gasPriceGwei * J.gasCost / GWEI_PER_ETH);
    return te / LAMPORTS_PER_SOL + (V.basePriceUsd + re) / ee.solPriceUsd;
  }
  /**
   * Estimate the cost of a relay request
   * @param chain The destination chain
   * @param gasDropoff The amount of native gas to end up with on the destination chain
   * @returns The estimated cost in lamports
   */
  async quoteDeliveryPrice(e, T) {
    if (chainToPlatform(e) !== "Evm")
      throw new Error("Only EVM chains are supported");
    const $ = whole(fromBaseUnits(T ?? 0n, 18)), [V, J, ee, te] = await Promise.all([
      this.getRegisteredChain(e),
      this.getInstance(),
      this.getRegisteredNtt(this.nttProgramId),
      this.program.provider.connection.getMinimumBalanceForRentExemption(this.program.account.relayRequest.size)
    ]);
    if (V.nativePriceUsd === 0)
      throw new Error("Native price is 0");
    if (J.solPriceUsd === 0)
      throw new Error("SOL price is 0");
    if ($ > V.maxGasDropoffEth)
      throw new Error("Requested gas dropoff exceeds allowed maximum");
    const re = V.nativePriceUsd * ($ + V.gasPriceGwei * ee.gasCost / GWEI_PER_ETH), ie = te / LAMPORTS_PER_SOL + (V.basePriceUsd + re) / J.solPriceUsd;
    return BigInt(U64.to(ie * 1.05, LAMPORTS_PER_SOL).toString());
  }
  async createRequestRelayInstruction(e, T, $, V, J) {
    return this.program.methods.requestRelay({
      maxFee: U64.to(V, LAMPORTS_PER_SOL),
      gasDropoff: U64.to(J, GWEI_PER_ETH)
    }).accountsStrict({
      payer: e,
      instance: this.instance,
      registeredChain: this.registeredChainPda($),
      outboxItem: T,
      relayRequest: this.relayRequestPda(T),
      systemProgram: SystemProgram.programId,
      registeredNtt: this.pdas.registeredNttAccount(this.nttProgramId)
    }).instruction();
  }
  // ---- admin/assistant (=authority) relevant functions ----
  async getInstance() {
    const e = await this.program.account.instance.fetch(this.instance);
    return {
      owner: e.owner,
      assistant: e.assistant,
      feeRecipient: e.feeRecipient,
      solPriceUsd: U64.from(e.solPrice, USD_UNIT)
    };
  }
  async getRegisteredChain(e) {
    const T = await this.program.account.registeredChain.fetch(this.registeredChainPda(e));
    return {
      paused: T.basePrice.eq(U64.MAX),
      maxGasDropoffEth: U64.from(T.maxGasDropoff, GWEI_PER_ETH),
      basePriceUsd: U64.from(T.basePrice, USD_UNIT),
      nativePriceUsd: U64.from(T.nativePrice, USD_UNIT),
      gasPriceGwei: U64.from(T.gasPrice, WEI_PER_GWEI)
    };
  }
  async getRegisteredNtt(e) {
    const T = await this.program.account.registeredNtt.fetch(this.registeredNttPda(e));
    return {
      gasCost: T.gasCost,
      wormholeTransceiverIndex: T.wormholeTransceiverIndex
    };
  }
  //returns null if no relay was requested, otherwise it the requested gas dropoff (in eth),
  //  which can be 0, so a strict === null check is required!
  async wasRelayRequested(e) {
    const T = await this.program.account.relayRequest.fetchNullable(this.relayRequestPda(e));
    return T ? U64.from(T.requestedGasDropoff, GWEI_PER_ETH) : null;
  }
  async createInitalizeInstruction(e) {
    if (!this.program.account.instance.fetchNullable(this.instance))
      throw new Error("Already initialized");
    const T = programDataAddress(this.program.programId), $ = await this.program.provider.connection.getAccountInfo(T);
    if (!$)
      throw new Error("Could not find program data account");
    const V = deserialize$2(programDataLayout, $.data);
    if (!V.upgradeAuthority.isSome)
      throw new Error("Could not determine program owner from program data.");
    return this.program.methods.initialize().accounts({
      owner: V.upgradeAuthority.value,
      instance: this.instance,
      feeRecipient: e,
      programData: T,
      systemProgram: SystemProgram.programId
    }).instruction();
  }
  async createSetAssistantInstruction(e) {
    const { owner: T, assistant: $ } = await this.getInstance();
    if ($.equals(e))
      throw new Error("Is already assistant");
    return this.program.methods.setAssistant().accounts({
      owner: T,
      instance: this.instance,
      assistant: e
    }).instruction();
  }
  async createSetFeeRecipientInstruction(e) {
    if (e.equals(PublicKey.default))
      throw new Error("Fee recipient cannot be default public key");
    const { owner: T, feeRecipient: $ } = await this.getInstance();
    if ($.equals(e))
      throw new Error("Is already feeRecipient");
    return this.program.methods.setFeeRecipient().accounts({
      owner: T,
      instance: this.instance,
      feeRecipient: e
    }).instruction();
  }
  async createRegisterChainInstruction(e, T) {
    const $ = toChainId(T);
    return this.program.methods.registerChain({ chainId: $ }).accounts({
      authority: e,
      instance: this.instance,
      registeredChain: this.registeredChainPda(T),
      systemProgram: SystemProgram.programId
    }).instruction();
  }
  async createRegisterNttInstruction(e, T, $, V) {
    return this.program.methods.registerNtt({
      nttProgramId: T,
      gasCost: $,
      wormholeTransceiverIndex: V
    }).accounts({
      authority: e,
      instance: this.instance,
      registeredNtt: this.registeredNttPda(T),
      systemProgram: SystemProgram.programId
    }).instruction();
  }
  async createDeregisterNttInstruction(e, T) {
    return this.program.methods.deregisterNtt({ nttProgramId: T }).accounts({
      authority: e,
      instance: this.instance,
      registeredNtt: this.registeredNttPda(T),
      systemProgram: SystemProgram.programId
    }).instruction();
  }
  async createUpdateSolPriceInstruction(e, T) {
    return this.program.methods.updateSolPrice({
      solPrice: U64.to(T, USD_UNIT)
    }).accounts({
      authority: e,
      instance: this.instance
    }).instruction();
  }
  async createUpdateChainParamsInstruction(e, T, $, V) {
    return this.program.methods.updateChainParams({
      maxGasDropoff: U64.to($, GWEI_PER_ETH),
      basePrice: U64.to(V, USD_UNIT)
    }).accounts({
      authority: e,
      instance: this.instance,
      registeredChain: this.registeredChainPda(T)
    }).instruction();
  }
  async createPauseRelayForChainInstruction(e, T) {
    return this.program.methods.updateChainParams({
      maxGasDropoff: U64.to(0, 1),
      basePrice: U64.MAX
    }).accounts({
      authority: e,
      instance: this.instance,
      registeredChain: this.registeredChainPda(T)
    }).instruction();
  }
  async createUpdateChainPricesInstruction(e, T, $, V) {
    return this.program.methods.updateChainPrices({
      nativePrice: U64.to($, USD_UNIT),
      gasPrice: U64.to(V, WEI_PER_GWEI)
    }).accounts({
      authority: e,
      instance: this.instance,
      registeredChain: this.registeredChainPda(T)
    }).instruction();
  }
  async createCloseRelayInstruction(e, T) {
    return this.program.methods.closeRelay().accounts({
      authority: e,
      instance: this.instance,
      relayRequest: this.relayRequestPda(T)
    }).instruction();
  }
  // ---- private ----
  registeredChainPda(e) {
    return derivePda([SEED_PREFIX_REGISTERED_CHAIN, chainToBytes(e)], this.program.programId);
  }
  registeredNttPda(e) {
    return derivePda([SEED_PREFIX_REGISTERED_NTT, e.toBytes()], this.program.programId);
  }
  relayRequestPda(e) {
    return derivePda([SEED_PREFIX_RELAY_REQUEST, e.toBytes()], this.program.programId);
  }
}
class SolanaNttWormholeTransceiver {
  constructor(e, T, $ = "3.0.0") {
    tt(this, "manager");
    tt(this, "program");
    tt(this, "version");
    tt(this, "programId");
    tt(this, "pdas");
    this.manager = e, this.program = T, this.version = $, this.programId = T.programId, this.pdas = NTT$1.transceiverPdas(T.programId);
  }
  async getPauser() {
    return null;
  }
  async *setPauser(e, T) {
    throw new Error("Method not implemented.");
  }
  // NOTE: this method is not used for the Solana Wormhole transceiver.
  // `createReceiveIx` is used directly as it can be batched with other ixs in a single tx
  async *receive(e, T) {
    if (e.payloadName !== "WormholeTransfer")
      throw new Error("Invalid attestation payload");
    const $ = new SolanaAddress(T).unwrap(), V = await this.createReceiveIx(e, $), J = new Transaction();
    J.feePayer = $, J.add(V), yield this.manager.createUnsignedTx({ transaction: J }, "Ntt.Redeem");
  }
  async createReceiveIx(e, T) {
    const $ = e.payload.nttManagerPayload, V = e.emitterChain;
    return this.program.methods.receiveWormholeMessage().accounts({
      payer: T,
      config: { config: this.manager.pdas.configAccount() },
      peer: this.pdas.transceiverPeerAccount(V),
      vaa: derivePostedVaaKey(this.manager.core.address, dist$2.Buffer.from(e.hash)),
      transceiverMessage: this.pdas.transceiverMessageAccount(V, $.id)
    }).instruction();
  }
  async getTransceiverType(e) {
    var ie, se;
    const [T, , ,] = parseVersion(this.version);
    if (T < 3)
      return "wormhole";
    const $ = new SolanaAddress(e).unwrap(), V = await this.program.methods.transceiverType().accountsStrict({}).instruction(), J = await this.program.provider.connection.getLatestBlockhash(), ee = new TransactionMessage({
      payerKey: $,
      recentBlockhash: J.blockhash,
      instructions: [V]
    }).compileToV0Message(), te = new VersionedTransaction(ee), re = await this.program.provider.connection.simulateTransaction(te, {
      sigVerify: !1
    });
    if ((ie = re.value.returnData) != null && ie.data[0]) {
      const de = dist$2.Buffer.from((se = re.value.returnData) == null ? void 0 : se.data[0], "base64"), ue = de.readUInt32LE(0);
      return de.subarray(4, ue + 4).toString();
    } else
      throw new Error("no transceiver type found");
  }
  getAddress() {
    return {
      chain: this.manager.chain,
      address: toUniversal(this.manager.chain, this.pdas.emitterAccount().toBase58())
    };
  }
  async *setPeer(e, T) {
    const $ = new SolanaAddress(T).unwrap(), V = await this.program.methods.setWormholePeer({
      chainId: { id: toChainId(e.chain) },
      address: Array.from(e.address.toUniversalAddress().toUint8Array())
    }).accounts({
      payer: $,
      owner: $,
      config: this.manager.pdas.configAccount(),
      peer: this.pdas.transceiverPeerAccount(e.chain)
    }).instruction(), J = Keypair.generate(), ee = await this.createBroadcastWormholePeerIx(e.chain, $, J.publicKey), te = new Transaction();
    te.feePayer = $, te.add(V, ee), yield this.manager.createUnsignedTx({ transaction: te, signers: [J] }, "Ntt.SetWormholeTransceiverPeer");
  }
  async getPeer(e) {
    const T = await this.manager.program.account.transceiverPeer.fetchNullable(this.pdas.transceiverPeerAccount(e));
    return T ? {
      chain: e,
      address: toUniversal(e, new Uint8Array(T.address))
    } : null;
  }
  async createBroadcastWormholeIdIx(e, T, $) {
    const V = getWormholeDerivedAccounts(this.program.programId, this.manager.core.address);
    return this.program.methods.broadcastWormholeId().accountsStrict({
      payer: e,
      config: this.manager.pdas.configAccount(),
      mint: T.mint,
      wormholeMessage: $,
      emitter: V.wormholeEmitter,
      wormhole: {
        bridge: V.wormholeBridge,
        feeCollector: V.wormholeFeeCollector,
        sequence: V.wormholeSequence,
        program: this.manager.core.address,
        systemProgram: SystemProgram.programId,
        clock: SYSVAR_CLOCK_PUBKEY,
        rent: SYSVAR_RENT_PUBKEY
      }
    }).instruction();
  }
  async createBroadcastWormholePeerIx(e, T, $) {
    const V = getWormholeDerivedAccounts(this.program.programId, this.manager.core.address);
    return this.program.methods.broadcastWormholePeer({ chainId: toChainId(e) }).accounts({
      payer: T,
      config: this.manager.pdas.configAccount(),
      peer: this.pdas.transceiverPeerAccount(e),
      wormholeMessage: $,
      emitter: V.wormholeEmitter,
      wormhole: {
        bridge: V.wormholeBridge,
        feeCollector: V.wormholeFeeCollector,
        sequence: V.wormholeSequence,
        program: this.manager.core.address
      }
    }).instruction();
  }
  async createReleaseWormholeOutboundIx(e, T, $) {
    const [V, , ,] = parseVersion(this.version), J = getWormholeDerivedAccounts(this.program.programId, this.manager.core.address);
    return this.program.methods.releaseWormholeOutbound({
      revertOnDelay: $
    }).accounts({
      payer: e,
      config: { config: this.manager.pdas.configAccount() },
      outboxItem: T,
      wormholeMessage: this.pdas.wormholeMessageAccount(T),
      emitter: J.wormholeEmitter,
      transceiver: this.manager.pdas.registeredTransceiver(this.program.programId),
      wormhole: {
        bridge: J.wormholeBridge,
        feeCollector: J.wormholeFeeCollector,
        sequence: J.wormholeSequence,
        program: this.manager.core.address
      },
      // NOTE: baked-in transceiver case is handled separately
      // due to tx size error when LUT is not configured
      ...V >= 3 && {
        manager: this.manager.program.programId,
        outboxItemSigner: this.pdas.outboxItemSigner()
      }
    }).instruction();
  }
}
class SolanaNtt {
  constructor(e, T, $, V, J = "3.0.0") {
    tt(this, "network");
    tt(this, "chain");
    tt(this, "connection");
    tt(this, "contracts");
    tt(this, "version");
    tt(this, "core");
    tt(this, "pdas");
    tt(this, "program");
    tt(this, "config");
    tt(this, "quoter");
    tt(this, "addressLookupTable");
    // 0 = Wormhole xcvr
    tt(this, "transceivers");
    // NOTE: these are stored from the constructor, but are not used directly
    // (only in verifyAddresses)
    tt(this, "managerAddress");
    tt(this, "tokenAddress");
    var ee;
    if (this.network = e, this.chain = T, this.connection = $, this.contracts = V, this.version = J, !V.ntt)
      throw new Error("Ntt contracts not found");
    this.program = getNttProgram($, V.ntt.manager, J), this.transceivers = [], "wormhole" in V.ntt.transceiver && V.ntt.transceiver.wormhole && [
      "wormhole",
      // wormhole xcvr should be ix 0
      ...Object.keys(V.ntt.transceiver).filter((re) => {
      })
    ].map((re) => {
      if (re !== "wormhole")
        throw new Error(`Unsupported transceiver type: ${re}`);
      const ie = new PublicKey(V.ntt.transceiver[re]);
      if (PublicKey.isOnCurve(ie))
        this.transceivers.push(getTransceiverProgram($, V.ntt.transceiver[re], J));
      else {
        const se = new SolanaNttWormholeTransceiver(this, getTransceiverProgram($, V.ntt.manager, J), J);
        if (!se.pdas.emitterAccount().equals(ie))
          throw new Error(`Invalid emitterAccount provided. Expected: ${se.pdas.emitterAccount().toBase58()}; Actual: ${ie.toBase58()}`);
        this.transceivers.push(se.program);
      }
    }), this.managerAddress = V.ntt.manager, this.tokenAddress = V.ntt.token, (ee = this.contracts.ntt) != null && ee.quoter && (this.quoter = new NttQuoter($, this.contracts.ntt.quoter, this.contracts.ntt.manager)), this.core = new SolanaWormholeCore(e, T, $, V), this.pdas = NTT$1.pdas(this.program.programId);
  }
  async getTransceiver(e) {
    const T = this.transceivers[e] ?? null;
    return T && e === 0 ? new SolanaNttWormholeTransceiver(this, T, this.version) : null;
  }
  async getWormholeTransceiver() {
    return this.getTransceiver(0);
  }
  async getMode() {
    return (await this.getConfig()).mode.locking != null ? "locking" : "burning";
  }
  async isPaused() {
    return (await this.getConfig()).paused;
  }
  async *pause(e) {
    const T = new SolanaAddress(e).unwrap(), $ = await NTT$1.createSetPausedInstruction(this.program, {
      owner: T,
      paused: !0
    }), V = new Transaction();
    V.feePayer = T, V.add($), yield this.createUnsignedTx({ transaction: V }, "Ntt.Pause");
  }
  async *unpause(e) {
    const T = new SolanaAddress(e).unwrap(), $ = await NTT$1.createSetPausedInstruction(this.program, {
      owner: T,
      paused: !1
    }), V = new Transaction();
    V.feePayer = T, V.add($), yield this.createUnsignedTx({ transaction: V }, "Ntt.Unpause");
  }
  async getThreshold() {
    return (await this.getConfig()).threshold;
  }
  async getOwner() {
    const e = await this.getConfig();
    return new SolanaAddress(e.owner);
  }
  async getPauser() {
    return null;
  }
  async *setOwner(e, T) {
    const $ = new SolanaAddress(T).unwrap(), V = await NTT$1.createTransferOwnershipInstruction(this.program, {
      newOwner: new SolanaAddress(e).unwrap()
    }), J = new Transaction();
    J.feePayer = $, J.add(V), yield this.createUnsignedTx({ transaction: J }, "Ntt.SetOwner");
  }
  async *setPauser(e, T) {
    throw new Error("Pauser role not supported on Solana.");
  }
  async isRelayingAvailable(e) {
    return this.quoter ? await this.quoter.isRelayEnabled(e) : !1;
  }
  async quoteDeliveryPrice(e, T) {
    if (!this.quoter)
      throw new Error("Quoter not available");
    if (!this.quoter.isRelayEnabled(e))
      throw new Error("Relay not enabled");
    return await this.quoter.quoteDeliveryPrice(e, T.gasDropoff);
  }
  static async fromRpc(e, T) {
    const [$, V] = await SolanaPlatform.chainFromRpc(e), J = T[V];
    if (J.network !== $)
      throw new Error(`Network mismatch: ${J.network} != ${$}`);
    if (!("ntt" in J.contracts))
      throw new Error("Ntt contracts not found");
    const ee = J.contracts.ntt, te = await SolanaNtt.getVersion(
      e,
      //@ts-ignore
      J.contracts
    );
    return new SolanaNtt($, V, e, { ...J.contracts, ntt: ee }, te);
  }
  async getConfig() {
    return this.config = this.config ?? await NTT$1.getConfig(this.program, this.pdas), this.config;
  }
  async getTokenDecimals() {
    const e = await this.getConfig();
    return await SolanaPlatform.getDecimals(this.chain, this.connection, e.mint);
  }
  async getPeer(e) {
    const T = await this.program.account.nttManagerPeer.fetchNullable(this.pdas.peerAccount(e));
    return T ? {
      address: {
        chain: e,
        address: toUniversal(e, new Uint8Array(T.address))
      },
      tokenDecimals: T.tokenDecimals,
      inboundLimit: await this.getInboundLimit(e)
    } : null;
  }
  async getCustodyAddress() {
    return (await this.getConfig()).custody.toBase58();
  }
  static async getVersion(e, T, $) {
    try {
      return await NTT$1.getVersion(e, new PublicKey(T.ntt.manager), $ ? new SolanaAddress($).unwrap() : void 0);
    } catch {
      return "3.0.0";
    }
  }
  async *initialize(e, T) {
    const $ = await this.connection.getAccountInfo(T.mint);
    if ($ === null)
      throw new Error("Couldn't determine token program. Mint account is null.");
    const V = new SolanaAddress(e).unwrap(), J = await NTT$1.createInitializeInstruction(this.program, {
      ...T,
      payer: V,
      owner: V,
      chain: this.chain,
      tokenProgram: $.owner
    }, this.pdas), ee = new Transaction();
    ee.feePayer = V, ee.add(J), yield this.createUnsignedTx({ transaction: ee, signers: [] }, "Ntt.Initialize"), yield* this.initializeOrUpdateLUT({ payer: V });
  }
  async *initializeOrUpdateLUT(e) {
    const T = await this.getConfig(), $ = await this.getWormholeTransceiver();
    if (!$)
      throw new Error("wormhole transceiver not found");
    const V = $.programId, J = await NTT$1.initializeOrUpdateLUT(this.program, T, V, {
      payer: e.payer,
      wormholeId: new PublicKey(this.core.address)
    });
    if (!J)
      return;
    const ee = new Transaction().add(J);
    ee.feePayer = e.payer, yield this.createUnsignedTx({ transaction: ee }, "Ntt.InitializeLUT");
  }
  async *registerWormholeTransceiver(e) {
    const T = new SolanaAddress(e.payer).unwrap(), $ = new SolanaAddress(e.owner).unwrap(), V = await this.getConfig();
    if (V.paused)
      throw new Error("Contract is paused");
    const J = await this.createRegisterTransceiverIx(0, T, $), ee = await this.getWormholeTransceiver(), te = Keypair.generate(), re = await ee.createBroadcastWormholeIdIx(T, V, te.publicKey), ie = new Transaction();
    ie.feePayer = T, ie.add(J, re), yield this.createUnsignedTx({ transaction: ie, signers: [te] }, "Ntt.RegisterTransceiver");
  }
  // TODO: maybe add to Ntt interface
  async createRegisterTransceiverIx(e, T, $) {
    const V = await this.getTransceiver(e);
    if (!V)
      throw new Error("Transceiver not found");
    const J = V.programId;
    return this.program.methods.registerTransceiver().accountsStrict({
      payer: T,
      owner: $,
      config: this.pdas.configAccount(),
      transceiver: J,
      registeredTransceiver: this.pdas.registeredTransceiver(J),
      systemProgram: SystemProgram.programId
    }).instruction();
  }
  async *setWormholeTransceiverPeer(e, T) {
    yield* this.setTransceiverPeer(0, e, T);
  }
  async *setTransceiverPeer(e, T, $) {
    const V = await this.getTransceiver(e);
    if (!V)
      throw new Error("Transceiver not found");
    yield* V.setPeer(T, $);
  }
  async *setPeer(e, T, $, V) {
    const J = new SolanaAddress(V).unwrap(), ee = await NTT$1.createSetPeerInstruction(this.program, {
      payer: J,
      owner: J,
      chain: e.chain,
      address: e.address.toUniversalAddress().toUint8Array(),
      limit: new BN($.toString()),
      tokenDecimals: T
    }), te = new Transaction();
    te.feePayer = J, te.add(ee), yield this.createUnsignedTx({ transaction: te }, "Ntt.SetPeer");
  }
  async *transfer(e, T, $, V, J) {
    const ee = await this.getConfig();
    if (ee.paused)
      throw new Error("Contract is paused");
    J = J ?? Keypair.generate();
    const te = new SolanaAddress(e).unwrap(), re = te, ie = await this.getTokenAccount(re), se = NTT$1.transferArgs(T, $, V.queue), de = {
      transferArgs: se,
      payer: te,
      from: ie,
      fromAuthority: re,
      outboxItem: J.publicKey
    }, ue = createApproveInstruction$1(ie, this.pdas.sessionAuthority(re, se), re, T, [], ee.tokenProgram), fe = [], he = ee.mode.locking != null ? NTT$1.createTransferLockInstruction(this.program, ee, de, this.pdas) : NTT$1.createTransferBurnInstruction(this.program, ee, de, this.pdas);
    fe.push(he);
    for (let we = 0; we < this.transceivers.length; ++we)
      if (we === 0) {
        const Ee = await this.getWormholeTransceiver();
        if (!Ee)
          throw new Error("wormhole transceiver not found");
        const Me = Ee.createReleaseWormholeOutboundIx(te, J.publicKey, !V.queue);
        fe.push(Me);
      }
    const me = new Transaction();
    if (me.feePayer = te, me.add(ue, ...await Promise.all(fe)), V.automatic) {
      if (!this.quoter)
        throw new Error("No quoter available, cannot initiate an automatic transfer.");
      const we = await this.quoteDeliveryPrice($.chain, V), Ee = await this.quoter.createRequestRelayInstruction(
        te,
        J.publicKey,
        $.chain,
        Number(we) / LAMPORTS_PER_SOL,
        // NOTE: quoter expects gas dropoff to be in terms of gwei
        Number(V.gasDropoff ?? 0n) / WEI_PER_GWEI
      );
      me.add(Ee);
    }
    const xe = [];
    try {
      xe.push(await this.getAddressLookupTable());
    } catch {
    }
    const ve = new TransactionMessage({
      payerKey: te,
      instructions: me.instructions,
      recentBlockhash: (await this.connection.getLatestBlockhash()).blockhash
    }).compileToV0Message(xe), Te = new VersionedTransaction(ve);
    yield this.createUnsignedTx({ transaction: Te, signers: [J] }, "Ntt.Transfer");
  }
  async getTokenAccount(e) {
    const T = await this.getConfig();
    return await getAssociatedTokenAddress$1(T.mint, e, !0, T.tokenProgram);
  }
  async *createAta(e) {
    const T = await this.getConfig(), $ = new SolanaAddress(e).unwrap(), V = await this.getTokenAccount($);
    if (await this.connection.getAccountInfo(V) === null) {
      const ee = new Transaction().add(createAssociatedTokenAccountInstruction$1($, V, $, T.mint, T.tokenProgram));
      ee.feePayer = $, yield this.createUnsignedTx({ transaction: ee }, "Redeem.CreateATA");
    }
  }
  async *redeem(e, T) {
    const $ = await this.getConfig();
    if ($.paused)
      throw new Error("Contract is paused");
    if (e.length !== this.transceivers.length)
      throw new Error("Not enough attestations provided");
    for (const { attestation: V, ix: J } of e.map((ee, te) => ({
      attestation: ee,
      ix: te
    })))
      if (J === 0) {
        const ee = V;
        if (ee.payloadName !== "WormholeTransfer")
          throw new Error("Invalid attestation payload");
        const te = await this.getWormholeTransceiver();
        if (!te)
          throw new Error("wormhole transceiver not found");
        yield* this.createAta(T), yield* this.core.postVaa(T, ee);
        const re = new SolanaAddress(T).unwrap(), ie = te.createReceiveIx(ee, re), se = NTT$1.createRedeemInstruction(this.program, $, te.program.programId, {
          payer: re,
          vaa: ee
        }), de = ee.payload.nttManagerPayload, ue = ee.emitterChain, fe = {
          payer: re,
          config: $,
          nttMessage: de,
          recipient: new PublicKey(de.payload.recipientAddress.toUint8Array()),
          chain: ue,
          revertOnDelay: !1
        }, he = $.mode.locking != null ? NTT$1.createReleaseInboundUnlockInstruction(this.program, $, fe) : NTT$1.createReleaseInboundMintInstruction(this.program, $, fe), me = new Transaction();
        me.feePayer = re, me.add(...await Promise.all([ie, se, he]));
        const xe = [];
        try {
          xe.push(await this.getAddressLookupTable());
        } catch {
        }
        const ve = new TransactionMessage({
          payerKey: re,
          instructions: me.instructions,
          recentBlockhash: (await this.connection.getLatestBlockhash()).blockhash
        }).compileToV0Message(xe), Te = new VersionedTransaction(ve);
        yield this.createUnsignedTx({ transaction: Te }, "Ntt.Redeem");
      }
  }
  async getCurrentOutboundCapacity() {
    const e = await this.program.account.outboxRateLimit.fetch(this.pdas.outboxRateLimitAccount());
    return BigInt(e.rateLimit.capacityAtLastTx.toString());
  }
  async getOutboundLimit() {
    const e = await this.program.account.outboxRateLimit.fetch(this.pdas.outboxRateLimitAccount());
    return BigInt(e.rateLimit.limit.toString());
  }
  async *setOutboundLimit(e, T) {
    const $ = new SolanaAddress(T).unwrap(), V = await NTT$1.createSetOutboundLimitInstruction(this.program, {
      owner: $,
      limit: new BN(e.toString())
    }), J = new Transaction();
    J.feePayer = $, J.add(V), yield this.createUnsignedTx({ transaction: J }, "Ntt.SetOutboundLimit");
  }
  async getCurrentInboundCapacity(e) {
    const T = await this.program.account.inboxRateLimit.fetch(this.pdas.inboxRateLimitAccount(e));
    return BigInt(T.rateLimit.capacityAtLastTx.toString());
  }
  async getRateLimitDuration() {
    return BigInt(24 * 60 * 60);
  }
  async getInboundLimit(e) {
    const T = await this.program.account.inboxRateLimit.fetch(this.pdas.inboxRateLimitAccount(e));
    return BigInt(T.rateLimit.limit.toString());
  }
  async *setInboundLimit(e, T, $) {
    const V = new SolanaAddress($).unwrap(), J = await NTT$1.setInboundLimit(this.program, {
      owner: V,
      chain: e,
      limit: new BN(T.toString())
    }), ee = new Transaction();
    ee.feePayer = V, ee.add(J), yield this.createUnsignedTx({ transaction: ee }, "Ntt.SetInboundLimit");
  }
  async getIsExecuted(e) {
    var V;
    if (e.payloadName !== "WormholeTransfer")
      return !1;
    const T = e.payload.nttManagerPayload;
    let $;
    try {
      $ = await this.program.account.inboxItem.fetch(this.pdas.inboxItemAccount(e.emitterChain, T));
    } catch (J) {
      if ((V = J.message) != null && V.includes("Account does not exist"))
        return !1;
      throw J;
    }
    return !!$.releaseStatus.released;
  }
  async getIsTransferInboundQueued(e) {
    var V;
    if (e.payloadName !== "WormholeTransfer")
      return !1;
    const T = e.payload.nttManagerPayload;
    let $;
    try {
      $ = await this.program.account.inboxItem.fetch(this.pdas.inboxItemAccount(e.emitterChain, T));
    } catch (J) {
      if ((V = J.message) != null && V.includes("Account does not exist"))
        return !1;
      throw J;
    }
    return !!$.releaseStatus.releaseAfter;
  }
  async getIsApproved(e) {
    var $;
    if (e.payloadName !== "WormholeTransfer")
      throw new Error(`Invalid payload: ${e.payloadName}`);
    const T = e.payload.nttManagerPayload;
    try {
      return (await this.program.account.inboxItem.fetch(this.pdas.inboxItemAccount(e.emitterChain, T))).init;
    } catch (V) {
      if (($ = V.message) != null && $.includes("Account does not exist"))
        return !1;
      throw V;
    }
  }
  async *completeInboundQueuedTransfer(e, T, $) {
    const V = await this.getConfig();
    if (V.paused)
      throw new Error("Contract is paused");
    const J = new SolanaAddress($).unwrap(), ee = new Transaction();
    ee.feePayer = J;
    const te = {
      payer: J,
      config: V,
      nttMessage: T,
      recipient: new PublicKey(T.payload.recipientAddress.toUint8Array()),
      chain: e,
      revertOnDelay: !1
    };
    ee.add(await (V.mode.locking != null ? NTT$1.createReleaseInboundUnlockInstruction(this.program, V, te) : NTT$1.createReleaseInboundMintInstruction(this.program, V, te))), yield this.createUnsignedTx({ transaction: ee }, "Ntt.CompleteInboundTransfer");
  }
  async getInboundQueuedTransfer(e, T) {
    var V;
    let $;
    try {
      $ = await this.program.account.inboxItem.fetch(this.pdas.inboxItemAccount(e, T));
    } catch (J) {
      if ((V = J.message) != null && V.includes("Account does not exist"))
        return null;
      throw J;
    }
    if ($.releaseStatus.releaseAfter) {
      const { recipientAddress: J, amount: ee, releaseStatus: te } = $, re = te.releaseAfter[0].toNumber();
      return {
        recipient: new SolanaAddress(J),
        amount: BigInt(ee.toString()),
        rateLimitExpiryTimestamp: re
      };
    }
    return null;
  }
  async verifyAddresses() {
    const e = await this.getWormholeTransceiver(), T = {
      manager: this.managerAddress,
      token: this.tokenAddress,
      transceiver: {
        ...e && {
          wormhole: e.pdas.emitterAccount().toBase58()
        }
      }
    }, $ = {
      manager: this.program.programId.toBase58(),
      token: (await this.getConfig()).mint.toBase58(),
      transceiver: {
        wormhole: NTT$1.transceiverPdas(this.program.programId).emitterAccount().toBase58()
      }
    }, V = (J, ee) => {
      for (const te in J)
        typeof J[te] == "object" ? (V(J[te], ee[te]), Object.keys(J[te]).length === 0 && delete J[te]) : J[te] === ee[te] && delete J[te];
    };
    return V($, T), Object.keys($).length > 0 ? $ : null;
  }
  async getAddressLookupTable(e = !0) {
    if (!e || !this.addressLookupTable) {
      const T = await NTT$1.getAddressLookupTable(this.program, this.pdas);
      T && (this.addressLookupTable = T);
    }
    if (!this.addressLookupTable)
      throw new Error("Address lookup table not found. Did you forget to call initializeLUT?");
    return this.addressLookupTable;
  }
  createUnsignedTx(e, T, $ = !1) {
    return new SolanaUnsignedTransaction(e, this.network, this.chain, T, $);
  }
}
registerProtocol(_platform, "Ntt", SolanaNtt);
const ERR_INSUFFICIENT_ALLOWANCE = "insufficient_allowance", ERR_INSUFFICIENT_GAS = "insufficient_gas", ERR_AMOUNT_TOO_LARGE = "amount_too_large", ERR_AMOUNT_TOO_SMALL = "amount_too_small", ERR_USER_REJECTED = "user_rejected", ERR_TIMEOUT = "user_timeout", ERR_UNKNOWN = "unknown", INSUFFICIENT_ALLOWANCE_REGEX = /insufficient token allowance/im, USER_REJECTED_REGEX = new RegExp(
  "user rejected|rejected the request|rejected from user|user cancel|aborted by user|plugin closed",
  "mi"
), AMOUNT_IN_TOO_SMALL = new RegExp("AmountInTooSmall", "m");
function interpretTransferError(C, e) {
  let T = "Error with transfer, please try again", $ = ERR_UNKNOWN;
  if (C.message) {
    if (INSUFFICIENT_ALLOWANCE_REGEX.test(C == null ? void 0 : C.message))
      T = "Error with transfer, please try again", $ = ERR_INSUFFICIENT_ALLOWANCE;
    else if (C.name === "TransactionExpiredTimeoutError" || C.name === "TransactionExpiredBlockheightExceededError")
      T = "Transfer timed out, please try again", $ = ERR_TIMEOUT;
    else if (InsufficientFundsForGasError.MESSAGE_REGEX.test(C == null ? void 0 : C.message))
      T = "Insufficient funds", $ = ERR_INSUFFICIENT_GAS;
    else if (USER_REJECTED_REGEX.test(C == null ? void 0 : C.message))
      T = "Transfer rejected in wallet, please try again", $ = ERR_USER_REJECTED;
    else if (AMOUNT_IN_TOO_SMALL.test(C == null ? void 0 : C.message))
      T = "Amount is too small for the selected route", $ = ERR_AMOUNT_TOO_SMALL;
    else if (e.route.includes("CCTP") && /burn.*exceed/i.test(C == null ? void 0 : C.toString())) {
      const { amount: J } = e;
      T = `Amount exceeds Circle limit${J !== void 0 && whole(J) > 1e6 ? " of 1,000,000" : ""}. Please reduce transfer amount.`, $ = ERR_AMOUNT_TOO_LARGE;
    }
  }
  return [T, { type: $, original: C }];
}
function maybeLogSdkError(C, e) {
  C instanceof Error && C.message.startsWith("No protocols registered for") || console.error(e ? `${e}: ${C}` : C);
}
const DEFAULT_ROUTES = [
  AutomaticCCTPRoute$1,
  CCTPRoute$1,
  AutomaticTokenBridgeRoute$1,
  TokenBridgeRoute$1,
  AutomaticPorticoRoute$1
];
class RouteOperator {
  constructor(e = DEFAULT_ROUTES) {
    tt(this, "preference");
    tt(this, "routes");
    tt(this, "quoteCache");
    const T = {}, $ = [];
    for (const V of e) {
      const J = V.meta.name;
      if (J === "")
        throw new Error("Route has empty meta.name");
      if (J in T)
        throw new Error(`Route has duplicate meta.name: ${J}`);
      $.push(J), T[J] = new SDKv2Route(V);
    }
    this.routes = T, this.preference = $, this.quoteCache = new QuoteCache(
      15e3
      /* 15 seconds */
    );
  }
  get(e) {
    return this.routes[e];
  }
  async forEach(e) {
    return Promise.all(
      this.preference.map((T) => e(T, this.routes[T]))
    );
  }
  async resumeFromTx(e) {
    return new Promise((T, $) => {
      const V = Object.keys(this.routes).length;
      let J = 0;
      this.forEach((ee, te) => {
        te.resumeIfManual(e).then((re) => {
          re !== null ? T({ route: ee, receipt: re }) : J += 1;
        }).catch((re) => {
          J += 1;
        }).finally(() => {
          J === V && T(null);
        });
      });
    });
  }
  allSupportedChains() {
    const e = /* @__PURE__ */ new Set();
    for (const T in config$1.chains) {
      const $ = T;
      this.forEach(async (V, J) => {
        e.has($) || J.isSupportedChain($) && e.add($);
      });
    }
    return Array.from(e);
  }
  async allSupportedSourceTokens(e, T, $) {
    const V = {};
    return await this.forEach(async (J, ee) => {
      try {
        const te = await ee.supportedSourceTokens(
          config$1.tokensArr,
          e,
          T,
          $
        );
        for (const re of te)
          V[re.key] = re;
      } catch (te) {
        maybeLogSdkError(te);
      }
    }), Object.values(V);
  }
  async allSupportedDestTokens(e, T, $) {
    const V = {};
    return await this.forEach(async (J, ee) => {
      try {
        const te = await ee.supportedDestTokens(
          config$1.tokensArr,
          e,
          T,
          $
        );
        for (const re of te)
          V[re.key] = re;
      } catch (te) {
        console.error(te);
      }
    }), Object.values(V);
  }
  async getQuotes(e, T) {
    return (await Promise.allSettled(
      e.map(($) => {
        const V = this.quoteCache.get($, T);
        return V || this.quoteCache.fetch($, T, this.get($));
      })
    )).map(($) => $.status === "rejected" ? {
      success: !1,
      error: $.reason
    } : $.value);
  }
}
class QuoteCache {
  constructor(e) {
    tt(this, "ttl");
    tt(this, "cache");
    tt(this, "pending");
    this.ttl = e, this.cache = {}, this.pending = {};
  }
  quoteParamsKey(e, T) {
    return `${e}:${T.sourceChain}:${T.sourceToken}:${T.destChain}:${T.destToken}:${units(T.amount)}:${T.nativeGas}`;
  }
  get(e, T) {
    const $ = this.quoteParamsKey(e, T), V = this.cache[$];
    if (V) {
      if (V.age() < this.ttl)
        return V.result;
      delete this.cache[$];
    }
    return null;
  }
  async fetch(e, T, $) {
    const V = this.quoteParamsKey(e, T), J = this.pending[V];
    if (J)
      return new Promise((ee, te) => {
        J.push({ resolve: ee, reject: te });
      });
    {
      const ee = new Promise(
        (te, re) => {
          this.pending[V] = [{ resolve: te, reject: re }];
        }
      );
      return $.computeQuote(
        T.amount,
        T.sourceToken,
        T.destToken,
        T.sourceChain,
        T.destChain,
        { nativeGas: T.nativeGas }
      ).then((te) => {
        const re = this.pending[V];
        for (const { resolve: ie } of re)
          ie(te);
        delete this.pending[V], this.cache[V] = new QuoteCacheEntry(te);
      }).catch((te) => {
        const re = this.pending[V];
        for (const { reject: ie } of re)
          ie(te);
        delete this.pending[V];
      }), ee;
    }
  }
}
class QuoteCacheEntry {
  constructor(e) {
    // Last quote we received (the cached value)
    tt(this, "result");
    // Last time we fetched a quote
    tt(this, "timestamp");
    this.result = e, this.timestamp = /* @__PURE__ */ new Date();
  }
  age() {
    return (/* @__PURE__ */ new Date()).valueOf() - this.timestamp.valueOf();
  }
}
const nttRoutes = (C) => [nttManualRoute(C), nttAutomaticRoute(C)];
function createUiConfig(C) {
  return {
    ...C,
    walletConnectProjectId: (C == null ? void 0 : C.walletConnectProjectId) ?? void 0
  };
}
function buildConfig(C) {
  var ie;
  const e = capitalize$1(
    (C == null ? void 0 : C.network) || void 0 || "Mainnet"
  );
  if (!["Mainnet", "Testnet", "Devnet"].includes(e))
    throw new Error(
      `Invalid env "${e}": Use "Testnet", "Devnet", or "Mainnet"`
    );
  const T = { MAINNET, DEVNET, TESTNET }[e.toUpperCase()], $ = mergeCustomTokensConfig(
    T.tokens,
    C == null ? void 0 : C.tokensConfig
  ), V = mergeCustomWrappedTokens(
    T.wrappedTokens,
    C == null ? void 0 : C.wrappedTokens
  ), J = WormholeContext.getConfig(e), ee = Object.assign(
    {},
    J.rpcs,
    T.rpcs,
    C == null ? void 0 : C.rpcs
  ), te = getLegacyWormholeContext(e, J, ee);
  (ie = C == null ? void 0 : C.ui) != null && ie.defaultInputs && validateDefaults(C.ui.defaultInputs, T.chains, $);
  const re = new SDKConverter(te);
  return {
    whLegacy: te,
    sdkConfig: J,
    sdkConverter: re,
    network: e,
    isMainnet: e === "Mainnet",
    // External resources
    rpcs: ee,
    rest: Object.assign(
      {},
      J.rest,
      T.rest,
      C == null ? void 0 : C.rest
    ),
    graphql: Object.assign({}, T.graphql, C == null ? void 0 : C.graphql),
    mayanApi: "https://explorer-api.mayan.finance",
    wormholeApi: {
      Mainnet: "https://api.wormholescan.io/",
      Testnet: "https://api.testnet.wormholescan.io/",
      Devnet: ""
    }[e],
    wormholeRpcHosts: {
      Mainnet: [
        "https://wormhole-v2-mainnet-api.mcf.rocks",
        "https://wormhole-v2-mainnet-api.chainlayer.network",
        "https://wormhole-v2-mainnet-api.staking.fund"
      ],
      Testnet: [
        "https://guardian.testnet.xlabs.xyz",
        "https://guardian-01.testnet.xlabs.xyz",
        "https://guardian-02.testnet.xlabs.xyz"
      ],
      Devnet: ["http://localhost:7071"]
    }[e],
    coinGeckoApiKey: C == null ? void 0 : C.coinGeckoApiKey,
    // Callbacks
    triggerEvent: wrapEventHandler(C == null ? void 0 : C.eventHandler),
    validateTransfer: C == null ? void 0 : C.validateTransferHandler,
    isRouteSupportedHandler: C == null ? void 0 : C.isRouteSupportedHandler,
    // White lists
    chains: T.chains,
    chainsArr: Object.values(T.chains).filter((se) => C != null && C.chains ? C.chains.includes(se.key) : !0).sort((se, de) => {
      const ue = CHAIN_ORDER.indexOf(se.key), fe = CHAIN_ORDER.indexOf(de.key);
      return ue >= 0 && fe >= 0 ? ue - fe : ue === -1 ? 1 : fe === -1 ? -1 : 0;
    }),
    tokens: $,
    tokensArr: Object.values($).filter((se) => C != null && C.tokens ? C.tokens.includes(se.key) : !0),
    // For token bridge =^_^=
    wrappedTokenAddressCache: new WrappedTokenAddressCache(
      $,
      V
    ),
    routes: new RouteOperator(C == null ? void 0 : C.routes),
    // UI details
    ui: createUiConfig({ ...C == null ? void 0 : C.ui }),
    // Guardian Set
    guardianSet: T.guardianSet
  };
}
const config$1 = buildConfig();
function getLegacyWormholeContext(C, e, T) {
  return new WormholeContext(C, {
    ...e,
    rpcs: T
  });
}
async function getWormholeContextV2() {
  return config$1._v2Wormhole || (config$1._v2Wormhole = await newWormholeContextV2()), config$1._v2Wormhole;
}
async function newWormholeContextV2() {
  const C = { chains: {} };
  for (const e in config$1.chains) {
    const T = e, $ = config$1.rpcs[T], V = {};
    for (const J of config$1.tokensArr) {
      const ee = {
        key: J.key,
        chain: T,
        symbol: J.symbol
      };
      if (J.nativeChain === T) {
        const te = config$1.sdkConverter.getNativeTokenAddressV2(J);
        if (!te) throw new Error("Token must have address");
        ee.address = te, ee.decimals = J.decimals;
      } else {
        ee.original = J.nativeChain;
        const te = getTokenBridgeWrappedTokenAddressSync(J, T);
        if (te)
          ee.address = te.toString(), ee.decimals = getTokenDecimals(T, getWrappedToken(J));
        else
          continue;
      }
      V[J.key] = ee;
    }
    C.chains[T] = { rpc: $, tokenMap: V };
  }
  return await wormhole(
    config$1.network,
    [evm, solana$1, aptos$1, sui],
    C
  );
}
function setConfig(C) {
  const e = buildConfig(C);
  for (const T in e)
    config$1[T] = e[T];
}
function getEmptyDataWrapper() {
  return {
    data: null,
    error: null,
    isFetching: !1,
    receivedAt: null
  };
}
function receiveDataWrapper(C) {
  return {
    data: C,
    error: null,
    isFetching: !1,
    receivedAt: (/* @__PURE__ */ new Date()).toISOString()
  };
}
function errorDataWrapper(C) {
  return {
    data: null,
    error: C,
    isFetching: !1,
    receivedAt: null
  };
}
function fetchDataWrapper() {
  return {
    data: null,
    error: null,
    isFetching: !0,
    receivedAt: null
  };
}
const getNativeVersionOfToken = (C, e) => {
  var T;
  return ((T = Object.entries(config$1.tokens).map(([$, V]) => V).find(($) => $.symbol === C && $.nativeChain === e)) == null ? void 0 : T.key) || "";
}, accessChainBalances = (C, e, T) => {
  if (!T || !C || !e) return;
  const $ = C[e];
  if (!$) return;
  const V = $[T];
  if (V)
    return V;
}, accessBalance = (C, e, T, $) => {
  const V = accessChainBalances(C, e, T);
  if (V)
    return V.balances[$];
};
function getInitialState() {
  var C, e, T, $, V;
  return {
    showValidationState: !1,
    validations: {
      fromChain: "",
      toChain: "",
      token: "",
      destToken: "",
      amount: "",
      toNativeToken: "",
      sendingWallet: "",
      receivingWallet: "",
      relayerFee: "",
      receiveAmount: ""
    },
    fromChain: ((C = config$1.ui.defaultInputs) == null ? void 0 : C.fromChain) || void 0,
    toChain: ((e = config$1.ui.defaultInputs) == null ? void 0 : e.toChain) || void 0,
    token: ((T = config$1.ui.defaultInputs) == null ? void 0 : T.tokenKey) || "",
    destToken: (($ = config$1.ui.defaultInputs) == null ? void 0 : $.toTokenKey) || "",
    amount: void 0,
    receiveAmount: getEmptyDataWrapper(),
    preferredRouteName: (V = config$1.ui.defaultInputs) == null ? void 0 : V.preferredRouteName,
    route: void 0,
    balances: {},
    foreignAsset: "",
    associatedTokenAddress: "",
    gasEst: {
      send: "",
      claim: ""
    },
    isTransactionInProgress: !1,
    receiverNativeBalance: "",
    supportedSourceTokens: [],
    supportedDestTokens: []
  };
}
const performModificationsIfFromChainChanged = (C) => {
  var $;
  const { fromChain: e, token: T } = C;
  if (T) {
    const V = config$1.tokens[T];
    (!e || !V.tokenId && V.nativeChain !== e) && (C.token = "", C.amount = void 0), V.symbol === "USDC" && V.nativeChain !== e ? C.token = getNativeVersionOfToken("USDC", e) : V.symbol === "tBTC" && V.nativeChain !== e && (C.token = getNativeVersionOfToken("tBTC", e) || (($ = config$1.tokens.tBTC) == null ? void 0 : $.key) || "");
  }
}, performModificationsIfToChainChanged = (C) => {
  var $;
  const { toChain: e, destToken: T } = C;
  if (T) {
    const V = config$1.tokens[T];
    e || (C.destToken = ""), V.symbol === "USDC" && V.nativeChain !== e ? C.destToken = getNativeVersionOfToken("USDC", e) : V.symbol === "tBTC" && V.nativeChain !== e && (C.destToken = getNativeVersionOfToken("tBTC", e) || (($ = config$1.tokens.tBTC) == null ? void 0 : $.key) || "");
  }
}, transferInputSlice = createSlice({
  name: "transfer",
  initialState: getInitialState(),
  reducers: {
    // validations
    setValidations: (C, {
      payload: { showValidationState: e, validations: T }
    }) => {
      Object.keys(T).forEach(($) => {
        C.validations[$] = T[$];
      }), C.showValidationState = e;
    },
    // user input
    setToken: (C, { payload: e }) => {
      C.token = e;
    },
    setDestToken: (C, { payload: e }) => {
      C.destToken = e;
    },
    setFromChain: (C, { payload: e }) => {
      C.fromChain = e, performModificationsIfFromChainChanged(C);
    },
    setToChain: (C, { payload: e }) => {
      C.toChain = e, performModificationsIfToChainChanged(C);
    },
    setAmount: (C, { payload: e }) => {
      if (C.token && C.fromChain) {
        const T = config$1.tokens[C.token], $ = getTokenDecimals(C.fromChain, T), V = parse$3(e, $);
        units(V) === 0n ? C.amount = void 0 : C.amount = V;
      } else
        console.warn("Can't call setAmount without a fromChain and token");
    },
    updateBalances: (C, {
      payload: e
    }) => {
      var J, ee;
      const { chain: T, balances: $, address: V } = e;
      V && ((J = C.balances)[V] ?? (J[V] = {}), (ee = C.balances[V])[T] ?? (ee[T] = {
        balances: {}
      }), C.balances[V][T].balances = {
        ...C.balances[V][T].balances,
        ...$
      });
    },
    setTransferRoute: (C, { payload: e }) => {
      if (!e) {
        C.route = void 0;
        return;
      }
      C.route = e;
    },
    // clear inputs
    clearTransfer: (C) => {
      const e = getInitialState();
      Object.keys(C).forEach((T) => {
        C[T] = e[T];
      });
    },
    setIsTransactionInProgress: (C, { payload: e }) => {
      C.isTransactionInProgress = e;
    },
    setSupportedSourceTokens: (C, { payload: e }) => {
      C.supportedSourceTokens = e;
    },
    setSupportedDestTokens: (C, { payload: e }) => {
      C.supportedDestTokens = e;
    },
    swapInputs: (C) => {
      const e = C.fromChain;
      C.fromChain = C.toChain, C.toChain = e;
      const T = C.token;
      C.token = C.destToken, C.destToken = T, performModificationsIfFromChainChanged(C), performModificationsIfToChainChanged(C);
    }
  }
}), isDisabledChain = (C, e) => e.name === "OKX Wallet" && C === "Evmos" ? !0 : !walletAcceptedChains(e.type).includes(C), selectFromChain = async (C, e, T) => {
  selectChain(TransferWallet.SENDING, C, e, T);
}, selectToChain = async (C, e, T) => {
  selectChain(TransferWallet.RECEIVING, C, e, T);
}, selectChain = async (C, e, T, $) => {
  isDisabledChain(T, $) && (e(clearWallet(C)), e(setWalletError({
    type: C,
    error: "Wallet disconnected, please connect a supported wallet"
  }))), config$1.chains[T] && e(
    C === TransferWallet.SENDING ? setFromChain(T) : setToChain(T)
  );
}, {
  setValidations,
  setToken,
  setDestToken,
  setFromChain,
  setToChain,
  setAmount,
  setTransferRoute,
  updateBalances,
  clearTransfer,
  setIsTransactionInProgress,
  setSupportedDestTokens,
  setSupportedSourceTokens,
  swapInputs
} = transferInputSlice.actions, transferInputReducer = transferInputSlice.reducer, initialState$2 = {
  maxSwapAmt: void 0,
  toNativeToken: 0,
  receiveNativeAmt: void 0,
  relayerFee: void 0,
  receiverNativeBalance: ""
}, relaySlice = createSlice({
  name: "transfer",
  initialState: initialState$2,
  reducers: {
    setToNativeToken: (C, { payload: e }) => {
      C.toNativeToken = e;
    },
    // clear relay state
    clearRelay: (C) => {
      Object.keys(C).forEach((e) => {
        C[e] = initialState$2[e];
      });
    }
  }
}), { setToNativeToken } = relaySlice.actions, relayReducer = relaySlice.reducer, initialState$1 = {
  route: "bridge",
  showFromChainsModal: !1,
  showToChainsModal: !1,
  showTokensModal: !1,
  showWalletModal: !1
}, routerSlice = createSlice({
  name: "router",
  initialState: initialState$1,
  reducers: {
    setRoute: (C, { payload: e }) => {
      C.route = e;
    }
  }
}), { setRoute } = routerSlice.actions, routerReducer = routerSlice.reducer, initialState = {
  usdPrices: getEmptyDataWrapper()
}, tokenPricesSlice = createSlice({
  name: "tokenPrices",
  initialState,
  reducers: {
    setPrices: (C, { payload: e }) => {
      C.usdPrices = receiveDataWrapper(e);
    },
    setFetchingPrices: (C) => {
      C.usdPrices = fetchDataWrapper();
    },
    setPricesError: (C, { payload: e }) => {
      C.usdPrices = errorDataWrapper(e);
    }
  }
}), { setPrices, setFetchingPrices, setPricesError } = tokenPricesSlice.actions, tokenPricesReducer = tokenPricesSlice.reducer, store = configureStore({
  reducer: {
    redeem: redeemReducer,
    transferInput: transferInputReducer,
    router: routerReducer,
    wallet: walletReducer,
    relay: relayReducer,
    tokenPrices: tokenPricesReducer
  }
}), objectFromEntries = Object.fromEntries ? Object.fromEntries : (C) => {
  if (!C || !C[Symbol.iterator])
    throw new Error("Object.fromEntries() requires a single iterable argument");
  const e = {};
  return Object.keys(C).forEach((T) => {
    const [$, V] = C[T];
    e[$] = V;
  }), e;
};
function objectKeys(C) {
  return Object.keys(C);
}
function assert(C, e) {
  if (!C)
    throw new Error(e);
}
function typeGuard(C, e) {
  return e;
}
const classnames = (C) => {
  const e = C.length;
  let T = 0, $ = "";
  for (; T < e; T++) {
    const V = C[T];
    if (V == null)
      continue;
    let J;
    switch (typeof V) {
      case "boolean":
        break;
      case "object": {
        if (Array.isArray(V))
          J = classnames(V);
        else {
          assert(!typeGuard(V, !1)), dist$2.process.env.NODE_ENV !== "production" && V.styles !== void 0 && V.name !== void 0 && console.error("You have passed styles created with `css` from `@emotion/react` package to the `cx`.\n`cx` is meant to compose class names (strings) so you should convert those styles to a class name by passing them to the `css` received from <ClassNames/> component."), J = "";
          for (const ee in V)
            V[ee] && ee && (J && (J += " "), J += ee);
        }
        break;
      }
      default:
        J = V;
    }
    J && ($ && ($ += " "), $ += J);
  }
  return $;
};
function useGuaranteedMemo(C, e) {
  var T;
  const $ = useRef();
  return (!$.current || e.length !== ((T = $.current.prevDeps) === null || T === void 0 ? void 0 : T.length) || $.current.prevDeps.map((V, J) => V === e[J]).indexOf(!1) >= 0) && ($.current = {
    v: C(),
    prevDeps: [...e]
  }), $.current.v;
}
function matchCSSObject(C) {
  return C instanceof Object && !("styles" in C) && !("length" in C) && !("__emotion_styles" in C);
}
const { createCssAndCx } = /* @__PURE__ */ (() => {
  function C(T, $, V) {
    const J = [], ee = getRegisteredStyles(T, J, V);
    return J.length < 2 ? V : ee + $(J);
  }
  function e(T) {
    const { cache: $ } = T, V = (...ee) => {
      const te = serializeStyles(ee, $.registered);
      insertStyles($, te, !1);
      const re = `${$.key}-${te.name}`;
      e: {
        const ie = ee[0];
        if (!matchCSSObject(ie))
          break e;
        increaseSpecificityToTakePrecedenceOverMediaQueries.saveClassNameCSSObjectMapping($, re, ie);
      }
      return re;
    };
    return { css: V, cx: (...ee) => {
      const te = classnames(ee), re = increaseSpecificityToTakePrecedenceOverMediaQueries.fixClassName($, te, V);
      return C($.registered, V, re);
    } };
  }
  return { createCssAndCx: e };
})();
function createUseCssAndCx(C) {
  const { useCache: e } = C;
  function T() {
    const $ = e(), { css: V, cx: J } = useGuaranteedMemo(() => createCssAndCx({ cache: $ }), [$]);
    return { css: V, cx: J };
  }
  return { useCssAndCx: T };
}
const increaseSpecificityToTakePrecedenceOverMediaQueries = /* @__PURE__ */ (() => {
  const C = /* @__PURE__ */ new WeakMap();
  return {
    saveClassNameCSSObjectMapping: (e, T, $) => {
      let V = C.get(e);
      V === void 0 && (V = /* @__PURE__ */ new Map(), C.set(e, V)), V.set(T, $);
    },
    fixClassName: /* @__PURE__ */ (() => {
      function e(T) {
        let $ = !1;
        return T.map(([V, J]) => {
          if (J === void 0)
            return V;
          let ee;
          if ($)
            ee = {
              "&&": J
            };
          else {
            ee = V;
            for (const te in J)
              if (te.startsWith("@media")) {
                $ = !0;
                break;
              }
          }
          return ee;
        });
      }
      return (T, $, V) => {
        const J = C.get(T);
        return classnames(e($.split(" ").map((ee) => [
          ee,
          J == null ? void 0 : J.get(ee)
        ])).map((ee) => typeof ee == "string" ? ee : V(ee)));
      };
    })()
  };
})();
function getDependencyArrayRef(C) {
  if (!(C instanceof Object) || typeof C == "function")
    return C;
  const e = [];
  for (const T in C) {
    const $ = C[T], V = typeof $;
    if (!(V === "string" || V === "number" && !isNaN($) || V === "boolean" || $ === void 0 || $ === null))
      return C;
    e.push(`${T}:${V}_${$}`);
  }
  return "xSqLiJdLMd9s" + e.join("|");
}
function mergeClasses(C, e, T) {
  if (!(e instanceof Object))
    return C;
  const $ = {};
  return objectKeys(C).forEach((V) => $[V] = T(C[V], e[V])), objectKeys(e).forEach((V) => {
    if (V in C)
      return;
    const J = e[V];
    typeof J == "string" && ($[V] = J);
  }), $;
}
const useMuiThemeStyleOverridesPlugin = ({ classes: C, theme: e, muiStyleOverridesParams: T, css: $, cx: V, name: J }) => {
  var ee, te;
  e: {
    if (J === "makeStyle no name") {
      J = void 0;
      break e;
    }
    if (T !== void 0 && J === void 0)
      throw new Error("To use muiStyleOverridesParams, you must specify a name using .withName('MyComponent')");
  }
  let re;
  try {
    re = J === void 0 ? void 0 : ((te = (ee = e.components) === null || ee === void 0 ? void 0 : ee[
      J
      /*example*/
    ]) === null || te === void 0 ? void 0 : te.styleOverrides) || void 0;
  } catch {
  }
  const ie = useMemo(() => {
    if (re === void 0)
      return;
    const se = {};
    for (const de in re) {
      const ue = re[de];
      ue instanceof Object && (se[de] = $(typeof ue == "function" ? ue({
        theme: e,
        ownerState: T == null ? void 0 : T.ownerState,
        ...T == null ? void 0 : T.props
      }) : ue));
    }
    return se;
  }, [
    re,
    getDependencyArrayRef(T == null ? void 0 : T.props),
    getDependencyArrayRef(T == null ? void 0 : T.ownerState),
    $
  ]);
  return C = useMemo(() => mergeClasses(C, ie, V), [C, ie, V]), { classes: C };
};
let counter$1 = 0;
function createMakeStyles(C) {
  const { useTheme: e, cache: T } = C, { useCache: $ } = createUseCache({ cacheProvidedAtInception: T }), { useCssAndCx: V } = createUseCssAndCx({ useCache: $ });
  function J(te) {
    const { name: re, uniqId: ie = `${counter$1++}` } = te ?? {}, se = typeof re != "object" ? re : Object.keys(re)[0];
    return function(de) {
      const ue = typeof de == "function" ? de : () => de;
      return function(he, me) {
        const xe = e();
        let { css: ve, cx: Te } = V();
        const we = $();
        let Ee = useMemo(() => {
          const Me = {}, Ie = typeof Proxy < "u" && new Proxy({}, {
            get: (De, Fe) => (typeof Fe == "symbol" && assert(!1), Me[Fe] = `${we.key}-${ie}${se !== void 0 ? `-${se}` : ""}-${Fe}-ref`)
          }), ke = ue(xe, he, Ie || {}), _e = objectFromEntries(objectKeys(ke).map((De) => {
            const Fe = ke[De];
            return Fe.label || (Fe.label = `${se !== void 0 ? `${se}-` : ""}${De}`), [
              De,
              `${ve(Fe)}${typeGuard(De, De in Me) ? ` ${Me[De]}` : ""}`
            ];
          }));
          return objectKeys(Me).forEach((De) => {
            De in _e || (_e[De] = Me[De]);
          }), _e;
        }, [we, ve, Te, xe, getDependencyArrayRef(he)]);
        {
          const Me = me == null ? void 0 : me.props.classes;
          Ee = useMemo(() => mergeClasses(Ee, Me, Te), [Ee, getDependencyArrayRef(Me), Te]);
        }
        {
          const Me = useMuiThemeStyleOverridesPlugin({
            classes: Ee,
            css: ve,
            cx: Te,
            name: se ?? "makeStyle no name",
            idOfUseStyles: ie,
            muiStyleOverridesParams: me,
            // NOTE: If it's not a Mui Theme the plugin is resilient, it will not crash
            theme: xe
          });
          Me.classes !== void 0 && (Ee = Me.classes), Me.css !== void 0 && (ve = Me.css), Me.cx !== void 0 && (Te = Me.cx);
        }
        return {
          classes: Ee,
          theme: xe,
          css: ve,
          cx: Te
        };
      };
    };
  }
  function ee() {
    const te = e(), { css: re, cx: ie } = V();
    return { theme: te, css: re, cx: ie };
  }
  return { makeStyles: J, useStyles: ee };
}
const reactContext = createContext(void 0), { createUseCache } = /* @__PURE__ */ (() => {
  function C() {
    return useContext(reactContext);
  }
  function e(T) {
    const { cacheProvidedAtInception: $ } = T;
    function V() {
      var J;
      const ee = __unsafe_useEmotionCache(), te = C(), re = (J = $ ?? te) !== null && J !== void 0 ? J : ee;
      if (re === null)
        throw new Error([
          "In order to get SSR working with tss-react you need to explicitly provide an Emotion cache.",
          "MUI users be aware: This is not an error strictly related to tss-react, with or without tss-react,",
          "MUI needs an Emotion cache to be provided for SSR to work.",
          "Here is the MUI documentation related to SSR setup: https://mui.com/material-ui/guides/server-rendering/",
          "TSS provides helper that makes the process of setting up SSR easier: https://docs.tss-react.dev/ssr"
        ].join(`
`));
      return re;
    }
    return { useCache: V };
  }
  return { createUseCache: e };
})();
function capitalize(C) {
  return C.charAt(0).toUpperCase() + C.slice(1);
}
function createWithStyles(C) {
  const { useTheme: e, cache: T } = C, { makeStyles: $ } = createMakeStyles({ useTheme: e, cache: T });
  function V(J, ee, te) {
    const re = typeof J == "string" ? (() => {
      const fe = J, he = function({ children: me, ...xe }) {
        return createElement(fe, xe, me);
      };
      return Object.defineProperty(he, "name", {
        value: capitalize(fe)
      }), he;
    })() : J, ie = (() => {
      {
        const { name: he } = te ?? {};
        if (he !== void 0)
          return typeof he != "object" ? he : Object.keys(he)[0];
      }
      let fe;
      e: {
        const he = re.displayName;
        if (typeof he != "string" || he === "")
          break e;
        fe = he;
      }
      e: {
        if (fe !== void 0)
          break e;
        const he = re.name;
        if (typeof he != "string" || he === "")
          break e;
        fe = he;
      }
      if (fe !== void 0)
        return fe = fe.replace(/\$/g, "usd"), fe = fe.replace(/\(/g, "_").replace(/\)/g, "_"), fe = fe.replace(/[^a-zA-Z0-9-_]/g, "_"), fe;
    })(), se = $({ ...te, name: ie })(typeof ee == "function" ? (fe, he, me) => incorporateMediaQueries(ee(fe, he, me)) : incorporateMediaQueries(ee));
    function de(fe) {
      for (const he in fe)
        if (he !== "root")
          return !0;
      return !1;
    }
    const ue = forwardRef(function(fe, he) {
      const { className: me, classes: xe, ...ve } = fe, { classes: Te, cx: we } = se(fe, { props: fe }), Ee = we(Te.root, me);
      return fixedClassesByClasses.set(Te, {
        ...Te,
        root: Ee
      }), React__default.createElement(re, { ref: he, className: de(Te) ? me : Ee, ...typeof J == "string" ? {} : { classes: Te }, ...ve });
    });
    return ie !== void 0 && (ue.displayName = `${capitalize(ie)}WithStyles`, Object.defineProperty(ue, "name", { value: ue.displayName })), ue;
  }
  return V.getClasses = getClasses, { withStyles: V };
}
const fixedClassesByClasses = /* @__PURE__ */ new WeakMap(), errorMessageGetClasses = "getClasses should only be used in conjunction with withStyles";
function getClasses(C) {
  const e = C.classes;
  if (e === void 0)
    throw new Error(errorMessageGetClasses);
  const T = fixedClassesByClasses.get(e);
  if (T === void 0)
    throw new Error(errorMessageGetClasses);
  return T;
}
function incorporateMediaQueries(C) {
  const e = {}, T = {};
  return Object.keys(C).forEach(($) => ($.startsWith("@media") ? T : e)[$] = C[$]), Object.keys(T).forEach(($) => {
    const V = T[$];
    Object.keys(V).forEach((J) => {
      var ee;
      return e[J] = {
        ...(ee = e[J]) !== null && ee !== void 0 ? ee : {},
        [$]: V[J]
      };
    });
  }), e;
}
const isSSR = !(typeof document == "object" && typeof (document == null ? void 0 : document.getElementById) == "function") && !(typeof jest < "u") && !(typeof mocha < "u") && !(typeof __vitest_worker__ < "u");
function createTss(C) {
  counter = 0, nestedSelectorUsageTrackRecord.splice(0, nestedSelectorUsageTrackRecord.length);
  const { useContext: e, usePlugin: T, cache: $ } = C, { useCache: V } = createUseCache({ cacheProvidedAtInception: $ }), { useCssAndCx: J } = createUseCssAndCx({ useCache: V });
  return { tss: createTss_internal({
    useContext: e,
    useCache: V,
    useCssAndCx: J,
    usePlugin: T ?? (({ classes: re, cx: ie, css: se }) => ({ classes: re, cx: ie, css: se })),
    name: void 0,
    doesUseNestedSelectors: !1
  }) };
}
let counter = 0;
const nestedSelectorUsageTrackRecord = [];
function createTss_internal(C) {
  const { useContext: e, useCache: T, useCssAndCx: $, usePlugin: V, name: J, doesUseNestedSelectors: ee } = C;
  return {
    withParams: () => createTss_internal({ ...C }),
    withName: (te) => createTss_internal({
      ...C,
      name: typeof te != "object" ? te : Object.keys(te)[0]
    }),
    withNestedSelectors: () => createTss_internal({
      ...C,
      doesUseNestedSelectors: !0
    }),
    create: (te) => {
      const re = `x${counter++}`;
      if (J !== void 0)
        for (; ; ) {
          const se = nestedSelectorUsageTrackRecord.find((de) => de.name === J);
          if (se === void 0)
            break;
          nestedSelectorUsageTrackRecord.splice(nestedSelectorUsageTrackRecord.indexOf(se), 1);
        }
      const ie = typeof te == "function" ? te : () => te;
      return function(de) {
        var ue, fe, he;
        const { classesOverrides: me, ...xe } = de ?? {}, ve = e(), { css: Te, cx: we } = $(), Ee = T(), Me = () => {
          const _e = {}, De = ie({
            ...de,
            ...ve,
            ...ee ? {
              classes: typeof Proxy > "u" ? {} : new Proxy({}, {
                get: (Ae, ne) => {
                  if (typeof ne == "symbol" && assert(!1), isSSR && J === void 0)
                    throw new Error([
                      "tss-react: In SSR setups, in order to use nested selectors, you must also give a unique name to the useStyle function.",
                      'Solution: Use tss.withName("ComponentName").withNestedSelectors<...>()... to set a name.'
                    ].join(`
`));
                  e: {
                    if (J === void 0)
                      break e;
                    let oe = nestedSelectorUsageTrackRecord.find((ce) => ce.name === J && ce.idOfUseStyles === re);
                    oe === void 0 && (oe = { name: J, idOfUseStyles: re, nestedSelectorRuleNames: /* @__PURE__ */ new Set() }, nestedSelectorUsageTrackRecord.push(oe)), oe.nestedSelectorRuleNames.add(ne);
                  }
                  e: {
                    if (J === void 0 || !(nestedSelectorUsageTrackRecord.find((ce) => ce.name === J && ce.idOfUseStyles !== re && ce.nestedSelectorRuleNames.has(ne)) !== void 0))
                      break e;
                    throw new Error([
                      `tss-react: There are in your codebase two different useStyles named "${J}" that`,
                      `both use use the nested selector ${ne}.
`,
                      `This may lead to CSS class name collisions, causing nested selectors to target elements outside of the intended scope.
`,
                      `Solution: Ensure each useStyles using nested selectors has a unique name.
`,
                      'Use: tss.withName("UniqueName").withNestedSelectors<...>()...'
                    ].join(" "));
                  }
                  return _e[ne] = `${Ee.key}-${J !== void 0 ? J : re}-${ne}-ref`;
                }
              })
            } : {}
          });
          let Fe = objectFromEntries(objectKeys(De).map((Ae) => {
            const ne = De[Ae];
            return ne.label || (ne.label = `${J !== void 0 ? `${J}-` : ""}${Ae}`), [
              Ae,
              `${Te(ne)}${typeGuard(Ae, Ae in _e) ? ` ${_e[Ae]}` : ""}`
            ];
          }));
          return objectKeys(_e).forEach((Ae) => {
            Ae in Fe || (Fe[Ae] = _e[Ae]);
          }), Fe = mergeClasses(Fe, me, we), Fe;
        }, Ie = runGetClassesOrUseCache({
          cache: Ee,
          cssObjectByRuleNameOrGetCssObjectByRuleName: te,
          classesOverridesRef: getDependencyArrayRef(me),
          paramsAndPluginParamsRef: getDependencyArrayRef(xe),
          idOfUseStyles: re,
          context: ve,
          getClasses: Me
        }), ke = V({
          classes: Ie,
          css: Te,
          cx: we,
          idOfUseStyles: re,
          name: J,
          ...ve,
          ...xe
        });
        return {
          classes: (ue = ke.classes) !== null && ue !== void 0 ? ue : Ie,
          css: (fe = ke.css) !== null && fe !== void 0 ? fe : Te,
          cx: (he = ke.cx) !== null && he !== void 0 ? he : we,
          ...ve
        };
      };
    }
  };
}
const mapCache = /* @__PURE__ */ new WeakMap();
function runGetClassesOrUseCache(C) {
  const { cache: e, cssObjectByRuleNameOrGetCssObjectByRuleName: T, classesOverridesRef: $, paramsAndPluginParamsRef: V, idOfUseStyles: J, context: ee, getClasses: te } = C;
  e: {
    const ie = mapCache.get(e);
    if (ie === void 0)
      break e;
    const se = ie.get(T);
    if (se === void 0)
      break e;
    const de = se.get($);
    if (de === void 0)
      break e;
    const ue = de.get(V);
    if (ue === void 0)
      break e;
    const fe = ue.find(({ context: he }) => {
      if (he === ee)
        return !0;
      if (objectKeys(he).length !== objectKeys(ee).length)
        return !1;
      for (const me in he)
        if (getDependencyArrayRef(he[me]) !== getDependencyArrayRef(ee[me]))
          return !1;
      return !0;
    });
    if (fe === void 0)
      break e;
    if ((fe == null ? void 0 : fe.idOfUseStyles) !== J) {
      ue.splice(ue.indexOf(fe), 1);
      break e;
    }
    return fe.result;
  }
  const re = te();
  {
    mapCache.has(e) || mapCache.set(e, /* @__PURE__ */ new WeakMap());
    const ie = mapCache.get(e);
    assert(ie !== void 0), ie.has(T) || ie.set(T, /* @__PURE__ */ new Map());
    const se = ie.get(T);
    assert(se !== void 0), se.has($) || (se.size > 200 && se.clear(), se.set($, /* @__PURE__ */ new Map()));
    const de = se.get($);
    if (assert(de !== void 0), !de.has(V)) {
      e: {
        const fe = typeof V == "string" ? 257 : 5;
        if (de.size < fe)
          break e;
        de.clear();
      }
      de.set(V, []);
    }
    let ue = de.get(V);
    assert(ue !== void 0), ue.length > 5 && (ue = []), ue.push({ idOfUseStyles: J, context: ee, result: re });
  }
  return re;
}
function createMakeAndWithStyles(C) {
  return {
    ...createMakeStyles(C),
    ...createWithStyles(C)
  };
}
const { tss: tss$1 } = createTss({
  useContext: () => ({})
});
tss$1.create({});
const { makeStyles, withStyles } = createMakeAndWithStyles({
  useTheme: useTheme$1
}), { tss } = createTss({
  useContext: function() {
    return { theme: useTheme$1() };
  },
  usePlugin: useMuiThemeStyleOverridesPlugin
});
tss.create({});
const useStyles$D = makeStyles()(
  (C, { align: e, fontSize: T }) => ({
    title: {
      fontSize: `${T}px`,
      width: "100%",
      textAlign: e,
      fontFamily: C.palette.font.header,
      [C.breakpoints.down("sm")]: {
        fontSize: "24px"
      }
    }
  })
);
function Header(C) {
  const e = {
    align: C.align || "center",
    fontSize: C.size || 42
  }, { classes: T } = useStyles$D(e);
  return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: T.title, "data-test-id": C.testId, children: C.text });
}
function getSvgIconUtilityClass(C) {
  return generateUtilityClass("MuiSvgIcon", C);
}
generateUtilityClasses("MuiSvgIcon", ["root", "colorPrimary", "colorSecondary", "colorAction", "colorError", "colorDisabled", "fontSizeInherit", "fontSizeSmall", "fontSizeMedium", "fontSizeLarge"]);
const _excluded$R = ["children", "className", "color", "component", "fontSize", "htmlColor", "inheritViewBox", "titleAccess", "viewBox"], useUtilityClasses$J = (C) => {
  const {
    color: e,
    fontSize: T,
    classes: $
  } = C, V = {
    root: ["root", e !== "inherit" && `color${capitalize$3(e)}`, `fontSize${capitalize$3(T)}`]
  };
  return composeClasses(V, getSvgIconUtilityClass, $);
}, SvgIconRoot = styled$1("svg", {
  name: "MuiSvgIcon",
  slot: "Root",
  overridesResolver: (C, e) => {
    const {
      ownerState: T
    } = C;
    return [e.root, T.color !== "inherit" && e[`color${capitalize$3(T.color)}`], e[`fontSize${capitalize$3(T.fontSize)}`]];
  }
})(({
  theme: C,
  ownerState: e
}) => {
  var T, $, V, J, ee, te, re, ie, se, de, ue, fe, he;
  return {
    userSelect: "none",
    width: "1em",
    height: "1em",
    display: "inline-block",
    // the <svg> will define the property that has `currentColor`
    // for example heroicons uses fill="none" and stroke="currentColor"
    fill: e.hasSvgAsChild ? void 0 : "currentColor",
    flexShrink: 0,
    transition: (T = C.transitions) == null || ($ = T.create) == null ? void 0 : $.call(T, "fill", {
      duration: (V = C.transitions) == null || (V = V.duration) == null ? void 0 : V.shorter
    }),
    fontSize: {
      inherit: "inherit",
      small: ((J = C.typography) == null || (ee = J.pxToRem) == null ? void 0 : ee.call(J, 20)) || "1.25rem",
      medium: ((te = C.typography) == null || (re = te.pxToRem) == null ? void 0 : re.call(te, 24)) || "1.5rem",
      large: ((ie = C.typography) == null || (se = ie.pxToRem) == null ? void 0 : se.call(ie, 35)) || "2.1875rem"
    }[e.fontSize],
    // TODO v5 deprecate, v6 remove for sx
    color: (de = (ue = (C.vars || C).palette) == null || (ue = ue[e.color]) == null ? void 0 : ue.main) != null ? de : {
      action: (fe = (C.vars || C).palette) == null || (fe = fe.action) == null ? void 0 : fe.active,
      disabled: (he = (C.vars || C).palette) == null || (he = he.action) == null ? void 0 : he.disabled,
      inherit: void 0
    }[e.color]
  };
}), SvgIcon = /* @__PURE__ */ React$1.forwardRef(function(e, T) {
  const $ = useDefaultProps({
    props: e,
    name: "MuiSvgIcon"
  }), {
    children: V,
    className: J,
    color: ee = "inherit",
    component: te = "svg",
    fontSize: re = "medium",
    htmlColor: ie,
    inheritViewBox: se = !1,
    titleAccess: de,
    viewBox: ue = "0 0 24 24"
  } = $, fe = _objectWithoutPropertiesLoose($, _excluded$R), he = /* @__PURE__ */ React$1.isValidElement(V) && V.type === "svg", me = _extends({}, $, {
    color: ee,
    component: te,
    fontSize: re,
    instanceFontSize: e.fontSize,
    inheritViewBox: se,
    viewBox: ue,
    hasSvgAsChild: he
  }), xe = {};
  se || (xe.viewBox = ue);
  const ve = useUtilityClasses$J(me);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(SvgIconRoot, _extends({
    as: te,
    className: clsx(ve.root, J),
    focusable: "false",
    color: ie,
    "aria-hidden": de ? void 0 : !0,
    role: de ? "img" : void 0,
    ref: T
  }, xe, fe, he && V.props, {
    ownerState: me,
    children: [he ? V.props.children : V, de ? /* @__PURE__ */ jsxRuntimeExports.jsx("title", {
      children: de
    }) : null]
  }));
});
dist$2.process.env.NODE_ENV !== "production" && (SvgIcon.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Node passed into the SVG element.
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * You can use the `htmlColor` prop to apply a color attribute to the SVG element.
   * @default 'inherit'
   */
  color: PropTypes.oneOfType([PropTypes.oneOf(["inherit", "action", "disabled", "primary", "secondary", "error", "info", "success", "warning"]), PropTypes.string]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes.elementType,
  /**
   * The fontSize applied to the icon. Defaults to 24px, but can be configure to inherit font size.
   * @default 'medium'
   */
  fontSize: PropTypes.oneOfType([PropTypes.oneOf(["inherit", "large", "medium", "small"]), PropTypes.string]),
  /**
   * Applies a color attribute to the SVG element.
   */
  htmlColor: PropTypes.string,
  /**
   * If `true`, the root node will inherit the custom `component`'s viewBox and the `viewBox`
   * prop will be ignored.
   * Useful when you want to reference a custom `component` and have `SvgIcon` pass that
   * `component`'s viewBox to the root node.
   * @default false
   */
  inheritViewBox: PropTypes.bool,
  /**
   * The shape-rendering attribute. The behavior of the different options is described on the
   * [MDN Web Docs](https://developer.mozilla.org/en-US/docs/Web/SVG/Attribute/shape-rendering).
   * If you are having issues with blurry icons you should investigate this prop.
   */
  shapeRendering: PropTypes.string,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * Provides a human-readable title for the element that contains it.
   * https://www.w3.org/TR/SVG-access/#Equivalent
   */
  titleAccess: PropTypes.string,
  /**
   * Allows you to redefine what the coordinates without units mean inside an SVG element.
   * For example, if the SVG element is 500 (width) by 200 (height),
   * and you pass viewBox="0 0 50 20",
   * this means that the coordinates inside the SVG will go from the top left corner (0,0)
   * to bottom right (50,20) and each unit will be worth 10px.
   * @default '0 0 24 24'
   */
  viewBox: PropTypes.string
});
SvgIcon.muiName = "SvgIcon";
function createSvgIcon$1(C, e) {
  function T($, V) {
    return /* @__PURE__ */ jsxRuntimeExports.jsx(SvgIcon, _extends({
      "data-testid": `${e}Icon`,
      ref: V
    }, $, {
      children: C
    }));
  }
  return dist$2.process.env.NODE_ENV !== "production" && (T.displayName = `${e}Icon`), T.muiName = SvgIcon.muiName, /* @__PURE__ */ React$1.memo(/* @__PURE__ */ React$1.forwardRef(T));
}
const unstable_ClassNameGenerator = {
  configure: (C) => {
    dist$2.process.env.NODE_ENV !== "production" && console.warn(["MUI: `ClassNameGenerator` import from `@mui/material/utils` is outdated and might cause unexpected issues.", "", "You should use `import { unstable_ClassNameGenerator } from '@mui/material/className'` instead", "", "The detail of the issue: https://github.com/mui/material-ui/issues/30011#issuecomment-1024993401", "", "The updated documentation: https://mui.com/guides/classname-generator/"].join(`
`)), ClassNameGenerator.configure(C);
  }
}, utils = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  capitalize: capitalize$3,
  createChainedFunction,
  createSvgIcon: createSvgIcon$1,
  debounce: debounce$1,
  deprecatedPropType,
  isMuiElement,
  ownerDocument,
  ownerWindow,
  requirePropFactory,
  setRef,
  unstable_ClassNameGenerator,
  unstable_useEnhancedEffect: useEnhancedEffect,
  unstable_useId: useId,
  unsupportedProp,
  useControlled,
  useEventCallback,
  useForkRef,
  useIsFocusVisible
}, Symbol.toStringTag, { value: "Module" }));
function _setPrototypeOf(C, e) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(T, $) {
    return T.__proto__ = $, T;
  }, _setPrototypeOf(C, e);
}
function _inheritsLoose(C, e) {
  C.prototype = Object.create(e.prototype), C.prototype.constructor = C, _setPrototypeOf(C, e);
}
const config = {
  disabled: !1
};
var timeoutsShape = dist$2.process.env.NODE_ENV !== "production" ? PropTypes.oneOfType([PropTypes.number, PropTypes.shape({
  enter: PropTypes.number,
  exit: PropTypes.number,
  appear: PropTypes.number
}).isRequired]) : null;
dist$2.process.env.NODE_ENV !== "production" && PropTypes.oneOfType([PropTypes.string, PropTypes.shape({
  enter: PropTypes.string,
  exit: PropTypes.string,
  active: PropTypes.string
}), PropTypes.shape({
  enter: PropTypes.string,
  enterDone: PropTypes.string,
  enterActive: PropTypes.string,
  exit: PropTypes.string,
  exitDone: PropTypes.string,
  exitActive: PropTypes.string
})]);
const TransitionGroupContext = React__default.createContext(null);
var forceReflow = function(e) {
  return e.scrollTop;
}, UNMOUNTED = "unmounted", EXITED = "exited", ENTERING = "entering", ENTERED = "entered", EXITING = "exiting", Transition = /* @__PURE__ */ function(C) {
  _inheritsLoose(e, C);
  function e($, V) {
    var J;
    J = C.call(this, $, V) || this;
    var ee = V, te = ee && !ee.isMounting ? $.enter : $.appear, re;
    return J.appearStatus = null, $.in ? te ? (re = EXITED, J.appearStatus = ENTERING) : re = ENTERED : $.unmountOnExit || $.mountOnEnter ? re = UNMOUNTED : re = EXITED, J.state = {
      status: re
    }, J.nextCallback = null, J;
  }
  e.getDerivedStateFromProps = function(V, J) {
    var ee = V.in;
    return ee && J.status === UNMOUNTED ? {
      status: EXITED
    } : null;
  };
  var T = e.prototype;
  return T.componentDidMount = function() {
    this.updateStatus(!0, this.appearStatus);
  }, T.componentDidUpdate = function(V) {
    var J = null;
    if (V !== this.props) {
      var ee = this.state.status;
      this.props.in ? ee !== ENTERING && ee !== ENTERED && (J = ENTERING) : (ee === ENTERING || ee === ENTERED) && (J = EXITING);
    }
    this.updateStatus(!1, J);
  }, T.componentWillUnmount = function() {
    this.cancelNextCallback();
  }, T.getTimeouts = function() {
    var V = this.props.timeout, J, ee, te;
    return J = ee = te = V, V != null && typeof V != "number" && (J = V.exit, ee = V.enter, te = V.appear !== void 0 ? V.appear : ee), {
      exit: J,
      enter: ee,
      appear: te
    };
  }, T.updateStatus = function(V, J) {
    if (V === void 0 && (V = !1), J !== null)
      if (this.cancelNextCallback(), J === ENTERING) {
        if (this.props.unmountOnExit || this.props.mountOnEnter) {
          var ee = this.props.nodeRef ? this.props.nodeRef.current : ReactDOM__default.findDOMNode(this);
          ee && forceReflow(ee);
        }
        this.performEnter(V);
      } else
        this.performExit();
    else this.props.unmountOnExit && this.state.status === EXITED && this.setState({
      status: UNMOUNTED
    });
  }, T.performEnter = function(V) {
    var J = this, ee = this.props.enter, te = this.context ? this.context.isMounting : V, re = this.props.nodeRef ? [te] : [ReactDOM__default.findDOMNode(this), te], ie = re[0], se = re[1], de = this.getTimeouts(), ue = te ? de.appear : de.enter;
    if (!V && !ee || config.disabled) {
      this.safeSetState({
        status: ENTERED
      }, function() {
        J.props.onEntered(ie);
      });
      return;
    }
    this.props.onEnter(ie, se), this.safeSetState({
      status: ENTERING
    }, function() {
      J.props.onEntering(ie, se), J.onTransitionEnd(ue, function() {
        J.safeSetState({
          status: ENTERED
        }, function() {
          J.props.onEntered(ie, se);
        });
      });
    });
  }, T.performExit = function() {
    var V = this, J = this.props.exit, ee = this.getTimeouts(), te = this.props.nodeRef ? void 0 : ReactDOM__default.findDOMNode(this);
    if (!J || config.disabled) {
      this.safeSetState({
        status: EXITED
      }, function() {
        V.props.onExited(te);
      });
      return;
    }
    this.props.onExit(te), this.safeSetState({
      status: EXITING
    }, function() {
      V.props.onExiting(te), V.onTransitionEnd(ee.exit, function() {
        V.safeSetState({
          status: EXITED
        }, function() {
          V.props.onExited(te);
        });
      });
    });
  }, T.cancelNextCallback = function() {
    this.nextCallback !== null && (this.nextCallback.cancel(), this.nextCallback = null);
  }, T.safeSetState = function(V, J) {
    J = this.setNextCallback(J), this.setState(V, J);
  }, T.setNextCallback = function(V) {
    var J = this, ee = !0;
    return this.nextCallback = function(te) {
      ee && (ee = !1, J.nextCallback = null, V(te));
    }, this.nextCallback.cancel = function() {
      ee = !1;
    }, this.nextCallback;
  }, T.onTransitionEnd = function(V, J) {
    this.setNextCallback(J);
    var ee = this.props.nodeRef ? this.props.nodeRef.current : ReactDOM__default.findDOMNode(this), te = V == null && !this.props.addEndListener;
    if (!ee || te) {
      setTimeout(this.nextCallback, 0);
      return;
    }
    if (this.props.addEndListener) {
      var re = this.props.nodeRef ? [this.nextCallback] : [ee, this.nextCallback], ie = re[0], se = re[1];
      this.props.addEndListener(ie, se);
    }
    V != null && setTimeout(this.nextCallback, V);
  }, T.render = function() {
    var V = this.state.status;
    if (V === UNMOUNTED)
      return null;
    var J = this.props, ee = J.children;
    J.in, J.mountOnEnter, J.unmountOnExit, J.appear, J.enter, J.exit, J.timeout, J.addEndListener, J.onEnter, J.onEntering, J.onEntered, J.onExit, J.onExiting, J.onExited, J.nodeRef;
    var te = _objectWithoutPropertiesLoose(J, ["children", "in", "mountOnEnter", "unmountOnExit", "appear", "enter", "exit", "timeout", "addEndListener", "onEnter", "onEntering", "onEntered", "onExit", "onExiting", "onExited", "nodeRef"]);
    return (
      // allows for nested Transitions
      /* @__PURE__ */ React__default.createElement(TransitionGroupContext.Provider, {
        value: null
      }, typeof ee == "function" ? ee(V, te) : React__default.cloneElement(React__default.Children.only(ee), te))
    );
  }, e;
}(React__default.Component);
Transition.contextType = TransitionGroupContext;
Transition.propTypes = dist$2.process.env.NODE_ENV !== "production" ? {
  /**
   * A React reference to DOM element that need to transition:
   * https://stackoverflow.com/a/51127130/4671932
   *
   *   - When `nodeRef` prop is used, `node` is not passed to callback functions
   *      (e.g. `onEnter`) because user already has direct access to the node.
   *   - When changing `key` prop of `Transition` in a `TransitionGroup` a new
   *     `nodeRef` need to be provided to `Transition` with changed `key` prop
   *     (see
   *     [test/CSSTransition-test.js](https://github.com/reactjs/react-transition-group/blob/13435f897b3ab71f6e19d724f145596f5910581c/test/CSSTransition-test.js#L362-L437)).
   */
  nodeRef: PropTypes.shape({
    current: typeof Element > "u" ? PropTypes.any : function(C, e, T, $, V, J) {
      var ee = C[e];
      return PropTypes.instanceOf(ee && "ownerDocument" in ee ? ee.ownerDocument.defaultView.Element : Element)(C, e, T, $, V, J);
    }
  }),
  /**
   * A `function` child can be used instead of a React element. This function is
   * called with the current transition status (`'entering'`, `'entered'`,
   * `'exiting'`, `'exited'`), which can be used to apply context
   * specific props to a component.
   *
   * ```jsx
   * <Transition in={this.state.in} timeout={150}>
   *   {state => (
   *     <MyComponent className={`fade fade-${state}`} />
   *   )}
   * </Transition>
   * ```
   */
  children: PropTypes.oneOfType([PropTypes.func.isRequired, PropTypes.element.isRequired]).isRequired,
  /**
   * Show the component; triggers the enter or exit states
   */
  in: PropTypes.bool,
  /**
   * By default the child component is mounted immediately along with
   * the parent `Transition` component. If you want to "lazy mount" the component on the
   * first `in={true}` you can set `mountOnEnter`. After the first enter transition the component will stay
   * mounted, even on "exited", unless you also specify `unmountOnExit`.
   */
  mountOnEnter: PropTypes.bool,
  /**
   * By default the child component stays mounted after it reaches the `'exited'` state.
   * Set `unmountOnExit` if you'd prefer to unmount the component after it finishes exiting.
   */
  unmountOnExit: PropTypes.bool,
  /**
   * By default the child component does not perform the enter transition when
   * it first mounts, regardless of the value of `in`. If you want this
   * behavior, set both `appear` and `in` to `true`.
   *
   * > **Note**: there are no special appear states like `appearing`/`appeared`, this prop
   * > only adds an additional enter transition. However, in the
   * > `<CSSTransition>` component that first enter transition does result in
   * > additional `.appear-*` classes, that way you can choose to style it
   * > differently.
   */
  appear: PropTypes.bool,
  /**
   * Enable or disable enter transitions.
   */
  enter: PropTypes.bool,
  /**
   * Enable or disable exit transitions.
   */
  exit: PropTypes.bool,
  /**
   * The duration of the transition, in milliseconds.
   * Required unless `addEndListener` is provided.
   *
   * You may specify a single timeout for all transitions:
   *
   * ```jsx
   * timeout={500}
   * ```
   *
   * or individually:
   *
   * ```jsx
   * timeout={{
   *  appear: 500,
   *  enter: 300,
   *  exit: 500,
   * }}
   * ```
   *
   * - `appear` defaults to the value of `enter`
   * - `enter` defaults to `0`
   * - `exit` defaults to `0`
   *
   * @type {number | { enter?: number, exit?: number, appear?: number }}
   */
  timeout: function(e) {
    var T = timeoutsShape;
    e.addEndListener || (T = T.isRequired);
    for (var $ = arguments.length, V = new Array($ > 1 ? $ - 1 : 0), J = 1; J < $; J++)
      V[J - 1] = arguments[J];
    return T.apply(void 0, [e].concat(V));
  },
  /**
   * Add a custom transition end trigger. Called with the transitioning
   * DOM node and a `done` callback. Allows for more fine grained transition end
   * logic. Timeouts are still used as a fallback if provided.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * ```jsx
   * addEndListener={(node, done) => {
   *   // use the css transitionend event to mark the finish of a transition
   *   node.addEventListener('transitionend', done, false);
   * }}
   * ```
   */
  addEndListener: PropTypes.func,
  /**
   * Callback fired before the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEnter: PropTypes.func,
  /**
   * Callback fired after the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntering: PropTypes.func,
  /**
   * Callback fired after the "entered" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEntered: PropTypes.func,
  /**
   * Callback fired before the "exiting" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExit: PropTypes.func,
  /**
   * Callback fired after the "exiting" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExiting: PropTypes.func,
  /**
   * Callback fired after the "exited" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExited: PropTypes.func
} : {};
function noop() {
}
Transition.defaultProps = {
  in: !1,
  mountOnEnter: !1,
  unmountOnExit: !1,
  appear: !1,
  enter: !0,
  exit: !0,
  onEnter: noop,
  onEntering: noop,
  onEntered: noop,
  onExit: noop,
  onExiting: noop,
  onExited: noop
};
Transition.UNMOUNTED = UNMOUNTED;
Transition.EXITED = EXITED;
Transition.ENTERING = ENTERING;
Transition.ENTERED = ENTERED;
Transition.EXITING = EXITING;
function _assertThisInitialized(C) {
  if (C === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return C;
}
function getChildMapping(C, e) {
  var T = function(J) {
    return e && isValidElement(J) ? e(J) : J;
  }, $ = /* @__PURE__ */ Object.create(null);
  return C && Children.map(C, function(V) {
    return V;
  }).forEach(function(V) {
    $[V.key] = T(V);
  }), $;
}
function mergeChildMappings(C, e) {
  C = C || {}, e = e || {};
  function T(se) {
    return se in e ? e[se] : C[se];
  }
  var $ = /* @__PURE__ */ Object.create(null), V = [];
  for (var J in C)
    J in e ? V.length && ($[J] = V, V = []) : V.push(J);
  var ee, te = {};
  for (var re in e) {
    if ($[re])
      for (ee = 0; ee < $[re].length; ee++) {
        var ie = $[re][ee];
        te[$[re][ee]] = T(ie);
      }
    te[re] = T(re);
  }
  for (ee = 0; ee < V.length; ee++)
    te[V[ee]] = T(V[ee]);
  return te;
}
function getProp(C, e, T) {
  return T[e] != null ? T[e] : C.props[e];
}
function getInitialChildMapping(C, e) {
  return getChildMapping(C.children, function(T) {
    return cloneElement(T, {
      onExited: e.bind(null, T),
      in: !0,
      appear: getProp(T, "appear", C),
      enter: getProp(T, "enter", C),
      exit: getProp(T, "exit", C)
    });
  });
}
function getNextChildMapping(C, e, T) {
  var $ = getChildMapping(C.children), V = mergeChildMappings(e, $);
  return Object.keys(V).forEach(function(J) {
    var ee = V[J];
    if (isValidElement(ee)) {
      var te = J in e, re = J in $, ie = e[J], se = isValidElement(ie) && !ie.props.in;
      re && (!te || se) ? V[J] = cloneElement(ee, {
        onExited: T.bind(null, ee),
        in: !0,
        exit: getProp(ee, "exit", C),
        enter: getProp(ee, "enter", C)
      }) : !re && te && !se ? V[J] = cloneElement(ee, {
        in: !1
      }) : re && te && isValidElement(ie) && (V[J] = cloneElement(ee, {
        onExited: T.bind(null, ee),
        in: ie.props.in,
        exit: getProp(ee, "exit", C),
        enter: getProp(ee, "enter", C)
      }));
    }
  }), V;
}
var values = Object.values || function(C) {
  return Object.keys(C).map(function(e) {
    return C[e];
  });
}, defaultProps = {
  component: "div",
  childFactory: function(e) {
    return e;
  }
}, TransitionGroup = /* @__PURE__ */ function(C) {
  _inheritsLoose(e, C);
  function e($, V) {
    var J;
    J = C.call(this, $, V) || this;
    var ee = J.handleExited.bind(_assertThisInitialized(J));
    return J.state = {
      contextValue: {
        isMounting: !0
      },
      handleExited: ee,
      firstRender: !0
    }, J;
  }
  var T = e.prototype;
  return T.componentDidMount = function() {
    this.mounted = !0, this.setState({
      contextValue: {
        isMounting: !1
      }
    });
  }, T.componentWillUnmount = function() {
    this.mounted = !1;
  }, e.getDerivedStateFromProps = function(V, J) {
    var ee = J.children, te = J.handleExited, re = J.firstRender;
    return {
      children: re ? getInitialChildMapping(V, te) : getNextChildMapping(V, ee, te),
      firstRender: !1
    };
  }, T.handleExited = function(V, J) {
    var ee = getChildMapping(this.props.children);
    V.key in ee || (V.props.onExited && V.props.onExited(J), this.mounted && this.setState(function(te) {
      var re = _extends({}, te.children);
      return delete re[V.key], {
        children: re
      };
    }));
  }, T.render = function() {
    var V = this.props, J = V.component, ee = V.childFactory, te = _objectWithoutPropertiesLoose(V, ["component", "childFactory"]), re = this.state.contextValue, ie = values(this.state.children).map(ee);
    return delete te.appear, delete te.enter, delete te.exit, J === null ? /* @__PURE__ */ React__default.createElement(TransitionGroupContext.Provider, {
      value: re
    }, ie) : /* @__PURE__ */ React__default.createElement(TransitionGroupContext.Provider, {
      value: re
    }, /* @__PURE__ */ React__default.createElement(J, te, ie));
  }, e;
}(React__default.Component);
TransitionGroup.propTypes = dist$2.process.env.NODE_ENV !== "production" ? {
  /**
   * `<TransitionGroup>` renders a `<div>` by default. You can change this
   * behavior by providing a `component` prop.
   * If you use React v16+ and would like to avoid a wrapping `<div>` element
   * you can pass in `component={null}`. This is useful if the wrapping div
   * borks your css styles.
   */
  component: PropTypes.any,
  /**
   * A set of `<Transition>` components, that are toggled `in` and out as they
   * leave. the `<TransitionGroup>` will inject specific transition props, so
   * remember to spread them through if you are wrapping the `<Transition>` as
   * with our `<Fade>` example.
   *
   * While this component is meant for multiple `Transition` or `CSSTransition`
   * children, sometimes you may want to have a single transition child with
   * content that you want to be transitioned out and in when you change it
   * (e.g. routes, images etc.) In that case you can change the `key` prop of
   * the transition child as you change its content, this will cause
   * `TransitionGroup` to transition the child out and back in.
   */
  children: PropTypes.node,
  /**
   * A convenience prop that enables or disables appear animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  appear: PropTypes.bool,
  /**
   * A convenience prop that enables or disables enter animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  enter: PropTypes.bool,
  /**
   * A convenience prop that enables or disables exit animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  exit: PropTypes.bool,
  /**
   * You may need to apply reactive updates to a child as it is exiting.
   * This is generally done by using `cloneElement` however in the case of an exiting
   * child the element has already been removed and not accessible to the consumer.
   *
   * If you do need to update a child as it leaves you can provide a `childFactory`
   * to wrap every child, even the ones that are leaving.
   *
   * @type Function(child: ReactElement) -> ReactElement
   */
  childFactory: PropTypes.func
} : {};
TransitionGroup.defaultProps = defaultProps;
const reflow = (C) => C.scrollTop;
function getTransitionProps(C, e) {
  var T, $;
  const {
    timeout: V,
    easing: J,
    style: ee = {}
  } = C;
  return {
    duration: (T = ee.transitionDuration) != null ? T : typeof V == "number" ? V : V[e.mode] || 0,
    easing: ($ = ee.transitionTimingFunction) != null ? $ : typeof J == "object" ? J[e.mode] : J,
    delay: ee.transitionDelay
  };
}
function getCollapseUtilityClass(C) {
  return generateUtilityClass("MuiCollapse", C);
}
generateUtilityClasses("MuiCollapse", ["root", "horizontal", "vertical", "entered", "hidden", "wrapper", "wrapperInner"]);
const _excluded$Q = ["addEndListener", "children", "className", "collapsedSize", "component", "easing", "in", "onEnter", "onEntered", "onEntering", "onExit", "onExited", "onExiting", "orientation", "style", "timeout", "TransitionComponent"], useUtilityClasses$I = (C) => {
  const {
    orientation: e,
    classes: T
  } = C, $ = {
    root: ["root", `${e}`],
    entered: ["entered"],
    hidden: ["hidden"],
    wrapper: ["wrapper", `${e}`],
    wrapperInner: ["wrapperInner", `${e}`]
  };
  return composeClasses($, getCollapseUtilityClass, T);
}, CollapseRoot = styled$1("div", {
  name: "MuiCollapse",
  slot: "Root",
  overridesResolver: (C, e) => {
    const {
      ownerState: T
    } = C;
    return [e.root, e[T.orientation], T.state === "entered" && e.entered, T.state === "exited" && !T.in && T.collapsedSize === "0px" && e.hidden];
  }
})(({
  theme: C,
  ownerState: e
}) => _extends({
  height: 0,
  overflow: "hidden",
  transition: C.transitions.create("height")
}, e.orientation === "horizontal" && {
  height: "auto",
  width: 0,
  transition: C.transitions.create("width")
}, e.state === "entered" && _extends({
  height: "auto",
  overflow: "visible"
}, e.orientation === "horizontal" && {
  width: "auto"
}), e.state === "exited" && !e.in && e.collapsedSize === "0px" && {
  visibility: "hidden"
})), CollapseWrapper = styled$1("div", {
  name: "MuiCollapse",
  slot: "Wrapper",
  overridesResolver: (C, e) => e.wrapper
})(({
  ownerState: C
}) => _extends({
  // Hack to get children with a negative margin to not falsify the height computation.
  display: "flex",
  width: "100%"
}, C.orientation === "horizontal" && {
  width: "auto",
  height: "100%"
})), CollapseWrapperInner = styled$1("div", {
  name: "MuiCollapse",
  slot: "WrapperInner",
  overridesResolver: (C, e) => e.wrapperInner
})(({
  ownerState: C
}) => _extends({
  width: "100%"
}, C.orientation === "horizontal" && {
  width: "auto",
  height: "100%"
})), Collapse = /* @__PURE__ */ React$1.forwardRef(function(e, T) {
  const $ = useDefaultProps({
    props: e,
    name: "MuiCollapse"
  }), {
    addEndListener: V,
    children: J,
    className: ee,
    collapsedSize: te = "0px",
    component: re,
    easing: ie,
    in: se,
    onEnter: de,
    onEntered: ue,
    onEntering: fe,
    onExit: he,
    onExited: me,
    onExiting: xe,
    orientation: ve = "vertical",
    style: Te,
    timeout: we = duration.standard,
    // eslint-disable-next-line react/prop-types
    TransitionComponent: Ee = Transition
  } = $, Me = _objectWithoutPropertiesLoose($, _excluded$Q), Ie = _extends({}, $, {
    orientation: ve,
    collapsedSize: te
  }), ke = useUtilityClasses$I(Ie), _e = useTheme$1(), De = useTimeout(), Fe = React$1.useRef(null), Ae = React$1.useRef(), ne = typeof te == "number" ? `${te}px` : te, oe = ve === "horizontal", ce = oe ? "width" : "height", le = React$1.useRef(null), pe = useForkRef(T, le), ye = (We) => (Be) => {
    if (We) {
      const Ue = le.current;
      Be === void 0 ? We(Ue) : We(Ue, Be);
    }
  }, Ce = () => Fe.current ? Fe.current[oe ? "clientWidth" : "clientHeight"] : 0, be = ye((We, Be) => {
    Fe.current && oe && (Fe.current.style.position = "absolute"), We.style[ce] = ne, de && de(We, Be);
  }), ae = ye((We, Be) => {
    const Ue = Ce();
    Fe.current && oe && (Fe.current.style.position = "");
    const {
      duration: Ge,
      easing: je
    } = getTransitionProps({
      style: Te,
      timeout: we,
      easing: ie
    }, {
      mode: "enter"
    });
    if (we === "auto") {
      const Oe = _e.transitions.getAutoHeightDuration(Ue);
      We.style.transitionDuration = `${Oe}ms`, Ae.current = Oe;
    } else
      We.style.transitionDuration = typeof Ge == "string" ? Ge : `${Ge}ms`;
    We.style[ce] = `${Ue}px`, We.style.transitionTimingFunction = je, fe && fe(We, Be);
  }), ge = ye((We, Be) => {
    We.style[ce] = "auto", ue && ue(We, Be);
  }), Se = ye((We) => {
    We.style[ce] = `${Ce()}px`, he && he(We);
  }), Le = ye(me), ze = ye((We) => {
    const Be = Ce(), {
      duration: Ue,
      easing: Ge
    } = getTransitionProps({
      style: Te,
      timeout: we,
      easing: ie
    }, {
      mode: "exit"
    });
    if (we === "auto") {
      const je = _e.transitions.getAutoHeightDuration(Be);
      We.style.transitionDuration = `${je}ms`, Ae.current = je;
    } else
      We.style.transitionDuration = typeof Ue == "string" ? Ue : `${Ue}ms`;
    We.style[ce] = ne, We.style.transitionTimingFunction = Ge, xe && xe(We);
  }), Re = (We) => {
    we === "auto" && De.start(Ae.current || 0, We), V && V(le.current, We);
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsx(Ee, _extends({
    in: se,
    onEnter: be,
    onEntered: ge,
    onEntering: ae,
    onExit: Se,
    onExited: Le,
    onExiting: ze,
    addEndListener: Re,
    nodeRef: le,
    timeout: we === "auto" ? null : we
  }, Me, {
    children: (We, Be) => /* @__PURE__ */ jsxRuntimeExports.jsx(CollapseRoot, _extends({
      as: re,
      className: clsx(ke.root, ee, {
        entered: ke.entered,
        exited: !se && ne === "0px" && ke.hidden
      }[We]),
      style: _extends({
        [oe ? "minWidth" : "minHeight"]: ne
      }, Te),
      ref: pe
    }, Be, {
      // `ownerState` is set after `childProps` to override any existing `ownerState` property in `childProps`
      // that might have been forwarded from the Transition component.
      ownerState: _extends({}, Ie, {
        state: We
      }),
      children: /* @__PURE__ */ jsxRuntimeExports.jsx(CollapseWrapper, {
        ownerState: _extends({}, Ie, {
          state: We
        }),
        className: ke.wrapper,
        ref: Fe,
        children: /* @__PURE__ */ jsxRuntimeExports.jsx(CollapseWrapperInner, {
          ownerState: _extends({}, Ie, {
            state: We
          }),
          className: ke.wrapperInner,
          children: J
        })
      })
    }))
  }));
});
dist$2.process.env.NODE_ENV !== "production" && (Collapse.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Add a custom transition end trigger. Called with the transitioning DOM
   * node and a done callback. Allows for more fine grained transition end
   * logic. Note: Timeouts are still used as a fallback if provided.
   */
  addEndListener: PropTypes.func,
  /**
   * The content node to be collapsed.
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The width (horizontal) or height (vertical) of the container when collapsed.
   * @default '0px'
   */
  collapsedSize: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: elementTypeAcceptingRef$1,
  /**
   * The transition timing function.
   * You may specify a single easing or a object containing enter and exit values.
   */
  easing: PropTypes.oneOfType([PropTypes.shape({
    enter: PropTypes.string,
    exit: PropTypes.string
  }), PropTypes.string]),
  /**
   * If `true`, the component will transition in.
   */
  in: PropTypes.bool,
  /**
   * @ignore
   */
  onEnter: PropTypes.func,
  /**
   * @ignore
   */
  onEntered: PropTypes.func,
  /**
   * @ignore
   */
  onEntering: PropTypes.func,
  /**
   * @ignore
   */
  onExit: PropTypes.func,
  /**
   * @ignore
   */
  onExited: PropTypes.func,
  /**
   * @ignore
   */
  onExiting: PropTypes.func,
  /**
   * The transition orientation.
   * @default 'vertical'
   */
  orientation: PropTypes.oneOf(["horizontal", "vertical"]),
  /**
   * @ignore
   */
  style: PropTypes.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   *
   * Set to 'auto' to automatically calculate transition time based on height.
   * @default duration.standard
   */
  timeout: PropTypes.oneOfType([PropTypes.oneOf(["auto"]), PropTypes.number, PropTypes.shape({
    appear: PropTypes.number,
    enter: PropTypes.number,
    exit: PropTypes.number
  })])
});
Collapse.muiSupportAuto = !0;
function getPaperUtilityClass(C) {
  return generateUtilityClass("MuiPaper", C);
}
generateUtilityClasses("MuiPaper", ["root", "rounded", "outlined", "elevation", "elevation0", "elevation1", "elevation2", "elevation3", "elevation4", "elevation5", "elevation6", "elevation7", "elevation8", "elevation9", "elevation10", "elevation11", "elevation12", "elevation13", "elevation14", "elevation15", "elevation16", "elevation17", "elevation18", "elevation19", "elevation20", "elevation21", "elevation22", "elevation23", "elevation24"]);
const _excluded$P = ["className", "component", "elevation", "square", "variant"], useUtilityClasses$H = (C) => {
  const {
    square: e,
    elevation: T,
    variant: $,
    classes: V
  } = C, J = {
    root: ["root", $, !e && "rounded", $ === "elevation" && `elevation${T}`]
  };
  return composeClasses(J, getPaperUtilityClass, V);
}, PaperRoot = styled$1("div", {
  name: "MuiPaper",
  slot: "Root",
  overridesResolver: (C, e) => {
    const {
      ownerState: T
    } = C;
    return [e.root, e[T.variant], !T.square && e.rounded, T.variant === "elevation" && e[`elevation${T.elevation}`]];
  }
})(({
  theme: C,
  ownerState: e
}) => {
  var T;
  return _extends({
    backgroundColor: (C.vars || C).palette.background.paper,
    color: (C.vars || C).palette.text.primary,
    transition: C.transitions.create("box-shadow")
  }, !e.square && {
    borderRadius: C.shape.borderRadius
  }, e.variant === "outlined" && {
    border: `1px solid ${(C.vars || C).palette.divider}`
  }, e.variant === "elevation" && _extends({
    boxShadow: (C.vars || C).shadows[e.elevation]
  }, !C.vars && C.palette.mode === "dark" && {
    backgroundImage: `linear-gradient(${alpha_1("#fff", getOverlayAlpha(e.elevation))}, ${alpha_1("#fff", getOverlayAlpha(e.elevation))})`
  }, C.vars && {
    backgroundImage: (T = C.vars.overlays) == null ? void 0 : T[e.elevation]
  }));
}), Paper = /* @__PURE__ */ React$1.forwardRef(function(e, T) {
  const $ = useDefaultProps({
    props: e,
    name: "MuiPaper"
  }), {
    className: V,
    component: J = "div",
    elevation: ee = 1,
    square: te = !1,
    variant: re = "elevation"
  } = $, ie = _objectWithoutPropertiesLoose($, _excluded$P), se = _extends({}, $, {
    component: J,
    elevation: ee,
    square: te,
    variant: re
  }), de = useUtilityClasses$H(se);
  return dist$2.process.env.NODE_ENV !== "production" && useTheme$1().shadows[ee] === void 0 && console.error([`MUI: The elevation provided <Paper elevation={${ee}}> is not available in the theme.`, `Please make sure that \`theme.shadows[${ee}]\` is defined.`].join(`
`)), /* @__PURE__ */ jsxRuntimeExports.jsx(PaperRoot, _extends({
    as: J,
    ownerState: se,
    className: clsx(de.root, V),
    ref: T
  }, ie));
});
dist$2.process.env.NODE_ENV !== "production" && (Paper.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes.elementType,
  /**
   * Shadow depth, corresponds to `dp` in the spec.
   * It accepts values between 0 and 24 inclusive.
   * @default 1
   */
  elevation: chainPropTypes(integerPropType, (C) => {
    const {
      elevation: e,
      variant: T
    } = C;
    return e > 0 && T === "outlined" ? new Error(`MUI: Combining \`elevation={${e}}\` with \`variant="${T}"\` has no effect. Either use \`elevation={0}\` or use a different \`variant\`.`) : null;
  }),
  /**
   * If `true`, rounded corners are disabled.
   * @default false
   */
  square: PropTypes.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * The variant to use.
   * @default 'elevation'
   */
  variant: PropTypes.oneOfType([PropTypes.oneOf(["elevation", "outlined"]), PropTypes.string])
});
function Ripple(C) {
  const {
    className: e,
    classes: T,
    pulsate: $ = !1,
    rippleX: V,
    rippleY: J,
    rippleSize: ee,
    in: te,
    onExited: re,
    timeout: ie
  } = C, [se, de] = React$1.useState(!1), ue = clsx(e, T.ripple, T.rippleVisible, $ && T.ripplePulsate), fe = {
    width: ee,
    height: ee,
    top: -(ee / 2) + J,
    left: -(ee / 2) + V
  }, he = clsx(T.child, se && T.childLeaving, $ && T.childPulsate);
  return !te && !se && de(!0), React$1.useEffect(() => {
    if (!te && re != null) {
      const me = setTimeout(re, ie);
      return () => {
        clearTimeout(me);
      };
    }
  }, [re, te, ie]), /* @__PURE__ */ jsxRuntimeExports.jsx("span", {
    className: ue,
    style: fe,
    children: /* @__PURE__ */ jsxRuntimeExports.jsx("span", {
      className: he
    })
  });
}
dist$2.process.env.NODE_ENV !== "production" && (Ripple.propTypes = {
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object.isRequired,
  className: PropTypes.string,
  /**
   * @ignore - injected from TransitionGroup
   */
  in: PropTypes.bool,
  /**
   * @ignore - injected from TransitionGroup
   */
  onExited: PropTypes.func,
  /**
   * If `true`, the ripple pulsates, typically indicating the keyboard focus state of an element.
   */
  pulsate: PropTypes.bool,
  /**
   * Diameter of the ripple.
   */
  rippleSize: PropTypes.number,
  /**
   * Horizontal position of the ripple center.
   */
  rippleX: PropTypes.number,
  /**
   * Vertical position of the ripple center.
   */
  rippleY: PropTypes.number,
  /**
   * exit delay
   */
  timeout: PropTypes.number.isRequired
});
const touchRippleClasses = generateUtilityClasses("MuiTouchRipple", ["root", "ripple", "rippleVisible", "ripplePulsate", "child", "childLeaving", "childPulsate"]), _excluded$O = ["center", "classes", "className"];
let _$3 = (C) => C, _t$3, _t2$3, _t3$3, _t4$3;
const DURATION = 550, DELAY_RIPPLE = 80, enterKeyframe = keyframes(_t$3 || (_t$3 = _$3`
  0% {
    transform: scale(0);
    opacity: 0.1;
  }

  100% {
    transform: scale(1);
    opacity: 0.3;
  }
`)), exitKeyframe = keyframes(_t2$3 || (_t2$3 = _$3`
  0% {
    opacity: 1;
  }

  100% {
    opacity: 0;
  }
`)), pulsateKeyframe = keyframes(_t3$3 || (_t3$3 = _$3`
  0% {
    transform: scale(1);
  }

  50% {
    transform: scale(0.92);
  }

  100% {
    transform: scale(1);
  }
`)), TouchRippleRoot = styled$1("span", {
  name: "MuiTouchRipple",
  slot: "Root"
})({
  overflow: "hidden",
  pointerEvents: "none",
  position: "absolute",
  zIndex: 0,
  top: 0,
  right: 0,
  bottom: 0,
  left: 0,
  borderRadius: "inherit"
}), TouchRippleRipple = styled$1(Ripple, {
  name: "MuiTouchRipple",
  slot: "Ripple"
})(_t4$3 || (_t4$3 = _$3`
  opacity: 0;
  position: absolute;

  &.${0} {
    opacity: 0.3;
    transform: scale(1);
    animation-name: ${0};
    animation-duration: ${0}ms;
    animation-timing-function: ${0};
  }

  &.${0} {
    animation-duration: ${0}ms;
  }

  & .${0} {
    opacity: 1;
    display: block;
    width: 100%;
    height: 100%;
    border-radius: 50%;
    background-color: currentColor;
  }

  & .${0} {
    opacity: 0;
    animation-name: ${0};
    animation-duration: ${0}ms;
    animation-timing-function: ${0};
  }

  & .${0} {
    position: absolute;
    /* @noflip */
    left: 0px;
    top: 0;
    animation-name: ${0};
    animation-duration: 2500ms;
    animation-timing-function: ${0};
    animation-iteration-count: infinite;
    animation-delay: 200ms;
  }
`), touchRippleClasses.rippleVisible, enterKeyframe, DURATION, ({
  theme: C
}) => C.transitions.easing.easeInOut, touchRippleClasses.ripplePulsate, ({
  theme: C
}) => C.transitions.duration.shorter, touchRippleClasses.child, touchRippleClasses.childLeaving, exitKeyframe, DURATION, ({
  theme: C
}) => C.transitions.easing.easeInOut, touchRippleClasses.childPulsate, pulsateKeyframe, ({
  theme: C
}) => C.transitions.easing.easeInOut), TouchRipple = /* @__PURE__ */ React$1.forwardRef(function(e, T) {
  const $ = useDefaultProps({
    props: e,
    name: "MuiTouchRipple"
  }), {
    center: V = !1,
    classes: J = {},
    className: ee
  } = $, te = _objectWithoutPropertiesLoose($, _excluded$O), [re, ie] = React$1.useState([]), se = React$1.useRef(0), de = React$1.useRef(null);
  React$1.useEffect(() => {
    de.current && (de.current(), de.current = null);
  }, [re]);
  const ue = React$1.useRef(!1), fe = useTimeout(), he = React$1.useRef(null), me = React$1.useRef(null), xe = React$1.useCallback((Ee) => {
    const {
      pulsate: Me,
      rippleX: Ie,
      rippleY: ke,
      rippleSize: _e,
      cb: De
    } = Ee;
    ie((Fe) => [...Fe, /* @__PURE__ */ jsxRuntimeExports.jsx(TouchRippleRipple, {
      classes: {
        ripple: clsx(J.ripple, touchRippleClasses.ripple),
        rippleVisible: clsx(J.rippleVisible, touchRippleClasses.rippleVisible),
        ripplePulsate: clsx(J.ripplePulsate, touchRippleClasses.ripplePulsate),
        child: clsx(J.child, touchRippleClasses.child),
        childLeaving: clsx(J.childLeaving, touchRippleClasses.childLeaving),
        childPulsate: clsx(J.childPulsate, touchRippleClasses.childPulsate)
      },
      timeout: DURATION,
      pulsate: Me,
      rippleX: Ie,
      rippleY: ke,
      rippleSize: _e
    }, se.current)]), se.current += 1, de.current = De;
  }, [J]), ve = React$1.useCallback((Ee = {}, Me = {}, Ie = () => {
  }) => {
    const {
      pulsate: ke = !1,
      center: _e = V || Me.pulsate,
      fakeElement: De = !1
      // For test purposes
    } = Me;
    if ((Ee == null ? void 0 : Ee.type) === "mousedown" && ue.current) {
      ue.current = !1;
      return;
    }
    (Ee == null ? void 0 : Ee.type) === "touchstart" && (ue.current = !0);
    const Fe = De ? null : me.current, Ae = Fe ? Fe.getBoundingClientRect() : {
      width: 0,
      height: 0,
      left: 0,
      top: 0
    };
    let ne, oe, ce;
    if (_e || Ee === void 0 || Ee.clientX === 0 && Ee.clientY === 0 || !Ee.clientX && !Ee.touches)
      ne = Math.round(Ae.width / 2), oe = Math.round(Ae.height / 2);
    else {
      const {
        clientX: le,
        clientY: pe
      } = Ee.touches && Ee.touches.length > 0 ? Ee.touches[0] : Ee;
      ne = Math.round(le - Ae.left), oe = Math.round(pe - Ae.top);
    }
    if (_e)
      ce = Math.sqrt((2 * Ae.width ** 2 + Ae.height ** 2) / 3), ce % 2 === 0 && (ce += 1);
    else {
      const le = Math.max(Math.abs((Fe ? Fe.clientWidth : 0) - ne), ne) * 2 + 2, pe = Math.max(Math.abs((Fe ? Fe.clientHeight : 0) - oe), oe) * 2 + 2;
      ce = Math.sqrt(le ** 2 + pe ** 2);
    }
    Ee != null && Ee.touches ? he.current === null && (he.current = () => {
      xe({
        pulsate: ke,
        rippleX: ne,
        rippleY: oe,
        rippleSize: ce,
        cb: Ie
      });
    }, fe.start(DELAY_RIPPLE, () => {
      he.current && (he.current(), he.current = null);
    })) : xe({
      pulsate: ke,
      rippleX: ne,
      rippleY: oe,
      rippleSize: ce,
      cb: Ie
    });
  }, [V, xe, fe]), Te = React$1.useCallback(() => {
    ve({}, {
      pulsate: !0
    });
  }, [ve]), we = React$1.useCallback((Ee, Me) => {
    if (fe.clear(), (Ee == null ? void 0 : Ee.type) === "touchend" && he.current) {
      he.current(), he.current = null, fe.start(0, () => {
        we(Ee, Me);
      });
      return;
    }
    he.current = null, ie((Ie) => Ie.length > 0 ? Ie.slice(1) : Ie), de.current = Me;
  }, [fe]);
  return React$1.useImperativeHandle(T, () => ({
    pulsate: Te,
    start: ve,
    stop: we
  }), [Te, ve, we]), /* @__PURE__ */ jsxRuntimeExports.jsx(TouchRippleRoot, _extends({
    className: clsx(touchRippleClasses.root, J.root, ee),
    ref: me
  }, te, {
    children: /* @__PURE__ */ jsxRuntimeExports.jsx(TransitionGroup, {
      component: null,
      exit: !0,
      children: re
    })
  }));
});
dist$2.process.env.NODE_ENV !== "production" && (TouchRipple.propTypes = {
  /**
   * If `true`, the ripple starts at the center of the component
   * rather than at the point of interaction.
   */
  center: PropTypes.bool,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string
});
function getButtonBaseUtilityClass(C) {
  return generateUtilityClass("MuiButtonBase", C);
}
const buttonBaseClasses = generateUtilityClasses("MuiButtonBase", ["root", "disabled", "focusVisible"]), _excluded$N = ["action", "centerRipple", "children", "className", "component", "disabled", "disableRipple", "disableTouchRipple", "focusRipple", "focusVisibleClassName", "LinkComponent", "onBlur", "onClick", "onContextMenu", "onDragLeave", "onFocus", "onFocusVisible", "onKeyDown", "onKeyUp", "onMouseDown", "onMouseLeave", "onMouseUp", "onTouchEnd", "onTouchMove", "onTouchStart", "tabIndex", "TouchRippleProps", "touchRippleRef", "type"], useUtilityClasses$G = (C) => {
  const {
    disabled: e,
    focusVisible: T,
    focusVisibleClassName: $,
    classes: V
  } = C, ee = composeClasses({
    root: ["root", e && "disabled", T && "focusVisible"]
  }, getButtonBaseUtilityClass, V);
  return T && $ && (ee.root += ` ${$}`), ee;
}, ButtonBaseRoot = styled$1("button", {
  name: "MuiButtonBase",
  slot: "Root",
  overridesResolver: (C, e) => e.root
})({
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  position: "relative",
  boxSizing: "border-box",
  WebkitTapHighlightColor: "transparent",
  backgroundColor: "transparent",
  // Reset default value
  // We disable the focus ring for mouse, touch and keyboard users.
  outline: 0,
  border: 0,
  margin: 0,
  // Remove the margin in Safari
  borderRadius: 0,
  padding: 0,
  // Remove the padding in Firefox
  cursor: "pointer",
  userSelect: "none",
  verticalAlign: "middle",
  MozAppearance: "none",
  // Reset
  WebkitAppearance: "none",
  // Reset
  textDecoration: "none",
  // So we take precedent over the style of a native <a /> element.
  color: "inherit",
  "&::-moz-focus-inner": {
    borderStyle: "none"
    // Remove Firefox dotted outline.
  },
  [`&.${buttonBaseClasses.disabled}`]: {
    pointerEvents: "none",
    // Disable link interactions
    cursor: "default"
  },
  "@media print": {
    colorAdjust: "exact"
  }
}), ButtonBase = /* @__PURE__ */ React$1.forwardRef(function(e, T) {
  const $ = useDefaultProps({
    props: e,
    name: "MuiButtonBase"
  }), {
    action: V,
    centerRipple: J = !1,
    children: ee,
    className: te,
    component: re = "button",
    disabled: ie = !1,
    disableRipple: se = !1,
    disableTouchRipple: de = !1,
    focusRipple: ue = !1,
    LinkComponent: fe = "a",
    onBlur: he,
    onClick: me,
    onContextMenu: xe,
    onDragLeave: ve,
    onFocus: Te,
    onFocusVisible: we,
    onKeyDown: Ee,
    onKeyUp: Me,
    onMouseDown: Ie,
    onMouseLeave: ke,
    onMouseUp: _e,
    onTouchEnd: De,
    onTouchMove: Fe,
    onTouchStart: Ae,
    tabIndex: ne = 0,
    TouchRippleProps: oe,
    touchRippleRef: ce,
    type: le
  } = $, pe = _objectWithoutPropertiesLoose($, _excluded$N), ye = React$1.useRef(null), Ce = React$1.useRef(null), be = useForkRef(Ce, ce), {
    isFocusVisibleRef: ae,
    onFocus: ge,
    onBlur: Se,
    ref: Le
  } = useIsFocusVisible(), [ze, Re] = React$1.useState(!1);
  ie && ze && Re(!1), React$1.useImperativeHandle(V, () => ({
    focusVisible: () => {
      Re(!0), ye.current.focus();
    }
  }), []);
  const [We, Be] = React$1.useState(!1);
  React$1.useEffect(() => {
    Be(!0);
  }, []);
  const Ue = We && !se && !ie;
  React$1.useEffect(() => {
    ze && ue && !se && We && Ce.current.pulsate();
  }, [se, ue, ze, We]);
  function Ge($e, Ze, at = de) {
    return useEventCallback((wt) => (Ze && Ze(wt), !at && Ce.current && Ce.current[$e](wt), !0));
  }
  const je = Ge("start", Ie), Oe = Ge("stop", xe), Ne = Ge("stop", ve), Ye = Ge("stop", _e), Je = Ge("stop", ($e) => {
    ze && $e.preventDefault(), ke && ke($e);
  }), Xe = Ge("start", Ae), st = Ge("stop", De), ct = Ge("stop", Fe), it = Ge("stop", ($e) => {
    Se($e), ae.current === !1 && Re(!1), he && he($e);
  }, !1), ot = useEventCallback(($e) => {
    ye.current || (ye.current = $e.currentTarget), ge($e), ae.current === !0 && (Re(!0), we && we($e)), Te && Te($e);
  }), yt = () => {
    const $e = ye.current;
    return re && re !== "button" && !($e.tagName === "A" && $e.href);
  }, dt = React$1.useRef(!1), mt = useEventCallback(($e) => {
    ue && !dt.current && ze && Ce.current && $e.key === " " && (dt.current = !0, Ce.current.stop($e, () => {
      Ce.current.start($e);
    })), $e.target === $e.currentTarget && yt() && $e.key === " " && $e.preventDefault(), Ee && Ee($e), $e.target === $e.currentTarget && yt() && $e.key === "Enter" && !ie && ($e.preventDefault(), me && me($e));
  }), It = useEventCallback(($e) => {
    ue && $e.key === " " && Ce.current && ze && !$e.defaultPrevented && (dt.current = !1, Ce.current.stop($e, () => {
      Ce.current.pulsate($e);
    })), Me && Me($e), me && $e.target === $e.currentTarget && yt() && $e.key === " " && !$e.defaultPrevented && me($e);
  });
  let xt = re;
  xt === "button" && (pe.href || pe.to) && (xt = fe);
  const Tt = {};
  xt === "button" ? (Tt.type = le === void 0 ? "button" : le, Tt.disabled = ie) : (!pe.href && !pe.to && (Tt.role = "button"), ie && (Tt["aria-disabled"] = ie));
  const Yt = useForkRef(T, Le, ye);
  dist$2.process.env.NODE_ENV !== "production" && React$1.useEffect(() => {
    Ue && !Ce.current && console.error(["MUI: The `component` prop provided to ButtonBase is invalid.", "Please make sure the children prop is rendered in this custom component."].join(`
`));
  }, [Ue]);
  const Ve = _extends({}, $, {
    centerRipple: J,
    component: re,
    disabled: ie,
    disableRipple: se,
    disableTouchRipple: de,
    focusRipple: ue,
    tabIndex: ne,
    focusVisible: ze
  }), Pe = useUtilityClasses$G(Ve);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(ButtonBaseRoot, _extends({
    as: xt,
    className: clsx(Pe.root, te),
    ownerState: Ve,
    onBlur: it,
    onClick: me,
    onContextMenu: Oe,
    onFocus: ot,
    onKeyDown: mt,
    onKeyUp: It,
    onMouseDown: je,
    onMouseLeave: Je,
    onMouseUp: Ye,
    onDragLeave: Ne,
    onTouchEnd: st,
    onTouchMove: ct,
    onTouchStart: Xe,
    ref: Yt,
    tabIndex: ie ? -1 : ne,
    type: le
  }, Tt, pe, {
    children: [ee, Ue ? (
      /* TouchRipple is only needed client-side, x2 boost on the server. */
      /* @__PURE__ */ jsxRuntimeExports.jsx(TouchRipple, _extends({
        ref: be,
        center: J
      }, oe))
    ) : null]
  }));
});
dist$2.process.env.NODE_ENV !== "production" && (ButtonBase.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * A ref for imperative actions.
   * It currently only supports `focusVisible()` action.
   */
  action: refType,
  /**
   * If `true`, the ripples are centered.
   * They won't start at the cursor interaction position.
   * @default false
   */
  centerRipple: PropTypes.bool,
  /**
   * The content of the component.
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: elementTypeAcceptingRef$1,
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: PropTypes.bool,
  /**
   * If `true`, the ripple effect is disabled.
   *
   * ⚠️ Without a ripple there is no styling for :focus-visible by default. Be sure
   * to highlight the element by applying separate styles with the `.Mui-focusVisible` class.
   * @default false
   */
  disableRipple: PropTypes.bool,
  /**
   * If `true`, the touch ripple effect is disabled.
   * @default false
   */
  disableTouchRipple: PropTypes.bool,
  /**
   * If `true`, the base button will have a keyboard focus ripple.
   * @default false
   */
  focusRipple: PropTypes.bool,
  /**
   * This prop can help identify which element has keyboard focus.
   * The class name will be applied when the element gains the focus through keyboard interaction.
   * It's a polyfill for the [CSS :focus-visible selector](https://drafts.csswg.org/selectors-4/#the-focus-visible-pseudo).
   * The rationale for using this feature [is explained here](https://github.com/WICG/focus-visible/blob/HEAD/explainer.md).
   * A [polyfill can be used](https://github.com/WICG/focus-visible) to apply a `focus-visible` class to other components
   * if needed.
   */
  focusVisibleClassName: PropTypes.string,
  /**
   * @ignore
   */
  href: PropTypes.any,
  /**
   * The component used to render a link when the `href` prop is provided.
   * @default 'a'
   */
  LinkComponent: PropTypes.elementType,
  /**
   * @ignore
   */
  onBlur: PropTypes.func,
  /**
   * @ignore
   */
  onClick: PropTypes.func,
  /**
   * @ignore
   */
  onContextMenu: PropTypes.func,
  /**
   * @ignore
   */
  onDragLeave: PropTypes.func,
  /**
   * @ignore
   */
  onFocus: PropTypes.func,
  /**
   * Callback fired when the component is focused with a keyboard.
   * We trigger a `onFocus` callback too.
   */
  onFocusVisible: PropTypes.func,
  /**
   * @ignore
   */
  onKeyDown: PropTypes.func,
  /**
   * @ignore
   */
  onKeyUp: PropTypes.func,
  /**
   * @ignore
   */
  onMouseDown: PropTypes.func,
  /**
   * @ignore
   */
  onMouseLeave: PropTypes.func,
  /**
   * @ignore
   */
  onMouseUp: PropTypes.func,
  /**
   * @ignore
   */
  onTouchEnd: PropTypes.func,
  /**
   * @ignore
   */
  onTouchMove: PropTypes.func,
  /**
   * @ignore
   */
  onTouchStart: PropTypes.func,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * @default 0
   */
  tabIndex: PropTypes.number,
  /**
   * Props applied to the `TouchRipple` element.
   */
  TouchRippleProps: PropTypes.object,
  /**
   * A ref that points to the `TouchRipple` element.
   */
  touchRippleRef: PropTypes.oneOfType([PropTypes.func, PropTypes.shape({
    current: PropTypes.shape({
      pulsate: PropTypes.func.isRequired,
      start: PropTypes.func.isRequired,
      stop: PropTypes.func.isRequired
    })
  })]),
  /**
   * @ignore
   */
  type: PropTypes.oneOfType([PropTypes.oneOf(["button", "reset", "submit"]), PropTypes.string])
});
function getIconButtonUtilityClass(C) {
  return generateUtilityClass("MuiIconButton", C);
}
const iconButtonClasses = generateUtilityClasses("MuiIconButton", ["root", "disabled", "colorInherit", "colorPrimary", "colorSecondary", "colorError", "colorInfo", "colorSuccess", "colorWarning", "edgeStart", "edgeEnd", "sizeSmall", "sizeMedium", "sizeLarge"]), _excluded$M = ["edge", "children", "className", "color", "disabled", "disableFocusRipple", "size"], useUtilityClasses$F = (C) => {
  const {
    classes: e,
    disabled: T,
    color: $,
    edge: V,
    size: J
  } = C, ee = {
    root: ["root", T && "disabled", $ !== "default" && `color${capitalize$3($)}`, V && `edge${capitalize$3(V)}`, `size${capitalize$3(J)}`]
  };
  return composeClasses(ee, getIconButtonUtilityClass, e);
}, IconButtonRoot = styled$1(ButtonBase, {
  name: "MuiIconButton",
  slot: "Root",
  overridesResolver: (C, e) => {
    const {
      ownerState: T
    } = C;
    return [e.root, T.color !== "default" && e[`color${capitalize$3(T.color)}`], T.edge && e[`edge${capitalize$3(T.edge)}`], e[`size${capitalize$3(T.size)}`]];
  }
})(({
  theme: C,
  ownerState: e
}) => _extends({
  textAlign: "center",
  flex: "0 0 auto",
  fontSize: C.typography.pxToRem(24),
  padding: 8,
  borderRadius: "50%",
  overflow: "visible",
  // Explicitly set the default value to solve a bug on IE11.
  color: (C.vars || C).palette.action.active,
  transition: C.transitions.create("background-color", {
    duration: C.transitions.duration.shortest
  })
}, !e.disableRipple && {
  "&:hover": {
    backgroundColor: C.vars ? `rgba(${C.vars.palette.action.activeChannel} / ${C.vars.palette.action.hoverOpacity})` : alpha_1(C.palette.action.active, C.palette.action.hoverOpacity),
    // Reset on touch devices, it doesn't add specificity
    "@media (hover: none)": {
      backgroundColor: "transparent"
    }
  }
}, e.edge === "start" && {
  marginLeft: e.size === "small" ? -3 : -12
}, e.edge === "end" && {
  marginRight: e.size === "small" ? -3 : -12
}), ({
  theme: C,
  ownerState: e
}) => {
  var T;
  const $ = (T = (C.vars || C).palette) == null ? void 0 : T[e.color];
  return _extends({}, e.color === "inherit" && {
    color: "inherit"
  }, e.color !== "inherit" && e.color !== "default" && _extends({
    color: $ == null ? void 0 : $.main
  }, !e.disableRipple && {
    "&:hover": _extends({}, $ && {
      backgroundColor: C.vars ? `rgba(${$.mainChannel} / ${C.vars.palette.action.hoverOpacity})` : alpha_1($.main, C.palette.action.hoverOpacity)
    }, {
      // Reset on touch devices, it doesn't add specificity
      "@media (hover: none)": {
        backgroundColor: "transparent"
      }
    })
  }), e.size === "small" && {
    padding: 5,
    fontSize: C.typography.pxToRem(18)
  }, e.size === "large" && {
    padding: 12,
    fontSize: C.typography.pxToRem(28)
  }, {
    [`&.${iconButtonClasses.disabled}`]: {
      backgroundColor: "transparent",
      color: (C.vars || C).palette.action.disabled
    }
  });
}), IconButton = /* @__PURE__ */ React$1.forwardRef(function(e, T) {
  const $ = useDefaultProps({
    props: e,
    name: "MuiIconButton"
  }), {
    edge: V = !1,
    children: J,
    className: ee,
    color: te = "default",
    disabled: re = !1,
    disableFocusRipple: ie = !1,
    size: se = "medium"
  } = $, de = _objectWithoutPropertiesLoose($, _excluded$M), ue = _extends({}, $, {
    edge: V,
    color: te,
    disabled: re,
    disableFocusRipple: ie,
    size: se
  }), fe = useUtilityClasses$F(ue);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(IconButtonRoot, _extends({
    className: clsx(fe.root, ee),
    centerRipple: !0,
    focusRipple: !ie,
    disabled: re,
    ref: T
  }, de, {
    ownerState: ue,
    children: J
  }));
});
dist$2.process.env.NODE_ENV !== "production" && (IconButton.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The icon to display.
   */
  children: chainPropTypes(PropTypes.node, (C) => React$1.Children.toArray(C.children).some((T) => /* @__PURE__ */ React$1.isValidElement(T) && T.props.onClick) ? new Error(["MUI: You are providing an onClick event listener to a child of a button element.", "Prefer applying it to the IconButton directly.", "This guarantees that the whole <button> will be responsive to click events."].join(`
`)) : null),
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'default'
   */
  color: PropTypes.oneOfType([PropTypes.oneOf(["inherit", "default", "primary", "secondary", "error", "info", "success", "warning"]), PropTypes.string]),
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: PropTypes.bool,
  /**
   * If `true`, the  keyboard focus ripple is disabled.
   * @default false
   */
  disableFocusRipple: PropTypes.bool,
  /**
   * If `true`, the ripple effect is disabled.
   *
   * ⚠️ Without a ripple there is no styling for :focus-visible by default. Be sure
   * to highlight the element by applying separate styles with the `.Mui-focusVisible` class.
   * @default false
   */
  disableRipple: PropTypes.bool,
  /**
   * If given, uses a negative margin to counteract the padding on one
   * side (this is often helpful for aligning the left or right
   * side of the icon with content above or below, without ruining the border
   * size and shape).
   * @default false
   */
  edge: PropTypes.oneOf(["end", "start", !1]),
  /**
   * The size of the component.
   * `small` is equivalent to the dense button styling.
   * @default 'medium'
   */
  size: PropTypes.oneOfType([PropTypes.oneOf(["small", "medium", "large"]), PropTypes.string]),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object])
});
function getTypographyUtilityClass(C) {
  return generateUtilityClass("MuiTypography", C);
}
generateUtilityClasses("MuiTypography", ["root", "h1", "h2", "h3", "h4", "h5", "h6", "subtitle1", "subtitle2", "body1", "body2", "inherit", "button", "caption", "overline", "alignLeft", "alignRight", "alignCenter", "alignJustify", "noWrap", "gutterBottom", "paragraph"]);
const _excluded$L = ["align", "className", "component", "gutterBottom", "noWrap", "paragraph", "variant", "variantMapping"], useUtilityClasses$E = (C) => {
  const {
    align: e,
    gutterBottom: T,
    noWrap: $,
    paragraph: V,
    variant: J,
    classes: ee
  } = C, te = {
    root: ["root", J, C.align !== "inherit" && `align${capitalize$3(e)}`, T && "gutterBottom", $ && "noWrap", V && "paragraph"]
  };
  return composeClasses(te, getTypographyUtilityClass, ee);
}, TypographyRoot = styled$1("span", {
  name: "MuiTypography",
  slot: "Root",
  overridesResolver: (C, e) => {
    const {
      ownerState: T
    } = C;
    return [e.root, T.variant && e[T.variant], T.align !== "inherit" && e[`align${capitalize$3(T.align)}`], T.noWrap && e.noWrap, T.gutterBottom && e.gutterBottom, T.paragraph && e.paragraph];
  }
})(({
  theme: C,
  ownerState: e
}) => _extends({
  margin: 0
}, e.variant === "inherit" && {
  // Some elements, like <button> on Chrome have default font that doesn't inherit, reset this.
  font: "inherit"
}, e.variant !== "inherit" && C.typography[e.variant], e.align !== "inherit" && {
  textAlign: e.align
}, e.noWrap && {
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap"
}, e.gutterBottom && {
  marginBottom: "0.35em"
}, e.paragraph && {
  marginBottom: 16
})), defaultVariantMapping = {
  h1: "h1",
  h2: "h2",
  h3: "h3",
  h4: "h4",
  h5: "h5",
  h6: "h6",
  subtitle1: "h6",
  subtitle2: "h6",
  body1: "p",
  body2: "p",
  inherit: "p"
}, colorTransformations$1 = {
  primary: "primary.main",
  textPrimary: "text.primary",
  secondary: "secondary.main",
  textSecondary: "text.secondary",
  error: "error.main"
}, transformDeprecatedColors$1 = (C) => colorTransformations$1[C] || C, Typography = /* @__PURE__ */ React$1.forwardRef(function(e, T) {
  const $ = useDefaultProps({
    props: e,
    name: "MuiTypography"
  }), V = transformDeprecatedColors$1($.color), J = extendSxProp(_extends({}, $, {
    color: V
  })), {
    align: ee = "inherit",
    className: te,
    component: re,
    gutterBottom: ie = !1,
    noWrap: se = !1,
    paragraph: de = !1,
    variant: ue = "body1",
    variantMapping: fe = defaultVariantMapping
  } = J, he = _objectWithoutPropertiesLoose(J, _excluded$L), me = _extends({}, J, {
    align: ee,
    color: V,
    className: te,
    component: re,
    gutterBottom: ie,
    noWrap: se,
    paragraph: de,
    variant: ue,
    variantMapping: fe
  }), xe = re || (de ? "p" : fe[ue] || defaultVariantMapping[ue]) || "span", ve = useUtilityClasses$E(me);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(TypographyRoot, _extends({
    as: xe,
    ref: T,
    ownerState: me,
    className: clsx(ve.root, te)
  }, he));
});
dist$2.process.env.NODE_ENV !== "production" && (Typography.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Set the text-align on the component.
   * @default 'inherit'
   */
  align: PropTypes.oneOf(["center", "inherit", "justify", "left", "right"]),
  /**
   * The content of the component.
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes.elementType,
  /**
   * If `true`, the text will have a bottom margin.
   * @default false
   */
  gutterBottom: PropTypes.bool,
  /**
   * If `true`, the text will not wrap, but instead will truncate with a text overflow ellipsis.
   *
   * Note that text overflow can only happen with block or inline-block level elements
   * (the element needs to have a width in order to overflow).
   * @default false
   */
  noWrap: PropTypes.bool,
  /**
   * If `true`, the element will be a paragraph element.
   * @default false
   */
  paragraph: PropTypes.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * Applies the theme typography styles.
   * @default 'body1'
   */
  variant: PropTypes.oneOfType([PropTypes.oneOf(["body1", "body2", "button", "caption", "h1", "h2", "h3", "h4", "h5", "h6", "inherit", "overline", "subtitle1", "subtitle2"]), PropTypes.string]),
  /**
   * The component maps the variant prop to a range of different HTML element types.
   * For instance, subtitle1 to `<h6>`.
   * If you wish to change that mapping, you can provide your own.
   * Alternatively, you can use the `component` prop.
   * @default {
   *   h1: 'h1',
   *   h2: 'h2',
   *   h3: 'h3',
   *   h4: 'h4',
   *   h5: 'h5',
   *   h6: 'h6',
   *   subtitle1: 'h6',
   *   subtitle2: 'h6',
   *   body1: 'p',
   *   body2: 'p',
   *   inherit: 'p',
   * }
   */
  variantMapping: PropTypes.object
});
var useThemeWithoutDefault = {};
Object.defineProperty(useThemeWithoutDefault, "__esModule", {
  value: !0
});
var default_1$c = useThemeWithoutDefault.default = void 0, React = _interopRequireWildcard(React__default), _styledEngine = require$$1$3;
function _getRequireWildcardCache(C) {
  if (typeof WeakMap != "function") return null;
  var e = /* @__PURE__ */ new WeakMap(), T = /* @__PURE__ */ new WeakMap();
  return (_getRequireWildcardCache = function($) {
    return $ ? T : e;
  })(C);
}
function _interopRequireWildcard(C, e) {
  if (C && C.__esModule) return C;
  if (C === null || typeof C != "object" && typeof C != "function") return { default: C };
  var T = _getRequireWildcardCache(e);
  if (T && T.has(C)) return T.get(C);
  var $ = { __proto__: null }, V = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var J in C) if (J !== "default" && Object.prototype.hasOwnProperty.call(C, J)) {
    var ee = V ? Object.getOwnPropertyDescriptor(C, J) : null;
    ee && (ee.get || ee.set) ? Object.defineProperty($, J, ee) : $[J] = C[J];
  }
  return $.default = C, T && T.set(C, $), $;
}
function isObjectEmpty(C) {
  return Object.keys(C).length === 0;
}
function useTheme(C = null) {
  const e = React.useContext(_styledEngine.ThemeContext);
  return !e || isObjectEmpty(e) ? C : e;
}
default_1$c = useThemeWithoutDefault.default = useTheme;
var top = "top", bottom = "bottom", right = "right", left = "left", auto = "auto", basePlacements = [top, bottom, right, left], start = "start", end = "end", clippingParents = "clippingParents", viewport = "viewport", popper = "popper", reference = "reference", variationPlacements = /* @__PURE__ */ basePlacements.reduce(function(C, e) {
  return C.concat([e + "-" + start, e + "-" + end]);
}, []), placements = /* @__PURE__ */ [].concat(basePlacements, [auto]).reduce(function(C, e) {
  return C.concat([e, e + "-" + start, e + "-" + end]);
}, []), beforeRead = "beforeRead", read = "read", afterRead = "afterRead", beforeMain = "beforeMain", main = "main", afterMain = "afterMain", beforeWrite = "beforeWrite", write = "write", afterWrite = "afterWrite", modifierPhases = [beforeRead, read, afterRead, beforeMain, main, afterMain, beforeWrite, write, afterWrite];
function getNodeName(C) {
  return C ? (C.nodeName || "").toLowerCase() : null;
}
function getWindow(C) {
  if (C == null)
    return window;
  if (C.toString() !== "[object Window]") {
    var e = C.ownerDocument;
    return e && e.defaultView || window;
  }
  return C;
}
function isElement(C) {
  var e = getWindow(C).Element;
  return C instanceof e || C instanceof Element;
}
function isHTMLElement$1(C) {
  var e = getWindow(C).HTMLElement;
  return C instanceof e || C instanceof HTMLElement;
}
function isShadowRoot(C) {
  if (typeof ShadowRoot > "u")
    return !1;
  var e = getWindow(C).ShadowRoot;
  return C instanceof e || C instanceof ShadowRoot;
}
function applyStyles(C) {
  var e = C.state;
  Object.keys(e.elements).forEach(function(T) {
    var $ = e.styles[T] || {}, V = e.attributes[T] || {}, J = e.elements[T];
    !isHTMLElement$1(J) || !getNodeName(J) || (Object.assign(J.style, $), Object.keys(V).forEach(function(ee) {
      var te = V[ee];
      te === !1 ? J.removeAttribute(ee) : J.setAttribute(ee, te === !0 ? "" : te);
    }));
  });
}
function effect$2(C) {
  var e = C.state, T = {
    popper: {
      position: e.options.strategy,
      left: "0",
      top: "0",
      margin: "0"
    },
    arrow: {
      position: "absolute"
    },
    reference: {}
  };
  return Object.assign(e.elements.popper.style, T.popper), e.styles = T, e.elements.arrow && Object.assign(e.elements.arrow.style, T.arrow), function() {
    Object.keys(e.elements).forEach(function($) {
      var V = e.elements[$], J = e.attributes[$] || {}, ee = Object.keys(e.styles.hasOwnProperty($) ? e.styles[$] : T[$]), te = ee.reduce(function(re, ie) {
        return re[ie] = "", re;
      }, {});
      !isHTMLElement$1(V) || !getNodeName(V) || (Object.assign(V.style, te), Object.keys(J).forEach(function(re) {
        V.removeAttribute(re);
      }));
    });
  };
}
const applyStyles$1 = {
  name: "applyStyles",
  enabled: !0,
  phase: "write",
  fn: applyStyles,
  effect: effect$2,
  requires: ["computeStyles"]
};
function getBasePlacement(C) {
  return C.split("-")[0];
}
var max = Math.max, min = Math.min, round$1 = Math.round;
function getUAString() {
  var C = navigator.userAgentData;
  return C != null && C.brands && Array.isArray(C.brands) ? C.brands.map(function(e) {
    return e.brand + "/" + e.version;
  }).join(" ") : navigator.userAgent;
}
function isLayoutViewport() {
  return !/^((?!chrome|android).)*safari/i.test(getUAString());
}
function getBoundingClientRect(C, e, T) {
  e === void 0 && (e = !1), T === void 0 && (T = !1);
  var $ = C.getBoundingClientRect(), V = 1, J = 1;
  e && isHTMLElement$1(C) && (V = C.offsetWidth > 0 && round$1($.width) / C.offsetWidth || 1, J = C.offsetHeight > 0 && round$1($.height) / C.offsetHeight || 1);
  var ee = isElement(C) ? getWindow(C) : window, te = ee.visualViewport, re = !isLayoutViewport() && T, ie = ($.left + (re && te ? te.offsetLeft : 0)) / V, se = ($.top + (re && te ? te.offsetTop : 0)) / J, de = $.width / V, ue = $.height / J;
  return {
    width: de,
    height: ue,
    top: se,
    right: ie + de,
    bottom: se + ue,
    left: ie,
    x: ie,
    y: se
  };
}
function getLayoutRect(C) {
  var e = getBoundingClientRect(C), T = C.offsetWidth, $ = C.offsetHeight;
  return Math.abs(e.width - T) <= 1 && (T = e.width), Math.abs(e.height - $) <= 1 && ($ = e.height), {
    x: C.offsetLeft,
    y: C.offsetTop,
    width: T,
    height: $
  };
}
function contains(C, e) {
  var T = e.getRootNode && e.getRootNode();
  if (C.contains(e))
    return !0;
  if (T && isShadowRoot(T)) {
    var $ = e;
    do {
      if ($ && C.isSameNode($))
        return !0;
      $ = $.parentNode || $.host;
    } while ($);
  }
  return !1;
}
function getComputedStyle(C) {
  return getWindow(C).getComputedStyle(C);
}
function isTableElement(C) {
  return ["table", "td", "th"].indexOf(getNodeName(C)) >= 0;
}
function getDocumentElement(C) {
  return ((isElement(C) ? C.ownerDocument : (
    // $FlowFixMe[prop-missing]
    C.document
  )) || window.document).documentElement;
}
function getParentNode(C) {
  return getNodeName(C) === "html" ? C : (
    // this is a quicker (but less type safe) way to save quite some bytes from the bundle
    // $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    C.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    C.parentNode || // DOM Element detected
    (isShadowRoot(C) ? C.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    getDocumentElement(C)
  );
}
function getTrueOffsetParent(C) {
  return !isHTMLElement$1(C) || // https://github.com/popperjs/popper-core/issues/837
  getComputedStyle(C).position === "fixed" ? null : C.offsetParent;
}
function getContainingBlock(C) {
  var e = /firefox/i.test(getUAString()), T = /Trident/i.test(getUAString());
  if (T && isHTMLElement$1(C)) {
    var $ = getComputedStyle(C);
    if ($.position === "fixed")
      return null;
  }
  var V = getParentNode(C);
  for (isShadowRoot(V) && (V = V.host); isHTMLElement$1(V) && ["html", "body"].indexOf(getNodeName(V)) < 0; ) {
    var J = getComputedStyle(V);
    if (J.transform !== "none" || J.perspective !== "none" || J.contain === "paint" || ["transform", "perspective"].indexOf(J.willChange) !== -1 || e && J.willChange === "filter" || e && J.filter && J.filter !== "none")
      return V;
    V = V.parentNode;
  }
  return null;
}
function getOffsetParent(C) {
  for (var e = getWindow(C), T = getTrueOffsetParent(C); T && isTableElement(T) && getComputedStyle(T).position === "static"; )
    T = getTrueOffsetParent(T);
  return T && (getNodeName(T) === "html" || getNodeName(T) === "body" && getComputedStyle(T).position === "static") ? e : T || getContainingBlock(C) || e;
}
function getMainAxisFromPlacement(C) {
  return ["top", "bottom"].indexOf(C) >= 0 ? "x" : "y";
}
function within(C, e, T) {
  return max(C, min(e, T));
}
function withinMaxClamp(C, e, T) {
  var $ = within(C, e, T);
  return $ > T ? T : $;
}
function getFreshSideObject() {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  };
}
function mergePaddingObject(C) {
  return Object.assign({}, getFreshSideObject(), C);
}
function expandToHashMap(C, e) {
  return e.reduce(function(T, $) {
    return T[$] = C, T;
  }, {});
}
var toPaddingObject = function(e, T) {
  return e = typeof e == "function" ? e(Object.assign({}, T.rects, {
    placement: T.placement
  })) : e, mergePaddingObject(typeof e != "number" ? e : expandToHashMap(e, basePlacements));
};
function arrow(C) {
  var e, T = C.state, $ = C.name, V = C.options, J = T.elements.arrow, ee = T.modifiersData.popperOffsets, te = getBasePlacement(T.placement), re = getMainAxisFromPlacement(te), ie = [left, right].indexOf(te) >= 0, se = ie ? "height" : "width";
  if (!(!J || !ee)) {
    var de = toPaddingObject(V.padding, T), ue = getLayoutRect(J), fe = re === "y" ? top : left, he = re === "y" ? bottom : right, me = T.rects.reference[se] + T.rects.reference[re] - ee[re] - T.rects.popper[se], xe = ee[re] - T.rects.reference[re], ve = getOffsetParent(J), Te = ve ? re === "y" ? ve.clientHeight || 0 : ve.clientWidth || 0 : 0, we = me / 2 - xe / 2, Ee = de[fe], Me = Te - ue[se] - de[he], Ie = Te / 2 - ue[se] / 2 + we, ke = within(Ee, Ie, Me), _e = re;
    T.modifiersData[$] = (e = {}, e[_e] = ke, e.centerOffset = ke - Ie, e);
  }
}
function effect$1(C) {
  var e = C.state, T = C.options, $ = T.element, V = $ === void 0 ? "[data-popper-arrow]" : $;
  V != null && (typeof V == "string" && (V = e.elements.popper.querySelector(V), !V) || contains(e.elements.popper, V) && (e.elements.arrow = V));
}
const arrow$1 = {
  name: "arrow",
  enabled: !0,
  phase: "main",
  fn: arrow,
  effect: effect$1,
  requires: ["popperOffsets"],
  requiresIfExists: ["preventOverflow"]
};
function getVariation(C) {
  return C.split("-")[1];
}
var unsetSides = {
  top: "auto",
  right: "auto",
  bottom: "auto",
  left: "auto"
};
function roundOffsetsByDPR(C, e) {
  var T = C.x, $ = C.y, V = e.devicePixelRatio || 1;
  return {
    x: round$1(T * V) / V || 0,
    y: round$1($ * V) / V || 0
  };
}
function mapToStyles(C) {
  var e, T = C.popper, $ = C.popperRect, V = C.placement, J = C.variation, ee = C.offsets, te = C.position, re = C.gpuAcceleration, ie = C.adaptive, se = C.roundOffsets, de = C.isFixed, ue = ee.x, fe = ue === void 0 ? 0 : ue, he = ee.y, me = he === void 0 ? 0 : he, xe = typeof se == "function" ? se({
    x: fe,
    y: me
  }) : {
    x: fe,
    y: me
  };
  fe = xe.x, me = xe.y;
  var ve = ee.hasOwnProperty("x"), Te = ee.hasOwnProperty("y"), we = left, Ee = top, Me = window;
  if (ie) {
    var Ie = getOffsetParent(T), ke = "clientHeight", _e = "clientWidth";
    if (Ie === getWindow(T) && (Ie = getDocumentElement(T), getComputedStyle(Ie).position !== "static" && te === "absolute" && (ke = "scrollHeight", _e = "scrollWidth")), Ie = Ie, V === top || (V === left || V === right) && J === end) {
      Ee = bottom;
      var De = de && Ie === Me && Me.visualViewport ? Me.visualViewport.height : (
        // $FlowFixMe[prop-missing]
        Ie[ke]
      );
      me -= De - $.height, me *= re ? 1 : -1;
    }
    if (V === left || (V === top || V === bottom) && J === end) {
      we = right;
      var Fe = de && Ie === Me && Me.visualViewport ? Me.visualViewport.width : (
        // $FlowFixMe[prop-missing]
        Ie[_e]
      );
      fe -= Fe - $.width, fe *= re ? 1 : -1;
    }
  }
  var Ae = Object.assign({
    position: te
  }, ie && unsetSides), ne = se === !0 ? roundOffsetsByDPR({
    x: fe,
    y: me
  }, getWindow(T)) : {
    x: fe,
    y: me
  };
  if (fe = ne.x, me = ne.y, re) {
    var oe;
    return Object.assign({}, Ae, (oe = {}, oe[Ee] = Te ? "0" : "", oe[we] = ve ? "0" : "", oe.transform = (Me.devicePixelRatio || 1) <= 1 ? "translate(" + fe + "px, " + me + "px)" : "translate3d(" + fe + "px, " + me + "px, 0)", oe));
  }
  return Object.assign({}, Ae, (e = {}, e[Ee] = Te ? me + "px" : "", e[we] = ve ? fe + "px" : "", e.transform = "", e));
}
function computeStyles(C) {
  var e = C.state, T = C.options, $ = T.gpuAcceleration, V = $ === void 0 ? !0 : $, J = T.adaptive, ee = J === void 0 ? !0 : J, te = T.roundOffsets, re = te === void 0 ? !0 : te, ie = {
    placement: getBasePlacement(e.placement),
    variation: getVariation(e.placement),
    popper: e.elements.popper,
    popperRect: e.rects.popper,
    gpuAcceleration: V,
    isFixed: e.options.strategy === "fixed"
  };
  e.modifiersData.popperOffsets != null && (e.styles.popper = Object.assign({}, e.styles.popper, mapToStyles(Object.assign({}, ie, {
    offsets: e.modifiersData.popperOffsets,
    position: e.options.strategy,
    adaptive: ee,
    roundOffsets: re
  })))), e.modifiersData.arrow != null && (e.styles.arrow = Object.assign({}, e.styles.arrow, mapToStyles(Object.assign({}, ie, {
    offsets: e.modifiersData.arrow,
    position: "absolute",
    adaptive: !1,
    roundOffsets: re
  })))), e.attributes.popper = Object.assign({}, e.attributes.popper, {
    "data-popper-placement": e.placement
  });
}
const computeStyles$1 = {
  name: "computeStyles",
  enabled: !0,
  phase: "beforeWrite",
  fn: computeStyles,
  data: {}
};
var passive = {
  passive: !0
};
function effect(C) {
  var e = C.state, T = C.instance, $ = C.options, V = $.scroll, J = V === void 0 ? !0 : V, ee = $.resize, te = ee === void 0 ? !0 : ee, re = getWindow(e.elements.popper), ie = [].concat(e.scrollParents.reference, e.scrollParents.popper);
  return J && ie.forEach(function(se) {
    se.addEventListener("scroll", T.update, passive);
  }), te && re.addEventListener("resize", T.update, passive), function() {
    J && ie.forEach(function(se) {
      se.removeEventListener("scroll", T.update, passive);
    }), te && re.removeEventListener("resize", T.update, passive);
  };
}
const eventListeners = {
  name: "eventListeners",
  enabled: !0,
  phase: "write",
  fn: function() {
  },
  effect,
  data: {}
};
var hash$1 = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
};
function getOppositePlacement(C) {
  return C.replace(/left|right|bottom|top/g, function(e) {
    return hash$1[e];
  });
}
var hash = {
  start: "end",
  end: "start"
};
function getOppositeVariationPlacement(C) {
  return C.replace(/start|end/g, function(e) {
    return hash[e];
  });
}
function getWindowScroll(C) {
  var e = getWindow(C), T = e.pageXOffset, $ = e.pageYOffset;
  return {
    scrollLeft: T,
    scrollTop: $
  };
}
function getWindowScrollBarX(C) {
  return getBoundingClientRect(getDocumentElement(C)).left + getWindowScroll(C).scrollLeft;
}
function getViewportRect(C, e) {
  var T = getWindow(C), $ = getDocumentElement(C), V = T.visualViewport, J = $.clientWidth, ee = $.clientHeight, te = 0, re = 0;
  if (V) {
    J = V.width, ee = V.height;
    var ie = isLayoutViewport();
    (ie || !ie && e === "fixed") && (te = V.offsetLeft, re = V.offsetTop);
  }
  return {
    width: J,
    height: ee,
    x: te + getWindowScrollBarX(C),
    y: re
  };
}
function getDocumentRect(C) {
  var e, T = getDocumentElement(C), $ = getWindowScroll(C), V = (e = C.ownerDocument) == null ? void 0 : e.body, J = max(T.scrollWidth, T.clientWidth, V ? V.scrollWidth : 0, V ? V.clientWidth : 0), ee = max(T.scrollHeight, T.clientHeight, V ? V.scrollHeight : 0, V ? V.clientHeight : 0), te = -$.scrollLeft + getWindowScrollBarX(C), re = -$.scrollTop;
  return getComputedStyle(V || T).direction === "rtl" && (te += max(T.clientWidth, V ? V.clientWidth : 0) - J), {
    width: J,
    height: ee,
    x: te,
    y: re
  };
}
function isScrollParent(C) {
  var e = getComputedStyle(C), T = e.overflow, $ = e.overflowX, V = e.overflowY;
  return /auto|scroll|overlay|hidden/.test(T + V + $);
}
function getScrollParent(C) {
  return ["html", "body", "#document"].indexOf(getNodeName(C)) >= 0 ? C.ownerDocument.body : isHTMLElement$1(C) && isScrollParent(C) ? C : getScrollParent(getParentNode(C));
}
function listScrollParents(C, e) {
  var T;
  e === void 0 && (e = []);
  var $ = getScrollParent(C), V = $ === ((T = C.ownerDocument) == null ? void 0 : T.body), J = getWindow($), ee = V ? [J].concat(J.visualViewport || [], isScrollParent($) ? $ : []) : $, te = e.concat(ee);
  return V ? te : (
    // $FlowFixMe[incompatible-call]: isBody tells us target will be an HTMLElement here
    te.concat(listScrollParents(getParentNode(ee)))
  );
}
function rectToClientRect(C) {
  return Object.assign({}, C, {
    left: C.x,
    top: C.y,
    right: C.x + C.width,
    bottom: C.y + C.height
  });
}
function getInnerBoundingClientRect(C, e) {
  var T = getBoundingClientRect(C, !1, e === "fixed");
  return T.top = T.top + C.clientTop, T.left = T.left + C.clientLeft, T.bottom = T.top + C.clientHeight, T.right = T.left + C.clientWidth, T.width = C.clientWidth, T.height = C.clientHeight, T.x = T.left, T.y = T.top, T;
}
function getClientRectFromMixedType(C, e, T) {
  return e === viewport ? rectToClientRect(getViewportRect(C, T)) : isElement(e) ? getInnerBoundingClientRect(e, T) : rectToClientRect(getDocumentRect(getDocumentElement(C)));
}
function getClippingParents(C) {
  var e = listScrollParents(getParentNode(C)), T = ["absolute", "fixed"].indexOf(getComputedStyle(C).position) >= 0, $ = T && isHTMLElement$1(C) ? getOffsetParent(C) : C;
  return isElement($) ? e.filter(function(V) {
    return isElement(V) && contains(V, $) && getNodeName(V) !== "body";
  }) : [];
}
function getClippingRect(C, e, T, $) {
  var V = e === "clippingParents" ? getClippingParents(C) : [].concat(e), J = [].concat(V, [T]), ee = J[0], te = J.reduce(function(re, ie) {
    var se = getClientRectFromMixedType(C, ie, $);
    return re.top = max(se.top, re.top), re.right = min(se.right, re.right), re.bottom = min(se.bottom, re.bottom), re.left = max(se.left, re.left), re;
  }, getClientRectFromMixedType(C, ee, $));
  return te.width = te.right - te.left, te.height = te.bottom - te.top, te.x = te.left, te.y = te.top, te;
}
function computeOffsets(C) {
  var e = C.reference, T = C.element, $ = C.placement, V = $ ? getBasePlacement($) : null, J = $ ? getVariation($) : null, ee = e.x + e.width / 2 - T.width / 2, te = e.y + e.height / 2 - T.height / 2, re;
  switch (V) {
    case top:
      re = {
        x: ee,
        y: e.y - T.height
      };
      break;
    case bottom:
      re = {
        x: ee,
        y: e.y + e.height
      };
      break;
    case right:
      re = {
        x: e.x + e.width,
        y: te
      };
      break;
    case left:
      re = {
        x: e.x - T.width,
        y: te
      };
      break;
    default:
      re = {
        x: e.x,
        y: e.y
      };
  }
  var ie = V ? getMainAxisFromPlacement(V) : null;
  if (ie != null) {
    var se = ie === "y" ? "height" : "width";
    switch (J) {
      case start:
        re[ie] = re[ie] - (e[se] / 2 - T[se] / 2);
        break;
      case end:
        re[ie] = re[ie] + (e[se] / 2 - T[se] / 2);
        break;
    }
  }
  return re;
}
function detectOverflow(C, e) {
  e === void 0 && (e = {});
  var T = e, $ = T.placement, V = $ === void 0 ? C.placement : $, J = T.strategy, ee = J === void 0 ? C.strategy : J, te = T.boundary, re = te === void 0 ? clippingParents : te, ie = T.rootBoundary, se = ie === void 0 ? viewport : ie, de = T.elementContext, ue = de === void 0 ? popper : de, fe = T.altBoundary, he = fe === void 0 ? !1 : fe, me = T.padding, xe = me === void 0 ? 0 : me, ve = mergePaddingObject(typeof xe != "number" ? xe : expandToHashMap(xe, basePlacements)), Te = ue === popper ? reference : popper, we = C.rects.popper, Ee = C.elements[he ? Te : ue], Me = getClippingRect(isElement(Ee) ? Ee : Ee.contextElement || getDocumentElement(C.elements.popper), re, se, ee), Ie = getBoundingClientRect(C.elements.reference), ke = computeOffsets({
    reference: Ie,
    element: we,
    strategy: "absolute",
    placement: V
  }), _e = rectToClientRect(Object.assign({}, we, ke)), De = ue === popper ? _e : Ie, Fe = {
    top: Me.top - De.top + ve.top,
    bottom: De.bottom - Me.bottom + ve.bottom,
    left: Me.left - De.left + ve.left,
    right: De.right - Me.right + ve.right
  }, Ae = C.modifiersData.offset;
  if (ue === popper && Ae) {
    var ne = Ae[V];
    Object.keys(Fe).forEach(function(oe) {
      var ce = [right, bottom].indexOf(oe) >= 0 ? 1 : -1, le = [top, bottom].indexOf(oe) >= 0 ? "y" : "x";
      Fe[oe] += ne[le] * ce;
    });
  }
  return Fe;
}
function computeAutoPlacement(C, e) {
  e === void 0 && (e = {});
  var T = e, $ = T.placement, V = T.boundary, J = T.rootBoundary, ee = T.padding, te = T.flipVariations, re = T.allowedAutoPlacements, ie = re === void 0 ? placements : re, se = getVariation($), de = se ? te ? variationPlacements : variationPlacements.filter(function(he) {
    return getVariation(he) === se;
  }) : basePlacements, ue = de.filter(function(he) {
    return ie.indexOf(he) >= 0;
  });
  ue.length === 0 && (ue = de);
  var fe = ue.reduce(function(he, me) {
    return he[me] = detectOverflow(C, {
      placement: me,
      boundary: V,
      rootBoundary: J,
      padding: ee
    })[getBasePlacement(me)], he;
  }, {});
  return Object.keys(fe).sort(function(he, me) {
    return fe[he] - fe[me];
  });
}
function getExpandedFallbackPlacements(C) {
  if (getBasePlacement(C) === auto)
    return [];
  var e = getOppositePlacement(C);
  return [getOppositeVariationPlacement(C), e, getOppositeVariationPlacement(e)];
}
function flip(C) {
  var e = C.state, T = C.options, $ = C.name;
  if (!e.modifiersData[$]._skip) {
    for (var V = T.mainAxis, J = V === void 0 ? !0 : V, ee = T.altAxis, te = ee === void 0 ? !0 : ee, re = T.fallbackPlacements, ie = T.padding, se = T.boundary, de = T.rootBoundary, ue = T.altBoundary, fe = T.flipVariations, he = fe === void 0 ? !0 : fe, me = T.allowedAutoPlacements, xe = e.options.placement, ve = getBasePlacement(xe), Te = ve === xe, we = re || (Te || !he ? [getOppositePlacement(xe)] : getExpandedFallbackPlacements(xe)), Ee = [xe].concat(we).reduce(function(ze, Re) {
      return ze.concat(getBasePlacement(Re) === auto ? computeAutoPlacement(e, {
        placement: Re,
        boundary: se,
        rootBoundary: de,
        padding: ie,
        flipVariations: he,
        allowedAutoPlacements: me
      }) : Re);
    }, []), Me = e.rects.reference, Ie = e.rects.popper, ke = /* @__PURE__ */ new Map(), _e = !0, De = Ee[0], Fe = 0; Fe < Ee.length; Fe++) {
      var Ae = Ee[Fe], ne = getBasePlacement(Ae), oe = getVariation(Ae) === start, ce = [top, bottom].indexOf(ne) >= 0, le = ce ? "width" : "height", pe = detectOverflow(e, {
        placement: Ae,
        boundary: se,
        rootBoundary: de,
        altBoundary: ue,
        padding: ie
      }), ye = ce ? oe ? right : left : oe ? bottom : top;
      Me[le] > Ie[le] && (ye = getOppositePlacement(ye));
      var Ce = getOppositePlacement(ye), be = [];
      if (J && be.push(pe[ne] <= 0), te && be.push(pe[ye] <= 0, pe[Ce] <= 0), be.every(function(ze) {
        return ze;
      })) {
        De = Ae, _e = !1;
        break;
      }
      ke.set(Ae, be);
    }
    if (_e)
      for (var ae = he ? 3 : 1, ge = function(Re) {
        var We = Ee.find(function(Be) {
          var Ue = ke.get(Be);
          if (Ue)
            return Ue.slice(0, Re).every(function(Ge) {
              return Ge;
            });
        });
        if (We)
          return De = We, "break";
      }, Se = ae; Se > 0; Se--) {
        var Le = ge(Se);
        if (Le === "break") break;
      }
    e.placement !== De && (e.modifiersData[$]._skip = !0, e.placement = De, e.reset = !0);
  }
}
const flip$1 = {
  name: "flip",
  enabled: !0,
  phase: "main",
  fn: flip,
  requiresIfExists: ["offset"],
  data: {
    _skip: !1
  }
};
function getSideOffsets(C, e, T) {
  return T === void 0 && (T = {
    x: 0,
    y: 0
  }), {
    top: C.top - e.height - T.y,
    right: C.right - e.width + T.x,
    bottom: C.bottom - e.height + T.y,
    left: C.left - e.width - T.x
  };
}
function isAnySideFullyClipped(C) {
  return [top, right, bottom, left].some(function(e) {
    return C[e] >= 0;
  });
}
function hide(C) {
  var e = C.state, T = C.name, $ = e.rects.reference, V = e.rects.popper, J = e.modifiersData.preventOverflow, ee = detectOverflow(e, {
    elementContext: "reference"
  }), te = detectOverflow(e, {
    altBoundary: !0
  }), re = getSideOffsets(ee, $), ie = getSideOffsets(te, V, J), se = isAnySideFullyClipped(re), de = isAnySideFullyClipped(ie);
  e.modifiersData[T] = {
    referenceClippingOffsets: re,
    popperEscapeOffsets: ie,
    isReferenceHidden: se,
    hasPopperEscaped: de
  }, e.attributes.popper = Object.assign({}, e.attributes.popper, {
    "data-popper-reference-hidden": se,
    "data-popper-escaped": de
  });
}
const hide$1 = {
  name: "hide",
  enabled: !0,
  phase: "main",
  requiresIfExists: ["preventOverflow"],
  fn: hide
};
function distanceAndSkiddingToXY(C, e, T) {
  var $ = getBasePlacement(C), V = [left, top].indexOf($) >= 0 ? -1 : 1, J = typeof T == "function" ? T(Object.assign({}, e, {
    placement: C
  })) : T, ee = J[0], te = J[1];
  return ee = ee || 0, te = (te || 0) * V, [left, right].indexOf($) >= 0 ? {
    x: te,
    y: ee
  } : {
    x: ee,
    y: te
  };
}
function offset(C) {
  var e = C.state, T = C.options, $ = C.name, V = T.offset, J = V === void 0 ? [0, 0] : V, ee = placements.reduce(function(se, de) {
    return se[de] = distanceAndSkiddingToXY(de, e.rects, J), se;
  }, {}), te = ee[e.placement], re = te.x, ie = te.y;
  e.modifiersData.popperOffsets != null && (e.modifiersData.popperOffsets.x += re, e.modifiersData.popperOffsets.y += ie), e.modifiersData[$] = ee;
}
const offset$1 = {
  name: "offset",
  enabled: !0,
  phase: "main",
  requires: ["popperOffsets"],
  fn: offset
};
function popperOffsets(C) {
  var e = C.state, T = C.name;
  e.modifiersData[T] = computeOffsets({
    reference: e.rects.reference,
    element: e.rects.popper,
    strategy: "absolute",
    placement: e.placement
  });
}
const popperOffsets$1 = {
  name: "popperOffsets",
  enabled: !0,
  phase: "read",
  fn: popperOffsets,
  data: {}
};
function getAltAxis(C) {
  return C === "x" ? "y" : "x";
}
function preventOverflow(C) {
  var e = C.state, T = C.options, $ = C.name, V = T.mainAxis, J = V === void 0 ? !0 : V, ee = T.altAxis, te = ee === void 0 ? !1 : ee, re = T.boundary, ie = T.rootBoundary, se = T.altBoundary, de = T.padding, ue = T.tether, fe = ue === void 0 ? !0 : ue, he = T.tetherOffset, me = he === void 0 ? 0 : he, xe = detectOverflow(e, {
    boundary: re,
    rootBoundary: ie,
    padding: de,
    altBoundary: se
  }), ve = getBasePlacement(e.placement), Te = getVariation(e.placement), we = !Te, Ee = getMainAxisFromPlacement(ve), Me = getAltAxis(Ee), Ie = e.modifiersData.popperOffsets, ke = e.rects.reference, _e = e.rects.popper, De = typeof me == "function" ? me(Object.assign({}, e.rects, {
    placement: e.placement
  })) : me, Fe = typeof De == "number" ? {
    mainAxis: De,
    altAxis: De
  } : Object.assign({
    mainAxis: 0,
    altAxis: 0
  }, De), Ae = e.modifiersData.offset ? e.modifiersData.offset[e.placement] : null, ne = {
    x: 0,
    y: 0
  };
  if (Ie) {
    if (J) {
      var oe, ce = Ee === "y" ? top : left, le = Ee === "y" ? bottom : right, pe = Ee === "y" ? "height" : "width", ye = Ie[Ee], Ce = ye + xe[ce], be = ye - xe[le], ae = fe ? -_e[pe] / 2 : 0, ge = Te === start ? ke[pe] : _e[pe], Se = Te === start ? -_e[pe] : -ke[pe], Le = e.elements.arrow, ze = fe && Le ? getLayoutRect(Le) : {
        width: 0,
        height: 0
      }, Re = e.modifiersData["arrow#persistent"] ? e.modifiersData["arrow#persistent"].padding : getFreshSideObject(), We = Re[ce], Be = Re[le], Ue = within(0, ke[pe], ze[pe]), Ge = we ? ke[pe] / 2 - ae - Ue - We - Fe.mainAxis : ge - Ue - We - Fe.mainAxis, je = we ? -ke[pe] / 2 + ae + Ue + Be + Fe.mainAxis : Se + Ue + Be + Fe.mainAxis, Oe = e.elements.arrow && getOffsetParent(e.elements.arrow), Ne = Oe ? Ee === "y" ? Oe.clientTop || 0 : Oe.clientLeft || 0 : 0, Ye = (oe = Ae == null ? void 0 : Ae[Ee]) != null ? oe : 0, Je = ye + Ge - Ye - Ne, Xe = ye + je - Ye, st = within(fe ? min(Ce, Je) : Ce, ye, fe ? max(be, Xe) : be);
      Ie[Ee] = st, ne[Ee] = st - ye;
    }
    if (te) {
      var ct, it = Ee === "x" ? top : left, ot = Ee === "x" ? bottom : right, yt = Ie[Me], dt = Me === "y" ? "height" : "width", mt = yt + xe[it], It = yt - xe[ot], xt = [top, left].indexOf(ve) !== -1, Tt = (ct = Ae == null ? void 0 : Ae[Me]) != null ? ct : 0, Yt = xt ? mt : yt - ke[dt] - _e[dt] - Tt + Fe.altAxis, Ve = xt ? yt + ke[dt] + _e[dt] - Tt - Fe.altAxis : It, Pe = fe && xt ? withinMaxClamp(Yt, yt, Ve) : within(fe ? Yt : mt, yt, fe ? Ve : It);
      Ie[Me] = Pe, ne[Me] = Pe - yt;
    }
    e.modifiersData[$] = ne;
  }
}
const preventOverflow$1 = {
  name: "preventOverflow",
  enabled: !0,
  phase: "main",
  fn: preventOverflow,
  requiresIfExists: ["offset"]
};
function getHTMLElementScroll(C) {
  return {
    scrollLeft: C.scrollLeft,
    scrollTop: C.scrollTop
  };
}
function getNodeScroll(C) {
  return C === getWindow(C) || !isHTMLElement$1(C) ? getWindowScroll(C) : getHTMLElementScroll(C);
}
function isElementScaled(C) {
  var e = C.getBoundingClientRect(), T = round$1(e.width) / C.offsetWidth || 1, $ = round$1(e.height) / C.offsetHeight || 1;
  return T !== 1 || $ !== 1;
}
function getCompositeRect(C, e, T) {
  T === void 0 && (T = !1);
  var $ = isHTMLElement$1(e), V = isHTMLElement$1(e) && isElementScaled(e), J = getDocumentElement(e), ee = getBoundingClientRect(C, V, T), te = {
    scrollLeft: 0,
    scrollTop: 0
  }, re = {
    x: 0,
    y: 0
  };
  return ($ || !$ && !T) && ((getNodeName(e) !== "body" || // https://github.com/popperjs/popper-core/issues/1078
  isScrollParent(J)) && (te = getNodeScroll(e)), isHTMLElement$1(e) ? (re = getBoundingClientRect(e, !0), re.x += e.clientLeft, re.y += e.clientTop) : J && (re.x = getWindowScrollBarX(J))), {
    x: ee.left + te.scrollLeft - re.x,
    y: ee.top + te.scrollTop - re.y,
    width: ee.width,
    height: ee.height
  };
}
function order(C) {
  var e = /* @__PURE__ */ new Map(), T = /* @__PURE__ */ new Set(), $ = [];
  C.forEach(function(J) {
    e.set(J.name, J);
  });
  function V(J) {
    T.add(J.name);
    var ee = [].concat(J.requires || [], J.requiresIfExists || []);
    ee.forEach(function(te) {
      if (!T.has(te)) {
        var re = e.get(te);
        re && V(re);
      }
    }), $.push(J);
  }
  return C.forEach(function(J) {
    T.has(J.name) || V(J);
  }), $;
}
function orderModifiers(C) {
  var e = order(C);
  return modifierPhases.reduce(function(T, $) {
    return T.concat(e.filter(function(V) {
      return V.phase === $;
    }));
  }, []);
}
function debounce(C) {
  var e;
  return function() {
    return e || (e = new Promise(function(T) {
      Promise.resolve().then(function() {
        e = void 0, T(C());
      });
    })), e;
  };
}
function mergeByName(C) {
  var e = C.reduce(function(T, $) {
    var V = T[$.name];
    return T[$.name] = V ? Object.assign({}, V, $, {
      options: Object.assign({}, V.options, $.options),
      data: Object.assign({}, V.data, $.data)
    }) : $, T;
  }, {});
  return Object.keys(e).map(function(T) {
    return e[T];
  });
}
var DEFAULT_OPTIONS = {
  placement: "bottom",
  modifiers: [],
  strategy: "absolute"
};
function areValidElements() {
  for (var C = arguments.length, e = new Array(C), T = 0; T < C; T++)
    e[T] = arguments[T];
  return !e.some(function($) {
    return !($ && typeof $.getBoundingClientRect == "function");
  });
}
function popperGenerator(C) {
  C === void 0 && (C = {});
  var e = C, T = e.defaultModifiers, $ = T === void 0 ? [] : T, V = e.defaultOptions, J = V === void 0 ? DEFAULT_OPTIONS : V;
  return function(te, re, ie) {
    ie === void 0 && (ie = J);
    var se = {
      placement: "bottom",
      orderedModifiers: [],
      options: Object.assign({}, DEFAULT_OPTIONS, J),
      modifiersData: {},
      elements: {
        reference: te,
        popper: re
      },
      attributes: {},
      styles: {}
    }, de = [], ue = !1, fe = {
      state: se,
      setOptions: function(ve) {
        var Te = typeof ve == "function" ? ve(se.options) : ve;
        me(), se.options = Object.assign({}, J, se.options, Te), se.scrollParents = {
          reference: isElement(te) ? listScrollParents(te) : te.contextElement ? listScrollParents(te.contextElement) : [],
          popper: listScrollParents(re)
        };
        var we = orderModifiers(mergeByName([].concat($, se.options.modifiers)));
        return se.orderedModifiers = we.filter(function(Ee) {
          return Ee.enabled;
        }), he(), fe.update();
      },
      // Sync update – it will always be executed, even if not necessary. This
      // is useful for low frequency updates where sync behavior simplifies the
      // logic.
      // For high frequency updates (e.g. `resize` and `scroll` events), always
      // prefer the async Popper#update method
      forceUpdate: function() {
        if (!ue) {
          var ve = se.elements, Te = ve.reference, we = ve.popper;
          if (areValidElements(Te, we)) {
            se.rects = {
              reference: getCompositeRect(Te, getOffsetParent(we), se.options.strategy === "fixed"),
              popper: getLayoutRect(we)
            }, se.reset = !1, se.placement = se.options.placement, se.orderedModifiers.forEach(function(Fe) {
              return se.modifiersData[Fe.name] = Object.assign({}, Fe.data);
            });
            for (var Ee = 0; Ee < se.orderedModifiers.length; Ee++) {
              if (se.reset === !0) {
                se.reset = !1, Ee = -1;
                continue;
              }
              var Me = se.orderedModifiers[Ee], Ie = Me.fn, ke = Me.options, _e = ke === void 0 ? {} : ke, De = Me.name;
              typeof Ie == "function" && (se = Ie({
                state: se,
                options: _e,
                name: De,
                instance: fe
              }) || se);
            }
          }
        }
      },
      // Async and optimistically optimized update – it will not be executed if
      // not necessary (debounced to run at most once-per-tick)
      update: debounce(function() {
        return new Promise(function(xe) {
          fe.forceUpdate(), xe(se);
        });
      }),
      destroy: function() {
        me(), ue = !0;
      }
    };
    if (!areValidElements(te, re))
      return fe;
    fe.setOptions(ie).then(function(xe) {
      !ue && ie.onFirstUpdate && ie.onFirstUpdate(xe);
    });
    function he() {
      se.orderedModifiers.forEach(function(xe) {
        var ve = xe.name, Te = xe.options, we = Te === void 0 ? {} : Te, Ee = xe.effect;
        if (typeof Ee == "function") {
          var Me = Ee({
            state: se,
            name: ve,
            instance: fe,
            options: we
          }), Ie = function() {
          };
          de.push(Me || Ie);
        }
      });
    }
    function me() {
      de.forEach(function(xe) {
        return xe();
      }), de = [];
    }
    return fe;
  };
}
var defaultModifiers = [eventListeners, popperOffsets$1, computeStyles$1, applyStyles$1, offset$1, flip$1, preventOverflow$1, arrow$1, hide$1], createPopper = /* @__PURE__ */ popperGenerator({
  defaultModifiers
});
function getContainer$1(C) {
  return typeof C == "function" ? C() : C;
}
const Portal = /* @__PURE__ */ React$1.forwardRef(function(e, T) {
  const {
    children: $,
    container: V,
    disablePortal: J = !1
  } = e, [ee, te] = React$1.useState(null), re = useForkRef(/* @__PURE__ */ React$1.isValidElement($) ? getReactElementRef($) : null, T);
  if (useEnhancedEffect(() => {
    J || te(getContainer$1(V) || document.body);
  }, [V, J]), useEnhancedEffect(() => {
    if (ee && !J)
      return setRef(T, ee), () => {
        setRef(T, null);
      };
  }, [T, ee, J]), J) {
    if (/* @__PURE__ */ React$1.isValidElement($)) {
      const ie = {
        ref: re
      };
      return /* @__PURE__ */ React$1.cloneElement($, ie);
    }
    return /* @__PURE__ */ jsxRuntimeExports.jsx(React$1.Fragment, {
      children: $
    });
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsx(React$1.Fragment, {
    children: ee && /* @__PURE__ */ ReactDOM.createPortal($, ee)
  });
});
dist$2.process.env.NODE_ENV !== "production" && (Portal.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The children to render into the `container`.
   */
  children: PropTypes.node,
  /**
   * An HTML element or function that returns one.
   * The `container` will have the portal children appended to it.
   *
   * You can also provide a callback, which is called in a React layout effect.
   * This lets you set the container from a ref, and also makes server-side rendering possible.
   *
   * By default, it uses the body of the top-level document object,
   * so it's simply `document.body` most of the time.
   */
  container: PropTypes.oneOfType([HTMLElementType, PropTypes.func]),
  /**
   * The `children` will be under the DOM hierarchy of the parent component.
   * @default false
   */
  disablePortal: PropTypes.bool
});
dist$2.process.env.NODE_ENV !== "production" && (Portal.propTypes = exactProp(Portal.propTypes));
function getPopperUtilityClass(C) {
  return generateUtilityClass("MuiPopper", C);
}
generateUtilityClasses("MuiPopper", ["root"]);
const _excluded$K = ["anchorEl", "children", "direction", "disablePortal", "modifiers", "open", "placement", "popperOptions", "popperRef", "slotProps", "slots", "TransitionProps", "ownerState"], _excluded2$5 = ["anchorEl", "children", "container", "direction", "disablePortal", "keepMounted", "modifiers", "open", "placement", "popperOptions", "popperRef", "style", "transition", "slotProps", "slots"];
function flipPlacement(C, e) {
  if (e === "ltr")
    return C;
  switch (C) {
    case "bottom-end":
      return "bottom-start";
    case "bottom-start":
      return "bottom-end";
    case "top-end":
      return "top-start";
    case "top-start":
      return "top-end";
    default:
      return C;
  }
}
function resolveAnchorEl$1(C) {
  return typeof C == "function" ? C() : C;
}
function isHTMLElement(C) {
  return C.nodeType !== void 0;
}
function isVirtualElement(C) {
  return !isHTMLElement(C);
}
const useUtilityClasses$D = (C) => {
  const {
    classes: e
  } = C;
  return composeClasses({
    root: ["root"]
  }, getPopperUtilityClass, e);
}, defaultPopperOptions = {}, PopperTooltip = /* @__PURE__ */ React$1.forwardRef(function(e, T) {
  var $;
  const {
    anchorEl: V,
    children: J,
    direction: ee,
    disablePortal: te,
    modifiers: re,
    open: ie,
    placement: se,
    popperOptions: de,
    popperRef: ue,
    slotProps: fe = {},
    slots: he = {},
    TransitionProps: me
    // @ts-ignore internal logic
    // prevent from spreading to DOM, it can come from the parent component e.g. Select.
  } = e, xe = _objectWithoutPropertiesLoose(e, _excluded$K), ve = React$1.useRef(null), Te = useForkRef(ve, T), we = React$1.useRef(null), Ee = useForkRef(we, ue), Me = React$1.useRef(Ee);
  useEnhancedEffect(() => {
    Me.current = Ee;
  }, [Ee]), React$1.useImperativeHandle(ue, () => we.current, []);
  const Ie = flipPlacement(se, ee), [ke, _e] = React$1.useState(Ie), [De, Fe] = React$1.useState(resolveAnchorEl$1(V));
  React$1.useEffect(() => {
    we.current && we.current.forceUpdate();
  }), React$1.useEffect(() => {
    V && Fe(resolveAnchorEl$1(V));
  }, [V]), useEnhancedEffect(() => {
    if (!De || !ie)
      return;
    const le = (Ce) => {
      _e(Ce.placement);
    };
    if (dist$2.process.env.NODE_ENV !== "production" && De && isHTMLElement(De) && De.nodeType === 1) {
      const Ce = De.getBoundingClientRect();
      dist$2.process.env.NODE_ENV !== "test" && Ce.top === 0 && Ce.left === 0 && Ce.right === 0 && Ce.bottom === 0 && console.warn(["MUI: The `anchorEl` prop provided to the component is invalid.", "The anchor element should be part of the document layout.", "Make sure the element is present in the document or that it's not display none."].join(`
`));
    }
    let pe = [{
      name: "preventOverflow",
      options: {
        altBoundary: te
      }
    }, {
      name: "flip",
      options: {
        altBoundary: te
      }
    }, {
      name: "onUpdate",
      enabled: !0,
      phase: "afterWrite",
      fn: ({
        state: Ce
      }) => {
        le(Ce);
      }
    }];
    re != null && (pe = pe.concat(re)), de && de.modifiers != null && (pe = pe.concat(de.modifiers));
    const ye = createPopper(De, ve.current, _extends({
      placement: Ie
    }, de, {
      modifiers: pe
    }));
    return Me.current(ye), () => {
      ye.destroy(), Me.current(null);
    };
  }, [De, te, re, ie, de, Ie]);
  const Ae = {
    placement: ke
  };
  me !== null && (Ae.TransitionProps = me);
  const ne = useUtilityClasses$D(e), oe = ($ = he.root) != null ? $ : "div", ce = useSlotProps({
    elementType: oe,
    externalSlotProps: fe.root,
    externalForwardedProps: xe,
    additionalProps: {
      role: "tooltip",
      ref: Te
    },
    ownerState: e,
    className: ne.root
  });
  return /* @__PURE__ */ jsxRuntimeExports.jsx(oe, _extends({}, ce, {
    children: typeof J == "function" ? J(Ae) : J
  }));
}), Popper$1 = /* @__PURE__ */ React$1.forwardRef(function(e, T) {
  const {
    anchorEl: $,
    children: V,
    container: J,
    direction: ee = "ltr",
    disablePortal: te = !1,
    keepMounted: re = !1,
    modifiers: ie,
    open: se,
    placement: de = "bottom",
    popperOptions: ue = defaultPopperOptions,
    popperRef: fe,
    style: he,
    transition: me = !1,
    slotProps: xe = {},
    slots: ve = {}
  } = e, Te = _objectWithoutPropertiesLoose(e, _excluded2$5), [we, Ee] = React$1.useState(!0), Me = () => {
    Ee(!1);
  }, Ie = () => {
    Ee(!0);
  };
  if (!re && !se && (!me || we))
    return null;
  let ke;
  if (J)
    ke = J;
  else if ($) {
    const Fe = resolveAnchorEl$1($);
    ke = Fe && isHTMLElement(Fe) ? ownerDocument(Fe).body : ownerDocument(null).body;
  }
  const _e = !se && re && (!me || we) ? "none" : void 0, De = me ? {
    in: se,
    onEnter: Me,
    onExited: Ie
  } : void 0;
  return /* @__PURE__ */ jsxRuntimeExports.jsx(Portal, {
    disablePortal: te,
    container: ke,
    children: /* @__PURE__ */ jsxRuntimeExports.jsx(PopperTooltip, _extends({
      anchorEl: $,
      direction: ee,
      disablePortal: te,
      modifiers: ie,
      ref: T,
      open: me ? !we : se,
      placement: de,
      popperOptions: ue,
      popperRef: fe,
      slotProps: xe,
      slots: ve
    }, Te, {
      style: _extends({
        // Prevents scroll issue, waiting for Popper.js to add this style once initiated.
        position: "fixed",
        // Fix Popper.js display issue
        top: 0,
        left: 0,
        display: _e
      }, he),
      TransitionProps: De,
      children: V
    }))
  });
});
dist$2.process.env.NODE_ENV !== "production" && (Popper$1.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * An HTML element, [virtualElement](https://popper.js.org/docs/v2/virtual-elements/),
   * or a function that returns either.
   * It's used to set the position of the popper.
   * The return value will passed as the reference object of the Popper instance.
   */
  anchorEl: chainPropTypes(PropTypes.oneOfType([HTMLElementType, PropTypes.object, PropTypes.func]), (C) => {
    if (C.open) {
      const e = resolveAnchorEl$1(C.anchorEl);
      if (e && isHTMLElement(e) && e.nodeType === 1) {
        const T = e.getBoundingClientRect();
        if (dist$2.process.env.NODE_ENV !== "test" && T.top === 0 && T.left === 0 && T.right === 0 && T.bottom === 0)
          return new Error(["MUI: The `anchorEl` prop provided to the component is invalid.", "The anchor element should be part of the document layout.", "Make sure the element is present in the document or that it's not display none."].join(`
`));
      } else if (!e || typeof e.getBoundingClientRect != "function" || isVirtualElement(e) && e.contextElement != null && e.contextElement.nodeType !== 1)
        return new Error(["MUI: The `anchorEl` prop provided to the component is invalid.", "It should be an HTML element instance or a virtualElement ", "(https://popper.js.org/docs/v2/virtual-elements/)."].join(`
`));
    }
    return null;
  }),
  /**
   * Popper render function or node.
   */
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.func]),
  /**
   * An HTML element or function that returns one.
   * The `container` will have the portal children appended to it.
   *
   * You can also provide a callback, which is called in a React layout effect.
   * This lets you set the container from a ref, and also makes server-side rendering possible.
   *
   * By default, it uses the body of the top-level document object,
   * so it's simply `document.body` most of the time.
   */
  container: PropTypes.oneOfType([HTMLElementType, PropTypes.func]),
  /**
   * Direction of the text.
   * @default 'ltr'
   */
  direction: PropTypes.oneOf(["ltr", "rtl"]),
  /**
   * The `children` will be under the DOM hierarchy of the parent component.
   * @default false
   */
  disablePortal: PropTypes.bool,
  /**
   * Always keep the children in the DOM.
   * This prop can be useful in SEO situation or
   * when you want to maximize the responsiveness of the Popper.
   * @default false
   */
  keepMounted: PropTypes.bool,
  /**
   * Popper.js is based on a "plugin-like" architecture,
   * most of its features are fully encapsulated "modifiers".
   *
   * A modifier is a function that is called each time Popper.js needs to
   * compute the position of the popper.
   * For this reason, modifiers should be very performant to avoid bottlenecks.
   * To learn how to create a modifier, [read the modifiers documentation](https://popper.js.org/docs/v2/modifiers/).
   */
  modifiers: PropTypes.arrayOf(PropTypes.shape({
    data: PropTypes.object,
    effect: PropTypes.func,
    enabled: PropTypes.bool,
    fn: PropTypes.func,
    name: PropTypes.any,
    options: PropTypes.object,
    phase: PropTypes.oneOf(["afterMain", "afterRead", "afterWrite", "beforeMain", "beforeRead", "beforeWrite", "main", "read", "write"]),
    requires: PropTypes.arrayOf(PropTypes.string),
    requiresIfExists: PropTypes.arrayOf(PropTypes.string)
  })),
  /**
   * If `true`, the component is shown.
   */
  open: PropTypes.bool.isRequired,
  /**
   * Popper placement.
   * @default 'bottom'
   */
  placement: PropTypes.oneOf(["auto-end", "auto-start", "auto", "bottom-end", "bottom-start", "bottom", "left-end", "left-start", "left", "right-end", "right-start", "right", "top-end", "top-start", "top"]),
  /**
   * Options provided to the [`Popper.js`](https://popper.js.org/docs/v2/constructors/#options) instance.
   * @default {}
   */
  popperOptions: PropTypes.shape({
    modifiers: PropTypes.array,
    onFirstUpdate: PropTypes.func,
    placement: PropTypes.oneOf(["auto-end", "auto-start", "auto", "bottom-end", "bottom-start", "bottom", "left-end", "left-start", "left", "right-end", "right-start", "right", "top-end", "top-start", "top"]),
    strategy: PropTypes.oneOf(["absolute", "fixed"])
  }),
  /**
   * A ref that points to the used popper instance.
   */
  popperRef: refType,
  /**
   * The props used for each slot inside the Popper.
   * @default {}
   */
  slotProps: PropTypes.shape({
    root: PropTypes.oneOfType([PropTypes.func, PropTypes.object])
  }),
  /**
   * The components used for each slot inside the Popper.
   * Either a string to use a HTML element or a component.
   * @default {}
   */
  slots: PropTypes.shape({
    root: PropTypes.elementType
  }),
  /**
   * Help supporting a react-transition-group/Transition component.
   * @default false
   */
  transition: PropTypes.bool
});
const _excluded$J = ["anchorEl", "component", "components", "componentsProps", "container", "disablePortal", "keepMounted", "modifiers", "open", "placement", "popperOptions", "popperRef", "transition", "slots", "slotProps"], PopperRoot = styled$1(Popper$1, {
  name: "MuiPopper",
  slot: "Root",
  overridesResolver: (C, e) => e.root
})({}), Popper = /* @__PURE__ */ React$1.forwardRef(function(e, T) {
  var $;
  const V = default_1$c(), J = useDefaultProps({
    props: e,
    name: "MuiPopper"
  }), {
    anchorEl: ee,
    component: te,
    components: re,
    componentsProps: ie,
    container: se,
    disablePortal: de,
    keepMounted: ue,
    modifiers: fe,
    open: he,
    placement: me,
    popperOptions: xe,
    popperRef: ve,
    transition: Te,
    slots: we,
    slotProps: Ee
  } = J, Me = _objectWithoutPropertiesLoose(J, _excluded$J), Ie = ($ = we == null ? void 0 : we.root) != null ? $ : re == null ? void 0 : re.Root, ke = _extends({
    anchorEl: ee,
    container: se,
    disablePortal: de,
    keepMounted: ue,
    modifiers: fe,
    open: he,
    placement: me,
    popperOptions: xe,
    popperRef: ve,
    transition: Te
  }, Me);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(PopperRoot, _extends({
    as: te,
    direction: V == null ? void 0 : V.direction,
    slots: {
      root: Ie
    },
    slotProps: Ee ?? ie
  }, ke, {
    ref: T
  }));
});
dist$2.process.env.NODE_ENV !== "production" && (Popper.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * An HTML element, [virtualElement](https://popper.js.org/docs/v2/virtual-elements/),
   * or a function that returns either.
   * It's used to set the position of the popper.
   * The return value will passed as the reference object of the Popper instance.
   */
  anchorEl: PropTypes.oneOfType([HTMLElementType, PropTypes.object, PropTypes.func]),
  /**
   * Popper render function or node.
   */
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.func]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes.elementType,
  /**
   * The components used for each slot inside the Popper.
   * Either a string to use a HTML element or a component.
   * @default {}
   */
  components: PropTypes.shape({
    Root: PropTypes.elementType
  }),
  /**
   * The props used for each slot inside the Popper.
   * @default {}
   */
  componentsProps: PropTypes.shape({
    root: PropTypes.oneOfType([PropTypes.func, PropTypes.object])
  }),
  /**
   * An HTML element or function that returns one.
   * The `container` will have the portal children appended to it.
   *
   * You can also provide a callback, which is called in a React layout effect.
   * This lets you set the container from a ref, and also makes server-side rendering possible.
   *
   * By default, it uses the body of the top-level document object,
   * so it's simply `document.body` most of the time.
   */
  container: PropTypes.oneOfType([HTMLElementType, PropTypes.func]),
  /**
   * The `children` will be under the DOM hierarchy of the parent component.
   * @default false
   */
  disablePortal: PropTypes.bool,
  /**
   * Always keep the children in the DOM.
   * This prop can be useful in SEO situation or
   * when you want to maximize the responsiveness of the Popper.
   * @default false
   */
  keepMounted: PropTypes.bool,
  /**
   * Popper.js is based on a "plugin-like" architecture,
   * most of its features are fully encapsulated "modifiers".
   *
   * A modifier is a function that is called each time Popper.js needs to
   * compute the position of the popper.
   * For this reason, modifiers should be very performant to avoid bottlenecks.
   * To learn how to create a modifier, [read the modifiers documentation](https://popper.js.org/docs/v2/modifiers/).
   */
  modifiers: PropTypes.arrayOf(PropTypes.shape({
    data: PropTypes.object,
    effect: PropTypes.func,
    enabled: PropTypes.bool,
    fn: PropTypes.func,
    name: PropTypes.any,
    options: PropTypes.object,
    phase: PropTypes.oneOf(["afterMain", "afterRead", "afterWrite", "beforeMain", "beforeRead", "beforeWrite", "main", "read", "write"]),
    requires: PropTypes.arrayOf(PropTypes.string),
    requiresIfExists: PropTypes.arrayOf(PropTypes.string)
  })),
  /**
   * If `true`, the component is shown.
   */
  open: PropTypes.bool.isRequired,
  /**
   * Popper placement.
   * @default 'bottom'
   */
  placement: PropTypes.oneOf(["auto-end", "auto-start", "auto", "bottom-end", "bottom-start", "bottom", "left-end", "left-start", "left", "right-end", "right-start", "right", "top-end", "top-start", "top"]),
  /**
   * Options provided to the [`Popper.js`](https://popper.js.org/docs/v2/constructors/#options) instance.
   * @default {}
   */
  popperOptions: PropTypes.shape({
    modifiers: PropTypes.array,
    onFirstUpdate: PropTypes.func,
    placement: PropTypes.oneOf(["auto-end", "auto-start", "auto", "bottom-end", "bottom-start", "bottom", "left-end", "left-start", "left", "right-end", "right-start", "right", "top-end", "top-start", "top"]),
    strategy: PropTypes.oneOf(["absolute", "fixed"])
  }),
  /**
   * A ref that points to the used popper instance.
   */
  popperRef: refType,
  /**
   * The props used for each slot inside the Popper.
   * @default {}
   */
  slotProps: PropTypes.shape({
    root: PropTypes.oneOfType([PropTypes.func, PropTypes.object])
  }),
  /**
   * The components used for each slot inside the Popper.
   * Either a string to use a HTML element or a component.
   * @default {}
   */
  slots: PropTypes.shape({
    root: PropTypes.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * Help supporting a react-transition-group/Transition component.
   * @default false
   */
  transition: PropTypes.bool
});
const _excluded$I = ["onChange", "maxRows", "minRows", "style", "value"];
function getStyleValue(C) {
  return parseInt(C, 10) || 0;
}
const styles$2 = {
  shadow: {
    // Visibility needed to hide the extra text area on iPads
    visibility: "hidden",
    // Remove from the content flow
    position: "absolute",
    // Ignore the scrollbar width
    overflow: "hidden",
    height: 0,
    top: 0,
    left: 0,
    // Create a new layer, increase the isolation of the computed values
    transform: "translateZ(0)"
  }
};
function isEmpty$1(C) {
  return C == null || Object.keys(C).length === 0 || C.outerHeightStyle === 0 && !C.overflowing;
}
const TextareaAutosize = /* @__PURE__ */ React$1.forwardRef(function(e, T) {
  const {
    onChange: $,
    maxRows: V,
    minRows: J = 1,
    style: ee,
    value: te
  } = e, re = _objectWithoutPropertiesLoose(e, _excluded$I), {
    current: ie
  } = React$1.useRef(te != null), se = React$1.useRef(null), de = useForkRef(T, se), ue = React$1.useRef(null), fe = React$1.useRef(null), he = React$1.useCallback(() => {
    const ve = se.current, we = ownerWindow(ve).getComputedStyle(ve);
    if (we.width === "0px")
      return {
        outerHeightStyle: 0,
        overflowing: !1
      };
    const Ee = fe.current;
    Ee.style.width = we.width, Ee.value = ve.value || e.placeholder || "x", Ee.value.slice(-1) === `
` && (Ee.value += " ");
    const Me = we.boxSizing, Ie = getStyleValue(we.paddingBottom) + getStyleValue(we.paddingTop), ke = getStyleValue(we.borderBottomWidth) + getStyleValue(we.borderTopWidth), _e = Ee.scrollHeight;
    Ee.value = "x";
    const De = Ee.scrollHeight;
    let Fe = _e;
    J && (Fe = Math.max(Number(J) * De, Fe)), V && (Fe = Math.min(Number(V) * De, Fe)), Fe = Math.max(Fe, De);
    const Ae = Fe + (Me === "border-box" ? Ie + ke : 0), ne = Math.abs(Fe - _e) <= 1;
    return {
      outerHeightStyle: Ae,
      overflowing: ne
    };
  }, [V, J, e.placeholder]), me = React$1.useCallback(() => {
    const ve = he();
    if (isEmpty$1(ve))
      return;
    const Te = ve.outerHeightStyle, we = se.current;
    ue.current !== Te && (ue.current = Te, we.style.height = `${Te}px`), we.style.overflow = ve.overflowing ? "hidden" : "";
  }, [he]);
  useEnhancedEffect(() => {
    const ve = () => {
      me();
    };
    let Te;
    const we = () => {
      cancelAnimationFrame(Te), Te = requestAnimationFrame(() => {
        ve();
      });
    }, Ee = debounce$1(ve), Me = se.current, Ie = ownerWindow(Me);
    Ie.addEventListener("resize", Ee);
    let ke;
    return typeof ResizeObserver < "u" && (ke = new ResizeObserver(dist$2.process.env.NODE_ENV === "test" ? we : ve), ke.observe(Me)), () => {
      Ee.clear(), cancelAnimationFrame(Te), Ie.removeEventListener("resize", Ee), ke && ke.disconnect();
    };
  }, [he, me]), useEnhancedEffect(() => {
    me();
  });
  const xe = (ve) => {
    ie || me(), $ && $(ve);
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(React$1.Fragment, {
    children: [/* @__PURE__ */ jsxRuntimeExports.jsx("textarea", _extends({
      value: te,
      onChange: xe,
      ref: de,
      rows: J,
      style: ee
    }, re)), /* @__PURE__ */ jsxRuntimeExports.jsx("textarea", {
      "aria-hidden": !0,
      className: e.className,
      readOnly: !0,
      ref: fe,
      tabIndex: -1,
      style: _extends({}, styles$2.shadow, ee, {
        paddingTop: 0,
        paddingBottom: 0
      })
    })]
  });
});
dist$2.process.env.NODE_ENV !== "production" && (TextareaAutosize.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * Maximum number of rows to display.
   */
  maxRows: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  /**
   * Minimum number of rows to display.
   * @default 1
   */
  minRows: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  /**
   * @ignore
   */
  onChange: PropTypes.func,
  /**
   * @ignore
   */
  placeholder: PropTypes.string,
  /**
   * @ignore
   */
  style: PropTypes.object,
  /**
   * @ignore
   */
  value: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.string), PropTypes.number, PropTypes.string])
});
function formControlState({
  props: C,
  states: e,
  muiFormControl: T
}) {
  return e.reduce(($, V) => ($[V] = C[V], T && typeof C[V] > "u" && ($[V] = T[V]), $), {});
}
const FormControlContext = /* @__PURE__ */ React$1.createContext(void 0);
dist$2.process.env.NODE_ENV !== "production" && (FormControlContext.displayName = "FormControlContext");
function useFormControl() {
  return React$1.useContext(FormControlContext);
}
function hasValue(C) {
  return C != null && !(Array.isArray(C) && C.length === 0);
}
function isFilled(C, e = !1) {
  return C && (hasValue(C.value) && C.value !== "" || e && hasValue(C.defaultValue) && C.defaultValue !== "");
}
function isAdornedStart(C) {
  return C.startAdornment;
}
function getInputBaseUtilityClass(C) {
  return generateUtilityClass("MuiInputBase", C);
}
const inputBaseClasses = generateUtilityClasses("MuiInputBase", ["root", "formControl", "focused", "disabled", "adornedStart", "adornedEnd", "error", "sizeSmall", "multiline", "colorSecondary", "fullWidth", "hiddenLabel", "readOnly", "input", "inputSizeSmall", "inputMultiline", "inputTypeSearch", "inputAdornedStart", "inputAdornedEnd", "inputHiddenLabel"]), _excluded$H = ["aria-describedby", "autoComplete", "autoFocus", "className", "color", "components", "componentsProps", "defaultValue", "disabled", "disableInjectingGlobalStyles", "endAdornment", "error", "fullWidth", "id", "inputComponent", "inputProps", "inputRef", "margin", "maxRows", "minRows", "multiline", "name", "onBlur", "onChange", "onClick", "onFocus", "onKeyDown", "onKeyUp", "placeholder", "readOnly", "renderSuffix", "rows", "size", "slotProps", "slots", "startAdornment", "type", "value"], rootOverridesResolver = (C, e) => {
  const {
    ownerState: T
  } = C;
  return [e.root, T.formControl && e.formControl, T.startAdornment && e.adornedStart, T.endAdornment && e.adornedEnd, T.error && e.error, T.size === "small" && e.sizeSmall, T.multiline && e.multiline, T.color && e[`color${capitalize$3(T.color)}`], T.fullWidth && e.fullWidth, T.hiddenLabel && e.hiddenLabel];
}, inputOverridesResolver = (C, e) => {
  const {
    ownerState: T
  } = C;
  return [e.input, T.size === "small" && e.inputSizeSmall, T.multiline && e.inputMultiline, T.type === "search" && e.inputTypeSearch, T.startAdornment && e.inputAdornedStart, T.endAdornment && e.inputAdornedEnd, T.hiddenLabel && e.inputHiddenLabel];
}, useUtilityClasses$C = (C) => {
  const {
    classes: e,
    color: T,
    disabled: $,
    error: V,
    endAdornment: J,
    focused: ee,
    formControl: te,
    fullWidth: re,
    hiddenLabel: ie,
    multiline: se,
    readOnly: de,
    size: ue,
    startAdornment: fe,
    type: he
  } = C, me = {
    root: ["root", `color${capitalize$3(T)}`, $ && "disabled", V && "error", re && "fullWidth", ee && "focused", te && "formControl", ue && ue !== "medium" && `size${capitalize$3(ue)}`, se && "multiline", fe && "adornedStart", J && "adornedEnd", ie && "hiddenLabel", de && "readOnly"],
    input: ["input", $ && "disabled", he === "search" && "inputTypeSearch", se && "inputMultiline", ue === "small" && "inputSizeSmall", ie && "inputHiddenLabel", fe && "inputAdornedStart", J && "inputAdornedEnd", de && "readOnly"]
  };
  return composeClasses(me, getInputBaseUtilityClass, e);
}, InputBaseRoot = styled$1("div", {
  name: "MuiInputBase",
  slot: "Root",
  overridesResolver: rootOverridesResolver
})(({
  theme: C,
  ownerState: e
}) => _extends({}, C.typography.body1, {
  color: (C.vars || C).palette.text.primary,
  lineHeight: "1.4375em",
  // 23px
  boxSizing: "border-box",
  // Prevent padding issue with fullWidth.
  position: "relative",
  cursor: "text",
  display: "inline-flex",
  alignItems: "center",
  [`&.${inputBaseClasses.disabled}`]: {
    color: (C.vars || C).palette.text.disabled,
    cursor: "default"
  }
}, e.multiline && _extends({
  padding: "4px 0 5px"
}, e.size === "small" && {
  paddingTop: 1
}), e.fullWidth && {
  width: "100%"
})), InputBaseComponent = styled$1("input", {
  name: "MuiInputBase",
  slot: "Input",
  overridesResolver: inputOverridesResolver
})(({
  theme: C,
  ownerState: e
}) => {
  const T = C.palette.mode === "light", $ = _extends({
    color: "currentColor"
  }, C.vars ? {
    opacity: C.vars.opacity.inputPlaceholder
  } : {
    opacity: T ? 0.42 : 0.5
  }, {
    transition: C.transitions.create("opacity", {
      duration: C.transitions.duration.shorter
    })
  }), V = {
    opacity: "0 !important"
  }, J = C.vars ? {
    opacity: C.vars.opacity.inputPlaceholder
  } : {
    opacity: T ? 0.42 : 0.5
  };
  return _extends({
    font: "inherit",
    letterSpacing: "inherit",
    color: "currentColor",
    padding: "4px 0 5px",
    border: 0,
    boxSizing: "content-box",
    background: "none",
    height: "1.4375em",
    // Reset 23pxthe native input line-height
    margin: 0,
    // Reset for Safari
    WebkitTapHighlightColor: "transparent",
    display: "block",
    // Make the flex item shrink with Firefox
    minWidth: 0,
    width: "100%",
    // Fix IE11 width issue
    animationName: "mui-auto-fill-cancel",
    animationDuration: "10ms",
    "&::-webkit-input-placeholder": $,
    "&::-moz-placeholder": $,
    // Firefox 19+
    "&:-ms-input-placeholder": $,
    // IE11
    "&::-ms-input-placeholder": $,
    // Edge
    "&:focus": {
      outline: 0
    },
    // Reset Firefox invalid required input style
    "&:invalid": {
      boxShadow: "none"
    },
    "&::-webkit-search-decoration": {
      // Remove the padding when type=search.
      WebkitAppearance: "none"
    },
    // Show and hide the placeholder logic
    [`label[data-shrink=false] + .${inputBaseClasses.formControl} &`]: {
      "&::-webkit-input-placeholder": V,
      "&::-moz-placeholder": V,
      // Firefox 19+
      "&:-ms-input-placeholder": V,
      // IE11
      "&::-ms-input-placeholder": V,
      // Edge
      "&:focus::-webkit-input-placeholder": J,
      "&:focus::-moz-placeholder": J,
      // Firefox 19+
      "&:focus:-ms-input-placeholder": J,
      // IE11
      "&:focus::-ms-input-placeholder": J
      // Edge
    },
    [`&.${inputBaseClasses.disabled}`]: {
      opacity: 1,
      // Reset iOS opacity
      WebkitTextFillColor: (C.vars || C).palette.text.disabled
      // Fix opacity Safari bug
    },
    "&:-webkit-autofill": {
      animationDuration: "5000s",
      animationName: "mui-auto-fill"
    }
  }, e.size === "small" && {
    paddingTop: 1
  }, e.multiline && {
    height: "auto",
    resize: "none",
    padding: 0,
    paddingTop: 0
  }, e.type === "search" && {
    // Improve type search style.
    MozAppearance: "textfield"
  });
}), inputGlobalStyles = /* @__PURE__ */ jsxRuntimeExports.jsx(GlobalStyles, {
  styles: {
    "@keyframes mui-auto-fill": {
      from: {
        display: "block"
      }
    },
    "@keyframes mui-auto-fill-cancel": {
      from: {
        display: "block"
      }
    }
  }
}), InputBase = /* @__PURE__ */ React$1.forwardRef(function(e, T) {
  var $;
  const V = useDefaultProps({
    props: e,
    name: "MuiInputBase"
  }), {
    "aria-describedby": J,
    autoComplete: ee,
    autoFocus: te,
    className: re,
    components: ie = {},
    componentsProps: se = {},
    defaultValue: de,
    disabled: ue,
    disableInjectingGlobalStyles: fe,
    endAdornment: he,
    fullWidth: me = !1,
    id: xe,
    inputComponent: ve = "input",
    inputProps: Te = {},
    inputRef: we,
    maxRows: Ee,
    minRows: Me,
    multiline: Ie = !1,
    name: ke,
    onBlur: _e,
    onChange: De,
    onClick: Fe,
    onFocus: Ae,
    onKeyDown: ne,
    onKeyUp: oe,
    placeholder: ce,
    readOnly: le,
    renderSuffix: pe,
    rows: ye,
    slotProps: Ce = {},
    slots: be = {},
    startAdornment: ae,
    type: ge = "text",
    value: Se
  } = V, Le = _objectWithoutPropertiesLoose(V, _excluded$H), ze = Te.value != null ? Te.value : Se, {
    current: Re
  } = React$1.useRef(ze != null), We = React$1.useRef(), Be = React$1.useCallback((Pe) => {
    dist$2.process.env.NODE_ENV !== "production" && Pe && Pe.nodeName !== "INPUT" && !Pe.focus && console.error(["MUI: You have provided a `inputComponent` to the input component", "that does not correctly handle the `ref` prop.", "Make sure the `ref` prop is called with a HTMLInputElement."].join(`
`));
  }, []), Ue = useForkRef(We, we, Te.ref, Be), [Ge, je] = React$1.useState(!1), Oe = useFormControl();
  dist$2.process.env.NODE_ENV !== "production" && React$1.useEffect(() => {
    if (Oe)
      return Oe.registerEffect();
  }, [Oe]);
  const Ne = formControlState({
    props: V,
    muiFormControl: Oe,
    states: ["color", "disabled", "error", "hiddenLabel", "size", "required", "filled"]
  });
  Ne.focused = Oe ? Oe.focused : Ge, React$1.useEffect(() => {
    !Oe && ue && Ge && (je(!1), _e && _e());
  }, [Oe, ue, Ge, _e]);
  const Ye = Oe && Oe.onFilled, Je = Oe && Oe.onEmpty, Xe = React$1.useCallback((Pe) => {
    isFilled(Pe) ? Ye && Ye() : Je && Je();
  }, [Ye, Je]);
  useEnhancedEffect(() => {
    Re && Xe({
      value: ze
    });
  }, [ze, Xe, Re]);
  const st = (Pe) => {
    if (Ne.disabled) {
      Pe.stopPropagation();
      return;
    }
    Ae && Ae(Pe), Te.onFocus && Te.onFocus(Pe), Oe && Oe.onFocus ? Oe.onFocus(Pe) : je(!0);
  }, ct = (Pe) => {
    _e && _e(Pe), Te.onBlur && Te.onBlur(Pe), Oe && Oe.onBlur ? Oe.onBlur(Pe) : je(!1);
  }, it = (Pe, ...$e) => {
    if (!Re) {
      const Ze = Pe.target || We.current;
      if (Ze == null)
        throw new Error(dist$2.process.env.NODE_ENV !== "production" ? "MUI: Expected valid input target. Did you use a custom `inputComponent` and forget to forward refs? See https://mui.com/r/input-component-ref-interface for more info." : formatMuiErrorMessage$1(1));
      Xe({
        value: Ze.value
      });
    }
    Te.onChange && Te.onChange(Pe, ...$e), De && De(Pe, ...$e);
  };
  React$1.useEffect(() => {
    Xe(We.current);
  }, []);
  const ot = (Pe) => {
    We.current && Pe.currentTarget === Pe.target && We.current.focus(), Fe && Fe(Pe);
  };
  let yt = ve, dt = Te;
  Ie && yt === "input" && (ye ? (dist$2.process.env.NODE_ENV !== "production" && (Me || Ee) && console.warn("MUI: You can not use the `minRows` or `maxRows` props when the input `rows` prop is set."), dt = _extends({
    type: void 0,
    minRows: ye,
    maxRows: ye
  }, dt)) : dt = _extends({
    type: void 0,
    maxRows: Ee,
    minRows: Me
  }, dt), yt = TextareaAutosize);
  const mt = (Pe) => {
    Xe(Pe.animationName === "mui-auto-fill-cancel" ? We.current : {
      value: "x"
    });
  };
  React$1.useEffect(() => {
    Oe && Oe.setAdornedStart(!!ae);
  }, [Oe, ae]);
  const It = _extends({}, V, {
    color: Ne.color || "primary",
    disabled: Ne.disabled,
    endAdornment: he,
    error: Ne.error,
    focused: Ne.focused,
    formControl: Oe,
    fullWidth: me,
    hiddenLabel: Ne.hiddenLabel,
    multiline: Ie,
    size: Ne.size,
    startAdornment: ae,
    type: ge
  }), xt = useUtilityClasses$C(It), Tt = be.root || ie.Root || InputBaseRoot, Yt = Ce.root || se.root || {}, Ve = be.input || ie.Input || InputBaseComponent;
  return dt = _extends({}, dt, ($ = Ce.input) != null ? $ : se.input), /* @__PURE__ */ jsxRuntimeExports.jsxs(React$1.Fragment, {
    children: [!fe && inputGlobalStyles, /* @__PURE__ */ jsxRuntimeExports.jsxs(Tt, _extends({}, Yt, !isHostComponent(Tt) && {
      ownerState: _extends({}, It, Yt.ownerState)
    }, {
      ref: T,
      onClick: ot
    }, Le, {
      className: clsx(xt.root, Yt.className, re, le && "MuiInputBase-readOnly"),
      children: [ae, /* @__PURE__ */ jsxRuntimeExports.jsx(FormControlContext.Provider, {
        value: null,
        children: /* @__PURE__ */ jsxRuntimeExports.jsx(Ve, _extends({
          ownerState: It,
          "aria-invalid": Ne.error,
          "aria-describedby": J,
          autoComplete: ee,
          autoFocus: te,
          defaultValue: de,
          disabled: Ne.disabled,
          id: xe,
          onAnimationStart: mt,
          name: ke,
          placeholder: ce,
          readOnly: le,
          required: Ne.required,
          rows: ye,
          value: ze,
          onKeyDown: ne,
          onKeyUp: oe,
          type: ge
        }, dt, !isHostComponent(Ve) && {
          as: yt,
          ownerState: _extends({}, It, dt.ownerState)
        }, {
          ref: Ue,
          className: clsx(xt.input, dt.className, le && "MuiInputBase-readOnly"),
          onBlur: ct,
          onChange: it,
          onFocus: st
        }))
      }), he, pe ? pe(_extends({}, Ne, {
        startAdornment: ae
      })) : null]
    }))]
  });
});
dist$2.process.env.NODE_ENV !== "production" && (InputBase.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * @ignore
   */
  "aria-describedby": PropTypes.string,
  /**
   * This prop helps users to fill forms faster, especially on mobile devices.
   * The name can be confusing, as it's more like an autofill.
   * You can learn more about it [following the specification](https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#autofill).
   */
  autoComplete: PropTypes.string,
  /**
   * If `true`, the `input` element is focused during the first mount.
   */
  autoFocus: PropTypes.bool,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * The prop defaults to the value (`'primary'`) inherited from the parent FormControl component.
   */
  color: PropTypes.oneOfType([PropTypes.oneOf(["primary", "secondary", "error", "info", "success", "warning"]), PropTypes.string]),
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `slots` prop.
   * It's recommended to use the `slots` prop instead.
   *
   * @default {}
   */
  components: PropTypes.shape({
    Input: PropTypes.elementType,
    Root: PropTypes.elementType
  }),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * This prop is an alias for the `slotProps` prop.
   * It's recommended to use the `slotProps` prop instead, as `componentsProps` will be deprecated in the future.
   *
   * @default {}
   */
  componentsProps: PropTypes.shape({
    input: PropTypes.object,
    root: PropTypes.object
  }),
  /**
   * The default value. Use when the component is not controlled.
   */
  defaultValue: PropTypes.any,
  /**
   * If `true`, the component is disabled.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  disabled: PropTypes.bool,
  /**
   * If `true`, GlobalStyles for the auto-fill keyframes will not be injected/removed on mount/unmount. Make sure to inject them at the top of your application.
   * This option is intended to help with boosting the initial rendering performance if you are loading a big amount of Input components at once.
   * @default false
   */
  disableInjectingGlobalStyles: PropTypes.bool,
  /**
   * End `InputAdornment` for this component.
   */
  endAdornment: PropTypes.node,
  /**
   * If `true`, the `input` will indicate an error.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  error: PropTypes.bool,
  /**
   * If `true`, the `input` will take up the full width of its container.
   * @default false
   */
  fullWidth: PropTypes.bool,
  /**
   * The id of the `input` element.
   */
  id: PropTypes.string,
  /**
   * The component used for the `input` element.
   * Either a string to use a HTML element or a component.
   * @default 'input'
   */
  inputComponent: elementTypeAcceptingRef$1,
  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   * @default {}
   */
  inputProps: PropTypes.object,
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: refType,
  /**
   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
   * FormControl.
   * The prop defaults to the value (`'none'`) inherited from the parent FormControl component.
   */
  margin: PropTypes.oneOf(["dense", "none"]),
  /**
   * Maximum number of rows to display when multiline option is set to true.
   */
  maxRows: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  /**
   * Minimum number of rows to display when multiline option is set to true.
   */
  minRows: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  /**
   * If `true`, a [TextareaAutosize](/material-ui/react-textarea-autosize/) element is rendered.
   * @default false
   */
  multiline: PropTypes.bool,
  /**
   * Name attribute of the `input` element.
   */
  name: PropTypes.string,
  /**
   * Callback fired when the `input` is blurred.
   *
   * Notice that the first argument (event) might be undefined.
   */
  onBlur: PropTypes.func,
  /**
   * Callback fired when the value is changed.
   *
   * @param {React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   */
  onChange: PropTypes.func,
  /**
   * @ignore
   */
  onClick: PropTypes.func,
  /**
   * @ignore
   */
  onFocus: PropTypes.func,
  /**
   * Callback fired when the `input` doesn't satisfy its constraints.
   */
  onInvalid: PropTypes.func,
  /**
   * @ignore
   */
  onKeyDown: PropTypes.func,
  /**
   * @ignore
   */
  onKeyUp: PropTypes.func,
  /**
   * The short hint displayed in the `input` before the user enters a value.
   */
  placeholder: PropTypes.string,
  /**
   * It prevents the user from changing the value of the field
   * (not from interacting with the field).
   */
  readOnly: PropTypes.bool,
  /**
   * @ignore
   */
  renderSuffix: PropTypes.func,
  /**
   * If `true`, the `input` element is required.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  required: PropTypes.bool,
  /**
   * Number of rows to display when multiline option is set to true.
   */
  rows: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  /**
   * The size of the component.
   */
  size: PropTypes.oneOfType([PropTypes.oneOf(["medium", "small"]), PropTypes.string]),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * This prop is an alias for the `componentsProps` prop, which will be deprecated in the future.
   *
   * @default {}
   */
  slotProps: PropTypes.shape({
    input: PropTypes.object,
    root: PropTypes.object
  }),
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `components` prop, which will be deprecated in the future.
   *
   * @default {}
   */
  slots: PropTypes.shape({
    input: PropTypes.elementType,
    root: PropTypes.elementType
  }),
  /**
   * Start `InputAdornment` for this component.
   */
  startAdornment: PropTypes.node,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * Type of the `input` element. It should be [a valid HTML5 input type](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Form_%3Cinput%3E_types).
   * @default 'text'
   */
  type: PropTypes.string,
  /**
   * The value of the `input` element, required for a controlled component.
   */
  value: PropTypes.any
});
function getInputUtilityClass(C) {
  return generateUtilityClass("MuiInput", C);
}
const inputClasses = _extends({}, inputBaseClasses, generateUtilityClasses("MuiInput", ["root", "underline", "input"]));
function getOutlinedInputUtilityClass(C) {
  return generateUtilityClass("MuiOutlinedInput", C);
}
const outlinedInputClasses = _extends({}, inputBaseClasses, generateUtilityClasses("MuiOutlinedInput", ["root", "notchedOutline", "input"]));
function getFilledInputUtilityClass(C) {
  return generateUtilityClass("MuiFilledInput", C);
}
const filledInputClasses = _extends({}, inputBaseClasses, generateUtilityClasses("MuiFilledInput", ["root", "underline", "input"])), ArrowDropDownIcon = createSvgIcon$1(/* @__PURE__ */ jsxRuntimeExports.jsx("path", {
  d: "M7 10l5 5 5-5z"
}), "ArrowDropDown"), _excluded$G = ["addEndListener", "appear", "children", "easing", "in", "onEnter", "onEntered", "onEntering", "onExit", "onExited", "onExiting", "style", "timeout", "TransitionComponent"], styles$1 = {
  entering: {
    opacity: 1
  },
  entered: {
    opacity: 1
  }
}, Fade = /* @__PURE__ */ React$1.forwardRef(function(e, T) {
  const $ = useTheme$1(), V = {
    enter: $.transitions.duration.enteringScreen,
    exit: $.transitions.duration.leavingScreen
  }, {
    addEndListener: J,
    appear: ee = !0,
    children: te,
    easing: re,
    in: ie,
    onEnter: se,
    onEntered: de,
    onEntering: ue,
    onExit: fe,
    onExited: he,
    onExiting: me,
    style: xe,
    timeout: ve = V,
    // eslint-disable-next-line react/prop-types
    TransitionComponent: Te = Transition
  } = e, we = _objectWithoutPropertiesLoose(e, _excluded$G), Ee = React$1.useRef(null), Me = useForkRef(Ee, getReactElementRef(te), T), Ie = (ce) => (le) => {
    if (ce) {
      const pe = Ee.current;
      le === void 0 ? ce(pe) : ce(pe, le);
    }
  }, ke = Ie(ue), _e = Ie((ce, le) => {
    reflow(ce);
    const pe = getTransitionProps({
      style: xe,
      timeout: ve,
      easing: re
    }, {
      mode: "enter"
    });
    ce.style.webkitTransition = $.transitions.create("opacity", pe), ce.style.transition = $.transitions.create("opacity", pe), se && se(ce, le);
  }), De = Ie(de), Fe = Ie(me), Ae = Ie((ce) => {
    const le = getTransitionProps({
      style: xe,
      timeout: ve,
      easing: re
    }, {
      mode: "exit"
    });
    ce.style.webkitTransition = $.transitions.create("opacity", le), ce.style.transition = $.transitions.create("opacity", le), fe && fe(ce);
  }), ne = Ie(he), oe = (ce) => {
    J && J(Ee.current, ce);
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsx(Te, _extends({
    appear: ee,
    in: ie,
    nodeRef: Ee,
    onEnter: _e,
    onEntered: De,
    onEntering: ke,
    onExit: Ae,
    onExited: ne,
    onExiting: Fe,
    addEndListener: oe,
    timeout: ve
  }, we, {
    children: (ce, le) => /* @__PURE__ */ React$1.cloneElement(te, _extends({
      style: _extends({
        opacity: 0,
        visibility: ce === "exited" && !ie ? "hidden" : void 0
      }, styles$1[ce], xe, te.props.style),
      ref: Me
    }, le))
  }));
});
dist$2.process.env.NODE_ENV !== "production" && (Fade.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Add a custom transition end trigger. Called with the transitioning DOM
   * node and a done callback. Allows for more fine grained transition end
   * logic. Note: Timeouts are still used as a fallback if provided.
   */
  addEndListener: PropTypes.func,
  /**
   * Perform the enter transition when it first mounts if `in` is also `true`.
   * Set this to `false` to disable this behavior.
   * @default true
   */
  appear: PropTypes.bool,
  /**
   * A single child content element.
   */
  children: elementAcceptingRef.isRequired,
  /**
   * The transition timing function.
   * You may specify a single easing or a object containing enter and exit values.
   */
  easing: PropTypes.oneOfType([PropTypes.shape({
    enter: PropTypes.string,
    exit: PropTypes.string
  }), PropTypes.string]),
  /**
   * If `true`, the component will transition in.
   */
  in: PropTypes.bool,
  /**
   * @ignore
   */
  onEnter: PropTypes.func,
  /**
   * @ignore
   */
  onEntered: PropTypes.func,
  /**
   * @ignore
   */
  onEntering: PropTypes.func,
  /**
   * @ignore
   */
  onExit: PropTypes.func,
  /**
   * @ignore
   */
  onExited: PropTypes.func,
  /**
   * @ignore
   */
  onExiting: PropTypes.func,
  /**
   * @ignore
   */
  style: PropTypes.object,
  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   * @default {
   *   enter: theme.transitions.duration.enteringScreen,
   *   exit: theme.transitions.duration.leavingScreen,
   * }
   */
  timeout: PropTypes.oneOfType([PropTypes.number, PropTypes.shape({
    appear: PropTypes.number,
    enter: PropTypes.number,
    exit: PropTypes.number
  })])
});
function getBackdropUtilityClass(C) {
  return generateUtilityClass("MuiBackdrop", C);
}
generateUtilityClasses("MuiBackdrop", ["root", "invisible"]);
const _excluded$F = ["children", "className", "component", "components", "componentsProps", "invisible", "open", "slotProps", "slots", "TransitionComponent", "transitionDuration"], useUtilityClasses$B = (C) => {
  const {
    classes: e,
    invisible: T
  } = C;
  return composeClasses({
    root: ["root", T && "invisible"]
  }, getBackdropUtilityClass, e);
}, BackdropRoot = styled$1("div", {
  name: "MuiBackdrop",
  slot: "Root",
  overridesResolver: (C, e) => {
    const {
      ownerState: T
    } = C;
    return [e.root, T.invisible && e.invisible];
  }
})(({
  ownerState: C
}) => _extends({
  position: "fixed",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  right: 0,
  bottom: 0,
  top: 0,
  left: 0,
  backgroundColor: "rgba(0, 0, 0, 0.5)",
  WebkitTapHighlightColor: "transparent"
}, C.invisible && {
  backgroundColor: "transparent"
})), Backdrop = /* @__PURE__ */ React$1.forwardRef(function(e, T) {
  var $, V, J;
  const ee = useDefaultProps({
    props: e,
    name: "MuiBackdrop"
  }), {
    children: te,
    className: re,
    component: ie = "div",
    components: se = {},
    componentsProps: de = {},
    invisible: ue = !1,
    open: fe,
    slotProps: he = {},
    slots: me = {},
    TransitionComponent: xe = Fade,
    transitionDuration: ve
  } = ee, Te = _objectWithoutPropertiesLoose(ee, _excluded$F), we = _extends({}, ee, {
    component: ie,
    invisible: ue
  }), Ee = useUtilityClasses$B(we), Me = ($ = he.root) != null ? $ : de.root;
  return /* @__PURE__ */ jsxRuntimeExports.jsx(xe, _extends({
    in: fe,
    timeout: ve
  }, Te, {
    children: /* @__PURE__ */ jsxRuntimeExports.jsx(BackdropRoot, _extends({
      "aria-hidden": !0
    }, Me, {
      as: (V = (J = me.root) != null ? J : se.Root) != null ? V : ie,
      className: clsx(Ee.root, re, Me == null ? void 0 : Me.className),
      ownerState: _extends({}, we, Me == null ? void 0 : Me.ownerState),
      classes: Ee,
      ref: T,
      children: te
    }))
  }));
});
dist$2.process.env.NODE_ENV !== "production" && (Backdrop.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes.elementType,
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `slots` prop.
   * It's recommended to use the `slots` prop instead.
   *
   * @default {}
   */
  components: PropTypes.shape({
    Root: PropTypes.elementType
  }),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * This prop is an alias for the `slotProps` prop.
   * It's recommended to use the `slotProps` prop instead, as `componentsProps` will be deprecated in the future.
   *
   * @default {}
   */
  componentsProps: PropTypes.shape({
    root: PropTypes.object
  }),
  /**
   * If `true`, the backdrop is invisible.
   * It can be used when rendering a popover or a custom select component.
   * @default false
   */
  invisible: PropTypes.bool,
  /**
   * If `true`, the component is shown.
   */
  open: PropTypes.bool.isRequired,
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * This prop is an alias for the `componentsProps` prop, which will be deprecated in the future.
   *
   * @default {}
   */
  slotProps: PropTypes.shape({
    root: PropTypes.object
  }),
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `components` prop, which will be deprecated in the future.
   *
   * @default {}
   */
  slots: PropTypes.shape({
    root: PropTypes.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * The component used for the transition.
   * [Follow this guide](/material-ui/transitions/#transitioncomponent-prop) to learn more about the requirements for this component.
   * @default Fade
   */
  TransitionComponent: PropTypes.elementType,
  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   */
  transitionDuration: PropTypes.oneOfType([PropTypes.number, PropTypes.shape({
    appear: PropTypes.number,
    enter: PropTypes.number,
    exit: PropTypes.number
  })])
});
function useBadge(C) {
  const {
    badgeContent: e,
    invisible: T = !1,
    max: $ = 99,
    showZero: V = !1
  } = C, J = usePreviousProps({
    badgeContent: e,
    max: $
  });
  let ee = T;
  T === !1 && e === 0 && !V && (ee = !0);
  const {
    badgeContent: te,
    max: re = $
  } = ee ? J : C, ie = te && Number(te) > re ? `${re}+` : te;
  return {
    badgeContent: te,
    invisible: ee,
    max: re,
    displayValue: ie
  };
}
function getBadgeUtilityClass(C) {
  return generateUtilityClass("MuiBadge", C);
}
const badgeClasses = generateUtilityClasses("MuiBadge", [
  "root",
  "badge",
  "dot",
  "standard",
  "anchorOriginTopRight",
  "anchorOriginBottomRight",
  "anchorOriginTopLeft",
  "anchorOriginBottomLeft",
  "invisible",
  "colorError",
  "colorInfo",
  "colorPrimary",
  "colorSecondary",
  "colorSuccess",
  "colorWarning",
  "overlapRectangular",
  "overlapCircular",
  // TODO: v6 remove the overlap value from these class keys
  "anchorOriginTopLeftCircular",
  "anchorOriginTopLeftRectangular",
  "anchorOriginTopRightCircular",
  "anchorOriginTopRightRectangular",
  "anchorOriginBottomLeftCircular",
  "anchorOriginBottomLeftRectangular",
  "anchorOriginBottomRightCircular",
  "anchorOriginBottomRightRectangular"
]), _excluded$E = ["anchorOrigin", "className", "classes", "component", "components", "componentsProps", "children", "overlap", "color", "invisible", "max", "badgeContent", "slots", "slotProps", "showZero", "variant"], RADIUS_STANDARD = 10, RADIUS_DOT = 4, useUtilityClasses$A = (C) => {
  const {
    color: e,
    anchorOrigin: T,
    invisible: $,
    overlap: V,
    variant: J,
    classes: ee = {}
  } = C, te = {
    root: ["root"],
    badge: ["badge", J, $ && "invisible", `anchorOrigin${capitalize$3(T.vertical)}${capitalize$3(T.horizontal)}`, `anchorOrigin${capitalize$3(T.vertical)}${capitalize$3(T.horizontal)}${capitalize$3(V)}`, `overlap${capitalize$3(V)}`, e !== "default" && `color${capitalize$3(e)}`]
  };
  return composeClasses(te, getBadgeUtilityClass, ee);
}, BadgeRoot = styled$1("span", {
  name: "MuiBadge",
  slot: "Root",
  overridesResolver: (C, e) => e.root
})({
  position: "relative",
  display: "inline-flex",
  // For correct alignment with the text.
  verticalAlign: "middle",
  flexShrink: 0
}), BadgeBadge = styled$1("span", {
  name: "MuiBadge",
  slot: "Badge",
  overridesResolver: (C, e) => {
    const {
      ownerState: T
    } = C;
    return [e.badge, e[T.variant], e[`anchorOrigin${capitalize$3(T.anchorOrigin.vertical)}${capitalize$3(T.anchorOrigin.horizontal)}${capitalize$3(T.overlap)}`], T.color !== "default" && e[`color${capitalize$3(T.color)}`], T.invisible && e.invisible];
  }
})(({
  theme: C
}) => {
  var e;
  return {
    display: "flex",
    flexDirection: "row",
    flexWrap: "wrap",
    justifyContent: "center",
    alignContent: "center",
    alignItems: "center",
    position: "absolute",
    boxSizing: "border-box",
    fontFamily: C.typography.fontFamily,
    fontWeight: C.typography.fontWeightMedium,
    fontSize: C.typography.pxToRem(12),
    minWidth: RADIUS_STANDARD * 2,
    lineHeight: 1,
    padding: "0 6px",
    height: RADIUS_STANDARD * 2,
    borderRadius: RADIUS_STANDARD,
    zIndex: 1,
    // Render the badge on top of potential ripples.
    transition: C.transitions.create("transform", {
      easing: C.transitions.easing.easeInOut,
      duration: C.transitions.duration.enteringScreen
    }),
    variants: [...Object.keys(((e = C.vars) != null ? e : C).palette).filter((T) => {
      var $, V;
      return (($ = C.vars) != null ? $ : C).palette[T].main && ((V = C.vars) != null ? V : C).palette[T].contrastText;
    }).map((T) => ({
      props: {
        color: T
      },
      style: {
        backgroundColor: (C.vars || C).palette[T].main,
        color: (C.vars || C).palette[T].contrastText
      }
    })), {
      props: {
        variant: "dot"
      },
      style: {
        borderRadius: RADIUS_DOT,
        height: RADIUS_DOT * 2,
        minWidth: RADIUS_DOT * 2,
        padding: 0
      }
    }, {
      props: ({
        ownerState: T
      }) => T.anchorOrigin.vertical === "top" && T.anchorOrigin.horizontal === "right" && T.overlap === "rectangular",
      style: {
        top: 0,
        right: 0,
        transform: "scale(1) translate(50%, -50%)",
        transformOrigin: "100% 0%",
        [`&.${badgeClasses.invisible}`]: {
          transform: "scale(0) translate(50%, -50%)"
        }
      }
    }, {
      props: ({
        ownerState: T
      }) => T.anchorOrigin.vertical === "bottom" && T.anchorOrigin.horizontal === "right" && T.overlap === "rectangular",
      style: {
        bottom: 0,
        right: 0,
        transform: "scale(1) translate(50%, 50%)",
        transformOrigin: "100% 100%",
        [`&.${badgeClasses.invisible}`]: {
          transform: "scale(0) translate(50%, 50%)"
        }
      }
    }, {
      props: ({
        ownerState: T
      }) => T.anchorOrigin.vertical === "top" && T.anchorOrigin.horizontal === "left" && T.overlap === "rectangular",
      style: {
        top: 0,
        left: 0,
        transform: "scale(1) translate(-50%, -50%)",
        transformOrigin: "0% 0%",
        [`&.${badgeClasses.invisible}`]: {
          transform: "scale(0) translate(-50%, -50%)"
        }
      }
    }, {
      props: ({
        ownerState: T
      }) => T.anchorOrigin.vertical === "bottom" && T.anchorOrigin.horizontal === "left" && T.overlap === "rectangular",
      style: {
        bottom: 0,
        left: 0,
        transform: "scale(1) translate(-50%, 50%)",
        transformOrigin: "0% 100%",
        [`&.${badgeClasses.invisible}`]: {
          transform: "scale(0) translate(-50%, 50%)"
        }
      }
    }, {
      props: ({
        ownerState: T
      }) => T.anchorOrigin.vertical === "top" && T.anchorOrigin.horizontal === "right" && T.overlap === "circular",
      style: {
        top: "14%",
        right: "14%",
        transform: "scale(1) translate(50%, -50%)",
        transformOrigin: "100% 0%",
        [`&.${badgeClasses.invisible}`]: {
          transform: "scale(0) translate(50%, -50%)"
        }
      }
    }, {
      props: ({
        ownerState: T
      }) => T.anchorOrigin.vertical === "bottom" && T.anchorOrigin.horizontal === "right" && T.overlap === "circular",
      style: {
        bottom: "14%",
        right: "14%",
        transform: "scale(1) translate(50%, 50%)",
        transformOrigin: "100% 100%",
        [`&.${badgeClasses.invisible}`]: {
          transform: "scale(0) translate(50%, 50%)"
        }
      }
    }, {
      props: ({
        ownerState: T
      }) => T.anchorOrigin.vertical === "top" && T.anchorOrigin.horizontal === "left" && T.overlap === "circular",
      style: {
        top: "14%",
        left: "14%",
        transform: "scale(1) translate(-50%, -50%)",
        transformOrigin: "0% 0%",
        [`&.${badgeClasses.invisible}`]: {
          transform: "scale(0) translate(-50%, -50%)"
        }
      }
    }, {
      props: ({
        ownerState: T
      }) => T.anchorOrigin.vertical === "bottom" && T.anchorOrigin.horizontal === "left" && T.overlap === "circular",
      style: {
        bottom: "14%",
        left: "14%",
        transform: "scale(1) translate(-50%, 50%)",
        transformOrigin: "0% 100%",
        [`&.${badgeClasses.invisible}`]: {
          transform: "scale(0) translate(-50%, 50%)"
        }
      }
    }, {
      props: {
        invisible: !0
      },
      style: {
        transition: C.transitions.create("transform", {
          easing: C.transitions.easing.easeInOut,
          duration: C.transitions.duration.leavingScreen
        })
      }
    }]
  };
}), Badge = /* @__PURE__ */ React$1.forwardRef(function(e, T) {
  var $, V, J, ee, te, re;
  const ie = useDefaultProps({
    props: e,
    name: "MuiBadge"
  }), {
    anchorOrigin: se = {
      vertical: "top",
      horizontal: "right"
    },
    className: de,
    component: ue,
    components: fe = {},
    componentsProps: he = {},
    children: me,
    overlap: xe = "rectangular",
    color: ve = "default",
    invisible: Te = !1,
    max: we = 99,
    badgeContent: Ee,
    slots: Me,
    slotProps: Ie,
    showZero: ke = !1,
    variant: _e = "standard"
  } = ie, De = _objectWithoutPropertiesLoose(ie, _excluded$E), {
    badgeContent: Fe,
    invisible: Ae,
    max: ne,
    displayValue: oe
  } = useBadge({
    max: we,
    invisible: Te,
    badgeContent: Ee,
    showZero: ke
  }), ce = usePreviousProps({
    anchorOrigin: se,
    color: ve,
    overlap: xe,
    variant: _e,
    badgeContent: Ee
  }), le = Ae || Fe == null && _e !== "dot", {
    color: pe = ve,
    overlap: ye = xe,
    anchorOrigin: Ce = se,
    variant: be = _e
  } = le ? ce : ie, ae = be !== "dot" ? oe : void 0, ge = _extends({}, ie, {
    badgeContent: Fe,
    invisible: le,
    max: ne,
    displayValue: ae,
    showZero: ke,
    anchorOrigin: Ce,
    color: pe,
    overlap: ye,
    variant: be
  }), Se = useUtilityClasses$A(ge), Le = ($ = (V = Me == null ? void 0 : Me.root) != null ? V : fe.Root) != null ? $ : BadgeRoot, ze = (J = (ee = Me == null ? void 0 : Me.badge) != null ? ee : fe.Badge) != null ? J : BadgeBadge, Re = (te = Ie == null ? void 0 : Ie.root) != null ? te : he.root, We = (re = Ie == null ? void 0 : Ie.badge) != null ? re : he.badge, Be = useSlotProps({
    elementType: Le,
    externalSlotProps: Re,
    externalForwardedProps: De,
    additionalProps: {
      ref: T,
      as: ue
    },
    ownerState: ge,
    className: clsx(Re == null ? void 0 : Re.className, Se.root, de)
  }), Ue = useSlotProps({
    elementType: ze,
    externalSlotProps: We,
    ownerState: ge,
    className: clsx(Se.badge, We == null ? void 0 : We.className)
  });
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(Le, _extends({}, Be, {
    children: [me, /* @__PURE__ */ jsxRuntimeExports.jsx(ze, _extends({}, Ue, {
      children: ae
    }))]
  }));
});
dist$2.process.env.NODE_ENV !== "production" && (Badge.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The anchor of the badge.
   * @default {
   *   vertical: 'top',
   *   horizontal: 'right',
   * }
   */
  anchorOrigin: PropTypes.shape({
    horizontal: PropTypes.oneOf(["left", "right"]).isRequired,
    vertical: PropTypes.oneOf(["bottom", "top"]).isRequired
  }),
  /**
   * The content rendered within the badge.
   */
  badgeContent: PropTypes.node,
  /**
   * The badge will be added relative to this node.
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'default'
   */
  color: PropTypes.oneOfType([PropTypes.oneOf(["default", "primary", "secondary", "error", "info", "success", "warning"]), PropTypes.string]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes.elementType,
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `slots` prop.
   * It's recommended to use the `slots` prop instead.
   *
   * @default {}
   */
  components: PropTypes.shape({
    Badge: PropTypes.elementType,
    Root: PropTypes.elementType
  }),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * This prop is an alias for the `slotProps` prop.
   * It's recommended to use the `slotProps` prop instead, as `componentsProps` will be deprecated in the future.
   *
   * @default {}
   */
  componentsProps: PropTypes.shape({
    badge: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
    root: PropTypes.oneOfType([PropTypes.func, PropTypes.object])
  }),
  /**
   * If `true`, the badge is invisible.
   * @default false
   */
  invisible: PropTypes.bool,
  /**
   * Max count to show.
   * @default 99
   */
  max: PropTypes.number,
  /**
   * Wrapped shape the badge should overlap.
   * @default 'rectangular'
   */
  overlap: PropTypes.oneOf(["circular", "rectangular"]),
  /**
   * Controls whether the badge is hidden when `badgeContent` is zero.
   * @default false
   */
  showZero: PropTypes.bool,
  /**
   * The props used for each slot inside the Badge.
   * @default {}
   */
  slotProps: PropTypes.shape({
    badge: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
    root: PropTypes.oneOfType([PropTypes.func, PropTypes.object])
  }),
  /**
   * The components used for each slot inside the Badge.
   * Either a string to use a HTML element or a component.
   * @default {}
   */
  slots: PropTypes.shape({
    badge: PropTypes.elementType,
    root: PropTypes.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * The variant to use.
   * @default 'standard'
   */
  variant: PropTypes.oneOfType([PropTypes.oneOf(["dot", "standard"]), PropTypes.string])
});
const boxClasses = generateUtilityClasses("MuiBox", ["root"]), defaultTheme = createTheme(), Box = createBox({
  themeId: THEME_ID,
  defaultTheme,
  defaultClassName: boxClasses.root,
  generateClassName: ClassNameGenerator.generate
});
dist$2.process.env.NODE_ENV !== "production" && (Box.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * @ignore
   */
  children: PropTypes.node,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes.elementType,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object])
});
function getButtonUtilityClass(C) {
  return generateUtilityClass("MuiButton", C);
}
const buttonClasses = generateUtilityClasses("MuiButton", ["root", "text", "textInherit", "textPrimary", "textSecondary", "textSuccess", "textError", "textInfo", "textWarning", "outlined", "outlinedInherit", "outlinedPrimary", "outlinedSecondary", "outlinedSuccess", "outlinedError", "outlinedInfo", "outlinedWarning", "contained", "containedInherit", "containedPrimary", "containedSecondary", "containedSuccess", "containedError", "containedInfo", "containedWarning", "disableElevation", "focusVisible", "disabled", "colorInherit", "colorPrimary", "colorSecondary", "colorSuccess", "colorError", "colorInfo", "colorWarning", "textSizeSmall", "textSizeMedium", "textSizeLarge", "outlinedSizeSmall", "outlinedSizeMedium", "outlinedSizeLarge", "containedSizeSmall", "containedSizeMedium", "containedSizeLarge", "sizeMedium", "sizeSmall", "sizeLarge", "fullWidth", "startIcon", "endIcon", "icon", "iconSizeSmall", "iconSizeMedium", "iconSizeLarge"]), ButtonGroupContext = /* @__PURE__ */ React$1.createContext({});
dist$2.process.env.NODE_ENV !== "production" && (ButtonGroupContext.displayName = "ButtonGroupContext");
const ButtonGroupButtonContext = /* @__PURE__ */ React$1.createContext(void 0);
dist$2.process.env.NODE_ENV !== "production" && (ButtonGroupButtonContext.displayName = "ButtonGroupButtonContext");
const _excluded$D = ["children", "color", "component", "className", "disabled", "disableElevation", "disableFocusRipple", "endIcon", "focusVisibleClassName", "fullWidth", "size", "startIcon", "type", "variant"], useUtilityClasses$z = (C) => {
  const {
    color: e,
    disableElevation: T,
    fullWidth: $,
    size: V,
    variant: J,
    classes: ee
  } = C, te = {
    root: ["root", J, `${J}${capitalize$3(e)}`, `size${capitalize$3(V)}`, `${J}Size${capitalize$3(V)}`, `color${capitalize$3(e)}`, T && "disableElevation", $ && "fullWidth"],
    label: ["label"],
    startIcon: ["icon", "startIcon", `iconSize${capitalize$3(V)}`],
    endIcon: ["icon", "endIcon", `iconSize${capitalize$3(V)}`]
  }, re = composeClasses(te, getButtonUtilityClass, ee);
  return _extends({}, ee, re);
}, commonIconStyles = (C) => _extends({}, C.size === "small" && {
  "& > *:nth-of-type(1)": {
    fontSize: 18
  }
}, C.size === "medium" && {
  "& > *:nth-of-type(1)": {
    fontSize: 20
  }
}, C.size === "large" && {
  "& > *:nth-of-type(1)": {
    fontSize: 22
  }
}), ButtonRoot = styled$1(ButtonBase, {
  shouldForwardProp: (C) => rootShouldForwardProp(C) || C === "classes",
  name: "MuiButton",
  slot: "Root",
  overridesResolver: (C, e) => {
    const {
      ownerState: T
    } = C;
    return [e.root, e[T.variant], e[`${T.variant}${capitalize$3(T.color)}`], e[`size${capitalize$3(T.size)}`], e[`${T.variant}Size${capitalize$3(T.size)}`], T.color === "inherit" && e.colorInherit, T.disableElevation && e.disableElevation, T.fullWidth && e.fullWidth];
  }
})(({
  theme: C,
  ownerState: e
}) => {
  var T, $;
  const V = C.palette.mode === "light" ? C.palette.grey[300] : C.palette.grey[800], J = C.palette.mode === "light" ? C.palette.grey.A100 : C.palette.grey[700];
  return _extends({}, C.typography.button, {
    minWidth: 64,
    padding: "6px 16px",
    borderRadius: (C.vars || C).shape.borderRadius,
    transition: C.transitions.create(["background-color", "box-shadow", "border-color", "color"], {
      duration: C.transitions.duration.short
    }),
    "&:hover": _extends({
      textDecoration: "none",
      backgroundColor: C.vars ? `rgba(${C.vars.palette.text.primaryChannel} / ${C.vars.palette.action.hoverOpacity})` : alpha_1(C.palette.text.primary, C.palette.action.hoverOpacity),
      // Reset on touch devices, it doesn't add specificity
      "@media (hover: none)": {
        backgroundColor: "transparent"
      }
    }, e.variant === "text" && e.color !== "inherit" && {
      backgroundColor: C.vars ? `rgba(${C.vars.palette[e.color].mainChannel} / ${C.vars.palette.action.hoverOpacity})` : alpha_1(C.palette[e.color].main, C.palette.action.hoverOpacity),
      // Reset on touch devices, it doesn't add specificity
      "@media (hover: none)": {
        backgroundColor: "transparent"
      }
    }, e.variant === "outlined" && e.color !== "inherit" && {
      border: `1px solid ${(C.vars || C).palette[e.color].main}`,
      backgroundColor: C.vars ? `rgba(${C.vars.palette[e.color].mainChannel} / ${C.vars.palette.action.hoverOpacity})` : alpha_1(C.palette[e.color].main, C.palette.action.hoverOpacity),
      // Reset on touch devices, it doesn't add specificity
      "@media (hover: none)": {
        backgroundColor: "transparent"
      }
    }, e.variant === "contained" && {
      backgroundColor: C.vars ? C.vars.palette.Button.inheritContainedHoverBg : J,
      boxShadow: (C.vars || C).shadows[4],
      // Reset on touch devices, it doesn't add specificity
      "@media (hover: none)": {
        boxShadow: (C.vars || C).shadows[2],
        backgroundColor: (C.vars || C).palette.grey[300]
      }
    }, e.variant === "contained" && e.color !== "inherit" && {
      backgroundColor: (C.vars || C).palette[e.color].dark,
      // Reset on touch devices, it doesn't add specificity
      "@media (hover: none)": {
        backgroundColor: (C.vars || C).palette[e.color].main
      }
    }),
    "&:active": _extends({}, e.variant === "contained" && {
      boxShadow: (C.vars || C).shadows[8]
    }),
    [`&.${buttonClasses.focusVisible}`]: _extends({}, e.variant === "contained" && {
      boxShadow: (C.vars || C).shadows[6]
    }),
    [`&.${buttonClasses.disabled}`]: _extends({
      color: (C.vars || C).palette.action.disabled
    }, e.variant === "outlined" && {
      border: `1px solid ${(C.vars || C).palette.action.disabledBackground}`
    }, e.variant === "contained" && {
      color: (C.vars || C).palette.action.disabled,
      boxShadow: (C.vars || C).shadows[0],
      backgroundColor: (C.vars || C).palette.action.disabledBackground
    })
  }, e.variant === "text" && {
    padding: "6px 8px"
  }, e.variant === "text" && e.color !== "inherit" && {
    color: (C.vars || C).palette[e.color].main
  }, e.variant === "outlined" && {
    padding: "5px 15px",
    border: "1px solid currentColor"
  }, e.variant === "outlined" && e.color !== "inherit" && {
    color: (C.vars || C).palette[e.color].main,
    border: C.vars ? `1px solid rgba(${C.vars.palette[e.color].mainChannel} / 0.5)` : `1px solid ${alpha_1(C.palette[e.color].main, 0.5)}`
  }, e.variant === "contained" && {
    color: C.vars ? (
      // this is safe because grey does not change between default light/dark mode
      C.vars.palette.text.primary
    ) : (T = ($ = C.palette).getContrastText) == null ? void 0 : T.call($, C.palette.grey[300]),
    backgroundColor: C.vars ? C.vars.palette.Button.inheritContainedBg : V,
    boxShadow: (C.vars || C).shadows[2]
  }, e.variant === "contained" && e.color !== "inherit" && {
    color: (C.vars || C).palette[e.color].contrastText,
    backgroundColor: (C.vars || C).palette[e.color].main
  }, e.color === "inherit" && {
    color: "inherit",
    borderColor: "currentColor"
  }, e.size === "small" && e.variant === "text" && {
    padding: "4px 5px",
    fontSize: C.typography.pxToRem(13)
  }, e.size === "large" && e.variant === "text" && {
    padding: "8px 11px",
    fontSize: C.typography.pxToRem(15)
  }, e.size === "small" && e.variant === "outlined" && {
    padding: "3px 9px",
    fontSize: C.typography.pxToRem(13)
  }, e.size === "large" && e.variant === "outlined" && {
    padding: "7px 21px",
    fontSize: C.typography.pxToRem(15)
  }, e.size === "small" && e.variant === "contained" && {
    padding: "4px 10px",
    fontSize: C.typography.pxToRem(13)
  }, e.size === "large" && e.variant === "contained" && {
    padding: "8px 22px",
    fontSize: C.typography.pxToRem(15)
  }, e.fullWidth && {
    width: "100%"
  });
}, ({
  ownerState: C
}) => C.disableElevation && {
  boxShadow: "none",
  "&:hover": {
    boxShadow: "none"
  },
  [`&.${buttonClasses.focusVisible}`]: {
    boxShadow: "none"
  },
  "&:active": {
    boxShadow: "none"
  },
  [`&.${buttonClasses.disabled}`]: {
    boxShadow: "none"
  }
}), ButtonStartIcon = styled$1("span", {
  name: "MuiButton",
  slot: "StartIcon",
  overridesResolver: (C, e) => {
    const {
      ownerState: T
    } = C;
    return [e.startIcon, e[`iconSize${capitalize$3(T.size)}`]];
  }
})(({
  ownerState: C
}) => _extends({
  display: "inherit",
  marginRight: 8,
  marginLeft: -4
}, C.size === "small" && {
  marginLeft: -2
}, commonIconStyles(C))), ButtonEndIcon = styled$1("span", {
  name: "MuiButton",
  slot: "EndIcon",
  overridesResolver: (C, e) => {
    const {
      ownerState: T
    } = C;
    return [e.endIcon, e[`iconSize${capitalize$3(T.size)}`]];
  }
})(({
  ownerState: C
}) => _extends({
  display: "inherit",
  marginRight: -4,
  marginLeft: 8
}, C.size === "small" && {
  marginRight: -2
}, commonIconStyles(C))), Button$2 = /* @__PURE__ */ React$1.forwardRef(function(e, T) {
  const $ = React$1.useContext(ButtonGroupContext), V = React$1.useContext(ButtonGroupButtonContext), J = resolveProps($, e), ee = useDefaultProps({
    props: J,
    name: "MuiButton"
  }), {
    children: te,
    color: re = "primary",
    component: ie = "button",
    className: se,
    disabled: de = !1,
    disableElevation: ue = !1,
    disableFocusRipple: fe = !1,
    endIcon: he,
    focusVisibleClassName: me,
    fullWidth: xe = !1,
    size: ve = "medium",
    startIcon: Te,
    type: we,
    variant: Ee = "text"
  } = ee, Me = _objectWithoutPropertiesLoose(ee, _excluded$D), Ie = _extends({}, ee, {
    color: re,
    component: ie,
    disabled: de,
    disableElevation: ue,
    disableFocusRipple: fe,
    fullWidth: xe,
    size: ve,
    type: we,
    variant: Ee
  }), ke = useUtilityClasses$z(Ie), _e = Te && /* @__PURE__ */ jsxRuntimeExports.jsx(ButtonStartIcon, {
    className: ke.startIcon,
    ownerState: Ie,
    children: Te
  }), De = he && /* @__PURE__ */ jsxRuntimeExports.jsx(ButtonEndIcon, {
    className: ke.endIcon,
    ownerState: Ie,
    children: he
  }), Fe = V || "";
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(ButtonRoot, _extends({
    ownerState: Ie,
    className: clsx($.className, ke.root, se, Fe),
    component: ie,
    disabled: de,
    focusRipple: !fe,
    focusVisibleClassName: clsx(ke.focusVisible, me),
    ref: T,
    type: we
  }, Me, {
    classes: ke,
    children: [_e, te, De]
  }));
});
dist$2.process.env.NODE_ENV !== "production" && (Button$2.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'primary'
   */
  color: PropTypes.oneOfType([PropTypes.oneOf(["inherit", "primary", "secondary", "success", "error", "info", "warning"]), PropTypes.string]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes.elementType,
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: PropTypes.bool,
  /**
   * If `true`, no elevation is used.
   * @default false
   */
  disableElevation: PropTypes.bool,
  /**
   * If `true`, the  keyboard focus ripple is disabled.
   * @default false
   */
  disableFocusRipple: PropTypes.bool,
  /**
   * If `true`, the ripple effect is disabled.
   *
   * ⚠️ Without a ripple there is no styling for :focus-visible by default. Be sure
   * to highlight the element by applying separate styles with the `.Mui-focusVisible` class.
   * @default false
   */
  disableRipple: PropTypes.bool,
  /**
   * Element placed after the children.
   */
  endIcon: PropTypes.node,
  /**
   * @ignore
   */
  focusVisibleClassName: PropTypes.string,
  /**
   * If `true`, the button will take up the full width of its container.
   * @default false
   */
  fullWidth: PropTypes.bool,
  /**
   * The URL to link to when the button is clicked.
   * If defined, an `a` element will be used as the root node.
   */
  href: PropTypes.string,
  /**
   * The size of the component.
   * `small` is equivalent to the dense button styling.
   * @default 'medium'
   */
  size: PropTypes.oneOfType([PropTypes.oneOf(["small", "medium", "large"]), PropTypes.string]),
  /**
   * Element placed before the children.
   */
  startIcon: PropTypes.node,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * @ignore
   */
  type: PropTypes.oneOfType([PropTypes.oneOf(["button", "reset", "submit"]), PropTypes.string]),
  /**
   * The variant to use.
   * @default 'text'
   */
  variant: PropTypes.oneOfType([PropTypes.oneOf(["contained", "outlined", "text"]), PropTypes.string])
});
function getCardUtilityClass(C) {
  return generateUtilityClass("MuiCard", C);
}
generateUtilityClasses("MuiCard", ["root"]);
const _excluded$C = ["className", "raised"], useUtilityClasses$y = (C) => {
  const {
    classes: e
  } = C;
  return composeClasses({
    root: ["root"]
  }, getCardUtilityClass, e);
}, CardRoot = styled$1(Paper, {
  name: "MuiCard",
  slot: "Root",
  overridesResolver: (C, e) => e.root
})(() => ({
  overflow: "hidden"
})), Card = /* @__PURE__ */ React$1.forwardRef(function(e, T) {
  const $ = useDefaultProps({
    props: e,
    name: "MuiCard"
  }), {
    className: V,
    raised: J = !1
  } = $, ee = _objectWithoutPropertiesLoose($, _excluded$C), te = _extends({}, $, {
    raised: J
  }), re = useUtilityClasses$y(te);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(CardRoot, _extends({
    className: clsx(re.root, V),
    elevation: J ? 8 : void 0,
    ref: T,
    ownerState: te
  }, ee));
});
dist$2.process.env.NODE_ENV !== "production" && (Card.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * If `true`, the card will use raised styling.
   * @default false
   */
  raised: chainPropTypes(PropTypes.bool, (C) => C.raised && C.variant === "outlined" ? new Error('MUI: Combining `raised={true}` with `variant="outlined"` has no effect.') : null),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object])
});
function getCardActionAreaUtilityClass(C) {
  return generateUtilityClass("MuiCardActionArea", C);
}
const cardActionAreaClasses = generateUtilityClasses("MuiCardActionArea", ["root", "focusVisible", "focusHighlight"]), _excluded$B = ["children", "className", "focusVisibleClassName"], useUtilityClasses$x = (C) => {
  const {
    classes: e
  } = C;
  return composeClasses({
    root: ["root"],
    focusHighlight: ["focusHighlight"]
  }, getCardActionAreaUtilityClass, e);
}, CardActionAreaRoot = styled$1(ButtonBase, {
  name: "MuiCardActionArea",
  slot: "Root",
  overridesResolver: (C, e) => e.root
})(({
  theme: C
}) => ({
  display: "block",
  textAlign: "inherit",
  borderRadius: "inherit",
  // for Safari to work https://github.com/mui/material-ui/issues/36285.
  width: "100%",
  [`&:hover .${cardActionAreaClasses.focusHighlight}`]: {
    opacity: (C.vars || C).palette.action.hoverOpacity,
    "@media (hover: none)": {
      opacity: 0
    }
  },
  [`&.${cardActionAreaClasses.focusVisible} .${cardActionAreaClasses.focusHighlight}`]: {
    opacity: (C.vars || C).palette.action.focusOpacity
  }
})), CardActionAreaFocusHighlight = styled$1("span", {
  name: "MuiCardActionArea",
  slot: "FocusHighlight",
  overridesResolver: (C, e) => e.focusHighlight
})(({
  theme: C
}) => ({
  overflow: "hidden",
  pointerEvents: "none",
  position: "absolute",
  top: 0,
  right: 0,
  bottom: 0,
  left: 0,
  borderRadius: "inherit",
  opacity: 0,
  backgroundColor: "currentcolor",
  transition: C.transitions.create("opacity", {
    duration: C.transitions.duration.short
  })
})), CardActionArea = /* @__PURE__ */ React$1.forwardRef(function(e, T) {
  const $ = useDefaultProps({
    props: e,
    name: "MuiCardActionArea"
  }), {
    children: V,
    className: J,
    focusVisibleClassName: ee
  } = $, te = _objectWithoutPropertiesLoose($, _excluded$B), re = $, ie = useUtilityClasses$x(re);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(CardActionAreaRoot, _extends({
    className: clsx(ie.root, J),
    focusVisibleClassName: clsx(ee, ie.focusVisible),
    ref: T,
    ownerState: re
  }, te, {
    children: [V, /* @__PURE__ */ jsxRuntimeExports.jsx(CardActionAreaFocusHighlight, {
      className: ie.focusHighlight,
      ownerState: re
    })]
  }));
});
dist$2.process.env.NODE_ENV !== "production" && (CardActionArea.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * @ignore
   */
  focusVisibleClassName: PropTypes.string,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object])
});
function getCardContentUtilityClass(C) {
  return generateUtilityClass("MuiCardContent", C);
}
generateUtilityClasses("MuiCardContent", ["root"]);
const _excluded$A = ["className", "component"], useUtilityClasses$w = (C) => {
  const {
    classes: e
  } = C;
  return composeClasses({
    root: ["root"]
  }, getCardContentUtilityClass, e);
}, CardContentRoot = styled$1("div", {
  name: "MuiCardContent",
  slot: "Root",
  overridesResolver: (C, e) => e.root
})(() => ({
  padding: 16,
  "&:last-child": {
    paddingBottom: 24
  }
})), CardContent = /* @__PURE__ */ React$1.forwardRef(function(e, T) {
  const $ = useDefaultProps({
    props: e,
    name: "MuiCardContent"
  }), {
    className: V,
    component: J = "div"
  } = $, ee = _objectWithoutPropertiesLoose($, _excluded$A), te = _extends({}, $, {
    component: J
  }), re = useUtilityClasses$w(te);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(CardContentRoot, _extends({
    as: J,
    className: clsx(re.root, V),
    ownerState: te,
    ref: T
  }, ee));
});
dist$2.process.env.NODE_ENV !== "production" && (CardContent.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes.elementType,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object])
});
function getCardHeaderUtilityClass(C) {
  return generateUtilityClass("MuiCardHeader", C);
}
const cardHeaderClasses = generateUtilityClasses("MuiCardHeader", ["root", "avatar", "action", "content", "title", "subheader"]), _excluded$z = ["action", "avatar", "className", "component", "disableTypography", "subheader", "subheaderTypographyProps", "title", "titleTypographyProps"], useUtilityClasses$v = (C) => {
  const {
    classes: e
  } = C;
  return composeClasses({
    root: ["root"],
    avatar: ["avatar"],
    action: ["action"],
    content: ["content"],
    title: ["title"],
    subheader: ["subheader"]
  }, getCardHeaderUtilityClass, e);
}, CardHeaderRoot = styled$1("div", {
  name: "MuiCardHeader",
  slot: "Root",
  overridesResolver: (C, e) => _extends({
    [`& .${cardHeaderClasses.title}`]: e.title,
    [`& .${cardHeaderClasses.subheader}`]: e.subheader
  }, e.root)
})({
  display: "flex",
  alignItems: "center",
  padding: 16
}), CardHeaderAvatar = styled$1("div", {
  name: "MuiCardHeader",
  slot: "Avatar",
  overridesResolver: (C, e) => e.avatar
})({
  display: "flex",
  flex: "0 0 auto",
  marginRight: 16
}), CardHeaderAction = styled$1("div", {
  name: "MuiCardHeader",
  slot: "Action",
  overridesResolver: (C, e) => e.action
})({
  flex: "0 0 auto",
  alignSelf: "flex-start",
  marginTop: -4,
  marginRight: -8,
  marginBottom: -4
}), CardHeaderContent = styled$1("div", {
  name: "MuiCardHeader",
  slot: "Content",
  overridesResolver: (C, e) => e.content
})({
  flex: "1 1 auto"
}), CardHeader = /* @__PURE__ */ React$1.forwardRef(function(e, T) {
  const $ = useDefaultProps({
    props: e,
    name: "MuiCardHeader"
  }), {
    action: V,
    avatar: J,
    className: ee,
    component: te = "div",
    disableTypography: re = !1,
    subheader: ie,
    subheaderTypographyProps: se,
    title: de,
    titleTypographyProps: ue
  } = $, fe = _objectWithoutPropertiesLoose($, _excluded$z), he = _extends({}, $, {
    component: te,
    disableTypography: re
  }), me = useUtilityClasses$v(he);
  let xe = de;
  xe != null && xe.type !== Typography && !re && (xe = /* @__PURE__ */ jsxRuntimeExports.jsx(Typography, _extends({
    variant: J ? "body2" : "h5",
    className: me.title,
    component: "span",
    display: "block"
  }, ue, {
    children: xe
  })));
  let ve = ie;
  return ve != null && ve.type !== Typography && !re && (ve = /* @__PURE__ */ jsxRuntimeExports.jsx(Typography, _extends({
    variant: J ? "body2" : "body1",
    className: me.subheader,
    color: "text.secondary",
    component: "span",
    display: "block"
  }, se, {
    children: ve
  }))), /* @__PURE__ */ jsxRuntimeExports.jsxs(CardHeaderRoot, _extends({
    className: clsx(me.root, ee),
    as: te,
    ref: T,
    ownerState: he
  }, fe, {
    children: [J && /* @__PURE__ */ jsxRuntimeExports.jsx(CardHeaderAvatar, {
      className: me.avatar,
      ownerState: he,
      children: J
    }), /* @__PURE__ */ jsxRuntimeExports.jsxs(CardHeaderContent, {
      className: me.content,
      ownerState: he,
      children: [xe, ve]
    }), V && /* @__PURE__ */ jsxRuntimeExports.jsx(CardHeaderAction, {
      className: me.action,
      ownerState: he,
      children: V
    })]
  }));
});
dist$2.process.env.NODE_ENV !== "production" && (CardHeader.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The action to display in the card header.
   */
  action: PropTypes.node,
  /**
   * The Avatar element to display.
   */
  avatar: PropTypes.node,
  /**
   * @ignore
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes.elementType,
  /**
   * If `true`, `subheader` and `title` won't be wrapped by a Typography component.
   * This can be useful to render an alternative Typography variant by wrapping
   * the `title` text, and optional `subheader` text
   * with the Typography component.
   * @default false
   */
  disableTypography: PropTypes.bool,
  /**
   * The content of the component.
   */
  subheader: PropTypes.node,
  /**
   * These props will be forwarded to the subheader
   * (as long as disableTypography is not `true`).
   */
  subheaderTypographyProps: PropTypes.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * The content of the component.
   */
  title: PropTypes.node,
  /**
   * These props will be forwarded to the title
   * (as long as disableTypography is not `true`).
   */
  titleTypographyProps: PropTypes.object
});
function getSwitchBaseUtilityClass(C) {
  return generateUtilityClass("PrivateSwitchBase", C);
}
generateUtilityClasses("PrivateSwitchBase", ["root", "checked", "disabled", "input", "edgeStart", "edgeEnd"]);
const _excluded$y = ["autoFocus", "checked", "checkedIcon", "className", "defaultChecked", "disabled", "disableFocusRipple", "edge", "icon", "id", "inputProps", "inputRef", "name", "onBlur", "onChange", "onFocus", "readOnly", "required", "tabIndex", "type", "value"], useUtilityClasses$u = (C) => {
  const {
    classes: e,
    checked: T,
    disabled: $,
    edge: V
  } = C, J = {
    root: ["root", T && "checked", $ && "disabled", V && `edge${capitalize$3(V)}`],
    input: ["input"]
  };
  return composeClasses(J, getSwitchBaseUtilityClass, e);
}, SwitchBaseRoot = styled$1(ButtonBase)(({
  ownerState: C
}) => _extends({
  padding: 9,
  borderRadius: "50%"
}, C.edge === "start" && {
  marginLeft: C.size === "small" ? -3 : -12
}, C.edge === "end" && {
  marginRight: C.size === "small" ? -3 : -12
})), SwitchBaseInput = styled$1("input", {
  shouldForwardProp: rootShouldForwardProp
})({
  cursor: "inherit",
  position: "absolute",
  opacity: 0,
  width: "100%",
  height: "100%",
  top: 0,
  left: 0,
  margin: 0,
  padding: 0,
  zIndex: 1
}), SwitchBase = /* @__PURE__ */ React$1.forwardRef(function(e, T) {
  const {
    autoFocus: $,
    checked: V,
    checkedIcon: J,
    className: ee,
    defaultChecked: te,
    disabled: re,
    disableFocusRipple: ie = !1,
    edge: se = !1,
    icon: de,
    id: ue,
    inputProps: fe,
    inputRef: he,
    name: me,
    onBlur: xe,
    onChange: ve,
    onFocus: Te,
    readOnly: we,
    required: Ee = !1,
    tabIndex: Me,
    type: Ie,
    value: ke
  } = e, _e = _objectWithoutPropertiesLoose(e, _excluded$y), [De, Fe] = useControlled({
    controlled: V,
    default: !!te,
    name: "SwitchBase",
    state: "checked"
  }), Ae = useFormControl(), ne = (be) => {
    Te && Te(be), Ae && Ae.onFocus && Ae.onFocus(be);
  }, oe = (be) => {
    xe && xe(be), Ae && Ae.onBlur && Ae.onBlur(be);
  }, ce = (be) => {
    if (be.nativeEvent.defaultPrevented)
      return;
    const ae = be.target.checked;
    Fe(ae), ve && ve(be, ae);
  };
  let le = re;
  Ae && typeof le > "u" && (le = Ae.disabled);
  const pe = Ie === "checkbox" || Ie === "radio", ye = _extends({}, e, {
    checked: De,
    disabled: le,
    disableFocusRipple: ie,
    edge: se
  }), Ce = useUtilityClasses$u(ye);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(SwitchBaseRoot, _extends({
    component: "span",
    className: clsx(Ce.root, ee),
    centerRipple: !0,
    focusRipple: !ie,
    disabled: le,
    tabIndex: null,
    role: void 0,
    onFocus: ne,
    onBlur: oe,
    ownerState: ye,
    ref: T
  }, _e, {
    children: [/* @__PURE__ */ jsxRuntimeExports.jsx(SwitchBaseInput, _extends({
      autoFocus: $,
      checked: V,
      defaultChecked: te,
      className: Ce.input,
      disabled: le,
      id: pe ? ue : void 0,
      name: me,
      onChange: ce,
      readOnly: we,
      ref: he,
      required: Ee,
      ownerState: ye,
      tabIndex: Me,
      type: Ie
    }, Ie === "checkbox" && ke === void 0 ? {} : {
      value: ke
    }, fe)), De ? J : de]
  }));
});
dist$2.process.env.NODE_ENV !== "production" && (SwitchBase.propTypes = {
  /**
   * If `true`, the `input` element is focused during the first mount.
   */
  autoFocus: PropTypes.bool,
  /**
   * If `true`, the component is checked.
   */
  checked: PropTypes.bool,
  /**
   * The icon to display when the component is checked.
   */
  checkedIcon: PropTypes.node.isRequired,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * @ignore
   */
  defaultChecked: PropTypes.bool,
  /**
   * If `true`, the component is disabled.
   */
  disabled: PropTypes.bool,
  /**
   * If `true`, the  keyboard focus ripple is disabled.
   * @default false
   */
  disableFocusRipple: PropTypes.bool,
  /**
   * If given, uses a negative margin to counteract the padding on one
   * side (this is often helpful for aligning the left or right
   * side of the icon with content above or below, without ruining the border
   * size and shape).
   * @default false
   */
  edge: PropTypes.oneOf(["end", "start", !1]),
  /**
   * The icon to display when the component is unchecked.
   */
  icon: PropTypes.node.isRequired,
  /**
   * The id of the `input` element.
   */
  id: PropTypes.string,
  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   */
  inputProps: PropTypes.object,
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: refType,
  /*
   * @ignore
   */
  name: PropTypes.string,
  /**
   * @ignore
   */
  onBlur: PropTypes.func,
  /**
   * Callback fired when the state is changed.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new checked state by accessing `event.target.checked` (boolean).
   */
  onChange: PropTypes.func,
  /**
   * @ignore
   */
  onFocus: PropTypes.func,
  /**
   * It prevents the user from changing the value of the field
   * (not from interacting with the field).
   */
  readOnly: PropTypes.bool,
  /**
   * If `true`, the `input` element is required.
   */
  required: PropTypes.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.object,
  /**
   * @ignore
   */
  tabIndex: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  /**
   * The input component prop `type`.
   */
  type: PropTypes.string.isRequired,
  /**
   * The value of the component.
   */
  value: PropTypes.any
});
function getCircularProgressUtilityClass(C) {
  return generateUtilityClass("MuiCircularProgress", C);
}
generateUtilityClasses("MuiCircularProgress", ["root", "determinate", "indeterminate", "colorPrimary", "colorSecondary", "svg", "circle", "circleDeterminate", "circleIndeterminate", "circleDisableShrink"]);
const _excluded$x = ["className", "color", "disableShrink", "size", "style", "thickness", "value", "variant"];
let _$2 = (C) => C, _t$2, _t2$2, _t3$2, _t4$2;
const SIZE = 44, circularRotateKeyframe = keyframes(_t$2 || (_t$2 = _$2`
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
`)), circularDashKeyframe = keyframes(_t2$2 || (_t2$2 = _$2`
  0% {
    stroke-dasharray: 1px, 200px;
    stroke-dashoffset: 0;
  }

  50% {
    stroke-dasharray: 100px, 200px;
    stroke-dashoffset: -15px;
  }

  100% {
    stroke-dasharray: 100px, 200px;
    stroke-dashoffset: -125px;
  }
`)), useUtilityClasses$t = (C) => {
  const {
    classes: e,
    variant: T,
    color: $,
    disableShrink: V
  } = C, J = {
    root: ["root", T, `color${capitalize$3($)}`],
    svg: ["svg"],
    circle: ["circle", `circle${capitalize$3(T)}`, V && "circleDisableShrink"]
  };
  return composeClasses(J, getCircularProgressUtilityClass, e);
}, CircularProgressRoot = styled$1("span", {
  name: "MuiCircularProgress",
  slot: "Root",
  overridesResolver: (C, e) => {
    const {
      ownerState: T
    } = C;
    return [e.root, e[T.variant], e[`color${capitalize$3(T.color)}`]];
  }
})(({
  ownerState: C,
  theme: e
}) => _extends({
  display: "inline-block"
}, C.variant === "determinate" && {
  transition: e.transitions.create("transform")
}, C.color !== "inherit" && {
  color: (e.vars || e).palette[C.color].main
}), ({
  ownerState: C
}) => C.variant === "indeterminate" && css(_t3$2 || (_t3$2 = _$2`
      animation: ${0} 1.4s linear infinite;
    `), circularRotateKeyframe)), CircularProgressSVG = styled$1("svg", {
  name: "MuiCircularProgress",
  slot: "Svg",
  overridesResolver: (C, e) => e.svg
})({
  display: "block"
  // Keeps the progress centered
}), CircularProgressCircle = styled$1("circle", {
  name: "MuiCircularProgress",
  slot: "Circle",
  overridesResolver: (C, e) => {
    const {
      ownerState: T
    } = C;
    return [e.circle, e[`circle${capitalize$3(T.variant)}`], T.disableShrink && e.circleDisableShrink];
  }
})(({
  ownerState: C,
  theme: e
}) => _extends({
  stroke: "currentColor"
}, C.variant === "determinate" && {
  transition: e.transitions.create("stroke-dashoffset")
}, C.variant === "indeterminate" && {
  // Some default value that looks fine waiting for the animation to kicks in.
  strokeDasharray: "80px, 200px",
  strokeDashoffset: 0
  // Add the unit to fix a Edge 16 and below bug.
}), ({
  ownerState: C
}) => C.variant === "indeterminate" && !C.disableShrink && css(_t4$2 || (_t4$2 = _$2`
      animation: ${0} 1.4s ease-in-out infinite;
    `), circularDashKeyframe)), CircularProgress = /* @__PURE__ */ React$1.forwardRef(function(e, T) {
  const $ = useDefaultProps({
    props: e,
    name: "MuiCircularProgress"
  }), {
    className: V,
    color: J = "primary",
    disableShrink: ee = !1,
    size: te = 40,
    style: re,
    thickness: ie = 3.6,
    value: se = 0,
    variant: de = "indeterminate"
  } = $, ue = _objectWithoutPropertiesLoose($, _excluded$x), fe = _extends({}, $, {
    color: J,
    disableShrink: ee,
    size: te,
    thickness: ie,
    value: se,
    variant: de
  }), he = useUtilityClasses$t(fe), me = {}, xe = {}, ve = {};
  if (de === "determinate") {
    const Te = 2 * Math.PI * ((SIZE - ie) / 2);
    me.strokeDasharray = Te.toFixed(3), ve["aria-valuenow"] = Math.round(se), me.strokeDashoffset = `${((100 - se) / 100 * Te).toFixed(3)}px`, xe.transform = "rotate(-90deg)";
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsx(CircularProgressRoot, _extends({
    className: clsx(he.root, V),
    style: _extends({
      width: te,
      height: te
    }, xe, re),
    ownerState: fe,
    ref: T,
    role: "progressbar"
  }, ve, ue, {
    children: /* @__PURE__ */ jsxRuntimeExports.jsx(CircularProgressSVG, {
      className: he.svg,
      ownerState: fe,
      viewBox: `${SIZE / 2} ${SIZE / 2} ${SIZE} ${SIZE}`,
      children: /* @__PURE__ */ jsxRuntimeExports.jsx(CircularProgressCircle, {
        className: he.circle,
        style: me,
        ownerState: fe,
        cx: SIZE,
        cy: SIZE,
        r: (SIZE - ie) / 2,
        fill: "none",
        strokeWidth: ie
      })
    })
  }));
});
dist$2.process.env.NODE_ENV !== "production" && (CircularProgress.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'primary'
   */
  color: PropTypes.oneOfType([PropTypes.oneOf(["inherit", "primary", "secondary", "error", "info", "success", "warning"]), PropTypes.string]),
  /**
   * If `true`, the shrink animation is disabled.
   * This only works if variant is `indeterminate`.
   * @default false
   */
  disableShrink: chainPropTypes(PropTypes.bool, (C) => C.disableShrink && C.variant && C.variant !== "indeterminate" ? new Error("MUI: You have provided the `disableShrink` prop with a variant other than `indeterminate`. This will have no effect.") : null),
  /**
   * The size of the component.
   * If using a number, the pixel unit is assumed.
   * If using a string, you need to provide the CSS unit, for example '3rem'.
   * @default 40
   */
  size: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  /**
   * @ignore
   */
  style: PropTypes.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * The thickness of the circle.
   * @default 3.6
   */
  thickness: PropTypes.number,
  /**
   * The value of the progress indicator for the determinate variant.
   * Value between 0 and 100.
   * @default 0
   */
  value: PropTypes.number,
  /**
   * The variant to use.
   * Use indeterminate when there is no progress value.
   * @default 'indeterminate'
   */
  variant: PropTypes.oneOf(["determinate", "indeterminate"])
});
function isOverflowing(C) {
  const e = ownerDocument(C);
  return e.body === C ? ownerWindow(C).innerWidth > e.documentElement.clientWidth : C.scrollHeight > C.clientHeight;
}
function ariaHidden(C, e) {
  e ? C.setAttribute("aria-hidden", "true") : C.removeAttribute("aria-hidden");
}
function getPaddingRight(C) {
  return parseInt(ownerWindow(C).getComputedStyle(C).paddingRight, 10) || 0;
}
function isAriaHiddenForbiddenOnElement(C) {
  const T = ["TEMPLATE", "SCRIPT", "STYLE", "LINK", "MAP", "META", "NOSCRIPT", "PICTURE", "COL", "COLGROUP", "PARAM", "SLOT", "SOURCE", "TRACK"].indexOf(C.tagName) !== -1, $ = C.tagName === "INPUT" && C.getAttribute("type") === "hidden";
  return T || $;
}
function ariaHiddenSiblings(C, e, T, $, V) {
  const J = [e, T, ...$];
  [].forEach.call(C.children, (ee) => {
    const te = J.indexOf(ee) === -1, re = !isAriaHiddenForbiddenOnElement(ee);
    te && re && ariaHidden(ee, V);
  });
}
function findIndexOf(C, e) {
  let T = -1;
  return C.some(($, V) => e($) ? (T = V, !0) : !1), T;
}
function handleContainer(C, e) {
  const T = [], $ = C.container;
  if (!e.disableScrollLock) {
    if (isOverflowing($)) {
      const ee = getScrollbarSize(ownerDocument($));
      T.push({
        value: $.style.paddingRight,
        property: "padding-right",
        el: $
      }), $.style.paddingRight = `${getPaddingRight($) + ee}px`;
      const te = ownerDocument($).querySelectorAll(".mui-fixed");
      [].forEach.call(te, (re) => {
        T.push({
          value: re.style.paddingRight,
          property: "padding-right",
          el: re
        }), re.style.paddingRight = `${getPaddingRight(re) + ee}px`;
      });
    }
    let J;
    if ($.parentNode instanceof DocumentFragment)
      J = ownerDocument($).body;
    else {
      const ee = $.parentElement, te = ownerWindow($);
      J = (ee == null ? void 0 : ee.nodeName) === "HTML" && te.getComputedStyle(ee).overflowY === "scroll" ? ee : $;
    }
    T.push({
      value: J.style.overflow,
      property: "overflow",
      el: J
    }, {
      value: J.style.overflowX,
      property: "overflow-x",
      el: J
    }, {
      value: J.style.overflowY,
      property: "overflow-y",
      el: J
    }), J.style.overflow = "hidden";
  }
  return () => {
    T.forEach(({
      value: J,
      el: ee,
      property: te
    }) => {
      J ? ee.style.setProperty(te, J) : ee.style.removeProperty(te);
    });
  };
}
function getHiddenSiblings(C) {
  const e = [];
  return [].forEach.call(C.children, (T) => {
    T.getAttribute("aria-hidden") === "true" && e.push(T);
  }), e;
}
class ModalManager {
  constructor() {
    this.containers = void 0, this.modals = void 0, this.modals = [], this.containers = [];
  }
  add(e, T) {
    let $ = this.modals.indexOf(e);
    if ($ !== -1)
      return $;
    $ = this.modals.length, this.modals.push(e), e.modalRef && ariaHidden(e.modalRef, !1);
    const V = getHiddenSiblings(T);
    ariaHiddenSiblings(T, e.mount, e.modalRef, V, !0);
    const J = findIndexOf(this.containers, (ee) => ee.container === T);
    return J !== -1 ? (this.containers[J].modals.push(e), $) : (this.containers.push({
      modals: [e],
      container: T,
      restore: null,
      hiddenSiblings: V
    }), $);
  }
  mount(e, T) {
    const $ = findIndexOf(this.containers, (J) => J.modals.indexOf(e) !== -1), V = this.containers[$];
    V.restore || (V.restore = handleContainer(V, T));
  }
  remove(e, T = !0) {
    const $ = this.modals.indexOf(e);
    if ($ === -1)
      return $;
    const V = findIndexOf(this.containers, (ee) => ee.modals.indexOf(e) !== -1), J = this.containers[V];
    if (J.modals.splice(J.modals.indexOf(e), 1), this.modals.splice($, 1), J.modals.length === 0)
      J.restore && J.restore(), e.modalRef && ariaHidden(e.modalRef, T), ariaHiddenSiblings(J.container, e.mount, e.modalRef, J.hiddenSiblings, !1), this.containers.splice(V, 1);
    else {
      const ee = J.modals[J.modals.length - 1];
      ee.modalRef && ariaHidden(ee.modalRef, !1);
    }
    return $;
  }
  isTopModal(e) {
    return this.modals.length > 0 && this.modals[this.modals.length - 1] === e;
  }
}
const candidatesSelector = ["input", "select", "textarea", "a[href]", "button", "[tabindex]", "audio[controls]", "video[controls]", '[contenteditable]:not([contenteditable="false"])'].join(",");
function getTabIndex(C) {
  const e = parseInt(C.getAttribute("tabindex") || "", 10);
  return Number.isNaN(e) ? C.contentEditable === "true" || (C.nodeName === "AUDIO" || C.nodeName === "VIDEO" || C.nodeName === "DETAILS") && C.getAttribute("tabindex") === null ? 0 : C.tabIndex : e;
}
function isNonTabbableRadio(C) {
  if (C.tagName !== "INPUT" || C.type !== "radio" || !C.name)
    return !1;
  const e = ($) => C.ownerDocument.querySelector(`input[type="radio"]${$}`);
  let T = e(`[name="${C.name}"]:checked`);
  return T || (T = e(`[name="${C.name}"]`)), T !== C;
}
function isNodeMatchingSelectorFocusable(C) {
  return !(C.disabled || C.tagName === "INPUT" && C.type === "hidden" || isNonTabbableRadio(C));
}
function defaultGetTabbable(C) {
  const e = [], T = [];
  return Array.from(C.querySelectorAll(candidatesSelector)).forEach(($, V) => {
    const J = getTabIndex($);
    J === -1 || !isNodeMatchingSelectorFocusable($) || (J === 0 ? e.push($) : T.push({
      documentOrder: V,
      tabIndex: J,
      node: $
    }));
  }), T.sort(($, V) => $.tabIndex === V.tabIndex ? $.documentOrder - V.documentOrder : $.tabIndex - V.tabIndex).map(($) => $.node).concat(e);
}
function defaultIsEnabled() {
  return !0;
}
function FocusTrap(C) {
  const {
    children: e,
    disableAutoFocus: T = !1,
    disableEnforceFocus: $ = !1,
    disableRestoreFocus: V = !1,
    getTabbable: J = defaultGetTabbable,
    isEnabled: ee = defaultIsEnabled,
    open: te
  } = C, re = React$1.useRef(!1), ie = React$1.useRef(null), se = React$1.useRef(null), de = React$1.useRef(null), ue = React$1.useRef(null), fe = React$1.useRef(!1), he = React$1.useRef(null), me = useForkRef(getReactElementRef(e), he), xe = React$1.useRef(null);
  React$1.useEffect(() => {
    !te || !he.current || (fe.current = !T);
  }, [T, te]), React$1.useEffect(() => {
    if (!te || !he.current)
      return;
    const we = ownerDocument(he.current);
    return he.current.contains(we.activeElement) || (he.current.hasAttribute("tabIndex") || (dist$2.process.env.NODE_ENV !== "production" && console.error(["MUI: The modal content node does not accept focus.", 'For the benefit of assistive technologies, the tabIndex of the node is being set to "-1".'].join(`
`)), he.current.setAttribute("tabIndex", "-1")), fe.current && he.current.focus()), () => {
      V || (de.current && de.current.focus && (re.current = !0, de.current.focus()), de.current = null);
    };
  }, [te]), React$1.useEffect(() => {
    if (!te || !he.current)
      return;
    const we = ownerDocument(he.current), Ee = (ke) => {
      xe.current = ke, !($ || !ee() || ke.key !== "Tab") && we.activeElement === he.current && ke.shiftKey && (re.current = !0, se.current && se.current.focus());
    }, Me = () => {
      const ke = he.current;
      if (ke === null)
        return;
      if (!we.hasFocus() || !ee() || re.current) {
        re.current = !1;
        return;
      }
      if (ke.contains(we.activeElement) || $ && we.activeElement !== ie.current && we.activeElement !== se.current)
        return;
      if (we.activeElement !== ue.current)
        ue.current = null;
      else if (ue.current !== null)
        return;
      if (!fe.current)
        return;
      let _e = [];
      if ((we.activeElement === ie.current || we.activeElement === se.current) && (_e = J(he.current)), _e.length > 0) {
        var De, Fe;
        const Ae = !!((De = xe.current) != null && De.shiftKey && ((Fe = xe.current) == null ? void 0 : Fe.key) === "Tab"), ne = _e[0], oe = _e[_e.length - 1];
        typeof ne != "string" && typeof oe != "string" && (Ae ? oe.focus() : ne.focus());
      } else
        ke.focus();
    };
    we.addEventListener("focusin", Me), we.addEventListener("keydown", Ee, !0);
    const Ie = setInterval(() => {
      we.activeElement && we.activeElement.tagName === "BODY" && Me();
    }, 50);
    return () => {
      clearInterval(Ie), we.removeEventListener("focusin", Me), we.removeEventListener("keydown", Ee, !0);
    };
  }, [T, $, V, ee, te, J]);
  const ve = (we) => {
    de.current === null && (de.current = we.relatedTarget), fe.current = !0, ue.current = we.target;
    const Ee = e.props.onFocus;
    Ee && Ee(we);
  }, Te = (we) => {
    de.current === null && (de.current = we.relatedTarget), fe.current = !0;
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(React$1.Fragment, {
    children: [/* @__PURE__ */ jsxRuntimeExports.jsx("div", {
      tabIndex: te ? 0 : -1,
      onFocus: Te,
      ref: ie,
      "data-testid": "sentinelStart"
    }), /* @__PURE__ */ React$1.cloneElement(e, {
      ref: me,
      onFocus: ve
    }), /* @__PURE__ */ jsxRuntimeExports.jsx("div", {
      tabIndex: te ? 0 : -1,
      onFocus: Te,
      ref: se,
      "data-testid": "sentinelEnd"
    })]
  });
}
dist$2.process.env.NODE_ENV !== "production" && (FocusTrap.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * A single child content element.
   */
  children: elementAcceptingRef,
  /**
   * If `true`, the focus trap will not automatically shift focus to itself when it opens, and
   * replace it to the last focused element when it closes.
   * This also works correctly with any focus trap children that have the `disableAutoFocus` prop.
   *
   * Generally this should never be set to `true` as it makes the focus trap less
   * accessible to assistive technologies, like screen readers.
   * @default false
   */
  disableAutoFocus: PropTypes.bool,
  /**
   * If `true`, the focus trap will not prevent focus from leaving the focus trap while open.
   *
   * Generally this should never be set to `true` as it makes the focus trap less
   * accessible to assistive technologies, like screen readers.
   * @default false
   */
  disableEnforceFocus: PropTypes.bool,
  /**
   * If `true`, the focus trap will not restore focus to previously focused element once
   * focus trap is hidden or unmounted.
   * @default false
   */
  disableRestoreFocus: PropTypes.bool,
  /**
   * Returns an array of ordered tabbable nodes (i.e. in tab order) within the root.
   * For instance, you can provide the "tabbable" npm dependency.
   * @param {HTMLElement} root
   */
  getTabbable: PropTypes.func,
  /**
   * This prop extends the `open` prop.
   * It allows to toggle the open state without having to wait for a rerender when changing the `open` prop.
   * This prop should be memoized.
   * It can be used to support multiple focus trap mounted at the same time.
   * @default function defaultIsEnabled(): boolean {
   *   return true;
   * }
   */
  isEnabled: PropTypes.func,
  /**
   * If `true`, focus is locked.
   */
  open: PropTypes.bool.isRequired
});
dist$2.process.env.NODE_ENV !== "production" && (FocusTrap.propTypes = exactProp(FocusTrap.propTypes));
function getContainer(C) {
  return typeof C == "function" ? C() : C;
}
function getHasTransition(C) {
  return C ? C.props.hasOwnProperty("in") : !1;
}
const defaultManager = new ModalManager();
function useModal(C) {
  const {
    container: e,
    disableEscapeKeyDown: T = !1,
    disableScrollLock: $ = !1,
    // @ts-ignore internal logic - Base UI supports the manager as a prop too
    manager: V = defaultManager,
    closeAfterTransition: J = !1,
    onTransitionEnter: ee,
    onTransitionExited: te,
    children: re,
    onClose: ie,
    open: se,
    rootRef: de
  } = C, ue = React$1.useRef({}), fe = React$1.useRef(null), he = React$1.useRef(null), me = useForkRef(he, de), [xe, ve] = React$1.useState(!se), Te = getHasTransition(re);
  let we = !0;
  (C["aria-hidden"] === "false" || C["aria-hidden"] === !1) && (we = !1);
  const Ee = () => ownerDocument(fe.current), Me = () => (ue.current.modalRef = he.current, ue.current.mount = fe.current, ue.current), Ie = () => {
    V.mount(Me(), {
      disableScrollLock: $
    }), he.current && (he.current.scrollTop = 0);
  }, ke = useEventCallback(() => {
    const pe = getContainer(e) || Ee().body;
    V.add(Me(), pe), he.current && Ie();
  }), _e = React$1.useCallback(() => V.isTopModal(Me()), [V]), De = useEventCallback((pe) => {
    fe.current = pe, pe && (se && _e() ? Ie() : he.current && ariaHidden(he.current, we));
  }), Fe = React$1.useCallback(() => {
    V.remove(Me(), we);
  }, [we, V]);
  React$1.useEffect(() => () => {
    Fe();
  }, [Fe]), React$1.useEffect(() => {
    se ? ke() : (!Te || !J) && Fe();
  }, [se, Fe, Te, J, ke]);
  const Ae = (pe) => (ye) => {
    var Ce;
    (Ce = pe.onKeyDown) == null || Ce.call(pe, ye), !(ye.key !== "Escape" || ye.which === 229 || // Wait until IME is settled.
    !_e()) && (T || (ye.stopPropagation(), ie && ie(ye, "escapeKeyDown")));
  }, ne = (pe) => (ye) => {
    var Ce;
    (Ce = pe.onClick) == null || Ce.call(pe, ye), ye.target === ye.currentTarget && ie && ie(ye, "backdropClick");
  };
  return {
    getRootProps: (pe = {}) => {
      const ye = extractEventHandlers(C);
      delete ye.onTransitionEnter, delete ye.onTransitionExited;
      const Ce = _extends({}, ye, pe);
      return _extends({
        role: "presentation"
      }, Ce, {
        onKeyDown: Ae(Ce),
        ref: me
      });
    },
    getBackdropProps: (pe = {}) => {
      const ye = pe;
      return _extends({
        "aria-hidden": !0
      }, ye, {
        onClick: ne(ye),
        open: se
      });
    },
    getTransitionProps: () => {
      const pe = () => {
        ve(!1), ee && ee();
      }, ye = () => {
        ve(!0), te && te(), J && Fe();
      };
      return {
        onEnter: createChainedFunction(pe, re == null ? void 0 : re.props.onEnter),
        onExited: createChainedFunction(ye, re == null ? void 0 : re.props.onExited)
      };
    },
    rootRef: me,
    portalRef: De,
    isTopModal: _e,
    exited: xe,
    hasTransition: Te
  };
}
function getModalUtilityClass(C) {
  return generateUtilityClass("MuiModal", C);
}
generateUtilityClasses("MuiModal", ["root", "hidden", "backdrop"]);
const _excluded$w = ["BackdropComponent", "BackdropProps", "classes", "className", "closeAfterTransition", "children", "container", "component", "components", "componentsProps", "disableAutoFocus", "disableEnforceFocus", "disableEscapeKeyDown", "disablePortal", "disableRestoreFocus", "disableScrollLock", "hideBackdrop", "keepMounted", "onBackdropClick", "onClose", "onTransitionEnter", "onTransitionExited", "open", "slotProps", "slots", "theme"], useUtilityClasses$s = (C) => {
  const {
    open: e,
    exited: T,
    classes: $
  } = C;
  return composeClasses({
    root: ["root", !e && T && "hidden"],
    backdrop: ["backdrop"]
  }, getModalUtilityClass, $);
}, ModalRoot = styled$1("div", {
  name: "MuiModal",
  slot: "Root",
  overridesResolver: (C, e) => {
    const {
      ownerState: T
    } = C;
    return [e.root, !T.open && T.exited && e.hidden];
  }
})(({
  theme: C,
  ownerState: e
}) => _extends({
  position: "fixed",
  zIndex: (C.vars || C).zIndex.modal,
  right: 0,
  bottom: 0,
  top: 0,
  left: 0
}, !e.open && e.exited && {
  visibility: "hidden"
})), ModalBackdrop = styled$1(Backdrop, {
  name: "MuiModal",
  slot: "Backdrop",
  overridesResolver: (C, e) => e.backdrop
})({
  zIndex: -1
}), Modal = /* @__PURE__ */ React$1.forwardRef(function(e, T) {
  var $, V, J, ee, te, re;
  const ie = useDefaultProps({
    name: "MuiModal",
    props: e
  }), {
    BackdropComponent: se = ModalBackdrop,
    BackdropProps: de,
    className: ue,
    closeAfterTransition: fe = !1,
    children: he,
    container: me,
    component: xe,
    components: ve = {},
    componentsProps: Te = {},
    disableAutoFocus: we = !1,
    disableEnforceFocus: Ee = !1,
    disableEscapeKeyDown: Me = !1,
    disablePortal: Ie = !1,
    disableRestoreFocus: ke = !1,
    disableScrollLock: _e = !1,
    hideBackdrop: De = !1,
    keepMounted: Fe = !1,
    onBackdropClick: Ae,
    open: ne,
    slotProps: oe,
    slots: ce
    // eslint-disable-next-line react/prop-types
  } = ie, le = _objectWithoutPropertiesLoose(ie, _excluded$w), pe = _extends({}, ie, {
    closeAfterTransition: fe,
    disableAutoFocus: we,
    disableEnforceFocus: Ee,
    disableEscapeKeyDown: Me,
    disablePortal: Ie,
    disableRestoreFocus: ke,
    disableScrollLock: _e,
    hideBackdrop: De,
    keepMounted: Fe
  }), {
    getRootProps: ye,
    getBackdropProps: Ce,
    getTransitionProps: be,
    portalRef: ae,
    isTopModal: ge,
    exited: Se,
    hasTransition: Le
  } = useModal(_extends({}, pe, {
    rootRef: T
  })), ze = _extends({}, pe, {
    exited: Se
  }), Re = useUtilityClasses$s(ze), We = {};
  if (he.props.tabIndex === void 0 && (We.tabIndex = "-1"), Le) {
    const {
      onEnter: Ye,
      onExited: Je
    } = be();
    We.onEnter = Ye, We.onExited = Je;
  }
  const Be = ($ = (V = ce == null ? void 0 : ce.root) != null ? V : ve.Root) != null ? $ : ModalRoot, Ue = (J = (ee = ce == null ? void 0 : ce.backdrop) != null ? ee : ve.Backdrop) != null ? J : se, Ge = (te = oe == null ? void 0 : oe.root) != null ? te : Te.root, je = (re = oe == null ? void 0 : oe.backdrop) != null ? re : Te.backdrop, Oe = useSlotProps({
    elementType: Be,
    externalSlotProps: Ge,
    externalForwardedProps: le,
    getSlotProps: ye,
    additionalProps: {
      ref: T,
      as: xe
    },
    ownerState: ze,
    className: clsx(ue, Ge == null ? void 0 : Ge.className, Re == null ? void 0 : Re.root, !ze.open && ze.exited && (Re == null ? void 0 : Re.hidden))
  }), Ne = useSlotProps({
    elementType: Ue,
    externalSlotProps: je,
    additionalProps: de,
    getSlotProps: (Ye) => Ce(_extends({}, Ye, {
      onClick: (Je) => {
        Ae && Ae(Je), Ye != null && Ye.onClick && Ye.onClick(Je);
      }
    })),
    className: clsx(je == null ? void 0 : je.className, de == null ? void 0 : de.className, Re == null ? void 0 : Re.backdrop),
    ownerState: ze
  });
  return !Fe && !ne && (!Le || Se) ? null : /* @__PURE__ */ jsxRuntimeExports.jsx(Portal, {
    ref: ae,
    container: me,
    disablePortal: Ie,
    children: /* @__PURE__ */ jsxRuntimeExports.jsxs(Be, _extends({}, Oe, {
      children: [!De && se ? /* @__PURE__ */ jsxRuntimeExports.jsx(Ue, _extends({}, Ne)) : null, /* @__PURE__ */ jsxRuntimeExports.jsx(FocusTrap, {
        disableEnforceFocus: Ee,
        disableAutoFocus: we,
        disableRestoreFocus: ke,
        isEnabled: ge,
        open: ne,
        children: /* @__PURE__ */ React$1.cloneElement(he, We)
      })]
    }))
  });
});
dist$2.process.env.NODE_ENV !== "production" && (Modal.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * A backdrop component. This prop enables custom backdrop rendering.
   * @deprecated Use `slots.backdrop` instead. While this prop currently works, it will be removed in the next major version.
   * Use the `slots.backdrop` prop to make your application ready for the next version of Material UI.
   * @default styled(Backdrop, {
   *   name: 'MuiModal',
   *   slot: 'Backdrop',
   *   overridesResolver: (props, styles) => {
   *     return styles.backdrop;
   *   },
   * })({
   *   zIndex: -1,
   * })
   */
  BackdropComponent: PropTypes.elementType,
  /**
   * Props applied to the [`Backdrop`](/material-ui/api/backdrop/) element.
   * @deprecated Use `slotProps.backdrop` instead.
   */
  BackdropProps: PropTypes.object,
  /**
   * A single child content element.
   */
  children: elementAcceptingRef.isRequired,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * When set to true the Modal waits until a nested Transition is completed before closing.
   * @default false
   */
  closeAfterTransition: PropTypes.bool,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes.elementType,
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `slots` prop.
   * It's recommended to use the `slots` prop instead.
   *
   * @default {}
   */
  components: PropTypes.shape({
    Backdrop: PropTypes.elementType,
    Root: PropTypes.elementType
  }),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * This prop is an alias for the `slotProps` prop.
   * It's recommended to use the `slotProps` prop instead, as `componentsProps` will be deprecated in the future.
   *
   * @default {}
   */
  componentsProps: PropTypes.shape({
    backdrop: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
    root: PropTypes.oneOfType([PropTypes.func, PropTypes.object])
  }),
  /**
   * An HTML element or function that returns one.
   * The `container` will have the portal children appended to it.
   *
   * You can also provide a callback, which is called in a React layout effect.
   * This lets you set the container from a ref, and also makes server-side rendering possible.
   *
   * By default, it uses the body of the top-level document object,
   * so it's simply `document.body` most of the time.
   */
  container: PropTypes.oneOfType([HTMLElementType, PropTypes.func]),
  /**
   * If `true`, the modal will not automatically shift focus to itself when it opens, and
   * replace it to the last focused element when it closes.
   * This also works correctly with any modal children that have the `disableAutoFocus` prop.
   *
   * Generally this should never be set to `true` as it makes the modal less
   * accessible to assistive technologies, like screen readers.
   * @default false
   */
  disableAutoFocus: PropTypes.bool,
  /**
   * If `true`, the modal will not prevent focus from leaving the modal while open.
   *
   * Generally this should never be set to `true` as it makes the modal less
   * accessible to assistive technologies, like screen readers.
   * @default false
   */
  disableEnforceFocus: PropTypes.bool,
  /**
   * If `true`, hitting escape will not fire the `onClose` callback.
   * @default false
   */
  disableEscapeKeyDown: PropTypes.bool,
  /**
   * The `children` will be under the DOM hierarchy of the parent component.
   * @default false
   */
  disablePortal: PropTypes.bool,
  /**
   * If `true`, the modal will not restore focus to previously focused element once
   * modal is hidden or unmounted.
   * @default false
   */
  disableRestoreFocus: PropTypes.bool,
  /**
   * Disable the scroll lock behavior.
   * @default false
   */
  disableScrollLock: PropTypes.bool,
  /**
   * If `true`, the backdrop is not rendered.
   * @default false
   */
  hideBackdrop: PropTypes.bool,
  /**
   * Always keep the children in the DOM.
   * This prop can be useful in SEO situation or
   * when you want to maximize the responsiveness of the Modal.
   * @default false
   */
  keepMounted: PropTypes.bool,
  /**
   * Callback fired when the backdrop is clicked.
   * @deprecated Use the `onClose` prop with the `reason` argument to handle the `backdropClick` events.
   */
  onBackdropClick: PropTypes.func,
  /**
   * Callback fired when the component requests to be closed.
   * The `reason` parameter can optionally be used to control the response to `onClose`.
   *
   * @param {object} event The event source of the callback.
   * @param {string} reason Can be: `"escapeKeyDown"`, `"backdropClick"`.
   */
  onClose: PropTypes.func,
  /**
   * A function called when a transition enters.
   */
  onTransitionEnter: PropTypes.func,
  /**
   * A function called when a transition has exited.
   */
  onTransitionExited: PropTypes.func,
  /**
   * If `true`, the component is shown.
   */
  open: PropTypes.bool.isRequired,
  /**
   * The props used for each slot inside the Modal.
   * @default {}
   */
  slotProps: PropTypes.shape({
    backdrop: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
    root: PropTypes.oneOfType([PropTypes.func, PropTypes.object])
  }),
  /**
   * The components used for each slot inside the Modal.
   * Either a string to use a HTML element or a component.
   * @default {}
   */
  slots: PropTypes.shape({
    backdrop: PropTypes.elementType,
    root: PropTypes.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object])
});
function getDividerUtilityClass(C) {
  return generateUtilityClass("MuiDivider", C);
}
const dividerClasses = generateUtilityClasses("MuiDivider", ["root", "absolute", "fullWidth", "inset", "middle", "flexItem", "light", "vertical", "withChildren", "withChildrenVertical", "textAlignRight", "textAlignLeft", "wrapper", "wrapperVertical"]), _excluded$v = ["absolute", "children", "className", "component", "flexItem", "light", "orientation", "role", "textAlign", "variant"], useUtilityClasses$r = (C) => {
  const {
    absolute: e,
    children: T,
    classes: $,
    flexItem: V,
    light: J,
    orientation: ee,
    textAlign: te,
    variant: re
  } = C;
  return composeClasses({
    root: ["root", e && "absolute", re, J && "light", ee === "vertical" && "vertical", V && "flexItem", T && "withChildren", T && ee === "vertical" && "withChildrenVertical", te === "right" && ee !== "vertical" && "textAlignRight", te === "left" && ee !== "vertical" && "textAlignLeft"],
    wrapper: ["wrapper", ee === "vertical" && "wrapperVertical"]
  }, getDividerUtilityClass, $);
}, DividerRoot = styled$1("div", {
  name: "MuiDivider",
  slot: "Root",
  overridesResolver: (C, e) => {
    const {
      ownerState: T
    } = C;
    return [e.root, T.absolute && e.absolute, e[T.variant], T.light && e.light, T.orientation === "vertical" && e.vertical, T.flexItem && e.flexItem, T.children && e.withChildren, T.children && T.orientation === "vertical" && e.withChildrenVertical, T.textAlign === "right" && T.orientation !== "vertical" && e.textAlignRight, T.textAlign === "left" && T.orientation !== "vertical" && e.textAlignLeft];
  }
})(({
  theme: C,
  ownerState: e
}) => _extends({
  margin: 0,
  // Reset browser default style.
  flexShrink: 0,
  borderWidth: 0,
  borderStyle: "solid",
  borderColor: (C.vars || C).palette.divider,
  borderBottomWidth: "thin"
}, e.absolute && {
  position: "absolute",
  bottom: 0,
  left: 0,
  width: "100%"
}, e.light && {
  borderColor: C.vars ? `rgba(${C.vars.palette.dividerChannel} / 0.08)` : alpha_1(C.palette.divider, 0.08)
}, e.variant === "inset" && {
  marginLeft: 72
}, e.variant === "middle" && e.orientation === "horizontal" && {
  marginLeft: C.spacing(2),
  marginRight: C.spacing(2)
}, e.variant === "middle" && e.orientation === "vertical" && {
  marginTop: C.spacing(1),
  marginBottom: C.spacing(1)
}, e.orientation === "vertical" && {
  height: "100%",
  borderBottomWidth: 0,
  borderRightWidth: "thin"
}, e.flexItem && {
  alignSelf: "stretch",
  height: "auto"
}), ({
  ownerState: C
}) => _extends({}, C.children && {
  display: "flex",
  whiteSpace: "nowrap",
  textAlign: "center",
  border: 0,
  borderTopStyle: "solid",
  borderLeftStyle: "solid",
  "&::before, &::after": {
    content: '""',
    alignSelf: "center"
  }
}), ({
  theme: C,
  ownerState: e
}) => _extends({}, e.children && e.orientation !== "vertical" && {
  "&::before, &::after": {
    width: "100%",
    borderTop: `thin solid ${(C.vars || C).palette.divider}`,
    borderTopStyle: "inherit"
  }
}), ({
  theme: C,
  ownerState: e
}) => _extends({}, e.children && e.orientation === "vertical" && {
  flexDirection: "column",
  "&::before, &::after": {
    height: "100%",
    borderLeft: `thin solid ${(C.vars || C).palette.divider}`,
    borderLeftStyle: "inherit"
  }
}), ({
  ownerState: C
}) => _extends({}, C.textAlign === "right" && C.orientation !== "vertical" && {
  "&::before": {
    width: "90%"
  },
  "&::after": {
    width: "10%"
  }
}, C.textAlign === "left" && C.orientation !== "vertical" && {
  "&::before": {
    width: "10%"
  },
  "&::after": {
    width: "90%"
  }
})), DividerWrapper = styled$1("span", {
  name: "MuiDivider",
  slot: "Wrapper",
  overridesResolver: (C, e) => {
    const {
      ownerState: T
    } = C;
    return [e.wrapper, T.orientation === "vertical" && e.wrapperVertical];
  }
})(({
  theme: C,
  ownerState: e
}) => _extends({
  display: "inline-block",
  paddingLeft: `calc(${C.spacing(1)} * 1.2)`,
  paddingRight: `calc(${C.spacing(1)} * 1.2)`
}, e.orientation === "vertical" && {
  paddingTop: `calc(${C.spacing(1)} * 1.2)`,
  paddingBottom: `calc(${C.spacing(1)} * 1.2)`
})), Divider = /* @__PURE__ */ React$1.forwardRef(function(e, T) {
  const $ = useDefaultProps({
    props: e,
    name: "MuiDivider"
  }), {
    absolute: V = !1,
    children: J,
    className: ee,
    component: te = J ? "div" : "hr",
    flexItem: re = !1,
    light: ie = !1,
    orientation: se = "horizontal",
    role: de = te !== "hr" ? "separator" : void 0,
    textAlign: ue = "center",
    variant: fe = "fullWidth"
  } = $, he = _objectWithoutPropertiesLoose($, _excluded$v), me = _extends({}, $, {
    absolute: V,
    component: te,
    flexItem: re,
    light: ie,
    orientation: se,
    role: de,
    textAlign: ue,
    variant: fe
  }), xe = useUtilityClasses$r(me);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(DividerRoot, _extends({
    as: te,
    className: clsx(xe.root, ee),
    role: de,
    ref: T,
    ownerState: me
  }, he, {
    children: J ? /* @__PURE__ */ jsxRuntimeExports.jsx(DividerWrapper, {
      className: xe.wrapper,
      ownerState: me,
      children: J
    }) : null
  }));
});
Divider.muiSkipListHighlight = !0;
dist$2.process.env.NODE_ENV !== "production" && (Divider.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Absolutely position the element.
   * @default false
   */
  absolute: PropTypes.bool,
  /**
   * The content of the component.
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes.elementType,
  /**
   * If `true`, a vertical divider will have the correct height when used in flex container.
   * (By default, a vertical divider will have a calculated height of `0px` if it is the child of a flex container.)
   * @default false
   */
  flexItem: PropTypes.bool,
  /**
   * If `true`, the divider will have a lighter color.
   * @default false
   * @deprecated Use <Divider sx={{ opacity: 0.6 }} /> (or any opacity or color) instead. [How to migrate](/material-ui/migration/migrating-from-deprecated-apis/)
   */
  light: PropTypes.bool,
  /**
   * The component orientation.
   * @default 'horizontal'
   */
  orientation: PropTypes.oneOf(["horizontal", "vertical"]),
  /**
   * @ignore
   */
  role: PropTypes.string,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * The text alignment.
   * @default 'center'
   */
  textAlign: PropTypes.oneOf(["center", "left", "right"]),
  /**
   * The variant to use.
   * @default 'fullWidth'
   */
  variant: PropTypes.oneOfType([PropTypes.oneOf(["fullWidth", "inset", "middle"]), PropTypes.string])
});
const _excluded$u = ["addEndListener", "appear", "children", "container", "direction", "easing", "in", "onEnter", "onEntered", "onEntering", "onExit", "onExited", "onExiting", "style", "timeout", "TransitionComponent"];
function getTranslateValue(C, e, T) {
  const $ = e.getBoundingClientRect(), V = T && T.getBoundingClientRect(), J = ownerWindow(e);
  let ee;
  if (e.fakeTransform)
    ee = e.fakeTransform;
  else {
    const ie = J.getComputedStyle(e);
    ee = ie.getPropertyValue("-webkit-transform") || ie.getPropertyValue("transform");
  }
  let te = 0, re = 0;
  if (ee && ee !== "none" && typeof ee == "string") {
    const ie = ee.split("(")[1].split(")")[0].split(",");
    te = parseInt(ie[4], 10), re = parseInt(ie[5], 10);
  }
  return C === "left" ? V ? `translateX(${V.right + te - $.left}px)` : `translateX(${J.innerWidth + te - $.left}px)` : C === "right" ? V ? `translateX(-${$.right - V.left - te}px)` : `translateX(-${$.left + $.width - te}px)` : C === "up" ? V ? `translateY(${V.bottom + re - $.top}px)` : `translateY(${J.innerHeight + re - $.top}px)` : V ? `translateY(-${$.top - V.top + $.height - re}px)` : `translateY(-${$.top + $.height - re}px)`;
}
function resolveContainer(C) {
  return typeof C == "function" ? C() : C;
}
function setTranslateValue(C, e, T) {
  const $ = resolveContainer(T), V = getTranslateValue(C, e, $);
  V && (e.style.webkitTransform = V, e.style.transform = V);
}
const Slide = /* @__PURE__ */ React$1.forwardRef(function(e, T) {
  const $ = useTheme$1(), V = {
    enter: $.transitions.easing.easeOut,
    exit: $.transitions.easing.sharp
  }, J = {
    enter: $.transitions.duration.enteringScreen,
    exit: $.transitions.duration.leavingScreen
  }, {
    addEndListener: ee,
    appear: te = !0,
    children: re,
    container: ie,
    direction: se = "down",
    easing: de = V,
    in: ue,
    onEnter: fe,
    onEntered: he,
    onEntering: me,
    onExit: xe,
    onExited: ve,
    onExiting: Te,
    style: we,
    timeout: Ee = J,
    // eslint-disable-next-line react/prop-types
    TransitionComponent: Me = Transition
  } = e, Ie = _objectWithoutPropertiesLoose(e, _excluded$u), ke = React$1.useRef(null), _e = useForkRef(getReactElementRef(re), ke, T), De = (Ce) => (be) => {
    Ce && (be === void 0 ? Ce(ke.current) : Ce(ke.current, be));
  }, Fe = De((Ce, be) => {
    setTranslateValue(se, Ce, ie), reflow(Ce), fe && fe(Ce, be);
  }), Ae = De((Ce, be) => {
    const ae = getTransitionProps({
      timeout: Ee,
      style: we,
      easing: de
    }, {
      mode: "enter"
    });
    Ce.style.webkitTransition = $.transitions.create("-webkit-transform", _extends({}, ae)), Ce.style.transition = $.transitions.create("transform", _extends({}, ae)), Ce.style.webkitTransform = "none", Ce.style.transform = "none", me && me(Ce, be);
  }), ne = De(he), oe = De(Te), ce = De((Ce) => {
    const be = getTransitionProps({
      timeout: Ee,
      style: we,
      easing: de
    }, {
      mode: "exit"
    });
    Ce.style.webkitTransition = $.transitions.create("-webkit-transform", be), Ce.style.transition = $.transitions.create("transform", be), setTranslateValue(se, Ce, ie), xe && xe(Ce);
  }), le = De((Ce) => {
    Ce.style.webkitTransition = "", Ce.style.transition = "", ve && ve(Ce);
  }), pe = (Ce) => {
    ee && ee(ke.current, Ce);
  }, ye = React$1.useCallback(() => {
    ke.current && setTranslateValue(se, ke.current, ie);
  }, [se, ie]);
  return React$1.useEffect(() => {
    if (ue || se === "down" || se === "right")
      return;
    const Ce = debounce$1(() => {
      ke.current && setTranslateValue(se, ke.current, ie);
    }), be = ownerWindow(ke.current);
    return be.addEventListener("resize", Ce), () => {
      Ce.clear(), be.removeEventListener("resize", Ce);
    };
  }, [se, ue, ie]), React$1.useEffect(() => {
    ue || ye();
  }, [ue, ye]), /* @__PURE__ */ jsxRuntimeExports.jsx(Me, _extends({
    nodeRef: ke,
    onEnter: Fe,
    onEntered: ne,
    onEntering: Ae,
    onExit: ce,
    onExited: le,
    onExiting: oe,
    addEndListener: pe,
    appear: te,
    in: ue,
    timeout: Ee
  }, Ie, {
    children: (Ce, be) => /* @__PURE__ */ React$1.cloneElement(re, _extends({
      ref: _e,
      style: _extends({
        visibility: Ce === "exited" && !ue ? "hidden" : void 0
      }, we, re.props.style)
    }, be))
  }));
});
dist$2.process.env.NODE_ENV !== "production" && (Slide.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Add a custom transition end trigger. Called with the transitioning DOM
   * node and a done callback. Allows for more fine grained transition end
   * logic. Note: Timeouts are still used as a fallback if provided.
   */
  addEndListener: PropTypes.func,
  /**
   * Perform the enter transition when it first mounts if `in` is also `true`.
   * Set this to `false` to disable this behavior.
   * @default true
   */
  appear: PropTypes.bool,
  /**
   * A single child content element.
   */
  children: elementAcceptingRef.isRequired,
  /**
   * An HTML element, or a function that returns one.
   * It's used to set the container the Slide is transitioning from.
   */
  container: chainPropTypes(PropTypes.oneOfType([HTMLElementType, PropTypes.func]), (C) => {
    if (C.open) {
      const e = resolveContainer(C.container);
      if (e && e.nodeType === 1) {
        const T = e.getBoundingClientRect();
        if (dist$2.process.env.NODE_ENV !== "test" && T.top === 0 && T.left === 0 && T.right === 0 && T.bottom === 0)
          return new Error(["MUI: The `container` prop provided to the component is invalid.", "The anchor element should be part of the document layout.", "Make sure the element is present in the document or that it's not display none."].join(`
`));
      } else if (!e || typeof e.getBoundingClientRect != "function" || e.contextElement != null && e.contextElement.nodeType !== 1)
        return new Error(["MUI: The `container` prop provided to the component is invalid.", "It should be an HTML element instance."].join(`
`));
    }
    return null;
  }),
  /**
   * Direction the child node will enter from.
   * @default 'down'
   */
  direction: PropTypes.oneOf(["down", "left", "right", "up"]),
  /**
   * The transition timing function.
   * You may specify a single easing or a object containing enter and exit values.
   * @default {
   *   enter: theme.transitions.easing.easeOut,
   *   exit: theme.transitions.easing.sharp,
   * }
   */
  easing: PropTypes.oneOfType([PropTypes.shape({
    enter: PropTypes.string,
    exit: PropTypes.string
  }), PropTypes.string]),
  /**
   * If `true`, the component will transition in.
   */
  in: PropTypes.bool,
  /**
   * @ignore
   */
  onEnter: PropTypes.func,
  /**
   * @ignore
   */
  onEntered: PropTypes.func,
  /**
   * @ignore
   */
  onEntering: PropTypes.func,
  /**
   * @ignore
   */
  onExit: PropTypes.func,
  /**
   * @ignore
   */
  onExited: PropTypes.func,
  /**
   * @ignore
   */
  onExiting: PropTypes.func,
  /**
   * @ignore
   */
  style: PropTypes.object,
  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   * @default {
   *   enter: theme.transitions.duration.enteringScreen,
   *   exit: theme.transitions.duration.leavingScreen,
   * }
   */
  timeout: PropTypes.oneOfType([PropTypes.number, PropTypes.shape({
    appear: PropTypes.number,
    enter: PropTypes.number,
    exit: PropTypes.number
  })])
});
function getDrawerUtilityClass(C) {
  return generateUtilityClass("MuiDrawer", C);
}
generateUtilityClasses("MuiDrawer", ["root", "docked", "paper", "paperAnchorLeft", "paperAnchorRight", "paperAnchorTop", "paperAnchorBottom", "paperAnchorDockedLeft", "paperAnchorDockedRight", "paperAnchorDockedTop", "paperAnchorDockedBottom", "modal"]);
const _excluded$t = ["BackdropProps"], _excluded2$4 = ["anchor", "BackdropProps", "children", "className", "elevation", "hideBackdrop", "ModalProps", "onClose", "open", "PaperProps", "SlideProps", "TransitionComponent", "transitionDuration", "variant"], overridesResolver$4 = (C, e) => {
  const {
    ownerState: T
  } = C;
  return [e.root, (T.variant === "permanent" || T.variant === "persistent") && e.docked, e.modal];
}, useUtilityClasses$q = (C) => {
  const {
    classes: e,
    anchor: T,
    variant: $
  } = C, V = {
    root: ["root"],
    docked: [($ === "permanent" || $ === "persistent") && "docked"],
    modal: ["modal"],
    paper: ["paper", `paperAnchor${capitalize$3(T)}`, $ !== "temporary" && `paperAnchorDocked${capitalize$3(T)}`]
  };
  return composeClasses(V, getDrawerUtilityClass, e);
}, DrawerRoot = styled$1(Modal, {
  name: "MuiDrawer",
  slot: "Root",
  overridesResolver: overridesResolver$4
})(({
  theme: C
}) => ({
  zIndex: (C.vars || C).zIndex.drawer
})), DrawerDockedRoot = styled$1("div", {
  shouldForwardProp: rootShouldForwardProp,
  name: "MuiDrawer",
  slot: "Docked",
  skipVariantsResolver: !1,
  overridesResolver: overridesResolver$4
})({
  flex: "0 0 auto"
}), DrawerPaper = styled$1(Paper, {
  name: "MuiDrawer",
  slot: "Paper",
  overridesResolver: (C, e) => {
    const {
      ownerState: T
    } = C;
    return [e.paper, e[`paperAnchor${capitalize$3(T.anchor)}`], T.variant !== "temporary" && e[`paperAnchorDocked${capitalize$3(T.anchor)}`]];
  }
})(({
  theme: C,
  ownerState: e
}) => _extends({
  overflowY: "auto",
  display: "flex",
  flexDirection: "column",
  height: "100%",
  flex: "1 0 auto",
  zIndex: (C.vars || C).zIndex.drawer,
  // Add iOS momentum scrolling for iOS < 13.0
  WebkitOverflowScrolling: "touch",
  // temporary style
  position: "fixed",
  top: 0,
  // We disable the focus ring for mouse, touch and keyboard users.
  // At some point, it would be better to keep it for keyboard users.
  // :focus-ring CSS pseudo-class will help.
  outline: 0
}, e.anchor === "left" && {
  left: 0
}, e.anchor === "top" && {
  top: 0,
  left: 0,
  right: 0,
  height: "auto",
  maxHeight: "100%"
}, e.anchor === "right" && {
  right: 0
}, e.anchor === "bottom" && {
  top: "auto",
  left: 0,
  bottom: 0,
  right: 0,
  height: "auto",
  maxHeight: "100%"
}, e.anchor === "left" && e.variant !== "temporary" && {
  borderRight: `1px solid ${(C.vars || C).palette.divider}`
}, e.anchor === "top" && e.variant !== "temporary" && {
  borderBottom: `1px solid ${(C.vars || C).palette.divider}`
}, e.anchor === "right" && e.variant !== "temporary" && {
  borderLeft: `1px solid ${(C.vars || C).palette.divider}`
}, e.anchor === "bottom" && e.variant !== "temporary" && {
  borderTop: `1px solid ${(C.vars || C).palette.divider}`
})), oppositeDirection = {
  left: "right",
  right: "left",
  top: "down",
  bottom: "up"
};
function isHorizontal(C) {
  return ["left", "right"].indexOf(C) !== -1;
}
function getAnchor({
  direction: C
}, e) {
  return C === "rtl" && isHorizontal(e) ? oppositeDirection[e] : e;
}
const Drawer = /* @__PURE__ */ React$1.forwardRef(function(e, T) {
  const $ = useDefaultProps({
    props: e,
    name: "MuiDrawer"
  }), V = useTheme$1(), J = useRtl(), ee = {
    enter: V.transitions.duration.enteringScreen,
    exit: V.transitions.duration.leavingScreen
  }, {
    anchor: te = "left",
    BackdropProps: re,
    children: ie,
    className: se,
    elevation: de = 16,
    hideBackdrop: ue = !1,
    ModalProps: {
      BackdropProps: fe
    } = {},
    onClose: he,
    open: me = !1,
    PaperProps: xe = {},
    SlideProps: ve,
    // eslint-disable-next-line react/prop-types
    TransitionComponent: Te = Slide,
    transitionDuration: we = ee,
    variant: Ee = "temporary"
  } = $, Me = _objectWithoutPropertiesLoose($.ModalProps, _excluded$t), Ie = _objectWithoutPropertiesLoose($, _excluded2$4), ke = React$1.useRef(!1);
  React$1.useEffect(() => {
    ke.current = !0;
  }, []);
  const _e = getAnchor({
    direction: J ? "rtl" : "ltr"
  }, te), Fe = _extends({}, $, {
    anchor: te,
    elevation: de,
    open: me,
    variant: Ee
  }, Ie), Ae = useUtilityClasses$q(Fe), ne = /* @__PURE__ */ jsxRuntimeExports.jsx(DrawerPaper, _extends({
    elevation: Ee === "temporary" ? de : 0,
    square: !0
  }, xe, {
    className: clsx(Ae.paper, xe.className),
    ownerState: Fe,
    children: ie
  }));
  if (Ee === "permanent")
    return /* @__PURE__ */ jsxRuntimeExports.jsx(DrawerDockedRoot, _extends({
      className: clsx(Ae.root, Ae.docked, se),
      ownerState: Fe,
      ref: T
    }, Ie, {
      children: ne
    }));
  const oe = /* @__PURE__ */ jsxRuntimeExports.jsx(Te, _extends({
    in: me,
    direction: oppositeDirection[_e],
    timeout: we,
    appear: ke.current
  }, ve, {
    children: ne
  }));
  return Ee === "persistent" ? /* @__PURE__ */ jsxRuntimeExports.jsx(DrawerDockedRoot, _extends({
    className: clsx(Ae.root, Ae.docked, se),
    ownerState: Fe,
    ref: T
  }, Ie, {
    children: oe
  })) : /* @__PURE__ */ jsxRuntimeExports.jsx(DrawerRoot, _extends({
    BackdropProps: _extends({}, re, fe, {
      transitionDuration: we
    }),
    className: clsx(Ae.root, Ae.modal, se),
    open: me,
    ownerState: Fe,
    onClose: he,
    hideBackdrop: ue,
    ref: T
  }, Ie, Me, {
    children: oe
  }));
});
dist$2.process.env.NODE_ENV !== "production" && (Drawer.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Side from which the drawer will appear.
   * @default 'left'
   */
  anchor: PropTypes.oneOf(["bottom", "left", "right", "top"]),
  /**
   * @ignore
   */
  BackdropProps: PropTypes.object,
  /**
   * The content of the component.
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The elevation of the drawer.
   * @default 16
   */
  elevation: integerPropType,
  /**
   * If `true`, the backdrop is not rendered.
   * @default false
   */
  hideBackdrop: PropTypes.bool,
  /**
   * Props applied to the [`Modal`](/material-ui/api/modal/) element.
   * @default {}
   */
  ModalProps: PropTypes.object,
  /**
   * Callback fired when the component requests to be closed.
   * The `reason` parameter can optionally be used to control the response to `onClose`.
   *
   * @param {object} event The event source of the callback.
   * @param {string} reason Can be: `"escapeKeyDown"`, `"backdropClick"`.
   */
  onClose: PropTypes.func,
  /**
   * If `true`, the component is shown.
   * @default false
   */
  open: PropTypes.bool,
  /**
   * Props applied to the [`Paper`](/material-ui/api/paper/) element.
   * @default {}
   */
  PaperProps: PropTypes.object,
  /**
   * Props applied to the [`Slide`](/material-ui/api/slide/) element.
   */
  SlideProps: PropTypes.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   * @default {
   *   enter: theme.transitions.duration.enteringScreen,
   *   exit: theme.transitions.duration.leavingScreen,
   * }
   */
  transitionDuration: PropTypes.oneOfType([PropTypes.number, PropTypes.shape({
    appear: PropTypes.number,
    enter: PropTypes.number,
    exit: PropTypes.number
  })]),
  /**
   * The variant to use.
   * @default 'temporary'
   */
  variant: PropTypes.oneOf(["permanent", "persistent", "temporary"])
});
const _excluded$s = ["disableUnderline", "components", "componentsProps", "fullWidth", "hiddenLabel", "inputComponent", "multiline", "slotProps", "slots", "type"], useUtilityClasses$p = (C) => {
  const {
    classes: e,
    disableUnderline: T
  } = C, V = composeClasses({
    root: ["root", !T && "underline"],
    input: ["input"]
  }, getFilledInputUtilityClass, e);
  return _extends({}, e, V);
}, FilledInputRoot = styled$1(InputBaseRoot, {
  shouldForwardProp: (C) => rootShouldForwardProp(C) || C === "classes",
  name: "MuiFilledInput",
  slot: "Root",
  overridesResolver: (C, e) => {
    const {
      ownerState: T
    } = C;
    return [...rootOverridesResolver(C, e), !T.disableUnderline && e.underline];
  }
})(({
  theme: C,
  ownerState: e
}) => {
  var T;
  const $ = C.palette.mode === "light", V = $ ? "rgba(0, 0, 0, 0.42)" : "rgba(255, 255, 255, 0.7)", J = $ ? "rgba(0, 0, 0, 0.06)" : "rgba(255, 255, 255, 0.09)", ee = $ ? "rgba(0, 0, 0, 0.09)" : "rgba(255, 255, 255, 0.13)", te = $ ? "rgba(0, 0, 0, 0.12)" : "rgba(255, 255, 255, 0.12)";
  return _extends({
    position: "relative",
    backgroundColor: C.vars ? C.vars.palette.FilledInput.bg : J,
    borderTopLeftRadius: (C.vars || C).shape.borderRadius,
    borderTopRightRadius: (C.vars || C).shape.borderRadius,
    transition: C.transitions.create("background-color", {
      duration: C.transitions.duration.shorter,
      easing: C.transitions.easing.easeOut
    }),
    "&:hover": {
      backgroundColor: C.vars ? C.vars.palette.FilledInput.hoverBg : ee,
      // Reset on touch devices, it doesn't add specificity
      "@media (hover: none)": {
        backgroundColor: C.vars ? C.vars.palette.FilledInput.bg : J
      }
    },
    [`&.${filledInputClasses.focused}`]: {
      backgroundColor: C.vars ? C.vars.palette.FilledInput.bg : J
    },
    [`&.${filledInputClasses.disabled}`]: {
      backgroundColor: C.vars ? C.vars.palette.FilledInput.disabledBg : te
    }
  }, !e.disableUnderline && {
    "&::after": {
      borderBottom: `2px solid ${(T = (C.vars || C).palette[e.color || "primary"]) == null ? void 0 : T.main}`,
      left: 0,
      bottom: 0,
      // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
      content: '""',
      position: "absolute",
      right: 0,
      transform: "scaleX(0)",
      transition: C.transitions.create("transform", {
        duration: C.transitions.duration.shorter,
        easing: C.transitions.easing.easeOut
      }),
      pointerEvents: "none"
      // Transparent to the hover style.
    },
    [`&.${filledInputClasses.focused}:after`]: {
      // translateX(0) is a workaround for Safari transform scale bug
      // See https://github.com/mui/material-ui/issues/31766
      transform: "scaleX(1) translateX(0)"
    },
    [`&.${filledInputClasses.error}`]: {
      "&::before, &::after": {
        borderBottomColor: (C.vars || C).palette.error.main
      }
    },
    "&::before": {
      borderBottom: `1px solid ${C.vars ? `rgba(${C.vars.palette.common.onBackgroundChannel} / ${C.vars.opacity.inputUnderline})` : V}`,
      left: 0,
      bottom: 0,
      // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
      content: '"\\00a0"',
      position: "absolute",
      right: 0,
      transition: C.transitions.create("border-bottom-color", {
        duration: C.transitions.duration.shorter
      }),
      pointerEvents: "none"
      // Transparent to the hover style.
    },
    [`&:hover:not(.${filledInputClasses.disabled}, .${filledInputClasses.error}):before`]: {
      borderBottom: `1px solid ${(C.vars || C).palette.text.primary}`
    },
    [`&.${filledInputClasses.disabled}:before`]: {
      borderBottomStyle: "dotted"
    }
  }, e.startAdornment && {
    paddingLeft: 12
  }, e.endAdornment && {
    paddingRight: 12
  }, e.multiline && _extends({
    padding: "25px 12px 8px"
  }, e.size === "small" && {
    paddingTop: 21,
    paddingBottom: 4
  }, e.hiddenLabel && {
    paddingTop: 16,
    paddingBottom: 17
  }, e.hiddenLabel && e.size === "small" && {
    paddingTop: 8,
    paddingBottom: 9
  }));
}), FilledInputInput = styled$1(InputBaseComponent, {
  name: "MuiFilledInput",
  slot: "Input",
  overridesResolver: inputOverridesResolver
})(({
  theme: C,
  ownerState: e
}) => _extends({
  paddingTop: 25,
  paddingRight: 12,
  paddingBottom: 8,
  paddingLeft: 12
}, !C.vars && {
  "&:-webkit-autofill": {
    WebkitBoxShadow: C.palette.mode === "light" ? null : "0 0 0 100px #266798 inset",
    WebkitTextFillColor: C.palette.mode === "light" ? null : "#fff",
    caretColor: C.palette.mode === "light" ? null : "#fff",
    borderTopLeftRadius: "inherit",
    borderTopRightRadius: "inherit"
  }
}, C.vars && {
  "&:-webkit-autofill": {
    borderTopLeftRadius: "inherit",
    borderTopRightRadius: "inherit"
  },
  [C.getColorSchemeSelector("dark")]: {
    "&:-webkit-autofill": {
      WebkitBoxShadow: "0 0 0 100px #266798 inset",
      WebkitTextFillColor: "#fff",
      caretColor: "#fff"
    }
  }
}, e.size === "small" && {
  paddingTop: 21,
  paddingBottom: 4
}, e.hiddenLabel && {
  paddingTop: 16,
  paddingBottom: 17
}, e.startAdornment && {
  paddingLeft: 0
}, e.endAdornment && {
  paddingRight: 0
}, e.hiddenLabel && e.size === "small" && {
  paddingTop: 8,
  paddingBottom: 9
}, e.multiline && {
  paddingTop: 0,
  paddingBottom: 0,
  paddingLeft: 0,
  paddingRight: 0
})), FilledInput = /* @__PURE__ */ React$1.forwardRef(function(e, T) {
  var $, V, J, ee;
  const te = useDefaultProps({
    props: e,
    name: "MuiFilledInput"
  }), {
    components: re = {},
    componentsProps: ie,
    fullWidth: se = !1,
    // declare here to prevent spreading to DOM
    inputComponent: de = "input",
    multiline: ue = !1,
    slotProps: fe,
    slots: he = {},
    type: me = "text"
  } = te, xe = _objectWithoutPropertiesLoose(te, _excluded$s), ve = _extends({}, te, {
    fullWidth: se,
    inputComponent: de,
    multiline: ue,
    type: me
  }), Te = useUtilityClasses$p(te), we = {
    root: {
      ownerState: ve
    },
    input: {
      ownerState: ve
    }
  }, Ee = fe ?? ie ? deepmerge$1(we, fe ?? ie) : we, Me = ($ = (V = he.root) != null ? V : re.Root) != null ? $ : FilledInputRoot, Ie = (J = (ee = he.input) != null ? ee : re.Input) != null ? J : FilledInputInput;
  return /* @__PURE__ */ jsxRuntimeExports.jsx(InputBase, _extends({
    slots: {
      root: Me,
      input: Ie
    },
    componentsProps: Ee,
    fullWidth: se,
    inputComponent: de,
    multiline: ue,
    ref: T,
    type: me
  }, xe, {
    classes: Te
  }));
});
dist$2.process.env.NODE_ENV !== "production" && (FilledInput.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * This prop helps users to fill forms faster, especially on mobile devices.
   * The name can be confusing, as it's more like an autofill.
   * You can learn more about it [following the specification](https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#autofill).
   */
  autoComplete: PropTypes.string,
  /**
   * If `true`, the `input` element is focused during the first mount.
   */
  autoFocus: PropTypes.bool,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * The prop defaults to the value (`'primary'`) inherited from the parent FormControl component.
   */
  color: PropTypes.oneOfType([PropTypes.oneOf(["primary", "secondary"]), PropTypes.string]),
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `slots` prop.
   * It's recommended to use the `slots` prop instead.
   *
   * @default {}
   */
  components: PropTypes.shape({
    Input: PropTypes.elementType,
    Root: PropTypes.elementType
  }),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * This prop is an alias for the `slotProps` prop.
   * It's recommended to use the `slotProps` prop instead, as `componentsProps` will be deprecated in the future.
   *
   * @default {}
   */
  componentsProps: PropTypes.shape({
    input: PropTypes.object,
    root: PropTypes.object
  }),
  /**
   * The default value. Use when the component is not controlled.
   */
  defaultValue: PropTypes.any,
  /**
   * If `true`, the component is disabled.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  disabled: PropTypes.bool,
  /**
   * If `true`, the input will not have an underline.
   */
  disableUnderline: PropTypes.bool,
  /**
   * End `InputAdornment` for this component.
   */
  endAdornment: PropTypes.node,
  /**
   * If `true`, the `input` will indicate an error.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  error: PropTypes.bool,
  /**
   * If `true`, the `input` will take up the full width of its container.
   * @default false
   */
  fullWidth: PropTypes.bool,
  /**
   * If `true`, the label is hidden.
   * This is used to increase density for a `FilledInput`.
   * Be sure to add `aria-label` to the `input` element.
   * @default false
   */
  hiddenLabel: PropTypes.bool,
  /**
   * The id of the `input` element.
   */
  id: PropTypes.string,
  /**
   * The component used for the `input` element.
   * Either a string to use a HTML element or a component.
   * @default 'input'
   */
  inputComponent: PropTypes.elementType,
  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   * @default {}
   */
  inputProps: PropTypes.object,
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: refType,
  /**
   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
   * FormControl.
   * The prop defaults to the value (`'none'`) inherited from the parent FormControl component.
   */
  margin: PropTypes.oneOf(["dense", "none"]),
  /**
   * Maximum number of rows to display when multiline option is set to true.
   */
  maxRows: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  /**
   * Minimum number of rows to display when multiline option is set to true.
   */
  minRows: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  /**
   * If `true`, a [TextareaAutosize](/material-ui/react-textarea-autosize/) element is rendered.
   * @default false
   */
  multiline: PropTypes.bool,
  /**
   * Name attribute of the `input` element.
   */
  name: PropTypes.string,
  /**
   * Callback fired when the value is changed.
   *
   * @param {React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   */
  onChange: PropTypes.func,
  /**
   * The short hint displayed in the `input` before the user enters a value.
   */
  placeholder: PropTypes.string,
  /**
   * It prevents the user from changing the value of the field
   * (not from interacting with the field).
   */
  readOnly: PropTypes.bool,
  /**
   * If `true`, the `input` element is required.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  required: PropTypes.bool,
  /**
   * Number of rows to display when multiline option is set to true.
   */
  rows: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * This prop is an alias for the `componentsProps` prop, which will be deprecated in the future.
   *
   * @default {}
   */
  slotProps: PropTypes.shape({
    input: PropTypes.object,
    root: PropTypes.object
  }),
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `components` prop, which will be deprecated in the future.
   *
   * @default {}
   */
  slots: PropTypes.shape({
    input: PropTypes.elementType,
    root: PropTypes.elementType
  }),
  /**
   * Start `InputAdornment` for this component.
   */
  startAdornment: PropTypes.node,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * Type of the `input` element. It should be [a valid HTML5 input type](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Form_%3Cinput%3E_types).
   * @default 'text'
   */
  type: PropTypes.string,
  /**
   * The value of the `input` element, required for a controlled component.
   */
  value: PropTypes.any
});
FilledInput.muiName = "Input";
function getFormControlUtilityClasses(C) {
  return generateUtilityClass("MuiFormControl", C);
}
generateUtilityClasses("MuiFormControl", ["root", "marginNone", "marginNormal", "marginDense", "fullWidth", "disabled"]);
const _excluded$r = ["children", "className", "color", "component", "disabled", "error", "focused", "fullWidth", "hiddenLabel", "margin", "required", "size", "variant"], useUtilityClasses$o = (C) => {
  const {
    classes: e,
    margin: T,
    fullWidth: $
  } = C, V = {
    root: ["root", T !== "none" && `margin${capitalize$3(T)}`, $ && "fullWidth"]
  };
  return composeClasses(V, getFormControlUtilityClasses, e);
}, FormControlRoot = styled$1("div", {
  name: "MuiFormControl",
  slot: "Root",
  overridesResolver: ({
    ownerState: C
  }, e) => _extends({}, e.root, e[`margin${capitalize$3(C.margin)}`], C.fullWidth && e.fullWidth)
})(({
  ownerState: C
}) => _extends({
  display: "inline-flex",
  flexDirection: "column",
  position: "relative",
  // Reset fieldset default style.
  minWidth: 0,
  padding: 0,
  margin: 0,
  border: 0,
  verticalAlign: "top"
}, C.margin === "normal" && {
  marginTop: 16,
  marginBottom: 8
}, C.margin === "dense" && {
  marginTop: 8,
  marginBottom: 4
}, C.fullWidth && {
  width: "100%"
})), FormControl = /* @__PURE__ */ React$1.forwardRef(function(e, T) {
  const $ = useDefaultProps({
    props: e,
    name: "MuiFormControl"
  }), {
    children: V,
    className: J,
    color: ee = "primary",
    component: te = "div",
    disabled: re = !1,
    error: ie = !1,
    focused: se,
    fullWidth: de = !1,
    hiddenLabel: ue = !1,
    margin: fe = "none",
    required: he = !1,
    size: me = "medium",
    variant: xe = "outlined"
  } = $, ve = _objectWithoutPropertiesLoose($, _excluded$r), Te = _extends({}, $, {
    color: ee,
    component: te,
    disabled: re,
    error: ie,
    fullWidth: de,
    hiddenLabel: ue,
    margin: fe,
    required: he,
    size: me,
    variant: xe
  }), we = useUtilityClasses$o(Te), [Ee, Me] = React$1.useState(() => {
    let oe = !1;
    return V && React$1.Children.forEach(V, (ce) => {
      if (!isMuiElement(ce, ["Input", "Select"]))
        return;
      const le = isMuiElement(ce, ["Select"]) ? ce.props.input : ce;
      le && isAdornedStart(le.props) && (oe = !0);
    }), oe;
  }), [Ie, ke] = React$1.useState(() => {
    let oe = !1;
    return V && React$1.Children.forEach(V, (ce) => {
      isMuiElement(ce, ["Input", "Select"]) && (isFilled(ce.props, !0) || isFilled(ce.props.inputProps, !0)) && (oe = !0);
    }), oe;
  }), [_e, De] = React$1.useState(!1);
  re && _e && De(!1);
  const Fe = se !== void 0 && !re ? se : _e;
  let Ae;
  if (dist$2.process.env.NODE_ENV !== "production") {
    const oe = React$1.useRef(!1);
    Ae = () => (oe.current && console.error(["MUI: There are multiple `InputBase` components inside a FormControl.", "This creates visual inconsistencies, only use one `InputBase`."].join(`
`)), oe.current = !0, () => {
      oe.current = !1;
    });
  }
  const ne = React$1.useMemo(() => ({
    adornedStart: Ee,
    setAdornedStart: Me,
    color: ee,
    disabled: re,
    error: ie,
    filled: Ie,
    focused: Fe,
    fullWidth: de,
    hiddenLabel: ue,
    size: me,
    onBlur: () => {
      De(!1);
    },
    onEmpty: () => {
      ke(!1);
    },
    onFilled: () => {
      ke(!0);
    },
    onFocus: () => {
      De(!0);
    },
    registerEffect: Ae,
    required: he,
    variant: xe
  }), [Ee, ee, re, ie, Ie, Fe, de, ue, Ae, he, me, xe]);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(FormControlContext.Provider, {
    value: ne,
    children: /* @__PURE__ */ jsxRuntimeExports.jsx(FormControlRoot, _extends({
      as: te,
      ownerState: Te,
      className: clsx(we.root, J),
      ref: T
    }, ve, {
      children: V
    }))
  });
});
dist$2.process.env.NODE_ENV !== "production" && (FormControl.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'primary'
   */
  color: PropTypes.oneOfType([PropTypes.oneOf(["primary", "secondary", "error", "info", "success", "warning"]), PropTypes.string]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes.elementType,
  /**
   * If `true`, the label, input and helper text should be displayed in a disabled state.
   * @default false
   */
  disabled: PropTypes.bool,
  /**
   * If `true`, the label is displayed in an error state.
   * @default false
   */
  error: PropTypes.bool,
  /**
   * If `true`, the component is displayed in focused state.
   */
  focused: PropTypes.bool,
  /**
   * If `true`, the component will take up the full width of its container.
   * @default false
   */
  fullWidth: PropTypes.bool,
  /**
   * If `true`, the label is hidden.
   * This is used to increase density for a `FilledInput`.
   * Be sure to add `aria-label` to the `input` element.
   * @default false
   */
  hiddenLabel: PropTypes.bool,
  /**
   * If `dense` or `normal`, will adjust vertical spacing of this and contained components.
   * @default 'none'
   */
  margin: PropTypes.oneOf(["dense", "none", "normal"]),
  /**
   * If `true`, the label will indicate that the `input` is required.
   * @default false
   */
  required: PropTypes.bool,
  /**
   * The size of the component.
   * @default 'medium'
   */
  size: PropTypes.oneOfType([PropTypes.oneOf(["medium", "small"]), PropTypes.string]),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * The variant to use.
   * @default 'outlined'
   */
  variant: PropTypes.oneOf(["filled", "outlined", "standard"])
});
const Stack = createStack({
  createStyledComponent: styled$1("div", {
    name: "MuiStack",
    slot: "Root",
    overridesResolver: (C, e) => e.root
  }),
  useThemeProps: (C) => useDefaultProps({
    props: C,
    name: "MuiStack"
  })
});
dist$2.process.env.NODE_ENV !== "production" && (Stack.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: PropTypes.node,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes.elementType,
  /**
   * Defines the `flex-direction` style property.
   * It is applied for all screen sizes.
   * @default 'column'
   */
  direction: PropTypes.oneOfType([PropTypes.oneOf(["column-reverse", "column", "row-reverse", "row"]), PropTypes.arrayOf(PropTypes.oneOf(["column-reverse", "column", "row-reverse", "row"])), PropTypes.object]),
  /**
   * Add an element between each child.
   */
  divider: PropTypes.node,
  /**
   * Defines the space between immediate children.
   * @default 0
   */
  spacing: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.number, PropTypes.string])), PropTypes.number, PropTypes.object, PropTypes.string]),
  /**
   * The system prop, which allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * If `true`, the CSS flexbox `gap` is used instead of applying `margin` to children.
   *
   * While CSS `gap` removes the [known limitations](https://mui.com/joy-ui/react-stack/#limitations),
   * it is not fully supported in some browsers. We recommend checking https://caniuse.com/?search=flex%20gap before using this flag.
   *
   * To enable this flag globally, follow the [theme's default props](https://mui.com/material-ui/customization/theme-components/#default-props) configuration.
   * @default false
   */
  useFlexGap: PropTypes.bool
});
function getFormHelperTextUtilityClasses(C) {
  return generateUtilityClass("MuiFormHelperText", C);
}
const formHelperTextClasses = generateUtilityClasses("MuiFormHelperText", ["root", "error", "disabled", "sizeSmall", "sizeMedium", "contained", "focused", "filled", "required"]);
var _span$3;
const _excluded$q = ["children", "className", "component", "disabled", "error", "filled", "focused", "margin", "required", "variant"], useUtilityClasses$n = (C) => {
  const {
    classes: e,
    contained: T,
    size: $,
    disabled: V,
    error: J,
    filled: ee,
    focused: te,
    required: re
  } = C, ie = {
    root: ["root", V && "disabled", J && "error", $ && `size${capitalize$3($)}`, T && "contained", te && "focused", ee && "filled", re && "required"]
  };
  return composeClasses(ie, getFormHelperTextUtilityClasses, e);
}, FormHelperTextRoot = styled$1("p", {
  name: "MuiFormHelperText",
  slot: "Root",
  overridesResolver: (C, e) => {
    const {
      ownerState: T
    } = C;
    return [e.root, T.size && e[`size${capitalize$3(T.size)}`], T.contained && e.contained, T.filled && e.filled];
  }
})(({
  theme: C,
  ownerState: e
}) => _extends({
  color: (C.vars || C).palette.text.secondary
}, C.typography.caption, {
  textAlign: "left",
  marginTop: 3,
  marginRight: 0,
  marginBottom: 0,
  marginLeft: 0,
  [`&.${formHelperTextClasses.disabled}`]: {
    color: (C.vars || C).palette.text.disabled
  },
  [`&.${formHelperTextClasses.error}`]: {
    color: (C.vars || C).palette.error.main
  }
}, e.size === "small" && {
  marginTop: 4
}, e.contained && {
  marginLeft: 14,
  marginRight: 14
})), FormHelperText = /* @__PURE__ */ React$1.forwardRef(function(e, T) {
  const $ = useDefaultProps({
    props: e,
    name: "MuiFormHelperText"
  }), {
    children: V,
    className: J,
    component: ee = "p"
  } = $, te = _objectWithoutPropertiesLoose($, _excluded$q), re = useFormControl(), ie = formControlState({
    props: $,
    muiFormControl: re,
    states: ["variant", "size", "disabled", "error", "filled", "focused", "required"]
  }), se = _extends({}, $, {
    component: ee,
    contained: ie.variant === "filled" || ie.variant === "outlined",
    variant: ie.variant,
    size: ie.size,
    disabled: ie.disabled,
    error: ie.error,
    filled: ie.filled,
    focused: ie.focused,
    required: ie.required
  }), de = useUtilityClasses$n(se);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(FormHelperTextRoot, _extends({
    as: ee,
    ownerState: se,
    className: clsx(de.root, J),
    ref: T
  }, te, {
    children: V === " " ? (
      // notranslate needed while Google Translate will not fix zero-width space issue
      _span$3 || (_span$3 = /* @__PURE__ */ jsxRuntimeExports.jsx("span", {
        className: "notranslate",
        children: "​"
      }))
    ) : V
  }));
});
dist$2.process.env.NODE_ENV !== "production" && (FormHelperText.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   *
   * If `' '` is provided, the component reserves one line height for displaying a future message.
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes.elementType,
  /**
   * If `true`, the helper text should be displayed in a disabled state.
   */
  disabled: PropTypes.bool,
  /**
   * If `true`, helper text should be displayed in an error state.
   */
  error: PropTypes.bool,
  /**
   * If `true`, the helper text should use filled classes key.
   */
  filled: PropTypes.bool,
  /**
   * If `true`, the helper text should use focused classes key.
   */
  focused: PropTypes.bool,
  /**
   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
   * FormControl.
   */
  margin: PropTypes.oneOf(["dense"]),
  /**
   * If `true`, the helper text should use required classes key.
   */
  required: PropTypes.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * The variant to use.
   */
  variant: PropTypes.oneOfType([PropTypes.oneOf(["filled", "outlined", "standard"]), PropTypes.string])
});
function getFormLabelUtilityClasses(C) {
  return generateUtilityClass("MuiFormLabel", C);
}
const formLabelClasses = generateUtilityClasses("MuiFormLabel", ["root", "colorSecondary", "focused", "disabled", "error", "filled", "required", "asterisk"]), _excluded$p = ["children", "className", "color", "component", "disabled", "error", "filled", "focused", "required"], useUtilityClasses$m = (C) => {
  const {
    classes: e,
    color: T,
    focused: $,
    disabled: V,
    error: J,
    filled: ee,
    required: te
  } = C, re = {
    root: ["root", `color${capitalize$3(T)}`, V && "disabled", J && "error", ee && "filled", $ && "focused", te && "required"],
    asterisk: ["asterisk", J && "error"]
  };
  return composeClasses(re, getFormLabelUtilityClasses, e);
}, FormLabelRoot = styled$1("label", {
  name: "MuiFormLabel",
  slot: "Root",
  overridesResolver: ({
    ownerState: C
  }, e) => _extends({}, e.root, C.color === "secondary" && e.colorSecondary, C.filled && e.filled)
})(({
  theme: C,
  ownerState: e
}) => _extends({
  color: (C.vars || C).palette.text.secondary
}, C.typography.body1, {
  lineHeight: "1.4375em",
  padding: 0,
  position: "relative",
  [`&.${formLabelClasses.focused}`]: {
    color: (C.vars || C).palette[e.color].main
  },
  [`&.${formLabelClasses.disabled}`]: {
    color: (C.vars || C).palette.text.disabled
  },
  [`&.${formLabelClasses.error}`]: {
    color: (C.vars || C).palette.error.main
  }
})), AsteriskComponent = styled$1("span", {
  name: "MuiFormLabel",
  slot: "Asterisk",
  overridesResolver: (C, e) => e.asterisk
})(({
  theme: C
}) => ({
  [`&.${formLabelClasses.error}`]: {
    color: (C.vars || C).palette.error.main
  }
})), FormLabel = /* @__PURE__ */ React$1.forwardRef(function(e, T) {
  const $ = useDefaultProps({
    props: e,
    name: "MuiFormLabel"
  }), {
    children: V,
    className: J,
    component: ee = "label"
  } = $, te = _objectWithoutPropertiesLoose($, _excluded$p), re = useFormControl(), ie = formControlState({
    props: $,
    muiFormControl: re,
    states: ["color", "required", "focused", "disabled", "error", "filled"]
  }), se = _extends({}, $, {
    color: ie.color || "primary",
    component: ee,
    disabled: ie.disabled,
    error: ie.error,
    filled: ie.filled,
    focused: ie.focused,
    required: ie.required
  }), de = useUtilityClasses$m(se);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(FormLabelRoot, _extends({
    as: ee,
    ownerState: se,
    className: clsx(de.root, J),
    ref: T
  }, te, {
    children: [V, ie.required && /* @__PURE__ */ jsxRuntimeExports.jsxs(AsteriskComponent, {
      ownerState: se,
      "aria-hidden": !0,
      className: de.asterisk,
      children: [" ", "*"]
    })]
  }));
});
dist$2.process.env.NODE_ENV !== "production" && (FormLabel.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   */
  color: PropTypes.oneOfType([PropTypes.oneOf(["error", "info", "primary", "secondary", "success", "warning"]), PropTypes.string]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes.elementType,
  /**
   * If `true`, the label should be displayed in a disabled state.
   */
  disabled: PropTypes.bool,
  /**
   * If `true`, the label is displayed in an error state.
   */
  error: PropTypes.bool,
  /**
   * If `true`, the label should use filled classes key.
   */
  filled: PropTypes.bool,
  /**
   * If `true`, the input of this label is focused (used by `FormGroup` components).
   */
  focused: PropTypes.bool,
  /**
   * If `true`, the label will indicate that the `input` is required.
   */
  required: PropTypes.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object])
});
const _excluded$o = ["addEndListener", "appear", "children", "easing", "in", "onEnter", "onEntered", "onEntering", "onExit", "onExited", "onExiting", "style", "timeout", "TransitionComponent"];
function getScale(C) {
  return `scale(${C}, ${C ** 2})`;
}
const styles = {
  entering: {
    opacity: 1,
    transform: getScale(1)
  },
  entered: {
    opacity: 1,
    transform: "none"
  }
}, isWebKit154 = typeof navigator < "u" && /^((?!chrome|android).)*(safari|mobile)/i.test(navigator.userAgent) && /(os |version\/)15(.|_)4/i.test(navigator.userAgent), Grow = /* @__PURE__ */ React$1.forwardRef(function(e, T) {
  const {
    addEndListener: $,
    appear: V = !0,
    children: J,
    easing: ee,
    in: te,
    onEnter: re,
    onEntered: ie,
    onEntering: se,
    onExit: de,
    onExited: ue,
    onExiting: fe,
    style: he,
    timeout: me = "auto",
    // eslint-disable-next-line react/prop-types
    TransitionComponent: xe = Transition
  } = e, ve = _objectWithoutPropertiesLoose(e, _excluded$o), Te = useTimeout(), we = React$1.useRef(), Ee = useTheme$1(), Me = React$1.useRef(null), Ie = useForkRef(Me, getReactElementRef(J), T), ke = (le) => (pe) => {
    if (le) {
      const ye = Me.current;
      pe === void 0 ? le(ye) : le(ye, pe);
    }
  }, _e = ke(se), De = ke((le, pe) => {
    reflow(le);
    const {
      duration: ye,
      delay: Ce,
      easing: be
    } = getTransitionProps({
      style: he,
      timeout: me,
      easing: ee
    }, {
      mode: "enter"
    });
    let ae;
    me === "auto" ? (ae = Ee.transitions.getAutoHeightDuration(le.clientHeight), we.current = ae) : ae = ye, le.style.transition = [Ee.transitions.create("opacity", {
      duration: ae,
      delay: Ce
    }), Ee.transitions.create("transform", {
      duration: isWebKit154 ? ae : ae * 0.666,
      delay: Ce,
      easing: be
    })].join(","), re && re(le, pe);
  }), Fe = ke(ie), Ae = ke(fe), ne = ke((le) => {
    const {
      duration: pe,
      delay: ye,
      easing: Ce
    } = getTransitionProps({
      style: he,
      timeout: me,
      easing: ee
    }, {
      mode: "exit"
    });
    let be;
    me === "auto" ? (be = Ee.transitions.getAutoHeightDuration(le.clientHeight), we.current = be) : be = pe, le.style.transition = [Ee.transitions.create("opacity", {
      duration: be,
      delay: ye
    }), Ee.transitions.create("transform", {
      duration: isWebKit154 ? be : be * 0.666,
      delay: isWebKit154 ? ye : ye || be * 0.333,
      easing: Ce
    })].join(","), le.style.opacity = 0, le.style.transform = getScale(0.75), de && de(le);
  }), oe = ke(ue), ce = (le) => {
    me === "auto" && Te.start(we.current || 0, le), $ && $(Me.current, le);
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsx(xe, _extends({
    appear: V,
    in: te,
    nodeRef: Me,
    onEnter: De,
    onEntered: Fe,
    onEntering: _e,
    onExit: ne,
    onExited: oe,
    onExiting: Ae,
    addEndListener: ce,
    timeout: me === "auto" ? null : me
  }, ve, {
    children: (le, pe) => /* @__PURE__ */ React$1.cloneElement(J, _extends({
      style: _extends({
        opacity: 0,
        transform: getScale(0.75),
        visibility: le === "exited" && !te ? "hidden" : void 0
      }, styles[le], he, J.props.style),
      ref: Ie
    }, pe))
  }));
});
dist$2.process.env.NODE_ENV !== "production" && (Grow.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Add a custom transition end trigger. Called with the transitioning DOM
   * node and a done callback. Allows for more fine grained transition end
   * logic. Note: Timeouts are still used as a fallback if provided.
   */
  addEndListener: PropTypes.func,
  /**
   * Perform the enter transition when it first mounts if `in` is also `true`.
   * Set this to `false` to disable this behavior.
   * @default true
   */
  appear: PropTypes.bool,
  /**
   * A single child content element.
   */
  children: elementAcceptingRef.isRequired,
  /**
   * The transition timing function.
   * You may specify a single easing or a object containing enter and exit values.
   */
  easing: PropTypes.oneOfType([PropTypes.shape({
    enter: PropTypes.string,
    exit: PropTypes.string
  }), PropTypes.string]),
  /**
   * If `true`, the component will transition in.
   */
  in: PropTypes.bool,
  /**
   * @ignore
   */
  onEnter: PropTypes.func,
  /**
   * @ignore
   */
  onEntered: PropTypes.func,
  /**
   * @ignore
   */
  onEntering: PropTypes.func,
  /**
   * @ignore
   */
  onExit: PropTypes.func,
  /**
   * @ignore
   */
  onExited: PropTypes.func,
  /**
   * @ignore
   */
  onExiting: PropTypes.func,
  /**
   * @ignore
   */
  style: PropTypes.object,
  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   *
   * Set to 'auto' to automatically calculate transition time based on height.
   * @default 'auto'
   */
  timeout: PropTypes.oneOfType([PropTypes.oneOf(["auto"]), PropTypes.number, PropTypes.shape({
    appear: PropTypes.number,
    enter: PropTypes.number,
    exit: PropTypes.number
  })])
});
Grow.muiSupportAuto = !0;
const _excluded$n = ["disableUnderline", "components", "componentsProps", "fullWidth", "inputComponent", "multiline", "slotProps", "slots", "type"], useUtilityClasses$l = (C) => {
  const {
    classes: e,
    disableUnderline: T
  } = C, V = composeClasses({
    root: ["root", !T && "underline"],
    input: ["input"]
  }, getInputUtilityClass, e);
  return _extends({}, e, V);
}, InputRoot = styled$1(InputBaseRoot, {
  shouldForwardProp: (C) => rootShouldForwardProp(C) || C === "classes",
  name: "MuiInput",
  slot: "Root",
  overridesResolver: (C, e) => {
    const {
      ownerState: T
    } = C;
    return [...rootOverridesResolver(C, e), !T.disableUnderline && e.underline];
  }
})(({
  theme: C,
  ownerState: e
}) => {
  let $ = C.palette.mode === "light" ? "rgba(0, 0, 0, 0.42)" : "rgba(255, 255, 255, 0.7)";
  return C.vars && ($ = `rgba(${C.vars.palette.common.onBackgroundChannel} / ${C.vars.opacity.inputUnderline})`), _extends({
    position: "relative"
  }, e.formControl && {
    "label + &": {
      marginTop: 16
    }
  }, !e.disableUnderline && {
    "&::after": {
      borderBottom: `2px solid ${(C.vars || C).palette[e.color].main}`,
      left: 0,
      bottom: 0,
      // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
      content: '""',
      position: "absolute",
      right: 0,
      transform: "scaleX(0)",
      transition: C.transitions.create("transform", {
        duration: C.transitions.duration.shorter,
        easing: C.transitions.easing.easeOut
      }),
      pointerEvents: "none"
      // Transparent to the hover style.
    },
    [`&.${inputClasses.focused}:after`]: {
      // translateX(0) is a workaround for Safari transform scale bug
      // See https://github.com/mui/material-ui/issues/31766
      transform: "scaleX(1) translateX(0)"
    },
    [`&.${inputClasses.error}`]: {
      "&::before, &::after": {
        borderBottomColor: (C.vars || C).palette.error.main
      }
    },
    "&::before": {
      borderBottom: `1px solid ${$}`,
      left: 0,
      bottom: 0,
      // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
      content: '"\\00a0"',
      position: "absolute",
      right: 0,
      transition: C.transitions.create("border-bottom-color", {
        duration: C.transitions.duration.shorter
      }),
      pointerEvents: "none"
      // Transparent to the hover style.
    },
    [`&:hover:not(.${inputClasses.disabled}, .${inputClasses.error}):before`]: {
      borderBottom: `2px solid ${(C.vars || C).palette.text.primary}`,
      // Reset on touch devices, it doesn't add specificity
      "@media (hover: none)": {
        borderBottom: `1px solid ${$}`
      }
    },
    [`&.${inputClasses.disabled}:before`]: {
      borderBottomStyle: "dotted"
    }
  });
}), InputInput = styled$1(InputBaseComponent, {
  name: "MuiInput",
  slot: "Input",
  overridesResolver: inputOverridesResolver
})({}), Input = /* @__PURE__ */ React$1.forwardRef(function(e, T) {
  var $, V, J, ee;
  const te = useDefaultProps({
    props: e,
    name: "MuiInput"
  }), {
    disableUnderline: re,
    components: ie = {},
    componentsProps: se,
    fullWidth: de = !1,
    inputComponent: ue = "input",
    multiline: fe = !1,
    slotProps: he,
    slots: me = {},
    type: xe = "text"
  } = te, ve = _objectWithoutPropertiesLoose(te, _excluded$n), Te = useUtilityClasses$l(te), Ee = {
    root: {
      ownerState: {
        disableUnderline: re
      }
    }
  }, Me = he ?? se ? deepmerge$1(he ?? se, Ee) : Ee, Ie = ($ = (V = me.root) != null ? V : ie.Root) != null ? $ : InputRoot, ke = (J = (ee = me.input) != null ? ee : ie.Input) != null ? J : InputInput;
  return /* @__PURE__ */ jsxRuntimeExports.jsx(InputBase, _extends({
    slots: {
      root: Ie,
      input: ke
    },
    slotProps: Me,
    fullWidth: de,
    inputComponent: ue,
    multiline: fe,
    ref: T,
    type: xe
  }, ve, {
    classes: Te
  }));
});
dist$2.process.env.NODE_ENV !== "production" && (Input.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * This prop helps users to fill forms faster, especially on mobile devices.
   * The name can be confusing, as it's more like an autofill.
   * You can learn more about it [following the specification](https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#autofill).
   */
  autoComplete: PropTypes.string,
  /**
   * If `true`, the `input` element is focused during the first mount.
   */
  autoFocus: PropTypes.bool,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * The prop defaults to the value (`'primary'`) inherited from the parent FormControl component.
   */
  color: PropTypes.oneOfType([PropTypes.oneOf(["primary", "secondary"]), PropTypes.string]),
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `slots` prop.
   * It's recommended to use the `slots` prop instead.
   *
   * @default {}
   */
  components: PropTypes.shape({
    Input: PropTypes.elementType,
    Root: PropTypes.elementType
  }),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * This prop is an alias for the `slotProps` prop.
   * It's recommended to use the `slotProps` prop instead, as `componentsProps` will be deprecated in the future.
   *
   * @default {}
   */
  componentsProps: PropTypes.shape({
    input: PropTypes.object,
    root: PropTypes.object
  }),
  /**
   * The default value. Use when the component is not controlled.
   */
  defaultValue: PropTypes.any,
  /**
   * If `true`, the component is disabled.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  disabled: PropTypes.bool,
  /**
   * If `true`, the `input` will not have an underline.
   */
  disableUnderline: PropTypes.bool,
  /**
   * End `InputAdornment` for this component.
   */
  endAdornment: PropTypes.node,
  /**
   * If `true`, the `input` will indicate an error.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  error: PropTypes.bool,
  /**
   * If `true`, the `input` will take up the full width of its container.
   * @default false
   */
  fullWidth: PropTypes.bool,
  /**
   * The id of the `input` element.
   */
  id: PropTypes.string,
  /**
   * The component used for the `input` element.
   * Either a string to use a HTML element or a component.
   * @default 'input'
   */
  inputComponent: PropTypes.elementType,
  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   * @default {}
   */
  inputProps: PropTypes.object,
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: refType,
  /**
   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
   * FormControl.
   * The prop defaults to the value (`'none'`) inherited from the parent FormControl component.
   */
  margin: PropTypes.oneOf(["dense", "none"]),
  /**
   * Maximum number of rows to display when multiline option is set to true.
   */
  maxRows: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  /**
   * Minimum number of rows to display when multiline option is set to true.
   */
  minRows: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  /**
   * If `true`, a [TextareaAutosize](/material-ui/react-textarea-autosize/) element is rendered.
   * @default false
   */
  multiline: PropTypes.bool,
  /**
   * Name attribute of the `input` element.
   */
  name: PropTypes.string,
  /**
   * Callback fired when the value is changed.
   *
   * @param {React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   */
  onChange: PropTypes.func,
  /**
   * The short hint displayed in the `input` before the user enters a value.
   */
  placeholder: PropTypes.string,
  /**
   * It prevents the user from changing the value of the field
   * (not from interacting with the field).
   */
  readOnly: PropTypes.bool,
  /**
   * If `true`, the `input` element is required.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  required: PropTypes.bool,
  /**
   * Number of rows to display when multiline option is set to true.
   */
  rows: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * This prop is an alias for the `componentsProps` prop, which will be deprecated in the future.
   *
   * @default {}
   */
  slotProps: PropTypes.shape({
    input: PropTypes.object,
    root: PropTypes.object
  }),
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `components` prop, which will be deprecated in the future.
   *
   * @default {}
   */
  slots: PropTypes.shape({
    input: PropTypes.elementType,
    root: PropTypes.elementType
  }),
  /**
   * Start `InputAdornment` for this component.
   */
  startAdornment: PropTypes.node,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * Type of the `input` element. It should be [a valid HTML5 input type](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Form_%3Cinput%3E_types).
   * @default 'text'
   */
  type: PropTypes.string,
  /**
   * The value of the `input` element, required for a controlled component.
   */
  value: PropTypes.any
});
Input.muiName = "Input";
function getInputAdornmentUtilityClass(C) {
  return generateUtilityClass("MuiInputAdornment", C);
}
const inputAdornmentClasses = generateUtilityClasses("MuiInputAdornment", ["root", "filled", "standard", "outlined", "positionStart", "positionEnd", "disablePointerEvents", "hiddenLabel", "sizeSmall"]);
var _span$2;
const _excluded$m = ["children", "className", "component", "disablePointerEvents", "disableTypography", "position", "variant"], overridesResolver$3 = (C, e) => {
  const {
    ownerState: T
  } = C;
  return [e.root, e[`position${capitalize$3(T.position)}`], T.disablePointerEvents === !0 && e.disablePointerEvents, e[T.variant]];
}, useUtilityClasses$k = (C) => {
  const {
    classes: e,
    disablePointerEvents: T,
    hiddenLabel: $,
    position: V,
    size: J,
    variant: ee
  } = C, te = {
    root: ["root", T && "disablePointerEvents", V && `position${capitalize$3(V)}`, ee, $ && "hiddenLabel", J && `size${capitalize$3(J)}`]
  };
  return composeClasses(te, getInputAdornmentUtilityClass, e);
}, InputAdornmentRoot = styled$1("div", {
  name: "MuiInputAdornment",
  slot: "Root",
  overridesResolver: overridesResolver$3
})(({
  theme: C,
  ownerState: e
}) => _extends({
  display: "flex",
  height: "0.01em",
  // Fix IE11 flexbox alignment. To remove at some point.
  maxHeight: "2em",
  alignItems: "center",
  whiteSpace: "nowrap",
  color: (C.vars || C).palette.action.active
}, e.variant === "filled" && {
  // Styles applied to the root element if `variant="filled"`.
  [`&.${inputAdornmentClasses.positionStart}&:not(.${inputAdornmentClasses.hiddenLabel})`]: {
    marginTop: 16
  }
}, e.position === "start" && {
  // Styles applied to the root element if `position="start"`.
  marginRight: 8
}, e.position === "end" && {
  // Styles applied to the root element if `position="end"`.
  marginLeft: 8
}, e.disablePointerEvents === !0 && {
  // Styles applied to the root element if `disablePointerEvents={true}`.
  pointerEvents: "none"
})), InputAdornment = /* @__PURE__ */ React$1.forwardRef(function(e, T) {
  const $ = useDefaultProps({
    props: e,
    name: "MuiInputAdornment"
  }), {
    children: V,
    className: J,
    component: ee = "div",
    disablePointerEvents: te = !1,
    disableTypography: re = !1,
    position: ie,
    variant: se
  } = $, de = _objectWithoutPropertiesLoose($, _excluded$m), ue = useFormControl() || {};
  let fe = se;
  se && ue.variant && dist$2.process.env.NODE_ENV !== "production" && se === ue.variant && console.error("MUI: The `InputAdornment` variant infers the variant prop you do not have to provide one."), ue && !fe && (fe = ue.variant);
  const he = _extends({}, $, {
    hiddenLabel: ue.hiddenLabel,
    size: ue.size,
    disablePointerEvents: te,
    position: ie,
    variant: fe
  }), me = useUtilityClasses$k(he);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(FormControlContext.Provider, {
    value: null,
    children: /* @__PURE__ */ jsxRuntimeExports.jsx(InputAdornmentRoot, _extends({
      as: ee,
      ownerState: he,
      className: clsx(me.root, J),
      ref: T
    }, de, {
      children: typeof V == "string" && !re ? /* @__PURE__ */ jsxRuntimeExports.jsx(Typography, {
        color: "text.secondary",
        children: V
      }) : /* @__PURE__ */ jsxRuntimeExports.jsxs(React$1.Fragment, {
        children: [ie === "start" ? (
          /* notranslate needed while Google Translate will not fix zero-width space issue */
          _span$2 || (_span$2 = /* @__PURE__ */ jsxRuntimeExports.jsx("span", {
            className: "notranslate",
            children: "​"
          }))
        ) : null, V]
      })
    }))
  });
});
dist$2.process.env.NODE_ENV !== "production" && (InputAdornment.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component, normally an `IconButton` or string.
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes.elementType,
  /**
   * Disable pointer events on the root.
   * This allows for the content of the adornment to focus the `input` on click.
   * @default false
   */
  disablePointerEvents: PropTypes.bool,
  /**
   * If children is a string then disable wrapping in a Typography component.
   * @default false
   */
  disableTypography: PropTypes.bool,
  /**
   * The position this adornment should appear relative to the `Input`.
   */
  position: PropTypes.oneOf(["end", "start"]).isRequired,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * The variant to use.
   * Note: If you are using the `TextField` component or the `FormControl` component
   * you do not have to set this manually.
   */
  variant: PropTypes.oneOf(["filled", "outlined", "standard"])
});
function getInputLabelUtilityClasses(C) {
  return generateUtilityClass("MuiInputLabel", C);
}
generateUtilityClasses("MuiInputLabel", ["root", "focused", "disabled", "error", "required", "asterisk", "formControl", "sizeSmall", "shrink", "animated", "standard", "filled", "outlined"]);
const _excluded$l = ["disableAnimation", "margin", "shrink", "variant", "className"], useUtilityClasses$j = (C) => {
  const {
    classes: e,
    formControl: T,
    size: $,
    shrink: V,
    disableAnimation: J,
    variant: ee,
    required: te
  } = C, re = {
    root: ["root", T && "formControl", !J && "animated", V && "shrink", $ && $ !== "normal" && `size${capitalize$3($)}`, ee],
    asterisk: [te && "asterisk"]
  }, ie = composeClasses(re, getInputLabelUtilityClasses, e);
  return _extends({}, e, ie);
}, InputLabelRoot = styled$1(FormLabel, {
  shouldForwardProp: (C) => rootShouldForwardProp(C) || C === "classes",
  name: "MuiInputLabel",
  slot: "Root",
  overridesResolver: (C, e) => {
    const {
      ownerState: T
    } = C;
    return [{
      [`& .${formLabelClasses.asterisk}`]: e.asterisk
    }, e.root, T.formControl && e.formControl, T.size === "small" && e.sizeSmall, T.shrink && e.shrink, !T.disableAnimation && e.animated, T.focused && e.focused, e[T.variant]];
  }
})(({
  theme: C,
  ownerState: e
}) => _extends({
  display: "block",
  transformOrigin: "top left",
  whiteSpace: "nowrap",
  overflow: "hidden",
  textOverflow: "ellipsis",
  maxWidth: "100%"
}, e.formControl && {
  position: "absolute",
  left: 0,
  top: 0,
  // slight alteration to spec spacing to match visual spec result
  transform: "translate(0, 20px) scale(1)"
}, e.size === "small" && {
  // Compensation for the `Input.inputSizeSmall` style.
  transform: "translate(0, 17px) scale(1)"
}, e.shrink && {
  transform: "translate(0, -1.5px) scale(0.75)",
  transformOrigin: "top left",
  maxWidth: "133%"
}, !e.disableAnimation && {
  transition: C.transitions.create(["color", "transform", "max-width"], {
    duration: C.transitions.duration.shorter,
    easing: C.transitions.easing.easeOut
  })
}, e.variant === "filled" && _extends({
  // Chrome's autofill feature gives the input field a yellow background.
  // Since the input field is behind the label in the HTML tree,
  // the input field is drawn last and hides the label with an opaque background color.
  // zIndex: 1 will raise the label above opaque background-colors of input.
  zIndex: 1,
  pointerEvents: "none",
  transform: "translate(12px, 16px) scale(1)",
  maxWidth: "calc(100% - 24px)"
}, e.size === "small" && {
  transform: "translate(12px, 13px) scale(1)"
}, e.shrink && _extends({
  userSelect: "none",
  pointerEvents: "auto",
  transform: "translate(12px, 7px) scale(0.75)",
  maxWidth: "calc(133% - 24px)"
}, e.size === "small" && {
  transform: "translate(12px, 4px) scale(0.75)"
})), e.variant === "outlined" && _extends({
  // see comment above on filled.zIndex
  zIndex: 1,
  pointerEvents: "none",
  transform: "translate(14px, 16px) scale(1)",
  maxWidth: "calc(100% - 24px)"
}, e.size === "small" && {
  transform: "translate(14px, 9px) scale(1)"
}, e.shrink && {
  userSelect: "none",
  pointerEvents: "auto",
  // Theoretically, we should have (8+5)*2/0.75 = 34px
  // but it feels a better when it bleeds a bit on the left, so 32px.
  maxWidth: "calc(133% - 32px)",
  transform: "translate(14px, -9px) scale(0.75)"
}))), InputLabel = /* @__PURE__ */ React$1.forwardRef(function(e, T) {
  const $ = useDefaultProps({
    name: "MuiInputLabel",
    props: e
  }), {
    disableAnimation: V = !1,
    shrink: J,
    className: ee
  } = $, te = _objectWithoutPropertiesLoose($, _excluded$l), re = useFormControl();
  let ie = J;
  typeof ie > "u" && re && (ie = re.filled || re.focused || re.adornedStart);
  const se = formControlState({
    props: $,
    muiFormControl: re,
    states: ["size", "variant", "required", "focused"]
  }), de = _extends({}, $, {
    disableAnimation: V,
    formControl: re,
    shrink: ie,
    size: se.size,
    variant: se.variant,
    required: se.required,
    focused: se.focused
  }), ue = useUtilityClasses$j(de);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(InputLabelRoot, _extends({
    "data-shrink": ie,
    ownerState: de,
    ref: T,
    className: clsx(ue.root, ee)
  }, te, {
    classes: ue
  }));
});
dist$2.process.env.NODE_ENV !== "production" && (InputLabel.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   */
  color: PropTypes.oneOfType([PropTypes.oneOf(["error", "info", "primary", "secondary", "success", "warning"]), PropTypes.string]),
  /**
   * If `true`, the transition animation is disabled.
   * @default false
   */
  disableAnimation: PropTypes.bool,
  /**
   * If `true`, the component is disabled.
   */
  disabled: PropTypes.bool,
  /**
   * If `true`, the label is displayed in an error state.
   */
  error: PropTypes.bool,
  /**
   * If `true`, the `input` of this label is focused.
   */
  focused: PropTypes.bool,
  /**
   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
   * FormControl.
   */
  margin: PropTypes.oneOf(["dense"]),
  /**
   * if `true`, the label will indicate that the `input` is required.
   */
  required: PropTypes.bool,
  /**
   * If `true`, the label is shrunk.
   */
  shrink: PropTypes.bool,
  /**
   * The size of the component.
   * @default 'normal'
   */
  size: PropTypes.oneOfType([PropTypes.oneOf(["normal", "small"]), PropTypes.string]),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * The variant to use.
   */
  variant: PropTypes.oneOf(["filled", "outlined", "standard"])
});
function getLinearProgressUtilityClass(C) {
  return generateUtilityClass("MuiLinearProgress", C);
}
generateUtilityClasses("MuiLinearProgress", ["root", "colorPrimary", "colorSecondary", "determinate", "indeterminate", "buffer", "query", "dashed", "dashedColorPrimary", "dashedColorSecondary", "bar", "barColorPrimary", "barColorSecondary", "bar1Indeterminate", "bar1Determinate", "bar1Buffer", "bar2Indeterminate", "bar2Buffer"]);
const _excluded$k = ["className", "color", "value", "valueBuffer", "variant"];
let _$1 = (C) => C, _t$1, _t2$1, _t3$1, _t4$1, _t5, _t6;
const TRANSITION_DURATION = 4, indeterminate1Keyframe = keyframes(_t$1 || (_t$1 = _$1`
  0% {
    left: -35%;
    right: 100%;
  }

  60% {
    left: 100%;
    right: -90%;
  }

  100% {
    left: 100%;
    right: -90%;
  }
`)), indeterminate2Keyframe = keyframes(_t2$1 || (_t2$1 = _$1`
  0% {
    left: -200%;
    right: 100%;
  }

  60% {
    left: 107%;
    right: -8%;
  }

  100% {
    left: 107%;
    right: -8%;
  }
`)), bufferKeyframe = keyframes(_t3$1 || (_t3$1 = _$1`
  0% {
    opacity: 1;
    background-position: 0 -23px;
  }

  60% {
    opacity: 0;
    background-position: 0 -23px;
  }

  100% {
    opacity: 1;
    background-position: -200px -23px;
  }
`)), useUtilityClasses$i = (C) => {
  const {
    classes: e,
    variant: T,
    color: $
  } = C, V = {
    root: ["root", `color${capitalize$3($)}`, T],
    dashed: ["dashed", `dashedColor${capitalize$3($)}`],
    bar1: ["bar", `barColor${capitalize$3($)}`, (T === "indeterminate" || T === "query") && "bar1Indeterminate", T === "determinate" && "bar1Determinate", T === "buffer" && "bar1Buffer"],
    bar2: ["bar", T !== "buffer" && `barColor${capitalize$3($)}`, T === "buffer" && `color${capitalize$3($)}`, (T === "indeterminate" || T === "query") && "bar2Indeterminate", T === "buffer" && "bar2Buffer"]
  };
  return composeClasses(V, getLinearProgressUtilityClass, e);
}, getColorShade = (C, e) => e === "inherit" ? "currentColor" : C.vars ? C.vars.palette.LinearProgress[`${e}Bg`] : C.palette.mode === "light" ? lighten_1(C.palette[e].main, 0.62) : darken_1(C.palette[e].main, 0.5), LinearProgressRoot = styled$1("span", {
  name: "MuiLinearProgress",
  slot: "Root",
  overridesResolver: (C, e) => {
    const {
      ownerState: T
    } = C;
    return [e.root, e[`color${capitalize$3(T.color)}`], e[T.variant]];
  }
})(({
  ownerState: C,
  theme: e
}) => _extends({
  position: "relative",
  overflow: "hidden",
  display: "block",
  height: 4,
  zIndex: 0,
  // Fix Safari's bug during composition of different paint.
  "@media print": {
    colorAdjust: "exact"
  },
  backgroundColor: getColorShade(e, C.color)
}, C.color === "inherit" && C.variant !== "buffer" && {
  backgroundColor: "none",
  "&::before": {
    content: '""',
    position: "absolute",
    left: 0,
    top: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "currentColor",
    opacity: 0.3
  }
}, C.variant === "buffer" && {
  backgroundColor: "transparent"
}, C.variant === "query" && {
  transform: "rotate(180deg)"
})), LinearProgressDashed = styled$1("span", {
  name: "MuiLinearProgress",
  slot: "Dashed",
  overridesResolver: (C, e) => {
    const {
      ownerState: T
    } = C;
    return [e.dashed, e[`dashedColor${capitalize$3(T.color)}`]];
  }
})(({
  ownerState: C,
  theme: e
}) => {
  const T = getColorShade(e, C.color);
  return _extends({
    position: "absolute",
    marginTop: 0,
    height: "100%",
    width: "100%"
  }, C.color === "inherit" && {
    opacity: 0.3
  }, {
    backgroundImage: `radial-gradient(${T} 0%, ${T} 16%, transparent 42%)`,
    backgroundSize: "10px 10px",
    backgroundPosition: "0 -23px"
  });
}, css(_t4$1 || (_t4$1 = _$1`
    animation: ${0} 3s infinite linear;
  `), bufferKeyframe)), LinearProgressBar1 = styled$1("span", {
  name: "MuiLinearProgress",
  slot: "Bar1",
  overridesResolver: (C, e) => {
    const {
      ownerState: T
    } = C;
    return [e.bar, e[`barColor${capitalize$3(T.color)}`], (T.variant === "indeterminate" || T.variant === "query") && e.bar1Indeterminate, T.variant === "determinate" && e.bar1Determinate, T.variant === "buffer" && e.bar1Buffer];
  }
})(({
  ownerState: C,
  theme: e
}) => _extends({
  width: "100%",
  position: "absolute",
  left: 0,
  bottom: 0,
  top: 0,
  transition: "transform 0.2s linear",
  transformOrigin: "left",
  backgroundColor: C.color === "inherit" ? "currentColor" : (e.vars || e).palette[C.color].main
}, C.variant === "determinate" && {
  transition: `transform .${TRANSITION_DURATION}s linear`
}, C.variant === "buffer" && {
  zIndex: 1,
  transition: `transform .${TRANSITION_DURATION}s linear`
}), ({
  ownerState: C
}) => (C.variant === "indeterminate" || C.variant === "query") && css(_t5 || (_t5 = _$1`
      width: auto;
      animation: ${0} 2.1s cubic-bezier(0.65, 0.815, 0.735, 0.395) infinite;
    `), indeterminate1Keyframe)), LinearProgressBar2 = styled$1("span", {
  name: "MuiLinearProgress",
  slot: "Bar2",
  overridesResolver: (C, e) => {
    const {
      ownerState: T
    } = C;
    return [e.bar, e[`barColor${capitalize$3(T.color)}`], (T.variant === "indeterminate" || T.variant === "query") && e.bar2Indeterminate, T.variant === "buffer" && e.bar2Buffer];
  }
})(({
  ownerState: C,
  theme: e
}) => _extends({
  width: "100%",
  position: "absolute",
  left: 0,
  bottom: 0,
  top: 0,
  transition: "transform 0.2s linear",
  transformOrigin: "left"
}, C.variant !== "buffer" && {
  backgroundColor: C.color === "inherit" ? "currentColor" : (e.vars || e).palette[C.color].main
}, C.color === "inherit" && {
  opacity: 0.3
}, C.variant === "buffer" && {
  backgroundColor: getColorShade(e, C.color),
  transition: `transform .${TRANSITION_DURATION}s linear`
}), ({
  ownerState: C
}) => (C.variant === "indeterminate" || C.variant === "query") && css(_t6 || (_t6 = _$1`
      width: auto;
      animation: ${0} 2.1s cubic-bezier(0.165, 0.84, 0.44, 1) 1.15s infinite;
    `), indeterminate2Keyframe)), LinearProgress = /* @__PURE__ */ React$1.forwardRef(function(e, T) {
  const $ = useDefaultProps({
    props: e,
    name: "MuiLinearProgress"
  }), {
    className: V,
    color: J = "primary",
    value: ee,
    valueBuffer: te,
    variant: re = "indeterminate"
  } = $, ie = _objectWithoutPropertiesLoose($, _excluded$k), se = _extends({}, $, {
    color: J,
    variant: re
  }), de = useUtilityClasses$i(se), ue = useRtl(), fe = {}, he = {
    bar1: {},
    bar2: {}
  };
  if (re === "determinate" || re === "buffer")
    if (ee !== void 0) {
      fe["aria-valuenow"] = Math.round(ee), fe["aria-valuemin"] = 0, fe["aria-valuemax"] = 100;
      let me = ee - 100;
      ue && (me = -me), he.bar1.transform = `translateX(${me}%)`;
    } else dist$2.process.env.NODE_ENV !== "production" && console.error("MUI: You need to provide a value prop when using the determinate or buffer variant of LinearProgress .");
  if (re === "buffer")
    if (te !== void 0) {
      let me = (te || 0) - 100;
      ue && (me = -me), he.bar2.transform = `translateX(${me}%)`;
    } else dist$2.process.env.NODE_ENV !== "production" && console.error("MUI: You need to provide a valueBuffer prop when using the buffer variant of LinearProgress.");
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(LinearProgressRoot, _extends({
    className: clsx(de.root, V),
    ownerState: se,
    role: "progressbar"
  }, fe, {
    ref: T
  }, ie, {
    children: [re === "buffer" ? /* @__PURE__ */ jsxRuntimeExports.jsx(LinearProgressDashed, {
      className: de.dashed,
      ownerState: se
    }) : null, /* @__PURE__ */ jsxRuntimeExports.jsx(LinearProgressBar1, {
      className: de.bar1,
      ownerState: se,
      style: he.bar1
    }), re === "determinate" ? null : /* @__PURE__ */ jsxRuntimeExports.jsx(LinearProgressBar2, {
      className: de.bar2,
      ownerState: se,
      style: he.bar2
    })]
  }));
});
dist$2.process.env.NODE_ENV !== "production" && (LinearProgress.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'primary'
   */
  color: PropTypes.oneOfType([PropTypes.oneOf(["inherit", "primary", "secondary"]), PropTypes.string]),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * The value of the progress indicator for the determinate and buffer variants.
   * Value between 0 and 100.
   */
  value: PropTypes.number,
  /**
   * The value for the buffer variant.
   * Value between 0 and 100.
   */
  valueBuffer: PropTypes.number,
  /**
   * The variant to use.
   * Use indeterminate or query when there is no progress value.
   * @default 'indeterminate'
   */
  variant: PropTypes.oneOf(["buffer", "determinate", "indeterminate", "query"])
});
function getLinkUtilityClass(C) {
  return generateUtilityClass("MuiLink", C);
}
const linkClasses = generateUtilityClasses("MuiLink", ["root", "underlineNone", "underlineHover", "underlineAlways", "button", "focusVisible"]), colorTransformations = {
  primary: "primary.main",
  textPrimary: "text.primary",
  secondary: "secondary.main",
  textSecondary: "text.secondary",
  error: "error.main"
}, transformDeprecatedColors = (C) => colorTransformations[C] || C, getTextDecoration = ({
  theme: C,
  ownerState: e
}) => {
  const T = transformDeprecatedColors(e.color), $ = getPath(C, `palette.${T}`, !1) || e.color, V = getPath(C, `palette.${T}Channel`);
  return "vars" in C && V ? `rgba(${V} / 0.4)` : alpha_1($, 0.4);
}, _excluded$j = ["className", "color", "component", "onBlur", "onFocus", "TypographyClasses", "underline", "variant", "sx"], useUtilityClasses$h = (C) => {
  const {
    classes: e,
    component: T,
    focusVisible: $,
    underline: V
  } = C, J = {
    root: ["root", `underline${capitalize$3(V)}`, T === "button" && "button", $ && "focusVisible"]
  };
  return composeClasses(J, getLinkUtilityClass, e);
}, LinkRoot = styled$1(Typography, {
  name: "MuiLink",
  slot: "Root",
  overridesResolver: (C, e) => {
    const {
      ownerState: T
    } = C;
    return [e.root, e[`underline${capitalize$3(T.underline)}`], T.component === "button" && e.button];
  }
})(({
  theme: C,
  ownerState: e
}) => _extends({}, e.underline === "none" && {
  textDecoration: "none"
}, e.underline === "hover" && {
  textDecoration: "none",
  "&:hover": {
    textDecoration: "underline"
  }
}, e.underline === "always" && _extends({
  textDecoration: "underline"
}, e.color !== "inherit" && {
  textDecorationColor: getTextDecoration({
    theme: C,
    ownerState: e
  })
}, {
  "&:hover": {
    textDecorationColor: "inherit"
  }
}), e.component === "button" && {
  position: "relative",
  WebkitTapHighlightColor: "transparent",
  backgroundColor: "transparent",
  // Reset default value
  // We disable the focus ring for mouse, touch and keyboard users.
  outline: 0,
  border: 0,
  margin: 0,
  // Remove the margin in Safari
  borderRadius: 0,
  padding: 0,
  // Remove the padding in Firefox
  cursor: "pointer",
  userSelect: "none",
  verticalAlign: "middle",
  MozAppearance: "none",
  // Reset
  WebkitAppearance: "none",
  // Reset
  "&::-moz-focus-inner": {
    borderStyle: "none"
    // Remove Firefox dotted outline.
  },
  [`&.${linkClasses.focusVisible}`]: {
    outline: "auto"
  }
})), Link = /* @__PURE__ */ React$1.forwardRef(function(e, T) {
  const $ = useDefaultProps({
    props: e,
    name: "MuiLink"
  }), {
    className: V,
    color: J = "primary",
    component: ee = "a",
    onBlur: te,
    onFocus: re,
    TypographyClasses: ie,
    underline: se = "always",
    variant: de = "inherit",
    sx: ue
  } = $, fe = _objectWithoutPropertiesLoose($, _excluded$j), {
    isFocusVisibleRef: he,
    onBlur: me,
    onFocus: xe,
    ref: ve
  } = useIsFocusVisible(), [Te, we] = React$1.useState(!1), Ee = useForkRef(T, ve), Me = (De) => {
    me(De), he.current === !1 && we(!1), te && te(De);
  }, Ie = (De) => {
    xe(De), he.current === !0 && we(!0), re && re(De);
  }, ke = _extends({}, $, {
    color: J,
    component: ee,
    focusVisible: Te,
    underline: se,
    variant: de
  }), _e = useUtilityClasses$h(ke);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(LinkRoot, _extends({
    color: J,
    className: clsx(_e.root, V),
    classes: ie,
    component: ee,
    onBlur: Me,
    onFocus: Ie,
    ref: Ee,
    ownerState: ke,
    variant: de,
    sx: [...Object.keys(colorTransformations).includes(J) ? [] : [{
      color: J
    }], ...Array.isArray(ue) ? ue : [ue]]
  }, fe));
});
dist$2.process.env.NODE_ENV !== "production" && (Link.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The color of the link.
   * @default 'primary'
   */
  color: PropTypes.any,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: elementTypeAcceptingRef$1,
  /**
   * @ignore
   */
  onBlur: PropTypes.func,
  /**
   * @ignore
   */
  onFocus: PropTypes.func,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * `classes` prop applied to the [`Typography`](/material-ui/api/typography/) element.
   */
  TypographyClasses: PropTypes.object,
  /**
   * Controls when the link should have an underline.
   * @default 'always'
   */
  underline: PropTypes.oneOf(["always", "hover", "none"]),
  /**
   * Applies the theme typography styles.
   * @default 'inherit'
   */
  variant: PropTypes.oneOfType([PropTypes.oneOf(["body1", "body2", "button", "caption", "h1", "h2", "h3", "h4", "h5", "h6", "inherit", "overline", "subtitle1", "subtitle2"]), PropTypes.string])
});
const ListContext = /* @__PURE__ */ React$1.createContext({});
dist$2.process.env.NODE_ENV !== "production" && (ListContext.displayName = "ListContext");
function getListUtilityClass(C) {
  return generateUtilityClass("MuiList", C);
}
generateUtilityClasses("MuiList", ["root", "padding", "dense", "subheader"]);
const _excluded$i = ["children", "className", "component", "dense", "disablePadding", "subheader"], useUtilityClasses$g = (C) => {
  const {
    classes: e,
    disablePadding: T,
    dense: $,
    subheader: V
  } = C;
  return composeClasses({
    root: ["root", !T && "padding", $ && "dense", V && "subheader"]
  }, getListUtilityClass, e);
}, ListRoot = styled$1("ul", {
  name: "MuiList",
  slot: "Root",
  overridesResolver: (C, e) => {
    const {
      ownerState: T
    } = C;
    return [e.root, !T.disablePadding && e.padding, T.dense && e.dense, T.subheader && e.subheader];
  }
})(({
  ownerState: C
}) => _extends({
  listStyle: "none",
  margin: 0,
  padding: 0,
  position: "relative"
}, !C.disablePadding && {
  paddingTop: 8,
  paddingBottom: 8
}, C.subheader && {
  paddingTop: 0
})), List = /* @__PURE__ */ React$1.forwardRef(function(e, T) {
  const $ = useDefaultProps({
    props: e,
    name: "MuiList"
  }), {
    children: V,
    className: J,
    component: ee = "ul",
    dense: te = !1,
    disablePadding: re = !1,
    subheader: ie
  } = $, se = _objectWithoutPropertiesLoose($, _excluded$i), de = React$1.useMemo(() => ({
    dense: te
  }), [te]), ue = _extends({}, $, {
    component: ee,
    dense: te,
    disablePadding: re
  }), fe = useUtilityClasses$g(ue);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(ListContext.Provider, {
    value: de,
    children: /* @__PURE__ */ jsxRuntimeExports.jsxs(ListRoot, _extends({
      as: ee,
      className: clsx(fe.root, J),
      ref: T,
      ownerState: ue
    }, se, {
      children: [ie, V]
    }))
  });
});
dist$2.process.env.NODE_ENV !== "production" && (List.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes.elementType,
  /**
   * If `true`, compact vertical padding designed for keyboard and mouse input is used for
   * the list and list items.
   * The prop is available to descendant components as the `dense` context.
   * @default false
   */
  dense: PropTypes.bool,
  /**
   * If `true`, vertical padding is removed from the list.
   * @default false
   */
  disablePadding: PropTypes.bool,
  /**
   * The content of the subheader, normally `ListSubheader`.
   */
  subheader: PropTypes.node,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object])
});
function getListItemUtilityClass(C) {
  return generateUtilityClass("MuiListItem", C);
}
const listItemClasses = generateUtilityClasses("MuiListItem", ["root", "container", "focusVisible", "dense", "alignItemsFlexStart", "disabled", "divider", "gutters", "padding", "button", "secondaryAction", "selected"]);
function getListItemButtonUtilityClass(C) {
  return generateUtilityClass("MuiListItemButton", C);
}
const listItemButtonClasses = generateUtilityClasses("MuiListItemButton", ["root", "focusVisible", "dense", "alignItemsFlexStart", "disabled", "divider", "gutters", "selected"]), _excluded$h = ["alignItems", "autoFocus", "component", "children", "dense", "disableGutters", "divider", "focusVisibleClassName", "selected", "className"], overridesResolver$2 = (C, e) => {
  const {
    ownerState: T
  } = C;
  return [e.root, T.dense && e.dense, T.alignItems === "flex-start" && e.alignItemsFlexStart, T.divider && e.divider, !T.disableGutters && e.gutters];
}, useUtilityClasses$f = (C) => {
  const {
    alignItems: e,
    classes: T,
    dense: $,
    disabled: V,
    disableGutters: J,
    divider: ee,
    selected: te
  } = C, ie = composeClasses({
    root: ["root", $ && "dense", !J && "gutters", ee && "divider", V && "disabled", e === "flex-start" && "alignItemsFlexStart", te && "selected"]
  }, getListItemButtonUtilityClass, T);
  return _extends({}, T, ie);
}, ListItemButtonRoot = styled$1(ButtonBase, {
  shouldForwardProp: (C) => rootShouldForwardProp(C) || C === "classes",
  name: "MuiListItemButton",
  slot: "Root",
  overridesResolver: overridesResolver$2
})(({
  theme: C,
  ownerState: e
}) => _extends({
  display: "flex",
  flexGrow: 1,
  justifyContent: "flex-start",
  alignItems: "center",
  position: "relative",
  textDecoration: "none",
  minWidth: 0,
  boxSizing: "border-box",
  textAlign: "left",
  paddingTop: 8,
  paddingBottom: 8,
  transition: C.transitions.create("background-color", {
    duration: C.transitions.duration.shortest
  }),
  "&:hover": {
    textDecoration: "none",
    backgroundColor: (C.vars || C).palette.action.hover,
    // Reset on touch devices, it doesn't add specificity
    "@media (hover: none)": {
      backgroundColor: "transparent"
    }
  },
  [`&.${listItemButtonClasses.selected}`]: {
    backgroundColor: C.vars ? `rgba(${C.vars.palette.primary.mainChannel} / ${C.vars.palette.action.selectedOpacity})` : alpha_1(C.palette.primary.main, C.palette.action.selectedOpacity),
    [`&.${listItemButtonClasses.focusVisible}`]: {
      backgroundColor: C.vars ? `rgba(${C.vars.palette.primary.mainChannel} / calc(${C.vars.palette.action.selectedOpacity} + ${C.vars.palette.action.focusOpacity}))` : alpha_1(C.palette.primary.main, C.palette.action.selectedOpacity + C.palette.action.focusOpacity)
    }
  },
  [`&.${listItemButtonClasses.selected}:hover`]: {
    backgroundColor: C.vars ? `rgba(${C.vars.palette.primary.mainChannel} / calc(${C.vars.palette.action.selectedOpacity} + ${C.vars.palette.action.hoverOpacity}))` : alpha_1(C.palette.primary.main, C.palette.action.selectedOpacity + C.palette.action.hoverOpacity),
    // Reset on touch devices, it doesn't add specificity
    "@media (hover: none)": {
      backgroundColor: C.vars ? `rgba(${C.vars.palette.primary.mainChannel} / ${C.vars.palette.action.selectedOpacity})` : alpha_1(C.palette.primary.main, C.palette.action.selectedOpacity)
    }
  },
  [`&.${listItemButtonClasses.focusVisible}`]: {
    backgroundColor: (C.vars || C).palette.action.focus
  },
  [`&.${listItemButtonClasses.disabled}`]: {
    opacity: (C.vars || C).palette.action.disabledOpacity
  }
}, e.divider && {
  borderBottom: `1px solid ${(C.vars || C).palette.divider}`,
  backgroundClip: "padding-box"
}, e.alignItems === "flex-start" && {
  alignItems: "flex-start"
}, !e.disableGutters && {
  paddingLeft: 16,
  paddingRight: 16
}, e.dense && {
  paddingTop: 4,
  paddingBottom: 4
})), ListItemButton = /* @__PURE__ */ React$1.forwardRef(function(e, T) {
  const $ = useDefaultProps({
    props: e,
    name: "MuiListItemButton"
  }), {
    alignItems: V = "center",
    autoFocus: J = !1,
    component: ee = "div",
    children: te,
    dense: re = !1,
    disableGutters: ie = !1,
    divider: se = !1,
    focusVisibleClassName: de,
    selected: ue = !1,
    className: fe
  } = $, he = _objectWithoutPropertiesLoose($, _excluded$h), me = React$1.useContext(ListContext), xe = React$1.useMemo(() => ({
    dense: re || me.dense || !1,
    alignItems: V,
    disableGutters: ie
  }), [V, me.dense, re, ie]), ve = React$1.useRef(null);
  useEnhancedEffect(() => {
    J && (ve.current ? ve.current.focus() : dist$2.process.env.NODE_ENV !== "production" && console.error("MUI: Unable to set focus to a ListItemButton whose component has not been rendered."));
  }, [J]);
  const Te = _extends({}, $, {
    alignItems: V,
    dense: xe.dense,
    disableGutters: ie,
    divider: se,
    selected: ue
  }), we = useUtilityClasses$f(Te), Ee = useForkRef(ve, T);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(ListContext.Provider, {
    value: xe,
    children: /* @__PURE__ */ jsxRuntimeExports.jsx(ListItemButtonRoot, _extends({
      ref: Ee,
      href: he.href || he.to,
      component: (he.href || he.to) && ee === "div" ? "button" : ee,
      focusVisibleClassName: clsx(we.focusVisible, de),
      ownerState: Te,
      className: clsx(we.root, fe)
    }, he, {
      classes: we,
      children: te
    }))
  });
});
dist$2.process.env.NODE_ENV !== "production" && (ListItemButton.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Defines the `align-items` style property.
   * @default 'center'
   */
  alignItems: PropTypes.oneOf(["center", "flex-start"]),
  /**
   * If `true`, the list item is focused during the first mount.
   * Focus will also be triggered if the value changes from false to true.
   * @default false
   */
  autoFocus: PropTypes.bool,
  /**
   * The content of the component if a `ListItemSecondaryAction` is used it must
   * be the last child.
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes.elementType,
  /**
   * If `true`, compact vertical padding designed for keyboard and mouse input is used.
   * The prop defaults to the value inherited from the parent List component.
   * @default false
   */
  dense: PropTypes.bool,
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: PropTypes.bool,
  /**
   * If `true`, the left and right padding is removed.
   * @default false
   */
  disableGutters: PropTypes.bool,
  /**
   * If `true`, a 1px light border is added to the bottom of the list item.
   * @default false
   */
  divider: PropTypes.bool,
  /**
   * This prop can help identify which element has keyboard focus.
   * The class name will be applied when the element gains the focus through keyboard interaction.
   * It's a polyfill for the [CSS :focus-visible selector](https://drafts.csswg.org/selectors-4/#the-focus-visible-pseudo).
   * The rationale for using this feature [is explained here](https://github.com/WICG/focus-visible/blob/HEAD/explainer.md).
   * A [polyfill can be used](https://github.com/WICG/focus-visible) to apply a `focus-visible` class to other components
   * if needed.
   */
  focusVisibleClassName: PropTypes.string,
  /**
   * @ignore
   */
  href: PropTypes.string,
  /**
   * Use to apply selected styling.
   * @default false
   */
  selected: PropTypes.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object])
});
function getListItemSecondaryActionClassesUtilityClass(C) {
  return generateUtilityClass("MuiListItemSecondaryAction", C);
}
generateUtilityClasses("MuiListItemSecondaryAction", ["root", "disableGutters"]);
const _excluded$g = ["className"], useUtilityClasses$e = (C) => {
  const {
    disableGutters: e,
    classes: T
  } = C;
  return composeClasses({
    root: ["root", e && "disableGutters"]
  }, getListItemSecondaryActionClassesUtilityClass, T);
}, ListItemSecondaryActionRoot = styled$1("div", {
  name: "MuiListItemSecondaryAction",
  slot: "Root",
  overridesResolver: (C, e) => {
    const {
      ownerState: T
    } = C;
    return [e.root, T.disableGutters && e.disableGutters];
  }
})(({
  ownerState: C
}) => _extends({
  position: "absolute",
  right: 16,
  top: "50%",
  transform: "translateY(-50%)"
}, C.disableGutters && {
  right: 0
})), ListItemSecondaryAction = /* @__PURE__ */ React$1.forwardRef(function(e, T) {
  const $ = useDefaultProps({
    props: e,
    name: "MuiListItemSecondaryAction"
  }), {
    className: V
  } = $, J = _objectWithoutPropertiesLoose($, _excluded$g), ee = React$1.useContext(ListContext), te = _extends({}, $, {
    disableGutters: ee.disableGutters
  }), re = useUtilityClasses$e(te);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(ListItemSecondaryActionRoot, _extends({
    className: clsx(re.root, V),
    ownerState: te,
    ref: T
  }, J));
});
dist$2.process.env.NODE_ENV !== "production" && (ListItemSecondaryAction.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component, normally an `IconButton` or selection control.
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object])
});
ListItemSecondaryAction.muiName = "ListItemSecondaryAction";
const _excluded$f = ["className"], _excluded2$3 = ["alignItems", "autoFocus", "button", "children", "className", "component", "components", "componentsProps", "ContainerComponent", "ContainerProps", "dense", "disabled", "disableGutters", "disablePadding", "divider", "focusVisibleClassName", "secondaryAction", "selected", "slotProps", "slots"], overridesResolver$1 = (C, e) => {
  const {
    ownerState: T
  } = C;
  return [e.root, T.dense && e.dense, T.alignItems === "flex-start" && e.alignItemsFlexStart, T.divider && e.divider, !T.disableGutters && e.gutters, !T.disablePadding && e.padding, T.button && e.button, T.hasSecondaryAction && e.secondaryAction];
}, useUtilityClasses$d = (C) => {
  const {
    alignItems: e,
    button: T,
    classes: $,
    dense: V,
    disabled: J,
    disableGutters: ee,
    disablePadding: te,
    divider: re,
    hasSecondaryAction: ie,
    selected: se
  } = C;
  return composeClasses({
    root: ["root", V && "dense", !ee && "gutters", !te && "padding", re && "divider", J && "disabled", T && "button", e === "flex-start" && "alignItemsFlexStart", ie && "secondaryAction", se && "selected"],
    container: ["container"]
  }, getListItemUtilityClass, $);
}, ListItemRoot = styled$1("div", {
  name: "MuiListItem",
  slot: "Root",
  overridesResolver: overridesResolver$1
})(({
  theme: C,
  ownerState: e
}) => _extends({
  display: "flex",
  justifyContent: "flex-start",
  alignItems: "center",
  position: "relative",
  textDecoration: "none",
  width: "100%",
  boxSizing: "border-box",
  textAlign: "left"
}, !e.disablePadding && _extends({
  paddingTop: 8,
  paddingBottom: 8
}, e.dense && {
  paddingTop: 4,
  paddingBottom: 4
}, !e.disableGutters && {
  paddingLeft: 16,
  paddingRight: 16
}, !!e.secondaryAction && {
  // Add some space to avoid collision as `ListItemSecondaryAction`
  // is absolutely positioned.
  paddingRight: 48
}), !!e.secondaryAction && {
  [`& > .${listItemButtonClasses.root}`]: {
    paddingRight: 48
  }
}, {
  [`&.${listItemClasses.focusVisible}`]: {
    backgroundColor: (C.vars || C).palette.action.focus
  },
  [`&.${listItemClasses.selected}`]: {
    backgroundColor: C.vars ? `rgba(${C.vars.palette.primary.mainChannel} / ${C.vars.palette.action.selectedOpacity})` : alpha_1(C.palette.primary.main, C.palette.action.selectedOpacity),
    [`&.${listItemClasses.focusVisible}`]: {
      backgroundColor: C.vars ? `rgba(${C.vars.palette.primary.mainChannel} / calc(${C.vars.palette.action.selectedOpacity} + ${C.vars.palette.action.focusOpacity}))` : alpha_1(C.palette.primary.main, C.palette.action.selectedOpacity + C.palette.action.focusOpacity)
    }
  },
  [`&.${listItemClasses.disabled}`]: {
    opacity: (C.vars || C).palette.action.disabledOpacity
  }
}, e.alignItems === "flex-start" && {
  alignItems: "flex-start"
}, e.divider && {
  borderBottom: `1px solid ${(C.vars || C).palette.divider}`,
  backgroundClip: "padding-box"
}, e.button && {
  transition: C.transitions.create("background-color", {
    duration: C.transitions.duration.shortest
  }),
  "&:hover": {
    textDecoration: "none",
    backgroundColor: (C.vars || C).palette.action.hover,
    // Reset on touch devices, it doesn't add specificity
    "@media (hover: none)": {
      backgroundColor: "transparent"
    }
  },
  [`&.${listItemClasses.selected}:hover`]: {
    backgroundColor: C.vars ? `rgba(${C.vars.palette.primary.mainChannel} / calc(${C.vars.palette.action.selectedOpacity} + ${C.vars.palette.action.hoverOpacity}))` : alpha_1(C.palette.primary.main, C.palette.action.selectedOpacity + C.palette.action.hoverOpacity),
    // Reset on touch devices, it doesn't add specificity
    "@media (hover: none)": {
      backgroundColor: C.vars ? `rgba(${C.vars.palette.primary.mainChannel} / ${C.vars.palette.action.selectedOpacity})` : alpha_1(C.palette.primary.main, C.palette.action.selectedOpacity)
    }
  }
}, e.hasSecondaryAction && {
  // Add some space to avoid collision as `ListItemSecondaryAction`
  // is absolutely positioned.
  paddingRight: 48
})), ListItemContainer = styled$1("li", {
  name: "MuiListItem",
  slot: "Container",
  overridesResolver: (C, e) => e.container
})({
  position: "relative"
}), ListItem = /* @__PURE__ */ React$1.forwardRef(function(e, T) {
  const $ = useDefaultProps({
    props: e,
    name: "MuiListItem"
  }), {
    alignItems: V = "center",
    autoFocus: J = !1,
    button: ee = !1,
    children: te,
    className: re,
    component: ie,
    components: se = {},
    componentsProps: de = {},
    ContainerComponent: ue = "li",
    ContainerProps: {
      className: fe
    } = {},
    dense: he = !1,
    disabled: me = !1,
    disableGutters: xe = !1,
    disablePadding: ve = !1,
    divider: Te = !1,
    focusVisibleClassName: we,
    secondaryAction: Ee,
    selected: Me = !1,
    slotProps: Ie = {},
    slots: ke = {}
  } = $, _e = _objectWithoutPropertiesLoose($.ContainerProps, _excluded$f), De = _objectWithoutPropertiesLoose($, _excluded2$3), Fe = React$1.useContext(ListContext), Ae = React$1.useMemo(() => ({
    dense: he || Fe.dense || !1,
    alignItems: V,
    disableGutters: xe
  }), [V, Fe.dense, he, xe]), ne = React$1.useRef(null);
  useEnhancedEffect(() => {
    J && (ne.current ? ne.current.focus() : dist$2.process.env.NODE_ENV !== "production" && console.error("MUI: Unable to set focus to a ListItem whose component has not been rendered."));
  }, [J]);
  const oe = React$1.Children.toArray(te), ce = oe.length && isMuiElement(oe[oe.length - 1], ["ListItemSecondaryAction"]), le = _extends({}, $, {
    alignItems: V,
    autoFocus: J,
    button: ee,
    dense: Ae.dense,
    disabled: me,
    disableGutters: xe,
    disablePadding: ve,
    divider: Te,
    hasSecondaryAction: ce,
    selected: Me
  }), pe = useUtilityClasses$d(le), ye = useForkRef(ne, T), Ce = ke.root || se.Root || ListItemRoot, be = Ie.root || de.root || {}, ae = _extends({
    className: clsx(pe.root, be.className, re),
    disabled: me
  }, De);
  let ge = ie || "li";
  return ee && (ae.component = ie || "div", ae.focusVisibleClassName = clsx(listItemClasses.focusVisible, we), ge = ButtonBase), ce ? (ge = !ae.component && !ie ? "div" : ge, ue === "li" && (ge === "li" ? ge = "div" : ae.component === "li" && (ae.component = "div")), /* @__PURE__ */ jsxRuntimeExports.jsx(ListContext.Provider, {
    value: Ae,
    children: /* @__PURE__ */ jsxRuntimeExports.jsxs(ListItemContainer, _extends({
      as: ue,
      className: clsx(pe.container, fe),
      ref: ye,
      ownerState: le
    }, _e, {
      children: [/* @__PURE__ */ jsxRuntimeExports.jsx(Ce, _extends({}, be, !isHostComponent(Ce) && {
        as: ge,
        ownerState: _extends({}, le, be.ownerState)
      }, ae, {
        children: oe
      })), oe.pop()]
    }))
  })) : /* @__PURE__ */ jsxRuntimeExports.jsx(ListContext.Provider, {
    value: Ae,
    children: /* @__PURE__ */ jsxRuntimeExports.jsxs(Ce, _extends({}, be, {
      as: ge,
      ref: ye
    }, !isHostComponent(Ce) && {
      ownerState: _extends({}, le, be.ownerState)
    }, ae, {
      children: [oe, Ee && /* @__PURE__ */ jsxRuntimeExports.jsx(ListItemSecondaryAction, {
        children: Ee
      })]
    }))
  });
});
dist$2.process.env.NODE_ENV !== "production" && (ListItem.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Defines the `align-items` style property.
   * @default 'center'
   */
  alignItems: PropTypes.oneOf(["center", "flex-start"]),
  /**
   * If `true`, the list item is focused during the first mount.
   * Focus will also be triggered if the value changes from false to true.
   * @default false
   * @deprecated checkout [ListItemButton](/material-ui/api/list-item-button/) instead
   */
  autoFocus: PropTypes.bool,
  /**
   * If `true`, the list item is a button (using `ButtonBase`). Props intended
   * for `ButtonBase` can then be applied to `ListItem`.
   * @default false
   * @deprecated checkout [ListItemButton](/material-ui/api/list-item-button/) instead
   */
  button: PropTypes.bool,
  /**
   * The content of the component if a `ListItemSecondaryAction` is used it must
   * be the last child.
   */
  children: chainPropTypes(PropTypes.node, (C) => {
    const e = React$1.Children.toArray(C.children);
    let T = -1;
    for (let $ = e.length - 1; $ >= 0; $ -= 1) {
      const V = e[$];
      if (isMuiElement(V, ["ListItemSecondaryAction"])) {
        T = $;
        break;
      }
    }
    return T !== -1 && T !== e.length - 1 ? new Error("MUI: You used an element after ListItemSecondaryAction. For ListItem to detect that it has a secondary action you must pass it as the last child to ListItem.") : null;
  }),
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes.elementType,
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `slots` prop.
   * It's recommended to use the `slots` prop instead.
   *
   * @default {}
   */
  components: PropTypes.shape({
    Root: PropTypes.elementType
  }),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * This prop is an alias for the `slotProps` prop.
   * It's recommended to use the `slotProps` prop instead, as `componentsProps` will be deprecated in the future.
   *
   * @default {}
   */
  componentsProps: PropTypes.shape({
    root: PropTypes.object
  }),
  /**
   * The container component used when a `ListItemSecondaryAction` is the last child.
   * @default 'li'
   * @deprecated
   */
  ContainerComponent: elementTypeAcceptingRef$1,
  /**
   * Props applied to the container component if used.
   * @default {}
   * @deprecated
   */
  ContainerProps: PropTypes.object,
  /**
   * If `true`, compact vertical padding designed for keyboard and mouse input is used.
   * The prop defaults to the value inherited from the parent List component.
   * @default false
   */
  dense: PropTypes.bool,
  /**
   * If `true`, the component is disabled.
   * @default false
   * @deprecated checkout [ListItemButton](/material-ui/api/list-item-button/) instead
   */
  disabled: PropTypes.bool,
  /**
   * If `true`, the left and right padding is removed.
   * @default false
   */
  disableGutters: PropTypes.bool,
  /**
   * If `true`, all padding is removed.
   * @default false
   */
  disablePadding: PropTypes.bool,
  /**
   * If `true`, a 1px light border is added to the bottom of the list item.
   * @default false
   */
  divider: PropTypes.bool,
  /**
   * @ignore
   */
  focusVisibleClassName: PropTypes.string,
  /**
   * The element to display at the end of ListItem.
   */
  secondaryAction: PropTypes.node,
  /**
   * Use to apply selected styling.
   * @default false
   * @deprecated checkout [ListItemButton](/material-ui/api/list-item-button/) instead
   */
  selected: PropTypes.bool,
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * This prop is an alias for the `componentsProps` prop, which will be deprecated in the future.
   *
   * @default {}
   */
  slotProps: PropTypes.shape({
    root: PropTypes.object
  }),
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `components` prop, which will be deprecated in the future.
   *
   * @default {}
   */
  slots: PropTypes.shape({
    root: PropTypes.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object])
});
function getListItemIconUtilityClass(C) {
  return generateUtilityClass("MuiListItemIcon", C);
}
const listItemIconClasses = generateUtilityClasses("MuiListItemIcon", ["root", "alignItemsFlexStart"]), _excluded$e = ["className"], useUtilityClasses$c = (C) => {
  const {
    alignItems: e,
    classes: T
  } = C;
  return composeClasses({
    root: ["root", e === "flex-start" && "alignItemsFlexStart"]
  }, getListItemIconUtilityClass, T);
}, ListItemIconRoot = styled$1("div", {
  name: "MuiListItemIcon",
  slot: "Root",
  overridesResolver: (C, e) => {
    const {
      ownerState: T
    } = C;
    return [e.root, T.alignItems === "flex-start" && e.alignItemsFlexStart];
  }
})(({
  theme: C,
  ownerState: e
}) => _extends({
  minWidth: 56,
  color: (C.vars || C).palette.action.active,
  flexShrink: 0,
  display: "inline-flex"
}, e.alignItems === "flex-start" && {
  marginTop: 8
})), ListItemIcon = /* @__PURE__ */ React$1.forwardRef(function(e, T) {
  const $ = useDefaultProps({
    props: e,
    name: "MuiListItemIcon"
  }), {
    className: V
  } = $, J = _objectWithoutPropertiesLoose($, _excluded$e), ee = React$1.useContext(ListContext), te = _extends({}, $, {
    alignItems: ee.alignItems
  }), re = useUtilityClasses$c(te);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(ListItemIconRoot, _extends({
    className: clsx(re.root, V),
    ownerState: te,
    ref: T
  }, J));
});
dist$2.process.env.NODE_ENV !== "production" && (ListItemIcon.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component, normally `Icon`, `SvgIcon`,
   * or a `@mui/icons-material` SVG icon element.
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object])
});
const listItemTextClasses = generateUtilityClasses("MuiListItemText", ["root", "multiline", "dense", "inset", "primary", "secondary"]), _excluded$d = ["actions", "autoFocus", "autoFocusItem", "children", "className", "disabledItemsFocusable", "disableListWrap", "onKeyDown", "variant"];
function nextItem(C, e, T) {
  return C === e ? C.firstChild : e && e.nextElementSibling ? e.nextElementSibling : T ? null : C.firstChild;
}
function previousItem(C, e, T) {
  return C === e ? T ? C.firstChild : C.lastChild : e && e.previousElementSibling ? e.previousElementSibling : T ? null : C.lastChild;
}
function textCriteriaMatches(C, e) {
  if (e === void 0)
    return !0;
  let T = C.innerText;
  return T === void 0 && (T = C.textContent), T = T.trim().toLowerCase(), T.length === 0 ? !1 : e.repeating ? T[0] === e.keys[0] : T.indexOf(e.keys.join("")) === 0;
}
function moveFocus(C, e, T, $, V, J) {
  let ee = !1, te = V(C, e, e ? T : !1);
  for (; te; ) {
    if (te === C.firstChild) {
      if (ee)
        return !1;
      ee = !0;
    }
    const re = $ ? !1 : te.disabled || te.getAttribute("aria-disabled") === "true";
    if (!te.hasAttribute("tabindex") || !textCriteriaMatches(te, J) || re)
      te = V(C, te, T);
    else
      return te.focus(), !0;
  }
  return !1;
}
const MenuList = /* @__PURE__ */ React$1.forwardRef(function(e, T) {
  const {
    // private
    // eslint-disable-next-line react/prop-types
    actions: $,
    autoFocus: V = !1,
    autoFocusItem: J = !1,
    children: ee,
    className: te,
    disabledItemsFocusable: re = !1,
    disableListWrap: ie = !1,
    onKeyDown: se,
    variant: de = "selectedMenu"
  } = e, ue = _objectWithoutPropertiesLoose(e, _excluded$d), fe = React$1.useRef(null), he = React$1.useRef({
    keys: [],
    repeating: !0,
    previousKeyMatched: !0,
    lastTime: null
  });
  useEnhancedEffect(() => {
    V && fe.current.focus();
  }, [V]), React$1.useImperativeHandle($, () => ({
    adjustStyleForScrollbar: (we, {
      direction: Ee
    }) => {
      const Me = !fe.current.style.width;
      if (we.clientHeight < fe.current.clientHeight && Me) {
        const Ie = `${getScrollbarSize(ownerDocument(we))}px`;
        fe.current.style[Ee === "rtl" ? "paddingLeft" : "paddingRight"] = Ie, fe.current.style.width = `calc(100% + ${Ie})`;
      }
      return fe.current;
    }
  }), []);
  const me = (we) => {
    const Ee = fe.current, Me = we.key, Ie = ownerDocument(Ee).activeElement;
    if (Me === "ArrowDown")
      we.preventDefault(), moveFocus(Ee, Ie, ie, re, nextItem);
    else if (Me === "ArrowUp")
      we.preventDefault(), moveFocus(Ee, Ie, ie, re, previousItem);
    else if (Me === "Home")
      we.preventDefault(), moveFocus(Ee, null, ie, re, nextItem);
    else if (Me === "End")
      we.preventDefault(), moveFocus(Ee, null, ie, re, previousItem);
    else if (Me.length === 1) {
      const ke = he.current, _e = Me.toLowerCase(), De = performance.now();
      ke.keys.length > 0 && (De - ke.lastTime > 500 ? (ke.keys = [], ke.repeating = !0, ke.previousKeyMatched = !0) : ke.repeating && _e !== ke.keys[0] && (ke.repeating = !1)), ke.lastTime = De, ke.keys.push(_e);
      const Fe = Ie && !ke.repeating && textCriteriaMatches(Ie, ke);
      ke.previousKeyMatched && (Fe || moveFocus(Ee, Ie, !1, re, nextItem, ke)) ? we.preventDefault() : ke.previousKeyMatched = !1;
    }
    se && se(we);
  }, xe = useForkRef(fe, T);
  let ve = -1;
  React$1.Children.forEach(ee, (we, Ee) => {
    if (!/* @__PURE__ */ React$1.isValidElement(we)) {
      ve === Ee && (ve += 1, ve >= ee.length && (ve = -1));
      return;
    }
    dist$2.process.env.NODE_ENV !== "production" && reactIsExports.isFragment(we) && console.error(["MUI: The Menu component doesn't accept a Fragment as a child.", "Consider providing an array instead."].join(`
`)), we.props.disabled || (de === "selectedMenu" && we.props.selected || ve === -1) && (ve = Ee), ve === Ee && (we.props.disabled || we.props.muiSkipListHighlight || we.type.muiSkipListHighlight) && (ve += 1, ve >= ee.length && (ve = -1));
  });
  const Te = React$1.Children.map(ee, (we, Ee) => {
    if (Ee === ve) {
      const Me = {};
      return J && (Me.autoFocus = !0), we.props.tabIndex === void 0 && de === "selectedMenu" && (Me.tabIndex = 0), /* @__PURE__ */ React$1.cloneElement(we, Me);
    }
    return we;
  });
  return /* @__PURE__ */ jsxRuntimeExports.jsx(List, _extends({
    role: "menu",
    ref: xe,
    className: te,
    onKeyDown: me,
    tabIndex: V ? 0 : -1
  }, ue, {
    children: Te
  }));
});
dist$2.process.env.NODE_ENV !== "production" && (MenuList.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * If `true`, will focus the `[role="menu"]` container and move into tab order.
   * @default false
   */
  autoFocus: PropTypes.bool,
  /**
   * If `true`, will focus the first menuitem if `variant="menu"` or selected item
   * if `variant="selectedMenu"`.
   * @default false
   */
  autoFocusItem: PropTypes.bool,
  /**
   * MenuList contents, normally `MenuItem`s.
   */
  children: PropTypes.node,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * If `true`, will allow focus on disabled items.
   * @default false
   */
  disabledItemsFocusable: PropTypes.bool,
  /**
   * If `true`, the menu items will not wrap focus.
   * @default false
   */
  disableListWrap: PropTypes.bool,
  /**
   * @ignore
   */
  onKeyDown: PropTypes.func,
  /**
   * The variant to use. Use `menu` to prevent selected items from impacting the initial focus
   * and the vertical alignment relative to the anchor element.
   * @default 'selectedMenu'
   */
  variant: PropTypes.oneOf(["menu", "selectedMenu"])
});
function getPopoverUtilityClass(C) {
  return generateUtilityClass("MuiPopover", C);
}
generateUtilityClasses("MuiPopover", ["root", "paper"]);
const _excluded$c = ["onEntering"], _excluded2$2 = ["action", "anchorEl", "anchorOrigin", "anchorPosition", "anchorReference", "children", "className", "container", "elevation", "marginThreshold", "open", "PaperProps", "slots", "slotProps", "transformOrigin", "TransitionComponent", "transitionDuration", "TransitionProps", "disableScrollLock"], _excluded3 = ["slotProps"];
function getOffsetTop(C, e) {
  let T = 0;
  return typeof e == "number" ? T = e : e === "center" ? T = C.height / 2 : e === "bottom" && (T = C.height), T;
}
function getOffsetLeft(C, e) {
  let T = 0;
  return typeof e == "number" ? T = e : e === "center" ? T = C.width / 2 : e === "right" && (T = C.width), T;
}
function getTransformOriginValue(C) {
  return [C.horizontal, C.vertical].map((e) => typeof e == "number" ? `${e}px` : e).join(" ");
}
function resolveAnchorEl(C) {
  return typeof C == "function" ? C() : C;
}
const useUtilityClasses$b = (C) => {
  const {
    classes: e
  } = C;
  return composeClasses({
    root: ["root"],
    paper: ["paper"]
  }, getPopoverUtilityClass, e);
}, PopoverRoot = styled$1(Modal, {
  name: "MuiPopover",
  slot: "Root",
  overridesResolver: (C, e) => e.root
})({}), PopoverPaper = styled$1(Paper, {
  name: "MuiPopover",
  slot: "Paper",
  overridesResolver: (C, e) => e.paper
})({
  position: "absolute",
  overflowY: "auto",
  overflowX: "hidden",
  // So we see the popover when it's empty.
  // It's most likely on issue on userland.
  minWidth: 16,
  minHeight: 16,
  maxWidth: "calc(100% - 32px)",
  maxHeight: "calc(100% - 32px)",
  // We disable the focus ring for mouse, touch and keyboard users.
  outline: 0
}), Popover = /* @__PURE__ */ React$1.forwardRef(function(e, T) {
  var $, V, J;
  const ee = useDefaultProps({
    props: e,
    name: "MuiPopover"
  }), {
    action: te,
    anchorEl: re,
    anchorOrigin: ie = {
      vertical: "top",
      horizontal: "left"
    },
    anchorPosition: se,
    anchorReference: de = "anchorEl",
    children: ue,
    className: fe,
    container: he,
    elevation: me = 8,
    marginThreshold: xe = 16,
    open: ve,
    PaperProps: Te = {},
    slots: we,
    slotProps: Ee,
    transformOrigin: Me = {
      vertical: "top",
      horizontal: "left"
    },
    TransitionComponent: Ie = Grow,
    transitionDuration: ke = "auto",
    TransitionProps: {
      onEntering: _e
    } = {},
    disableScrollLock: De = !1
  } = ee, Fe = _objectWithoutPropertiesLoose(ee.TransitionProps, _excluded$c), Ae = _objectWithoutPropertiesLoose(ee, _excluded2$2), ne = ($ = Ee == null ? void 0 : Ee.paper) != null ? $ : Te, oe = React$1.useRef(), ce = useForkRef(oe, ne.ref), le = _extends({}, ee, {
    anchorOrigin: ie,
    anchorReference: de,
    elevation: me,
    marginThreshold: xe,
    externalPaperSlotProps: ne,
    transformOrigin: Me,
    TransitionComponent: Ie,
    transitionDuration: ke,
    TransitionProps: Fe
  }), pe = useUtilityClasses$b(le), ye = React$1.useCallback(() => {
    if (de === "anchorPosition")
      return dist$2.process.env.NODE_ENV !== "production" && (se || console.error('MUI: You need to provide a `anchorPosition` prop when using <Popover anchorReference="anchorPosition" />.')), se;
    const Ye = resolveAnchorEl(re), Je = Ye && Ye.nodeType === 1 ? Ye : ownerDocument(oe.current).body, Xe = Je.getBoundingClientRect();
    if (dist$2.process.env.NODE_ENV !== "production") {
      const st = Je.getBoundingClientRect();
      dist$2.process.env.NODE_ENV !== "test" && st.top === 0 && st.left === 0 && st.right === 0 && st.bottom === 0 && console.warn(["MUI: The `anchorEl` prop provided to the component is invalid.", "The anchor element should be part of the document layout.", "Make sure the element is present in the document or that it's not display none."].join(`
`));
    }
    return {
      top: Xe.top + getOffsetTop(Xe, ie.vertical),
      left: Xe.left + getOffsetLeft(Xe, ie.horizontal)
    };
  }, [re, ie.horizontal, ie.vertical, se, de]), Ce = React$1.useCallback((Ye) => ({
    vertical: getOffsetTop(Ye, Me.vertical),
    horizontal: getOffsetLeft(Ye, Me.horizontal)
  }), [Me.horizontal, Me.vertical]), be = React$1.useCallback((Ye) => {
    const Je = {
      width: Ye.offsetWidth,
      height: Ye.offsetHeight
    }, Xe = Ce(Je);
    if (de === "none")
      return {
        top: null,
        left: null,
        transformOrigin: getTransformOriginValue(Xe)
      };
    const st = ye();
    let ct = st.top - Xe.vertical, it = st.left - Xe.horizontal;
    const ot = ct + Je.height, yt = it + Je.width, dt = ownerWindow(resolveAnchorEl(re)), mt = dt.innerHeight - xe, It = dt.innerWidth - xe;
    if (xe !== null && ct < xe) {
      const xt = ct - xe;
      ct -= xt, Xe.vertical += xt;
    } else if (xe !== null && ot > mt) {
      const xt = ot - mt;
      ct -= xt, Xe.vertical += xt;
    }
    if (dist$2.process.env.NODE_ENV !== "production" && Je.height > mt && Je.height && mt && console.error(["MUI: The popover component is too tall.", `Some part of it can not be seen on the screen (${Je.height - mt}px).`, "Please consider adding a `max-height` to improve the user-experience."].join(`
`)), xe !== null && it < xe) {
      const xt = it - xe;
      it -= xt, Xe.horizontal += xt;
    } else if (yt > It) {
      const xt = yt - It;
      it -= xt, Xe.horizontal += xt;
    }
    return {
      top: `${Math.round(ct)}px`,
      left: `${Math.round(it)}px`,
      transformOrigin: getTransformOriginValue(Xe)
    };
  }, [re, de, ye, Ce, xe]), [ae, ge] = React$1.useState(ve), Se = React$1.useCallback(() => {
    const Ye = oe.current;
    if (!Ye)
      return;
    const Je = be(Ye);
    Je.top !== null && (Ye.style.top = Je.top), Je.left !== null && (Ye.style.left = Je.left), Ye.style.transformOrigin = Je.transformOrigin, ge(!0);
  }, [be]);
  React$1.useEffect(() => (De && window.addEventListener("scroll", Se), () => window.removeEventListener("scroll", Se)), [re, De, Se]);
  const Le = (Ye, Je) => {
    _e && _e(Ye, Je), Se();
  }, ze = () => {
    ge(!1);
  };
  React$1.useEffect(() => {
    ve && Se();
  }), React$1.useImperativeHandle(te, () => ve ? {
    updatePosition: () => {
      Se();
    }
  } : null, [ve, Se]), React$1.useEffect(() => {
    if (!ve)
      return;
    const Ye = debounce$1(() => {
      Se();
    }), Je = ownerWindow(re);
    return Je.addEventListener("resize", Ye), () => {
      Ye.clear(), Je.removeEventListener("resize", Ye);
    };
  }, [re, ve, Se]);
  let Re = ke;
  ke === "auto" && !Ie.muiSupportAuto && (Re = void 0);
  const We = he || (re ? ownerDocument(resolveAnchorEl(re)).body : void 0), Be = (V = we == null ? void 0 : we.root) != null ? V : PopoverRoot, Ue = (J = we == null ? void 0 : we.paper) != null ? J : PopoverPaper, Ge = useSlotProps({
    elementType: Ue,
    externalSlotProps: _extends({}, ne, {
      style: ae ? ne.style : _extends({}, ne.style, {
        opacity: 0
      })
    }),
    additionalProps: {
      elevation: me,
      ref: ce
    },
    ownerState: le,
    className: clsx(pe.paper, ne == null ? void 0 : ne.className)
  }), je = useSlotProps({
    elementType: Be,
    externalSlotProps: (Ee == null ? void 0 : Ee.root) || {},
    externalForwardedProps: Ae,
    additionalProps: {
      ref: T,
      slotProps: {
        backdrop: {
          invisible: !0
        }
      },
      container: We,
      open: ve
    },
    ownerState: le,
    className: clsx(pe.root, fe)
  }), {
    slotProps: Oe
  } = je, Ne = _objectWithoutPropertiesLoose(je, _excluded3);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(Be, _extends({}, Ne, !isHostComponent(Be) && {
    slotProps: Oe,
    disableScrollLock: De
  }, {
    children: /* @__PURE__ */ jsxRuntimeExports.jsx(Ie, _extends({
      appear: !0,
      in: ve,
      onEntering: Le,
      onExited: ze,
      timeout: Re
    }, Fe, {
      children: /* @__PURE__ */ jsxRuntimeExports.jsx(Ue, _extends({}, Ge, {
        children: ue
      }))
    }))
  }));
});
dist$2.process.env.NODE_ENV !== "production" && (Popover.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * A ref for imperative actions.
   * It currently only supports updatePosition() action.
   */
  action: refType,
  /**
   * An HTML element, [PopoverVirtualElement](/material-ui/react-popover/#virtual-element),
   * or a function that returns either.
   * It's used to set the position of the popover.
   */
  anchorEl: chainPropTypes(PropTypes.oneOfType([HTMLElementType, PropTypes.func]), (C) => {
    if (C.open && (!C.anchorReference || C.anchorReference === "anchorEl")) {
      const e = resolveAnchorEl(C.anchorEl);
      if (e && e.nodeType === 1) {
        const T = e.getBoundingClientRect();
        if (dist$2.process.env.NODE_ENV !== "test" && T.top === 0 && T.left === 0 && T.right === 0 && T.bottom === 0)
          return new Error(["MUI: The `anchorEl` prop provided to the component is invalid.", "The anchor element should be part of the document layout.", "Make sure the element is present in the document or that it's not display none."].join(`
`));
      } else
        return new Error(["MUI: The `anchorEl` prop provided to the component is invalid.", `It should be an Element or PopoverVirtualElement instance but it's \`${e}\` instead.`].join(`
`));
    }
    return null;
  }),
  /**
   * This is the point on the anchor where the popover's
   * `anchorEl` will attach to. This is not used when the
   * anchorReference is 'anchorPosition'.
   *
   * Options:
   * vertical: [top, center, bottom];
   * horizontal: [left, center, right].
   * @default {
   *   vertical: 'top',
   *   horizontal: 'left',
   * }
   */
  anchorOrigin: PropTypes.shape({
    horizontal: PropTypes.oneOfType([PropTypes.oneOf(["center", "left", "right"]), PropTypes.number]).isRequired,
    vertical: PropTypes.oneOfType([PropTypes.oneOf(["bottom", "center", "top"]), PropTypes.number]).isRequired
  }),
  /**
   * This is the position that may be used to set the position of the popover.
   * The coordinates are relative to the application's client area.
   */
  anchorPosition: PropTypes.shape({
    left: PropTypes.number.isRequired,
    top: PropTypes.number.isRequired
  }),
  /**
   * This determines which anchor prop to refer to when setting
   * the position of the popover.
   * @default 'anchorEl'
   */
  anchorReference: PropTypes.oneOf(["anchorEl", "anchorPosition", "none"]),
  /**
   * The content of the component.
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * An HTML element, component instance, or function that returns either.
   * The `container` will passed to the Modal component.
   *
   * By default, it uses the body of the anchorEl's top-level document object,
   * so it's simply `document.body` most of the time.
   */
  container: PropTypes.oneOfType([HTMLElementType, PropTypes.func]),
  /**
   * Disable the scroll lock behavior.
   * @default false
   */
  disableScrollLock: PropTypes.bool,
  /**
   * The elevation of the popover.
   * @default 8
   */
  elevation: integerPropType,
  /**
   * Specifies how close to the edge of the window the popover can appear.
   * If null, the popover will not be constrained by the window.
   * @default 16
   */
  marginThreshold: PropTypes.number,
  /**
   * Callback fired when the component requests to be closed.
   * The `reason` parameter can optionally be used to control the response to `onClose`.
   */
  onClose: PropTypes.func,
  /**
   * If `true`, the component is shown.
   */
  open: PropTypes.bool.isRequired,
  /**
   * Props applied to the [`Paper`](/material-ui/api/paper/) element.
   *
   * This prop is an alias for `slotProps.paper` and will be overriden by it if both are used.
   * @deprecated Use `slotProps.paper` instead.
   *
   * @default {}
   */
  PaperProps: PropTypes.shape({
    component: elementTypeAcceptingRef$1
  }),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * @default {}
   */
  slotProps: PropTypes.shape({
    paper: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
    root: PropTypes.oneOfType([PropTypes.func, PropTypes.object])
  }),
  /**
   * The components used for each slot inside.
   *
   * @default {}
   */
  slots: PropTypes.shape({
    paper: PropTypes.elementType,
    root: PropTypes.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * This is the point on the popover which
   * will attach to the anchor's origin.
   *
   * Options:
   * vertical: [top, center, bottom, x(px)];
   * horizontal: [left, center, right, x(px)].
   * @default {
   *   vertical: 'top',
   *   horizontal: 'left',
   * }
   */
  transformOrigin: PropTypes.shape({
    horizontal: PropTypes.oneOfType([PropTypes.oneOf(["center", "left", "right"]), PropTypes.number]).isRequired,
    vertical: PropTypes.oneOfType([PropTypes.oneOf(["bottom", "center", "top"]), PropTypes.number]).isRequired
  }),
  /**
   * The component used for the transition.
   * [Follow this guide](/material-ui/transitions/#transitioncomponent-prop) to learn more about the requirements for this component.
   * @default Grow
   */
  TransitionComponent: PropTypes.elementType,
  /**
   * Set to 'auto' to automatically calculate transition time based on height.
   * @default 'auto'
   */
  transitionDuration: PropTypes.oneOfType([PropTypes.oneOf(["auto"]), PropTypes.number, PropTypes.shape({
    appear: PropTypes.number,
    enter: PropTypes.number,
    exit: PropTypes.number
  })]),
  /**
   * Props applied to the transition element.
   * By default, the element is based on this [`Transition`](https://reactcommunity.org/react-transition-group/transition/) component.
   * @default {}
   */
  TransitionProps: PropTypes.object
});
function getMenuUtilityClass(C) {
  return generateUtilityClass("MuiMenu", C);
}
generateUtilityClasses("MuiMenu", ["root", "paper", "list"]);
const _excluded$b = ["onEntering"], _excluded2$1 = ["autoFocus", "children", "className", "disableAutoFocusItem", "MenuListProps", "onClose", "open", "PaperProps", "PopoverClasses", "transitionDuration", "TransitionProps", "variant", "slots", "slotProps"], RTL_ORIGIN = {
  vertical: "top",
  horizontal: "right"
}, LTR_ORIGIN = {
  vertical: "top",
  horizontal: "left"
}, useUtilityClasses$a = (C) => {
  const {
    classes: e
  } = C;
  return composeClasses({
    root: ["root"],
    paper: ["paper"],
    list: ["list"]
  }, getMenuUtilityClass, e);
}, MenuRoot = styled$1(Popover, {
  shouldForwardProp: (C) => rootShouldForwardProp(C) || C === "classes",
  name: "MuiMenu",
  slot: "Root",
  overridesResolver: (C, e) => e.root
})({}), MenuPaper = styled$1(PopoverPaper, {
  name: "MuiMenu",
  slot: "Paper",
  overridesResolver: (C, e) => e.paper
})({
  // specZ: The maximum height of a simple menu should be one or more rows less than the view
  // height. This ensures a tappable area outside of the simple menu with which to dismiss
  // the menu.
  maxHeight: "calc(100% - 96px)",
  // Add iOS momentum scrolling for iOS < 13.0
  WebkitOverflowScrolling: "touch"
}), MenuMenuList = styled$1(MenuList, {
  name: "MuiMenu",
  slot: "List",
  overridesResolver: (C, e) => e.list
})({
  // We disable the focus ring for mouse, touch and keyboard users.
  outline: 0
}), Menu = /* @__PURE__ */ React$1.forwardRef(function(e, T) {
  var $, V;
  const J = useDefaultProps({
    props: e,
    name: "MuiMenu"
  }), {
    autoFocus: ee = !0,
    children: te,
    className: re,
    disableAutoFocusItem: ie = !1,
    MenuListProps: se = {},
    onClose: de,
    open: ue,
    PaperProps: fe = {},
    PopoverClasses: he,
    transitionDuration: me = "auto",
    TransitionProps: {
      onEntering: xe
    } = {},
    variant: ve = "selectedMenu",
    slots: Te = {},
    slotProps: we = {}
  } = J, Ee = _objectWithoutPropertiesLoose(J.TransitionProps, _excluded$b), Me = _objectWithoutPropertiesLoose(J, _excluded2$1), Ie = useRtl(), ke = _extends({}, J, {
    autoFocus: ee,
    disableAutoFocusItem: ie,
    MenuListProps: se,
    onEntering: xe,
    PaperProps: fe,
    transitionDuration: me,
    TransitionProps: Ee,
    variant: ve
  }), _e = useUtilityClasses$a(ke), De = ee && !ie && ue, Fe = React$1.useRef(null), Ae = (Ce, be) => {
    Fe.current && Fe.current.adjustStyleForScrollbar(Ce, {
      direction: Ie ? "rtl" : "ltr"
    }), xe && xe(Ce, be);
  }, ne = (Ce) => {
    Ce.key === "Tab" && (Ce.preventDefault(), de && de(Ce, "tabKeyDown"));
  };
  let oe = -1;
  React$1.Children.map(te, (Ce, be) => {
    /* @__PURE__ */ React$1.isValidElement(Ce) && (dist$2.process.env.NODE_ENV !== "production" && reactIsExports.isFragment(Ce) && console.error(["MUI: The Menu component doesn't accept a Fragment as a child.", "Consider providing an array instead."].join(`
`)), Ce.props.disabled || (ve === "selectedMenu" && Ce.props.selected || oe === -1) && (oe = be));
  });
  const ce = ($ = Te.paper) != null ? $ : MenuPaper, le = (V = we.paper) != null ? V : fe, pe = useSlotProps({
    elementType: Te.root,
    externalSlotProps: we.root,
    ownerState: ke,
    className: [_e.root, re]
  }), ye = useSlotProps({
    elementType: ce,
    externalSlotProps: le,
    ownerState: ke,
    className: _e.paper
  });
  return /* @__PURE__ */ jsxRuntimeExports.jsx(MenuRoot, _extends({
    onClose: de,
    anchorOrigin: {
      vertical: "bottom",
      horizontal: Ie ? "right" : "left"
    },
    transformOrigin: Ie ? RTL_ORIGIN : LTR_ORIGIN,
    slots: {
      paper: ce,
      root: Te.root
    },
    slotProps: {
      root: pe,
      paper: ye
    },
    open: ue,
    ref: T,
    transitionDuration: me,
    TransitionProps: _extends({
      onEntering: Ae
    }, Ee),
    ownerState: ke
  }, Me, {
    classes: he,
    children: /* @__PURE__ */ jsxRuntimeExports.jsx(MenuMenuList, _extends({
      onKeyDown: ne,
      actions: Fe,
      autoFocus: ee && (oe === -1 || ie),
      autoFocusItem: De,
      variant: ve
    }, se, {
      className: clsx(_e.list, se.className),
      children: te
    }))
  }));
});
dist$2.process.env.NODE_ENV !== "production" && (Menu.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * An HTML element, or a function that returns one.
   * It's used to set the position of the menu.
   */
  anchorEl: PropTypes.oneOfType([HTMLElementType, PropTypes.func]),
  /**
   * If `true` (Default) will focus the `[role="menu"]` if no focusable child is found. Disabled
   * children are not focusable. If you set this prop to `false` focus will be placed
   * on the parent modal container. This has severe accessibility implications
   * and should only be considered if you manage focus otherwise.
   * @default true
   */
  autoFocus: PropTypes.bool,
  /**
   * Menu contents, normally `MenuItem`s.
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * When opening the menu will not focus the active item but the `[role="menu"]`
   * unless `autoFocus` is also set to `false`. Not using the default means not
   * following WAI-ARIA authoring practices. Please be considerate about possible
   * accessibility implications.
   * @default false
   */
  disableAutoFocusItem: PropTypes.bool,
  /**
   * Props applied to the [`MenuList`](/material-ui/api/menu-list/) element.
   * @default {}
   */
  MenuListProps: PropTypes.object,
  /**
   * Callback fired when the component requests to be closed.
   *
   * @param {object} event The event source of the callback.
   * @param {string} reason Can be: `"escapeKeyDown"`, `"backdropClick"`, `"tabKeyDown"`.
   */
  onClose: PropTypes.func,
  /**
   * If `true`, the component is shown.
   */
  open: PropTypes.bool.isRequired,
  /**
   * @ignore
   */
  PaperProps: PropTypes.object,
  /**
   * `classes` prop applied to the [`Popover`](/material-ui/api/popover/) element.
   */
  PopoverClasses: PropTypes.object,
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * @default {}
   */
  slotProps: PropTypes.shape({
    paper: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
    root: PropTypes.oneOfType([PropTypes.func, PropTypes.object])
  }),
  /**
   * The components used for each slot inside.
   *
   * @default {}
   */
  slots: PropTypes.shape({
    paper: PropTypes.elementType,
    root: PropTypes.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * The length of the transition in `ms`, or 'auto'
   * @default 'auto'
   */
  transitionDuration: PropTypes.oneOfType([PropTypes.oneOf(["auto"]), PropTypes.number, PropTypes.shape({
    appear: PropTypes.number,
    enter: PropTypes.number,
    exit: PropTypes.number
  })]),
  /**
   * Props applied to the transition element.
   * By default, the element is based on this [`Transition`](https://reactcommunity.org/react-transition-group/transition/) component.
   * @default {}
   */
  TransitionProps: PropTypes.object,
  /**
   * The variant to use. Use `menu` to prevent selected items from impacting the initial focus.
   * @default 'selectedMenu'
   */
  variant: PropTypes.oneOf(["menu", "selectedMenu"])
});
function getMenuItemUtilityClass(C) {
  return generateUtilityClass("MuiMenuItem", C);
}
const menuItemClasses = generateUtilityClasses("MuiMenuItem", ["root", "focusVisible", "dense", "disabled", "divider", "gutters", "selected"]), _excluded$a = ["autoFocus", "component", "dense", "divider", "disableGutters", "focusVisibleClassName", "role", "tabIndex", "className"], overridesResolver = (C, e) => {
  const {
    ownerState: T
  } = C;
  return [e.root, T.dense && e.dense, T.divider && e.divider, !T.disableGutters && e.gutters];
}, useUtilityClasses$9 = (C) => {
  const {
    disabled: e,
    dense: T,
    divider: $,
    disableGutters: V,
    selected: J,
    classes: ee
  } = C, re = composeClasses({
    root: ["root", T && "dense", e && "disabled", !V && "gutters", $ && "divider", J && "selected"]
  }, getMenuItemUtilityClass, ee);
  return _extends({}, ee, re);
}, MenuItemRoot = styled$1(ButtonBase, {
  shouldForwardProp: (C) => rootShouldForwardProp(C) || C === "classes",
  name: "MuiMenuItem",
  slot: "Root",
  overridesResolver
})(({
  theme: C,
  ownerState: e
}) => _extends({}, C.typography.body1, {
  display: "flex",
  justifyContent: "flex-start",
  alignItems: "center",
  position: "relative",
  textDecoration: "none",
  minHeight: 48,
  paddingTop: 6,
  paddingBottom: 6,
  boxSizing: "border-box",
  whiteSpace: "nowrap"
}, !e.disableGutters && {
  paddingLeft: 16,
  paddingRight: 16
}, e.divider && {
  borderBottom: `1px solid ${(C.vars || C).palette.divider}`,
  backgroundClip: "padding-box"
}, {
  "&:hover": {
    textDecoration: "none",
    backgroundColor: (C.vars || C).palette.action.hover,
    // Reset on touch devices, it doesn't add specificity
    "@media (hover: none)": {
      backgroundColor: "transparent"
    }
  },
  [`&.${menuItemClasses.selected}`]: {
    backgroundColor: C.vars ? `rgba(${C.vars.palette.primary.mainChannel} / ${C.vars.palette.action.selectedOpacity})` : alpha_1(C.palette.primary.main, C.palette.action.selectedOpacity),
    [`&.${menuItemClasses.focusVisible}`]: {
      backgroundColor: C.vars ? `rgba(${C.vars.palette.primary.mainChannel} / calc(${C.vars.palette.action.selectedOpacity} + ${C.vars.palette.action.focusOpacity}))` : alpha_1(C.palette.primary.main, C.palette.action.selectedOpacity + C.palette.action.focusOpacity)
    }
  },
  [`&.${menuItemClasses.selected}:hover`]: {
    backgroundColor: C.vars ? `rgba(${C.vars.palette.primary.mainChannel} / calc(${C.vars.palette.action.selectedOpacity} + ${C.vars.palette.action.hoverOpacity}))` : alpha_1(C.palette.primary.main, C.palette.action.selectedOpacity + C.palette.action.hoverOpacity),
    // Reset on touch devices, it doesn't add specificity
    "@media (hover: none)": {
      backgroundColor: C.vars ? `rgba(${C.vars.palette.primary.mainChannel} / ${C.vars.palette.action.selectedOpacity})` : alpha_1(C.palette.primary.main, C.palette.action.selectedOpacity)
    }
  },
  [`&.${menuItemClasses.focusVisible}`]: {
    backgroundColor: (C.vars || C).palette.action.focus
  },
  [`&.${menuItemClasses.disabled}`]: {
    opacity: (C.vars || C).palette.action.disabledOpacity
  },
  [`& + .${dividerClasses.root}`]: {
    marginTop: C.spacing(1),
    marginBottom: C.spacing(1)
  },
  [`& + .${dividerClasses.inset}`]: {
    marginLeft: 52
  },
  [`& .${listItemTextClasses.root}`]: {
    marginTop: 0,
    marginBottom: 0
  },
  [`& .${listItemTextClasses.inset}`]: {
    paddingLeft: 36
  },
  [`& .${listItemIconClasses.root}`]: {
    minWidth: 36
  }
}, !e.dense && {
  [C.breakpoints.up("sm")]: {
    minHeight: "auto"
  }
}, e.dense && _extends({
  minHeight: 32,
  // https://m2.material.io/components/menus#specs > Dense
  paddingTop: 4,
  paddingBottom: 4
}, C.typography.body2, {
  [`& .${listItemIconClasses.root} svg`]: {
    fontSize: "1.25rem"
  }
}))), MenuItem = /* @__PURE__ */ React$1.forwardRef(function(e, T) {
  const $ = useDefaultProps({
    props: e,
    name: "MuiMenuItem"
  }), {
    autoFocus: V = !1,
    component: J = "li",
    dense: ee = !1,
    divider: te = !1,
    disableGutters: re = !1,
    focusVisibleClassName: ie,
    role: se = "menuitem",
    tabIndex: de,
    className: ue
  } = $, fe = _objectWithoutPropertiesLoose($, _excluded$a), he = React$1.useContext(ListContext), me = React$1.useMemo(() => ({
    dense: ee || he.dense || !1,
    disableGutters: re
  }), [he.dense, ee, re]), xe = React$1.useRef(null);
  useEnhancedEffect(() => {
    V && (xe.current ? xe.current.focus() : dist$2.process.env.NODE_ENV !== "production" && console.error("MUI: Unable to set focus to a MenuItem whose component has not been rendered."));
  }, [V]);
  const ve = _extends({}, $, {
    dense: me.dense,
    divider: te,
    disableGutters: re
  }), Te = useUtilityClasses$9($), we = useForkRef(xe, T);
  let Ee;
  return $.disabled || (Ee = de !== void 0 ? de : -1), /* @__PURE__ */ jsxRuntimeExports.jsx(ListContext.Provider, {
    value: me,
    children: /* @__PURE__ */ jsxRuntimeExports.jsx(MenuItemRoot, _extends({
      ref: we,
      role: se,
      tabIndex: Ee,
      component: J,
      focusVisibleClassName: clsx(Te.focusVisible, ie),
      className: clsx(Te.root, ue)
    }, fe, {
      ownerState: ve,
      classes: Te
    }))
  });
});
dist$2.process.env.NODE_ENV !== "production" && (MenuItem.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * If `true`, the list item is focused during the first mount.
   * Focus will also be triggered if the value changes from false to true.
   * @default false
   */
  autoFocus: PropTypes.bool,
  /**
   * The content of the component.
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes.elementType,
  /**
   * If `true`, compact vertical padding designed for keyboard and mouse input is used.
   * The prop defaults to the value inherited from the parent Menu component.
   * @default false
   */
  dense: PropTypes.bool,
  /**
   * @ignore
   */
  disabled: PropTypes.bool,
  /**
   * If `true`, the left and right padding is removed.
   * @default false
   */
  disableGutters: PropTypes.bool,
  /**
   * If `true`, a 1px light border is added to the bottom of the menu item.
   * @default false
   */
  divider: PropTypes.bool,
  /**
   * This prop can help identify which element has keyboard focus.
   * The class name will be applied when the element gains the focus through keyboard interaction.
   * It's a polyfill for the [CSS :focus-visible selector](https://drafts.csswg.org/selectors-4/#the-focus-visible-pseudo).
   * The rationale for using this feature [is explained here](https://github.com/WICG/focus-visible/blob/HEAD/explainer.md).
   * A [polyfill can be used](https://github.com/WICG/focus-visible) to apply a `focus-visible` class to other components
   * if needed.
   */
  focusVisibleClassName: PropTypes.string,
  /**
   * @ignore
   */
  role: PropTypes.string,
  /**
   * If `true`, the component is selected.
   * @default false
   */
  selected: PropTypes.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * @default 0
   */
  tabIndex: PropTypes.number
});
function getNativeSelectUtilityClasses(C) {
  return generateUtilityClass("MuiNativeSelect", C);
}
const nativeSelectClasses = generateUtilityClasses("MuiNativeSelect", ["root", "select", "multiple", "filled", "outlined", "standard", "disabled", "icon", "iconOpen", "iconFilled", "iconOutlined", "iconStandard", "nativeInput", "error"]), _excluded$9 = ["className", "disabled", "error", "IconComponent", "inputRef", "variant"], useUtilityClasses$8 = (C) => {
  const {
    classes: e,
    variant: T,
    disabled: $,
    multiple: V,
    open: J,
    error: ee
  } = C, te = {
    select: ["select", T, $ && "disabled", V && "multiple", ee && "error"],
    icon: ["icon", `icon${capitalize$3(T)}`, J && "iconOpen", $ && "disabled"]
  };
  return composeClasses(te, getNativeSelectUtilityClasses, e);
}, nativeSelectSelectStyles = ({
  ownerState: C,
  theme: e
}) => _extends({
  MozAppearance: "none",
  // Reset
  WebkitAppearance: "none",
  // Reset
  // When interacting quickly, the text can end up selected.
  // Native select can't be selected either.
  userSelect: "none",
  borderRadius: 0,
  // Reset
  cursor: "pointer",
  "&:focus": _extends({}, e.vars ? {
    backgroundColor: `rgba(${e.vars.palette.common.onBackgroundChannel} / 0.05)`
  } : {
    backgroundColor: e.palette.mode === "light" ? "rgba(0, 0, 0, 0.05)" : "rgba(255, 255, 255, 0.05)"
  }, {
    borderRadius: 0
    // Reset Chrome style
  }),
  // Remove IE11 arrow
  "&::-ms-expand": {
    display: "none"
  },
  [`&.${nativeSelectClasses.disabled}`]: {
    cursor: "default"
  },
  "&[multiple]": {
    height: "auto"
  },
  "&:not([multiple]) option, &:not([multiple]) optgroup": {
    backgroundColor: (e.vars || e).palette.background.paper
  },
  // Bump specificity to allow extending custom inputs
  "&&&": {
    paddingRight: 24,
    minWidth: 16
    // So it doesn't collapse.
  }
}, C.variant === "filled" && {
  "&&&": {
    paddingRight: 32
  }
}, C.variant === "outlined" && {
  borderRadius: (e.vars || e).shape.borderRadius,
  "&:focus": {
    borderRadius: (e.vars || e).shape.borderRadius
    // Reset the reset for Chrome style
  },
  "&&&": {
    paddingRight: 32
  }
}), NativeSelectSelect = styled$1("select", {
  name: "MuiNativeSelect",
  slot: "Select",
  shouldForwardProp: rootShouldForwardProp,
  overridesResolver: (C, e) => {
    const {
      ownerState: T
    } = C;
    return [e.select, e[T.variant], T.error && e.error, {
      [`&.${nativeSelectClasses.multiple}`]: e.multiple
    }];
  }
})(nativeSelectSelectStyles), nativeSelectIconStyles = ({
  ownerState: C,
  theme: e
}) => _extends({
  // We use a position absolute over a flexbox in order to forward the pointer events
  // to the input and to support wrapping tags..
  position: "absolute",
  right: 0,
  top: "calc(50% - .5em)",
  // Center vertically, height is 1em
  pointerEvents: "none",
  // Don't block pointer events on the select under the icon.
  color: (e.vars || e).palette.action.active,
  [`&.${nativeSelectClasses.disabled}`]: {
    color: (e.vars || e).palette.action.disabled
  }
}, C.open && {
  transform: "rotate(180deg)"
}, C.variant === "filled" && {
  right: 7
}, C.variant === "outlined" && {
  right: 7
}), NativeSelectIcon = styled$1("svg", {
  name: "MuiNativeSelect",
  slot: "Icon",
  overridesResolver: (C, e) => {
    const {
      ownerState: T
    } = C;
    return [e.icon, T.variant && e[`icon${capitalize$3(T.variant)}`], T.open && e.iconOpen];
  }
})(nativeSelectIconStyles), NativeSelectInput = /* @__PURE__ */ React$1.forwardRef(function(e, T) {
  const {
    className: $,
    disabled: V,
    error: J,
    IconComponent: ee,
    inputRef: te,
    variant: re = "standard"
  } = e, ie = _objectWithoutPropertiesLoose(e, _excluded$9), se = _extends({}, e, {
    disabled: V,
    variant: re,
    error: J
  }), de = useUtilityClasses$8(se);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(React$1.Fragment, {
    children: [/* @__PURE__ */ jsxRuntimeExports.jsx(NativeSelectSelect, _extends({
      ownerState: se,
      className: clsx(de.select, $),
      disabled: V,
      ref: te || T
    }, ie)), e.multiple ? null : /* @__PURE__ */ jsxRuntimeExports.jsx(NativeSelectIcon, {
      as: ee,
      ownerState: se,
      className: de.icon
    })]
  });
});
dist$2.process.env.NODE_ENV !== "production" && (NativeSelectInput.propTypes = {
  /**
   * The option elements to populate the select with.
   * Can be some `<option>` elements.
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * The CSS class name of the select element.
   */
  className: PropTypes.string,
  /**
   * If `true`, the select is disabled.
   */
  disabled: PropTypes.bool,
  /**
   * If `true`, the `select input` will indicate an error.
   */
  error: PropTypes.bool,
  /**
   * The icon that displays the arrow.
   */
  IconComponent: PropTypes.elementType.isRequired,
  /**
   * Use that prop to pass a ref to the native select element.
   * @deprecated
   */
  inputRef: refType,
  /**
   * @ignore
   */
  multiple: PropTypes.bool,
  /**
   * Name attribute of the `select` or hidden `input` element.
   */
  name: PropTypes.string,
  /**
   * Callback fired when a menu item is selected.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   */
  onChange: PropTypes.func,
  /**
   * The input value.
   */
  value: PropTypes.any,
  /**
   * The variant to use.
   */
  variant: PropTypes.oneOf(["standard", "outlined", "filled"])
});
var _span$1;
const _excluded$8 = ["children", "classes", "className", "label", "notched"], NotchedOutlineRoot$1 = styled$1("fieldset", {
  shouldForwardProp: rootShouldForwardProp
})({
  textAlign: "left",
  position: "absolute",
  bottom: 0,
  right: 0,
  top: -5,
  left: 0,
  margin: 0,
  padding: "0 8px",
  pointerEvents: "none",
  borderRadius: "inherit",
  borderStyle: "solid",
  borderWidth: 1,
  overflow: "hidden",
  minWidth: "0%"
}), NotchedOutlineLegend = styled$1("legend", {
  shouldForwardProp: rootShouldForwardProp
})(({
  ownerState: C,
  theme: e
}) => _extends({
  float: "unset",
  // Fix conflict with bootstrap
  width: "auto",
  // Fix conflict with bootstrap
  overflow: "hidden"
}, !C.withLabel && {
  padding: 0,
  lineHeight: "11px",
  // sync with `height` in `legend` styles
  transition: e.transitions.create("width", {
    duration: 150,
    easing: e.transitions.easing.easeOut
  })
}, C.withLabel && _extends({
  display: "block",
  // Fix conflict with normalize.css and sanitize.css
  padding: 0,
  height: 11,
  // sync with `lineHeight` in `legend` styles
  fontSize: "0.75em",
  visibility: "hidden",
  maxWidth: 0.01,
  transition: e.transitions.create("max-width", {
    duration: 50,
    easing: e.transitions.easing.easeOut
  }),
  whiteSpace: "nowrap",
  "& > span": {
    paddingLeft: 5,
    paddingRight: 5,
    display: "inline-block",
    opacity: 0,
    visibility: "visible"
  }
}, C.notched && {
  maxWidth: "100%",
  transition: e.transitions.create("max-width", {
    duration: 100,
    easing: e.transitions.easing.easeOut,
    delay: 50
  })
})));
function NotchedOutline(C) {
  const {
    className: e,
    label: T,
    notched: $
  } = C, V = _objectWithoutPropertiesLoose(C, _excluded$8), J = T != null && T !== "", ee = _extends({}, C, {
    notched: $,
    withLabel: J
  });
  return /* @__PURE__ */ jsxRuntimeExports.jsx(NotchedOutlineRoot$1, _extends({
    "aria-hidden": !0,
    className: e,
    ownerState: ee
  }, V, {
    children: /* @__PURE__ */ jsxRuntimeExports.jsx(NotchedOutlineLegend, {
      ownerState: ee,
      children: J ? /* @__PURE__ */ jsxRuntimeExports.jsx("span", {
        children: T
      }) : (
        // notranslate needed while Google Translate will not fix zero-width space issue
        _span$1 || (_span$1 = /* @__PURE__ */ jsxRuntimeExports.jsx("span", {
          className: "notranslate",
          children: "​"
        }))
      )
    })
  }));
}
dist$2.process.env.NODE_ENV !== "production" && (NotchedOutline.propTypes = {
  /**
   * The content of the component.
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The label.
   */
  label: PropTypes.node,
  /**
   * If `true`, the outline is notched to accommodate the label.
   */
  notched: PropTypes.bool.isRequired,
  /**
   * @ignore
   */
  style: PropTypes.object
});
const _excluded$7 = ["components", "fullWidth", "inputComponent", "label", "multiline", "notched", "slots", "type"], useUtilityClasses$7 = (C) => {
  const {
    classes: e
  } = C, $ = composeClasses({
    root: ["root"],
    notchedOutline: ["notchedOutline"],
    input: ["input"]
  }, getOutlinedInputUtilityClass, e);
  return _extends({}, e, $);
}, OutlinedInputRoot = styled$1(InputBaseRoot, {
  shouldForwardProp: (C) => rootShouldForwardProp(C) || C === "classes",
  name: "MuiOutlinedInput",
  slot: "Root",
  overridesResolver: rootOverridesResolver
})(({
  theme: C,
  ownerState: e
}) => {
  const T = C.palette.mode === "light" ? "rgba(0, 0, 0, 0.23)" : "rgba(255, 255, 255, 0.23)";
  return _extends({
    position: "relative",
    borderRadius: (C.vars || C).shape.borderRadius,
    [`&:hover .${outlinedInputClasses.notchedOutline}`]: {
      borderColor: (C.vars || C).palette.text.primary
    },
    // Reset on touch devices, it doesn't add specificity
    "@media (hover: none)": {
      [`&:hover .${outlinedInputClasses.notchedOutline}`]: {
        borderColor: C.vars ? `rgba(${C.vars.palette.common.onBackgroundChannel} / 0.23)` : T
      }
    },
    [`&.${outlinedInputClasses.focused} .${outlinedInputClasses.notchedOutline}`]: {
      borderColor: (C.vars || C).palette[e.color].main,
      borderWidth: 2
    },
    [`&.${outlinedInputClasses.error} .${outlinedInputClasses.notchedOutline}`]: {
      borderColor: (C.vars || C).palette.error.main
    },
    [`&.${outlinedInputClasses.disabled} .${outlinedInputClasses.notchedOutline}`]: {
      borderColor: (C.vars || C).palette.action.disabled
    }
  }, e.startAdornment && {
    paddingLeft: 14
  }, e.endAdornment && {
    paddingRight: 14
  }, e.multiline && _extends({
    padding: "16.5px 14px"
  }, e.size === "small" && {
    padding: "8.5px 14px"
  }));
}), NotchedOutlineRoot = styled$1(NotchedOutline, {
  name: "MuiOutlinedInput",
  slot: "NotchedOutline",
  overridesResolver: (C, e) => e.notchedOutline
})(({
  theme: C
}) => {
  const e = C.palette.mode === "light" ? "rgba(0, 0, 0, 0.23)" : "rgba(255, 255, 255, 0.23)";
  return {
    borderColor: C.vars ? `rgba(${C.vars.palette.common.onBackgroundChannel} / 0.23)` : e
  };
}), OutlinedInputInput = styled$1(InputBaseComponent, {
  name: "MuiOutlinedInput",
  slot: "Input",
  overridesResolver: inputOverridesResolver
})(({
  theme: C,
  ownerState: e
}) => _extends({
  padding: "16.5px 14px"
}, !C.vars && {
  "&:-webkit-autofill": {
    WebkitBoxShadow: C.palette.mode === "light" ? null : "0 0 0 100px #266798 inset",
    WebkitTextFillColor: C.palette.mode === "light" ? null : "#fff",
    caretColor: C.palette.mode === "light" ? null : "#fff",
    borderRadius: "inherit"
  }
}, C.vars && {
  "&:-webkit-autofill": {
    borderRadius: "inherit"
  },
  [C.getColorSchemeSelector("dark")]: {
    "&:-webkit-autofill": {
      WebkitBoxShadow: "0 0 0 100px #266798 inset",
      WebkitTextFillColor: "#fff",
      caretColor: "#fff"
    }
  }
}, e.size === "small" && {
  padding: "8.5px 14px"
}, e.multiline && {
  padding: 0
}, e.startAdornment && {
  paddingLeft: 0
}, e.endAdornment && {
  paddingRight: 0
})), OutlinedInput = /* @__PURE__ */ React$1.forwardRef(function(e, T) {
  var $, V, J, ee, te;
  const re = useDefaultProps({
    props: e,
    name: "MuiOutlinedInput"
  }), {
    components: ie = {},
    fullWidth: se = !1,
    inputComponent: de = "input",
    label: ue,
    multiline: fe = !1,
    notched: he,
    slots: me = {},
    type: xe = "text"
  } = re, ve = _objectWithoutPropertiesLoose(re, _excluded$7), Te = useUtilityClasses$7(re), we = useFormControl(), Ee = formControlState({
    props: re,
    muiFormControl: we,
    states: ["color", "disabled", "error", "focused", "hiddenLabel", "size", "required"]
  }), Me = _extends({}, re, {
    color: Ee.color || "primary",
    disabled: Ee.disabled,
    error: Ee.error,
    focused: Ee.focused,
    formControl: we,
    fullWidth: se,
    hiddenLabel: Ee.hiddenLabel,
    multiline: fe,
    size: Ee.size,
    type: xe
  }), Ie = ($ = (V = me.root) != null ? V : ie.Root) != null ? $ : OutlinedInputRoot, ke = (J = (ee = me.input) != null ? ee : ie.Input) != null ? J : OutlinedInputInput;
  return /* @__PURE__ */ jsxRuntimeExports.jsx(InputBase, _extends({
    slots: {
      root: Ie,
      input: ke
    },
    renderSuffix: (_e) => /* @__PURE__ */ jsxRuntimeExports.jsx(NotchedOutlineRoot, {
      ownerState: Me,
      className: Te.notchedOutline,
      label: ue != null && ue !== "" && Ee.required ? te || (te = /* @__PURE__ */ jsxRuntimeExports.jsxs(React$1.Fragment, {
        children: [ue, " ", "*"]
      })) : ue,
      notched: typeof he < "u" ? he : !!(_e.startAdornment || _e.filled || _e.focused)
    }),
    fullWidth: se,
    inputComponent: de,
    multiline: fe,
    ref: T,
    type: xe
  }, ve, {
    classes: _extends({}, Te, {
      notchedOutline: null
    })
  }));
});
dist$2.process.env.NODE_ENV !== "production" && (OutlinedInput.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * This prop helps users to fill forms faster, especially on mobile devices.
   * The name can be confusing, as it's more like an autofill.
   * You can learn more about it [following the specification](https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#autofill).
   */
  autoComplete: PropTypes.string,
  /**
   * If `true`, the `input` element is focused during the first mount.
   */
  autoFocus: PropTypes.bool,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * The prop defaults to the value (`'primary'`) inherited from the parent FormControl component.
   */
  color: PropTypes.oneOfType([PropTypes.oneOf(["primary", "secondary"]), PropTypes.string]),
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `slots` prop.
   * It's recommended to use the `slots` prop instead.
   *
   * @default {}
   */
  components: PropTypes.shape({
    Input: PropTypes.elementType,
    Root: PropTypes.elementType
  }),
  /**
   * The default value. Use when the component is not controlled.
   */
  defaultValue: PropTypes.any,
  /**
   * If `true`, the component is disabled.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  disabled: PropTypes.bool,
  /**
   * End `InputAdornment` for this component.
   */
  endAdornment: PropTypes.node,
  /**
   * If `true`, the `input` will indicate an error.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  error: PropTypes.bool,
  /**
   * If `true`, the `input` will take up the full width of its container.
   * @default false
   */
  fullWidth: PropTypes.bool,
  /**
   * The id of the `input` element.
   */
  id: PropTypes.string,
  /**
   * The component used for the `input` element.
   * Either a string to use a HTML element or a component.
   * @default 'input'
   */
  inputComponent: PropTypes.elementType,
  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   * @default {}
   */
  inputProps: PropTypes.object,
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: refType,
  /**
   * The label of the `input`. It is only used for layout. The actual labelling
   * is handled by `InputLabel`.
   */
  label: PropTypes.node,
  /**
   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
   * FormControl.
   * The prop defaults to the value (`'none'`) inherited from the parent FormControl component.
   */
  margin: PropTypes.oneOf(["dense", "none"]),
  /**
   * Maximum number of rows to display when multiline option is set to true.
   */
  maxRows: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  /**
   * Minimum number of rows to display when multiline option is set to true.
   */
  minRows: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  /**
   * If `true`, a [TextareaAutosize](/material-ui/react-textarea-autosize/) element is rendered.
   * @default false
   */
  multiline: PropTypes.bool,
  /**
   * Name attribute of the `input` element.
   */
  name: PropTypes.string,
  /**
   * If `true`, the outline is notched to accommodate the label.
   */
  notched: PropTypes.bool,
  /**
   * Callback fired when the value is changed.
   *
   * @param {React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   */
  onChange: PropTypes.func,
  /**
   * The short hint displayed in the `input` before the user enters a value.
   */
  placeholder: PropTypes.string,
  /**
   * It prevents the user from changing the value of the field
   * (not from interacting with the field).
   */
  readOnly: PropTypes.bool,
  /**
   * If `true`, the `input` element is required.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  required: PropTypes.bool,
  /**
   * Number of rows to display when multiline option is set to true.
   */
  rows: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `components` prop, which will be deprecated in the future.
   *
   * @default {}
   */
  slots: PropTypes.shape({
    input: PropTypes.elementType,
    root: PropTypes.elementType
  }),
  /**
   * Start `InputAdornment` for this component.
   */
  startAdornment: PropTypes.node,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * Type of the `input` element. It should be [a valid HTML5 input type](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Form_%3Cinput%3E_types).
   * @default 'text'
   */
  type: PropTypes.string,
  /**
   * The value of the `input` element, required for a controlled component.
   */
  value: PropTypes.any
});
OutlinedInput.muiName = "Input";
function getSelectUtilityClasses(C) {
  return generateUtilityClass("MuiSelect", C);
}
const selectClasses = generateUtilityClasses("MuiSelect", ["root", "select", "multiple", "filled", "outlined", "standard", "disabled", "focused", "icon", "iconOpen", "iconFilled", "iconOutlined", "iconStandard", "nativeInput", "error"]);
var _span;
const _excluded$6 = ["aria-describedby", "aria-label", "autoFocus", "autoWidth", "children", "className", "defaultOpen", "defaultValue", "disabled", "displayEmpty", "error", "IconComponent", "inputRef", "labelId", "MenuProps", "multiple", "name", "onBlur", "onChange", "onClose", "onFocus", "onOpen", "open", "readOnly", "renderValue", "SelectDisplayProps", "tabIndex", "type", "value", "variant"], SelectSelect = styled$1("div", {
  name: "MuiSelect",
  slot: "Select",
  overridesResolver: (C, e) => {
    const {
      ownerState: T
    } = C;
    return [
      // Win specificity over the input base
      {
        [`&.${selectClasses.select}`]: e.select
      },
      {
        [`&.${selectClasses.select}`]: e[T.variant]
      },
      {
        [`&.${selectClasses.error}`]: e.error
      },
      {
        [`&.${selectClasses.multiple}`]: e.multiple
      }
    ];
  }
})(nativeSelectSelectStyles, {
  // Win specificity over the input base
  [`&.${selectClasses.select}`]: {
    height: "auto",
    // Resets for multiple select with chips
    minHeight: "1.4375em",
    // Required for select\text-field height consistency
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    overflow: "hidden"
  }
}), SelectIcon = styled$1("svg", {
  name: "MuiSelect",
  slot: "Icon",
  overridesResolver: (C, e) => {
    const {
      ownerState: T
    } = C;
    return [e.icon, T.variant && e[`icon${capitalize$3(T.variant)}`], T.open && e.iconOpen];
  }
})(nativeSelectIconStyles), SelectNativeInput = styled$1("input", {
  shouldForwardProp: (C) => slotShouldForwardProp(C) && C !== "classes",
  name: "MuiSelect",
  slot: "NativeInput",
  overridesResolver: (C, e) => e.nativeInput
})({
  bottom: 0,
  left: 0,
  position: "absolute",
  opacity: 0,
  pointerEvents: "none",
  width: "100%",
  boxSizing: "border-box"
});
function areEqualValues(C, e) {
  return typeof e == "object" && e !== null ? C === e : String(C) === String(e);
}
function isEmpty(C) {
  return C == null || typeof C == "string" && !C.trim();
}
const useUtilityClasses$6 = (C) => {
  const {
    classes: e,
    variant: T,
    disabled: $,
    multiple: V,
    open: J,
    error: ee
  } = C, te = {
    select: ["select", T, $ && "disabled", V && "multiple", ee && "error"],
    icon: ["icon", `icon${capitalize$3(T)}`, J && "iconOpen", $ && "disabled"],
    nativeInput: ["nativeInput"]
  };
  return composeClasses(te, getSelectUtilityClasses, e);
}, SelectInput = /* @__PURE__ */ React$1.forwardRef(function(e, T) {
  var $;
  const {
    "aria-describedby": V,
    "aria-label": J,
    autoFocus: ee,
    autoWidth: te,
    children: re,
    className: ie,
    defaultOpen: se,
    defaultValue: de,
    disabled: ue,
    displayEmpty: fe,
    error: he = !1,
    IconComponent: me,
    inputRef: xe,
    labelId: ve,
    MenuProps: Te = {},
    multiple: we,
    name: Ee,
    onBlur: Me,
    onChange: Ie,
    onClose: ke,
    onFocus: _e,
    onOpen: De,
    open: Fe,
    readOnly: Ae,
    renderValue: ne,
    SelectDisplayProps: oe = {},
    tabIndex: ce,
    value: le,
    variant: pe = "standard"
  } = e, ye = _objectWithoutPropertiesLoose(e, _excluded$6), [Ce, be] = useControlled({
    controlled: le,
    default: de,
    name: "Select"
  }), [ae, ge] = useControlled({
    controlled: Fe,
    default: se,
    name: "Select"
  }), Se = React$1.useRef(null), Le = React$1.useRef(null), [ze, Re] = React$1.useState(null), {
    current: We
  } = React$1.useRef(Fe != null), [Be, Ue] = React$1.useState(), Ge = useForkRef(T, xe), je = React$1.useCallback((Ct) => {
    Le.current = Ct, Ct && Re(Ct);
  }, []), Oe = ze == null ? void 0 : ze.parentNode;
  React$1.useImperativeHandle(Ge, () => ({
    focus: () => {
      Le.current.focus();
    },
    node: Se.current,
    value: Ce
  }), [Ce]), React$1.useEffect(() => {
    se && ae && ze && !We && (Ue(te ? null : Oe.clientWidth), Le.current.focus());
  }, [ze, te]), React$1.useEffect(() => {
    ee && Le.current.focus();
  }, [ee]), React$1.useEffect(() => {
    if (!ve)
      return;
    const Ct = ownerDocument(Le.current).getElementById(ve);
    if (Ct) {
      const Ut = () => {
        getSelection().isCollapsed && Le.current.focus();
      };
      return Ct.addEventListener("click", Ut), () => {
        Ct.removeEventListener("click", Ut);
      };
    }
  }, [ve]);
  const Ne = (Ct, Ut) => {
    Ct ? De && De(Ut) : ke && ke(Ut), We || (Ue(te ? null : Oe.clientWidth), ge(Ct));
  }, Ye = (Ct) => {
    Ct.button === 0 && (Ct.preventDefault(), Le.current.focus(), Ne(!0, Ct));
  }, Je = (Ct) => {
    Ne(!1, Ct);
  }, Xe = React$1.Children.toArray(re), st = (Ct) => {
    const Ut = Xe.find((vt) => vt.props.value === Ct.target.value);
    Ut !== void 0 && (be(Ut.props.value), Ie && Ie(Ct, Ut));
  }, ct = (Ct) => (Ut) => {
    let vt;
    if (Ut.currentTarget.hasAttribute("tabindex")) {
      if (we) {
        vt = Array.isArray(Ce) ? Ce.slice() : [];
        const Mt = Ce.indexOf(Ct.props.value);
        Mt === -1 ? vt.push(Ct.props.value) : vt.splice(Mt, 1);
      } else
        vt = Ct.props.value;
      if (Ct.props.onClick && Ct.props.onClick(Ut), Ce !== vt && (be(vt), Ie)) {
        const Mt = Ut.nativeEvent || Ut, Xt = new Mt.constructor(Mt.type, Mt);
        Object.defineProperty(Xt, "target", {
          writable: !0,
          value: {
            value: vt,
            name: Ee
          }
        }), Ie(Xt, Ct);
      }
      we || Ne(!1, Ut);
    }
  }, it = (Ct) => {
    Ae || [
      " ",
      "ArrowUp",
      "ArrowDown",
      // The native select doesn't respond to enter on macOS, but it's recommended by
      // https://www.w3.org/WAI/ARIA/apg/patterns/combobox/examples/combobox-select-only/
      "Enter"
    ].indexOf(Ct.key) !== -1 && (Ct.preventDefault(), Ne(!0, Ct));
  }, ot = ze !== null && ae, yt = (Ct) => {
    !ot && Me && (Object.defineProperty(Ct, "target", {
      writable: !0,
      value: {
        value: Ce,
        name: Ee
      }
    }), Me(Ct));
  };
  delete ye["aria-invalid"];
  let dt, mt;
  const It = [];
  let xt = !1, Tt = !1;
  (isFilled({
    value: Ce
  }) || fe) && (ne ? dt = ne(Ce) : xt = !0);
  const Yt = Xe.map((Ct) => {
    if (!/* @__PURE__ */ React$1.isValidElement(Ct))
      return null;
    dist$2.process.env.NODE_ENV !== "production" && reactIsExports.isFragment(Ct) && console.error(["MUI: The Select component doesn't accept a Fragment as a child.", "Consider providing an array instead."].join(`
`));
    let Ut;
    if (we) {
      if (!Array.isArray(Ce))
        throw new Error(dist$2.process.env.NODE_ENV !== "production" ? "MUI: The `value` prop must be an array when using the `Select` component with `multiple`." : formatMuiErrorMessage$1(2));
      Ut = Ce.some((vt) => areEqualValues(vt, Ct.props.value)), Ut && xt && It.push(Ct.props.children);
    } else
      Ut = areEqualValues(Ce, Ct.props.value), Ut && xt && (mt = Ct.props.children);
    return Ut && (Tt = !0), /* @__PURE__ */ React$1.cloneElement(Ct, {
      "aria-selected": Ut ? "true" : "false",
      onClick: ct(Ct),
      onKeyUp: (vt) => {
        vt.key === " " && vt.preventDefault(), Ct.props.onKeyUp && Ct.props.onKeyUp(vt);
      },
      role: "option",
      selected: Ut,
      value: void 0,
      // The value is most likely not a valid HTML attribute.
      "data-value": Ct.props.value
      // Instead, we provide it as a data attribute.
    });
  });
  dist$2.process.env.NODE_ENV !== "production" && React$1.useEffect(() => {
    if (!Tt && !we && Ce !== "") {
      const Ct = Xe.map((Ut) => Ut.props.value);
      console.warn([`MUI: You have provided an out-of-range value \`${Ce}\` for the select ${Ee ? `(name="${Ee}") ` : ""}component.`, "Consider providing a value that matches one of the available options or ''.", `The available values are ${Ct.filter((Ut) => Ut != null).map((Ut) => `\`${Ut}\``).join(", ") || '""'}.`].join(`
`));
    }
  }, [Tt, Xe, we, Ee, Ce]), xt && (we ? It.length === 0 ? dt = null : dt = It.reduce((Ct, Ut, vt) => (Ct.push(Ut), vt < It.length - 1 && Ct.push(", "), Ct), []) : dt = mt);
  let Ve = Be;
  !te && We && ze && (Ve = Oe.clientWidth);
  let Pe;
  typeof ce < "u" ? Pe = ce : Pe = ue ? null : 0;
  const $e = oe.id || (Ee ? `mui-component-select-${Ee}` : void 0), Ze = _extends({}, e, {
    variant: pe,
    value: Ce,
    open: ot,
    error: he
  }), at = useUtilityClasses$6(Ze), wt = _extends({}, Te.PaperProps, ($ = Te.slotProps) == null ? void 0 : $.paper), ft = useId();
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(React$1.Fragment, {
    children: [/* @__PURE__ */ jsxRuntimeExports.jsx(SelectSelect, _extends({
      ref: je,
      tabIndex: Pe,
      role: "combobox",
      "aria-controls": ft,
      "aria-disabled": ue ? "true" : void 0,
      "aria-expanded": ot ? "true" : "false",
      "aria-haspopup": "listbox",
      "aria-label": J,
      "aria-labelledby": [ve, $e].filter(Boolean).join(" ") || void 0,
      "aria-describedby": V,
      onKeyDown: it,
      onMouseDown: ue || Ae ? null : Ye,
      onBlur: yt,
      onFocus: _e
    }, oe, {
      ownerState: Ze,
      className: clsx(oe.className, at.select, ie),
      id: $e,
      children: isEmpty(dt) ? (
        // notranslate needed while Google Translate will not fix zero-width space issue
        _span || (_span = /* @__PURE__ */ jsxRuntimeExports.jsx("span", {
          className: "notranslate",
          children: "​"
        }))
      ) : dt
    })), /* @__PURE__ */ jsxRuntimeExports.jsx(SelectNativeInput, _extends({
      "aria-invalid": he,
      value: Array.isArray(Ce) ? Ce.join(",") : Ce,
      name: Ee,
      ref: Se,
      "aria-hidden": !0,
      onChange: st,
      tabIndex: -1,
      disabled: ue,
      className: at.nativeInput,
      autoFocus: ee,
      ownerState: Ze
    }, ye)), /* @__PURE__ */ jsxRuntimeExports.jsx(SelectIcon, {
      as: me,
      className: at.icon,
      ownerState: Ze
    }), /* @__PURE__ */ jsxRuntimeExports.jsx(Menu, _extends({
      id: `menu-${Ee || ""}`,
      anchorEl: Oe,
      open: ot,
      onClose: Je,
      anchorOrigin: {
        vertical: "bottom",
        horizontal: "center"
      },
      transformOrigin: {
        vertical: "top",
        horizontal: "center"
      }
    }, Te, {
      MenuListProps: _extends({
        "aria-labelledby": ve,
        role: "listbox",
        "aria-multiselectable": we ? "true" : void 0,
        disableListWrap: !0,
        id: ft
      }, Te.MenuListProps),
      slotProps: _extends({}, Te.slotProps, {
        paper: _extends({}, wt, {
          style: _extends({
            minWidth: Ve
          }, wt != null ? wt.style : null)
        })
      }),
      children: Yt
    }))]
  });
});
dist$2.process.env.NODE_ENV !== "production" && (SelectInput.propTypes = {
  /**
   * @ignore
   */
  "aria-describedby": PropTypes.string,
  /**
   * @ignore
   */
  "aria-label": PropTypes.string,
  /**
   * @ignore
   */
  autoFocus: PropTypes.bool,
  /**
   * If `true`, the width of the popover will automatically be set according to the items inside the
   * menu, otherwise it will be at least the width of the select input.
   */
  autoWidth: PropTypes.bool,
  /**
   * The option elements to populate the select with.
   * Can be some `<MenuItem>` elements.
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * The CSS class name of the select element.
   */
  className: PropTypes.string,
  /**
   * If `true`, the component is toggled on mount. Use when the component open state is not controlled.
   * You can only use it when the `native` prop is `false` (default).
   */
  defaultOpen: PropTypes.bool,
  /**
   * The default value. Use when the component is not controlled.
   */
  defaultValue: PropTypes.any,
  /**
   * If `true`, the select is disabled.
   */
  disabled: PropTypes.bool,
  /**
   * If `true`, the selected item is displayed even if its value is empty.
   */
  displayEmpty: PropTypes.bool,
  /**
   * If `true`, the `select input` will indicate an error.
   */
  error: PropTypes.bool,
  /**
   * The icon that displays the arrow.
   */
  IconComponent: PropTypes.elementType.isRequired,
  /**
   * Imperative handle implementing `{ value: T, node: HTMLElement, focus(): void }`
   * Equivalent to `ref`
   */
  inputRef: refType,
  /**
   * The ID of an element that acts as an additional label. The Select will
   * be labelled by the additional label and the selected value.
   */
  labelId: PropTypes.string,
  /**
   * Props applied to the [`Menu`](/material-ui/api/menu/) element.
   */
  MenuProps: PropTypes.object,
  /**
   * If `true`, `value` must be an array and the menu will support multiple selections.
   */
  multiple: PropTypes.bool,
  /**
   * Name attribute of the `select` or hidden `input` element.
   */
  name: PropTypes.string,
  /**
   * @ignore
   */
  onBlur: PropTypes.func,
  /**
   * Callback fired when a menu item is selected.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (any).
   * @param {object} [child] The react element that was selected.
   */
  onChange: PropTypes.func,
  /**
   * Callback fired when the component requests to be closed.
   * Use in controlled mode (see open).
   *
   * @param {object} event The event source of the callback.
   */
  onClose: PropTypes.func,
  /**
   * @ignore
   */
  onFocus: PropTypes.func,
  /**
   * Callback fired when the component requests to be opened.
   * Use in controlled mode (see open).
   *
   * @param {object} event The event source of the callback.
   */
  onOpen: PropTypes.func,
  /**
   * If `true`, the component is shown.
   */
  open: PropTypes.bool,
  /**
   * @ignore
   */
  readOnly: PropTypes.bool,
  /**
   * Render the selected value.
   *
   * @param {any} value The `value` provided to the component.
   * @returns {ReactNode}
   */
  renderValue: PropTypes.func,
  /**
   * Props applied to the clickable div element.
   */
  SelectDisplayProps: PropTypes.object,
  /**
   * @ignore
   */
  tabIndex: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  /**
   * @ignore
   */
  type: PropTypes.any,
  /**
   * The input value.
   */
  value: PropTypes.any,
  /**
   * The variant to use.
   */
  variant: PropTypes.oneOf(["standard", "outlined", "filled"])
});
const _excluded$5 = ["autoWidth", "children", "classes", "className", "defaultOpen", "displayEmpty", "IconComponent", "id", "input", "inputProps", "label", "labelId", "MenuProps", "multiple", "native", "onClose", "onOpen", "open", "renderValue", "SelectDisplayProps", "variant"], _excluded2 = ["root"], useUtilityClasses$5 = (C) => {
  const {
    classes: e
  } = C;
  return e;
}, styledRootConfig = {
  name: "MuiSelect",
  overridesResolver: (C, e) => e.root,
  shouldForwardProp: (C) => rootShouldForwardProp(C) && C !== "variant",
  slot: "Root"
}, StyledInput = styled$1(Input, styledRootConfig)(""), StyledOutlinedInput = styled$1(OutlinedInput, styledRootConfig)(""), StyledFilledInput = styled$1(FilledInput, styledRootConfig)(""), Select = /* @__PURE__ */ React$1.forwardRef(function(e, T) {
  const $ = useDefaultProps({
    name: "MuiSelect",
    props: e
  }), {
    autoWidth: V = !1,
    children: J,
    classes: ee = {},
    className: te,
    defaultOpen: re = !1,
    displayEmpty: ie = !1,
    IconComponent: se = ArrowDropDownIcon,
    id: de,
    input: ue,
    inputProps: fe,
    label: he,
    labelId: me,
    MenuProps: xe,
    multiple: ve = !1,
    native: Te = !1,
    onClose: we,
    onOpen: Ee,
    open: Me,
    renderValue: Ie,
    SelectDisplayProps: ke,
    variant: _e = "outlined"
  } = $, De = _objectWithoutPropertiesLoose($, _excluded$5), Fe = Te ? NativeSelectInput : SelectInput, Ae = useFormControl(), ne = formControlState({
    props: $,
    muiFormControl: Ae,
    states: ["variant", "error"]
  }), oe = ne.variant || _e, ce = _extends({}, $, {
    variant: oe,
    classes: ee
  }), le = useUtilityClasses$5(ce), pe = _objectWithoutPropertiesLoose(le, _excluded2), ye = ue || {
    standard: /* @__PURE__ */ jsxRuntimeExports.jsx(StyledInput, {
      ownerState: ce
    }),
    outlined: /* @__PURE__ */ jsxRuntimeExports.jsx(StyledOutlinedInput, {
      label: he,
      ownerState: ce
    }),
    filled: /* @__PURE__ */ jsxRuntimeExports.jsx(StyledFilledInput, {
      ownerState: ce
    })
  }[oe], Ce = useForkRef(T, getReactElementRef(ye));
  return /* @__PURE__ */ jsxRuntimeExports.jsx(React$1.Fragment, {
    children: /* @__PURE__ */ React$1.cloneElement(ye, _extends({
      // Most of the logic is implemented in `SelectInput`.
      // The `Select` component is a simple API wrapper to expose something better to play with.
      inputComponent: Fe,
      inputProps: _extends({
        children: J,
        error: ne.error,
        IconComponent: se,
        variant: oe,
        type: void 0,
        // We render a select. We can ignore the type provided by the `Input`.
        multiple: ve
      }, Te ? {
        id: de
      } : {
        autoWidth: V,
        defaultOpen: re,
        displayEmpty: ie,
        labelId: me,
        MenuProps: xe,
        onClose: we,
        onOpen: Ee,
        open: Me,
        renderValue: Ie,
        SelectDisplayProps: _extends({
          id: de
        }, ke)
      }, fe, {
        classes: fe ? deepmerge$1(pe, fe.classes) : pe
      }, ue ? ue.props.inputProps : {})
    }, (ve && Te || ie) && oe === "outlined" ? {
      notched: !0
    } : {}, {
      ref: Ce,
      className: clsx(ye.props.className, te, le.root)
    }, !ue && {
      variant: oe
    }, De))
  });
});
dist$2.process.env.NODE_ENV !== "production" && (Select.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * If `true`, the width of the popover will automatically be set according to the items inside the
   * menu, otherwise it will be at least the width of the select input.
   * @default false
   */
  autoWidth: PropTypes.bool,
  /**
   * The option elements to populate the select with.
   * Can be some `MenuItem` when `native` is false and `option` when `native` is true.
   *
   * ⚠️The `MenuItem` elements **must** be direct descendants when `native` is false.
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   * @default {}
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * If `true`, the component is initially open. Use when the component open state is not controlled (i.e. the `open` prop is not defined).
   * You can only use it when the `native` prop is `false` (default).
   * @default false
   */
  defaultOpen: PropTypes.bool,
  /**
   * The default value. Use when the component is not controlled.
   */
  defaultValue: PropTypes.any,
  /**
   * If `true`, a value is displayed even if no items are selected.
   *
   * In order to display a meaningful value, a function can be passed to the `renderValue` prop which
   * returns the value to be displayed when no items are selected.
   *
   * ⚠️ When using this prop, make sure the label doesn't overlap with the empty displayed value.
   * The label should either be hidden or forced to a shrunk state.
   * @default false
   */
  displayEmpty: PropTypes.bool,
  /**
   * The icon that displays the arrow.
   * @default ArrowDropDownIcon
   */
  IconComponent: PropTypes.elementType,
  /**
   * The `id` of the wrapper element or the `select` element when `native`.
   */
  id: PropTypes.string,
  /**
   * An `Input` element; does not have to be a material-ui specific `Input`.
   */
  input: PropTypes.element,
  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   * When `native` is `true`, the attributes are applied on the `select` element.
   */
  inputProps: PropTypes.object,
  /**
   * See [OutlinedInput#label](/material-ui/api/outlined-input/#props)
   */
  label: PropTypes.node,
  /**
   * The ID of an element that acts as an additional label. The Select will
   * be labelled by the additional label and the selected value.
   */
  labelId: PropTypes.string,
  /**
   * Props applied to the [`Menu`](/material-ui/api/menu/) element.
   */
  MenuProps: PropTypes.object,
  /**
   * If `true`, `value` must be an array and the menu will support multiple selections.
   * @default false
   */
  multiple: PropTypes.bool,
  /**
   * If `true`, the component uses a native `select` element.
   * @default false
   */
  native: PropTypes.bool,
  /**
   * Callback fired when a menu item is selected.
   *
   * @param {SelectChangeEvent<Value>} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (any).
   * **Warning**: This is a generic event, not a change event, unless the change event is caused by browser autofill.
   * @param {object} [child] The react element that was selected when `native` is `false` (default).
   */
  onChange: PropTypes.func,
  /**
   * Callback fired when the component requests to be closed.
   * Use it in either controlled (see the `open` prop), or uncontrolled mode (to detect when the Select collapses).
   *
   * @param {object} event The event source of the callback.
   */
  onClose: PropTypes.func,
  /**
   * Callback fired when the component requests to be opened.
   * Use it in either controlled (see the `open` prop), or uncontrolled mode (to detect when the Select expands).
   *
   * @param {object} event The event source of the callback.
   */
  onOpen: PropTypes.func,
  /**
   * If `true`, the component is shown.
   * You can only use it when the `native` prop is `false` (default).
   */
  open: PropTypes.bool,
  /**
   * Render the selected value.
   * You can only use it when the `native` prop is `false` (default).
   *
   * @param {any} value The `value` provided to the component.
   * @returns {ReactNode}
   */
  renderValue: PropTypes.func,
  /**
   * Props applied to the clickable div element.
   */
  SelectDisplayProps: PropTypes.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * The `input` value. Providing an empty string will select no options.
   * Set to an empty string `''` if you don't want any of the available options to be selected.
   *
   * If the value is an object it must have reference equality with the option in order to be selected.
   * If the value is not an object, the string representation must match with the string representation of the option in order to be selected.
   */
  value: PropTypes.oneOfType([PropTypes.oneOf([""]), PropTypes.any]),
  /**
   * The variant to use.
   * @default 'outlined'
   */
  variant: PropTypes.oneOf(["filled", "outlined", "standard"])
});
Select.muiName = "Select";
function getSkeletonUtilityClass(C) {
  return generateUtilityClass("MuiSkeleton", C);
}
generateUtilityClasses("MuiSkeleton", ["root", "text", "rectangular", "rounded", "circular", "pulse", "wave", "withChildren", "fitContent", "heightAuto"]);
const _excluded$4 = ["animation", "className", "component", "height", "style", "variant", "width"];
let _ = (C) => C, _t, _t2, _t3, _t4;
const useUtilityClasses$4 = (C) => {
  const {
    classes: e,
    variant: T,
    animation: $,
    hasChildren: V,
    width: J,
    height: ee
  } = C;
  return composeClasses({
    root: ["root", T, $, V && "withChildren", V && !J && "fitContent", V && !ee && "heightAuto"]
  }, getSkeletonUtilityClass, e);
}, pulseKeyframe = keyframes(_t || (_t = _`
  0% {
    opacity: 1;
  }

  50% {
    opacity: 0.4;
  }

  100% {
    opacity: 1;
  }
`)), waveKeyframe = keyframes(_t2 || (_t2 = _`
  0% {
    transform: translateX(-100%);
  }

  50% {
    /* +0.5s of delay between each loop */
    transform: translateX(100%);
  }

  100% {
    transform: translateX(100%);
  }
`)), SkeletonRoot = styled$1("span", {
  name: "MuiSkeleton",
  slot: "Root",
  overridesResolver: (C, e) => {
    const {
      ownerState: T
    } = C;
    return [e.root, e[T.variant], T.animation !== !1 && e[T.animation], T.hasChildren && e.withChildren, T.hasChildren && !T.width && e.fitContent, T.hasChildren && !T.height && e.heightAuto];
  }
})(({
  theme: C,
  ownerState: e
}) => {
  const T = getUnit(C.shape.borderRadius) || "px", $ = toUnitless(C.shape.borderRadius);
  return _extends({
    display: "block",
    // Create a "on paper" color with sufficient contrast retaining the color
    backgroundColor: C.vars ? C.vars.palette.Skeleton.bg : alpha(C.palette.text.primary, C.palette.mode === "light" ? 0.11 : 0.13),
    height: "1.2em"
  }, e.variant === "text" && {
    marginTop: 0,
    marginBottom: 0,
    height: "auto",
    transformOrigin: "0 55%",
    transform: "scale(1, 0.60)",
    borderRadius: `${$}${T}/${Math.round($ / 0.6 * 10) / 10}${T}`,
    "&:empty:before": {
      content: '"\\00a0"'
    }
  }, e.variant === "circular" && {
    borderRadius: "50%"
  }, e.variant === "rounded" && {
    borderRadius: (C.vars || C).shape.borderRadius
  }, e.hasChildren && {
    "& > *": {
      visibility: "hidden"
    }
  }, e.hasChildren && !e.width && {
    maxWidth: "fit-content"
  }, e.hasChildren && !e.height && {
    height: "auto"
  });
}, ({
  ownerState: C
}) => C.animation === "pulse" && css(_t3 || (_t3 = _`
      animation: ${0} 2s ease-in-out 0.5s infinite;
    `), pulseKeyframe), ({
  ownerState: C,
  theme: e
}) => C.animation === "wave" && css(_t4 || (_t4 = _`
      position: relative;
      overflow: hidden;

      /* Fix bug in Safari https://bugs.webkit.org/show_bug.cgi?id=68196 */
      -webkit-mask-image: -webkit-radial-gradient(white, black);

      &::after {
        animation: ${0} 2s linear 0.5s infinite;
        background: linear-gradient(
          90deg,
          transparent,
          ${0},
          transparent
        );
        content: '';
        position: absolute;
        transform: translateX(-100%); /* Avoid flash during server-side hydration */
        bottom: 0;
        left: 0;
        right: 0;
        top: 0;
      }
    `), waveKeyframe, (e.vars || e).palette.action.hover)), Skeleton = /* @__PURE__ */ React$1.forwardRef(function(e, T) {
  const $ = useDefaultProps({
    props: e,
    name: "MuiSkeleton"
  }), {
    animation: V = "pulse",
    className: J,
    component: ee = "span",
    height: te,
    style: re,
    variant: ie = "text",
    width: se
  } = $, de = _objectWithoutPropertiesLoose($, _excluded$4), ue = _extends({}, $, {
    animation: V,
    component: ee,
    variant: ie,
    hasChildren: !!de.children
  }), fe = useUtilityClasses$4(ue);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(SkeletonRoot, _extends({
    as: ee,
    ref: T,
    className: clsx(fe.root, J),
    ownerState: ue
  }, de, {
    style: _extends({
      width: se,
      height: te
    }, re)
  }));
});
dist$2.process.env.NODE_ENV !== "production" && (Skeleton.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The animation.
   * If `false` the animation effect is disabled.
   * @default 'pulse'
   */
  animation: PropTypes.oneOf(["pulse", "wave", !1]),
  /**
   * Optional children to infer width and height from.
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes.elementType,
  /**
   * Height of the skeleton.
   * Useful when you don't want to adapt the skeleton to a text element but for instance a card.
   */
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  /**
   * @ignore
   */
  style: PropTypes.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * The type of content that will be rendered.
   * @default 'text'
   */
  variant: PropTypes.oneOfType([PropTypes.oneOf(["circular", "rectangular", "rounded", "text"]), PropTypes.string]),
  /**
   * Width of the skeleton.
   * Useful when the skeleton is inside an inline element with no width of its own.
   */
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
});
function areArraysEqual(C, e, T = ($, V) => $ === V) {
  return C.length === e.length && C.every(($, V) => T($, e[V]));
}
const INTENTIONAL_DRAG_COUNT_THRESHOLD = 2;
function asc(C, e) {
  return C - e;
}
function findClosest(C, e) {
  var T;
  const {
    index: $
  } = (T = C.reduce((V, J, ee) => {
    const te = Math.abs(e - J);
    return V === null || te < V.distance || te === V.distance ? {
      distance: te,
      index: ee
    } : V;
  }, null)) != null ? T : {};
  return $;
}
function trackFinger(C, e) {
  if (e.current !== void 0 && C.changedTouches) {
    const T = C;
    for (let $ = 0; $ < T.changedTouches.length; $ += 1) {
      const V = T.changedTouches[$];
      if (V.identifier === e.current)
        return {
          x: V.clientX,
          y: V.clientY
        };
    }
    return !1;
  }
  return {
    x: C.clientX,
    y: C.clientY
  };
}
function valueToPercent(C, e, T) {
  return (C - e) * 100 / (T - e);
}
function percentToValue(C, e, T) {
  return (T - e) * C + e;
}
function getDecimalPrecision(C) {
  if (Math.abs(C) < 1) {
    const T = C.toExponential().split("e-"), $ = T[0].split(".")[1];
    return ($ ? $.length : 0) + parseInt(T[1], 10);
  }
  const e = C.toString().split(".")[1];
  return e ? e.length : 0;
}
function roundValueToStep(C, e, T) {
  const $ = Math.round((C - T) / e) * e + T;
  return Number($.toFixed(getDecimalPrecision(e)));
}
function setValueIndex({
  values: C,
  newValue: e,
  index: T
}) {
  const $ = C.slice();
  return $[T] = e, $.sort(asc);
}
function focusThumb({
  sliderRef: C,
  activeIndex: e,
  setActive: T
}) {
  var $, V;
  const J = ownerDocument(C.current);
  if (!(($ = C.current) != null && $.contains(J.activeElement)) || Number(J == null || (V = J.activeElement) == null ? void 0 : V.getAttribute("data-index")) !== e) {
    var ee;
    (ee = C.current) == null || ee.querySelector(`[type="range"][data-index="${e}"]`).focus();
  }
  T && T(e);
}
function areValuesEqual(C, e) {
  return typeof C == "number" && typeof e == "number" ? C === e : typeof C == "object" && typeof e == "object" ? areArraysEqual(C, e) : !1;
}
const axisProps = {
  horizontal: {
    offset: (C) => ({
      left: `${C}%`
    }),
    leap: (C) => ({
      width: `${C}%`
    })
  },
  "horizontal-reverse": {
    offset: (C) => ({
      right: `${C}%`
    }),
    leap: (C) => ({
      width: `${C}%`
    })
  },
  vertical: {
    offset: (C) => ({
      bottom: `${C}%`
    }),
    leap: (C) => ({
      height: `${C}%`
    })
  }
}, Identity$1 = (C) => C;
let cachedSupportsTouchActionNone;
function doesSupportTouchActionNone() {
  return cachedSupportsTouchActionNone === void 0 && (typeof CSS < "u" && typeof CSS.supports == "function" ? cachedSupportsTouchActionNone = CSS.supports("touch-action", "none") : cachedSupportsTouchActionNone = !0), cachedSupportsTouchActionNone;
}
function useSlider(C) {
  const {
    "aria-labelledby": e,
    defaultValue: T,
    disabled: $ = !1,
    disableSwap: V = !1,
    isRtl: J = !1,
    marks: ee = !1,
    max: te = 100,
    min: re = 0,
    name: ie,
    onChange: se,
    onChangeCommitted: de,
    orientation: ue = "horizontal",
    rootRef: fe,
    scale: he = Identity$1,
    step: me = 1,
    shiftStep: xe = 10,
    tabIndex: ve,
    value: Te
  } = C, we = React$1.useRef(void 0), [Ee, Me] = React$1.useState(-1), [Ie, ke] = React$1.useState(-1), [_e, De] = React$1.useState(!1), Fe = React$1.useRef(0), [Ae, ne] = useControlled({
    controlled: Te,
    default: T ?? re,
    name: "Slider"
  }), oe = se && ((Pe, $e, Ze) => {
    const at = Pe.nativeEvent || Pe, wt = new at.constructor(at.type, at);
    Object.defineProperty(wt, "target", {
      writable: !0,
      value: {
        value: $e,
        name: ie
      }
    }), se(wt, $e, Ze);
  }), ce = Array.isArray(Ae);
  let le = ce ? Ae.slice().sort(asc) : [Ae];
  le = le.map((Pe) => Pe == null ? re : clamp$1(Pe, re, te));
  const pe = ee === !0 && me !== null ? [...Array(Math.floor((te - re) / me) + 1)].map((Pe, $e) => ({
    value: re + me * $e
  })) : ee || [], ye = pe.map((Pe) => Pe.value), {
    isFocusVisibleRef: Ce,
    onBlur: be,
    onFocus: ae,
    ref: ge
  } = useIsFocusVisible(), [Se, Le] = React$1.useState(-1), ze = React$1.useRef(null), Re = useForkRef(ge, ze), We = useForkRef(fe, Re), Be = (Pe) => ($e) => {
    var Ze;
    const at = Number($e.currentTarget.getAttribute("data-index"));
    ae($e), Ce.current === !0 && Le(at), ke(at), Pe == null || (Ze = Pe.onFocus) == null || Ze.call(Pe, $e);
  }, Ue = (Pe) => ($e) => {
    var Ze;
    be($e), Ce.current === !1 && Le(-1), ke(-1), Pe == null || (Ze = Pe.onBlur) == null || Ze.call(Pe, $e);
  }, Ge = (Pe, $e) => {
    const Ze = Number(Pe.currentTarget.getAttribute("data-index")), at = le[Ze], wt = ye.indexOf(at);
    let ft = $e;
    if (pe && me == null) {
      const Ct = ye[ye.length - 1];
      ft > Ct ? ft = Ct : ft < ye[0] ? ft = ye[0] : ft = ft < at ? ye[wt - 1] : ye[wt + 1];
    }
    if (ft = clamp$1(ft, re, te), ce) {
      V && (ft = clamp$1(ft, le[Ze - 1] || -1 / 0, le[Ze + 1] || 1 / 0));
      const Ct = ft;
      ft = setValueIndex({
        values: le,
        newValue: ft,
        index: Ze
      });
      let Ut = Ze;
      V || (Ut = ft.indexOf(Ct)), focusThumb({
        sliderRef: ze,
        activeIndex: Ut
      });
    }
    ne(ft), Le(Ze), oe && !areValuesEqual(ft, Ae) && oe(Pe, ft, Ze), de && de(Pe, ft);
  }, je = (Pe) => ($e) => {
    var Ze;
    if (me !== null) {
      const at = Number($e.currentTarget.getAttribute("data-index")), wt = le[at];
      let ft = null;
      ($e.key === "ArrowLeft" || $e.key === "ArrowDown") && $e.shiftKey || $e.key === "PageDown" ? ft = Math.max(wt - xe, re) : (($e.key === "ArrowRight" || $e.key === "ArrowUp") && $e.shiftKey || $e.key === "PageUp") && (ft = Math.min(wt + xe, te)), ft !== null && (Ge($e, ft), $e.preventDefault());
    }
    Pe == null || (Ze = Pe.onKeyDown) == null || Ze.call(Pe, $e);
  };
  useEnhancedEffect(() => {
    if ($ && ze.current.contains(document.activeElement)) {
      var Pe;
      (Pe = document.activeElement) == null || Pe.blur();
    }
  }, [$]), $ && Ee !== -1 && Me(-1), $ && Se !== -1 && Le(-1);
  const Oe = (Pe) => ($e) => {
    var Ze;
    (Ze = Pe.onChange) == null || Ze.call(Pe, $e), Ge($e, $e.target.valueAsNumber);
  }, Ne = React$1.useRef(void 0);
  let Ye = ue;
  J && ue === "horizontal" && (Ye += "-reverse");
  const Je = ({
    finger: Pe,
    move: $e = !1
  }) => {
    const {
      current: Ze
    } = ze, {
      width: at,
      height: wt,
      bottom: ft,
      left: Ct
    } = Ze.getBoundingClientRect();
    let Ut;
    Ye.indexOf("vertical") === 0 ? Ut = (ft - Pe.y) / wt : Ut = (Pe.x - Ct) / at, Ye.indexOf("-reverse") !== -1 && (Ut = 1 - Ut);
    let vt;
    if (vt = percentToValue(Ut, re, te), me)
      vt = roundValueToStep(vt, me, re);
    else {
      const Xt = findClosest(ye, vt);
      vt = ye[Xt];
    }
    vt = clamp$1(vt, re, te);
    let Mt = 0;
    if (ce) {
      $e ? Mt = Ne.current : Mt = findClosest(le, vt), V && (vt = clamp$1(vt, le[Mt - 1] || -1 / 0, le[Mt + 1] || 1 / 0));
      const Xt = vt;
      vt = setValueIndex({
        values: le,
        newValue: vt,
        index: Mt
      }), V && $e || (Mt = vt.indexOf(Xt), Ne.current = Mt);
    }
    return {
      newValue: vt,
      activeIndex: Mt
    };
  }, Xe = useEventCallback((Pe) => {
    const $e = trackFinger(Pe, we);
    if (!$e)
      return;
    if (Fe.current += 1, Pe.type === "mousemove" && Pe.buttons === 0) {
      st(Pe);
      return;
    }
    const {
      newValue: Ze,
      activeIndex: at
    } = Je({
      finger: $e,
      move: !0
    });
    focusThumb({
      sliderRef: ze,
      activeIndex: at,
      setActive: Me
    }), ne(Ze), !_e && Fe.current > INTENTIONAL_DRAG_COUNT_THRESHOLD && De(!0), oe && !areValuesEqual(Ze, Ae) && oe(Pe, Ze, at);
  }), st = useEventCallback((Pe) => {
    const $e = trackFinger(Pe, we);
    if (De(!1), !$e)
      return;
    const {
      newValue: Ze
    } = Je({
      finger: $e,
      move: !0
    });
    Me(-1), Pe.type === "touchend" && ke(-1), de && de(Pe, Ze), we.current = void 0, it();
  }), ct = useEventCallback((Pe) => {
    if ($)
      return;
    doesSupportTouchActionNone() || Pe.preventDefault();
    const $e = Pe.changedTouches[0];
    $e != null && (we.current = $e.identifier);
    const Ze = trackFinger(Pe, we);
    if (Ze !== !1) {
      const {
        newValue: wt,
        activeIndex: ft
      } = Je({
        finger: Ze
      });
      focusThumb({
        sliderRef: ze,
        activeIndex: ft,
        setActive: Me
      }), ne(wt), oe && !areValuesEqual(wt, Ae) && oe(Pe, wt, ft);
    }
    Fe.current = 0;
    const at = ownerDocument(ze.current);
    at.addEventListener("touchmove", Xe, {
      passive: !0
    }), at.addEventListener("touchend", st, {
      passive: !0
    });
  }), it = React$1.useCallback(() => {
    const Pe = ownerDocument(ze.current);
    Pe.removeEventListener("mousemove", Xe), Pe.removeEventListener("mouseup", st), Pe.removeEventListener("touchmove", Xe), Pe.removeEventListener("touchend", st);
  }, [st, Xe]);
  React$1.useEffect(() => {
    const {
      current: Pe
    } = ze;
    return Pe.addEventListener("touchstart", ct, {
      passive: doesSupportTouchActionNone()
    }), () => {
      Pe.removeEventListener("touchstart", ct), it();
    };
  }, [it, ct]), React$1.useEffect(() => {
    $ && it();
  }, [$, it]);
  const ot = (Pe) => ($e) => {
    var Ze;
    if ((Ze = Pe.onMouseDown) == null || Ze.call(Pe, $e), $ || $e.defaultPrevented || $e.button !== 0)
      return;
    $e.preventDefault();
    const at = trackFinger($e, we);
    if (at !== !1) {
      const {
        newValue: ft,
        activeIndex: Ct
      } = Je({
        finger: at
      });
      focusThumb({
        sliderRef: ze,
        activeIndex: Ct,
        setActive: Me
      }), ne(ft), oe && !areValuesEqual(ft, Ae) && oe($e, ft, Ct);
    }
    Fe.current = 0;
    const wt = ownerDocument(ze.current);
    wt.addEventListener("mousemove", Xe, {
      passive: !0
    }), wt.addEventListener("mouseup", st);
  }, yt = valueToPercent(ce ? le[0] : re, re, te), dt = valueToPercent(le[le.length - 1], re, te) - yt, mt = (Pe = {}) => {
    const $e = extractEventHandlers(Pe), Ze = {
      onMouseDown: ot($e || {})
    }, at = _extends({}, $e, Ze);
    return _extends({}, Pe, {
      ref: We
    }, at);
  }, It = (Pe) => ($e) => {
    var Ze;
    (Ze = Pe.onMouseOver) == null || Ze.call(Pe, $e);
    const at = Number($e.currentTarget.getAttribute("data-index"));
    ke(at);
  }, xt = (Pe) => ($e) => {
    var Ze;
    (Ze = Pe.onMouseLeave) == null || Ze.call(Pe, $e), ke(-1);
  };
  return {
    active: Ee,
    axis: Ye,
    axisProps,
    dragging: _e,
    focusedThumbIndex: Se,
    getHiddenInputProps: (Pe = {}) => {
      var $e;
      const Ze = extractEventHandlers(Pe), at = {
        onChange: Oe(Ze || {}),
        onFocus: Be(Ze || {}),
        onBlur: Ue(Ze || {}),
        onKeyDown: je(Ze || {})
      }, wt = _extends({}, Ze, at);
      return _extends({
        tabIndex: ve,
        "aria-labelledby": e,
        "aria-orientation": ue,
        "aria-valuemax": he(te),
        "aria-valuemin": he(re),
        name: ie,
        type: "range",
        min: C.min,
        max: C.max,
        step: C.step === null && C.marks ? "any" : ($e = C.step) != null ? $e : void 0,
        disabled: $
      }, Pe, wt, {
        style: _extends({}, visuallyHidden, {
          direction: J ? "rtl" : "ltr",
          // So that VoiceOver's focus indicator matches the thumb's dimensions
          width: "100%",
          height: "100%"
        })
      });
    },
    getRootProps: mt,
    getThumbProps: (Pe = {}) => {
      const $e = extractEventHandlers(Pe), Ze = {
        onMouseOver: It($e || {}),
        onMouseLeave: xt($e || {})
      };
      return _extends({}, Pe, $e, Ze);
    },
    marks: pe,
    open: Ie,
    range: ce,
    rootRef: We,
    trackLeap: dt,
    trackOffset: yt,
    values: le,
    getThumbStyle: (Pe) => ({
      // So the non active thumb doesn't show its label on hover.
      pointerEvents: Ee !== -1 && Ee !== Pe ? "none" : void 0
    })
  };
}
const shouldSpreadAdditionalProps = (C) => !C || !isHostComponent(C);
function getSliderUtilityClass(C) {
  return generateUtilityClass("MuiSlider", C);
}
const sliderClasses = generateUtilityClasses("MuiSlider", ["root", "active", "colorPrimary", "colorSecondary", "colorError", "colorInfo", "colorSuccess", "colorWarning", "disabled", "dragging", "focusVisible", "mark", "markActive", "marked", "markLabel", "markLabelActive", "rail", "sizeSmall", "thumb", "thumbColorPrimary", "thumbColorSecondary", "thumbColorError", "thumbColorSuccess", "thumbColorInfo", "thumbColorWarning", "track", "trackInverted", "trackFalse", "thumbSizeSmall", "valueLabel", "valueLabelOpen", "valueLabelCircle", "valueLabelLabel", "vertical"]), useValueLabelClasses = (C) => {
  const {
    open: e
  } = C;
  return {
    offset: clsx(e && sliderClasses.valueLabelOpen),
    circle: sliderClasses.valueLabelCircle,
    label: sliderClasses.valueLabelLabel
  };
};
function SliderValueLabel$1(C) {
  const {
    children: e,
    className: T,
    value: $
  } = C, V = useValueLabelClasses(C);
  return e ? /* @__PURE__ */ React$1.cloneElement(e, {
    className: clsx(e.props.className)
  }, /* @__PURE__ */ jsxRuntimeExports.jsxs(React$1.Fragment, {
    children: [e.props.children, /* @__PURE__ */ jsxRuntimeExports.jsx("span", {
      className: clsx(V.offset, T),
      "aria-hidden": !0,
      children: /* @__PURE__ */ jsxRuntimeExports.jsx("span", {
        className: V.circle,
        children: /* @__PURE__ */ jsxRuntimeExports.jsx("span", {
          className: V.label,
          children: $
        })
      })
    })]
  })) : null;
}
dist$2.process.env.NODE_ENV !== "production" && (SliderValueLabel$1.propTypes = {
  children: PropTypes.element.isRequired,
  className: PropTypes.string,
  value: PropTypes.node
});
const _excluded$3 = ["aria-label", "aria-valuetext", "aria-labelledby", "component", "components", "componentsProps", "color", "classes", "className", "disableSwap", "disabled", "getAriaLabel", "getAriaValueText", "marks", "max", "min", "name", "onChange", "onChangeCommitted", "orientation", "shiftStep", "size", "step", "scale", "slotProps", "slots", "tabIndex", "track", "value", "valueLabelDisplay", "valueLabelFormat"];
function Identity(C) {
  return C;
}
const SliderRoot = styled$1("span", {
  name: "MuiSlider",
  slot: "Root",
  overridesResolver: (C, e) => {
    const {
      ownerState: T
    } = C;
    return [e.root, e[`color${capitalize$3(T.color)}`], T.size !== "medium" && e[`size${capitalize$3(T.size)}`], T.marked && e.marked, T.orientation === "vertical" && e.vertical, T.track === "inverted" && e.trackInverted, T.track === !1 && e.trackFalse];
  }
})(({
  theme: C
}) => {
  var e;
  return {
    borderRadius: 12,
    boxSizing: "content-box",
    display: "inline-block",
    position: "relative",
    cursor: "pointer",
    touchAction: "none",
    WebkitTapHighlightColor: "transparent",
    "@media print": {
      colorAdjust: "exact"
    },
    [`&.${sliderClasses.disabled}`]: {
      pointerEvents: "none",
      cursor: "default",
      color: (C.vars || C).palette.grey[400]
    },
    [`&.${sliderClasses.dragging}`]: {
      [`& .${sliderClasses.thumb}, & .${sliderClasses.track}`]: {
        transition: "none"
      }
    },
    variants: [...Object.keys(((e = C.vars) != null ? e : C).palette).filter((T) => {
      var $;
      return (($ = C.vars) != null ? $ : C).palette[T].main;
    }).map((T) => ({
      props: {
        color: T
      },
      style: {
        color: (C.vars || C).palette[T].main
      }
    })), {
      props: {
        orientation: "horizontal"
      },
      style: {
        height: 4,
        width: "100%",
        padding: "13px 0",
        // The primary input mechanism of the device includes a pointing device of limited accuracy.
        "@media (pointer: coarse)": {
          // Reach 42px touch target, about ~8mm on screen.
          padding: "20px 0"
        }
      }
    }, {
      props: {
        orientation: "horizontal",
        size: "small"
      },
      style: {
        height: 2
      }
    }, {
      props: {
        orientation: "horizontal",
        marked: !0
      },
      style: {
        marginBottom: 20
      }
    }, {
      props: {
        orientation: "vertical"
      },
      style: {
        height: "100%",
        width: 4,
        padding: "0 13px",
        // The primary input mechanism of the device includes a pointing device of limited accuracy.
        "@media (pointer: coarse)": {
          // Reach 42px touch target, about ~8mm on screen.
          padding: "0 20px"
        }
      }
    }, {
      props: {
        orientation: "vertical",
        size: "small"
      },
      style: {
        width: 2
      }
    }, {
      props: {
        orientation: "vertical",
        marked: !0
      },
      style: {
        marginRight: 44
      }
    }]
  };
}), SliderRail = styled$1("span", {
  name: "MuiSlider",
  slot: "Rail",
  overridesResolver: (C, e) => e.rail
})({
  display: "block",
  position: "absolute",
  borderRadius: "inherit",
  backgroundColor: "currentColor",
  opacity: 0.38,
  variants: [{
    props: {
      orientation: "horizontal"
    },
    style: {
      width: "100%",
      height: "inherit",
      top: "50%",
      transform: "translateY(-50%)"
    }
  }, {
    props: {
      orientation: "vertical"
    },
    style: {
      height: "100%",
      width: "inherit",
      left: "50%",
      transform: "translateX(-50%)"
    }
  }, {
    props: {
      track: "inverted"
    },
    style: {
      opacity: 1
    }
  }]
}), SliderTrack = styled$1("span", {
  name: "MuiSlider",
  slot: "Track",
  overridesResolver: (C, e) => e.track
})(({
  theme: C
}) => {
  var e;
  return {
    display: "block",
    position: "absolute",
    borderRadius: "inherit",
    border: "1px solid currentColor",
    backgroundColor: "currentColor",
    transition: C.transitions.create(["left", "width", "bottom", "height"], {
      duration: C.transitions.duration.shortest
    }),
    variants: [{
      props: {
        size: "small"
      },
      style: {
        border: "none"
      }
    }, {
      props: {
        orientation: "horizontal"
      },
      style: {
        height: "inherit",
        top: "50%",
        transform: "translateY(-50%)"
      }
    }, {
      props: {
        orientation: "vertical"
      },
      style: {
        width: "inherit",
        left: "50%",
        transform: "translateX(-50%)"
      }
    }, {
      props: {
        track: !1
      },
      style: {
        display: "none"
      }
    }, ...Object.keys(((e = C.vars) != null ? e : C).palette).filter((T) => {
      var $;
      return (($ = C.vars) != null ? $ : C).palette[T].main;
    }).map((T) => ({
      props: {
        color: T,
        track: "inverted"
      },
      style: _extends({}, C.vars ? {
        backgroundColor: C.vars.palette.Slider[`${T}Track`],
        borderColor: C.vars.palette.Slider[`${T}Track`]
      } : _extends({
        backgroundColor: lighten_1(C.palette[T].main, 0.62),
        borderColor: lighten_1(C.palette[T].main, 0.62)
      }, C.applyStyles("dark", {
        backgroundColor: darken_1(C.palette[T].main, 0.5)
      }), C.applyStyles("dark", {
        borderColor: darken_1(C.palette[T].main, 0.5)
      })))
    }))]
  };
}), SliderThumb = styled$1("span", {
  name: "MuiSlider",
  slot: "Thumb",
  overridesResolver: (C, e) => {
    const {
      ownerState: T
    } = C;
    return [e.thumb, e[`thumbColor${capitalize$3(T.color)}`], T.size !== "medium" && e[`thumbSize${capitalize$3(T.size)}`]];
  }
})(({
  theme: C
}) => {
  var e;
  return {
    position: "absolute",
    width: 20,
    height: 20,
    boxSizing: "border-box",
    borderRadius: "50%",
    outline: 0,
    backgroundColor: "currentColor",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    transition: C.transitions.create(["box-shadow", "left", "bottom"], {
      duration: C.transitions.duration.shortest
    }),
    "&::before": {
      position: "absolute",
      content: '""',
      borderRadius: "inherit",
      width: "100%",
      height: "100%",
      boxShadow: (C.vars || C).shadows[2]
    },
    "&::after": {
      position: "absolute",
      content: '""',
      borderRadius: "50%",
      // 42px is the hit target
      width: 42,
      height: 42,
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)"
    },
    [`&.${sliderClasses.disabled}`]: {
      "&:hover": {
        boxShadow: "none"
      }
    },
    variants: [{
      props: {
        size: "small"
      },
      style: {
        width: 12,
        height: 12,
        "&::before": {
          boxShadow: "none"
        }
      }
    }, {
      props: {
        orientation: "horizontal"
      },
      style: {
        top: "50%",
        transform: "translate(-50%, -50%)"
      }
    }, {
      props: {
        orientation: "vertical"
      },
      style: {
        left: "50%",
        transform: "translate(-50%, 50%)"
      }
    }, ...Object.keys(((e = C.vars) != null ? e : C).palette).filter((T) => {
      var $;
      return (($ = C.vars) != null ? $ : C).palette[T].main;
    }).map((T) => ({
      props: {
        color: T
      },
      style: {
        [`&:hover, &.${sliderClasses.focusVisible}`]: _extends({}, C.vars ? {
          boxShadow: `0px 0px 0px 8px rgba(${C.vars.palette[T].mainChannel} / 0.16)`
        } : {
          boxShadow: `0px 0px 0px 8px ${alpha_1(C.palette[T].main, 0.16)}`
        }, {
          "@media (hover: none)": {
            boxShadow: "none"
          }
        }),
        [`&.${sliderClasses.active}`]: _extends({}, C.vars ? {
          boxShadow: `0px 0px 0px 14px rgba(${C.vars.palette[T].mainChannel} / 0.16)`
        } : {
          boxShadow: `0px 0px 0px 14px ${alpha_1(C.palette[T].main, 0.16)}`
        })
      }
    }))]
  };
}), SliderValueLabel = styled$1(SliderValueLabel$1, {
  name: "MuiSlider",
  slot: "ValueLabel",
  overridesResolver: (C, e) => e.valueLabel
})(({
  theme: C
}) => _extends({
  zIndex: 1,
  whiteSpace: "nowrap"
}, C.typography.body2, {
  fontWeight: 500,
  transition: C.transitions.create(["transform"], {
    duration: C.transitions.duration.shortest
  }),
  position: "absolute",
  backgroundColor: (C.vars || C).palette.grey[600],
  borderRadius: 2,
  color: (C.vars || C).palette.common.white,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  padding: "0.25rem 0.75rem",
  variants: [{
    props: {
      orientation: "horizontal"
    },
    style: {
      transform: "translateY(-100%) scale(0)",
      top: "-10px",
      transformOrigin: "bottom center",
      "&::before": {
        position: "absolute",
        content: '""',
        width: 8,
        height: 8,
        transform: "translate(-50%, 50%) rotate(45deg)",
        backgroundColor: "inherit",
        bottom: 0,
        left: "50%"
      },
      [`&.${sliderClasses.valueLabelOpen}`]: {
        transform: "translateY(-100%) scale(1)"
      }
    }
  }, {
    props: {
      orientation: "vertical"
    },
    style: {
      transform: "translateY(-50%) scale(0)",
      right: "30px",
      top: "50%",
      transformOrigin: "right center",
      "&::before": {
        position: "absolute",
        content: '""',
        width: 8,
        height: 8,
        transform: "translate(-50%, -50%) rotate(45deg)",
        backgroundColor: "inherit",
        right: -8,
        top: "50%"
      },
      [`&.${sliderClasses.valueLabelOpen}`]: {
        transform: "translateY(-50%) scale(1)"
      }
    }
  }, {
    props: {
      size: "small"
    },
    style: {
      fontSize: C.typography.pxToRem(12),
      padding: "0.25rem 0.5rem"
    }
  }, {
    props: {
      orientation: "vertical",
      size: "small"
    },
    style: {
      right: "20px"
    }
  }]
})), SliderMark = styled$1("span", {
  name: "MuiSlider",
  slot: "Mark",
  shouldForwardProp: (C) => slotShouldForwardProp(C) && C !== "markActive",
  overridesResolver: (C, e) => {
    const {
      markActive: T
    } = C;
    return [e.mark, T && e.markActive];
  }
})(({
  theme: C
}) => ({
  position: "absolute",
  width: 2,
  height: 2,
  borderRadius: 1,
  backgroundColor: "currentColor",
  variants: [{
    props: {
      orientation: "horizontal"
    },
    style: {
      top: "50%",
      transform: "translate(-1px, -50%)"
    }
  }, {
    props: {
      orientation: "vertical"
    },
    style: {
      left: "50%",
      transform: "translate(-50%, 1px)"
    }
  }, {
    props: {
      markActive: !0
    },
    style: {
      backgroundColor: (C.vars || C).palette.background.paper,
      opacity: 0.8
    }
  }]
})), SliderMarkLabel = styled$1("span", {
  name: "MuiSlider",
  slot: "MarkLabel",
  shouldForwardProp: (C) => slotShouldForwardProp(C) && C !== "markLabelActive",
  overridesResolver: (C, e) => e.markLabel
})(({
  theme: C
}) => _extends({}, C.typography.body2, {
  color: (C.vars || C).palette.text.secondary,
  position: "absolute",
  whiteSpace: "nowrap",
  variants: [{
    props: {
      orientation: "horizontal"
    },
    style: {
      top: 30,
      transform: "translateX(-50%)",
      "@media (pointer: coarse)": {
        top: 40
      }
    }
  }, {
    props: {
      orientation: "vertical"
    },
    style: {
      left: 36,
      transform: "translateY(50%)",
      "@media (pointer: coarse)": {
        left: 44
      }
    }
  }, {
    props: {
      markLabelActive: !0
    },
    style: {
      color: (C.vars || C).palette.text.primary
    }
  }]
})), useUtilityClasses$3 = (C) => {
  const {
    disabled: e,
    dragging: T,
    marked: $,
    orientation: V,
    track: J,
    classes: ee,
    color: te,
    size: re
  } = C, ie = {
    root: ["root", e && "disabled", T && "dragging", $ && "marked", V === "vertical" && "vertical", J === "inverted" && "trackInverted", J === !1 && "trackFalse", te && `color${capitalize$3(te)}`, re && `size${capitalize$3(re)}`],
    rail: ["rail"],
    track: ["track"],
    mark: ["mark"],
    markActive: ["markActive"],
    markLabel: ["markLabel"],
    markLabelActive: ["markLabelActive"],
    valueLabel: ["valueLabel"],
    thumb: ["thumb", e && "disabled", re && `thumbSize${capitalize$3(re)}`, te && `thumbColor${capitalize$3(te)}`],
    active: ["active"],
    disabled: ["disabled"],
    focusVisible: ["focusVisible"]
  };
  return composeClasses(ie, getSliderUtilityClass, ee);
}, Forward = ({
  children: C
}) => C, Slider = /* @__PURE__ */ React$1.forwardRef(function(e, T) {
  var $, V, J, ee, te, re, ie, se, de, ue, fe, he, me, xe, ve, Te, we, Ee, Me, Ie, ke, _e, De, Fe;
  const Ae = useDefaultProps({
    props: e,
    name: "MuiSlider"
  }), ne = useRtl(), {
    "aria-label": oe,
    "aria-valuetext": ce,
    "aria-labelledby": le,
    // eslint-disable-next-line react/prop-types
    component: pe = "span",
    components: ye = {},
    componentsProps: Ce = {},
    color: be = "primary",
    classes: ae,
    className: ge,
    disableSwap: Se = !1,
    disabled: Le = !1,
    getAriaLabel: ze,
    getAriaValueText: Re,
    marks: We = !1,
    max: Be = 100,
    min: Ue = 0,
    orientation: Ge = "horizontal",
    shiftStep: je = 10,
    size: Oe = "medium",
    step: Ne = 1,
    scale: Ye = Identity,
    slotProps: Je,
    slots: Xe,
    track: st = "normal",
    valueLabelDisplay: ct = "off",
    valueLabelFormat: it = Identity
  } = Ae, ot = _objectWithoutPropertiesLoose(Ae, _excluded$3), yt = _extends({}, Ae, {
    isRtl: ne,
    max: Be,
    min: Ue,
    classes: ae,
    disabled: Le,
    disableSwap: Se,
    orientation: Ge,
    marks: We,
    color: be,
    size: Oe,
    step: Ne,
    shiftStep: je,
    scale: Ye,
    track: st,
    valueLabelDisplay: ct,
    valueLabelFormat: it
  }), {
    axisProps: dt,
    getRootProps: mt,
    getHiddenInputProps: It,
    getThumbProps: xt,
    open: Tt,
    active: Yt,
    axis: Ve,
    focusedThumbIndex: Pe,
    range: $e,
    dragging: Ze,
    marks: at,
    values: wt,
    trackOffset: ft,
    trackLeap: Ct,
    getThumbStyle: Ut
  } = useSlider(_extends({}, yt, {
    rootRef: T
  }));
  yt.marked = at.length > 0 && at.some((bt) => bt.label), yt.dragging = Ze, yt.focusedThumbIndex = Pe;
  const vt = useUtilityClasses$3(yt), Mt = ($ = (V = Xe == null ? void 0 : Xe.root) != null ? V : ye.Root) != null ? $ : SliderRoot, Xt = (J = (ee = Xe == null ? void 0 : Xe.rail) != null ? ee : ye.Rail) != null ? J : SliderRail, St = (te = (re = Xe == null ? void 0 : Xe.track) != null ? re : ye.Track) != null ? te : SliderTrack, Ot = (ie = (se = Xe == null ? void 0 : Xe.thumb) != null ? se : ye.Thumb) != null ? ie : SliderThumb, wn = (de = (ue = Xe == null ? void 0 : Xe.valueLabel) != null ? ue : ye.ValueLabel) != null ? de : SliderValueLabel, kt = (fe = (he = Xe == null ? void 0 : Xe.mark) != null ? he : ye.Mark) != null ? fe : SliderMark, Bt = (me = (xe = Xe == null ? void 0 : Xe.markLabel) != null ? xe : ye.MarkLabel) != null ? me : SliderMarkLabel, Tn = (ve = (Te = Xe == null ? void 0 : Xe.input) != null ? Te : ye.Input) != null ? ve : "input", Nt = (we = Je == null ? void 0 : Je.root) != null ? we : Ce.root, Wt = (Ee = Je == null ? void 0 : Je.rail) != null ? Ee : Ce.rail, En = (Me = Je == null ? void 0 : Je.track) != null ? Me : Ce.track, Lt = (Ie = Je == null ? void 0 : Je.thumb) != null ? Ie : Ce.thumb, Ht = (ke = Je == null ? void 0 : Je.valueLabel) != null ? ke : Ce.valueLabel, In = (_e = Je == null ? void 0 : Je.mark) != null ? _e : Ce.mark, Dt = (De = Je == null ? void 0 : Je.markLabel) != null ? De : Ce.markLabel, Gt = (Fe = Je == null ? void 0 : Je.input) != null ? Fe : Ce.input, Ke = useSlotProps({
    elementType: Mt,
    getSlotProps: mt,
    externalSlotProps: Nt,
    externalForwardedProps: ot,
    additionalProps: _extends({}, shouldSpreadAdditionalProps(Mt) && {
      as: pe
    }),
    ownerState: _extends({}, yt, Nt == null ? void 0 : Nt.ownerState),
    className: [vt.root, ge]
  }), Qe = useSlotProps({
    elementType: Xt,
    externalSlotProps: Wt,
    ownerState: yt,
    className: vt.rail
  }), et = useSlotProps({
    elementType: St,
    externalSlotProps: En,
    additionalProps: {
      style: _extends({}, dt[Ve].offset(ft), dt[Ve].leap(Ct))
    },
    ownerState: _extends({}, yt, En == null ? void 0 : En.ownerState),
    className: vt.track
  }), He = useSlotProps({
    elementType: Ot,
    getSlotProps: xt,
    externalSlotProps: Lt,
    ownerState: _extends({}, yt, Lt == null ? void 0 : Lt.ownerState),
    className: vt.thumb
  }), nt = useSlotProps({
    elementType: wn,
    externalSlotProps: Ht,
    ownerState: _extends({}, yt, Ht == null ? void 0 : Ht.ownerState),
    className: vt.valueLabel
  }), qe = useSlotProps({
    elementType: kt,
    externalSlotProps: In,
    ownerState: yt,
    className: vt.mark
  }), ht = useSlotProps({
    elementType: Bt,
    externalSlotProps: Dt,
    ownerState: yt,
    className: vt.markLabel
  }), pt = useSlotProps({
    elementType: Tn,
    getSlotProps: It,
    externalSlotProps: Gt,
    ownerState: yt
  });
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(Mt, _extends({}, Ke, {
    children: [/* @__PURE__ */ jsxRuntimeExports.jsx(Xt, _extends({}, Qe)), /* @__PURE__ */ jsxRuntimeExports.jsx(St, _extends({}, et)), at.filter((bt) => bt.value >= Ue && bt.value <= Be).map((bt, jt) => {
      const $t = valueToPercent(bt.value, Ue, Be), Jt = dt[Ve].offset($t);
      let zt;
      return st === !1 ? zt = wt.indexOf(bt.value) !== -1 : zt = st === "normal" && ($e ? bt.value >= wt[0] && bt.value <= wt[wt.length - 1] : bt.value <= wt[0]) || st === "inverted" && ($e ? bt.value <= wt[0] || bt.value >= wt[wt.length - 1] : bt.value >= wt[0]), /* @__PURE__ */ jsxRuntimeExports.jsxs(React$1.Fragment, {
        children: [/* @__PURE__ */ jsxRuntimeExports.jsx(kt, _extends({
          "data-index": jt
        }, qe, !isHostComponent(kt) && {
          markActive: zt
        }, {
          style: _extends({}, Jt, qe.style),
          className: clsx(qe.className, zt && vt.markActive)
        })), bt.label != null ? /* @__PURE__ */ jsxRuntimeExports.jsx(Bt, _extends({
          "aria-hidden": !0,
          "data-index": jt
        }, ht, !isHostComponent(Bt) && {
          markLabelActive: zt
        }, {
          style: _extends({}, Jt, ht.style),
          className: clsx(vt.markLabel, ht.className, zt && vt.markLabelActive),
          children: bt.label
        })) : null]
      }, jt);
    }), wt.map((bt, jt) => {
      const $t = valueToPercent(bt, Ue, Be), Jt = dt[Ve].offset($t), zt = ct === "off" ? Forward : wn;
      return (
        /* TODO v6: Change component structure. It will help in avoiding the complicated React.cloneElement API added in SliderValueLabel component. Should be: Thumb -> Input, ValueLabel. Follow Joy UI's Slider structure. */
        /* @__PURE__ */ jsxRuntimeExports.jsx(zt, _extends({}, !isHostComponent(zt) && {
          valueLabelFormat: it,
          valueLabelDisplay: ct,
          value: typeof it == "function" ? it(Ye(bt), jt) : it,
          index: jt,
          open: Tt === jt || Yt === jt || ct === "on",
          disabled: Le
        }, nt, {
          children: /* @__PURE__ */ jsxRuntimeExports.jsx(Ot, _extends({
            "data-index": jt
          }, He, {
            className: clsx(vt.thumb, He.className, Yt === jt && vt.active, Pe === jt && vt.focusVisible),
            style: _extends({}, Jt, Ut(jt), He.style),
            children: /* @__PURE__ */ jsxRuntimeExports.jsx(Tn, _extends({
              "data-index": jt,
              "aria-label": ze ? ze(jt) : oe,
              "aria-valuenow": Ye(bt),
              "aria-labelledby": le,
              "aria-valuetext": Re ? Re(Ye(bt), jt) : ce,
              value: wt[jt]
            }, pt))
          }))
        }), jt)
      );
    })]
  }));
});
dist$2.process.env.NODE_ENV !== "production" && (Slider.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The label of the slider.
   */
  "aria-label": chainPropTypes(PropTypes.string, (C) => Array.isArray(C.value || C.defaultValue) && C["aria-label"] != null ? new Error("MUI: You need to use the `getAriaLabel` prop instead of `aria-label` when using a range slider.") : null),
  /**
   * The id of the element containing a label for the slider.
   */
  "aria-labelledby": PropTypes.string,
  /**
   * A string value that provides a user-friendly name for the current value of the slider.
   */
  "aria-valuetext": chainPropTypes(PropTypes.string, (C) => Array.isArray(C.value || C.defaultValue) && C["aria-valuetext"] != null ? new Error("MUI: You need to use the `getAriaValueText` prop instead of `aria-valuetext` when using a range slider.") : null),
  /**
   * @ignore
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'primary'
   */
  color: PropTypes.oneOfType([PropTypes.oneOf(["primary", "secondary", "error", "info", "success", "warning"]), PropTypes.string]),
  /**
   * The components used for each slot inside.
   *
   * @deprecated use the `slots` prop instead. This prop will be removed in v7. [How to migrate](/material-ui/migration/migrating-from-deprecated-apis/).
   *
   * @default {}
   */
  components: PropTypes.shape({
    Input: PropTypes.elementType,
    Mark: PropTypes.elementType,
    MarkLabel: PropTypes.elementType,
    Rail: PropTypes.elementType,
    Root: PropTypes.elementType,
    Thumb: PropTypes.elementType,
    Track: PropTypes.elementType,
    ValueLabel: PropTypes.elementType
  }),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * @deprecated use the `slotProps` prop instead. This prop will be removed in v7. [How to migrate](/material-ui/migration/migrating-from-deprecated-apis/).
   *
   * @default {}
   */
  componentsProps: PropTypes.shape({
    input: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
    mark: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
    markLabel: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
    rail: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
    root: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
    thumb: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
    track: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
    valueLabel: PropTypes.oneOfType([PropTypes.func, PropTypes.shape({
      children: PropTypes.element,
      className: PropTypes.string,
      open: PropTypes.bool,
      style: PropTypes.object,
      value: PropTypes.number,
      valueLabelDisplay: PropTypes.oneOf(["auto", "off", "on"])
    })])
  }),
  /**
   * The default value. Use when the component is not controlled.
   */
  defaultValue: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.number), PropTypes.number]),
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: PropTypes.bool,
  /**
   * If `true`, the active thumb doesn't swap when moving pointer over a thumb while dragging another thumb.
   * @default false
   */
  disableSwap: PropTypes.bool,
  /**
   * Accepts a function which returns a string value that provides a user-friendly name for the thumb labels of the slider.
   * This is important for screen reader users.
   * @param {number} index The thumb label's index to format.
   * @returns {string}
   */
  getAriaLabel: PropTypes.func,
  /**
   * Accepts a function which returns a string value that provides a user-friendly name for the current value of the slider.
   * This is important for screen reader users.
   * @param {number} value The thumb label's value to format.
   * @param {number} index The thumb label's index to format.
   * @returns {string}
   */
  getAriaValueText: PropTypes.func,
  /**
   * Marks indicate predetermined values to which the user can move the slider.
   * If `true` the marks are spaced according the value of the `step` prop.
   * If an array, it should contain objects with `value` and an optional `label` keys.
   * @default false
   */
  marks: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.node,
    value: PropTypes.number.isRequired
  })), PropTypes.bool]),
  /**
   * The maximum allowed value of the slider.
   * Should not be equal to min.
   * @default 100
   */
  max: PropTypes.number,
  /**
   * The minimum allowed value of the slider.
   * Should not be equal to max.
   * @default 0
   */
  min: PropTypes.number,
  /**
   * Name attribute of the hidden `input` element.
   */
  name: PropTypes.string,
  /**
   * Callback function that is fired when the slider's value changed.
   *
   * @param {Event} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (any).
   * **Warning**: This is a generic event not a change event.
   * @param {number | number[]} value The new value.
   * @param {number} activeThumb Index of the currently moved thumb.
   */
  onChange: PropTypes.func,
  /**
   * Callback function that is fired when the `mouseup` is triggered.
   *
   * @param {React.SyntheticEvent | Event} event The event source of the callback. **Warning**: This is a generic event not a change event.
   * @param {number | number[]} value The new value.
   */
  onChangeCommitted: PropTypes.func,
  /**
   * The component orientation.
   * @default 'horizontal'
   */
  orientation: PropTypes.oneOf(["horizontal", "vertical"]),
  /**
   * A transformation function, to change the scale of the slider.
   * @param {any} x
   * @returns {any}
   * @default function Identity(x) {
   *   return x;
   * }
   */
  scale: PropTypes.func,
  /**
   * The granularity with which the slider can step through values when using Page Up/Page Down or Shift + Arrow Up/Arrow Down.
   * @default 10
   */
  shiftStep: PropTypes.number,
  /**
   * The size of the slider.
   * @default 'medium'
   */
  size: PropTypes.oneOfType([PropTypes.oneOf(["small", "medium"]), PropTypes.string]),
  /**
   * The props used for each slot inside the Slider.
   * @default {}
   */
  slotProps: PropTypes.shape({
    input: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
    mark: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
    markLabel: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
    rail: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
    root: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
    thumb: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
    track: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
    valueLabel: PropTypes.oneOfType([PropTypes.func, PropTypes.shape({
      children: PropTypes.element,
      className: PropTypes.string,
      open: PropTypes.bool,
      style: PropTypes.object,
      value: PropTypes.number,
      valueLabelDisplay: PropTypes.oneOf(["auto", "off", "on"])
    })])
  }),
  /**
   * The components used for each slot inside the Slider.
   * Either a string to use a HTML element or a component.
   * @default {}
   */
  slots: PropTypes.shape({
    input: PropTypes.elementType,
    mark: PropTypes.elementType,
    markLabel: PropTypes.elementType,
    rail: PropTypes.elementType,
    root: PropTypes.elementType,
    thumb: PropTypes.elementType,
    track: PropTypes.elementType,
    valueLabel: PropTypes.elementType
  }),
  /**
   * The granularity with which the slider can step through values. (A "discrete" slider.)
   * The `min` prop serves as the origin for the valid values.
   * We recommend (max - min) to be evenly divisible by the step.
   *
   * When step is `null`, the thumb can only be slid onto marks provided with the `marks` prop.
   * @default 1
   */
  step: PropTypes.number,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * Tab index attribute of the hidden `input` element.
   */
  tabIndex: PropTypes.number,
  /**
   * The track presentation:
   *
   * - `normal` the track will render a bar representing the slider value.
   * - `inverted` the track will render a bar representing the remaining slider value.
   * - `false` the track will render without a bar.
   * @default 'normal'
   */
  track: PropTypes.oneOf(["inverted", "normal", !1]),
  /**
   * The value of the slider.
   * For ranged sliders, provide an array with two values.
   */
  value: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.number), PropTypes.number]),
  /**
   * Controls when the value label is displayed:
   *
   * - `auto` the value label will display when the thumb is hovered or focused.
   * - `on` will display persistently.
   * - `off` will never display.
   * @default 'off'
   */
  valueLabelDisplay: PropTypes.oneOf(["auto", "off", "on"]),
  /**
   * The format function the value label's value.
   *
   * When a function is provided, it should have the following signature:
   *
   * - {number} value The value label's value to format
   * - {number} index The value label's index to format
   * @param {any} x
   * @returns {any}
   * @default function Identity(x) {
   *   return x;
   * }
   */
  valueLabelFormat: PropTypes.oneOfType([PropTypes.func, PropTypes.string])
});
function getTooltipUtilityClass(C) {
  return generateUtilityClass("MuiTooltip", C);
}
const tooltipClasses = generateUtilityClasses("MuiTooltip", ["popper", "popperInteractive", "popperArrow", "popperClose", "tooltip", "tooltipArrow", "touch", "tooltipPlacementLeft", "tooltipPlacementRight", "tooltipPlacementTop", "tooltipPlacementBottom", "arrow"]), _excluded$2 = ["arrow", "children", "classes", "components", "componentsProps", "describeChild", "disableFocusListener", "disableHoverListener", "disableInteractive", "disableTouchListener", "enterDelay", "enterNextDelay", "enterTouchDelay", "followCursor", "id", "leaveDelay", "leaveTouchDelay", "onClose", "onOpen", "open", "placement", "PopperComponent", "PopperProps", "slotProps", "slots", "title", "TransitionComponent", "TransitionProps"];
function round(C) {
  return Math.round(C * 1e5) / 1e5;
}
const useUtilityClasses$2 = (C) => {
  const {
    classes: e,
    disableInteractive: T,
    arrow: $,
    touch: V,
    placement: J
  } = C, ee = {
    popper: ["popper", !T && "popperInteractive", $ && "popperArrow"],
    tooltip: ["tooltip", $ && "tooltipArrow", V && "touch", `tooltipPlacement${capitalize$3(J.split("-")[0])}`],
    arrow: ["arrow"]
  };
  return composeClasses(ee, getTooltipUtilityClass, e);
}, TooltipPopper = styled$1(Popper, {
  name: "MuiTooltip",
  slot: "Popper",
  overridesResolver: (C, e) => {
    const {
      ownerState: T
    } = C;
    return [e.popper, !T.disableInteractive && e.popperInteractive, T.arrow && e.popperArrow, !T.open && e.popperClose];
  }
})(({
  theme: C,
  ownerState: e,
  open: T
}) => _extends({
  zIndex: (C.vars || C).zIndex.tooltip,
  pointerEvents: "none"
}, !e.disableInteractive && {
  pointerEvents: "auto"
}, !T && {
  pointerEvents: "none"
}, e.arrow && {
  [`&[data-popper-placement*="bottom"] .${tooltipClasses.arrow}`]: {
    top: 0,
    marginTop: "-0.71em",
    "&::before": {
      transformOrigin: "0 100%"
    }
  },
  [`&[data-popper-placement*="top"] .${tooltipClasses.arrow}`]: {
    bottom: 0,
    marginBottom: "-0.71em",
    "&::before": {
      transformOrigin: "100% 0"
    }
  },
  [`&[data-popper-placement*="right"] .${tooltipClasses.arrow}`]: _extends({}, e.isRtl ? {
    right: 0,
    marginRight: "-0.71em"
  } : {
    left: 0,
    marginLeft: "-0.71em"
  }, {
    height: "1em",
    width: "0.71em",
    "&::before": {
      transformOrigin: "100% 100%"
    }
  }),
  [`&[data-popper-placement*="left"] .${tooltipClasses.arrow}`]: _extends({}, e.isRtl ? {
    left: 0,
    marginLeft: "-0.71em"
  } : {
    right: 0,
    marginRight: "-0.71em"
  }, {
    height: "1em",
    width: "0.71em",
    "&::before": {
      transformOrigin: "0 0"
    }
  })
})), TooltipTooltip = styled$1("div", {
  name: "MuiTooltip",
  slot: "Tooltip",
  overridesResolver: (C, e) => {
    const {
      ownerState: T
    } = C;
    return [e.tooltip, T.touch && e.touch, T.arrow && e.tooltipArrow, e[`tooltipPlacement${capitalize$3(T.placement.split("-")[0])}`]];
  }
})(({
  theme: C,
  ownerState: e
}) => _extends({
  backgroundColor: C.vars ? C.vars.palette.Tooltip.bg : alpha_1(C.palette.grey[700], 0.92),
  borderRadius: (C.vars || C).shape.borderRadius,
  color: (C.vars || C).palette.common.white,
  fontFamily: C.typography.fontFamily,
  padding: "4px 8px",
  fontSize: C.typography.pxToRem(11),
  maxWidth: 300,
  margin: 2,
  wordWrap: "break-word",
  fontWeight: C.typography.fontWeightMedium
}, e.arrow && {
  position: "relative",
  margin: 0
}, e.touch && {
  padding: "8px 16px",
  fontSize: C.typography.pxToRem(14),
  lineHeight: `${round(16 / 14)}em`,
  fontWeight: C.typography.fontWeightRegular
}, {
  [`.${tooltipClasses.popper}[data-popper-placement*="left"] &`]: _extends({
    transformOrigin: "right center"
  }, e.isRtl ? _extends({
    marginLeft: "14px"
  }, e.touch && {
    marginLeft: "24px"
  }) : _extends({
    marginRight: "14px"
  }, e.touch && {
    marginRight: "24px"
  })),
  [`.${tooltipClasses.popper}[data-popper-placement*="right"] &`]: _extends({
    transformOrigin: "left center"
  }, e.isRtl ? _extends({
    marginRight: "14px"
  }, e.touch && {
    marginRight: "24px"
  }) : _extends({
    marginLeft: "14px"
  }, e.touch && {
    marginLeft: "24px"
  })),
  [`.${tooltipClasses.popper}[data-popper-placement*="top"] &`]: _extends({
    transformOrigin: "center bottom",
    marginBottom: "14px"
  }, e.touch && {
    marginBottom: "24px"
  }),
  [`.${tooltipClasses.popper}[data-popper-placement*="bottom"] &`]: _extends({
    transformOrigin: "center top",
    marginTop: "14px"
  }, e.touch && {
    marginTop: "24px"
  })
})), TooltipArrow = styled$1("span", {
  name: "MuiTooltip",
  slot: "Arrow",
  overridesResolver: (C, e) => e.arrow
})(({
  theme: C
}) => ({
  overflow: "hidden",
  position: "absolute",
  width: "1em",
  height: "0.71em",
  boxSizing: "border-box",
  color: C.vars ? C.vars.palette.Tooltip.bg : alpha_1(C.palette.grey[700], 0.9),
  "&::before": {
    content: '""',
    margin: "auto",
    display: "block",
    width: "100%",
    height: "100%",
    backgroundColor: "currentColor",
    transform: "rotate(45deg)"
  }
}));
let hystersisOpen = !1;
const hystersisTimer = new Timeout();
let cursorPosition = {
  x: 0,
  y: 0
};
function composeEventHandler(C, e) {
  return (T, ...$) => {
    e && e(T, ...$), C(T, ...$);
  };
}
const Tooltip = /* @__PURE__ */ React$1.forwardRef(function(e, T) {
  var $, V, J, ee, te, re, ie, se, de, ue, fe, he, me, xe, ve, Te, we, Ee, Me;
  const Ie = useDefaultProps({
    props: e,
    name: "MuiTooltip"
  }), {
    arrow: ke = !1,
    children: _e,
    components: De = {},
    componentsProps: Fe = {},
    describeChild: Ae = !1,
    disableFocusListener: ne = !1,
    disableHoverListener: oe = !1,
    disableInteractive: ce = !1,
    disableTouchListener: le = !1,
    enterDelay: pe = 100,
    enterNextDelay: ye = 0,
    enterTouchDelay: Ce = 700,
    followCursor: be = !1,
    id: ae,
    leaveDelay: ge = 0,
    leaveTouchDelay: Se = 1500,
    onClose: Le,
    onOpen: ze,
    open: Re,
    placement: We = "bottom",
    PopperComponent: Be,
    PopperProps: Ue = {},
    slotProps: Ge = {},
    slots: je = {},
    title: Oe,
    TransitionComponent: Ne = Grow,
    TransitionProps: Ye
  } = Ie, Je = _objectWithoutPropertiesLoose(Ie, _excluded$2), Xe = /* @__PURE__ */ React$1.isValidElement(_e) ? _e : /* @__PURE__ */ jsxRuntimeExports.jsx("span", {
    children: _e
  }), st = useTheme$1(), ct = useRtl(), [it, ot] = React$1.useState(), [yt, dt] = React$1.useState(null), mt = React$1.useRef(!1), It = ce || be, xt = useTimeout(), Tt = useTimeout(), Yt = useTimeout(), Ve = useTimeout(), [Pe, $e] = useControlled({
    controlled: Re,
    default: !1,
    name: "Tooltip",
    state: "open"
  });
  let Ze = Pe;
  if (dist$2.process.env.NODE_ENV !== "production") {
    const {
      current: Vt
    } = React$1.useRef(Re !== void 0);
    React$1.useEffect(() => {
      it && it.disabled && !Vt && Oe !== "" && it.tagName.toLowerCase() === "button" && console.error(["MUI: You are providing a disabled `button` child to the Tooltip component.", "A disabled element does not fire events.", "Tooltip needs to listen to the child element's events to display the title.", "", "Add a simple wrapper element, such as a `span`."].join(`
`));
    }, [Oe, it, Vt]);
  }
  const at = useId(ae), wt = React$1.useRef(), ft = useEventCallback(() => {
    wt.current !== void 0 && (document.body.style.WebkitUserSelect = wt.current, wt.current = void 0), Ve.clear();
  });
  React$1.useEffect(() => ft, [ft]);
  const Ct = (Vt) => {
    hystersisTimer.clear(), hystersisOpen = !0, $e(!0), ze && !Ze && ze(Vt);
  }, Ut = useEventCallback(
    /**
     * @param {React.SyntheticEvent | Event} event
     */
    (Vt) => {
      hystersisTimer.start(800 + ge, () => {
        hystersisOpen = !1;
      }), $e(!1), Le && Ze && Le(Vt), xt.start(st.transitions.duration.shortest, () => {
        mt.current = !1;
      });
    }
  ), vt = (Vt) => {
    mt.current && Vt.type !== "touchstart" || (it && it.removeAttribute("title"), Tt.clear(), Yt.clear(), pe || hystersisOpen && ye ? Tt.start(hystersisOpen ? ye : pe, () => {
      Ct(Vt);
    }) : Ct(Vt));
  }, Mt = (Vt) => {
    Tt.clear(), Yt.start(ge, () => {
      Ut(Vt);
    });
  }, {
    isFocusVisibleRef: Xt,
    onBlur: St,
    onFocus: Ot,
    ref: wn
  } = useIsFocusVisible(), [, kt] = React$1.useState(!1), Bt = (Vt) => {
    St(Vt), Xt.current === !1 && (kt(!1), Mt(Vt));
  }, Tn = (Vt) => {
    it || ot(Vt.currentTarget), Ot(Vt), Xt.current === !0 && (kt(!0), vt(Vt));
  }, Nt = (Vt) => {
    mt.current = !0;
    const Kt = Xe.props;
    Kt.onTouchStart && Kt.onTouchStart(Vt);
  }, Wt = (Vt) => {
    Nt(Vt), Yt.clear(), xt.clear(), ft(), wt.current = document.body.style.WebkitUserSelect, document.body.style.WebkitUserSelect = "none", Ve.start(Ce, () => {
      document.body.style.WebkitUserSelect = wt.current, vt(Vt);
    });
  }, En = (Vt) => {
    Xe.props.onTouchEnd && Xe.props.onTouchEnd(Vt), ft(), Yt.start(Se, () => {
      Ut(Vt);
    });
  };
  React$1.useEffect(() => {
    if (!Ze)
      return;
    function Vt(Kt) {
      (Kt.key === "Escape" || Kt.key === "Esc") && Ut(Kt);
    }
    return document.addEventListener("keydown", Vt), () => {
      document.removeEventListener("keydown", Vt);
    };
  }, [Ut, Ze]);
  const Lt = useForkRef(getReactElementRef(Xe), wn, ot, T);
  !Oe && Oe !== 0 && (Ze = !1);
  const Ht = React$1.useRef(), In = (Vt) => {
    const Kt = Xe.props;
    Kt.onMouseMove && Kt.onMouseMove(Vt), cursorPosition = {
      x: Vt.clientX,
      y: Vt.clientY
    }, Ht.current && Ht.current.update();
  }, Dt = {}, Gt = typeof Oe == "string";
  Ae ? (Dt.title = !Ze && Gt && !oe ? Oe : null, Dt["aria-describedby"] = Ze ? at : null) : (Dt["aria-label"] = Gt ? Oe : null, Dt["aria-labelledby"] = Ze && !Gt ? at : null);
  const Ke = _extends({}, Dt, Je, Xe.props, {
    className: clsx(Je.className, Xe.props.className),
    onTouchStart: Nt,
    ref: Lt
  }, be ? {
    onMouseMove: In
  } : {});
  dist$2.process.env.NODE_ENV !== "production" && (Ke["data-mui-internal-clone-element"] = !0, React$1.useEffect(() => {
    it && !it.getAttribute("data-mui-internal-clone-element") && console.error(["MUI: The `children` component of the Tooltip is not forwarding its props correctly.", "Please make sure that props are spread on the same element that the ref is applied to."].join(`
`));
  }, [it]));
  const Qe = {};
  le || (Ke.onTouchStart = Wt, Ke.onTouchEnd = En), oe || (Ke.onMouseOver = composeEventHandler(vt, Ke.onMouseOver), Ke.onMouseLeave = composeEventHandler(Mt, Ke.onMouseLeave), It || (Qe.onMouseOver = vt, Qe.onMouseLeave = Mt)), ne || (Ke.onFocus = composeEventHandler(Tn, Ke.onFocus), Ke.onBlur = composeEventHandler(Bt, Ke.onBlur), It || (Qe.onFocus = Tn, Qe.onBlur = Bt)), dist$2.process.env.NODE_ENV !== "production" && Xe.props.title && console.error(["MUI: You have provided a `title` prop to the child of <Tooltip />.", `Remove this title prop \`${Xe.props.title}\` or the Tooltip component.`].join(`
`));
  const et = React$1.useMemo(() => {
    var Vt;
    let Kt = [{
      name: "arrow",
      enabled: !!yt,
      options: {
        element: yt,
        padding: 4
      }
    }];
    return (Vt = Ue.popperOptions) != null && Vt.modifiers && (Kt = Kt.concat(Ue.popperOptions.modifiers)), _extends({}, Ue.popperOptions, {
      modifiers: Kt
    });
  }, [yt, Ue]), He = _extends({}, Ie, {
    isRtl: ct,
    arrow: ke,
    disableInteractive: It,
    placement: We,
    PopperComponentProp: Be,
    touch: mt.current
  }), nt = useUtilityClasses$2(He), qe = ($ = (V = je.popper) != null ? V : De.Popper) != null ? $ : TooltipPopper, ht = (J = (ee = (te = je.transition) != null ? te : De.Transition) != null ? ee : Ne) != null ? J : Grow, pt = (re = (ie = je.tooltip) != null ? ie : De.Tooltip) != null ? re : TooltipTooltip, bt = (se = (de = je.arrow) != null ? de : De.Arrow) != null ? se : TooltipArrow, jt = appendOwnerState(qe, _extends({}, Ue, (ue = Ge.popper) != null ? ue : Fe.popper, {
    className: clsx(nt.popper, Ue == null ? void 0 : Ue.className, (fe = (he = Ge.popper) != null ? he : Fe.popper) == null ? void 0 : fe.className)
  }), He), $t = appendOwnerState(ht, _extends({}, Ye, (me = Ge.transition) != null ? me : Fe.transition), He), Jt = appendOwnerState(pt, _extends({}, (xe = Ge.tooltip) != null ? xe : Fe.tooltip, {
    className: clsx(nt.tooltip, (ve = (Te = Ge.tooltip) != null ? Te : Fe.tooltip) == null ? void 0 : ve.className)
  }), He), zt = appendOwnerState(bt, _extends({}, (we = Ge.arrow) != null ? we : Fe.arrow, {
    className: clsx(nt.arrow, (Ee = (Me = Ge.arrow) != null ? Me : Fe.arrow) == null ? void 0 : Ee.className)
  }), He);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(React$1.Fragment, {
    children: [/* @__PURE__ */ React$1.cloneElement(Xe, Ke), /* @__PURE__ */ jsxRuntimeExports.jsx(qe, _extends({
      as: Be ?? Popper,
      placement: We,
      anchorEl: be ? {
        getBoundingClientRect: () => ({
          top: cursorPosition.y,
          left: cursorPosition.x,
          right: cursorPosition.x,
          bottom: cursorPosition.y,
          width: 0,
          height: 0
        })
      } : it,
      popperRef: Ht,
      open: it ? Ze : !1,
      id: at,
      transition: !0
    }, Qe, jt, {
      popperOptions: et,
      children: ({
        TransitionProps: Vt
      }) => /* @__PURE__ */ jsxRuntimeExports.jsx(ht, _extends({
        timeout: st.transitions.duration.shorter
      }, Vt, $t, {
        children: /* @__PURE__ */ jsxRuntimeExports.jsxs(pt, _extends({}, Jt, {
          children: [Oe, ke ? /* @__PURE__ */ jsxRuntimeExports.jsx(bt, _extends({}, zt, {
            ref: dt
          })) : null]
        }))
      }))
    }))]
  });
});
dist$2.process.env.NODE_ENV !== "production" && (Tooltip.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * If `true`, adds an arrow to the tooltip.
   * @default false
   */
  arrow: PropTypes.bool,
  /**
   * Tooltip reference element.
   */
  children: elementAcceptingRef.isRequired,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `slots` prop.
   * It's recommended to use the `slots` prop instead.
   *
   * @default {}
   */
  components: PropTypes.shape({
    Arrow: PropTypes.elementType,
    Popper: PropTypes.elementType,
    Tooltip: PropTypes.elementType,
    Transition: PropTypes.elementType
  }),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * This prop is an alias for the `slotProps` prop.
   * It's recommended to use the `slotProps` prop instead, as `componentsProps` will be deprecated in the future.
   *
   * @default {}
   */
  componentsProps: PropTypes.shape({
    arrow: PropTypes.object,
    popper: PropTypes.object,
    tooltip: PropTypes.object,
    transition: PropTypes.object
  }),
  /**
   * Set to `true` if the `title` acts as an accessible description.
   * By default the `title` acts as an accessible label for the child.
   * @default false
   */
  describeChild: PropTypes.bool,
  /**
   * Do not respond to focus-visible events.
   * @default false
   */
  disableFocusListener: PropTypes.bool,
  /**
   * Do not respond to hover events.
   * @default false
   */
  disableHoverListener: PropTypes.bool,
  /**
   * Makes a tooltip not interactive, i.e. it will close when the user
   * hovers over the tooltip before the `leaveDelay` is expired.
   * @default false
   */
  disableInteractive: PropTypes.bool,
  /**
   * Do not respond to long press touch events.
   * @default false
   */
  disableTouchListener: PropTypes.bool,
  /**
   * The number of milliseconds to wait before showing the tooltip.
   * This prop won't impact the enter touch delay (`enterTouchDelay`).
   * @default 100
   */
  enterDelay: PropTypes.number,
  /**
   * The number of milliseconds to wait before showing the tooltip when one was already recently opened.
   * @default 0
   */
  enterNextDelay: PropTypes.number,
  /**
   * The number of milliseconds a user must touch the element before showing the tooltip.
   * @default 700
   */
  enterTouchDelay: PropTypes.number,
  /**
   * If `true`, the tooltip follow the cursor over the wrapped element.
   * @default false
   */
  followCursor: PropTypes.bool,
  /**
   * This prop is used to help implement the accessibility logic.
   * If you don't provide this prop. It falls back to a randomly generated id.
   */
  id: PropTypes.string,
  /**
   * The number of milliseconds to wait before hiding the tooltip.
   * This prop won't impact the leave touch delay (`leaveTouchDelay`).
   * @default 0
   */
  leaveDelay: PropTypes.number,
  /**
   * The number of milliseconds after the user stops touching an element before hiding the tooltip.
   * @default 1500
   */
  leaveTouchDelay: PropTypes.number,
  /**
   * Callback fired when the component requests to be closed.
   *
   * @param {React.SyntheticEvent} event The event source of the callback.
   */
  onClose: PropTypes.func,
  /**
   * Callback fired when the component requests to be open.
   *
   * @param {React.SyntheticEvent} event The event source of the callback.
   */
  onOpen: PropTypes.func,
  /**
   * If `true`, the component is shown.
   */
  open: PropTypes.bool,
  /**
   * Tooltip placement.
   * @default 'bottom'
   */
  placement: PropTypes.oneOf(["bottom-end", "bottom-start", "bottom", "left-end", "left-start", "left", "right-end", "right-start", "right", "top-end", "top-start", "top"]),
  /**
   * The component used for the popper.
   * @default Popper
   */
  PopperComponent: PropTypes.elementType,
  /**
   * Props applied to the [`Popper`](/material-ui/api/popper/) element.
   * @default {}
   */
  PopperProps: PropTypes.object,
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * This prop is an alias for the `componentsProps` prop, which will be deprecated in the future.
   *
   * @default {}
   */
  slotProps: PropTypes.shape({
    arrow: PropTypes.object,
    popper: PropTypes.object,
    tooltip: PropTypes.object,
    transition: PropTypes.object
  }),
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `components` prop, which will be deprecated in the future.
   *
   * @default {}
   */
  slots: PropTypes.shape({
    arrow: PropTypes.elementType,
    popper: PropTypes.elementType,
    tooltip: PropTypes.elementType,
    transition: PropTypes.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * Tooltip title. Zero-length titles string, undefined, null and false are never displayed.
   */
  title: PropTypes.node,
  /**
   * The component used for the transition.
   * [Follow this guide](/material-ui/transitions/#transitioncomponent-prop) to learn more about the requirements for this component.
   * @default Grow
   */
  TransitionComponent: PropTypes.elementType,
  /**
   * Props applied to the transition element.
   * By default, the element is based on this [`Transition`](https://reactcommunity.org/react-transition-group/transition/) component.
   */
  TransitionProps: PropTypes.object
});
function getSwitchUtilityClass(C) {
  return generateUtilityClass("MuiSwitch", C);
}
const switchClasses = generateUtilityClasses("MuiSwitch", ["root", "edgeStart", "edgeEnd", "switchBase", "colorPrimary", "colorSecondary", "sizeSmall", "sizeMedium", "checked", "disabled", "input", "thumb", "track"]), _excluded$1 = ["className", "color", "edge", "size", "sx"], useUtilityClasses$1 = (C) => {
  const {
    classes: e,
    edge: T,
    size: $,
    color: V,
    checked: J,
    disabled: ee
  } = C, te = {
    root: ["root", T && `edge${capitalize$3(T)}`, `size${capitalize$3($)}`],
    switchBase: ["switchBase", `color${capitalize$3(V)}`, J && "checked", ee && "disabled"],
    thumb: ["thumb"],
    track: ["track"],
    input: ["input"]
  }, re = composeClasses(te, getSwitchUtilityClass, e);
  return _extends({}, e, re);
}, SwitchRoot = styled$1("span", {
  name: "MuiSwitch",
  slot: "Root",
  overridesResolver: (C, e) => {
    const {
      ownerState: T
    } = C;
    return [e.root, T.edge && e[`edge${capitalize$3(T.edge)}`], e[`size${capitalize$3(T.size)}`]];
  }
})({
  display: "inline-flex",
  width: 34 + 12 * 2,
  height: 14 + 12 * 2,
  overflow: "hidden",
  padding: 12,
  boxSizing: "border-box",
  position: "relative",
  flexShrink: 0,
  zIndex: 0,
  // Reset the stacking context.
  verticalAlign: "middle",
  // For correct alignment with the text.
  "@media print": {
    colorAdjust: "exact"
  },
  variants: [{
    props: {
      edge: "start"
    },
    style: {
      marginLeft: -8
    }
  }, {
    props: {
      edge: "end"
    },
    style: {
      marginRight: -8
    }
  }, {
    props: {
      size: "small"
    },
    style: {
      width: 40,
      height: 24,
      padding: 7,
      [`& .${switchClasses.thumb}`]: {
        width: 16,
        height: 16
      },
      [`& .${switchClasses.switchBase}`]: {
        padding: 4,
        [`&.${switchClasses.checked}`]: {
          transform: "translateX(16px)"
        }
      }
    }
  }]
}), SwitchSwitchBase = styled$1(SwitchBase, {
  name: "MuiSwitch",
  slot: "SwitchBase",
  overridesResolver: (C, e) => {
    const {
      ownerState: T
    } = C;
    return [e.switchBase, {
      [`& .${switchClasses.input}`]: e.input
    }, T.color !== "default" && e[`color${capitalize$3(T.color)}`]];
  }
})(({
  theme: C
}) => ({
  position: "absolute",
  top: 0,
  left: 0,
  zIndex: 1,
  // Render above the focus ripple.
  color: C.vars ? C.vars.palette.Switch.defaultColor : `${C.palette.mode === "light" ? C.palette.common.white : C.palette.grey[300]}`,
  transition: C.transitions.create(["left", "transform"], {
    duration: C.transitions.duration.shortest
  }),
  [`&.${switchClasses.checked}`]: {
    transform: "translateX(20px)"
  },
  [`&.${switchClasses.disabled}`]: {
    color: C.vars ? C.vars.palette.Switch.defaultDisabledColor : `${C.palette.mode === "light" ? C.palette.grey[100] : C.palette.grey[600]}`
  },
  [`&.${switchClasses.checked} + .${switchClasses.track}`]: {
    opacity: 0.5
  },
  [`&.${switchClasses.disabled} + .${switchClasses.track}`]: {
    opacity: C.vars ? C.vars.opacity.switchTrackDisabled : `${C.palette.mode === "light" ? 0.12 : 0.2}`
  },
  [`& .${switchClasses.input}`]: {
    left: "-100%",
    width: "300%"
  }
}), ({
  theme: C
}) => ({
  "&:hover": {
    backgroundColor: C.vars ? `rgba(${C.vars.palette.action.activeChannel} / ${C.vars.palette.action.hoverOpacity})` : alpha_1(C.palette.action.active, C.palette.action.hoverOpacity),
    // Reset on touch devices, it doesn't add specificity
    "@media (hover: none)": {
      backgroundColor: "transparent"
    }
  },
  variants: [...Object.entries(C.palette).filter(([, e]) => e.main && e.light).map(([e]) => ({
    props: {
      color: e
    },
    style: {
      [`&.${switchClasses.checked}`]: {
        color: (C.vars || C).palette[e].main,
        "&:hover": {
          backgroundColor: C.vars ? `rgba(${C.vars.palette[e].mainChannel} / ${C.vars.palette.action.hoverOpacity})` : alpha_1(C.palette[e].main, C.palette.action.hoverOpacity),
          "@media (hover: none)": {
            backgroundColor: "transparent"
          }
        },
        [`&.${switchClasses.disabled}`]: {
          color: C.vars ? C.vars.palette.Switch[`${e}DisabledColor`] : `${C.palette.mode === "light" ? lighten_1(C.palette[e].main, 0.62) : darken_1(C.palette[e].main, 0.55)}`
        }
      },
      [`&.${switchClasses.checked} + .${switchClasses.track}`]: {
        backgroundColor: (C.vars || C).palette[e].main
      }
    }
  }))]
})), SwitchTrack = styled$1("span", {
  name: "MuiSwitch",
  slot: "Track",
  overridesResolver: (C, e) => e.track
})(({
  theme: C
}) => ({
  height: "100%",
  width: "100%",
  borderRadius: 14 / 2,
  zIndex: -1,
  transition: C.transitions.create(["opacity", "background-color"], {
    duration: C.transitions.duration.shortest
  }),
  backgroundColor: C.vars ? C.vars.palette.common.onBackground : `${C.palette.mode === "light" ? C.palette.common.black : C.palette.common.white}`,
  opacity: C.vars ? C.vars.opacity.switchTrack : `${C.palette.mode === "light" ? 0.38 : 0.3}`
})), SwitchThumb = styled$1("span", {
  name: "MuiSwitch",
  slot: "Thumb",
  overridesResolver: (C, e) => e.thumb
})(({
  theme: C
}) => ({
  boxShadow: (C.vars || C).shadows[1],
  backgroundColor: "currentColor",
  width: 20,
  height: 20,
  borderRadius: "50%"
})), Switch = /* @__PURE__ */ React$1.forwardRef(function(e, T) {
  const $ = useDefaultProps({
    props: e,
    name: "MuiSwitch"
  }), {
    className: V,
    color: J = "primary",
    edge: ee = !1,
    size: te = "medium",
    sx: re
  } = $, ie = _objectWithoutPropertiesLoose($, _excluded$1), se = _extends({}, $, {
    color: J,
    edge: ee,
    size: te
  }), de = useUtilityClasses$1(se), ue = /* @__PURE__ */ jsxRuntimeExports.jsx(SwitchThumb, {
    className: de.thumb,
    ownerState: se
  });
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(SwitchRoot, {
    className: clsx(de.root, V),
    sx: re,
    ownerState: se,
    children: [/* @__PURE__ */ jsxRuntimeExports.jsx(SwitchSwitchBase, _extends({
      type: "checkbox",
      icon: ue,
      checkedIcon: ue,
      ref: T,
      ownerState: se
    }, ie, {
      classes: _extends({}, de, {
        root: de.switchBase
      })
    })), /* @__PURE__ */ jsxRuntimeExports.jsx(SwitchTrack, {
      className: de.track,
      ownerState: se
    })]
  });
});
dist$2.process.env.NODE_ENV !== "production" && (Switch.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * If `true`, the component is checked.
   */
  checked: PropTypes.bool,
  /**
   * The icon to display when the component is checked.
   */
  checkedIcon: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'primary'
   */
  color: PropTypes.oneOfType([PropTypes.oneOf(["default", "primary", "secondary", "error", "info", "success", "warning"]), PropTypes.string]),
  /**
   * The default checked state. Use when the component is not controlled.
   */
  defaultChecked: PropTypes.bool,
  /**
   * If `true`, the component is disabled.
   */
  disabled: PropTypes.bool,
  /**
   * If `true`, the ripple effect is disabled.
   * @default false
   */
  disableRipple: PropTypes.bool,
  /**
   * If given, uses a negative margin to counteract the padding on one
   * side (this is often helpful for aligning the left or right
   * side of the icon with content above or below, without ruining the border
   * size and shape).
   * @default false
   */
  edge: PropTypes.oneOf(["end", "start", !1]),
  /**
   * The icon to display when the component is unchecked.
   */
  icon: PropTypes.node,
  /**
   * The id of the `input` element.
   */
  id: PropTypes.string,
  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   */
  inputProps: PropTypes.object,
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: refType,
  /**
   * Callback fired when the state is changed.
   *
   * @param {React.ChangeEvent<HTMLInputElement>} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   * You can pull out the new checked state by accessing `event.target.checked` (boolean).
   */
  onChange: PropTypes.func,
  /**
   * If `true`, the `input` element is required.
   * @default false
   */
  required: PropTypes.bool,
  /**
   * The size of the component.
   * `small` is equivalent to the dense switch styling.
   * @default 'medium'
   */
  size: PropTypes.oneOfType([PropTypes.oneOf(["medium", "small"]), PropTypes.string]),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * The value of the component. The DOM API casts this to a string.
   * The browser uses "on" as the default value.
   */
  value: PropTypes.any
});
function getTextFieldUtilityClass(C) {
  return generateUtilityClass("MuiTextField", C);
}
generateUtilityClasses("MuiTextField", ["root"]);
const _excluded = ["autoComplete", "autoFocus", "children", "className", "color", "defaultValue", "disabled", "error", "FormHelperTextProps", "fullWidth", "helperText", "id", "InputLabelProps", "inputProps", "InputProps", "inputRef", "label", "maxRows", "minRows", "multiline", "name", "onBlur", "onChange", "onFocus", "placeholder", "required", "rows", "select", "SelectProps", "type", "value", "variant"], variantComponent = {
  standard: Input,
  filled: FilledInput,
  outlined: OutlinedInput
}, useUtilityClasses = (C) => {
  const {
    classes: e
  } = C;
  return composeClasses({
    root: ["root"]
  }, getTextFieldUtilityClass, e);
}, TextFieldRoot = styled$1(FormControl, {
  name: "MuiTextField",
  slot: "Root",
  overridesResolver: (C, e) => e.root
})({}), TextField = /* @__PURE__ */ React$1.forwardRef(function(e, T) {
  const $ = useDefaultProps({
    props: e,
    name: "MuiTextField"
  }), {
    autoComplete: V,
    autoFocus: J = !1,
    children: ee,
    className: te,
    color: re = "primary",
    defaultValue: ie,
    disabled: se = !1,
    error: de = !1,
    FormHelperTextProps: ue,
    fullWidth: fe = !1,
    helperText: he,
    id: me,
    InputLabelProps: xe,
    inputProps: ve,
    InputProps: Te,
    inputRef: we,
    label: Ee,
    maxRows: Me,
    minRows: Ie,
    multiline: ke = !1,
    name: _e,
    onBlur: De,
    onChange: Fe,
    onFocus: Ae,
    placeholder: ne,
    required: oe = !1,
    rows: ce,
    select: le = !1,
    SelectProps: pe,
    type: ye,
    value: Ce,
    variant: be = "outlined"
  } = $, ae = _objectWithoutPropertiesLoose($, _excluded), ge = _extends({}, $, {
    autoFocus: J,
    color: re,
    disabled: se,
    error: de,
    fullWidth: fe,
    multiline: ke,
    required: oe,
    select: le,
    variant: be
  }), Se = useUtilityClasses(ge);
  dist$2.process.env.NODE_ENV !== "production" && le && !ee && console.error("MUI: `children` must be passed when using the `TextField` component with `select`.");
  const Le = {};
  be === "outlined" && (xe && typeof xe.shrink < "u" && (Le.notched = xe.shrink), Le.label = Ee), le && ((!pe || !pe.native) && (Le.id = void 0), Le["aria-describedby"] = void 0);
  const ze = useId(me), Re = he && ze ? `${ze}-helper-text` : void 0, We = Ee && ze ? `${ze}-label` : void 0, Be = variantComponent[be], Ue = /* @__PURE__ */ jsxRuntimeExports.jsx(Be, _extends({
    "aria-describedby": Re,
    autoComplete: V,
    autoFocus: J,
    defaultValue: ie,
    fullWidth: fe,
    multiline: ke,
    name: _e,
    rows: ce,
    maxRows: Me,
    minRows: Ie,
    type: ye,
    value: Ce,
    id: ze,
    inputRef: we,
    onBlur: De,
    onChange: Fe,
    onFocus: Ae,
    placeholder: ne,
    inputProps: ve
  }, Le, Te));
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(TextFieldRoot, _extends({
    className: clsx(Se.root, te),
    disabled: se,
    error: de,
    fullWidth: fe,
    ref: T,
    required: oe,
    color: re,
    variant: be,
    ownerState: ge
  }, ae, {
    children: [Ee != null && Ee !== "" && /* @__PURE__ */ jsxRuntimeExports.jsx(InputLabel, _extends({
      htmlFor: ze,
      id: We
    }, xe, {
      children: Ee
    })), le ? /* @__PURE__ */ jsxRuntimeExports.jsx(Select, _extends({
      "aria-describedby": Re,
      id: ze,
      labelId: We,
      value: Ce,
      input: Ue
    }, pe, {
      children: ee
    })) : Ue, he && /* @__PURE__ */ jsxRuntimeExports.jsx(FormHelperText, _extends({
      id: Re
    }, ue, {
      children: he
    }))]
  }));
});
dist$2.process.env.NODE_ENV !== "production" && (TextField.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * This prop helps users to fill forms faster, especially on mobile devices.
   * The name can be confusing, as it's more like an autofill.
   * You can learn more about it [following the specification](https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#autofill).
   */
  autoComplete: PropTypes.string,
  /**
   * If `true`, the `input` element is focused during the first mount.
   * @default false
   */
  autoFocus: PropTypes.bool,
  /**
   * @ignore
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'primary'
   */
  color: PropTypes.oneOfType([PropTypes.oneOf(["primary", "secondary", "error", "info", "success", "warning"]), PropTypes.string]),
  /**
   * The default value. Use when the component is not controlled.
   */
  defaultValue: PropTypes.any,
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: PropTypes.bool,
  /**
   * If `true`, the label is displayed in an error state.
   * @default false
   */
  error: PropTypes.bool,
  /**
   * Props applied to the [`FormHelperText`](/material-ui/api/form-helper-text/) element.
   */
  FormHelperTextProps: PropTypes.object,
  /**
   * If `true`, the input will take up the full width of its container.
   * @default false
   */
  fullWidth: PropTypes.bool,
  /**
   * The helper text content.
   */
  helperText: PropTypes.node,
  /**
   * The id of the `input` element.
   * Use this prop to make `label` and `helperText` accessible for screen readers.
   */
  id: PropTypes.string,
  /**
   * Props applied to the [`InputLabel`](/material-ui/api/input-label/) element.
   * Pointer events like `onClick` are enabled if and only if `shrink` is `true`.
   */
  InputLabelProps: PropTypes.object,
  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   */
  inputProps: PropTypes.object,
  /**
   * Props applied to the Input element.
   * It will be a [`FilledInput`](/material-ui/api/filled-input/),
   * [`OutlinedInput`](/material-ui/api/outlined-input/) or [`Input`](/material-ui/api/input/)
   * component depending on the `variant` prop value.
   */
  InputProps: PropTypes.object,
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: refType,
  /**
   * The label content.
   */
  label: PropTypes.node,
  /**
   * If `dense` or `normal`, will adjust vertical spacing of this and contained components.
   * @default 'none'
   */
  margin: PropTypes.oneOf(["dense", "none", "normal"]),
  /**
   * Maximum number of rows to display when multiline option is set to true.
   */
  maxRows: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  /**
   * Minimum number of rows to display when multiline option is set to true.
   */
  minRows: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  /**
   * If `true`, a `textarea` element is rendered instead of an input.
   * @default false
   */
  multiline: PropTypes.bool,
  /**
   * Name attribute of the `input` element.
   */
  name: PropTypes.string,
  /**
   * @ignore
   */
  onBlur: PropTypes.func,
  /**
   * Callback fired when the value is changed.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   */
  onChange: PropTypes.func,
  /**
   * @ignore
   */
  onFocus: PropTypes.func,
  /**
   * The short hint displayed in the `input` before the user enters a value.
   */
  placeholder: PropTypes.string,
  /**
   * If `true`, the label is displayed as required and the `input` element is required.
   * @default false
   */
  required: PropTypes.bool,
  /**
   * Number of rows to display when multiline option is set to true.
   */
  rows: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  /**
   * Render a [`Select`](/material-ui/api/select/) element while passing the Input element to `Select` as `input` parameter.
   * If this option is set you must pass the options of the select as children.
   * @default false
   */
  select: PropTypes.bool,
  /**
   * Props applied to the [`Select`](/material-ui/api/select/) element.
   */
  SelectProps: PropTypes.object,
  /**
   * The size of the component.
   */
  size: PropTypes.oneOfType([PropTypes.oneOf(["medium", "small"]), PropTypes.string]),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * Type of the `input` element. It should be [a valid HTML5 input type](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Form_%3Cinput%3E_types).
   */
  type: PropTypes.string,
  /**
   * The value of the `input` element, required for a controlled component.
   */
  value: PropTypes.any,
  /**
   * The variant to use.
   * @default 'outlined'
   */
  variant: PropTypes.oneOf(["filled", "outlined", "standard"])
});
const DownIcon = createSvgIcon$1(
  /* @__PURE__ */ jsxRuntimeExports.jsx(
    "path",
    {
      d: "M7 9L12 14L17 9",
      fill: "none",
      stroke: "currentColor",
      strokeOpacity: "0.9",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  ),
  "Down"
), useStyles$C = makeStyles()((C, { align: e }) => ({
  container: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    gap: "8px",
    marginBottom: "0px",
    [C.breakpoints.down("sm")]: {
      marginBottom: "20px"
    }
  },
  header: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    width: "100%"
  },
  left: {
    display: "flex",
    flexGrow: 1,
    alignItems: "center",
    textAlign: e
  },
  arrowBack: {
    transform: "rotate(90deg)",
    marginRight: "16px",
    cursor: "pointer"
  },
  description: {
    fontWeight: "300",
    fontSize: "14px",
    opacity: "0.6",
    marginBottom: "40px"
  }
}));
function PageHeader({
  back: C,
  title: e,
  align: T = "left",
  description: $,
  testId: V
}) {
  const { classes: J } = useStyles$C({ align: T }), ee = useDispatch();
  function te() {
    ee(setRoute("bridge"));
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: J.container, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: J.header, children: /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: J.left, children: [
      C && /* @__PURE__ */ jsxRuntimeExports.jsx(
        DownIcon,
        {
          className: J.arrowBack,
          fontSize: "large",
          onClick: te
        }
      ),
      /* @__PURE__ */ jsxRuntimeExports.jsx(Header, { text: e, align: T, testId: V })
    ] }) }),
    $ && /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: J.description, children: $ })
  ] });
}
const joinClass = (C) => C.filter((e) => !!e).join(" "), OPACITY = {
  0: "00",
  5: "0C",
  7: "0F",
  10: "19",
  15: "26",
  20: "33",
  25: "3F",
  30: "4C",
  35: "59",
  40: "66",
  45: "72",
  50: "7F",
  55: "8C",
  60: "99",
  65: "A5",
  70: "B2",
  75: "BF",
  80: "CC",
  85: "D8",
  90: "E5",
  95: "F2",
  100: "FF"
}, CENTER = {
  display: "flex",
  alignItems: "center",
  justifyContent: "center"
}, ICON = {
  width: "40px",
  height: "40px",
  ...CENTER,
  cursor: "pointer"
}, changeOpacity = (C, e) => C.length === 7 ? C + OPACITY[e] : C.length === 9 ? C.slice(0, 7) + OPACITY[e] : C, useScrollbarClassName = makeStyles()((C) => ({
  scrollbar: {
    "&::-webkit-scrollbar": {
      backgroundColor: "transparent",
      width: "8px"
    },
    "&::-webkit-scrollbar-track": {
      backgroundColor: "transparent"
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "transparent",
      borderRadius: "16px"
    },
    "&:hover::-webkit-scrollbar-thumb": {
      backgroundColor: `${C.palette.text.primary}1a`
    },
    "&::-webkit-scrollbar-button": {
      display: "none"
    }
  }
})), useCustomScrollbar = () => useScrollbarClassName().classes.scrollbar, useStyles$B = makeStyles()((C) => ({
  menuIcon: ICON,
  menu: {
    display: "flex",
    [C.breakpoints.down("md")]: {
      flexDirection: "column"
    },
    flexDirection: "row",
    gap: "8px",
    padding: "8px",
    width: "100%"
  },
  menuItem: {
    padding: "16px 0",
    textAlign: "center",
    fontSize: "14px",
    margin: "auto",
    cursor: "pointer",
    "&:hover": {
      textDecoration: "underline"
    }
  }
}));
function itemAppender(C, e) {
  const { order: T = C.length, target: $ = "_black", href: V, label: J } = e;
  return C.splice(T, 0, { label: J, handleClick: () => window.open(V, $) }), C;
}
function defaultMenuItems(C) {
  return [
    { label: "Resume Transaction", handleClick: () => C("search") },
    { label: "Terms of Use", handleClick: () => C("terms") }
  ];
}
function FooterNavBar() {
  var V;
  const { classes: C } = useStyles$B(), e = useDispatch(), T = useCallback(
    (J) => {
      e(setRoute(J));
    },
    [e]
  ), $ = (((V = config$1.ui) == null ? void 0 : V.menu) ?? []).reduce(
    itemAppender,
    defaultMenuItems(T)
  );
  return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: C.menu, children: $.map(({ label: J, handleClick: ee }, te) => /* @__PURE__ */ jsxRuntimeExports.jsx(
    "div",
    {
      className: C.menuItem,
      onClick: ee,
      children: J
    },
    `${J.toLowerCase()}_${te}`
  )) });
}
const useStyles$A = makeStyles()(() => ({
  terms: {
    width: "100%",
    maxWidth: "700px",
    display: "flex",
    flexDirection: "column",
    alignItems: "center"
  },
  body: {
    textAlign: "left",
    display: "flex",
    flexDirection: "column",
    gap: "8px",
    fontWeight: "300"
  }
}));
function Terms() {
  const { classes: C } = useStyles$A();
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: C.terms, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(PageHeader, { title: "Terms", back: !0 }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: C.body, children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx("div", { children: "Disclaimer:" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("div", { children: `The operator (the "Operator") of this website or mobile application has implemented, deployed, and is operating open source software (the "SDK") that overlays the Wormhole protocol, a cross chain messaging protocol. THIS SDK AND THE WORMHOLE PROTOCOL ARE MADE AVAILABLE "AS IS", AT YOUR OWN RISK, AND WITHOUT WARRANTIES OF ANY KIND. By using or accessing this SDK or the Wormhole protocol, you and the Operator agree that no developer or entity involved in creating, deploying, maintaining, operating this SDK or the Wormhole protocol, or causing or supporting any of the foregoing, will be liable in any manner for any claims or damages whatsoever associated with your use, inability to use, or your interaction with other users of this SDK or the Wormhole protocol, or this SDK or the Wormhole protocol themselves, including any direct, indirect, incidental, special, exemplary, punitive or consequential damages, or loss of profits, cryptocurrencies, tokens, or anything else of value. By using or accessing this SDK, you represent that you are not subject to sanctions or otherwise designated on any list of prohibited or restricted parties or excluded or denied persons, including but not limited to the lists maintained by the United States' Department of Treasury's Office of Foreign Assets Control, the United Nations Security Council, the European Union or its Member States, or any other government authority.` }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("div", { children: "You assume all risks associated with using the SDK, the Wormhole protocol, and digital assets and decentralized systems generally, including but not limited to, that: (a) digital assets are highly volatile; (b) using digital assets is inherently risky due to both features of such assets and the potential unauthorized acts of third parties; (c) you may not have ready access to assets; and (d) you may lose some or all of your tokens or other assets. You agree that you will have no recourse against anyone else for any losses due to the use of the SDK or the Wormhole protocol. For example, these losses may arise from or relate to: (i) incorrect information; (ii) software or network failures; (iii) corrupted cryptocurrency wallet files; (iv) unauthorized access; (v) errors, mistakes, or inaccuracies; or (vi) third-party activities." })
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(FooterNavBar, {})
  ] });
}
const useStyles$z = makeStyles()((C, { align: e }) => ({
  input: {
    width: "100%",
    border: "none",
    backgroundImage: "none",
    backgroundColor: "transparent",
    background: "transparent",
    fontSize: "inherit",
    boxShadow: "none",
    webkitBoxShadow: "none",
    moxBoxShadow: "none",
    outline: "none",
    flexGrow: "1",
    textAlign: e || "left"
  }
})), NUMBER_FORMAT_REGEX = /^\d*\.?\d*$/, NUMBER_REPLACE_REGEX = /[^0-9.]/g;
function InputTransparent(C) {
  const { classes: e } = useStyles$z({ align: C.align }), T = (V) => {
    C.type === "number" && !NUMBER_FORMAT_REGEX.test(V.target.value) && (V.target.value = V.target.value.replace(NUMBER_REPLACE_REGEX, "")), C.onChange && C.onChange(V);
  }, $ = (V) => {
    V.key === "Enter" && C.onEnter && C.onEnter(V);
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    "input",
    {
      ref: C.inputRef,
      id: C.id,
      className: e.input,
      placeholder: C.placeholder,
      min: C.min,
      max: C.max,
      step: C.step,
      onChange: T,
      onKeyDown: $,
      readOnly: C.disabled,
      value: C.value,
      "data-testid": C.testId
    }
  );
}
const SearchIcon = createSvgIcon$1(
  /* @__PURE__ */ jsxRuntimeExports.jsx(
    "path",
    {
      d: "M21.0008 21.0008L15.8038 15.8038M15.8038 15.8038C17.2104 14.3972 18.0006 12.4895 18.0006 10.5003C18.0006 8.51108 17.2104 6.60336 15.8038 5.19678C14.3972 3.79021 12.4895 3 10.5003 3C8.51108 3 6.60336 3.79021 5.19678 5.19678C3.79021 6.60336 3 8.51108 3 10.5003C3 12.4895 3.79021 14.3972 5.19678 15.8038C6.60336 17.2104 8.51108 18.0006 10.5003 18.0006C12.4895 18.0006 14.3972 17.2104 15.8038 15.8038V15.8038Z",
      fill: "none",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  ),
  "Search"
), useStyles$y = makeStyles()((C) => ({
  searchContent: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between"
  },
  container: {
    width: "100%",
    padding: "16px",
    borderRadius: "8px",
    backgroundColor: C.palette.card.secondary
  },
  input: {
    flexGrow: 1
  },
  // TODO: make border into prop on InputContainer
  searchBorder: {
    border: `1px solid ${changeOpacity(C.palette.divider, 50)}`,
    borderRadius: "8px"
  },
  clickable: {
    cursor: "pointer"
  }
}));
function Search$1(C) {
  const { classes: e } = useStyles$y(), T = useRef(null), $ = () => {
    T.current && T.current.focus();
  };
  return useEffect(() => {
    $();
  }, []), /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: e.searchBorder, children: /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: e.container, onClick: $, children: /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: e.searchContent, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: e.input, children: /* @__PURE__ */ jsxRuntimeExports.jsx(
      InputTransparent,
      {
        value: C.value,
        inputRef: T,
        placeholder: C.placeholder,
        onChange: C.onChange,
        onEnter: C.onSearch
      }
    ) }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      "div",
      {
        onClick: C.onSearch,
        className: C.onSearch && e.clickable,
        children: /* @__PURE__ */ jsxRuntimeExports.jsx(SearchIcon, {})
      }
    )
  ] }) }) });
}
const useStyles$x = makeStyles()((C) => ({
  button: {
    width: "100%",
    backgroundColor: C.palette.button.primary,
    color: C.palette.button.primaryText,
    borderRadius: "8px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: "12px 64px",
    cursor: "pointer",
    textAlign: "center"
  },
  disabled: {
    cursor: "not-allowed",
    clickEvents: "none",
    backgroundColor: C.palette.button.disabled + " !important",
    color: C.palette.button.disabledText + " !important"
  },
  elevated: {
    boxShadow: C.palette.card.elevation
  },
  action: {
    backgroundColor: C.palette.button.action,
    color: C.palette.button.actionText
  },
  link: {
    backgroundColor: "transparent"
  }
}));
function Button$1(C) {
  const { classes: e } = useStyles$x(), T = ($) => {
    C.onClick && !C.disabled && C.onClick($);
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    "div",
    {
      className: joinClass([
        e.button,
        !!C.elevated && e.elevated,
        !!C.action && e.action,
        !!C.link && e.link,
        !!C.disabled && e.disabled
      ]),
      onClick: T,
      "data-testid": C.testId,
      children: C.children
    }
  );
}
function Spacer(C) {
  return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { style: { height: `${C.height || 24}px` } });
}
const AlertIcon = createSvgIcon$1(
  /* @__PURE__ */ jsxRuntimeExports.jsx(
    "path",
    {
      d: "M12.0003 9.99993V13.7499M2.69731 17.1259C1.83131 18.6259 2.91431 20.4999 4.64531 20.4999H19.3553C21.0853 20.4999 22.1683 18.6259 21.3033 17.1259L13.9493 4.37793C13.0833 2.87793 10.9173 2.87793 10.0513 4.37793L2.69731 17.1259ZM12.0003 16.7499H12.0073V16.7579H12.0003V16.7499Z",
      fill: "none",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  ),
  "Alert"
), useStyles$w = makeStyles()((C) => ({
  base: {
    width: "100%",
    padding: "8px",
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
    gap: "10px",
    borderRadius: "8px"
  },
  error: {
    backgroundColor: C.palette.error[500] + OPACITY[25]
  },
  warning: {
    backgroundColor: C.palette.warning[500] + OPACITY[25]
  }
}));
function AlertBanner$1(C) {
  const { classes: e } = useStyles$w();
  return /* @__PURE__ */ jsxRuntimeExports.jsx(Collapse, { in: C.show && !!C.content, unmountOnExit: !0, children: /* @__PURE__ */ jsxRuntimeExports.jsxs(
    "div",
    {
      className: joinClass([
        e.base,
        !!C.warning && e.warning,
        !!C.error && e.error
      ]),
      style: { margin: C.margin || 0 },
      "data-testid": C.testId,
      children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(AlertIcon, {}),
        C.content
      ]
    }
  ) });
}
function useExternalSearch() {
  const [C, e] = useState(!1), [T, $] = useState(), [V, J] = useState();
  return useEffect(() => {
    var ee, te;
    if ((ee = config$1.ui.searchTx) != null && ee.chainName && ((te = config$1.ui.searchTx) != null && te.txHash)) {
      const re = config$1.ui.searchTx.chainName.toLowerCase();
      config$1.chainsArr.filter((se) => se.key !== "Wormchain").map((se) => se.key).includes(re) && (e(!0), $(config$1.ui.searchTx.txHash), J(re));
    }
  }, []), {
    hasExternalSearch: C,
    txHash: T,
    chainName: V,
    clear: () => {
      e(!1), $(void 0), J(void 0), config$1.ui.searchTx && (config$1.ui.searchTx.chainName = void 0, config$1.ui.searchTx.txHash = void 0);
    }
  };
}
const RouteContext = React__default.createContext({
  route: null,
  receipt: null,
  setRoute: () => {
  },
  setReceipt: () => {
  },
  clear: () => {
  }
}), RouteProvider = ({
  children: C
}) => {
  const [e, T] = React__default.useState(null), [$, V] = React__default.useState(null), J = useCallback(() => {
    T(null), V(null);
  }, []);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    RouteContext.Provider,
    {
      value: { route: e, receipt: $, setRoute: T, setReceipt: V, clear: J },
      children: C
    }
  );
}, useStyles$v = makeStyles()((C) => ({
  container: {
    maxWidth: "650px"
  },
  chain: {
    width: "175px",
    [C.breakpoints.down("sm")]: {
      width: "100%"
    }
  },
  inputs: {
    display: "flex",
    flexDirection: "row",
    gap: "16px",
    [C.breakpoints.down("sm")]: {
      flexDirection: "column"
    }
  },
  search: {
    flexGrow: 1
  },
  footerNavBar: {
    width: "100%",
    maxWidth: "700px",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    marginTop: "20px"
  }
})), EMPTY = "";
function TxSearch() {
  const { classes: C } = useStyles$v(), e = useDispatch(), [T, $] = useState({
    chain: EMPTY,
    tx: EMPTY,
    autoSearch: !1
  }), [V, J] = useState(""), [ee, te] = useState(!1), re = useContext(RouteContext);
  function ie(ve) {
    $((Te) => ({ ...Te, chain: ve.target.value }));
  }
  function se(ve) {
    $((Te) => ({ ...Te, tx: ve.target.value }));
  }
  async function de() {
    if (!T.tx || !T.chain)
      return J("Enter the source chain and transaction ID");
    if (!isValidTxId(T.chain, T.tx))
      return J("Invalid transaction ID");
    te(!0);
    const ve = await config$1.routes.resumeFromTx({
      chain: T.chain,
      txid: T.tx
    });
    if (ve === null) {
      J(
        "Transfer not found, check that you have the correct chain and transaction ID"
      ), te(!1);
      return;
    }
    const { route: Te } = ve;
    let { receipt: we } = ve;
    const Ee = await getWormholeContextV2(), Me = new (config$1.routes.get(Te)).rc(Ee);
    if (J(""), we.state < TransferState.Attested) {
      for await (we of Me.track(we))
        if (we.state >= TransferState.Attested)
          break;
    }
    const Ie = await parseReceipt(
      Te,
      we
    );
    Ie ? (e(setTxDetails(Ie)), e(setIsResumeTx(!0)), e(setRoute$1(Te)), e(setRoute("redeem")), e(setToChain(we.to)), re.setRoute(Me), re.setReceipt(we)) : console.error("Failed to parse receipt", we), te(!1);
  }
  const { hasExternalSearch: ue, txHash: fe, chainName: he, clear: me } = useExternalSearch();
  useEffect(() => {
    const ve = !!(ue && fe && he);
    ve && ($({ chain: he, tx: fe, autoSearch: ve }), me());
  }, [ue, fe, he, me]);
  const xe = useCallback(() => de(), [T]);
  return useEffect(() => {
    const { chain: ve, tx: Te, autoSearch: we } = T;
    we && ve !== EMPTY && Te !== EMPTY && !ee && ($((Ee) => ({ ...Ee, autoSearch: !1 })), xe());
  }, [xe, T, ee]), /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: C.container, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      PageHeader,
      {
        title: "Resume transaction",
        description: "Bridging can require a manual redemption process on the designation chain. If you did not complete the redemption during your initial transaction, you may do so here.",
        back: !0
      }
    ),
    /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: C.inputs, children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: C.chain, children: /* @__PURE__ */ jsxRuntimeExports.jsxs(
        Select,
        {
          sx: { width: "100%", height: "100%", minHeight: "64.5px" },
          value: T.chain,
          displayEmpty: !0,
          placeholder: "Select network",
          onChange: (ve) => ie(ve),
          children: [
            /* @__PURE__ */ jsxRuntimeExports.jsx(MenuItem, { disabled: !0, value: "", children: "Select network" }, 0),
            config$1.chainsArr.filter((ve) => ve.key !== "Wormchain").map((ve, Te) => /* @__PURE__ */ jsxRuntimeExports.jsx(MenuItem, { value: ve.key, children: ve.displayName }, Te + 1))
          ]
        }
      ) }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: C.search, children: /* @__PURE__ */ jsxRuntimeExports.jsx(
        Search$1,
        {
          placeholder: "Source chain transaction hash",
          onChange: se,
          onSearch: de,
          value: T.tx
        }
      ) })
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Spacer, {}),
    /* @__PURE__ */ jsxRuntimeExports.jsx(AlertBanner$1, { show: !!V, content: V, error: !0, margin: "0 0 16px 0" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Button$1, { disabled: !T.chain || !T.tx, elevated: !0, onClick: de, children: ee ? /* @__PURE__ */ jsxRuntimeExports.jsx(CircularProgress, { size: 24 }) : "Search" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: C.footerNavBar, children: /* @__PURE__ */ jsxRuntimeExports.jsx(FooterNavBar, {}) })
  ] });
}
var History = {}, createSvgIcon = {};
const require$$0 = /* @__PURE__ */ getAugmentedNamespace(utils);
var hasRequiredCreateSvgIcon;
function requireCreateSvgIcon() {
  return hasRequiredCreateSvgIcon || (hasRequiredCreateSvgIcon = 1, function(C) {
    "use client";
    Object.defineProperty(C, "__esModule", {
      value: !0
    }), Object.defineProperty(C, "default", {
      enumerable: !0,
      get: function() {
        return e.createSvgIcon;
      }
    });
    var e = require$$0;
  }(createSvgIcon)), createSvgIcon;
}
var _interopRequireDefault$b = interopRequireDefaultExports;
Object.defineProperty(History, "__esModule", {
  value: !0
});
var default_1$b = History.default = void 0, _createSvgIcon$b = _interopRequireDefault$b(requireCreateSvgIcon()), _jsxRuntime$b = jsxRuntimeExports;
default_1$b = History.default = (0, _createSvgIcon$b.default)(/* @__PURE__ */ (0, _jsxRuntime$b.jsx)("path", {
  d: "M13 3c-4.97 0-9 4.03-9 9H1l3.89 3.89.07.14L9 12H6c0-3.87 3.13-7 7-7s7 3.13 7 7-3.13 7-7 7c-1.93 0-3.68-.79-4.94-2.06l-1.42 1.42C8.27 19.99 10.51 21 13 21c4.97 0 9-4.03 9-9s-4.03-9-9-9m-1 5v5l4.28 2.54.72-1.21-3.5-2.08V8z"
}), "History");
const PrimaryButton = styled$1(Button$2)(({ theme: C }) => ({
  backgroundColor: C.palette.primary.main,
  color: C.palette.primary.contrastText,
  "&:disabled": {
    backgroundColor: C.palette.primary.main,
    color: C.palette.primary.contrastText,
    opacity: 0.4
  }
})), ErrorButton = styled$1(Button$2)(({ theme: C }) => ({
  backgroundColor: C.palette.error.main,
  color: C.palette.error.contrastText,
  "&:disabled": {
    backgroundColor: C.palette.error.main,
    color: C.palette.error.contrastText,
    opacity: 0.4
  }
})), Button = forwardRef((C, e) => {
  const { variant: T, ...$ } = C;
  return T === "primary" ? /* @__PURE__ */ jsxRuntimeExports.jsx(PrimaryButton, { ref: e, variant: "contained", ...$ }) : T === "error" ? /* @__PURE__ */ jsxRuntimeExports.jsx(ErrorButton, { ref: e, variant: "contained", ...$ }) : /* @__PURE__ */ jsxRuntimeExports.jsx(Button$2, { ...$ });
}), useStyles$u = makeStyles()((C) => ({
  container: {
    display: "flex",
    justifyContent: "center",
    alignContent: "center",
    alignItems: "center",
    flexDirection: "row",
    maxWidth: "100%",
    flexWrap: "wrap",
    gap: "20px 4px"
  },
  partnerLogo: {
    maxHeight: C.spacing(3)
  },
  separator: {
    display: "flex",
    paddingLeft: C.spacing(1),
    paddingRight: C.spacing(1)
  }
}));
function SeparatorSymbol(C) {
  const { classes: e } = useStyles$u();
  return /* @__PURE__ */ jsxRuntimeExports.jsx(Box, { className: e.separator, children: /* @__PURE__ */ jsxRuntimeExports.jsx(
    "svg",
    {
      width: "16",
      height: "16",
      viewBox: "0 0 27 38",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: /* @__PURE__ */ jsxRuntimeExports.jsx(
        "path",
        {
          fill: C.color,
          d: "M24.536 37.864C22.376 37.72 20.6 37.288 18.728 35.416C17.432 36.328 15.416 37.432 12.008 37.432H11.624C5.096 37.432 0.632 33.832 0.632 27.64V26.824C0.632 22.024 3.608 19.528 6.68 17.464C4.808 14.392 3.176 11.848 3.176 8.632V8.056C3.176 3.832 5.72 0.951998 11.336 0.951998H12.104C18.008 0.951998 20.024 4.072 20.024 8.056V8.248C20.024 12.136 17.864 14.92 13.64 17.992L19.016 26.728C19.448 23.992 19.688 20.872 19.688 16.6H25.448C25.4 21.784 24.536 26.872 22.616 31.24C24.2 32.392 25.592 32.392 26.888 32.536L24.536 37.864ZM9.224 8.392C9.224 10.168 9.848 11.8 11.432 14.44C13.496 11.992 14.072 10.696 14.072 8.632V8.44C14.072 6.184 13.208 5.464 11.672 5.464C10.088 5.464 9.224 6.232 9.224 8.296V8.392ZM12.632 32.536C14.024 32.536 15.032 32.248 15.848 31.72L9.032 21.16C7.928 22.456 6.824 23.896 6.824 26.344V26.584C6.824 30.04 9.032 32.536 12.632 32.536Z"
        }
      )
    }
  ) });
}
function WormholeLogo(C) {
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(
    Stack,
    {
      alignItems: "center",
      direction: "row",
      justifyContent: "space-between",
      gap: "4px",
      children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(Typography, { fontSize: "12px", sx: { opacity: 0.6 }, children: "Powered by" }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          Link,
          {
            href: "https://wormhole.com/products/connect",
            paddingBottom: "2px",
            target: "_blank",
            children: /* @__PURE__ */ jsxRuntimeExports.jsxs(
              "svg",
              {
                xmlns: "http://www.w3.org/2000/svg",
                width: "78",
                height: "8",
                viewBox: "0 0 78 8",
                fill: "none",
                children: [
                  /* @__PURE__ */ jsxRuntimeExports.jsxs("g", { clipPath: "url(#clip0_2_9880)", children: [
                    /* @__PURE__ */ jsxRuntimeExports.jsx(
                      "path",
                      {
                        d: "M58.9654 0.5H55.3552C53.9676 0.5 52.8438 1.59108 52.8438 2.93817V5.06183C52.8438 6.40892 53.9676 7.5 55.3552 7.5H59.0508V7.49634C60.3982 7.45246 61.4769 6.38088 61.4769 5.06183V2.93817C61.4769 1.59108 60.353 0.5 58.9654 0.5ZM58.5762 6.33699H55.7445V1.66301H58.5762V6.33699Z",
                        fill: "white"
                      }
                    ),
                    /* @__PURE__ */ jsxRuntimeExports.jsx(
                      "path",
                      {
                        d: "M18.8612 0.5H15.251C13.8634 0.5 12.7395 1.59108 12.7395 2.93817V5.06183C12.7395 6.40892 13.8634 7.5 15.251 7.5H18.9466V7.49634C20.294 7.45246 21.3726 6.38088 21.3726 5.06183V2.93817C21.3726 1.59108 20.2488 0.5 18.8612 0.5ZM18.4719 6.33699H15.6402V1.66301H18.4719V6.33699Z",
                        fill: "white"
                      }
                    ),
                    /* @__PURE__ */ jsxRuntimeExports.jsx(
                      "path",
                      {
                        d: "M39.0683 1.71909L36.9713 5.24469V0.5H35.5184C34.6206 0.5 33.7918 0.964472 33.3435 1.71909L30.3046 6.82828L28.9673 4.58029C29.9279 4.56931 30.7039 3.80982 30.7039 2.87478V2.20672C30.7039 1.26437 29.9166 0.5 28.9459 0.5H22.0708V7.5H24.9715V4.5815H25.6195L27.3549 7.5H31.2452L34.0705 2.748V7.5H36.9713V7.49756L39.7841 2.7675V7.5H42.6848V0.5H41.242C40.3442 0.5 39.5154 0.964472 39.0671 1.71909H39.0683ZM27.8032 3.4185H24.9715V1.66301H27.8032V3.4185Z",
                        fill: "white"
                      }
                    ),
                    /* @__PURE__ */ jsxRuntimeExports.jsx(
                      "path",
                      {
                        d: "M49.2273 3.4185H46.3956V0.5H43.4949V7.5H46.3956V4.5815H49.2273V7.5H52.128V0.5H49.2273V3.4185Z",
                        fill: "white"
                      }
                    ),
                    /* @__PURE__ */ jsxRuntimeExports.jsx(
                      "path",
                      {
                        d: "M65.0934 0.5H62.1926V5.06183C62.1926 6.40892 63.3165 7.5 64.7041 7.5H68.8379V6.33699H65.0934V0.5Z",
                        fill: "white"
                      }
                    ),
                    /* @__PURE__ */ jsxRuntimeExports.jsx(
                      "path",
                      {
                        d: "M77.5001 1.66301V0.5H72.4847H69.584V1.66301V3.4185V4.5815V6.33699V7.5H72.4847H77.5001V6.33699H72.4847V4.5815H76.4541V3.4185H72.4847V1.66301H77.5001Z",
                        fill: "white"
                      }
                    ),
                    /* @__PURE__ */ jsxRuntimeExports.jsx(
                      "path",
                      {
                        d: "M11.9409 0.5L9.11555 5.252V0.5H6.21482V0.502438L3.40199 5.2325V0.5H0.5V7.5H1.94283C2.84068 7.5 3.66946 7.03553 4.11775 6.28091L6.21482 2.75531V7.5H7.6677C8.56554 7.5 9.39432 7.03553 9.84262 6.28091L13.2808 0.5H11.9409Z",
                        fill: "white"
                      }
                    )
                  ] }),
                  /* @__PURE__ */ jsxRuntimeExports.jsx("defs", { children: /* @__PURE__ */ jsxRuntimeExports.jsx("clipPath", { id: "clip0_2_9880", children: /* @__PURE__ */ jsxRuntimeExports.jsx(
                    "rect",
                    {
                      width: "77",
                      height: "7",
                      fill: "white",
                      transform: "translate(0.5 0.5)"
                    }
                  ) }) })
                ]
              }
            )
          }
        )
      ]
    }
  );
}
function PartnerLogo(C) {
  const { classes: e } = useStyles$u();
  return /* @__PURE__ */ jsxRuntimeExports.jsx("img", { src: C.src, alt: "partner", className: e.partnerLogo });
}
function PoweredByIcon(C) {
  const { classes: e } = useStyles$u();
  return config$1.ui.partnerLogo ? /* @__PURE__ */ jsxRuntimeExports.jsxs(Box, { className: e.container, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(WormholeLogo, { color: C.color }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(SeparatorSymbol, { color: C.color }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(PartnerLogo, { src: config$1.ui.partnerLogo })
  ] }) : /* @__PURE__ */ jsxRuntimeExports.jsx(WormholeLogo, { color: C.color });
}
function getTokenDetails(C) {
  const e = config$1.tokens[C], { symbol: T, tokenId: $ } = e;
  return {
    symbol: T,
    tokenId: $ ?? "native"
  };
}
function getTransferDetails(C, e, T, $, V, J, ee) {
  return {
    route: C,
    fromToken: getTokenDetails(e),
    toToken: getTokenDetails(T),
    fromChain: $,
    toChain: V,
    amount: J,
    USDAmount: ee({ token: e, amount: J })
  };
}
const useFetchSupportedRoutes = () => {
  const [C, e] = useState([]), [T, $] = useState(!1), { token: V, destToken: J, fromChain: ee, toChain: te, amount: re } = useSelector(
    (de) => de.transferInput
  ), { toNativeToken: ie } = useSelector((de) => de.relay), se = useSelector(
    (de) => de.wallet.receiving
  );
  return useEffect(() => {
    if (!ee || !te || !V || !J) {
      e([]), $(!1);
      return;
    }
    let de = !0;
    return (async () => {
      $(!0);
      const fe = [];
      await config$1.routes.forEach(async (he, me) => {
        if (!me.AUTOMATIC_DEPOSIT && se.name === ReadOnlyWallet.NAME)
          return;
        let xe = !1;
        try {
          xe = await me.isRouteSupported(
            V,
            J,
            ee,
            te
          ), xe && config$1.isRouteSupportedHandler && (xe = await config$1.isRouteSupportedHandler({
            route: he,
            fromChain: ee,
            toChain: te,
            fromToken: getTokenDetails(V),
            toToken: getTokenDetails(J)
          }));
        } catch (ve) {
          maybeLogSdkError(
            ve,
            `Error when checking route (${he}) is supported`
          );
        }
        xe && fe.push(he);
      }), de && ($(!1), e(fe));
    })(), () => {
      de = !1;
    };
  }, [
    V,
    J,
    re,
    ee,
    te,
    ie,
    se
  ]), {
    supportedRoutes: C,
    isFetching: T
  };
}, useComputeDestinationTokens = (C) => {
  const { sourceChain: e, destChain: T, sourceToken: $ } = C, V = useDispatch(), [J, ee] = useState(!1);
  return useEffect(() => {
    if (!T)
      return;
    let te = !0;
    return (async () => {
      var de;
      let ie = [];
      ee(!0);
      try {
        ie = await config$1.routes.allSupportedDestTokens(
          config$1.tokens[$],
          e,
          T
        );
      } catch (ue) {
        console.error(ue);
      }
      V(setSupportedDestTokens(ie)), ee(!1), T && ie.length === 1 && te && V(setDestToken(ie[0].key));
      const se = ie.map((ue) => ue.symbol);
      if (T && se.every((ue) => ue === se[0]) && ["USDC", "tBTC"].includes(se[0])) {
        const ue = (de = ie.find(
          (fe) => {
            var he;
            return fe.symbol === se[0] && fe.nativeChain === ((he = fe.tokenId) == null ? void 0 : he.chain) && fe.nativeChain === T;
          }
        )) == null ? void 0 : de.key;
        te && ue && V(setDestToken(ue));
      }
    })(), () => {
      te = !1;
    };
  }, [$, e, T, V]), {
    isFetching: J
  };
}, useComputeSourceTokens = (C) => {
  const { sourceChain: e, destChain: T, sourceToken: $, destToken: V, route: J } = C, ee = useDispatch(), [te, re] = useState(!1);
  return useEffect(() => {
    if (!e)
      return;
    let ie = !0;
    return (async () => {
      let de = [];
      re(!0);
      try {
        de = await config$1.routes.allSupportedSourceTokens(
          config$1.tokens[V],
          e,
          T
        );
      } catch (ue) {
        console.error(ue);
      }
      ie && (ee(setSupportedSourceTokens(de)), $ && de.some((fe) => fe.key === $) || ee(setToken("")), de.length === 1 && $ === "" && ee(setToken(de[0].key))), re(!1);
    })(), () => {
      ie = !1;
    };
  }, [T, V, ee, J, e]), { isFetching: te };
}, SANCTIONED_WALLETS = Object.freeze(
  /* @__PURE__ */ new Set([
    "3",
    "1Gq",
    "1N6XqS",
    "1B64QRxf",
    "1B11Ezqg3AXj",
    "3F6bbvS1krsc1qR8FsbTDfYQyvkMm",
    "125W5ek3DT6Zqy5S2iPt4FHQdNMCbZA3FU",
    "1295rkVyNfFpqZpXvKGhDqwhP1jZcNNDMV",
    "129zKFLoVad9JtxSmDKeJoLCsjhGR7b3vr",
    "12HQDsicffSBaYdJ6BhnE22sfjTESmmzKx",
    "12NpCkhddSNiDkD9rRYUCHsTT9ReMNiJjG",
    "12QtD5BFwRsdNsAZY76UVE1xyCGNTojH9h",
    "12udabs2TkX7NXCSj6KpqXfakjE52ZPLhz",
    "12w6v1qAaBc4W8h8C2Cu5SKFaKDSv3erUW",
    "12YCfVAEzkEZXBYhUTyJJaRkgMXiFxJgcu",
    "12YyR9EpvHxBjjKjTWqfKqeyoWnvcraxpW",
    "134r8iHv69xdT6p5qVKTsHrcUEuBVZAYak",
    "13f59kUM5FU8MfTG7DCEugYarDhSD7XCoC",
    "13fhnkmpBBWXUQucJd6efWvXdEj78DKavk",
    "13JtX4h7G5ZuNK5mFudKGq9DHLvvMFuNuz",
    "13mnk8SvDGqsQTHbiGiHBXqtaQCUKfcsnP",
    "13RH4JaFhaCxDGPyYE9emjp2aDxdX18uBA",
    "13YBQr2Cp1YY3xqq2qngaPb7ca1o4ugeq6",
    "149w62rY42aZBox8fGcmqNsXUzSStKeq8C",
    "14gM1HuLVDELNHaFU22qpabjtiWek4HhV1",
    "14kqryJUxM3a7aEi117KX9hoLUw592WsMR",
    "14rjAD8ZP5xaL571cMRE98qgxxbg1S8mAN",
    "158treVZBGMBThoaympxccPdZPtqUfYrT9",
    "15cRqR3TXS1JehBGWERuxFE8NhWZzfoeeU",
    "15kZobLkD6HZgEECtz4oS2Vz21XHTnNfSg",
    "15Pt4NwZaUmMUwS2bQbyyncc7mzgWShtv8",
    "15qyVrZvvVGvB7GWiAZ82TNcZ6QWMKu3kx",
    "15uqdxqNXQwVf5H7yZPz4TmEGeSccCwdor",
    "15YK647qtoZQDzNrvY6HJL6QwXduLHfT28",
    "15yqWQ4sqr7jzCwDtZ3U1KaCa8WMEy7Mm2",
    "16PhXY3hNNMTo8kpuJx2emh713KbWpkqci",
    "17a5bpKvEp1j1Trs4qTbcNZrby53JbaS9C",
    "17ezuJoT3XBbdcwFZbkTnrXbup11F4uhiy",
    "17mhyeBX617ABZ1ffThhUTJkHUcMvCkfd5",
    "17UVSMegvrzfobKC82dHXpZLtLcqzW9stF",
    "17V7THwHMiDJmDwZK4unhE5HgKFJKx7VCe",
    "182NGZbPJXwg2WDrhrPpR7tpiGQkNPF844",
    "18gaXypKj9M23S2zT9qZfL9iPbLFM372Q5",
    "18Qj1THHuETfYhuRDZycXJbWwDMGw73Poa",
    "18uKfaUjgG52rVeXEi3wxnveww7zZuECtE",
    "18yWCu6agTxYqAerMxiz9sgHrK3ViezzGa",
    "1986rYHckYbJpGQJy6ornuMyD2N5MTqwDt",
    "19D1iGzDr7FyAdiy3ZZdxMd6ttHj1kj6WW",
    "19D8PHBjZH29uS1uPZ4m3sVyqqfF8UFG9o",
    "19GrL5jnUkGmHXVcraB1Etv5rXCANeLWpq",
    "1A7SKE2dQtezLktCY8peLsdAtkqxV9r1dC",
    "1AeSq93WDNdLoEJ92sex7T8xQZoYYm8BtS",
    "1AjZPMsnmpdK2Rv9KQNfMurTXinscVro9V",
    "1AoxtfiBQ22DvbhqAN9Ctb8sULMRhrdwTr",
    "1AXUTu9y3H8w4wYx4BjyFWgRhZKDhmcMrn",
    "1BiUFjzH6wsT73U3tfy4aXHCQsYQHzjk5h",
    "1CF46Rfbp97absrs7zb7dFfZS6qBXUm9EP",
    "1CPJak9ZyddbawMGJPyEhCiJLXXb4sYv8N",
    "1D6gG9iKEhPitTcWRJiniuj1jYM2hNeAfJ",
    "1DbShx4r8i2XesthoDBf5EkYWz5dsKEusV",
    "1DbvK8P6imBuLcwh2Vruis4xsUb8YAwJQF",
    "1DDA93oZPn7wte2eR1ABwcFoxUFxkKMwCf",
    "1Df883c96LVauVsx9FEgnsourD8DELwCUQ",
    "1DH2xDH7TngrDU6LXciprKCBKNcPA1xX8A",
    "1DJoEMvp95yJYWyxAZy8DDBzuvjnrTVrsN",
    "1DJoVLgn1foJHHngduRPJvRbwpaFEKxvxd",
    "1DT3tenf14cxz9WFNxmYrXFbB6TFiVWA9U",
    "1DYFJ6CuBvrxyoQSuBzVsNcetY9tvdsrag",
    "1ECeZBxCVJ8Wm2JSN3Cyc6rge2gnvD3W5K",
    "1Edue8XZCWNoDBNZgnQkCCivDyr9GEo4x6",
    "1EfMVkxQQuZfBdocpJu6RUsCJvenQWbQyE",
    "1EpMiZkQVekM5ij12nMiEwttFPcDK9XhX6",
    "1EYitrwBYNWuTBcjZFbEUdqHppe2raLpaF",
    "1F2Gdug9ib9NQMhKMGGJczzMk5SuENoqrp",
    "1FCNgfZWpYMeYhy9t18AAkTBu8AsdoAc1Z",
    "1FE2cuvkq8n5VGwj5hi8YYQxskwJpovPyV",
    "1FjubFHV4mpYjBmvjsEhZssyiiA4TNmnm2",
    "1FRyL9gmFGbzfYDAB4iY9836DJe3KSnjP9",
    "1Fz29BQp82pE3vXXcsZoMNQ3KSHfMzfMe3",
    "1G6DuwDKNHiUWqks2Lgu44cesu7ffFbLK7",
    "1G9A8WRjGXdnYY4TNEVRrcaHsMtana4ncF",
    "1G9CKRHA3mx22DoT1QyNYrh85VSQ19Y1em",
    "1GYuu9d5HPikafbys3k5Q3DRJq6debGsoB",
    "1H939dom7i4WDLCKyGbXUp3fs9CSTNRzgL",
    "1Hn9ErTCPRP6j5UDBeuXPGuq5RtRjFJxJQ",
    "1Hpj6qm9i7nMF3VkKfBFtjhEDpEjxHWvgv",
    "1J9oGoAiHeRfeMZeUnJ9W7RpV55CdKtgYE",
    "1JHdQHkBZiim1cb4hyUh2PbzEbbg6z2TrF",
    "1JPfVv5cWRLx1js9NWxg46dG2CGbeRz4th",
    "1JREJdZupiFhE7ZzQPtASuMCvvpXC7wRsC",
    "1Js6goCey2NaqPQptiLANLQGuk4d6mowjP",
    "1Kc6egXevyLEaeTxLFA1Zyw7GuhCN8jQtt",
    "1KctQENEX5QkQMpnMC3Zh9yRAzkMBLpPcr",
    "1KgudqxMfYaGzqAA7MS4DcsqejtMteqhix",
    "1KSAbh5trMCTZwhiNsuUQvfTtSSTT8zqRk",
    "1Kuf2Rd8mDyAViwBozGTNYnvWL8uYFrkVo",
    "1KUUJPkyDhamZXgpsyXqNGc3x1QPXtdhgz",
    "1Kys8fqDen8NGFUJ6AFcXfFW5qquuTH4eh",
    "1L4ncif9hh9TnUveqWq77HfWWt6CJWtrnb",
    "1LAh7PQwpd1uGiLHae5C5Xz9QXse3y2phq",
    "1LiNmTUPSJEd92ZgVJjAV3RT9BzUjvUCkx",
    "1Ljk8RNNabkZ9bfDYQBn98XfFozJhTjqcZ",
    "1LpYKb3SXZPve9hsH2QEJZFX279wJVGowi",
    "1LrxsRd7zNuxPJcL5rttnoeJFy1y4AffYY",
    "1MkCnCa9agS5t6V1B15bzusBgYECB4LfWp",
    "1MLPqwaFFUBZePTjpR3nxRoK19Cv9mPCc7",
    "1MnbhWe5wr7Ut45ReyQsm96PwnM9jD7KaH",
    "1NayLEVF3bEEbDtdF2Cwso1VdEtvVNh2qX",
    "1NE2NiGhhbkFPSEyNWwj7hKGhGDedBtSrQ",
    "1NuBZQXJPyYQGfoBib8wWBDpZmbtkJa5Ba",
    "1P3ZfGFLezzYGg9k5SVzQmnjyh7nrUmF2y",
    "1PfwHNxUnkpfkK9MKjMqzR3Xq3KCtq9u17",
    "1PhqQpaGCrqSxQ6QDXcv14QCd1U98Zp34E",
    "1PJp8diNa89cVHpiT1VPu7EQ8LxYM5HX6v",
    "1Q6saNmqKkyFB9mFR68Ck8F7Dp7dTopF2W",
    "1Q9UAQbcDezmyouFrzt94t4dSMxgsUfW1X",
    "31p6woV4e55HUfC2aGynFhzQnGoJFW26cD",
    "32DaxSzUhLBHY2WGSWQYiBSHnRsfQZrrRp",
    "32jgFkZsTEjMFaBvxJnYvJEeTNKTmq5b32",
    "32pTjxTNi7snk8sodrgfmdKao3DEn1nVJM",
    "32wdqwX3zCEX3DhAVEcKwXCEGdzgBnx1R9",
    "33Kja69SQVc8kozpoP7Qw6HFtGxHkiWzTz",
    "33xWfziVZesgo83U5izdNCBVTnrtBpSwK7",
    "347QFbejDBdMZFTxpmn6evvvqyXiqZTCd7",
    "34pFGsSYbWEritXncW9unZtQQE9dKSvKku",
    "35KAdTa2vqnJzitF2xiUzZn1Gmcas2Y465",
    "35LScRJ8hzDvvWh9t9UA8bHGnGNVz3YEfa",
    "35QpLWYkvD3ALhjbge5bK2kd7HfHYcDMu3",
    "35qwVtMEohWDdBWRiCSR7azoP5cbY8SG1Q",
    "3685sEusmTwZBiKJ4cgV73EAhpVD1nbgbe",
    "372Wk9NLrMkJzKgqJdatWJy4bYRfxFjgat",
    "389Sft4nJFkPGhbagk9FN4jXncA9piYTuU",
    "38ncxqt932N9CcfNfYuHGZgCyR85hDkWBW",
    "38TftW1heYPqvKbiAhT4ttNBqkUPpooXad",
    "39eboeqYNFe2VoLC3mUGx4dh6GNhLB3D2q",
    "39fhoB2DohisGBbHvvfmkdPdShT75CNHdX",
    "39NG2LcGRHXxSr1irpEVnJMw4ydL231sEn",
    "39p8qWp1bkBNhi4vPpFTetKPtH7goqNDZf",
    "39Te8MbphSgs7npDJPj2hbNzhke61NTcnB",
    "3AjyprBY5yhijiCjUC5NUJutGbwhd3AQdE",
    "3AQSmMk5n3c6TKEg9B2WyzYAPm33gJJAA4",
    "3B7S6zrgxQVQUHTU8wstM23tB9afE7ojuX",
    "3BsyZ7qRFSi3NsaoV1Ff724qAgrEpjVUHm",
    "3DNsaQnaUz7wkQny1ZDSmtz6QfbEShxoDD",
    "3E6rY4dSCDW6y2bzJNwrjvTtdmMQjB6yeh",
    "3E6ZCKRrsdPc35chA9Eftp1h3DLW18NFNV",
    "3E7YbpXuhh3CWFks1jmvWoV8y5DvsfzE6n",
    "3EeR8FbcPbkcGj77D6ttneJxmsr3Nu7KGV",
    "3EPqGUw2q89pwPZ1UF8FJspE2AyojSTjdu",
    "3F2sZ4jbhvDKQdGbHYPC6ZxFXEau2m5Lqj",
    "3F6bbvS1krsc1qR8FsbTDfYQyvkMm3QvmR",
    "3Gbs4rjcVUtQd8p3CiFUCxPLZwRqurezRZ",
    "3GXdtA6kbb4M5aqzZm5qqxcFDFRMW8LqdJ",
    "3H3rh85qPaGLy2w6618yZNaH7i8asHv46B",
    "3He6EyDaCUgmdr4GXqhxbeTQukaGLCByU2",
    "3HePkztPU6UsdENxnyQHFrdZA6eVKeMtvz",
    "3HqA7i3ttECLvgqvq69HNxxUP5BL7Z5YgA",
    "3HQRveQzPifZorZLDXHernc5zjoZax8U9f",
    "3JHMz3mTna1gVCZSPp8NgRFiY7phkv5mA8",
    "3JXKQ81JzBqVbB8VHdV9Jtd7auWokkdPgY",
    "3K35dyL85fR9ht7UgzPfd1gLRRXQtNTqE3",
    "3K4rjdh8A5yi6LWvft2rbmyZvqEbPSSSX4",
    "3K7PMJyMNVnxqsfpmK9r9nJDtzDw9wNwNV",
    "3KHfXU24Bt3YD5Ef4J7uNp2buCuhrxfGen",
    "3LbDu1rUXHNyiz4i8eb3KwkSSBMf7C583D",
    "3LhnVMcBq4gsR7aDaRr9XmUo17CuYBV4FN",
    "3Lpoy53K625zVeE47ZasiG5jGkAxJ27kh1",
    "3MkUNScqf21EcfWq6T4x2MFgBeSTqhB5t6",
    "3MN8nYo1tt5hLxMwMbxDkXWd7Xu522hb9P",
    "3MTrJTFhYK9v1C6pjHtuweZSopfZa4b1wb",
    "3MTRvM5QrYZHKo8gh5qKcrPK3RLjxcDCZE",
    "3N6WeZ6i34taX8Ditser6LKWBcXmt2XXL4",
    "3N9YcPBDky9UsMx1RTk33tL4jDkZfSnsPk",
    "3NNcbBcMZokPB2JC2dxYuZrpgcetvyGeJn",
    "3NQ1aa9ceirMJ1JvRq3eXefvXj1L639fzX",
    "3NRJ8aXdUiZdHaiFX9ePX3DhGHzcEi14Fq",
    "3NU9zkD8CCVGVmYnNNSN7PbU9sSFQBm5UV",
    "3PiCnZrBvGfWAKQ9hr4cCpfaDjy64yNSpE",
    "3PKiHs4GY4rFg8dpppNVPXGPqMX6K2cBML",
    "3Q5dGfLKkWqWSwYtbMUyc8xGjN5LrRviK4",
    "3Q8H2ZWMtc4R1M3mkmhnTjCoYKTeCFigDP",
    "DFFJhnQNZf8rf67tYnesPu7MuGUpYtzv7Z",
    "GPwg61XoHqQPNmAucFACuQ5H9sGCDv9TpS",
    "LaizKtS5DUhPuP1nTQcc83MS7HwK6vk85z",
    "LeKvNdNEzgQkzVVnRdV3fAu2DSF1nLsNw6",
    "Leo3j36nn1JcsUQruytQhFUdCdCH5YHMR3",
    "LNwgtMxcKUQ51dw7bQL1yPQjBVZh6QEqsd",
    "M8yFL6SFC6TreATegTyuSYkDfDRbisdpT3",
    "TDdbRFoBTEmE3qiR69Y6rKRSG1hoF65QaE",
    "TEAqwfMhXLaomXhZ8KeMhx3njGmQEDnsUR",
    "TEFph7dZoUN5233cGEzF6XFwRpjPF8fQDS",
    "TFdTr9C3BqQrzKBXqSxJfAZFTh8UwBAfSg",
    "TFFvv7NAWmbcVfA7QN81mMvUC25TWj1WJx",
    "TGJVc32ig2u8tQsYMLE7KXHT5NDQroaVNU",
    "TH96tFMn8KGiYSLiwcV3E2UiaJc8jmcbz3",
    "THh5woR8qfmDsNknQ3agPYzQSiRtMnKsTh",
    "TLM3zA3EWycoDX4ZX4gKze7sgfbdkntTum",
    "TLNRT524dzL5FF1nJHDhYEMFpeWjLjRbz1",
    "TMGLqRQ4twjW8wJhVH1mQR7nUThpGHUsN3",
    "TMStbg5fgb4uTV7fK1gEYF9hKAzP3siPsG",
    "TRBACioxdrdsYEZHvJWiUDZcMdBPpEe5Ub",
    "TTAHMdqoom4f2VTWniroPWQHcTRZ4caoH4",
    "TTgcTTNbNuFdbrhvbjMZVrdU5KALyzDaPw",
    "TTKnV2S1295UrPr7N67Tp9ykNL7xX2Z4Uj",
    "TTUDyVhhpCC1xJoPmWzdjLAzeoPwbSABdr",
    "TUCsTq7TofTCJRRoHk6RvhMoS2mJLm5Yzq",
    "TV5ZTpKDszLTF6XcMnPongS33pwBgF91by",
    "TVacWx7F5wgMgn49L5frDf9KLgdYy8nPHL",
    "TWBAPzpPiZarfVsY2BLXeaLhNHurn4wkWG",
    "TX5GV4DyfxNB3rPkzZJhmqZ1efVmL4rEqG",
    "TXEsK1sEsKjZ1xtHitnyAAoqw3WLdYdRNW",
    "XnPFsRWTaSgiVauosEwQ6dEitGYXgwznz2",
    "Xs3vzQmNvAxRa3Xo8XzQqUb3BMgb9EogF4",
    "XyARKoupuArYtToA2S6yMdnoquDCDaBsaT",
    "t1g7wowvQ8gn2v8jrU1biyJ26sieNqNsBJy",
    "t1MMXtBrSp1XG38Lx9cePcNUCJj5vdWfUWL",
    "0x01e2919679362dFBC9ee1644Ba9C6da6D6245BB1",
    "0x03893a7c7463AE47D46bc7f091665f1893656003",
    "0x04DBA1194ee10112fE6C3207C0687DEf0e78baCf",
    "0x05E0b5B40B7b66098C2161A5EE11C5740A3A7C45",
    "0x07687e702b410Fa43f4cB4Af7FA097918ffD2730",
    "0x0836222F2B2B24A3F36f98668Ed8F0B38D1a872f",
    "0x08723392Ed15743cc38513C4925f5e6be5c17243",
    "0x08b2eFdcdB8822EfE5ad0Eae55517cf5DC544251",
    "0x09193888b3f38C82dEdfda55259A82C0E7De875E",
    "0x0931cA4D13BB4ba75D9B7132AB690265D749a5E7",
    "0x098B716B8Aaf21512996dC57EB0615e2383E2f96",
    "0x0E3A09dDA6B20aFbB34aC7cD4A6881493f3E7bf7",
    "0x0Ee5067b06776A89CcC7dC8Ee369984AD7Db5e06",
    "0x12D66f87A04A9E220743712cE6d9bB1B5616B8Fc",
    "0x1356c899D8C9467C7f71C195612F8A395aBf2f0a",
    "0x169AD27A470D064DEDE56a2D3ff727986b15D52B",
    "0x175d44451403Edf28469dF03A9280c1197ADb92c",
    "0x178169B423a011fff22B9e3F3abeA13414dDD0F1",
    "0x179f48C78f57A3A78f0608cC9197B8972921d1D2",
    "0x1967D8Af5Bd86A497fb3DD7899A020e47560dAAF",
    "0x1999EF52700c34De7EC2b68a28aAFB37db0C5ade",
    "0x19Aa5Fe80D33a56D56c78e82eA5E50E5d80b4Dff",
    "0x19F8f2B0915Daa12a3f5C9CF01dF9E24D53794F7",
    "0x1da5821544e25c636c1417Ba96Ade4Cf6D2f9B5A",
    "0x1E34A77868E19A6647b1f2F47B51ed72dEDE95DD",
    "0x21B8d56BDA776bbE68655A16895afd96F5534feD",
    "0x22aaA7720ddd5388A3c0A3333430953C68f1849b",
    "0x23173fE8b96A4Ad8d2E17fB83EA5dcccdCa1Ae52",
    "0x23773E65ed146A459791799d01336DB287f25334",
    "0x242654336ca2205714071898f67E254EB49ACdCe",
    "0x2573BAc39EBe2901B4389CD468F2872cF7767FAF",
    "0x26903a5a198D571422b2b4EA08b56a37cbD68c89",
    "0x2717c5e28cf931547B621a5dddb772Ab6A35B701",
    "0x2f389cE8bD8ff92De3402FFCe4691d17fC4f6535",
    "0x2F50508a8a3D323B91336FA3eA6ae50E55f32185",
    "0x2FC93484614a34f26F7970CBB94615bA109BB4bf",
    "0x308eD4B7b49797e1A98D3818bFF6fe5385410370",
    "0x330bdFADE01eE9bF63C209Ee33102DD334618e0a",
    "0x35fB6f6DB4fb05e6A4cE86f2C93691425626d4b1",
    "0x38735f03b30FbC022DdD06ABED01F0Ca823C6a94",
    "0x39D908dac893CBCB53Cc86e0ECc369aA4DeF1A29",
    "0x3aac1cC67c2ec5Db4eA850957b967Ba153aD6279",
    "0x3AD9dB589d201A710Ed237c829c7860Ba86510Fc",
    "0x3CBdeD43EFdAf0FC77b9C55F6fC9988fCC9b757d",
    "0x3Cffd56B47B7b41c56258D9C7731ABaDc360E073",
    "0x3e37627dEAA754090fBFbb8bd226c1CE66D255e9",
    "0x3eFA30704D2b8BBAc821307230376556cF8CC39e",
    "0x407CcEeaA7c95d2FE2250Bf9F2c105aA7AAFB512",
    "0x43fa21d92141BA9db43052492E0DeEE5aa5f0A93",
    "0x4736dCf1b7A3d580672CcE6E7c65cd5cc9cFBa9D",
    "0x47CE0C6eD5B0Ce3d3A51fdb1C52DC66a7c3c2936",
    "0x48549A34AE37b12F6a30566245176994e17C6b4A",
    "0x4F47Bc496083C727c5fbe3CE9CDf2B0f6496270c",
    "0x502371699497d08D5339c870851898D6D72521Dd",
    "0x527653eA119F3E6a1F5BD18fbF4714081D7B31ce",
    "0x530A64c0Ce595026a4A556b703644228179E2d57",
    "0x538Ab61E8A9fc1b2f93b3dd9011d662d89bE6FE6",
    "0x53b6936513e738f44FB50d2b9476730C0Ab3Bfc1",
    "0x5512d943eD1f7c8a43F3435C85F7aB68b30121b0",
    "0x57b2B8c82F065de8Ef5573f9730fC1449B403C9f",
    "0x58E8dCC13BE9780fC42E8723D8EaD4CF46943dF2",
    "0x5A14E72060c11313E38738009254a90968F58f51",
    "0x5A7a51bFb49F190e5A6060a5bc6052Ac14a3b59f",
    "0x5cab7692D4E94096462119ab7bF57319726Eed2A",
    "0x5efda50f22d34F262c29268506C5Fa42cB56A1Ce",
    "0x5f48C2A71B2CC96e3F0CCae4E39318Ff0dc375b2",
    "0x5f6c97C6AD7bdd0AE7E0Dd4ca33A4ED3fDabD4D7",
    "0x610B717796ad172B316836AC95a2ffad065CeaB4",
    "0x653477c392c16b0765603074f157314Cc4f40c32",
    "0x67d40EE1A85bf4a4Bb7Ffae16De985e8427B6b45",
    "0x6aCDFBA02D390b97Ac2b2d42A63E85293BCc160e",
    "0x6Be0aE71e6c41f2f9D0D1A3B8d0f75E6f6A0b46e",
    "0x6Bf694a291DF3FeC1f7e69701E3ab6c592435Ae7",
    "0x6F1cA141A28907F78Ebaa64fb83A9088b02A8352",
    "0x722122dF12D4e14e13Ac3b6895a86e84145b6967",
    "0x723B78e67497E85279CB204544566F4dC5d2acA0",
    "0x72a5843cc08275C8171E582972Aa4fDa8C397B2A",
    "0x743494b60097A2230018079c02fe21a7B687EAA5",
    "0x746Aebc06D2aE31B71ac51429A19D54E797878E9",
    "0x756C4628E57F7e7f8a459EC2752968360Cf4D1AA",
    "0x76D85B4C0Fc497EeCc38902397aC608000A06607",
    "0x776198CCF446DFa168347089d7338879273172cF",
    "0x77777FeDdddFfC19Ff86DB637967013e6C6A116C",
    "0x797d7Ae72EbddCDea2a346c1834E04d1F8dF102b",
    "0x7Db418b5D567A4e0E8c59Ad71BE1FcE48f3E6107",
    "0x7F19720A857F834887FC9A7bC0a0fBe7Fc7f8102",
    "0x7F367cC41522cE07553e823bf3be79A889DEbe1B",
    "0x7FF9cFad3877F21d41Da833E2F775dB0569eE3D9",
    "0x8281Aa6795aDE17C8973e1aedcA380258Bc124F9",
    "0x833481186f16Cece3f1Eeea1a694c42034c3a0dB",
    "0x83E5bC4Ffa856BB84Bb88581f5Dd62A433A25e0D",
    "0x84443CFd09A48AF6eF360C6976C5392aC5023a1F",
    "0x8576aCC5C05D6Ce88f4e49bf65BdF0C62F91353C",
    "0x8589427373D6D84E98730D7795D8f6f8731FDA16",
    "0x88fd245fEdeC4A936e700f9173454D1931B4C307",
    "0x901bb9583b24D97e995513C6778dc6888AB6870e",
    "0x905b63Fff465B9fFBF41DeA908CEb12478ec7601",
    "0x910Cbd523D972eb0a6f4cAe4618aD62622b39DbF",
    "0x931546D9e66836AbF687d2bc64B30407bAc8C568",
    "0x94A1B5CdB22c43faab4AbEb5c74999895464Ddaf",
    "0x94Be88213a387E992Dd87DE56950a9aef34b9448",
    "0x94C92F096437ab9958fC0A37F09348f30389Ae79",
    "0x961C5Be54a2ffC17CF4Cb021d863c42daCd47Fc1",
    "0x97B1043ABD9E6FC31681635166d430a458D14F9C",
    "0x983a81ca6FB1e441266D2FbcB7D8E530AC2E05A2",
    "0x9AD122c22B14202B4490eDAf288FDb3C7cb3ff5E",
    "0x9C2Bc757B66F24D60F016B6237F8CdD414a879Fa",
    "0x9F4cda013E354b8fC285BF4b9A60460cEe7f7Ea9",
    "0xa0e1c89Ef1a489c9C7dE96311eD5Ce5D32c20E4B",
    "0xA160cdAB225685dA1d56aa342Ad8841c3b53f291",
    "0xa5C2254e4253490C54cef0a4347fddb8f75A4998",
    "0xA60C772958a3eD56c1F15dD055bA37AC8e523a0D",
    "0xA7e5d5A720f06526557c513402f2e6B5fA20b008",
    "0xaEaaC358560e11f52454D997AAFF2c5731B6f8a6",
    "0xaf4c0B70B2Ea9FB7487C7CbB37aDa259579fe040",
    "0xaf8d1839c3c67cf571aa74B5c12398d4901147B3",
    "0xb04E030140b30C27bcdfaafFFA98C57d80eDa7B4",
    "0xb1C8094B234DcE6e03f10a5b673c1d8C69739A00",
    "0xB20c66C4DE72433F3cE747b58B86830c459CA911",
    "0xb541fc07bC7619fD4062A54d96268525cBC6FfEF",
    "0xb6f5ec1A0a9cd1526536D3F0426c429529471F40",
    "0xBA214C1c1928a32Bffe790263E38B4Af9bFCD659",
    "0xbB93e510BbCD0B7beb5A853875f9eC60275CF498",
    "0xc2a3829F459B3Edd87791c74cD45402BA0a20Be3",
    "0xC455f7fd3e0e12afd51fba5c106909934D8A0e4a",
    "0xCa0840578f57fE71599D29375e16783424023357",
    "0xCC84179FFD19A1627E79F8648d09e095252Bc418",
    "0xCEe71753C9820f063b38FDbE4cFDAf1d3D928A80",
    "0xD0975B32cEa532eaDDdFC9c60481976e39dB3472",
    "0xD21be7248e0197Ee08E0c20D4a96DEBdaC3D20Af",
    "0xd47438C816c9E7f2E2888E060936a499Af9582b3",
    "0xD4B88Df4D29F5CedD6857912842cff3b20C8Cfa3",
    "0xD5d6f8D9e784d0e26222ad3834500801a68D027D",
    "0xD691F27f38B395864Ea86CfC7253969B409c362d",
    "0xD692Fd2D0b2Fbd2e52CFa5B5b9424bC981C30696",
    "0xD82ed8786D7c69DC7e052F7A542AB047971E73d2",
    "0xd882cFc20F52f2599D84b8e8D58C7FB62cfE344b",
    "0xd8D7DE3349ccaA0Fde6298fe6D7b7d0d34586193",
    "0xd90e2f925DA726b50C4Ed8D0Fb90Ad053324F31b",
    "0xd96f2B1c14Db8458374d9Aca76E26c3D18364307",
    "0xdcbEfFBECcE100cCE9E4b153C4e15cB885643193",
    "0xDD4c48C0B24039969fC16D1cdF626eaB821d3384",
    "0xdf231d99Ff8b6c6CBF4E9B9a945CBAcEF9339178",
    "0xDF3A408c53E5078af6e8fb2A85088D46Ee09A61b",
    "0xe7aa314c77F4233C18C6CC84384A9247c0cf367B",
    "0xE950DC316b836e4EeFb8308bf32Bf7C72a1358FF",
    "0xeD6e0A7e4Ac94D976eeBfB82ccf777A3c6baD921",
    "0xeDC5d01286f99A066559F60a585406f3878a033e",
    "0xEFE301d259F525cA1ba74A7977b80D5b060B3ccA",
    "0xf3701F445b6BDaFeDbcA97D1e477357839e4120D",
    "0xf4B067dD14e95Bab89Be928c07Cb22E3c94E0DAA",
    "0xF60dD140cFf0706bAE9Cd734Ac3ae76AD9eBC32A",
    "0xF67721A2D8F736E75a49FdD7FAd2e31D8676542a",
    "0xF7B31119c2682c88d88D455dBb9d5932c65Cf1bE",
    "0xFAC583C0cF07Ea434052c49115a4682172aB6b4F",
    "0xFD8610d20aA15b7B2E3Be39B396a1bC3516c7144",
    "0xfEC8A60023265364D066a1212fDE3930F6Ae8da7",
    "0xffbaC21a641Dcfe4552920138D90F3638B3c9fba",
    "bc1q2lpgjntr348pfvxhfy33ehmdzy3gmx8w4052z6",
    "bc1q3y5v2khlyvemcz042wl98dzflywr8ghglqws6s",
    "bc1q4namcagg5wljs0u20z6h2sqgsq4q5lts8rt2rr",
    "bc1q5jqgm7nvrhaw2rh2vk0dk8e4gg5g373g0vz07r",
    "bc1q8ew45w2agdffrnwp6adt2gqrc9n4mkev9ns29c",
    "bc1q9lvynkfpaw330uhqmunzdz6gmafsvapv7y3zty",
    "bc1qagp0gy58v8hqvw4p2wsphcxg067rrppp45hexr",
    "bc1qardcxz845jw83vgfvcmewhuxa0ag9gchjwmcfd",
    "bc1qdpazd6smrkq5hmw6lupq98za2fqtgmq3azv3av",
    "bc1qdt3gml5z5n50y5hm04u2yjdphefkm0fl2zdj68",
    "bc1qfg4gfg0y6t6xjnpmlhuwx5k0wlw6nmfzxn2psc",
    "bc1ql7dlyh8xz6tpqk92vztrhqh88dmjvcwrmsemrm",
    "bc1qn6segn8km4nfdp9vueu6msfjsaxaqgun9h60n9",
    "bc1qnykkrlk67f9kdqvzyw2ndu3xmef5z2e52886yl",
    "bc1qpaly5nm7pfka9v92d6qvl4fc2l9xzee8a6ys3s",
    "bc1qsxf77cvwcd6jv6j8d8j3uhh4g0xqw4meswmwuc",
    "bc1qtdupwe722vcc5e0vh94cgwfs0ep4gzwyfsf75q",
    "bc1qte9ret332gwrk6e7vqc87d807npzvdj5savg4h",
    "bc1qtrrfhr0f3ufsrjxfv8a7p3yuqj0spe4cm6vaws",
    "bc1qtsl3ufenrv3zgrgm9z8xarcx22x8mfztuartyn",
    "bc1qu5vngdtcx8nc9d68pq8nv7pzcjrswsy87s66gk",
    "bc1qv4krhj2qmpd9qz9xj9nhvj99fq8s9xsw05d485",
    "bc1qv7k70u2zynvem59u88ctdlaw7hc735d8xep9rq",
    "bc1qvhnfknw852ephxyc5hm4q520zmvf9maphetc9z",
    "bc1qw4cxpe6sxa5dg6sdwxjph959cw6yztrzl4r54s",
    "bc1qw8evftpgc8wsmkemd8yl5fg2husza5z802xaym",
    "bc1qwz0l2ceddckwdy5rh6zyrm3x4ha6gn5f2da5zg",
    "bc1qx3e2axj3wsfn0ndtvlwmkghmmgm4583nqg8ngk",
    "bc1qx9upga7f09tsetqf78wa3qrmcjar58mkwz6ng6",
    "qpf2cphc5dkuclkqur7lhj2yuqq9pk3hmukle77vhq",
    "qzjv8hrdvz6edu4gkzpnd4w6jc7zf296g5e9kkq4lx",
    "bc1q86tl9255vg5wldamfymaaz36uqxzm30gs7fhkljvzdlt9t38s3lqgdwdfq",
    "bc1q90zrdysy4flyacw7hsury3ajs9yzwtwp6guqpypx94w0d3p58hysvz6pde",
    "bc1qkfqh5p2qsakseg5gnwen6zh5xf3elmku2xaup29mw3l0wnncy3es880dss",
    "bc1qq7p0es3dv5hcynjjf40f2xjjr6qp5py47d2f6n847vduuq9gvnyq7y9ecd",
    "bc1qw7vfgv3r5vnehafl0y95sclg3uqsj87wxs9ad628yjjcq33cwessr6ndyw",
    "5be5543ff73456ab9f2d207887e2af87322c651ea1a873c5b25b7ffae456c320",
    "49HqitRzdnhYjgTEAhgGpCfsjdTeMbUTU6cyR4JV1R7k2Eej9rGT8JpFiYDa4tZM6RZiFrHmMzgSrhHEqpDYKBe5B2ufNsL",
    "884Bz8UH63aYsjVdkfWfScRYWZGGNbjFL7pztqvWNSrtYT4reFSwyvkCj9KEGUtheHhhMUj87ciTBFyzoesrMJ4L1FvSoxL"
  ])
);
function c(C, e, T) {
  var $ = this, V = useRef(null), J = useRef(0), ee = useRef(null), te = useRef([]), re = useRef(), ie = useRef(), se = useRef(C), de = useRef(!0);
  useEffect(function() {
    se.current = C;
  }, [C]);
  var ue = !e && e !== 0 && typeof window < "u";
  if (typeof C != "function") throw new TypeError("Expected a function");
  e = +e || 0;
  var fe = !!(T = T || {}).leading, he = !("trailing" in T) || !!T.trailing, me = "maxWait" in T, xe = me ? Math.max(+T.maxWait || 0, e) : null;
  useEffect(function() {
    return de.current = !0, function() {
      de.current = !1;
    };
  }, []);
  var ve = useMemo(function() {
    var Te = function(_e) {
      var De = te.current, Fe = re.current;
      return te.current = re.current = null, J.current = _e, ie.current = se.current.apply(Fe, De);
    }, we = function(_e, De) {
      ue && cancelAnimationFrame(ee.current), ee.current = ue ? requestAnimationFrame(_e) : setTimeout(_e, De);
    }, Ee = function(_e) {
      if (!de.current) return !1;
      var De = _e - V.current;
      return !V.current || De >= e || De < 0 || me && _e - J.current >= xe;
    }, Me = function(_e) {
      return ee.current = null, he && te.current ? Te(_e) : (te.current = re.current = null, ie.current);
    }, Ie = function _e() {
      var De = Date.now();
      if (Ee(De)) return Me(De);
      if (de.current) {
        var Fe = e - (De - V.current), Ae = me ? Math.min(Fe, xe - (De - J.current)) : Fe;
        we(_e, Ae);
      }
    }, ke = function() {
      var _e = Date.now(), De = Ee(_e);
      if (te.current = [].slice.call(arguments), re.current = $, V.current = _e, De) {
        if (!ee.current && de.current) return J.current = V.current, we(Ie, e), fe ? Te(V.current) : ie.current;
        if (me) return we(Ie, e), Te(V.current);
      }
      return ee.current || we(Ie, e), ie.current;
    };
    return ke.cancel = function() {
      ee.current && (ue ? cancelAnimationFrame(ee.current) : clearTimeout(ee.current)), J.current = 0, te.current = V.current = re.current = ee.current = null;
    }, ke.isPending = function() {
      return !!ee.current;
    }, ke.flush = function() {
      return ee.current ? Me(Date.now()) : ie.current;
    }, ke;
  }, [fe, me, e, xe, he, ue]);
  return ve;
}
function i(C, e) {
  return C === e;
}
function a(C) {
  return typeof C == "function" ? function() {
    return C;
  } : C;
}
function o$1(C, e, T) {
  var $, V, J = i, ee = ($ = useState(a(C)), V = $[1], [$[0], useCallback(function(de) {
    return V(a(de));
  }, [])]), te = ee[0], re = ee[1], ie = c(useCallback(function(de) {
    return re(de);
  }, [re]), e, T), se = useRef(C);
  return J(se.current, C) || (ie(C), se.current = C), [te, ie];
}
const validateFromChain = (C) => !C || !config$1.chains[C] ? "Select a source chain" : "", validateToChain = (C, e) => {
  if (!C || !config$1.chains[C]) return "Select a destination chain";
  if (e && C === e)
    return "Source chain and destination chain cannot be the same";
  if (config$1.ui.defaultInputs && config$1.ui.defaultInputs.requiredChain && C && e) {
    const { requiredChain: $ } = config$1.ui.defaultInputs, V = config$1.chains[$];
    if (V && C !== $ && e !== $)
      return `Must select ${V.displayName} as either the source or destination chain`;
  }
  return "";
}, validateToken = (C, e) => {
  if (!C) return "Select an asset";
  const T = config$1.tokens[C];
  if (!T) return "Select an asset";
  if (e) {
    if (!config$1.chains[e] || T.tokenId) return "";
    if (!T.tokenId && T.nativeChain !== e)
      return `${C} not available on ${e}, select a different token`;
  }
  return "";
}, validateDestToken = (C, e, T) => {
  if (!C) return "Select an asset";
  const $ = config$1.tokens[C];
  if (!$) return "Select an asset";
  if (e) {
    if (!config$1.chains[e] || $.tokenId) return "";
    if (!$.tokenId && $.nativeChain !== e)
      return `${C} not available on ${e}, select a different token`;
  }
  return T.some((V) => V.key === C) ? "" : "No route available for this token, please select another";
}, validateAmount = (C, e) => {
  if (!C) return "";
  const T = units(C);
  if (T === 0n)
    return "Amount must be greater than 0";
  if (e) {
    const $ = units(e);
    if (T > $)
      return "Amount exceeds available balance";
  }
  return "";
}, checkAddressIsSanctioned = (C) => SANCTIONED_WALLETS.has(C) || SANCTIONED_WALLETS.has("0x" + C), validateWallet = async (C, e) => {
  if (!C.address) return "Wallet not connected";
  try {
    if (checkAddressIsSanctioned(C.address))
      return "This address is sanctioned, bridging is not available";
  } catch ($) {
    console.error($);
  }
  if (C.currentAddress && C.currentAddress !== C.address)
    return "Switch to connected wallet";
  const T = walletAcceptedChains(C.type);
  return e && !T.includes(e) ? `Connected wallet is not supported for ${e}` : "";
}, validateToNativeAmt = (C, e) => C < 0 ? "Amount must be equal to or greater than zero" : e && C > e ? "Amount exceeds maximum amount" : "", getIsAutomatic = (C) => {
  if (!C) return !1;
  const e = config$1.routes.get(C);
  return e ? e.AUTOMATIC_DEPOSIT : !1;
}, validateAll = async (C, e, T) => {
  const {
    fromChain: $,
    toChain: V,
    token: J,
    destToken: ee,
    amount: te,
    balances: re,
    route: ie,
    supportedDestTokens: se
  } = C, { maxSwapAmt: de, toNativeToken: ue } = e, { sending: fe, receiving: he } = T, me = getIsAutomatic(ie), xe = accessBalance(
    re,
    fe.address,
    $,
    J
  ), ve = {
    sendingWallet: await validateWallet(fe, $),
    receivingWallet: await validateWallet(he, V),
    fromChain: validateFromChain($),
    toChain: validateToChain(V, $),
    token: validateToken(J, $),
    destToken: validateDestToken(ee, V, se),
    amount: validateAmount(te, (xe == null ? void 0 : xe.balance) || null),
    toNativeToken: "",
    relayerFee: "",
    receiveAmount: ""
  };
  return me ? ie === "AutomaticNtt" ? ve : {
    ...ve,
    toNativeToken: validateToNativeAmt(ue, de)
  } : ve;
}, isTransferValid = (C) => {
  for (const e of Object.values(C))
    if (e)
      return !1;
  return !0;
}, validate = async ({
  transferInput: C,
  relay: e,
  wallet: T
}, $, V) => {
  const J = await validateAll(C, e, T), ee = T.sending.address && T.receiving.address && C.fromChain && C.toChain && C.token && C.destToken && C.amount;
  V() || $(
    setValidations({
      validations: J,
      showValidationState: !!ee
    })
  );
}, VALIDATION_DELAY_MS = 250, useValidate = () => {
  const C = useDispatch(), e = useSelector((ee) => ee.transferInput), T = useSelector((ee) => ee.relay), $ = useSelector((ee) => ee.wallet), V = useMemo(
    () => ({ transferInput: e, relay: T, wallet: $ }),
    [e, T, $]
  ), [J] = o$1(
    V,
    VALIDATION_DELAY_MS
  );
  useEffect(() => {
    let ee = !1;
    return validate(J, C, () => ee), () => {
      ee = !0;
    };
  }, [J, C]);
}, minutesAndSecondsWithPadding = (C, e) => {
  const T = C.toString().padStart(2, "0"), $ = e.toString().padStart(2, "0");
  return `${T}:${$}`;
}, millisToMinutesAndSeconds = (C) => {
  const e = Math.floor(C / 6e4), T = Math.floor(C % 6e4 / 1e3);
  return minutesAndSecondsWithPadding(e, T);
};
var Search = {}, _interopRequireDefault$a = interopRequireDefaultExports;
Object.defineProperty(Search, "__esModule", {
  value: !0
});
var default_1$a = Search.default = void 0, _createSvgIcon$a = _interopRequireDefault$a(requireCreateSvgIcon()), _jsxRuntime$a = jsxRuntimeExports;
default_1$a = Search.default = (0, _createSvgIcon$a.default)(/* @__PURE__ */ (0, _jsxRuntime$a.jsx)("path", {
  d: "M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14"
}), "Search");
var Close = {}, _interopRequireDefault$9 = interopRequireDefaultExports;
Object.defineProperty(Close, "__esModule", {
  value: !0
});
var default_1$9 = Close.default = void 0, _createSvgIcon$9 = _interopRequireDefault$9(requireCreateSvgIcon()), _jsxRuntime$9 = jsxRuntimeExports;
default_1$9 = Close.default = (0, _createSvgIcon$9.default)(/* @__PURE__ */ (0, _jsxRuntime$9.jsx)("path", {
  d: "M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
}), "Close");
var ErrorOutline = {}, _interopRequireDefault$8 = interopRequireDefaultExports;
Object.defineProperty(ErrorOutline, "__esModule", {
  value: !0
});
var default_1$8 = ErrorOutline.default = void 0, _createSvgIcon$8 = _interopRequireDefault$8(requireCreateSvgIcon()), _jsxRuntime$8 = jsxRuntimeExports;
default_1$8 = ErrorOutline.default = (0, _createSvgIcon$8.default)(/* @__PURE__ */ (0, _jsxRuntime$8.jsx)("path", {
  d: "M11 15h2v2h-2zm0-8h2v6h-2zm.99-5C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2M12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8"
}), "ErrorOutline");
const useStyles$t = makeStyles()((C) => ({
  container: {
    width: "100%",
    display: "flex",
    flexDirection: "row",
    alignItems: "flex-start",
    justifyContent: "flex-start",
    gap: "8px"
  }
}));
function AlertBanner(C) {
  const { classes: e } = useStyles$t(), T = useTheme$1();
  let $;
  return C.color ? $ = C.color : C.warning ? $ = T.palette.warning.main : C.error && ($ = T.palette.error.main), /* @__PURE__ */ jsxRuntimeExports.jsx(
    Collapse,
    {
      className: C.className,
      in: C.show && !!C.content,
      unmountOnExit: !0,
      children: /* @__PURE__ */ jsxRuntimeExports.jsxs(
        "div",
        {
          className: e.container,
          style: C.style || {},
          "data-testid": C.testId,
          children: [
            /* @__PURE__ */ jsxRuntimeExports.jsx(
              default_1$8,
              {
                fontSize: "small",
                htmlColor: $,
                sx: { paddingTop: "2px" }
              }
            ),
            /* @__PURE__ */ jsxRuntimeExports.jsx(Typography, { color: $, fontSize: 14, children: C.content })
          ]
        }
      )
    }
  );
}
const FAILED_TO_LOAD_ERR = "Failed to load wallets. Please refresh and try again.", useAvailableWallets = (C) => {
  const { chain: e, supportedChains: T } = C, [$, V] = useState(
    {
      state: "loading"
    }
  );
  return useEffect(() => {
    let J = !1;
    async function ee() {
      if (!e)
        return [];
      const te = config$1.chains[e];
      return te && T.has(te.context) ? await getWalletOptions(te) : [];
    }
    return (async () => {
      try {
        const te = await ee();
        !J && te && V({
          state: "result",
          options: te
        });
      } catch (te) {
        console.error(`Error loading wallet options for ${e}: ${te}`), V({ state: "error", error: FAILED_TO_LOAD_ERR });
      }
    })(), () => {
      J = !0;
    };
  }, [e, T]), {
    walletOptionsResult: $
  };
}, useStyles$s = makeStyles()((C, { size: e }) => ({
  container: {
    height: e,
    width: e,
    ...CENTER
  },
  icon: {
    maxHeight: "100%",
    maxWidth: "100%"
  }
}));
function WalletIcon(C) {
  const e = C.size || 32, { classes: T } = useStyles$s({ size: e }), { icon: $, name: V } = C;
  return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: T.container, children: $ && /* @__PURE__ */ jsxRuntimeExports.jsx("img", { className: T.icon, src: $, alt: V }) });
}
function isValidEvmAddress(C) {
  if (!C.startsWith("0x") || C.length !== 42 || !hex$1.valid(C))
    return !1;
  try {
    return getAddress(C), !0;
  } catch {
    return !1;
  }
}
async function isValidSolanaAddress(C) {
  try {
    const e = new PublicKey(C);
    if (config$1.rpcs.Solana) {
      const T = new Connection$1(config$1.rpcs.Solana);
      if ((await Promise.allSettled([
        getAccount(T, e, "finalized", TOKEN_PROGRAM_ID$3),
        getAccount(T, e, "finalized", TOKEN_2022_PROGRAM_ID$1)
      ])).some((V) => V.status === "fulfilled")) return !1;
    }
    return !0;
  } catch {
    return !1;
  }
}
function isValidAptosAddress(C) {
  return C.startsWith("0x") && C.length === 66 && hex$1.valid(C);
}
async function validateWalletAddress(C, e) {
  const T = chainToPlatform(C);
  switch (T) {
    case "Evm":
      if (!isValidEvmAddress(e)) return null;
      break;
    case "Solana":
      if (!await isValidSolanaAddress(e)) return null;
      break;
    case "Sui":
      if (!isValidSuiAddress(e)) return null;
      break;
    case "Aptos":
      if (!isValidAptosAddress(e)) return null;
      break;
    default:
      return console.warn(`Unsupported platform: ${T}`), null;
  }
  try {
    return toNative(C, e);
  } catch ($) {
    console.error(
      `Invalid address for chain ${C}: ${e}, error: ${$}`
    );
  }
  return null;
}
const useStyles$r = makeStyles()((C) => ({
  listButton: {
    display: "flex",
    flexDirection: "row",
    padding: "12px 16px"
  },
  drawer: {
    width: "360px"
  },
  notInstalled: {
    opacity: 0.6
  },
  title: {
    width: "100%",
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center"
  },
  smOnly: {
    display: "none",
    [C.breakpoints.down("sm")]: {
      display: "block"
    }
  },
  addressInputContainer: {
    display: "flex",
    flexDirection: "column",
    gap: "8px",
    width: "100%",
    padding: "16px"
  },
  submitButton: {
    width: "100%"
  }
})), WalletSidebar = (C) => {
  const e = useDispatch(), { classes: T } = useStyles$r(), { fromChain: $, toChain: V } = useSelector(
    (Te) => Te.transferInput
  ), [J, ee] = useState(""), [te, re] = useState(""), [ie, se] = useState(""), de = useMemo(() => {
    const Te = config$1.chainsArr.map((we) => we.context);
    return new Set(Te);
  }, []), ue = useMemo(
    () => C.type === TransferWallet.SENDING ? $ : V,
    [C.type, $, V]
  ), { walletOptionsResult: fe } = useAvailableWallets({
    chain: ue,
    supportedChains: de
  }), he = useCallback(
    async (Te) => {
      var we;
      ue && ((we = C.onClose) == null || we.call(C), await connectWallet(C.type, ue, Te, e));
    },
    [ue, C, e]
  ), me = useCallback(async () => {
    var Ie;
    if (!ue || !te) return;
    const Te = config$1.chains[ue];
    if (!Te) return;
    const we = await validateWalletAddress(ue, te);
    if (!we) {
      se("Invalid Address");
      return;
    }
    for (const ke of SANCTIONED_WALLETS)
      if (we.toString().toLowerCase() === ke.toLowerCase()) {
        se("Sanctioned Address");
        return;
      }
    const Ee = new ReadOnlyWallet(we, ue), Me = {
      name: Ee.getName(),
      type: Te.context,
      icon: Ee.getIcon(),
      isReady: !0,
      wallet: Ee
    };
    await connectWallet(
      TransferWallet.RECEIVING,
      ue,
      Me,
      e
    ), (Ie = C.onClose) == null || Ie.call(C);
  }, [te, ue, C.onClose]), xe = useCallback(
    (Te) => {
      const we = [...Te].sort((Me) => Me.isReady ? -1 : 1), Ee = J ? we.filter(
        ({ name: Me, type: Ie }) => [Me, Ie].some(
          (ke) => ke.toLowerCase().includes(J.toLowerCase())
        )
      ) : we;
      return /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children: Ee.length ? Ee.map((Me) => /* @__PURE__ */ jsxRuntimeExports.jsxs(
        ListItemButton,
        {
          className: T.listButton,
          dense: !0,
          onClick: () => Me.isReady ? he(Me) : window.open(Me.wallet.getUrl()),
          children: [
            /* @__PURE__ */ jsxRuntimeExports.jsx(ListItemIcon, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(WalletIcon, { name: Me.name, icon: Me.icon }) }),
            /* @__PURE__ */ jsxRuntimeExports.jsx(Typography, { component: "div", fontSize: 14, children: /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: `${!Me.isReady && T.notInstalled}`, children: [
              !Me.isReady && "Install",
              " ",
              Me.name
            ] }) })
          ]
        },
        Me.name
      )) : /* @__PURE__ */ jsxRuntimeExports.jsx(ListItem, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(Typography, { children: "No results" }) }) });
    },
    [T.listButton, T.notInstalled, he, J]
  ), ve = useMemo(() => {
    var Te;
    switch (fe.state) {
      case "loading":
        return /* @__PURE__ */ jsxRuntimeExports.jsx(CircularProgress, {});
      case "error":
        return /* @__PURE__ */ jsxRuntimeExports.jsx(AlertBanner, { error: !0, show: !0, content: fe.error });
      case "result":
        return !!((Te = fe.options) != null && Te.length) && /* @__PURE__ */ jsxRuntimeExports.jsxs(List, { children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(ListItem, { children: /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: T.title, children: [
            /* @__PURE__ */ jsxRuntimeExports.jsx(Typography, { component: "div", fontSize: 16, children: C.type === TransferWallet.RECEIVING ? "Select destination wallet" : "Connect a wallet" }),
            /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: T.smOnly, children: /* @__PURE__ */ jsxRuntimeExports.jsx(IconButton, { onClick: C.onClose, sx: { padding: 0 }, children: /* @__PURE__ */ jsxRuntimeExports.jsx(default_1$9, { sx: { height: "18px", width: "18px" } }) }) })
          ] }) }),
          /* @__PURE__ */ jsxRuntimeExports.jsx(ListItem, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(
            TextField,
            {
              fullWidth: !0,
              placeholder: "Search for a wallet",
              size: "small",
              variant: "outlined",
              value: J,
              onChange: (we) => ee(we.target.value),
              InputProps: {
                startAdornment: /* @__PURE__ */ jsxRuntimeExports.jsx(InputAdornment, { position: "start", children: /* @__PURE__ */ jsxRuntimeExports.jsx(default_1$a, {}) })
              }
            }
          ) }),
          xe(fe.options),
          C.showAddressInput && !J && /* @__PURE__ */ jsxRuntimeExports.jsxs(ListItem, { className: T.addressInputContainer, children: [
            /* @__PURE__ */ jsxRuntimeExports.jsx(
              TextField,
              {
                fullWidth: !0,
                placeholder: "Send to wallet address",
                size: "small",
                variant: "outlined",
                value: te,
                onChange: (we) => {
                  re(we.target.value), se("");
                },
                error: !!ie,
                helperText: ie
              }
            ),
            /* @__PURE__ */ jsxRuntimeExports.jsx(
              Button$2,
              {
                variant: "contained",
                color: "primary",
                onClick: me,
                disabled: !te,
                className: T.submitButton,
                children: "Submit"
              }
            )
          ] })
        ] });
      default:
        return /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, {});
    }
  }, [
    fe.state,
    fe.error,
    fe.options,
    T.title,
    T.smOnly,
    J,
    C.onClose,
    C.type,
    C.showAddressInput,
    xe,
    te,
    ie,
    me
  ]);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    Drawer,
    {
      anchor: "right",
      open: C.type && C.open,
      onClose: () => {
        var Te;
        return (Te = C.onClose) == null ? void 0 : Te.call(C);
      },
      children: /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: T.drawer, children: ve })
    }
  );
}, useStyles$q = makeStyles()((C) => ({
  connectWallet: {
    padding: "8px 16px",
    borderRadius: "8px",
    height: "48px",
    margin: "auto",
    maxWidth: "420px",
    width: "100%"
  },
  connected: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "8px",
    padding: "8px 16px",
    borderRadius: "8px",
    backgroundColor: C.palette.button.primary,
    cursor: "not-allowed",
    opacity: 0.7,
    margin: "auto",
    maxWidth: "420px",
    width: "100%"
  }
})), WalletConnector = (C) => {
  const { disabled: e = !1, type: T } = C, $ = useTheme$1(), { classes: V } = useStyles$q(), J = useMediaQuery($.breakpoints.down("sm")), ee = useSelector((ue) => ue.wallet[T]), [te, re] = useState(!1), ie = useCallback(
    async (ue) => {
      e || (ue == null || ue.close(), re(!0));
    },
    [e]
  ), se = useMemo(() => ee != null && ee.address ? /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: V.connected, children: `Connected to ${displayWalletAddress(
    ee.type,
    ee.address
  )}` }) : null, [V.connected, ee.address, ee.type]), de = useMemo(() => {
    const ue = /* @__PURE__ */ jsxRuntimeExports.jsx("span", { style: { width: "100%" }, children: /* @__PURE__ */ jsxRuntimeExports.jsx(
      Button,
      {
        variant: "primary",
        className: V.connectWallet,
        "data-testid": `${C.side}-section-connect-wallet-button`,
        disabled: e,
        sx: {
          "&:disabled": {
            cursor: "not-allowed",
            pointerEvents: "all !important"
          }
        },
        onClick: () => ie(),
        children: /* @__PURE__ */ jsxRuntimeExports.jsx(Typography, { textTransform: "none", children: J ? C.side === "source" ? "Connect" : "Select wallet" : `${C.side === "source" ? "Connect" : "Select"} ${C.side} wallet` })
      }
    ) });
    return e ? /* @__PURE__ */ jsxRuntimeExports.jsx(Tooltip, { title: `Please select a ${C.side} network`, children: ue }) : /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
      ue,
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        WalletSidebar,
        {
          open: te,
          type: C.type,
          onClose: () => {
            re(!1);
          },
          showAddressInput: C.type === TransferWallet.RECEIVING
        }
      )
    ] });
  }, [
    e,
    te,
    J,
    C.side,
    C.type,
    V.connectWallet,
    ie
  ]);
  return ee && ee.address ? se : de;
};
function useEvent(C) {
  if (typeof window > "u")
    return C;
  const e = React$1.useRef(null);
  return React$1.useLayoutEffect(() => {
    e.current = C;
  }), React$1.useCallback((...T) => {
    var $;
    ($ = e.current) === null || $ === void 0 || $.call(e, ...T);
  }, []);
}
const printedWarnings = {};
function warn(C, e) {
  printedWarnings[C] || (printedWarnings[C] = !0, console.error("[material-ui-popup-state] WARNING", e));
}
const initCoreState = {
  isOpen: !1,
  setAnchorElUsed: !1,
  anchorEl: void 0,
  anchorPosition: void 0,
  hovered: !1,
  focused: !1,
  _openEventType: null,
  _childPopupState: null,
  _deferNextOpen: !1,
  _deferNextClose: !1
}, _react = React$1, defaultPopupId = "useId" in _react ? () => _react.useId() : (
  // istanbul ignore next
  () => {
  }
);
function usePopupState({
  parentPopupState: C,
  popupId: e = defaultPopupId(),
  variant: T,
  disableAutoFocus: $
}) {
  const V = useRef(!0);
  useEffect(() => (V.current = !0, () => {
    V.current = !1;
  }), []);
  const [J, ee] = useState(initCoreState), te = useCallback((Te) => {
    V.current && ee(Te);
  }, []), re = useCallback((Te) => te((we) => ({
    ...we,
    setAnchorElUsed: !0,
    anchorEl: Te ?? void 0
  })), []), ie = useEvent((Te) => (J.isOpen ? ue(Te) : se(Te), J)), se = useEvent((Te) => {
    const we = Te instanceof Element ? void 0 : Te, Ee = Te instanceof Element ? Te : (Te == null ? void 0 : Te.currentTarget) instanceof Element ? Te.currentTarget : void 0;
    if ((we == null ? void 0 : we.type) === "touchstart") {
      te((De) => ({
        ...De,
        _deferNextOpen: !0
      }));
      return;
    }
    const Me = we == null ? void 0 : we.clientX, Ie = we == null ? void 0 : we.clientY, ke = typeof Me == "number" && typeof Ie == "number" ? {
      left: Me,
      top: Ie
    } : void 0, _e = (De) => {
      if (!Te && !De.setAnchorElUsed && T !== "dialog" && warn("missingEventOrAnchorEl", "eventOrAnchorEl should be defined if setAnchorEl is not used"), C) {
        if (!C.isOpen) return De;
        setTimeout(() => C._setChildPopupState(ve));
      }
      const Fe = {
        ...De,
        isOpen: !0,
        anchorPosition: ke,
        hovered: (we == null ? void 0 : we.type) === "mouseover" || De.hovered,
        focused: (we == null ? void 0 : we.type) === "focus" || De.focused,
        _openEventType: we == null ? void 0 : we.type
      };
      return De.setAnchorElUsed || (we != null && we.currentTarget ? Fe.anchorEl = we == null ? void 0 : we.currentTarget : Ee && (Fe.anchorEl = Ee)), Fe;
    };
    te((De) => De._deferNextOpen ? (setTimeout(() => te(_e), 0), {
      ...De,
      _deferNextOpen: !1
    }) : _e(De));
  }), de = (Te) => {
    const {
      _childPopupState: we
    } = Te;
    return setTimeout(() => {
      we == null || we.close(), C == null || C._setChildPopupState(null);
    }), {
      ...Te,
      isOpen: !1,
      hovered: !1,
      focused: !1
    };
  }, ue = useEvent((Te) => {
    const we = Te instanceof Element ? void 0 : Te;
    if ((we == null ? void 0 : we.type) === "touchstart") {
      te((Ee) => ({
        ...Ee,
        _deferNextClose: !0
      }));
      return;
    }
    te((Ee) => Ee._deferNextClose ? (setTimeout(() => te(de), 0), {
      ...Ee,
      _deferNextClose: !1
    }) : de(Ee));
  }), fe = useCallback((Te, we) => {
    Te ? se(we) : ue(we);
  }, []), he = useEvent((Te) => {
    const {
      relatedTarget: we
    } = Te;
    te((Ee) => Ee.hovered && !(we instanceof Element && isElementInPopup(we, ve)) ? Ee.focused ? {
      ...Ee,
      hovered: !1
    } : de(Ee) : Ee);
  }), me = useEvent((Te) => {
    if (!Te) return;
    const {
      relatedTarget: we
    } = Te;
    te((Ee) => Ee.focused && !(we instanceof Element && isElementInPopup(we, ve)) ? Ee.hovered ? {
      ...Ee,
      focused: !1
    } : de(Ee) : Ee);
  }), xe = useCallback((Te) => te((we) => ({
    ...we,
    _childPopupState: Te
  })), []), ve = {
    ...J,
    setAnchorEl: re,
    popupId: e ?? void 0,
    variant: T,
    open: se,
    close: ue,
    toggle: ie,
    setOpen: fe,
    onBlur: me,
    onMouseLeave: he,
    disableAutoFocus: $ ?? !!(J.hovered || J.focused),
    _setChildPopupState: xe
  };
  return ve;
}
function controlAriaProps({
  isOpen: C,
  popupId: e,
  variant: T
}) {
  return {
    ...T === "popover" ? {
      "aria-haspopup": !0,
      "aria-controls": C ? e : void 0
    } : T === "popper" ? {
      "aria-describedby": C ? e : void 0
    } : void 0
  };
}
function bindTrigger(C) {
  return {
    ...controlAriaProps(C),
    onClick: C.open,
    onTouchStart: C.open
  };
}
function bindPopover({
  isOpen: C,
  anchorEl: e,
  anchorPosition: T,
  close: $,
  popupId: V,
  onMouseLeave: J,
  disableAutoFocus: ee,
  _openEventType: te
}) {
  return {
    id: V,
    anchorEl: e,
    anchorPosition: T,
    anchorReference: te === "contextmenu" ? "anchorPosition" : "anchorEl",
    open: C,
    onClose: $,
    onMouseLeave: J,
    ...ee && {
      disableAutoFocus: !0,
      disableEnforceFocus: !0,
      disableRestoreFocus: !0
    }
  };
}
function getPopup(C, {
  popupId: e
}) {
  if (!e) return null;
  const T = typeof C.getRootNode == "function" ? C.getRootNode() : document;
  return typeof T.getElementById == "function" ? T.getElementById(e) : null;
}
function isElementInPopup(C, e) {
  const {
    anchorEl: T,
    _childPopupState: $
  } = e;
  return isAncestor(T, C) || isAncestor(getPopup(C, e), C) || $ != null && isElementInPopup(C, $);
}
function isAncestor(C, e) {
  if (!C) return !1;
  for (; e; ) {
    if (e === C) return !0;
    e = e.parentElement;
  }
  return !1;
}
var ExpandMore = {}, _interopRequireDefault$7 = interopRequireDefaultExports;
Object.defineProperty(ExpandMore, "__esModule", {
  value: !0
});
var default_1$7 = ExpandMore.default = void 0, _createSvgIcon$7 = _interopRequireDefault$7(requireCreateSvgIcon()), _jsxRuntime$7 = jsxRuntimeExports;
default_1$7 = ExpandMore.default = (0, _createSvgIcon$7.default)(/* @__PURE__ */ (0, _jsxRuntime$7.jsx)("path", {
  d: "M16.59 8.59 12 13.17 7.41 8.59 6 10l6 6 6-6z"
}), "ExpandMore");
var ExpandLess = {}, _interopRequireDefault$6 = interopRequireDefaultExports;
Object.defineProperty(ExpandLess, "__esModule", {
  value: !0
});
var default_1$6 = ExpandLess.default = void 0, _createSvgIcon$6 = _interopRequireDefault$6(requireCreateSvgIcon()), _jsxRuntime$6 = jsxRuntimeExports;
default_1$6 = ExpandLess.default = (0, _createSvgIcon$6.default)(/* @__PURE__ */ (0, _jsxRuntime$6.jsx)("path", {
  d: "m12 8-6 6 1.41 1.41L12 10.83l4.59 4.58L18 14z"
}), "ExpandLess");
function GLMR$1() {
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(
    "svg",
    {
      width: "36",
      height: "36",
      viewBox: "0 0 36 36",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx("rect", { width: "36", height: "36", rx: "6", fill: "white" }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "path",
          {
            d: "M29.8809 18.0146C29.8809 11.5195 24.5917 6.25427 18.0682 6.25427C11.5446 6.25427 6.25415 11.5195 6.25415 18.0146C6.25415 19.3574 6.4807 20.6472 6.89662 21.8493C6.8992 21.8547 6.92193 21.9236 6.92193 21.9236C7.08986 22.4557 6.25673 22.664 6.25673 22.9825C6.25673 23.4814 8.01354 23.4138 8.01354 23.9936C8.01354 24.4992 6.27541 24.6558 6.27541 25.1652C6.27541 25.8699 10.1237 25.6244 10.173 26.2294C10.2104 26.6965 8.84943 26.7257 8.84142 27.2246C8.82808 28.0221 14.0933 27.7607 14.0933 28.2914C14.0933 28.6935 11.6979 28.5475 11.6979 29.0226C11.6979 29.4976 14.8504 29.7975 18.3254 29.7975C21.8005 29.7975 24.1971 29.4127 24.1971 28.9973C24.1971 28.582 21.9604 28.667 22.0071 28.2927C22.087 27.6386 27.0523 27.973 27.0523 27.2153C27.0523 26.8159 25.6874 26.723 25.7314 26.2931C25.7941 25.6854 29.8809 25.7756 29.8809 25.1441C29.8809 24.6478 27.8548 24.5257 27.8588 24.0095C27.8615 23.4827 29.8809 23.5054 29.8675 23.0117C29.8569 22.6322 28.9638 22.6415 29.2437 21.8374C29.668 20.6075 29.8843 19.3155 29.8835 18.0146H29.8809ZM26.1273 21.3544C25.7167 22.2793 24.7943 22.0935 24.6903 22.4823C24.5824 22.8843 25.8274 22.9427 25.8274 23.3633C25.8274 23.8742 22.0324 23.6698 22.0697 24.3439C22.0938 24.7685 24.765 24.8401 24.7143 25.2833C24.641 25.9256 20.5755 25.6045 20.5355 26.2202C20.5062 26.6713 22.5203 26.6872 22.5243 27.0986C22.5283 27.4449 20.9434 27.6333 17.9069 27.6333C14.4492 27.6333 12.767 27.4476 12.9589 27.0614C13.1376 26.7005 16.1994 26.7669 16.1687 26.1989C16.1381 25.6324 10.7316 25.7982 10.5689 25.2475C10.433 24.7898 12.3457 24.6955 12.3338 24.2603C12.3217 23.8171 9.88509 23.918 9.83181 23.3806C9.79712 23.0289 11.1048 23.0502 11.0488 22.607C11.0074 22.2845 10.4676 22.3296 10.1477 21.6649C9.61569 20.5211 9.3404 19.2747 9.34118 18.0133C9.34118 13.2152 13.2495 9.32477 18.0695 9.32477C22.8895 9.32477 26.7977 13.2152 26.7977 18.0133C26.7977 19.1969 26.5591 20.3248 26.1286 21.3531L26.1273 21.3544Z",
            fill: "black"
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M6.89666 21.8493C6.48075 20.6472 6.25419 19.3574 6.25419 18.0145C6.25419 11.5194 11.5447 6.25422 18.0682 6.25422C24.5917 6.25422 29.8809 11.5194 29.8809 18.0145H29.8836C29.8843 19.3155 29.6681 20.6075 29.2438 21.8373C29.0703 22.336 29.3477 22.5218 29.586 22.6816C29.7321 22.7794 29.8635 22.8675 29.8676 23.0117C29.8742 23.2549 29.387 23.3728 28.8909 23.4929C28.3803 23.6164 27.8602 23.7424 27.8588 24.0095C27.8569 24.2703 28.373 24.4304 28.8843 24.5891C29.385 24.7445 29.8809 24.8984 29.8809 25.144C29.8809 25.4639 28.8325 25.5986 27.7896 25.7326C26.7734 25.8633 25.7624 25.9932 25.7315 26.293C25.7088 26.514 26.0584 26.646 26.4035 26.7762C26.7299 26.8995 27.0524 27.0212 27.0524 27.2153C27.0524 27.6089 25.7124 27.7078 24.4135 27.8036C23.212 27.8923 22.0455 27.9784 22.0071 28.2927C21.9843 28.4758 22.5077 28.5489 23.0486 28.6245C23.6134 28.7035 24.1972 28.7851 24.1972 28.9973C24.1972 29.4126 21.8005 29.7975 18.3255 29.7975C14.8504 29.7975 11.698 29.4976 11.698 29.0225C11.698 28.7751 12.3478 28.6961 12.9704 28.6205C13.5434 28.5509 14.0933 28.484 14.0933 28.2914C14.0933 28.053 13.0312 27.9745 11.8623 27.8879C10.4285 27.7818 8.83415 27.6639 8.84146 27.2246C8.84542 26.9732 9.19283 26.8411 9.53179 26.7121C9.86577 26.5851 10.1916 26.4612 10.1731 26.2293C10.1494 25.939 9.25084 25.8445 8.32243 25.7469C7.31646 25.6411 6.27554 25.5317 6.27554 25.1652C6.27554 24.91 6.71169 24.7432 7.14715 24.5769C7.5808 24.4113 8.01367 24.2458 8.01367 23.9935C8.01367 23.6928 7.54086 23.5662 7.08577 23.4444C6.66366 23.3314 6.25686 23.2225 6.25686 22.9825C6.25686 22.8523 6.39587 22.7406 6.549 22.6176C6.77056 22.4397 7.0213 22.2383 6.92197 21.9236C6.92197 21.9236 6.89933 21.8546 6.89666 21.8493ZM6.83176 21.9528C6.86499 22.0584 6.84898 22.1443 6.80585 22.223C6.76023 22.3063 6.6832 22.3829 6.59127 22.4606C6.56131 22.4859 6.52843 22.5123 6.49512 22.5392C6.43315 22.589 6.36928 22.6404 6.31866 22.689C6.24085 22.7639 6.16201 22.8609 6.16201 22.9825C6.16201 23.0764 6.20453 23.1531 6.26607 23.2132C6.32581 23.2718 6.40612 23.3178 6.49305 23.3562C6.65247 23.4268 6.85888 23.482 7.05943 23.5356L7.11074 23.5494C7.33229 23.6089 7.54206 23.6681 7.69657 23.7459C7.85478 23.8257 7.9189 23.9062 7.9189 23.9935C7.9189 24.0271 7.90513 24.0633 7.86812 24.1052C7.83024 24.1479 7.77214 24.1915 7.69485 24.2359C7.53974 24.3252 7.3304 24.4053 7.11082 24.4892L7.10798 24.4903C6.89382 24.5721 6.66985 24.6577 6.49968 24.7561C6.41395 24.8057 6.33614 24.8616 6.27907 24.9266C6.22105 24.9925 6.18068 25.0721 6.18068 25.1652C6.18068 25.3039 6.277 25.4022 6.39295 25.4703C6.51061 25.5395 6.67218 25.5926 6.85578 25.636C7.22427 25.7232 7.71318 25.7781 8.19581 25.829L8.31141 25.8412C8.75763 25.8881 9.19111 25.9338 9.52482 26C9.70653 26.0362 9.85157 26.0772 9.95064 26.1245C10.0558 26.1748 10.0769 26.2163 10.0786 26.2371C10.0835 26.298 10.0468 26.3596 9.93187 26.4311C9.81903 26.5014 9.66237 26.5609 9.49134 26.626L9.49056 26.6262C9.3247 26.6894 9.14548 26.7577 9.00794 26.8438C8.87185 26.9289 8.74954 27.0485 8.7467 27.223C8.74403 27.3829 8.87417 27.4904 9.02145 27.5628C9.17561 27.6387 9.3902 27.6978 9.63827 27.7463C10.1363 27.8434 10.7986 27.9023 11.4552 27.9527C11.5897 27.9629 11.7241 27.9729 11.8568 27.9827C12.3748 28.021 12.8686 28.0576 13.259 28.1071C13.5046 28.1383 13.7033 28.1739 13.8388 28.2165C13.9071 28.2379 13.9527 28.2591 13.9793 28.2781C13.9898 28.2856 13.9951 28.291 13.9976 28.2941C13.9964 28.2962 13.9951 28.2981 13.9935 28.2999C13.9865 28.3084 13.972 28.3208 13.9453 28.3352C13.8916 28.3643 13.8084 28.3911 13.6984 28.4158C13.4974 28.4608 13.2335 28.4929 12.9579 28.5264L12.8842 28.5353C12.5863 28.5717 12.2801 28.6112 12.0481 28.6726C11.9326 28.7032 11.8276 28.741 11.7496 28.7914C11.6718 28.8416 11.6032 28.9165 11.6032 29.0225C11.6032 29.1379 11.6966 29.2189 11.7929 29.2745C11.8964 29.3342 12.0424 29.3874 12.22 29.4356C12.577 29.5324 13.0854 29.6151 13.6982 29.6825C14.9252 29.8173 16.5858 29.8923 18.3255 29.8923C20.0659 29.8923 21.5385 29.796 22.5779 29.6471C23.0968 29.5727 23.5116 29.4847 23.7988 29.3875C23.9417 29.3391 24.0585 29.2866 24.1415 29.2289C24.2206 29.1739 24.2919 29.0977 24.2919 28.9973C24.2919 28.8963 24.2227 28.8272 24.1514 28.7826C24.0783 28.7369 23.9803 28.7019 23.8731 28.673C23.6573 28.6148 23.3728 28.5741 23.0978 28.5356L23.0647 28.5309C22.7976 28.4936 22.5419 28.4579 22.3527 28.4102C22.2535 28.3852 22.1811 28.3589 22.1368 28.3321C22.115 28.3189 22.1055 28.3088 22.102 28.3038L22.1014 28.3028C22.1029 28.2936 22.1096 28.2773 22.1373 28.2544C22.1669 28.2299 22.2138 28.204 22.2808 28.1784C22.4144 28.1272 22.6067 28.0848 22.8434 28.0488C23.2792 27.9825 23.8438 27.9409 24.4216 27.8982L24.5668 27.8875C25.1912 27.8411 25.8197 27.7912 26.2923 27.7047C26.5279 27.6616 26.7321 27.6081 26.8795 27.538C27.0203 27.4711 27.1472 27.37 27.1472 27.2153C27.1472 27.1357 27.1125 27.0689 27.0644 27.0152C27.0173 26.9626 26.9541 26.9186 26.8863 26.8803C26.7595 26.8091 26.5955 26.7472 26.4394 26.6883L26.4089 26.6768C26.2389 26.6126 26.0816 26.5513 25.9691 26.4816C25.8517 26.4089 25.8208 26.351 25.8257 26.3028C25.828 26.2813 25.8535 26.2364 25.9689 26.1806C26.0766 26.1286 26.2328 26.0816 26.4267 26.0387C26.8042 25.955 27.3008 25.8912 27.8047 25.8264L27.8418 25.8216C28.355 25.7557 28.8731 25.6882 29.263 25.597C29.4572 25.5515 29.6267 25.4987 29.7495 25.4338C29.8659 25.3721 29.9757 25.2804 29.9757 25.144C29.9757 25.0463 29.9251 24.9668 29.8586 24.9046C29.7927 24.8428 29.7033 24.7904 29.6047 24.744C29.4128 24.6537 29.1608 24.5756 28.9163 24.4997L28.8965 24.4935C28.6413 24.4144 28.396 24.3373 28.2144 24.2493C28.1236 24.2053 28.0552 24.1615 28.0108 24.1181C27.967 24.0755 27.9533 24.0404 27.9536 24.0102V24.01C27.9538 23.9784 27.968 23.9445 28.0104 23.9057C28.0542 23.8655 28.1219 23.8264 28.2124 23.7883C28.3934 23.7121 28.6376 23.6519 28.8915 23.5904L28.917 23.5842C29.1582 23.5259 29.4064 23.4658 29.5952 23.3898C29.6928 23.3505 29.7821 23.304 29.848 23.2459C29.9152 23.1864 29.965 23.1079 29.9624 23.0091V23.009C29.9585 22.8714 29.8729 22.7774 29.7856 22.7071C29.7415 22.6716 29.6918 22.6382 29.6445 22.6064L29.6397 22.6032C29.5928 22.5718 29.5475 22.5414 29.5044 22.5084C29.4154 22.4401 29.3458 22.3672 29.3103 22.2732C29.2756 22.1809 29.2686 22.0544 29.3333 21.8686L29.3334 21.8683C29.7611 20.6285 29.979 19.326 29.9784 18.0145V17.9197H29.9754C29.9241 11.4152 24.6117 6.15936 18.0682 6.15936C11.4929 6.15936 6.15942 11.4664 6.15942 18.0145C6.15942 19.3681 6.38778 20.6684 6.80706 21.8804L6.80913 21.8863L6.80999 21.888L6.81214 21.8943C6.81455 21.901 6.81747 21.9098 6.82049 21.9187L6.82841 21.9426L6.83099 21.9503L6.83159 21.9522M13.9997 28.2972C13.9997 28.2972 13.9994 28.2971 13.9992 28.2964L13.9997 28.2972ZM26.1286 21.3531C26.5592 20.3247 26.7978 19.1969 26.7978 18.0132C26.7978 13.2152 22.8896 9.32472 18.0696 9.32472C13.2496 9.32472 9.34131 13.2152 9.34131 18.0132C9.34131 19.3175 9.6319 20.5543 10.1478 21.6648C10.3259 22.0351 10.5724 22.1852 10.7629 22.3012C10.9143 22.3934 11.0305 22.4641 11.0488 22.6069C11.0785 22.8418 10.7252 22.9462 10.3918 23.0449C10.0959 23.1323 9.8155 23.2152 9.83186 23.3806C9.85966 23.6614 10.5386 23.7679 11.1821 23.8689C11.7699 23.9612 12.3281 24.0487 12.3338 24.2603C12.3396 24.471 11.8941 24.6018 11.4484 24.7327C10.9737 24.872 10.4989 25.0114 10.5689 25.2475C10.6493 25.5197 12.0108 25.6167 13.371 25.7138C14.7627 25.8131 16.1533 25.9123 16.1688 26.1989C16.1861 26.5197 15.2165 26.6381 14.3373 26.7455C13.6602 26.8282 13.0366 26.9044 12.959 27.0614C12.767 27.4475 14.4492 27.6332 17.9069 27.6332C20.9434 27.6332 22.5283 27.4448 22.5244 27.0985C22.5224 26.8984 22.0449 26.7919 21.5583 26.6833C21.0445 26.5687 20.5205 26.4519 20.5356 26.2201C20.5554 25.9153 21.5623 25.84 22.5827 25.7639C23.623 25.6862 24.6774 25.6075 24.7144 25.2833C24.7402 25.0576 24.0597 24.9282 23.3826 24.7995C22.7305 24.6755 22.0816 24.5522 22.0698 24.3439C22.0498 23.983 23.1279 23.8739 24.1342 23.7721C25.0079 23.6837 25.8274 23.6007 25.8274 23.3633C25.8274 23.1559 25.5247 23.0365 25.2308 22.9207C24.9286 22.8015 24.6356 22.686 24.6904 22.4822C24.7322 22.3259 24.9064 22.2625 25.1264 22.1823C25.4535 22.0632 25.8819 21.9072 26.1273 21.3544L26.1286 21.3531ZM26.0485 21.299C26.4697 20.2867 26.703 19.1773 26.703 18.0132C26.703 13.2681 22.8378 9.41966 18.0696 9.41966C13.3013 9.41966 9.43608 13.2681 9.43608 18.0132C9.43526 19.2606 9.7074 20.4931 10.2334 21.6242C10.3822 21.9331 10.58 22.0761 10.7528 22.1837C10.7709 22.195 10.7894 22.2062 10.8079 22.2174C10.8751 22.2583 10.9429 22.2996 10.9964 22.3444C11.0695 22.4057 11.1285 22.4832 11.1428 22.5949L11.1429 22.5951C11.1643 22.7648 11.0486 22.8762 10.9247 22.9476C10.7993 23.0199 10.6313 23.0726 10.4754 23.1191L10.4186 23.1359C10.2788 23.1773 10.1512 23.2151 10.0551 23.2597C10.001 23.2849 9.96536 23.3087 9.94504 23.3301C9.92705 23.3489 9.92516 23.361 9.92611 23.3711C9.92895 23.3992 9.94763 23.4346 10.008 23.4763C10.068 23.5178 10.157 23.5563 10.2715 23.5917C10.5 23.6624 10.803 23.7131 11.113 23.762L11.1977 23.7752C11.4762 23.819 11.7544 23.8626 11.9696 23.9197C12.0876 23.9509 12.1943 23.9882 12.2737 24.0358C12.3509 24.0821 12.4257 24.1529 12.4285 24.2577M12.4285 24.2577C12.4311 24.351 12.3807 24.4249 12.3187 24.4799C12.2569 24.5347 12.1732 24.5806 12.0821 24.6207C11.9118 24.6956 11.6905 24.7606 11.477 24.8231L11.4316 24.8365C11.1994 24.9047 10.9823 24.9707 10.8314 25.0462C10.7555 25.0842 10.7059 25.12 10.6791 25.1522C10.6559 25.1802 10.6536 25.1995 10.6598 25.2205C10.6597 25.2201 10.6607 25.2241 10.668 25.2317C10.6755 25.2396 10.6878 25.2497 10.7071 25.2613C10.746 25.2847 10.804 25.3087 10.8823 25.3324C11.0384 25.3793 11.2569 25.4195 11.5208 25.4547C12.0358 25.5234 12.7058 25.5712 13.3797 25.6192L13.4251 25.6225C14.1119 25.6715 14.7993 25.7213 15.317 25.7947C15.5751 25.8312 15.7965 25.8743 15.9562 25.9279C16.0354 25.9546 16.1056 25.9858 16.1583 26.0241C16.2101 26.0617 16.2592 26.1172 16.2634 26.1937C16.2699 26.3148 16.1912 26.403 16.0989 26.4636C16.0054 26.5249 15.8764 26.5735 15.7306 26.6139C15.4376 26.6953 15.0456 26.7523 14.6543 26.8019C14.5511 26.815 14.4481 26.8276 14.3466 26.84C14.0593 26.8751 13.7845 26.9087 13.5561 26.9477C13.4017 26.9743 13.2733 27.0025 13.1795 27.034C13.1326 27.0497 13.0977 27.0652 13.0737 27.0797C13.0484 27.095 13.0435 27.1042 13.0439 27.1035L13.0438 27.1037C13.0384 27.1144 13.0389 27.1193 13.039 27.1204C13.0392 27.1216 13.04 27.1269 13.0479 27.1366C13.0665 27.1593 13.1112 27.191 13.1991 27.2251C13.3718 27.2921 13.6618 27.3506 14.0751 27.3977C14.8982 27.4918 16.1787 27.5383 17.9069 27.5383C19.4242 27.5383 20.5751 27.4912 21.3449 27.4014C21.7307 27.3565 22.0153 27.3013 22.2011 27.2382C22.2945 27.2066 22.3565 27.1749 22.3933 27.1461C22.4297 27.1176 22.4296 27.1018 22.4296 27.0996V27.0994C22.4295 27.0915 22.4253 27.0707 22.3804 27.0377C22.3364 27.0053 22.2679 26.9729 22.1764 26.9408C22.0033 26.8799 21.774 26.8288 21.5351 26.7754L21.4968 26.7669C21.2485 26.7114 20.9919 26.6528 20.7992 26.5784C20.7032 26.5414 20.6154 26.4975 20.5511 26.4429C20.4857 26.3873 20.4346 26.3111 20.441 26.2139C20.4498 26.079 20.5661 25.9957 20.685 25.9427C20.8112 25.8863 20.983 25.8443 21.1791 25.8108C21.564 25.7447 22.0697 25.707 22.5724 25.6694L22.6054 25.667C23.1222 25.6284 23.6332 25.5894 24.0196 25.5206C24.2133 25.4861 24.3689 25.4452 24.4762 25.3963C24.5896 25.3446 24.6172 25.299 24.6202 25.2725C24.6204 25.2706 24.6209 25.2667 24.6147 25.2574C24.6073 25.2464 24.5922 25.231 24.564 25.2123C24.5072 25.1747 24.4173 25.137 24.2979 25.0999C24.0604 25.0262 23.7362 24.9634 23.4024 24.8999L23.3626 24.8923C23.0449 24.8319 22.7218 24.7705 22.4739 24.6987C22.3452 24.6613 22.2303 24.6195 22.145 24.5702C22.0657 24.5244 21.9811 24.4543 21.9752 24.3492V24.3491C21.9675 24.2116 22.0608 24.1141 22.172 24.0477C22.2847 23.9802 22.4412 23.9282 22.6192 23.8858C22.9769 23.8005 23.4541 23.7463 23.9249 23.6979L24.1252 23.6775C24.5293 23.6367 24.9172 23.5974 25.2184 23.5438C25.3945 23.5124 25.5337 23.4773 25.6271 23.4372C25.6738 23.4171 25.703 23.3982 25.7192 23.3826C25.7241 23.3783 25.7283 23.373 25.7315 23.3672C25.7326 23.3649 25.7327 23.364 25.7327 23.3633C25.7327 23.3111 25.6947 23.2532 25.5849 23.1855C25.4803 23.1211 25.34 23.0658 25.1911 23.007L25.1837 23.0041C25.0378 22.9466 24.8815 22.8847 24.7695 22.809C24.7129 22.7709 24.6602 22.7243 24.6263 22.666C24.6079 22.6349 24.5959 22.6004 24.5912 22.5646C24.5865 22.5288 24.5891 22.4924 24.5989 22.4576C24.6359 22.3194 24.745 22.2418 24.86 22.1864C24.9183 22.1585 24.9835 22.1336 25.0499 22.1092L25.0948 22.0928C25.1498 22.0731 25.2045 22.0525 25.2588 22.0312C25.5424 21.9179 25.8496 21.7463 26.0407 21.3158L26.048 21.2995L26.0485 21.299",
            fill: "black"
          }
        )
      ]
    }
  );
}
function AVAX$1() {
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(
    "svg",
    {
      width: "36",
      height: "36",
      viewBox: "0 0 36 36",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx("rect", { width: "36", height: "36", rx: "6", fill: "#E84142" }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "ellipse",
          {
            cx: "18.2683",
            cy: "18.2682",
            rx: "12.0875",
            ry: "12.0875",
            fill: "white"
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M35.5131 18.2567C35.5131 27.7873 27.7873 35.5131 18.2567 35.5131C8.72631 35.5131 1.00037 27.7873 1.00037 18.2567C1.00037 8.72631 8.72631 1.00037 18.2567 1.00037C27.7873 1.00037 35.5131 8.72631 35.5131 18.2567ZM13.3668 25.1239H10.0178C9.31408 25.1239 8.96647 25.1239 8.75452 24.9883C8.52559 24.8399 8.3857 24.594 8.36875 24.3227C8.35602 24.0727 8.52984 23.7673 8.87745 23.1569L17.1465 8.58157C17.4984 7.96264 17.6764 7.65317 17.9011 7.53872C18.1427 7.41579 18.431 7.41579 18.6726 7.53872C18.8973 7.65317 19.0754 7.96264 19.4272 8.58157L21.1271 11.549L21.1358 11.5642C21.5158 12.2282 21.7085 12.5649 21.7927 12.9183C21.8859 13.304 21.8859 13.711 21.7927 14.0968C21.7079 14.4529 21.5171 14.792 21.1314 15.4661L16.7878 23.1442L16.7766 23.1639C16.3941 23.8333 16.2002 24.1726 15.9315 24.4286C15.639 24.7085 15.2872 24.9118 14.9014 25.0265C14.5495 25.1239 14.1553 25.1239 13.3668 25.1239ZM21.8241 25.1239H26.6228C27.3307 25.1239 27.6869 25.1239 27.8989 24.9842C28.1278 24.8358 28.2719 24.5855 28.2847 24.3144C28.2969 24.0724 28.1269 23.779 27.7937 23.204C27.7822 23.1845 27.7707 23.1645 27.759 23.1443L25.3553 19.0322L25.328 18.9859C24.9902 18.4148 24.8197 18.1263 24.6007 18.0148C24.3592 17.8919 24.075 17.8919 23.8334 18.0148C23.613 18.1293 23.435 18.4303 23.0831 19.0365L20.6879 23.1485L20.6797 23.1627C20.3291 23.7679 20.1539 24.0704 20.1665 24.3185C20.1835 24.5899 20.3234 24.8399 20.5523 24.9883C20.76 25.1239 21.1161 25.1239 21.8241 25.1239Z",
            fill: "#E84142"
          }
        )
      ]
    }
  );
}
function CELO$1() {
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(
    "svg",
    {
      width: "36",
      height: "36",
      viewBox: "0 0 36 36",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx("rect", { width: "36", height: "36", rx: "6", fill: "#FCFF52" }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M27.9986 8H8V28H28V21.0184H24.6812C23.5373 23.5658 20.962 25.3389 18.015 25.3389C13.9527 25.3389 10.6625 22.02 10.6625 17.9865C10.6625 13.9516 13.9527 10.6611 18.015 10.6611C21.0192 10.6611 23.5945 12.4924 24.7384 15.0953H28V8H27.9986Z",
            fill: "black"
          }
        )
      ]
    }
  );
}
function ETH$1() {
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(
    "svg",
    {
      width: "36",
      height: "36",
      viewBox: "0 0 36 36",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx("rect", { width: "36", height: "36", rx: "6", fill: "white" }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "path",
          {
            d: "M17.8051 5L17.6345 5.5795V22.3938L17.8051 22.564L25.61 17.9505L17.8051 5Z",
            fill: "#343434"
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "M17.805 5L10 17.9505L17.805 22.564V14.4028V5Z", fill: "#8C8C8C" }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "path",
          {
            d: "M17.8051 24.0417L17.709 24.1589V30.1484L17.8051 30.4291L25.6148 19.4306L17.8051 24.0417Z",
            fill: "#3C3C3B"
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "path",
          {
            d: "M17.805 30.4291V24.0417L10 19.4306L17.805 30.4291Z",
            fill: "#8C8C8C"
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "path",
          {
            d: "M17.8051 22.564L25.6099 17.9505L17.8051 14.4028V22.564Z",
            fill: "#141414"
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "M10 17.9505L17.805 22.564V14.4028L10 17.9505Z", fill: "#393939" })
      ]
    }
  );
}
function FTM$1() {
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(
    "svg",
    {
      width: "36",
      height: "36",
      viewBox: "0 0 36 36",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx("rect", { width: "36", height: "36", rx: "6", fill: "#13B5EC" }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "path",
          {
            d: "M16.7073 6.23963C17.3111 5.92012 18.2345 5.92012 18.8384 6.23963L25.0178 9.49782C25.3829 9.69093 25.583 9.97532 25.6181 10.2738H25.6252V26.649C25.6181 26.972 25.4145 27.2915 25.0178 27.5022L18.8384 30.7604C18.2345 31.0799 17.3111 31.0799 16.7073 30.7604L10.5279 27.5022C10.1347 27.295 9.94509 26.972 9.93456 26.649C9.93456 26.6174 9.93456 26.5893 9.93456 26.5683V10.3861C9.93456 10.365 9.93456 10.3405 9.93456 10.3194V10.2773H9.93807C9.96615 9.97883 10.1557 9.69795 10.5279 9.50133L16.7073 6.23963ZM24.6421 19.3777L18.8349 22.4499C18.231 22.7694 17.3111 22.7694 16.7037 22.4499L10.9106 19.3848V26.5999L16.7037 29.6474C17.0478 29.83 17.4024 30.009 17.75 30.016H17.7711C18.1187 30.016 18.4522 29.8405 18.7928 29.6755L24.6421 26.5718V19.3777ZM8.96201 26.2944C8.96201 26.9229 9.03574 27.3337 9.17618 27.6251C9.29556 27.8673 9.47462 28.0499 9.80114 28.2746L9.81869 28.2886C9.88891 28.3378 9.96966 28.3869 10.0645 28.4466L10.1768 28.5169L10.5244 28.7275L10.0294 29.5596L9.63963 29.3244L9.57292 29.2822C9.46057 29.212 9.36577 29.1523 9.28151 29.0927C8.3511 28.4607 8.00702 27.7725 8 26.3365V26.2944H8.96201ZM17.3041 15.0241C17.2585 15.0382 17.2163 15.0592 17.1777 15.0768L11.0089 18.3455C11.0019 18.349 10.9949 18.3525 10.9914 18.356L10.9843 18.3596L10.9949 18.3666L11.0089 18.3736L17.1777 21.6423C17.2163 21.6634 17.2585 21.681 17.3041 21.695V15.0241ZM18.2872 15.0241V21.695C18.3328 21.681 18.375 21.6599 18.4136 21.6423L24.5824 18.3736C24.5894 18.3701 24.5964 18.3666 24.6 18.3631L24.6035 18.3596L24.5929 18.3525L24.5789 18.3455L18.4101 15.0768C18.375 15.0592 18.3328 15.0382 18.2872 15.0241ZM24.6421 11.4429L19.0947 14.357L24.6421 17.2712V11.4429ZM10.9141 11.4429V17.2712L16.4615 14.357L10.9141 11.4429ZM18.4066 7.11035C18.0871 6.94182 17.5042 6.94182 17.1847 7.11035L11.0089 10.3756C11.0019 10.3791 10.9949 10.3826 10.9914 10.3861L10.9843 10.3896L10.9949 10.3966L11.0089 10.4037L17.1847 13.6689C17.5042 13.8374 18.0871 13.8374 18.4066 13.6689L24.5824 10.4037C24.5894 10.4001 24.5964 10.3966 24.6 10.3931L24.6035 10.3896L24.5929 10.3826L24.5789 10.3756L18.4066 7.11035ZM25.562 7.44038L25.9517 7.67562L26.0184 7.71775C26.1307 7.78797 26.2255 7.84766 26.3098 7.90735C27.2402 8.53932 27.5843 9.22748 27.5913 10.6635V10.7056H26.6293C26.6293 10.0771 26.5556 9.66635 26.4151 9.37494C26.2958 9.13268 26.1167 8.95011 25.7902 8.72541L25.7726 8.71136C25.7024 8.66221 25.6217 8.61305 25.5269 8.55337L25.4145 8.48315L25.0669 8.27249L25.562 7.44038Z",
            fill: "white"
          }
        )
      ]
    }
  );
}
function SOL$1() {
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(
    "svg",
    {
      width: "36",
      height: "36",
      viewBox: "0 0 36 36",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx("rect", { width: "36", height: "36", rx: "6", fill: "black" }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "path",
          {
            d: "M10.4854 22.4808C10.6216 22.3449 10.8064 22.2687 10.999 22.2687H28.7693C29.093 22.2687 29.255 22.6593 29.026 22.8877L25.5147 26.3893C25.3784 26.5252 25.1937 26.6015 25.0011 26.6015H7.23081C6.9071 26.6015 6.74507 26.2108 6.97406 25.9825L10.4854 22.4808Z",
            fill: "url(#paint0_linear_85_9551)"
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "path",
          {
            d: "M10.4854 9.39895C10.6216 9.26308 10.8064 9.18677 10.999 9.18677H28.7693C29.093 9.18677 29.255 9.57744 29.026 9.80581L25.5147 13.3074C25.3784 13.4433 25.1937 13.5196 25.0011 13.5196H7.23081C6.9071 13.5196 6.74507 13.129 6.97406 12.9006L10.4854 9.39895Z",
            fill: "url(#paint1_linear_85_9551)"
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "path",
          {
            d: "M25.5147 15.8982C25.3784 15.7624 25.1937 15.686 25.0011 15.686H7.23081C6.9071 15.686 6.74507 16.0767 6.97406 16.305L10.4854 19.8067C10.6216 19.9425 10.8064 20.0189 10.999 20.0189H28.7693C29.093 20.0189 29.255 19.6282 29.026 19.3998L25.5147 15.8982Z",
            fill: "url(#paint2_linear_85_9551)"
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsxs("defs", { children: [
          /* @__PURE__ */ jsxRuntimeExports.jsxs(
            "linearGradient",
            {
              id: "paint0_linear_85_9551",
              x1: "21.9203",
              y1: "4.40983",
              x2: "9.65997",
              y2: "27.9398",
              gradientUnits: "userSpaceOnUse",
              children: [
                /* @__PURE__ */ jsxRuntimeExports.jsx("stop", { stopColor: "#00FFA3" }),
                /* @__PURE__ */ jsxRuntimeExports.jsx("stop", { offset: "1", stopColor: "#DC1FFF" })
              ]
            }
          ),
          /* @__PURE__ */ jsxRuntimeExports.jsxs(
            "linearGradient",
            {
              id: "paint1_linear_85_9551",
              x1: "21.9203",
              y1: "4.40982",
              x2: "9.65999",
              y2: "27.9398",
              gradientUnits: "userSpaceOnUse",
              children: [
                /* @__PURE__ */ jsxRuntimeExports.jsx("stop", { stopColor: "#00FFA3" }),
                /* @__PURE__ */ jsxRuntimeExports.jsx("stop", { offset: "1", stopColor: "#DC1FFF" })
              ]
            }
          ),
          /* @__PURE__ */ jsxRuntimeExports.jsxs(
            "linearGradient",
            {
              id: "paint2_linear_85_9551",
              x1: "21.9203",
              y1: "4.40983",
              x2: "9.66001",
              y2: "27.9398",
              gradientUnits: "userSpaceOnUse",
              children: [
                /* @__PURE__ */ jsxRuntimeExports.jsx("stop", { stopColor: "#00FFA3" }),
                /* @__PURE__ */ jsxRuntimeExports.jsx("stop", { offset: "1", stopColor: "#DC1FFF" })
              ]
            }
          )
        ] })
      ]
    }
  );
}
function APT$1() {
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(
    "svg",
    {
      width: "36",
      height: "36",
      viewBox: "0 0 36 36",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx("rect", { width: "36", height: "36", rx: "6", fill: "white" }),
        /* @__PURE__ */ jsxRuntimeExports.jsxs("g", { clipPath: "url(#clip0_84_8298)", children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            "path",
            {
              d: "M36 18C36 8.05887 27.9411 0 18 0C8.05887 0 0 8.05887 0 18C0 27.9411 8.05887 36 18 36C27.9411 36 36 27.9411 36 18Z",
              fill: "white"
            }
          ),
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            "path",
            {
              d: "M6 16.9982L6.65314 14.2624C6.696 14.1538 6.97886 14.021 7.15371 14.021H17.7497C18.468 14.0434 19.0337 13.8245 19.4897 13.2332C20.2954 12.2264 20.5337 12.2264 21.3617 13.2108C21.5667 13.4867 21.8379 13.7058 22.15 13.8475C22.4621 13.9892 22.8049 14.0489 23.1463 14.021L28.8463 13.9986C29.1943 13.9986 29.3897 14.0865 29.4549 14.4365L30 16.9775H29.3263C26.6709 16.9775 24.0394 16.9551 21.384 17C21.1328 17.0156 20.8816 16.9679 20.6535 16.861C20.4253 16.7541 20.2274 16.5915 20.0777 16.388C19.272 15.3588 18.9686 15.0761 17.9246 16.3225C17.4891 16.8483 17.0109 17 16.38 16.9793L6.76286 16.9569C6.588 17 6.39257 17 6.00171 17L6 16.9982ZM6.17486 20.2375H13.5514C14.2251 20.2375 14.7909 20.0841 15.2057 19.4928C15.3137 19.3393 15.4457 19.2307 15.576 19.0773C16.0337 18.5739 16.4469 18.5308 16.8377 19.0773C17.4909 20.041 18.3171 20.2582 19.428 20.2375L29.088 20.2151H29.8714L28.8703 23.0372C28.8274 23.1251 28.6097 23.1906 28.4571 23.1906H16.7726C16.512 23.1906 16.2291 23.0147 16.032 22.8406C15.7491 22.5993 15.5314 22.2717 15.2709 22.0097C14.9451 21.6821 14.5749 21.6597 14.2269 21.9873L14.184 22.0304C13.488 23.1906 12.4217 23.3216 11.1806 23.2561C10.0269 23.1682 8.87486 23.213 7.69886 23.2561C7.32857 23.2561 7.13314 23.1251 7.02514 22.7958L6.17657 20.2358L6.17486 20.2375ZM8.48229 10.8059C13.0303 4.50492 22.7554 4.30667 27.5211 10.7628C26.6726 10.7628 25.8463 10.8507 25.0406 10.7197C24.6926 10.6766 24.3874 10.2387 24.1269 9.93185C23.3657 9.10091 23.148 9.05609 22.4297 9.90944C21.864 10.5663 21.2554 10.8283 20.3623 10.8283L9.17829 10.8059H8.48229ZM9.31029 26.1661C10.0286 26.1437 10.3543 25.6196 10.7469 25.1817C11.3554 24.4818 11.7257 24.4387 12.2691 25.1817C12.8349 25.992 13.5531 26.1885 14.4891 26.1661L26.064 26.1437H26.6726C22.8 30.9138 14.1823 31.6361 9.30857 26.1661H9.31029Z",
              fill: "black"
            }
          )
        ] }),
        /* @__PURE__ */ jsxRuntimeExports.jsx("defs", { children: /* @__PURE__ */ jsxRuntimeExports.jsx("clipPath", { id: "clip0_84_8298", children: /* @__PURE__ */ jsxRuntimeExports.jsx("rect", { width: "36", height: "36", fill: "white" }) }) })
      ]
    }
  );
}
function SUI$1() {
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(
    "svg",
    {
      width: "36",
      height: "36",
      viewBox: "0 0 36 36",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx("rect", { width: "36", height: "36", rx: "6", fill: "#4DA2FF" }),
        /* @__PURE__ */ jsxRuntimeExports.jsx("g", { clipPath: "url(#clip0_287_480)", children: /* @__PURE__ */ jsxRuntimeExports.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M23.406 16.0068C24.342 17.2334 24.906 18.7916 24.906 20.4813C24.906 22.171 24.33 23.7731 23.364 25.0122L23.28 25.1186L23.256 24.9809C23.238 24.8683 23.214 24.7494 23.19 24.6305C22.71 22.4214 21.138 20.5251 18.546 18.9856C16.8 17.953 15.798 16.7077 15.534 15.2933C15.366 14.3796 15.492 13.4597 15.732 12.6712C15.978 11.8826 16.338 11.2255 16.644 10.8313L17.652 9.54835C17.826 9.32306 18.162 9.32306 18.336 9.54835L23.406 16.0068ZM24.996 14.7238L18.252 6.12515C18.126 5.96243 17.88 5.96243 17.754 6.12515L11.004 14.7238L10.98 14.7551C9.744 16.3635 9 18.4036 9 20.6253C9 25.8008 13.032 30 18 30C22.968 30 27 25.8008 27 20.6253C27 18.4036 26.256 16.3635 25.014 14.7551L24.996 14.7238ZM12.618 15.9817L13.218 15.212L13.236 15.3559C13.248 15.4686 13.266 15.5812 13.29 15.6939C13.68 17.8279 15.078 19.6115 17.406 20.9882C19.434 22.1898 20.61 23.5729 20.952 25.0936C21.096 25.7257 21.12 26.3515 21.06 26.8959L21.054 26.9272L21.024 26.9398C20.112 27.4029 19.08 27.6657 17.994 27.6657C14.184 27.6657 11.094 24.449 11.094 20.4813C11.094 18.7791 11.664 17.2083 12.618 15.9817Z",
            fill: "white"
          }
        ) }),
        /* @__PURE__ */ jsxRuntimeExports.jsx("defs", { children: /* @__PURE__ */ jsxRuntimeExports.jsx("clipPath", { id: "clip0_287_480", children: /* @__PURE__ */ jsxRuntimeExports.jsx(
          "rect",
          {
            width: "18",
            height: "24",
            fill: "white",
            transform: "translate(9 6)"
          }
        ) }) })
      ]
    }
  );
}
function BASE$1() {
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(
    "svg",
    {
      width: "36",
      height: "36",
      viewBox: "0 0 36 36",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx("rect", { width: "36", height: "36", rx: "6", fill: "#0052FF" }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "path",
          {
            d: "M17.9773 31C25.1695 31 31 25.1797 31 18C31 10.8203 25.1695 5 17.9773 5C11.1537 5 5.55599 10.2388 5 16.9072H22.2131V19.0928H5C5.55599 25.761 11.1537 31 17.9773 31Z",
            fill: "white"
          }
        )
      ]
    }
  );
}
function MATIC() {
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(
    "svg",
    {
      width: "36",
      height: "36",
      viewBox: "0 0 36 36",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx("rect", { width: "36", height: "36", rx: "6", fill: "#8247E5" }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "path",
          {
            d: "M24.1723 14.2068C23.7337 13.9658 23.1697 13.9658 22.6684 14.2068L19.1593 16.1954L16.7781 17.4609L13.3316 19.4494C12.893 19.6905 12.329 19.6905 11.8277 19.4494L9.13316 17.8827C8.69452 17.6416 8.3812 17.1596 8.3812 16.6172V13.6042C8.3812 13.1221 8.63185 12.64 9.13316 12.3387L11.8277 10.8322C12.2663 10.5912 12.8303 10.5912 13.3316 10.8322L16.0261 12.399C16.4648 12.64 16.7781 13.1221 16.7781 13.6645V15.653L19.1593 14.3273V12.2785C19.1593 11.7964 18.9086 11.3143 18.4073 11.013L13.3943 8.18078C12.9556 7.93974 12.3916 7.93974 11.8903 8.18078L6.75196 11.0733C6.25065 11.3143 6 11.7964 6 12.2785V17.9429C6 18.425 6.25065 18.9071 6.75196 19.2084L11.8277 22.0406C12.2663 22.2817 12.8303 22.2817 13.3316 22.0406L16.7781 20.1123L19.1593 18.7866L22.6057 16.8583C23.0444 16.6172 23.6084 16.6172 24.1097 16.8583L26.8042 18.3648C27.2428 18.6058 27.5561 19.0879 27.5561 19.6302V22.6432C27.5561 23.1253 27.3055 23.6074 26.8042 23.9087L24.1723 25.4152C23.7337 25.6562 23.1697 25.6562 22.6684 25.4152L19.9739 23.9087C19.5352 23.6677 19.2219 23.1856 19.2219 22.6432V20.7149L16.8407 22.0406V24.0292C16.8407 24.5113 17.0914 24.9934 17.5927 25.2947L22.6684 28.1269C23.107 28.368 23.671 28.368 24.1723 28.1269L29.248 25.2947C29.6867 25.0536 30 24.5716 30 24.0292V18.3045C30 17.8224 29.7493 17.3403 29.248 17.039L24.1723 14.2068Z",
            fill: "white"
          }
        )
      ]
    }
  );
}
function BSC$1() {
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(
    "svg",
    {
      width: "36",
      height: "36",
      viewBox: "0 0 36 36",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx("rect", { width: "36", height: "36", rx: "6", fill: "#F0B90B" }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M18 0C27.9418 0 36 8.05817 36 18C36 27.9418 27.9418 36 18 36C8.05817 36 0 27.9418 0 18C0 8.05817 8.05817 0 18 0Z",
            fill: "#F0B90B"
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "path",
          {
            d: "M9.89289 18L9.90587 22.7596L13.9501 25.1394V27.9259L7.53904 24.1658V16.6081L9.89289 18ZM9.89289 13.2403V16.0139L7.5376 14.6206V11.8471L9.89289 10.4538L12.2597 11.8471L9.89289 13.2403ZM15.639 11.8471L17.9943 10.4538L20.3612 11.8471L17.9943 13.2403L15.639 11.8471Z",
            fill: "white"
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "path",
          {
            d: "M11.5948 21.773V18.9865L13.9501 20.3798V23.1533L11.5948 21.773ZM15.6391 26.1374L17.9944 27.5307L20.3612 26.1374V28.911L17.9944 30.3043L15.6391 28.911V26.1374ZM23.7391 11.8471L26.0944 10.4538L28.4612 11.8471V14.6206L26.0944 16.0139V13.2403L23.7391 11.8471ZM26.0944 22.7596L26.1073 18L28.4626 16.6067V24.1644L22.0516 27.9245V25.1379L26.0944 22.7596Z",
            fill: "white"
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "path",
          {
            d: "M24.4053 21.7731L22.05 23.1534V20.3798L24.4053 18.9865V21.7731Z",
            fill: "white"
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "path",
          {
            d: "M24.4054 14.227L24.4184 17.0135L20.3626 19.3933V24.1645L18.0073 25.5447L15.6521 24.1645V19.3933L11.5963 17.0135V14.227L13.9617 12.8337L17.9929 15.225L22.0487 12.8337L24.4155 14.227H24.4054ZM11.5948 9.46879L17.9944 5.69571L24.4054 9.46879L22.0501 10.8621L17.9944 8.47071L13.9501 10.8621L11.5948 9.46879Z",
            fill: "white"
          }
        )
      ]
    }
  );
}
const noIcon$1 = /* @__PURE__ */ jsxRuntimeExports.jsx(
  "svg",
  {
    width: "13",
    height: "13",
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ jsxRuntimeExports.jsx("rect", { width: "13", height: "13", rx: "2", fill: "#3D405C" })
  }
);
function ARBITRUM$1() {
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(
    "svg",
    {
      width: "36",
      height: "36",
      viewBox: "0 0 36 36",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx("rect", { width: "36", height: "36", rx: "6", fill: "#213147" }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "path",
          {
            d: "M7.35034 12.904V23.096C7.35034 23.7512 7.69354 24.344 8.26554 24.6768L17.0951 29.7728C17.6567 30.0952 18.3535 30.0952 18.9151 29.7728L27.7447 24.6768C28.3063 24.3544 28.6599 23.7512 28.6599 23.096V12.904C28.6599 12.2488 28.3167 11.656 27.7447 11.3232L18.9151 6.2272C18.3535 5.9048 17.6567 5.9048 17.0951 6.2272L8.26554 11.3232C7.70394 11.6456 7.36074 12.2488 7.36074 12.904H7.35034Z",
            fill: "#213147"
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "path",
          {
            d: "M19.924 19.976L18.6656 23.4288C18.6344 23.5224 18.6344 23.6264 18.6656 23.7304L20.8288 29.6688L23.3352 28.2232L20.3296 19.976C20.2568 19.7888 19.9968 19.7888 19.924 19.976Z",
            fill: "#12AAFF"
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "path",
          {
            d: "M22.4512 14.1728C22.3784 13.9856 22.1184 13.9856 22.0456 14.1728L20.7872 17.6256C20.756 17.7192 20.756 17.8232 20.7872 17.9272L24.3336 27.6512L26.84 26.2056L22.4512 14.1832V14.1728Z",
            fill: "#12AAFF"
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "path",
          {
            d: "M18 6.612C18.0624 6.612 18.1248 6.6328 18.1768 6.664L27.724 12.176C27.8384 12.2384 27.9008 12.3632 27.9008 12.488V23.512C27.9008 23.6368 27.828 23.7616 27.724 23.824L18.1768 29.336C18.1248 29.3672 18.0624 29.388 18 29.388C17.9376 29.388 17.8752 29.3672 17.8232 29.336L8.27601 23.824C8.16161 23.7616 8.09921 23.6368 8.09921 23.512V12.4776C8.09921 12.3528 8.17201 12.228 8.27601 12.1656L17.8232 6.6536C17.8752 6.6224 17.9376 6.6016 18 6.6016V6.612ZM18 5C17.6568 5 17.324 5.0832 17.012 5.26L7.46481 10.772C6.85121 11.1256 6.47681 11.7704 6.47681 12.4776V23.5016C6.47681 24.2088 6.85121 24.8536 7.46481 25.2072L17.012 30.7192C17.3136 30.896 17.6568 30.9792 18 30.9792C18.3432 30.9792 18.676 30.896 18.988 30.7192L28.5352 25.2072C29.1488 24.8536 29.5232 24.2088 29.5232 23.5016V12.4776C29.5232 11.7704 29.1488 11.1256 28.5352 10.772L18.9776 5.26C18.676 5.0832 18.3328 5 17.9896 5H18Z",
            fill: "#9DCCED"
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "path",
          {
            d: "M11.6768 27.6616L12.5608 25.2488L14.3288 26.7152L12.6752 28.2336L11.6768 27.6616Z",
            fill: "#213147"
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "path",
          {
            d: "M17.1888 11.6976H14.7656C14.5888 11.6976 14.4224 11.812 14.36 11.9784L9.17041 26.2056L11.6768 27.6512L17.3968 11.9784C17.4488 11.8328 17.3448 11.6872 17.1992 11.6872L17.1888 11.6976Z",
            fill: "white"
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "path",
          {
            d: "M21.4321 11.6976H19.0089C18.8321 11.6976 18.6657 11.812 18.6033 11.9784L12.6753 28.2232L15.1817 29.6688L21.6297 11.9784C21.6817 11.8328 21.5777 11.6872 21.4321 11.6872V11.6976Z",
            fill: "white"
          }
        )
      ]
    }
  );
}
function OPTIMISM$1() {
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(
    "svg",
    {
      width: "36",
      height: "36",
      viewBox: "0 0 36 36",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx("rect", { width: "36", height: "36", rx: "7", fill: "#FF0420" }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "path",
          {
            d: "M11.4903 24C10.1707 24 9.09018 23.6891 8.24879 23.0674C7.41626 22.4367 7 21.5307 7 20.3671C7 20.1184 7.02657 19.8253 7.07971 19.47C7.22142 18.6706 7.42512 17.7113 7.69082 16.5833C8.44364 13.5278 10.3921 12 13.5274 12C14.3776 12 15.1481 12.1421 15.8213 12.4352C16.4944 12.7106 17.0258 13.1369 17.4155 13.7054C17.8052 14.265 18 14.9312 18 15.7039C18 15.9349 17.9734 16.228 17.9203 16.5833C17.752 17.5692 17.5572 18.5374 17.318 19.47C16.9283 20.9889 16.2641 22.1347 15.3076 22.8897C14.3599 23.6358 13.0845 24 11.4903 24ZM11.7295 21.6018C12.3494 21.6018 12.872 21.4152 13.306 21.0511C13.7488 20.6869 14.0676 20.1273 14.2536 19.3634C14.5105 18.3153 14.7053 17.4093 14.8382 16.6277C14.8824 16.3967 14.909 16.1569 14.909 15.9082C14.909 14.8956 14.3865 14.3893 13.3325 14.3893C12.7126 14.3893 12.1812 14.5759 11.7383 14.94C11.3043 15.3042 10.9944 15.8638 10.8084 16.6277C10.6047 17.3738 10.4098 18.2798 10.2061 19.3634C10.1618 19.5855 10.1353 19.8164 10.1353 20.0651C10.1264 21.0955 10.6667 21.6018 11.7295 21.6018Z",
            fill: "white"
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "path",
          {
            d: "M18.3639 24C18.2324 24 18.1385 23.9635 18.0634 23.8813C18.007 23.79 17.9883 23.6895 18.007 23.5708L20.4394 12.4292C20.4582 12.3014 20.524 12.2009 20.6367 12.1187C20.74 12.0365 20.8527 12 20.9748 12H25.6611C26.9665 12 28.009 12.2648 28.7979 12.7854C29.5962 13.3151 30 14.0731 30 15.0685C30 15.3516 29.9624 15.653 29.8967 15.9635C29.6056 17.2785 29.0139 18.2466 28.1123 18.8767C27.2295 19.5068 26.018 19.8174 24.4778 19.8174H22.1017L21.2941 23.5708C21.2659 23.6986 21.2095 23.7991 21.0968 23.8813C20.9935 23.9635 20.8808 24 20.7588 24H18.3639ZM24.5999 17.4521C25.0976 17.4521 25.5202 17.3242 25.8865 17.0594C26.2622 16.7945 26.5064 16.4201 26.6284 15.9269C26.666 15.7352 26.6848 15.5616 26.6848 15.4155C26.6848 15.0868 26.5815 14.8311 26.3843 14.6575C26.187 14.4749 25.8396 14.3836 25.3606 14.3836H23.2475L22.5807 17.4521H24.5999Z",
            fill: "white"
          }
        )
      ]
    }
  );
}
function KAIA() {
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(
    "svg",
    {
      width: "36",
      height: "36",
      viewBox: "0 0 36 36",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx("rect", { width: "36", height: "36", rx: "6", fill: "black" }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "path",
          {
            d: "M17.7211 11.2061C17.7211 10.2099 18.5249 9.39834 19.5117 9.39834H22.7158V5H19.5117C16.117 5 13.3643 7.77901 13.3643 11.2061C13.3643 12.1004 13.553 12.9505 13.8901 13.7178C11.2538 14.8429 9.50303 17.2334 9.09538 20.2586C8.61909 23.5799 9.93735 27.1628 12.8082 28.8937C15.3703 30.5226 19.3765 30.4149 21.5404 28.1552V29.6553H26V13.0139H19.5136C18.5268 13.0139 17.7229 12.2023 17.7229 11.2061H17.7211ZM21.6394 17.4142V21.5913C21.6394 23.8992 19.786 25.7686 17.5019 25.7686C15.218 25.7686 13.3643 23.8972 13.3643 21.5913C13.3643 19.2854 15.218 17.4142 17.5019 17.4142H21.6394Z",
            fill: "#BFF009"
          }
        )
      ]
    }
  );
}
function SCROLL$1() {
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(
    "svg",
    {
      width: "36",
      height: "36",
      viewBox: "0 0 36 36",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx("rect", { width: "36", height: "36", rx: "6", fill: "#FFEEDA" }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "path",
          {
            d: "M27.4 21.6933V8.92C27.3733 7.85333 26.52 7 25.4533 7H12.1733C9.29333 7.05333 7 9.4 7 12.28C7 13.24 7.26667 14.0933 7.66667 14.8133C8.01333 15.4267 8.54667 15.9867 9.05333 16.4133C9.21333 16.5467 9.13333 16.4933 9.58667 16.76C10.2 17.1333 10.92 17.32 10.92 17.32V24.9467C10.9467 25.32 10.9733 25.6667 11.08 25.9867C11.3733 27.0533 12.12 27.88 13.1333 28.28C13.56 28.44 14.04 28.5467 14.5467 28.5733L25.1333 28.6267C27.24 28.6267 28.9733 26.92 28.9733 24.7867C28.9733 23.5333 28.36 22.3867 27.4 21.6933Z",
            fill: "#FFEEDA"
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "path",
          {
            d: "M27.6667 24.8666C27.6133 26.2266 26.4933 27.3199 25.1333 27.3199L17.8267 27.2932C18.4133 26.6266 18.76 25.7466 18.76 24.7866C18.76 23.2932 17.88 22.2532 17.88 22.2532H25.16C26.5467 22.2532 27.6933 23.3999 27.6933 24.7866L27.6667 24.8666Z",
            fill: "#EBC28E"
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "path",
          {
            d: "M9.74667 15.3467C8.89333 14.5467 8.30667 13.5067 8.30667 12.28V12.1467C8.38667 10.0667 10.0933 8.36 12.1733 8.30667H25.48C25.8267 8.33333 26.0933 8.57333 26.0933 8.92V20.2C26.3867 20.2533 26.5467 20.3067 26.84 20.3867C27.08 20.4667 27.4 20.6533 27.4 20.6533V8.92C27.3733 7.85333 26.52 7 25.4533 7H12.1733C9.29333 7.05333 7 9.4 7 12.28C7 13.96 7.77333 15.4 9 16.3867C9.08 16.4667 9.16 16.5467 9.4 16.5467C9.8 16.5467 10.0667 16.2267 10.04 15.9067C10.04 15.6133 9.93333 15.5067 9.74667 15.3467Z",
            fill: "#101010"
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "path",
          {
            d: "M25.1333 20.9466H14.7066C14.0133 20.9466 13.4533 21.5066 13.4533 22.2266V23.7199C13.4799 24.4133 14.0666 24.9999 14.7599 24.9999H15.5333V23.7199H14.7599V22.2533C14.7599 22.2533 14.9466 22.2533 15.1866 22.2533C16.4933 22.2533 17.4799 23.4799 17.4799 24.7866C17.4799 25.9599 16.4133 27.4266 14.6533 27.3199C13.0799 27.2133 12.2266 25.8266 12.2266 24.7866V12.0666C12.2266 11.5066 11.7466 11.0266 11.1866 11.0266H10.1466V12.3333H10.9199V24.8133C10.8666 27.3466 12.7333 28.6266 14.6533 28.6266L25.1599 28.6533C27.2666 28.6533 28.9999 26.9466 28.9999 24.8133C28.9733 22.6799 27.2666 20.9466 25.1333 20.9466ZM27.6666 24.8666C27.6133 26.2266 26.4933 27.3199 25.1333 27.3199L17.8266 27.2933C18.4133 26.6266 18.7599 25.7466 18.7599 24.7866C18.7599 23.2933 17.8799 22.2533 17.8799 22.2533H25.1599C26.5466 22.2533 27.6933 23.3999 27.6933 24.7866L27.6666 24.8666Z",
            fill: "#101010"
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "path",
          {
            d: "M22.3335 12.5467H14.4668V11.2667H22.3335C22.6801 11.2667 22.9735 11.56 22.9735 11.9067C22.9735 12.2533 22.7068 12.5467 22.3335 12.5467Z",
            fill: "#101010"
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "path",
          {
            d: "M22.3335 18.6801H14.4668V17.3734H22.3335C22.6801 17.3734 22.9735 17.6667 22.9735 18.0134C22.9735 18.3867 22.7068 18.6801 22.3335 18.6801Z",
            fill: "#101010"
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "path",
          {
            d: "M23.7201 15.6134H14.4668V14.3067H23.7201C24.0668 14.3067 24.3601 14.6 24.3601 14.9467C24.3601 15.32 24.0668 15.6134 23.7201 15.6134Z",
            fill: "#101010"
          }
        )
      ]
    }
  );
}
function BLAST$1() {
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(
    "svg",
    {
      width: "36",
      height: "36",
      viewBox: "0 0 36 36",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx("rect", { width: "36", height: "36", rx: "6", fill: "black" }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "path",
          {
            d: "M26.2139 17.3414L30.4386 15.2363L31.8949 10.7665L28.9823 8.64699H9.58929L5.1051 11.9777H27.9009L26.6898 15.7265H17.5484L16.6688 18.466H25.8102L23.2437 26.353L27.526 24.2335L29.0544 19.5042L26.1851 17.3991L26.2139 17.3414Z",
            fill: "#FCFC03"
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "path",
          {
            d: "M11.5502 22.9646L14.1888 14.7461L11.2618 12.5544L6.86414 26.353H23.2437L24.3395 22.9646H11.5502Z",
            fill: "#FCFC03"
          }
        )
      ]
    }
  );
}
function MANTLE() {
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(
    "svg",
    {
      width: "36",
      height: "36",
      viewBox: "0 0 36 36",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx("rect", { width: "36", height: "36", rx: "6", fill: "black" }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "path",
          {
            d: "M18.0484 31V26.573C17.6028 26.573 17.1475 26.5343 16.7019 26.4665L16.0045 30.8353C16.6826 30.9516 17.3703 31 18.0484 31ZM20.0827 30.845C20.7608 30.7385 21.4292 30.5835 22.0782 30.3703L20.7124 26.1565C20.2861 26.2921 19.8405 26.3987 19.3949 26.4665L20.0827 30.845ZM14.0186 30.3703L15.3845 26.1662C14.9583 26.0306 14.5417 25.8562 14.1349 25.6528L12.12 29.5954C12.7303 29.8957 13.3696 30.1572 14.0186 30.3703ZM23.9672 29.5954C24.5775 29.2854 25.1587 28.927 25.7109 28.5298L23.0954 24.9553C22.737 25.2168 22.3495 25.459 21.9426 25.6528L23.9672 29.5954ZM10.3763 28.5201L12.9918 24.9456C12.6334 24.6841 12.2846 24.3934 11.965 24.0738L8.82638 27.2027C9.31073 27.6773 9.83383 28.123 10.3763 28.5201ZM27.2511 27.2221L27.2802 27.193C27.7645 26.7183 28.2101 26.1952 28.6073 25.6528L25.0231 23.0469C24.7616 23.4054 24.4613 23.7541 24.1513 24.0641L24.1028 24.1125L25.614 25.5365L27.2511 27.2221ZM7.49925 25.6431L11.0835 23.0373C10.8219 22.6788 10.5797 22.2914 10.3763 21.8942L6.42399 23.8994C6.73398 24.5097 7.0924 25.0909 7.49925 25.6431ZM29.6729 23.9091C29.9829 23.3085 30.2444 22.6692 30.4575 22.0201L26.234 20.6639C26.0984 21.0902 25.924 21.5067 25.7206 21.9039L29.6729 23.9091ZM5.63934 22.0201L9.86289 20.6542C9.72727 20.228 9.62072 19.7921 9.55291 19.3465L5.16468 20.0343C5.27124 20.7027 5.43592 21.3711 5.63934 22.0201ZM30.9322 20.044C31.0388 19.3756 31.0969 18.6878 31.0969 18.0097H26.6602C26.6602 18.4553 26.6215 18.9106 26.5537 19.3562L30.9322 20.044ZM9.44635 18C9.44635 17.5544 9.4851 17.0991 9.55291 16.6535L5.16468 15.9657C5.05812 16.6341 5.00969 17.3219 5 18H9.44635ZM26.5537 16.6632L30.9419 15.9754C30.8353 15.307 30.6803 14.6386 30.4672 13.9896L26.2437 15.3458C26.3793 15.7817 26.4858 16.2176 26.5537 16.6632ZM9.86289 15.3458C9.99851 14.9195 10.1729 14.503 10.3763 14.1058L6.42399 12.1006C6.11401 12.7012 5.85246 13.3405 5.63934 13.9896L9.86289 15.3458ZM25.7303 14.1155L29.6923 12.1103C29.3823 11.5 29.0238 10.9188 28.617 10.3666L25.0231 12.9724C25.2847 13.3309 25.5268 13.7183 25.7303 14.1155ZM11.0835 12.9627C11.345 12.6043 11.6453 12.2556 11.965 11.9359L11.9747 11.9262L8.83607 8.79732L8.82638 8.807C8.34203 9.29136 7.89642 9.80477 7.49925 10.3569L11.0835 12.9627ZM24.1513 11.9553L25.1006 10.9963L27.2802 8.82638L27.2705 8.81669C26.7861 8.34203 26.2727 7.89642 25.7303 7.49925L23.1148 11.0738C23.4732 11.3353 23.8219 11.6259 24.1319 11.9456L24.1513 11.9553ZM13.0015 11.0544C13.3599 10.7928 13.7474 10.5604 14.1542 10.3569L12.1393 6.41431C11.5291 6.72429 10.9478 7.08271 10.3957 7.47988L13.0015 11.0544ZM21.9717 10.3666L23.9963 6.42399C23.386 6.11401 22.7563 5.85246 22.1073 5.63934L20.7317 9.84352C21.1483 9.98882 21.5648 10.1632 21.9717 10.3666ZM15.4039 9.84352C15.8301 9.7079 16.2757 9.60134 16.7213 9.53353L16.0335 5.16468C15.3651 5.27124 14.687 5.42623 14.038 5.63934L15.4039 9.84352ZM19.4046 9.53353L20.1021 5.16468C19.4337 5.05812 18.7459 5 18.0678 5V9.42697C18.5134 9.42697 18.9687 9.46572 19.4046 9.53353Z",
            fill: "white"
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "path",
          {
            d: "M18.0483 26.7765V22.3302C17.6705 22.3302 17.3024 22.2818 16.9343 22.1849L15.7719 26.4762C16.5178 26.67 17.283 26.7765 18.0483 26.7765ZM20.3248 26.4762C21.0707 26.2825 21.7778 25.9919 22.4462 25.6044L20.1988 21.7586C19.8792 21.9427 19.5304 22.088 19.172 22.1849L20.3248 26.4762ZM13.6601 25.6044L15.9075 21.7586C15.5878 21.5746 15.2875 21.3421 15.0163 21.0806L14.9775 21.0418L13.5632 22.5239L11.8195 24.1998L11.8486 24.2288C12.3911 24.7616 13.0014 25.2266 13.6601 25.6044ZM24.2577 24.2288C24.8002 23.6864 25.2748 23.0858 25.6526 22.4271L21.7681 20.199C21.5841 20.5187 21.3516 20.8093 21.0803 21.0806L24.2577 24.2288ZM10.444 22.4174L14.3285 20.199C14.1444 19.8794 13.9991 19.5403 13.9023 19.1819L9.57215 20.325C9.76589 21.0515 10.0662 21.7587 10.444 22.4174ZM26.5341 20.3347C26.7279 19.5984 26.8344 18.8429 26.8344 18.0873H22.3493C22.3493 18.4554 22.3009 18.8332 22.204 19.1916L26.5341 20.3347ZM13.7666 18.0776C13.7666 17.7095 13.8151 17.3317 13.9119 16.9733L9.57215 15.8302C9.37841 16.5664 9.27185 17.322 9.27185 18.0776H13.7666ZM22.1944 16.9829L26.5341 15.8399C26.3404 15.1037 26.0401 14.3965 25.6623 13.7378L21.7778 15.9561C21.9522 16.2855 22.0975 16.6245 22.1944 16.9829ZM14.3382 15.9561C14.5222 15.6461 14.745 15.3458 15.0163 15.0843L15.0259 15.0746L13.4179 13.4859L11.8777 11.9069L11.8486 11.936C11.3061 12.4688 10.8411 13.0791 10.4537 13.7281L14.3382 15.9561ZM21.0803 15.0843L22.669 13.5053L24.2964 11.9747L24.2577 11.936C23.7152 11.3935 23.1049 10.9382 22.4462 10.5507L20.1988 14.3965C20.5185 14.5806 20.8091 14.8034 21.0803 15.0649V15.0843ZM15.9075 14.3965C16.2271 14.2124 16.5759 14.0671 16.9343 13.9703L15.7912 9.67892C15.0453 9.87266 14.3382 10.1633 13.6698 10.5507L15.9075 14.3965ZM19.1623 13.98L20.3248 9.6886C19.5885 9.49486 18.8233 9.38831 18.058 9.38831V13.8347C18.4261 13.8347 18.8039 13.8831 19.1623 13.98Z",
            fill: "white"
          }
        )
      ]
    }
  );
}
function XLAYER() {
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(
    "svg",
    {
      width: "38",
      height: "38",
      viewBox: "0 0 38 38",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "rect",
          {
            y: "0.999573",
            width: "36",
            height: "36",
            rx: "6",
            fill: "url(#paint0_linear_287_487)"
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "path",
          {
            d: "M27.1921 22.667V29.2442H28.9861C29.1021 29.2437 29.2132 29.1974 29.2952 29.1151C29.3771 29.0329 29.4231 28.9216 29.4231 28.8056V23.1056C29.4231 22.9895 29.3771 22.8782 29.2952 22.796C29.2132 22.7138 29.1021 22.6674 28.9861 22.667H27.1921ZM27.1921 9.5V16.0772H28.9861C29.1021 16.0767 29.2132 16.0304 29.2952 15.9481C29.3771 15.8659 29.4231 15.7546 29.4231 15.6386V9.93858C29.4231 9.82254 29.3771 9.71122 29.2952 9.62902C29.2132 9.54681 29.1021 9.50042 28.9861 9.5H27.1921Z",
            fill: "#898989"
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "path",
          {
            d: "M30.5536 9.5V16.0772H31.2249C31.341 16.0767 31.4521 16.0304 31.534 15.9481C31.6159 15.8659 31.6619 15.7546 31.6619 15.6386V9.93858C31.6619 9.82281 31.6162 9.71173 31.5346 9.62957C31.453 9.54741 31.3423 9.50084 31.2265 9.5H30.5536ZM30.5583 22.667V29.2442H31.2281C31.2857 29.2442 31.3427 29.2328 31.3959 29.2108C31.4491 29.1887 31.4975 29.1564 31.5382 29.1157C31.5789 29.075 31.6112 29.0266 31.6333 28.9734C31.6553 28.9202 31.6667 28.8632 31.6667 28.8056V23.1056C31.6667 23.048 31.6553 22.991 31.6333 22.9377C31.6112 22.8845 31.5789 22.8362 31.5382 22.7955C31.4975 22.7547 31.4491 22.7224 31.3959 22.7004C31.3427 22.6783 31.2857 22.667 31.2281 22.667H30.5583Z",
            fill: "#575757"
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "path",
          {
            d: "M19.038 16.0914H13.3634C13.3062 16.0912 13.2495 16.1023 13.1966 16.124C13.1437 16.1456 13.0956 16.1775 13.055 16.2178C13.0144 16.2581 12.9822 16.306 12.9601 16.3587C12.938 16.4115 12.9266 16.4681 12.9264 16.5253V22.1572C12.9264 22.3963 13.1227 22.591 13.3634 22.591H19.0349C19.0921 22.5912 19.1487 22.5802 19.2016 22.5585C19.2545 22.5368 19.3026 22.5049 19.3432 22.4646C19.3838 22.4243 19.4161 22.3764 19.4381 22.3237C19.4602 22.2709 19.4717 22.2143 19.4719 22.1572V16.5253C19.4715 16.41 19.4254 16.2997 19.3438 16.2184C19.2622 16.1371 19.1517 16.0914 19.0365 16.0914M12.472 9.5H6.77196C6.65564 9.5 6.54408 9.54621 6.46183 9.62846C6.37958 9.71071 6.33337 9.82226 6.33337 9.93858V15.6386C6.33337 15.8808 6.52971 16.0772 6.77196 16.0772H12.472C12.5883 16.0772 12.6998 16.031 12.7821 15.9487C12.8643 15.8665 12.9105 15.7549 12.9105 15.6386V9.93858C12.9105 9.82226 12.8643 9.71071 12.7821 9.62846C12.6998 9.54621 12.5883 9.5 12.472 9.5ZM25.6215 9.5H19.9215C19.8052 9.5 19.6937 9.54621 19.6114 9.62846C19.5292 9.71071 19.483 9.82226 19.483 9.93858V15.6386C19.483 15.8808 19.6809 16.0772 19.9215 16.0772H25.6215C25.7379 16.0772 25.8494 16.031 25.9317 15.9487C26.0139 15.8665 26.0601 15.7549 26.0601 15.6386V9.93858C26.0601 9.82226 26.0139 9.71071 25.9317 9.62846C25.8494 9.54621 25.7379 9.5 25.6215 9.5ZM12.472 22.6528H6.77196C6.65564 22.6528 6.54408 22.699 6.46183 22.7812C6.37958 22.8635 6.33337 22.975 6.33337 23.0913V28.7913C6.33337 29.0336 6.52971 29.2283 6.77196 29.2283H12.472C12.588 29.2283 12.6993 29.1823 12.7815 29.1004C12.8637 29.0185 12.9101 28.9074 12.9105 28.7913V23.0913C12.9105 22.975 12.8643 22.8635 12.7821 22.7812C12.6998 22.699 12.5883 22.6528 12.472 22.6528ZM25.6215 22.6528H19.9215C19.8052 22.6528 19.6937 22.699 19.6114 22.7812C19.5292 22.8635 19.483 22.975 19.483 23.0913V28.7913C19.483 29.0336 19.6809 29.2283 19.9215 29.2283H25.6215C25.7376 29.2283 25.8489 29.1823 25.9311 29.1004C26.0133 29.0185 26.0597 28.9074 26.0601 28.7913V23.0913C26.0601 22.975 26.0139 22.8635 25.9317 22.7812C25.8494 22.699 25.7379 22.6528 25.6215 22.6528Z",
            fill: "white"
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx("defs", { children: /* @__PURE__ */ jsxRuntimeExports.jsxs(
          "linearGradient",
          {
            id: "paint0_linear_287_487",
            x1: "34",
            y1: "35.4996",
            x2: "1.5",
            y2: "3.49957",
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ jsxRuntimeExports.jsx("stop", { stopColor: "#040404" }),
              /* @__PURE__ */ jsxRuntimeExports.jsx("stop", { offset: "1", stopColor: "#282828" })
            ]
          }
        ) })
      ]
    }
  );
}
function OSMO$1() {
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      style: { maxHeight: "100%", maxWidth: "100%" },
      width: "256",
      height: "256",
      fill: "none",
      viewBox: "0 0 800 800",
      children: [
        /* @__PURE__ */ jsxRuntimeExports.jsxs("g", { clipPath: "url(#clip0)", children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            "path",
            {
              fill: "#5E12A0",
              d: "M673.964 193.237C667.62 168.805 647.227 144.373 610.519 117.174C581.062 95.5081 549.792 83.0615 524.867 83.0615C519.882 83.0615 515.35 83.5225 510.819 84.4445C499.489 86.7494 489.519 95.0471 483.174 107.494C475.47 122.245 473.658 142.068 478.643 154.053C480.455 157.741 482.721 162.351 485.44 166.5C461.422 181.251 447.826 185.4 446.013 185.861C508.553 207.067 560.669 251.321 593.298 308.944L593.751 303.413C595.111 288.2 599.642 270.683 605.987 252.704C612.332 254.548 618.676 255.47 625.021 255.47C641.788 255.47 656.29 248.555 665.354 236.109C674.418 223.662 678.043 207.067 673.964 193.237Z"
            }
          ),
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            "path",
            {
              fill: "url(#paint0_radial)",
              d: "M608.706 239.342C649.945 250.867 666.713 218.598 661.275 196.932C655.383 175.265 636.35 153.138 602.814 128.245C569.279 103.352 535.29 93.2098 513.537 97.8197C491.784 102.43 485.44 136.081 490.878 148.989C493.144 154.06 498.129 161.436 504.927 169.733C496.316 175.726 488.159 180.336 481.361 184.485C523.054 203.385 559.309 232.888 586.5 269.767C589.672 257.321 594.204 246.257 598.282 236.576C601.455 237.037 605.08 237.959 608.706 239.342Z"
            }
          ),
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            "path",
            {
              fill: "url(#paint1_radial)",
              d: "M372.594 691.101C512.504 691.101 625.924 575.729 625.924 433.41C625.924 291.091 512.504 175.719 372.594 175.719C232.685 175.719 119.265 291.091 119.265 433.41C119.265 575.729 232.685 691.101 372.594 691.101Z"
            }
          ),
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            "path",
            {
              fill: "#A98698",
              d: "M640.427 175.721C605.985 138.842 576.982 129.161 542.087 121.325C514.896 114.871 522.146 99.1973 555.229 102.424C539.367 96.8924 524.412 95.5094 513.536 97.8143C491.783 102.424 485.439 136.076 490.877 148.984C493.143 154.055 498.128 161.43 504.925 169.728C492.69 178.026 482.266 184.019 473.656 188.629C477.735 190.472 482.72 192.777 488.611 196.004C504.019 204.302 520.787 218.132 520.787 218.132C495.409 196.004 500.847 185.863 535.742 160.969C546.618 153.133 566.558 154.055 585.139 163.735C603.719 173.416 625.472 197.848 625.472 197.848L604.626 238.415C605.985 238.876 607.345 239.337 608.704 239.798C621.847 243.486 632.27 242.564 640.427 239.337C649.944 233.344 674.869 213.061 640.427 175.721Z",
              opacity: ".6"
            }
          ),
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            "path",
            {
              fill: "#5E12A0",
              d: "M541.631 143.45C550.695 147.138 562.478 153.592 576.979 163.273C594.2 174.797 609.155 187.705 618.672 197.847C602.811 219.052 592.388 248.094 586.043 268.377C589.215 272.987 592.841 277.597 596.013 282.207C599.185 270.682 604.624 253.626 611.875 236.569C613.687 237.03 615.953 237.03 618.219 237.03C623.657 237.03 630.002 236.108 634.987 231.96C638.612 229.194 642.691 224.123 642.238 214.903C642.238 206.144 635.44 195.081 621.391 181.712C611.421 172.031 597.826 161.429 584.23 151.748C545.257 125.472 518.066 118.096 505.83 130.543C497.672 138.84 498.579 148.982 501.298 156.358C486.796 166.039 474.56 172.953 466.403 177.563C471.841 179.407 476.826 181.712 482.264 184.017C496.766 176.18 517.613 162.812 541.631 143.45ZM627.283 209.371C628.642 211.676 629.095 213.981 629.095 215.364C629.095 219.513 627.736 220.896 626.83 221.818C625.017 223.201 621.391 224.123 618.219 224.123C620.938 218.591 624.11 213.981 627.283 209.371ZM515.347 140.684C516.706 139.301 520.332 138.379 526.223 139.301C521.691 142.989 517.159 146.216 512.628 149.443C512.174 146.216 512.627 142.989 515.347 140.684Z"
            }
          ),
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            "path",
            {
              fill: "#5E12A0",
              d: "M372.596 160.503C224.405 160.503 104.311 282.664 104.311 433.406C104.311 584.149 224.405 706.31 372.596 706.31C520.786 706.31 640.88 584.149 640.88 433.406C640.88 282.664 520.333 160.503 372.596 160.503ZM372.596 691.098C232.562 691.098 119.266 575.851 119.266 433.406C119.266 290.962 232.562 175.715 372.596 175.715C512.629 175.715 625.925 290.962 625.925 433.406C625.925 575.851 512.176 691.098 372.596 691.098Z"
            }
          ),
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            "path",
            {
              fill: "url(#paint2_linear)",
              d: "M372.594 691.101C512.504 691.101 625.924 575.729 625.924 433.41C625.924 291.091 512.504 175.719 372.594 175.719C232.685 175.719 119.265 291.091 119.265 433.41C119.265 575.729 232.685 691.101 372.594 691.101Z",
              opacity: ".6"
            }
          ),
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            "path",
            {
              fill: "#A98698",
              d: "M370.783 659.75C232.562 637.161 138.754 504.858 161.413 364.258C171.383 302.025 202.199 249.011 245.705 210.75C182.259 248.089 135.128 313.088 122.439 392.378C100.233 532.978 194.042 665.281 331.809 687.87C408.851 700.777 483.173 676.345 538.008 628.403C489.517 656.984 430.603 669.43 370.783 659.75Z",
              opacity: ".6"
            }
          ),
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            "path",
            {
              fill: "url(#paint3_linear)",
              d: "M412.93 179.411C349.031 168.808 286.945 183.56 236.189 216.29C235.282 217.212 234.376 218.133 234.376 218.133C253.863 206.148 282.413 195.545 282.413 195.545C208.998 238.878 186.339 288.203 186.339 288.203C214.889 231.963 298.728 192.318 364.439 189.552C430.151 186.786 473.203 206.609 525.772 249.481C578.342 292.813 610.064 381.322 606.892 451.392C604.173 521.462 567.918 578.163 567.918 578.163C592.844 545.433 607.799 521.462 617.315 497.03C619.128 489.654 620.941 482.278 621.847 474.441C644.506 334.302 551.151 201.999 412.93 179.411Z",
              opacity: ".6"
            }
          ),
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            "path",
            {
              fill: "url(#paint4_linear)",
              d: "M613.235 431.104C613.235 566.173 505.377 675.887 372.595 675.887C239.812 675.887 131.501 566.173 131.501 431.104H613.235Z"
            }
          ),
          /* @__PURE__ */ jsxRuntimeExports.jsx("g", { opacity: ".6", children: /* @__PURE__ */ jsxRuntimeExports.jsx(
            "path",
            {
              fill: "url(#paint5_linear)",
              d: "M594.201 431.104C594.201 562.946 491.781 670.817 363.077 675.887C366.25 675.887 369.422 675.887 372.594 675.887C505.377 675.887 613.234 566.173 613.234 431.104H594.201Z",
              opacity: ".6"
            }
          ) }),
          /* @__PURE__ */ jsxRuntimeExports.jsx("g", { opacity: ".7", children: /* @__PURE__ */ jsxRuntimeExports.jsx(
            "path",
            {
              fill: "url(#paint6_linear)",
              d: "M165.49 431.104H131.501C131.501 566.173 239.359 675.887 372.142 675.887C378.033 675.887 383.471 675.887 388.909 675.426C264.284 666.207 165.49 560.18 165.49 431.104Z",
              opacity: ".7"
            }
          ) }),
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            "path",
            {
              fill: "url(#paint7_linear)",
              d: "M612.781 433.407C612.781 405.287 564.744 389.153 500.845 383.621C454.621 379.933 407.943 384.543 354.467 401.138C308.243 414.968 266.55 412.663 236.187 408.975C168.662 401.138 131.501 400.216 131.501 433.407C131.501 481.35 227.576 541.278 371.688 520.533C444.651 509.931 482.265 488.264 525.317 473.513C571.995 457.839 612.781 458.3 612.781 433.407Z"
            }
          ),
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            "path",
            {
              fill: "#fff",
              d: "M451.448 317.236C473.974 317.236 492.234 298.661 492.234 275.747C492.234 252.833 473.974 234.258 451.448 234.258C428.922 234.258 410.661 252.833 410.661 275.747C410.661 298.661 428.922 317.236 451.448 317.236Z"
            }
          ),
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            "path",
            {
              fill: "#fff",
              d: "M518.067 348.13C527.578 348.13 535.288 340.287 535.288 330.612C535.288 320.938 527.578 313.095 518.067 313.095C508.556 313.095 500.846 320.938 500.846 330.612C500.846 340.287 508.556 348.13 518.067 348.13Z"
            }
          ),
          /* @__PURE__ */ jsxRuntimeExports.jsx("g", { opacity: ".6", children: /* @__PURE__ */ jsxRuntimeExports.jsx(
            "path",
            {
              fill: "url(#paint8_linear)",
              d: "M579.703 242.563C579.25 242.563 578.796 242.563 578.796 242.563C576.077 242.102 574.265 239.336 574.718 236.109C578.796 214.904 596.017 194.62 596.924 193.698C598.736 191.393 602.362 191.393 604.175 193.237C606.441 195.081 606.44 198.769 604.628 200.613C604.175 201.074 588.313 219.975 584.688 238.414C584.235 241.18 581.969 242.563 579.703 242.563Z",
              opacity: ".6"
            }
          ) }),
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            "path",
            {
              fill: "#fff",
              d: "M355.905 625.64C362.913 625.64 368.594 619.861 368.594 612.732C368.594 605.604 362.913 599.825 355.905 599.825C348.897 599.825 343.216 605.604 343.216 612.732C343.216 619.861 348.897 625.64 355.905 625.64Z",
              opacity: ".2"
            }
          ),
          /* @__PURE__ */ jsxRuntimeExports.jsx("g", { opacity: ".4", children: /* @__PURE__ */ jsxRuntimeExports.jsx(
            "path",
            {
              fill: "url(#paint9_linear)",
              d: "M348.577 621.135C343.592 616.065 343.592 607.767 348.577 602.696C349.484 601.774 350.39 601.313 351.296 600.391C349.484 600.852 348.124 601.774 346.765 603.157C341.78 608.228 341.78 616.526 346.765 621.596C350.843 625.745 357.188 626.667 362.173 623.901C357.641 625.745 352.203 624.823 348.577 621.135Z",
              opacity: ".6"
            }
          ) }),
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            "path",
            {
              fill: "#fff",
              d: "M360.361 609.042C361.863 609.042 363.08 607.804 363.08 606.276C363.08 604.749 361.863 603.51 360.361 603.51C358.859 603.51 357.642 604.749 357.642 606.276C357.642 607.804 358.859 609.042 360.361 609.042Z",
              opacity: ".3"
            }
          ),
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            "path",
            {
              fill: "#fff",
              d: "M422.07 619.19C429.078 619.19 434.759 613.411 434.759 606.282C434.759 599.153 429.078 593.375 422.07 593.375C415.062 593.375 409.381 599.153 409.381 606.282C409.381 613.411 415.062 619.19 422.07 619.19Z",
              opacity: ".2"
            }
          ),
          /* @__PURE__ */ jsxRuntimeExports.jsx("g", { opacity: ".4", children: /* @__PURE__ */ jsxRuntimeExports.jsx(
            "path",
            {
              fill: "url(#paint10_linear)",
              d: "M414.742 614.685C409.757 609.614 409.757 601.317 414.742 596.246C415.648 595.324 416.555 594.863 417.461 593.941C415.648 594.402 414.289 595.324 412.929 596.707C407.944 601.778 407.944 610.075 412.929 615.146C417.008 619.295 423.352 620.217 428.337 617.451C423.806 619.295 418.367 618.373 414.742 614.685Z",
              opacity: ".6"
            }
          ) }),
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            "path",
            {
              fill: "#fff",
              d: "M426.526 602.592C428.027 602.592 429.245 601.354 429.245 599.826C429.245 598.298 428.027 597.06 426.526 597.06C425.024 597.06 423.806 598.298 423.806 599.826C423.806 601.354 425.024 602.592 426.526 602.592Z",
              opacity: ".3"
            }
          ),
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            "path",
            {
              fill: "#fff",
              d: "M389.361 649.153C394.617 649.153 398.878 644.819 398.878 639.472C398.878 634.126 394.617 629.792 389.361 629.792C384.105 629.792 379.845 634.126 379.845 639.472C379.845 644.819 384.105 649.153 389.361 649.153Z",
              opacity: ".2"
            }
          ),
          /* @__PURE__ */ jsxRuntimeExports.jsx("g", { opacity: ".4", children: /* @__PURE__ */ jsxRuntimeExports.jsx(
            "path",
            {
              fill: "url(#paint11_linear)",
              d: "M383.923 645.57C380.298 641.882 380.298 635.429 383.923 631.741C384.376 631.28 385.283 630.819 385.736 630.358C384.376 630.819 383.47 631.741 382.564 632.663C378.938 636.351 378.938 642.805 382.564 646.492C385.736 649.719 390.268 650.18 394.346 647.875C390.721 649.258 386.642 648.336 383.923 645.57Z",
              opacity: ".6"
            }
          ) }),
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            "path",
            {
              fill: "#fff",
              d: "M392.532 636.243C393.534 636.243 394.345 635.418 394.345 634.4C394.345 633.381 393.534 632.556 392.532 632.556C391.531 632.556 390.72 633.381 390.72 634.4C390.72 635.418 391.531 636.243 392.532 636.243Z",
              opacity: ".3"
            }
          ),
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            "path",
            {
              fill: "#fff",
              d: "M447.825 642.238C453.081 642.238 457.342 637.904 457.342 632.558C457.342 627.211 453.081 622.877 447.825 622.877C442.569 622.877 438.308 627.211 438.308 632.558C438.308 637.904 442.569 642.238 447.825 642.238Z",
              opacity: ".2"
            }
          ),
          /* @__PURE__ */ jsxRuntimeExports.jsx("g", { opacity: ".4", children: /* @__PURE__ */ jsxRuntimeExports.jsx(
            "path",
            {
              fill: "url(#paint12_linear)",
              d: "M442.387 638.656C438.761 634.968 438.761 628.514 442.387 624.826C442.84 624.365 443.746 623.904 444.199 623.443C442.84 623.904 441.934 624.826 441.027 625.748C437.402 629.436 437.402 635.89 441.027 639.578C444.199 642.805 448.731 643.266 452.81 640.961C449.184 642.344 445.106 641.422 442.387 638.656Z",
              opacity: ".6"
            }
          ) }),
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            "path",
            {
              fill: "#fff",
              d: "M450.996 629.338C451.997 629.338 452.809 628.512 452.809 627.494C452.809 626.475 451.997 625.65 450.996 625.65C449.995 625.65 449.183 626.475 449.183 627.494C449.183 628.512 449.995 629.338 450.996 629.338Z",
              opacity: ".3"
            }
          ),
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            "path",
            {
              fill: "#fff",
              d: "M301.896 621.034C313.41 621.034 322.743 611.54 322.743 599.829C322.743 588.118 313.41 578.624 301.896 578.624C290.383 578.624 281.05 588.118 281.05 599.829C281.05 611.54 290.383 621.034 301.896 621.034Z",
              opacity: ".2"
            }
          ),
          /* @__PURE__ */ jsxRuntimeExports.jsx("g", { opacity: ".4", children: /* @__PURE__ */ jsxRuntimeExports.jsx(
            "path",
            {
              fill: "url(#paint13_linear)",
              d: "M290.128 613.192C281.971 604.895 281.971 591.526 290.128 583.228C291.488 581.845 292.847 580.923 294.66 580.001C291.941 580.923 289.675 582.767 287.409 584.611C279.252 592.909 279.252 606.278 287.409 614.575C294.207 621.49 304.63 622.873 312.787 617.802C305.083 621.029 296.019 619.646 290.128 613.192Z",
              opacity: ".6"
            }
          ) }),
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            "path",
            {
              fill: "#fff",
              d: "M309.15 593.372C311.653 593.372 313.682 591.308 313.682 588.762C313.682 586.216 311.653 584.152 309.15 584.152C306.647 584.152 304.618 586.216 304.618 588.762C304.618 591.308 306.647 593.372 309.15 593.372Z",
              opacity: ".3"
            }
          ),
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            "path",
            {
              fill: "#fff",
              d: "M488.23 568.936C499.743 568.936 509.076 559.442 509.076 547.731C509.076 536.019 499.743 526.525 488.23 526.525C476.717 526.525 467.383 536.019 467.383 547.731C467.383 559.442 476.717 568.936 488.23 568.936Z",
              opacity: ".2"
            }
          ),
          /* @__PURE__ */ jsxRuntimeExports.jsx("g", { opacity: ".4", children: /* @__PURE__ */ jsxRuntimeExports.jsx(
            "path",
            {
              fill: "url(#paint14_linear)",
              d: "M475.92 561.103C467.763 552.805 467.763 539.436 475.92 531.139C477.28 529.756 478.639 528.834 480.452 527.912C477.733 528.834 475.467 530.678 473.201 532.521C465.044 540.819 465.044 554.188 473.201 562.486C479.999 569.4 490.422 570.783 498.579 565.713C490.875 568.939 482.265 567.556 475.92 561.103Z",
              opacity: ".6"
            }
          ) }),
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            "path",
            {
              fill: "#fff",
              d: "M495.407 541.282C497.91 541.282 499.939 539.218 499.939 536.672C499.939 534.126 497.91 532.062 495.407 532.062C492.904 532.062 490.875 534.126 490.875 536.672C490.875 539.218 492.904 541.282 495.407 541.282Z",
              opacity: ".3"
            }
          )
        ] }),
        /* @__PURE__ */ jsxRuntimeExports.jsxs("defs", { children: [
          /* @__PURE__ */ jsxRuntimeExports.jsxs(
            "radialGradient",
            {
              id: "paint0_radial",
              cx: "0",
              cy: "0",
              r: "1",
              gradientTransform: "translate(653.009 167.889) scale(202.547 206.035)",
              gradientUnits: "userSpaceOnUse",
              children: [
                /* @__PURE__ */ jsxRuntimeExports.jsx("stop", { stopColor: "#FFEAFF", stopOpacity: ".6" }),
                /* @__PURE__ */ jsxRuntimeExports.jsx("stop", { offset: ".681", stopColor: "#A087C9" }),
                /* @__PURE__ */ jsxRuntimeExports.jsx("stop", { offset: "1", stopColor: "#10002F" })
              ]
            }
          ),
          /* @__PURE__ */ jsxRuntimeExports.jsxs(
            "radialGradient",
            {
              id: "paint1_radial",
              cx: "0",
              cy: "0",
              r: "1",
              gradientTransform: "translate(540.32 255.753) scale(495.56 504.093)",
              gradientUnits: "userSpaceOnUse",
              children: [
                /* @__PURE__ */ jsxRuntimeExports.jsx("stop", { stopColor: "#FFEAFF", stopOpacity: ".6" }),
                /* @__PURE__ */ jsxRuntimeExports.jsx("stop", { offset: ".681", stopColor: "#A087C9" }),
                /* @__PURE__ */ jsxRuntimeExports.jsx("stop", { offset: "1", stopColor: "#10002F" })
              ]
            }
          ),
          /* @__PURE__ */ jsxRuntimeExports.jsxs(
            "linearGradient",
            {
              id: "paint2_linear",
              x1: "331.959",
              x2: "415.726",
              y1: "687.445",
              y2: "179.399",
              gradientUnits: "userSpaceOnUse",
              children: [
                /* @__PURE__ */ jsxRuntimeExports.jsx("stop", { stopColor: "#81FFFF" }),
                /* @__PURE__ */ jsxRuntimeExports.jsx("stop", { offset: ".62", stopColor: "#fff", stopOpacity: "0" })
              ]
            }
          ),
          /* @__PURE__ */ jsxRuntimeExports.jsxs(
            "linearGradient",
            {
              id: "paint3_linear",
              x1: "551.129",
              x2: "338.385",
              y1: "258.408",
              y2: "450.302",
              gradientUnits: "userSpaceOnUse",
              children: [
                /* @__PURE__ */ jsxRuntimeExports.jsx("stop", { offset: ".289", stopColor: "#fff" }),
                /* @__PURE__ */ jsxRuntimeExports.jsx("stop", { offset: ".78", stopColor: "#fff", stopOpacity: "0" })
              ]
            }
          ),
          /* @__PURE__ */ jsxRuntimeExports.jsxs(
            "linearGradient",
            {
              id: "paint4_linear",
              x1: "131.705",
              x2: "613.118",
              y1: "553.353",
              y2: "553.353",
              gradientUnits: "userSpaceOnUse",
              children: [
                /* @__PURE__ */ jsxRuntimeExports.jsx("stop", { stopColor: "#0002E9" }),
                /* @__PURE__ */ jsxRuntimeExports.jsx("stop", { offset: ".995", stopColor: "#FF00C7" })
              ]
            }
          ),
          /* @__PURE__ */ jsxRuntimeExports.jsxs(
            "linearGradient",
            {
              id: "paint5_linear",
              x1: "635.906",
              x2: "369.659",
              y1: "452.584",
              y2: "699.942",
              gradientUnits: "userSpaceOnUse",
              children: [
                /* @__PURE__ */ jsxRuntimeExports.jsx("stop", { offset: ".289", stopColor: "#fff" }),
                /* @__PURE__ */ jsxRuntimeExports.jsx("stop", { offset: ".78", stopColor: "#fff", stopOpacity: "0" })
              ]
            }
          ),
          /* @__PURE__ */ jsxRuntimeExports.jsxs(
            "linearGradient",
            {
              id: "paint6_linear",
              x1: "131.705",
              x2: "389.259",
              y1: "553.352",
              y2: "553.352",
              gradientUnits: "userSpaceOnUse",
              children: [
                /* @__PURE__ */ jsxRuntimeExports.jsx("stop", { stopColor: "#000292" }),
                /* @__PURE__ */ jsxRuntimeExports.jsx("stop", { offset: ".995", stopColor: "#7D00C7" })
              ]
            }
          ),
          /* @__PURE__ */ jsxRuntimeExports.jsxs(
            "linearGradient",
            {
              id: "paint7_linear",
              x1: "132.029",
              x2: "612.795",
              y1: "453.743",
              y2: "453.743",
              gradientUnits: "userSpaceOnUse",
              children: [
                /* @__PURE__ */ jsxRuntimeExports.jsx("stop", { stopColor: "#000292" }),
                /* @__PURE__ */ jsxRuntimeExports.jsx("stop", { offset: ".995", stopColor: "#BE00C7" })
              ]
            }
          ),
          /* @__PURE__ */ jsxRuntimeExports.jsxs(
            "linearGradient",
            {
              id: "paint8_linear",
              x1: "604.91",
              x2: "569.494",
              y1: "191.453",
              y2: "248.03",
              gradientUnits: "userSpaceOnUse",
              children: [
                /* @__PURE__ */ jsxRuntimeExports.jsx("stop", { offset: ".289", stopColor: "#fff" }),
                /* @__PURE__ */ jsxRuntimeExports.jsx("stop", { offset: ".78", stopColor: "#fff", stopOpacity: "0" })
              ]
            }
          ),
          /* @__PURE__ */ jsxRuntimeExports.jsxs(
            "linearGradient",
            {
              id: "paint9_linear",
              x1: "343.013",
              x2: "362.187",
              y1: "613.233",
              y2: "613.233",
              gradientUnits: "userSpaceOnUse",
              children: [
                /* @__PURE__ */ jsxRuntimeExports.jsx("stop", { offset: ".289", stopColor: "#fff" }),
                /* @__PURE__ */ jsxRuntimeExports.jsx("stop", { offset: ".78", stopColor: "#fff", stopOpacity: "0" })
              ]
            }
          ),
          /* @__PURE__ */ jsxRuntimeExports.jsxs(
            "linearGradient",
            {
              id: "paint10_linear",
              x1: "409.132",
              x2: "428.305",
              y1: "606.695",
              y2: "606.695",
              gradientUnits: "userSpaceOnUse",
              children: [
                /* @__PURE__ */ jsxRuntimeExports.jsx("stop", { offset: ".289", stopColor: "#fff" }),
                /* @__PURE__ */ jsxRuntimeExports.jsx("stop", { offset: ".78", stopColor: "#fff", stopOpacity: "0" })
              ]
            }
          ),
          /* @__PURE__ */ jsxRuntimeExports.jsxs(
            "linearGradient",
            {
              id: "paint11_linear",
              x1: "379.785",
              x2: "394.18",
              y1: "639.688",
              y2: "639.688",
              gradientUnits: "userSpaceOnUse",
              children: [
                /* @__PURE__ */ jsxRuntimeExports.jsx("stop", { offset: ".289", stopColor: "#fff" }),
                /* @__PURE__ */ jsxRuntimeExports.jsx("stop", { offset: ".78", stopColor: "#fff", stopOpacity: "0" })
              ]
            }
          ),
          /* @__PURE__ */ jsxRuntimeExports.jsxs(
            "linearGradient",
            {
              id: "paint12_linear",
              x1: "438.053",
              x2: "452.447",
              y1: "632.755",
              y2: "632.755",
              gradientUnits: "userSpaceOnUse",
              children: [
                /* @__PURE__ */ jsxRuntimeExports.jsx("stop", { offset: ".289", stopColor: "#fff" }),
                /* @__PURE__ */ jsxRuntimeExports.jsx("stop", { offset: ".78", stopColor: "#fff", stopOpacity: "0" })
              ]
            }
          ),
          /* @__PURE__ */ jsxRuntimeExports.jsxs(
            "linearGradient",
            {
              id: "paint13_linear",
              x1: "281.083",
              x2: "312.395",
              y1: "600.365",
              y2: "600.365",
              gradientUnits: "userSpaceOnUse",
              children: [
                /* @__PURE__ */ jsxRuntimeExports.jsx("stop", { offset: ".289", stopColor: "#fff" }),
                /* @__PURE__ */ jsxRuntimeExports.jsx("stop", { offset: ".78", stopColor: "#fff", stopOpacity: "0" })
              ]
            }
          ),
          /* @__PURE__ */ jsxRuntimeExports.jsxs(
            "linearGradient",
            {
              id: "paint14_linear",
              x1: "467.049",
              x2: "498.361",
              y1: "548.259",
              y2: "548.259",
              gradientUnits: "userSpaceOnUse",
              children: [
                /* @__PURE__ */ jsxRuntimeExports.jsx("stop", { offset: ".289", stopColor: "#fff" }),
                /* @__PURE__ */ jsxRuntimeExports.jsx("stop", { offset: ".78", stopColor: "#fff", stopOpacity: "0" })
              ]
            }
          ),
          /* @__PURE__ */ jsxRuntimeExports.jsx("clipPath", { id: "clip0", children: /* @__PURE__ */ jsxRuntimeExports.jsx("rect", { width: "800", height: "800", fill: "#fff" }) })
        ] })
      ]
    }
  );
}
function WORLD$1() {
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(
    "svg",
    {
      width: "36",
      height: "36",
      viewBox: "0 0 36 36",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx("rect", { width: "36", height: "36", rx: "6", fill: "black" }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "path",
          {
            d: "M29.1239 11.0384L18.375 11.0554C14.8158 11.0554 11.9303 13.9408 11.9303 17.5C11.9303 21.0592 14.8158 23.9447 18.375 23.9447H28.726",
            stroke: "white",
            strokeWidth: "2.25944",
            strokeMiterlimit: "10",
            strokeLinecap: "round"
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "path",
          {
            d: "M6.17065 17.5H31.0001",
            stroke: "white",
            strokeWidth: "2.25944",
            strokeMiterlimit: "10",
            strokeLinecap: "round"
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "path",
          {
            d: "M18.5 5C25.4036 5 31 10.5964 31 17.5C31 24.4036 25.4036 30 18.5 30C11.5964 30 6 24.4036 6 17.5C6 10.5964 11.5964 5 18.5 5Z",
            stroke: "white",
            strokeWidth: "2.25944",
            strokeMiterlimit: "10",
            strokeLinecap: "round"
          }
        )
      ]
    }
  );
}
const useStyles$p = makeStyles()((C, { size: e }) => ({
  container: {
    height: e,
    width: e,
    ...CENTER
  },
  iconImage: {
    width: e,
    height: e
  },
  icon: {
    maxHeight: "100%",
    maxWidth: "100%"
  }
})), iconMap$1 = {
  Moonbeam: GLMR$1(),
  Avalanche: AVAX$1(),
  Bsc: BSC$1(),
  Celo: CELO$1(),
  Ethereum: ETH$1(),
  Fantom: FTM$1(),
  Polygon: MATIC(),
  Solana: SOL$1(),
  Sui: SUI$1(),
  Aptos: APT$1(),
  Arbitrum: ARBITRUM$1(),
  Optimism: OPTIMISM$1(),
  Base: BASE$1(),
  Klaytn: KAIA(),
  Scroll: SCROLL$1(),
  Blast: BLAST$1(),
  Xlayer: XLAYER(),
  Mantle: MANTLE(),
  Osmosis: OSMO$1(),
  Worldchain: WORLD$1()
};
function isBuiltinChainIcon(C) {
  return Object.keys(iconMap$1).includes(C);
}
function ChainIconComponent(C) {
  const e = C.height || 36, { classes: T } = useStyles$p({ size: e });
  let $ = noIcon$1;
  return isBuiltinChainIcon(C.icon) ? $ = iconMap$1[C.icon] || noIcon$1 : typeof C.icon == "string" && ($ = /* @__PURE__ */ jsxRuntimeExports.jsx("img", { className: T.iconImage, src: C.icon })), /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: T.container, children: $ });
}
const PlusIcon = createSvgIcon$1(
  /* @__PURE__ */ jsxRuntimeExports.jsxs(
    "svg",
    {
      width: "36",
      height: "36",
      viewBox: "0 0 36 36",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx("rect", { width: "36", height: "36", rx: "6", fill: "#2E2E34" }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "path",
          {
            d: "M17.1429 17.6429V12.5H18.8571V17.6429H24V19.3571H18.8571V24.5H17.1429V19.3571H12V17.6429H17.1429Z",
            fill: "white"
          }
        )
      ]
    }
  ),
  "Plus"
), useStyles$o = makeStyles()((C) => ({
  input: {
    "& fieldset": {
      borderRadius: "100vh"
    },
    "& input::placeholder": {
      color: C.palette.text.primary,
      opacity: 0.2
    }
  },
  icon: {
    height: 20,
    width: 20,
    color: C.palette.text.primary,
    opacity: 0.2
  }
}));
function SearchInput(C) {
  const { classes: e } = useStyles$o();
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    TextField,
    {
      className: e.input,
      autoFocus: !0,
      fullWidth: !0,
      inputProps: {
        style: {
          fontSize: 16,
          height: 22,
          lineHeight: 22
        }
      },
      placeholder: C.placeholder,
      size: "small",
      sx: {
        // Root class for the input field
        "& .MuiOutlinedInput-root": {
          // Class for the input placeholder text
          "& .MuiOutlinedInput-input::placeholder": {
            fontWeight: 300
          },
          // Class for the border around the input field
          "& .MuiOutlinedInput-notchedOutline": {
            borderWidth: "1px"
          }
        }
      },
      variant: "outlined",
      value: C.value,
      onChange: (T) => C.onChange(T.target.value),
      InputProps: {
        startAdornment: /* @__PURE__ */ jsxRuntimeExports.jsx(InputAdornment, { position: "start", children: /* @__PURE__ */ jsxRuntimeExports.jsx(SearchIcon, { className: e.icon }) })
      }
    }
  );
}
const useStyles$n = makeStyles()(() => ({
  wrapper: {
    maxHeight: 240,
    display: "flex",
    flexDirection: "column"
  },
  searchList: {
    marginTop: 12,
    overflow: "auto"
  }
}));
function SearchableList(C) {
  const { classes: e } = useStyles$n(), T = useCustomScrollbar(), [$, V] = useState(""), J = useMemo(() => C.items.filter((ee) => C.filterFn(ee, $)), [C.items, C.filterFn, $]);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(Box, { className: `${e.wrapper} ${(C == null ? void 0 : C.className) ?? ""}`, children: [
    C.title,
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      SearchInput,
      {
        value: $,
        onChange: V,
        placeholder: C.searchPlaceholder
      }
    ),
    /* @__PURE__ */ jsxRuntimeExports.jsxs(List, { className: joinClass([e.searchList, T]), children: [
      C.listTitle,
      C.loading || J.map(C.renderFn)
    ] })
  ] });
}
const SearchableList$1 = memo(SearchableList), useStyles$m = makeStyles()((C) => ({
  card: {
    width: "420px",
    [C.breakpoints.down("sm")]: {
      maxWidth: "420px",
      width: "360px"
    },
    "@media (max-width: 366px)": {
      width: "330px"
    }
  },
  cardContent: {
    paddingBottom: 0,
    [C.breakpoints.down("sm")]: {
      padding: "16px 10px",
      ":last-child": {
        padding: "16px 10px"
      }
    }
  },
  title: {
    fontSize: "14px",
    marginBottom: "12px"
  },
  chainSearch: {
    maxHeight: "400px"
  },
  chainButton: {
    display: "flex",
    flexDirection: "column",
    padding: "8px",
    border: "1px solid transparent",
    borderRadius: "8px",
    "&.Mui-selected": {
      border: "1px solid",
      borderColor: C.palette.primary.main
    }
  },
  chainItem: {
    display: "flex",
    flexDirection: "row",
    padding: "8px",
    borderRadius: "8px"
  }
})), SHORT_LIST_SIZE = 5, SHORT_LIST_SIZE_MOBILE = 4, ChainList = (C) => {
  const { classes: e } = useStyles$m(), T = useTheme$1(), $ = useMediaQuery(T.breakpoints.down("sm")), {
    chainList: V,
    selectedChainConfig: J,
    showSearch: ee,
    setShowSearch: te,
    onChainSelect: re
  } = C, ie = useMemo(() => {
    const ue = V ?? [], fe = J, he = ue.findIndex((xe) => xe.key === (fe == null ? void 0 : fe.key)), me = $ ? SHORT_LIST_SIZE_MOBILE : SHORT_LIST_SIZE;
    return fe && he && he >= me ? [fe, ...ue.slice(0, me - 1)] : ue.slice(0, me);
  }, [$, V, J]), se = useMemo(() => /* @__PURE__ */ jsxRuntimeExports.jsxs(List, { component: Stack, direction: "row", children: [
    ie.map((ue) => /* @__PURE__ */ jsxRuntimeExports.jsx(Tooltip, { title: ue.displayName, children: /* @__PURE__ */ jsxRuntimeExports.jsxs(
      ListItemButton,
      {
        selected: (J == null ? void 0 : J.key) === ue.key,
        className: e.chainButton,
        onClick: () => re(ue.key),
        children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(ChainIconComponent, { icon: ue.icon }),
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            Typography,
            {
              fontSize: "12px",
              lineHeight: "12px",
              marginTop: "8px",
              whiteSpace: "nowrap",
              children: ue.symbol
            }
          )
        ]
      },
      ue.key
    ) })),
    /* @__PURE__ */ jsxRuntimeExports.jsxs(
      ListItemButton,
      {
        className: e.chainButton,
        onClick: () => {
          te(!0);
        },
        children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(PlusIcon, { sx: { height: "36px", width: "36px" } }),
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            Typography,
            {
              fontSize: "12px",
              lineHeight: "12px",
              marginTop: "8px",
              whiteSpace: "nowrap",
              children: "other"
            }
          )
        ]
      }
    )
  ] }), [
    e.chainButton,
    re,
    J == null ? void 0 : J.key,
    te,
    ie
  ]), de = useMemo(
    () => /* @__PURE__ */ jsxRuntimeExports.jsx(
      SearchableList$1,
      {
        searchPlaceholder: "Search for a chain",
        className: e.chainSearch,
        items: V ?? [],
        filterFn: (ue, fe) => !fe || ue.displayName.toLowerCase().includes(fe.toLowerCase()),
        renderFn: (ue) => /* @__PURE__ */ jsxRuntimeExports.jsxs(
          ListItemButton,
          {
            dense: !0,
            className: e.chainItem,
            onClick: () => {
              re(ue.key), te(!1);
            },
            children: [
              /* @__PURE__ */ jsxRuntimeExports.jsx(ListItemIcon, { sx: { minWidth: "50px" }, children: /* @__PURE__ */ jsxRuntimeExports.jsx(ChainIconComponent, { icon: ue.icon, height: 36 }) }),
              /* @__PURE__ */ jsxRuntimeExports.jsx(Typography, { fontSize: "16px", fontWeight: 500, children: ue.displayName })
            ]
          },
          ue.key
        )
      }
    ),
    [
      V,
      e.chainItem,
      e.chainSearch,
      re,
      te
    ]
  );
  return /* @__PURE__ */ jsxRuntimeExports.jsx(Card, { className: e.card, variant: "elevation", children: /* @__PURE__ */ jsxRuntimeExports.jsxs(CardContent, { className: e.cardContent, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(Typography, { className: e.title, fontSize: "16px", fontWeight: 500, children: "Select a network" }),
    ee ? de : se
  ] }) });
}, useGetTokenBalances = (C, e, T) => {
  const [$, V] = useState(!1), [J, ee] = useState({}), te = useSelector(
    (ie) => ie.transferInput.balances
  ), re = useDispatch();
  return useEffect(() => {
    if (V(!0), ee({}), !C || !e || !config$1.chains[e] || T.length === 0) {
      V(!1);
      return;
    }
    if (!config$1.chains[e]) {
      V(!1);
      return;
    }
    let se = !0;
    return (async () => {
      const ue = {}, fe = [], he = Date.now(), me = he - 5 * 60 * 1e3;
      let xe = !1;
      for (const ve of T) {
        const Te = accessBalance(
          te,
          C,
          e,
          ve.key
        );
        Te && Te.lastUpdated > me ? ue[ve.key] = Te : fe.push(ve);
      }
      if (fe.length > 0)
        try {
          const Te = (await getWormholeContextV2()).getPlatform(chainToPlatform(e)), we = Te.getRpc(e), Ee = {}, Me = [];
          for (const ke of fe) {
            const _e = getTokenDecimals(e, ke);
            ue[ke.key] = {
              balance: fromBaseUnits(0n, _e),
              lastUpdated: he
            };
            try {
              let De = null;
              if (ke.nativeChain === e && ke.tokenId === void 0)
                Me.push("native"), Ee.native = ke;
              else {
                const Fe = await getTokenBridgeWrappedTokenAddress(
                  ke,
                  e
                );
                if (Fe)
                  De = Fe.toString();
                else {
                  console.warn(
                    `No foreign address for ${ke.key} on chain ${e}`
                  );
                  continue;
                }
                Ee[De] = ke, Me.push(De);
              }
            } catch (De) {
              console.error(De);
            }
          }
          if (Me.length === 0)
            return;
          const Ie = await Te.utils().getBalances(
            e,
            we,
            C,
            Me
          );
          for (const ke in Ie) {
            const _e = Ee[ke], De = getTokenDecimals(e, _e), Fe = Ie[ke], Ae = fromBaseUnits(Fe ?? 0n, De);
            ue[_e.key] = {
              balance: Ae,
              lastUpdated: he
            };
          }
          xe = !0;
        } catch (ve) {
          console.error("Failed to get token balances", ve);
        }
      se && (V(!1), ee(ue), xe && re(
        updateBalances({
          address: C,
          chain: e,
          balances: ue
        })
      ));
    })(), () => {
      se = !1;
    };
  }, [te, e, re, T, C]), { isFetching: $, balances: J };
};
var OpenInNew = {}, _interopRequireDefault$5 = interopRequireDefaultExports;
Object.defineProperty(OpenInNew, "__esModule", {
  value: !0
});
var default_1$5 = OpenInNew.default = void 0, _createSvgIcon$5 = _interopRequireDefault$5(requireCreateSvgIcon()), _jsxRuntime$5 = jsxRuntimeExports;
default_1$5 = OpenInNew.default = (0, _createSvgIcon$5.default)(/* @__PURE__ */ (0, _jsxRuntime$5.jsx)("path", {
  d: "M19 19H5V5h7V3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2v-7h-2zM14 3v2h3.59l-9.83 9.83 1.41 1.41L19 6.41V10h2V3z"
}), "OpenInNew");
const PREFIX = "data:image/svg+xml;base64,";
function chainToIcon(C) {
  if (C === "Solana")
    return PREFIX + "PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI5NiIgaGVpZ2h0PSI4NCIgZmlsbD0ibm9uZSI+PGcgY2xpcC1wYXRoPSJ1cmwoI2EpIj48cGF0aCBmaWxsPSJ1cmwoI2IpIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xNy4zNjggNjQuMDUyQTMuMjE0IDMuMjE0IDAgMCAxIDE5Ljc0NCA2M2w3My4zMTIuMDZhMS42MTIgMS42MTIgMCAwIDEgMS4xODggMi42OThsLTE1LjYxMiAxNy4xOUEzLjIxMyAzLjIxMyAwIDAgMSA3Ni4yNTQgODRsLTczLjMxLS4wNmExLjYxMSAxLjYxMSAwIDAgMS0xLjE4OC0yLjY5OGwxNS42MTItMTcuMTlabTc2Ljg3Ni0xNC4zMWExLjYxMSAxLjYxMSAwIDAgMS0xLjE4OCAyLjY5OGwtNzMuMzEuMDZhMy4yMTMgMy4yMTMgMCAwIDEtMi4zNzgtMS4wNTJsLTE1LjYxMi0xNy4yYTEuNjEyIDEuNjEyIDAgMCAxIDEuMTg4LTIuNjk4bDczLjMxMi0uMDZhMy4yMTMgMy4yMTMgMCAwIDEgMi4zNzYgMS4wNTJsMTUuNjEyIDE3LjJaTTE3LjM2OCAxLjA1MkEzLjIxNSAzLjIxNSAwIDAgMSAxOS43NDQgMGw3My4zMTIuMDZhMS42MTIgMS42MTIgMCAwIDEgMS4xODggMi42OThsLTE1LjYxMiAxNy4xOUEzLjIxMyAzLjIxMyAwIDAgMSA3Ni4yNTQgMjFsLTczLjMxLS4wNmExLjYxMSAxLjYxMSAwIDAgMS0xLjE4OC0yLjY5OGwxNS42MTItMTcuMTlaIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiLz48L2c+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJiIiB4MT0iNC4xNjgiIHgyPSI5MS44MzIiIHkxPSI4NS44MzIiIHkyPSItMS44MzIiIGdyYWRpZW50VW5pdHM9InVzZXJTcGFjZU9uVXNlIj48c3RvcCBzdG9wLWNvbG9yPSIjOTk0NUZGIi8+PHN0b3Agb2Zmc2V0PSIuMiIgc3RvcC1jb2xvcj0iIzc5NjJFNyIvPjxzdG9wIG9mZnNldD0iMSIgc3RvcC1jb2xvcj0iIzAwRDE4QyIvPjwvbGluZWFyR3JhZGllbnQ+PGNsaXBQYXRoIGlkPSJhIj48cGF0aCBmaWxsPSIjZmZmIiBkPSJNMCAwaDk2djg0SDB6Ii8+PC9jbGlwUGF0aD48L2RlZnM+PC9zdmc+";
  if (C === "Ethereum" || C === "Sepolia" || C === "Holesky")
    return PREFIX + "PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbDpzcGFjZT0icHJlc2VydmUiIHZpZXdCb3g9IjAgMCAxOTIwIDE5MjAiPjxwYXRoIGZpbGw9IiM4QTkyQjIiIGQ9Ik05NTkuOCA4MC43IDQyMC4xIDk3Ni4zIDk1OS44IDczMXoiLz48cGF0aCBmaWxsPSIjNjI2ODhGIiBkPSJNOTU5LjggNzMxIDQyMC4xIDk3Ni4zbDUzOS43IDMxOS4xem01MzkuOCAyNDUuM0w5NTkuOCA4MC43VjczMXoiLz48cGF0aCBmaWxsPSIjNDU0QTc1IiBkPSJtOTU5LjggMTI5NS40IDUzOS44LTMxOS4xTDk1OS44IDczMXoiLz48cGF0aCBmaWxsPSIjOEE5MkIyIiBkPSJtNDIwLjEgMTA3OC43IDUzOS43IDc2MC42di00NDEuN3oiLz48cGF0aCBmaWxsPSIjNjI2ODhGIiBkPSJNOTU5LjggMTM5Ny42djQ0MS43bDU0MC4xLTc2MC42eiIvPjwvc3ZnPg==";
  if (C === "Terra")
    return PREFIX + "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";
  if (C === "Bsc")
    return PREFIX + "PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI0MCIgaGVpZ2h0PSI0MCIgZmlsbD0ibm9uZSI+PHBhdGggZmlsbD0iI0YwQjkwQiIgZD0iTTIwLjMwMiAwIDkuNjggNi4xMjdsMy45MDYgMi4yNjMgNi43MTctMy44NjNMMjcuMDIgOC4zOWwzLjkwNi0yLjI2M0wyMC4zMDMgMFptNi43MTggMTEuNTkgMy45MDYgMi4yNjR2NC41MjdsLTYuNzE4IDMuODYzdjcuNzI3bC0zLjkwNSAyLjI2My0zLjkwNi0yLjI2M3YtNy43MjdMOS42NzkgMTguMzh2LTQuNTI3bDMuOTA2LTIuMjY0IDYuNzE3IDMuODY0IDYuNzE4LTMuODY0WiIvPjxwYXRoIGZpbGw9IiNGMEI5MEIiIGQ9Ik0zMC45MjYgMjEuNTh2NC41MjdsLTMuOTA2IDIuMjY0di00LjUyN2wzLjkwNi0yLjI2NFoiLz48cGF0aCBmaWxsPSIjRjBCOTBCIiBkPSJtMjYuOTgxIDMxLjU3IDYuNzE4LTMuODYzVjE5Ljk4bDMuOTA2LTIuMjYzdjEyLjI1NGwtMTAuNjI0IDYuMTI3VjMxLjU3Wk0zMy43IDEyLjI1NCAyOS43OTIgOS45OSAzMy43IDcuNzI3bDMuOTA2IDIuMjYzdjQuNTI3TDMzLjcgMTYuNzgxdi00LjUyN1pNMTYuMzk3IDM3LjczN1YzMy4yMWwzLjkwNSAyLjI2MyAzLjkwNi0yLjI2M3Y0LjUyN0wyMC4zMDMgNDBsLTMuOTA2LTIuMjYzWm0tMi44MTItOS4zNjctMy45MDYtMi4yNjN2LTQuNTI2bDMuOTA2IDIuMjYzdjQuNTI3Wm02LjcxNy0xNi4xMTZMMTYuMzk3IDkuOTlsMy45MDUtMi4yNjMgMy45MDYgMi4yNjMtMy45MDUgMi4yNjRabS05LjQ5LTIuMjY0LTMuOTA2IDIuMjY0djQuNTI3TDMgMTQuNTE3VjkuOTlsMy45MDYtMi4yNjMgMy45MDYgMi4yNjNaIi8+PHBhdGggZmlsbD0iI0YwQjkwQiIgZD0ibTMgMTcuNzE3IDMuOTA2IDIuMjY0djcuNzI2bDYuNzE4IDMuODY0djQuNTI3TDMgMjkuOTdWMTcuNzE3WiIvPjwvc3ZnPg==";
  if (C === "Polygon" || C === "PolygonSepolia")
    return PREFIX + "PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbDpzcGFjZT0icHJlc2VydmUiIHN0eWxlPSJlbmFibGUtYmFja2dyb3VuZDpuZXcgMCAwIDM4LjQgMzMuNSIgdmlld0JveD0iMCAwIDM4LjQgMzMuNSI+PHBhdGggZD0iTTI5IDEwLjJjLS43LS40LTEuNi0uNC0yLjQgMEwyMSAxMy41bC0zLjggMi4xLTUuNSAzLjNjLS43LjQtMS42LjQtMi40IDBMNSAxNi4zYy0uNy0uNC0xLjItMS4yLTEuMi0yLjF2LTVjMC0uOC40LTEuNiAxLjItMi4xbDQuMy0yLjVjLjctLjQgMS42LS40IDIuNCAwTDE2IDcuMmMuNy40IDEuMiAxLjIgMS4yIDIuMXYzLjNsMy44LTIuMlY3YzAtLjgtLjQtMS42LTEuMi0yLjFsLTgtNC43Yy0uNy0uNC0xLjYtLjQtMi40IDBMMS4yIDVDLjQgNS40IDAgNi4yIDAgN3Y5LjRjMCAuOC40IDEuNiAxLjIgMi4xbDguMSA0LjdjLjcuNCAxLjYuNCAyLjQgMGw1LjUtMy4yIDMuOC0yLjIgNS41LTMuMmMuNy0uNCAxLjYtLjQgMi40IDBsNC4zIDIuNWMuNy40IDEuMiAxLjIgMS4yIDIuMXY1YzAgLjgtLjQgMS42LTEuMiAyLjFMMjkgMjguOGMtLjcuNC0xLjYuNC0yLjQgMGwtNC4zLTIuNWMtLjctLjQtMS4yLTEuMi0xLjItMi4xVjIxbC0zLjggMi4ydjMuM2MwIC44LjQgMS42IDEuMiAyLjFsOC4xIDQuN2MuNy40IDEuNi40IDIuNCAwbDguMS00LjdjLjctLjQgMS4yLTEuMiAxLjItMi4xVjE3YzAtLjgtLjQtMS42LTEuMi0yLjFMMjkgMTAuMnoiIHN0eWxlPSJmaWxsOiM4MjQ3ZTUiLz48L3N2Zz4=";
  if (C === "Avalanche")
    return PREFIX + "PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbDpzcGFjZT0icHJlc2VydmUiIHN0eWxlPSJlbmFibGUtYmFja2dyb3VuZDpuZXcgMCAwIDI1NCAyNTQiIHZpZXdCb3g9IjAgMCAyNTQgMjU0Ij48Y2lyY2xlIGN4PSIxMjciIGN5PSIxMjciIHI9IjEyNyIgc3R5bGU9ImZpbGwtcnVsZTpldmVub2RkO2NsaXAtcnVsZTpldmVub2RkO2ZpbGw6I2U4NDE0MiIvPjxwYXRoIGQ9Ik0xNzEuOCAxMzAuM2M0LjQtNy42IDExLjUtNy42IDE1LjkgMGwyNy40IDQ4LjFjNC40IDcuNi44IDEzLjgtOCAxMy44aC01NS4yYy04LjcgMC0xMi4zLTYuMi04LTEzLjhsMjcuOS00OC4xem0tNTMtOTIuNmM0LjQtNy42IDExLjQtNy42IDE1LjggMGw2LjEgMTFMMTU1LjEgNzRjMy41IDcuMiAzLjUgMTUuNyAwIDIyLjlsLTQ4LjMgODMuN2MtNC40IDYuOC0xMS43IDExLjEtMTkuOCAxMS42SDQ2LjljLTguOCAwLTEyLjQtNi4xLTgtMTMuOGw3OS45LTE0MC43eiIgc3R5bGU9ImZpbGw6I2ZmZiIvPjwvc3ZnPg==";
  if (C === "Oasis")
    return PREFIX + "PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB4bWw6c3BhY2U9InByZXNlcnZlIiBzdHlsZT0iZW5hYmxlLWJhY2tncm91bmQ6bmV3IDAgMCAxMjggMTI4IiB2aWV3Qm94PSIwIDAgMTI4IDEyOCI+PGRlZnM+PHBhdGggaWQ9ImEiIGQ9Ik0wIDBoMTI4djEyOEgweiIvPjwvZGVmcz48Y2xpcFBhdGggaWQ9ImIiPjx1c2UgeGxpbms6aHJlZj0iI2EiIHN0eWxlPSJvdmVyZmxvdzp2aXNpYmxlIi8+PC9jbGlwUGF0aD48ZyBzdHlsZT0iY2xpcC1wYXRoOnVybCgjYikiPjxwYXRoIGQ9Ik0xMTUgMjUuNEMxMDUuMyAxMyA5MS4xIDUuMSA3NS40IDUuMSA0NSA1LjEgMjIuNyAzMy40IDIyLjcgNjRjMCAyMS4zIDE0LjIgMzcuMyAyOS45IDM3LjMgMS41IDAgMi45LS4xIDQuNC0uNEM0Ni40IDkzLjIgMzkuNyA3OS4yIDM5LjcgNjRjMC0yNC4yIDE2LjQtNDMuMSAzNS43LTQzLjEgMjEuMSAwIDM1LjcgMjAuOSAzNS43IDQzLjEtLjEgMTYuNC01LjkgMzIuNy0xNi4yIDQ0LjctOSAxMC41LTIwLjYgMTcuMS0zMy40IDE5LjIgMCAwIDEuMS4xIDIuNS4xIDM1LjMgMCA2NC0yOC43IDY0LTY0IDAtMTQuNS00LjgtMjcuOS0xMy0zOC42ek0xMDUuMyA2NGMwLTIxLjMtMTQuMi0zNy4zLTI5LjktMzcuMy0xLjUgMC0yLjkuMS00LjQuNEM4MS42IDM0LjggODguMyA0OC44IDg4LjMgNjRjMCAyNC4yLTE2LjQgNDMuMS0zNS43IDQzLjEtMjEuMSAwLTM1LjctMjAuOS0zNS43LTQzLjEuMS0xNi40IDUuOS0zMi43IDE2LjItNDQuN0M0Mi4xIDguOCA1My43IDIuMiA2Ni41LjFjMCAwLTEuMS0uMS0yLjUtLjFDMjguNyAwIDAgMjguNyAwIDY0YzAgMTQuNSA0LjggMjcuOSAxMyAzOC42IDkuNyAxMi40IDIzLjkgMjAuMiAzOS42IDIwLjIgMzAuNC4xIDUyLjctMjguMiA1Mi43LTU4Ljh6IiBzdHlsZT0iZmlsbC1ydWxlOmV2ZW5vZGQ7Y2xpcC1ydWxlOmV2ZW5vZGQ7ZmlsbDojMDA4OWRiIi8+PC9nPjwvc3ZnPg==";
  if (C === "Algorand")
    return PREFIX + "PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGRhdGEtbmFtZT0iTGF5ZXIgMSIgdmlld0JveD0iMCAwIDY1MCA2NTAiPjxwYXRoIGQ9Ik00NDQuMTggNDQ0LjMyaC0zNy4zN2wtMjQuMjctOTAuMjgtNTIuMTggOTAuMjloLTQxLjcybDgwLjY1LTEzOS43Ni0xMi45OC00OC41Mi0xMDguNzUgMTg4LjMxaC00MS43NGwxMzcuODItMjM4LjcyaDM2LjU0bDE2IDU5LjMxaDM3LjdsLTI1Ljc0IDQ0Ljc2IDM2LjA0IDEzNC42MXoiIHN0eWxlPSJmaWxsOiNmZmYiLz48L3N2Zz4=";
  if (C === "Aurora")
    return PREFIX + "PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbDpzcGFjZT0icHJlc2VydmUiIHZpZXdCb3g9IjAgMCAyODggMjg4Ij48cGF0aCBkPSJNMTQ0IDBjNzkuNSAwIDE0NCA2NC41IDE0NCAxNDRzLTY0LjUgMTQ0LTE0NCAxNDRTMCAyMjMuNSAwIDE0NCA2NC41IDAgMTQ0IDB6IiBzdHlsZT0iZmlsbDojNzBkNDRiIi8+PHBhdGggZD0iTTE0NCA1OC44YzcuNiAwIDE0LjUgNC4zIDE3LjkgMTEuMWw1Ni4yIDExMi41YzQuOSA5LjkuOSAyMS45LTkgMjYuOC0yLjggMS40LTUuOCAyLjEtOC45IDIuMUg4Ny44Yy0xMSAwLTIwLTktMjAtMjAgMC0zLjEuNy02LjIgMi4xLTguOWw1Ni4yLTExMi41YzMuNC02LjkgMTAuMy0xMS4yIDE3LjktMTEuMW0wLTEzLjhjLTEyLjggMC0yNC41IDcuMi0zMC4yIDE4LjdMNTcuNiAxNzYuMmMtOC4zIDE2LjctMS42IDM2LjkgMTUuMSA0NS4zIDQuNyAyLjMgOS45IDMuNiAxNS4xIDMuNmgxMTIuNWMxOC42IDAgMzMuOC0xNS4xIDMzLjgtMzMuNyAwLTUuMi0xLjItMTAuNC0zLjYtMTUuMUwxNzQuMiA2My43QzE2OC41IDUyLjIgMTU2LjggNDUgMTQ0IDQ1eiIgc3R5bGU9ImZpbGw6I2ZmZiIvPjwvc3ZnPg==";
  if (C === "Fantom")
    return PREFIX + "PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAzMiAzMiI+PGRlZnM+PHN0eWxlPi5jbHMtMXtmaWxsOiNmZmY7ZmlsbC1ydWxlOmV2ZW5vZGR9PC9zdHlsZT48bWFzayBpZD0ibWFzayIgd2lkdGg9IjkzLjEiIGhlaWdodD0iMjAiIHg9IjEwIiB5PSI2IiBtYXNrVW5pdHM9InVzZXJTcGFjZU9uVXNlIj48cGF0aCBpZD0iYSIgZD0iTTEwIDZoOTMuMXYyMEgxMFoiIGNsYXNzPSJjbHMtMSIvPjwvbWFzaz48L2RlZnM+PGcgaWQ9IkxheWVyXzIiIGRhdGEtbmFtZT0iTGF5ZXIgMiI+PGcgaWQ9IkxheWVyXzEtMiIgZGF0YS1uYW1lPSJMYXllciAxIj48Y2lyY2xlIGN4PSIxNiIgY3k9IjE2IiByPSIxNiIgc3R5bGU9ImZpbGw6IzEzYjVlYyIvPjxwYXRoIGQ9Im0xNy4yIDEyLjkgMy42LTIuMVYxNVptMy42IDlMMTYgMjQuN2wtNC44LTIuOFYxN2w0LjggMi44IDQuOC0yLjhabS05LjYtMTEuMSAzLjYgMi4xLTMuNiAyLjFabTUuNCAzLjEgMy42IDIuMS0zLjYgMi4xWm0tMS4yIDQuMkwxMS44IDE2bDMuNi0yLjFabTQuOC04LjNMMTYgMTIuMmwtNC4yLTIuNEwxNiA3LjNaTTEwIDkuNHYxMy4xbDYgMy40IDYtMy40VjkuNEwxNiA2WiIgY2xhc3M9ImNscy0xIiBzdHlsZT0ibWFzazp1cmwoI21hc2spIi8+PC9nPjwvZz48L3N2Zz4=";
  if (C === "Karura")
    return PREFIX + "PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbDpzcGFjZT0icHJlc2VydmUiIHZpZXdCb3g9IjAgMCAzMiAzMiI+PHN0eWxlPi5zdDB7ZmlsbDp1cmwoI3BhdGg5XzAwMDAwMTgzMjA3MjI2NDIxMjQzMjQ2MTMwMDAwMDAwNjQ5ODcxNTEzNjMzMzUwMDIwXyl9LnN0MXtmaWxsOnVybCgjcGF0aDExXzAwMDAwMTExOTA3NTExMTc3MTAzNTczNzQwMDAwMDA3Mjc3NzI2NzYwNDY4OTA4MTkxXyl9PC9zdHlsZT48bGluZWFyR3JhZGllbnQgaWQ9ImEiIHgxPSIzMC42MDMiIHgyPSI5LjA2NyIgeTE9IjMuMTE4IiB5Mj0iMjYuNTI3IiBncmFkaWVudFRyYW5zZm9ybT0ibWF0cml4KDEgMCAwIC0xIDAgMzQpIiBncmFkaWVudFVuaXRzPSJ1c2VyU3BhY2VPblVzZSI+PHN0b3Agb2Zmc2V0PSIwIiBzdG9wLWNvbG9yPSIjRTQwQzVCIi8+PHN0b3Agb2Zmc2V0PSIxIiBzdG9wLWNvbG9yPSIjRkY0QzNCIi8+PC9saW5lYXJHcmFkaWVudD48cGF0aCBmaWxsPSJ1cmwoI2EpIiBkPSJtMjIuMSAyLTguNiA3LjhjLS45LjgtMi4xIDEuMy0zLjMgMS4zSDcuNlYySDN2MjZoMi41YzEuNCAwIDIuNy0uOCAzLjQtMiAuNS0uOC43LTIuNS42LTMuNi0uMS0yLjUtLjUtMy4yLS41LTMuMiAwIDEuOC0xLjggMS45LTEuOCAxLjkgMS4zLTEuMi42LTIuMi42LTIuMi0yLjMgMS42LTIuOS0uMS0yLjktLjMuMS4xLjcuNiAyLTEuMSAxLjMtMS44IDMuMS00LjggNC4yLTUuNnMyLjItLjcgMi4yLS43LjYtLjggMi4yLTEuNSAyLjYuMyAyLjYuM2MtMS42IDEuMy0zLjkgMy41LTQgNi42LS4xIDIuNSA1LjQgNi45IDQuNCAxMy4zLjYtMS41LjgtMi45LjYtNC43LS4yLTEuNS0xLjEtNC41LTEuMS00LjVsNS4yIDcuMkgyOUwxNy43IDEyLjQgMjkgMmgtNi45eiIvPjxsaW5lYXJHcmFkaWVudCBpZD0iYiIgeDE9IjEyLjQxNCIgeDI9IjEwLjg4OSIgeTE9IjIwLjE4NSIgeTI9IjIxLjg1NSIgZ3JhZGllbnRUcmFuc2Zvcm09Im1hdHJpeCgxIDAgMCAtMSAwIDM0KSIgZ3JhZGllbnRVbml0cz0idXNlclNwYWNlT25Vc2UiPjxzdG9wIG9mZnNldD0iMCIgc3RvcC1jb2xvcj0iI0U0MEM1QiIvPjxzdG9wIG9mZnNldD0iMSIgc3RvcC1jb2xvcj0iI0ZGNEMzQiIvPjwvbGluZWFyR3JhZGllbnQ+PHBhdGggZmlsbD0idXJsKCNiKSIgZD0iTTEwLjkgMTIuOGMtLjQuNy0uNC45LS40LjlzMS41LS4yIDEuOS0yYy0uMSAwLTEgLjMtMS41IDEuMXoiLz48L3N2Zz4=";
  if (C === "Acala")
    return PREFIX + "PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGZpbGw9Im5vbmUiIHZpZXdCb3g9IjAgMCA0OTAgNDkwIj48cGF0aCBmaWxsPSJ1cmwoI2EpIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0yNDUgNDkwYzEzNS4zMSAwIDI0NS0xMDkuNjkgMjQ1LTI0NVMzODAuMzEgMCAyNDUgMCAwIDEwOS42OSAwIDI0NXMxMDkuNjkgMjQ1IDI0NSAyNDV6bTEtMjNjMTIyLjYxIDAgMjIyLTk5LjM5MyAyMjItMjIyUzM2OC42MDcgMjMgMjQ2IDIzIDI0IDEyMi4zOTMgMjQgMjQ1czk5LjM5MyAyMjIgMjIyIDIyMnptLTEtMTdjMTEzLjIyIDAgMjA1LTkxLjc4MiAyMDUtMjA1UzM1OC4yMTggNDAgMjQ1IDQwIDQwIDEzMS43ODIgNDAgMjQ1czkxLjc4MiAyMDUgMjA1IDIwNXptLjUtMjVjOTkuNjg3IDAgMTgwLjUtODAuODEzIDE4MC41LTE4MC41UzM0NS4xODcgNjQgMjQ1LjUgNjQgNjUgMTQ0LjgxMyA2NSAyNDQuNSAxNDUuODEzIDQyNSAyNDUuNSA0MjV6TTIzNS4zMTMgOTguNjZsMTMwLjY4IDIyNi43IDE0LjAxMi0yNC4zMS0xMTYuNjYtMjAyLjM5em0tMTI1LjMxIDIwMS45OCAxMTEuODQtMTk0LjAzLjIzMS40LjIyLS4zODIgMTMyLjU0IDIyOS45M2gtMjguMDI1bC0zMy40ODQtNTguMDg4Yy0xNS4yMTUtNC44MS0zMS40MTQtNy40MDQtNDguMjItNy40MDQtOC42NjMgMC0xNy4xMTcuNjA1LTI1LjMzNiAxLjgxMmwxNi4xNC0yNy45NTZjMy4wNDctLjE0OSA2LjExMy0uMjI0IDkuMTk2LS4yMjQgMTAuMjY3IDAgMjAuMzM5LjgzMSAzMC4xNTQgMi40M2wtNTMuMTk1LTkyLjI4NC05OC4wNSAxNzAuMXptNzYuMDM1LTIuOTQ5IDUwLjI1Ni04Ny4xODYtMTQuMDEyLTI0LjMwOS04Ni42NzYgMTUwLjM3aDI4LjAyNWwuMjY2LS40NjJjMjQuMDM3LTE0LjQ3MiA1MS42MTktMjEuNzg3IDgxLjczNy0yMS43ODcgMTkuMjMyIDAgMzcuNjcgMy4zOTcgNTQuNzQ3IDkuNjI1bC0xOC43NzUtMzIuNTJhMTg3LjE0IDE4Ny4xNCAwIDAgMC0zNS45NzItMy40NzJjLTIwLjg0MiAwLTQwLjg4NSAzLjQyNS01OS41OTYgOS43NDR6IiBjbGlwLXJ1bGU9ImV2ZW5vZGQiLz48ZGVmcz48bGluZWFyR3JhZGllbnQgaWQ9ImEiIHgxPSI0NjIuNSIgeDI9IjEwMSIgeTE9IjQ5MCIgeTI9IjQzLjUiIGdyYWRpZW50VW5pdHM9InVzZXJTcGFjZU9uVXNlIj48c3RvcCBvZmZzZXQ9IjAiIHN0b3AtY29sb3I9IiM1QTgxRkYiLz48c3RvcCBvZmZzZXQ9Ii41MjQiIHN0b3AtY29sb3I9IiNFNDBDNUIiLz48c3RvcCBvZmZzZXQ9IjEiIHN0b3AtY29sb3I9IiNGRjRDM0IiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48L3N2Zz4=";
  if (C === "Klaytn")
    return PREFIX + "PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbDpzcGFjZT0icHJlc2VydmUiIHN0eWxlPSJlbmFibGUtYmFja2dyb3VuZDpuZXcgMCAwIDUxMiA1MTIiIHZpZXdCb3g9IjAgMCA1MTIgNTEyIj48cGF0aCBkPSJtMjU0LjggMjg4LjEgMTYwIDE1OS43Yy04Ny45IDc1LjItMjI1LjkgNzguNC0zMTkuNy0xLjIgNTMuNC01Mi45IDEwNi42LTEwNS43IDE1OS43LTE1OC41eiIgc3R5bGU9ImZpbGw6I2JkMDcyZiIvPjxwYXRoIGQ9Ik0yOTEuNSAyNTUuOWMzNS4yLTM2LjIgNzAuOS03My4yIDEwNy0xMDkuOSAxNS0xNS4zIDMwLjUtMjkuOSA0Ni4xLTQ0LjYgMS4yLTEuMSA1LjItMS4zIDUuOS0uNCAyNy40IDM2IDQ3LjggNzUuMyA1My4yIDEyMC44IDguMiA2OS40LTcuNyAxMzIuNi01MS4zIDE4OC4xLTEuMiAxLjUtMi4zIDMuMi0yLjkgNC4xLTUzLjItNTMuMy0xMDYuNC0xMDYuNC0xNTgtMTU4LjF6IiBzdHlsZT0iZmlsbDojZmE0MjEyIi8+PHBhdGggZD0iTTEzOS4xIDMzNy44YzUuOS0xNS42IDExLjktMzEuMiAxNy44LTQ2LjggMjQuNS02NC41IDQ5LTEyOSA3My41LTE5My40IDcuNy0yMCAxNi40LTM5LjcgMjQuMy01OS43IDMtNy43IDUuMy0xNS43IDcuNy0yMy42IDEuOC01LjkgNS40LTguMSAxMS42LTcuNSAyNC40IDIuNCA0OC40IDYuMiA3MC45IDE2LjUgMTMgNiAyNi4zIDExLjQgMzguNyAxOC41IDEwLjEgNS44IDE4LjkgMTMuNyAzMC4xIDIyTDE0MC43IDMzOWwtMS42LTEuMnoiIHN0eWxlPSJmaWxsOiNmZjgwMDAiLz48cGF0aCBkPSJNMjAwLjIgNDcuN2MtNDUuOSAxMjEuNS05MS43IDI0Mi45LTEzOC41IDM2Ni45LTguOC0xMy40LTE3LTI0LjctMjMuOS0zNi43QzIyIDM1MC40IDExLjkgMzIwIDcuOSAyODguNWMtMS45LTE1LTEuNS0zMC40LTEuNi00NS42IDAtMi40IDIuMi01LjMgNC4xLTcuMkM2OS41IDE3Ni40IDEyOC44IDExNy4zIDE4OCA1OC4yYzMuNi0zLjYgNy4xLTcuNCAxMC43LTExLjJsMS41Ljd6IiBzdHlsZT0iZmlsbDojYjcwYzAyIi8+PC9zdmc+";
  if (C === "Celo")
    return PREFIX + "PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbDpzcGFjZT0icHJlc2VydmUiIHN0eWxlPSJlbmFibGUtYmFja2dyb3VuZDpuZXcgMCAwIDk1MCA5NTAiIHZpZXdCb3g9IjAgMCA5NTAgOTUwIj48cGF0aCBkPSJNMzc1IDg1MGMxNTEuOSAwIDI3NS0xMjMuMSAyNzUtMjc1UzUyNi45IDMwMCAzNzUgMzAwIDEwMCA0MjMuMSAxMDAgNTc1czEyMy4xIDI3NSAyNzUgMjc1em0wIDEwMEMxNjcuOSA5NTAgMCA3ODIuMSAwIDU3NXMxNjcuOS0zNzUgMzc1LTM3NSAzNzUgMTY3LjkgMzc1IDM3NS0xNjcuOSAzNzUtMzc1IDM3NXoiIHN0eWxlPSJmaWxsOiNmYmNjNWMiLz48cGF0aCBkPSJNNTc1IDY1MGMxNTEuOSAwIDI3NS0xMjMuMSAyNzUtMjc1UzcyNi45IDEwMCA1NzUgMTAwIDMwMCAyMjMuMSAzMDAgMzc1czEyMy4xIDI3NSAyNzUgMjc1em0wIDEwMGMtMjA3LjEgMC0zNzUtMTY3LjktMzc1LTM3NVMzNjcuOSAwIDU3NSAwczM3NSAxNjcuOSAzNzUgMzc1LTE2Ny45IDM3NS0zNzUgMzc1eiIgc3R5bGU9ImZpbGw6IzM1ZDA3ZiIvPjxwYXRoIGQ9Ik01ODcuNCA3NTBjMjYtMzEuNSA0NC42LTY4LjQgNTQuNS0xMDguMSAzOS42LTkuOSA3Ni41LTI4LjUgMTA4LjEtNTQuNS0xLjQgNDUuOS0xMS4zIDkxLjEtMjkuMiAxMzMuNS00Mi4zIDE3LjgtODcuNSAyNy43LTEzMy40IDI5LjF6TTMwOC4xIDMwOC4xYy0zOS42IDkuOS03Ni41IDI4LjUtMTA4LjEgNTQuNSAxLjQtNDUuOSAxMS4zLTkxLjEgMjkuMi0xMzMuNCA0Mi4zLTE3LjggODcuNi0yNy43IDEzMy40LTI5LjItMjYgMzEuNS00NC42IDY4LjQtNTQuNSAxMDguMXoiIHN0eWxlPSJmaWxsOiM1ZWEzM2IiLz48L3N2Zz4=";
  if (C === "Near")
    return PREFIX + "PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbDpzcGFjZT0icHJlc2VydmUiIHN0eWxlPSJlbmFibGUtYmFja2dyb3VuZDpuZXcgMCAwIDkwLjEgOTAiIHZpZXdCb3g9IjAgMCA5MC4xIDkwIj48cGF0aCBmaWxsPSIjZmZmIiBkPSJNNzIuMiA0LjYgNTMuNCAzMi41Yy0xLjMgMS45IDEuMiA0LjIgMyAyLjZMNzQuOSAxOWMuNS0uNCAxLjItLjEgMS4yLjZ2NTAuM2MwIC43LS45IDEtMS4zLjVsLTU2LTY3QzE3IDEuMiAxNC40IDAgMTEuNSAwaC0yQzQuMyAwIDAgNC4zIDAgOS42djcwLjhDMCA4NS43IDQuMyA5MCA5LjYgOTBjMy4zIDAgNi40LTEuNyA4LjItNC42bDE4LjgtMjcuOWMxLjMtMS45LTEuMi00LjItMy0yLjZsLTE4LjUgMTZjLS41LjQtMS4yLjEtMS4yLS42VjIwLjFjMC0uNy45LTEgMS4zLS41bDU2IDY3YzEuOCAyLjIgNC41IDMuNCA3LjMgMy40aDJjNS4zIDAgOS42LTQuMyA5LjYtOS42VjkuNmMwLTUuMy00LjMtOS42LTkuNi05LjYtMy40IDAtNi41IDEuNy04LjMgNC42eiIvPjwvc3ZnPg==";
  if (C === "Moonbeam")
    return PREFIX + "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";
  if (C === "Neon")
    return PREFIX + "PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyOCIgaGVpZ2h0PSIyOCIgZmlsbD0ibm9uZSI+PHBhdGggZmlsbD0iI0RGNDJBQiIgZmlsbC1ydWxlPSJldmVub2RkIiBkPSJNMjggMTRjMCA3LjczMi02LjI2OCAxNC0xNCAxNFMwIDIxLjczMiAwIDE0IDYuMjY4IDAgMTQgMHMxNCA2LjI2OCAxNCAxNFpNOC41ODUgOC4wNTJsNS4yMzggNS4yMzhWOC4zMTVhLjM3My4zNzMgMCAwIDEgLjM3Ny0uMzc0aDUuOTE4YS4zNzQuMzc0IDAgMCAxIC4zNjkuMzc0djUuODVhLjM4LjM4IDAgMCAxIC4wMDIuMDQzVjIwLjFhLjM3Ni4zNzYgMCAwIDEtLjUyNS4zNDguMzgyLjM4MiAwIDAgMS0uMTI4LS4wODVoLS4wMDNsLTUuMjM3LTUuMjM4VjIwLjFhLjM3NC4zNzQgMCAwIDEtLjM3NC4zNzdIOC4zMDZhLjM3My4zNzMgMCAwIDEtLjM3Ni0uMzc3di01Ljg5M2MwLS4wMy4wMDMtLjA2LjAxLS4wOVY4LjMxNWEuMzc3LjM3NyAwIDAgMSAuNjQ1LS4yNjNaIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiLz48L3N2Zz4=";
  if (C === "Terra2")
    return PREFIX + "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";
  if (C === "Injective")
    return PREFIX + "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";
  if (C === "Osmosis")
    return PREFIX + "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";
  if (C === "Sui")
    return PREFIX + "PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNjAiIGhlaWdodD0iMTYwIiBmaWxsPSJub25lIiB2aWV3Qm94PSIwIDAgMTEwIDE2MCI+PHBhdGggZmlsbD0iIzZGQkNGMCIgZmlsbC1ydWxlPSJldmVub2RkIiBkPSJNNy40NDQgMTMyLjIxNkMxNy4zNyAxNDkuNjE1IDM1LjE1IDE2MCA1NSAxNjBzMzcuNjI3LTEwLjM4NSA0Ny41NTYtMjcuNzg0YzkuOTI1LTE3LjM5NCA5LjkyNS0zOC4xNjUgMC01NS41NjNMNjAuNzMgMy4zNDdjLTIuNTQ3LTQuNDYzLTguOTEzLTQuNDYzLTExLjQ2IDBMNy40NDQgNzYuNjUzYy05LjkyNSAxNy4zOTQtOS45MjUgMzguMTY1IDAgNTUuNTYzWm0zNS43NzMtOTMuOTk0IDguOTE4LTE1LjYzYzEuMjczLTIuMjMyIDQuNDU3LTIuMjMyIDUuNzMgMGwzNC4zMDcgNjAuMTNjNi4zMDMgMTEuMDQ2IDcuNDg2IDIzLjgzMSAzLjU1IDM1LjUzMWEzNy43MDggMzcuNzA4IDAgMCAwLTEuNzU2LTUuODM1Yy00LjczOS0xMi4xMDEtMTUuNDU0LTIxLjQzOS0zMS44NTMtMjcuNzU3LTExLjI3NS00LjMyNy0xOC40NzItMTAuNjkyLTIxLjM5Ni0xOC45MTktMy43NjctMTAuNjAzLjE2Ny0yMi4xNjUgMi41LTI3LjUyWk0yOC4wMTIgNjQuODc0IDE3LjgyOCA4Mi43MjJjLTcuNzYgMTMuNTk5LTcuNzYgMjkuODMzIDAgNDMuNDMyIDcuNzYgMTMuNiAyMS42NTMgMjEuNzE1IDM3LjE3MiAyMS43MTUgMTAuMzA3IDAgMTkuOS0zLjU4MyAyNy40NTQtOS45NzUuOTg1LTIuNTA5IDQuMDM2LTExLjY5Ni4yNjctMjEuMTY1LTMuNDgtOC43NDMtMTEuODU4LTE1LjcyMy0yNC45LTIwLjc1LTE0Ljc0My01LjY1OS0yNC4zMjItMTQuNDkzLTI4LjQ2My0yNi4yNWEzNy4xNzQgMzcuMTc0IDAgMCAxLTEuMzQ3LTQuODU1WiIgY2xpcC1ydWxlPSJldmVub2RkIi8+PC9zdmc+";
  if (C === "Aptos")
    return PREFIX + "PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbDpzcGFjZT0icHJlc2VydmUiIGJhc2VQcm9maWxlPSJ0aW55IiBvdmVyZmxvdz0idmlzaWJsZSIgdmVyc2lvbj0iMS4yIiB2aWV3Qm94PSIwIDAgMTEyIDExMiI+PHBhdGggZmlsbD0iI2ZmZiIgZD0iTTg2LjYgMzcuNGgtOS45Yy0xLjEgMC0yLjItLjUtMy0xLjNsLTQtNC41Yy0xLjItMS4zLTMuMS0xLjQtNC41LS4zbC0uMy4zLTMuNCAzLjljLTEuMSAxLjMtMi44IDItNC41IDJIMi45QzEuNCA0MS45LjQgNDYuNiAwIDUxLjNoNTEuMmMuOSAwIDEuOC0uNCAyLjQtMWw0LjgtNWMuNi0uNiAxLjQtMSAyLjMtMWguMmMuOSAwIDEuOC40IDIuNCAxLjFsNCA0LjVjLjguOSAxLjkgMS40IDMgMS40SDExMmMtLjQtNC43LTEuNC05LjQtMi45LTEzLjhIODYuNnpNNTMuOCA2NWwtNC00LjVjLTEuMi0xLjMtMy4xLTEuNC00LjUtLjNsLS4zLjMtMy41IDMuOWMtMS4xIDEuMy0yLjcgMi00LjQgMkguOGMuOSA0LjggMi41IDkuNSA0LjYgMTRoMjUuNWMuOSAwIDEuNy0uNCAyLjQtMWw0LjgtNWMuNi0uNiAxLjQtMSAyLjMtMWguMmMuOSAwIDEuOC40IDIuNCAxLjFsNCA0LjVjLjguOSAxLjkgMS40IDMgMS40aDU2LjZjMi4xLTQuNCAzLjctOS4xIDQuNi0xNEg1Ni44Yy0xLjIgMC0yLjMtLjUtMy0xLjR6bTE5LjYtNDMuNiA0LjgtNWMuNi0uNiAxLjQtMSAyLjMtMWguMmMuOSAwIDEuOC40IDIuNCAxbDQgNC41Yy44LjkgMS45IDEuMyAzIDEuM2gxMC44Yy0xOC44LTI0LjgtNTQuMS0yOS43LTc5LTExLTQuMSAzLjEtNy44IDYuOC0xMSAxMUg3MWMxIC4yIDEuOC0uMiAyLjQtLjh6TTM0LjcgOTQuMmMtMS4yIDAtMi4zLS41LTMtMS4zbC00LTQuNWMtMS4yLTEuMy0zLjItMS40LTQuNS0uMmwtLjIuMi0zLjUgMy45Yy0xLjEgMS4zLTIuNyAyLTQuNCAyaC0uMkMzNiAxMTYuOSA3MS43IDExOCA5NC40IDk2LjdjLjktLjggMS43LTEuNyAyLjYtMi42SDM0Ljd6Ii8+PC9zdmc+";
  if (C === "Arbitrum" || C === "ArbitrumSepolia")
    return PREFIX + "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";
  if (C === "Optimism" || C === "OptimismSepolia")
    return PREFIX + "PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMjIiIGhlaWdodD0iMTIyIj48Y2lyY2xlIGN4PSI2MSIgY3k9IjYxIiByPSI2MSIgZmlsbD0iI2ZmMDQyMCIgZGF0YS1uYW1lPSJFbGxpcHNlIDExIi8+PHBhdGggZmlsbD0iI2ZmZiIgZD0iTTQzLjIwMSA3Ny4xNzdhMTQuNjU2IDE0LjY1NiAwIDAgMS04LjkyNC0yLjU2MyA4Ljc2MiA4Ljc2MiAwIDAgMS0zLjQzMi03LjQxMyAxNi40MzMgMTYuNDMzIDAgMCAxIC4yMjktMi40NzFxLjU5NS0zLjMgMS42OTMtNy45MTcgMy4xMTItMTIuNTg1IDE2LjA2Mi0xMi41ODVhMTUuOTY2IDE1Ljk2NiAwIDAgMSA2LjMxNSAxLjE5IDkuNiA5LjYgMCAwIDEgNC4zOTMgMy40NzggOS4zMzMgOS4zMzMgMCAwIDEgMS42IDUuNDkyIDE2LjI4OCAxNi4yODggMCAwIDEtLjIyOSAyLjQyNXEtLjY4NyA0LjA3My0xLjY0NyA3LjkxNy0xLjYgNi4yNjktNS41MzcgOS4zODEtMy45MzMgMy4wNjYtMTAuNTIzIDMuMDY2Wm0uNjQxLTYuNTlhNi41IDYuNSAwIDAgMCA0LjM0OC0xLjUxIDguNDI0IDguNDI0IDAgMCAwIDIuNjA4LTQuNjIycTEuMDUzLTQuMyAxLjYtNy41MDVhMTAuNSAxMC41IDAgMCAwIC4xODMtMS45NjhxMC00LjE2NS00LjM0Ny00LjE2NGE2LjY4MSA2LjY4MSAwIDAgMC00LjM5MyAxLjUxIDguNTczIDguNTczIDAgMCAwLTIuNTYzIDQuNjIycS0uODI0IDMuMDY2LTEuNjQ3IDcuNTA1YTkuNzkxIDkuNzkxIDAgMCAwLS4xODMgMS45MjJxMCA0LjIxIDQuMzk0IDQuMjFaIiBkYXRhLW5hbWU9IlBhdGggMTM5Ii8+PHBhdGggZmlsbD0iI2ZmZiIgZD0iTTYzLjI0NSA3Ni43MmEuOTcuOTcgMCAwIDEtLjc3OC0uMzIgMS4xIDEuMSAwIDAgMS0uMTM3LS44MjRsNi4zMTUtMjkuNzQ2YTEuMzEgMS4zMSAwIDAgMSAuNS0uODI0IDEuNCAxLjQgMCAwIDEgLjg3LS4zMmgxMi4xNzNhMTQuMTQ4IDE0LjE0OCAwIDAgMSA4LjE0NiAyLjEwNSA2LjkgNi45IDAgMCAxIDMuMTEyIDYuMDg3IDEwLjk1NSAxMC45NTUgMCAwIDEtLjI3NSAyLjM4IDEyLjM5IDEyLjM5IDAgMCAxLTQuNjIyIDcuNzhxLTMuNDMyIDIuNTE3LTkuNDI3IDIuNTE3aC02LjE3N0w3MC44NCA3NS41NzdhMS4zMTEgMS4zMTEgMCAwIDEtLjUuODI0IDEuNCAxLjQgMCAwIDEtLjg2OS4zMlptMTYuMi0xNy40ODJhNS40NTEgNS40NTEgMCAwIDAgMy4zNDEtMS4wNTIgNC45NDIgNC45NDIgMCAwIDAgMS45MjItMy4wMiA4LjAyMiA4LjAyMiAwIDAgMCAuMTM3LTEuMzczIDIuNTQzIDIuNTQzIDAgMCAwLS43NzgtMi4wMTQgMy44MzYgMy44MzYgMCAwIDAtMi42NTQtLjczMmgtNS40OTFsLTEuNzM5IDguMTkxWiIgZGF0YS1uYW1lPSJQYXRoIDE0MCIvPjwvc3ZnPg==";
  if (C === "Gnosis")
    return PREFIX + "PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbDpzcGFjZT0icHJlc2VydmUiIHN0eWxlPSJlbmFibGUtYmFja2dyb3VuZDpuZXcgMCAwIDQyOCA0MjgiIHZpZXdCb3g9IjAgMCA0MjggNDI4Ij48cGF0aCBkPSJNMTI1LjggMjQzLjdjMTIuMyAwIDI0LjMtNC4xIDM0LTExLjZsLTc4LTc4Yy0xOC44IDI0LjMtMTQuMyA1OS4zIDEwIDc4LjEgOS44IDcuNCAyMS43IDExLjUgMzQgMTEuNXpNMzU3LjggMTg4YzAtMTIuMy00LjEtMjQuMy0xMS42LTM0bC03OCA3OGMyNC4zIDE4LjggNTkuMiAxNC4zIDc4LTEwIDcuNS05LjcgMTEuNi0yMS43IDExLjYtMzR6IiBzdHlsZT0iZmlsbDojMDAxOTNjIi8+PHBhdGggZD0ibTM5Ny4xIDEwMy4xLTM0LjUgMzQuNWMyNy44IDMzLjMgMjMuNCA4Mi45LTkuOSAxMTAuNy0yOS4yIDI0LjQtNzEuNiAyNC40LTEwMC44IDBMMjE0IDI4Ni4ybC0zNy44LTM3LjhjLTMzLjMgMjcuOC04Mi45IDIzLjQtMTEwLjctOS45LTI0LjQtMjkuMi0yNC40LTcxLjYgMC0xMDAuOEw0Ny44IDEyMCAzMSAxMDMuMUMxMC43IDEzNi41IDAgMTc0LjkgMCAyMTRjMCAxMTguMiA5NS44IDIxNCAyMTQgMjE0czIxNC05NS44IDIxNC0yMTRjLjEtMzkuMS0xMC43LTc3LjUtMzAuOS0xMTAuOXoiIHN0eWxlPSJmaWxsOiMwMDE5M2MiLz48cGF0aCBkPSJNMzY4LjggNjYuM2MtODEuNS04NS41LTIxNi45LTg4LjctMzAyLjQtNy4yLTIuNSAyLjQtNC45IDQuOC03LjIgNy4yLTUuMyA1LjYtMTAuMyAxMS40LTE1IDE3LjVMMjE0IDI1My43IDM4My44IDgzLjhjLTQuNi02LjEtOS43LTExLjktMTUtMTcuNXpNMjE0IDI4YzUwIDAgOTYuNiAxOS4zIDEzMS42IDU0LjVMMjE0IDIxNC4xIDgyLjQgODIuNUMxMTcuNCA0Ny4zIDE2NCAyOCAyMTQgMjh6IiBzdHlsZT0iZmlsbDojMDAxOTNjIi8+PC9zdmc+";
  if (C === "Pythnet")
    return PREFIX + "PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIzNzIiIGhlaWdodD0iNDY2IiBmaWxsPSJub25lIj48cGF0aCBmaWxsPSIjZmZmIiBkPSJNMjMyLjQ5OSAxODYuNjMyYzAgMjUuNjk4LTIwLjgyMSA0Ni41MzUtNDYuNSA0Ni41MzV2NDYuNTM1YzUxLjM1OCAwIDkzLTQxLjY3MyA5My05My4wNyAwLTUxLjM5Ny00MS42NDItOTMuMDctOTMtOTMuMDctMTYuOTMxIDAtMzIuODMgNC41MjUtNDYuNSAxMi40Ni0yNy44MDQgMTYuMDgtNDYuNSA0Ni4xNTYtNDYuNSA4MC42MXYyMzIuNjc1bDQxLjgxIDQxLjg0MSA0LjY5IDQuNjkzVjE4Ni42MzJjMC0yNS42OTggMjAuODItNDYuNTM1IDQ2LjUtNDYuNTM1IDI1LjY3OSAwIDQ2LjUgMjAuODM3IDQ2LjUgNDYuNTM1WiIvPjxwYXRoIGZpbGw9IiNmZmYiIGQ9Ik0xODYgLjVjLTMzLjg4MSAwLTY1LjYzOCA5LjA3MS05MyAyNC45MmExODYuMDA3IDE4Ni4wMDcgMCAwIDAtNDYuNSAzOC4xMTZDMTcuNTYxIDk2LjM0OCAwIDEzOS40NTIgMCAxODYuNjR2MTM5LjYwNGw0Ni41IDQ2LjUzNVYxODYuNjRjMC00MS4zMzcgMTcuOTYtNzguNDg1IDQ2LjUtMTA0LjA1NyAxMy40MTgtMTEuOTk2IDI5LjE3LTIxLjQ2OCA0Ni41LTI3LjU3MSAxNC41MzMtNS4xNzggMzAuMjAxLTcuOTc3IDQ2LjUtNy45NzcgNzcuMDM3IDAgMTM5LjUgNjIuNTA5IDEzOS41IDEzOS42MDUgMCA3Ny4wOTUtNjIuNDYzIDEzOS42MDQtMTM5LjUgMTM5LjYwNHY0Ni41MzVjMTAyLjczNyAwIDE4Ni04My4zNDYgMTg2LTE4Ni4xMzlDMzcyIDgzLjg0NiAyODguNzM3LjUgMTg2IC41WiIvPjwvc3ZnPg==";
  if (C === "Xpla")
    return PREFIX + "PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI0OCIgaGVpZ2h0PSI0OCIgZmlsbD0ibm9uZSI+PHBhdGggZmlsbD0iIzAwQjFGRiIgZD0iTTI0IDQ4YzEzLjI2IDAgMjQtMTAuNzQgMjQtMjRTMzcuMjYgMCAyNCAwIDAgMTAuNzQgMCAyNHMxMC43NCAyNCAyNCAyNFoiLz48cGF0aCBmaWxsPSIjZmZmIiBkPSJtMjcuNDM1IDI1LjcxLTEuNjk1IDEuNjk1IDExLjY0IDExLjY3IDEuNjk1LTEuNjk1LTExLjY0LTExLjY3Wk0xMC41OSA4Ljg5NSA4Ljg5NSAxMC41OWwxMS42NyAxMS42NyAxLjY5NS0xLjY5NS0xMS42Ny0xMS42N1ptMjYuNzc1LjAzLTExLjY0IDExLjY3IDEuNjk1IDEuNjk1IDExLjY0LTExLjY3LTEuNjk1LTEuNjk1Wk0yMC41OTUgMjUuNzQgOC45NTUgMzcuNDFsMS42OTUgMS42OTUgMTEuNjQtMTEuNjctMS42OTUtMS42OTVaIi8+PC9zdmc+";
  if (C === "Btc")
    return PREFIX + "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";
  if (C === "Base" || C === "BaseSepolia")
    return PREFIX + "PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNiIgaGVpZ2h0PSIxNiIgZmlsbD0ibm9uZSI+PGcgY2xpcC1wYXRoPSJ1cmwoI2EpIj48cGF0aCBmaWxsPSIjMDA1MkZGIiBkPSJNOCAxNkE4IDggMCAxIDAgOC0uMDAxIDggOCAwIDAgMCA4IDE2WiIvPjxwYXRoIGZpbGw9IiNmZmYiIGZpbGwtcnVsZT0iZXZlbm9kZCIgZD0iTTcuOTgxIDEzLjYzNGE1LjYzNCA1LjYzNCAwIDEgMC01LjYxNC02LjEwOGg4LjM2di45MzhoLTguMzZhNS42MzQgNS42MzQgMCAwIDAgNS42MTQgNS4xN1oiIGNsaXAtcnVsZT0iZXZlbm9kZCIvPjwvZz48ZGVmcz48Y2xpcFBhdGggaWQ9ImEiPjxwYXRoIGZpbGw9IiNmZmYiIGQ9Ik0wIDBoMTZ2MTZIMHoiLz48L2NsaXBQYXRoPjwvZGVmcz48L3N2Zz4=";
  if (C === "Sei" || C === "Seievm")
    return PREFIX + "PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNTYiIGhlaWdodD0iMjU2IiBmaWxsPSJub25lIj48cGF0aCBmaWxsPSIjZmZmIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xMjcuNjc0IDI1NmMzOC4wMjUgMCA3Mi4xODgtMTYuNDk3IDk1LjY4Ny00Mi43MDctMTAuOTMyLTkuNDc2LTI3LjQwNS0xMC4wNTEtMzkuMDQyLS42ODVsLTIuMjIzIDEuNzljLTIxLjMwNyAxNy4xNDgtNTIuMzU1IDE0LjYxNi03MC41ODUtNS43NTgtOS45NDMtMTEuMTEyLTI2Ljk3Mi0xMi4yNDctMzguMzA5LTIuNTUzbC0yNS42MzIgMjEuOTJDNjkuNTI0IDI0NS41MjQgOTcuMzczIDI1NiAxMjcuNjc0IDI1NlptNDEuNjA3LTYxLjk4MWMyMC4yOTUtMTYuMzM1IDQ4LjgyLTE1Ljc0OSA2OC4zNC4wMjdDMjQ5LjI4NyAxNzQuNzY0IDI1NiAxNTIuMTY0IDI1NiAxMjhjMC0yNi44NS04LjI4OC01MS43Ny0yMi40NTEtNzIuMzUtOS4xMzEtMS45NC0xOS4wMjguMzI1LTI2LjU0IDYuOTY2bC0yLjE0IDEuODljLTIwLjQ5IDE4LjExMS01MS42MjEgMTcuMDEtNzAuNzc2LTIuNTAyLTEwLjQ0Ni0xMC42NDMtMjcuNTEtMTAuOTkyLTM4LjM4NS0uNzg3TDY1Ljg3OSA4OS4yMSA0OS40NyA3MS44MSA3OS4zIDQzLjgyYzIwLjM3My0xOS4xMTggNTIuMzM3LTE4LjQ2NCA3MS45MDYgMS40NzMgMTAuMjI1IDEwLjQxNyAyNi44NDQgMTEuMDA0IDM3Ljc4MiAxLjMzNWwyLjEzOS0xLjg5YTU0LjE5IDU0LjE5IDAgMCAxIDIyLjM2Ni0xMS45MDZDMTkwLjc1NiAxMi40MjIgMTYwLjY2OSAwIDEyNy42NzQgMCA2Mi41MyAwIDguNzI0IDQ4LjQxNy40NTEgMTExLjE0MmMxOS43ODYtOS40NzEgNDQuMTkzLTUuODI3IDYwLjMyNiAxMC42NTIgMTAuMTg1IDEwLjQwMyAyNi41ODUgMTEuNTAxIDM4LjA3MiAyLjU1bDE2LjY3OC0xMi45OTdjMjAuOTYtMTYuMzMzIDUwLjU5LTE1LjU0MiA3MC42NDQgMS44ODVsMzIuNDcgMjguMjE4LTE1LjczIDE4LjAxLTMyLjQ3LTI4LjIxN2MtMTEuNDA0LTkuOTEtMjguMjUyLTEwLjM2LTQwLjE3LTEuMDczbC0xNi42NzggMTIuOTk3Yy0yMS4xMDcgMTYuNDQ3LTUxLjIzNyAxNC40My02OS45NS00LjY4NC0xMC44OC0xMS4xMTUtMjguNjc3LTExLjUwMy00MC4wMzQtLjg3M0wwIDE0MC45ODhjMi43IDI2LjczNCAxMy42NSA1MS4wNDEgMzAuMjcgNzAuMzVsMjcuMzQ2LTIzLjM4NWMyMS4yMzYtMTguMTYgNTMuMTM1LTE2LjAzNSA3MS43NjEgNC43ODEgOS43MzMgMTAuODc3IDI2LjMwNiAxMi4yMjggMzcuNjggMy4wNzR6IiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIHN0eWxlPSJzdHJva2Utd2lkdGg6Ni44MjMzMyIvPjwvc3ZnPg==";
  if (C === "Rootstock")
    return PREFIX + "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";
  if (C === "Scroll")
    return PREFIX + "PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbDpzcGFjZT0icHJlc2VydmUiIGlkPSJMYXllcl8xIiB4PSIwIiB5PSIwIiBzdHlsZT0iZW5hYmxlLWJhY2tncm91bmQ6bmV3IDAgMCAyNCAyNCIgdmVyc2lvbj0iMS4xIiB2aWV3Qm94PSIwIDAgMjQgMjQiPjxzdHlsZT4uc3Qye2ZpbGw6IzEwMTAxMH08L3N0eWxlPjxwYXRoIGQ9Ik0yMS42IDE2VjIuN2MwLTEuMS0uOS0yLTItMkg2LjFDMy4yLjcuOCAzLjIuOCA2LjJjMCAxIC4zIDEuOS43IDIuNi4zLjYuOSAxLjIgMS40IDEuNy4xLjIuMS4xLjUuNC42LjQgMS40LjYgMS40LjZ2Ny45YzAgLjQuMS43LjIgMS4xLjMgMS4xIDEuMSAyIDIuMSAyLjQuNC4yLjkuMyAxLjQuM2gxMC44YzIuMiAwIDMuOS0xLjggMy45LTQgMC0xLjMtLjctMi40LTEuNi0zLjJ6IiBzdHlsZT0iZmlsbDojZmZlZWRhIi8+PHBhdGggZD0iTTIxLjkgMTkuM2MwIDEuNC0xLjIgMi42LTIuNiAyLjZoLTcuNGMuNi0uNyAxLTEuNiAxLTIuNiAwLTEuNi0uOS0yLjYtLjktMi42aDcuNGMxLjMtLjEgMi41IDEuMSAyLjUgMi42eiIgc3R5bGU9ImZpbGw6I2ViYzI4ZSIvPjxwYXRoIGQ9Ik0zLjYgOS40Yy0uOS0uOC0xLjUtMS45LTEuNS0zLjJ2LS4xYy4xLTIuMiAxLjgtMy45IDMuOS00aDEzLjVjLjQgMCAuNi4zLjYuNnYxMS43Yy4zLjEuNS4xLjguMmwuNi4zVjIuN2MwLTEuMS0uOS0yLTItMkg2LjFDMy4yLjcuOCAzLjIuOCA2LjJjMCAxLjcuOCAzLjIgMiA0LjMuMi4xLjIuMi41LjIuNCAwIC43LS4zLjctLjctLjEtLjMtLjItLjQtLjQtLjZ6IiBjbGFzcz0ic3QyIi8+PHBhdGggZD0iTTE5LjMgMTUuMkg4LjdjLS43IDAtMS4zLjYtMS4zIDEuM3YxLjZjMCAuNy42IDEuMyAxLjMgMS4zaC44di0xLjNoLS44di0xLjVoLjRjMS4zIDAgMi4zIDEuMyAyLjMgMi42IDAgMS4yLTEuMSAyLjgtMi45IDIuNi0xLjYtLjEtMi41LTEuNi0yLjUtMi42VjZjMC0uNi0uNS0xLjEtMS4xLTEuMUg0djEuNGguOHYxM2MwIDIuNiAxLjggNCAzLjggNGgxMC43YzIuMiAwIDMuOS0xLjggMy45LTQgMC0yLjMtMS44LTQuMS0zLjktNC4xem0yLjYgNC4xYzAgMS40LTEuMiAyLjYtMi42IDIuNmgtNy40Yy42LS43IDEtMS42IDEtMi42IDAtMS42LS45LTIuNi0uOS0yLjZoNy40YzEuMy0uMSAyLjUgMS4xIDIuNSAyLjZ6TTE2LjQgNi41aC04VjUuMmg4Yy40IDAgLjcuMy43LjcgMCAuMy0uMy42LS43LjZ6IiBjbGFzcz0ic3QyIi8+PHBhdGggZD0iTTE2LjQgMTIuOWgtOHYtMS40aDhjLjQgMCAuNy4zLjcuNyAwIC40LS4zLjctLjcuN3pNMTcuOCA5LjdIOC40VjguNGg5LjRjLjQgMCAuNy4zLjcuNyAwIC4zLS4zLjYtLjcuNnoiIGNsYXNzPSJzdDIiLz48L3N2Zz4=";
  if (C === "Mantle")
    return PREFIX + "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";
  if (C === "Blast")
    return PREFIX + "PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNTIiIGhlaWdodD0iMTY2IiBmaWxsPSJub25lIj48cGF0aCBmaWxsPSIjRkNGQzAzIiBkPSJtMTk3LjkwMiA4MS41MTMgMzkuNjA4LTE5LjczNiAxMy42NTMtNDEuOTA2TDIyMy44NTcgMEg0Mi4wNDFMMCAzMS4yMjZoMjEzLjcxOGwtMTEuMzU1IDM1LjE0N0gxMTYuNjZsLTguMjQ2IDI1LjY4NGg4NS43MDNMMTcwLjA1NSAxNjZsNDAuMTQ5LTE5Ljg3MSAxNC4zMjktNDQuMzM5LTI2LjkwMS0xOS43MzYuMjctLjU0MVoiLz48cGF0aCBmaWxsPSIjRkNGQzAzIiBkPSJtNjAuNDIyIDEzNC4yMzMgMjQuNzM3LTc3LjA1Mi0yNy40NDEtMjAuNTQ4TDE2LjQ4OCAxNjZoMTUzLjU2NGwxMC4yNzMtMzEuNzY3SDYwLjQyMloiLz48L3N2Zz4=";
  if (C === "Xlayer")
    return PREFIX + "PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGlkPSJMYXllcl8xIiBkYXRhLW5hbWU9IkxheWVyIDEiIHZlcnNpb249IjEuMSIgdmlld0JveD0iMCAwIDY0IDY0Ij48ZGVmcz48bWFzayBpZD0ibWFzayIgd2lkdGg9IjE2LjMiIGhlaWdodD0iMTYuMyIgeD0iNDEuNSIgeT0iNDAuMiIgbWFza1VuaXRzPSJ1c2VyU3BhY2VPblVzZSI+PHBhdGggaWQ9Im1hc2swXzExMzc1Xzg1NTkiIGQ9Ik01Mi4zIDQwLjJoNS41djE2LjNoLTUuNXoiIGNsYXNzPSJjbHMtNCIgZGF0YS1uYW1lPSJtYXNrMCAxMTM3NSA4NTU5Ii8+PC9tYXNrPjxtYXNrIGlkPSJtYXNrLTEiIHdpZHRoPSIxNi4zIiBoZWlnaHQ9IjE2LjMiIHg9IjQxLjUiIHk9IjcuNSIgbWFza1VuaXRzPSJ1c2VyU3BhY2VPblVzZSI+PHBhdGggaWQ9Im1hc2sxXzExMzc1Xzg1NTkiIGQ9Ik01Mi4zIDcuNWg1LjV2MTYuM2gtNS41eiIgZGF0YS1uYW1lPSJtYXNrMSAxMTM3NSA4NTU5IiBzdHlsZT0ic3Ryb2tlLXdpZHRoOjA7ZmlsbDp1cmwoI2xpbmVhci1ncmFkaWVudCkiLz48L21hc2s+PG1hc2sgaWQ9Im1hc2stMiIgd2lkdGg9IjE2LjMiIGhlaWdodD0iMTYuMyIgeD0iNDciIHk9IjcuNSIgbWFza1VuaXRzPSJ1c2VyU3BhY2VPblVzZSI+PHBhdGggaWQ9Im1hc2syXzExMzc1Xzg1NTkiIGQ9Ik02MC42IDcuNWgyLjh2MTYuM2gtMi44eiIgY2xhc3M9ImNscy00IiBkYXRhLW5hbWU9Im1hc2syIDExMzc1IDg1NTkiLz48L21hc2s+PG1hc2sgaWQ9Im1hc2stMyIgd2lkdGg9IjE2LjMiIGhlaWdodD0iMTYuMyIgeD0iNDcuMSIgeT0iNDAuMiIgbWFza1VuaXRzPSJ1c2VyU3BhY2VPblVzZSI+PHBhdGggaWQ9Im1hc2szXzExMzc1Xzg1NTkiIGQ9Ik02MC42IDQwLjJoMi44djE2LjNoLTIuOHoiIGNsYXNzPSJjbHMtNCIgZGF0YS1uYW1lPSJtYXNrMyAxMTM3NSA4NTU5Ii8+PC9tYXNrPjxsaW5lYXJHcmFkaWVudCBpZD0ibGluZWFyLWdyYWRpZW50IiB4MT0iLTI5MjkuNCIgeDI9Ii0yOTM1LjQiIHkxPSI1MC4yIiB5Mj0iNTEuNCIgZ3JhZGllbnRUcmFuc2Zvcm09InJvdGF0ZSgtMTgwIC0xNDM4Ljg1IDMzLjI1KSIgZ3JhZGllbnRVbml0cz0idXNlclNwYWNlT25Vc2UiPjxzdG9wIG9mZnNldD0iMCIvPjxzdG9wIG9mZnNldD0iMSIgc3RvcC1jb2xvcj0iI2ZmZiIvPjwvbGluZWFyR3JhZGllbnQ+PHN0eWxlPi5jbHMtMywuY2xzLTQsLmNscy01LC5jbHMtNntzdHJva2Utd2lkdGg6MH0uY2xzLTN7ZmlsbC1vcGFjaXR5Oi4zfS5jbHMtMywuY2xzLTUsLmNscy02e2ZpbGw6I2ZmZn0uY2xzLTR7ZmlsbDojMDAwfS5jbHMtNXtmaWxsLW9wYWNpdHk6LjV9PC9zdHlsZT48L2RlZnM+PHBhdGggZD0iTTAgMGg2NHY2NEgweiIgY2xhc3M9ImNscy00Ii8+PHBhdGggZD0iTTU2LjcgNDAuMkg0Mi42Yy0uNiAwLTEuMS41LTEuMSAxLjF2MTQuMWMwIC42LjUgMS4xIDEuMSAxLjFoMTQuMWMuNiAwIDEuMS0uNSAxLjEtMS4xVjQxLjNjMC0uNi0uNS0xLjEtMS4xLTEuMVoiIGNsYXNzPSJjbHMtNSIgc3R5bGU9Im1hc2s6dXJsKCNtYXNrKSIvPjxwYXRoIGQ9Ik01Ni43IDcuNUg0Mi42Yy0uNiAwLTEuMS41LTEuMSAxLjF2MTQuMWMwIC42LjUgMS4xIDEuMSAxLjFoMTQuMWMuNiAwIDEuMS0uNSAxLjEtMS4xVjguNmMwLS42LS41LTEuMS0xLjEtMS4xWiIgY2xhc3M9ImNscy01IiBzdHlsZT0ibWFzazp1cmwoI21hc2stMSkiLz48cGF0aCBkPSJNNjIuMyA3LjVINDguMmMtLjYgMC0xLjEuNS0xLjEgMS4xdjE0LjFjMCAuNi41IDEuMSAxLjEgMS4xaDE0LjFjLjYgMCAxLjEtLjUgMS4xLTEuMVY4LjZjMC0uNi0uNS0xLjEtMS4xLTEuMVoiIGNsYXNzPSJjbHMtMyIgc3R5bGU9Im1hc2s6dXJsKCNtYXNrLTIpIi8+PHBhdGggZD0iTTYyLjMgNDAuMkg0OC4yYy0uNiAwLTEuMS41LTEuMSAxLjF2MTQuMWMwIC42LjUgMS4xIDEuMSAxLjFoMTQuMWMuNiAwIDEuMS0uNSAxLjEtMS4xVjQxLjNjMC0uNi0uNS0xLjEtMS4xLTEuMVoiIGNsYXNzPSJjbHMtMyIgc3R5bGU9Im1hc2s6dXJsKCNtYXNrLTMpIi8+PHBhdGggZD0iTTMyIDIzLjlIMTcuOWMtLjYgMC0xLjEuNS0xLjEgMS4xdjE0YzAgLjYuNSAxLjEgMS4xIDEuMUgzMmMuNiAwIDEuMS0uNSAxLjEtMS4xVjI1YzAtLjYtLjUtMS4xLTEuMS0xLjFaTTE1LjcgNy41SDEuNkMxIDcuNS41IDggLjUgOC42djE0LjFjMCAuNi41IDEuMSAxLjEgMS4xaDE0LjFjLjYgMCAxLjEtLjUgMS4xLTEuMVY4LjZjMC0uNi0uNS0xLjEtMS4xLTEuMVpNNDguNCA3LjVIMzQuM2MtLjYgMC0xLjEuNS0xLjEgMS4xdjE0LjFjMCAuNi41IDEuMSAxLjEgMS4xaDE0LjFjLjYgMCAxLjEtLjUgMS4xLTEuMVY4LjZjMC0uNi0uNS0xLjEtMS4xLTEuMVpNMTUuNyA0MC4ySDEuNmMtLjYgMC0xLjEuNS0xLjEgMS4xdjE0LjFjMCAuNi41IDEuMSAxLjEgMS4xaDE0LjFjLjYgMCAxLjEtLjUgMS4xLTEuMVY0MS4zYzAtLjYtLjUtMS4xLTEuMS0xLjFaTTQ4LjQgNDAuMkgzNC4zYy0uNiAwLTEuMS41LTEuMSAxLjF2MTQuMWMwIC42LjUgMS4xIDEuMSAxLjFoMTQuMWMuNiAwIDEuMS0uNSAxLjEtMS4xVjQxLjNjMC0uNi0uNS0xLjEtMS4xLTEuMVoiIGNsYXNzPSJjbHMtNiIvPjwvc3ZnPg==";
  if (C === "Linea")
    return PREFIX + "PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGlkPSJMYXllcl8yIiBkYXRhLW5hbWU9IkxheWVyIDIiIHZlcnNpb249IjEuMSIgdmlld0JveD0iMCAwIDEyOCAxMjgiPjxkZWZzPjxzdHlsZT4uY2xzLTJ7c3Ryb2tlLXdpZHRoOjA7ZmlsbDojZmZmfTwvc3R5bGU+PC9kZWZzPjxwYXRoIGQ9Ik0wIDBoMTI4djEyOEgweiIgc3R5bGU9InN0cm9rZS13aWR0aDowO2ZpbGw6IzAwMCIvPjxnIGlkPSJMYXllcl8xLTIiIGRhdGEtbmFtZT0iTGF5ZXIgMS0yIj48cGF0aCBkPSJNMTAwLjYgMTIxLjhIOC43VjI1aDIxdjc4aDcwLjl2MTguOFoiIGNsYXNzPSJjbHMtMiIvPjxjaXJjbGUgY3g9IjEwMC42IiBjeT0iMjUiIHI9IjE4LjgiIGNsYXNzPSJjbHMtMiIvPjwvZz48L3N2Zz4=";
  if (C === "Berachain")
    return PREFIX + "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";
  if (C === "Snaxchain")
    return PREFIX + "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";
  if (C === "Unichain")
    return PREFIX + "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";
  if (C === "Worldchain")
    return PREFIX + "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";
  if (C === "Ink")
    return PREFIX + "PHN2ZyB3aWR0aD0iMjc1IiBoZWlnaHQ9IjI3NSIgdmlld0JveD0iMCAwIDI3NSAyNzUiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+ICAgIDxwYXRoIGZpbGxSdWxlPSJldmVub2RkIiBjbGlwUnVsZT0iZXZlbm9kZCIgZD0iTTI3NSAxMzcuNUMyNzUgNjEuNTYwOCAyMTMuNDM5IC0zLjMxOTQxZS0wNiAxMzcuNSAwQzYxLjU2MDggMy4zMTk0MWUtMDYgLTMuMzE5NDFlLTA2IDYxLjU2MDggMCAxMzcuNUMzLjMxOTQxZS0wNiAyMTMuNDM5IDYxLjU2MDggMjc1IDEzNy41IDI3NUMyMTMuNDM5IDI3NSAyNzUgMjEzLjQzOSAyNzUgMTM3LjVaTTE1Ny4xMjUgMjQwLjQwN0MxNTcuMTI1IDI0OS43MzUgMTQ5LjQ2OSAyNTcuMzE3IDEzOC42MDIgMjU3LjUzNUMxMzguMzAxIDI1Ny41MzggMTM4IDI1Ny41MzkgMTM3LjY5OCAyNTcuNTRIMTM3LjMwMkM3MS4wOTY5IDI1Ny40MzMgMTcuNDYwMyAyMDMuNzMgMTcuNDYwMyAxMzcuNUMxNy40NjAzIDcxLjIwNDEgNzEuMjAzOSAxNy40NjA1IDEzNy41IDE3LjQ2MDVDMTM3Ljg1NyAxNy40NjA1IDEzOC4yMTUgMTcuNDYyMSAxMzguNTcxIDE3LjQ2NTJDMTUwLjgzNCAxNy42ODM2IDE1Ny4xMjUgMjUuMjY1NCAxNTcuMTI1IDM0LjU5MjlDMTU3LjEyNSA0NC4wODU5IDE0OC43MzMgNTEuMDcxNSAxMzkuODQzIDUxLjA3MTVDMTMwLjk1MiA1MS4wNzE1IDEzMC41MTYgNTEuMDcxNSAxMjIuMDA2IDUxLjc1MzRDMTEzLjQ5NSA1Mi40MzU0IDEwNC42OTUgNTkuNDIwOSAxMDQuNjk1IDY4Ljg4NTlDMTA0LjY5NSA3OC40MDcxIDExMi40MyA4Ni4wNzQ1IDEyMi4wMDYgODYuMDc0NUgxOTcuNDhDMjA3LjAyOCA4Ni4wNzQ1IDIxNC43NjIgOTMuNzQyIDIxNC43NjIgMTAzLjIwN0MyMTQuNzYyIDExMi42NzIgMjA3LjAyOCAxMjAuMzM5IDE5Ny40OCAxMjAuMzM5SDgxLjIyOThDNzEuNjUzOSAxMjAuMzM5IDYzLjkxOTUgMTI4LjAzNSA2My45MTk1IDEzNy41MjhDNjMuOTE5NSAxNDYuOTkzIDcxLjY1MzkgMTU0LjY2MSA4MS4yMjk4IDE1NC42NjFIMTM5Ljg0M0MxNDkuMzkxIDE1NC42NjEgMTU3LjEyNSAxNjIuMzI4IDE1Ny4xMjUgMTcxLjgyMUMxNTcuMTI1IDE4MS4yODYgMTQ5LjM5MSAxODguOTU0IDEzOS44NDMgMTg4Ljk1NEgxMjIuMDA2QzExMi40MyAxODguOTU0IDEwNC42OTUgMTk2LjYyMSAxMDQuNjk1IDIwNi4wODZDMTA0LjY5NSAyMTUuNTc5IDExMi42MjIgMjIyLjUwOSAxMjIuMDA2IDIyMy4yMTlDMTIyLjc0NSAyMjMuMjc1IDEyMy40MjIgMjIzLjMyNiAxMjQuMDQ1IDIyMy4zNzRDMTI3LjM0NyAyMjMuNjI1IDEyOS4xNTEgMjIzLjc2MyAxMzAuOTU4IDIyMy44MzhDMTMzLjEzNCAyMjMuOTI5IDEzNS4zMTQgMjIzLjkyOSAxNDAuMTE5IDIyMy45MjlDMTQ5LjY2NyAyMjMuOTI5IDE1Ny4xMjUgMjMwLjk0MiAxNTcuMTI1IDI0MC40MDdaIiBmaWxsPSIjNzEzMkY1Ii8+PC9zdmc+";
  if (C === "Wormchain")
    return PREFIX + "PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyOCIgaGVpZ2h0PSIyOCIgZmlsbD0ibm9uZSI+PGNpcmNsZSBjeD0iMTQiIGN5PSIxNCIgcj0iMTQiIGZpbGw9IiMwMDAiLz48cGF0aCBmaWxsPSIjZmZmIiBkPSJNMTQuMDM1IDIzLjMxYTkuMjc1IDkuMjc1IDAgMSAxIDkuMjc1LTkuMjc1IDkuMjgxIDkuMjgxIDAgMCAxLTkuMjc1IDkuMjc1Wm0wLTE4LjE0YTguODY1IDguODY1IDAgMSAwIDAgMTcuNzMgOC44NjUgOC44NjUgMCAwIDAgMC0xNy43M1oiLz48cGF0aCBmaWxsPSIjZmZmIiBkPSJNMTQuNzk0IDIyLjRhOC4zMzQgOC4zMzQgMCAxIDEgMC0xNi42NjkgOC4zMzQgOC4zMzQgMCAwIDEgMCAxNi42NjlabTAtMTYuMzA4YTcuOTggNy45OCAwIDEgMCA3Ljk4IDcuOTggNy45OTEgNy45OTEgMCAwIDAtNy45OC03Ljk4WiIvPjxwYXRoIGZpbGw9IiNmZmYiIGQ9Ik0xNS41NTQgMjEuNDk2YTcuMzk1IDcuMzk1IDAgMSAxIDAtMTQuNzkgNy4zOTUgNy4zOTUgMCAwIDEgMCAxNC43OVptMC0xNC40NjRhNy4wOTMgNy4wOTMgMCAxIDAgNy4wOTMgNy4wNyA3LjEgNy4xIDAgMCAwLTcuMDkzLTcuMDg4Ii8+PHBhdGggZmlsbD0iI2ZmZiIgZD0iTTE2LjMxMyAyMC41ODZhNi40NDggNi40NDggMCAxIDEgMC0xMi44OTcgNi40NDggNi40NDggMCAwIDEgMCAxMi44OTdabTAtMTIuNjU2YTYuMjA4IDYuMjA4IDAgMSAwIDAgMTIuNDE1IDYuMjA4IDYuMjA4IDAgMCAwIDAtMTIuNDE1WiIvPjxwYXRoIGZpbGw9IiNmZmYiIGQ9Ik0xNy4wNzIgMTkuNjgyYTUuNTA4IDUuNTA4IDAgMSAxIDAtMTEuMDE2IDUuNTA4IDUuNTA4IDAgMCAxIDAgMTEuMDE2Wm0wLTEwLjg0OGE1LjMyMiA1LjMyMiAwIDEgMC0uMDEyIDEwLjY0MyA1LjMyMiA1LjMyMiAwIDAgMCAuMDEyLTEwLjY0M1oiLz48cGF0aCBmaWxsPSIjZmZmIiBkPSJNMTcuODMyIDE4Ljc3MmE0LjU2OCA0LjU2OCAwIDEgMSAwLTkuMTM3IDQuNTY4IDQuNTY4IDAgMCAxIDAgOS4xMzdabTAtOC45OThhNC40MzYgNC40MzYgMCAxIDAgNC40MDUgNC40MzYgNC40MzYgNC40MzYgMCAwIDAtNC40My00LjQzIi8+PC9zdmc+";
  if (C === "Cosmoshub")
    return PREFIX + "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";
  if (C === "Evmos")
    return PREFIX + "PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNTYiIGhlaWdodD0iMTU2IiBmaWxsPSJub25lIj48Y2lyY2xlIGN4PSI3Ny41NzEiIGN5PSI3Ny41NzEiIHI9Ijc3LjU3MSIgZmlsbD0iI2VkNGUzMyIvPjxwYXRoIGZpbGw9IiNmZmYiIGQ9Ik02My41ODcgNDEuNTQzQzQyLjQyNSA0OS42OCA0MC40ODcgNzAuNTE4IDM0LjQyIDgwLjI1Yy02LjE0IDkuODQ4LTIwLjIwNiAxNS4yODEtMTguMjgyIDIwLjMgMS45MjMgNS4wMTggMTYuMDA2LS4zNzIgMjcuMTQ3IDIuODMgMTEuMDEgMy4xNjQgMjYuMzcxIDE3LjM1MiA0Ny41MzMgOS4yMTUgMTAuNzgtNC4xNDUgMTguNTg2LTEyLjY3NyAyMi4xNzYtMjIuNzgyLjM4Ni0xLjA4NC0uMzM2LTIuMjQ0LTEuNDgxLTIuMzUyYTEuNzM3IDEuNzM3IDAgMCAwLTEuNzE2Ljk0NmMtMy4yNDcgNi40NzgtOC44MTcgMTEuODEzLTE2LjEwNyAxNC42MTUtMTIuMDMzIDQuNjI3LTI1LjIuOTk0LTMzLjI4Ny04LjExN2EzMC4wMTEgMzAuMDExIDAgMCAxLTQuNjQ4LTcuMDI3IDMwLjAwNiAzMC4wMDYgMCAwIDEtLjk1Mi0yLjE5OCAzMC40NjUgMzAuNDY1IDAgMCAxLS43Ni0yLjI3M2M2LjM2LTIuOTcgMTMuNy02LjExNCAyMi4wMi05LjMxMyA4LjE1OS0zLjEzNyAxNS41ODQtNS42ODEgMjIuMTk1LTcuNzE3YTI1MS44MDEgMjUxLjgwMSAwIDAgMSAxMi4yNzItMy40NTZsLjc5NC0uMmMuNTYtLjEzOCAxLjEzNS4xNjEgMS4zNDIuN2wuMDA0LjAxYy4xMjIuMzIuMjI3LjY0MS4zNC45NjNhMzguNDcxIDM4LjQ3MSAwIDAgMSAxLjY0MyA2LjI3IDEuMzYxIDEuMzYxIDAgMCAwIDEuOTg0Ljk3OCAxNjEuMjY0IDE2MS4yNjQgMCAwIDAgOC4zLTQuNzYxYzkuMjU0LTUuNzA4IDE0LjM4NC0xMC41NDkgMTMuMzMxLTEzLjI5Mi0xLjA1MS0yLjc0NS04LjA5Ny0yLjkwMy0xOC43ODctLjk0NC0zLjM5Ny42MjItNy4xNjQgMS40Ni0xMS4yMjMgMi40OTUtLjcwMi4xOC0xLjQxMi4zNjUtMi4xMzEuNTU2YTI3My43OTUgMjczLjc5NSAwIDAgMC0xMC43NyAzLjExYy02Ljk3OCAyLjE2NS0xNC40NjMgNC43NTctMjIuMTkgNy43MjlhMzYwLjQ5NiAzNjAuNDk2IDAgMCAwLTIwLjM2NCA4LjUzNWMtLjA3Ny0xMi4xOTEgNy4yOC0yMy43MTYgMTkuMzE1LTI4LjM0M2EyOS45MzUgMjkuOTM1IDAgMCAxIDIxLjczMy4wNjdjLjY2NS4yNjIgMS40MjIuMDggMS45MDgtLjQ0Ni43NzktLjg0Ni41NC0yLjE5Mi0uNDcxLTIuNzQtOS40MTktNS4xMDEtMjAuOTItNi4yMS0zMS43LTIuMDY1eiIvPjwvc3ZnPg==";
  if (C === "Kujira")
    return PREFIX + "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";
  if (C === "Neutron")
    return PREFIX + "PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI2NCIgaGVpZ2h0PSI2NCIgZmlsbD0ibm9uZSIgdmlld0JveD0iLTQgLTQgNjQgNjQiPjxwYXRoIGZpbGw9IiNmZmYiIGZpbGwtcnVsZT0iZXZlbm9kZCIgZD0iTTU2IDBIMy45NmwxNS4yOSAxOC4wMzJBMTMuMjEzIDEzLjIxMyAwIDAgMSAyOCAxNC43MzdjNy4zMjUgMCAxMy4yNjMgNS45MzggMTMuMjYzIDEzLjI2M2ExMy4yMSAxMy4yMSAwIDAgMS0zLjE5IDguNjI5TDU2IDUyLjEzMlY1NiAwWm0tNi43MjQgNTYtMTQuMjItMTYuNzY4QTEzLjIgMTMuMiAwIDAgMSAyOCA0MS4yNjNjLTcuMzI2IDAtMTMuMjY0LTUuOTM4LTEzLjI2NC0xMy4yNjMgMC0yLjU3OC43MzYtNC45ODUgMi4wMS03LjAyMkwwIDYuNTRWNTZoNDkuMjc2WiIgY2xpcC1ydWxlPSJldmVub2RkIi8+PC9zdmc+";
  if (C === "Celestia")
    return PREFIX + "PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbDpzcGFjZT0icHJlc2VydmUiIHZpZXdCb3g9IjAgMCAyMTQuNyAyMTQuNyI+PHBhdGggZD0iTTIxMi4yIDg0LjlDMTk5LjkgMjcgMTQyLjktMTAgODUgMi40Yy0yMC4zIDQuMy0zOC44IDE0LjQtNTMuNSAyOS00LjkgNC45LTkuMyAxMC4yLTEzLjEgMTUuOWEzOC44IDM4LjggMCAwIDAtMyA0LjhjLTMwLjYgNTAuNy0xNC4yIDExNi43IDM2LjUgMTQ3LjIgNTAuNyAzMC41IDExNi43IDE0LjIgMTQ3LjItMzYuNSAyLjQtNCA0LjUtOC4xIDYuNC0xMi4zLjYtMS4zIDEuMi0yLjcgMS43LTQuMSA3LjYtMTkuNSA5LjMtNDAuNyA1LjEtNjEuMXptLTM3LjItNDkgMS44IDEuOGM5LjMgOS4zIDE2LjcgMjAuNCAyMS43IDMyLjYuMy44LS4xIDEuOC0uOSAyLjItLjMuMS0uNi4yLS45LjEtMy4xLS41LTYuMy0uOC05LjUtLjctMi40IDAtNC41LTEuNy01LTQuMS0xLjctMTAtNC41LTE5LjgtOC4yLTI5LjNsLS42LTEuNWMtLjMtLjUtLjItMS4xLjItMS41LjQtLjQgMS4xLS4xIDEuNC40em0xMC4yIDYyLjljMC0uNi41LTEuMiAxLjEtMS4yLjQgMCAuNy4yIDEgLjUuOCAxLjEgMS42IDIuMyAyLjMgMy40IDEgMS41IDEuOSAzIDIuOCA0LjUuNS45LjQgMi4xLS4zIDIuOS0xLjEgMS4zLTIuNCAyLjYtMy44IDMuOWwtMS41IDEuNWMtLjQuNC0xIC4zLTEuNC0uMS0uMi0uMi0uMy0uNC0uMy0uNy4xLTEuNi4xLTMuMi4xLTQuOS4xLTMuMi4xLTYuNSAwLTkuOHptLTEzNS03MS43QzY2LjkgMTUuMiA4Ni45IDguOCAxMDcuMyA4LjljNS40IDAgMTAuOC40IDE2LjIgMS4zLjkuMSAxLjUgMSAxLjQgMS45LS4xLjQtLjMuOC0uNiAxLTUuMSA0LTkuOSAxMC0xNC4xIDE3LjctMSAxLjktMy4yIDIuOC01LjMgMi4yYTEzNSAxMzUgMCAwIDAtNDAuNS01LjNjLTQuNS4xLTguOS42LTEzLjMgMS40LS42LjEtMS4yLS4zLTEuMy0uOS0uMS0uNC4xLS44LjQtMS4xek0zNi4yIDE3NGMtMi4xLTMuOS42LTEyLjkgMTQuMi0yNi43IDEuMy0xLjMgMS4zLTMuNS0uMS00LjgtLjEtLjEtLjItLjEtLjItLjJsLTEuNi0xLjNjLTEuMy0xLjEtMy4zLTEtNC41LjJsLS41LjVjLTYuOCA3LTExLjUgMTMuNC0xNC4yIDE5LjItLjYgMS4yLTEuOSAxLjYtMy4xIDEuMS0uNC0uMi0uNy0uNC0uOS0uOEMxNC42IDE0NS4zIDkgMTI2LjUgOSAxMDcuM2MwLTYuOS43LTEzLjggMi4xLTIwLjUuMS0uNS43LS45IDEuMi0uOC4zLjEuNi4zLjcuNyAyLjMgNy40IDUuNyAxNC4zIDkuOSAyMC44IDYuNyAxMC4xIDE0LjggMTkuMiAyNCAyNyAzLjMgMi45IDYuOCA1LjYgMTAuNCA4LjMgNy41IDUuNSAxNS41IDEwLjQgMjMuOCAxNC43IDMuOCAyIDcuNCAzLjggMTEuMiA1LjUgMi4xLjkgNC41IDEgNi42LjIgMS44LS43IDMuNi0xLjQgNS40LTIuMiAyLS44IDMtMi45IDIuNS01LS4xLS4zLS4xLS41LS4xLS42LTMuMS0xMy41LTQuNy0yNy4zLTQuOC00MS4ydi03Yy4xLTIuNS4xLTUgLjMtNy41LjktMTcuNyAzLjktMzQuNCA4LjctNDguNC40LTEuMy0uMi0yLjctMS41LTMuMS0xLjMtLjQtMi41LS44LTMuOC0xLjItMS4zLS40LTIuNi4zLTMuMSAxLjYtNS4yIDE1LjItOC40IDMzLjMtOS4yIDUyLjQtLjEgMi40LTEuNCA0LjYtMy41IDUuOS0xMC43IDYuMy0yMSAxMy4zLTMwLjcgMjEtMS45IDEuNS00LjUgMS40LTYuNC0uMS04LjYtNy4zLTE2LjEtMTUuNy0yMi4zLTI1LjEtMTEuMi0xNy4zLTEzLjktMzMuNi03LjUtNDUuOGwuMS0uMWMuOC0xLjQgMS43LTIuNyAyLjYtNCA3LjQtOS43IDIxLTE1LjQgMzkuMi0xNiAxLjEgMCAyLjMtLjEgMy41LS4xIDExLjkuMSAyMy44IDEuOSAzNS4yIDUuM2wuOC4yLjYuMmMyLjguOCA1LjYgMS44IDguNCAyLjhsLjIuMSAyLjIuOC43LjMuNy4yYzYgMi4zIDEyIDUgMTcuNyA4IDExIDUuNyAyMS4zIDEyLjUgMzAuNyAyMC40LTE3LjIgNC0zNy4yIDExLjYtNTcuNCAyMS45LS45LjUtMS41IDEuNC0xLjYgMi40LS4xIDEuMi0uMiAzLjgtLjIgNS44IDAgLjkuNyAxLjcgMS42IDEuNy4zIDAgLjUtLjEuOC0uMiAxOS45LTEwLjUgMzkuOC0xOC4zIDU2LjktMjIuNCAzLjItLjggNS4zLTMuOCA0LjgtNy4xLS4zLTIuMy0uNy00LjUtMS4xLTYuNy0uNS0yLjgtMi01LjItNC4yLTYuOS04LjMtNi4zLTE3LTExLjgtMjYuMy0xNi42LTYuMy0zLjMtMTIuNy02LjItMTkuMy04LjctMS4zLS41LTEuOS0xLjktMS40LTMuMSAwLS4xLjEtLjIuMi0uMyA2LjctMTEuOSAxNC42LTE4LjYgMjIuMy0xOC42aC4yYzkuMS4yIDE4LjIgOS43IDI0LjkgMjYgMy42IDkuMSA2LjMgMTguNiA3LjkgMjguMi44IDQuNCAxLjQgOSAxLjkgMTMuN2wtLjEuMS4yLjJjLjggOC4xIDEuMSAxNi4zLjkgMjQuNS0uMSA1LjMtLjQgMTAuNS0uOCAxNS42LTEzLjcgMTAuOC0yOC4zIDIwLjQtNDMuOCAyOC40LTUuNCAyLjktMTAuOSA1LjYtMTYuMyA4bC0uMi4xLTEuMi42Yy00LjUgMi04LjkgMy45LTEzLjIgNS42bC0uNy4zLS45LjQtMi4yLjgtLjYuMmMtLjkuMy0xLjguNi0yLjYgMWwtLjMuMWMtOC42IDMuMS0xNy40IDUuNi0yNi4zIDcuNC0xOS45IDMuNS0yOS4xLjYtMzEuMi0zLjR6bTI3LTM4LjFjOS41LTcuNiAxOS41LTE0LjYgMzAtMjAuOC4yIDEzLjUgMS43IDI3IDQuNiA0MC4zLTQuMS0xLjgtOC4yLTMuNy0xMi4zLTUuOC03LjgtNC4xLTE1LjMtOC42LTIyLjMtMTMuN3ptNTYuOSA2OC45Yy00LjIuNS04LjQuOC0xMi43LjgtMTguOC4xLTM3LjMtNS4zLTUzLjEtMTUuNS0uNi0uNC0uOC0xLjItLjQtMS44LjItLjQuNi0uNiAxLjEtLjZoLjdjNC40LS4zIDguOC0uOSAxMy4xLTEuOCAxMS4zLTIuMyAyMi4zLTUuNiAzMy05LjcgMS4xLS40IDIuMi4xIDIuNiAxLjIgNC42IDExLjEgMTAuMSAxOS40IDE2LjQgMjQuOC43LjYuNyAxLjYuMSAyLjItLjIuMS0uNS4zLS44LjR6bTQxLjUtMjYuM2MtNyAxMy44LTE1LjcgMjEuNi0yNCAyMS40LTkuMS0uMi0xOC4yLTkuNi0yNC45LTI2LS40LTEgLjEtMi4yIDEuMS0yLjdsLjItLjFjLjQtLjIuOS0uMiAxLjQtLjEgMTEuOSAzLjQgMjQuMiA1LjMgMzYuNiA1LjQgMS4zIDAgMi41IDAgMy44LS4xIDEuNS0uMSAyLjktLjEgNC4zLS4yLjkgMCAxLjcuNyAxLjcgMS42IDAgLjMtLjEuNi0uMi44em0zLTExLjljLTMuMS40LTYuMi43LTkuMi44LTguMy4yLTE2LjYtLjQtMjQuOC0yLS42LS4xLTEtLjctLjktMS4zLjEtLjMuMy0uNi42LS44IDEuOS0uOSAzLjctMS45IDUuNi0yLjkgMTIuNS02LjYgMjQuNS0xNCAzNi0yMi4zLjUtLjQgMS4yLS4zIDEuNS4yLjIuMi4zLjYuMi45LTEuNCA4LjUtMy40IDE2LjgtNi4xIDI0LjktLjQgMS40LTEuNSAyLjMtMi45IDIuNXptMTQuNSA3LjhjLS43LjgtMS41IDEuNi0yLjMgMi4zLTEuMyAxLjMtMi43IDIuNi00LjEgMy45LS41LjQtMS4yLjMtMS42LS4xLS4zLS4zLS4zLS44LS4yLTEuMi4xLS4zLjMtLjYuNC0uOS42LTEuMyAxLjItMi43IDEuNy00IC4xLS4zLjQtLjYuNy0uNiAxLjQtLjMgMi44LS43IDQuMS0xLjIuNi0uMiAxLjIuMSAxLjQuNy4zLjQuMi44LS4xIDEuMXptMTkuOC0zMS4yLTEuNSAzLjYtLjIuNWMtMy4yIDYuMi04LjcgMTEuMi0xNiAxNC42LTEuMS41LTIuMyAwLTIuOC0xLS4yLS41LS4zLTEtLjEtMS40IDIuNS05LjEgNC4zLTE4LjQgNS40LTI3LjguMi0xLjggMS4xLTMuNSAyLjUtNC43IDMtMi42IDUuOC01LjIgOC40LTcuNy45LS45IDIuNC0uOSAzLjMgMCAuMy4zLjUuNi42IDEgMi42IDguMiAyLjcgMTYuMS40IDIyLjl6bTItNDZjLS41IDEtMS44IDEuMy0yLjcuOC0uMy0uMi0uNS0uNC0uNy0uNy0uMS0uMi0uMi0uNC0uNC0uNi0zLTQuNi02LjQtOS4xLTEwLjEtMTMuMi0uNi0uNy0uNS0xLjcuMS0yLjMuMy0uMy43LS40IDEuMS0uNCA4LjggMCAxMy40IDIuMiAxNC44IDQuOCAxLjIgMi4yLjkgNi4xLTIuMSAxMS42em00LjggMTNjMCAuMy0uMy42LS42LjYtLjIgMC0uNS0uMi0uNi0uNGwtLjMtLjhjLS4yLS41LS4yLTEgLjEtMS41LjEtLjEuMi0uMy40LS41LjQtLjYgMS0uNSAxIC4xeiIgc3R5bGU9ImZpbGw6IzdiMmJmOSIvPjwvc3ZnPg==";
  if (C === "Stargaze")
    return PREFIX + "PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxODAiIGhlaWdodD0iMTgwIiBmaWxsPSJub25lIj48ZyBmaWxsPSIjZmZmIj48cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik05MCAxNzJjNDUuMjg3IDAgODItMzYuNzEzIDgyLTgyUzEzNS4yODcgOCA5MCA4IDggNDQuNzEzIDggOTBzMzYuNzEzIDgyIDgyIDgyem05MC04MmMwIDQ5LjcwNi00MC4yOTQgOTAtOTAgOTBTMCAxMzkuNzA2IDAgOTAgNDAuMjk0IDAgOTAgMHM5MCA0MC4yOTQgOTAgOTB6IiBjbGlwLXJ1bGU9ImV2ZW5vZGQiLz48cGF0aCBkPSJtMTA2LjY5IDIyLjQ3IDMuNjMgNTAuNDFMMTU5LjM4IDg1bC00Ni44MiAxOS4wMyAzLjYzIDUwLjQxLTMyLjU2LTM4LjY1LTQ2LjgyIDE5LjA0TDYzLjUgOTEuOTEgMzAuOTMgNTMuMjZsNDkuMDYgMTIuMTN6Ii8+PC9nPjwvc3ZnPg==";
  if (C === "Seda")
    return PREFIX + "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";
  if (C === "Dymension")
    return PREFIX + "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";
  if (C === "Provenance")
    return PREFIX + "PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI1MTIiIGhlaWdodD0iNTEyIiBmaWxsPSJub25lIj48cGF0aCBmaWxsPSIjMkE3REUxIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0yNjUuMjMzIDIuNTQ1YTE5LjI5OCAxOS4yOTggMCAwIDAtMTkuMTU2IDBsLTIwNS41IDExOC43MzRBMTkuMDIgMTkuMDIgMCAwIDAgMzEgMTM3Ljc1OHYyMzcuNDdhMTkuMDE3IDE5LjAxNyAwIDAgMCA5LjU3OCAxNi40NzlsODMuMjQyIDQ4LjE3VjE5OS4xNjhhMTkuMjkxIDE5LjI5MSAwIDAgMSA5LjAxNC0xNi4wNTdsNTYuMzQtMzQuOTMgNTYuMzQtMzQuNTA4YTE5LjAyMiAxOS4wMjIgMCAwIDEgMjAgMGw1Ni4zNCAzNC41MDggNTYuMzQgMzQuOTNhMTkuMyAxOS4zIDAgMCAxIDkuMDE0IDE2LjMzOXYxMTMuOTQ1YTE5LjAwNyAxOS4wMDcgMCAwIDEtOS4wMTQgMTYuMzM5bC01Ni4zNCAzNS4wNzEtNTYuMzQgMzQuMzY3Yy01LjM1MiAzLjM4LTEwLjcwNC0yLjExMy0xMC43MDQtOC40NTFWMzQ1LjY1YTE4LjQ1NyAxOC40NTcgMCAwIDEgMTAuNzA0LTE0LjA4NWw0Ny4xODUtMjkuMTU2YTE5LjI5NCAxOS4yOTQgMCAwIDAgOS4wMTQtMTYuMzM4VjIzOS40NWExOC44NjcgMTguODY3IDAgMCAwLTkuMDE0LTE1LjkxNWwtNDYuOTAzLTI4LjE3YTE5LjAxMyAxOS4wMTMgMCAwIDAtMjAgMGwtNDYuNzYzIDI4LjE3YTE4Ljc0MSAxOC43NDEgMCAwIDAtOS4yOTYgMTUuOTE1djIzNC43OTNjLjA3Ljg0NC4wNyAxLjY5MiAwIDIuNTM2bDU2LjM0IDMyLjY3NmExOS4yOTMgMTkuMjkzIDAgMCAwIDE5LjE1NiAwbDIwNS42NC0xMTguNzM0YTE5LjAxOCAxOS4wMTggMCAwIDAgOS41NzgtMTYuNDc5VjEzNy43NThhMTkuMDE0IDE5LjAxNCAwIDAgMC05LjU3OC0xNi40NzlMMjY1LjIzMyAyLjU0NVoiIGNsaXAtcnVsZT0iZXZlbm9kZCIvPjwvc3ZnPg==";
  if (C === "Noble")
    return PREFIX + "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";
  if (C === "MonadDevnet")
    return PREFIX + "PHN2ZyB3aWR0aD0iMzIiIGhlaWdodD0iMzIiIHZpZXdCb3g9IjAgMCAzMiAzMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTUuOTk5OSAwQzExLjM3OTUgMCAwIDExLjM3OTIgMCAxNS45OTk5QzAgMjAuNjIwNiAxMS4zNzk1IDMyIDE1Ljk5OTkgMzJDMjAuNjIwMyAzMiAzMiAyMC42MjA0IDMyIDE1Ljk5OTlDMzIgMTEuMzc5NCAyMC42MjA1IDAgMTUuOTk5OSAwWk0xMy41MDY2IDI1LjE0OTJDMTEuNTU4MiAyNC42MTgzIDYuMzE5ODEgMTUuNDU1IDYuODUwODMgMTMuNTA2NkM3LjM4MTg1IDExLjU1ODEgMTYuNTQ1IDYuMzE5NzkgMTguNDkzMyA2Ljg1MDhDMjAuNDQxOCA3LjM4MTczIDI1LjY4MDIgMTYuNTQ0OSAyNS4xNDkyIDE4LjQ5MzRDMjQuNjE4MiAyMC40NDE4IDE1LjQ1NSAyNS42ODAyIDEzLjUwNjYgMjUuMTQ5MloiIGZpbGw9IiM4MzZFRjkiLz48L3N2Zz4=";
  {
    const e = C;
    return "";
  }
}
function WBTC() {
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(
    "svg",
    {
      style: { maxHeight: "100%", maxWidth: "100%" },
      width: "200",
      height: "201",
      viewBox: "0 0 200 201",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ jsxRuntimeExports.jsxs("g", { clipPath: "url(#clip0_314_9802)", children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            "path",
            {
              d: "M197.008 124.204C183.651 177.782 129.385 210.389 75.8004 197.028C22.2386 183.671 -10.3679 129.402 2.99519 75.8283C16.3465 22.2444 70.6123 -10.3645 124.18 2.99268C177.76 16.3499 210.365 70.625 197.006 124.205L197.007 124.204H197.008Z",
              fill: "#F7931A"
            }
          ),
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            "path",
            {
              d: "M144.1 85.7619C146.091 72.4526 135.958 65.2984 122.102 60.5258L126.597 42.4971L115.623 39.7625L111.247 57.3165C108.362 56.5969 105.399 55.9189 102.454 55.2467L106.862 37.5769L95.8939 34.8423L91.3965 52.8651C89.009 52.3215 86.664 51.7842 84.3889 51.2181L84.4016 51.1614L69.2674 47.3822L66.3481 59.1037C66.3481 59.1037 74.4903 60.9701 74.3187 61.085C78.7628 62.1942 79.5665 65.1361 79.433 67.4679L74.3128 88.0067C74.6188 88.0844 75.0158 88.1969 75.4538 88.3729C75.0876 88.2819 74.698 88.1827 74.2938 88.0859L67.117 116.858C66.5739 118.208 65.1954 120.234 62.0883 119.465C62.1982 119.624 54.1118 117.474 54.1118 117.474L48.6631 130.037L62.9447 133.597C65.6016 134.263 68.2052 134.96 70.7692 135.616L66.2278 153.851L77.1897 156.586L81.6871 138.544C84.6817 139.357 87.5879 140.107 90.433 140.814L85.9508 158.771L96.9258 161.505L101.467 143.304C120.181 146.846 134.252 145.418 140.175 128.491C144.948 114.863 139.937 107.002 130.092 101.876C137.263 100.222 142.664 95.5061 144.104 85.7634L144.101 85.7609L144.1 85.7619ZM119.026 120.923C115.634 134.551 92.689 127.184 85.2498 125.336L91.2763 101.178C98.715 103.035 122.571 106.71 119.027 120.923H119.026ZM122.42 85.5644C119.326 97.9606 100.228 91.6628 94.0333 90.1185L99.4972 68.208C105.692 69.7522 125.643 72.6345 122.421 85.5644H122.42Z",
              fill: "white"
            }
          )
        ] }),
        /* @__PURE__ */ jsxRuntimeExports.jsx("defs", { children: /* @__PURE__ */ jsxRuntimeExports.jsx("clipPath", { id: "clip0_314_9802", children: /* @__PURE__ */ jsxRuntimeExports.jsx("rect", { width: "200", height: "200.022", fill: "white" }) }) })
      ]
    }
  );
}
function BUSD() {
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(
    "svg",
    {
      style: { maxHeight: "100%", maxWidth: "100%" },
      width: "200",
      height: "200",
      viewBox: "0 0 200 200",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ jsxRuntimeExports.jsxs("g", { clipPath: "url(#clip0_313_9795)", children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            "path",
            {
              d: "M99.6979 0.420898L124.296 25.6121L62.3557 87.5527L37.7573 62.9542L99.6979 0.420898Z",
              fill: "#F0B90B",
              stroke: "#F0B90B"
            }
          ),
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            "path",
            {
              d: "M137.04 37.7632L161.639 62.9543L62.3557 162.237L37.7573 137.639L137.04 37.7632Z",
              fill: "#F0B90B",
              stroke: "#F0B90B"
            }
          ),
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            "path",
            {
              d: "M25.0135 75.1055L49.6119 100.297L25.0135 124.895L0.415039 100.297L25.0135 75.1055Z",
              fill: "#F0B90B",
              stroke: "#F0B90B"
            }
          ),
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            "path",
            {
              d: "M174.382 75.1055L198.981 100.297L99.698 199.579L75.0996 174.981L174.382 75.1055Z",
              fill: "#F0B90B",
              stroke: "#F0B90B"
            }
          )
        ] }),
        /* @__PURE__ */ jsxRuntimeExports.jsx("defs", { children: /* @__PURE__ */ jsxRuntimeExports.jsx("clipPath", { id: "clip0_313_9795", children: /* @__PURE__ */ jsxRuntimeExports.jsx("rect", { width: "199.401", height: "200", fill: "white" }) }) })
      ]
    }
  );
}
function USDT() {
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(
    "svg",
    {
      style: { maxHeight: "100%", maxWidth: "100%" },
      width: "230",
      height: "200",
      viewBox: "0 0 230 200",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ jsxRuntimeExports.jsxs("g", { clipPath: "url(#clip0_313_9792)", children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            "path",
            {
              fillRule: "evenodd",
              clipRule: "evenodd",
              d: "M42.0972 0.982283L0.176253 89.0373C0.0167314 89.3648 -0.0338199 89.7348 0.0319915 90.0931C0.0978028 90.4514 0.276524 90.7792 0.54202 91.0287L113.76 199.519C114.082 199.828 114.51 200 114.956 200C115.402 200 115.83 199.828 116.151 199.519L229.37 91.0355C229.635 90.786 229.814 90.4582 229.88 90.0998C229.946 89.7415 229.895 89.3716 229.736 89.0441L187.815 0.989056C187.679 0.69333 187.462 0.442813 187.188 0.267445C186.914 0.0920761 186.596 -0.00072543 186.27 0.000131083H43.6551C43.3283 -0.00393409 43.0074 0.086632 42.731 0.260904C42.4545 0.435177 42.2344 0.68571 42.0972 0.982283Z",
              fill: "#50AF95"
            }
          ),
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            "path",
            {
              fillRule: "evenodd",
              clipRule: "evenodd",
              d: "M129.502 98.0801C128.689 98.1411 124.49 98.3917 115.122 98.3917C107.671 98.3917 102.381 98.1682 100.525 98.0801C71.7311 96.8135 50.2389 91.8011 50.2389 85.7998C50.2389 79.7985 71.7311 74.7929 100.525 73.506V93.0881C102.408 93.2235 107.8 93.5419 115.251 93.5419C124.192 93.5419 128.669 93.1693 129.475 93.0948V73.5195C158.208 74.7997 179.653 79.8121 179.653 85.7998C179.653 91.7876 158.215 96.7999 129.475 98.0733L129.502 98.0801ZM129.502 71.4943V53.9713H169.601V27.25H60.4262V53.9713H100.518V71.4875C67.9312 72.9844 43.4248 79.4395 43.4248 87.1748C43.4248 94.9101 67.9312 101.358 100.518 102.862V159.014H129.495V102.842C162.008 101.345 186.474 94.8966 186.474 87.1681C186.474 79.4395 162.028 72.9912 129.495 71.4875L129.502 71.4943Z",
              fill: "white"
            }
          )
        ] }),
        /* @__PURE__ */ jsxRuntimeExports.jsx("defs", { children: /* @__PURE__ */ jsxRuntimeExports.jsx("clipPath", { id: "clip0_313_9792", children: /* @__PURE__ */ jsxRuntimeExports.jsx("rect", { width: "229.912", height: "200", fill: "white" }) }) })
      ]
    }
  );
}
function DAI() {
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(
    "svg",
    {
      style: { maxHeight: "100%", maxWidth: "100%" },
      width: "200",
      height: "200",
      viewBox: "0 0 200 200",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ jsxRuntimeExports.jsxs("g", { clipPath: "url(#clip0_313_9788)", children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            "path",
            {
              d: "M100 0C155.234 0 200 44.7754 200 100C200 155.234 155.234 200 100 200C44.7754 200 0 155.229 0 100C0 44.7754 44.7754 0 100 0Z",
              fill: "#F5AC37"
            }
          ),
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            "path",
            {
              d: "M103.686 107.06H141.684C142.494 107.06 142.877 107.06 142.935 105.998C143.246 102.133 143.246 98.2448 142.935 94.3748C142.935 93.6233 142.562 93.3128 141.747 93.3128H66.1237C65.1877 93.3128 64.9357 93.6233 64.9357 94.5008V105.625C64.9357 107.06 64.9357 107.06 66.4343 107.06H103.686ZM138.691 80.3121C138.799 80.0286 138.799 79.7181 138.691 79.4391C138.057 78.0576 137.305 76.7391 136.432 75.5016C135.118 73.3866 133.57 71.4381 131.806 69.6875C130.974 68.63 130.011 67.6805 128.931 66.875C123.522 62.2715 117.091 59.0134 110.179 57.3754C106.692 56.5924 103.128 56.2189 99.5546 56.2504H65.9932C65.0572 56.2504 64.9312 56.6239 64.9312 57.4384V79.6236C64.9312 80.5597 64.9312 80.8117 66.1192 80.8117H138.241C138.241 80.8117 138.867 80.6857 138.993 80.3121H138.687H138.691ZM138.691 120.061C137.629 119.944 136.558 119.944 135.496 120.061H66.1868C65.2507 120.061 64.9357 120.061 64.9357 121.312V143.002C64.9357 144.001 64.9357 144.253 66.1868 144.253H98.1866C99.7166 144.37 101.247 144.262 102.745 143.943C107.389 143.61 111.957 142.602 116.313 140.941C117.897 140.392 119.427 139.677 120.871 138.817H121.308C128.809 134.916 134.902 128.787 138.745 121.263C138.745 121.263 139.182 120.318 138.691 120.07V120.061ZM52.3761 155.499V155.125V140.563V135.627V120.939C52.3761 120.124 52.3761 120.003 51.3771 120.003H37.814C37.0625 120.003 36.752 120.003 36.752 119.004V107.128H51.2511C52.0611 107.128 52.3761 107.128 52.3761 106.066V94.3163C52.3761 93.5648 52.3761 93.3803 51.3771 93.3803H37.814C37.0625 93.3803 36.752 93.3803 36.752 92.3813V81.3832C36.752 80.6947 36.752 80.5102 37.751 80.5102H51.1881C52.1241 80.5102 52.3761 80.5102 52.3761 79.3221V45.6348C52.3761 44.6358 52.3761 44.3838 53.6271 44.3838H100.5C103.902 44.5188 107.281 44.8923 110.625 45.5088C117.514 46.7823 124.134 49.2438 130.186 52.7584C134.2 55.1209 137.895 57.9739 141.184 61.259C143.66 63.8285 145.892 66.6095 147.872 69.5705C149.838 72.5721 151.472 75.7806 152.754 79.1331C152.912 80.0061 153.749 80.5957 154.622 80.4472H165.809C167.244 80.4472 167.244 80.4472 167.307 81.8242V92.0753C167.307 93.0743 166.934 93.3263 165.93 93.3263H157.304C156.431 93.3263 156.179 93.3263 156.242 94.4513C156.584 98.2583 156.584 102.079 156.242 105.886C156.242 106.948 156.242 107.074 157.434 107.074H167.303C167.739 107.636 167.303 108.199 167.303 108.766C167.366 109.49 167.366 110.224 167.303 110.948V118.513C167.303 119.575 166.992 119.89 166.052 119.89H154.239C153.416 119.733 152.615 120.259 152.426 121.078C149.613 128.391 145.113 134.947 139.299 140.203C137.175 142.116 134.943 143.916 132.612 145.576C130.11 147.016 127.675 148.515 125.11 149.703C120.39 151.827 115.44 153.393 110.359 154.387C105.535 155.251 100.644 155.643 95.734 155.575H52.3581V155.512L52.3761 155.499Z",
              fill: "#FEFEFD"
            }
          )
        ] }),
        /* @__PURE__ */ jsxRuntimeExports.jsx("defs", { children: /* @__PURE__ */ jsxRuntimeExports.jsx("clipPath", { id: "clip0_313_9788", children: /* @__PURE__ */ jsxRuntimeExports.jsx("rect", { width: "200", height: "200", fill: "white" }) }) })
      ]
    }
  );
}
function GLMR() {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    "svg",
    {
      width: "92",
      height: "91",
      viewBox: "0 0 92 91",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: /* @__PURE__ */ jsxRuntimeExports.jsx(
        "path",
        {
          d: "M91.3583 45.4564C91.3583 20.351 70.9064 0 45.6817 0C20.4571 0 0 20.351 0 45.4564C0 50.6467 0.876215 55.6319 2.48433 60.2786C2.49464 60.2991 2.58226 60.5658 2.58226 60.5658C3.23169 62.6224 0.0103084 63.4277 0.0103084 64.6586C0.0103084 66.587 6.80355 66.3254 6.80355 68.5667C6.80355 70.5208 0.0824673 71.126 0.0824673 73.0954C0.0824673 75.8188 14.9627 74.87 15.1534 77.2087C15.2977 79.014 10.0352 79.1269 10.0043 81.0553C9.95277 84.1377 30.3119 83.1273 30.3119 85.1788C30.3119 86.7329 21.0498 86.1687 21.0498 88.0048C21.0498 89.8409 33.2395 91 46.6765 91C60.1135 91 69.3808 89.5127 69.3808 87.9073C69.3808 86.302 60.732 86.6303 60.9124 85.184C61.2217 82.6555 80.4211 83.9479 80.4211 81.0194C80.4211 79.4756 75.1432 79.1166 75.3133 77.4549C75.5555 75.1059 91.3583 75.4547 91.3583 73.0134C91.3583 71.0952 83.5239 70.6233 83.5394 68.6283C83.5497 66.5921 91.3583 66.6793 91.3068 64.7714C91.2655 63.3046 87.8122 63.3405 88.8946 60.2324C90.4924 55.6011 91.3686 50.6313 91.3686 45.4564H91.3583ZM76.8441 58.3656C75.2566 61.9403 71.6899 61.2223 71.2878 62.725C70.8704 64.279 75.6844 64.5047 75.6844 66.1305C75.6844 68.1051 61.0104 67.3153 61.1547 69.9207C61.2474 71.5619 71.5765 71.8389 71.3806 73.5519C71.0971 76.0342 55.3768 74.7931 55.2222 77.1728C55.1088 78.9166 62.8968 78.9781 62.9123 80.5681C62.9277 81.9067 56.7994 82.635 45.0581 82.635C31.6881 82.635 25.1835 81.9169 25.9257 80.4245C26.6163 79.0294 38.4555 79.2859 38.337 77.0907C38.2184 74.9008 17.313 75.5419 16.6842 73.4134C16.1584 71.644 23.5547 71.2798 23.5083 69.5976C23.462 67.8846 14.0401 68.2744 13.8339 66.1972C13.6999 64.8381 18.7562 64.9201 18.5397 63.2071C18.3799 61.9608 16.2924 62.1352 15.0554 59.5657C13.0608 55.2729 11.9371 50.4929 11.9371 45.4513C11.9371 26.9056 27.0493 11.868 45.6869 11.868C64.3245 11.868 79.4366 26.9056 79.4366 45.4513C79.4366 50.0262 78.514 54.3856 76.8492 58.3604L76.8441 58.3656Z",
          fill: "white"
        }
      )
    }
  );
}
function AVAX() {
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(
    "svg",
    {
      style: { maxHeight: "100%", maxWidth: "100%" },
      xmlns: "http://www.w3.org/2000/svg",
      enableBackground: "new 0 0 254 254",
      width: "254",
      height: "254",
      viewBox: "0 0 254 254",
      children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "circle",
          {
            cx: "127",
            cy: "127",
            r: "127",
            fill: "#e84142",
            fillRule: "evenodd",
            clipRule: "evenodd"
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "path",
          {
            fill: "#fff",
            d: "M171.8 130.3c4.4-7.6 11.5-7.6 15.9 0l27.4 48.1c4.4 7.6.8 13.8-8 13.8h-55.2c-8.7 0-12.3-6.2-8-13.8l27.9-48.1zm-53-92.6c4.4-7.6 11.4-7.6 15.8 0l6.1 11L155.1 74c3.5 7.2 3.5 15.7 0 22.9l-48.3 83.7c-4.4 6.8-11.7 11.1-19.8 11.6H46.9c-8.8 0-12.4-6.1-8-13.8l79.9-140.7z"
          }
        )
      ]
    }
  );
}
function BNB() {
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(
    "svg",
    {
      id: "Layer_1",
      style: { maxHeight: "100%", maxWidth: "100%" },
      xmlns: "http://www.w3.org/2000/svg",
      width: "511.97",
      height: "511.97",
      viewBox: "0 0 511.97 511.97",
      children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx("defs", {}),
        /* @__PURE__ */ jsxRuntimeExports.jsx("title", { children: "binance-coin-bnb" }),
        /* @__PURE__ */ jsxRuntimeExports.jsx("g", { id: "Layer_2", "data-name": "Layer 2", children: /* @__PURE__ */ jsxRuntimeExports.jsxs("g", { id: "Layer_1-2", "data-name": "Layer 1-2", children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            "path",
            {
              fill: "#f3ba2f",
              d: "M156.56,215.14,256,115.71l99.47,99.47,57.86-57.85L256,0,98.71,157.28l57.85,57.85M0,256l57.86-57.87L115.71,256,57.85,313.83Zm156.56,40.85L256,396.27l99.47-99.47,57.89,57.82,0,0L256,512,98.71,354.7l-.08-.09,57.93-57.77M396.27,256l57.85-57.85L512,256l-57.85,57.85Z"
            }
          ),
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            "path",
            {
              fill: "#f3ba2f",
              d: "M314.66,256h0L256,197.25,212.6,240.63h0l-5,5L197.33,255.9l-.08.08.08.08L256,314.72l58.7-58.7,0,0-.05,0"
            }
          )
        ] }) })
      ]
    }
  );
}
function CELO() {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    "svg",
    {
      version: "1.1",
      id: "Symbol",
      xmlns: "http://www.w3.org/2000/svg",
      xmlnsXlink: "http://www.w3.org/1999/xlink",
      x: "0px",
      y: "0px",
      viewBox: "0 0 384 383",
      style: { width: "100%", height: "100%" },
      xmlSpace: "preserve",
      children: /* @__PURE__ */ jsxRuntimeExports.jsx(
        "path",
        {
          fill: "#FFF572",
          d: `M383.5,0H0.5v383h383V249.3h-63.6C298,298.1,248.7,332,192.3,332c-77.8,0-140.8-63.6-140.8-140.8
  C51.4,114,114.5,51,192.3,51c57.5,0,106.8,35,128.7,84.9h62.5V0z`
        }
      )
    }
  );
}
function ETH() {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      version: "1.1",
      height: "182",
      width: "182",
      viewBox: "0 0 182 182",
      style: { maxHeight: "100%", maxWidth: "100%" },
      children: /* @__PURE__ */ jsxRuntimeExports.jsx("g", { children: /* @__PURE__ */ jsxRuntimeExports.jsx("g", { id: "Layer_1", focusable: "false", children: /* @__PURE__ */ jsxRuntimeExports.jsxs("g", { children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "path",
          {
            d: "M90.9,181v-45.2l-55.9-32.7,55.9,77.8Z",
            fill: "#f0cdc2",
            stroke: "#1616b4",
            strokeLinejoin: "round"
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "path",
          {
            d: "M91.1,181v-45.2l55.9-32.7-55.9,77.8Z",
            fill: "#c9b3f5",
            stroke: "#1616b4",
            strokeLinejoin: "round"
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "path",
          {
            d: "M90.9,124.6v-57.6l-56.5,25.3,56.5,32.3Z",
            fill: "#88aaf1",
            stroke: "#1616b4",
            strokeLinejoin: "round"
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "path",
          {
            d: "M91.1,124.6v-57.6l56.5,25.3-56.5,32.3Z",
            fill: "#c9b3f5",
            stroke: "#1616b4",
            strokeLinejoin: "round"
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "path",
          {
            d: "M34.4,92.3L90.9,1v66l-56.5,25.3Z",
            fill: "#f0cdc2",
            stroke: "#1616b4",
            strokeLinejoin: "round"
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "path",
          {
            d: "M147.6,92.3L91.1,1v66l56.5,25.3Z",
            fill: "#b8faf6",
            stroke: "#1616b4",
            strokeLinejoin: "round"
          }
        )
      ] }) }) })
    }
  );
}
function FTM() {
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(
    "svg",
    {
      style: { maxHeight: "100%", maxWidth: "100%" },
      width: "100",
      height: "100",
      viewBox: "0 0 100 100",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "path",
          {
            d: "M50 100C77.6142 100 100 77.6142 100 50C100 22.3858 77.6142 0 50 0C22.3858 0 0 22.3858 0 50C0 77.6142 22.3858 100 50 100Z",
            fill: "#13B5EC"
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M53.75 40.3125L65 33.75V46.875L53.75 40.3125ZM65 68.4375L50 77.1875L35 68.4375V53.125L50 61.875L65 53.125V68.4375ZM35 33.75L46.25 40.3125L35 46.875V33.75ZM51.875 43.4375L63.125 50L51.875 56.5625V43.4375ZM48.125 56.5625L36.875 50L48.125 43.4375V56.5625ZM63.125 30.625L50 38.125L36.875 30.625L50 22.8125L63.125 30.625ZM31.25 29.375V70.3125L50 80.9375L68.75 70.3125V29.375L50 18.75L31.25 29.375Z",
            fill: "white"
          }
        )
      ]
    }
  );
}
function SOL() {
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(
    "svg",
    {
      style: { maxHeight: "100%", maxWidth: "100%" },
      width: "96",
      height: "84",
      viewBox: "0 0 96 84",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx("g", { clipPath: "url(#a)", children: /* @__PURE__ */ jsxRuntimeExports.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M17.368 64.052A3.214 3.214 0 0 1 19.744 63l73.312.06a1.612 1.612 0 0 1 1.188 2.698l-15.612 17.19A3.213 3.213 0 0 1 76.254 84l-73.31-.06a1.611 1.611 0 0 1-1.188-2.698l15.612-17.19Zm76.876-14.31a1.611 1.611 0 0 1-1.188 2.698l-73.31.06a3.213 3.213 0 0 1-2.378-1.052l-15.612-17.2a1.612 1.612 0 0 1 1.188-2.698l73.312-.06a3.213 3.213 0 0 1 2.376 1.052l15.612 17.2ZM17.368 1.052A3.215 3.215 0 0 1 19.744 0l73.312.06a1.612 1.612 0 0 1 1.188 2.698l-15.612 17.19A3.213 3.213 0 0 1 76.254 21l-73.31-.06a1.611 1.611 0 0 1-1.188-2.698l15.612-17.19Z",
            fill: "url(#b)"
          }
        ) }),
        /* @__PURE__ */ jsxRuntimeExports.jsxs("defs", { children: [
          /* @__PURE__ */ jsxRuntimeExports.jsxs(
            "linearGradient",
            {
              id: "b",
              x1: "4.168",
              y1: "85.832",
              x2: "91.832",
              y2: "-1.832",
              gradientUnits: "userSpaceOnUse",
              children: [
                /* @__PURE__ */ jsxRuntimeExports.jsx("stop", { stopColor: "#9945FF" }),
                /* @__PURE__ */ jsxRuntimeExports.jsx("stop", { offset: ".2", stopColor: "#7962E7" }),
                /* @__PURE__ */ jsxRuntimeExports.jsx("stop", { offset: "1", stopColor: "#00D18C" })
              ]
            }
          ),
          /* @__PURE__ */ jsxRuntimeExports.jsx("clipPath", { id: "a", children: /* @__PURE__ */ jsxRuntimeExports.jsx("path", { fill: "#fff", d: "M0 0h96v84H0z" }) })
        ] })
      ]
    }
  );
}
function APT() {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    "svg",
    {
      style: { maxHeight: "100%", maxWidth: "100%" },
      width: "200",
      height: "200",
      version: "1.2",
      baseProfile: "tiny",
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 112 112",
      overflow: "visible",
      xmlSpace: "preserve",
      children: /* @__PURE__ */ jsxRuntimeExports.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M86.6 37.4h-9.9c-1.1 0-2.2-.5-3-1.3l-4-4.5c-1.2-1.3-3.1-1.4-4.5-.3l-.3.3-3.4 3.9c-1.1 1.3-2.8 2-4.5 2H2.9C1.4 41.9.4 46.6 0 51.3h51.2c.9 0 1.8-.4 2.4-1l4.8-5c.6-.6 1.4-1 2.3-1h.2c.9 0 1.8.4 2.4 1.1l4 4.5c.8.9 1.9 1.4 3 1.4H112c-.4-4.7-1.4-9.4-2.9-13.8H86.6zM53.8 65l-4-4.5c-1.2-1.3-3.1-1.4-4.5-.3l-.3.3-3.5 3.9c-1.1 1.3-2.7 2-4.4 2H.8c.9 4.8 2.5 9.5 4.6 14h25.5c.9 0 1.7-.4 2.4-1l4.8-5c.6-.6 1.4-1 2.3-1h.2c.9 0 1.8.4 2.4 1.1l4 4.5c.8.9 1.9 1.4 3 1.4h56.6c2.1-4.4 3.7-9.1 4.6-14H56.8c-1.2 0-2.3-.5-3-1.4zm19.6-43.6 4.8-5c.6-.6 1.4-1 2.3-1h.2c.9 0 1.8.4 2.4 1l4 4.5c.8.9 1.9 1.3 3 1.3h10.8c-18.8-24.8-54.1-29.7-79-11-4.1 3.1-7.8 6.8-11 11H71c1 .2 1.8-.2 2.4-.8zM34.7 94.2c-1.2 0-2.3-.5-3-1.3l-4-4.5c-1.2-1.3-3.2-1.4-4.5-.2l-.2.2-3.5 3.9c-1.1 1.3-2.7 2-4.4 2h-.2C36 116.9 71.7 118 94.4 96.7c.9-.8 1.7-1.7 2.6-2.6H34.7z"
        }
      )
    }
  );
}
function SUI() {
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(
    "svg",
    {
      style: { maxHeight: "100%", maxWidth: "100%" },
      width: "200",
      height: "200",
      viewBox: "0 0 200 200",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx("circle", { cx: "100", cy: "100", r: "100", fill: "#6FBCEF" }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "mask",
          {
            id: "mask0_309_9859",
            maskUnits: "userSpaceOnUse",
            x: "0",
            y: "0",
            width: "200",
            height: "200",
            children: /* @__PURE__ */ jsxRuntimeExports.jsx(
              "path",
              {
                d: "M200 100C200 155.228 155.228 200 100 200C44.7715 200 0 155.228 0 100C0 44.7715 44.7715 0 100 0C155.228 0 200 44.7715 200 100Z",
                fill: "#8DCBF5"
              }
            )
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsxs("g", { mask: "url(#mask0_309_9859)", children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            "path",
            {
              d: "M113 -4L174 19L196 63.5C196 63.5 169.5 40.5 138.5 24.5C107.5 8.5 58.5 4 58.5 4L113 -4Z",
              fill: "#7AC1F2"
            }
          ),
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            "path",
            {
              d: "M15.8341 34.0023C15.8341 34.0023 72.9887 50.5017 103.494 64.5009C134 78.5001 144.388 89.0206 163.495 112.001C175.611 126.574 189.379 153.053 189.379 153.053L165.999 179.499C165.999 179.499 158.272 146.022 145.999 128.499C129.42 104.828 107.493 94.0004 86.4965 84.5002C65.5 75 -0.00518256 57.0917 -0.00518256 57.0917L15.8341 34.0023Z",
              fill: "#7AC1F2"
            }
          ),
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            "path",
            {
              d: "M2.49892 130.498L-1.50005 100.5C-1.50005 100.5 45.5 117.5 75.5 138.5C105.5 159.5 123.499 199.998 123.499 199.998L89.9989 201.498C89.9989 201.498 86.5 192 62.5 165.5C38.5 139 2.49892 130.498 2.49892 130.498Z",
              fill: "#7AC1F2"
            }
          )
        ] }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M45.4743 158.743C56.7736 178.317 77.0124 190 99.6108 190C122.209 190 142.444 178.317 153.747 158.743C165.047 139.175 165.047 115.807 153.747 96.2343L106.133 13.7657C103.234 8.74477 95.9873 8.74478 93.0885 13.7657L45.4743 96.2343C34.1752 115.803 34.1752 139.17 45.4743 158.743ZM86.1978 52.9996L96.3497 35.416C97.799 32.9054 101.423 32.9054 102.872 35.416L141.927 103.062C149.102 115.489 150.448 129.872 145.967 143.034C145.501 140.887 144.848 138.69 143.969 136.47C138.575 122.856 126.377 112.351 107.708 105.244C94.8728 100.375 86.6799 93.2146 83.3509 83.96C79.063 72.0315 83.5416 59.0237 86.1978 52.9996ZM68.8873 82.9829L57.2949 103.062C48.4619 118.361 48.4619 136.624 57.2949 151.924C66.128 167.222 81.9447 176.352 99.6108 176.352C111.344 176.352 122.265 172.321 130.864 165.131C131.986 162.307 135.458 151.973 131.168 141.32C127.205 131.484 117.669 123.632 102.821 117.976C86.0386 111.61 75.1351 101.671 70.4201 88.4448C69.7707 86.6237 69.2662 84.7988 68.8873 82.9829Z",
            fill: "white"
          }
        )
      ]
    }
  );
}
function SEI() {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    "svg",
    {
      style: { maxHeight: "100%", maxWidth: "100%" },
      width: "256",
      height: "256",
      viewBox: "0 0 256 256",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: /* @__PURE__ */ jsxRuntimeExports.jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "m 127.67411,256 c 38.02499,0 72.18784,-16.49691 95.68658,-42.70676 -10.93123,-9.47577 -27.40461,-10.05162 -39.04159,-0.68556 l -2.22314,1.78953 c -21.30703,17.14908 -52.35448,14.61676 -70.58505,-5.7577 -9.94332,-11.11197 -26.972141,-12.24661 -38.308517,-2.55277 L 47.570215,228.00608 C 69.524032,245.52451 97.372724,256 127.67411,256 Z m 41.60702,-61.98133 C 189.57566,177.68394 218.1014,178.27 237.62049,194.0459 249.28754,174.76386 256,152.16374 256,128.00034 c 0,-26.85042 -8.28793,-51.769568 -22.45139,-72.350916 -9.131,-1.939587 -19.02787,0.325741 -26.54036,6.966212 l -2.13843,1.889976 C 184.37854,82.617466 153.24774,81.516899 134.09348,62.003681 123.64732,51.36103 106.58366,51.011574 95.70776,61.217474 L 65.879285,89.2086 49.470132,71.811468 79.298607,43.820001 C 99.6717,24.70176 131.636,25.356444 151.20497,45.292785 c 10.2248,10.416813 26.8437,11.004304 37.78245,1.335536 l 2.13842,-1.889909 c 6.64005,-5.869189 14.32197,-9.825846 22.366,-11.906837 C 190.75623,12.421275 160.66937,0 127.67411,0 62.5305,0 8.7242884,48.41669 0.45065936,111.14157 20.23734,101.67056 44.644196,105.31504 60.77713,121.79424 c 10.185043,10.40324 26.584631,11.50108 38.071994,2.54936 l 16.677656,-12.99623 c 20.96064,-16.333367 50.58976,-15.542866 70.64448,1.88493 l 32.46987,28.21744 -15.73073,18.00977 -32.46987,-28.21675 c -11.40333,-9.91056 -28.25178,-10.36033 -40.17025,-1.07263 l -16.67765,12.9969 C 92.486461,159.61353 62.356352,157.59639 43.643919,138.48264 32.762761,127.36794 14.966434,126.98019 3.609064,137.61037 L 0,140.98839 c 2.7009241,26.73389 13.649562,51.04108 30.269414,70.34973 l 27.34647,-23.38517 c 21.235909,-18.16038 53.135306,-16.03488 71.761456,4.78115 9.73221,10.87688 26.30602,12.22823 37.67997,3.07342 z",
          fill: "#ffffff",
          id: "path1050",
          style: { strokeWidth: 6.82333 }
        }
      )
    }
  );
}
function BASE() {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    "svg",
    {
      style: { maxHeight: "100%", maxWidth: "100%" },
      width: "111",
      height: "111",
      viewBox: "0 0 111 111",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: /* @__PURE__ */ jsxRuntimeExports.jsx(
        "path",
        {
          d: "M54.921 110.034C85.359 110.034 110.034 85.402 110.034 55.017C110.034 24.6319 85.359 0 54.921 0C26.0432 0 2.35281 22.1714 0 50.3923H72.8467V59.6416H3.9565e-07C2.35281 87.8625 26.0432 110.034 54.921 110.034Z",
          fill: "#0052FF"
        }
      )
    }
  );
}
function POLY() {
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(
    "svg",
    {
      style: { maxHeight: "100%", maxWidth: "100%" },
      width: "100",
      height: "88",
      viewBox: "0 0 100 88",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx("g", { clipPath: "url(#clip0_103_6769)", children: /* @__PURE__ */ jsxRuntimeExports.jsx(
          "path",
          {
            d: "M75.5208 26.5625C73.6979 25.5209 71.3542 25.5209 69.2708 26.5625L54.6875 35.1563L44.7917 40.625L30.4687 49.2188C28.6458 50.2605 26.3021 50.2605 24.2187 49.2188L13.0208 42.448C11.1979 41.4063 9.89583 39.323 9.89583 36.9792V23.9584C9.89583 21.875 10.9375 19.7917 13.0208 18.4896L24.2187 11.9792C26.0417 10.9375 28.3854 10.9375 30.4687 11.9792L41.6667 18.75C43.4896 19.7917 44.7917 21.875 44.7917 24.2188V32.8125L54.6875 27.0834V18.2292C54.6875 16.1459 53.6458 14.0625 51.5625 12.7605L30.7292 0.520874C28.9062 -0.520793 26.5625 -0.520793 24.4792 0.520874L3.125 13.0209C1.04167 14.0625 0 16.1459 0 18.2292V42.7084C0 44.7917 1.04167 46.875 3.125 48.1771L24.2187 60.4167C26.0417 61.4584 28.3854 61.4584 30.4687 60.4167L44.7917 52.0834L54.6875 46.3542L69.0104 38.0209C70.8333 36.9792 73.1771 36.9792 75.2604 38.0209L86.4583 44.5313C88.2812 45.573 89.5833 47.6563 89.5833 50V63.0209C89.5833 65.1042 88.5417 67.1875 86.4583 68.4896L75.5208 75C73.6979 76.0417 71.3542 76.0417 69.2708 75L58.0729 68.4896C56.25 67.448 54.9479 65.3646 54.9479 63.0209V54.6875L45.0521 60.4167V69.0105C45.0521 71.0938 46.0937 73.1771 48.1771 74.4792L69.2708 86.7188C71.0937 87.7604 73.4375 87.7604 75.5208 86.7188L96.6146 74.4792C98.4375 73.4375 99.7396 71.3542 99.7396 69.0105V44.2709C99.7396 42.1875 98.6979 40.1042 96.6146 38.8021L75.5208 26.5625Z",
            fill: "#8247E5"
          }
        ) }),
        /* @__PURE__ */ jsxRuntimeExports.jsx("defs", { children: /* @__PURE__ */ jsxRuntimeExports.jsx("clipPath", { id: "clip0_103_6769", children: /* @__PURE__ */ jsxRuntimeExports.jsx("rect", { width: "100", height: "87.2396", fill: "white" }) }) })
      ]
    }
  );
}
function BSC() {
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(
    "svg",
    {
      style: { maxHeight: "100%", maxWidth: "100%" },
      width: "100",
      height: "100",
      viewBox: "0 0 100 100",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "path",
          {
            d: "M50.7548 0L24.1998 15.3175L33.9648 20.975L50.7573 11.3175L67.5498 20.975L77.3148 15.3175L50.7548 0ZM67.5498 28.975L77.3148 34.635V45.9525L60.5198 55.61V74.9275L50.7573 80.585L40.9923 74.9275V55.61L24.1973 45.95V34.6325L33.9623 28.9725L50.7548 38.6325L67.5498 28.9725V28.975Z",
            fill: "#F0B90B"
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "path",
          {
            d: "M77.3148 53.95V65.2675L67.5498 70.9275V59.61L77.3148 53.95Z",
            fill: "#F0B90B"
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "path",
          {
            d: "M67.4525 78.925L84.2475 69.2675V49.95L94.0125 44.2925V74.9275L67.4525 90.245V78.925ZM84.25 30.635L74.48 24.975L84.25 19.3175L94.015 24.975V36.2925L84.25 41.9525V30.635ZM40.9925 94.3425V83.025L50.755 88.6825L60.52 83.025V94.3425L50.7575 100L40.9925 94.3425ZM33.9625 70.925L24.1975 65.2675V53.9525L33.9625 59.61V70.925ZM50.755 30.635L40.9925 24.975L50.755 19.3175L60.52 24.975L50.755 30.635ZM27.03 24.975L17.265 30.635V41.9525L7.5 36.2925V24.975L17.265 19.3175L27.03 24.975Z",
            fill: "#F0B90B"
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "path",
          {
            d: "M7.5 44.2925L17.265 49.9525V69.2675L34.06 78.9275V90.245L7.5 74.925V44.2925Z",
            fill: "#F0B90B"
          }
        )
      ]
    }
  );
}
function USDC() {
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(
    "svg",
    {
      style: { maxHeight: "100%", maxWidth: "100%" },
      xmlns: "http://www.w3.org/2000/svg",
      "data-name": "86977684-12db-4850-8f30-233a7c267d11",
      width: "2000",
      height: "2000",
      viewBox: "0 0 2000 2000",
      children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "path",
          {
            fill: "#2775ca",
            d: "M1000 2000c554.17 0 1000-445.83 1000-1000S1554.17 0 1000 0 0 445.83 0 1000s445.83 1000 1000 1000z"
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "path",
          {
            fill: "#fff",
            d: "M1275 1158.33c0-145.83-87.5-195.83-262.5-216.66-125-16.67-150-50-150-108.34s41.67-95.83 125-95.83c75 0 116.67 25 137.5 87.5 4.17 12.5 16.67 20.83 29.17 20.83h66.66c16.67 0 29.17-12.5 29.17-29.16v-4.17c-16.67-91.67-91.67-162.5-187.5-170.83v-100c0-16.67-12.5-29.17-33.33-33.34h-62.5c-16.67 0-29.17 12.5-33.34 33.34v95.83c-125 16.67-204.16 100-204.16 204.17 0 137.5 83.33 191.66 258.33 212.5 116.67 20.83 154.17 45.83 154.17 112.5s-58.34 112.5-137.5 112.5c-108.34 0-145.84-45.84-158.34-108.34-4.16-16.66-16.66-25-29.16-25h-70.84c-16.66 0-29.16 12.5-29.16 29.17v4.17c16.66 104.16 83.33 179.16 220.83 200v100c0 16.66 12.5 29.16 33.33 33.33h62.5c16.67 0 29.17-12.5 33.34-33.33v-100c125-20.84 208.33-108.34 208.33-220.84z"
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "path",
          {
            fill: "#fff",
            d: "M787.5 1595.83c-325-116.66-491.67-479.16-370.83-800 62.5-175 200-308.33 370.83-370.83 16.67-8.33 25-20.83 25-41.67V325c0-16.67-8.33-29.17-25-33.33-4.17 0-12.5 0-16.67 4.16-395.83 125-612.5 545.84-487.5 941.67 75 233.33 254.17 412.5 487.5 487.5 16.67 8.33 33.34 0 37.5-16.67 4.17-4.16 4.17-8.33 4.17-16.66v-58.34c0-12.5-12.5-29.16-25-37.5zm441.67-1300c-16.67-8.33-33.34 0-37.5 16.67-4.17 4.17-4.17 8.33-4.17 16.67v58.33c0 16.67 12.5 33.33 25 41.67 325 116.66 491.67 479.16 370.83 800-62.5 175-200 308.33-370.83 370.83-16.67 8.33-25 20.83-25 41.67V1700c0 16.67 8.33 29.17 25 33.33 4.17 0 12.5 0 16.67-4.16 395.83-125 612.5-545.84 487.5-941.67-75-237.5-258.34-416.67-487.5-491.67z"
          }
        )
      ]
    }
  );
}
const noIcon = /* @__PURE__ */ jsxRuntimeExports.jsx(
  "svg",
  {
    width: "36",
    height: "36",
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ jsxRuntimeExports.jsx(
      "path",
      {
        d: "M18 36C27.9411 36 36 27.9411 36 18C36 8.05887 27.9411 0 18 0C8.05887 0 0 8.05887 0 18C0 27.9411 8.05887 36 18 36Z",
        fill: "#3D405C"
      }
    )
  }
);
function ARBITRUM() {
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(
    "svg",
    {
      style: { maxHeight: "100%", maxWidth: "100%" },
      width: "470.29",
      height: "514.25",
      viewBox: "0 0 470.29 514.25",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "path",
          {
            d: "m291.13 237.47 35.654-60.5 96.103 149.68 0.046 28.727-0.313-197.67c-0.228-4.832-2.794-9.252-6.887-11.859l-173.02-99.525c-4.045-1.99-9.18-1.967-13.22 0.063-0.546 0.272-1.06 0.57-1.548 0.895l-0.604 0.379-167.94 97.322-0.651 0.296c-0.838 0.385-1.686 0.875-2.48 1.444-3.185 2.283-5.299 5.66-5.983 9.448-0.103 0.574-0.179 1.158-0.214 1.749l0.264 161.08 89.515-138.74c11.271-18.397 35.825-24.323 58.62-24.001l26.753 0.706-157.64 252.8 18.582 10.697 159.52-263.24 70.51-0.256-159.11 269.88 66.306 38.138 7.922 4.556c3.351 1.362 7.302 1.431 10.681 0.21l175.45-101.68-33.544 19.438-92.775-150.04zm13.602 195.93-66.969-105.11 40.881-69.371 87.952 138.63-61.864 35.851z",
            fill: "#2D374B"
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "polygon",
          {
            points: "237.77 328.29 304.74 433.4 366.6 397.54 278.65 258.92",
            fill: "#28A0F0"
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "path",
          {
            d: "m422.94 355.38-0.046-28.727-96.103-149.68-35.654 60.5 92.774 150.04 33.544-19.438c3.29-2.673 5.281-6.594 5.49-10.825l-5e-3 -1.869z",
            fill: "#28A0F0"
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "path",
          {
            d: "m20.219 382.47 47.369 27.296 157.63-252.8-26.753-0.706c-22.795-0.322-47.35 5.604-58.62 24.001l-89.515 138.74-30.115 46.271v17.194z",
            fill: "#fff"
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "polygon",
          {
            points: "316.2 156.96 245.69 157.22 86.17 420.46 141.93 452.56 157.09 426.85",
            fill: "#fff"
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "path",
          {
            d: "m452.65 156.6c-0.59-14.746-8.574-28.245-21.08-36.104l-175.29-100.8c-12.371-6.229-27.825-6.237-40.218-4e-3 -1.465 0.739-170.46 98.752-170.46 98.752-2.339 1.122-4.592 2.458-6.711 3.975-11.164 8.001-17.969 20.435-18.668 34.095v208.76l30.115-46.271-0.263-161.08c0.035-0.589 0.109-1.169 0.214-1.741 0.681-3.79 2.797-7.171 5.983-9.456 0.795-0.569 172.68-100.06 173.23-100.34 4.04-2.029 9.175-2.053 13.22-0.063l173.02 99.523c4.093 2.607 6.659 7.027 6.887 11.859v199.54c-0.209 4.231-1.882 8.152-5.172 10.825l-33.544 19.438-17.308 10.031-61.864 35.852-62.737 36.357c-3.379 1.221-7.33 1.152-10.681-0.21l-74.228-42.693-15.163 25.717 66.706 38.406c2.206 1.255 4.171 2.367 5.784 3.272 2.497 1.4 4.199 2.337 4.8 2.629 4.741 2.303 11.563 3.643 17.71 3.643 5.636 0 11.132-1.035 16.332-3.072l182.22-105.53c10.459-8.104 16.612-20.325 17.166-33.564v-201.75z",
            fill: "#96BEDC"
          }
        )
      ]
    }
  );
}
function OPTIMISM() {
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(
    "svg",
    {
      style: { maxHeight: "100%", maxWidth: "100%" },
      xmlns: "http://www.w3.org/2000/svg",
      id: "optimism-logo-circle",
      width: "122",
      height: "122",
      viewBox: "0 0 122 122",
      children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "circle",
          {
            id: "Ellipse_11",
            "data-name": "Ellipse 11",
            cx: "61",
            cy: "61",
            r: "61",
            fill: "#ff0420"
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "path",
          {
            id: "Path_139",
            "data-name": "Path 139",
            d: "M113.533,178.026a14.656,14.656,0,0,1-8.924-2.563,8.762,8.762,0,0,1-3.432-7.413,16.433,16.433,0,0,1,.229-2.471q.595-3.3,1.693-7.917,3.112-12.585,16.062-12.585a15.966,15.966,0,0,1,6.315,1.19,9.6,9.6,0,0,1,4.393,3.478,9.333,9.333,0,0,1,1.6,5.492,16.288,16.288,0,0,1-.229,2.425q-.687,4.073-1.647,7.917-1.6,6.269-5.537,9.381Q120.123,178.026,113.533,178.026Zm.641-6.59a6.5,6.5,0,0,0,4.348-1.51,8.424,8.424,0,0,0,2.608-4.622q1.053-4.3,1.6-7.505a10.5,10.5,0,0,0,.183-1.968q0-4.165-4.347-4.164a6.681,6.681,0,0,0-4.393,1.51,8.573,8.573,0,0,0-2.563,4.622q-.824,3.066-1.647,7.505a9.791,9.791,0,0,0-.183,1.922Q109.78,171.436,114.174,171.436Z",
            transform: "translate(-70.332 -100.849)",
            fill: "#fff"
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "path",
          {
            id: "Path_140",
            "data-name": "Path 140",
            d: "M205.3,178.612a.97.97,0,0,1-.778-.32,1.1,1.1,0,0,1-.137-.824l6.315-29.746a1.31,1.31,0,0,1,.5-.824,1.4,1.4,0,0,1,.87-.32h12.173a14.148,14.148,0,0,1,8.146,2.105,6.9,6.9,0,0,1,3.112,6.087,10.955,10.955,0,0,1-.275,2.38,12.39,12.39,0,0,1-4.622,7.78q-3.432,2.517-9.427,2.517H215l-2.105,10.022a1.311,1.311,0,0,1-.5.824,1.4,1.4,0,0,1-.869.32Zm16.2-17.482a5.451,5.451,0,0,0,3.341-1.052,4.942,4.942,0,0,0,1.922-3.02,8.022,8.022,0,0,0,.137-1.373,2.543,2.543,0,0,0-.778-2.014,3.836,3.836,0,0,0-2.654-.732h-5.491l-1.739,8.191Z",
            transform: "translate(-142.055 -101.892)",
            fill: "#fff"
          }
        )
      ]
    }
  );
}
function OSMO() {
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      style: { maxHeight: "100%", maxWidth: "100%" },
      width: "256",
      height: "256",
      fill: "none",
      viewBox: "0 0 800 800",
      children: [
        /* @__PURE__ */ jsxRuntimeExports.jsxs("g", { clipPath: "url(#clip0)", children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            "path",
            {
              fill: "#5E12A0",
              d: "M673.964 193.237C667.62 168.805 647.227 144.373 610.519 117.174C581.062 95.5081 549.792 83.0615 524.867 83.0615C519.882 83.0615 515.35 83.5225 510.819 84.4445C499.489 86.7494 489.519 95.0471 483.174 107.494C475.47 122.245 473.658 142.068 478.643 154.053C480.455 157.741 482.721 162.351 485.44 166.5C461.422 181.251 447.826 185.4 446.013 185.861C508.553 207.067 560.669 251.321 593.298 308.944L593.751 303.413C595.111 288.2 599.642 270.683 605.987 252.704C612.332 254.548 618.676 255.47 625.021 255.47C641.788 255.47 656.29 248.555 665.354 236.109C674.418 223.662 678.043 207.067 673.964 193.237Z"
            }
          ),
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            "path",
            {
              fill: "url(#paint0_radial)",
              d: "M608.706 239.342C649.945 250.867 666.713 218.598 661.275 196.932C655.383 175.265 636.35 153.138 602.814 128.245C569.279 103.352 535.29 93.2098 513.537 97.8197C491.784 102.43 485.44 136.081 490.878 148.989C493.144 154.06 498.129 161.436 504.927 169.733C496.316 175.726 488.159 180.336 481.361 184.485C523.054 203.385 559.309 232.888 586.5 269.767C589.672 257.321 594.204 246.257 598.282 236.576C601.455 237.037 605.08 237.959 608.706 239.342Z"
            }
          ),
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            "path",
            {
              fill: "url(#paint1_radial)",
              d: "M372.594 691.101C512.504 691.101 625.924 575.729 625.924 433.41C625.924 291.091 512.504 175.719 372.594 175.719C232.685 175.719 119.265 291.091 119.265 433.41C119.265 575.729 232.685 691.101 372.594 691.101Z"
            }
          ),
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            "path",
            {
              fill: "#A98698",
              d: "M640.427 175.721C605.985 138.842 576.982 129.161 542.087 121.325C514.896 114.871 522.146 99.1973 555.229 102.424C539.367 96.8924 524.412 95.5094 513.536 97.8143C491.783 102.424 485.439 136.076 490.877 148.984C493.143 154.055 498.128 161.43 504.925 169.728C492.69 178.026 482.266 184.019 473.656 188.629C477.735 190.472 482.72 192.777 488.611 196.004C504.019 204.302 520.787 218.132 520.787 218.132C495.409 196.004 500.847 185.863 535.742 160.969C546.618 153.133 566.558 154.055 585.139 163.735C603.719 173.416 625.472 197.848 625.472 197.848L604.626 238.415C605.985 238.876 607.345 239.337 608.704 239.798C621.847 243.486 632.27 242.564 640.427 239.337C649.944 233.344 674.869 213.061 640.427 175.721Z",
              opacity: ".6"
            }
          ),
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            "path",
            {
              fill: "#5E12A0",
              d: "M541.631 143.45C550.695 147.138 562.478 153.592 576.979 163.273C594.2 174.797 609.155 187.705 618.672 197.847C602.811 219.052 592.388 248.094 586.043 268.377C589.215 272.987 592.841 277.597 596.013 282.207C599.185 270.682 604.624 253.626 611.875 236.569C613.687 237.03 615.953 237.03 618.219 237.03C623.657 237.03 630.002 236.108 634.987 231.96C638.612 229.194 642.691 224.123 642.238 214.903C642.238 206.144 635.44 195.081 621.391 181.712C611.421 172.031 597.826 161.429 584.23 151.748C545.257 125.472 518.066 118.096 505.83 130.543C497.672 138.84 498.579 148.982 501.298 156.358C486.796 166.039 474.56 172.953 466.403 177.563C471.841 179.407 476.826 181.712 482.264 184.017C496.766 176.18 517.613 162.812 541.631 143.45ZM627.283 209.371C628.642 211.676 629.095 213.981 629.095 215.364C629.095 219.513 627.736 220.896 626.83 221.818C625.017 223.201 621.391 224.123 618.219 224.123C620.938 218.591 624.11 213.981 627.283 209.371ZM515.347 140.684C516.706 139.301 520.332 138.379 526.223 139.301C521.691 142.989 517.159 146.216 512.628 149.443C512.174 146.216 512.627 142.989 515.347 140.684Z"
            }
          ),
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            "path",
            {
              fill: "#5E12A0",
              d: "M372.596 160.503C224.405 160.503 104.311 282.664 104.311 433.406C104.311 584.149 224.405 706.31 372.596 706.31C520.786 706.31 640.88 584.149 640.88 433.406C640.88 282.664 520.333 160.503 372.596 160.503ZM372.596 691.098C232.562 691.098 119.266 575.851 119.266 433.406C119.266 290.962 232.562 175.715 372.596 175.715C512.629 175.715 625.925 290.962 625.925 433.406C625.925 575.851 512.176 691.098 372.596 691.098Z"
            }
          ),
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            "path",
            {
              fill: "url(#paint2_linear)",
              d: "M372.594 691.101C512.504 691.101 625.924 575.729 625.924 433.41C625.924 291.091 512.504 175.719 372.594 175.719C232.685 175.719 119.265 291.091 119.265 433.41C119.265 575.729 232.685 691.101 372.594 691.101Z",
              opacity: ".6"
            }
          ),
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            "path",
            {
              fill: "#A98698",
              d: "M370.783 659.75C232.562 637.161 138.754 504.858 161.413 364.258C171.383 302.025 202.199 249.011 245.705 210.75C182.259 248.089 135.128 313.088 122.439 392.378C100.233 532.978 194.042 665.281 331.809 687.87C408.851 700.777 483.173 676.345 538.008 628.403C489.517 656.984 430.603 669.43 370.783 659.75Z",
              opacity: ".6"
            }
          ),
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            "path",
            {
              fill: "url(#paint3_linear)",
              d: "M412.93 179.411C349.031 168.808 286.945 183.56 236.189 216.29C235.282 217.212 234.376 218.133 234.376 218.133C253.863 206.148 282.413 195.545 282.413 195.545C208.998 238.878 186.339 288.203 186.339 288.203C214.889 231.963 298.728 192.318 364.439 189.552C430.151 186.786 473.203 206.609 525.772 249.481C578.342 292.813 610.064 381.322 606.892 451.392C604.173 521.462 567.918 578.163 567.918 578.163C592.844 545.433 607.799 521.462 617.315 497.03C619.128 489.654 620.941 482.278 621.847 474.441C644.506 334.302 551.151 201.999 412.93 179.411Z",
              opacity: ".6"
            }
          ),
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            "path",
            {
              fill: "url(#paint4_linear)",
              d: "M613.235 431.104C613.235 566.173 505.377 675.887 372.595 675.887C239.812 675.887 131.501 566.173 131.501 431.104H613.235Z"
            }
          ),
          /* @__PURE__ */ jsxRuntimeExports.jsx("g", { opacity: ".6", children: /* @__PURE__ */ jsxRuntimeExports.jsx(
            "path",
            {
              fill: "url(#paint5_linear)",
              d: "M594.201 431.104C594.201 562.946 491.781 670.817 363.077 675.887C366.25 675.887 369.422 675.887 372.594 675.887C505.377 675.887 613.234 566.173 613.234 431.104H594.201Z",
              opacity: ".6"
            }
          ) }),
          /* @__PURE__ */ jsxRuntimeExports.jsx("g", { opacity: ".7", children: /* @__PURE__ */ jsxRuntimeExports.jsx(
            "path",
            {
              fill: "url(#paint6_linear)",
              d: "M165.49 431.104H131.501C131.501 566.173 239.359 675.887 372.142 675.887C378.033 675.887 383.471 675.887 388.909 675.426C264.284 666.207 165.49 560.18 165.49 431.104Z",
              opacity: ".7"
            }
          ) }),
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            "path",
            {
              fill: "url(#paint7_linear)",
              d: "M612.781 433.407C612.781 405.287 564.744 389.153 500.845 383.621C454.621 379.933 407.943 384.543 354.467 401.138C308.243 414.968 266.55 412.663 236.187 408.975C168.662 401.138 131.501 400.216 131.501 433.407C131.501 481.35 227.576 541.278 371.688 520.533C444.651 509.931 482.265 488.264 525.317 473.513C571.995 457.839 612.781 458.3 612.781 433.407Z"
            }
          ),
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            "path",
            {
              fill: "#fff",
              d: "M451.448 317.236C473.974 317.236 492.234 298.661 492.234 275.747C492.234 252.833 473.974 234.258 451.448 234.258C428.922 234.258 410.661 252.833 410.661 275.747C410.661 298.661 428.922 317.236 451.448 317.236Z"
            }
          ),
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            "path",
            {
              fill: "#fff",
              d: "M518.067 348.13C527.578 348.13 535.288 340.287 535.288 330.612C535.288 320.938 527.578 313.095 518.067 313.095C508.556 313.095 500.846 320.938 500.846 330.612C500.846 340.287 508.556 348.13 518.067 348.13Z"
            }
          ),
          /* @__PURE__ */ jsxRuntimeExports.jsx("g", { opacity: ".6", children: /* @__PURE__ */ jsxRuntimeExports.jsx(
            "path",
            {
              fill: "url(#paint8_linear)",
              d: "M579.703 242.563C579.25 242.563 578.796 242.563 578.796 242.563C576.077 242.102 574.265 239.336 574.718 236.109C578.796 214.904 596.017 194.62 596.924 193.698C598.736 191.393 602.362 191.393 604.175 193.237C606.441 195.081 606.44 198.769 604.628 200.613C604.175 201.074 588.313 219.975 584.688 238.414C584.235 241.18 581.969 242.563 579.703 242.563Z",
              opacity: ".6"
            }
          ) }),
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            "path",
            {
              fill: "#fff",
              d: "M355.905 625.64C362.913 625.64 368.594 619.861 368.594 612.732C368.594 605.604 362.913 599.825 355.905 599.825C348.897 599.825 343.216 605.604 343.216 612.732C343.216 619.861 348.897 625.64 355.905 625.64Z",
              opacity: ".2"
            }
          ),
          /* @__PURE__ */ jsxRuntimeExports.jsx("g", { opacity: ".4", children: /* @__PURE__ */ jsxRuntimeExports.jsx(
            "path",
            {
              fill: "url(#paint9_linear)",
              d: "M348.577 621.135C343.592 616.065 343.592 607.767 348.577 602.696C349.484 601.774 350.39 601.313 351.296 600.391C349.484 600.852 348.124 601.774 346.765 603.157C341.78 608.228 341.78 616.526 346.765 621.596C350.843 625.745 357.188 626.667 362.173 623.901C357.641 625.745 352.203 624.823 348.577 621.135Z",
              opacity: ".6"
            }
          ) }),
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            "path",
            {
              fill: "#fff",
              d: "M360.361 609.042C361.863 609.042 363.08 607.804 363.08 606.276C363.08 604.749 361.863 603.51 360.361 603.51C358.859 603.51 357.642 604.749 357.642 606.276C357.642 607.804 358.859 609.042 360.361 609.042Z",
              opacity: ".3"
            }
          ),
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            "path",
            {
              fill: "#fff",
              d: "M422.07 619.19C429.078 619.19 434.759 613.411 434.759 606.282C434.759 599.153 429.078 593.375 422.07 593.375C415.062 593.375 409.381 599.153 409.381 606.282C409.381 613.411 415.062 619.19 422.07 619.19Z",
              opacity: ".2"
            }
          ),
          /* @__PURE__ */ jsxRuntimeExports.jsx("g", { opacity: ".4", children: /* @__PURE__ */ jsxRuntimeExports.jsx(
            "path",
            {
              fill: "url(#paint10_linear)",
              d: "M414.742 614.685C409.757 609.614 409.757 601.317 414.742 596.246C415.648 595.324 416.555 594.863 417.461 593.941C415.648 594.402 414.289 595.324 412.929 596.707C407.944 601.778 407.944 610.075 412.929 615.146C417.008 619.295 423.352 620.217 428.337 617.451C423.806 619.295 418.367 618.373 414.742 614.685Z",
              opacity: ".6"
            }
          ) }),
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            "path",
            {
              fill: "#fff",
              d: "M426.526 602.592C428.027 602.592 429.245 601.354 429.245 599.826C429.245 598.298 428.027 597.06 426.526 597.06C425.024 597.06 423.806 598.298 423.806 599.826C423.806 601.354 425.024 602.592 426.526 602.592Z",
              opacity: ".3"
            }
          ),
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            "path",
            {
              fill: "#fff",
              d: "M389.361 649.153C394.617 649.153 398.878 644.819 398.878 639.472C398.878 634.126 394.617 629.792 389.361 629.792C384.105 629.792 379.845 634.126 379.845 639.472C379.845 644.819 384.105 649.153 389.361 649.153Z",
              opacity: ".2"
            }
          ),
          /* @__PURE__ */ jsxRuntimeExports.jsx("g", { opacity: ".4", children: /* @__PURE__ */ jsxRuntimeExports.jsx(
            "path",
            {
              fill: "url(#paint11_linear)",
              d: "M383.923 645.57C380.298 641.882 380.298 635.429 383.923 631.741C384.376 631.28 385.283 630.819 385.736 630.358C384.376 630.819 383.47 631.741 382.564 632.663C378.938 636.351 378.938 642.805 382.564 646.492C385.736 649.719 390.268 650.18 394.346 647.875C390.721 649.258 386.642 648.336 383.923 645.57Z",
              opacity: ".6"
            }
          ) }),
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            "path",
            {
              fill: "#fff",
              d: "M392.532 636.243C393.534 636.243 394.345 635.418 394.345 634.4C394.345 633.381 393.534 632.556 392.532 632.556C391.531 632.556 390.72 633.381 390.72 634.4C390.72 635.418 391.531 636.243 392.532 636.243Z",
              opacity: ".3"
            }
          ),
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            "path",
            {
              fill: "#fff",
              d: "M447.825 642.238C453.081 642.238 457.342 637.904 457.342 632.558C457.342 627.211 453.081 622.877 447.825 622.877C442.569 622.877 438.308 627.211 438.308 632.558C438.308 637.904 442.569 642.238 447.825 642.238Z",
              opacity: ".2"
            }
          ),
          /* @__PURE__ */ jsxRuntimeExports.jsx("g", { opacity: ".4", children: /* @__PURE__ */ jsxRuntimeExports.jsx(
            "path",
            {
              fill: "url(#paint12_linear)",
              d: "M442.387 638.656C438.761 634.968 438.761 628.514 442.387 624.826C442.84 624.365 443.746 623.904 444.199 623.443C442.84 623.904 441.934 624.826 441.027 625.748C437.402 629.436 437.402 635.89 441.027 639.578C444.199 642.805 448.731 643.266 452.81 640.961C449.184 642.344 445.106 641.422 442.387 638.656Z",
              opacity: ".6"
            }
          ) }),
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            "path",
            {
              fill: "#fff",
              d: "M450.996 629.338C451.997 629.338 452.809 628.512 452.809 627.494C452.809 626.475 451.997 625.65 450.996 625.65C449.995 625.65 449.183 626.475 449.183 627.494C449.183 628.512 449.995 629.338 450.996 629.338Z",
              opacity: ".3"
            }
          ),
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            "path",
            {
              fill: "#fff",
              d: "M301.896 621.034C313.41 621.034 322.743 611.54 322.743 599.829C322.743 588.118 313.41 578.624 301.896 578.624C290.383 578.624 281.05 588.118 281.05 599.829C281.05 611.54 290.383 621.034 301.896 621.034Z",
              opacity: ".2"
            }
          ),
          /* @__PURE__ */ jsxRuntimeExports.jsx("g", { opacity: ".4", children: /* @__PURE__ */ jsxRuntimeExports.jsx(
            "path",
            {
              fill: "url(#paint13_linear)",
              d: "M290.128 613.192C281.971 604.895 281.971 591.526 290.128 583.228C291.488 581.845 292.847 580.923 294.66 580.001C291.941 580.923 289.675 582.767 287.409 584.611C279.252 592.909 279.252 606.278 287.409 614.575C294.207 621.49 304.63 622.873 312.787 617.802C305.083 621.029 296.019 619.646 290.128 613.192Z",
              opacity: ".6"
            }
          ) }),
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            "path",
            {
              fill: "#fff",
              d: "M309.15 593.372C311.653 593.372 313.682 591.308 313.682 588.762C313.682 586.216 311.653 584.152 309.15 584.152C306.647 584.152 304.618 586.216 304.618 588.762C304.618 591.308 306.647 593.372 309.15 593.372Z",
              opacity: ".3"
            }
          ),
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            "path",
            {
              fill: "#fff",
              d: "M488.23 568.936C499.743 568.936 509.076 559.442 509.076 547.731C509.076 536.019 499.743 526.525 488.23 526.525C476.717 526.525 467.383 536.019 467.383 547.731C467.383 559.442 476.717 568.936 488.23 568.936Z",
              opacity: ".2"
            }
          ),
          /* @__PURE__ */ jsxRuntimeExports.jsx("g", { opacity: ".4", children: /* @__PURE__ */ jsxRuntimeExports.jsx(
            "path",
            {
              fill: "url(#paint14_linear)",
              d: "M475.92 561.103C467.763 552.805 467.763 539.436 475.92 531.139C477.28 529.756 478.639 528.834 480.452 527.912C477.733 528.834 475.467 530.678 473.201 532.521C465.044 540.819 465.044 554.188 473.201 562.486C479.999 569.4 490.422 570.783 498.579 565.713C490.875 568.939 482.265 567.556 475.92 561.103Z",
              opacity: ".6"
            }
          ) }),
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            "path",
            {
              fill: "#fff",
              d: "M495.407 541.282C497.91 541.282 499.939 539.218 499.939 536.672C499.939 534.126 497.91 532.062 495.407 532.062C492.904 532.062 490.875 534.126 490.875 536.672C490.875 539.218 492.904 541.282 495.407 541.282Z",
              opacity: ".3"
            }
          )
        ] }),
        /* @__PURE__ */ jsxRuntimeExports.jsxs("defs", { children: [
          /* @__PURE__ */ jsxRuntimeExports.jsxs(
            "radialGradient",
            {
              id: "paint0_radial",
              cx: "0",
              cy: "0",
              r: "1",
              gradientTransform: "translate(653.009 167.889) scale(202.547 206.035)",
              gradientUnits: "userSpaceOnUse",
              children: [
                /* @__PURE__ */ jsxRuntimeExports.jsx("stop", { stopColor: "#FFEAFF", stopOpacity: ".6" }),
                /* @__PURE__ */ jsxRuntimeExports.jsx("stop", { offset: ".681", stopColor: "#A087C9" }),
                /* @__PURE__ */ jsxRuntimeExports.jsx("stop", { offset: "1", stopColor: "#10002F" })
              ]
            }
          ),
          /* @__PURE__ */ jsxRuntimeExports.jsxs(
            "radialGradient",
            {
              id: "paint1_radial",
              cx: "0",
              cy: "0",
              r: "1",
              gradientTransform: "translate(540.32 255.753) scale(495.56 504.093)",
              gradientUnits: "userSpaceOnUse",
              children: [
                /* @__PURE__ */ jsxRuntimeExports.jsx("stop", { stopColor: "#FFEAFF", stopOpacity: ".6" }),
                /* @__PURE__ */ jsxRuntimeExports.jsx("stop", { offset: ".681", stopColor: "#A087C9" }),
                /* @__PURE__ */ jsxRuntimeExports.jsx("stop", { offset: "1", stopColor: "#10002F" })
              ]
            }
          ),
          /* @__PURE__ */ jsxRuntimeExports.jsxs(
            "linearGradient",
            {
              id: "paint2_linear",
              x1: "331.959",
              x2: "415.726",
              y1: "687.445",
              y2: "179.399",
              gradientUnits: "userSpaceOnUse",
              children: [
                /* @__PURE__ */ jsxRuntimeExports.jsx("stop", { stopColor: "#81FFFF" }),
                /* @__PURE__ */ jsxRuntimeExports.jsx("stop", { offset: ".62", stopColor: "#fff", stopOpacity: "0" })
              ]
            }
          ),
          /* @__PURE__ */ jsxRuntimeExports.jsxs(
            "linearGradient",
            {
              id: "paint3_linear",
              x1: "551.129",
              x2: "338.385",
              y1: "258.408",
              y2: "450.302",
              gradientUnits: "userSpaceOnUse",
              children: [
                /* @__PURE__ */ jsxRuntimeExports.jsx("stop", { offset: ".289", stopColor: "#fff" }),
                /* @__PURE__ */ jsxRuntimeExports.jsx("stop", { offset: ".78", stopColor: "#fff", stopOpacity: "0" })
              ]
            }
          ),
          /* @__PURE__ */ jsxRuntimeExports.jsxs(
            "linearGradient",
            {
              id: "paint4_linear",
              x1: "131.705",
              x2: "613.118",
              y1: "553.353",
              y2: "553.353",
              gradientUnits: "userSpaceOnUse",
              children: [
                /* @__PURE__ */ jsxRuntimeExports.jsx("stop", { stopColor: "#0002E9" }),
                /* @__PURE__ */ jsxRuntimeExports.jsx("stop", { offset: ".995", stopColor: "#FF00C7" })
              ]
            }
          ),
          /* @__PURE__ */ jsxRuntimeExports.jsxs(
            "linearGradient",
            {
              id: "paint5_linear",
              x1: "635.906",
              x2: "369.659",
              y1: "452.584",
              y2: "699.942",
              gradientUnits: "userSpaceOnUse",
              children: [
                /* @__PURE__ */ jsxRuntimeExports.jsx("stop", { offset: ".289", stopColor: "#fff" }),
                /* @__PURE__ */ jsxRuntimeExports.jsx("stop", { offset: ".78", stopColor: "#fff", stopOpacity: "0" })
              ]
            }
          ),
          /* @__PURE__ */ jsxRuntimeExports.jsxs(
            "linearGradient",
            {
              id: "paint6_linear",
              x1: "131.705",
              x2: "389.259",
              y1: "553.352",
              y2: "553.352",
              gradientUnits: "userSpaceOnUse",
              children: [
                /* @__PURE__ */ jsxRuntimeExports.jsx("stop", { stopColor: "#000292" }),
                /* @__PURE__ */ jsxRuntimeExports.jsx("stop", { offset: ".995", stopColor: "#7D00C7" })
              ]
            }
          ),
          /* @__PURE__ */ jsxRuntimeExports.jsxs(
            "linearGradient",
            {
              id: "paint7_linear",
              x1: "132.029",
              x2: "612.795",
              y1: "453.743",
              y2: "453.743",
              gradientUnits: "userSpaceOnUse",
              children: [
                /* @__PURE__ */ jsxRuntimeExports.jsx("stop", { stopColor: "#000292" }),
                /* @__PURE__ */ jsxRuntimeExports.jsx("stop", { offset: ".995", stopColor: "#BE00C7" })
              ]
            }
          ),
          /* @__PURE__ */ jsxRuntimeExports.jsxs(
            "linearGradient",
            {
              id: "paint8_linear",
              x1: "604.91",
              x2: "569.494",
              y1: "191.453",
              y2: "248.03",
              gradientUnits: "userSpaceOnUse",
              children: [
                /* @__PURE__ */ jsxRuntimeExports.jsx("stop", { offset: ".289", stopColor: "#fff" }),
                /* @__PURE__ */ jsxRuntimeExports.jsx("stop", { offset: ".78", stopColor: "#fff", stopOpacity: "0" })
              ]
            }
          ),
          /* @__PURE__ */ jsxRuntimeExports.jsxs(
            "linearGradient",
            {
              id: "paint9_linear",
              x1: "343.013",
              x2: "362.187",
              y1: "613.233",
              y2: "613.233",
              gradientUnits: "userSpaceOnUse",
              children: [
                /* @__PURE__ */ jsxRuntimeExports.jsx("stop", { offset: ".289", stopColor: "#fff" }),
                /* @__PURE__ */ jsxRuntimeExports.jsx("stop", { offset: ".78", stopColor: "#fff", stopOpacity: "0" })
              ]
            }
          ),
          /* @__PURE__ */ jsxRuntimeExports.jsxs(
            "linearGradient",
            {
              id: "paint10_linear",
              x1: "409.132",
              x2: "428.305",
              y1: "606.695",
              y2: "606.695",
              gradientUnits: "userSpaceOnUse",
              children: [
                /* @__PURE__ */ jsxRuntimeExports.jsx("stop", { offset: ".289", stopColor: "#fff" }),
                /* @__PURE__ */ jsxRuntimeExports.jsx("stop", { offset: ".78", stopColor: "#fff", stopOpacity: "0" })
              ]
            }
          ),
          /* @__PURE__ */ jsxRuntimeExports.jsxs(
            "linearGradient",
            {
              id: "paint11_linear",
              x1: "379.785",
              x2: "394.18",
              y1: "639.688",
              y2: "639.688",
              gradientUnits: "userSpaceOnUse",
              children: [
                /* @__PURE__ */ jsxRuntimeExports.jsx("stop", { offset: ".289", stopColor: "#fff" }),
                /* @__PURE__ */ jsxRuntimeExports.jsx("stop", { offset: ".78", stopColor: "#fff", stopOpacity: "0" })
              ]
            }
          ),
          /* @__PURE__ */ jsxRuntimeExports.jsxs(
            "linearGradient",
            {
              id: "paint12_linear",
              x1: "438.053",
              x2: "452.447",
              y1: "632.755",
              y2: "632.755",
              gradientUnits: "userSpaceOnUse",
              children: [
                /* @__PURE__ */ jsxRuntimeExports.jsx("stop", { offset: ".289", stopColor: "#fff" }),
                /* @__PURE__ */ jsxRuntimeExports.jsx("stop", { offset: ".78", stopColor: "#fff", stopOpacity: "0" })
              ]
            }
          ),
          /* @__PURE__ */ jsxRuntimeExports.jsxs(
            "linearGradient",
            {
              id: "paint13_linear",
              x1: "281.083",
              x2: "312.395",
              y1: "600.365",
              y2: "600.365",
              gradientUnits: "userSpaceOnUse",
              children: [
                /* @__PURE__ */ jsxRuntimeExports.jsx("stop", { offset: ".289", stopColor: "#fff" }),
                /* @__PURE__ */ jsxRuntimeExports.jsx("stop", { offset: ".78", stopColor: "#fff", stopOpacity: "0" })
              ]
            }
          ),
          /* @__PURE__ */ jsxRuntimeExports.jsxs(
            "linearGradient",
            {
              id: "paint14_linear",
              x1: "467.049",
              x2: "498.361",
              y1: "548.259",
              y2: "548.259",
              gradientUnits: "userSpaceOnUse",
              children: [
                /* @__PURE__ */ jsxRuntimeExports.jsx("stop", { offset: ".289", stopColor: "#fff" }),
                /* @__PURE__ */ jsxRuntimeExports.jsx("stop", { offset: ".78", stopColor: "#fff", stopOpacity: "0" })
              ]
            }
          ),
          /* @__PURE__ */ jsxRuntimeExports.jsx("clipPath", { id: "clip0", children: /* @__PURE__ */ jsxRuntimeExports.jsx("rect", { width: "800", height: "800", fill: "#fff" }) })
        ] })
      ]
    }
  );
}
function TBTC() {
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(
    "svg",
    {
      width: "144",
      height: "144",
      viewBox: "0 0 144 144",
      style: { maxHeight: "100%", maxWidth: "100%" },
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "path",
          {
            d: "M71.85 143.7C111.532 143.7 143.7 111.532 143.7 71.85C143.7 32.1683 111.532 0 71.85 0C32.1683 0 0 32.1683 0 71.85C0 111.532 32.1683 143.7 71.85 143.7Z",
            fill: "#1D2229"
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "M59.5621 65.1122H47.531V77.1433H59.5621V65.1122Z", fill: "white" }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "path",
          {
            d: "M47.5309 53.081H35.4997V65.1121L47.531 65.1122L47.5309 53.081Z",
            fill: "white"
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "path",
          {
            d: "M35.4978 65.1122H23.4667V77.1433H35.4978V65.1122Z",
            fill: "white"
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "path",
          {
            d: "M47.531 77.1433L35.4997 77.1427V89.1738H47.5309L47.531 77.1433Z",
            fill: "white"
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "path",
          {
            d: "M115.922 55.6723C115.074 46.824 107.437 43.8538 97.791 43.0056V37.3377H90.3225V42.6822C88.3601 42.6822 86.3535 42.7198 84.3579 42.7575V37.3333H76.8938V42.9989C75.2769 43.0299 65.3433 43.0211 65.3433 43.0211L65.3211 49.6058L71.5538 49.6413V92.7977H65.3233L65.268 99.2895C67.0775 99.2895 75.1308 99.3249 76.8761 99.336V104.931H84.3401V99.4689C86.3867 99.5132 88.3712 99.5309 90.307 99.5287V104.933H97.7777V99.3626C110.338 98.6472 119.133 95.4866 120.225 83.6947C121.111 74.1974 116.646 69.9626 109.516 68.2394C113.849 66.0246 116.558 62.1463 115.926 55.6701L115.922 55.6723ZM105.457 82.2129C105.457 91.491 89.5739 90.4301 84.5063 90.4323V73.9847C89.5716 73.9847 105.448 72.5384 105.45 82.2129H105.457ZM101.99 59.0057C101.99 67.4465 88.7366 66.4565 84.5173 66.4565V51.5372C88.7433 51.5394 101.995 50.2016 101.99 59.0057Z",
            fill: "white"
          }
        )
      ]
    }
  );
}
function WSTETH() {
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(
    "svg",
    {
      width: "512",
      height: "512",
      viewBox: "0 0 512 512",
      style: { maxHeight: "100%", maxWidth: "100%" },
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx("rect", { width: "512", height: "512", rx: "256", fill: "#00A3FF" }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "path",
          {
            opacity: "0.6",
            d: "M361.012 237.812L363.878 242.209C396.204 291.798 388.984 356.742 346.52 398.348C321.539 422.826 288.798 435.066 256.056 435.069C256.056 435.069 256.056 435.069 361.012 237.812Z",
            fill: "white"
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "path",
          {
            opacity: "0.2",
            d: "M256.044 297.764L361 237.812C256.045 435.069 256.044 435.069 256.044 435.069C256.044 392.108 256.044 342.88 256.044 297.764Z",
            fill: "white"
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "path",
          {
            d: "M150.988 237.812L148.122 242.209C115.796 291.798 123.016 356.742 165.48 398.348C190.461 422.826 223.202 435.066 255.944 435.069C255.944 435.069 255.944 435.069 150.988 237.812Z",
            fill: "white"
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "path",
          {
            opacity: "0.6",
            d: "M255.914 297.764L150.958 237.812C255.914 435.069 255.914 435.069 255.914 435.069C255.914 392.108 255.914 342.88 255.914 297.764Z",
            fill: "white"
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "path",
          {
            opacity: "0.2",
            d: "M256.083 163.833V267.233L346.491 215.566L256.083 163.833Z",
            fill: "white"
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "path",
          {
            opacity: "0.6",
            d: "M256.056 163.833L165.583 215.565L256.056 267.233V163.833Z",
            fill: "white"
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "path",
          {
            d: "M256.056 76.875L165.583 215.599L256.056 163.722V76.875Z",
            fill: "white"
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "path",
          {
            opacity: "0.6",
            d: "M256.083 163.706L346.56 215.585L256.083 76.7916V163.706Z",
            fill: "white"
          }
        )
      ]
    }
  );
}
function EVMOS() {
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(
    "svg",
    {
      style: { maxHeight: "100%", maxWidth: "100%" },
      width: "156",
      height: "156",
      viewBox: "0 0 156 156",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx("circle", { cx: "77.5713", cy: "77.5713", r: "77.5713", fill: "#ED4E33" }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "path",
          {
            d: "M63.5871 41.5434C42.4254 49.6802 40.4869 70.5184 34.419 80.2503C28.2792 90.0978 14.2132 95.5313 16.1367 100.55C18.0601 105.568 32.1429 100.178 43.2844 103.38C54.2939 106.544 69.655 120.732 90.8167 112.595C101.597 108.45 109.403 99.9185 112.993 89.8133C113.379 88.7286 112.657 87.5686 111.512 87.4614C110.8 87.3945 110.117 87.7678 109.796 88.4072C106.549 94.8851 100.979 100.22 93.6894 103.022C81.6555 107.649 68.4886 104.016 60.4019 94.9052C58.5653 92.8363 56.9944 90.4811 55.7544 87.8782C55.4135 87.1618 55.0893 86.4337 54.8019 85.6804C54.5128 84.9272 54.2671 84.1689 54.0415 83.4073C60.4019 80.4378 67.7415 77.2926 76.0622 74.0938C84.2207 70.9569 91.6456 68.4126 98.2566 66.3772C102.729 65.0012 106.828 63.8563 110.529 62.9206C110.797 62.8536 111.061 62.7867 111.323 62.7214C111.883 62.5825 112.458 62.8821 112.665 63.4211L112.669 63.4311C112.791 63.7508 112.896 64.0722 113.009 64.3936C113.741 66.4676 114.29 68.5633 114.652 70.664C114.811 71.583 115.814 72.0835 116.636 71.6416C119.674 70.0078 122.453 68.4143 124.936 66.881C134.19 61.1731 139.32 56.3322 138.267 53.5887C137.216 50.8435 130.17 50.6862 119.48 52.6446C116.083 53.2673 112.316 54.1042 108.257 55.1404C107.555 55.3195 106.845 55.5053 106.126 55.6961C102.71 56.6034 99.1072 57.6428 95.3555 58.8062C88.3785 60.9705 80.8934 63.5634 73.1661 66.5345C65.9367 69.3148 59.085 72.1973 52.8015 75.0697C52.7247 62.8788 60.0827 51.354 72.1166 46.7274C79.4045 43.9253 87.1084 44.1547 93.8498 46.7944C94.5149 47.0555 95.272 46.8747 95.7583 46.3475C96.537 45.5021 96.298 44.1563 95.287 43.6073C85.8684 38.507 74.3676 37.3989 63.5871 41.5434Z",
            fill: "white"
          }
        )
      ]
    }
  );
}
function ATOM() {
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(
    "svg",
    {
      style: { maxHeight: "100%", maxWidth: "100%" },
      xmlns: "http://www.w3.org/2000/svg",
      width: "800",
      height: "800",
      fill: "none",
      viewBox: "0 0 800 800",
      children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "path",
          {
            fill: "#2E3148",
            fillRule: "evenodd",
            d: "M400.012 0.768066C620.509 0.768066 799.257 179.501 799.257 399.98C799.257 620.458 620.509 799.192 400.012 799.192C179.516 799.192 0.767944 620.458 0.767944 399.98C0.767944 179.501 179.516 0.768066 400.012 0.768066Z",
            clipRule: "evenodd"
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "path",
          {
            fill: "#1B1E36",
            fillRule: "evenodd",
            d: "M399.226 169.68C526.431 169.68 629.552 272.801 629.552 400.007C629.552 527.212 526.431 630.333 399.226 630.333C272.02 630.333 168.899 527.212 168.899 400.007C168.899 272.801 272.02 169.68 399.226 169.68Z",
            clipRule: "evenodd"
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "path",
          {
            fillRule: "evenodd",
            stroke: "#6F7390",
            strokeWidth: "15",
            d: "M401.181 58.2666C394.32 58.2666 386.121 65.8115 377.843 81.5569C368.982 98.411 360.796 123.281 353.849 154.523C339.501 219.047 331.271 306.552 331.271 399.977C331.271 493.402 339.501 580.908 353.849 645.431C360.796 676.673 368.982 701.543 377.843 718.397C386.121 734.143 394.32 741.688 401.181 741.688C408.042 741.688 416.241 734.143 424.519 718.397C433.38 701.543 441.566 676.673 448.513 645.431C462.862 580.908 471.092 493.402 471.092 399.977C471.092 306.552 462.862 219.047 448.513 154.523C441.566 123.281 433.38 98.411 424.519 81.5569C416.241 65.8115 408.042 58.2666 401.181 58.2666Z",
            clipRule: "evenodd"
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "path",
          {
            fillRule: "evenodd",
            stroke: "#6F7390",
            strokeWidth: "15",
            d: "M697.298 229.144C693.869 223.208 683.229 219.884 665.444 220.592C646.407 221.351 620.761 226.702 590.213 236.311C527.123 256.157 447.177 292.789 366.216 339.504C285.255 386.219 213.538 437.098 164.797 481.78C141.196 503.415 123.737 522.936 113.562 539.033C104.057 554.069 101.618 564.935 105.046 570.868C108.475 576.804 119.115 580.129 136.9 579.42C155.937 578.662 181.583 573.311 212.131 563.701C275.221 543.856 355.167 507.224 436.129 460.508C517.09 413.793 588.806 362.915 637.547 318.233C661.148 296.598 678.607 277.077 688.783 260.98C698.287 245.944 700.726 235.078 697.298 229.144V229.144ZM697.298 229.144C697.298 229.144 697.298 229.144 697.298 229.144L697.298 229.144C697.298 229.144 697.298 229.144 697.298 229.144V229.144Z",
            clipRule: "evenodd"
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "path",
          {
            fillRule: "evenodd",
            stroke: "#6F7390",
            strokeWidth: "15",
            d: "M697.298 570.868L697.298 570.868C700.726 564.935 698.288 554.069 688.783 539.033C678.607 522.936 661.148 503.415 637.548 481.78C588.806 437.098 517.09 386.219 436.129 339.504C355.167 292.789 275.221 256.157 212.131 236.311C181.583 226.702 155.937 221.351 136.9 220.592C119.115 219.884 108.475 223.208 105.046 229.144C101.618 235.078 104.057 245.944 113.562 260.98C123.737 277.077 141.196 296.598 164.797 318.233C213.538 362.915 285.255 413.793 366.216 460.508C447.177 507.224 527.123 543.856 590.213 563.701C620.761 573.311 646.407 578.662 665.444 579.42C683.229 580.129 693.869 576.804 697.298 570.868Z",
            clipRule: "evenodd"
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "path",
          {
            fill: "#B7B9C8",
            fillRule: "evenodd",
            d: "M177.765 302.102C191.34 302.102 202.345 313.112 202.345 326.694C202.345 340.276 191.34 351.286 177.765 351.286C164.189 351.286 153.185 340.276 153.185 326.694C153.185 313.112 164.189 302.102 177.765 302.102Z",
            clipRule: "evenodd"
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "path",
          {
            fill: "#B7B9C8",
            fillRule: "evenodd",
            d: "M568.451 217.905C582.033 217.905 593.043 228.915 593.043 242.497C593.043 256.079 582.033 267.089 568.451 267.089C554.869 267.089 543.859 256.079 543.859 242.497C543.859 228.915 554.869 217.905 568.451 217.905Z",
            clipRule: "evenodd"
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "path",
          {
            fill: "#B7B9C8",
            fillRule: "evenodd",
            d: "M351.649 603.909C365.231 603.909 376.241 614.914 376.241 628.489C376.241 642.064 365.231 653.069 351.649 653.069C338.067 653.069 327.057 642.064 327.057 628.489C327.057 614.914 338.067 603.909 351.649 603.909Z",
            clipRule: "evenodd"
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "path",
          {
            fill: "#B7B9C8",
            fillRule: "evenodd",
            d: "M399.811 358.173C422.806 358.173 441.447 376.814 441.447 399.809C441.447 422.803 422.806 441.444 399.811 441.444C376.817 441.444 358.176 422.803 358.176 399.809C358.176 376.814 376.817 358.173 399.811 358.173Z",
            clipRule: "evenodd"
          }
        )
      ]
    }
  );
}
function KUJI() {
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(
    "svg",
    {
      style: { maxHeight: "100%", maxWidth: "100%" },
      width: "100px",
      height: "100px",
      viewBox: "0 0 100 100",
      version: "1.1",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx("title", { children: "kuji" }),
        /* @__PURE__ */ jsxRuntimeExports.jsxs("g", { id: "kuji", stroke: "none", strokeWidth: "1", fill: "none", fillRule: "evenodd", children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx("circle", { id: "Oval", fill: "#22242F", cx: "50", cy: "50", r: "50" }),
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            "path",
            {
              d: "M50,2 C76.509668,2 98,23.490332 98,50 C98,76.509668 76.509668,98 50,98 C23.490332,98 2,76.509668 2,50 C2,23.490332 23.490332,2 50,2 Z M50,5.38823529 C25.3616027,5.38823529 5.38823529,25.3616027 5.38823529,50 C5.38823529,74.6383973 25.3616027,94.6117647 50,94.6117647 C74.6383973,94.6117647 94.6117647,74.6383973 94.6117647,50 C94.6117647,25.3616027 74.6383973,5.38823529 50,5.38823529 Z",
              id: "Oval",
              fill: "#E53935",
              fillRule: "nonzero"
            }
          ),
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            "path",
            {
              d: "M80.2507798,31.0832298 L80.2507798,26.7229814 L66.4391765,26.7229814 C65.6980661,23.9055901 64.9569557,21.4236025 64.1484716,19.1428571 L59.4996881,19.9478261 C60.3081722,21.9602484 61.1166563,24.2409938 61.8577667,26.7229814 L47.2376794,26.7229814 L47.2376794,31.0832298 L80.2507798,31.0832298 Z M44.8796007,63.4832298 L44.8796007,35.6447205 L38.0748596,35.6447205 C39.4897068,33.5652174 40.904554,31.0161491 42.3194011,27.9304348 L42.3194011,24.710559 L31.2027449,24.710559 C31.8091079,23.3689441 32.3480973,22.0273292 32.8870867,20.6186335 L28.5751716,19.2770186 C26.5539613,25.8509317 23.3873986,31.1503106 19.1428571,35.242236 L20.1534623,40.0049689 C21.02932,39.2 21.9051778,38.3950311 22.7136619,37.5229814 L22.7136619,63.4832298 L44.8796007,63.4832298 Z M33.4260761,35.6447205 L24.3980037,35.6447205 C26.1497193,33.4981366 27.8340611,31.0832298 29.316282,28.5341615 L37.8053649,28.5341615 C36.3231441,31.2173913 34.9082969,33.6322981 33.4260761,35.6447205 Z M61.1840299,80.8571429 C64.5527137,80.8571429 66.3044292,78.978882 66.3044292,75.289441 L66.3044292,56.1714286 L77.0168434,56.1714286 L77.0168434,37.1204969 L50.8084841,37.1204969 L50.8084841,56.1714286 L61.588272,56.1714286 L61.588272,74.1490683 C61.588272,75.826087 60.9145352,76.6981366 59.5670618,76.6981366 C58.0174672,76.6981366 56.4004991,76.5639752 54.7835309,76.3627329 L55.7267623,80.8571429 L61.1840299,80.8571429 Z M31.8764816,47.5850932 L26.8908297,47.5850932 L26.8908297,39.6024845 L31.8764816,39.6024845 L31.8764816,47.5850932 Z M40.7024329,47.5850932 L35.7841547,47.5850932 L35.7841547,39.6024845 L40.7024329,39.6024845 L40.7024329,47.5850932 Z M72.4354336,51.9453416 L55.3898939,51.9453416 L55.3898939,41.4136646 L72.4354336,41.4136646 L72.4354336,51.9453416 Z M40.7024329,59.4583851 L35.7841547,59.4583851 L35.7841547,51.4757764 L40.7024329,51.4757764 L40.7024329,59.4583851 Z M31.8764816,59.4583851 L26.8908297,59.4583851 L26.8908297,51.4757764 L31.8764816,51.4757764 L31.8764816,59.4583851 Z M77.2863381,77.7714286 L80.8571429,75.289441 C79.0380536,70.9962733 76.477854,66.0322981 73.1091703,60.3304348 L69.5383656,62.4770186 C72.7723019,68.0447205 75.3998752,73.1428571 77.2863381,77.7714286 Z M49.0567686,78.9118012 C52.0212102,74.2832298 54.5814099,68.7826087 56.7373674,62.4770186 L52.8296943,60.5987578 C50.7411104,66.6360248 48.2482845,71.868323 45.4185901,76.2956522 L49.0567686,78.9118012 Z M43.4647536,74.3503106 L46.7660636,73.5453416 C45.8228322,70.3254658 44.8796007,67.5080745 43.801622,65.0931677 L40.6350593,66.0322981 C41.7130381,68.715528 42.6562695,71.4658385 43.4647536,74.3503106 Z M36.3231441,78.2409938 L39.8265752,77.8385093 C39.4223331,72.7403727 38.6812227,68.715528 37.6032439,65.7639752 L34.2345602,66.1664596 C35.312539,68.9838509 35.9862757,73.0086957 36.3231441,78.2409938 Z M23.4547723,80.0521739 C24.8696195,76.0944099 25.7454772,71.6 26.1497193,66.5018634 L22.5115409,66.0322981 C22.1746725,70.8621118 21.231441,75.1552795 19.7492202,78.9118012 L23.4547723,80.0521739 Z M29.1141609,79.247205 L32.617592,78.8447205 C32.4828447,73.5453416 32.1459763,69.3192547 31.6743606,66.2335404 L28.4404242,66.6360248 C28.7772926,69.5875776 28.9794136,73.8136646 29.1141609,79.247205 Z",
              id: "鯨",
              fill: "#E53935",
              fillRule: "nonzero"
            }
          )
        ] })
      ]
    }
  );
}
function KLAY() {
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "72",
      height: "72",
      viewBox: "0 0 72 72",
      fill: "none",
      children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "path",
          {
            d: "M0 35.9864C0 16.2622 15.9896 0 35.7138 0V0C55.438 0 71.4276 16.2622 71.4276 35.9864V35.9864C71.4276 55.7106 55.438 71.9728 35.7138 71.9728V71.9728C15.9896 71.9728 0 55.7106 0 35.9864V35.9864Z",
            fill: "#040404"
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx("g", { clipPath: "url(#clip0_2310_14480)", children: /* @__PURE__ */ jsxRuntimeExports.jsx(
          "path",
          {
            d: "M34.6646 25.2973C34.6646 23.701 35.9571 22.4006 37.5438 22.4006H42.6955V15.353H40.1196H37.5438C32.0857 15.353 27.6598 19.8059 27.6598 25.2973C27.6598 26.7302 27.963 28.0923 28.5052 29.3217C24.2661 31.1245 21.4514 34.9549 20.7959 39.8022C20.0302 45.1241 22.1497 50.865 26.7655 53.6385C30.885 56.2486 37.3262 56.076 40.8057 52.4551V54.8588H47.9759V28.1939H37.5467C35.9602 28.1939 34.6646 26.8936 34.6646 25.2973ZM40.965 35.2446V41.9377C40.965 45.6356 37.9848 48.6309 34.3124 48.6309C30.64 48.6309 27.6598 45.6325 27.6598 41.9377C27.6598 38.2429 30.64 35.2446 34.3124 35.2446H40.965Z",
            fill: "#BFF009"
          }
        ) })
      ]
    }
  );
}
function PYTH() {
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(
    "svg",
    {
      style: { maxHeight: "100%", maxWidth: "100%" },
      width: "1000",
      height: "1000",
      viewBox: "0 0 1000 1000",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "path",
          {
            d: "M1000 500C1000 776.142 776.142 1000 500 1000C223.858 1000 0 776.142 0 500C0 223.858 223.858 0 500 0C776.142 0 1000 223.858 1000 500Z",
            fill: "#E6DAFE"
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "path",
          {
            d: "M575.336 459.157C575.336 494.675 546.559 523.473 511.068 523.473V587.789C582.05 587.789 639.604 530.193 639.604 459.157C639.604 388.122 582.05 330.526 511.068 330.526C487.669 330.526 465.695 336.78 446.801 347.746C408.374 369.97 382.533 411.539 382.533 459.157V780.736L446.801 845.052V459.157C446.801 423.64 475.577 394.841 511.068 394.841C546.559 394.841 575.336 423.64 575.336 459.157Z",
            fill: "#242235"
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "path",
          {
            d: "M511.07 201.904C464.243 201.904 420.352 214.442 382.535 236.346C358.322 250.338 336.638 268.169 318.268 289.026C278.271 334.376 254 393.95 254 459.168V652.115L318.268 716.431V459.168C318.268 402.037 343.091 350.695 382.535 315.351C401.08 298.771 422.851 285.681 446.803 277.245C466.888 270.089 488.543 266.22 511.07 266.22C617.543 266.22 703.873 352.614 703.873 459.168C703.873 565.721 617.543 652.115 511.07 652.115V716.431C653.063 716.431 768.14 601.238 768.14 459.168C768.14 317.097 653.063 201.904 511.07 201.904Z",
            fill: "#242235"
          }
        )
      ]
    }
  );
}
function INJ() {
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("svg", { viewBox: "100 100 400 400", xmlns: "http://www.w3.org/2000/svg", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      "path",
      {
        d: `M148.497 169.135C150.981 166.013 153.613 163.009 156.245
    160.005C156.363 159.856 156.63 159.826 156.748 159.677C156.985 159.38 157.37
    159.201 157.606 158.903L157.843 158.606C159.678 156.91 161.63 155.064
    163.881 153.456C171.845 147.41 180.11 142.817 188.825 139.795C216.778
    129.981 247.894 136.029 272.295 159.065C306.366 191.002 303.315 242.451
    276.117 276.647C241.748 327.625 182.684 398.748 264.463 462.46C279.167
    473.916 290.075 483.361 336.392 496.746C306.1 502.326 278.012 500.59 246.748
    492.605C224.634 480.123 189.866 453.397 178.037 417.3C160.159 362.562
    209.513 280.732 233.365 249.216C266.113 205.599 213.124 158.382 174.112
    211.095C153.72 238.566 118.044 316.303 130.442 373.965C137.691 406.664
    147.353 430.499 185.663 463.241C178.559 459.049 171.66 454.294 164.968
    448.974C75.957 366.06 86.2838 237.859 148.497 169.135Z`,
        fill: "url(#paint-inj-1)"
      }
    ),
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      "path",
      {
        d: `M451.503 430.865C449.019
    433.987 446.387 436.991 443.755 439.995C443.637 440.144 443.37 440.174
    443.252 440.323C443.015 440.62 442.63 440.799 442.394 441.097L442.157
    441.394C440.322 443.09 438.37 444.936 436.119 446.544C428.155 452.59 419.89
    457.183 411.175 460.205C383.222 470.019 352.106 463.971 327.705
    440.935C293.634 408.998 296.685 357.549 323.883 323.353C358.252 272.375
    417.316 201.252 335.537 137.54C320.833 126.084 309.925 116.639 263.608
    103.254C293.9 97.6736 321.988 99.4095 353.251 107.395C375.366 119.877
    410.134 146.603 421.963 182.7C439.841 237.438 390.487 319.268 366.635
    350.784C333.887 394.401 386.876 441.618 425.888 388.905C446.28 361.434
    481.956 283.697 469.558 226.035C462.309 193.336 452.647 169.501 414.337
    136.759C421.441 140.951 428.34 145.706 435.032 151.026C524.043 233.94
    513.716 362.141 451.503 430.865Z`,
        fill: "url(#paint-inj-2)"
      }
    ),
    /* @__PURE__ */ jsxRuntimeExports.jsxs("defs", { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsxs(
        "linearGradient",
        {
          id: "paint-inj-1",
          x1: "100",
          y1: "300",
          x2: "500",
          y2: "300",
          gradientUnits: "userSpaceOnUse",
          children: [
            /* @__PURE__ */ jsxRuntimeExports.jsx("stop", { stopColor: "#0082FA" }),
            /* @__PURE__ */ jsxRuntimeExports.jsx("stop", { offset: "1", stopColor: "#00F2FE" })
          ]
        }
      ),
      /* @__PURE__ */ jsxRuntimeExports.jsxs(
        "linearGradient",
        {
          id: "paint-inj-2",
          x1: "100",
          y1: "300",
          x2: "500",
          y2: "300",
          gradientUnits: "userSpaceOnUse",
          children: [
            /* @__PURE__ */ jsxRuntimeExports.jsx("stop", { stopColor: "#0082FA" }),
            /* @__PURE__ */ jsxRuntimeExports.jsx("stop", { offset: "1", stopColor: "#00F2FE" })
          ]
        }
      )
    ] })
  ] });
}
function NTT() {
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(
    "svg",
    {
      viewBox: "316.829 225.555 66.146 48.89",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ jsxRuntimeExports.jsxs("defs", { children: [
          /* @__PURE__ */ jsxRuntimeExports.jsxs(
            "filter",
            {
              id: "filter0_f_4160_67832",
              x: "36.0726",
              y: "19.3241",
              width: "12.6301",
              height: "12.6306",
              filterUnits: "userSpaceOnUse",
              colorInterpolationFilters: "sRGB",
              children: [
                /* @__PURE__ */ jsxRuntimeExports.jsx("feFlood", { floodOpacity: "0", result: "BackgroundImageFix" }),
                /* @__PURE__ */ jsxRuntimeExports.jsx(
                  "feBlend",
                  {
                    mode: "normal",
                    in: "SourceGraphic",
                    in2: "BackgroundImageFix",
                    result: "shape"
                  }
                ),
                /* @__PURE__ */ jsxRuntimeExports.jsx(
                  "feGaussianBlur",
                  {
                    stdDeviation: "1.18048",
                    result: "effect1_foregroundBlur_4160_67832"
                  }
                )
              ]
            }
          ),
          /* @__PURE__ */ jsxRuntimeExports.jsxs(
            "linearGradient",
            {
              id: "paint0_linear_4160_67832",
              x1: "76.3139",
              y1: "25.3915",
              x2: "10.1678",
              y2: "25.3915",
              gradientUnits: "userSpaceOnUse",
              gradientTransform: "matrix(1, 0, 0, 1, 307.155052, 224.001474)",
              children: [
                /* @__PURE__ */ jsxRuntimeExports.jsx("stop", { stopColor: "white", stopOpacity: "0" }),
                /* @__PURE__ */ jsxRuntimeExports.jsx("stop", { offset: "0.5142", stopColor: "white" }),
                /* @__PURE__ */ jsxRuntimeExports.jsx("stop", { offset: "1", stopColor: "white", stopOpacity: "0" })
              ]
            }
          ),
          /* @__PURE__ */ jsxRuntimeExports.jsxs(
            "linearGradient",
            {
              id: "paint1_linear_4160_67832",
              x1: "42.748",
              y1: "1.55322",
              x2: "42.748",
              y2: "50.4438",
              gradientUnits: "userSpaceOnUse",
              gradientTransform: "matrix(1, 0, 0, 1, 307.155052, 224.001474)",
              children: [
                /* @__PURE__ */ jsxRuntimeExports.jsx("stop", { stopColor: "white" }),
                /* @__PURE__ */ jsxRuntimeExports.jsx("stop", { offset: "0.4519", stopColor: "white", stopOpacity: "0" }),
                /* @__PURE__ */ jsxRuntimeExports.jsx("stop", { offset: "0.5397", stopColor: "white", stopOpacity: "0" }),
                /* @__PURE__ */ jsxRuntimeExports.jsx("stop", { offset: "1", stopColor: "white" })
              ]
            }
          )
        ] }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "g",
          {
            filter: "url(#filter0_f_4160_67832)",
            transform: "matrix(1, 0, 0, 1, 307.15521240234375, 224.00100708007812)",
            children: /* @__PURE__ */ jsxRuntimeExports.jsx(
              "path",
              {
                d: "M42.3874 29.5938C40.2035 29.5938 38.433 27.8234 38.433 25.6394C38.433 23.4555 40.2035 21.6851 42.3874 21.6851C44.5714 21.6851 46.3418 23.4555 46.3418 25.6394C46.3418 27.8234 44.5714 29.5938 42.3874 29.5938Z",
                fill: "white"
              }
            )
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M 316.829 249.281 L 382.975 249.281 L 382.975 250.719 L 316.829 250.719 L 316.829 249.281 Z",
            fill: "url(#paint0_linear_4160_67832)"
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M 349.903 273.007 C 362.609 273.007 372.91 262.707 372.91 250 C 372.91 237.293 362.609 226.993 349.903 226.993 C 337.196 226.993 326.896 237.293 326.896 250 C 326.896 262.707 337.196 273.007 349.903 273.007 Z M 349.903 274.445 C 363.404 274.445 374.348 263.501 374.348 250 C 374.348 236.499 363.404 225.555 349.903 225.555 C 336.402 225.555 325.458 236.499 325.458 250 C 325.458 263.501 336.402 274.445 349.903 274.445 Z",
            fill: "url(#paint1_linear_4160_67832)"
          }
        )
      ]
    }
  );
}
function SCROLL() {
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(
    "svg",
    {
      style: { maxHeight: "100%", maxWidth: "100%" },
      width: "444",
      height: "444",
      viewBox: "0 0 444 444",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx("style", { children: ".st0{fill:#ffeeda}.st2{fill:#101010}" }),
        /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "M0 0h444v444H0z", className: "st0" }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "path",
          {
            d: "M333.4 262V110.6c-.2-12.7-10.3-22.9-23-22.9h-158c-34.1.5-61.5 28.4-61.5 62.6 0 11.5 3.1 21.4 7.8 30.1 4 7.2 10.3 14 16.5 19.1 1.8 1.4.9.8 6.3 4.1 7.4 4.5 15.9 6.8 15.9 6.8l-.1 90.6c.2 4.3.6 8.4 1.8 12.3 3.5 12.8 12.4 22.6 24.4 27.3 5 2 10.7 3.3 16.8 3.4l126.2.4c25.1 0 45.5-20.4 45.5-45.6.1-15-7.4-28.4-18.6-36.8z",
            className: "st0"
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "path",
          {
            d: "M336.5 299.9C336 316 322.7 329 306.4 329l-86.8-.3c6.9-8 11.1-18.4 11.1-29.8 0-17.8-10.6-30.1-10.6-30.1h86.4c16.6 0 30.1 13.5 30.1 30.1l-.1 1z",
            style: {
              fill: "#ebc28e"
            }
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "path",
          {
            d: "M123.5 186.7c-10-9.5-17-21.7-17-36.3v-1.5c.8-24.8 21.2-44.8 46-45.5h158c4.1.2 7.4 3.1 7.4 7.3v133.7c3.6.6 5.4 1.1 8.9 2.4 2.8 1 6.6 3.2 6.6 3.2V110.7c-.2-12.7-10.3-22.9-23-22.9h-158c-34.1.5-61.5 28.4-61.5 62.6 0 19.9 9.1 36.9 23.9 48.8 1 .8 2 1.9 4.6 1.9 4.6 0 7.9-3.7 7.7-7.7 0-3.4-1.5-4.6-3.6-6.7z",
            className: "st2"
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "path",
          {
            d: "M306.4 253.2H182.5c-8.3.1-15 6.8-15 15.1v17.8c.2 8.2 7.2 15.2 15.6 15.2h9.2v-15.2H183v-17.4h5c15.7 0 27.2 14.5 27.2 30.1 0 13.8-12.6 31.4-33.6 30-18.6-1.2-28.7-17.8-28.7-30v-151c0-6.8-5.6-12.4-12.4-12.4h-12.4v15.5h9.2v148c-.5 30.1 21.4 45.2 44.3 45.2l124.9.4c25.1 0 45.5-20.4 45.5-45.6.1-25.2-20.4-45.7-45.6-45.7zm30.1 46.7C336 316 322.7 329 306.4 329l-86.8-.3c6.9-8 11.1-18.4 11.1-29.8 0-17.8-10.6-30.1-10.6-30.1h86.4c16.6 0 30.1 13.5 30.1 30.1l-.1 1zM273 153.7h-93.4v-15.5H273c4.2 0 7.7 3.4 7.7 7.7.1 4.3-3.3 7.8-7.7 7.8z",
            className: "st2"
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "path",
          {
            d: "M273 226.4h-93.4V211H273c4.2 0 7.7 3.4 7.7 7.7.1 4.2-3.3 7.7-7.7 7.7zm16.5-36.4H179.6v-15.5h109.8c4.2 0 7.7 3.4 7.7 7.7.2 4.3-3.3 7.8-7.6 7.8z",
            className: "st2"
          }
        )
      ]
    }
  );
}
function BLAST() {
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(
    "svg",
    {
      style: { maxHeight: "100%", maxWidth: "100%" },
      xmlns: "http://www.w3.org/2000/svg",
      width: "252",
      height: "166",
      viewBox: "0 0 252 166",
      fill: "none",
      children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "path",
          {
            fill: "#FCFC03",
            d: "m197.902 81.513 39.608-19.736 13.653-41.906L223.857 0H42.041L0 31.226h213.718l-11.355 35.147H116.66l-8.246 25.684h85.703L170.055 166l40.149-19.871 14.329-44.339-26.901-19.736.27-.541Z"
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "path",
          {
            fill: "#FCFC03",
            d: "m60.422 134.233 24.737-77.052-27.441-20.548L16.488 166h153.564l10.273-31.767H60.422Z"
          }
        )
      ]
    }
  );
}
function WORLD() {
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(
    "svg",
    {
      width: "36",
      height: "36",
      viewBox: "0 0 36 36",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx("circle", { cx: "18", cy: "18", r: "18", fill: "black" }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "path",
          {
            d: "M28.3266 11.8302L17.9483 11.8466C14.5118 11.8466 11.7258 14.6326 11.7258 18.069C11.7258 21.5055 14.5118 24.2915 17.9483 24.2915H27.9424",
            stroke: "white",
            strokeWidth: "2.18153",
            strokeMiterlimit: "10",
            strokeLinecap: "round"
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "path",
          {
            d: "M6.16479 18.069H30.138",
            stroke: "white",
            strokeWidth: "2.18153",
            strokeMiterlimit: "10",
            strokeLinecap: "round"
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "path",
          {
            d: "M18.069 6C24.7345 6 30.1379 11.4035 30.1379 18.069C30.1379 24.7345 24.7345 30.1379 18.069 30.1379C11.4035 30.1379 6 24.7345 6 18.069C6 11.4035 11.4035 6 18.069 6Z",
            stroke: "white",
            strokeWidth: "2.18153",
            strokeMiterlimit: "10",
            strokeLinecap: "round"
          }
        )
      ]
    }
  );
}
const useStyles$l = makeStyles()((C, { size: e }) => ({
  container: {
    height: e,
    width: e,
    ...CENTER
  },
  iconImage: {
    width: e,
    height: e
  },
  icon: {
    maxHeight: "100%",
    maxWidth: "100%"
  }
})), iconMap = {
  [TokenIcon.WBTC]: WBTC(),
  [TokenIcon.BUSD]: BUSD(),
  [TokenIcon.USDT]: USDT(),
  [TokenIcon.DAI]: DAI(),
  [TokenIcon.GLMR]: GLMR(),
  [TokenIcon.AVAX]: AVAX(),
  [TokenIcon.BNB]: BNB(),
  [TokenIcon.BSC]: BSC(),
  [TokenIcon.CELO]: CELO(),
  [TokenIcon.ETH]: ETH(),
  [TokenIcon.FANTOM]: FTM(),
  [TokenIcon.POLYGON]: POLY(),
  [TokenIcon.SOLANA]: SOL(),
  [TokenIcon.USDC]: USDC(),
  [TokenIcon.SUI]: SUI(),
  [TokenIcon.APT]: APT(),
  [TokenIcon.ARBITRUM]: ARBITRUM(),
  [TokenIcon.OPTIMISM]: OPTIMISM(),
  [TokenIcon.SEI]: SEI(),
  [TokenIcon.BASE]: BASE(),
  [TokenIcon.OSMO]: OSMO(),
  [TokenIcon.TBTC]: TBTC(),
  [TokenIcon.WSTETH]: WSTETH(),
  [TokenIcon.ATOM]: ATOM(),
  [TokenIcon.EVMOS]: EVMOS(),
  [TokenIcon.KUJI]: KUJI(),
  [TokenIcon.PYTH]: PYTH(),
  [TokenIcon.KLAY]: KLAY(),
  [TokenIcon.INJ]: INJ(),
  [TokenIcon.NTT]: NTT(),
  [TokenIcon.SCROLL]: SCROLL(),
  [TokenIcon.BLAST]: BLAST(),
  [TokenIcon.XLAYER]: /* @__PURE__ */ jsxRuntimeExports.jsx(
    "img",
    {
      style: { maxHeight: "100%", maxWidth: "100%" },
      src: chainToIcon("Xlayer")
    }
  ),
  [TokenIcon.MANTLE]: /* @__PURE__ */ jsxRuntimeExports.jsx(
    "img",
    {
      style: { maxHeight: "100%", maxWidth: "100%" },
      src: chainToIcon("Mantle")
    }
  ),
  [TokenIcon.WORLDCHAIN]: WORLD()
};
function isBuiltinTokenIcon(C) {
  return Object.values(TokenIcon).includes(C);
}
function TokenIconComponent(C) {
  const e = C.height || 36, { classes: T } = useStyles$l({ size: e });
  let $ = noIcon;
  return isBuiltinTokenIcon(C.icon) ? $ = iconMap[C.icon] || noIcon : typeof C.icon == "string" && ($ = /* @__PURE__ */ jsxRuntimeExports.jsx("img", { className: T.iconImage, src: C.icon })), /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: T.container, children: $ });
}
const useStyles$k = makeStyles()((C) => ({
  tokenListItem: {
    display: "flex",
    justifyContent: "space-between",
    paddingLeft: 8,
    borderRadius: 8
  },
  tokenDetails: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center"
  },
  addressLink: {
    display: "inline-flex",
    alignItems: "center",
    marginLeft: 4,
    height: "10px",
    overflow: "hidden",
    color: C.palette.text.primary,
    opacity: 0.6
  }
}));
function TokenItem(C) {
  var ie, se;
  const { classes: e } = useStyles$k(), T = useTheme$1(), { chain: $, token: V } = C, J = $ === V.nativeChain ? (ie = V.tokenId) == null ? void 0 : ie.address : (se = getTokenBridgeWrappedTokenAddressSync(
    getWrappedToken(V),
    $
  )) == null ? void 0 : se.toString(), ee = J ? getExplorerUrl($, J) : void 0, te = `${J == null ? void 0 : J.slice(0, 4)}...${J == null ? void 0 : J.slice(-4)}`, re = getDisplayName(V, $);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(
    ListItemButton,
    {
      className: e.tokenListItem,
      dense: !0,
      disabled: C.disabled,
      onClick: C.onClick,
      children: [
        /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: e.tokenDetails, children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(ListItemIcon, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(TokenIconComponent, { icon: C.token.icon }) }),
          /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { children: [
            /* @__PURE__ */ jsxRuntimeExports.jsx(Typography, { fontSize: 16, children: C.token.symbol }),
            /* @__PURE__ */ jsxRuntimeExports.jsxs(Typography, { fontSize: 10, color: T.palette.text.secondary, children: [
              re,
              !!J && /* @__PURE__ */ jsxRuntimeExports.jsxs(
                Link,
                {
                  onClick: (de) => de.stopPropagation(),
                  className: e.addressLink,
                  href: ee,
                  rel: "noreferrer noopener",
                  target: "_blank",
                  children: [
                    te,
                    /* @__PURE__ */ jsxRuntimeExports.jsx(default_1$5, { sx: { height: "8px", width: "12px" } })
                  ]
                }
              )
            ] })
          ] })
        ] }),
        /* @__PURE__ */ jsxRuntimeExports.jsxs(Stack, { alignItems: "flex-end", children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(Typography, { fontSize: 14, children: C.isFetchingBalance ? /* @__PURE__ */ jsxRuntimeExports.jsx(CircularProgress, { size: 24 }) : C.balance ? display(truncate(C.balance, 6)) : "" }),
          C.price && /* @__PURE__ */ jsxRuntimeExports.jsx(Typography, { color: T.palette.text.secondary, fontSize: "10px", children: C.price })
        ] })
      ]
    }
  );
}
const TokenItem$1 = memo(TokenItem), useStyles$j = makeStyles()((C) => ({
  card: {
    maxWidth: "420px"
  },
  cardContent: {
    paddingTop: 0
  },
  title: {
    fontSize: 14,
    marginBottom: "8px"
  },
  tokenLoader: {
    display: "flex",
    justifyContent: "space-between"
  },
  tokenList: {
    maxHeight: 340
  }
})), TokenList = (C) => {
  var se, de;
  const { classes: e } = useStyles$j(), T = useTheme$1(), { isFetching: $, balances: V } = useGetTokenBalances(
    ((se = C.wallet) == null ? void 0 : se.address) || "",
    C.selectedChainConfig.key,
    C.tokenList || []
  ), { usdPrices: J } = useSelector(
    (ue) => ue.tokenPrices
  ), ee = useMemo(() => {
    var xe, ve, Te, we, Ee;
    const ue = (xe = C.tokenList) == null ? void 0 : xe.find(
      (Me) => Me.key === C.selectedToken
    ), fe = (ve = C.tokenList) == null ? void 0 : ve.find(
      (Me) => Me.key === C.selectedChainConfig.gasToken
    ), he = /* @__PURE__ */ new Set(), me = [];
    if (ue && C.selectedTokenChain === C.selectedChainConfig.key && !he.has(ue.key) && (he.add(ue.key), me.push(ue)), C.sourceToken) {
      const Me = config$1.tokens[C.sourceToken];
      if (Me) {
        const Ie = Me.wrappedAsset;
        if (Ie) {
          const ke = (Te = C.tokenList) == null ? void 0 : Te.find(
            (_e) => _e.key === Ie && // Only add the wrapped token if it actually exists on the destination chain
            !!getTokenBridgeWrappedTokenAddressSync(
              _e,
              C.selectedChainConfig.key
            )
          );
          ke && !he.has(ke.key) && !isFrankensteinToken(ke, C.selectedChainConfig.key) && (he.add(ke.key), me.push(ke));
        }
      }
    }
    return fe && fe.key !== (ue == null ? void 0 : ue.key) && !he.has(fe.key) && (he.add(fe.key), me.push(fe)), Object.entries(V).forEach(([Me, Ie]) => {
      var ke;
      if (Ie != null && Ie.balance && units(Ie.balance) > 0n) {
        const _e = (ke = C.tokenList) == null ? void 0 : ke.find((De) => De.key === Me);
        _e && !he.has(_e.key) && (he.add(_e.key), me.push(_e));
      }
    }), (!C.isSource || !((we = C.wallet) != null && we.address)) && ((Ee = C.tokenList) == null || Ee.forEach((Me) => {
      he.has(Me.key) || isFrankensteinToken(Me, C.selectedChainConfig.key) || C.isSource && isWrappedToken(Me, C.selectedChainConfig.key) && !isCanonicalToken(Me, C.selectedChainConfig.key) || (he.add(Me.key), me.push(Me));
    })), me;
  }, [
    V,
    C.tokenList,
    C.selectedChainConfig.key,
    C.selectedChainConfig.gasToken,
    C.sourceToken,
    C.isSource,
    (de = C.wallet) == null ? void 0 : de.address,
    C.selectedToken,
    C.selectedTokenChain
  ]), te = useMemo(
    () => /* @__PURE__ */ jsxRuntimeExports.jsx(Typography, { variant: "body2", color: T.palette.grey.A400, children: "No supported tokens found in wallet" }),
    [T.palette.grey.A400]
  ), re = ee.length === 0 && !$ && !C.isFetching, ie = /* @__PURE__ */ jsxRuntimeExports.jsx(
    SearchableList$1,
    {
      searchPlaceholder: "Search for a token",
      className: e.tokenList,
      listTitle: re ? te : /* @__PURE__ */ jsxRuntimeExports.jsxs(Typography, { fontSize: 14, color: T.palette.text.secondary, children: [
        "Tokens on ",
        C.selectedChainConfig.displayName
      ] }),
      loading: C.isFetching && /* @__PURE__ */ jsxRuntimeExports.jsx(ListItemButton, { className: e.tokenLoader, dense: !0, children: /* @__PURE__ */ jsxRuntimeExports.jsx(CircularProgress, {}) }),
      items: ee,
      filterFn: (ue, fe) => {
        var Me, Ie, ke;
        if (fe.length === 0) return !0;
        const he = C.selectedChainConfig.key, me = Number((Me = V == null ? void 0 : V[ue.key]) == null ? void 0 : Me.balance);
        if (isFrankensteinToken(ue, he) && !me || C.isSource && isWrappedToken(ue, he) && !isCanonicalToken(ue, he) && !me)
          return !1;
        const xe = fe.toLowerCase();
        if ([ue.symbol, ue.coinGeckoId].some(
          (_e) => {
            var De, Fe;
            return (Fe = (De = _e == null ? void 0 : _e.toLowerCase()) == null ? void 0 : De.includes) == null ? void 0 : Fe.call(De, xe);
          }
        ) || getDisplayName(ue, he).toLowerCase().includes(xe)) return !0;
        const we = isWrappedToken(ue, he) ? (Ie = getTokenBridgeWrappedTokenAddressSync(ue, he)) == null ? void 0 : Ie.toString() : (ke = ue.tokenId) == null ? void 0 : ke.address;
        return !!(we == null ? void 0 : we.toLowerCase().includes(xe));
      },
      renderFn: (ue) => {
        var xe, ve;
        const fe = (xe = V == null ? void 0 : V[ue.key]) == null ? void 0 : xe.balance, he = fe ? calculateUSDPrice(fe, J.data, ue) : null, me = C.isSource && !!((ve = C.wallet) != null && ve.address) && !!V && !fe;
        return /* @__PURE__ */ jsxRuntimeExports.jsx(
          TokenItem$1,
          {
            token: ue,
            chain: C.selectedChainConfig.key,
            disabled: me,
            onClick: () => {
              C.onSelectToken(ue.key);
            },
            balance: fe,
            price: he,
            isFetchingBalance: $
          },
          ue.key
        );
      }
    }
  );
  return /* @__PURE__ */ jsxRuntimeExports.jsx(Card, { className: e.card, variant: "elevation", children: /* @__PURE__ */ jsxRuntimeExports.jsxs(CardContent, { className: e.cardContent, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(Typography, { className: e.title, children: "Select a token" }),
    ie
  ] }) });
}, useStyles$i = makeStyles()((C) => ({
  badgeContent: {
    border: `1.5px solid ${C.palette.modal.background}`,
    borderRadius: "4px"
  }
}));
function AssetBadge(C) {
  const { classes: e } = useStyles$i(), { chainConfig: T, tokenConfig: $ } = C;
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    Badge,
    {
      badgeContent: /* @__PURE__ */ jsxRuntimeExports.jsx(Box, { className: e.badgeContent, children: /* @__PURE__ */ jsxRuntimeExports.jsx(ChainIconComponent, { icon: T == null ? void 0 : T.icon, height: 13 }) }),
      sx: {
        height: "38px",
        // Icon height (36px) + the distance from badge's bottom (2px)
        marginRight: "8px",
        "& .MuiBadge-badge": {
          right: 2,
          top: 32
        }
      },
      children: /* @__PURE__ */ jsxRuntimeExports.jsx(TokenIconComponent, { icon: $ == null ? void 0 : $.icon, height: 36 })
    }
  );
}
const useStyles$h = makeStyles()((C) => ({
  card: {
    width: "100%",
    cursor: "pointer",
    maxWidth: "420px",
    minHeight: "72px",
    borderRadius: "8px"
  },
  cardContent: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "16px 20px",
    ":last-child": {
      padding: "16px 20px"
    }
  },
  chainSelector: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between"
  },
  disabled: {
    opacity: "0.4",
    cursor: "not-allowed",
    clickEvent: "none"
  },
  popover: {
    marginTop: "4px"
  },
  popoverSlot: {
    width: "100%",
    maxWidth: "420px"
  }
})), AssetPicker = (C) => {
  const [e, T] = useState(!1), [$, V] = useState(""), { classes: J } = useStyles$h(), ee = usePopupState({
    variant: "popover",
    popupId: "asset-picker"
  });
  useEffect(() => {
    ee.isOpen || setTimeout(() => {
      T(!1);
    }, 300);
  }, [ee.isOpen]), useEffect(() => {
    if (ee.isOpen && !C.chain) {
      const se = C.chainList.find(
        (de) => !isDisabledChain(de.key, C.wallet)
      );
      se && C.setChain(se.key);
    }
  }, [ee.isOpen]);
  const te = useMemo(() => C.chain ? config$1.chains[C.chain] : void 0, [C.chain]), re = useMemo(() => C.token ? config$1.tokens[C.token] : void 0, [C.token]), ie = useMemo(() => !te && !re ? /* @__PURE__ */ jsxRuntimeExports.jsx(Typography, { component: "div", fontSize: 16, children: "Select chain and token" }) : /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(Typography, { component: "div", fontSize: 16, fontWeight: 700, children: (re == null ? void 0 : re.symbol) || "Select token" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Typography, { component: "div", fontSize: 12, sx: { opacity: 0.6 }, children: te == null ? void 0 : te.displayName })
  ] }), [te, re]);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      Card,
      {
        className: J.card,
        variant: "elevation",
        ...bindTrigger(ee),
        children: /* @__PURE__ */ jsxRuntimeExports.jsxs(CardContent, { className: J.cardContent, children: [
          /* @__PURE__ */ jsxRuntimeExports.jsxs(
            Typography,
            {
              className: J.chainSelector,
              component: "div",
              gap: 1,
              children: [
                /* @__PURE__ */ jsxRuntimeExports.jsx(AssetBadge, { chainConfig: te, tokenConfig: re }),
                ie
              ]
            }
          ),
          ee.isOpen ? /* @__PURE__ */ jsxRuntimeExports.jsx(default_1$6, {}) : /* @__PURE__ */ jsxRuntimeExports.jsx(default_1$7, {})
        ] })
      }
    ),
    /* @__PURE__ */ jsxRuntimeExports.jsxs(
      Popover,
      {
        ...bindPopover(ee),
        anchorOrigin: {
          vertical: "top",
          horizontal: "center"
        },
        className: J.popover,
        transformOrigin: {
          vertical: "top",
          horizontal: "center"
        },
        marginThreshold: 4,
        slotProps: {
          paper: {
            className: J.popoverSlot
          }
        },
        children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            ChainList,
            {
              chainList: C.chainList,
              selectedChainConfig: te,
              showSearch: e,
              setShowSearch: T,
              wallet: C.wallet,
              onChainSelect: (se) => {
                C.setChain(se);
              }
            }
          ),
          !e && te && /* @__PURE__ */ jsxRuntimeExports.jsx(
            TokenList,
            {
              tokenList: C.tokenList,
              isFetching: C.isFetching,
              selectedChainConfig: te,
              selectedToken: C.token,
              selectedTokenChain: $,
              sourceToken: C.sourceToken,
              wallet: C.wallet,
              onSelectToken: (se) => {
                C.setToken(se), V(te.key), ee.close();
              },
              isSource: C.isSource
            }
          )
        ]
      }
    )
  ] });
}, ExplorerLink = (C) => {
  const { address: e, href: T, target: $ = "_blank", label: V = "Transactions" } = C, J = useCallback(
    () => window.open(T.replace("{:address}", e), $),
    [e, T, $]
  );
  return /* @__PURE__ */ jsxRuntimeExports.jsx(ListItemButton, { onClick: J, children: /* @__PURE__ */ jsxRuntimeExports.jsx(Typography, { fontSize: 14, children: V }) });
}, useStyles$g = makeStyles()((C) => ({
  connectWallet: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: "8px",
    cursor: "pointer",
    paddingTop: "2px",
    opacity: 1
  },
  walletAddress: {
    color: C.palette.primary.main,
    marginLeft: "8px"
  },
  down: {
    color: C.palette.primary.main,
    transition: "transform 0.15s ease-in",
    strokeWidth: "2px"
  },
  up: {
    transform: "scaleY(-1)"
  },
  dropdown: {
    backgroundColor: C.palette.popover.background,
    display: "flex",
    flexDirection: "column",
    gap: "8px",
    padding: "8px"
  },
  dropdownItem: {
    borderRadius: "8px",
    padding: "16px",
    cursor: "pointer",
    "&:hover": {
      backgroundColor: C.palette.popover.secondary
    }
  }
})), COPY_MESSAGE_TIMOUT = 1e3, ConnectedWallet = (C) => {
  const e = useDispatch(), { classes: T } = useStyles$g(), $ = useSelector((ue) => ue.wallet[C.type]), [V, J] = useState(!1), [ee, te] = useState(!1), re = usePopupState({
    variant: "popover",
    popupId: `connected-wallet-popover-${C.type}`
  }), ie = useCallback(() => {
    re == null || re.close(), J(!0);
  }, []), se = useCallback(() => {
    copyTextToClipboard($.address), re == null || re.close(), te(!0);
  }, [$.address]), de = useCallback(() => {
    e(disconnectWallet(C.type)), re == null || re.close();
  }, [C.type]);
  return useEffect(() => {
    ee && setTimeout(() => {
      te(!1);
    }, COPY_MESSAGE_TIMOUT);
  }, [ee]), $ != null && $.address ? /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: T.connectWallet, ...bindTrigger(re), children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(WalletIcon, { name: $.name, icon: $.icon, size: 20 }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(Tooltip, { title: "Copied", open: ee, placement: "top", arrow: !0, children: /* @__PURE__ */ jsxRuntimeExports.jsx(
        Typography,
        {
          className: T.walletAddress,
          fontSize: 14,
          fontWeight: 700,
          children: displayWalletAddress($.type, $.address)
        }
      ) }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        DownIcon,
        {
          className: `${T.down} ${re.isOpen ? T.up : ""}`
        }
      )
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      Popover,
      {
        ...bindPopover(re),
        anchorOrigin: {
          vertical: "bottom",
          horizontal: "right"
        },
        transformOrigin: {
          vertical: "top",
          horizontal: "right"
        },
        children: /* @__PURE__ */ jsxRuntimeExports.jsxs(List, { children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(ListItemButton, { onClick: se, children: /* @__PURE__ */ jsxRuntimeExports.jsx(Typography, { fontSize: 14, children: "Copy address" }) }),
          config$1.ui.explorer ? /* @__PURE__ */ jsxRuntimeExports.jsx(
            ExplorerLink,
            {
              address: $.address,
              href: config$1.ui.explorer.href,
              target: config$1.ui.explorer.target,
              label: config$1.ui.explorer.label
            }
          ) : null,
          /* @__PURE__ */ jsxRuntimeExports.jsx(ListItemButton, { onClick: ie, children: /* @__PURE__ */ jsxRuntimeExports.jsx(Typography, { fontSize: 14, children: "Change wallet" }) }),
          /* @__PURE__ */ jsxRuntimeExports.jsx(ListItemButton, { onClick: de, children: /* @__PURE__ */ jsxRuntimeExports.jsx(Typography, { fontSize: 14, children: "Disconnect" }) })
        ] })
      }
    ),
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      WalletSidebar,
      {
        open: V,
        type: C.type,
        onClose: () => {
          J(!1);
        },
        showAddressInput: C.type === TransferWallet.RECEIVING
      }
    )
  ] }) : /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, {});
}, INPUT_DEBOUNCE = 500, DebouncedTextField = memo(
  ({
    value: C,
    onChange: e,
    ...T
  }) => {
    const [$, V] = useState(C), [J, ee] = useState(!1), te = c(e, INPUT_DEBOUNCE), re = useCallback(
      (ie) => {
        let se = ie.target.value;
        se === "." && (se = "0.");
        const de = Number(se);
        isNaN(de) || de < 0 || (V(ie.target.value), te(ie.target.value));
      },
      []
    );
    return useEffect(() => {
      J || V(C);
    }, [C]), /* @__PURE__ */ jsxRuntimeExports.jsx(
      TextField,
      {
        ...T,
        value: $,
        focused: J,
        onChange: re,
        onFocus: () => ee(!0),
        onBlur: () => ee(!1)
      }
    );
  }
), useStyles$f = makeStyles()((C) => ({
  amountContainer: {
    width: "100%",
    maxWidth: "420px"
  },
  amountCard: {
    borderRadius: "8px"
  },
  amountCardContent: {
    display: "flex",
    alignItems: "center"
  },
  amountTitle: {
    color: C.palette.text.secondary,
    display: "flex",
    minHeight: "40px",
    alignItems: "center",
    justifyContent: "space-between"
  },
  inputError: {
    marginTop: "12px"
  },
  balance: {
    color: C.palette.text.secondary
  }
})), AmountInput = (C) => {
  const { classes: e } = useStyles$f(), T = useDispatch(), $ = useTheme$1(), { sending: V } = useSelector(
    (ve) => ve.wallet
  ), { amount: J } = useSelector((ve) => ve.transferInput), [ee, te] = useState(
    J ? display(J) : ""
  ), { fromChain: re, token: ie } = useSelector(
    (ve) => ve.transferInput
  ), { balances: se, isFetching: de } = useGetTokenBalances(
    (V == null ? void 0 : V.address) || "",
    re,
    C.supportedSourceTokens || []
  );
  useEffect(() => {
    !J && ee && te("");
  }, [J]);
  const ue = useMemo(
    () => {
      var ve;
      return ((ve = se == null ? void 0 : se[ie]) == null ? void 0 : ve.balance) || null;
    },
    [se, ie]
  ), fe = useMemo(
    () => !re || !ie,
    [re, ie]
  ), he = useMemo(() => fe || !V.address ? null : /* @__PURE__ */ jsxRuntimeExports.jsxs(Stack, { direction: "row", alignItems: "center", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      Typography,
      {
        fontSize: 14,
        textAlign: "right",
        sx: { marginRight: "4px" },
        className: e.balance,
        children: "Balance:"
      }
    ),
    de ? /* @__PURE__ */ jsxRuntimeExports.jsx(CircularProgress, { size: 14 }) : /* @__PURE__ */ jsxRuntimeExports.jsx(
      Typography,
      {
        fontSize: 14,
        textAlign: "right",
        className: e.balance,
        children: ue === null ? "0" : display(truncate(ue, 6))
      }
    )
  ] }), [fe, se, ue, V.address]), me = useCallback((ve) => {
    T(setAmount(ve)), te(ve);
  }, []), xe = useMemo(() => {
    const ve = fe || !V.address || !ue;
    return /* @__PURE__ */ jsxRuntimeExports.jsx(
      Button$2,
      {
        sx: { minWidth: "32px", padding: "4px" },
        disabled: ve,
        onClick: () => {
          ue && me(display(ue));
        },
        children: /* @__PURE__ */ jsxRuntimeExports.jsx(
          Typography,
          {
            fontSize: 14,
            fontWeight: ve ? 400 : 600,
            textTransform: "none",
            children: "Max"
          }
        )
      }
    );
  }, [me, fe, V.address, ue]);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: e.amountContainer, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: e.amountTitle, children: /* @__PURE__ */ jsxRuntimeExports.jsx(Typography, { variant: "body2", children: "Amount" }) }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Card, { className: e.amountCard, variant: "elevation", children: /* @__PURE__ */ jsxRuntimeExports.jsx(
      CardContent,
      {
        className: e.amountCardContent,
        style: { paddingBottom: "16px" },
        children: /* @__PURE__ */ jsxRuntimeExports.jsx(
          DebouncedTextField,
          {
            fullWidth: !0,
            disabled: fe,
            inputProps: {
              style: {
                color: C.error ? $.palette.error.main : $.palette.text.primary,
                fontSize: 24,
                height: "40px",
                padding: "4px"
              },
              onWheel: (ve) => {
                ve.currentTarget.blur();
              },
              step: "0.1"
            },
            placeholder: "0",
            variant: "standard",
            value: ee,
            onChange: me,
            InputProps: {
              disableUnderline: !0,
              endAdornment: /* @__PURE__ */ jsxRuntimeExports.jsx(InputAdornment, { position: "end", children: /* @__PURE__ */ jsxRuntimeExports.jsxs(Stack, { alignItems: "end", children: [
                xe,
                he
              ] }) })
            }
          }
        )
      }
    ) }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      AlertBanner,
      {
        error: !!C.error,
        content: C.error || C.warning,
        show: !!C.error || !!C.warning,
        color: C.error ? $.palette.error.main : $.palette.grey.A400,
        className: e.inputError
      }
    )
  ] });
}, useStyles$e = makeStyles()((C) => ({
  logo: {
    strokeWidth: "0px",
    fill: C.palette.logo
  }
}));
function WormholeIcon() {
  const { classes: C } = useStyles$e();
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      id: "Layer_1",
      "data-name": "Layer 1",
      viewBox: "0 0 255.4235 255.4555",
      children: /* @__PURE__ */ jsxRuntimeExports.jsx(
        "path",
        {
          id: "fullLogo",
          d: "m197.9535,174.6565c-7.318,12.735-20.858,20.566-35.532,20.566h-23.731v-80.03l-34.251,59.483c-7.3188,12.734-20.8583,20.565-35.5323,20.565h-23.5661v-118.1051h47.4067v79.8281l45.9427-79.7915v-.0366h47.389v80.1581l49.785-86.5071c2.013-3.513,1.976-7.8676-.201-11.2891C212.7015,23.2333,171.9905-.6805,125.7365.0148,55.203,1.1126-.3641,57.8872.0018,128.4215c.3659,70.222,57.4151,127.034,127.7107,127.034s127.711-57.178,127.711-127.711c0-11.363-1.5-22.377-4.299-32.8796-.842-3.1836-5.087-3.7691-6.734-.9331l-46.455,80.7067.018.018Z",
          className: C.logo
        }
      )
    }
  );
}
function XLabsIcon() {
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(
    "svg",
    {
      style: { maxHeight: "100%", maxWidth: "100%" },
      width: "200",
      height: "200",
      viewBox: "0 0 200 200",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M45.6197 18.1392C45.6197 16.9577 44.6394 16 43.4299 16H2.19037C0.98056 16 0 16.9577 0 18.1392V47.2774C0 48.4588 0.98056 49.4166 2.19037 49.4166H20.6197C21.8293 49.4166 22.8099 50.3743 22.8099 51.5556V80.6939C22.8099 81.8753 23.7906 82.833 25.0002 82.833H43.4299C44.6394 82.833 45.6197 83.7907 45.6197 84.9722V114.11C45.6197 115.292 44.6394 116.25 43.4299 116.25H25.0002C23.7906 116.25 22.8099 117.207 22.8099 118.389V147.527C22.8099 148.709 21.8293 149.666 20.6197 149.666H2.19037C0.98056 149.666 0 150.624 0 151.805V180.944C0 182.124 0.98056 183.083 2.19037 183.083H43.4299C44.6394 183.083 45.6197 182.124 45.6197 180.944V151.805C45.6197 150.624 46.6008 149.666 47.8103 149.666H66.2395C67.449 149.666 68.4301 148.709 68.4301 147.527V118.389C68.4301 117.207 69.4104 116.25 70.62 116.25H89.0491C90.2594 116.25 91.2397 115.292 91.2397 114.11V84.9722C91.2397 83.7907 90.2594 82.833 89.0491 82.833H70.62C69.4104 82.833 68.4301 81.8753 68.4301 80.6939V51.5556C68.4301 50.3743 67.449 49.4166 66.2395 49.4166H47.8103C46.6008 49.4166 45.6197 48.4588 45.6197 47.2774V18.1392Z",
            fill: "#0000FF"
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M154.38 18.1391C154.38 16.9576 155.36 15.9999 156.57 15.9999H197.809C199.019 15.9999 199.999 16.9576 199.999 18.1391V47.2773C199.999 48.4587 199.019 49.4165 197.809 49.4165H179.38C178.17 49.4165 177.19 50.3742 177.19 51.5555V80.6938C177.19 81.8752 176.208 82.8329 174.999 82.8329H156.57C155.36 82.8329 154.38 83.7906 154.38 84.9721V114.11C154.38 115.292 155.36 116.249 156.57 116.249H174.999C176.208 116.249 177.19 117.207 177.19 118.389V147.526C177.19 148.708 178.17 149.666 179.38 149.666H197.809C199.019 149.666 199.999 150.624 199.999 151.805V180.943C199.999 182.124 199.019 183.083 197.809 183.083H156.57C155.36 183.083 154.38 182.124 154.38 180.943V151.805C154.38 150.624 153.399 149.666 152.19 149.666H133.761C132.551 149.666 131.569 148.708 131.569 147.526V118.389C131.569 117.207 130.589 116.249 129.379 116.249H110.95C109.741 116.249 108.76 115.292 108.76 114.11V84.9721C108.76 83.7906 109.741 82.8329 110.95 82.8329H129.379C130.589 82.8329 131.569 81.8752 131.569 80.6938V51.5555C131.569 50.3742 132.551 49.4165 133.761 49.4165H152.19C153.399 49.4165 154.38 48.4587 154.38 47.2773V18.1391Z",
            fill: "#0000FF"
          }
        )
      ]
    }
  );
}
function CCTPIcon() {
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(
    "svg",
    {
      style: { maxHeight: "100%", maxWidth: "100%" },
      width: "200",
      height: "200",
      viewBox: "0 0 200 200",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      xmlnsXlink: "http://www.w3.org/1999/xlink",
      children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx("rect", { width: "200", height: "200", fill: "url(#pattern0)" }),
        /* @__PURE__ */ jsxRuntimeExports.jsxs("defs", { children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            "pattern",
            {
              id: "pattern0",
              patternContentUnits: "objectBoundingBox",
              width: "1",
              height: "1",
              children: /* @__PURE__ */ jsxRuntimeExports.jsx("use", { xlinkHref: "#image0_101_2", transform: "scale(0.00416667)" })
            }
          ),
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            "image",
            {
              id: "image0_101_2",
              width: "934",
              height: "240",
              xlinkHref: "data:image/png;base64,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"
            }
          )
        ] })
      ]
    }
  );
}
const RoutesConfig = {
  ManualTokenBridge: {
    name: "ManualTokenBridge",
    displayName: "Manual Bridge",
    link: "https://wormhole.com/",
    icon: WormholeIcon,
    pendingMessage: "Waiting for Wormhole network consensus . . ."
  },
  AutomaticTokenBridge: {
    name: "AutomaticTokenBridge",
    displayName: "Automatic Bridge",
    link: "https://xlabs.xyz",
    icon: XLabsIcon,
    pendingMessage: "Waiting for Wormhole network consensus . . ."
  },
  ManualCCTP: {
    name: "ManualCCTP",
    displayName: "Circle CCTP",
    providedBy: "Circle",
    link: "https://www.circle.com/en/cross-chain-transfer-protocol",
    icon: CCTPIcon,
    pendingMessage: "Waiting for Circle attestation . . ."
  },
  AutomaticCCTP: {
    name: "AutomaticCCTP",
    displayName: "Circle CCTP",
    providedBy: "Circle",
    link: "https://www.circle.com/en/cross-chain-transfer-protocol",
    icon: CCTPIcon,
    pendingMessage: "Waiting for Circle attestation . . ."
  },
  /*
  [Route.TBTC]: {
    route: Route.TBTC,
    name: 'tBTC',
    providedBy: 'Threshold',
    link: 'https://threshold.network/earn/btc',
    icon: WormholeIcon,
    pendingMessage: 'Waiting for Wormhole network consensus . . .',
  },
  [Route.CosmosGateway]: {
    route: Route.CosmosGateway,
    name: 'Cosmos Gateway',
    providedBy: 'Wormhole',
    link: 'https://wormhole.com/',
    icon: WormholeIcon,
    pendingMessage: 'Waiting for Wormhole network consensus . . .',
  },
  [Route.ETHBridge]: {
    route: Route.ETHBridge,
    name: 'ETH Bridge',
    providedBy: 'xLabs',
    link: 'https://xlabs.xyz',
    icon: WormholeIcon,
    pendingMessage: 'Waiting for Wormhole network consensus . . .',
  },
  [Route.wstETHBridge]: {
    route: Route.wstETHBridge,
    name: 'wstETH Bridge',
    providedBy: 'xLabs',
    link: 'https://xlabs.xyz',
    icon: WormholeIcon,
    pendingMessage: 'Waiting for Wormhole network consensus . . .',
  },
  */
  AutomaticPortico: {
    name: "AutomaticPortico",
    displayName: "Portico",
    providedBy: "xLabs",
    link: "https://xlabs.xyz",
    icon: WormholeIcon,
    pendingMessage: "Waiting for Wormhole network consensus . . ."
  },
  ManualNtt: {
    name: "ManualNtt",
    displayName: "Native Token Transfer",
    link: "https://wormhole.com/",
    icon: WormholeIcon,
    pendingMessage: "Waiting for Wormhole network consensus . . ."
  },
  AutomaticNtt: {
    name: "AutomaticNtt",
    displayName: "Native Token Transfer",
    link: "https://xlabs.xyz",
    icon: XLabsIcon,
    pendingMessage: "Waiting for Wormhole network consensus . . ."
  },
  MayanSwap: {
    name: "MayanSwap",
    displayName: "Mayan Swap",
    providedBy: "Mayan",
    link: "https://mayan.finance/",
    icon: XLabsIcon,
    pendingMessage: "Waiting for Wormhole network consensus . . ."
  },
  MayanSwapWH: {
    name: "MayanSwapWH",
    displayName: "Mayan Swap",
    providedBy: "Mayan",
    link: "https://mayan.finance/",
    icon: XLabsIcon,
    pendingMessage: "Waiting for Wormhole network consensus . . ."
  },
  MayanSwapMCTP: {
    name: "MayanSwapMCTP",
    displayName: "Mayan Swap MCTP",
    providedBy: "Mayan MCTP",
    link: "https://mayan.finance/",
    icon: XLabsIcon,
    pendingMessage: "Waiting for Wormhole network consensus . . ."
  },
  MayanSwapSWIFT: {
    name: "MayanSwapSWIFT",
    displayName: "Mayan Swap Swift",
    providedBy: "Mayan Swift",
    link: "https://mayan.finance/",
    icon: XLabsIcon,
    pendingMessage: "Waiting for Wormhole network consensus . . ."
  }
}, ErrorIcon = createSvgIcon$1(
  /* @__PURE__ */ jsxRuntimeExports.jsxs(
    "svg",
    {
      width: "34",
      height: "35",
      viewBox: "0 0 34 35",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx("circle", { opacity: "0.1", cx: "17", cy: "17.5", r: "17", fill: "currentColor" }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "path",
          {
            d: "M17 11C13.1386 11 10 14.1386 10 18C10 21.8614 13.1386 25 17 25C20.8614 25 24 21.8614 24 18C24 14.1386 20.8614 11 17 11ZM17 24.0233C13.6791 24.0233 10.9767 21.3209 10.9767 18C10.9767 14.6791 13.6791 11.9767 17 11.9767C20.3209 11.9767 23.0233 14.6791 23.0233 18C23.0233 21.3209 20.3209 24.0233 17 24.0233ZM16.5116 18.6512V14.7442C16.5116 14.4772 16.733 14.2558 17 14.2558C17.267 14.2558 17.4884 14.4772 17.4884 14.7442V18.6512C17.4884 18.9181 17.267 19.1395 17 19.1395C16.733 19.1395 16.5116 18.9181 16.5116 18.6512ZM17.814 20.9302C17.814 21.3795 17.4493 21.7442 17 21.7442C16.5507 21.7442 16.186 21.3795 16.186 20.9302C16.186 20.4809 16.5507 20.1163 17 20.1163C17.4493 20.1163 17.814 20.4809 17.814 20.9302Z",
            fill: "currentColor"
          }
        )
      ]
    }
  ),
  "Error"
), WarningIcon = createSvgIcon$1(
  /* @__PURE__ */ jsxRuntimeExports.jsxs(
    "svg",
    {
      width: "34",
      height: "35",
      viewBox: "0 0 34 35",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx("circle", { opacity: "0.1", cx: "17", cy: "17.5", r: "17", fill: "currentColor" }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "path",
          {
            d: "M17 10.5C13.1386 10.5 10 13.6386 10 17.5C10 21.3614 13.1386 24.5 17 24.5C20.8614 24.5 24 21.3614 24 17.5C24 13.6386 20.8614 10.5 17 10.5ZM17 23.5233C13.6791 23.5233 10.9767 20.8209 10.9767 17.5C10.9767 14.1791 13.6791 11.4767 17 11.4767C20.3209 11.4767 23.0233 14.1791 23.0233 17.5C23.0233 20.8209 20.3209 23.5233 17 23.5233ZM16.5116 18.1512V14.2442C16.5116 13.9772 16.733 13.7558 17 13.7558C17.267 13.7558 17.4884 13.9772 17.4884 14.2442V18.1512C17.4884 18.4181 17.267 18.6395 17 18.6395C16.733 18.6395 16.5116 18.4181 16.5116 18.1512ZM17.814 20.4302C17.814 20.8795 17.4493 21.2442 17 21.2442C16.5507 21.2442 16.186 20.8795 16.186 20.4302C16.186 19.9809 16.5507 19.6163 17 19.6163C17.4493 19.6163 17.814 19.9809 17.814 20.4302Z",
            fill: "currentColor"
          }
        )
      ]
    }
  ),
  "Warning"
), FastestRoute = createSvgIcon$1(
  /* @__PURE__ */ jsxRuntimeExports.jsx(
    "svg",
    {
      width: "9",
      height: "14",
      viewBox: "0 0 9 14",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "M8.9,5.7c0-.1-.2-.2-.4-.2h-4c-.3,0-.5-.2-.5-.4V0L0,7.9c0,.1,0,.3,0,.4,0,.1.2.2.4.2h4c.3,0,.5.2.5.4v5.1l4-7.9c0-.1,0-.3,0-.4Z" })
    }
  ),
  "Fastest"
), CheapestRoute = createSvgIcon$1(
  /* @__PURE__ */ jsxRuntimeExports.jsxs(
    "svg",
    {
      width: "14",
      height: "13",
      viewBox: "0 0 14 13",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "M5.2,7.5c0-1,.8-1.8,1.7-1.8s1.7.8,1.7,1.8-.8,1.8-1.7,1.8-1.7-.8-1.7-1.8Z" }),
        /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "M10.1,7.5c0,1.2-.6,2.2-1.6,2.7l1.9,3.4c2.1-1.2,3.5-3.5,3.5-6.1h-3.9Z" }),
        /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "M7,4.3c.6,0,1.1.2,1.6.4l1.9-3.4c-1-.6-2.2-.9-3.5-.9s-2.5.3-3.5.9l1.9,3.4c.5-.3,1-.4,1.6-.4Z" }),
        /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "M3.9,7.5H0c0,2.6,1.4,4.9,3.5,6.1l1.9-3.4c-.9-.5-1.6-1.5-1.6-2.7Z" })
      ]
    }
  ),
  "Cheapest"
), HIGH_FEE_THRESHOLD = 20, useStyles$d = makeStyles()((C) => ({
  container: {
    width: "100%",
    maxWidth: "420px",
    marginBottom: "8px"
  },
  card: {
    borderRadius: "8px",
    width: "100%",
    maxWidth: "420px"
  },
  cardHeader: {
    padding: "20px 20px 0px"
  },
  cardContent: {
    marginTop: "18px",
    padding: "0px 20px 20px"
  },
  errorIcon: {
    color: C.palette.error.main,
    height: "34px",
    width: "34px",
    marginRight: "24px"
  },
  fastestBadge: {
    width: "14px",
    height: "14px",
    position: "relative",
    top: "2px",
    marginRight: "4px",
    fill: C.palette.primary.main
  },
  cheapestBadge: {
    width: "12px",
    height: "12px",
    position: "relative",
    top: "1px",
    marginRight: "3px",
    fill: C.palette.primary.main
  },
  messageContainer: {
    padding: "12px 0px 0px"
  },
  warningIcon: {
    color: C.palette.warning.main,
    height: "34px",
    width: "34px",
    marginRight: "12px"
  }
})), SingleRoute = (C) => {
  const { classes: e } = useStyles$d(), T = useTheme$1(), $ = config$1.routes.get(C.route.name), {
    toChain: V,
    destToken: J,
    fromChain: ee,
    token: te
  } = useSelector((oe) => oe.transferInput), { usdPrices: re } = useSelector(
    (oe) => oe.tokenPrices
  ), { name: ie } = C.route, { quote: se } = C, de = useMemo(
    () => config$1.tokens[J],
    [J]
  ), [ue, fe, he] = useMemo(() => {
    if (!(se != null && se.relayFee))
      return [void 0, !1, void 0];
    const oe = whole(se.relayFee.amount), ce = se.relayFee.token, le = config$1.sdkConverter.findTokenConfigV1(
      ce,
      Object.values(config$1.tokens)
    ), pe = calculateUSDPriceRaw(
      oe,
      re.data,
      le
    );
    return pe === void 0 ? [void 0, !1, void 0] : [pe, pe > HIGH_FEE_THRESHOLD, le];
  }, [se == null ? void 0 : se.relayFee, re.data]), me = useMemo(() => {
    if (!$.AUTOMATIC_DEPOSIT)
      return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
        "You pay gas on ",
        V
      ] });
    if (!se || !ue || !he)
      return /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, {});
    const oe = getUSDFormat(ue);
    let ce = `${display(
      truncate(se.relayFee.amount, 6)
    )} ${he.symbol} (${oe})`;
    return C.route.name.startsWith("MayanSwap") && (ce = oe), /* @__PURE__ */ jsxRuntimeExports.jsxs(Stack, { direction: "row", justifyContent: "space-between", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        Typography,
        {
          color: T.palette.text.secondary,
          component: "div",
          fontSize: "14px",
          lineHeight: "14px",
          children: "Network cost"
        }
      ),
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        Typography,
        {
          color: T.palette.text.primary,
          component: "div",
          fontSize: "14px",
          lineHeight: "14px",
          children: ce
        }
      )
    ] });
  }, [
    V,
    ue,
    he,
    C.route.name,
    se,
    $.AUTOMATIC_DEPOSIT,
    T.palette.text.primary,
    T.palette.text.secondary
  ]), xe = useMemo(() => {
    if (!V || C.destinationGasDrop === void 0 || units(C.destinationGasDrop) === 0n)
      return /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, {});
    const oe = config$1.chains[V];
    if (!oe)
      return /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, {});
    const ce = config$1.tokens[oe.gasToken], le = calculateUSDPrice(
      C.destinationGasDrop,
      re.data,
      ce
    ), pe = display(
      truncate(C.destinationGasDrop, 6)
    ), ye = le ? ` (${le})` : "";
    return /* @__PURE__ */ jsxRuntimeExports.jsxs(Stack, { direction: "row", justifyContent: "space-between", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        Typography,
        {
          color: T.palette.text.secondary,
          component: "div",
          fontSize: "14px",
          lineHeight: "14px",
          children: "Additional gas"
        }
      ),
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        Typography,
        {
          color: T.palette.text.primary,
          component: "div",
          fontSize: "14px",
          lineHeight: "14px",
          children: `${pe} ${ce.symbol}${ye}`
        }
      )
    ] });
  }, [
    V,
    C.destinationGasDrop,
    T.palette.text.primary,
    T.palette.text.secondary,
    re.data
  ]), ve = useMemo(
    () => /* @__PURE__ */ jsxRuntimeExports.jsxs(Stack, { direction: "row", justifyContent: "space-between", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        Typography,
        {
          color: T.palette.text.secondary,
          component: "div",
          fontSize: "14px",
          lineHeight: "14px",
          children: `Time to ${V}`
        }
      ),
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        Typography,
        {
          component: "div",
          fontSize: "14px",
          lineHeight: "14px",
          sx: {
            color: se != null && se.eta && se.eta < 60 * 1e3 ? T.palette.success.main : T.palette.text.primary
          },
          children: se != null && se.eta ? millisToHumanString(se.eta) : "N/A"
        }
      )
    ] }),
    [
      V,
      se == null ? void 0 : se.eta,
      T.palette.success.main,
      T.palette.text.primary,
      T.palette.text.secondary
    ]
  ), Te = useMemo(() => C.route ? !$.AUTOMATIC_DEPOSIT : !1, [C.route, $.AUTOMATIC_DEPOSIT]), we = useMemo(
    () => /* @__PURE__ */ jsxRuntimeExports.jsx(Divider, { flexItem: !0, sx: { marginTop: "24px" } }),
    []
  ), Ee = useMemo(() => C.error ? /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
    we,
    /* @__PURE__ */ jsxRuntimeExports.jsxs(
      Stack,
      {
        className: e.messageContainer,
        direction: "row",
        alignItems: "center",
        children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(ErrorIcon, { className: e.errorIcon }),
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            Typography,
            {
              color: T.palette.error.main,
              fontSize: "14px",
              lineHeight: "18px",
              children: C.error
            }
          )
        ]
      }
    )
  ] }) : null, [
    e.errorIcon,
    e.messageContainer,
    we,
    C.error,
    T.palette.error.main
  ]), Me = useMemo(() => {
    const oe = [];
    Te && oe.push(
      /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { children: [
        we,
        /* @__PURE__ */ jsxRuntimeExports.jsxs(
          Stack,
          {
            className: e.messageContainer,
            direction: "row",
            alignItems: "center",
            children: [
              /* @__PURE__ */ jsxRuntimeExports.jsx(WarningIcon, { className: e.warningIcon }),
              /* @__PURE__ */ jsxRuntimeExports.jsxs(Stack, { children: [
                /* @__PURE__ */ jsxRuntimeExports.jsx(
                  Typography,
                  {
                    color: T.palette.warning.main,
                    fontSize: 14,
                    lineHeight: "18px",
                    children: "This transfer requires two transactions."
                  }
                ),
                /* @__PURE__ */ jsxRuntimeExports.jsx(
                  Typography,
                  {
                    color: T.palette.text.secondary,
                    fontSize: 14,
                    lineHeight: "18px",
                    children: "You will need to make two wallet approvals and have gas on the destination chain."
                  }
                )
              ] })
            ]
          }
        )
      ] }, "ManualTransactionWarning")
    );
    for (const ce of (se == null ? void 0 : se.warnings) || [])
      if (ce.type === "DestinationCapacityWarning" && ce.delayDurationSec) {
        const le = config$1.tokens[J].symbol, pe = formatDuration(ce.delayDurationSec);
        oe.push(
          /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { children: [
            we,
            /* @__PURE__ */ jsxRuntimeExports.jsxs(
              Stack,
              {
                className: e.messageContainer,
                direction: "row",
                alignItems: "center",
                children: [
                  /* @__PURE__ */ jsxRuntimeExports.jsx(WarningIcon, { className: e.warningIcon }),
                  /* @__PURE__ */ jsxRuntimeExports.jsx(
                    Typography,
                    {
                      color: T.palette.warning.main,
                      fontSize: 14,
                      lineHeight: "18px",
                      children: `Your transfer to ${V} may be delayed due to rate limits set by ${le}. If your transfer is delayed, you will need to return after ${pe} to complete the transfer. Please consider this before proceeding.`
                    }
                  )
                ]
              }
            )
          ] }, `${ce.type}-${ce.delayDurationSec}`)
        );
      }
    return fe && oe.push(
      /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { children: [
        we,
        /* @__PURE__ */ jsxRuntimeExports.jsxs(
          Stack,
          {
            className: e.messageContainer,
            direction: "row",
            alignItems: "center",
            children: [
              /* @__PURE__ */ jsxRuntimeExports.jsx(WarningIcon, { className: e.warningIcon }),
              /* @__PURE__ */ jsxRuntimeExports.jsxs(Stack, { children: [
                /* @__PURE__ */ jsxRuntimeExports.jsx(
                  Typography,
                  {
                    color: T.palette.warning.main,
                    fontSize: 14,
                    lineHeight: "18px",
                    children: "Output amount is much lower than input amount."
                  }
                ),
                /* @__PURE__ */ jsxRuntimeExports.jsx(
                  Typography,
                  {
                    color: T.palette.text.secondary,
                    fontSize: 14,
                    lineHeight: "18px",
                    children: "Double check before proceeding."
                  }
                )
              ] })
            ]
          }
        )
      ] }, "HighFee")
    ), oe;
  }, [
    Te,
    fe,
    we,
    e.warningIcon,
    e.messageContainer,
    T.palette.warning.main,
    T.palette.text.secondary,
    se == null ? void 0 : se.warnings,
    J,
    V
  ]), Ie = useMemo(() => {
    if (!te)
      return "";
    const { providedBy: oe, name: ce } = C.route, { symbol: le } = config$1.tokens[te];
    let pe = "";
    return ce === "AutomaticNtt" && le === "wstETH" && (ee === "Ethereum" && V === "Bsc" || ee === "Bsc" && V === "Ethereum") ? pe = "via NTT: Wormhole + Axelar" : oe && !oe.toLowerCase().includes("xlabs") && (pe = `via ${C.route.providedBy}`), pe;
  }, [C.route, ee, te, V]), ke = useMemo(() => se ? whole(se == null ? void 0 : se.destinationToken.amount) : void 0, [se]), _e = useMemo(() => {
    if (se)
      return display(truncate(se.destinationToken.amount, 6));
  }, [se]), De = useMemo(() => {
    if (C.error)
      return /* @__PURE__ */ jsxRuntimeExports.jsx(Typography, { color: "error", children: "Route is unavailable" });
    if (ke === void 0 || !de)
      return null;
    const oe = fe ? T.palette.warning.main : T.palette.text.primary;
    return /* @__PURE__ */ jsxRuntimeExports.jsxs(
      Typography,
      {
        fontSize: "18px",
        lineHeight: "18px",
        color: oe,
        component: "div",
        marginBottom: "6px",
        children: [
          _e,
          " ",
          de.symbol
        ]
      }
    );
  }, [
    C.error,
    ke,
    _e,
    de,
    fe,
    T.palette.warning.main,
    T.palette.text.primary
  ]), Fe = useMemo(() => {
    if (C.error || !V || ke === void 0)
      return null;
    const oe = calculateUSDPrice(
      ke,
      re.data,
      de
    );
    return /* @__PURE__ */ jsxRuntimeExports.jsx(
      Typography,
      {
        fontSize: "14px",
        lineHeight: "14px",
        color: T.palette.text.secondary,
        component: "div",
        children: `${oe} ${Ie}`
      }
    );
  }, [
    V,
    de,
    C.error,
    Ie,
    ke,
    T.palette.text.secondary,
    re.data
  ]), Ae = useMemo(() => C.isSelected || typeof C.onSelect != "function" ? "default" : C.error ? "not-allowed" : "pointer", [C.error, C.isSelected, C.onSelect]), ne = useMemo(() => C.isFastest ? /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(FastestRoute, { className: e.fastestBadge }),
    C.isOnlyChoice ? "Fast" : "Fastest"
  ] }) : C.isCheapest && !C.isOnlyChoice ? /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(CheapestRoute, { className: e.cheapestBadge }),
    " Cheapest"
  ] }) : null, [
    C.isFastest,
    C.isCheapest,
    C.isOnlyChoice,
    e.fastestBadge,
    e.cheapestBadge
  ]);
  return isEmptyObject(C.route) ? /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, {}) : /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: e.container, children: /* @__PURE__ */ jsxRuntimeExports.jsx(
    Card,
    {
      className: e.card,
      sx: {
        border: "1px solid",
        borderColor: C.isSelected ? T.palette.primary.main : "transparent",
        opacity: 1
      },
      children: /* @__PURE__ */ jsxRuntimeExports.jsxs(
        CardActionArea,
        {
          disabled: typeof C.onSelect != "function" || C.error !== void 0,
          disableTouchRipple: !0,
          sx: { cursor: Ae },
          onClick: () => {
            var oe;
            (oe = C.onSelect) == null || oe.call(C, C.route.name);
          },
          children: [
            /* @__PURE__ */ jsxRuntimeExports.jsx(
              CardHeader,
              {
                avatar: /* @__PURE__ */ jsxRuntimeExports.jsx(TokenIconComponent, { icon: de == null ? void 0 : de.icon }),
                className: e.cardHeader,
                title: De,
                subheader: Fe,
                action: ne
              }
            ),
            /* @__PURE__ */ jsxRuntimeExports.jsxs(CardContent, { className: e.cardContent, children: [
              /* @__PURE__ */ jsxRuntimeExports.jsxs(Stack, { gap: "14px", children: [
                me,
                xe,
                ve
              ] }),
              Ee,
              Me
            ] })
          ]
        }
      )
    }
  ) }, ie);
}, useStyles$c = makeStyles()((C) => ({
  otherRoutesToggle: {
    display: "block",
    width: "100%",
    textAlign: "center",
    fontSize: 14,
    color: C.palette.text.secondary,
    textDecoration: "none",
    cursor: "pointer",
    "&:hover": {
      textDecoration: "underline"
    }
  }
})), Routes = ({ ...C }) => {
  const { classes: e } = useStyles$c(), [T, $] = useState(!1), V = useMemo(() => C.routes.filter((re) => C.quotes[re] !== void 0), [C.routes, C.quotes]), J = useMemo(() => {
    if (T)
      return V;
    const re = V.find((ie) => ie === C.selectedRoute);
    return re ? [re] : V.slice(0, 1);
  }, [T, V]), ee = useMemo(() => V.reduce(
    (re, ie) => {
      const se = C.quotes[ie];
      return !se || !se.success ? re : se.eta !== void 0 && se.eta < re.eta && se.eta < 6e4 ? { name: ie, eta: se.eta } : re;
    },
    { name: "", eta: 1 / 0 }
  ), [V, C.quotes]), te = useMemo(() => V.reduce(
    (re, ie) => {
      const se = C.quotes[ie], de = config$1.routes.get(ie);
      if (!se || !se.success || !de.AUTOMATIC_DEPOSIT) return re;
      const ue = BigInt(se.destinationToken.amount.amount);
      return ue > re.amountOut ? { name: ie, amountOut: ue } : re;
    },
    { name: "", amountOut: 0n }
  ), [V, C.quotes]);
  return C.hasError ? null : /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
    C.isLoading || J.length > 0 ? /* @__PURE__ */ jsxRuntimeExports.jsxs(Box, { sx: { display: "flex", width: "100%" }, children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        Typography,
        {
          align: "left",
          fontSize: 16,
          paddingBottom: 0,
          marginTop: "8px",
          marginBottom: 0,
          width: "100%",
          textAlign: "left",
          children: "Routes"
        }
      ),
      C.isLoading ? /* @__PURE__ */ jsxRuntimeExports.jsx(CircularProgress, { sx: { alignSelf: "flex-end" }, size: 20 }) : null
    ] }) : null,
    C.isLoading && J.length === 0 ? /* @__PURE__ */ jsxRuntimeExports.jsx(Skeleton, { variant: "rounded", height: 153, width: "100%" }) : J.map((re, ie) => {
      var me;
      const se = RoutesConfig[re], de = se.name === C.selectedRoute, ue = C.quotes[re], fe = ue != null && ue.success ? ue : void 0, he = (ue == null ? void 0 : ue.success) === !1 ? ((me = ue == null ? void 0 : ue.error) == null ? void 0 : me.message) ?? `Error while getting a quote for ${re}.` : void 0;
      return /* @__PURE__ */ jsxRuntimeExports.jsx(
        SingleRoute,
        {
          route: se,
          error: he,
          isSelected: de && !he,
          isFastest: re === ee.name,
          isCheapest: re === te.name,
          isOnlyChoice: V.length === 1,
          onSelect: C.onRouteChange,
          quote: fe
        },
        re
      );
    }),
    V.length > 1 && /* @__PURE__ */ jsxRuntimeExports.jsx(
      Link,
      {
        onClick: () => $((re) => !re),
        className: e.otherRoutesToggle,
        children: T ? "Hide other routes" : "View other routes"
      }
    )
  ] });
};
var ChevronLeft = {}, _interopRequireDefault$4 = interopRequireDefaultExports;
Object.defineProperty(ChevronLeft, "__esModule", {
  value: !0
});
var default_1$4 = ChevronLeft.default = void 0, _createSvgIcon$4 = _interopRequireDefault$4(requireCreateSvgIcon()), _jsxRuntime$4 = jsxRuntimeExports;
default_1$4 = ChevronLeft.default = (0, _createSvgIcon$4.default)(/* @__PURE__ */ (0, _jsxRuntime$4.jsx)("path", {
  d: "M15.41 7.41 14 6l-6 6 6 6 1.41-1.41L10.83 12z"
}), "ChevronLeft");
const LOCAL_STORAGE_KEY = "wormhole-connect:transactions:inprogress", LOCAL_STORAGE_MAX = 3, JSONReplacer = (C, e) => typeof e == "bigint" ? e.toString() : e, validateChildPropTypes = (C, e) => {
  if (isEmptyObject(C))
    return !1;
  for (const T in e)
    if (C[T] === null || // Line below is an explicit check for undefined values as well
    typeof C[T] !== e[T])
      return !1;
  return !0;
}, validateSingleTransaction = (C) => !(!validateChildPropTypes(C, {
  receipt: "object",
  route: "string",
  timestamp: "number",
  txDetails: "object",
  txHash: "string"
}) || !validateChildPropTypes(C.txDetails, {
  amount: "object",
  eta: "number",
  fromChain: "string",
  toChain: "string",
  tokenKey: "string"
}) || !validateChildPropTypes(C.txDetails.amount, {
  amount: "string",
  decimals: "number"
})), validateTransactions = (C) => {
  if (!Array.isArray(C))
    return !1;
  for (const e of C)
    if (!validateSingleTransaction(e))
      return !1;
  return !0;
}, getTxsFromLocalStorage = () => {
  const C = window.localStorage;
  for (let e = 0; e < C.length; e++) {
    const T = C.key(e);
    if ((T == null ? void 0 : T.toLowerCase()) === LOCAL_STORAGE_KEY) {
      const $ = C.getItem(T);
      if ($)
        try {
          const V = JSON.parse($);
          if (validateTransactions(V))
            return V;
          console.log(
            `Error while parsing localStorage item ${LOCAL_STORAGE_KEY}: Not an array of valid transactions`
          ), C.removeItem(LOCAL_STORAGE_KEY);
          return;
        } catch (V) {
          console.log(
            `Error while parsing localStorage item ${LOCAL_STORAGE_KEY}: ${V}`
          ), C.removeItem(LOCAL_STORAGE_KEY);
          return;
        }
    }
  }
}, addTxToLocalStorage = (C) => {
  const e = window.localStorage, T = getTxsFromLocalStorage();
  let $;
  T ? T.length < LOCAL_STORAGE_MAX ? $ = T.concat([C]) : (T.splice(0, 1), $ = T.concat([C])) : $ = [C];
  try {
    e.setItem(LOCAL_STORAGE_KEY, JSON.stringify($, JSONReplacer));
  } catch (V) {
    console.log(
      `Error while adding item to localStorage ${LOCAL_STORAGE_KEY}: ${V}`
    );
  }
}, removeTxFromLocalStorage = (C) => {
  const e = window.localStorage, T = getTxsFromLocalStorage();
  if (T && T.length > 0) {
    const $ = T.findIndex((V) => V.txHash === C);
    if ($ > -1) {
      T.splice($, 1);
      try {
        e.setItem(LOCAL_STORAGE_KEY, JSON.stringify(T, JSONReplacer));
      } catch (V) {
        console.log(
          `Error while removing item from localStorage ${LOCAL_STORAGE_KEY}: ${V}`
        );
      }
    }
  }
}, updateTxInLocalStorage = (C, e, T) => {
  const $ = window.localStorage, V = getTxsFromLocalStorage();
  if (V && V.length > 0) {
    const J = V.findIndex((ee) => ee.txHash === C);
    if (J > -1) {
      V[J][e] = T;
      try {
        $.setItem(LOCAL_STORAGE_KEY, JSON.stringify(V, JSONReplacer));
      } catch (ee) {
        console.log(
          `Error while updating item in localStorage ${LOCAL_STORAGE_KEY}: ${ee}`
        );
      }
    }
  }
}, useGasSlider = (C) => {
  const { destChain: e, destToken: T, route: $, isTransactionInProgress: V, valid: J } = C, ee = !J || V, te = e ? config$1.chains[e] : void 0, re = te ? config$1.tokens[te.gasToken] : void 0, ie = re ? getWrappedToken(re) : void 0, se = ie && T === ie.key, de = !!$ && config$1.routes.get($).NATIVE_GAS_DROPOFF_SUPPORTED && !se;
  return {
    disabled: ee,
    showGasSlider: de
  };
}, useStyles$b = makeStyles()(() => ({
  card: {
    width: "100%",
    cursor: "pointer",
    maxWidth: "420px",
    overflow: "visible",
    padding: "0 4px"
  },
  container: {
    display: "flex",
    flexDirection: "column",
    gap: "8px",
    width: "100%"
  },
  amounts: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center"
  }
})), StyledSlider = styled$1(Slider, {
  shouldForwardProp: (C) => !["baseColor", "railColor"].includes(C.toString())
})(({ baseColor: C, railColor: e, theme: T }) => ({
  color: C,
  height: 8,
  "& .MuiSlider-rail": {
    height: "8px",
    backgroundColor: e,
    opacity: 0.1
  },
  "& .MuiSlider-track": {
    height: "8px"
  },
  "& .MuiSlider-thumb": {
    height: 20,
    width: 20,
    backgroundColor: T.palette.primary.main
  }
})), StyledSwitch = styled$1(Switch)(({ theme: C }) => ({
  padding: "9px 12px",
  right: "-12px",
  // reposition towards right to negate switch padding
  "& .MuiSwitch-switchBase.Mui-checked": {
    color: C.palette.primary.main
  },
  "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
    backgroundColor: C.palette.primary.main
  },
  "& .MuiSwitch-track": {
    height: "20px",
    borderRadius: "9px"
  }
})), GasSlider = (C) => {
  const { classes: e } = useStyles$b(), T = useDispatch(), $ = useTheme$1(), { toChain: V } = useSelector(
    (he) => he.transferInput
  ), { usdPrices: J } = useSelector(
    (he) => he.tokenPrices
  ), ee = config$1.chains[V], te = config$1.tokens[ee.gasToken], [re, ie] = useState(!C.disabled), [se, de] = useState(0), [ue] = o$1(se, 500);
  useEffect(() => {
    T(setToNativeToken(ue / 100));
  }, [ue]);
  const fe = useMemo(() => {
    if (!V)
      return null;
    const he = display(
      truncate(C.destinationGasDrop, 6)
    );
    console.log(he);
    const me = calculateUSDPrice(
      C.destinationGasDrop,
      J.data,
      te
    );
    return /* @__PURE__ */ jsxRuntimeExports.jsx(Typography, { fontSize: 14, children: `${he} ${getDisplayName(
      te,
      V
    )} ${me}` });
  }, [te, J, C.destinationGasDrop, V]);
  return !ee || !te ? /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, {}) : /* @__PURE__ */ jsxRuntimeExports.jsx(Card, { className: e.card, variant: "elevation", children: /* @__PURE__ */ jsxRuntimeExports.jsxs(CardContent, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsxs(
      Stack,
      {
        direction: "row",
        alignItems: "center",
        justifyContent: "space-between",
        children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(Typography, { children: `Need more gas on ${V}?` }),
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            StyledSwitch,
            {
              checked: re,
              onClick: (he) => {
                const { checked: me } = he.target;
                ie(me), me || (de(0), T(setToNativeToken(0)));
              }
            }
          )
        ]
      }
    ),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Collapse, { in: re, unmountOnExit: !0, children: /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: e.container, children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(Typography, { color: $.palette.text.secondary, fontSize: 14, children: `Use the slider to buy extra ${te.symbol} for future transactions.` }),
      /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          StyledSlider,
          {
            "aria-label": "Native gas conversion amount",
            defaultValue: 0,
            value: se,
            baseColor: $.palette.primary.main,
            railColor: $.palette.background.default,
            step: 1,
            min: 0,
            max: 100,
            valueLabelFormat: () => `${se}%`,
            valueLabelDisplay: "auto",
            onChange: (he) => de(he.target.value)
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: e.amounts, children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(Typography, { color: $.palette.text.secondary, fontSize: 14, children: "Additional gas" }),
          /* @__PURE__ */ jsxRuntimeExports.jsx(Typography, { color: $.palette.text.secondary, fontSize: 14, children: fe })
        ] })
      ] })
    ] }) })
  ] }) });
};
function toDecimals(C, e, T) {
  return display(
    {
      amount: C.toString(),
      decimals: e
    },
    T
  );
}
function toFixedDecimals(C, e) {
  if (typeof C != "string")
    throw new Error("Invalid argument");
  return C === "0.0" ? "0" : C.includes(".") ? parseFloat(C).toFixed(e) : C;
}
const useUSDamountGetter = () => {
  const {
    usdPrices: { data: C }
  } = useSelector((e) => e.tokenPrices);
  return useCallback(
    ({ token: e, amount: T }) => {
      const $ = C || {}, V = whole(T), ee = Number(getTokenPrice($, config$1.tokens[e])) * V;
      return isNaN(ee) ? void 0 : parseFloat(ee.toFixed(2));
    },
    [C]
  );
};
var ContentCopy = {}, _interopRequireDefault$3 = interopRequireDefaultExports;
Object.defineProperty(ContentCopy, "__esModule", {
  value: !0
});
var default_1$3 = ContentCopy.default = void 0, _createSvgIcon$3 = _interopRequireDefault$3(requireCreateSvgIcon()), _jsxRuntime$3 = jsxRuntimeExports;
default_1$3 = ContentCopy.default = (0, _createSvgIcon$3.default)(/* @__PURE__ */ (0, _jsxRuntime$3.jsx)("path", {
  d: "M16 1H4c-1.1 0-2 .9-2 2v14h2V3h12zm3 4H8c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h11c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2m0 16H8V7h11z"
}), "ContentCopy");
var Done = {}, _interopRequireDefault$2 = interopRequireDefaultExports;
Object.defineProperty(Done, "__esModule", {
  value: !0
});
var default_1$2 = Done.default = void 0, _createSvgIcon$2 = _interopRequireDefault$2(requireCreateSvgIcon()), _jsxRuntime$2 = jsxRuntimeExports;
default_1$2 = Done.default = (0, _createSvgIcon$2.default)(/* @__PURE__ */ (0, _jsxRuntime$2.jsx)("path", {
  d: "M9 16.2 4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4z"
}), "Done");
const useStyles$a = makeStyles()((C) => ({
  copyIcon: {
    fontSize: "14px"
  },
  doneIcon: {
    fontSize: "14px",
    color: C.palette.success.main
  }
})), SendError = ({ humanError: C, internalError: e }) => {
  const { classes: T } = useStyles$a(), [$, V] = useState(!1);
  if (C === void 0)
    return null;
  const J = e && e.message && config$1.ui.getHelpUrl ? /* @__PURE__ */ jsxRuntimeExports.jsxs(Typography, { fontSize: 14, sx: { marginTop: 1 }, children: [
    "Having trouble?",
    " ",
    /* @__PURE__ */ jsxRuntimeExports.jsxs(
      "a",
      {
        href: "#",
        onClick: () => {
          copyTextToClipboard(e.message), V(!0), setTimeout(() => V(!1), 3e3);
        },
        children: [
          "Copy the error logs",
          " ",
          $ ? /* @__PURE__ */ jsxRuntimeExports.jsx(default_1$2, { className: T.doneIcon }) : /* @__PURE__ */ jsxRuntimeExports.jsx(default_1$3, { className: T.copyIcon })
        ]
      }
    ),
    " and ",
    /* @__PURE__ */ jsxRuntimeExports.jsx("a", { href: config$1.ui.getHelpUrl, target: "_blank", children: "ask for help" }),
    "."
  ] }) : null;
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(Box, { sx: { marginBottom: 2 }, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      AlertBanner,
      {
        error: !0,
        content: C,
        show: !0,
        testId: "send-error-message"
      }
    ),
    J
  ] });
}, useStyles$9 = makeStyles()((C) => ({
  container: {
    gap: "16px",
    width: "100%",
    maxWidth: "420px"
  },
  confirmTransaction: {
    padding: "8px 16px",
    borderRadius: "8px",
    margin: "auto",
    maxWidth: "420px",
    width: "100%"
  }
})), ReviewTransaction = (C) => {
  const { classes: e } = useStyles$9(), T = useDispatch(), $ = useTheme$1(), V = useMediaQuery($.breakpoints.down("sm")), [J, ee] = useState(void 0), [te, re] = useState(
    void 0
  ), ie = useContext(RouteContext), se = useSelector((ye) => ye.transferInput), {
    amount: de,
    fromChain: ue,
    toChain: fe,
    token: he,
    destToken: me,
    isTransactionInProgress: xe,
    route: ve,
    validations: Te
  } = se, we = useSelector((ye) => ye.wallet), { sending: Ee, receiving: Me } = we, Ie = useSelector((ye) => ye.relay), { toNativeToken: ke } = Ie, _e = useUSDamountGetter(), { disabled: De, showGasSlider: Fe } = useGasSlider({
    destChain: fe,
    destToken: me,
    route: ve,
    valid: !0,
    isTransactionInProgress: xe
  }), Ae = C.quotes[ve ?? ""], ne = Ae != null && Ae.success ? Ae : void 0, oe = ne == null ? void 0 : ne.destinationNativeGas, ce = async () => {
    if (ee(void 0), config$1.ui.previewMode) {
      ee("Connect is in preview mode");
      return;
    }
    if (!ue || !he || !fe || !me || !de || !ve || !ne || (await validate({ transferInput: se, relay: Ie, wallet: we }, T, () => !1), !isTransferValid(Te) || !ve))
      return;
    const Ce = getTransferDetails(
      ve,
      he,
      me,
      ue,
      fe,
      de,
      _e
    );
    if (config$1.validateTransfer)
      try {
        const { isValid: ae, error: ge } = await config$1.validateTransfer({
          ...Ce,
          fromWalletAddress: Ee.address,
          toWalletAddress: Me.address
        });
        if (!ae) {
          ee(ge ?? "Transfer validation failed");
          return;
        }
      } catch (ae) {
        ee("Error validating transfer"), re(ae), console.error(ae);
        return;
      }
    T(setIsTransactionInProgress(!0));
    const be = config$1.tokens[he];
    try {
      const ae = config$1.chains[ue];
      if ((ae == null ? void 0 : ae.context) === Context.ETH) {
        const Be = ae.chainId;
        if (typeof Be != "number")
          throw new Error("Invalid EVM chain ID");
        await switchChain(Be, TransferWallet.SENDING), await registerWalletSigner(ue, TransferWallet.SENDING);
      }
      config$1.triggerEvent({
        type: "transfer.initiate",
        details: Ce
      });
      const [ge, Se] = await config$1.routes.get(ve).send(
        be,
        de,
        ue,
        Ee.address,
        fe,
        Me.address,
        me,
        { nativeGas: ke }
      ), Le = "originTxs" in Se ? Se.originTxs[Se.originTxs.length - 1].txid : void 0;
      if (config$1.triggerEvent({
        type: "transfer.start",
        details: { ...Ce, txId: Le }
      }), !Le) throw new Error("Can't find txid in receipt");
      let ze;
      if (ne.relayFee) {
        const { token: Be, amount: Ue } = ne.relayFee, Ge = config$1.sdkConverter.findTokenConfigV1(
          Be,
          Object.values(config$1.tokens)
        );
        ze = {
          fee: Number.parseFloat(
            toDecimals(Ue.amount, Ue.decimals, 6)
          ),
          tokenKey: (Ge == null ? void 0 : Ge.key) || ""
        };
      }
      const Re = Date.now(), We = {
        sendTx: Le,
        sender: Ee.address,
        amount: de,
        recipient: Me.address,
        toChain: Se.to,
        fromChain: Se.from,
        tokenAddress: getWrappedToken(be).tokenId.address,
        tokenKey: be.key,
        tokenDecimals: getTokenDecimals(
          ue,
          getWrappedToken(be)
        ),
        receivedTokenKey: config$1.tokens[me].key,
        // TODO: possibly wrong (e..g if portico swap fails)
        relayerFee: ze,
        receiveAmount: ne.destinationToken.amount,
        receiveNativeAmount: oe,
        eta: ne.eta || 0
      };
      addTxToLocalStorage({
        txDetails: We,
        txHash: Le,
        timestamp: Re,
        receipt: Se,
        route: ve
      }), T(setTimestamp(Re)), T(setTxDetails(We)), T(setAmount("")), ie.setRoute(ge), ie.setReceipt(Se), T(setSendTx(Le)), T(setRoute$1(ve)), T(setRoute("redeem")), ee(void 0);
    } catch (ae) {
      const [ge, Se] = interpretTransferError(
        ae,
        Ce
      );
      Se.type === ERR_USER_REJECTED || (console.error("Wormhole Connect: error completing transfer", ae), ee(ge), re(ae), config$1.triggerEvent({
        type: "transfer.error",
        error: Se,
        details: Ce
      }));
    } finally {
      T(setIsTransactionInProgress(!1));
    }
  }, le = useMemo(
    () => !!Ee.address && !!Me.address,
    [Ee.address, Me.address]
  ), pe = useMemo(() => !ue || !he || !fe || !me || !ve || !de ? null : /* @__PURE__ */ jsxRuntimeExports.jsx(
    Button,
    {
      disabled: C.isFetchingQuotes || xe,
      variant: "primary",
      className: e.confirmTransaction,
      onClick: () => ce(),
      children: xe ? /* @__PURE__ */ jsxRuntimeExports.jsxs(
        Typography,
        {
          display: "flex",
          alignItems: "center",
          gap: 1,
          textTransform: "none",
          children: [
            /* @__PURE__ */ jsxRuntimeExports.jsx(
              CircularProgress,
              {
                size: 16,
                sx: { color: $.palette.primary.contrastText }
              }
            ),
            V ? "Preparing" : "Preparing transaction"
          ]
        }
      ) : !xe && C.isFetchingQuotes ? /* @__PURE__ */ jsxRuntimeExports.jsxs(
        Typography,
        {
          display: "flex",
          alignItems: "center",
          gap: 1,
          textTransform: "none",
          children: [
            /* @__PURE__ */ jsxRuntimeExports.jsx(CircularProgress, { color: "secondary", size: 16 }),
            V ? "Refreshing" : "Refreshing quote"
          ]
        }
      ) : /* @__PURE__ */ jsxRuntimeExports.jsx(Typography, { textTransform: "none", children: V ? "Confirm" : "Confirm transaction" })
    }
  ), [
    C.isFetchingQuotes,
    xe,
    ue,
    he,
    fe,
    me,
    ve,
    de,
    ce
  ]);
  return !ve || !le ? /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, {}) : /* @__PURE__ */ jsxRuntimeExports.jsxs(Stack, { className: e.container, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("div", { children: /* @__PURE__ */ jsxRuntimeExports.jsx(
      IconButton,
      {
        disabled: xe,
        sx: { padding: 0 },
        onClick: () => {
          var ye;
          return (ye = C.onClose) == null ? void 0 : ye.call(C);
        },
        children: /* @__PURE__ */ jsxRuntimeExports.jsx(default_1$4, { sx: { fontSize: "32px" } })
      }
    ) }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      SingleRoute,
      {
        route: RoutesConfig[ve],
        isSelected: !1,
        destinationGasDrop: oe,
        quote: ne
      }
    ),
    Fe && /* @__PURE__ */ jsxRuntimeExports.jsx(Collapse, { in: Fe, children: /* @__PURE__ */ jsxRuntimeExports.jsx(
      GasSlider,
      {
        destinationGasDrop: oe || fromBaseUnits(0n, 8),
        disabled: De
      }
    ) }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(SendError, { humanError: J, internalError: te }),
    pe
  ] });
};
var SwapVert = {}, _interopRequireDefault$1 = interopRequireDefaultExports;
Object.defineProperty(SwapVert, "__esModule", {
  value: !0
});
var default_1$1 = SwapVert.default = void 0, _createSvgIcon$1 = _interopRequireDefault$1(requireCreateSvgIcon()), _jsxRuntime$1 = jsxRuntimeExports;
default_1$1 = SwapVert.default = (0, _createSvgIcon$1.default)(/* @__PURE__ */ (0, _jsxRuntime$1.jsx)("path", {
  d: "M16 17.01V10h-2v7.01h-3L15 21l4-3.99zM9 3 5 6.99h3V14h2V6.99h3z"
}), "SwapVert");
const useStyles$8 = makeStyles()(() => ({
  swapButton: {
    display: "block",
    position: "absolute",
    bottom: -44,
    left: "calc(50% - 20px)",
    width: 40,
    height: 40,
    zIndex: 1
  }
}));
function SwapInputs() {
  var de, ue;
  const C = useDispatch(), [e, T] = useState(""), {
    isTransactionInProgress: $,
    fromChain: V,
    toChain: J,
    destToken: ee,
    token: te
  } = useSelector((fe) => fe.transferInput), re = V && !((de = config$1.chains[V]) != null && de.disabledAsDestination) && J && !((ue = config$1.chains[J]) != null && ue.disabledAsSource), ie = useCallback(() => {
    !re || $ || (T(
      (fe) => fe === "spinRight" ? "spinLeft" : "spinRight"
    ), C(swapInputs()), C(swapWallets()), C(setAmount("")), ee && config$1.routes.allSupportedDestTokens(config$1.tokens[ee], J, V).then((fe) => {
      fe.find(
        (me) => me.key === te
      ) || C(setDestToken(""));
    }));
  }, [
    V,
    J,
    te,
    ee,
    re,
    $,
    C
  ]), { classes: se } = useStyles$8();
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    IconButton,
    {
      className: se.swapButton,
      sx: {
        animation: `${e} 0.3s linear 1`,
        "@keyframes spinRight": {
          "0%": {
            transform: "rotate(-180deg)"
          },
          "100%": {
            transform: "rotate(0deg)"
          }
        },
        "@keyframes spinLeft": {
          "0%": {
            transform: "rotate(180deg)"
          },
          "100%": {
            transform: "rotate(0deg)"
          }
        }
      },
      onClick: ie,
      disabled: !re,
      children: /* @__PURE__ */ jsxRuntimeExports.jsx(default_1$1, {})
    }
  );
}
var dist = { exports: {} };
(function(C, e) {
  (function(T, $) {
    C.exports = $(React__default);
  })(typeof self < "u" ? self : commonjsGlobal$1, (T) => (() => {
    var $ = { 155: (ve) => {
      ve.exports = T;
    } }, V = {};
    function J(ve) {
      var Te = V[ve];
      if (Te !== void 0) return Te.exports;
      var we = V[ve] = { exports: {} };
      return $[ve](we, we.exports, J), we.exports;
    }
    J.d = (ve, Te) => {
      for (var we in Te) J.o(Te, we) && !J.o(ve, we) && Object.defineProperty(ve, we, { enumerable: !0, get: Te[we] });
    }, J.o = (ve, Te) => Object.prototype.hasOwnProperty.call(ve, Te), J.r = (ve) => {
      typeof Symbol < "u" && Symbol.toStringTag && Object.defineProperty(ve, Symbol.toStringTag, { value: "Module" }), Object.defineProperty(ve, "__esModule", { value: !0 });
    };
    var ee = {};
    J.r(ee), J.d(ee, { default: () => xe, useStopwatch: () => he, useTime: () => me, useTimer: () => fe });
    var te = J(155);
    class re {
      static expiryTimestamp(Te) {
        const we = new Date(Te).getTime() > 0;
        return we || console.warn("react-timer-hook: { useTimer } Invalid expiryTimestamp settings", Te), we;
      }
      static onExpire(Te) {
        const we = Te && typeof Te == "function";
        return Te && !we && console.warn("react-timer-hook: { useTimer } Invalid onExpire settings function", Te), we;
      }
    }
    class ie {
      static getTimeFromSeconds(Te) {
        const we = Math.ceil(Te), Ee = Math.floor(we / 86400), Me = Math.floor(we % 86400 / 3600), Ie = Math.floor(we % 3600 / 60);
        return { totalSeconds: we, seconds: Math.floor(we % 60), minutes: Ie, hours: Me, days: Ee };
      }
      static getSecondsFromExpiry(Te, we) {
        const Ee = Te - (/* @__PURE__ */ new Date()).getTime();
        if (Ee > 0) {
          const Me = Ee / 1e3;
          return we ? Math.round(Me) : Me;
        }
        return 0;
      }
      static getSecondsFromPrevTime(Te, we) {
        const Ee = (/* @__PURE__ */ new Date()).getTime() - Te;
        if (Ee > 0) {
          const Me = Ee / 1e3;
          return we ? Math.round(Me) : Me;
        }
        return 0;
      }
      static getSecondsFromTimeNow() {
        const Te = /* @__PURE__ */ new Date();
        return Te.getTime() / 1e3 - 60 * Te.getTimezoneOffset();
      }
      static getFormattedTimeFromSeconds(Te, we) {
        const { seconds: Ee, minutes: Me, hours: Ie } = ie.getTimeFromSeconds(Te);
        let ke = "", _e = Ie;
        return we === "12-hour" && (ke = Ie >= 12 ? "pm" : "am", _e = Ie % 12), { seconds: Ee, minutes: Me, hours: _e, ampm: ke };
      }
    }
    function se(ve, Te) {
      const we = (0, te.useRef)();
      (0, te.useEffect)(() => {
        we.current = ve;
      }), (0, te.useEffect)(() => {
        if (!Te) return () => {
        };
        const Ee = setInterval(() => {
          we.current && we.current();
        }, Te);
        return () => clearInterval(Ee);
      }, [Te]);
    }
    const de = 1e3;
    function ue(ve) {
      if (!re.expiryTimestamp(ve)) return null;
      const Te = ie.getSecondsFromExpiry(ve), we = Math.floor(1e3 * (Te - Math.floor(Te)));
      return we > 0 ? we : de;
    }
    function fe() {
      let { expiryTimestamp: ve, onExpire: Te, autoStart: we = !0 } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
      const [Ee, Me] = (0, te.useState)(ve), [Ie, ke] = (0, te.useState)(ie.getSecondsFromExpiry(Ee)), [_e, De] = (0, te.useState)(we), [Fe, Ae] = (0, te.useState)(we), [ne, oe] = (0, te.useState)(ue(Ee)), ce = (0, te.useCallback)(() => {
        re.onExpire(Te) && Te(), De(!1), oe(null);
      }, [Te]), le = (0, te.useCallback)(() => {
        De(!1);
      }, []), pe = (0, te.useCallback)(function(be) {
        let ae = !(arguments.length > 1 && arguments[1] !== void 0) || arguments[1];
        oe(ue(be)), Ae(ae), De(ae), Me(be), ke(ie.getSecondsFromExpiry(be));
      }, []), ye = (0, te.useCallback)(() => {
        const be = /* @__PURE__ */ new Date();
        be.setMilliseconds(be.getMilliseconds() + 1e3 * Ie), pe(be);
      }, [Ie, pe]), Ce = (0, te.useCallback)(() => {
        Fe ? (ke(ie.getSecondsFromExpiry(Ee)), De(!0)) : ye();
      }, [Ee, Fe, ye]);
      return se(() => {
        ne !== de && oe(de);
        const be = ie.getSecondsFromExpiry(Ee);
        ke(be), be <= 0 && ce();
      }, _e ? ne : null), { ...ie.getTimeFromSeconds(Ie), start: Ce, pause: le, resume: ye, restart: pe, isRunning: _e };
    }
    function he() {
      let { autoStart: ve, offsetTimestamp: Te } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
      const [we, Ee] = (0, te.useState)(ie.getSecondsFromExpiry(Te, !0) || 0), [Me, Ie] = (0, te.useState)(/* @__PURE__ */ new Date()), [ke, _e] = (0, te.useState)(we + ie.getSecondsFromPrevTime(Me || 0, !0)), [De, Fe] = (0, te.useState)(ve);
      se(() => {
        _e(we + ie.getSecondsFromPrevTime(Me, !0));
      }, De ? 1e3 : null);
      const Ae = (0, te.useCallback)(() => {
        const ce = /* @__PURE__ */ new Date();
        Ie(ce), Fe(!0), _e(we + ie.getSecondsFromPrevTime(ce, !0));
      }, [we]), ne = (0, te.useCallback)(() => {
        Ee(ke), Fe(!1);
      }, [ke]), oe = (0, te.useCallback)(function() {
        let ce = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0, le = !(arguments.length > 1 && arguments[1] !== void 0) || arguments[1];
        const pe = ie.getSecondsFromExpiry(ce, !0) || 0, ye = /* @__PURE__ */ new Date();
        Ie(ye), Ee(pe), Fe(le), _e(pe + ie.getSecondsFromPrevTime(ye, !0));
      }, []);
      return { ...ie.getTimeFromSeconds(ke), start: Ae, pause: ne, reset: oe, isRunning: De };
    }
    function me() {
      let { format: ve } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
      const [Te, we] = (0, te.useState)(ie.getSecondsFromTimeNow());
      return se(() => {
        we(ie.getSecondsFromTimeNow());
      }, 1e3), { ...ie.getFormattedTimeFromSeconds(Te, ve) };
    }
    function xe(ve) {
      if ((0, te.useEffect)(() => {
        console.warn("react-timer-hook: default export useTimer is deprecated, use named exports { useTimer, useStopwatch, useTime } instead");
      }, []), ve.expiryTimestamp) {
        const we = fe(ve);
        return { ...we, startTimer: we.start, stopTimer: we.pause, resetTimer: () => {
        } };
      }
      const Te = he(ve);
      return { ...Te, startTimer: Te.start, stopTimer: Te.pause, resetTimer: Te.reset };
    }
    return ee;
  })());
})(dist);
var distExports = dist.exports;
const TRACK_INTERVAL = 5e3, TRACK_INTERVAL_FAST = 1e3, TRACK_TIMEOUT = 120 * 1e3, useTrackTransfer = (C) => {
  const [e, T] = useState(!1), [$, V] = useState(!1), [J, ee] = useState(), { eta: te, route: re } = C;
  return useEffect(() => {
    C.receipt && ee(C.receipt);
  }, [C.receipt]), useEffect(() => {
    let ie = !0, se = TRACK_INTERVAL;
    return te && te < 3e4 && (se = TRACK_INTERVAL_FAST), (async () => {
      if (!re || !J)
        return;
      const ue = config$1.routes.get(re);
      if (!ue)
        return;
      const fe = await getWormholeContextV2(), he = new ue.rc(fe);
      let me = !1;
      for (; ie && !isCompleted(J) && !me; ) {
        try {
          for await (const xe of he.track(
            J,
            TRACK_TIMEOUT
          )) {
            if (!ie)
              break;
            if (xe.state !== J.state) {
              if (ee(xe), isCompleted(xe)) {
                T(!0), me = !0;
                break;
              }
              !ue.AUTOMATIC_DEPOSIT && xe.state >= TransferState.Attested && V(!0);
            }
          }
        } catch (xe) {
          console.error("Error tracking transfer:", xe), se = TRACK_INTERVAL;
        }
        await sleep(se);
      }
    })(), () => {
      ie = !1;
    };
  }, [te, J, re]), {
    isCompleted: e,
    isReadyToClaim: $,
    receipt: J
  };
}, ArrowRightIcon = createSvgIcon$1(
  /* @__PURE__ */ jsxRuntimeExports.jsx(
    "path",
    {
      d: "M4 12H20M20 12L13 5M20 12L13 19",
      fill: "none",
      stroke: "currentColor",
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  ),
  "ArrowRight"
), TxCompleteIcon = createSvgIcon$1(
  /* @__PURE__ */ jsxRuntimeExports.jsxs(
    "svg",
    {
      width: "107",
      height: "106",
      viewBox: "0 0 107 106",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M53.2079 105.5C82.2486 105.5 105.791 81.9949 105.791 53C105.791 24.0051 82.2486 0.5 53.2079 0.5C24.1672 0.5 0.625 24.0051 0.625 53C0.625 81.9949 24.1672 105.5 53.2079 105.5ZM53.207 102.097C80.3654 102.097 102.382 80.1157 102.382 53.0001C102.382 25.8844 80.3654 3.90283 53.207 3.90283C26.0485 3.90283 4.03223 25.8844 4.03223 53.0001C4.03223 80.1157 26.0485 102.097 53.207 102.097Z",
            fill: "currentColor"
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "path",
          {
            d: "M46.8789 68L32.628906 53.75L36.19141 50.1875L46.8789 60.875L69.8164 37.9375L73.3789 41.5L46.8789 68Z",
            fill: "currentColor"
          }
        )
      ]
    }
  ),
  "Alert"
), useStyles$7 = makeStyles()((C) => ({
  alertBanner: {
    marginTop: "12px"
  },
  arrowIcon: {
    fontSize: "16px",
    margin: "0 4px"
  },
  card: {
    width: "100%",
    boxShadow: `0px 0px 3.5px 0px ${C.palette.primary.main}`
  },
  cardActionArea: {
    height: "76px"
  },
  chainIcon: {
    background: C.palette.background.default,
    border: `2px solid ${C.palette.modal.background}`,
    borderRadius: "6px",
    padding: "2px"
  },
  completedIcon: {
    color: C.palette.success.main,
    height: "24px",
    width: "24px"
  },
  container: {
    width: "100%",
    maxWidth: "420px"
  },
  progressBar: {
    borderRadius: "4px",
    marginTop: "8px"
  }
})), WidgetItem = (C) => {
  var ye, Ce;
  const [e, T] = useState(""), [$, V] = useState(!1), { classes: J } = useStyles$7(), ee = useDispatch(), te = useContext(RouteContext), re = useTheme$1(), { data: ie } = C, {
    receipt: se,
    route: de,
    timestamp: ue,
    txDetails: fe,
    txHash: he
  } = ie, { amount: me, eta: xe, fromChain: ve, toChain: Te, tokenKey: we } = fe || {}, { seconds: Ee, minutes: Me, totalSeconds: Ie, isRunning: ke, restart: _e } = distExports.useTimer({
    expiryTimestamp: /* @__PURE__ */ new Date(),
    autoStart: !1,
    onExpire: () => V(!0)
  }), {
    isCompleted: De,
    isReadyToClaim: Fe,
    receipt: Ae
  } = useTrackTransfer({
    eta: xe,
    receipt: se,
    route: de
  });
  useEffect(() => {
    De && he && removeTxFromLocalStorage(he);
  }, [De, he]);
  const ne = Ae || se, oe = useMemo(() => {
    if (!xe || !ue)
      return 0;
    const be = Date.now() - ue;
    return xe < be ? 0 : xe - be;
  }, [xe, ue, Ie]), ce = useMemo(() => Fe || ie.isReadyToClaim ? "Ready to claim..." : $ || oe === 0 ? "Wrapping up..." : ke ? minutesAndSecondsWithPadding(Me, Ee) : /* @__PURE__ */ jsxRuntimeExports.jsx(CircularProgress, { size: 16 }), [
    $,
    oe,
    Fe,
    ke,
    Me,
    Ee,
    ie
  ]), le = useMemo(() => !xe || oe > xe || !$ && oe === 0 ? 0 : $ ? 100 : (xe - oe) / xe * 100, [xe, oe, De]);
  useEffect(() => {
    !ke && !De && oe && _e(new Date(Date.now() + oe), !0);
  }, [oe, De, ke]);
  const pe = useCallback(async () => {
    if (T(""), !ne) {
      T("No receipt found for this transaction");
      return;
    }
    try {
      const be = await getWormholeContextV2(), ae = new (config$1.routes.get(de)).rc(be);
      ee(setTimestamp(ue)), ee(setTxDetails(fe)), ee(setIsResumeTx(!0)), ee(setRoute$1(de)), ee(setToChain(fe.toChain)), ee(setRoute("redeem")), te.setReceipt(ne), te.setRoute(ae);
    } catch {
      T(`Error resuming transaction: ${fe.sendTx}`);
    }
  }, [ee, ne, de, te, ue, fe]);
  return ie ? /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: J.container, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(Card, { className: J.card, children: /* @__PURE__ */ jsxRuntimeExports.jsx(
      CardActionArea,
      {
        disableTouchRipple: !0,
        disabled: !fe,
        className: J.cardActionArea,
        onClick: pe,
        children: /* @__PURE__ */ jsxRuntimeExports.jsxs(CardContent, { children: [
          /* @__PURE__ */ jsxRuntimeExports.jsxs(
            Stack,
            {
              direction: "row",
              alignItems: "center",
              justifyContent: "space-between",
              children: [
                /* @__PURE__ */ jsxRuntimeExports.jsx(Typography, { display: "flex", justifyContent: "space-between", children: De ? /* @__PURE__ */ jsxRuntimeExports.jsx(TxCompleteIcon, { className: J.completedIcon }) : ce }),
                /* @__PURE__ */ jsxRuntimeExports.jsxs(Stack, { direction: "row", alignItems: "center", children: [
                  /* @__PURE__ */ jsxRuntimeExports.jsx(Typography, { fontSize: 14, marginRight: "8px", children: `${display(truncate(me, 4))} ${config$1.tokens[we].symbol}` }),
                  /* @__PURE__ */ jsxRuntimeExports.jsx(Box, { className: J.chainIcon, children: /* @__PURE__ */ jsxRuntimeExports.jsx(
                    ChainIconComponent,
                    {
                      icon: (ye = config$1.chains[ve]) == null ? void 0 : ye.icon,
                      height: 24
                    }
                  ) }),
                  /* @__PURE__ */ jsxRuntimeExports.jsx(ArrowRightIcon, { className: J.arrowIcon }),
                  /* @__PURE__ */ jsxRuntimeExports.jsx(Box, { className: J.chainIcon, children: /* @__PURE__ */ jsxRuntimeExports.jsx(ChainIconComponent, { icon: (Ce = config$1.chains[Te]) == null ? void 0 : Ce.icon, height: 24 }) })
                ] })
              ]
            }
          ),
          !De && /* @__PURE__ */ jsxRuntimeExports.jsx(
            LinearProgress,
            {
              className: J.progressBar,
              variant: "determinate",
              value: le
            }
          )
        ] })
      }
    ) }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      AlertBanner,
      {
        className: J.alertBanner,
        color: e ? re.palette.error.light : re.palette.grey.A400,
        content: e,
        error: !!e,
        show: !!e
      }
    )
  ] }) : /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, {});
}, useStyles$6 = makeStyles()((C) => ({
  container: {
    width: "100%",
    maxWidth: "420px"
  },
  card: {
    width: "100%",
    boxShadow: `0px 0px 3.5px 0px ${C.palette.primary.main}`
  },
  cardHeader: {
    paddingBottom: 0
  },
  spacer: {
    display: "flex",
    flexDirection: "column",
    gap: "16px",
    marginBottom: "16px",
    alignItems: "center",
    justifyContent: "center",
    width: "100%"
  },
  txHistoryHeader: {
    width: "100%",
    display: "flex",
    alignItems: "center"
  }
})), TxHistoryWidget = () => {
  const { classes: C } = useStyles$6(), e = useTheme$1(), [T, $] = useState();
  return useEffect(() => {
    $(getTxsFromLocalStorage());
  }, []), !T || T.length === 0 ? /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, {}) : /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: C.spacer, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: C.txHistoryHeader, children: /* @__PURE__ */ jsxRuntimeExports.jsx(Typography, { color: e.palette.text.secondary, fontSize: 14, children: "Transactions in progress" }) }),
    T.map((V) => /* @__PURE__ */ jsxRuntimeExports.jsx(WidgetItem, { data: V }, V.txHash))
  ] });
}, QUOTE_REFRESH_INTERVAL = 2e4, MAYAN_BETA_LIMIT = 1e4, MAYAN_BETA_PROTOCOLS = ["MCTP", "SWIFT"], useRoutesQuotesBulk = (C, e) => {
  var xe;
  const [T, $] = useState((/* @__PURE__ */ new Date()).valueOf()), [V, J] = useState(null), [ee, te] = useState(!1), [re, ie] = useState([]), se = config$1.tokens[e.sourceToken], de = config$1.tokens[e.destToken], { usdPrices: ue } = useSelector((ve) => ve.tokenPrices), { isTransactionInProgress: fe } = useSelector(
    (ve) => ve.transferInput
  ), he = calculateUSDPriceRaw(
    e.amount,
    ue.data,
    se
  );
  useEffect(() => {
    let ve = !1;
    if (!e.sourceChain || !e.sourceToken || !e.destChain || !e.destToken || !e.amount || C.length === 0)
      return;
    const Te = e, we = () => {
      const Ee = setTimeout(
        () => $((/* @__PURE__ */ new Date()).valueOf()),
        QUOTE_REFRESH_INTERVAL
      );
      J(Ee);
    };
    return fe ? we() : (te(!0), config$1.routes.getQuotes(C, Te).then((Ee) => {
      ve || (ie(Ee), te(!1), we());
    })), () => {
      ve = !0, V && clearTimeout(V);
    };
  }, [
    // eslint-disable-next-line react-hooks/exhaustive-deps
    C.join(),
    // .join() is necessary to prevent unnecessary updates when routes array's ref changed but its content did not
    e.sourceChain,
    e.sourceToken,
    e.destChain,
    e.destToken,
    e.amount,
    e.nativeGas,
    T,
    fe,
    e
  ]);
  const me = useMemo(
    () => C.reduce((ve, Te, we) => (ve[Te] = re[we], ve), {}),
    // Important: We should not include routes property in deps. See routes.join() below.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
      // eslint-disable-next-line react-hooks/exhaustive-deps
      C.join(),
      // .join() is necessary to prevent unnecessary updates when routes array's ref changed but its content did not
      re
    ]
  );
  for (const ve in me) {
    const Te = me[ve];
    if (Te !== void 0 && Te.success) {
      const we = calculateUSDPriceRaw(
        Te.destinationToken.amount,
        ue.data,
        de
      );
      if (he && we) {
        const Ee = we / he;
        he >= 1e3 && Ee <= 0.9 && delete me[ve];
      }
    }
  }
  for (const ve in me)
    if (ve.startsWith("MayanSwap")) {
      const Te = me[ve];
      if (Te !== void 0 && Te.success && MAYAN_BETA_PROTOCOLS.includes((xe = Te.details) == null ? void 0 : xe.type.toUpperCase()))
        if (he !== void 0 && he > MAYAN_BETA_LIMIT)
          me[ve] = {
            success: !1,
            error: new Error(
              `Amount exceeds limit of $${MAYAN_BETA_LIMIT} USD`
            )
          };
        else {
          const we = calculateUSDPriceRaw(
            e.amount,
            ue.data,
            se
          ), Ee = calculateUSDPriceRaw(
            Te.destinationToken.amount,
            ue.data,
            config$1.tokens[e.destToken]
          );
          if (we && Ee) {
            const Me = we - Ee;
            !isNaN(Me) && Me > 0 && (me[ve].relayFee = {
              token: {
                chain: "Solana",
                address: Wormhole.parseAddress(
                  "Solana",
                  usdcContract.get("Mainnet", "Solana")
                )
              },
              amount: parse$3(
                denoise(Me, 6),
                6
              )
            });
          }
        }
    }
  return {
    quotesMap: me,
    isFetching: ee
  };
}, useSortedRoutesWithQuotes = () => {
  const { amount: C, fromChain: e, token: T, toChain: $, destToken: V, preferredRouteName: J } = useSelector((me) => me.transferInput), { toNativeToken: ee } = useSelector((me) => me.relay), { supportedRoutes: te, isFetching: re } = useFetchSupportedRoutes(), ie = useMemo(
    () => ({
      amount: C,
      sourceChain: e,
      sourceToken: T,
      destChain: $,
      destToken: V,
      nativeGas: ee
    }),
    [C, e, T, $, V, ee]
  ), { quotesMap: se, isFetching: de } = useRoutesQuotesBulk(
    te,
    ie
  ), ue = useMemo(() => te.map((me) => {
    const xe = se[me];
    if (xe != null && xe.success)
      return {
        route: me,
        quote: xe
      };
  }).filter(Boolean), [te, se]), fe = useMemo(() => bucketByEta(ue).map((me) => me.sort((xe, ve) => {
    const Te = config$1.routes.get(xe.route), we = config$1.routes.get(ve.route);
    if (J) {
      if (xe.route === J)
        return -1;
      if (ve.route === J)
        return 1;
    }
    if (Te.AUTOMATIC_DEPOSIT && !we.AUTOMATIC_DEPOSIT)
      return -1;
    if (!Te.AUTOMATIC_DEPOSIT && we.AUTOMATIC_DEPOSIT)
      return 1;
    const Ee = BigInt(
      xe.quote.destinationToken.amount.amount
    ), Me = BigInt(
      ve.quote.destinationToken.amount.amount
    );
    return Number(Me - Ee);
  })).flat(), [J, ue]), he = useMemo(
    () => fe.map((me) => me.route),
    [fe]
  );
  return useMemo(
    () => ({
      allSupportedRoutes: te,
      sortedRoutes: he,
      sortedRoutesWithQuotes: fe,
      quotesMap: se,
      isFetching: re || de
    }),
    [
      te,
      he,
      fe,
      se,
      re,
      de
    ]
  );
}, bucketByEta = (C) => {
  const e = [6e4, 1 / 0], T = [];
  for (let $ = 0; $ < e.length; $++)
    T.push([]);
  for (const $ of C) {
    const { quote: V } = $;
    for (let J = 0; J < e.length; J++) {
      const ee = e[J];
      if ((V.eta ?? 1 / 0) <= ee) {
        T[J].push($);
        break;
      }
    }
  }
  return T;
}, COINGECKO_URL = "https://api.coingecko.com/", COINGECKO_URL_PRO = "https://pro-api.coingecko.com/", useFetchTokenPrices = () => {
  const C = useDispatch();
  useEffect(() => {
    let e = !1;
    const T = new AbortController(), $ = T.signal, V = Object.values(config$1.tokens).filter((te) => !!te.coinGeckoId).map(({ coinGeckoId: te }) => te).join(","), J = new Headers({
      "Content-Type": "application/json",
      ...config$1.coinGeckoApiKey ? { "x-cg-pro-api-key": config$1.coinGeckoApiKey } : {}
    });
    return (async () => {
      for (C(setFetchingPrices()); !e; ) {
        let te = 3e5;
        try {
          const ie = await (await fetch(
            `${config$1.coinGeckoApiKey ? COINGECKO_URL_PRO : COINGECKO_URL}api/v3/simple/price?ids=${V}&vs_currencies=usd${config$1.coinGeckoApiKey ? `&x_cg_pro_api_key=${config$1.coinGeckoApiKey}` : ""}`,
            { signal: $, headers: J }
          )).json();
          e || C(setPrices(ie));
        } catch (re) {
          e || C(setPricesError(`Error fetching token prices: ${re}`)), te = 30 * 1e3;
        }
        await sleep(te);
      }
    })(), () => {
      e = !0, T.abort();
    };
  }, []);
}, useAmountValidation = (C) => {
  const { amount: e } = useSelector((V) => V.transferInput), T = useMemo(
    () => Object.values(C.quotesMap).reduce((V, J) => {
      if (J != null && J.success || !isMinAmountError(J == null ? void 0 : J.error))
        return V;
      if (!V)
        return J.error.min;
      const ee = BigInt(J.error.min.amount), te = BigInt(V.amount);
      return ee < te ? J.error.min : V;
    }, void 0),
    [C.quotesMap]
  ), $ = useMemo(() => Object.keys(C.quotesMap).length === 0 ? !1 : C.routes.every((V) => {
    var J;
    return ((J = C.quotesMap[V]) == null ? void 0 : J.success) === !1;
  }), [C.routes, C.quotesMap]);
  return !e || C.disabled ? {} : C.balance && units(e) > units(C.balance) ? {
    error: "Amount exceeds available balance."
  } : $ ? T ? {
    error: `Amount too small (min ~${display(T)} ${C.tokenSymbol})`
  } : {
    error: "No routes found for this transaction."
  } : T ? {
    warning: `More routes available for amounts exceeding ${display(T)} ${C.tokenSymbol}`
  } : {};
}, useStyles$5 = makeStyles()((C) => ({
  assetPickerContainer: {
    width: "100%",
    position: "relative"
  },
  assetPickerTitle: {
    color: C.palette.text.secondary,
    display: "flex",
    minHeight: "40px",
    alignItems: "center",
    justifyContent: "space-between"
  },
  bridgeContent: {
    margin: "auto",
    maxWidth: "420px"
  },
  bridgeHeader: {
    width: "100%",
    display: "flex",
    alignItems: "center"
  },
  ctaContainer: {
    marginTop: "8px",
    width: "100%"
  },
  header: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    width: "100%"
  },
  reviewTransaction: {
    padding: "8px 16px",
    borderRadius: "8px",
    height: "48px",
    margin: "auto",
    maxWidth: "420px",
    width: "100%"
  },
  spacer: {
    display: "flex",
    flexDirection: "column",
    gap: "8px",
    alignItems: "center",
    justifyContent: "center",
    width: "100%"
  }
})), Bridge = () => {
  var Ye, Je;
  const { classes: C } = useStyles$5(), e = useTheme$1(), T = useDispatch(), $ = useMediaQuery(e.breakpoints.down("sm")), { sending: V, receiving: J } = useSelector(
    (Xe) => Xe.wallet
  ), [ee, te] = useState(), [re, ie] = useState(!1), {
    fromChain: se,
    toChain: de,
    token: ue,
    destToken: fe,
    route: he,
    preferredRouteName: me,
    supportedDestTokens: xe,
    supportedSourceTokens: ve,
    amount: Te,
    validations: we
  } = useSelector((Xe) => Xe.transferInput), {
    allSupportedRoutes: Ee,
    sortedRoutes: Me,
    sortedRoutesWithQuotes: Ie,
    quotesMap: ke,
    isFetching: _e
  } = useSortedRoutesWithQuotes(), { isFetching: De } = useComputeSourceTokens({
    sourceChain: se,
    destChain: de,
    sourceToken: ue,
    destToken: fe,
    route: ee
  }), { isFetching: Fe } = useComputeDestinationTokens({
    sourceChain: se,
    destChain: de,
    sourceToken: ue,
    route: ee
  });
  useEffect(() => {
    if (Ie.length === 0)
      te("");
    else {
      const Xe = Ie.find(
        (ot) => ot.route === me
      ), st = he ?? (Xe == null ? void 0 : Xe.route) ?? Ie[0].route, ct = Ie.findIndex((ot) => ot.route === ee) > -1;
      if (ct || te(""), !st || ee && ct)
        return;
      const it = Ie == null ? void 0 : Ie.find(
        (ot) => ot.route === st
      );
      it && te(it.route);
    }
  }, [he, Ie]), useFetchSupportedRoutes(), useConnectToLastUsedWallet(), useValidate(), useFetchTokenPrices();
  const Ae = useMemo(() => ue ? [config$1.tokens[ue]] : [], [ue]), { balances: ne, isFetching: oe } = useGetTokenBalances(
    (V == null ? void 0 : V.address) || "",
    se,
    Ae
  ), ce = !V.address || !J.address || !se || !ue || !de || !fe, le = useAmountValidation({
    balance: (Ye = ne[ue]) == null ? void 0 : Ye.balance,
    routes: Ee,
    quotesMap: ke,
    tokenSymbol: ((Je = config$1.tokens[ue]) == null ? void 0 : Je.symbol) ?? "",
    isLoading: oe || _e,
    disabled: ce
  }), pe = useMemo(() => isTransferValid(we), [we]), ye = useMemo(
    () => config$1.routes.allSupportedChains(),
    [config$1.chainsArr]
  ), Ce = useMemo(() => config$1.chainsArr.filter((Xe) => Xe.key !== de && !Xe.disabledAsSource && ye.includes(Xe.key)), [config$1.chainsArr, de, ye]), be = useMemo(() => config$1.chainsArr.filter(
    (Xe) => Xe.key !== se && !Xe.disabledAsDestination && ye.includes(Xe.key)
  ), [config$1.chainsArr, se, ye]), ae = useMemo(() => se && ue ? xe : config$1.tokensArr.filter(
    (Xe) => {
      var st;
      return Xe.nativeChain === de || ((st = Xe.tokenId) == null ? void 0 : st.chain) === de;
    }
  ), [de, se, ue, xe]), ge = useMemo(() => {
    const Xe = {
      text: "",
      align: "left"
    };
    let st;
    return typeof config$1.ui.pageHeader == "string" ? st = { ...Xe, text: config$1.ui.pageHeader } : st = { ...Xe, ...config$1.ui.pageHeader }, /* @__PURE__ */ jsxRuntimeExports.jsx(PageHeader, { title: st.text, align: st.align });
  }, [config$1.ui]), Se = useMemo(() => /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: C.assetPickerContainer, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: C.assetPickerTitle, children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(Typography, { variant: "body2", children: "From" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(ConnectedWallet, { type: TransferWallet.SENDING })
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      AssetPicker,
      {
        chain: se,
        chainList: Ce,
        token: ue,
        tokenList: ve,
        isFetching: De,
        setChain: (Xe) => {
          selectFromChain(T, Xe, V);
        },
        setToken: (Xe) => {
          T(setToken(Xe));
        },
        wallet: V,
        isSource: !0
      }
    ),
    /* @__PURE__ */ jsxRuntimeExports.jsx(SwapInputs, {})
  ] }), [
    se,
    Ce,
    ue,
    ve,
    V,
    De
  ]), Le = useMemo(() => /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: C.assetPickerContainer, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: C.assetPickerTitle, children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(Typography, { variant: "body2", children: "To" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(ConnectedWallet, { type: TransferWallet.RECEIVING })
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      AssetPicker,
      {
        chain: de,
        chainList: be,
        token: fe,
        sourceToken: ue,
        tokenList: ae,
        isFetching: Fe,
        setChain: (Xe) => {
          selectToChain(T, Xe, J);
        },
        setToken: (Xe) => {
          T(setDestToken(Xe));
        },
        wallet: J,
        isSource: !1
      }
    )
  ] }), [
    de,
    be,
    fe,
    ae,
    J,
    Fe
  ]), ze = useMemo(() => {
    const Xe = !(V != null && V.address);
    return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: C.bridgeHeader, children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        Header,
        {
          align: "left",
          text: config$1.ui.title ?? "Wormhole Connect",
          size: 18
        }
      ),
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        Tooltip,
        {
          title: Xe ? "No connected wallets found" : "",
          children: /* @__PURE__ */ jsxRuntimeExports.jsx("span", { children: /* @__PURE__ */ jsxRuntimeExports.jsx(
            IconButton,
            {
              sx: { padding: 0 },
              disabled: Xe,
              onClick: () => T(setRoute("history")),
              children: /* @__PURE__ */ jsxRuntimeExports.jsx(default_1$b, {})
            }
          ) })
        }
      )
    ] });
  }, [V == null ? void 0 : V.address, config$1.ui]), Re = useMemo(() => V != null && V.address && (J != null && J.address) ? null : V != null && V.address && !(J != null && J.address) ? /* @__PURE__ */ jsxRuntimeExports.jsx(
    WalletConnector,
    {
      disabled: !de,
      side: "destination",
      type: TransferWallet.RECEIVING
    }
  ) : /* @__PURE__ */ jsxRuntimeExports.jsx(
    WalletConnector,
    {
      disabled: !se,
      side: "source",
      type: TransferWallet.SENDING
    }
  ), [se, de, V, J]), We = !!le.error, Be = Te && whole(Te) > 0, Ue = V.address && J.address, Ge = Ue && Be && !We, je = !se || !ue || !de || !fe || !Ue || !ee || !pe || _e || !Be || We, Oe = /* @__PURE__ */ jsxRuntimeExports.jsx(
    Button,
    {
      variant: "primary",
      className: C.reviewTransaction,
      disabled: je,
      onClick: () => {
        T(setTransferRoute(ee)), ie(!0);
      },
      children: /* @__PURE__ */ jsxRuntimeExports.jsx(Typography, { textTransform: "none", children: $ ? "Review" : "Review transaction" })
    }
  ), Ne = !se || !ue ? "Please select a source asset" : !de || !fe ? "Please select a destination asset" : Be ? _e ? "Loading quotes..." : ee ? "" : "Please select a quote" : "Please enter an amount";
  return re ? /* @__PURE__ */ jsxRuntimeExports.jsx(
    ReviewTransaction,
    {
      quotes: ke,
      isFetchingQuotes: _e,
      onClose: () => ie(!1)
    }
  ) : /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: joinClass([C.bridgeContent, C.spacer]), children: [
    ge,
    config$1.ui.showInProgressWidget && /* @__PURE__ */ jsxRuntimeExports.jsx(TxHistoryWidget, {}),
    ze,
    Se,
    Le,
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      AmountInput,
      {
        supportedSourceTokens: ve,
        error: le.error,
        warning: le.warning
      }
    ),
    Ge && /* @__PURE__ */ jsxRuntimeExports.jsx(
      Routes,
      {
        routes: Me,
        selectedRoute: ee,
        onRouteChange: te,
        quotes: ke,
        isLoading: _e || oe,
        hasError: We
      }
    ),
    /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: C.ctaContainer, children: Ue ? /* @__PURE__ */ jsxRuntimeExports.jsx(Tooltip, { title: Ne, children: /* @__PURE__ */ jsxRuntimeExports.jsx("span", { children: Oe }) }) : Re }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(PoweredByIcon, { color: e.palette.text.primary }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(FooterNavBar, {})
  ] });
}, useStyles$4 = makeStyles()((C) => ({
  container: {
    width: "100%",
    maxWidth: "420px"
  },
  card: {
    width: "100%"
  }
})), TransactionDetails = () => {
  const { classes: C } = useStyles$4(), e = useTheme$1(), T = React__default.useContext(RouteContext), {
    sendTx: $,
    sender: V,
    amount: J,
    recipient: ee,
    toChain: te,
    fromChain: re,
    tokenKey: ie,
    receivedTokenKey: se,
    receiveAmount: de,
    receiveNativeAmount: ue,
    relayerFee: fe,
    eta: he
  } = useSelector((De) => De.redeem.txData), { route: me } = useSelector((De) => De.redeem), { usdPrices: xe } = useSelector(
    (De) => De.tokenPrices
  ), ve = useMemo(
    () => /* @__PURE__ */ jsxRuntimeExports.jsx(Typography, { component: "span", padding: "0px 8px", children: "·" }),
    []
  ), Te = useMemo(() => {
    if (!ie || !re)
      return /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, {});
    const De = config$1.tokens[ie], Fe = config$1.chains[re], Ae = calculateUSDPrice(
      J,
      xe.data,
      De
    ), ne = V ? trimAddress(V) : "", oe = display(truncate(J, 6));
    return /* @__PURE__ */ jsxRuntimeExports.jsxs(Stack, { alignItems: "center", direction: "row", justifyContent: "flex-start", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        AssetBadge,
        {
          chainConfig: Fe,
          tokenConfig: De
        }
      ),
      /* @__PURE__ */ jsxRuntimeExports.jsxs(Stack, { direction: "column", marginLeft: "12px", children: [
        /* @__PURE__ */ jsxRuntimeExports.jsxs(Typography, { fontSize: 16, children: [
          oe,
          " ",
          De.symbol
        ] }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(Typography, { color: e.palette.text.secondary, fontSize: 14, children: xe.isFetching ? /* @__PURE__ */ jsxRuntimeExports.jsx(CircularProgress, { size: 14 }) : /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
          Ae,
          ve,
          Fe.displayName,
          ve,
          ne
        ] }) })
      ] })
    ] });
  }, [
    J,
    re,
    V,
    ve,
    e.palette.text.secondary,
    ie,
    xe.data,
    xe.isFetching
  ]), we = useMemo(() => {
    if (!se || !te)
      return /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, {});
    const De = config$1.tokens[se], Fe = config$1.chains[te], Ae = calculateUSDPrice(
      de,
      xe.data,
      De
    ), ne = ee ? trimAddress(ee) : "", oe = de ? display(truncate(de, 6)) : "-";
    return /* @__PURE__ */ jsxRuntimeExports.jsxs(Stack, { alignItems: "center", direction: "row", justifyContent: "flex-start", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        AssetBadge,
        {
          chainConfig: Fe,
          tokenConfig: De
        }
      ),
      /* @__PURE__ */ jsxRuntimeExports.jsxs(Stack, { direction: "column", marginLeft: "12px", children: [
        /* @__PURE__ */ jsxRuntimeExports.jsxs(Typography, { fontSize: 16, children: [
          oe,
          " ",
          De.symbol
        ] }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(Typography, { color: e.palette.text.secondary, fontSize: 14, children: xe.isFetching ? /* @__PURE__ */ jsxRuntimeExports.jsx(CircularProgress, { size: 14 }) : /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
          Ae,
          ve,
          Fe.displayName,
          ve,
          ne
        ] }) })
      ] })
    ] });
  }, [
    de,
    se,
    ee,
    ve,
    e.palette.text.secondary,
    te,
    xe.data,
    xe.isFetching
  ]), Ee = useMemo(
    () => /* @__PURE__ */ jsxRuntimeExports.jsx(
      Stack,
      {
        height: "28px",
        borderLeft: "1px solid #8B919D",
        marginLeft: "16px"
      }
    ),
    []
  ), Me = useMemo(() => {
    if (!fe)
      return /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, {});
    const De = config$1.tokens[fe.tokenKey];
    if (!De)
      return /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, {});
    const Fe = calculateUSDPrice(
      fe.fee,
      xe.data,
      De
    );
    if (!Fe)
      return /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, {});
    let Ae = /* @__PURE__ */ jsxRuntimeExports.jsx(Typography, { fontSize: 14, children: `${toFixedDecimals(
      fe.fee.toString(),
      4
    )} ${De.symbol} (${Fe})` });
    return me != null && me.startsWith("MayanSwap") && (Ae = /* @__PURE__ */ jsxRuntimeExports.jsx(Typography, { fontSize: 14, children: Fe })), /* @__PURE__ */ jsxRuntimeExports.jsxs(Stack, { direction: "row", justifyContent: "space-between", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(Typography, { color: e.palette.text.secondary, fontSize: 14, children: "Network cost" }),
      xe.isFetching ? /* @__PURE__ */ jsxRuntimeExports.jsx(CircularProgress, { size: 14 }) : Ae
    ] });
  }, [
    fe,
    me,
    e.palette.text.secondary,
    xe.data,
    xe.isFetching
  ]), Ie = useMemo(() => {
    if (!se || !ue || units(ue) === 0n)
      return /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, {});
    const De = config$1.chains[te];
    if (!De)
      return /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, {});
    const Fe = calculateUSDPrice(
      ue,
      xe.data,
      config$1.tokens[De.gasToken]
    );
    return /* @__PURE__ */ jsxRuntimeExports.jsxs(Stack, { direction: "row", justifyContent: "space-between", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(Typography, { color: e.palette.text.secondary, fontSize: 14, children: "Additional gas" }),
      xe.isFetching ? /* @__PURE__ */ jsxRuntimeExports.jsx(CircularProgress, { size: 14 }) : /* @__PURE__ */ jsxRuntimeExports.jsx(Typography, { fontSize: 14, children: Fe })
    ] });
  }, [
    ue,
    se,
    e.palette.text.secondary,
    te,
    xe.data,
    xe.isFetching
  ]), ke = useMemo(() => {
    const De = T.route ?? me;
    if (!De)
      return null;
    const { name: Fe, url: Ae } = getExplorerInfo(De, $);
    return /* @__PURE__ */ jsxRuntimeExports.jsx(Stack, { alignItems: "center", padding: "24px 12px", children: /* @__PURE__ */ jsxRuntimeExports.jsx(
      Link,
      {
        display: "flex",
        gap: "8px",
        href: Ae,
        rel: "noreferrer",
        target: "_blank",
        underline: "none",
        children: /* @__PURE__ */ jsxRuntimeExports.jsx(
          Typography,
          {
            color: e.palette.text.primary,
            fontSize: 14,
            children: `View on ${Fe}`
          }
        )
      }
    ) });
  }, [T.route, me, $, e.palette.text.primary]), _e = useMemo(() => {
    let De = /* @__PURE__ */ jsxRuntimeExports.jsx(CircularProgress, { size: 14 });
    return he ? (De = millisToHumanString(he), /* @__PURE__ */ jsxRuntimeExports.jsxs(Stack, { direction: "row", justifyContent: "space-between", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(Typography, { color: e.palette.text.secondary, fontSize: 14, children: `Time to ${te}` }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(Typography, { fontSize: 14, children: De })
    ] })) : null;
  }, [he, e.palette.text.secondary, te]);
  return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: C.container, children: /* @__PURE__ */ jsxRuntimeExports.jsxs(Card, { className: C.card, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsxs(CardContent, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        Typography,
        {
          color: e.palette.text.secondary,
          marginBottom: "12px",
          children: `Transaction #${trimTxHash($)}`
        }
      ),
      Te,
      Ee,
      we,
      /* @__PURE__ */ jsxRuntimeExports.jsxs(
        Stack,
        {
          direction: "column",
          gap: "8px",
          justifyContent: "space-between",
          marginTop: "16px",
          children: [
            Me,
            Ie,
            _e
          ]
        }
      )
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Divider, { flexItem: !0, sx: { margin: "0 16px", opacity: "50%" } }),
    ke
  ] }) });
}, TxWarning = createSvgIcon$1(
  /* @__PURE__ */ jsxRuntimeExports.jsx(
    "svg",
    {
      width: "107",
      height: "107",
      viewBox: "0 0 107 107",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: /* @__PURE__ */ jsxRuntimeExports.jsx(
        "path",
        {
          d: "M53.5 36.625V57.7188M104.125 53.5C104.125 60.1482 102.816 66.7312 100.271 72.8733C97.7273 79.0155 93.9982 84.5963 89.2973 89.2973C84.5963 93.9982 79.0155 97.7273 72.8733 100.271C66.7312 102.816 60.1482 104.125 53.5 104.125C46.8518 104.125 40.2688 102.816 34.1267 100.271C27.9845 97.7273 22.4037 93.9982 17.7027 89.2973C13.0018 84.5963 9.27274 79.0155 6.7286 72.8733C4.18445 66.7312 2.875 60.1482 2.875 53.5C2.875 40.0734 8.20869 27.1967 17.7027 17.7027C27.1967 8.20869 40.0734 2.875 53.5 2.875C66.9266 2.875 79.8032 8.20869 89.2973 17.7027C98.7913 27.1967 104.125 40.0734 104.125 53.5ZM53.5 74.5938H53.545V74.6388H53.5V74.5938Z",
          stroke: "currentColor",
          strokeWidth: "4",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      )
    }
  ),
  "Alert"
), TxFailedIcon = createSvgIcon$1(
  /* @__PURE__ */ jsxRuntimeExports.jsxs(
    "svg",
    {
      width: "106",
      height: "106",
      viewBox: "0 0 106 106",
      stroke: "none",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M52.5829 105C81.6236 105 105.166 81.4949 105.166 52.5C105.166 23.5051 81.6236 0 52.5829 0C23.5422 0 0 23.5051 0 52.5C0 81.4949 23.5422 105 52.5829 105ZM52.582 101.597C79.7404 101.597 101.757 79.6157 101.757 52.5001C101.757 25.3844 79.7404 3.40283 52.582 3.40283C25.4235 3.40283 3.40723 25.3844 3.40723 52.5001C3.40723 79.6157 25.4235 101.597 52.582 101.597Z",
            fill: "currentColor"
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "path",
          {
            d: "M65.7583 39.2417L39.2418 65.7582",
            stroke: "currentColor",
            strokeWidth: "4"
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "path",
          {
            d: "M39.2417 39.2417L65.7582 65.7582",
            stroke: "currentColor",
            strokeWidth: "4"
          }
        )
      ]
    }
  ),
  "Alert"
), TxReadyForClaimIcon = createSvgIcon$1(
  /* @__PURE__ */ jsxRuntimeExports.jsxs(
    "svg",
    {
      width: "107",
      height: "106",
      viewBox: "0 0 107 106",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            fill: "currentColor",
            d: "M53.2,105.5c29,0,52.6-23.5,52.6-52.5S82.2.5,53.2.5.6,24,.6,53s23.5,52.5,52.6,52.5ZM53.2,102.1c27.2,0,49.2-22,49.2-49.1S80.4,3.9,53.2,3.9,4,25.9,4,53s22,49.1,49.2,49.1Z"
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx("rect", { fill: "currentColor", x: "51", y: "28.8", width: "5", height: "42.6" }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "rect",
          {
            fill: "currentColor",
            x: "48",
            y: "63.9",
            width: "25.5",
            height: "5",
            transform: "translate(-29.2 62.4) rotate(-45)"
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "rect",
          {
            fill: "currentColor",
            x: "43.8",
            y: "53.7",
            width: "5",
            height: "25.5",
            transform: "translate(-33.4 52.2) rotate(-45)"
          }
        )
      ]
    }
  ),
  "Alert"
), useStyles$3 = makeStyles()((C, { transitionDuration: e }) => ({
  spacer: {
    display: "flex",
    flexDirection: "column",
    gap: "16px",
    alignItems: "center",
    justifyContent: "center",
    width: "100%"
  },
  container: {
    margin: "auto",
    maxWidth: "650px"
  },
  header: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    width: "100%"
  },
  actionButton: {
    padding: "12px 16px",
    backgroundColor: C.palette.primary.main,
    borderRadius: "8px",
    margin: "auto",
    maxWidth: "420px",
    width: "100%"
  },
  backButton: {
    alignItems: "start",
    maxWidth: "420px",
    width: "100%"
  },
  claimButton: {
    backgroundColor: C.palette.warning.light,
    color: C.palette.warning.contrastText ?? C.palette.background.default,
    "&:hover": {
      backgroundColor: C.palette.warning.main
    }
  },
  circularProgressCircleIndeterminite: {
    stroke: "url(#circularGradient)",
    strokeDasharray: "100px, 200px",
    strokeLinecap: "round"
  },
  circularProgressCircleDeterminite: {
    strokeLinecap: "round",
    transitionDuration: e,
    transitionProperty: "all",
    transitionTimingFunction: "linear"
  },
  circularProgressRoot: {
    animationDuration: "1s"
  },
  errorBox: {
    maxWidth: "420px"
  },
  txStatusIcon: {
    width: "105px",
    height: "105px"
  },
  delayText: {
    maxWidth: "420px"
  }
})), Redeem = () => {
  const C = useDispatch(), e = useTheme$1(), [T, $] = useState(""), [V, J] = useState(!1), [ee, te] = useState(!1), [re, ie] = useState(!1), [se, de] = useState(!1), ue = React__default.useContext(RouteContext);
  useConnectToLastUsedWallet();
  const {
    route: fe,
    timestamp: he,
    isResumeTx: me,
    txData: xe
  } = useSelector((ct) => ct.redeem), [ve, Te] = useState(void 0), { receipt: we } = ue, Ee = we && isAttested(we), Me = we && isRefunded(we), Ie = we && isFailed(we) || !!ve, ke = we && isDestinationQueued(we), {
    recipient: _e,
    toChain: De,
    fromChain: Fe,
    tokenKey: Ae,
    receivedTokenKey: ne,
    amount: oe,
    eta: ce = 0
  } = xe, le = useUSDamountGetter(), pe = useTrackTransfer({
    receipt: we,
    route: fe
  }), ye = we && isCompleted(we) || pe.isCompleted;
  useEffect(() => {
    pe.receipt && ue.setReceipt(pe.receipt);
  }, [ue, pe.receipt]);
  const Ce = useMemo(() => {
    if (!fe)
      return !1;
    const ct = config$1.routes.get(fe);
    return ct ? ct.AUTOMATIC_DEPOSIT : !1;
  }, [fe]), be = getTransferDetails(
    fe,
    Ae,
    ne,
    Fe,
    De,
    oe,
    le
  );
  useEffect(() => {
    const { receipt: ct } = ue;
    if (ct)
      if (ye)
        ee || (te(!0), config$1.triggerEvent({
          type: "transfer.success",
          details: be
        }), Ce || config$1.triggerEvent({
          type: "transfer.redeem.success",
          details: be
        }), J(!1), $(""), xe != null && xe.sendTx && removeTxFromLocalStorage(xe == null ? void 0 : xe.sendTx));
      else if (Me)
        config$1.triggerEvent({
          type: "transfer.refunded",
          details: be
        });
      else if (isFailed(ct)) {
        const [it, ot] = interpretTransferError(
          ct.error,
          be
        );
        $(it), config$1.triggerEvent({
          type: "transfer.error",
          details: be,
          error: ot
        }), console.error(
          `Transfer failed with error ${ot}: ${ct.error}`
        ), J(!1);
      } else if (ve) {
        const [it, ot] = interpretTransferError(
          ve,
          be
        );
        $(it), config$1.triggerEvent({
          type: "transfer.redeem.error",
          details: be,
          error: ot
        }), console.error(
          `Error while manually redeeming: ${ot.type} - ${ve}`
        ), J(!1);
      } else Ee && !Ce && (xe != null && xe.sendTx) && updateTxInLocalStorage(xe == null ? void 0 : xe.sendTx, "isReadyToClaim", !0);
  }, [
    we == null ? void 0 : we.state,
    ye,
    Me,
    Ee,
    ve,
    ee
  ]);
  const ae = useSelector(
    (ct) => ct.wallet.receiving
  ), { seconds: ge, minutes: Se, isRunning: Le, restart: ze } = distExports.useTimer({
    expiryTimestamp: /* @__PURE__ */ new Date(),
    autoStart: !1,
    onExpire: () => ie(!0)
  });
  useEffect(() => {
    !he || !ce || Le || ze(new Date(he + ce), !0);
  }, [ce, Le, ze, he]);
  const Re = useMemo(() => {
    const ct = he + ce, it = Date.now();
    return ct > it ? ct - it : 0;
  }, [he, ce]), { classes: We } = useStyles$3({
    transitionDuration: `${Re}ms`
  }), Be = useMemo(() => {
    const ct = {
      text: "",
      align: "left"
    };
    let it;
    return typeof config$1.ui.pageHeader == "string" ? it = { ...ct, text: config$1.ui.pageHeader } : it = { ...ct, ...config$1.ui.pageHeader }, /* @__PURE__ */ jsxRuntimeExports.jsx(PageHeader, { title: it.text, align: it.align });
  }, []), Ue = useMemo(() => {
    let ct = "Transaction submitted";
    return ye ? ct = "Transaction complete" : Me ? ct = "Transaction was refunded" : Ie ? ct = "Transaction failed" : ke ? ct = "Transaction delayed" : Ee && !Ce && (ct = `Ready to claim on ${De}`), /* @__PURE__ */ jsxRuntimeExports.jsx(Stack, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(Typography, { fontSize: 18, children: ct }) });
  }, [
    ye,
    Me,
    Ie,
    ke,
    Ee,
    Ce,
    De
  ]), Ge = useMemo(() => {
    if (re)
      return /* @__PURE__ */ jsxRuntimeExports.jsx(Stack, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(Typography, { color: e.palette.text.secondary, fontSize: 14, children: "Wrapping up..." }) });
    const ct = Le ? minutesAndSecondsWithPadding(Se, ge) : null;
    let it = /* @__PURE__ */ jsxRuntimeExports.jsx(CircularProgress, { size: 14 });
    return ce && (it = millisToMinutesAndSeconds(ce)), /* @__PURE__ */ jsxRuntimeExports.jsxs(Stack, { alignItems: "center", justifyContent: "center", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsxs(Typography, { color: e.palette.text.secondary, fontSize: 14, children: [
        "ETA ",
        it
      ] }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(Typography, { fontSize: 28, children: ct })
    ] });
  }, [
    ce,
    re,
    Le,
    Se,
    ge,
    e.palette.text.secondary
  ]), je = useMemo(() => {
    if (ce) {
      if (Le || Re === 0)
        return 100;
      const it = (ce - Re) / ce;
      return Math.floor(it * 100);
    }
    return 0;
  }, [ce, Re, Le]), Oe = useMemo(() => /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("svg", { width: 0, height: 0, children: /* @__PURE__ */ jsxRuntimeExports.jsx("defs", { children: /* @__PURE__ */ jsxRuntimeExports.jsxs(
      "linearGradient",
      {
        id: "circularGradient",
        x1: "0%",
        y1: "0%",
        x2: "100%",
        y2: "100%",
        children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            "stop",
            {
              offset: "0%",
              stopColor: e.palette.primary.main,
              stopOpacity: "1"
            }
          ),
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            "stop",
            {
              offset: "100%",
              stopColor: e.palette.background.default,
              stopOpacity: "0.1"
            }
          )
        ]
      }
    ) }) }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs(Box, { sx: { position: "relative" }, children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        CircularProgress,
        {
          variant: "determinate",
          sx: (ct) => ({
            color: ct.palette.primary.main,
            opacity: 0.2,
            position: "absolute"
          }),
          size: 140,
          thickness: 2,
          value: 100
        }
      ),
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        CircularProgress,
        {
          variant: re ? "indeterminate" : "determinate",
          classes: {
            root: We.circularProgressRoot,
            circle: re ? We.circularProgressCircleIndeterminite : We.circularProgressCircleDeterminite
          },
          disableShrink: re,
          size: 140,
          thickness: 2,
          value: je
        }
      )
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      Box,
      {
        sx: {
          top: 0,
          left: 0,
          bottom: 0,
          right: 0,
          position: "absolute",
          display: "flex",
          alignItems: "center",
          justifyContent: "center"
        },
        children: Ge
      }
    )
  ] }), [
    We.circularProgressCircleDeterminite,
    We.circularProgressCircleIndeterminite,
    We.circularProgressRoot,
    Ge,
    re,
    je,
    e.palette.background.default,
    e.palette.primary.main
  ]), Ne = useMemo(() => ye ? /* @__PURE__ */ jsxRuntimeExports.jsx(
    TxCompleteIcon,
    {
      className: We.txStatusIcon,
      sx: { color: e.palette.primary.light }
    }
  ) : Me || ke ? /* @__PURE__ */ jsxRuntimeExports.jsx(
    TxWarning,
    {
      className: We.txStatusIcon,
      sx: { color: e.palette.warning.main }
    }
  ) : Ie ? /* @__PURE__ */ jsxRuntimeExports.jsx(
    TxFailedIcon,
    {
      className: We.txStatusIcon,
      sx: { color: e.palette.error.light }
    }
  ) : !Ce && Ee ? /* @__PURE__ */ jsxRuntimeExports.jsx(
    TxReadyForClaimIcon,
    {
      className: We.txStatusIcon,
      sx: { color: e.palette.warning.light }
    }
  ) : Oe, [
    We.txStatusIcon,
    Oe,
    Ce,
    ye,
    Me,
    ke,
    Ie,
    Ee,
    e.palette.primary.light,
    e.palette.warning.main,
    e.palette.warning.light,
    e.palette.error.light
  ]);
  useEffect(() => {
    let ct;
    if (ue.receipt && isDestinationQueued(ue.receipt)) {
      J(!0);
      const ot = ue.receipt.queueReleaseTime.getTime() - Date.now();
      ct = setTimeout(() => {
        J(!1);
      }, ot);
    }
    return () => {
      ct && clearTimeout(ct);
    };
  }, [ue.receipt]);
  const Ye = useMemo(() => {
    if (!_e)
      return !1;
    if (me && De === "Solana" && ae.address && ae.address !== _e && fe && // These routes set the recipient address to the associated token address
    ["ManualTokenBridge", "ManualCCTP"].includes(fe)) {
      const yt = config$1.sdkConverter.toTokenIdV2(
        config$1.tokens[ne],
        "Solana"
      );
      try {
        if (!getAssociatedTokenAddressSync$1(
          new PublicKey(yt.address.toString()),
          new PublicKey(ae.address)
        ).equals(new PublicKey(_e)))
          return $("Not connected to the receiving wallet"), !1;
      } catch (dt) {
        return console.log(
          `Error while checking associated token address for the recipient: ${dt}`
        ), !1;
      }
      return $(""), !0;
    }
    const ct = ae.address.toLowerCase(), it = ae.currentAddress.toLowerCase(), ot = _e.toLowerCase();
    return ct === it && ct === ot;
  }, [
    ae,
    _e,
    De,
    me,
    fe,
    ne
  ]), Je = useCallback(async () => {
    if (J(!0), $(""), !fe)
      throw new Error("Unknown route, can not claim");
    if (!ue.receipt)
      throw new Error("No receipt found, can not claim");
    const ct = {
      route: fe,
      fromToken: getTokenDetails(Ae),
      toToken: getTokenDetails(ne),
      fromChain: Fe,
      toChain: De
    };
    if (config$1.triggerEvent({
      type: "transfer.redeem.initiate",
      details: ct
    }), !Ye)
      throw $("Not connected to the receiving wallet"), new Error("Not connected to the receiving wallet");
    const it = config$1.chains[De];
    if (!it)
      throw $("Your claim has failed, please try again"), new Error("invalid destination chain");
    const ot = ue.route;
    try {
      if (it.context === Context.ETH && typeof it.chainId == "number" && (await switchChain(it.chainId, TransferWallet.RECEIVING), await registerWalletSigner(De, TransferWallet.RECEIVING)), !isManual(ot) && !isFinalizable(ot))
        throw new Error("Route is not manual or finalizable");
      const yt = await SDKv2Signer.fromChain(
        De,
        ae.address,
        {},
        TransferWallet.RECEIVING
      ), dt = ke && isFinalizable(ot) ? ot.finalize(yt, ue.receipt) : !ke && isManual(ot) ? ot.complete(yt, ue.receipt) : void 0;
      dt && (config$1.triggerEvent({
        type: "transfer.redeem.start",
        details: be
      }), await dt);
    } catch (yt) {
      Te(yt), J(!1);
    }
  }, [
    be,
    Fe,
    Ye,
    ke,
    ne,
    ae.address,
    ue.receipt,
    ue.route,
    fe,
    De,
    Ae
  ]), Xe = useMemo(() => V ? /* @__PURE__ */ jsxRuntimeExports.jsx(Button, { disabled: !0, variant: "primary", className: We.actionButton, children: /* @__PURE__ */ jsxRuntimeExports.jsxs(
    Typography,
    {
      display: "flex",
      alignItems: "center",
      gap: 1,
      textTransform: "none",
      children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          CircularProgress,
          {
            size: 16,
            sx: {
              color: e.palette.primary.contrastText
            }
          }
        ),
        "Transfer in progress"
      ]
    }
  ) }) : ke || !Ce && Ee ? Ye ? /* @__PURE__ */ jsxRuntimeExports.jsx(
    Button,
    {
      className: joinClass([We.actionButton, We.claimButton]),
      variant: T ? "error" : "primary",
      onClick: Je,
      children: /* @__PURE__ */ jsxRuntimeExports.jsx(Typography, { textTransform: "none", children: "Claim tokens to complete transfer" })
    }
  ) : /* @__PURE__ */ jsxRuntimeExports.jsx(
    Button,
    {
      variant: "primary",
      className: We.actionButton,
      onClick: () => de(!0),
      children: /* @__PURE__ */ jsxRuntimeExports.jsx(Typography, { textTransform: "none", children: "Connect receiving wallet" })
    }
  ) : /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      Button,
      {
        variant: "primary",
        className: We.actionButton,
        onClick: () => {
          C(setRoute("bridge"));
        },
        children: /* @__PURE__ */ jsxRuntimeExports.jsx(Typography, { textTransform: "none", children: "Start a new transaction" })
      }
    ),
    !ye && /* @__PURE__ */ jsxRuntimeExports.jsx(Typography, { fontSize: "12px", sx: { margin: "auto", opacity: 0.6 }, children: "Your current transaction will continue to process in the background." })
  ] }), [
    T,
    We.actionButton,
    We.claimButton,
    C,
    Je,
    Ce,
    V,
    Ye,
    Ee,
    ye,
    ke,
    e.palette.primary.contrastText
  ]), st = useMemo(() => {
    var dt;
    if (!ue.receipt || !isDestinationQueued(ue.receipt))
      return null;
    const { to: ct, queueReleaseTime: it } = ue.receipt, ot = ((dt = config$1.tokens[ne]) == null ? void 0 : dt.symbol) || "", yt = it.toLocaleString();
    return /* @__PURE__ */ jsxRuntimeExports.jsx(
      Typography,
      {
        color: e.palette.text.secondary,
        fontSize: 14,
        className: We.delayText,
        children: `Your transfer to ${ct} is delayed due to rate limits configured by ${ot}. After
        the delay ends on ${yt}, you will need to tap "Claim" to
        complete your transfer.`
      }
    );
  }, [
    We.delayText,
    ne,
    ue.receipt,
    e.palette.text.secondary
  ]);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: joinClass([We.container, We.spacer]), children: [
    Be,
    /* @__PURE__ */ jsxRuntimeExports.jsx(Stack, { className: We.backButton, children: /* @__PURE__ */ jsxRuntimeExports.jsx(
      IconButton,
      {
        sx: { padding: 0 },
        onClick: () => C(setRoute("bridge")),
        children: /* @__PURE__ */ jsxRuntimeExports.jsx(default_1$4, { sx: { fontSize: "32px" } })
      }
    ) }),
    Ue,
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      Box,
      {
        sx: {
          position: "relative",
          display: "inline-flex",
          alignItems: "center",
          marginBottom: "24px",
          height: "140px"
        },
        children: Ne
      }
    ),
    /* @__PURE__ */ jsxRuntimeExports.jsx(TransactionDetails, {}),
    Xe,
    st,
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      AlertBanner,
      {
        error: !0,
        content: T,
        show: !!T,
        className: We.errorBox
      }
    ),
    /* @__PURE__ */ jsxRuntimeExports.jsx(PoweredByIcon, { color: e.palette.text.primary }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      WalletSidebar,
      {
        open: se,
        type: TransferWallet.RECEIVING,
        onClose: () => {
          de(!1);
        }
      }
    )
  ] });
};
class InfiniteScroll extends Component {
  constructor(e) {
    super(e), this.scrollListener = this.scrollListener.bind(this), this.eventListenerOptions = this.eventListenerOptions.bind(this), this.mousewheelListener = this.mousewheelListener.bind(this);
  }
  componentDidMount() {
    this.pageLoaded = this.props.pageStart, this.options = this.eventListenerOptions(), this.attachScrollListener();
  }
  componentDidUpdate() {
    if (this.props.isReverse && this.loadMore) {
      const e = this.getParentElement(this.scrollComponent);
      e.scrollTop = e.scrollHeight - this.beforeScrollHeight + this.beforeScrollTop, this.loadMore = !1;
    }
    this.attachScrollListener();
  }
  componentWillUnmount() {
    this.detachScrollListener(), this.detachMousewheelListener();
  }
  isPassiveSupported() {
    let e = !1;
    const T = {
      get passive() {
        e = !0;
      }
    };
    try {
      document.addEventListener("test", null, T), document.removeEventListener("test", null, T);
    } catch {
    }
    return e;
  }
  eventListenerOptions() {
    let e = this.props.useCapture;
    return this.isPassiveSupported() ? e = {
      useCapture: this.props.useCapture,
      passive: !0
    } : e = {
      passive: !1
    }, e;
  }
  // Set a defaut loader for all your `InfiniteScroll` components
  setDefaultLoader(e) {
    this.defaultLoader = e;
  }
  detachMousewheelListener() {
    let e = window;
    this.props.useWindow === !1 && (e = this.scrollComponent.parentNode), e.removeEventListener(
      "mousewheel",
      this.mousewheelListener,
      this.options ? this.options : this.props.useCapture
    );
  }
  detachScrollListener() {
    let e = window;
    this.props.useWindow === !1 && (e = this.getParentElement(this.scrollComponent)), e.removeEventListener(
      "scroll",
      this.scrollListener,
      this.options ? this.options : this.props.useCapture
    ), e.removeEventListener(
      "resize",
      this.scrollListener,
      this.options ? this.options : this.props.useCapture
    );
  }
  getParentElement(e) {
    const T = this.props.getScrollParent && this.props.getScrollParent();
    return T ?? (e && e.parentNode);
  }
  filterProps(e) {
    return e;
  }
  attachScrollListener() {
    const e = this.getParentElement(this.scrollComponent);
    if (!this.props.hasMore || !e)
      return;
    let T = window;
    this.props.useWindow === !1 && (T = e), T.addEventListener(
      "mousewheel",
      this.mousewheelListener,
      this.options ? this.options : this.props.useCapture
    ), T.addEventListener(
      "scroll",
      this.scrollListener,
      this.options ? this.options : this.props.useCapture
    ), T.addEventListener(
      "resize",
      this.scrollListener,
      this.options ? this.options : this.props.useCapture
    ), this.props.initialLoad && this.scrollListener();
  }
  mousewheelListener(e) {
    e.deltaY === 1 && !this.isPassiveSupported() && e.preventDefault();
  }
  scrollListener() {
    const e = this.scrollComponent, T = window, $ = this.getParentElement(e);
    let V;
    if (this.props.useWindow) {
      const J = document.documentElement || document.body.parentNode || document.body, ee = T.pageYOffset !== void 0 ? T.pageYOffset : J.scrollTop;
      this.props.isReverse ? V = ee : V = this.calculateOffset(e, ee);
    } else this.props.isReverse ? V = $.scrollTop : V = e.scrollHeight - $.scrollTop - $.clientHeight;
    V < Number(this.props.threshold) && e && e.offsetParent !== null && (this.detachScrollListener(), this.beforeScrollHeight = $.scrollHeight, this.beforeScrollTop = $.scrollTop, typeof this.props.loadMore == "function" && (this.props.loadMore(this.pageLoaded += 1), this.loadMore = !0));
  }
  calculateOffset(e, T) {
    return e ? this.calculateTopPosition(e) + (e.offsetHeight - T - window.innerHeight) : 0;
  }
  calculateTopPosition(e) {
    return e ? e.offsetTop + this.calculateTopPosition(e.offsetParent) : 0;
  }
  render() {
    const e = this.filterProps(this.props), {
      children: T,
      element: $,
      hasMore: V,
      initialLoad: J,
      isReverse: ee,
      loader: te,
      loadMore: re,
      pageStart: ie,
      ref: se,
      threshold: de,
      useCapture: ue,
      useWindow: fe,
      getScrollParent: he,
      ...me
    } = e;
    me.ref = (ve) => {
      this.scrollComponent = ve, se && se(ve);
    };
    const xe = [T];
    return V && (te ? ee ? xe.unshift(te) : xe.push(te) : this.defaultLoader && (ee ? xe.unshift(this.defaultLoader) : xe.push(this.defaultLoader))), React__default.createElement($, me, xe);
  }
}
tt(InfiniteScroll, "propTypes", {
  children: PropTypes.node.isRequired,
  element: PropTypes.node,
  hasMore: PropTypes.bool,
  initialLoad: PropTypes.bool,
  isReverse: PropTypes.bool,
  loader: PropTypes.node,
  loadMore: PropTypes.func.isRequired,
  pageStart: PropTypes.number,
  ref: PropTypes.func,
  getScrollParent: PropTypes.func,
  threshold: PropTypes.number,
  useCapture: PropTypes.bool,
  useWindow: PropTypes.bool
}), tt(InfiniteScroll, "defaultProps", {
  element: "div",
  hasMore: !1,
  initialLoad: !0,
  pageStart: 0,
  ref: null,
  threshold: 250,
  useWindow: !0,
  isReverse: !1,
  useCapture: !1,
  loader: null,
  getScrollParent: null
});
var SwapHoriz = {}, _interopRequireDefault = interopRequireDefaultExports;
Object.defineProperty(SwapHoriz, "__esModule", {
  value: !0
});
var default_1 = SwapHoriz.default = void 0, _createSvgIcon = _interopRequireDefault(requireCreateSvgIcon()), _jsxRuntime = jsxRuntimeExports;
default_1 = SwapHoriz.default = (0, _createSvgIcon.default)(/* @__PURE__ */ (0, _jsxRuntime.jsx)("path", {
  d: "M6.99 11 3 15l3.99 4v-3H14v-2H6.99zM21 9l-3.99-4v3H10v2h7.01v3z"
}), "SwapHoriz");
const DECIMALS = 8, useTransactionHistoryWHScan = (C) => {
  const [e, T] = useState(), [$, V] = useState(""), [J, ee] = useState(!1), [te, re] = useState(!0), { address: ie, page: se = 0, pageSize: de = 30 } = C, ue = useCallback((we) => {
    var Re, We, Be, Ue;
    const { content: Ee, data: Me, sourceChain: Ie, targetChain: ke } = we, { tokenAmount: _e, usdAmount: De } = Me || {}, { standarizedProperties: Fe } = Ee || {}, Ae = Fe.fromChain || (Ie == null ? void 0 : Ie.chainId), ne = Fe.toChain || (ke == null ? void 0 : ke.chainId), oe = Fe.tokenChain, ce = chainIdToChain(Ae);
    if (!ce)
      return;
    const le = chainIdToChain(oe);
    let pe = getTokenById({
      chain: le,
      address: Fe.tokenAddress
    });
    if (!pe)
      if (Me != null && Me.symbol && config$1.tokens[Me.symbol])
        pe = config$1.tokens[Me.symbol];
      else
        return;
    const ye = chainIdToChain(ne), Ce = pe.nativeChain === ye ? pe.key : (Re = getWrappedToken(pe)) == null ? void 0 : Re.key, be = _e ?? display(
      {
        amount: Fe.amount,
        decimals: Fe.normalizedDecimals ?? DECIMALS
      },
      0
    ), ae = BigInt(Fe.amount) - BigInt(Fe.fee), ge = ae > 0 ? display(
      {
        amount: ae.toString(),
        decimals: DECIMALS
      },
      0
    ) : "", Se = (We = Ie.transaction) == null ? void 0 : We.txHash, Le = ((Be = Ie == null ? void 0 : Ie.status) == null ? void 0 : Be.toLowerCase()) === "confirmed" && ((Ue = ke == null ? void 0 : ke.status) == null ? void 0 : Ue.toLowerCase()) !== "completed";
    return {
      txHash: Se,
      sender: Fe.fromAddress || Ie.from,
      recipient: Fe.toAddress,
      amount: be,
      amountUsd: De ? Number(De) : 0,
      receiveAmount: ge,
      fromChain: ce,
      toChain: ye,
      tokenKey: pe.key,
      tokenAddress: Fe.tokenAddress,
      receivedTokenKey: Ce,
      senderTimestamp: Ie == null ? void 0 : Ie.timestamp,
      receiverTimestamp: ke == null ? void 0 : ke.timestamp,
      explorerLink: `${WORMSCAN}tx/${Se}${config$1.isMainnet ? "" : "?network=TESTNET"}`,
      inProgress: Le
    };
  }, []), fe = useCallback(
    (we) => ue(we),
    [ue]
  ), he = useCallback(
    (we) => ue(we),
    [ue]
  ), me = useCallback(
    (we) => ue(we),
    [ue]
  ), xe = useCallback(
    (we) => {
      var pe, ye, Ce;
      const Ee = ue(we);
      if (!Ee) return;
      const Me = we.content.payload.parsedPayload, {
        finalTokenAddress: Ie,
        flagSet: ke,
        minAmountFinish: _e,
        recipientAddress: De,
        relayerFee: Fe
      } = Me, Ae = getNativeVersionOfToken(
        we.data.symbol,
        Ee.fromChain
      ), ne = config$1.tokens[Ae];
      if (!ne) return;
      const oe = (pe = ke.flags) != null && pe.shouldWrapNative ? getGasToken(Ee.fromChain) : ne, ce = config$1.sdkConverter.findTokenConfigV1(
        Wormhole.tokenId(
          Ee.toChain,
          toNative(Ee.toChain, Ie).toString()
        ),
        config$1.tokensArr
      );
      if (!ce) return;
      const le = BigInt(_e) - BigInt(Fe);
      return Ee.tokenKey = oe.key, Ee.tokenAddress = ((ye = oe.tokenId) == null ? void 0 : ye.address) || "native", Ee.receivedTokenKey = (Ce = ke.flags) != null && Ce.shouldUnwrapNative ? getGasToken(Ee.toChain).key : ce.key, Ee.receiveAmount = le > 0 ? toFixedDecimals(
        display(
          fromBaseUnits(
            le,
            ce.decimals
          ),
          0
        ),
        DECIMALS
      ) : "", Ee.recipient = toNative(Ee.toChain, De).toString(), Ee;
    },
    [ue]
  ), ve = useMemo(
    () => ({
      PORTAL_TOKEN_BRIDGE: fe,
      NATIVE_TOKEN_TRANSFER: he,
      CCTP_WORMHOLE_INTEGRATION: me,
      ETH_BRIDGE: xe,
      USDT_BRIDGE: xe
    }),
    [me, he, xe, fe]
  ), Te = useCallback(
    (we) => we.map((Ee) => {
      var Ie, ke;
      const Me = ((ke = (Ie = Ee.content) == null ? void 0 : Ie.standarizedProperties) == null ? void 0 : ke.appIds) || [];
      if (Me.includes("ETH_BRIDGE") || Me.includes("USDT_BRIDGE"))
        return xe(Ee);
      for (const _e of Me) {
        const De = ve[_e];
        if (De)
          try {
            return De(Ee);
          } catch (Fe) {
            console.error(`Error parsing transaction: ${Fe}`);
          }
      }
    }).filter((Ee) => !!Ee),
    [ve, xe]
  );
  return useEffect(() => {
    let we = !1;
    const Ee = new Headers({
      accept: "application/json"
    });
    return (async () => {
      ee(!0);
      try {
        const Ie = await fetch(
          `${config$1.wormholeApi}api/v1/operations?address=${ie}&page=${se}&pageSize=${de}`,
          { headers: Ee }
        );
        if (Ie.status !== 200)
          T([]), re(!1), ee(!1);
        else {
          const ke = await Ie.json();
          if (!we) {
            const _e = ke == null ? void 0 : ke.operations;
            _e && T((De) => {
              const Fe = Te(_e);
              if (De && De.length > 0) {
                const Ae = /* @__PURE__ */ new Set();
                return De.forEach((ne) => {
                  ne != null && ne.txHash && Ae.add(ne.txHash);
                }), De.concat(
                  Fe.filter(
                    (ne) => !Ae.has(ne.txHash)
                  )
                );
              }
              return Fe;
            }), (_e == null ? void 0 : _e.length) < de && re(!1);
          }
        }
      } catch (Ie) {
        we || (re(!1), V(
          `Error fetching transaction history from WormholeScan: ${Ie}`
        ));
      } finally {
        ee(!1);
      }
    })(), () => {
      we = !0;
    };
  }, [ie, se, de, Te]), {
    transactions: e,
    error: $,
    isFetching: J,
    hasMore: te
  };
}, useTransactionHistoryMayan = (C) => {
  const [e, T] = useState(), [$, V] = useState(""), [J, ee] = useState(!1), [te, re] = useState(!0), { address: ie, page: se = 0, pageSize: de = 30 } = C, ue = (he) => {
    const {
      fromAmount: me,
      sourceChain: xe,
      destChain: ve,
      fromTokenPrice: Te,
      fromTokenSymbol: we,
      initiatedAt: Ee,
      toAmount: Me,
      toTokenAddress: Ie,
      toTokenSymbol: ke,
      sourceTxHash: _e,
      trader: De,
      destAddress: Fe,
      clientStatus: Ae
    } = he, ne = chainIdToChain(xe), oe = chainIdToChain(ve);
    if (!ne || !oe)
      return;
    const ce = config$1.tokensArr.find(
      (be) => {
        var ae;
        return be.symbol === we && (be.nativeChain === ne || ((ae = be.tokenId) == null ? void 0 : ae.chain) === ne);
      }
    ), le = config$1.tokensArr.find(
      (be) => {
        var ae;
        return be.symbol === ke && (be.nativeChain === oe || ((ae = be.tokenId) == null ? void 0 : ae.chain) === oe);
      }
    );
    if (!ce || !le)
      return;
    const pe = Ae == null ? void 0 : Ae.toLowerCase(), ye = pe !== "completed" && pe !== "refunded";
    return {
      txHash: _e,
      sender: De,
      amount: me,
      amountUsd: Number(me) * Te,
      recipient: Fe,
      toChain: oe,
      fromChain: ne,
      tokenKey: ce == null ? void 0 : ce.key,
      receivedTokenKey: le == null ? void 0 : le.key,
      receiveAmount: Me,
      tokenAddress: Ie,
      senderTimestamp: Ee,
      explorerLink: `https://explorer.mayan.finance/swap/${_e}`,
      inProgress: ye
    };
  }, fe = useCallback(
    (he) => he.map((me) => ue(me)).filter((me) => !!me),
    // Filter out unsupported transactions
    []
  );
  return useEffect(() => {
    let he = !1;
    return (async () => {
      ee(!0);
      const xe = de, ve = xe * se;
      try {
        const Te = await fetch(
          `${config$1.mayanApi}/v3/swaps?trader=${ie}&offset=${ve}&limit=${xe}`
        );
        if (Te.status !== 200)
          T([]), re(!1), ee(!1);
        else {
          const we = await Te.json();
          if (!he) {
            const Ee = we == null ? void 0 : we.data;
            Ee && T((Me) => {
              const Ie = fe(Ee);
              if (Me && Me.length > 0) {
                const ke = /* @__PURE__ */ new Set();
                return Me.forEach((_e) => {
                  _e != null && _e.txHash && ke.add(_e.txHash);
                }), Me.concat(
                  Ie.filter(
                    (_e) => !ke.has(_e.txHash)
                  )
                );
              }
              return Ie;
            }), (Ee == null ? void 0 : Ee.length) < xe && re(!1);
          }
        }
      } catch (Te) {
        he || (re(!1), V(`Error fetching transaction history from Mayan: ${Te}`));
      } finally {
        ee(!1);
      }
    })(), () => {
      he = !0;
    };
  }, [ie, se, de, fe]), {
    transactions: e,
    error: $,
    isFetching: J,
    hasMore: te
  };
}, useTransactionHistory = (C) => {
  const { page: e = 0, pageSize: T = 30 } = C || {}, [$, V] = useState(0), [J, ee] = useState(0), [te, re] = useState(e), [ie, se] = useState(e), [de, ue] = useState(), { address: fe } = useSelector((De) => De.wallet.sending), {
    transactions: he,
    isFetching: me,
    hasMore: xe,
    error: ve
  } = useTransactionHistoryWHScan({
    address: fe,
    page: ie,
    pageSize: T
  }), {
    transactions: Te,
    isFetching: we,
    hasMore: Ee,
    error: Me
  } = useTransactionHistoryMayan({
    address: fe,
    page: te,
    pageSize: T
  }), Ie = useCallback(
    (De, Fe) => De ? De.concat(Fe) : Fe,
    []
  ), ke = useCallback(
    (De) => {
      he && De <= (he == null ? void 0 : he.length) && ee(De);
    },
    [he]
  ), _e = useCallback(
    (De) => {
      Te && De <= (Te == null ? void 0 : Te.length) && V(De);
    },
    [Te]
  );
  return useEffect(() => {
    Ee && te !== e && re(e), xe && ie !== e && se(e);
  }, [Ee, xe, te, e, ie]), useEffect(() => {
    if (!he || !Te)
      return;
    const De = [];
    let Fe = J, Ae = $;
    for (let ne = 0; ne < T; ne++) {
      if (Fe === he.length && xe || Ae === Te.length && Ee) {
        ke(Fe), _e(Ae), ue((le) => Ie(le, De));
        return;
      }
      const oe = he[Fe], ce = Te[Ae];
      if (!oe && !ce) {
        ke(Fe), _e(Ae), ue((le) => Ie(le, De));
        return;
      }
      if (!ce)
        De.push(oe), Fe += 1;
      else if (!oe)
        De.push(ce), Ae += 1;
      else {
        const le = new Date(oe.senderTimestamp), pe = new Date(ce.senderTimestamp);
        le > pe ? (De.push(oe), Fe += 1) : (De.push(ce), Ae += 1);
      }
    }
    ke(Fe), _e(Ae), ue((ne) => Ie(ne, De));
  }, [he, Te]), {
    transactions: de,
    error: [ve, Me],
    isFetching: me || we,
    hasMore: xe || Ee
  };
}, useStyles$2 = makeStyles()((C) => ({
  container: {
    width: "100%",
    maxWidth: "420px"
  },
  card: {
    width: "100%",
    borderRadius: "8px"
  },
  cardHeader: {
    paddingBottom: 0
  }
})), TxHistoryItem = (C) => {
  const { classes: e } = useStyles$2(), T = useTheme$1(), {
    txHash: $,
    amount: V,
    amountUsd: J,
    toChain: ee,
    fromChain: te,
    tokenKey: re,
    receivedTokenKey: ie,
    receiveAmount: se,
    senderTimestamp: de,
    explorerLink: ue
  } = C.data, fe = useMemo(
    () => /* @__PURE__ */ jsxRuntimeExports.jsx(Typography, { component: "span", padding: "0px 8px", children: "·" }),
    []
  ), he = useMemo(() => {
    const Te = config$1.tokens[re], we = config$1.chains[te];
    return /* @__PURE__ */ jsxRuntimeExports.jsxs(Stack, { alignItems: "center", direction: "row", justifyContent: "flex-start", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        AssetBadge,
        {
          chainConfig: we,
          tokenConfig: Te
        }
      ),
      /* @__PURE__ */ jsxRuntimeExports.jsxs(Stack, { direction: "column", marginLeft: "12px", children: [
        /* @__PURE__ */ jsxRuntimeExports.jsxs(Typography, { fontSize: 16, children: [
          V,
          " ",
          Te == null ? void 0 : Te.symbol
        ] }),
        /* @__PURE__ */ jsxRuntimeExports.jsxs(Typography, { color: T.palette.text.secondary, fontSize: 14, children: [
          getUSDFormat(J),
          fe,
          we == null ? void 0 : we.displayName
        ] })
      ] })
    ] });
  }, [
    V,
    J,
    te,
    fe,
    T.palette.text.secondary,
    re
  ]), me = useMemo(() => {
    const Te = config$1.chains[ee], we = ie ? config$1.tokens[ie] : void 0, Ee = calculateUSDPrice(
      parseFloat(se),
      C.tokenPrices,
      we
    ), Me = Ee ? /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
      Ee,
      fe
    ] }) : null;
    return /* @__PURE__ */ jsxRuntimeExports.jsxs(Stack, { alignItems: "center", direction: "row", justifyContent: "flex-start", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        AssetBadge,
        {
          chainConfig: Te,
          tokenConfig: we
        }
      ),
      /* @__PURE__ */ jsxRuntimeExports.jsxs(Stack, { direction: "column", marginLeft: "12px", children: [
        /* @__PURE__ */ jsxRuntimeExports.jsxs(Typography, { fontSize: 16, children: [
          se,
          " ",
          we == null ? void 0 : we.symbol
        ] }),
        /* @__PURE__ */ jsxRuntimeExports.jsxs(Typography, { color: T.palette.text.secondary, fontSize: 14, children: [
          Me,
          Te == null ? void 0 : Te.displayName
        ] })
      ] })
    ] });
  }, [
    C.tokenPrices,
    se,
    ie,
    fe,
    T.palette.text.secondary,
    ee
  ]), xe = useMemo(
    () => /* @__PURE__ */ jsxRuntimeExports.jsx(
      Stack,
      {
        height: "24px",
        borderLeft: "1px solid #8B919D",
        marginLeft: "16px"
      }
    ),
    []
  ), ve = useMemo(() => {
    if (!de)
      return "Unknown time";
    const Te = new Date(de), we = Date.now() - Te.getTime();
    return we < 1e3 * 60 * 60 * 24 ? millisToRelativeTime(we) : `${new Intl.DateTimeFormat("en-US", {
      dateStyle: "short",
      timeStyle: "short"
    }).format(Te)}`;
  }, [de]);
  return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: e.container, children: /* @__PURE__ */ jsxRuntimeExports.jsx(Card, { className: e.card, children: /* @__PURE__ */ jsxRuntimeExports.jsxs(
    CardActionArea,
    {
      disableTouchRipple: !0,
      onClick: () => {
        window.open(ue, "_blank");
      },
      children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          CardHeader,
          {
            className: e.cardHeader,
            title: /* @__PURE__ */ jsxRuntimeExports.jsxs(
              Typography,
              {
                justifyContent: "space-between",
                color: T.palette.text.secondary,
                display: "flex",
                children: [
                  /* @__PURE__ */ jsxRuntimeExports.jsx("span", { children: `Transaction #${trimTxHash($, 4, 4)}` }),
                  /* @__PURE__ */ jsxRuntimeExports.jsx("span", { children: ve })
                ]
              }
            )
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsxs(CardContent, { children: [
          he,
          xe,
          me
        ] })
      ]
    }
  ) }) });
}, useStyles$1 = makeStyles()((C) => ({
  container: {
    margin: "auto",
    maxWidth: "420px"
  },
  header: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    width: "100%"
  },
  infiniteScroller: {
    height: "640px",
    overflow: "auto",
    width: "100%"
  },
  txHistoryHeader: {
    width: "100%",
    display: "flex",
    alignItems: "center"
  },
  spacer: {
    display: "flex",
    flexDirection: "column",
    gap: "24px",
    alignItems: "center",
    justifyContent: "center",
    width: "100%"
  }
})), TxHistory = () => {
  const C = useDispatch(), { classes: e } = useStyles$1(), T = useTheme$1(), [$, V] = useState(0), { transactions: J, isFetching: ee, hasMore: te } = useTransactionHistory({
    page: $
  }), re = useSelector((fe) => fe.wallet.sending), { usdPrices: ie } = useSelector(
    (fe) => fe.tokenPrices
  ), se = useMemo(() => {
    const fe = {
      text: "",
      align: "left"
    };
    let he;
    return typeof config$1.ui.pageHeader == "string" ? he = { ...fe, text: config$1.ui.pageHeader } : he = { ...fe, ...config$1.ui.pageHeader }, /* @__PURE__ */ jsxRuntimeExports.jsx(PageHeader, { title: he.text, align: he.align });
  }, []), de = useMemo(() => /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: e.txHistoryHeader, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(Header, { align: "left", size: 18, text: "Transaction history" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(IconButton, { onClick: () => C(setRoute("bridge")), children: /* @__PURE__ */ jsxRuntimeExports.jsx(default_1, {}) })
  ] }), [e.txHistoryHeader, C]), ue = useMemo(() => {
    if (J) {
      if (J.length === 0)
        return /* @__PURE__ */ jsxRuntimeExports.jsx(Typography, { color: T.palette.text.secondary, textAlign: "center", children: `No transactions found for the wallet ${trimAddress(
          re.address
        )}` });
    } else return /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, {});
    return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: joinClass([e.infiniteScroller]), children: /* @__PURE__ */ jsxRuntimeExports.jsx(
      InfiniteScroll,
      {
        hasMore: te,
        loadMore: (fe) => V(fe),
        useWindow: !1,
        style: { scrollbarWidth: "thin" },
        children: /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: joinClass([e.spacer]), children: J.map((fe, he) => /* @__PURE__ */ jsxRuntimeExports.jsx(
          TxHistoryItem,
          {
            data: fe,
            tokenPrices: ie.data
          },
          he
        )) })
      }
    ) });
  }, [
    e.infiniteScroller,
    e.spacer,
    te,
    re.address,
    T.palette.text.secondary,
    ie.data,
    J
  ]);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: joinClass([e.container, e.spacer]), children: [
    se,
    de,
    ue,
    (!J || ee) && /* @__PURE__ */ jsxRuntimeExports.jsx(CircularProgress, {}),
    /* @__PURE__ */ jsxRuntimeExports.jsx(PoweredByIcon, { color: T.palette.text.primary })
  ] });
}, useStyles = makeStyles()((C) => ({
  appContent: {
    textAlign: "left",
    margin: "40px auto",
    maxWidth: "900px",
    width: "100%",
    display: "flex",
    justifyContent: "center",
    padding: "4px",
    fontFamily: C.palette.font.primary,
    [C.breakpoints.down("sm")]: {
      margin: "0 auto"
    }
  }
}));
function AppRouter(C) {
  const { classes: e } = useStyles(), T = useDispatch(), $ = useContext(RouteContext);
  React__default.useEffect(() => {
    isEmptyObject(C.config) || (setConfig(C.config), T(clearTransfer())), config$1.triggerEvent({
      type: "load",
      config: C.config
    });
  }, []);
  const V = useSelector((te) => te.router.route), J = usePrevious(V), { hasExternalSearch: ee } = useExternalSearch();
  return useEffect(() => {
    const te = "redeem", re = "bridge";
    J === te && V !== te && (T(clearRedeem()), T(clearWallets()), $.clear(), config$1.whLegacy.registerProviders()), V === re && J !== re && J !== "history" && T(clearTransfer());
  }, [V, J, T]), useEffect(() => {
    ee && (T(clearRedeem()), T(setRoute("search")));
  }, [ee, T]), /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: e.appContent, children: [
    V === "bridge" && /* @__PURE__ */ jsxRuntimeExports.jsx(Bridge, {}),
    V === "redeem" && /* @__PURE__ */ jsxRuntimeExports.jsx(Redeem, {}),
    V === "search" && /* @__PURE__ */ jsxRuntimeExports.jsx(TxSearch, {}),
    V === "history" && /* @__PURE__ */ jsxRuntimeExports.jsx(TxHistory, {}),
    V === "terms" && /* @__PURE__ */ jsxRuntimeExports.jsx(Terms, {})
  ] });
}
const light = {
  mode: "light",
  primary: {
    50: "#161718",
    100: "#2d2e30",
    200: "#444548",
    300: "#5b5c60",
    400: "#727479",
    500: "#898b91",
    600: "#a0a2a9",
    700: "#b7b9c1",
    800: "#ced0d9",
    900: "#E5E8F2",
    A100: "#ceced1",
    A200: "#9d9ea4",
    A400: "#535660",
    A700: "#0a0e1c"
  },
  secondary: grey,
  divider: "#a0a2a9",
  background: {
    default: "transparent",
    badge: "#E5E8F2"
  },
  text: {
    primary: grey[900],
    secondary: grey[800]
  },
  error: red,
  info: {
    50: "#d1e3f9",
    100: "#c8def7",
    200: "#bfd8f6",
    300: "#b6d3f5",
    400: "#adcdf4",
    500: "#A4C8F3",
    600: "#93b4da",
    700: "#83a0c2",
    800: "#728caa",
    900: "#627891",
    A100: "#A4C8F3",
    A200: "#A4C8F3",
    A400: "#A4C8F3",
    A700: "#A4C8F3"
  },
  success: green,
  warning: orange,
  button: {
    primary: "#ffffff",
    primaryText: grey[900],
    disabled: "#c8cad1",
    disabledText: grey[800],
    action: "#F3A01E",
    actionText: "#000000",
    hover: "#b7b9c1"
  },
  options: {
    hover: "#f9f9fb",
    select: "#F0F0F5"
  },
  card: {
    background: "#ffffff",
    elevation: "10px 10px 30px 15px #CCD2E7",
    secondary: "#F0F0F5"
  },
  popover: {
    background: "#ffffff",
    elevation: "10px 10px 30px 15px #CCD2E7",
    secondary: "#F0F0F5"
  },
  modal: {
    background: "#ffffff"
  },
  font: '"Inter", sans-serif',
  logo: "#000000"
}, dark = {
  mode: "dark",
  primary: {
    25: "#FCFAFF",
    50: "#F9F5FF",
    100: "#F4EBFF",
    200: "#E9D7FE",
    300: "#D6BBFB",
    400: "#B692F6",
    500: "#9E77ED",
    600: "#7F56D9",
    700: "#6941C6",
    800: "#53389E",
    900: "#42307D",
    950: "#2C1C5F",
    A100: purple.A100,
    A200: purple.A200,
    A400: purple.A400,
    A700: purple.A700
  },
  secondary: {
    25: "#FCFCFD",
    50: "#F9FAFB",
    100: "#F2F4F7",
    200: "#E4E7EC",
    300: "#D0D5DD",
    400: "#98A2B3",
    500: "#667085",
    600: "#475467",
    700: "#344054",
    800: "#1D2939",
    900: "#101828",
    950: "#0C111D",
    A100: grey.A100,
    A200: grey.A200,
    A400: grey.A400,
    A700: grey.A700
  },
  divider: "#ffffff" + OPACITY[20],
  background: {
    default: "transparent",
    badge: "#010101"
  },
  text: {
    primary: "#ffffff",
    secondary: "#79859e"
  },
  info: {
    50: "#97a5b7",
    100: "#8293a9",
    200: "#6e819a",
    300: "#596f8c",
    400: "#445d7e",
    500: "#304C70",
    600: "#2b4464",
    700: "#263c59",
    800: "#21354e",
    900: "#1c2d43",
    A100: "#304C70",
    A200: "#304C70",
    A400: "#304C70",
    A700: "#304C70"
  },
  error: {
    25: "#FFFBFA",
    50: "#FEF3F2",
    100: "#FEE4E2",
    200: "#FECDCA",
    300: "#FDA29B",
    400: "#F97066",
    500: "#F04438",
    600: "#D92D20",
    700: "#B42318",
    800: "#912018",
    900: "#7A271A",
    950: "#55160C",
    A100: red.A100,
    A200: red.A200,
    A400: red.A400,
    A700: red.A700
  },
  success: {
    25: "#F6FEF9",
    50: "#ECFDF3",
    100: "#D1FADF",
    200: "#A6F4C5",
    300: "#6CE9A6",
    400: "#32D583",
    500: "#12B76A",
    600: "#039855",
    700: "#027A48",
    800: "#05603A",
    900: "#054F31",
    950: "#053321",
    A100: green.A100,
    A200: green.A200,
    A400: green.A400,
    A700: green.A700
  },
  warning: {
    25: "#FFFCF5",
    50: "#FFFAEB",
    100: "#FEF0C7",
    200: "#FEDF89",
    300: "#FEC84B",
    400: "#FDB022",
    500: "#F79009",
    600: "#DC6803",
    700: "#B54708",
    800: "#93370D",
    900: "#7A2E0E",
    950: "#4E1D09",
    A100: orange.A100,
    A200: orange.A200,
    A400: orange.A400,
    A700: orange.A700
  },
  button: {
    primary: "#ffffff" + OPACITY[10],
    primaryText: "#ffffff",
    disabled: "#ffffff" + OPACITY[7],
    disabledText: "#ffffff" + OPACITY[40],
    action: "#ffffff",
    actionText: "#000000",
    hover: "#ffffff" + OPACITY[7]
  },
  options: {
    hover: "#ffffff" + OPACITY[7],
    select: "#ffffff" + OPACITY[10]
  },
  card: {
    background: "#ffffff" + OPACITY[5],
    secondary: "#ffffff" + OPACITY[5],
    elevation: "none"
  },
  popover: {
    background: "#1b2033",
    secondary: "#ffffff" + OPACITY[5],
    elevation: "none"
  },
  modal: {
    background: "#181a2d"
  },
  font: '"Inter", sans-serif',
  logo: "#ffffff"
}, generateTheme = (C) => {
  const e = C.mode === "light" ? light : dark, T = Object.assign({}, e);
  return C && (C.input && (T.modal = {
    background: C.input
  }), C.primary && (T.primary = {
    main: C.primary
  }), C.secondary && (T.secondary = {
    main: C.secondary
  }), C.text && (T.text.primary = C.text), C.textSecondary && (T.text.secondary = C.textSecondary), C.error && (T.error = {
    main: C.error
  }), C.success && (T.success = {
    main: C.success
  }), C.badge && (T.background.badge = C.badge)), createTheme({
    components: {
      MuiPaper: {
        styleOverrides: {
          root: {
            background: T.modal.background + " !important"
          }
        }
      },
      MuiCollapse: {
        styleOverrides: {
          root: {
            width: "100%"
          }
        }
      }
    },
    breakpoints: {
      values: {
        xs: 300,
        sm: 500,
        md: 650,
        lg: 900,
        xl: 1200
      }
    },
    typography: {
      fontFamily: C.font ?? '"Inter", sans-serif'
    },
    palette: {
      ...T
    }
  });
};
class ErrorBoundary extends React__default.Component {
  constructor(e) {
    super(e), this.state = { hasError: !1 };
  }
  static getDerivedStateFromError(e) {
    return { hasError: !0 };
  }
  componentDidCatch(e, T) {
    console.error(e, T);
  }
  render() {
    return this.state.hasError ? /* @__PURE__ */ jsxRuntimeExports.jsx(Card, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(
      Typography,
      {
        variant: "h5",
        style: { textAlign: "center", marginTop: 24, marginBottom: 24 },
        children: "An unexpected error has occurred. Please refresh the page."
      }
    ) }) : this.props.children;
  }
}
function WormholeConnect({
  config: C,
  theme: e
}) {
  const T = React$1.useMemo(
    () => generateTheme(e ?? { mode: "dark" }),
    [e]
  );
  return /* @__PURE__ */ jsxRuntimeExports.jsx(Provider, { store, children: /* @__PURE__ */ jsxRuntimeExports.jsx(ThemeProvider, { theme: T, children: /* @__PURE__ */ jsxRuntimeExports.jsx(ScopedCssBaseline, { enableColorScheme: !0, children: /* @__PURE__ */ jsxRuntimeExports.jsx(ErrorBoundary, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(RouteProvider, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(AppRouter, { config: C }) }) }) }) }) });
}
var browserPonyfill = { exports: {} };
(function(C, e) {
  var T = typeof self < "u" ? self : commonjsGlobal$1, $ = function() {
    function J() {
      this.fetch = !1, this.DOMException = T.DOMException;
    }
    return J.prototype = T, new J();
  }();
  (function(J) {
    (function(ee) {
      var te = {
        searchParams: "URLSearchParams" in J,
        iterable: "Symbol" in J && "iterator" in Symbol,
        blob: "FileReader" in J && "Blob" in J && function() {
          try {
            return new Blob(), !0;
          } catch {
            return !1;
          }
        }(),
        formData: "FormData" in J,
        arrayBuffer: "ArrayBuffer" in J
      };
      function re(ce) {
        return ce && DataView.prototype.isPrototypeOf(ce);
      }
      if (te.arrayBuffer)
        var ie = [
          "[object Int8Array]",
          "[object Uint8Array]",
          "[object Uint8ClampedArray]",
          "[object Int16Array]",
          "[object Uint16Array]",
          "[object Int32Array]",
          "[object Uint32Array]",
          "[object Float32Array]",
          "[object Float64Array]"
        ], se = ArrayBuffer.isView || function(ce) {
          return ce && ie.indexOf(Object.prototype.toString.call(ce)) > -1;
        };
      function de(ce) {
        if (typeof ce != "string" && (ce = String(ce)), /[^a-z0-9\-#$%&'*+.^_`|~]/i.test(ce))
          throw new TypeError("Invalid character in header field name");
        return ce.toLowerCase();
      }
      function ue(ce) {
        return typeof ce != "string" && (ce = String(ce)), ce;
      }
      function fe(ce) {
        var le = {
          next: function() {
            var pe = ce.shift();
            return { done: pe === void 0, value: pe };
          }
        };
        return te.iterable && (le[Symbol.iterator] = function() {
          return le;
        }), le;
      }
      function he(ce) {
        this.map = {}, ce instanceof he ? ce.forEach(function(le, pe) {
          this.append(pe, le);
        }, this) : Array.isArray(ce) ? ce.forEach(function(le) {
          this.append(le[0], le[1]);
        }, this) : ce && Object.getOwnPropertyNames(ce).forEach(function(le) {
          this.append(le, ce[le]);
        }, this);
      }
      he.prototype.append = function(ce, le) {
        ce = de(ce), le = ue(le);
        var pe = this.map[ce];
        this.map[ce] = pe ? pe + ", " + le : le;
      }, he.prototype.delete = function(ce) {
        delete this.map[de(ce)];
      }, he.prototype.get = function(ce) {
        return ce = de(ce), this.has(ce) ? this.map[ce] : null;
      }, he.prototype.has = function(ce) {
        return this.map.hasOwnProperty(de(ce));
      }, he.prototype.set = function(ce, le) {
        this.map[de(ce)] = ue(le);
      }, he.prototype.forEach = function(ce, le) {
        for (var pe in this.map)
          this.map.hasOwnProperty(pe) && ce.call(le, this.map[pe], pe, this);
      }, he.prototype.keys = function() {
        var ce = [];
        return this.forEach(function(le, pe) {
          ce.push(pe);
        }), fe(ce);
      }, he.prototype.values = function() {
        var ce = [];
        return this.forEach(function(le) {
          ce.push(le);
        }), fe(ce);
      }, he.prototype.entries = function() {
        var ce = [];
        return this.forEach(function(le, pe) {
          ce.push([pe, le]);
        }), fe(ce);
      }, te.iterable && (he.prototype[Symbol.iterator] = he.prototype.entries);
      function me(ce) {
        if (ce.bodyUsed)
          return Promise.reject(new TypeError("Already read"));
        ce.bodyUsed = !0;
      }
      function xe(ce) {
        return new Promise(function(le, pe) {
          ce.onload = function() {
            le(ce.result);
          }, ce.onerror = function() {
            pe(ce.error);
          };
        });
      }
      function ve(ce) {
        var le = new FileReader(), pe = xe(le);
        return le.readAsArrayBuffer(ce), pe;
      }
      function Te(ce) {
        var le = new FileReader(), pe = xe(le);
        return le.readAsText(ce), pe;
      }
      function we(ce) {
        for (var le = new Uint8Array(ce), pe = new Array(le.length), ye = 0; ye < le.length; ye++)
          pe[ye] = String.fromCharCode(le[ye]);
        return pe.join("");
      }
      function Ee(ce) {
        if (ce.slice)
          return ce.slice(0);
        var le = new Uint8Array(ce.byteLength);
        return le.set(new Uint8Array(ce)), le.buffer;
      }
      function Me() {
        return this.bodyUsed = !1, this._initBody = function(ce) {
          this._bodyInit = ce, ce ? typeof ce == "string" ? this._bodyText = ce : te.blob && Blob.prototype.isPrototypeOf(ce) ? this._bodyBlob = ce : te.formData && FormData.prototype.isPrototypeOf(ce) ? this._bodyFormData = ce : te.searchParams && URLSearchParams.prototype.isPrototypeOf(ce) ? this._bodyText = ce.toString() : te.arrayBuffer && te.blob && re(ce) ? (this._bodyArrayBuffer = Ee(ce.buffer), this._bodyInit = new Blob([this._bodyArrayBuffer])) : te.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(ce) || se(ce)) ? this._bodyArrayBuffer = Ee(ce) : this._bodyText = ce = Object.prototype.toString.call(ce) : this._bodyText = "", this.headers.get("content-type") || (typeof ce == "string" ? this.headers.set("content-type", "text/plain;charset=UTF-8") : this._bodyBlob && this._bodyBlob.type ? this.headers.set("content-type", this._bodyBlob.type) : te.searchParams && URLSearchParams.prototype.isPrototypeOf(ce) && this.headers.set("content-type", "application/x-www-form-urlencoded;charset=UTF-8"));
        }, te.blob && (this.blob = function() {
          var ce = me(this);
          if (ce)
            return ce;
          if (this._bodyBlob)
            return Promise.resolve(this._bodyBlob);
          if (this._bodyArrayBuffer)
            return Promise.resolve(new Blob([this._bodyArrayBuffer]));
          if (this._bodyFormData)
            throw new Error("could not read FormData body as blob");
          return Promise.resolve(new Blob([this._bodyText]));
        }, this.arrayBuffer = function() {
          return this._bodyArrayBuffer ? me(this) || Promise.resolve(this._bodyArrayBuffer) : this.blob().then(ve);
        }), this.text = function() {
          var ce = me(this);
          if (ce)
            return ce;
          if (this._bodyBlob)
            return Te(this._bodyBlob);
          if (this._bodyArrayBuffer)
            return Promise.resolve(we(this._bodyArrayBuffer));
          if (this._bodyFormData)
            throw new Error("could not read FormData body as text");
          return Promise.resolve(this._bodyText);
        }, te.formData && (this.formData = function() {
          return this.text().then(De);
        }), this.json = function() {
          return this.text().then(JSON.parse);
        }, this;
      }
      var Ie = ["DELETE", "GET", "HEAD", "OPTIONS", "POST", "PUT"];
      function ke(ce) {
        var le = ce.toUpperCase();
        return Ie.indexOf(le) > -1 ? le : ce;
      }
      function _e(ce, le) {
        le = le || {};
        var pe = le.body;
        if (ce instanceof _e) {
          if (ce.bodyUsed)
            throw new TypeError("Already read");
          this.url = ce.url, this.credentials = ce.credentials, le.headers || (this.headers = new he(ce.headers)), this.method = ce.method, this.mode = ce.mode, this.signal = ce.signal, !pe && ce._bodyInit != null && (pe = ce._bodyInit, ce.bodyUsed = !0);
        } else
          this.url = String(ce);
        if (this.credentials = le.credentials || this.credentials || "same-origin", (le.headers || !this.headers) && (this.headers = new he(le.headers)), this.method = ke(le.method || this.method || "GET"), this.mode = le.mode || this.mode || null, this.signal = le.signal || this.signal, this.referrer = null, (this.method === "GET" || this.method === "HEAD") && pe)
          throw new TypeError("Body not allowed for GET or HEAD requests");
        this._initBody(pe);
      }
      _e.prototype.clone = function() {
        return new _e(this, { body: this._bodyInit });
      };
      function De(ce) {
        var le = new FormData();
        return ce.trim().split("&").forEach(function(pe) {
          if (pe) {
            var ye = pe.split("="), Ce = ye.shift().replace(/\+/g, " "), be = ye.join("=").replace(/\+/g, " ");
            le.append(decodeURIComponent(Ce), decodeURIComponent(be));
          }
        }), le;
      }
      function Fe(ce) {
        var le = new he(), pe = ce.replace(/\r?\n[\t ]+/g, " ");
        return pe.split(/\r?\n/).forEach(function(ye) {
          var Ce = ye.split(":"), be = Ce.shift().trim();
          if (be) {
            var ae = Ce.join(":").trim();
            le.append(be, ae);
          }
        }), le;
      }
      Me.call(_e.prototype);
      function Ae(ce, le) {
        le || (le = {}), this.type = "default", this.status = le.status === void 0 ? 200 : le.status, this.ok = this.status >= 200 && this.status < 300, this.statusText = "statusText" in le ? le.statusText : "OK", this.headers = new he(le.headers), this.url = le.url || "", this._initBody(ce);
      }
      Me.call(Ae.prototype), Ae.prototype.clone = function() {
        return new Ae(this._bodyInit, {
          status: this.status,
          statusText: this.statusText,
          headers: new he(this.headers),
          url: this.url
        });
      }, Ae.error = function() {
        var ce = new Ae(null, { status: 0, statusText: "" });
        return ce.type = "error", ce;
      };
      var ne = [301, 302, 303, 307, 308];
      Ae.redirect = function(ce, le) {
        if (ne.indexOf(le) === -1)
          throw new RangeError("Invalid status code");
        return new Ae(null, { status: le, headers: { location: ce } });
      }, ee.DOMException = J.DOMException;
      try {
        new ee.DOMException();
      } catch {
        ee.DOMException = function(le, pe) {
          this.message = le, this.name = pe;
          var ye = Error(le);
          this.stack = ye.stack;
        }, ee.DOMException.prototype = Object.create(Error.prototype), ee.DOMException.prototype.constructor = ee.DOMException;
      }
      function oe(ce, le) {
        return new Promise(function(pe, ye) {
          var Ce = new _e(ce, le);
          if (Ce.signal && Ce.signal.aborted)
            return ye(new ee.DOMException("Aborted", "AbortError"));
          var be = new XMLHttpRequest();
          function ae() {
            be.abort();
          }
          be.onload = function() {
            var ge = {
              status: be.status,
              statusText: be.statusText,
              headers: Fe(be.getAllResponseHeaders() || "")
            };
            ge.url = "responseURL" in be ? be.responseURL : ge.headers.get("X-Request-URL");
            var Se = "response" in be ? be.response : be.responseText;
            pe(new Ae(Se, ge));
          }, be.onerror = function() {
            ye(new TypeError("Network request failed"));
          }, be.ontimeout = function() {
            ye(new TypeError("Network request failed"));
          }, be.onabort = function() {
            ye(new ee.DOMException("Aborted", "AbortError"));
          }, be.open(Ce.method, Ce.url, !0), Ce.credentials === "include" ? be.withCredentials = !0 : Ce.credentials === "omit" && (be.withCredentials = !1), "responseType" in be && te.blob && (be.responseType = "blob"), Ce.headers.forEach(function(ge, Se) {
            be.setRequestHeader(Se, ge);
          }), Ce.signal && (Ce.signal.addEventListener("abort", ae), be.onreadystatechange = function() {
            be.readyState === 4 && Ce.signal.removeEventListener("abort", ae);
          }), be.send(typeof Ce._bodyInit > "u" ? null : Ce._bodyInit);
        });
      }
      return oe.polyfill = !0, J.fetch || (J.fetch = oe, J.Headers = he, J.Request = _e, J.Response = Ae), ee.Headers = he, ee.Request = _e, ee.Response = Ae, ee.fetch = oe, Object.defineProperty(ee, "__esModule", { value: !0 }), ee;
    })({});
  })($), $.fetch.ponyfill = !0, delete $.fetch.polyfill;
  var V = $;
  e = V.fetch, e.default = V.fetch, e.fetch = V.fetch, e.Headers = V.Headers, e.Request = V.Request, e.Response = V.Response, C.exports = e;
})(browserPonyfill, browserPonyfill.exports);
var browserPonyfillExports = browserPonyfill.exports;
const o = /* @__PURE__ */ getDefaultExportFromCjs$2(browserPonyfillExports);
var sha3$1 = { exports: {} };
(function(C) {
  (function() {
    var e = "input is invalid type", T = "finalize already called", $ = typeof window == "object", V = $ ? window : {};
    V.JS_SHA3_NO_WINDOW && ($ = !1);
    var J = !$ && typeof self == "object", ee = !V.JS_SHA3_NO_NODE_JS && typeof dist$2.process == "object" && dist$2.process.versions && dist$2.process.versions.node;
    ee ? V = commonjsGlobal$1 : J && (V = self);
    var te = !V.JS_SHA3_NO_COMMON_JS && !0 && C.exports, re = !V.JS_SHA3_NO_ARRAY_BUFFER && typeof ArrayBuffer < "u", ie = "0123456789abcdef".split(""), se = [31, 7936, 2031616, 520093696], de = [4, 1024, 262144, 67108864], ue = [1, 256, 65536, 16777216], fe = [6, 1536, 393216, 100663296], he = [0, 8, 16, 24], me = [
      1,
      0,
      32898,
      0,
      32906,
      2147483648,
      2147516416,
      2147483648,
      32907,
      0,
      2147483649,
      0,
      2147516545,
      2147483648,
      32777,
      2147483648,
      138,
      0,
      136,
      0,
      2147516425,
      0,
      2147483658,
      0,
      2147516555,
      0,
      139,
      2147483648,
      32905,
      2147483648,
      32771,
      2147483648,
      32770,
      2147483648,
      128,
      2147483648,
      32778,
      0,
      2147483658,
      2147483648,
      2147516545,
      2147483648,
      32896,
      2147483648,
      2147483649,
      0,
      2147516424,
      2147483648
    ], xe = [224, 256, 384, 512], ve = [128, 256], Te = ["hex", "buffer", "arrayBuffer", "array", "digest"], we = {
      128: 168,
      256: 136
    };
    (V.JS_SHA3_NO_NODE_JS || !Array.isArray) && (Array.isArray = function(Re) {
      return Object.prototype.toString.call(Re) === "[object Array]";
    }), re && (V.JS_SHA3_NO_ARRAY_BUFFER_IS_VIEW || !ArrayBuffer.isView) && (ArrayBuffer.isView = function(Re) {
      return typeof Re == "object" && Re.buffer && Re.buffer.constructor === ArrayBuffer;
    });
    for (var Ee = function(Re, We, Be) {
      return function(Ue) {
        return new Se(Re, We, Re).update(Ue)[Be]();
      };
    }, Me = function(Re, We, Be) {
      return function(Ue, Ge) {
        return new Se(Re, We, Ge).update(Ue)[Be]();
      };
    }, Ie = function(Re, We, Be) {
      return function(Ue, Ge, je, Oe) {
        return ce["cshake" + Re].update(Ue, Ge, je, Oe)[Be]();
      };
    }, ke = function(Re, We, Be) {
      return function(Ue, Ge, je, Oe) {
        return ce["kmac" + Re].update(Ue, Ge, je, Oe)[Be]();
      };
    }, _e = function(Re, We, Be, Ue) {
      for (var Ge = 0; Ge < Te.length; ++Ge) {
        var je = Te[Ge];
        Re[je] = We(Be, Ue, je);
      }
      return Re;
    }, De = function(Re, We) {
      var Be = Ee(Re, We, "hex");
      return Be.create = function() {
        return new Se(Re, We, Re);
      }, Be.update = function(Ue) {
        return Be.create().update(Ue);
      }, _e(Be, Ee, Re, We);
    }, Fe = function(Re, We) {
      var Be = Me(Re, We, "hex");
      return Be.create = function(Ue) {
        return new Se(Re, We, Ue);
      }, Be.update = function(Ue, Ge) {
        return Be.create(Ge).update(Ue);
      }, _e(Be, Me, Re, We);
    }, Ae = function(Re, We) {
      var Be = we[Re], Ue = Ie(Re, We, "hex");
      return Ue.create = function(Ge, je, Oe) {
        return !je && !Oe ? ce["shake" + Re].create(Ge) : new Se(Re, We, Ge).bytepad([je, Oe], Be);
      }, Ue.update = function(Ge, je, Oe, Ne) {
        return Ue.create(je, Oe, Ne).update(Ge);
      }, _e(Ue, Ie, Re, We);
    }, ne = function(Re, We) {
      var Be = we[Re], Ue = ke(Re, We, "hex");
      return Ue.create = function(Ge, je, Oe) {
        return new Le(Re, We, je).bytepad(["KMAC", Oe], Be).bytepad([Ge], Be);
      }, Ue.update = function(Ge, je, Oe, Ne) {
        return Ue.create(Ge, Oe, Ne).update(je);
      }, _e(Ue, ke, Re, We);
    }, oe = [
      { name: "keccak", padding: ue, bits: xe, createMethod: De },
      { name: "sha3", padding: fe, bits: xe, createMethod: De },
      { name: "shake", padding: se, bits: ve, createMethod: Fe },
      { name: "cshake", padding: de, bits: ve, createMethod: Ae },
      { name: "kmac", padding: de, bits: ve, createMethod: ne }
    ], ce = {}, le = [], pe = 0; pe < oe.length; ++pe)
      for (var ye = oe[pe], Ce = ye.bits, be = 0; be < Ce.length; ++be) {
        var ae = ye.name + "_" + Ce[be];
        if (le.push(ae), ce[ae] = ye.createMethod(Ce[be], ye.padding), ye.name !== "sha3") {
          var ge = ye.name + Ce[be];
          le.push(ge), ce[ge] = ce[ae];
        }
      }
    function Se(Re, We, Be) {
      this.blocks = [], this.s = [], this.padding = We, this.outputBits = Be, this.reset = !0, this.finalized = !1, this.block = 0, this.start = 0, this.blockCount = 1600 - (Re << 1) >> 5, this.byteCount = this.blockCount << 2, this.outputBlocks = Be >> 5, this.extraBytes = (Be & 31) >> 3;
      for (var Ue = 0; Ue < 50; ++Ue)
        this.s[Ue] = 0;
    }
    Se.prototype.update = function(Re) {
      if (this.finalized)
        throw new Error(T);
      var We, Be = typeof Re;
      if (Be !== "string") {
        if (Be === "object") {
          if (Re === null)
            throw new Error(e);
          if (re && Re.constructor === ArrayBuffer)
            Re = new Uint8Array(Re);
          else if (!Array.isArray(Re) && (!re || !ArrayBuffer.isView(Re)))
            throw new Error(e);
        } else
          throw new Error(e);
        We = !0;
      }
      for (var Ue = this.blocks, Ge = this.byteCount, je = Re.length, Oe = this.blockCount, Ne = 0, Ye = this.s, Je, Xe; Ne < je; ) {
        if (this.reset)
          for (this.reset = !1, Ue[0] = this.block, Je = 1; Je < Oe + 1; ++Je)
            Ue[Je] = 0;
        if (We)
          for (Je = this.start; Ne < je && Je < Ge; ++Ne)
            Ue[Je >> 2] |= Re[Ne] << he[Je++ & 3];
        else
          for (Je = this.start; Ne < je && Je < Ge; ++Ne)
            Xe = Re.charCodeAt(Ne), Xe < 128 ? Ue[Je >> 2] |= Xe << he[Je++ & 3] : Xe < 2048 ? (Ue[Je >> 2] |= (192 | Xe >> 6) << he[Je++ & 3], Ue[Je >> 2] |= (128 | Xe & 63) << he[Je++ & 3]) : Xe < 55296 || Xe >= 57344 ? (Ue[Je >> 2] |= (224 | Xe >> 12) << he[Je++ & 3], Ue[Je >> 2] |= (128 | Xe >> 6 & 63) << he[Je++ & 3], Ue[Je >> 2] |= (128 | Xe & 63) << he[Je++ & 3]) : (Xe = 65536 + ((Xe & 1023) << 10 | Re.charCodeAt(++Ne) & 1023), Ue[Je >> 2] |= (240 | Xe >> 18) << he[Je++ & 3], Ue[Je >> 2] |= (128 | Xe >> 12 & 63) << he[Je++ & 3], Ue[Je >> 2] |= (128 | Xe >> 6 & 63) << he[Je++ & 3], Ue[Je >> 2] |= (128 | Xe & 63) << he[Je++ & 3]);
        if (this.lastByteIndex = Je, Je >= Ge) {
          for (this.start = Je - Ge, this.block = Ue[Oe], Je = 0; Je < Oe; ++Je)
            Ye[Je] ^= Ue[Je];
          ze(Ye), this.reset = !0;
        } else
          this.start = Je;
      }
      return this;
    }, Se.prototype.encode = function(Re, We) {
      var Be = Re & 255, Ue = 1, Ge = [Be];
      for (Re = Re >> 8, Be = Re & 255; Be > 0; )
        Ge.unshift(Be), Re = Re >> 8, Be = Re & 255, ++Ue;
      return We ? Ge.push(Ue) : Ge.unshift(Ue), this.update(Ge), Ge.length;
    }, Se.prototype.encodeString = function(Re) {
      var We, Be = typeof Re;
      if (Be !== "string") {
        if (Be === "object") {
          if (Re === null)
            throw new Error(e);
          if (re && Re.constructor === ArrayBuffer)
            Re = new Uint8Array(Re);
          else if (!Array.isArray(Re) && (!re || !ArrayBuffer.isView(Re)))
            throw new Error(e);
        } else
          throw new Error(e);
        We = !0;
      }
      var Ue = 0, Ge = Re.length;
      if (We)
        Ue = Ge;
      else
        for (var je = 0; je < Re.length; ++je) {
          var Oe = Re.charCodeAt(je);
          Oe < 128 ? Ue += 1 : Oe < 2048 ? Ue += 2 : Oe < 55296 || Oe >= 57344 ? Ue += 3 : (Oe = 65536 + ((Oe & 1023) << 10 | Re.charCodeAt(++je) & 1023), Ue += 4);
        }
      return Ue += this.encode(Ue * 8), this.update(Re), Ue;
    }, Se.prototype.bytepad = function(Re, We) {
      for (var Be = this.encode(We), Ue = 0; Ue < Re.length; ++Ue)
        Be += this.encodeString(Re[Ue]);
      var Ge = We - Be % We, je = [];
      return je.length = Ge, this.update(je), this;
    }, Se.prototype.finalize = function() {
      if (!this.finalized) {
        this.finalized = !0;
        var Re = this.blocks, We = this.lastByteIndex, Be = this.blockCount, Ue = this.s;
        if (Re[We >> 2] |= this.padding[We & 3], this.lastByteIndex === this.byteCount)
          for (Re[0] = Re[Be], We = 1; We < Be + 1; ++We)
            Re[We] = 0;
        for (Re[Be - 1] |= 2147483648, We = 0; We < Be; ++We)
          Ue[We] ^= Re[We];
        ze(Ue);
      }
    }, Se.prototype.toString = Se.prototype.hex = function() {
      this.finalize();
      for (var Re = this.blockCount, We = this.s, Be = this.outputBlocks, Ue = this.extraBytes, Ge = 0, je = 0, Oe = "", Ne; je < Be; ) {
        for (Ge = 0; Ge < Re && je < Be; ++Ge, ++je)
          Ne = We[Ge], Oe += ie[Ne >> 4 & 15] + ie[Ne & 15] + ie[Ne >> 12 & 15] + ie[Ne >> 8 & 15] + ie[Ne >> 20 & 15] + ie[Ne >> 16 & 15] + ie[Ne >> 28 & 15] + ie[Ne >> 24 & 15];
        je % Re === 0 && (ze(We), Ge = 0);
      }
      return Ue && (Ne = We[Ge], Oe += ie[Ne >> 4 & 15] + ie[Ne & 15], Ue > 1 && (Oe += ie[Ne >> 12 & 15] + ie[Ne >> 8 & 15]), Ue > 2 && (Oe += ie[Ne >> 20 & 15] + ie[Ne >> 16 & 15])), Oe;
    }, Se.prototype.arrayBuffer = function() {
      this.finalize();
      var Re = this.blockCount, We = this.s, Be = this.outputBlocks, Ue = this.extraBytes, Ge = 0, je = 0, Oe = this.outputBits >> 3, Ne;
      Ue ? Ne = new ArrayBuffer(Be + 1 << 2) : Ne = new ArrayBuffer(Oe);
      for (var Ye = new Uint32Array(Ne); je < Be; ) {
        for (Ge = 0; Ge < Re && je < Be; ++Ge, ++je)
          Ye[je] = We[Ge];
        je % Re === 0 && ze(We);
      }
      return Ue && (Ye[Ge] = We[Ge], Ne = Ne.slice(0, Oe)), Ne;
    }, Se.prototype.buffer = Se.prototype.arrayBuffer, Se.prototype.digest = Se.prototype.array = function() {
      this.finalize();
      for (var Re = this.blockCount, We = this.s, Be = this.outputBlocks, Ue = this.extraBytes, Ge = 0, je = 0, Oe = [], Ne, Ye; je < Be; ) {
        for (Ge = 0; Ge < Re && je < Be; ++Ge, ++je)
          Ne = je << 2, Ye = We[Ge], Oe[Ne] = Ye & 255, Oe[Ne + 1] = Ye >> 8 & 255, Oe[Ne + 2] = Ye >> 16 & 255, Oe[Ne + 3] = Ye >> 24 & 255;
        je % Re === 0 && ze(We);
      }
      return Ue && (Ne = je << 2, Ye = We[Ge], Oe[Ne] = Ye & 255, Ue > 1 && (Oe[Ne + 1] = Ye >> 8 & 255), Ue > 2 && (Oe[Ne + 2] = Ye >> 16 & 255)), Oe;
    };
    function Le(Re, We, Be) {
      Se.call(this, Re, We, Be);
    }
    Le.prototype = new Se(), Le.prototype.finalize = function() {
      return this.encode(this.outputBits, !0), Se.prototype.finalize.call(this);
    };
    var ze = function(Re) {
      var We, Be, Ue, Ge, je, Oe, Ne, Ye, Je, Xe, st, ct, it, ot, yt, dt, mt, It, xt, Tt, Yt, Ve, Pe, $e, Ze, at, wt, ft, Ct, Ut, vt, Mt, Xt, St, Ot, wn, kt, Bt, Tn, Nt, Wt, En, Lt, Ht, In, Dt, Gt, Ke, Qe, et, He, nt, qe, ht, pt, bt, jt, $t, Jt, zt, Vt, Kt, pn;
      for (Ue = 0; Ue < 48; Ue += 2)
        Ge = Re[0] ^ Re[10] ^ Re[20] ^ Re[30] ^ Re[40], je = Re[1] ^ Re[11] ^ Re[21] ^ Re[31] ^ Re[41], Oe = Re[2] ^ Re[12] ^ Re[22] ^ Re[32] ^ Re[42], Ne = Re[3] ^ Re[13] ^ Re[23] ^ Re[33] ^ Re[43], Ye = Re[4] ^ Re[14] ^ Re[24] ^ Re[34] ^ Re[44], Je = Re[5] ^ Re[15] ^ Re[25] ^ Re[35] ^ Re[45], Xe = Re[6] ^ Re[16] ^ Re[26] ^ Re[36] ^ Re[46], st = Re[7] ^ Re[17] ^ Re[27] ^ Re[37] ^ Re[47], ct = Re[8] ^ Re[18] ^ Re[28] ^ Re[38] ^ Re[48], it = Re[9] ^ Re[19] ^ Re[29] ^ Re[39] ^ Re[49], We = ct ^ (Oe << 1 | Ne >>> 31), Be = it ^ (Ne << 1 | Oe >>> 31), Re[0] ^= We, Re[1] ^= Be, Re[10] ^= We, Re[11] ^= Be, Re[20] ^= We, Re[21] ^= Be, Re[30] ^= We, Re[31] ^= Be, Re[40] ^= We, Re[41] ^= Be, We = Ge ^ (Ye << 1 | Je >>> 31), Be = je ^ (Je << 1 | Ye >>> 31), Re[2] ^= We, Re[3] ^= Be, Re[12] ^= We, Re[13] ^= Be, Re[22] ^= We, Re[23] ^= Be, Re[32] ^= We, Re[33] ^= Be, Re[42] ^= We, Re[43] ^= Be, We = Oe ^ (Xe << 1 | st >>> 31), Be = Ne ^ (st << 1 | Xe >>> 31), Re[4] ^= We, Re[5] ^= Be, Re[14] ^= We, Re[15] ^= Be, Re[24] ^= We, Re[25] ^= Be, Re[34] ^= We, Re[35] ^= Be, Re[44] ^= We, Re[45] ^= Be, We = Ye ^ (ct << 1 | it >>> 31), Be = Je ^ (it << 1 | ct >>> 31), Re[6] ^= We, Re[7] ^= Be, Re[16] ^= We, Re[17] ^= Be, Re[26] ^= We, Re[27] ^= Be, Re[36] ^= We, Re[37] ^= Be, Re[46] ^= We, Re[47] ^= Be, We = Xe ^ (Ge << 1 | je >>> 31), Be = st ^ (je << 1 | Ge >>> 31), Re[8] ^= We, Re[9] ^= Be, Re[18] ^= We, Re[19] ^= Be, Re[28] ^= We, Re[29] ^= Be, Re[38] ^= We, Re[39] ^= Be, Re[48] ^= We, Re[49] ^= Be, ot = Re[0], yt = Re[1], Dt = Re[11] << 4 | Re[10] >>> 28, Gt = Re[10] << 4 | Re[11] >>> 28, ft = Re[20] << 3 | Re[21] >>> 29, Ct = Re[21] << 3 | Re[20] >>> 29, zt = Re[31] << 9 | Re[30] >>> 23, Vt = Re[30] << 9 | Re[31] >>> 23, En = Re[40] << 18 | Re[41] >>> 14, Lt = Re[41] << 18 | Re[40] >>> 14, St = Re[2] << 1 | Re[3] >>> 31, Ot = Re[3] << 1 | Re[2] >>> 31, dt = Re[13] << 12 | Re[12] >>> 20, mt = Re[12] << 12 | Re[13] >>> 20, Ke = Re[22] << 10 | Re[23] >>> 22, Qe = Re[23] << 10 | Re[22] >>> 22, Ut = Re[33] << 13 | Re[32] >>> 19, vt = Re[32] << 13 | Re[33] >>> 19, Kt = Re[42] << 2 | Re[43] >>> 30, pn = Re[43] << 2 | Re[42] >>> 30, ht = Re[5] << 30 | Re[4] >>> 2, pt = Re[4] << 30 | Re[5] >>> 2, wn = Re[14] << 6 | Re[15] >>> 26, kt = Re[15] << 6 | Re[14] >>> 26, It = Re[25] << 11 | Re[24] >>> 21, xt = Re[24] << 11 | Re[25] >>> 21, et = Re[34] << 15 | Re[35] >>> 17, He = Re[35] << 15 | Re[34] >>> 17, Mt = Re[45] << 29 | Re[44] >>> 3, Xt = Re[44] << 29 | Re[45] >>> 3, $e = Re[6] << 28 | Re[7] >>> 4, Ze = Re[7] << 28 | Re[6] >>> 4, bt = Re[17] << 23 | Re[16] >>> 9, jt = Re[16] << 23 | Re[17] >>> 9, Bt = Re[26] << 25 | Re[27] >>> 7, Tn = Re[27] << 25 | Re[26] >>> 7, Tt = Re[36] << 21 | Re[37] >>> 11, Yt = Re[37] << 21 | Re[36] >>> 11, nt = Re[47] << 24 | Re[46] >>> 8, qe = Re[46] << 24 | Re[47] >>> 8, Ht = Re[8] << 27 | Re[9] >>> 5, In = Re[9] << 27 | Re[8] >>> 5, at = Re[18] << 20 | Re[19] >>> 12, wt = Re[19] << 20 | Re[18] >>> 12, $t = Re[29] << 7 | Re[28] >>> 25, Jt = Re[28] << 7 | Re[29] >>> 25, Nt = Re[38] << 8 | Re[39] >>> 24, Wt = Re[39] << 8 | Re[38] >>> 24, Ve = Re[48] << 14 | Re[49] >>> 18, Pe = Re[49] << 14 | Re[48] >>> 18, Re[0] = ot ^ ~dt & It, Re[1] = yt ^ ~mt & xt, Re[10] = $e ^ ~at & ft, Re[11] = Ze ^ ~wt & Ct, Re[20] = St ^ ~wn & Bt, Re[21] = Ot ^ ~kt & Tn, Re[30] = Ht ^ ~Dt & Ke, Re[31] = In ^ ~Gt & Qe, Re[40] = ht ^ ~bt & $t, Re[41] = pt ^ ~jt & Jt, Re[2] = dt ^ ~It & Tt, Re[3] = mt ^ ~xt & Yt, Re[12] = at ^ ~ft & Ut, Re[13] = wt ^ ~Ct & vt, Re[22] = wn ^ ~Bt & Nt, Re[23] = kt ^ ~Tn & Wt, Re[32] = Dt ^ ~Ke & et, Re[33] = Gt ^ ~Qe & He, Re[42] = bt ^ ~$t & zt, Re[43] = jt ^ ~Jt & Vt, Re[4] = It ^ ~Tt & Ve, Re[5] = xt ^ ~Yt & Pe, Re[14] = ft ^ ~Ut & Mt, Re[15] = Ct ^ ~vt & Xt, Re[24] = Bt ^ ~Nt & En, Re[25] = Tn ^ ~Wt & Lt, Re[34] = Ke ^ ~et & nt, Re[35] = Qe ^ ~He & qe, Re[44] = $t ^ ~zt & Kt, Re[45] = Jt ^ ~Vt & pn, Re[6] = Tt ^ ~Ve & ot, Re[7] = Yt ^ ~Pe & yt, Re[16] = Ut ^ ~Mt & $e, Re[17] = vt ^ ~Xt & Ze, Re[26] = Nt ^ ~En & St, Re[27] = Wt ^ ~Lt & Ot, Re[36] = et ^ ~nt & Ht, Re[37] = He ^ ~qe & In, Re[46] = zt ^ ~Kt & ht, Re[47] = Vt ^ ~pn & pt, Re[8] = Ve ^ ~ot & dt, Re[9] = Pe ^ ~yt & mt, Re[18] = Mt ^ ~$e & at, Re[19] = Xt ^ ~Ze & wt, Re[28] = En ^ ~St & wn, Re[29] = Lt ^ ~Ot & kt, Re[38] = nt ^ ~Ht & Dt, Re[39] = qe ^ ~In & Gt, Re[48] = Kt ^ ~ht & bt, Re[49] = pn ^ ~pt & jt, Re[0] ^= me[Ue], Re[1] ^= me[Ue + 1];
    };
    if (te)
      C.exports = ce;
    else
      for (pe = 0; pe < le.length; ++pe)
        V[le[pe]] = ce[le[pe]];
  })();
})(sha3$1);
var sha3Exports = sha3$1.exports;
const sha3 = /* @__PURE__ */ getDefaultExportFromCjs$2(sha3Exports);
var sha256 = { exports: {} };
(function(module) {
  (function() {
    var ERROR = "input is invalid type", WINDOW = typeof window == "object", root = WINDOW ? window : {};
    root.JS_SHA256_NO_WINDOW && (WINDOW = !1);
    var WEB_WORKER = !WINDOW && typeof self == "object", NODE_JS = !root.JS_SHA256_NO_NODE_JS && typeof dist$2.process == "object" && dist$2.process.versions && dist$2.process.versions.node;
    NODE_JS ? root = commonjsGlobal$1 : WEB_WORKER && (root = self);
    var COMMON_JS = !root.JS_SHA256_NO_COMMON_JS && !0 && module.exports, ARRAY_BUFFER = !root.JS_SHA256_NO_ARRAY_BUFFER && typeof ArrayBuffer < "u", HEX_CHARS = "0123456789abcdef".split(""), EXTRA = [-2147483648, 8388608, 32768, 128], SHIFT = [24, 16, 8, 0], K = [
      1116352408,
      1899447441,
      3049323471,
      3921009573,
      961987163,
      1508970993,
      2453635748,
      2870763221,
      3624381080,
      310598401,
      607225278,
      1426881987,
      1925078388,
      2162078206,
      2614888103,
      3248222580,
      3835390401,
      4022224774,
      264347078,
      604807628,
      770255983,
      1249150122,
      1555081692,
      1996064986,
      2554220882,
      2821834349,
      2952996808,
      3210313671,
      3336571891,
      3584528711,
      113926993,
      338241895,
      666307205,
      773529912,
      1294757372,
      1396182291,
      1695183700,
      1986661051,
      2177026350,
      2456956037,
      2730485921,
      2820302411,
      3259730800,
      3345764771,
      3516065817,
      3600352804,
      4094571909,
      275423344,
      430227734,
      506948616,
      659060556,
      883997877,
      958139571,
      1322822218,
      1537002063,
      1747873779,
      1955562222,
      2024104815,
      2227730452,
      2361852424,
      2428436474,
      2756734187,
      3204031479,
      3329325298
    ], OUTPUT_TYPES = ["hex", "array", "digest", "arrayBuffer"], blocks = [];
    (root.JS_SHA256_NO_NODE_JS || !Array.isArray) && (Array.isArray = function(C) {
      return Object.prototype.toString.call(C) === "[object Array]";
    }), ARRAY_BUFFER && (root.JS_SHA256_NO_ARRAY_BUFFER_IS_VIEW || !ArrayBuffer.isView) && (ArrayBuffer.isView = function(C) {
      return typeof C == "object" && C.buffer && C.buffer.constructor === ArrayBuffer;
    });
    var createOutputMethod = function(C, e) {
      return function(T) {
        return new Sha256(e, !0).update(T)[C]();
      };
    }, createMethod = function(C) {
      var e = createOutputMethod("hex", C);
      NODE_JS && (e = nodeWrap(e, C)), e.create = function() {
        return new Sha256(C);
      }, e.update = function(V) {
        return e.create().update(V);
      };
      for (var T = 0; T < OUTPUT_TYPES.length; ++T) {
        var $ = OUTPUT_TYPES[T];
        e[$] = createOutputMethod($, C);
      }
      return e;
    }, nodeWrap = function(method, is224) {
      var crypto = eval("require('crypto')"), Buffer = eval("require('buffer').Buffer"), algorithm = is224 ? "sha224" : "sha256", nodeMethod = function(C) {
        if (typeof C == "string")
          return crypto.createHash(algorithm).update(C, "utf8").digest("hex");
        if (C == null)
          throw new Error(ERROR);
        return C.constructor === ArrayBuffer && (C = new Uint8Array(C)), Array.isArray(C) || ArrayBuffer.isView(C) || C.constructor === Buffer ? crypto.createHash(algorithm).update(new Buffer(C)).digest("hex") : method(C);
      };
      return nodeMethod;
    }, createHmacOutputMethod = function(C, e) {
      return function(T, $) {
        return new HmacSha256(T, e, !0).update($)[C]();
      };
    }, createHmacMethod = function(C) {
      var e = createHmacOutputMethod("hex", C);
      e.create = function(V) {
        return new HmacSha256(V, C);
      }, e.update = function(V, J) {
        return e.create(V).update(J);
      };
      for (var T = 0; T < OUTPUT_TYPES.length; ++T) {
        var $ = OUTPUT_TYPES[T];
        e[$] = createHmacOutputMethod($, C);
      }
      return e;
    };
    function Sha256(C, e) {
      e ? (blocks[0] = blocks[16] = blocks[1] = blocks[2] = blocks[3] = blocks[4] = blocks[5] = blocks[6] = blocks[7] = blocks[8] = blocks[9] = blocks[10] = blocks[11] = blocks[12] = blocks[13] = blocks[14] = blocks[15] = 0, this.blocks = blocks) : this.blocks = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], C ? (this.h0 = 3238371032, this.h1 = 914150663, this.h2 = 812702999, this.h3 = 4144912697, this.h4 = 4290775857, this.h5 = 1750603025, this.h6 = 1694076839, this.h7 = 3204075428) : (this.h0 = 1779033703, this.h1 = 3144134277, this.h2 = 1013904242, this.h3 = 2773480762, this.h4 = 1359893119, this.h5 = 2600822924, this.h6 = 528734635, this.h7 = 1541459225), this.block = this.start = this.bytes = this.hBytes = 0, this.finalized = this.hashed = !1, this.first = !0, this.is224 = C;
    }
    Sha256.prototype.update = function(C) {
      if (!this.finalized) {
        var e, T = typeof C;
        if (T !== "string") {
          if (T === "object") {
            if (C === null)
              throw new Error(ERROR);
            if (ARRAY_BUFFER && C.constructor === ArrayBuffer)
              C = new Uint8Array(C);
            else if (!Array.isArray(C) && (!ARRAY_BUFFER || !ArrayBuffer.isView(C)))
              throw new Error(ERROR);
          } else
            throw new Error(ERROR);
          e = !0;
        }
        for (var $, V = 0, J, ee = C.length, te = this.blocks; V < ee; ) {
          if (this.hashed && (this.hashed = !1, te[0] = this.block, te[16] = te[1] = te[2] = te[3] = te[4] = te[5] = te[6] = te[7] = te[8] = te[9] = te[10] = te[11] = te[12] = te[13] = te[14] = te[15] = 0), e)
            for (J = this.start; V < ee && J < 64; ++V)
              te[J >> 2] |= C[V] << SHIFT[J++ & 3];
          else
            for (J = this.start; V < ee && J < 64; ++V)
              $ = C.charCodeAt(V), $ < 128 ? te[J >> 2] |= $ << SHIFT[J++ & 3] : $ < 2048 ? (te[J >> 2] |= (192 | $ >> 6) << SHIFT[J++ & 3], te[J >> 2] |= (128 | $ & 63) << SHIFT[J++ & 3]) : $ < 55296 || $ >= 57344 ? (te[J >> 2] |= (224 | $ >> 12) << SHIFT[J++ & 3], te[J >> 2] |= (128 | $ >> 6 & 63) << SHIFT[J++ & 3], te[J >> 2] |= (128 | $ & 63) << SHIFT[J++ & 3]) : ($ = 65536 + (($ & 1023) << 10 | C.charCodeAt(++V) & 1023), te[J >> 2] |= (240 | $ >> 18) << SHIFT[J++ & 3], te[J >> 2] |= (128 | $ >> 12 & 63) << SHIFT[J++ & 3], te[J >> 2] |= (128 | $ >> 6 & 63) << SHIFT[J++ & 3], te[J >> 2] |= (128 | $ & 63) << SHIFT[J++ & 3]);
          this.lastByteIndex = J, this.bytes += J - this.start, J >= 64 ? (this.block = te[16], this.start = J - 64, this.hash(), this.hashed = !0) : this.start = J;
        }
        return this.bytes > 4294967295 && (this.hBytes += this.bytes / 4294967296 << 0, this.bytes = this.bytes % 4294967296), this;
      }
    }, Sha256.prototype.finalize = function() {
      if (!this.finalized) {
        this.finalized = !0;
        var C = this.blocks, e = this.lastByteIndex;
        C[16] = this.block, C[e >> 2] |= EXTRA[e & 3], this.block = C[16], e >= 56 && (this.hashed || this.hash(), C[0] = this.block, C[16] = C[1] = C[2] = C[3] = C[4] = C[5] = C[6] = C[7] = C[8] = C[9] = C[10] = C[11] = C[12] = C[13] = C[14] = C[15] = 0), C[14] = this.hBytes << 3 | this.bytes >>> 29, C[15] = this.bytes << 3, this.hash();
      }
    }, Sha256.prototype.hash = function() {
      var C = this.h0, e = this.h1, T = this.h2, $ = this.h3, V = this.h4, J = this.h5, ee = this.h6, te = this.h7, re = this.blocks, ie, se, de, ue, fe, he, me, xe, ve, Te, we;
      for (ie = 16; ie < 64; ++ie)
        fe = re[ie - 15], se = (fe >>> 7 | fe << 25) ^ (fe >>> 18 | fe << 14) ^ fe >>> 3, fe = re[ie - 2], de = (fe >>> 17 | fe << 15) ^ (fe >>> 19 | fe << 13) ^ fe >>> 10, re[ie] = re[ie - 16] + se + re[ie - 7] + de << 0;
      for (we = e & T, ie = 0; ie < 64; ie += 4)
        this.first ? (this.is224 ? (xe = 300032, fe = re[0] - 1413257819, te = fe - 150054599 << 0, $ = fe + 24177077 << 0) : (xe = 704751109, fe = re[0] - 210244248, te = fe - 1521486534 << 0, $ = fe + 143694565 << 0), this.first = !1) : (se = (C >>> 2 | C << 30) ^ (C >>> 13 | C << 19) ^ (C >>> 22 | C << 10), de = (V >>> 6 | V << 26) ^ (V >>> 11 | V << 21) ^ (V >>> 25 | V << 7), xe = C & e, ue = xe ^ C & T ^ we, me = V & J ^ ~V & ee, fe = te + de + me + K[ie] + re[ie], he = se + ue, te = $ + fe << 0, $ = fe + he << 0), se = ($ >>> 2 | $ << 30) ^ ($ >>> 13 | $ << 19) ^ ($ >>> 22 | $ << 10), de = (te >>> 6 | te << 26) ^ (te >>> 11 | te << 21) ^ (te >>> 25 | te << 7), ve = $ & C, ue = ve ^ $ & e ^ xe, me = te & V ^ ~te & J, fe = ee + de + me + K[ie + 1] + re[ie + 1], he = se + ue, ee = T + fe << 0, T = fe + he << 0, se = (T >>> 2 | T << 30) ^ (T >>> 13 | T << 19) ^ (T >>> 22 | T << 10), de = (ee >>> 6 | ee << 26) ^ (ee >>> 11 | ee << 21) ^ (ee >>> 25 | ee << 7), Te = T & $, ue = Te ^ T & C ^ ve, me = ee & te ^ ~ee & V, fe = J + de + me + K[ie + 2] + re[ie + 2], he = se + ue, J = e + fe << 0, e = fe + he << 0, se = (e >>> 2 | e << 30) ^ (e >>> 13 | e << 19) ^ (e >>> 22 | e << 10), de = (J >>> 6 | J << 26) ^ (J >>> 11 | J << 21) ^ (J >>> 25 | J << 7), we = e & T, ue = we ^ e & $ ^ Te, me = J & ee ^ ~J & te, fe = V + de + me + K[ie + 3] + re[ie + 3], he = se + ue, V = C + fe << 0, C = fe + he << 0;
      this.h0 = this.h0 + C << 0, this.h1 = this.h1 + e << 0, this.h2 = this.h2 + T << 0, this.h3 = this.h3 + $ << 0, this.h4 = this.h4 + V << 0, this.h5 = this.h5 + J << 0, this.h6 = this.h6 + ee << 0, this.h7 = this.h7 + te << 0;
    }, Sha256.prototype.hex = function() {
      this.finalize();
      var C = this.h0, e = this.h1, T = this.h2, $ = this.h3, V = this.h4, J = this.h5, ee = this.h6, te = this.h7, re = HEX_CHARS[C >> 28 & 15] + HEX_CHARS[C >> 24 & 15] + HEX_CHARS[C >> 20 & 15] + HEX_CHARS[C >> 16 & 15] + HEX_CHARS[C >> 12 & 15] + HEX_CHARS[C >> 8 & 15] + HEX_CHARS[C >> 4 & 15] + HEX_CHARS[C & 15] + HEX_CHARS[e >> 28 & 15] + HEX_CHARS[e >> 24 & 15] + HEX_CHARS[e >> 20 & 15] + HEX_CHARS[e >> 16 & 15] + HEX_CHARS[e >> 12 & 15] + HEX_CHARS[e >> 8 & 15] + HEX_CHARS[e >> 4 & 15] + HEX_CHARS[e & 15] + HEX_CHARS[T >> 28 & 15] + HEX_CHARS[T >> 24 & 15] + HEX_CHARS[T >> 20 & 15] + HEX_CHARS[T >> 16 & 15] + HEX_CHARS[T >> 12 & 15] + HEX_CHARS[T >> 8 & 15] + HEX_CHARS[T >> 4 & 15] + HEX_CHARS[T & 15] + HEX_CHARS[$ >> 28 & 15] + HEX_CHARS[$ >> 24 & 15] + HEX_CHARS[$ >> 20 & 15] + HEX_CHARS[$ >> 16 & 15] + HEX_CHARS[$ >> 12 & 15] + HEX_CHARS[$ >> 8 & 15] + HEX_CHARS[$ >> 4 & 15] + HEX_CHARS[$ & 15] + HEX_CHARS[V >> 28 & 15] + HEX_CHARS[V >> 24 & 15] + HEX_CHARS[V >> 20 & 15] + HEX_CHARS[V >> 16 & 15] + HEX_CHARS[V >> 12 & 15] + HEX_CHARS[V >> 8 & 15] + HEX_CHARS[V >> 4 & 15] + HEX_CHARS[V & 15] + HEX_CHARS[J >> 28 & 15] + HEX_CHARS[J >> 24 & 15] + HEX_CHARS[J >> 20 & 15] + HEX_CHARS[J >> 16 & 15] + HEX_CHARS[J >> 12 & 15] + HEX_CHARS[J >> 8 & 15] + HEX_CHARS[J >> 4 & 15] + HEX_CHARS[J & 15] + HEX_CHARS[ee >> 28 & 15] + HEX_CHARS[ee >> 24 & 15] + HEX_CHARS[ee >> 20 & 15] + HEX_CHARS[ee >> 16 & 15] + HEX_CHARS[ee >> 12 & 15] + HEX_CHARS[ee >> 8 & 15] + HEX_CHARS[ee >> 4 & 15] + HEX_CHARS[ee & 15];
      return this.is224 || (re += HEX_CHARS[te >> 28 & 15] + HEX_CHARS[te >> 24 & 15] + HEX_CHARS[te >> 20 & 15] + HEX_CHARS[te >> 16 & 15] + HEX_CHARS[te >> 12 & 15] + HEX_CHARS[te >> 8 & 15] + HEX_CHARS[te >> 4 & 15] + HEX_CHARS[te & 15]), re;
    }, Sha256.prototype.toString = Sha256.prototype.hex, Sha256.prototype.digest = function() {
      this.finalize();
      var C = this.h0, e = this.h1, T = this.h2, $ = this.h3, V = this.h4, J = this.h5, ee = this.h6, te = this.h7, re = [
        C >> 24 & 255,
        C >> 16 & 255,
        C >> 8 & 255,
        C & 255,
        e >> 24 & 255,
        e >> 16 & 255,
        e >> 8 & 255,
        e & 255,
        T >> 24 & 255,
        T >> 16 & 255,
        T >> 8 & 255,
        T & 255,
        $ >> 24 & 255,
        $ >> 16 & 255,
        $ >> 8 & 255,
        $ & 255,
        V >> 24 & 255,
        V >> 16 & 255,
        V >> 8 & 255,
        V & 255,
        J >> 24 & 255,
        J >> 16 & 255,
        J >> 8 & 255,
        J & 255,
        ee >> 24 & 255,
        ee >> 16 & 255,
        ee >> 8 & 255,
        ee & 255
      ];
      return this.is224 || re.push(te >> 24 & 255, te >> 16 & 255, te >> 8 & 255, te & 255), re;
    }, Sha256.prototype.array = Sha256.prototype.digest, Sha256.prototype.arrayBuffer = function() {
      this.finalize();
      var C = new ArrayBuffer(this.is224 ? 28 : 32), e = new DataView(C);
      return e.setUint32(0, this.h0), e.setUint32(4, this.h1), e.setUint32(8, this.h2), e.setUint32(12, this.h3), e.setUint32(16, this.h4), e.setUint32(20, this.h5), e.setUint32(24, this.h6), this.is224 || e.setUint32(28, this.h7), C;
    };
    function HmacSha256(C, e, T) {
      var $, V = typeof C;
      if (V === "string") {
        var J = [], ee = C.length, te = 0, re;
        for ($ = 0; $ < ee; ++$)
          re = C.charCodeAt($), re < 128 ? J[te++] = re : re < 2048 ? (J[te++] = 192 | re >> 6, J[te++] = 128 | re & 63) : re < 55296 || re >= 57344 ? (J[te++] = 224 | re >> 12, J[te++] = 128 | re >> 6 & 63, J[te++] = 128 | re & 63) : (re = 65536 + ((re & 1023) << 10 | C.charCodeAt(++$) & 1023), J[te++] = 240 | re >> 18, J[te++] = 128 | re >> 12 & 63, J[te++] = 128 | re >> 6 & 63, J[te++] = 128 | re & 63);
        C = J;
      } else if (V === "object") {
        if (C === null)
          throw new Error(ERROR);
        if (ARRAY_BUFFER && C.constructor === ArrayBuffer)
          C = new Uint8Array(C);
        else if (!Array.isArray(C) && (!ARRAY_BUFFER || !ArrayBuffer.isView(C)))
          throw new Error(ERROR);
      } else
        throw new Error(ERROR);
      C.length > 64 && (C = new Sha256(e, !0).update(C).array());
      var ie = [], se = [];
      for ($ = 0; $ < 64; ++$) {
        var de = C[$] || 0;
        ie[$] = 92 ^ de, se[$] = 54 ^ de;
      }
      Sha256.call(this, e, T), this.update(se), this.oKeyPad = ie, this.inner = !0, this.sharedMemory = T;
    }
    HmacSha256.prototype = new Sha256(), HmacSha256.prototype.finalize = function() {
      if (Sha256.prototype.finalize.call(this), this.inner) {
        this.inner = !1;
        var C = this.array();
        Sha256.call(this, this.is224, this.sharedMemory), this.update(this.oKeyPad), this.update(C), Sha256.prototype.finalize.call(this);
      }
    };
    var exports = createMethod();
    exports.sha256 = exports, exports.sha224 = createMethod(!0), exports.sha256.hmac = createHmacMethod(), exports.sha224.hmac = createHmacMethod(!0), COMMON_JS ? module.exports = exports : (root.sha256 = exports.sha256, root.sha224 = exports.sha224);
  })();
})(sha256);
var sha256Exports = sha256.exports, addresses_default = {
  MAYAN_FORWARDER_CONTRACT: "0x0654874eb7F59C6f5b39931FC45dC45337c967c3",
  MAYAN_PROGRAM_ID: "FC4eXxkyrMPTjiYUpp4EAnkmwMbQyZ6NDCh1kfLn6vsf",
  AUCTION_PROGRAM_ID: "8QJmxZcEzwuYmCPy6XqgN2sHcYCcFq6AEfBMJZZuLo5a",
  MCTP_PROGRAM_ID: "Awm2zSgzMGTRraAVjRvshqLehy7mJ2Qr3maURDsoDmwi",
  SWIFT_PROGRAM_ID: "BLZRi6frs4X4DNLw56V4EXai1b6QVESN1BhHBTYM9VcY",
  FEE_MANAGER_PROGRAM_ID: "5VtQHnhs2pfVEr68qQsbTRwKh4JV5GTu9mBHgHFxpHeQ",
  WORMHOLE_PROGRAM_ID: "worm2ZoG2kUd4vFXhvjh93UUH596ayRfgQ2MgjNMTth",
  CCTP_CORE_PROGRAM_ID: "CCTPmbSD7gX1bxKPAmg77w8oFzNFpaQiQUWD43TKaecd",
  CCTP_TOKEN_PROGRAM_ID: "CCTPiPYPc6AsJuwueEnWgSgucamXDZwBd53dQ11YiKX3",
  TOKEN_PROGRAM_ID: "TokenkegQfeZyiNwAJbNbGKPFXCWuBvf9Ss623VQ5DA",
  ASSOCIATED_TOKEN_PROGRAM_ID: "ATokenGPvbdGVxr1b2hvZbsiqW5xWH25efTNsLJA8knL",
  LOOKUP_TABLE: "75X8YgJPcadksw6Ag3qsYUfi1bsFwDoCKYtqPPqdydAG",
  EXPLORER_URL: "https://explorer-api.mayan.finance/v3",
  PRICE_URL: "https://price-api.mayan.finance/v3",
  RELAYER_URL: "https://relayer-api.mayan.finance/v3"
}, sha3_2562 = sha3Exports.sha3_256, isValidAptosType = (C) => /^(0x)?[0-9a-fA-F]+::\w+::\w+$/.test(C);
function nativeAddressToHexString(C, e) {
  if (e === 1)
    return zeroPadValue(new PublicKey(C).toBytes(), 32);
  if (e === 2 || e === 4 || e === 5 || e === 6 || e === 23 || e === 24 || e === 30)
    return zeroPadValue(C, 32);
  if (e === 22 && isValidAptosType(C))
    return `0x${sha3_2562(C)}`;
  throw console.log(`Unsupported chain id: ${e}`, C), new Error("Unsupported token chain");
}
function hexToUint8Array(C) {
  return new Uint8Array(
    bufferPolyfill.Buffer.from(
      C.startsWith("0x") ? C.substring(2) : C,
      "hex"
    )
  );
}
function getAssociatedTokenAddress(C, e, T = !1, $ = new PublicKey(addresses_default.TOKEN_PROGRAM_ID), V = new PublicKey(addresses_default.ASSOCIATED_TOKEN_PROGRAM_ID)) {
  if (!T && !PublicKey.isOnCurve(e.toBuffer()))
    throw new Error("TokenOwnerOffCurveError");
  const [J] = PublicKey.findProgramAddressSync(
    [e.toBuffer(), $.toBuffer(), C.toBuffer()],
    V
  );
  return J;
}
function getAmountOfFractionalAmount(C, e) {
  if (C == null)
    throw new Error("getAmountOfFractionalAmount: Amount is null or undefined");
  if (typeof C != "string" && typeof C != "number")
    throw new Error("getAmountOfFractionalAmount: Amount is not a string or number");
  if (typeof C == "string" && C.length === 0)
    throw new Error("getAmountOfFractionalAmount: Amount is empty");
  if (!Number.isFinite(Number(C)))
    throw new Error("getAmountOfFractionalAmount: Amount is not a number");
  const T = Math.min(8, Number(e)), $ = Number(C).toFixed(T + 1), V = new RegExp(`^-?\\d+(?:\\.\\d{0,${T}})?`), J = $.match(V);
  if (!J)
    throw new Error("getAmountOfFractionalAmount: fixedAmount is null");
  const ee = J[0];
  return parseUnits$1(ee, Number(e));
}
var chains = {
  solana: 1,
  ethereum: 2,
  bsc: 4,
  polygon: 5,
  avalanche: 6,
  arbitrum: 23,
  optimism: 24,
  base: 30,
  aptos: 22
};
function getWormholeChainIdByName(C) {
  return chains[C];
}
var evmChainIdMap = {
  1: 2,
  56: 4,
  137: 5,
  43114: 6,
  42161: 23,
  10: 24,
  8453: 30
};
function getWormholeChainIdById(C) {
  return evmChainIdMap[C];
}
var sdkVersion = [9, 3, 0];
function getSdkVersion() {
  return sdkVersion.join("_");
}
function checkSdkVersionSupport(C) {
  return sdkVersion[0] < C[0] ? !1 : sdkVersion[0] > C[0] ? !0 : sdkVersion[1] < C[1] ? !1 : sdkVersion[1] > C[1] || sdkVersion[2] >= C[2];
}
function getGasDecimal(C) {
  return C === "solana" ? 9 : 18;
}
function getGasDecimalsInSolana(C) {
  return C === "solana" ? 9 : 8;
}
var MAX_U64 = BigInt(2) ** BigInt(64) - BigInt(1);
function getSafeU64Blob(C) {
  if (C < BigInt(0) || C > MAX_U64)
    throw new Error(`Invalid u64: ${C}`);
  const e = bufferPolyfill.Buffer.alloc(8);
  return e.writeBigUInt64LE(C), e;
}
var ZeroPermit = {
  value: BigInt(0),
  deadline: 0,
  v: 0,
  r: `0x${SystemProgram.programId.toBuffer().toString("hex")}`,
  s: `0x${SystemProgram.programId.toBuffer().toString("hex")}`
};
function getQuoteSuitableReferrerAddress(C, e) {
  return !C || !e ? null : C.type === "WH" ? (e == null ? void 0 : e.solana) || null : C.type === "MCTP" || C.type === "SWIFT" ? C.toChain === "solana" ? (e == null ? void 0 : e.solana) || null : (e == null ? void 0 : e.evm) || null : null;
}
function toQueryString(C) {
  return Object.entries(C).filter(([e, T]) => T != null && !Array.isArray(T)).map(([e, T]) => `${encodeURIComponent(e)}=${encodeURIComponent(T)}`).join("&");
}
async function check5xxError(C) {
  if (C.status.toString().startsWith("5")) {
    let e;
    try {
      const T = await C.json();
      T.code && (T != null && T.message || T != null && T.msg) && (e = {
        code: T.code,
        message: (T == null ? void 0 : T.message) || (T == null ? void 0 : T.msg)
      });
    } catch {
      e = new Error("Internal server error");
    }
    throw e;
  }
}
async function fetchTokenList(C, e = !1) {
  const T = await o(`${addresses_default.PRICE_URL}/tokens?chain=${C}${e ? "&nonPortal=true" : ""}`);
  if (await check5xxError(T), T.status === 200)
    return (await T.json())[C];
  throw new Error("Cannot fetch Mayan tokens!");
}
function generateFetchQuoteUrl(C, e = {
  swift: !0,
  mctp: !0,
  gasless: !1,
  onlyDirect: !1
}) {
  const { gasDrop: T, referrerBps: $ } = C;
  let V = C.slippageBps;
  V !== "auto" && !Number.isFinite(V) && (V = C.slippage * 100);
  const ee = {
    ...{
      swift: e.swift !== !1,
      // default to true
      mctp: e.mctp !== !1,
      // default to true
      gasless: e.gasless === !0,
      // default to false
      onlyDirect: e.onlyDirect === !0
      // default to false
    },
    solanaProgram: addresses_default.MAYAN_PROGRAM_ID,
    forwarderAddress: addresses_default.MAYAN_FORWARDER_CONTRACT,
    amountIn: Number.isFinite(C.amount) ? C.amount : void 0,
    fromToken: C.fromToken,
    fromChain: C.fromChain,
    toToken: C.toToken,
    toChain: C.toChain,
    slippageBps: V,
    referrer: C.referrer,
    referrerBps: Number.isFinite($) ? $ : void 0,
    gasDrop: Number.isFinite(T) ? T : void 0,
    sdkVersion: getSdkVersion()
  }, te = `${addresses_default.PRICE_URL}/quote?`, re = toQueryString(ee);
  return te + re;
}
async function fetchQuote(C, e = {
  swift: !0,
  mctp: !0,
  gasless: !1,
  onlyDirect: !1
}) {
  const T = generateFetchQuoteUrl(C, e), $ = await o(T, {
    method: "GET",
    redirect: "follow"
  });
  await check5xxError($);
  const V = await $.json();
  if ($.status !== 200 && $.status !== 201)
    throw {
      code: (V == null ? void 0 : V.code) || 0,
      message: (V == null ? void 0 : V.msg) || "Route not found"
    };
  if (!checkSdkVersionSupport(V.minimumSdkVersion))
    throw {
      code: 9999,
      message: "Swap SDK is outdated!"
    };
  return V.quotes;
}
async function getSuggestedRelayer() {
  const C = await o(`${addresses_default.RELAYER_URL}/active-relayers?solanaProgram=${addresses_default.MAYAN_PROGRAM_ID}`, {
    method: "GET",
    redirect: "follow"
  });
  await check5xxError(C);
  const e = await C.json();
  if (C.status !== 200 && C.status !== 201)
    throw e;
  return e.suggested;
}
async function getSwapSolana(C) {
  const e = toQueryString(C), T = await o(`${addresses_default.PRICE_URL}/get-swap/solana?${e}`, {
    method: "GET",
    redirect: "follow"
  });
  await check5xxError(T);
  const $ = await T.json();
  if (T.status !== 200 && T.status !== 201)
    throw $;
  return $;
}
var MayanSwapArtifact_default = {
  _format: "hh-sol-artifact-1",
  contractName: "MayanSwap",
  sourceName: "src/MayanSwap.sol",
  abi: [
    {
      inputs: [
        {
          internalType: "address",
          name: "_tokenBridge",
          type: "address"
        },
        {
          internalType: "address",
          name: "_weth",
          type: "address"
        }
      ],
      stateMutability: "nonpayable",
      type: "constructor"
    },
    {
      anonymous: !1,
      inputs: [
        {
          indexed: !0,
          internalType: "uint16",
          name: "emitterChainId",
          type: "uint16"
        },
        {
          indexed: !0,
          internalType: "bytes32",
          name: "emitterAddress",
          type: "bytes32"
        },
        {
          indexed: !0,
          internalType: "uint64",
          name: "sequence",
          type: "uint64"
        }
      ],
      name: "Redeemed",
      type: "event"
    },
    {
      inputs: [
        {
          internalType: "address",
          name: "newGuardian",
          type: "address"
        }
      ],
      name: "changeGuardian",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function"
    },
    {
      inputs: [],
      name: "claimGuardian",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function"
    },
    {
      inputs: [
        {
          components: [
            {
              internalType: "uint8",
              name: "payloadId",
              type: "uint8"
            },
            {
              internalType: "bytes32",
              name: "tokenAddr",
              type: "bytes32"
            },
            {
              internalType: "uint16",
              name: "tokenChainId",
              type: "uint16"
            },
            {
              internalType: "bytes32",
              name: "destAddr",
              type: "bytes32"
            },
            {
              internalType: "uint16",
              name: "destChainId",
              type: "uint16"
            },
            {
              internalType: "bytes32",
              name: "sourceAddr",
              type: "bytes32"
            },
            {
              internalType: "uint16",
              name: "sourceChainId",
              type: "uint16"
            },
            {
              internalType: "uint64",
              name: "sequence",
              type: "uint64"
            },
            {
              internalType: "uint64",
              name: "amountOutMin",
              type: "uint64"
            },
            {
              internalType: "uint64",
              name: "deadline",
              type: "uint64"
            },
            {
              internalType: "uint64",
              name: "swapFee",
              type: "uint64"
            },
            {
              internalType: "uint64",
              name: "redeemFee",
              type: "uint64"
            },
            {
              internalType: "uint64",
              name: "refundFee",
              type: "uint64"
            },
            {
              internalType: "bytes32",
              name: "auctionAddr",
              type: "bytes32"
            },
            {
              internalType: "bool",
              name: "unwrapRedeem",
              type: "bool"
            },
            {
              internalType: "bool",
              name: "unwrapRefund",
              type: "bool"
            }
          ],
          internalType: "struct MayanStructs.Swap",
          name: "s",
          type: "tuple"
        }
      ],
      name: "encodeSwap",
      outputs: [
        {
          internalType: "bytes",
          name: "encoded",
          type: "bytes"
        }
      ],
      stateMutability: "pure",
      type: "function"
    },
    {
      inputs: [],
      name: "getWeth",
      outputs: [
        {
          internalType: "address",
          name: "",
          type: "address"
        }
      ],
      stateMutability: "view",
      type: "function"
    },
    {
      inputs: [],
      name: "isPaused",
      outputs: [
        {
          internalType: "bool",
          name: "",
          type: "bool"
        }
      ],
      stateMutability: "view",
      type: "function"
    },
    {
      inputs: [
        {
          internalType: "bytes",
          name: "encoded",
          type: "bytes"
        }
      ],
      name: "parseRedeemPayload",
      outputs: [
        {
          components: [
            {
              internalType: "uint8",
              name: "payloadId",
              type: "uint8"
            },
            {
              internalType: "bytes32",
              name: "recipient",
              type: "bytes32"
            },
            {
              internalType: "uint64",
              name: "relayerFee",
              type: "uint64"
            },
            {
              internalType: "bool",
              name: "unwrap",
              type: "bool"
            },
            {
              internalType: "uint64",
              name: "gasDrop",
              type: "uint64"
            },
            {
              internalType: "bytes",
              name: "customPayload",
              type: "bytes"
            }
          ],
          internalType: "struct MayanStructs.Redeem",
          name: "r",
          type: "tuple"
        }
      ],
      stateMutability: "pure",
      type: "function"
    },
    {
      inputs: [
        {
          internalType: "bytes",
          name: "encodedVm",
          type: "bytes"
        }
      ],
      name: "redeem",
      outputs: [],
      stateMutability: "payable",
      type: "function"
    },
    {
      inputs: [
        {
          internalType: "bytes",
          name: "encodedVm",
          type: "bytes"
        }
      ],
      name: "redeemAndUnwrap",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function"
    },
    {
      inputs: [
        {
          internalType: "bool",
          name: "_pause",
          type: "bool"
        }
      ],
      name: "setPause",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function"
    },
    {
      inputs: [
        {
          components: [
            {
              internalType: "uint64",
              name: "swapFee",
              type: "uint64"
            },
            {
              internalType: "uint64",
              name: "redeemFee",
              type: "uint64"
            },
            {
              internalType: "uint64",
              name: "refundFee",
              type: "uint64"
            }
          ],
          internalType: "struct MayanSwap.RelayerFees",
          name: "relayerFees",
          type: "tuple"
        },
        {
          components: [
            {
              internalType: "bytes32",
              name: "mayanAddr",
              type: "bytes32"
            },
            {
              internalType: "uint16",
              name: "mayanChainId",
              type: "uint16"
            },
            {
              internalType: "bytes32",
              name: "auctionAddr",
              type: "bytes32"
            },
            {
              internalType: "bytes32",
              name: "destAddr",
              type: "bytes32"
            },
            {
              internalType: "uint16",
              name: "destChainId",
              type: "uint16"
            },
            {
              internalType: "bytes32",
              name: "referrer",
              type: "bytes32"
            },
            {
              internalType: "bytes32",
              name: "refundAddr",
              type: "bytes32"
            }
          ],
          internalType: "struct MayanSwap.Recepient",
          name: "recipient",
          type: "tuple"
        },
        {
          internalType: "bytes32",
          name: "tokenOutAddr",
          type: "bytes32"
        },
        {
          internalType: "uint16",
          name: "tokenOutChainId",
          type: "uint16"
        },
        {
          components: [
            {
              internalType: "uint256",
              name: "transferDeadline",
              type: "uint256"
            },
            {
              internalType: "uint64",
              name: "swapDeadline",
              type: "uint64"
            },
            {
              internalType: "uint64",
              name: "amountOutMin",
              type: "uint64"
            },
            {
              internalType: "bool",
              name: "unwrap",
              type: "bool"
            },
            {
              internalType: "uint64",
              name: "gasDrop",
              type: "uint64"
            },
            {
              internalType: "bytes",
              name: "customPayload",
              type: "bytes"
            }
          ],
          internalType: "struct MayanSwap.Criteria",
          name: "criteria",
          type: "tuple"
        },
        {
          internalType: "address",
          name: "tokenIn",
          type: "address"
        },
        {
          internalType: "uint256",
          name: "amountIn",
          type: "uint256"
        }
      ],
      name: "swap",
      outputs: [
        {
          internalType: "uint64",
          name: "sequence",
          type: "uint64"
        }
      ],
      stateMutability: "payable",
      type: "function"
    },
    {
      inputs: [
        {
          internalType: "uint256",
          name: "amount",
          type: "uint256"
        },
        {
          internalType: "address payable",
          name: "to",
          type: "address"
        }
      ],
      name: "sweepEth",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function"
    },
    {
      inputs: [
        {
          internalType: "address",
          name: "token",
          type: "address"
        },
        {
          internalType: "uint256",
          name: "amount",
          type: "uint256"
        },
        {
          internalType: "address",
          name: "to",
          type: "address"
        }
      ],
      name: "sweepToken",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function"
    },
    {
      inputs: [
        {
          components: [
            {
              internalType: "uint64",
              name: "swapFee",
              type: "uint64"
            },
            {
              internalType: "uint64",
              name: "redeemFee",
              type: "uint64"
            },
            {
              internalType: "uint64",
              name: "refundFee",
              type: "uint64"
            }
          ],
          internalType: "struct MayanSwap.RelayerFees",
          name: "relayerFees",
          type: "tuple"
        },
        {
          components: [
            {
              internalType: "bytes32",
              name: "mayanAddr",
              type: "bytes32"
            },
            {
              internalType: "uint16",
              name: "mayanChainId",
              type: "uint16"
            },
            {
              internalType: "bytes32",
              name: "auctionAddr",
              type: "bytes32"
            },
            {
              internalType: "bytes32",
              name: "destAddr",
              type: "bytes32"
            },
            {
              internalType: "uint16",
              name: "destChainId",
              type: "uint16"
            },
            {
              internalType: "bytes32",
              name: "referrer",
              type: "bytes32"
            },
            {
              internalType: "bytes32",
              name: "refundAddr",
              type: "bytes32"
            }
          ],
          internalType: "struct MayanSwap.Recepient",
          name: "recipient",
          type: "tuple"
        },
        {
          internalType: "bytes32",
          name: "tokenOutAddr",
          type: "bytes32"
        },
        {
          internalType: "uint16",
          name: "tokenOutChainId",
          type: "uint16"
        },
        {
          components: [
            {
              internalType: "uint256",
              name: "transferDeadline",
              type: "uint256"
            },
            {
              internalType: "uint64",
              name: "swapDeadline",
              type: "uint64"
            },
            {
              internalType: "uint64",
              name: "amountOutMin",
              type: "uint64"
            },
            {
              internalType: "bool",
              name: "unwrap",
              type: "bool"
            },
            {
              internalType: "uint64",
              name: "gasDrop",
              type: "uint64"
            },
            {
              internalType: "bytes",
              name: "customPayload",
              type: "bytes"
            }
          ],
          internalType: "struct MayanSwap.Criteria",
          name: "criteria",
          type: "tuple"
        }
      ],
      name: "wrapAndSwapETH",
      outputs: [
        {
          internalType: "uint64",
          name: "sequence",
          type: "uint64"
        }
      ],
      stateMutability: "payable",
      type: "function"
    },
    {
      stateMutability: "payable",
      type: "receive"
    }
  ]
}, MayanForwarderArtifact_default = {
  _format: "hh-sol-artifact-1",
  contractName: "MayanForwarder",
  sourceName: "src/MayanForwarder.sol",
  abi: [
    {
      inputs: [
        {
          internalType: "address",
          name: "_guardian",
          type: "address"
        },
        {
          internalType: "address[]",
          name: "_swapProtocols",
          type: "address[]"
        },
        {
          internalType: "address[]",
          name: "_mayanProtocols",
          type: "address[]"
        }
      ],
      stateMutability: "nonpayable",
      type: "constructor"
    },
    {
      inputs: [],
      name: "UnsupportedProtocol",
      type: "error"
    },
    {
      anonymous: !1,
      inputs: [
        {
          indexed: !1,
          internalType: "address",
          name: "token",
          type: "address"
        },
        {
          indexed: !1,
          internalType: "uint256",
          name: "amount",
          type: "uint256"
        },
        {
          indexed: !1,
          internalType: "address",
          name: "mayanProtocol",
          type: "address"
        },
        {
          indexed: !1,
          internalType: "bytes",
          name: "protocolData",
          type: "bytes"
        }
      ],
      name: "ForwardedERC20",
      type: "event"
    },
    {
      anonymous: !1,
      inputs: [
        {
          indexed: !1,
          internalType: "address",
          name: "mayanProtocol",
          type: "address"
        },
        {
          indexed: !1,
          internalType: "bytes",
          name: "protocolData",
          type: "bytes"
        }
      ],
      name: "ForwardedEth",
      type: "event"
    },
    {
      anonymous: !1,
      inputs: [
        {
          indexed: !1,
          internalType: "uint256",
          name: "amount",
          type: "uint256"
        }
      ],
      name: "SwapAndForwarded",
      type: "event"
    },
    {
      anonymous: !1,
      inputs: [
        {
          indexed: !1,
          internalType: "address",
          name: "tokenIn",
          type: "address"
        },
        {
          indexed: !1,
          internalType: "uint256",
          name: "amountIn",
          type: "uint256"
        },
        {
          indexed: !1,
          internalType: "address",
          name: "swapProtocol",
          type: "address"
        },
        {
          indexed: !1,
          internalType: "address",
          name: "middleToken",
          type: "address"
        },
        {
          indexed: !1,
          internalType: "uint256",
          name: "middleAmount",
          type: "uint256"
        },
        {
          indexed: !1,
          internalType: "address",
          name: "mayanProtocol",
          type: "address"
        },
        {
          indexed: !1,
          internalType: "bytes",
          name: "mayanData",
          type: "bytes"
        }
      ],
      name: "SwapAndForwardedERC20",
      type: "event"
    },
    {
      anonymous: !1,
      inputs: [
        {
          indexed: !1,
          internalType: "uint256",
          name: "amountIn",
          type: "uint256"
        },
        {
          indexed: !1,
          internalType: "address",
          name: "swapProtocol",
          type: "address"
        },
        {
          indexed: !1,
          internalType: "address",
          name: "middleToken",
          type: "address"
        },
        {
          indexed: !1,
          internalType: "uint256",
          name: "middleAmount",
          type: "uint256"
        },
        {
          indexed: !1,
          internalType: "address",
          name: "mayanProtocol",
          type: "address"
        },
        {
          indexed: !1,
          internalType: "bytes",
          name: "mayanData",
          type: "bytes"
        }
      ],
      name: "SwapAndForwardedEth",
      type: "event"
    },
    {
      inputs: [
        {
          internalType: "address",
          name: "newGuardian",
          type: "address"
        }
      ],
      name: "changeGuardian",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function"
    },
    {
      inputs: [],
      name: "claimGuardian",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function"
    },
    {
      inputs: [
        {
          internalType: "address",
          name: "tokenIn",
          type: "address"
        },
        {
          internalType: "uint256",
          name: "amountIn",
          type: "uint256"
        },
        {
          components: [
            {
              internalType: "uint256",
              name: "value",
              type: "uint256"
            },
            {
              internalType: "uint256",
              name: "deadline",
              type: "uint256"
            },
            {
              internalType: "uint8",
              name: "v",
              type: "uint8"
            },
            {
              internalType: "bytes32",
              name: "r",
              type: "bytes32"
            },
            {
              internalType: "bytes32",
              name: "s",
              type: "bytes32"
            }
          ],
          internalType: "struct MayanForwarder.PermitParams",
          name: "permitParams",
          type: "tuple"
        },
        {
          internalType: "address",
          name: "mayanProtocol",
          type: "address"
        },
        {
          internalType: "bytes",
          name: "protocolData",
          type: "bytes"
        }
      ],
      name: "forwardERC20",
      outputs: [],
      stateMutability: "payable",
      type: "function"
    },
    {
      inputs: [
        {
          internalType: "address",
          name: "mayanProtocol",
          type: "address"
        },
        {
          internalType: "bytes",
          name: "protocolData",
          type: "bytes"
        }
      ],
      name: "forwardEth",
      outputs: [],
      stateMutability: "payable",
      type: "function"
    },
    {
      inputs: [],
      name: "guardian",
      outputs: [
        {
          internalType: "address",
          name: "",
          type: "address"
        }
      ],
      stateMutability: "view",
      type: "function"
    },
    {
      inputs: [
        {
          internalType: "address",
          name: "",
          type: "address"
        }
      ],
      name: "mayanProtocols",
      outputs: [
        {
          internalType: "bool",
          name: "",
          type: "bool"
        }
      ],
      stateMutability: "view",
      type: "function"
    },
    {
      inputs: [],
      name: "nextGuardian",
      outputs: [
        {
          internalType: "address",
          name: "",
          type: "address"
        }
      ],
      stateMutability: "view",
      type: "function"
    },
    {
      inputs: [
        {
          internalType: "uint256",
          name: "amount",
          type: "uint256"
        },
        {
          internalType: "address payable",
          name: "to",
          type: "address"
        }
      ],
      name: "rescueEth",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function"
    },
    {
      inputs: [
        {
          internalType: "address",
          name: "token",
          type: "address"
        },
        {
          internalType: "uint256",
          name: "amount",
          type: "uint256"
        },
        {
          internalType: "address",
          name: "to",
          type: "address"
        }
      ],
      name: "rescueToken",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function"
    },
    {
      inputs: [
        {
          internalType: "address",
          name: "mayanProtocol",
          type: "address"
        },
        {
          internalType: "bool",
          name: "enabled",
          type: "bool"
        }
      ],
      name: "setMayanProtocol",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function"
    },
    {
      inputs: [
        {
          internalType: "address",
          name: "swapProtocol",
          type: "address"
        },
        {
          internalType: "bool",
          name: "enabled",
          type: "bool"
        }
      ],
      name: "setSwapProtocol",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function"
    },
    {
      inputs: [
        {
          internalType: "address",
          name: "tokenIn",
          type: "address"
        },
        {
          internalType: "uint256",
          name: "amountIn",
          type: "uint256"
        },
        {
          components: [
            {
              internalType: "uint256",
              name: "value",
              type: "uint256"
            },
            {
              internalType: "uint256",
              name: "deadline",
              type: "uint256"
            },
            {
              internalType: "uint8",
              name: "v",
              type: "uint8"
            },
            {
              internalType: "bytes32",
              name: "r",
              type: "bytes32"
            },
            {
              internalType: "bytes32",
              name: "s",
              type: "bytes32"
            }
          ],
          internalType: "struct MayanForwarder.PermitParams",
          name: "permitParams",
          type: "tuple"
        },
        {
          internalType: "address",
          name: "swapProtocol",
          type: "address"
        },
        {
          internalType: "bytes",
          name: "swapData",
          type: "bytes"
        },
        {
          internalType: "address",
          name: "middleToken",
          type: "address"
        },
        {
          internalType: "uint256",
          name: "minMiddleAmount",
          type: "uint256"
        },
        {
          internalType: "address",
          name: "mayanProtocol",
          type: "address"
        },
        {
          internalType: "bytes",
          name: "mayanData",
          type: "bytes"
        }
      ],
      name: "swapAndForwardERC20",
      outputs: [],
      stateMutability: "payable",
      type: "function"
    },
    {
      inputs: [
        {
          internalType: "uint256",
          name: "amountIn",
          type: "uint256"
        },
        {
          internalType: "address",
          name: "swapProtocol",
          type: "address"
        },
        {
          internalType: "bytes",
          name: "swapData",
          type: "bytes"
        },
        {
          internalType: "address",
          name: "middleToken",
          type: "address"
        },
        {
          internalType: "uint256",
          name: "minMiddleAmount",
          type: "uint256"
        },
        {
          internalType: "address",
          name: "mayanProtocol",
          type: "address"
        },
        {
          internalType: "bytes",
          name: "mayanData",
          type: "bytes"
        }
      ],
      name: "swapAndForwardEth",
      outputs: [],
      stateMutability: "payable",
      type: "function"
    },
    {
      inputs: [
        {
          internalType: "address",
          name: "",
          type: "address"
        }
      ],
      name: "swapProtocols",
      outputs: [
        {
          internalType: "bool",
          name: "",
          type: "bool"
        }
      ],
      stateMutability: "view",
      type: "function"
    }
  ],
  linkReferences: {},
  deployedLinkReferences: {}
}, MayanCircleArtifact_default = {
  _format: "hh-sol-artifact-1",
  contractName: "MayanCircle",
  sourceName: "src/MayanCircle.sol",
  abi: [
    {
      inputs: [
        {
          internalType: "address",
          name: "_cctpTokenMessenger",
          type: "address"
        },
        {
          internalType: "address",
          name: "_wormhole",
          type: "address"
        },
        {
          internalType: "address",
          name: "_feeManager",
          type: "address"
        },
        {
          internalType: "uint16",
          name: "_auctionChainId",
          type: "uint16"
        },
        {
          internalType: "bytes32",
          name: "_auctionAddr",
          type: "bytes32"
        },
        {
          internalType: "bytes32",
          name: "_solanaEmitter",
          type: "bytes32"
        },
        {
          internalType: "uint8",
          name: "_consistencyLevel",
          type: "uint8"
        }
      ],
      stateMutability: "nonpayable",
      type: "constructor"
    },
    {
      inputs: [],
      name: "CctpReceiveFailed",
      type: "error"
    },
    {
      inputs: [],
      name: "InvalidAction",
      type: "error"
    },
    {
      inputs: [],
      name: "InvalidDomain",
      type: "error"
    },
    {
      inputs: [],
      name: "InvalidEmitter",
      type: "error"
    },
    {
      inputs: [],
      name: "InvalidGasDrop",
      type: "error"
    },
    {
      inputs: [],
      name: "InvalidNonce",
      type: "error"
    },
    {
      inputs: [],
      name: "InvalidOrder",
      type: "error"
    },
    {
      inputs: [],
      name: "Paused",
      type: "error"
    },
    {
      inputs: [],
      name: "Unauthorized",
      type: "error"
    },
    {
      inputs: [],
      name: "auctionAddr",
      outputs: [
        {
          internalType: "bytes32",
          name: "",
          type: "bytes32"
        }
      ],
      stateMutability: "view",
      type: "function"
    },
    {
      inputs: [],
      name: "auctionChainId",
      outputs: [
        {
          internalType: "uint16",
          name: "",
          type: "uint16"
        }
      ],
      stateMutability: "view",
      type: "function"
    },
    {
      inputs: [
        {
          internalType: "address",
          name: "tokenIn",
          type: "address"
        },
        {
          internalType: "uint256",
          name: "amountIn",
          type: "uint256"
        },
        {
          internalType: "uint64",
          name: "redeemFee",
          type: "uint64"
        },
        {
          internalType: "uint64",
          name: "gasDrop",
          type: "uint64"
        },
        {
          internalType: "bytes32",
          name: "destAddr",
          type: "bytes32"
        },
        {
          components: [
            {
              internalType: "uint32",
              name: "destDomain",
              type: "uint32"
            },
            {
              internalType: "bytes32",
              name: "mintRecipient",
              type: "bytes32"
            },
            {
              internalType: "bytes32",
              name: "callerAddr",
              type: "bytes32"
            }
          ],
          internalType: "struct MayanCircle.CctpRecipient",
          name: "recipient",
          type: "tuple"
        }
      ],
      name: "bridgeWithFee",
      outputs: [
        {
          internalType: "uint64",
          name: "sequence",
          type: "uint64"
        }
      ],
      stateMutability: "payable",
      type: "function"
    },
    {
      inputs: [
        {
          internalType: "address",
          name: "tokenIn",
          type: "address"
        },
        {
          internalType: "uint256",
          name: "amountIn",
          type: "uint256"
        },
        {
          internalType: "uint64",
          name: "gasDrop",
          type: "uint64"
        },
        {
          internalType: "uint256",
          name: "redeemFee",
          type: "uint256"
        },
        {
          components: [
            {
              internalType: "uint32",
              name: "destDomain",
              type: "uint32"
            },
            {
              internalType: "bytes32",
              name: "mintRecipient",
              type: "bytes32"
            },
            {
              internalType: "bytes32",
              name: "callerAddr",
              type: "bytes32"
            }
          ],
          internalType: "struct MayanCircle.CctpRecipient",
          name: "recipient",
          type: "tuple"
        }
      ],
      name: "bridgeWithLockedFee",
      outputs: [
        {
          internalType: "uint64",
          name: "cctpNonce",
          type: "uint64"
        }
      ],
      stateMutability: "nonpayable",
      type: "function"
    },
    {
      inputs: [],
      name: "cctpTokenMessenger",
      outputs: [
        {
          internalType: "contract ITokenMessenger",
          name: "",
          type: "address"
        }
      ],
      stateMutability: "view",
      type: "function"
    },
    {
      inputs: [
        {
          internalType: "address",
          name: "newGuardian",
          type: "address"
        }
      ],
      name: "changeGuardian",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function"
    },
    {
      inputs: [],
      name: "claimGuardian",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function"
    },
    {
      inputs: [],
      name: "consistencyLevel",
      outputs: [
        {
          internalType: "uint8",
          name: "",
          type: "uint8"
        }
      ],
      stateMutability: "view",
      type: "function"
    },
    {
      inputs: [
        {
          components: [
            {
              internalType: "address",
              name: "tokenIn",
              type: "address"
            },
            {
              internalType: "uint256",
              name: "amountIn",
              type: "uint256"
            },
            {
              internalType: "uint64",
              name: "gasDrop",
              type: "uint64"
            },
            {
              internalType: "bytes32",
              name: "destAddr",
              type: "bytes32"
            },
            {
              internalType: "uint16",
              name: "destChain",
              type: "uint16"
            },
            {
              internalType: "bytes32",
              name: "tokenOut",
              type: "bytes32"
            },
            {
              internalType: "uint64",
              name: "minAmountOut",
              type: "uint64"
            },
            {
              internalType: "uint64",
              name: "deadline",
              type: "uint64"
            },
            {
              internalType: "uint64",
              name: "redeemFee",
              type: "uint64"
            },
            {
              internalType: "bytes32",
              name: "referrerAddr",
              type: "bytes32"
            },
            {
              internalType: "uint8",
              name: "referrerBps",
              type: "uint8"
            }
          ],
          internalType: "struct MayanCircle.OrderParams",
          name: "params",
          type: "tuple"
        },
        {
          components: [
            {
              internalType: "uint32",
              name: "destDomain",
              type: "uint32"
            },
            {
              internalType: "bytes32",
              name: "mintRecipient",
              type: "bytes32"
            },
            {
              internalType: "bytes32",
              name: "callerAddr",
              type: "bytes32"
            }
          ],
          internalType: "struct MayanCircle.CctpRecipient",
          name: "recipient",
          type: "tuple"
        }
      ],
      name: "createOrder",
      outputs: [],
      stateMutability: "payable",
      type: "function"
    },
    {
      inputs: [],
      name: "feeManager",
      outputs: [
        {
          internalType: "contract IFeeManager",
          name: "",
          type: "address"
        }
      ],
      stateMutability: "view",
      type: "function"
    },
    {
      inputs: [
        {
          internalType: "uint64",
          name: "",
          type: "uint64"
        }
      ],
      name: "feeStorage",
      outputs: [
        {
          internalType: "bytes32",
          name: "destAddr",
          type: "bytes32"
        },
        {
          internalType: "uint64",
          name: "gasDrop",
          type: "uint64"
        },
        {
          internalType: "address",
          name: "token",
          type: "address"
        },
        {
          internalType: "uint256",
          name: "redeemFee",
          type: "uint256"
        }
      ],
      stateMutability: "view",
      type: "function"
    },
    {
      inputs: [
        {
          internalType: "bytes",
          name: "cctpMsg",
          type: "bytes"
        },
        {
          internalType: "bytes",
          name: "cctpSigs",
          type: "bytes"
        },
        {
          internalType: "bytes",
          name: "encodedVm",
          type: "bytes"
        },
        {
          internalType: "address",
          name: "swapProtocol",
          type: "address"
        },
        {
          internalType: "bytes",
          name: "swapData",
          type: "bytes"
        }
      ],
      name: "fulfillOrder",
      outputs: [],
      stateMutability: "payable",
      type: "function"
    },
    {
      inputs: [],
      name: "guardian",
      outputs: [
        {
          internalType: "address",
          name: "",
          type: "address"
        }
      ],
      stateMutability: "view",
      type: "function"
    },
    {
      inputs: [],
      name: "isPaused",
      outputs: [
        {
          internalType: "bool",
          name: "",
          type: "bool"
        }
      ],
      stateMutability: "view",
      type: "function"
    },
    {
      inputs: [],
      name: "localDomain",
      outputs: [
        {
          internalType: "uint32",
          name: "",
          type: "uint32"
        }
      ],
      stateMutability: "view",
      type: "function"
    },
    {
      inputs: [
        {
          internalType: "bytes",
          name: "encoded",
          type: "bytes"
        }
      ],
      name: "parseFulfillMsg",
      outputs: [
        {
          components: [
            {
              internalType: "uint8",
              name: "action",
              type: "uint8"
            },
            {
              internalType: "uint8",
              name: "payloadId",
              type: "uint8"
            },
            {
              internalType: "uint16",
              name: "destChainId",
              type: "uint16"
            },
            {
              internalType: "bytes32",
              name: "destAddr",
              type: "bytes32"
            },
            {
              internalType: "bytes32",
              name: "driver",
              type: "bytes32"
            },
            {
              internalType: "bytes32",
              name: "tokenOut",
              type: "bytes32"
            },
            {
              internalType: "uint64",
              name: "promisedAmount",
              type: "uint64"
            },
            {
              internalType: "uint64",
              name: "gasDrop",
              type: "uint64"
            },
            {
              internalType: "bytes32",
              name: "referrerAddr",
              type: "bytes32"
            },
            {
              internalType: "uint8",
              name: "referrerBps",
              type: "uint8"
            },
            {
              internalType: "uint8",
              name: "protocolBps",
              type: "uint8"
            },
            {
              internalType: "uint64",
              name: "deadline",
              type: "uint64"
            },
            {
              internalType: "uint64",
              name: "redeemFee",
              type: "uint64"
            },
            {
              internalType: "uint32",
              name: "cctpDomain",
              type: "uint32"
            },
            {
              internalType: "uint64",
              name: "cctpNonce",
              type: "uint64"
            }
          ],
          internalType: "struct MayanCircle.FulfillMsg",
          name: "fulfillMsg",
          type: "tuple"
        }
      ],
      stateMutability: "pure",
      type: "function"
    },
    {
      inputs: [],
      name: "paused",
      outputs: [
        {
          internalType: "bool",
          name: "",
          type: "bool"
        }
      ],
      stateMutability: "view",
      type: "function"
    },
    {
      inputs: [
        {
          internalType: "bytes",
          name: "cctpMsg",
          type: "bytes"
        },
        {
          internalType: "bytes",
          name: "cctpSigs",
          type: "bytes"
        },
        {
          internalType: "bytes",
          name: "encodedVm",
          type: "bytes"
        }
      ],
      name: "redeemWithFee",
      outputs: [],
      stateMutability: "payable",
      type: "function"
    },
    {
      inputs: [
        {
          internalType: "bytes",
          name: "cctpMsg",
          type: "bytes"
        },
        {
          internalType: "bytes",
          name: "cctpSigs",
          type: "bytes"
        },
        {
          internalType: "bytes32",
          name: "unlockerAddr",
          type: "bytes32"
        }
      ],
      name: "redeemWithLockedFee",
      outputs: [
        {
          internalType: "uint64",
          name: "sequence",
          type: "uint64"
        }
      ],
      stateMutability: "payable",
      type: "function"
    },
    {
      inputs: [
        {
          internalType: "uint32",
          name: "cctpNonce",
          type: "uint32"
        },
        {
          internalType: "uint32",
          name: "cctpDomain",
          type: "uint32"
        },
        {
          internalType: "bytes32",
          name: "destAddr",
          type: "bytes32"
        },
        {
          internalType: "bytes32",
          name: "unlockerAddr",
          type: "bytes32"
        }
      ],
      name: "refineFee",
      outputs: [
        {
          internalType: "uint64",
          name: "sequence",
          type: "uint64"
        }
      ],
      stateMutability: "payable",
      type: "function"
    },
    {
      inputs: [
        {
          internalType: "bytes",
          name: "encodedVm",
          type: "bytes"
        },
        {
          internalType: "bytes",
          name: "cctpMsg",
          type: "bytes"
        },
        {
          internalType: "bytes",
          name: "cctpSigs",
          type: "bytes"
        },
        {
          components: [
            {
              internalType: "address",
              name: "tokenIn",
              type: "address"
            },
            {
              internalType: "uint256",
              name: "amountIn",
              type: "uint256"
            },
            {
              internalType: "uint64",
              name: "gasDrop",
              type: "uint64"
            },
            {
              internalType: "bytes32",
              name: "destAddr",
              type: "bytes32"
            },
            {
              internalType: "uint16",
              name: "destChain",
              type: "uint16"
            },
            {
              internalType: "bytes32",
              name: "tokenOut",
              type: "bytes32"
            },
            {
              internalType: "uint64",
              name: "minAmountOut",
              type: "uint64"
            },
            {
              internalType: "uint64",
              name: "deadline",
              type: "uint64"
            },
            {
              internalType: "uint64",
              name: "redeemFee",
              type: "uint64"
            },
            {
              internalType: "bytes32",
              name: "referrerAddr",
              type: "bytes32"
            },
            {
              internalType: "uint8",
              name: "referrerBps",
              type: "uint8"
            }
          ],
          internalType: "struct MayanCircle.OrderParams",
          name: "orderParams",
          type: "tuple"
        },
        {
          components: [
            {
              internalType: "bytes32",
              name: "trader",
              type: "bytes32"
            },
            {
              internalType: "uint16",
              name: "sourceChainId",
              type: "uint16"
            },
            {
              internalType: "uint8",
              name: "protocolBps",
              type: "uint8"
            }
          ],
          internalType: "struct MayanCircle.ExtraParams",
          name: "extraParams",
          type: "tuple"
        }
      ],
      name: "refund",
      outputs: [],
      stateMutability: "payable",
      type: "function"
    },
    {
      inputs: [
        {
          internalType: "uint256",
          name: "amount",
          type: "uint256"
        },
        {
          internalType: "address payable",
          name: "to",
          type: "address"
        }
      ],
      name: "rescueEth",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function"
    },
    {
      inputs: [
        {
          internalType: "address",
          name: "token",
          type: "address"
        },
        {
          internalType: "uint256",
          name: "amount",
          type: "uint256"
        },
        {
          internalType: "address",
          name: "to",
          type: "address"
        }
      ],
      name: "rescueToken",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function"
    },
    {
      inputs: [
        {
          internalType: "uint8",
          name: "_consistencyLevel",
          type: "uint8"
        }
      ],
      name: "setConsistencyLevel",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function"
    },
    {
      inputs: [
        {
          internalType: "address",
          name: "_feeManager",
          type: "address"
        }
      ],
      name: "setFeeManager",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function"
    },
    {
      inputs: [
        {
          internalType: "bool",
          name: "_pause",
          type: "bool"
        }
      ],
      name: "setPause",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function"
    },
    {
      inputs: [],
      name: "solanaEmitter",
      outputs: [
        {
          internalType: "bytes32",
          name: "",
          type: "bytes32"
        }
      ],
      stateMutability: "view",
      type: "function"
    },
    {
      inputs: [
        {
          internalType: "bytes",
          name: "encodedVm",
          type: "bytes"
        }
      ],
      name: "unlockFee",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function"
    },
    {
      inputs: [
        {
          internalType: "bytes",
          name: "encodedVm1",
          type: "bytes"
        },
        {
          internalType: "bytes",
          name: "encodedVm2",
          type: "bytes"
        }
      ],
      name: "unlockFeeRefined",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function"
    },
    {
      inputs: [],
      name: "wormhole",
      outputs: [
        {
          internalType: "contract IWormhole",
          name: "",
          type: "address"
        }
      ],
      stateMutability: "view",
      type: "function"
    },
    {
      stateMutability: "payable",
      type: "receive"
    }
  ],
  linkReferences: {},
  deployedLinkReferences: {}
}, CCTP_TOKEN_DECIMALS = 6;
function getCCTPDomain(C) {
  switch (C) {
    case "ethereum":
      return 0;
    case "avalanche":
      return 1;
    case "optimism":
      return 2;
    case "arbitrum":
      return 3;
    case "solana":
      return 5;
    case "base":
      return 6;
    case "polygon":
      return 7;
    default:
      throw new Error("unsupported chain for cctp");
  }
}
function getCCTPBridgePDAs(C, e) {
  const T = new PublicKey(addresses_default.CCTP_CORE_PROGRAM_ID), $ = new PublicKey(addresses_default.CCTP_TOKEN_PROGRAM_ID), [V] = PublicKey.findProgramAddressSync(
    [bufferPolyfill.Buffer.from("message_transmitter")],
    T
  ), [J] = PublicKey.findProgramAddressSync(
    [bufferPolyfill.Buffer.from("sender_authority")],
    $
  ), [ee] = PublicKey.findProgramAddressSync(
    [bufferPolyfill.Buffer.from("local_token"), C.toBytes()],
    $
  ), [te] = PublicKey.findProgramAddressSync(
    [bufferPolyfill.Buffer.from("token_messenger")],
    $
  ), [re] = PublicKey.findProgramAddressSync(
    [bufferPolyfill.Buffer.from("token_minter")],
    $
  ), ie = getCCTPDomain(e), [se] = PublicKey.findProgramAddressSync(
    [bufferPolyfill.Buffer.from("remote_token_messenger"), bufferPolyfill.Buffer.from(ie.toString())],
    $
  ), [de] = PublicKey.findProgramAddressSync(
    [bufferPolyfill.Buffer.from("__event_authority")],
    T
  ), [ue] = PublicKey.findProgramAddressSync(
    [bufferPolyfill.Buffer.from("__event_authority")],
    $
  );
  return {
    messageTransmitter: V,
    senderAuthority: J,
    remoteTokenMessengerKey: se,
    tokenMessenger: te,
    tokenMinter: re,
    eventAuthToken: ue,
    eventAuthCore: de,
    localToken: ee
  };
}
function getEvmMctpBridgeParams(C, e, T) {
  const $ = getWormholeChainIdById(Number(T)), V = getWormholeChainIdByName(C.fromChain), J = getWormholeChainIdByName(C.toChain);
  if (V !== $)
    throw new Error(`Signer chain id(${Number(T)}) and quote from chain are not same! ${V} !== ${$}`);
  const ee = C.cheaperChain === C.fromChain, te = nativeAddressToHexString(e, J), re = getAmountOfFractionalAmount(C.redeemRelayerFee, CCTP_TOKEN_DECIMALS), ie = getAmountOfFractionalAmount(C.gasDrop, Math.min(getGasDecimal(C.toChain), 8)), se = getAmountOfFractionalAmount(C.effectiveAmountIn, C.fromToken.decimals), de = getCCTPDomain(C.toChain);
  if (!C.mctpMayanContract)
    throw new Error("MCTP contract address is missing");
  const ue = C.mctpMayanContract;
  let fe, he;
  if (C.toChain === "solana") {
    if (ee)
      throw new Error("Cannot lock fee for transfer to solana");
    const [xe] = PublicKey.findProgramAddressSync(
      [bufferPolyfill.Buffer.from("CALLER")],
      new PublicKey(addresses_default.MCTP_PROGRAM_ID)
    ), [ve] = PublicKey.findProgramAddressSync(
      [bufferPolyfill.Buffer.from("MAIN")],
      new PublicKey(addresses_default.MCTP_PROGRAM_ID)
    ), Te = new PublicKey(C.mctpOutputContract), we = getAssociatedTokenAddress(
      Te,
      ve,
      !0
    );
    fe = nativeAddressToHexString(we.toString(), getWormholeChainIdByName("solana")), he = nativeAddressToHexString(xe.toString(), getWormholeChainIdByName("solana"));
  } else
    he = nativeAddressToHexString(ue, J), ee ? fe = te : fe = he;
  let me = getAmountOfFractionalAmount(
    C.bridgeFee,
    getGasDecimal(C.fromChain)
  );
  return ee && (me = BigInt(0)), {
    lockFee: ee,
    tokenIn: C.mctpInputContract,
    amountIn: se,
    redeemFee: re,
    gasDrop: ie,
    destAddr: te,
    recipient: {
      destDomain: de,
      mintRecipient: fe,
      callerAddr: he
    },
    bridgeFee: me,
    contractAddress: ue
  };
}
function getEvmMctpBridgeTxPayload(C, e, T) {
  const $ = getEvmMctpBridgeParams(
    C,
    e,
    T
  ), {
    contractAddress: V,
    tokenIn: J,
    amountIn: ee,
    destAddr: te,
    lockFee: re,
    redeemFee: ie,
    gasDrop: se,
    recipient: de,
    bridgeFee: ue
  } = $, fe = new Contract(V, MayanCircleArtifact_default.abi);
  let he, me;
  return re ? he = fe.interface.encodeFunctionData(
    "bridgeWithLockedFee",
    [J, ee, se, ie, de]
  ) : he = fe.interface.encodeFunctionData(
    "bridgeWithFee",
    [J, ee, ie, se, te, de]
  ), me = toBeHex(ue), {
    to: V,
    data: he,
    value: me,
    _params: $
  };
}
function getEvmMctpCreateOrderParams(C, e, T, $) {
  const V = getWormholeChainIdById(Number($)), J = getWormholeChainIdByName(C.fromChain), ee = getWormholeChainIdByName(C.toChain);
  if (J !== V)
    throw new Error(`Signer chain id(${Number($)}) and quote from chain are not same! ${J} !== ${V}`);
  if (!C.mctpMayanContract)
    throw new Error("MCTP contract address is missing");
  const te = C.mctpMayanContract;
  let re, ie;
  if (C.toChain === "solana") {
    const [we] = PublicKey.findProgramAddressSync(
      [bufferPolyfill.Buffer.from("CALLER")],
      new PublicKey(addresses_default.MCTP_PROGRAM_ID)
    ), [Ee] = PublicKey.findProgramAddressSync(
      [bufferPolyfill.Buffer.from("MAIN")],
      new PublicKey(addresses_default.MCTP_PROGRAM_ID)
    ), Me = new PublicKey(C.mctpOutputContract), Ie = getAssociatedTokenAddress(
      Me,
      Ee,
      !0
    );
    re = nativeAddressToHexString(Ie.toString(), getWormholeChainIdByName("solana")), ie = nativeAddressToHexString(we.toString(), getWormholeChainIdByName("solana"));
  } else
    re = nativeAddressToHexString(te, ee), ie = nativeAddressToHexString(te, ee);
  const se = getCCTPDomain(C.toChain), de = nativeAddressToHexString(e, ee);
  let ue;
  T ? ue = nativeAddressToHexString(
    T,
    ee
  ) : ue = nativeAddressToHexString(
    SystemProgram.programId.toString(),
    getWormholeChainIdByName("solana")
  );
  const fe = getAmountOfFractionalAmount(C.redeemRelayerFee, CCTP_TOKEN_DECIMALS), he = getAmountOfFractionalAmount(C.gasDrop, Math.min(getGasDecimal(C.toChain), 8));
  let me = getAmountOfFractionalAmount(C.effectiveAmountIn, C.fromToken.decimals);
  const xe = getAmountOfFractionalAmount(
    C.minAmountOut,
    Math.min(8, C.toToken.decimals)
  ), ve = BigInt(C.deadline64), Te = C.toToken.contract === ZeroAddress ? nativeAddressToHexString(SystemProgram.programId.toString(), getWormholeChainIdByName("solana")) : nativeAddressToHexString(C.toToken.contract, C.toToken.wChainId);
  return {
    params: {
      tokenIn: C.mctpInputContract,
      amountIn: me,
      gasDrop: he,
      destAddr: de,
      destChain: ee,
      tokenOut: Te,
      minAmountOut: xe,
      deadline: ve,
      redeemFee: fe,
      referrerAddr: ue,
      referrerBps: C.referrerBps || 0
    },
    recipient: {
      destDomain: se,
      mintRecipient: re,
      callerAddr: ie
    },
    bridgeFee: getAmountOfFractionalAmount(C.bridgeFee, getGasDecimal(C.fromChain)),
    contractAddress: te
  };
}
function getEvmMctpCreateOrderTxPayload(C, e, T, $) {
  const V = getEvmMctpCreateOrderParams(
    C,
    e,
    T,
    $
  ), {
    contractAddress: J,
    params: ee,
    bridgeFee: te,
    recipient: re
  } = V, se = new Contract(J, MayanCircleArtifact_default.abi).interface.encodeFunctionData(
    "createOrder",
    [ee, re]
  ), de = toBeHex(te);
  return {
    to: J,
    data: se,
    value: de,
    _params: V
  };
}
function getMctpFromEvmTxPayload(C, e, T, $, V) {
  if (C.type !== "MCTP")
    throw new Error("Quote type is not MCTP");
  if (!Number.isFinite(Number($)))
    throw new Error("Invalid signer chain id");
  $ = Number($);
  const J = V || ZeroPermit, ee = new Contract(addresses_default.MAYAN_FORWARDER_CONTRACT, MayanForwarderArtifact_default.abi), te = getAmountOfFractionalAmount(
    C.bridgeFee,
    getGasDecimal(C.fromChain)
  );
  let re = toBeHex(te);
  if (C.fromToken.contract === C.mctpInputContract)
    if (C.hasAuction) {
      if (!Number(C.deadline64))
        throw new Error("MCTP order requires timeout");
      const ie = getEvmMctpCreateOrderTxPayload(
        C,
        e,
        T,
        $
      ), se = "forwardERC20", de = [
        C.fromToken.contract,
        ie._params.params.amountIn,
        J,
        ie._params.contractAddress,
        ie.data
      ];
      return {
        data: ee.interface.encodeFunctionData(se, de),
        to: addresses_default.MAYAN_FORWARDER_CONTRACT,
        value: toBeHex(re),
        chainId: $,
        _forwarder: {
          method: se,
          params: de
        }
      };
    } else {
      const ie = getEvmMctpBridgeTxPayload(
        C,
        e,
        $
      ), se = "forwardERC20", de = [
        C.fromToken.contract,
        ie._params.amountIn,
        J,
        ie._params.contractAddress,
        ie.data
      ];
      return {
        data: ee.interface.encodeFunctionData(se, de),
        to: addresses_default.MAYAN_FORWARDER_CONTRACT,
        value: toBeHex(re),
        chainId: $,
        _forwarder: {
          method: se,
          params: de
        }
      };
    }
  else {
    const { minMiddleAmount: ie, evmSwapRouterAddress: se, evmSwapRouterCalldata: de } = C;
    if (!ie || !se || !de)
      throw new Error("MCTP swap requires middle amount, router address and calldata");
    if (C.hasAuction) {
      if (!Number(C.deadline64))
        throw new Error("MCTP order requires timeout");
      const ue = getEvmMctpCreateOrderTxPayload(
        C,
        e,
        T,
        $
      ), fe = getAmountOfFractionalAmount(C.minMiddleAmount, CCTP_TOKEN_DECIMALS);
      if (C.fromToken.contract === ZeroAddress) {
        let he = ue._params.params.amountIn;
        if (he <= te)
          throw new Error("Amount in is less than bridge fee");
        te !== BigInt(0) && (he -= te), re = toBeHex(ue._params.params.amountIn);
        const me = "swapAndForwardEth", xe = [
          he,
          se,
          de,
          C.mctpInputContract,
          fe,
          ue._params.contractAddress,
          ue.data
        ];
        return {
          data: ee.interface.encodeFunctionData(me, xe),
          to: addresses_default.MAYAN_FORWARDER_CONTRACT,
          value: toBeHex(re),
          chainId: $,
          _forwarder: {
            method: me,
            params: xe
          }
        };
      } else {
        const he = "swapAndForwardERC20", me = [
          C.fromToken.contract,
          ue._params.params.amountIn,
          J,
          se,
          de,
          C.mctpInputContract,
          fe,
          ue._params.contractAddress,
          ue.data
        ];
        return {
          data: ee.interface.encodeFunctionData(he, me),
          to: addresses_default.MAYAN_FORWARDER_CONTRACT,
          value: toBeHex(re),
          chainId: $,
          _forwarder: {
            method: he,
            params: me
          }
        };
      }
    } else {
      const ue = getEvmMctpBridgeTxPayload(C, e, $), fe = getAmountOfFractionalAmount(C.minMiddleAmount, CCTP_TOKEN_DECIMALS);
      if (C.fromToken.contract === ZeroAddress) {
        let he = ue._params.amountIn;
        if (he <= te)
          throw new Error("Amount in is less than bridge fee");
        te !== BigInt(0) && (he -= te), re = toBeHex(ue._params.amountIn);
        const me = "swapAndForwardEth", xe = [
          he,
          se,
          de,
          C.mctpInputContract,
          fe,
          ue._params.contractAddress,
          ue.data
        ];
        return {
          data: ee.interface.encodeFunctionData(me, xe),
          to: addresses_default.MAYAN_FORWARDER_CONTRACT,
          value: toBeHex(re),
          chainId: $,
          _forwarder: {
            method: me,
            params: xe
          }
        };
      } else {
        const he = "swapAndForwardERC20", me = [
          C.fromToken.contract,
          ue._params.amountIn,
          J,
          se,
          de,
          C.mctpInputContract,
          fe,
          ue._params.contractAddress,
          ue.data
        ];
        return {
          data: ee.interface.encodeFunctionData(he, me),
          to: addresses_default.MAYAN_FORWARDER_CONTRACT,
          value: toBeHex(re),
          chainId: $,
          _forwarder: {
            method: he,
            params: me
          }
        };
      }
    }
  }
}
var MayanSwiftArtifact_default = {
  _format: "hh-sol-artifact-1",
  contractName: "MayanSwift",
  sourceName: "src/MayanSwift.sol",
  abi: [
    {
      inputs: [
        {
          internalType: "address",
          name: "_wormhole",
          type: "address"
        },
        {
          internalType: "address",
          name: "_feeManager",
          type: "address"
        },
        {
          internalType: "uint16",
          name: "_auctionChainId",
          type: "uint16"
        },
        {
          internalType: "bytes32",
          name: "_auctionAddr",
          type: "bytes32"
        },
        {
          internalType: "bytes32",
          name: "_solanaEmitter",
          type: "bytes32"
        },
        {
          internalType: "uint8",
          name: "_consistencyLevel",
          type: "uint8"
        }
      ],
      stateMutability: "nonpayable",
      type: "constructor"
    },
    {
      inputs: [],
      name: "DeadlineViolation",
      type: "error"
    },
    {
      inputs: [],
      name: "DuplicateOrder",
      type: "error"
    },
    {
      inputs: [],
      name: "FeesTooHigh",
      type: "error"
    },
    {
      inputs: [],
      name: "InvalidAction",
      type: "error"
    },
    {
      inputs: [],
      name: "InvalidAmount",
      type: "error"
    },
    {
      inputs: [],
      name: "InvalidAuctionMode",
      type: "error"
    },
    {
      inputs: [],
      name: "InvalidBpsFee",
      type: "error"
    },
    {
      inputs: [],
      name: "InvalidContractSignature",
      type: "error"
    },
    {
      inputs: [],
      name: "InvalidDestChain",
      type: "error"
    },
    {
      inputs: [],
      name: "InvalidEmitterAddress",
      type: "error"
    },
    {
      inputs: [],
      name: "InvalidEmitterChain",
      type: "error"
    },
    {
      inputs: [],
      name: "InvalidEvmAddr",
      type: "error"
    },
    {
      inputs: [],
      name: "InvalidGasDrop",
      type: "error"
    },
    {
      inputs: [],
      name: "InvalidOrderHash",
      type: "error"
    },
    {
      inputs: [],
      name: "InvalidOrderStatus",
      type: "error"
    },
    {
      inputs: [],
      name: "InvalidSignature",
      type: "error"
    },
    {
      inputs: [],
      name: "InvalidSignatureLength",
      type: "error"
    },
    {
      inputs: [],
      name: "InvalidSigner",
      type: "error"
    },
    {
      inputs: [],
      name: "InvalidSrcChain",
      type: "error"
    },
    {
      inputs: [],
      name: "InvalidWormholeFee",
      type: "error"
    },
    {
      inputs: [],
      name: "OrderNotExists",
      type: "error"
    },
    {
      inputs: [],
      name: "Paused",
      type: "error"
    },
    {
      inputs: [],
      name: "SmallAmountIn",
      type: "error"
    },
    {
      inputs: [],
      name: "Unauthorized",
      type: "error"
    },
    {
      anonymous: !1,
      inputs: [
        {
          indexed: !1,
          internalType: "bytes32",
          name: "key",
          type: "bytes32"
        },
        {
          indexed: !1,
          internalType: "uint64",
          name: "sequence",
          type: "uint64"
        }
      ],
      name: "OrderCanceled",
      type: "event"
    },
    {
      anonymous: !1,
      inputs: [
        {
          indexed: !1,
          internalType: "bytes32",
          name: "key",
          type: "bytes32"
        }
      ],
      name: "OrderCreated",
      type: "event"
    },
    {
      anonymous: !1,
      inputs: [
        {
          indexed: !1,
          internalType: "bytes32",
          name: "key",
          type: "bytes32"
        },
        {
          indexed: !1,
          internalType: "uint64",
          name: "sequence",
          type: "uint64"
        },
        {
          indexed: !1,
          internalType: "uint256",
          name: "netAmount",
          type: "uint256"
        }
      ],
      name: "OrderFulfilled",
      type: "event"
    },
    {
      anonymous: !1,
      inputs: [
        {
          indexed: !1,
          internalType: "bytes32",
          name: "key",
          type: "bytes32"
        },
        {
          indexed: !1,
          internalType: "uint256",
          name: "netAmount",
          type: "uint256"
        }
      ],
      name: "OrderRefunded",
      type: "event"
    },
    {
      anonymous: !1,
      inputs: [
        {
          indexed: !1,
          internalType: "bytes32",
          name: "key",
          type: "bytes32"
        }
      ],
      name: "OrderUnlocked",
      type: "event"
    },
    {
      inputs: [],
      name: "auctionAddr",
      outputs: [
        {
          internalType: "bytes32",
          name: "",
          type: "bytes32"
        }
      ],
      stateMutability: "view",
      type: "function"
    },
    {
      inputs: [],
      name: "auctionChainId",
      outputs: [
        {
          internalType: "uint16",
          name: "",
          type: "uint16"
        }
      ],
      stateMutability: "view",
      type: "function"
    },
    {
      inputs: [
        {
          internalType: "bytes32",
          name: "tokenIn",
          type: "bytes32"
        },
        {
          components: [
            {
              internalType: "bytes32",
              name: "trader",
              type: "bytes32"
            },
            {
              internalType: "bytes32",
              name: "tokenOut",
              type: "bytes32"
            },
            {
              internalType: "uint64",
              name: "minAmountOut",
              type: "uint64"
            },
            {
              internalType: "uint64",
              name: "gasDrop",
              type: "uint64"
            },
            {
              internalType: "uint64",
              name: "cancelFee",
              type: "uint64"
            },
            {
              internalType: "uint64",
              name: "refundFee",
              type: "uint64"
            },
            {
              internalType: "uint64",
              name: "deadline",
              type: "uint64"
            },
            {
              internalType: "bytes32",
              name: "destAddr",
              type: "bytes32"
            },
            {
              internalType: "uint16",
              name: "destChainId",
              type: "uint16"
            },
            {
              internalType: "bytes32",
              name: "referrerAddr",
              type: "bytes32"
            },
            {
              internalType: "uint8",
              name: "referrerBps",
              type: "uint8"
            },
            {
              internalType: "uint8",
              name: "auctionMode",
              type: "uint8"
            },
            {
              internalType: "bytes32",
              name: "random",
              type: "bytes32"
            }
          ],
          internalType: "struct MayanSwift.OrderParams",
          name: "params",
          type: "tuple"
        },
        {
          internalType: "uint16",
          name: "srcChainId",
          type: "uint16"
        },
        {
          internalType: "uint8",
          name: "protocolBps",
          type: "uint8"
        },
        {
          internalType: "bytes32",
          name: "canceler",
          type: "bytes32"
        }
      ],
      name: "cancelOrder",
      outputs: [
        {
          internalType: "uint64",
          name: "sequence",
          type: "uint64"
        }
      ],
      stateMutability: "payable",
      type: "function"
    },
    {
      inputs: [
        {
          internalType: "address",
          name: "newGuardian",
          type: "address"
        }
      ],
      name: "changeGuardian",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function"
    },
    {
      inputs: [],
      name: "claimGuardian",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function"
    },
    {
      inputs: [],
      name: "consistencyLevel",
      outputs: [
        {
          internalType: "uint8",
          name: "",
          type: "uint8"
        }
      ],
      stateMutability: "view",
      type: "function"
    },
    {
      inputs: [
        {
          components: [
            {
              internalType: "bytes32",
              name: "trader",
              type: "bytes32"
            },
            {
              internalType: "bytes32",
              name: "tokenOut",
              type: "bytes32"
            },
            {
              internalType: "uint64",
              name: "minAmountOut",
              type: "uint64"
            },
            {
              internalType: "uint64",
              name: "gasDrop",
              type: "uint64"
            },
            {
              internalType: "uint64",
              name: "cancelFee",
              type: "uint64"
            },
            {
              internalType: "uint64",
              name: "refundFee",
              type: "uint64"
            },
            {
              internalType: "uint64",
              name: "deadline",
              type: "uint64"
            },
            {
              internalType: "bytes32",
              name: "destAddr",
              type: "bytes32"
            },
            {
              internalType: "uint16",
              name: "destChainId",
              type: "uint16"
            },
            {
              internalType: "bytes32",
              name: "referrerAddr",
              type: "bytes32"
            },
            {
              internalType: "uint8",
              name: "referrerBps",
              type: "uint8"
            },
            {
              internalType: "uint8",
              name: "auctionMode",
              type: "uint8"
            },
            {
              internalType: "bytes32",
              name: "random",
              type: "bytes32"
            }
          ],
          internalType: "struct MayanSwift.OrderParams",
          name: "params",
          type: "tuple"
        }
      ],
      name: "createOrderWithEth",
      outputs: [
        {
          internalType: "bytes32",
          name: "orderHash",
          type: "bytes32"
        }
      ],
      stateMutability: "payable",
      type: "function"
    },
    {
      inputs: [
        {
          internalType: "address",
          name: "tokenIn",
          type: "address"
        },
        {
          internalType: "uint256",
          name: "amountIn",
          type: "uint256"
        },
        {
          components: [
            {
              internalType: "bytes32",
              name: "trader",
              type: "bytes32"
            },
            {
              internalType: "bytes32",
              name: "tokenOut",
              type: "bytes32"
            },
            {
              internalType: "uint64",
              name: "minAmountOut",
              type: "uint64"
            },
            {
              internalType: "uint64",
              name: "gasDrop",
              type: "uint64"
            },
            {
              internalType: "uint64",
              name: "cancelFee",
              type: "uint64"
            },
            {
              internalType: "uint64",
              name: "refundFee",
              type: "uint64"
            },
            {
              internalType: "uint64",
              name: "deadline",
              type: "uint64"
            },
            {
              internalType: "bytes32",
              name: "destAddr",
              type: "bytes32"
            },
            {
              internalType: "uint16",
              name: "destChainId",
              type: "uint16"
            },
            {
              internalType: "bytes32",
              name: "referrerAddr",
              type: "bytes32"
            },
            {
              internalType: "uint8",
              name: "referrerBps",
              type: "uint8"
            },
            {
              internalType: "uint8",
              name: "auctionMode",
              type: "uint8"
            },
            {
              internalType: "bytes32",
              name: "random",
              type: "bytes32"
            }
          ],
          internalType: "struct MayanSwift.OrderParams",
          name: "params",
          type: "tuple"
        },
        {
          internalType: "bytes",
          name: "signedOrderHash",
          type: "bytes"
        }
      ],
      name: "createOrderWithSig",
      outputs: [
        {
          internalType: "bytes32",
          name: "orderHash",
          type: "bytes32"
        }
      ],
      stateMutability: "nonpayable",
      type: "function"
    },
    {
      inputs: [
        {
          internalType: "address",
          name: "tokenIn",
          type: "address"
        },
        {
          internalType: "uint256",
          name: "amountIn",
          type: "uint256"
        },
        {
          components: [
            {
              internalType: "bytes32",
              name: "trader",
              type: "bytes32"
            },
            {
              internalType: "bytes32",
              name: "tokenOut",
              type: "bytes32"
            },
            {
              internalType: "uint64",
              name: "minAmountOut",
              type: "uint64"
            },
            {
              internalType: "uint64",
              name: "gasDrop",
              type: "uint64"
            },
            {
              internalType: "uint64",
              name: "cancelFee",
              type: "uint64"
            },
            {
              internalType: "uint64",
              name: "refundFee",
              type: "uint64"
            },
            {
              internalType: "uint64",
              name: "deadline",
              type: "uint64"
            },
            {
              internalType: "bytes32",
              name: "destAddr",
              type: "bytes32"
            },
            {
              internalType: "uint16",
              name: "destChainId",
              type: "uint16"
            },
            {
              internalType: "bytes32",
              name: "referrerAddr",
              type: "bytes32"
            },
            {
              internalType: "uint8",
              name: "referrerBps",
              type: "uint8"
            },
            {
              internalType: "uint8",
              name: "auctionMode",
              type: "uint8"
            },
            {
              internalType: "bytes32",
              name: "random",
              type: "bytes32"
            }
          ],
          internalType: "struct MayanSwift.OrderParams",
          name: "params",
          type: "tuple"
        }
      ],
      name: "createOrderWithToken",
      outputs: [
        {
          internalType: "bytes32",
          name: "orderHash",
          type: "bytes32"
        }
      ],
      stateMutability: "nonpayable",
      type: "function"
    },
    {
      inputs: [],
      name: "feeManager",
      outputs: [
        {
          internalType: "contract IFeeManager",
          name: "",
          type: "address"
        }
      ],
      stateMutability: "view",
      type: "function"
    },
    {
      inputs: [
        {
          internalType: "uint256",
          name: "fulfillAmount",
          type: "uint256"
        },
        {
          internalType: "bytes",
          name: "encodedVm",
          type: "bytes"
        },
        {
          internalType: "bytes32",
          name: "recepient",
          type: "bytes32"
        },
        {
          internalType: "bool",
          name: "batch",
          type: "bool"
        }
      ],
      name: "fulfillOrder",
      outputs: [
        {
          internalType: "uint64",
          name: "sequence",
          type: "uint64"
        }
      ],
      stateMutability: "payable",
      type: "function"
    },
    {
      inputs: [
        {
          internalType: "uint256",
          name: "fulfillAmount",
          type: "uint256"
        },
        {
          internalType: "bytes32",
          name: "orderHash",
          type: "bytes32"
        },
        {
          internalType: "uint16",
          name: "srcChainId",
          type: "uint16"
        },
        {
          internalType: "bytes32",
          name: "tokenIn",
          type: "bytes32"
        },
        {
          internalType: "uint8",
          name: "protocolBps",
          type: "uint8"
        },
        {
          components: [
            {
              internalType: "bytes32",
              name: "trader",
              type: "bytes32"
            },
            {
              internalType: "bytes32",
              name: "tokenOut",
              type: "bytes32"
            },
            {
              internalType: "uint64",
              name: "minAmountOut",
              type: "uint64"
            },
            {
              internalType: "uint64",
              name: "gasDrop",
              type: "uint64"
            },
            {
              internalType: "uint64",
              name: "cancelFee",
              type: "uint64"
            },
            {
              internalType: "uint64",
              name: "refundFee",
              type: "uint64"
            },
            {
              internalType: "uint64",
              name: "deadline",
              type: "uint64"
            },
            {
              internalType: "bytes32",
              name: "destAddr",
              type: "bytes32"
            },
            {
              internalType: "uint16",
              name: "destChainId",
              type: "uint16"
            },
            {
              internalType: "bytes32",
              name: "referrerAddr",
              type: "bytes32"
            },
            {
              internalType: "uint8",
              name: "referrerBps",
              type: "uint8"
            },
            {
              internalType: "uint8",
              name: "auctionMode",
              type: "uint8"
            },
            {
              internalType: "bytes32",
              name: "random",
              type: "bytes32"
            }
          ],
          internalType: "struct MayanSwift.OrderParams",
          name: "params",
          type: "tuple"
        },
        {
          internalType: "bytes32",
          name: "recepient",
          type: "bytes32"
        },
        {
          internalType: "bool",
          name: "batch",
          type: "bool"
        }
      ],
      name: "fulfillSimple",
      outputs: [
        {
          internalType: "uint64",
          name: "sequence",
          type: "uint64"
        }
      ],
      stateMutability: "payable",
      type: "function"
    },
    {
      inputs: [],
      name: "guardian",
      outputs: [
        {
          internalType: "address",
          name: "",
          type: "address"
        }
      ],
      stateMutability: "view",
      type: "function"
    },
    {
      inputs: [],
      name: "nextGuardian",
      outputs: [
        {
          internalType: "address",
          name: "",
          type: "address"
        }
      ],
      stateMutability: "view",
      type: "function"
    },
    {
      inputs: [
        {
          internalType: "bytes32",
          name: "",
          type: "bytes32"
        }
      ],
      name: "orders",
      outputs: [
        {
          internalType: "enum MayanSwift.Status",
          name: "status",
          type: "uint8"
        },
        {
          internalType: "uint64",
          name: "amountIn",
          type: "uint64"
        },
        {
          internalType: "uint16",
          name: "destChainId",
          type: "uint16"
        }
      ],
      stateMutability: "view",
      type: "function"
    },
    {
      inputs: [
        {
          internalType: "bytes",
          name: "encoded",
          type: "bytes"
        }
      ],
      name: "parseFulfillPayload",
      outputs: [
        {
          components: [
            {
              internalType: "uint8",
              name: "action",
              type: "uint8"
            },
            {
              internalType: "bytes32",
              name: "orderHash",
              type: "bytes32"
            },
            {
              internalType: "uint16",
              name: "destChainId",
              type: "uint16"
            },
            {
              internalType: "bytes32",
              name: "destAddr",
              type: "bytes32"
            },
            {
              internalType: "bytes32",
              name: "driver",
              type: "bytes32"
            },
            {
              internalType: "bytes32",
              name: "tokenOut",
              type: "bytes32"
            },
            {
              internalType: "uint64",
              name: "promisedAmount",
              type: "uint64"
            },
            {
              internalType: "uint64",
              name: "gasDrop",
              type: "uint64"
            },
            {
              internalType: "uint64",
              name: "deadline",
              type: "uint64"
            },
            {
              internalType: "bytes32",
              name: "referrerAddr",
              type: "bytes32"
            },
            {
              internalType: "uint8",
              name: "referrerBps",
              type: "uint8"
            },
            {
              internalType: "uint8",
              name: "protocolBps",
              type: "uint8"
            },
            {
              internalType: "uint16",
              name: "srcChainId",
              type: "uint16"
            },
            {
              internalType: "bytes32",
              name: "tokenIn",
              type: "bytes32"
            }
          ],
          internalType: "struct MayanSwift.FulfillMsg",
          name: "fulfillMsg",
          type: "tuple"
        }
      ],
      stateMutability: "pure",
      type: "function"
    },
    {
      inputs: [
        {
          internalType: "bytes",
          name: "encoded",
          type: "bytes"
        }
      ],
      name: "parseRefundPayload",
      outputs: [
        {
          components: [
            {
              internalType: "uint8",
              name: "action",
              type: "uint8"
            },
            {
              internalType: "bytes32",
              name: "orderHash",
              type: "bytes32"
            },
            {
              internalType: "uint16",
              name: "srcChainId",
              type: "uint16"
            },
            {
              internalType: "bytes32",
              name: "tokenIn",
              type: "bytes32"
            },
            {
              internalType: "bytes32",
              name: "recipient",
              type: "bytes32"
            },
            {
              internalType: "bytes32",
              name: "canceler",
              type: "bytes32"
            },
            {
              internalType: "uint64",
              name: "cancelFee",
              type: "uint64"
            },
            {
              internalType: "uint64",
              name: "refundFee",
              type: "uint64"
            }
          ],
          internalType: "struct MayanSwift.RefundMsg",
          name: "refundMsg",
          type: "tuple"
        }
      ],
      stateMutability: "pure",
      type: "function"
    },
    {
      inputs: [
        {
          internalType: "bytes",
          name: "encoded",
          type: "bytes"
        }
      ],
      name: "parseUnlockPayload",
      outputs: [
        {
          components: [
            {
              internalType: "uint8",
              name: "action",
              type: "uint8"
            },
            {
              internalType: "bytes32",
              name: "orderHash",
              type: "bytes32"
            },
            {
              internalType: "uint16",
              name: "srcChainId",
              type: "uint16"
            },
            {
              internalType: "bytes32",
              name: "tokenIn",
              type: "bytes32"
            },
            {
              internalType: "bytes32",
              name: "recipient",
              type: "bytes32"
            }
          ],
          internalType: "struct MayanSwift.UnlockMsg",
          name: "unlockMsg",
          type: "tuple"
        }
      ],
      stateMutability: "pure",
      type: "function"
    },
    {
      inputs: [],
      name: "paused",
      outputs: [
        {
          internalType: "bool",
          name: "",
          type: "bool"
        }
      ],
      stateMutability: "view",
      type: "function"
    },
    {
      inputs: [
        {
          internalType: "bytes32[]",
          name: "orderHashes",
          type: "bytes32[]"
        }
      ],
      name: "postBatch",
      outputs: [
        {
          internalType: "uint64",
          name: "sequence",
          type: "uint64"
        }
      ],
      stateMutability: "payable",
      type: "function"
    },
    {
      inputs: [
        {
          internalType: "bytes",
          name: "encodedVm",
          type: "bytes"
        }
      ],
      name: "refundOrder",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function"
    },
    {
      inputs: [
        {
          internalType: "uint8",
          name: "_consistencyLevel",
          type: "uint8"
        }
      ],
      name: "setConsistencyLevel",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function"
    },
    {
      inputs: [
        {
          internalType: "address",
          name: "_feeManager",
          type: "address"
        }
      ],
      name: "setFeeManager",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function"
    },
    {
      inputs: [
        {
          internalType: "bool",
          name: "_pause",
          type: "bool"
        }
      ],
      name: "setPause",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function"
    },
    {
      inputs: [],
      name: "solanaEmitter",
      outputs: [
        {
          internalType: "bytes32",
          name: "",
          type: "bytes32"
        }
      ],
      stateMutability: "view",
      type: "function"
    },
    {
      inputs: [
        {
          internalType: "bytes",
          name: "encodedVm",
          type: "bytes"
        }
      ],
      name: "unlockBatch",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function"
    },
    {
      inputs: [
        {
          internalType: "bytes32",
          name: "",
          type: "bytes32"
        }
      ],
      name: "unlockMsgs",
      outputs: [
        {
          internalType: "uint8",
          name: "action",
          type: "uint8"
        },
        {
          internalType: "bytes32",
          name: "orderHash",
          type: "bytes32"
        },
        {
          internalType: "uint16",
          name: "srcChainId",
          type: "uint16"
        },
        {
          internalType: "bytes32",
          name: "tokenIn",
          type: "bytes32"
        },
        {
          internalType: "bytes32",
          name: "recipient",
          type: "bytes32"
        }
      ],
      stateMutability: "view",
      type: "function"
    },
    {
      inputs: [
        {
          internalType: "bytes",
          name: "encodedVm",
          type: "bytes"
        }
      ],
      name: "unlockSingle",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function"
    },
    {
      inputs: [],
      name: "wormhole",
      outputs: [
        {
          internalType: "contract IWormhole",
          name: "",
          type: "address"
        }
      ],
      stateMutability: "view",
      type: "function"
    },
    {
      stateMutability: "payable",
      type: "receive"
    }
  ],
  linkReferences: {},
  deployedLinkReferences: {}
};
function createAssociatedTokenAccountInstruction(C, e, T, $, V = new PublicKey(addresses_default.TOKEN_PROGRAM_ID), J = new PublicKey(addresses_default.ASSOCIATED_TOKEN_PROGRAM_ID)) {
  const ee = [
    { pubkey: C, isSigner: !0, isWritable: !0 },
    { pubkey: e, isSigner: !1, isWritable: !0 },
    { pubkey: T, isSigner: !1, isWritable: !1 },
    { pubkey: $, isSigner: !1, isWritable: !1 },
    { pubkey: SystemProgram.programId, isSigner: !1, isWritable: !1 },
    { pubkey: V, isSigner: !1, isWritable: !1 },
    { pubkey: SYSVAR_RENT_PUBKEY, isSigner: !1, isWritable: !1 }
  ];
  return new TransactionInstruction({
    keys: ee,
    programId: J,
    data: bufferPolyfill.Buffer.alloc(0)
  });
}
var ApproveInstructionData = struct$1([
  u8$1("instruction"),
  blob$1(8, "amount")
]);
function createApproveInstruction(C, e, T, $, V = new PublicKey(addresses_default.TOKEN_PROGRAM_ID)) {
  const J = [
    { pubkey: C, isSigner: !1, isWritable: !0 },
    { pubkey: e, isSigner: !1, isWritable: !1 },
    { pubkey: T, isSigner: !0, isWritable: !1 }
  ], ee = bufferPolyfill.Buffer.alloc(ApproveInstructionData.span);
  return ApproveInstructionData.encode(
    {
      instruction: 4,
      amount: getSafeU64Blob($)
    },
    ee
  ), new TransactionInstruction({ keys: J, programId: V, data: ee });
}
var SyncNativeInstructionData = struct$1([u8$1("instruction")]);
function createSyncNativeInstruction(C) {
  const e = [{ pubkey: C, isSigner: !1, isWritable: !0 }], T = bufferPolyfill.Buffer.alloc(SyncNativeInstructionData.span);
  return SyncNativeInstructionData.encode({ instruction: 17 }, T), new TransactionInstruction({
    keys: e,
    programId: new PublicKey(addresses_default.TOKEN_PROGRAM_ID),
    data: T
  });
}
struct$1([
  u8$1("instruction")
]);
var SplTransferInstructionData = struct$1([
  u8$1("instruction"),
  blob$1(8, "amount")
]);
function createSplTransferInstruction(C, e, T, $, V = new PublicKey(addresses_default.TOKEN_PROGRAM_ID)) {
  const J = [
    { pubkey: C, isSigner: !1, isWritable: !0 },
    { pubkey: e, isSigner: !1, isWritable: !0 },
    { pubkey: T, isSigner: !0, isWritable: !1 }
  ], ee = bufferPolyfill.Buffer.alloc(SplTransferInstructionData.span);
  return SplTransferInstructionData.encode(
    {
      instruction: 3,
      amount: getSafeU64Blob($)
    },
    ee
  ), new TransactionInstruction({ keys: J, programId: V, data: ee });
}
var solMint = new PublicKey("So11111111111111111111111111111111111111112");
function deserializeInstructionInfo(C) {
  return new TransactionInstruction({
    programId: new PublicKey(C.programId),
    keys: C.accounts.map((e) => ({
      pubkey: new PublicKey(e.pubkey),
      isSigner: e.isSigner,
      isWritable: e.isWritable
    })),
    data: bufferPolyfill.Buffer.from(C.data, "base64")
  });
}
async function getAddressLookupTableAccounts(C, e) {
  return (await e.getMultipleAccountsInfo(
    C.map(($) => new PublicKey($))
  )).reduce(($, V, J) => {
    const ee = C[J];
    if (V) {
      const te = new AddressLookupTableAccount({
        key: new PublicKey(ee),
        state: AddressLookupTableAccount.deserialize(V.data)
      });
      $.push(te);
    }
    return $;
  }, new Array());
}
function decentralizeClientSwapInstructions(C, e) {
  const T = deserializeInstructionInfo(C.swapInstruction), $ = C.cleanupInstruction ? deserializeInstructionInfo(C.cleanupInstruction) : null, V = C.computeBudgetInstructions ? C.computeBudgetInstructions.map(deserializeInstructionInfo) : [], J = C.setupInstructions ? C.setupInstructions.map(deserializeInstructionInfo) : [];
  return {
    swapInstruction: T,
    cleanupInstruction: $,
    computeBudgetInstructions: V,
    setupInstructions: J,
    addressLookupTableAddresses: C.addressLookupTableAddresses
  };
}
function getAnchorInstructionData(C) {
  let e = `global:${C}`;
  return bufferPolyfill.Buffer.from(sha256Exports.sha256.digest(e)).slice(0, 8);
}
async function decideRelayer() {
  let C;
  try {
    const e = await getSuggestedRelayer();
    C = new PublicKey(e);
  } catch {
    console.log("Relayer not found, using system program"), C = SystemProgram.programId;
  }
  return C;
}
function createSwiftOrderHash(C, e, T, $, V) {
  const ee = bufferPolyfill.Buffer.alloc(239);
  let te = 0;
  const re = getWormholeChainIdByName(C.fromChain), ie = bufferPolyfill.Buffer.from(hexToUint8Array(nativeAddressToHexString(e, re)));
  ee.set(ie, 0), te += 32, ee.writeUInt16BE(re, te), te += 2;
  const se = C.swiftInputContract === ZeroAddress ? nativeAddressToHexString(SystemProgram.programId.toString(), getWormholeChainIdByName("solana")) : nativeAddressToHexString(C.swiftInputContract, re), de = bufferPolyfill.Buffer.from(hexToUint8Array(se));
  ee.set(de, te), te += 32;
  const ue = getWormholeChainIdByName(C.toChain), fe = bufferPolyfill.Buffer.from(hexToUint8Array(nativeAddressToHexString(T, ue)));
  ee.set(fe, te), te += 32, ee.writeUInt16BE(ue, te), te += 2;
  const he = C.toToken.contract === ZeroAddress ? nativeAddressToHexString(SystemProgram.programId.toString(), getWormholeChainIdByName("solana")) : nativeAddressToHexString(C.toToken.contract, ue), me = bufferPolyfill.Buffer.from(hexToUint8Array(he));
  ee.set(me, te), te += 32, ee.writeBigUInt64BE(getAmountOfFractionalAmount(C.minAmountOut, Math.min(C.toToken.decimals, 8)), te), te += 8, ee.writeBigUInt64BE(getAmountOfFractionalAmount(C.gasDrop, Math.min(getGasDecimal(C.toChain), 8)), te), te += 8, ee.writeBigUInt64BE(BigInt(C.cancelRelayerFee64), te), te += 8, ee.writeBigUInt64BE(BigInt(C.refundRelayerFee64), te), te += 8, ee.writeBigUInt64BE(BigInt(C.deadline64), te), te += 8;
  const xe = $ ? bufferPolyfill.Buffer.from(hexToUint8Array(nativeAddressToHexString($, ue))) : SystemProgram.programId.toBuffer();
  ee.set(xe, te), te += 32, ee.writeUInt8(C.referrerBps, te), te += 1;
  const ve = C.protocolBps;
  ee.writeUInt8(ve, te), te += 1, ee.writeUInt8(C.swiftAuctionMode, te), te += 1;
  const Te = bufferPolyfill.Buffer.from(hexToUint8Array(V));
  if (ee.set(Te, te), te += 32, te !== 239)
    throw new Error(`Invalid order data size: ${te}`);
  const we = keccak256(ee);
  return bufferPolyfill.Buffer.from(hexToUint8Array(we));
}
var InitSwiftLayout = struct$1([
  blob$1(8, "instruction"),
  blob$1(8, "amountInMin"),
  u8$1("nativeInput"),
  blob$1(8, "feeSubmit"),
  blob$1(32, "destAddress"),
  u16("destinationChain"),
  blob$1(32, "tokenOut"),
  blob$1(8, "amountOutMin"),
  blob$1(8, "gasDrop"),
  blob$1(8, "feeCancel"),
  blob$1(8, "feeRefund"),
  blob$1(8, "deadline"),
  blob$1(32, "refAddress"),
  u8$1("feeRateRef"),
  u8$1("feeRateMayan"),
  u8$1("auctionMode"),
  blob$1(32, "randomKey")
]);
function createSwiftInitInstruction(C) {
  const { quote: e } = C, T = e.swiftInputContract === ZeroAddress ? solMint : new PublicKey(e.swiftInputContract), $ = getWormholeChainIdByName(e.toChain);
  if ($ !== e.toToken.wChainId)
    throw new Error(`Destination chain ID mismatch: ${$} != ${e.toToken.wChainId}`);
  const V = [
    { pubkey: C.trader, isWritable: !1, isSigner: !0 },
    { pubkey: C.relayer, isWritable: !0, isSigner: !0 },
    { pubkey: C.state, isWritable: !0, isSigner: !1 },
    { pubkey: C.stateAccount, isWritable: !0, isSigner: !1 },
    { pubkey: C.relayerAccount, isWritable: !0, isSigner: !1 },
    { pubkey: T, isWritable: !1, isSigner: !1 },
    { pubkey: new PublicKey(addresses_default.FEE_MANAGER_PROGRAM_ID), isWritable: !1, isSigner: !1 },
    { pubkey: new PublicKey(addresses_default.TOKEN_PROGRAM_ID), isWritable: !1, isSigner: !1 },
    { pubkey: SystemProgram.programId, isWritable: !1, isSigner: !1 }
  ], J = bufferPolyfill.Buffer.alloc(InitSwiftLayout.span), ee = C.referrerAddress ? bufferPolyfill.Buffer.from(hexToUint8Array(nativeAddressToHexString(C.referrerAddress, $))) : SystemProgram.programId.toBuffer(), te = e.fromToken.contract === e.swiftInputContract ? e.effectiveAmountIn : e.minMiddleAmount;
  return InitSwiftLayout.encode({
    instruction: getAnchorInstructionData("init_order"),
    amountInMin: getSafeU64Blob(getAmountOfFractionalAmount(te, e.swiftInputDecimals)),
    nativeInput: e.swiftInputContract === ZeroAddress ? 1 : 0,
    feeSubmit: getSafeU64Blob(BigInt(e.submitRelayerFee64)),
    destAddress: bufferPolyfill.Buffer.from(hexToUint8Array(nativeAddressToHexString(C.destinationAddress, $))),
    destinationChain: $,
    tokenOut: bufferPolyfill.Buffer.from(hexToUint8Array(nativeAddressToHexString(e.toToken.contract, $))),
    amountOutMin: getSafeU64Blob(getAmountOfFractionalAmount(e.minAmountOut, Math.min(e.toToken.decimals, 8))),
    gasDrop: getSafeU64Blob(getAmountOfFractionalAmount(e.gasDrop, Math.min(getGasDecimal(e.toChain), 8))),
    feeCancel: getSafeU64Blob(BigInt(e.cancelRelayerFee64)),
    feeRefund: getSafeU64Blob(BigInt(e.refundRelayerFee64)),
    deadline: getSafeU64Blob(C.deadline),
    refAddress: ee,
    feeRateRef: e.referrerBps,
    feeRateMayan: e.protocolBps,
    auctionMode: e.swiftAuctionMode,
    randomKey: C.randomKey.toBuffer()
  }, J), new TransactionInstruction({
    keys: V,
    data: J,
    programId: new PublicKey(addresses_default.SWIFT_PROGRAM_ID)
  });
}
async function createSwiftFromSolanaInstructions(C, e, T, $, V) {
  if (C.type !== "SWIFT")
    throw new Error("Unsupported quote type for Swift: " + C.type);
  if (C.toChain === "solana")
    throw new Error("Unsupported destination chain: " + C.toChain);
  let J = [], ee = [], te = [];
  te.push(addresses_default.LOOKUP_TABLE);
  const re = new PublicKey(addresses_default.SWIFT_PROGRAM_ID), ie = new PublicKey(e), se = Keypair.generate();
  if (!Number(C.deadline64))
    throw new Error("Swift mode requires a timeout");
  const de = BigInt(C.deadline64), ue = createSwiftOrderHash(
    C,
    e,
    T,
    $,
    se.publicKey.toBuffer().toString("hex")
  ), [fe] = PublicKey.findProgramAddressSync(
    [bufferPolyfill.Buffer.from("STATE_SOURCE"), ue],
    re
  ), he = getAssociatedTokenAddress(
    new PublicKey(C.swiftInputContract),
    fe,
    !0
  ), me = C.swiftInputContract === ZeroAddress ? solMint : new PublicKey(C.swiftInputContract), xe = C.gasless ? new PublicKey(C.relayer) : ie, ve = getAssociatedTokenAddress(me, xe, !1);
  if (C.fromToken.contract === C.swiftInputContract)
    C.suggestedPriorityFee > 0 && J.push(ComputeBudgetProgram.setComputeUnitPrice({
      microLamports: C.suggestedPriorityFee
    })), J.push(
      createAssociatedTokenAccountInstruction(xe, he, fe, me)
    ), C.swiftInputContract === ZeroAddress ? J.push(
      SystemProgram.transfer({
        fromPubkey: ie,
        toPubkey: he,
        lamports: getAmountOfFractionalAmount(C.effectiveAmountIn, C.fromToken.decimals)
      }),
      createSyncNativeInstruction(he)
    ) : J.push(
      createSplTransferInstruction(
        getAssociatedTokenAddress(
          me,
          ie,
          !1
        ),
        he,
        ie,
        getAmountOfFractionalAmount(C.effectiveAmountIn, C.fromToken.decimals)
      )
    );
  else {
    const Te = await getSwapSolana({
      minMiddleAmount: C.minMiddleAmount,
      middleToken: C.swiftInputContract,
      userWallet: e,
      slippageBps: C.slippageBps,
      fromToken: C.fromToken.contract,
      amountIn: C.effectiveAmountIn,
      depositMode: C.gasless ? "SWIFT_GASLESS" : "SWIFT",
      orderHash: `0x${ue.toString("hex")}`
    }), we = decentralizeClientSwapInstructions(Te);
    J.push(...we.computeBudgetInstructions), we.setupInstructions && J.push(...we.setupInstructions), J.push(we.swapInstruction), we.cleanupInstruction && J.push(we.cleanupInstruction), te.push(...we.addressLookupTableAddresses);
  }
  return J.push(createSwiftInitInstruction({
    quote: C,
    state: fe,
    trader: ie,
    stateAccount: he,
    randomKey: se.publicKey,
    relayerAccount: ve,
    relayer: xe,
    destinationAddress: T,
    deadline: de,
    referrerAddress: $
  })), ee = await getAddressLookupTableAccounts(te, V), { instructions: J, signers: [], lookupTables: ee };
}
function getEvmSwiftParams(C, e, T, $, V) {
  const J = getWormholeChainIdById(Number(V)), ee = getWormholeChainIdByName(C.fromChain), te = getWormholeChainIdByName(C.toChain);
  if (ee !== J)
    throw new Error(`Signer chain id(${Number(V)}) and quote from chain are not same! ${ee} !== ${J}`);
  if (!C.swiftMayanContract)
    throw new Error("SWIFT contract address is missing");
  if (C.toToken.wChainId !== te)
    throw new Error(`Destination chain ID mismatch: ${te} != ${C.toToken.wChainId}`);
  const re = C.swiftMayanContract;
  if (!Number(C.deadline64))
    throw new Error("Swift order requires timeout");
  const ie = BigInt(C.deadline64), se = C.swiftInputContract, de = getAmountOfFractionalAmount(
    C.effectiveAmountIn,
    C.fromToken.decimals
  );
  let ue;
  $ ? ue = nativeAddressToHexString(
    $,
    te
  ) : ue = nativeAddressToHexString(
    SystemProgram.programId.toString(),
    1
  );
  const fe = nativeAddressToHexString(Keypair.generate().publicKey.toString(), 1), he = C.toToken.contract === ZeroAddress ? nativeAddressToHexString(SystemProgram.programId.toString(), 1) : nativeAddressToHexString(C.toToken.contract, te), me = getAmountOfFractionalAmount(
    C.minAmountOut,
    Math.min(8, C.toToken.decimals)
  ), xe = getAmountOfFractionalAmount(
    C.gasDrop,
    Math.min(8, getGasDecimal(C.toChain))
  ), ve = nativeAddressToHexString(T, te), Te = {
    trader: nativeAddressToHexString(e, ee),
    tokenOut: he,
    minAmountOut: me,
    gasDrop: xe,
    cancelFee: BigInt(C.cancelRelayerFee64),
    refundFee: BigInt(C.refundRelayerFee64),
    deadline: ie,
    destAddr: ve,
    destChainId: te,
    referrerAddr: ue,
    referrerBps: C.referrerBps || 0,
    auctionMode: C.swiftAuctionMode,
    random: fe
  };
  return {
    contractAddress: re,
    tokenIn: se,
    amountIn: de,
    order: Te
  };
}
function getSwiftFromEvmTxPayload(C, e, T, $, V, J) {
  if (C.type !== "SWIFT")
    throw new Error("Quote type is not SWIFT");
  if (!Number.isFinite(Number(V)))
    throw new Error("Invalid signer chain id");
  if (!Number(C.deadline64))
    throw new Error("Swift order requires timeout");
  V = Number(V);
  const ee = ZeroPermit, te = new Contract(addresses_default.MAYAN_FORWARDER_CONTRACT, MayanForwarderArtifact_default.abi), {
    tokenIn: re,
    amountIn: ie,
    order: se,
    contractAddress: de
  } = getEvmSwiftParams(C, e, T, $, V);
  let ue;
  const fe = new Contract(de, MayanSwiftArtifact_default.abi);
  C.swiftInputContract === ZeroAddress ? ue = fe.interface.encodeFunctionData(
    "createOrderWithEth",
    [se]
  ) : ue = fe.interface.encodeFunctionData(
    "createOrderWithToken",
    [re, ie, se]
  );
  let he, me, xe;
  if (C.fromToken.contract === C.swiftInputContract)
    C.fromToken.contract === ZeroAddress ? (he = "forwardEth", me = [de, ue], xe = toBeHex(ie)) : (he = "forwardERC20", me = [re, ie, ee, de, ue], xe = toBeHex(0));
  else {
    const { evmSwapRouterAddress: Te, evmSwapRouterCalldata: we } = C;
    if (!C.minMiddleAmount || !Te || !we)
      throw new Error("Swift swap requires middle amount, router address and calldata");
    const Ee = C.fromToken.contract, Me = getAmountOfFractionalAmount(C.minMiddleAmount, C.swiftInputDecimals);
    C.fromToken.contract === ZeroAddress ? (he = "swapAndForwardEth", me = [
      ie,
      Te,
      we,
      C.swiftInputContract,
      Me,
      de,
      ue
    ], xe = toBeHex(ie)) : (he = "swapAndForwardERC20", me = [
      Ee,
      ie,
      ee,
      Te,
      we,
      C.swiftInputContract,
      Me,
      de,
      ue
    ], xe = toBeHex(0));
  }
  return {
    data: te.interface.encodeFunctionData(he, me),
    to: addresses_default.MAYAN_FORWARDER_CONTRACT,
    value: xe,
    chainId: V,
    _forwarder: {
      method: he,
      params: me
    }
  };
}
function getEvmSwapParams(C, e, T, $, V, J) {
  const ee = new PublicKey(addresses_default.MAYAN_PROGRAM_ID), [te] = PublicKey.findProgramAddressSync(
    [bufferPolyfill.Buffer.from("MAIN")],
    ee
  ), re = getAssociatedTokenAddress(
    new PublicKey(C.fromToken.mint),
    te,
    !0
  ), ie = getAmountOfFractionalAmount(
    C.effectiveAmountIn,
    C.fromToken.decimals
  ), se = nativeAddressToHexString(re.toString(), 1), de = nativeAddressToHexString(
    addresses_default.AUCTION_PROGRAM_ID,
    1
  );
  let ue;
  T ? ue = nativeAddressToHexString(
    T,
    1
  ) : ue = nativeAddressToHexString(
    SystemProgram.programId.toString(),
    1
  );
  const fe = getWormholeChainIdById(Number(V)), he = getWormholeChainIdByName(C.fromChain), me = getWormholeChainIdByName(C.toChain);
  if (he !== fe)
    throw new Error(`Signer chain id(${Number(V)}) and quote from chain are not same! ${he} !== ${fe}`);
  const xe = C.whMayanContract, ve = {
    mayanAddr: se,
    mayanChainId: 1,
    destAddr: nativeAddressToHexString(e, me),
    destChainId: me,
    auctionAddr: de,
    referrer: ue,
    refundAddr: nativeAddressToHexString($, fe)
  }, Te = C.toToken.contract === ZeroAddress, we = {
    transferDeadline: BigInt(C.deadline64),
    swapDeadline: BigInt(C.deadline64),
    amountOutMin: getAmountOfFractionalAmount(
      C.minAmountOut,
      Math.min(8, C.toToken.decimals)
    ),
    gasDrop: getAmountOfFractionalAmount(
      C.gasDrop,
      Math.min(8, getGasDecimal(C.toChain))
    ),
    unwrap: Te,
    customPayload: "0x"
  }, Ee = {
    swapFee: getAmountOfFractionalAmount(
      C.swapRelayerFee,
      Math.min(8, C.fromToken.decimals)
    ),
    redeemFee: getAmountOfFractionalAmount(
      C.redeemRelayerFee,
      Math.min(8, C.toToken.decimals)
    ),
    refundFee: getAmountOfFractionalAmount(
      C.refundRelayerFee,
      Math.min(8, C.fromToken.decimals)
    )
  }, Me = nativeAddressToHexString(
    C.toToken.realOriginContractAddress,
    C.toToken.realOriginChainId
  ), Ie = getAmountOfFractionalAmount(
    C.bridgeFee,
    18
  );
  return {
    amountIn: ie,
    tokenIn: C.fromToken.contract,
    tokenOut: Me,
    tokenOutWChainId: C.toToken.realOriginChainId,
    criteria: we,
    recipient: ve,
    relayerFees: Ee,
    contractAddress: xe,
    bridgeFee: Ie
  };
}
function getSwapFromEvmTxPayload(C, e, T, $, V, J, ee, te) {
  const re = getWormholeChainIdById(Number(J)), ie = getWormholeChainIdByName(C.fromChain);
  if (ie !== re)
    throw new Error(`Signer chain id(${Number(J)}) and quote from chain are not same! ${ie} !== ${re}`);
  const se = getQuoteSuitableReferrerAddress(C, $);
  if (C.type === "MCTP")
    return getMctpFromEvmTxPayload(C, T, se, J, te);
  if (C.type === "SWIFT")
    return getSwiftFromEvmTxPayload(C, e, T, se, J);
  if (C.type != "WH")
    throw new Error("Unsupported quote type");
  if (!Number(C.deadline64))
    throw new Error("WH mode requires a timeout");
  const {
    relayerFees: de,
    recipient: ue,
    tokenOut: fe,
    tokenOutWChainId: he,
    criteria: me,
    tokenIn: xe,
    amountIn: ve,
    contractAddress: Te,
    bridgeFee: we
  } = getEvmSwapParams(
    C,
    T,
    se,
    V,
    J
  ), Ee = new Contract(addresses_default.MAYAN_FORWARDER_CONTRACT, MayanForwarderArtifact_default.abi), Me = new Contract(Te, MayanSwapArtifact_default.abi);
  let Ie, ke, _e;
  const De = ZeroPermit;
  if (xe === ZeroAddress) {
    const Ae = Me.interface.encodeFunctionData(
      "wrapAndSwapETH",
      [de, ue, fe, he, me]
    );
    Ie = "forwardEth", ke = [Te, Ae], _e = toBeHex(ve);
  } else {
    const Ae = Me.interface.encodeFunctionData(
      "swap",
      [
        de,
        ue,
        fe,
        he,
        me,
        xe,
        ve
      ]
    );
    Ie = "forwardERC20", ke = [xe, ve, De, Te, Ae], _e = toBeHex(we);
  }
  const Fe = Ee.interface.encodeFunctionData(Ie, ke);
  return {
    to: addresses_default.MAYAN_FORWARDER_CONTRACT,
    data: Fe,
    value: _e,
    chainId: J,
    _forwarder: {
      method: Ie,
      params: ke
    }
  };
}
function getWormholePDAs(C) {
  const e = new PublicKey(addresses_default.WORMHOLE_PROGRAM_ID), T = new PublicKey(C), [$] = PublicKey.findProgramAddressSync(
    [bufferPolyfill.Buffer.from("Bridge")],
    e
  ), [V] = PublicKey.findProgramAddressSync(
    [bufferPolyfill.Buffer.from("emitter")],
    T
  ), [J] = PublicKey.findProgramAddressSync(
    [bufferPolyfill.Buffer.from("Sequence"), V.toBuffer()],
    e
  ), [ee] = PublicKey.findProgramAddressSync(
    [bufferPolyfill.Buffer.from("fee_collector")],
    e
  );
  return {
    bridgeConfig: $,
    sequenceKey: J,
    feeCollector: ee,
    emitter: V
  };
}
var MCTPBridgeWithFeeLayout = struct$1([
  u8$1("instruction"),
  u32$1("destinationDomain")
]);
function createMctpBridgeWithFeeInstruction(C, e, T, $, V) {
  const J = new PublicKey(addresses_default.WORMHOLE_PROGRAM_ID), ee = new PublicKey(addresses_default.TOKEN_PROGRAM_ID), te = new PublicKey(addresses_default.CCTP_CORE_PROGRAM_ID), re = new PublicKey(addresses_default.CCTP_TOKEN_PROGRAM_ID), ie = new PublicKey(addresses_default.MCTP_PROGRAM_ID), se = new PublicKey($), de = new PublicKey(T), ue = getAssociatedTokenAddress(
    de,
    C,
    !0
  );
  let fe;
  V && V > 0 ? fe = getAssociatedTokenAddress(de, se, !1) : fe = C;
  const he = getCCTPBridgePDAs(de, e), me = getWormholePDAs(addresses_default.MCTP_PROGRAM_ID), xe = Keypair.generate(), ve = Keypair.generate(), Te = [
    { pubkey: C, isWritable: !1, isSigner: !1 },
    { pubkey: he.senderAuthority, isWritable: !1, isSigner: !1 },
    { pubkey: ue, isWritable: !0, isSigner: !1 },
    { pubkey: he.messageTransmitter, isWritable: !0, isSigner: !1 },
    { pubkey: he.tokenMessenger, isWritable: !1, isSigner: !1 },
    { pubkey: he.remoteTokenMessengerKey, isWritable: !1, isSigner: !1 },
    { pubkey: he.tokenMinter, isWritable: !1, isSigner: !1 },
    { pubkey: he.localToken, isWritable: !0, isSigner: !1 },
    { pubkey: de, isWritable: !0, isSigner: !1 },
    { pubkey: xe.publicKey, isWritable: !0, isSigner: !0 },
    { pubkey: he.eventAuthToken, isWritable: !1, isSigner: !1 },
    { pubkey: me.emitter, isWritable: !1, isSigner: !1 },
    { pubkey: me.sequenceKey, isWritable: !0, isSigner: !1 },
    { pubkey: ve.publicKey, isWritable: !0, isSigner: !0 },
    { pubkey: me.bridgeConfig, isWritable: !0, isSigner: !1 },
    { pubkey: me.feeCollector, isWritable: !0, isSigner: !1 },
    { pubkey: se, isWritable: !0, isSigner: !0 },
    { pubkey: fe, isWritable: !0, isSigner: !1 },
    { pubkey: SYSVAR_CLOCK_PUBKEY, isWritable: !1, isSigner: !1 },
    { pubkey: SYSVAR_RENT_PUBKEY, isWritable: !1, isSigner: !1 },
    { pubkey: ee, isWritable: !1, isSigner: !1 },
    { pubkey: te, isWritable: !1, isSigner: !1 },
    { pubkey: re, isWritable: !1, isSigner: !1 },
    { pubkey: SystemProgram.programId, isWritable: !1, isSigner: !1 },
    { pubkey: J, isWritable: !1, isSigner: !1 }
  ], we = bufferPolyfill.Buffer.alloc(MCTPBridgeWithFeeLayout.span);
  return MCTPBridgeWithFeeLayout.encode(
    {
      instruction: 11,
      destinationDomain: getCCTPDomain(e)
    },
    we
  ), { instruction: new TransactionInstruction({
    keys: Te,
    data: we,
    programId: ie
  }), signers: [xe, ve] };
}
var MctpBridgeLockFeeLayout = struct$1([
  u8$1("instruction"),
  u32$1("destinationDomain")
]);
function createMctpBridgeLockFeeInstruction(C, e, T, $, V) {
  const J = [], ee = new PublicKey(addresses_default.TOKEN_PROGRAM_ID), te = new PublicKey(addresses_default.CCTP_CORE_PROGRAM_ID), re = new PublicKey(addresses_default.CCTP_TOKEN_PROGRAM_ID), ie = new PublicKey(addresses_default.MCTP_PROGRAM_ID), se = new PublicKey($), de = new PublicKey(T), ue = getAssociatedTokenAddress(
    de,
    C,
    !0
  ), fe = getCCTPBridgePDAs(de, e), he = Keypair.generate(), [me] = PublicKey.findProgramAddressSync(
    [bufferPolyfill.Buffer.from("FEESTATE"), de.toBuffer(), he.publicKey.toBytes()],
    ie
  );
  let xe;
  V && V > 0 ? xe = getAssociatedTokenAddress(de, se, !1) : xe = C;
  const ve = getAssociatedTokenAddress(
    de,
    me,
    !0
  );
  J.push(createAssociatedTokenAccountInstruction(
    se,
    ve,
    me,
    de
  ));
  const Te = [
    { pubkey: C, isWritable: !1, isSigner: !1 },
    { pubkey: fe.senderAuthority, isWritable: !1, isSigner: !1 },
    { pubkey: ue, isWritable: !0, isSigner: !1 },
    { pubkey: fe.messageTransmitter, isWritable: !0, isSigner: !1 },
    { pubkey: fe.tokenMessenger, isWritable: !1, isSigner: !1 },
    { pubkey: fe.remoteTokenMessengerKey, isWritable: !1, isSigner: !1 },
    { pubkey: fe.tokenMinter, isWritable: !1, isSigner: !1 },
    { pubkey: fe.localToken, isWritable: !0, isSigner: !1 },
    { pubkey: de, isWritable: !0, isSigner: !1 },
    { pubkey: he.publicKey, isWritable: !0, isSigner: !0 },
    { pubkey: fe.eventAuthToken, isWritable: !1, isSigner: !1 },
    { pubkey: me, isWritable: !0, isSigner: !1 },
    { pubkey: ve, isWritable: !0, isSigner: !1 },
    { pubkey: se, isWritable: !0, isSigner: !0 },
    { pubkey: xe, isWritable: !0, isSigner: !1 },
    { pubkey: SYSVAR_RENT_PUBKEY, isWritable: !1, isSigner: !1 },
    { pubkey: ee, isWritable: !1, isSigner: !1 },
    { pubkey: te, isWritable: !1, isSigner: !1 },
    { pubkey: re, isWritable: !1, isSigner: !1 },
    { pubkey: SystemProgram.programId, isWritable: !1, isSigner: !1 }
  ], we = bufferPolyfill.Buffer.alloc(MctpBridgeLockFeeLayout.span);
  MctpBridgeLockFeeLayout.encode(
    {
      instruction: 12,
      destinationDomain: getCCTPDomain(e)
    },
    we
  );
  const Ee = new TransactionInstruction({
    keys: Te,
    data: we,
    programId: ie
  });
  return J.push(Ee), { instructions: J, signer: he };
}
var MctpInitSwapLayout = struct$1([
  u8$1("instruction"),
  u32$1("destinationDomain")
]);
function createMctpInitSwapInstruction(C, e, T, $, V) {
  const J = new PublicKey(addresses_default.TOKEN_PROGRAM_ID), ee = new PublicKey(addresses_default.CCTP_CORE_PROGRAM_ID), te = new PublicKey(addresses_default.CCTP_TOKEN_PROGRAM_ID), re = new PublicKey(addresses_default.MCTP_PROGRAM_ID), ie = new PublicKey(addresses_default.MAYAN_PROGRAM_ID), se = new PublicKey($), de = new PublicKey(T), ue = getAssociatedTokenAddress(
    de,
    C,
    !0
  ), fe = getCCTPBridgePDAs(de, e), he = Keypair.generate(), [me] = PublicKey.findProgramAddressSync(
    [bufferPolyfill.Buffer.from("SWAP"), C.toBuffer()],
    re
  ), [xe] = PublicKey.findProgramAddressSync(
    [bufferPolyfill.Buffer.from("MAYANFEE")],
    ie
  );
  let ve;
  V && V > 0 ? ve = getAssociatedTokenAddress(de, se, !1) : ve = C;
  const Te = [
    { pubkey: me, isWritable: !0, isSigner: !1 },
    { pubkey: xe, isWritable: !1, isSigner: !1 },
    { pubkey: se, isWritable: !0, isSigner: !0 },
    { pubkey: ve, isWritable: !0, isSigner: !1 },
    { pubkey: C, isWritable: !1, isSigner: !1 },
    { pubkey: fe.senderAuthority, isWritable: !1, isSigner: !1 },
    { pubkey: ue, isWritable: !0, isSigner: !1 },
    { pubkey: fe.messageTransmitter, isWritable: !0, isSigner: !1 },
    { pubkey: fe.tokenMessenger, isWritable: !1, isSigner: !1 },
    { pubkey: fe.remoteTokenMessengerKey, isWritable: !1, isSigner: !1 },
    { pubkey: fe.tokenMinter, isWritable: !1, isSigner: !1 },
    { pubkey: fe.localToken, isWritable: !0, isSigner: !1 },
    { pubkey: de, isWritable: !0, isSigner: !1 },
    { pubkey: he.publicKey, isWritable: !0, isSigner: !0 },
    { pubkey: fe.eventAuthToken, isWritable: !1, isSigner: !1 },
    { pubkey: SYSVAR_RENT_PUBKEY, isWritable: !1, isSigner: !1 },
    { pubkey: J, isWritable: !1, isSigner: !1 },
    { pubkey: ee, isWritable: !1, isSigner: !1 },
    { pubkey: te, isWritable: !1, isSigner: !1 },
    { pubkey: SystemProgram.programId, isWritable: !1, isSigner: !1 }
  ], we = bufferPolyfill.Buffer.alloc(MctpInitSwapLayout.span);
  return MctpInitSwapLayout.encode(
    {
      instruction: 42,
      destinationDomain: getCCTPDomain(e)
    },
    we
  ), { instruction: new TransactionInstruction({
    keys: Te,
    data: we,
    programId: re
  }), signer: he };
}
var MctpBridgeLedgerLayout = struct$1([
  u8$1("instruction"),
  blob$1(32, "destAddress"),
  blob$1(8, "amountInMin"),
  blob$1(8, "gasDrop"),
  blob$1(8, "feeRedeem"),
  blob$1(8, "feeSolana"),
  u32$1("destinationDomain"),
  u16("destinationChain"),
  u8$1("mode")
]);
function createMctpBridgeLedgerInstruction(C) {
  if (C.mode !== "WITH_FEE" && C.mode !== "LOCK_FEE")
    throw new Error("Invalid mode: " + C.mode);
  const e = new PublicKey(C.swapperAddress), T = new PublicKey(C.mintAddress), $ = getAssociatedTokenAddress(T, C.ledger, !0), V = getCCTPDomain(C.toChain), J = getWormholeChainIdByName(C.toChain), ee = bufferPolyfill.Buffer.from(
    hexToUint8Array(
      nativeAddressToHexString(C.destinationAddress, J)
    )
  ), te = getSafeU64Blob(
    getAmountOfFractionalAmount(C.amountInMin, CCTP_TOKEN_DECIMALS)
  ), re = getSafeU64Blob(
    getAmountOfFractionalAmount(C.gasDrop, Math.min(getGasDecimal(C.toChain), 8))
  ), ie = getSafeU64Blob(
    getAmountOfFractionalAmount(C.feeRedeem, CCTP_TOKEN_DECIMALS)
  ), se = getSafeU64Blob(
    getAmountOfFractionalAmount(C.feeSolana || 0, CCTP_TOKEN_DECIMALS)
  ), de = C.referrerAddress ? bufferPolyfill.Buffer.from(hexToUint8Array(
    nativeAddressToHexString(C.referrerAddress, J)
  )) : SystemProgram.programId.toBuffer(), ue = [
    { pubkey: e, isWritable: !0, isSigner: !0 },
    { pubkey: C.ledger, isWritable: !0, isSigner: !1 },
    { pubkey: $, isWritable: !1, isSigner: !1 },
    { pubkey: T, isWritable: !1, isSigner: !1 },
    { pubkey: C.randomKey, isWritable: !1, isSigner: !0 },
    { pubkey: SYSVAR_RENT_PUBKEY, isWritable: !1, isSigner: !1 },
    { pubkey: SystemProgram.programId, isWritable: !1, isSigner: !1 },
    { pubkey: new PublicKey(de), isWritable: !1, isSigner: !1 }
  ], fe = bufferPolyfill.Buffer.alloc(MctpBridgeLedgerLayout.span);
  return MctpBridgeLedgerLayout.encode(
    {
      instruction: 40,
      destAddress: ee,
      amountInMin: te,
      gasDrop: re,
      feeRedeem: ie,
      feeSolana: se,
      destinationDomain: V,
      destinationChain: J,
      mode: C.mode === "WITH_FEE" ? 1 : 2
    },
    fe
  ), new TransactionInstruction({
    keys: ue,
    data: fe,
    programId: new PublicKey(addresses_default.MCTP_PROGRAM_ID)
  });
}
var MctpSwapLedgerLayout = struct$1([
  u8$1("instruction"),
  blob$1(32, "destAddress"),
  blob$1(8, "amountInMin"),
  blob$1(8, "gasDrop"),
  blob$1(8, "feeRedeem"),
  blob$1(8, "feeSolana"),
  u32$1("destinationDomain"),
  u16("destinationChain"),
  u8$1("mode"),
  blob$1(32, "tokenOut"),
  blob$1(32, "refAddress"),
  blob$1(8, "amountOutMin"),
  blob$1(8, "deadline"),
  u8$1("feeRateRef")
]);
function createMctpSwapLedgerInstruction(C) {
  const e = new PublicKey(C.swapperAddress), T = new PublicKey(C.mintAddress), $ = getAssociatedTokenAddress(T, C.ledger, !0), V = getCCTPDomain(C.toChain), J = getWormholeChainIdByName(C.toChain), ee = bufferPolyfill.Buffer.from(
    hexToUint8Array(
      nativeAddressToHexString(C.destinationAddress, J)
    )
  ), te = getSafeU64Blob(
    getAmountOfFractionalAmount(C.amountInMin, CCTP_TOKEN_DECIMALS)
  ), re = getSafeU64Blob(
    getAmountOfFractionalAmount(C.gasDrop, Math.min(getGasDecimal(C.toChain), 8))
  ), ie = getSafeU64Blob(
    getAmountOfFractionalAmount(C.feeRedeem, CCTP_TOKEN_DECIMALS)
  ), se = getSafeU64Blob(
    getAmountOfFractionalAmount(C.feeSolana || 0, CCTP_TOKEN_DECIMALS)
  ), de = bufferPolyfill.Buffer.from(hexToUint8Array(
    nativeAddressToHexString(C.tokenOut, J)
  )), ue = C.referrerAddress ? bufferPolyfill.Buffer.from(hexToUint8Array(
    nativeAddressToHexString(C.referrerAddress, J)
  )) : SystemProgram.programId.toBuffer(), fe = getSafeU64Blob(
    getAmountOfFractionalAmount(C.amountOutMin, Math.min(8, C.tokenOutDecimals))
  ), he = getSafeU64Blob(C.deadline), me = [
    { pubkey: e, isWritable: !0, isSigner: !0 },
    { pubkey: C.ledger, isWritable: !0, isSigner: !1 },
    { pubkey: $, isWritable: !1, isSigner: !1 },
    { pubkey: T, isWritable: !1, isSigner: !1 },
    { pubkey: C.randomKey, isWritable: !1, isSigner: !0 },
    { pubkey: SYSVAR_RENT_PUBKEY, isWritable: !1, isSigner: !1 },
    { pubkey: SystemProgram.programId, isWritable: !1, isSigner: !1 }
  ], xe = bufferPolyfill.Buffer.alloc(MctpSwapLedgerLayout.span);
  return MctpSwapLedgerLayout.encode(
    {
      instruction: 41,
      destAddress: ee,
      amountInMin: te,
      gasDrop: re,
      feeRedeem: ie,
      feeSolana: se,
      destinationDomain: V,
      destinationChain: J,
      mode: 3,
      tokenOut: de,
      refAddress: ue,
      amountOutMin: fe,
      deadline: he,
      feeRateRef: C.feeRateRef
    },
    xe
  ), new TransactionInstruction({
    keys: me,
    data: xe,
    programId: new PublicKey(addresses_default.MCTP_PROGRAM_ID)
  });
}
async function createMctpFromSolanaInstructions(C, e, T, $, V) {
  if (C.toChain === "solana")
    throw new Error("Unsupported destination chain: " + C.toChain);
  let J = [], ee = [], te = [], re = [];
  J.push(addresses_default.LOOKUP_TABLE);
  const ie = new PublicKey(addresses_default.MCTP_PROGRAM_ID), se = new PublicKey(e), de = Keypair.generate();
  te.push(de);
  const ue = C.deadline64 ? BigInt(C.deadline64) : BigInt(0);
  if (C.hasAuction && !Number(C.deadline64))
    throw new Error("Swap mode requires a timeout");
  const [fe] = PublicKey.findProgramAddressSync(
    [bufferPolyfill.Buffer.from("LEDGER"), se.toBytes(), de.publicKey.toBytes()],
    ie
  ), he = getAssociatedTokenAddress(
    new PublicKey(C.mctpInputContract),
    fe,
    !0
  ), me = C.cheaperChain === "solana" ? "LOCK_FEE" : "WITH_FEE";
  if (C.fromToken.contract === C.mctpInputContract)
    if (C.suggestedPriorityFee > 0 && ee.push(ComputeBudgetProgram.setComputeUnitPrice({
      microLamports: C.suggestedPriorityFee
    })), ee.push(
      createAssociatedTokenAccountInstruction(se, he, fe, new PublicKey(C.mctpInputContract))
    ), ee.push(
      createSplTransferInstruction(
        getAssociatedTokenAddress(
          new PublicKey(C.mctpInputContract),
          se,
          !1
        ),
        he,
        se,
        getAmountOfFractionalAmount(C.effectiveAmountIn, CCTP_TOKEN_DECIMALS)
      )
    ), C.hasAuction) {
      ee.push(createMctpSwapLedgerInstruction({
        ledger: fe,
        swapperAddress: e,
        mintAddress: C.mctpInputContract,
        randomKey: de.publicKey,
        toChain: C.toChain,
        destinationAddress: T,
        feeSolana: C.solanaRelayerFee,
        feeRedeem: C.redeemRelayerFee,
        gasDrop: C.gasDrop,
        amountInMin: C.effectiveAmountIn,
        tokenOut: C.toToken.contract,
        tokenOutDecimals: C.toToken.decimals,
        referrerAddress: $,
        amountOutMin: C.minAmountOut,
        deadline: ue,
        feeRateRef: C.referrerBps
      }));
      const {
        instruction: xe,
        signer: ve
      } = createMctpInitSwapInstruction(
        fe,
        C.toChain,
        C.mctpInputContract,
        e,
        C.solanaRelayerFee
      );
      ee.push(xe), te.push(ve);
    } else if (ee.push(createMctpBridgeLedgerInstruction({
      ledger: fe,
      swapperAddress: e,
      mintAddress: C.mctpInputContract,
      randomKey: de.publicKey,
      toChain: C.toChain,
      destinationAddress: T,
      feeSolana: C.solanaRelayerFee,
      feeRedeem: C.redeemRelayerFee,
      gasDrop: C.gasDrop,
      amountInMin: C.effectiveAmountIn,
      mode: me,
      referrerAddress: $
    })), me === "WITH_FEE") {
      const {
        instruction: xe,
        signers: ve
      } = createMctpBridgeWithFeeInstruction(
        fe,
        C.toChain,
        C.mctpInputContract,
        e,
        C.solanaRelayerFee
      );
      ee.push(xe), te.push(...ve);
    } else {
      const {
        instructions: xe,
        signer: ve
      } = createMctpBridgeLockFeeInstruction(
        fe,
        C.toChain,
        C.mctpInputContract,
        e,
        C.solanaRelayerFee
      );
      ee.push(...xe), te.push(ve);
    }
  else {
    const xe = await getSwapSolana({
      minMiddleAmount: C.minMiddleAmount,
      middleToken: C.mctpInputContract,
      userWallet: e,
      userLedger: fe.toString(),
      slippageBps: C.slippageBps,
      fromToken: C.fromToken.contract,
      amountIn: C.effectiveAmountIn,
      depositMode: C.hasAuction ? "SWAP" : me
    }), ve = decentralizeClientSwapInstructions(xe);
    ee.push(...ve.computeBudgetInstructions), ve.setupInstructions && ee.push(...ve.setupInstructions), ee.push(ve.swapInstruction), ve.cleanupInstruction && ee.push(ve.cleanupInstruction), J.push(...ve.addressLookupTableAddresses), C.hasAuction ? ee.push(createMctpSwapLedgerInstruction({
      ledger: fe,
      swapperAddress: e,
      mintAddress: C.mctpInputContract,
      randomKey: de.publicKey,
      toChain: C.toChain,
      destinationAddress: T,
      feeSolana: C.solanaRelayerFee,
      feeRedeem: C.redeemRelayerFee,
      gasDrop: C.gasDrop,
      amountInMin: C.minMiddleAmount,
      tokenOut: C.toToken.contract,
      tokenOutDecimals: C.toToken.decimals,
      referrerAddress: $,
      amountOutMin: C.minAmountOut,
      deadline: ue,
      feeRateRef: C.referrerBps
    })) : ee.push(createMctpBridgeLedgerInstruction({
      ledger: fe,
      swapperAddress: e,
      mintAddress: C.mctpInputContract,
      randomKey: de.publicKey,
      toChain: C.toChain,
      destinationAddress: T,
      feeSolana: C.solanaRelayerFee,
      feeRedeem: C.redeemRelayerFee,
      gasDrop: C.gasDrop,
      amountInMin: C.minMiddleAmount,
      mode: me,
      referrerAddress: $
    }));
  }
  return re = await getAddressLookupTableAccounts(J, V), { instructions: ee, signers: te, lookupTables: re };
}
var STATE_SIZE = 420, SwapLayout = struct$1([
  u8$1("instruction"),
  u8$1("stateNonce"),
  blob$1(8, "amount"),
  blob$1(8, "minAmountOut"),
  blob$1(8, "deadline"),
  blob$1(8, "feeSwap"),
  blob$1(8, "feeReturn"),
  blob$1(8, "feeCancel"),
  blob$1(8, "gasDrop"),
  u16("destinationChain"),
  blob$1(32, "destinationAddress"),
  u8$1("unwrapRedeem"),
  u8$1("unwrapRefund"),
  u8$1("mayanFeeNonce"),
  u8$1("referrerFeeNonce")
]);
async function createSwapFromSolanaInstructions(C, e, T, $, V) {
  const J = getQuoteSuitableReferrerAddress(C, $);
  if (C.type === "MCTP")
    return createMctpFromSolanaInstructions(C, e, T, J, V);
  if (C.type === "SWIFT")
    return createSwiftFromSolanaInstructions(C, e, T, J, V);
  let ee = [];
  const te = V ?? new Connection$1("https://rpc.ankr.com/solana"), re = new PublicKey(addresses_default.MAYAN_PROGRAM_ID), ie = new PublicKey(addresses_default.TOKEN_PROGRAM_ID), se = new PublicKey(e), de = new PublicKey(addresses_default.AUCTION_PROGRAM_ID);
  C.suggestedPriorityFee > 0 && ee.push(ComputeBudgetProgram.setComputeUnitPrice({
    microLamports: C.suggestedPriorityFee
  }));
  let ue;
  J ? ue = new PublicKey(J) : ue = SystemProgram.programId;
  const [fe, he] = PublicKey.findProgramAddressSync(
    [bufferPolyfill.Buffer.from("MAYANFEE")],
    re
  ), [me, xe] = PublicKey.findProgramAddressSync(
    [
      bufferPolyfill.Buffer.from("REFERRERFEE"),
      ue.toBuffer()
    ],
    re
  ), ve = Keypair.generate(), Te = Keypair.generate(), [we, Ee] = PublicKey.findProgramAddressSync(
    [
      bufferPolyfill.Buffer.from("V2STATE"),
      bufferPolyfill.Buffer.from(ve.publicKey.toBytes()),
      bufferPolyfill.Buffer.from(Te.publicKey.toBytes())
    ],
    re
  ), Me = new PublicKey(C.fromToken.mint), Ie = new PublicKey(C.toToken.mint), ke = getAssociatedTokenAddress(Me, se), _e = getAssociatedTokenAddress(Me, we, !0), [
    [De, Fe],
    Ae,
    ne
  ] = await Promise.all([
    te.getMultipleAccountsInfo([ke, _e], "finalized"),
    te.getMinimumBalanceForRentExemption(STATE_SIZE),
    decideRelayer()
  ]);
  (!De || De.data.length === 0) && ee.push(createAssociatedTokenAccountInstruction(
    se,
    ke,
    se,
    Me
  )), (!Fe || Fe.data.length === 0) && ee.push(createAssociatedTokenAccountInstruction(
    se,
    _e,
    we,
    Me
  )), C.fromToken.contract === ZeroAddress && (ee.push(SystemProgram.transfer({
    fromPubkey: se,
    toPubkey: ke,
    lamports: getAmountOfFractionalAmount(
      C.effectiveAmountIn,
      9
    )
  })), ee.push(createSyncNativeInstruction(ke)));
  const oe = getAmountOfFractionalAmount(
    C.effectiveAmountIn,
    C.mintDecimals.from
  ), ce = Keypair.generate();
  ee.push(createApproveInstruction(
    ke,
    ce.publicKey,
    se,
    oe
  )), ee.push(SystemProgram.transfer({
    fromPubkey: se,
    toPubkey: ce.publicKey,
    lamports: Ae
  }));
  const le = [
    { pubkey: ce.publicKey, isWritable: !1, isSigner: !0 },
    { pubkey: ve.publicKey, isWritable: !1, isSigner: !0 },
    { pubkey: Te.publicKey, isWritable: !1, isSigner: !0 },
    { pubkey: we, isWritable: !0, isSigner: !1 },
    { pubkey: ke, isWritable: !0, isSigner: !1 },
    { pubkey: se, isWritable: !1, isSigner: !1 },
    { pubkey: _e, isWritable: !0, isSigner: !1 },
    { pubkey: Me, isWritable: !1, isSigner: !1 },
    { pubkey: Ie, isWritable: !1, isSigner: !1 },
    { pubkey: de, isWritable: !1, isSigner: !1 },
    { pubkey: ue, isWritable: !1, isSigner: !1 },
    { pubkey: fe, isWritable: !1, isSigner: !1 },
    { pubkey: me, isWritable: !1, isSigner: !1 },
    { pubkey: ce.publicKey, isWritable: !0, isSigner: !0 },
    { pubkey: ne, isWritable: !1, isSigner: !1 },
    { pubkey: SYSVAR_CLOCK_PUBKEY, isWritable: !1, isSigner: !1 },
    { pubkey: SYSVAR_RENT_PUBKEY, isWritable: !1, isSigner: !1 },
    { pubkey: ie, isWritable: !1, isSigner: !1 },
    { pubkey: SystemProgram.programId, isWritable: !1, isSigner: !1 }
  ], pe = getWormholeChainIdByName(C.toChain);
  if (pe === 1) {
    const Ge = await te.getAccountInfo(new PublicKey(T));
    if (Ge && Ge.owner && Ge.owner.equals(ie))
      throw new Error(
        "Destination address is not about token account. It should be a owner address"
      );
  }
  const ye = bufferPolyfill.Buffer.from(
    hexToUint8Array(
      nativeAddressToHexString(T, pe)
    )
  ), Ce = getAmountOfFractionalAmount(
    C.minAmountOut,
    C.mintDecimals.to
  ), be = getAmountOfFractionalAmount(
    C.swapRelayerFee,
    C.mintDecimals.from
  ), ae = getAmountOfFractionalAmount(
    C.redeemRelayerFee,
    C.mintDecimals.to
  ), ge = getAmountOfFractionalAmount(
    C.refundRelayerFee,
    C.mintDecimals.from
  ), Se = getAmountOfFractionalAmount(
    C.gasDrop,
    getGasDecimalsInSolana(C.toChain)
  ), Le = C.toToken.contract === ZeroAddress, ze = C.fromToken.contract === ZeroAddress;
  if (!Number(C.deadline64))
    throw new Error("Deadline is not valid");
  const Re = BigInt(C.deadline64), We = bufferPolyfill.Buffer.alloc(SwapLayout.span), Be = {
    instruction: 101,
    stateNonce: Ee,
    amount: getSafeU64Blob(oe),
    minAmountOut: getSafeU64Blob(Ce),
    deadline: getSafeU64Blob(Re),
    feeSwap: getSafeU64Blob(be),
    feeReturn: getSafeU64Blob(ae),
    feeCancel: getSafeU64Blob(ge),
    gasDrop: getSafeU64Blob(Se),
    destinationChain: pe,
    destinationAddress: ye,
    unwrapRedeem: Le ? 1 : 0,
    unwrapRefund: ze ? 1 : 0,
    mayanFeeNonce: he,
    referrerFeeNonce: xe
  };
  SwapLayout.encode(Be, We);
  const Ue = new TransactionInstruction({
    keys: le,
    data: We,
    programId: re
  });
  return ee.push(Ue), {
    instructions: ee,
    signers: [ce, ve, Te],
    lookupTables: []
  };
}
const arbitrum = [
  {
    mint: "CSD6JQMvLi46psjHdpfFdr826mF336pEVMJgjwcoS1m4",
    name: "ETH",
    symbol: "ETH",
    wChainId: 23,
    chainId: 42161,
    decimals: 18,
    coingeckoId: "weth",
    contract: "0x0000000000000000000000000000000000000000",
    wrappedAddress: "0x82af49447d8a07e3bd95bd0d56f35241523fbab1",
    logoURI: "https://statics.mayan.finance/eth.png",
    realOriginContractAddress: "0x82aF49447D8a07e3bd95BD0d56f35241523fBab1",
    realOriginChainId: 23,
    supportsPermit: !1
  },
  {
    name: "USDC",
    symbol: "USDC",
    mint: "CR4xnGrhsu1fWNPoX4KbTUUtqGMF3mzRLfj4S6YEs1Yo",
    contract: "0xaf88d065e77c8cc2239327c5edb3a432268e5831",
    chainId: 42161,
    wChainId: 23,
    decimals: 6,
    logoURI: "https://assets.coingecko.com/coins/images/6319/small/usdc.png?1696506694",
    coingeckoId: "usd-coin",
    realOriginContractAddress: "0xaf88d065e77c8cc2239327c5edb3a432268e5831",
    realOriginChainId: 23,
    supportsPermit: !0
  },
  {
    name: "WETH",
    symbol: "WETH",
    mint: "CSD6JQMvLi46psjHdpfFdr826mF336pEVMJgjwcoS1m4",
    contract: "0x82af49447d8a07e3bd95bd0d56f35241523fbab1",
    chainId: 42161,
    wChainId: 23,
    decimals: 18,
    logoURI: "https://assets.coingecko.com/coins/images/2518/small/weth.png?1628852295",
    coingeckoId: "weth",
    realOriginContractAddress: "0x82af49447d8a07e3bd95bd0d56f35241523fbab1",
    realOriginChainId: 23,
    supportsPermit: !0
  },
  {
    name: "Tether",
    symbol: "USDT",
    mint: "H9o3LaDfoMSVLm9aBWaY56eMmPGDbRFnUHpqcTb9exXB",
    contract: "0xfd086bc7cd5c481dcc9c85ebe478a1c0b69fcbb9",
    chainId: 42161,
    wChainId: 23,
    decimals: 6,
    logoURI: "https://assets.coingecko.com/coins/images/325/small/Tether.png?1668148663",
    coingeckoId: "tether",
    realOriginContractAddress: "0xfd086bc7cd5c481dcc9c85ebe478a1c0b69fcbb9",
    realOriginChainId: 23,
    supportsPermit: !0
  },
  {
    name: "USDC (Portal from Polygon)",
    symbol: "USDC",
    mint: "C321jHPwWBzgfSGndosDTp5pBsiXPyMU1irxKLVcedRB",
    contract: "0x599ADB10E6A012dF34935D47407450f6D7170e3C",
    chainId: 42161,
    wChainId: 23,
    decimals: 6,
    logoURI: "https://assets.coingecko.com/coins/images/6319/small/usdc.png?1696506694",
    coingeckoId: "usd-coin",
    realOriginContractAddress: "0x3c499c542cef5e3811e1192ce70d8cc03d5c3359",
    realOriginChainId: 5,
    supportsPermit: !0
  },
  {
    name: "USD Coin (Arb1)",
    symbol: "USDC.e",
    mint: "HAxCJjnmgkdXhwZYeJiUvBgm4NdQvqhGJCS3KxCnCxWs",
    contract: "0xff970a61a04b1ca14834a43f5de4533ebddb5cc8",
    chainId: 42161,
    wChainId: 23,
    decimals: 6,
    logoURI: "https://assets.coingecko.com/coins/images/6319/small/USD_Coin_icon.png?1547042389",
    coingeckoId: "usd-coin",
    realOriginContractAddress: "0xff970a61a04b1ca14834a43f5de4533ebddb5cc8",
    realOriginChainId: 23,
    supportsPermit: !0
  },
  {
    name: "Basket (Portal from Solana)",
    symbol: "BSKT",
    mint: "6gnCPhXtLnUD76HjQuSYPENLSZdG8RvDB1pTLM5aLSJA",
    contract: "0xa3210cd727fE6DAf8386af5623ba51A367E46263",
    chainId: 42161,
    wChainId: 23,
    decimals: 5,
    logoURI: "https://assets.coingecko.com/coins/images/34661/small/BSKT_Logo.png?1705636891",
    coingeckoId: "basket",
    realOriginContractAddress: "6gnCPhXtLnUD76HjQuSYPENLSZdG8RvDB1pTLM5aLSJA",
    realOriginChainId: 1,
    supportsPermit: !0
  },
  {
    name: "WETH (Portal from Optimism)",
    symbol: "WETH",
    mint: "8M6d63oL7dvMZ1gNbgGe3h8afMSWJEKEhtPTFM2u8h3c",
    contract: "0xB1fC645a86fB5085e12D8BDDb77702F728D2A26F",
    chainId: 42161,
    wChainId: 23,
    decimals: 18,
    logoURI: "https://assets.coingecko.com/coins/images/2518/small/weth.png?1696503332",
    coingeckoId: "weth",
    realOriginContractAddress: "0x4200000000000000000000000000000000000006",
    realOriginChainId: 24,
    supportsPermit: !0
  },
  {
    name: "USDC (Portal from Optimism)",
    symbol: "USDC",
    mint: "J8kcD4Wnd1ehne1dpL8WNtgZQR6Jpui2cTZcrmg5ybAa",
    contract: "0x3A5C2Da9E30741cb59a5e9446A23A86886fC9DC2",
    chainId: 42161,
    wChainId: 23,
    decimals: 6,
    logoURI: "https://assets.coingecko.com/coins/images/6319/small/usdc.png?1696506694",
    coingeckoId: "usd-coin",
    realOriginContractAddress: "0x0b2c639c533813f4aa9d7837caf62653d097ff85",
    realOriginChainId: 24,
    supportsPermit: !0
  },
  {
    name: "Bridged USDC (Optimism) (Portal from Optimism)",
    symbol: "USDC.E",
    mint: "D6YyAUMTJipLQfUhYs6psdnwpmMz6KbM4Qs9AtCmPpxR",
    contract: "0xF6938032c44bB69CD0aF34a2A50eAB75d89b35dc",
    chainId: 42161,
    wChainId: 23,
    decimals: 6,
    logoURI: "https://assets.coingecko.com/coins/images/31580/small/USDC-icon.png?1696530397",
    coingeckoId: "bridged-usd-coin-optimism",
    realOriginContractAddress: "0x7f5c764cbc14f9669b88837ca1490cca17c31607",
    realOriginChainId: 24,
    supportsPermit: !0
  },
  {
    name: "Tether (Portal from Optimism)",
    symbol: "USDT",
    mint: "CLV6gB88nQtnuo3akGLSVRFaiFPTXaBXV4EDaFxV7iRq",
    contract: "0x16A9d7FECE7Feb0d8ece07483E5d80f52c0a6e31",
    chainId: 42161,
    wChainId: 23,
    decimals: 6,
    logoURI: "https://assets.coingecko.com/coins/images/325/small/Tether.png?1696501661",
    coingeckoId: "tether",
    realOriginContractAddress: "0x94b008aa00579c1307b0ef2c499ad98a8ce58e58",
    realOriginChainId: 24,
    supportsPermit: !0
  }
], ethereum = [
  {
    name: "ETH",
    symbol: "ETH",
    mint: "7vfCXTUXx5WJV5JADk17DUJ4ksgau7utNKj4b963voxs",
    contract: "0x0000000000000000000000000000000000000000",
    chainId: 1,
    wChainId: 2,
    decimals: 18,
    logoURI: "https://statics.mayan.finance/eth.png",
    wrappedAddress: "0xc02aaa39b223fe8d0a0e5c4f27ead9083c756cc2",
    coingeckoId: "weth",
    realOriginContractAddress: "0xc02aaa39b223fe8d0a0e5c4f27ead9083c756cc2",
    realOriginChainId: 2,
    supportsPermit: !1
  },
  {
    name: "Basket (Portal from Solana)",
    symbol: "BSKT",
    mint: "6gnCPhXtLnUD76HjQuSYPENLSZdG8RvDB1pTLM5aLSJA",
    contract: "0xbC0899E527007f1B8Ced694508FCb7a2b9a46F53",
    chainId: 1,
    wChainId: 2,
    decimals: 5,
    logoURI: "https://assets.coingecko.com/coins/images/34661/small/BSKT_Logo.png?1705636891",
    coingeckoId: "basket",
    realOriginContractAddress: "6gnCPhXtLnUD76HjQuSYPENLSZdG8RvDB1pTLM5aLSJA",
    realOriginChainId: 1,
    supportsPermit: !0
  },
  {
    name: "Wrapped Bitcoin",
    symbol: "WBTC",
    mint: "3NZ9JMVBmGAqocybic2c7LQCJScmgsAZ6vQqTDzcqmJh",
    contract: "0x2260fac5e5542a773aa44fbcfedf7c193bc2c599",
    chainId: 1,
    wChainId: 2,
    decimals: 8,
    logoURI: "https://assets.coingecko.com/coins/images/7598/small/wrapped_bitcoin_wbtc.png?1548822744",
    coingeckoId: "wrapped-bitcoin",
    realOriginContractAddress: "0x2260fac5e5542a773aa44fbcfedf7c193bc2c599",
    realOriginChainId: 2,
    supportsPermit: !1
  },
  {
    name: "WETH (Portal from Arbitrum)",
    symbol: "WETH",
    mint: "CSD6JQMvLi46psjHdpfFdr826mF336pEVMJgjwcoS1m4",
    contract: "0xb945E3F853B5f8033C8513Cf3cE9F8AD9beBB1c9",
    chainId: 1,
    wChainId: 2,
    decimals: 18,
    logoURI: "https://assets.coingecko.com/coins/images/2518/small/weth.png?1628852295",
    coingeckoId: "weth",
    realOriginContractAddress: "0x82af49447d8a07e3bd95bd0d56f35241523fbab1",
    realOriginChainId: 23,
    supportsPermit: !0
  },
  {
    name: "Tether (Portal from Arbitrum)",
    symbol: "USDT",
    mint: "H9o3LaDfoMSVLm9aBWaY56eMmPGDbRFnUHpqcTb9exXB",
    contract: "0xFbA2B8D6D4554Ed67DDDe4814847b02c5114285D",
    chainId: 1,
    wChainId: 2,
    decimals: 6,
    logoURI: "https://assets.coingecko.com/coins/images/325/small/Tether.png?1668148663",
    coingeckoId: "tether",
    realOriginContractAddress: "0xfd086bc7cd5c481dcc9c85ebe478a1c0b69fcbb9",
    realOriginChainId: 23,
    supportsPermit: !0
  },
  {
    name: "USD Coin (Arb1)(Portal from Arbitrum)",
    symbol: "USDC.e",
    mint: "HAxCJjnmgkdXhwZYeJiUvBgm4NdQvqhGJCS3KxCnCxWs",
    contract: "0x5c14172D3876200ad4063a33aee47a281020d4b3",
    chainId: 1,
    wChainId: 2,
    decimals: 6,
    logoURI: "https://assets.coingecko.com/coins/images/6319/small/USD_Coin_icon.png?1547042389",
    coingeckoId: "usd-coin",
    realOriginContractAddress: "0xff970a61a04b1ca14834a43f5de4533ebddb5cc8",
    realOriginChainId: 23,
    supportsPermit: !0
  },
  {
    name: "USD Coin (Portal from Avalanche)",
    symbol: "USDC",
    mint: "FHfba3ov5P3RjaiLVgh8FTv4oirxQDoVXuoUUDvHuXax",
    contract: "0x39EbF69137D98FB7659Ef8D4ea21ec26394389d7",
    chainId: 1,
    wChainId: 2,
    decimals: 6,
    logoURI: "https://assets.coingecko.com/coins/images/6319/small/USD_Coin_icon.png?1547042389",
    coingeckoId: "usd-coin",
    realOriginContractAddress: "0xb97ef9ef8734c71904d8002f8b6bc66dd9c48a6e",
    realOriginChainId: 6,
    supportsPermit: !0
  },
  {
    name: "Tether (Portal from Avalanche)",
    symbol: "USDT",
    mint: "Kz1csQA91WUGcQ2TB3o5kdGmWmMGp8eJcDEyHzNDVCX",
    contract: "0x72B2095361926E72692DFd5986C5B0d2bc18bF1e",
    chainId: 1,
    wChainId: 2,
    decimals: 6,
    logoURI: "https://assets.coingecko.com/coins/images/325/small/Tether.png?1668148663",
    coingeckoId: "tether",
    realOriginContractAddress: "0x9702230a8ea53601f5cd2dc00fdbc13d4df4a8c7",
    realOriginChainId: 6,
    supportsPermit: !0
  },
  {
    name: "USD Coin (Portal from BSC)",
    symbol: "USDC",
    mint: "FCqfQSujuPxy6V42UvafBhsysWtEq1vhjfMN1PUbgaxA",
    contract: "0x7cd167B101D2808Cfd2C45d17b2E7EA9F46b74B6",
    chainId: 1,
    wChainId: 2,
    decimals: 18,
    logoURI: "https://assets.coingecko.com/coins/images/6319/small/USD_Coin_icon.png?1547042389",
    coingeckoId: "usd-coin",
    realOriginContractAddress: "0x8ac76a51cc950d9822d68b83fe1ad97b32cd580d",
    realOriginChainId: 4,
    supportsPermit: !0
  },
  {
    name: "Dai",
    symbol: "DAI",
    mint: "EjmyN6qEC1Tf1JxiG1ae7UTJhUxSwk1TCWNWqxWV4J6o",
    contract: "0x6b175474e89094c44da98b954eedeac495271d0f",
    chainId: 1,
    wChainId: 2,
    decimals: 18,
    logoURI: "https://assets.coingecko.com/coins/images/9956/small/4943.png?1636636734",
    coingeckoId: "dai",
    realOriginContractAddress: "0x6b175474e89094c44da98b954eedeac495271d0f",
    realOriginChainId: 2,
    supportsPermit: !1
  },
  {
    name: "1Sol",
    symbol: "1SOL",
    mint: "4ThReWAbAVZjNVgs5Ui9Pk3cZ5TYaD9u6Y89fp6EFzoF",
    contract: "0x009178997aff09a67d4caccfeb897fb79d036214",
    chainId: 1,
    wChainId: 2,
    decimals: 18,
    logoURI: "https://assets.coingecko.com/coins/images/21615/small/YyGDie9f_400x400.jpg?1639610633",
    coingeckoId: "1sol",
    realOriginContractAddress: "0x009178997aff09a67d4caccfeb897fb79d036214",
    realOriginChainId: 2,
    supportsPermit: !1
  },
  {
    name: "agEUR",
    symbol: "AGEUR",
    mint: "CbNYA9n3927uXUukee2Hf4tm3xxkffJPPZvGazc2EAH1",
    contract: "0x1a7e4e63778b4f12a199c062f3efdd288afcbce8",
    chainId: 1,
    wChainId: 2,
    decimals: 18,
    logoURI: "https://assets.coingecko.com/coins/images/19479/small/agEUR.png?1635283566",
    coingeckoId: "ageur",
    realOriginContractAddress: "0x1a7e4e63778b4f12a199c062f3efdd288afcbce8",
    realOriginChainId: 2,
    supportsPermit: !0
  },
  {
    name: "Aldrin (Portal from solana)",
    symbol: "RIN",
    mint: "E5ndSkaB17Dm7CsD22dvcjfrYSDLCxFcMd6z8ddCk5wp",
    contract: "0xf51421C93BD9943f057CF5668a5FD6C7Ac3F66ae",
    chainId: 1,
    wChainId: 2,
    decimals: 9,
    logoURI: "https://assets.coingecko.com/coins/images/16849/small/Aldrin.png?1629959768",
    coingeckoId: "aldrin",
    realOriginContractAddress: "E5ndSkaB17Dm7CsD22dvcjfrYSDLCxFcMd6z8ddCk5wp",
    realOriginChainId: 1,
    supportsPermit: !0
  },
  {
    name: "Aleph.im",
    symbol: "ALEPH",
    mint: "3UCMiSnkcnkPE1pgQ5ggPCBv6dXgVUy16TmMUe1WpG9x",
    contract: "0x27702a26126e0b3702af63ee09ac4d1a084ef628",
    chainId: 1,
    wChainId: 2,
    decimals: 18,
    logoURI: "https://assets.coingecko.com/coins/images/11676/small/Monochram-aleph.png?1608483725",
    coingeckoId: "aleph",
    realOriginContractAddress: "0x27702a26126e0b3702af63ee09ac4d1a084ef628",
    realOriginChainId: 2,
    supportsPermit: !0
  },
  {
    name: "Atlas DEX (Portal from solana)",
    symbol: "ATS",
    mint: "HJbNXx2YMRxgfUJ6K4qeWtjatMK5KYQT1QnsCdDWywNv",
    contract: "0xbE635F061DC6e918a1be980df82910621859cC93",
    chainId: 1,
    wChainId: 2,
    decimals: 9,
    logoURI: "https://assets.coingecko.com/coins/images/23002/small/logo.png?1643091340",
    coingeckoId: "atlas-dex",
    realOriginContractAddress: "HJbNXx2YMRxgfUJ6K4qeWtjatMK5KYQT1QnsCdDWywNv",
    realOriginChainId: 1,
    supportsPermit: !0
  },
  {
    name: "Audius",
    symbol: "AUDIO",
    mint: "9LzCMqDgTKYz9Drzqnpgee3SGa89up3a247ypMj2xrqM",
    contract: "0x18aaa7115705e8be94bffebde57af9bfc265b998",
    chainId: 1,
    wChainId: 2,
    decimals: 18,
    logoURI: "https://assets.coingecko.com/coins/images/12913/small/AudiusCoinLogo_2x.png?1603425727",
    coingeckoId: "audius",
    realOriginContractAddress: "0x18aaa7115705e8be94bffebde57af9bfc265b998",
    realOriginChainId: 2,
    supportsPermit: !0
  },
  {
    name: "Aurory (Portal from solana)",
    symbol: "AURY",
    mint: "AURYydfxJib1ZkTir1Jn1J9ECYUtjb6rKQVmtYaixWPP",
    contract: "0xFe81232e1C2475782085b094D6Aa212ddFEb6560",
    chainId: 1,
    wChainId: 2,
    decimals: 9,
    logoURI: "https://assets.coingecko.com/coins/images/19324/small/Ico_Blanc.png?1672824647",
    coingeckoId: "aurory",
    realOriginContractAddress: "AURYydfxJib1ZkTir1Jn1J9ECYUtjb6rKQVmtYaixWPP",
    realOriginChainId: 1,
    supportsPermit: !0
  },
  {
    name: "Axie Infinity",
    symbol: "AXS",
    mint: "HysWcbHiYY9888pHbaqhwLYZQeZrcQMXKQWRqS7zcPK5",
    contract: "0xbb0e17ef65f82ab018d8edd776e8dd940327b28b",
    chainId: 1,
    wChainId: 2,
    decimals: 18,
    logoURI: "https://assets.coingecko.com/coins/images/13029/small/axie_infinity_logo.png?1604471082",
    coingeckoId: "axie-infinity",
    realOriginContractAddress: "0xbb0e17ef65f82ab018d8edd776e8dd940327b28b",
    realOriginChainId: 2,
    supportsPermit: !1
  },
  {
    name: "Binance USD (Portal from BSC)",
    symbol: "BUSD",
    mint: "5RpUwQ8wtdPCZHhu6MERp2RGrpobsbZ6MH5dDHkUjs2",
    contract: "0x7B4B0B9b024109D182dCF3831222fbdA81369423",
    chainId: 1,
    wChainId: 2,
    decimals: 18,
    logoURI: "https://assets.coingecko.com/coins/images/9576/small/BUSD.png?1568947766",
    coingeckoId: "binance-usd",
    realOriginContractAddress: "0xe9e7cea3dedca5984780bafc599bd69add087d56",
    realOriginChainId: 4,
    supportsPermit: !0
  },
  {
    name: "Bitmon (Portal from solana)",
    symbol: "BIT",
    mint: "EGiWZhNk3vUNJr35MbL2tY5YD6D81VVZghR2LgEFyXZh",
    contract: "0x79dF183eFcc80915dd08B74Be0B021A8a45b0419",
    chainId: 1,
    wChainId: 2,
    decimals: 9,
    logoURI: "https://assets.coingecko.com/coins/images/25282/small/BT-logo.png?1651127844",
    coingeckoId: "bitmon",
    realOriginContractAddress: "EGiWZhNk3vUNJr35MbL2tY5YD6D81VVZghR2LgEFyXZh",
    realOriginChainId: 1,
    supportsPermit: !0
  },
  {
    name: "Bitspawn (Portal from solana)",
    symbol: "SPWN",
    mint: "5U9QqCPhqXAJcEv9uyzFJd5zhN93vuPk1aNNkXnUfPnt",
    contract: "0x1437760948fC7f8A548d8eC680d4849BfdaD8cDF",
    chainId: 1,
    wChainId: 2,
    decimals: 9,
    logoURI: "https://assets.coingecko.com/coins/images/16513/small/token_logo.png?1631603192",
    coingeckoId: "bitspawn",
    realOriginContractAddress: "5U9QqCPhqXAJcEv9uyzFJd5zhN93vuPk1aNNkXnUfPnt",
    realOriginChainId: 1,
    supportsPermit: !0
  },
  {
    name: "Blockasset (Portal from solana)",
    symbol: "BLOCK",
    mint: "NFTUkR4u7wKxy9QLaX2TGvd9oZSWoMo4jqSJqdMb7Nk",
    contract: "0x620A06380559d03ac74a8adC9A760111E6fb2eca",
    chainId: 1,
    wChainId: 2,
    decimals: 6,
    logoURI: "https://assets.coingecko.com/coins/images/21332/small/Blockasset-Logo-Symbol.png?1648442722",
    coingeckoId: "blockasset",
    realOriginContractAddress: "NFTUkR4u7wKxy9QLaX2TGvd9oZSWoMo4jqSJqdMb7Nk",
    realOriginChainId: 1,
    supportsPermit: !0
  },
  {
    name: "Bonfida (Portal from solana)",
    symbol: "FIDA",
    mint: "EchesyfXePKdLtoiZSL8pBe8Myagyy8ZRqsACNCFGnvp",
    contract: "0x7306B6F1059611Db89d582950E64291465F351Fc",
    chainId: 1,
    wChainId: 2,
    decimals: 6,
    logoURI: "https://assets.coingecko.com/coins/images/13395/small/bonfida.png?1658327819",
    coingeckoId: "bonfida",
    realOriginContractAddress: "EchesyfXePKdLtoiZSL8pBe8Myagyy8ZRqsACNCFGnvp",
    realOriginChainId: 1,
    supportsPermit: !0
  },
  {
    name: "Brazilian Digital (Portal from solana)",
    symbol: "BRZ",
    mint: "FtgGSFADXBtroxq8VCausXRr2of47QBf5AS1NtZCu4GD",
    contract: "0xBb0acB1c05f52C005aa262A1FaC33E782391b890",
    chainId: 1,
    wChainId: 2,
    decimals: 4,
    logoURI: "https://assets.coingecko.com/coins/images/8472/small/2_vtiD3xwce9knG2COxtSMaQ.png?1597786961",
    coingeckoId: "brz",
    realOriginContractAddress: "FtgGSFADXBtroxq8VCausXRr2of47QBf5AS1NtZCu4GD",
    realOriginChainId: 1,
    supportsPermit: !0
  },
  {
    name: "Celsius Network",
    symbol: "CEL",
    mint: "nRtfwU9G82CSHhHGJNxFhtn7FLvWP2rqvQvje1WtL69",
    contract: "0xaaaebe6fe48e54f431b0c390cfaf0b017d09d42d",
    chainId: 1,
    wChainId: 2,
    decimals: 4,
    logoURI: "https://assets.coingecko.com/coins/images/3263/small/CEL_logo.png?1609598753",
    coingeckoId: "celsius-degree-token",
    realOriginContractAddress: "0xaaaebe6fe48e54f431b0c390cfaf0b017d09d42d",
    realOriginChainId: 2,
    supportsPermit: !1
  },
  {
    name: "Chainlink",
    symbol: "LINK",
    mint: "2wpTofQ8SkACrkZWrZDjXPitYa8AwWgX8AfxdeBRRVLX",
    contract: "0x514910771af9ca656af840dff83e8264ecf986ca",
    chainId: 1,
    wChainId: 2,
    decimals: 18,
    logoURI: "https://assets.coingecko.com/coins/images/877/small/chainlink-new-logo.png?1547034700",
    coingeckoId: "chainlink",
    realOriginContractAddress: "0x514910771af9ca656af840dff83e8264ecf986ca",
    realOriginChainId: 2,
    supportsPermit: !1
  },
  {
    name: "ClinTex CTi",
    symbol: "CTI",
    mint: "9ET2QCQJdFkeKkuaampNbmicbA8eLYauFCWch9Ddh9p5",
    contract: "0xcb8fb2438a805664cd8c3e640b85ac473da5be87",
    chainId: 1,
    wChainId: 2,
    decimals: 18,
    logoURI: "https://assets.coingecko.com/coins/images/13266/small/CTI.png?1606817542",
    coingeckoId: "clintex-cti",
    realOriginContractAddress: "0xcb8fb2438a805664cd8c3e640b85ac473da5be87",
    realOriginChainId: 2,
    supportsPermit: !1
  },
  {
    name: "ConstitutionDAO",
    symbol: "PEOPLE",
    mint: "CobcsUrt3p91FwvULYKorQejgsm5HoQdv5T8RUZ6PnLA",
    contract: "0x7a58c0be72be218b41c608b7fe7c5bb630736c71",
    chainId: 1,
    wChainId: 2,
    decimals: 18,
    logoURI: "https://assets.coingecko.com/coins/images/20612/small/GN_UVm3d_400x400.jpg?1637294355",
    coingeckoId: "constitutiondao",
    realOriginContractAddress: "0x7a58c0be72be218b41c608b7fe7c5bb630736c71",
    realOriginChainId: 2,
    supportsPermit: !0
  },
  {
    name: "Decentraland",
    symbol: "MANA",
    mint: "7dgHoN8wBZCc5wbnQ2C47TDnBMAxG4Q5L3KjP67z8kNi",
    contract: "0x0f5d2fb29fb7d3cfee444a200298f468908cc942",
    chainId: 1,
    wChainId: 2,
    decimals: 18,
    logoURI: "https://assets.coingecko.com/coins/images/878/small/decentraland-mana.png?1550108745",
    coingeckoId: "decentraland",
    realOriginContractAddress: "0x0f5d2fb29fb7d3cfee444a200298f468908cc942",
    realOriginChainId: 2,
    supportsPermit: !1
  },
  {
    name: "dYdX",
    symbol: "DYDX",
    mint: "4Hx6Bj56eGyw8EJrrheM6LBQAvVYRikYCWsALeTrwyRU",
    contract: "0x92d6c1e31e14520e676a687f0a93788b716beff5",
    chainId: 1,
    wChainId: 2,
    decimals: 18,
    logoURI: "https://assets.coingecko.com/coins/images/17500/small/hjnIm9bV.jpg?1628009360",
    coingeckoId: "dydx",
    realOriginContractAddress: "0x92d6c1e31e14520e676a687f0a93788b716beff5",
    realOriginChainId: 2,
    supportsPermit: !0
  },
  {
    name: "Frax",
    symbol: "FRAX",
    mint: "FR87nWEUxVgerFGhZM8Y4AggKGLnaXswr1Pd8wZ4kZcp",
    contract: "0x853d955acef822db058eb8505911ed77f175b99e",
    chainId: 1,
    wChainId: 2,
    decimals: 18,
    logoURI: "https://assets.coingecko.com/coins/images/13422/small/ethCanonicalFRAX.png?1669277108",
    coingeckoId: "frax",
    realOriginContractAddress: "0x853d955acef822db058eb8505911ed77f175b99e",
    realOriginChainId: 2,
    supportsPermit: !1
  },
  {
    name: "FTX",
    symbol: "FTT",
    mint: "EzfgjvkSwthhgHaceR3LnKXUoRkP6NUhfghdaHAj1tUv",
    contract: "0x50d1c9771902476076ecfc8b2a83ad6b9355a4c9",
    chainId: 1,
    wChainId: 2,
    decimals: 18,
    logoURI: "https://assets.coingecko.com/coins/images/9026/small/F.png?1609051564",
    coingeckoId: "ftx-token",
    realOriginContractAddress: "0x50d1c9771902476076ecfc8b2a83ad6b9355a4c9",
    realOriginChainId: 2,
    supportsPermit: !1
  },
  {
    name: "FTX (Portal from solana)",
    symbol: "FTT",
    mint: "AGFEad2et2ZJif9jaGpdMixQqvW5i81aBdvKe7PHNfz3",
    contract: "0x6B8e49057247Bc33f4305Af6Aa13532bd1E072e8",
    chainId: 1,
    wChainId: 2,
    decimals: 6,
    logoURI: "https://assets.coingecko.com/coins/images/9026/small/F.png?1609051564",
    coingeckoId: "ftx-token",
    realOriginContractAddress: "AGFEad2et2ZJif9jaGpdMixQqvW5i81aBdvKe7PHNfz3",
    realOriginChainId: 1,
    supportsPermit: !0
  },
  {
    name: "STEPN Green Satoshi Token on Solana (Portal from solana)",
    symbol: "GST-SOL",
    mint: "AFbX8oGjGpmVFywbVouvhQSRmiW2aR1mohfahi4Y2AdB",
    contract: "0xEa6425a03B4545C10b49c785Df9EfbBbB68b7167",
    chainId: 1,
    wChainId: 2,
    decimals: 9,
    logoURI: "https://assets.coingecko.com/coins/images/21841/small/gst.png?1640332626",
    coingeckoId: "green-satoshi-token",
    realOriginContractAddress: "AFbX8oGjGpmVFywbVouvhQSRmiW2aR1mohfahi4Y2AdB",
    realOriginChainId: 1,
    supportsPermit: !0
  },
  {
    name: "HAPI (Portal from solana)",
    symbol: "HAPI",
    mint: "6VNKqgz9hk7zRShTFdg5AnkfKwZUcojzwAkzxSH3bnUm",
    contract: "0x11b8Cf8B970323C5118f8c79E3F90a11A8f431BE",
    chainId: 1,
    wChainId: 2,
    decimals: 9,
    logoURI: "https://assets.coingecko.com/coins/images/14298/small/R9i2HjAL_400x400.jpg?1615332438",
    coingeckoId: "hapi",
    realOriginContractAddress: "6VNKqgz9hk7zRShTFdg5AnkfKwZUcojzwAkzxSH3bnUm",
    realOriginChainId: 1,
    supportsPermit: !0
  },
  {
    name: "Hxro",
    symbol: "HXRO",
    mint: "HxhWkVpk5NS4Ltg5nij2G671CKXFRKPK8vy271Ub4uEK",
    contract: "0x4bd70556ae3f8a6ec6c4080a0c327b24325438f3",
    chainId: 1,
    wChainId: 2,
    decimals: 18,
    logoURI: "https://assets.coingecko.com/coins/images/7805/small/Hxro_Profile_Transparent.png?1622443308",
    coingeckoId: "hxro",
    realOriginContractAddress: "0x4bd70556ae3f8a6ec6c4080a0c327b24325438f3",
    realOriginChainId: 2,
    supportsPermit: !1
  },
  {
    name: "Kin (Portal from solana)",
    symbol: "KIN",
    mint: "kinXdEcpDQeHPEuQnqmUgtYykqKGVFq6CeVX5iAHJq6",
    contract: "0x5B2BC12576C25cF8178498a7E74597E74d6EcC92",
    chainId: 1,
    wChainId: 2,
    decimals: 5,
    logoURI: "https://assets.coingecko.com/coins/images/959/small/kin.png?1586917032",
    coingeckoId: "kin",
    realOriginContractAddress: "kinXdEcpDQeHPEuQnqmUgtYykqKGVFq6CeVX5iAHJq6",
    realOriginChainId: 1,
    supportsPermit: !0
  },
  {
    name: "KKO Protocol (Portal from solana)",
    symbol: "KKO",
    mint: "kiNeKo77w1WBEzFFCXrTDRWGRWGP8yHvKC9rX6dqjQh",
    contract: "0x904830cDC0176A0Bd157aa43A07cDe6d083082e0",
    chainId: 1,
    wChainId: 2,
    decimals: 9,
    logoURI: "https://assets.coingecko.com/coins/images/15366/small/kko-coingecko.png?1658982821",
    coingeckoId: "kineko",
    realOriginContractAddress: "kiNeKo77w1WBEzFFCXrTDRWGRWGP8yHvKC9rX6dqjQh",
    realOriginChainId: 1,
    supportsPermit: !0
  },
  {
    name: "Kurobi (Portal from solana)",
    symbol: "KURO",
    mint: "2Kc38rfQ49DFaKHQaWbijkE7fcymUMLY5guUiUsDmFfn",
    contract: "0x664Eb280F53505FCc39B4656cfA7a4477Bf613Ce",
    chainId: 1,
    wChainId: 2,
    decimals: 6,
    logoURI: "https://assets.coingecko.com/coins/images/18612/small/logo_-_2021-09-26T233232.947.png?1632670367",
    coingeckoId: "kurobi",
    realOriginContractAddress: "2Kc38rfQ49DFaKHQaWbijkE7fcymUMLY5guUiUsDmFfn",
    realOriginChainId: 1,
    supportsPermit: !0
  },
  {
    name: "Lido DAO",
    symbol: "LDO",
    mint: "HZRCwxP2Vq9PCpPXooayhJ2bxTpo5xfpQrwB1svh332p",
    contract: "0x5a98fcbea516cf06857215779fd812ca3bef1b32",
    chainId: 1,
    wChainId: 2,
    decimals: 18,
    logoURI: "https://assets.coingecko.com/coins/images/13573/small/Lido_DAO.png?1609873644",
    coingeckoId: "lido-dao",
    realOriginContractAddress: "0x5a98fcbea516cf06857215779fd812ca3bef1b32",
    realOriginChainId: 2,
    supportsPermit: !1
  },
  {
    name: "Lido Staked SOL (Portal from solana)",
    symbol: "STSOL",
    mint: "7dHbWXmci3dT8UFYWYZweBLXgycu7Y3iL6trKn1Y7ARj",
    contract: "0x5A114487131513637aCcF739CC7aD78EA9FAbc34",
    chainId: 1,
    wChainId: 2,
    decimals: 9,
    logoURI: "https://assets.coingecko.com/coins/images/18369/small/logo_-_2021-09-15T100934.765.png?1631671781",
    coingeckoId: "lido-staked-sol",
    realOriginContractAddress: "7dHbWXmci3dT8UFYWYZweBLXgycu7Y3iL6trKn1Y7ARj",
    realOriginChainId: 1,
    supportsPermit: !0
  },
  {
    name: "Media Network (Portal from solana)",
    symbol: "MEDIA",
    mint: "ETAtLmCmsoiEEKfNrHKJ2kYy3MoABhU6NQvpSfij5tDs",
    contract: "0x08A7180Af3D7552ab14cE689F9196D273E747843",
    chainId: 1,
    wChainId: 2,
    decimals: 6,
    logoURI: "https://assets.coingecko.com/coins/images/15142/small/media50x50.png?1620122020",
    coingeckoId: "media-network",
    realOriginContractAddress: "ETAtLmCmsoiEEKfNrHKJ2kYy3MoABhU6NQvpSfij5tDs",
    realOriginChainId: 1,
    supportsPermit: !0
  },
  {
    name: "Marinade staked SOL (Portal from solana)",
    symbol: "MSOL",
    mint: "mSoLzYCxHdYgdzU16g5QSh3i5K3z3KZK7ytfqcJm7So",
    contract: "0x756bFb452cFE36A5Bc82e4F5f4261A89a18c242b",
    chainId: 1,
    wChainId: 2,
    decimals: 9,
    logoURI: "https://assets.coingecko.com/coins/images/17752/small/mSOL.png?1644541955",
    coingeckoId: "msol",
    realOriginContractAddress: "mSoLzYCxHdYgdzU16g5QSh3i5K3z3KZK7ytfqcJm7So",
    realOriginChainId: 1,
    supportsPermit: !0
  },
  {
    name: "Parrot Protocol (Portal from solana)",
    symbol: "PRT",
    mint: "PRT88RkA4Kg5z7pKnezeNH4mafTvtQdfFgpQTGRjz44",
    contract: "0xB601bD14386C1bb5b3d0C6132DCc8Ca241DbB89a",
    chainId: 1,
    wChainId: 2,
    decimals: 6,
    logoURI: "https://assets.coingecko.com/coins/images/18443/small/PRT.png?1634698095",
    coingeckoId: "parrot-protocol",
    realOriginContractAddress: "PRT88RkA4Kg5z7pKnezeNH4mafTvtQdfFgpQTGRjz44",
    realOriginChainId: 1,
    supportsPermit: !0
  },
  {
    name: "Playground Waves Floor Index (Portal from solana)",
    symbol: "WAVES",
    mint: "4uRn7vxRPWYP4HuAa4UNXwEPLRL8oQ71YByMhr6yBnL4",
    contract: "0x776B3dF6c701a5E3A424E290241D61Fa88eFA05c",
    chainId: 1,
    wChainId: 2,
    decimals: 2,
    logoURI: "https://assets.coingecko.com/coins/images/24388/small/playgorund_waves.PNG?1647502973",
    coingeckoId: "playground-waves-floor-index",
    realOriginContractAddress: "4uRn7vxRPWYP4HuAa4UNXwEPLRL8oQ71YByMhr6yBnL4",
    realOriginChainId: 1,
    supportsPermit: !0
  },
  {
    name: "Rally (Solana) (Portal from solana)",
    symbol: "SRLY",
    mint: "sRLY3migNrkC1HLgqotpvi66qGkdNedqPZ9TJpAQhyh",
    contract: "0xc879BBdA252278B0859e811deef88e9978810E85",
    chainId: 1,
    wChainId: 2,
    decimals: 9,
    logoURI: "https://assets.coingecko.com/coins/images/23239/small/srly.png?1643531979",
    coingeckoId: "rally-solana",
    realOriginContractAddress: "sRLY3migNrkC1HLgqotpvi66qGkdNedqPZ9TJpAQhyh",
    realOriginChainId: 1,
    supportsPermit: !0
  },
  {
    name: "Raydium (Portal from solana)",
    symbol: "RAY",
    mint: "4k3Dyjzvzp8eMZWUXbBCjEvwSkkk59S5iCNLY3QrkX6R",
    contract: "0xE617dd80c621a5072bD8cBa65E9d76c07327004d",
    chainId: 1,
    wChainId: 2,
    decimals: 6,
    logoURI: "https://assets.coingecko.com/coins/images/13928/small/PSigc4ie_400x400.jpg?1612875614",
    coingeckoId: "raydium",
    realOriginContractAddress: "4k3Dyjzvzp8eMZWUXbBCjEvwSkkk59S5iCNLY3QrkX6R",
    realOriginChainId: 1,
    supportsPermit: !0
  },
  {
    name: "renDOGE (Portal from solana)",
    symbol: "RENDOGE",
    mint: "ArUkYE2XDKzqy77PRRGjo4wREWwqk6RXTfM9NeqzPvjU",
    contract: "0xC9Db5D64348505f56aF09e869D0b6E6835f892a5",
    chainId: 1,
    wChainId: 2,
    decimals: 8,
    logoURI: "https://assets.coingecko.com/coins/images/13796/small/Dogecoin.jpg?1628072827",
    coingeckoId: "rendoge",
    realOriginContractAddress: "ArUkYE2XDKzqy77PRRGjo4wREWwqk6RXTfM9NeqzPvjU",
    realOriginChainId: 1,
    supportsPermit: !0
  },
  {
    name: "Sator (Portal from solana)",
    symbol: "SAO",
    mint: "2HeykdKjzHKGm2LKHw8pDYwjKPiFEoXAz74dirhUgQvq",
    contract: "0x3EF389f264e07fFF3106A3926F2a166d1393086F",
    chainId: 1,
    wChainId: 2,
    decimals: 9,
    logoURI: "https://assets.coingecko.com/coins/images/19410/small/sator-logo-CMC.png?1635211626",
    coingeckoId: "sator",
    realOriginContractAddress: "2HeykdKjzHKGm2LKHw8pDYwjKPiFEoXAz74dirhUgQvq",
    realOriginChainId: 1,
    supportsPermit: !0
  },
  {
    name: "Serum",
    symbol: "SRM",
    mint: "xnorPhAzWXUczCP3KjU5yDxmKKZi5cSbxytQ1LgE3kG",
    contract: "0x476c5e26a75bd202a9683ffd34359c0cc15be0ff",
    chainId: 1,
    wChainId: 2,
    decimals: 6,
    logoURI: "https://assets.coingecko.com/coins/images/11970/small/serum-logo.png?1597121577",
    coingeckoId: "serum",
    realOriginContractAddress: "0x476c5e26a75bd202a9683ffd34359c0cc15be0ff",
    realOriginChainId: 2,
    supportsPermit: !1
  },
  {
    name: "Serum (Portal from solana)",
    symbol: "SRM",
    mint: "SRMuApVNdxXokk5GT7XD5cUUgXMBCoAz2LHeuAoKWRt",
    contract: "0xE3ADAA4fb7c92AB833Ee08B3561D9c434aA2A3eE",
    chainId: 1,
    wChainId: 2,
    decimals: 6,
    logoURI: "https://assets.coingecko.com/coins/images/11970/small/serum-logo.png?1597121577",
    coingeckoId: "serum",
    realOriginContractAddress: "SRMuApVNdxXokk5GT7XD5cUUgXMBCoAz2LHeuAoKWRt",
    realOriginChainId: 1,
    supportsPermit: !0
  },
  {
    name: "Shiba Inu",
    symbol: "SHIB",
    mint: "CiKu4eHsVrc1eueVQeHn7qhXTcVu95gSQmBpX4utjL9z",
    contract: "0x95ad61b0a150d79219dcf64e1e6cc01f0b64c4ce",
    chainId: 1,
    wChainId: 2,
    decimals: 18,
    logoURI: "https://assets.coingecko.com/coins/images/11939/small/shiba.png?1622619446",
    coingeckoId: "shiba-inu",
    realOriginContractAddress: "0x95ad61b0a150d79219dcf64e1e6cc01f0b64c4ce",
    realOriginChainId: 2,
    supportsPermit: !1
  },
  {
    name: "SolanaPrime (Portal from solana)",
    symbol: "PRIME",
    mint: "PRiME7gDoiG1vGr95a3CRMv9xHY7UGjd4JKvfSkmQu2",
    contract: "0x770241c7B2793512c64aAE8D9a100699feb615E5",
    chainId: 1,
    wChainId: 2,
    decimals: 9,
    logoURI: "https://assets.coingecko.com/coins/images/25911/small/solana_black200x200.png?1654587637",
    coingeckoId: "solanaprime",
    realOriginContractAddress: "PRiME7gDoiG1vGr95a3CRMv9xHY7UGjd4JKvfSkmQu2",
    realOriginChainId: 1,
    supportsPermit: !0
  },
  {
    name: "Solanium (Portal from solana)",
    symbol: "SLIM",
    mint: "xxxxa1sKNGwFtw2kFn8XauW9xq8hBZ5kVtcSesTT9fW",
    contract: "0x1E6fC70D0f4807C933443426722d22149355d8cC",
    chainId: 1,
    wChainId: 2,
    decimals: 6,
    logoURI: "https://assets.coingecko.com/coins/images/15816/small/logo_cg.png?1659000206",
    coingeckoId: "solanium",
    realOriginContractAddress: "xxxxa1sKNGwFtw2kFn8XauW9xq8hBZ5kVtcSesTT9fW",
    realOriginChainId: 1,
    supportsPermit: !0
  },
  {
    name: "Star Atlas (Portal from solana)",
    symbol: "ATLAS",
    mint: "ATLASXmbPQxBUYbxPsV97usA3fPQYEqzQBUHgiFCUsXx",
    contract: "0xb9F747162AB1E95d07361f9048BcDF6eDdA9eEA7",
    chainId: 1,
    wChainId: 2,
    decimals: 8,
    logoURI: "https://assets.coingecko.com/coins/images/17659/small/Icon_Reverse.png?1628759092",
    coingeckoId: "star-atlas",
    realOriginContractAddress: "ATLASXmbPQxBUYbxPsV97usA3fPQYEqzQBUHgiFCUsXx",
    realOriginChainId: 1,
    supportsPermit: !0
  },
  {
    name: "STEPN (Portal from solana)",
    symbol: "GMT",
    mint: "7i5KKsX2weiTkry7jA4ZwSuXGhs5eJBEjY8vVxR4pfRx",
    contract: "0x8589A26eb762c9D8126b69c0582151186C4E71Bd",
    chainId: 1,
    wChainId: 2,
    decimals: 9,
    logoURI: "https://assets.coingecko.com/coins/images/23597/small/gmt.png?1644658792",
    coingeckoId: "stepn",
    realOriginContractAddress: "7i5KKsX2weiTkry7jA4ZwSuXGhs5eJBEjY8vVxR4pfRx",
    realOriginChainId: 1,
    supportsPermit: !0
  },
  {
    name: "Sunny Aggregator (Portal from solana)",
    symbol: "SUNNY",
    mint: "SUNNYWgPQmFxe9wTZzNK7iPnJ3vYDrkgnxJRJm1s3ag",
    contract: "0xe6bFcDA5741011b80862cC2C245829FE29D30b0e",
    chainId: 1,
    wChainId: 2,
    decimals: 6,
    logoURI: "https://assets.coingecko.com/coins/images/18039/small/90dbe787-8e5f-473c-b923-fe138a7a30ea.png?1630314924",
    coingeckoId: "sunny-aggregator",
    realOriginContractAddress: "SUNNYWgPQmFxe9wTZzNK7iPnJ3vYDrkgnxJRJm1s3ag",
    realOriginChainId: 1,
    supportsPermit: !0
  },
  {
    name: "Sushi",
    symbol: "SUSHI",
    mint: "ChVzxWRmrTeSgwd3Ui3UumcN8KX7VK3WaD4KGeSKpypj",
    contract: "0x6b3595068778dd592e39a122f4f5a5cf09c90fe2",
    chainId: 1,
    wChainId: 2,
    decimals: 18,
    logoURI: "https://assets.coingecko.com/coins/images/12271/small/512x512_Logo_no_chop.png?1606986688",
    coingeckoId: "sushi",
    realOriginContractAddress: "0x6b3595068778dd592e39a122f4f5a5cf09c90fe2",
    realOriginChainId: 2,
    supportsPermit: !0
  },
  {
    name: "Sypool (Portal from solana)",
    symbol: "SYP",
    mint: "FnKE9n6aGjQoNWRBZXy4RW6LZVao7qwBonUbiD7edUmZ",
    contract: "0x69512e863D108A82DBD968b2D9A5697AB1eeC666",
    chainId: 1,
    wChainId: 2,
    decimals: 9,
    logoURI: "https://assets.coingecko.com/coins/images/18518/small/sypool.PNG?1632268218",
    coingeckoId: "sypool",
    realOriginContractAddress: "FnKE9n6aGjQoNWRBZXy4RW6LZVao7qwBonUbiD7edUmZ",
    realOriginChainId: 1,
    supportsPermit: !0
  },
  {
    name: "Tether (Portal from Polygon)",
    symbol: "USDT",
    mint: "5goWRao6a3yNC4d6UjMdQxonkCMvKBwdpubU3qhfcdf1",
    contract: "0x9024B09C1C6D33221F6AeA9571821a2062B88eEf",
    chainId: 1,
    wChainId: 2,
    decimals: 6,
    logoURI: "https://assets.coingecko.com/coins/images/325/small/Tether.png?1668148663",
    coingeckoId: "tether",
    realOriginContractAddress: "0xc2132d05d31c914a87c6611c10748aeb04b58e8f",
    realOriginChainId: 5,
    supportsPermit: !0
  },
  {
    name: "Tether (Portal from BSC)",
    symbol: "USDT",
    mint: "8qJSyQprMC57TWKaYEmetUR3UUiTP2M3hXdcvFhkZdmv",
    contract: "0xDe60aDfDdAAbaAAC3dAFa57B26AcC91Cb63728c4",
    chainId: 1,
    wChainId: 2,
    decimals: 18,
    logoURI: "https://assets.coingecko.com/coins/images/325/small/Tether-logo.png?1598003707",
    coingeckoId: "tether",
    realOriginContractAddress: "0x55d398326f99059ff775485246999027b3197955",
    realOriginChainId: 4,
    supportsPermit: !0
  },
  {
    name: "Tether",
    symbol: "USDT",
    mint: "Dn4noZ5jgGfkntzcQSUZ8czkreiZ1ForXYoV2H8Dm7S1",
    contract: "0xdac17f958d2ee523a2206206994597c13d831ec7",
    chainId: 1,
    wChainId: 2,
    decimals: 6,
    logoURI: "https://assets.coingecko.com/coins/images/325/small/Tether-logo.png?1598003707",
    coingeckoId: "tether",
    realOriginContractAddress: "0xdac17f958d2ee523a2206206994597c13d831ec7",
    realOriginChainId: 2,
    supportsPermit: !1
  },
  {
    name: "Tether (Portal from solana)",
    symbol: "USDT",
    mint: "Es9vMFrzaCERmJfrF4H2FYD4KCoNkY11McCe8BenwNYB",
    contract: "0x1CDD2EaB61112697626F7b4bB0e23Da4FeBF7B7C",
    chainId: 1,
    wChainId: 2,
    decimals: 6,
    logoURI: "https://assets.coingecko.com/coins/images/325/small/Tether-logo.png?1598003707",
    coingeckoId: "tether",
    realOriginContractAddress: "Es9vMFrzaCERmJfrF4H2FYD4KCoNkY11McCe8BenwNYB",
    realOriginChainId: 1,
    supportsPermit: !0
  },
  {
    name: "The Sandbox",
    symbol: "SAND",
    mint: "49c7WuCZkQgc3M4qH8WuEUNXfgwupZf1xqWkDQ7gjRGt",
    contract: "0x3845badade8e6dff049820680d1f14bd3903a5d0",
    chainId: 1,
    wChainId: 2,
    decimals: 18,
    logoURI: "https://assets.coingecko.com/coins/images/12129/small/sandbox_logo.jpg?1597397942",
    coingeckoId: "the-sandbox",
    realOriginContractAddress: "0x3845badade8e6dff049820680d1f14bd3903a5d0",
    realOriginChainId: 2,
    supportsPermit: !1
  },
  {
    name: "Uniswap",
    symbol: "UNI",
    mint: "8FU95xFJhUUkyyCLU13HSzDLs7oC4QZdXQHL6SCeab36",
    contract: "0x1f9840a85d5af5bf1d1762f925bdaddc4201f984",
    chainId: 1,
    wChainId: 2,
    decimals: 18,
    logoURI: "https://assets.coingecko.com/coins/images/12504/small/uniswap-uni.png?1600306604",
    coingeckoId: "uniswap",
    realOriginContractAddress: "0x1f9840a85d5af5bf1d1762f925bdaddc4201f984",
    realOriginChainId: 2,
    supportsPermit: !0
  },
  {
    name: "Bridged USDC (Portal from Polygon)",
    symbol: "USDC.e",
    mint: "E2VmbootbVCBkMNNxKQgCLMS1X3NoGMaYAsufaAsf7M",
    contract: "0x566957eF80F9fd5526CD2BEF8BE67035C0b81130",
    chainId: 1,
    wChainId: 2,
    decimals: 6,
    logoURI: "https://assets.coingecko.com/coins/images/6319/small/USD_Coin_icon.png?1547042389",
    coingeckoId: "usd-coin",
    realOriginContractAddress: "0x2791bca1f2de4661ed88a30c99a7a9449aa84174",
    realOriginChainId: 5,
    supportsPermit: !0
  },
  {
    name: "USDC (Portal from Polygon)",
    symbol: "USDC",
    mint: "C321jHPwWBzgfSGndosDTp5pBsiXPyMU1irxKLVcedRB",
    contract: "0xFbcE0f9e92AD1003e893Ba647bC055D845aAa507",
    chainId: 1,
    wChainId: 2,
    decimals: 6,
    logoURI: "https://assets.coingecko.com/coins/images/6319/small/usdc.png?1696506694",
    coingeckoId: "usd-coin",
    realOriginContractAddress: "0x3c499c542cef5e3811e1192ce70d8cc03d5c3359",
    realOriginChainId: 5,
    supportsPermit: !0
  },
  {
    name: "USD Coin",
    symbol: "USDC",
    mint: "A9mUU4qviSctJVPJdBJWkb28deg915LYJKrzQ19ji3FM",
    contract: "0xa0b86991c6218b36c1d19d4a2e9eb0ce3606eb48",
    chainId: 1,
    wChainId: 2,
    decimals: 6,
    logoURI: "https://assets.coingecko.com/coins/images/6319/small/USD_Coin_icon.png?1547042389",
    coingeckoId: "usd-coin",
    realOriginContractAddress: "0xa0b86991c6218b36c1d19d4a2e9eb0ce3606eb48",
    realOriginChainId: 2,
    supportsPermit: !0
  },
  {
    name: "USD Coin (Portal from solana)",
    symbol: "USDC",
    mint: "EPjFWdd5AufqSSqeM2qN1xzybapC8G4wEGGkZwyTDt1v",
    contract: "0x41f7B8b9b897276b7AAE926a9016935280b44E97",
    chainId: 1,
    wChainId: 2,
    decimals: 6,
    logoURI: "https://assets.coingecko.com/coins/images/6319/small/USD_Coin_icon.png?1547042389",
    coingeckoId: "usd-coin",
    realOriginContractAddress: "EPjFWdd5AufqSSqeM2qN1xzybapC8G4wEGGkZwyTDt1v",
    realOriginChainId: 1,
    supportsPermit: !0
  },
  {
    name: "Waggle Network (Portal from solana)",
    symbol: "WAG",
    mint: "5tN42n9vMi6ubp67Uy4NnmM5DMZYN8aS8GeB3bEDHr6E",
    contract: "0xa76F832ACf4CcC434929964978BB8747E0dF33BF",
    chainId: 1,
    wChainId: 2,
    decimals: 9,
    logoURI: "https://assets.coingecko.com/coins/images/18696/small/waggle.PNG?1633750177",
    coingeckoId: "waggle-network",
    realOriginContractAddress: "5tN42n9vMi6ubp67Uy4NnmM5DMZYN8aS8GeB3bEDHr6E",
    realOriginChainId: 1,
    supportsPermit: !0
  },
  {
    name: "Wrapped BNB (Portal from BSC)",
    symbol: "WBNB",
    mint: "9gP2kCy3wA1ctvYWQk75guqXuHfrEomqydHLtcTCqiLa",
    contract: "0x418D75f65a02b3D53B2418FB8E1fe493759c7605",
    chainId: 1,
    wChainId: 2,
    decimals: 18,
    logoURI: "https://assets.coingecko.com/coins/images/12591/small/binance-coin-logo.png?1600947313",
    coingeckoId: "wbnb",
    realOriginContractAddress: "0xbb4cdb9cbd36b01bd1cbaebf2de08d9173bc095c",
    realOriginChainId: 4,
    supportsPermit: !0
  },
  {
    name: "WETH",
    symbol: "WETH",
    mint: "7vfCXTUXx5WJV5JADk17DUJ4ksgau7utNKj4b963voxs",
    contract: "0xc02aaa39b223fe8d0a0e5c4f27ead9083c756cc2",
    chainId: 1,
    wChainId: 2,
    decimals: 18,
    logoURI: "https://assets.coingecko.com/coins/images/2518/small/weth.png?1628852295",
    coingeckoId: "weth",
    realOriginContractAddress: "0xc02aaa39b223fe8d0a0e5c4f27ead9083c756cc2",
    realOriginChainId: 2,
    supportsPermit: !1
  },
  {
    name: "Wrapped Matic (Portal from Polygon)",
    symbol: "WMATIC",
    mint: "Gz7VkD4MacbEB6yC5XD3HcumEiYx2EtDYYrfikGsvopG",
    contract: "0x7c9f4C87d911613Fe9ca58b579f737911AAD2D43",
    chainId: 1,
    wChainId: 2,
    decimals: 18,
    logoURI: "https://assets.coingecko.com/coins/images/14073/small/matic.png?1628852392",
    coingeckoId: "wmatic",
    realOriginContractAddress: "0x0d500b1d8e8ef31e21c99d1db9a6444d3adf1270",
    realOriginChainId: 5,
    supportsPermit: !0
  },
  {
    name: "Wrapped AVAX (Portal from Avalanche)",
    symbol: "WAVAX",
    mint: "KgV1GvrHQmRBY8sHQQeUKwTm2r2h8t4C8qt12Cw1HVE",
    contract: "0x85f138bfEE4ef8e540890CFb48F620571d67Eda3",
    chainId: 1,
    wChainId: 2,
    decimals: 18,
    logoURI: "https://assets.coingecko.com/coins/images/15075/small/wrapped-avax.png?1629873618",
    coingeckoId: "wrapped-avax",
    realOriginContractAddress: "0xb31f66aa3c1e785363f0875a1b74e27b85fd66c7",
    realOriginChainId: 6,
    supportsPermit: !0
  },
  {
    name: "Wrapped Bitcoin (Sollet) (Portal from solana)",
    symbol: "SOBTC",
    mint: "9n4nbM75f5Ui33ZbPYXn59EwSgE8CGsHtAeTH5YFeJ9E",
    contract: "0x1f4e35D4380D91AF30eDca625C8d158019786299",
    chainId: 1,
    wChainId: 2,
    decimals: 6,
    logoURI: "https://assets.coingecko.com/coins/images/24917/small/opengraph.png?1649344256",
    coingeckoId: "wrapped-bitcoin-sollet",
    realOriginContractAddress: "9n4nbM75f5Ui33ZbPYXn59EwSgE8CGsHtAeTH5YFeJ9E",
    realOriginChainId: 1,
    supportsPermit: !0
  },
  {
    name: "Wrapped Chainlink (Sollet) (Portal from solana)",
    symbol: "SOLINK",
    mint: "CWE8jPTUYhdCTZYWPTe1o5DFqfdjzWKc9WKz6rSjQUdG",
    contract: "0xfEf87D8c2558a8866BA1b90d545Bfe2ec73744FC",
    chainId: 1,
    wChainId: 2,
    decimals: 6,
    logoURI: "https://assets.coingecko.com/coins/images/24705/small/qvSHhRyC_400x400.jpg?1648646324",
    coingeckoId: "wrapped-chainlink-sollet",
    realOriginContractAddress: "CWE8jPTUYhdCTZYWPTe1o5DFqfdjzWKc9WKz6rSjQUdG",
    realOriginChainId: 1,
    supportsPermit: !0
  },
  {
    name: "Wrapped Ethereum (Sollet) (Portal from solana)",
    symbol: "SOETH",
    mint: "2FPyTwcZLUg1MDrwsyoP4D6s1tM7hAkHYRjkNb5w6Pxk",
    contract: "0x6E4f753D7Fe74eC11A17d0F81c50acAE11bDf68d",
    chainId: 1,
    wChainId: 2,
    decimals: 6,
    logoURI: "https://assets.coingecko.com/coins/images/24918/small/6250754.png?1649344492",
    coingeckoId: "wrapped-ethereum-sollet",
    realOriginContractAddress: "2FPyTwcZLUg1MDrwsyoP4D6s1tM7hAkHYRjkNb5w6Pxk",
    realOriginChainId: 1,
    supportsPermit: !0
  },
  {
    name: "Wrapped Solana (Portal from solana)",
    symbol: "wSOL",
    mint: "So11111111111111111111111111111111111111112",
    contract: "0xD31a59c85aE9D8edEFeC411D448f90841571b89c",
    chainId: 1,
    wChainId: 2,
    decimals: 9,
    logoURI: "https://assets.coingecko.com/coins/images/21629/small/solana.jpg?1639626543",
    coingeckoId: "wrapped-solana",
    realOriginContractAddress: "So11111111111111111111111111111111111111112",
    realOriginChainId: 1,
    supportsPermit: !0
  },
  {
    name: "Wrapped USDT (Allbridge from Polygon) (Portal from solana)",
    symbol: "APUSDT",
    mint: "DNhZkUaxHXYvpxZ7LNnHtss8sQgdAfd1ZYS1fB7LKWUZ",
    contract: "0x887FE928645020db1eC4af4Aa922C2327F96F90f",
    chainId: 1,
    wChainId: 2,
    decimals: 6,
    logoURI: "https://assets.coingecko.com/coins/images/23060/small/logo_-_2022-01-26T084912.902.png?1643158161",
    coingeckoId: "wrapped-usdt-allbridge-from-polygon",
    realOriginContractAddress: "DNhZkUaxHXYvpxZ7LNnHtss8sQgdAfd1ZYS1fB7LKWUZ",
    realOriginChainId: 1,
    supportsPermit: !0
  },
  {
    name: "Zap (Portal from BSC)",
    symbol: "ZAP",
    mint: "HxPoEHMt1vKeqjKCePcqTj6yYgn6Xqq1fKTY3Pjx4YrX",
    contract: "0x98413f1D5B29521E0641d57D05f6eb95523a49Aa",
    chainId: 1,
    wChainId: 2,
    decimals: 18,
    logoURI: "https://assets.coingecko.com/coins/images/2180/small/zap.png?1547036476",
    coingeckoId: "zap",
    realOriginContractAddress: "0xc5326b32e8baef125acd68f8bc646fd646104f1c",
    realOriginChainId: 4,
    supportsPermit: !0
  },
  {
    name: "WETH (Portal from Optimism)",
    symbol: "WETH",
    mint: "8M6d63oL7dvMZ1gNbgGe3h8afMSWJEKEhtPTFM2u8h3c",
    contract: "0x8B5653Ae095529155462eDa8CF664eD96773F557",
    chainId: 1,
    wChainId: 2,
    decimals: 18,
    logoURI: "https://assets.coingecko.com/coins/images/2518/small/weth.png?1696503332",
    coingeckoId: "weth",
    realOriginContractAddress: "0x4200000000000000000000000000000000000006",
    realOriginChainId: 24,
    supportsPermit: !0
  },
  {
    name: "USDC (Portal from Optimism)",
    symbol: "USDC",
    mint: "J8kcD4Wnd1ehne1dpL8WNtgZQR6Jpui2cTZcrmg5ybAa",
    contract: "0xe77C99b64414e0fd9aeEA48AFFBBD2E97A895020",
    chainId: 1,
    wChainId: 2,
    decimals: 6,
    logoURI: "https://assets.coingecko.com/coins/images/6319/small/usdc.png?1696506694",
    coingeckoId: "usd-coin",
    realOriginContractAddress: "0x0b2c639c533813f4aa9d7837caf62653d097ff85",
    realOriginChainId: 24,
    supportsPermit: !0
  },
  {
    name: "Bridged USDC (Optimism) (Portal from Optimism)",
    symbol: "USDC.E",
    mint: "D6YyAUMTJipLQfUhYs6psdnwpmMz6KbM4Qs9AtCmPpxR",
    contract: "0x3E7570058930728e03B798673Ae2a43fdc209758",
    chainId: 1,
    wChainId: 2,
    decimals: 6,
    logoURI: "https://assets.coingecko.com/coins/images/31580/small/USDC-icon.png?1696530397",
    coingeckoId: "bridged-usd-coin-optimism",
    realOriginContractAddress: "0x7f5c764cbc14f9669b88837ca1490cca17c31607",
    realOriginChainId: 24,
    supportsPermit: !0
  },
  {
    name: "Tether (Portal from Optimism)",
    symbol: "USDT",
    mint: "CLV6gB88nQtnuo3akGLSVRFaiFPTXaBXV4EDaFxV7iRq",
    contract: "0x6253993E8f980f94d0E9bB7Cb2095953c062cc83",
    chainId: 1,
    wChainId: 2,
    decimals: 6,
    logoURI: "https://assets.coingecko.com/coins/images/325/small/Tether.png?1696501661",
    coingeckoId: "tether",
    realOriginContractAddress: "0x94b008aa00579c1307b0ef2c499ad98a8ce58e58",
    realOriginChainId: 24,
    supportsPermit: !0
  },
  {
    name: "SPX6900",
    symbol: "SPX",
    mint: "J3NKxxXZcnNiMjKw9hYb2K4LUxgwB6t1FtPtQVsv3KFr",
    contract: "0xe0f63a424a4439cbe457d80e4f4b51ad25b2c56c",
    chainId: 1,
    wChainId: 2,
    decimals: 8,
    logoURI: "https://assets.coingecko.com/coins/images/31401/small/sticker_%281%29.jpg?1702371083",
    coingeckoId: "spx6900",
    realOriginContractAddress: "0xe0f63a424a4439cbe457d80e4f4b51ad25b2c56c",
    realOriginChainId: 2
  }
], base = [
  {
    name: "ETH",
    symbol: "ETH",
    mint: "",
    contract: "0x0000000000000000000000000000000000000000",
    wrappedAddress: "0x4200000000000000000000000000000000000006",
    chainId: 8453,
    wChainId: 30,
    decimals: 18,
    logoURI: "https://statics.mayan.finance/eth.png",
    coingeckoId: "weth",
    realOriginContractAddress: "0x4200000000000000000000000000000000000006",
    realOriginChainId: 30,
    supportsPermit: !1
  },
  {
    name: "WETH",
    symbol: "WETH",
    mint: "DWXe1hxpnb8LAH21iyXcjvMbiAGzoYyuCVQtRLvZdLYd",
    contract: "0x4200000000000000000000000000000000000006",
    chainId: 8453,
    wChainId: 30,
    decimals: 18,
    logoURI: "https://assets.coingecko.com/coins/images/2518/small/weth.png?1696503332",
    coingeckoId: "weth",
    realOriginContractAddress: "0x4200000000000000000000000000000000000006",
    realOriginChainId: 30,
    supportsPermit: !1
  },
  {
    name: "USDC",
    symbol: "USDC",
    mint: "EfqRM8ZGWhDTKJ7BHmFvNagKVu3AxQRDQs8WMMaoBCu6",
    contract: "0x833589fcd6edb6e08f4c7c32d4f71b54bda02913",
    chainId: 8453,
    wChainId: 30,
    decimals: 6,
    logoURI: "https://assets.coingecko.com/coins/images/6319/small/usdc.png?1696506694",
    coingeckoId: "usd-coin",
    realOriginContractAddress: "0x833589fcd6edb6e08f4c7c32d4f71b54bda02913",
    realOriginChainId: 30,
    supportsPermit: !0
  },
  {
    name: "SPX6900 (Portal from Ethereum)",
    symbol: "SPX",
    mint: "J3NKxxXZcnNiMjKw9hYb2K4LUxgwB6t1FtPtQVsv3KFr",
    contract: "0x50dA645f148798F68EF2d7dB7C1CB22A6819bb2C",
    chainId: 8453,
    wChainId: 30,
    decimals: 8,
    logoURI: "https://assets.coingecko.com/coins/images/31401/small/sticker_%281%29.jpg?1702371083",
    coingeckoId: "spx6900",
    realOriginContractAddress: "0xe0f63a424a4439cbe457d80e4f4b51ad25b2c56c",
    realOriginChainId: 2
  }
], aptos = [
  {
    name: "APT",
    symbol: "APT",
    mint: "6LNeTYMqtNm1pBFN8PfhQaoLyegAH8GD32WmHU9erXKN",
    contract: "0x1::aptos_coin::AptosCoin",
    chainId: 1998,
    wChainId: 22,
    decimals: 8,
    logoURI: "https://statics.mayan.finance/aptos.png",
    coingeckoId: "aptos",
    realOriginContractAddress: "0x1::aptos_coin::AptosCoin",
    realOriginChainId: 22,
    supportsPermit: !0
  }
], polygon = [
  {
    name: "Matic",
    symbol: "MATIC",
    mint: "Gz7VkD4MacbEB6yC5XD3HcumEiYx2EtDYYrfikGsvopG",
    contract: "0x0000000000000000000000000000000000000000",
    chainId: 137,
    wChainId: 5,
    decimals: 18,
    logoURI: "https://statics.mayan.finance/polygon.png",
    wrappedAddress: "0x0d500b1d8e8ef31e21c99d1db9a6444d3adf1270",
    coingeckoId: "wmatic",
    realOriginContractAddress: "0x0d500b1d8e8ef31e21c99d1db9a6444d3adf1270",
    realOriginChainId: 5,
    supportsPermit: !1
  },
  {
    name: "Wrapped Bitcoin (Portal from Ethereum)",
    symbol: "WBTC",
    mint: "3NZ9JMVBmGAqocybic2c7LQCJScmgsAZ6vQqTDzcqmJh",
    contract: "0x5D49c278340655B56609FdF8976eb0612aF3a0C3",
    chainId: 137,
    wChainId: 5,
    decimals: 8,
    logoURI: "https://assets.coingecko.com/coins/images/7598/small/wrapped_bitcoin_wbtc.png?1548822744",
    coingeckoId: "wrapped-bitcoin",
    realOriginContractAddress: "0x2260fac5e5542a773aa44fbcfedf7c193bc2c599",
    realOriginChainId: 2,
    supportsPermit: !0
  },
  {
    name: "WETH (Portal from Arbitrum)",
    symbol: "WETH",
    mint: "CSD6JQMvLi46psjHdpfFdr826mF336pEVMJgjwcoS1m4",
    contract: "0x6a5c59AB16268d2c872916054C50440B999e417C",
    chainId: 137,
    wChainId: 5,
    decimals: 18,
    logoURI: "https://assets.coingecko.com/coins/images/2518/small/weth.png?1628852295",
    coingeckoId: "weth",
    realOriginContractAddress: "0x82af49447d8a07e3bd95bd0d56f35241523fbab1",
    realOriginChainId: 23,
    supportsPermit: !0
  },
  {
    name: "Tether (Portal from Arbitrum)",
    symbol: "USDT",
    mint: "H9o3LaDfoMSVLm9aBWaY56eMmPGDbRFnUHpqcTb9exXB",
    contract: "0x6df9e1d2502E0a370Ef5f7b1f541505D100e59b5",
    chainId: 137,
    wChainId: 5,
    decimals: 6,
    logoURI: "https://assets.coingecko.com/coins/images/325/small/Tether.png?1668148663",
    coingeckoId: "tether",
    realOriginContractAddress: "0xfd086bc7cd5c481dcc9c85ebe478a1c0b69fcbb9",
    realOriginChainId: 23,
    supportsPermit: !0
  },
  {
    name: "USD Coin (Arb1)(Portal from Arbitrum)",
    symbol: "USDC.e",
    mint: "HAxCJjnmgkdXhwZYeJiUvBgm4NdQvqhGJCS3KxCnCxWs",
    contract: "0x79f848D0257f20051aFe82B292Ef7707dA942823",
    chainId: 137,
    wChainId: 5,
    decimals: 6,
    logoURI: "https://assets.coingecko.com/coins/images/6319/small/USD_Coin_icon.png?1547042389",
    coingeckoId: "usd-coin",
    realOriginContractAddress: "0xff970a61a04b1ca14834a43f5de4533ebddb5cc8",
    realOriginChainId: 23,
    supportsPermit: !0
  },
  {
    name: "USD Coin (Portal from Avalanche)",
    symbol: "USDC",
    mint: "FHfba3ov5P3RjaiLVgh8FTv4oirxQDoVXuoUUDvHuXax",
    contract: "0xAEA5CC14DefbC1b845FDE729E563B717Ee6825ae",
    chainId: 137,
    wChainId: 5,
    decimals: 6,
    logoURI: "https://assets.coingecko.com/coins/images/6319/small/USD_Coin_icon.png?1547042389",
    coingeckoId: "usd-coin",
    realOriginContractAddress: "0xb97ef9ef8734c71904d8002f8b6bc66dd9c48a6e",
    realOriginChainId: 6,
    supportsPermit: !0
  },
  {
    name: "Tether (Portal from Avalanche)",
    symbol: "USDT",
    mint: "Kz1csQA91WUGcQ2TB3o5kdGmWmMGp8eJcDEyHzNDVCX",
    contract: "0x32279A16358B5B1EfE1b3412d3aab9CFEbC54B4d",
    chainId: 137,
    wChainId: 5,
    decimals: 6,
    logoURI: "https://assets.coingecko.com/coins/images/325/small/Tether.png?1668148663",
    coingeckoId: "tether",
    realOriginContractAddress: "0x9702230a8ea53601f5cd2dc00fdbc13d4df4a8c7",
    realOriginChainId: 6,
    supportsPermit: !0
  },
  {
    name: "USD Coin (Portal from BSC)",
    symbol: "USDC",
    mint: "FCqfQSujuPxy6V42UvafBhsysWtEq1vhjfMN1PUbgaxA",
    contract: "0x4B3a922c773BDCF3BA8f1A4FDAc2029E1D0E9868",
    chainId: 137,
    wChainId: 5,
    decimals: 18,
    logoURI: "https://assets.coingecko.com/coins/images/6319/small/USD_Coin_icon.png?1547042389",
    coingeckoId: "usd-coin",
    realOriginContractAddress: "0x8ac76a51cc950d9822d68b83fe1ad97b32cd580d",
    realOriginChainId: 4,
    supportsPermit: !0
  },
  {
    name: "Dai (Portal from Ethereum)",
    symbol: "DAI",
    mint: "EjmyN6qEC1Tf1JxiG1ae7UTJhUxSwk1TCWNWqxWV4J6o",
    contract: "0x732EB1747ecCFC431fF19bc359ffc83755B1918c",
    chainId: 137,
    wChainId: 5,
    decimals: 18,
    logoURI: "https://assets.coingecko.com/coins/images/9956/small/4943.png?1636636734",
    coingeckoId: "dai",
    realOriginContractAddress: "0x6b175474e89094c44da98b954eedeac495271d0f",
    realOriginChainId: 2,
    supportsPermit: !1
  },
  {
    name: "agEUR (Portal from Ethereum)",
    symbol: "AGEUR",
    mint: "CbNYA9n3927uXUukee2Hf4tm3xxkffJPPZvGazc2EAH1",
    contract: "0xE1cB9e87d8c3FD0ef592B175A64d40F9E7cc2C07",
    chainId: 137,
    wChainId: 5,
    decimals: 18,
    logoURI: "https://assets.coingecko.com/coins/images/19479/small/agEUR.png?1635283566",
    coingeckoId: "ageur",
    realOriginContractAddress: "0x1a7e4e63778b4f12a199c062f3efdd288afcbce8",
    realOriginChainId: 2,
    supportsPermit: !0
  },
  {
    name: "Apricot (Portal from solana)",
    symbol: "APRT",
    mint: "APTtJyaRX5yGTsJU522N4VYWg3vCvSb65eam5GrPT5Rt",
    contract: "0xcaE44951d8CBFaADa09591f2aE2f9B6D3f5E0a19",
    chainId: 137,
    wChainId: 5,
    decimals: 6,
    logoURI: "https://assets.coingecko.com/coins/images/20636/small/hF_3FMuH_400x400.jpg?1637399870",
    coingeckoId: "apricot",
    realOriginContractAddress: "APTtJyaRX5yGTsJU522N4VYWg3vCvSb65eam5GrPT5Rt",
    realOriginChainId: 1,
    supportsPermit: !0
  },
  {
    name: "Atlas DEX (Portal from solana)",
    symbol: "ATS",
    mint: "HJbNXx2YMRxgfUJ6K4qeWtjatMK5KYQT1QnsCdDWywNv",
    contract: "0xe4C9bb18E6AF3B43c232BB51B1FD357D9f2cc0d7",
    chainId: 137,
    wChainId: 5,
    decimals: 9,
    logoURI: "https://assets.coingecko.com/coins/images/23002/small/logo.png?1643091340",
    coingeckoId: "atlas-dex",
    realOriginContractAddress: "HJbNXx2YMRxgfUJ6K4qeWtjatMK5KYQT1QnsCdDWywNv",
    realOriginChainId: 1,
    supportsPermit: !0
  },
  {
    name: "Audius (Portal from Ethereum)",
    symbol: "AUDIO",
    mint: "9LzCMqDgTKYz9Drzqnpgee3SGa89up3a247ypMj2xrqM",
    contract: "0x0D9C58a7D3106C0Af682B61579D9484f99dab901",
    chainId: 137,
    wChainId: 5,
    decimals: 18,
    logoURI: "https://assets.coingecko.com/coins/images/12913/small/AudiusCoinLogo_2x.png?1603425727",
    coingeckoId: "audius",
    realOriginContractAddress: "0x18aaa7115705e8be94bffebde57af9bfc265b998",
    realOriginChainId: 2,
    supportsPermit: !0
  },
  {
    name: "Aurory (Portal from solana)",
    symbol: "AURY",
    mint: "AURYydfxJib1ZkTir1Jn1J9ECYUtjb6rKQVmtYaixWPP",
    contract: "0x6E8aaF74cB7454C9103848861E47f67A8aa5Db65",
    chainId: 137,
    wChainId: 5,
    decimals: 9,
    logoURI: "https://assets.coingecko.com/coins/images/19324/small/Ico_Blanc.png?1672824647",
    coingeckoId: "aurory",
    realOriginContractAddress: "AURYydfxJib1ZkTir1Jn1J9ECYUtjb6rKQVmtYaixWPP",
    realOriginChainId: 1,
    supportsPermit: !0
  },
  {
    name: "Axie Infinity (Portal from Ethereum)",
    symbol: "AXS",
    mint: "HysWcbHiYY9888pHbaqhwLYZQeZrcQMXKQWRqS7zcPK5",
    contract: "0x224AB8aC8a181F92Af6122Aa8774F4500ea58D66",
    chainId: 137,
    wChainId: 5,
    decimals: 18,
    logoURI: "https://assets.coingecko.com/coins/images/13029/small/axie_infinity_logo.png?1604471082",
    coingeckoId: "axie-infinity",
    realOriginContractAddress: "0xbb0e17ef65f82ab018d8edd776e8dd940327b28b",
    realOriginChainId: 2,
    supportsPermit: !0
  },
  {
    name: "BiLira (Portal from solana)",
    symbol: "TRYB",
    mint: "A94X2fRy3wydNShU4dRaDyap2UuoeWJGWyATtyp61WZf",
    contract: "0x26ff5291bbBB453adaD1Eb808ABC4CF40D53336D",
    chainId: 137,
    wChainId: 5,
    decimals: 6,
    logoURI: "https://assets.coingecko.com/coins/images/10119/small/JBs9jiXO_400x400.jpg?1642668342",
    coingeckoId: "bilira",
    realOriginContractAddress: "A94X2fRy3wydNShU4dRaDyap2UuoeWJGWyATtyp61WZf",
    realOriginChainId: 1,
    supportsPermit: !0
  },
  {
    name: "Binance USD (Portal from BSC)",
    symbol: "BUSD",
    mint: "5RpUwQ8wtdPCZHhu6MERp2RGrpobsbZ6MH5dDHkUjs2",
    contract: "0xA8D394fE7380b8cE6145d5f85E6aC22d4E91ACDe",
    chainId: 137,
    wChainId: 5,
    decimals: 18,
    logoURI: "https://assets.coingecko.com/coins/images/9576/small/BUSD.png?1568947766",
    coingeckoId: "binance-usd",
    realOriginContractAddress: "0xe9e7cea3dedca5984780bafc599bd69add087d56",
    realOriginChainId: 4,
    supportsPermit: !0
  },
  {
    name: "Bonfida (Portal from solana)",
    symbol: "FIDA",
    mint: "EchesyfXePKdLtoiZSL8pBe8Myagyy8ZRqsACNCFGnvp",
    contract: "0xb83218520B9515C645c09953235C20936beEfB42",
    chainId: 137,
    wChainId: 5,
    decimals: 6,
    logoURI: "https://assets.coingecko.com/coins/images/13395/small/bonfida.png?1658327819",
    coingeckoId: "bonfida",
    realOriginContractAddress: "EchesyfXePKdLtoiZSL8pBe8Myagyy8ZRqsACNCFGnvp",
    realOriginChainId: 1,
    supportsPermit: !0
  },
  {
    name: "Brazilian Digital (Portal from solana)",
    symbol: "BRZ",
    mint: "FtgGSFADXBtroxq8VCausXRr2of47QBf5AS1NtZCu4GD",
    contract: "0x6c060CE95131427550201cB296fb09F3A52150D0",
    chainId: 137,
    wChainId: 5,
    decimals: 4,
    logoURI: "https://assets.coingecko.com/coins/images/8472/small/2_vtiD3xwce9knG2COxtSMaQ.png?1597786961",
    coingeckoId: "brz",
    realOriginContractAddress: "FtgGSFADXBtroxq8VCausXRr2of47QBf5AS1NtZCu4GD",
    realOriginChainId: 1,
    supportsPermit: !0
  },
  {
    name: "Celsius Network (Portal from Ethereum)",
    symbol: "CEL",
    mint: "nRtfwU9G82CSHhHGJNxFhtn7FLvWP2rqvQvje1WtL69",
    contract: "0x83abfFf35499F5Df8423a227465F4C62eD1Ccdcf",
    chainId: 137,
    wChainId: 5,
    decimals: 4,
    logoURI: "https://assets.coingecko.com/coins/images/3263/small/CEL_logo.png?1609598753",
    coingeckoId: "celsius-degree-token",
    realOriginContractAddress: "0xaaaebe6fe48e54f431b0c390cfaf0b017d09d42d",
    realOriginChainId: 2,
    supportsPermit: !0
  },
  {
    name: "Chainlink (Portal from Ethereum)",
    symbol: "LINK",
    mint: "2wpTofQ8SkACrkZWrZDjXPitYa8AwWgX8AfxdeBRRVLX",
    contract: "0xD7a2F809198b872196bfC43A248e067e0Cf3Fb88",
    chainId: 137,
    wChainId: 5,
    decimals: 18,
    logoURI: "https://assets.coingecko.com/coins/images/877/small/chainlink-new-logo.png?1547034700",
    coingeckoId: "chainlink",
    realOriginContractAddress: "0x514910771af9ca656af840dff83e8264ecf986ca",
    realOriginChainId: 2,
    supportsPermit: !0
  },
  {
    name: "Cheems (Portal from solana)",
    symbol: "CHEEMS",
    mint: "3FoUAsGDbvTD6YZ4wVKJgTB76onJUKz7GPEBNiR5b8wc",
    contract: "0x5561683aB5aAd562c338dA0DF64A7B768772b37f",
    chainId: 137,
    wChainId: 5,
    decimals: 4,
    logoURI: "https://assets.coingecko.com/coins/images/18358/small/newlogo.png?1644476666",
    coingeckoId: "cheems",
    realOriginContractAddress: "3FoUAsGDbvTD6YZ4wVKJgTB76onJUKz7GPEBNiR5b8wc",
    realOriginChainId: 1,
    supportsPermit: !0
  },
  {
    name: "ClinTex CTi (Portal from Ethereum)",
    symbol: "CTI",
    mint: "9ET2QCQJdFkeKkuaampNbmicbA8eLYauFCWch9Ddh9p5",
    contract: "0x03C2F6808502fFD4aB2787aD1A98eC13dbD5718b",
    chainId: 137,
    wChainId: 5,
    decimals: 18,
    logoURI: "https://assets.coingecko.com/coins/images/13266/small/CTI.png?1606817542",
    coingeckoId: "clintex-cti",
    realOriginContractAddress: "0xcb8fb2438a805664cd8c3e640b85ac473da5be87",
    realOriginChainId: 2,
    supportsPermit: !0
  },
  {
    name: "Cryowar (Portal from solana)",
    symbol: "CWAR",
    mint: "HfYFjMKNZygfMC8LsQ8LtpPsPxEJoXJx4M6tqi75Hajo",
    contract: "0x56726266D820Ecf8130CE5fb41f8693000193838",
    chainId: 137,
    wChainId: 5,
    decimals: 9,
    logoURI: "https://assets.coingecko.com/coins/images/20227/small/CWAR_round_200_200.png?1636689418",
    coingeckoId: "cryowar-token",
    realOriginContractAddress: "HfYFjMKNZygfMC8LsQ8LtpPsPxEJoXJx4M6tqi75Hajo",
    realOriginChainId: 1,
    supportsPermit: !0
  },
  {
    name: "Decentraland (Portal from Ethereum)",
    symbol: "MANA",
    mint: "7dgHoN8wBZCc5wbnQ2C47TDnBMAxG4Q5L3KjP67z8kNi",
    contract: "0x1eA5147ca7640798d84194A30E8E58BFBfAFd4dc",
    chainId: 137,
    wChainId: 5,
    decimals: 18,
    logoURI: "https://assets.coingecko.com/coins/images/878/small/decentraland-mana.png?1550108745",
    coingeckoId: "decentraland",
    realOriginContractAddress: "0x0f5d2fb29fb7d3cfee444a200298f468908cc942",
    realOriginChainId: 2,
    supportsPermit: !0
  },
  {
    name: "FLOOF (Portal from solana)",
    symbol: "FLOOF",
    mint: "3jzdrXXKxwkBk82u2eCWASZLCKoZs1LQTg87HBEAmBJw",
    contract: "0x79311dE967845458Aa3bA8d6Df442fD34746144d",
    chainId: 137,
    wChainId: 5,
    decimals: 1,
    logoURI: "https://assets.coingecko.com/coins/images/19810/small/FLOOF_logo_200x200.png?1635917291",
    coingeckoId: "floof",
    realOriginContractAddress: "3jzdrXXKxwkBk82u2eCWASZLCKoZs1LQTg87HBEAmBJw",
    realOriginChainId: 1,
    supportsPermit: !0
  },
  {
    name: "Frax (Portal from Ethereum)",
    symbol: "FRAX",
    mint: "FR87nWEUxVgerFGhZM8Y4AggKGLnaXswr1Pd8wZ4kZcp",
    contract: "0xE8CF1d35d4C7DF33eaa8aCAC3A2773B4bc9517C7",
    chainId: 137,
    wChainId: 5,
    decimals: 18,
    logoURI: "https://assets.coingecko.com/coins/images/13422/small/ethCanonicalFRAX.png?1669277108",
    coingeckoId: "frax",
    realOriginContractAddress: "0x853d955acef822db058eb8505911ed77f175b99e",
    realOriginChainId: 2,
    supportsPermit: !0
  },
  {
    name: "GenesysGo Shadow (Portal from solana)",
    symbol: "SHDW",
    mint: "SHDWyBxihqiCj6YekG2GUr7wqKLeLAMK1gHZck9pL6y",
    contract: "0xfEF4ab6138Aa1D978ff280DA27f0133958E59278",
    chainId: 137,
    wChainId: 5,
    decimals: 9,
    logoURI: "https://assets.coingecko.com/coins/images/22271/small/logo_-_2022-01-05T083602.373.png?1641342974",
    coingeckoId: "genesysgo-shadow",
    realOriginContractAddress: "SHDWyBxihqiCj6YekG2GUr7wqKLeLAMK1gHZck9pL6y",
    realOriginChainId: 1,
    supportsPermit: !0
  },
  {
    name: "Genopets (Portal from solana)",
    symbol: "GENE",
    mint: "GENEtH5amGSi8kHAtQoezp1XEXwZJ8vcuePYnXdKrMYz",
    contract: "0xb6846dbcB48CD57d2FA07AC0A12690FFd7ED530E",
    chainId: 137,
    wChainId: 5,
    decimals: 9,
    logoURI: "https://assets.coingecko.com/coins/images/20360/small/gene-token.png?1636945172",
    coingeckoId: "genopets",
    realOriginContractAddress: "GENEtH5amGSi8kHAtQoezp1XEXwZJ8vcuePYnXdKrMYz",
    realOriginChainId: 1,
    supportsPermit: !0
  },
  {
    name: "Grape Protocol (Portal from solana)",
    symbol: "GRAPE",
    mint: "8upjSpvjcdpuzhfR1zriwg5NXkwDruejqNE9WNbPRtyA",
    contract: "0x690c67BB22034A361Ef9533BAa8d0448Fa21394B",
    chainId: 137,
    wChainId: 5,
    decimals: 6,
    logoURI: "https://assets.coingecko.com/coins/images/18149/small/fRsuAlcV_400x400.png?1632437325",
    coingeckoId: "grape-2",
    realOriginContractAddress: "8upjSpvjcdpuzhfR1zriwg5NXkwDruejqNE9WNbPRtyA",
    realOriginChainId: 1,
    supportsPermit: !0
  },
  {
    name: "Keeshond (Portal from solana)",
    symbol: "$KSH",
    mint: "6j14WyX1Ag2pLWvn99euK4xp2VcZD62VeJv2iwCrYmT8",
    contract: "0x664302BcB730f88498EB9D41c145400A048a224B",
    chainId: 137,
    wChainId: 5,
    decimals: 9,
    logoURI: "https://assets.coingecko.com/coins/images/21353/small/lkdYjrVS_400x400.jpg?1638999576",
    coingeckoId: "keeshond",
    realOriginContractAddress: "6j14WyX1Ag2pLWvn99euK4xp2VcZD62VeJv2iwCrYmT8",
    realOriginChainId: 1,
    supportsPermit: !0
  },
  {
    name: "Kin (Portal from solana)",
    symbol: "KIN",
    mint: "kinXdEcpDQeHPEuQnqmUgtYykqKGVFq6CeVX5iAHJq6",
    contract: "0xae20bC21D17fAfB945551D4Fd15bf4f136e106F7",
    chainId: 137,
    wChainId: 5,
    decimals: 5,
    logoURI: "https://assets.coingecko.com/coins/images/959/small/kin.png?1586917032",
    coingeckoId: "kin",
    realOriginContractAddress: "kinXdEcpDQeHPEuQnqmUgtYykqKGVFq6CeVX5iAHJq6",
    realOriginChainId: 1,
    supportsPermit: !0
  },
  {
    name: "Lido DAO (Portal from Ethereum)",
    symbol: "LDO",
    mint: "HZRCwxP2Vq9PCpPXooayhJ2bxTpo5xfpQrwB1svh332p",
    contract: "0x2CA4c4425ba34dE0C944aA02210fcc629d5E4832",
    chainId: 137,
    wChainId: 5,
    decimals: 18,
    logoURI: "https://assets.coingecko.com/coins/images/13573/small/Lido_DAO.png?1609873644",
    coingeckoId: "lido-dao",
    realOriginContractAddress: "0x5a98fcbea516cf06857215779fd812ca3bef1b32",
    realOriginChainId: 2,
    supportsPermit: !0
  },
  {
    name: "Mango (Portal from solana)",
    symbol: "MNGO",
    mint: "MangoCzJ36AjZyKwVj3VnYU4GTonjfVEnJmvvWaxLac",
    contract: "0x214c9481D1c8b6461859E308f04aC83F4C07657a",
    chainId: 137,
    wChainId: 5,
    decimals: 6,
    logoURI: "https://assets.coingecko.com/coins/images/14773/small/token-mango.png?1628171237",
    coingeckoId: "mango-markets",
    realOriginContractAddress: "MangoCzJ36AjZyKwVj3VnYU4GTonjfVEnJmvvWaxLac",
    realOriginChainId: 1,
    supportsPermit: !0
  },
  {
    name: "Marinade (Portal from solana)",
    symbol: "MNDE",
    mint: "MNDEFzGvMt87ueuHvVU9VcTqsAP5b3fTGPsHuuPA5ey",
    contract: "0x4e64D8B044a8b126038ECE729b17D8102Af763af",
    chainId: 137,
    wChainId: 5,
    decimals: 9,
    logoURI: "https://assets.coingecko.com/coins/images/18867/small/MNDE.png?1643187748",
    coingeckoId: "marinade",
    realOriginContractAddress: "MNDEFzGvMt87ueuHvVU9VcTqsAP5b3fTGPsHuuPA5ey",
    realOriginChainId: 1,
    supportsPermit: !0
  },
  {
    name: "Meanfi (Portal from solana)",
    symbol: "MEAN",
    mint: "MEANeD3XDdUmNMsRGjASkSWdC8prLYsoRJ61pPeHctD",
    contract: "0x4867B60aD7C6aDc98653f661f1AEA31740986bA5",
    chainId: 137,
    wChainId: 5,
    decimals: 6,
    logoURI: "https://assets.coingecko.com/coins/images/21557/small/89934951.png?1639466364",
    coingeckoId: "meanfi",
    realOriginContractAddress: "MEANeD3XDdUmNMsRGjASkSWdC8prLYsoRJ61pPeHctD",
    realOriginChainId: 1,
    supportsPermit: !0
  },
  {
    name: "MAI (Portal from solana)",
    symbol: "MIMATIC",
    mint: "9mWRABuz2x6koTPCWiCPM49WUbcrNqGTHBV9T9k7y1o7",
    contract: "0x8DD58c5a51E0e4aC3701119facF4b300eA412bE5",
    chainId: 137,
    wChainId: 5,
    decimals: 9,
    logoURI: "https://assets.coingecko.com/coins/images/15264/small/mimatic-red.png?1620281018",
    coingeckoId: "mimatic",
    realOriginContractAddress: "9mWRABuz2x6koTPCWiCPM49WUbcrNqGTHBV9T9k7y1o7",
    realOriginChainId: 1,
    supportsPermit: !0
  },
  {
    name: "Marinade staked SOL (Portal from solana)",
    symbol: "MSOL",
    mint: "mSoLzYCxHdYgdzU16g5QSh3i5K3z3KZK7ytfqcJm7So",
    contract: "0xc60AF012b3106a2A0Ab9d3bf7dFF0E0e19886B48",
    chainId: 137,
    wChainId: 5,
    decimals: 9,
    logoURI: "https://assets.coingecko.com/coins/images/17752/small/mSOL.png?1644541955",
    coingeckoId: "msol",
    realOriginContractAddress: "mSoLzYCxHdYgdzU16g5QSh3i5K3z3KZK7ytfqcJm7So",
    realOriginChainId: 1,
    supportsPermit: !0
  },
  {
    name: "Orca (Portal from solana)",
    symbol: "ORCA",
    mint: "orcaEKTdK7LKz57vaAYr9QeNsVEPfiu6QeMU1kektZE",
    contract: "0x276CFEe75f638B4405D1cF5f871092eFA70a0C6A",
    chainId: 137,
    wChainId: 5,
    decimals: 6,
    logoURI: "https://assets.coingecko.com/coins/images/17547/small/Orca_Logo.png?1628781615",
    coingeckoId: "orca",
    realOriginContractAddress: "orcaEKTdK7LKz57vaAYr9QeNsVEPfiu6QeMU1kektZE",
    realOriginChainId: 1,
    supportsPermit: !0
  },
  {
    name: "Parasol Finance (Portal from solana)",
    symbol: "PSOL",
    mint: "Hmatmu1ktLbobSvim94mfpZmjL5iiyoM1zidtXJRAdLZ",
    contract: "0x2e0ab46E86886D2D2d7Cd99Abb21e07dDE2029e5",
    chainId: 137,
    wChainId: 5,
    decimals: 7,
    logoURI: "https://assets.coingecko.com/coins/images/21551/small/icon.png?1642584584",
    coingeckoId: "parasol-finance",
    realOriginContractAddress: "Hmatmu1ktLbobSvim94mfpZmjL5iiyoM1zidtXJRAdLZ",
    realOriginChainId: 1,
    supportsPermit: !0
  },
  {
    name: "Parrot Protocol (Portal from solana)",
    symbol: "PRT",
    mint: "PRT88RkA4Kg5z7pKnezeNH4mafTvtQdfFgpQTGRjz44",
    contract: "0x096831535ddEdBbD6F67157d203895F1e76cf4DC",
    chainId: 137,
    wChainId: 5,
    decimals: 6,
    logoURI: "https://assets.coingecko.com/coins/images/18443/small/PRT.png?1634698095",
    coingeckoId: "parrot-protocol",
    realOriginContractAddress: "PRT88RkA4Kg5z7pKnezeNH4mafTvtQdfFgpQTGRjz44",
    realOriginChainId: 1,
    supportsPermit: !0
  },
  {
    name: "Parrot USD (Portal from solana)",
    symbol: "PAI",
    mint: "Ea5SjE2Y6yvCeW5dYTn7PYMuW5ikXkvbGdcmSnXeaLjS",
    contract: "0x02D64Db0625B705fAf21FCe9fFb2dCa79567AB22",
    chainId: 137,
    wChainId: 5,
    decimals: 6,
    logoURI: "https://assets.coingecko.com/coins/images/18439/small/pai.png?1632004568",
    coingeckoId: "parrot-usd",
    realOriginContractAddress: "Ea5SjE2Y6yvCeW5dYTn7PYMuW5ikXkvbGdcmSnXeaLjS",
    realOriginChainId: 1,
    supportsPermit: !0
  },
  {
    name: "Ratio Stable Coin (Portal from solana)",
    symbol: "USDR",
    mint: "USDrbBQwQbQ2oWHUPfA8QBHcyVxKUq1xHyXsSLKdUq2",
    contract: "0xD9Ad3adCFdC34A2EA7C837a6384808375cEa00aA",
    chainId: 137,
    wChainId: 5,
    decimals: 6,
    logoURI: "https://assets.coingecko.com/coins/images/26066/small/usdr_logo.png?1655469254",
    coingeckoId: "ratio-stable-coin",
    realOriginContractAddress: "USDrbBQwQbQ2oWHUPfA8QBHcyVxKUq1xHyXsSLKdUq2",
    realOriginChainId: 1,
    supportsPermit: !0
  },
  {
    name: "Raydium (Portal from solana)",
    symbol: "RAY",
    mint: "4k3Dyjzvzp8eMZWUXbBCjEvwSkkk59S5iCNLY3QrkX6R",
    contract: "0x5D0D8D062eb1F0971385BAE419BC5cf745cD10b0",
    chainId: 137,
    wChainId: 5,
    decimals: 6,
    logoURI: "https://assets.coingecko.com/coins/images/13928/small/PSigc4ie_400x400.jpg?1612875614",
    coingeckoId: "raydium",
    realOriginContractAddress: "4k3Dyjzvzp8eMZWUXbBCjEvwSkkk59S5iCNLY3QrkX6R",
    realOriginChainId: 1,
    supportsPermit: !0
  },
  {
    name: "Rollbit Coin (Portal from solana)",
    symbol: "RLB",
    mint: "RLBxxFkseAZ4RgJH3Sqn8jXxhmGoz9jWxDNJMh8pL7a",
    contract: "0x2a28bf1789Ec27B312030B8aE16E50192a9A75ef",
    chainId: 137,
    wChainId: 5,
    decimals: 2,
    logoURI: "https://assets.coingecko.com/coins/images/24552/small/unziL6wO_400x400.jpg?1648134494",
    coingeckoId: "rollbit-coin",
    realOriginContractAddress: "RLBxxFkseAZ4RgJH3Sqn8jXxhmGoz9jWxDNJMh8pL7a",
    realOriginChainId: 1,
    supportsPermit: !0
  },
  {
    name: "Saber (Portal from solana)",
    symbol: "SBR",
    mint: "Saber2gLauYim4Mvftnrasomsv6NvAuncvMEZwcLpD1",
    contract: "0x7686E89BC3d657AB23eECC712c8c79548971eb23",
    chainId: 137,
    wChainId: 5,
    decimals: 6,
    logoURI: "https://assets.coingecko.com/coins/images/17162/small/oYs_YFz8_400x400.jpg?1626678457",
    coingeckoId: "saber",
    realOriginContractAddress: "Saber2gLauYim4Mvftnrasomsv6NvAuncvMEZwcLpD1",
    realOriginChainId: 1,
    supportsPermit: !0
  },
  {
    name: "SAIL (Portal from solana)",
    symbol: "SAIL",
    mint: "6kwTqmdQkJd8qRr9RjSnUX9XJ24RmJRSrU1rsragP97Y",
    contract: "0x7f21eDd7268F63c61ECc8E59C2D7b3E7d6ed215C",
    chainId: 137,
    wChainId: 5,
    decimals: 6,
    logoURI: "https://assets.coingecko.com/coins/images/16657/small/SAIL.png?1624608515",
    coingeckoId: "sail",
    realOriginContractAddress: "6kwTqmdQkJd8qRr9RjSnUX9XJ24RmJRSrU1rsragP97Y",
    realOriginChainId: 1,
    supportsPermit: !0
  },
  {
    name: "Serum (Portal from solana)",
    symbol: "SRM",
    mint: "SRMuApVNdxXokk5GT7XD5cUUgXMBCoAz2LHeuAoKWRt",
    contract: "0x0BDc7767Be68cfBECFC9a90cDc7D0c1C8d215D08",
    chainId: 137,
    wChainId: 5,
    decimals: 6,
    logoURI: "https://assets.coingecko.com/coins/images/11970/small/serum-logo.png?1597121577",
    coingeckoId: "serum",
    realOriginContractAddress: "SRMuApVNdxXokk5GT7XD5cUUgXMBCoAz2LHeuAoKWRt",
    realOriginChainId: 1,
    supportsPermit: !0
  },
  {
    name: "Shibalana (Portal from solana)",
    symbol: "SHIBA",
    mint: "Dhg9XnzJWzSQqH2aAnhPTEJHGQAkALDfD98MA499A7pa",
    contract: "0xbcDBE9DEe98FcCCb52f0429CEDf5192FD0Dfd481",
    chainId: 137,
    wChainId: 5,
    decimals: 9,
    logoURI: "https://assets.coingecko.com/coins/images/20003/small/output-onlinepngtools_%2810%29.png?1636364960",
    coingeckoId: "shibalana",
    realOriginContractAddress: "Dhg9XnzJWzSQqH2aAnhPTEJHGQAkALDfD98MA499A7pa",
    realOriginChainId: 1,
    supportsPermit: !0
  },
  {
    name: "Solareum Wallet (Portal from solana)",
    symbol: "XSB",
    mint: "4UuGQgkD3rSeoXatXRWwRfRd21G87d5LiCfkVzNNv1Tt",
    contract: "0x2d3701F4BFe603CdC3846199Adc225aa9EefEBd7",
    chainId: 137,
    wChainId: 5,
    decimals: 9,
    logoURI: "https://assets.coingecko.com/coins/images/20958/small/xsb-200.png?1638141904",
    coingeckoId: "solareum-wallet",
    realOriginContractAddress: "4UuGQgkD3rSeoXatXRWwRfRd21G87d5LiCfkVzNNv1Tt",
    realOriginChainId: 1,
    supportsPermit: !0
  },
  {
    name: "SolRazr (Portal from solana)",
    symbol: "SOLR",
    mint: "7j7H7sgsnNDeCngAPjpaCN4aaaru4HS7NAFYSEUyzJ3k",
    contract: "0x74D88adc13A82e3339de9BE5854C3b20c0c2DB49",
    chainId: 137,
    wChainId: 5,
    decimals: 6,
    logoURI: "https://assets.coingecko.com/coins/images/18390/small/Sol-Razr-Logo-TICKER.png?1631759669",
    coingeckoId: "solrazr",
    realOriginContractAddress: "7j7H7sgsnNDeCngAPjpaCN4aaaru4HS7NAFYSEUyzJ3k",
    realOriginChainId: 1,
    supportsPermit: !0
  },
  {
    name: "Star Atlas (Portal from solana)",
    symbol: "ATLAS",
    mint: "ATLASXmbPQxBUYbxPsV97usA3fPQYEqzQBUHgiFCUsXx",
    contract: "0xCEf3fAe648270E1d064922283dC26f2e25D8d77f",
    chainId: 137,
    wChainId: 5,
    decimals: 8,
    logoURI: "https://assets.coingecko.com/coins/images/17659/small/Icon_Reverse.png?1628759092",
    coingeckoId: "star-atlas",
    realOriginContractAddress: "ATLASXmbPQxBUYbxPsV97usA3fPQYEqzQBUHgiFCUsXx",
    realOriginChainId: 1,
    supportsPermit: !0
  },
  {
    name: "STEPN (Portal from solana)",
    symbol: "GMT",
    mint: "7i5KKsX2weiTkry7jA4ZwSuXGhs5eJBEjY8vVxR4pfRx",
    contract: "0xcb325908359b4BbE2d81868C20A77eD70ACF5067",
    chainId: 137,
    wChainId: 5,
    decimals: 9,
    logoURI: "https://assets.coingecko.com/coins/images/23597/small/gmt.png?1644658792",
    coingeckoId: "stepn",
    realOriginContractAddress: "7i5KKsX2weiTkry7jA4ZwSuXGhs5eJBEjY8vVxR4pfRx",
    realOriginChainId: 1,
    supportsPermit: !0
  },
  {
    name: "Sunny Aggregator (Portal from solana)",
    symbol: "SUNNY",
    mint: "SUNNYWgPQmFxe9wTZzNK7iPnJ3vYDrkgnxJRJm1s3ag",
    contract: "0x953B6Ea09b77F0B45498B6a5Ead26157628942c0",
    chainId: 137,
    wChainId: 5,
    decimals: 6,
    logoURI: "https://assets.coingecko.com/coins/images/18039/small/90dbe787-8e5f-473c-b923-fe138a7a30ea.png?1630314924",
    coingeckoId: "sunny-aggregator",
    realOriginContractAddress: "SUNNYWgPQmFxe9wTZzNK7iPnJ3vYDrkgnxJRJm1s3ag",
    realOriginChainId: 1,
    supportsPermit: !0
  },
  {
    name: "Sushi (Portal from Ethereum)",
    symbol: "SUSHI",
    mint: "ChVzxWRmrTeSgwd3Ui3UumcN8KX7VK3WaD4KGeSKpypj",
    contract: "0x39ecFC5941DfB0BF9FEde32BA1a8a2a36B0b9d7b",
    chainId: 137,
    wChainId: 5,
    decimals: 18,
    logoURI: "https://assets.coingecko.com/coins/images/12271/small/512x512_Logo_no_chop.png?1606986688",
    coingeckoId: "sushi",
    realOriginContractAddress: "0x6b3595068778dd592e39a122f4f5a5cf09c90fe2",
    realOriginChainId: 2,
    supportsPermit: !0
  },
  {
    name: "Swole Doge (Portal from solana)",
    symbol: "SWOLE",
    mint: "4BzxVoBQzwKoqm1dQc78r42Yby3EzAeZmMiYFdCjeu5Z",
    contract: "0x1B0f10F7baDa9aC10B7343fAF3bB1A7732761620",
    chainId: 137,
    wChainId: 5,
    decimals: 9,
    logoURI: "https://assets.coingecko.com/coins/images/19643/small/swole.png?1635853067",
    coingeckoId: "swole-doge",
    realOriginContractAddress: "4BzxVoBQzwKoqm1dQc78r42Yby3EzAeZmMiYFdCjeu5Z",
    realOriginChainId: 1,
    supportsPermit: !0
  },
  {
    name: "Synthetify (Portal from solana)",
    symbol: "SNY",
    mint: "4dmKkXNHdgYsXqBHCuMikNQWwVomZURhYvkkX5c4pQ7y",
    contract: "0x02836036380e9613BC9a1992Fff9e17bd9f5a982",
    chainId: 137,
    wChainId: 5,
    decimals: 6,
    logoURI: "https://assets.coingecko.com/coins/images/14835/small/synthetify_token.png?1618611507",
    coingeckoId: "synthetify-token",
    realOriginContractAddress: "4dmKkXNHdgYsXqBHCuMikNQWwVomZURhYvkkX5c4pQ7y",
    realOriginChainId: 1,
    supportsPermit: !0
  },
  {
    name: "Tether",
    symbol: "USDT",
    mint: "5goWRao6a3yNC4d6UjMdQxonkCMvKBwdpubU3qhfcdf1",
    contract: "0xc2132d05d31c914a87c6611c10748aeb04b58e8f",
    chainId: 137,
    wChainId: 5,
    decimals: 6,
    logoURI: "https://assets.coingecko.com/coins/images/325/small/Tether.png?1668148663",
    coingeckoId: "tether",
    realOriginContractAddress: "0xc2132d05d31c914a87c6611c10748aeb04b58e8f",
    realOriginChainId: 5,
    supportsPermit: !1
  },
  {
    name: "Tether (Portal from BSC)",
    symbol: "USDT",
    mint: "8qJSyQprMC57TWKaYEmetUR3UUiTP2M3hXdcvFhkZdmv",
    contract: "0x07365017e2436b5C3553028DB2a98d7672fb75Eb",
    chainId: 137,
    wChainId: 5,
    decimals: 18,
    logoURI: "https://assets.coingecko.com/coins/images/325/small/Tether-logo.png?1598003707",
    coingeckoId: "tether",
    realOriginContractAddress: "0x55d398326f99059ff775485246999027b3197955",
    realOriginChainId: 4,
    supportsPermit: !0
  },
  {
    name: "Tether (Portal from Ethereum)",
    symbol: "USDT",
    mint: "Dn4noZ5jgGfkntzcQSUZ8czkreiZ1ForXYoV2H8Dm7S1",
    contract: "0x9417669fBF23357D2774e9D421307bd5eA1006d2",
    chainId: 137,
    wChainId: 5,
    decimals: 6,
    logoURI: "https://assets.coingecko.com/coins/images/325/small/Tether-logo.png?1598003707",
    coingeckoId: "tether",
    realOriginContractAddress: "0xdac17f958d2ee523a2206206994597c13d831ec7",
    realOriginChainId: 2,
    supportsPermit: !0
  },
  {
    name: "Tether (Portal from solana)",
    symbol: "USDT",
    mint: "Es9vMFrzaCERmJfrF4H2FYD4KCoNkY11McCe8BenwNYB",
    contract: "0x3553f861dEc0257baDA9F8Ed268bf0D74e45E89C",
    chainId: 137,
    wChainId: 5,
    decimals: 6,
    logoURI: "https://assets.coingecko.com/coins/images/325/small/Tether-logo.png?1598003707",
    coingeckoId: "tether",
    realOriginContractAddress: "Es9vMFrzaCERmJfrF4H2FYD4KCoNkY11McCe8BenwNYB",
    realOriginChainId: 1,
    supportsPermit: !0
  },
  {
    name: "The Sandbox (Portal from Ethereum)",
    symbol: "SAND",
    mint: "49c7WuCZkQgc3M4qH8WuEUNXfgwupZf1xqWkDQ7gjRGt",
    contract: "0x33Af345CeAF1dcA90F622a63bFD7AeBB94Eb54B2",
    chainId: 137,
    wChainId: 5,
    decimals: 18,
    logoURI: "https://assets.coingecko.com/coins/images/12129/small/sandbox_logo.jpg?1597397942",
    coingeckoId: "the-sandbox",
    realOriginContractAddress: "0x3845badade8e6dff049820680d1f14bd3903a5d0",
    realOriginChainId: 2,
    supportsPermit: !0
  },
  {
    name: "USDC",
    symbol: "USDC",
    mint: "C321jHPwWBzgfSGndosDTp5pBsiXPyMU1irxKLVcedRB",
    contract: "0x3c499c542cef5e3811e1192ce70d8cc03d5c3359",
    chainId: 137,
    wChainId: 5,
    decimals: 6,
    logoURI: "https://assets.coingecko.com/coins/images/6319/small/usdc.png?1696506694",
    coingeckoId: "usd-coin",
    realOriginContractAddress: "0x3c499c542cef5e3811e1192ce70d8cc03d5c3359",
    realOriginChainId: 5,
    supportsPermit: !0
  },
  {
    name: "Bridged USDC",
    symbol: "USDC.e",
    mint: "E2VmbootbVCBkMNNxKQgCLMS1X3NoGMaYAsufaAsf7M",
    contract: "0x2791bca1f2de4661ed88a30c99a7a9449aa84174",
    chainId: 137,
    wChainId: 5,
    decimals: 6,
    logoURI: "https://assets.coingecko.com/coins/images/6319/small/USD_Coin_icon.png?1547042389",
    coingeckoId: "usd-coin",
    realOriginContractAddress: "0x2791bca1f2de4661ed88a30c99a7a9449aa84174",
    realOriginChainId: 5,
    supportsPermit: !0
  },
  {
    name: "USD Coin (Portal from Ethereum)",
    symbol: "USDC",
    mint: "A9mUU4qviSctJVPJdBJWkb28deg915LYJKrzQ19ji3FM",
    contract: "0x4318CB63A2b8edf2De971E2F17F77097e499459D",
    chainId: 137,
    wChainId: 5,
    decimals: 6,
    logoURI: "https://assets.coingecko.com/coins/images/6319/small/USD_Coin_icon.png?1547042389",
    coingeckoId: "usd-coin",
    realOriginContractAddress: "0xa0b86991c6218b36c1d19d4a2e9eb0ce3606eb48",
    realOriginChainId: 2,
    supportsPermit: !0
  },
  {
    name: "USD Coin (Portal from solana)",
    symbol: "USDC",
    mint: "EPjFWdd5AufqSSqeM2qN1xzybapC8G4wEGGkZwyTDt1v",
    contract: "0x576Cf361711cd940CD9C397BB98C4C896cBd38De",
    chainId: 137,
    wChainId: 5,
    decimals: 6,
    logoURI: "https://assets.coingecko.com/coins/images/6319/small/USD_Coin_icon.png?1547042389",
    coingeckoId: "usd-coin",
    realOriginContractAddress: "EPjFWdd5AufqSSqeM2qN1xzybapC8G4wEGGkZwyTDt1v",
    realOriginChainId: 1,
    supportsPermit: !0
  },
  {
    name: "UXD Protocol (Portal from solana)",
    symbol: "UXP",
    mint: "UXPhBoR3qG4UCiGNJfV7MqhHyFqKN68g45GoYvAeL2M",
    contract: "0xC1c6F4B28A314221134cb684C7d9c7237225bF3C",
    chainId: 137,
    wChainId: 5,
    decimals: 9,
    logoURI: "https://assets.coingecko.com/coins/images/20319/small/UXP.jpg?1636864568",
    coingeckoId: "uxd-protocol-token",
    realOriginContractAddress: "UXPhBoR3qG4UCiGNJfV7MqhHyFqKN68g45GoYvAeL2M",
    realOriginChainId: 1,
    supportsPermit: !0
  },
  {
    name: "Wrapped BNB (Portal from BSC)",
    symbol: "WBNB",
    mint: "9gP2kCy3wA1ctvYWQk75guqXuHfrEomqydHLtcTCqiLa",
    contract: "0xeCDCB5B88F8e3C15f95c720C51c71c9E2080525d",
    chainId: 137,
    wChainId: 5,
    decimals: 18,
    logoURI: "https://assets.coingecko.com/coins/images/12591/small/binance-coin-logo.png?1600947313",
    coingeckoId: "wbnb",
    realOriginContractAddress: "0xbb4cdb9cbd36b01bd1cbaebf2de08d9173bc095c",
    realOriginChainId: 4,
    supportsPermit: !0
  },
  {
    name: "WETH (Portal from Ethereum)",
    symbol: "WETH",
    mint: "7vfCXTUXx5WJV5JADk17DUJ4ksgau7utNKj4b963voxs",
    contract: "0x11CD37bb86F65419713f30673A480EA33c826872",
    chainId: 137,
    wChainId: 5,
    decimals: 18,
    logoURI: "https://assets.coingecko.com/coins/images/2518/small/weth.png?1628852295",
    coingeckoId: "weth",
    realOriginContractAddress: "0xc02aaa39b223fe8d0a0e5c4f27ead9083c756cc2",
    realOriginChainId: 2,
    supportsPermit: !0
  },
  {
    name: "Whalemap (Portal from solana)",
    symbol: "WMP",
    mint: "BygDd5LURoqztD3xETc99WCxLUbTi6WYSht9XiBgZ4HW",
    contract: "0x62bf1Db4fe8BB3F395b112C07fc570e539508892",
    chainId: 137,
    wChainId: 5,
    decimals: 9,
    logoURI: "https://assets.coingecko.com/coins/images/21892/small/logo-token_%281%29.png?1640228860",
    coingeckoId: "whalemap",
    realOriginContractAddress: "BygDd5LURoqztD3xETc99WCxLUbTi6WYSht9XiBgZ4HW",
    realOriginChainId: 1,
    supportsPermit: !0
  },
  {
    name: "Wrapped Matic",
    symbol: "WMATIC",
    mint: "Gz7VkD4MacbEB6yC5XD3HcumEiYx2EtDYYrfikGsvopG",
    contract: "0x0d500b1d8e8ef31e21c99d1db9a6444d3adf1270",
    chainId: 137,
    wChainId: 5,
    decimals: 18,
    logoURI: "https://assets.coingecko.com/coins/images/14073/small/matic.png?1628852392",
    coingeckoId: "wmatic",
    realOriginContractAddress: "0x0d500b1d8e8ef31e21c99d1db9a6444d3adf1270",
    realOriginChainId: 5,
    supportsPermit: !1
  },
  {
    name: "Wrapped AVAX (Portal from Avalanche)",
    symbol: "WAVAX",
    mint: "KgV1GvrHQmRBY8sHQQeUKwTm2r2h8t4C8qt12Cw1HVE",
    contract: "0x7Bb11E7f8b10E9e571E5d8Eace04735fDFB2358a",
    chainId: 137,
    wChainId: 5,
    decimals: 18,
    logoURI: "https://assets.coingecko.com/coins/images/15075/small/wrapped-avax.png?1629873618",
    coingeckoId: "wrapped-avax",
    realOriginContractAddress: "0xb31f66aa3c1e785363f0875a1b74e27b85fd66c7",
    realOriginChainId: 6,
    supportsPermit: !0
  },
  {
    name: "Wrapped Bitcoin (Sollet) (Portal from solana)",
    symbol: "SOBTC",
    mint: "9n4nbM75f5Ui33ZbPYXn59EwSgE8CGsHtAeTH5YFeJ9E",
    contract: "0x4653dDd751CD1dA6dFc6dd4cBf1F575d17be2e33",
    chainId: 137,
    wChainId: 5,
    decimals: 6,
    logoURI: "https://assets.coingecko.com/coins/images/24917/small/opengraph.png?1649344256",
    coingeckoId: "wrapped-bitcoin-sollet",
    realOriginContractAddress: "9n4nbM75f5Ui33ZbPYXn59EwSgE8CGsHtAeTH5YFeJ9E",
    realOriginChainId: 1,
    supportsPermit: !0
  },
  {
    name: "Wrapped Chainlink (Sollet) (Portal from solana)",
    symbol: "SOLINK",
    mint: "CWE8jPTUYhdCTZYWPTe1o5DFqfdjzWKc9WKz6rSjQUdG",
    contract: "0xB009950702980f546B7F066Cb959183A9E380011",
    chainId: 137,
    wChainId: 5,
    decimals: 6,
    logoURI: "https://assets.coingecko.com/coins/images/24705/small/qvSHhRyC_400x400.jpg?1648646324",
    coingeckoId: "wrapped-chainlink-sollet",
    realOriginContractAddress: "CWE8jPTUYhdCTZYWPTe1o5DFqfdjzWKc9WKz6rSjQUdG",
    realOriginChainId: 1,
    supportsPermit: !0
  },
  {
    name: "Wrapped Solana (Portal from solana)",
    symbol: "wSOL",
    mint: "So11111111111111111111111111111111111111112",
    contract: "0xd93f7E271cB87c23AaA73edC008A79646d1F9912",
    chainId: 137,
    wChainId: 5,
    decimals: 9,
    logoURI: "https://assets.coingecko.com/coins/images/21629/small/solana.jpg?1639626543",
    coingeckoId: "wrapped-solana",
    realOriginContractAddress: "So11111111111111111111111111111111111111112",
    realOriginChainId: 1,
    supportsPermit: !0
  },
  {
    name: "Wrapped USDT (Allbridge from Polygon) (Portal from solana)",
    symbol: "APUSDT",
    mint: "DNhZkUaxHXYvpxZ7LNnHtss8sQgdAfd1ZYS1fB7LKWUZ",
    contract: "0x53525C9A130987fC593fdcf2774620e424C8E0D6",
    chainId: 137,
    wChainId: 5,
    decimals: 6,
    logoURI: "https://assets.coingecko.com/coins/images/23060/small/logo_-_2022-01-26T084912.902.png?1643158161",
    coingeckoId: "wrapped-usdt-allbridge-from-polygon",
    realOriginContractAddress: "DNhZkUaxHXYvpxZ7LNnHtss8sQgdAfd1ZYS1fB7LKWUZ",
    realOriginChainId: 1,
    supportsPermit: !0
  },
  {
    name: "Basket (Portal from Solana)",
    symbol: "BSKT",
    mint: "6gnCPhXtLnUD76HjQuSYPENLSZdG8RvDB1pTLM5aLSJA",
    contract: "0x9a6a40CdF21a0AF417F1b815223FD92c85636c58",
    chainId: 137,
    wChainId: 5,
    decimals: 5,
    logoURI: "https://assets.coingecko.com/coins/images/34661/small/BSKT_Logo.png?1705636891",
    coingeckoId: "basket",
    realOriginContractAddress: "6gnCPhXtLnUD76HjQuSYPENLSZdG8RvDB1pTLM5aLSJA",
    realOriginChainId: 1,
    supportsPermit: !0
  },
  {
    name: "WETH (Portal from Optimism)",
    symbol: "WETH",
    mint: "8M6d63oL7dvMZ1gNbgGe3h8afMSWJEKEhtPTFM2u8h3c",
    contract: "0x8182De59485Bb646542Db8C7E5958148Dc699319",
    chainId: 137,
    wChainId: 5,
    decimals: 18,
    logoURI: "https://assets.coingecko.com/coins/images/2518/small/weth.png?1696503332",
    coingeckoId: "weth",
    realOriginContractAddress: "0x4200000000000000000000000000000000000006",
    realOriginChainId: 24,
    supportsPermit: !0
  },
  {
    name: "USDC (Portal from Optimism)",
    symbol: "USDC",
    mint: "J8kcD4Wnd1ehne1dpL8WNtgZQR6Jpui2cTZcrmg5ybAa",
    contract: "0x31F12aCb60C3c32EE884F3894a873347C097D925",
    chainId: 137,
    wChainId: 5,
    decimals: 6,
    logoURI: "https://assets.coingecko.com/coins/images/6319/small/usdc.png?1696506694",
    coingeckoId: "usd-coin",
    realOriginContractAddress: "0x0b2c639c533813f4aa9d7837caf62653d097ff85",
    realOriginChainId: 24,
    supportsPermit: !0
  },
  {
    name: "Bridged USDC (Optimism) (Portal from Optimism)",
    symbol: "USDC.E",
    mint: "D6YyAUMTJipLQfUhYs6psdnwpmMz6KbM4Qs9AtCmPpxR",
    contract: "0x09D67f6B613b988DCaDfcC48600D0e12f942B307",
    chainId: 137,
    wChainId: 5,
    decimals: 6,
    logoURI: "https://assets.coingecko.com/coins/images/31580/small/USDC-icon.png?1696530397",
    coingeckoId: "bridged-usd-coin-optimism",
    realOriginContractAddress: "0x7f5c764cbc14f9669b88837ca1490cca17c31607",
    realOriginChainId: 24,
    supportsPermit: !0
  },
  {
    name: "Tether (Portal from Optimism)",
    symbol: "USDT",
    mint: "CLV6gB88nQtnuo3akGLSVRFaiFPTXaBXV4EDaFxV7iRq",
    contract: "0xfef8183b580d50Cb9e636eD75B104C3423e70dcC",
    chainId: 137,
    wChainId: 5,
    decimals: 6,
    logoURI: "https://assets.coingecko.com/coins/images/325/small/Tether.png?1696501661",
    coingeckoId: "tether",
    realOriginContractAddress: "0x94b008aa00579c1307b0ef2c499ad98a8ce58e58",
    realOriginChainId: 24,
    supportsPermit: !0
  }
], optimism = [
  {
    name: "ETH",
    symbol: "ETH",
    mint: "8M6d63oL7dvMZ1gNbgGe3h8afMSWJEKEhtPTFM2u8h3c",
    contract: "0x0000000000000000000000000000000000000000",
    wrappedAddress: "0x4200000000000000000000000000000000000006",
    chainId: 10,
    wChainId: 24,
    decimals: 18,
    logoURI: "https://statics.mayan.finance/eth.png",
    coingeckoId: "weth",
    realOriginContractAddress: "0x4200000000000000000000000000000000000006",
    realOriginChainId: 24,
    supportsPermit: !1
  },
  {
    name: "WETH",
    symbol: "WETH",
    mint: "8M6d63oL7dvMZ1gNbgGe3h8afMSWJEKEhtPTFM2u8h3c",
    contract: "0x4200000000000000000000000000000000000006",
    chainId: 10,
    wChainId: 24,
    decimals: 18,
    logoURI: "https://assets.coingecko.com/coins/images/2518/small/weth.png?1696503332",
    coingeckoId: "weth",
    realOriginContractAddress: "0x4200000000000000000000000000000000000006",
    realOriginChainId: 24,
    supportsPermit: !1
  },
  {
    name: "USDC",
    symbol: "USDC",
    mint: "J8kcD4Wnd1ehne1dpL8WNtgZQR6Jpui2cTZcrmg5ybAa",
    contract: "0x0b2c639c533813f4aa9d7837caf62653d097ff85",
    chainId: 10,
    wChainId: 24,
    decimals: 6,
    logoURI: "https://assets.coingecko.com/coins/images/6319/small/usdc.png?1696506694",
    coingeckoId: "usd-coin",
    realOriginContractAddress: "0x0b2c639c533813f4aa9d7837caf62653d097ff85",
    realOriginChainId: 24,
    supportsPermit: !0
  },
  {
    name: "Bridged USDC (Optimism)",
    symbol: "USDC.E",
    mint: "D6YyAUMTJipLQfUhYs6psdnwpmMz6KbM4Qs9AtCmPpxR",
    contract: "0x7f5c764cbc14f9669b88837ca1490cca17c31607",
    chainId: 10,
    wChainId: 24,
    decimals: 6,
    logoURI: "https://assets.coingecko.com/coins/images/31580/small/USDC-icon.png?1696530397",
    coingeckoId: "bridged-usd-coin-optimism",
    realOriginContractAddress: "0x7f5c764cbc14f9669b88837ca1490cca17c31607",
    realOriginChainId: 24,
    supportsPermit: !1
  },
  {
    name: "USDC (Portal from Polygon)",
    symbol: "USDC",
    mint: "C321jHPwWBzgfSGndosDTp5pBsiXPyMU1irxKLVcedRB",
    contract: "0xbB1EaB9Eb8fDf65F0E291D013DA07B4b65a27a01",
    chainId: 10,
    wChainId: 24,
    decimals: 6,
    logoURI: "https://assets.coingecko.com/coins/images/6319/small/usdc.png?1696506694",
    coingeckoId: "usd-coin",
    realOriginContractAddress: "0x3c499c542cef5e3811e1192ce70d8cc03d5c3359",
    realOriginChainId: 5,
    supportsPermit: !0
  },
  {
    name: "Tether",
    symbol: "USDT",
    mint: "CLV6gB88nQtnuo3akGLSVRFaiFPTXaBXV4EDaFxV7iRq",
    contract: "0x94b008aa00579c1307b0ef2c499ad98a8ce58e58",
    chainId: 10,
    wChainId: 24,
    decimals: 6,
    logoURI: "https://assets.coingecko.com/coins/images/325/small/Tether.png?1696501661",
    coingeckoId: "tether",
    realOriginContractAddress: "0x94b008aa00579c1307b0ef2c499ad98a8ce58e58",
    realOriginChainId: 24,
    supportsPermit: !1
  },
  {
    name: "Wrapped Bitcoin (Portal from Ethereum)",
    symbol: "WBTC",
    mint: "3NZ9JMVBmGAqocybic2c7LQCJScmgsAZ6vQqTDzcqmJh",
    contract: "0xB214C19d81c99E75e84706a3aa0A757319023e26",
    chainId: 10,
    wChainId: 24,
    decimals: 8,
    logoURI: "https://assets.coingecko.com/coins/images/7598/small/wrapped_bitcoin_wbtc.png?1696507857",
    coingeckoId: "wrapped-bitcoin",
    realOriginContractAddress: "0x2260fac5e5542a773aa44fbcfedf7c193bc2c599",
    realOriginChainId: 2,
    supportsPermit: !0
  },
  {
    name: "Binance-Peg BUSD (Portal from BSC)",
    symbol: "BUSD",
    mint: "5RpUwQ8wtdPCZHhu6MERp2RGrpobsbZ6MH5dDHkUjs2",
    contract: "0x778A91d18e78f5e1E35D23910B54Dd42559AFEA1",
    chainId: 10,
    wChainId: 24,
    decimals: 18,
    logoURI: "https://assets.coingecko.com/coins/images/31273/small/new_binance-peg-busd.png?1696530096",
    coingeckoId: "binance-peg-busd",
    realOriginContractAddress: "0xe9e7cea3dedca5984780bafc599bd69add087d56",
    realOriginChainId: 4,
    supportsPermit: !0
  },
  {
    name: "Tether (Portal from Polygon)",
    symbol: "USDT",
    mint: "5goWRao6a3yNC4d6UjMdQxonkCMvKBwdpubU3qhfcdf1",
    contract: "0x71502667a00334dEE00c5bA34A07f7FeFF03832d",
    chainId: 10,
    wChainId: 24,
    decimals: 6,
    logoURI: "https://assets.coingecko.com/coins/images/325/small/Tether.png?1696501661",
    coingeckoId: "tether",
    realOriginContractAddress: "0xc2132d05d31c914a87c6611c10748aeb04b58e8f",
    realOriginChainId: 5,
    supportsPermit: !0
  },
  {
    name: "Tether (Portal from BSC)",
    symbol: "USDT",
    mint: "8qJSyQprMC57TWKaYEmetUR3UUiTP2M3hXdcvFhkZdmv",
    contract: "0xa9A78f45944372cc51B7aEF0C2F6817C9729A21D",
    chainId: 10,
    wChainId: 24,
    decimals: 18,
    logoURI: "https://assets.coingecko.com/coins/images/325/small/Tether.png?1696501661",
    coingeckoId: "tether",
    realOriginContractAddress: "0x55d398326f99059ff775485246999027b3197955",
    realOriginChainId: 4,
    supportsPermit: !0
  },
  {
    name: "Tether (Portal from Ethereum)",
    symbol: "USDT",
    mint: "Dn4noZ5jgGfkntzcQSUZ8czkreiZ1ForXYoV2H8Dm7S1",
    contract: "0xf6B4185FCf8aF291c0E3927fbEab7046b4f6A8CA",
    chainId: 10,
    wChainId: 24,
    decimals: 6,
    logoURI: "https://assets.coingecko.com/coins/images/325/small/Tether.png?1696501661",
    coingeckoId: "tether",
    realOriginContractAddress: "0xdac17f958d2ee523a2206206994597c13d831ec7",
    realOriginChainId: 2,
    supportsPermit: !0
  },
  {
    name: "Bridged USDC (Polygon PoS Bridge) (Portal from Polygon)",
    symbol: "USDC.E",
    mint: "E2VmbootbVCBkMNNxKQgCLMS1X3NoGMaYAsufaAsf7M",
    contract: "0x8ab72605E48C1f70A20BdD2B3A217FEc24d777f9",
    chainId: 10,
    wChainId: 24,
    decimals: 6,
    logoURI: "https://assets.coingecko.com/coins/images/33000/small/usdc.png?1700119918",
    coingeckoId: "bridged-usdc-polygon-pos-bridge",
    realOriginContractAddress: "0x2791bca1f2de4661ed88a30c99a7a9449aa84174",
    realOriginChainId: 5,
    supportsPermit: !0
  },
  {
    name: "USDC (Portal from Ethereum)",
    symbol: "USDC",
    mint: "A9mUU4qviSctJVPJdBJWkb28deg915LYJKrzQ19ji3FM",
    contract: "0x711e53D031ea9B0bb0C24dD506df11b41AEA419e",
    chainId: 10,
    wChainId: 24,
    decimals: 6,
    logoURI: "https://assets.coingecko.com/coins/images/6319/small/usdc.png?1696506694",
    coingeckoId: "usd-coin",
    realOriginContractAddress: "0xa0b86991c6218b36c1d19d4a2e9eb0ce3606eb48",
    realOriginChainId: 2,
    supportsPermit: !0
  },
  {
    name: "Wrapped BNB (Portal from BSC)",
    symbol: "WBNB",
    mint: "9gP2kCy3wA1ctvYWQk75guqXuHfrEomqydHLtcTCqiLa",
    contract: "0x6A09fE65ACa27C12573F04aAFa290bD75497E1BC",
    chainId: 10,
    wChainId: 24,
    decimals: 18,
    logoURI: "https://assets.coingecko.com/coins/images/12591/small/binance-coin-logo.png?1696512401",
    coingeckoId: "wbnb",
    realOriginContractAddress: "0xbb4cdb9cbd36b01bd1cbaebf2de08d9173bc095c",
    realOriginChainId: 4,
    supportsPermit: !0
  },
  {
    name: "WETH (Portal from Ethereum)",
    symbol: "WETH",
    mint: "7vfCXTUXx5WJV5JADk17DUJ4ksgau7utNKj4b963voxs",
    contract: "0xb47bC3ed6D70F04fe759b2529c9bc7377889678f",
    chainId: 10,
    wChainId: 24,
    decimals: 18,
    logoURI: "https://assets.coingecko.com/coins/images/2518/small/weth.png?1696503332",
    coingeckoId: "weth",
    realOriginContractAddress: "0xc02aaa39b223fe8d0a0e5c4f27ead9083c756cc2",
    realOriginChainId: 2,
    supportsPermit: !0
  },
  {
    name: "Wrapped Matic (Portal from Polygon)",
    symbol: "WMATIC",
    mint: "Gz7VkD4MacbEB6yC5XD3HcumEiYx2EtDYYrfikGsvopG",
    contract: "0x8f02B6a32cebcAe44D2Fd17d87966f5B5dD14c6d",
    chainId: 10,
    wChainId: 24,
    decimals: 18,
    logoURI: "https://assets.coingecko.com/coins/images/14073/small/matic.png?1696513797",
    coingeckoId: "wmatic",
    realOriginContractAddress: "0x0d500b1d8e8ef31e21c99d1db9a6444d3adf1270",
    realOriginChainId: 5,
    supportsPermit: !0
  },
  {
    name: "Wrapped AVAX (Portal from Avalanche)",
    symbol: "WAVAX",
    mint: "KgV1GvrHQmRBY8sHQQeUKwTm2r2h8t4C8qt12Cw1HVE",
    contract: "0x8418C1d909842f458c9394886b83F19d62bF1A0D",
    chainId: 10,
    wChainId: 24,
    decimals: 18,
    logoURI: "https://assets.coingecko.com/coins/images/15075/small/wrapped-avax.png?1696514734",
    coingeckoId: "wrapped-avax",
    realOriginContractAddress: "0xb31f66aa3c1e785363f0875a1b74e27b85fd66c7",
    realOriginChainId: 6,
    supportsPermit: !0
  }
], avalanche = [
  {
    name: "Avax",
    symbol: "AVAX",
    mint: "KgV1GvrHQmRBY8sHQQeUKwTm2r2h8t4C8qt12Cw1HVE",
    contract: "0x0000000000000000000000000000000000000000",
    chainId: 43114,
    wChainId: 6,
    decimals: 18,
    logoURI: "https://statics.mayan.finance/avax.png",
    wrappedAddress: "0xb31f66aa3c1e785363f0875a1b74e27b85fd66c7",
    coingeckoId: "wrapped-avax",
    realOriginContractAddress: "0xb31f66aa3c1e785363f0875a1b74e27b85fd66c7",
    realOriginChainId: 6,
    supportsPermit: !1
  },
  {
    name: "USD Coin",
    symbol: "USDC",
    mint: "FHfba3ov5P3RjaiLVgh8FTv4oirxQDoVXuoUUDvHuXax",
    contract: "0xb97ef9ef8734c71904d8002f8b6bc66dd9c48a6e",
    chainId: 43114,
    wChainId: 6,
    decimals: 6,
    logoURI: "https://assets.coingecko.com/coins/images/6319/small/USD_Coin_icon.png?1547042389",
    coingeckoId: "usd-coin",
    realOriginContractAddress: "0xb97ef9ef8734c71904d8002f8b6bc66dd9c48a6e",
    realOriginChainId: 6,
    supportsPermit: !0
  },
  {
    name: "Tether",
    symbol: "USDT",
    mint: "Kz1csQA91WUGcQ2TB3o5kdGmWmMGp8eJcDEyHzNDVCX",
    contract: "0x9702230a8ea53601f5cd2dc00fdbc13d4df4a8c7",
    chainId: 43114,
    wChainId: 6,
    decimals: 6,
    logoURI: "https://assets.coingecko.com/coins/images/325/small/Tether.png?1668148663",
    coingeckoId: "tether",
    realOriginContractAddress: "0x9702230a8ea53601f5cd2dc00fdbc13d4df4a8c7",
    realOriginChainId: 6,
    supportsPermit: !0
  },
  {
    name: "Tether (Portal from Arbitrum)",
    symbol: "USDT",
    mint: "H9o3LaDfoMSVLm9aBWaY56eMmPGDbRFnUHpqcTb9exXB",
    contract: "0x3e2eE3C3C93408ab00f30BE6462E532aAfCC574d",
    chainId: 43114,
    wChainId: 6,
    decimals: 6,
    logoURI: "https://assets.coingecko.com/coins/images/325/small/Tether.png?1668148663",
    coingeckoId: "tether",
    realOriginContractAddress: "0xfd086bc7cd5c481dcc9c85ebe478a1c0b69fcbb9",
    realOriginChainId: 23,
    supportsPermit: !0
  },
  {
    name: "USD Coin (Arb1)(Portal from Arbitrum)",
    symbol: "USDC.e",
    mint: "HAxCJjnmgkdXhwZYeJiUvBgm4NdQvqhGJCS3KxCnCxWs",
    contract: "0xa2BA71dbDb6aD2add0329b892135DCe49c5ABb02",
    chainId: 43114,
    wChainId: 6,
    decimals: 6,
    logoURI: "https://assets.coingecko.com/coins/images/6319/small/USD_Coin_icon.png?1547042389",
    coingeckoId: "usd-coin",
    realOriginContractAddress: "0xff970a61a04b1ca14834a43f5de4533ebddb5cc8",
    realOriginChainId: 23,
    supportsPermit: !0
  },
  {
    name: "USD Coin (Portal from BSC)",
    symbol: "USDC",
    mint: "FCqfQSujuPxy6V42UvafBhsysWtEq1vhjfMN1PUbgaxA",
    contract: "0x6145E8a910aE937913426BF32De2b26039728ACF",
    chainId: 43114,
    wChainId: 6,
    decimals: 18,
    logoURI: "https://assets.coingecko.com/coins/images/6319/small/USD_Coin_icon.png?1547042389",
    coingeckoId: "usd-coin",
    realOriginContractAddress: "0x8ac76a51cc950d9822d68b83fe1ad97b32cd580d",
    realOriginChainId: 4,
    supportsPermit: !0
  },
  {
    name: "Dai (Portal from Ethereum)",
    symbol: "DAI",
    mint: "EjmyN6qEC1Tf1JxiG1ae7UTJhUxSwk1TCWNWqxWV4J6o",
    contract: "0xca319f81D147559e19A522A0a0310Dd43A96cA0F",
    chainId: 43114,
    wChainId: 6,
    decimals: 18,
    logoURI: "https://assets.coingecko.com/coins/images/9956/small/4943.png?1636636734",
    coingeckoId: "dai",
    realOriginContractAddress: "0x6b175474e89094c44da98b954eedeac495271d0f",
    realOriginChainId: 2,
    supportsPermit: !1
  },
  {
    name: "Audius (Portal from Ethereum)",
    symbol: "AUDIO",
    mint: "9LzCMqDgTKYz9Drzqnpgee3SGa89up3a247ypMj2xrqM",
    contract: "0x4890198d3354E340d724607e7d4cdC3696185267",
    chainId: 43114,
    wChainId: 6,
    decimals: 18,
    logoURI: "https://assets.coingecko.com/coins/images/12913/small/AudiusCoinLogo_2x.png?1603425727",
    coingeckoId: "audius",
    realOriginContractAddress: "0x18aaa7115705e8be94bffebde57af9bfc265b998",
    realOriginChainId: 2,
    supportsPermit: !0
  },
  {
    name: "Binance USD (Portal from BSC)",
    symbol: "BUSD",
    mint: "5RpUwQ8wtdPCZHhu6MERp2RGrpobsbZ6MH5dDHkUjs2",
    contract: "0xA41a6c7E25DdD361343e8Cb8cFa579bbE5eEdb7a",
    chainId: 43114,
    wChainId: 6,
    decimals: 18,
    logoURI: "https://assets.coingecko.com/coins/images/9576/small/BUSD.png?1568947766",
    coingeckoId: "binance-usd",
    realOriginContractAddress: "0xe9e7cea3dedca5984780bafc599bd69add087d56",
    realOriginChainId: 4,
    supportsPermit: !0
  },
  {
    name: "Brazilian Digital (Portal from solana)",
    symbol: "BRZ",
    mint: "FtgGSFADXBtroxq8VCausXRr2of47QBf5AS1NtZCu4GD",
    contract: "0xeed8377eC9522Cc58Da6Df1Ad6b4E4cC8A4C90dD",
    chainId: 43114,
    wChainId: 6,
    decimals: 4,
    logoURI: "https://assets.coingecko.com/coins/images/8472/small/2_vtiD3xwce9knG2COxtSMaQ.png?1597786961",
    coingeckoId: "brz",
    realOriginContractAddress: "FtgGSFADXBtroxq8VCausXRr2of47QBf5AS1NtZCu4GD",
    realOriginChainId: 1,
    supportsPermit: !0
  },
  {
    name: "Chainlink (Portal from Ethereum)",
    symbol: "LINK",
    mint: "2wpTofQ8SkACrkZWrZDjXPitYa8AwWgX8AfxdeBRRVLX",
    contract: "0x20F8AC126d35c1D74281F2b95887277747b325e1",
    chainId: 43114,
    wChainId: 6,
    decimals: 18,
    logoURI: "https://assets.coingecko.com/coins/images/877/small/chainlink-new-logo.png?1547034700",
    coingeckoId: "chainlink",
    realOriginContractAddress: "0x514910771af9ca656af840dff83e8264ecf986ca",
    realOriginChainId: 2,
    supportsPermit: !0
  },
  {
    name: "Frax (Portal from Ethereum)",
    symbol: "FRAX",
    mint: "FR87nWEUxVgerFGhZM8Y4AggKGLnaXswr1Pd8wZ4kZcp",
    contract: "0x928702a5f31dA622e5Cbadb33D3d8cED67cDCf93",
    chainId: 43114,
    wChainId: 6,
    decimals: 18,
    logoURI: "https://assets.coingecko.com/coins/images/13422/small/ethCanonicalFRAX.png?1669277108",
    coingeckoId: "frax",
    realOriginContractAddress: "0x853d955acef822db058eb8505911ed77f175b99e",
    realOriginChainId: 2,
    supportsPermit: !0
  },
  {
    name: "Kin (Portal from solana)",
    symbol: "KIN",
    mint: "kinXdEcpDQeHPEuQnqmUgtYykqKGVFq6CeVX5iAHJq6",
    contract: "0x2E9d44DB98ACF5D5B48D3E5925C0D43a4addfb61",
    chainId: 43114,
    wChainId: 6,
    decimals: 5,
    logoURI: "https://assets.coingecko.com/coins/images/959/small/kin.png?1586917032",
    coingeckoId: "kin",
    realOriginContractAddress: "kinXdEcpDQeHPEuQnqmUgtYykqKGVFq6CeVX5iAHJq6",
    realOriginChainId: 1,
    supportsPermit: !0
  },
  {
    name: "Parrot USD (Portal from solana)",
    symbol: "PAI",
    mint: "Ea5SjE2Y6yvCeW5dYTn7PYMuW5ikXkvbGdcmSnXeaLjS",
    contract: "0x2BB1f8d5c5409621ef14Ee2e892bB230F46B1fF1",
    chainId: 43114,
    wChainId: 6,
    decimals: 6,
    logoURI: "https://assets.coingecko.com/coins/images/18439/small/pai.png?1632004568",
    coingeckoId: "parrot-usd",
    realOriginContractAddress: "Ea5SjE2Y6yvCeW5dYTn7PYMuW5ikXkvbGdcmSnXeaLjS",
    realOriginChainId: 1,
    supportsPermit: !0
  },
  {
    name: "Plutonian DAO (Portal from solana)",
    symbol: "PLD",
    mint: "2cJgFtnqjaoiu9fKVX3fny4Z4pRzuaqfJ3PBTMk2D9ur",
    contract: "0x92FAD76974C631987e33B281543299e11e64bF98",
    chainId: 43114,
    wChainId: 6,
    decimals: 6,
    logoURI: "https://assets.coingecko.com/coins/images/25092/small/logo-pld_200.png?1650270204",
    coingeckoId: "plutonian-dao",
    realOriginContractAddress: "2cJgFtnqjaoiu9fKVX3fny4Z4pRzuaqfJ3PBTMk2D9ur",
    realOriginChainId: 1,
    supportsPermit: !0
  },
  {
    name: "Raydium (Portal from solana)",
    symbol: "RAY",
    mint: "4k3Dyjzvzp8eMZWUXbBCjEvwSkkk59S5iCNLY3QrkX6R",
    contract: "0xEF0a164F3cDCb295A136BFC1EA50f1e0B0e135ef",
    chainId: 43114,
    wChainId: 6,
    decimals: 6,
    logoURI: "https://assets.coingecko.com/coins/images/13928/small/PSigc4ie_400x400.jpg?1612875614",
    coingeckoId: "raydium",
    realOriginContractAddress: "4k3Dyjzvzp8eMZWUXbBCjEvwSkkk59S5iCNLY3QrkX6R",
    realOriginChainId: 1,
    supportsPermit: !0
  },
  {
    name: "Tulip Protocol (Portal from solana)",
    symbol: "TULIP",
    mint: "TuLipcqtGVXP9XR62wM8WWCm6a9vhLs7T1uoWBk6FDs",
    contract: "0x9E99aA3cA421CEADC08dA268795a46E3e88dB4DB",
    chainId: 43114,
    wChainId: 6,
    decimals: 6,
    logoURI: "https://assets.coingecko.com/coins/images/15764/small/TqrUdBG.png?1621827144",
    coingeckoId: "solfarm",
    realOriginContractAddress: "TuLipcqtGVXP9XR62wM8WWCm6a9vhLs7T1uoWBk6FDs",
    realOriginChainId: 1,
    supportsPermit: !0
  },
  {
    name: "SolRazr (Portal from solana)",
    symbol: "SOLR",
    mint: "7j7H7sgsnNDeCngAPjpaCN4aaaru4HS7NAFYSEUyzJ3k",
    contract: "0x7127034A6e7e2BD688a9106F508078A3d571d7FB",
    chainId: 43114,
    wChainId: 6,
    decimals: 6,
    logoURI: "https://assets.coingecko.com/coins/images/18390/small/Sol-Razr-Logo-TICKER.png?1631759669",
    coingeckoId: "solrazr",
    realOriginContractAddress: "7j7H7sgsnNDeCngAPjpaCN4aaaru4HS7NAFYSEUyzJ3k",
    realOriginChainId: 1,
    supportsPermit: !0
  },
  {
    name: "Sunny Aggregator (Portal from solana)",
    symbol: "SUNNY",
    mint: "SUNNYWgPQmFxe9wTZzNK7iPnJ3vYDrkgnxJRJm1s3ag",
    contract: "0x5bd40bC6967B81c6bcF40BB587489BF375C00B83",
    chainId: 43114,
    wChainId: 6,
    decimals: 6,
    logoURI: "https://assets.coingecko.com/coins/images/18039/small/90dbe787-8e5f-473c-b923-fe138a7a30ea.png?1630314924",
    coingeckoId: "sunny-aggregator",
    realOriginContractAddress: "SUNNYWgPQmFxe9wTZzNK7iPnJ3vYDrkgnxJRJm1s3ag",
    realOriginChainId: 1,
    supportsPermit: !0
  },
  {
    name: "Synthetic USD (Portal from solana)",
    symbol: "XUSD",
    mint: "83LGLCm7QKpYZbX8q4W2kYWbtt8NJBwbVwEepzkVnJ9y",
    contract: "0xe04a932836C8d06A1dF869722C59Dac223721b18",
    chainId: 43114,
    wChainId: 6,
    decimals: 6,
    logoURI: "https://assets.coingecko.com/coins/images/19596/small/uJzDI4j.png?1635488810",
    coingeckoId: "synthetic-usd",
    realOriginContractAddress: "83LGLCm7QKpYZbX8q4W2kYWbtt8NJBwbVwEepzkVnJ9y",
    realOriginChainId: 1,
    supportsPermit: !0
  },
  {
    name: "Tether (Portal from Polygon)",
    symbol: "USDT",
    mint: "5goWRao6a3yNC4d6UjMdQxonkCMvKBwdpubU3qhfcdf1",
    contract: "0x038627d23Dacdc967087A57309F8139aeb99D8e4",
    chainId: 43114,
    wChainId: 6,
    decimals: 6,
    logoURI: "https://assets.coingecko.com/coins/images/325/small/Tether.png?1668148663",
    coingeckoId: "tether",
    realOriginContractAddress: "0xc2132d05d31c914a87c6611c10748aeb04b58e8f",
    realOriginChainId: 5,
    supportsPermit: !0
  },
  {
    name: "Tether (Portal from BSC)",
    symbol: "USDT",
    mint: "8qJSyQprMC57TWKaYEmetUR3UUiTP2M3hXdcvFhkZdmv",
    contract: "0xA67BCC0D06d7d13A13A2AE30bF30f1B434f5a28B",
    chainId: 43114,
    wChainId: 6,
    decimals: 18,
    logoURI: "https://assets.coingecko.com/coins/images/325/small/Tether-logo.png?1598003707",
    coingeckoId: "tether",
    realOriginContractAddress: "0x55d398326f99059ff775485246999027b3197955",
    realOriginChainId: 4,
    supportsPermit: !0
  },
  {
    name: "Tether (Portal from Ethereum)",
    symbol: "USDT",
    mint: "Dn4noZ5jgGfkntzcQSUZ8czkreiZ1ForXYoV2H8Dm7S1",
    contract: "0x9d228444FC4B7E15A2C481b48E10247A03351FD8",
    chainId: 43114,
    wChainId: 6,
    decimals: 6,
    logoURI: "https://assets.coingecko.com/coins/images/325/small/Tether-logo.png?1598003707",
    coingeckoId: "tether",
    realOriginContractAddress: "0xdac17f958d2ee523a2206206994597c13d831ec7",
    realOriginChainId: 2,
    supportsPermit: !0
  },
  {
    name: "Tether (Portal from solana)",
    symbol: "USDT",
    mint: "Es9vMFrzaCERmJfrF4H2FYD4KCoNkY11McCe8BenwNYB",
    contract: "0xF0FF231e3F1A50F83136717f287ADAB862f89431",
    chainId: 43114,
    wChainId: 6,
    decimals: 6,
    logoURI: "https://assets.coingecko.com/coins/images/325/small/Tether-logo.png?1598003707",
    coingeckoId: "tether",
    realOriginContractAddress: "Es9vMFrzaCERmJfrF4H2FYD4KCoNkY11McCe8BenwNYB",
    realOriginChainId: 1,
    supportsPermit: !0
  },
  {
    name: "Bridged USDC (Portal from Polygon)",
    symbol: "USDC.e",
    mint: "E2VmbootbVCBkMNNxKQgCLMS1X3NoGMaYAsufaAsf7M",
    contract: "0x543672E9CBEC728CBBa9C3Ccd99ed80aC3607FA8",
    chainId: 43114,
    wChainId: 6,
    decimals: 6,
    logoURI: "https://assets.coingecko.com/coins/images/6319/small/USD_Coin_icon.png?1547042389",
    coingeckoId: "usd-coin",
    realOriginContractAddress: "0x2791bca1f2de4661ed88a30c99a7a9449aa84174",
    realOriginChainId: 5,
    supportsPermit: !0
  },
  {
    name: "USD Coin (Portal from Ethereum)",
    symbol: "USDC",
    mint: "A9mUU4qviSctJVPJdBJWkb28deg915LYJKrzQ19ji3FM",
    contract: "0xB24CA28D4e2742907115fECda335b40dbda07a4C",
    chainId: 43114,
    wChainId: 6,
    decimals: 6,
    logoURI: "https://assets.coingecko.com/coins/images/6319/small/USD_Coin_icon.png?1547042389",
    coingeckoId: "usd-coin",
    realOriginContractAddress: "0xa0b86991c6218b36c1d19d4a2e9eb0ce3606eb48",
    realOriginChainId: 2,
    supportsPermit: !0
  },
  {
    name: "USD Coin (Portal from solana)",
    symbol: "USDC",
    mint: "EPjFWdd5AufqSSqeM2qN1xzybapC8G4wEGGkZwyTDt1v",
    contract: "0x0950Fc1AD509358dAeaD5eB8020a3c7d8b43b9DA",
    chainId: 43114,
    wChainId: 6,
    decimals: 6,
    logoURI: "https://assets.coingecko.com/coins/images/6319/small/USD_Coin_icon.png?1547042389",
    coingeckoId: "usd-coin",
    realOriginContractAddress: "EPjFWdd5AufqSSqeM2qN1xzybapC8G4wEGGkZwyTDt1v",
    realOriginChainId: 1,
    supportsPermit: !0
  },
  {
    name: "Wrapped BNB (Portal from BSC)",
    symbol: "WBNB",
    mint: "9gP2kCy3wA1ctvYWQk75guqXuHfrEomqydHLtcTCqiLa",
    contract: "0x442F7f22b1EE2c842bEAFf52880d4573E9201158",
    chainId: 43114,
    wChainId: 6,
    decimals: 18,
    logoURI: "https://assets.coingecko.com/coins/images/12591/small/binance-coin-logo.png?1600947313",
    coingeckoId: "wbnb",
    realOriginContractAddress: "0xbb4cdb9cbd36b01bd1cbaebf2de08d9173bc095c",
    realOriginChainId: 4,
    supportsPermit: !0
  },
  {
    name: "WETH (Portal from Ethereum)",
    symbol: "WETH",
    mint: "7vfCXTUXx5WJV5JADk17DUJ4ksgau7utNKj4b963voxs",
    contract: "0x8b82A291F83ca07Af22120ABa21632088fC92931",
    chainId: 43114,
    wChainId: 6,
    decimals: 18,
    logoURI: "https://assets.coingecko.com/coins/images/2518/small/weth.png?1628852295",
    coingeckoId: "weth",
    realOriginContractAddress: "0xc02aaa39b223fe8d0a0e5c4f27ead9083c756cc2",
    realOriginChainId: 2,
    supportsPermit: !0
  },
  {
    name: "Wrapped Matic (Portal from Polygon)",
    symbol: "WMATIC",
    mint: "Gz7VkD4MacbEB6yC5XD3HcumEiYx2EtDYYrfikGsvopG",
    contract: "0xf2f13f0B7008ab2FA4A2418F4ccC3684E49D20Eb",
    chainId: 43114,
    wChainId: 6,
    decimals: 18,
    logoURI: "https://assets.coingecko.com/coins/images/14073/small/matic.png?1628852392",
    coingeckoId: "wmatic",
    realOriginContractAddress: "0x0d500b1d8e8ef31e21c99d1db9a6444d3adf1270",
    realOriginChainId: 5,
    supportsPermit: !0
  },
  {
    name: "Wrapped AVAX",
    symbol: "WAVAX",
    mint: "KgV1GvrHQmRBY8sHQQeUKwTm2r2h8t4C8qt12Cw1HVE",
    contract: "0xb31f66aa3c1e785363f0875a1b74e27b85fd66c7",
    chainId: 43114,
    wChainId: 6,
    decimals: 18,
    logoURI: "https://assets.coingecko.com/coins/images/15075/small/wrapped-avax.png?1629873618",
    coingeckoId: "wrapped-avax",
    realOriginContractAddress: "0xb31f66aa3c1e785363f0875a1b74e27b85fd66c7",
    realOriginChainId: 6,
    supportsPermit: !1
  },
  {
    name: "Wrapped Bitcoin (Sollet) (Portal from solana)",
    symbol: "SOBTC",
    mint: "9n4nbM75f5Ui33ZbPYXn59EwSgE8CGsHtAeTH5YFeJ9E",
    contract: "0x546AB8d4320B94a763B33817a4A775F7514015f1",
    chainId: 43114,
    wChainId: 6,
    decimals: 6,
    logoURI: "https://assets.coingecko.com/coins/images/24917/small/opengraph.png?1649344256",
    coingeckoId: "wrapped-bitcoin-sollet",
    realOriginContractAddress: "9n4nbM75f5Ui33ZbPYXn59EwSgE8CGsHtAeTH5YFeJ9E",
    realOriginChainId: 1,
    supportsPermit: !0
  },
  {
    name: "Wrapped Solana (Portal from solana)",
    symbol: "wSOL",
    mint: "So11111111111111111111111111111111111111112",
    contract: "0xFE6B19286885a4F7F55AdAD09C3Cd1f906D2478F",
    chainId: 43114,
    wChainId: 6,
    decimals: 9,
    logoURI: "https://assets.coingecko.com/coins/images/21629/small/solana.jpg?1639626543",
    coingeckoId: "wrapped-solana",
    realOriginContractAddress: "So11111111111111111111111111111111111111112",
    realOriginChainId: 1,
    supportsPermit: !0
  },
  {
    name: "Wrapped YFI (Sollet) (Portal from solana)",
    symbol: "SOYFI",
    mint: "3JSf5tPeuscJGtaCp5giEiDhv51gQ4v3zWg8DGgyLfAB",
    contract: "0x6D41228a484d8523C4F3210B8F976C4034B550F8",
    chainId: 43114,
    wChainId: 6,
    decimals: 6,
    logoURI: "https://assets.coingecko.com/coins/images/24704/small/yl4nOJno_400x400.jpg?1648646042",
    coingeckoId: "wrapped-yfi-sollet",
    realOriginContractAddress: "3JSf5tPeuscJGtaCp5giEiDhv51gQ4v3zWg8DGgyLfAB",
    realOriginChainId: 1,
    supportsPermit: !0
  },
  {
    name: "xHashtag (Portal from solana)",
    symbol: "XTAG",
    mint: "5gs8nf4wojB5EXgDUWNLwXpknzgV2YWDhveAeBZpVLbp",
    contract: "0xA608D79C5f695C0D4C0E773A4938b57e18e0fc57",
    chainId: 43114,
    wChainId: 6,
    decimals: 6,
    logoURI: "https://assets.coingecko.com/coins/images/20912/small/xtag.png?1637922382",
    coingeckoId: "xhashtag",
    realOriginContractAddress: "5gs8nf4wojB5EXgDUWNLwXpknzgV2YWDhveAeBZpVLbp",
    realOriginChainId: 1,
    supportsPermit: !0
  },
  {
    name: "Basket (Portal from Solana)",
    symbol: "BSKT",
    mint: "6gnCPhXtLnUD76HjQuSYPENLSZdG8RvDB1pTLM5aLSJA",
    contract: "0x6Ac048ae05E7E015accA2aA7Abd0Ec013e8E3a59",
    chainId: 43114,
    wChainId: 6,
    decimals: 5,
    logoURI: "https://assets.coingecko.com/coins/images/34661/small/BSKT_Logo.png?1705636891",
    coingeckoId: "basket",
    realOriginContractAddress: "6gnCPhXtLnUD76HjQuSYPENLSZdG8RvDB1pTLM5aLSJA",
    realOriginChainId: 1,
    supportsPermit: !0
  },
  {
    name: "WETH (Portal from Optimism)",
    symbol: "WETH",
    mint: "8M6d63oL7dvMZ1gNbgGe3h8afMSWJEKEhtPTFM2u8h3c",
    contract: "0xDf11535274c0FD2Fe41A88bd1bBF802D72296037",
    chainId: 43114,
    wChainId: 6,
    decimals: 18,
    logoURI: "https://assets.coingecko.com/coins/images/2518/small/weth.png?1696503332",
    coingeckoId: "weth",
    realOriginContractAddress: "0x4200000000000000000000000000000000000006",
    realOriginChainId: 24,
    supportsPermit: !0
  },
  {
    name: "USDC (Portal from Optimism)",
    symbol: "USDC",
    mint: "J8kcD4Wnd1ehne1dpL8WNtgZQR6Jpui2cTZcrmg5ybAa",
    contract: "0xBe04f76A0ba2100c3F2d6Aa1FD8484F415469573",
    chainId: 43114,
    wChainId: 6,
    decimals: 6,
    logoURI: "https://assets.coingecko.com/coins/images/6319/small/usdc.png?1696506694",
    coingeckoId: "usd-coin",
    realOriginContractAddress: "0x0b2c639c533813f4aa9d7837caf62653d097ff85",
    realOriginChainId: 24,
    supportsPermit: !0
  },
  {
    name: "Bridged USDC (Optimism) (Portal from Optimism)",
    symbol: "USDC.E",
    mint: "D6YyAUMTJipLQfUhYs6psdnwpmMz6KbM4Qs9AtCmPpxR",
    contract: "0x7b9313E7C3794820376F1a4F2549CC964bD17123",
    chainId: 43114,
    wChainId: 6,
    decimals: 6,
    logoURI: "https://assets.coingecko.com/coins/images/31580/small/USDC-icon.png?1696530397",
    coingeckoId: "bridged-usd-coin-optimism",
    realOriginContractAddress: "0x7f5c764cbc14f9669b88837ca1490cca17c31607",
    realOriginChainId: 24,
    supportsPermit: !0
  },
  {
    name: "Tether (Portal from Optimism)",
    symbol: "USDT",
    mint: "CLV6gB88nQtnuo3akGLSVRFaiFPTXaBXV4EDaFxV7iRq",
    contract: "0x2AE95d92355d1C2aB073FD1F9C69D76f0E557aB4",
    chainId: 43114,
    wChainId: 6,
    decimals: 6,
    logoURI: "https://assets.coingecko.com/coins/images/325/small/Tether.png?1696501661",
    coingeckoId: "tether",
    realOriginContractAddress: "0x94b008aa00579c1307b0ef2c499ad98a8ce58e58",
    realOriginChainId: 24,
    supportsPermit: !0
  }
], bsc = [
  {
    name: "BNB",
    symbol: "BNB",
    mint: "9gP2kCy3wA1ctvYWQk75guqXuHfrEomqydHLtcTCqiLa",
    contract: "0x0000000000000000000000000000000000000000",
    chainId: 56,
    wChainId: 4,
    decimals: 18,
    logoURI: "https://statics.mayan.finance/bsc.png",
    wrappedAddress: "0xbb4cdb9cbd36b01bd1cbaebf2de08d9173bc095c",
    coingeckoId: "wbnb",
    realOriginContractAddress: "0xbb4cdb9cbd36b01bd1cbaebf2de08d9173bc095c",
    realOriginChainId: 4,
    supportsPermit: !1
  },
  {
    name: "Wrapped Bitcoin (Portal from Ethereum)",
    symbol: "WBTC",
    mint: "3NZ9JMVBmGAqocybic2c7LQCJScmgsAZ6vQqTDzcqmJh",
    contract: "0x43359676E1A3F9FbB5de095333f8e9c1B46dFA44",
    chainId: 56,
    wChainId: 4,
    decimals: 8,
    logoURI: "https://assets.coingecko.com/coins/images/7598/small/wrapped_bitcoin_wbtc.png?1548822744",
    coingeckoId: "wrapped-bitcoin",
    realOriginContractAddress: "0x2260fac5e5542a773aa44fbcfedf7c193bc2c599",
    realOriginChainId: 2,
    supportsPermit: !0
  },
  {
    name: "Tether (Portal from Arbitrum)",
    symbol: "USDT",
    mint: "H9o3LaDfoMSVLm9aBWaY56eMmPGDbRFnUHpqcTb9exXB",
    contract: "0xa6E2b045a0BbCfb5b3Eb8253480Cf20325e85784",
    chainId: 56,
    wChainId: 4,
    decimals: 6,
    logoURI: "https://assets.coingecko.com/coins/images/325/small/Tether.png?1668148663",
    coingeckoId: "tether",
    realOriginContractAddress: "0xfd086bc7cd5c481dcc9c85ebe478a1c0b69fcbb9",
    realOriginChainId: 23,
    supportsPermit: !0
  },
  {
    name: "USD Coin (Arb1)(Portal from Arbitrum)",
    symbol: "USDC.e",
    mint: "HAxCJjnmgkdXhwZYeJiUvBgm4NdQvqhGJCS3KxCnCxWs",
    contract: "0x32a266C3ba64Cc5f2A5bC18cC02927Ad23EE7e15",
    chainId: 56,
    wChainId: 4,
    decimals: 6,
    logoURI: "https://assets.coingecko.com/coins/images/6319/small/USD_Coin_icon.png?1547042389",
    coingeckoId: "usd-coin",
    realOriginContractAddress: "0xff970a61a04b1ca14834a43f5de4533ebddb5cc8",
    realOriginChainId: 23,
    supportsPermit: !0
  },
  {
    name: "USD Coin (Portal from Avalanche)",
    symbol: "USDC",
    mint: "FHfba3ov5P3RjaiLVgh8FTv4oirxQDoVXuoUUDvHuXax",
    contract: "0xc88Dc63bf0c8c8198C97Db0945E3eF25Ca89A8e4",
    chainId: 56,
    wChainId: 4,
    decimals: 6,
    logoURI: "https://assets.coingecko.com/coins/images/6319/small/USD_Coin_icon.png?1547042389",
    coingeckoId: "usd-coin",
    realOriginContractAddress: "0xb97ef9ef8734c71904d8002f8b6bc66dd9c48a6e",
    realOriginChainId: 6,
    supportsPermit: !0
  },
  {
    name: "Tether (Portal from Avalanche)",
    symbol: "USDT",
    mint: "Kz1csQA91WUGcQ2TB3o5kdGmWmMGp8eJcDEyHzNDVCX",
    contract: "0x4a618Df8E3e6f2E94D1F9bed94722e43b9fD97D5",
    chainId: 56,
    wChainId: 4,
    decimals: 6,
    logoURI: "https://assets.coingecko.com/coins/images/325/small/Tether.png?1668148663",
    coingeckoId: "tether",
    realOriginContractAddress: "0x9702230a8ea53601f5cd2dc00fdbc13d4df4a8c7",
    realOriginChainId: 6,
    supportsPermit: !0
  },
  {
    name: "USD Coin",
    symbol: "USDC",
    mint: "FCqfQSujuPxy6V42UvafBhsysWtEq1vhjfMN1PUbgaxA",
    contract: "0x8ac76a51cc950d9822d68b83fe1ad97b32cd580d",
    chainId: 56,
    wChainId: 4,
    decimals: 18,
    logoURI: "https://assets.coingecko.com/coins/images/6319/small/USD_Coin_icon.png?1547042389",
    coingeckoId: "usd-coin",
    realOriginContractAddress: "0x8ac76a51cc950d9822d68b83fe1ad97b32cd580d",
    realOriginChainId: 4,
    supportsPermit: !1
  },
  {
    name: "USDC (Portal from Polygon)",
    symbol: "USDC",
    mint: "C321jHPwWBzgfSGndosDTp5pBsiXPyMU1irxKLVcedRB",
    contract: "0xe6d82Bbe75041E42E51d755e922cE1BA91af9c4d",
    chainId: 56,
    wChainId: 4,
    decimals: 6,
    logoURI: "https://assets.coingecko.com/coins/images/6319/small/usdc.png?1696506694",
    coingeckoId: "usd-coin",
    realOriginContractAddress: "0x3c499c542cef5e3811e1192ce70d8cc03d5c3359",
    realOriginChainId: 5,
    supportsPermit: !0
  },
  {
    name: "Dai (Portal from Ethereum)",
    symbol: "DAI",
    mint: "EjmyN6qEC1Tf1JxiG1ae7UTJhUxSwk1TCWNWqxWV4J6o",
    contract: "0x3413a030EF81a3dD5a302F4B4D11d911e12ed337",
    chainId: 56,
    wChainId: 4,
    decimals: 18,
    logoURI: "https://assets.coingecko.com/coins/images/9956/small/4943.png?1636636734",
    coingeckoId: "dai",
    realOriginContractAddress: "0x6b175474e89094c44da98b954eedeac495271d0f",
    realOriginChainId: 2,
    supportsPermit: !1
  },
  {
    name: "Aleph.im (Portal from Ethereum)",
    symbol: "ALEPH",
    mint: "3UCMiSnkcnkPE1pgQ5ggPCBv6dXgVUy16TmMUe1WpG9x",
    contract: "0xfB0c80D4587ecA81C0aA35d56FB19373117df55f",
    chainId: 56,
    wChainId: 4,
    decimals: 18,
    logoURI: "https://assets.coingecko.com/coins/images/11676/small/Monochram-aleph.png?1608483725",
    coingeckoId: "aleph",
    realOriginContractAddress: "0x27702a26126e0b3702af63ee09ac4d1a084ef628",
    realOriginChainId: 2,
    supportsPermit: !0
  },
  {
    name: "Allbridge (Portal from solana)",
    symbol: "ABR",
    mint: "a11bdAAuV8iB2fu7X6AxAvDTo1QZ8FXB3kk5eecdasp",
    contract: "0xc31eb703C224315a8E7ea18ed35484Cd8F30F8e6",
    chainId: 56,
    wChainId: 4,
    decimals: 9,
    logoURI: "https://assets.coingecko.com/coins/images/18690/small/abr.png?1640742053",
    coingeckoId: "allbridge",
    realOriginContractAddress: "a11bdAAuV8iB2fu7X6AxAvDTo1QZ8FXB3kk5eecdasp",
    realOriginChainId: 1,
    supportsPermit: !0
  },
  {
    name: "ApeXit Finance (Portal from solana)",
    symbol: "APEX",
    mint: "51tMb3zBKDiQhNwGqpgwbavaGH54mk8fXFzxTc1xnasg",
    contract: "0x102786121bb14AaA8A768D6dB66BB2a7eba2e999",
    chainId: 56,
    wChainId: 4,
    decimals: 9,
    logoURI: "https://assets.coingecko.com/coins/images/16864/small/cg.png?1625470996",
    coingeckoId: "apexit-finance",
    realOriginContractAddress: "51tMb3zBKDiQhNwGqpgwbavaGH54mk8fXFzxTc1xnasg",
    realOriginChainId: 1,
    supportsPermit: !0
  },
  {
    name: "APYSwap (Portal from solana)",
    symbol: "APYS",
    mint: "5JnZ667P3VcjDinkJFysWh2K2KtViy63FZ3oL5YghEhW",
    contract: "0x5B034dd9CA6f4612df5b45e79b2198BCc3040b52",
    chainId: 56,
    wChainId: 4,
    decimals: 9,
    logoURI: "https://assets.coingecko.com/coins/images/14163/small/apys.png?1635831990",
    coingeckoId: "apyswap",
    realOriginContractAddress: "5JnZ667P3VcjDinkJFysWh2K2KtViy63FZ3oL5YghEhW",
    realOriginChainId: 1,
    supportsPermit: !0
  },
  {
    name: "Arenum (Portal from solana)",
    symbol: "ARNM",
    mint: "3Dy8KFyvpUJ8nfRCbvk4HLWjNRRzxiVhTeE9PQF9RARD",
    contract: "0x5D623999fb9A8FebE7A9B7f2F4Dc87e9445b095B",
    chainId: 56,
    wChainId: 4,
    decimals: 6,
    logoURI: "https://assets.coingecko.com/coins/images/24393/small/6253dcf123d4f40001e9c793_CryptoCoin_1024.png?1649733527",
    coingeckoId: "arenum",
    realOriginContractAddress: "3Dy8KFyvpUJ8nfRCbvk4HLWjNRRzxiVhTeE9PQF9RARD",
    realOriginChainId: 1,
    supportsPermit: !0
  },
  {
    name: "Atlas DEX (Portal from solana)",
    symbol: "ATS",
    mint: "HJbNXx2YMRxgfUJ6K4qeWtjatMK5KYQT1QnsCdDWywNv",
    contract: "0x7F101846d76A786ea8EF3a032d202FBFE524Cce9",
    chainId: 56,
    wChainId: 4,
    decimals: 9,
    logoURI: "https://assets.coingecko.com/coins/images/23002/small/logo.png?1643091340",
    coingeckoId: "atlas-dex",
    realOriginContractAddress: "HJbNXx2YMRxgfUJ6K4qeWtjatMK5KYQT1QnsCdDWywNv",
    realOriginChainId: 1,
    supportsPermit: !0
  },
  {
    name: "Audius (Portal from Ethereum)",
    symbol: "AUDIO",
    mint: "9LzCMqDgTKYz9Drzqnpgee3SGa89up3a247ypMj2xrqM",
    contract: "0x883c8Bc8311467181A67FbA8bBA5e12c016A6c93",
    chainId: 56,
    wChainId: 4,
    decimals: 18,
    logoURI: "https://assets.coingecko.com/coins/images/12913/small/AudiusCoinLogo_2x.png?1603425727",
    coingeckoId: "audius",
    realOriginContractAddress: "0x18aaa7115705e8be94bffebde57af9bfc265b998",
    realOriginChainId: 2,
    supportsPermit: !0
  },
  {
    name: "Aurory (Portal from solana)",
    symbol: "AURY",
    mint: "AURYydfxJib1ZkTir1Jn1J9ECYUtjb6rKQVmtYaixWPP",
    contract: "0xF5a367b7809e5683538C93Ce638B9258A0B88271",
    chainId: 56,
    wChainId: 4,
    decimals: 9,
    logoURI: "https://assets.coingecko.com/coins/images/19324/small/Ico_Blanc.png?1672824647",
    coingeckoId: "aurory",
    realOriginContractAddress: "AURYydfxJib1ZkTir1Jn1J9ECYUtjb6rKQVmtYaixWPP",
    realOriginChainId: 1,
    supportsPermit: !0
  },
  {
    name: "Avenue Hamilton Token (Portal from solana)",
    symbol: "AHT",
    mint: "AHT1yynTv45s3P3KrRfQCVMHckdHeMVA3fteEg34xt9y",
    contract: "0x50eC4E5cBADffAa0cc10bA462D2462C697e3CF76",
    chainId: 56,
    wChainId: 4,
    decimals: 9,
    logoURI: "https://assets.coingecko.com/coins/images/28086/small/7FbZmTSKMsSqtlfe8yH1n3QgdBc3RBBt0B6dsdprVBs.png?1667724654",
    coingeckoId: "avenue-hamilton-token",
    realOriginContractAddress: "AHT1yynTv45s3P3KrRfQCVMHckdHeMVA3fteEg34xt9y",
    realOriginChainId: 1,
    supportsPermit: !0
  },
  {
    name: "Avenue University Token (Portal from solana)",
    symbol: "AUT",
    mint: "AUT1gfMZw37wMMQqAxk89nfpjZpEEf2XSoBUd8V5ydnS",
    contract: "0x8d07A1946d74f35378E519be3bdEDB731010CA0B",
    chainId: 56,
    wChainId: 4,
    decimals: 9,
    logoURI: "https://assets.coingecko.com/coins/images/28087/small/T-R84Zo32rDOA5Wo66T8jAlqcyjD7Folt1oeCfjlizU.png?1667724695",
    coingeckoId: "avenue-university-token",
    realOriginContractAddress: "AUT1gfMZw37wMMQqAxk89nfpjZpEEf2XSoBUd8V5ydnS",
    realOriginChainId: 1,
    supportsPermit: !0
  },
  {
    name: "Axie Infinity (Portal from Ethereum)",
    symbol: "AXS",
    mint: "HysWcbHiYY9888pHbaqhwLYZQeZrcQMXKQWRqS7zcPK5",
    contract: "0x556b60c53fbC1518Ad17E03d52E47368dD4d81B3",
    chainId: 56,
    wChainId: 4,
    decimals: 18,
    logoURI: "https://assets.coingecko.com/coins/images/13029/small/axie_infinity_logo.png?1604471082",
    coingeckoId: "axie-infinity",
    realOriginContractAddress: "0xbb0e17ef65f82ab018d8edd776e8dd940327b28b",
    realOriginChainId: 2,
    supportsPermit: !0
  },
  {
    name: "Bamboo Coin (Portal from solana)",
    symbol: "BMBO",
    mint: "5sM9xxcBTM9rWza6nEgq2cShA87JjTBx1Cu82LjgmaEg",
    contract: "0xC9629d59DdFE8CB83516D82c90b515B7c5bF7262",
    chainId: 56,
    wChainId: 4,
    decimals: 9,
    logoURI: "https://assets.coingecko.com/coins/images/19620/small/FC0hnduacAAHYFC.png?1635496724",
    coingeckoId: "bamboo-coin",
    realOriginContractAddress: "5sM9xxcBTM9rWza6nEgq2cShA87JjTBx1Cu82LjgmaEg",
    realOriginChainId: 1,
    supportsPermit: !0
  },
  {
    name: "Binance USD",
    symbol: "BUSD",
    mint: "5RpUwQ8wtdPCZHhu6MERp2RGrpobsbZ6MH5dDHkUjs2",
    contract: "0xe9e7cea3dedca5984780bafc599bd69add087d56",
    chainId: 56,
    wChainId: 4,
    decimals: 18,
    logoURI: "https://assets.coingecko.com/coins/images/9576/small/BUSD.png?1568947766",
    coingeckoId: "binance-usd",
    realOriginContractAddress: "0xe9e7cea3dedca5984780bafc599bd69add087d56",
    realOriginChainId: 4,
    supportsPermit: !1
  },
  {
    name: "Blockasset (Portal from solana)",
    symbol: "BLOCK",
    mint: "NFTUkR4u7wKxy9QLaX2TGvd9oZSWoMo4jqSJqdMb7Nk",
    contract: "0xbC7A566b85eF73F935e640A06b5a8b031Cd975Df",
    chainId: 56,
    wChainId: 4,
    decimals: 6,
    logoURI: "https://assets.coingecko.com/coins/images/21332/small/Blockasset-Logo-Symbol.png?1648442722",
    coingeckoId: "blockasset",
    realOriginContractAddress: "NFTUkR4u7wKxy9QLaX2TGvd9oZSWoMo4jqSJqdMb7Nk",
    realOriginChainId: 1,
    supportsPermit: !0
  },
  {
    name: "Bonfida (Portal from solana)",
    symbol: "FIDA",
    mint: "EchesyfXePKdLtoiZSL8pBe8Myagyy8ZRqsACNCFGnvp",
    contract: "0xED6e7c148Dddf8deeAEc7c6c9E3F4069AA2Fe33d",
    chainId: 56,
    wChainId: 4,
    decimals: 6,
    logoURI: "https://assets.coingecko.com/coins/images/13395/small/bonfida.png?1658327819",
    coingeckoId: "bonfida",
    realOriginContractAddress: "EchesyfXePKdLtoiZSL8pBe8Myagyy8ZRqsACNCFGnvp",
    realOriginChainId: 1,
    supportsPermit: !0
  },
  {
    name: "Brazilian Digital (Portal from solana)",
    symbol: "BRZ",
    mint: "FtgGSFADXBtroxq8VCausXRr2of47QBf5AS1NtZCu4GD",
    contract: "0x5b1a9850f55d9282a7C4Bf23A2a21B050e3Beb2f",
    chainId: 56,
    wChainId: 4,
    decimals: 4,
    logoURI: "https://assets.coingecko.com/coins/images/8472/small/2_vtiD3xwce9knG2COxtSMaQ.png?1597786961",
    coingeckoId: "brz",
    realOriginContractAddress: "FtgGSFADXBtroxq8VCausXRr2of47QBf5AS1NtZCu4GD",
    realOriginChainId: 1,
    supportsPermit: !0
  },
  {
    name: "Celsius Network (Portal from Ethereum)",
    symbol: "CEL",
    mint: "nRtfwU9G82CSHhHGJNxFhtn7FLvWP2rqvQvje1WtL69",
    contract: "0xfaF23406406DE9068cA8503f48271233e728d517",
    chainId: 56,
    wChainId: 4,
    decimals: 4,
    logoURI: "https://assets.coingecko.com/coins/images/3263/small/CEL_logo.png?1609598753",
    coingeckoId: "celsius-degree-token",
    realOriginContractAddress: "0xaaaebe6fe48e54f431b0c390cfaf0b017d09d42d",
    realOriginChainId: 2,
    supportsPermit: !0
  },
  {
    name: "Chainlink (Portal from Ethereum)",
    symbol: "LINK",
    mint: "2wpTofQ8SkACrkZWrZDjXPitYa8AwWgX8AfxdeBRRVLX",
    contract: "0xaf8906b6244A13Dc64404E1715D5702fE8bc1d35",
    chainId: 56,
    wChainId: 4,
    decimals: 18,
    logoURI: "https://assets.coingecko.com/coins/images/877/small/chainlink-new-logo.png?1547034700",
    coingeckoId: "chainlink",
    realOriginContractAddress: "0x514910771af9ca656af840dff83e8264ecf986ca",
    realOriginChainId: 2,
    supportsPermit: !0
  },
  {
    name: "Cheems (Portal from solana)",
    symbol: "CHEEMS",
    mint: "3FoUAsGDbvTD6YZ4wVKJgTB76onJUKz7GPEBNiR5b8wc",
    contract: "0xe731EDA12D85FfF3C207136008C0b08F33A66570",
    chainId: 56,
    wChainId: 4,
    decimals: 4,
    logoURI: "https://assets.coingecko.com/coins/images/18358/small/newlogo.png?1644476666",
    coingeckoId: "cheems",
    realOriginContractAddress: "3FoUAsGDbvTD6YZ4wVKJgTB76onJUKz7GPEBNiR5b8wc",
    realOriginChainId: 1,
    supportsPermit: !0
  },
  {
    name: "ChikinCoin (Portal from solana)",
    symbol: "CKC",
    mint: "8s9FCz99Wcr3dHpiauFRi6bLXzshXfcGTfgQE7UEopVx",
    contract: "0x80B526f6393380ccFB688c226C6b2Ac91bA1de86",
    chainId: 56,
    wChainId: 4,
    decimals: 6,
    logoURI: "https://assets.coingecko.com/coins/images/24978/small/Screenshot_from_2022-04-11_15-47-44.png?1649663281",
    coingeckoId: "chikincoin",
    realOriginContractAddress: "8s9FCz99Wcr3dHpiauFRi6bLXzshXfcGTfgQE7UEopVx",
    realOriginChainId: 1,
    supportsPermit: !0
  },
  {
    name: "ClinTex CTi (Portal from Ethereum)",
    symbol: "CTI",
    mint: "9ET2QCQJdFkeKkuaampNbmicbA8eLYauFCWch9Ddh9p5",
    contract: "0x7C3B67B30eFBAcC8f787f7EBd3bdc65234299f4c",
    chainId: 56,
    wChainId: 4,
    decimals: 18,
    logoURI: "https://assets.coingecko.com/coins/images/13266/small/CTI.png?1606817542",
    coingeckoId: "clintex-cti",
    realOriginContractAddress: "0xcb8fb2438a805664cd8c3e640b85ac473da5be87",
    realOriginChainId: 2,
    supportsPermit: !0
  },
  {
    name: "Coin98 (Portal from solana)",
    symbol: "C98",
    mint: "C98A4nkJXhpVZNAZdHUA95RpTF3T4whtQubL3YobiUX9",
    contract: "0xAa3A37d3bA662417222E760372B8a67a1a71D480",
    chainId: 56,
    wChainId: 4,
    decimals: 6,
    logoURI: "https://assets.coingecko.com/coins/images/17117/small/logo.png?1626412904",
    coingeckoId: "coin98",
    realOriginContractAddress: "C98A4nkJXhpVZNAZdHUA95RpTF3T4whtQubL3YobiUX9",
    realOriginChainId: 1,
    supportsPermit: !0
  },
  {
    name: "ConstitutionDAO (Portal from Ethereum)",
    symbol: "PEOPLE",
    mint: "CobcsUrt3p91FwvULYKorQejgsm5HoQdv5T8RUZ6PnLA",
    contract: "0xA7B094a4eA872A5bE53ea57a0e82dF78C2C5F1f0",
    chainId: 56,
    wChainId: 4,
    decimals: 18,
    logoURI: "https://assets.coingecko.com/coins/images/20612/small/GN_UVm3d_400x400.jpg?1637294355",
    coingeckoId: "constitutiondao",
    realOriginContractAddress: "0x7a58c0be72be218b41c608b7fe7c5bb630736c71",
    realOriginChainId: 2,
    supportsPermit: !0
  },
  {
    name: "Cope (Portal from solana)",
    symbol: "COPE",
    mint: "8HGyAAB1yoM1ttS7pXjHMa3dukTFGQggnFFH3hJZgzQh",
    contract: "0x80Ca0D6D9f4560a396de02fb170B0BC9348A2D97",
    chainId: 56,
    wChainId: 4,
    decimals: 6,
    logoURI: "https://assets.coingecko.com/coins/images/14567/small/COPE.png?1617162230",
    coingeckoId: "cope",
    realOriginContractAddress: "8HGyAAB1yoM1ttS7pXjHMa3dukTFGQggnFFH3hJZgzQh",
    realOriginChainId: 1,
    supportsPermit: !0
  },
  {
    name: "Konstellation",
    symbol: "DARC",
    mint: "CpFE715P5DnDoJj9FbCRcuyHHeTXNdRnvzNkHvq1o23U",
    contract: "0x8ebc361536094fd5b4ffb8521e31900614c9f55d",
    chainId: 56,
    wChainId: 4,
    decimals: 18,
    logoURI: "https://assets.coingecko.com/coins/images/2943/small/darctoken.png?1645230834",
    coingeckoId: "darcmatter-coin",
    realOriginContractAddress: "0x8ebc361536094fd5b4ffb8521e31900614c9f55d",
    realOriginChainId: 4,
    supportsPermit: !1
  },
  {
    name: "Dead Knight (Portal from solana)",
    symbol: "DKM",
    mint: "HtbhBYdcfXbbD2JiH6jtsTt2m2FXjn7h4k6iXfz98k5W",
    contract: "0x71Ab1678aCaAfD7Fc011d269b23964f07007d98D",
    chainId: 56,
    wChainId: 4,
    decimals: 9,
    logoURI: "https://assets.coingecko.com/coins/images/24442/small/SAq1GaQc_400x400.jpg?1647673953",
    coingeckoId: "dead-knight",
    realOriginContractAddress: "HtbhBYdcfXbbD2JiH6jtsTt2m2FXjn7h4k6iXfz98k5W",
    realOriginChainId: 1,
    supportsPermit: !0
  },
  {
    name: "Decentraland (Portal from Ethereum)",
    symbol: "MANA",
    mint: "7dgHoN8wBZCc5wbnQ2C47TDnBMAxG4Q5L3KjP67z8kNi",
    contract: "0xbA707A49858364a1916Ce797023194147F5B4B67",
    chainId: 56,
    wChainId: 4,
    decimals: 18,
    logoURI: "https://assets.coingecko.com/coins/images/878/small/decentraland-mana.png?1550108745",
    coingeckoId: "decentraland",
    realOriginContractAddress: "0x0f5d2fb29fb7d3cfee444a200298f468908cc942",
    realOriginChainId: 2,
    supportsPermit: !0
  },
  {
    name: "DeFi Land (Portal from solana)",
    symbol: "DFL",
    mint: "DFL1zNkaGPWm1BqAVqRjCZvHmwTFrEaJtbzJWgseoNJh",
    contract: "0x142bF7462bdd7cEd89D9144575409a7ABd99c0D2",
    chainId: 56,
    wChainId: 4,
    decimals: 9,
    logoURI: "https://assets.coingecko.com/coins/images/18910/small/defilend.png?1637190571",
    coingeckoId: "defi-land",
    realOriginContractAddress: "DFL1zNkaGPWm1BqAVqRjCZvHmwTFrEaJtbzJWgseoNJh",
    realOriginChainId: 1,
    supportsPermit: !0
  },
  {
    name: "Dexlab (Portal from solana)",
    symbol: "DXL",
    mint: "GsNzxJfFn6zQdJGeYsupJWzUAm57Ba7335mfhWvFiE9Z",
    contract: "0x3DC82573e64454851C95432A6A763Ef297209980",
    chainId: 56,
    wChainId: 4,
    decimals: 6,
    logoURI: "https://assets.coingecko.com/coins/images/17276/small/3_GradientSymbol.png?1650936792",
    coingeckoId: "dexlab",
    realOriginContractAddress: "GsNzxJfFn6zQdJGeYsupJWzUAm57Ba7335mfhWvFiE9Z",
    realOriginChainId: 1,
    supportsPermit: !0
  },
  {
    name: "DogemonGo (Portal from solana)",
    symbol: "DOGO",
    mint: "5LSFpvLDkcdV2a3Kiyzmg5YmJsj2XDLySaXvnfP1cgLT",
    contract: "0xd4f37a22c4e3C1c638E99423ffc1078FcB76921B",
    chainId: 56,
    wChainId: 4,
    decimals: 6,
    logoURI: "https://assets.coingecko.com/coins/images/17480/small/dogemongo.PNG?1627950869",
    coingeckoId: "dogemon-go",
    realOriginContractAddress: "5LSFpvLDkcdV2a3Kiyzmg5YmJsj2XDLySaXvnfP1cgLT",
    realOriginChainId: 1,
    supportsPermit: !0
  },
  {
    name: "DUST Protocol (Portal from solana)",
    symbol: "DUST",
    mint: "DUSTawucrTsGU8hcqRdHDCbuYhCPADMLM2VcCb8VnFnQ",
    contract: "0xa8961E2B3945272F5098bdaDeb0632f430aCA157",
    chainId: 56,
    wChainId: 4,
    decimals: 9,
    logoURI: "https://assets.coingecko.com/coins/images/24289/small/dust-protocol-degod.png?1647306854",
    coingeckoId: "dust-protocol",
    realOriginContractAddress: "DUSTawucrTsGU8hcqRdHDCbuYhCPADMLM2VcCb8VnFnQ",
    realOriginChainId: 1,
    supportsPermit: !0
  },
  {
    name: "Famous Fox Federation (Portal from solana)",
    symbol: "FOXY",
    mint: "FoXyMu5xwXre7zEoSvzViRk3nGawHUp9kUh97y2NDhcq",
    contract: "0x7485a0aaC4856Fe63ec2Ece0C1D75C6fa82d7A22",
    chainId: 56,
    wChainId: 4,
    decimals: 0,
    logoURI: "https://assets.coingecko.com/coins/images/26191/small/uFYaQEsU_400x400.jpg?1656397523",
    coingeckoId: "famous-fox-federation",
    realOriginContractAddress: "FoXyMu5xwXre7zEoSvzViRk3nGawHUp9kUh97y2NDhcq",
    realOriginChainId: 1,
    supportsPermit: !0
  },
  {
    name: "FTX (Portal from Ethereum)",
    symbol: "FTT",
    mint: "EzfgjvkSwthhgHaceR3LnKXUoRkP6NUhfghdaHAj1tUv",
    contract: "0x49BA054B9664e99ac335667a917c63bB94332E84",
    chainId: 56,
    wChainId: 4,
    decimals: 18,
    logoURI: "https://assets.coingecko.com/coins/images/9026/small/F.png?1609051564",
    coingeckoId: "ftx-token",
    realOriginContractAddress: "0x50d1c9771902476076ecfc8b2a83ad6b9355a4c9",
    realOriginChainId: 2,
    supportsPermit: !0
  },
  {
    name: "Gari Network (Portal from solana)",
    symbol: "GARI",
    mint: "CKaKtYvz6dKPyMvYq9Rh3UBrnNqYZAyd7iF4hJtjUvks",
    contract: "0x7e23f3EE68024f6aE14d201eb90B3ae016521BCb",
    chainId: 56,
    wChainId: 4,
    decimals: 9,
    logoURI: "https://assets.coingecko.com/coins/images/22615/small/gari.png?1642313087",
    coingeckoId: "gari-network",
    realOriginContractAddress: "CKaKtYvz6dKPyMvYq9Rh3UBrnNqYZAyd7iF4hJtjUvks",
    realOriginChainId: 1,
    supportsPermit: !0
  },
  {
    name: "Genopets (Portal from solana)",
    symbol: "GENE",
    mint: "GENEtH5amGSi8kHAtQoezp1XEXwZJ8vcuePYnXdKrMYz",
    contract: "0xa9ECbf7D4d2d90c3A341E162540f8588f7FbA8BC",
    chainId: 56,
    wChainId: 4,
    decimals: 9,
    logoURI: "https://assets.coingecko.com/coins/images/20360/small/gene-token.png?1636945172",
    coingeckoId: "genopets",
    realOriginContractAddress: "GENEtH5amGSi8kHAtQoezp1XEXwZJ8vcuePYnXdKrMYz",
    realOriginChainId: 1,
    supportsPermit: !0
  },
  {
    name: "GooseFX (Portal from solana)",
    symbol: "GOFX",
    mint: "GFX1ZjR2P15tmrSwow6FjyDYcEkoFb4p4gJCpLBjaxHD",
    contract: "0x5802D2Efd4AB4FAb7d77C249743230bDffFC6Ef7",
    chainId: 56,
    wChainId: 4,
    decimals: 9,
    logoURI: "https://assets.coingecko.com/coins/images/19793/small/0Kjm9f4.png?1635906737",
    coingeckoId: "goosefx",
    realOriginContractAddress: "GFX1ZjR2P15tmrSwow6FjyDYcEkoFb4p4gJCpLBjaxHD",
    realOriginChainId: 1,
    supportsPermit: !0
  },
  {
    name: "Grape Protocol (Portal from solana)",
    symbol: "GRAPE",
    mint: "8upjSpvjcdpuzhfR1zriwg5NXkwDruejqNE9WNbPRtyA",
    contract: "0x727c55C17D63a8746A53e1e5f7E8A72A8aaCD885",
    chainId: 56,
    wChainId: 4,
    decimals: 6,
    logoURI: "https://assets.coingecko.com/coins/images/18149/small/fRsuAlcV_400x400.png?1632437325",
    coingeckoId: "grape-2",
    realOriginContractAddress: "8upjSpvjcdpuzhfR1zriwg5NXkwDruejqNE9WNbPRtyA",
    realOriginChainId: 1,
    supportsPermit: !0
  },
  {
    name: "STEPN Green Satoshi Token on Solana (Portal from solana)",
    symbol: "GST-SOL",
    mint: "AFbX8oGjGpmVFywbVouvhQSRmiW2aR1mohfahi4Y2AdB",
    contract: "0x9769aa47D7688a44e2B9414159ee49Ab9c33bC10",
    chainId: 56,
    wChainId: 4,
    decimals: 9,
    logoURI: "https://assets.coingecko.com/coins/images/21841/small/gst.png?1640332626",
    coingeckoId: "green-satoshi-token",
    realOriginContractAddress: "AFbX8oGjGpmVFywbVouvhQSRmiW2aR1mohfahi4Y2AdB",
    realOriginChainId: 1,
    supportsPermit: !0
  },
  {
    name: "HAPI (Portal from solana)",
    symbol: "HAPI",
    mint: "6VNKqgz9hk7zRShTFdg5AnkfKwZUcojzwAkzxSH3bnUm",
    contract: "0xAFDCF594a6CFFE8a0cE888C4cE809FAcf7A761b7",
    chainId: 56,
    wChainId: 4,
    decimals: 9,
    logoURI: "https://assets.coingecko.com/coins/images/14298/small/R9i2HjAL_400x400.jpg?1615332438",
    coingeckoId: "hapi",
    realOriginContractAddress: "6VNKqgz9hk7zRShTFdg5AnkfKwZUcojzwAkzxSH3bnUm",
    realOriginChainId: 1,
    supportsPermit: !0
  },
  {
    name: "Kin (Portal from solana)",
    symbol: "KIN",
    mint: "kinXdEcpDQeHPEuQnqmUgtYykqKGVFq6CeVX5iAHJq6",
    contract: "0x03043561F1708471f07FC106cED204a2E8b20724",
    chainId: 56,
    wChainId: 4,
    decimals: 5,
    logoURI: "https://assets.coingecko.com/coins/images/959/small/kin.png?1586917032",
    coingeckoId: "kin",
    realOriginContractAddress: "kinXdEcpDQeHPEuQnqmUgtYykqKGVFq6CeVX5iAHJq6",
    realOriginChainId: 1,
    supportsPermit: !0
  },
  {
    name: "Larix (Portal from solana)",
    symbol: "LARIX",
    mint: "Lrxqnh6ZHKbGy3dcrCED43nsoLkM1LTzU2jRfWe8qUC",
    contract: "0x484E95C6a8bd686c2aA968Ee507868fddA708F86",
    chainId: 56,
    wChainId: 4,
    decimals: 6,
    logoURI: "https://assets.coingecko.com/coins/images/18450/small/larix.PNG?1632092483",
    coingeckoId: "larix",
    realOriginContractAddress: "Lrxqnh6ZHKbGy3dcrCED43nsoLkM1LTzU2jRfWe8qUC",
    realOriginChainId: 1,
    supportsPermit: !0
  },
  {
    name: "Lido DAO (Portal from Ethereum)",
    symbol: "LDO",
    mint: "HZRCwxP2Vq9PCpPXooayhJ2bxTpo5xfpQrwB1svh332p",
    contract: "0x986854779804799C1d68867F5E03e601E781e41b",
    chainId: 56,
    wChainId: 4,
    decimals: 18,
    logoURI: "https://assets.coingecko.com/coins/images/13573/small/Lido_DAO.png?1609873644",
    coingeckoId: "lido-dao",
    realOriginContractAddress: "0x5a98fcbea516cf06857215779fd812ca3bef1b32",
    realOriginChainId: 2,
    supportsPermit: !0
  },
  {
    name: "Lido Staked SOL (Portal from solana)",
    symbol: "STSOL",
    mint: "7dHbWXmci3dT8UFYWYZweBLXgycu7Y3iL6trKn1Y7ARj",
    contract: "0x39C131bfCace0C5D2a6DA6fdf0Ba8c20C3A16f3C",
    chainId: 56,
    wChainId: 4,
    decimals: 9,
    logoURI: "https://assets.coingecko.com/coins/images/18369/small/logo_-_2021-09-15T100934.765.png?1631671781",
    coingeckoId: "lido-staked-sol",
    realOriginContractAddress: "7dHbWXmci3dT8UFYWYZweBLXgycu7Y3iL6trKn1Y7ARj",
    realOriginChainId: 1,
    supportsPermit: !0
  },
  {
    name: "Mango (Portal from solana)",
    symbol: "MNGO",
    mint: "MangoCzJ36AjZyKwVj3VnYU4GTonjfVEnJmvvWaxLac",
    contract: "0xDfe6Aee548B5Dc9CDf96fdADF5ED3bc770c01992",
    chainId: 56,
    wChainId: 4,
    decimals: 6,
    logoURI: "https://assets.coingecko.com/coins/images/14773/small/token-mango.png?1628171237",
    coingeckoId: "mango-markets",
    realOriginContractAddress: "MangoCzJ36AjZyKwVj3VnYU4GTonjfVEnJmvvWaxLac",
    realOriginChainId: 1,
    supportsPermit: !0
  },
  {
    name: "Marinade (Portal from solana)",
    symbol: "MNDE",
    mint: "MNDEFzGvMt87ueuHvVU9VcTqsAP5b3fTGPsHuuPA5ey",
    contract: "0x57076699fF1d42D48422f3472F2434A6D62D4d4D",
    chainId: 56,
    wChainId: 4,
    decimals: 9,
    logoURI: "https://assets.coingecko.com/coins/images/18867/small/MNDE.png?1643187748",
    coingeckoId: "marinade",
    realOriginContractAddress: "MNDEFzGvMt87ueuHvVU9VcTqsAP5b3fTGPsHuuPA5ey",
    realOriginChainId: 1,
    supportsPermit: !0
  },
  {
    name: "Mercurial (Portal from solana)",
    symbol: "MER",
    mint: "MERt85fc5boKw3BW1eYdxonEuJNvXbiMbs6hvheau5K",
    contract: "0x18D0FE336a2064c5f277741d29954D83fC0376E8",
    chainId: 56,
    wChainId: 4,
    decimals: 6,
    logoURI: "https://assets.coingecko.com/coins/images/15527/small/mer_logo.png?1621128922",
    coingeckoId: "mercurial",
    realOriginContractAddress: "MERt85fc5boKw3BW1eYdxonEuJNvXbiMbs6hvheau5K",
    realOriginChainId: 1,
    supportsPermit: !0
  },
  {
    name: "MonkeyLeague (Portal from solana)",
    symbol: "MBS",
    mint: "Fm9rHUTF5v3hwMLbStjZXqNBBoZyGriQaFM6sTFz3K8A",
    contract: "0x135b4821134F91a10f34Ca98345D215b725a526c",
    chainId: 56,
    wChainId: 4,
    decimals: 6,
    logoURI: "https://assets.coingecko.com/coins/images/20841/small/monkeyball.png?1639023123",
    coingeckoId: "monkeyball",
    realOriginContractAddress: "Fm9rHUTF5v3hwMLbStjZXqNBBoZyGriQaFM6sTFz3K8A",
    realOriginChainId: 1,
    supportsPermit: !0
  },
  {
    name: "MoonLana (Portal from solana)",
    symbol: "MOLA",
    mint: "AMdnw9H5DFtQwZowVFr4kUgSXJzLokKSinvgGiUoLSps",
    contract: "0x61ECC86E5D5990BC1EdDcA712689Cb24259626b9",
    chainId: 56,
    wChainId: 4,
    decimals: 9,
    logoURI: "https://assets.coingecko.com/coins/images/16278/small/NW8RySX.png?1623635238",
    coingeckoId: "moonlana",
    realOriginContractAddress: "AMdnw9H5DFtQwZowVFr4kUgSXJzLokKSinvgGiUoLSps",
    realOriginChainId: 1,
    supportsPermit: !0
  },
  {
    name: "Marinade staked SOL (Portal from solana)",
    symbol: "MSOL",
    mint: "mSoLzYCxHdYgdzU16g5QSh3i5K3z3KZK7ytfqcJm7So",
    contract: "0xF2beBF36994381595331Af1f11Eb4F8114eD2c09",
    chainId: 56,
    wChainId: 4,
    decimals: 9,
    logoURI: "https://assets.coingecko.com/coins/images/17752/small/mSOL.png?1644541955",
    coingeckoId: "msol",
    realOriginContractAddress: "mSoLzYCxHdYgdzU16g5QSh3i5K3z3KZK7ytfqcJm7So",
    realOriginChainId: 1,
    supportsPermit: !0
  },
  {
    name: "Only1 (Portal from solana)",
    symbol: "LIKE",
    mint: "3bRTivrVsitbmCTGtqwp7hxXPsybkjn4XLNtPsHqa3zR",
    contract: "0x122207a7061E19c0dD89305A7798224c97F075b8",
    chainId: 56,
    wChainId: 4,
    decimals: 9,
    logoURI: "https://assets.coingecko.com/coins/images/17501/small/like-token.png?1628036165",
    coingeckoId: "only1",
    realOriginContractAddress: "3bRTivrVsitbmCTGtqwp7hxXPsybkjn4XLNtPsHqa3zR",
    realOriginChainId: 1,
    supportsPermit: !0
  },
  {
    name: "Orca (Portal from solana)",
    symbol: "ORCA",
    mint: "orcaEKTdK7LKz57vaAYr9QeNsVEPfiu6QeMU1kektZE",
    contract: "0x180646A8E543430f42300d8F12b63Dc5C871e119",
    chainId: 56,
    wChainId: 4,
    decimals: 6,
    logoURI: "https://assets.coingecko.com/coins/images/17547/small/Orca_Logo.png?1628781615",
    coingeckoId: "orca",
    realOriginContractAddress: "orcaEKTdK7LKz57vaAYr9QeNsVEPfiu6QeMU1kektZE",
    realOriginChainId: 1,
    supportsPermit: !0
  },
  {
    name: "Parrot Protocol (Portal from solana)",
    symbol: "PRT",
    mint: "PRT88RkA4Kg5z7pKnezeNH4mafTvtQdfFgpQTGRjz44",
    contract: "0xBbc0Ef4FC2B05Efcca23e36fA60A48DBC6E19424",
    chainId: 56,
    wChainId: 4,
    decimals: 6,
    logoURI: "https://assets.coingecko.com/coins/images/18443/small/PRT.png?1634698095",
    coingeckoId: "parrot-protocol",
    realOriginContractAddress: "PRT88RkA4Kg5z7pKnezeNH4mafTvtQdfFgpQTGRjz44",
    realOriginChainId: 1,
    supportsPermit: !0
  },
  {
    name: "Parrot USD (Portal from solana)",
    symbol: "PAI",
    mint: "Ea5SjE2Y6yvCeW5dYTn7PYMuW5ikXkvbGdcmSnXeaLjS",
    contract: "0xDf85be53e5CFA18e964bdfdE0a15049f774B21dE",
    chainId: 56,
    wChainId: 4,
    decimals: 6,
    logoURI: "https://assets.coingecko.com/coins/images/18439/small/pai.png?1632004568",
    coingeckoId: "parrot-usd",
    realOriginContractAddress: "Ea5SjE2Y6yvCeW5dYTn7PYMuW5ikXkvbGdcmSnXeaLjS",
    realOriginChainId: 1,
    supportsPermit: !0
  },
  {
    name: "Plutonian DAO (Portal from solana)",
    symbol: "PLD",
    mint: "2cJgFtnqjaoiu9fKVX3fny4Z4pRzuaqfJ3PBTMk2D9ur",
    contract: "0x187597F33EF17C7a089150DB29Ab34424Cd41569",
    chainId: 56,
    wChainId: 4,
    decimals: 6,
    logoURI: "https://assets.coingecko.com/coins/images/25092/small/logo-pld_200.png?1650270204",
    coingeckoId: "plutonian-dao",
    realOriginContractAddress: "2cJgFtnqjaoiu9fKVX3fny4Z4pRzuaqfJ3PBTMk2D9ur",
    realOriginChainId: 1,
    supportsPermit: !0
  },
  {
    name: "RaceFi (Portal from solana)",
    symbol: "RACEFI",
    mint: "AAmGoPDFLG6bE82BgZWjVi8k95tj9Tf3vUN7WvtUm2BU",
    contract: "0x78079551634Ff9c3283639b645256DcC77C9Ee3d",
    chainId: 56,
    wChainId: 4,
    decimals: 6,
    logoURI: "https://assets.coingecko.com/coins/images/21873/small/XIF9z8Z6_400x400.jpg?1640209612",
    coingeckoId: "racefi",
    realOriginContractAddress: "AAmGoPDFLG6bE82BgZWjVi8k95tj9Tf3vUN7WvtUm2BU",
    realOriginChainId: 1,
    supportsPermit: !0
  },
  {
    name: "Raydium (Portal from solana)",
    symbol: "RAY",
    mint: "4k3Dyjzvzp8eMZWUXbBCjEvwSkkk59S5iCNLY3QrkX6R",
    contract: "0x13b6A55662f6591f8B8408Af1C73B017E32eEdB8",
    chainId: 56,
    wChainId: 4,
    decimals: 6,
    logoURI: "https://assets.coingecko.com/coins/images/13928/small/PSigc4ie_400x400.jpg?1612875614",
    coingeckoId: "raydium",
    realOriginContractAddress: "4k3Dyjzvzp8eMZWUXbBCjEvwSkkk59S5iCNLY3QrkX6R",
    realOriginChainId: 1,
    supportsPermit: !0
  },
  {
    name: "Rollbit Coin (Portal from solana)",
    symbol: "RLB",
    mint: "RLBxxFkseAZ4RgJH3Sqn8jXxhmGoz9jWxDNJMh8pL7a",
    contract: "0x0DE06aAe339B316FFa6d285Afc12580712992e04",
    chainId: 56,
    wChainId: 4,
    decimals: 2,
    logoURI: "https://assets.coingecko.com/coins/images/24552/small/unziL6wO_400x400.jpg?1648134494",
    coingeckoId: "rollbit-coin",
    realOriginContractAddress: "RLBxxFkseAZ4RgJH3Sqn8jXxhmGoz9jWxDNJMh8pL7a",
    realOriginChainId: 1,
    supportsPermit: !0
  },
  {
    name: "Rope Token (Portal from solana)",
    symbol: "ROPE",
    mint: "8PMHT4swUMtBzgHnh5U564N5sjPSiUz2cjEQzFnnP1Fo",
    contract: "0xB1172d1f6CE870B2390620b10523E801484e73b6",
    chainId: 56,
    wChainId: 4,
    decimals: 9,
    logoURI: "https://assets.coingecko.com/coins/images/14661/small/rope-v6.png?1619606776",
    coingeckoId: "rope-token",
    realOriginContractAddress: "8PMHT4swUMtBzgHnh5U564N5sjPSiUz2cjEQzFnnP1Fo",
    realOriginChainId: 1,
    supportsPermit: !0
  },
  {
    name: "Saber (Portal from solana)",
    symbol: "SBR",
    mint: "Saber2gLauYim4Mvftnrasomsv6NvAuncvMEZwcLpD1",
    contract: "0x75344E5693ed5ecAdF4f292fFeb866c2cF8afCF1",
    chainId: 56,
    wChainId: 4,
    decimals: 6,
    logoURI: "https://assets.coingecko.com/coins/images/17162/small/oYs_YFz8_400x400.jpg?1626678457",
    coingeckoId: "saber",
    realOriginContractAddress: "Saber2gLauYim4Mvftnrasomsv6NvAuncvMEZwcLpD1",
    realOriginChainId: 1,
    supportsPermit: !0
  },
  {
    name: "SAIL (Portal from solana)",
    symbol: "SAIL",
    mint: "6kwTqmdQkJd8qRr9RjSnUX9XJ24RmJRSrU1rsragP97Y",
    contract: "0x4c4C7B87e44bf00e413535019159044c5a2C8943",
    chainId: 56,
    wChainId: 4,
    decimals: 6,
    logoURI: "https://assets.coingecko.com/coins/images/16657/small/SAIL.png?1624608515",
    coingeckoId: "sail",
    realOriginContractAddress: "6kwTqmdQkJd8qRr9RjSnUX9XJ24RmJRSrU1rsragP97Y",
    realOriginChainId: 1,
    supportsPermit: !0
  },
  {
    name: "Samoyedcoin (Portal from solana)",
    symbol: "SAMO",
    mint: "7xKXtg2CW87d97TXJSDpbD5jBkheTqA83TZRuJosgAsU",
    contract: "0x5283b237eDce5bFcBEB01C97298D71f5a994Ec68",
    chainId: 56,
    wChainId: 4,
    decimals: 9,
    logoURI: "https://assets.coingecko.com/coins/images/15051/small/IXeEj5e.png?1619560738",
    coingeckoId: "samoyedcoin",
    realOriginContractAddress: "7xKXtg2CW87d97TXJSDpbD5jBkheTqA83TZRuJosgAsU",
    realOriginChainId: 1,
    supportsPermit: !0
  },
  {
    name: "Scrap (Portal from solana)",
    symbol: "SCRAP",
    mint: "6naWDMGNWwqffJnnXFLBCLaYu1y5U9Rohe5wwJPHvf1p",
    contract: "0x5aE8Cb1111193e2b6cBDe6d2ae3d8C18f76B9304",
    chainId: 56,
    wChainId: 4,
    decimals: 3,
    logoURI: "https://assets.coingecko.com/coins/images/23086/small/bd1b1275fdc0ac1.png?1643181131",
    coingeckoId: "scrap",
    realOriginContractAddress: "6naWDMGNWwqffJnnXFLBCLaYu1y5U9Rohe5wwJPHvf1p",
    realOriginChainId: 1,
    supportsPermit: !0
  },
  {
    name: "Serum (Portal from Ethereum)",
    symbol: "SRM",
    mint: "xnorPhAzWXUczCP3KjU5yDxmKKZi5cSbxytQ1LgE3kG",
    contract: "0xd63CDf02853D759831550fAe7dF8FFfE0B317b39",
    chainId: 56,
    wChainId: 4,
    decimals: 6,
    logoURI: "https://assets.coingecko.com/coins/images/11970/small/serum-logo.png?1597121577",
    coingeckoId: "serum",
    realOriginContractAddress: "0x476c5e26a75bd202a9683ffd34359c0cc15be0ff",
    realOriginChainId: 2,
    supportsPermit: !0
  },
  {
    name: "Serum (Portal from solana)",
    symbol: "SRM",
    mint: "SRMuApVNdxXokk5GT7XD5cUUgXMBCoAz2LHeuAoKWRt",
    contract: "0x12BeffdCEcb547640DC30e1495E4B9cdc21922b4",
    chainId: 56,
    wChainId: 4,
    decimals: 6,
    logoURI: "https://assets.coingecko.com/coins/images/11970/small/serum-logo.png?1597121577",
    coingeckoId: "serum",
    realOriginContractAddress: "SRMuApVNdxXokk5GT7XD5cUUgXMBCoAz2LHeuAoKWRt",
    realOriginChainId: 1,
    supportsPermit: !0
  },
  {
    name: "Shiba Inu (Portal from Ethereum)",
    symbol: "SHIB",
    mint: "CiKu4eHsVrc1eueVQeHn7qhXTcVu95gSQmBpX4utjL9z",
    contract: "0xb1547683DA678f2e1F003A780143EC10Af8a832B",
    chainId: 56,
    wChainId: 4,
    decimals: 18,
    logoURI: "https://assets.coingecko.com/coins/images/11939/small/shiba.png?1622619446",
    coingeckoId: "shiba-inu",
    realOriginContractAddress: "0x95ad61b0a150d79219dcf64e1e6cc01f0b64c4ce",
    realOriginChainId: 2,
    supportsPermit: !0
  },
  {
    name: "Project SEED SHILL (Portal from solana)",
    symbol: "SHILL",
    mint: "6cVgJUqo4nmvQpbgrDZwyfd6RwWw5bfnCamS3M9N1fd",
    contract: "0x93A70759b3521d8De481f88e1F726c00309676B1",
    chainId: 56,
    wChainId: 4,
    decimals: 6,
    logoURI: "https://assets.coingecko.com/coins/images/18176/small/SHILL_Logo.png?1630896205",
    coingeckoId: "shill-token",
    realOriginContractAddress: "6cVgJUqo4nmvQpbgrDZwyfd6RwWw5bfnCamS3M9N1fd",
    realOriginChainId: 1,
    supportsPermit: !0
  },
  {
    name: "Socean Staked Sol (Portal from solana)",
    symbol: "SCNSOL",
    mint: "5oVNBeEEQvYi1cX3ir8Dx5n1P7pdxydbGF2X4TxVusJm",
    contract: "0xf5BF9917E704547f2083d48D2aaf0066BF0DC814",
    chainId: 56,
    wChainId: 4,
    decimals: 9,
    logoURI: "https://assets.coingecko.com/coins/images/18468/small/biOTzfxE_400x400.png?1633662119",
    coingeckoId: "socean-staked-sol",
    realOriginContractAddress: "5oVNBeEEQvYi1cX3ir8Dx5n1P7pdxydbGF2X4TxVusJm",
    realOriginChainId: 1,
    supportsPermit: !0
  },
  {
    name: "Solanium (Portal from solana)",
    symbol: "SLIM",
    mint: "xxxxa1sKNGwFtw2kFn8XauW9xq8hBZ5kVtcSesTT9fW",
    contract: "0xE3CBa77f89349DB13c1a441B447E4E5dFa374662",
    chainId: 56,
    wChainId: 4,
    decimals: 6,
    logoURI: "https://assets.coingecko.com/coins/images/15816/small/logo_cg.png?1659000206",
    coingeckoId: "solanium",
    realOriginContractAddress: "xxxxa1sKNGwFtw2kFn8XauW9xq8hBZ5kVtcSesTT9fW",
    realOriginChainId: 1,
    supportsPermit: !0
  },
  {
    name: "SOLAPE (Portal from solana)",
    symbol: "SOLAPE",
    mint: "GHvFFSZ9BctWsEc5nujR1MTmmJWY7tgQz2AXE6WVFtGN",
    contract: "0x82672868482B8436215E4F3fb2F2B1aB427F0b10",
    chainId: 56,
    wChainId: 4,
    decimals: 9,
    logoURI: "https://assets.coingecko.com/coins/images/16930/small/128px-coin.png?1625753550",
    coingeckoId: "solape-token",
    realOriginContractAddress: "GHvFFSZ9BctWsEc5nujR1MTmmJWY7tgQz2AXE6WVFtGN",
    realOriginChainId: 1,
    supportsPermit: !0
  },
  {
    name: "SolChicks (Portal from solana)",
    symbol: "CHICKS",
    mint: "cxxShYRVcepDudXhe7U62QHvw8uBJoKFifmzggGKVC2",
    contract: "0x2C79098BcD3EF23A11125eb51BD312edFD5B402A",
    chainId: 56,
    wChainId: 4,
    decimals: 9,
    logoURI: "https://assets.coingecko.com/coins/images/20978/small/chicks.png?1638162821",
    coingeckoId: "solchicks-token",
    realOriginContractAddress: "cxxShYRVcepDudXhe7U62QHvw8uBJoKFifmzggGKVC2",
    realOriginChainId: 1,
    supportsPermit: !0
  },
  {
    name: "Solcial (Portal from solana)",
    symbol: "SLCL",
    mint: "SLCLww7nc1PD2gQPQdGayHviVVcpMthnqUz2iWKhNQV",
    contract: "0x7c15ba1941f249B8653728B2e4B0e43529136C53",
    chainId: 56,
    wChainId: 4,
    decimals: 9,
    logoURI: "https://assets.coingecko.com/coins/images/24583/small/1_N9szP0_400x400.jpg?1648217020",
    coingeckoId: "solcial",
    realOriginContractAddress: "SLCLww7nc1PD2gQPQdGayHviVVcpMthnqUz2iWKhNQV",
    realOriginChainId: 1,
    supportsPermit: !0
  },
  {
    name: "SolClout (Portal from solana)",
    symbol: "SCT",
    mint: "4Te4KJgjtnZe4aE2zne8G4NPfrPjCwDmaiEx9rKnyDVZ",
    contract: "0x43274dA7818fb8F1d1121D93245ED7c8422EBAf0",
    chainId: 56,
    wChainId: 4,
    decimals: 9,
    logoURI: "https://assets.coingecko.com/coins/images/21638/small/solclout.jpg?1639630028",
    coingeckoId: "solclout",
    realOriginContractAddress: "4Te4KJgjtnZe4aE2zne8G4NPfrPjCwDmaiEx9rKnyDVZ",
    realOriginChainId: 1,
    supportsPermit: !0
  },
  {
    name: "Tulip Protocol (Portal from solana)",
    symbol: "TULIP",
    mint: "TuLipcqtGVXP9XR62wM8WWCm6a9vhLs7T1uoWBk6FDs",
    contract: "0x5FFF208371047b8F50B97688981a1F1a046C9568",
    chainId: 56,
    wChainId: 4,
    decimals: 6,
    logoURI: "https://assets.coingecko.com/coins/images/15764/small/TqrUdBG.png?1621827144",
    coingeckoId: "solfarm",
    realOriginContractAddress: "TuLipcqtGVXP9XR62wM8WWCm6a9vhLs7T1uoWBk6FDs",
    realOriginChainId: 1,
    supportsPermit: !0
  },
  {
    name: "Solpad Finance (Portal from solana)",
    symbol: "SOLPAD",
    mint: "GfJ3Vq2eSTYf1hJP6kKLE9RT6u7jF9gNszJhZwo5VPZp",
    contract: "0x282C7A0132f7086c2E7460AD5E324442C521f87E",
    chainId: 56,
    wChainId: 4,
    decimals: 9,
    logoURI: "https://assets.coingecko.com/coins/images/16368/small/solpad.PNG?1623820231",
    coingeckoId: "solpad-finance",
    realOriginContractAddress: "GfJ3Vq2eSTYf1hJP6kKLE9RT6u7jF9gNszJhZwo5VPZp",
    realOriginChainId: 1,
    supportsPermit: !0
  },
  {
    name: "Solrise Finance (Portal from solana)",
    symbol: "SLRS",
    mint: "SLRSSpSLUTP7okbCUBYStWCo1vUgyt775faPqz8HUMr",
    contract: "0x4eEe11381556EbDb078B6170E55f3E1805e1112b",
    chainId: 56,
    wChainId: 4,
    decimals: 6,
    logoURI: "https://assets.coingecko.com/coins/images/15762/small/9989.png?1621825696",
    coingeckoId: "solrise-finance",
    realOriginContractAddress: "SLRSSpSLUTP7okbCUBYStWCo1vUgyt775faPqz8HUMr",
    realOriginChainId: 1,
    supportsPermit: !0
  },
  {
    name: "Star Atlas (Portal from solana)",
    symbol: "ATLAS",
    mint: "ATLASXmbPQxBUYbxPsV97usA3fPQYEqzQBUHgiFCUsXx",
    contract: "0x83850D97018f665EB746FBb8f18351e977d1b0D6",
    chainId: 56,
    wChainId: 4,
    decimals: 8,
    logoURI: "https://assets.coingecko.com/coins/images/17659/small/Icon_Reverse.png?1628759092",
    coingeckoId: "star-atlas",
    realOriginContractAddress: "ATLASXmbPQxBUYbxPsV97usA3fPQYEqzQBUHgiFCUsXx",
    realOriginChainId: 1,
    supportsPermit: !0
  },
  {
    name: "Starbots (Portal from solana)",
    symbol: "BOT",
    mint: "AkhdZGVbJXPuQZ53u2LrimCjkRP6ZyxG1SoM85T98eE1",
    contract: "0xDbCcd9131405DD1fE7320090Af337952B9845DFA",
    chainId: 56,
    wChainId: 4,
    decimals: 8,
    logoURI: "https://assets.coingecko.com/coins/images/21823/small/coin_%286%29.png?1640076014",
    coingeckoId: "starbots",
    realOriginContractAddress: "AkhdZGVbJXPuQZ53u2LrimCjkRP6ZyxG1SoM85T98eE1",
    realOriginChainId: 1,
    supportsPermit: !0
  },
  {
    name: "Step Finance (Portal from solana)",
    symbol: "STEP",
    mint: "StepAscQoEioFxxWGnh2sLBDFp9d8rvKz2Yp39iDpyT",
    contract: "0xBad2D28192bf0068Ff00284137f081318dE787a1",
    chainId: 56,
    wChainId: 4,
    decimals: 9,
    logoURI: "https://assets.coingecko.com/coins/images/14988/small/step.png?1619274762",
    coingeckoId: "step-finance",
    realOriginContractAddress: "StepAscQoEioFxxWGnh2sLBDFp9d8rvKz2Yp39iDpyT",
    realOriginChainId: 1,
    supportsPermit: !0
  },
  {
    name: "STEPN (Portal from solana)",
    symbol: "GMT",
    mint: "7i5KKsX2weiTkry7jA4ZwSuXGhs5eJBEjY8vVxR4pfRx",
    contract: "0xB84Acac47ebC20C1AeA46e20F622B6DfaACec83F",
    chainId: 56,
    wChainId: 4,
    decimals: 9,
    logoURI: "https://assets.coingecko.com/coins/images/23597/small/gmt.png?1644658792",
    coingeckoId: "stepn",
    realOriginContractAddress: "7i5KKsX2weiTkry7jA4ZwSuXGhs5eJBEjY8vVxR4pfRx",
    realOriginChainId: 1,
    supportsPermit: !0
  },
  {
    name: "Sunny Aggregator (Portal from solana)",
    symbol: "SUNNY",
    mint: "SUNNYWgPQmFxe9wTZzNK7iPnJ3vYDrkgnxJRJm1s3ag",
    contract: "0x8e18E1F0fa101d683D1aBde0b061F66aa6380dCA",
    chainId: 56,
    wChainId: 4,
    decimals: 6,
    logoURI: "https://assets.coingecko.com/coins/images/18039/small/90dbe787-8e5f-473c-b923-fe138a7a30ea.png?1630314924",
    coingeckoId: "sunny-aggregator",
    realOriginContractAddress: "SUNNYWgPQmFxe9wTZzNK7iPnJ3vYDrkgnxJRJm1s3ag",
    realOriginChainId: 1,
    supportsPermit: !0
  },
  {
    name: "Sushi (Portal from Ethereum)",
    symbol: "SUSHI",
    mint: "ChVzxWRmrTeSgwd3Ui3UumcN8KX7VK3WaD4KGeSKpypj",
    contract: "0x3524fd7488fdb1F4723BBc22C9cbD1Bf89f46E3B",
    chainId: 56,
    wChainId: 4,
    decimals: 18,
    logoURI: "https://assets.coingecko.com/coins/images/12271/small/512x512_Logo_no_chop.png?1606986688",
    coingeckoId: "sushi",
    realOriginContractAddress: "0x6b3595068778dd592e39a122f4f5a5cf09c90fe2",
    realOriginChainId: 2,
    supportsPermit: !0
  },
  {
    name: "Synchrony (Portal from solana)",
    symbol: "SCY",
    mint: "SCYfrGCw8aDiqdgcpdGjV6jp4UVVQLuphxTDLNWu36f",
    contract: "0x37019eB29bA72EE648D84A3FC82c500939FB953e",
    chainId: 56,
    wChainId: 4,
    decimals: 9,
    logoURI: "https://assets.coingecko.com/coins/images/19308/small/SYNCHRONY-LOGO.png?1634973091",
    coingeckoId: "synchrony",
    realOriginContractAddress: "SCYfrGCw8aDiqdgcpdGjV6jp4UVVQLuphxTDLNWu36f",
    realOriginChainId: 1,
    supportsPermit: !0
  },
  {
    name: "Synex Coin (Portal from solana)",
    symbol: "MINECRAFT",
    mint: "FTkj421DxbS1wajE74J34BJ5a1o9ccA97PkK6mYq9hNQ",
    contract: "0x60e5EF0Ae3DEaFe3Eec96DF2921E8D33F503BFd1",
    chainId: 56,
    wChainId: 4,
    decimals: 9,
    logoURI: "https://assets.coingecko.com/coins/images/21247/small/logo_-_2021-12-06T135451.604.png?1638770098",
    coingeckoId: "synex-coin",
    realOriginContractAddress: "FTkj421DxbS1wajE74J34BJ5a1o9ccA97PkK6mYq9hNQ",
    realOriginChainId: 1,
    supportsPermit: !0
  },
  {
    name: "Synthetic USD (Portal from solana)",
    symbol: "XUSD",
    mint: "83LGLCm7QKpYZbX8q4W2kYWbtt8NJBwbVwEepzkVnJ9y",
    contract: "0x3DFcC17EB686d260d080a830826F21473c064D49",
    chainId: 56,
    wChainId: 4,
    decimals: 6,
    logoURI: "https://assets.coingecko.com/coins/images/19596/small/uJzDI4j.png?1635488810",
    coingeckoId: "synthetic-usd",
    realOriginContractAddress: "83LGLCm7QKpYZbX8q4W2kYWbtt8NJBwbVwEepzkVnJ9y",
    realOriginChainId: 1,
    supportsPermit: !0
  },
  {
    name: "Synthetify (Portal from solana)",
    symbol: "SNY",
    mint: "4dmKkXNHdgYsXqBHCuMikNQWwVomZURhYvkkX5c4pQ7y",
    contract: "0xacaCa3260a41715215A38BfB82d2221FC20c93CC",
    chainId: 56,
    wChainId: 4,
    decimals: 6,
    logoURI: "https://assets.coingecko.com/coins/images/14835/small/synthetify_token.png?1618611507",
    coingeckoId: "synthetify-token",
    realOriginContractAddress: "4dmKkXNHdgYsXqBHCuMikNQWwVomZURhYvkkX5c4pQ7y",
    realOriginChainId: 1,
    supportsPermit: !0
  },
  {
    name: "Sypool (Portal from solana)",
    symbol: "SYP",
    mint: "FnKE9n6aGjQoNWRBZXy4RW6LZVao7qwBonUbiD7edUmZ",
    contract: "0xBA1Ee032E9eD59AD0c0216e55C561767529615FB",
    chainId: 56,
    wChainId: 4,
    decimals: 9,
    logoURI: "https://assets.coingecko.com/coins/images/18518/small/sypool.PNG?1632268218",
    coingeckoId: "sypool",
    realOriginContractAddress: "FnKE9n6aGjQoNWRBZXy4RW6LZVao7qwBonUbiD7edUmZ",
    realOriginChainId: 1,
    supportsPermit: !0
  },
  {
    name: "Tap Fantasy MC (Portal from solana)",
    symbol: "TFMC",
    mint: "FYUkUybywqUUyrUwiAezbvhTp2DUgx1eg8tQNiKkXqJ9",
    contract: "0x0b450b428E48E6986C9bC15CA560c7e2C1bE705b",
    chainId: 56,
    wChainId: 4,
    decimals: 9,
    logoURI: "https://assets.coingecko.com/coins/images/26483/small/Tap-Fantasy-MC-Logo.png?1658279327",
    coingeckoId: "tap-fantasy-mc",
    realOriginContractAddress: "FYUkUybywqUUyrUwiAezbvhTp2DUgx1eg8tQNiKkXqJ9",
    realOriginChainId: 1,
    supportsPermit: !0
  },
  {
    name: "Tether (Portal from Polygon)",
    symbol: "USDT",
    mint: "5goWRao6a3yNC4d6UjMdQxonkCMvKBwdpubU3qhfcdf1",
    contract: "0xD343968e46690D6C89A88a36a5B8CE5Fb5D65AC4",
    chainId: 56,
    wChainId: 4,
    decimals: 6,
    logoURI: "https://assets.coingecko.com/coins/images/325/small/Tether.png?1668148663",
    coingeckoId: "tether",
    realOriginContractAddress: "0xc2132d05d31c914a87c6611c10748aeb04b58e8f",
    realOriginChainId: 5,
    supportsPermit: !0
  },
  {
    name: "Tether",
    symbol: "USDT",
    mint: "8qJSyQprMC57TWKaYEmetUR3UUiTP2M3hXdcvFhkZdmv",
    contract: "0x55d398326f99059ff775485246999027b3197955",
    chainId: 56,
    wChainId: 4,
    decimals: 18,
    logoURI: "https://assets.coingecko.com/coins/images/325/small/Tether-logo.png?1598003707",
    coingeckoId: "tether",
    realOriginContractAddress: "0x55d398326f99059ff775485246999027b3197955",
    realOriginChainId: 4,
    supportsPermit: !1
  },
  {
    name: "Tether (Portal from Ethereum)",
    symbol: "USDT",
    mint: "Dn4noZ5jgGfkntzcQSUZ8czkreiZ1ForXYoV2H8Dm7S1",
    contract: "0x524bC91Dc82d6b90EF29F76A3ECAaBAffFD490Bc",
    chainId: 56,
    wChainId: 4,
    decimals: 6,
    logoURI: "https://assets.coingecko.com/coins/images/325/small/Tether-logo.png?1598003707",
    coingeckoId: "tether",
    realOriginContractAddress: "0xdac17f958d2ee523a2206206994597c13d831ec7",
    realOriginChainId: 2,
    supportsPermit: !0
  },
  {
    name: "Tether (Portal from solana)",
    symbol: "USDT",
    mint: "Es9vMFrzaCERmJfrF4H2FYD4KCoNkY11McCe8BenwNYB",
    contract: "0x49d5cC521F75e13fa8eb4E89E9D381352C897c96",
    chainId: 56,
    wChainId: 4,
    decimals: 6,
    logoURI: "https://assets.coingecko.com/coins/images/325/small/Tether-logo.png?1598003707",
    coingeckoId: "tether",
    realOriginContractAddress: "Es9vMFrzaCERmJfrF4H2FYD4KCoNkY11McCe8BenwNYB",
    realOriginChainId: 1,
    supportsPermit: !0
  },
  {
    name: "The Sandbox (Portal from Ethereum)",
    symbol: "SAND",
    mint: "49c7WuCZkQgc3M4qH8WuEUNXfgwupZf1xqWkDQ7gjRGt",
    contract: "0x306891aaE4d076FA431277E482C847e931f2883D",
    chainId: 56,
    wChainId: 4,
    decimals: 18,
    logoURI: "https://assets.coingecko.com/coins/images/12129/small/sandbox_logo.jpg?1597397942",
    coingeckoId: "the-sandbox",
    realOriginContractAddress: "0x3845badade8e6dff049820680d1f14bd3903a5d0",
    realOriginChainId: 2,
    supportsPermit: !0
  },
  {
    name: "tudaBirds (Portal from solana)",
    symbol: "BURD",
    mint: "Qikhhhg9Ta3Jg7WoDFbSYuCAE14hx9hPvdz1zVp3zUw",
    contract: "0x5b1C54F37EE79bF2836325a597a6a0ba53139c62",
    chainId: 56,
    wChainId: 4,
    decimals: 9,
    logoURI: "https://assets.coingecko.com/coins/images/22839/small/_TOvRxfx_400x400.jpg?1642745695",
    coingeckoId: "tudabirds",
    realOriginContractAddress: "Qikhhhg9Ta3Jg7WoDFbSYuCAE14hx9hPvdz1zVp3zUw",
    realOriginChainId: 1,
    supportsPermit: !0
  },
  {
    name: "Uniswap (Portal from Ethereum)",
    symbol: "UNI",
    mint: "8FU95xFJhUUkyyCLU13HSzDLs7oC4QZdXQHL6SCeab36",
    contract: "0xB8C9eafe23670f5287034844742d3Df497260389",
    chainId: 56,
    wChainId: 4,
    decimals: 18,
    logoURI: "https://assets.coingecko.com/coins/images/12504/small/uniswap-uni.png?1600306604",
    coingeckoId: "uniswap",
    realOriginContractAddress: "0x1f9840a85d5af5bf1d1762f925bdaddc4201f984",
    realOriginChainId: 2,
    supportsPermit: !0
  },
  {
    name: "Bridged USDC (Portal from Polygon)",
    symbol: "USDC.e",
    mint: "E2VmbootbVCBkMNNxKQgCLMS1X3NoGMaYAsufaAsf7M",
    contract: "0x672147dD47674757C457eB155BAA382cc10705Dd",
    chainId: 56,
    wChainId: 4,
    decimals: 6,
    logoURI: "https://assets.coingecko.com/coins/images/6319/small/USD_Coin_icon.png?1547042389",
    coingeckoId: "usd-coin",
    realOriginContractAddress: "0x2791bca1f2de4661ed88a30c99a7a9449aa84174",
    realOriginChainId: 5,
    supportsPermit: !0
  },
  {
    name: "USD Coin (Portal from Ethereum)",
    symbol: "USDC",
    mint: "A9mUU4qviSctJVPJdBJWkb28deg915LYJKrzQ19ji3FM",
    contract: "0xB04906e95AB5D797aDA81508115611fee694c2b3",
    chainId: 56,
    wChainId: 4,
    decimals: 6,
    logoURI: "https://assets.coingecko.com/coins/images/6319/small/USD_Coin_icon.png?1547042389",
    coingeckoId: "usd-coin",
    realOriginContractAddress: "0xa0b86991c6218b36c1d19d4a2e9eb0ce3606eb48",
    realOriginChainId: 2,
    supportsPermit: !0
  },
  {
    name: "USD Coin (Portal from solana)",
    symbol: "USDC",
    mint: "EPjFWdd5AufqSSqeM2qN1xzybapC8G4wEGGkZwyTDt1v",
    contract: "0x91Ca579B0D47E5cfD5D0862c21D5659d39C8eCf0",
    chainId: 56,
    wChainId: 4,
    decimals: 6,
    logoURI: "https://assets.coingecko.com/coins/images/6319/small/USD_Coin_icon.png?1547042389",
    coingeckoId: "usd-coin",
    realOriginContractAddress: "EPjFWdd5AufqSSqeM2qN1xzybapC8G4wEGGkZwyTDt1v",
    realOriginChainId: 1,
    supportsPermit: !0
  },
  {
    name: "USDH (Portal from solana)",
    symbol: "USDH",
    mint: "USDH1SM1ojwWUga67PGrgFWUHibbjqMvuMaDkRJTgkX",
    contract: "0xb6C8A0B4D451e571fedcE9deC318745a6C6b0036",
    chainId: 56,
    wChainId: 4,
    decimals: 6,
    logoURI: "https://assets.coingecko.com/coins/images/22941/small/USDH_icon.png?1643008131",
    coingeckoId: "usdh",
    realOriginContractAddress: "USDH1SM1ojwWUga67PGrgFWUHibbjqMvuMaDkRJTgkX",
    realOriginChainId: 1,
    supportsPermit: !0
  },
  {
    name: "Waggle Network (Portal from solana)",
    symbol: "WAG",
    mint: "5tN42n9vMi6ubp67Uy4NnmM5DMZYN8aS8GeB3bEDHr6E",
    contract: "0x705290CE4cA50E7ddFeea58e4c2359fe3c9D4DA1",
    chainId: 56,
    wChainId: 4,
    decimals: 9,
    logoURI: "https://assets.coingecko.com/coins/images/18696/small/waggle.PNG?1633750177",
    coingeckoId: "waggle-network",
    realOriginContractAddress: "5tN42n9vMi6ubp67Uy4NnmM5DMZYN8aS8GeB3bEDHr6E",
    realOriginChainId: 1,
    supportsPermit: !0
  },
  {
    name: "Wrapped BNB",
    symbol: "WBNB",
    mint: "9gP2kCy3wA1ctvYWQk75guqXuHfrEomqydHLtcTCqiLa",
    contract: "0xbb4cdb9cbd36b01bd1cbaebf2de08d9173bc095c",
    chainId: 56,
    wChainId: 4,
    decimals: 18,
    logoURI: "https://assets.coingecko.com/coins/images/12591/small/binance-coin-logo.png?1600947313",
    coingeckoId: "wbnb",
    realOriginContractAddress: "0xbb4cdb9cbd36b01bd1cbaebf2de08d9173bc095c",
    realOriginChainId: 4,
    supportsPermit: !1
  },
  {
    name: "WETH (Portal from Ethereum)",
    symbol: "WETH",
    mint: "7vfCXTUXx5WJV5JADk17DUJ4ksgau7utNKj4b963voxs",
    contract: "0x4DB5a66E937A9F4473fA95b1cAF1d1E1D62E29EA",
    chainId: 56,
    wChainId: 4,
    decimals: 18,
    logoURI: "https://assets.coingecko.com/coins/images/2518/small/weth.png?1628852295",
    coingeckoId: "weth",
    realOriginContractAddress: "0xc02aaa39b223fe8d0a0e5c4f27ead9083c756cc2",
    realOriginChainId: 2,
    supportsPermit: !0
  },
  {
    name: "WEYU",
    symbol: "WEYU",
    mint: "EHaEBhYHWA7HSphorXXosysJem6qF4agccoqDqQKCUge",
    contract: "0xfafd4cb703b25cb22f43d017e7e0d75febc26743",
    chainId: 56,
    wChainId: 4,
    decimals: 18,
    logoURI: "https://assets.coingecko.com/coins/images/18112/small/weyu.PNG?1630542552",
    coingeckoId: "weyu",
    realOriginContractAddress: "0xfafd4cb703b25cb22f43d017e7e0d75febc26743",
    realOriginChainId: 4,
    supportsPermit: !1
  },
  {
    name: "Wrapped Matic (Portal from Polygon)",
    symbol: "WMATIC",
    mint: "Gz7VkD4MacbEB6yC5XD3HcumEiYx2EtDYYrfikGsvopG",
    contract: "0xc836d8dC361E44DbE64c4862D55BA041F88Ddd39",
    chainId: 56,
    wChainId: 4,
    decimals: 18,
    logoURI: "https://assets.coingecko.com/coins/images/14073/small/matic.png?1628852392",
    coingeckoId: "wmatic",
    realOriginContractAddress: "0x0d500b1d8e8ef31e21c99d1db9a6444d3adf1270",
    realOriginChainId: 5,
    supportsPermit: !0
  },
  {
    name: "WOOF (Portal from solana)",
    symbol: "WOOF",
    mint: "9nEqaUcb16sQ3Tn1psbkWqyhPdLmfHWjKGymREjsAgTE",
    contract: "0x5a16A1814Ef033679c7d0a8AF32fE910E3C25560",
    chainId: 56,
    wChainId: 4,
    decimals: 6,
    logoURI: "https://assets.coingecko.com/coins/images/18319/small/woof-logo-svg-true-solana-radient-blackinside.png?1637655115",
    coingeckoId: "woof-token",
    realOriginContractAddress: "9nEqaUcb16sQ3Tn1psbkWqyhPdLmfHWjKGymREjsAgTE",
    realOriginChainId: 1,
    supportsPermit: !0
  },
  {
    name: "Wrapped AVAX (Portal from Avalanche)",
    symbol: "WAVAX",
    mint: "KgV1GvrHQmRBY8sHQQeUKwTm2r2h8t4C8qt12Cw1HVE",
    contract: "0x96412902aa9aFf61E13f085e70D3152C6ef2a817",
    chainId: 56,
    wChainId: 4,
    decimals: 18,
    logoURI: "https://assets.coingecko.com/coins/images/15075/small/wrapped-avax.png?1629873618",
    coingeckoId: "wrapped-avax",
    realOriginContractAddress: "0xb31f66aa3c1e785363f0875a1b74e27b85fd66c7",
    realOriginChainId: 6,
    supportsPermit: !0
  },
  {
    name: "Wrapped Bitcoin (Sollet) (Portal from solana)",
    symbol: "SOBTC",
    mint: "9n4nbM75f5Ui33ZbPYXn59EwSgE8CGsHtAeTH5YFeJ9E",
    contract: "0xA9dBcE5FE45f51Fb1FeFe8693b2bBAA9e5F8D0bB",
    chainId: 56,
    wChainId: 4,
    decimals: 6,
    logoURI: "https://assets.coingecko.com/coins/images/24917/small/opengraph.png?1649344256",
    coingeckoId: "wrapped-bitcoin-sollet",
    realOriginContractAddress: "9n4nbM75f5Ui33ZbPYXn59EwSgE8CGsHtAeTH5YFeJ9E",
    realOriginChainId: 1,
    supportsPermit: !0
  },
  {
    name: "Wrapped BUSD (Allbridge from BSC) (Portal from solana)",
    symbol: "ABBUSD",
    mint: "6nuaX3ogrr2CaoAPjtaKHAoBNWok32BMcRozuf32s2QF",
    contract: "0xeeF9B822924b7D4a9f6E22A712655efcBf7Cca3D",
    chainId: 56,
    wChainId: 4,
    decimals: 9,
    logoURI: "https://assets.coingecko.com/coins/images/23061/small/logo_-_2022-01-26T091043.556.png?1643159457",
    coingeckoId: "wrapped-busd-allbridge-from-bsc",
    realOriginContractAddress: "6nuaX3ogrr2CaoAPjtaKHAoBNWok32BMcRozuf32s2QF",
    realOriginChainId: 1,
    supportsPermit: !0
  },
  {
    name: "Wrapped Chainlink (Sollet) (Portal from solana)",
    symbol: "SOLINK",
    mint: "CWE8jPTUYhdCTZYWPTe1o5DFqfdjzWKc9WKz6rSjQUdG",
    contract: "0x001F4C92df87cE07313634e2B11752B3b0712c9e",
    chainId: 56,
    wChainId: 4,
    decimals: 6,
    logoURI: "https://assets.coingecko.com/coins/images/24705/small/qvSHhRyC_400x400.jpg?1648646324",
    coingeckoId: "wrapped-chainlink-sollet",
    realOriginContractAddress: "CWE8jPTUYhdCTZYWPTe1o5DFqfdjzWKc9WKz6rSjQUdG",
    realOriginChainId: 1,
    supportsPermit: !0
  },
  {
    name: "Wrapped CUSD (Allbridge from Celo) (Portal from solana)",
    symbol: "ACUSD",
    mint: "EwxNF8g9UfmsJVcZFTpL9Hx5MCkoQFoJi6XNWzKf1j8e",
    contract: "0xDff036520e70e33043fc9b6eC7B4C681be1bcDF5",
    chainId: 56,
    wChainId: 4,
    decimals: 9,
    logoURI: "https://assets.coingecko.com/coins/images/23057/small/7236.png?1643153224",
    coingeckoId: "wrapped-cusd-allbridge-from-celo",
    realOriginContractAddress: "EwxNF8g9UfmsJVcZFTpL9Hx5MCkoQFoJi6XNWzKf1j8e",
    realOriginChainId: 1,
    supportsPermit: !0
  },
  {
    name: "Wrapped Solana (Portal from solana)",
    symbol: "wSOL",
    mint: "So11111111111111111111111111111111111111112",
    contract: "0xfA54fF1a158B5189Ebba6ae130CEd6bbd3aEA76e",
    chainId: 56,
    wChainId: 4,
    decimals: 9,
    logoURI: "https://assets.coingecko.com/coins/images/21629/small/solana.jpg?1639626543",
    coingeckoId: "wrapped-solana",
    realOriginContractAddress: "So11111111111111111111111111111111111111112",
    realOriginChainId: 1,
    supportsPermit: !0
  },
  {
    name: "Wrapped USDT (Allbridge from Polygon) (Portal from solana)",
    symbol: "APUSDT",
    mint: "DNhZkUaxHXYvpxZ7LNnHtss8sQgdAfd1ZYS1fB7LKWUZ",
    contract: "0xDc4039357980994B3754CF98B0144E2821CB3579",
    chainId: 56,
    wChainId: 4,
    decimals: 6,
    logoURI: "https://assets.coingecko.com/coins/images/23060/small/logo_-_2022-01-26T084912.902.png?1643158161",
    coingeckoId: "wrapped-usdt-allbridge-from-polygon",
    realOriginContractAddress: "DNhZkUaxHXYvpxZ7LNnHtss8sQgdAfd1ZYS1fB7LKWUZ",
    realOriginChainId: 1,
    supportsPermit: !0
  },
  {
    name: "Wrapped YFI (Sollet) (Portal from solana)",
    symbol: "SOYFI",
    mint: "3JSf5tPeuscJGtaCp5giEiDhv51gQ4v3zWg8DGgyLfAB",
    contract: "0x359446eC76b147A055ad7dF90F38709D1907370F",
    chainId: 56,
    wChainId: 4,
    decimals: 6,
    logoURI: "https://assets.coingecko.com/coins/images/24704/small/yl4nOJno_400x400.jpg?1648646042",
    coingeckoId: "wrapped-yfi-sollet",
    realOriginContractAddress: "3JSf5tPeuscJGtaCp5giEiDhv51gQ4v3zWg8DGgyLfAB",
    realOriginChainId: 1,
    supportsPermit: !0
  },
  {
    name: "Zap",
    symbol: "ZAP",
    mint: "HxPoEHMt1vKeqjKCePcqTj6yYgn6Xqq1fKTY3Pjx4YrX",
    contract: "0xc5326b32e8baef125acd68f8bc646fd646104f1c",
    chainId: 56,
    wChainId: 4,
    decimals: 18,
    logoURI: "https://assets.coingecko.com/coins/images/2180/small/zap.png?1547036476",
    coingeckoId: "zap",
    realOriginContractAddress: "0xc5326b32e8baef125acd68f8bc646fd646104f1c",
    realOriginChainId: 4,
    supportsPermit: !1
  },
  {
    name: "Zebec Protocol (Portal from solana)",
    symbol: "ZBC",
    mint: "zebeczgi5fSEtbpfQKVZKCJ3WgYXxjkMUkNNx7fLKAF",
    contract: "0x6D1054C3102E842314e250b9e9C4Be327b8DaaE2",
    chainId: 56,
    wChainId: 4,
    decimals: 9,
    logoURI: "https://assets.coingecko.com/coins/images/24342/small/zbc.PNG?1647400775",
    coingeckoId: "zebec-protocol",
    realOriginContractAddress: "zebeczgi5fSEtbpfQKVZKCJ3WgYXxjkMUkNNx7fLKAF",
    realOriginChainId: 1,
    supportsPermit: !0
  },
  {
    name: "Basket (Portal from Solana)",
    symbol: "BSKT",
    mint: "6gnCPhXtLnUD76HjQuSYPENLSZdG8RvDB1pTLM5aLSJA",
    contract: "0xaF42A5df3C1C1427DA8FC0326bD7b030A9367e78",
    chainId: 56,
    wChainId: 4,
    decimals: 5,
    logoURI: "https://assets.coingecko.com/coins/images/34661/small/BSKT_Logo.png?1705636891",
    coingeckoId: "basket",
    realOriginContractAddress: "6gnCPhXtLnUD76HjQuSYPENLSZdG8RvDB1pTLM5aLSJA",
    realOriginChainId: 1,
    supportsPermit: !0
  },
  {
    name: "WETH (Portal from Optimism)",
    symbol: "WETH",
    mint: "8M6d63oL7dvMZ1gNbgGe3h8afMSWJEKEhtPTFM2u8h3c",
    contract: "0x94AEc09B5e2CE591e39DC6aa58A3A6E85Ed45265",
    chainId: 56,
    wChainId: 4,
    decimals: 18,
    logoURI: "https://assets.coingecko.com/coins/images/2518/small/weth.png?1696503332",
    coingeckoId: "weth",
    realOriginContractAddress: "0x4200000000000000000000000000000000000006",
    realOriginChainId: 24,
    supportsPermit: !0
  },
  {
    name: "USDC (Portal from Optimism)",
    symbol: "USDC",
    mint: "J8kcD4Wnd1ehne1dpL8WNtgZQR6Jpui2cTZcrmg5ybAa",
    contract: "0xa41ae127D04F7ee73B5058E2C60Fb7c7A2D21F79",
    chainId: 56,
    wChainId: 4,
    decimals: 6,
    logoURI: "https://assets.coingecko.com/coins/images/6319/small/usdc.png?1696506694",
    coingeckoId: "usd-coin",
    realOriginContractAddress: "0x0b2c639c533813f4aa9d7837caf62653d097ff85",
    realOriginChainId: 24,
    supportsPermit: !0
  },
  {
    name: "Bridged USDC (Optimism) (Portal from Optimism)",
    symbol: "USDC.E",
    mint: "D6YyAUMTJipLQfUhYs6psdnwpmMz6KbM4Qs9AtCmPpxR",
    contract: "0xf697E6070599a192Dbc0907609e7A0bB4CFC4b41",
    chainId: 56,
    wChainId: 4,
    decimals: 6,
    logoURI: "https://assets.coingecko.com/coins/images/31580/small/USDC-icon.png?1696530397",
    coingeckoId: "bridged-usd-coin-optimism",
    realOriginContractAddress: "0x7f5c764cbc14f9669b88837ca1490cca17c31607",
    realOriginChainId: 24,
    supportsPermit: !0
  },
  {
    name: "Tether (Portal from Optimism)",
    symbol: "USDT",
    mint: "CLV6gB88nQtnuo3akGLSVRFaiFPTXaBXV4EDaFxV7iRq",
    contract: "0xe38FEb1B0Fa77979c39Df0EBd61Bf8BAeE25B675",
    chainId: 56,
    wChainId: 4,
    decimals: 6,
    logoURI: "https://assets.coingecko.com/coins/images/325/small/Tether.png?1696501661",
    coingeckoId: "tether",
    realOriginContractAddress: "0x94b008aa00579c1307b0ef2c499ad98a8ce58e58",
    realOriginChainId: 24,
    supportsPermit: !0
  }
], solana = [
  {
    name: "SOL",
    symbol: "SOL",
    mint: "So11111111111111111111111111111111111111112",
    contract: "0x0000000000000000000000000000000000000000",
    chainId: 0,
    wChainId: 1,
    decimals: 9,
    logoURI: "https://statics.mayan.finance/SOL.png",
    wrappedAddress: "So11111111111111111111111111111111111111112",
    coingeckoId: "solana",
    realOriginContractAddress: "So11111111111111111111111111111111111111112",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "Drift Protocol",
    symbol: "DRIFT",
    mint: "DriFtupJYLTosbwoN8koMbEYSx54aFAVLddWsbksjwg7",
    contract: "DriFtupJYLTosbwoN8koMbEYSx54aFAVLddWsbksjwg7",
    chainId: 0,
    wChainId: 1,
    decimals: 6,
    logoURI: "https://assets.coingecko.com/coins/images/37509/small/DRIFT.png?1715842607",
    coingeckoId: "drift-protocol",
    realOriginContractAddress: "DriFtupJYLTosbwoN8koMbEYSx54aFAVLddWsbksjwg7",
    realOriginChainId: 1
  },
  {
    name: "Wormhole",
    symbol: "W",
    mint: "85VBFQZC9TZkfaptBWjvUw7YbZjy52A6mjtPGjstQAmQ",
    contract: "85VBFQZC9TZkfaptBWjvUw7YbZjy52A6mjtPGjstQAmQ",
    chainId: 0,
    wChainId: 1,
    decimals: 6,
    logoURI: "https://assets.coingecko.com/coins/images/35087/small/womrhole_logo_full_color_rgb_2000px_72ppi_fb766ac85a.png?1708688954",
    coingeckoId: "wormhole",
    realOriginContractAddress: "85VBFQZC9TZkfaptBWjvUw7YbZjy52A6mjtPGjstQAmQ",
    realOriginChainId: 1
  },
  {
    name: "Jupiter",
    symbol: "JUP",
    mint: "JUPyiwrYJFskUPiHa7hkeR8VUtAeFoSYbKedZNsDvCN",
    contract: "JUPyiwrYJFskUPiHa7hkeR8VUtAeFoSYbKedZNsDvCN",
    chainId: 0,
    wChainId: 1,
    decimals: 6,
    logoURI: "https://assets.coingecko.com/coins/images/34188/small/jup.png?1704266489",
    coingeckoId: "jupiter-exchange-solana",
    realOriginContractAddress: "JUPyiwrYJFskUPiHa7hkeR8VUtAeFoSYbKedZNsDvCN",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "Basket",
    symbol: "BSKT",
    mint: "6gnCPhXtLnUD76HjQuSYPENLSZdG8RvDB1pTLM5aLSJA",
    contract: "6gnCPhXtLnUD76HjQuSYPENLSZdG8RvDB1pTLM5aLSJA",
    chainId: 0,
    wChainId: 1,
    decimals: 5,
    logoURI: "https://assets.coingecko.com/coins/images/34661/small/BSKT_Logo.png?1705636891",
    coingeckoId: "basket",
    realOriginContractAddress: "6gnCPhXtLnUD76HjQuSYPENLSZdG8RvDB1pTLM5aLSJA",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "Wen",
    symbol: "$WEN",
    mint: "WENWENvqqNya429ubCdR81ZmD69brwQaaBYY6p3LCpk",
    contract: "WENWENvqqNya429ubCdR81ZmD69brwQaaBYY6p3LCpk",
    chainId: 0,
    wChainId: 1,
    decimals: 5,
    logoURI: "https://assets.coingecko.com/coins/images/34856/small/wen.jpeg?1706281701",
    coingeckoId: "wen-4",
    realOriginContractAddress: "WENWENvqqNya429ubCdR81ZmD69brwQaaBYY6p3LCpk",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "USDC (Portal from Arbitrum)",
    symbol: "USDC",
    mint: "CR4xnGrhsu1fWNPoX4KbTUUtqGMF3mzRLfj4S6YEs1Yo",
    contract: "CR4xnGrhsu1fWNPoX4KbTUUtqGMF3mzRLfj4S6YEs1Yo",
    chainId: 0,
    wChainId: 1,
    decimals: 6,
    logoURI: "https://assets.coingecko.com/coins/images/6319/small/usdc.png?1696506694",
    coingeckoId: "usd-coin",
    realOriginContractAddress: "0xaf88d065e77c8cc2239327c5edb3a432268e5831",
    realOriginChainId: 23,
    supportsPermit: !1
  },
  {
    name: "LessFnGas",
    symbol: "LFG",
    mint: "LFG1ezantSY2LPX8jRz2qa31pPEhpwN9msFDzZw4T9Q",
    contract: "LFG1ezantSY2LPX8jRz2qa31pPEhpwN9msFDzZw4T9Q",
    chainId: 0,
    wChainId: 1,
    decimals: 7,
    logoURI: "https://assets.coingecko.com/coins/images/34141/small/gpjWSfjo_400x400.jpg?1704180211",
    coingeckoId: "lessfngas",
    realOriginContractAddress: "LFG1ezantSY2LPX8jRz2qa31pPEhpwN9msFDzZw4T9Q",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "Popo, Pepe's Dog",
    symbol: "$POPO",
    mint: "96QoNkZLTKH7Gecf6dKMRXBQXW1wqh378uF9pnTejgAw",
    contract: "96QoNkZLTKH7Gecf6dKMRXBQXW1wqh378uF9pnTejgAw",
    chainId: 0,
    wChainId: 1,
    decimals: 9,
    logoURI: "https://assets.coingecko.com/coins/images/33898/small/msg-4035486419-2265.jpg?1703236543",
    coingeckoId: "popo-pepe-s-dog",
    realOriginContractAddress: "96QoNkZLTKH7Gecf6dKMRXBQXW1wqh378uF9pnTejgAw",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "Jito",
    symbol: "JTO",
    mint: "jtojtomepa8beP8AuQc6eXt5FriJwfFMwQx2v2f9mCL",
    contract: "jtojtomepa8beP8AuQc6eXt5FriJwfFMwQx2v2f9mCL",
    chainId: 0,
    wChainId: 1,
    decimals: 9,
    logoURI: "https://assets.coingecko.com/coins/images/33228/small/jto.png?1701137022",
    coingeckoId: "jito-governance-token",
    realOriginContractAddress: "jtojtomepa8beP8AuQc6eXt5FriJwfFMwQx2v2f9mCL",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "Solanacorn",
    symbol: "CORN",
    mint: "6DSqVXg9WLTWgz6LACqxN757QdHe1sCqkUfojWmxWtok",
    contract: "6DSqVXg9WLTWgz6LACqxN757QdHe1sCqkUfojWmxWtok",
    chainId: 0,
    wChainId: 1,
    decimals: 7,
    logoURI: "https://assets.coingecko.com/coins/images/33100/small/200x200.png?1700948230",
    coingeckoId: "solanacorn",
    realOriginContractAddress: "6DSqVXg9WLTWgz6LACqxN757QdHe1sCqkUfojWmxWtok",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "Liquid Solana Derivative",
    symbol: "LSD",
    mint: "DDti34vnkrCehR8fih6dTGpPuc3w8tL4XQ4QLQhc3xPa",
    contract: "DDti34vnkrCehR8fih6dTGpPuc3w8tL4XQ4QLQhc3xPa",
    chainId: 0,
    wChainId: 1,
    decimals: 9,
    logoURI: "https://assets.coingecko.com/coins/images/33209/small/IMG_3480.jpeg?1701083888",
    coingeckoId: "liquid-solana-derivative",
    realOriginContractAddress: "DDti34vnkrCehR8fih6dTGpPuc3w8tL4XQ4QLQhc3xPa",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "Myro",
    symbol: "$MYRO",
    mint: "HhJpBhRRn4g56VsyLuT8DL5Bv31HkXqsrahTTUCZeZg4",
    contract: "HhJpBhRRn4g56VsyLuT8DL5Bv31HkXqsrahTTUCZeZg4",
    chainId: 0,
    wChainId: 1,
    decimals: 9,
    logoURI: "https://assets.coingecko.com/coins/images/32878/small/MYRO_200x200.png?1699709942",
    coingeckoId: "myro",
    realOriginContractAddress: "HhJpBhRRn4g56VsyLuT8DL5Bv31HkXqsrahTTUCZeZg4",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "Ponk",
    symbol: "PONK",
    mint: "HeqCcMjmuV5s25J49YiJyT6bD5qWLkP88YPajBySniaV",
    contract: "HeqCcMjmuV5s25J49YiJyT6bD5qWLkP88YPajBySniaV",
    chainId: 0,
    wChainId: 1,
    decimals: 5,
    logoURI: "https://assets.coingecko.com/coins/images/33065/small/PONK_%284%29.png?1700498498",
    coingeckoId: "ponk",
    realOriginContractAddress: "HeqCcMjmuV5s25J49YiJyT6bD5qWLkP88YPajBySniaV",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "Jupiter Perps",
    symbol: "JLP",
    mint: "27G8MtK7VtTcCHkpASjSDdkWWYfoqT6ggEuKidVJidD4",
    contract: "27G8MtK7VtTcCHkpASjSDdkWWYfoqT6ggEuKidVJidD4",
    chainId: 0,
    wChainId: 1,
    decimals: 6,
    logoURI: "https://assets.coingecko.com/coins/images/33094/small/jlp.png?1700631386",
    coingeckoId: "jupiter-perpetuals-liquidity-provider-token",
    realOriginContractAddress: "27G8MtK7VtTcCHkpASjSDdkWWYfoqT6ggEuKidVJidD4",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "Pyth Network",
    symbol: "PYTH",
    mint: "HZ1JovNiVvGrGNiiYvEozEVgZ58xaU3RKwX8eACQBCt3",
    contract: "HZ1JovNiVvGrGNiiYvEozEVgZ58xaU3RKwX8eACQBCt3",
    chainId: 0,
    wChainId: 1,
    decimals: 6,
    logoURI: "https://assets.coingecko.com/coins/images/31924/small/Pyth_Logomark_%281%29.png?1696530732",
    coingeckoId: "pyth-network",
    realOriginContractAddress: "HZ1JovNiVvGrGNiiYvEozEVgZ58xaU3RKwX8eACQBCt3",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "Wrapped Bitcoin (Portal from Ethereum)",
    symbol: "WBTC",
    mint: "3NZ9JMVBmGAqocybic2c7LQCJScmgsAZ6vQqTDzcqmJh",
    contract: "3NZ9JMVBmGAqocybic2c7LQCJScmgsAZ6vQqTDzcqmJh",
    chainId: 0,
    wChainId: 1,
    decimals: 8,
    logoURI: "https://assets.coingecko.com/coins/images/7598/small/wrapped_bitcoin_wbtc.png?1548822744",
    coingeckoId: "wrapped-bitcoin",
    realOriginContractAddress: "0x2260fac5e5542a773aa44fbcfedf7c193bc2c599",
    realOriginChainId: 2,
    supportsPermit: !1
  },
  {
    name: "Helium",
    symbol: "HNT",
    mint: "hntyVP6YFm1Hg25TN9WGLqM12b8TQmcknKrdu1oxWux",
    contract: "hntyVP6YFm1Hg25TN9WGLqM12b8TQmcknKrdu1oxWux",
    chainId: 0,
    wChainId: 1,
    decimals: 8,
    logoURI: "https://assets.coingecko.com/coins/images/4284/small/Helium_HNT.png?1612620071",
    coingeckoId: "helium",
    realOriginContractAddress: "hntyVP6YFm1Hg25TN9WGLqM12b8TQmcknKrdu1oxWux",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "SWEETS",
    symbol: "$SWTS",
    mint: "5SwxhEunuUUcWe4ojybdDwky6dpLxAehNmF4AA71STNh",
    contract: "5SwxhEunuUUcWe4ojybdDwky6dpLxAehNmF4AA71STNh",
    chainId: 0,
    wChainId: 1,
    decimals: 5,
    logoURI: "https://assets.coingecko.com/coins/images/30294/small/CG_SWEETS.png?1683867695",
    coingeckoId: "sweets",
    realOriginContractAddress: "5SwxhEunuUUcWe4ojybdDwky6dpLxAehNmF4AA71STNh",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "Guacamole",
    symbol: "GUAC",
    mint: "AZsHEMXd36Bj1EMNXhowJajpUXzrKcK57wW4ZGXVa7yR",
    contract: "AZsHEMXd36Bj1EMNXhowJajpUXzrKcK57wW4ZGXVa7yR",
    chainId: 0,
    wChainId: 1,
    decimals: 5,
    logoURI: "https://assets.coingecko.com/coins/images/30119/small/GUAC_Official_Logo.png?1683249431",
    coingeckoId: "guacamole",
    realOriginContractAddress: "AZsHEMXd36Bj1EMNXhowJajpUXzrKcK57wW4ZGXVa7yR",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "KING",
    symbol: "KING",
    mint: "9noXzpXnkyEcKF3AeXqUHTdR59V5uvrRBUZ9bwfQwxeq",
    contract: "9noXzpXnkyEcKF3AeXqUHTdR59V5uvrRBUZ9bwfQwxeq",
    chainId: 0,
    wChainId: 1,
    decimals: 9,
    logoURI: "https://assets.coingecko.com/coins/images/30183/small/king.png?1683600013",
    coingeckoId: "king-2",
    realOriginContractAddress: "9noXzpXnkyEcKF3AeXqUHTdR59V5uvrRBUZ9bwfQwxeq",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "WETH (Portal from Arbitrum)",
    symbol: "WETH",
    mint: "CSD6JQMvLi46psjHdpfFdr826mF336pEVMJgjwcoS1m4",
    contract: "CSD6JQMvLi46psjHdpfFdr826mF336pEVMJgjwcoS1m4",
    chainId: 0,
    wChainId: 1,
    decimals: 8,
    logoURI: "https://assets.coingecko.com/coins/images/2518/small/weth.png?1628852295",
    coingeckoId: "weth",
    realOriginContractAddress: "0x82af49447d8a07e3bd95bd0d56f35241523fbab1",
    realOriginChainId: 23,
    supportsPermit: !1
  },
  {
    name: "Tether (Portal from Arbitrum)",
    symbol: "USDT",
    mint: "H9o3LaDfoMSVLm9aBWaY56eMmPGDbRFnUHpqcTb9exXB",
    contract: "H9o3LaDfoMSVLm9aBWaY56eMmPGDbRFnUHpqcTb9exXB",
    chainId: 0,
    wChainId: 1,
    decimals: 6,
    logoURI: "https://assets.coingecko.com/coins/images/325/small/Tether.png?1668148663",
    coingeckoId: "tether",
    realOriginContractAddress: "0xfd086bc7cd5c481dcc9c85ebe478a1c0b69fcbb9",
    realOriginChainId: 23,
    supportsPermit: !1
  },
  {
    name: "USD Coin (Arb1)(Portal from Arbitrum)",
    symbol: "USDC.e",
    mint: "HAxCJjnmgkdXhwZYeJiUvBgm4NdQvqhGJCS3KxCnCxWs",
    contract: "HAxCJjnmgkdXhwZYeJiUvBgm4NdQvqhGJCS3KxCnCxWs",
    chainId: 0,
    wChainId: 1,
    decimals: 6,
    logoURI: "https://assets.coingecko.com/coins/images/6319/small/USD_Coin_icon.png?1547042389",
    coingeckoId: "usd-coin",
    realOriginContractAddress: "0xff970a61a04b1ca14834a43f5de4533ebddb5cc8",
    realOriginChainId: 23,
    supportsPermit: !1
  },
  {
    name: "USD Coin (Portal from Avalanche)",
    symbol: "USDC",
    mint: "FHfba3ov5P3RjaiLVgh8FTv4oirxQDoVXuoUUDvHuXax",
    contract: "FHfba3ov5P3RjaiLVgh8FTv4oirxQDoVXuoUUDvHuXax",
    chainId: 0,
    wChainId: 1,
    decimals: 6,
    logoURI: "https://assets.coingecko.com/coins/images/6319/small/USD_Coin_icon.png?1547042389",
    coingeckoId: "usd-coin",
    realOriginContractAddress: "0xb97ef9ef8734c71904d8002f8b6bc66dd9c48a6e",
    realOriginChainId: 6,
    supportsPermit: !1
  },
  {
    name: "Hades",
    symbol: "HADES",
    mint: "BWXrrYFhT7bMHmNBFoQFWdsSgA3yXoAnMhDK6Fn1eSEn",
    contract: "BWXrrYFhT7bMHmNBFoQFWdsSgA3yXoAnMhDK6Fn1eSEn",
    chainId: 0,
    wChainId: 1,
    decimals: 9,
    logoURI: "https://assets.coingecko.com/coins/images/28819/small/hadeswap.jpeg?1674624974",
    coingeckoId: "hades",
    realOriginContractAddress: "BWXrrYFhT7bMHmNBFoQFWdsSgA3yXoAnMhDK6Fn1eSEn",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "Tether (Portal from Avalanche)",
    symbol: "USDT",
    mint: "Kz1csQA91WUGcQ2TB3o5kdGmWmMGp8eJcDEyHzNDVCX",
    contract: "Kz1csQA91WUGcQ2TB3o5kdGmWmMGp8eJcDEyHzNDVCX",
    chainId: 0,
    wChainId: 1,
    decimals: 6,
    logoURI: "https://assets.coingecko.com/coins/images/325/small/Tether.png?1668148663",
    coingeckoId: "tether",
    realOriginContractAddress: "0x9702230a8ea53601f5cd2dc00fdbc13d4df4a8c7",
    realOriginChainId: 6,
    supportsPermit: !1
  },
  {
    name: "USD Coin (Portal from BSC)",
    symbol: "USDC",
    mint: "FCqfQSujuPxy6V42UvafBhsysWtEq1vhjfMN1PUbgaxA",
    contract: "FCqfQSujuPxy6V42UvafBhsysWtEq1vhjfMN1PUbgaxA",
    chainId: 0,
    wChainId: 1,
    decimals: 8,
    logoURI: "https://assets.coingecko.com/coins/images/6319/small/USD_Coin_icon.png?1547042389",
    coingeckoId: "usd-coin",
    realOriginContractAddress: "0x8ac76a51cc950d9822d68b83fe1ad97b32cd580d",
    realOriginChainId: 4,
    supportsPermit: !1
  },
  {
    name: "Dai (Portal from Ethereum)",
    symbol: "DAI",
    mint: "EjmyN6qEC1Tf1JxiG1ae7UTJhUxSwk1TCWNWqxWV4J6o",
    contract: "EjmyN6qEC1Tf1JxiG1ae7UTJhUxSwk1TCWNWqxWV4J6o",
    chainId: 0,
    wChainId: 1,
    decimals: 8,
    logoURI: "https://assets.coingecko.com/coins/images/9956/small/4943.png?1636636734",
    coingeckoId: "dai",
    realOriginContractAddress: "0x6b175474e89094c44da98b954eedeac495271d0f",
    realOriginChainId: 2,
    supportsPermit: !1
  },
  {
    name: "1Sol (Portal from Ethereum)",
    symbol: "1SOL",
    mint: "4ThReWAbAVZjNVgs5Ui9Pk3cZ5TYaD9u6Y89fp6EFzoF",
    contract: "4ThReWAbAVZjNVgs5Ui9Pk3cZ5TYaD9u6Y89fp6EFzoF",
    chainId: 0,
    wChainId: 1,
    decimals: 8,
    logoURI: "https://assets.coingecko.com/coins/images/21615/small/YyGDie9f_400x400.jpg?1639610633",
    coingeckoId: "1sol",
    realOriginContractAddress: "0x009178997aff09a67d4caccfeb897fb79d036214",
    realOriginChainId: 2,
    supportsPermit: !1
  },
  {
    name: "agEUR (Portal from Ethereum)",
    symbol: "AGEUR",
    mint: "CbNYA9n3927uXUukee2Hf4tm3xxkffJPPZvGazc2EAH1",
    contract: "CbNYA9n3927uXUukee2Hf4tm3xxkffJPPZvGazc2EAH1",
    chainId: 0,
    wChainId: 1,
    decimals: 8,
    logoURI: "https://assets.coingecko.com/coins/images/19479/small/agEUR.png?1635283566",
    coingeckoId: "ageur",
    realOriginContractAddress: "0x1a7e4e63778b4f12a199c062f3efdd288afcbce8",
    realOriginChainId: 2,
    supportsPermit: !1
  },
  {
    name: "Aldrin",
    symbol: "RIN",
    mint: "E5ndSkaB17Dm7CsD22dvcjfrYSDLCxFcMd6z8ddCk5wp",
    contract: "E5ndSkaB17Dm7CsD22dvcjfrYSDLCxFcMd6z8ddCk5wp",
    chainId: 0,
    wChainId: 1,
    decimals: 9,
    logoURI: "https://assets.coingecko.com/coins/images/16849/small/Aldrin.png?1629959768",
    coingeckoId: "aldrin",
    realOriginContractAddress: "E5ndSkaB17Dm7CsD22dvcjfrYSDLCxFcMd6z8ddCk5wp",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "Aleph.im (Portal from Ethereum)",
    symbol: "ALEPH",
    mint: "3UCMiSnkcnkPE1pgQ5ggPCBv6dXgVUy16TmMUe1WpG9x",
    contract: "3UCMiSnkcnkPE1pgQ5ggPCBv6dXgVUy16TmMUe1WpG9x",
    chainId: 0,
    wChainId: 1,
    decimals: 8,
    logoURI: "https://assets.coingecko.com/coins/images/11676/small/Monochram-aleph.png?1608483725",
    coingeckoId: "aleph",
    realOriginContractAddress: "0x27702a26126e0b3702af63ee09ac4d1a084ef628",
    realOriginChainId: 2,
    supportsPermit: !1
  },
  {
    name: "Alien Chicken Farm",
    symbol: "ACF",
    mint: "2cZv8HrgcWSvC6n1uEiS48cEQGb1d3fiowP2rpa4wBL9",
    contract: "2cZv8HrgcWSvC6n1uEiS48cEQGb1d3fiowP2rpa4wBL9",
    chainId: 0,
    wChainId: 1,
    decimals: 2,
    logoURI: "https://assets.coingecko.com/coins/images/25441/small/acf-token_%281%29.png?1651760005",
    coingeckoId: "alien-chicken-farm",
    realOriginContractAddress: "2cZv8HrgcWSvC6n1uEiS48cEQGb1d3fiowP2rpa4wBL9",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "ALL.ART",
    symbol: "AART",
    mint: "F3nefJBcejYbtdREjui1T9DPh5dBgpkKq7u2GAAMXs5B",
    contract: "F3nefJBcejYbtdREjui1T9DPh5dBgpkKq7u2GAAMXs5B",
    chainId: 0,
    wChainId: 1,
    decimals: 6,
    logoURI: "https://assets.coingecko.com/coins/images/22012/small/all-art.PNG?1640590472",
    coingeckoId: "all-art",
    realOriginContractAddress: "F3nefJBcejYbtdREjui1T9DPh5dBgpkKq7u2GAAMXs5B",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "Allbridge",
    symbol: "ABR",
    mint: "a11bdAAuV8iB2fu7X6AxAvDTo1QZ8FXB3kk5eecdasp",
    contract: "a11bdAAuV8iB2fu7X6AxAvDTo1QZ8FXB3kk5eecdasp",
    chainId: 0,
    wChainId: 1,
    decimals: 9,
    logoURI: "https://assets.coingecko.com/coins/images/18690/small/abr.png?1640742053",
    coingeckoId: "allbridge",
    realOriginContractAddress: "a11bdAAuV8iB2fu7X6AxAvDTo1QZ8FXB3kk5eecdasp",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "Amulet Staked SOL",
    symbol: "AMTSOL",
    mint: "SoLW9muuNQmEAoBws7CWfYQnXRXMVEG12cQhy6LE2Zf",
    contract: "SoLW9muuNQmEAoBws7CWfYQnXRXMVEG12cQhy6LE2Zf",
    chainId: 0,
    wChainId: 1,
    decimals: 9,
    logoURI: "https://assets.coingecko.com/coins/images/27786/small/amtSOL200x200.png?1665814113",
    coingeckoId: "amulet-staked-sol",
    realOriginContractAddress: "SoLW9muuNQmEAoBws7CWfYQnXRXMVEG12cQhy6LE2Zf",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "ApeXit Finance",
    symbol: "APEX",
    mint: "51tMb3zBKDiQhNwGqpgwbavaGH54mk8fXFzxTc1xnasg",
    contract: "51tMb3zBKDiQhNwGqpgwbavaGH54mk8fXFzxTc1xnasg",
    chainId: 0,
    wChainId: 1,
    decimals: 9,
    logoURI: "https://assets.coingecko.com/coins/images/16864/small/cg.png?1625470996",
    coingeckoId: "apexit-finance",
    realOriginContractAddress: "51tMb3zBKDiQhNwGqpgwbavaGH54mk8fXFzxTc1xnasg",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "Apricot",
    symbol: "APRT",
    mint: "APTtJyaRX5yGTsJU522N4VYWg3vCvSb65eam5GrPT5Rt",
    contract: "APTtJyaRX5yGTsJU522N4VYWg3vCvSb65eam5GrPT5Rt",
    chainId: 0,
    wChainId: 1,
    decimals: 6,
    logoURI: "https://assets.coingecko.com/coins/images/20636/small/hF_3FMuH_400x400.jpg?1637399870",
    coingeckoId: "apricot",
    realOriginContractAddress: "APTtJyaRX5yGTsJU522N4VYWg3vCvSb65eam5GrPT5Rt",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "APYSwap",
    symbol: "APYS",
    mint: "5JnZ667P3VcjDinkJFysWh2K2KtViy63FZ3oL5YghEhW",
    contract: "5JnZ667P3VcjDinkJFysWh2K2KtViy63FZ3oL5YghEhW",
    chainId: 0,
    wChainId: 1,
    decimals: 9,
    logoURI: "https://assets.coingecko.com/coins/images/14163/small/apys.png?1635831990",
    coingeckoId: "apyswap",
    realOriginContractAddress: "5JnZ667P3VcjDinkJFysWh2K2KtViy63FZ3oL5YghEhW",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "ARB Protocol",
    symbol: "ARB",
    mint: "9tzZzEHsKnwFL1A3DyFJwj36KnZj3gZ7g4srWp9YTEoh",
    contract: "9tzZzEHsKnwFL1A3DyFJwj36KnZj3gZ7g4srWp9YTEoh",
    chainId: 0,
    wChainId: 1,
    decimals: 6,
    logoURI: "https://assets.coingecko.com/coins/images/26046/small/IMG_3600.png?1656916820",
    coingeckoId: "arb-protocol",
    realOriginContractAddress: "9tzZzEHsKnwFL1A3DyFJwj36KnZj3gZ7g4srWp9YTEoh",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "Arenum",
    symbol: "ARNM",
    mint: "3Dy8KFyvpUJ8nfRCbvk4HLWjNRRzxiVhTeE9PQF9RARD",
    contract: "3Dy8KFyvpUJ8nfRCbvk4HLWjNRRzxiVhTeE9PQF9RARD",
    chainId: 0,
    wChainId: 1,
    decimals: 6,
    logoURI: "https://assets.coingecko.com/coins/images/24393/small/6253dcf123d4f40001e9c793_CryptoCoin_1024.png?1649733527",
    coingeckoId: "arenum",
    realOriginContractAddress: "3Dy8KFyvpUJ8nfRCbvk4HLWjNRRzxiVhTeE9PQF9RARD",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "ARTE",
    symbol: "ARTE",
    mint: "6Dujewcxn1qCd6rcj448SXQL9YYqTcqZCNQdCn3xJAKS",
    contract: "6Dujewcxn1qCd6rcj448SXQL9YYqTcqZCNQdCn3xJAKS",
    chainId: 0,
    wChainId: 1,
    decimals: 6,
    logoURI: "https://assets.coingecko.com/coins/images/23556/small/token_200.png?1644473079",
    coingeckoId: "arte",
    realOriginContractAddress: "6Dujewcxn1qCd6rcj448SXQL9YYqTcqZCNQdCn3xJAKS",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "ArtiCoin",
    symbol: "ATC",
    mint: "GXnw9YSt6DANCt84Ti6ZpbaXvrvuEJFCYqrDjygnq4R8",
    contract: "GXnw9YSt6DANCt84Ti6ZpbaXvrvuEJFCYqrDjygnq4R8",
    chainId: 0,
    wChainId: 1,
    decimals: 6,
    logoURI: "https://assets.coingecko.com/coins/images/25232/small/LOGO-256.png?1650953344",
    coingeckoId: "articoin",
    realOriginContractAddress: "GXnw9YSt6DANCt84Ti6ZpbaXvrvuEJFCYqrDjygnq4R8",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "Astrals GLXY",
    symbol: "GLXY",
    mint: "CJ5U6wPmjxFUyTJpUTS7Rt1UqhTmSVRMvmJ8WD4nndXW",
    contract: "CJ5U6wPmjxFUyTJpUTS7Rt1UqhTmSVRMvmJ8WD4nndXW",
    chainId: 0,
    wChainId: 1,
    decimals: 9,
    logoURI: "https://assets.coingecko.com/coins/images/25389/small/glxy.png?1651661031",
    coingeckoId: "astrals-glxy",
    realOriginContractAddress: "CJ5U6wPmjxFUyTJpUTS7Rt1UqhTmSVRMvmJ8WD4nndXW",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "Atlas DEX",
    symbol: "ATS",
    mint: "HJbNXx2YMRxgfUJ6K4qeWtjatMK5KYQT1QnsCdDWywNv",
    contract: "HJbNXx2YMRxgfUJ6K4qeWtjatMK5KYQT1QnsCdDWywNv",
    chainId: 0,
    wChainId: 1,
    decimals: 9,
    logoURI: "https://assets.coingecko.com/coins/images/23002/small/logo.png?1643091340",
    coingeckoId: "atlas-dex",
    realOriginContractAddress: "HJbNXx2YMRxgfUJ6K4qeWtjatMK5KYQT1QnsCdDWywNv",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "AtPay",
    symbol: "ATPAY",
    mint: "CWBzupvyXN1Cf5rsBEHbzfTFvreLfUaJ77BMNLVJ739y",
    contract: "CWBzupvyXN1Cf5rsBEHbzfTFvreLfUaJ77BMNLVJ739y",
    chainId: 0,
    wChainId: 1,
    decimals: 9,
    logoURI: "https://assets.coingecko.com/coins/images/27254/small/atpay.png?1663049746",
    coingeckoId: "atpay",
    realOriginContractAddress: "CWBzupvyXN1Cf5rsBEHbzfTFvreLfUaJ77BMNLVJ739y",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "Audius (Portal from Ethereum)",
    symbol: "AUDIO",
    mint: "9LzCMqDgTKYz9Drzqnpgee3SGa89up3a247ypMj2xrqM",
    contract: "9LzCMqDgTKYz9Drzqnpgee3SGa89up3a247ypMj2xrqM",
    chainId: 0,
    wChainId: 1,
    decimals: 8,
    logoURI: "https://assets.coingecko.com/coins/images/12913/small/AudiusCoinLogo_2x.png?1603425727",
    coingeckoId: "audius",
    realOriginContractAddress: "0x18aaa7115705e8be94bffebde57af9bfc265b998",
    realOriginChainId: 2,
    supportsPermit: !1
  },
  {
    name: "Aurory",
    symbol: "AURY",
    mint: "AURYydfxJib1ZkTir1Jn1J9ECYUtjb6rKQVmtYaixWPP",
    contract: "AURYydfxJib1ZkTir1Jn1J9ECYUtjb6rKQVmtYaixWPP",
    chainId: 0,
    wChainId: 1,
    decimals: 9,
    logoURI: "https://assets.coingecko.com/coins/images/19324/small/Ico_Blanc.png?1672824647",
    coingeckoId: "aurory",
    realOriginContractAddress: "AURYydfxJib1ZkTir1Jn1J9ECYUtjb6rKQVmtYaixWPP",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "Avenue Hamilton Token",
    symbol: "AHT",
    mint: "AHT1yynTv45s3P3KrRfQCVMHckdHeMVA3fteEg34xt9y",
    contract: "AHT1yynTv45s3P3KrRfQCVMHckdHeMVA3fteEg34xt9y",
    chainId: 0,
    wChainId: 1,
    decimals: 9,
    logoURI: "https://assets.coingecko.com/coins/images/28086/small/7FbZmTSKMsSqtlfe8yH1n3QgdBc3RBBt0B6dsdprVBs.png?1667724654",
    coingeckoId: "avenue-hamilton-token",
    realOriginContractAddress: "AHT1yynTv45s3P3KrRfQCVMHckdHeMVA3fteEg34xt9y",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "Avenue University Token",
    symbol: "AUT",
    mint: "AUT1gfMZw37wMMQqAxk89nfpjZpEEf2XSoBUd8V5ydnS",
    contract: "AUT1gfMZw37wMMQqAxk89nfpjZpEEf2XSoBUd8V5ydnS",
    chainId: 0,
    wChainId: 1,
    decimals: 9,
    logoURI: "https://assets.coingecko.com/coins/images/28087/small/T-R84Zo32rDOA5Wo66T8jAlqcyjD7Folt1oeCfjlizU.png?1667724695",
    coingeckoId: "avenue-university-token",
    realOriginContractAddress: "AUT1gfMZw37wMMQqAxk89nfpjZpEEf2XSoBUd8V5ydnS",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "Axie Infinity (Portal from Ethereum)",
    symbol: "AXS",
    mint: "HysWcbHiYY9888pHbaqhwLYZQeZrcQMXKQWRqS7zcPK5",
    contract: "HysWcbHiYY9888pHbaqhwLYZQeZrcQMXKQWRqS7zcPK5",
    chainId: 0,
    wChainId: 1,
    decimals: 8,
    logoURI: "https://assets.coingecko.com/coins/images/13029/small/axie_infinity_logo.png?1604471082",
    coingeckoId: "axie-infinity",
    realOriginContractAddress: "0xbb0e17ef65f82ab018d8edd776e8dd940327b28b",
    realOriginChainId: 2,
    supportsPermit: !1
  },
  {
    name: "Baby Samo Coin",
    symbol: "BABY",
    mint: "Uuc6hiKT9Y6ASoqs2phonGGw2LAtecfJu9yEohppzWH",
    contract: "Uuc6hiKT9Y6ASoqs2phonGGw2LAtecfJu9yEohppzWH",
    chainId: 0,
    wChainId: 1,
    decimals: 9,
    logoURI: "https://assets.coingecko.com/coins/images/20262/small/386VuTho_400x400.jpg?1636704021",
    coingeckoId: "baby-samo-coin",
    realOriginContractAddress: "Uuc6hiKT9Y6ASoqs2phonGGw2LAtecfJu9yEohppzWH",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "Balloonsville AIR",
    symbol: "AIR",
    mint: "E6eCEE3KqjRD5UxcBYQTdV8Z535hyaBuFin9Udm6s6bz",
    contract: "E6eCEE3KqjRD5UxcBYQTdV8Z535hyaBuFin9Udm6s6bz",
    chainId: 0,
    wChainId: 1,
    decimals: 9,
    logoURI: "https://assets.coingecko.com/coins/images/24853/small/9CmgcH6.png?1649134566",
    coingeckoId: "balloonsville-air",
    realOriginContractAddress: "E6eCEE3KqjRD5UxcBYQTdV8Z535hyaBuFin9Udm6s6bz",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "Bamboo Coin",
    symbol: "BMBO",
    mint: "5sM9xxcBTM9rWza6nEgq2cShA87JjTBx1Cu82LjgmaEg",
    contract: "5sM9xxcBTM9rWza6nEgq2cShA87JjTBx1Cu82LjgmaEg",
    chainId: 0,
    wChainId: 1,
    decimals: 9,
    logoURI: "https://assets.coingecko.com/coins/images/19620/small/FC0hnduacAAHYFC.png?1635496724",
    coingeckoId: "bamboo-coin",
    realOriginContractAddress: "5sM9xxcBTM9rWza6nEgq2cShA87JjTBx1Cu82LjgmaEg",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "Bancambios AX",
    symbol: "BXS",
    mint: "pH5wWJc3KhdeVQSt86DU31pdcL9c8P88x2FQoKEJVHC",
    contract: "pH5wWJc3KhdeVQSt86DU31pdcL9c8P88x2FQoKEJVHC",
    chainId: 0,
    wChainId: 1,
    decimals: 9,
    logoURI: "https://assets.coingecko.com/coins/images/25644/small/81660481.png?1652949329",
    coingeckoId: "bancambios-ax",
    realOriginContractAddress: "pH5wWJc3KhdeVQSt86DU31pdcL9c8P88x2FQoKEJVHC",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "basis.markets",
    symbol: "BASIS",
    mint: "Basis9oJw9j8cw53oMV7iqsgo6ihi9ALw4QR31rcjUJa",
    contract: "Basis9oJw9j8cw53oMV7iqsgo6ihi9ALw4QR31rcjUJa",
    chainId: 0,
    wChainId: 1,
    decimals: 6,
    logoURI: "https://assets.coingecko.com/coins/images/21444/small/tkQevyc.png?1653297101",
    coingeckoId: "basis-markets",
    realOriginContractAddress: "Basis9oJw9j8cw53oMV7iqsgo6ihi9ALw4QR31rcjUJa",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "BiLira",
    symbol: "TRYB",
    mint: "A94X2fRy3wydNShU4dRaDyap2UuoeWJGWyATtyp61WZf",
    contract: "A94X2fRy3wydNShU4dRaDyap2UuoeWJGWyATtyp61WZf",
    chainId: 0,
    wChainId: 1,
    decimals: 6,
    logoURI: "https://assets.coingecko.com/coins/images/10119/small/JBs9jiXO_400x400.jpg?1642668342",
    coingeckoId: "bilira",
    realOriginContractAddress: "A94X2fRy3wydNShU4dRaDyap2UuoeWJGWyATtyp61WZf",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "Binance USD (Portal from BSC)",
    symbol: "BUSD",
    mint: "5RpUwQ8wtdPCZHhu6MERp2RGrpobsbZ6MH5dDHkUjs2",
    contract: "5RpUwQ8wtdPCZHhu6MERp2RGrpobsbZ6MH5dDHkUjs2",
    chainId: 0,
    wChainId: 1,
    decimals: 8,
    logoURI: "https://assets.coingecko.com/coins/images/9576/small/BUSD.png?1568947766",
    coingeckoId: "binance-usd",
    realOriginContractAddress: "0xe9e7cea3dedca5984780bafc599bd69add087d56",
    realOriginChainId: 4,
    supportsPermit: !1
  },
  {
    name: "Bitmon",
    symbol: "BIT",
    mint: "EGiWZhNk3vUNJr35MbL2tY5YD6D81VVZghR2LgEFyXZh",
    contract: "EGiWZhNk3vUNJr35MbL2tY5YD6D81VVZghR2LgEFyXZh",
    chainId: 0,
    wChainId: 1,
    decimals: 9,
    logoURI: "https://assets.coingecko.com/coins/images/25282/small/BT-logo.png?1651127844",
    coingeckoId: "bitmon",
    realOriginContractAddress: "EGiWZhNk3vUNJr35MbL2tY5YD6D81VVZghR2LgEFyXZh",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "Bitspawn",
    symbol: "SPWN",
    mint: "5U9QqCPhqXAJcEv9uyzFJd5zhN93vuPk1aNNkXnUfPnt",
    contract: "5U9QqCPhqXAJcEv9uyzFJd5zhN93vuPk1aNNkXnUfPnt",
    chainId: 0,
    wChainId: 1,
    decimals: 9,
    logoURI: "https://assets.coingecko.com/coins/images/16513/small/token_logo.png?1631603192",
    coingeckoId: "bitspawn",
    realOriginContractAddress: "5U9QqCPhqXAJcEv9uyzFJd5zhN93vuPk1aNNkXnUfPnt",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "BlazeStake Staked SOL",
    symbol: "BSOL",
    mint: "bSo13r4TkiE4KumL71LsHTPpL2euBYLFx6h9HP3piy1",
    contract: "bSo13r4TkiE4KumL71LsHTPpL2euBYLFx6h9HP3piy1",
    chainId: 0,
    wChainId: 1,
    decimals: 9,
    logoURI: "https://assets.coingecko.com/coins/images/26636/small/blazesolana.png?1659328728",
    coingeckoId: "blazestake-staked-sol",
    realOriginContractAddress: "bSo13r4TkiE4KumL71LsHTPpL2euBYLFx6h9HP3piy1",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "Blockasset",
    symbol: "BLOCK",
    mint: "NFTUkR4u7wKxy9QLaX2TGvd9oZSWoMo4jqSJqdMb7Nk",
    contract: "NFTUkR4u7wKxy9QLaX2TGvd9oZSWoMo4jqSJqdMb7Nk",
    chainId: 0,
    wChainId: 1,
    decimals: 6,
    logoURI: "https://assets.coingecko.com/coins/images/21332/small/Blockasset-Logo-Symbol.png?1648442722",
    coingeckoId: "blockasset",
    realOriginContractAddress: "NFTUkR4u7wKxy9QLaX2TGvd9oZSWoMo4jqSJqdMb7Nk",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "Blocksmith Labs Forge",
    symbol: "$FORGE",
    mint: "FoRGERiW7odcCBGU1bztZi16osPBHjxharvDathL5eds",
    contract: "FoRGERiW7odcCBGU1bztZi16osPBHjxharvDathL5eds",
    chainId: 0,
    wChainId: 1,
    decimals: 9,
    logoURI: "https://assets.coingecko.com/coins/images/25411/small/Logo_%281%29.png?1651733020",
    coingeckoId: "blocksmith-labs-forge",
    realOriginContractAddress: "FoRGERiW7odcCBGU1bztZi16osPBHjxharvDathL5eds",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "bofb",
    symbol: "BOFB",
    mint: "45wdSjpSqZCk9mkqmq5Nh7beCEqqUJMJcVduwYCip5eq",
    contract: "45wdSjpSqZCk9mkqmq5Nh7beCEqqUJMJcVduwYCip5eq",
    chainId: 0,
    wChainId: 1,
    decimals: 8,
    logoURI: "https://assets.coingecko.com/coins/images/24866/small/2qsZgpxd_400x400.jpg?1649166378",
    coingeckoId: "bofb",
    realOriginContractAddress: "45wdSjpSqZCk9mkqmq5Nh7beCEqqUJMJcVduwYCip5eq",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "Boryoku Dragonz",
    symbol: "BOKU",
    mint: "CN7qFa5iYkHz99PTctvT4xXUHnxwjQ5MHxCuTJtPN5uS",
    contract: "CN7qFa5iYkHz99PTctvT4xXUHnxwjQ5MHxCuTJtPN5uS",
    chainId: 0,
    wChainId: 1,
    decimals: 9,
    logoURI: "https://assets.coingecko.com/coins/images/20820/small/ZdgsxFPV_400x400.png?1637721291",
    coingeckoId: "boku",
    realOriginContractAddress: "CN7qFa5iYkHz99PTctvT4xXUHnxwjQ5MHxCuTJtPN5uS",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "Bonfida",
    symbol: "FIDA",
    mint: "EchesyfXePKdLtoiZSL8pBe8Myagyy8ZRqsACNCFGnvp",
    contract: "EchesyfXePKdLtoiZSL8pBe8Myagyy8ZRqsACNCFGnvp",
    chainId: 0,
    wChainId: 1,
    decimals: 6,
    logoURI: "https://assets.coingecko.com/coins/images/13395/small/bonfida.png?1658327819",
    coingeckoId: "bonfida",
    realOriginContractAddress: "EchesyfXePKdLtoiZSL8pBe8Myagyy8ZRqsACNCFGnvp",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "Bonk",
    symbol: "BONK",
    mint: "DezXAZ8z7PnrnRJjz3wXBoRgixCa6xjnB7YaB1pPB263",
    contract: "DezXAZ8z7PnrnRJjz3wXBoRgixCa6xjnB7YaB1pPB263",
    chainId: 0,
    wChainId: 1,
    decimals: 5,
    logoURI: "https://assets.coingecko.com/coins/images/28600/small/bonk.jpg?1672304290",
    coingeckoId: "bonk",
    realOriginContractAddress: "DezXAZ8z7PnrnRJjz3wXBoRgixCa6xjnB7YaB1pPB263",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "Boring Protocol",
    symbol: "BOP",
    mint: "BLwTnYKqf7u4qjgZrrsKeNs2EzWkMLqVCu6j8iHyrNA3",
    contract: "BLwTnYKqf7u4qjgZrrsKeNs2EzWkMLqVCu6j8iHyrNA3",
    chainId: 0,
    wChainId: 1,
    decimals: 8,
    logoURI: "https://assets.coingecko.com/coins/images/16828/small/imgonline-com-ua-resize-VT59gqn-Bya-WGG.jpg?1625210880",
    coingeckoId: "boring-protocol",
    realOriginContractAddress: "BLwTnYKqf7u4qjgZrrsKeNs2EzWkMLqVCu6j8iHyrNA3",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "Boryoku Genesis Dragonz Index",
    symbol: "DRGNZ",
    mint: "CzXF8oUJSsB9ADKV99WAi2TgytqAyKvQw6EihwiL9em4",
    contract: "CzXF8oUJSsB9ADKV99WAi2TgytqAyKvQw6EihwiL9em4",
    chainId: 0,
    wChainId: 1,
    decimals: 2,
    logoURI: "https://assets.coingecko.com/coins/images/24386/small/AzJI7FQ.png?1647501836",
    coingeckoId: "boryoku-genesis-dragonz-index",
    realOriginContractAddress: "CzXF8oUJSsB9ADKV99WAi2TgytqAyKvQw6EihwiL9em4",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "Boxch",
    symbol: "BOXCH",
    mint: "Boxch1343xWQWbahVBPhYHuYLXNHnWYHG6QbuqfNugQ1",
    contract: "Boxch1343xWQWbahVBPhYHuYLXNHnWYHG6QbuqfNugQ1",
    chainId: 0,
    wChainId: 1,
    decimals: 9,
    logoURI: "https://assets.coingecko.com/coins/images/26119/small/Group_212.png?1667726216",
    coingeckoId: "boxch",
    realOriginContractAddress: "Boxch1343xWQWbahVBPhYHuYLXNHnWYHG6QbuqfNugQ1",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "Bridgesplit Brand Index",
    symbol: "BBI",
    mint: "GRsoqmhsS7fCLpEqqE7oRM92ag3WVy8VbJAi6KfWSeHS",
    contract: "GRsoqmhsS7fCLpEqqE7oRM92ag3WVy8VbJAi6KfWSeHS",
    chainId: 0,
    wChainId: 1,
    decimals: 2,
    logoURI: "https://assets.coingecko.com/coins/images/25640/small/a.png?1652942415",
    coingeckoId: "bridgesplit-brand-index",
    realOriginContractAddress: "GRsoqmhsS7fCLpEqqE7oRM92ag3WVy8VbJAi6KfWSeHS",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "Brazilian Digital",
    symbol: "BRZ",
    mint: "FtgGSFADXBtroxq8VCausXRr2of47QBf5AS1NtZCu4GD",
    contract: "FtgGSFADXBtroxq8VCausXRr2of47QBf5AS1NtZCu4GD",
    chainId: 0,
    wChainId: 1,
    decimals: 4,
    logoURI: "https://assets.coingecko.com/coins/images/8472/small/2_vtiD3xwce9knG2COxtSMaQ.png?1597786961",
    coingeckoId: "brz",
    realOriginContractAddress: "FtgGSFADXBtroxq8VCausXRr2of47QBf5AS1NtZCu4GD",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "BunnyDucky",
    symbol: "BUD",
    mint: "BUD1144GGYwmMRFs4Whjfkom5UHqC9a8dZHPVvR2vfPx",
    contract: "BUD1144GGYwmMRFs4Whjfkom5UHqC9a8dZHPVvR2vfPx",
    chainId: 0,
    wChainId: 1,
    decimals: 6,
    logoURI: "https://assets.coingecko.com/coins/images/25934/small/bdlogo.png?1654758682",
    coingeckoId: "bunnyducky",
    realOriginContractAddress: "BUD1144GGYwmMRFs4Whjfkom5UHqC9a8dZHPVvR2vfPx",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "Capybara",
    symbol: "CAPY",
    mint: "CAPYD6Lrm7bTZ6C7t7JvSxvpEcfKQ9YNB7kUjh6p6XBN",
    contract: "CAPYD6Lrm7bTZ6C7t7JvSxvpEcfKQ9YNB7kUjh6p6XBN",
    chainId: 0,
    wChainId: 1,
    decimals: 9,
    logoURI: "https://assets.coingecko.com/coins/images/22000/small/logo_-_2021-12-27T143844.581.png?1640587159",
    coingeckoId: "capybara",
    realOriginContractAddress: "CAPYD6Lrm7bTZ6C7t7JvSxvpEcfKQ9YNB7kUjh6p6XBN",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "Catalina Whales Index",
    symbol: "WHALES",
    mint: "DSXWF79VQ3RzFBB67WeNfCzfzAQq5X6m97zi85bq1TRx",
    contract: "DSXWF79VQ3RzFBB67WeNfCzfzAQq5X6m97zi85bq1TRx",
    chainId: 0,
    wChainId: 1,
    decimals: 2,
    logoURI: "https://assets.coingecko.com/coins/images/27053/small/whales.png?1661507402",
    coingeckoId: "catalina-whales-index",
    realOriginContractAddress: "DSXWF79VQ3RzFBB67WeNfCzfzAQq5X6m97zi85bq1TRx",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "CATO",
    symbol: "CATO",
    mint: "5p2zjqCd1WJzAVgcEnjhb9zWDU7b9XVhFhx4usiyN7jB",
    contract: "5p2zjqCd1WJzAVgcEnjhb9zWDU7b9XVhFhx4usiyN7jB",
    chainId: 0,
    wChainId: 1,
    decimals: 9,
    logoURI: "https://assets.coingecko.com/coins/images/17031/small/CATO200newlogo.png?1648448136",
    coingeckoId: "cato",
    realOriginContractAddress: "5p2zjqCd1WJzAVgcEnjhb9zWDU7b9XVhFhx4usiyN7jB",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "CaveWorld",
    symbol: "CAVE",
    mint: "4SZjjNABoqhbd4hnapbvoEPEqT8mnNkfbEoAwALf1V8t",
    contract: "4SZjjNABoqhbd4hnapbvoEPEqT8mnNkfbEoAwALf1V8t",
    chainId: 0,
    wChainId: 1,
    decimals: 6,
    logoURI: "https://assets.coingecko.com/coins/images/19358/small/token.png?1650866628",
    coingeckoId: "cave",
    realOriginContractAddress: "4SZjjNABoqhbd4hnapbvoEPEqT8mnNkfbEoAwALf1V8t",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "Celsius Network (Portal from Ethereum)",
    symbol: "CEL",
    mint: "nRtfwU9G82CSHhHGJNxFhtn7FLvWP2rqvQvje1WtL69",
    contract: "nRtfwU9G82CSHhHGJNxFhtn7FLvWP2rqvQvje1WtL69",
    chainId: 0,
    wChainId: 1,
    decimals: 4,
    logoURI: "https://assets.coingecko.com/coins/images/3263/small/CEL_logo.png?1609598753",
    coingeckoId: "celsius-degree-token",
    realOriginContractAddress: "0xaaaebe6fe48e54f431b0c390cfaf0b017d09d42d",
    realOriginChainId: 2,
    supportsPermit: !1
  },
  {
    name: "Chainlink (Portal from Ethereum)",
    symbol: "LINK",
    mint: "2wpTofQ8SkACrkZWrZDjXPitYa8AwWgX8AfxdeBRRVLX",
    contract: "2wpTofQ8SkACrkZWrZDjXPitYa8AwWgX8AfxdeBRRVLX",
    chainId: 0,
    wChainId: 1,
    decimals: 8,
    logoURI: "https://assets.coingecko.com/coins/images/877/small/chainlink-new-logo.png?1547034700",
    coingeckoId: "chainlink",
    realOriginContractAddress: "0x514910771af9ca656af840dff83e8264ecf986ca",
    realOriginChainId: 2,
    supportsPermit: !1
  },
  {
    name: "Charactbit",
    symbol: "CHB",
    mint: "YtfMZ4jg2ubdz4GasY86iuGjHdo5rCPJnFqgSf8gxAz",
    contract: "YtfMZ4jg2ubdz4GasY86iuGjHdo5rCPJnFqgSf8gxAz",
    chainId: 0,
    wChainId: 1,
    decimals: 9,
    logoURI: "https://assets.coingecko.com/coins/images/24863/small/200x_logo.png?1649165917",
    coingeckoId: "charactbit",
    realOriginContractAddress: "YtfMZ4jg2ubdz4GasY86iuGjHdo5rCPJnFqgSf8gxAz",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "Cheems",
    symbol: "CHEEMS",
    mint: "3FoUAsGDbvTD6YZ4wVKJgTB76onJUKz7GPEBNiR5b8wc",
    contract: "3FoUAsGDbvTD6YZ4wVKJgTB76onJUKz7GPEBNiR5b8wc",
    chainId: 0,
    wChainId: 1,
    decimals: 4,
    logoURI: "https://assets.coingecko.com/coins/images/18358/small/newlogo.png?1644476666",
    coingeckoId: "cheems",
    realOriginContractAddress: "3FoUAsGDbvTD6YZ4wVKJgTB76onJUKz7GPEBNiR5b8wc",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "ChikinCoin",
    symbol: "CKC",
    mint: "8s9FCz99Wcr3dHpiauFRi6bLXzshXfcGTfgQE7UEopVx",
    contract: "8s9FCz99Wcr3dHpiauFRi6bLXzshXfcGTfgQE7UEopVx",
    chainId: 0,
    wChainId: 1,
    decimals: 6,
    logoURI: "https://assets.coingecko.com/coins/images/24978/small/Screenshot_from_2022-04-11_15-47-44.png?1649663281",
    coingeckoId: "chikincoin",
    realOriginContractAddress: "8s9FCz99Wcr3dHpiauFRi6bLXzshXfcGTfgQE7UEopVx",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "CHILI",
    symbol: "CHILI",
    mint: "GPyzPHuFFGvN4yWWixt6TYUtDG49gfMdFFi2iniTmCkh",
    contract: "GPyzPHuFFGvN4yWWixt6TYUtDG49gfMdFFi2iniTmCkh",
    chainId: 0,
    wChainId: 1,
    decimals: 2,
    logoURI: "https://assets.coingecko.com/coins/images/28668/small/CHILI_start.png?1672995567",
    coingeckoId: "chili",
    realOriginContractAddress: "GPyzPHuFFGvN4yWWixt6TYUtDG49gfMdFFi2iniTmCkh",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "Nana",
    symbol: "NANA",
    mint: "6uZ7MRGGf3FJhzk9TUk3QRMR2fz83WY9BEVBukRvMRVX",
    contract: "6uZ7MRGGf3FJhzk9TUk3QRMR2fz83WY9BEVBukRvMRVX",
    chainId: 0,
    wChainId: 1,
    decimals: 9,
    logoURI: "https://assets.coingecko.com/coins/images/22407/small/200x200.png?1641967515",
    coingeckoId: "chimp-fight",
    realOriginContractAddress: "6uZ7MRGGf3FJhzk9TUk3QRMR2fz83WY9BEVBukRvMRVX",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "Clash",
    symbol: "CLH",
    mint: "CLAsHPfTPpsXmzZzdexdEuKeRzZrWjZFRHQEPu2kSgWM",
    contract: "CLAsHPfTPpsXmzZzdexdEuKeRzZrWjZFRHQEPu2kSgWM",
    chainId: 0,
    wChainId: 1,
    decimals: 6,
    logoURI: "https://assets.coingecko.com/coins/images/27836/small/New-Clash-Icon_copy.png?1665996878",
    coingeckoId: "clash",
    realOriginContractAddress: "CLAsHPfTPpsXmzZzdexdEuKeRzZrWjZFRHQEPu2kSgWM",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "ClinTex CTi (Portal from Ethereum)",
    symbol: "CTI",
    mint: "9ET2QCQJdFkeKkuaampNbmicbA8eLYauFCWch9Ddh9p5",
    contract: "9ET2QCQJdFkeKkuaampNbmicbA8eLYauFCWch9Ddh9p5",
    chainId: 0,
    wChainId: 1,
    decimals: 8,
    logoURI: "https://assets.coingecko.com/coins/images/13266/small/CTI.png?1606817542",
    coingeckoId: "clintex-cti",
    realOriginContractAddress: "0xcb8fb2438a805664cd8c3e640b85ac473da5be87",
    realOriginChainId: 2,
    supportsPermit: !1
  },
  {
    name: "COBAN",
    symbol: "COBAN",
    mint: "7udMmYXh6cuWVY6qQVCd9b429wDVn2J71r5BdxHkQADY",
    contract: "7udMmYXh6cuWVY6qQVCd9b429wDVn2J71r5BdxHkQADY",
    chainId: 0,
    wChainId: 1,
    decimals: 3,
    logoURI: "https://assets.coingecko.com/coins/images/19483/small/coban-logo-pebyyxjzxvebwa8nsvpp9t8iple69h6enp9bdknotq.png?1635285761",
    coingeckoId: "coban",
    realOriginContractAddress: "7udMmYXh6cuWVY6qQVCd9b429wDVn2J71r5BdxHkQADY",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "Coin98",
    symbol: "C98",
    mint: "C98A4nkJXhpVZNAZdHUA95RpTF3T4whtQubL3YobiUX9",
    contract: "C98A4nkJXhpVZNAZdHUA95RpTF3T4whtQubL3YobiUX9",
    chainId: 0,
    wChainId: 1,
    decimals: 6,
    logoURI: "https://assets.coingecko.com/coins/images/17117/small/logo.png?1626412904",
    coingeckoId: "coin98",
    realOriginContractAddress: "C98A4nkJXhpVZNAZdHUA95RpTF3T4whtQubL3YobiUX9",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "Coin98 Dollar",
    symbol: "CUSD",
    mint: "CUSDvqAQLbt7fRofcmV2EXfPA2t36kzj7FjzdmqDiNQL",
    contract: "CUSDvqAQLbt7fRofcmV2EXfPA2t36kzj7FjzdmqDiNQL",
    chainId: 0,
    wChainId: 1,
    decimals: 6,
    logoURI: "https://assets.coingecko.com/coins/images/26588/small/CUSD-01.png?1658909049",
    coingeckoId: "coin98-dollar",
    realOriginContractAddress: "CUSDvqAQLbt7fRofcmV2EXfPA2t36kzj7FjzdmqDiNQL",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "Companion",
    symbol: "CMPN",
    mint: "9tQhCmFtCh56qqf9szLQ8dNjYcd4TTv6MWPpw6MqLubu",
    contract: "9tQhCmFtCh56qqf9szLQ8dNjYcd4TTv6MWPpw6MqLubu",
    chainId: 0,
    wChainId: 1,
    decimals: 6,
    logoURI: "https://assets.coingecko.com/coins/images/27914/small/cmpn.png?1666343810",
    coingeckoId: "companion",
    realOriginContractAddress: "9tQhCmFtCh56qqf9szLQ8dNjYcd4TTv6MWPpw6MqLubu",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "Compendium.Fi",
    symbol: "CMFI",
    mint: "5Wsd311hY8NXQhkt9cWHwTnqafk7BGEbLu8Py3DSnPAr",
    contract: "5Wsd311hY8NXQhkt9cWHwTnqafk7BGEbLu8Py3DSnPAr",
    chainId: 0,
    wChainId: 1,
    decimals: 6,
    logoURI: "https://assets.coingecko.com/coins/images/22269/small/ckxanb97x357108l6qrnrjxtr.png?1641340080",
    coingeckoId: "compendium-fi",
    realOriginContractAddress: "5Wsd311hY8NXQhkt9cWHwTnqafk7BGEbLu8Py3DSnPAr",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "ConstitutionDAO (Portal from Ethereum)",
    symbol: "PEOPLE",
    mint: "CobcsUrt3p91FwvULYKorQejgsm5HoQdv5T8RUZ6PnLA",
    contract: "CobcsUrt3p91FwvULYKorQejgsm5HoQdv5T8RUZ6PnLA",
    chainId: 0,
    wChainId: 1,
    decimals: 8,
    logoURI: "https://assets.coingecko.com/coins/images/20612/small/GN_UVm3d_400x400.jpg?1637294355",
    coingeckoId: "constitutiondao",
    realOriginContractAddress: "0x7a58c0be72be218b41c608b7fe7c5bb630736c71",
    realOriginChainId: 2,
    supportsPermit: !1
  },
  {
    name: "Cope",
    symbol: "COPE",
    mint: "8HGyAAB1yoM1ttS7pXjHMa3dukTFGQggnFFH3hJZgzQh",
    contract: "8HGyAAB1yoM1ttS7pXjHMa3dukTFGQggnFFH3hJZgzQh",
    chainId: 0,
    wChainId: 1,
    decimals: 6,
    logoURI: "https://assets.coingecko.com/coins/images/14567/small/COPE.png?1617162230",
    coingeckoId: "cope",
    realOriginContractAddress: "8HGyAAB1yoM1ttS7pXjHMa3dukTFGQggnFFH3hJZgzQh",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "Cope Token",
    symbol: "COPE",
    mint: "o1Mw5Y3n68o8TakZFuGKLZMGjm72qv4JeoZvGiCLEvK",
    contract: "o1Mw5Y3n68o8TakZFuGKLZMGjm72qv4JeoZvGiCLEvK",
    chainId: 0,
    wChainId: 1,
    decimals: 2,
    logoURI: "https://assets.coingecko.com/coins/images/28717/small/coingecko.png?1673576722",
    coingeckoId: "cope-token",
    realOriginContractAddress: "o1Mw5Y3n68o8TakZFuGKLZMGjm72qv4JeoZvGiCLEvK",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "CoreStarter",
    symbol: "CSTR",
    mint: "G7uYedVqFy97mzjygebnmmaMUVxWHFhNZotY6Zzsprvf",
    contract: "G7uYedVqFy97mzjygebnmmaMUVxWHFhNZotY6Zzsprvf",
    chainId: 0,
    wChainId: 1,
    decimals: 9,
    logoURI: "https://assets.coingecko.com/coins/images/20209/small/cstr.png?1636642782",
    coingeckoId: "corestarter",
    realOriginContractAddress: "G7uYedVqFy97mzjygebnmmaMUVxWHFhNZotY6Zzsprvf",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "Creamy",
    symbol: "CREAMY",
    mint: "CREAMpdDimXxj2zTCwP5wMEtba4NYaKCrTBEQTSKtqHe",
    contract: "CREAMpdDimXxj2zTCwP5wMEtba4NYaKCrTBEQTSKtqHe",
    chainId: 0,
    wChainId: 1,
    decimals: 9,
    logoURI: "https://assets.coingecko.com/coins/images/25285/small/logo200.png?1651128831",
    coingeckoId: "creamy",
    realOriginContractAddress: "CREAMpdDimXxj2zTCwP5wMEtba4NYaKCrTBEQTSKtqHe",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "Cricket Star Manager",
    symbol: "CSM",
    mint: "EzfnjRUKtc5vweE1GCLdHV4MkDQ3ebSpQXLobSKgQ9RB",
    contract: "EzfnjRUKtc5vweE1GCLdHV4MkDQ3ebSpQXLobSKgQ9RB",
    chainId: 0,
    wChainId: 1,
    decimals: 6,
    logoURI: "https://assets.coingecko.com/coins/images/25774/small/CSM_token.png?1653631158",
    coingeckoId: "cricket-star-manager",
    realOriginContractAddress: "EzfnjRUKtc5vweE1GCLdHV4MkDQ3ebSpQXLobSKgQ9RB",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "Cripco",
    symbol: "IP3",
    mint: "3uejHm24sWmniGA5m4j4S1DVuGqzYBR5DJpevND4mivq",
    contract: "3uejHm24sWmniGA5m4j4S1DVuGqzYBR5DJpevND4mivq",
    chainId: 0,
    wChainId: 1,
    decimals: 9,
    logoURI: "https://assets.coingecko.com/coins/images/26344/small/f55kBYa2_400x400.jpeg?1657586586",
    coingeckoId: "cripco",
    realOriginContractAddress: "3uejHm24sWmniGA5m4j4S1DVuGqzYBR5DJpevND4mivq",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "CropperFinance",
    symbol: "CRP",
    mint: "DubwWZNWiNGMMeeQHPnMATNj77YZPZSAz2WVR5WjLJqz",
    contract: "DubwWZNWiNGMMeeQHPnMATNj77YZPZSAz2WVR5WjLJqz",
    chainId: 0,
    wChainId: 1,
    decimals: 9,
    logoURI: "https://assets.coingecko.com/coins/images/17883/small/copperfinance.PNG?1629708744",
    coingeckoId: "cropperfinance",
    realOriginContractAddress: "DubwWZNWiNGMMeeQHPnMATNj77YZPZSAz2WVR5WjLJqz",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "Crowny",
    symbol: "CRWNY",
    mint: "CRWNYkqdgvhGGae9CKfNka58j6QQkaD5bLhKXvUYqnc1",
    contract: "CRWNYkqdgvhGGae9CKfNka58j6QQkaD5bLhKXvUYqnc1",
    chainId: 0,
    wChainId: 1,
    decimals: 6,
    logoURI: "https://assets.coingecko.com/coins/images/14958/small/crowny-icon-rounded_2x.png?1619147225",
    coingeckoId: "crowny-token",
    realOriginContractAddress: "CRWNYkqdgvhGGae9CKfNka58j6QQkaD5bLhKXvUYqnc1",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "Cry Cat Coin",
    symbol: "CRYY",
    mint: "56tNQ29XBrbovm5K5SThuQatjCy92w2wKUaUeQ8WCD9g",
    contract: "56tNQ29XBrbovm5K5SThuQatjCy92w2wKUaUeQ8WCD9g",
    chainId: 0,
    wChainId: 1,
    decimals: 9,
    logoURI: "https://assets.coingecko.com/coins/images/22128/small/cry_logo_200_200.png?1640870275",
    coingeckoId: "cry-coin",
    realOriginContractAddress: "56tNQ29XBrbovm5K5SThuQatjCy92w2wKUaUeQ8WCD9g",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "Cryowar",
    symbol: "CWAR",
    mint: "HfYFjMKNZygfMC8LsQ8LtpPsPxEJoXJx4M6tqi75Hajo",
    contract: "HfYFjMKNZygfMC8LsQ8LtpPsPxEJoXJx4M6tqi75Hajo",
    chainId: 0,
    wChainId: 1,
    decimals: 9,
    logoURI: "https://assets.coingecko.com/coins/images/20227/small/CWAR_round_200_200.png?1636689418",
    coingeckoId: "cryowar-token",
    realOriginContractAddress: "HfYFjMKNZygfMC8LsQ8LtpPsPxEJoXJx4M6tqi75Hajo",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "Cyborg Apes",
    symbol: "BORG",
    mint: "CFbdjaKonbBQTYG2GC6CmB7exofgDYGCDR8tp8KVGS7T",
    contract: "CFbdjaKonbBQTYG2GC6CmB7exofgDYGCDR8tp8KVGS7T",
    chainId: 0,
    wChainId: 1,
    decimals: 6,
    logoURI: "https://assets.coingecko.com/coins/images/23020/small/lgo-head-export.png?1643094853",
    coingeckoId: "cyborg-apes",
    realOriginContractAddress: "CFbdjaKonbBQTYG2GC6CmB7exofgDYGCDR8tp8KVGS7T",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "Cykura",
    symbol: "CYS",
    mint: "BRLsMczKuaR5w9vSubF4j8HwEGGprVAyyVgS4EX7DKEg",
    contract: "BRLsMczKuaR5w9vSubF4j8HwEGGprVAyyVgS4EX7DKEg",
    chainId: 0,
    wChainId: 1,
    decimals: 6,
    logoURI: "https://assets.coingecko.com/coins/images/18139/small/cyclos-text-logo.png?1630651169",
    coingeckoId: "cyclos",
    realOriginContractAddress: "BRLsMczKuaR5w9vSubF4j8HwEGGprVAyyVgS4EX7DKEg",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "daoSOL",
    symbol: "DAOSOL",
    mint: "GEJpt3Wjmr628FqXxTgxMce1pLntcPV4uFi8ksxMyPQh",
    contract: "GEJpt3Wjmr628FqXxTgxMce1pLntcPV4uFi8ksxMyPQh",
    chainId: 0,
    wChainId: 1,
    decimals: 9,
    logoURI: "https://assets.coingecko.com/coins/images/25488/small/logo_%284%29.png?1652071503",
    coingeckoId: "daosol",
    realOriginContractAddress: "GEJpt3Wjmr628FqXxTgxMce1pLntcPV4uFi8ksxMyPQh",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "Konstellation (Portal from BSC)",
    symbol: "DARC",
    mint: "CpFE715P5DnDoJj9FbCRcuyHHeTXNdRnvzNkHvq1o23U",
    contract: "CpFE715P5DnDoJj9FbCRcuyHHeTXNdRnvzNkHvq1o23U",
    chainId: 0,
    wChainId: 1,
    decimals: 8,
    logoURI: "https://assets.coingecko.com/coins/images/2943/small/darctoken.png?1645230834",
    coingeckoId: "darcmatter-coin",
    realOriginContractAddress: "0x8ebc361536094fd5b4ffb8521e31900614c9f55d",
    realOriginChainId: 4,
    supportsPermit: !1
  },
  {
    name: "DarleyGo Essence",
    symbol: "DGE",
    mint: "AAXng5czWLNtTXHdWEn9Ef7kXMXEaraHj2JQKo7ZoLux",
    contract: "AAXng5czWLNtTXHdWEn9Ef7kXMXEaraHj2JQKo7ZoLux",
    chainId: 0,
    wChainId: 1,
    decimals: 9,
    logoURI: "https://assets.coingecko.com/coins/images/24403/small/DGE.png?1647530006",
    coingeckoId: "darleygo-essence",
    realOriginContractAddress: "AAXng5czWLNtTXHdWEn9Ef7kXMXEaraHj2JQKo7ZoLux",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "DAWG",
    symbol: "DAWG",
    mint: "3DHPqxdMXogNNnpqBMF8N4Zs4dn1WR31H7UjWq6FExwG",
    contract: "3DHPqxdMXogNNnpqBMF8N4Zs4dn1WR31H7UjWq6FExwG",
    chainId: 0,
    wChainId: 1,
    decimals: 9,
    logoURI: "https://assets.coingecko.com/coins/images/20881/small/143299698-37b637ea-7fce-4bd6-8713-71c42e37629e.png?1637820203",
    coingeckoId: "dawg",
    realOriginContractAddress: "3DHPqxdMXogNNnpqBMF8N4Zs4dn1WR31H7UjWq6FExwG",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "Dead Knight",
    symbol: "DKM",
    mint: "HtbhBYdcfXbbD2JiH6jtsTt2m2FXjn7h4k6iXfz98k5W",
    contract: "HtbhBYdcfXbbD2JiH6jtsTt2m2FXjn7h4k6iXfz98k5W",
    chainId: 0,
    wChainId: 1,
    decimals: 9,
    logoURI: "https://assets.coingecko.com/coins/images/24442/small/SAq1GaQc_400x400.jpg?1647673953",
    coingeckoId: "dead-knight",
    realOriginContractAddress: "HtbhBYdcfXbbD2JiH6jtsTt2m2FXjn7h4k6iXfz98k5W",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "Decentraland (Portal from Ethereum)",
    symbol: "MANA",
    mint: "7dgHoN8wBZCc5wbnQ2C47TDnBMAxG4Q5L3KjP67z8kNi",
    contract: "7dgHoN8wBZCc5wbnQ2C47TDnBMAxG4Q5L3KjP67z8kNi",
    chainId: 0,
    wChainId: 1,
    decimals: 8,
    logoURI: "https://assets.coingecko.com/coins/images/878/small/decentraland-mana.png?1550108745",
    coingeckoId: "decentraland",
    realOriginContractAddress: "0x0f5d2fb29fb7d3cfee444a200298f468908cc942",
    realOriginChainId: 2,
    supportsPermit: !1
  },
  {
    name: "Decimated",
    symbol: "DIO",
    mint: "BiDB55p4G3n1fGhwKFpxsokBMqgctL4qnZpDH1bVQxMD",
    contract: "BiDB55p4G3n1fGhwKFpxsokBMqgctL4qnZpDH1bVQxMD",
    chainId: 0,
    wChainId: 1,
    decimals: 9,
    logoURI: "https://assets.coingecko.com/coins/images/8271/small/dio_logo_coloured_transparent.png?1640744585",
    coingeckoId: "decimated",
    realOriginContractAddress: "BiDB55p4G3n1fGhwKFpxsokBMqgctL4qnZpDH1bVQxMD",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "DeFi Land",
    symbol: "DFL",
    mint: "DFL1zNkaGPWm1BqAVqRjCZvHmwTFrEaJtbzJWgseoNJh",
    contract: "DFL1zNkaGPWm1BqAVqRjCZvHmwTFrEaJtbzJWgseoNJh",
    chainId: 0,
    wChainId: 1,
    decimals: 9,
    logoURI: "https://assets.coingecko.com/coins/images/18910/small/defilend.png?1637190571",
    coingeckoId: "defi-land",
    realOriginContractAddress: "DFL1zNkaGPWm1BqAVqRjCZvHmwTFrEaJtbzJWgseoNJh",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "DeFi Land Gold",
    symbol: "GOLDY",
    mint: "GoLDYyyiVeXnVf9qgoK712N5esm1cCbHEK9aNJFx47Sx",
    contract: "GoLDYyyiVeXnVf9qgoK712N5esm1cCbHEK9aNJFx47Sx",
    chainId: 0,
    wChainId: 1,
    decimals: 9,
    logoURI: "https://assets.coingecko.com/coins/images/25647/small/GODLY.png?1653025856",
    coingeckoId: "defi-land-gold",
    realOriginContractAddress: "GoLDYyyiVeXnVf9qgoK712N5esm1cCbHEK9aNJFx47Sx",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "Degenerate Ape Academy Floor Index",
    symbol: "DAPE",
    mint: "6AarZpv8KwmPBxBEZdRmd3g1q2tUBaSgTNQ5e621qcZQ",
    contract: "6AarZpv8KwmPBxBEZdRmd3g1q2tUBaSgTNQ5e621qcZQ",
    chainId: 0,
    wChainId: 1,
    decimals: 2,
    logoURI: "https://assets.coingecko.com/coins/images/27054/small/dape.png?1661508642",
    coingeckoId: "degenerate-ape-academy-floor-index",
    realOriginContractAddress: "6AarZpv8KwmPBxBEZdRmd3g1q2tUBaSgTNQ5e621qcZQ",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "DeltaFi",
    symbol: "DELFI",
    mint: "de1QJkP1qDCk5JYCCXCeq27bQQUdCaiv7xVKFrhPSzF",
    contract: "de1QJkP1qDCk5JYCCXCeq27bQQUdCaiv7xVKFrhPSzF",
    chainId: 0,
    wChainId: 1,
    decimals: 6,
    logoURI: "https://assets.coingecko.com/coins/images/24085/small/logo.png?1646293860",
    coingeckoId: "deltafi",
    realOriginContractAddress: "de1QJkP1qDCk5JYCCXCeq27bQQUdCaiv7xVKFrhPSzF",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "Dexlab",
    symbol: "DXL",
    mint: "GsNzxJfFn6zQdJGeYsupJWzUAm57Ba7335mfhWvFiE9Z",
    contract: "GsNzxJfFn6zQdJGeYsupJWzUAm57Ba7335mfhWvFiE9Z",
    chainId: 0,
    wChainId: 1,
    decimals: 6,
    logoURI: "https://assets.coingecko.com/coins/images/17276/small/3_GradientSymbol.png?1650936792",
    coingeckoId: "dexlab",
    realOriginContractAddress: "GsNzxJfFn6zQdJGeYsupJWzUAm57Ba7335mfhWvFiE9Z",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "Dingocoin",
    symbol: "DINGO",
    mint: "6VYF5jXq6rfq4QRgGMG6co7b1Ev1Lj7KSbHBxfQ9e1L3",
    contract: "6VYF5jXq6rfq4QRgGMG6co7b1Ev1Lj7KSbHBxfQ9e1L3",
    chainId: 0,
    wChainId: 1,
    decimals: 8,
    logoURI: "https://assets.coingecko.com/coins/images/15989/small/dingocoin.png?1634699256",
    coingeckoId: "dingocoin",
    realOriginContractAddress: "6VYF5jXq6rfq4QRgGMG6co7b1Ev1Lj7KSbHBxfQ9e1L3",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "Dino",
    symbol: "DINO",
    mint: "6Y7LbYB3tfGBG6CSkyssoxdtHb77AEMTRVXe8JUJRwZ7",
    contract: "6Y7LbYB3tfGBG6CSkyssoxdtHb77AEMTRVXe8JUJRwZ7",
    chainId: 0,
    wChainId: 1,
    decimals: 6,
    logoURI: "https://assets.coingecko.com/coins/images/17770/small/solana_dino.png?1629207162",
    coingeckoId: "dino",
    realOriginContractAddress: "6Y7LbYB3tfGBG6CSkyssoxdtHb77AEMTRVXe8JUJRwZ7",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "DINOEGG",
    symbol: "DINOEGG",
    mint: "2TxM6S3ZozrBHZGHEPh9CtM74a9SVXbr7NQ7UxkRvQij",
    contract: "2TxM6S3ZozrBHZGHEPh9CtM74a9SVXbr7NQ7UxkRvQij",
    chainId: 0,
    wChainId: 1,
    decimals: 6,
    logoURI: "https://assets.coingecko.com/coins/images/22291/small/xOcKL1Fw_400x400.png?1641367958",
    coingeckoId: "dinoegg",
    realOriginContractAddress: "2TxM6S3ZozrBHZGHEPh9CtM74a9SVXbr7NQ7UxkRvQij",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "Dogelana",
    symbol: "DGLN",
    mint: "E6UU5M1z4CvSAAF99d9wRoXsasWMEXsvHrz3JQRXtm2X",
    contract: "E6UU5M1z4CvSAAF99d9wRoXsasWMEXsvHrz3JQRXtm2X",
    chainId: 0,
    wChainId: 1,
    decimals: 9,
    logoURI: "https://assets.coingecko.com/coins/images/21133/small/logo_%285%29.png?1642042028",
    coingeckoId: "dogelana",
    realOriginContractAddress: "E6UU5M1z4CvSAAF99d9wRoXsasWMEXsvHrz3JQRXtm2X",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "DogemonGo",
    symbol: "DOGO",
    mint: "5LSFpvLDkcdV2a3Kiyzmg5YmJsj2XDLySaXvnfP1cgLT",
    contract: "5LSFpvLDkcdV2a3Kiyzmg5YmJsj2XDLySaXvnfP1cgLT",
    chainId: 0,
    wChainId: 1,
    decimals: 6,
    logoURI: "https://assets.coingecko.com/coins/images/17480/small/dogemongo.PNG?1627950869",
    coingeckoId: "dogemon-go",
    realOriginContractAddress: "5LSFpvLDkcdV2a3Kiyzmg5YmJsj2XDLySaXvnfP1cgLT",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "Dragon War",
    symbol: "DRAW",
    mint: "48AEwauAHsJibyt3WqjQ6EoHnFBcnyHASfo7vB2eCXPS",
    contract: "48AEwauAHsJibyt3WqjQ6EoHnFBcnyHASfo7vB2eCXPS",
    chainId: 0,
    wChainId: 1,
    decimals: 0,
    logoURI: "https://assets.coingecko.com/coins/images/23100/small/logo_%284%29.png?1643184693",
    coingeckoId: "dragon-war",
    realOriginContractAddress: "48AEwauAHsJibyt3WqjQ6EoHnFBcnyHASfo7vB2eCXPS",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "Duck Punkz Universe Floor Index",
    symbol: "DPUNKZ",
    mint: "McpgFn2CxFYFq6JLiBxeC6viNfebLsfsf9Sv5wcwKvL",
    contract: "McpgFn2CxFYFq6JLiBxeC6viNfebLsfsf9Sv5wcwKvL",
    chainId: 0,
    wChainId: 1,
    decimals: 2,
    logoURI: "https://assets.coingecko.com/coins/images/27171/small/2588.png?1662287086",
    coingeckoId: "duck-punkz-universe-floor-index",
    realOriginContractAddress: "McpgFn2CxFYFq6JLiBxeC6viNfebLsfsf9Sv5wcwKvL",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "DUST Protocol",
    symbol: "DUST",
    mint: "DUSTawucrTsGU8hcqRdHDCbuYhCPADMLM2VcCb8VnFnQ",
    contract: "DUSTawucrTsGU8hcqRdHDCbuYhCPADMLM2VcCb8VnFnQ",
    chainId: 0,
    wChainId: 1,
    decimals: 9,
    logoURI: "https://assets.coingecko.com/coins/images/24289/small/dust-protocol-degod.png?1647306854",
    coingeckoId: "dust-protocol",
    realOriginContractAddress: "DUSTawucrTsGU8hcqRdHDCbuYhCPADMLM2VcCb8VnFnQ",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "dYdX (Portal from Ethereum)",
    symbol: "DYDX",
    mint: "4Hx6Bj56eGyw8EJrrheM6LBQAvVYRikYCWsALeTrwyRU",
    contract: "4Hx6Bj56eGyw8EJrrheM6LBQAvVYRikYCWsALeTrwyRU",
    chainId: 0,
    wChainId: 1,
    decimals: 8,
    logoURI: "https://assets.coingecko.com/coins/images/17500/small/hjnIm9bV.jpg?1628009360",
    coingeckoId: "dydx",
    realOriginContractAddress: "0x92d6c1e31e14520e676a687f0a93788b716beff5",
    realOriginChainId: 2,
    supportsPermit: !1
  },
  {
    name: "edeXa Service Token",
    symbol: "EDX",
    mint: "3Ysmnbdddpxv9xK8FUKXexdhRzEA4yrCz8WaE6Za5sjV",
    contract: "3Ysmnbdddpxv9xK8FUKXexdhRzEA4yrCz8WaE6Za5sjV",
    chainId: 0,
    wChainId: 1,
    decimals: 9,
    logoURI: "https://assets.coingecko.com/coins/images/28646/small/EDX_SERVICE_TOKEN.png?1672883345",
    coingeckoId: "edexa-service-token",
    realOriginContractAddress: "3Ysmnbdddpxv9xK8FUKXexdhRzEA4yrCz8WaE6Za5sjV",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "Elumia",
    symbol: "ELU",
    mint: "4tJZhSdGePuMEfZQ3h5LaHjTPsw1iWTRFTojnZcwsAU6",
    contract: "4tJZhSdGePuMEfZQ3h5LaHjTPsw1iWTRFTojnZcwsAU6",
    chainId: 0,
    wChainId: 1,
    decimals: 9,
    logoURI: "https://assets.coingecko.com/coins/images/24433/small/me4oOqTM_400x400.png?1647662654",
    coingeckoId: "elumia",
    realOriginContractAddress: "4tJZhSdGePuMEfZQ3h5LaHjTPsw1iWTRFTojnZcwsAU6",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "Enrex",
    symbol: "ENRX",
    mint: "5s4BYUXLuvs9ZcVDTxkTpKhThWFSpaU8GG55q2iySe2N",
    contract: "5s4BYUXLuvs9ZcVDTxkTpKhThWFSpaU8GG55q2iySe2N",
    chainId: 0,
    wChainId: 1,
    decimals: 2,
    logoURI: "https://assets.coingecko.com/coins/images/24952/small/enrx.png?1649505778",
    coingeckoId: "enrex",
    realOriginContractAddress: "5s4BYUXLuvs9ZcVDTxkTpKhThWFSpaU8GG55q2iySe2N",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "Equinox",
    symbol: "ENX",
    mint: "87rSGrpYdmTxfNBf8o2cpyiNcxCmNhUPBXjT8aoyfob5",
    contract: "87rSGrpYdmTxfNBf8o2cpyiNcxCmNhUPBXjT8aoyfob5",
    chainId: 0,
    wChainId: 1,
    decimals: 9,
    logoURI: "https://assets.coingecko.com/coins/images/25234/small/ReKXsCZUnqSChIZZg4dlCIHQTKU0owxPuvj1feBDWaE.png?1650954548",
    coingeckoId: "equinox",
    realOriginContractAddress: "87rSGrpYdmTxfNBf8o2cpyiNcxCmNhUPBXjT8aoyfob5",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "Eversol Staked SOL",
    symbol: "ESOL",
    mint: "Hg35Vd8K3BS2pLB3xwC2WqQV8pmpCm3oNRGYP1PEpmCM",
    contract: "Hg35Vd8K3BS2pLB3xwC2WqQV8pmpCm3oNRGYP1PEpmCM",
    chainId: 0,
    wChainId: 1,
    decimals: 9,
    logoURI: "https://assets.coingecko.com/coins/images/23056/small/SUWTLy9j_400x400.jpeg?1657789195",
    coingeckoId: "eversol-staked-sol",
    realOriginContractAddress: "Hg35Vd8K3BS2pLB3xwC2WqQV8pmpCm3oNRGYP1PEpmCM",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "Fabric",
    symbol: "FAB",
    mint: "EdAhkbj5nF9sRM7XN7ewuW8C9XEUMs8P7cnoQ57SYE96",
    contract: "EdAhkbj5nF9sRM7XN7ewuW8C9XEUMs8P7cnoQ57SYE96",
    chainId: 0,
    wChainId: 1,
    decimals: 9,
    logoURI: "https://assets.coingecko.com/coins/images/16649/small/FABLOGO_TRANS200.png?1624592643",
    coingeckoId: "fabric",
    realOriginContractAddress: "EdAhkbj5nF9sRM7XN7ewuW8C9XEUMs8P7cnoQ57SYE96",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "Famous Fox Federation",
    symbol: "FOXY",
    mint: "FoXyMu5xwXre7zEoSvzViRk3nGawHUp9kUh97y2NDhcq",
    contract: "FoXyMu5xwXre7zEoSvzViRk3nGawHUp9kUh97y2NDhcq",
    chainId: 0,
    wChainId: 1,
    decimals: 0,
    logoURI: "https://assets.coingecko.com/coins/images/26191/small/uFYaQEsU_400x400.jpg?1656397523",
    coingeckoId: "famous-fox-federation",
    realOriginContractAddress: "FoXyMu5xwXre7zEoSvzViRk3nGawHUp9kUh97y2NDhcq",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "FaniTrade",
    symbol: "FANI",
    mint: "6c4L5nTH2sBKkfeuP3WhGp6Vq1tE4Suh4ezRp5KSu8Z7",
    contract: "6c4L5nTH2sBKkfeuP3WhGp6Vq1tE4Suh4ezRp5KSu8Z7",
    chainId: 0,
    wChainId: 1,
    decimals: 9,
    logoURI: "https://assets.coingecko.com/coins/images/24029/small/fani_200x200.png?1646115606",
    coingeckoId: "fanitrade",
    realOriginContractAddress: "6c4L5nTH2sBKkfeuP3WhGp6Vq1tE4Suh4ezRp5KSu8Z7",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "Final Frontier",
    symbol: "FRNT",
    mint: "3vHSsV6mgvpa1JVuuDZVB72vYbeUNzW4mBxiBftwzHEA",
    contract: "3vHSsV6mgvpa1JVuuDZVB72vYbeUNzW4mBxiBftwzHEA",
    chainId: 0,
    wChainId: 1,
    decimals: 9,
    logoURI: "https://assets.coingecko.com/coins/images/24120/small/Token_Logo_2_720p.png?1646386860",
    coingeckoId: "final-frontier",
    realOriginContractAddress: "3vHSsV6mgvpa1JVuuDZVB72vYbeUNzW4mBxiBftwzHEA",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "FLOOF",
    symbol: "FLOOF",
    mint: "3jzdrXXKxwkBk82u2eCWASZLCKoZs1LQTg87HBEAmBJw",
    contract: "3jzdrXXKxwkBk82u2eCWASZLCKoZs1LQTg87HBEAmBJw",
    chainId: 0,
    wChainId: 1,
    decimals: 1,
    logoURI: "https://assets.coingecko.com/coins/images/19810/small/FLOOF_logo_200x200.png?1635917291",
    coingeckoId: "floof",
    realOriginContractAddress: "3jzdrXXKxwkBk82u2eCWASZLCKoZs1LQTg87HBEAmBJw",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "Fone",
    symbol: "FONE",
    mint: "ATZERmcPfopS9vGqw9kxqRj9Bmdi3Z268nHXkGsMa3Pf",
    contract: "ATZERmcPfopS9vGqw9kxqRj9Bmdi3Z268nHXkGsMa3Pf",
    chainId: 0,
    wChainId: 1,
    decimals: 2,
    logoURI: "https://assets.coingecko.com/coins/images/23390/small/Fl-zRI0g_400x400.jpg?1644115198",
    coingeckoId: "fone",
    realOriginContractAddress: "ATZERmcPfopS9vGqw9kxqRj9Bmdi3Z268nHXkGsMa3Pf",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "Fractionalized SMB-2367",
    symbol: "DAOJONES",
    mint: "r8nuuzXCchjtqsmQZVZDPXXq928tuk7KVH479GsKVpy",
    contract: "r8nuuzXCchjtqsmQZVZDPXXq928tuk7KVH479GsKVpy",
    chainId: 0,
    wChainId: 1,
    decimals: 2,
    logoURI: "https://assets.coingecko.com/coins/images/22611/small/daojones.png?1642228974",
    coingeckoId: "fractionalized-smb-2367",
    realOriginContractAddress: "r8nuuzXCchjtqsmQZVZDPXXq928tuk7KVH479GsKVpy",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "Fractionalized WAVE-999",
    symbol: "WAV",
    mint: "4NGNdLiQ1KG8GgqZimKku4WCLdXbNw6UQJvqax3fE6CJ",
    contract: "4NGNdLiQ1KG8GgqZimKku4WCLdXbNw6UQJvqax3fE6CJ",
    chainId: 0,
    wChainId: 1,
    decimals: 2,
    logoURI: "https://assets.coingecko.com/coins/images/22176/small/IMG-20220101-021048.jpg?1641176801",
    coingeckoId: "fractionalized-wave-999",
    realOriginContractAddress: "4NGNdLiQ1KG8GgqZimKku4WCLdXbNw6UQJvqax3fE6CJ",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "FRAKT",
    symbol: "FRKT",
    mint: "ErGB9xa24Szxbk1M28u2Tx8rKPqzL6BroNkkzk5rG4zj",
    contract: "ErGB9xa24Szxbk1M28u2Tx8rKPqzL6BroNkkzk5rG4zj",
    chainId: 0,
    wChainId: 1,
    decimals: 8,
    logoURI: "https://assets.coingecko.com/coins/images/18926/small/logo_-_2021-10-11T132203.751.png?1633929748",
    coingeckoId: "frakt-token",
    realOriginContractAddress: "ErGB9xa24Szxbk1M28u2Tx8rKPqzL6BroNkkzk5rG4zj",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "Frax (Portal from Ethereum)",
    symbol: "FRAX",
    mint: "FR87nWEUxVgerFGhZM8Y4AggKGLnaXswr1Pd8wZ4kZcp",
    contract: "FR87nWEUxVgerFGhZM8Y4AggKGLnaXswr1Pd8wZ4kZcp",
    chainId: 0,
    wChainId: 1,
    decimals: 8,
    logoURI: "https://assets.coingecko.com/coins/images/13422/small/ethCanonicalFRAX.png?1669277108",
    coingeckoId: "frax",
    realOriginContractAddress: "0x853d955acef822db058eb8505911ed77f175b99e",
    realOriginChainId: 2,
    supportsPermit: !1
  },
  {
    name: "Fronk",
    symbol: "FRONK",
    mint: "5yxNbU8DgYJZNi3mPD9rs4XLh9ckXrhPjJ5VCujUWg5H",
    contract: "5yxNbU8DgYJZNi3mPD9rs4XLh9ckXrhPjJ5VCujUWg5H",
    chainId: 0,
    wChainId: 1,
    decimals: 5,
    logoURI: "https://assets.coingecko.com/coins/images/28679/small/_7XVXQ46_400x400.jpg?1673340405",
    coingeckoId: "fronk",
    realOriginContractAddress: "5yxNbU8DgYJZNi3mPD9rs4XLh9ckXrhPjJ5VCujUWg5H",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "FTX (Portal from Ethereum)",
    symbol: "FTT",
    mint: "EzfgjvkSwthhgHaceR3LnKXUoRkP6NUhfghdaHAj1tUv",
    contract: "EzfgjvkSwthhgHaceR3LnKXUoRkP6NUhfghdaHAj1tUv",
    chainId: 0,
    wChainId: 1,
    decimals: 8,
    logoURI: "https://assets.coingecko.com/coins/images/9026/small/F.png?1609051564",
    coingeckoId: "ftx-token",
    realOriginContractAddress: "0x50d1c9771902476076ecfc8b2a83ad6b9355a4c9",
    realOriginChainId: 2,
    supportsPermit: !1
  },
  {
    name: "FTX",
    symbol: "FTT",
    mint: "AGFEad2et2ZJif9jaGpdMixQqvW5i81aBdvKe7PHNfz3",
    contract: "AGFEad2et2ZJif9jaGpdMixQqvW5i81aBdvKe7PHNfz3",
    chainId: 0,
    wChainId: 1,
    decimals: 6,
    logoURI: "https://assets.coingecko.com/coins/images/9026/small/F.png?1609051564",
    coingeckoId: "ftx-token",
    realOriginContractAddress: "AGFEad2et2ZJif9jaGpdMixQqvW5i81aBdvKe7PHNfz3",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "FUMoney",
    symbol: "FUM",
    mint: "EZF2sPJRe26e8iyXaCrmEefrGVBkqqNGv9UPGG9EnTQz",
    contract: "EZF2sPJRe26e8iyXaCrmEefrGVBkqqNGv9UPGG9EnTQz",
    chainId: 0,
    wChainId: 1,
    decimals: 9,
    logoURI: "https://assets.coingecko.com/coins/images/21054/small/KuH9TXMM_400x400.jpg?1638263205",
    coingeckoId: "fumoney",
    realOriginContractAddress: "EZF2sPJRe26e8iyXaCrmEefrGVBkqqNGv9UPGG9EnTQz",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "Galaxy Essential",
    symbol: "GXE",
    mint: "DsVPH4mAppxKrmdzcizGfPtLYEBAkQGK4eUch32wgaHY",
    contract: "DsVPH4mAppxKrmdzcizGfPtLYEBAkQGK4eUch32wgaHY",
    chainId: 0,
    wChainId: 1,
    decimals: 9,
    logoURI: "https://assets.coingecko.com/coins/images/25754/small/GXE.png?1653466290",
    coingeckoId: "galaxy-essential",
    realOriginContractAddress: "DsVPH4mAppxKrmdzcizGfPtLYEBAkQGK4eUch32wgaHY",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "GameYoo",
    symbol: "GYC",
    mint: "GYCVdmDthkf3jSz5ns6fkzCmHub7FSZxjVCfbfGqkH7P",
    contract: "GYCVdmDthkf3jSz5ns6fkzCmHub7FSZxjVCfbfGqkH7P",
    chainId: 0,
    wChainId: 1,
    decimals: 9,
    logoURI: "https://assets.coingecko.com/coins/images/24525/small/gameyoo-logo-200x200.png?1648027227",
    coingeckoId: "gameyoo",
    realOriginContractAddress: "GYCVdmDthkf3jSz5ns6fkzCmHub7FSZxjVCfbfGqkH7P",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "Gari Network",
    symbol: "GARI",
    mint: "CKaKtYvz6dKPyMvYq9Rh3UBrnNqYZAyd7iF4hJtjUvks",
    contract: "CKaKtYvz6dKPyMvYq9Rh3UBrnNqYZAyd7iF4hJtjUvks",
    chainId: 0,
    wChainId: 1,
    decimals: 9,
    logoURI: "https://assets.coingecko.com/coins/images/22615/small/gari.png?1642313087",
    coingeckoId: "gari-network",
    realOriginContractAddress: "CKaKtYvz6dKPyMvYq9Rh3UBrnNqYZAyd7iF4hJtjUvks",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "Garlic",
    symbol: "GRLC",
    mint: "88YqDBWxYhhwPbExF966EdaCYBKP51xVm1oGBcbWzcf2",
    contract: "88YqDBWxYhhwPbExF966EdaCYBKP51xVm1oGBcbWzcf2",
    chainId: 0,
    wChainId: 1,
    decimals: 9,
    logoURI: "https://assets.coingecko.com/coins/images/21011/small/logo.png?1638190406",
    coingeckoId: "garlic",
    realOriginContractAddress: "88YqDBWxYhhwPbExF966EdaCYBKP51xVm1oGBcbWzcf2",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "Gary",
    symbol: "GARY",
    mint: "8c71AvjQeKKeWRe8jtTGG1bJ2WiYXQdbjqFbUfhHgSVk",
    contract: "8c71AvjQeKKeWRe8jtTGG1bJ2WiYXQdbjqFbUfhHgSVk",
    chainId: 0,
    wChainId: 1,
    decimals: 9,
    logoURI: "https://assets.coingecko.com/coins/images/26448/small/gary_logo_icon.png?1658111709",
    coingeckoId: "gary",
    realOriginContractAddress: "8c71AvjQeKKeWRe8jtTGG1bJ2WiYXQdbjqFbUfhHgSVk",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "Gear",
    symbol: "GEAR",
    mint: "7s6NLX42eURZfpyuKkVLrr9ED9hJE8718cyXFsYKqq5g",
    contract: "7s6NLX42eURZfpyuKkVLrr9ED9hJE8718cyXFsYKqq5g",
    chainId: 0,
    wChainId: 1,
    decimals: 9,
    logoURI: "https://assets.coingecko.com/coins/images/24653/small/output-onlinepngtools.png?1648524609",
    coingeckoId: "gear",
    realOriginContractAddress: "7s6NLX42eURZfpyuKkVLrr9ED9hJE8718cyXFsYKqq5g",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "GenesysGo Shadow",
    symbol: "SHDW",
    mint: "SHDWyBxihqiCj6YekG2GUr7wqKLeLAMK1gHZck9pL6y",
    contract: "SHDWyBxihqiCj6YekG2GUr7wqKLeLAMK1gHZck9pL6y",
    chainId: 0,
    wChainId: 1,
    decimals: 9,
    logoURI: "https://assets.coingecko.com/coins/images/22271/small/logo_-_2022-01-05T083602.373.png?1641342974",
    coingeckoId: "genesysgo-shadow",
    realOriginContractAddress: "SHDWyBxihqiCj6YekG2GUr7wqKLeLAMK1gHZck9pL6y",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "Genopets KI",
    symbol: "KI",
    mint: "kiGenopAScF8VF31Zbtx2Hg8qA5ArGqvnVtXb83sotc",
    contract: "kiGenopAScF8VF31Zbtx2Hg8qA5ArGqvnVtXb83sotc",
    chainId: 0,
    wChainId: 1,
    decimals: 9,
    logoURI: "https://assets.coingecko.com/coins/images/26135/small/genopets_ki.png?1660017469",
    coingeckoId: "genopet-ki",
    realOriginContractAddress: "kiGenopAScF8VF31Zbtx2Hg8qA5ArGqvnVtXb83sotc",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "Genopets",
    symbol: "GENE",
    mint: "GENEtH5amGSi8kHAtQoezp1XEXwZJ8vcuePYnXdKrMYz",
    contract: "GENEtH5amGSi8kHAtQoezp1XEXwZJ8vcuePYnXdKrMYz",
    chainId: 0,
    wChainId: 1,
    decimals: 9,
    logoURI: "https://assets.coingecko.com/coins/images/20360/small/gene-token.png?1636945172",
    coingeckoId: "genopets",
    realOriginContractAddress: "GENEtH5amGSi8kHAtQoezp1XEXwZJ8vcuePYnXdKrMYz",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "GENZ Token",
    symbol: "GENZ",
    mint: "GENZexWRRGNS2Ko5rEgGG1snRXpaa3CDDGYnhTSmE3kd",
    contract: "GENZexWRRGNS2Ko5rEgGG1snRXpaa3CDDGYnhTSmE3kd",
    chainId: 0,
    wChainId: 1,
    decimals: 9,
    logoURI: "https://assets.coingecko.com/coins/images/28039/small/Qq_rj-aG_400x400.png?1667199323",
    coingeckoId: "genz-token",
    realOriginContractAddress: "GENZexWRRGNS2Ko5rEgGG1snRXpaa3CDDGYnhTSmE3kd",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "Glitter Finance",
    symbol: "XGLI",
    mint: "FsPncBfeDV3Uv9g6yyx1NnKidvUeCaAiT2NtBAPy17xg",
    contract: "FsPncBfeDV3Uv9g6yyx1NnKidvUeCaAiT2NtBAPy17xg",
    chainId: 0,
    wChainId: 1,
    decimals: 6,
    logoURI: "https://assets.coingecko.com/coins/images/23292/small/glitter_finance.png?1660285639",
    coingeckoId: "glitter-finance",
    realOriginContractAddress: "FsPncBfeDV3Uv9g6yyx1NnKidvUeCaAiT2NtBAPy17xg",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "GMSOL",
    symbol: "GMSOL",
    mint: "gmdu3snwW28DmmxCseChp9owWLUhamH9eS3hWfHG8Vg",
    contract: "gmdu3snwW28DmmxCseChp9owWLUhamH9eS3hWfHG8Vg",
    chainId: 0,
    wChainId: 1,
    decimals: 9,
    logoURI: "https://assets.coingecko.com/coins/images/20717/small/gm-logo-200.png?1637584967",
    coingeckoId: "gmsol",
    realOriginContractAddress: "gmdu3snwW28DmmxCseChp9owWLUhamH9eS3hWfHG8Vg",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "Gobi Labs",
    symbol: "GOBI",
    mint: "MarcoPaG4dV4qit3ZPGPFm4qt4KKNBKvAsm2rPGNF72",
    contract: "MarcoPaG4dV4qit3ZPGPFm4qt4KKNBKvAsm2rPGNF72",
    chainId: 0,
    wChainId: 1,
    decimals: 6,
    logoURI: "https://assets.coingecko.com/coins/images/28554/small/GOBI.png?1671697657",
    coingeckoId: "gobi-labs",
    realOriginContractAddress: "MarcoPaG4dV4qit3ZPGPFm4qt4KKNBKvAsm2rPGNF72",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "GooseFX",
    symbol: "GOFX",
    mint: "GFX1ZjR2P15tmrSwow6FjyDYcEkoFb4p4gJCpLBjaxHD",
    contract: "GFX1ZjR2P15tmrSwow6FjyDYcEkoFb4p4gJCpLBjaxHD",
    chainId: 0,
    wChainId: 1,
    decimals: 9,
    logoURI: "https://assets.coingecko.com/coins/images/19793/small/0Kjm9f4.png?1635906737",
    coingeckoId: "goosefx",
    realOriginContractAddress: "GFX1ZjR2P15tmrSwow6FjyDYcEkoFb4p4gJCpLBjaxHD",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "Grape Protocol",
    symbol: "GRAPE",
    mint: "8upjSpvjcdpuzhfR1zriwg5NXkwDruejqNE9WNbPRtyA",
    contract: "8upjSpvjcdpuzhfR1zriwg5NXkwDruejqNE9WNbPRtyA",
    chainId: 0,
    wChainId: 1,
    decimals: 6,
    logoURI: "https://assets.coingecko.com/coins/images/18149/small/fRsuAlcV_400x400.png?1632437325",
    coingeckoId: "grape-2",
    realOriginContractAddress: "8upjSpvjcdpuzhfR1zriwg5NXkwDruejqNE9WNbPRtyA",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "STEPN Green Satoshi Token on Solana",
    symbol: "GST-SOL",
    mint: "AFbX8oGjGpmVFywbVouvhQSRmiW2aR1mohfahi4Y2AdB",
    contract: "AFbX8oGjGpmVFywbVouvhQSRmiW2aR1mohfahi4Y2AdB",
    chainId: 0,
    wChainId: 1,
    decimals: 9,
    logoURI: "https://assets.coingecko.com/coins/images/21841/small/gst.png?1640332626",
    coingeckoId: "green-satoshi-token",
    realOriginContractAddress: "AFbX8oGjGpmVFywbVouvhQSRmiW2aR1mohfahi4Y2AdB",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "Kugle GU",
    symbol: "GU",
    mint: "5KV2W2XPdSo97wQWcuAVi6G4PaCoieg4Lhhi61PAMaMJ",
    contract: "5KV2W2XPdSo97wQWcuAVi6G4PaCoieg4Lhhi61PAMaMJ",
    chainId: 0,
    wChainId: 1,
    decimals: 9,
    logoURI: "https://assets.coingecko.com/coins/images/17532/small/Logo_GU_512.png?1628129442",
    coingeckoId: "gu",
    realOriginContractAddress: "5KV2W2XPdSo97wQWcuAVi6G4PaCoieg4Lhhi61PAMaMJ",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "HAPI",
    symbol: "HAPI",
    mint: "6VNKqgz9hk7zRShTFdg5AnkfKwZUcojzwAkzxSH3bnUm",
    contract: "6VNKqgz9hk7zRShTFdg5AnkfKwZUcojzwAkzxSH3bnUm",
    chainId: 0,
    wChainId: 1,
    decimals: 9,
    logoURI: "https://assets.coingecko.com/coins/images/14298/small/R9i2HjAL_400x400.jpg?1615332438",
    coingeckoId: "hapi",
    realOriginContractAddress: "6VNKqgz9hk7zRShTFdg5AnkfKwZUcojzwAkzxSH3bnUm",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "Hawksight",
    symbol: "HAWK",
    mint: "BKipkearSqAUdNKa1WDstvcMjoPsSKBuNyvKDQDDu9WE",
    contract: "BKipkearSqAUdNKa1WDstvcMjoPsSKBuNyvKDQDDu9WE",
    chainId: 0,
    wChainId: 1,
    decimals: 6,
    logoURI: "https://assets.coingecko.com/coins/images/24459/small/3CnlKM0x_400x400.jpg?1647679676",
    coingeckoId: "hawksight",
    realOriginContractAddress: "BKipkearSqAUdNKa1WDstvcMjoPsSKBuNyvKDQDDu9WE",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "Heavenland HTO",
    symbol: "HTO",
    mint: "htoHLBJV1err8xP5oxyQdV2PLQhtVjxLXpKB7FsgJQD",
    contract: "htoHLBJV1err8xP5oxyQdV2PLQhtVjxLXpKB7FsgJQD",
    chainId: 0,
    wChainId: 1,
    decimals: 9,
    logoURI: "https://assets.coingecko.com/coins/images/25553/small/rTFh6BD.png?1652420842",
    coingeckoId: "heavenland-hto",
    realOriginContractAddress: "htoHLBJV1err8xP5oxyQdV2PLQhtVjxLXpKB7FsgJQD",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "Hedge Protocol",
    symbol: "HDG",
    mint: "5PmpMzWjraf3kSsGEKtqdUsCoLhptg4yriZ17LKKdBBy",
    contract: "5PmpMzWjraf3kSsGEKtqdUsCoLhptg4yriZ17LKKdBBy",
    chainId: 0,
    wChainId: 1,
    decimals: 9,
    logoURI: "https://assets.coingecko.com/coins/images/25482/small/hdg.png?1652011201",
    coingeckoId: "hedge-protocol",
    realOriginContractAddress: "5PmpMzWjraf3kSsGEKtqdUsCoLhptg4yriZ17LKKdBBy",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "Hedge USD",
    symbol: "USH",
    mint: "9iLH8T7zoWhY7sBmj1WK9ENbWdS1nL8n9wAxaeRitTa6",
    contract: "9iLH8T7zoWhY7sBmj1WK9ENbWdS1nL8n9wAxaeRitTa6",
    chainId: 0,
    wChainId: 1,
    decimals: 9,
    logoURI: "https://assets.coingecko.com/coins/images/25481/small/ush.png?1652011029",
    coingeckoId: "hedge-usd",
    realOriginContractAddress: "9iLH8T7zoWhY7sBmj1WK9ENbWdS1nL8n9wAxaeRitTa6",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "High Roller Hippo Clique",
    symbol: "ROLL",
    mint: "76aYNHbDfHemxSS7vmh6eJGfjodK8m7srCxiYCrKxzY1",
    contract: "76aYNHbDfHemxSS7vmh6eJGfjodK8m7srCxiYCrKxzY1",
    chainId: 0,
    wChainId: 1,
    decimals: 6,
    logoURI: "https://assets.coingecko.com/coins/images/23458/small/OslGsgzd_400x400.jpg?1644215478",
    coingeckoId: "high-roller-hippo-clique",
    realOriginContractAddress: "76aYNHbDfHemxSS7vmh6eJGfjodK8m7srCxiYCrKxzY1",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "HolyGrails.io",
    symbol: "HOLY",
    mint: "HezGWsxSVMqEZy7HJf7TtXzQRLiDruYsheYWqoUVnWQo",
    contract: "HezGWsxSVMqEZy7HJf7TtXzQRLiDruYsheYWqoUVnWQo",
    chainId: 0,
    wChainId: 1,
    decimals: 9,
    logoURI: "https://assets.coingecko.com/coins/images/28395/small/HG_Token_Design-07.png?1670290228",
    coingeckoId: "holygrails-io",
    realOriginContractAddress: "HezGWsxSVMqEZy7HJf7TtXzQRLiDruYsheYWqoUVnWQo",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "Honey Finance",
    symbol: "HONEY",
    mint: "HonyeYAaTPgKUgQpayL914P6VAqbQZPrbkGMETZvW4iN",
    contract: "HonyeYAaTPgKUgQpayL914P6VAqbQZPrbkGMETZvW4iN",
    chainId: 0,
    wChainId: 1,
    decimals: 6,
    logoURI: "https://assets.coingecko.com/coins/images/24781/small/honey.png?1648902423",
    coingeckoId: "honey-finance",
    realOriginContractAddress: "HonyeYAaTPgKUgQpayL914P6VAqbQZPrbkGMETZvW4iN",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "Hubble",
    symbol: "HBB",
    mint: "HBB111SCo9jkCejsZfz8Ec8nH7T6THF8KEKSnvwT6XK6",
    contract: "HBB111SCo9jkCejsZfz8Ec8nH7T6THF8KEKSnvwT6XK6",
    chainId: 0,
    wChainId: 1,
    decimals: 6,
    logoURI: "https://assets.coingecko.com/coins/images/22070/small/hubble.PNG?1640749942",
    coingeckoId: "hubble",
    realOriginContractAddress: "HBB111SCo9jkCejsZfz8Ec8nH7T6THF8KEKSnvwT6XK6",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "Hunter Diamond",
    symbol: "HUNT",
    mint: "CTYiHf58UGShfHtpkTwx7vjPDA779dd6iVaeD281fEVx",
    contract: "CTYiHf58UGShfHtpkTwx7vjPDA779dd6iVaeD281fEVx",
    chainId: 0,
    wChainId: 1,
    decimals: 9,
    logoURI: "https://assets.coingecko.com/coins/images/27566/small/Token_Hunters__CoinMarketCap.png?1664522159",
    coingeckoId: "hunter-diamond",
    realOriginContractAddress: "CTYiHf58UGShfHtpkTwx7vjPDA779dd6iVaeD281fEVx",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "Hxro (Portal from Ethereum)",
    symbol: "HXRO",
    mint: "HxhWkVpk5NS4Ltg5nij2G671CKXFRKPK8vy271Ub4uEK",
    contract: "HxhWkVpk5NS4Ltg5nij2G671CKXFRKPK8vy271Ub4uEK",
    chainId: 0,
    wChainId: 1,
    decimals: 8,
    logoURI: "https://assets.coingecko.com/coins/images/7805/small/Hxro_Profile_Transparent.png?1622443308",
    coingeckoId: "hxro",
    realOriginContractAddress: "0x4bd70556ae3f8a6ec6c4080a0c327b24325438f3",
    realOriginChainId: 2,
    supportsPermit: !1
  },
  {
    name: "Investin",
    symbol: "IVN",
    mint: "iVNcrNE9BRZBC9Aqf753iZiZfbszeAVUoikgT9yvr2a",
    contract: "iVNcrNE9BRZBC9Aqf753iZiZfbszeAVUoikgT9yvr2a",
    chainId: 0,
    wChainId: 1,
    decimals: 6,
    logoURI: "https://assets.coingecko.com/coins/images/15588/small/ivn_logo.png?1621267247",
    coingeckoId: "investin",
    realOriginContractAddress: "iVNcrNE9BRZBC9Aqf753iZiZfbszeAVUoikgT9yvr2a",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "Invictus",
    symbol: "IN",
    mint: "inL8PMVd6iiW3RCBJnr5AsrRN6nqr4BTrcNuQWQSkvY",
    contract: "inL8PMVd6iiW3RCBJnr5AsrRN6nqr4BTrcNuQWQSkvY",
    chainId: 0,
    wChainId: 1,
    decimals: 9,
    logoURI: "https://assets.coingecko.com/coins/images/20097/small/jv2xoOxJ_400x400.jpg?1636494713",
    coingeckoId: "invictus",
    realOriginContractAddress: "inL8PMVd6iiW3RCBJnr5AsrRN6nqr4BTrcNuQWQSkvY",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "Jelly eSports",
    symbol: "JELLY",
    mint: "9WMwGcY6TcbSfy9XPpQymY3qNEsvEaYL3wivdwPG2fpp",
    contract: "9WMwGcY6TcbSfy9XPpQymY3qNEsvEaYL3wivdwPG2fpp",
    chainId: 0,
    wChainId: 1,
    decimals: 6,
    logoURI: "https://assets.coingecko.com/coins/images/28572/small/jellylogo.png?1671863817",
    coingeckoId: "jelly-esports",
    realOriginContractAddress: "9WMwGcY6TcbSfy9XPpQymY3qNEsvEaYL3wivdwPG2fpp",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "JET",
    symbol: "JET",
    mint: "JET6zMJWkCN9tpRT2v2jfAmm5VnQFDpUBCyaKojmGtz",
    contract: "JET6zMJWkCN9tpRT2v2jfAmm5VnQFDpUBCyaKojmGtz",
    chainId: 0,
    wChainId: 1,
    decimals: 9,
    logoURI: "https://assets.coingecko.com/coins/images/18437/small/jet_logomark_color.png?1631972990",
    coingeckoId: "jet",
    realOriginContractAddress: "JET6zMJWkCN9tpRT2v2jfAmm5VnQFDpUBCyaKojmGtz",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "Jito Staked SOL",
    symbol: "JITOSOL",
    mint: "J1toso1uCk3RLmjorhTtrVwY9HJ7X8V9yYac6Y7kGCPn",
    contract: "J1toso1uCk3RLmjorhTtrVwY9HJ7X8V9yYac6Y7kGCPn",
    chainId: 0,
    wChainId: 1,
    decimals: 9,
    logoURI: "https://assets.coingecko.com/coins/images/28046/small/JitoSOL-200.png?1667271467",
    coingeckoId: "jito-staked-sol",
    realOriginContractAddress: "J1toso1uCk3RLmjorhTtrVwY9HJ7X8V9yYac6Y7kGCPn",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "JPool",
    symbol: "JSOL",
    mint: "7Q2afV64in6N6SeZsAAB81TJzwDoD6zpqmHkzi9Dcavn",
    contract: "7Q2afV64in6N6SeZsAAB81TJzwDoD6zpqmHkzi9Dcavn",
    chainId: 0,
    wChainId: 1,
    decimals: 9,
    logoURI: "https://assets.coingecko.com/coins/images/20664/small/jsol.png?1637545897",
    coingeckoId: "jpool",
    realOriginContractAddress: "7Q2afV64in6N6SeZsAAB81TJzwDoD6zpqmHkzi9Dcavn",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "Jungle",
    symbol: "JUNGLE",
    mint: "Aogv6j1wWiBAZcqRNN1Y89eozda2ke6rkc4CYy7c4iCi",
    contract: "Aogv6j1wWiBAZcqRNN1Y89eozda2ke6rkc4CYy7c4iCi",
    chainId: 0,
    wChainId: 1,
    decimals: 9,
    logoURI: "https://assets.coingecko.com/coins/images/20893/small/O9Usopi.png?1637847516",
    coingeckoId: "jungle",
    realOriginContractAddress: "Aogv6j1wWiBAZcqRNN1Y89eozda2ke6rkc4CYy7c4iCi",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "Jungle DeFi",
    symbol: "JFI",
    mint: "GePFQaZKHcWE5vpxHfviQtH5jgxokSs51Y5Q4zgBiMDs",
    contract: "GePFQaZKHcWE5vpxHfviQtH5jgxokSs51Y5Q4zgBiMDs",
    chainId: 0,
    wChainId: 1,
    decimals: 9,
    logoURI: "https://assets.coingecko.com/coins/images/23679/small/logo.png?1644997055",
    coingeckoId: "jungle-defi",
    realOriginContractAddress: "GePFQaZKHcWE5vpxHfviQtH5jgxokSs51Y5Q4zgBiMDs",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "Kalisten",
    symbol: "KS",
    mint: "3swraHsc77KMg1tFvwH3tfYcd8SWr5fcUhtmRxjavG7H",
    contract: "3swraHsc77KMg1tFvwH3tfYcd8SWr5fcUhtmRxjavG7H",
    chainId: 0,
    wChainId: 1,
    decimals: 9,
    logoURI: "https://assets.coingecko.com/coins/images/25486/small/kalisten_token.png?1652067781",
    coingeckoId: "kalisten",
    realOriginContractAddress: "3swraHsc77KMg1tFvwH3tfYcd8SWr5fcUhtmRxjavG7H",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "Keeshond",
    symbol: "$KSH",
    mint: "6j14WyX1Ag2pLWvn99euK4xp2VcZD62VeJv2iwCrYmT8",
    contract: "6j14WyX1Ag2pLWvn99euK4xp2VcZD62VeJv2iwCrYmT8",
    chainId: 0,
    wChainId: 1,
    decimals: 9,
    logoURI: "https://assets.coingecko.com/coins/images/21353/small/lkdYjrVS_400x400.jpg?1638999576",
    coingeckoId: "keeshond",
    realOriginContractAddress: "6j14WyX1Ag2pLWvn99euK4xp2VcZD62VeJv2iwCrYmT8",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "Kin",
    symbol: "KIN",
    mint: "kinXdEcpDQeHPEuQnqmUgtYykqKGVFq6CeVX5iAHJq6",
    contract: "kinXdEcpDQeHPEuQnqmUgtYykqKGVFq6CeVX5iAHJq6",
    chainId: 0,
    wChainId: 1,
    decimals: 5,
    logoURI: "https://assets.coingecko.com/coins/images/959/small/kin.png?1586917032",
    coingeckoId: "kin",
    realOriginContractAddress: "kinXdEcpDQeHPEuQnqmUgtYykqKGVFq6CeVX5iAHJq6",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "KKO Protocol",
    symbol: "KKO",
    mint: "kiNeKo77w1WBEzFFCXrTDRWGRWGP8yHvKC9rX6dqjQh",
    contract: "kiNeKo77w1WBEzFFCXrTDRWGRWGP8yHvKC9rX6dqjQh",
    chainId: 0,
    wChainId: 1,
    decimals: 9,
    logoURI: "https://assets.coingecko.com/coins/images/15366/small/kko-coingecko.png?1658982821",
    coingeckoId: "kineko",
    realOriginContractAddress: "kiNeKo77w1WBEzFFCXrTDRWGRWGP8yHvKC9rX6dqjQh",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "Kineko",
    symbol: "KNK",
    mint: "kNkT1RDnexWqYP3EYGyWv5ZtazB8CfgGAfJtv9AQ3kz",
    contract: "kNkT1RDnexWqYP3EYGyWv5ZtazB8CfgGAfJtv9AQ3kz",
    chainId: 0,
    wChainId: 1,
    decimals: 9,
    logoURI: "https://assets.coingecko.com/coins/images/26597/small/knk-cmc-logo.png?1658974690",
    coingeckoId: "kineko-knk",
    realOriginContractAddress: "kNkT1RDnexWqYP3EYGyWv5ZtazB8CfgGAfJtv9AQ3kz",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "Kitty Coin Solana",
    symbol: "KITTY",
    mint: "6XWfkyg5mzGtKNftSDgYjyoPyUsLRf2rafj95XSFSFrr",
    contract: "6XWfkyg5mzGtKNftSDgYjyoPyUsLRf2rafj95XSFSFrr",
    chainId: 0,
    wChainId: 1,
    decimals: 9,
    logoURI: "https://assets.coingecko.com/coins/images/20819/small/brand-1.png?1642645998",
    coingeckoId: "kitty-coin-solana",
    realOriginContractAddress: "6XWfkyg5mzGtKNftSDgYjyoPyUsLRf2rafj95XSFSFrr",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "Krill",
    symbol: "KRILL",
    mint: "EP2aYBDD4WvdhnwWLUMyqU69g1ePtEjgYK6qyEAFCHTx",
    contract: "EP2aYBDD4WvdhnwWLUMyqU69g1ePtEjgYK6qyEAFCHTx",
    chainId: 0,
    wChainId: 1,
    decimals: 9,
    logoURI: "https://assets.coingecko.com/coins/images/23917/small/Krill_towen.png?1645684293",
    coingeckoId: "krill",
    realOriginContractAddress: "EP2aYBDD4WvdhnwWLUMyqU69g1ePtEjgYK6qyEAFCHTx",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "Kurobi",
    symbol: "KURO",
    mint: "2Kc38rfQ49DFaKHQaWbijkE7fcymUMLY5guUiUsDmFfn",
    contract: "2Kc38rfQ49DFaKHQaWbijkE7fcymUMLY5guUiUsDmFfn",
    chainId: 0,
    wChainId: 1,
    decimals: 6,
    logoURI: "https://assets.coingecko.com/coins/images/18612/small/logo_-_2021-09-26T233232.947.png?1632670367",
    coingeckoId: "kurobi",
    realOriginContractAddress: "2Kc38rfQ49DFaKHQaWbijkE7fcymUMLY5guUiUsDmFfn",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "Laine Stake",
    symbol: "LAINESOL",
    mint: "LAinEtNLgpmCP9Rvsf5Hn8W6EhNiKLZQti1xfWMLy6X",
    contract: "LAinEtNLgpmCP9Rvsf5Hn8W6EhNiKLZQti1xfWMLy6X",
    chainId: 0,
    wChainId: 1,
    decimals: 9,
    logoURI: "https://assets.coingecko.com/coins/images/28184/small/laineSOL.png?1668257050",
    coingeckoId: "laine-stake",
    realOriginContractAddress: "LAinEtNLgpmCP9Rvsf5Hn8W6EhNiKLZQti1xfWMLy6X",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "Larix",
    symbol: "LARIX",
    mint: "Lrxqnh6ZHKbGy3dcrCED43nsoLkM1LTzU2jRfWe8qUC",
    contract: "Lrxqnh6ZHKbGy3dcrCED43nsoLkM1LTzU2jRfWe8qUC",
    chainId: 0,
    wChainId: 1,
    decimals: 6,
    logoURI: "https://assets.coingecko.com/coins/images/18450/small/larix.PNG?1632092483",
    coingeckoId: "larix",
    realOriginContractAddress: "Lrxqnh6ZHKbGy3dcrCED43nsoLkM1LTzU2jRfWe8qUC",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "Learning Star",
    symbol: "LSTAR",
    mint: "C6qep3y7tCZUJYDXHiwuK46Gt6FsoxLi8qV1bTCRYaY1",
    contract: "C6qep3y7tCZUJYDXHiwuK46Gt6FsoxLi8qV1bTCRYaY1",
    chainId: 0,
    wChainId: 1,
    decimals: 6,
    logoURI: "https://assets.coingecko.com/coins/images/25986/small/20581.png?1655155804",
    coingeckoId: "learning-star",
    realOriginContractAddress: "C6qep3y7tCZUJYDXHiwuK46Gt6FsoxLi8qV1bTCRYaY1",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "Lido DAO (Portal from Ethereum)",
    symbol: "LDO",
    mint: "HZRCwxP2Vq9PCpPXooayhJ2bxTpo5xfpQrwB1svh332p",
    contract: "HZRCwxP2Vq9PCpPXooayhJ2bxTpo5xfpQrwB1svh332p",
    chainId: 0,
    wChainId: 1,
    decimals: 8,
    logoURI: "https://assets.coingecko.com/coins/images/13573/small/Lido_DAO.png?1609873644",
    coingeckoId: "lido-dao",
    realOriginContractAddress: "0x5a98fcbea516cf06857215779fd812ca3bef1b32",
    realOriginChainId: 2,
    supportsPermit: !1
  },
  {
    name: "Lido Staked SOL",
    symbol: "STSOL",
    mint: "7dHbWXmci3dT8UFYWYZweBLXgycu7Y3iL6trKn1Y7ARj",
    contract: "7dHbWXmci3dT8UFYWYZweBLXgycu7Y3iL6trKn1Y7ARj",
    chainId: 0,
    wChainId: 1,
    decimals: 9,
    logoURI: "https://assets.coingecko.com/coins/images/18369/small/logo_-_2021-09-15T100934.765.png?1631671781",
    coingeckoId: "lido-staked-sol",
    realOriginContractAddress: "7dHbWXmci3dT8UFYWYZweBLXgycu7Y3iL6trKn1Y7ARj",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "Lifinity",
    symbol: "LFNTY",
    mint: "LFNTYraetVioAPnGJht4yNg2aUZFXR776cMeN9VMjXp",
    contract: "LFNTYraetVioAPnGJht4yNg2aUZFXR776cMeN9VMjXp",
    chainId: 0,
    wChainId: 1,
    decimals: 6,
    logoURI: "https://assets.coingecko.com/coins/images/25406/small/LFNTY_s.png?1651731251",
    coingeckoId: "lifinity",
    realOriginContractAddress: "LFNTYraetVioAPnGJht4yNg2aUZFXR776cMeN9VMjXp",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "LIQ Protocol",
    symbol: "LIQ",
    mint: "4wjPQJ6PrkC4dHhYghwJzGBVP78DkBzA2U3kHoFNBuhj",
    contract: "4wjPQJ6PrkC4dHhYghwJzGBVP78DkBzA2U3kHoFNBuhj",
    chainId: 0,
    wChainId: 1,
    decimals: 6,
    logoURI: "https://assets.coingecko.com/coins/images/16534/small/85853665.png?1624348565",
    coingeckoId: "liq-protocol",
    realOriginContractAddress: "4wjPQJ6PrkC4dHhYghwJzGBVP78DkBzA2U3kHoFNBuhj",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "Loot",
    symbol: "LOOT",
    mint: "GzpRsvnKXKz586kRLkjdppR4dUCFwHa2qaszKkPUQx6g",
    contract: "GzpRsvnKXKz586kRLkjdppR4dUCFwHa2qaszKkPUQx6g",
    chainId: 0,
    wChainId: 1,
    decimals: 6,
    logoURI: "https://assets.coingecko.com/coins/images/23015/small/Bag_Open_%283%29.png?1643093342",
    coingeckoId: "loot-token",
    realOriginContractAddress: "GzpRsvnKXKz586kRLkjdppR4dUCFwHa2qaszKkPUQx6g",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "LP Finance DAO",
    symbol: "LPFI",
    mint: "LPFiNAybMobY5oHfYVdy9jPozFBGKpPiEGoobK2xCe3",
    contract: "LPFiNAybMobY5oHfYVdy9jPozFBGKpPiEGoobK2xCe3",
    chainId: 0,
    wChainId: 1,
    decimals: 9,
    logoURI: "https://assets.coingecko.com/coins/images/27704/small/output-onlinepngtools_%2827%29.png?1666087863",
    coingeckoId: "lp-finance",
    realOriginContractAddress: "LPFiNAybMobY5oHfYVdy9jPozFBGKpPiEGoobK2xCe3",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "Maneki-neko",
    symbol: "NEKI",
    mint: "ALKiRVrfLgzeAV2mCT7cJHKg3ZoPvsCRSV7VCRWnE8zQ",
    contract: "ALKiRVrfLgzeAV2mCT7cJHKg3ZoPvsCRSV7VCRWnE8zQ",
    chainId: 0,
    wChainId: 1,
    decimals: 9,
    logoURI: "https://assets.coingecko.com/coins/images/21321/small/logo.png?1638944515",
    coingeckoId: "maneki-neko",
    realOriginContractAddress: "ALKiRVrfLgzeAV2mCT7cJHKg3ZoPvsCRSV7VCRWnE8zQ",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "Mango",
    symbol: "MNGO",
    mint: "MangoCzJ36AjZyKwVj3VnYU4GTonjfVEnJmvvWaxLac",
    contract: "MangoCzJ36AjZyKwVj3VnYU4GTonjfVEnJmvvWaxLac",
    chainId: 0,
    wChainId: 1,
    decimals: 6,
    logoURI: "https://assets.coingecko.com/coins/images/14773/small/token-mango.png?1628171237",
    coingeckoId: "mango-markets",
    realOriginContractAddress: "MangoCzJ36AjZyKwVj3VnYU4GTonjfVEnJmvvWaxLac",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "MAPS",
    symbol: "MAPS",
    mint: "MAPS41MDahZ9QdKXhVa4dWB9RuyfV4XqhyAZ8XcYepb",
    contract: "MAPS41MDahZ9QdKXhVa4dWB9RuyfV4XqhyAZ8XcYepb",
    chainId: 0,
    wChainId: 1,
    decimals: 6,
    logoURI: "https://assets.coingecko.com/coins/images/13556/small/Copy_of_image_%28139%29.png?1609768934",
    coingeckoId: "maps",
    realOriginContractAddress: "MAPS41MDahZ9QdKXhVa4dWB9RuyfV4XqhyAZ8XcYepb",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "Marinade",
    symbol: "MNDE",
    mint: "MNDEFzGvMt87ueuHvVU9VcTqsAP5b3fTGPsHuuPA5ey",
    contract: "MNDEFzGvMt87ueuHvVU9VcTqsAP5b3fTGPsHuuPA5ey",
    chainId: 0,
    wChainId: 1,
    decimals: 9,
    logoURI: "https://assets.coingecko.com/coins/images/18867/small/MNDE.png?1643187748",
    coingeckoId: "marinade",
    realOriginContractAddress: "MNDEFzGvMt87ueuHvVU9VcTqsAP5b3fTGPsHuuPA5ey",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "Matrix Solana Index",
    symbol: "MSI",
    mint: "2e7yNwrmTgXp9ABUmcPXvFJTSrEVLj4YMyrb4GUM4Pdd",
    contract: "2e7yNwrmTgXp9ABUmcPXvFJTSrEVLj4YMyrb4GUM4Pdd",
    chainId: 0,
    wChainId: 1,
    decimals: 6,
    logoURI: "https://assets.coingecko.com/coins/images/20785/small/MSI.png?1637671199",
    coingeckoId: "matrix-solana-index",
    realOriginContractAddress: "2e7yNwrmTgXp9ABUmcPXvFJTSrEVLj4YMyrb4GUM4Pdd",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "MatrixETF",
    symbol: "MDF",
    mint: "ALQ9KMWjFmxVbew3vMkJj3ypbAKuorSgGst6svCHEe2z",
    contract: "ALQ9KMWjFmxVbew3vMkJj3ypbAKuorSgGst6svCHEe2z",
    chainId: 0,
    wChainId: 1,
    decimals: 6,
    logoURI: "https://assets.coingecko.com/coins/images/18538/small/MDF.png?1632304949",
    coingeckoId: "matrixetf",
    realOriginContractAddress: "ALQ9KMWjFmxVbew3vMkJj3ypbAKuorSgGst6svCHEe2z",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "Meanfi",
    symbol: "MEAN",
    mint: "MEANeD3XDdUmNMsRGjASkSWdC8prLYsoRJ61pPeHctD",
    contract: "MEANeD3XDdUmNMsRGjASkSWdC8prLYsoRJ61pPeHctD",
    chainId: 0,
    wChainId: 1,
    decimals: 6,
    logoURI: "https://assets.coingecko.com/coins/images/21557/small/89934951.png?1639466364",
    coingeckoId: "meanfi",
    realOriginContractAddress: "MEANeD3XDdUmNMsRGjASkSWdC8prLYsoRJ61pPeHctD",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "Media Network",
    symbol: "MEDIA",
    mint: "ETAtLmCmsoiEEKfNrHKJ2kYy3MoABhU6NQvpSfij5tDs",
    contract: "ETAtLmCmsoiEEKfNrHKJ2kYy3MoABhU6NQvpSfij5tDs",
    chainId: 0,
    wChainId: 1,
    decimals: 6,
    logoURI: "https://assets.coingecko.com/coins/images/15142/small/media50x50.png?1620122020",
    coingeckoId: "media-network",
    realOriginContractAddress: "ETAtLmCmsoiEEKfNrHKJ2kYy3MoABhU6NQvpSfij5tDs",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "MekkaCoin",
    symbol: "MEK",
    mint: "MekkANZkBpzbGeTWsD1cRRuQxZMTFfBJyLrKywGQRss",
    contract: "MekkANZkBpzbGeTWsD1cRRuQxZMTFfBJyLrKywGQRss",
    chainId: 0,
    wChainId: 1,
    decimals: 9,
    logoURI: "https://assets.coingecko.com/coins/images/27530/small/unknown_%2819%29.png?1664372136",
    coingeckoId: "mekkacoin",
    realOriginContractAddress: "MekkANZkBpzbGeTWsD1cRRuQxZMTFfBJyLrKywGQRss",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "Mend",
    symbol: "MEND",
    mint: "Ch9NFVk5sqEPQHtw2gJVgnHfTm7FW1JspYwc7SxLi6q3",
    contract: "Ch9NFVk5sqEPQHtw2gJVgnHfTm7FW1JspYwc7SxLi6q3",
    chainId: 0,
    wChainId: 1,
    decimals: 9,
    logoURI: "https://assets.coingecko.com/coins/images/25917/small/logo-e1637099222337.png?1654592434",
    coingeckoId: "mend",
    realOriginContractAddress: "Ch9NFVk5sqEPQHtw2gJVgnHfTm7FW1JspYwc7SxLi6q3",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "Mercurial",
    symbol: "MER",
    mint: "MERt85fc5boKw3BW1eYdxonEuJNvXbiMbs6hvheau5K",
    contract: "MERt85fc5boKw3BW1eYdxonEuJNvXbiMbs6hvheau5K",
    chainId: 0,
    wChainId: 1,
    decimals: 6,
    logoURI: "https://assets.coingecko.com/coins/images/15527/small/mer_logo.png?1621128922",
    coingeckoId: "mercurial",
    realOriginContractAddress: "MERt85fc5boKw3BW1eYdxonEuJNvXbiMbs6hvheau5K",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "MetaMall",
    symbol: "MALL",
    mint: "5EbpXhW7t8ypBF3Q1X7odFaHjuh7XJfCohXR3VYAW32i",
    contract: "5EbpXhW7t8ypBF3Q1X7odFaHjuh7XJfCohXR3VYAW32i",
    chainId: 0,
    wChainId: 1,
    decimals: 3,
    logoURI: "https://assets.coingecko.com/coins/images/24183/small/gRlsG1JA_400x400.jpg?1646787127",
    coingeckoId: "metamall",
    realOriginContractAddress: "5EbpXhW7t8ypBF3Q1X7odFaHjuh7XJfCohXR3VYAW32i",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "Metaplex",
    symbol: "MPLX",
    mint: "METAewgxyPbgwsseH8T16a39CQ5VyVxZi9zXiDPY18m",
    contract: "METAewgxyPbgwsseH8T16a39CQ5VyVxZi9zXiDPY18m",
    chainId: 0,
    wChainId: 1,
    decimals: 6,
    logoURI: "https://assets.coingecko.com/coins/images/27344/small/mplx.png?1663636769",
    coingeckoId: "metaplex",
    realOriginContractAddress: "METAewgxyPbgwsseH8T16a39CQ5VyVxZi9zXiDPY18m",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "Million Monke",
    symbol: "MIMO",
    mint: "9TE7ebz1dsFo1uQ2T4oYAKSm39Y6fWuHrd6Uk6XaiD16",
    contract: "9TE7ebz1dsFo1uQ2T4oYAKSm39Y6fWuHrd6Uk6XaiD16",
    chainId: 0,
    wChainId: 1,
    decimals: 9,
    logoURI: "https://assets.coingecko.com/coins/images/21071/small/200xMIMO.png?1638281151",
    coingeckoId: "million-monke",
    realOriginContractAddress: "9TE7ebz1dsFo1uQ2T4oYAKSm39Y6fWuHrd6Uk6XaiD16",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "MAI",
    symbol: "MIMATIC",
    mint: "9mWRABuz2x6koTPCWiCPM49WUbcrNqGTHBV9T9k7y1o7",
    contract: "9mWRABuz2x6koTPCWiCPM49WUbcrNqGTHBV9T9k7y1o7",
    chainId: 0,
    wChainId: 1,
    decimals: 9,
    logoURI: "https://assets.coingecko.com/coins/images/15264/small/mimatic-red.png?1620281018",
    coingeckoId: "mimatic",
    realOriginContractAddress: "9mWRABuz2x6koTPCWiCPM49WUbcrNqGTHBV9T9k7y1o7",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "Mindfolk Wood",
    symbol: "$WOOD",
    mint: "674PmuiDtgKx3uKuJ1B16f9m5L84eFvNwj3xDMvHcbo7",
    contract: "674PmuiDtgKx3uKuJ1B16f9m5L84eFvNwj3xDMvHcbo7",
    chainId: 0,
    wChainId: 1,
    decimals: 9,
    logoURI: "https://assets.coingecko.com/coins/images/22512/small/tokenlogo.png?1641966072",
    coingeckoId: "mindfolk-wood",
    realOriginContractAddress: "674PmuiDtgKx3uKuJ1B16f9m5L84eFvNwj3xDMvHcbo7",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "MMA Gaming",
    symbol: "MMA",
    mint: "MMAx26JtJgSWv6yH48nEHCGZcVvRbf9Lt9ALa7jSipe",
    contract: "MMAx26JtJgSWv6yH48nEHCGZcVvRbf9Lt9ALa7jSipe",
    chainId: 0,
    wChainId: 1,
    decimals: 9,
    logoURI: "https://assets.coingecko.com/coins/images/23767/small/18166.png?1645425116",
    coingeckoId: "mma-gaming",
    realOriginContractAddress: "MMAx26JtJgSWv6yH48nEHCGZcVvRbf9Lt9ALa7jSipe",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "MonkeyLeague",
    symbol: "MBS",
    mint: "Fm9rHUTF5v3hwMLbStjZXqNBBoZyGriQaFM6sTFz3K8A",
    contract: "Fm9rHUTF5v3hwMLbStjZXqNBBoZyGriQaFM6sTFz3K8A",
    chainId: 0,
    wChainId: 1,
    decimals: 6,
    logoURI: "https://assets.coingecko.com/coins/images/20841/small/monkeyball.png?1639023123",
    coingeckoId: "monkeyball",
    realOriginContractAddress: "Fm9rHUTF5v3hwMLbStjZXqNBBoZyGriQaFM6sTFz3K8A",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "MoonLana",
    symbol: "MOLA",
    mint: "AMdnw9H5DFtQwZowVFr4kUgSXJzLokKSinvgGiUoLSps",
    contract: "AMdnw9H5DFtQwZowVFr4kUgSXJzLokKSinvgGiUoLSps",
    chainId: 0,
    wChainId: 1,
    decimals: 9,
    logoURI: "https://assets.coingecko.com/coins/images/16278/small/NW8RySX.png?1623635238",
    coingeckoId: "moonlana",
    realOriginContractAddress: "AMdnw9H5DFtQwZowVFr4kUgSXJzLokKSinvgGiUoLSps",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "Marinade staked SOL",
    symbol: "MSOL",
    mint: "mSoLzYCxHdYgdzU16g5QSh3i5K3z3KZK7ytfqcJm7So",
    contract: "mSoLzYCxHdYgdzU16g5QSh3i5K3z3KZK7ytfqcJm7So",
    chainId: 0,
    wChainId: 1,
    decimals: 9,
    logoURI: "https://assets.coingecko.com/coins/images/17752/small/mSOL.png?1644541955",
    coingeckoId: "msol",
    realOriginContractAddress: "mSoLzYCxHdYgdzU16g5QSh3i5K3z3KZK7ytfqcJm7So",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "Neonomad Finance",
    symbol: "NNI",
    mint: "buMnhMd5xSyXBssTQo15jouu8VhuEZJCfbtBUZgRcuW",
    contract: "buMnhMd5xSyXBssTQo15jouu8VhuEZJCfbtBUZgRcuW",
    chainId: 0,
    wChainId: 1,
    decimals: 6,
    logoURI: "https://assets.coingecko.com/coins/images/25068/small/SeSkZxx7_400x400.jpeg?1658118217",
    coingeckoId: "neonomad-finance",
    realOriginContractAddress: "buMnhMd5xSyXBssTQo15jouu8VhuEZJCfbtBUZgRcuW",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "Nest Arcade",
    symbol: "NESTA",
    mint: "Czt7Fc4dz6BpLh2vKiSYyotNK2uPPDhvbWrrLeD9QxhV",
    contract: "Czt7Fc4dz6BpLh2vKiSYyotNK2uPPDhvbWrrLeD9QxhV",
    chainId: 0,
    wChainId: 1,
    decimals: 9,
    logoURI: "https://assets.coingecko.com/coins/images/24182/small/mPFhh9sZ_400x400.jpg?1646786783",
    coingeckoId: "nest-arcade",
    realOriginContractAddress: "Czt7Fc4dz6BpLh2vKiSYyotNK2uPPDhvbWrrLeD9QxhV",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "NftEyez",
    symbol: "EYE",
    mint: "G7eETAaUzmsBPKhokZyfbaT4tD9igdZSmfQGEYWem8Sw",
    contract: "G7eETAaUzmsBPKhokZyfbaT4tD9igdZSmfQGEYWem8Sw",
    chainId: 0,
    wChainId: 1,
    decimals: 6,
    logoURI: "https://assets.coingecko.com/coins/images/22079/small/eye-coin.png?1640755291",
    coingeckoId: "nfteyez",
    realOriginContractAddress: "G7eETAaUzmsBPKhokZyfbaT4tD9igdZSmfQGEYWem8Sw",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "Ninja Protocol",
    symbol: "NINJA",
    mint: "FgX1WD9WzMU3yLwXaFSarPfkgzjLb2DZCqmkx9ExpuvJ",
    contract: "FgX1WD9WzMU3yLwXaFSarPfkgzjLb2DZCqmkx9ExpuvJ",
    chainId: 0,
    wChainId: 1,
    decimals: 6,
    logoURI: "https://assets.coingecko.com/coins/images/18442/small/ninja.PNG?1632006127",
    coingeckoId: "ninja-protocol",
    realOriginContractAddress: "FgX1WD9WzMU3yLwXaFSarPfkgzjLb2DZCqmkx9ExpuvJ",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "Nirvana ANA",
    symbol: "ANA",
    mint: "ANAxByE6G2WjFp7A4NqtWYXb3mgruyzZYg3spfxe6Lbo",
    contract: "ANAxByE6G2WjFp7A4NqtWYXb3mgruyzZYg3spfxe6Lbo",
    chainId: 0,
    wChainId: 1,
    decimals: 6,
    logoURI: "https://assets.coingecko.com/coins/images/25012/small/ANA_Logo.png?1649822203",
    coingeckoId: "nirvana-ana",
    realOriginContractAddress: "ANAxByE6G2WjFp7A4NqtWYXb3mgruyzZYg3spfxe6Lbo",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "Nirvana prANA",
    symbol: "PRANA",
    mint: "PRAxfbouRoJ9yZqhyejEAH6RvjJ86Y82vfiZTBSM3xG",
    contract: "PRAxfbouRoJ9yZqhyejEAH6RvjJ86Y82vfiZTBSM3xG",
    chainId: 0,
    wChainId: 1,
    decimals: 6,
    logoURI: "https://assets.coingecko.com/coins/images/26176/small/prANA.png?1656379283",
    coingeckoId: "nirvana-prana",
    realOriginContractAddress: "PRAxfbouRoJ9yZqhyejEAH6RvjJ86Y82vfiZTBSM3xG",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "Nosana",
    symbol: "NOS",
    mint: "nosXBVoaCTtYdLvKY6Csb4AC8JCdQKKAaWYtx2ZMoo7",
    contract: "nosXBVoaCTtYdLvKY6Csb4AC8JCdQKKAaWYtx2ZMoo7",
    chainId: 0,
    wChainId: 1,
    decimals: 6,
    logoURI: "https://assets.coingecko.com/coins/images/22553/small/POfb_I4u_400x400.jpg?1642053655",
    coingeckoId: "nosana",
    realOriginContractAddress: "nosXBVoaCTtYdLvKY6Csb4AC8JCdQKKAaWYtx2ZMoo7",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "Nova Finance",
    symbol: "NOVA",
    mint: "BDrL8huis6S5tpmozaAaT5zhE5A7ZBAB2jMMvpKEeF8A",
    contract: "BDrL8huis6S5tpmozaAaT5zhE5A7ZBAB2jMMvpKEeF8A",
    chainId: 0,
    wChainId: 1,
    decimals: 9,
    logoURI: "https://assets.coingecko.com/coins/images/21672/small/bGVB8h2Q_400x400.jpg?1639710371",
    coingeckoId: "nova-finance",
    realOriginContractAddress: "BDrL8huis6S5tpmozaAaT5zhE5A7ZBAB2jMMvpKEeF8A",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "Okay Bears Floor Index",
    symbol: "OKAYB",
    mint: "Ca9LxRYdZ7jK4QAqjLo4iaYmiV8FNdngtSkzM69hzgDX",
    contract: "Ca9LxRYdZ7jK4QAqjLo4iaYmiV8FNdngtSkzM69hzgDX",
    chainId: 0,
    wChainId: 1,
    decimals: 2,
    logoURI: "https://assets.coingecko.com/coins/images/27170/small/9815.png?1662286926",
    coingeckoId: "okay-bears-floor-index",
    realOriginContractAddress: "Ca9LxRYdZ7jK4QAqjLo4iaYmiV8FNdngtSkzM69hzgDX",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "Onespace",
    symbol: "1SP",
    mint: "2zzC22UBgJGCYPdFyo7GDwz7YHq5SozJc1nnBqLU8oZb",
    contract: "2zzC22UBgJGCYPdFyo7GDwz7YHq5SozJc1nnBqLU8oZb",
    chainId: 0,
    wChainId: 1,
    decimals: 9,
    logoURI: "https://assets.coingecko.com/coins/images/26474/small/1SP_logo.png?1658195640",
    coingeckoId: "onespace",
    realOriginContractAddress: "2zzC22UBgJGCYPdFyo7GDwz7YHq5SozJc1nnBqLU8oZb",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "Only1",
    symbol: "LIKE",
    mint: "3bRTivrVsitbmCTGtqwp7hxXPsybkjn4XLNtPsHqa3zR",
    contract: "3bRTivrVsitbmCTGtqwp7hxXPsybkjn4XLNtPsHqa3zR",
    chainId: 0,
    wChainId: 1,
    decimals: 9,
    logoURI: "https://assets.coingecko.com/coins/images/17501/small/like-token.png?1628036165",
    coingeckoId: "only1",
    realOriginContractAddress: "3bRTivrVsitbmCTGtqwp7hxXPsybkjn4XLNtPsHqa3zR",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "OOGI",
    symbol: "OOGI",
    mint: "H7Qc9APCWWGDVxGD5fJHmLTmdEgT9GFatAKFNg6sHh8A",
    contract: "H7Qc9APCWWGDVxGD5fJHmLTmdEgT9GFatAKFNg6sHh8A",
    chainId: 0,
    wChainId: 1,
    decimals: 9,
    logoURI: "https://assets.coingecko.com/coins/images/19714/small/oogi.PNG?1635756218",
    coingeckoId: "oogi",
    realOriginContractAddress: "H7Qc9APCWWGDVxGD5fJHmLTmdEgT9GFatAKFNg6sHh8A",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "Orca",
    symbol: "ORCA",
    mint: "orcaEKTdK7LKz57vaAYr9QeNsVEPfiu6QeMU1kektZE",
    contract: "orcaEKTdK7LKz57vaAYr9QeNsVEPfiu6QeMU1kektZE",
    chainId: 0,
    wChainId: 1,
    decimals: 6,
    logoURI: "https://assets.coingecko.com/coins/images/17547/small/Orca_Logo.png?1628781615",
    coingeckoId: "orca",
    realOriginContractAddress: "orcaEKTdK7LKz57vaAYr9QeNsVEPfiu6QeMU1kektZE",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "Oxbull Solana",
    symbol: "OXS",
    mint: "4TGxgCSJQx2GQk9oHZ8dC5m3JNXTYZHjXumKAW3vLnNx",
    contract: "4TGxgCSJQx2GQk9oHZ8dC5m3JNXTYZHjXumKAW3vLnNx",
    chainId: 0,
    wChainId: 1,
    decimals: 9,
    logoURI: "https://assets.coingecko.com/coins/images/17304/small/9xPPXxJC_400x400.jpg?1627269668",
    coingeckoId: "oxbull-solana",
    realOriginContractAddress: "4TGxgCSJQx2GQk9oHZ8dC5m3JNXTYZHjXumKAW3vLnNx",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "Oxygen",
    symbol: "OXY",
    mint: "z3dn17yLaGMKffVogeFHQ9zWVcXgqgf3PQnDsNs2g6M",
    contract: "z3dn17yLaGMKffVogeFHQ9zWVcXgqgf3PQnDsNs2g6M",
    chainId: 0,
    wChainId: 1,
    decimals: 6,
    logoURI: "https://assets.coingecko.com/coins/images/13509/small/8DjBZ79V_400x400.jpg?1609236331",
    coingeckoId: "oxygen",
    realOriginContractAddress: "z3dn17yLaGMKffVogeFHQ9zWVcXgqgf3PQnDsNs2g6M",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "Panda Coin",
    symbol: "PANDA",
    mint: "Aw8qLRHGhMcKq7rxs5XBNCd9oe3BvoAhpNMVz7AdGmty",
    contract: "Aw8qLRHGhMcKq7rxs5XBNCd9oe3BvoAhpNMVz7AdGmty",
    chainId: 0,
    wChainId: 1,
    decimals: 9,
    logoURI: "https://assets.coingecko.com/coins/images/20500/small/panda.png?1638349709",
    coingeckoId: "panda-coin",
    realOriginContractAddress: "Aw8qLRHGhMcKq7rxs5XBNCd9oe3BvoAhpNMVz7AdGmty",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "Parasol Finance",
    symbol: "PSOL",
    mint: "Hmatmu1ktLbobSvim94mfpZmjL5iiyoM1zidtXJRAdLZ",
    contract: "Hmatmu1ktLbobSvim94mfpZmjL5iiyoM1zidtXJRAdLZ",
    chainId: 0,
    wChainId: 1,
    decimals: 7,
    logoURI: "https://assets.coingecko.com/coins/images/21551/small/icon.png?1642584584",
    coingeckoId: "parasol-finance",
    realOriginContractAddress: "Hmatmu1ktLbobSvim94mfpZmjL5iiyoM1zidtXJRAdLZ",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "Parrot Protocol",
    symbol: "PRT",
    mint: "PRT88RkA4Kg5z7pKnezeNH4mafTvtQdfFgpQTGRjz44",
    contract: "PRT88RkA4Kg5z7pKnezeNH4mafTvtQdfFgpQTGRjz44",
    chainId: 0,
    wChainId: 1,
    decimals: 6,
    logoURI: "https://assets.coingecko.com/coins/images/18443/small/PRT.png?1634698095",
    coingeckoId: "parrot-protocol",
    realOriginContractAddress: "PRT88RkA4Kg5z7pKnezeNH4mafTvtQdfFgpQTGRjz44",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "Parrot USD",
    symbol: "PAI",
    mint: "Ea5SjE2Y6yvCeW5dYTn7PYMuW5ikXkvbGdcmSnXeaLjS",
    contract: "Ea5SjE2Y6yvCeW5dYTn7PYMuW5ikXkvbGdcmSnXeaLjS",
    chainId: 0,
    wChainId: 1,
    decimals: 6,
    logoURI: "https://assets.coingecko.com/coins/images/18439/small/pai.png?1632004568",
    coingeckoId: "parrot-usd",
    realOriginContractAddress: "Ea5SjE2Y6yvCeW5dYTn7PYMuW5ikXkvbGdcmSnXeaLjS",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "Particle Technology",
    symbol: "PART",
    mint: "AVKnbqNQgXDY8kbnno9eSGfwpVz5idimBnDKiz1vbWAh",
    contract: "AVKnbqNQgXDY8kbnno9eSGfwpVz5idimBnDKiz1vbWAh",
    chainId: 0,
    wChainId: 1,
    decimals: 9,
    logoURI: "https://assets.coingecko.com/coins/images/21302/small/logo.png?1638882252",
    coingeckoId: "particle-technology",
    realOriginContractAddress: "AVKnbqNQgXDY8kbnno9eSGfwpVz5idimBnDKiz1vbWAh",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "Phant",
    symbol: "PNT",
    mint: "AKxR1NLTtPnsVcWwPSEGat1TC9da3Z2vX7sY4G7ZLj1r",
    contract: "AKxR1NLTtPnsVcWwPSEGat1TC9da3Z2vX7sY4G7ZLj1r",
    chainId: 0,
    wChainId: 1,
    decimals: 9,
    logoURI: "https://assets.coingecko.com/coins/images/22799/small/logogradientsm.png?1642583142",
    coingeckoId: "phant",
    realOriginContractAddress: "AKxR1NLTtPnsVcWwPSEGat1TC9da3Z2vX7sY4G7ZLj1r",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "Phantasia",
    symbol: "FANT",
    mint: "FANTafPFBAt93BNJVpdu25pGPmca3RfwdsDsRrT3LX1r",
    contract: "FANTafPFBAt93BNJVpdu25pGPmca3RfwdsDsRrT3LX1r",
    chainId: 0,
    wChainId: 1,
    decimals: 6,
    logoURI: "https://assets.coingecko.com/coins/images/21604/small/Phantasia_Logo.png?1639553227",
    coingeckoId: "phantasia",
    realOriginContractAddress: "FANTafPFBAt93BNJVpdu25pGPmca3RfwdsDsRrT3LX1r",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "Physis",
    symbol: "PHY",
    mint: "EswgBj2hZKdgovX2ihWSUDnuBg9VNbGmSGoH5yjNsPRa",
    contract: "EswgBj2hZKdgovX2ihWSUDnuBg9VNbGmSGoH5yjNsPRa",
    chainId: 0,
    wChainId: 1,
    decimals: 9,
    logoURI: "https://assets.coingecko.com/coins/images/23087/small/PHY-icon-200x200.png?1643181312",
    coingeckoId: "physis",
    realOriginContractAddress: "EswgBj2hZKdgovX2ihWSUDnuBg9VNbGmSGoH5yjNsPRa",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "Pixels.so",
    symbol: "PIXL",
    mint: "5L2YboFbHAUpBDDJjvDB5M6pu9CW2FRjyDB2asZyvjtE",
    contract: "5L2YboFbHAUpBDDJjvDB5M6pu9CW2FRjyDB2asZyvjtE",
    chainId: 0,
    wChainId: 1,
    decimals: 8,
    logoURI: "https://assets.coingecko.com/coins/images/21390/small/logo.png?1639036659",
    coingeckoId: "pixels-so",
    realOriginContractAddress: "5L2YboFbHAUpBDDJjvDB5M6pu9CW2FRjyDB2asZyvjtE",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "Playground",
    symbol: "PLAYA",
    mint: "E6oCGvmSYW7qhy7oeDfiNZLX6hEmPCVxBC8AknwAj82B",
    contract: "E6oCGvmSYW7qhy7oeDfiNZLX6hEmPCVxBC8AknwAj82B",
    chainId: 0,
    wChainId: 1,
    decimals: 2,
    logoURI: "https://assets.coingecko.com/coins/images/24387/small/playa.PNG?1647502195",
    coingeckoId: "playground",
    realOriginContractAddress: "E6oCGvmSYW7qhy7oeDfiNZLX6hEmPCVxBC8AknwAj82B",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "Playground Waves Floor Index",
    symbol: "WAVES",
    mint: "4uRn7vxRPWYP4HuAa4UNXwEPLRL8oQ71YByMhr6yBnL4",
    contract: "4uRn7vxRPWYP4HuAa4UNXwEPLRL8oQ71YByMhr6yBnL4",
    chainId: 0,
    wChainId: 1,
    decimals: 2,
    logoURI: "https://assets.coingecko.com/coins/images/24388/small/playgorund_waves.PNG?1647502973",
    coingeckoId: "playground-waves-floor-index",
    realOriginContractAddress: "4uRn7vxRPWYP4HuAa4UNXwEPLRL8oQ71YByMhr6yBnL4",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "Plutonian DAO",
    symbol: "PLD",
    mint: "2cJgFtnqjaoiu9fKVX3fny4Z4pRzuaqfJ3PBTMk2D9ur",
    contract: "2cJgFtnqjaoiu9fKVX3fny4Z4pRzuaqfJ3PBTMk2D9ur",
    chainId: 0,
    wChainId: 1,
    decimals: 6,
    logoURI: "https://assets.coingecko.com/coins/images/25092/small/logo-pld_200.png?1650270204",
    coingeckoId: "plutonian-dao",
    realOriginContractAddress: "2cJgFtnqjaoiu9fKVX3fny4Z4pRzuaqfJ3PBTMk2D9ur",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "Pollen Coin",
    symbol: "PCN",
    mint: "GWsZd8k85q2ie9SNycVSLeKkX7HLZfSsgx6Jdat9cjY1",
    contract: "GWsZd8k85q2ie9SNycVSLeKkX7HLZfSsgx6Jdat9cjY1",
    chainId: 0,
    wChainId: 1,
    decimals: 9,
    logoURI: "https://assets.coingecko.com/coins/images/25687/small/97762641.png?1653374572",
    coingeckoId: "pollen-coin",
    realOriginContractAddress: "GWsZd8k85q2ie9SNycVSLeKkX7HLZfSsgx6Jdat9cjY1",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "Port Finance",
    symbol: "PORT",
    mint: "PoRTjZMPXb9T7dyU7tpLEZRQj7e6ssfAE62j2oQuc6y",
    contract: "PoRTjZMPXb9T7dyU7tpLEZRQj7e6ssfAE62j2oQuc6y",
    chainId: 0,
    wChainId: 1,
    decimals: 6,
    logoURI: "https://assets.coingecko.com/coins/images/17607/small/d-k0Ezts_400x400.jpg?1628648715",
    coingeckoId: "port-finance",
    realOriginContractAddress: "PoRTjZMPXb9T7dyU7tpLEZRQj7e6ssfAE62j2oQuc6y",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "Portals Ivory Index",
    symbol: "IVRY",
    mint: "2MtPZqwNKTNsBoFCwm4ZTWk3ySz4LSd82ucDGeTk7VNu",
    contract: "2MtPZqwNKTNsBoFCwm4ZTWk3ySz4LSd82ucDGeTk7VNu",
    chainId: 0,
    wChainId: 1,
    decimals: 2,
    logoURI: "https://assets.coingecko.com/coins/images/24389/small/portal.PNG?1647503207",
    coingeckoId: "portals-ivory-index",
    realOriginContractAddress: "2MtPZqwNKTNsBoFCwm4ZTWk3ySz4LSd82ucDGeTk7VNu",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "Positron",
    symbol: "POT",
    mint: "9iz45n44TQUPyoRymdZXEunqvZUksZyhzS6zQ7sLMadj",
    contract: "9iz45n44TQUPyoRymdZXEunqvZUksZyhzS6zQ7sLMadj",
    chainId: 0,
    wChainId: 1,
    decimals: 9,
    logoURI: "https://assets.coingecko.com/coins/images/23910/small/logo.png?1645682226",
    coingeckoId: "positron-token",
    realOriginContractAddress: "9iz45n44TQUPyoRymdZXEunqvZUksZyhzS6zQ7sLMadj",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "Potato",
    symbol: "POTATO",
    mint: "GEYrotdkRitGUK5UMv3aMttEhVAZLhRJMcG82zKYsaWB",
    contract: "GEYrotdkRitGUK5UMv3aMttEhVAZLhRJMcG82zKYsaWB",
    chainId: 0,
    wChainId: 1,
    decimals: 3,
    logoURI: "https://assets.coingecko.com/coins/images/18254/small/logocircle.png?1631151305",
    coingeckoId: "potato",
    realOriginContractAddress: "GEYrotdkRitGUK5UMv3aMttEhVAZLhRJMcG82zKYsaWB",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "Prism",
    symbol: "PRISM",
    mint: "PRSMNsEPqhGVCH1TtWiJqPjJyh2cKrLostPZTNy1o5x",
    contract: "PRSMNsEPqhGVCH1TtWiJqPjJyh2cKrLostPZTNy1o5x",
    chainId: 0,
    wChainId: 1,
    decimals: 6,
    logoURI: "https://assets.coingecko.com/coins/images/21475/small/7KzeGb1.png?1639350211",
    coingeckoId: "prism",
    realOriginContractAddress: "PRSMNsEPqhGVCH1TtWiJqPjJyh2cKrLostPZTNy1o5x",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "ProtoReality Games",
    symbol: "PRGC",
    mint: "66edZnAPEJSxnAK4SckuupssXpbu5doV57FUcghaqPsY",
    contract: "66edZnAPEJSxnAK4SckuupssXpbu5doV57FUcghaqPsY",
    chainId: 0,
    wChainId: 1,
    decimals: 9,
    logoURI: "https://assets.coingecko.com/coins/images/25525/small/Bjh4zRK1_400x400.png?1652235059",
    coingeckoId: "protoreality-games",
    realOriginContractAddress: "66edZnAPEJSxnAK4SckuupssXpbu5doV57FUcghaqPsY",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "PsyOptions",
    symbol: "PSY",
    mint: "PsyFiqqjiv41G7o5SMRzDJCu4psptThNR2GtfeGHfSq",
    contract: "PsyFiqqjiv41G7o5SMRzDJCu4psptThNR2GtfeGHfSq",
    chainId: 0,
    wChainId: 1,
    decimals: 6,
    logoURI: "https://assets.coingecko.com/coins/images/22784/small/download.png?1642580392",
    coingeckoId: "psyoptions",
    realOriginContractAddress: "PsyFiqqjiv41G7o5SMRzDJCu4psptThNR2GtfeGHfSq",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "PUFF",
    symbol: "PUFF",
    mint: "G9tt98aYSznRk7jWsfuz9FnTdokxS6Brohdo9hSmjTRB",
    contract: "G9tt98aYSznRk7jWsfuz9FnTdokxS6Brohdo9hSmjTRB",
    chainId: 0,
    wChainId: 1,
    decimals: 9,
    logoURI: "https://assets.coingecko.com/coins/images/22049/small/logo_%281%29.png?1640675965",
    coingeckoId: "puff",
    realOriginContractAddress: "G9tt98aYSznRk7jWsfuz9FnTdokxS6Brohdo9hSmjTRB",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "RaceFi",
    symbol: "RACEFI",
    mint: "AAmGoPDFLG6bE82BgZWjVi8k95tj9Tf3vUN7WvtUm2BU",
    contract: "AAmGoPDFLG6bE82BgZWjVi8k95tj9Tf3vUN7WvtUm2BU",
    chainId: 0,
    wChainId: 1,
    decimals: 6,
    logoURI: "https://assets.coingecko.com/coins/images/21873/small/XIF9z8Z6_400x400.jpg?1640209612",
    coingeckoId: "racefi",
    realOriginContractAddress: "AAmGoPDFLG6bE82BgZWjVi8k95tj9Tf3vUN7WvtUm2BU",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "RAD",
    symbol: "RAD",
    mint: "B6aJ3TGfme3SMnLSouHXqWXjVFqYyqj7czzhzr8WJFAi",
    contract: "B6aJ3TGfme3SMnLSouHXqWXjVFqYyqj7czzhzr8WJFAi",
    chainId: 0,
    wChainId: 1,
    decimals: 4,
    logoURI: "https://assets.coingecko.com/coins/images/22854/small/unknown.png?1642750640",
    coingeckoId: "rad",
    realOriginContractAddress: "B6aJ3TGfme3SMnLSouHXqWXjVFqYyqj7czzhzr8WJFAi",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "Rally (Solana)",
    symbol: "SRLY",
    mint: "sRLY3migNrkC1HLgqotpvi66qGkdNedqPZ9TJpAQhyh",
    contract: "sRLY3migNrkC1HLgqotpvi66qGkdNedqPZ9TJpAQhyh",
    chainId: 0,
    wChainId: 1,
    decimals: 9,
    logoURI: "https://assets.coingecko.com/coins/images/23239/small/srly.png?1643531979",
    coingeckoId: "rally-solana",
    realOriginContractAddress: "sRLY3migNrkC1HLgqotpvi66qGkdNedqPZ9TJpAQhyh",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "Ratio Protocol",
    symbol: "RATIO",
    mint: "ratioMVg27rSZbSvBopUvsdrGUzeALUfFma61mpxc8J",
    contract: "ratioMVg27rSZbSvBopUvsdrGUzeALUfFma61mpxc8J",
    chainId: 0,
    wChainId: 1,
    decimals: 6,
    logoURI: "https://assets.coingecko.com/coins/images/24543/small/ratio.png?1648108625",
    coingeckoId: "ratio-finance",
    realOriginContractAddress: "ratioMVg27rSZbSvBopUvsdrGUzeALUfFma61mpxc8J",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "Ratio Stable Coin",
    symbol: "USDR",
    mint: "USDrbBQwQbQ2oWHUPfA8QBHcyVxKUq1xHyXsSLKdUq2",
    contract: "USDrbBQwQbQ2oWHUPfA8QBHcyVxKUq1xHyXsSLKdUq2",
    chainId: 0,
    wChainId: 1,
    decimals: 6,
    logoURI: "https://assets.coingecko.com/coins/images/26066/small/usdr_logo.png?1655469254",
    coingeckoId: "ratio-stable-coin",
    realOriginContractAddress: "USDrbBQwQbQ2oWHUPfA8QBHcyVxKUq1xHyXsSLKdUq2",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "Raydium",
    symbol: "RAY",
    mint: "4k3Dyjzvzp8eMZWUXbBCjEvwSkkk59S5iCNLY3QrkX6R",
    contract: "4k3Dyjzvzp8eMZWUXbBCjEvwSkkk59S5iCNLY3QrkX6R",
    chainId: 0,
    wChainId: 1,
    decimals: 6,
    logoURI: "https://assets.coingecko.com/coins/images/13928/small/PSigc4ie_400x400.jpg?1612875614",
    coingeckoId: "raydium",
    realOriginContractAddress: "4k3Dyjzvzp8eMZWUXbBCjEvwSkkk59S5iCNLY3QrkX6R",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "Realy Metaverse",
    symbol: "REAL",
    mint: "AD27ov5fVU2XzwsbvnFvb1JpCBaCB5dRXrczV9CqSVGb",
    contract: "AD27ov5fVU2XzwsbvnFvb1JpCBaCB5dRXrczV9CqSVGb",
    chainId: 0,
    wChainId: 1,
    decimals: 9,
    logoURI: "https://assets.coingecko.com/coins/images/21448/small/2SIFWp0b_400x400.jpg?1639174188",
    coingeckoId: "realy-metaverse",
    realOriginContractAddress: "AD27ov5fVU2XzwsbvnFvb1JpCBaCB5dRXrczV9CqSVGb",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "renDOGE",
    symbol: "RENDOGE",
    mint: "ArUkYE2XDKzqy77PRRGjo4wREWwqk6RXTfM9NeqzPvjU",
    contract: "ArUkYE2XDKzqy77PRRGjo4wREWwqk6RXTfM9NeqzPvjU",
    chainId: 0,
    wChainId: 1,
    decimals: 8,
    logoURI: "https://assets.coingecko.com/coins/images/13796/small/Dogecoin.jpg?1628072827",
    coingeckoId: "rendoge",
    realOriginContractAddress: "ArUkYE2XDKzqy77PRRGjo4wREWwqk6RXTfM9NeqzPvjU",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "Republic Credits",
    symbol: "RPC",
    mint: "EAefyXw6E8sny1cX3LTH6RSvtzH6E5EFy1XsE2AiH1f3",
    contract: "EAefyXw6E8sny1cX3LTH6RSvtzH6E5EFy1XsE2AiH1f3",
    chainId: 0,
    wChainId: 1,
    decimals: 6,
    logoURI: "https://assets.coingecko.com/coins/images/25094/small/logo-rpc_200.png?1650270552",
    coingeckoId: "republic-credits",
    realOriginContractAddress: "EAefyXw6E8sny1cX3LTH6RSvtzH6E5EFy1XsE2AiH1f3",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "Rice",
    symbol: "RICE",
    mint: "5yw793FZPCaPcuUN4F61VJh2ehsFX87zvHbCA4oRebfn",
    contract: "5yw793FZPCaPcuUN4F61VJh2ehsFX87zvHbCA4oRebfn",
    chainId: 0,
    wChainId: 1,
    decimals: 2,
    logoURI: "https://assets.coingecko.com/coins/images/24010/small/rice_200_200.png?1646030160",
    coingeckoId: "rice",
    realOriginContractAddress: "5yw793FZPCaPcuUN4F61VJh2ehsFX87zvHbCA4oRebfn",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "Rollbit Coin",
    symbol: "RLB",
    mint: "RLBxxFkseAZ4RgJH3Sqn8jXxhmGoz9jWxDNJMh8pL7a",
    contract: "RLBxxFkseAZ4RgJH3Sqn8jXxhmGoz9jWxDNJMh8pL7a",
    chainId: 0,
    wChainId: 1,
    decimals: 2,
    logoURI: "https://assets.coingecko.com/coins/images/24552/small/unziL6wO_400x400.jpg?1648134494",
    coingeckoId: "rollbit-coin",
    realOriginContractAddress: "RLBxxFkseAZ4RgJH3Sqn8jXxhmGoz9jWxDNJMh8pL7a",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "Rope Token",
    symbol: "ROPE",
    mint: "8PMHT4swUMtBzgHnh5U564N5sjPSiUz2cjEQzFnnP1Fo",
    contract: "8PMHT4swUMtBzgHnh5U564N5sjPSiUz2cjEQzFnnP1Fo",
    chainId: 0,
    wChainId: 1,
    decimals: 9,
    logoURI: "https://assets.coingecko.com/coins/images/14661/small/rope-v6.png?1619606776",
    coingeckoId: "rope-token",
    realOriginContractAddress: "8PMHT4swUMtBzgHnh5U564N5sjPSiUz2cjEQzFnnP1Fo",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "Run",
    symbol: "RUN",
    mint: "6F9XriABHfWhit6zmMUYAQBSy6XK5VF1cHXuW5LDpRtC",
    contract: "6F9XriABHfWhit6zmMUYAQBSy6XK5VF1cHXuW5LDpRtC",
    chainId: 0,
    wChainId: 1,
    decimals: 9,
    logoURI: "https://assets.coingecko.com/coins/images/21374/small/cZoMwlyl_400x400.jpg?1639032079",
    coingeckoId: "run",
    realOriginContractAddress: "6F9XriABHfWhit6zmMUYAQBSy6XK5VF1cHXuW5LDpRtC",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "Saber",
    symbol: "SBR",
    mint: "Saber2gLauYim4Mvftnrasomsv6NvAuncvMEZwcLpD1",
    contract: "Saber2gLauYim4Mvftnrasomsv6NvAuncvMEZwcLpD1",
    chainId: 0,
    wChainId: 1,
    decimals: 6,
    logoURI: "https://assets.coingecko.com/coins/images/17162/small/oYs_YFz8_400x400.jpg?1626678457",
    coingeckoId: "saber",
    realOriginContractAddress: "Saber2gLauYim4Mvftnrasomsv6NvAuncvMEZwcLpD1",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "SAIL",
    symbol: "SAIL",
    mint: "6kwTqmdQkJd8qRr9RjSnUX9XJ24RmJRSrU1rsragP97Y",
    contract: "6kwTqmdQkJd8qRr9RjSnUX9XJ24RmJRSrU1rsragP97Y",
    chainId: 0,
    wChainId: 1,
    decimals: 6,
    logoURI: "https://assets.coingecko.com/coins/images/16657/small/SAIL.png?1624608515",
    coingeckoId: "sail",
    realOriginContractAddress: "6kwTqmdQkJd8qRr9RjSnUX9XJ24RmJRSrU1rsragP97Y",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "Samoyedcoin",
    symbol: "SAMO",
    mint: "7xKXtg2CW87d97TXJSDpbD5jBkheTqA83TZRuJosgAsU",
    contract: "7xKXtg2CW87d97TXJSDpbD5jBkheTqA83TZRuJosgAsU",
    chainId: 0,
    wChainId: 1,
    decimals: 9,
    logoURI: "https://assets.coingecko.com/coins/images/15051/small/IXeEj5e.png?1619560738",
    coingeckoId: "samoyedcoin",
    realOriginContractAddress: "7xKXtg2CW87d97TXJSDpbD5jBkheTqA83TZRuJosgAsU",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "Samusky",
    symbol: "SAMU",
    mint: "SAMUmmSvrE8yqtcG94oyP1Zu2P9t8PSRSV3vewsGtPM",
    contract: "SAMUmmSvrE8yqtcG94oyP1Zu2P9t8PSRSV3vewsGtPM",
    chainId: 0,
    wChainId: 1,
    decimals: 9,
    logoURI: "https://assets.coingecko.com/coins/images/20187/small/tokenlogo200x200.png?1636635312",
    coingeckoId: "samusky-token",
    realOriginContractAddress: "SAMUmmSvrE8yqtcG94oyP1Zu2P9t8PSRSV3vewsGtPM",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "Santaclaus",
    symbol: "SANTA",
    mint: "EctmRn2jMAdTDvQdG7mxadyiTvhGZiGYNrt9PWe6zioG",
    contract: "EctmRn2jMAdTDvQdG7mxadyiTvhGZiGYNrt9PWe6zioG",
    chainId: 0,
    wChainId: 1,
    decimals: 9,
    logoURI: "https://assets.coingecko.com/coins/images/22211/small/logo_%281%29.png?1641195172",
    coingeckoId: "santaclaus",
    realOriginContractAddress: "EctmRn2jMAdTDvQdG7mxadyiTvhGZiGYNrt9PWe6zioG",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "Sator",
    symbol: "SAO",
    mint: "2HeykdKjzHKGm2LKHw8pDYwjKPiFEoXAz74dirhUgQvq",
    contract: "2HeykdKjzHKGm2LKHw8pDYwjKPiFEoXAz74dirhUgQvq",
    chainId: 0,
    wChainId: 1,
    decimals: 9,
    logoURI: "https://assets.coingecko.com/coins/images/19410/small/sator-logo-CMC.png?1635211626",
    coingeckoId: "sator",
    realOriginContractAddress: "2HeykdKjzHKGm2LKHw8pDYwjKPiFEoXAz74dirhUgQvq",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "Scrap",
    symbol: "SCRAP",
    mint: "6naWDMGNWwqffJnnXFLBCLaYu1y5U9Rohe5wwJPHvf1p",
    contract: "6naWDMGNWwqffJnnXFLBCLaYu1y5U9Rohe5wwJPHvf1p",
    chainId: 0,
    wChainId: 1,
    decimals: 3,
    logoURI: "https://assets.coingecko.com/coins/images/23086/small/bd1b1275fdc0ac1.png?1643181131",
    coingeckoId: "scrap",
    realOriginContractAddress: "6naWDMGNWwqffJnnXFLBCLaYu1y5U9Rohe5wwJPHvf1p",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "Seeded Network",
    symbol: "SEEDED",
    mint: "seedEDBqu63tJ7PFqvcbwvThrYUkQeqT6NLf81kLibs",
    contract: "seedEDBqu63tJ7PFqvcbwvThrYUkQeqT6NLf81kLibs",
    chainId: 0,
    wChainId: 1,
    decimals: 9,
    logoURI: "https://assets.coingecko.com/coins/images/23618/small/seeded.png?1644761600",
    coingeckoId: "seeded-network",
    realOriginContractAddress: "seedEDBqu63tJ7PFqvcbwvThrYUkQeqT6NLf81kLibs",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "Sentre",
    symbol: "SNTR",
    mint: "SENBBKVCM7homnf5RX9zqpf1GFe935hnbU4uVzY1Y6M",
    contract: "SENBBKVCM7homnf5RX9zqpf1GFe935hnbU4uVzY1Y6M",
    chainId: 0,
    wChainId: 1,
    decimals: 9,
    logoURI: "https://assets.coingecko.com/coins/images/19268/small/sentre.PNG?1634866010",
    coingeckoId: "sentre",
    realOriginContractAddress: "SENBBKVCM7homnf5RX9zqpf1GFe935hnbU4uVzY1Y6M",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "Serum (Portal from Ethereum)",
    symbol: "SRM",
    mint: "xnorPhAzWXUczCP3KjU5yDxmKKZi5cSbxytQ1LgE3kG",
    contract: "xnorPhAzWXUczCP3KjU5yDxmKKZi5cSbxytQ1LgE3kG",
    chainId: 0,
    wChainId: 1,
    decimals: 6,
    logoURI: "https://assets.coingecko.com/coins/images/11970/small/serum-logo.png?1597121577",
    coingeckoId: "serum",
    realOriginContractAddress: "0x476c5e26a75bd202a9683ffd34359c0cc15be0ff",
    realOriginChainId: 2,
    supportsPermit: !1
  },
  {
    name: "Serum",
    symbol: "SRM",
    mint: "SRMuApVNdxXokk5GT7XD5cUUgXMBCoAz2LHeuAoKWRt",
    contract: "SRMuApVNdxXokk5GT7XD5cUUgXMBCoAz2LHeuAoKWRt",
    chainId: 0,
    wChainId: 1,
    decimals: 6,
    logoURI: "https://assets.coingecko.com/coins/images/11970/small/serum-logo.png?1597121577",
    coingeckoId: "serum",
    realOriginContractAddress: "SRMuApVNdxXokk5GT7XD5cUUgXMBCoAz2LHeuAoKWRt",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "Shiba Inu (Portal from Ethereum)",
    symbol: "SHIB",
    mint: "CiKu4eHsVrc1eueVQeHn7qhXTcVu95gSQmBpX4utjL9z",
    contract: "CiKu4eHsVrc1eueVQeHn7qhXTcVu95gSQmBpX4utjL9z",
    chainId: 0,
    wChainId: 1,
    decimals: 8,
    logoURI: "https://assets.coingecko.com/coins/images/11939/small/shiba.png?1622619446",
    coingeckoId: "shiba-inu",
    realOriginContractAddress: "0x95ad61b0a150d79219dcf64e1e6cc01f0b64c4ce",
    realOriginChainId: 2,
    supportsPermit: !1
  },
  {
    name: "Shibalana",
    symbol: "SHIBA",
    mint: "Dhg9XnzJWzSQqH2aAnhPTEJHGQAkALDfD98MA499A7pa",
    contract: "Dhg9XnzJWzSQqH2aAnhPTEJHGQAkALDfD98MA499A7pa",
    chainId: 0,
    wChainId: 1,
    decimals: 9,
    logoURI: "https://assets.coingecko.com/coins/images/20003/small/output-onlinepngtools_%2810%29.png?1636364960",
    coingeckoId: "shibalana",
    realOriginContractAddress: "Dhg9XnzJWzSQqH2aAnhPTEJHGQAkALDfD98MA499A7pa",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "Shibana",
    symbol: "BANA",
    mint: "BhPXDQio8xtNC6k5Bg5fnUVL9kGN8uvRDNwW8MZBu8DL",
    contract: "BhPXDQio8xtNC6k5Bg5fnUVL9kGN8uvRDNwW8MZBu8DL",
    chainId: 0,
    wChainId: 1,
    decimals: 4,
    logoURI: "https://assets.coingecko.com/coins/images/21234/small/solshib.png?1638758546",
    coingeckoId: "shibana",
    realOriginContractAddress: "BhPXDQio8xtNC6k5Bg5fnUVL9kGN8uvRDNwW8MZBu8DL",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "SHIBONK",
    symbol: "SBONK",
    mint: "H1G6sZ1WDoMmMCFqBKAbg9gkQPCo1sKQtaJWz9dHmqZr",
    contract: "H1G6sZ1WDoMmMCFqBKAbg9gkQPCo1sKQtaJWz9dHmqZr",
    chainId: 0,
    wChainId: 1,
    decimals: 9,
    logoURI: "https://assets.coingecko.com/coins/images/28675/small/bonklogo2.png?1673161859",
    coingeckoId: "shibonk-311f81df-a4ea-4f31-9e61-df0af8211bd7",
    realOriginContractAddress: "H1G6sZ1WDoMmMCFqBKAbg9gkQPCo1sKQtaJWz9dHmqZr",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "Project SEED SHILL",
    symbol: "SHILL",
    mint: "6cVgJUqo4nmvQpbgrDZwyfd6RwWw5bfnCamS3M9N1fd",
    contract: "6cVgJUqo4nmvQpbgrDZwyfd6RwWw5bfnCamS3M9N1fd",
    chainId: 0,
    wChainId: 1,
    decimals: 6,
    logoURI: "https://assets.coingecko.com/coins/images/18176/small/SHILL_Logo.png?1630896205",
    coingeckoId: "shill-token",
    realOriginContractAddress: "6cVgJUqo4nmvQpbgrDZwyfd6RwWw5bfnCamS3M9N1fd",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "Socean Staked Sol",
    symbol: "SCNSOL",
    mint: "5oVNBeEEQvYi1cX3ir8Dx5n1P7pdxydbGF2X4TxVusJm",
    contract: "5oVNBeEEQvYi1cX3ir8Dx5n1P7pdxydbGF2X4TxVusJm",
    chainId: 0,
    wChainId: 1,
    decimals: 9,
    logoURI: "https://assets.coingecko.com/coins/images/18468/small/biOTzfxE_400x400.png?1633662119",
    coingeckoId: "socean-staked-sol",
    realOriginContractAddress: "5oVNBeEEQvYi1cX3ir8Dx5n1P7pdxydbGF2X4TxVusJm",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "SOL Baby Doge",
    symbol: "SBABYDOGE",
    mint: "BABYsocP6cB95xvBDXnjXKX96VBNC37dmNWUtaV9Jk6v",
    contract: "BABYsocP6cB95xvBDXnjXKX96VBNC37dmNWUtaV9Jk6v",
    chainId: 0,
    wChainId: 1,
    decimals: 2,
    logoURI: "https://assets.coingecko.com/coins/images/21436/small/logo_%282%29.png?1639121887",
    coingeckoId: "sol-baby-doge",
    realOriginContractAddress: "BABYsocP6cB95xvBDXnjXKX96VBNC37dmNWUtaV9Jk6v",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "SOL Flowers",
    symbol: "FLWR",
    mint: "HDVR9Edy2o8uRdf5xFUDSGVLo556UjAaNR9BrwZ8QeMJ",
    contract: "HDVR9Edy2o8uRdf5xFUDSGVLo556UjAaNR9BrwZ8QeMJ",
    chainId: 0,
    wChainId: 1,
    decimals: 9,
    logoURI: "https://assets.coingecko.com/coins/images/23534/small/FLWR-Token-Front-ALPHA.png?1644387944",
    coingeckoId: "sol-flowers",
    realOriginContractAddress: "HDVR9Edy2o8uRdf5xFUDSGVLo556UjAaNR9BrwZ8QeMJ",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "SOLA",
    symbol: "SOLA",
    mint: "FYfQ9uaRaYvRiaEGUmct45F9WKam3BYXArTrotnTNFXF",
    contract: "FYfQ9uaRaYvRiaEGUmct45F9WKam3BYXArTrotnTNFXF",
    chainId: 0,
    wChainId: 1,
    decimals: 9,
    logoURI: "https://assets.coingecko.com/coins/images/18263/small/sola-new.png?1632238376",
    coingeckoId: "sola-token",
    realOriginContractAddress: "FYfQ9uaRaYvRiaEGUmct45F9WKam3BYXArTrotnTNFXF",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "Solabrador",
    symbol: "SOLAB",
    mint: "GLmaRDRmYd4u3YLfnj9eq1mrwxa1YfSweZYYZXZLTRdK",
    contract: "GLmaRDRmYd4u3YLfnj9eq1mrwxa1YfSweZYYZXZLTRdK",
    chainId: 0,
    wChainId: 1,
    decimals: 9,
    logoURI: "https://assets.coingecko.com/coins/images/21014/small/2ZR6Gkz.png?1638190959",
    coingeckoId: "solabrador",
    realOriginContractAddress: "GLmaRDRmYd4u3YLfnj9eq1mrwxa1YfSweZYYZXZLTRdK",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "Solana Ecosystem Index",
    symbol: "SOLI",
    mint: "8JnNWJ46yfdq8sKgT1Lk4G7VWkAA8Rhh7LhqgJ6WY41G",
    contract: "8JnNWJ46yfdq8sKgT1Lk4G7VWkAA8Rhh7LhqgJ6WY41G",
    chainId: 0,
    wChainId: 1,
    decimals: 6,
    logoURI: "https://assets.coingecko.com/coins/images/23550/small/Token-SOLI-200x200.png?1644460319",
    coingeckoId: "solana-ecosystem-index",
    realOriginContractAddress: "8JnNWJ46yfdq8sKgT1Lk4G7VWkAA8Rhh7LhqgJ6WY41G",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "Solana Inu",
    symbol: "INU",
    mint: "5jFnsfx36DyGk8uVGrbXnVUMTsBkPXGpx6e69BiGFzko",
    contract: "5jFnsfx36DyGk8uVGrbXnVUMTsBkPXGpx6e69BiGFzko",
    chainId: 0,
    wChainId: 1,
    decimals: 9,
    logoURI: "https://assets.coingecko.com/coins/images/20020/small/YGid9wMv_400x400.jpg?1636412528",
    coingeckoId: "solana-inu",
    realOriginContractAddress: "5jFnsfx36DyGk8uVGrbXnVUMTsBkPXGpx6e69BiGFzko",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "SolanaPrime",
    symbol: "PRIME",
    mint: "PRiME7gDoiG1vGr95a3CRMv9xHY7UGjd4JKvfSkmQu2",
    contract: "PRiME7gDoiG1vGr95a3CRMv9xHY7UGjd4JKvfSkmQu2",
    chainId: 0,
    wChainId: 1,
    decimals: 9,
    logoURI: "https://assets.coingecko.com/coins/images/25911/small/solana_black200x200.png?1654587637",
    coingeckoId: "solanaprime",
    realOriginContractAddress: "PRiME7gDoiG1vGr95a3CRMv9xHY7UGjd4JKvfSkmQu2",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "Solanax",
    symbol: "SOLD",
    mint: "5v6tZ1SiAi7G8Qg4rBF1ZdAn4cn6aeQtefewMr1NLy61",
    contract: "5v6tZ1SiAi7G8Qg4rBF1ZdAn4cn6aeQtefewMr1NLy61",
    chainId: 0,
    wChainId: 1,
    decimals: 9,
    logoURI: "https://assets.coingecko.com/coins/images/17634/small/sold.png?1639988619",
    coingeckoId: "solanax",
    realOriginContractAddress: "5v6tZ1SiAi7G8Qg4rBF1ZdAn4cn6aeQtefewMr1NLy61",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "Solanium",
    symbol: "SLIM",
    mint: "xxxxa1sKNGwFtw2kFn8XauW9xq8hBZ5kVtcSesTT9fW",
    contract: "xxxxa1sKNGwFtw2kFn8XauW9xq8hBZ5kVtcSesTT9fW",
    chainId: 0,
    wChainId: 1,
    decimals: 6,
    logoURI: "https://assets.coingecko.com/coins/images/15816/small/logo_cg.png?1659000206",
    coingeckoId: "solanium",
    realOriginContractAddress: "xxxxa1sKNGwFtw2kFn8XauW9xq8hBZ5kVtcSesTT9fW",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "Solanyx",
    symbol: "SYX",
    mint: "94jMUy411XNUw1CnkFr2514fq6KRc49W3kAmrjJiuZLx",
    contract: "94jMUy411XNUw1CnkFr2514fq6KRc49W3kAmrjJiuZLx",
    chainId: 0,
    wChainId: 1,
    decimals: 9,
    logoURI: "https://assets.coingecko.com/coins/images/21964/small/logo.png?1640524913",
    coingeckoId: "solanyx",
    realOriginContractAddress: "94jMUy411XNUw1CnkFr2514fq6KRc49W3kAmrjJiuZLx",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "SOLAPE",
    symbol: "SOLAPE",
    mint: "GHvFFSZ9BctWsEc5nujR1MTmmJWY7tgQz2AXE6WVFtGN",
    contract: "GHvFFSZ9BctWsEc5nujR1MTmmJWY7tgQz2AXE6WVFtGN",
    chainId: 0,
    wChainId: 1,
    decimals: 9,
    logoURI: "https://assets.coingecko.com/coins/images/16930/small/128px-coin.png?1625753550",
    coingeckoId: "solape-token",
    realOriginContractAddress: "GHvFFSZ9BctWsEc5nujR1MTmmJWY7tgQz2AXE6WVFtGN",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "Solareum Wallet",
    symbol: "XSB",
    mint: "4UuGQgkD3rSeoXatXRWwRfRd21G87d5LiCfkVzNNv1Tt",
    contract: "4UuGQgkD3rSeoXatXRWwRfRd21G87d5LiCfkVzNNv1Tt",
    chainId: 0,
    wChainId: 1,
    decimals: 9,
    logoURI: "https://assets.coingecko.com/coins/images/20958/small/xsb-200.png?1638141904",
    coingeckoId: "solareum-wallet",
    realOriginContractAddress: "4UuGQgkD3rSeoXatXRWwRfRd21G87d5LiCfkVzNNv1Tt",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "Solbank",
    symbol: "SBNK",
    mint: "uNrix3Q5g51MCEUrYBUEBDdQ96RQDQspQJJnnQ4T3Vc",
    contract: "uNrix3Q5g51MCEUrYBUEBDdQ96RQDQspQJJnnQ4T3Vc",
    chainId: 0,
    wChainId: 1,
    decimals: 6,
    logoURI: "https://assets.coingecko.com/coins/images/18513/small/yo_gS6Hi_400x400.png?1632218794",
    coingeckoId: "solbank-token",
    realOriginContractAddress: "uNrix3Q5g51MCEUrYBUEBDdQ96RQDQspQJJnnQ4T3Vc",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "Solberg",
    symbol: "SLB",
    mint: "2uRFEWRBQLEKpLmF8mohFZGDcFQmrkQEEZmHQvMUBvY7",
    contract: "2uRFEWRBQLEKpLmF8mohFZGDcFQmrkQEEZmHQvMUBvY7",
    chainId: 0,
    wChainId: 1,
    decimals: 9,
    logoURI: "https://assets.coingecko.com/coins/images/18918/small/logo_%2822%29.png?1633922185",
    coingeckoId: "solberg",
    realOriginContractAddress: "2uRFEWRBQLEKpLmF8mohFZGDcFQmrkQEEZmHQvMUBvY7",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "SolChicks Shards",
    symbol: "SHARDS",
    mint: "8j3hXRK5rdoZ2vSpGLRmXtWmW6iYaRUw5xVk4Kzmc9Hp",
    contract: "8j3hXRK5rdoZ2vSpGLRmXtWmW6iYaRUw5xVk4Kzmc9Hp",
    chainId: 0,
    wChainId: 1,
    decimals: 9,
    logoURI: "https://assets.coingecko.com/coins/images/23728/small/logo_%282%29.png?1645163819",
    coingeckoId: "solchicks-shards",
    realOriginContractAddress: "8j3hXRK5rdoZ2vSpGLRmXtWmW6iYaRUw5xVk4Kzmc9Hp",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "SolChicks",
    symbol: "CHICKS",
    mint: "cxxShYRVcepDudXhe7U62QHvw8uBJoKFifmzggGKVC2",
    contract: "cxxShYRVcepDudXhe7U62QHvw8uBJoKFifmzggGKVC2",
    chainId: 0,
    wChainId: 1,
    decimals: 9,
    logoURI: "https://assets.coingecko.com/coins/images/20978/small/chicks.png?1638162821",
    coingeckoId: "solchicks-token",
    realOriginContractAddress: "cxxShYRVcepDudXhe7U62QHvw8uBJoKFifmzggGKVC2",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "Solcial",
    symbol: "SLCL",
    mint: "SLCLww7nc1PD2gQPQdGayHviVVcpMthnqUz2iWKhNQV",
    contract: "SLCLww7nc1PD2gQPQdGayHviVVcpMthnqUz2iWKhNQV",
    chainId: 0,
    wChainId: 1,
    decimals: 9,
    logoURI: "https://assets.coingecko.com/coins/images/24583/small/1_N9szP0_400x400.jpg?1648217020",
    coingeckoId: "solcial",
    realOriginContractAddress: "SLCLww7nc1PD2gQPQdGayHviVVcpMthnqUz2iWKhNQV",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "SolClout",
    symbol: "SCT",
    mint: "4Te4KJgjtnZe4aE2zne8G4NPfrPjCwDmaiEx9rKnyDVZ",
    contract: "4Te4KJgjtnZe4aE2zne8G4NPfrPjCwDmaiEx9rKnyDVZ",
    chainId: 0,
    wChainId: 1,
    decimals: 9,
    logoURI: "https://assets.coingecko.com/coins/images/21638/small/solclout.jpg?1639630028",
    coingeckoId: "solclout",
    realOriginContractAddress: "4Te4KJgjtnZe4aE2zne8G4NPfrPjCwDmaiEx9rKnyDVZ",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "SolCondoms",
    symbol: "CONDOMS",
    mint: "EzL6LLmv4vgfF7irkjG7ZxM92bTJ9f6nFopDXJTow7zj",
    contract: "EzL6LLmv4vgfF7irkjG7ZxM92bTJ9f6nFopDXJTow7zj",
    chainId: 0,
    wChainId: 1,
    decimals: 9,
    logoURI: "https://assets.coingecko.com/coins/images/21814/small/DboqD2_o_400x400.jpg?1640071580",
    coingeckoId: "solcondoms",
    realOriginContractAddress: "EzL6LLmv4vgfF7irkjG7ZxM92bTJ9f6nFopDXJTow7zj",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "Solcubator",
    symbol: "SOLC",
    mint: "Bx1fDtvTN6NvE4kjdPHQXtmGSg582bZx9fGy4DQNMmAT",
    contract: "Bx1fDtvTN6NvE4kjdPHQXtmGSg582bZx9fGy4DQNMmAT",
    chainId: 0,
    wChainId: 1,
    decimals: 9,
    logoURI: "https://assets.coingecko.com/coins/images/18682/small/Solcubator-Logo-Icon.png?1632966591",
    coingeckoId: "solcubator",
    realOriginContractAddress: "Bx1fDtvTN6NvE4kjdPHQXtmGSg582bZx9fGy4DQNMmAT",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "SolDate",
    symbol: "DATE",
    mint: "Ce3PSQfkxT5ua4r2JqCoWYrMwKWC5hEzwsrT9Hb7mAz9",
    contract: "Ce3PSQfkxT5ua4r2JqCoWYrMwKWC5hEzwsrT9Hb7mAz9",
    chainId: 0,
    wChainId: 1,
    decimals: 9,
    logoURI: "https://assets.coingecko.com/coins/images/18461/small/date.PNG?1632108952",
    coingeckoId: "soldate-token",
    realOriginContractAddress: "Ce3PSQfkxT5ua4r2JqCoWYrMwKWC5hEzwsrT9Hb7mAz9",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "SolDoge",
    symbol: "SDOGE",
    mint: "8ymi88q5DtmdNTn2sPRNFkvMkszMHuLJ1e3RVdWjPa3s",
    contract: "8ymi88q5DtmdNTn2sPRNFkvMkszMHuLJ1e3RVdWjPa3s",
    chainId: 0,
    wChainId: 1,
    decimals: 0,
    logoURI: "https://assets.coingecko.com/coins/images/19746/small/2L4aX1r.png?1635822424",
    coingeckoId: "soldoge",
    realOriginContractAddress: "8ymi88q5DtmdNTn2sPRNFkvMkszMHuLJ1e3RVdWjPa3s",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "Solend",
    symbol: "SLND",
    mint: "SLNDpmoWTVADgEdndyvWzroNL7zSi1dF9PC3xHGtPwp",
    contract: "SLNDpmoWTVADgEdndyvWzroNL7zSi1dF9PC3xHGtPwp",
    chainId: 0,
    wChainId: 1,
    decimals: 6,
    logoURI: "https://assets.coingecko.com/coins/images/19573/small/i6AMOwun_400x400.jpg?1635458597",
    coingeckoId: "solend",
    realOriginContractAddress: "SLNDpmoWTVADgEdndyvWzroNL7zSi1dF9PC3xHGtPwp",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "Solex Finance",
    symbol: "SLX",
    mint: "AASdD9rAefJ4PP7iM89MYUsQEyCQwvBofhceZUGDh5HZ",
    contract: "AASdD9rAefJ4PP7iM89MYUsQEyCQwvBofhceZUGDh5HZ",
    chainId: 0,
    wChainId: 1,
    decimals: 9,
    logoURI: "https://assets.coingecko.com/coins/images/19392/small/logo_-_2021-10-25T161153.717.png?1635149522",
    coingeckoId: "solex-finance",
    realOriginContractAddress: "AASdD9rAefJ4PP7iM89MYUsQEyCQwvBofhceZUGDh5HZ",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "Tulip Protocol",
    symbol: "TULIP",
    mint: "TuLipcqtGVXP9XR62wM8WWCm6a9vhLs7T1uoWBk6FDs",
    contract: "TuLipcqtGVXP9XR62wM8WWCm6a9vhLs7T1uoWBk6FDs",
    chainId: 0,
    wChainId: 1,
    decimals: 6,
    logoURI: "https://assets.coingecko.com/coins/images/15764/small/TqrUdBG.png?1621827144",
    coingeckoId: "solfarm",
    realOriginContractAddress: "TuLipcqtGVXP9XR62wM8WWCm6a9vhLs7T1uoWBk6FDs",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "Solfina",
    symbol: "SOLFI",
    mint: "3CaBxqxWsP5oqS84Pkja4wLxyZYsHzMivQbnfwFJQeL1",
    contract: "3CaBxqxWsP5oqS84Pkja4wLxyZYsHzMivQbnfwFJQeL1",
    chainId: 0,
    wChainId: 1,
    decimals: 9,
    logoURI: "https://assets.coingecko.com/coins/images/20729/small/dDDqpMiA_400x400.jpg?1637616143",
    coingeckoId: "solfina",
    realOriginContractAddress: "3CaBxqxWsP5oqS84Pkja4wLxyZYsHzMivQbnfwFJQeL1",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "Solge",
    symbol: "SOLGE",
    mint: "FM8ai6JTyf6HWAgPbnsdonqCeWfjomPMFfnBgPSf23W2",
    contract: "FM8ai6JTyf6HWAgPbnsdonqCeWfjomPMFfnBgPSf23W2",
    chainId: 0,
    wChainId: 1,
    decimals: 5,
    logoURI: "https://assets.coingecko.com/coins/images/28678/small/solge_%281%29.png?1673231982",
    coingeckoId: "solge",
    realOriginContractAddress: "FM8ai6JTyf6HWAgPbnsdonqCeWfjomPMFfnBgPSf23W2",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "Solice",
    symbol: "SLC",
    mint: "METAmTMXwdb8gYzyCPfXXFmZZw4rUsXX58PNsDg7zjL",
    contract: "METAmTMXwdb8gYzyCPfXXFmZZw4rUsXX58PNsDg7zjL",
    chainId: 0,
    wChainId: 1,
    decimals: 6,
    logoURI: "https://assets.coingecko.com/coins/images/22115/small/solice_logo_200x200.png?1640845206",
    coingeckoId: "solice",
    realOriginContractAddress: "METAmTMXwdb8gYzyCPfXXFmZZw4rUsXX58PNsDg7zjL",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "Solily Protocol",
    symbol: "LILY",
    mint: "LiLyT885cG9xZKYQk9x6VWMzmcui4ueV9J1uzPDDajY",
    contract: "LiLyT885cG9xZKYQk9x6VWMzmcui4ueV9J1uzPDDajY",
    chainId: 0,
    wChainId: 1,
    decimals: 6,
    logoURI: "https://assets.coingecko.com/coins/images/25611/small/logo200.png?1652846780",
    coingeckoId: "solily-protocol",
    realOriginContractAddress: "LiLyT885cG9xZKYQk9x6VWMzmcui4ueV9J1uzPDDajY",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "Solminter",
    symbol: "SMRT",
    mint: "95KN8q3qubEVjPf9trgyur2nHx8T5RCmztRbLuQ5E5i",
    contract: "95KN8q3qubEVjPf9trgyur2nHx8T5RCmztRbLuQ5E5i",
    chainId: 0,
    wChainId: 1,
    decimals: 0,
    logoURI: "https://assets.coingecko.com/coins/images/17937/small/apple-touch-icon.png?1629868107",
    coingeckoId: "solminter",
    realOriginContractAddress: "95KN8q3qubEVjPf9trgyur2nHx8T5RCmztRbLuQ5E5i",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "Solpad Finance",
    symbol: "SOLPAD",
    mint: "GfJ3Vq2eSTYf1hJP6kKLE9RT6u7jF9gNszJhZwo5VPZp",
    contract: "GfJ3Vq2eSTYf1hJP6kKLE9RT6u7jF9gNszJhZwo5VPZp",
    chainId: 0,
    wChainId: 1,
    decimals: 9,
    logoURI: "https://assets.coingecko.com/coins/images/16368/small/solpad.PNG?1623820231",
    coingeckoId: "solpad-finance",
    realOriginContractAddress: "GfJ3Vq2eSTYf1hJP6kKLE9RT6u7jF9gNszJhZwo5VPZp",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "SolPatrol Bail",
    symbol: "BAIL",
    mint: "3e9pHUxa2nvAqso2Kr2KqJxYvZaz9qZLjoLaG77uQwB1",
    contract: "3e9pHUxa2nvAqso2Kr2KqJxYvZaz9qZLjoLaG77uQwB1",
    chainId: 0,
    wChainId: 1,
    decimals: 9,
    logoURI: "https://assets.coingecko.com/coins/images/25787/small/hammer.png?1653882632",
    coingeckoId: "solpatrol-bail",
    realOriginContractAddress: "3e9pHUxa2nvAqso2Kr2KqJxYvZaz9qZLjoLaG77uQwB1",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "SolPay Finance",
    symbol: "SOLPAY",
    mint: "zwqe1Nd4eiWyCcqdo4FgCq7LYZHdSeGKKudv6RwiAEn",
    contract: "zwqe1Nd4eiWyCcqdo4FgCq7LYZHdSeGKKudv6RwiAEn",
    chainId: 0,
    wChainId: 1,
    decimals: 9,
    logoURI: "https://assets.coingecko.com/coins/images/22766/small/1_wTkhKXbxhBQxR1BW5WKSNA.png?1642575140",
    coingeckoId: "solpay-finance",
    realOriginContractAddress: "zwqe1Nd4eiWyCcqdo4FgCq7LYZHdSeGKKudv6RwiAEn",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "SolRazr",
    symbol: "SOLR",
    mint: "7j7H7sgsnNDeCngAPjpaCN4aaaru4HS7NAFYSEUyzJ3k",
    contract: "7j7H7sgsnNDeCngAPjpaCN4aaaru4HS7NAFYSEUyzJ3k",
    chainId: 0,
    wChainId: 1,
    decimals: 6,
    logoURI: "https://assets.coingecko.com/coins/images/18390/small/Sol-Razr-Logo-TICKER.png?1631759669",
    coingeckoId: "solrazr",
    realOriginContractAddress: "7j7H7sgsnNDeCngAPjpaCN4aaaru4HS7NAFYSEUyzJ3k",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "Solrise Finance",
    symbol: "SLRS",
    mint: "SLRSSpSLUTP7okbCUBYStWCo1vUgyt775faPqz8HUMr",
    contract: "SLRSSpSLUTP7okbCUBYStWCo1vUgyt775faPqz8HUMr",
    chainId: 0,
    wChainId: 1,
    decimals: 6,
    logoURI: "https://assets.coingecko.com/coins/images/15762/small/9989.png?1621825696",
    coingeckoId: "solrise-finance",
    realOriginContractAddress: "SLRSSpSLUTP7okbCUBYStWCo1vUgyt775faPqz8HUMr",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "Solster",
    symbol: "STR",
    mint: "9zoqdwEBKWEi9G5Ze8BSkdmppxGgVv1Kw4LuigDiNr9m",
    contract: "9zoqdwEBKWEi9G5Ze8BSkdmppxGgVv1Kw4LuigDiNr9m",
    chainId: 0,
    wChainId: 1,
    decimals: 9,
    logoURI: "https://assets.coingecko.com/coins/images/18621/small/log-350.png?1632701442",
    coingeckoId: "solster",
    realOriginContractAddress: "9zoqdwEBKWEi9G5Ze8BSkdmppxGgVv1Kw4LuigDiNr9m",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "Soltato FRIES",
    symbol: "FRIES",
    mint: "FriCEbw1V99GwrJRXPnSQ6su2TabHabNxiZ3VNsVFPPN",
    contract: "FriCEbw1V99GwrJRXPnSQ6su2TabHabNxiZ3VNsVFPPN",
    chainId: 0,
    wChainId: 1,
    decimals: 9,
    logoURI: "https://assets.coingecko.com/coins/images/19533/small/soltato.png?1635745612",
    coingeckoId: "soltato-fries",
    realOriginContractAddress: "FriCEbw1V99GwrJRXPnSQ6su2TabHabNxiZ3VNsVFPPN",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "Solvent",
    symbol: "SVT",
    mint: "svtMpL5eQzdmB3uqK9NXaQkq8prGZoKQFNVJghdWCkV",
    contract: "svtMpL5eQzdmB3uqK9NXaQkq8prGZoKQFNVJghdWCkV",
    chainId: 0,
    wChainId: 1,
    decimals: 6,
    logoURI: "https://assets.coingecko.com/coins/images/22387/small/svt.png?1641789503",
    coingeckoId: "solvent",
    realOriginContractAddress: "svtMpL5eQzdmB3uqK9NXaQkq8prGZoKQFNVJghdWCkV",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "Solyard Finance",
    symbol: "YARD",
    mint: "8RYSc3rrS4X4bvBCtSJnhcpPpMaAJkXnVKZPzANxQHgz",
    contract: "8RYSc3rrS4X4bvBCtSJnhcpPpMaAJkXnVKZPzANxQHgz",
    chainId: 0,
    wChainId: 1,
    decimals: 9,
    logoURI: "https://assets.coingecko.com/coins/images/18400/small/IMG_7306.JPG?1631775657",
    coingeckoId: "solyard-finance",
    realOriginContractAddress: "8RYSc3rrS4X4bvBCtSJnhcpPpMaAJkXnVKZPzANxQHgz",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "SonarWatch",
    symbol: "SONAR",
    mint: "sonarX4VtVkQemriJeLm6CKeW3GDMyiBnnAEMw1MRAE",
    contract: "sonarX4VtVkQemriJeLm6CKeW3GDMyiBnnAEMw1MRAE",
    chainId: 0,
    wChainId: 1,
    decimals: 9,
    logoURI: "https://assets.coingecko.com/coins/images/20494/small/S_7gaWIC_400x400.png?1637131427",
    coingeckoId: "sonarwatch",
    realOriginContractAddress: "sonarX4VtVkQemriJeLm6CKeW3GDMyiBnnAEMw1MRAE",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "Soul Dogs City Bones",
    symbol: "BONES",
    mint: "bonegFPgrpZ4bfVn3kQK1aMbGYddWtfMAywNt5LsuVE",
    contract: "bonegFPgrpZ4bfVn3kQK1aMbGYddWtfMAywNt5LsuVE",
    chainId: 0,
    wChainId: 1,
    decimals: 2,
    logoURI: "https://assets.coingecko.com/coins/images/25025/small/JEepabYB_400x400.png?1649838257",
    coingeckoId: "soul-dog-city-bones",
    realOriginContractAddress: "bonegFPgrpZ4bfVn3kQK1aMbGYddWtfMAywNt5LsuVE",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "SouloCoin",
    symbol: "SOULO",
    mint: "Gz3u6eJaKEviYpPC5AwUziz891kNX76PNdsmJrnaNNY4",
    contract: "Gz3u6eJaKEviYpPC5AwUziz891kNX76PNdsmJrnaNNY4",
    chainId: 0,
    wChainId: 1,
    decimals: 9,
    logoURI: "https://assets.coingecko.com/coins/images/22082/small/logo.png?1640759758",
    coingeckoId: "soulocoin",
    realOriginContractAddress: "Gz3u6eJaKEviYpPC5AwUziz891kNX76PNdsmJrnaNNY4",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "Star Atlas",
    symbol: "ATLAS",
    mint: "ATLASXmbPQxBUYbxPsV97usA3fPQYEqzQBUHgiFCUsXx",
    contract: "ATLASXmbPQxBUYbxPsV97usA3fPQYEqzQBUHgiFCUsXx",
    chainId: 0,
    wChainId: 1,
    decimals: 8,
    logoURI: "https://assets.coingecko.com/coins/images/17659/small/Icon_Reverse.png?1628759092",
    coingeckoId: "star-atlas",
    realOriginContractAddress: "ATLASXmbPQxBUYbxPsV97usA3fPQYEqzQBUHgiFCUsXx",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "Star Atlas DAO",
    symbol: "POLIS",
    mint: "poLisWXnNRwC6oBu1vHiuKQzFjGL4XDSu4g9qjz9qVk",
    contract: "poLisWXnNRwC6oBu1vHiuKQzFjGL4XDSu4g9qjz9qVk",
    chainId: 0,
    wChainId: 1,
    decimals: 8,
    logoURI: "https://assets.coingecko.com/coins/images/17789/small/POLIS.jpg?1629256006",
    coingeckoId: "star-atlas-dao",
    realOriginContractAddress: "poLisWXnNRwC6oBu1vHiuKQzFjGL4XDSu4g9qjz9qVk",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "Starbots",
    symbol: "BOT",
    mint: "AkhdZGVbJXPuQZ53u2LrimCjkRP6ZyxG1SoM85T98eE1",
    contract: "AkhdZGVbJXPuQZ53u2LrimCjkRP6ZyxG1SoM85T98eE1",
    chainId: 0,
    wChainId: 1,
    decimals: 8,
    logoURI: "https://assets.coingecko.com/coins/images/21823/small/coin_%286%29.png?1640076014",
    coingeckoId: "starbots",
    realOriginContractAddress: "AkhdZGVbJXPuQZ53u2LrimCjkRP6ZyxG1SoM85T98eE1",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "Starbots GEAR",
    symbol: "GEAR",
    mint: "23WuycvPjEuzJTsBPBZqnbFZFcBtBKAMTowUDHwagkuD",
    contract: "23WuycvPjEuzJTsBPBZqnbFZFcBtBKAMTowUDHwagkuD",
    chainId: 0,
    wChainId: 1,
    decimals: 0,
    logoURI: "https://assets.coingecko.com/coins/images/26651/small/logo_%282%29.png?1659408350",
    coingeckoId: "starbots-gear",
    realOriginContractAddress: "23WuycvPjEuzJTsBPBZqnbFZFcBtBKAMTowUDHwagkuD",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "StarLaunch",
    symbol: "STARS",
    mint: "HCgybxq5Upy8Mccihrp7EsmwwFqYZtrHrsmsKwtGXLgW",
    contract: "HCgybxq5Upy8Mccihrp7EsmwwFqYZtrHrsmsKwtGXLgW",
    chainId: 0,
    wChainId: 1,
    decimals: 6,
    logoURI: "https://assets.coingecko.com/coins/images/20109/small/OP3eksDQ_400x400.png?1636513478",
    coingeckoId: "starlaunch",
    realOriginContractAddress: "HCgybxq5Upy8Mccihrp7EsmwwFqYZtrHrsmsKwtGXLgW",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "Step Finance",
    symbol: "STEP",
    mint: "StepAscQoEioFxxWGnh2sLBDFp9d8rvKz2Yp39iDpyT",
    contract: "StepAscQoEioFxxWGnh2sLBDFp9d8rvKz2Yp39iDpyT",
    chainId: 0,
    wChainId: 1,
    decimals: 9,
    logoURI: "https://assets.coingecko.com/coins/images/14988/small/step.png?1619274762",
    coingeckoId: "step-finance",
    realOriginContractAddress: "StepAscQoEioFxxWGnh2sLBDFp9d8rvKz2Yp39iDpyT",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "STEPN",
    symbol: "GMT",
    mint: "7i5KKsX2weiTkry7jA4ZwSuXGhs5eJBEjY8vVxR4pfRx",
    contract: "7i5KKsX2weiTkry7jA4ZwSuXGhs5eJBEjY8vVxR4pfRx",
    chainId: 0,
    wChainId: 1,
    decimals: 9,
    logoURI: "https://assets.coingecko.com/coins/images/23597/small/gmt.png?1644658792",
    coingeckoId: "stepn",
    realOriginContractAddress: "7i5KKsX2weiTkry7jA4ZwSuXGhs5eJBEjY8vVxR4pfRx",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "Stoned Ape Crew Index",
    symbol: "SAC",
    mint: "GZL4yjPohDShW4RofJ6dEWu2Fv7qEa5mBT7Dpje5hqe7",
    contract: "GZL4yjPohDShW4RofJ6dEWu2Fv7qEa5mBT7Dpje5hqe7",
    chainId: 0,
    wChainId: 1,
    decimals: 2,
    logoURI: "https://assets.coingecko.com/coins/images/24385/small/stone_ape.PNG?1647501586",
    coingeckoId: "stoned-ape-crew-index",
    realOriginContractAddress: "GZL4yjPohDShW4RofJ6dEWu2Fv7qEa5mBT7Dpje5hqe7",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "Style",
    symbol: "STYLE",
    mint: "3FHpkMTQ3QyAJoLoXVdBpH4TfHiehnL2kXmv9UXBpYuF",
    contract: "3FHpkMTQ3QyAJoLoXVdBpH4TfHiehnL2kXmv9UXBpYuF",
    chainId: 0,
    wChainId: 1,
    decimals: 9,
    logoURI: "https://assets.coingecko.com/coins/images/28060/small/78oZvtZW_400x400.jpeg?1667442304",
    coingeckoId: "style",
    realOriginContractAddress: "3FHpkMTQ3QyAJoLoXVdBpH4TfHiehnL2kXmv9UXBpYuF",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "Such Shiba",
    symbol: "SUCH",
    mint: "HnZiKrSKYQkEfzjQs6qkvuGbBmrBP9YzjB1SMM7tiGZ1",
    contract: "HnZiKrSKYQkEfzjQs6qkvuGbBmrBP9YzjB1SMM7tiGZ1",
    chainId: 0,
    wChainId: 1,
    decimals: 9,
    logoURI: "https://assets.coingecko.com/coins/images/25100/small/1CA10540-30AB-4F34-AF3A-9E8F88471FDF.png?1650284205",
    coingeckoId: "such-shiba",
    realOriginContractAddress: "HnZiKrSKYQkEfzjQs6qkvuGbBmrBP9YzjB1SMM7tiGZ1",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "Sunny Aggregator",
    symbol: "SUNNY",
    mint: "SUNNYWgPQmFxe9wTZzNK7iPnJ3vYDrkgnxJRJm1s3ag",
    contract: "SUNNYWgPQmFxe9wTZzNK7iPnJ3vYDrkgnxJRJm1s3ag",
    chainId: 0,
    wChainId: 1,
    decimals: 6,
    logoURI: "https://assets.coingecko.com/coins/images/18039/small/90dbe787-8e5f-473c-b923-fe138a7a30ea.png?1630314924",
    coingeckoId: "sunny-aggregator",
    realOriginContractAddress: "SUNNYWgPQmFxe9wTZzNK7iPnJ3vYDrkgnxJRJm1s3ag",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "SunnySideUp",
    symbol: "SSU",
    mint: "AGkFkKgXUEP7ZXazza5a25bSKbz5dDpgafPhqywuQnpf",
    contract: "AGkFkKgXUEP7ZXazza5a25bSKbz5dDpgafPhqywuQnpf",
    chainId: 0,
    wChainId: 1,
    decimals: 9,
    logoURI: "https://assets.coingecko.com/coins/images/23369/small/logo.png?1643954242",
    coingeckoId: "sunnysideup",
    realOriginContractAddress: "AGkFkKgXUEP7ZXazza5a25bSKbz5dDpgafPhqywuQnpf",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "SuperBonds",
    symbol: "SB",
    mint: "SuperbZyz7TsSdSoFAZ6RYHfAWe9NmjXBLVQpS8hqdx",
    contract: "SuperbZyz7TsSdSoFAZ6RYHfAWe9NmjXBLVQpS8hqdx",
    chainId: 0,
    wChainId: 1,
    decimals: 6,
    logoURI: "https://assets.coingecko.com/coins/images/22743/small/ywws9ojM_400x400.jpg?1642548336",
    coingeckoId: "superbonds",
    realOriginContractAddress: "SuperbZyz7TsSdSoFAZ6RYHfAWe9NmjXBLVQpS8hqdx",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "Sushi (Portal from Ethereum)",
    symbol: "SUSHI",
    mint: "ChVzxWRmrTeSgwd3Ui3UumcN8KX7VK3WaD4KGeSKpypj",
    contract: "ChVzxWRmrTeSgwd3Ui3UumcN8KX7VK3WaD4KGeSKpypj",
    chainId: 0,
    wChainId: 1,
    decimals: 8,
    logoURI: "https://assets.coingecko.com/coins/images/12271/small/512x512_Logo_no_chop.png?1606986688",
    coingeckoId: "sushi",
    realOriginContractAddress: "0x6b3595068778dd592e39a122f4f5a5cf09c90fe2",
    realOriginChainId: 2,
    supportsPermit: !1
  },
  {
    name: "Swole Doge",
    symbol: "SWOLE",
    mint: "4BzxVoBQzwKoqm1dQc78r42Yby3EzAeZmMiYFdCjeu5Z",
    contract: "4BzxVoBQzwKoqm1dQc78r42Yby3EzAeZmMiYFdCjeu5Z",
    chainId: 0,
    wChainId: 1,
    decimals: 9,
    logoURI: "https://assets.coingecko.com/coins/images/19643/small/swole.png?1635853067",
    coingeckoId: "swole-doge",
    realOriginContractAddress: "4BzxVoBQzwKoqm1dQc78r42Yby3EzAeZmMiYFdCjeu5Z",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "Synchrony",
    symbol: "SCY",
    mint: "SCYfrGCw8aDiqdgcpdGjV6jp4UVVQLuphxTDLNWu36f",
    contract: "SCYfrGCw8aDiqdgcpdGjV6jp4UVVQLuphxTDLNWu36f",
    chainId: 0,
    wChainId: 1,
    decimals: 9,
    logoURI: "https://assets.coingecko.com/coins/images/19308/small/SYNCHRONY-LOGO.png?1634973091",
    coingeckoId: "synchrony",
    realOriginContractAddress: "SCYfrGCw8aDiqdgcpdGjV6jp4UVVQLuphxTDLNWu36f",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "Synesis One",
    symbol: "SNS",
    mint: "SNSNkV9zfG5ZKWQs6x4hxvBRV6s8SqMfSGCtECDvdMd",
    contract: "SNSNkV9zfG5ZKWQs6x4hxvBRV6s8SqMfSGCtECDvdMd",
    chainId: 0,
    wChainId: 1,
    decimals: 9,
    logoURI: "https://assets.coingecko.com/coins/images/23289/small/sns.png?1643549030",
    coingeckoId: "synesis-one",
    realOriginContractAddress: "SNSNkV9zfG5ZKWQs6x4hxvBRV6s8SqMfSGCtECDvdMd",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "Synex Coin",
    symbol: "MINECRAFT",
    mint: "FTkj421DxbS1wajE74J34BJ5a1o9ccA97PkK6mYq9hNQ",
    contract: "FTkj421DxbS1wajE74J34BJ5a1o9ccA97PkK6mYq9hNQ",
    chainId: 0,
    wChainId: 1,
    decimals: 9,
    logoURI: "https://assets.coingecko.com/coins/images/21247/small/logo_-_2021-12-06T135451.604.png?1638770098",
    coingeckoId: "synex-coin",
    realOriginContractAddress: "FTkj421DxbS1wajE74J34BJ5a1o9ccA97PkK6mYq9hNQ",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "Synthetic FTT",
    symbol: "XFTT",
    mint: "Fr3W7NPVvdVbwMcHgA7Gx2wUxP43txdsn3iULJGFbKz9",
    contract: "Fr3W7NPVvdVbwMcHgA7Gx2wUxP43txdsn3iULJGFbKz9",
    chainId: 0,
    wChainId: 1,
    decimals: 8,
    logoURI: "https://assets.coingecko.com/coins/images/20025/small/BGYHyQ4.png?1636418021",
    coingeckoId: "synthetic-ftt",
    realOriginContractAddress: "Fr3W7NPVvdVbwMcHgA7Gx2wUxP43txdsn3iULJGFbKz9",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "Synthetic SOL",
    symbol: "XSOL",
    mint: "BdUJucPJyjkHxLMv6ipKNUhSeY3DWrVtgxAES1iSBAov",
    contract: "BdUJucPJyjkHxLMv6ipKNUhSeY3DWrVtgxAES1iSBAov",
    chainId: 0,
    wChainId: 1,
    decimals: 9,
    logoURI: "https://assets.coingecko.com/coins/images/20022/small/mmJpy6j.png?1636417738",
    coingeckoId: "synthetic-sol",
    realOriginContractAddress: "BdUJucPJyjkHxLMv6ipKNUhSeY3DWrVtgxAES1iSBAov",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "Synthetic USD",
    symbol: "XUSD",
    mint: "83LGLCm7QKpYZbX8q4W2kYWbtt8NJBwbVwEepzkVnJ9y",
    contract: "83LGLCm7QKpYZbX8q4W2kYWbtt8NJBwbVwEepzkVnJ9y",
    chainId: 0,
    wChainId: 1,
    decimals: 6,
    logoURI: "https://assets.coingecko.com/coins/images/19596/small/uJzDI4j.png?1635488810",
    coingeckoId: "synthetic-usd",
    realOriginContractAddress: "83LGLCm7QKpYZbX8q4W2kYWbtt8NJBwbVwEepzkVnJ9y",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "Synthetify",
    symbol: "SNY",
    mint: "4dmKkXNHdgYsXqBHCuMikNQWwVomZURhYvkkX5c4pQ7y",
    contract: "4dmKkXNHdgYsXqBHCuMikNQWwVomZURhYvkkX5c4pQ7y",
    chainId: 0,
    wChainId: 1,
    decimals: 6,
    logoURI: "https://assets.coingecko.com/coins/images/14835/small/synthetify_token.png?1618611507",
    coingeckoId: "synthetify-token",
    realOriginContractAddress: "4dmKkXNHdgYsXqBHCuMikNQWwVomZURhYvkkX5c4pQ7y",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "Sypool",
    symbol: "SYP",
    mint: "FnKE9n6aGjQoNWRBZXy4RW6LZVao7qwBonUbiD7edUmZ",
    contract: "FnKE9n6aGjQoNWRBZXy4RW6LZVao7qwBonUbiD7edUmZ",
    chainId: 0,
    wChainId: 1,
    decimals: 9,
    logoURI: "https://assets.coingecko.com/coins/images/18518/small/sypool.PNG?1632268218",
    coingeckoId: "sypool",
    realOriginContractAddress: "FnKE9n6aGjQoNWRBZXy4RW6LZVao7qwBonUbiD7edUmZ",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "TabTrader",
    symbol: "TTT",
    mint: "FNFKRV3V8DtA3gVJN6UshMiLGYA8izxFwkNWmJbFjmRj",
    contract: "FNFKRV3V8DtA3gVJN6UshMiLGYA8izxFwkNWmJbFjmRj",
    chainId: 0,
    wChainId: 1,
    decimals: 6,
    logoURI: "https://assets.coingecko.com/coins/images/21060/small/xFYsZV9U_400x400.jpg?1638268495",
    coingeckoId: "tabtrader",
    realOriginContractAddress: "FNFKRV3V8DtA3gVJN6UshMiLGYA8izxFwkNWmJbFjmRj",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "Taki",
    symbol: "TAKI",
    mint: "Taki7fi3Zicv7Du1xNAWLaf6mRK7ikdn77HeGzgwvo4",
    contract: "Taki7fi3Zicv7Du1xNAWLaf6mRK7ikdn77HeGzgwvo4",
    chainId: 0,
    wChainId: 1,
    decimals: 9,
    logoURI: "https://assets.coingecko.com/coins/images/25271/small/logo.png?1651118069",
    coingeckoId: "taki",
    realOriginContractAddress: "Taki7fi3Zicv7Du1xNAWLaf6mRK7ikdn77HeGzgwvo4",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "Tap Fantasy MC",
    symbol: "TFMC",
    mint: "FYUkUybywqUUyrUwiAezbvhTp2DUgx1eg8tQNiKkXqJ9",
    contract: "FYUkUybywqUUyrUwiAezbvhTp2DUgx1eg8tQNiKkXqJ9",
    chainId: 0,
    wChainId: 1,
    decimals: 9,
    logoURI: "https://assets.coingecko.com/coins/images/26483/small/Tap-Fantasy-MC-Logo.png?1658279327",
    coingeckoId: "tap-fantasy-mc",
    realOriginContractAddress: "FYUkUybywqUUyrUwiAezbvhTp2DUgx1eg8tQNiKkXqJ9",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "Tether (Portal from Polygon)",
    symbol: "USDT",
    mint: "5goWRao6a3yNC4d6UjMdQxonkCMvKBwdpubU3qhfcdf1",
    contract: "5goWRao6a3yNC4d6UjMdQxonkCMvKBwdpubU3qhfcdf1",
    chainId: 0,
    wChainId: 1,
    decimals: 6,
    logoURI: "https://assets.coingecko.com/coins/images/325/small/Tether.png?1668148663",
    coingeckoId: "tether",
    realOriginContractAddress: "0xc2132d05d31c914a87c6611c10748aeb04b58e8f",
    realOriginChainId: 5,
    supportsPermit: !1
  },
  {
    name: "Tether (Portal from BSC)",
    symbol: "USDT",
    mint: "8qJSyQprMC57TWKaYEmetUR3UUiTP2M3hXdcvFhkZdmv",
    contract: "8qJSyQprMC57TWKaYEmetUR3UUiTP2M3hXdcvFhkZdmv",
    chainId: 0,
    wChainId: 1,
    decimals: 8,
    logoURI: "https://assets.coingecko.com/coins/images/325/small/Tether-logo.png?1598003707",
    coingeckoId: "tether",
    realOriginContractAddress: "0x55d398326f99059ff775485246999027b3197955",
    realOriginChainId: 4,
    supportsPermit: !1
  },
  {
    name: "Tether (Portal from Ethereum)",
    symbol: "USDT",
    mint: "Dn4noZ5jgGfkntzcQSUZ8czkreiZ1ForXYoV2H8Dm7S1",
    contract: "Dn4noZ5jgGfkntzcQSUZ8czkreiZ1ForXYoV2H8Dm7S1",
    chainId: 0,
    wChainId: 1,
    decimals: 6,
    logoURI: "https://assets.coingecko.com/coins/images/325/small/Tether-logo.png?1598003707",
    coingeckoId: "tether",
    realOriginContractAddress: "0xdac17f958d2ee523a2206206994597c13d831ec7",
    realOriginChainId: 2,
    supportsPermit: !1
  },
  {
    name: "Tether",
    symbol: "USDT",
    mint: "Es9vMFrzaCERmJfrF4H2FYD4KCoNkY11McCe8BenwNYB",
    contract: "Es9vMFrzaCERmJfrF4H2FYD4KCoNkY11McCe8BenwNYB",
    chainId: 0,
    wChainId: 1,
    decimals: 6,
    logoURI: "https://assets.coingecko.com/coins/images/325/small/Tether-logo.png?1598003707",
    coingeckoId: "tether",
    realOriginContractAddress: "Es9vMFrzaCERmJfrF4H2FYD4KCoNkY11McCe8BenwNYB",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "The Sandbox (Portal from Ethereum)",
    symbol: "SAND",
    mint: "49c7WuCZkQgc3M4qH8WuEUNXfgwupZf1xqWkDQ7gjRGt",
    contract: "49c7WuCZkQgc3M4qH8WuEUNXfgwupZf1xqWkDQ7gjRGt",
    chainId: 0,
    wChainId: 1,
    decimals: 8,
    logoURI: "https://assets.coingecko.com/coins/images/12129/small/sandbox_logo.jpg?1597397942",
    coingeckoId: "the-sandbox",
    realOriginContractAddress: "0x3845badade8e6dff049820680d1f14bd3903a5d0",
    realOriginChainId: 2,
    supportsPermit: !1
  },
  {
    name: "TheSolanDAO",
    symbol: "SDO",
    mint: "7SZUnH7H9KptyJkUhJ5L4Kee5fFAbqVgCHvt7B6wg4Xc",
    contract: "7SZUnH7H9KptyJkUhJ5L4Kee5fFAbqVgCHvt7B6wg4Xc",
    chainId: 0,
    wChainId: 1,
    decimals: 5,
    logoURI: "https://assets.coingecko.com/coins/images/22427/small/sdo-new_osvgbz.jpg?1641821718",
    coingeckoId: "thesolandao",
    realOriginContractAddress: "7SZUnH7H9KptyJkUhJ5L4Kee5fFAbqVgCHvt7B6wg4Xc",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "Ticket Finance",
    symbol: "TICKET",
    mint: "AymKzSDznoLT7Vhsb4wSRnCj1gjcG3zkgYFY8fxsHHer",
    contract: "AymKzSDznoLT7Vhsb4wSRnCj1gjcG3zkgYFY8fxsHHer",
    chainId: 0,
    wChainId: 1,
    decimals: 8,
    logoURI: "https://assets.coingecko.com/coins/images/22756/small/PK65p32H_400x400.jpg?1642573249",
    coingeckoId: "ticket-finance",
    realOriginContractAddress: "AymKzSDznoLT7Vhsb4wSRnCj1gjcG3zkgYFY8fxsHHer",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "Tiny Bonez",
    symbol: "T1NY",
    mint: "C5xtJBKm24WTt3JiXrvguv7vHCe7CknDB7PNabp4eYX6",
    contract: "C5xtJBKm24WTt3JiXrvguv7vHCe7CknDB7PNabp4eYX6",
    chainId: 0,
    wChainId: 1,
    decimals: 9,
    logoURI: "https://assets.coingecko.com/coins/images/24426/small/coin.png?1647848074",
    coingeckoId: "tiny-bonez",
    realOriginContractAddress: "C5xtJBKm24WTt3JiXrvguv7vHCe7CknDB7PNabp4eYX6",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "Tiny Colony",
    symbol: "TINY",
    mint: "HKfs24UEDQpHS5hUyKYkHd9q7GY5UQ679q2bokeL2whu",
    contract: "HKfs24UEDQpHS5hUyKYkHd9q7GY5UQ679q2bokeL2whu",
    chainId: 0,
    wChainId: 1,
    decimals: 6,
    logoURI: "https://assets.coingecko.com/coins/images/22264/small/Kq4gAMJi_400x400.png?1641336657",
    coingeckoId: "tiny-colony",
    realOriginContractAddress: "HKfs24UEDQpHS5hUyKYkHd9q7GY5UQ679q2bokeL2whu",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "tudaBirds",
    symbol: "BURD",
    mint: "Qikhhhg9Ta3Jg7WoDFbSYuCAE14hx9hPvdz1zVp3zUw",
    contract: "Qikhhhg9Ta3Jg7WoDFbSYuCAE14hx9hPvdz1zVp3zUw",
    chainId: 0,
    wChainId: 1,
    decimals: 9,
    logoURI: "https://assets.coingecko.com/coins/images/22839/small/_TOvRxfx_400x400.jpg?1642745695",
    coingeckoId: "tudabirds",
    realOriginContractAddress: "Qikhhhg9Ta3Jg7WoDFbSYuCAE14hx9hPvdz1zVp3zUw",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "Turtles",
    symbol: "TRTLS",
    mint: "q4bpaRKw3fJB1AJBeeBaKv3TjYzWsmntLgnSB275YUb",
    contract: "q4bpaRKw3fJB1AJBeeBaKv3TjYzWsmntLgnSB275YUb",
    chainId: 0,
    wChainId: 1,
    decimals: 9,
    logoURI: "https://assets.coingecko.com/coins/images/21017/small/turtles200x200.png?1638191778",
    coingeckoId: "turtles-token",
    realOriginContractAddress: "q4bpaRKw3fJB1AJBeeBaKv3TjYzWsmntLgnSB275YUb",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "MILK",
    symbol: "MILK",
    mint: "MLKmUCaj1dpBY881aFsrBwR9RUMoKic8SWT3u1q5Nkj",
    contract: "MLKmUCaj1dpBY881aFsrBwR9RUMoKic8SWT3u1q5Nkj",
    chainId: 0,
    wChainId: 1,
    decimals: 9,
    logoURI: "https://assets.coingecko.com/coins/images/27168/small/UClogoMLKtoken.png?1662285921",
    coingeckoId: "udder-chaos-milk",
    realOriginContractAddress: "MLKmUCaj1dpBY881aFsrBwR9RUMoKic8SWT3u1q5Nkj",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "UncleMine",
    symbol: "UM",
    mint: "DMCUFm2ZAnSU7UgsdVq23gRogMU3MEBjPgQF1gK53rEn",
    contract: "DMCUFm2ZAnSU7UgsdVq23gRogMU3MEBjPgQF1gK53rEn",
    chainId: 0,
    wChainId: 1,
    decimals: 6,
    logoURI: "https://assets.coingecko.com/coins/images/22871/small/unclemine_icon_400.png?1642756525",
    coingeckoId: "unclemine",
    realOriginContractAddress: "DMCUFm2ZAnSU7UgsdVq23gRogMU3MEBjPgQF1gK53rEn",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "Uniswap (Portal from Ethereum)",
    symbol: "UNI",
    mint: "8FU95xFJhUUkyyCLU13HSzDLs7oC4QZdXQHL6SCeab36",
    contract: "8FU95xFJhUUkyyCLU13HSzDLs7oC4QZdXQHL6SCeab36",
    chainId: 0,
    wChainId: 1,
    decimals: 8,
    logoURI: "https://assets.coingecko.com/coins/images/12504/small/uniswap-uni.png?1600306604",
    coingeckoId: "uniswap",
    realOriginContractAddress: "0x1f9840a85d5af5bf1d1762f925bdaddc4201f984",
    realOriginChainId: 2,
    supportsPermit: !1
  },
  {
    name: "Unique Venture clubs",
    symbol: "UNQ",
    mint: "UNQtEecZ5Zb4gSSVHCAWUQEoNnSVEbWiKCi1v9kdUJJ",
    contract: "UNQtEecZ5Zb4gSSVHCAWUQEoNnSVEbWiKCi1v9kdUJJ",
    chainId: 0,
    wChainId: 1,
    decimals: 6,
    logoURI: "https://assets.coingecko.com/coins/images/21730/small/unq.png?1659789179",
    coingeckoId: "unq",
    realOriginContractAddress: "UNQtEecZ5Zb4gSSVHCAWUQEoNnSVEbWiKCi1v9kdUJJ",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "UPFI Network",
    symbol: "UPS",
    mint: "EwJN2GqUGXXzYmoAciwuABtorHczTA5LqbukKXV1viH7",
    contract: "EwJN2GqUGXXzYmoAciwuABtorHczTA5LqbukKXV1viH7",
    chainId: 0,
    wChainId: 1,
    decimals: 6,
    logoURI: "https://assets.coingecko.com/coins/images/20179/small/logo_-_2021-11-11T122041.439.png?1636604452",
    coingeckoId: "upfi-network",
    realOriginContractAddress: "EwJN2GqUGXXzYmoAciwuABtorHczTA5LqbukKXV1viH7",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "Bridged USDC (Portal from Polygon)",
    symbol: "USDC.e",
    mint: "E2VmbootbVCBkMNNxKQgCLMS1X3NoGMaYAsufaAsf7M",
    contract: "E2VmbootbVCBkMNNxKQgCLMS1X3NoGMaYAsufaAsf7M",
    chainId: 0,
    wChainId: 1,
    decimals: 6,
    logoURI: "https://assets.coingecko.com/coins/images/6319/small/USD_Coin_icon.png?1547042389",
    coingeckoId: "usd-coin",
    realOriginContractAddress: "0x2791bca1f2de4661ed88a30c99a7a9449aa84174",
    realOriginChainId: 5,
    supportsPermit: !1
  },
  {
    name: "USDC (Portal from Polygon)",
    symbol: "USDC",
    mint: "C321jHPwWBzgfSGndosDTp5pBsiXPyMU1irxKLVcedRB",
    contract: "C321jHPwWBzgfSGndosDTp5pBsiXPyMU1irxKLVcedRB",
    chainId: 0,
    wChainId: 1,
    decimals: 6,
    logoURI: "https://assets.coingecko.com/coins/images/6319/small/usdc.png?1696506694",
    coingeckoId: "usd-coin",
    realOriginContractAddress: "0x3c499c542cef5e3811e1192ce70d8cc03d5c3359",
    realOriginChainId: 5,
    supportsPermit: !1
  },
  {
    name: "USD Coin (Portal from Ethereum)",
    symbol: "USDC",
    mint: "A9mUU4qviSctJVPJdBJWkb28deg915LYJKrzQ19ji3FM",
    contract: "A9mUU4qviSctJVPJdBJWkb28deg915LYJKrzQ19ji3FM",
    chainId: 0,
    wChainId: 1,
    decimals: 6,
    logoURI: "https://assets.coingecko.com/coins/images/6319/small/USD_Coin_icon.png?1547042389",
    coingeckoId: "usd-coin",
    realOriginContractAddress: "0xa0b86991c6218b36c1d19d4a2e9eb0ce3606eb48",
    realOriginChainId: 2,
    supportsPermit: !1
  },
  {
    name: "USD Coin",
    symbol: "USDC",
    mint: "EPjFWdd5AufqSSqeM2qN1xzybapC8G4wEGGkZwyTDt1v",
    contract: "EPjFWdd5AufqSSqeM2qN1xzybapC8G4wEGGkZwyTDt1v",
    chainId: 0,
    wChainId: 1,
    decimals: 6,
    logoURI: "https://assets.coingecko.com/coins/images/6319/small/USD_Coin_icon.png?1547042389",
    coingeckoId: "usd-coin",
    realOriginContractAddress: "EPjFWdd5AufqSSqeM2qN1xzybapC8G4wEGGkZwyTDt1v",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "USDH",
    symbol: "USDH",
    mint: "USDH1SM1ojwWUga67PGrgFWUHibbjqMvuMaDkRJTgkX",
    contract: "USDH1SM1ojwWUga67PGrgFWUHibbjqMvuMaDkRJTgkX",
    chainId: 0,
    wChainId: 1,
    decimals: 6,
    logoURI: "https://assets.coingecko.com/coins/images/22941/small/USDH_icon.png?1643008131",
    coingeckoId: "usdh",
    realOriginContractAddress: "USDH1SM1ojwWUga67PGrgFWUHibbjqMvuMaDkRJTgkX",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "UXD Protocol",
    symbol: "UXP",
    mint: "UXPhBoR3qG4UCiGNJfV7MqhHyFqKN68g45GoYvAeL2M",
    contract: "UXPhBoR3qG4UCiGNJfV7MqhHyFqKN68g45GoYvAeL2M",
    chainId: 0,
    wChainId: 1,
    decimals: 9,
    logoURI: "https://assets.coingecko.com/coins/images/20319/small/UXP.jpg?1636864568",
    coingeckoId: "uxd-protocol-token",
    realOriginContractAddress: "UXPhBoR3qG4UCiGNJfV7MqhHyFqKN68g45GoYvAeL2M",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "UXD Stablecoin",
    symbol: "UXD",
    mint: "7kbnvuGBxxj8AG9qp8Scn56muWGaRaFqxg1FsRp3PaFT",
    contract: "7kbnvuGBxxj8AG9qp8Scn56muWGaRaFqxg1FsRp3PaFT",
    chainId: 0,
    wChainId: 1,
    decimals: 6,
    logoURI: "https://assets.coingecko.com/coins/images/22850/small/UXD-White.png?1642747473",
    coingeckoId: "uxd-stablecoin",
    realOriginContractAddress: "7kbnvuGBxxj8AG9qp8Scn56muWGaRaFqxg1FsRp3PaFT",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "Viral Inu",
    symbol: "VINU",
    mint: "CgbJxXyaHeU8VsquBpySuFXA94b6LWXxioZ28wRr8fs9",
    contract: "CgbJxXyaHeU8VsquBpySuFXA94b6LWXxioZ28wRr8fs9",
    chainId: 0,
    wChainId: 1,
    decimals: 6,
    logoURI: "https://assets.coingecko.com/coins/images/20698/small/vinu.png?1642917940",
    coingeckoId: "viral-inu",
    realOriginContractAddress: "CgbJxXyaHeU8VsquBpySuFXA94b6LWXxioZ28wRr8fs9",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "Vivaion",
    symbol: "VIVAION",
    mint: "2jw1uFmc1hhfJH3EqGhaE2rfZMMC2YBpxkZcdUbPppMn",
    contract: "2jw1uFmc1hhfJH3EqGhaE2rfZMMC2YBpxkZcdUbPppMn",
    chainId: 0,
    wChainId: 1,
    decimals: 9,
    logoURI: "https://assets.coingecko.com/coins/images/22797/small/zCKgUOy13nTdqluJ1VWG2aqDfMgD4axJt_g4C9T-W3I.png?1650957408",
    coingeckoId: "vivaion",
    realOriginContractAddress: "2jw1uFmc1hhfJH3EqGhaE2rfZMMC2YBpxkZcdUbPppMn",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "Void Games",
    symbol: "VOID",
    mint: "DjPt6xxMoZx1DyyWUHGs4mwqWWX48Fwf6ZJgqv2F9qwc",
    contract: "DjPt6xxMoZx1DyyWUHGs4mwqWWX48Fwf6ZJgqv2F9qwc",
    chainId: 0,
    wChainId: 1,
    decimals: 9,
    logoURI: "https://assets.coingecko.com/coins/images/21307/small/h5lkasZH_400x400.jpg?1638886042",
    coingeckoId: "void-games",
    realOriginContractAddress: "DjPt6xxMoZx1DyyWUHGs4mwqWWX48Fwf6ZJgqv2F9qwc",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "Waggle Network",
    symbol: "WAG",
    mint: "5tN42n9vMi6ubp67Uy4NnmM5DMZYN8aS8GeB3bEDHr6E",
    contract: "5tN42n9vMi6ubp67Uy4NnmM5DMZYN8aS8GeB3bEDHr6E",
    chainId: 0,
    wChainId: 1,
    decimals: 9,
    logoURI: "https://assets.coingecko.com/coins/images/18696/small/waggle.PNG?1633750177",
    coingeckoId: "waggle-network",
    realOriginContractAddress: "5tN42n9vMi6ubp67Uy4NnmM5DMZYN8aS8GeB3bEDHr6E",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "Walken",
    symbol: "WLKN",
    mint: "EcQCUYv57C4V6RoPxkVUiDwtX1SP8y8FP5AEToYL8Az",
    contract: "EcQCUYv57C4V6RoPxkVUiDwtX1SP8y8FP5AEToYL8Az",
    chainId: 0,
    wChainId: 1,
    decimals: 9,
    logoURI: "https://assets.coingecko.com/coins/images/25566/small/wlkn.jpg?1652523301",
    coingeckoId: "walken",
    realOriginContractAddress: "EcQCUYv57C4V6RoPxkVUiDwtX1SP8y8FP5AEToYL8Az",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "Wrapped BNB (Portal from BSC)",
    symbol: "WBNB",
    mint: "9gP2kCy3wA1ctvYWQk75guqXuHfrEomqydHLtcTCqiLa",
    contract: "9gP2kCy3wA1ctvYWQk75guqXuHfrEomqydHLtcTCqiLa",
    chainId: 0,
    wChainId: 1,
    decimals: 8,
    logoURI: "https://assets.coingecko.com/coins/images/12591/small/binance-coin-logo.png?1600947313",
    coingeckoId: "wbnb",
    realOriginContractAddress: "0xbb4cdb9cbd36b01bd1cbaebf2de08d9173bc095c",
    realOriginChainId: 4,
    supportsPermit: !1
  },
  {
    name: "Ween",
    symbol: "WEENS",
    mint: "DmXfDUeyRJqnpvdjssGgUXwZrRFPXvu2DfMq4jfTTC9C",
    contract: "DmXfDUeyRJqnpvdjssGgUXwZrRFPXvu2DfMq4jfTTC9C",
    chainId: 0,
    wChainId: 1,
    decimals: 0,
    logoURI: "https://assets.coingecko.com/coins/images/21764/small/logo_%281%29.png?1639991986",
    coingeckoId: "ween-token",
    realOriginContractAddress: "DmXfDUeyRJqnpvdjssGgUXwZrRFPXvu2DfMq4jfTTC9C",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "WETH (Portal from Ethereum)",
    symbol: "WETH",
    mint: "7vfCXTUXx5WJV5JADk17DUJ4ksgau7utNKj4b963voxs",
    contract: "7vfCXTUXx5WJV5JADk17DUJ4ksgau7utNKj4b963voxs",
    chainId: 0,
    wChainId: 1,
    decimals: 8,
    logoURI: "https://assets.coingecko.com/coins/images/2518/small/weth.png?1628852295",
    coingeckoId: "weth",
    realOriginContractAddress: "0xc02aaa39b223fe8d0a0e5c4f27ead9083c756cc2",
    realOriginChainId: 2,
    supportsPermit: !1
  },
  {
    name: "WEYU (Portal from BSC)",
    symbol: "WEYU",
    mint: "EHaEBhYHWA7HSphorXXosysJem6qF4agccoqDqQKCUge",
    contract: "EHaEBhYHWA7HSphorXXosysJem6qF4agccoqDqQKCUge",
    chainId: 0,
    wChainId: 1,
    decimals: 8,
    logoURI: "https://assets.coingecko.com/coins/images/18112/small/weyu.PNG?1630542552",
    coingeckoId: "weyu",
    realOriginContractAddress: "0xfafd4cb703b25cb22f43d017e7e0d75febc26743",
    realOriginChainId: 4,
    supportsPermit: !1
  },
  {
    name: "Whalemap",
    symbol: "WMP",
    mint: "BygDd5LURoqztD3xETc99WCxLUbTi6WYSht9XiBgZ4HW",
    contract: "BygDd5LURoqztD3xETc99WCxLUbTi6WYSht9XiBgZ4HW",
    chainId: 0,
    wChainId: 1,
    decimals: 9,
    logoURI: "https://assets.coingecko.com/coins/images/21892/small/logo-token_%281%29.png?1640228860",
    coingeckoId: "whalemap",
    realOriginContractAddress: "BygDd5LURoqztD3xETc99WCxLUbTi6WYSht9XiBgZ4HW",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "Shredded Apes Whey",
    symbol: "WHEY",
    mint: "5fTwKZP2AK39LtFN9Ayppu6hdCVKfMGVm79F2EgHCtsi",
    contract: "5fTwKZP2AK39LtFN9Ayppu6hdCVKfMGVm79F2EgHCtsi",
    chainId: 0,
    wChainId: 1,
    decimals: 6,
    logoURI: "https://assets.coingecko.com/coins/images/23256/small/whey-coin-2048x2048.png?1643360509",
    coingeckoId: "whey-token",
    realOriginContractAddress: "5fTwKZP2AK39LtFN9Ayppu6hdCVKfMGVm79F2EgHCtsi",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "Whole Earth Coin",
    symbol: "WEC",
    mint: "6y8W5YwAuzostqrS4YDJufBvksosfSi47Pd8U4A5vrBC",
    contract: "6y8W5YwAuzostqrS4YDJufBvksosfSi47Pd8U4A5vrBC",
    chainId: 0,
    wChainId: 1,
    decimals: 9,
    logoURI: "https://assets.coingecko.com/coins/images/16313/small/WEC_logo.png?1669459247",
    coingeckoId: "whole-earth-coin",
    realOriginContractAddress: "6y8W5YwAuzostqrS4YDJufBvksosfSi47Pd8U4A5vrBC",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "Winerz",
    symbol: "$WNZ",
    mint: "WNZzxM1WqWFH8DpDZSqr6EoHKWXeMx9NLLd2R5RzGPA",
    contract: "WNZzxM1WqWFH8DpDZSqr6EoHKWXeMx9NLLd2R5RzGPA",
    chainId: 0,
    wChainId: 1,
    decimals: 4,
    logoURI: "https://assets.coingecko.com/coins/images/24786/small/wnz.png?1648905714",
    coingeckoId: "winerz",
    realOriginContractAddress: "WNZzxM1WqWFH8DpDZSqr6EoHKWXeMx9NLLd2R5RzGPA",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "WipeMyAss",
    symbol: "WIPE",
    mint: "9ae76zqD3cgzR9gvf5Thc2NN3ACF7rqqnrLqxNzgcre6",
    contract: "9ae76zqD3cgzR9gvf5Thc2NN3ACF7rqqnrLqxNzgcre6",
    chainId: 0,
    wChainId: 1,
    decimals: 9,
    logoURI: "https://assets.coingecko.com/coins/images/19967/small/wipemyass.jpeg?1636344049",
    coingeckoId: "wipemyass",
    realOriginContractAddress: "9ae76zqD3cgzR9gvf5Thc2NN3ACF7rqqnrLqxNzgcre6",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "Wrapped Matic (Portal from Polygon)",
    symbol: "WMATIC",
    mint: "Gz7VkD4MacbEB6yC5XD3HcumEiYx2EtDYYrfikGsvopG",
    contract: "Gz7VkD4MacbEB6yC5XD3HcumEiYx2EtDYYrfikGsvopG",
    chainId: 0,
    wChainId: 1,
    decimals: 8,
    logoURI: "https://assets.coingecko.com/coins/images/14073/small/matic.png?1628852392",
    coingeckoId: "wmatic",
    realOriginContractAddress: "0x0d500b1d8e8ef31e21c99d1db9a6444d3adf1270",
    realOriginChainId: 5,
    supportsPermit: !1
  },
  {
    name: "WOOF",
    symbol: "WOOF",
    mint: "9nEqaUcb16sQ3Tn1psbkWqyhPdLmfHWjKGymREjsAgTE",
    contract: "9nEqaUcb16sQ3Tn1psbkWqyhPdLmfHWjKGymREjsAgTE",
    chainId: 0,
    wChainId: 1,
    decimals: 6,
    logoURI: "https://assets.coingecko.com/coins/images/18319/small/woof-logo-svg-true-solana-radient-blackinside.png?1637655115",
    coingeckoId: "woof-token",
    realOriginContractAddress: "9nEqaUcb16sQ3Tn1psbkWqyhPdLmfHWjKGymREjsAgTE",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "WOOP",
    symbol: "WOOP",
    mint: "A3HyGZqe451CBesNqieNPfJ4A9Mu332ui8ni6dobVSLB",
    contract: "A3HyGZqe451CBesNqieNPfJ4A9Mu332ui8ni6dobVSLB",
    chainId: 0,
    wChainId: 1,
    decimals: 5,
    logoURI: "https://assets.coingecko.com/coins/images/24904/small/coin-gecko.png?1649335210",
    coingeckoId: "woop",
    realOriginContractAddress: "A3HyGZqe451CBesNqieNPfJ4A9Mu332ui8ni6dobVSLB",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "Wrapped ALGO",
    symbol: "XALGO",
    mint: "xALGoH1zUfRmpCriy94qbfoMXHtK6NDnMKzT4Xdvgms",
    contract: "xALGoH1zUfRmpCriy94qbfoMXHtK6NDnMKzT4Xdvgms",
    chainId: 0,
    wChainId: 1,
    decimals: 6,
    logoURI: "https://assets.coingecko.com/coins/images/26335/small/xALGO.png?1657494713",
    coingeckoId: "wrapped-algo",
    realOriginContractAddress: "xALGoH1zUfRmpCriy94qbfoMXHtK6NDnMKzT4Xdvgms",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "Wrapped AVAX (Portal from Avalanche)",
    symbol: "WAVAX",
    mint: "KgV1GvrHQmRBY8sHQQeUKwTm2r2h8t4C8qt12Cw1HVE",
    contract: "KgV1GvrHQmRBY8sHQQeUKwTm2r2h8t4C8qt12Cw1HVE",
    chainId: 0,
    wChainId: 1,
    decimals: 8,
    logoURI: "https://assets.coingecko.com/coins/images/15075/small/wrapped-avax.png?1629873618",
    coingeckoId: "wrapped-avax",
    realOriginContractAddress: "0xb31f66aa3c1e785363f0875a1b74e27b85fd66c7",
    realOriginChainId: 6,
    supportsPermit: !1
  },
  {
    name: "Wrapped Bitcoin (Sollet)",
    symbol: "SOBTC",
    mint: "9n4nbM75f5Ui33ZbPYXn59EwSgE8CGsHtAeTH5YFeJ9E",
    contract: "9n4nbM75f5Ui33ZbPYXn59EwSgE8CGsHtAeTH5YFeJ9E",
    chainId: 0,
    wChainId: 1,
    decimals: 6,
    logoURI: "https://assets.coingecko.com/coins/images/24917/small/opengraph.png?1649344256",
    coingeckoId: "wrapped-bitcoin-sollet",
    realOriginContractAddress: "9n4nbM75f5Ui33ZbPYXn59EwSgE8CGsHtAeTH5YFeJ9E",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "Wrapped BUSD (Allbridge from BSC)",
    symbol: "ABBUSD",
    mint: "6nuaX3ogrr2CaoAPjtaKHAoBNWok32BMcRozuf32s2QF",
    contract: "6nuaX3ogrr2CaoAPjtaKHAoBNWok32BMcRozuf32s2QF",
    chainId: 0,
    wChainId: 1,
    decimals: 9,
    logoURI: "https://assets.coingecko.com/coins/images/23061/small/logo_-_2022-01-26T091043.556.png?1643159457",
    coingeckoId: "wrapped-busd-allbridge-from-bsc",
    realOriginContractAddress: "6nuaX3ogrr2CaoAPjtaKHAoBNWok32BMcRozuf32s2QF",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "Wrapped Chainlink (Sollet)",
    symbol: "SOLINK",
    mint: "CWE8jPTUYhdCTZYWPTe1o5DFqfdjzWKc9WKz6rSjQUdG",
    contract: "CWE8jPTUYhdCTZYWPTe1o5DFqfdjzWKc9WKz6rSjQUdG",
    chainId: 0,
    wChainId: 1,
    decimals: 6,
    logoURI: "https://assets.coingecko.com/coins/images/24705/small/qvSHhRyC_400x400.jpg?1648646324",
    coingeckoId: "wrapped-chainlink-sollet",
    realOriginContractAddress: "CWE8jPTUYhdCTZYWPTe1o5DFqfdjzWKc9WKz6rSjQUdG",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "Wrapped CUSD (Allbridge from Celo)",
    symbol: "ACUSD",
    mint: "EwxNF8g9UfmsJVcZFTpL9Hx5MCkoQFoJi6XNWzKf1j8e",
    contract: "EwxNF8g9UfmsJVcZFTpL9Hx5MCkoQFoJi6XNWzKf1j8e",
    chainId: 0,
    wChainId: 1,
    decimals: 9,
    logoURI: "https://assets.coingecko.com/coins/images/23057/small/7236.png?1643153224",
    coingeckoId: "wrapped-cusd-allbridge-from-celo",
    realOriginContractAddress: "EwxNF8g9UfmsJVcZFTpL9Hx5MCkoQFoJi6XNWzKf1j8e",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "Wrapped Ethereum (Sollet)",
    symbol: "SOETH",
    mint: "2FPyTwcZLUg1MDrwsyoP4D6s1tM7hAkHYRjkNb5w6Pxk",
    contract: "2FPyTwcZLUg1MDrwsyoP4D6s1tM7hAkHYRjkNb5w6Pxk",
    chainId: 0,
    wChainId: 1,
    decimals: 6,
    logoURI: "https://assets.coingecko.com/coins/images/24918/small/6250754.png?1649344492",
    coingeckoId: "wrapped-ethereum-sollet",
    realOriginContractAddress: "2FPyTwcZLUg1MDrwsyoP4D6s1tM7hAkHYRjkNb5w6Pxk",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "Wrapped Solana",
    symbol: "wSOL",
    mint: "So11111111111111111111111111111111111111112",
    contract: "So11111111111111111111111111111111111111112",
    chainId: 0,
    wChainId: 1,
    decimals: 9,
    logoURI: "https://assets.coingecko.com/coins/images/21629/small/solana.jpg?1639626543",
    coingeckoId: "wrapped-solana",
    realOriginContractAddress: "So11111111111111111111111111111111111111112",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "Wrapped USDT (Allbridge from Polygon)",
    symbol: "APUSDT",
    mint: "DNhZkUaxHXYvpxZ7LNnHtss8sQgdAfd1ZYS1fB7LKWUZ",
    contract: "DNhZkUaxHXYvpxZ7LNnHtss8sQgdAfd1ZYS1fB7LKWUZ",
    chainId: 0,
    wChainId: 1,
    decimals: 6,
    logoURI: "https://assets.coingecko.com/coins/images/23060/small/logo_-_2022-01-26T084912.902.png?1643158161",
    coingeckoId: "wrapped-usdt-allbridge-from-polygon",
    realOriginContractAddress: "DNhZkUaxHXYvpxZ7LNnHtss8sQgdAfd1ZYS1fB7LKWUZ",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "Wrapped USTC",
    symbol: "USTC",
    mint: "CXLBjMMcwkc17GfJtBos6rQCo1ypeH6eDbB82Kby4MRm",
    contract: "CXLBjMMcwkc17GfJtBos6rQCo1ypeH6eDbB82Kby4MRm",
    chainId: 0,
    wChainId: 1,
    decimals: 9,
    logoURI: "https://assets.coingecko.com/coins/images/15462/small/ust.png?1620910058",
    coingeckoId: "wrapped-ust",
    realOriginContractAddress: "CXLBjMMcwkc17GfJtBos6rQCo1ypeH6eDbB82Kby4MRm",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "Wrapped YFI (Sollet)",
    symbol: "SOYFI",
    mint: "3JSf5tPeuscJGtaCp5giEiDhv51gQ4v3zWg8DGgyLfAB",
    contract: "3JSf5tPeuscJGtaCp5giEiDhv51gQ4v3zWg8DGgyLfAB",
    chainId: 0,
    wChainId: 1,
    decimals: 6,
    logoURI: "https://assets.coingecko.com/coins/images/24704/small/yl4nOJno_400x400.jpg?1648646042",
    coingeckoId: "wrapped-yfi-sollet",
    realOriginContractAddress: "3JSf5tPeuscJGtaCp5giEiDhv51gQ4v3zWg8DGgyLfAB",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "xHashtag",
    symbol: "XTAG",
    mint: "5gs8nf4wojB5EXgDUWNLwXpknzgV2YWDhveAeBZpVLbp",
    contract: "5gs8nf4wojB5EXgDUWNLwXpknzgV2YWDhveAeBZpVLbp",
    chainId: 0,
    wChainId: 1,
    decimals: 6,
    logoURI: "https://assets.coingecko.com/coins/images/20912/small/xtag.png?1637922382",
    coingeckoId: "xhashtag",
    realOriginContractAddress: "5gs8nf4wojB5EXgDUWNLwXpknzgV2YWDhveAeBZpVLbp",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "Xverse",
    symbol: "XVC",
    mint: "25Vu6457o2gdZRGVVt5K8NbAvaP3esYaQNHbNDitVtw1",
    contract: "25Vu6457o2gdZRGVVt5K8NbAvaP3esYaQNHbNDitVtw1",
    chainId: 0,
    wChainId: 1,
    decimals: 9,
    logoURI: "https://assets.coingecko.com/coins/images/17709/small/1_y5qvEWJiA4dFjoQNcqth3g.png?1629081157",
    coingeckoId: "xverse",
    realOriginContractAddress: "25Vu6457o2gdZRGVVt5K8NbAvaP3esYaQNHbNDitVtw1",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "Yawww",
    symbol: "YAW",
    mint: "YAWtS7vWCSRPckx1agB6sKidVXiXiDUfehXdEUSRGKE",
    contract: "YAWtS7vWCSRPckx1agB6sKidVXiXiDUfehXdEUSRGKE",
    chainId: 0,
    wChainId: 1,
    decimals: 6,
    logoURI: "https://assets.coingecko.com/coins/images/24233/small/yaw.PNG?1646982198",
    coingeckoId: "yawww",
    realOriginContractAddress: "YAWtS7vWCSRPckx1agB6sKidVXiXiDUfehXdEUSRGKE",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "Zap (Portal from BSC)",
    symbol: "ZAP",
    mint: "HxPoEHMt1vKeqjKCePcqTj6yYgn6Xqq1fKTY3Pjx4YrX",
    contract: "HxPoEHMt1vKeqjKCePcqTj6yYgn6Xqq1fKTY3Pjx4YrX",
    chainId: 0,
    wChainId: 1,
    decimals: 8,
    logoURI: "https://assets.coingecko.com/coins/images/2180/small/zap.png?1547036476",
    coingeckoId: "zap",
    realOriginContractAddress: "0xc5326b32e8baef125acd68f8bc646fd646104f1c",
    realOriginChainId: 4,
    supportsPermit: !1
  },
  {
    name: "Zebec Protocol",
    symbol: "ZBC",
    mint: "zebeczgi5fSEtbpfQKVZKCJ3WgYXxjkMUkNNx7fLKAF",
    contract: "zebeczgi5fSEtbpfQKVZKCJ3WgYXxjkMUkNNx7fLKAF",
    chainId: 0,
    wChainId: 1,
    decimals: 9,
    logoURI: "https://assets.coingecko.com/coins/images/24342/small/zbc.PNG?1647400775",
    coingeckoId: "zebec-protocol",
    realOriginContractAddress: "zebeczgi5fSEtbpfQKVZKCJ3WgYXxjkMUkNNx7fLKAF",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "Zion",
    symbol: "ZION",
    mint: "A7rqejP8LKN8syXMr4tvcKjs2iJ4WtZjXNs1e6qP3m9g",
    contract: "A7rqejP8LKN8syXMr4tvcKjs2iJ4WtZjXNs1e6qP3m9g",
    chainId: 0,
    wChainId: 1,
    decimals: 9,
    logoURI: "https://assets.coingecko.com/coins/images/22150/small/Ziontoken_2_84.png?1640931619",
    coingeckoId: "zion",
    realOriginContractAddress: "A7rqejP8LKN8syXMr4tvcKjs2iJ4WtZjXNs1e6qP3m9g",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "GME",
    symbol: "GME",
    mint: "8wXtPeU6557ETkp9WHFY1n1EcU6NxDvbAggHGsMYiHsB",
    contract: "8wXtPeU6557ETkp9WHFY1n1EcU6NxDvbAggHGsMYiHsB",
    chainId: 0,
    wChainId: 1,
    decimals: 9,
    logoURI: "https://assets.coingecko.com/coins/images/34930/small/GMEstop_%281%29_%281%29.png?1706689237",
    coingeckoId: "gme",
    realOriginContractAddress: "8wXtPeU6557ETkp9WHFY1n1EcU6NxDvbAggHGsMYiHsB",
    realOriginChainId: 1,
    supportsPermit: !1
  },
  {
    name: "WETH (Portal from Optimism)",
    symbol: "WETH",
    mint: "8M6d63oL7dvMZ1gNbgGe3h8afMSWJEKEhtPTFM2u8h3c",
    contract: "8M6d63oL7dvMZ1gNbgGe3h8afMSWJEKEhtPTFM2u8h3c",
    chainId: 0,
    wChainId: 1,
    decimals: 8,
    logoURI: "https://assets.coingecko.com/coins/images/2518/small/weth.png?1696503332",
    coingeckoId: "weth",
    realOriginContractAddress: "0x4200000000000000000000000000000000000006",
    realOriginChainId: 24,
    supportsPermit: !1
  },
  {
    name: "USDC (Portal from Optimism)",
    symbol: "USDC",
    mint: "J8kcD4Wnd1ehne1dpL8WNtgZQR6Jpui2cTZcrmg5ybAa",
    contract: "J8kcD4Wnd1ehne1dpL8WNtgZQR6Jpui2cTZcrmg5ybAa",
    chainId: 0,
    wChainId: 1,
    decimals: 6,
    logoURI: "https://assets.coingecko.com/coins/images/6319/small/usdc.png?1696506694",
    coingeckoId: "usd-coin",
    realOriginContractAddress: "0x0b2c639c533813f4aa9d7837caf62653d097ff85",
    realOriginChainId: 24,
    supportsPermit: !1
  },
  {
    name: "Bridged USDC (Optimism) (Portal from Optimism)",
    symbol: "USDC.E",
    mint: "D6YyAUMTJipLQfUhYs6psdnwpmMz6KbM4Qs9AtCmPpxR",
    contract: "D6YyAUMTJipLQfUhYs6psdnwpmMz6KbM4Qs9AtCmPpxR",
    chainId: 0,
    wChainId: 1,
    decimals: 6,
    logoURI: "https://assets.coingecko.com/coins/images/31580/small/USDC-icon.png?1696530397",
    coingeckoId: "bridged-usd-coin-optimism",
    realOriginContractAddress: "0x7f5c764cbc14f9669b88837ca1490cca17c31607",
    realOriginChainId: 24,
    supportsPermit: !1
  },
  {
    name: "Tether (Portal from Optimism)",
    symbol: "USDT",
    mint: "CLV6gB88nQtnuo3akGLSVRFaiFPTXaBXV4EDaFxV7iRq",
    contract: "CLV6gB88nQtnuo3akGLSVRFaiFPTXaBXV4EDaFxV7iRq",
    chainId: 0,
    wChainId: 1,
    decimals: 6,
    logoURI: "https://assets.coingecko.com/coins/images/325/small/Tether.png?1696501661",
    coingeckoId: "tether",
    realOriginContractAddress: "0x94b008aa00579c1307b0ef2c499ad98a8ce58e58",
    realOriginChainId: 24,
    supportsPermit: !1
  },
  {
    name: "WETH (Portal from Base)",
    symbol: "WETH",
    mint: "DWXe1hxpnb8LAH21iyXcjvMbiAGzoYyuCVQtRLvZdLYd",
    contract: "DWXe1hxpnb8LAH21iyXcjvMbiAGzoYyuCVQtRLvZdLYd",
    chainId: 0,
    wChainId: 1,
    decimals: 8,
    logoURI: "https://assets.coingecko.com/coins/images/2518/small/weth.png?1696503332",
    coingeckoId: "weth",
    realOriginContractAddress: "0x4200000000000000000000000000000000000006",
    realOriginChainId: 30
  },
  {
    name: "USDC (Portal from Base)",
    symbol: "USDC",
    mint: "EfqRM8ZGWhDTKJ7BHmFvNagKVu3AxQRDQs8WMMaoBCu6",
    contract: "EfqRM8ZGWhDTKJ7BHmFvNagKVu3AxQRDQs8WMMaoBCu6",
    chainId: 0,
    wChainId: 1,
    decimals: 6,
    logoURI: "https://assets.coingecko.com/coins/images/6319/small/usdc.png?1696506694",
    coingeckoId: "usd-coin",
    realOriginContractAddress: "0x833589fcd6edb6e08f4c7c32d4f71b54bda02913",
    realOriginChainId: 30
  },
  {
    name: "Edgevana Staked SOL",
    symbol: "EDGESOL",
    mint: "edge86g9cVz87xcpKpy3J77vbp4wYd9idEV562CCntt",
    contract: "edge86g9cVz87xcpKpy3J77vbp4wYd9idEV562CCntt",
    chainId: 0,
    wChainId: 1,
    decimals: 9,
    logoURI: "https://assets.coingecko.com/coins/images/35492/small/edgesol.png?1708918562",
    coingeckoId: "edgevana-staked-sol",
    realOriginContractAddress: "edge86g9cVz87xcpKpy3J77vbp4wYd9idEV562CCntt",
    realOriginChainId: 1
  },
  {
    name: "Chinu",
    symbol: "CHINU",
    mint: "FLrgwxXaX8q8ECF18weDf3PLAYorXST5orpY34d8jfbm",
    contract: "FLrgwxXaX8q8ECF18weDf3PLAYorXST5orpY34d8jfbm",
    chainId: 0,
    wChainId: 1,
    decimals: 9,
    logoURI: "https://assets.coingecko.com/coins/images/34610/small/chinuHeadLogo200.png?1705499604",
    coingeckoId: "chinu-2",
    realOriginContractAddress: "FLrgwxXaX8q8ECF18weDf3PLAYorXST5orpY34d8jfbm",
    realOriginChainId: 1
  },
  {
    name: "SPX6900 (Portal from Ethereum)",
    symbol: "SPX",
    mint: "J3NKxxXZcnNiMjKw9hYb2K4LUxgwB6t1FtPtQVsv3KFr",
    contract: "J3NKxxXZcnNiMjKw9hYb2K4LUxgwB6t1FtPtQVsv3KFr",
    chainId: 0,
    wChainId: 1,
    decimals: 8,
    logoURI: "https://assets.coingecko.com/coins/images/31401/small/sticker_%281%29.jpg?1702371083",
    coingeckoId: "spx6900",
    realOriginContractAddress: "0xe0f63a424a4439cbe457d80e4f4b51ad25b2c56c",
    realOriginChainId: 2
  }
], tokenCache = {
  arbitrum,
  ethereum,
  base,
  aptos,
  polygon,
  optimism,
  avalanche,
  bsc,
  solana
}, NATIVE_CONTRACT_ADDRESS = "0x0000000000000000000000000000000000000000", chainNameMap = {
  Solana: "solana",
  Ethereum: "ethereum",
  Bsc: "bsc",
  Polygon: "polygon",
  Avalanche: "avalanche",
  Arbitrum: "arbitrum",
  Aptos: "aptos",
  Base: "base",
  Optimism: "optimism"
};
function toMayanChainName(C) {
  if (!chainNameMap[C])
    throw new Error(`Chain ${C} not supported`);
  return chainNameMap[C];
}
function fromMayanChainName(C) {
  for (const [e, T] of Object.entries(chainNameMap))
    if (T === C)
      return e;
  throw new Error(`Unknown Mayan chain ${C}`);
}
function toWormholeChainName(C) {
  return toChain(Number(C));
}
function supportedChains() {
  return Object.keys(chainNameMap);
}
let tokenListCache = {};
async function fetchTokensForChain(C) {
  if (C in tokenListCache)
    return tokenListCache[C];
  let e, T = toMayanChainName(C);
  try {
    e = await fetchTokenList(T);
  } catch {
    e = tokenCache[T];
  }
  const $ = e.map((V) => V.contract === NATIVE_CONTRACT_ADDRESS ? nativeTokenId(C) : {
    chain: C,
    address: toNative(C, V.contract)
  });
  return tokenListCache[C] = $, $;
}
var MayanClientStatus;
(function(C) {
  C.INPROGRESS = "INPROGRESS", C.COMPLETED = "COMPLETED", C.REFUNDED = "REFUNDED", C.CANCELED = "CANCELED";
})(MayanClientStatus || (MayanClientStatus = {}));
const possibleVaaTypes = [
  // Bridge to swap chain (solana)
  "transfer",
  // Info about the swap
  "swap",
  // Successful, bridge to destination chain
  "redeem",
  // Unsuccessful auction, refund back to source chain (evm)
  "refund"
];
var MayanTransactionGoal;
(function(C) {
  C.Send = "SEND", C.Bridge = "BRIDGE", C.Swap = "SWAP", C.Register = "REGISTER", C.Settle = "SETTLE";
})(MayanTransactionGoal || (MayanTransactionGoal = {}));
function txStatusToReceipt(C) {
  const e = toWormholeChainName(C.sourceChain), T = toWormholeChainName(C.destChain), $ = C.txs.filter((ie) => (
    // Send from Evm to Solana
    ie.goals.includes(MayanTransactionGoal.Send) || // Register for auction on Solana
    ie.goals.includes(MayanTransactionGoal.Register)
  )).map((ie) => ({
    chain: e,
    txid: ie.txHash
  })), V = C.txs.filter((ie) => ie.goals.includes(MayanTransactionGoal.Settle)).map((ie) => ({
    chain: T,
    txid: ie.txHash
  }));
  let J = [];
  C.refundTxHash && J.push({
    chain: fromMayanChainName(C.refundChain),
    txid: C.refundTxHash
  });
  const ee = {};
  for (const ie of possibleVaaTypes) {
    const se = `${ie}SignedVaa`;
    if (se in C && C[se] !== null) {
      const de = deserialize$1("Uint8Array", hex$1.decode(C[se]));
      ee[ie] = {
        id: {
          emitter: de.emitterAddress,
          sequence: de.sequence,
          chain: de.emitterChain
        },
        attestation: de
      };
    }
  }
  let te = {}, re = !1;
  if ("redeem" in ee ? (te = ee.redeem, re = !0) : "transfer" in ee && (te = ee.transfer, re = !0), C.clientStatus === MayanClientStatus.COMPLETED)
    return {
      from: e,
      to: T,
      originTxs: $,
      destinationTxs: V,
      state: TransferState.DestinationFinalized,
      attestation: te
    };
  if (C.clientStatus === MayanClientStatus.REFUNDED || C.clientStatus === MayanClientStatus.CANCELED)
    return {
      from: e,
      to: T,
      originTxs: $,
      refundTxs: J,
      state: TransferState.Refunded,
      attestation: ee.refund
    };
  if (C.clientStatus === MayanClientStatus.INPROGRESS)
    return re && V.length > 0 ? {
      from: e,
      to: T,
      originTxs: $,
      destinationTxs: V,
      state: TransferState.DestinationInitiated,
      attestation: te
    } : {
      from: e,
      to: T,
      originTxs: $,
      state: TransferState.SourceInitiated
    };
  throw new Error(`Unknown Mayan clientStatus ${C.clientStatus}`);
}
async function getTransactionStatus(C) {
  var T;
  const e = `https://explorer-api.mayan.finance/v3/swap/trx/${C.txid}`;
  try {
    const $ = await axios.get(e);
    if ($.data.id)
      return $.data;
  } catch ($) {
    if (!$ || typeof $ == "object" && (axios.isAxiosError($) && ((T = $.response) == null ? void 0 : T.status) === 404 || "status" in $ && $.status === 404))
      return null;
    throw $;
  }
  return null;
}
class MayanRouteBase extends AutomaticRoute {
  constructor() {
    super(...arguments);
    tt(this, "MAX_SLIPPAGE", 1);
    tt(this, "protocols", ["WH", "MCTP", "SWIFT"]);
  }
  getDefaultOptions() {
    return {
      gasDrop: 0,
      slippageBps: "auto",
      optimizeFor: "speed"
    };
  }
  static supportedNetworks() {
    return ["Mainnet"];
  }
  static supportedChains(T) {
    return supportedChains();
  }
  static async supportedSourceTokens(T) {
    return fetchTokensForChain(T.chain);
  }
  static isProtocolSupported(T) {
    return supportedChains().includes(T.chain);
  }
  static async supportedDestinationTokens(T, $, V) {
    return !supportedChains().includes($.chain) || !supportedChains().includes(V.chain) ? [] : fetchTokensForChain(V.chain);
  }
  async isAvailable() {
    return !0;
  }
  async validate(T, $) {
    try {
      return $.options = $.options ?? this.getDefaultOptions(), {
        valid: !0,
        params: {
          ...$,
          normalizedParams: {
            slippageBps: $.options.slippageBps
          }
        }
      };
    } catch (V) {
      return { valid: !1, params: $, error: V };
    }
  }
  destTokenAddress(T) {
    const { destination: $ } = T;
    return $ && !isNative$1($.id.address) ? canonicalAddress($.id) : NATIVE_CONTRACT_ADDRESS;
  }
  sourceTokenAddress(T) {
    const { source: $ } = T;
    return isNative$1($.id.address) ? NATIVE_CONTRACT_ADDRESS : canonicalAddress($.id);
  }
  async fetchQuote(T, $) {
    const { fromChain: V, toChain: J } = T, ee = {
      amount: Number($.amount),
      fromToken: this.sourceTokenAddress(T),
      toToken: this.destTokenAddress(T),
      fromChain: toMayanChainName(V.chain),
      toChain: toMayanChainName(J.chain),
      ...this.getDefaultOptions(),
      ...$.options,
      slippageBps: "auto"
    }, te = {
      swift: this.protocols.includes("SWIFT"),
      mctp: this.protocols.includes("MCTP")
    }, re = (await fetchQuote(ee, te)).filter((ie) => this.protocols.includes(ie.type));
    if (re.length !== 0)
      return re.length === 1 || re.sort((ie, se) => $.options.optimizeFor === "cost" ? se.expectedAmountOut === ie.expectedAmountOut ? ie.etaSeconds - se.etaSeconds : se.expectedAmountOut - ie.expectedAmountOut : $.options.optimizeFor === "speed" ? ie.etaSeconds === se.etaSeconds ? se.expectedAmountOut - ie.expectedAmountOut : ie.etaSeconds - se.etaSeconds : 0), re[0];
  }
  async quote(T, $) {
    try {
      const { fromChain: V, toChain: J } = T, ee = await this.fetchQuote(T, $);
      if (!ee)
        return {
          success: !1,
          error: new UnavailableError(new Error("Couldn't fetch a quote"))
        };
      const te = {
        token: {
          chain: "Solana",
          address: Wormhole.parseAddress("Solana", usdcContract.get(T.fromChain.network, "Solana"))
        },
        amount: parse$3(denoise(ee.clientRelayerFeeSuccess || "0", 6), 6)
      };
      return {
        success: !0,
        params: $,
        sourceToken: {
          token: Wormhole.tokenId(V.chain, this.sourceTokenAddress(T)),
          amount: parse$3(denoise(ee.effectiveAmountIn, ee.fromToken.decimals), ee.fromToken.decimals)
        },
        destinationToken: {
          token: Wormhole.tokenId(J.chain, this.destTokenAddress(T)),
          amount: parse$3(denoise(ee.expectedAmountOut, ee.toToken.decimals), ee.toToken.decimals)
        },
        relayFee: te,
        destinationNativeGas: parse$3(denoise(ee.gasDrop, ee.toToken.decimals), ee.toToken.decimals),
        /* @ts-ignore TODO: https://github.com/mayan-finance/swap-sdk/pull/11 */
        eta: ee.etaSeconds * 1e3,
        details: ee
      };
    } catch (V) {
      if (V.code && V.code === "AMOUNT_TOO_SMALL") {
        const J = V.message.match(/([\d\.]+)/);
        if (J[1] !== void 0) {
          const ee = parseFloat(J[1]), te = parse$3(ee, T.source.decimals);
          return {
            success: !1,
            error: new MinAmountError(te)
          };
        } else
          return {
            success: !1,
            error: V
          };
      }
      return {
        success: !1,
        error: V
      };
    }
  }
  async initiate(T, $, V, J) {
    const ee = $.address(), te = canonicalAddress(J);
    try {
      const re = await T.fromChain.getRpc(), ie = [];
      if (T.fromChain.chain === "Solana") {
        const { instructions: se, signers: de, lookupTables: ue } = await createSwapFromSolanaInstructions(V.details, ee, te, this.referrerAddress(), re), fe = MessageV0.compile({
          instructions: se,
          payerKey: new PublicKey(ee),
          recentBlockhash: "",
          addressLookupTableAccounts: ue
        }), he = [
          new SolanaUnsignedTransaction({
            transaction: new VersionedTransaction(fe),
            signers: de
          }, T.fromChain.network, T.fromChain.chain, "Execute Swap")
        ];
        if (isSignAndSendSigner($)) {
          const me = await $.signAndSend(he);
          ie.push(...me.map((xe) => ({
            chain: T.fromChain.chain,
            txid: xe
          })));
        } else if (isSignOnlySigner($)) {
          const me = await $.sign(he), xe = await SolanaPlatform.sendWait(T.fromChain.chain, re, me);
          ie.push(...xe.map((ve) => ({
            chain: T.fromChain.chain,
            txid: ve
          })));
        }
      } else {
        const se = [], de = networkChainToNativeChainId.get(T.fromChain.network, T.fromChain.chain);
        if (!isNative$1(T.source.id.address)) {
          const fe = EvmPlatform.getTokenImplementation(await T.fromChain.getRpc(), this.sourceTokenAddress(T)), he = addresses_default.MAYAN_FORWARDER_CONTRACT, me = await fe.allowance(ee, he), xe = units(V.sourceToken.amount);
          if (me < xe) {
            const ve = await fe.approve.populateTransaction(
              // mayan contract address,
              he,
              xe
            );
            se.push(new EvmUnsignedTransaction({
              from: $.address(),
              chainId: de,
              ...ve
            }, T.fromChain.network, T.fromChain.chain, "Approve Allowance"));
          }
        }
        const ue = getSwapFromEvmTxPayload(
          V.details,
          ee,
          te,
          this.referrerAddress(),
          ee,
          Number(de),
          void 0,
          void 0
          // permit?
        );
        if (se.push(new EvmUnsignedTransaction({
          from: $.address(),
          chainId: de,
          ...ue
        }, T.fromChain.network, T.fromChain.chain, "Execute Swap")), isSignAndSendSigner($)) {
          const fe = await $.signAndSend(se);
          ie.push(...fe.map((he) => ({
            chain: T.fromChain.chain,
            txid: he
          })));
        } else if (isSignOnlySigner($)) {
          const fe = await $.sign(se), he = await EvmPlatform.sendWait(T.fromChain.chain, re, fe);
          ie.push(...he.map((me) => ({
            chain: T.fromChain.chain,
            txid: me
          })));
        }
      }
      return {
        from: T.fromChain.chain,
        to: T.toChain.chain,
        state: TransferState.SourceInitiated,
        originTxs: ie
      };
    } catch (re) {
      throw console.error(re), re;
    }
  }
  async *track(T, $) {
    if (isCompleted(T) || isRedeemed(T) || isRefunded(T))
      return T;
    let V = $ || 60 * 60 * 1e3;
    for (; V > 0; ) {
      const J = Date.now();
      if (
        // this is awkward but there is not hasSourceInitiated like fn in sdk (todo)
        isSourceInitiated(T) || isSourceFinalized(T) || isAttested(T)
      ) {
        const ee = await getTransactionStatus(T.originTxs[T.originTxs.length - 1]);
        if (ee && (T = txStatusToReceipt(ee), yield { ...T, txstatus: ee }, isCompleted(T) || isRedeemed(T) || isRefunded(T)))
          return T;
      } else
        throw new Error("Transfer must have been initiated");
      await new Promise((ee) => setTimeout(ee, 1e3)), V -= Date.now() - J;
    }
    return T;
  }
  transferUrl(T) {
    return `https://explorer.mayan.finance/swap/${T}`;
  }
  referrerAddress() {
  }
}
tt(MayanRouteBase, "NATIVE_GAS_DROPOFF_SUPPORTED", !1), tt(MayanRouteBase, "IS_AUTOMATIC", !0);
class MayanRoute extends MayanRouteBase {
  constructor() {
    super(...arguments);
    tt(this, "protocols", ["WH", "MCTP", "SWIFT"]);
  }
}
tt(MayanRoute, "meta", {
  name: "MayanSwap"
});
class MayanRouteSWIFT extends MayanRouteBase {
  constructor() {
    super(...arguments);
    tt(this, "protocols", ["SWIFT"]);
  }
}
tt(MayanRouteSWIFT, "meta", {
  name: "MayanSwapSWIFT"
});
class MayanRouteMCTP extends MayanRouteBase {
  constructor() {
    super(...arguments);
    tt(this, "protocols", ["MCTP"]);
  }
}
tt(MayanRouteMCTP, "meta", {
  name: "MayanSwapMCTP"
});
class MayanRouteWH extends MayanRouteBase {
  constructor() {
    super(...arguments);
    tt(this, "protocols", ["WH"]);
  }
}
tt(MayanRouteWH, "meta", {
  name: "MayanSwapWH"
});
function wormholeConnectHosted(C, e = {}) {
  window.__CONNECT_CONFIG = e.config, window.__CONNECT_THEME = e.theme;
  const T = document.createElement("div");
  T.id = "wormhole-connect";
  const $ = e.version ?? CONNECT_VERSION, V = e.cdnBaseUrl ?? `https://cdn.jsdelivr.net/npm/@wormhole-foundation/wormhole-connect@${$}`, J = document.createElement("script");
  J.setAttribute("src", `${V}/dist/main.js`), J.setAttribute("type", "module"), C.appendChild(T), C.appendChild(J);
}
const {
  AutomaticTokenBridgeRoute,
  TokenBridgeRoute,
  AutomaticCCTPRoute,
  CCTPRoute,
  AutomaticPorticoRoute
} = routes;
export {
  NotSupported as $,
  AbstractSigner as A,
  normalizeSuiObjectId$1 as B,
  ChainContext as C,
  SUI_TYPE_ARG$1 as D,
  EvmPlatform as E,
  isValidSuiObjectId$1 as F,
  isValidTransactionDigest$1 as G,
  normalizeSuiType as H,
  getPackageIdFromType as I,
  b64 as J,
  SUI_COIN as K,
  SuiAddress$1 as L,
  MOVE_STDLIB_ADDRESS$1 as M,
  hexToBytes$1 as N,
  bytesToHex$1 as O,
  PlatformNativeSigner as P,
  sha512$5 as Q,
  nacl as R,
  SolanaAddress as S,
  JsonRpcApiPollingProvider as T,
  assertArgument as U,
  dist$2 as V,
  Wallet$1 as W,
  EventEmitter$1 as X,
  CHAINS as Y,
  Wallet as Z,
  _platform$1 as _,
  EvmAddress as a,
  ASSOCIATED_TOKEN_PROGRAM_ID$1 as a$,
  CHAIN_ID_ETH as a0,
  NotConnected as a1,
  toBeHex as a2,
  WalletState as a3,
  Contract as a4,
  formatUnits as a5,
  formatEther as a6,
  isHexString as a7,
  BaseFeatures as a8,
  isEVMChain as a9,
  wrapConstructor$1 as aA,
  HashMD$1 as aB,
  rotl as aC,
  secp256k1$1 as aD,
  createBase58check as aE,
  utf8ToBytes$2 as aF,
  concatBytes$2 as aG,
  abytes$2 as aH,
  createView$1 as aI,
  mod as aJ,
  sha256$5 as aK,
  ed25519 as aL,
  randomBytes$1 as aM,
  axios as aN,
  Hash$1 as aO,
  ahash$1 as aP,
  toBytes$2 as aQ,
  aexists$1 as aR,
  checkOpts as aS,
  anumber$1 as aT,
  struct$1 as aU,
  u32$1 as aV,
  publicKey$3 as aW,
  u64$1 as aX,
  u8$1 as aY,
  bool as aZ,
  TOKEN_PROGRAM_ID$2 as a_,
  config$1 as aa,
  getBigInt as ab,
  PublicKey as ac,
  bs58$6 as ad,
  CHAIN_ID_SOLANA as ae,
  VersionedTransaction as af,
  Transaction as ag,
  Connection$1 as ah,
  clusterApiUrl as ai,
  isVersionedTransaction$1 as aj,
  TransactionMessage as ak,
  sleep as al,
  ComputeBudgetProgram as am,
  isEmptyObject as an,
  Keypair as ao,
  b58 as ap,
  TransactionExpiredBlockheightExceededError as aq,
  SendTransactionError as ar,
  JsonRpcProvider as as,
  CHAIN_ID_SUI as at,
  naclFastExports as au,
  commonjsGlobal$1 as av,
  getDefaultExportFromCjs$2 as aw,
  sha3_256 as ax,
  bufferPolyfill as ay,
  CHAIN_ID_APTOS as az,
  EvmChain as b,
  getPostMessageCpiAccounts as b$,
  TOKEN_2022_PROGRAM_ID as b0,
  Interface as b1,
  toChainId as b2,
  EvmWormholeCore as b3,
  networkChainToNativeChainId as b4,
  resolveWrappedToken as b5,
  canonicalAddress as b6,
  PorticoBridge as b7,
  addFrom as b8,
  toChain as b9,
  unusedArbiterFee as bA,
  unusedNonce as bB,
  toNative as bC,
  TransactionInstruction as bD,
  ns64$1 as bE,
  s16 as bF,
  u16 as bG,
  blob$1 as bH,
  seq as bI,
  greedy as bJ,
  SYSVAR_RENT_PUBKEY as bK,
  SystemProgram as bL,
  deriveAddress as bM,
  bignum as bN,
  getAccountData as bO,
  accountSize$1 as bP,
  Program as bQ,
  createReadOnlyProvider as bR,
  newAccountMeta as bS,
  newReadOnlyAccountMeta as bT,
  getPostMessageAccounts as bU,
  derivePostedVaaKey as bV,
  deriveClaimKey as bW,
  deriveUpgradeAuthorityKey as bX,
  deriveProgramDataAddress as bY,
  SYSVAR_CLOCK_PUBKEY as bZ,
  BPF_LOADER_UPGRADEABLE_PROGRAM_ID$1 as b_,
  serialize$1 as ba,
  keccak256 as bb,
  isEqualCaseInsensitive as bc,
  EvmUnsignedTransaction as bd,
  addChainId as be,
  registerProtocol as bf,
  hexlify as bg,
  concat as bh,
  getBytes as bi,
  toUtf8Bytes as bj,
  getAddress as bk,
  toTwos as bl,
  zeroPadValue as bm,
  toBeArray as bn,
  dataLength as bo,
  zeroPadBytes as bp,
  circleChainId as bq,
  CircleBridge as br,
  usdcContract as bs,
  toCircleChain as bt,
  chainToChainId as bu,
  ContractFactory as bv,
  ErrNotWrapped as bw,
  UniversalAddress as bx,
  EvmZeroAddress as by,
  keccak_256 as bz,
  applyChainsConfigConfigOverrides as c,
  getWormholeDerivedAccounts as c0,
  BN as c1,
  SolanaWormholeCore as c2,
  getClaim as c3,
  createBridgeFeeTransferInstruction as c4,
  bytes as c5,
  SolanaUnsignedTransaction as c6,
  index$2 as c7,
  createVAA as c8,
  universalAddressItem as c9,
  requireBrowser$b as cA,
  _defineProperty as cB,
  requireElliptic as cC,
  requireHash as cD,
  requireCryptoBrowserify as cE,
  sha3 as cF,
  WormholeConnect as cG,
  MAINNET as cH,
  TESTNET as cI,
  buildConfig as cJ,
  DEFAULT_ROUTES as cK,
  nttRoutes as cL,
  nttAutomaticRoute as cM,
  nttManualRoute as cN,
  AutomaticTokenBridgeRoute as cO,
  TokenBridgeRoute as cP,
  AutomaticCCTPRoute as cQ,
  CCTPRoute as cR,
  AutomaticPorticoRoute as cS,
  MayanRoute as cT,
  MayanRouteWH as cU,
  MayanRouteMCTP as cV,
  MayanRouteSWIFT as cW,
  wormholeConnectHosted as cX,
  index$3 as cY,
  index as cZ,
  chainItem as ca,
  serialize$2 as cb,
  coalesceModuleAddress as cc,
  isValidAptosType$1 as cd,
  isValidSuiType as ce,
  getTableKeyType as cf,
  trimSuiType as cg,
  getCoinTypeFromPackageId as ch,
  SUI_SEPARATOR as ci,
  constMap as cj,
  o as ck,
  getAugmentedNamespace as cl,
  requireEvents as cm,
  require_stream_readable$1 as cn,
  require_stream_writable$1 as co,
  require_stream_duplex$1 as cp,
  require_stream_transform$1 as cq,
  require_stream_passthrough$1 as cr,
  requireEndOfStream as cs,
  requirePipeline as ct,
  requireInherits_browser as cu,
  browserExports as cv,
  requireString_decoder$1 as cw,
  require$$0$2 as cx,
  commonjsRequire as cy,
  requireStreamBrowserify as cz,
  defineProperties as d,
  SolanaPlatform as e,
  SolanaChain as f,
  _platform as g,
  PlatformContext as h,
  _platform$3 as i,
  Wormhole as j,
  APTOS_COIN as k,
  chainToPlatform as l,
  isNative$1 as m,
  networkPlatformConfigs as n,
  nativeDecimals as o,
  APTOS_SEPARATOR as p,
  AptosAddress as q,
  platformNativeChainIdToNetworkChain as r,
  hex$1 as s,
  fromB58$1 as t,
  toB58$1 as u,
  normalizeSuiAddress$1 as v,
  SUI_ADDRESS_LENGTH$2 as w,
  isValidSuiAddress$1 as x,
  SUI_FRAMEWORK_ADDRESS$1 as y,
  blake2b as z
};
